/*! bm-client-app - v4.2.8 - 2019-09-06 - Copyright 2016 Thomson Reuters™. All rights reserved. *//*!
 * jQuery JavaScript Library v2.1.4
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-04-28T16:01Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//

var arr = [];

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	// Use the correct document accordingly with window argument (sandbox)
	document = window.document,

	version = "2.1.4",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {
		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {
	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	// (You can seed the arguments with an array of args, but this is
	// only used internally.)
	each: function( callback, args ) {
		return jQuery.each( this, callback, args );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map(this, function( elem, i ) {
			return callback.call( elem, i, elem );
		}));
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor(null);
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[0] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {
		// Only deal with non-null/undefined values
		if ( (options = arguments[ i ]) != null ) {
			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray(src) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject(src) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend({
	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type(obj) === "function";
	},

	isArray: Array.isArray,

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {
		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		return !jQuery.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
	},

	isPlainObject: function( obj ) {
		// Not plain objects:
		// - Any object or value whose internal [[Class]] property is not "[object Object]"
		// - DOM nodes
		// - window
		if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		if ( obj.constructor &&
				!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
			return false;
		}

		// If the function hasn't returned already, we're confident that
		// |obj| is a plain object, created by {} or constructed with new Object
		return true;
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
		// Support: Android<4.0, iOS<6 (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call(obj) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		var script,
			indirect = eval;

		code = jQuery.trim( code );

		if ( code ) {
			// If the code includes a valid, prologue position
			// strict mode pragma, execute code by injecting a
			// script tag into the document.
			if ( code.indexOf("use strict") === 1 ) {
				script = document.createElement("script");
				script.text = code;
				document.head.appendChild( script ).parentNode.removeChild( script );
			} else {
			// Otherwise, avoid the DOM node creation, insertion
			// and removal by using an indirect global eval
				indirect( code );
			}
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE9-11+
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	// args is for internal usage only
	each: function( obj, callback, args ) {
		var value,
			i = 0,
			length = obj.length,
			isArray = isArraylike( obj );

		if ( args ) {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			}

		// A special, fast, case for the most common use of each
		} else {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArraylike( Object(arr) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var value,
			i = 0,
			length = elems.length,
			isArray = isArraylike( elems ),
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArray ) {
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
});

// Populate the class2type map
jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
});

function isArraylike( obj ) {

	// Support: iOS 8.2 (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	if ( obj.nodeType === 1 && length ) {
		return true;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.0-pre
 * http://sizzlejs.com/
 *
 * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2014-12-16
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",
	// http://www.w3.org/TR/css3-syntax/#characters
	characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Loosely modeled on CSS identifier characters
	// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
	// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = characterEncoding.replace( "w", "w#" ),

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + characterEncoding + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + characterEncoding + ")" ),
		"CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
		"TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var match, elem, m, nodeType,
		// QSA vars
		i, groups, old, nid, newContext, newSelector;

	if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
		setDocument( context );
	}

	context = context || document;
	results = results || [];
	nodeType = context.nodeType;

	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	if ( !seed && documentIsHTML ) {

		// Try to shortcut find operations when possible (e.g., not under DocumentFragment)
		if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
			// Speed-up: Sizzle("#ID")
			if ( (m = match[1]) ) {
				if ( nodeType === 9 ) {
					elem = context.getElementById( m );
					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document (jQuery #6963)
					if ( elem && elem.parentNode ) {
						// Handle the case where IE, Opera, and Webkit return items
						// by name instead of ID
						if ( elem.id === m ) {
							results.push( elem );
							return results;
						}
					} else {
						return results;
					}
				} else {
					// Context is not a document
					if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
						contains( context, elem ) && elem.id === m ) {
						results.push( elem );
						return results;
					}
				}

			// Speed-up: Sizzle("TAG")
			} else if ( match[2] ) {
				push.apply( results, context.getElementsByTagName( selector ) );
				return results;

			// Speed-up: Sizzle(".CLASS")
			} else if ( (m = match[3]) && support.getElementsByClassName ) {
				push.apply( results, context.getElementsByClassName( m ) );
				return results;
			}
		}

		// QSA path
		if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
			nid = old = expando;
			newContext = context;
			newSelector = nodeType !== 1 && selector;

			// qSA works strangely on Element-rooted queries
			// We can work around this by specifying an extra ID on the root
			// and working up from there (Thanks to Andrew Dupont for the technique)
			// IE 8 doesn't work on object elements
			if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
				groups = tokenize( selector );

				if ( (old = context.getAttribute("id")) ) {
					nid = old.replace( rescape, "\\$&" );
				} else {
					context.setAttribute( "id", nid );
				}
				nid = "[id='" + nid + "'] ";

				i = groups.length;
				while ( i-- ) {
					groups[i] = nid + toSelector( groups[i] );
				}
				newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
				newSelector = groups.join(",");
			}

			if ( newSelector ) {
				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch(qsaError) {
				} finally {
					if ( !old ) {
						context.removeAttribute("id");
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = attrs.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// If no document and documentElement is available, return
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Set our document
	document = doc;
	docElem = doc.documentElement;
	parent = doc.defaultView;

	// Support: IE>8
	// If iframe document is assigned to "document" variable and if iframe has been reloaded,
	// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
	// IE6-8 do not support the defaultView property so parent will be undefined
	if ( parent && parent !== parent.top ) {
		// IE11 does not have attachEvent, so all must suffer
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Support tests
	---------------------------------------------------------------------- */
	documentIsHTML = !isXML( doc );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( doc.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( doc.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				// Check parentNode to catch when Blackberry 4.6 returns
				// nodes that are no longer in the document #6963
				return m && m.parentNode ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\f]' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.2+, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.7+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = doc.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully does not implement inclusive descendent
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === doc ? -1 :
				b === doc ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return doc;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, outerCache, node, diff, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {
							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || (parent[ expando ] = {});
							cache = outerCache[ type ] || [];
							nodeIndex = cache[0] === dirruns && cache[1];
							diff = cache[0] === dirruns && cache[2];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						// Use previously-cached element index if available
						} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
							diff = cache[1];

						// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
						} else {
							// Use the same loop as above to seek `elem` from the start
							while ( (node = ++nodeIndex && node && node[ dir ] ||
								(diff = nodeIndex = 0) || start.pop()) ) {

								if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
									// Cache the index of each encountered element
									if ( useCache ) {
										(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
									}

									if ( node === elem ) {
										break;
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});
						if ( (oldCache = outerCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							outerCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context !== document && context;
			}

			// Add elements passing elementMatchers directly to results
			// Keep `i` a string if there are no elements so `matchedCount` will be "00" below
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// Apply set filters to unmatched elements
			matchedCount += i;
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is no seed and only one group
	if ( match.length === 1 ) {

		// Take a shortcut and set the context if the root selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[":"] = jQuery.expr.pseudos;
jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		});

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		});

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) >= 0 ) !== not;
	});
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		}));
};

jQuery.fn.extend({
	find: function( selector ) {
		var i,
			len = this.length,
			ret = [],
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter(function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			}) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow(this, selector || [], false) );
	},
	not: function( selector ) {
		return this.pushStack( winnow(this, selector || [], true) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
});


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[0] === "<" && selector[ selector.length - 1 ] === ">" && selector.length >= 3 ) {
				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && (match[1] || !context) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[1] ) {
					context = context instanceof jQuery ? context[0] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[1],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {
							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[2] );

					// Support: Blackberry 4.6
					// gEBID returns nodes no longer in the document (#6963)
					if ( elem && elem.parentNode ) {
						// Inject the element directly into the jQuery object
						this.length = 1;
						this[0] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || rootjQuery ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[0] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return typeof rootjQuery.ready !== "undefined" ?
				rootjQuery.ready( selector ) :
				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.extend({
	dir: function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;

		while ( (elem = elem[ dir ]) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	},

	sibling: function( n, elem ) {
		var matched = [];

		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}

		return matched;
	}
});

jQuery.fn.extend({
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter(function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[i] ) ) {
					return true;
				}
			}
		});
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
				// Always skip document fragments
				if ( cur.nodeType < 11 && (pos ?
					pos.index(cur) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector(cur, selectors)) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.unique(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter(selector)
		);
	}
});

function sibling( cur, dir ) {
	while ( (cur = cur[dir]) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each({
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return jQuery.dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return jQuery.dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return jQuery.dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return jQuery.sibling( elem.firstChild );
	},
	contents: function( elem ) {
		return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {
			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.unique( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
});
var rnotwhite = (/\S+/g);



// String to Object options format cache
var optionsCache = {};

// Convert String-formatted options into Object-formatted ones and store in cache
function createOptions( options ) {
	var object = optionsCache[ options ] = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	});
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		( optionsCache[ options ] || createOptions( options ) ) :
		jQuery.extend( {}, options );

	var // Last fire value (for non-forgettable lists)
		memory,
		// Flag to know if list was already fired
		fired,
		// Flag to know if list is currently firing
		firing,
		// First callback to fire (used internally by add and fireWith)
		firingStart,
		// End of the loop when firing
		firingLength,
		// Index of currently firing callback (modified by remove if needed)
		firingIndex,
		// Actual callback list
		list = [],
		// Stack of fire calls for repeatable lists
		stack = !options.once && [],
		// Fire callbacks
		fire = function( data ) {
			memory = options.memory && data;
			fired = true;
			firingIndex = firingStart || 0;
			firingStart = 0;
			firingLength = list.length;
			firing = true;
			for ( ; list && firingIndex < firingLength; firingIndex++ ) {
				if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
					memory = false; // To prevent further calls using add
					break;
				}
			}
			firing = false;
			if ( list ) {
				if ( stack ) {
					if ( stack.length ) {
						fire( stack.shift() );
					}
				} else if ( memory ) {
					list = [];
				} else {
					self.disable();
				}
			}
		},
		// Actual Callbacks object
		self = {
			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {
					// First, we save the current length
					var start = list.length;
					(function add( args ) {
						jQuery.each( args, function( _, arg ) {
							var type = jQuery.type( arg );
							if ( type === "function" ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && type !== "string" ) {
								// Inspect recursively
								add( arg );
							}
						});
					})( arguments );
					// Do we need to add the callbacks to the
					// current firing batch?
					if ( firing ) {
						firingLength = list.length;
					// With memory, if we're not firing then
					// we should call right away
					} else if ( memory ) {
						firingStart = start;
						fire( memory );
					}
				}
				return this;
			},
			// Remove a callback from the list
			remove: function() {
				if ( list ) {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
							// Handle firing indexes
							if ( firing ) {
								if ( index <= firingLength ) {
									firingLength--;
								}
								if ( index <= firingIndex ) {
									firingIndex--;
								}
							}
						}
					});
				}
				return this;
			},
			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
			},
			// Remove all callbacks from the list
			empty: function() {
				list = [];
				firingLength = 0;
				return this;
			},
			// Have the list do nothing anymore
			disable: function() {
				list = stack = memory = undefined;
				return this;
			},
			// Is it disabled?
			disabled: function() {
				return !list;
			},
			// Lock the list in its current state
			lock: function() {
				stack = undefined;
				if ( !memory ) {
					self.disable();
				}
				return this;
			},
			// Is it locked?
			locked: function() {
				return !stack;
			},
			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( list && ( !fired || stack ) ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					if ( firing ) {
						stack.push( args );
					} else {
						fire( args );
					}
				}
				return this;
			},
			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},
			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend({

	Deferred: function( func ) {
		var tuples = [
				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks("memory") ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred(function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[1] ](function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.done( newDefer.resolve )
										.fail( newDefer.reject )
										.progress( newDefer.notify );
								} else {
									newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
								}
							});
						});
						fns = null;
					}).promise();
				},
				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[1] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(function() {
					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[0] ] = function() {
				deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[0] + "With" ] = list.fireWith;
		});

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred. If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );
					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// Add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject )
						.progress( updateFunc( i, progressContexts, progressValues ) );
				} else {
					--remaining;
				}
			}
		}

		// If we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
});


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {
	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend({
	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
});

/**
 * The ready event handler and self cleanup method
 */
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed, false );
	window.removeEventListener( "load", completed, false );
	jQuery.ready();
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called after the browser event has already occurred.
		// We once tried to use readyState "interactive" here, but it caused issues like the one
		// discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
		if ( document.readyState === "complete" ) {
			// Handle it asynchronously to allow scripts the opportunity to delay ready
			setTimeout( jQuery.ready );

		} else {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed, false );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed, false );
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = jQuery.access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {
			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			len ? fn( elems[0], key ) : emptyGet;
};


/**
 * Determines whether an object can have data
 */
jQuery.acceptData = function( owner ) {
	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	/* jshint -W018 */
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};


function Data() {
	// Support: Android<4,
	// Old WebKit does not have Object.preventExtensions/freeze method,
	// return new empty object instead with no [[set]] accessor
	Object.defineProperty( this.cache = {}, 0, {
		get: function() {
			return {};
		}
	});

	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;
Data.accepts = jQuery.acceptData;

Data.prototype = {
	key: function( owner ) {
		// We can accept data for non-element nodes in modern browsers,
		// but we should not, see #8335.
		// Always return the key for a frozen object.
		if ( !Data.accepts( owner ) ) {
			return 0;
		}

		var descriptor = {},
			// Check if the owner object already has a cache key
			unlock = owner[ this.expando ];

		// If not, create one
		if ( !unlock ) {
			unlock = Data.uid++;

			// Secure it in a non-enumerable, non-writable property
			try {
				descriptor[ this.expando ] = { value: unlock };
				Object.defineProperties( owner, descriptor );

			// Support: Android<4
			// Fallback to a less secure definition
			} catch ( e ) {
				descriptor[ this.expando ] = unlock;
				jQuery.extend( owner, descriptor );
			}
		}

		// Ensure the cache object
		if ( !this.cache[ unlock ] ) {
			this.cache[ unlock ] = {};
		}

		return unlock;
	},
	set: function( owner, data, value ) {
		var prop,
			// There may be an unlock assigned to this node,
			// if there is no entry for this "owner", create one inline
			// and set the unlock as though an owner entry had always existed
			unlock = this.key( owner ),
			cache = this.cache[ unlock ];

		// Handle: [ owner, key, value ] args
		if ( typeof data === "string" ) {
			cache[ data ] = value;

		// Handle: [ owner, { properties } ] args
		} else {
			// Fresh assignments by object are shallow copied
			if ( jQuery.isEmptyObject( cache ) ) {
				jQuery.extend( this.cache[ unlock ], data );
			// Otherwise, copy the properties one-by-one to the cache object
			} else {
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		// Either a valid cache is found, or will be created.
		// New caches will be created and the unlock returned,
		// allowing direct access to the newly created
		// empty data object. A valid owner object must be provided.
		var cache = this.cache[ this.key( owner ) ];

		return key === undefined ?
			cache : cache[ key ];
	},
	access: function( owner, key, value ) {
		var stored;
		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				((key && typeof key === "string") && value === undefined) ) {

			stored = this.get( owner, key );

			return stored !== undefined ?
				stored : this.get( owner, jQuery.camelCase(key) );
		}

		// [*]When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i, name, camel,
			unlock = this.key( owner ),
			cache = this.cache[ unlock ];

		if ( key === undefined ) {
			this.cache[ unlock ] = {};

		} else {
			// Support array or space separated string of keys
			if ( jQuery.isArray( key ) ) {
				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = key.concat( key.map( jQuery.camelCase ) );
			} else {
				camel = jQuery.camelCase( key );
				// Try the string as a key before any manipulation
				if ( key in cache ) {
					name = [ key, camel ];
				} else {
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					name = camel;
					name = name in cache ?
						[ name ] : ( name.match( rnotwhite ) || [] );
				}
			}

			i = name.length;
			while ( i-- ) {
				delete cache[ name[ i ] ];
			}
		}
	},
	hasData: function( owner ) {
		return !jQuery.isEmptyObject(
			this.cache[ owner[ this.expando ] ] || {}
		);
	},
	discard: function( owner ) {
		if ( owner[ this.expando ] ) {
			delete this.cache[ owner[ this.expando ] ];
		}
	}
};
var data_priv = new Data();

var data_user = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /([A-Z])/g;

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :
					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch( e ) {}

			// Make sure we set the data so it isn't changed later
			data_user.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend({
	hasData: function( elem ) {
		return data_user.hasData( elem ) || data_priv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return data_user.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		data_user.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to data_priv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return data_priv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		data_priv.remove( elem, name );
	}
});

jQuery.fn.extend({
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = data_user.get( elem );

				if ( elem.nodeType === 1 && !data_priv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice(5) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					data_priv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each(function() {
				data_user.set( this, key );
			});
		}

		return access( this, function( value ) {
			var data,
				camelKey = jQuery.camelCase( key );

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {
				// Attempt to get data from the cache
				// with the key as-is
				data = data_user.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to get data from the cache
				// with the key camelized
				data = data_user.get( elem, camelKey );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, camelKey, undefined );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each(function() {
				// First, attempt to store a copy or reference of any
				// data that might've been store with a camelCased key.
				var data = data_user.get( this, camelKey );

				// For HTML5 data-* attribute interop, we have to
				// store property names with dashes in a camelCase form.
				// This might not apply to all properties...*
				data_user.set( this, camelKey, value );

				// *... In the case of properties that might _actually_
				// have dashes, we need to also store a copy of that
				// unchanged property.
				if ( key.indexOf("-") !== -1 && data !== undefined ) {
					data_user.set( this, key, value );
				}
			});
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each(function() {
			data_user.remove( this, key );
		});
	}
});


jQuery.extend({
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = data_priv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = data_priv.access( elem, type, jQuery.makeArray(data) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return data_priv.get( elem, key ) || data_priv.access( elem, key, {
			empty: jQuery.Callbacks("once memory").add(function() {
				data_priv.remove( elem, [ type + "queue", key ] );
			})
		});
	}
});

jQuery.fn.extend({
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[0], type );
		}

		return data === undefined ?
			this :
			this.each(function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[0] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			});
	},
	dequeue: function( type ) {
		return this.each(function() {
			jQuery.dequeue( this, type );
		});
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},
	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = data_priv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
});
var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;

var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {
		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
	};

var rcheckableType = (/^(?:checkbox|radio)$/i);



(function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Safari<=5.1
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari<=5.1, Android<4.2
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<=11+
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
})();
var strundefined = typeof undefined;



support.focusinBubbles = "onfocusin" in window;


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
	rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = data_priv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !(events = elemData.events) ) {
			events = elemData.events = {};
		}
		if ( !(eventHandle = elemData.handle) ) {
			eventHandle = elemData.handle = function( e ) {
				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== strundefined && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend({
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join(".")
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !(handlers = events[ type ]) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle, false );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = data_priv.hasData( elem ) && data_priv.get( elem );

		if ( !elemData || !(events = elemData.events) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			delete elemData.handle;
			data_priv.remove( elem, "events" );
		}
	},

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf(".") >= 0 ) {
			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split(".");
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf(":") < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join(".");
		event.namespace_re = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === (elem.ownerDocument || document) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( data_priv.get( cur, "events" ) || {} )[ event.type ] && data_priv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
				jQuery.acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( data_priv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[0] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
							.apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( (event.result = ret) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		// Avoid non-left-click bubbling in Firefox (#3861)
		if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.disabled !== true || event.type !== "click" ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) >= 0 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push({ elem: cur, handlers: matches });
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
		}

		return handlerQueue;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split(" "),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
		filter: function( event, original ) {
			var eventDoc, doc, body,
				button = original.button;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: Cordova 2.5 (WebKit) (#13255)
		// All events should have a target; Cordova deviceready doesn't
		if ( !event.target ) {
			event.target = document;
		}

		// Support: Safari 6.0+, Chrome<28
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	special: {
		load: {
			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {
			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {
			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	},

	simulate: function( type, elem, event, bubble ) {
		// Piggyback on a donor event to simulate a different one.
		// Fake originalEvent to avoid donor's stopPropagation, but if the
		// simulated event prevents default then we do the same on the donor.
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true,
				originalEvent: {}
			}
		);
		if ( bubble ) {
			jQuery.event.trigger( e, null, elem );
		} else {
			jQuery.event.dispatch.call( elem, e );
		}
		if ( e.isDefaultPrevented() ) {
			event.preventDefault();
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle, false );
	}
};

jQuery.Event = function( src, props ) {
	// Allow instantiation without the 'new' keyword
	if ( !(this instanceof jQuery.Event) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&
				// Support: Android<4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && e.preventDefault ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && e.stopPropagation ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && e.stopImmediatePropagation ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// Support: Chrome 15+
jQuery.each({
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mousenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
});

// Support: Firefox, Chrome, Safari
// Create "bubbling" focus and blur events
if ( !support.focusinBubbles ) {
	jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
			};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = data_priv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				data_priv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = data_priv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					data_priv.remove( doc, fix );

				} else {
					data_priv.access( doc, fix, attaches );
				}
			}
		};
	});
}

jQuery.fn.extend({

	on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
		var origFn, type;

		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				this.on( type, selector, data, types[ type ], one );
			}
			return this;
		}

		if ( data == null && fn == null ) {
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return this;
		}

		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return this.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		});
	},
	one: function( types, selector, data, fn ) {
		return this.on( types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {
			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {
			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {
			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each(function() {
			jQuery.event.remove( this, types, fn, selector );
		});
	},

	trigger: function( type, data ) {
		return this.each(function() {
			jQuery.event.trigger( type, data, this );
		});
	},
	triggerHandler: function( type, data ) {
		var elem = this[0];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
});


var
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
	rtagName = /<([\w:]+)/,
	rhtml = /<|&#?\w+;/,
	rnoInnerhtml = /<(?:script|style|link)/i,
	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptType = /^$|\/(?:java|ecma)script/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,

	// We have to close these tags to support XHTML (#13200)
	wrapMap = {

		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],

		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

		_default: [ 0, "", "" ]
	};

// Support: IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: 1.x compatibility
// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName("tbody")[0] ||
			elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute("type");
	}

	return elem;
}

// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		data_priv.set(
			elems[ i ], "globalEval", !refElements || data_priv.get( refElements[ i ], "globalEval" )
		);
	}
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( data_priv.hasData( src ) ) {
		pdataOld = data_priv.access( src );
		pdataCur = data_priv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( data_user.hasData( src ) ) {
		udataOld = data_user.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		data_user.set( dest, udataCur );
	}
}

function getAll( context, tag ) {
	var ret = context.getElementsByTagName ? context.getElementsByTagName( tag || "*" ) :
			context.querySelectorAll ? context.querySelectorAll( tag || "*" ) :
			[];

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], ret ) :
		ret;
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

jQuery.extend({
	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	buildFragment: function( elems, context, scripts, selection ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;

		for ( ; i < l; i++ ) {
			elem = elems[ i ];

			if ( elem || elem === 0 ) {

				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
					// Support: QtWebKit, PhantomJS
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );

				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement("div") );

					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[ 2 ];

					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}

					// Support: QtWebKit, PhantomJS
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );

					// Remember the top-level container
					tmp = fragment.firstChild;

					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}

		// Remove wrapper from fragment
		fragment.textContent = "";

		i = 0;
		while ( (elem = nodes[ i++ ]) ) {

			// #4087 - If origin and destination elements are the same, and this is
			// that element, do not do anything
			if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
				continue;
			}

			contains = jQuery.contains( elem.ownerDocument, elem );

			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );

			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}

			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( (elem = tmp[ j++ ]) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}

		return fragment;
	},

	cleanData: function( elems ) {
		var data, elem, type, key,
			special = jQuery.event.special,
			i = 0;

		for ( ; (elem = elems[ i ]) !== undefined; i++ ) {
			if ( jQuery.acceptData( elem ) ) {
				key = elem[ data_priv.expando ];

				if ( key && (data = data_priv.cache[ key ]) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}
					if ( data_priv.cache[ key ] ) {
						// Discard any remaining `private` data
						delete data_priv.cache[ key ];
					}
				}
			}
			// Discard any remaining `user` data
			delete data_user.cache[ elem[ data_user.expando ] ];
		}
	}
});

jQuery.fn.extend({
	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each(function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				});
		}, null, value, arguments.length );
	},

	append: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		});
	},

	prepend: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		});
	},

	before: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		});
	},

	after: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		});
	},

	remove: function( selector, keepData /* Internal Use Only */ ) {
		var elem,
			elems = selector ? jQuery.filter( selector, this ) : this,
			i = 0;

		for ( ; (elem = elems[i]) != null; i++ ) {
			if ( !keepData && elem.nodeType === 1 ) {
				jQuery.cleanData( getAll( elem ) );
			}

			if ( elem.parentNode ) {
				if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
					setGlobalEval( getAll( elem, "script" ) );
				}
				elem.parentNode.removeChild( elem );
			}
		}

		return this;
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; (elem = this[i]) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map(function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		});
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = value.replace( rxhtmlTag, "<$1></$2>" );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var arg = arguments[ 0 ];

		// Make the changes, replacing each context element with the new content
		this.domManip( arguments, function( elem ) {
			arg = this.parentNode;

			jQuery.cleanData( getAll( this ) );

			if ( arg ) {
				arg.replaceChild( elem, this );
			}
		});

		// Force removal if there was no new content (e.g., from empty arguments)
		return arg && (arg.length || arg.nodeType) ? this : this.remove();
	},

	detach: function( selector ) {
		return this.remove( selector, true );
	},

	domManip: function( args, callback ) {

		// Flatten any nested arrays
		args = concat.apply( [], args );

		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = this.length,
			set = this,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );

		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return this.each(function( index ) {
				var self = set.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				self.domManip( args, callback );
			});
		}

		if ( l ) {
			fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
			first = fragment.firstChild;

			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}

			if ( first ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;

				// Use the original fragment for the last item instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;

					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );

						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
							// Support: QtWebKit
							// jQuery.merge because push.apply(_, arraylike) throws
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}

					callback.call( this[ i ], node, i );
				}

				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;

					// Reenable scripts
					jQuery.map( scripts, restoreScript );

					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!data_priv.access( node, "globalEval" ) && jQuery.contains( doc, node ) ) {

							if ( node.src ) {
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}

		return this;
	}
});

jQuery.each({
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: QtWebKit
			// .get() because push.apply(_, arraylike) throws
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
});


var iframe,
	elemdisplay = {};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */
// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var style,
		elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		// getDefaultComputedStyle might be reliably used only on attached element
		display = window.getDefaultComputedStyle && ( style = window.getDefaultComputedStyle( elem[ 0 ] ) ) ?

			// Use of this method is a temporary fix (more like optimization) until something better comes along,
			// since it was removed from specification and supported only in FF
			style.display : jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = iframe[ 0 ].contentDocument;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = (/^margin/);

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {
		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		if ( elem.ownerDocument.defaultView.opener ) {
			return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
		}

		return window.getComputedStyle( elem, null );
	};



function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		style = elem.style;

	computed = computed || getStyles( elem );

	// Support: IE9
	// getPropertyValue is only needed for .css('filter') (#12537)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];
	}

	if ( computed ) {

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// Support: iOS < 6
		// A tribute to the "awesome hack by Dean Edwards"
		// iOS < 6 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
		// this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
		if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?
		// Support: IE
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {
	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {
				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return (this.get = hookFn).apply( this, arguments );
		}
	};
}


(function() {
	var pixelPositionVal, boxSizingReliableVal,
		docElem = document.documentElement,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	if ( !div.style ) {
		return;
	}

	// Support: IE9-11+
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;" +
		"position:absolute";
	container.appendChild( div );

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computePixelPositionAndBoxSizingReliable() {
		div.style.cssText =
			// Support: Firefox<29, Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
			"box-sizing:border-box;display:block;margin-top:1%;top:1%;" +
			"border:1px;padding:1px;width:4px;position:absolute";
		div.innerHTML = "";
		docElem.appendChild( container );

		var divStyle = window.getComputedStyle( div, null );
		pixelPositionVal = divStyle.top !== "1%";
		boxSizingReliableVal = divStyle.width === "4px";

		docElem.removeChild( container );
	}

	// Support: node.js jsdom
	// Don't assume that getComputedStyle is a property of the global object
	if ( window.getComputedStyle ) {
		jQuery.extend( support, {
			pixelPosition: function() {

				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computePixelPositionAndBoxSizingReliable();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computePixelPositionAndBoxSizingReliable();
				}
				return boxSizingReliableVal;
			},
			reliableMarginRight: function() {

				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );

				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
					// Support: Firefox<29, Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				docElem.appendChild( container );

				ret = !parseFloat( window.getComputedStyle( marginDiv, null ).marginRight );

				docElem.removeChild( container );
				div.removeChild( marginDiv );

				return ret;
			}
		});
	}
})();


// A method for quickly swapping in/out CSS properties to get correct calculations.
jQuery.swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var
	// Swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
	rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( style, name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in style ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[0].toUpperCase() + name.slice(1),
		origName = name,
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in style ) {
			return name;
		}
	}

	return origName;
}

function setPositiveNumber( elem, value, subtract ) {
	var matches = rnumsplit.exec( value );
	return matches ?
		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?
		// If we already have the right measurement, avoid augmentation
		4 :
		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {
		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {
			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {
			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {
		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test(val) ) {
			return val;
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = data_priv.get( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {
			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] = data_priv.access( elem, "olddisplay", defaultDisplay(elem.nodeName) );
			}
		} else {
			hidden = isHidden( elem );

			if ( display !== "none" || !hidden ) {
				data_priv.set( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

jQuery.extend({

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && (ret = rrelNum.exec( value )) ) {
				value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number, add 'px' to the (except for certain CSS properties)
			if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
				value += "px";
			}

			// Support: IE9-11+
			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {
				style[ name ] = value;
			}

		} else {
			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
		}
		return val;
	}
});

jQuery.each([ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) && elem.offsetWidth === 0 ?
					jQuery.swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, name, extra );
					}) :
					getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var styles = extra && getStyles( elem );
			return setPositiveNumber( elem, value, extra ?
				augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				) : 0
			);
		}
	};
});

// Support: Android 2.3
jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return jQuery.swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each({
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split(" ") : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
});

jQuery.fn.extend({
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each(function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		});
	}
});


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || "swing";
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			if ( tween.elem[ tween.prop ] != null &&
				(!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );
			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {
			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE9
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	}
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
	rrun = /queueHooks$/,
	animationPrefilters = [ defaultPrefilter ],
	tweeners = {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value ),
				target = tween.cur(),
				parts = rfxnum.exec( value ),
				unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

				// Starting value computation is required for potential unit mismatches
				start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
					rfxnum.exec( jQuery.css( tween.elem, prop ) ),
				scale = 1,
				maxIterations = 20;

			if ( start && start[ 3 ] !== unit ) {
				// Trust units reported by jQuery.css
				unit = unit || start[ 3 ];

				// Make sure we update the tween properties later on
				parts = parts || [];

				// Iteratively approximate from a nonzero starting point
				start = +target || 1;

				do {
					// If previous iteration zeroed out, double until we get *something*.
					// Use string for doubling so we don't accidentally see scale as unchanged below
					scale = scale || ".5";

					// Adjust and apply
					start = start / scale;
					jQuery.style( tween.elem, prop, start + unit );

				// Update scale, tolerating zero or NaN from tween.cur(),
				// break the loop if scale is unchanged or perfect, or if we've just had enough
				} while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
			}

			// Update tween properties
			if ( parts ) {
				start = tween.start = +start || +target || 0;
				tween.unit = unit;
				// If a +=/-= token was provided, we're doing a relative animation
				tween.end = parts[ 1 ] ?
					start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
					+parts[ 2 ];
			}

			return tween;
		} ]
	};

// Animations created synchronously will run synchronously
function createFxNow() {
	setTimeout(function() {
		fxNow = undefined;
	});
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( (tween = collection[ index ].call( animation, prop, value )) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = data_priv.get( elem, "fxshow" );

	// Handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always(function() {
			// Ensure the complete handler is called before this completes
			anim.always(function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			});
		});
	}

	// Height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE9-10 do not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			data_priv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
			style.display = "inline-block";
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always(function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		});
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = data_priv.access( elem, "fxshow", {} );
		}

		// Store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done(function() {
				jQuery( elem ).hide();
			});
		}
		anim.done(function() {
			var prop;

			data_priv.remove( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		});
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = animationPrefilters.length,
		deferred = jQuery.Deferred().always( function() {
			// Don't match elem in the :animated selector
			delete tick.elem;
		}),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ]);

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise({
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, { specialEasing: {} }, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,
					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		}),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		})
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.split(" ");
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			tweeners[ prop ] = tweeners[ prop ] || [];
			tweeners[ prop ].unshift( callback );
		}
	},

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			animationPrefilters.unshift( callback );
		} else {
			animationPrefilters.push( callback );
		}
	}
});

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
		opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend({
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate({ opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {
				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || data_priv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each(function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = data_priv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		});
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each(function() {
			var index,
				data = data_priv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		});
	}
});

jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
});

// Generate shortcuts for custom animations
jQuery.each({
	slideDown: genFx("show"),
	slideUp: genFx("hide"),
	slideToggle: genFx("toggle"),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
});

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];
		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;

jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	clearInterval( timerId );
	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,
	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = setTimeout( next, time );
		hooks.stop = function() {
			clearTimeout( timeout );
		};
	});
};


(function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: iOS<=5.1, Android<=4.2+
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE<=11+
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: Android<=2.3
	// Options inside disabled selects are incorrectly marked as disabled
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE<=11+
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
})();


var nodeHook, boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend({
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each(function() {
			jQuery.removeAttr( this, name );
		});
	}
});

jQuery.extend({
	attr: function( elem, name, value ) {
		var hooks, ret,
			nType = elem.nodeType;

		// don't get/set attributes on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === strundefined ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
		}

		if ( value !== undefined ) {

			if ( value === null ) {
				jQuery.removeAttr( elem, name );

			} else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
				return ret;

			} else {
				elem.setAttribute( name, value + "" );
				return value;
			}

		} else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
			return ret;

		} else {
			ret = jQuery.find.attr( elem, name );

			// Non-existent attributes return null, we normalize to undefined
			return ret == null ?
				undefined :
				ret;
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( (name = attrNames[i++]) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {
					// Set corresponding property to false
					elem[ propName ] = false;
				}

				elem.removeAttribute( name );
			}
		}
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	}
});

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {
			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};
jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle;
		if ( !isXML ) {
			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ name ];
			attrHandle[ name ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				name.toLowerCase() :
				null;
			attrHandle[ name ] = handle;
		}
		return ret;
	};
});




var rfocusable = /^(?:input|select|textarea|button)$/i;

jQuery.fn.extend({
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each(function() {
			delete this[ jQuery.propFix[ name ] || name ];
		});
	}
});

jQuery.extend({
	propFix: {
		"for": "htmlFor",
		"class": "className"
	},

	prop: function( elem, name, value ) {
		var ret, hooks, notxml,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		notxml = nType !== 1 || !jQuery.isXMLDoc( elem );

		if ( notxml ) {
			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
				ret :
				( elem[ name ] = value );

		} else {
			return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
				ret :
				elem[ name ];
		}
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {
				return elem.hasAttribute( "tabindex" ) || rfocusable.test( elem.nodeName ) || elem.href ?
					elem.tabIndex :
					-1;
			}
		}
	}
});

if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		}
	};
}

jQuery.each([
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
});




var rclass = /[\t\r\n\f]/g;

jQuery.fn.extend({
	addClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			proceed = typeof value === "string" && value,
			i = 0,
			len = this.length;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).addClass( value.call( this, j, this.className ) );
			});
		}

		if ( proceed ) {
			// The disjunction here is for better compressibility (see removeClass)
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					" "
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			proceed = arguments.length === 0 || typeof value === "string" && value,
			i = 0,
			len = this.length;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).removeClass( value.call( this, j, this.className ) );
			});
		}
		if ( proceed ) {
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					""
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = value ? jQuery.trim( cur ) : "";
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( i ) {
				jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
			});
		}

		return this.each(function() {
			if ( type === "string" ) {
				// Toggle individual class names
				var className,
					i = 0,
					self = jQuery( this ),
					classNames = value.match( rnotwhite ) || [];

				while ( (className = classNames[ i++ ]) ) {
					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( type === strundefined || type === "boolean" ) {
				if ( this.className ) {
					// store className if set
					data_priv.set( this, "__className__", this.className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				this.className = this.className || value === false ? "" : data_priv.get( this, "__className__" ) || "";
			}
		});
	},

	hasClass: function( selector ) {
		var className = " " + selector + " ",
			i = 0,
			l = this.length;
		for ( ; i < l; i++ ) {
			if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
				return true;
			}
		}

		return false;
	}
});




var rreturn = /\r/g;

jQuery.fn.extend({
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[0];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?
					// Handle most common string cases
					ret.replace(rreturn, "") :
					// Handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each(function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				});
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		});
	}
});

jQuery.extend({
	valHooks: {
		option: {
			get: function( elem ) {
				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :
					// Support: IE10-11+
					// option.text throws exceptions (#14686, #14858)
					jQuery.trim( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// IE6-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&
							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ? !option.disabled : option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];
					if ( (option.selected = jQuery.inArray( option.value, values ) >= 0) ) {
						optionSet = true;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
});

// Radios and checkboxes getter/setter
jQuery.each([ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute("value") === null ? "on" : elem.value;
		};
	}
});




// Return jQuery for attributes-only inclusion


jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
});

jQuery.fn.extend({
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	},

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {
		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
	}
});


var nonce = jQuery.now();

var rquery = (/\?/);



// Support: Android 2.3
// Workaround failure to string-cast null input
jQuery.parseJSON = function( data ) {
	return JSON.parse( data + "" );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, tmp;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE9
	try {
		tmp = new DOMParser();
		xml = tmp.parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,
	rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Document location
	ajaxLocation = window.location.href,

	// Segment location into parts
	ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {
			// For each dataType in the dataTypeExpression
			while ( (dataType = dataTypes[i++]) ) {
				// Prepend if requested
				if ( dataType[0] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					(structure[ dataType ] = structure[ dataType ] || []).unshift( func );

				// Otherwise append
				} else {
					(structure[ dataType ] = structure[ dataType ] || []).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		});
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {
		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}
		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},
		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

		// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {
								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s[ "throws" ] ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend({

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: ajaxLocation,
		type: "GET",
		isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /xml/,
			html: /html/,
			json: /json/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,
			// URL without anti-cache param
			cacheURL,
			// Response headers
			responseHeadersString,
			responseHeaders,
			// timeout handle
			timeoutTimer,
			// Cross-domain detection vars
			parts,
			// To know if global events are to be dispatched
			fireGlobals,
			// Loop variable
			i,
			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),
			// Callbacks context
			callbackContext = s.context || s,
			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,
			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks("once memory"),
			// Status-dependent callbacks
			statusCode = s.statusCode || {},
			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},
			// The jqXHR state
			state = 0,
			// Default abort message
			strAbort = "canceled",
			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( (match = rheaders.exec( responseHeadersString )) ) {
								responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {
								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {
							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" )
			.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when we have a protocol:host:port mismatch
		if ( s.crossDomain == null ) {
			parts = rurl.exec( s.url.toLowerCase() );
			s.crossDomain = !!( parts &&
				( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
					( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
						( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
			);
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger("ajaxStart");
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
				s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}
			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = setTimeout(function() {
					jqXHR.abort("timeout");
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {
				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );
				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader("Last-Modified");
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader("etag");
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {
				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger("ajaxStop");
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
});

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {
		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		return jQuery.ajax({
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		});
	};
});


jQuery._evalUrl = function( url ) {
	return jQuery.ajax({
		url: url,
		type: "GET",
		dataType: "script",
		async: false,
		global: false,
		"throws": true
	});
};


jQuery.fn.extend({
	wrapAll: function( html ) {
		var wrap;

		if ( jQuery.isFunction( html ) ) {
			return this.each(function( i ) {
				jQuery( this ).wrapAll( html.call(this, i) );
			});
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map(function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			}).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each(function( i ) {
				jQuery( this ).wrapInner( html.call(this, i) );
			});
		}

		return this.each(function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		});
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each(function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
		});
	},

	unwrap: function() {
		return this.parent().each(function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		}).end();
	}
});


jQuery.expr.filters.hidden = function( elem ) {
	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	return elem.offsetWidth <= 0 && elem.offsetHeight <= 0;
};
jQuery.expr.filters.visible = function( elem ) {
	return !jQuery.expr.filters.hidden( elem );
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {
		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {
				// Treat each array item as a scalar.
				add( prefix, v );

			} else {
				// Item is non-scalar (array or object), encode its numeric index.
				buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
			}
		});

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {
		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {
		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {
			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		});

	} else {
		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend({
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map(function() {
			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		})
		.filter(function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		})
		.map(function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					}) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		}).get();
	}
});


jQuery.ajaxSettings.xhr = function() {
	try {
		return new XMLHttpRequest();
	} catch( e ) {}
};

var xhrId = 0,
	xhrCallbacks = {},
	xhrSuccessStatus = {
		// file protocol always yields status code 0, assume 200
		0: 200,
		// Support: IE9
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

// Support: IE9
// Open requests must be manually aborted on unload (#5280)
// See https://support.microsoft.com/kb/2856746 for more info
if ( window.attachEvent ) {
	window.attachEvent( "onunload", function() {
		for ( var key in xhrCallbacks ) {
			xhrCallbacks[ key ]();
		}
	});
}

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport(function( options ) {
	var callback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr(),
					id = ++xhrId;

				xhr.open( options.type, options.url, options.async, options.username, options.password );

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers["X-Requested-With"] ) {
					headers["X-Requested-With"] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							delete xhrCallbacks[ id ];
							callback = xhr.onload = xhr.onerror = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {
								complete(
									// file: protocol always yields status 0; see #8605, #14207
									xhr.status,
									xhr.statusText
								);
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,
									// Support: IE9
									// Accessing binary-data responseText throws an exception
									// (#11426)
									typeof xhr.responseText === "string" ? {
										text: xhr.responseText
									} : undefined,
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				xhr.onerror = callback("error");

				// Create the abort callback
				callback = xhrCallbacks[ id ] = callback("abort");

				try {
					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {
					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
});




// Install script dataType
jQuery.ajaxSetup({
	accepts: {
		script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /(?:java|ecma)script/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
});

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
});

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {
	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery("<script>").prop({
					async: true,
					charset: s.scriptCharset,
					src: s.url
				}).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
});




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup({
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
});

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters["script json"] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always(function() {
			// Restore preexisting value
			window[ callbackName ] = overwritten;

			// Save back as free
			if ( s[ callbackName ] ) {
				// make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		});

		// Delegate to script
		return "script";
	}
});




// data: string of html
// context (optional): If specified, the fragment will be created in this context, defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}
	context = context || document;

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[1] ) ];
	}

	parsed = jQuery.buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf(" ");

	if ( off >= 0 ) {
		selector = jQuery.trim( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax({
			url: url,

			// if "type" variable is undefined, then "GET" method will be used
			type: type,
			dataType: "html",
			data: params
		}).done(function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		}).complete( callback && function( jqXHR, status ) {
			self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
		});
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
});




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep(jQuery.timers, function( fn ) {
		return elem === fn.elem;
	}).length;
};




var docElem = window.document.documentElement;

/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf("auto") > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {
			options = options.call( elem, i, curOffset );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend({
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each(function( i ) {
					jQuery.offset.setOffset( this, options, i );
				});
		}

		var docElem, win,
			elem = this[ 0 ],
			box = { top: 0, left: 0 },
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		// Support: BlackBerry 5, iOS 3 (original iPhone)
		// If we don't have gBCR, just use 0,0 rather than error
		if ( typeof elem.getBoundingClientRect !== strundefined ) {
			box = elem.getBoundingClientRect();
		}
		win = getWindow( doc );
		return {
			top: box.top + win.pageYOffset - docElem.clientTop,
			left: box.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {
			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {
			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	offsetParent: function() {
		return this.map(function() {
			var offsetParent = this.offsetParent || docElem;

			while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || docElem;
		});
	}
});

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : window.pageXOffset,
					top ? val : window.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length, null );
	};
});

// Support: Safari<7+, Chrome<37+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );
				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
});


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {
					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?
					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	});
});


// The number of elements contained in the matched element set
jQuery.fn.size = function() {
	return this.length;
};

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	});
}




var
	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === strundefined ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;

}));

/**
 * @license AngularJS v1.6.1
 * (c) 2010-2016 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window) {'use strict';

/**
 * @description
 *
 * This object provides a utility for producing rich Error messages within
 * Angular. It can be called as follows:
 *
 * var exampleMinErr = minErr('example');
 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
 *
 * The above creates an instance of minErr in the example namespace. The
 * resulting error will have a namespaced error code of example.one.  The
 * resulting error will replace {0} with the value of foo, and {1} with the
 * value of bar. The object is not restricted in the number of arguments it can
 * take.
 *
 * If fewer arguments are specified than necessary for interpolation, the extra
 * interpolation markers will be preserved in the final string.
 *
 * Since data will be parsed statically during a build step, some restrictions
 * are applied with respect to how minErr instances are created and called.
 * Instances should have names of the form namespaceMinErr for a minErr created
 * using minErr('namespace') . Error codes, namespaces and template strings
 * should all be static strings, not variables or general expressions.
 *
 * @param {string} module The namespace to use for the new minErr instance.
 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
 *   error from returned function, for cases when a particular type of error is useful.
 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
 */

function minErr(module, ErrorConstructor) {
  ErrorConstructor = ErrorConstructor || Error;
  return function() {
    var SKIP_INDEXES = 2;

    var templateArgs = arguments,
      code = templateArgs[0],
      message = '[' + (module ? module + ':' : '') + code + '] ',
      template = templateArgs[1],
      paramPrefix, i;

    message += template.replace(/\{\d+\}/g, function(match) {
      var index = +match.slice(1, -1),
        shiftedIndex = index + SKIP_INDEXES;

      if (shiftedIndex < templateArgs.length) {
        return toDebugString(templateArgs[shiftedIndex]);
      }

      return match;
    });

    message += '\nhttp://errors.angularjs.org/1.6.1/' +
      (module ? module + '/' : '') + code;

    for (i = SKIP_INDEXES, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
      message += paramPrefix + 'p' + (i - SKIP_INDEXES) + '=' +
        encodeURIComponent(toDebugString(templateArgs[i]));
    }

    return new ErrorConstructor(message);
  };
}

/* We need to tell ESLint what variables are being exported */
/* exported
  angular,
  msie,
  jqLite,
  jQuery,
  slice,
  splice,
  push,
  toString,
  ngMinErr,
  angularModule,
  uid,
  REGEX_STRING_REGEXP,
  VALIDITY_STATE_PROPERTY,

  lowercase,
  uppercase,
  manualLowercase,
  manualUppercase,
  nodeName_,
  isArrayLike,
  forEach,
  forEachSorted,
  reverseParams,
  nextUid,
  setHashKey,
  extend,
  toInt,
  inherit,
  merge,
  noop,
  identity,
  valueFn,
  isUndefined,
  isDefined,
  isObject,
  isBlankObject,
  isString,
  isNumber,
  isNumberNaN,
  isDate,
  isArray,
  isFunction,
  isRegExp,
  isWindow,
  isScope,
  isFile,
  isFormData,
  isBlob,
  isBoolean,
  isPromiseLike,
  trim,
  escapeForRegexp,
  isElement,
  makeMap,
  includes,
  arrayRemove,
  copy,
  equals,
  csp,
  jq,
  concat,
  sliceArgs,
  bind,
  toJsonReplacer,
  toJson,
  fromJson,
  convertTimezoneToLocal,
  timezoneToOffset,
  startingTag,
  tryDecodeURIComponent,
  parseKeyValue,
  toKeyValue,
  encodeUriSegment,
  encodeUriQuery,
  angularInit,
  bootstrap,
  getTestability,
  snake_case,
  bindJQuery,
  assertArg,
  assertArgFn,
  assertNotHasOwnProperty,
  getter,
  getBlockNodes,
  hasOwnProperty,
  createMap,
  stringify,

  NODE_TYPE_ELEMENT,
  NODE_TYPE_ATTRIBUTE,
  NODE_TYPE_TEXT,
  NODE_TYPE_COMMENT,
  NODE_TYPE_DOCUMENT,
  NODE_TYPE_DOCUMENT_FRAGMENT
*/

////////////////////////////////////

/**
 * @ngdoc module
 * @name ng
 * @module ng
 * @installation
 * @description
 *
 * # ng (core module)
 * The ng module is loaded by default when an AngularJS application is started. The module itself
 * contains the essential components for an AngularJS application to function. The table below
 * lists a high level breakdown of each of the services/factories, filters, directives and testing
 * components available within this core module.
 *
 * <div doc-module-components="ng"></div>
 */

var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;

// The name of a form control's ValidityState property.
// This is used so that it's possible for internal tests to create mock ValidityStates.
var VALIDITY_STATE_PROPERTY = 'validity';


var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * @ngdoc function
 * @name angular.lowercase
 * @module ng
 * @kind function
 *
 * @deprecated
 * sinceVersion="1.5.0"
 * removeVersion="1.7.0"
 * Use [String.prototype.toLowerCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toLowerCase) instead.
 *
 * @description Converts the specified string to lowercase.
 * @param {string} string String to be converted to lowercase.
 * @returns {string} Lowercased string.
 */
var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};

/**
 * @ngdoc function
 * @name angular.uppercase
 * @module ng
 * @kind function
 *
 * @deprecated
 * sinceVersion="1.5.0"
 * removeVersion="1.7.0"
 * Use [String.prototype.toUpperCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toUpperCase) instead.
 *
 * @description Converts the specified string to uppercase.
 * @param {string} string String to be converted to uppercase.
 * @returns {string} Uppercased string.
 */
var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};


var manualLowercase = function(s) {
  /* eslint-disable no-bitwise */
  return isString(s)
      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
      : s;
  /* eslint-enable */
};
var manualUppercase = function(s) {
  /* eslint-disable no-bitwise */
  return isString(s)
      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
      : s;
  /* eslint-enable */
};


// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
if ('i' !== 'I'.toLowerCase()) {
  lowercase = manualLowercase;
  uppercase = manualUppercase;
}


var
    msie,             // holds major version number for IE, or NaN if UA is not IE.
    jqLite,           // delay binding since jQuery could be loaded after us.
    jQuery,           // delay binding
    slice             = [].slice,
    splice            = [].splice,
    push              = [].push,
    toString          = Object.prototype.toString,
    getPrototypeOf    = Object.getPrototypeOf,
    ngMinErr          = minErr('ng'),

    /** @name angular */
    angular           = window.angular || (window.angular = {}),
    angularModule,
    uid               = 0;

// Support: IE 9-11 only
/**
 * documentMode is an IE-only property
 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
 */
msie = window.document.documentMode;


/**
 * @private
 * @param {*} obj
 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
 *                   String ...)
 */
function isArrayLike(obj) {

  // `null`, `undefined` and `window` are not array-like
  if (obj == null || isWindow(obj)) return false;

  // arrays, strings and jQuery/jqLite objects are array like
  // * jqLite is either the jQuery or jqLite constructor function
  // * we have to check the existence of jqLite first as this method is called
  //   via the forEach method when constructing the jqLite object in the first place
  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;

  // Support: iOS 8.2 (not reproducible in simulator)
  // "length" in obj used to prevent JIT error (gh-11508)
  var length = 'length' in Object(obj) && obj.length;

  // NodeList objects (with `item` method) and
  // other objects with suitable length characteristics are array-like
  return isNumber(length) &&
    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item === 'function');

}

/**
 * @ngdoc function
 * @name angular.forEach
 * @module ng
 * @kind function
 *
 * @description
 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
 * is the value of an object property or an array element, `key` is the object property key or
 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
 *
 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
 * using the `hasOwnProperty` method.
 *
 * Unlike ES262's
 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
 * return the value provided.
 *
   ```js
     var values = {name: 'misko', gender: 'male'};
     var log = [];
     angular.forEach(values, function(value, key) {
       this.push(key + ': ' + value);
     }, log);
     expect(log).toEqual(['name: misko', 'gender: male']);
   ```
 *
 * @param {Object|Array} obj Object to iterate over.
 * @param {Function} iterator Iterator function.
 * @param {Object=} context Object to become context (`this`) for the iterator function.
 * @returns {Object|Array} Reference to `obj`.
 */

function forEach(obj, iterator, context) {
  var key, length;
  if (obj) {
    if (isFunction(obj)) {
      for (key in obj) {
        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (isArray(obj) || isArrayLike(obj)) {
      var isPrimitive = typeof obj !== 'object';
      for (key = 0, length = obj.length; key < length; key++) {
        if (isPrimitive || key in obj) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (obj.forEach && obj.forEach !== forEach) {
        obj.forEach(iterator, context, obj);
    } else if (isBlankObject(obj)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in obj) {
        iterator.call(context, obj[key], key, obj);
      }
    } else if (typeof obj.hasOwnProperty === 'function') {
      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
      for (key in obj) {
        if (obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else {
      // Slow path for objects which do not have a method `hasOwnProperty`
      for (key in obj) {
        if (hasOwnProperty.call(obj, key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    }
  }
  return obj;
}

function forEachSorted(obj, iterator, context) {
  var keys = Object.keys(obj).sort();
  for (var i = 0; i < keys.length; i++) {
    iterator.call(context, obj[keys[i]], keys[i]);
  }
  return keys;
}


/**
 * when using forEach the params are value, key, but it is often useful to have key, value.
 * @param {function(string, *)} iteratorFn
 * @returns {function(*, string)}
 */
function reverseParams(iteratorFn) {
  return function(value, key) {iteratorFn(key, value);};
}

/**
 * A consistent way of creating unique IDs in angular.
 *
 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
 * we hit number precision issues in JavaScript.
 *
 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
 *
 * @returns {number} an unique alpha-numeric string
 */
function nextUid() {
  return ++uid;
}


/**
 * Set or clear the hashkey for an object.
 * @param obj object
 * @param h the hashkey (!truthy to delete the hashkey)
 */
function setHashKey(obj, h) {
  if (h) {
    obj.$$hashKey = h;
  } else {
    delete obj.$$hashKey;
  }
}


function baseExtend(dst, objs, deep) {
  var h = dst.$$hashKey;

  for (var i = 0, ii = objs.length; i < ii; ++i) {
    var obj = objs[i];
    if (!isObject(obj) && !isFunction(obj)) continue;
    var keys = Object.keys(obj);
    for (var j = 0, jj = keys.length; j < jj; j++) {
      var key = keys[j];
      var src = obj[key];

      if (deep && isObject(src)) {
        if (isDate(src)) {
          dst[key] = new Date(src.valueOf());
        } else if (isRegExp(src)) {
          dst[key] = new RegExp(src);
        } else if (src.nodeName) {
          dst[key] = src.cloneNode(true);
        } else if (isElement(src)) {
          dst[key] = src.clone();
        } else {
          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
          baseExtend(dst[key], [src], true);
        }
      } else {
        dst[key] = src;
      }
    }
  }

  setHashKey(dst, h);
  return dst;
}

/**
 * @ngdoc function
 * @name angular.extend
 * @module ng
 * @kind function
 *
 * @description
 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
 *
 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
 * {@link angular.merge} for this.
 *
 * @param {Object} dst Destination object.
 * @param {...Object} src Source object(s).
 * @returns {Object} Reference to `dst`.
 */
function extend(dst) {
  return baseExtend(dst, slice.call(arguments, 1), false);
}


/**
* @ngdoc function
* @name angular.merge
* @module ng
* @kind function
*
* @description
* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
*
* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
* objects, performing a deep copy.
*
* @param {Object} dst Destination object.
* @param {...Object} src Source object(s).
* @returns {Object} Reference to `dst`.
*/
function merge(dst) {
  return baseExtend(dst, slice.call(arguments, 1), true);
}



function toInt(str) {
  return parseInt(str, 10);
}

var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
  // eslint-disable-next-line no-self-compare
  return num !== num;
};


function inherit(parent, extra) {
  return extend(Object.create(parent), extra);
}

/**
 * @ngdoc function
 * @name angular.noop
 * @module ng
 * @kind function
 *
 * @description
 * A function that performs no operations. This function can be useful when writing code in the
 * functional style.
   ```js
     function foo(callback) {
       var result = calculateResult();
       (callback || angular.noop)(result);
     }
   ```
 */
function noop() {}
noop.$inject = [];


/**
 * @ngdoc function
 * @name angular.identity
 * @module ng
 * @kind function
 *
 * @description
 * A function that returns its first argument. This function is useful when writing code in the
 * functional style.
 *
   ```js
   function transformer(transformationFn, value) {
     return (transformationFn || angular.identity)(value);
   };

   // E.g.
   function getResult(fn, input) {
     return (fn || angular.identity)(input);
   };

   getResult(function(n) { return n * 2; }, 21);   // returns 42
   getResult(null, 21);                            // returns 21
   getResult(undefined, 21);                       // returns 21
   ```
 *
 * @param {*} value to be returned.
 * @returns {*} the value passed in.
 */
function identity($) {return $;}
identity.$inject = [];


function valueFn(value) {return function valueRef() {return value;};}

function hasCustomToString(obj) {
  return isFunction(obj.toString) && obj.toString !== toString;
}


/**
 * @ngdoc function
 * @name angular.isUndefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is undefined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is undefined.
 */
function isUndefined(value) {return typeof value === 'undefined';}


/**
 * @ngdoc function
 * @name angular.isDefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is defined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is defined.
 */
function isDefined(value) {return typeof value !== 'undefined';}


/**
 * @ngdoc function
 * @name angular.isObject
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
 * considered to be objects. Note that JavaScript arrays are objects.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Object` but not `null`.
 */
function isObject(value) {
  // http://jsperf.com/isobject4
  return value !== null && typeof value === 'object';
}


/**
 * Determine if a value is an object with a null prototype
 *
 * @returns {boolean} True if `value` is an `Object` with a null prototype
 */
function isBlankObject(value) {
  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
}


/**
 * @ngdoc function
 * @name angular.isString
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `String`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `String`.
 */
function isString(value) {return typeof value === 'string';}


/**
 * @ngdoc function
 * @name angular.isNumber
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Number`.
 *
 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
 *
 * If you wish to exclude these then you can use the native
 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
 * method.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Number`.
 */
function isNumber(value) {return typeof value === 'number';}


/**
 * @ngdoc function
 * @name angular.isDate
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a value is a date.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Date`.
 */
function isDate(value) {
  return toString.call(value) === '[object Date]';
}


/**
 * @ngdoc function
 * @name angular.isArray
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Array`. Alias of Array.isArray.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Array`.
 */
var isArray = Array.isArray;

/**
 * @ngdoc function
 * @name angular.isFunction
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Function`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Function`.
 */
function isFunction(value) {return typeof value === 'function';}


/**
 * Determines if a value is a regular expression object.
 *
 * @private
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `RegExp`.
 */
function isRegExp(value) {
  return toString.call(value) === '[object RegExp]';
}


/**
 * Checks if `obj` is a window object.
 *
 * @private
 * @param {*} obj Object to check
 * @returns {boolean} True if `obj` is a window obj.
 */
function isWindow(obj) {
  return obj && obj.window === obj;
}


function isScope(obj) {
  return obj && obj.$evalAsync && obj.$watch;
}


function isFile(obj) {
  return toString.call(obj) === '[object File]';
}


function isFormData(obj) {
  return toString.call(obj) === '[object FormData]';
}


function isBlob(obj) {
  return toString.call(obj) === '[object Blob]';
}


function isBoolean(value) {
  return typeof value === 'boolean';
}


function isPromiseLike(obj) {
  return obj && isFunction(obj.then);
}


var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
function isTypedArray(value) {
  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
}

function isArrayBuffer(obj) {
  return toString.call(obj) === '[object ArrayBuffer]';
}


var trim = function(value) {
  return isString(value) ? value.trim() : value;
};

// Copied from:
// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
// Prereq: s is a string.
var escapeForRegexp = function(s) {
  return s
    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
    // eslint-disable-next-line no-control-regex
    .replace(/\x08/g, '\\x08');
};


/**
 * @ngdoc function
 * @name angular.isElement
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a DOM element (or wrapped jQuery element).
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
 */
function isElement(node) {
  return !!(node &&
    (node.nodeName  // We are a direct element.
    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
}

/**
 * @param str 'key1,key2,...'
 * @returns {object} in the form of {key1:true, key2:true, ...}
 */
function makeMap(str) {
  var obj = {}, items = str.split(','), i;
  for (i = 0; i < items.length; i++) {
    obj[items[i]] = true;
  }
  return obj;
}


function nodeName_(element) {
  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
}

function includes(array, obj) {
  return Array.prototype.indexOf.call(array, obj) !== -1;
}

function arrayRemove(array, value) {
  var index = array.indexOf(value);
  if (index >= 0) {
    array.splice(index, 1);
  }
  return index;
}

/**
 * @ngdoc function
 * @name angular.copy
 * @module ng
 * @kind function
 *
 * @description
 * Creates a deep copy of `source`, which should be an object or an array.
 *
 * * If no destination is supplied, a copy of the object or array is created.
 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
 *   are deleted and then all elements/properties from the source are copied to it.
 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
 * * If `source` is identical to `destination` an exception will be thrown.
 *
 * <br />
 * <div class="alert alert-warning">
 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
 *   and on `destination`) will be ignored.
 * </div>
 *
 * @param {*} source The source that will be used to make a copy.
 *                   Can be any type, including primitives, `null`, and `undefined`.
 * @param {(Object|Array)=} destination Destination into which the source is copied. If
 *     provided, must be of the same type as `source`.
 * @returns {*} The copy or updated `destination`, if `destination` was specified.
 *
 * @example
  <example module="copyExample" name="angular-copy">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate class="simple-form">
          <label>Name: <input type="text" ng-model="user.name" /></label><br />
          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
          <button ng-click="reset()">RESET</button>
          <button ng-click="update(user)">SAVE</button>
        </form>
        <pre>form = {{user | json}}</pre>
        <pre>master = {{master | json}}</pre>
      </div>
    </file>
    <file name="script.js">
      // Module: copyExample
      angular.
        module('copyExample', []).
        controller('ExampleController', ['$scope', function($scope) {
          $scope.master = {};

          $scope.reset = function() {
            // Example with 1 argument
            $scope.user = angular.copy($scope.master);
          };

          $scope.update = function(user) {
            // Example with 2 arguments
            angular.copy(user, $scope.master);
          };

          $scope.reset();
        }]);
    </file>
  </example>
 */
function copy(source, destination) {
  var stackSource = [];
  var stackDest = [];

  if (destination) {
    if (isTypedArray(destination) || isArrayBuffer(destination)) {
      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
    }
    if (source === destination) {
      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
    }

    // Empty the destination object
    if (isArray(destination)) {
      destination.length = 0;
    } else {
      forEach(destination, function(value, key) {
        if (key !== '$$hashKey') {
          delete destination[key];
        }
      });
    }

    stackSource.push(source);
    stackDest.push(destination);
    return copyRecurse(source, destination);
  }

  return copyElement(source);

  function copyRecurse(source, destination) {
    var h = destination.$$hashKey;
    var key;
    if (isArray(source)) {
      for (var i = 0, ii = source.length; i < ii; i++) {
        destination.push(copyElement(source[i]));
      }
    } else if (isBlankObject(source)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in source) {
        destination[key] = copyElement(source[key]);
      }
    } else if (source && typeof source.hasOwnProperty === 'function') {
      // Slow path, which must rely on hasOwnProperty
      for (key in source) {
        if (source.hasOwnProperty(key)) {
          destination[key] = copyElement(source[key]);
        }
      }
    } else {
      // Slowest path --- hasOwnProperty can't be called as a method
      for (key in source) {
        if (hasOwnProperty.call(source, key)) {
          destination[key] = copyElement(source[key]);
        }
      }
    }
    setHashKey(destination, h);
    return destination;
  }

  function copyElement(source) {
    // Simple values
    if (!isObject(source)) {
      return source;
    }

    // Already copied values
    var index = stackSource.indexOf(source);
    if (index !== -1) {
      return stackDest[index];
    }

    if (isWindow(source) || isScope(source)) {
      throw ngMinErr('cpws',
        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
    }

    var needsRecurse = false;
    var destination = copyType(source);

    if (destination === undefined) {
      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
      needsRecurse = true;
    }

    stackSource.push(source);
    stackDest.push(destination);

    return needsRecurse
      ? copyRecurse(source, destination)
      : destination;
  }

  function copyType(source) {
    switch (toString.call(source)) {
      case '[object Int8Array]':
      case '[object Int16Array]':
      case '[object Int32Array]':
      case '[object Float32Array]':
      case '[object Float64Array]':
      case '[object Uint8Array]':
      case '[object Uint8ClampedArray]':
      case '[object Uint16Array]':
      case '[object Uint32Array]':
        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);

      case '[object ArrayBuffer]':
        // Support: IE10
        if (!source.slice) {
          // If we're in this case we know the environment supports ArrayBuffer
          /* eslint-disable no-undef */
          var copied = new ArrayBuffer(source.byteLength);
          new Uint8Array(copied).set(new Uint8Array(source));
          /* eslint-enable */
          return copied;
        }
        return source.slice(0);

      case '[object Boolean]':
      case '[object Number]':
      case '[object String]':
      case '[object Date]':
        return new source.constructor(source.valueOf());

      case '[object RegExp]':
        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
        re.lastIndex = source.lastIndex;
        return re;

      case '[object Blob]':
        return new source.constructor([source], {type: source.type});
    }

    if (isFunction(source.cloneNode)) {
      return source.cloneNode(true);
    }
  }
}


/**
 * @ngdoc function
 * @name angular.equals
 * @module ng
 * @kind function
 *
 * @description
 * Determines if two objects or two values are equivalent. Supports value types, regular
 * expressions, arrays and objects.
 *
 * Two objects or values are considered equivalent if at least one of the following is true:
 *
 * * Both objects or values pass `===` comparison.
 * * Both objects or values are of the same type and all of their properties are equal by
 *   comparing them with `angular.equals`.
 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
 * * Both values represent the same regular expression (In JavaScript,
 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
 *   representation matches).
 *
 * During a property comparison, properties of `function` type and properties with names
 * that begin with `$` are ignored.
 *
 * Scope and DOMWindow objects are being compared only by identify (`===`).
 *
 * @param {*} o1 Object or value to compare.
 * @param {*} o2 Object or value to compare.
 * @returns {boolean} True if arguments are equal.
 *
 * @example
   <example module="equalsExample" name="equalsExample">
     <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate>
          <h3>User 1</h3>
          Name: <input type="text" ng-model="user1.name">
          Age: <input type="number" ng-model="user1.age">

          <h3>User 2</h3>
          Name: <input type="text" ng-model="user2.name">
          Age: <input type="number" ng-model="user2.age">

          <div>
            <br/>
            <input type="button" value="Compare" ng-click="compare()">
          </div>
          User 1: <pre>{{user1 | json}}</pre>
          User 2: <pre>{{user2 | json}}</pre>
          Equal: <pre>{{result}}</pre>
        </form>
      </div>
    </file>
    <file name="script.js">
        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
          $scope.user1 = {};
          $scope.user2 = {};
          $scope.compare = function() {
            $scope.result = angular.equals($scope.user1, $scope.user2);
          };
        }]);
    </file>
  </example>
 */
function equals(o1, o2) {
  if (o1 === o2) return true;
  if (o1 === null || o2 === null) return false;
  // eslint-disable-next-line no-self-compare
  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
  if (t1 === t2 && t1 === 'object') {
    if (isArray(o1)) {
      if (!isArray(o2)) return false;
      if ((length = o1.length) === o2.length) {
        for (key = 0; key < length; key++) {
          if (!equals(o1[key], o2[key])) return false;
        }
        return true;
      }
    } else if (isDate(o1)) {
      if (!isDate(o2)) return false;
      return equals(o1.getTime(), o2.getTime());
    } else if (isRegExp(o1)) {
      if (!isRegExp(o2)) return false;
      return o1.toString() === o2.toString();
    } else {
      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
      keySet = createMap();
      for (key in o1) {
        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
        if (!equals(o1[key], o2[key])) return false;
        keySet[key] = true;
      }
      for (key in o2) {
        if (!(key in keySet) &&
            key.charAt(0) !== '$' &&
            isDefined(o2[key]) &&
            !isFunction(o2[key])) return false;
      }
      return true;
    }
  }
  return false;
}

var csp = function() {
  if (!isDefined(csp.rules)) {


    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
                    window.document.querySelector('[data-ng-csp]'));

    if (ngCspElement) {
      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
                    ngCspElement.getAttribute('data-ng-csp');
      csp.rules = {
        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
      };
    } else {
      csp.rules = {
        noUnsafeEval: noUnsafeEval(),
        noInlineStyle: false
      };
    }
  }

  return csp.rules;

  function noUnsafeEval() {
    try {
      // eslint-disable-next-line no-new, no-new-func
      new Function('');
      return false;
    } catch (e) {
      return true;
    }
  }
};

/**
 * @ngdoc directive
 * @module ng
 * @name ngJq
 *
 * @element ANY
 * @param {string=} ngJq the name of the library available under `window`
 * to be used for angular.element
 * @description
 * Use this directive to force the angular.element library.  This should be
 * used to force either jqLite by leaving ng-jq blank or setting the name of
 * the jquery variable under window (eg. jQuery).
 *
 * Since angular looks for this directive when it is loaded (doesn't wait for the
 * DOMContentLoaded event), it must be placed on an element that comes before the script
 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
 * others ignored.
 *
 * @example
 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
 ```html
 <!doctype html>
 <html ng-app ng-jq>
 ...
 ...
 </html>
 ```
 * @example
 * This example shows how to use a jQuery based library of a different name.
 * The library name must be available at the top most 'window'.
 ```html
 <!doctype html>
 <html ng-app ng-jq="jQueryLib">
 ...
 ...
 </html>
 ```
 */
var jq = function() {
  if (isDefined(jq.name_)) return jq.name_;
  var el;
  var i, ii = ngAttrPrefixes.length, prefix, name;
  for (i = 0; i < ii; ++i) {
    prefix = ngAttrPrefixes[i];
    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
    if (el) {
      name = el.getAttribute(prefix + 'jq');
      break;
    }
  }

  return (jq.name_ = name);
};

function concat(array1, array2, index) {
  return array1.concat(slice.call(array2, index));
}

function sliceArgs(args, startIndex) {
  return slice.call(args, startIndex || 0);
}


/**
 * @ngdoc function
 * @name angular.bind
 * @module ng
 * @kind function
 *
 * @description
 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
 *
 * @param {Object} self Context which `fn` should be evaluated in.
 * @param {function()} fn Function to be bound.
 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
 */
function bind(self, fn) {
  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
  if (isFunction(fn) && !(fn instanceof RegExp)) {
    return curryArgs.length
      ? function() {
          return arguments.length
            ? fn.apply(self, concat(curryArgs, arguments, 0))
            : fn.apply(self, curryArgs);
        }
      : function() {
          return arguments.length
            ? fn.apply(self, arguments)
            : fn.call(self);
        };
  } else {
    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
    return fn;
  }
}


function toJsonReplacer(key, value) {
  var val = value;

  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
    val = undefined;
  } else if (isWindow(value)) {
    val = '$WINDOW';
  } else if (value &&  window.document === value) {
    val = '$DOCUMENT';
  } else if (isScope(value)) {
    val = '$SCOPE';
  }

  return val;
}


/**
 * @ngdoc function
 * @name angular.toJson
 * @module ng
 * @kind function
 *
 * @description
 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
 * stripped since angular uses this notation internally.
 *
 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
 *    If set to an integer, the JSON output will contain that many spaces per indentation.
 * @returns {string|undefined} JSON-ified string representing `obj`.
 * @knownIssue
 *
 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
 * `Date.prototype.toJSON` method as follows:
 *
 * ```
 * var _DatetoJSON = Date.prototype.toJSON;
 * Date.prototype.toJSON = function() {
 *   try {
 *     return _DatetoJSON.call(this);
 *   } catch(e) {
 *     if (e instanceof RangeError) {
 *       return null;
 *     }
 *     throw e;
 *   }
 * };
 * ```
 *
 * See https://github.com/angular/angular.js/pull/14221 for more information.
 */
function toJson(obj, pretty) {
  if (isUndefined(obj)) return undefined;
  if (!isNumber(pretty)) {
    pretty = pretty ? 2 : null;
  }
  return JSON.stringify(obj, toJsonReplacer, pretty);
}


/**
 * @ngdoc function
 * @name angular.fromJson
 * @module ng
 * @kind function
 *
 * @description
 * Deserializes a JSON string.
 *
 * @param {string} json JSON string to deserialize.
 * @returns {Object|Array|string|number} Deserialized JSON string.
 */
function fromJson(json) {
  return isString(json)
      ? JSON.parse(json)
      : json;
}


var ALL_COLONS = /:/g;
function timezoneToOffset(timezone, fallback) {
  // Support: IE 9-11 only, Edge 13-14+
  // IE/Edge do not "understand" colon (`:`) in timezone
  timezone = timezone.replace(ALL_COLONS, '');
  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
}


function addDateMinutes(date, minutes) {
  date = new Date(date.getTime());
  date.setMinutes(date.getMinutes() + minutes);
  return date;
}


function convertTimezoneToLocal(date, timezone, reverse) {
  reverse = reverse ? -1 : 1;
  var dateTimezoneOffset = date.getTimezoneOffset();
  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
}


/**
 * @returns {string} Returns the string representation of the element.
 */
function startingTag(element) {
  element = jqLite(element).clone();
  try {
    // turns out IE does not let you set .html() on elements which
    // are not allowed to have children. So we just ignore it.
    element.empty();
  } catch (e) { /* empty */ }
  var elemHtml = jqLite('<div>').append(element).html();
  try {
    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
        elemHtml.
          match(/^(<[^>]+>)/)[1].
          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
  } catch (e) {
    return lowercase(elemHtml);
  }

}


/////////////////////////////////////////////////

/**
 * Tries to decode the URI component without throwing an exception.
 *
 * @private
 * @param str value potential URI component to check.
 * @returns {boolean} True if `value` can be decoded
 * with the decodeURIComponent function.
 */
function tryDecodeURIComponent(value) {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    // Ignore any invalid uri component.
  }
}


/**
 * Parses an escaped url query string into key-value pairs.
 * @returns {Object.<string,boolean|Array>}
 */
function parseKeyValue(/**string*/keyValue) {
  var obj = {};
  forEach((keyValue || '').split('&'), function(keyValue) {
    var splitPoint, key, val;
    if (keyValue) {
      key = keyValue = keyValue.replace(/\+/g,'%20');
      splitPoint = keyValue.indexOf('=');
      if (splitPoint !== -1) {
        key = keyValue.substring(0, splitPoint);
        val = keyValue.substring(splitPoint + 1);
      }
      key = tryDecodeURIComponent(key);
      if (isDefined(key)) {
        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
        if (!hasOwnProperty.call(obj, key)) {
          obj[key] = val;
        } else if (isArray(obj[key])) {
          obj[key].push(val);
        } else {
          obj[key] = [obj[key],val];
        }
      }
    }
  });
  return obj;
}

function toKeyValue(obj) {
  var parts = [];
  forEach(obj, function(value, key) {
    if (isArray(value)) {
      forEach(value, function(arrayValue) {
        parts.push(encodeUriQuery(key, true) +
                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
      });
    } else {
    parts.push(encodeUriQuery(key, true) +
               (value === true ? '' : '=' + encodeUriQuery(value, true)));
    }
  });
  return parts.length ? parts.join('&') : '';
}


/**
 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
 * segments:
 *    segment       = *pchar
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriSegment(val) {
  return encodeUriQuery(val, true).
             replace(/%26/gi, '&').
             replace(/%3D/gi, '=').
             replace(/%2B/gi, '+');
}


/**
 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
 * encoded per http://tools.ietf.org/html/rfc3986:
 *    query         = *( pchar / "/" / "?" )
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriQuery(val, pctEncodeSpaces) {
  return encodeURIComponent(val).
             replace(/%40/gi, '@').
             replace(/%3A/gi, ':').
             replace(/%24/g, '$').
             replace(/%2C/gi, ',').
             replace(/%3B/gi, ';').
             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
}

var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];

function getNgAttribute(element, ngAttr) {
  var attr, i, ii = ngAttrPrefixes.length;
  for (i = 0; i < ii; ++i) {
    attr = ngAttrPrefixes[i] + ngAttr;
    if (isString(attr = element.getAttribute(attr))) {
      return attr;
    }
  }
  return null;
}

function allowAutoBootstrap(document) {
  if (!document.currentScript) {
    return true;
  }
  var src = document.currentScript.getAttribute('src');
  var link = document.createElement('a');
  link.href = src;
  if (document.location.origin === link.origin) {
    // Same-origin resources are always allowed, even for non-whitelisted schemes.
    return true;
  }
  // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
  // This is to prevent angular.js bundled with browser extensions from being used to bypass the
  // content security policy in web pages and other browser extensions.
  switch (link.protocol) {
    case 'http:':
    case 'https:':
    case 'ftp:':
    case 'blob:':
    case 'file:':
    case 'data:':
      return true;
    default:
      return false;
  }
}

// Cached as it has to run during loading so that document.currentScript is available.
var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);

/**
 * @ngdoc directive
 * @name ngApp
 * @module ng
 *
 * @element ANY
 * @param {angular.Module} ngApp an optional application
 *   {@link angular.module module} name to load.
 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
 *   tracking down the root of these bugs.
 *
 * @description
 *
 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
 * designates the **root element** of the application and is typically placed near the root element
 * of the page - e.g. on the `<body>` or `<html>` tags.
 *
 * There are a few things to keep in mind when using `ngApp`:
 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
 *   found in the document will be used to define the root element to auto-bootstrap as an
 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
 *   {@link angular.bootstrap} instead.
 * - AngularJS applications cannot be nested within each other.
 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
 *   {@link ngRoute.ngView `ngView`}.
 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 *   causing animations to stop working and making the injector inaccessible from outside the app.
 *
 * You can specify an **AngularJS module** to be used as the root module for the application.  This
 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
 * should contain the application code needed or have dependencies on other modules that will
 * contain the code. See {@link angular.module} for more information.
 *
 * In the example below if the `ngApp` directive were not placed on the `html` element then the
 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
 * would not be resolved to `3`.
 *
 * `ngApp` is the easiest, and most common way to bootstrap an application.
 *
 <example module="ngAppDemo" name="ng-app">
   <file name="index.html">
   <div ng-controller="ngAppDemoController">
     I can add: {{a}} + {{b}} =  {{ a+b }}
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
     $scope.a = 1;
     $scope.b = 2;
   });
   </file>
 </example>
 *
 * Using `ngStrictDi`, you would see something like this:
 *
 <example ng-app-included="true" name="strict-di">
   <file name="index.html">
   <div ng-app="ngAppStrictDemo" ng-strict-di>
       <div ng-controller="GoodController1">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style (see
              script.js for details)
           </p>
       </div>

       <div ng-controller="GoodController2">
           Name: <input ng-model="name"><br />
           Hello, {{name}}!

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style
              (see script.js for details)
           </p>
       </div>

       <div ng-controller="BadController">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>The controller could not be instantiated, due to relying
              on automatic function annotations (which are disabled in
              strict mode). As such, the content of this section is not
              interpolated, and there should be an error in your web console.
           </p>
       </div>
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppStrictDemo', [])
     // BadController will fail to instantiate, due to relying on automatic function annotation,
     // rather than an explicit annotation
     .controller('BadController', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     })
     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
     // due to using explicit annotations using the array style and $inject property, respectively.
     .controller('GoodController1', ['$scope', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     }])
     .controller('GoodController2', GoodController2);
     function GoodController2($scope) {
       $scope.name = 'World';
     }
     GoodController2.$inject = ['$scope'];
   </file>
   <file name="style.css">
   div[ng-controller] {
       margin-bottom: 1em;
       -webkit-border-radius: 4px;
       border-radius: 4px;
       border: 1px solid;
       padding: .5em;
   }
   div[ng-controller^=Good] {
       border-color: #d6e9c6;
       background-color: #dff0d8;
       color: #3c763d;
   }
   div[ng-controller^=Bad] {
       border-color: #ebccd1;
       background-color: #f2dede;
       color: #a94442;
       margin-bottom: 0;
   }
   </file>
 </example>
 */
function angularInit(element, bootstrap) {
  var appElement,
      module,
      config = {};

  // The element `element` has priority over any other element.
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';

    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
      appElement = element;
      module = element.getAttribute(name);
    }
  });
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';
    var candidate;

    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
      appElement = candidate;
      module = candidate.getAttribute(name);
    }
  });
  if (appElement) {
    if (!isAutoBootstrapAllowed) {
      window.console.error('Angular: disabling automatic bootstrap. <script> protocol indicates ' +
          'an extension, document.location.href does not match.');
      return;
    }
    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
    bootstrap(appElement, module ? [module] : [], config);
  }
}

/**
 * @ngdoc function
 * @name angular.bootstrap
 * @module ng
 * @description
 * Use this function to manually start up angular application.
 *
 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
 *
 * Angular will detect if it has been loaded into the browser more than once and only allow the
 * first loaded script to be bootstrapped and will report a warning to the browser console for
 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
 * multiple instances of Angular try to work on the DOM.
 *
 * <div class="alert alert-warning">
 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
 * They must use {@link ng.directive:ngApp ngApp}.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 * causing animations to stop working and making the injector inaccessible from outside the app.
 * </div>
 *
 * ```html
 * <!doctype html>
 * <html>
 * <body>
 * <div ng-controller="WelcomeController">
 *   {{greeting}}
 * </div>
 *
 * <script src="angular.js"></script>
 * <script>
 *   var app = angular.module('demo', [])
 *   .controller('WelcomeController', function($scope) {
 *       $scope.greeting = 'Welcome!';
 *   });
 *   angular.bootstrap(document, ['demo']);
 * </script>
 * </body>
 * </html>
 * ```
 *
 * @param {DOMElement} element DOM element which is the root of angular application.
 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 * @param {Object=} config an object for defining configuration options for the application. The
 *     following keys are supported:
 *
 * * `strictDi` - disable automatic function annotation for the application. This is meant to
 *   assist in finding bugs which break minified code. Defaults to `false`.
 *
 * @returns {auto.$injector} Returns the newly created injector for this app.
 */
function bootstrap(element, modules, config) {
  if (!isObject(config)) config = {};
  var defaultConfig = {
    strictDi: false
  };
  config = extend(defaultConfig, config);
  var doBootstrap = function() {
    element = jqLite(element);

    if (element.injector()) {
      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
      throw ngMinErr(
          'btstrpd',
          'App already bootstrapped with this element \'{0}\'',
          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
    }

    modules = modules || [];
    modules.unshift(['$provide', function($provide) {
      $provide.value('$rootElement', element);
    }]);

    if (config.debugInfoEnabled) {
      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
      modules.push(['$compileProvider', function($compileProvider) {
        $compileProvider.debugInfoEnabled(true);
      }]);
    }

    modules.unshift('ng');
    var injector = createInjector(modules, config.strictDi);
    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
       function bootstrapApply(scope, element, compile, injector) {
        scope.$apply(function() {
          element.data('$injector', injector);
          compile(element)(scope);
        });
      }]
    );
    return injector;
  };

  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;

  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
    config.debugInfoEnabled = true;
    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
  }

  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
    return doBootstrap();
  }

  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
  angular.resumeBootstrap = function(extraModules) {
    forEach(extraModules, function(module) {
      modules.push(module);
    });
    return doBootstrap();
  };

  if (isFunction(angular.resumeDeferredBootstrap)) {
    angular.resumeDeferredBootstrap();
  }
}

/**
 * @ngdoc function
 * @name angular.reloadWithDebugInfo
 * @module ng
 * @description
 * Use this function to reload the current application with debug information turned on.
 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
 *
 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
 */
function reloadWithDebugInfo() {
  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
  window.location.reload();
}

/**
 * @name angular.getTestability
 * @module ng
 * @description
 * Get the testability service for the instance of Angular on the given
 * element.
 * @param {DOMElement} element DOM element which is the root of angular application.
 */
function getTestability(rootElement) {
  var injector = angular.element(rootElement).injector();
  if (!injector) {
    throw ngMinErr('test',
      'no injector found for element argument to getTestability');
  }
  return injector.get('$$testability');
}

var SNAKE_CASE_REGEXP = /[A-Z]/g;
function snake_case(name, separator) {
  separator = separator || '_';
  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
    return (pos ? separator : '') + letter.toLowerCase();
  });
}

var bindJQueryFired = false;
function bindJQuery() {
  var originalCleanData;

  if (bindJQueryFired) {
    return;
  }

  // bind to jQuery if present;
  var jqName = jq();
  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
           !jqName             ? undefined     :   // use jqLite
                                 window[jqName];   // use jQuery specified by `ngJq`

  // Use jQuery if it exists with proper functionality, otherwise default to us.
  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
  // versions. It will not work for sure with jQuery <1.7, though.
  if (jQuery && jQuery.fn.on) {
    jqLite = jQuery;
    extend(jQuery.fn, {
      scope: JQLitePrototype.scope,
      isolateScope: JQLitePrototype.isolateScope,
      controller: JQLitePrototype.controller,
      injector: JQLitePrototype.injector,
      inheritedData: JQLitePrototype.inheritedData
    });

    // All nodes removed from the DOM via various jQuery APIs like .remove()
    // are passed through jQuery.cleanData. Monkey-patch this method to fire
    // the $destroy event on all removed nodes.
    originalCleanData = jQuery.cleanData;
    jQuery.cleanData = function(elems) {
      var events;
      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
        events = jQuery._data(elem, 'events');
        if (events && events.$destroy) {
          jQuery(elem).triggerHandler('$destroy');
        }
      }
      originalCleanData(elems);
    };
  } else {
    jqLite = JQLite;
  }

  angular.element = jqLite;

  // Prevent double-proxying.
  bindJQueryFired = true;
}

/**
 * throw error if the argument is falsy.
 */
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
  }
  return arg;
}

function assertArgFn(arg, name, acceptArrayAnnotation) {
  if (acceptArrayAnnotation && isArray(arg)) {
      arg = arg[arg.length - 1];
  }

  assertArg(isFunction(arg), name, 'not a function, got ' +
      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
  return arg;
}

/**
 * throw error if the name given is hasOwnProperty
 * @param  {String} name    the name to test
 * @param  {String} context the context in which the name is used, such as module or directive
 */
function assertNotHasOwnProperty(name, context) {
  if (name === 'hasOwnProperty') {
    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
  }
}

/**
 * Return the value accessible from the object by path. Any undefined traversals are ignored
 * @param {Object} obj starting object
 * @param {String} path path to traverse
 * @param {boolean} [bindFnToScope=true]
 * @returns {Object} value as accessible by path
 */
//TODO(misko): this function needs to be removed
function getter(obj, path, bindFnToScope) {
  if (!path) return obj;
  var keys = path.split('.');
  var key;
  var lastInstance = obj;
  var len = keys.length;

  for (var i = 0; i < len; i++) {
    key = keys[i];
    if (obj) {
      obj = (lastInstance = obj)[key];
    }
  }
  if (!bindFnToScope && isFunction(obj)) {
    return bind(lastInstance, obj);
  }
  return obj;
}

/**
 * Return the DOM siblings between the first and last node in the given array.
 * @param {Array} array like object
 * @returns {Array} the inputted object or a jqLite collection containing the nodes
 */
function getBlockNodes(nodes) {
  // TODO(perf): update `nodes` instead of creating a new object?
  var node = nodes[0];
  var endNode = nodes[nodes.length - 1];
  var blockNodes;

  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
    if (blockNodes || nodes[i] !== node) {
      if (!blockNodes) {
        blockNodes = jqLite(slice.call(nodes, 0, i));
      }
      blockNodes.push(node);
    }
  }

  return blockNodes || nodes;
}


/**
 * Creates a new object without a prototype. This object is useful for lookup without having to
 * guard against prototypically inherited properties via hasOwnProperty.
 *
 * Related micro-benchmarks:
 * - http://jsperf.com/object-create2
 * - http://jsperf.com/proto-map-lookup/2
 * - http://jsperf.com/for-in-vs-object-keys2
 *
 * @returns {Object}
 */
function createMap() {
  return Object.create(null);
}

function stringify(value) {
  if (value == null) { // null || undefined
    return '';
  }
  switch (typeof value) {
    case 'string':
      break;
    case 'number':
      value = '' + value;
      break;
    default:
      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
        value = value.toString();
      } else {
        value = toJson(value);
      }
  }

  return value;
}

var NODE_TYPE_ELEMENT = 1;
var NODE_TYPE_ATTRIBUTE = 2;
var NODE_TYPE_TEXT = 3;
var NODE_TYPE_COMMENT = 8;
var NODE_TYPE_DOCUMENT = 9;
var NODE_TYPE_DOCUMENT_FRAGMENT = 11;

/**
 * @ngdoc type
 * @name angular.Module
 * @module ng
 * @description
 *
 * Interface for configuring angular {@link angular.module modules}.
 */

function setupModuleLoader(window) {

  var $injectorMinErr = minErr('$injector');
  var ngMinErr = minErr('ng');

  function ensure(obj, name, factory) {
    return obj[name] || (obj[name] = factory());
  }

  var angular = ensure(window, 'angular', Object);

  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
  angular.$$minErr = angular.$$minErr || minErr;

  return ensure(angular, 'module', function() {
    /** @type {Object.<string, angular.Module>} */
    var modules = {};

    /**
     * @ngdoc function
     * @name angular.module
     * @module ng
     * @description
     *
     * The `angular.module` is a global place for creating, registering and retrieving Angular
     * modules.
     * All modules (angular core or 3rd party) that should be available to an application must be
     * registered using this mechanism.
     *
     * Passing one argument retrieves an existing {@link angular.Module},
     * whereas passing more than one argument creates a new {@link angular.Module}
     *
     *
     * # Module
     *
     * A module is a collection of services, directives, controllers, filters, and configuration information.
     * `angular.module` is used to configure the {@link auto.$injector $injector}.
     *
     * ```js
     * // Create a new module
     * var myModule = angular.module('myModule', []);
     *
     * // register a new service
     * myModule.value('appName', 'MyCoolApp');
     *
     * // configure existing services inside initialization blocks.
     * myModule.config(['$locationProvider', function($locationProvider) {
     *   // Configure existing providers
     *   $locationProvider.hashPrefix('!');
     * }]);
     * ```
     *
     * Then you can create an injector and load your modules like this:
     *
     * ```js
     * var injector = angular.injector(['ng', 'myModule'])
     * ```
     *
     * However it's more likely that you'll just use
     * {@link ng.directive:ngApp ngApp} or
     * {@link angular.bootstrap} to simplify this process for you.
     *
     * @param {!string} name The name of the module to create or retrieve.
     * @param {!Array.<string>=} requires If specified then new module is being created. If
     *        unspecified then the module is being retrieved for further configuration.
     * @param {Function=} configFn Optional configuration function for the module. Same as
     *        {@link angular.Module#config Module#config()}.
     * @returns {angular.Module} new module with the {@link angular.Module} api.
     */
    return function module(name, requires, configFn) {
      var assertNotHasOwnProperty = function(name, context) {
        if (name === 'hasOwnProperty') {
          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
        }
      };

      assertNotHasOwnProperty(name, 'module');
      if (requires && modules.hasOwnProperty(name)) {
        modules[name] = null;
      }
      return ensure(modules, name, function() {
        if (!requires) {
          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
             'the module name or forgot to load it. If registering a module ensure that you ' +
             'specify the dependencies as the second argument.', name);
        }

        /** @type {!Array.<Array.<*>>} */
        var invokeQueue = [];

        /** @type {!Array.<Function>} */
        var configBlocks = [];

        /** @type {!Array.<Function>} */
        var runBlocks = [];

        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);

        /** @type {angular.Module} */
        var moduleInstance = {
          // Private state
          _invokeQueue: invokeQueue,
          _configBlocks: configBlocks,
          _runBlocks: runBlocks,

          /**
           * @ngdoc property
           * @name angular.Module#requires
           * @module ng
           *
           * @description
           * Holds the list of modules which the injector will load before the current module is
           * loaded.
           */
          requires: requires,

          /**
           * @ngdoc property
           * @name angular.Module#name
           * @module ng
           *
           * @description
           * Name of the module.
           */
          name: name,


          /**
           * @ngdoc method
           * @name angular.Module#provider
           * @module ng
           * @param {string} name service name
           * @param {Function} providerType Construction function for creating new instance of the
           *                                service.
           * @description
           * See {@link auto.$provide#provider $provide.provider()}.
           */
          provider: invokeLaterAndSetModuleName('$provide', 'provider'),

          /**
           * @ngdoc method
           * @name angular.Module#factory
           * @module ng
           * @param {string} name service name
           * @param {Function} providerFunction Function for creating new instance of the service.
           * @description
           * See {@link auto.$provide#factory $provide.factory()}.
           */
          factory: invokeLaterAndSetModuleName('$provide', 'factory'),

          /**
           * @ngdoc method
           * @name angular.Module#service
           * @module ng
           * @param {string} name service name
           * @param {Function} constructor A constructor function that will be instantiated.
           * @description
           * See {@link auto.$provide#service $provide.service()}.
           */
          service: invokeLaterAndSetModuleName('$provide', 'service'),

          /**
           * @ngdoc method
           * @name angular.Module#value
           * @module ng
           * @param {string} name service name
           * @param {*} object Service instance object.
           * @description
           * See {@link auto.$provide#value $provide.value()}.
           */
          value: invokeLater('$provide', 'value'),

          /**
           * @ngdoc method
           * @name angular.Module#constant
           * @module ng
           * @param {string} name constant name
           * @param {*} object Constant value.
           * @description
           * Because the constants are fixed, they get applied before other provide methods.
           * See {@link auto.$provide#constant $provide.constant()}.
           */
          constant: invokeLater('$provide', 'constant', 'unshift'),

           /**
           * @ngdoc method
           * @name angular.Module#decorator
           * @module ng
           * @param {string} name The name of the service to decorate.
           * @param {Function} decorFn This function will be invoked when the service needs to be
           *                           instantiated and should return the decorated service instance.
           * @description
           * See {@link auto.$provide#decorator $provide.decorator()}.
           */
          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),

          /**
           * @ngdoc method
           * @name angular.Module#animation
           * @module ng
           * @param {string} name animation name
           * @param {Function} animationFactory Factory function for creating new instance of an
           *                                    animation.
           * @description
           *
           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
           *
           *
           * Defines an animation hook that can be later used with
           * {@link $animate $animate} service and directives that use this service.
           *
           * ```js
           * module.animation('.animation-name', function($inject1, $inject2) {
           *   return {
           *     eventName : function(element, done) {
           *       //code to run the animation
           *       //once complete, then run done()
           *       return function cancellationFunction(element) {
           *         //code to cancel the animation
           *       }
           *     }
           *   }
           * })
           * ```
           *
           * See {@link ng.$animateProvider#register $animateProvider.register()} and
           * {@link ngAnimate ngAnimate module} for more information.
           */
          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#filter
           * @module ng
           * @param {string} name Filter name - this must be a valid angular expression identifier
           * @param {Function} filterFactory Factory function for creating new instance of filter.
           * @description
           * See {@link ng.$filterProvider#register $filterProvider.register()}.
           *
           * <div class="alert alert-warning">
           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
           * (`myapp_subsection_filterx`).
           * </div>
           */
          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#controller
           * @module ng
           * @param {string|Object} name Controller name, or an object map of controllers where the
           *    keys are the names and the values are the constructors.
           * @param {Function} constructor Controller constructor function.
           * @description
           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
           */
          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#directive
           * @module ng
           * @param {string|Object} name Directive name, or an object map of directives where the
           *    keys are the names and the values are the factories.
           * @param {Function} directiveFactory Factory function for creating new instance of
           * directives.
           * @description
           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
           */
          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),

          /**
           * @ngdoc method
           * @name angular.Module#component
           * @module ng
           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
           * @param {Object} options Component definition object (a simplified
           *    {@link ng.$compile#directive-definition-object directive definition object})
           *
           * @description
           * See {@link ng.$compileProvider#component $compileProvider.component()}.
           */
          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),

          /**
           * @ngdoc method
           * @name angular.Module#config
           * @module ng
           * @param {Function} configFn Execute this function on module load. Useful for service
           *    configuration.
           * @description
           * Use this method to register work which needs to be performed on module loading.
           * For more about how to configure services, see
           * {@link providers#provider-recipe Provider Recipe}.
           */
          config: config,

          /**
           * @ngdoc method
           * @name angular.Module#run
           * @module ng
           * @param {Function} initializationFn Execute this function after injector creation.
           *    Useful for application initialization.
           * @description
           * Use this method to register work which should be performed when the injector is done
           * loading all modules.
           */
          run: function(block) {
            runBlocks.push(block);
            return this;
          }
        };

        if (configFn) {
          config(configFn);
        }

        return moduleInstance;

        /**
         * @param {string} provider
         * @param {string} method
         * @param {String=} insertMethod
         * @returns {angular.Module}
         */
        function invokeLater(provider, method, insertMethod, queue) {
          if (!queue) queue = invokeQueue;
          return function() {
            queue[insertMethod || 'push']([provider, method, arguments]);
            return moduleInstance;
          };
        }

        /**
         * @param {string} provider
         * @param {string} method
         * @returns {angular.Module}
         */
        function invokeLaterAndSetModuleName(provider, method, queue) {
          if (!queue) queue = invokeQueue;
          return function(recipeName, factoryFunction) {
            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
            queue.push([provider, method, arguments]);
            return moduleInstance;
          };
        }
      });
    };
  });

}

/* global shallowCopy: true */

/**
 * Creates a shallow copy of an object, an array or a primitive.
 *
 * Assumes that there are no proto properties for objects.
 */
function shallowCopy(src, dst) {
  if (isArray(src)) {
    dst = dst || [];

    for (var i = 0, ii = src.length; i < ii; i++) {
      dst[i] = src[i];
    }
  } else if (isObject(src)) {
    dst = dst || {};

    for (var key in src) {
      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
        dst[key] = src[key];
      }
    }
  }

  return dst || src;
}

/* global toDebugString: true */

function serializeObject(obj) {
  var seen = [];

  return JSON.stringify(obj, function(key, val) {
    val = toJsonReplacer(key, val);
    if (isObject(val)) {

      if (seen.indexOf(val) >= 0) return '...';

      seen.push(val);
    }
    return val;
  });
}

function toDebugString(obj) {
  if (typeof obj === 'function') {
    return obj.toString().replace(/ \{[\s\S]*$/, '');
  } else if (isUndefined(obj)) {
    return 'undefined';
  } else if (typeof obj !== 'string') {
    return serializeObject(obj);
  }
  return obj;
}

/* global angularModule: true,
  version: true,

  $CompileProvider,

  htmlAnchorDirective,
  inputDirective,
  inputDirective,
  formDirective,
  scriptDirective,
  selectDirective,
  optionDirective,
  ngBindDirective,
  ngBindHtmlDirective,
  ngBindTemplateDirective,
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective,
  ngCloakDirective,
  ngControllerDirective,
  ngFormDirective,
  ngHideDirective,
  ngIfDirective,
  ngIncludeDirective,
  ngIncludeFillContentDirective,
  ngInitDirective,
  ngNonBindableDirective,
  ngPluralizeDirective,
  ngRepeatDirective,
  ngShowDirective,
  ngStyleDirective,
  ngSwitchDirective,
  ngSwitchWhenDirective,
  ngSwitchDefaultDirective,
  ngOptionsDirective,
  ngTranscludeDirective,
  ngModelDirective,
  ngListDirective,
  ngChangeDirective,
  patternDirective,
  patternDirective,
  requiredDirective,
  requiredDirective,
  minlengthDirective,
  minlengthDirective,
  maxlengthDirective,
  maxlengthDirective,
  ngValueDirective,
  ngModelOptionsDirective,
  ngAttributeAliasDirectives,
  ngEventDirectives,

  $AnchorScrollProvider,
  $AnimateProvider,
  $CoreAnimateCssProvider,
  $$CoreAnimateJsProvider,
  $$CoreAnimateQueueProvider,
  $$AnimateRunnerFactoryProvider,
  $$AnimateAsyncRunFactoryProvider,
  $BrowserProvider,
  $CacheFactoryProvider,
  $ControllerProvider,
  $DateProvider,
  $DocumentProvider,
  $$IsDocumentHiddenProvider,
  $ExceptionHandlerProvider,
  $FilterProvider,
  $$ForceReflowProvider,
  $InterpolateProvider,
  $IntervalProvider,
  $$HashMapProvider,
  $HttpProvider,
  $HttpParamSerializerProvider,
  $HttpParamSerializerJQLikeProvider,
  $HttpBackendProvider,
  $xhrFactoryProvider,
  $jsonpCallbacksProvider,
  $LocationProvider,
  $LogProvider,
  $ParseProvider,
  $RootScopeProvider,
  $QProvider,
  $$QProvider,
  $$SanitizeUriProvider,
  $SceProvider,
  $SceDelegateProvider,
  $SnifferProvider,
  $TemplateCacheProvider,
  $TemplateRequestProvider,
  $$TestabilityProvider,
  $TimeoutProvider,
  $$RAFProvider,
  $WindowProvider,
  $$jqLiteProvider,
  $$CookieReaderProvider
*/


/**
 * @ngdoc object
 * @name angular.version
 * @module ng
 * @description
 * An object that contains information about the current AngularJS version.
 *
 * This object has the following properties:
 *
 * - `full` – `{string}` – Full version string, such as "0.9.18".
 * - `major` – `{number}` – Major version number, such as "0".
 * - `minor` – `{number}` – Minor version number, such as "9".
 * - `dot` – `{number}` – Dot version number, such as "18".
 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
 */
var version = {
  // These placeholder strings will be replaced by grunt's `build` task.
  // They need to be double- or single-quoted.
  full: '1.6.1',
  major: 1,
  minor: 6,
  dot: 1,
  codeName: 'promise-rectification'
};


function publishExternalAPI(angular) {
  extend(angular, {
    'bootstrap': bootstrap,
    'copy': copy,
    'extend': extend,
    'merge': merge,
    'equals': equals,
    'element': jqLite,
    'forEach': forEach,
    'injector': createInjector,
    'noop': noop,
    'bind': bind,
    'toJson': toJson,
    'fromJson': fromJson,
    'identity': identity,
    'isUndefined': isUndefined,
    'isDefined': isDefined,
    'isString': isString,
    'isFunction': isFunction,
    'isObject': isObject,
    'isNumber': isNumber,
    'isElement': isElement,
    'isArray': isArray,
    'version': version,
    'isDate': isDate,
    'lowercase': lowercase,
    'uppercase': uppercase,
    'callbacks': {$$counter: 0},
    'getTestability': getTestability,
    'reloadWithDebugInfo': reloadWithDebugInfo,
    '$$minErr': minErr,
    '$$csp': csp,
    '$$encodeUriSegment': encodeUriSegment,
    '$$encodeUriQuery': encodeUriQuery,
    '$$stringify': stringify
  });

  angularModule = setupModuleLoader(window);

  angularModule('ng', ['ngLocale'], ['$provide',
    function ngModule($provide) {
      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
      $provide.provider({
        $$sanitizeUri: $$SanitizeUriProvider
      });
      $provide.provider('$compile', $CompileProvider).
        directive({
            a: htmlAnchorDirective,
            input: inputDirective,
            textarea: inputDirective,
            form: formDirective,
            script: scriptDirective,
            select: selectDirective,
            option: optionDirective,
            ngBind: ngBindDirective,
            ngBindHtml: ngBindHtmlDirective,
            ngBindTemplate: ngBindTemplateDirective,
            ngClass: ngClassDirective,
            ngClassEven: ngClassEvenDirective,
            ngClassOdd: ngClassOddDirective,
            ngCloak: ngCloakDirective,
            ngController: ngControllerDirective,
            ngForm: ngFormDirective,
            ngHide: ngHideDirective,
            ngIf: ngIfDirective,
            ngInclude: ngIncludeDirective,
            ngInit: ngInitDirective,
            ngNonBindable: ngNonBindableDirective,
            ngPluralize: ngPluralizeDirective,
            ngRepeat: ngRepeatDirective,
            ngShow: ngShowDirective,
            ngStyle: ngStyleDirective,
            ngSwitch: ngSwitchDirective,
            ngSwitchWhen: ngSwitchWhenDirective,
            ngSwitchDefault: ngSwitchDefaultDirective,
            ngOptions: ngOptionsDirective,
            ngTransclude: ngTranscludeDirective,
            ngModel: ngModelDirective,
            ngList: ngListDirective,
            ngChange: ngChangeDirective,
            pattern: patternDirective,
            ngPattern: patternDirective,
            required: requiredDirective,
            ngRequired: requiredDirective,
            minlength: minlengthDirective,
            ngMinlength: minlengthDirective,
            maxlength: maxlengthDirective,
            ngMaxlength: maxlengthDirective,
            ngValue: ngValueDirective,
            ngModelOptions: ngModelOptionsDirective
        }).
        directive({
          ngInclude: ngIncludeFillContentDirective
        }).
        directive(ngAttributeAliasDirectives).
        directive(ngEventDirectives);
      $provide.provider({
        $anchorScroll: $AnchorScrollProvider,
        $animate: $AnimateProvider,
        $animateCss: $CoreAnimateCssProvider,
        $$animateJs: $$CoreAnimateJsProvider,
        $$animateQueue: $$CoreAnimateQueueProvider,
        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
        $browser: $BrowserProvider,
        $cacheFactory: $CacheFactoryProvider,
        $controller: $ControllerProvider,
        $document: $DocumentProvider,
        $$isDocumentHidden: $$IsDocumentHiddenProvider,
        $exceptionHandler: $ExceptionHandlerProvider,
        $filter: $FilterProvider,
        $$forceReflow: $$ForceReflowProvider,
        $interpolate: $InterpolateProvider,
        $interval: $IntervalProvider,
        $http: $HttpProvider,
        $httpParamSerializer: $HttpParamSerializerProvider,
        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
        $httpBackend: $HttpBackendProvider,
        $xhrFactory: $xhrFactoryProvider,
        $jsonpCallbacks: $jsonpCallbacksProvider,
        $location: $LocationProvider,
        $log: $LogProvider,
        $parse: $ParseProvider,
        $rootScope: $RootScopeProvider,
        $q: $QProvider,
        $$q: $$QProvider,
        $sce: $SceProvider,
        $sceDelegate: $SceDelegateProvider,
        $sniffer: $SnifferProvider,
        $templateCache: $TemplateCacheProvider,
        $templateRequest: $TemplateRequestProvider,
        $$testability: $$TestabilityProvider,
        $timeout: $TimeoutProvider,
        $window: $WindowProvider,
        $$rAF: $$RAFProvider,
        $$jqLite: $$jqLiteProvider,
        $$HashMap: $$HashMapProvider,
        $$cookieReader: $$CookieReaderProvider
      });
    }
  ]);
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* global
  JQLitePrototype: true,
  BOOLEAN_ATTR: true,
  ALIASED_ATTR: true
*/

//////////////////////////////////
//JQLite
//////////////////////////////////

/**
 * @ngdoc function
 * @name angular.element
 * @module ng
 * @kind function
 *
 * @description
 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
 *
 * If jQuery is available, `angular.element` is an alias for the
 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
 *
 * jqLite is a tiny, API-compatible subset of jQuery that allows
 * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
 * commonly needed functionality with the goal of having a very small footprint.
 *
 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
 * specific version of jQuery if multiple versions exist on the page.
 *
 * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
 *
 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
 *
 * ## Angular's jqLite
 * jqLite provides only the following jQuery methods:
 *
 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
 * - [`after()`](http://api.jquery.com/after/)
 * - [`append()`](http://api.jquery.com/append/)
 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
 * - [`clone()`](http://api.jquery.com/clone/)
 * - [`contents()`](http://api.jquery.com/contents/)
 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
 * - [`data()`](http://api.jquery.com/data/)
 * - [`detach()`](http://api.jquery.com/detach/)
 * - [`empty()`](http://api.jquery.com/empty/)
 * - [`eq()`](http://api.jquery.com/eq/)
 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
 * - [`hasClass()`](http://api.jquery.com/hasClass/)
 * - [`html()`](http://api.jquery.com/html/)
 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
 * - [`prepend()`](http://api.jquery.com/prepend/)
 * - [`prop()`](http://api.jquery.com/prop/)
 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
 * - [`remove()`](http://api.jquery.com/remove/)
 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
 * - [`removeData()`](http://api.jquery.com/removeData/)
 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
 * - [`text()`](http://api.jquery.com/text/)
 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
 * - [`val()`](http://api.jquery.com/val/)
 * - [`wrap()`](http://api.jquery.com/wrap/)
 *
 * ## jQuery/jqLite Extras
 * Angular also provides the following additional methods and events to both jQuery and jqLite:
 *
 * ### Events
 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
 *    element before it is removed.
 *
 * ### Methods
 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
 *   `'ngModel'`).
 * - `injector()` - retrieves the injector of the current element or its parent.
 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
 *   be enabled.
 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
 *   parent element is reached.
 *
 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
 * https://github.com/angular/angular.js/issues/14251 for more information.
 *
 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
 * @returns {Object} jQuery object.
 */

JQLite.expando = 'ng339';

var jqCache = JQLite.cache = {},
    jqId = 1;

/*
 * !!! This is an undocumented "private" function !!!
 */
JQLite._data = function(node) {
  //jQuery always returns an object on cache miss
  return this.cache[node[this.expando]] || {};
};

function jqNextId() { return ++jqId; }


var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
var MS_HACK_REGEXP = /^-ms-/;
var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
var jqLiteMinErr = minErr('jqLite');

/**
 * Converts kebab-case to camelCase.
 * There is also a special case for the ms prefix starting with a lowercase letter.
 * @param name Name to normalize
 */
function cssKebabToCamel(name) {
    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
}

function fnCamelCaseReplace(all, letter) {
  return letter.toUpperCase();
}

/**
 * Converts kebab-case to camelCase.
 * @param name Name to normalize
 */
function kebabToCamel(name) {
  return name
    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
}

var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
var HTML_REGEXP = /<|&#?\w+;/;
var TAG_NAME_REGEXP = /<([\w:-]+)/;
var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;

var wrapMap = {
  'option': [1, '<select multiple="multiple">', '</select>'],

  'thead': [1, '<table>', '</table>'],
  'col': [2, '<table><colgroup>', '</colgroup></table>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],
  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
  '_default': [0, '', '']
};

wrapMap.optgroup = wrapMap.option;
wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function jqLiteIsTextNode(html) {
  return !HTML_REGEXP.test(html);
}

function jqLiteAcceptsData(node) {
  // The window object can accept data but has no nodeType
  // Otherwise we are only interested in elements (1) and documents (9)
  var nodeType = node.nodeType;
  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
}

function jqLiteHasData(node) {
  for (var key in jqCache[node.ng339]) {
    return true;
  }
  return false;
}

function jqLiteCleanData(nodes) {
  for (var i = 0, ii = nodes.length; i < ii; i++) {
    jqLiteRemoveData(nodes[i]);
  }
}

function jqLiteBuildFragment(html, context) {
  var tmp, tag, wrap,
      fragment = context.createDocumentFragment(),
      nodes = [], i;

  if (jqLiteIsTextNode(html)) {
    // Convert non-html into a text node
    nodes.push(context.createTextNode(html));
  } else {
    // Convert html into DOM nodes
    tmp = fragment.appendChild(context.createElement('div'));
    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
    wrap = wrapMap[tag] || wrapMap._default;
    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, '<$1></$2>') + wrap[2];

    // Descend through wrappers to the right content
    i = wrap[0];
    while (i--) {
      tmp = tmp.lastChild;
    }

    nodes = concat(nodes, tmp.childNodes);

    tmp = fragment.firstChild;
    tmp.textContent = '';
  }

  // Remove wrapper from fragment
  fragment.textContent = '';
  fragment.innerHTML = ''; // Clear inner HTML
  forEach(nodes, function(node) {
    fragment.appendChild(node);
  });

  return fragment;
}

function jqLiteParseHTML(html, context) {
  context = context || window.document;
  var parsed;

  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
    return [context.createElement(parsed[1])];
  }

  if ((parsed = jqLiteBuildFragment(html, context))) {
    return parsed.childNodes;
  }

  return [];
}

function jqLiteWrapNode(node, wrapper) {
  var parent = node.parentNode;

  if (parent) {
    parent.replaceChild(wrapper, node);
  }

  wrapper.appendChild(node);
}


// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
  // eslint-disable-next-line no-bitwise
  return !!(this.compareDocumentPosition(arg) & 16);
};

/////////////////////////////////////////////
function JQLite(element) {
  if (element instanceof JQLite) {
    return element;
  }

  var argIsString;

  if (isString(element)) {
    element = trim(element);
    argIsString = true;
  }
  if (!(this instanceof JQLite)) {
    if (argIsString && element.charAt(0) !== '<') {
      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
    }
    return new JQLite(element);
  }

  if (argIsString) {
    jqLiteAddNodes(this, jqLiteParseHTML(element));
  } else if (isFunction(element)) {
    jqLiteReady(element);
  } else {
    jqLiteAddNodes(this, element);
  }
}

function jqLiteClone(element) {
  return element.cloneNode(true);
}

function jqLiteDealoc(element, onlyDescendants) {
  if (!onlyDescendants) jqLiteRemoveData(element);

  if (element.querySelectorAll) {
    var descendants = element.querySelectorAll('*');
    for (var i = 0, l = descendants.length; i < l; i++) {
      jqLiteRemoveData(descendants[i]);
    }
  }
}

function jqLiteOff(element, type, fn, unsupported) {
  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');

  var expandoStore = jqLiteExpandoStore(element);
  var events = expandoStore && expandoStore.events;
  var handle = expandoStore && expandoStore.handle;

  if (!handle) return; //no listeners registered

  if (!type) {
    for (type in events) {
      if (type !== '$destroy') {
        element.removeEventListener(type, handle);
      }
      delete events[type];
    }
  } else {

    var removeHandler = function(type) {
      var listenerFns = events[type];
      if (isDefined(fn)) {
        arrayRemove(listenerFns || [], fn);
      }
      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
        element.removeEventListener(type, handle);
        delete events[type];
      }
    };

    forEach(type.split(' '), function(type) {
      removeHandler(type);
      if (MOUSE_EVENT_MAP[type]) {
        removeHandler(MOUSE_EVENT_MAP[type]);
      }
    });
  }
}

function jqLiteRemoveData(element, name) {
  var expandoId = element.ng339;
  var expandoStore = expandoId && jqCache[expandoId];

  if (expandoStore) {
    if (name) {
      delete expandoStore.data[name];
      return;
    }

    if (expandoStore.handle) {
      if (expandoStore.events.$destroy) {
        expandoStore.handle({}, '$destroy');
      }
      jqLiteOff(element);
    }
    delete jqCache[expandoId];
    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
  }
}


function jqLiteExpandoStore(element, createIfNecessary) {
  var expandoId = element.ng339,
      expandoStore = expandoId && jqCache[expandoId];

  if (createIfNecessary && !expandoStore) {
    element.ng339 = expandoId = jqNextId();
    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
  }

  return expandoStore;
}


function jqLiteData(element, key, value) {
  if (jqLiteAcceptsData(element)) {
    var prop;

    var isSimpleSetter = isDefined(value);
    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
    var massGetter = !key;
    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
    var data = expandoStore && expandoStore.data;

    if (isSimpleSetter) { // data('key', value)
      data[kebabToCamel(key)] = value;
    } else {
      if (massGetter) {  // data()
        return data;
      } else {
        if (isSimpleGetter) { // data('key')
          // don't force creation of expandoStore if it doesn't exist yet
          return data && data[kebabToCamel(key)];
        } else { // mass-setter: data({key1: val1, key2: val2})
          for (prop in key) {
            data[kebabToCamel(prop)] = key[prop];
          }
        }
      }
    }
  }
}

function jqLiteHasClass(element, selector) {
  if (!element.getAttribute) return false;
  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
      indexOf(' ' + selector + ' ') > -1);
}

function jqLiteRemoveClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    forEach(cssClasses.split(' '), function(cssClass) {
      element.setAttribute('class', trim(
          (' ' + (element.getAttribute('class') || '') + ' ')
          .replace(/[\n\t]/g, ' ')
          .replace(' ' + trim(cssClass) + ' ', ' '))
      );
    });
  }
}

function jqLiteAddClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
                            .replace(/[\n\t]/g, ' ');

    forEach(cssClasses.split(' '), function(cssClass) {
      cssClass = trim(cssClass);
      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
        existingClasses += cssClass + ' ';
      }
    });

    element.setAttribute('class', trim(existingClasses));
  }
}


function jqLiteAddNodes(root, elements) {
  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.

  if (elements) {

    // if a Node (the most common case)
    if (elements.nodeType) {
      root[root.length++] = elements;
    } else {
      var length = elements.length;

      // if an Array or NodeList and not a Window
      if (typeof length === 'number' && elements.window !== elements) {
        if (length) {
          for (var i = 0; i < length; i++) {
            root[root.length++] = elements[i];
          }
        }
      } else {
        root[root.length++] = elements;
      }
    }
  }
}


function jqLiteController(element, name) {
  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
}

function jqLiteInheritedData(element, name, value) {
  // if element is the document object work with the html element instead
  // this makes $(document).scope() possible
  if (element.nodeType === NODE_TYPE_DOCUMENT) {
    element = element.documentElement;
  }
  var names = isArray(name) ? name : [name];

  while (element) {
    for (var i = 0, ii = names.length; i < ii; i++) {
      if (isDefined(value = jqLite.data(element, names[i]))) return value;
    }

    // If dealing with a document fragment node with a host element, and no parent, use the host
    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
    // to lookup parent controllers.
    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
  }
}

function jqLiteEmpty(element) {
  jqLiteDealoc(element, true);
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
}

function jqLiteRemove(element, keepData) {
  if (!keepData) jqLiteDealoc(element);
  var parent = element.parentNode;
  if (parent) parent.removeChild(element);
}


function jqLiteDocumentLoaded(action, win) {
  win = win || window;
  if (win.document.readyState === 'complete') {
    // Force the action to be run async for consistent behavior
    // from the action's point of view
    // i.e. it will definitely not be in a $apply
    win.setTimeout(action);
  } else {
    // No need to unbind this handler as load is only ever called once
    jqLite(win).on('load', action);
  }
}

function jqLiteReady(fn) {
  function trigger() {
    window.document.removeEventListener('DOMContentLoaded', trigger);
    window.removeEventListener('load', trigger);
    fn();
  }

  // check if document is already loaded
  if (window.document.readyState === 'complete') {
    window.setTimeout(fn);
  } else {
    // We can not use jqLite since we are not done loading and jQuery could be loaded later.

    // Works for modern browsers and IE9
    window.document.addEventListener('DOMContentLoaded', trigger);

    // Fallback to window.onload for others
    window.addEventListener('load', trigger);
  }
}

//////////////////////////////////////////
// Functions which are declared directly.
//////////////////////////////////////////
var JQLitePrototype = JQLite.prototype = {
  ready: jqLiteReady,
  toString: function() {
    var value = [];
    forEach(this, function(e) { value.push('' + e);});
    return '[' + value.join(', ') + ']';
  },

  eq: function(index) {
      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
  },

  length: 0,
  push: push,
  sort: [].sort,
  splice: [].splice
};

//////////////////////////////////////////
// Functions iterating getter/setters.
// these functions return self on setter and
// value on get.
//////////////////////////////////////////
var BOOLEAN_ATTR = {};
forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
  BOOLEAN_ATTR[lowercase(value)] = value;
});
var BOOLEAN_ELEMENTS = {};
forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
  BOOLEAN_ELEMENTS[value] = true;
});
var ALIASED_ATTR = {
  'ngMinlength': 'minlength',
  'ngMaxlength': 'maxlength',
  'ngMin': 'min',
  'ngMax': 'max',
  'ngPattern': 'pattern',
  'ngStep': 'step'
};

function getBooleanAttrName(element, name) {
  // check dom last since we will most likely fail on name
  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];

  // booleanAttr is here twice to minimize DOM access
  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
}

function getAliasedAttrName(name) {
  return ALIASED_ATTR[name];
}

forEach({
  data: jqLiteData,
  removeData: jqLiteRemoveData,
  hasData: jqLiteHasData,
  cleanData: jqLiteCleanData
}, function(fn, name) {
  JQLite[name] = fn;
});

forEach({
  data: jqLiteData,
  inheritedData: jqLiteInheritedData,

  scope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
  },

  isolateScope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
  },

  controller: jqLiteController,

  injector: function(element) {
    return jqLiteInheritedData(element, '$injector');
  },

  removeAttr: function(element, name) {
    element.removeAttribute(name);
  },

  hasClass: jqLiteHasClass,

  css: function(element, name, value) {
    name = cssKebabToCamel(name);

    if (isDefined(value)) {
      element.style[name] = value;
    } else {
      return element.style[name];
    }
  },

  attr: function(element, name, value) {
    var ret;
    var nodeType = element.nodeType;
    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
      !element.getAttribute) {
      return;
    }

    var lowercasedName = lowercase(name);
    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];

    if (isDefined(value)) {
      // setter

      if (value === null || (value === false && isBooleanAttr)) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
      }
    } else {
      // getter

      ret = element.getAttribute(name);

      if (isBooleanAttr && ret !== null) {
        ret = lowercasedName;
      }
      // Normalize non-existing attributes to undefined (as jQuery).
      return ret === null ? undefined : ret;
    }
  },

  prop: function(element, name, value) {
    if (isDefined(value)) {
      element[name] = value;
    } else {
      return element[name];
    }
  },

  text: (function() {
    getText.$dv = '';
    return getText;

    function getText(element, value) {
      if (isUndefined(value)) {
        var nodeType = element.nodeType;
        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
      }
      element.textContent = value;
    }
  })(),

  val: function(element, value) {
    if (isUndefined(value)) {
      if (element.multiple && nodeName_(element) === 'select') {
        var result = [];
        forEach(element.options, function(option) {
          if (option.selected) {
            result.push(option.value || option.text);
          }
        });
        return result;
      }
      return element.value;
    }
    element.value = value;
  },

  html: function(element, value) {
    if (isUndefined(value)) {
      return element.innerHTML;
    }
    jqLiteDealoc(element, true);
    element.innerHTML = value;
  },

  empty: jqLiteEmpty
}, function(fn, name) {
  /**
   * Properties: writes return selection, reads return first value
   */
  JQLite.prototype[name] = function(arg1, arg2) {
    var i, key;
    var nodeCount = this.length;

    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
    // in a way that survives minification.
    // jqLiteEmpty takes no arguments but is a setter.
    if (fn !== jqLiteEmpty &&
        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
      if (isObject(arg1)) {

        // we are a write, but the object properties are the key/values
        for (i = 0; i < nodeCount; i++) {
          if (fn === jqLiteData) {
            // data() takes the whole object in jQuery
            fn(this[i], arg1);
          } else {
            for (key in arg1) {
              fn(this[i], key, arg1[key]);
            }
          }
        }
        // return self for chaining
        return this;
      } else {
        // we are a read, so read the first child.
        // TODO: do we still need this?
        var value = fn.$dv;
        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
        for (var j = 0; j < jj; j++) {
          var nodeValue = fn(this[j], arg1, arg2);
          value = value ? value + nodeValue : nodeValue;
        }
        return value;
      }
    } else {
      // we are a write, so apply to all children
      for (i = 0; i < nodeCount; i++) {
        fn(this[i], arg1, arg2);
      }
      // return self for chaining
      return this;
    }
  };
});

function createEventHandler(element, events) {
  var eventHandler = function(event, type) {
    // jQuery specific api
    event.isDefaultPrevented = function() {
      return event.defaultPrevented;
    };

    var eventFns = events[type || event.type];
    var eventFnsLength = eventFns ? eventFns.length : 0;

    if (!eventFnsLength) return;

    if (isUndefined(event.immediatePropagationStopped)) {
      var originalStopImmediatePropagation = event.stopImmediatePropagation;
      event.stopImmediatePropagation = function() {
        event.immediatePropagationStopped = true;

        if (event.stopPropagation) {
          event.stopPropagation();
        }

        if (originalStopImmediatePropagation) {
          originalStopImmediatePropagation.call(event);
        }
      };
    }

    event.isImmediatePropagationStopped = function() {
      return event.immediatePropagationStopped === true;
    };

    // Some events have special handlers that wrap the real handler
    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;

    // Copy event handlers in case event handlers array is modified during execution.
    if ((eventFnsLength > 1)) {
      eventFns = shallowCopy(eventFns);
    }

    for (var i = 0; i < eventFnsLength; i++) {
      if (!event.isImmediatePropagationStopped()) {
        handlerWrapper(element, event, eventFns[i]);
      }
    }
  };

  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
  //       events on `element`
  eventHandler.elem = element;
  return eventHandler;
}

function defaultHandlerWrapper(element, event, handler) {
  handler.call(element, event);
}

function specialMouseHandlerWrapper(target, event, handler) {
  // Refer to jQuery's implementation of mouseenter & mouseleave
  // Read about mouseenter and mouseleave:
  // http://www.quirksmode.org/js/events_mouse.html#link8
  var related = event.relatedTarget;
  // For mousenter/leave call the handler if related is outside the target.
  // NB: No relatedTarget if the mouse left/entered the browser window
  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
    handler.call(target, event);
  }
}

//////////////////////////////////////////
// Functions iterating traversal.
// These functions chain results into a single
// selector.
//////////////////////////////////////////
forEach({
  removeData: jqLiteRemoveData,

  on: function jqLiteOn(element, type, fn, unsupported) {
    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');

    // Do not add event handlers to non-elements because they will not be cleaned up.
    if (!jqLiteAcceptsData(element)) {
      return;
    }

    var expandoStore = jqLiteExpandoStore(element, true);
    var events = expandoStore.events;
    var handle = expandoStore.handle;

    if (!handle) {
      handle = expandoStore.handle = createEventHandler(element, events);
    }

    // http://jsperf.com/string-indexof-vs-split
    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
    var i = types.length;

    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
      var eventFns = events[type];

      if (!eventFns) {
        eventFns = events[type] = [];
        eventFns.specialHandlerWrapper = specialHandlerWrapper;
        if (type !== '$destroy' && !noEventListener) {
          element.addEventListener(type, handle);
        }
      }

      eventFns.push(fn);
    };

    while (i--) {
      type = types[i];
      if (MOUSE_EVENT_MAP[type]) {
        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
        addHandler(type, undefined, true);
      } else {
        addHandler(type);
      }
    }
  },

  off: jqLiteOff,

  one: function(element, type, fn) {
    element = jqLite(element);

    //add the listener twice so that when it is called
    //you can remove the original function and still be
    //able to call element.off(ev, fn) normally
    element.on(type, function onFn() {
      element.off(type, fn);
      element.off(type, onFn);
    });
    element.on(type, fn);
  },

  replaceWith: function(element, replaceNode) {
    var index, parent = element.parentNode;
    jqLiteDealoc(element);
    forEach(new JQLite(replaceNode), function(node) {
      if (index) {
        parent.insertBefore(node, index.nextSibling);
      } else {
        parent.replaceChild(node, element);
      }
      index = node;
    });
  },

  children: function(element) {
    var children = [];
    forEach(element.childNodes, function(element) {
      if (element.nodeType === NODE_TYPE_ELEMENT) {
        children.push(element);
      }
    });
    return children;
  },

  contents: function(element) {
    return element.contentDocument || element.childNodes || [];
  },

  append: function(element, node) {
    var nodeType = element.nodeType;
    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;

    node = new JQLite(node);

    for (var i = 0, ii = node.length; i < ii; i++) {
      var child = node[i];
      element.appendChild(child);
    }
  },

  prepend: function(element, node) {
    if (element.nodeType === NODE_TYPE_ELEMENT) {
      var index = element.firstChild;
      forEach(new JQLite(node), function(child) {
        element.insertBefore(child, index);
      });
    }
  },

  wrap: function(element, wrapNode) {
    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
  },

  remove: jqLiteRemove,

  detach: function(element) {
    jqLiteRemove(element, true);
  },

  after: function(element, newElement) {
    var index = element, parent = element.parentNode;

    if (parent) {
      newElement = new JQLite(newElement);

      for (var i = 0, ii = newElement.length; i < ii; i++) {
        var node = newElement[i];
        parent.insertBefore(node, index.nextSibling);
        index = node;
      }
    }
  },

  addClass: jqLiteAddClass,
  removeClass: jqLiteRemoveClass,

  toggleClass: function(element, selector, condition) {
    if (selector) {
      forEach(selector.split(' '), function(className) {
        var classCondition = condition;
        if (isUndefined(classCondition)) {
          classCondition = !jqLiteHasClass(element, className);
        }
        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
      });
    }
  },

  parent: function(element) {
    var parent = element.parentNode;
    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
  },

  next: function(element) {
    return element.nextElementSibling;
  },

  find: function(element, selector) {
    if (element.getElementsByTagName) {
      return element.getElementsByTagName(selector);
    } else {
      return [];
    }
  },

  clone: jqLiteClone,

  triggerHandler: function(element, event, extraParameters) {

    var dummyEvent, eventFnsCopy, handlerArgs;
    var eventName = event.type || event;
    var expandoStore = jqLiteExpandoStore(element);
    var events = expandoStore && expandoStore.events;
    var eventFns = events && events[eventName];

    if (eventFns) {
      // Create a dummy event to pass to the handlers
      dummyEvent = {
        preventDefault: function() { this.defaultPrevented = true; },
        isDefaultPrevented: function() { return this.defaultPrevented === true; },
        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
        stopPropagation: noop,
        type: eventName,
        target: element
      };

      // If a custom event was provided then extend our dummy event with it
      if (event.type) {
        dummyEvent = extend(dummyEvent, event);
      }

      // Copy event handlers in case event handlers array is modified during execution.
      eventFnsCopy = shallowCopy(eventFns);
      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];

      forEach(eventFnsCopy, function(fn) {
        if (!dummyEvent.isImmediatePropagationStopped()) {
          fn.apply(element, handlerArgs);
        }
      });
    }
  }
}, function(fn, name) {
  /**
   * chaining functions
   */
  JQLite.prototype[name] = function(arg1, arg2, arg3) {
    var value;

    for (var i = 0, ii = this.length; i < ii; i++) {
      if (isUndefined(value)) {
        value = fn(this[i], arg1, arg2, arg3);
        if (isDefined(value)) {
          // any function which returns a value needs to be wrapped
          value = jqLite(value);
        }
      } else {
        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
      }
    }
    return isDefined(value) ? value : this;
  };
});

// bind legacy bind/unbind to on/off
JQLite.prototype.bind = JQLite.prototype.on;
JQLite.prototype.unbind = JQLite.prototype.off;


// Provider for private $$jqLite service
/** @this */
function $$jqLiteProvider() {
  this.$get = function $$jqLite() {
    return extend(JQLite, {
      hasClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteHasClass(node, classes);
      },
      addClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteAddClass(node, classes);
      },
      removeClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteRemoveClass(node, classes);
      }
    });
  };
}

/**
 * Computes a hash of an 'obj'.
 * Hash of a:
 *  string is string
 *  number is number as string
 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
 *         that is also assigned to the $$hashKey property of the object.
 *
 * @param obj
 * @returns {string} hash string such that the same input will have the same hash string.
 *         The resulting string key is in 'type:hashKey' format.
 */
function hashKey(obj, nextUidFn) {
  var key = obj && obj.$$hashKey;

  if (key) {
    if (typeof key === 'function') {
      key = obj.$$hashKey();
    }
    return key;
  }

  var objType = typeof obj;
  if (objType === 'function' || (objType === 'object' && obj !== null)) {
    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
  } else {
    key = objType + ':' + obj;
  }

  return key;
}

/**
 * HashMap which can use objects as keys
 */
function HashMap(array, isolatedUid) {
  if (isolatedUid) {
    var uid = 0;
    this.nextUid = function() {
      return ++uid;
    };
  }
  forEach(array, this.put, this);
}
HashMap.prototype = {
  /**
   * Store key value pair
   * @param key key to store can be any type
   * @param value value to store can be any type
   */
  put: function(key, value) {
    this[hashKey(key, this.nextUid)] = value;
  },

  /**
   * @param key
   * @returns {Object} the value for the key
   */
  get: function(key) {
    return this[hashKey(key, this.nextUid)];
  },

  /**
   * Remove the key/value pair
   * @param key
   */
  remove: function(key) {
    var value = this[key = hashKey(key, this.nextUid)];
    delete this[key];
    return value;
  }
};

var $$HashMapProvider = [/** @this */function() {
  this.$get = [function() {
    return HashMap;
  }];
}];

/**
 * @ngdoc function
 * @module ng
 * @name angular.injector
 * @kind function
 *
 * @description
 * Creates an injector object that can be used for retrieving services as well as for
 * dependency injection (see {@link guide/di dependency injection}).
 *
 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
 *     {@link angular.module}. The `ng` module must be explicitly added.
 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
 *     disallows argument name annotation inference.
 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
 *
 * @example
 * Typical usage
 * ```js
 *   // create an injector
 *   var $injector = angular.injector(['ng']);
 *
 *   // use the injector to kick off your application
 *   // use the type inference to auto inject arguments, or use implicit injection
 *   $injector.invoke(function($rootScope, $compile, $document) {
 *     $compile($document)($rootScope);
 *     $rootScope.$digest();
 *   });
 * ```
 *
 * Sometimes you want to get access to the injector of a currently running Angular app
 * from outside Angular. Perhaps, you want to inject and compile some markup after the
 * application has been bootstrapped. You can do this using the extra `injector()` added
 * to JQuery/jqLite elements. See {@link angular.element}.
 *
 * *This is fairly rare but could be the case if a third party library is injecting the
 * markup.*
 *
 * In the following example a new block of HTML containing a `ng-controller`
 * directive is added to the end of the document body by JQuery. We then compile and link
 * it into the current AngularJS scope.
 *
 * ```js
 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
 * $(document.body).append($div);
 *
 * angular.element(document).injector().invoke(function($compile) {
 *   var scope = angular.element($div).scope();
 *   $compile($div)(scope);
 * });
 * ```
 */


/**
 * @ngdoc module
 * @name auto
 * @installation
 * @description
 *
 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
 */

var ARROW_ARG = /^([^(]+?)=>/;
var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
var FN_ARG_SPLIT = /,/;
var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
var $injectorMinErr = minErr('$injector');

function stringifyFn(fn) {
  // Support: Chrome 50-51 only
  // Creating a new string by adding `' '` at the end, to hack around some bug in Chrome v50/51
  // (See https://github.com/angular/angular.js/issues/14487.)
  // TODO (gkalpak): Remove workaround when Chrome v52 is released
  return Function.prototype.toString.call(fn) + ' ';
}

function extractArgs(fn) {
  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
  return args;
}

function anonFn(fn) {
  // For anonymous functions, showing at the very least the function signature can help in
  // debugging.
  var args = extractArgs(fn);
  if (args) {
    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
  }
  return 'fn';
}

function annotate(fn, strictDi, name) {
  var $inject,
      argDecl,
      last;

  if (typeof fn === 'function') {
    if (!($inject = fn.$inject)) {
      $inject = [];
      if (fn.length) {
        if (strictDi) {
          if (!isString(name) || !name) {
            name = fn.name || anonFn(fn);
          }
          throw $injectorMinErr('strictdi',
            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
        }
        argDecl = extractArgs(fn);
        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
          arg.replace(FN_ARG, function(all, underscore, name) {
            $inject.push(name);
          });
        });
      }
      fn.$inject = $inject;
    }
  } else if (isArray(fn)) {
    last = fn.length - 1;
    assertArgFn(fn[last], 'fn');
    $inject = fn.slice(0, last);
  } else {
    assertArgFn(fn, 'fn', true);
  }
  return $inject;
}

///////////////////////////////////////

/**
 * @ngdoc service
 * @name $injector
 *
 * @description
 *
 * `$injector` is used to retrieve object instances as defined by
 * {@link auto.$provide provider}, instantiate types, invoke methods,
 * and load modules.
 *
 * The following always holds true:
 *
 * ```js
 *   var $injector = angular.injector();
 *   expect($injector.get('$injector')).toBe($injector);
 *   expect($injector.invoke(function($injector) {
 *     return $injector;
 *   })).toBe($injector);
 * ```
 *
 * # Injection Function Annotation
 *
 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
 * following are all valid ways of annotating function with injection arguments and are equivalent.
 *
 * ```js
 *   // inferred (only works if code not minified/obfuscated)
 *   $injector.invoke(function(serviceA){});
 *
 *   // annotated
 *   function explicit(serviceA) {};
 *   explicit.$inject = ['serviceA'];
 *   $injector.invoke(explicit);
 *
 *   // inline
 *   $injector.invoke(['serviceA', function(serviceA){}]);
 * ```
 *
 * ## Inference
 *
 * In JavaScript calling `toString()` on a function returns the function definition. The definition
 * can then be parsed and the function arguments can be extracted. This method of discovering
 * annotations is disallowed when the injector is in strict mode.
 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
 * argument names.
 *
 * ## `$inject` Annotation
 * By adding an `$inject` property onto a function the injection parameters can be specified.
 *
 * ## Inline
 * As an array of injection names, where the last item in the array is the function to call.
 */

/**
 * @ngdoc method
 * @name $injector#get
 *
 * @description
 * Return an instance of the service.
 *
 * @param {string} name The name of the instance to retrieve.
 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
 * @return {*} The instance.
 */

/**
 * @ngdoc method
 * @name $injector#invoke
 *
 * @description
 * Invoke the method and supply the method arguments from the `$injector`.
 *
 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
 *   injected according to the {@link guide/di $inject Annotation} rules.
 * @param {Object=} self The `this` for the invoked method.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 *                         object first, before the `$injector` is consulted.
 * @returns {*} the value returned by the invoked `fn` function.
 */

/**
 * @ngdoc method
 * @name $injector#has
 *
 * @description
 * Allows the user to query if the particular service exists.
 *
 * @param {string} name Name of the service to query.
 * @returns {boolean} `true` if injector has given service.
 */

/**
 * @ngdoc method
 * @name $injector#instantiate
 * @description
 * Create a new instance of JS type. The method takes a constructor function, invokes the new
 * operator, and supplies all of the arguments to the constructor function as specified by the
 * constructor annotation.
 *
 * @param {Function} Type Annotated constructor function.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 * object first, before the `$injector` is consulted.
 * @returns {Object} new instance of `Type`.
 */

/**
 * @ngdoc method
 * @name $injector#annotate
 *
 * @description
 * Returns an array of service names which the function is requesting for injection. This API is
 * used by the injector to determine which services need to be injected into the function when the
 * function is invoked. There are three ways in which the function can be annotated with the needed
 * dependencies.
 *
 * # Argument names
 *
 * The simplest form is to extract the dependencies from the arguments of the function. This is done
 * by converting the function into a string using `toString()` method and extracting the argument
 * names.
 * ```js
 *   // Given
 *   function MyController($scope, $route) {
 *     // ...
 *   }
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * You can disallow this method by using strict injection mode.
 *
 * This method does not work with code minification / obfuscation. For this reason the following
 * annotation strategies are supported.
 *
 * # The `$inject` property
 *
 * If a function has an `$inject` property and its value is an array of strings, then the strings
 * represent names of services to be injected into the function.
 * ```js
 *   // Given
 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
 *     // ...
 *   }
 *   // Define function dependencies
 *   MyController['$inject'] = ['$scope', '$route'];
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * # The array notation
 *
 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
 * is very inconvenient. In these situations using the array notation to specify the dependencies in
 * a way that survives minification is a better choice:
 *
 * ```js
 *   // We wish to write this (not minification / obfuscation safe)
 *   injector.invoke(function($compile, $rootScope) {
 *     // ...
 *   });
 *
 *   // We are forced to write break inlining
 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
 *     // ...
 *   };
 *   tmpFn.$inject = ['$compile', '$rootScope'];
 *   injector.invoke(tmpFn);
 *
 *   // To better support inline function the inline annotation is supported
 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
 *     // ...
 *   }]);
 *
 *   // Therefore
 *   expect(injector.annotate(
 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
 *    ).toEqual(['$compile', '$rootScope']);
 * ```
 *
 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
 * be retrieved as described above.
 *
 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
 *
 * @returns {Array.<string>} The names of the services which the function requires.
 */



/**
 * @ngdoc service
 * @name $provide
 *
 * @description
 *
 * The {@link auto.$provide $provide} service has a number of methods for registering components
 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
 * {@link angular.Module}.
 *
 * An Angular **service** is a singleton object created by a **service factory**.  These **service
 * factories** are functions which, in turn, are created by a **service provider**.
 * The **service providers** are constructor functions. When instantiated they must contain a
 * property called `$get`, which holds the **service factory** function.
 *
 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
 * function to get the instance of the **service**.
 *
 * Often services have no configuration options and there is no need to add methods to the service
 * provider.  The provider will be no more than a constructor function with a `$get` property. For
 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
 * services without specifying a provider.
 *
 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
 *     {@link auto.$injector $injector}
 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
 *     providers and services.
 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
 *     services, not providers.
 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
 *     given factory function.
 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
 *      a new object using the given constructor function.
 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
 *      will be able to modify or replace the implementation of another service.
 *
 * See the individual methods for more information and examples.
 */

/**
 * @ngdoc method
 * @name $provide#provider
 * @description
 *
 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
 * are constructor functions, whose instances are responsible for "providing" a factory for a
 * service.
 *
 * Service provider names start with the name of the service they provide followed by `Provider`.
 * For example, the {@link ng.$log $log} service has a provider called
 * {@link ng.$logProvider $logProvider}.
 *
 * Service provider objects can have additional methods which allow configuration of the provider
 * and its service. Importantly, you can configure what kind of service is created by the `$get`
 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
 * method {@link ng.$logProvider#debugEnabled debugEnabled}
 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
 * console or not.
 *
 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
                        'Provider'` key.
 * @param {(Object|function())} provider If the provider is:
 *
 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
 *   - `Constructor`: a new instance of the provider will be created using
 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
 *
 * @returns {Object} registered provider instance

 * @example
 *
 * The following example shows how to create a simple event tracking service and register it using
 * {@link auto.$provide#provider $provide.provider()}.
 *
 * ```js
 *  // Define the eventTracker provider
 *  function EventTrackerProvider() {
 *    var trackingUrl = '/track';
 *
 *    // A provider method for configuring where the tracked events should been saved
 *    this.setTrackingUrl = function(url) {
 *      trackingUrl = url;
 *    };
 *
 *    // The service factory function
 *    this.$get = ['$http', function($http) {
 *      var trackedEvents = {};
 *      return {
 *        // Call this to track an event
 *        event: function(event) {
 *          var count = trackedEvents[event] || 0;
 *          count += 1;
 *          trackedEvents[event] = count;
 *          return count;
 *        },
 *        // Call this to save the tracked events to the trackingUrl
 *        save: function() {
 *          $http.post(trackingUrl, trackedEvents);
 *        }
 *      };
 *    }];
 *  }
 *
 *  describe('eventTracker', function() {
 *    var postSpy;
 *
 *    beforeEach(module(function($provide) {
 *      // Register the eventTracker provider
 *      $provide.provider('eventTracker', EventTrackerProvider);
 *    }));
 *
 *    beforeEach(module(function(eventTrackerProvider) {
 *      // Configure eventTracker provider
 *      eventTrackerProvider.setTrackingUrl('/custom-track');
 *    }));
 *
 *    it('tracks events', inject(function(eventTracker) {
 *      expect(eventTracker.event('login')).toEqual(1);
 *      expect(eventTracker.event('login')).toEqual(2);
 *    }));
 *
 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
 *      postSpy = spyOn($http, 'post');
 *      eventTracker.event('login');
 *      eventTracker.save();
 *      expect(postSpy).toHaveBeenCalled();
 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
 *    }));
 *  });
 * ```
 */

/**
 * @ngdoc method
 * @name $provide#factory
 * @description
 *
 * Register a **service factory**, which will be called to return the service instance.
 * This is short for registering a service where its provider consists of only a `$get` property,
 * which is the given service factory function.
 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
 * configure your service in a provider.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service
 * ```js
 *   $provide.factory('ping', ['$http', function($http) {
 *     return function ping() {
 *       return $http.send('/ping');
 *     };
 *   }]);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#service
 * @description
 *
 * Register a **service constructor**, which will be invoked with `new` to create the service
 * instance.
 * This is short for registering a service where its provider's `$get` property is a factory
 * function that returns an instance instantiated by the injector from the service constructor
 * function.
 *
 * Internally it looks a bit like this:
 *
 * ```
 * {
 *   $get: function() {
 *     return $injector.instantiate(constructor);
 *   }
 * }
 * ```
 *
 *
 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
 * as a type/class.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
 *     that will be instantiated.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service using
 * {@link auto.$provide#service $provide.service(class)}.
 * ```js
 *   var Ping = function($http) {
 *     this.$http = $http;
 *   };
 *
 *   Ping.$inject = ['$http'];
 *
 *   Ping.prototype.send = function() {
 *     return this.$http.get('/ping');
 *   };
 *   $provide.service('ping', Ping);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping.send();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#value
 * @description
 *
 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
 * number, an array, an object or a function. This is short for registering a service where its
 * provider's `$get` property is a factory function that takes no arguments and returns the **value
 * service**. That also means it is not possible to inject other services into a value service.
 *
 * Value services are similar to constant services, except that they cannot be injected into a
 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
 * an Angular {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the instance.
 * @param {*} value The value.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here are some examples of creating value services.
 * ```js
 *   $provide.value('ADMIN_USER', 'admin');
 *
 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
 *
 *   $provide.value('halfOf', function(value) {
 *     return value / 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#constant
 * @description
 *
 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
 * possible to inject other services into a constant.
 *
 * But unlike {@link auto.$provide#value value}, a constant can be
 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the constant.
 * @param {*} value The constant value.
 * @returns {Object} registered instance
 *
 * @example
 * Here a some examples of creating constants:
 * ```js
 *   $provide.constant('SHARD_HEIGHT', 306);
 *
 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
 *
 *   $provide.constant('double', function(value) {
 *     return value * 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#decorator
 * @description
 *
 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
 * intercepts the creation of a service, allowing it to override or modify the behavior of the
 * service. The return value of the decorator function may be the original service, or a new service
 * that replaces (or wraps and delegates to) the original service.
 *
 * You can find out more about using decorators in the {@link guide/decorators} guide.
 *
 * @param {string} name The name of the service to decorate.
 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
 *    provided and should return the decorated service instance. The function is called using
 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
 *    Local injection arguments:
 *
 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
 *      decorated or delegated to.
 *
 * @example
 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
 * calls to {@link ng.$log#error $log.warn()}.
 * ```js
 *   $provide.decorator('$log', ['$delegate', function($delegate) {
 *     $delegate.warn = $delegate.error;
 *     return $delegate;
 *   }]);
 * ```
 */


function createInjector(modulesToLoad, strictDi) {
  strictDi = (strictDi === true);
  var INSTANTIATING = {},
      providerSuffix = 'Provider',
      path = [],
      loadedModules = new HashMap([], true),
      providerCache = {
        $provide: {
            provider: supportObject(provider),
            factory: supportObject(factory),
            service: supportObject(service),
            value: supportObject(value),
            constant: supportObject(constant),
            decorator: decorator
          }
      },
      providerInjector = (providerCache.$injector =
          createInternalInjector(providerCache, function(serviceName, caller) {
            if (angular.isString(caller)) {
              path.push(caller);
            }
            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
          })),
      instanceCache = {},
      protoInstanceInjector =
          createInternalInjector(instanceCache, function(serviceName, caller) {
            var provider = providerInjector.get(serviceName + providerSuffix, caller);
            return instanceInjector.invoke(
                provider.$get, provider, undefined, serviceName);
          }),
      instanceInjector = protoInstanceInjector;

  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
  var runBlocks = loadModules(modulesToLoad);
  instanceInjector = protoInstanceInjector.get('$injector');
  instanceInjector.strictDi = strictDi;
  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });

  return instanceInjector;

  ////////////////////////////////////
  // $provider
  ////////////////////////////////////

  function supportObject(delegate) {
    return function(key, value) {
      if (isObject(key)) {
        forEach(key, reverseParams(delegate));
      } else {
        return delegate(key, value);
      }
    };
  }

  function provider(name, provider_) {
    assertNotHasOwnProperty(name, 'service');
    if (isFunction(provider_) || isArray(provider_)) {
      provider_ = providerInjector.instantiate(provider_);
    }
    if (!provider_.$get) {
      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
    }
    return (providerCache[name + providerSuffix] = provider_);
  }

  function enforceReturnValue(name, factory) {
    return /** @this */ function enforcedReturnValue() {
      var result = instanceInjector.invoke(factory, this);
      if (isUndefined(result)) {
        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
      }
      return result;
    };
  }

  function factory(name, factoryFn, enforce) {
    return provider(name, {
      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
    });
  }

  function service(name, constructor) {
    return factory(name, ['$injector', function($injector) {
      return $injector.instantiate(constructor);
    }]);
  }

  function value(name, val) { return factory(name, valueFn(val), false); }

  function constant(name, value) {
    assertNotHasOwnProperty(name, 'constant');
    providerCache[name] = value;
    instanceCache[name] = value;
  }

  function decorator(serviceName, decorFn) {
    var origProvider = providerInjector.get(serviceName + providerSuffix),
        orig$get = origProvider.$get;

    origProvider.$get = function() {
      var origInstance = instanceInjector.invoke(orig$get, origProvider);
      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
    };
  }

  ////////////////////////////////////
  // Module Loading
  ////////////////////////////////////
  function loadModules(modulesToLoad) {
    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
    var runBlocks = [], moduleFn;
    forEach(modulesToLoad, function(module) {
      if (loadedModules.get(module)) return;
      loadedModules.put(module, true);

      function runInvokeQueue(queue) {
        var i, ii;
        for (i = 0, ii = queue.length; i < ii; i++) {
          var invokeArgs = queue[i],
              provider = providerInjector.get(invokeArgs[0]);

          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
        }
      }

      try {
        if (isString(module)) {
          moduleFn = angularModule(module);
          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
          runInvokeQueue(moduleFn._invokeQueue);
          runInvokeQueue(moduleFn._configBlocks);
        } else if (isFunction(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else if (isArray(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else {
          assertArgFn(module, 'module');
        }
      } catch (e) {
        if (isArray(module)) {
          module = module[module.length - 1];
        }
        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
          // Safari & FF's stack traces don't contain error.message content
          // unlike those of Chrome and IE
          // So if stack doesn't contain message, we create a new string that contains both.
          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
          // eslint-disable-next-line no-ex-assign
          e = e.message + '\n' + e.stack;
        }
        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
                  module, e.stack || e.message || e);
      }
    });
    return runBlocks;
  }

  ////////////////////////////////////
  // internal Injector
  ////////////////////////////////////

  function createInternalInjector(cache, factory) {

    function getService(serviceName, caller) {
      if (cache.hasOwnProperty(serviceName)) {
        if (cache[serviceName] === INSTANTIATING) {
          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
                    serviceName + ' <- ' + path.join(' <- '));
        }
        return cache[serviceName];
      } else {
        try {
          path.unshift(serviceName);
          cache[serviceName] = INSTANTIATING;
          cache[serviceName] = factory(serviceName, caller);
          return cache[serviceName];
        } catch (err) {
          if (cache[serviceName] === INSTANTIATING) {
            delete cache[serviceName];
          }
          throw err;
        } finally {
          path.shift();
        }
      }
    }


    function injectionArgs(fn, locals, serviceName) {
      var args = [],
          $inject = createInjector.$$annotate(fn, strictDi, serviceName);

      for (var i = 0, length = $inject.length; i < length; i++) {
        var key = $inject[i];
        if (typeof key !== 'string') {
          throw $injectorMinErr('itkn',
                  'Incorrect injection token! Expected service name as string, got {0}', key);
        }
        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
                                                         getService(key, serviceName));
      }
      return args;
    }

    function isClass(func) {
      // Support: IE 9-11 only
      // IE 9-11 do not support classes and IE9 leaks with the code below.
      if (msie || typeof func !== 'function') {
        return false;
      }
      var result = func.$$ngIsClass;
      if (!isBoolean(result)) {
        // Support: Edge 12-13 only
        // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
        result = func.$$ngIsClass = /^(?:class\b|constructor\()/.test(stringifyFn(func));
      }
      return result;
    }

    function invoke(fn, self, locals, serviceName) {
      if (typeof locals === 'string') {
        serviceName = locals;
        locals = null;
      }

      var args = injectionArgs(fn, locals, serviceName);
      if (isArray(fn)) {
        fn = fn[fn.length - 1];
      }

      if (!isClass(fn)) {
        // http://jsperf.com/angularjs-invoke-apply-vs-switch
        // #5388
        return fn.apply(self, args);
      } else {
        args.unshift(null);
        return new (Function.prototype.bind.apply(fn, args))();
      }
    }


    function instantiate(Type, locals, serviceName) {
      // Check if Type is annotated and use just the given function at n-1 as parameter
      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
      var args = injectionArgs(Type, locals, serviceName);
      // Empty object at position 0 is ignored for invocation with `new`, but required.
      args.unshift(null);
      return new (Function.prototype.bind.apply(ctor, args))();
    }


    return {
      invoke: invoke,
      instantiate: instantiate,
      get: getService,
      annotate: createInjector.$$annotate,
      has: function(name) {
        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
      }
    };
  }
}

createInjector.$$annotate = annotate;

/**
 * @ngdoc provider
 * @name $anchorScrollProvider
 * @this
 *
 * @description
 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
 * {@link ng.$location#hash $location.hash()} changes.
 */
function $AnchorScrollProvider() {

  var autoScrollingEnabled = true;

  /**
   * @ngdoc method
   * @name $anchorScrollProvider#disableAutoScrolling
   *
   * @description
   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
   * Use this method to disable automatic scrolling.
   *
   * If automatic scrolling is disabled, one must explicitly call
   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
   * current hash.
   */
  this.disableAutoScrolling = function() {
    autoScrollingEnabled = false;
  };

  /**
   * @ngdoc service
   * @name $anchorScroll
   * @kind function
   * @requires $window
   * @requires $location
   * @requires $rootScope
   *
   * @description
   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
   * in the
   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
   *
   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
   * match any anchor whenever it changes. This can be disabled by calling
   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
   *
   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
   * vertical scroll-offset (either fixed or dynamic).
   *
   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
   *                       {@link ng.$location#hash $location.hash()} will be used.
   *
   * @property {(number|function|jqLite)} yOffset
   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
   * positioned elements at the top of the page, such as navbars, headers etc.
   *
   * `yOffset` can be specified in various ways:
   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
   *   a number representing the offset (in pixels).<br /><br />
   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
   *   the top of the page to the element's bottom will be used as offset.<br />
   *   **Note**: The element will be taken into account only as long as its `position` is set to
   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
   *   their height and/or positioning according to the viewport's size.
   *
   * <br />
   * <div class="alert alert-warning">
   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
   * not some child element.
   * </div>
   *
   * @example
     <example module="anchorScrollExample" name="anchor-scroll">
       <file name="index.html">
         <div id="scrollArea" ng-controller="ScrollController">
           <a ng-click="gotoBottom()">Go to bottom</a>
           <a id="bottom"></a> You're at the bottom!
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollExample', [])
           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
             function($scope, $location, $anchorScroll) {
               $scope.gotoBottom = function() {
                 // set the location.hash to the id of
                 // the element you wish to scroll to.
                 $location.hash('bottom');

                 // call $anchorScroll()
                 $anchorScroll();
               };
             }]);
       </file>
       <file name="style.css">
         #scrollArea {
           height: 280px;
           overflow: auto;
         }

         #bottom {
           display: block;
           margin-top: 2000px;
         }
       </file>
     </example>
   *
   * <hr />
   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
   *
   * @example
     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
       <file name="index.html">
         <div class="fixed-header" ng-controller="headerCtrl">
           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
             Go to anchor {{x}}
           </a>
         </div>
         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
           Anchor {{x}} of 5
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollOffsetExample', [])
           .run(['$anchorScroll', function($anchorScroll) {
             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
           }])
           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
             function($anchorScroll, $location, $scope) {
               $scope.gotoAnchor = function(x) {
                 var newHash = 'anchor' + x;
                 if ($location.hash() !== newHash) {
                   // set the $location.hash to `newHash` and
                   // $anchorScroll will automatically scroll to it
                   $location.hash('anchor' + x);
                 } else {
                   // call $anchorScroll() explicitly,
                   // since $location.hash hasn't changed
                   $anchorScroll();
                 }
               };
             }
           ]);
       </file>
       <file name="style.css">
         body {
           padding-top: 50px;
         }

         .anchor {
           border: 2px dashed DarkOrchid;
           padding: 10px 10px 200px 10px;
         }

         .fixed-header {
           background-color: rgba(0, 0, 0, 0.2);
           height: 50px;
           position: fixed;
           top: 0; left: 0; right: 0;
         }

         .fixed-header > a {
           display: inline-block;
           margin: 5px 15px;
         }
       </file>
     </example>
   */
  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
    var document = $window.document;

    // Helper function to get first anchor from a NodeList
    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
    //  and working in all supported browsers.)
    function getFirstAnchor(list) {
      var result = null;
      Array.prototype.some.call(list, function(element) {
        if (nodeName_(element) === 'a') {
          result = element;
          return true;
        }
      });
      return result;
    }

    function getYOffset() {

      var offset = scroll.yOffset;

      if (isFunction(offset)) {
        offset = offset();
      } else if (isElement(offset)) {
        var elem = offset[0];
        var style = $window.getComputedStyle(elem);
        if (style.position !== 'fixed') {
          offset = 0;
        } else {
          offset = elem.getBoundingClientRect().bottom;
        }
      } else if (!isNumber(offset)) {
        offset = 0;
      }

      return offset;
    }

    function scrollTo(elem) {
      if (elem) {
        elem.scrollIntoView();

        var offset = getYOffset();

        if (offset) {
          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
          // top of the viewport.
          //
          // IF the number of pixels from the top of `elem` to the end of the page's content is less
          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
          // way down the page.
          //
          // This is often the case for elements near the bottom of the page.
          //
          // In such cases we do not need to scroll the whole `offset` up, just the difference between
          // the top of the element and the offset, which is enough to align the top of `elem` at the
          // desired position.
          var elemTop = elem.getBoundingClientRect().top;
          $window.scrollBy(0, elemTop - offset);
        }
      } else {
        $window.scrollTo(0, 0);
      }
    }

    function scroll(hash) {
      // Allow numeric hashes
      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
      var elm;

      // empty hash, scroll to the top of the page
      if (!hash) scrollTo(null);

      // element with given id
      else if ((elm = document.getElementById(hash))) scrollTo(elm);

      // first anchor with given name :-D
      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);

      // no element and hash === 'top', scroll to the top of the page
      else if (hash === 'top') scrollTo(null);
    }

    // does not scroll when user clicks on anchor link that is currently on
    // (no url change, no $location.hash() change), browser native does scroll
    if (autoScrollingEnabled) {
      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
        function autoScrollWatchAction(newVal, oldVal) {
          // skip the initial scroll if $location.hash is empty
          if (newVal === oldVal && newVal === '') return;

          jqLiteDocumentLoaded(function() {
            $rootScope.$evalAsync(scroll);
          });
        });
    }

    return scroll;
  }];
}

var $animateMinErr = minErr('$animate');
var ELEMENT_NODE = 1;
var NG_ANIMATE_CLASSNAME = 'ng-animate';

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function extractElementNode(element) {
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType === ELEMENT_NODE) {
      return elm;
    }
  }
}

function splitClasses(classes) {
  if (isString(classes)) {
    classes = classes.split(' ');
  }

  // Use createMap() to prevent class assumptions involving property names in
  // Object.prototype
  var obj = createMap();
  forEach(classes, function(klass) {
    // sometimes the split leaves empty string values
    // incase extra spaces were applied to the options
    if (klass.length) {
      obj[klass] = true;
    }
  });
  return obj;
}

// if any other type of options value besides an Object value is
// passed into the $animate.method() animation then this helper code
// will be run which will ignore it. While this patch is not the
// greatest solution to this, a lot of existing plugins depend on
// $animate to either call the callback (< 1.2) or return a promise
// that can be changed. This helper function ensures that the options
// are wiped clean incase a callback function is provided.
function prepareAnimateOptions(options) {
  return isObject(options)
      ? options
      : {};
}

var $$CoreAnimateJsProvider = /** @this */ function() {
  this.$get = noop;
};

// this is prefixed with Core since it conflicts with
// the animateQueueProvider defined in ngAnimate/animateQueue.js
var $$CoreAnimateQueueProvider = /** @this */ function() {
  var postDigestQueue = new HashMap();
  var postDigestElements = [];

  this.$get = ['$$AnimateRunner', '$rootScope',
       function($$AnimateRunner,   $rootScope) {
    return {
      enabled: noop,
      on: noop,
      off: noop,
      pin: noop,

      push: function(element, event, options, domOperation) {
        if (domOperation) {
          domOperation();
        }

        options = options || {};
        if (options.from) {
          element.css(options.from);
        }
        if (options.to) {
          element.css(options.to);
        }

        if (options.addClass || options.removeClass) {
          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
        }

        var runner = new $$AnimateRunner();

        // since there are no animations to run the runner needs to be
        // notified that the animation call is complete.
        runner.complete();
        return runner;
      }
    };


    function updateData(data, classes, value) {
      var changed = false;
      if (classes) {
        classes = isString(classes) ? classes.split(' ') :
                  isArray(classes) ? classes : [];
        forEach(classes, function(className) {
          if (className) {
            changed = true;
            data[className] = value;
          }
        });
      }
      return changed;
    }

    function handleCSSClassChanges() {
      forEach(postDigestElements, function(element) {
        var data = postDigestQueue.get(element);
        if (data) {
          var existing = splitClasses(element.attr('class'));
          var toAdd = '';
          var toRemove = '';
          forEach(data, function(status, className) {
            var hasClass = !!existing[className];
            if (status !== hasClass) {
              if (status) {
                toAdd += (toAdd.length ? ' ' : '') + className;
              } else {
                toRemove += (toRemove.length ? ' ' : '') + className;
              }
            }
          });

          forEach(element, function(elm) {
            if (toAdd) {
              jqLiteAddClass(elm, toAdd);
            }
            if (toRemove) {
              jqLiteRemoveClass(elm, toRemove);
            }
          });
          postDigestQueue.remove(element);
        }
      });
      postDigestElements.length = 0;
    }


    function addRemoveClassesPostDigest(element, add, remove) {
      var data = postDigestQueue.get(element) || {};

      var classesAdded = updateData(data, add, true);
      var classesRemoved = updateData(data, remove, false);

      if (classesAdded || classesRemoved) {

        postDigestQueue.put(element, data);
        postDigestElements.push(element);

        if (postDigestElements.length === 1) {
          $rootScope.$$postDigest(handleCSSClassChanges);
        }
      }
    }
  }];
};

/**
 * @ngdoc provider
 * @name $animateProvider
 *
 * @description
 * Default implementation of $animate that doesn't perform any animations, instead just
 * synchronously performs DOM updates and resolves the returned runner promise.
 *
 * In order to enable animations the `ngAnimate` module has to be loaded.
 *
 * To see the functional implementation check out `src/ngAnimate/animate.js`.
 */
var $AnimateProvider = ['$provide', /** @this */ function($provide) {
  var provider = this;

  this.$$registeredAnimations = Object.create(null);

   /**
   * @ngdoc method
   * @name $animateProvider#register
   *
   * @description
   * Registers a new injectable animation factory function. The factory function produces the
   * animation object which contains callback functions for each event that is expected to be
   * animated.
   *
   *   * `eventFn`: `function(element, ... , doneFunction, options)`
   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
   *   on the type of animation additional arguments will be injected into the animation function. The
   *   list below explains the function signatures for the different animation methods:
   *
   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
   *   - addClass: function(element, addedClasses, doneFunction, options)
   *   - removeClass: function(element, removedClasses, doneFunction, options)
   *   - enter, leave, move: function(element, doneFunction, options)
   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
   *
   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
   *
   * ```js
   *   return {
   *     //enter, leave, move signature
   *     eventFn : function(element, done, options) {
   *       //code to run the animation
   *       //once complete, then run done()
   *       return function endFunction(wasCancelled) {
   *         //code to cancel the animation
   *       }
   *     }
   *   }
   * ```
   *
   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
   * @param {Function} factory The factory function that will be executed to return the animation
   *                           object.
   */
  this.register = function(name, factory) {
    if (name && name.charAt(0) !== '.') {
      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
    }

    var key = name + '-animation';
    provider.$$registeredAnimations[name.substr(1)] = key;
    $provide.factory(key, factory);
  };

  /**
   * @ngdoc method
   * @name $animateProvider#classNameFilter
   *
   * @description
   * Sets and/or returns the CSS class regular expression that is checked when performing
   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
   * When setting the `classNameFilter` value, animations will only be performed on elements
   * that successfully match the filter expression. This in turn can boost performance
   * for low-powered devices as well as applications containing a lot of structural operations.
   * @param {RegExp=} expression The className expression which will be checked against all animations
   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
   */
  this.classNameFilter = function(expression) {
    if (arguments.length === 1) {
      this.$$classNameFilter = (expression instanceof RegExp) ? expression : null;
      if (this.$$classNameFilter) {
        var reservedRegex = new RegExp('(\\s+|\\/)' + NG_ANIMATE_CLASSNAME + '(\\s+|\\/)');
        if (reservedRegex.test(this.$$classNameFilter.toString())) {
          throw $animateMinErr('nongcls','$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
        }
      }
    }
    return this.$$classNameFilter;
  };

  this.$get = ['$$animateQueue', function($$animateQueue) {
    function domInsert(element, parentElement, afterElement) {
      // if for some reason the previous element was removed
      // from the dom sometime before this code runs then let's
      // just stick to using the parent element as the anchor
      if (afterElement) {
        var afterNode = extractElementNode(afterElement);
        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
          afterElement = null;
        }
      }
      if (afterElement) {
        afterElement.after(element);
      } else {
        parentElement.prepend(element);
      }
    }

    /**
     * @ngdoc service
     * @name $animate
     * @description The $animate service exposes a series of DOM utility methods that provide support
     * for animation hooks. The default behavior is the application of DOM operations, however,
     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
     * to ensure that animation runs with the triggered DOM operation.
     *
     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
     * included and only when it is active then the animation hooks that `$animate` triggers will be
     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
     *
     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
     *
     * To learn more about enabling animation support, click here to visit the
     * {@link ngAnimate ngAnimate module page}.
     */
    return {
      // we don't call it directly since non-existant arguments may
      // be interpreted as null within the sub enabled function

      /**
       *
       * @ngdoc method
       * @name $animate#on
       * @kind function
       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
       *    is fired with the following params:
       *
       * ```js
       * $animate.on('enter', container,
       *    function callback(element, phase) {
       *      // cool we detected an enter animation within the container
       *    }
       * );
       * ```
       *
       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
       *     as well as among its children
       * @param {Function} callback the callback function that will be fired when the listener is triggered
       *
       * The arguments present in the callback function are:
       * * `element` - The captured DOM element that the animation was fired on.
       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
       */
      on: $$animateQueue.on,

      /**
       *
       * @ngdoc method
       * @name $animate#off
       * @kind function
       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
       * can be used in three different ways depending on the arguments:
       *
       * ```js
       * // remove all the animation event listeners listening for `enter`
       * $animate.off('enter');
       *
       * // remove listeners for all animation events from the container element
       * $animate.off(container);
       *
       * // remove all the animation event listeners listening for `enter` on the given element and its children
       * $animate.off('enter', container);
       *
       * // remove the event listener function provided by `callback` that is set
       * // to listen for `enter` on the given `container` as well as its children
       * $animate.off('enter', container, callback);
       * ```
       *
       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
       * addClass, removeClass, etc...), or the container element. If it is the element, all other
       * arguments are ignored.
       * @param {DOMElement=} container the container element the event listener was placed on
       * @param {Function=} callback the callback function that was registered as the listener
       */
      off: $$animateQueue.off,

      /**
       * @ngdoc method
       * @name $animate#pin
       * @kind function
       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
       *    element despite being outside the realm of the application or within another application. Say for example if the application
       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
       *
       *    Note that this feature is only active when the `ngAnimate` module is used.
       *
       * @param {DOMElement} element the external element that will be pinned
       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
       */
      pin: $$animateQueue.pin,

      /**
       *
       * @ngdoc method
       * @name $animate#enabled
       * @kind function
       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
       * function can be called in four ways:
       *
       * ```js
       * // returns true or false
       * $animate.enabled();
       *
       * // changes the enabled state for all animations
       * $animate.enabled(false);
       * $animate.enabled(true);
       *
       * // returns true or false if animations are enabled for an element
       * $animate.enabled(element);
       *
       * // changes the enabled state for an element and its children
       * $animate.enabled(element, true);
       * $animate.enabled(element, false);
       * ```
       *
       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
       * @param {boolean=} enabled whether or not the animations will be enabled for the element
       *
       * @return {boolean} whether or not animations are enabled
       */
      enabled: $$animateQueue.enabled,

      /**
       * @ngdoc method
       * @name $animate#cancel
       * @kind function
       * @description Cancels the provided animation.
       *
       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
       */
      cancel: function(runner) {
        if (runner.end) {
          runner.end();
        }
      },

      /**
       *
       * @ngdoc method
       * @name $animate#enter
       * @kind function
       * @description Inserts the element into the DOM either after the `after` element (if provided) or
       *   as the first child within the `parent` element and then triggers an animation.
       *   A promise is returned that will be resolved during the next digest once the animation
       *   has completed.
       *
       * @param {DOMElement} element the element which will be inserted into the DOM
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      enter: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
      },

      /**
       *
       * @ngdoc method
       * @name $animate#move
       * @kind function
       * @description Inserts (moves) the element into its new position in the DOM either after
       *   the `after` element (if provided) or as the first child within the `parent` element
       *   and then triggers an animation. A promise is returned that will be resolved
       *   during the next digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be moved into the new DOM position
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      move: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
      },

      /**
       * @ngdoc method
       * @name $animate#leave
       * @kind function
       * @description Triggers an animation and then removes the element from the DOM.
       * When the function is called a promise is returned that will be resolved during the next
       * digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be removed from the DOM
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      leave: function(element, options) {
        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
          element.remove();
        });
      },

      /**
       * @ngdoc method
       * @name $animate#addClass
       * @kind function
       *
       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element already contains the CSS class or if the class is removed at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      addClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addclass, className);
        return $$animateQueue.push(element, 'addClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#removeClass
       * @kind function
       *
       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element does not contain the CSS class or if the class is added at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      removeClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.removeClass = mergeClasses(options.removeClass, className);
        return $$animateQueue.push(element, 'removeClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#setClass
       * @kind function
       *
       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
       *    passed. Note that class-based animations are treated differently compared to structural animations
       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
       *    depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      setClass: function(element, add, remove, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addClass, add);
        options.removeClass = mergeClasses(options.removeClass, remove);
        return $$animateQueue.push(element, 'setClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#animate
       * @kind function
       *
       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
       * style in `to`, the style in `from` is applied immediately, and no animation is run.
       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
       * method (or as part of the `options` parameter):
       *
       * ```js
       * ngModule.animation('.my-inline-animation', function() {
       *   return {
       *     animate : function(element, from, to, done, options) {
       *       //animation
       *       done();
       *     }
       *   }
       * });
       * ```
       *
       * @param {DOMElement} element the element which the CSS styles will be applied to
       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
       *    (Note that if no animation is detected then this value will not be applied to the element.)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      animate: function(element, from, to, className, options) {
        options = prepareAnimateOptions(options);
        options.from = options.from ? extend(options.from, from) : from;
        options.to   = options.to   ? extend(options.to, to)     : to;

        className = className || 'ng-inline-animate';
        options.tempClasses = mergeClasses(options.tempClasses, className);
        return $$animateQueue.push(element, 'animate', options);
      }
    };
  }];
}];

var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
  this.$get = ['$$rAF', function($$rAF) {
    var waitQueue = [];

    function waitForTick(fn) {
      waitQueue.push(fn);
      if (waitQueue.length > 1) return;
      $$rAF(function() {
        for (var i = 0; i < waitQueue.length; i++) {
          waitQueue[i]();
        }
        waitQueue = [];
      });
    }

    return function() {
      var passed = false;
      waitForTick(function() {
        passed = true;
      });
      return function(callback) {
        if (passed) {
          callback();
        } else {
          waitForTick(callback);
        }
      };
    };
  }];
};

var $$AnimateRunnerFactoryProvider = /** @this */ function() {
  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {

    var INITIAL_STATE = 0;
    var DONE_PENDING_STATE = 1;
    var DONE_COMPLETE_STATE = 2;

    AnimateRunner.chain = function(chain, callback) {
      var index = 0;

      next();
      function next() {
        if (index === chain.length) {
          callback(true);
          return;
        }

        chain[index](function(response) {
          if (response === false) {
            callback(false);
            return;
          }
          index++;
          next();
        });
      }
    };

    AnimateRunner.all = function(runners, callback) {
      var count = 0;
      var status = true;
      forEach(runners, function(runner) {
        runner.done(onProgress);
      });

      function onProgress(response) {
        status = status && response;
        if (++count === runners.length) {
          callback(status);
        }
      }
    };

    function AnimateRunner(host) {
      this.setHost(host);

      var rafTick = $$animateAsyncRun();
      var timeoutTick = function(fn) {
        $timeout(fn, 0, false);
      };

      this._doneCallbacks = [];
      this._tick = function(fn) {
        if ($$isDocumentHidden()) {
          timeoutTick(fn);
        } else {
          rafTick(fn);
        }
      };
      this._state = 0;
    }

    AnimateRunner.prototype = {
      setHost: function(host) {
        this.host = host || {};
      },

      done: function(fn) {
        if (this._state === DONE_COMPLETE_STATE) {
          fn();
        } else {
          this._doneCallbacks.push(fn);
        }
      },

      progress: noop,

      getPromise: function() {
        if (!this.promise) {
          var self = this;
          this.promise = $q(function(resolve, reject) {
            self.done(function(status) {
              if (status === false) {
                reject();
              } else {
                resolve();
              }
            });
          });
        }
        return this.promise;
      },

      then: function(resolveHandler, rejectHandler) {
        return this.getPromise().then(resolveHandler, rejectHandler);
      },

      'catch': function(handler) {
        return this.getPromise()['catch'](handler);
      },

      'finally': function(handler) {
        return this.getPromise()['finally'](handler);
      },

      pause: function() {
        if (this.host.pause) {
          this.host.pause();
        }
      },

      resume: function() {
        if (this.host.resume) {
          this.host.resume();
        }
      },

      end: function() {
        if (this.host.end) {
          this.host.end();
        }
        this._resolve(true);
      },

      cancel: function() {
        if (this.host.cancel) {
          this.host.cancel();
        }
        this._resolve(false);
      },

      complete: function(response) {
        var self = this;
        if (self._state === INITIAL_STATE) {
          self._state = DONE_PENDING_STATE;
          self._tick(function() {
            self._resolve(response);
          });
        }
      },

      _resolve: function(response) {
        if (this._state !== DONE_COMPLETE_STATE) {
          forEach(this._doneCallbacks, function(fn) {
            fn(response);
          });
          this._doneCallbacks.length = 0;
          this._state = DONE_COMPLETE_STATE;
        }
      }
    };

    return AnimateRunner;
  }];
};

/* exported $CoreAnimateCssProvider */

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 * @this
 *
 * @description
 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
 * then the `$animateCss` service will actually perform animations.
 *
 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
 */
var $CoreAnimateCssProvider = function() {
  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {

    return function(element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
      var options = initialOptions || {};
      if (!options.$$prepared) {
        options = copy(options);
      }

      // there is no point in applying the styles since
      // there is no animation that goes on at all in
      // this version of $animateCss.
      if (options.cleanupStyles) {
        options.from = options.to = null;
      }

      if (options.from) {
        element.css(options.from);
        options.from = null;
      }

      var closed, runner = new $$AnimateRunner();
      return {
        start: run,
        end: run
      };

      function run() {
        $$rAF(function() {
          applyAnimationContents();
          if (!closed) {
            runner.complete();
          }
          closed = true;
        });
        return runner;
      }

      function applyAnimationContents() {
        if (options.addClass) {
          element.addClass(options.addClass);
          options.addClass = null;
        }
        if (options.removeClass) {
          element.removeClass(options.removeClass);
          options.removeClass = null;
        }
        if (options.to) {
          element.css(options.to);
          options.to = null;
        }
      }
    };
  }];
};

/* global stripHash: true */

/**
 * ! This is a private undocumented service !
 *
 * @name $browser
 * @requires $log
 * @description
 * This object has two goals:
 *
 * - hide all the global state in the browser caused by the window object
 * - abstract away all the browser specific features and inconsistencies
 *
 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
 * service, which can be used for convenient testing of the application without the interaction with
 * the real browser apis.
 */
/**
 * @param {object} window The global window object.
 * @param {object} document jQuery wrapped document.
 * @param {object} $log window.console or an object with the same interface.
 * @param {object} $sniffer $sniffer service
 */
function Browser(window, document, $log, $sniffer) {
  var self = this,
      location = window.location,
      history = window.history,
      setTimeout = window.setTimeout,
      clearTimeout = window.clearTimeout,
      pendingDeferIds = {};

  self.isMock = false;

  var outstandingRequestCount = 0;
  var outstandingRequestCallbacks = [];

  // TODO(vojta): remove this temporary api
  self.$$completeOutstandingRequest = completeOutstandingRequest;
  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };

  /**
   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
   */
  function completeOutstandingRequest(fn) {
    try {
      fn.apply(null, sliceArgs(arguments, 1));
    } finally {
      outstandingRequestCount--;
      if (outstandingRequestCount === 0) {
        while (outstandingRequestCallbacks.length) {
          try {
            outstandingRequestCallbacks.pop()();
          } catch (e) {
            $log.error(e);
          }
        }
      }
    }
  }

  function getHash(url) {
    var index = url.indexOf('#');
    return index === -1 ? '' : url.substr(index);
  }

  /**
   * @private
   * Note: this method is used only by scenario runner
   * TODO(vojta): prefix this method with $$ ?
   * @param {function()} callback Function that will be called when no outstanding request
   */
  self.notifyWhenNoOutstandingRequests = function(callback) {
    if (outstandingRequestCount === 0) {
      callback();
    } else {
      outstandingRequestCallbacks.push(callback);
    }
  };

  //////////////////////////////////////////////////////////////
  // URL API
  //////////////////////////////////////////////////////////////

  var cachedState, lastHistoryState,
      lastBrowserUrl = location.href,
      baseElement = document.find('base'),
      pendingLocation = null,
      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
        try {
          return history.state;
        } catch (e) {
          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
        }
      };

  cacheState();
  lastHistoryState = cachedState;

  /**
   * @name $browser#url
   *
   * @description
   * GETTER:
   * Without any argument, this method just returns current value of location.href.
   *
   * SETTER:
   * With at least one argument, this method sets url to new value.
   * If html5 history api supported, pushState/replaceState is used, otherwise
   * location.href/location.replace is used.
   * Returns its own instance to allow chaining
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to change url.
   *
   * @param {string} url New url (when used as setter)
   * @param {boolean=} replace Should new url replace current history record?
   * @param {object=} state object to use with pushState/replaceState
   */
  self.url = function(url, replace, state) {
    // In modern browsers `history.state` is `null` by default; treating it separately
    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
    if (isUndefined(state)) {
      state = null;
    }

    // Android Browser BFCache causes location, history reference to become stale.
    if (location !== window.location) location = window.location;
    if (history !== window.history) history = window.history;

    // setter
    if (url) {
      var sameState = lastHistoryState === state;

      // Don't change anything if previous and current URLs and states match. This also prevents
      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
      // See https://github.com/angular/angular.js/commit/ffb2701
      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
        return self;
      }
      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
      lastBrowserUrl = url;
      lastHistoryState = state;
      // Don't use history API if only the hash changed
      // due to a bug in IE10/IE11 which leads
      // to not firing a `hashchange` nor `popstate` event
      // in some cases (see #9143).
      if ($sniffer.history && (!sameBase || !sameState)) {
        history[replace ? 'replaceState' : 'pushState'](state, '', url);
        cacheState();
        // Do the assignment again so that those two variables are referentially identical.
        lastHistoryState = cachedState;
      } else {
        if (!sameBase) {
          pendingLocation = url;
        }
        if (replace) {
          location.replace(url);
        } else if (!sameBase) {
          location.href = url;
        } else {
          location.hash = getHash(url);
        }
        if (location.href !== url) {
          pendingLocation = url;
        }
      }
      if (pendingLocation) {
        pendingLocation = url;
      }
      return self;
    // getter
    } else {
      // - pendingLocation is needed as browsers don't allow to read out
      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
      //   https://openradar.appspot.com/22186109).
      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
      return pendingLocation || location.href.replace(/%27/g,'\'');
    }
  };

  /**
   * @name $browser#state
   *
   * @description
   * This method is a getter.
   *
   * Return history.state or null if history.state is undefined.
   *
   * @returns {object} state
   */
  self.state = function() {
    return cachedState;
  };

  var urlChangeListeners = [],
      urlChangeInit = false;

  function cacheStateAndFireUrlChange() {
    pendingLocation = null;
    cacheState();
    fireUrlChange();
  }

  // This variable should be used *only* inside the cacheState function.
  var lastCachedState = null;
  function cacheState() {
    // This should be the only place in $browser where `history.state` is read.
    cachedState = getCurrentState();
    cachedState = isUndefined(cachedState) ? null : cachedState;

    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
    if (equals(cachedState, lastCachedState)) {
      cachedState = lastCachedState;
    }
    lastCachedState = cachedState;
  }

  function fireUrlChange() {
    if (lastBrowserUrl === self.url() && lastHistoryState === cachedState) {
      return;
    }

    lastBrowserUrl = self.url();
    lastHistoryState = cachedState;
    forEach(urlChangeListeners, function(listener) {
      listener(self.url(), cachedState);
    });
  }

  /**
   * @name $browser#onUrlChange
   *
   * @description
   * Register callback function that will be called, when url changes.
   *
   * It's only called when the url is changed from outside of angular:
   * - user types different url into address bar
   * - user clicks on history (forward/back) button
   * - user clicks on a link
   *
   * It's not called when url is changed by $browser.url() method
   *
   * The listener gets called with new url as parameter.
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to monitor url changes in angular apps.
   *
   * @param {function(string)} listener Listener function to be called when url changes.
   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
   */
  self.onUrlChange = function(callback) {
    // TODO(vojta): refactor to use node's syntax for events
    if (!urlChangeInit) {
      // We listen on both (hashchange/popstate) when available, as some browsers (e.g. Opera)
      // don't fire popstate when user change the address bar and don't fire hashchange when url
      // changed by push/replaceState

      // html5 history api - popstate event
      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
      // hashchange event
      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);

      urlChangeInit = true;
    }

    urlChangeListeners.push(callback);
    return callback;
  };

  /**
   * @private
   * Remove popstate and hashchange handler from window.
   *
   * NOTE: this api is intended for use only by $rootScope.
   */
  self.$$applicationDestroyed = function() {
    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
  };

  /**
   * Checks whether the url has changed outside of Angular.
   * Needs to be exported to be able to check for changes that have been done in sync,
   * as hashchange/popstate events fire in async.
   */
  self.$$checkUrlChange = fireUrlChange;

  //////////////////////////////////////////////////////////////
  // Misc API
  //////////////////////////////////////////////////////////////

  /**
   * @name $browser#baseHref
   *
   * @description
   * Returns current <base href>
   * (always relative - without domain)
   *
   * @returns {string} The current base href
   */
  self.baseHref = function() {
    var href = baseElement.attr('href');
    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
  };

  /**
   * @name $browser#defer
   * @param {function()} fn A function, who's execution should be deferred.
   * @param {number=} [delay=0] of milliseconds to defer the function execution.
   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
   *
   * @description
   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
   *
   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
   * via `$browser.defer.flush()`.
   *
   */
  self.defer = function(fn, delay) {
    var timeoutId;
    outstandingRequestCount++;
    timeoutId = setTimeout(function() {
      delete pendingDeferIds[timeoutId];
      completeOutstandingRequest(fn);
    }, delay || 0);
    pendingDeferIds[timeoutId] = true;
    return timeoutId;
  };


  /**
   * @name $browser#defer.cancel
   *
   * @description
   * Cancels a deferred task identified with `deferId`.
   *
   * @param {*} deferId Token returned by the `$browser.defer` function.
   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
   *                    canceled.
   */
  self.defer.cancel = function(deferId) {
    if (pendingDeferIds[deferId]) {
      delete pendingDeferIds[deferId];
      clearTimeout(deferId);
      completeOutstandingRequest(noop);
      return true;
    }
    return false;
  };

}

/** @this */
function $BrowserProvider() {
  this.$get = ['$window', '$log', '$sniffer', '$document',
      function($window, $log, $sniffer, $document) {
        return new Browser($window, $document, $log, $sniffer);
      }];
}

/**
 * @ngdoc service
 * @name $cacheFactory
 * @this
 *
 * @description
 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
 * them.
 *
 * ```js
 *
 *  var cache = $cacheFactory('cacheId');
 *  expect($cacheFactory.get('cacheId')).toBe(cache);
 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
 *
 *  cache.put("key", "value");
 *  cache.put("another key", "another value");
 *
 *  // We've specified no options on creation
 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
 *
 * ```
 *
 *
 * @param {string} cacheId Name or id of the newly created cache.
 * @param {object=} options Options object that specifies the cache behavior. Properties:
 *
 *   - `{number=}` `capacity` — turns the cache into LRU cache.
 *
 * @returns {object} Newly created cache object with the following set of methods:
 *
 * - `{object}` `info()` — Returns id, size, and options of cache.
 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
 *   it.
 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
 * - `{void}` `removeAll()` — Removes all cached values.
 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
 *
 * @example
   <example module="cacheExampleApp" name="cache-factory">
     <file name="index.html">
       <div ng-controller="CacheController">
         <input ng-model="newCacheKey" placeholder="Key">
         <input ng-model="newCacheValue" placeholder="Value">
         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>

         <p ng-if="keys.length">Cached Values</p>
         <div ng-repeat="key in keys">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="cache.get(key)"></b>
         </div>

         <p>Cache Info</p>
         <div ng-repeat="(key, value) in cache.info()">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="value"></b>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('cacheExampleApp', []).
         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
           $scope.keys = [];
           $scope.cache = $cacheFactory('cacheId');
           $scope.put = function(key, value) {
             if (angular.isUndefined($scope.cache.get(key))) {
               $scope.keys.push(key);
             }
             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
           };
         }]);
     </file>
     <file name="style.css">
       p {
         margin: 10px 0 3px;
       }
     </file>
   </example>
 */
function $CacheFactoryProvider() {

  this.$get = function() {
    var caches = {};

    function cacheFactory(cacheId, options) {
      if (cacheId in caches) {
        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
      }

      var size = 0,
          stats = extend({}, options, {id: cacheId}),
          data = createMap(),
          capacity = (options && options.capacity) || Number.MAX_VALUE,
          lruHash = createMap(),
          freshEnd = null,
          staleEnd = null;

      /**
       * @ngdoc type
       * @name $cacheFactory.Cache
       *
       * @description
       * A cache object used to store and retrieve data, primarily used by
       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
       * templates and other data.
       *
       * ```js
       *  angular.module('superCache')
       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
       *      return $cacheFactory('super-cache');
       *    }]);
       * ```
       *
       * Example test:
       *
       * ```js
       *  it('should behave like a cache', inject(function(superCache) {
       *    superCache.put('key', 'value');
       *    superCache.put('another key', 'another value');
       *
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 2
       *    });
       *
       *    superCache.remove('another key');
       *    expect(superCache.get('another key')).toBeUndefined();
       *
       *    superCache.removeAll();
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 0
       *    });
       *  }));
       * ```
       */
      return (caches[cacheId] = {

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#put
         * @kind function
         *
         * @description
         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
         * retrieved later, and incrementing the size of the cache if the key was not already
         * present in the cache. If behaving like an LRU cache, it will also remove stale
         * entries from the set.
         *
         * It will not insert undefined values into the cache.
         *
         * @param {string} key the key under which the cached data is stored.
         * @param {*} value the value to store alongside the key. If it is undefined, the key
         *    will not be stored.
         * @returns {*} the value stored.
         */
        put: function(key, value) {
          if (isUndefined(value)) return;
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});

            refresh(lruEntry);
          }

          if (!(key in data)) size++;
          data[key] = value;

          if (size > capacity) {
            this.remove(staleEnd.key);
          }

          return value;
        },

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#get
         * @kind function
         *
         * @description
         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the data to be retrieved
         * @returns {*} the value stored.
         */
        get: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            refresh(lruEntry);
          }

          return data[key];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#remove
         * @kind function
         *
         * @description
         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the entry to be removed
         */
        remove: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
            link(lruEntry.n,lruEntry.p);

            delete lruHash[key];
          }

          if (!(key in data)) return;

          delete data[key];
          size--;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#removeAll
         * @kind function
         *
         * @description
         * Clears the cache object of any entries.
         */
        removeAll: function() {
          data = createMap();
          size = 0;
          lruHash = createMap();
          freshEnd = staleEnd = null;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#destroy
         * @kind function
         *
         * @description
         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
         * removing it from the {@link $cacheFactory $cacheFactory} set.
         */
        destroy: function() {
          data = null;
          stats = null;
          lruHash = null;
          delete caches[cacheId];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#info
         * @kind function
         *
         * @description
         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
         *
         * @returns {object} an object with the following properties:
         *   <ul>
         *     <li>**id**: the id of the cache instance</li>
         *     <li>**size**: the number of entries kept in the cache instance</li>
         *     <li>**...**: any additional properties from the options object when creating the
         *       cache.</li>
         *   </ul>
         */
        info: function() {
          return extend({}, stats, {size: size});
        }
      });


      /**
       * makes the `entry` the freshEnd of the LRU linked list
       */
      function refresh(entry) {
        if (entry !== freshEnd) {
          if (!staleEnd) {
            staleEnd = entry;
          } else if (staleEnd === entry) {
            staleEnd = entry.n;
          }

          link(entry.n, entry.p);
          link(entry, freshEnd);
          freshEnd = entry;
          freshEnd.n = null;
        }
      }


      /**
       * bidirectionally links two entries of the LRU linked list
       */
      function link(nextEntry, prevEntry) {
        if (nextEntry !== prevEntry) {
          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
        }
      }
    }


  /**
   * @ngdoc method
   * @name $cacheFactory#info
   *
   * @description
   * Get information about all the caches that have been created
   *
   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
   */
    cacheFactory.info = function() {
      var info = {};
      forEach(caches, function(cache, cacheId) {
        info[cacheId] = cache.info();
      });
      return info;
    };


  /**
   * @ngdoc method
   * @name $cacheFactory#get
   *
   * @description
   * Get access to a cache object by the `cacheId` used when it was created.
   *
   * @param {string} cacheId Name or id of a cache to access.
   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
   */
    cacheFactory.get = function(cacheId) {
      return caches[cacheId];
    };


    return cacheFactory;
  };
}

/**
 * @ngdoc service
 * @name $templateCache
 * @this
 *
 * @description
 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
 * can load templates directly into the cache in a `script` tag, or by consuming the
 * `$templateCache` service directly.
 *
 * Adding via the `script` tag:
 *
 * ```html
 *   <script type="text/ng-template" id="templateId.html">
 *     <p>This is the content of the template</p>
 *   </script>
 * ```
 *
 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
 * element with ng-app attribute), otherwise the template will be ignored.
 *
 * Adding via the `$templateCache` service:
 *
 * ```js
 * var myApp = angular.module('myApp', []);
 * myApp.run(function($templateCache) {
 *   $templateCache.put('templateId.html', 'This is the content of the template');
 * });
 * ```
 *
 * To retrieve the template later, simply use it in your component:
 * ```js
 * myApp.component('myComponent', {
 *    templateUrl: 'templateId.html'
 * });
 * ```
 *
 * or get it via the `$templateCache` service:
 * ```js
 * $templateCache.get('templateId.html')
 * ```
 *
 * See {@link ng.$cacheFactory $cacheFactory}.
 *
 */
function $TemplateCacheProvider() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('templates');
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables like document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
 *
 * DOM-related variables:
 *
 * - "node" - DOM Node
 * - "element" - DOM Element or Node
 * - "$node" or "$element" - jqLite-wrapped node or element
 *
 *
 * Compiler related stuff:
 *
 * - "linkFn" - linking fn of a single directive
 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
 */


/**
 * @ngdoc service
 * @name $compile
 * @kind function
 *
 * @description
 * Compiles an HTML string or DOM into a template and produces a template function, which
 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
 *
 * The compilation is a process of walking the DOM tree and matching DOM elements to
 * {@link ng.$compileProvider#directive directives}.
 *
 * <div class="alert alert-warning">
 * **Note:** This document is an in-depth reference of all directive options.
 * For a gentle introduction to directives with examples of common use cases,
 * see the {@link guide/directive directive guide}.
 * </div>
 *
 * ## Comprehensive Directive API
 *
 * There are many different options for a directive.
 *
 * The difference resides in the return value of the factory function.
 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
 * that defines the directive properties, or just the `postLink` function (all other properties will have
 * the default values).
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's recommended to use the "directive definition object" form.
 * </div>
 *
 * Here's an example directive declared with a Directive Definition Object:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       {@link $compile#-priority- priority}: 0,
 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
 *       // or
 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
 *       {@link $compile#-transclude- transclude}: false,
 *       {@link $compile#-restrict- restrict}: 'A',
 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
 *       {@link $compile#-scope- scope}: false,
 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
 *       {@link $compile#-bindtocontroller- bindToController}: false,
 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
 *       {@link $compile#-multielement- multiElement}: false,
 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
 *         return {
 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *         }
 *         // or
 *         // return function postLink( ... ) { ... }
 *       },
 *       // or
 *       // {@link $compile#-link- link}: {
 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *       // }
 *       // or
 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
 *     };
 *     return directiveDefinitionObject;
 *   });
 * ```
 *
 * <div class="alert alert-warning">
 * **Note:** Any unspecified options will use the default value. You can see the default values below.
 * </div>
 *
 * Therefore the above can be simplified as:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       link: function postLink(scope, iElement, iAttrs) { ... }
 *     };
 *     return directiveDefinitionObject;
 *     // or
 *     // return function postLink(scope, iElement, iAttrs) { ... }
 *   });
 * ```
 *
 * ### Life-cycle hooks
 * Directive controllers can provide the following methods that are called by Angular at points in the life-cycle of the
 * directive:
 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
 *   this element). This is a good place to put initialization code for your controller.
 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
 *   component such as cloning the bound value to prevent accidental mutation of the outer value.
 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
 *   changes. Any actions that you wish to take in response to the changes that you detect must be
 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
 *   be detected by Angular's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
 *   components will have their `$onDestroy()` hook called before child components.
 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
 *   suspended until that occurs.
 *
 * #### Comparison with Angular 2 life-cycle hooks
 * Angular 2 also uses life-cycle hooks for its components. While the Angular 1 life-cycle hooks are similar there are
 * some differences that you should be aware of, especially when it comes to moving your code from Angular 1 to Angular 2:
 *
 * * Angular 1 hooks are prefixed with `$`, such as `$onInit`. Angular 2 hooks are prefixed with `ng`, such as `ngOnInit`.
 * * Angular 1 hooks can be defined on the controller prototype or added to the controller inside its constructor.
 *   In Angular 2 you can only define hooks on the prototype of the Component class.
 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in Angular 1 than you would to
 *   `ngDoCheck` in Angular 2
 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
 *   propagated throughout the application.
 *   Angular 2 does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
 *   error or do nothing depending upon the state of `enableProdMode()`.
 *
 * #### Life-cycle hook examples
 *
 * This example shows how you can check for mutations to a Date object even though the identity of the object
 * has not changed.
 *
 * <example name="doCheckDateExample" module="do-check-module">
 *   <file name="app.js">
 *     angular.module('do-check-module', [])
 *       .component('app', {
 *         template:
 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
 *           'Date: {{ $ctrl.date }}' +
 *           '<test date="$ctrl.date"></test>',
 *         controller: function() {
 *           this.date = new Date();
 *           this.month = this.date.getMonth();
 *           this.updateDate = function() {
 *             this.date.setMonth(this.month);
 *           };
 *         }
 *       })
 *       .component('test', {
 *         bindings: { date: '<' },
 *         template:
 *           '<pre>{{ $ctrl.log | json }}</pre>',
 *         controller: function() {
 *           var previousValue;
 *           this.log = [];
 *           this.$doCheck = function() {
 *             var currentValue = this.date && this.date.valueOf();
 *             if (previousValue !== currentValue) {
 *               this.log.push('doCheck: date mutated: ' + this.date);
 *               previousValue = currentValue;
 *             }
 *           };
 *         }
 *       });
 *   </file>
 *   <file name="index.html">
 *     <app></app>
 *   </file>
 * </example>
 *
 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
 * arrays or objects can have a negative impact on your application performance)
 *
 * <example name="doCheckArrayExample" module="do-check-module">
 *   <file name="index.html">
 *     <div ng-init="items = []">
 *       <button ng-click="items.push(items.length)">Add Item</button>
 *       <button ng-click="items = []">Reset Items</button>
 *       <pre>{{ items }}</pre>
 *       <test items="items"></test>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *      angular.module('do-check-module', [])
 *        .component('test', {
 *          bindings: { items: '<' },
 *          template:
 *            '<pre>{{ $ctrl.log | json }}</pre>',
 *          controller: function() {
 *            this.log = [];
 *
 *            this.$doCheck = function() {
 *              if (this.items_ref !== this.items) {
 *                this.log.push('doCheck: items changed');
 *                this.items_ref = this.items;
 *              }
 *              if (!angular.equals(this.items_clone, this.items)) {
 *                this.log.push('doCheck: items mutated');
 *                this.items_clone = angular.copy(this.items);
 *              }
 *            };
 *          }
 *        });
 *   </file>
 * </example>
 *
 *
 * ### Directive Definition Object
 *
 * The directive definition object provides instructions to the {@link ng.$compile
 * compiler}. The attributes are:
 *
 * #### `multiElement`
 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
 * together as the directive elements. It is recommended that this feature be used on directives
 * which are not strictly behavioral (such as {@link ngClick}), and which
 * do not manipulate or replace child nodes (such as {@link ngInclude}).
 *
 * #### `priority`
 * When there are multiple directives defined on a single DOM element, sometimes it
 * is necessary to specify the order in which the directives are applied. The `priority` is used
 * to sort the directives before their `compile` functions get called. Priority is defined as a
 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
 * are also run in priority order, but post-link functions are run in reverse order. The order
 * of directives with the same priority is undefined. The default priority is `0`.
 *
 * #### `terminal`
 * If set to true then the current `priority` will be the last set of directives
 * which will execute (any directives at the current priority will still execute
 * as the order of execution on same `priority` is undefined). Note that expressions
 * and other directives used in the directive's template will also be excluded from execution.
 *
 * #### `scope`
 * The scope property can be `false`, `true`, or an object:
 *
 * * **`false` (default):** No scope will be created for the directive. The directive will use its
 * parent's scope.
 *
 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
 * the directive's element. If multiple directives on the same element request a new scope,
 * only one new scope is created.
 *
 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's element. The
 * 'isolate' scope differs from normal scope in that it does not prototypically inherit from its parent
 * scope. This is useful when creating reusable components, which should not accidentally read or modify
 * data in the parent scope.
 *
 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
 * directive's element. These local properties are useful for aliasing values for templates. The keys in
 * the object hash map to the name of the property on the isolate scope; the values define how the property
 * is bound to the parent scope, via matching attributes on the directive's element:
 *
 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
 *   attribute name is assumed to be the same as the local name. Given `<my-component
 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
 *   the directive's scope property `localName` will reflect the interpolated value of `hello
 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
 *   scope. The `name` is read from the parent scope (not the directive's scope).
 *
 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
 *   method is used for tracking changes, and the equality check is based on object identity.
 *   However, if an object literal or an array literal is passed as the binding expression, the
 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
 *
  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
 *
 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
 *   two caveats:
 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
 *     sets the same value. That means if your bound value is an object, changes to its properties
 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
 *     to the value has changed. In most cases, this should not be of concern, but can be important
 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
 *     If you now change a property of the object in your parent scope, the change will not be
 *     propagated to the isolated scope, because the identity of the object on the parent scope
 *     has not changed. Instead you must assign a new object.
 *
 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
 *   back to the parent. However, it does not make this completely impossible.
 *
 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
 *   via an expression to the parent scope. This can be done by passing a map of local variable names
 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
 *
 * In general it's possible to apply more than one directive to one element, but there might be limitations
 * depending on the type of scope required by the directives. The following points will help explain these limitations.
 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
 *
 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
 * * **child scope** + **no scope** =>  Both directives will share one single child scope
 * * **child scope** + **child scope** =>  Both directives will share one single child scope
 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
 * its parent's scope
 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
 * be applied to the same element.
 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
 * cannot be applied to the same element.
 *
 *
 * #### `bindToController`
 * This property is used to bind scope properties directly to the controller. It can be either
 * `true` or an object hash with the same format as the `scope` property.
 *
 * When an isolate scope is used for a directive (see above), `bindToController: true` will
 * allow a component to have its properties bound to the controller, rather than to scope.
 *
 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
 * properties. You can access these bindings once they have been initialized by providing a controller method called
 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
 * initialized.
 *
 * <div class="alert alert-warning">
 * **Deprecation warning:** although bindings for non-ES6 class controllers are currently
 * bound to `this` before the controller constructor is called, this use is now deprecated. Please place initialization
 * code that relies upon bindings inside a `$onInit` method on the controller, instead.
 * </div>
 *
 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
 * scope (useful for component directives).
 *
 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
 *
 *
 * #### `controller`
 * Controller constructor function. The controller is instantiated before the
 * pre-linking phase and can be accessed by other directives (see
 * `require` attribute). This allows the directives to communicate with each other and augment
 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
 *
 * * `$scope` - Current scope associated with the element
 * * `$element` - Current element
 * * `$attrs` - Current attributes object for the element
 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
 *    * `scope`: (optional) override the scope.
 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
 *    * `futureParentElement` (optional):
 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
 *          and when the `cloneLinkingFn` is passed,
 *          as those elements need to created and cloned in a special way when they are defined outside their
 *          usual containers (e.g. like `<svg>`).
 *        * See also the `directive.templateNamespace` property.
 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
 *      then the default transclusion is provided.
 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
 *
 * #### `require`
 * Require another directive and inject its controller as the fourth argument to the linking function. The
 * `require` property can be a string, an array or an object:
 * * a **string** containing the name of the directive to pass to the linking function
 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
 * linking function will be an array of controllers in the same order as the names in the `require` property
 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
 * controllers.
 *
 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
 * have been constructed but before `$onInit` is called.
 * If the name of the required controller is the same as the local name (the key), the name can be
 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
 * See the {@link $compileProvider#component} helper for an example of how this can be used.
 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
 * raised (unless no link function is specified and the required controllers are not being bound to the directive
 * controller, in which case error checking is skipped). The name can be prefixed with:
 *
 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
 *   `null` to the `link` fn if not found.
 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
 *   `null` to the `link` fn if not found.
 *
 *
 * #### `controllerAs`
 * Identifier name for a reference to the controller in the directive's scope.
 * This allows the controller to be referenced from the directive template. This is especially
 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
 *
 *
 * #### `restrict`
 * String of subset of `EACM` which restricts the directive to a specific directive
 * declaration style. If omitted, the defaults (elements and attributes) are used.
 *
 * * `E` - Element name (default): `<my-directive></my-directive>`
 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
 * * `C` - Class: `<div class="my-directive: exp;"></div>`
 * * `M` - Comment: `<!-- directive: my-directive exp -->`
 *
 *
 * #### `templateNamespace`
 * String representing the document type used by the markup in the template.
 * AngularJS needs this information as those elements need to be created and cloned
 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
 *
 * * `html` - All root nodes in the template are HTML. Root nodes may also be
 *   top-level elements such as `<svg>` or `<math>`.
 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
 *
 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
 *
 * #### `template`
 * HTML markup that may:
 * * Replace the contents of the directive's element (default).
 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
 * * Wrap the contents of the directive's element (if `transclude` is true).
 *
 * Value may be:
 *
 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
 *   function api below) and returns a string value.
 *
 *
 * #### `templateUrl`
 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
 *
 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
 * for later when the template has been resolved.  In the meantime it will continue to compile and link
 * sibling and parent elements as though this element had not contained any directives.
 *
 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
 * case when only one deeply nested directive has `templateUrl`.
 *
 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
 *
 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
 * a string value representing the url.  In either case, the template URL is passed through {@link
 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
 *
 *
 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
 * specify what the template should replace. Defaults to `false`.
 *
 * * `true` - the template will replace the directive's element.
 * * `false` - the template will replace the contents of the directive's element.
 *
 * The replacement process migrates all of the attributes / classes from the old element to the new
 * one. See the {@link guide/directive#template-expanding-directive
 * Directives Guide} for an example.
 *
 * There are very few scenarios where element replacement is required for the application function,
 * the main one being reusable custom components that are used within SVG contexts
 * (because SVG doesn't work with custom elements in the DOM tree).
 *
 * #### `transclude`
 * Extract the contents of the element where the directive appears and make it available to the directive.
 * The contents are compiled and provided to the directive as a **transclusion function**. See the
 * {@link $compile#transclusion Transclusion} section below.
 *
 *
 * #### `compile`
 *
 * ```js
 *   function compile(tElement, tAttrs, transclude) { ... }
 * ```
 *
 * The compile function deals with transforming the template DOM. Since most directives do not do
 * template transformation, it is not used often. The compile function takes the following arguments:
 *
 *   * `tElement` - template element - The element where the directive has been declared. It is
 *     safe to do template transformation on the element and child elements only.
 *
 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
 *     between all directive compile functions.
 *
 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
 *
 * <div class="alert alert-warning">
 * **Note:** The template instance and the link instance may be different objects if the template has
 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
 * should be done in a linking function rather than in a compile function.
 * </div>

 * <div class="alert alert-warning">
 * **Note:** The compile function cannot handle directives that recursively use themselves in their
 * own templates or compile functions. Compiling these directives results in an infinite loop and
 * stack overflow errors.
 *
 * This can be avoided by manually using $compile in the postLink function to imperatively compile
 * a directive's template instead of relying on automatic template compilation via `template` or
 * `templateUrl` declaration or manual compilation inside the compile function.
 * </div>
 *
 * <div class="alert alert-danger">
 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
 *   to the link function instead.
 * </div>

 * A compile function can have a return value which can be either a function or an object.
 *
 * * returning a (post-link) function - is equivalent to registering the linking function via the
 *   `link` property of the config object when the compile function is empty.
 *
 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
 *   control when a linking function should be called during the linking phase. See info about
 *   pre-linking and post-linking functions below.
 *
 *
 * #### `link`
 * This property is used only if the `compile` property is not defined.
 *
 * ```js
 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
 * ```
 *
 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
 * executed after the template has been cloned. This is where most of the directive logic will be
 * put.
 *
 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
 *
 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
 *     manipulate the children of the element only in `postLink` function since the children have
 *     already been linked.
 *
 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
 *     between all directive linking functions.
 *
 *   * `controller` - the directive's required controller instance(s) - Instances are shared
 *     among all directives, which allows the directives to use the controllers as a communication
 *     channel. The exact value depends on the directive's `require` property:
 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
 *       * `string`: the controller instance
 *       * `array`: array of controller instances
 *
 *     If a required controller cannot be found, and it is optional, the instance is `null`,
 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
 *
 *     Note that you can also require the directive's own controller - it will be made available like
 *     any other controller.
 *
 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
 *     This is the same as the `$transclude` parameter of directive controllers,
 *     see {@link ng.$compile#-controller- the controller section for details}.
 *     `function([scope], cloneLinkingFn, futureParentElement)`.
 *
 * #### Pre-linking function
 *
 * Executed before the child elements are linked. Not safe to do DOM transformation since the
 * compiler linking function will fail to locate the correct elements for linking.
 *
 * #### Post-linking function
 *
 * Executed after the child elements are linked.
 *
 * Note that child elements that contain `templateUrl` directives will not have been compiled
 * and linked since they are waiting for their template to load asynchronously and their own
 * compilation and linking has been suspended until that occurs.
 *
 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
 * for their async templates to be resolved.
 *
 *
 * ### Transclusion
 *
 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
 * scope from where they were taken.
 *
 * Transclusion is used (often with {@link ngTransclude}) to insert the
 * original contents of a directive's element into a specified place in the template of the directive.
 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
 * content has access to the properties on the scope from which it was taken, even if the directive
 * has isolated scope.
 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
 *
 * This makes it possible for the widget to have private state for its template, while the transcluded
 * content has access to its originating scope.
 *
 * <div class="alert alert-warning">
 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
 * Testing Transclusion Directives}.
 * </div>
 *
 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
 * directive's element, the entire element or multiple parts of the element contents:
 *
 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
 * * `'element'` - transclude the whole of the directive's element including any directives on this
 *   element that defined at a lower priority than this directive. When used, the `template`
 *   property is ignored.
 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
 *
 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
 *
 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
 *
 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
 *
 * If the element selector is prefixed with a `?` then that slot is optional.
 *
 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
 *
 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
 * injectable into the directive's controller.
 *
 *
 * #### Transclusion Functions
 *
 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
 * function** to the directive's `link` function and `controller`. This transclusion function is a special
 * **linking function** that will return the compiled contents linked to a new transclusion scope.
 *
 * <div class="alert alert-info">
 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
 * ngTransclude will deal with it for us.
 * </div>
 *
 * If you want to manually control the insertion and removal of the transcluded content in your directive
 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
 *
 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
 *
 * <div class="alert alert-info">
 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
 * </div>
 *
 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
 * attach function**:
 *
 * ```js
 * var transcludedContent, transclusionScope;
 *
 * $transclude(function(clone, scope) {
 *   element.append(clone);
 *   transcludedContent = clone;
 *   transclusionScope = scope;
 * });
 * ```
 *
 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
 * associated transclusion scope:
 *
 * ```js
 * transcludedContent.remove();
 * transclusionScope.$destroy();
 * ```
 *
 * <div class="alert alert-info">
 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
 * then you are also responsible for calling `$destroy` on the transclusion scope.
 * </div>
 *
 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
 *
 *
 * #### Transclusion Scopes
 *
 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
 * was taken.
 *
 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
 * like this:
 *
 * ```html
 * <div ng-app>
 *   <div isolate>
 *     <div transclusion>
 *     </div>
 *   </div>
 * </div>
 * ```
 *
 * The `$parent` scope hierarchy will look like this:
 *
   ```
   - $rootScope
     - isolate
       - transclusion
   ```
 *
 * but the scopes will inherit prototypically from different scopes to their `$parent`.
 *
   ```
   - $rootScope
     - transclusion
   - isolate
   ```
 *
 *
 * ### Attributes
 *
 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
 * `link()` or `compile()` functions. It has a variety of uses.
 *
 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
 *   to the attributes.
 *
 * * *Directive inter-communication:* All directives share the same instance of the attributes
 *   object which allows the directives to use the attributes object as inter directive
 *   communication.
 *
 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
 *   allowing other directives to read the interpolated value.
 *
 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
 *   the only way to easily get the actual value because during the linking phase the interpolation
 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
 *
 * ```js
 * function linkingFn(scope, elm, attrs, ctrl) {
 *   // get the attribute value
 *   console.log(attrs.ngModel);
 *
 *   // change the attribute
 *   attrs.$set('ngModel', 'new value');
 *
 *   // observe changes to interpolated attribute
 *   attrs.$observe('ngModel', function(value) {
 *     console.log('ngModel has changed value to ' + value);
 *   });
 * }
 * ```
 *
 * ## Example
 *
 * <div class="alert alert-warning">
 * **Note**: Typically directives are registered with `module.directive`. The example below is
 * to illustrate how `$compile` works.
 * </div>
 *
 <example module="compileExample" name="compile">
   <file name="index.html">
    <script>
      angular.module('compileExample', [], function($compileProvider) {
        // configure new 'compile' directive by passing a directive
        // factory function. The factory function injects the '$compile'
        $compileProvider.directive('compile', function($compile) {
          // directive factory creates a link function
          return function(scope, element, attrs) {
            scope.$watch(
              function(scope) {
                 // watch the 'compile' expression for changes
                return scope.$eval(attrs.compile);
              },
              function(value) {
                // when the 'compile' expression changes
                // assign it into the current DOM
                element.html(value);

                // compile the new DOM and link it to the current
                // scope.
                // NOTE: we only compile .childNodes so that
                // we don't get into infinite loop compiling ourselves
                $compile(element.contents())(scope);
              }
            );
          };
        });
      })
      .controller('GreeterController', ['$scope', function($scope) {
        $scope.name = 'Angular';
        $scope.html = 'Hello {{name}}';
      }]);
    </script>
    <div ng-controller="GreeterController">
      <input ng-model="name"> <br/>
      <textarea ng-model="html"></textarea> <br/>
      <div compile="html"></div>
    </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should auto compile', function() {
       var textarea = $('textarea');
       var output = $('div[compile]');
       // The initial state reads 'Hello Angular'.
       expect(output.getText()).toBe('Hello Angular');
       textarea.clear();
       textarea.sendKeys('{{name}}!');
       expect(output.getText()).toBe('Angular!');
     });
   </file>
 </example>

 *
 *
 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
 *
 * <div class="alert alert-danger">
 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
 *   e.g. will not use the right outer scope. Please pass the transclude function as a
 *   `parentBoundTranscludeFn` to the link function instead.
 * </div>
 *
 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
 *                 root element(s), not their children)
 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
 * (a DOM element/tree) to a scope. Where:
 *
 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
 *
 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
 *      * `scope` - is the current scope with which the linking function is working with.
 *
 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
 *  keys may be used to control linking behavior:
 *
 *      * `parentBoundTranscludeFn` - the transclude function made available to
 *        directives; if given, it will be passed through to the link functions of
 *        directives found in `element` during compilation.
 *      * `transcludeControllers` - an object hash with keys that map controller names
 *        to a hash with the key `instance`, which maps to the controller instance;
 *        if given, it will make the controllers available to directives on the compileNode:
 *        ```
 *        {
 *          parent: {
 *            instance: parentControllerInstance
 *          }
 *        }
 *        ```
 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
 *        the cloned elements; only needed for transcludes that are allowed to contain non html
 *        elements (e.g. SVG elements). See also the directive.controller property.
 *
 * Calling the linking function returns the element of the template. It is either the original
 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
 *
 * After linking the view is not updated until after a call to $digest which typically is done by
 * Angular automatically.
 *
 * If you need access to the bound view, there are two ways to do it:
 *
 * - If you are not asking the linking function to clone the template, create the DOM element(s)
 *   before you send them to the compiler and keep this reference around.
 *   ```js
 *     var element = $compile('<p>{{total}}</p>')(scope);
 *   ```
 *
 * - if on the other hand, you need the element to be cloned, the view reference from the original
 *   example would not point to the clone, but rather to the original template that was cloned. In
 *   this case, you can access the clone via the cloneAttachFn:
 *   ```js
 *     var templateElement = angular.element('<p>{{total}}</p>'),
 *         scope = ....;
 *
 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
 *       //attach the clone to DOM document at the right place
 *     });
 *
 *     //now we have reference to the cloned DOM via `clonedElement`
 *   ```
 *
 *
 * For information on how the compiler works, see the
 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
 *
 * @knownIssue
 *
 * ### Double Compilation
 *
   Double compilation occurs when an already compiled part of the DOM gets
   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
   section on double compilation} for an in-depth explanation and ways to avoid it.
 *
 */

var $compileMinErr = minErr('$compile');

function UNINITIALIZED_VALUE() {}
var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();

/**
 * @ngdoc provider
 * @name $compileProvider
 *
 * @description
 */
$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
/** @this */
function $CompileProvider($provide, $$sanitizeUriProvider) {
  var hasDirectives = {},
      Suffix = 'Directive',
      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;

  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
  // The assumption is that future DOM event attribute names will begin with
  // 'on' and be composed of only English letters.
  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
  var bindingCache = createMap();

  function parseIsolateBindings(scope, directiveName, isController) {
    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*(\w*)\s*$/;

    var bindings = createMap();

    forEach(scope, function(definition, scopeName) {
      if (definition in bindingCache) {
        bindings[scopeName] = bindingCache[definition];
        return;
      }
      var match = definition.match(LOCAL_REGEXP);

      if (!match) {
        throw $compileMinErr('iscp',
            'Invalid {3} for directive \'{0}\'.' +
            ' Definition: {... {1}: \'{2}\' ...}',
            directiveName, scopeName, definition,
            (isController ? 'controller bindings definition' :
            'isolate scope definition'));
      }

      bindings[scopeName] = {
        mode: match[1][0],
        collection: match[2] === '*',
        optional: match[3] === '?',
        attrName: match[4] || scopeName
      };
      if (match[4]) {
        bindingCache[definition] = bindings[scopeName];
      }
    });

    return bindings;
  }

  function parseDirectiveBindings(directive, directiveName) {
    var bindings = {
      isolateScope: null,
      bindToController: null
    };
    if (isObject(directive.scope)) {
      if (directive.bindToController === true) {
        bindings.bindToController = parseIsolateBindings(directive.scope,
                                                         directiveName, true);
        bindings.isolateScope = {};
      } else {
        bindings.isolateScope = parseIsolateBindings(directive.scope,
                                                     directiveName, false);
      }
    }
    if (isObject(directive.bindToController)) {
      bindings.bindToController =
          parseIsolateBindings(directive.bindToController, directiveName, true);
    }
    if (bindings.bindToController && !directive.controller) {
      // There is no controller
      throw $compileMinErr('noctrl',
            'Cannot bind to controller without directive \'{0}\'s controller.',
            directiveName);
    }
    return bindings;
  }

  function assertValidDirectiveName(name) {
    var letter = name.charAt(0);
    if (!letter || letter !== lowercase(letter)) {
      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
    }
    if (name !== name.trim()) {
      throw $compileMinErr('baddir',
            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
            name);
    }
  }

  function getDirectiveRequire(directive) {
    var require = directive.require || (directive.controller && directive.name);

    if (!isArray(require) && isObject(require)) {
      forEach(require, function(value, key) {
        var match = value.match(REQUIRE_PREFIX_REGEXP);
        var name = value.substring(match[0].length);
        if (!name) require[key] = match[0] + key;
      });
    }

    return require;
  }

  function getDirectiveRestrict(restrict, name) {
    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
      throw $compileMinErr('badrestrict',
          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
          restrict,
          name);
    }

    return restrict || 'EA';
  }

  /**
   * @ngdoc method
   * @name $compileProvider#directive
   * @kind function
   *
   * @description
   * Register a new directive with the compiler.
   *
   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
   *    names and the values are the factories.
   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
   * @returns {ng.$compileProvider} Self for chaining.
   */
  this.directive = function registerDirective(name, directiveFactory) {
    assertArg(name, 'name');
    assertNotHasOwnProperty(name, 'directive');
    if (isString(name)) {
      assertValidDirectiveName(name);
      assertArg(directiveFactory, 'directiveFactory');
      if (!hasDirectives.hasOwnProperty(name)) {
        hasDirectives[name] = [];
        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
          function($injector, $exceptionHandler) {
            var directives = [];
            forEach(hasDirectives[name], function(directiveFactory, index) {
              try {
                var directive = $injector.invoke(directiveFactory);
                if (isFunction(directive)) {
                  directive = { compile: valueFn(directive) };
                } else if (!directive.compile && directive.link) {
                  directive.compile = valueFn(directive.link);
                }
                directive.priority = directive.priority || 0;
                directive.index = index;
                directive.name = directive.name || name;
                directive.require = getDirectiveRequire(directive);
                directive.restrict = getDirectiveRestrict(directive.restrict, name);
                directive.$$moduleName = directiveFactory.$$moduleName;
                directives.push(directive);
              } catch (e) {
                $exceptionHandler(e);
              }
            });
            return directives;
          }]);
      }
      hasDirectives[name].push(directiveFactory);
    } else {
      forEach(name, reverseParams(registerDirective));
    }
    return this;
  };

  /**
   * @ngdoc method
   * @name $compileProvider#component
   * @module ng
   * @param {string} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`)
   * @param {Object} options Component definition object (a simplified
   *    {@link ng.$compile#directive-definition-object directive definition object}),
   *    with the following properties (all optional):
   *
   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
   *      registered controller} if passed as a string. An empty `noop` function by default.
   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
   *      If present, the controller will be published to scope under the `controllerAs` name.
   *      If not present, this will default to be `$ctrl`.
   *    - `template` – `{string=|function()=}` – html template as a string or a function that
   *      returns an html template as a string which should be used as the contents of this component.
   *      Empty string by default.
   *
   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
   *      template that should be used  as the contents of this component.
   *
   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
   *      Component properties are always bound to the component controller and not to the scope.
   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
   *      Disabled by default.
   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
   *      this component's controller. The object keys specify the property names under which the required
   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
   *    - `$...` – additional properties to attach to the directive factory function and the controller
   *      constructor function. (This is used by the component router to annotate)
   *
   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
   * @description
   * Register a **component definition** with the compiler. This is a shorthand for registering a special
   * type of directive, which represents a self-contained UI component in your application. Such components
   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
   *
   * Component definitions are very simple and do not require as much configuration as defining general
   * directives. Component definitions usually consist only of a template and a controller backing it.
   *
   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
   * `bindToController`. They always have **isolate scope** and are restricted to elements.
   *
   * Here are a few examples of how you would usually define components:
   *
   * ```js
   *   var myMod = angular.module(...);
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     controller: function() {
   *       this.name = 'shahar';
   *     }
   *   });
   *
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     bindings: {name: '@'}
   *   });
   *
   *   myMod.component('myComp', {
   *     templateUrl: 'views/my-comp.html',
   *     controller: 'MyCtrl',
   *     controllerAs: 'ctrl',
   *     bindings: {name: '@'}
   *   });
   *
   * ```
   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
   *
   * <br />
   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
   */
  this.component = function registerComponent(name, options) {
    var controller = options.controller || function() {};

    function factory($injector) {
      function makeInjectable(fn) {
        if (isFunction(fn) || isArray(fn)) {
          return /** @this */ function(tElement, tAttrs) {
            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
          };
        } else {
          return fn;
        }
      }

      var template = (!options.template && !options.templateUrl ? '' : options.template);
      var ddo = {
        controller: controller,
        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
        template: makeInjectable(template),
        templateUrl: makeInjectable(options.templateUrl),
        transclude: options.transclude,
        scope: {},
        bindToController: options.bindings || {},
        restrict: 'E',
        require: options.require
      };

      // Copy annotations (starting with $) over to the DDO
      forEach(options, function(val, key) {
        if (key.charAt(0) === '$') ddo[key] = val;
      });

      return ddo;
    }

    // TODO(pete) remove the following `forEach` before we release 1.6.0
    // The component-router@0.2.0 looks for the annotations on the controller constructor
    // Nothing in Angular looks for annotations on the factory function but we can't remove
    // it from 1.5.x yet.

    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
    // These could be used by libraries such as the new component router
    forEach(options, function(val, key) {
      if (key.charAt(0) === '$') {
        factory[key] = val;
        // Don't try to copy over annotations to named controller
        if (isFunction(controller)) controller[key] = val;
      }
    });

    factory.$inject = ['$injector'];

    return this.directive(name, factory);
  };


  /**
   * @ngdoc method
   * @name $compileProvider#aHrefSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
    }
  };


  /**
   * @ngdoc method
   * @name $compileProvider#imgSrcSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
    }
  };

  /**
   * @ngdoc method
   * @name  $compileProvider#debugInfoEnabled
   *
   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
   * current debugInfoEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable various debug runtime information in the compiler such as adding
   * binding information and a reference to the current scope on to DOM elements.
   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
   * * `ng-binding` CSS class
   * * `$binding` data property containing an array of the binding expressions
   *
   * You may want to disable this in production for a significant performance boost. See
   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
   *
   * The default value is true.
   */
  var debugInfoEnabled = true;
  this.debugInfoEnabled = function(enabled) {
    if (isDefined(enabled)) {
      debugInfoEnabled = enabled;
      return this;
    }
    return debugInfoEnabled;
  };

  /**
   * @ngdoc method
   * @name  $compileProvider#preAssignBindingsEnabled
   *
   * @param {boolean=} enabled update the preAssignBindingsEnabled state if provided, otherwise just return the
   * current preAssignBindingsEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable whether directive controllers are assigned bindings before
   * calling the controller's constructor.
   * If enabled (true), the compiler assigns the value of each of the bindings to the
   * properties of the controller object before the constructor of this object is called.
   *
   * If disabled (false), the compiler calls the constructor first before assigning bindings.
   *
   * The default value is true in Angular 1.5.x but will switch to false in Angular 1.6.x.
   */
  var preAssignBindingsEnabled = false;
  this.preAssignBindingsEnabled = function(enabled) {
    if (isDefined(enabled)) {
      preAssignBindingsEnabled = enabled;
      return this;
    }
    return preAssignBindingsEnabled;
  };


  var TTL = 10;
  /**
   * @ngdoc method
   * @name $compileProvider#onChangesTtl
   * @description
   *
   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
   * assuming that the model is unstable.
   *
   * The current default is 10 iterations.
   *
   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
   * in several iterations of calls to these hooks. However if an application needs more than the default 10
   * iterations to stabilize then you should investigate what is causing the model to continuously change during
   * the `$onChanges` hook execution.
   *
   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
   *
   * @param {number} limit The number of `$onChanges` hook iterations.
   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
   */
  this.onChangesTtl = function(value) {
    if (arguments.length) {
      TTL = value;
      return this;
    }
    return TTL;
  };

  var commentDirectivesEnabledConfig = true;
  /**
   * @ngdoc method
   * @name $compileProvider#commentDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on comments should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on comments for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check comments when looking for directives.
   * This should however only be used if you are sure that no comment directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */
  this.commentDirectivesEnabled = function(value) {
    if (arguments.length) {
      commentDirectivesEnabledConfig = value;
      return this;
    }
    return commentDirectivesEnabledConfig;
  };


  var cssClassDirectivesEnabledConfig = true;
  /**
   * @ngdoc method
   * @name $compileProvider#cssClassDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on element classes should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on element classes for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check element classes when looking for directives.
   * This should however only be used if you are sure that no class directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */
  this.cssClassDirectivesEnabled = function(value) {
    if (arguments.length) {
      cssClassDirectivesEnabledConfig = value;
      return this;
    }
    return cssClassDirectivesEnabledConfig;
  };

  this.$get = [
            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {

    var SIMPLE_ATTR_NAME = /^\w/;
    var specialAttrHolder = window.document.createElement('div');


    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;


    var onChangesTtl = TTL;
    // The onChanges hooks should all be run together in a single digest
    // When changes occur, the call to trigger their hooks will be added to this queue
    var onChangesQueue;

    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
    function flushOnChangesQueue() {
      try {
        if (!(--onChangesTtl)) {
          // We have hit the TTL limit so reset everything
          onChangesQueue = undefined;
          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
        }
        // We must run this hook in an apply since the $$postDigest runs outside apply
        $rootScope.$apply(function() {
          var errors = [];
          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
            try {
              onChangesQueue[i]();
            } catch (e) {
              errors.push(e);
            }
          }
          // Reset the queue to trigger a new schedule next time there is a change
          onChangesQueue = undefined;
          if (errors.length) {
            throw errors;
          }
        });
      } finally {
        onChangesTtl++;
      }
    }


    function Attributes(element, attributesToCopy) {
      if (attributesToCopy) {
        var keys = Object.keys(attributesToCopy);
        var i, l, key;

        for (i = 0, l = keys.length; i < l; i++) {
          key = keys[i];
          this[key] = attributesToCopy[key];
        }
      } else {
        this.$attr = {};
      }

      this.$$element = element;
    }

    Attributes.prototype = {
      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$normalize
       * @kind function
       *
       * @description
       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
       * `data-`) to its normalized, camelCase form.
       *
       * Also there is special case for Moz prefix starting with upper case letter.
       *
       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
       *
       * @param {string} name Name to normalize
       */
      $normalize: directiveNormalize,


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$addClass
       * @kind function
       *
       * @description
       * Adds the CSS class value specified by the classVal parameter to the element. If animations
       * are enabled then an animation will be triggered for the class addition.
       *
       * @param {string} classVal The className value that will be added to the element
       */
      $addClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.addClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$removeClass
       * @kind function
       *
       * @description
       * Removes the CSS class value specified by the classVal parameter from the element. If
       * animations are enabled then an animation will be triggered for the class removal.
       *
       * @param {string} classVal The className value that will be removed from the element
       */
      $removeClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.removeClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$updateClass
       * @kind function
       *
       * @description
       * Adds and removes the appropriate CSS class values to the element based on the difference
       * between the new and old CSS class values (specified as newClasses and oldClasses).
       *
       * @param {string} newClasses The current CSS className value
       * @param {string} oldClasses The former CSS className value
       */
      $updateClass: function(newClasses, oldClasses) {
        var toAdd = tokenDifference(newClasses, oldClasses);
        if (toAdd && toAdd.length) {
          $animate.addClass(this.$$element, toAdd);
        }

        var toRemove = tokenDifference(oldClasses, newClasses);
        if (toRemove && toRemove.length) {
          $animate.removeClass(this.$$element, toRemove);
        }
      },

      /**
       * Set a normalized attribute on the element in a way such that all directives
       * can share the attribute. This function properly handles boolean attributes.
       * @param {string} key Normalized key. (ie ngAttribute)
       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
       *     Defaults to true.
       * @param {string=} attrName Optional none normalized name. Defaults to key.
       */
      $set: function(key, value, writeAttr, attrName) {
        // TODO: decide whether or not to throw an error if "class"
        //is set through this function since it may cause $updateClass to
        //become unstable.

        var node = this.$$element[0],
            booleanKey = getBooleanAttrName(node, key),
            aliasedKey = getAliasedAttrName(key),
            observer = key,
            nodeName;

        if (booleanKey) {
          this.$$element.prop(key, value);
          attrName = booleanKey;
        } else if (aliasedKey) {
          this[aliasedKey] = value;
          observer = aliasedKey;
        }

        this[key] = value;

        // translate normalized key to actual key
        if (attrName) {
          this.$attr[key] = attrName;
        } else {
          attrName = this.$attr[key];
          if (!attrName) {
            this.$attr[key] = attrName = snake_case(key, '-');
          }
        }

        nodeName = nodeName_(this.$$element);

        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
            (nodeName === 'img' && key === 'src')) {
          // sanitize a[href] and img[src] values
          this[key] = value = $$sanitizeUri(value, key === 'src');
        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
          // sanitize img[srcset] values
          var result = '';

          // first check if there are spaces because it's not the same pattern
          var trimmedSrcset = trim(value);
          //                (   999x   ,|   999w   ,|   ,|,   )
          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;

          // split srcset into tuple of uri and descriptor except for the last item
          var rawUris = trimmedSrcset.split(pattern);

          // for each tuples
          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
          for (var i = 0; i < nbrUrisWith2parts; i++) {
            var innerIdx = i * 2;
            // sanitize the uri
            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
            // add the descriptor
            result += (' ' + trim(rawUris[innerIdx + 1]));
          }

          // split the last item into uri and descriptor
          var lastTuple = trim(rawUris[i * 2]).split(/\s/);

          // sanitize the last uri
          result += $$sanitizeUri(trim(lastTuple[0]), true);

          // and add the last descriptor if any
          if (lastTuple.length === 2) {
            result += (' ' + trim(lastTuple[1]));
          }
          this[key] = value = result;
        }

        if (writeAttr !== false) {
          if (value === null || isUndefined(value)) {
            this.$$element.removeAttr(attrName);
          } else {
            if (SIMPLE_ATTR_NAME.test(attrName)) {
              this.$$element.attr(attrName, value);
            } else {
              setSpecialAttr(this.$$element[0], attrName, value);
            }
          }
        }

        // fire observers
        var $$observers = this.$$observers;
        if ($$observers) {
          forEach($$observers[observer], function(fn) {
            try {
              fn(value);
            } catch (e) {
              $exceptionHandler(e);
            }
          });
        }
      },


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$observe
       * @kind function
       *
       * @description
       * Observes an interpolated attribute.
       *
       * The observer function will be invoked once during the next `$digest` following
       * compilation. The observer is then invoked whenever the interpolated value
       * changes.
       *
       * @param {string} key Normalized key. (ie ngAttribute) .
       * @param {function(interpolatedValue)} fn Function that will be called whenever
                the interpolated value of the attribute changes.
       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
       *        guide} for more info.
       * @returns {function()} Returns a deregistration function for this observer.
       */
      $observe: function(key, fn) {
        var attrs = this,
            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
            listeners = ($$observers[key] || ($$observers[key] = []));

        listeners.push(fn);
        $rootScope.$evalAsync(function() {
          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
            // no one registered attribute interpolation function, so lets call it manually
            fn(attrs[key]);
          }
        });

        return function() {
          arrayRemove(listeners, fn);
        };
      }
    };

    function setSpecialAttr(element, attrName, value) {
      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
      // so we have to jump through some hoops to get such an attribute
      // https://github.com/angular/angular.js/pull/13318
      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
      var attributes = specialAttrHolder.firstChild.attributes;
      var attribute = attributes[0];
      // We have to remove the attribute from its container element before we can add it to the destination element
      attributes.removeNamedItem(attribute.name);
      attribute.value = value;
      element.attributes.setNamedItem(attribute);
    }

    function safeAddClass($element, className) {
      try {
        $element.addClass(className);
      } catch (e) {
        // ignore, since it means that we are trying to set class on
        // SVG element, where class name is read-only.
      }
    }


    var startSymbol = $interpolate.startSymbol(),
        endSymbol = $interpolate.endSymbol(),
        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
            ? identity
            : function denormalizeTemplate(template) {
              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
        },
        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;

    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
      var bindings = $element.data('$binding') || [];

      if (isArray(binding)) {
        bindings = bindings.concat(binding);
      } else {
        bindings.push(binding);
      }

      $element.data('$binding', bindings);
    } : noop;

    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
      safeAddClass($element, 'ng-binding');
    } : noop;

    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
      $element.data(dataName, scope);
    } : noop;

    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
    } : noop;

    compile.$$createComment = function(directiveName, comment) {
      var content = '';
      if (debugInfoEnabled) {
        content = ' ' + (directiveName || '') + ': ';
        if (comment) content += comment + ' ';
      }
      return window.document.createComment(content);
    };

    return compile;

    //================================

    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
                        previousCompileContext) {
      if (!($compileNodes instanceof jqLite)) {
        // jquery always rewraps, whereas we need to preserve the original selector so that we can
        // modify it.
        $compileNodes = jqLite($compileNodes);
      }
      var compositeLinkFn =
              compileNodes($compileNodes, transcludeFn, $compileNodes,
                           maxPriority, ignoreDirective, previousCompileContext);
      compile.$$addScopeClass($compileNodes);
      var namespace = null;
      return function publicLinkFn(scope, cloneConnectFn, options) {
        if (!$compileNodes) {
          throw $compileMinErr('multilink', 'This element has already been linked.');
        }
        assertArg(scope, 'scope');

        if (previousCompileContext && previousCompileContext.needsNewScope) {
          // A parent directive did a replace and a directive on this element asked
          // for transclusion, which caused us to lose a layer of element on which
          // we could hold the new transclusion scope, so we will create it manually
          // here.
          scope = scope.$parent.$new();
        }

        options = options || {};
        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
          transcludeControllers = options.transcludeControllers,
          futureParentElement = options.futureParentElement;

        // When `parentBoundTranscludeFn` is passed, it is a
        // `controllersBoundTransclude` function (it was previously passed
        // as `transclude` to directive.link) so we must unwrap it to get
        // its `boundTranscludeFn`
        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
        }

        if (!namespace) {
          namespace = detectNamespaceForChildElements(futureParentElement);
        }
        var $linkNode;
        if (namespace !== 'html') {
          // When using a directive with replace:true and templateUrl the $compileNodes
          // (or a child element inside of them)
          // might change, so we need to recreate the namespace adapted compileNodes
          // for call to the link function.
          // Note: This will already clone the nodes...
          $linkNode = jqLite(
            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
          );
        } else if (cloneConnectFn) {
          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
          // and sometimes changes the structure of the DOM.
          $linkNode = JQLitePrototype.clone.call($compileNodes);
        } else {
          $linkNode = $compileNodes;
        }

        if (transcludeControllers) {
          for (var controllerName in transcludeControllers) {
            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
          }
        }

        compile.$$addScopeInfo($linkNode, scope);

        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);

        if (!cloneConnectFn) {
          $compileNodes = compositeLinkFn = null;
        }
        return $linkNode;
      };
    }

    function detectNamespaceForChildElements(parentElement) {
      // TODO: Make this detect MathML as well...
      var node = parentElement && parentElement[0];
      if (!node) {
        return 'html';
      } else {
        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
      }
    }

    /**
     * Compile function matches each node in nodeList against the directives. Once all directives
     * for a particular node are collected their compile functions are executed. The compile
     * functions return values - the linking functions - are combined into a composite linking
     * function, which is the a linking function for the node.
     *
     * @param {NodeList} nodeList an array of nodes or NodeList to compile
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *        scope argument is auto-generated to the new child of the transcluded parent scope.
     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
     *        the rootElement must be set the jqLite collection of the compile root. This is
     *        needed so that the jqLite collection items can be replaced with widgets.
     * @param {number=} maxPriority Max directive priority.
     * @returns {Function} A composite linking function of all of the matched directives or null.
     */
    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
                            previousCompileContext) {
      var linkFns = [],
          // `nodeList` can be either an element's `.childNodes` (live NodeList)
          // or a jqLite/jQuery collection or an array
          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;


      for (var i = 0; i < nodeList.length; i++) {
        attrs = new Attributes();

        // Support: IE 11 only
        // Workaround for #11781 and #14924
        if (msie === 11) {
          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
        }

        // We must always refer to `nodeList[i]` hereafter,
        // since the nodes can be replaced underneath us.
        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
                                        ignoreDirective);

        nodeLinkFn = (directives.length)
            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
                                      null, [], [], previousCompileContext)
            : null;

        if (nodeLinkFn && nodeLinkFn.scope) {
          compile.$$addScopeClass(attrs.$$element);
        }

        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
                      !(childNodes = nodeList[i].childNodes) ||
                      !childNodes.length)
            ? null
            : compileNodes(childNodes,
                 nodeLinkFn ? (
                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
                     && nodeLinkFn.transclude) : transcludeFn);

        if (nodeLinkFn || childLinkFn) {
          linkFns.push(i, nodeLinkFn, childLinkFn);
          linkFnFound = true;
          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
        }

        //use the previous context only for the first element in the virtual group
        previousCompileContext = null;
      }

      // return a linking function if we have found anything, null otherwise
      return linkFnFound ? compositeLinkFn : null;

      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
        var stableNodeList;


        if (nodeLinkFnFound) {
          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
          // offsets don't get screwed up
          var nodeListLength = nodeList.length;
          stableNodeList = new Array(nodeListLength);

          // create a sparse array by only copying the elements which have a linkFn
          for (i = 0; i < linkFns.length; i += 3) {
            idx = linkFns[i];
            stableNodeList[idx] = nodeList[idx];
          }
        } else {
          stableNodeList = nodeList;
        }

        for (i = 0, ii = linkFns.length; i < ii;) {
          node = stableNodeList[linkFns[i++]];
          nodeLinkFn = linkFns[i++];
          childLinkFn = linkFns[i++];

          if (nodeLinkFn) {
            if (nodeLinkFn.scope) {
              childScope = scope.$new();
              compile.$$addScopeInfo(jqLite(node), childScope);
            } else {
              childScope = scope;
            }

            if (nodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(
                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);

            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
              childBoundTranscludeFn = parentBoundTranscludeFn;

            } else if (!parentBoundTranscludeFn && transcludeFn) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);

            } else {
              childBoundTranscludeFn = null;
            }

            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);

          } else if (childLinkFn) {
            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
          }
        }
      }
    }

    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
      var node = nodeList[idx];
      var parent = node.parentNode;
      var sibling;

      if (node.nodeType !== NODE_TYPE_TEXT) {
        return;
      }

      while (true) {
        sibling = parent ? node.nextSibling : nodeList[idx + 1];
        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
          break;
        }

        node.nodeValue = node.nodeValue + sibling.nodeValue;

        if (sibling.parentNode) {
          sibling.parentNode.removeChild(sibling);
        }
        if (notLiveList && sibling === nodeList[idx + 1]) {
          nodeList.splice(idx + 1, 1);
        }
      }
    }

    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {

        if (!transcludedScope) {
          transcludedScope = scope.$new(false, containingScope);
          transcludedScope.$$transcluded = true;
        }

        return transcludeFn(transcludedScope, cloneFn, {
          parentBoundTranscludeFn: previousBoundTranscludeFn,
          transcludeControllers: controllers,
          futureParentElement: futureParentElement
        });
      }

      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
      // so that they are available inside the `controllersBoundTransclude` function
      var boundSlots = boundTranscludeFn.$$slots = createMap();
      for (var slotName in transcludeFn.$$slots) {
        if (transcludeFn.$$slots[slotName]) {
          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
        } else {
          boundSlots[slotName] = null;
        }
      }

      return boundTranscludeFn;
    }

    /**
     * Looks for directives on the given node and adds them to the directive collection which is
     * sorted.
     *
     * @param node Node to search.
     * @param directives An array to which the directives are added to. This array is sorted before
     *        the function returns.
     * @param attrs The shared attrs object which is used to populate the normalized attributes.
     * @param {number=} maxPriority Max directive priority.
     */
    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      var nodeType = node.nodeType,
          attrsMap = attrs.$attr,
          match,
          nodeName,
          className;

      switch (nodeType) {
        case NODE_TYPE_ELEMENT: /* Element */

          nodeName = nodeName_(node);

          // use the node name: <directive>
          addDirective(directives,
              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);

          // iterate over the attributes
          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
            var attrStartName = false;
            var attrEndName = false;

            attr = nAttrs[j];
            name = attr.name;
            value = attr.value;

            // support ngAttr attribute binding
            ngAttrName = directiveNormalize(name);
            isNgAttr = NG_ATTR_BINDING.test(ngAttrName);
            if (isNgAttr) {
              name = name.replace(PREFIX_REGEXP, '')
                .substr(8).replace(/_(.)/g, function(match, letter) {
                  return letter.toUpperCase();
                });
            }

            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
              attrStartName = name;
              attrEndName = name.substr(0, name.length - 5) + 'end';
              name = name.substr(0, name.length - 6);
            }

            nName = directiveNormalize(name.toLowerCase());
            attrsMap[nName] = name;
            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
                attrs[nName] = value;
                if (getBooleanAttrName(node, nName)) {
                  attrs[nName] = true; // presence means true
                }
            }
            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
                          attrEndName);
          }

          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
            // Hidden input elements can have strange behaviour when navigating back to the page
            // This tells the browser not to try to cache and reinstate previous values
            node.setAttribute('autocomplete', 'off');
          }

          // use class as directive
          if (!cssClassDirectivesEnabled) break;
          className = node.className;
          if (isObject(className)) {
              // Maybe SVGAnimatedString
              className = className.animVal;
          }
          if (isString(className) && className !== '') {
            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
              nName = directiveNormalize(match[2]);
              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
                attrs[nName] = trim(match[3]);
              }
              className = className.substr(match.index + match[0].length);
            }
          }
          break;
        case NODE_TYPE_TEXT: /* Text Node */
          addTextInterpolateDirective(directives, node.nodeValue);
          break;
        case NODE_TYPE_COMMENT: /* Comment */
          if (!commentDirectivesEnabled) break;
          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
          break;
      }

      directives.sort(byPriority);
      return directives;
    }

    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      // function created because of performance, try/catch disables
      // the optimization of the whole function #14848
      try {
        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
        if (match) {
          var nName = directiveNormalize(match[1]);
          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
            attrs[nName] = trim(match[2]);
          }
        }
      } catch (e) {
        // turns out that under some circumstances IE9 throws errors when one attempts to read
        // comment's node value.
        // Just ignore it and continue. (Can't seem to reproduce in test case.)
      }
    }

    /**
     * Given a node with a directive-start it collects all of the siblings until it finds
     * directive-end.
     * @param node
     * @param attrStart
     * @param attrEnd
     * @returns {*}
     */
    function groupScan(node, attrStart, attrEnd) {
      var nodes = [];
      var depth = 0;
      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
        do {
          if (!node) {
            throw $compileMinErr('uterdir',
                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
                      attrStart, attrEnd);
          }
          if (node.nodeType === NODE_TYPE_ELEMENT) {
            if (node.hasAttribute(attrStart)) depth++;
            if (node.hasAttribute(attrEnd)) depth--;
          }
          nodes.push(node);
          node = node.nextSibling;
        } while (depth > 0);
      } else {
        nodes.push(node);
      }

      return jqLite(nodes);
    }

    /**
     * Wrapper for linking function which converts normal linking function into a grouped
     * linking function.
     * @param linkFn
     * @param attrStart
     * @param attrEnd
     * @returns {Function}
     */
    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
        element = groupScan(element[0], attrStart, attrEnd);
        return linkFn(scope, element, attrs, controllers, transcludeFn);
      };
    }

    /**
     * A function generator that is used to support both eager and lazy compilation
     * linking function.
     * @param eager
     * @param $compileNodes
     * @param transcludeFn
     * @param maxPriority
     * @param ignoreDirective
     * @param previousCompileContext
     * @returns {Function}
     */
    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
      var compiled;

      if (eager) {
        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
      }
      return /** @this */ function lazyCompilation() {
        if (!compiled) {
          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);

          // Null out all of these references in order to make them eligible for garbage collection
          // since this is a potentially long lived closure
          $compileNodes = transcludeFn = previousCompileContext = null;
        }
        return compiled.apply(this, arguments);
      };
    }

    /**
     * Once the directives have been collected, their compile functions are executed. This method
     * is responsible for inlining directive templates as well as terminating the application
     * of the directives if the terminal directive has been reached.
     *
     * @param {Array} directives Array of collected directives to execute their compile function.
     *        this needs to be pre-sorted by priority order.
     * @param {Node} compileNode The raw DOM node to apply the compile functions to
     * @param {Object} templateAttrs The shared attribute function
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *                                                  scope argument is auto-generated to the new
     *                                                  child of the transcluded parent scope.
     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
     *                              argument has the root jqLite array so that we can replace nodes
     *                              on it.
     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
     *                                           compiling the transclusion.
     * @param {Array.<Function>} preLinkFns
     * @param {Array.<Function>} postLinkFns
     * @param {Object} previousCompileContext Context used for previous compilation of the current
     *                                        node
     * @returns {Function} linkFn
     */
    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
                                   previousCompileContext) {
      previousCompileContext = previousCompileContext || {};

      var terminalPriority = -Number.MAX_VALUE,
          newScopeDirective = previousCompileContext.newScopeDirective,
          controllerDirectives = previousCompileContext.controllerDirectives,
          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
          templateDirective = previousCompileContext.templateDirective,
          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
          hasTranscludeDirective = false,
          hasTemplate = false,
          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
          $compileNode = templateAttrs.$$element = jqLite(compileNode),
          directive,
          directiveName,
          $template,
          replaceDirective = originalReplaceDirective,
          childTranscludeFn = transcludeFn,
          linkFn,
          didScanForMultipleTransclusion = false,
          mightHaveMultipleTransclusionError = false,
          directiveValue;

      // executes all directives on the current element
      for (var i = 0, ii = directives.length; i < ii; i++) {
        directive = directives[i];
        var attrStart = directive.$$start;
        var attrEnd = directive.$$end;

        // collect multiblock sections
        if (attrStart) {
          $compileNode = groupScan(compileNode, attrStart, attrEnd);
        }
        $template = undefined;

        if (terminalPriority > directive.priority) {
          break; // prevent further processing of directives
        }

        directiveValue = directive.scope;

        if (directiveValue) {

          // skip the check for directives with async templates, we'll check the derived sync
          // directive when the template arrives
          if (!directive.templateUrl) {
            if (isObject(directiveValue)) {
              // This directive is trying to add an isolated scope.
              // Check that there is no scope of any kind already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
                                directive, $compileNode);
              newIsolateScopeDirective = directive;
            } else {
              // This directive is trying to add a child scope.
              // Check that there is no isolated scope already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
                                $compileNode);
            }
          }

          newScopeDirective = newScopeDirective || directive;
        }

        directiveName = directive.name;

        // If we encounter a condition that can result in transclusion on the directive,
        // then scan ahead in the remaining directives for others that may cause a multiple
        // transclusion error to be thrown during the compilation process.  If a matching directive
        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
        // compile the `transclude` function rather than doing it lazily in order to throw
        // exceptions at the correct time
        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
            || (directive.transclude && !directive.$$tlb))) {
                var candidateDirective;

                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
                        mightHaveMultipleTransclusionError = true;
                        break;
                    }
                }

                didScanForMultipleTransclusion = true;
        }

        if (!directive.templateUrl && directive.controller) {
          controllerDirectives = controllerDirectives || createMap();
          assertNoDuplicate('\'' + directiveName + '\' controller',
              controllerDirectives[directiveName], directive, $compileNode);
          controllerDirectives[directiveName] = directive;
        }

        directiveValue = directive.transclude;

        if (directiveValue) {
          hasTranscludeDirective = true;

          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
          // This option should only be used by directives that know how to safely handle element transclusion,
          // where the transcluded nodes are added or replaced after linking.
          if (!directive.$$tlb) {
            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
            nonTlbTranscludeDirective = directive;
          }

          if (directiveValue === 'element') {
            hasElementTranscludeDirective = true;
            terminalPriority = directive.priority;
            $template = $compileNode;
            $compileNode = templateAttrs.$$element =
                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
            compileNode = $compileNode[0];
            replaceWith(jqCollection, sliceArgs($template), compileNode);

            // Support: Chrome < 50
            // https://github.com/angular/angular.js/issues/14041

            // In the versions of V8 prior to Chrome 50, the document fragment that is created
            // in the `replaceWith` function is improperly garbage collected despite still
            // being referenced by the `parentNode` property of all of the child nodes.  By adding
            // a reference to the fragment via a different property, we can avoid that incorrect
            // behavior.
            // TODO: remove this line after Chrome 50 has been released
            $template[0].$$parentNode = $template[0].parentNode;

            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
                                        replaceDirective && replaceDirective.name, {
                                          // Don't pass in:
                                          // - controllerDirectives - otherwise we'll create duplicates controllers
                                          // - newIsolateScopeDirective or templateDirective - combining templates with
                                          //   element transclusion doesn't make sense.
                                          //
                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
                                          // on the same element more than once.
                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
                                        });
          } else {

            var slots = createMap();

            if (!isObject(directiveValue)) {
              $template = jqLite(jqLiteClone(compileNode)).contents();
            } else {

              // We have transclusion slots,
              // collect them up, compile them and store their transclusion functions
              $template = [];

              var slotMap = createMap();
              var filledSlots = createMap();

              // Parse the element selectors
              forEach(directiveValue, function(elementSelector, slotName) {
                // If an element selector starts with a ? then it is optional
                var optional = (elementSelector.charAt(0) === '?');
                elementSelector = optional ? elementSelector.substring(1) : elementSelector;

                slotMap[elementSelector] = slotName;

                // We explicitly assign `null` since this implies that a slot was defined but not filled.
                // Later when calling boundTransclusion functions with a slot name we only error if the
                // slot is `undefined`
                slots[slotName] = null;

                // filledSlots contains `true` for all slots that are either optional or have been
                // filled. This is used to check that we have not missed any required slots
                filledSlots[slotName] = optional;
              });

              // Add the matching elements into their slot
              forEach($compileNode.contents(), function(node) {
                var slotName = slotMap[directiveNormalize(nodeName_(node))];
                if (slotName) {
                  filledSlots[slotName] = true;
                  slots[slotName] = slots[slotName] || [];
                  slots[slotName].push(node);
                } else {
                  $template.push(node);
                }
              });

              // Check for required slots that were not filled
              forEach(filledSlots, function(filled, slotName) {
                if (!filled) {
                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
                }
              });

              for (var slotName in slots) {
                if (slots[slotName]) {
                  // Only define a transclusion function if the slot was filled
                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
                }
              }
            }

            $compileNode.empty(); // clear contents
            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
            childTranscludeFn.$$slots = slots;
          }
        }

        if (directive.template) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          directiveValue = (isFunction(directive.template))
              ? directive.template($compileNode, templateAttrs)
              : directive.template;

          directiveValue = denormalizeTemplate(directiveValue);

          if (directive.replace) {
            replaceDirective = directive;
            if (jqLiteIsTextNode(directiveValue)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
            }
            compileNode = $template[0];

            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  'Template for directive \'{0}\' must have exactly one root element. {1}',
                  directiveName, '');
            }

            replaceWith(jqCollection, $compileNode, compileNode);

            var newTemplateAttrs = {$attr: {}};

            // combine directives from the original node and from the template:
            // - take the array of directives for this element
            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
            // - collect directives from the template and sort them by priority
            // - combine directives as: processed + template + unprocessed
            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));

            if (newIsolateScopeDirective || newScopeDirective) {
              // The original directive caused the current element to be replaced but this element
              // also needs to have a new scope, so we need to tell the template directives
              // that they would need to get their scope from further up, if they require transclusion
              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
            }
            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);

            ii = directives.length;
          } else {
            $compileNode.html(directiveValue);
          }
        }

        if (directive.templateUrl) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          if (directive.replace) {
            replaceDirective = directive;
          }

          // eslint-disable-next-line no-func-assign
          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
                controllerDirectives: controllerDirectives,
                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
                newIsolateScopeDirective: newIsolateScopeDirective,
                templateDirective: templateDirective,
                nonTlbTranscludeDirective: nonTlbTranscludeDirective
              });
          ii = directives.length;
        } else if (directive.compile) {
          try {
            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
            var context = directive.$$originalDirective || directive;
            if (isFunction(linkFn)) {
              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
            } else if (linkFn) {
              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
            }
          } catch (e) {
            $exceptionHandler(e, startingTag($compileNode));
          }
        }

        if (directive.terminal) {
          nodeLinkFn.terminal = true;
          terminalPriority = Math.max(terminalPriority, directive.priority);
        }

      }

      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
      nodeLinkFn.templateOnThisElement = hasTemplate;
      nodeLinkFn.transclude = childTranscludeFn;

      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;

      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
      return nodeLinkFn;

      ////////////////////

      function addLinkFns(pre, post, attrStart, attrEnd) {
        if (pre) {
          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
          pre.require = directive.require;
          pre.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
          }
          preLinkFns.push(pre);
        }
        if (post) {
          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
          post.require = directive.require;
          post.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            post = cloneAndAnnotateFn(post, {isolateScope: true});
          }
          postLinkFns.push(post);
        }
      }

      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
            attrs, scopeBindingInfo;

        if (compileNode === linkNode) {
          attrs = templateAttrs;
          $element = templateAttrs.$$element;
        } else {
          $element = jqLite(linkNode);
          attrs = new Attributes($element, templateAttrs);
        }

        controllerScope = scope;
        if (newIsolateScopeDirective) {
          isolateScope = scope.$new(true);
        } else if (newScopeDirective) {
          controllerScope = scope.$parent;
        }

        if (boundTranscludeFn) {
          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
          transcludeFn = controllersBoundTransclude;
          transcludeFn.$$boundTransclude = boundTranscludeFn;
          // expose the slots on the `$transclude` function
          transcludeFn.isSlotFilled = function(slotName) {
            return !!boundTranscludeFn.$$slots[slotName];
          };
        }

        if (controllerDirectives) {
          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
        }

        if (newIsolateScopeDirective) {
          // Initialize isolate scope bindings for new isolate scope directive.
          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
              templateDirective === newIsolateScopeDirective.$$originalDirective)));
          compile.$$addScopeClass($element, true);
          isolateScope.$$isolateBindings =
              newIsolateScopeDirective.$$isolateBindings;
          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
                                        isolateScope.$$isolateBindings,
                                        newIsolateScopeDirective);
          if (scopeBindingInfo.removeWatches) {
            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
          }
        }

        // Initialize bindToController bindings
        for (var name in elementControllers) {
          var controllerDirective = controllerDirectives[name];
          var controller = elementControllers[name];
          var bindings = controllerDirective.$$bindings.bindToController;

          if (preAssignBindingsEnabled) {
            if (bindings) {
              controller.bindingInfo =
                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
            } else {
              controller.bindingInfo = {};
            }

            var controllerResult = controller();
            if (controllerResult !== controller.instance) {
              // If the controller constructor has a return value, overwrite the instance
              // from setupControllers
              controller.instance = controllerResult;
              $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
              if (controller.bindingInfo.removeWatches) {
                controller.bindingInfo.removeWatches();
              }
              controller.bindingInfo =
                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
            }
          } else {
            controller.instance = controller();
            $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
            controller.bindingInfo =
              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
          }
        }

        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
        forEach(controllerDirectives, function(controllerDirective, name) {
          var require = controllerDirective.require;
          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
          }
        });

        // Handle the init and destroy lifecycle hooks on all controllers that have them
        forEach(elementControllers, function(controller) {
          var controllerInstance = controller.instance;
          if (isFunction(controllerInstance.$onChanges)) {
            try {
              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          if (isFunction(controllerInstance.$onInit)) {
            try {
              controllerInstance.$onInit();
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          if (isFunction(controllerInstance.$doCheck)) {
            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
            controllerInstance.$doCheck();
          }
          if (isFunction(controllerInstance.$onDestroy)) {
            controllerScope.$on('$destroy', function callOnDestroyHook() {
              controllerInstance.$onDestroy();
            });
          }
        });

        // PRELINKING
        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
          linkFn = preLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // RECURSION
        // We only pass the isolate scope, if the isolate directive has a template,
        // otherwise the child elements do not belong to the isolate directive.
        var scopeToChild = scope;
        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
          scopeToChild = isolateScope;
        }
        if (childLinkFn) {
          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
        }

        // POSTLINKING
        for (i = postLinkFns.length - 1; i >= 0; i--) {
          linkFn = postLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // Trigger $postLink lifecycle hooks
        forEach(elementControllers, function(controller) {
          var controllerInstance = controller.instance;
          if (isFunction(controllerInstance.$postLink)) {
            controllerInstance.$postLink();
          }
        });

        // This is the function that is injected as `$transclude`.
        // Note: all arguments are optional!
        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
          var transcludeControllers;
          // No scope passed in:
          if (!isScope(scope)) {
            slotName = futureParentElement;
            futureParentElement = cloneAttachFn;
            cloneAttachFn = scope;
            scope = undefined;
          }

          if (hasElementTranscludeDirective) {
            transcludeControllers = elementControllers;
          }
          if (!futureParentElement) {
            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
          }
          if (slotName) {
            // slotTranscludeFn can be one of three things:
            //  * a transclude function - a filled slot
            //  * `null` - an optional slot that was not filled
            //  * `undefined` - a slot that was not declared (i.e. invalid)
            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
            if (slotTranscludeFn) {
              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
            } else if (isUndefined(slotTranscludeFn)) {
              throw $compileMinErr('noslot',
               'No parent directive that requires a transclusion with slot name "{0}". ' +
               'Element: {1}',
               slotName, startingTag($element));
            }
          } else {
            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
          }
        }
      }
    }

    function getControllers(directiveName, require, $element, elementControllers) {
      var value;

      if (isString(require)) {
        var match = require.match(REQUIRE_PREFIX_REGEXP);
        var name = require.substring(match[0].length);
        var inheritType = match[1] || match[3];
        var optional = match[2] === '?';

        //If only parents then start at the parent element
        if (inheritType === '^^') {
          $element = $element.parent();
        //Otherwise attempt getting the controller from elementControllers in case
        //the element is transcluded (and has no data) and to avoid .data if possible
        } else {
          value = elementControllers && elementControllers[name];
          value = value && value.instance;
        }

        if (!value) {
          var dataName = '$' + name + 'Controller';
          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
        }

        if (!value && !optional) {
          throw $compileMinErr('ctreq',
              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
              name, directiveName);
        }
      } else if (isArray(require)) {
        value = [];
        for (var i = 0, ii = require.length; i < ii; i++) {
          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
        }
      } else if (isObject(require)) {
        value = {};
        forEach(require, function(controller, property) {
          value[property] = getControllers(directiveName, controller, $element, elementControllers);
        });
      }

      return value || null;
    }

    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
      var elementControllers = createMap();
      for (var controllerKey in controllerDirectives) {
        var directive = controllerDirectives[controllerKey];
        var locals = {
          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
          $element: $element,
          $attrs: attrs,
          $transclude: transcludeFn
        };

        var controller = directive.controller;
        if (controller === '@') {
          controller = attrs[directive.name];
        }

        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);

        // For directives with element transclusion the element is a comment.
        // In this case .data will not attach any data.
        // Instead, we save the controllers for the element in a local hash and attach to .data
        // later, once we have the actual element.
        elementControllers[directive.name] = controllerInstance;
        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
      }
      return elementControllers;
    }

    // Depending upon the context in which a directive finds itself it might need to have a new isolated
    // or child scope created. For instance:
    // * if the directive has been pulled into a template because another directive with a higher priority
    // asked for element transclusion
    // * if the directive itself asks for transclusion but it is at the root of a template and the original
    // element was replaced. See https://github.com/angular/angular.js/issues/12936
    function markDirectiveScope(directives, isolateScope, newScope) {
      for (var j = 0, jj = directives.length; j < jj; j++) {
        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
      }
    }

    /**
     * looks up the directive and decorates it with exception handling and proper parameters. We
     * call this the boundDirective.
     *
     * @param {string} name name of the directive to look up.
     * @param {string} location The directive must be found in specific format.
     *   String containing any of theses characters:
     *
     *   * `E`: element name
     *   * `A': attribute
     *   * `C`: class
     *   * `M`: comment
     * @returns {boolean} true if directive was added.
     */
    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
                          endAttrName) {
      if (name === ignoreDirective) return null;
      var match = null;
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
               directive.restrict.indexOf(location) !== -1) {
            if (startAttrName) {
              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
            }
            if (!directive.$$bindings) {
              var bindings = directive.$$bindings =
                  parseDirectiveBindings(directive, directive.name);
              if (isObject(bindings.isolateScope)) {
                directive.$$isolateBindings = bindings.isolateScope;
              }
            }
            tDirectives.push(directive);
            match = directive;
          }
        }
      }
      return match;
    }


    /**
     * looks up the directive and returns true if it is a multi-element directive,
     * and therefore requires DOM nodes between -start and -end markers to be grouped
     * together.
     *
     * @param {string} name name of the directive to look up.
     * @returns true if directive was registered as multi-element.
     */
    function directiveIsMultiElement(name) {
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          if (directive.multiElement) {
            return true;
          }
        }
      }
      return false;
    }

    /**
     * When the element is replaced with HTML template then the new attributes
     * on the template need to be merged with the existing attributes in the DOM.
     * The desired effect is to have both of the attributes present.
     *
     * @param {object} dst destination attributes (original DOM)
     * @param {object} src source attributes (from the directive template)
     */
    function mergeTemplateAttributes(dst, src) {
      var srcAttr = src.$attr,
          dstAttr = dst.$attr;

      // reapply the old attributes to the new element
      forEach(dst, function(value, key) {
        if (key.charAt(0) !== '$') {
          if (src[key] && src[key] !== value) {
            if (value.length) {
              value += (key === 'style' ? ';' : ' ') + src[key];
            } else {
              value = src[key];
            }
          }
          dst.$set(key, value, true, srcAttr[key]);
        }
      });

      // copy the new attributes on the old attrs object
      forEach(src, function(value, key) {
        // Check if we already set this attribute in the loop above.
        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
        // have an attribute like "has-own-property" or "data-has-own-property", etc.
        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
          dst[key] = value;

          if (key !== 'class' && key !== 'style') {
            dstAttr[key] = srcAttr[key];
          }
        }
      });
    }


    function compileTemplateUrl(directives, $compileNode, tAttrs,
        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
      var linkQueue = [],
          afterTemplateNodeLinkFn,
          afterTemplateChildLinkFn,
          beforeTemplateCompileNode = $compileNode[0],
          origAsyncDirective = directives.shift(),
          derivedSyncDirective = inherit(origAsyncDirective, {
            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
          }),
          templateUrl = (isFunction(origAsyncDirective.templateUrl))
              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
              : origAsyncDirective.templateUrl,
          templateNamespace = origAsyncDirective.templateNamespace;

      $compileNode.empty();

      $templateRequest(templateUrl)
        .then(function(content) {
          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;

          content = denormalizeTemplate(content);

          if (origAsyncDirective.replace) {
            if (jqLiteIsTextNode(content)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
            }
            compileNode = $template[0];

            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  'Template for directive \'{0}\' must have exactly one root element. {1}',
                  origAsyncDirective.name, templateUrl);
            }

            tempTemplateAttrs = {$attr: {}};
            replaceWith($rootElement, $compileNode, compileNode);
            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);

            if (isObject(origAsyncDirective.scope)) {
              // the original directive that caused the template to be loaded async required
              // an isolate scope
              markDirectiveScope(templateDirectives, true);
            }
            directives = templateDirectives.concat(directives);
            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
          } else {
            compileNode = beforeTemplateCompileNode;
            $compileNode.html(content);
          }

          directives.unshift(derivedSyncDirective);

          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
              previousCompileContext);
          forEach($rootElement, function(node, i) {
            if (node === compileNode) {
              $rootElement[i] = $compileNode[0];
            }
          });
          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);

          while (linkQueue.length) {
            var scope = linkQueue.shift(),
                beforeTemplateLinkNode = linkQueue.shift(),
                linkRootElement = linkQueue.shift(),
                boundTranscludeFn = linkQueue.shift(),
                linkNode = $compileNode[0];

            if (scope.$$destroyed) continue;

            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
              var oldClasses = beforeTemplateLinkNode.className;

              if (!(previousCompileContext.hasElementTranscludeDirective &&
                  origAsyncDirective.replace)) {
                // it was cloned therefore we have to clone as well.
                linkNode = jqLiteClone(compileNode);
              }
              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);

              // Copy in CSS classes from original node
              safeAddClass(jqLite(linkNode), oldClasses);
            }
            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
            } else {
              childBoundTranscludeFn = boundTranscludeFn;
            }
            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
              childBoundTranscludeFn);
          }
          linkQueue = null;
        }).catch(function(error) {
          if (error instanceof Error) {
            $exceptionHandler(error);
          }
        }).catch(noop);

      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
        var childBoundTranscludeFn = boundTranscludeFn;
        if (scope.$$destroyed) return;
        if (linkQueue) {
          linkQueue.push(scope,
                         node,
                         rootElement,
                         childBoundTranscludeFn);
        } else {
          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
          }
          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
        }
      };
    }


    /**
     * Sorting function for bound directives.
     */
    function byPriority(a, b) {
      var diff = b.priority - a.priority;
      if (diff !== 0) return diff;
      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
      return a.index - b.index;
    }

    function assertNoDuplicate(what, previousDirective, directive, element) {

      function wrapModuleNameIfDefined(moduleName) {
        return moduleName ?
          (' (module: ' + moduleName + ')') :
          '';
      }

      if (previousDirective) {
        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
      }
    }


    function addTextInterpolateDirective(directives, text) {
      var interpolateFn = $interpolate(text, true);
      if (interpolateFn) {
        directives.push({
          priority: 0,
          compile: function textInterpolateCompileFn(templateNode) {
            var templateNodeParent = templateNode.parent(),
                hasCompileParent = !!templateNodeParent.length;

            // When transcluding a template that has bindings in the root
            // we don't have a parent and thus need to add the class during linking fn.
            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);

            return function textInterpolateLinkFn(scope, node) {
              var parent = node.parent();
              if (!hasCompileParent) compile.$$addBindingClass(parent);
              compile.$$addBindingInfo(parent, interpolateFn.expressions);
              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
                node[0].nodeValue = value;
              });
            };
          }
        });
      }
    }


    function wrapTemplate(type, template) {
      type = lowercase(type || 'html');
      switch (type) {
      case 'svg':
      case 'math':
        var wrapper = window.document.createElement('div');
        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
        return wrapper.childNodes[0].childNodes;
      default:
        return template;
      }
    }


    function getTrustedContext(node, attrNormalizedName) {
      if (attrNormalizedName === 'srcdoc') {
        return $sce.HTML;
      }
      var tag = nodeName_(node);
      // All tags with src attributes require a RESOURCE_URL value, except for
      // img and various html5 media tags.
      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
        if (['img', 'video', 'audio', 'source', 'track'].indexOf(tag) === -1) {
          return $sce.RESOURCE_URL;
        }
      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
      } else if (attrNormalizedName === 'xlinkHref' ||
          (tag === 'form' && attrNormalizedName === 'action') ||
          // links can be stylesheets or imports, which can run script in the current origin
          (tag === 'link' && attrNormalizedName === 'href')
      ) {
        return $sce.RESOURCE_URL;
      }
    }


    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
      var trustedContext = getTrustedContext(node, name);
      var mustHaveExpression = !isNgAttr;
      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;

      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);

      // no interpolation found -> ignore
      if (!interpolateFn) return;

      if (name === 'multiple' && nodeName_(node) === 'select') {
        throw $compileMinErr('selmulti',
            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
            startingTag(node));
      }

      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
        throw $compileMinErr('nodomevents',
            'Interpolations for HTML DOM event attributes are disallowed.  Please use the ' +
                'ng- versions (such as ng-click instead of onclick) instead.');
      }

      directives.push({
        priority: 100,
        compile: function() {
            return {
              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));

                // If the attribute has changed since last $interpolate()ed
                var newValue = attr[name];
                if (newValue !== value) {
                  // we need to interpolate again since the attribute value has been updated
                  // (e.g. by another directive's compile function)
                  // ensure unset/empty values make interpolateFn falsy
                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
                  value = newValue;
                }

                // if attribute was updated so that there is no interpolation going on we don't want to
                // register any observers
                if (!interpolateFn) return;

                // initialize attr object so that it's ready in case we need the value for isolate
                // scope initialization, otherwise the value would not be available from isolate
                // directive's linking fn during linking phase
                attr[name] = interpolateFn(scope);

                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
                (attr.$$observers && attr.$$observers[name].$$scope || scope).
                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
                    //special case for class attribute addition + removal
                    //so that class changes can tap into the animation
                    //hooks provided by the $animate service. Be sure to
                    //skip animations when the first digest occurs (when
                    //both the new and the old values are the same) since
                    //the CSS classes are the non-interpolated values
                    if (name === 'class' && newValue !== oldValue) {
                      attr.$updateClass(newValue, oldValue);
                    } else {
                      attr.$set(name, newValue);
                    }
                  });
              }
            };
          }
      });
    }


    /**
     * This is a special jqLite.replaceWith, which can replace items which
     * have no parents, provided that the containing jqLite collection is provided.
     *
     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
     *                               in the root of the tree.
     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
     *                                  the shell, but replace its DOM node reference.
     * @param {Node} newNode The new DOM node.
     */
    function replaceWith($rootElement, elementsToRemove, newNode) {
      var firstElementToRemove = elementsToRemove[0],
          removeCount = elementsToRemove.length,
          parent = firstElementToRemove.parentNode,
          i, ii;

      if ($rootElement) {
        for (i = 0, ii = $rootElement.length; i < ii; i++) {
          if ($rootElement[i] === firstElementToRemove) {
            $rootElement[i++] = newNode;
            for (var j = i, j2 = j + removeCount - 1,
                     jj = $rootElement.length;
                 j < jj; j++, j2++) {
              if (j2 < jj) {
                $rootElement[j] = $rootElement[j2];
              } else {
                delete $rootElement[j];
              }
            }
            $rootElement.length -= removeCount - 1;

            // If the replaced element is also the jQuery .context then replace it
            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
            // http://api.jquery.com/context/
            if ($rootElement.context === firstElementToRemove) {
              $rootElement.context = newNode;
            }
            break;
          }
        }
      }

      if (parent) {
        parent.replaceChild(newNode, firstElementToRemove);
      }

      // Append all the `elementsToRemove` to a fragment. This will...
      // - remove them from the DOM
      // - allow them to still be traversed with .nextSibling
      // - allow a single fragment.qSA to fetch all elements being removed
      var fragment = window.document.createDocumentFragment();
      for (i = 0; i < removeCount; i++) {
        fragment.appendChild(elementsToRemove[i]);
      }

      if (jqLite.hasData(firstElementToRemove)) {
        // Copy over user data (that includes Angular's $scope etc.). Don't copy private
        // data here because there's no public interface in jQuery to do that and copying over
        // event listeners (which is the main use of private data) wouldn't work anyway.
        jqLite.data(newNode, jqLite.data(firstElementToRemove));

        // Remove $destroy event listeners from `firstElementToRemove`
        jqLite(firstElementToRemove).off('$destroy');
      }

      // Cleanup any data/listeners on the elements and children.
      // This includes invoking the $destroy event on any elements with listeners.
      jqLite.cleanData(fragment.querySelectorAll('*'));

      // Update the jqLite collection to only contain the `newNode`
      for (i = 1; i < removeCount; i++) {
        delete elementsToRemove[i];
      }
      elementsToRemove[0] = newNode;
      elementsToRemove.length = 1;
    }


    function cloneAndAnnotateFn(fn, annotation) {
      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
    }


    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
      try {
        linkFn(scope, $element, attrs, controllers, transcludeFn);
      } catch (e) {
        $exceptionHandler(e, startingTag($element));
      }
    }


    // Set up $watches for isolate scope and controller bindings.
    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
      var removeWatchCollection = [];
      var initialChanges = {};
      var changes;
      forEach(bindings, function initializeBinding(definition, scopeName) {
        var attrName = definition.attrName,
        optional = definition.optional,
        mode = definition.mode, // @, =, <, or &
        lastValue,
        parentGet, parentSet, compare, removeWatch;

        switch (mode) {

          case '@':
            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
              destination[scopeName] = attrs[attrName] = undefined;
            }
            removeWatch = attrs.$observe(attrName, function(value) {
              if (isString(value) || isBoolean(value)) {
                var oldValue = destination[scopeName];
                recordChanges(scopeName, value, oldValue);
                destination[scopeName] = value;
              }
            });
            attrs.$$observers[attrName].$$scope = scope;
            lastValue = attrs[attrName];
            if (isString(lastValue)) {
              // If the attribute has been provided then we trigger an interpolation to ensure
              // the value is there for use in the link fn
              destination[scopeName] = $interpolate(lastValue)(scope);
            } else if (isBoolean(lastValue)) {
              // If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
              // the value to boolean rather than a string, so we special case this situation
              destination[scopeName] = lastValue;
            }
            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
            removeWatchCollection.push(removeWatch);
            break;

          case '=':
            if (!hasOwnProperty.call(attrs, attrName)) {
              if (optional) break;
              attrs[attrName] = undefined;
            }
            if (optional && !attrs[attrName]) break;

            parentGet = $parse(attrs[attrName]);
            if (parentGet.literal) {
              compare = equals;
            } else {
              // eslint-disable-next-line no-self-compare
              compare = function simpleCompare(a, b) { return a === b || (a !== a && b !== b); };
            }
            parentSet = parentGet.assign || function() {
              // reset the change, or we will throw this exception on every $digest
              lastValue = destination[scopeName] = parentGet(scope);
              throw $compileMinErr('nonassign',
                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
                  attrs[attrName], attrName, directive.name);
            };
            lastValue = destination[scopeName] = parentGet(scope);
            var parentValueWatch = function parentValueWatch(parentValue) {
              if (!compare(parentValue, destination[scopeName])) {
                // we are out of sync and need to copy
                if (!compare(parentValue, lastValue)) {
                  // parent changed and it has precedence
                  destination[scopeName] = parentValue;
                } else {
                  // if the parent can be assigned then do so
                  parentSet(scope, parentValue = destination[scopeName]);
                }
              }
              lastValue = parentValue;
              return lastValue;
            };
            parentValueWatch.$stateful = true;
            if (definition.collection) {
              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
            } else {
              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
            }
            removeWatchCollection.push(removeWatch);
            break;

          case '<':
            if (!hasOwnProperty.call(attrs, attrName)) {
              if (optional) break;
              attrs[attrName] = undefined;
            }
            if (optional && !attrs[attrName]) break;

            parentGet = $parse(attrs[attrName]);
            var deepWatch = parentGet.literal;

            var initialValue = destination[scopeName] = parentGet(scope);
            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);

            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
              if (oldValue === newValue) {
                if (oldValue === initialValue || (deepWatch && equals(oldValue, initialValue))) {
                  return;
                }
                oldValue = initialValue;
              }
              recordChanges(scopeName, newValue, oldValue);
              destination[scopeName] = newValue;
            }, deepWatch);

            removeWatchCollection.push(removeWatch);
            break;

          case '&':
            // Don't assign Object.prototype method to scope
            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;

            // Don't assign noop to destination if expression is not valid
            if (parentGet === noop && optional) break;

            destination[scopeName] = function(locals) {
              return parentGet(scope, locals);
            };
            break;
        }
      });

      function recordChanges(key, currentValue, previousValue) {
        if (isFunction(destination.$onChanges) && currentValue !== previousValue &&
            // eslint-disable-next-line no-self-compare
            (currentValue === currentValue || previousValue === previousValue)) {
          // If we have not already scheduled the top level onChangesQueue handler then do so now
          if (!onChangesQueue) {
            scope.$$postDigest(flushOnChangesQueue);
            onChangesQueue = [];
          }
          // If we have not already queued a trigger of onChanges for this controller then do so now
          if (!changes) {
            changes = {};
            onChangesQueue.push(triggerOnChangesHook);
          }
          // If the has been a change on this property already then we need to reuse the previous value
          if (changes[key]) {
            previousValue = changes[key].previousValue;
          }
          // Store this change
          changes[key] = new SimpleChange(previousValue, currentValue);
        }
      }

      function triggerOnChangesHook() {
        destination.$onChanges(changes);
        // Now clear the changes so that we schedule onChanges when more changes arrive
        changes = undefined;
      }

      return {
        initialChanges: initialChanges,
        removeWatches: removeWatchCollection.length && function removeWatches() {
          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
            removeWatchCollection[i]();
          }
        }
      };
    }
  }];
}

function SimpleChange(previous, current) {
  this.previousValue = previous;
  this.currentValue = current;
}
SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };


var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;

/**
 * Converts all accepted directives format into proper directive name.
 * @param name Name to normalize
 */
function directiveNormalize(name) {
  return name
    .replace(PREFIX_REGEXP, '')
    .replace(SPECIAL_CHARS_REGEXP, fnCamelCaseReplace);
}

/**
 * @ngdoc type
 * @name $compile.directive.Attributes
 *
 * @description
 * A shared object between directive compile / linking functions which contains normalized DOM
 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
 * needed since all of these are treated as equivalent in Angular:
 *
 * ```
 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
 * ```
 */

/**
 * @ngdoc property
 * @name $compile.directive.Attributes#$attr
 *
 * @description
 * A map of DOM element attribute names to the normalized name. This is
 * needed to do reverse lookup from normalized name back to actual name.
 */


/**
 * @ngdoc method
 * @name $compile.directive.Attributes#$set
 * @kind function
 *
 * @description
 * Set DOM element attribute value.
 *
 *
 * @param {string} name Normalized element attribute name of the property to modify. The name is
 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
 *          property to the original name.
 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
 */



/**
 * Closure compiler type information
 */

function nodesetLinkingFn(
  /* angular.Scope */ scope,
  /* NodeList */ nodeList,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function directiveLinkingFn(
  /* nodesetLinkingFn */ nodesetLinkingFn,
  /* angular.Scope */ scope,
  /* Node */ node,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function tokenDifference(str1, str2) {
  var values = '',
      tokens1 = str1.split(/\s+/),
      tokens2 = str2.split(/\s+/);

  outer:
  for (var i = 0; i < tokens1.length; i++) {
    var token = tokens1[i];
    for (var j = 0; j < tokens2.length; j++) {
      if (token === tokens2[j]) continue outer;
    }
    values += (values.length > 0 ? ' ' : '') + token;
  }
  return values;
}

function removeComments(jqNodes) {
  jqNodes = jqLite(jqNodes);
  var i = jqNodes.length;

  if (i <= 1) {
    return jqNodes;
  }

  while (i--) {
    var node = jqNodes[i];
    if (node.nodeType === NODE_TYPE_COMMENT ||
       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
         splice.call(jqNodes, i, 1);
    }
  }
  return jqNodes;
}

var $controllerMinErr = minErr('$controller');


var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
function identifierForController(controller, ident) {
  if (ident && isString(ident)) return ident;
  if (isString(controller)) {
    var match = CNTRL_REG.exec(controller);
    if (match) return match[3];
  }
}


/**
 * @ngdoc provider
 * @name $controllerProvider
 * @this
 *
 * @description
 * The {@link ng.$controller $controller service} is used by Angular to create new
 * controllers.
 *
 * This provider allows controller registration via the
 * {@link ng.$controllerProvider#register register} method.
 */
function $ControllerProvider() {
  var controllers = {},
      globals = false;

  /**
   * @ngdoc method
   * @name $controllerProvider#has
   * @param {string} name Controller name to check.
   */
  this.has = function(name) {
    return controllers.hasOwnProperty(name);
  };

  /**
   * @ngdoc method
   * @name $controllerProvider#register
   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
   *    the names and the values are the constructors.
   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
   *    annotations in the array notation).
   */
  this.register = function(name, constructor) {
    assertNotHasOwnProperty(name, 'controller');
    if (isObject(name)) {
      extend(controllers, name);
    } else {
      controllers[name] = constructor;
    }
  };

  /**
   * @ngdoc method
   * @name $controllerProvider#allowGlobals
   * @description If called, allows `$controller` to find controller constructors on `window`
   *
   * @deprecated
   * sinceVersion="v1.3.0"
   * removeVersion="v1.7.0"
   * This method of finding controllers has been deprecated.
   */
  this.allowGlobals = function() {
    globals = true;
  };


  this.$get = ['$injector', '$window', function($injector, $window) {

    /**
     * @ngdoc service
     * @name $controller
     * @requires $injector
     *
     * @param {Function|string} constructor If called with a function then it's considered to be the
     *    controller constructor function. Otherwise it's considered to be a string which is used
     *    to retrieve the controller constructor using the following steps:
     *
     *    * check if a controller with given name is registered via `$controllerProvider`
     *    * check if evaluating the string on the current scope returns a constructor
     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
     *      `window` object (deprecated, not recommended)
     *
     *    The string can use the `controller as property` syntax, where the controller instance is published
     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
     *    to work correctly.
     *
     * @param {Object} locals Injection locals for Controller.
     * @return {Object} Instance of given controller.
     *
     * @description
     * `$controller` service is responsible for instantiating controllers.
     *
     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
     */
    return function $controller(expression, locals, later, ident) {
      // PRIVATE API:
      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
      //                     If true, $controller will allocate the object with the correct
      //                     prototype chain, but will not invoke the controller until a returned
      //                     callback is invoked.
      //   param `ident` --- An optional label which overrides the label parsed from the controller
      //                     expression, if any.
      var instance, match, constructor, identifier;
      later = later === true;
      if (ident && isString(ident)) {
        identifier = ident;
      }

      if (isString(expression)) {
        match = expression.match(CNTRL_REG);
        if (!match) {
          throw $controllerMinErr('ctrlfmt',
            'Badly formed controller string \'{0}\'. ' +
            'Must match `__name__ as __id__` or `__name__`.', expression);
        }
        constructor = match[1];
        identifier = identifier || match[3];
        expression = controllers.hasOwnProperty(constructor)
            ? controllers[constructor]
            : getter(locals.$scope, constructor, true) ||
                (globals ? getter($window, constructor, true) : undefined);

        if (!expression) {
          throw $controllerMinErr('ctrlreg',
            'The controller with the name \'{0}\' is not registered.', constructor);
        }

        assertArgFn(expression, constructor, true);
      }

      if (later) {
        // Instantiate controller later:
        // This machinery is used to create an instance of the object before calling the
        // controller's constructor itself.
        //
        // This allows properties to be added to the controller before the constructor is
        // invoked. Primarily, this is used for isolate scope bindings in $compile.
        //
        // This feature is not intended for use by applications, and is thus not documented
        // publicly.
        // Object creation: http://jsperf.com/create-constructor/2
        var controllerPrototype = (isArray(expression) ?
          expression[expression.length - 1] : expression).prototype;
        instance = Object.create(controllerPrototype || null);

        if (identifier) {
          addIdentifier(locals, identifier, instance, constructor || expression.name);
        }

        return extend(function $controllerInit() {
          var result = $injector.invoke(expression, instance, locals, constructor);
          if (result !== instance && (isObject(result) || isFunction(result))) {
            instance = result;
            if (identifier) {
              // If result changed, re-assign controllerAs value to scope.
              addIdentifier(locals, identifier, instance, constructor || expression.name);
            }
          }
          return instance;
        }, {
          instance: instance,
          identifier: identifier
        });
      }

      instance = $injector.instantiate(expression, locals, constructor);

      if (identifier) {
        addIdentifier(locals, identifier, instance, constructor || expression.name);
      }

      return instance;
    };

    function addIdentifier(locals, identifier, instance, name) {
      if (!(locals && isObject(locals.$scope))) {
        throw minErr('$controller')('noscp',
          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
          name, identifier);
      }

      locals.$scope[identifier] = instance;
    }
  }];
}

/**
 * @ngdoc service
 * @name $document
 * @requires $window
 * @this
 *
 * @description
 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
 *
 * @example
   <example module="documentExample" name="document">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <p>$document title: <b ng-bind="title"></b></p>
         <p>window.document title: <b ng-bind="windowTitle"></b></p>
       </div>
     </file>
     <file name="script.js">
       angular.module('documentExample', [])
         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
           $scope.title = $document[0].title;
           $scope.windowTitle = angular.element(window.document)[0].title;
         }]);
     </file>
   </example>
 */
function $DocumentProvider() {
  this.$get = ['$window', function(window) {
    return jqLite(window.document);
  }];
}


/**
 * @private
 * @this
 * Listens for document visibility change and makes the current status accessible.
 */
function $$IsDocumentHiddenProvider() {
  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
    var doc = $document[0];
    var hidden = doc && doc.hidden;

    $document.on('visibilitychange', changeListener);

    $rootScope.$on('$destroy', function() {
      $document.off('visibilitychange', changeListener);
    });

    function changeListener() {
      hidden = doc.hidden;
    }

    return function() {
      return hidden;
    };
  }];
}

/**
 * @ngdoc service
 * @name $exceptionHandler
 * @requires ng.$log
 * @this
 *
 * @description
 * Any uncaught exception in angular expressions is delegated to this service.
 * The default implementation simply delegates to `$log.error` which logs it into
 * the browser console.
 *
 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
 *
 * ## Example:
 *
 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
 * of `$log.error()`.
 *
 * ```js
 *   angular.
 *     module('exceptionOverwrite', []).
 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
 *       return function myExceptionHandler(exception, cause) {
 *         logErrorsToBackend(exception, cause);
 *         $log.warn(exception, cause);
 *       };
 *     }]);
 * ```
 *
 * <hr />
 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
 * (unless executed during a digest).
 *
 * If you wish, you can manually delegate exceptions, e.g.
 * `try { ... } catch(e) { $exceptionHandler(e); }`
 *
 * @param {Error} exception Exception associated with the error.
 * @param {string=} cause Optional information about the context in which
 *       the error was thrown.
 *
 */
function $ExceptionHandlerProvider() {
  this.$get = ['$log', function($log) {
    return function(exception, cause) {
      $log.error.apply($log, arguments);
    };
  }];
}

var $$ForceReflowProvider = /** @this */ function() {
  this.$get = ['$document', function($document) {
    return function(domNode) {
      //the line below will force the browser to perform a repaint so
      //that all the animated elements within the animation frame will
      //be properly updated and drawn on screen. This is required to
      //ensure that the preparation animation is properly flushed so that
      //the active state picks up from there. DO NOT REMOVE THIS LINE.
      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
      if (domNode) {
        if (!domNode.nodeType && domNode instanceof jqLite) {
          domNode = domNode[0];
        }
      } else {
        domNode = $document[0].body;
      }
      return domNode.offsetWidth + 1;
    };
  }];
};

var APPLICATION_JSON = 'application/json';
var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
var JSON_START = /^\[|^\{(?!\{)/;
var JSON_ENDS = {
  '[': /]$/,
  '{': /}$/
};
var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
var $httpMinErr = minErr('$http');

function serializeValue(v) {
  if (isObject(v)) {
    return isDate(v) ? v.toISOString() : toJson(v);
  }
  return v;
}


/** @this */
function $HttpParamSerializerProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializer
   * @description
   *
   * Default {@link $http `$http`} params serializer that converts objects to strings
   * according to the following rules:
   *
   * * `{'foo': 'bar'}` results in `foo=bar`
   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
   *
   * Note that serializer will sort the request parameters alphabetically.
   * */

  this.$get = function() {
    return function ngParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      forEachSorted(params, function(value, key) {
        if (value === null || isUndefined(value)) return;
        if (isArray(value)) {
          forEach(value, function(v) {
            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
          });
        } else {
          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
        }
      });

      return parts.join('&');
    };
  };
}

/** @this */
function $HttpParamSerializerJQLikeProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializerJQLike
   *
   * @description
   *
   * Alternative {@link $http `$http`} params serializer that follows
   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
   * The serializer will also sort the params alphabetically.
   *
   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
   *
   * ```js
   * $http({
   *   url: myUrl,
   *   method: 'GET',
   *   params: myParams,
   *   paramSerializer: '$httpParamSerializerJQLike'
   * });
   * ```
   *
   * It is also possible to set it as the default `paramSerializer` in the
   * {@link $httpProvider#defaults `$httpProvider`}.
   *
   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
   * form data for submission:
   *
   * ```js
   * .controller(function($http, $httpParamSerializerJQLike) {
   *   //...
   *
   *   $http({
   *     url: myUrl,
   *     method: 'POST',
   *     data: $httpParamSerializerJQLike(myData),
   *     headers: {
   *       'Content-Type': 'application/x-www-form-urlencoded'
   *     }
   *   });
   *
   * });
   * ```
   *
   * */
  this.$get = function() {
    return function jQueryLikeParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      serialize(params, '', true);
      return parts.join('&');

      function serialize(toSerialize, prefix, topLevel) {
        if (toSerialize === null || isUndefined(toSerialize)) return;
        if (isArray(toSerialize)) {
          forEach(toSerialize, function(value, index) {
            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
          });
        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
          forEachSorted(toSerialize, function(value, key) {
            serialize(value, prefix +
                (topLevel ? '' : '[') +
                key +
                (topLevel ? '' : ']'));
          });
        } else {
          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
        }
      }
    };
  };
}

function defaultHttpResponseTransform(data, headers) {
  if (isString(data)) {
    // Strip json vulnerability protection prefix and trim whitespace
    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();

    if (tempData) {
      var contentType = headers('Content-Type');
      if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
        data = fromJson(tempData);
      }
    }
  }

  return data;
}

function isJsonLike(str) {
    var jsonStart = str.match(JSON_START);
    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
}

/**
 * Parse headers into key value object
 *
 * @param {string} headers Raw headers as a string
 * @returns {Object} Parsed headers as key value object
 */
function parseHeaders(headers) {
  var parsed = createMap(), i;

  function fillInParsed(key, val) {
    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  }

  if (isString(headers)) {
    forEach(headers.split('\n'), function(line) {
      i = line.indexOf(':');
      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
    });
  } else if (isObject(headers)) {
    forEach(headers, function(headerVal, headerKey) {
      fillInParsed(lowercase(headerKey), trim(headerVal));
    });
  }

  return parsed;
}


/**
 * Returns a function that provides access to parsed headers.
 *
 * Headers are lazy parsed when first requested.
 * @see parseHeaders
 *
 * @param {(string|Object)} headers Headers to provide access to.
 * @returns {function(string=)} Returns a getter function which if called with:
 *
 *   - if called with an argument returns a single header value or null
 *   - if called with no arguments returns an object containing all headers.
 */
function headersGetter(headers) {
  var headersObj;

  return function(name) {
    if (!headersObj) headersObj =  parseHeaders(headers);

    if (name) {
      var value = headersObj[lowercase(name)];
      if (value === undefined) {
        value = null;
      }
      return value;
    }

    return headersObj;
  };
}


/**
 * Chain all given functions
 *
 * This function is used for both request and response transforming
 *
 * @param {*} data Data to transform.
 * @param {function(string=)} headers HTTP headers getter fn.
 * @param {number} status HTTP status code of the response.
 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
 * @returns {*} Transformed data.
 */
function transformData(data, headers, status, fns) {
  if (isFunction(fns)) {
    return fns(data, headers, status);
  }

  forEach(fns, function(fn) {
    data = fn(data, headers, status);
  });

  return data;
}


function isSuccess(status) {
  return 200 <= status && status < 300;
}


/**
 * @ngdoc provider
 * @name $httpProvider
 * @this
 *
 * @description
 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
 * */
function $HttpProvider() {
  /**
   * @ngdoc property
   * @name $httpProvider#defaults
   * @description
   *
   * Object containing default values for all {@link ng.$http $http} requests.
   *
   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
   * by default. See {@link $http#caching $http Caching} for more information.
   *
   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
   * Defaults value is `'XSRF-TOKEN'`.
   *
   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
   *
   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
   * setting default headers.
   *     - **`defaults.headers.common`**
   *     - **`defaults.headers.post`**
   *     - **`defaults.headers.put`**
   *     - **`defaults.headers.patch`**
   *
   *
   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
   *  used to the prepare string representation of request parameters (specified as an object).
   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
   *
   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
   *
   **/
  var defaults = this.defaults = {
    // transform incoming response data
    transformResponse: [defaultHttpResponseTransform],

    // transform outgoing request data
    transformRequest: [function(d) {
      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
    }],

    // default headers
    headers: {
      common: {
        'Accept': 'application/json, text/plain, */*'
      },
      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
    },

    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',

    paramSerializer: '$httpParamSerializer',

    jsonpCallbackParam: 'callback'
  };

  var useApplyAsync = false;
  /**
   * @ngdoc method
   * @name $httpProvider#useApplyAsync
   * @description
   *
   * Configure $http service to combine processing of multiple http responses received at around
   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
   * significant performance improvement for bigger applications that make many HTTP requests
   * concurrently (common during application bootstrap).
   *
   * Defaults to false. If no value is specified, returns the current configured value.
   *
   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
   *    to load and share the same digest cycle.
   *
   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
   *    otherwise, returns the current configured value.
   **/
  this.useApplyAsync = function(value) {
    if (isDefined(value)) {
      useApplyAsync = !!value;
      return this;
    }
    return useApplyAsync;
  };

  /**
   * @ngdoc property
   * @name $httpProvider#interceptors
   * @description
   *
   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
   * pre-processing of request or postprocessing of responses.
   *
   * These service factories are ordered by request, i.e. they are applied in the same order as the
   * array, on request, but reverse order, on response.
   *
   * {@link ng.$http#interceptors Interceptors detailed info}
   **/
  var interceptorFactories = this.interceptors = [];

  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {

    var defaultCache = $cacheFactory('$http');

    /**
     * Make sure that default param serializer is exposed as a function
     */
    defaults.paramSerializer = isString(defaults.paramSerializer) ?
      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;

    /**
     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
     * The reversal is needed so that we can build up the interception chain around the
     * server request.
     */
    var reversedInterceptors = [];

    forEach(interceptorFactories, function(interceptorFactory) {
      reversedInterceptors.unshift(isString(interceptorFactory)
          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
    });

    /**
     * @ngdoc service
     * @kind function
     * @name $http
     * @requires ng.$httpBackend
     * @requires $cacheFactory
     * @requires $rootScope
     * @requires $q
     * @requires $injector
     *
     * @description
     * The `$http` service is a core Angular service that facilitates communication with the remote
     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
     *
     * For unit testing applications that use `$http` service, see
     * {@link ngMock.$httpBackend $httpBackend mock}.
     *
     * For a higher level of abstraction, please check out the {@link ngResource.$resource
     * $resource} service.
     *
     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
     * it is important to familiarize yourself with these APIs and the guarantees they provide.
     *
     *
     * ## General usage
     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
     *
     * ```js
     *   // Simple GET request example:
     *   $http({
     *     method: 'GET',
     *     url: '/someUrl'
     *   }).then(function successCallback(response) {
     *       // this callback will be called asynchronously
     *       // when the response is available
     *     }, function errorCallback(response) {
     *       // called asynchronously if an error occurs
     *       // or server returns response with an error status.
     *     });
     * ```
     *
     * The response object has these properties:
     *
     *   - **data** – `{string|Object}` – The response body transformed with the transform
     *     functions.
     *   - **status** – `{number}` – HTTP status code of the response.
     *   - **headers** – `{function([headerName])}` – Header getter function.
     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
     *   - **statusText** – `{string}` – HTTP status text of the response.
     *
     * A response status code between 200 and 299 is considered a success status and will result in
     * the success callback being called. Any response status code outside of that range is
     * considered an error status and will result in the error callback being called.
     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
     * aborted, e.g. using a `config.timeout`.
     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
     * that the outcome (success or error) will be determined by the final response status code.
     *
     *
     * ## Shortcut methods
     *
     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
     * last argument.
     *
     * ```js
     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
     * ```
     *
     * Complete list of shortcut methods:
     *
     * - {@link ng.$http#get $http.get}
     * - {@link ng.$http#head $http.head}
     * - {@link ng.$http#post $http.post}
     * - {@link ng.$http#put $http.put}
     * - {@link ng.$http#delete $http.delete}
     * - {@link ng.$http#jsonp $http.jsonp}
     * - {@link ng.$http#patch $http.patch}
     *
     *
     * ## Writing Unit Tests that use $http
     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
     * request using trained responses.
     *
     * ```
     * $httpBackend.expectGET(...);
     * $http.get(...);
     * $httpBackend.flush();
     * ```
     *
     * ## Setting HTTP Headers
     *
     * The $http service will automatically add certain HTTP headers to all requests. These defaults
     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
     * object, which currently contains this default configuration:
     *
     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
     *   - `Content-Type: application/json`
     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
     *   - `Content-Type: application/json`
     *
     * To add or overwrite these defaults, simply add or remove a property from these configuration
     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
     * with the lowercased HTTP method name as the key, e.g.
     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
     *
     * The defaults can also be set at runtime via the `$http.defaults` object in the same
     * fashion. For example:
     *
     * ```
     * module.run(function($http) {
     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
     * });
     * ```
     *
     * In addition, you can supply a `headers` property in the config object passed when
     * calling `$http(config)`, which overrides the defaults without changing them globally.
     *
     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
     * Use the `headers` property, setting the desired header to `undefined`. For example:
     *
     * ```js
     * var req = {
     *  method: 'POST',
     *  url: 'http://example.com',
     *  headers: {
     *    'Content-Type': undefined
     *  },
     *  data: { test: 'test' }
     * }
     *
     * $http(req).then(function(){...}, function(){...});
     * ```
     *
     * ## Transforming Requests and Responses
     *
     * Both requests and responses can be transformed using transformation functions: `transformRequest`
     * and `transformResponse`. These properties can be a single function that returns
     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
     *
     * <div class="alert alert-warning">
     * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
     * function will be reflected on the scope and in any templates where the object is data-bound.
     * To prevent this, transform functions should have no side-effects.
     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
     * </div>
     *
     * ### Default Transformations
     *
     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
     * `defaults.transformResponse` properties. If a request does not provide its own transformations
     * then these will be applied.
     *
     * You can augment or replace the default transformations by modifying these properties by adding to or
     * replacing the array.
     *
     * Angular provides the following default transformations:
     *
     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
     *
     * - If the `data` property of the request configuration object contains an object, serialize it
     *   into JSON format.
     *
     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
     *
     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
     *  - If JSON response is detected, deserialize it using a JSON parser.
     *
     *
     * ### Overriding the Default Transformations Per Request
     *
     * If you wish to override the request/response transformations only for a single request then provide
     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
     * into `$http`.
     *
     * Note that if you provide these properties on the config object the default transformations will be
     * overwritten. If you wish to augment the default transformations then you must include them in your
     * local transformation array.
     *
     * The following code demonstrates adding a new response transformation to be run after the default response
     * transformations have been run.
     *
     * ```js
     * function appendTransform(defaults, transform) {
     *
     *   // We can't guarantee that the default transformation is an array
     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
     *
     *   // Append the new transformation to the defaults
     *   return defaults.concat(transform);
     * }
     *
     * $http({
     *   url: '...',
     *   method: 'GET',
     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
     *     return doTransform(value);
     *   })
     * });
     * ```
     *
     *
     * ## Caching
     *
     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
     * set the config.cache value or the default cache value to TRUE or to a cache object (created
     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
     * precedence over the default cache value.
     *
     * In order to:
     *   * cache all responses - set the default cache value to TRUE or to a cache object
     *   * cache a specific response - set config.cache value to TRUE or to a cache object
     *
     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
     * then the default `$cacheFactory("$http")` object is used.
     *
     * The default cache value can be set by updating the
     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
     *
     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
     * the relevant cache object. The next time the same request is made, the response is returned
     * from the cache without sending a request to the server.
     *
     * Take note that:
     *
     *   * Only GET and JSONP requests are cached.
     *   * The cache key is the request URL including search parameters; headers are not considered.
     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
     *   * If multiple identical requests are made using the same cache, which is not yet populated,
     *     one request will be made to the server and remaining requests will return the same response.
     *   * A cache-control header on the response does not affect if or how responses are cached.
     *
     *
     * ## Interceptors
     *
     * Before you start creating interceptors, be sure to understand the
     * {@link ng.$q $q and deferred/promise APIs}.
     *
     * For purposes of global error handling, authentication, or any kind of synchronous or
     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
     * able to intercept requests before they are handed to the server and
     * responses before they are handed over to the application code that
     * initiated these requests. The interceptors leverage the {@link ng.$q
     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
     *
     * The interceptors are service factories that are registered with the `$httpProvider` by
     * adding them to the `$httpProvider.interceptors` array. The factory is called and
     * injected with dependencies (if specified) and returns the interceptor.
     *
     * There are two kinds of interceptors (and two kinds of rejection interceptors):
     *
     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
     *     modify the `config` object or create a new one. The function needs to return the `config`
     *     object directly, or a promise containing the `config` or a new `config` object.
     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *   * `response`: interceptors get called with http `response` object. The function is free to
     *     modify the `response` object or create a new one. The function needs to return the `response`
     *     object directly, or as a promise containing the `response` or a new `response` object.
     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *
     *
     * ```js
     *   // register the interceptor as a service
     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
     *     return {
     *       // optional method
     *       'request': function(config) {
     *         // do something on success
     *         return config;
     *       },
     *
     *       // optional method
     *      'requestError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       },
     *
     *
     *
     *       // optional method
     *       'response': function(response) {
     *         // do something on success
     *         return response;
     *       },
     *
     *       // optional method
     *      'responseError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       }
     *     };
     *   });
     *
     *   $httpProvider.interceptors.push('myHttpInterceptor');
     *
     *
     *   // alternatively, register the interceptor via an anonymous factory
     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
     *     return {
     *      'request': function(config) {
     *          // same as above
     *       },
     *
     *       'response': function(response) {
     *          // same as above
     *       }
     *     };
     *   });
     * ```
     *
     * ## Security Considerations
     *
     * When designing web applications, consider security threats from:
     *
     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
     *
     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
     * pre-configured with strategies that address these issues, but for this to work backend server
     * cooperation is required.
     *
     * ### JSON Vulnerability Protection
     *
     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * allows third party website to turn your JSON resource URL into
     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
     * Angular will automatically strip the prefix before processing it as JSON.
     *
     * For example if your server needs to return:
     * ```js
     * ['one','two']
     * ```
     *
     * which is vulnerable to attack, your server can return:
     * ```js
     * )]}',
     * ['one','two']
     * ```
     *
     * Angular will strip the prefix, before processing the JSON.
     *
     *
     * ### Cross Site Request Forgery (XSRF) Protection
     *
     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
     * which the attacker can trick an authenticated user into unknowingly executing actions on your
     * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
     * The header will not be set for cross-domain requests.
     *
     * To take advantage of this, your server needs to set a token in a JavaScript readable session
     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
     * that only JavaScript running on your domain could have sent the request. The token must be
     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
     * making up its own tokens). We recommend that the token is a digest of your site's
     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
     * for added security.
     *
     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
     * or the per-request config object.
     *
     * In order to prevent collisions in environments where multiple Angular apps share the
     * same domain or subdomain, we recommend that each application uses unique cookie name.
     *
     * @param {object} config Object describing the request to be made and how it should be
     *    processed. The object has following properties:
     *
     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
     *      with the `paramSerializer` and appended as GET parameters.
     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
     *      HTTP headers to send to the server. If the return value of a function is null, the
     *      header will not be sent. Functions accept a config object as an argument.
     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
     *    - **transformRequest** –
     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      request body and headers and returns its transformed (typically serialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **transformResponse** –
     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      response body, headers and status and returns its transformed (typically deserialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
     *      prepare the string representation of request parameters (specified as an object).
     *      If specified as string, it is interpreted as function registered with the
     *      {@link $injector $injector}, which means you can create your own serializer
     *      by registering it as a {@link auto.$provide#service service}.
     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
     *      See {@link $http#caching $http Caching} for more information.
     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
     *      that should abort the request when resolved.
     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
     *      for more information.
     *    - **responseType** - `{string}` - see
     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
     *
     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
     *                        when the request succeeds or fails.
     *
     *
     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
     *   requests. This is primarily meant to be used for debugging purposes.
     *
     *
     * @example
<example module="httpExample" name="http-service">
<file name="index.html">
  <div ng-controller="FetchController">
    <select ng-model="method" aria-label="Request method">
      <option>GET</option>
      <option>JSONP</option>
    </select>
    <input type="text" ng-model="url" size="80" aria-label="URL" />
    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
    <button id="samplejsonpbtn"
      ng-click="updateModel('JSONP',
                    'https://angularjs.org/greet.php?name=Super%20Hero')">
      Sample JSONP
    </button>
    <button id="invalidjsonpbtn"
      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
        Invalid JSONP
      </button>
    <pre>http status code: {{status}}</pre>
    <pre>http response data: {{data}}</pre>
  </div>
</file>
<file name="script.js">
  angular.module('httpExample', [])
    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
      // We must whitelist the JSONP endpoint that we are using to show that we trust it
      $sceDelegateProvider.resourceUrlWhitelist([
        'self',
        'https://angularjs.org/**'
      ]);
    }])
    .controller('FetchController', ['$scope', '$http', '$templateCache',
      function($scope, $http, $templateCache) {
        $scope.method = 'GET';
        $scope.url = 'http-hello.html';

        $scope.fetch = function() {
          $scope.code = null;
          $scope.response = null;

          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
            then(function(response) {
              $scope.status = response.status;
              $scope.data = response.data;
            }, function(response) {
              $scope.data = response.data || 'Request failed';
              $scope.status = response.status;
          });
        };

        $scope.updateModel = function(method, url) {
          $scope.method = method;
          $scope.url = url;
        };
      }]);
</file>
<file name="http-hello.html">
  Hello, $http!
</file>
<file name="protractor.js" type="protractor">
  var status = element(by.binding('status'));
  var data = element(by.binding('data'));
  var fetchBtn = element(by.id('fetchbtn'));
  var sampleGetBtn = element(by.id('samplegetbtn'));
  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));

  it('should make an xhr GET request', function() {
    sampleGetBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('200');
    expect(data.getText()).toMatch(/Hello, \$http!/);
  });

// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
// it('should make a JSONP request to angularjs.org', function() {
//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
//   sampleJsonpBtn.click();
//   fetchBtn.click();
//   expect(status.getText()).toMatch('200');
//   expect(data.getText()).toMatch(/Super Hero!/);
// });

  it('should make JSONP request to invalid URL and invoke the error handler',
      function() {
    invalidJsonpBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('0');
    expect(data.getText()).toMatch('Request failed');
  });
</file>
</example>
     */
    function $http(requestConfig) {

      if (!isObject(requestConfig)) {
        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
      }

      if (!isString($sce.valueOf(requestConfig.url))) {
        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
      }

      var config = extend({
        method: 'get',
        transformRequest: defaults.transformRequest,
        transformResponse: defaults.transformResponse,
        paramSerializer: defaults.paramSerializer,
        jsonpCallbackParam: defaults.jsonpCallbackParam
      }, requestConfig);

      config.headers = mergeHeaders(requestConfig);
      config.method = uppercase(config.method);
      config.paramSerializer = isString(config.paramSerializer) ?
          $injector.get(config.paramSerializer) : config.paramSerializer;

      $browser.$$incOutstandingRequestCount();

      var requestInterceptors = [];
      var responseInterceptors = [];
      var promise = $q.resolve(config);

      // apply interceptors
      forEach(reversedInterceptors, function(interceptor) {
        if (interceptor.request || interceptor.requestError) {
          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
        }
        if (interceptor.response || interceptor.responseError) {
          responseInterceptors.push(interceptor.response, interceptor.responseError);
        }
      });

      promise = chainInterceptors(promise, requestInterceptors);
      promise = promise.then(serverRequest);
      promise = chainInterceptors(promise, responseInterceptors);
      promise = promise.finally(completeOutstandingRequest);

      return promise;


      function chainInterceptors(promise, interceptors) {
        for (var i = 0, ii = interceptors.length; i < ii;) {
          var thenFn = interceptors[i++];
          var rejectFn = interceptors[i++];

          promise = promise.then(thenFn, rejectFn);
        }

        interceptors.length = 0;

        return promise;
      }

      function completeOutstandingRequest() {
        $browser.$$completeOutstandingRequest(noop);
      }

      function executeHeaderFns(headers, config) {
        var headerContent, processedHeaders = {};

        forEach(headers, function(headerFn, header) {
          if (isFunction(headerFn)) {
            headerContent = headerFn(config);
            if (headerContent != null) {
              processedHeaders[header] = headerContent;
            }
          } else {
            processedHeaders[header] = headerFn;
          }
        });

        return processedHeaders;
      }

      function mergeHeaders(config) {
        var defHeaders = defaults.headers,
            reqHeaders = extend({}, config.headers),
            defHeaderName, lowercaseDefHeaderName, reqHeaderName;

        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);

        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
        defaultHeadersIteration:
        for (defHeaderName in defHeaders) {
          lowercaseDefHeaderName = lowercase(defHeaderName);

          for (reqHeaderName in reqHeaders) {
            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
              continue defaultHeadersIteration;
            }
          }

          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
        }

        // execute if header value is a function for merged headers
        return executeHeaderFns(reqHeaders, shallowCopy(config));
      }

      function serverRequest(config) {
        var headers = config.headers;
        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);

        // strip content-type if data is undefined
        if (isUndefined(reqData)) {
          forEach(headers, function(value, header) {
            if (lowercase(header) === 'content-type') {
              delete headers[header];
            }
          });
        }

        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
          config.withCredentials = defaults.withCredentials;
        }

        // send request
        return sendReq(config, reqData).then(transformResponse, transformResponse);
      }

      function transformResponse(response) {
        // make a copy since the response must be cacheable
        var resp = extend({}, response);
        resp.data = transformData(response.data, response.headers, response.status,
                                  config.transformResponse);
        return (isSuccess(response.status))
          ? resp
          : $q.reject(resp);
      }
    }

    $http.pendingRequests = [];

    /**
     * @ngdoc method
     * @name $http#get
     *
     * @description
     * Shortcut method to perform `GET` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#delete
     *
     * @description
     * Shortcut method to perform `DELETE` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#head
     *
     * @description
     * Shortcut method to perform `HEAD` request.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#jsonp
     *
     * @description
     * Shortcut method to perform `JSONP` request.
     *
     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
     * the url must be declared, via {@link $sce} as a trusted resource URL.
     * You can trust a URL by adding it to the whitelist via
     * {@link $sceDelegateProvider#resourceUrlWhitelist  `$sceDelegateProvider.resourceUrlWhitelist`} or
     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
     *
     * JSONP requests must specify a callback to be used in the response from the server. This callback
     * is passed as a query parameter in the request. You must specify the name of this parameter by
     * setting the `jsonpCallbackParam` property on the request config object.
     *
     * ```
     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
     * ```
     *
     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
     * Initially this is set to `'callback'`.
     *
     * <div class="alert alert-danger">
     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
     * parameter value should go.
     * </div>
     *
     * If you would like to customise where and how the callbacks are stored then try overriding
     * or decorating the {@link $jsonpCallbacks} service.
     *
     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */
    createShortMethods('get', 'delete', 'head', 'jsonp');

    /**
     * @ngdoc method
     * @name $http#post
     *
     * @description
     * Shortcut method to perform `POST` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#put
     *
     * @description
     * Shortcut method to perform `PUT` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

     /**
      * @ngdoc method
      * @name $http#patch
      *
      * @description
      * Shortcut method to perform `PATCH` request.
      *
      * @param {string} url Relative or absolute URL specifying the destination of the request
      * @param {*} data Request content
      * @param {Object=} config Optional configuration object
      * @returns {HttpPromise} Future object
      */
    createShortMethodsWithData('post', 'put', 'patch');

        /**
         * @ngdoc property
         * @name $http#defaults
         *
         * @description
         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
         * default headers, withCredentials as well as request and response transformations.
         *
         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
         */
    $http.defaults = defaults;


    return $http;


    function createShortMethods(names) {
      forEach(arguments, function(name) {
        $http[name] = function(url, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url
          }));
        };
      });
    }


    function createShortMethodsWithData(name) {
      forEach(arguments, function(name) {
        $http[name] = function(url, data, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url,
            data: data
          }));
        };
      });
    }


    /**
     * Makes the request.
     *
     * !!! ACCESSES CLOSURE VARS:
     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
     */
    function sendReq(config, reqData) {
      var deferred = $q.defer(),
          promise = deferred.promise,
          cache,
          cachedResp,
          reqHeaders = config.headers,
          isJsonp = lowercase(config.method) === 'jsonp',
          url = config.url;

      if (isJsonp) {
        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
        url = $sce.getTrustedResourceUrl(url);
      } else if (!isString(url)) {
        // If it is not a string then the URL must be a $sce trusted object
        url = $sce.valueOf(url);
      }

      url = buildUrl(url, config.paramSerializer(config.params));

      if (isJsonp) {
        // Check the url and add the JSONP callback placeholder
        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
      }

      $http.pendingRequests.push(config);
      promise.then(removePendingReq, removePendingReq);

      if ((config.cache || defaults.cache) && config.cache !== false &&
          (config.method === 'GET' || config.method === 'JSONP')) {
        cache = isObject(config.cache) ? config.cache
              : isObject(defaults.cache) ? defaults.cache
              : defaultCache;
      }

      if (cache) {
        cachedResp = cache.get(url);
        if (isDefined(cachedResp)) {
          if (isPromiseLike(cachedResp)) {
            // cached request has already been sent, but there is no response yet
            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
          } else {
            // serving from cache
            if (isArray(cachedResp)) {
              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
            } else {
              resolvePromise(cachedResp, 200, {}, 'OK');
            }
          }
        } else {
          // put the promise for the non-transformed response into cache as a placeholder
          cache.put(url, promise);
        }
      }


      // if we won't have the response in cache, set the xsrf headers and
      // send the request to the backend
      if (isUndefined(cachedResp)) {
        var xsrfValue = urlIsSameOrigin(config.url)
            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
            : undefined;
        if (xsrfValue) {
          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
        }

        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
            config.withCredentials, config.responseType,
            createApplyHandlers(config.eventHandlers),
            createApplyHandlers(config.uploadEventHandlers));
      }

      return promise;

      function createApplyHandlers(eventHandlers) {
        if (eventHandlers) {
          var applyHandlers = {};
          forEach(eventHandlers, function(eventHandler, key) {
            applyHandlers[key] = function(event) {
              if (useApplyAsync) {
                $rootScope.$applyAsync(callEventHandler);
              } else if ($rootScope.$$phase) {
                callEventHandler();
              } else {
                $rootScope.$apply(callEventHandler);
              }

              function callEventHandler() {
                eventHandler(event);
              }
            };
          });
          return applyHandlers;
        }
      }


      /**
       * Callback registered to $httpBackend():
       *  - caches the response if desired
       *  - resolves the raw $http promise
       *  - calls $apply
       */
      function done(status, response, headersString, statusText) {
        if (cache) {
          if (isSuccess(status)) {
            cache.put(url, [status, response, parseHeaders(headersString), statusText]);
          } else {
            // remove promise from the cache
            cache.remove(url);
          }
        }

        function resolveHttpPromise() {
          resolvePromise(response, status, headersString, statusText);
        }

        if (useApplyAsync) {
          $rootScope.$applyAsync(resolveHttpPromise);
        } else {
          resolveHttpPromise();
          if (!$rootScope.$$phase) $rootScope.$apply();
        }
      }


      /**
       * Resolves the raw $http promise.
       */
      function resolvePromise(response, status, headers, statusText) {
        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
        status = status >= -1 ? status : 0;

        (isSuccess(status) ? deferred.resolve : deferred.reject)({
          data: response,
          status: status,
          headers: headersGetter(headers),
          config: config,
          statusText: statusText
        });
      }

      function resolvePromiseWithResult(result) {
        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
      }

      function removePendingReq() {
        var idx = $http.pendingRequests.indexOf(config);
        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
      }
    }


    function buildUrl(url, serializedParams) {
      if (serializedParams.length > 0) {
        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
      }
      return url;
    }

    function sanitizeJsonpCallbackParam(url, key) {
      if (/[&?][^=]+=JSON_CALLBACK/.test(url)) {
        // Throw if the url already contains a reference to JSON_CALLBACK
        throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
      }

      var callbackParamRegex = new RegExp('[&?]' + key + '=');
      if (callbackParamRegex.test(url)) {
        // Throw if the callback param was already provided
        throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', key, url);
      }

      // Add in the JSON_CALLBACK callback param value
      url += ((url.indexOf('?') === -1) ? '?' : '&') + key + '=JSON_CALLBACK';

      return url;
    }
  }];
}

/**
 * @ngdoc service
 * @name $xhrFactory
 * @this
 *
 * @description
 * Factory function used to create XMLHttpRequest objects.
 *
 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
 *
 * ```
 * angular.module('myApp', [])
 * .factory('$xhrFactory', function() {
 *   return function createXhr(method, url) {
 *     return new window.XMLHttpRequest({mozSystem: true});
 *   };
 * });
 * ```
 *
 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
 * @param {string} url URL of the request.
 */
function $xhrFactoryProvider() {
  this.$get = function() {
    return function createXhr() {
      return new window.XMLHttpRequest();
    };
  };
}

/**
 * @ngdoc service
 * @name $httpBackend
 * @requires $jsonpCallbacks
 * @requires $document
 * @requires $xhrFactory
 * @this
 *
 * @description
 * HTTP backend used by the {@link ng.$http service} that delegates to
 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
 *
 * You should never need to use this service directly, instead use the higher-level abstractions:
 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
 *
 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
 * $httpBackend} which can be trained with responses.
 */
function $HttpBackendProvider() {
  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
  }];
}

function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
  // TODO(vojta): fix the signature
  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
    url = url || $browser.url();

    if (lowercase(method) === 'jsonp') {
      var callbackPath = callbacks.createCallback(url);
      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
        var response = (status === 200) && callbacks.getResponse(callbackPath);
        completeRequest(callback, status, response, '', text);
        callbacks.removeCallback(callbackPath);
      });
    } else {

      var xhr = createXhr(method, url);

      xhr.open(method, url, true);
      forEach(headers, function(value, key) {
        if (isDefined(value)) {
            xhr.setRequestHeader(key, value);
        }
      });

      xhr.onload = function requestLoaded() {
        var statusText = xhr.statusText || '';

        // responseText is the old-school way of retrieving response (supported by IE9)
        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
        var response = ('response' in xhr) ? xhr.response : xhr.responseText;

        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
        var status = xhr.status === 1223 ? 204 : xhr.status;

        // fix status code when it is 0 (0 status is undocumented).
        // Occurs when accessing file resources or on Android 4.1 stock browser
        // while retrieving files from application cache.
        if (status === 0) {
          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
        }

        completeRequest(callback,
            status,
            response,
            xhr.getAllResponseHeaders(),
            statusText);
      };

      var requestError = function() {
        // The response is always empty
        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
        completeRequest(callback, -1, null, null, '');
      };

      xhr.onerror = requestError;
      xhr.onabort = requestError;
      xhr.ontimeout = requestError;

      forEach(eventHandlers, function(value, key) {
          xhr.addEventListener(key, value);
      });

      forEach(uploadEventHandlers, function(value, key) {
        xhr.upload.addEventListener(key, value);
      });

      if (withCredentials) {
        xhr.withCredentials = true;
      }

      if (responseType) {
        try {
          xhr.responseType = responseType;
        } catch (e) {
          // WebKit added support for the json responseType value on 09/03/2013
          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
          // known to throw when setting the value "json" as the response type. Other older
          // browsers implementing the responseType
          //
          // The json response type can be ignored if not supported, because JSON payloads are
          // parsed on the client-side regardless.
          if (responseType !== 'json') {
            throw e;
          }
        }
      }

      xhr.send(isUndefined(post) ? null : post);
    }

    if (timeout > 0) {
      var timeoutId = $browserDefer(timeoutRequest, timeout);
    } else if (isPromiseLike(timeout)) {
      timeout.then(timeoutRequest);
    }


    function timeoutRequest() {
      if (jsonpDone) {
        jsonpDone();
      }
      if (xhr) {
        xhr.abort();
      }
    }

    function completeRequest(callback, status, response, headersString, statusText) {
      // cancel timeout and subsequent timeout promise resolution
      if (isDefined(timeoutId)) {
        $browserDefer.cancel(timeoutId);
      }
      jsonpDone = xhr = null;

      callback(status, response, headersString, statusText);
    }
  };

  function jsonpReq(url, callbackPath, done) {
    url = url.replace('JSON_CALLBACK', callbackPath);
    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
    // - fetches local scripts via XHR and evals them
    // - adds and immediately removes script elements from the document
    var script = rawDocument.createElement('script'), callback = null;
    script.type = 'text/javascript';
    script.src = url;
    script.async = true;

    callback = function(event) {
      script.removeEventListener('load', callback);
      script.removeEventListener('error', callback);
      rawDocument.body.removeChild(script);
      script = null;
      var status = -1;
      var text = 'unknown';

      if (event) {
        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
          event = { type: 'error' };
        }
        text = event.type;
        status = event.type === 'error' ? 404 : 200;
      }

      if (done) {
        done(status, text);
      }
    };

    script.addEventListener('load', callback);
    script.addEventListener('error', callback);
    rawDocument.body.appendChild(script);
    return callback;
  }
}

var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
$interpolateMinErr.throwNoconcat = function(text) {
  throw $interpolateMinErr('noconcat',
      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
      'interpolations that concatenate multiple expressions when a trusted value is ' +
      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
};

$interpolateMinErr.interr = function(text, err) {
  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
};

/**
 * @ngdoc provider
 * @name $interpolateProvider
 * @this
 *
 * @description
 *
 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
 *
 * <div class="alert alert-danger">
 * This feature is sometimes used to mix different markup languages, e.g. to wrap an Angular
 * template within a Python Jinja template (or any other template language). Mixing templating
 * languages is **very dangerous**. The embedding template language will not safely escape Angular
 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
 * security bugs!
 * </div>
 *
 * @example
<example name="custom-interpolation-markup" module="customInterpolationApp">
<file name="index.html">
<script>
  var customInterpolationApp = angular.module('customInterpolationApp', []);

  customInterpolationApp.config(function($interpolateProvider) {
    $interpolateProvider.startSymbol('//');
    $interpolateProvider.endSymbol('//');
  });


  customInterpolationApp.controller('DemoController', function() {
      this.label = "This binding is brought you by // interpolation symbols.";
  });
</script>
<div ng-controller="DemoController as demo">
    //demo.label//
</div>
</file>
<file name="protractor.js" type="protractor">
  it('should interpolate binding with custom symbols', function() {
    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
  });
</file>
</example>
 */
function $InterpolateProvider() {
  var startSymbol = '{{';
  var endSymbol = '}}';

  /**
   * @ngdoc method
   * @name $interpolateProvider#startSymbol
   * @description
   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
   *
   * @param {string=} value new value to set the starting symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.startSymbol = function(value) {
    if (value) {
      startSymbol = value;
      return this;
    } else {
      return startSymbol;
    }
  };

  /**
   * @ngdoc method
   * @name $interpolateProvider#endSymbol
   * @description
   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
   *
   * @param {string=} value new value to set the ending symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.endSymbol = function(value) {
    if (value) {
      endSymbol = value;
      return this;
    } else {
      return endSymbol;
    }
  };


  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
    var startSymbolLength = startSymbol.length,
        endSymbolLength = endSymbol.length,
        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');

    function escape(ch) {
      return '\\\\\\' + ch;
    }

    function unescapeText(text) {
      return text.replace(escapedStartRegexp, startSymbol).
        replace(escapedEndRegexp, endSymbol);
    }

    // TODO: this is the same as the constantWatchDelegate in parse.js
    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
        unwatch();
        return constantInterp(scope);
      }, listener, objectEquality);
      return unwatch;
    }

    /**
     * @ngdoc service
     * @name $interpolate
     * @kind function
     *
     * @requires $parse
     * @requires $sce
     *
     * @description
     *
     * Compiles a string with markup into an interpolation function. This service is used by the
     * HTML {@link ng.$compile $compile} service for data binding. See
     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
     * interpolation markup.
     *
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var exp = $interpolate('Hello {{name | uppercase}}!');
     *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
     * ```
     *
     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
     * `true`, the interpolation function will return `undefined` unless all embedded expressions
     * evaluate to a value other than `undefined`.
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var context = {greeting: 'Hello', name: undefined };
     *
     *   // default "forgiving" mode
     *   var exp = $interpolate('{{greeting}} {{name}}!');
     *   expect(exp(context)).toEqual('Hello !');
     *
     *   // "allOrNothing" mode
     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
     *   expect(exp(context)).toBeUndefined();
     *   context.name = 'Angular';
     *   expect(exp(context)).toEqual('Hello Angular!');
     * ```
     *
     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
     *
     * #### Escaped Interpolation
     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
     * or binding.
     *
     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
     * degree, while also enabling code examples to work without relying on the
     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
     *
     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
     * interpolation start/end markers with their escaped counterparts.**
     *
     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
     * output when the $interpolate service processes the text. So, for HTML elements interpolated
     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
     * this is typically useful only when user-data is used in rendering a template from the server, or
     * when otherwise untrusted data is used by a directive.
     *
     * <example name="interpolation">
     *  <file name="index.html">
     *    <div ng-init="username='A user'">
     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
     *        </p>
     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
     *        application, but fails to accomplish their task, because the server has correctly
     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
     *        characters.</p>
     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
     *        from the database by an administrator.</p>
     *    </div>
     *  </file>
     * </example>
     *
     * @knownIssue
     * It is currently not possible for an interpolated expression to contain the interpolation end
     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
     *
     * @knownIssue
     * All directives and components must use the standard `{{` `}}` interpolation symbols
     * in their templates. If you change the application interpolation symbols the {@link $compile}
     * service will attempt to denormalize the standard symbols to the custom symbols.
     * The denormalization process is not clever enough to know not to replace instances of the standard
     * symbols where they would not normally be treated as interpolation symbols. For example in the following
     * code snippet the closing braces of the literal object will get incorrectly denormalized:
     *
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"}}">
     * ```
     *
     * The workaround is to ensure that such instances are separated by whitespace:
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"} }">
     * ```
     *
     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
     *
     * @param {string} text The text with markup to interpolate.
     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
     *    embedded expression in order to return an interpolation function. Strings with no
     *    embedded expression will return null for the interpolation function.
     * @param {string=} trustedContext when provided, the returned function passes the interpolated
     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
     *    provides Strict Contextual Escaping for details.
     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
     *    unless all embedded expressions evaluate to a value other than `undefined`.
     * @returns {function(context)} an interpolation function which is used to compute the
     *    interpolated string. The function has these parameters:
     *
     * - `context`: evaluation context for all expressions embedded in the interpolated text
     */
    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
      // Provide a quick exit and simplified result function for text with no interpolation
      if (!text.length || text.indexOf(startSymbol) === -1) {
        var constantInterp;
        if (!mustHaveExpression) {
          var unescapedText = unescapeText(text);
          constantInterp = valueFn(unescapedText);
          constantInterp.exp = text;
          constantInterp.expressions = [];
          constantInterp.$$watchDelegate = constantWatchDelegate;
        }
        return constantInterp;
      }

      allOrNothing = !!allOrNothing;
      var startIndex,
          endIndex,
          index = 0,
          expressions = [],
          parseFns = [],
          textLength = text.length,
          exp,
          concat = [],
          expressionPositions = [];

      while (index < textLength) {
        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
          if (index !== startIndex) {
            concat.push(unescapeText(text.substring(index, startIndex)));
          }
          exp = text.substring(startIndex + startSymbolLength, endIndex);
          expressions.push(exp);
          parseFns.push($parse(exp, parseStringifyInterceptor));
          index = endIndex + endSymbolLength;
          expressionPositions.push(concat.length);
          concat.push('');
        } else {
          // we did not find an interpolation, so we have to add the remainder to the separators array
          if (index !== textLength) {
            concat.push(unescapeText(text.substring(index)));
          }
          break;
        }
      }

      // Concatenating expressions makes it hard to reason about whether some combination of
      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
      // single expression be used for iframe[src], object[src], etc., we ensure that the value
      // that's used is assigned or constructed by some JS code somewhere that is more testable or
      // make it obvious that you bound the value to some user controlled value.  This helps reduce
      // the load when auditing for XSS issues.
      if (trustedContext && concat.length > 1) {
          $interpolateMinErr.throwNoconcat(text);
      }

      if (!mustHaveExpression || expressions.length) {
        var compute = function(values) {
          for (var i = 0, ii = expressions.length; i < ii; i++) {
            if (allOrNothing && isUndefined(values[i])) return;
            concat[expressionPositions[i]] = values[i];
          }
          return concat.join('');
        };

        var getValue = function(value) {
          return trustedContext ?
            $sce.getTrusted(trustedContext, value) :
            $sce.valueOf(value);
        };

        return extend(function interpolationFn(context) {
            var i = 0;
            var ii = expressions.length;
            var values = new Array(ii);

            try {
              for (; i < ii; i++) {
                values[i] = parseFns[i](context);
              }

              return compute(values);
            } catch (err) {
              $exceptionHandler($interpolateMinErr.interr(text, err));
            }

          }, {
          // all of these properties are undocumented for now
          exp: text, //just for compatibility with regular watchers created via $watch
          expressions: expressions,
          $$watchDelegate: function(scope, listener) {
            var lastValue;
            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
              var currValue = compute(values);
              if (isFunction(listener)) {
                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
              }
              lastValue = currValue;
            });
          }
        });
      }

      function parseStringifyInterceptor(value) {
        try {
          value = getValue(value);
          return allOrNothing && !isDefined(value) ? value : stringify(value);
        } catch (err) {
          $exceptionHandler($interpolateMinErr.interr(text, err));
        }
      }
    }


    /**
     * @ngdoc method
     * @name $interpolate#startSymbol
     * @description
     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
     *
     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
     * the symbol.
     *
     * @returns {string} start symbol.
     */
    $interpolate.startSymbol = function() {
      return startSymbol;
    };


    /**
     * @ngdoc method
     * @name $interpolate#endSymbol
     * @description
     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
     *
     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
     * the symbol.
     *
     * @returns {string} end symbol.
     */
    $interpolate.endSymbol = function() {
      return endSymbol;
    };

    return $interpolate;
  }];
}

/** @this */
function $IntervalProvider() {
  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
       function($rootScope,   $window,   $q,   $$q,   $browser) {
    var intervals = {};


     /**
      * @ngdoc service
      * @name $interval
      *
      * @description
      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
      * milliseconds.
      *
      * The return value of registering an interval function is a promise. This promise will be
      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
      * run indefinitely if `count` is not defined. The value of the notification will be the
      * number of iterations that have run.
      * To cancel an interval, call `$interval.cancel(promise)`.
      *
      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
      * time.
      *
      * <div class="alert alert-warning">
      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
      * with them.  In particular they are not automatically destroyed when a controller's scope or a
      * directive's element are destroyed.
      * You should take this into consideration and make sure to always cancel the interval at the
      * appropriate moment.  See the example below for more details on how and when to do this.
      * </div>
      *
      * @param {function()} fn A function that should be called repeatedly. If no additional arguments
      *   are passed (see below), the function is called with the current iteration count.
      * @param {number} delay Number of milliseconds between each function call.
      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
      *   indefinitely.
      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
      * @param {...*=} Pass additional parameters to the executed function.
      * @returns {promise} A promise which will be notified on each iteration.
      *
      * @example
      * <example module="intervalExample" name="interval-service">
      * <file name="index.html">
      *   <script>
      *     angular.module('intervalExample', [])
      *       .controller('ExampleController', ['$scope', '$interval',
      *         function($scope, $interval) {
      *           $scope.format = 'M/d/yy h:mm:ss a';
      *           $scope.blood_1 = 100;
      *           $scope.blood_2 = 120;
      *
      *           var stop;
      *           $scope.fight = function() {
      *             // Don't start a new fight if we are already fighting
      *             if ( angular.isDefined(stop) ) return;
      *
      *             stop = $interval(function() {
      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
      *                 $scope.blood_1 = $scope.blood_1 - 3;
      *                 $scope.blood_2 = $scope.blood_2 - 4;
      *               } else {
      *                 $scope.stopFight();
      *               }
      *             }, 100);
      *           };
      *
      *           $scope.stopFight = function() {
      *             if (angular.isDefined(stop)) {
      *               $interval.cancel(stop);
      *               stop = undefined;
      *             }
      *           };
      *
      *           $scope.resetFight = function() {
      *             $scope.blood_1 = 100;
      *             $scope.blood_2 = 120;
      *           };
      *
      *           $scope.$on('$destroy', function() {
      *             // Make sure that the interval is destroyed too
      *             $scope.stopFight();
      *           });
      *         }])
      *       // Register the 'myCurrentTime' directive factory method.
      *       // We inject $interval and dateFilter service since the factory method is DI.
      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
      *         function($interval, dateFilter) {
      *           // return the directive link function. (compile function not needed)
      *           return function(scope, element, attrs) {
      *             var format,  // date format
      *                 stopTime; // so that we can cancel the time updates
      *
      *             // used to update the UI
      *             function updateTime() {
      *               element.text(dateFilter(new Date(), format));
      *             }
      *
      *             // watch the expression, and update the UI on change.
      *             scope.$watch(attrs.myCurrentTime, function(value) {
      *               format = value;
      *               updateTime();
      *             });
      *
      *             stopTime = $interval(updateTime, 1000);
      *
      *             // listen on DOM destroy (removal) event, and cancel the next UI update
      *             // to prevent updating time after the DOM element was removed.
      *             element.on('$destroy', function() {
      *               $interval.cancel(stopTime);
      *             });
      *           }
      *         }]);
      *   </script>
      *
      *   <div>
      *     <div ng-controller="ExampleController">
      *       <label>Date format: <input ng-model="format"></label> <hr/>
      *       Current time is: <span my-current-time="format"></span>
      *       <hr/>
      *       Blood 1 : <font color='red'>{{blood_1}}</font>
      *       Blood 2 : <font color='red'>{{blood_2}}</font>
      *       <button type="button" data-ng-click="fight()">Fight</button>
      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
      *     </div>
      *   </div>
      *
      * </file>
      * </example>
      */
    function interval(fn, delay, count, invokeApply) {
      var hasParams = arguments.length > 4,
          args = hasParams ? sliceArgs(arguments, 4) : [],
          setInterval = $window.setInterval,
          clearInterval = $window.clearInterval,
          iteration = 0,
          skipApply = (isDefined(invokeApply) && !invokeApply),
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise;

      count = isDefined(count) ? count : 0;

      promise.$$intervalId = setInterval(function tick() {
        if (skipApply) {
          $browser.defer(callback);
        } else {
          $rootScope.$evalAsync(callback);
        }
        deferred.notify(iteration++);

        if (count > 0 && iteration >= count) {
          deferred.resolve(iteration);
          clearInterval(promise.$$intervalId);
          delete intervals[promise.$$intervalId];
        }

        if (!skipApply) $rootScope.$apply();

      }, delay);

      intervals[promise.$$intervalId] = deferred;

      return promise;

      function callback() {
        if (!hasParams) {
          fn(iteration);
        } else {
          fn.apply(null, args);
        }
      }
    }


     /**
      * @ngdoc method
      * @name $interval#cancel
      *
      * @description
      * Cancels a task associated with the `promise`.
      *
      * @param {Promise=} promise returned by the `$interval` function.
      * @returns {boolean} Returns `true` if the task was successfully canceled.
      */
    interval.cancel = function(promise) {
      if (promise && promise.$$intervalId in intervals) {
        // Interval cancels should not report as unhandled promise.
        intervals[promise.$$intervalId].promise.catch(noop);
        intervals[promise.$$intervalId].reject('canceled');
        $window.clearInterval(promise.$$intervalId);
        delete intervals[promise.$$intervalId];
        return true;
      }
      return false;
    };

    return interval;
  }];
}

/**
 * @ngdoc service
 * @name $jsonpCallbacks
 * @requires $window
 * @description
 * This service handles the lifecycle of callbacks to handle JSONP requests.
 * Override this service if you wish to customise where the callbacks are stored and
 * how they vary compared to the requested url.
 */
var $jsonpCallbacksProvider = /** @this */ function() {
  this.$get = ['$window', function($window) {
    var callbacks = $window.angular.callbacks;
    var callbackMap = {};

    function createCallback(callbackId) {
      var callback = function(data) {
        callback.data = data;
        callback.called = true;
      };
      callback.id = callbackId;
      return callback;
    }

    return {
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#createCallback
       * @param {string} url the url of the JSONP request
       * @returns {string} the callback path to send to the server as part of the JSONP request
       * @description
       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
       */
      createCallback: function(url) {
        var callbackId = '_' + (callbacks.$$counter++).toString(36);
        var callbackPath = 'angular.callbacks.' + callbackId;
        var callback = createCallback(callbackId);
        callbackMap[callbackPath] = callbacks[callbackId] = callback;
        return callbackPath;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#wasCalled
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
       * @description
       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
       * callback that was passed in the request.
       */
      wasCalled: function(callbackPath) {
        return callbackMap[callbackPath].called;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#getResponse
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {*} the data received from the response via the registered callback
       * @description
       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
       * in the JSONP response.
       */
      getResponse: function(callbackPath) {
        return callbackMap[callbackPath].data;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#removeCallback
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @description
       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
       * completed or timed-out.
       */
      removeCallback: function(callbackPath) {
        var callback = callbackMap[callbackPath];
        delete callbacks[callback.id];
        delete callbackMap[callbackPath];
      }
    };
  }];
};

/**
 * @ngdoc service
 * @name $locale
 *
 * @description
 * $locale service provides localization rules for various Angular components. As of right now the
 * only public api is:
 *
 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
 */

var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
var $locationMinErr = minErr('$location');


/**
 * Encode path using encodeUriSegment, ignoring forward slashes
 *
 * @param {string} path Path to encode
 * @returns {string}
 */
function encodePath(path) {
  var segments = path.split('/'),
      i = segments.length;

  while (i--) {
    segments[i] = encodeUriSegment(segments[i]);
  }

  return segments.join('/');
}

function parseAbsoluteUrl(absoluteUrl, locationObj) {
  var parsedUrl = urlResolve(absoluteUrl);

  locationObj.$$protocol = parsedUrl.protocol;
  locationObj.$$host = parsedUrl.hostname;
  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
}

var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
function parseAppUrl(url, locationObj) {

  if (DOUBLE_SLASH_REGEX.test(url)) {
    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
  }

  var prefixed = (url.charAt(0) !== '/');
  if (prefixed) {
    url = '/' + url;
  }
  var match = urlResolve(url);
  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
      match.pathname.substring(1) : match.pathname);
  locationObj.$$search = parseKeyValue(match.search);
  locationObj.$$hash = decodeURIComponent(match.hash);

  // make sure path starts with '/';
  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
    locationObj.$$path = '/' + locationObj.$$path;
  }
}

function startsWith(str, search) {
  return str.slice(0, search.length) === search;
}

/**
 *
 * @param {string} base
 * @param {string} url
 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
 *                   the expected string.
 */
function stripBaseUrl(base, url) {
  if (startsWith(url, base)) {
    return url.substr(base.length);
  }
}


function stripHash(url) {
  var index = url.indexOf('#');
  return index === -1 ? url : url.substr(0, index);
}

function trimEmptyHash(url) {
  return url.replace(/(#.+)|#$/, '$1');
}


function stripFile(url) {
  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
}

/* return the server only (scheme://host:port) */
function serverBase(url) {
  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
}


/**
 * LocationHtml5Url represents a URL
 * This object is exposed as $location service when HTML5 mode is enabled and supported
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} basePrefix URL path prefix
 */
function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
  this.$$html5 = true;
  basePrefix = basePrefix || '';
  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given HTML5 (regular) URL string into properties
   * @param {string} url HTML5 URL
   * @private
   */
  this.$$parse = function(url) {
    var pathUrl = stripBaseUrl(appBaseNoFile, url);
    if (!isString(pathUrl)) {
      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
          appBaseNoFile);
    }

    parseAppUrl(pathUrl, this);

    if (!this.$$path) {
      this.$$path = '/';
    }

    this.$$compose();
  };

  /**
   * Compose url and update `absUrl` property
   * @private
   */
  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }
    var appUrl, prevAppUrl;
    var rewrittenUrl;


    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
      prevAppUrl = appUrl;
      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
      } else {
        rewrittenUrl = appBase + prevAppUrl;
      }
    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
      rewrittenUrl = appBaseNoFile + appUrl;
    } else if (appBaseNoFile === url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };
}


/**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when developer doesn't opt into html5 mode.
 * It also serves as the base class for html5 mode fallback on legacy browsers.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {

  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given hashbang URL into properties
   * @param {string} url Hashbang URL
   * @private
   */
  this.$$parse = function(url) {
    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
    var withoutHashUrl;

    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {

      // The rest of the URL starts with a hash so we have
      // got either a hashbang path or a plain hash fragment
      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
      if (isUndefined(withoutHashUrl)) {
        // There was no hashbang prefix so we just have a hash fragment
        withoutHashUrl = withoutBaseUrl;
      }

    } else {
      // There was no hashbang path nor hash fragment:
      // If we are in HTML5 mode we use what is left as the path;
      // Otherwise we ignore what is left
      if (this.$$html5) {
        withoutHashUrl = withoutBaseUrl;
      } else {
        withoutHashUrl = '';
        if (isUndefined(withoutBaseUrl)) {
          appBase = url;
          this.replace();
        }
      }
    }

    parseAppUrl(withoutHashUrl, this);

    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);

    this.$$compose();

    /*
     * In Windows, on an anchor node on documents loaded from
     * the filesystem, the browser will return a pathname
     * prefixed with the drive name ('/C:/path') when a
     * pathname without a drive is set:
     *  * a.setAttribute('href', '/foo')
     *   * a.pathname === '/C:/foo' //true
     *
     * Inside of Angular, we're always using pathnames that
     * do not include drive names for routing.
     */
    function removeWindowsDriveName(path, url, base) {
      /*
      Matches paths for file protocol on windows,
      such as /C:/foo/bar, and captures only /foo/bar.
      */
      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;

      var firstPathSegmentMatch;

      //Get the relative path from the input URL.
      if (startsWith(url, base)) {
        url = url.replace(base, '');
      }

      // The input URL intentionally contains a first path segment that ends with a colon.
      if (windowsFilePathExp.exec(url)) {
        return path;
      }

      firstPathSegmentMatch = windowsFilePathExp.exec(path);
      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
    }
  };

  /**
   * Compose hashbang URL and update `absUrl` property
   * @private
   */
  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (stripHash(appBase) === stripHash(url)) {
      this.$$parse(url);
      return true;
    }
    return false;
  };
}


/**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when html5 history api is enabled but the browser
 * does not support it.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
  this.$$html5 = true;
  LocationHashbangUrl.apply(this, arguments);

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }

    var rewrittenUrl;
    var appUrl;

    if (appBase === stripHash(url)) {
      rewrittenUrl = url;
    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
      rewrittenUrl = appBase + hashPrefix + appUrl;
    } else if (appBaseNoFile === url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };

  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
    this.$$absUrl = appBase + hashPrefix + this.$$url;
  };

}


var locationPrototype = {

  /**
   * Ensure absolute URL is initialized.
   * @private
   */
  $$absUrl:'',

  /**
   * Are we in html5 mode?
   * @private
   */
  $$html5: false,

  /**
   * Has any change been replacing?
   * @private
   */
  $$replace: false,

  /**
   * @ngdoc method
   * @name $location#absUrl
   *
   * @description
   * This method is getter only.
   *
   * Return full URL representation with all segments encoded according to rules specified in
   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var absUrl = $location.absUrl();
   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @return {string} full URL
   */
  absUrl: locationGetter('$$absUrl'),

  /**
   * @ngdoc method
   * @name $location#url
   *
   * @description
   * This method is getter / setter.
   *
   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
   *
   * Change path, search and hash, when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var url = $location.url();
   * // => "/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
   * @return {string} url
   */
  url: function(url) {
    if (isUndefined(url)) {
      return this.$$url;
    }

    var match = PATH_MATCH.exec(url);
    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
    if (match[2] || match[1] || url === '') this.search(match[3] || '');
    this.hash(match[5] || '');

    return this;
  },

  /**
   * @ngdoc method
   * @name $location#protocol
   *
   * @description
   * This method is getter only.
   *
   * Return protocol of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var protocol = $location.protocol();
   * // => "http"
   * ```
   *
   * @return {string} protocol of current URL
   */
  protocol: locationGetter('$$protocol'),

  /**
   * @ngdoc method
   * @name $location#host
   *
   * @description
   * This method is getter only.
   *
   * Return host of current URL.
   *
   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var host = $location.host();
   * // => "example.com"
   *
   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
   * host = $location.host();
   * // => "example.com"
   * host = location.host;
   * // => "example.com:8080"
   * ```
   *
   * @return {string} host of current URL.
   */
  host: locationGetter('$$host'),

  /**
   * @ngdoc method
   * @name $location#port
   *
   * @description
   * This method is getter only.
   *
   * Return port of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var port = $location.port();
   * // => 80
   * ```
   *
   * @return {Number} port
   */
  port: locationGetter('$$port'),

  /**
   * @ngdoc method
   * @name $location#path
   *
   * @description
   * This method is getter / setter.
   *
   * Return path of current URL when called without any parameter.
   *
   * Change path when called with parameter and return `$location`.
   *
   * Note: Path should always begin with forward slash (/), this method will add the forward slash
   * if it is missing.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var path = $location.path();
   * // => "/some/path"
   * ```
   *
   * @param {(string|number)=} path New path
   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
   */
  path: locationGetterSetter('$$path', function(path) {
    path = path !== null ? path.toString() : '';
    return path.charAt(0) === '/' ? path : '/' + path;
  }),

  /**
   * @ngdoc method
   * @name $location#search
   *
   * @description
   * This method is getter / setter.
   *
   * Return search part (as object) of current URL when called without any parameter.
   *
   * Change search part when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var searchObject = $location.search();
   * // => {foo: 'bar', baz: 'xoxo'}
   *
   * // set foo to 'yipee'
   * $location.search('foo', 'yipee');
   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
   * ```
   *
   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
   * hash object.
   *
   * When called with a single argument the method acts as a setter, setting the `search` component
   * of `$location` to the specified value.
   *
   * If the argument is a hash object containing an array of values, these values will be encoded
   * as duplicate search parameters in the URL.
   *
   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
   * will override only a single search property.
   *
   * If `paramValue` is an array, it will override the property of the `search` component of
   * `$location` specified via the first argument.
   *
   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
   *
   * If `paramValue` is `true`, the property specified via the first argument will be added with no
   * value nor trailing equal sign.
   *
   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
   * one or more arguments returns `$location` object itself.
   */
  search: function(search, paramValue) {
    switch (arguments.length) {
      case 0:
        return this.$$search;
      case 1:
        if (isString(search) || isNumber(search)) {
          search = search.toString();
          this.$$search = parseKeyValue(search);
        } else if (isObject(search)) {
          search = copy(search, {});
          // remove object undefined or null properties
          forEach(search, function(value, key) {
            if (value == null) delete search[key];
          });

          this.$$search = search;
        } else {
          throw $locationMinErr('isrcharg',
              'The first argument of the `$location#search()` call must be a string or an object.');
        }
        break;
      default:
        if (isUndefined(paramValue) || paramValue === null) {
          delete this.$$search[search];
        } else {
          this.$$search[search] = paramValue;
        }
    }

    this.$$compose();
    return this;
  },

  /**
   * @ngdoc method
   * @name $location#hash
   *
   * @description
   * This method is getter / setter.
   *
   * Returns the hash fragment when called without any parameters.
   *
   * Changes the hash fragment when called with a parameter and returns `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
   * var hash = $location.hash();
   * // => "hashValue"
   * ```
   *
   * @param {(string|number)=} hash New hash fragment
   * @return {string} hash
   */
  hash: locationGetterSetter('$$hash', function(hash) {
    return hash !== null ? hash.toString() : '';
  }),

  /**
   * @ngdoc method
   * @name $location#replace
   *
   * @description
   * If called, all changes to $location during the current `$digest` will replace the current history
   * record, instead of adding a new one.
   */
  replace: function() {
    this.$$replace = true;
    return this;
  }
};

forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
  Location.prototype = Object.create(locationPrototype);

  /**
   * @ngdoc method
   * @name $location#state
   *
   * @description
   * This method is getter / setter.
   *
   * Return the history state object when called without any parameter.
   *
   * Change the history state object when called with one parameter and return `$location`.
   * The state object is later passed to `pushState` or `replaceState`.
   *
   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
   * older browsers (like IE9 or Android < 4.0), don't use this method.
   *
   * @param {object=} state State object for pushState or replaceState
   * @return {object} state
   */
  Location.prototype.state = function(state) {
    if (!arguments.length) {
      return this.$$state;
    }

    if (Location !== LocationHtml5Url || !this.$$html5) {
      throw $locationMinErr('nostate', 'History API state support is available only ' +
        'in HTML5 mode and only in browsers supporting HTML5 History API');
    }
    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
    // but we're changing the $$state reference to $browser.state() during the $digest
    // so the modification window is narrow.
    this.$$state = isUndefined(state) ? null : state;

    return this;
  };
});


function locationGetter(property) {
  return /** @this */ function() {
    return this[property];
  };
}


function locationGetterSetter(property, preprocess) {
  return /** @this */ function(value) {
    if (isUndefined(value)) {
      return this[property];
    }

    this[property] = preprocess(value);
    this.$$compose();

    return this;
  };
}


/**
 * @ngdoc service
 * @name $location
 *
 * @requires $rootElement
 *
 * @description
 * The $location service parses the URL in the browser address bar (based on the
 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
 * available to your application. Changes to the URL in the address bar are reflected into
 * $location service and changes to $location are reflected into the browser address bar.
 *
 * **The $location service:**
 *
 * - Exposes the current URL in the browser address bar, so you can
 *   - Watch and observe the URL.
 *   - Change the URL.
 * - Synchronizes the URL with the browser when the user
 *   - Changes the address bar.
 *   - Clicks the back or forward button (or clicks a History link).
 *   - Clicks on a link.
 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
 *
 * For more information see {@link guide/$location Developer Guide: Using $location}
 */

/**
 * @ngdoc provider
 * @name $locationProvider
 * @this
 *
 * @description
 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
 */
function $LocationProvider() {
  var hashPrefix = '!',
      html5Mode = {
        enabled: false,
        requireBase: true,
        rewriteLinks: true
      };

  /**
   * @ngdoc method
   * @name $locationProvider#hashPrefix
   * @description
   * The default value for the prefix is `'!'`.
   * @param {string=} prefix Prefix for hash part (containing path and search)
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.hashPrefix = function(prefix) {
    if (isDefined(prefix)) {
      hashPrefix = prefix;
      return this;
    } else {
      return hashPrefix;
    }
  };

  /**
   * @ngdoc method
   * @name $locationProvider#html5Mode
   * @description
   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
   *   properties:
   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
   *     support `pushState`.
   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
   *     See the {@link guide/$location $location guide for more information}
   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
   *     only happen on links with an attribute that matches the given string. For example, if set
   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
   *     here, so `'internalLink'` will **not** match `'internal-link'`.
   *
   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
   */
  this.html5Mode = function(mode) {
    if (isBoolean(mode)) {
      html5Mode.enabled = mode;
      return this;
    } else if (isObject(mode)) {

      if (isBoolean(mode.enabled)) {
        html5Mode.enabled = mode.enabled;
      }

      if (isBoolean(mode.requireBase)) {
        html5Mode.requireBase = mode.requireBase;
      }

      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
        html5Mode.rewriteLinks = mode.rewriteLinks;
      }

      return this;
    } else {
      return html5Mode;
    }
  };

  /**
   * @ngdoc event
   * @name $location#$locationChangeStart
   * @eventType broadcast on root scope
   * @description
   * Broadcasted before a URL will change.
   *
   * This change can be prevented by calling
   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
   * details about event object. Upon successful change
   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  /**
   * @ngdoc event
   * @name $location#$locationChangeSuccess
   * @eventType broadcast on root scope
   * @description
   * Broadcasted after a URL was changed.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
      function($rootScope, $browser, $sniffer, $rootElement, $window) {
    var $location,
        LocationMode,
        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
        initialUrl = $browser.url(),
        appBase;

    if (html5Mode.enabled) {
      if (!baseHref && html5Mode.requireBase) {
        throw $locationMinErr('nobase',
          '$location in HTML5 mode requires a <base> tag to be present!');
      }
      appBase = serverBase(initialUrl) + (baseHref || '/');
      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
    } else {
      appBase = stripHash(initialUrl);
      LocationMode = LocationHashbangUrl;
    }
    var appBaseNoFile = stripFile(appBase);

    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
    $location.$$parseLinkUrl(initialUrl, initialUrl);

    $location.$$state = $browser.state();

    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;

    function setBrowserUrlWithFallback(url, replace, state) {
      var oldUrl = $location.url();
      var oldState = $location.$$state;
      try {
        $browser.url(url, replace, state);

        // Make sure $location.state() returns referentially identical (not just deeply equal)
        // state object; this makes possible quick checking if the state changed in the digest
        // loop. Checking deep equality would be too expensive.
        $location.$$state = $browser.state();
      } catch (e) {
        // Restore old values if pushState fails
        $location.url(oldUrl);
        $location.$$state = oldState;

        throw e;
      }
    }

    $rootElement.on('click', function(event) {
      var rewriteLinks = html5Mode.rewriteLinks;
      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
      // currently we open nice url link and redirect then

      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;

      var elm = jqLite(event.target);

      // traverse the DOM up to find first A tag
      while (nodeName_(elm[0]) !== 'a') {
        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
      }

      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;

      var absHref = elm.prop('href');
      // get the actual href attribute - see
      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
      var relHref = elm.attr('href') || elm.attr('xlink:href');

      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
        // an animation.
        absHref = urlResolve(absHref.animVal).href;
      }

      // Ignore when url is started with javascript: or mailto:
      if (IGNORE_URI_REGEXP.test(absHref)) return;

      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
        if ($location.$$parseLinkUrl(absHref, relHref)) {
          // We do a preventDefault for all urls that are part of the angular application,
          // in html5mode and also without, so that we are able to abort navigation without
          // getting double entries in the location history.
          event.preventDefault();
          // update location manually
          if ($location.absUrl() !== $browser.url()) {
            $rootScope.$apply();
            // hack to work around FF6 bug 684208 when scenario runner clicks on links
            $window.angular['ff-684208-preventDefault'] = true;
          }
        }
      }
    });


    // rewrite hashbang url <> html5 url
    if (trimEmptyHash($location.absUrl()) !== trimEmptyHash(initialUrl)) {
      $browser.url($location.absUrl(), true);
    }

    var initializing = true;

    // update $location when $browser url changes
    $browser.onUrlChange(function(newUrl, newState) {

      if (!startsWith(newUrl, appBaseNoFile)) {
        // If we are navigating outside of the app then force a reload
        $window.location.href = newUrl;
        return;
      }

      $rootScope.$evalAsync(function() {
        var oldUrl = $location.absUrl();
        var oldState = $location.$$state;
        var defaultPrevented;
        newUrl = trimEmptyHash(newUrl);
        $location.$$parse(newUrl);
        $location.$$state = newState;

        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
            newState, oldState).defaultPrevented;

        // if the location was changed by a `$locationChangeStart` handler then stop
        // processing this location change
        if ($location.absUrl() !== newUrl) return;

        if (defaultPrevented) {
          $location.$$parse(oldUrl);
          $location.$$state = oldState;
          setBrowserUrlWithFallback(oldUrl, false, oldState);
        } else {
          initializing = false;
          afterLocationChange(oldUrl, oldState);
        }
      });
      if (!$rootScope.$$phase) $rootScope.$digest();
    });

    // update browser
    $rootScope.$watch(function $locationWatch() {
      var oldUrl = trimEmptyHash($browser.url());
      var newUrl = trimEmptyHash($location.absUrl());
      var oldState = $browser.state();
      var currentReplace = $location.$$replace;
      var urlOrStateChanged = oldUrl !== newUrl ||
        ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);

      if (initializing || urlOrStateChanged) {
        initializing = false;

        $rootScope.$evalAsync(function() {
          var newUrl = $location.absUrl();
          var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
              $location.$$state, oldState).defaultPrevented;

          // if the location was changed by a `$locationChangeStart` handler then stop
          // processing this location change
          if ($location.absUrl() !== newUrl) return;

          if (defaultPrevented) {
            $location.$$parse(oldUrl);
            $location.$$state = oldState;
          } else {
            if (urlOrStateChanged) {
              setBrowserUrlWithFallback(newUrl, currentReplace,
                                        oldState === $location.$$state ? null : $location.$$state);
            }
            afterLocationChange(oldUrl, oldState);
          }
        });
      }

      $location.$$replace = false;

      // we don't need to return anything because $evalAsync will make the digest loop dirty when
      // there is a change
    });

    return $location;

    function afterLocationChange(oldUrl, oldState) {
      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
        $location.$$state, oldState);
    }
}];
}

/**
 * @ngdoc service
 * @name $log
 * @requires $window
 *
 * @description
 * Simple service for logging. Default implementation safely writes the message
 * into the browser's console (if present).
 *
 * The main purpose of this service is to simplify debugging and troubleshooting.
 *
 * The default is to log `debug` messages. You can use
 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
 *
 * @example
   <example module="logExample" name="log-service">
     <file name="script.js">
       angular.module('logExample', [])
         .controller('LogController', ['$scope', '$log', function($scope, $log) {
           $scope.$log = $log;
           $scope.message = 'Hello World!';
         }]);
     </file>
     <file name="index.html">
       <div ng-controller="LogController">
         <p>Reload this page with open console, enter text and hit the log button...</p>
         <label>Message:
         <input type="text" ng-model="message" /></label>
         <button ng-click="$log.log(message)">log</button>
         <button ng-click="$log.warn(message)">warn</button>
         <button ng-click="$log.info(message)">info</button>
         <button ng-click="$log.error(message)">error</button>
         <button ng-click="$log.debug(message)">debug</button>
       </div>
     </file>
   </example>
 */

/**
 * @ngdoc provider
 * @name $logProvider
 * @this
 *
 * @description
 * Use the `$logProvider` to configure how the application logs messages
 */
function $LogProvider() {
  var debug = true,
      self = this;

  /**
   * @ngdoc method
   * @name $logProvider#debugEnabled
   * @description
   * @param {boolean=} flag enable or disable debug level messages
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.debugEnabled = function(flag) {
    if (isDefined(flag)) {
      debug = flag;
    return this;
    } else {
      return debug;
    }
  };

  this.$get = ['$window', function($window) {
    return {
      /**
       * @ngdoc method
       * @name $log#log
       *
       * @description
       * Write a log message
       */
      log: consoleLog('log'),

      /**
       * @ngdoc method
       * @name $log#info
       *
       * @description
       * Write an information message
       */
      info: consoleLog('info'),

      /**
       * @ngdoc method
       * @name $log#warn
       *
       * @description
       * Write a warning message
       */
      warn: consoleLog('warn'),

      /**
       * @ngdoc method
       * @name $log#error
       *
       * @description
       * Write an error message
       */
      error: consoleLog('error'),

      /**
       * @ngdoc method
       * @name $log#debug
       *
       * @description
       * Write a debug message
       */
      debug: (function() {
        var fn = consoleLog('debug');

        return function() {
          if (debug) {
            fn.apply(self, arguments);
          }
        };
      })()
    };

    function formatError(arg) {
      if (arg instanceof Error) {
        if (arg.stack) {
          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
              ? 'Error: ' + arg.message + '\n' + arg.stack
              : arg.stack;
        } else if (arg.sourceURL) {
          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
        }
      }
      return arg;
    }

    function consoleLog(type) {
      var console = $window.console || {},
          logFn = console[type] || console.log || noop,
          hasApply = false;

      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
      // The reason behind this is that console.log has type "object" in IE8...
      try {
        hasApply = !!logFn.apply;
      } catch (e) { /* empty */ }

      if (hasApply) {
        return function() {
          var args = [];
          forEach(arguments, function(arg) {
            args.push(formatError(arg));
          });
          return logFn.apply(console, args);
        };
      }

      // we are IE which either doesn't have window.console => this is noop and we do nothing,
      // or we are IE where console.log doesn't have apply so we log at least first 2 args
      return function(arg1, arg2) {
        logFn(arg1, arg2 == null ? '' : arg2);
      };
    }
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $parseMinErr = minErr('$parse');

var objectValueOf = {}.constructor.prototype.valueOf;

// Sandboxing Angular Expressions
// ------------------------------
// Angular expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
// various means such as obtaining a reference to native JS functions like the Function constructor.
//
// As an example, consider the following Angular expression:
//
//   {}.toString.constructor('alert("evil JS code")')
//
// It is important to realize that if you create an expression from a string that contains user provided
// content then it is possible that your application contains a security vulnerability to an XSS style attack.
//
// See https://docs.angularjs.org/guide/security


function getStringValue(name) {
  // Property names must be strings. This means that non-string objects cannot be used
  // as keys in an object. Any non-string object, including a number, is typecasted
  // into a string via the toString method.
  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
  //
  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
  // to a string. It's not always possible. If `name` is an object and its `toString` method is
  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
  //
  // TypeError: Cannot convert object to primitive value
  //
  // For performance reasons, we don't catch this error here and allow it to propagate up the call
  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
  // such a 'broken' object as a key.
  return name + '';
}


var OPERATORS = createMap();
forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};


/////////////////////////////////////////


/**
 * @constructor
 */
var Lexer = function Lexer(options) {
  this.options = options;
};

Lexer.prototype = {
  constructor: Lexer,

  lex: function(text) {
    this.text = text;
    this.index = 0;
    this.tokens = [];

    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      if (ch === '"' || ch === '\'') {
        this.readString(ch);
      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
        this.readNumber();
      } else if (this.isIdentifierStart(this.peekMultichar())) {
        this.readIdent();
      } else if (this.is(ch, '(){}[].,;:?')) {
        this.tokens.push({index: this.index, text: ch});
        this.index++;
      } else if (this.isWhitespace(ch)) {
        this.index++;
      } else {
        var ch2 = ch + this.peek();
        var ch3 = ch2 + this.peek(2);
        var op1 = OPERATORS[ch];
        var op2 = OPERATORS[ch2];
        var op3 = OPERATORS[ch3];
        if (op1 || op2 || op3) {
          var token = op3 ? ch3 : (op2 ? ch2 : ch);
          this.tokens.push({index: this.index, text: token, operator: true});
          this.index += token.length;
        } else {
          this.throwError('Unexpected next character ', this.index, this.index + 1);
        }
      }
    }
    return this.tokens;
  },

  is: function(ch, chars) {
    return chars.indexOf(ch) !== -1;
  },

  peek: function(i) {
    var num = i || 1;
    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
  },

  isNumber: function(ch) {
    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
  },

  isWhitespace: function(ch) {
    // IE treats non-breaking space as \u00A0
    return (ch === ' ' || ch === '\r' || ch === '\t' ||
            ch === '\n' || ch === '\v' || ch === '\u00A0');
  },

  isIdentifierStart: function(ch) {
    return this.options.isIdentifierStart ?
        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
        this.isValidIdentifierStart(ch);
  },

  isValidIdentifierStart: function(ch) {
    return ('a' <= ch && ch <= 'z' ||
            'A' <= ch && ch <= 'Z' ||
            '_' === ch || ch === '$');
  },

  isIdentifierContinue: function(ch) {
    return this.options.isIdentifierContinue ?
        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
        this.isValidIdentifierContinue(ch);
  },

  isValidIdentifierContinue: function(ch, cp) {
    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
  },

  codePointAt: function(ch) {
    if (ch.length === 1) return ch.charCodeAt(0);
    // eslint-disable-next-line no-bitwise
    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
  },

  peekMultichar: function() {
    var ch = this.text.charAt(this.index);
    var peek = this.peek();
    if (!peek) {
      return ch;
    }
    var cp1 = ch.charCodeAt(0);
    var cp2 = peek.charCodeAt(0);
    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
      return ch + peek;
    }
    return ch;
  },

  isExpOperator: function(ch) {
    return (ch === '-' || ch === '+' || this.isNumber(ch));
  },

  throwError: function(error, start, end) {
    end = end || this.index;
    var colStr = (isDefined(start)
            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
            : ' ' + end);
    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
        error, colStr, this.text);
  },

  readNumber: function() {
    var number = '';
    var start = this.index;
    while (this.index < this.text.length) {
      var ch = lowercase(this.text.charAt(this.index));
      if (ch === '.' || this.isNumber(ch)) {
        number += ch;
      } else {
        var peekCh = this.peek();
        if (ch === 'e' && this.isExpOperator(peekCh)) {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            peekCh && this.isNumber(peekCh) &&
            number.charAt(number.length - 1) === 'e') {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            (!peekCh || !this.isNumber(peekCh)) &&
            number.charAt(number.length - 1) === 'e') {
          this.throwError('Invalid exponent');
        } else {
          break;
        }
      }
      this.index++;
    }
    this.tokens.push({
      index: start,
      text: number,
      constant: true,
      value: Number(number)
    });
  },

  readIdent: function() {
    var start = this.index;
    this.index += this.peekMultichar().length;
    while (this.index < this.text.length) {
      var ch = this.peekMultichar();
      if (!this.isIdentifierContinue(ch)) {
        break;
      }
      this.index += ch.length;
    }
    this.tokens.push({
      index: start,
      text: this.text.slice(start, this.index),
      identifier: true
    });
  },

  readString: function(quote) {
    var start = this.index;
    this.index++;
    var string = '';
    var rawString = quote;
    var escape = false;
    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      rawString += ch;
      if (escape) {
        if (ch === 'u') {
          var hex = this.text.substring(this.index + 1, this.index + 5);
          if (!hex.match(/[\da-f]{4}/i)) {
            this.throwError('Invalid unicode escape [\\u' + hex + ']');
          }
          this.index += 4;
          string += String.fromCharCode(parseInt(hex, 16));
        } else {
          var rep = ESCAPE[ch];
          string = string + (rep || ch);
        }
        escape = false;
      } else if (ch === '\\') {
        escape = true;
      } else if (ch === quote) {
        this.index++;
        this.tokens.push({
          index: start,
          text: rawString,
          constant: true,
          value: string
        });
        return;
      } else {
        string += ch;
      }
      this.index++;
    }
    this.throwError('Unterminated quote', start);
  }
};

var AST = function AST(lexer, options) {
  this.lexer = lexer;
  this.options = options;
};

AST.Program = 'Program';
AST.ExpressionStatement = 'ExpressionStatement';
AST.AssignmentExpression = 'AssignmentExpression';
AST.ConditionalExpression = 'ConditionalExpression';
AST.LogicalExpression = 'LogicalExpression';
AST.BinaryExpression = 'BinaryExpression';
AST.UnaryExpression = 'UnaryExpression';
AST.CallExpression = 'CallExpression';
AST.MemberExpression = 'MemberExpression';
AST.Identifier = 'Identifier';
AST.Literal = 'Literal';
AST.ArrayExpression = 'ArrayExpression';
AST.Property = 'Property';
AST.ObjectExpression = 'ObjectExpression';
AST.ThisExpression = 'ThisExpression';
AST.LocalsExpression = 'LocalsExpression';

// Internal use only
AST.NGValueParameter = 'NGValueParameter';

AST.prototype = {
  ast: function(text) {
    this.text = text;
    this.tokens = this.lexer.lex(text);

    var value = this.program();

    if (this.tokens.length !== 0) {
      this.throwError('is an unexpected token', this.tokens[0]);
    }

    return value;
  },

  program: function() {
    var body = [];
    while (true) {
      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
        body.push(this.expressionStatement());
      if (!this.expect(';')) {
        return { type: AST.Program, body: body};
      }
    }
  },

  expressionStatement: function() {
    return { type: AST.ExpressionStatement, expression: this.filterChain() };
  },

  filterChain: function() {
    var left = this.expression();
    while (this.expect('|')) {
      left = this.filter(left);
    }
    return left;
  },

  expression: function() {
    return this.assignment();
  },

  assignment: function() {
    var result = this.ternary();
    if (this.expect('=')) {
      if (!isAssignable(result)) {
        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
      }

      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
    }
    return result;
  },

  ternary: function() {
    var test = this.logicalOR();
    var alternate;
    var consequent;
    if (this.expect('?')) {
      alternate = this.expression();
      if (this.consume(':')) {
        consequent = this.expression();
        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
      }
    }
    return test;
  },

  logicalOR: function() {
    var left = this.logicalAND();
    while (this.expect('||')) {
      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
    }
    return left;
  },

  logicalAND: function() {
    var left = this.equality();
    while (this.expect('&&')) {
      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
    }
    return left;
  },

  equality: function() {
    var left = this.relational();
    var token;
    while ((token = this.expect('==','!=','===','!=='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
    }
    return left;
  },

  relational: function() {
    var left = this.additive();
    var token;
    while ((token = this.expect('<', '>', '<=', '>='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
    }
    return left;
  },

  additive: function() {
    var left = this.multiplicative();
    var token;
    while ((token = this.expect('+','-'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
    }
    return left;
  },

  multiplicative: function() {
    var left = this.unary();
    var token;
    while ((token = this.expect('*','/','%'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
    }
    return left;
  },

  unary: function() {
    var token;
    if ((token = this.expect('+', '-', '!'))) {
      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
    } else {
      return this.primary();
    }
  },

  primary: function() {
    var primary;
    if (this.expect('(')) {
      primary = this.filterChain();
      this.consume(')');
    } else if (this.expect('[')) {
      primary = this.arrayDeclaration();
    } else if (this.expect('{')) {
      primary = this.object();
    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
      primary = copy(this.selfReferential[this.consume().text]);
    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
    } else if (this.peek().identifier) {
      primary = this.identifier();
    } else if (this.peek().constant) {
      primary = this.constant();
    } else {
      this.throwError('not a primary expression', this.peek());
    }

    var next;
    while ((next = this.expect('(', '[', '.'))) {
      if (next.text === '(') {
        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
        this.consume(')');
      } else if (next.text === '[') {
        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
        this.consume(']');
      } else if (next.text === '.') {
        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
      } else {
        this.throwError('IMPOSSIBLE');
      }
    }
    return primary;
  },

  filter: function(baseExpression) {
    var args = [baseExpression];
    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};

    while (this.expect(':')) {
      args.push(this.expression());
    }

    return result;
  },

  parseArguments: function() {
    var args = [];
    if (this.peekToken().text !== ')') {
      do {
        args.push(this.filterChain());
      } while (this.expect(','));
    }
    return args;
  },

  identifier: function() {
    var token = this.consume();
    if (!token.identifier) {
      this.throwError('is not a valid identifier', token);
    }
    return { type: AST.Identifier, name: token.text };
  },

  constant: function() {
    // TODO check that it is a constant
    return { type: AST.Literal, value: this.consume().value };
  },

  arrayDeclaration: function() {
    var elements = [];
    if (this.peekToken().text !== ']') {
      do {
        if (this.peek(']')) {
          // Support trailing commas per ES5.1.
          break;
        }
        elements.push(this.expression());
      } while (this.expect(','));
    }
    this.consume(']');

    return { type: AST.ArrayExpression, elements: elements };
  },

  object: function() {
    var properties = [], property;
    if (this.peekToken().text !== '}') {
      do {
        if (this.peek('}')) {
          // Support trailing commas per ES5.1.
          break;
        }
        property = {type: AST.Property, kind: 'init'};
        if (this.peek().constant) {
          property.key = this.constant();
          property.computed = false;
          this.consume(':');
          property.value = this.expression();
        } else if (this.peek().identifier) {
          property.key = this.identifier();
          property.computed = false;
          if (this.peek(':')) {
            this.consume(':');
            property.value = this.expression();
          } else {
            property.value = property.key;
          }
        } else if (this.peek('[')) {
          this.consume('[');
          property.key = this.expression();
          this.consume(']');
          property.computed = true;
          this.consume(':');
          property.value = this.expression();
        } else {
          this.throwError('invalid key', this.peek());
        }
        properties.push(property);
      } while (this.expect(','));
    }
    this.consume('}');

    return {type: AST.ObjectExpression, properties: properties };
  },

  throwError: function(msg, token) {
    throw $parseMinErr('syntax',
        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
  },

  consume: function(e1) {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }

    var token = this.expect(e1);
    if (!token) {
      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
    }
    return token;
  },

  peekToken: function() {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }
    return this.tokens[0];
  },

  peek: function(e1, e2, e3, e4) {
    return this.peekAhead(0, e1, e2, e3, e4);
  },

  peekAhead: function(i, e1, e2, e3, e4) {
    if (this.tokens.length > i) {
      var token = this.tokens[i];
      var t = token.text;
      if (t === e1 || t === e2 || t === e3 || t === e4 ||
          (!e1 && !e2 && !e3 && !e4)) {
        return token;
      }
    }
    return false;
  },

  expect: function(e1, e2, e3, e4) {
    var token = this.peek(e1, e2, e3, e4);
    if (token) {
      this.tokens.shift();
      return token;
    }
    return false;
  },

  selfReferential: {
    'this': {type: AST.ThisExpression },
    '$locals': {type: AST.LocalsExpression }
  }
};

function ifDefined(v, d) {
  return typeof v !== 'undefined' ? v : d;
}

function plusFn(l, r) {
  if (typeof l === 'undefined') return r;
  if (typeof r === 'undefined') return l;
  return l + r;
}

function isStateless($filter, filterName) {
  var fn = $filter(filterName);
  return !fn.$stateful;
}

function findConstantAndWatchExpressions(ast, $filter) {
  var allConstants;
  var argsToWatch;
  var isStatelessFilter;
  switch (ast.type) {
  case AST.Program:
    allConstants = true;
    forEach(ast.body, function(expr) {
      findConstantAndWatchExpressions(expr.expression, $filter);
      allConstants = allConstants && expr.expression.constant;
    });
    ast.constant = allConstants;
    break;
  case AST.Literal:
    ast.constant = true;
    ast.toWatch = [];
    break;
  case AST.UnaryExpression:
    findConstantAndWatchExpressions(ast.argument, $filter);
    ast.constant = ast.argument.constant;
    ast.toWatch = ast.argument.toWatch;
    break;
  case AST.BinaryExpression:
    findConstantAndWatchExpressions(ast.left, $filter);
    findConstantAndWatchExpressions(ast.right, $filter);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
    break;
  case AST.LogicalExpression:
    findConstantAndWatchExpressions(ast.left, $filter);
    findConstantAndWatchExpressions(ast.right, $filter);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.ConditionalExpression:
    findConstantAndWatchExpressions(ast.test, $filter);
    findConstantAndWatchExpressions(ast.alternate, $filter);
    findConstantAndWatchExpressions(ast.consequent, $filter);
    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.Identifier:
    ast.constant = false;
    ast.toWatch = [ast];
    break;
  case AST.MemberExpression:
    findConstantAndWatchExpressions(ast.object, $filter);
    if (ast.computed) {
      findConstantAndWatchExpressions(ast.property, $filter);
    }
    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
    ast.toWatch = [ast];
    break;
  case AST.CallExpression:
    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
    allConstants = isStatelessFilter;
    argsToWatch = [];
    forEach(ast.arguments, function(expr) {
      findConstantAndWatchExpressions(expr, $filter);
      allConstants = allConstants && expr.constant;
      if (!expr.constant) {
        argsToWatch.push.apply(argsToWatch, expr.toWatch);
      }
    });
    ast.constant = allConstants;
    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
    break;
  case AST.AssignmentExpression:
    findConstantAndWatchExpressions(ast.left, $filter);
    findConstantAndWatchExpressions(ast.right, $filter);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = [ast];
    break;
  case AST.ArrayExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.elements, function(expr) {
      findConstantAndWatchExpressions(expr, $filter);
      allConstants = allConstants && expr.constant;
      if (!expr.constant) {
        argsToWatch.push.apply(argsToWatch, expr.toWatch);
      }
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ObjectExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.properties, function(property) {
      findConstantAndWatchExpressions(property.value, $filter);
      allConstants = allConstants && property.value.constant && !property.computed;
      if (!property.value.constant) {
        argsToWatch.push.apply(argsToWatch, property.value.toWatch);
      }
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ThisExpression:
    ast.constant = false;
    ast.toWatch = [];
    break;
  case AST.LocalsExpression:
    ast.constant = false;
    ast.toWatch = [];
    break;
  }
}

function getInputs(body) {
  if (body.length !== 1) return;
  var lastExpression = body[0].expression;
  var candidate = lastExpression.toWatch;
  if (candidate.length !== 1) return candidate;
  return candidate[0] !== lastExpression ? candidate : undefined;
}

function isAssignable(ast) {
  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
}

function assignableAST(ast) {
  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
  }
}

function isLiteral(ast) {
  return ast.body.length === 0 ||
      ast.body.length === 1 && (
      ast.body[0].expression.type === AST.Literal ||
      ast.body[0].expression.type === AST.ArrayExpression ||
      ast.body[0].expression.type === AST.ObjectExpression);
}

function isConstant(ast) {
  return ast.constant;
}

function ASTCompiler(astBuilder, $filter) {
  this.astBuilder = astBuilder;
  this.$filter = $filter;
}

ASTCompiler.prototype = {
  compile: function(expression) {
    var self = this;
    var ast = this.astBuilder.ast(expression);
    this.state = {
      nextId: 0,
      filters: {},
      fn: {vars: [], body: [], own: {}},
      assign: {vars: [], body: [], own: {}},
      inputs: []
    };
    findConstantAndWatchExpressions(ast, self.$filter);
    var extra = '';
    var assignable;
    this.stage = 'assign';
    if ((assignable = assignableAST(ast))) {
      this.state.computing = 'assign';
      var result = this.nextId();
      this.recurse(assignable, result);
      this.return_(result);
      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
    }
    var toWatch = getInputs(ast.body);
    self.stage = 'inputs';
    forEach(toWatch, function(watch, key) {
      var fnKey = 'fn' + key;
      self.state[fnKey] = {vars: [], body: [], own: {}};
      self.state.computing = fnKey;
      var intoId = self.nextId();
      self.recurse(watch, intoId);
      self.return_(intoId);
      self.state.inputs.push(fnKey);
      watch.watchId = key;
    });
    this.state.computing = 'fn';
    this.stage = 'main';
    this.recurse(ast);
    var fnString =
      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
      '"' + this.USE + ' ' + this.STRICT + '";\n' +
      this.filterPrefix() +
      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
      extra +
      this.watchFns() +
      'return fn;';

    // eslint-disable-next-line no-new-func
    var fn = (new Function('$filter',
        'getStringValue',
        'ifDefined',
        'plus',
        fnString))(
          this.$filter,
          getStringValue,
          ifDefined,
          plusFn);
    this.state = this.stage = undefined;
    fn.literal = isLiteral(ast);
    fn.constant = isConstant(ast);
    return fn;
  },

  USE: 'use',

  STRICT: 'strict',

  watchFns: function() {
    var result = [];
    var fns = this.state.inputs;
    var self = this;
    forEach(fns, function(name) {
      result.push('var ' + name + '=' + self.generateFunction(name, 's'));
    });
    if (fns.length) {
      result.push('fn.inputs=[' + fns.join(',') + '];');
    }
    return result.join('');
  },

  generateFunction: function(name, params) {
    return 'function(' + params + '){' +
        this.varsPrefix(name) +
        this.body(name) +
        '};';
  },

  filterPrefix: function() {
    var parts = [];
    var self = this;
    forEach(this.state.filters, function(id, filter) {
      parts.push(id + '=$filter(' + self.escape(filter) + ')');
    });
    if (parts.length) return 'var ' + parts.join(',') + ';';
    return '';
  },

  varsPrefix: function(section) {
    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
  },

  body: function(section) {
    return this.state[section].body.join('');
  },

  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var left, right, self = this, args, expression, computed;
    recursionFn = recursionFn || noop;
    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
      intoId = intoId || this.nextId();
      this.if_('i',
        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
      );
      return;
    }
    switch (ast.type) {
    case AST.Program:
      forEach(ast.body, function(expression, pos) {
        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
        if (pos !== ast.body.length - 1) {
          self.current().body.push(right, ';');
        } else {
          self.return_(right);
        }
      });
      break;
    case AST.Literal:
      expression = this.escape(ast.value);
      this.assign(intoId, expression);
      recursionFn(intoId || expression);
      break;
    case AST.UnaryExpression:
      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.BinaryExpression:
      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
      if (ast.operator === '+') {
        expression = this.plus(left, right);
      } else if (ast.operator === '-') {
        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
      } else {
        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
      }
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.LogicalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.left, intoId);
      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
      recursionFn(intoId);
      break;
    case AST.ConditionalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.test, intoId);
      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
      recursionFn(intoId);
      break;
    case AST.Identifier:
      intoId = intoId || this.nextId();
      if (nameId) {
        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
        nameId.computed = false;
        nameId.name = ast.name;
      }
      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
        function() {
          self.if_(self.stage === 'inputs' || 's', function() {
            if (create && create !== 1) {
              self.if_(
                self.isNull(self.nonComputedMember('s', ast.name)),
                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
            }
            self.assign(intoId, self.nonComputedMember('s', ast.name));
          });
        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
        );
      recursionFn(intoId);
      break;
    case AST.MemberExpression:
      left = nameId && (nameId.context = this.nextId()) || this.nextId();
      intoId = intoId || this.nextId();
      self.recurse(ast.object, left, undefined, function() {
        self.if_(self.notNull(left), function() {
          if (ast.computed) {
            right = self.nextId();
            self.recurse(ast.property, right);
            self.getStringValue(right);
            if (create && create !== 1) {
              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
            }
            expression = self.computedMember(left, right);
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = true;
              nameId.name = right;
            }
          } else {
            if (create && create !== 1) {
              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
            }
            expression = self.nonComputedMember(left, ast.property.name);
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = false;
              nameId.name = ast.property.name;
            }
          }
        }, function() {
          self.assign(intoId, 'undefined');
        });
        recursionFn(intoId);
      }, !!create);
      break;
    case AST.CallExpression:
      intoId = intoId || this.nextId();
      if (ast.filter) {
        right = self.filter(ast.callee.name);
        args = [];
        forEach(ast.arguments, function(expr) {
          var argument = self.nextId();
          self.recurse(expr, argument);
          args.push(argument);
        });
        expression = right + '(' + args.join(',') + ')';
        self.assign(intoId, expression);
        recursionFn(intoId);
      } else {
        right = self.nextId();
        left = {};
        args = [];
        self.recurse(ast.callee, right, left, function() {
          self.if_(self.notNull(right), function() {
            forEach(ast.arguments, function(expr) {
              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
                args.push(argument);
              });
            });
            if (left.name) {
              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
            } else {
              expression = right + '(' + args.join(',') + ')';
            }
            self.assign(intoId, expression);
          }, function() {
            self.assign(intoId, 'undefined');
          });
          recursionFn(intoId);
        });
      }
      break;
    case AST.AssignmentExpression:
      right = this.nextId();
      left = {};
      this.recurse(ast.left, undefined, left, function() {
        self.if_(self.notNull(left.context), function() {
          self.recurse(ast.right, right);
          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
          self.assign(intoId, expression);
          recursionFn(intoId || expression);
        });
      }, 1);
      break;
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
          args.push(argument);
        });
      });
      expression = '[' + args.join(',') + ']';
      this.assign(intoId, expression);
      recursionFn(intoId || expression);
      break;
    case AST.ObjectExpression:
      args = [];
      computed = false;
      forEach(ast.properties, function(property) {
        if (property.computed) {
          computed = true;
        }
      });
      if (computed) {
        intoId = intoId || this.nextId();
        this.assign(intoId, '{}');
        forEach(ast.properties, function(property) {
          if (property.computed) {
            left = self.nextId();
            self.recurse(property.key, left);
          } else {
            left = property.key.type === AST.Identifier ?
                       property.key.name :
                       ('' + property.key.value);
          }
          right = self.nextId();
          self.recurse(property.value, right);
          self.assign(self.member(intoId, left, property.computed), right);
        });
      } else {
        forEach(ast.properties, function(property) {
          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
            args.push(self.escape(
                property.key.type === AST.Identifier ? property.key.name :
                  ('' + property.key.value)) +
                ':' + expr);
          });
        });
        expression = '{' + args.join(',') + '}';
        this.assign(intoId, expression);
      }
      recursionFn(intoId || expression);
      break;
    case AST.ThisExpression:
      this.assign(intoId, 's');
      recursionFn(intoId || 's');
      break;
    case AST.LocalsExpression:
      this.assign(intoId, 'l');
      recursionFn(intoId || 'l');
      break;
    case AST.NGValueParameter:
      this.assign(intoId, 'v');
      recursionFn(intoId || 'v');
      break;
    }
  },

  getHasOwnProperty: function(element, property) {
    var key = element + '.' + property;
    var own = this.current().own;
    if (!own.hasOwnProperty(key)) {
      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
    }
    return own[key];
  },

  assign: function(id, value) {
    if (!id) return;
    this.current().body.push(id, '=', value, ';');
    return id;
  },

  filter: function(filterName) {
    if (!this.state.filters.hasOwnProperty(filterName)) {
      this.state.filters[filterName] = this.nextId(true);
    }
    return this.state.filters[filterName];
  },

  ifDefined: function(id, defaultValue) {
    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
  },

  plus: function(left, right) {
    return 'plus(' + left + ',' + right + ')';
  },

  return_: function(id) {
    this.current().body.push('return ', id, ';');
  },

  if_: function(test, alternate, consequent) {
    if (test === true) {
      alternate();
    } else {
      var body = this.current().body;
      body.push('if(', test, '){');
      alternate();
      body.push('}');
      if (consequent) {
        body.push('else{');
        consequent();
        body.push('}');
      }
    }
  },

  not: function(expression) {
    return '!(' + expression + ')';
  },

  isNull: function(expression) {
    return expression + '==null';
  },

  notNull: function(expression) {
    return expression + '!=null';
  },

  nonComputedMember: function(left, right) {
    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
    if (SAFE_IDENTIFIER.test(right)) {
      return left + '.' + right;
    } else {
      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
    }
  },

  computedMember: function(left, right) {
    return left + '[' + right + ']';
  },

  member: function(left, right, computed) {
    if (computed) return this.computedMember(left, right);
    return this.nonComputedMember(left, right);
  },

  getStringValue: function(item) {
    this.assign(item, 'getStringValue(' + item + ')');
  },

  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var self = this;
    return function() {
      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
    };
  },

  lazyAssign: function(id, value) {
    var self = this;
    return function() {
      self.assign(id, value);
    };
  },

  stringEscapeRegex: /[^ a-zA-Z0-9]/g,

  stringEscapeFn: function(c) {
    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
  },

  escape: function(value) {
    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
    if (isNumber(value)) return value.toString();
    if (value === true) return 'true';
    if (value === false) return 'false';
    if (value === null) return 'null';
    if (typeof value === 'undefined') return 'undefined';

    throw $parseMinErr('esc', 'IMPOSSIBLE');
  },

  nextId: function(skip, init) {
    var id = 'v' + (this.state.nextId++);
    if (!skip) {
      this.current().vars.push(id + (init ? '=' + init : ''));
    }
    return id;
  },

  current: function() {
    return this.state[this.state.computing];
  }
};


function ASTInterpreter(astBuilder, $filter) {
  this.astBuilder = astBuilder;
  this.$filter = $filter;
}

ASTInterpreter.prototype = {
  compile: function(expression) {
    var self = this;
    var ast = this.astBuilder.ast(expression);
    findConstantAndWatchExpressions(ast, self.$filter);
    var assignable;
    var assign;
    if ((assignable = assignableAST(ast))) {
      assign = this.recurse(assignable);
    }
    var toWatch = getInputs(ast.body);
    var inputs;
    if (toWatch) {
      inputs = [];
      forEach(toWatch, function(watch, key) {
        var input = self.recurse(watch);
        watch.input = input;
        inputs.push(input);
        watch.watchId = key;
      });
    }
    var expressions = [];
    forEach(ast.body, function(expression) {
      expressions.push(self.recurse(expression.expression));
    });
    var fn = ast.body.length === 0 ? noop :
             ast.body.length === 1 ? expressions[0] :
             function(scope, locals) {
               var lastValue;
               forEach(expressions, function(exp) {
                 lastValue = exp(scope, locals);
               });
               return lastValue;
             };
    if (assign) {
      fn.assign = function(scope, value, locals) {
        return assign(scope, locals, value);
      };
    }
    if (inputs) {
      fn.inputs = inputs;
    }
    fn.literal = isLiteral(ast);
    fn.constant = isConstant(ast);
    return fn;
  },

  recurse: function(ast, context, create) {
    var left, right, self = this, args;
    if (ast.input) {
      return this.inputs(ast.input, ast.watchId);
    }
    switch (ast.type) {
    case AST.Literal:
      return this.value(ast.value, context);
    case AST.UnaryExpression:
      right = this.recurse(ast.argument);
      return this['unary' + ast.operator](right, context);
    case AST.BinaryExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.LogicalExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.ConditionalExpression:
      return this['ternary?:'](
        this.recurse(ast.test),
        this.recurse(ast.alternate),
        this.recurse(ast.consequent),
        context
      );
    case AST.Identifier:
      return self.identifier(ast.name, context, create);
    case AST.MemberExpression:
      left = this.recurse(ast.object, false, !!create);
      if (!ast.computed) {
        right = ast.property.name;
      }
      if (ast.computed) right = this.recurse(ast.property);
      return ast.computed ?
        this.computedMember(left, right, context, create) :
        this.nonComputedMember(left, right, context, create);
    case AST.CallExpression:
      args = [];
      forEach(ast.arguments, function(expr) {
        args.push(self.recurse(expr));
      });
      if (ast.filter) right = this.$filter(ast.callee.name);
      if (!ast.filter) right = this.recurse(ast.callee, true);
      return ast.filter ?
        function(scope, locals, assign, inputs) {
          var values = [];
          for (var i = 0; i < args.length; ++i) {
            values.push(args[i](scope, locals, assign, inputs));
          }
          var value = right.apply(undefined, values, inputs);
          return context ? {context: undefined, name: undefined, value: value} : value;
        } :
        function(scope, locals, assign, inputs) {
          var rhs = right(scope, locals, assign, inputs);
          var value;
          if (rhs.value != null) {
            var values = [];
            for (var i = 0; i < args.length; ++i) {
              values.push(args[i](scope, locals, assign, inputs));
            }
            value = rhs.value.apply(rhs.context, values);
          }
          return context ? {value: value} : value;
        };
    case AST.AssignmentExpression:
      left = this.recurse(ast.left, true, 1);
      right = this.recurse(ast.right);
      return function(scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs = right(scope, locals, assign, inputs);
        lhs.context[lhs.name] = rhs;
        return context ? {value: rhs} : rhs;
      };
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        args.push(self.recurse(expr));
      });
      return function(scope, locals, assign, inputs) {
        var value = [];
        for (var i = 0; i < args.length; ++i) {
          value.push(args[i](scope, locals, assign, inputs));
        }
        return context ? {value: value} : value;
      };
    case AST.ObjectExpression:
      args = [];
      forEach(ast.properties, function(property) {
        if (property.computed) {
          args.push({key: self.recurse(property.key),
                     computed: true,
                     value: self.recurse(property.value)
          });
        } else {
          args.push({key: property.key.type === AST.Identifier ?
                          property.key.name :
                          ('' + property.key.value),
                     computed: false,
                     value: self.recurse(property.value)
          });
        }
      });
      return function(scope, locals, assign, inputs) {
        var value = {};
        for (var i = 0; i < args.length; ++i) {
          if (args[i].computed) {
            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
          } else {
            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
          }
        }
        return context ? {value: value} : value;
      };
    case AST.ThisExpression:
      return function(scope) {
        return context ? {value: scope} : scope;
      };
    case AST.LocalsExpression:
      return function(scope, locals) {
        return context ? {value: locals} : locals;
      };
    case AST.NGValueParameter:
      return function(scope, locals, assign) {
        return context ? {value: assign} : assign;
      };
    }
  },

  'unary+': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = +arg;
      } else {
        arg = 0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary-': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = -arg;
      } else {
        arg = -0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary!': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = !argument(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary+': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = plusFn(lhs, rhs);
      return context ? {value: arg} : arg;
    };
  },
  'binary-': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
      return context ? {value: arg} : arg;
    };
  },
  'binary*': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary/': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary%': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary===': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      // eslint-disable-next-line eqeqeq
      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      // eslint-disable-next-line eqeqeq
      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary&&': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary||': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'ternary?:': function(test, alternate, consequent, context) {
    return function(scope, locals, assign, inputs) {
      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  value: function(value, context) {
    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
  },
  identifier: function(name, context, create) {
    return function(scope, locals, assign, inputs) {
      var base = locals && (name in locals) ? locals : scope;
      if (create && create !== 1 && base && base[name] == null) {
        base[name] = {};
      }
      var value = base ? base[name] : undefined;
      if (context) {
        return {context: base, name: name, value: value};
      } else {
        return value;
      }
    };
  },
  computedMember: function(left, right, context, create) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs;
      var value;
      if (lhs != null) {
        rhs = right(scope, locals, assign, inputs);
        rhs = getStringValue(rhs);
        if (create && create !== 1) {
          if (lhs && !(lhs[rhs])) {
            lhs[rhs] = {};
          }
        }
        value = lhs[rhs];
      }
      if (context) {
        return {context: lhs, name: rhs, value: value};
      } else {
        return value;
      }
    };
  },
  nonComputedMember: function(left, right, context, create) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      if (create && create !== 1) {
        if (lhs && lhs[right] == null) {
          lhs[right] = {};
        }
      }
      var value = lhs != null ? lhs[right] : undefined;
      if (context) {
        return {context: lhs, name: right, value: value};
      } else {
        return value;
      }
    };
  },
  inputs: function(input, watchId) {
    return function(scope, value, locals, inputs) {
      if (inputs) return inputs[watchId];
      return input(scope, value, locals);
    };
  }
};

/**
 * @constructor
 */
var Parser = function Parser(lexer, $filter, options) {
  this.lexer = lexer;
  this.$filter = $filter;
  this.options = options;
  this.ast = new AST(lexer, options);
  this.astCompiler = options.csp ? new ASTInterpreter(this.ast, $filter) :
                                   new ASTCompiler(this.ast, $filter);
};

Parser.prototype = {
  constructor: Parser,

  parse: function(text) {
    return this.astCompiler.compile(text);
  }
};

function getValueOf(value) {
  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
}

///////////////////////////////////

/**
 * @ngdoc service
 * @name $parse
 * @kind function
 *
 * @description
 *
 * Converts Angular {@link guide/expression expression} into a function.
 *
 * ```js
 *   var getter = $parse('user.name');
 *   var setter = getter.assign;
 *   var context = {user:{name:'angular'}};
 *   var locals = {user:{name:'local'}};
 *
 *   expect(getter(context)).toEqual('angular');
 *   setter(context, 'newValue');
 *   expect(context.user.name).toEqual('newValue');
 *   expect(getter(context, locals)).toEqual('local');
 * ```
 *
 *
 * @param {string} expression String expression to compile.
 * @returns {function(context, locals)} a function which represents the compiled expression:
 *
 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
 *      are evaluated against (typically a scope object).
 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
 *      `context`.
 *
 *    The returned function also has the following properties:
 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
 *        literal.
 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
 *        constant literals.
 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
 *        set to a function to change its value on the given context.
 *
 */


/**
 * @ngdoc provider
 * @name $parseProvider
 * @this
 *
 * @description
 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
 *  service.
 */
function $ParseProvider() {
  var cache = createMap();
  var literals = {
    'true': true,
    'false': false,
    'null': null,
    'undefined': undefined
  };
  var identStart, identContinue;

  /**
   * @ngdoc method
   * @name $parseProvider#addLiteral
   * @description
   *
   * Configure $parse service to add literal values that will be present as literal at expressions.
   *
   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
   *
   **/
  this.addLiteral = function(literalName, literalValue) {
    literals[literalName] = literalValue;
  };

 /**
  * @ngdoc method
  * @name $parseProvider#setIdentifierFns
  *
  * @description
  *
  * Allows defining the set of characters that are allowed in Angular expressions. The function
  * `identifierStart` will get called to know if a given character is a valid character to be the
  * first character for an identifier. The function `identifierContinue` will get called to know if
  * a given character is a valid character to be a follow-up identifier character. The functions
  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
  * mind that the `string` parameter can be two characters long depending on the character
  * representation. It is expected for the function to return `true` or `false`, whether that
  * character is allowed or not.
  *
  * Since this function will be called extensively, keep the implementation of these functions fast,
  * as the performance of these functions have a direct impact on the expressions parsing speed.
  *
  * @param {function=} identifierStart The function that will decide whether the given character is
  *   a valid identifier start character.
  * @param {function=} identifierContinue The function that will decide whether the given character is
  *   a valid identifier continue character.
  */
  this.setIdentifierFns = function(identifierStart, identifierContinue) {
    identStart = identifierStart;
    identContinue = identifierContinue;
    return this;
  };

  this.$get = ['$filter', function($filter) {
    var noUnsafeEval = csp().noUnsafeEval;
    var $parseOptions = {
          csp: noUnsafeEval,
          literals: copy(literals),
          isIdentifierStart: isFunction(identStart) && identStart,
          isIdentifierContinue: isFunction(identContinue) && identContinue
        };
    return $parse;

    function $parse(exp, interceptorFn) {
      var parsedExpression, oneTime, cacheKey;

      switch (typeof exp) {
        case 'string':
          exp = exp.trim();
          cacheKey = exp;

          parsedExpression = cache[cacheKey];

          if (!parsedExpression) {
            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
              oneTime = true;
              exp = exp.substring(2);
            }
            var lexer = new Lexer($parseOptions);
            var parser = new Parser(lexer, $filter, $parseOptions);
            parsedExpression = parser.parse(exp);
            if (parsedExpression.constant) {
              parsedExpression.$$watchDelegate = constantWatchDelegate;
            } else if (oneTime) {
              parsedExpression.$$watchDelegate = parsedExpression.literal ?
                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
            } else if (parsedExpression.inputs) {
              parsedExpression.$$watchDelegate = inputsWatchDelegate;
            }
            cache[cacheKey] = parsedExpression;
          }
          return addInterceptor(parsedExpression, interceptorFn);

        case 'function':
          return addInterceptor(exp, interceptorFn);

        default:
          return addInterceptor(noop, interceptorFn);
      }
    }

    function expressionInputDirtyCheck(newValue, oldValueOfValue) {

      if (newValue == null || oldValueOfValue == null) { // null/undefined
        return newValue === oldValueOfValue;
      }

      if (typeof newValue === 'object') {

        // attempt to convert the value to a primitive type
        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
        //             be cheaply dirty-checked
        newValue = getValueOf(newValue);

        if (typeof newValue === 'object') {
          // objects/arrays are not supported - deep-watching them would be too expensive
          return false;
        }

        // fall-through to the primitive equality check
      }

      //Primitive or NaN
      // eslint-disable-next-line no-self-compare
      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
    }

    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
      var inputExpressions = parsedExpression.inputs;
      var lastResult;

      if (inputExpressions.length === 1) {
        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
        inputExpressions = inputExpressions[0];
        return scope.$watch(function expressionInputWatch(scope) {
          var newInputValue = inputExpressions(scope);
          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf)) {
            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
            oldInputValueOf = newInputValue && getValueOf(newInputValue);
          }
          return lastResult;
        }, listener, objectEquality, prettyPrintExpression);
      }

      var oldInputValueOfValues = [];
      var oldInputValues = [];
      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
        oldInputValues[i] = null;
      }

      return scope.$watch(function expressionInputsWatch(scope) {
        var changed = false;

        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
          var newInputValue = inputExpressions[i](scope);
          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i]))) {
            oldInputValues[i] = newInputValue;
            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
          }
        }

        if (changed) {
          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
        }

        return lastResult;
      }, listener, objectEquality, prettyPrintExpression);
    }

    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
      var unwatch, lastValue;
      if (parsedExpression.inputs) {
        unwatch = inputsWatchDelegate(scope, oneTimeListener, objectEquality, parsedExpression, prettyPrintExpression);
      } else {
        unwatch = scope.$watch(oneTimeWatch, oneTimeListener, objectEquality);
      }
      return unwatch;

      function oneTimeWatch(scope) {
        return parsedExpression(scope);
      }
      function oneTimeListener(value, old, scope) {
        lastValue = value;
        if (isFunction(listener)) {
          listener(value, old, scope);
        }
        if (isDefined(value)) {
          scope.$$postDigest(function() {
            if (isDefined(lastValue)) {
              unwatch();
            }
          });
        }
      }
    }

    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch, lastValue;
      unwatch = scope.$watch(function oneTimeWatch(scope) {
        return parsedExpression(scope);
      }, function oneTimeListener(value, old, scope) {
        lastValue = value;
        if (isFunction(listener)) {
          listener(value, old, scope);
        }
        if (isAllDefined(value)) {
          scope.$$postDigest(function() {
            if (isAllDefined(lastValue)) unwatch();
          });
        }
      }, objectEquality);

      return unwatch;

      function isAllDefined(value) {
        var allDefined = true;
        forEach(value, function(val) {
          if (!isDefined(val)) allDefined = false;
        });
        return allDefined;
      }
    }

    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch = scope.$watch(function constantWatch(scope) {
        unwatch();
        return parsedExpression(scope);
      }, listener, objectEquality);
      return unwatch;
    }

    function addInterceptor(parsedExpression, interceptorFn) {
      if (!interceptorFn) return parsedExpression;
      var watchDelegate = parsedExpression.$$watchDelegate;
      var useInputs = false;

      var regularWatch =
          watchDelegate !== oneTimeLiteralWatchDelegate &&
          watchDelegate !== oneTimeWatchDelegate;

      var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
        return interceptorFn(value, scope, locals);
      } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
        var value = parsedExpression(scope, locals, assign, inputs);
        var result = interceptorFn(value, scope, locals);
        // we only return the interceptor's result if the
        // initial value is defined (for bind-once)
        return isDefined(value) ? result : value;
      };

      // Propagate $$watchDelegates other then inputsWatchDelegate
      useInputs = !parsedExpression.inputs;
      if (parsedExpression.$$watchDelegate &&
          parsedExpression.$$watchDelegate !== inputsWatchDelegate) {
        fn.$$watchDelegate = parsedExpression.$$watchDelegate;
        fn.inputs = parsedExpression.inputs;
      } else if (!interceptorFn.$stateful) {
        // If there is an interceptor, but no watchDelegate then treat the interceptor like
        // we treat filters - it is assumed to be a pure function unless flagged with $stateful
        fn.$$watchDelegate = inputsWatchDelegate;
        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
      }

      return fn;
    }
  }];
}

/**
 * @ngdoc service
 * @name $q
 * @requires $rootScope
 *
 * @description
 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
 * when they are done processing.
 *
 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
 *
 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
 *
 * # $q constructor
 *
 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
 * function as the first argument. This is similar to the native Promise implementation from ES6,
 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 *
 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
 * available yet.
 *
 * It can be used like so:
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
 *     return $q(function(resolve, reject) {
 *       setTimeout(function() {
 *         if (okToGreet(name)) {
 *           resolve('Hello, ' + name + '!');
 *         } else {
 *           reject('Greeting ' + name + ' is not allowed.');
 *         }
 *       }, 1000);
 *     });
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   });
 * ```
 *
 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
 *
 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
 *
 * However, the more traditional CommonJS-style usage is still available, and documented below.
 *
 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
 * interface for interacting with an object that represents the result of an action that is
 * performed asynchronously, and may or may not be finished at any given point in time.
 *
 * From the perspective of dealing with error handling, deferred and promise APIs are to
 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     var deferred = $q.defer();
 *
 *     setTimeout(function() {
 *       deferred.notify('About to greet ' + name + '.');
 *
 *       if (okToGreet(name)) {
 *         deferred.resolve('Hello, ' + name + '!');
 *       } else {
 *         deferred.reject('Greeting ' + name + ' is not allowed.');
 *       }
 *     }, 1000);
 *
 *     return deferred.promise;
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   }, function(update) {
 *     alert('Got notification: ' + update);
 *   });
 * ```
 *
 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
 * comes in the way of guarantees that promise and deferred APIs make, see
 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
 *
 * Additionally the promise api allows for composition that is very hard to do with the
 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
 * section on serial or parallel joining of promises.
 *
 * # The Deferred API
 *
 * A new instance of deferred is constructed by calling `$q.defer()`.
 *
 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
 * that can be used for signaling the successful or unsuccessful completion, as well as the status
 * of the task.
 *
 * **Methods**
 *
 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
 *   constructed via `$q.reject`, the promise will be rejected instead.
 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
 *   resolving it with a rejection constructed via `$q.reject`.
 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
 *   multiple times before the promise is either resolved or rejected.
 *
 * **Properties**
 *
 * - promise – `{Promise}` – promise object associated with this deferred.
 *
 *
 * # The Promise API
 *
 * A new promise instance is created when a deferred instance is created and can be retrieved by
 * calling `deferred.promise`.
 *
 * The purpose of the promise object is to allow for interested parties to get access to the result
 * of the deferred task when it completes.
 *
 * **Methods**
 *
 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
 *   as soon as the result is available. The callbacks are called with a single argument: the result
 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
 *   provide a progress indication, before the promise is resolved or rejected.
 *
 *   This method *returns a new promise* which is resolved or rejected via the return value of the
 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
 *   with the value which is resolved in that promise using
 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
 *   arguments are optional.
 *
 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
 *
 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
 *   but to do so without modifying the final value. This is useful to release resources or do some
 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
 *   more information.
 *
 * # Chaining promises
 *
 * Because calling the `then` method of a promise returns a new derived promise, it is easily
 * possible to create a chain of promises:
 *
 * ```js
 *   promiseB = promiseA.then(function(result) {
 *     return result + 1;
 *   });
 *
 *   // promiseB will be resolved immediately after promiseA is resolved and its value
 *   // will be the result of promiseA incremented by 1
 * ```
 *
 * It is possible to create chains of any length and since a promise can be resolved with another
 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
 * $http's response interceptors.
 *
 *
 * # Differences between Kris Kowal's Q and $q
 *
 *  There are two main differences:
 *
 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
 *   mechanism in angular, which means faster propagation of resolution or rejection into your
 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
 *   all the important functionality needed for common async tasks.
 *
 * # Testing
 *
 *  ```js
 *    it('should simulate promise', inject(function($q, $rootScope) {
 *      var deferred = $q.defer();
 *      var promise = deferred.promise;
 *      var resolvedValue;
 *
 *      promise.then(function(value) { resolvedValue = value; });
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Simulate resolving of promise
 *      deferred.resolve(123);
 *      // Note that the 'then' function does not get called synchronously.
 *      // This is because we want the promise API to always be async, whether or not
 *      // it got called synchronously or asynchronously.
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Propagate promise resolution to 'then' functions using $apply().
 *      $rootScope.$apply();
 *      expect(resolvedValue).toEqual(123);
 *    }));
 *  ```
 *
 * @param {function(function, function)} resolver Function which is responsible for resolving or
 *   rejecting the newly created promise. The first parameter is a function which resolves the
 *   promise, the second parameter is a function which rejects the promise.
 *
 * @returns {Promise} The newly created promise.
 */
/**
 * @ngdoc provider
 * @name $qProvider
 * @this
 *
 * @description
 */
function $QProvider() {
  var errorOnUnhandledRejections = true;
  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
    return qFactory(function(callback) {
      $rootScope.$evalAsync(callback);
    }, $exceptionHandler, errorOnUnhandledRejections);
  }];

  /**
   * @ngdoc method
   * @name $qProvider#errorOnUnhandledRejections
   * @kind function
   *
   * @description
   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
   * This feature is enabled by default.
   *
   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
   *    chaining otherwise.
   */
  this.errorOnUnhandledRejections = function(value) {
    if (isDefined(value)) {
      errorOnUnhandledRejections = value;
      return this;
    } else {
      return errorOnUnhandledRejections;
    }
  };
}

/** @this */
function $$QProvider() {
  var errorOnUnhandledRejections = true;
  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
    return qFactory(function(callback) {
      $browser.defer(callback);
    }, $exceptionHandler, errorOnUnhandledRejections);
  }];

  this.errorOnUnhandledRejections = function(value) {
    if (isDefined(value)) {
      errorOnUnhandledRejections = value;
      return this;
    } else {
      return errorOnUnhandledRejections;
    }
  };
}

/**
 * Constructs a promise manager.
 *
 * @param {function(function)} nextTick Function for executing functions in the next turn.
 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
 *     debugging purposes.
 @ param {=boolean} errorOnUnhandledRejections Whether an error should be generated on unhandled
 *     promises rejections.
 * @returns {object} Promise manager.
 */
function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
  var $qMinErr = minErr('$q', TypeError);
  var queueSize = 0;
  var checkQueue = [];

  /**
   * @ngdoc method
   * @name ng.$q#defer
   * @kind function
   *
   * @description
   * Creates a `Deferred` object which represents a task which will finish in the future.
   *
   * @returns {Deferred} Returns a new instance of deferred.
   */
  function defer() {
    return new Deferred();
  }

  function Deferred() {
    var promise = this.promise = new Promise();
    //Non prototype methods necessary to support unbound execution :/
    this.resolve = function(val) { resolvePromise(promise, val); };
    this.reject = function(reason) { rejectPromise(promise, reason); };
    this.notify = function(progress) { notifyPromise(promise, progress); };
  }


  function Promise() {
    this.$$state = { status: 0 };
  }

  extend(Promise.prototype, {
    then: function(onFulfilled, onRejected, progressBack) {
      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
        return this;
      }
      var result = new Promise();

      this.$$state.pending = this.$$state.pending || [];
      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);

      return result;
    },

    'catch': function(callback) {
      return this.then(null, callback);
    },

    'finally': function(callback, progressBack) {
      return this.then(function(value) {
        return handleCallback(value, resolve, callback);
      }, function(error) {
        return handleCallback(error, reject, callback);
      }, progressBack);
    }
  });

  function processQueue(state) {
    var fn, promise, pending;

    pending = state.pending;
    state.processScheduled = false;
    state.pending = undefined;
    try {
      for (var i = 0, ii = pending.length; i < ii; ++i) {
        state.pur = true;
        promise = pending[i][0];
        fn = pending[i][state.status];
        try {
          if (isFunction(fn)) {
            resolvePromise(promise, fn(state.value));
          } else if (state.status === 1) {
            resolvePromise(promise, state.value);
          } else {
            rejectPromise(promise, state.value);
          }
        } catch (e) {
          rejectPromise(promise, e);
        }
      }
    } finally {
      --queueSize;
      if (errorOnUnhandledRejections && queueSize === 0) {
        nextTick(processChecks);
      }
    }
  }

  function processChecks() {
    // eslint-disable-next-line no-unmodified-loop-condition
    while (!queueSize && checkQueue.length) {
      var toCheck = checkQueue.shift();
      if (!toCheck.pur) {
        toCheck.pur = true;
        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
        if (toCheck.value instanceof Error) {
          exceptionHandler(toCheck.value, errorMessage);
        } else {
          exceptionHandler(errorMessage);
        }
      }
    }
  }

  function scheduleProcessQueue(state) {
    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !state.pur) {
      if (queueSize === 0 && checkQueue.length === 0) {
        nextTick(processChecks);
      }
      checkQueue.push(state);
    }
    if (state.processScheduled || !state.pending) return;
    state.processScheduled = true;
    ++queueSize;
    nextTick(function() { processQueue(state); });
  }

  function resolvePromise(promise, val) {
    if (promise.$$state.status) return;
    if (val === promise) {
      $$reject(promise, $qMinErr(
        'qcycle',
        'Expected promise to be resolved with value other than itself \'{0}\'',
        val));
    } else {
      $$resolve(promise, val);
    }

  }

  function $$resolve(promise, val) {
    var then;
    var done = false;
    try {
      if (isObject(val) || isFunction(val)) then = val.then;
      if (isFunction(then)) {
        promise.$$state.status = -1;
        then.call(val, doResolve, doReject, doNotify);
      } else {
        promise.$$state.value = val;
        promise.$$state.status = 1;
        scheduleProcessQueue(promise.$$state);
      }
    } catch (e) {
      doReject(e);
    }

    function doResolve(val) {
      if (done) return;
      done = true;
      $$resolve(promise, val);
    }
    function doReject(val) {
      if (done) return;
      done = true;
      $$reject(promise, val);
    }
    function doNotify(progress) {
      notifyPromise(promise, progress);
    }
  }

  function rejectPromise(promise, reason) {
    if (promise.$$state.status) return;
    $$reject(promise, reason);
  }

  function $$reject(promise, reason) {
    promise.$$state.value = reason;
    promise.$$state.status = 2;
    scheduleProcessQueue(promise.$$state);
  }

  function notifyPromise(promise, progress) {
    var callbacks = promise.$$state.pending;

    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
      nextTick(function() {
        var callback, result;
        for (var i = 0, ii = callbacks.length; i < ii; i++) {
          result = callbacks[i][0];
          callback = callbacks[i][3];
          try {
            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
          } catch (e) {
            exceptionHandler(e);
          }
        }
      });
    }
  }

  /**
   * @ngdoc method
   * @name $q#reject
   * @kind function
   *
   * @description
   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
   * a promise chain, you don't need to worry about it.
   *
   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
   * a promise error callback and you want to forward the error to the promise derived from the
   * current promise, you have to "rethrow" the error by returning a rejection constructed via
   * `reject`.
   *
   * ```js
   *   promiseB = promiseA.then(function(result) {
   *     // success: do something and resolve promiseB
   *     //          with the old or a new result
   *     return result;
   *   }, function(reason) {
   *     // error: handle the error if possible and
   *     //        resolve promiseB with newPromiseOrValue,
   *     //        otherwise forward the rejection to promiseB
   *     if (canHandle(reason)) {
   *      // handle the error and recover
   *      return newPromiseOrValue;
   *     }
   *     return $q.reject(reason);
   *   });
   * ```
   *
   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
   */
  function reject(reason) {
    var result = new Promise();
    rejectPromise(result, reason);
    return result;
  }

  function handleCallback(value, resolver, callback) {
    var callbackOutput = null;
    try {
      if (isFunction(callback)) callbackOutput = callback();
    } catch (e) {
      return reject(e);
    }
    if (isPromiseLike(callbackOutput)) {
      return callbackOutput.then(function() {
        return resolver(value);
      }, reject);
    } else {
      return resolver(value);
    }
  }

  /**
   * @ngdoc method
   * @name $q#when
   * @kind function
   *
   * @description
   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
   * This is useful when you are dealing with an object that might or might not be a promise, or if
   * the promise comes from a source that can't be trusted.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */


  function when(value, callback, errback, progressBack) {
    var result = new Promise();
    resolvePromise(result, value);
    return result.then(callback, errback, progressBack);
  }

  /**
   * @ngdoc method
   * @name $q#resolve
   * @kind function
   *
   * @description
   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */
  var resolve = when;

  /**
   * @ngdoc method
   * @name $q#all
   * @kind function
   *
   * @description
   * Combines multiple promises into a single promise that is resolved when all of the input
   * promises are resolved.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
   *   with the same rejection value.
   */

  function all(promises) {
    var result = new Promise(),
        counter = 0,
        results = isArray(promises) ? [] : {};

    forEach(promises, function(promise, key) {
      counter++;
      when(promise).then(function(value) {
        results[key] = value;
        if (!(--counter)) resolvePromise(result, results);
      }, function(reason) {
        rejectPromise(result, reason);
      });
    });

    if (counter === 0) {
      resolvePromise(result, results);
    }

    return result;
  }

  /**
   * @ngdoc method
   * @name $q#race
   * @kind function
   *
   * @description
   * Returns a promise that resolves or rejects as soon as one of those promises
   * resolves or rejects, with the value or reason from that promise.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
   * resolves or rejects, with the value or reason from that promise.
   */

  function race(promises) {
    var deferred = defer();

    forEach(promises, function(promise) {
      when(promise).then(deferred.resolve, deferred.reject);
    });

    return deferred.promise;
  }

  function $Q(resolver) {
    if (!isFunction(resolver)) {
      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
    }

    var promise = new Promise();

    function resolveFn(value) {
      resolvePromise(promise, value);
    }

    function rejectFn(reason) {
      rejectPromise(promise, reason);
    }

    resolver(resolveFn, rejectFn);

    return promise;
  }

  // Let's make the instanceof operator work for promises, so that
  // `new $q(fn) instanceof $q` would evaluate to true.
  $Q.prototype = Promise.prototype;

  $Q.defer = defer;
  $Q.reject = reject;
  $Q.when = when;
  $Q.resolve = resolve;
  $Q.all = all;
  $Q.race = race;

  return $Q;
}

/** @this */
function $$RAFProvider() { //rAF
  this.$get = ['$window', '$timeout', function($window, $timeout) {
    var requestAnimationFrame = $window.requestAnimationFrame ||
                                $window.webkitRequestAnimationFrame;

    var cancelAnimationFrame = $window.cancelAnimationFrame ||
                               $window.webkitCancelAnimationFrame ||
                               $window.webkitCancelRequestAnimationFrame;

    var rafSupported = !!requestAnimationFrame;
    var raf = rafSupported
      ? function(fn) {
          var id = requestAnimationFrame(fn);
          return function() {
            cancelAnimationFrame(id);
          };
        }
      : function(fn) {
          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
          return function() {
            $timeout.cancel(timer);
          };
        };

    raf.supported = rafSupported;

    return raf;
  }];
}

/**
 * DESIGN NOTES
 *
 * The design decisions behind the scope are heavily favored for speed and memory consumption.
 *
 * The typical use of scope is to watch the expressions, which most of the time return the same
 * value as last time so we optimize the operation.
 *
 * Closures construction is expensive in terms of speed as well as memory:
 *   - No closures, instead use prototypical inheritance for API
 *   - Internal state needs to be stored on scope directly, which means that private state is
 *     exposed as $$____ properties
 *
 * Loop operations are optimized by using while(count--) { ... }
 *   - This means that in order to keep the same order of execution as addition we have to add
 *     items to the array at the beginning (unshift) instead of at the end (push)
 *
 * Child scopes are created and removed often
 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
 *
 * There are fewer watches than observers. This is why you don't want the observer to be implemented
 * in the same way as watch. Watch requires return of the initialization function which is expensive
 * to construct.
 */


/**
 * @ngdoc provider
 * @name $rootScopeProvider
 * @description
 *
 * Provider for the $rootScope service.
 */

/**
 * @ngdoc method
 * @name $rootScopeProvider#digestTtl
 * @description
 *
 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
 * assuming that the model is unstable.
 *
 * The current default is 10 iterations.
 *
 * In complex applications it's possible that the dependencies between `$watch`s will result in
 * several digest iterations. However if an application needs more than the default 10 digest
 * iterations for its model to stabilize then you should investigate what is causing the model to
 * continuously change during the digest.
 *
 * Increasing the TTL could have performance implications, so you should not change it without
 * proper justification.
 *
 * @param {number} limit The number of digest iterations.
 */


/**
 * @ngdoc service
 * @name $rootScope
 * @this
 *
 * @description
 *
 * Every application has a single root {@link ng.$rootScope.Scope scope}.
 * All other scopes are descendant scopes of the root scope. Scopes provide separation
 * between the model and the view, via a mechanism for watching the model for changes.
 * They also provide event emission/broadcast and subscription facility. See the
 * {@link guide/scope developer guide on scopes}.
 */
function $RootScopeProvider() {
  var TTL = 10;
  var $rootScopeMinErr = minErr('$rootScope');
  var lastDirtyWatch = null;
  var applyAsyncId = null;

  this.digestTtl = function(value) {
    if (arguments.length) {
      TTL = value;
    }
    return TTL;
  };

  function createChildScopeClass(parent) {
    function ChildScope() {
      this.$$watchers = this.$$nextSibling =
          this.$$childHead = this.$$childTail = null;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$id = nextUid();
      this.$$ChildScope = null;
    }
    ChildScope.prototype = parent;
    return ChildScope;
  }

  this.$get = ['$exceptionHandler', '$parse', '$browser',
      function($exceptionHandler, $parse, $browser) {

    function destroyChildScope($event) {
        $event.currentScope.$$destroyed = true;
    }

    function cleanUpScope($scope) {

      // Support: IE 9 only
      if (msie === 9) {
        // There is a memory leak in IE9 if all child scopes are not disconnected
        // completely when a scope is destroyed. So this code will recurse up through
        // all this scopes children
        //
        // See issue https://github.com/angular/angular.js/issues/10706
        if ($scope.$$childHead) {
          cleanUpScope($scope.$$childHead);
        }
        if ($scope.$$nextSibling) {
          cleanUpScope($scope.$$nextSibling);
        }
      }

      // The code below works around IE9 and V8's memory leaks
      //
      // See:
      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451

      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
    }

    /**
     * @ngdoc type
     * @name $rootScope.Scope
     *
     * @description
     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
     * {@link auto.$injector $injector}. Child scopes are created using the
     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
     * an in-depth introduction and usage examples.
     *
     *
     * # Inheritance
     * A scope can inherit from a parent scope, as in this example:
     * ```js
         var parent = $rootScope;
         var child = parent.$new();

         parent.salutation = "Hello";
         expect(child.salutation).toEqual('Hello');

         child.salutation = "Welcome";
         expect(child.salutation).toEqual('Welcome');
         expect(parent.salutation).toEqual('Hello');
     * ```
     *
     * When interacting with `Scope` in tests, additional helper methods are available on the
     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
     * details.
     *
     *
     * @param {Object.<string, function()>=} providers Map of service factory which need to be
     *                                       provided for the current scope. Defaults to {@link ng}.
     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
     *                              append/override services provided by `providers`. This is handy
     *                              when unit-testing and having the need to override a default
     *                              service.
     * @returns {Object} Newly created scope.
     *
     */
    function Scope() {
      this.$id = nextUid();
      this.$$phase = this.$parent = this.$$watchers =
                     this.$$nextSibling = this.$$prevSibling =
                     this.$$childHead = this.$$childTail = null;
      this.$root = this;
      this.$$destroyed = false;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$$isolateBindings = null;
    }

    /**
     * @ngdoc property
     * @name $rootScope.Scope#$id
     *
     * @description
     * Unique scope ID (monotonically increasing) useful for debugging.
     */

     /**
      * @ngdoc property
      * @name $rootScope.Scope#$parent
      *
      * @description
      * Reference to the parent scope.
      */

      /**
       * @ngdoc property
       * @name $rootScope.Scope#$root
       *
       * @description
       * Reference to the root scope.
       */

    Scope.prototype = {
      constructor: Scope,
      /**
       * @ngdoc method
       * @name $rootScope.Scope#$new
       * @kind function
       *
       * @description
       * Creates a new child {@link ng.$rootScope.Scope scope}.
       *
       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
       *
       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
       * desired for the scope and its child scopes to be permanently detached from the parent and
       * thus stop participating in model change detection and listener notification by invoking.
       *
       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
       *         parent scope. The scope is isolated, as it can not see parent scope properties.
       *         When creating widgets, it is useful for the widget to not accidentally read parent
       *         state.
       *
       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
       *                              of the newly created scope. Defaults to `this` scope if not provided.
       *                              This is used when creating a transclude scope to correctly place it
       *                              in the scope hierarchy while maintaining the correct prototypical
       *                              inheritance.
       *
       * @returns {Object} The newly created child scope.
       *
       */
      $new: function(isolate, parent) {
        var child;

        parent = parent || this;

        if (isolate) {
          child = new Scope();
          child.$root = this.$root;
        } else {
          // Only create a child scope class if somebody asks for one,
          // but cache it to allow the VM to optimize lookups.
          if (!this.$$ChildScope) {
            this.$$ChildScope = createChildScopeClass(this);
          }
          child = new this.$$ChildScope();
        }
        child.$parent = parent;
        child.$$prevSibling = parent.$$childTail;
        if (parent.$$childHead) {
          parent.$$childTail.$$nextSibling = child;
          parent.$$childTail = child;
        } else {
          parent.$$childHead = parent.$$childTail = child;
        }

        // When the new scope is not isolated or we inherit from `this`, and
        // the parent scope is destroyed, the property `$$destroyed` is inherited
        // prototypically. In all other cases, this property needs to be set
        // when the parent scope is destroyed.
        // The listener needs to be added after the parent is set
        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);

        return child;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watch
       * @kind function
       *
       * @description
       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
       *
       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
       *   its value when executed multiple times with the same input because it may be executed multiple
       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
       * - The `listener` is called only when the value from the current `watchExpression` and the
       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
       *   see below). Inequality is determined according to reference inequality,
       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
       *    via the `!==` Javascript operator, unless `objectEquality == true`
       *   (see next point)
       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
       *   according to the {@link angular.equals} function. To save the value of the object for
       *   later comparison, the {@link angular.copy} function is used. This therefore means that
       *   watching complex objects will have adverse memory and performance implications.
       * - This should not be used to watch for changes in objects that are
       *   or contain [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
       *   iteration limit is 10 to prevent an infinite loop deadlock.
       *
       *
       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
       * you can register a `watchExpression` function with no `listener`. (Be prepared for
       * multiple calls to your `watchExpression` because it will execute multiple times in a
       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
       *
       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
       * watcher. In rare cases, this is undesirable because the listener is called when the result
       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
       * listener was called due to initialization.
       *
       *
       *
       * # Example
       * ```js
           // let's assume that scope was dependency injected as the $rootScope
           var scope = $rootScope;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);



           // Using a function as a watchExpression
           var food;
           scope.foodCounter = 0;
           expect(scope.foodCounter).toEqual(0);
           scope.$watch(
             // This function returns the value being watched. It is called for each turn of the $digest loop
             function() { return food; },
             // This is the change listener, called when the value returned from the above function changes
             function(newValue, oldValue) {
               if ( newValue !== oldValue ) {
                 // Only increment the counter if the value changed
                 scope.foodCounter = scope.foodCounter + 1;
               }
             }
           );
           // No digest has been run so the counter will be zero
           expect(scope.foodCounter).toEqual(0);

           // Run the digest but since food has not changed count will still be zero
           scope.$digest();
           expect(scope.foodCounter).toEqual(0);

           // Update food and run digest.  Now the counter will increment
           food = 'cheeseburger';
           scope.$digest();
           expect(scope.foodCounter).toEqual(1);

       * ```
       *
       *
       *
       * @param {(function()|string)} watchExpression Expression that is evaluated on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
       *    a call to the `listener`.
       *
       *    - `string`: Evaluated as {@link guide/expression expression}
       *    - `function(scope)`: called with current `scope` as a parameter.
       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
       *    of `watchExpression` changes.
       *
       *    - `newVal` contains the current value of the `watchExpression`
       *    - `oldVal` contains the previous value of the `watchExpression`
       *    - `scope` refers to the current scope
       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
       *     comparing for reference equality.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
        var get = $parse(watchExp);

        if (get.$$watchDelegate) {
          return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
        }
        var scope = this,
            array = scope.$$watchers,
            watcher = {
              fn: listener,
              last: initWatchVal,
              get: get,
              exp: prettyPrintExpression || watchExp,
              eq: !!objectEquality
            };

        lastDirtyWatch = null;

        if (!isFunction(listener)) {
          watcher.fn = noop;
        }

        if (!array) {
          array = scope.$$watchers = [];
          array.$$digestWatchIndex = -1;
        }
        // we use unshift since we use a while loop in $digest for speed.
        // the while loop reads in reverse order.
        array.unshift(watcher);
        array.$$digestWatchIndex++;
        incrementWatchersCount(this, 1);

        return function deregisterWatch() {
          var index = arrayRemove(array, watcher);
          if (index >= 0) {
            incrementWatchersCount(scope, -1);
            if (index < array.$$digestWatchIndex) {
              array.$$digestWatchIndex--;
            }
          }
          lastDirtyWatch = null;
        };
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchGroup
       * @kind function
       *
       * @description
       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
       * If any one expression in the collection changes the `listener` is executed.
       *
       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
       *   values are examined for changes on every call to `$digest`.
       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
       *
       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
       *
       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
       *    expression in `watchExpressions` changes
       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    The `scope` refers to the current scope.
       * @returns {function()} Returns a de-registration function for all listeners.
       */
      $watchGroup: function(watchExpressions, listener) {
        var oldValues = new Array(watchExpressions.length);
        var newValues = new Array(watchExpressions.length);
        var deregisterFns = [];
        var self = this;
        var changeReactionScheduled = false;
        var firstRun = true;

        if (!watchExpressions.length) {
          // No expressions means we call the listener ASAP
          var shouldCall = true;
          self.$evalAsync(function() {
            if (shouldCall) listener(newValues, newValues, self);
          });
          return function deregisterWatchGroup() {
            shouldCall = false;
          };
        }

        if (watchExpressions.length === 1) {
          // Special case size of one
          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
            newValues[0] = value;
            oldValues[0] = oldValue;
            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
          });
        }

        forEach(watchExpressions, function(expr, i) {
          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
            newValues[i] = value;
            oldValues[i] = oldValue;
            if (!changeReactionScheduled) {
              changeReactionScheduled = true;
              self.$evalAsync(watchGroupAction);
            }
          });
          deregisterFns.push(unwatchFn);
        });

        function watchGroupAction() {
          changeReactionScheduled = false;

          if (firstRun) {
            firstRun = false;
            listener(newValues, newValues, self);
          } else {
            listener(newValues, oldValues, self);
          }
        }

        return function deregisterWatchGroup() {
          while (deregisterFns.length) {
            deregisterFns.shift()();
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchCollection
       * @kind function
       *
       * @description
       * Shallow watches the properties of an object and fires whenever any of the properties change
       * (for arrays, this implies watching the array items; for object maps, this implies watching
       * the properties). If a change is detected, the `listener` callback is fired.
       *
       * - The `obj` collection is observed via standard $watch operation and is examined on every
       *   call to $digest() to see if any items have been added, removed, or moved.
       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
       *   adding, removing, and moving items belonging to an object or array.
       *
       *
       * # Example
       * ```js
          $scope.names = ['igor', 'matias', 'misko', 'james'];
          $scope.dataCount = 4;

          $scope.$watchCollection('names', function(newNames, oldNames) {
            $scope.dataCount = newNames.length;
          });

          expect($scope.dataCount).toEqual(4);
          $scope.$digest();

          //still at 4 ... no changes
          expect($scope.dataCount).toEqual(4);

          $scope.names.pop();
          $scope.$digest();

          //now there's been a change
          expect($scope.dataCount).toEqual(3);
       * ```
       *
       *
       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
       *    expression value should evaluate to an object or an array which is observed on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
       *    collection will trigger a call to the `listener`.
       *
       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
       *    when a change is detected.
       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
       *    - The `oldCollection` object is a copy of the former collection data.
       *      Due to performance considerations, the`oldCollection` value is computed only if the
       *      `listener` function declares two or more arguments.
       *    - The `scope` argument refers to the current scope.
       *
       * @returns {function()} Returns a de-registration function for this listener. When the
       *    de-registration function is executed, the internal watch operation is terminated.
       */
      $watchCollection: function(obj, listener) {
        $watchCollectionInterceptor.$stateful = true;

        var self = this;
        // the current value, updated on each dirty-check run
        var newValue;
        // a shallow copy of the newValue from the last dirty-check run,
        // updated to match newValue during dirty-check run
        var oldValue;
        // a shallow copy of the newValue from when the last change happened
        var veryOldValue;
        // only track veryOldValue if the listener is asking for it
        var trackVeryOldValue = (listener.length > 1);
        var changeDetected = 0;
        var changeDetector = $parse(obj, $watchCollectionInterceptor);
        var internalArray = [];
        var internalObject = {};
        var initRun = true;
        var oldLength = 0;

        function $watchCollectionInterceptor(_value) {
          newValue = _value;
          var newLength, key, bothNaN, newItem, oldItem;

          // If the new value is undefined, then return undefined as the watch may be a one-time watch
          if (isUndefined(newValue)) return;

          if (!isObject(newValue)) { // if primitive
            if (oldValue !== newValue) {
              oldValue = newValue;
              changeDetected++;
            }
          } else if (isArrayLike(newValue)) {
            if (oldValue !== internalArray) {
              // we are transitioning from something which was not an array into array.
              oldValue = internalArray;
              oldLength = oldValue.length = 0;
              changeDetected++;
            }

            newLength = newValue.length;

            if (oldLength !== newLength) {
              // if lengths do not match we need to trigger change notification
              changeDetected++;
              oldValue.length = oldLength = newLength;
            }
            // copy the items to oldValue and look for changes.
            for (var i = 0; i < newLength; i++) {
              oldItem = oldValue[i];
              newItem = newValue[i];

              // eslint-disable-next-line no-self-compare
              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
              if (!bothNaN && (oldItem !== newItem)) {
                changeDetected++;
                oldValue[i] = newItem;
              }
            }
          } else {
            if (oldValue !== internalObject) {
              // we are transitioning from something which was not an object into object.
              oldValue = internalObject = {};
              oldLength = 0;
              changeDetected++;
            }
            // copy the items to oldValue and look for changes.
            newLength = 0;
            for (key in newValue) {
              if (hasOwnProperty.call(newValue, key)) {
                newLength++;
                newItem = newValue[key];
                oldItem = oldValue[key];

                if (key in oldValue) {
                  // eslint-disable-next-line no-self-compare
                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
                  if (!bothNaN && (oldItem !== newItem)) {
                    changeDetected++;
                    oldValue[key] = newItem;
                  }
                } else {
                  oldLength++;
                  oldValue[key] = newItem;
                  changeDetected++;
                }
              }
            }
            if (oldLength > newLength) {
              // we used to have more keys, need to find them and destroy them.
              changeDetected++;
              for (key in oldValue) {
                if (!hasOwnProperty.call(newValue, key)) {
                  oldLength--;
                  delete oldValue[key];
                }
              }
            }
          }
          return changeDetected;
        }

        function $watchCollectionAction() {
          if (initRun) {
            initRun = false;
            listener(newValue, newValue, self);
          } else {
            listener(newValue, veryOldValue, self);
          }

          // make a copy for the next time a collection is changed
          if (trackVeryOldValue) {
            if (!isObject(newValue)) {
              //primitive
              veryOldValue = newValue;
            } else if (isArrayLike(newValue)) {
              veryOldValue = new Array(newValue.length);
              for (var i = 0; i < newValue.length; i++) {
                veryOldValue[i] = newValue[i];
              }
            } else { // if object
              veryOldValue = {};
              for (var key in newValue) {
                if (hasOwnProperty.call(newValue, key)) {
                  veryOldValue[key] = newValue[key];
                }
              }
            }
          }
        }

        return this.$watch(changeDetector, $watchCollectionAction);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$digest
       * @kind function
       *
       * @description
       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
       * until no more listeners are firing. This means that it is possible to get into an infinite
       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
       * iterations exceeds 10.
       *
       * Usually, you don't call `$digest()` directly in
       * {@link ng.directive:ngController controllers} or in
       * {@link ng.$compileProvider#directive directives}.
       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
       *
       * If you want to be notified whenever `$digest()` is called,
       * you can register a `watchExpression` function with
       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
       *
       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
       *
       * # Example
       * ```js
           var scope = ...;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);
       * ```
       *
       */
      $digest: function() {
        var watch, value, last, fn, get,
            watchers,
            dirty, ttl = TTL,
            next, current, target = this,
            watchLog = [],
            logIdx, asyncTask;

        beginPhase('$digest');
        // Check for changes to browser url that happened in sync before the call to $digest
        $browser.$$checkUrlChange();

        if (this === $rootScope && applyAsyncId !== null) {
          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
          $browser.defer.cancel(applyAsyncId);
          flushApplyAsync();
        }

        lastDirtyWatch = null;

        do { // "while dirty" loop
          dirty = false;
          current = target;

          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
          // be reentered recursively. Calling $digest from a function passed to $applyAsync would
          // lead to a '$digest already in progress' error.
          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
            try {
              asyncTask = asyncQueue[asyncQueuePosition];
              asyncTask.scope.$eval(asyncTask.expression, asyncTask.locals);
            } catch (e) {
              $exceptionHandler(e);
            }
            lastDirtyWatch = null;
          }
          asyncQueue.length = 0;

          traverseScopesLoop:
          do { // "traverse the scopes" loop
            if ((watchers = current.$$watchers)) {
              // process our watches
              watchers.$$digestWatchIndex = watchers.length;
              while (watchers.$$digestWatchIndex--) {
                try {
                  watch = watchers[watchers.$$digestWatchIndex];
                  // Most common watches are on primitives, in which case we can short
                  // circuit it with === operator, only when === fails do we use .equals
                  if (watch) {
                    get = watch.get;
                    if ((value = get(current)) !== (last = watch.last) &&
                        !(watch.eq
                            ? equals(value, last)
                            : (isNumberNaN(value) && isNumberNaN(last)))) {
                      dirty = true;
                      lastDirtyWatch = watch;
                      watch.last = watch.eq ? copy(value, null) : value;
                      fn = watch.fn;
                      fn(value, ((last === initWatchVal) ? value : last), current);
                      if (ttl < 5) {
                        logIdx = 4 - ttl;
                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
                        watchLog[logIdx].push({
                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
                          newVal: value,
                          oldVal: last
                        });
                      }
                    } else if (watch === lastDirtyWatch) {
                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
                      // have already been tested.
                      dirty = false;
                      break traverseScopesLoop;
                    }
                  }
                } catch (e) {
                  $exceptionHandler(e);
                }
              }
            }

            // Insanity Warning: scope depth-first traversal
            // yes, this code is a bit crazy, but it works and we have tests to prove it!
            // this piece should be kept in sync with the traversal in $broadcast
            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
                (current !== target && current.$$nextSibling)))) {
              while (current !== target && !(next = current.$$nextSibling)) {
                current = current.$parent;
              }
            }
          } while ((current = next));

          // `break traverseScopesLoop;` takes us to here

          if ((dirty || asyncQueue.length) && !(ttl--)) {
            clearPhase();
            throw $rootScopeMinErr('infdig',
                '{0} $digest() iterations reached. Aborting!\n' +
                'Watchers fired in the last 5 iterations: {1}',
                TTL, watchLog);
          }

        } while (dirty || asyncQueue.length);

        clearPhase();

        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
        while (postDigestQueuePosition < postDigestQueue.length) {
          try {
            postDigestQueue[postDigestQueuePosition++]();
          } catch (e) {
            $exceptionHandler(e);
          }
        }
        postDigestQueue.length = postDigestQueuePosition = 0;
      },


      /**
       * @ngdoc event
       * @name $rootScope.Scope#$destroy
       * @eventType broadcast on scope being destroyed
       *
       * @description
       * Broadcasted when a scope and its children are being destroyed.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$destroy
       * @kind function
       *
       * @description
       * Removes the current scope (and all of its children) from the parent scope. Removal implies
       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
       * propagate to the current scope and its children. Removal also implies that the current
       * scope is eligible for garbage collection.
       *
       * The `$destroy()` is usually used by directives such as
       * {@link ng.directive:ngRepeat ngRepeat} for managing the
       * unrolling of the loop.
       *
       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
       * Application code can register a `$destroy` event handler that will give it a chance to
       * perform any necessary cleanup.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */
      $destroy: function() {
        // We can't destroy a scope that has been already destroyed.
        if (this.$$destroyed) return;
        var parent = this.$parent;

        this.$broadcast('$destroy');
        this.$$destroyed = true;

        if (this === $rootScope) {
          //Remove handlers attached to window when $rootScope is removed
          $browser.$$applicationDestroyed();
        }

        incrementWatchersCount(this, -this.$$watchersCount);
        for (var eventName in this.$$listenerCount) {
          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
        }

        // sever all the references to parent scopes (after this cleanup, the current scope should
        // not be retained by any of our references and should be eligible for garbage collection)
        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;

        // Disable listeners, watchers and apply/digest methods
        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
        this.$$listeners = {};

        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
        this.$$nextSibling = null;
        cleanUpScope(this);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$eval
       * @kind function
       *
       * @description
       * Executes the `expression` on the current scope and returns the result. Any exceptions in
       * the expression are propagated (uncaught). This is useful when evaluating Angular
       * expressions.
       *
       * # Example
       * ```js
           var scope = ng.$rootScope.Scope();
           scope.a = 1;
           scope.b = 2;

           expect(scope.$eval('a+b')).toEqual(3);
           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
       * ```
       *
       * @param {(string|function())=} expression An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       * @returns {*} The result of evaluating the expression.
       */
      $eval: function(expr, locals) {
        return $parse(expr)(this, locals);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$evalAsync
       * @kind function
       *
       * @description
       * Executes the expression on the current scope at a later point in time.
       *
       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
       * that:
       *
       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
       *     rendering).
       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
       *     `expression` execution.
       *
       * Any exceptions from the execution of the expression are forwarded to the
       * {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
       * will be scheduled. However, it is encouraged to always call code that changes the model
       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
       *
       * @param {(string|function())=} expression An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       */
      $evalAsync: function(expr, locals) {
        // if we are outside of an $digest loop and this is the first time we are scheduling async
        // task also schedule async auto-flush
        if (!$rootScope.$$phase && !asyncQueue.length) {
          $browser.defer(function() {
            if (asyncQueue.length) {
              $rootScope.$digest();
            }
          });
        }

        asyncQueue.push({scope: this, expression: $parse(expr), locals: locals});
      },

      $$postDigest: function(fn) {
        postDigestQueue.push(fn);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$apply
       * @kind function
       *
       * @description
       * `$apply()` is used to execute an expression in angular from outside of the angular
       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
       * Because we are calling into the angular framework we need to perform proper scope life
       * cycle of {@link ng.$exceptionHandler exception handling},
       * {@link ng.$rootScope.Scope#$digest executing watches}.
       *
       * ## Life cycle
       *
       * # Pseudo-Code of `$apply()`
       * ```js
           function $apply(expr) {
             try {
               return $eval(expr);
             } catch (e) {
               $exceptionHandler(e);
             } finally {
               $root.$digest();
             }
           }
       * ```
       *
       *
       * Scope's `$apply()` method transitions through the following stages:
       *
       * 1. The {@link guide/expression expression} is executed using the
       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
       * 2. Any exceptions from the execution of the expression are forwarded to the
       *    {@link ng.$exceptionHandler $exceptionHandler} service.
       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
       *
       *
       * @param {(string|function())=} exp An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       *
       * @returns {*} The result of evaluating the expression.
       */
      $apply: function(expr) {
        try {
          beginPhase('$apply');
          try {
            return this.$eval(expr);
          } finally {
            clearPhase();
          }
        } catch (e) {
          $exceptionHandler(e);
        } finally {
          try {
            $rootScope.$digest();
          } catch (e) {
            $exceptionHandler(e);
            // eslint-disable-next-line no-unsafe-finally
            throw e;
          }
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$applyAsync
       * @kind function
       *
       * @description
       * Schedule the invocation of $apply to occur at a later time. The actual time difference
       * varies across browsers, but is typically around ~10 milliseconds.
       *
       * This can be used to queue up multiple expressions which need to be evaluated in the same
       * digest.
       *
       * @param {(string|function())=} exp An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       */
      $applyAsync: function(expr) {
        var scope = this;
        if (expr) {
          applyAsyncQueue.push($applyAsyncExpression);
        }
        expr = $parse(expr);
        scheduleApplyAsync();

        function $applyAsyncExpression() {
          scope.$eval(expr);
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$on
       * @kind function
       *
       * @description
       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
       * discussion of event life cycle.
       *
       * The event listener function format is: `function(event, args...)`. The `event` object
       * passed into the listener has the following attributes:
       *
       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
       *     `$broadcast`-ed.
       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
       *     event propagates through the scope hierarchy, this property is set to null.
       *   - `name` - `{string}`: name of the event.
       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
       *     further event propagation (available only for events that were `$emit`-ed).
       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
       *     to true.
       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
       *
       * @param {string} name Event name to listen on.
       * @param {function(event, ...args)} listener Function to call when the event is emitted.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $on: function(name, listener) {
        var namedListeners = this.$$listeners[name];
        if (!namedListeners) {
          this.$$listeners[name] = namedListeners = [];
        }
        namedListeners.push(listener);

        var current = this;
        do {
          if (!current.$$listenerCount[name]) {
            current.$$listenerCount[name] = 0;
          }
          current.$$listenerCount[name]++;
        } while ((current = current.$parent));

        var self = this;
        return function() {
          var indexOfListener = namedListeners.indexOf(listener);
          if (indexOfListener !== -1) {
            namedListeners[indexOfListener] = null;
            decrementListenerCount(self, 1, name);
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$emit
       * @kind function
       *
       * @description
       * Dispatches an event `name` upwards through the scope hierarchy notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$emit` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
       * registered listeners along the way. The event will stop propagating if one of the listeners
       * cancels it.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to emit.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
       */
      $emit: function(name, args) {
        var empty = [],
            namedListeners,
            scope = this,
            stopPropagation = false,
            event = {
              name: name,
              targetScope: scope,
              stopPropagation: function() {stopPropagation = true;},
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            },
            listenerArgs = concat([event], arguments, 1),
            i, length;

        do {
          namedListeners = scope.$$listeners[name] || empty;
          event.currentScope = scope;
          for (i = 0, length = namedListeners.length; i < length; i++) {

            // if listeners were deregistered, defragment the array
            if (!namedListeners[i]) {
              namedListeners.splice(i, 1);
              i--;
              length--;
              continue;
            }
            try {
              //allow all listeners attached to the current scope to run
              namedListeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          //if any listener on the current scope stops propagation, prevent bubbling
          if (stopPropagation) {
            event.currentScope = null;
            return event;
          }
          //traverse upwards
          scope = scope.$parent;
        } while (scope);

        event.currentScope = null;

        return event;
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$broadcast
       * @kind function
       *
       * @description
       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$broadcast` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
       * scope and calls all registered listeners along the way. The event cannot be canceled.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to broadcast.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
       */
      $broadcast: function(name, args) {
        var target = this,
            current = target,
            next = target,
            event = {
              name: name,
              targetScope: target,
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            };

        if (!target.$$listenerCount[name]) return event;

        var listenerArgs = concat([event], arguments, 1),
            listeners, i, length;

        //down while you can, then up and next sibling or up and next sibling until back at root
        while ((current = next)) {
          event.currentScope = current;
          listeners = current.$$listeners[name] || [];
          for (i = 0, length = listeners.length; i < length; i++) {
            // if listeners were deregistered, defragment the array
            if (!listeners[i]) {
              listeners.splice(i, 1);
              i--;
              length--;
              continue;
            }

            try {
              listeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }

          // Insanity Warning: scope depth-first traversal
          // yes, this code is a bit crazy, but it works and we have tests to prove it!
          // this piece should be kept in sync with the traversal in $digest
          // (though it differs due to having the extra check for $$listenerCount)
          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
              (current !== target && current.$$nextSibling)))) {
            while (current !== target && !(next = current.$$nextSibling)) {
              current = current.$parent;
            }
          }
        }

        event.currentScope = null;
        return event;
      }
    };

    var $rootScope = new Scope();

    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
    var asyncQueue = $rootScope.$$asyncQueue = [];
    var postDigestQueue = $rootScope.$$postDigestQueue = [];
    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];

    var postDigestQueuePosition = 0;

    return $rootScope;


    function beginPhase(phase) {
      if ($rootScope.$$phase) {
        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
      }

      $rootScope.$$phase = phase;
    }

    function clearPhase() {
      $rootScope.$$phase = null;
    }

    function incrementWatchersCount(current, count) {
      do {
        current.$$watchersCount += count;
      } while ((current = current.$parent));
    }

    function decrementListenerCount(current, count, name) {
      do {
        current.$$listenerCount[name] -= count;

        if (current.$$listenerCount[name] === 0) {
          delete current.$$listenerCount[name];
        }
      } while ((current = current.$parent));
    }

    /**
     * function used as an initial value for watchers.
     * because it's unique we can easily tell it apart from other values
     */
    function initWatchVal() {}

    function flushApplyAsync() {
      while (applyAsyncQueue.length) {
        try {
          applyAsyncQueue.shift()();
        } catch (e) {
          $exceptionHandler(e);
        }
      }
      applyAsyncId = null;
    }

    function scheduleApplyAsync() {
      if (applyAsyncId === null) {
        applyAsyncId = $browser.defer(function() {
          $rootScope.$apply(flushApplyAsync);
        });
      }
    }
  }];
}

/**
 * @ngdoc service
 * @name $rootElement
 *
 * @description
 * The root element of Angular application. This is either the element where {@link
 * ng.directive:ngApp ngApp} was declared or the element passed into
 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
 * location where the application's {@link auto.$injector $injector} service gets
 * published, and can be retrieved using `$rootElement.injector()`.
 */


// the implementation is in angular.bootstrap

/**
 * @this
 * @description
 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
 */
function $$SanitizeUriProvider() {
  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;

  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      aHrefSanitizationWhitelist = regexp;
      return this;
    }
    return aHrefSanitizationWhitelist;
  };


  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      imgSrcSanitizationWhitelist = regexp;
      return this;
    }
    return imgSrcSanitizationWhitelist;
  };

  this.$get = function() {
    return function sanitizeUri(uri, isImage) {
      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
      var normalizedVal;
      normalizedVal = urlResolve(uri).href;
      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
        return 'unsafe:' + normalizedVal;
      }
      return uri;
    };
  };
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* exported $SceProvider, $SceDelegateProvider */

var $sceMinErr = minErr('$sce');

var SCE_CONTEXTS = {
  HTML: 'html',
  CSS: 'css',
  URL: 'url',
  // RESOURCE_URL is a subtype of URL used in contexts where a privileged resource is sourced from a
  // url.  (e.g. ng-include, script src, templateUrl)
  RESOURCE_URL: 'resourceUrl',
  JS: 'js'
};

// Helper functions follow.

var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;

function snakeToCamel(name) {
  return name
    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
}

function adjustMatcher(matcher) {
  if (matcher === 'self') {
    return matcher;
  } else if (isString(matcher)) {
    // Strings match exactly except for 2 wildcards - '*' and '**'.
    // '*' matches any character except those from the set ':/.?&'.
    // '**' matches any character (like .* in a RegExp).
    // More than 2 *'s raises an error as it's ill defined.
    if (matcher.indexOf('***') > -1) {
      throw $sceMinErr('iwcard',
          'Illegal sequence *** in string matcher.  String: {0}', matcher);
    }
    matcher = escapeForRegexp(matcher).
                  replace(/\\\*\\\*/g, '.*').
                  replace(/\\\*/g, '[^:/.?&;]*');
    return new RegExp('^' + matcher + '$');
  } else if (isRegExp(matcher)) {
    // The only other type of matcher allowed is a Regexp.
    // Match entire URL / disallow partial matches.
    // Flags are reset (i.e. no global, ignoreCase or multiline)
    return new RegExp('^' + matcher.source + '$');
  } else {
    throw $sceMinErr('imatcher',
        'Matchers may only be "self", string patterns or RegExp objects');
  }
}


function adjustMatchers(matchers) {
  var adjustedMatchers = [];
  if (isDefined(matchers)) {
    forEach(matchers, function(matcher) {
      adjustedMatchers.push(adjustMatcher(matcher));
    });
  }
  return adjustedMatchers;
}


/**
 * @ngdoc service
 * @name $sceDelegate
 * @kind function
 *
 * @description
 *
 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
 * Contextual Escaping (SCE)} services to AngularJS.
 *
 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
 * work because `$sce` delegates to `$sceDelegate` for these operations.
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
 *
 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
 * can override it completely to change the behavior of `$sce`, the common case would
 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
 */

/**
 * @ngdoc provider
 * @name $sceDelegateProvider
 * @this
 *
 * @description
 *
 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
 * $sceDelegate} service.  This allows one to get/set the whitelists and blacklists used to ensure
 * that the URLs used for sourcing Angular templates are safe.  Refer {@link
 * ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist} and
 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
 *
 * For the general details about this service in Angular, read the main page for {@link ng.$sce
 * Strict Contextual Escaping (SCE)}.
 *
 * **Example**:  Consider the following case. <a name="example"></a>
 *
 * - your app is hosted at url `http://myapp.example.com/`
 * - but some of your templates are hosted on other domains you control such as
 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
 *
 * Here is what a secure configuration for this scenario might look like:
 *
 * ```
 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
 *    $sceDelegateProvider.resourceUrlWhitelist([
 *      // Allow same origin resource loads.
 *      'self',
 *      // Allow loading from our assets domain.  Notice the difference between * and **.
 *      'http://srv*.assets.example.com/**'
 *    ]);
 *
 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
 *    $sceDelegateProvider.resourceUrlBlacklist([
 *      'http://myapp.example.com/clickThru**'
 *    ]);
 *  });
 * ```
 */

function $SceDelegateProvider() {
  this.SCE_CONTEXTS = SCE_CONTEXTS;

  // Resource URLs can also be trusted by policy.
  var resourceUrlWhitelist = ['self'],
      resourceUrlBlacklist = [];

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlWhitelist
   * @kind function
   *
   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
   *    provided.  This must be an array or null.  A snapshot of this array is used so further
   *    changes to the array are ignored.
   *
   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *    allowed in this array.
   *
   *    <div class="alert alert-warning">
   *    **Note:** an empty whitelist array will block all URLs!
   *    </div>
   *
   * @return {Array} the currently set whitelist array.
   *
   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
   * same origin resource requests.
   *
   * @description
   * Sets/Gets the whitelist of trusted resource URLs.
   */
  this.resourceUrlWhitelist = function(value) {
    if (arguments.length) {
      resourceUrlWhitelist = adjustMatchers(value);
    }
    return resourceUrlWhitelist;
  };

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlBlacklist
   * @kind function
   *
   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
   *    provided.  This must be an array or null.  A snapshot of this array is used so further
   *    changes to the array are ignored.
   *
   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *    allowed in this array.
   *
   *    The typical usage for the blacklist is to **block
   *    [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
   *    these would otherwise be trusted but actually return content from the redirected domain.
   *
   *    Finally, **the blacklist overrides the whitelist** and has the final say.
   *
   * @return {Array} the currently set blacklist array.
   *
   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
   * is no blacklist.)
   *
   * @description
   * Sets/Gets the blacklist of trusted resource URLs.
   */

  this.resourceUrlBlacklist = function(value) {
    if (arguments.length) {
      resourceUrlBlacklist = adjustMatchers(value);
    }
    return resourceUrlBlacklist;
  };

  this.$get = ['$injector', function($injector) {

    var htmlSanitizer = function htmlSanitizer(html) {
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    };

    if ($injector.has('$sanitize')) {
      htmlSanitizer = $injector.get('$sanitize');
    }


    function matchUrl(matcher, parsedUrl) {
      if (matcher === 'self') {
        return urlIsSameOrigin(parsedUrl);
      } else {
        // definitely a regex.  See adjustMatchers()
        return !!matcher.exec(parsedUrl.href);
      }
    }

    function isResourceUrlAllowedByPolicy(url) {
      var parsedUrl = urlResolve(url.toString());
      var i, n, allowed = false;
      // Ensure that at least one item from the whitelist allows this url.
      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
          allowed = true;
          break;
        }
      }
      if (allowed) {
        // Ensure that no item from the blacklist blocked this url.
        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
            allowed = false;
            break;
          }
        }
      }
      return allowed;
    }

    function generateHolderType(Base) {
      var holderType = function TrustedValueHolderType(trustedValue) {
        this.$$unwrapTrustedValue = function() {
          return trustedValue;
        };
      };
      if (Base) {
        holderType.prototype = new Base();
      }
      holderType.prototype.valueOf = function sceValueOf() {
        return this.$$unwrapTrustedValue();
      };
      holderType.prototype.toString = function sceToString() {
        return this.$$unwrapTrustedValue().toString();
      };
      return holderType;
    }

    var trustedValueHolderBase = generateHolderType(),
        byType = {};

    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);

    /**
     * @ngdoc method
     * @name $sceDelegate#trustAs
     *
     * @description
     * Returns an object that is trusted by angular for use in specified strict
     * contextual escaping contexts (such as ng-bind-html, ng-include, any src
     * attribute interpolation, any dom event binding attribute interpolation
     * such as for onclick,  etc.) that uses the provided value.
     * See {@link ng.$sce $sce} for enabling strict contextual escaping.
     *
     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
     *   resourceUrl, html, js and css.
     * @param {*} value The value that that should be considered trusted/safe.
     * @returns {*} A value that can be used to stand in for the provided `value` in places
     * where Angular expects a $sce.trustAs() return value.
     */
    function trustAs(type, trustedValue) {
      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      if (!Constructor) {
        throw $sceMinErr('icontext',
            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
            type, trustedValue);
      }
      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
        return trustedValue;
      }
      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
      // mutable objects, we ensure here that the value passed in is actually a string.
      if (typeof trustedValue !== 'string') {
        throw $sceMinErr('itype',
            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
            type);
      }
      return new Constructor(trustedValue);
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#valueOf
     *
     * @description
     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
     *
     * If the passed parameter is not a value that had been returned by {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, returns it as-is.
     *
     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
     *      call or anything else.
     * @returns {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
     *     `value` unchanged.
     */
    function valueOf(maybeTrusted) {
      if (maybeTrusted instanceof trustedValueHolderBase) {
        return maybeTrusted.$$unwrapTrustedValue();
      } else {
        return maybeTrusted;
      }
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#getTrusted
     *
     * @description
     * Takes the result of a {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call and
     * returns the originally supplied value if the queried context type is a supertype of the
     * created type.  If this condition isn't satisfied, throws an exception.
     *
     * <div class="alert alert-danger">
     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
     * (XSS) vulnerability in your application.
     * </div>
     *
     * @param {string} type The kind of context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} call.
     * @returns {*} The value the was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if valid in this context.  Otherwise, throws an exception.
     */
    function getTrusted(type, maybeTrusted) {
      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
        return maybeTrusted;
      }
      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      if (constructor && maybeTrusted instanceof constructor) {
        return maybeTrusted.$$unwrapTrustedValue();
      }
      // If we get here, then we may only take one of two actions.
      // 1. sanitize the value for the requested type, or
      // 2. throw an exception.
      if (type === SCE_CONTEXTS.RESOURCE_URL) {
        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
          return maybeTrusted;
        } else {
          throw $sceMinErr('insecurl',
              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
              maybeTrusted.toString());
        }
      } else if (type === SCE_CONTEXTS.HTML) {
        return htmlSanitizer(maybeTrusted);
      }
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    }

    return { trustAs: trustAs,
             getTrusted: getTrusted,
             valueOf: valueOf };
  }];
}


/**
 * @ngdoc provider
 * @name $sceProvider
 * @this
 *
 * @description
 *
 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
 * -   enable/disable Strict Contextual Escaping (SCE) in a module
 * -   override the default implementation with a custom delegate
 *
 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
 */

/**
 * @ngdoc service
 * @name $sce
 * @kind function
 *
 * @description
 *
 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
 *
 * # Strict Contextual Escaping
 *
 * Strict Contextual Escaping (SCE) is a mode in which AngularJS requires bindings in certain
 * contexts to result in a value that is marked as safe to use for that context.  One example of
 * such a context is binding arbitrary html controlled by the user via `ng-bind-html`.  We refer
 * to these contexts as privileged or SCE contexts.
 *
 * As of version 1.2, Angular ships with SCE enabled by default.
 *
 * Note:  When enabled (the default), IE<11 in quirks mode is not supported.  In this mode, IE<11 allow
 * one to execute arbitrary javascript by the use of the expression() syntax.  Refer
 * <http://blogs.msdn.com/b/ie/archive/2008/10/16/ending-expressions.aspx> to learn more about them.
 * You can ensure your document is in standards mode and not quirks mode by adding `<!doctype html>`
 * to the top of your HTML document.
 *
 * SCE assists in writing code in a way that (a) is secure by default and (b) makes auditing for
 * security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
 *
 * Here's an example of a binding in a privileged context:
 *
 * ```
 * <input ng-model="userHtml" aria-label="User input">
 * <div ng-bind-html="userHtml"></div>
 * ```
 *
 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
 * disabled, this application allows the user to render arbitrary HTML into the DIV.
 * In a more realistic example, one may be rendering user comments, blog articles, etc. via
 * bindings.  (HTML is just one example of a context where rendering user controlled input creates
 * security vulnerabilities.)
 *
 * For the case of HTML, you might use a library, either on the client side, or on the server side,
 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
 *
 * How would you ensure that every place that used these types of bindings was bound to a value that
 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
 * properties/fields and forgot to update the binding to the sanitized value?
 *
 * To be secure by default, you want to ensure that any such bindings are disallowed unless you can
 * determine that something explicitly says it's safe to use a value for binding in that
 * context.  You can then audit your code (a simple grep would do) to ensure that this is only done
 * for those values that you can easily tell are safe - because they were received from your server,
 * sanitized by your library, etc.  You can organize your codebase to help with this - perhaps
 * allowing only the files in a specific directory to do this.  Ensuring that the internal API
 * exposed by that code doesn't markup arbitrary values as safe then becomes a more manageable task.
 *
 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
 * obtain values that will be accepted by SCE / privileged contexts.
 *
 *
 * ## How does it work?
 *
 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
 * $sce.getTrusted(context, value)} rather than to the value directly.  Directives use {@link
 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs the
 * {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals.
 *
 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
 * simplified):
 *
 * ```
 * var ngBindHtmlDirective = ['$sce', function($sce) {
 *   return function(scope, element, attr) {
 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
 *       element.html(value || '');
 *     });
 *   };
 * }];
 * ```
 *
 * ## Impact on loading templates
 *
 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
 * `templateUrl`'s specified by {@link guide/directive directives}.
 *
 * By default, Angular only loads templates from the same domain and protocol as the application
 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
 *
 * *Please note*:
 * The browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy apply in addition to this and may further restrict whether the template is successfully
 * loaded.  This means that without the right CORS policy, loading templates from a different domain
 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
 * browsers.
 *
 * ## This feels like too much overhead
 *
 * It's important to remember that SCE only applies to interpolation expressions.
 *
 * If your expressions are constant literals, they're automatically trusted and you don't need to
 * call `$sce.trustAs` on them (remember to include the `ngSanitize` module) (e.g.
 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works.
 *
 * Additionally, `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
 * through {@link ng.$sce#getTrusted $sce.getTrusted}.  SCE doesn't play a role here.
 *
 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
 * templates in `ng-include` from your application's domain without having to even know about SCE.
 * It blocks loading templates from other domains or loading templates over http from an https
 * served document.  You can change these by setting your own custom {@link
 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
 *
 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
 * application that's secure and can be audited to verify that with much more ease than bolting
 * security onto an application later.
 *
 * <a name="contexts"></a>
 * ## What trusted context types are supported?
 *
 * | Context             | Notes          |
 * |---------------------|----------------|
 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=` and `<img src=` sanitize their urls and don't constitute an SCE context. |
 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG`, `VIDEO`, `AUDIO`, `SOURCE`, and `TRACK` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
 *
 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
 *
 *  Each element in these arrays must be one of the following:
 *
 *  - **'self'**
 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
 *      domain** as the application document using the **same protocol**.
 *  - **String** (except the special value `'self'`)
 *    - The string is matched against the full *normalized / absolute URL* of the resource
 *      being tested (substring matches are not good enough.)
 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
 *      match themselves.
 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
 *      in a whitelist.
 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
 *      http://foo.example.com/templates/**).
 *  - **RegExp** (*see caveat below*)
 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
 *      is highly recommended to use the string patterns and only fall back to regular expressions
 *      as a last resort.
 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
 *    - If you are generating your JavaScript from some other templating engine (not
 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
 *      remember to escape your regular expression (and be aware that you might need more than
 *      one level of escaping depending on your templating engine and the way you interpolated
 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
 *      enough before coding your own.  E.g. Ruby has
 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
 *      Closure library's [goog.string.regExpEscape(s)](
 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
 *
 * ## Show me an example using SCE.
 *
 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
 * <file name="index.html">
 *   <div ng-controller="AppController as myCtrl">
 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
 *     <b>User comments</b><br>
 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
 *     exploit.
 *     <div class="well">
 *       <div ng-repeat="userComment in myCtrl.userComments">
 *         <b>{{userComment.name}}</b>:
 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
 *         <br>
 *       </div>
 *     </div>
 *   </div>
 * </file>
 *
 * <file name="script.js">
 *   angular.module('mySceApp', ['ngSanitize'])
 *     .controller('AppController', ['$http', '$templateCache', '$sce',
 *       function AppController($http, $templateCache, $sce) {
 *         var self = this;
 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
 *           self.userComments = response.data;
 *         });
 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *             'sanitization.&quot;">Hover over this text.</span>');
 *       }]);
 * </file>
 *
 * <file name="test_data.json">
 * [
 *   { "name": "Alice",
 *     "htmlComment":
 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
 *   },
 *   { "name": "Bob",
 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
 *   }
 * ]
 * </file>
 *
 * <file name="protractor.js" type="protractor">
 *   describe('SCE doc demo', function() {
 *     it('should sanitize untrusted values', function() {
 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
 *     });
 *
 *     it('should NOT sanitize explicitly trusted values', function() {
 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *           'sanitization.&quot;">Hover over this text.</span>');
 *     });
 *   });
 * </file>
 * </example>
 *
 *
 *
 * ## Can I disable SCE completely?
 *
 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
 * for little coding overhead.  It will be much harder to take an SCE disabled application and
 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
 * for cases where you have a lot of existing code that was written before SCE was introduced and
 * you're migrating them a module at a time.
 *
 * That said, here's how you can completely disable SCE:
 *
 * ```
 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
 *   // Completely disable SCE.  For demonstration purposes only!
 *   // Do not use in new projects.
 *   $sceProvider.enabled(false);
 * });
 * ```
 *
 */

function $SceProvider() {
  var enabled = true;

  /**
   * @ngdoc method
   * @name $sceProvider#enabled
   * @kind function
   *
   * @param {boolean=} value If provided, then enables/disables SCE.
   * @return {boolean} true if SCE is enabled, false otherwise.
   *
   * @description
   * Enables/disables SCE and returns the current value.
   */
  this.enabled = function(value) {
    if (arguments.length) {
      enabled = !!value;
    }
    return enabled;
  };


  /* Design notes on the default implementation for SCE.
   *
   * The API contract for the SCE delegate
   * -------------------------------------
   * The SCE delegate object must provide the following 3 methods:
   *
   * - trustAs(contextEnum, value)
   *     This method is used to tell the SCE service that the provided value is OK to use in the
   *     contexts specified by contextEnum.  It must return an object that will be accepted by
   *     getTrusted() for a compatible contextEnum and return this value.
   *
   * - valueOf(value)
   *     For values that were not produced by trustAs(), return them as is.  For values that were
   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
   *     such a value.
   *
   * - getTrusted(contextEnum, value)
   *     This function should return the a value that is safe to use in the context specified by
   *     contextEnum or throw and exception otherwise.
   *
   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
   * instance, an implementation could maintain a registry of all trusted objects by context.  In
   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
   * return the same object passed in if it was found in the registry under a compatible context or
   * throw an exception otherwise.  An implementation might only wrap values some of the time based
   * on some criteria.  getTrusted() might return a value and not throw an exception for special
   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
   *
   *
   * A note on the inheritance model for SCE contexts
   * ------------------------------------------------
   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
   * is purely an implementation details.
   *
   * The contract is simply this:
   *
   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
   *     will also succeed.
   *
   * Inheritance happens to capture this in a natural way.  In some future, we
   * may not use inheritance anymore.  That is OK because no code outside of
   * sce.js and sceSpecs.js would need to be aware of this detail.
   */

  this.$get = ['$parse', '$sceDelegate', function(
                $parse,   $sceDelegate) {
    // Support: IE 9-11 only
    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
    // the "expression(javascript expression)" syntax which is insecure.
    if (enabled && msie < 8) {
      throw $sceMinErr('iequirks',
        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
    }

    var sce = shallowCopy(SCE_CONTEXTS);

    /**
     * @ngdoc method
     * @name $sce#isEnabled
     * @kind function
     *
     * @return {Boolean} true if SCE is enabled, false otherwise.  If you want to set the value, you
     * have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
     *
     * @description
     * Returns a boolean indicating if SCE is enabled.
     */
    sce.isEnabled = function() {
      return enabled;
    };
    sce.trustAs = $sceDelegate.trustAs;
    sce.getTrusted = $sceDelegate.getTrusted;
    sce.valueOf = $sceDelegate.valueOf;

    if (!enabled) {
      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
      sce.valueOf = identity;
    }

    /**
     * @ngdoc method
     * @name $sce#parseAs
     *
     * @description
     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
     * *result*)}
     *
     * @param {string} type The kind of SCE context in which this result will be used.
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */
    sce.parseAs = function sceParseAs(type, expr) {
      var parsed = $parse(expr);
      if (parsed.literal && parsed.constant) {
        return parsed;
      } else {
        return $parse(expr, function(value) {
          return sce.getTrusted(type, value);
        });
      }
    };

    /**
     * @ngdoc method
     * @name $sce#trustAs
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.  As such,
     * returns an object that is trusted by angular for use in specified strict contextual
     * escaping contexts (such as ng-bind-html, ng-include, any src attribute
     * interpolation, any dom event binding attribute interpolation such as for onclick,  etc.)
     * that uses the provided value.  See * {@link ng.$sce $sce} for enabling strict contextual
     * escaping.
     *
     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
     *   resourceUrl, html, js and css.
     * @param {*} value The value that that should be considered trusted/safe.
     * @returns {*} A value that can be used to stand in for the provided `value` in places
     * where Angular expects a $sce.trustAs() return value.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsHtml
     *
     * @description
     * Shorthand method.  `$sce.trustAsHtml(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedHtml
     *     $sce.getTrustedHtml(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the
     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedUrl
     *     $sce.getTrustedUrl(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the
     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedResourceUrl
     *     $sce.getTrustedResourceUrl(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the return
     *     value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsJs
     *
     * @description
     * Shorthand method.  `$sce.trustAsJs(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedJs
     *     $sce.getTrustedJs(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the
     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#getTrusted
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
     * takes the result of a {@link ng.$sce#trustAs `$sce.trustAs`}() call and returns the
     * originally supplied value if the queried context type is a supertype of the created type.
     * If this condition isn't satisfied, throws an exception.
     *
     * @param {string} type The kind of context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs `$sce.trustAs`}
     *                         call.
     * @returns {*} The value the was originally provided to
     *              {@link ng.$sce#trustAs `$sce.trustAs`} if valid in this context.
     *              Otherwise, throws an exception.
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedHtml
     *
     * @description
     * Shorthand method.  `$sce.getTrustedHtml(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.HTML, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedCss
     *
     * @description
     * Shorthand method.  `$sce.getTrustedCss(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.CSS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedJs
     *
     * @description
     * Shorthand method.  `$sce.getTrustedJs(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.JS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsHtml
     *
     * @description
     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsCss
     *
     * @description
     * Shorthand method.  `$sce.parseAsCss(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsJs
     *
     * @description
     * Shorthand method.  `$sce.parseAsJs(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    // Shorthand delegations.
    var parse = sce.parseAs,
        getTrusted = sce.getTrusted,
        trustAs = sce.trustAs;

    forEach(SCE_CONTEXTS, function(enumValue, name) {
      var lName = lowercase(name);
      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
        return parse(enumValue, expr);
      };
      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
        return getTrusted(enumValue, value);
      };
      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
        return trustAs(enumValue, value);
      };
    });

    return sce;
  }];
}

/* exported $SnifferProvider */

/**
 * !!! This is an undocumented "private" service !!!
 *
 * @name $sniffer
 * @requires $window
 * @requires $document
 * @this
 *
 * @property {boolean} history Does the browser support html5 history api ?
 * @property {boolean} transitions Does the browser support CSS transition events ?
 * @property {boolean} animations Does the browser support CSS animation events ?
 *
 * @description
 * This is very simple implementation of testing browser's features.
 */
function $SnifferProvider() {
  this.$get = ['$window', '$document', function($window, $document) {
    var eventSupport = {},
        // Chrome Packaged Apps are not allowed to access `history.pushState`.
        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
        // (see https://developer.chrome.com/apps/manifest/sandbox).
        isChromePackagedApp =
            $window.chrome &&
            ($window.chrome.app && $window.chrome.app.runtime ||
                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
        android =
          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
        document = $document[0] || {},
        bodyStyle = document.body && document.body.style,
        transitions = false,
        animations = false;

    if (bodyStyle) {
      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
      // Mentioned browsers need a -webkit- prefix for transitions & animations.
      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
    }


    return {
      // Android has history.pushState, but it does not update location correctly
      // so let's not use the history API at all.
      // http://code.google.com/p/android/issues/detail?id=17471
      // https://github.com/angular/angular.js/issues/904

      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
      // so let's not use the history API also
      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
      hasEvent: function(event) {
        // Support: IE 9-11 only
        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
        // it. In particular the event is not fired when backspace or delete key are pressed or
        // when cut operation is performed.
        // IE10+ implements 'input' event but it erroneously fires under various situations,
        // e.g. when placeholder changes, or a form is focused.
        if (event === 'input' && msie) return false;

        if (isUndefined(eventSupport[event])) {
          var divElm = document.createElement('div');
          eventSupport[event] = 'on' + event in divElm;
        }

        return eventSupport[event];
      },
      csp: csp(),
      transitions: transitions,
      animations: animations,
      android: android
    };
  }];
}

var $templateRequestMinErr = minErr('$compile');

/**
 * @ngdoc provider
 * @name $templateRequestProvider
 * @this
 *
 * @description
 * Used to configure the options passed to the {@link $http} service when making a template request.
 *
 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
 * requesting a template.
 */
function $TemplateRequestProvider() {

  var httpOptions;

  /**
   * @ngdoc method
   * @name $templateRequestProvider#httpOptions
   * @description
   * The options to be passed to the {@link $http} service when making the request.
   * You can use this to override options such as the "Accept" header for template requests.
   *
   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
   * options if not overridden here.
   *
   * @param {string=} value new value for the {@link $http} options.
   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
   */
  this.httpOptions = function(val) {
    if (val) {
      httpOptions = val;
      return this;
    }
    return httpOptions;
  };

  /**
   * @ngdoc service
   * @name $templateRequest
   *
   * @description
   * The `$templateRequest` service runs security checks then downloads the provided template using
   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
   * when `tpl` is of type string and `$templateCache` has the matching entry.
   *
   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
   * can configure this via {@link $templateRequestProvider#httpOptions}.
   *
   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
   *
   * @return {Promise} a promise for the HTTP response data of the given URL.
   *
   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
   */
  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
    function($exceptionHandler, $templateCache, $http, $q, $sce) {

      function handleRequestFn(tpl, ignoreRequestError) {
        handleRequestFn.totalPendingRequests++;

        // We consider the template cache holds only trusted templates, so
        // there's no need to go through whitelisting again for keys that already
        // are included in there. This also makes Angular accept any script
        // directive, no matter its name. However, we still need to unwrap trusted
        // types.
        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
          tpl = $sce.getTrustedResourceUrl(tpl);
        }

        var transformResponse = $http.defaults && $http.defaults.transformResponse;

        if (isArray(transformResponse)) {
          transformResponse = transformResponse.filter(function(transformer) {
            return transformer !== defaultHttpResponseTransform;
          });
        } else if (transformResponse === defaultHttpResponseTransform) {
          transformResponse = null;
        }

        return $http.get(tpl, extend({
            cache: $templateCache,
            transformResponse: transformResponse
          }, httpOptions))
          .finally(function() {
            handleRequestFn.totalPendingRequests--;
          })
          .then(function(response) {
            $templateCache.put(tpl, response.data);
            return response.data;
          }, handleError);

        function handleError(resp) {
          if (!ignoreRequestError) {
            resp = $templateRequestMinErr('tpload',
                'Failed to load template: {0} (HTTP status: {1} {2})',
                tpl, resp.status, resp.statusText);

            $exceptionHandler(resp);
          }

          return $q.reject(resp);
        }
      }

      handleRequestFn.totalPendingRequests = 0;

      return handleRequestFn;
    }
  ];
}

/** @this */
function $$TestabilityProvider() {
  this.$get = ['$rootScope', '$browser', '$location',
       function($rootScope,   $browser,   $location) {

    /**
     * @name $testability
     *
     * @description
     * The private $$testability service provides a collection of methods for use when debugging
     * or by automated test and debugging tools.
     */
    var testability = {};

    /**
     * @name $$testability#findBindings
     *
     * @description
     * Returns an array of elements that are bound (via ng-bind or {{}})
     * to expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The binding expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression. Filters and whitespace are ignored.
     */
    testability.findBindings = function(element, expression, opt_exactMatch) {
      var bindings = element.getElementsByClassName('ng-binding');
      var matches = [];
      forEach(bindings, function(binding) {
        var dataBinding = angular.element(binding).data('$binding');
        if (dataBinding) {
          forEach(dataBinding, function(bindingName) {
            if (opt_exactMatch) {
              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
              if (matcher.test(bindingName)) {
                matches.push(binding);
              }
            } else {
              if (bindingName.indexOf(expression) !== -1) {
                matches.push(binding);
              }
            }
          });
        }
      });
      return matches;
    };

    /**
     * @name $$testability#findModels
     *
     * @description
     * Returns an array of elements that are two-way found via ng-model to
     * expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The model expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression.
     */
    testability.findModels = function(element, expression, opt_exactMatch) {
      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
      for (var p = 0; p < prefixes.length; ++p) {
        var attributeEquals = opt_exactMatch ? '=' : '*=';
        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
        var elements = element.querySelectorAll(selector);
        if (elements.length) {
          return elements;
        }
      }
    };

    /**
     * @name $$testability#getLocation
     *
     * @description
     * Shortcut for getting the location in a browser agnostic way. Returns
     *     the path, search, and hash. (e.g. /path?a=b#hash)
     */
    testability.getLocation = function() {
      return $location.url();
    };

    /**
     * @name $$testability#setLocation
     *
     * @description
     * Shortcut for navigating to a location without doing a full page reload.
     *
     * @param {string} url The location url (path, search and hash,
     *     e.g. /path?a=b#hash) to go to.
     */
    testability.setLocation = function(url) {
      if (url !== $location.url()) {
        $location.url(url);
        $rootScope.$digest();
      }
    };

    /**
     * @name $$testability#whenStable
     *
     * @description
     * Calls the callback when $timeout and $http requests are completed.
     *
     * @param {function} callback
     */
    testability.whenStable = function(callback) {
      $browser.notifyWhenNoOutstandingRequests(callback);
    };

    return testability;
  }];
}

/** @this */
function $TimeoutProvider() {
  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {

    var deferreds = {};


     /**
      * @ngdoc service
      * @name $timeout
      *
      * @description
      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
      * block and delegates any exceptions to
      * {@link ng.$exceptionHandler $exceptionHandler} service.
      *
      * The return value of calling `$timeout` is a promise, which will be resolved when
      * the delay has passed and the timeout function, if provided, is executed.
      *
      * To cancel a timeout request, call `$timeout.cancel(promise)`.
      *
      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
      * synchronously flush the queue of deferred functions.
      *
      * If you only want a promise that will be resolved after some specified delay
      * then you can call `$timeout` without the `fn` function.
      *
      * @param {function()=} fn A function, whose execution should be delayed.
      * @param {number=} [delay=0] Delay in milliseconds.
      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
      * @param {...*=} Pass additional parameters to the executed function.
      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
      *   will be resolved with the return value of the `fn` function.
      *
      */
    function timeout(fn, delay, invokeApply) {
      if (!isFunction(fn)) {
        invokeApply = delay;
        delay = fn;
        fn = noop;
      }

      var args = sliceArgs(arguments, 3),
          skipApply = (isDefined(invokeApply) && !invokeApply),
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise,
          timeoutId;

      timeoutId = $browser.defer(function() {
        try {
          deferred.resolve(fn.apply(null, args));
        } catch (e) {
          deferred.reject(e);
          $exceptionHandler(e);
        } finally {
          delete deferreds[promise.$$timeoutId];
        }

        if (!skipApply) $rootScope.$apply();
      }, delay);

      promise.$$timeoutId = timeoutId;
      deferreds[timeoutId] = deferred;

      return promise;
    }


     /**
      * @ngdoc method
      * @name $timeout#cancel
      *
      * @description
      * Cancels a task associated with the `promise`. As a result of this, the promise will be
      * resolved with a rejection.
      *
      * @param {Promise=} promise Promise returned by the `$timeout` function.
      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
      *   canceled.
      */
    timeout.cancel = function(promise) {
      if (promise && promise.$$timeoutId in deferreds) {
        // Timeout cancels should not report an unhandled promise.
        deferreds[promise.$$timeoutId].promise.catch(noop);
        deferreds[promise.$$timeoutId].reject('canceled');
        delete deferreds[promise.$$timeoutId];
        return $browser.defer.cancel(promise.$$timeoutId);
      }
      return false;
    };

    return timeout;
  }];
}

// NOTE:  The usage of window and document instead of $window and $document here is
// deliberate.  This service depends on the specific behavior of anchor nodes created by the
// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
// doesn't know about mocked locations and resolves URLs to the real document - which is
// exactly the behavior needed here.  There is little value is mocking these out for this
// service.
var urlParsingNode = window.document.createElement('a');
var originUrl = urlResolve(window.location.href);


/**
 *
 * Implementation Notes for non-IE browsers
 * ----------------------------------------
 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
 * URL will be resolved into an absolute URL in the context of the application document.
 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
 * properties are all populated to reflect the normalized URL.  This approach has wide
 * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *
 * Implementation Notes for IE
 * ---------------------------
 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
 * work around that by performing the parsing in a 2nd step by taking a previously normalized
 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
 * properties such as protocol, hostname, port, etc.
 *
 * References:
 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *   http://url.spec.whatwg.org/#urlutils
 *   https://github.com/angular/angular.js/pull/2902
 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
 *
 * @kind function
 * @param {string} url The URL to be parsed.
 * @description Normalizes and parses a URL.
 * @returns {object} Returns the normalized URL as a dictionary.
 *
 *   | member name   | Description    |
 *   |---------------|----------------|
 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
 *   | protocol      | The protocol including the trailing colon                              |
 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
 *   | search        | The search params, minus the question mark                             |
 *   | hash          | The hash string, minus the hash symbol
 *   | hostname      | The hostname
 *   | port          | The port, without ":"
 *   | pathname      | The pathname, beginning with "/"
 *
 */
function urlResolve(url) {
  var href = url;

  // Support: IE 9-11 only
  if (msie) {
    // Normalize before parse.  Refer Implementation Notes on why this is
    // done in two steps on IE.
    urlParsingNode.setAttribute('href', href);
    href = urlParsingNode.href;
  }

  urlParsingNode.setAttribute('href', href);

  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
  return {
    href: urlParsingNode.href,
    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
    host: urlParsingNode.host,
    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
    hostname: urlParsingNode.hostname,
    port: urlParsingNode.port,
    pathname: (urlParsingNode.pathname.charAt(0) === '/')
      ? urlParsingNode.pathname
      : '/' + urlParsingNode.pathname
  };
}

/**
 * Parse a request URL and determine whether this is a same-origin request as the application document.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the request is for the same origin as the application document.
 */
function urlIsSameOrigin(requestUrl) {
  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
  return (parsed.protocol === originUrl.protocol &&
          parsed.host === originUrl.host);
}

/**
 * @ngdoc service
 * @name $window
 * @this
 *
 * @description
 * A reference to the browser's `window` object. While `window`
 * is globally available in JavaScript, it causes testability problems, because
 * it is a global variable. In angular we always refer to it through the
 * `$window` service, so it may be overridden, removed or mocked for testing.
 *
 * Expressions, like the one defined for the `ngClick` directive in the example
 * below, are evaluated with respect to the current scope.  Therefore, there is
 * no risk of inadvertently coding in a dependency on a global value in such an
 * expression.
 *
 * @example
   <example module="windowExample" name="window-service">
     <file name="index.html">
       <script>
         angular.module('windowExample', [])
           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
             $scope.greeting = 'Hello, World!';
             $scope.doGreeting = function(greeting) {
               $window.alert(greeting);
             };
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="text" ng-model="greeting" aria-label="greeting" />
         <button ng-click="doGreeting(greeting)">ALERT</button>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
      it('should display the greeting in the input box', function() {
       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
       // If we click the button it will block the test runner
       // element(':button').click();
      });
     </file>
   </example>
 */
function $WindowProvider() {
  this.$get = valueFn(window);
}

/**
 * @name $$cookieReader
 * @requires $document
 *
 * @description
 * This is a private service for reading cookies used by $http and ngCookies
 *
 * @return {Object} a key/value map of the current cookies
 */
function $$CookieReader($document) {
  var rawDocument = $document[0] || {};
  var lastCookies = {};
  var lastCookieString = '';

  function safeGetCookie(rawDocument) {
    try {
      return rawDocument.cookie || '';
    } catch (e) {
      return '';
    }
  }

  function safeDecodeURIComponent(str) {
    try {
      return decodeURIComponent(str);
    } catch (e) {
      return str;
    }
  }

  return function() {
    var cookieArray, cookie, i, index, name;
    var currentCookieString = safeGetCookie(rawDocument);

    if (currentCookieString !== lastCookieString) {
      lastCookieString = currentCookieString;
      cookieArray = lastCookieString.split('; ');
      lastCookies = {};

      for (i = 0; i < cookieArray.length; i++) {
        cookie = cookieArray[i];
        index = cookie.indexOf('=');
        if (index > 0) { //ignore nameless cookies
          name = safeDecodeURIComponent(cookie.substring(0, index));
          // the first value that is seen for a cookie is the most
          // specific one.  values for the same cookie name that
          // follow are for less specific paths.
          if (isUndefined(lastCookies[name])) {
            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
          }
        }
      }
    }
    return lastCookies;
  };
}

$$CookieReader.$inject = ['$document'];

/** @this */
function $$CookieReaderProvider() {
  this.$get = $$CookieReader;
}

/* global currencyFilter: true,
 dateFilter: true,
 filterFilter: true,
 jsonFilter: true,
 limitToFilter: true,
 lowercaseFilter: true,
 numberFilter: true,
 orderByFilter: true,
 uppercaseFilter: true,
 */

/**
 * @ngdoc provider
 * @name $filterProvider
 * @description
 *
 * Filters are just functions which transform input to an output. However filters need to be
 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
 * annotated with dependencies and is responsible for creating a filter function.
 *
 * <div class="alert alert-warning">
 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
 * (`myapp_subsection_filterx`).
 * </div>
 *
 * ```js
 *   // Filter registration
 *   function MyModule($provide, $filterProvider) {
 *     // create a service to demonstrate injection (not always needed)
 *     $provide.value('greet', function(name){
 *       return 'Hello ' + name + '!';
 *     });
 *
 *     // register a filter factory which uses the
 *     // greet service to demonstrate DI.
 *     $filterProvider.register('greet', function(greet){
 *       // return the filter function which uses the greet service
 *       // to generate salutation
 *       return function(text) {
 *         // filters need to be forgiving so check input validity
 *         return text && greet(text) || text;
 *       };
 *     });
 *   }
 * ```
 *
 * The filter function is registered with the `$injector` under the filter name suffix with
 * `Filter`.
 *
 * ```js
 *   it('should be the same instance', inject(
 *     function($filterProvider) {
 *       $filterProvider.register('reverse', function(){
 *         return ...;
 *       });
 *     },
 *     function($filter, reverseFilter) {
 *       expect($filter('reverse')).toBe(reverseFilter);
 *     });
 * ```
 *
 *
 * For more information about how angular filters work, and how to create your own filters, see
 * {@link guide/filter Filters} in the Angular Developer Guide.
 */

/**
 * @ngdoc service
 * @name $filter
 * @kind function
 * @description
 * Filters are used for formatting data displayed to the user.
 *
 * They can be used in view templates, controllers or services.Angular comes
 * with a collection of [built-in filters](api/ng/filter), but it is easy to
 * define your own as well.
 *
 * The general syntax in templates is as follows:
 *
 * ```html
 * {{ expression [| filter_name[:parameter_value] ... ] }}
 * ```
 *
 * @param {String} name Name of the filter function to retrieve
 * @return {Function} the filter function
 * @example
   <example name="$filter" module="filterExample">
     <file name="index.html">
       <div ng-controller="MainCtrl">
        <h3>{{ originalText }}</h3>
        <h3>{{ filteredText }}</h3>
       </div>
     </file>

     <file name="script.js">
      angular.module('filterExample', [])
      .controller('MainCtrl', function($scope, $filter) {
        $scope.originalText = 'hello';
        $scope.filteredText = $filter('uppercase')($scope.originalText);
      });
     </file>
   </example>
  */
$FilterProvider.$inject = ['$provide'];
/** @this */
function $FilterProvider($provide) {
  var suffix = 'Filter';

  /**
   * @ngdoc method
   * @name $filterProvider#register
   * @param {string|Object} name Name of the filter function, or an object map of filters where
   *    the keys are the filter names and the values are the filter factories.
   *
   *    <div class="alert alert-warning">
   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
   *    (`myapp_subsection_filterx`).
   *    </div>
    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
   *    of the registered filter instances.
   */
  function register(name, factory) {
    if (isObject(name)) {
      var filters = {};
      forEach(name, function(filter, key) {
        filters[key] = register(key, filter);
      });
      return filters;
    } else {
      return $provide.factory(name + suffix, factory);
    }
  }
  this.register = register;

  this.$get = ['$injector', function($injector) {
    return function(name) {
      return $injector.get(name + suffix);
    };
  }];

  ////////////////////////////////////////

  /* global
    currencyFilter: false,
    dateFilter: false,
    filterFilter: false,
    jsonFilter: false,
    limitToFilter: false,
    lowercaseFilter: false,
    numberFilter: false,
    orderByFilter: false,
    uppercaseFilter: false
  */

  register('currency', currencyFilter);
  register('date', dateFilter);
  register('filter', filterFilter);
  register('json', jsonFilter);
  register('limitTo', limitToFilter);
  register('lowercase', lowercaseFilter);
  register('number', numberFilter);
  register('orderBy', orderByFilter);
  register('uppercase', uppercaseFilter);
}

/**
 * @ngdoc filter
 * @name filter
 * @kind function
 *
 * @description
 * Selects a subset of items from `array` and returns it as a new array.
 *
 * @param {Array} array The source array.
 * @param {string|Object|function()} expression The predicate to be used for selecting items from
 *   `array`.
 *
 *   Can be one of:
 *
 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
 *     objects with string properties in `array` that match this string will be returned. This also
 *     applies to nested object properties.
 *     The predicate can be negated by prefixing the string with `!`.
 *
 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
 *     which have property `name` containing "M" and property `phone` containing "1". A special
 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
 *     against any property of the object or its nested object properties. That's equivalent to the
 *     simple substring match with a `string` as described above. The special property name can be
 *     overwritten, using the `anyPropertyKey` parameter.
 *     The predicate can be negated by prefixing the string with `!`.
 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
 *     not containing "M".
 *
 *     Note that a named property will match properties on the same level only, while the special
 *     `$` property will match properties on the same level or deeper. E.g. an array item like
 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
 *     **will** be matched by `{$: 'John'}`.
 *
 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
 *     The function is called for each element of the array, with the element, its index, and
 *     the entire array itself as arguments.
 *
 *     The final result is an array of those elements that the predicate returned true for.
 *
 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
 *     determining if the expected value (from the filter expression) and actual value (from
 *     the object in the array) should be considered a match.
 *
 *   Can be one of:
 *
 *   - `function(actual, expected)`:
 *     The function will be given the object value and the predicate value to compare and
 *     should return true if both values should be considered equal.
 *
 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
 *     This is essentially strict comparison of expected and actual.
 *
 *   - `false`: A short hand for a function which will look for a substring match in a case
 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
 *
 *
 *   Defaults to `false`.
 *
 * @param {string} [anyPropertyKey] The special property name that matches against any property.
 *     By default `$`.
 *
 * @example
   <example name="filter-filter">
     <file name="index.html">
       <div ng-init="friends = [{name:'John', phone:'555-1276'},
                                {name:'Mary', phone:'800-BIG-MARY'},
                                {name:'Mike', phone:'555-4321'},
                                {name:'Adam', phone:'555-5678'},
                                {name:'Julie', phone:'555-8765'},
                                {name:'Juliette', phone:'555-5678'}]"></div>

       <label>Search: <input ng-model="searchText"></label>
       <table id="searchTextResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friend in friends | filter:searchText">
           <td>{{friend.name}}</td>
           <td>{{friend.phone}}</td>
         </tr>
       </table>
       <hr>
       <label>Any: <input ng-model="search.$"></label> <br>
       <label>Name only <input ng-model="search.name"></label><br>
       <label>Phone only <input ng-model="search.phone"></label><br>
       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
       <table id="searchObjResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friendObj in friends | filter:search:strict">
           <td>{{friendObj.name}}</td>
           <td>{{friendObj.phone}}</td>
         </tr>
       </table>
     </file>
     <file name="protractor.js" type="protractor">
       var expectFriendNames = function(expectedNames, key) {
         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
           arr.forEach(function(wd, i) {
             expect(wd.getText()).toMatch(expectedNames[i]);
           });
         });
       };

       it('should search across all fields when filtering with a string', function() {
         var searchText = element(by.model('searchText'));
         searchText.clear();
         searchText.sendKeys('m');
         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');

         searchText.clear();
         searchText.sendKeys('76');
         expectFriendNames(['John', 'Julie'], 'friend');
       });

       it('should search in specific fields when filtering with a predicate object', function() {
         var searchAny = element(by.model('search.$'));
         searchAny.clear();
         searchAny.sendKeys('i');
         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
       });
       it('should use a equal comparison when comparator is true', function() {
         var searchName = element(by.model('search.name'));
         var strict = element(by.model('strict'));
         searchName.clear();
         searchName.sendKeys('Julie');
         strict.click();
         expectFriendNames(['Julie'], 'friendObj');
       });
     </file>
   </example>
 */

function filterFilter() {
  return function(array, expression, comparator, anyPropertyKey) {
    if (!isArrayLike(array)) {
      if (array == null) {
        return array;
      } else {
        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
      }
    }

    anyPropertyKey = anyPropertyKey || '$';
    var expressionType = getTypeForFilter(expression);
    var predicateFn;
    var matchAgainstAnyProp;

    switch (expressionType) {
      case 'function':
        predicateFn = expression;
        break;
      case 'boolean':
      case 'null':
      case 'number':
      case 'string':
        matchAgainstAnyProp = true;
        // falls through
      case 'object':
        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
        break;
      default:
        return array;
    }

    return Array.prototype.filter.call(array, predicateFn);
  };
}

// Helper functions for `filterFilter`
function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
  var predicateFn;

  if (comparator === true) {
    comparator = equals;
  } else if (!isFunction(comparator)) {
    comparator = function(actual, expected) {
      if (isUndefined(actual)) {
        // No substring matching against `undefined`
        return false;
      }
      if ((actual === null) || (expected === null)) {
        // No substring matching against `null`; only match against `null`
        return actual === expected;
      }
      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
        // Should not compare primitives against objects, unless they have custom `toString` method
        return false;
      }

      actual = lowercase('' + actual);
      expected = lowercase('' + expected);
      return actual.indexOf(expected) !== -1;
    };
  }

  predicateFn = function(item) {
    if (shouldMatchPrimitives && !isObject(item)) {
      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
    }
    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
  };

  return predicateFn;
}

function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
  var actualType = getTypeForFilter(actual);
  var expectedType = getTypeForFilter(expected);

  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
  } else if (isArray(actual)) {
    // In case `actual` is an array, consider it a match
    // if ANY of it's items matches `expected`
    return actual.some(function(item) {
      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
    });
  }

  switch (actualType) {
    case 'object':
      var key;
      if (matchAgainstAnyProp) {
        for (key in actual) {
          if ((key.charAt(0) !== '$') && deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
            return true;
          }
        }
        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
      } else if (expectedType === 'object') {
        for (key in expected) {
          var expectedVal = expected[key];
          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
            continue;
          }

          var matchAnyProperty = key === anyPropertyKey;
          var actualVal = matchAnyProperty ? actual : actual[key];
          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
            return false;
          }
        }
        return true;
      } else {
        return comparator(actual, expected);
      }
    case 'function':
      return false;
    default:
      return comparator(actual, expected);
  }
}

// Used for easily differentiating between `null` and actual `object`
function getTypeForFilter(val) {
  return (val === null) ? 'null' : typeof val;
}

var MAX_DIGITS = 22;
var DECIMAL_SEP = '.';
var ZERO_CHAR = '0';

/**
 * @ngdoc filter
 * @name currency
 * @kind function
 *
 * @description
 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
 * symbol for current locale is used.
 *
 * @param {number} amount Input to filter.
 * @param {string=} symbol Currency symbol or identifier to be displayed.
 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
 * @returns {string} Formatted number.
 *
 *
 * @example
   <example module="currencyExample" name="currency-filter">
     <file name="index.html">
       <script>
         angular.module('currencyExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.amount = 1234.56;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="number" ng-model="amount" aria-label="amount"> <br>
         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should init with 1234.56', function() {
         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
       });
       it('should update', function() {
         if (browser.params.browser === 'safari') {
           // Safari does not understand the minus key. See
           // https://github.com/angular/protractor/issues/481
           return;
         }
         element(by.model('amount')).clear();
         element(by.model('amount')).sendKeys('-1234');
         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
       });
     </file>
   </example>
 */
currencyFilter.$inject = ['$locale'];
function currencyFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(amount, currencySymbol, fractionSize) {
    if (isUndefined(currencySymbol)) {
      currencySymbol = formats.CURRENCY_SYM;
    }

    if (isUndefined(fractionSize)) {
      fractionSize = formats.PATTERNS[1].maxFrac;
    }

    // if null or undefined pass it through
    return (amount == null)
        ? amount
        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
            replace(/\u00A4/g, currencySymbol);
  };
}

/**
 * @ngdoc filter
 * @name number
 * @kind function
 *
 * @description
 * Formats a number as text.
 *
 * If the input is null or undefined, it will just be returned.
 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
 * If the input is not a number an empty string is returned.
 *
 *
 * @param {number|string} number Number to format.
 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
 * If this is not provided then the fraction size is computed from the current locale's number
 * formatting pattern. In the case of the default locale, it will be 3.
 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
 *                   include "," group separators after each third digit).
 *
 * @example
   <example module="numberFilterExample" name="number-filter">
     <file name="index.html">
       <script>
         angular.module('numberFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.val = 1234.56789;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter number: <input ng-model='val'></label><br>
         Default formatting: <span id='number-default'>{{val | number}}</span><br>
         No fractions: <span>{{val | number:0}}</span><br>
         Negative number: <span>{{-val | number:4}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format numbers', function() {
         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
       });

       it('should update', function() {
         element(by.model('val')).clear();
         element(by.model('val')).sendKeys('3374.333');
         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
      });
     </file>
   </example>
 */
numberFilter.$inject = ['$locale'];
function numberFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(number, fractionSize) {

    // if null or undefined pass it through
    return (number == null)
        ? number
        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
                       fractionSize);
  };
}

/**
 * Parse a number (as a string) into three components that can be used
 * for formatting the number.
 *
 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
 *
 * @param  {string} numStr The number to parse
 * @return {object} An object describing this number, containing the following keys:
 *  - d : an array of digits containing leading zeros as necessary
 *  - i : the number of the digits in `d` that are to the left of the decimal point
 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
 *
 */
function parse(numStr) {
  var exponent = 0, digits, numberOfIntegerDigits;
  var i, j, zeros;

  // Decimal point?
  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
    numStr = numStr.replace(DECIMAL_SEP, '');
  }

  // Exponential form?
  if ((i = numStr.search(/e/i)) > 0) {
    // Work out the exponent.
    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
    numberOfIntegerDigits += +numStr.slice(i + 1);
    numStr = numStr.substring(0, i);
  } else if (numberOfIntegerDigits < 0) {
    // There was no decimal point or exponent so it is an integer.
    numberOfIntegerDigits = numStr.length;
  }

  // Count the number of leading zeros.
  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }

  if (i === (zeros = numStr.length)) {
    // The digits are all zero.
    digits = [0];
    numberOfIntegerDigits = 1;
  } else {
    // Count the number of trailing zeros
    zeros--;
    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;

    // Trailing zeros are insignificant so ignore them
    numberOfIntegerDigits -= i;
    digits = [];
    // Convert string to array of digits without leading/trailing zeros.
    for (j = 0; i <= zeros; i++, j++) {
      digits[j] = +numStr.charAt(i);
    }
  }

  // If the number overflows the maximum allowed digits then use an exponent.
  if (numberOfIntegerDigits > MAX_DIGITS) {
    digits = digits.splice(0, MAX_DIGITS - 1);
    exponent = numberOfIntegerDigits - 1;
    numberOfIntegerDigits = 1;
  }

  return { d: digits, e: exponent, i: numberOfIntegerDigits };
}

/**
 * Round the parsed number to the specified number of decimal places
 * This function changed the parsedNumber in-place
 */
function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
    var digits = parsedNumber.d;
    var fractionLen = digits.length - parsedNumber.i;

    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;

    // The index of the digit to where rounding is to occur
    var roundAt = fractionSize + parsedNumber.i;
    var digit = digits[roundAt];

    if (roundAt > 0) {
      // Drop fractional digits beyond `roundAt`
      digits.splice(Math.max(parsedNumber.i, roundAt));

      // Set non-fractional digits beyond `roundAt` to 0
      for (var j = roundAt; j < digits.length; j++) {
        digits[j] = 0;
      }
    } else {
      // We rounded to zero so reset the parsedNumber
      fractionLen = Math.max(0, fractionLen);
      parsedNumber.i = 1;
      digits.length = Math.max(1, roundAt = fractionSize + 1);
      digits[0] = 0;
      for (var i = 1; i < roundAt; i++) digits[i] = 0;
    }

    if (digit >= 5) {
      if (roundAt - 1 < 0) {
        for (var k = 0; k > roundAt; k--) {
          digits.unshift(0);
          parsedNumber.i++;
        }
        digits.unshift(1);
        parsedNumber.i++;
      } else {
        digits[roundAt - 1]++;
      }
    }

    // Pad out with zeros to get the required fraction length
    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);


    // Do any carrying, e.g. a digit was rounded up to 10
    var carry = digits.reduceRight(function(carry, d, i, digits) {
      d = d + carry;
      digits[i] = d % 10;
      return Math.floor(d / 10);
    }, 0);
    if (carry) {
      digits.unshift(carry);
      parsedNumber.i++;
    }
}

/**
 * Format a number into a string
 * @param  {number} number       The number to format
 * @param  {{
 *           minFrac, // the minimum number of digits required in the fraction part of the number
 *           maxFrac, // the maximum number of digits required in the fraction part of the number
 *           gSize,   // number of digits in each group of separated digits
 *           lgSize,  // number of digits in the last group of digits before the decimal separator
 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
 *           posPre,  // the string to go in front of a positive number
 *           negSuf,  // the string to go after a negative number (e.g. `)`)
 *           posSuf   // the string to go after a positive number
 *         }} pattern
 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
 * @param  {[type]} fractionSize The size of the fractional part of the number
 * @return {string}              The number formatted as a string
 */
function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {

  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';

  var isInfinity = !isFinite(number);
  var isZero = false;
  var numStr = Math.abs(number) + '',
      formattedText = '',
      parsedNumber;

  if (isInfinity) {
    formattedText = '\u221e';
  } else {
    parsedNumber = parse(numStr);

    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);

    var digits = parsedNumber.d;
    var integerLen = parsedNumber.i;
    var exponent = parsedNumber.e;
    var decimals = [];
    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);

    // pad zeros for small numbers
    while (integerLen < 0) {
      digits.unshift(0);
      integerLen++;
    }

    // extract decimals digits
    if (integerLen > 0) {
      decimals = digits.splice(integerLen, digits.length);
    } else {
      decimals = digits;
      digits = [0];
    }

    // format the integer digits with grouping separators
    var groups = [];
    if (digits.length >= pattern.lgSize) {
      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
    }
    while (digits.length > pattern.gSize) {
      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
    }
    if (digits.length) {
      groups.unshift(digits.join(''));
    }
    formattedText = groups.join(groupSep);

    // append the decimal digits
    if (decimals.length) {
      formattedText += decimalSep + decimals.join('');
    }

    if (exponent) {
      formattedText += 'e+' + exponent;
    }
  }
  if (number < 0 && !isZero) {
    return pattern.negPre + formattedText + pattern.negSuf;
  } else {
    return pattern.posPre + formattedText + pattern.posSuf;
  }
}

function padNumber(num, digits, trim, negWrap) {
  var neg = '';
  if (num < 0 || (negWrap && num <= 0)) {
    if (negWrap) {
      num = -num + 1;
    } else {
      num = -num;
      neg = '-';
    }
  }
  num = '' + num;
  while (num.length < digits) num = ZERO_CHAR + num;
  if (trim) {
    num = num.substr(num.length - digits);
  }
  return neg + num;
}


function dateGetter(name, size, offset, trim, negWrap) {
  offset = offset || 0;
  return function(date) {
    var value = date['get' + name]();
    if (offset > 0 || value > -offset) {
      value += offset;
    }
    if (value === 0 && offset === -12) value = 12;
    return padNumber(value, size, trim, negWrap);
  };
}

function dateStrGetter(name, shortForm, standAlone) {
  return function(date, formats) {
    var value = date['get' + name]();
    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
    var get = uppercase(propPrefix + name);

    return formats[get][value];
  };
}

function timeZoneGetter(date, formats, offset) {
  var zone = -1 * offset;
  var paddedZone = (zone >= 0) ? '+' : '';

  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
                padNumber(Math.abs(zone % 60), 2);

  return paddedZone;
}

function getFirstThursdayOfYear(year) {
    // 0 = index of January
    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
    // 4 = index of Thursday (+1 to account for 1st = 5)
    // 11 = index of *next* Thursday (+1 account for 1st = 12)
    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
}

function getThursdayThisWeek(datetime) {
    return new Date(datetime.getFullYear(), datetime.getMonth(),
      // 4 = index of Thursday
      datetime.getDate() + (4 - datetime.getDay()));
}

function weekGetter(size) {
   return function(date) {
      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
         thisThurs = getThursdayThisWeek(date);

      var diff = +thisThurs - +firstThurs,
         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week

      return padNumber(result, size);
   };
}

function ampmGetter(date, formats) {
  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
}

function eraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
}

function longEraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
}

var DATE_FORMATS = {
  yyyy: dateGetter('FullYear', 4, 0, false, true),
    yy: dateGetter('FullYear', 2, 0, true, true),
     y: dateGetter('FullYear', 1, 0, false, true),
  MMMM: dateStrGetter('Month'),
   MMM: dateStrGetter('Month', true),
    MM: dateGetter('Month', 2, 1),
     M: dateGetter('Month', 1, 1),
  LLLL: dateStrGetter('Month', false, true),
    dd: dateGetter('Date', 2),
     d: dateGetter('Date', 1),
    HH: dateGetter('Hours', 2),
     H: dateGetter('Hours', 1),
    hh: dateGetter('Hours', 2, -12),
     h: dateGetter('Hours', 1, -12),
    mm: dateGetter('Minutes', 2),
     m: dateGetter('Minutes', 1),
    ss: dateGetter('Seconds', 2),
     s: dateGetter('Seconds', 1),
     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
   sss: dateGetter('Milliseconds', 3),
  EEEE: dateStrGetter('Day'),
   EEE: dateStrGetter('Day', true),
     a: ampmGetter,
     Z: timeZoneGetter,
    ww: weekGetter(2),
     w: weekGetter(1),
     G: eraGetter,
     GG: eraGetter,
     GGG: eraGetter,
     GGGG: longEraGetter
};

var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,
    NUMBER_STRING = /^-?\d+$/;

/**
 * @ngdoc filter
 * @name date
 * @kind function
 *
 * @description
 *   Formats `date` to a string based on the requested `format`.
 *
 *   `format` string can be composed of the following elements:
 *
 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
 *   * `'MMMM'`: Month in year (January-December)
 *   * `'MMM'`: Month in year (Jan-Dec)
 *   * `'MM'`: Month in year, padded (01-12)
 *   * `'M'`: Month in year (1-12)
 *   * `'LLLL'`: Stand-alone month in year (January-December)
 *   * `'dd'`: Day in month, padded (01-31)
 *   * `'d'`: Day in month (1-31)
 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
 *   * `'EEE'`: Day in Week, (Sun-Sat)
 *   * `'HH'`: Hour in day, padded (00-23)
 *   * `'H'`: Hour in day (0-23)
 *   * `'hh'`: Hour in AM/PM, padded (01-12)
 *   * `'h'`: Hour in AM/PM, (1-12)
 *   * `'mm'`: Minute in hour, padded (00-59)
 *   * `'m'`: Minute in hour (0-59)
 *   * `'ss'`: Second in minute, padded (00-59)
 *   * `'s'`: Second in minute (0-59)
 *   * `'sss'`: Millisecond in second, padded (000-999)
 *   * `'a'`: AM/PM marker
 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
 *
 *   `format` string can also be one of the following predefined
 *   {@link guide/i18n localizable formats}:
 *
 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
 *     (e.g. Sep 3, 2010 12:05:08 PM)
 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
 *     (e.g. Friday, September 3, 2010)
 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
 *
 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
 *   (e.g. `"h 'o''clock'"`).
 *
 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
 *    specified in the string input, the time is considered to be in the local timezone.
 * @param {string=} format Formatting rules (see Description). If not specified,
 *    `mediumDate` is used.
 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *    If not specified, the timezone of the browser will be used.
 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
 *
 * @example
   <example name="filter-date">
     <file name="index.html">
       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
           <span>{{1288323623006 | date:'medium'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format date', function() {
         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
       });
     </file>
   </example>
 */
dateFilter.$inject = ['$locale'];
function dateFilter($locale) {


  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
                     // 1        2       3         4          5          6          7          8  9     10      11
  function jsonStringToDate(string) {
    var match;
    if ((match = string.match(R_ISO8601_STR))) {
      var date = new Date(0),
          tzHour = 0,
          tzMin  = 0,
          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
          timeSetter = match[8] ? date.setUTCHours : date.setHours;

      if (match[9]) {
        tzHour = toInt(match[9] + match[10]);
        tzMin = toInt(match[9] + match[11]);
      }
      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
      var h = toInt(match[4] || 0) - tzHour;
      var m = toInt(match[5] || 0) - tzMin;
      var s = toInt(match[6] || 0);
      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
      timeSetter.call(date, h, m, s, ms);
      return date;
    }
    return string;
  }


  return function(date, format, timezone) {
    var text = '',
        parts = [],
        fn, match;

    format = format || 'mediumDate';
    format = $locale.DATETIME_FORMATS[format] || format;
    if (isString(date)) {
      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
    }

    if (isNumber(date)) {
      date = new Date(date);
    }

    if (!isDate(date) || !isFinite(date.getTime())) {
      return date;
    }

    while (format) {
      match = DATE_FORMATS_SPLIT.exec(format);
      if (match) {
        parts = concat(parts, match, 1);
        format = parts.pop();
      } else {
        parts.push(format);
        format = null;
      }
    }

    var dateTimezoneOffset = date.getTimezoneOffset();
    if (timezone) {
      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
      date = convertTimezoneToLocal(date, timezone, true);
    }
    forEach(parts, function(value) {
      fn = DATE_FORMATS[value];
      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
    });

    return text;
  };
}


/**
 * @ngdoc filter
 * @name json
 * @kind function
 *
 * @description
 *   Allows you to convert a JavaScript object into JSON string.
 *
 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
 *   the binding is automatically converted to JSON.
 *
 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
 * @returns {string} JSON string.
 *
 *
 * @example
   <example name="filter-json">
     <file name="index.html">
       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
     </file>
     <file name="protractor.js" type="protractor">
       it('should jsonify filtered objects', function() {
         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
       });
     </file>
   </example>
 *
 */
function jsonFilter() {
  return function(object, spacing) {
    if (isUndefined(spacing)) {
        spacing = 2;
    }
    return toJson(object, spacing);
  };
}


/**
 * @ngdoc filter
 * @name lowercase
 * @kind function
 * @description
 * Converts string to lowercase.
 * @see angular.lowercase
 */
var lowercaseFilter = valueFn(lowercase);


/**
 * @ngdoc filter
 * @name uppercase
 * @kind function
 * @description
 * Converts string to uppercase.
 * @see angular.uppercase
 */
var uppercaseFilter = valueFn(uppercase);

/**
 * @ngdoc filter
 * @name limitTo
 * @kind function
 *
 * @description
 * Creates a new array or string containing only a specified number of elements. The elements are
 * taken from either the beginning or the end of the source array, string or number, as specified by
 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
 * it is converted to a string.
 *
 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
 *     If the number is negative, `limit` number  of items from the end of the source array/string
 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
 *     the input will be returned unchanged.
 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
 *     less than `limit` elements.
 *
 * @example
   <example module="limitToExample" name="limit-to-filter">
     <file name="index.html">
       <script>
         angular.module('limitToExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.numbers = [1,2,3,4,5,6,7,8,9];
             $scope.letters = "abcdefghi";
             $scope.longNumber = 2345432342;
             $scope.numLimit = 3;
             $scope.letterLimit = 3;
             $scope.longNumberLimit = 3;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>
            Limit {{numbers}} to:
            <input type="number" step="1" ng-model="numLimit">
         </label>
         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
         <label>
            Limit {{letters}} to:
            <input type="number" step="1" ng-model="letterLimit">
         </label>
         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
         <label>
            Limit {{longNumber}} to:
            <input type="number" step="1" ng-model="longNumberLimit">
         </label>
         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       var numLimitInput = element(by.model('numLimit'));
       var letterLimitInput = element(by.model('letterLimit'));
       var longNumberLimitInput = element(by.model('longNumberLimit'));
       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));

       it('should limit the number array to first three items', function() {
         expect(numLimitInput.getAttribute('value')).toBe('3');
         expect(letterLimitInput.getAttribute('value')).toBe('3');
         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
         expect(limitedLetters.getText()).toEqual('Output letters: abc');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
       });

       // There is a bug in safari and protractor that doesn't like the minus key
       // it('should update the output when -3 is entered', function() {
       //   numLimitInput.clear();
       //   numLimitInput.sendKeys('-3');
       //   letterLimitInput.clear();
       //   letterLimitInput.sendKeys('-3');
       //   longNumberLimitInput.clear();
       //   longNumberLimitInput.sendKeys('-3');
       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
       // });

       it('should not exceed the maximum size of input array', function() {
         numLimitInput.clear();
         numLimitInput.sendKeys('100');
         letterLimitInput.clear();
         letterLimitInput.sendKeys('100');
         longNumberLimitInput.clear();
         longNumberLimitInput.sendKeys('100');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
       });
     </file>
   </example>
*/
function limitToFilter() {
  return function(input, limit, begin) {
    if (Math.abs(Number(limit)) === Infinity) {
      limit = Number(limit);
    } else {
      limit = toInt(limit);
    }
    if (isNumberNaN(limit)) return input;

    if (isNumber(input)) input = input.toString();
    if (!isArrayLike(input)) return input;

    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;

    if (limit >= 0) {
      return sliceFn(input, begin, begin + limit);
    } else {
      if (begin === 0) {
        return sliceFn(input, limit, input.length);
      } else {
        return sliceFn(input, Math.max(0, begin + limit), begin);
      }
    }
  };
}

function sliceFn(input, begin, end) {
  if (isString(input)) return input.slice(begin, end);

  return slice.call(input, begin, end);
}

/**
 * @ngdoc filter
 * @name orderBy
 * @kind function
 *
 * @description
 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
 * function based on the values computed using the `expression` predicate.
 *
 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
 * `[{id: 'bar'}, {id: 'foo'}]`.
 *
 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
 * String, etc).
 *
 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
 * for the preceding one. The `expression` is evaluated against each item and the output is used
 * for comparing with other items.
 *
 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
 * ascending order.
 *
 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
 * strings alphabetically).
 *
 * ### Under the hood
 *
 * Ordering the specified `collection` happens in two phases:
 *
 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
 *    through a predicate that extracts the value of the `label` property, would be transformed to:
 *    ```
 *    {
 *      value: 'foo',
 *      type: 'string',
 *      index: ...
 *    }
 *    ```
 * 2. The comparator function is used to sort the items, based on the derived values, types and
 *    indices.
 *
 * If you use a custom comparator, it will be called with pairs of objects of the form
 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
 * second, or `1` otherwise.
 *
 * In order to ensure that the sorting will be deterministic across platforms, if none of the
 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
 * dummy predicate that returns the item's index as `value`.
 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
 *
 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
 * it to the comparator. The following rules govern the conversion:
 *
 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
 *    used instead.<br />
 *    (If the object has a `valueOf()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
 *    returns a primitive, its return value will be used instead.<br />
 *    (If the object has a `toString()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 3. No conversion; the object itself is used.
 *
 * ### The default comparator
 *
 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
 * using their index in the original collection, and sorts values of different types by type.
 *
 * More specifically, it follows these steps to determine the relative order of items:
 *
 * 1. If the compared values are of different types, compare the types themselves alphabetically.
 * 2. If both values are of type `string`, compare them alphabetically in a case- and
 *    locale-insensitive way.
 * 3. If both values are objects, compare their indices instead.
 * 4. Otherwise, return:
 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
 *    -  `1`, otherwise.
 *
 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
 *           saved as numbers and not strings.
 * **Note:** For the purpose of sorting, `null` values are treated as the string `'null'` (i.e.
 *           `type: 'string'`, `value: 'null'`). This may cause unexpected sort order relative to
 *           other values.
 *
 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
 *    predicates) to be used by the comparator to determine the order of elements.
 *
 *    Can be one of:
 *
 *    - `Function`: A getter function. This function will be called with each item as argument and
 *      the return value will be used for sorting.
 *    - `string`: An Angular expression. This expression will be evaluated against each item and the
 *      result will be used for sorting. For example, use `'label'` to sort by a property called
 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
 *      property.<br />
 *      (The result of a constant expression is interpreted as a property name to be used for
 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
 *      property called `special name`.)<br />
 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
 *      relative order of two items, the next predicate is used as a tie-breaker.
 *
 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
 *
 * @param {boolean=} reverse - If `true`, reverse the sorting order.
 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
 *    value pairs. If omitted, the built-in comparator will be used.
 *
 * @returns {Array} - The sorted array.
 *
 *
 * @example
 * ### Ordering a table with `ngRepeat`
 *
 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
 * it defaults to the built-in comparator.
 *
   <example name="orderBy-static" module="orderByExample1">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <table class="friends">
           <tr>
             <th>Name</th>
             <th>Phone Number</th>
             <th>Age</th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:'-age'">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample1', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var names = element.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by age in reverse order', function() {
         expect(names.get(0).getText()).toBe('Adam');
         expect(names.get(1).getText()).toBe('Julie');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('John');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Changing parameters dynamically
 *
 * All parameters can be changed dynamically. The next example shows how you can make the columns of
 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
 *
   <example name="orderBy-dynamic" module="orderByExample2">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample2', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = friends;

           $scope.sortBy = function(propertyName) {
             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using `orderBy` inside a controller
 *
 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
 *
   <example name="orderBy-call-manually" module="orderByExample3">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="sortBy(null)">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample3', [])
         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);

           $scope.sortBy = function(propertyName) {
             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
                 ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using a custom comparator
 *
 * If you have very specific requirements about the way items are sorted, you can pass your own
 * comparator function. For example, you might need to compare some strings in a locale-sensitive
 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
 * argument - passing `false` retains the default sorting order, i.e. ascending.)
 *
   <example name="orderBy-custom-comparator" module="orderByExample4">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <div class="friends-container custom-comparator">
           <h3>Locale-sensitive Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
         <div class="friends-container default-comparator">
           <h3>Default Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample4', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   favoriteLetter: 'Ä'},
             {name: 'Mary',   favoriteLetter: 'Ü'},
             {name: 'Mike',   favoriteLetter: 'Ö'},
             {name: 'Adam',   favoriteLetter: 'H'},
             {name: 'Julie',  favoriteLetter: 'Z'}
           ];

           $scope.localeSensitiveComparator = function(v1, v2) {
             // If we don't get strings, just compare by index
             if (v1.type !== 'string' || v2.type !== 'string') {
               return (v1.index < v2.index) ? -1 : 1;
             }

             // Compare strings alphabetically, taking locale into account
             return v1.value.localeCompare(v2.value);
           };
         }]);
     </file>
     <file name="style.css">
       .friends-container {
         display: inline-block;
         margin: 0 30px;
       }

       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var container = element(by.css('.custom-comparator'));
       var names = container.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
         expect(names.get(0).getText()).toBe('John');
         expect(names.get(1).getText()).toBe('Adam');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('Julie');
       });
     </file>
   </example>
 *
 */
orderByFilter.$inject = ['$parse'];
function orderByFilter($parse) {
  return function(array, sortPredicate, reverseOrder, compareFn) {

    if (array == null) return array;
    if (!isArrayLike(array)) {
      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
    }

    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
    if (sortPredicate.length === 0) { sortPredicate = ['+']; }

    var predicates = processPredicates(sortPredicate);

    var descending = reverseOrder ? -1 : 1;

    // Define the `compare()` function. Use a default comparator if none is specified.
    var compare = isFunction(compareFn) ? compareFn : defaultCompare;

    // The next three lines are a version of a Swartzian Transform idiom from Perl
    // (sometimes called the Decorate-Sort-Undecorate idiom)
    // See https://en.wikipedia.org/wiki/Schwartzian_transform
    var compareValues = Array.prototype.map.call(array, getComparisonObject);
    compareValues.sort(doComparison);
    array = compareValues.map(function(item) { return item.value; });

    return array;

    function getComparisonObject(value, index) {
      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
      // This will be used to keep the sort stable when none of the input predicates can
      // distinguish between two elements.
      return {
        value: value,
        tieBreaker: {value: index, type: 'number', index: index},
        predicateValues: predicates.map(function(predicate) {
          return getPredicateValue(predicate.get(value), index);
        })
      };
    }

    function doComparison(v1, v2) {
      for (var i = 0, ii = predicates.length; i < ii; i++) {
        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
        if (result) {
          return result * predicates[i].descending * descending;
        }
      }

      return compare(v1.tieBreaker, v2.tieBreaker) * descending;
    }
  };

  function processPredicates(sortPredicates) {
    return sortPredicates.map(function(predicate) {
      var descending = 1, get = identity;

      if (isFunction(predicate)) {
        get = predicate;
      } else if (isString(predicate)) {
        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
          descending = predicate.charAt(0) === '-' ? -1 : 1;
          predicate = predicate.substring(1);
        }
        if (predicate !== '') {
          get = $parse(predicate);
          if (get.constant) {
            var key = get();
            get = function(value) { return value[key]; };
          }
        }
      }
      return {get: get, descending: descending};
    });
  }

  function isPrimitive(value) {
    switch (typeof value) {
      case 'number': /* falls through */
      case 'boolean': /* falls through */
      case 'string':
        return true;
      default:
        return false;
    }
  }

  function objectValue(value) {
    // If `valueOf` is a valid function use that
    if (isFunction(value.valueOf)) {
      value = value.valueOf();
      if (isPrimitive(value)) return value;
    }
    // If `toString` is a valid function and not the one from `Object.prototype` use that
    if (hasCustomToString(value)) {
      value = value.toString();
      if (isPrimitive(value)) return value;
    }

    return value;
  }

  function getPredicateValue(value, index) {
    var type = typeof value;
    if (value === null) {
      type = 'string';
      value = 'null';
    } else if (type === 'object') {
      value = objectValue(value);
    }
    return {value: value, type: type, index: index};
  }

  function defaultCompare(v1, v2) {
    var result = 0;
    var type1 = v1.type;
    var type2 = v2.type;

    if (type1 === type2) {
      var value1 = v1.value;
      var value2 = v2.value;

      if (type1 === 'string') {
        // Compare strings case-insensitively
        value1 = value1.toLowerCase();
        value2 = value2.toLowerCase();
      } else if (type1 === 'object') {
        // For basic objects, use the position of the object
        // in the collection instead of the value
        if (isObject(value1)) value1 = v1.index;
        if (isObject(value2)) value2 = v2.index;
      }

      if (value1 !== value2) {
        result = value1 < value2 ? -1 : 1;
      }
    } else {
      result = type1 < type2 ? -1 : 1;
    }

    return result;
  }
}

function ngDirective(directive) {
  if (isFunction(directive)) {
    directive = {
      link: directive
    };
  }
  directive.restrict = directive.restrict || 'AC';
  return valueFn(directive);
}

/**
 * @ngdoc directive
 * @name a
 * @restrict E
 *
 * @description
 * Modifies the default behavior of the html a tag so that the default action is prevented when
 * the href attribute is empty.
 *
 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
 */
var htmlAnchorDirective = valueFn({
  restrict: 'E',
  compile: function(element, attr) {
    if (!attr.href && !attr.xlinkHref) {
      return function(scope, element) {
        // If the linked element is not an anchor tag anymore, do nothing
        if (element[0].nodeName.toLowerCase() !== 'a') return;

        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
                   'xlink:href' : 'href';
        element.on('click', function(event) {
          // if we have no href url, then don't navigate anywhere.
          if (!element.attr(href)) {
            event.preventDefault();
          }
        });
      };
    }
  }
});

/**
 * @ngdoc directive
 * @name ngHref
 * @restrict A
 * @priority 99
 *
 * @description
 * Using Angular markup like `{{hash}}` in an href attribute will
 * make the link go to the wrong URL if the user clicks it before
 * Angular has a chance to replace the `{{hash}}` markup with its
 * value. Until Angular replaces the markup the link will be broken
 * and will most likely return a 404 error. The `ngHref` directive
 * solves this problem.
 *
 * The wrong way to write it:
 * ```html
 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * @element A
 * @param {template} ngHref any string which can contain `{{}}` markup.
 *
 * @example
 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
 * in links and their different behaviors:
    <example name="ng-href">
      <file name="index.html">
        <input ng-model="value" /><br />
        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
      </file>
      <file name="protractor.js" type="protractor">
        it('should execute ng-click but not reload when href without value', function() {
          element(by.id('link-1')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when href empty string', function() {
          element(by.id('link-2')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click and change url when ng-href specified', function() {
          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);

          element(by.id('link-3')).click();

          // At this point, we navigate away from an Angular page, so we need
          // to use browser.driver to get the base webdriver.

          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/123$/);
            });
          }, 5000, 'page should navigate to /123');
        });

        it('should execute ng-click but not reload when href empty string and name specified', function() {
          element(by.id('link-4')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when no href but name specified', function() {
          element(by.id('link-5')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
        });

        it('should only change url when only ng-href', function() {
          element(by.model('value')).clear();
          element(by.model('value')).sendKeys('6');
          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);

          element(by.id('link-6')).click();

          // At this point, we navigate away from an Angular page, so we need
          // to use browser.driver to get the base webdriver.
          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/6$/);
            });
          }, 5000, 'page should navigate to /6');
        });
      </file>
    </example>
 */

/**
 * @ngdoc directive
 * @name ngSrc
 * @restrict A
 * @priority 99
 *
 * @description
 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until Angular replaces the expression inside
 * `{{hash}}`. The `ngSrc` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrc any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngSrcset
 * @restrict A
 * @priority 99
 *
 * @description
 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until Angular replaces the expression inside
 * `{{hash}}`. The `ngSrcset` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrcset any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngDisabled
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * This directive sets the `disabled` attribute on the element if the
 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `disabled`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-disabled">
      <file name="index.html">
        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
        <button ng-model="button" ng-disabled="checked">Button</button>
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle button', function() {
          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
 *     then the `disabled` attribute will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngChecked
 * @restrict A
 * @priority 100
 *
 * @description
 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
 *
 * Note that this directive should not be used together with {@link ngModel `ngModel`},
 * as this can lead to unexpected behavior.
 *
 * A special directive is necessary because we cannot use interpolation inside the `checked`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-checked">
      <file name="index.html">
        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
      </file>
      <file name="protractor.js" type="protractor">
        it('should check both checkBoxes', function() {
          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
          element(by.model('master')).click();
          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
 *     then the `checked` attribute will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngReadonly
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
 *
 * A special directive is necessary because we cannot use interpolation inside the `readonly`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-readonly">
      <file name="index.html">
        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle readonly attr', function() {
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
 *     then special attribute "readonly" will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngSelected
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `selected`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * <div class="alert alert-warning">
 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
 *   selected options.
 * </div>
 *
 * @example
    <example name="ng-selected">
      <file name="index.html">
        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
        <select aria-label="ngSelected demo">
          <option>Hello!</option>
          <option id="greet" ng-selected="selected">Greetings!</option>
        </select>
      </file>
      <file name="protractor.js" type="protractor">
        it('should select Greetings!', function() {
          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
          element(by.model('selected')).click();
          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element OPTION
 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
 *     then special attribute "selected" will be set on the element
 */

/**
 * @ngdoc directive
 * @name ngOpen
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `open`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * ## A note about browser compatibility
 *
 * Edge, Firefox, and Internet Explorer do not support the `details` element, it is
 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
 *
 * @example
     <example name="ng-open">
       <file name="index.html">
         <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
         <details id="details" ng-open="open">
            <summary>Show/Hide me</summary>
         </details>
       </file>
       <file name="protractor.js" type="protractor">
         it('should toggle open', function() {
           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
           element(by.model('open')).click();
           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
         });
       </file>
     </example>
 *
 * @element DETAILS
 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
 *     then special attribute "open" will be set on the element
 */

var ngAttributeAliasDirectives = {};

// boolean attrs are evaluated
forEach(BOOLEAN_ATTR, function(propName, attrName) {
  // binding to multiple is not supported
  if (propName === 'multiple') return;

  function defaultLinkFn(scope, element, attr) {
    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
      attr.$set(attrName, !!value);
    });
  }

  var normalized = directiveNormalize('ng-' + attrName);
  var linkFn = defaultLinkFn;

  if (propName === 'checked') {
    linkFn = function(scope, element, attr) {
      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
      if (attr.ngModel !== attr[normalized]) {
        defaultLinkFn(scope, element, attr);
      }
    };
  }

  ngAttributeAliasDirectives[normalized] = function() {
    return {
      restrict: 'A',
      priority: 100,
      link: linkFn
    };
  };
});

// aliased input attrs are evaluated
forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
  ngAttributeAliasDirectives[ngAttr] = function() {
    return {
      priority: 100,
      link: function(scope, element, attr) {
        //special case ngPattern when a literal regular expression value
        //is used as the expression (this way we don't have to watch anything).
        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
          if (match) {
            attr.$set('ngPattern', new RegExp(match[1], match[2]));
            return;
          }
        }

        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
          attr.$set(ngAttr, value);
        });
      }
    };
  };
});

// ng-src, ng-srcset, ng-href are interpolated
forEach(['src', 'srcset', 'href'], function(attrName) {
  var normalized = directiveNormalize('ng-' + attrName);
  ngAttributeAliasDirectives[normalized] = function() {
    return {
      priority: 99, // it needs to run after the attributes are interpolated
      link: function(scope, element, attr) {
        var propName = attrName,
            name = attrName;

        if (attrName === 'href' &&
            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
          name = 'xlinkHref';
          attr.$attr[name] = 'xlink:href';
          propName = null;
        }

        attr.$observe(normalized, function(value) {
          if (!value) {
            if (attrName === 'href') {
              attr.$set(name, null);
            }
            return;
          }

          attr.$set(name, value);

          // Support: IE 9-11 only
          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
          // to set the property as well to achieve the desired effect.
          // We use attr[attrName] value since $set can sanitize the url.
          if (msie && propName) element.prop(propName, attr[name]);
        });
      }
    };
  };
});

/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
 */
var nullFormCtrl = {
  $addControl: noop,
  $$renameControl: nullFormRenameControl,
  $removeControl: noop,
  $setValidity: noop,
  $setDirty: noop,
  $setPristine: noop,
  $setSubmitted: noop
},
PENDING_CLASS = 'ng-pending',
SUBMITTED_CLASS = 'ng-submitted';

function nullFormRenameControl(control, name) {
  control.$name = name;
}

/**
 * @ngdoc type
 * @name form.FormController
 *
 * @property {boolean} $pristine True if user has not interacted with the form yet.
 * @property {boolean} $dirty True if user has already interacted with the form.
 * @property {boolean} $valid True if all of the containing forms and controls are valid.
 * @property {boolean} $invalid True if at least one containing control or form is invalid.
 * @property {boolean} $pending True if at least one containing control or form is pending.
 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
 *
 * @property {Object} $error Is an object hash, containing references to controls or
 *  forms with failing validators, where:
 *
 *  - keys are validation tokens (error names),
 *  - values are arrays of controls or forms that have a failing validator for given error name.
 *
 *  Built-in validation tokens:
 *
 *  - `email`
 *  - `max`
 *  - `maxlength`
 *  - `min`
 *  - `minlength`
 *  - `number`
 *  - `pattern`
 *  - `required`
 *  - `url`
 *  - `date`
 *  - `datetimelocal`
 *  - `time`
 *  - `week`
 *  - `month`
 *
 * @description
 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
 * such as being valid/invalid or dirty/pristine.
 *
 * Each {@link ng.directive:form form} directive creates an instance
 * of `FormController`.
 *
 */
//asks for $scope to fool the BC controller module
FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
function FormController($element, $attrs, $scope, $animate, $interpolate) {
  this.$$controls = [];

  // init state
  this.$error = {};
  this.$$success = {};
  this.$pending = undefined;
  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
  this.$dirty = false;
  this.$pristine = true;
  this.$valid = true;
  this.$invalid = false;
  this.$submitted = false;
  this.$$parentForm = nullFormCtrl;

  this.$$element = $element;
  this.$$animate = $animate;

  setupValidity(this);
}

FormController.prototype = {
  /**
   * @ngdoc method
   * @name form.FormController#$rollbackViewValue
   *
   * @description
   * Rollback all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is typically needed by the reset button of
   * a form that uses `ng-model-options` to pend updates.
   */
  $rollbackViewValue: function() {
    forEach(this.$$controls, function(control) {
      control.$rollbackViewValue();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$commitViewValue
   *
   * @description
   * Commit all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  $commitViewValue: function() {
    forEach(this.$$controls, function(control) {
      control.$commitViewValue();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$addControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Register a control with the form. Input elements using ngModelController do this automatically
   * when they are linked.
   *
   * Note that the current state of the control will not be reflected on the new parent form. This
   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
   * state.
   *
   * However, if the method is used programmatically, for example by adding dynamically created controls,
   * or controls that have been previously removed without destroying their corresponding DOM element,
   * it's the developers responsibility to make sure the current state propagates to the parent form.
   *
   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
   */
  $addControl: function(control) {
    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
    // and not added to the scope.  Now we throw an error.
    assertNotHasOwnProperty(control.$name, 'input');
    this.$$controls.push(control);

    if (control.$name) {
      this[control.$name] = control;
    }

    control.$$parentForm = this;
  },

  // Private API: rename a form control
  $$renameControl: function(control, newName) {
    var oldName = control.$name;

    if (this[oldName] === control) {
      delete this[oldName];
    }
    this[newName] = control;
    control.$name = newName;
  },

  /**
   * @ngdoc method
   * @name form.FormController#$removeControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Deregister a control from the form.
   *
   * Input elements using ngModelController do this automatically when they are destroyed.
   *
   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
   * different from case to case. For example, removing the only `$dirty` control from a form may or
   * may not mean that the form is still `$dirty`.
   */
  $removeControl: function(control) {
    if (control.$name && this[control.$name] === control) {
      delete this[control.$name];
    }
    forEach(this.$pending, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);
    forEach(this.$error, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);
    forEach(this.$$success, function(value, name) {
      // eslint-disable-next-line no-invalid-this
      this.$setValidity(name, null, control);
    }, this);

    arrayRemove(this.$$controls, control);
    control.$$parentForm = nullFormCtrl;
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setDirty
   *
   * @description
   * Sets the form to a dirty state.
   *
   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
   * state (ng-dirty class). This method will also propagate to parent forms.
   */
  $setDirty: function() {
    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
    this.$dirty = true;
    this.$pristine = false;
    this.$$parentForm.$setDirty();
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setPristine
   *
   * @description
   * Sets the form to its pristine state.
   *
   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
   * state to false.
   *
   * This method will also propagate to all the controls contained in this form.
   *
   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
   * saving or resetting it.
   */
  $setPristine: function() {
    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
    this.$dirty = false;
    this.$pristine = true;
    this.$submitted = false;
    forEach(this.$$controls, function(control) {
      control.$setPristine();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setUntouched
   *
   * @description
   * Sets the form to its untouched state.
   *
   * This method can be called to remove the 'ng-touched' class and set the form controls to their
   * untouched state (ng-untouched class).
   *
   * Setting a form controls back to their untouched state is often useful when setting the form
   * back to its pristine state.
   */
  $setUntouched: function() {
    forEach(this.$$controls, function(control) {
      control.$setUntouched();
    });
  },

  /**
   * @ngdoc method
   * @name form.FormController#$setSubmitted
   *
   * @description
   * Sets the form to its submitted state.
   */
  $setSubmitted: function() {
    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
    this.$submitted = true;
    this.$$parentForm.$setSubmitted();
  }
};

/**
 * @ngdoc method
 * @name form.FormController#$setValidity
 *
 * @description
 * Sets the validity of a form control.
 *
 * This method will also propagate to parent forms.
 */
addSetValidityMethod({
  clazz: FormController,
  set: function(object, property, controller) {
    var list = object[property];
    if (!list) {
      object[property] = [controller];
    } else {
      var index = list.indexOf(controller);
      if (index === -1) {
        list.push(controller);
      }
    }
  },
  unset: function(object, property, controller) {
    var list = object[property];
    if (!list) {
      return;
    }
    arrayRemove(list, controller);
    if (list.length === 0) {
      delete object[property];
    }
  }
});

/**
 * @ngdoc directive
 * @name ngForm
 * @restrict EAC
 *
 * @description
 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
 * sub-group of controls needs to be determined.
 *
 * Note: the purpose of `ngForm` is to group controls,
 * but not to be a replacement for the `<form>` tag with all of its capabilities
 * (e.g. posting to the server, ...).
 *
 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 *
 */

 /**
 * @ngdoc directive
 * @name form
 * @restrict E
 *
 * @description
 * Directive that instantiates
 * {@link form.FormController FormController}.
 *
 * If the `name` attribute is specified, the form controller is published onto the current scope under
 * this name.
 *
 * # Alias: {@link ng.directive:ngForm `ngForm`}
 *
 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
 * of controls needs to be determined.
 *
 * # CSS classes
 *  - `ng-valid` is set if the form is valid.
 *  - `ng-invalid` is set if the form is invalid.
 *  - `ng-pending` is set if the form is pending.
 *  - `ng-pristine` is set if the form is pristine.
 *  - `ng-dirty` is set if the form is dirty.
 *  - `ng-submitted` is set if the form was submitted.
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 *
 * # Submitting a form and preventing the default action
 *
 * Since the role of forms in client-side Angular applications is different than in classical
 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
 * page reload that sends the data to the server. Instead some javascript logic should be triggered
 * to handle the form submission in an application-specific way.
 *
 * For this reason, Angular prevents the default action (form submission to the server) unless the
 * `<form>` element has an `action` attribute specified.
 *
 * You can use one of the following two ways to specify what javascript method should be called when
 * a form is submitted:
 *
 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
 * - {@link ng.directive:ngClick ngClick} directive on the first
  *  button or input field of type submit (input[type=submit])
 *
 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
 * or {@link ng.directive:ngClick ngClick} directives.
 * This is because of the following form submission rules in the HTML specification:
 *
 * - If a form has only one input field then hitting enter in this field triggers form submit
 * (`ngSubmit`)
 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
 * doesn't trigger submit
 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
 *
 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * ## Animation Hooks
 *
 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
 * other validations that are performed within the form. Animations in ngForm are similar to how
 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
 * as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style a form element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-form {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-form.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
      <file name="index.html">
       <script>
         angular.module('formExample', [])
           .controller('FormController', ['$scope', function($scope) {
             $scope.userType = 'guest';
           }]);
       </script>
       <style>
        .my-form {
          transition:all linear 0.5s;
          background: transparent;
        }
        .my-form.ng-invalid {
          background: red;
        }
       </style>
       <form name="myForm" ng-controller="FormController" class="my-form">
         userType: <input name="input" ng-model="userType" required>
         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
         <code>userType = {{userType}}</code><br>
         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
         <code>myForm.$valid = {{myForm.$valid}}</code><br>
         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        it('should initialize to model', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));

          expect(userType.getText()).toContain('guest');
          expect(valid.getText()).toContain('true');
        });

        it('should be invalid if empty', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));
          var userInput = element(by.model('userType'));

          userInput.clear();
          userInput.sendKeys('');

          expect(userType.getText()).toEqual('userType =');
          expect(valid.getText()).toContain('false');
        });
      </file>
    </example>
 *
 * @param {string=} name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 */
var formDirectiveFactory = function(isNgForm) {
  return ['$timeout', '$parse', function($timeout, $parse) {
    var formDirective = {
      name: 'form',
      restrict: isNgForm ? 'EAC' : 'E',
      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
      controller: FormController,
      compile: function ngFormCompile(formElement, attr) {
        // Setup initial state of the control
        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);

        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);

        return {
          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
            var controller = ctrls[0];

            // if `action` attr is not present on the form, prevent the default action (submission)
            if (!('action' in attr)) {
              // we can't use jq events because if a form is destroyed during submission the default
              // action is not prevented. see #1238
              //
              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
              // page reload if the form was destroyed by submission of the form via a click handler
              // on a button in the form. Looks like an IE9 specific bug.
              var handleFormSubmission = function(event) {
                scope.$apply(function() {
                  controller.$commitViewValue();
                  controller.$setSubmitted();
                });

                event.preventDefault();
              };

              formElement[0].addEventListener('submit', handleFormSubmission);

              // unregister the preventDefault listener so that we don't not leak memory but in a
              // way that will achieve the prevention of the default action.
              formElement.on('$destroy', function() {
                $timeout(function() {
                  formElement[0].removeEventListener('submit', handleFormSubmission);
                }, 0, false);
              });
            }

            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
            parentFormCtrl.$addControl(controller);

            var setter = nameAttr ? getSetter(controller.$name) : noop;

            if (nameAttr) {
              setter(scope, controller);
              attr.$observe(nameAttr, function(newValue) {
                if (controller.$name === newValue) return;
                setter(scope, undefined);
                controller.$$parentForm.$$renameControl(controller, newValue);
                setter = getSetter(controller.$name);
                setter(scope, controller);
              });
            }
            formElement.on('$destroy', function() {
              controller.$$parentForm.$removeControl(controller);
              setter(scope, undefined);
              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
            });
          }
        };
      }
    };

    return formDirective;

    function getSetter(expression) {
      if (expression === '') {
        //create an assignable expression, so forms with an empty name can be renamed later
        return $parse('this[""]').assign;
      }
      return $parse(expression).assign || noop;
    }
  }];
};

var formDirective = formDirectiveFactory();
var ngFormDirective = formDirectiveFactory(true);



// helper methods
function setupValidity(instance) {
  instance.$$classCache = {};
  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
}
function addSetValidityMethod(context) {
  var clazz = context.clazz,
      set = context.set,
      unset = context.unset;

  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
    if (isUndefined(state)) {
      createAndSet(this, '$pending', validationErrorKey, controller);
    } else {
      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
    }
    if (!isBoolean(state)) {
      unset(this.$error, validationErrorKey, controller);
      unset(this.$$success, validationErrorKey, controller);
    } else {
      if (state) {
        unset(this.$error, validationErrorKey, controller);
        set(this.$$success, validationErrorKey, controller);
      } else {
        set(this.$error, validationErrorKey, controller);
        unset(this.$$success, validationErrorKey, controller);
      }
    }
    if (this.$pending) {
      cachedToggleClass(this, PENDING_CLASS, true);
      this.$valid = this.$invalid = undefined;
      toggleValidationCss(this, '', null);
    } else {
      cachedToggleClass(this, PENDING_CLASS, false);
      this.$valid = isObjectEmpty(this.$error);
      this.$invalid = !this.$valid;
      toggleValidationCss(this, '', this.$valid);
    }

    // re-read the state as the set/unset methods could have
    // combined state in this.$error[validationError] (used for forms),
    // where setting/unsetting only increments/decrements the value,
    // and does not replace it.
    var combinedState;
    if (this.$pending && this.$pending[validationErrorKey]) {
      combinedState = undefined;
    } else if (this.$error[validationErrorKey]) {
      combinedState = false;
    } else if (this.$$success[validationErrorKey]) {
      combinedState = true;
    } else {
      combinedState = null;
    }

    toggleValidationCss(this, validationErrorKey, combinedState);
    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
  };

  function createAndSet(ctrl, name, value, controller) {
    if (!ctrl[name]) {
      ctrl[name] = {};
    }
    set(ctrl[name], value, controller);
  }

  function unsetAndCleanup(ctrl, name, value, controller) {
    if (ctrl[name]) {
      unset(ctrl[name], value, controller);
    }
    if (isObjectEmpty(ctrl[name])) {
      ctrl[name] = undefined;
    }
  }

  function cachedToggleClass(ctrl, className, switchValue) {
    if (switchValue && !ctrl.$$classCache[className]) {
      ctrl.$$animate.addClass(ctrl.$$element, className);
      ctrl.$$classCache[className] = true;
    } else if (!switchValue && ctrl.$$classCache[className]) {
      ctrl.$$animate.removeClass(ctrl.$$element, className);
      ctrl.$$classCache[className] = false;
    }
  }

  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';

    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
  }
}

function isObjectEmpty(obj) {
  if (obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
  }
  return true;
}

/* global
  VALID_CLASS: false,
  INVALID_CLASS: false,
  PRISTINE_CLASS: false,
  DIRTY_CLASS: false,
  ngModelMinErr: false
*/

// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
// Note: We are being more lenient, because browsers are too.
//   1. Scheme
//   2. Slashes
//   3. Username
//   4. Password
//   5. Hostname
//   6. Port
//   7. Path
//   8. Query
//   9. Fragment
//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
// eslint-disable-next-line max-len
var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;

var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
var PARTIAL_VALIDATION_TYPES = createMap();
forEach('date,datetime-local,month,time,week'.split(','), function(type) {
  PARTIAL_VALIDATION_TYPES[type] = true;
});

var inputType = {

  /**
   * @ngdoc input
   * @name input[text]
   *
   * @description
   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
   *
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Adds `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
   *    This parameter is ignored for input[type=password] controls, which will never trim the
   *    input.
   *
   * @example
      <example name="text-input-directive" module="textInputExample">
        <file name="index.html">
         <script>
           angular.module('textInputExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 text: 'guest',
                 word: /^\s*\w*\s*$/
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Single word:
             <input type="text" name="input" ng-model="example.text"
                    ng-pattern="example.word" required ng-trim="false">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.pattern">
               Single word only!</span>
           </div>
           <code>text = {{example.text}}</code><br/>
           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('example.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('guest');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if multi word', function() {
            input.clear();
            input.sendKeys('hello world');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'text': textInputType,

    /**
     * @ngdoc input
     * @name input[date]
     *
     * @description
     * Input with date validation and transformation. In browsers that do not yet support
     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
     * modern browsers do not yet support this input type, it is important to provide cues to users on the
     * expected input format via a placeholder or label.
     *
     * The model must always be a Date object, otherwise Angular will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable angular expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
     *   constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
     *   constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange Angular expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="date-input-directive" module="dateInputExample">
     <file name="index.html">
       <script>
          angular.module('dateInputExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.example = {
                value: new Date(2013, 9, 22)
              };
            }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
          <label for="exampleInput">Pick a date in 2013:</label>
          <input type="date" id="exampleInput" name="input" ng-model="example.value"
              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
          <div role="alert">
            <span class="error" ng-show="myForm.input.$error.required">
                Required!</span>
            <span class="error" ng-show="myForm.input.$error.date">
                Not a valid date!</span>
           </div>
           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
        var valid = element(by.binding('myForm.input.$valid'));

        // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (see https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }

        it('should initialize to model', function() {
          expect(value.getText()).toContain('2013-10-22');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });

        it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });

        it('should be invalid if over max', function() {
          setInput('2015-01-01');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */
  'date': createDateInputType('date', DATE_REGEXP,
         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
         'yyyy-MM-dd'),

   /**
    * @ngdoc input
    * @name input[datetime-local]
    *
    * @description
    * Input with datetime validation and transformation. In browsers that do not yet support
    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
    *
    * The model must always be a Date object, otherwise Angular will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable angular expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `min` will also add native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `max` will also add native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange Angular expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="datetimelocal-input-directive" module="dateExample">
    <file name="index.html">
      <script>
        angular.module('dateExample', [])
          .controller('DateController', ['$scope', function($scope) {
            $scope.example = {
              value: new Date(2010, 11, 28, 14, 57)
            };
          }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a date between in 2013:</label>
        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.datetimelocal">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2010-12-28T14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01-01T23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
      'yyyy-MM-ddTHH:mm:ss.sss'),

  /**
   * @ngdoc input
   * @name input[time]
   *
   * @description
   * Input with time validation and transformation. In browsers that do not yet support
   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
   *
   * The model must always be a Date object, otherwise Angular will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="time-input-directive" module="timeExample">
   <file name="index.html">
     <script>
      angular.module('timeExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(1970, 0, 1, 14, 57, 0)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
        <input type="time" id="exampleInput" name="input" ng-model="example.value"
            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.time">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'time': createDateInputType('time', TIME_REGEXP,
      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
     'HH:mm:ss.sss'),

   /**
    * @ngdoc input
    * @name input[week]
    *
    * @description
    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * week format (yyyy-W##), for example: `2013-W02`.
    *
    * The model must always be a Date object, otherwise Angular will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable angular expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
    *   native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
    *   native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange Angular expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="week-input-directive" module="weekExample">
    <file name="index.html">
      <script>
      angular.module('weekExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 0, 3)
          };
        }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label>Pick a date between in 2013:
          <input id="exampleInput" type="week" name="input" ng-model="example.value"
                 placeholder="YYYY-W##" min="2012-W32"
                 max="2013-W52" required />
        </label>
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.week">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-Www"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-W01');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-W01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),

  /**
   * @ngdoc input
   * @name input[month]
   *
   * @description
   * Input with month validation and transformation. In browsers that do not yet support
   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * month format (yyyy-MM), for example: `2009-01`.
   *
   * The model must always be a Date object, otherwise Angular will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   * If the model is not set to the first of the month, the next view to model update will set it
   * to the first of the month.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.

   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="month-input-directive" module="monthExample">
   <file name="index.html">
     <script>
      angular.module('monthExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 9, 1)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
       <label for="exampleInput">Pick a month in 2013:</label>
       <input id="exampleInput" type="month" name="input" ng-model="example.value"
          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
       <div role="alert">
         <span class="error" ng-show="myForm.input.$error.required">
            Required!</span>
         <span class="error" ng-show="myForm.input.$error.month">
            Not a valid month!</span>
       </div>
       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-10');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'month': createDateInputType('month', MONTH_REGEXP,
     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
     'yyyy-MM'),

  /**
   * @ngdoc input
   * @name input[number]
   *
   * @description
   * Text input with number validation and transformation. Sets the `number` validation
   * error if not a valid number.
   *
   * <div class="alert alert-warning">
   * The model must always be of type `number` otherwise Angular will throw an error.
   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
   * error docs for more information and an example of how to convert your model if necessary.
   * </div>
   *
   * ## Issues with HTML5 constraint validation
   *
   * In browsers that follow the
   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
   * If a non-number is entered in the input, the browser will report the value as an empty string,
   * which means the view / model values in `ngModel` and subsequently the scope value
   * will also be an empty string.
   *
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *    Can be interpolated.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *    Can be interpolated.
   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
   *    Can be interpolated.
   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
   *    but does not trigger HTML5 native validation. Takes an expression.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="number-input-directive" module="numberExample">
        <file name="index.html">
         <script>
           angular.module('numberExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 value: 12
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Number:
             <input type="number" name="input" ng-model="example.value"
                    min="0" max="99" required>
          </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.number">
               Not valid number!</span>
           </div>
           <tt>value = {{example.value}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var value = element(by.binding('example.value'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.value'));

          it('should initialize to model', function() {
            expect(value.getText()).toContain('12');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if over max', function() {
            input.clear();
            input.sendKeys('123');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'number': numberInputType,


  /**
   * @ngdoc input
   * @name input[url]
   *
   * @description
   * Text input with URL validation. Sets the `url` validation error key if the content is not a
   * valid URL.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
   * the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="url-input-directive" module="urlExample">
        <file name="index.html">
         <script>
           angular.module('urlExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.url = {
                 text: 'http://google.com'
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>URL:
             <input type="url" name="input" ng-model="url.text" required>
           <label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.url">
               Not valid url!</span>
           </div>
           <tt>text = {{url.text}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('url.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('url.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('http://google.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not url', function() {
            input.clear();
            input.sendKeys('box');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'url': urlInputType,


  /**
   * @ngdoc input
   * @name input[email]
   *
   * @description
   * Text input with email validation. Sets the `email` validation error key if not a valid email
   * address.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="email-input-directive" module="emailExample">
        <file name="index.html">
         <script>
           angular.module('emailExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.email = {
                 text: 'me@example.com'
               };
             }]);
         </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Email:
               <input type="email" name="input" ng-model="email.text" required>
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.email">
                 Not valid email!</span>
             </div>
             <tt>text = {{email.text}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
           </form>
         </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('email.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('email.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('me@example.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not email', function() {
            input.clear();
            input.sendKeys('xxx');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'email': emailInputType,


  /**
   * @ngdoc input
   * @name input[radio]
   *
   * @description
   * HTML radio button.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string} value The value to which the `ngModel` expression should be set when selected.
   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
   *    is selected. Should be used instead of the `value` attribute if you need
   *    a non-string `ngModel` (`boolean`, `array`, ...).
   *
   * @example
      <example name="radio-input-directive" module="radioExample">
        <file name="index.html">
         <script>
           angular.module('radioExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.color = {
                 name: 'blue'
               };
               $scope.specialValue = {
                 "id": "12345",
                 "value": "green"
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>
             <input type="radio" ng-model="color.name" value="red">
             Red
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" ng-value="specialValue">
             Green
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" value="blue">
             Blue
           </label><br/>
           <tt>color = {{color.name | json}}</tt><br/>
          </form>
          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var inputs = element.all(by.model('color.name'));
            var color = element(by.binding('color.name'));

            expect(color.getText()).toContain('blue');

            inputs.get(0).click();
            expect(color.getText()).toContain('red');

            inputs.get(1).click();
            expect(color.getText()).toContain('green');
          });
        </file>
      </example>
   */
  'radio': radioInputType,

  /**
   * @ngdoc input
   * @name input[range]
   *
   * @description
   * Native range input with validation and transformation.
   *
   * The model for the range input must always be a `Number`.
   *
   * IE9 and other browsers that do not support the `range` type fall back
   * to a text input without any default values for `min`, `max` and `step`. Model binding,
   * validation and number parsing are nevertheless supported.
   *
   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
   * in a way that never allows the input to hold an invalid value. That means:
   * - any non-numerical value is set to `(max + min) / 2`.
   * - any numerical value that is less than the current min val, or greater than the current max val
   * is set to the min / max val respectively.
   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
   * is used.
   *
   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
   * for more info.
   *
   * This has the following consequences for Angular:
   *
   * Since the element value should always reflect the current model value, a range input
   * will set the bound ngModel expression to the value that the browser has set for the
   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
   * Angular will then set the model to `50`, to prevent input and model value being out of sync.
   *
   * That means the model for range will immediately be set to `50` after `ngModel` has been
   * initialized. It also means a range input can never have the required error.
   *
   * This does not only affect changes to the model value, but also to the values of the `min`,
   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
   * the input value, Angular will also update the model value.
   *
   * Automatic value adjustment also means that a range input element can never have the `required`,
   * `min`, or `max` errors.
   *
   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
   * when the step value changes dynamically - they do not adjust the element value correctly, but
   * instead may set the `stepMismatch` error. If that's the case, the Angular will set the `step`
   * error on the input, and set the model to `undefined`.
   *
   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
   *
   * @param {string}  ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
   *                  than `min`. Can be interpolated.
   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
   *                  Can be interpolated.
   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
   *                  Can be interpolated.
   * @param {string=} ngChange Angular expression to be executed when the ngModel value changes due
   *                  to user interaction with the input element.
   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
   *
   * @example
      <example name="range-input-directive" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">

            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   * ## Range Input with ngMin & ngMax attributes

   * @example
      <example name="range-input-directive-ng" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">
            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   */
  'range': rangeInputType,

  /**
   * @ngdoc input
   * @name input[checkbox]
   *
   * @description
   * HTML checkbox.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="checkbox-input-directive" module="checkboxExample">
        <file name="index.html">
         <script>
           angular.module('checkboxExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.checkboxModel = {
                value1 : true,
                value2 : 'YES'
              };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Value1:
             <input type="checkbox" ng-model="checkboxModel.value1">
           </label><br/>
           <label>Value2:
             <input type="checkbox" ng-model="checkboxModel.value2"
                    ng-true-value="'YES'" ng-false-value="'NO'">
            </label><br/>
           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var value1 = element(by.binding('checkboxModel.value1'));
            var value2 = element(by.binding('checkboxModel.value2'));

            expect(value1.getText()).toContain('true');
            expect(value2.getText()).toContain('YES');

            element(by.model('checkboxModel.value1')).click();
            element(by.model('checkboxModel.value2')).click();

            expect(value1.getText()).toContain('false');
            expect(value2.getText()).toContain('NO');
          });
        </file>
      </example>
   */
  'checkbox': checkboxInputType,

  'hidden': noop,
  'button': noop,
  'submit': noop,
  'reset': noop,
  'file': noop
};

function stringBasedInputType(ctrl) {
  ctrl.$formatters.push(function(value) {
    return ctrl.$isEmpty(value) ? value : value.toString();
  });
}

function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);
}

function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  var type = lowercase(element[0].type);

  // In composition mode, users are still inputting intermediate text buffer,
  // hold the listener until composition is done.
  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
  if (!$sniffer.android) {
    var composing = false;

    element.on('compositionstart', function() {
      composing = true;
    });

    element.on('compositionend', function() {
      composing = false;
      listener();
    });
  }

  var timeout;

  var listener = function(ev) {
    if (timeout) {
      $browser.defer.cancel(timeout);
      timeout = null;
    }
    if (composing) return;
    var value = element.val(),
        event = ev && ev.type;

    // By default we will trim the value
    // If the attribute ng-trim exists we will avoid trimming
    // If input type is 'password', the value is never trimmed
    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
      value = trim(value);
    }

    // If a control is suffering from bad input (due to native validators), browsers discard its
    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
    // control's value is the same empty value twice in a row.
    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
      ctrl.$setViewValue(value, event);
    }
  };

  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
  // input event on backspace, delete or cut
  if ($sniffer.hasEvent('input')) {
    element.on('input', listener);
  } else {
    var deferListener = function(ev, input, origValue) {
      if (!timeout) {
        timeout = $browser.defer(function() {
          timeout = null;
          if (!input || input.value !== origValue) {
            listener(ev);
          }
        });
      }
    };

    element.on('keydown', /** @this */ function(event) {
      var key = event.keyCode;

      // ignore
      //    command            modifiers                   arrows
      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;

      deferListener(event, this, this.value);
    });

    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
    if ($sniffer.hasEvent('paste')) {
      element.on('paste cut', deferListener);
    }
  }

  // if user paste into input using mouse on older browser
  // or form autocomplete on newer browser, we need "change" event to catch it
  element.on('change', listener);

  // Some native input types (date-family) have the ability to change validity without
  // firing any input/change events.
  // For these event types, when native validators are present and the browser supports the type,
  // check for validity changes on various DOM events.
  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
      if (!timeout) {
        var validity = this[VALIDITY_STATE_PROPERTY];
        var origBadInput = validity.badInput;
        var origTypeMismatch = validity.typeMismatch;
        timeout = $browser.defer(function() {
          timeout = null;
          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
            listener(ev);
          }
        });
      }
    });
  }

  ctrl.$render = function() {
    // Workaround for Firefox validation #12102.
    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
    if (element.val() !== value) {
      element.val(value);
    }
  };
}

function weekParser(isoWeek, existingDate) {
  if (isDate(isoWeek)) {
    return isoWeek;
  }

  if (isString(isoWeek)) {
    WEEK_REGEXP.lastIndex = 0;
    var parts = WEEK_REGEXP.exec(isoWeek);
    if (parts) {
      var year = +parts[1],
          week = +parts[2],
          hours = 0,
          minutes = 0,
          seconds = 0,
          milliseconds = 0,
          firstThurs = getFirstThursdayOfYear(year),
          addDays = (week - 1) * 7;

      if (existingDate) {
        hours = existingDate.getHours();
        minutes = existingDate.getMinutes();
        seconds = existingDate.getSeconds();
        milliseconds = existingDate.getMilliseconds();
      }

      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
    }
  }

  return NaN;
}

function createDateParser(regexp, mapping) {
  return function(iso, date) {
    var parts, map;

    if (isDate(iso)) {
      return iso;
    }

    if (isString(iso)) {
      // When a date is JSON'ified to wraps itself inside of an extra
      // set of double quotes. This makes the date parsing code unable
      // to match the date string and parse it as a date.
      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
        iso = iso.substring(1, iso.length - 1);
      }
      if (ISO_DATE_REGEXP.test(iso)) {
        return new Date(iso);
      }
      regexp.lastIndex = 0;
      parts = regexp.exec(iso);

      if (parts) {
        parts.shift();
        if (date) {
          map = {
            yyyy: date.getFullYear(),
            MM: date.getMonth() + 1,
            dd: date.getDate(),
            HH: date.getHours(),
            mm: date.getMinutes(),
            ss: date.getSeconds(),
            sss: date.getMilliseconds() / 1000
          };
        } else {
          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
        }

        forEach(parts, function(part, index) {
          if (index < mapping.length) {
            map[mapping[index]] = +part;
          }
        });
        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
      }
    }

    return NaN;
  };
}

function createDateInputType(type, regexp, parseDate, format) {
  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
    badInputChecker(scope, element, attr, ctrl);
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
    var timezone = ctrl && ctrl.$options.getOption('timezone');
    var previousDate;

    ctrl.$$parserName = type;
    ctrl.$parsers.push(function(value) {
      if (ctrl.$isEmpty(value)) return null;
      if (regexp.test(value)) {
        // Note: We cannot read ctrl.$modelValue, as there might be a different
        // parser/formatter in the processing chain so that the model
        // contains some different data format!
        var parsedDate = parseDate(value, previousDate);
        if (timezone) {
          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
        }
        return parsedDate;
      }
      return undefined;
    });

    ctrl.$formatters.push(function(value) {
      if (value && !isDate(value)) {
        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
      }
      if (isValidDate(value)) {
        previousDate = value;
        if (previousDate && timezone) {
          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
        }
        return $filter('date')(value, format, timezone);
      } else {
        previousDate = null;
        return '';
      }
    });

    if (isDefined(attr.min) || attr.ngMin) {
      var minVal;
      ctrl.$validators.min = function(value) {
        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
      };
      attr.$observe('min', function(val) {
        minVal = parseObservedDateValue(val);
        ctrl.$validate();
      });
    }

    if (isDefined(attr.max) || attr.ngMax) {
      var maxVal;
      ctrl.$validators.max = function(value) {
        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
      };
      attr.$observe('max', function(val) {
        maxVal = parseObservedDateValue(val);
        ctrl.$validate();
      });
    }

    function isValidDate(value) {
      // Invalid Date: getTime() returns NaN
      return value && !(value.getTime && value.getTime() !== value.getTime());
    }

    function parseObservedDateValue(val) {
      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
    }
  };
}

function badInputChecker(scope, element, attr, ctrl) {
  var node = element[0];
  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
  if (nativeValidation) {
    ctrl.$parsers.push(function(value) {
      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
      return validity.badInput || validity.typeMismatch ? undefined : value;
    });
  }
}

function numberFormatterParser(ctrl) {
  ctrl.$$parserName = 'number';
  ctrl.$parsers.push(function(value) {
    if (ctrl.$isEmpty(value))      return null;
    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
    return undefined;
  });

  ctrl.$formatters.push(function(value) {
    if (!ctrl.$isEmpty(value)) {
      if (!isNumber(value)) {
        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
      }
      value = value.toString();
    }
    return value;
  });
}

function parseNumberAttrVal(val) {
  if (isDefined(val) && !isNumber(val)) {
    val = parseFloat(val);
  }
  return !isNumberNaN(val) ? val : undefined;
}

function isNumberInteger(num) {
  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
  // (minus the assumption that `num` is a number)

  // eslint-disable-next-line no-bitwise
  return (num | 0) === num;
}

function countDecimals(num) {
  var numString = num.toString();
  var decimalSymbolIndex = numString.indexOf('.');

  if (decimalSymbolIndex === -1) {
    if (-1 < num && num < 1) {
      // It may be in the exponential notation format (`1e-X`)
      var match = /e-(\d+)$/.exec(numString);

      if (match) {
        return Number(match[1]);
      }
    }

    return 0;
  }

  return numString.length - decimalSymbolIndex - 1;
}

function isValidForStep(viewValue, stepBase, step) {
  // At this point `stepBase` and `step` are expected to be non-NaN values
  // and `viewValue` is expected to be a valid stringified number.
  var value = Number(viewValue);

  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
  if (!isNumberInteger(value) || !isNumberInteger(stepBase) || !isNumberInteger(step)) {
    var decimalCount = Math.max(countDecimals(value), countDecimals(stepBase), countDecimals(step));
    var multiplier = Math.pow(10, decimalCount);

    value = value * multiplier;
    stepBase = stepBase * multiplier;
    step = step * multiplier;
  }

  return (value - stepBase) % step === 0;
}

function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  badInputChecker(scope, element, attr, ctrl);
  numberFormatterParser(ctrl);
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

  var minVal;
  var maxVal;

  if (isDefined(attr.min) || attr.ngMin) {
    ctrl.$validators.min = function(value) {
      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
    };

    attr.$observe('min', function(val) {
      minVal = parseNumberAttrVal(val);
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    });
  }

  if (isDefined(attr.max) || attr.ngMax) {
    ctrl.$validators.max = function(value) {
      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
    };

    attr.$observe('max', function(val) {
      maxVal = parseNumberAttrVal(val);
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    });
  }

  if (isDefined(attr.step) || attr.ngStep) {
    var stepVal;
    ctrl.$validators.step = function(modelValue, viewValue) {
      return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
             isValidForStep(viewValue, minVal || 0, stepVal);
    };

    attr.$observe('step', function(val) {
      stepVal = parseNumberAttrVal(val);
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    });
  }
}

function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  badInputChecker(scope, element, attr, ctrl);
  numberFormatterParser(ctrl);
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
      minVal = supportsRange ? 0 : undefined,
      maxVal = supportsRange ? 100 : undefined,
      stepVal = supportsRange ? 1 : undefined,
      validity = element[0].validity,
      hasMinAttr = isDefined(attr.min),
      hasMaxAttr = isDefined(attr.max),
      hasStepAttr = isDefined(attr.step);

  var originalRender = ctrl.$render;

  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
    //Browsers that implement range will set these values automatically, but reading the adjusted values after
    //$render would cause the min / max validators to be applied with the wrong value
    function rangeRender() {
      originalRender();
      ctrl.$setViewValue(element.val());
    } :
    originalRender;

  if (hasMinAttr) {
    ctrl.$validators.min = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMinValidator() { return true; } :
      // non-support browsers validate the min val
      function minValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
      };

    setInitialValueAndObserver('min', minChange);
  }

  if (hasMaxAttr) {
    ctrl.$validators.max = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMaxValidator() { return true; } :
      // non-support browsers validate the max val
      function maxValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
      };

    setInitialValueAndObserver('max', maxChange);
  }

  if (hasStepAttr) {
    ctrl.$validators.step = supportsRange ?
      function nativeStepValidator() {
        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
        // input element value to a valid value). It's possible that other browsers set the stepMismatch
        // validity error instead, so we can at least report an error in that case.
        return !validity.stepMismatch;
      } :
      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
      function stepValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
               isValidForStep(viewValue, minVal || 0, stepVal);
      };

    setInitialValueAndObserver('step', stepChange);
  }

  function setInitialValueAndObserver(htmlAttrName, changeFn) {
    // interpolated attributes set the attribute value only after a digest, but we need the
    // attribute value when the input is first rendered, so that the browser can adjust the
    // input value based on the min/max value
    element.attr(htmlAttrName, attr[htmlAttrName]);
    attr.$observe(htmlAttrName, changeFn);
  }

  function minChange(val) {
    minVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    if (supportsRange) {
      var elVal = element.val();
      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
      if (minVal > elVal) {
        elVal = minVal;
        element.val(elVal);
      }
      ctrl.$setViewValue(elVal);
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }

  function maxChange(val) {
    maxVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    if (supportsRange) {
      var elVal = element.val();
      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
      if (maxVal < elVal) {
        element.val(maxVal);
        // IE11 and Chrome don't set the value to the minVal when max < min
        elVal = maxVal < minVal ? minVal : maxVal;
      }
      ctrl.$setViewValue(elVal);
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }

  function stepChange(val) {
    stepVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
    if (supportsRange && ctrl.$viewValue !== element.val()) {
      ctrl.$setViewValue(element.val());
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }
}

function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$$parserName = 'url';
  ctrl.$validators.url = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
  };
}

function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$$parserName = 'email';
  ctrl.$validators.email = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
  };
}

function radioInputType(scope, element, attr, ctrl) {
  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
  // make the name unique, if not defined
  if (isUndefined(attr.name)) {
    element.attr('name', nextUid());
  }

  var listener = function(ev) {
    var value;
    if (element[0].checked) {
      value = attr.value;
      if (doTrim) {
        value = trim(value);
      }
      ctrl.$setViewValue(value, ev && ev.type);
    }
  };

  element.on('click', listener);

  ctrl.$render = function() {
    var value = attr.value;
    if (doTrim) {
      value = trim(value);
    }
    element[0].checked = (value === ctrl.$viewValue);
  };

  attr.$observe('value', ctrl.$render);
}

function parseConstantExpr($parse, context, name, expression, fallback) {
  var parseFn;
  if (isDefined(expression)) {
    parseFn = $parse(expression);
    if (!parseFn.constant) {
      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
                                   '`{1}`.', name, expression);
    }
    return parseFn(context);
  }
  return fallback;
}

function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);

  var listener = function(ev) {
    ctrl.$setViewValue(element[0].checked, ev && ev.type);
  };

  element.on('click', listener);

  ctrl.$render = function() {
    element[0].checked = ctrl.$viewValue;
  };

  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
  // it to a boolean.
  ctrl.$isEmpty = function(value) {
    return value === false;
  };

  ctrl.$formatters.push(function(value) {
    return equals(value, trueValue);
  });

  ctrl.$parsers.push(function(value) {
    return value ? trueValue : falseValue;
  });
}


/**
 * @ngdoc directive
 * @name textarea
 * @restrict E
 *
 * @description
 * HTML textarea element control with angular data-binding. The data-binding and validation
 * properties of this element are exactly the same as those of the
 * {@link ng.directive:input input element}.
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange Angular expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
 *
 * @knownIssue
 *
 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
 * insert the placeholder value as the textarea's content. If the placeholder value contains
 * interpolation (`{{ ... }}`), an error will be logged in the console when Angular tries to update
 * the value of the by-then-removed text node. This doesn't affect the functionality of the
 * textarea, but can be undesirable.
 *
 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
 * find more details on `ngAttr` in the
 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
 * Developer Guide.
 */


/**
 * @ngdoc directive
 * @name input
 * @restrict E
 *
 * @description
 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
 * input state control, and validation.
 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
 *
 * <div class="alert alert-warning">
 * **Note:** Not every feature offered is available for all input types.
 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
 * </div>
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {boolean=} ngRequired Sets `required` attribute if set to true
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    value does not match a RegExp found by evaluating the Angular expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange Angular expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
 *    This parameter is ignored for input[type=password] controls, which will never trim the
 *    input.
 *
 * @example
    <example name="input-directive" module="inputExample">
      <file name="index.html">
       <script>
          angular.module('inputExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.user = {name: 'guest', last: 'visitor'};
            }]);
       </script>
       <div ng-controller="ExampleController">
         <form name="myForm">
           <label>
              User name:
              <input type="text" name="userName" ng-model="user.name" required>
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.userName.$error.required">
              Required!</span>
           </div>
           <label>
              Last name:
              <input type="text" name="lastName" ng-model="user.last"
              ng-minlength="3" ng-maxlength="10">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.lastName.$error.minlength">
               Too short!</span>
             <span class="error" ng-show="myForm.lastName.$error.maxlength">
               Too long!</span>
           </div>
         </form>
         <hr>
         <tt>user = {{user}}</tt><br/>
         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
       </div>
      </file>
      <file name="protractor.js" type="protractor">
        var user = element(by.exactBinding('user'));
        var userNameValid = element(by.binding('myForm.userName.$valid'));
        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
        var lastNameError = element(by.binding('myForm.lastName.$error'));
        var formValid = element(by.binding('myForm.$valid'));
        var userNameInput = element(by.model('user.name'));
        var userLastInput = element(by.model('user.last'));

        it('should initialize to model', function() {
          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
          expect(userNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if empty when required', function() {
          userNameInput.clear();
          userNameInput.sendKeys('');

          expect(user.getText()).toContain('{"last":"visitor"}');
          expect(userNameValid.getText()).toContain('false');
          expect(formValid.getText()).toContain('false');
        });

        it('should be valid if empty when min length is set', function() {
          userLastInput.clear();
          userLastInput.sendKeys('');

          expect(user.getText()).toContain('{"name":"guest","last":""}');
          expect(lastNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if less than required min length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('xx');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('minlength');
          expect(formValid.getText()).toContain('false');
        });

        it('should be invalid if longer than max length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('some ridiculously long name');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('maxlength');
          expect(formValid.getText()).toContain('false');
        });
      </file>
    </example>
 */
var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
    function($browser, $sniffer, $filter, $parse) {
  return {
    restrict: 'E',
    require: ['?ngModel'],
    link: {
      pre: function(scope, element, attr, ctrls) {
        if (ctrls[0]) {
          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
                                                              $browser, $filter, $parse);
        }
      }
    }
  };
}];



var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
/**
 * @ngdoc directive
 * @name ngValue
 *
 * @description
 * Binds the given expression to the value of the element.
 *
 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
 * {@link select `select`} parent element) is set to the bound value. It is especially useful
 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
 *
 * It can also be used to achieve one-way binding of a given expression to an input element
 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
 *
 * @element input
 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
 * and `value` property of the element.
 *
 * @example
    <example name="ngValue-directive" module="valueExample">
      <file name="index.html">
       <script>
          angular.module('valueExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.names = ['pizza', 'unicorns', 'robots'];
              $scope.my = { favorite: 'unicorns' };
            }]);
       </script>
        <form ng-controller="ExampleController">
          <h2>Which is your favorite?</h2>
            <label ng-repeat="name in names" for="{{name}}">
              {{name}}
              <input type="radio"
                     ng-model="my.favorite"
                     ng-value="name"
                     id="{{name}}"
                     name="favorite">
            </label>
          <div>You chose {{my.favorite}}</div>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        var favorite = element(by.binding('my.favorite'));

        it('should initialize to model', function() {
          expect(favorite.getText()).toContain('unicorns');
        });
        it('should bind the values to the inputs', function() {
          element.all(by.model('my.favorite')).get(0).click();
          expect(favorite.getText()).toContain('pizza');
        });
      </file>
    </example>
 */
var ngValueDirective = function() {
  /**
   *  inputs use the value attribute as their default value if the value property is not set.
   *  Once the value property has been set (by adding input), it will not react to changes to
   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
   *  makes it possible to use ngValue as a sort of one-way bind.
   */
  function updateElementValue(element, attr, value) {
    element.prop('value', value);
    attr.$set('value', value);
  }

  return {
    restrict: 'A',
    priority: 100,
    compile: function(tpl, tplAttr) {
      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
        return function ngValueConstantLink(scope, elm, attr) {
          var value = scope.$eval(attr.ngValue);
          updateElementValue(elm, attr, value);
        };
      } else {
        return function ngValueLink(scope, elm, attr) {
          scope.$watch(attr.ngValue, function valueWatchAction(value) {
            updateElementValue(elm, attr, value);
          });
        };
      }
    }
  };
};

/**
 * @ngdoc directive
 * @name ngBind
 * @restrict AC
 *
 * @description
 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
 * with the value of a given expression, and to update the text content when the value of that
 * expression changes.
 *
 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
 * `{{ expression }}` which is similar but less verbose.
 *
 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
 * element attribute, it makes the bindings invisible to the user while the page is loading.
 *
 * An alternative solution to this problem would be using the
 * {@link ng.directive:ngCloak ngCloak} directive.
 *
 *
 * @element ANY
 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
 *
 * @example
 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
   <example module="bindExample" name="ng-bind">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.name = 'Whirled';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter name: <input type="text" ng-model="name"></label><br>
         Hello <span ng-bind="name"></span>!
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var nameInput = element(by.model('name'));

         expect(element(by.binding('name')).getText()).toBe('Whirled');
         nameInput.clear();
         nameInput.sendKeys('world');
         expect(element(by.binding('name')).getText()).toBe('world');
       });
     </file>
   </example>
 */
var ngBindDirective = ['$compile', function($compile) {
  return {
    restrict: 'AC',
    compile: function ngBindCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBind);
        element = element[0];
        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
          element.textContent = stringify(value);
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindTemplate
 *
 * @description
 * The `ngBindTemplate` directive specifies that the element
 * text content should be replaced with the interpolation of the template
 * in the `ngBindTemplate` attribute.
 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
 * expressions. This directive is needed since some HTML elements
 * (such as TITLE and OPTION) cannot contain SPAN elements.
 *
 * @element ANY
 * @param {string} ngBindTemplate template of form
 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
 *
 * @example
 * Try it here: enter text in text box and watch the greeting change.
   <example module="bindExample" name="ng-bind-template">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.salutation = 'Hello';
             $scope.name = 'World';
           }]);
       </script>
       <div ng-controller="ExampleController">
        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
        <label>Name: <input type="text" ng-model="name"></label><br>
        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var salutationElem = element(by.binding('salutation'));
         var salutationInput = element(by.model('salutation'));
         var nameInput = element(by.model('name'));

         expect(salutationElem.getText()).toBe('Hello World!');

         salutationInput.clear();
         salutationInput.sendKeys('Greetings');
         nameInput.clear();
         nameInput.sendKeys('user');

         expect(salutationElem.getText()).toBe('Greetings user!');
       });
     </file>
   </example>
 */
var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
  return {
    compile: function ngBindTemplateCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindTemplateLink(scope, element, attr) {
        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
        $compile.$$addBindingInfo(element, interpolateFn.expressions);
        element = element[0];
        attr.$observe('ngBindTemplate', function(value) {
          element.textContent = isUndefined(value) ? '' : value;
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindHtml
 *
 * @description
 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
 *
 * You may also bypass sanitization for values you know are safe. To do so, bind to
 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
 *
 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
 * will have an exception (instead of an exploit.)
 *
 * @element ANY
 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
 *
 * @example

   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
     <file name="index.html">
       <div ng-controller="ExampleController">
        <p ng-bind-html="myHTML"></p>
       </div>
     </file>

     <file name="script.js">
       angular.module('bindHtmlExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.myHTML =
              'I am an <code>HTML</code>string with ' +
              '<a href="#">links!</a> and other <em>stuff</em>';
         }]);
     </file>

     <file name="protractor.js" type="protractor">
       it('should check ng-bind-html', function() {
         expect(element(by.binding('myHTML')).getText()).toBe(
             'I am an HTMLstring with links! and other stuff');
       });
     </file>
   </example>
 */
var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
  return {
    restrict: 'A',
    compile: function ngBindHtmlCompile(tElement, tAttrs) {
      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
        return $sce.valueOf(val);
      });
      $compile.$$addBindingClass(tElement);

      return function ngBindHtmlLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBindHtml);

        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
          var value = ngBindHtmlGetter(scope);
          element.html($sce.getTrustedHtml(value) || '');
        });
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngChange
 *
 * @description
 * Evaluate the given expression when the user changes the input.
 * The expression is evaluated immediately, unlike the JavaScript onchange event
 * which only triggers at the end of a change (usually, when the user leaves the
 * form element or presses the return key).
 *
 * The `ngChange` expression is only evaluated when a change in the input value causes
 * a new value to be committed to the model.
 *
 * It will not be evaluated:
 * * if the value returned from the `$parsers` transformation pipeline has not changed
 * * if the input has continued to be invalid since the model will stay `null`
 * * if the model is changed programmatically and not by a change to the input value
 *
 *
 * Note, this directive requires `ngModel` to be present.
 *
 * @element input
 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
 * in input value.
 *
 * @example
 * <example name="ngChange-directive" module="changeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('changeExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.counter = 0;
 *           $scope.change = function() {
 *             $scope.counter++;
 *           };
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
 *       <label for="ng-change-example2">Confirmed</label><br />
 *       <tt>debug = {{confirmed}}</tt><br/>
 *       <tt>counter = {{counter}}</tt><br/>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var counter = element(by.binding('counter'));
 *     var debug = element(by.binding('confirmed'));
 *
 *     it('should evaluate the expression if changing from view', function() {
 *       expect(counter.getText()).toContain('0');
 *
 *       element(by.id('ng-change-example1')).click();
 *
 *       expect(counter.getText()).toContain('1');
 *       expect(debug.getText()).toContain('true');
 *     });
 *
 *     it('should not evaluate the expression if changing from model', function() {
 *       element(by.id('ng-change-example2')).click();

 *       expect(counter.getText()).toContain('0');
 *       expect(debug.getText()).toContain('true');
 *     });
 *   </file>
 * </example>
 */
var ngChangeDirective = valueFn({
  restrict: 'A',
  require: 'ngModel',
  link: function(scope, element, attr, ctrl) {
    ctrl.$viewChangeListeners.push(function() {
      scope.$eval(attr.ngChange);
    });
  }
});

/* exported
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective
*/

function classDirective(name, selector) {
  name = 'ngClass' + name;
  var indexWatchExpression;

  return ['$parse', function($parse) {
    return {
      restrict: 'AC',
      link: function(scope, element, attr) {
        var expression = attr[name].trim();
        var isOneTime = (expression.charAt(0) === ':') && (expression.charAt(1) === ':');

        var watchInterceptor = isOneTime ? toFlatValue : toClassString;
        var watchExpression = $parse(expression, watchInterceptor);
        var watchAction = isOneTime ? ngClassOneTimeWatchAction : ngClassWatchAction;

        var classCounts = element.data('$classCounts');
        var oldModulo = true;
        var oldClassString;

        if (!classCounts) {
          // Use createMap() to prevent class assumptions involving property
          // names in Object.prototype
          classCounts = createMap();
          element.data('$classCounts', classCounts);
        }

        if (name !== 'ngClass') {
          if (!indexWatchExpression) {
            indexWatchExpression = $parse('$index', function moduloTwo($index) {
              // eslint-disable-next-line no-bitwise
              return $index & 1;
            });
          }

          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
        }

        scope.$watch(watchExpression, watchAction, isOneTime);

        function addClasses(classString) {
          classString = digestClassCounts(split(classString), 1);
          attr.$addClass(classString);
        }

        function removeClasses(classString) {
          classString = digestClassCounts(split(classString), -1);
          attr.$removeClass(classString);
        }

        function updateClasses(oldClassString, newClassString) {
          var oldClassArray = split(oldClassString);
          var newClassArray = split(newClassString);

          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
          var toAddArray = arrayDifference(newClassArray, oldClassArray);

          var toRemoveString = digestClassCounts(toRemoveArray, -1);
          var toAddString = digestClassCounts(toAddArray, 1);

          attr.$addClass(toAddString);
          attr.$removeClass(toRemoveString);
        }

        function digestClassCounts(classArray, count) {
          var classesToUpdate = [];

          forEach(classArray, function(className) {
            if (count > 0 || classCounts[className]) {
              classCounts[className] = (classCounts[className] || 0) + count;
              if (classCounts[className] === +(count > 0)) {
                classesToUpdate.push(className);
              }
            }
          });

          return classesToUpdate.join(' ');
        }

        function ngClassIndexWatchAction(newModulo) {
          // This watch-action should run before the `ngClass[OneTime]WatchAction()`, thus it
          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
          // `ngClass[OneTime]WatchAction()` will update the classes.
          if (newModulo === selector) {
            addClasses(oldClassString);
          } else {
            removeClasses(oldClassString);
          }

          oldModulo = newModulo;
        }

        function ngClassOneTimeWatchAction(newClassValue) {
          var newClassString = toClassString(newClassValue);

          if (newClassString !== oldClassString) {
            ngClassWatchAction(newClassString);
          }
        }

        function ngClassWatchAction(newClassString) {
          if (oldModulo === selector) {
            updateClasses(oldClassString, newClassString);
          }

          oldClassString = newClassString;
        }
      }
    };
  }];

  // Helpers
  function arrayDifference(tokens1, tokens2) {
    if (!tokens1 || !tokens1.length) return [];
    if (!tokens2 || !tokens2.length) return tokens1;

    var values = [];

    outer:
    for (var i = 0; i < tokens1.length; i++) {
      var token = tokens1[i];
      for (var j = 0; j < tokens2.length; j++) {
        if (token === tokens2[j]) continue outer;
      }
      values.push(token);
    }

    return values;
  }

  function split(classString) {
    return classString && classString.split(' ');
  }

  function toClassString(classValue) {
    var classString = classValue;

    if (isArray(classValue)) {
      classString = classValue.map(toClassString).join(' ');
    } else if (isObject(classValue)) {
      classString = Object.keys(classValue).
        filter(function(key) { return classValue[key]; }).
        join(' ');
    }

    return classString;
  }

  function toFlatValue(classValue) {
    var flatValue = classValue;

    if (isArray(classValue)) {
      flatValue = classValue.map(toFlatValue);
    } else if (isObject(classValue)) {
      var hasUndefined = false;

      flatValue = Object.keys(classValue).filter(function(key) {
        var value = classValue[key];

        if (!hasUndefined && isUndefined(value)) {
          hasUndefined = true;
        }

        return value;
      });

      if (hasUndefined) {
        // Prevent the `oneTimeLiteralWatchInterceptor` from unregistering
        // the watcher, by including at least one `undefined` value.
        flatValue.push(undefined);
      }
    }

    return flatValue;
  }
}

/**
 * @ngdoc directive
 * @name ngClass
 * @restrict AC
 *
 * @description
 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
 * an expression that represents all classes to be added.
 *
 * The directive operates in three different ways, depending on which of three types the expression
 * evaluates to:
 *
 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
 * names.
 *
 * 2. If the expression evaluates to an object, then for each key-value pair of the
 * object with a truthy value the corresponding key is used as a class name.
 *
 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
 * to give you more control over what CSS classes appear. See the code below for an example of this.
 *
 *
 * The directive won't add duplicate classes if a particular class was already set.
 *
 * When the expression changes, the previously added classes are removed and only then are the
 * new classes added.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
 * attribute, when using the `ngClass` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * @element ANY
 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class
 *   names, an array, or a map of class names to boolean values. In the case of a map, the
 *   names of the properties whose values are truthy will be added as css classes to the
 *   element.
 *
 * @example Example that demonstrates basic bindings via ngClass directive.
   <example name="ng-class">
     <file name="index.html">
       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
       <label>
          <input type="checkbox" ng-model="deleted">
          deleted (apply "strike" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="important">
          important (apply "bold" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="error">
          error (apply "has-error" class)
       </label>
       <hr>
       <p ng-class="style">Using String Syntax</p>
       <input type="text" ng-model="style"
              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
       <hr>
       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
       <input ng-model="style1"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
       <input ng-model="style2"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
       <input ng-model="style3"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
       <hr>
       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
     </file>
     <file name="style.css">
       .strike {
           text-decoration: line-through;
       }
       .bold {
           font-weight: bold;
       }
       .red {
           color: red;
       }
       .has-error {
           color: red;
           background-color: yellow;
       }
       .orange {
           color: orange;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var ps = element.all(by.css('p'));

       it('should let you toggle the class', function() {

         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);

         element(by.model('important')).click();
         expect(ps.first().getAttribute('class')).toMatch(/bold/);

         element(by.model('error')).click();
         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
       });

       it('should let you toggle string example', function() {
         expect(ps.get(1).getAttribute('class')).toBe('');
         element(by.model('style')).clear();
         element(by.model('style')).sendKeys('red');
         expect(ps.get(1).getAttribute('class')).toBe('red');
       });

       it('array example should have 3 classes', function() {
         expect(ps.get(2).getAttribute('class')).toBe('');
         element(by.model('style1')).sendKeys('bold');
         element(by.model('style2')).sendKeys('strike');
         element(by.model('style3')).sendKeys('red');
         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
       });

       it('array with map example should have 2 classes', function() {
         expect(ps.last().getAttribute('class')).toBe('');
         element(by.model('style4')).sendKeys('bold');
         element(by.model('warning')).click();
         expect(ps.last().getAttribute('class')).toBe('bold orange');
       });
     </file>
   </example>

   ## Animations

   The example below demonstrates how to perform animations using ngClass.

   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
     <file name="index.html">
      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
      <br>
      <span class="base-class" ng-class="myVar">Sample Text</span>
     </file>
     <file name="style.css">
       .base-class {
         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
       }

       .base-class.my-class {
         color: red;
         font-size:3em;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class', function() {
         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);

         element(by.id('setbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).
           toMatch(/my-class/);

         element(by.id('clearbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);
       });
     </file>
   </example>


   ## ngClass and pre-existing CSS3 Transitions/Animations
   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
   to view the step by step details of {@link $animate#addClass $animate.addClass} and
   {@link $animate#removeClass $animate.removeClass}.
 */
var ngClassDirective = classDirective('', true);

/**
 * @ngdoc directive
 * @name ngClassOdd
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @element ANY
 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-odd">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}}
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 */
var ngClassOddDirective = classDirective('Odd', 0);

/**
 * @ngdoc directive
 * @name ngClassEven
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @element ANY
 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
 *   result of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-even">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}} &nbsp; &nbsp; &nbsp;
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 */
var ngClassEvenDirective = classDirective('Even', 1);

/**
 * @ngdoc directive
 * @name ngCloak
 * @restrict AC
 *
 * @description
 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
 * directive to avoid the undesirable flicker effect caused by the html template display.
 *
 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
 * of the browser view.
 *
 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
 * `angular.min.js`.
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```css
 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
 *   display: none !important;
 * }
 * ```
 *
 * When this css rule is loaded by the browser, all html elements (including their children) that
 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
 * during the compilation of the template it deletes the `ngCloak` element attribute, making
 * the compiled element visible.
 *
 * For the best result, the `angular.js` script must be loaded in the head section of the html
 * document; alternatively, the css rule above must be included in the external stylesheet of the
 * application.
 *
 * @element ANY
 *
 * @example
   <example name="ng-cloak">
     <file name="index.html">
        <div id="template1" ng-cloak>{{ 'hello' }}</div>
        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should remove the template directive and css class', function() {
         expect($('#template1').getAttribute('ng-cloak')).
           toBeNull();
         expect($('#template2').getAttribute('ng-cloak')).
           toBeNull();
       });
     </file>
   </example>
 *
 */
var ngCloakDirective = ngDirective({
  compile: function(element, attr) {
    attr.$set('ngCloak', undefined);
    element.removeClass('ng-cloak');
  }
});

/**
 * @ngdoc directive
 * @name ngController
 *
 * @description
 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
 * supports the principles behind the Model-View-Controller design pattern.
 *
 * MVC components in angular:
 *
 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
 *   are accessed through bindings.
 * * View — The template (HTML with data bindings) that is rendered into the View.
 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
 *   logic behind the application to decorate the scope with functions and values
 *
 * Note that you can also attach controllers to the DOM by declaring it in a route definition
 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
 * and executed twice.
 *
 * @element ANY
 * @scope
 * @priority 500
 * @param {expression} ngController Name of a constructor function registered with the current
 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
 * that on the current scope evaluates to a constructor function.
 *
 * The controller instance can be published into a scope property by specifying
 * `ng-controller="as propertyName"`.
 *
 * If the current `$controllerProvider` is configured to use globals (via
 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
 * also be the name of a globally accessible constructor function (deprecated, not recommended).
 *
 * @example
 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
 * greeting are methods declared on the controller (see source tab). These methods can
 * easily be called from the angular markup. Any changes to the data are automatically reflected
 * in the View without the need for a manual update.
 *
 * Two different declaration styles are included below:
 *
 * * one binds methods and properties directly onto the controller using `this`:
 * `ng-controller="SettingsController1 as settings"`
 * * one injects `$scope` into the controller:
 * `ng-controller="SettingsController2"`
 *
 * The second option is more common in the Angular community, and is generally used in boilerplates
 * and in this guide. However, there are advantages to binding properties directly to the controller
 * and avoiding scope.
 *
 * * Using `controller as` makes it obvious which controller you are accessing in the template when
 * multiple controllers apply to an element.
 * * If you are writing your controllers as classes you have easier access to the properties and
 * methods, which will appear on the scope, from inside the controller code.
 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
 * inheritance masking primitives.
 *
 * This example demonstrates the `controller as` syntax.
 *
 * <example name="ngControllerAs" module="controllerAsExample">
 *   <file name="index.html">
 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
 *      <button ng-click="settings.greet()">greet</button><br/>
 *      Contact:
 *      <ul>
 *        <li ng-repeat="contact in settings.contacts">
 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
 *             <option>phone</option>
 *             <option>email</option>
 *          </select>
 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *          <button ng-click="settings.clearContact(contact)">clear</button>
 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
 *        </li>
 *        <li><button ng-click="settings.addContact()">add</button></li>
 *     </ul>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('controllerAsExample', [])
 *      .controller('SettingsController1', SettingsController1);
 *
 *    function SettingsController1() {
 *      this.name = 'John Smith';
 *      this.contacts = [
 *        {type: 'phone', value: '408 555 1212'},
 *        {type: 'email', value: 'john.smith@example.org'}
 *      ];
 *    }
 *
 *    SettingsController1.prototype.greet = function() {
 *      alert(this.name);
 *    };
 *
 *    SettingsController1.prototype.addContact = function() {
 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
 *    };
 *
 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
 *     var index = this.contacts.indexOf(contactToRemove);
 *      this.contacts.splice(index, 1);
 *    };
 *
 *    SettingsController1.prototype.clearContact = function(contact) {
 *      contact.type = 'phone';
 *      contact.value = '';
 *    };
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should check controller as', function() {
 *       var container = element(by.id('ctrl-as-exmpl'));
 *         expect(container.element(by.model('settings.name'))
 *           .getAttribute('value')).toBe('John Smith');
 *
 *       var firstRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(0));
 *       var secondRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(1));
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('408 555 1212');
 *
 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('john.smith@example.org');
 *
 *       firstRepeat.element(by.buttonText('clear')).click();
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('');
 *
 *       container.element(by.buttonText('add')).click();
 *
 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
 *           .element(by.model('contact.value'))
 *           .getAttribute('value'))
 *           .toBe('yourname@example.org');
 *     });
 *   </file>
 * </example>
 *
 * This example demonstrates the "attach to `$scope`" style of controller.
 *
 * <example name="ngController" module="controllerExample">
 *  <file name="index.html">
 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
 *     <label>Name: <input type="text" ng-model="name"/></label>
 *     <button ng-click="greet()">greet</button><br/>
 *     Contact:
 *     <ul>
 *       <li ng-repeat="contact in contacts">
 *         <select ng-model="contact.type" id="select_{{$index}}">
 *            <option>phone</option>
 *            <option>email</option>
 *         </select>
 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *         <button ng-click="clearContact(contact)">clear</button>
 *         <button ng-click="removeContact(contact)">X</button>
 *       </li>
 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
 *    </ul>
 *   </div>
 *  </file>
 *  <file name="app.js">
 *   angular.module('controllerExample', [])
 *     .controller('SettingsController2', ['$scope', SettingsController2]);
 *
 *   function SettingsController2($scope) {
 *     $scope.name = 'John Smith';
 *     $scope.contacts = [
 *       {type:'phone', value:'408 555 1212'},
 *       {type:'email', value:'john.smith@example.org'}
 *     ];
 *
 *     $scope.greet = function() {
 *       alert($scope.name);
 *     };
 *
 *     $scope.addContact = function() {
 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
 *     };
 *
 *     $scope.removeContact = function(contactToRemove) {
 *       var index = $scope.contacts.indexOf(contactToRemove);
 *       $scope.contacts.splice(index, 1);
 *     };
 *
 *     $scope.clearContact = function(contact) {
 *       contact.type = 'phone';
 *       contact.value = '';
 *     };
 *   }
 *  </file>
 *  <file name="protractor.js" type="protractor">
 *    it('should check controller', function() {
 *      var container = element(by.id('ctrl-exmpl'));
 *
 *      expect(container.element(by.model('name'))
 *          .getAttribute('value')).toBe('John Smith');
 *
 *      var firstRepeat =
 *          container.element(by.repeater('contact in contacts').row(0));
 *      var secondRepeat =
 *          container.element(by.repeater('contact in contacts').row(1));
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('408 555 1212');
 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('john.smith@example.org');
 *
 *      firstRepeat.element(by.buttonText('clear')).click();
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('');
 *
 *      container.element(by.buttonText('add')).click();
 *
 *      expect(container.element(by.repeater('contact in contacts').row(2))
 *          .element(by.model('contact.value'))
 *          .getAttribute('value'))
 *          .toBe('yourname@example.org');
 *    });
 *  </file>
 *</example>

 */
var ngControllerDirective = [function() {
  return {
    restrict: 'A',
    scope: true,
    controller: '@',
    priority: 500
  };
}];

/**
 * @ngdoc directive
 * @name ngCsp
 *
 * @restrict A
 * @element ANY
 * @description
 *
 * Angular has some features that can conflict with certain restrictions that are applied when using
 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
 *
 * If you intend to implement CSP with these rules then you must tell Angular not to use these
 * features.
 *
 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
 *
 *
 * The following default rules in CSP affect Angular:
 *
 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
 * code from strings is forbidden. Angular makes use of this in the {@link $parse} service to
 * provide a 30% increase in the speed of evaluating Angular expressions. (This CSP rule can be
 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
 * weaken the protections offered by CSP.)
 *
 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
 * This prevents apps from injecting custom styles directly into the document. Angular makes use of
 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
 * it is generally not recommended as it would weaken the protections offered by CSP.)
 *
 * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking dynamic code
 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
 * CSP error to be logged in the console:
 *
 * ```
 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
 * script in the following Content Security Policy directive: "default-src 'self'". Note that
 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
 * ```
 *
 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
 * directive on an element of the HTML document that appears before the `<script>` tag that loads
 * the `angular.js` file.
 *
 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
 *
 * You can specify which of the CSP related Angular features should be deactivated by providing
 * a value for the `ng-csp` attribute. The options are as follows:
 *
 * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
 *
 * * no-unsafe-eval: this stops Angular from optimizing $parse with unsafe eval of strings
 *
 * You can use these values in the following combinations:
 *
 *
 * * No declaration means that Angular will assume that you can do inline styles, but it will do
 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
 * versions of Angular.
 *
 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
 * versions of Angular.
 *
 * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can
 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
 *
 * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
 *
 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
 * styles nor use eval, which is the same as an empty: ng-csp.
 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
 *
 * @example
 * This example shows how to apply the `ngCsp` directive to the `html` tag.
   ```html
     <!doctype html>
     <html ng-app ng-csp>
     ...
     ...
     </html>
   ```
  * @example
      <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
      <example name="example.csp" module="cspExample" ng-csp="true">
        <file name="index.html">
          <div ng-controller="MainController as ctrl">
            <div>
              <button ng-click="ctrl.inc()" id="inc">Increment</button>
              <span id="counter">
                {{ctrl.counter}}
              </span>
            </div>

            <div>
              <button ng-click="ctrl.evil()" id="evil">Evil</button>
              <span id="evilError">
                {{ctrl.evilError}}
              </span>
            </div>
          </div>
        </file>
        <file name="script.js">
           angular.module('cspExample', [])
             .controller('MainController', function MainController() {
                this.counter = 0;
                this.inc = function() {
                  this.counter++;
                };
                this.evil = function() {
                  try {
                    eval('1+2'); // eslint-disable-line no-eval
                  } catch (e) {
                    this.evilError = e.message;
                  }
                };
              });
        </file>
        <file name="protractor.js" type="protractor">
          var util, webdriver;

          var incBtn = element(by.id('inc'));
          var counter = element(by.id('counter'));
          var evilBtn = element(by.id('evil'));
          var evilError = element(by.id('evilError'));

          function getAndClearSevereErrors() {
            return browser.manage().logs().get('browser').then(function(browserLog) {
              return browserLog.filter(function(logEntry) {
                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
              });
            });
          }

          function clearErrors() {
            getAndClearSevereErrors();
          }

          function expectNoErrors() {
            getAndClearSevereErrors().then(function(filteredLog) {
              expect(filteredLog.length).toEqual(0);
              if (filteredLog.length) {
                console.log('browser console errors: ' + util.inspect(filteredLog));
              }
            });
          }

          function expectError(regex) {
            getAndClearSevereErrors().then(function(filteredLog) {
              var found = false;
              filteredLog.forEach(function(log) {
                if (log.message.match(regex)) {
                  found = true;
                }
              });
              if (!found) {
                throw new Error('expected an error that matches ' + regex);
              }
            });
          }

          beforeEach(function() {
            util = require('util');
            webdriver = require('selenium-webdriver');
          });

          // For now, we only test on Chrome,
          // as Safari does not load the page with Protractor's injected scripts,
          // and Firefox webdriver always disables content security policy (#6358)
          if (browser.params.browser !== 'chrome') {
            return;
          }

          it('should not report errors when the page is loaded', function() {
            // clear errors so we are not dependent on previous tests
            clearErrors();
            // Need to reload the page as the page is already loaded when
            // we come here
            browser.driver.getCurrentUrl().then(function(url) {
              browser.get(url);
            });
            expectNoErrors();
          });

          it('should evaluate expressions', function() {
            expect(counter.getText()).toEqual('0');
            incBtn.click();
            expect(counter.getText()).toEqual('1');
            expectNoErrors();
          });

          it('should throw and report an error when using "eval"', function() {
            evilBtn.click();
            expect(evilError.getText()).toMatch(/Content Security Policy/);
            expectError(/Content Security Policy/);
          });
        </file>
      </example>
  */

// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
// fn that looks for the `ng-csp` attribute anywhere in the current doc.

/**
 * @ngdoc directive
 * @name ngClick
 *
 * @description
 * The ngClick directive allows you to specify custom behavior when
 * an element is clicked.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
 * click. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-click">
     <file name="index.html">
      <button ng-click="count = count + 1" ng-init="count=0">
        Increment
      </button>
      <span>
        count: {{count}}
      </span>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-click', function() {
         expect(element(by.binding('count')).getText()).toMatch('0');
         element(by.css('button')).click();
         expect(element(by.binding('count')).getText()).toMatch('1');
       });
     </file>
   </example>
 */
/*
 * A collection of directives that allows creation of custom event handlers that are defined as
 * angular expressions and are compiled and executed within the current scope.
 */
var ngEventDirectives = {};

// For events that might fire synchronously during DOM manipulation
// we need to execute their event handlers asynchronously using $evalAsync,
// so that they are not executed in an inconsistent state.
var forceAsyncEvents = {
  'blur': true,
  'focus': true
};
forEach(
  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
  function(eventName) {
    var directiveName = directiveNormalize('ng-' + eventName);
    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
      return {
        restrict: 'A',
        compile: function($element, attr) {
          // We expose the powerful $event object on the scope that provides access to the Window,
          // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
          // checks at the cost of speed since event handler expressions are not executed as
          // frequently as regular change detection.
          var fn = $parse(attr[directiveName], /* interceptorFn */ null, /* expensiveChecks */ true);
          return function ngEventHandler(scope, element) {
            element.on(eventName, function(event) {
              var callback = function() {
                fn(scope, {$event:event});
              };
              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
                scope.$evalAsync(callback);
              } else {
                scope.$apply(callback);
              }
            });
          };
        }
      };
    }];
  }
);

/**
 * @ngdoc directive
 * @name ngDblclick
 *
 * @description
 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
 * a dblclick. (The Event object is available as `$event`)
 *
 * @example
   <example name="ng-dblclick">
     <file name="index.html">
      <button ng-dblclick="count = count + 1" ng-init="count=0">
        Increment (on double click)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousedown
 *
 * @description
 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousedown">
     <file name="index.html">
      <button ng-mousedown="count = count + 1" ng-init="count=0">
        Increment (on mouse down)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseup
 *
 * @description
 * Specify custom behavior on mouseup event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseup">
     <file name="index.html">
      <button ng-mouseup="count = count + 1" ng-init="count=0">
        Increment (on mouse up)
      </button>
      count: {{count}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngMouseover
 *
 * @description
 * Specify custom behavior on mouseover event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseover">
     <file name="index.html">
      <button ng-mouseover="count = count + 1" ng-init="count=0">
        Increment (when mouse is over)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseenter
 *
 * @description
 * Specify custom behavior on mouseenter event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseenter">
     <file name="index.html">
      <button ng-mouseenter="count = count + 1" ng-init="count=0">
        Increment (when mouse enters)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseleave
 *
 * @description
 * Specify custom behavior on mouseleave event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseleave">
     <file name="index.html">
      <button ng-mouseleave="count = count + 1" ng-init="count=0">
        Increment (when mouse leaves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousemove
 *
 * @description
 * Specify custom behavior on mousemove event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousemove">
     <file name="index.html">
      <button ng-mousemove="count = count + 1" ng-init="count=0">
        Increment (when mouse moves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeydown
 *
 * @description
 * Specify custom behavior on keydown event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keydown">
     <file name="index.html">
      <input ng-keydown="count = count + 1" ng-init="count=0">
      key down count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeyup
 *
 * @description
 * Specify custom behavior on keyup event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keyup">
     <file name="index.html">
       <p>Typing in the input box below updates the key count</p>
       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}

       <p>Typing in the input box below updates the keycode</p>
       <input ng-keyup="event=$event">
       <p>event keyCode: {{ event.keyCode }}</p>
       <p>event altKey: {{ event.altKey }}</p>
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeypress
 *
 * @description
 * Specify custom behavior on keypress event.
 *
 * @element ANY
 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
 * and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keypress">
     <file name="index.html">
      <input ng-keypress="count = count + 1" ng-init="count=0">
      key press count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngSubmit
 *
 * @description
 * Enables binding angular expressions to onsubmit events.
 *
 * Additionally it prevents the default action (which for form means sending the request to the
 * server and reloading the current page), but only if the form does not contain `action`,
 * `data-action`, or `x-action` attributes.
 *
 * <div class="alert alert-warning">
 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
 * `ngSubmit` handlers together. See the
 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
 * for a detailed discussion of when `ngSubmit` may be triggered.
 * </div>
 *
 * @element form
 * @priority 0
 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
 * ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example module="submitExample" name="ng-submit">
     <file name="index.html">
      <script>
        angular.module('submitExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.list = [];
            $scope.text = 'hello';
            $scope.submit = function() {
              if ($scope.text) {
                $scope.list.push(this.text);
                $scope.text = '';
              }
            };
          }]);
      </script>
      <form ng-submit="submit()" ng-controller="ExampleController">
        Enter text and hit enter:
        <input type="text" ng-model="text" name="text" />
        <input type="submit" id="submit" value="Submit" />
        <pre>list={{list}}</pre>
      </form>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-submit', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
         expect(element(by.model('text')).getAttribute('value')).toBe('');
       });
       it('should ignore empty strings', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
        });
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngFocus
 *
 * @description
 * Specify custom behavior on focus event.
 *
 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngBlur
 *
 * @description
 * Specify custom behavior on blur event.
 *
 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
 * an element has lost focus.
 *
 * Note: As the `blur` event is executed synchronously also during DOM manipulations
 * (e.g. removing a focussed input),
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngCopy
 *
 * @description
 * Specify custom behavior on copy event.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-copy">
     <file name="index.html">
      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
      copied: {{copied}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngCut
 *
 * @description
 * Specify custom behavior on cut event.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-cut">
     <file name="index.html">
      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
      cut: {{cut}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngPaste
 *
 * @description
 * Specify custom behavior on paste event.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-paste">
     <file name="index.html">
      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
      pasted: {{paste}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngIf
 * @restrict A
 * @multiElement
 *
 * @description
 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
 * {expression}. If the expression assigned to `ngIf` evaluates to a false
 * value then the element is removed from the DOM, otherwise a clone of the
 * element is reinserted into the DOM.
 *
 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
 * element in the DOM rather than changing its visibility via the `display` css property.  A common
 * case when this difference is significant is when using css selectors that rely on an element's
 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
 *
 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
 * is created when the element is restored.  The scope created within `ngIf` inherits from
 * its parent scope using
 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
 * a javascript primitive defined in the parent scope. In this case any modifications made to the
 * variable within the child scope will override (hide) the value in the parent scope.
 *
 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
 * is if an element's class attribute is directly modified after it's compiled, using something like
 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
 * the added class will be lost because the original compiled state is used to regenerate the element.
 *
 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
 * and `leave` effects.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
 *
 * @element ANY
 * @scope
 * @priority 600
 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
 *     element is added to the DOM tree.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
    <file name="index.html">
      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
      Show when checked:
      <span ng-if="checked" class="animate-if">
        This is removed when the checkbox is unchecked.
      </span>
    </file>
    <file name="animations.css">
      .animate-if {
        background:white;
        border:1px solid black;
        padding:10px;
      }

      .animate-if.ng-enter, .animate-if.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
      }

      .animate-if.ng-enter,
      .animate-if.ng-leave.ng-leave-active {
        opacity:0;
      }

      .animate-if.ng-leave,
      .animate-if.ng-enter.ng-enter-active {
        opacity:1;
      }
    </file>
  </example>
 */
var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
  return {
    multiElement: true,
    transclude: 'element',
    priority: 600,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function($scope, $element, $attr, ctrl, $transclude) {
        var block, childScope, previousElements;
        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {

          if (value) {
            if (!childScope) {
              $transclude(function(clone, newScope) {
                childScope = newScope;
                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block = {
                  clone: clone
                };
                $animate.enter(clone, $element.parent(), $element);
              });
            }
          } else {
            if (previousElements) {
              previousElements.remove();
              previousElements = null;
            }
            if (childScope) {
              childScope.$destroy();
              childScope = null;
            }
            if (block) {
              previousElements = getBlockNodes(block.clone);
              $animate.leave(previousElements).done(function(response) {
                if (response !== false) previousElements = null;
              });
              block = null;
            }
          }
        });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngInclude
 * @restrict ECA
 *
 * @description
 * Fetches, compiles and includes an external HTML fragment.
 *
 * By default, the template URL is restricted to the same domain and protocol as the
 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
 * ng.$sce Strict Contextual Escaping}.
 *
 * In addition, the browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy may further restrict whether the template is successfully loaded.
 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
 * access on some browsers.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
 *
 * The enter and leave animation occur concurrently.
 *
 * @scope
 * @priority 400
 *
 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
 * @param {string=} onload Expression to evaluate when a new partial is loaded.
 *                  <div class="alert alert-warning">
 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
 *                  a function with the name on the window element, which will usually throw a
 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
 *                  different form that {@link guide/directive#normalization matches} `onload`.
 *                  </div>
   *
 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
 *                  $anchorScroll} to scroll the viewport after the content is loaded.
 *
 *                  - If the attribute is not set, disable scrolling.
 *                  - If the attribute is set without value, enable scrolling.
 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
 *
 * @example
  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
    <file name="index.html">
     <div ng-controller="ExampleController">
       <select ng-model="template" ng-options="t.name for t in templates">
        <option value="">(blank)</option>
       </select>
       url of the template: <code>{{template.url}}</code>
       <hr/>
       <div class="slide-animate-container">
         <div class="slide-animate" ng-include="template.url"></div>
       </div>
     </div>
    </file>
    <file name="script.js">
      angular.module('includeExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.templates =
            [{ name: 'template1.html', url: 'template1.html'},
             { name: 'template2.html', url: 'template2.html'}];
          $scope.template = $scope.templates[0];
        }]);
     </file>
    <file name="template1.html">
      Content of template1.html
    </file>
    <file name="template2.html">
      Content of template2.html
    </file>
    <file name="animations.css">
      .slide-animate-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .slide-animate {
        padding:10px;
      }

      .slide-animate.ng-enter, .slide-animate.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        display:block;
        padding:10px;
      }

      .slide-animate.ng-enter {
        top:-50px;
      }
      .slide-animate.ng-enter.ng-enter-active {
        top:0;
      }

      .slide-animate.ng-leave {
        top:0;
      }
      .slide-animate.ng-leave.ng-leave-active {
        top:50px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var templateSelect = element(by.model('template'));
      var includeElem = element(by.css('[ng-include]'));

      it('should load template1.html', function() {
        expect(includeElem.getText()).toMatch(/Content of template1.html/);
      });

      it('should load template2.html', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          // See https://github.com/angular/protractor/issues/480
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(2).click();
        expect(includeElem.getText()).toMatch(/Content of template2.html/);
      });

      it('should change to blank', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(0).click();
        expect(includeElem.isPresent()).toBe(false);
      });
    </file>
  </example>
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentRequested
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted every time the ngInclude content is requested.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentLoaded
 * @eventType emit on the current ngInclude scope
 * @description
 * Emitted every time the ngInclude content is reloaded.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentError
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */
var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
                  function($templateRequest,   $anchorScroll,   $animate) {
  return {
    restrict: 'ECA',
    priority: 400,
    terminal: true,
    transclude: 'element',
    controller: angular.noop,
    compile: function(element, attr) {
      var srcExp = attr.ngInclude || attr.src,
          onloadExp = attr.onload || '',
          autoScrollExp = attr.autoscroll;

      return function(scope, $element, $attr, ctrl, $transclude) {
        var changeCounter = 0,
            currentScope,
            previousElement,
            currentElement;

        var cleanupLastIncludeContent = function() {
          if (previousElement) {
            previousElement.remove();
            previousElement = null;
          }
          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }
          if (currentElement) {
            $animate.leave(currentElement).done(function(response) {
              if (response !== false) previousElement = null;
            });
            previousElement = currentElement;
            currentElement = null;
          }
        };

        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
          var afterAnimation = function(response) {
            if (response !== false && isDefined(autoScrollExp) &&
              (!autoScrollExp || scope.$eval(autoScrollExp))) {
                $anchorScroll();
            }
          };
          var thisChangeId = ++changeCounter;

          if (src) {
            //set the 2nd param to true to ignore the template request error so that the inner
            //contents and scope can be cleaned up.
            $templateRequest(src, true).then(function(response) {
              if (scope.$$destroyed) return;

              if (thisChangeId !== changeCounter) return;
              var newScope = scope.$new();
              ctrl.template = response;

              // Note: This will also link all children of ng-include that were contained in the original
              // html. If that content contains controllers, ... they could pollute/change the scope.
              // However, using ng-include on an element with additional content does not make sense...
              // Note: We can't remove them in the cloneAttchFn of $transclude as that
              // function is called before linking the content, which would apply child
              // directives to non existing elements.
              var clone = $transclude(newScope, function(clone) {
                cleanupLastIncludeContent();
                $animate.enter(clone, null, $element).done(afterAnimation);
              });

              currentScope = newScope;
              currentElement = clone;

              currentScope.$emit('$includeContentLoaded', src);
              scope.$eval(onloadExp);
            }, function() {
              if (scope.$$destroyed) return;

              if (thisChangeId === changeCounter) {
                cleanupLastIncludeContent();
                scope.$emit('$includeContentError', src);
              }
            });
            scope.$emit('$includeContentRequested', src);
          } else {
            cleanupLastIncludeContent();
            ctrl.template = null;
          }
        });
      };
    }
  };
}];

// This directive is called during the $transclude call of the first `ngInclude` directive.
// It will replace and compile the content of the element with the loaded template.
// We need this directive so that the element content is already filled when
// the link function of another directive on the same element as ngInclude
// is called.
var ngIncludeFillContentDirective = ['$compile',
  function($compile) {
    return {
      restrict: 'ECA',
      priority: -400,
      require: 'ngInclude',
      link: function(scope, $element, $attr, ctrl) {
        if (toString.call($element[0]).match(/SVG/)) {
          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
          // support innerHTML, so detect this here and try to generate the contents
          // specially.
          $element.empty();
          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
              function namespaceAdaptedClone(clone) {
            $element.append(clone);
          }, {futureParentElement: $element});
          return;
        }

        $element.html(ctrl.template);
        $compile($element.contents())(scope);
      }
    };
  }];

/**
 * @ngdoc directive
 * @name ngInit
 * @restrict AC
 *
 * @description
 * The `ngInit` directive allows you to evaluate an expression in the
 * current scope.
 *
 * <div class="alert alert-danger">
 * This directive can be abused to add unnecessary amounts of logic into your templates.
 * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
 * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
 * rather than `ngInit` to initialize values on a scope.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
 * sure you have parentheses to ensure correct operator precedence:
 * <pre class="prettyprint">
 * `<div ng-init="test1 = ($index | toString)"></div>`
 * </pre>
 * </div>
 *
 * @priority 450
 *
 * @element ANY
 * @param {expression} ngInit {@link guide/expression Expression} to eval.
 *
 * @example
   <example module="initExample" name="ng-init">
     <file name="index.html">
   <script>
     angular.module('initExample', [])
       .controller('ExampleController', ['$scope', function($scope) {
         $scope.list = [['a', 'b'], ['c', 'd']];
       }]);
   </script>
   <div ng-controller="ExampleController">
     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
       </div>
     </div>
   </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should alias index positions', function() {
         var elements = element.all(by.css('.example-init'));
         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
       });
     </file>
   </example>
 */
var ngInitDirective = ngDirective({
  priority: 450,
  compile: function() {
    return {
      pre: function(scope, element, attrs) {
        scope.$eval(attrs.ngInit);
      }
    };
  }
});

/**
 * @ngdoc directive
 * @name ngList
 *
 * @description
 * Text input that converts between a delimited string and an array of strings. The default
 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
 *
 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
 *   list item is respected. This implies that the user of the directive is responsible for
 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
 *   tab or newline character.
 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
 *   when joining the list items back together) and whitespace around each list item is stripped
 *   before it is added to the model.
 *
 * ### Example with Validation
 *
 * <example name="ngList-directive" module="listExample">
 *   <file name="app.js">
 *      angular.module('listExample', [])
 *        .controller('ExampleController', ['$scope', function($scope) {
 *          $scope.names = ['morpheus', 'neo', 'trinity'];
 *        }]);
 *   </file>
 *   <file name="index.html">
 *    <form name="myForm" ng-controller="ExampleController">
 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
 *      <span role="alert">
 *        <span class="error" ng-show="myForm.namesInput.$error.required">
 *        Required!</span>
 *      </span>
 *      <br>
 *      <tt>names = {{names}}</tt><br/>
 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
 *     </form>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var listInput = element(by.model('names'));
 *     var names = element(by.exactBinding('names'));
 *     var valid = element(by.binding('myForm.namesInput.$valid'));
 *     var error = element(by.css('span.error'));
 *
 *     it('should initialize to model', function() {
 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
 *       expect(valid.getText()).toContain('true');
 *       expect(error.getCssValue('display')).toBe('none');
 *     });
 *
 *     it('should be invalid if empty', function() {
 *       listInput.clear();
 *       listInput.sendKeys('');
 *
 *       expect(names.getText()).toContain('');
 *       expect(valid.getText()).toContain('false');
 *       expect(error.getCssValue('display')).not.toBe('none');
 *     });
 *   </file>
 * </example>
 *
 * ### Example - splitting on newline
 * <example name="ngList-directive-newlines">
 *   <file name="index.html">
 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
 *    <pre>{{ list | json }}</pre>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it("should split the text by newlines", function() {
 *       var listInput = element(by.model('list'));
 *       var output = element(by.binding('list | json'));
 *       listInput.sendKeys('abc\ndef\nghi');
 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
 *     });
 *   </file>
 * </example>
 *
 * @element input
 * @param {string=} ngList optional delimiter that should be used to split the value.
 */
var ngListDirective = function() {
  return {
    restrict: 'A',
    priority: 100,
    require: 'ngModel',
    link: function(scope, element, attr, ctrl) {
      var ngList = attr.ngList || ', ';
      var trimValues = attr.ngTrim !== 'false';
      var separator = trimValues ? trim(ngList) : ngList;

      var parse = function(viewValue) {
        // If the viewValue is invalid (say required but empty) it will be `undefined`
        if (isUndefined(viewValue)) return;

        var list = [];

        if (viewValue) {
          forEach(viewValue.split(separator), function(value) {
            if (value) list.push(trimValues ? trim(value) : value);
          });
        }

        return list;
      };

      ctrl.$parsers.push(parse);
      ctrl.$formatters.push(function(value) {
        if (isArray(value)) {
          return value.join(ngList);
        }

        return undefined;
      });

      // Override the standard $isEmpty because an empty array means the input is empty.
      ctrl.$isEmpty = function(value) {
        return !value || !value.length;
      };
    }
  };
};

/* global VALID_CLASS: true,
  INVALID_CLASS: true,
  PRISTINE_CLASS: true,
  DIRTY_CLASS: true,
  UNTOUCHED_CLASS: true,
  TOUCHED_CLASS: true,
  PENDING_CLASS: true,
  addSetValidityMethod: true,
  setupValidity: true,
  defaultModelOptions: false
*/


var VALID_CLASS = 'ng-valid',
    INVALID_CLASS = 'ng-invalid',
    PRISTINE_CLASS = 'ng-pristine',
    DIRTY_CLASS = 'ng-dirty',
    UNTOUCHED_CLASS = 'ng-untouched',
    TOUCHED_CLASS = 'ng-touched',
    EMPTY_CLASS = 'ng-empty',
    NOT_EMPTY_CLASS = 'ng-not-empty';

var ngModelMinErr = minErr('ngModel');

/**
 * @ngdoc type
 * @name ngModel.NgModelController
 *
 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
 * is set.
 * @property {*} $modelValue The value in the model that the control is bound to.
 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
       the control reads value from the DOM. The functions are called in array order, each passing
       its return value through to the next. The last return value is forwarded to the
       {@link ngModel.NgModelController#$validators `$validators`} collection.

Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
`$viewValue`}.

Returning `undefined` from a parser means a parse error occurred. In that case,
no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
is set to `true`. The parse error is stored in `ngModel.$error.parse`.

 *
 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
       the model value changes. The functions are called in reverse array order, each passing the value through to the
       next. The last return value is used as the actual DOM value.
       Used to format / convert values for display in the control.
 * ```js
 * function formatter(value) {
 *   if (value) {
 *     return value.toUpperCase();
 *   }
 * }
 * ngModel.$formatters.push(formatter);
 * ```
 *
 * @property {Object.<string, function>} $validators A collection of validators that are applied
 *      whenever the model value changes. The key value within the object refers to the name of the
 *      validator while the function refers to the validation operation. The validation operation is
 *      provided with the model value as an argument and must return a true or false value depending
 *      on the response of that validation.
 *
 * ```js
 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *   return /[0-9]+/.test(value) &&
 *          /[a-z]+/.test(value) &&
 *          /[A-Z]+/.test(value) &&
 *          /\W+/.test(value);
 * };
 * ```
 *
 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
 *      is expected to return a promise when it is run during the model validation process. Once the promise
 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
 *      will only run once all synchronous validators have passed.
 *
 * Please note that if $http is used then it is important that the server returns a success HTTP response code
 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
 *
 * ```js
 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *
 *   // Lookup user by username
 *   return $http.get('/api/users/' + value).
 *      then(function resolved() {
 *        //username exists, this means validation fails
 *        return $q.reject('exists');
 *      }, function rejected() {
 *        //username does not exist, therefore this validation passes
 *        return true;
 *      });
 * };
 * ```
 *
 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
 *     view value has changed. It is called with no arguments, and its return value is ignored.
 *     This can be used in place of additional $watches against the model value.
 *
 * @property {Object} $error An object hash with all failing validator ids as keys.
 * @property {Object} $pending An object hash with all pending validator ids as keys.
 *
 * @property {boolean} $untouched True if control has not lost focus yet.
 * @property {boolean} $touched True if control has lost focus.
 * @property {boolean} $pristine True if user has not interacted with the control yet.
 * @property {boolean} $dirty True if user has already interacted with the control.
 * @property {boolean} $valid True if there is no error.
 * @property {boolean} $invalid True if at least one error on the control.
 * @property {string} $name The name attribute of the control.
 *
 * @description
 *
 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
 * The controller contains services for data-binding, validation, CSS updates, and value formatting
 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
 * listening to DOM events.
 * Such DOM related logic should be provided by other directives which make use of
 * `NgModelController` for data-binding to control elements.
 * Angular provides this DOM logic for most {@link input `input`} elements.
 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
 *
 * @example
 * ### Custom Control Example
 * This example shows how to use `NgModelController` with a custom control to achieve
 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
 * collaborate together to achieve the desired result.
 *
 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
 * contents be edited in place by the user.
 *
 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
 * that content using the `$sce` service.
 *
 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
    <file name="style.css">
      [contenteditable] {
        border: 1px solid black;
        background-color: white;
        min-height: 20px;
      }

      .ng-invalid {
        border: 1px solid red;
      }

    </file>
    <file name="script.js">
      angular.module('customControl', ['ngSanitize']).
        directive('contenteditable', ['$sce', function($sce) {
          return {
            restrict: 'A', // only activate on element attribute
            require: '?ngModel', // get a hold of NgModelController
            link: function(scope, element, attrs, ngModel) {
              if (!ngModel) return; // do nothing if no ng-model

              // Specify how UI should be updated
              ngModel.$render = function() {
                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
              };

              // Listen for change events to enable binding
              element.on('blur keyup change', function() {
                scope.$evalAsync(read);
              });
              read(); // initialize

              // Write data to the model
              function read() {
                var html = element.html();
                // When we clear the content editable the browser leaves a <br> behind
                // If strip-br attribute is provided then we strip this out
                if (attrs.stripBr && html === '<br>') {
                  html = '';
                }
                ngModel.$setViewValue(html);
              }
            }
          };
        }]);
    </file>
    <file name="index.html">
      <form name="myForm">
       <div contenteditable
            name="myWidget" ng-model="userContent"
            strip-br="true"
            required>Change me!</div>
        <span ng-show="myForm.myWidget.$error.required">Required!</span>
       <hr>
       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
    it('should data-bind and become invalid', function() {
      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
        // SafariDriver can't handle contenteditable
        // and Firefox driver can't clear contenteditables very well
        return;
      }
      var contentEditable = element(by.css('[contenteditable]'));
      var content = 'Change me!';

      expect(contentEditable.getText()).toEqual(content);

      contentEditable.clear();
      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
      expect(contentEditable.getText()).toEqual('');
      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
    });
    </file>
 * </example>
 *
 *
 */
NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
  this.$viewValue = Number.NaN;
  this.$modelValue = Number.NaN;
  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
  this.$validators = {};
  this.$asyncValidators = {};
  this.$parsers = [];
  this.$formatters = [];
  this.$viewChangeListeners = [];
  this.$untouched = true;
  this.$touched = false;
  this.$pristine = true;
  this.$dirty = false;
  this.$valid = true;
  this.$invalid = false;
  this.$error = {}; // keep invalid keys here
  this.$$success = {}; // keep valid keys here
  this.$pending = undefined; // keep pending keys here
  this.$name = $interpolate($attr.name || '', false)($scope);
  this.$$parentForm = nullFormCtrl;
  this.$options = defaultModelOptions;

  this.$$parsedNgModel = $parse($attr.ngModel);
  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
  this.$$ngModelGet = this.$$parsedNgModel;
  this.$$ngModelSet = this.$$parsedNgModelAssign;
  this.$$pendingDebounce = null;
  this.$$parserValid = undefined;

  this.$$currentValidationRunId = 0;

  this.$$scope = $scope;
  this.$$attr = $attr;
  this.$$element = $element;
  this.$$animate = $animate;
  this.$$timeout = $timeout;
  this.$$parse = $parse;
  this.$$q = $q;
  this.$$exceptionHandler = $exceptionHandler;

  setupValidity(this);
  setupModelWatcher(this);
}

NgModelController.prototype = {
  $$initGetterSetters: function() {
    if (this.$options.getOption('getterSetter')) {
      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');

      this.$$ngModelGet = function($scope) {
        var modelValue = this.$$parsedNgModel($scope);
        if (isFunction(modelValue)) {
          modelValue = invokeModelGetter($scope);
        }
        return modelValue;
      };
      this.$$ngModelSet = function($scope, newValue) {
        if (isFunction(this.$$parsedNgModel($scope))) {
          invokeModelSetter($scope, {$$$p: newValue});
        } else {
          this.$$parsedNgModelAssign($scope, newValue);
        }
      };
    } else if (!this.$$parsedNgModel.assign) {
      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
          this.$$attr.ngModel, startingTag(this.$$element));
    }
  },


  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$render
   *
   * @description
   * Called when the view needs to be updated. It is expected that the user of the ng-model
   * directive will implement this method.
   *
   * The `$render()` method is invoked in the following situations:
   *
   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
   *   committed value then `$render()` is called to update the input control.
   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
   *   the `$viewValue` are different from last time.
   *
   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
   * invoked if you only change a property on the objects.
   */
  $render: noop,

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$isEmpty
   *
   * @description
   * This is called when we need to determine if the value of an input is empty.
   *
   * For instance, the required directive does this to work out if the input has data or not.
   *
   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
   *
   * You can override this for input directives whose concept of being empty is different from the
   * default. The `checkboxInputType` directive does this because in its case a value of `false`
   * implies empty.
   *
   * @param {*} value The value of the input to check for emptiness.
   * @returns {boolean} True if `value` is "empty".
   */
  $isEmpty: function(value) {
    // eslint-disable-next-line no-self-compare
    return isUndefined(value) || value === '' || value === null || value !== value;
  },

  $$updateEmptyClasses: function(value) {
    if (this.$isEmpty(value)) {
      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
    } else {
      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
    }
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setPristine
   *
   * @description
   * Sets the control to its pristine state.
   *
   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
   * state (`ng-pristine` class). A model is considered to be pristine when the control
   * has not been changed from when first compiled.
   */
  $setPristine: function() {
    this.$dirty = false;
    this.$pristine = true;
    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setDirty
   *
   * @description
   * Sets the control to its dirty state.
   *
   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
   * from when first compiled.
   */
  $setDirty: function() {
    this.$dirty = true;
    this.$pristine = false;
    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
    this.$$parentForm.$setDirty();
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setUntouched
   *
   * @description
   * Sets the control to its untouched state.
   *
   * This method can be called to remove the `ng-touched` class and set the control to its
   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
   * by default, however this function can be used to restore that state if the model has
   * already been touched by the user.
   */
  $setUntouched: function() {
    this.$touched = false;
    this.$untouched = true;
    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setTouched
   *
   * @description
   * Sets the control to its touched state.
   *
   * This method can be called to remove the `ng-untouched` class and set the control to its
   * touched state (`ng-touched` class). A model is considered to be touched when the user has
   * first focused the control element and then shifted focus away from the control (blur event).
   */
  $setTouched: function() {
    this.$touched = true;
    this.$untouched = false;
    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$rollbackViewValue
   *
   * @description
   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
   * which may be caused by a pending debounced event or because the input is waiting for some
   * future event.
   *
   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
   * sync with the ngModel's `$modelValue`.
   *
   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
   * and reset the input to the last committed view value.
   *
   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
   * programmatically before these debounced/future events have resolved/occurred, because Angular's
   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
   *
   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
   * input which may have such events pending. This is important in order to make sure that the
   * input field will be updated with the new model value and any pending operations are cancelled.
   *
   * <example name="ng-model-cancel-update" module="cancel-update-example">
   *   <file name="app.js">
   *     angular.module('cancel-update-example', [])
   *
   *     .controller('CancelUpdateController', ['$scope', function($scope) {
   *       $scope.model = {value1: '', value2: ''};
   *
   *       $scope.setEmpty = function(e, value, rollback) {
   *         if (e.keyCode === 27) {
   *           e.preventDefault();
   *           if (rollback) {
   *             $scope.myForm[value].$rollbackViewValue();
   *           }
   *           $scope.model[value] = '';
   *         }
   *       };
   *     }]);
   *   </file>
   *   <file name="index.html">
   *     <div ng-controller="CancelUpdateController">
   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
   *       empty them. Follow these steps and observe the difference:</p>
   *       <ol>
   *         <li>Type something in the input. You will see that the model is not yet updated</li>
   *         <li>Press the Escape key.
   *           <ol>
   *             <li> In the first example, nothing happens, because the model is already '', and no
   *             update is detected. If you blur the input, the model will be set to the current view.
   *             </li>
   *             <li> In the second example, the pending update is cancelled, and the input is set back
   *             to the last committed view value (''). Blurring the input does nothing.
   *             </li>
   *           </ol>
   *         </li>
   *       </ol>
   *
   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
   *         <div>
   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
   *                  ng-keydown="setEmpty($event, 'value1')">
   *           value1: "{{ model.value1 }}"
   *         </div>
   *
   *         <div>
   *           <p id="inputDescription2">With $rollbackViewValue():</p>
   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
   *                  ng-keydown="setEmpty($event, 'value2', true)">
   *           value2: "{{ model.value2 }}"
   *         </div>
   *       </form>
   *     </div>
   *   </file>
       <file name="style.css">
          div {
            display: table-cell;
          }
          div:nth-child(1) {
            padding-right: 30px;
          }

        </file>
   * </example>
   */
  $rollbackViewValue: function() {
    this.$$timeout.cancel(this.$$pendingDebounce);
    this.$viewValue = this.$$lastCommittedViewValue;
    this.$render();
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$validate
   *
   * @description
   * Runs each of the registered validators (first synchronous validators and then
   * asynchronous validators).
   * If the validity changes to invalid, the model will be set to `undefined`,
   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
   * If the validity changes to valid, it will set the model to the last available valid
   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
   */
  $validate: function() {
    // ignore $validate before model is initialized
    if (isNumberNaN(this.$modelValue)) {
      return;
    }

    var viewValue = this.$$lastCommittedViewValue;
    // Note: we use the $$rawModelValue as $modelValue might have been
    // set to undefined during a view -> model update that found validation
    // errors. We can't parse the view here, since that could change
    // the model although neither viewValue nor the model on the scope changed
    var modelValue = this.$$rawModelValue;

    var prevValid = this.$valid;
    var prevModelValue = this.$modelValue;

    var allowInvalid = this.$options.getOption('allowInvalid');

    var that = this;
    this.$$runValidators(modelValue, viewValue, function(allValid) {
      // If there was no change in validity, don't update the model
      // This prevents changing an invalid modelValue to undefined
      if (!allowInvalid && prevValid !== allValid) {
        // Note: Don't check this.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        that.$modelValue = allValid ? modelValue : undefined;

        if (that.$modelValue !== prevModelValue) {
          that.$$writeModelToScope();
        }
      }
    });
  },

  $$runValidators: function(modelValue, viewValue, doneCallback) {
    this.$$currentValidationRunId++;
    var localValidationRunId = this.$$currentValidationRunId;
    var that = this;

    // check parser error
    if (!processParseErrors()) {
      validationDone(false);
      return;
    }
    if (!processSyncValidators()) {
      validationDone(false);
      return;
    }
    processAsyncValidators();

    function processParseErrors() {
      var errorKey = that.$$parserName || 'parse';
      if (isUndefined(that.$$parserValid)) {
        setValidity(errorKey, null);
      } else {
        if (!that.$$parserValid) {
          forEach(that.$validators, function(v, name) {
            setValidity(name, null);
          });
          forEach(that.$asyncValidators, function(v, name) {
            setValidity(name, null);
          });
        }
        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
        setValidity(errorKey, that.$$parserValid);
        return that.$$parserValid;
      }
      return true;
    }

    function processSyncValidators() {
      var syncValidatorsValid = true;
      forEach(that.$validators, function(validator, name) {
        var result = Boolean(validator(modelValue, viewValue));
        syncValidatorsValid = syncValidatorsValid && result;
        setValidity(name, result);
      });
      if (!syncValidatorsValid) {
        forEach(that.$asyncValidators, function(v, name) {
          setValidity(name, null);
        });
        return false;
      }
      return true;
    }

    function processAsyncValidators() {
      var validatorPromises = [];
      var allValid = true;
      forEach(that.$asyncValidators, function(validator, name) {
        var promise = validator(modelValue, viewValue);
        if (!isPromiseLike(promise)) {
          throw ngModelMinErr('nopromise',
            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
        }
        setValidity(name, undefined);
        validatorPromises.push(promise.then(function() {
          setValidity(name, true);
        }, function() {
          allValid = false;
          setValidity(name, false);
        }));
      });
      if (!validatorPromises.length) {
        validationDone(true);
      } else {
        that.$$q.all(validatorPromises).then(function() {
          validationDone(allValid);
        }, noop);
      }
    }

    function setValidity(name, isValid) {
      if (localValidationRunId === that.$$currentValidationRunId) {
        that.$setValidity(name, isValid);
      }
    }

    function validationDone(allValid) {
      if (localValidationRunId === that.$$currentValidationRunId) {

        doneCallback(allValid);
      }
    }
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$commitViewValue
   *
   * @description
   * Commit a pending update to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  $commitViewValue: function() {
    var viewValue = this.$viewValue;

    this.$$timeout.cancel(this.$$pendingDebounce);

    // If the view value has not changed then we should just exit, except in the case where there is
    // a native validator on the element. In this case the validation state may have changed even though
    // the viewValue has stayed empty.
    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
      return;
    }
    this.$$updateEmptyClasses(viewValue);
    this.$$lastCommittedViewValue = viewValue;

    // change to dirty
    if (this.$pristine) {
      this.$setDirty();
    }
    this.$$parseAndValidate();
  },

  $$parseAndValidate: function() {
    var viewValue = this.$$lastCommittedViewValue;
    var modelValue = viewValue;
    var that = this;

    this.$$parserValid = isUndefined(modelValue) ? undefined : true;

    if (this.$$parserValid) {
      for (var i = 0; i < this.$parsers.length; i++) {
        modelValue = this.$parsers[i](modelValue);
        if (isUndefined(modelValue)) {
          this.$$parserValid = false;
          break;
        }
      }
    }
    if (isNumberNaN(this.$modelValue)) {
      // this.$modelValue has not been touched yet...
      this.$modelValue = this.$$ngModelGet(this.$$scope);
    }
    var prevModelValue = this.$modelValue;
    var allowInvalid = this.$options.getOption('allowInvalid');
    this.$$rawModelValue = modelValue;

    if (allowInvalid) {
      this.$modelValue = modelValue;
      writeToModelIfNeeded();
    }

    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
    // This can happen if e.g. $setViewValue is called from inside a parser
    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
      if (!allowInvalid) {
        // Note: Don't check this.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        that.$modelValue = allValid ? modelValue : undefined;
        writeToModelIfNeeded();
      }
    });

    function writeToModelIfNeeded() {
      if (that.$modelValue !== prevModelValue) {
        that.$$writeModelToScope();
      }
    }
  },

  $$writeModelToScope: function() {
    this.$$ngModelSet(this.$$scope, this.$modelValue);
    forEach(this.$viewChangeListeners, function(listener) {
      try {
        listener();
      } catch (e) {
        // eslint-disable-next-line no-invalid-this
        this.$$exceptionHandler(e);
      }
    }, this);
  },

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setViewValue
   *
   * @description
   * Update the view value.
   *
   * This method should be called when a control wants to change the view value; typically,
   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
   * directive calls it when the value of the input changes and {@link ng.directive:select select}
   * calls it when an option is selected.
   *
   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
   * value sent directly for processing, finally to be applied to `$modelValue` and then the
   * **expression** specified in the `ng-model` attribute. Lastly, all the registered change listeners,
   * in the `$viewChangeListeners` list, are called.
   *
   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
   * and the `default` trigger is not listed, all those actions will remain pending until one of the
   * `updateOn` events is triggered on the DOM element.
   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
   * directive is used with a custom debounce for this particular event.
   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
   * is specified, once the timer runs out.
   *
   * When used with standard inputs, the view value will always be a string (which is in some cases
   * parsed into another type, such as a `Date` object for `input[date]`.)
   * However, custom controls might also pass objects to this method. In this case, we should make
   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
   * perform a deep watch of objects, it only looks for a change of identity. If you only change
   * the property of the object then ngModel will not realize that the object has changed and
   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
   * not change properties of the copy once it has been passed to `$setViewValue`.
   * Otherwise you may cause the model value on the scope to change incorrectly.
   *
   * <div class="alert alert-info">
   * In any case, the value passed to the method should always reflect the current value
   * of the control. For example, if you are calling `$setViewValue` for an input element,
   * you should pass the input DOM value. Otherwise, the control and the scope model become
   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
   * the control's DOM value in any way. If we want to change the control's DOM value
   * programmatically, we should update the `ngModel` scope expression. Its new value will be
   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
   * to update the DOM, and finally call `$validate` on it.
   * </div>
   *
   * @param {*} value value from the view.
   * @param {string} trigger Event that triggered the update.
   */
  $setViewValue: function(value, trigger) {
    this.$viewValue = value;
    if (this.$options.getOption('updateOnDefault')) {
      this.$$debounceViewValueCommit(trigger);
    }
  },

  $$debounceViewValueCommit: function(trigger) {
    var debounceDelay = this.$options.getOption('debounce');

    if (isNumber(debounceDelay[trigger])) {
      debounceDelay = debounceDelay[trigger];
    } else if (isNumber(debounceDelay['default'])) {
      debounceDelay = debounceDelay['default'];
    }

    this.$$timeout.cancel(this.$$pendingDebounce);
    var that = this;
    if (debounceDelay > 0) { // this fails if debounceDelay is an object
      this.$$pendingDebounce = this.$$timeout(function() {
        that.$commitViewValue();
      }, debounceDelay);
    } else if (this.$$scope.$root.$$phase) {
      this.$commitViewValue();
    } else {
      this.$$scope.$apply(function() {
        that.$commitViewValue();
      });
    }
  }
};

function setupModelWatcher(ctrl) {
  // model -> value
  // Note: we cannot use a normal scope.$watch as we want to detect the following:
  // 1. scope value is 'a'
  // 2. user enters 'b'
  // 3. ng-change kicks in and reverts scope value to 'a'
  //    -> scope value did not change since the last digest as
  //       ng-change executes in apply phase
  // 4. view should be changed back to 'a'
  ctrl.$$scope.$watch(function ngModelWatch() {
    var modelValue = ctrl.$$ngModelGet(ctrl.$$scope);

    // if scope model value and ngModel value are out of sync
    // TODO(perf): why not move this to the action fn?
    if (modelValue !== ctrl.$modelValue &&
       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
        // eslint-disable-next-line no-self-compare
       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
    ) {
      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
      ctrl.$$parserValid = undefined;

      var formatters = ctrl.$formatters,
          idx = formatters.length;

      var viewValue = modelValue;
      while (idx--) {
        viewValue = formatters[idx](viewValue);
      }
      if (ctrl.$viewValue !== viewValue) {
        ctrl.$$updateEmptyClasses(viewValue);
        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
        ctrl.$render();

        // It is possible that model and view value have been updated during render
        ctrl.$$runValidators(ctrl.$modelValue, ctrl.$viewValue, noop);
      }
    }

    return modelValue;
  });
}

/**
 * @ngdoc method
 * @name ngModel.NgModelController#$setValidity
 *
 * @description
 * Change the validity state, and notify the form.
 *
 * This method can be called within $parsers/$formatters or a custom validation implementation.
 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
 *
 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
 *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
 *                          Skipped is used by Angular when validators do not run because of parse errors and
 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
 */
addSetValidityMethod({
  clazz: NgModelController,
  set: function(object, property) {
    object[property] = true;
  },
  unset: function(object, property) {
    delete object[property];
  }
});


/**
 * @ngdoc directive
 * @name ngModel
 *
 * @element input
 * @priority 1
 *
 * @description
 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
 * property on the scope using {@link ngModel.NgModelController NgModelController},
 * which is created and exposed by this directive.
 *
 * `ngModel` is responsible for:
 *
 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
 *   require.
 * - Providing validation behavior (i.e. required, number, email, url).
 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
 * - Registering the control with its parent {@link ng.directive:form form}.
 *
 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
 * current scope. If the property doesn't already exist on this scope, it will be created
 * implicitly and added to the scope.
 *
 * For best practices on using `ngModel`, see:
 *
 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
 *
 * For basic examples, how to use `ngModel`, see:
 *
 *  - {@link ng.directive:input input}
 *    - {@link input[text] text}
 *    - {@link input[checkbox] checkbox}
 *    - {@link input[radio] radio}
 *    - {@link input[number] number}
 *    - {@link input[email] email}
 *    - {@link input[url] url}
 *    - {@link input[date] date}
 *    - {@link input[datetime-local] datetime-local}
 *    - {@link input[time] time}
 *    - {@link input[month] month}
 *    - {@link input[week] week}
 *  - {@link ng.directive:select select}
 *  - {@link ng.directive:textarea textarea}
 *
 * # Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
 *
 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
 *
 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
 * if the select is given the `multiple` attribute.
 *
 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
 * not trigger a re-rendering of the model.
 *
 * # CSS classes
 * The following CSS classes are added and removed on the associated input/select/textarea element
 * depending on the validity of the model.
 *
 *  - `ng-valid`: the model is valid
 *  - `ng-invalid`: the model is invalid
 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
 *  - `ng-pristine`: the control hasn't been interacted with yet
 *  - `ng-dirty`: the control has been interacted with
 *  - `ng-touched`: the control has been blurred
 *  - `ng-untouched`: the control hasn't been blurred
 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
 *     by the {@link ngModel.NgModelController#$isEmpty} method
 *  - `ng-not-empty`: the view contains a non-empty value
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 * ## Animation Hooks
 *
 * Animations within models are triggered when any of the associated CSS classes are added and removed
 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
 * The animations that are triggered within ngModel are similar to how they work in ngClass and
 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style an input element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-input {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-input.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
     <file name="index.html">
       <script>
        angular.module('inputExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.val = '1';
          }]);
       </script>
       <style>
         .my-input {
           transition:all linear 0.5s;
           background: transparent;
         }
         .my-input.ng-invalid {
           color:white;
           background: red;
         }
       </style>
       <p id="inputDescription">
        Update input to see transitions when valid/invalid.
        Integer is a valid value.
       </p>
       <form name="testForm" ng-controller="ExampleController">
         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
                aria-describedby="inputDescription" />
       </form>
     </file>
 * </example>
 *
 * ## Binding to a getter/setter
 *
 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
 * function that returns a representation of the model when called with zero arguments, and sets
 * the internal state of a model when called with an argument. It's sometimes useful to use this
 * for models that have an internal representation that's different from what the model exposes
 * to the view.
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
 * frequently than other parts of your code.
 * </div>
 *
 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
 *
 * The following example shows how to use `ngModel` with a getter/setter:
 *
 * @example
 * <example name="ngModel-getter-setter" module="getterSetterExample">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <form name="userForm">
           <label>Name:
             <input type="text" name="userName"
                    ng-model="user.name"
                    ng-model-options="{ getterSetter: true }" />
           </label>
         </form>
         <pre>user.name = <span ng-bind="user.name()"></span></pre>
       </div>
     </file>
     <file name="app.js">
       angular.module('getterSetterExample', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var _name = 'Brian';
           $scope.user = {
             name: function(newName) {
              // Note that newName can be undefined for two reasons:
              // 1. Because it is called as a getter and thus called with no arguments
              // 2. Because the property should actually be set to undefined. This happens e.g. if the
              //    input is invalid
              return arguments.length ? (_name = newName) : _name;
             }
           };
         }]);
     </file>
 * </example>
 */
var ngModelDirective = ['$rootScope', function($rootScope) {
  return {
    restrict: 'A',
    require: ['ngModel', '^?form', '^?ngModelOptions'],
    controller: NgModelController,
    // Prelink needs to run before any input directive
    // so that we can set the NgModelOptions in NgModelController
    // before anyone else uses it.
    priority: 1,
    compile: function ngModelCompile(element) {
      // Setup initial state of the control
      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);

      return {
        pre: function ngModelPreLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0],
              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
              optionsCtrl = ctrls[2];

          if (optionsCtrl) {
            modelCtrl.$options = optionsCtrl.$options;
          }

          modelCtrl.$$initGetterSetters();

          // notify others, especially parent forms
          formCtrl.$addControl(modelCtrl);

          attr.$observe('name', function(newValue) {
            if (modelCtrl.$name !== newValue) {
              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
            }
          });

          scope.$on('$destroy', function() {
            modelCtrl.$$parentForm.$removeControl(modelCtrl);
          });
        },
        post: function ngModelPostLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0];
          if (modelCtrl.$options.getOption('updateOn')) {
            element.on(modelCtrl.$options.getOption('updateOn'), function(ev) {
              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
            });
          }

          function setTouched() {
            modelCtrl.$setTouched();
          }

          element.on('blur', function() {
            if (modelCtrl.$touched) return;

            if ($rootScope.$$phase) {
              scope.$evalAsync(setTouched);
            } else {
              scope.$apply(setTouched);
            }
          });
        }
      };
    }
  };
}];

/* exported defaultModelOptions */
var defaultModelOptions;
var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;

/**
 * @ngdoc type
 * @name ModelOptions
 * @description
 * A container for the options set by the {@link ngModelOptions} directive
 */
function ModelOptions(options) {
  this.$$options = options;
}

ModelOptions.prototype = {

  /**
   * @ngdoc method
   * @name ModelOptions#getOption
   * @param {string} name the name of the option to retrieve
   * @returns {*} the value of the option
   * @description
   * Returns the value of the given option
   */
  getOption: function(name) {
    return this.$$options[name];
  },

  /**
   * @ngdoc method
   * @name ModelOptions#createChild
   * @param {Object} options a hash of options for the new child that will override the parent's options
   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
   */
  createChild: function(options) {
    var inheritAll = false;

    // make a shallow copy
    options = extend({}, options);

    // Inherit options from the parent if specified by the value `"$inherit"`
    forEach(options, /* @this */ function(option, key) {
      if (option === '$inherit') {
        if (key === '*') {
          inheritAll = true;
        } else {
          options[key] = this.$$options[key];
          // `updateOn` is special so we must also inherit the `updateOnDefault` option
          if (key === 'updateOn') {
            options.updateOnDefault = this.$$options.updateOnDefault;
          }
        }
      } else {
        if (key === 'updateOn') {
          // If the `updateOn` property contains the `default` event then we have to remove
          // it from the event list and set the `updateOnDefault` flag.
          options.updateOnDefault = false;
          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
            options.updateOnDefault = true;
            return ' ';
          }));
        }
      }
    }, this);

    if (inheritAll) {
      // We have a property of the form: `"*": "$inherit"`
      delete options['*'];
      defaults(options, this.$$options);
    }

    // Finally add in any missing defaults
    defaults(options, defaultModelOptions.$$options);

    return new ModelOptions(options);
  }
};


defaultModelOptions = new ModelOptions({
  updateOn: '',
  updateOnDefault: true,
  debounce: 0,
  getterSetter: false,
  allowInvalid: false,
  timezone: null
});


/**
 * @ngdoc directive
 * @name ngModelOptions
 *
 * @description
 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
 * directives will use the options of their nearest `ngModelOptions` ancestor.
 *
 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
 * an Angular expression. This expression should evaluate to an object, whose properties contain
 * the settings. For example: `<div "ng-model-options"="{ debounce: 100 }"`.
 *
 * ## Inheriting Options
 *
 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
 * directive by giving it the value of `"$inherit"`.
 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
 * will be used.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
 * ```
 *
 * Notice that the `debounce` setting was not inherited and used the default value instead.
 *
 * You can specify that all undefined settings are automatically inherited from an ancestor by
 * including a property with key of `"*"` and value of `"$inherit"`.
 *
 * For example given the following fragment of HTML
 *
 *
 * ```html
 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
 *   </form>
 * </div>
 * ```
 *
 * the `input` element will have the following settings
 *
 * ```js
 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
 * ```
 *
 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
 *
 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
 *
 *
 * ## Triggering and debouncing model updates
 *
 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
 * a timer expires; this timer will be reset after another change takes place.
 *
 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
 * be different from the value in the actual model. This means that if you update the model you
 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
 * order to make sure it is synchronized with the model and that any debounced action is canceled.
 *
 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
 * important because `form` controllers are published to the related scope under the name in their
 * `name` attribute.
 *
 * Any pending changes will take place immediately when an enclosing form is submitted via the
 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * The following example shows how to override immediate updates. Changes on the inputs within the
 * form will update the model only when the control loses focus (blur event). If `escape` key is
 * pressed while the input field is focused, the value is reset to the value in the current model.
 *
 * <example name="ngModelOptions-directive-blur" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ updateOn: 'blur' }"
 *                  ng-keyup="cancel($event)" />
 *         </label><br />
 *         <label>
 *           Other data:
 *           <input type="text" ng-model="user.data" />
 *         </label><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say', data: '' };
 *
 *         $scope.cancel = function(e) {
 *           if (e.keyCode === 27) {
 *             $scope.userForm.userName.$rollbackViewValue();
 *           }
 *         };
 *       }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var model = element(by.binding('user.name'));
 *     var input = element(by.model('user.name'));
 *     var other = element(by.model('user.data'));
 *
 *     it('should allow custom events', function() {
 *       input.sendKeys(' hello');
 *       input.click();
 *       expect(model.getText()).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say hello');
 *     });
 *
 *     it('should $rollbackViewValue when model changes', function() {
 *       input.sendKeys(' hello');
 *       expect(input.getAttribute('value')).toEqual('say hello');
 *       input.sendKeys(protractor.Key.ESCAPE);
 *       expect(input.getAttribute('value')).toEqual('say');
 *       other.click();
 *       expect(model.getText()).toEqual('say');
 *     });
 *   </file>
 * </example>
 *
 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
 *
 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         Name:
 *         <input type="text" name="userName"
 *                ng-model="user.name"
 *                ng-model-options="{ debounce: 1000 }" />
 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('optionsExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.user = { name: 'say' };
 *       }]);
 *   </file>
 * </example>
 *
 * ## Model updates and validation
 *
 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
 * the model will still be updated even if the value is invalid.
 *
 *
 * ## Connecting to the scope
 *
 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
 * on the scope refers to a "getter/setter" function rather than the value itself.
 *
 * The following example shows how to bind to getter/setters:
 *
 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
 *   <file name="index.html">
 *     <div ng-controller="ExampleController">
 *       <form name="userForm">
 *         <label>
 *           Name:
 *           <input type="text" name="userName"
 *                  ng-model="user.name"
 *                  ng-model-options="{ getterSetter: true }" />
 *         </label>
 *       </form>
 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *     angular.module('getterSetterExample', [])
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         var _name = 'Brian';
 *         $scope.user = {
 *           name: function(newName) {
 *             return angular.isDefined(newName) ? (_name = newName) : _name;
 *           }
 *         };
 *       }]);
 *   </file>
 * </example>
 *
 *
 * ## Specifying timezones
 *
 * You can specify the timezone that date/time input directives expect by providing its name in the
 * `timezone` property.
 *
 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
 *   and its descendents. Valid keys are:
 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
 *     events using an space delimited list. There is a special event called `default` that
 *     matches the default events belonging to the control.
 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
 *     custom value for each event. For example:
 *     ```
 *     ng-model-options="{
 *       updateOn: 'default blur',
 *       debounce: { 'default': 500, 'blur': 0 }
 *     }"
 *     ```
 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
 *     not validate correctly instead of the default behavior of setting the model to undefined.
 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
 *     `ngModel` as getters/setters.
 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *     If not specified, the timezone of the browser will be used.
 *
 */
var ngModelOptionsDirective = function() {
  NgModelOptionsController.$inject = ['$attrs', '$scope'];
  function NgModelOptionsController($attrs, $scope) {
    this.$$attrs = $attrs;
    this.$$scope = $scope;
  }
  NgModelOptionsController.prototype = {
    $onInit: function() {
      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);

      this.$options = parentOptions.createChild(modelOptionsDefinition);
    }
  };

  return {
    restrict: 'A',
    // ngModelOptions needs to run before ngModel and input directives
    priority: 10,
    require: {parentCtrl: '?^^ngModelOptions'},
    bindToController: true,
    controller: NgModelOptionsController
  };
};


// shallow copy over values from `src` that are not already specified on `dst`
function defaults(dst, src) {
  forEach(src, function(value, key) {
    if (!isDefined(dst[key])) {
      dst[key] = value;
    }
  });
}

/**
 * @ngdoc directive
 * @name ngNonBindable
 * @restrict AC
 * @priority 1000
 *
 * @description
 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
 * DOM element. This is useful if the element contains what appears to be Angular directives and
 * bindings but which should be ignored by Angular. This could be the case if you have a site that
 * displays snippets of code, for instance.
 *
 * @element ANY
 *
 * @example
 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
 * but the one wrapped in `ngNonBindable` is left alone.
 *
 * @example
    <example name="ng-non-bindable">
      <file name="index.html">
        <div>Normal: {{1 + 2}}</div>
        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
      </file>
      <file name="protractor.js" type="protractor">
       it('should check ng-non-bindable', function() {
         expect(element(by.binding('1 + 2')).getText()).toContain('3');
         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
       });
      </file>
    </example>
 */
var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });

/* exported ngOptionsDirective */

/* global jqLiteRemove */

var ngOptionsMinErr = minErr('ngOptions');

/**
 * @ngdoc directive
 * @name ngOptions
 * @restrict A
 *
 * @description
 *
 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
 * elements for the `<select>` element using the array or object obtained by evaluating the
 * `ngOptions` comprehension expression.
 *
 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * When an item in the `<select>` menu is selected, the array element or object property
 * represented by the selected option will be bound to the model identified by the `ngModel`
 * directive.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding the select to a model that is an object or a collection.
 *
 * One issue occurs if you want to preselect an option. For example, if you set
 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
 * because the objects are not identical. So by default, you should always reference the item in your collection
 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
 *
 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
 * of the item not by reference, but by the result of the `track by` expression. For example, if your
 * collection items have an id property, you would `track by item.id`.
 *
 * A different issue with objects or collections is that ngModel won't detect if an object property or
 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
 * has not changed identity, but only a property on the object or an item in the collection changes.
 *
 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
 * if the model is an array). This means that changing a property deeper than the first level inside the
 * object/collection will not trigger a re-rendering.
 *
 * ## `select` **`as`**
 *
 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
 *
 *
 * ### `select` **`as`** and **`track by`**
 *
 * <div class="alert alert-warning">
 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
 * </div>
 *
 * Given this array of items on the $scope:
 *
 * ```js
 * $scope.items = [{
 *   id: 1,
 *   label: 'aLabel',
 *   subItem: { name: 'aSubItem' }
 * }, {
 *   id: 2,
 *   label: 'bLabel',
 *   subItem: { name: 'bSubItem' }
 * }];
 * ```
 *
 * This will work:
 *
 * ```html
 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0];
 * ```
 *
 * but this will not work:
 *
 * ```html
 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0].subItem;
 * ```
 *
 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
 * `items` array. Because the selected option has been set programmatically in the controller, the
 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
 *
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required The control is considered valid only if value is entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {comprehension_expression=} ngOptions in one of the following forms:
 *
 *   * for array data sources:
 *     * `label` **`for`** `value` **`in`** `array`
 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
 *        (for including a filter with `track by`)
 *   * for object data sources:
 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`group by`** `group`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`disable when`** `disable`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *
 * Where:
 *
 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
 *   * `value`: local variable which will refer to each item in the `array` or each property value
 *      of `object` during iteration.
 *   * `key`: local variable which will refer to a property name in `object` during iteration.
 *   * `label`: The result of this expression will be the label for `<option>` element. The
 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
 *      element. If not specified, `select` expression will default to `value`.
 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
 *      DOM element.
 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
 *      element. Return `true` to disable.
 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
 *      even when the options are recreated (e.g. reloaded from the server).
 *
 * @example
    <example module="selectExample" name="select">
      <file name="index.html">
        <script>
        angular.module('selectExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.colors = [
              {name:'black', shade:'dark'},
              {name:'white', shade:'light', notAnOption: true},
              {name:'red', shade:'dark'},
              {name:'blue', shade:'dark', notAnOption: true},
              {name:'yellow', shade:'light', notAnOption: false}
            ];
            $scope.myColor = $scope.colors[2]; // red
          }]);
        </script>
        <div ng-controller="ExampleController">
          <ul>
            <li ng-repeat="color in colors">
              <label>Name: <input ng-model="color.name"></label>
              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
            </li>
            <li>
              <button ng-click="colors.push({})">add</button>
            </li>
          </ul>
          <hr/>
          <label>Color (null not allowed):
            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
          </label><br/>
          <label>Color (null allowed):
          <span  class="nullable">
            <select ng-model="myColor" ng-options="color.name for color in colors">
              <option value="">-- choose color --</option>
            </select>
          </span></label><br/>

          <label>Color grouped by shade:
            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
            </select>
          </label><br/>

          <label>Color grouped by shade, with some disabled:
            <select ng-model="myColor"
                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
            </select>
          </label><br/>



          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
          <br/>
          <hr/>
          Currently selected: {{ {selected_color:myColor} }}
          <div style="border:solid 1px black; height:20px"
               ng-style="{'background-color':myColor.name}">
          </div>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
         it('should check ng-options', function() {
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
           element.all(by.model('myColor')).first().click();
           element.all(by.css('select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
           element(by.css('.nullable select[ng-model="myColor"]')).click();
           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
         });
      </file>
    </example>
 */

/* eslint-disable max-len */
//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
                        // 1: value expression (valueFn)
                        // 2: label expression (displayFn)
                        // 3: group by expression (groupByFn)
                        // 4: disable when expression (disableWhenFn)
                        // 5: array item variable name
                        // 6: object item key variable name
                        // 7: object item value variable name
                        // 8: collection expression
                        // 9: track by expression
/* eslint-enable */


var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {

  function parseOptionsExpression(optionsExp, selectElement, scope) {

    var match = optionsExp.match(NG_OPTIONS_REGEXP);
    if (!(match)) {
      throw ngOptionsMinErr('iexp',
        'Expected expression in form of ' +
        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
        ' but got \'{0}\'. Element: {1}',
        optionsExp, startingTag(selectElement));
    }

    // Extract the parts from the ngOptions expression

    // The variable name for the value of the item in the collection
    var valueName = match[5] || match[7];
    // The variable name for the key of the item in the collection
    var keyName = match[6];

    // An expression that generates the viewValue for an option if there is a label expression
    var selectAs = / as /.test(match[0]) && match[1];
    // An expression that is used to track the id of each object in the options collection
    var trackBy = match[9];
    // An expression that generates the viewValue for an option if there is no label expression
    var valueFn = $parse(match[2] ? match[1] : valueName);
    var selectAsFn = selectAs && $parse(selectAs);
    var viewValueFn = selectAsFn || valueFn;
    var trackByFn = trackBy && $parse(trackBy);

    // Get the value by which we are going to track the option
    // if we have a trackFn then use that (passing scope and locals)
    // otherwise just hash the given viewValue
    var getTrackByValueFn = trackBy ?
                              function(value, locals) { return trackByFn(scope, locals); } :
                              function getHashOfValue(value) { return hashKey(value); };
    var getTrackByValue = function(value, key) {
      return getTrackByValueFn(value, getLocals(value, key));
    };

    var displayFn = $parse(match[2] || match[1]);
    var groupByFn = $parse(match[3] || '');
    var disableWhenFn = $parse(match[4] || '');
    var valuesFn = $parse(match[8]);

    var locals = {};
    var getLocals = keyName ? function(value, key) {
      locals[keyName] = key;
      locals[valueName] = value;
      return locals;
    } : function(value) {
      locals[valueName] = value;
      return locals;
    };


    function Option(selectValue, viewValue, label, group, disabled) {
      this.selectValue = selectValue;
      this.viewValue = viewValue;
      this.label = label;
      this.group = group;
      this.disabled = disabled;
    }

    function getOptionValuesKeys(optionValues) {
      var optionValuesKeys;

      if (!keyName && isArrayLike(optionValues)) {
        optionValuesKeys = optionValues;
      } else {
        // if object, extract keys, in enumeration order, unsorted
        optionValuesKeys = [];
        for (var itemKey in optionValues) {
          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
            optionValuesKeys.push(itemKey);
          }
        }
      }
      return optionValuesKeys;
    }

    return {
      trackBy: trackBy,
      getTrackByValue: getTrackByValue,
      getWatchables: $parse(valuesFn, function(optionValues) {
        // Create a collection of things that we would like to watch (watchedArray)
        // so that they can all be watched using a single $watchCollection
        // that only runs the handler once if anything changes
        var watchedArray = [];
        optionValues = optionValues || [];

        var optionValuesKeys = getOptionValuesKeys(optionValues);
        var optionValuesLength = optionValuesKeys.length;
        for (var index = 0; index < optionValuesLength; index++) {
          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
          var value = optionValues[key];

          var locals = getLocals(value, key);
          var selectValue = getTrackByValueFn(value, locals);
          watchedArray.push(selectValue);

          // Only need to watch the displayFn if there is a specific label expression
          if (match[2] || match[1]) {
            var label = displayFn(scope, locals);
            watchedArray.push(label);
          }

          // Only need to watch the disableWhenFn if there is a specific disable expression
          if (match[4]) {
            var disableWhen = disableWhenFn(scope, locals);
            watchedArray.push(disableWhen);
          }
        }
        return watchedArray;
      }),

      getOptions: function() {

        var optionItems = [];
        var selectValueMap = {};

        // The option values were already computed in the `getWatchables` fn,
        // which must have been called to trigger `getOptions`
        var optionValues = valuesFn(scope) || [];
        var optionValuesKeys = getOptionValuesKeys(optionValues);
        var optionValuesLength = optionValuesKeys.length;

        for (var index = 0; index < optionValuesLength; index++) {
          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
          var value = optionValues[key];
          var locals = getLocals(value, key);
          var viewValue = viewValueFn(scope, locals);
          var selectValue = getTrackByValueFn(viewValue, locals);
          var label = displayFn(scope, locals);
          var group = groupByFn(scope, locals);
          var disabled = disableWhenFn(scope, locals);
          var optionItem = new Option(selectValue, viewValue, label, group, disabled);

          optionItems.push(optionItem);
          selectValueMap[selectValue] = optionItem;
        }

        return {
          items: optionItems,
          selectValueMap: selectValueMap,
          getOptionFromViewValue: function(value) {
            return selectValueMap[getTrackByValue(value)];
          },
          getViewValueFromOption: function(option) {
            // If the viewValue could be an object that may be mutated by the application,
            // we need to make a copy and not return the reference to the value on the option.
            return trackBy ? copy(option.viewValue) : option.viewValue;
          }
        };
      }
    };
  }


  // we can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  var optionTemplate = window.document.createElement('option'),
      optGroupTemplate = window.document.createElement('optgroup');

    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];
      var multiple = attr.multiple;

      // The emptyOption allows the application developer to provide their own custom "empty"
      // option when the viewValue does not match any of the option values.
      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
        if (children[i].value === '') {
          selectCtrl.hasEmptyOption = true;
          selectCtrl.emptyOption = children.eq(i);
          break;
        }
      }

      var providedEmptyOption = !!selectCtrl.emptyOption;

      var unknownOption = jqLite(optionTemplate.cloneNode(false));
      unknownOption.val('?');

      var options;
      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
      // This stores the newly created options before they are appended to the select.
      // Since the contents are removed from the fragment when it is appended,
      // we only need to create it once.
      var listFragment = $document[0].createDocumentFragment();

      // Overwrite the implementation. ngOptions doesn't use hashes
      selectCtrl.generateUnknownOptionValue = function(val) {
        return '?';
      };

      // Update the controller methods for multiple selectable options
      if (!multiple) {

        selectCtrl.writeValue = function writeNgOptionsValue(value) {
          var selectedOption = options.selectValueMap[selectElement.val()];
          var option = options.getOptionFromViewValue(value);

          // Make sure to remove the selected attribute from the previously selected option
          // Otherwise, screen readers might get confused
          if (selectedOption) selectedOption.element.removeAttribute('selected');

          if (option) {
            // Don't update the option when it is already selected.
            // For example, the browser will select the first option by default. In that case,
            // most properties are set automatically - except the `selected` attribute, which we
            // set always

            if (selectElement[0].value !== option.selectValue) {
              selectCtrl.removeUnknownOption();
              selectCtrl.unselectEmptyOption();

              selectElement[0].value = option.selectValue;
              option.element.selected = true;
            }

            option.element.setAttribute('selected', 'selected');
          } else {

            if (providedEmptyOption) {
              selectCtrl.selectEmptyOption();
            } else if (selectCtrl.unknownOption.parent().length) {
              selectCtrl.updateUnknownOption(value);
            } else {
              selectCtrl.renderUnknownOption(value);
            }
          }
        };

        selectCtrl.readValue = function readNgOptionsValue() {

          var selectedOption = options.selectValueMap[selectElement.val()];

          if (selectedOption && !selectedOption.disabled) {
            selectCtrl.unselectEmptyOption();
            selectCtrl.removeUnknownOption();
            return options.getViewValueFromOption(selectedOption);
          }
          return null;
        };

        // If we are using `track by` then we must watch the tracked value on the model
        // since ngModel only watches for object identity change
        // FIXME: When a user selects an option, this watch will fire needlessly
        if (ngOptions.trackBy) {
          scope.$watch(
            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
            function() { ngModelCtrl.$render(); }
          );
        }

      } else {

        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.

          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];

          options.items.forEach(function(option) {
            if (option.element.selected && !includes(selectedOptions, option)) {
              option.element.selected = false;
            }
          });
        };


        selectCtrl.readValue = function readNgOptionsMultiple() {
          var selectedValues = selectElement.val() || [],
              selections = [];

          forEach(selectedValues, function(value) {
            var option = options.selectValueMap[value];
            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
          });

          return selections;
        };

        // If we are using `track by` then we must watch these tracked values on the model
        // since ngModel only watches for object identity change
        if (ngOptions.trackBy) {

          scope.$watchCollection(function() {
            if (isArray(ngModelCtrl.$viewValue)) {
              return ngModelCtrl.$viewValue.map(function(value) {
                return ngOptions.getTrackByValue(value);
              });
            }
          }, function() {
            ngModelCtrl.$render();
          });

        }
      }

      if (providedEmptyOption) {

        // we need to remove it before calling selectElement.empty() because otherwise IE will
        // remove the label from the element. wtf?
        selectCtrl.emptyOption.remove();

        // compile the element since there might be bindings in it
        $compile(selectCtrl.emptyOption)(scope);

        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
          // This means the empty option has currently no actual DOM node, probably because
          // it has been modified by a transclusion directive.
          selectCtrl.hasEmptyOption = false;

          // Redefine the registerOption function, which will catch
          // options that are added by ngIf etc. (rendering of the node is async because of
          // lazy transclusion)
          selectCtrl.registerOption = function(optionScope, optionEl) {
            if (optionEl.val() === '') {
              selectCtrl.hasEmptyOption = true;
              selectCtrl.emptyOption = optionEl;
              selectCtrl.emptyOption.removeClass('ng-scope');
              // This ensures the new empty option is selected if previously no option was selected
              ngModelCtrl.$render();

              optionEl.on('$destroy', function() {
                selectCtrl.hasEmptyOption = false;
                selectCtrl.emptyOption = undefined;
              });
            }
          };

        } else {
          // remove the class, which is added automatically because we recompile the element and it
          // becomes the compilation root
          selectCtrl.emptyOption.removeClass('ng-scope');
        }

      }

      selectElement.empty();

      // We need to do this here to ensure that the options object is defined
      // when we first hit it in writeNgOptionsValue
      updateOptions();

      // We will re-render the option elements if the option values or labels change
      scope.$watchCollection(ngOptions.getWatchables, updateOptions);

      // ------------------------------------------------------------------ //

      function addOptionElement(option, parent) {
        var optionElement = optionTemplate.cloneNode(false);
        parent.appendChild(optionElement);
        updateOptionElement(option, optionElement);
      }

      function getAndUpdateSelectedOption(viewValue) {
        var option = options.getOptionFromViewValue(viewValue);
        var element = option && option.element;

        if (element && !element.selected) element.selected = true;

        return option;
      }

      function updateOptionElement(option, element) {
        option.element = element;
        element.disabled = option.disabled;
        // NOTE: The label must be set before the value, otherwise IE10/11/EDGE create unresponsive
        // selects in certain circumstances when multiple selects are next to each other and display
        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
        // See https://github.com/angular/angular.js/issues/11314 for more info.
        // This is unfortunately untestable with unit / e2e tests
        if (option.label !== element.label) {
          element.label = option.label;
          element.textContent = option.label;
        }
        element.value = option.selectValue;
      }

      function updateOptions() {
        var previousValue = options && selectCtrl.readValue();

        // We must remove all current options, but cannot simply set innerHTML = null
        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
        // must preserve.
        // Instead, iterate over the current option elements and remove them or their optgroup
        // parents
        if (options) {

          for (var i = options.items.length - 1; i >= 0; i--) {
            var option = options.items[i];
            if (isDefined(option.group)) {
              jqLiteRemove(option.element.parentNode);
            } else {
              jqLiteRemove(option.element);
            }
          }
        }

        options = ngOptions.getOptions();

        var groupElementMap = {};

        // Ensure that the empty option is always there if it was explicitly provided
        if (providedEmptyOption) {
          selectElement.prepend(selectCtrl.emptyOption);
        }

        options.items.forEach(function addOption(option) {
          var groupElement;

          if (isDefined(option.group)) {

            // This option is to live in a group
            // See if we have already created this group
            groupElement = groupElementMap[option.group];

            if (!groupElement) {

              groupElement = optGroupTemplate.cloneNode(false);
              listFragment.appendChild(groupElement);

              // Update the label on the group element
              // "null" is special cased because of Safari
              groupElement.label = option.group === null ? 'null' : option.group;

              // Store it for use later
              groupElementMap[option.group] = groupElement;
            }

            addOptionElement(option, groupElement);

          } else {

            // This option is not in a group
            addOptionElement(option, listFragment);
          }
        });

        selectElement[0].appendChild(listFragment);

        ngModelCtrl.$render();

        // Check to see if the value has changed due to the update to the options
        if (!ngModelCtrl.$isEmpty(previousValue)) {
          var nextValue = selectCtrl.readValue();
          var isNotPrimitive = ngOptions.trackBy || multiple;
          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
            ngModelCtrl.$setViewValue(nextValue);
            ngModelCtrl.$render();
          }
        }

      }
  }

  return {
    restrict: 'A',
    terminal: true,
    require: ['select', 'ngModel'],
    link: {
      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
        // Deactivate the SelectController.register method to prevent
        // option directives from accidentally registering themselves
        // (and unwanted $destroy handlers etc.)
        ctrls[0].registerOption = noop;
      },
      post: ngOptionsPostLink
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngPluralize
 * @restrict EA
 *
 * @description
 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
 * These rules are bundled with angular.js, but can be overridden
 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
 * by specifying the mappings between
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * and the strings to be displayed.
 *
 * # Plural categories and explicit number rules
 * There are two
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * in Angular's default en-US locale: "one" and "other".
 *
 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
 * any number that is not 1), an explicit number rule can only match one number. For example, the
 * explicit number rule for "3" matches the number 3. There are examples of plural categories
 * and explicit number rules throughout the rest of this documentation.
 *
 * # Configuring ngPluralize
 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
 * You can also provide an optional attribute, `offset`.
 *
 * The value of the `count` attribute can be either a string or an {@link guide/expression
 * Angular expression}; these are evaluated on the current scope for its bound value.
 *
 * The `when` attribute specifies the mappings between plural categories and the actual
 * string to be displayed. The value of the attribute should be a JSON object.
 *
 * The following example shows how to configure ngPluralize:
 *
 * ```html
 * <ng-pluralize count="personCount"
                 when="{'0': 'Nobody is viewing.',
 *                      'one': '1 person is viewing.',
 *                      'other': '{} people are viewing.'}">
 * </ng-pluralize>
 *```
 *
 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
 * show "a dozen people are viewing".
 *
 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
 * into pluralized strings. In the previous example, Angular will replace `{}` with
 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
 * for <span ng-non-bindable>{{numberExpression}}</span>.
 *
 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
 *
 * # Configuring ngPluralize with offset
 * The `offset` attribute allows further customization of pluralized text, which can result in
 * a better user experience. For example, instead of the message "4 people are viewing this document",
 * you might display "John, Kate and 2 others are viewing this document".
 * The offset attribute allows you to offset a number by any desired value.
 * Let's take a look at an example:
 *
 * ```html
 * <ng-pluralize count="personCount" offset=2
 *               when="{'0': 'Nobody is viewing.',
 *                      '1': '{{person1}} is viewing.',
 *                      '2': '{{person1}} and {{person2}} are viewing.',
 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
 * </ng-pluralize>
 * ```
 *
 * Notice that we are still using two plural categories(one, other), but we added
 * three explicit number rules 0, 1 and 2.
 * When one person, perhaps John, views the document, "John is viewing" will be shown.
 * When three people view the document, no explicit number rule is found, so
 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
 * is shown.
 *
 * Note that when you specify offsets, you must provide explicit number rules for
 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
 * plural categories "one" and "other".
 *
 * @param {string|expression} count The variable to be bound to.
 * @param {string} when The mapping between plural category to its corresponding strings.
 * @param {number=} offset Offset to deduct from the total number.
 *
 * @example
    <example module="pluralizeExample" name="ng-pluralize">
      <file name="index.html">
        <script>
          angular.module('pluralizeExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.person1 = 'Igor';
              $scope.person2 = 'Misko';
              $scope.personCount = 1;
            }]);
        </script>
        <div ng-controller="ExampleController">
          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>

          <!--- Example with simple pluralization rules for en locale --->
          Without Offset:
          <ng-pluralize count="personCount"
                        when="{'0': 'Nobody is viewing.',
                               'one': '1 person is viewing.',
                               'other': '{} people are viewing.'}">
          </ng-pluralize><br>

          <!--- Example with offset --->
          With Offset(2):
          <ng-pluralize count="personCount" offset=2
                        when="{'0': 'Nobody is viewing.',
                               '1': '{{person1}} is viewing.',
                               '2': '{{person1}} and {{person2}} are viewing.',
                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
          </ng-pluralize>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
        it('should show correct pluralized string', function() {
          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var countInput = element(by.model('personCount'));

          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
          expect(withOffset.getText()).toEqual('Igor is viewing.');

          countInput.clear();
          countInput.sendKeys('0');

          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
          expect(withOffset.getText()).toEqual('Nobody is viewing.');

          countInput.clear();
          countInput.sendKeys('2');

          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');

          countInput.clear();
          countInput.sendKeys('3');

          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');

          countInput.clear();
          countInput.sendKeys('4');

          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
        });
        it('should show data-bound names', function() {
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var personCount = element(by.model('personCount'));
          var person1 = element(by.model('person1'));
          var person2 = element(by.model('person2'));
          personCount.clear();
          personCount.sendKeys('4');
          person1.clear();
          person1.sendKeys('Di');
          person2.clear();
          person2.sendKeys('Vojta');
          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
        });
      </file>
    </example>
 */
var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
  var BRACE = /{}/g,
      IS_WHEN = /^when(Minus)?(.+)$/;

  return {
    link: function(scope, element, attr) {
      var numberExp = attr.count,
          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
          offset = attr.offset || 0,
          whens = scope.$eval(whenExp) || {},
          whensExpFns = {},
          startSymbol = $interpolate.startSymbol(),
          endSymbol = $interpolate.endSymbol(),
          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
          watchRemover = angular.noop,
          lastCount;

      forEach(attr, function(expression, attributeName) {
        var tmpMatch = IS_WHEN.exec(attributeName);
        if (tmpMatch) {
          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
          whens[whenKey] = element.attr(attr.$attr[attributeName]);
        }
      });
      forEach(whens, function(expression, key) {
        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));

      });

      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
        var count = parseFloat(newVal);
        var countIsNaN = isNumberNaN(count);

        if (!countIsNaN && !(count in whens)) {
          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
          // Otherwise, check it against pluralization rules in $locale service.
          count = $locale.pluralCat(count - offset);
        }

        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
        // In JS `NaN !== NaN`, so we have to explicitly check.
        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
          watchRemover();
          var whenExpFn = whensExpFns[count];
          if (isUndefined(whenExpFn)) {
            if (newVal != null) {
              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
            }
            watchRemover = noop;
            updateElementText();
          } else {
            watchRemover = scope.$watch(whenExpFn, updateElementText);
          }
          lastCount = count;
        }
      });

      function updateElementText(newText) {
        element.text(newText || '');
      }
    }
  };
}];

/* exported ngRepeatDirective */

/**
 * @ngdoc directive
 * @name ngRepeat
 * @multiElement
 *
 * @description
 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
 * instance gets its own scope, where the given loop variable is set to the current collection item,
 * and `$index` is set to the item index or key.
 *
 * Special properties are exposed on the local scope of each template instance, including:
 *
 * | Variable  | Type            | Details                                                                     |
 * |-----------|-----------------|-----------------------------------------------------------------------------|
 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
 *
 * <div class="alert alert-info">
 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
 *   This may be useful when, for instance, nesting ngRepeats.
 * </div>
 *
 *
 * # Iterating over object properties
 *
 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
 * syntax:
 *
 * ```js
 * <div ng-repeat="(key, value) in myObj"> ... </div>
 * ```
 *
 * However, there are a few limitations compared to array iteration:
 *
 * - The JavaScript specification does not define the order of keys
 *   returned for an object, so Angular relies on the order returned by the browser
 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
 *   and reinstated. See the
 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
 *
 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
 *   it's a prefix used by Angular for public (`$`) and private (`$$`) properties.
 *
 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
 *   objects, and will throw an error if used with one.
 *
 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
 * or implement a `$watch` on the object yourself.
 *
 *
 * # Tracking and Duplicates
 *
 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
 *
 * * When an item is added, a new instance of the template is added to the DOM.
 * * When an item is removed, its template instance is removed from the DOM.
 * * When items are reordered, their respective templates are reordered in the DOM.
 *
 * To minimize creation of DOM elements, `ngRepeat` uses a function
 * to "keep track" of all items in the collection and their corresponding DOM elements.
 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
 * already have DOM elements, and will not re-render them.
 *
 * The default tracking function (which tracks items by their identity) does not allow
 * duplicate items in arrays. This is because when there are duplicates, it is not possible
 * to maintain a one-to-one mapping between collection items and DOM elements.
 *
 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
 * with your own using the `track by` expression.
 *
 * For example, you may track items by the index of each item in the collection, using the
 * special scope property `$index`:
 * ```html
 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
 *      {{n}}
 *    </div>
 * ```
 *
 * You may also use arbitrary expressions in `track by`, including references to custom functions
 * on the scope:
 * ```html
 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
 *      {{n}}
 *    </div>
 * ```
 *
 * <div class="alert alert-success">
 * If you are working with objects that have a unique identifier property, you should track
 * by this identifier instead of the object instance. Should you reload your data later, `ngRepeat`
 * will not have to rebuild the DOM elements for items it has already rendered, even if the
 * JavaScript objects in the collection have been substituted for new ones. For large collections,
 * this significantly improves rendering performance. If you don't have a unique identifier,
 * `track by $index` can also provide a performance boost.
 * </div>
 *
 * ```html
 *    <div ng-repeat="model in collection track by model.id">
 *      {{model.name}}
 *    </div>
 * ```
 *
 * <br />
 * <div class="alert alert-warning">
 * Avoid using `track by $index` when the repeated template contains
 * {@link guide/expression#one-time-binding one-time bindings}. In such cases, the `nth` DOM
 * element will always be matched with the `nth` item of the array, so the bindings on that element
 * will not be updated even when the corresponding item changes, essentially causing the view to get
 * out-of-sync with the underlying data.
 * </div>
 *
 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
 * `$id` function, which tracks items by their identity:
 * ```html
 *    <div ng-repeat="obj in collection track by $id(obj)">
 *      {{obj.prop}}
 *    </div>
 * ```
 *
 * <br />
 * <div class="alert alert-warning">
 * **Note:** `track by` must always be the last expression:
 * </div>
 * ```
 *    <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
 *      {{model.name}}
 *    </div>
 * ```
 *
 *
 * # Special repeat start and end points
 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
 *
 * The example below makes use of this feature:
 * ```html
 *   <header ng-repeat-start="item in items">
 *     Header {{ item }}
 *   </header>
 *   <div class="body">
 *     Body {{ item }}
 *   </div>
 *   <footer ng-repeat-end>
 *     Footer {{ item }}
 *   </footer>
 * ```
 *
 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
 * ```html
 *   <header>
 *     Header A
 *   </header>
 *   <div class="body">
 *     Body A
 *   </div>
 *   <footer>
 *     Footer A
 *   </footer>
 *   <header>
 *     Header B
 *   </header>
 *   <div class="body">
 *     Body B
 *   </div>
 *   <footer>
 *     Footer B
 *   </footer>
 * ```
 *
 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
 *
 * See the example below for defining CSS animations with ngRepeat.
 *
 * @element ANY
 * @scope
 * @priority 1000
 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
 *   formats are currently supported:
 *
 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
 *     is a scope expression giving the collection to enumerate.
 *
 *     For example: `album in artist.albums`.
 *
 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
 *     and `expression` is the scope expression giving the collection to enumerate.
 *
 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
 *
 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
 *     is specified, ng-repeat associates elements by identity. It is an error to have
 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
 *     mapped to the same DOM element, which is not possible.)
 *
 *     Note that the tracking expression must come last, after any filters, and the alias expression.
 *
 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
 *     will be associated by item identity in the array.
 *
 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
 *     element in the same way in the DOM.
 *
 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
 *     property is same.
 *
 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
 *     to items in conjunction with a tracking expression.
 *
 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
 *     when a filter is active on the repeater, but the filtered result set is empty.
 *
 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
 *     the items have been processed through the filter.
 *
 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
 *     (and not as operator, inside an expression).
 *
 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
 *
 * @example
 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
 * results by name or by age. New (entering) and removed (leaving) items are animated.
  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true" name="ng-repeat">
    <file name="index.html">
      <div ng-controller="repeatController">
        I have {{friends.length}} friends. They are:
        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
          </li>
          <li class="animate-repeat" ng-if="results.length === 0">
            <strong>No results found...</strong>
          </li>
        </ul>
      </div>
    </file>
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        $scope.friends = [
          {name:'John', age:25, gender:'boy'},
          {name:'Jessie', age:30, gender:'girl'},
          {name:'Johanna', age:28, gender:'girl'},
          {name:'Joy', age:15, gender:'girl'},
          {name:'Mary', age:28, gender:'girl'},
          {name:'Peter', age:95, gender:'boy'},
          {name:'Sebastian', age:50, gender:'boy'},
          {name:'Erika', age:27, gender:'girl'},
          {name:'Patrick', age:40, gender:'boy'},
          {name:'Samantha', age:60, gender:'girl'}
        ];
      });
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var friends = element.all(by.repeater('friend in friends'));

      it('should render initial data set', function() {
        expect(friends.count()).toBe(10);
        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
        expect(element(by.binding('friends.length')).getText())
            .toMatch("I have 10 friends. They are:");
      });

       it('should update repeater when filter predicate changes', function() {
         expect(friends.count()).toBe(10);

         element(by.model('q')).sendKeys('ma');

         expect(friends.count()).toBe(2);
         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
       });
      </file>
    </example>
 */
var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
  var NG_REMOVED = '$$NG_REMOVED';
  var ngRepeatMinErr = minErr('ngRepeat');

  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
    scope[valueIdentifier] = value;
    if (keyIdentifier) scope[keyIdentifier] = key;
    scope.$index = index;
    scope.$first = (index === 0);
    scope.$last = (index === (arrayLength - 1));
    scope.$middle = !(scope.$first || scope.$last);
    // eslint-disable-next-line no-bitwise
    scope.$odd = !(scope.$even = (index & 1) === 0);
  };

  var getBlockStart = function(block) {
    return block.clone[0];
  };

  var getBlockEnd = function(block) {
    return block.clone[block.clone.length - 1];
  };


  return {
    restrict: 'A',
    multiElement: true,
    transclude: 'element',
    priority: 1000,
    terminal: true,
    $$tlb: true,
    compile: function ngRepeatCompile($element, $attr) {
      var expression = $attr.ngRepeat;
      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);

      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

      if (!match) {
        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
            expression);
      }

      var lhs = match[1];
      var rhs = match[2];
      var aliasAs = match[3];
      var trackByExp = match[4];

      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);

      if (!match) {
        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
            lhs);
      }
      var valueIdentifier = match[3] || match[1];
      var keyIdentifier = match[2];

      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
          aliasAs);
      }

      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
      var hashFnLocals = {$id: hashKey};

      if (trackByExp) {
        trackByExpGetter = $parse(trackByExp);
      } else {
        trackByIdArrayFn = function(key, value) {
          return hashKey(value);
        };
        trackByIdObjFn = function(key) {
          return key;
        };
      }

      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {

        if (trackByExpGetter) {
          trackByIdExpFn = function(key, value, index) {
            // assign key, value, and $index to the locals so that they can be used in hash functions
            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
            hashFnLocals[valueIdentifier] = value;
            hashFnLocals.$index = index;
            return trackByExpGetter($scope, hashFnLocals);
          };
        }

        // Store a list of elements from previous run. This is a hash where key is the item from the
        // iterator, and the value is objects with following properties.
        //   - scope: bound scope
        //   - element: previous element.
        //   - index: position
        //
        // We are using no-proto object so that we don't need to guard against inherited props via
        // hasOwnProperty.
        var lastBlockMap = createMap();

        //watch props
        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
          var index, length,
              previousNode = $element[0],     // node that cloned nodes should be inserted after
                                              // initialized to the comment node anchor
              nextNode,
              // Same as lastBlockMap but it has the current state. It will become the
              // lastBlockMap on the next iteration.
              nextBlockMap = createMap(),
              collectionLength,
              key, value, // key/value of iteration
              trackById,
              trackByIdFn,
              collectionKeys,
              block,       // last object information {scope, element, id}
              nextBlockOrder,
              elementsToRemove;

          if (aliasAs) {
            $scope[aliasAs] = collection;
          }

          if (isArrayLike(collection)) {
            collectionKeys = collection;
            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
          } else {
            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
            // if object, extract keys, in enumeration order, unsorted
            collectionKeys = [];
            for (var itemKey in collection) {
              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
                collectionKeys.push(itemKey);
              }
            }
          }

          collectionLength = collectionKeys.length;
          nextBlockOrder = new Array(collectionLength);

          // locate existing items
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            trackById = trackByIdFn(key, value, index);
            if (lastBlockMap[trackById]) {
              // found previously seen block
              block = lastBlockMap[trackById];
              delete lastBlockMap[trackById];
              nextBlockMap[trackById] = block;
              nextBlockOrder[index] = block;
            } else if (nextBlockMap[trackById]) {
              // if collision detected. restore lastBlockMap and throw an error
              forEach(nextBlockOrder, function(block) {
                if (block && block.scope) lastBlockMap[block.id] = block;
              });
              throw ngRepeatMinErr('dupes',
                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
                  expression, trackById, value);
            } else {
              // new never before seen block
              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
              nextBlockMap[trackById] = true;
            }
          }

          // remove leftover items
          for (var blockKey in lastBlockMap) {
            block = lastBlockMap[blockKey];
            elementsToRemove = getBlockNodes(block.clone);
            $animate.leave(elementsToRemove);
            if (elementsToRemove[0].parentNode) {
              // if the element was not removed yet because of pending animation, mark it as deleted
              // so that we can ignore it later
              for (index = 0, length = elementsToRemove.length; index < length; index++) {
                elementsToRemove[index][NG_REMOVED] = true;
              }
            }
            block.scope.$destroy();
          }

          // we are not using forEach for perf reasons (trying to avoid #call)
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            block = nextBlockOrder[index];

            if (block.scope) {
              // if we have already seen this object, then we need to reuse the
              // associated scope/element

              nextNode = previousNode;

              // skip nodes that are already pending removal via leave animation
              do {
                nextNode = nextNode.nextSibling;
              } while (nextNode && nextNode[NG_REMOVED]);

              if (getBlockStart(block) !== nextNode) {
                // existing item which got moved
                $animate.move(getBlockNodes(block.clone), null, previousNode);
              }
              previousNode = getBlockEnd(block);
              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
            } else {
              // new item which we don't know about
              $transclude(function ngRepeatTransclude(clone, scope) {
                block.scope = scope;
                // http://jsperf.com/clone-vs-createcomment
                var endNode = ngRepeatEndComment.cloneNode(false);
                clone[clone.length++] = endNode;

                $animate.enter(clone, null, previousNode);
                previousNode = endNode;
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block.clone = clone;
                nextBlockMap[block.id] = block;
                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
              });
            }
          }
          lastBlockMap = nextBlockMap;
        });
      };
    }
  };
}];

var NG_HIDE_CLASS = 'ng-hide';
var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
/**
 * @ngdoc directive
 * @name ngShow
 * @multiElement
 *
 * @description
 * The `ngShow` directive shows or hides the given HTML element based on the expression
 * provided to the `ngShow` attribute. The element is shown or hidden by removing or adding
 * the `.ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
 * in AngularJS and sets the display style to none (using an !important flag).
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is visible) -->
 * <div ng-show="myValue"></div>
 *
 * <!-- when $scope.myValue is falsy (element is hidden) -->
 * <div ng-show="myValue" class="ng-hide"></div>
 * ```
 *
 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added to the class
 * attribute on the element causing it to become hidden. When truthy, the `.ng-hide` CSS class is removed
 * from the element causing the element not to appear hidden.
 *
 * ## Why is !important used?
 *
 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
 * can be easily overridden by heavier selectors. For example, something as simple
 * as changing the display style on a HTML list item would make hidden elements appear visible.
 * This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
 * class CSS. Note that the selector that needs to be used is actually `.ng-hide:not(.ng-hide-animate)` to cope
 * with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; this is just another form of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override in CSS anything and the animations will work around the display style.
 *
 * ## A note about animations with `ngShow`
 *
 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
 * is true and false. This system works like the animation system present with ngClass except that
 * you must also include the !important flag to override the display property
 * so that you can perform an animation when the element is hidden during the time of the animation.
 *
 * ```css
 * //
 * //a working example can be found at the bottom of this page
 * //
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   /&#42; this is required as of 1.3x to properly
 *      apply all styling in a show/hide animation &#42;/
 *   transition: 0s linear all;
 * }
 *
 * .my-element.ng-hide-add-active,
 * .my-element.ng-hide-remove-active {
 *   /&#42; the transition is defined in the active class &#42;/
 *   transition: 1s linear all;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden |
 * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngShow` expression evaluates to a truthy value and just before contents are set to visible |
 *
 * @element ANY
 * @param {expression} ngShow If the {@link guide/expression expression} is truthy
 *     then the element is shown or hidden respectively.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show">
    <file name="index.html">
      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br/>
      <div>
        Show:
        <div class="check-element animate-show" ng-show="checked">
          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
        </div>
      </div>
      <div>
        Hide:
        <div class="check-element animate-show" ng-hide="checked">
          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
        </div>
      </div>
    </file>
    <file name="glyphicons.css">
      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
    </file>
    <file name="animations.css">
      .animate-show {
        line-height: 20px;
        opacity: 1;
        padding: 10px;
        border: 1px solid black;
        background: white;
      }

      .animate-show.ng-hide-add, .animate-show.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .animate-show.ng-hide {
        line-height: 0;
        opacity: 0;
        padding: 0 10px;
      }

      .check-element {
        padding: 10px;
        border: 1px solid black;
        background: white;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));

      it('should check ng-show / ng-hide', function() {
        expect(thumbsUp.isDisplayed()).toBeFalsy();
        expect(thumbsDown.isDisplayed()).toBeTruthy();

        element(by.model('checked')).click();

        expect(thumbsUp.isDisplayed()).toBeTruthy();
        expect(thumbsDown.isDisplayed()).toBeFalsy();
      });
    </file>
  </example>
 */
var ngShowDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
        // we're adding a temporary, animation-specific class for ng-hide since this way
        // we can control when the element is actually displayed on screen without having
        // to have a global/greedy CSS selector that breaks when other animations are run.
        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngHide
 * @multiElement
 *
 * @description
 * The `ngHide` directive shows or hides the given HTML element based on the expression
 * provided to the `ngHide` attribute. The element is shown or hidden by removing or adding
 * the `ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
 * in AngularJS and sets the display style to none (using an !important flag).
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is hidden) -->
 * <div ng-hide="myValue" class="ng-hide"></div>
 *
 * <!-- when $scope.myValue is falsy (element is visible) -->
 * <div ng-hide="myValue"></div>
 * ```
 *
 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added to the class
 * attribute on the element causing it to become hidden. When falsy, the `.ng-hide` CSS class is removed
 * from the element causing the element not to appear hidden.
 *
 * ## Why is !important used?
 *
 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
 * can be easily overridden by heavier selectors. For example, something as simple
 * as changing the display style on a HTML list item would make hidden elements appear visible.
 * This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
 * class in CSS:
 *
 * ```css
 * .ng-hide {
 *   /&#42; this is just another form of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override in CSS anything and the animations will work around the display style.
 *
 * ## A note about animations with `ngHide`
 *
 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
 * is true and false. This system works like the animation system present with ngClass, except that the `.ng-hide`
 * CSS class is added and removed for you instead of your own CSS class.
 *
 * ```css
 * //
 * //a working example can be found at the bottom of this page
 * //
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: 0.5s linear all;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden |
 * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible |
 *
 *
 * @element ANY
 * @param {expression} ngHide If the {@link guide/expression expression} is truthy then
 *     the element is shown or hidden respectively.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide">
    <file name="index.html">
      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br/>
      <div>
        Show:
        <div class="check-element animate-hide" ng-show="checked">
          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
        </div>
      </div>
      <div>
        Hide:
        <div class="check-element animate-hide" ng-hide="checked">
          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
        </div>
      </div>
    </file>
    <file name="glyphicons.css">
      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
    </file>
    <file name="animations.css">
      .animate-hide {
        transition: all linear 0.5s;
        line-height: 20px;
        opacity: 1;
        padding: 10px;
        border: 1px solid black;
        background: white;
      }

      .animate-hide.ng-hide {
        line-height: 0;
        opacity: 0;
        padding: 0 10px;
      }

      .check-element {
        padding: 10px;
        border: 1px solid black;
        background: white;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));

      it('should check ng-show / ng-hide', function() {
        expect(thumbsUp.isDisplayed()).toBeFalsy();
        expect(thumbsDown.isDisplayed()).toBeTruthy();

        element(by.model('checked')).click();

        expect(thumbsUp.isDisplayed()).toBeTruthy();
        expect(thumbsDown.isDisplayed()).toBeFalsy();
      });
    </file>
  </example>
 */
var ngHideDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
        // The comment inside of the ngShowDirective explains why we add and
        // remove a temporary class for the show/hide animation
        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngStyle
 * @restrict AC
 *
 * @description
 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
 * attribute, when using the `ngStyle` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @element ANY
 * @param {expression} ngStyle
 *
 * {@link guide/expression Expression} which evals to an
 * object whose keys are CSS style names and values are corresponding values for those CSS
 * keys.
 *
 * Since some CSS style names are not valid keys for an object, they must be quoted.
 * See the 'background-color' style in the example below.
 *
 * @example
   <example name="ng-style">
     <file name="index.html">
        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
        <input type="button" value="clear" ng-click="myStyle={}">
        <br/>
        <span ng-style="myStyle">Sample Text</span>
        <pre>myStyle={{myStyle}}</pre>
     </file>
     <file name="style.css">
       span {
         color: black;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var colorSpan = element(by.css('span'));

       it('should check ng-style', function() {
         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
         element(by.css('input[value=\'set color\']')).click();
         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
         element(by.css('input[value=clear]')).click();
         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
       });
     </file>
   </example>
 */
var ngStyleDirective = ngDirective(function(scope, element, attr) {
  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
    if (oldStyles && (newStyles !== oldStyles)) {
      forEach(oldStyles, function(val, style) { element.css(style, '');});
    }
    if (newStyles) element.css(newStyles);
  }, true);
});

/**
 * @ngdoc directive
 * @name ngSwitch
 * @restrict EA
 *
 * @description
 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
 * as specified in the template.
 *
 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
 * matches the value obtained from the evaluated expression. In other words, you define a container element
 * (where you place the directive), place an expression on the **`on="..."` attribute**
 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
 * attribute is displayed.
 *
 * <div class="alert alert-info">
 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
 * as literal string values to match against.
 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
 * value of the expression `$scope.someVal`.
 * </div>

 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
 *
 * @usage
 *
 * ```
 * <ANY ng-switch="expression">
 *   <ANY ng-switch-when="matchValue1">...</ANY>
 *   <ANY ng-switch-when="matchValue2">...</ANY>
 *   <ANY ng-switch-default>...</ANY>
 * </ANY>
 * ```
 *
 *
 * @scope
 * @priority 1200
 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
 * On child elements add:
 *
 * * `ngSwitchWhen`: the case statement to match against. If match then this
 *   case will be displayed. If the same match appears multiple times, all the
 *   elements will be displayed. It is possible to associate multiple values to
 *   the same `ngSwitchWhen` by defining the optional attribute
 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
 *   if any of the `ngSwitch` evaluates to any of these tokens.
 * * `ngSwitchDefault`: the default case when no other case match. If there
 *   are multiple default cases, all of them will be displayed when no other
 *   case match.
 *
 *
 * @example
  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <select ng-model="selection" ng-options="item for item in items">
        </select>
        <code>selection={{selection}}</code>
        <hr/>
        <div class="animate-switch-container"
          ng-switch on="selection">
            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
            <div class="animate-switch" ng-switch-when="home">Home Span</div>
            <div class="animate-switch" ng-switch-default>default</div>
        </div>
      </div>
    </file>
    <file name="script.js">
      angular.module('switchExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.items = ['settings', 'home', 'options', 'other'];
          $scope.selection = $scope.items[0];
        }]);
    </file>
    <file name="animations.css">
      .animate-switch-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .animate-switch {
        padding:10px;
      }

      .animate-switch.ng-animate {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
      }

      .animate-switch.ng-leave.ng-leave-active,
      .animate-switch.ng-enter {
        top:-50px;
      }
      .animate-switch.ng-leave,
      .animate-switch.ng-enter.ng-enter-active {
        top:0;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var switchElem = element(by.css('[ng-switch]'));
      var select = element(by.model('selection'));

      it('should start in settings', function() {
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should change to home', function() {
        select.all(by.css('option')).get(1).click();
        expect(switchElem.getText()).toMatch(/Home Span/);
      });
      it('should change to settings via "options"', function() {
        select.all(by.css('option')).get(2).click();
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should select default', function() {
        select.all(by.css('option')).get(3).click();
        expect(switchElem.getText()).toMatch(/default/);
      });
    </file>
  </example>
 */
var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
  return {
    require: 'ngSwitch',

    // asks for $scope to fool the BC controller module
    controller: ['$scope', function NgSwitchController() {
     this.cases = {};
    }],
    link: function(scope, element, attr, ngSwitchController) {
      var watchExpr = attr.ngSwitch || attr.on,
          selectedTranscludes = [],
          selectedElements = [],
          previousLeaveAnimations = [],
          selectedScopes = [];

      var spliceFactory = function(array, index) {
          return function(response) {
            if (response !== false) array.splice(index, 1);
          };
      };

      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
        var i, ii;

        // Start with the last, in case the array is modified during the loop
        while (previousLeaveAnimations.length) {
          $animate.cancel(previousLeaveAnimations.pop());
        }

        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
          var selected = getBlockNodes(selectedElements[i].clone);
          selectedScopes[i].$destroy();
          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
          runner.done(spliceFactory(previousLeaveAnimations, i));
        }

        selectedElements.length = 0;
        selectedScopes.length = 0;

        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
          forEach(selectedTranscludes, function(selectedTransclude) {
            selectedTransclude.transclude(function(caseElement, selectedScope) {
              selectedScopes.push(selectedScope);
              var anchor = selectedTransclude.element;
              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
              var block = { clone: caseElement };

              selectedElements.push(block);
              $animate.enter(caseElement, anchor.parent(), anchor);
            });
          });
        }
      });
    }
  };
}];

var ngSwitchWhenDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attrs, ctrl, $transclude) {

    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
      // Filter duplicate cases
      function(element, index, array) { return array[index - 1] !== element; }
    );

    forEach(cases, function(whenCase) {
      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
    });
  }
});

var ngSwitchDefaultDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attr, ctrl, $transclude) {
    ctrl.cases['?'] = (ctrl.cases['?'] || []);
    ctrl.cases['?'].push({ transclude: $transclude, element: element });
   }
});

/**
 * @ngdoc directive
 * @name ngTransclude
 * @restrict EAC
 *
 * @description
 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
 *
 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
 *
 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
 * content of this element will be removed before the transcluded content is inserted.
 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
 * content in the case that no transcluded content is provided.
 *
 * @element ANY
 *
 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
 *                                               or its value is the same as the name of the attribute then the default slot is used.
 *
 * @example
 * ### Basic transclusion
 * This example demonstrates basic transclusion of content into a component directive.
 * <example name="simpleTranscludeExample" module="transcludeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('transcludeExample', [])
 *        .directive('pane', function(){
 *           return {
 *             restrict: 'E',
 *             transclude: true,
 *             scope: { title:'@' },
 *             template: '<div style="border: 1px solid black;">' +
 *                         '<div style="background-color: gray">{{title}}</div>' +
 *                         '<ng-transclude></ng-transclude>' +
 *                       '</div>'
 *           };
 *       })
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.title = 'Lorem Ipsum';
 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *       }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input ng-model="title" aria-label="title"> <br/>
 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *       <pane title="{{title}}"><span>{{text}}</span></pane>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *      });
 *   </file>
 * </example>
 *
 * @example
 * ### Transclude fallback content
 * This example shows how to use `NgTransclude` with fallback content, that
 * is displayed if no transcluded content is provided.
 *
 * <example module="transcludeFallbackContentExample" name="ng-transclude">
 * <file name="index.html">
 * <script>
 * angular.module('transcludeFallbackContentExample', [])
 * .directive('myButton', function(){
 *             return {
 *               restrict: 'E',
 *               transclude: true,
 *               scope: true,
 *               template: '<button style="cursor: pointer;">' +
 *                           '<ng-transclude>' +
 *                             '<b style="color: red;">Button1</b>' +
 *                           '</ng-transclude>' +
 *                         '</button>'
 *             };
 *         });
 * </script>
 * <!-- fallback button content -->
 * <my-button id="fallback"></my-button>
 * <!-- modified button content -->
 * <my-button id="modified">
 *   <i style="color: green;">Button2</i>
 * </my-button>
 * </file>
 * <file name="protractor.js" type="protractor">
 * it('should have different transclude element content', function() {
 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
 *          expect(element(by.id('modified')).getText()).toBe('Button2');
 *        });
 * </file>
 * </example>
 *
 * @example
 * ### Multi-slot transclusion
 * This example demonstrates using multi-slot transclusion in a component directive.
 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
 *   <file name="index.html">
 *    <style>
 *      .title, .footer {
 *        background-color: gray
 *      }
 *    </style>
 *    <div ng-controller="ExampleController">
 *      <input ng-model="title" aria-label="title"> <br/>
 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *      <pane>
 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
 *        <pane-body><p>{{text}}</p></pane-body>
 *      </pane>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('multiSlotTranscludeExample', [])
 *     .directive('pane', function() {
 *        return {
 *          restrict: 'E',
 *          transclude: {
 *            'title': '?paneTitle',
 *            'body': 'paneBody',
 *            'footer': '?paneFooter'
 *          },
 *          template: '<div style="border: 1px solid black;">' +
 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
 *                      '<div ng-transclude="body"></div>' +
 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
 *                    '</div>'
 *        };
 *    })
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.title = 'Lorem Ipsum';
 *      $scope.link = 'https://google.com';
 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *    }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded the title and the body', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
 *      });
 *   </file>
 * </example>
 */
var ngTranscludeMinErr = minErr('ngTransclude');
var ngTranscludeDirective = ['$compile', function($compile) {
  return {
    restrict: 'EAC',
    terminal: true,
    compile: function ngTranscludeCompile(tElement) {

      // Remove and cache any original content to act as a fallback
      var fallbackLinkFn = $compile(tElement.contents());
      tElement.empty();

      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {

        if (!$transclude) {
          throw ngTranscludeMinErr('orphan',
          'Illegal use of ngTransclude directive in the template! ' +
          'No parent directive that requires a transclusion found. ' +
          'Element: {0}',
          startingTag($element));
        }


        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
          $attrs.ngTransclude = '';
        }
        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;

        // If the slot is required and no transclusion content is provided then this call will throw an error
        $transclude(ngTranscludeCloneAttachFn, null, slotName);

        // If the slot is optional and no transclusion content is provided then use the fallback content
        if (slotName && !$transclude.isSlotFilled(slotName)) {
          useFallbackContent();
        }

        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
          if (clone.length && notWhitespace(clone)) {
            $element.append(clone);
          } else {
            useFallbackContent();
            // There is nothing linked against the transcluded scope since no content was available,
            // so it should be safe to clean up the generated scope.
            transcludedScope.$destroy();
          }
        }

        function useFallbackContent() {
          // Since this is the fallback content rather than the transcluded content,
          // we link against the scope of this directive rather than the transcluded scope
          fallbackLinkFn($scope, function(clone) {
            $element.append(clone);
          });
        }

        function notWhitespace(nodes) {
          for (var i = 0, ii = nodes.length; i < ii; i++) {
            var node = nodes[i];
            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
              return true;
            }
          }
        }
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name script
 * @restrict E
 *
 * @description
 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
 *
 * @param {string} type Must be set to `'text/ng-template'`.
 * @param {string} id Cache name of the template.
 *
 * @example
  <example  name="script-tag">
    <file name="index.html">
      <script type="text/ng-template" id="/tpl.html">
        Content of the template.
      </script>

      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
      <div id="tpl-content" ng-include src="currentTpl"></div>
    </file>
    <file name="protractor.js" type="protractor">
      it('should load template defined inside script tag', function() {
        element(by.css('#tpl-link')).click();
        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
      });
    </file>
  </example>
 */
var scriptDirective = ['$templateCache', function($templateCache) {
  return {
    restrict: 'E',
    terminal: true,
    compile: function(element, attr) {
      if (attr.type === 'text/ng-template') {
        var templateUrl = attr.id,
            text = element[0].text;

        $templateCache.put(templateUrl, text);
      }
    }
  };
}];

/* exported selectDirective, optionDirective */

var noopNgModelController = { $setViewValue: noop, $render: noop };

/**
 * @ngdoc type
 * @name  select.SelectController
 * @description
 * The controller for the `<select>` directive. This provides support for reading
 * and writing the selected value(s) of the control and also coordinates dynamically
 * added `<option>` elements, perhaps by an `ngRepeat` directive.
 */
var SelectController =
        ['$element', '$scope', /** @this */ function($element, $scope) {

  var self = this,
      optionsMap = new HashMap();

  self.selectValueMap = {}; // Keys are the hashed values, values the original values

  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
  self.ngModelCtrl = noopNgModelController;
  self.multiple = false;

  // The "unknown" option is one that is prepended to the list if the viewValue
  // does not match any of the options. When it is rendered the value of the unknown
  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
  //
  // We can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  self.unknownOption = jqLite(window.document.createElement('option'));

  // The empty option is an option with the value '' that te application developer can
  // provide inside the select. When the model changes to a value that doesn't match an option,
  // it is selected - so if an empty option is provided, no unknown option is generated.
  // However, the empty option is not removed when the model matches an option. It is always selectable
  // and indicates that a "null" selection has been made.
  self.hasEmptyOption = false;
  self.emptyOption = undefined;

  self.renderUnknownOption = function(val) {
    var unknownVal = self.generateUnknownOptionValue(val);
    self.unknownOption.val(unknownVal);
    $element.prepend(self.unknownOption);
    setOptionAsSelected(self.unknownOption);
    $element.val(unknownVal);
  };

  self.updateUnknownOption = function(val) {
    var unknownVal = self.generateUnknownOptionValue(val);
    self.unknownOption.val(unknownVal);
    setOptionAsSelected(self.unknownOption);
    $element.val(unknownVal);
  };

  self.generateUnknownOptionValue = function(val) {
    return '? ' + hashKey(val) + ' ?';
  };

  self.removeUnknownOption = function() {
    if (self.unknownOption.parent()) self.unknownOption.remove();
  };

  self.selectEmptyOption = function() {
    if (self.emptyOption) {
      $element.val('');
      setOptionAsSelected(self.emptyOption);
    }
  };

  self.unselectEmptyOption = function() {
    if (self.hasEmptyOption) {
      self.emptyOption.removeAttr('selected');
    }
  };

  $scope.$on('$destroy', function() {
    // disable unknown option so that we don't do work when the whole select is being destroyed
    self.renderUnknownOption = noop;
  });

  // Read the value of the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.readValue = function readSingleValue() {
    var val = $element.val();
    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;

    if (self.hasOption(realVal)) {
      return realVal;
    }

    return null;
  };


  // Write the value to the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.writeValue = function writeSingleValue(value) {
    // Make sure to remove the selected attribute from the previously selected option
    // Otherwise, screen readers might get confused
    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
    if (currentlySelectedOption) currentlySelectedOption.removeAttribute('selected');

    if (self.hasOption(value)) {
      self.removeUnknownOption();

      var hashedVal = hashKey(value);
      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);

      // Set selected attribute and property on selected option for screen readers
      var selectedOption = $element[0].options[$element[0].selectedIndex];
      setOptionAsSelected(jqLite(selectedOption));
    } else {
      if (value == null && self.emptyOption) {
        self.removeUnknownOption();
        self.selectEmptyOption();
      } else if (self.unknownOption.parent().length) {
        self.updateUnknownOption(value);
      } else {
        self.renderUnknownOption(value);
      }
    }
  };


  // Tell the select control that an option, with the given value, has been added
  self.addOption = function(value, element) {
    // Skip comment nodes, as they only pollute the `optionsMap`
    if (element[0].nodeType === NODE_TYPE_COMMENT) return;

    assertNotHasOwnProperty(value, '"option value"');
    if (value === '') {
      self.hasEmptyOption = true;
      self.emptyOption = element;
    }
    var count = optionsMap.get(value) || 0;
    optionsMap.put(value, count + 1);
    // Only render at the end of a digest. This improves render performance when many options
    // are added during a digest and ensures all relevant options are correctly marked as selected
    scheduleRender();
  };

  // Tell the select control that an option, with the given value, has been removed
  self.removeOption = function(value) {
    var count = optionsMap.get(value);
    if (count) {
      if (count === 1) {
        optionsMap.remove(value);
        if (value === '') {
          self.hasEmptyOption = false;
          self.emptyOption = undefined;
        }
      } else {
        optionsMap.put(value, count - 1);
      }
    }
  };

  // Check whether the select control has an option matching the given value
  self.hasOption = function(value) {
    return !!optionsMap.get(value);
  };


  var renderScheduled = false;
  function scheduleRender() {
    if (renderScheduled) return;
    renderScheduled = true;
    $scope.$$postDigest(function() {
      renderScheduled = false;
      self.ngModelCtrl.$render();
    });
  }

  var updateScheduled = false;
  function scheduleViewValueUpdate(renderAfter) {
    if (updateScheduled) return;

    updateScheduled = true;

    $scope.$$postDigest(function() {
      if ($scope.$$destroyed) return;

      updateScheduled = false;
      self.ngModelCtrl.$setViewValue(self.readValue());
      if (renderAfter) self.ngModelCtrl.$render();
    });
  }


  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {

    if (optionAttrs.$attr.ngValue) {
      // The value attribute is set by ngValue
      var oldVal, hashedVal = NaN;
      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {

        var removal;
        var previouslySelected = optionElement.prop('selected');

        if (isDefined(hashedVal)) {
          self.removeOption(oldVal);
          delete self.selectValueMap[hashedVal];
          removal = true;
        }

        hashedVal = hashKey(newVal);
        oldVal = newVal;
        self.selectValueMap[hashedVal] = newVal;
        self.addOption(newVal, optionElement);
        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
        // from firing a second time. Other $observers on value will also get the result of the
        // ngValue expression, not the hashed value
        optionElement.attr('value', hashedVal);

        if (removal && previouslySelected) {
          scheduleViewValueUpdate();
        }

      });
    } else if (interpolateValueFn) {
      // The value attribute is interpolated
      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
        // This method is overwritten in ngOptions and has side-effects!
        self.readValue();

        var removal;
        var previouslySelected = optionElement.prop('selected');

        if (isDefined(oldVal)) {
          self.removeOption(oldVal);
          removal = true;
        }
        oldVal = newVal;
        self.addOption(newVal, optionElement);

        if (removal && previouslySelected) {
          scheduleViewValueUpdate();
        }
      });
    } else if (interpolateTextFn) {
      // The text content is interpolated
      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
        optionAttrs.$set('value', newVal);
        var previouslySelected = optionElement.prop('selected');
        if (oldVal !== newVal) {
          self.removeOption(oldVal);
        }
        self.addOption(newVal, optionElement);

        if (oldVal && previouslySelected) {
          scheduleViewValueUpdate();
        }
      });
    } else {
      // The value attribute is static
      self.addOption(optionAttrs.value, optionElement);
    }


    optionAttrs.$observe('disabled', function(newVal) {

      // Since model updates will also select disabled options (like ngOptions),
      // we only have to handle options becoming disabled, not enabled

      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
        if (self.multiple) {
          scheduleViewValueUpdate(true);
        } else {
          self.ngModelCtrl.$setViewValue(null);
          self.ngModelCtrl.$render();
        }
      }
    });

    optionElement.on('$destroy', function() {
      var currentValue = self.readValue();
      var removeValue = optionAttrs.value;

      self.removeOption(removeValue);
      self.ngModelCtrl.$render();

      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
          currentValue === removeValue
      ) {
        // When multiple (selected) options are destroyed at the same time, we don't want
        // to run a model update for each of them. Instead, run a single update in the $$postDigest
        scheduleViewValueUpdate(true);
      }
    });
  };

  function setOptionAsSelected(optionEl) {
    optionEl.prop('selected', true); // needed for IE
    optionEl.attr('selected', true);
  }
}];

/**
 * @ngdoc directive
 * @name select
 * @restrict E
 *
 * @description
 * HTML `select` element with angular data-binding.
 *
 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
 * between the scope and the `<select>` control (including setting default values).
 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
 * {@link ngOptions `ngOptions`} directives.
 *
 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
 * to the model identified by the `ngModel` directive. With static or repeated options, this is
 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
 * Value and textContent can be interpolated.
 *
 * ## Matching model and option values
 *
 * In general, the match between the model and an option is evaluated by strictly comparing the model
 * value against the value of the available options.
 *
 * If you are setting the option value with the option's `value` attribute, or textContent, the
 * value will always be a `string` which means that the model value must also be a string.
 * Otherwise the `select` directive cannot match them correctly.
 *
 * To bind the model to a non-string value, you can use one of the following strategies:
 * - the {@link ng.ngOptions `ngOptions`} directive
 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
 * - model $parsers / $formatters to convert the string value
 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
 *
 * If the viewValue of `ngModel` does not match any of the options, then the control
 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Choosing between `ngRepeat` and `ngOptions`
 *
 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression
 * - reduced memory consumption by not creating a new scope for each repeated instance
 * - increased render speed by creating the options in a documentFragment instead of individually
 *
 * Specifically, select with repeated options slows down significantly starting at 2000 options in
 * Chrome and Internet Explorer / Edge.
 *
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
 *     bound to the model as an array.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds required attribute and required validation constraint to
 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
 * when you want to data-bind to the required attribute.
 * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
 *    interaction with the select element.
 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
 * set on the model on selection. See {@link ngOptions `ngOptions`}.
 *
 * @example
 * ### Simple `select` elements with static options
 *
 * <example name="static-select" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="singleSelect"> Single select: </label><br>
 *     <select name="singleSelect" ng-model="data.singleSelect">
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *
 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *     <tt>singleSelect = {{data.singleSelect}}</tt>
 *
 *     <hr>
 *     <label for="multipleSelect"> Multiple select: </label><br>
 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *       <option value="option-3">Option 3</option>
 *     </select><br>
 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       singleSelect: null,
 *       multipleSelect: [],
 *       option1: 'option-1'
 *      };
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.data.singleSelect = 'nonsense';
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * ### Using `ngRepeat` to generate `select` options
 * <example name="select-ngrepeat" module="ngrepeatSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="repeatSelect"> Repeat select: </label>
 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <tt>model = {{data.model}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngrepeatSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * ### Using `ngValue` to bind the model to an array of objects
 * <example name="select-ngvalue" module="ngvalueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="ngvalueselect"> ngvalue select: </label>
 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <pre>model = {{data.model | json}}</pre><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngvalueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       model: null,
 *       availableOptions: [
           {value: 'myString', name: 'string'},
           {value: 1, name: 'integer'},
           {value: true, name: 'boolean'},
           {value: null, name: 'null'},
           {value: {prop: 'value'}, name: 'object'},
           {value: ['a'], name: 'array'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * ### Using `select` with `ngOptions` and setting a default value
 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
 *
 * <example name="select-with-default-values" module="defaultValueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="mySelect">Make a choice:</label>
 *     <select name="mySelect" id="mySelect"
 *       ng-options="option.name for option in data.availableOptions track by option.id"
 *       ng-model="data.selectedOption"></select>
 *   </form>
 *   <hr>
 *   <tt>option = {{data.selectedOption}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('defaultValueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ],
 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
 *       };
 *   }]);
 * </file>
 *</example>
 *
 *
 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
 *
 * <example name="select-with-non-string-options" module="nonStringSelect">
 *   <file name="index.html">
 *     <select ng-model="model.id" convert-to-number>
 *       <option value="0">Zero</option>
 *       <option value="1">One</option>
 *       <option value="2">Two</option>
 *     </select>
 *     {{ model }}
 *   </file>
 *   <file name="app.js">
 *     angular.module('nonStringSelect', [])
 *       .run(function($rootScope) {
 *         $rootScope.model = { id: 2 };
 *       })
 *       .directive('convertToNumber', function() {
 *         return {
 *           require: 'ngModel',
 *           link: function(scope, element, attrs, ngModel) {
 *             ngModel.$parsers.push(function(val) {
 *               return parseInt(val, 10);
 *             });
 *             ngModel.$formatters.push(function(val) {
 *               return '' + val;
 *             });
 *           }
 *         };
 *       });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should initialize to model', function() {
 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
 *     });
 *   </file>
 * </example>
 *
 */
var selectDirective = function() {

  return {
    restrict: 'E',
    require: ['select', '?ngModel'],
    controller: SelectController,
    priority: 1,
    link: {
      pre: selectPreLink,
      post: selectPostLink
    }
  };

  function selectPreLink(scope, element, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];

      // if ngModel is not defined, we don't need to do anything but set the registerOption
      // function to noop, so options don't get added internally
      if (!ngModelCtrl) {
        selectCtrl.registerOption = noop;
        return;
      }


      selectCtrl.ngModelCtrl = ngModelCtrl;

      // When the selected item(s) changes we delegate getting the value of the select control
      // to the `readValue` method, which can be changed if the select can have multiple
      // selected values or if the options are being generated by `ngOptions`
      element.on('change', function() {
        selectCtrl.removeUnknownOption();
        scope.$apply(function() {
          ngModelCtrl.$setViewValue(selectCtrl.readValue());
        });
      });

      // If the select allows multiple values then we need to modify how we read and write
      // values from and to the control; also what it means for the value to be empty and
      // we have to add an extra watch since ngModel doesn't work well with arrays - it
      // doesn't trigger rendering if only an item in the array changes.
      if (attr.multiple) {
        selectCtrl.multiple = true;

        // Read value now needs to check each option to see if it is selected
        selectCtrl.readValue = function readMultipleValue() {
          var array = [];
          forEach(element.find('option'), function(option) {
            if (option.selected && !option.disabled) {
              var val = option.value;
              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
            }
          });
          return array;
        };

        // Write value now needs to set the selected property of each matching option
        selectCtrl.writeValue = function writeMultipleValue(value) {
          var items = new HashMap(value);
          forEach(element.find('option'), function(option) {
            option.selected = isDefined(items.get(option.value)) || isDefined(items.get(selectCtrl.selectValueMap[option.value]));
          });
        };

        // we have to do it on each watch since ngModel watches reference, but
        // we need to work of an array, so we need to see if anything was inserted/removed
        var lastView, lastViewRef = NaN;
        scope.$watch(function selectMultipleWatch() {
          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
            lastView = shallowCopy(ngModelCtrl.$viewValue);
            ngModelCtrl.$render();
          }
          lastViewRef = ngModelCtrl.$viewValue;
        });

        // If we are a multiple select then value is now a collection
        // so the meaning of $isEmpty changes
        ngModelCtrl.$isEmpty = function(value) {
          return !value || value.length === 0;
        };

      }
    }

    function selectPostLink(scope, element, attrs, ctrls) {
      // if ngModel is not defined, we don't need to do anything
      var ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) return;

      var selectCtrl = ctrls[0];

      // We delegate rendering to the `writeValue` method, which can be changed
      // if the select can have multiple selected values or if the options are being
      // generated by `ngOptions`.
      // This must be done in the postLink fn to prevent $render to be called before
      // all nodes have been linked correctly.
      ngModelCtrl.$render = function() {
        selectCtrl.writeValue(ngModelCtrl.$viewValue);
      };
    }
};


// The option directive is purely designed to communicate the existence (or lack of)
// of dynamically created (and destroyed) option elements to their containing select
// directive via its controller.
var optionDirective = ['$interpolate', function($interpolate) {
  return {
    restrict: 'E',
    priority: 100,
    compile: function(element, attr) {
      var interpolateValueFn, interpolateTextFn;

      if (isDefined(attr.ngValue)) {
        // Will be handled by registerOption
      } else if (isDefined(attr.value)) {
        // If the value attribute is defined, check if it contains an interpolation
        interpolateValueFn = $interpolate(attr.value, true);
      } else {
        // If the value attribute is not defined then we fall back to the
        // text content of the option element, which may be interpolated
        interpolateTextFn = $interpolate(element.text(), true);
        if (!interpolateTextFn) {
          attr.$set('value', element.text());
        }
      }

      return function(scope, element, attr) {
        // This is an optimization over using ^^ since we don't want to have to search
        // all the way to the root of the DOM for every single option element
        var selectCtrlName = '$selectController',
            parent = element.parent(),
            selectCtrl = parent.data(selectCtrlName) ||
              parent.parent().data(selectCtrlName); // in case we are in optgroup

        if (selectCtrl) {
          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
        }
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngRequired
 * @restrict A
 *
 * @description
 *
 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
 * applied to custom controls.
 *
 * The directive sets the `required` attribute on the element if the Angular expression inside
 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
 * for more info.
 *
 * The validator will set the `required` error key to true if the `required` attribute is set and
 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
 *
 * @example
 * <example name="ngRequiredDirective" module="ngRequiredExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngRequiredExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.required = true;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="required">Toggle required: </label>
 *         <input type="checkbox" ng-model="required" id="required" />
 *         <br>
 *         <label for="input">This input must be filled if `required` is true: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
 *         <hr>
 *         required error set? = <code>{{form.input.$error.required}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var required = element(by.binding('form.input.$error.required'));
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should set the required error', function() {
         expect(required.getText()).toContain('true');

         input.sendKeys('123');
         expect(required.getText()).not.toContain('true');
         expect(model.getText()).toContain('123');
       });
 *   </file>
 * </example>
 */
var requiredDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;
      attr.required = true; // force truthy in case we are on non input element

      ctrl.$validators.required = function(modelValue, viewValue) {
        return !attr.required || !ctrl.$isEmpty(viewValue);
      };

      attr.$observe('required', function() {
        ctrl.$validate();
      });
    }
  };
};

/**
 * @ngdoc directive
 * @name ngPattern
 *
 * @description
 *
 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * does not match a RegExp which is obtained by evaluating the Angular expression given in the
 * `ngPattern` attribute value:
 * * If the expression evaluates to a RegExp object, then this is used directly.
 * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
 * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
 *
 * <div class="alert alert-info">
 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 * start at the index of the last search's match, thus not taking the whole input value into
 * account.
 * </div>
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
 *     not available.
 *   </li>
 *   <li>
 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngPatternDirective" module="ngPatternExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngPatternExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.regex = '\\d+';
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="regex">Set a pattern (regex string): </label>
 *         <input type="text" ng-model="regex" id="regex" />
 *         <br>
 *         <label for="input">This input is restricted by the current pattern: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default pattern', function() {
         input.sendKeys('aaa');
         expect(model.getText()).not.toContain('aaa');

         input.clear().then(function() {
           input.sendKeys('123');
           expect(model.getText()).toContain('123');
         });
       });
 *   </file>
 * </example>
 */
var patternDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var regexp, patternExp = attr.ngPattern || attr.pattern;
      attr.$observe('pattern', function(regex) {
        if (isString(regex) && regex.length > 0) {
          regex = new RegExp('^' + regex + '$');
        }

        if (regex && !regex.test) {
          throw minErr('ngPattern')('noregexp',
            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
            regex, startingTag(elm));
        }

        regexp = regex || undefined;
        ctrl.$validate();
      });

      ctrl.$validators.pattern = function(modelValue, viewValue) {
        // HTML5 pattern constraint validates the input value, so we validate the viewValue
        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
      };
    }
  };
};

/**
 * @ngdoc directive
 * @name ngMaxlength
 *
 * @description
 *
 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is longer than the integer obtained by evaluating the Angular expression given in the
 * `ngMaxlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMaxlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.maxlength = 5;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="maxlength">Set a maxlength: </label>
 *         <input type="number" ng-model="maxlength" id="maxlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current maxlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default maxlength', function() {
         input.sendKeys('abcdef');
         expect(model.getText()).not.toContain('abcdef');

         input.clear().then(function() {
           input.sendKeys('abcde');
           expect(model.getText()).toContain('abcde');
         });
       });
 *   </file>
 * </example>
 */
var maxlengthDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var maxlength = -1;
      attr.$observe('maxlength', function(value) {
        var intVal = toInt(value);
        maxlength = isNumberNaN(intVal) ? -1 : intVal;
        ctrl.$validate();
      });
      ctrl.$validators.maxlength = function(modelValue, viewValue) {
        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
      };
    }
  };
};

/**
 * @ngdoc directive
 * @name ngMinlength
 *
 * @description
 *
 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is shorter than the integer obtained by evaluating the Angular expression given in the
 * `ngMinlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMinlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.minlength = 3;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="minlength">Set a minlength: </label>
 *         <input type="number" ng-model="minlength" id="minlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current minlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default minlength', function() {
         input.sendKeys('ab');
         expect(model.getText()).not.toContain('ab');

         input.sendKeys('abc');
         expect(model.getText()).toContain('abc');
       });
 *   </file>
 * </example>
 */
var minlengthDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var minlength = 0;
      attr.$observe('minlength', function(value) {
        minlength = toInt(value) || 0;
        ctrl.$validate();
      });
      ctrl.$validators.minlength = function(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
      };
    }
  };
};

if (window.angular.bootstrap) {
  // AngularJS is already loaded, so we can return here...
  if (window.console) {
    console.log('WARNING: Tried to load angular more than once.');
  }
  return;
}

// try to bind to jquery now so that one can write jqLite(fn)
// but we will rebind on bootstrap again.
bindJQuery();

publishExternalAPI(angular);

angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "ERANAMES": [
      "Before Christ",
      "Anno Domini"
    ],
    "ERAS": [
      "BC",
      "AD"
    ],
    "FIRSTDAYOFWEEK": 6,
    "MONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "SHORTDAY": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "SHORTMONTH": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "STANDALONEMONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, MMMM d, y",
    "longDate": "MMMM d, y",
    "medium": "MMM d, y h:mm:ss a",
    "mediumDate": "MMM d, y",
    "mediumTime": "h:mm:ss a",
    "short": "M/d/yy h:mm a",
    "shortDate": "M/d/yy",
    "shortTime": "h:mm a"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "$",
    "DECIMAL_SEP": ".",
    "GROUP_SEP": ",",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-\u00a4",
        "negSuf": "",
        "posPre": "\u00a4",
        "posSuf": ""
      }
    ]
  },
  "id": "en-us",
  "localeID": "en_US",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

  jqLite(function() {
    angularInit(window.document, bootstrap);
  });

})(window);

!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');
/**
 * @license AngularJS v1.6.1
 * (c) 2010-2016 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

var ELEMENT_NODE = 1;
var COMMENT_NODE = 8;

var ADD_CLASS_SUFFIX = '-add';
var REMOVE_CLASS_SUFFIX = '-remove';
var EVENT_CLASS_PREFIX = 'ng-';
var ACTIVE_CLASS_SUFFIX = '-active';
var PREPARE_CLASS_SUFFIX = '-prepare';

var NG_ANIMATE_CLASSNAME = 'ng-animate';
var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';

// Detect proper transitionend/animationend event names.
var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;

// If unprefixed events are not supported but webkit-prefixed are, use the latter.
// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
// Register both events in case `window.onanimationend` is not supported because of that,
// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
// therefore there is no reason to test anymore for other vendor prefixes:
// http://caniuse.com/#search=transition
if ((window.ontransitionend === undefined) && (window.onwebkittransitionend !== undefined)) {
  CSS_PREFIX = '-webkit-';
  TRANSITION_PROP = 'WebkitTransition';
  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
} else {
  TRANSITION_PROP = 'transition';
  TRANSITIONEND_EVENT = 'transitionend';
}

if ((window.onanimationend === undefined) && (window.onwebkitanimationend !== undefined)) {
  CSS_PREFIX = '-webkit-';
  ANIMATION_PROP = 'WebkitAnimation';
  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
} else {
  ANIMATION_PROP = 'animation';
  ANIMATIONEND_EVENT = 'animationend';
}

var DURATION_KEY = 'Duration';
var PROPERTY_KEY = 'Property';
var DELAY_KEY = 'Delay';
var TIMING_KEY = 'TimingFunction';
var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
var ANIMATION_PLAYSTATE_KEY = 'PlayState';
var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;

var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;

var ngMinErr = angular.$$minErr('ng');
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
  }
  return arg;
}

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function packageStyles(options) {
  var styles = {};
  if (options && (options.to || options.from)) {
    styles.to = options.to;
    styles.from = options.from;
  }
  return styles;
}

function pendClasses(classes, fix, isPrefix) {
  var className = '';
  classes = isArray(classes)
      ? classes
      : classes && isString(classes) && classes.length
          ? classes.split(/\s+/)
          : [];
  forEach(classes, function(klass, i) {
    if (klass && klass.length > 0) {
      className += (i > 0) ? ' ' : '';
      className += isPrefix ? fix + klass
                            : klass + fix;
    }
  });
  return className;
}

function removeFromArray(arr, val) {
  var index = arr.indexOf(val);
  if (val >= 0) {
    arr.splice(index, 1);
  }
}

function stripCommentsFromElement(element) {
  if (element instanceof jqLite) {
    switch (element.length) {
      case 0:
        return element;

      case 1:
        // there is no point of stripping anything if the element
        // is the only element within the jqLite wrapper.
        // (it's important that we retain the element instance.)
        if (element[0].nodeType === ELEMENT_NODE) {
          return element;
        }
        break;

      default:
        return jqLite(extractElementNode(element));
    }
  }

  if (element.nodeType === ELEMENT_NODE) {
    return jqLite(element);
  }
}

function extractElementNode(element) {
  if (!element[0]) return element;
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType === ELEMENT_NODE) {
      return elm;
    }
  }
}

function $$addClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.addClass(elm, className);
  });
}

function $$removeClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.removeClass(elm, className);
  });
}

function applyAnimationClassesFactory($$jqLite) {
  return function(element, options) {
    if (options.addClass) {
      $$addClass($$jqLite, element, options.addClass);
      options.addClass = null;
    }
    if (options.removeClass) {
      $$removeClass($$jqLite, element, options.removeClass);
      options.removeClass = null;
    }
  };
}

function prepareAnimationOptions(options) {
  options = options || {};
  if (!options.$$prepared) {
    var domOperation = options.domOperation || noop;
    options.domOperation = function() {
      options.$$domOperationFired = true;
      domOperation();
      domOperation = noop;
    };
    options.$$prepared = true;
  }
  return options;
}

function applyAnimationStyles(element, options) {
  applyAnimationFromStyles(element, options);
  applyAnimationToStyles(element, options);
}

function applyAnimationFromStyles(element, options) {
  if (options.from) {
    element.css(options.from);
    options.from = null;
  }
}

function applyAnimationToStyles(element, options) {
  if (options.to) {
    element.css(options.to);
    options.to = null;
  }
}

function mergeAnimationDetails(element, oldAnimation, newAnimation) {
  var target = oldAnimation.options || {};
  var newOptions = newAnimation.options || {};

  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);

  if (newOptions.preparationClasses) {
    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
    delete newOptions.preparationClasses;
  }

  // noop is basically when there is no callback; otherwise something has been set
  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;

  extend(target, newOptions);

  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
  if (realDomOperation) {
    target.domOperation = realDomOperation;
  }

  if (classes.addClass) {
    target.addClass = classes.addClass;
  } else {
    target.addClass = null;
  }

  if (classes.removeClass) {
    target.removeClass = classes.removeClass;
  } else {
    target.removeClass = null;
  }

  oldAnimation.addClass = target.addClass;
  oldAnimation.removeClass = target.removeClass;

  return target;
}

function resolveElementClasses(existing, toAdd, toRemove) {
  var ADD_CLASS = 1;
  var REMOVE_CLASS = -1;

  var flags = {};
  existing = splitClassesToLookup(existing);

  toAdd = splitClassesToLookup(toAdd);
  forEach(toAdd, function(value, key) {
    flags[key] = ADD_CLASS;
  });

  toRemove = splitClassesToLookup(toRemove);
  forEach(toRemove, function(value, key) {
    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
  });

  var classes = {
    addClass: '',
    removeClass: ''
  };

  forEach(flags, function(val, klass) {
    var prop, allow;
    if (val === ADD_CLASS) {
      prop = 'addClass';
      allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
    } else if (val === REMOVE_CLASS) {
      prop = 'removeClass';
      allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
    }
    if (allow) {
      if (classes[prop].length) {
        classes[prop] += ' ';
      }
      classes[prop] += klass;
    }
  });

  function splitClassesToLookup(classes) {
    if (isString(classes)) {
      classes = classes.split(' ');
    }

    var obj = {};
    forEach(classes, function(klass) {
      // sometimes the split leaves empty string values
      // incase extra spaces were applied to the options
      if (klass.length) {
        obj[klass] = true;
      }
    });
    return obj;
  }

  return classes;
}

function getDomNode(element) {
  return (element instanceof jqLite) ? element[0] : element;
}

function applyGeneratedPreparationClasses(element, event, options) {
  var classes = '';
  if (event) {
    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
  }
  if (options.addClass) {
    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
  }
  if (options.removeClass) {
    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
  }
  if (classes.length) {
    options.preparationClasses = classes;
    element.addClass(classes);
  }
}

function clearGeneratedClasses(element, options) {
  if (options.preparationClasses) {
    element.removeClass(options.preparationClasses);
    options.preparationClasses = null;
  }
  if (options.activeClasses) {
    element.removeClass(options.activeClasses);
    options.activeClasses = null;
  }
}

function blockTransitions(node, duration) {
  // we use a negative delay value since it performs blocking
  // yet it doesn't kill any existing transitions running on the
  // same element which makes this safe for class-based animations
  var value = duration ? '-' + duration + 's' : '';
  applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
  return [TRANSITION_DELAY_PROP, value];
}

function blockKeyframeAnimations(node, applyBlock) {
  var value = applyBlock ? 'paused' : '';
  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
  applyInlineStyle(node, [key, value]);
  return [key, value];
}

function applyInlineStyle(node, styleTuple) {
  var prop = styleTuple[0];
  var value = styleTuple[1];
  node.style[prop] = value;
}

function concatWithSpace(a,b) {
  if (!a) return b;
  if (!b) return a;
  return a + ' ' + b;
}

var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
  var queue, cancelFn;

  function scheduler(tasks) {
    // we make a copy since RAFScheduler mutates the state
    // of the passed in array variable and this would be difficult
    // to track down on the outside code
    queue = queue.concat(tasks);
    nextTick();
  }

  queue = scheduler.queue = [];

  /* waitUntilQuiet does two things:
   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
   *
   * The motivation here is that animation code can request more time from the scheduler
   * before the next wave runs. This allows for certain DOM properties such as classes to
   * be resolved in time for the next animation to run.
   */
  scheduler.waitUntilQuiet = function(fn) {
    if (cancelFn) cancelFn();

    cancelFn = $$rAF(function() {
      cancelFn = null;
      fn();
      nextTick();
    });
  };

  return scheduler;

  function nextTick() {
    if (!queue.length) return;

    var items = queue.shift();
    for (var i = 0; i < items.length; i++) {
      items[i]();
    }

    if (!cancelFn) {
      $$rAF(function() {
        if (!cancelFn) nextTick();
      });
    }
  }
}];

/**
 * @ngdoc directive
 * @name ngAnimateChildren
 * @restrict AE
 * @element ANY
 *
 * @description
 *
 * ngAnimateChildren allows you to specify that children of this element should animate even if any
 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
 * (structural) animation, child elements that also have an active structural animation are not animated.
 *
 * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
 *
 *
 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
 *
 * @example
 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
     <file name="index.html">
       <div ng-controller="MainController as main">
         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
         <hr>
         <div ng-animate-children="{{main.animateChildren}}">
           <div ng-if="main.enterElement" class="container">
             List of items:
             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
           </div>
         </div>
       </div>
     </file>
     <file name="animations.css">

      .container.ng-enter,
      .container.ng-leave {
        transition: all ease 1.5s;
      }

      .container.ng-enter,
      .container.ng-leave-active {
        opacity: 0;
      }

      .container.ng-leave,
      .container.ng-enter-active {
        opacity: 1;
      }

      .item {
        background: firebrick;
        color: #FFF;
        margin-bottom: 10px;
      }

      .item.ng-enter,
      .item.ng-leave {
        transition: transform 1.5s ease;
      }

      .item.ng-enter {
        transform: translateX(50px);
      }

      .item.ng-enter-active {
        transform: translateX(0);
      }
    </file>
    <file name="script.js">
      angular.module('ngAnimateChildren', ['ngAnimate'])
        .controller('MainController', function MainController() {
          this.animateChildren = false;
          this.enterElement = false;
        });
    </file>
  </example>
 */
var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
  return {
    link: function(scope, element, attrs) {
      var val = attrs.ngAnimateChildren;
      if (isString(val) && val.length === 0) { //empty attribute
        element.data(NG_ANIMATE_CHILDREN_DATA, true);
      } else {
        // Interpolate and set the value, so that it is available to
        // animations that run right after compilation
        setData($interpolate(val)(scope));
        attrs.$observe('ngAnimateChildren', setData);
      }

      function setData(value) {
        value = value === 'on' || value === 'true';
        element.data(NG_ANIMATE_CHILDREN_DATA, value);
      }
    }
  };
}];

/* exported $AnimateCssProvider */

var ANIMATE_TIMER_KEY = '$$animateCss';

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 *
 * @description
 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
 * directives to create more complex animations that can be purely driven using CSS code.
 *
 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
 *
 * ## Usage
 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
 * any automatic control over cancelling animations and/or preventing animations from being run on
 * child elements will not be handled by Angular. For this to work as expected, please use `$animate` to
 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
 * the CSS animation.
 *
 * The example below shows how we can create a folding animation on an element using `ng-if`:
 *
 * ```html
 * <!-- notice the `fold-animation` CSS class -->
 * <div ng-if="onOff" class="fold-animation">
 *   This element will go BOOM
 * </div>
 * <button ng-click="onOff=true">Fold In</button>
 * ```
 *
 * Now we create the **JavaScript animation** that will trigger the CSS transition:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * ## More Advanced Uses
 *
 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
 *
 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
 * to provide a working animation that will run in CSS.
 *
 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         addClass: 'red large-text pulse-twice',
 *         easing: 'ease-out',
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
 *
 * ```css
 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
 * .red { background:red; }
 * .large-text { font-size:20px; }
 *
 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
 * .pulse-twice {
 *   animation: 0.5s pulse linear 2;
 *   -webkit-animation: 0.5s pulse linear 2;
 * }
 *
 * @keyframes pulse {
 *   from { transform: scale(0.5); }
 *   to { transform: scale(1.5); }
 * }
 *
 * @-webkit-keyframes pulse {
 *   from { -webkit-transform: scale(0.5); }
 *   to { -webkit-transform: scale(1.5); }
 * }
 * ```
 *
 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
 *
 * ## How the Options are handled
 *
 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
 * styles using the `from` and `to` properties.
 *
 * ```js
 * var animator = $animateCss(element, {
 *   from: { background:'red' },
 *   to: { background:'blue' }
 * });
 * animator.start();
 * ```
 *
 * ```css
 * .rotating-animation {
 *   animation:0.5s rotate linear;
 *   -webkit-animation:0.5s rotate linear;
 * }
 *
 * @keyframes rotate {
 *   from { transform: rotate(0deg); }
 *   to { transform: rotate(360deg); }
 * }
 *
 * @-webkit-keyframes rotate {
 *   from { -webkit-transform: rotate(0deg); }
 *   to { -webkit-transform: rotate(360deg); }
 * }
 * ```
 *
 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
 * and spread across the transition and keyframe animation.
 *
 * ## What is returned
 *
 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
 *
 * ```js
 * var animator = $animateCss(element, { ... });
 * ```
 *
 * Now what do the contents of our `animator` variable look like:
 *
 * ```js
 * {
 *   // starts the animation
 *   start: Function,
 *
 *   // ends (aborts) the animation
 *   end: Function
 * }
 * ```
 *
 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
 * and that changing them will not reconfigure the parameters of the animation.
 *
 * ### runner.done() vs runner.then()
 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
 * unless you really need a digest to kick off afterwards.
 *
 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
 *
 * @param {DOMElement} element the element that will be animated
 * @param {object} options the animation-related options that will be applied during the animation
 *
 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
 * is provided then the animation will be skipped entirely.
 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
 * CSS delay value.
 * * `stagger` - A numeric time value representing the delay between successively animated elements
 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
 *    the animation is closed. This is useful for when the styles are used purely for the sake of
 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
 *    By default this value is set to `false`.
 *
 * @return {object} an object with start and end methods and details about the animation.
 *
 * * `start` - The method to start the animation. This will return a `Promise` when called.
 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
 */
var ONE_SECOND = 1000;

var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
var CLOSING_TIME_BUFFER = 1.5;

var DETECT_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP,
  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
};

var DETECT_STAGGER_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP
};

function getCssKeyframeDurationStyle(duration) {
  return [ANIMATION_DURATION_PROP, duration + 's'];
}

function getCssDelayStyle(delay, isKeyframeAnimation) {
  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
  return [prop, delay + 's'];
}

function computeCssStyles($window, element, properties) {
  var styles = Object.create(null);
  var detectedStyles = $window.getComputedStyle(element) || {};
  forEach(properties, function(formalStyleName, actualStyleName) {
    var val = detectedStyles[formalStyleName];
    if (val) {
      var c = val.charAt(0);

      // only numerical-based values have a negative sign or digit as the first value
      if (c === '-' || c === '+' || c >= 0) {
        val = parseMaxTime(val);
      }

      // by setting this to null in the event that the delay is not set or is set directly as 0
      // then we can still allow for negative values to be used later on and not mistake this
      // value for being greater than any other negative value.
      if (val === 0) {
        val = null;
      }
      styles[actualStyleName] = val;
    }
  });

  return styles;
}

function parseMaxTime(str) {
  var maxValue = 0;
  var values = str.split(/\s*,\s*/);
  forEach(values, function(value) {
    // it's always safe to consider only second values and omit `ms` values since
    // getComputedStyle will always handle the conversion for us
    if (value.charAt(value.length - 1) === 's') {
      value = value.substring(0, value.length - 1);
    }
    value = parseFloat(value) || 0;
    maxValue = maxValue ? Math.max(value, maxValue) : value;
  });
  return maxValue;
}

function truthyTimingValue(val) {
  return val === 0 || val != null;
}

function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
  var style = TRANSITION_PROP;
  var value = duration + 's';
  if (applyOnlyDuration) {
    style += DURATION_KEY;
  } else {
    value += ' linear all';
  }
  return [style, value];
}

function createLocalCacheLookup() {
  var cache = Object.create(null);
  return {
    flush: function() {
      cache = Object.create(null);
    },

    count: function(key) {
      var entry = cache[key];
      return entry ? entry.total : 0;
    },

    get: function(key) {
      var entry = cache[key];
      return entry && entry.value;
    },

    put: function(key, value) {
      if (!cache[key]) {
        cache[key] = { total: 1, value: value };
      } else {
        cache[key].total++;
      }
    }
  };
}

// we do not reassign an already present style value since
// if we detect the style property value again we may be
// detecting styles that were added via the `from` styles.
// We make use of `isDefined` here since an empty string
// or null value (which is what getPropertyValue will return
// for a non-existing style) will still be marked as a valid
// value for the style (a falsy value implies that the style
// is to be removed at the end of the animation). If we had a simple
// "OR" statement then it would not be enough to catch that.
function registerRestorableStyles(backup, node, properties) {
  forEach(properties, function(prop) {
    backup[prop] = isDefined(backup[prop])
        ? backup[prop]
        : node.style.getPropertyValue(prop);
  });
}

var $AnimateCssProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var gcsLookup = createLocalCacheLookup();
  var gcsStaggerLookup = createLocalCacheLookup();

  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout',
               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,
                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    var parentCounter = 0;
    function gcsHashFn(node, extraClasses) {
      var KEY = '$$ngAnimateParentKey';
      var parentNode = node.parentNode;
      var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
      return parentID + '-' + node.getAttribute('class') + '-' + extraClasses;
    }

    function computeCachedCssStyles(node, className, cacheKey, properties) {
      var timings = gcsLookup.get(cacheKey);

      if (!timings) {
        timings = computeCssStyles($window, node, properties);
        if (timings.animationIterationCount === 'infinite') {
          timings.animationIterationCount = 1;
        }
      }

      // we keep putting this in multiple times even though the value and the cacheKey are the same
      // because we're keeping an internal tally of how many duplicate animations are detected.
      gcsLookup.put(cacheKey, timings);
      return timings;
    }

    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
      var stagger;

      // if we have one or more existing matches of matching elements
      // containing the same parent + CSS styles (which is how cacheKey works)
      // then staggering is possible
      if (gcsLookup.count(cacheKey) > 0) {
        stagger = gcsStaggerLookup.get(cacheKey);

        if (!stagger) {
          var staggerClassName = pendClasses(className, '-stagger');

          $$jqLite.addClass(node, staggerClassName);

          stagger = computeCssStyles($window, node, properties);

          // force the conversion of a null value to zero incase not set
          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);

          $$jqLite.removeClass(node, staggerClassName);

          gcsStaggerLookup.put(cacheKey, stagger);
        }
      }

      return stagger || {};
    }

    var rafWaitQueue = [];
    function waitUntilQuiet(callback) {
      rafWaitQueue.push(callback);
      $$rAFScheduler.waitUntilQuiet(function() {
        gcsLookup.flush();
        gcsStaggerLookup.flush();

        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
        var pageWidth = $$forceReflow();

        // we use a for loop to ensure that if the queue is changed
        // during this looping then it will consider new requests
        for (var i = 0; i < rafWaitQueue.length; i++) {
          rafWaitQueue[i](pageWidth);
        }
        rafWaitQueue.length = 0;
      });
    }

    function computeTimings(node, className, cacheKey) {
      var timings = computeCachedCssStyles(node, className, cacheKey, DETECT_CSS_PROPERTIES);
      var aD = timings.animationDelay;
      var tD = timings.transitionDelay;
      timings.maxDelay = aD && tD
          ? Math.max(aD, tD)
          : (aD || tD);
      timings.maxDuration = Math.max(
          timings.animationDuration * timings.animationIterationCount,
          timings.transitionDuration);

      return timings;
    }

    return function init(element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
      var options = initialOptions || {};
      if (!options.$$prepared) {
        options = prepareAnimationOptions(copy(options));
      }

      var restoreStyles = {};
      var node = getDomNode(element);
      if (!node
          || !node.parentNode
          || !$$animateQueue.enabled()) {
        return closeAndReturnNoopAnimator();
      }

      var temporaryStyles = [];
      var classes = element.attr('class');
      var styles = packageStyles(options);
      var animationClosed;
      var animationPaused;
      var animationCompleted;
      var runner;
      var runnerHost;
      var maxDelay;
      var maxDelayTime;
      var maxDuration;
      var maxDurationTime;
      var startTime;
      var events = [];

      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
        return closeAndReturnNoopAnimator();
      }

      var method = options.event && isArray(options.event)
            ? options.event.join(' ')
            : options.event;

      var isStructural = method && options.structural;
      var structuralClassName = '';
      var addRemoveClassName = '';

      if (isStructural) {
        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
      } else if (method) {
        structuralClassName = method;
      }

      if (options.addClass) {
        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
      }

      if (options.removeClass) {
        if (addRemoveClassName.length) {
          addRemoveClassName += ' ';
        }
        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
      }

      // there may be a situation where a structural animation is combined together
      // with CSS classes that need to resolve before the animation is computed.
      // However this means that there is no explicit CSS code to block the animation
      // from happening (by setting 0s none in the class name). If this is the case
      // we need to apply the classes before the first rAF so we know to continue if
      // there actually is a detected transition or keyframe animation
      if (options.applyClassesEarly && addRemoveClassName.length) {
        applyAnimationClasses(element, options);
      }

      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
      var fullClassName = classes + ' ' + preparationClasses;
      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;

      // there is no way we can trigger an animation if no styles and
      // no classes are being applied which would then trigger a transition,
      // unless there a is raw keyframe value that is applied to the element.
      if (!containsKeyframeAnimation
           && !hasToStyles
           && !preparationClasses) {
        return closeAndReturnNoopAnimator();
      }

      var cacheKey, stagger;
      if (options.stagger > 0) {
        var staggerVal = parseFloat(options.stagger);
        stagger = {
          transitionDelay: staggerVal,
          animationDelay: staggerVal,
          transitionDuration: 0,
          animationDuration: 0
        };
      } else {
        cacheKey = gcsHashFn(node, fullClassName);
        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
      }

      if (!options.$$skipPreparationClasses) {
        $$jqLite.addClass(element, preparationClasses);
      }

      var applyOnlyDuration;

      if (options.transitionStyle) {
        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
        applyInlineStyle(node, transitionStyle);
        temporaryStyles.push(transitionStyle);
      }

      if (options.duration >= 0) {
        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);

        // we set the duration so that it will be picked up by getComputedStyle later
        applyInlineStyle(node, durationStyle);
        temporaryStyles.push(durationStyle);
      }

      if (options.keyframeStyle) {
        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
        applyInlineStyle(node, keyframeStyle);
        temporaryStyles.push(keyframeStyle);
      }

      var itemIndex = stagger
          ? options.staggerIndex >= 0
              ? options.staggerIndex
              : gcsLookup.count(cacheKey)
          : 0;

      var isFirst = itemIndex === 0;

      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
      // without causing any combination of transitions to kick in. By adding a negative delay value
      // it forces the setup class' transition to end immediately. We later then remove the negative
      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
      // that if there is no transition defined then nothing will happen and this will also allow
      // other transitions to be stacked on top of each other without any chopping them out.
      if (isFirst && !options.skipBlocking) {
        blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
      }

      var timings = computeTimings(node, fullClassName, cacheKey);
      var relativeDelay = timings.maxDelay;
      maxDelay = Math.max(relativeDelay, 0);
      maxDuration = timings.maxDuration;

      var flags = {};
      flags.hasTransitions          = timings.transitionDuration > 0;
      flags.hasAnimations           = timings.animationDuration > 0;
      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty === 'all';
      flags.applyTransitionDuration = hasToStyles && (
                                        (flags.hasTransitions && !flags.hasTransitionAll)
                                         || (flags.hasAnimations && !flags.hasTransitions));
      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
      flags.recalculateTimingStyles = addRemoveClassName.length > 0;

      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;

        if (flags.applyTransitionDuration) {
          flags.hasTransitions = true;
          timings.transitionDuration = maxDuration;
          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
        }

        if (flags.applyAnimationDuration) {
          flags.hasAnimations = true;
          timings.animationDuration = maxDuration;
          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
        }
      }

      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
        return closeAndReturnNoopAnimator();
      }

      if (options.delay != null) {
        var delayStyle;
        if (typeof options.delay !== 'boolean') {
          delayStyle = parseFloat(options.delay);
          // number in options.delay means we have to recalculate the delay for the closing timeout
          maxDelay = Math.max(delayStyle, 0);
        }

        if (flags.applyTransitionDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle));
        }

        if (flags.applyAnimationDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
        }
      }

      // we need to recalculate the delay value since we used a pre-emptive negative
      // delay value and the delay value is required for the final event checking. This
      // property will ensure that this will happen after the RAF phase has passed.
      if (options.duration == null && timings.transitionDuration > 0) {
        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
      }

      maxDelayTime = maxDelay * ONE_SECOND;
      maxDurationTime = maxDuration * ONE_SECOND;
      if (!options.skipBlocking) {
        flags.blockTransition = timings.transitionDuration > 0;
        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
                                       stagger.animationDelay > 0 &&
                                       stagger.animationDuration === 0;
      }

      if (options.from) {
        if (options.cleanupStyles) {
          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
        }
        applyAnimationFromStyles(element, options);
      }

      if (flags.blockTransition || flags.blockKeyframeAnimation) {
        applyBlocking(maxDuration);
      } else if (!options.skipBlocking) {
        blockTransitions(node, false);
      }

      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
      return {
        $$willAnimate: true,
        end: endFn,
        start: function() {
          if (animationClosed) return;

          runnerHost = {
            end: endFn,
            cancel: cancelFn,
            resume: null, //this will be set during the start() phase
            pause: null
          };

          runner = new $$AnimateRunner(runnerHost);

          waitUntilQuiet(start);

          // we don't have access to pause/resume the animation
          // since it hasn't run yet. AnimateRunner will therefore
          // set noop functions for resume and pause and they will
          // later be overridden once the animation is triggered
          return runner;
        }
      };

      function endFn() {
        close();
      }

      function cancelFn() {
        close(true);
      }

      function close(rejected) {
        // if the promise has been called already then we shouldn't close
        // the animation again
        if (animationClosed || (animationCompleted && animationPaused)) return;
        animationClosed = true;
        animationPaused = false;

        if (!options.$$skipPreparationClasses) {
          $$jqLite.removeClass(element, preparationClasses);
        }
        $$jqLite.removeClass(element, activeClasses);

        blockKeyframeAnimations(node, false);
        blockTransitions(node, false);

        forEach(temporaryStyles, function(entry) {
          // There is only one way to remove inline style properties entirely from elements.
          // By using `removeProperty` this works, but we need to convert camel-cased CSS
          // styles down to hyphenated values.
          node.style[entry[0]] = '';
        });

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);

        if (Object.keys(restoreStyles).length) {
          forEach(restoreStyles, function(value, prop) {
            if (value) {
              node.style.setProperty(prop, value);
            } else {
              node.style.removeProperty(prop);
            }
          });
        }

        // the reason why we have this option is to allow a synchronous closing callback
        // that is fired as SOON as the animation ends (when the CSS is removed) or if
        // the animation never takes off at all. A good example is a leave animation since
        // the element must be removed just after the animation is over or else the element
        // will appear on screen for one animation frame causing an overbearing flicker.
        if (options.onDone) {
          options.onDone();
        }

        if (events && events.length) {
          // Remove the transitionend / animationend listener(s)
          element.off(events.join(' '), onAnimationProgress);
        }

        //Cancel the fallback closing timeout and remove the timer data
        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
        if (animationTimerData) {
          $timeout.cancel(animationTimerData[0].timer);
          element.removeData(ANIMATE_TIMER_KEY);
        }

        // if the preparation function fails then the promise is not setup
        if (runner) {
          runner.complete(!rejected);
        }
      }

      function applyBlocking(duration) {
        if (flags.blockTransition) {
          blockTransitions(node, duration);
        }

        if (flags.blockKeyframeAnimation) {
          blockKeyframeAnimations(node, !!duration);
        }
      }

      function closeAndReturnNoopAnimator() {
        runner = new $$AnimateRunner({
          end: endFn,
          cancel: cancelFn
        });

        // should flush the cache animation
        waitUntilQuiet(noop);
        close();

        return {
          $$willAnimate: false,
          start: function() {
            return runner;
          },
          end: endFn
        };
      }

      function onAnimationProgress(event) {
        event.stopPropagation();
        var ev = event.originalEvent || event;

        // we now always use `Date.now()` due to the recent changes with
        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
        var timeStamp = ev.$manualTimeStamp || Date.now();

        /* Firefox (or possibly just Gecko) likes to not round values up
         * when a ms measurement is used for the animation */
        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));

        /* $manualTimeStamp is a mocked timeStamp value which is set
         * within browserTrigger(). This is only here so that tests can
         * mock animations properly. Real events fallback to event.timeStamp,
         * or, if they don't, then a timeStamp is automatically created for them.
         * We're checking to see if the timeStamp surpasses the expected delay,
         * but we're using elapsedTime instead of the timeStamp on the 2nd
         * pre-condition since animationPauseds sometimes close off early */
        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
          // we set this flag to ensure that if the transition is paused then, when resumed,
          // the animation will automatically close itself since transitions cannot be paused.
          animationCompleted = true;
          close();
        }
      }

      function start() {
        if (animationClosed) return;
        if (!node.parentNode) {
          close();
          return;
        }

        // even though we only pause keyframe animations here the pause flag
        // will still happen when transitions are used. Only the transition will
        // not be paused since that is not possible. If the animation ends when
        // paused then it will not complete until unpaused or cancelled.
        var playPause = function(playAnimation) {
          if (!animationCompleted) {
            animationPaused = !playAnimation;
            if (timings.animationDuration) {
              var value = blockKeyframeAnimations(node, animationPaused);
              if (animationPaused) {
                temporaryStyles.push(value);
              } else {
                removeFromArray(temporaryStyles, value);
              }
            }
          } else if (animationPaused && playAnimation) {
            animationPaused = false;
            close();
          }
        };

        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
        // being inherited from the parent. If the transition duration is zero then we can safely
        // rely that the delay value is an intentional stagger delay style.
        var maxStagger = itemIndex > 0
                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
                            (timings.animationDuration && stagger.animationDuration === 0))
                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
        if (maxStagger) {
          $timeout(triggerAnimationStart,
                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
                   false);
        } else {
          triggerAnimationStart();
        }

        // this will decorate the existing promise runner with pause/resume methods
        runnerHost.resume = function() {
          playPause(true);
        };

        runnerHost.pause = function() {
          playPause(false);
        };

        function triggerAnimationStart() {
          // just incase a stagger animation kicks in when the animation
          // itself was cancelled entirely
          if (animationClosed) return;

          applyBlocking(false);

          forEach(temporaryStyles, function(entry) {
            var key = entry[0];
            var value = entry[1];
            node.style[key] = value;
          });

          applyAnimationClasses(element, options);
          $$jqLite.addClass(element, activeClasses);

          if (flags.recalculateTimingStyles) {
            fullClassName = node.getAttribute('class') + ' ' + preparationClasses;
            cacheKey = gcsHashFn(node, fullClassName);

            timings = computeTimings(node, fullClassName, cacheKey);
            relativeDelay = timings.maxDelay;
            maxDelay = Math.max(relativeDelay, 0);
            maxDuration = timings.maxDuration;

            if (maxDuration === 0) {
              close();
              return;
            }

            flags.hasTransitions = timings.transitionDuration > 0;
            flags.hasAnimations = timings.animationDuration > 0;
          }

          if (flags.applyAnimationDelay) {
            relativeDelay = typeof options.delay !== 'boolean' && truthyTimingValue(options.delay)
                  ? parseFloat(options.delay)
                  : relativeDelay;

            maxDelay = Math.max(relativeDelay, 0);
            timings.animationDelay = relativeDelay;
            delayStyle = getCssDelayStyle(relativeDelay, true);
            temporaryStyles.push(delayStyle);
            node.style[delayStyle[0]] = delayStyle[1];
          }

          maxDelayTime = maxDelay * ONE_SECOND;
          maxDurationTime = maxDuration * ONE_SECOND;

          if (options.easing) {
            var easeProp, easeVal = options.easing;
            if (flags.hasTransitions) {
              easeProp = TRANSITION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
            if (flags.hasAnimations) {
              easeProp = ANIMATION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
          }

          if (timings.transitionDuration) {
            events.push(TRANSITIONEND_EVENT);
          }

          if (timings.animationDuration) {
            events.push(ANIMATIONEND_EVENT);
          }

          startTime = Date.now();
          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
          var endTime = startTime + timerTime;

          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
          var setupFallbackTimer = true;
          if (animationsData.length) {
            var currentTimerData = animationsData[0];
            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
            if (setupFallbackTimer) {
              $timeout.cancel(currentTimerData.timer);
            } else {
              animationsData.push(close);
            }
          }

          if (setupFallbackTimer) {
            var timer = $timeout(onAnimationExpired, timerTime, false);
            animationsData[0] = {
              timer: timer,
              expectedEndTime: endTime
            };
            animationsData.push(close);
            element.data(ANIMATE_TIMER_KEY, animationsData);
          }

          if (events.length) {
            element.on(events.join(' '), onAnimationProgress);
          }

          if (options.to) {
            if (options.cleanupStyles) {
              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
            }
            applyAnimationToStyles(element, options);
          }
        }

        function onAnimationExpired() {
          var animationsData = element.data(ANIMATE_TIMER_KEY);

          // this will be false in the event that the element was
          // removed from the DOM (via a leave animation or something
          // similar)
          if (animationsData) {
            for (var i = 1; i < animationsData.length; i++) {
              animationsData[i]();
            }
            element.removeData(ANIMATE_TIMER_KEY);
          }
        }
      }
    };
  }];
}];

var $$AnimateCssDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateCssDriver');

  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';

  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';

  function isDocumentFragment(node) {
    return node.parentNode && node.parentNode.nodeType === 11;
  }

  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {

    // only browsers that support these properties can render animations
    if (!$sniffer.animations && !$sniffer.transitions) return noop;

    var bodyNode = $document[0].body;
    var rootNode = getDomNode($rootElement);

    var rootBodyElement = jqLite(
      // this is to avoid using something that exists outside of the body
      // we also special case the doc fragment case because our unit test code
      // appends the $rootElement to the body after the app has been bootstrapped
      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
    );

    return function initDriverFn(animationDetails) {
      return animationDetails.from && animationDetails.to
          ? prepareFromToAnchorAnimation(animationDetails.from,
                                         animationDetails.to,
                                         animationDetails.classes,
                                         animationDetails.anchors)
          : prepareRegularAnimation(animationDetails);
    };

    function filterCssClasses(classes) {
      //remove all the `ng-` stuff
      return classes.replace(/\bng-\S+\b/g, '');
    }

    function getUniqueValues(a, b) {
      if (isString(a)) a = a.split(' ');
      if (isString(b)) b = b.split(' ');
      return a.filter(function(val) {
        return b.indexOf(val) === -1;
      }).join(' ');
    }

    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
      var startingClasses = filterCssClasses(getClassVal(clone));

      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);

      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);

      rootBodyElement.append(clone);

      var animatorIn, animatorOut = prepareOutAnimation();

      // the user may not end up using the `out` animation and
      // only making use of the `in` animation or vice-versa.
      // In either case we should allow this and not assume the
      // animation is over unless both animations are not used.
      if (!animatorOut) {
        animatorIn = prepareInAnimation();
        if (!animatorIn) {
          return end();
        }
      }

      var startingAnimator = animatorOut || animatorIn;

      return {
        start: function() {
          var runner;

          var currentAnimation = startingAnimator.start();
          currentAnimation.done(function() {
            currentAnimation = null;
            if (!animatorIn) {
              animatorIn = prepareInAnimation();
              if (animatorIn) {
                currentAnimation = animatorIn.start();
                currentAnimation.done(function() {
                  currentAnimation = null;
                  end();
                  runner.complete();
                });
                return currentAnimation;
              }
            }
            // in the event that there is no `in` animation
            end();
            runner.complete();
          });

          runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn
          });

          return runner;

          function endFn() {
            if (currentAnimation) {
              currentAnimation.end();
            }
          }
        }
      };

      function calculateAnchorStyles(anchor) {
        var styles = {};

        var coords = getDomNode(anchor).getBoundingClientRect();

        // we iterate directly since safari messes up and doesn't return
        // all the keys for the coords object when iterated
        forEach(['width','height','top','left'], function(key) {
          var value = coords[key];
          switch (key) {
            case 'top':
              value += bodyNode.scrollTop;
              break;
            case 'left':
              value += bodyNode.scrollLeft;
              break;
          }
          styles[key] = Math.floor(value) + 'px';
        });
        return styles;
      }

      function prepareOutAnimation() {
        var animator = $animateCss(clone, {
          addClass: NG_OUT_ANCHOR_CLASS_NAME,
          delay: true,
          from: calculateAnchorStyles(outAnchor)
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function getClassVal(element) {
        return element.attr('class') || '';
      }

      function prepareInAnimation() {
        var endingClasses = filterCssClasses(getClassVal(inAnchor));
        var toAdd = getUniqueValues(endingClasses, startingClasses);
        var toRemove = getUniqueValues(startingClasses, endingClasses);

        var animator = $animateCss(clone, {
          to: calculateAnchorStyles(inAnchor),
          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
          delay: true
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function end() {
        clone.remove();
        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
      }
    }

    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
      var fromAnimation = prepareRegularAnimation(from, noop);
      var toAnimation = prepareRegularAnimation(to, noop);

      var anchorAnimations = [];
      forEach(anchors, function(anchor) {
        var outElement = anchor['out'];
        var inElement = anchor['in'];
        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
        if (animator) {
          anchorAnimations.push(animator);
        }
      });

      // no point in doing anything when there are no elements to animate
      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;

      return {
        start: function() {
          var animationRunners = [];

          if (fromAnimation) {
            animationRunners.push(fromAnimation.start());
          }

          if (toAnimation) {
            animationRunners.push(toAnimation.start());
          }

          forEach(anchorAnimations, function(animation) {
            animationRunners.push(animation.start());
          });

          var runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
          });

          $$AnimateRunner.all(animationRunners, function(status) {
            runner.complete(status);
          });

          return runner;

          function endFn() {
            forEach(animationRunners, function(runner) {
              runner.end();
            });
          }
        }
      };
    }

    function prepareRegularAnimation(animationDetails) {
      var element = animationDetails.element;
      var options = animationDetails.options || {};

      if (animationDetails.structural) {
        options.event = animationDetails.event;
        options.structural = true;
        options.applyClassesEarly = true;

        // we special case the leave animation since we want to ensure that
        // the element is removed as soon as the animation is over. Otherwise
        // a flicker might appear or the element may not be removed at all
        if (animationDetails.event === 'leave') {
          options.onDone = options.domOperation;
        }
      }

      // We assign the preparationClasses as the actual animation event since
      // the internals of $animateCss will just suffix the event token values
      // with `-active` to trigger the animation.
      if (options.preparationClasses) {
        options.event = concatWithSpace(options.event, options.preparationClasses);
      }

      var animator = $animateCss(element, options);

      // the driver lookup code inside of $$animation attempts to spawn a
      // driver one by one until a driver returns a.$$willAnimate animator object.
      // $animateCss will always return an object, however, it will pass in
      // a flag as a hint as to whether an animation was detected or not
      return animator.$$willAnimate ? animator : null;
    }
  }];
}];

// TODO(matsko): use caching here to speed things up for detection
// TODO(matsko): add documentation
//  by the time...

var $$AnimateJsProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
       function($injector,   $$AnimateRunner,   $$jqLite) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
         // $animateJs(element, 'enter');
    return function(element, event, classes, options) {
      var animationClosed = false;

      // the `classes` argument is optional and if it is not used
      // then the classes will be resolved from the element's className
      // property as well as options.addClass/options.removeClass.
      if (arguments.length === 3 && isObject(classes)) {
        options = classes;
        classes = null;
      }

      options = prepareAnimationOptions(options);
      if (!classes) {
        classes = element.attr('class') || '';
        if (options.addClass) {
          classes += ' ' + options.addClass;
        }
        if (options.removeClass) {
          classes += ' ' + options.removeClass;
        }
      }

      var classesToAdd = options.addClass;
      var classesToRemove = options.removeClass;

      // the lookupAnimations function returns a series of animation objects that are
      // matched up with one or more of the CSS classes. These animation objects are
      // defined via the module.animation factory function. If nothing is detected then
      // we don't return anything which then makes $animation query the next driver.
      var animations = lookupAnimations(classes);
      var before, after;
      if (animations.length) {
        var afterFn, beforeFn;
        if (event === 'leave') {
          beforeFn = 'leave';
          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
        } else {
          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
          afterFn = event;
        }

        if (event !== 'enter' && event !== 'move') {
          before = packageAnimations(element, event, options, animations, beforeFn);
        }
        after  = packageAnimations(element, event, options, animations, afterFn);
      }

      // no matching animations
      if (!before && !after) return;

      function applyOptions() {
        options.domOperation();
        applyAnimationClasses(element, options);
      }

      function close() {
        animationClosed = true;
        applyOptions();
        applyAnimationStyles(element, options);
      }

      var runner;

      return {
        $$willAnimate: true,
        end: function() {
          if (runner) {
            runner.end();
          } else {
            close();
            runner = new $$AnimateRunner();
            runner.complete(true);
          }
          return runner;
        },
        start: function() {
          if (runner) {
            return runner;
          }

          runner = new $$AnimateRunner();
          var closeActiveAnimations;
          var chain = [];

          if (before) {
            chain.push(function(fn) {
              closeActiveAnimations = before(fn);
            });
          }

          if (chain.length) {
            chain.push(function(fn) {
              applyOptions();
              fn(true);
            });
          } else {
            applyOptions();
          }

          if (after) {
            chain.push(function(fn) {
              closeActiveAnimations = after(fn);
            });
          }

          runner.setHost({
            end: function() {
              endAnimations();
            },
            cancel: function() {
              endAnimations(true);
            }
          });

          $$AnimateRunner.chain(chain, onComplete);
          return runner;

          function onComplete(success) {
            close(success);
            runner.complete(success);
          }

          function endAnimations(cancelled) {
            if (!animationClosed) {
              (closeActiveAnimations || noop)(cancelled);
              onComplete(cancelled);
            }
          }
        }
      };

      function executeAnimationFn(fn, element, event, options, onDone) {
        var args;
        switch (event) {
          case 'animate':
            args = [element, options.from, options.to, onDone];
            break;

          case 'setClass':
            args = [element, classesToAdd, classesToRemove, onDone];
            break;

          case 'addClass':
            args = [element, classesToAdd, onDone];
            break;

          case 'removeClass':
            args = [element, classesToRemove, onDone];
            break;

          default:
            args = [element, onDone];
            break;
        }

        args.push(options);

        var value = fn.apply(fn, args);
        if (value) {
          if (isFunction(value.start)) {
            value = value.start();
          }

          if (value instanceof $$AnimateRunner) {
            value.done(onDone);
          } else if (isFunction(value)) {
            // optional onEnd / onCancel callback
            return value;
          }
        }

        return noop;
      }

      function groupEventedAnimations(element, event, options, animations, fnName) {
        var operations = [];
        forEach(animations, function(ani) {
          var animation = ani[fnName];
          if (!animation) return;

          // note that all of these animations will run in parallel
          operations.push(function() {
            var runner;
            var endProgressCb;

            var resolved = false;
            var onAnimationComplete = function(rejected) {
              if (!resolved) {
                resolved = true;
                (endProgressCb || noop)(rejected);
                runner.complete(!rejected);
              }
            };

            runner = new $$AnimateRunner({
              end: function() {
                onAnimationComplete();
              },
              cancel: function() {
                onAnimationComplete(true);
              }
            });

            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
              var cancelled = result === false;
              onAnimationComplete(cancelled);
            });

            return runner;
          });
        });

        return operations;
      }

      function packageAnimations(element, event, options, animations, fnName) {
        var operations = groupEventedAnimations(element, event, options, animations, fnName);
        if (operations.length === 0) {
          var a, b;
          if (fnName === 'beforeSetClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
          } else if (fnName === 'setClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
          }

          if (a) {
            operations = operations.concat(a);
          }
          if (b) {
            operations = operations.concat(b);
          }
        }

        if (operations.length === 0) return;

        // TODO(matsko): add documentation
        return function startAnimation(callback) {
          var runners = [];
          if (operations.length) {
            forEach(operations, function(animateFn) {
              runners.push(animateFn());
            });
          }

          if (runners.length) {
            $$AnimateRunner.all(runners, callback);
          }  else {
            callback();
          }

          return function endFn(reject) {
            forEach(runners, function(runner) {
              if (reject) {
                runner.cancel();
              } else {
                runner.end();
              }
            });
          };
        };
      }
    };

    function lookupAnimations(classes) {
      classes = isArray(classes) ? classes : classes.split(' ');
      var matches = [], flagMap = {};
      for (var i = 0; i < classes.length; i++) {
        var klass = classes[i],
            animationFactory = $animateProvider.$$registeredAnimations[klass];
        if (animationFactory && !flagMap[klass]) {
          matches.push($injector.get(animationFactory));
          flagMap[klass] = true;
        }
      }
      return matches;
    }
  }];
}];

var $$AnimateJsDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateJsDriver');
  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
    return function initDriverFn(animationDetails) {
      if (animationDetails.from && animationDetails.to) {
        var fromAnimation = prepareAnimation(animationDetails.from);
        var toAnimation = prepareAnimation(animationDetails.to);
        if (!fromAnimation && !toAnimation) return;

        return {
          start: function() {
            var animationRunners = [];

            if (fromAnimation) {
              animationRunners.push(fromAnimation.start());
            }

            if (toAnimation) {
              animationRunners.push(toAnimation.start());
            }

            $$AnimateRunner.all(animationRunners, done);

            var runner = new $$AnimateRunner({
              end: endFnFactory(),
              cancel: endFnFactory()
            });

            return runner;

            function endFnFactory() {
              return function() {
                forEach(animationRunners, function(runner) {
                  // at this point we cannot cancel animations for groups just yet. 1.5+
                  runner.end();
                });
              };
            }

            function done(status) {
              runner.complete(status);
            }
          }
        };
      } else {
        return prepareAnimation(animationDetails);
      }
    };

    function prepareAnimation(animationDetails) {
      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
      var element = animationDetails.element;
      var event = animationDetails.event;
      var options = animationDetails.options;
      var classes = animationDetails.classes;
      return $$animateJs(element, event, classes, options);
    }
  }];
}];

var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
var $$AnimateQueueProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var PRE_DIGEST_STATE = 1;
  var RUNNING_STATE = 2;
  var ONE_SPACE = ' ';

  var rules = this.rules = {
    skip: [],
    cancel: [],
    join: []
  };

  function makeTruthyCssClassMap(classString) {
    if (!classString) {
      return null;
    }

    var keys = classString.split(ONE_SPACE);
    var map = Object.create(null);

    forEach(keys, function(key) {
      map[key] = true;
    });
    return map;
  }

  function hasMatchingClasses(newClassString, currentClassString) {
    if (newClassString && currentClassString) {
      var currentClassMap = makeTruthyCssClassMap(currentClassString);
      return newClassString.split(ONE_SPACE).some(function(className) {
        return currentClassMap[className];
      });
    }
  }

  function isAllowed(ruleType, element, currentAnimation, previousAnimation) {
    return rules[ruleType].some(function(fn) {
      return fn(element, currentAnimation, previousAnimation);
    });
  }

  function hasAnimationClasses(animation, and) {
    var a = (animation.addClass || '').length > 0;
    var b = (animation.removeClass || '').length > 0;
    return and ? a && b : a || b;
  }

  rules.join.push(function(element, newAnimation, currentAnimation) {
    // if the new animation is class-based then we can just tack that on
    return !newAnimation.structural && hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(element, newAnimation, currentAnimation) {
    // there is no need to animate anything if no classes are being added and
    // there is no structural animation that will be triggered
    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(element, newAnimation, currentAnimation) {
    // why should we trigger a new structural animation if the element will
    // be removed from the DOM anyway?
    return currentAnimation.event === 'leave' && newAnimation.structural;
  });

  rules.skip.push(function(element, newAnimation, currentAnimation) {
    // if there is an ongoing current animation then don't even bother running the class-based animation
    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
  });

  rules.cancel.push(function(element, newAnimation, currentAnimation) {
    // there can never be two structural animations running at the same time
    return currentAnimation.structural && newAnimation.structural;
  });

  rules.cancel.push(function(element, newAnimation, currentAnimation) {
    // if the previous animation is already running, but the new animation will
    // be triggered, but the new animation is structural
    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
  });

  rules.cancel.push(function(element, newAnimation, currentAnimation) {
    // cancel the animation if classes added / removed in both animation cancel each other out,
    // but only if the current animation isn't structural

    if (currentAnimation.structural) return false;

    var nA = newAnimation.addClass;
    var nR = newAnimation.removeClass;
    var cA = currentAnimation.addClass;
    var cR = currentAnimation.removeClass;

    // early detection to save the global CPU shortage :)
    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
      return false;
    }

    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
  });

  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$HashMap',
               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
               '$$isDocumentHidden',
       function($$rAF,   $rootScope,   $rootElement,   $document,   $$HashMap,
                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow,
                $$isDocumentHidden) {

    var activeAnimationsLookup = new $$HashMap();
    var disabledElementsLookup = new $$HashMap();
    var animationsEnabled = null;

    function postDigestTaskFactory() {
      var postDigestCalled = false;
      return function(fn) {
        // we only issue a call to postDigest before
        // it has first passed. This prevents any callbacks
        // from not firing once the animation has completed
        // since it will be out of the digest cycle.
        if (postDigestCalled) {
          fn();
        } else {
          $rootScope.$$postDigest(function() {
            postDigestCalled = true;
            fn();
          });
        }
      };
    }

    // Wait until all directive and route-related templates are downloaded and
    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
    // all of the remote templates being currently downloaded. If there are no
    // templates currently downloading then the watcher will still fire anyway.
    var deregisterWatch = $rootScope.$watch(
      function() { return $templateRequest.totalPendingRequests === 0; },
      function(isEmpty) {
        if (!isEmpty) return;
        deregisterWatch();

        // Now that all templates have been downloaded, $animate will wait until
        // the post digest queue is empty before enabling animations. By having two
        // calls to $postDigest calls we can ensure that the flag is enabled at the
        // very end of the post digest queue. Since all of the animations in $animate
        // use $postDigest, it's important that the code below executes at the end.
        // This basically means that the page is fully downloaded and compiled before
        // any animations are triggered.
        $rootScope.$$postDigest(function() {
          $rootScope.$$postDigest(function() {
            // we check for null directly in the event that the application already called
            // .enabled() with whatever arguments that it provided it with
            if (animationsEnabled === null) {
              animationsEnabled = true;
            }
          });
        });
      }
    );

    var callbackRegistry = Object.create(null);

    // remember that the classNameFilter is set during the provider/config
    // stage therefore we can optimize here and setup a helper function
    var classNameFilter = $animateProvider.classNameFilter();
    var isAnimatableClassName = !classNameFilter
              ? function() { return true; }
              : function(className) {
                return classNameFilter.test(className);
              };

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function normalizeAnimationDetails(element, animation) {
      return mergeAnimationDetails(element, animation, {});
    }

    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
    var contains = window.Node.prototype.contains || /** @this */ function(arg) {
      // eslint-disable-next-line no-bitwise
      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
    };

    function findCallbacks(parent, element, event) {
      var targetNode = getDomNode(element);
      var targetParentNode = getDomNode(parent);

      var matches = [];
      var entries = callbackRegistry[event];
      if (entries) {
        forEach(entries, function(entry) {
          if (contains.call(entry.node, targetNode)) {
            matches.push(entry.callback);
          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
            matches.push(entry.callback);
          }
        });
      }

      return matches;
    }

    function filterFromRegistry(list, matchContainer, matchCallback) {
      var containerNode = extractElementNode(matchContainer);
      return list.filter(function(entry) {
        var isMatch = entry.node === containerNode &&
                        (!matchCallback || entry.callback === matchCallback);
        return !isMatch;
      });
    }

    function cleanupEventListeners(phase, element) {
      if (phase === 'close' && !element[0].parentNode) {
        // If the element is not attached to a parentNode, it has been removed by
        // the domOperation, and we can safely remove the event callbacks
        $animate.off(element);
      }
    }

    var $animate = {
      on: function(event, container, callback) {
        var node = extractElementNode(container);
        callbackRegistry[event] = callbackRegistry[event] || [];
        callbackRegistry[event].push({
          node: node,
          callback: callback
        });

        // Remove the callback when the element is removed from the DOM
        jqLite(container).on('$destroy', function() {
          var animationDetails = activeAnimationsLookup.get(node);

          if (!animationDetails) {
            // If there's an animation ongoing, the callback calling code will remove
            // the event listeners. If we'd remove here, the callbacks would be removed
            // before the animation ends
            $animate.off(event, container, callback);
          }
        });
      },

      off: function(event, container, callback) {
        if (arguments.length === 1 && !isString(arguments[0])) {
          container = arguments[0];
          for (var eventType in callbackRegistry) {
            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
          }

          return;
        }

        var entries = callbackRegistry[event];
        if (!entries) return;

        callbackRegistry[event] = arguments.length === 1
            ? null
            : filterFromRegistry(entries, container, callback);
      },

      pin: function(element, parentElement) {
        assertArg(isElement(element), 'element', 'not an element');
        assertArg(isElement(parentElement), 'parentElement', 'not an element');
        element.data(NG_ANIMATE_PIN_DATA, parentElement);
      },

      push: function(element, event, options, domOperation) {
        options = options || {};
        options.domOperation = domOperation;
        return queueAnimation(element, event, options);
      },

      // this method has four signatures:
      //  () - global getter
      //  (bool) - global setter
      //  (element) - element getter
      //  (element, bool) - element setter<F37>
      enabled: function(element, bool) {
        var argCount = arguments.length;

        if (argCount === 0) {
          // () - Global getter
          bool = !!animationsEnabled;
        } else {
          var hasElement = isElement(element);

          if (!hasElement) {
            // (bool) - Global setter
            bool = animationsEnabled = !!element;
          } else {
            var node = getDomNode(element);

            if (argCount === 1) {
              // (element) - Element getter
              bool = !disabledElementsLookup.get(node);
            } else {
              // (element, bool) - Element setter
              disabledElementsLookup.put(node, !bool);
            }
          }
        }

        return bool;
      }
    };

    return $animate;

    function queueAnimation(element, event, initialOptions) {
      // we always make a copy of the options since
      // there should never be any side effects on
      // the input data when running `$animateCss`.
      var options = copy(initialOptions);

      var node, parent;
      element = stripCommentsFromElement(element);
      if (element) {
        node = getDomNode(element);
        parent = element.parent();
      }

      options = prepareAnimationOptions(options);

      // we create a fake runner with a working promise.
      // These methods will become available after the digest has passed
      var runner = new $$AnimateRunner();

      // this is used to trigger callbacks in postDigest mode
      var runInNextPostDigestOrNow = postDigestTaskFactory();

      if (isArray(options.addClass)) {
        options.addClass = options.addClass.join(' ');
      }

      if (options.addClass && !isString(options.addClass)) {
        options.addClass = null;
      }

      if (isArray(options.removeClass)) {
        options.removeClass = options.removeClass.join(' ');
      }

      if (options.removeClass && !isString(options.removeClass)) {
        options.removeClass = null;
      }

      if (options.from && !isObject(options.from)) {
        options.from = null;
      }

      if (options.to && !isObject(options.to)) {
        options.to = null;
      }

      // there are situations where a directive issues an animation for
      // a jqLite wrapper that contains only comment nodes... If this
      // happens then there is no way we can perform an animation
      if (!node) {
        close();
        return runner;
      }

      var className = [node.getAttribute('class'), options.addClass, options.removeClass].join(' ');
      if (!isAnimatableClassName(className)) {
        close();
        return runner;
      }

      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      var documentHidden = $$isDocumentHidden();

      // this is a hard disable of all animations for the application or on
      // the element itself, therefore  there is no need to continue further
      // past this point if not enabled
      // Animations are also disabled if the document is currently hidden (page is not visible
      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
      var skipAnimations = !animationsEnabled || documentHidden || disabledElementsLookup.get(node);
      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
      var hasExistingAnimation = !!existingAnimation.state;

      // there is no point in traversing the same collection of parent ancestors if a followup
      // animation will be run on the same element that already did all that checking work
      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) {
        skipAnimations = !areAnimationsAllowed(element, parent, event);
      }

      if (skipAnimations) {
        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
        if (documentHidden) notifyProgress(runner, event, 'start');
        close();
        if (documentHidden) notifyProgress(runner, event, 'close');
        return runner;
      }

      if (isStructural) {
        closeChildAnimations(element);
      }

      var newAnimation = {
        structural: isStructural,
        element: element,
        event: event,
        addClass: options.addClass,
        removeClass: options.removeClass,
        close: close,
        options: options,
        runner: runner
      };

      if (hasExistingAnimation) {
        var skipAnimationFlag = isAllowed('skip', element, newAnimation, existingAnimation);
        if (skipAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            close();
            return runner;
          } else {
            mergeAnimationDetails(element, existingAnimation, newAnimation);
            return existingAnimation.runner;
          }
        }
        var cancelAnimationFlag = isAllowed('cancel', element, newAnimation, existingAnimation);
        if (cancelAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            // this will end the animation right away and it is safe
            // to do so since the animation is already running and the
            // runner callback code will run in async
            existingAnimation.runner.end();
          } else if (existingAnimation.structural) {
            // this means that the animation is queued into a digest, but
            // hasn't started yet. Therefore it is safe to run the close
            // method which will call the runner methods in async.
            existingAnimation.close();
          } else {
            // this will merge the new animation options into existing animation options
            mergeAnimationDetails(element, existingAnimation, newAnimation);

            return existingAnimation.runner;
          }
        } else {
          // a joined animation means that this animation will take over the existing one
          // so an example would involve a leave animation taking over an enter. Then when
          // the postDigest kicks in the enter will be ignored.
          var joinAnimationFlag = isAllowed('join', element, newAnimation, existingAnimation);
          if (joinAnimationFlag) {
            if (existingAnimation.state === RUNNING_STATE) {
              normalizeAnimationDetails(element, newAnimation);
            } else {
              applyGeneratedPreparationClasses(element, isStructural ? event : null, options);

              event = newAnimation.event = existingAnimation.event;
              options = mergeAnimationDetails(element, existingAnimation, newAnimation);

              //we return the same runner since only the option values of this animation will
              //be fed into the `existingAnimation`.
              return existingAnimation.runner;
            }
          }
        }
      } else {
        // normalization in this case means that it removes redundant CSS classes that
        // already exist (addClass) or do not exist (removeClass) on the element
        normalizeAnimationDetails(element, newAnimation);
      }

      // when the options are merged and cleaned up we may end up not having to do
      // an animation at all, therefore we should check this before issuing a post
      // digest callback. Structural animations will always run no matter what.
      var isValidAnimation = newAnimation.structural;
      if (!isValidAnimation) {
        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
                            || hasAnimationClasses(newAnimation);
      }

      if (!isValidAnimation) {
        close();
        clearElementAnimationState(element);
        return runner;
      }

      // the counter keeps track of cancelled animations
      var counter = (existingAnimation.counter || 0) + 1;
      newAnimation.counter = counter;

      markElementAnimationState(element, PRE_DIGEST_STATE, newAnimation);

      $rootScope.$$postDigest(function() {
        var animationDetails = activeAnimationsLookup.get(node);
        var animationCancelled = !animationDetails;
        animationDetails = animationDetails || {};

        // if addClass/removeClass is called before something like enter then the
        // registered parent element may not be present. The code below will ensure
        // that a final value for parent element is obtained
        var parentElement = element.parent() || [];

        // animate/structural/class-based animations all have requirements. Otherwise there
        // is no point in performing an animation. The parent node must also be set.
        var isValidAnimation = parentElement.length > 0
                                && (animationDetails.event === 'animate'
                                    || animationDetails.structural
                                    || hasAnimationClasses(animationDetails));

        // this means that the previous animation was cancelled
        // even if the follow-up animation is the same event
        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
          // if another animation did not take over then we need
          // to make sure that the domOperation and options are
          // handled accordingly
          if (animationCancelled) {
            applyAnimationClasses(element, options);
            applyAnimationStyles(element, options);
          }

          // if the event changed from something like enter to leave then we do
          // it, otherwise if it's the same then the end result will be the same too
          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
            options.domOperation();
            runner.end();
          }

          // in the event that the element animation was not cancelled or a follow-up animation
          // isn't allowed to animate from here then we need to clear the state of the element
          // so that any future animations won't read the expired animation data.
          if (!isValidAnimation) {
            clearElementAnimationState(element);
          }

          return;
        }

        // this combined multiple class to addClass / removeClass into a setClass event
        // so long as a structural event did not take over the animation
        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
            ? 'setClass'
            : animationDetails.event;

        markElementAnimationState(element, RUNNING_STATE);
        var realRunner = $$animation(element, event, animationDetails.options);

        // this will update the runner's flow-control events based on
        // the `realRunner` object.
        runner.setHost(realRunner);
        notifyProgress(runner, event, 'start', {});

        realRunner.done(function(status) {
          close(!status);
          var animationDetails = activeAnimationsLookup.get(node);
          if (animationDetails && animationDetails.counter === counter) {
            clearElementAnimationState(getDomNode(element));
          }
          notifyProgress(runner, event, 'close', {});
        });
      });

      return runner;

      function notifyProgress(runner, event, phase, data) {
        runInNextPostDigestOrNow(function() {
          var callbacks = findCallbacks(parent, element, event);
          if (callbacks.length) {
            // do not optimize this call here to RAF because
            // we don't know how heavy the callback code here will
            // be and if this code is buffered then this can
            // lead to a performance regression.
            $$rAF(function() {
              forEach(callbacks, function(callback) {
                callback(element, phase, data);
              });
              cleanupEventListeners(phase, element);
            });
          } else {
            cleanupEventListeners(phase, element);
          }
        });
        runner.progress(event, phase, data);
      }

      function close(reject) {
        clearGeneratedClasses(element, options);
        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();
        runner.complete(!reject);
      }
    }

    function closeChildAnimations(element) {
      var node = getDomNode(element);
      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
      forEach(children, function(child) {
        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
        var animationDetails = activeAnimationsLookup.get(child);
        if (animationDetails) {
          switch (state) {
            case RUNNING_STATE:
              animationDetails.runner.end();
              /* falls through */
            case PRE_DIGEST_STATE:
              activeAnimationsLookup.remove(child);
              break;
          }
        }
      });
    }

    function clearElementAnimationState(element) {
      var node = getDomNode(element);
      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
      activeAnimationsLookup.remove(node);
    }

    function isMatchingElement(nodeOrElmA, nodeOrElmB) {
      return getDomNode(nodeOrElmA) === getDomNode(nodeOrElmB);
    }

    /**
     * This fn returns false if any of the following is true:
     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
     * b) a parent element has an ongoing structural animation, and animateChildren is false
     * c) the element is not a child of the body
     * d) the element is not a child of the $rootElement
     */
    function areAnimationsAllowed(element, parentElement, event) {
      var bodyElement = jqLite($document[0].body);
      var bodyElementDetected = isMatchingElement(element, bodyElement) || element[0].nodeName === 'HTML';
      var rootElementDetected = isMatchingElement(element, $rootElement);
      var parentAnimationDetected = false;
      var animateChildren;
      var elementDisabled = disabledElementsLookup.get(getDomNode(element));

      var parentHost = jqLite.data(element[0], NG_ANIMATE_PIN_DATA);
      if (parentHost) {
        parentElement = parentHost;
      }

      parentElement = getDomNode(parentElement);

      while (parentElement) {
        if (!rootElementDetected) {
          // angular doesn't want to attempt to animate elements outside of the application
          // therefore we need to ensure that the rootElement is an ancestor of the current element
          rootElementDetected = isMatchingElement(parentElement, $rootElement);
        }

        if (parentElement.nodeType !== ELEMENT_NODE) {
          // no point in inspecting the #document element
          break;
        }

        var details = activeAnimationsLookup.get(parentElement) || {};
        // either an enter, leave or move animation will commence
        // therefore we can't allow any animations to take place
        // but if a parent animation is class-based then that's ok
        if (!parentAnimationDetected) {
          var parentElementDisabled = disabledElementsLookup.get(parentElement);

          if (parentElementDisabled === true && elementDisabled !== false) {
            // disable animations if the user hasn't explicitly enabled animations on the
            // current element
            elementDisabled = true;
            // element is disabled via parent element, no need to check anything else
            break;
          } else if (parentElementDisabled === false) {
            elementDisabled = false;
          }
          parentAnimationDetected = details.structural;
        }

        if (isUndefined(animateChildren) || animateChildren === true) {
          var value = jqLite.data(parentElement, NG_ANIMATE_CHILDREN_DATA);
          if (isDefined(value)) {
            animateChildren = value;
          }
        }

        // there is no need to continue traversing at this point
        if (parentAnimationDetected && animateChildren === false) break;

        if (!bodyElementDetected) {
          // we also need to ensure that the element is or will be a part of the body element
          // otherwise it is pointless to even issue an animation to be rendered
          bodyElementDetected = isMatchingElement(parentElement, bodyElement);
        }

        if (bodyElementDetected && rootElementDetected) {
          // If both body and root have been found, any other checks are pointless,
          // as no animation data should live outside the application
          break;
        }

        if (!rootElementDetected) {
          // If no rootElement is detected, check if the parentElement is pinned to another element
          parentHost = jqLite.data(parentElement, NG_ANIMATE_PIN_DATA);
          if (parentHost) {
            // The pin target element becomes the next parent element
            parentElement = getDomNode(parentHost);
            continue;
          }
        }

        parentElement = parentElement.parentNode;
      }

      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
      return allowAnimation && rootElementDetected && bodyElementDetected;
    }

    function markElementAnimationState(element, state, details) {
      details = details || {};
      details.state = state;

      var node = getDomNode(element);
      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);

      var oldValue = activeAnimationsLookup.get(node);
      var newValue = oldValue
          ? extend(oldValue, details)
          : details;
      activeAnimationsLookup.put(node, newValue);
    }
  }];
}];

/* exported $$AnimationProvider */

var $$AnimationProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';

  var drivers = this.drivers = [];

  var RUNNER_STORAGE_KEY = '$$animationRunner';

  function setRunner(element, runner) {
    element.data(RUNNER_STORAGE_KEY, runner);
  }

  function removeRunner(element) {
    element.removeData(RUNNER_STORAGE_KEY);
  }

  function getRunner(element) {
    return element.data(RUNNER_STORAGE_KEY);
  }

  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$HashMap', '$$rAFScheduler',
       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$HashMap,   $$rAFScheduler) {

    var animationQueue = [];
    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function sortAnimations(animations) {
      var tree = { children: [] };
      var i, lookup = new $$HashMap();

      // this is done first beforehand so that the hashmap
      // is filled with a list of the elements that will be animated
      for (i = 0; i < animations.length; i++) {
        var animation = animations[i];
        lookup.put(animation.domNode, animations[i] = {
          domNode: animation.domNode,
          fn: animation.fn,
          children: []
        });
      }

      for (i = 0; i < animations.length; i++) {
        processNode(animations[i]);
      }

      return flatten(tree);

      function processNode(entry) {
        if (entry.processed) return entry;
        entry.processed = true;

        var elementNode = entry.domNode;
        var parentNode = elementNode.parentNode;
        lookup.put(elementNode, entry);

        var parentEntry;
        while (parentNode) {
          parentEntry = lookup.get(parentNode);
          if (parentEntry) {
            if (!parentEntry.processed) {
              parentEntry = processNode(parentEntry);
            }
            break;
          }
          parentNode = parentNode.parentNode;
        }

        (parentEntry || tree).children.push(entry);
        return entry;
      }

      function flatten(tree) {
        var result = [];
        var queue = [];
        var i;

        for (i = 0; i < tree.children.length; i++) {
          queue.push(tree.children[i]);
        }

        var remainingLevelEntries = queue.length;
        var nextLevelEntries = 0;
        var row = [];

        for (i = 0; i < queue.length; i++) {
          var entry = queue[i];
          if (remainingLevelEntries <= 0) {
            remainingLevelEntries = nextLevelEntries;
            nextLevelEntries = 0;
            result.push(row);
            row = [];
          }
          row.push(entry.fn);
          entry.children.forEach(function(childEntry) {
            nextLevelEntries++;
            queue.push(childEntry);
          });
          remainingLevelEntries--;
        }

        if (row.length) {
          result.push(row);
        }

        return result;
      }
    }

    // TODO(matsko): document the signature in a better way
    return function(element, event, options) {
      options = prepareAnimationOptions(options);
      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      // there is no animation at the current moment, however
      // these runner methods will get later updated with the
      // methods leading into the driver's end/cancel methods
      // for now they just stop the animation from starting
      var runner = new $$AnimateRunner({
        end: function() { close(); },
        cancel: function() { close(true); }
      });

      if (!drivers.length) {
        close();
        return runner;
      }

      setRunner(element, runner);

      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
      var tempClasses = options.tempClasses;
      if (tempClasses) {
        classes += ' ' + tempClasses;
        options.tempClasses = null;
      }

      var prepareClassName;
      if (isStructural) {
        prepareClassName = 'ng-' + event + PREPARE_CLASS_SUFFIX;
        $$jqLite.addClass(element, prepareClassName);
      }

      animationQueue.push({
        // this data is used by the postDigest code and passed into
        // the driver step function
        element: element,
        classes: classes,
        event: event,
        structural: isStructural,
        options: options,
        beforeStart: beforeStart,
        close: close
      });

      element.on('$destroy', handleDestroyedElement);

      // we only want there to be one function called within the post digest
      // block. This way we can group animations for all the animations that
      // were apart of the same postDigest flush call.
      if (animationQueue.length > 1) return runner;

      $rootScope.$$postDigest(function() {
        var animations = [];
        forEach(animationQueue, function(entry) {
          // the element was destroyed early on which removed the runner
          // form its storage. This means we can't animate this element
          // at all and it already has been closed due to destruction.
          if (getRunner(entry.element)) {
            animations.push(entry);
          } else {
            entry.close();
          }
        });

        // now any future animations will be in another postDigest
        animationQueue.length = 0;

        var groupedAnimations = groupAnimations(animations);
        var toBeSortedAnimations = [];

        forEach(groupedAnimations, function(animationEntry) {
          toBeSortedAnimations.push({
            domNode: getDomNode(animationEntry.from ? animationEntry.from.element : animationEntry.element),
            fn: function triggerAnimationStart() {
              // it's important that we apply the `ng-animate` CSS class and the
              // temporary classes before we do any driver invoking since these
              // CSS classes may be required for proper CSS detection.
              animationEntry.beforeStart();

              var startAnimationFn, closeFn = animationEntry.close;

              // in the event that the element was removed before the digest runs or
              // during the RAF sequencing then we should not trigger the animation.
              var targetElement = animationEntry.anchors
                  ? (animationEntry.from.element || animationEntry.to.element)
                  : animationEntry.element;

              if (getRunner(targetElement)) {
                var operation = invokeFirstDriver(animationEntry);
                if (operation) {
                  startAnimationFn = operation.start;
                }
              }

              if (!startAnimationFn) {
                closeFn();
              } else {
                var animationRunner = startAnimationFn();
                animationRunner.done(function(status) {
                  closeFn(!status);
                });
                updateAnimationRunners(animationEntry, animationRunner);
              }
            }
          });
        });

        // we need to sort each of the animations in order of parent to child
        // relationships. This ensures that the child classes are applied at the
        // right time.
        $$rAFScheduler(sortAnimations(toBeSortedAnimations));
      });

      return runner;

      // TODO(matsko): change to reference nodes
      function getAnchorNodes(node) {
        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
              ? [node]
              : node.querySelectorAll(SELECTOR);
        var anchors = [];
        forEach(items, function(node) {
          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
          if (attr && attr.length) {
            anchors.push(node);
          }
        });
        return anchors;
      }

      function groupAnimations(animations) {
        var preparedAnimations = [];
        var refLookup = {};
        forEach(animations, function(animation, index) {
          var element = animation.element;
          var node = getDomNode(element);
          var event = animation.event;
          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];

          if (anchorNodes.length) {
            var direction = enterOrMove ? 'to' : 'from';

            forEach(anchorNodes, function(anchor) {
              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
              refLookup[key] = refLookup[key] || {};
              refLookup[key][direction] = {
                animationID: index,
                element: jqLite(anchor)
              };
            });
          } else {
            preparedAnimations.push(animation);
          }
        });

        var usedIndicesLookup = {};
        var anchorGroups = {};
        forEach(refLookup, function(operations, key) {
          var from = operations.from;
          var to = operations.to;

          if (!from || !to) {
            // only one of these is set therefore we can't have an
            // anchor animation since all three pieces are required
            var index = from ? from.animationID : to.animationID;
            var indexKey = index.toString();
            if (!usedIndicesLookup[indexKey]) {
              usedIndicesLookup[indexKey] = true;
              preparedAnimations.push(animations[index]);
            }
            return;
          }

          var fromAnimation = animations[from.animationID];
          var toAnimation = animations[to.animationID];
          var lookupKey = from.animationID.toString();
          if (!anchorGroups[lookupKey]) {
            var group = anchorGroups[lookupKey] = {
              structural: true,
              beforeStart: function() {
                fromAnimation.beforeStart();
                toAnimation.beforeStart();
              },
              close: function() {
                fromAnimation.close();
                toAnimation.close();
              },
              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
              from: fromAnimation,
              to: toAnimation,
              anchors: [] // TODO(matsko): change to reference nodes
            };

            // the anchor animations require that the from and to elements both have at least
            // one shared CSS class which effectively marries the two elements together to use
            // the same animation driver and to properly sequence the anchor animation.
            if (group.classes.length) {
              preparedAnimations.push(group);
            } else {
              preparedAnimations.push(fromAnimation);
              preparedAnimations.push(toAnimation);
            }
          }

          anchorGroups[lookupKey].anchors.push({
            'out': from.element, 'in': to.element
          });
        });

        return preparedAnimations;
      }

      function cssClassesIntersection(a,b) {
        a = a.split(' ');
        b = b.split(' ');
        var matches = [];

        for (var i = 0; i < a.length; i++) {
          var aa = a[i];
          if (aa.substring(0,3) === 'ng-') continue;

          for (var j = 0; j < b.length; j++) {
            if (aa === b[j]) {
              matches.push(aa);
              break;
            }
          }
        }

        return matches.join(' ');
      }

      function invokeFirstDriver(animationDetails) {
        // we loop in reverse order since the more general drivers (like CSS and JS)
        // may attempt more elements, but custom drivers are more particular
        for (var i = drivers.length - 1; i >= 0; i--) {
          var driverName = drivers[i];
          var factory = $injector.get(driverName);
          var driver = factory(animationDetails);
          if (driver) {
            return driver;
          }
        }
      }

      function beforeStart() {
        element.addClass(NG_ANIMATE_CLASSNAME);
        if (tempClasses) {
          $$jqLite.addClass(element, tempClasses);
        }
        if (prepareClassName) {
          $$jqLite.removeClass(element, prepareClassName);
          prepareClassName = null;
        }
      }

      function updateAnimationRunners(animation, newRunner) {
        if (animation.from && animation.to) {
          update(animation.from.element);
          update(animation.to.element);
        } else {
          update(animation.element);
        }

        function update(element) {
          var runner = getRunner(element);
          if (runner) runner.setHost(newRunner);
        }
      }

      function handleDestroyedElement() {
        var runner = getRunner(element);
        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
          runner.end();
        }
      }

      function close(rejected) {
        element.off('$destroy', handleDestroyedElement);
        removeRunner(element);

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();

        if (tempClasses) {
          $$jqLite.removeClass(element, tempClasses);
        }

        element.removeClass(NG_ANIMATE_CLASSNAME);
        runner.complete(!rejected);
      }
    };
  }];
}];

/**
 * @ngdoc directive
 * @name ngAnimateSwap
 * @restrict A
 * @scope
 *
 * @description
 *
 * ngAnimateSwap is a animation-oriented directive that allows for the container to
 * be removed and entered in whenever the associated expression changes. A
 * common usecase for this directive is a rotating banner or slider component which
 * contains one image being present at a time. When the active image changes
 * then the old image will perform a `leave` animation and the new element
 * will be inserted via an `enter` animation.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|--------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
 *
 * @example
 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
 *          deps="angular-animate.js"
 *          animations="true" fixBase="true">
 *   <file name="index.html">
 *     <div class="container" ng-controller="AppCtrl">
 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
 *         {{ number }}
 *       </div>
 *     </div>
 *   </file>
 *   <file name="script.js">
 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
 *         $scope.number = 0;
 *         $interval(function() {
 *           $scope.number++;
 *         }, 1000);
 *
 *         var colors = ['red','blue','green','yellow','orange'];
 *         $scope.colorClass = function(number) {
 *           return colors[number % colors.length];
 *         };
 *       }]);
 *   </file>
 *  <file name="animations.css">
 *  .container {
 *    height:250px;
 *    width:250px;
 *    position:relative;
 *    overflow:hidden;
 *    border:2px solid black;
 *  }
 *  .container .cell {
 *    font-size:150px;
 *    text-align:center;
 *    line-height:250px;
 *    position:absolute;
 *    top:0;
 *    left:0;
 *    right:0;
 *    border-bottom:2px solid black;
 *  }
 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
 *    transition:0.5s linear all;
 *  }
 *  .swap-animation.ng-enter {
 *    top:-250px;
 *  }
 *  .swap-animation.ng-enter-active {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave-active {
 *    top:250px;
 *  }
 *  .red { background:red; }
 *  .green { background:green; }
 *  .blue { background:blue; }
 *  .yellow { background:yellow; }
 *  .orange { background:orange; }
 *  </file>
 * </example>
 */
var ngAnimateSwapDirective = ['$animate', '$rootScope', function($animate, $rootScope) {
  return {
    restrict: 'A',
    transclude: 'element',
    terminal: true,
    priority: 600, // we use 600 here to ensure that the directive is caught before others
    link: function(scope, $element, attrs, ctrl, $transclude) {
      var previousElement, previousScope;
      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
        if (previousElement) {
          $animate.leave(previousElement);
        }
        if (previousScope) {
          previousScope.$destroy();
          previousScope = null;
        }
        if (value || value === 0) {
          previousScope = scope.$new();
          $transclude(previousScope, function(element) {
            previousElement = element;
            $animate.enter(element, null, $element);
          });
        }
      });
    }
  };
}];

/**
 * @ngdoc module
 * @name ngAnimate
 * @description
 *
 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an Angular app.
 *
 * <div doc-module-components="ngAnimate"></div>
 *
 * # Usage
 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
 * the HTML element that the animation will be triggered on.
 *
 * ## Directive Support
 * The following directives are "animation aware":
 *
 * | Directive                                                                                                | Supported Animations                                                     |
 * |----------------------------------------------------------------------------------------------------------|--------------------------------------------------------------------------|
 * | {@link ng.directive:ngRepeat#animations ngRepeat}                                                        | enter, leave and move                                                    |
 * | {@link ngRoute.directive:ngView#animations ngView}                                                       | enter and leave                                                          |
 * | {@link ng.directive:ngInclude#animations ngInclude}                                                      | enter and leave                                                          |
 * | {@link ng.directive:ngSwitch#animations ngSwitch}                                                        | enter and leave                                                          |
 * | {@link ng.directive:ngIf#animations ngIf}                                                                | enter and leave                                                          |
 * | {@link ng.directive:ngClass#animations ngClass}                                                          | add and remove (the CSS class(es) present)                               |
 * | {@link ng.directive:ngShow#animations ngShow} & {@link ng.directive:ngHide#animations ngHide}            | add and remove (the ng-hide class value)                                 |
 * | {@link ng.directive:form#animation-hooks form} & {@link ng.directive:ngModel#animation-hooks ngModel}    | add and remove (dirty, pristine, valid, invalid & all other validations) |
 * | {@link module:ngMessages#animations ngMessages}                                                          | add and remove (ng-active & ng-inactive)                                 |
 * | {@link module:ngMessages#animations ngMessage}                                                           | enter and leave                                                          |
 *
 * (More information can be found by visiting each the documentation associated with each directive.)
 *
 * ## CSS-based Animations
 *
 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
 * and CSS code we can create an animation that will be picked up by Angular when an underlying directive performs an operation.
 *
 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
 *
 * ```html
 * <div ng-if="bool" class="fade">
 *    Fade me in out
 * </div>
 * <button ng-click="bool=true">Fade In!</button>
 * <button ng-click="bool=false">Fade Out!</button>
 * ```
 *
 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
 *
 * ```css
 * /&#42; The starting CSS styles for the enter animation &#42;/
 * .fade.ng-enter {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 *
 * /&#42; The finishing CSS styles for the enter animation &#42;/
 * .fade.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * ```
 *
 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
 *
 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
 *
 * ```css
 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
 * .fade.ng-leave {
 *   transition:0.5s linear all;
 *   opacity:1;
 * }
 * .fade.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
 *
 * ```css
 * /&#42; there is no need to define anything inside of the destination
 * CSS class since the keyframe will take charge of the animation &#42;/
 * .fade.ng-leave {
 *   animation: my_fade_animation 0.5s linear;
 *   -webkit-animation: my_fade_animation 0.5s linear;
 * }
 *
 * @keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 *
 * @-webkit-keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 * ```
 *
 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
 *
 * ### CSS Class-based Animations
 *
 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
 * and removed.
 *
 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
 *
 * ```html
 * <div ng-show="bool" class="fade">
 *   Show and hide me
 * </div>
 * <button ng-click="bool=!bool">Toggle</button>
 *
 * <style>
 * .fade.ng-hide {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 * </style>
 * ```
 *
 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
 *
 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
 * with CSS styles.
 *
 * ```html
 * <div ng-class="{on:onOff}" class="highlight">
 *   Highlight this box
 * </div>
 * <button ng-click="onOff=!onOff">Toggle</button>
 *
 * <style>
 * .highlight {
 *   transition:0.5s linear all;
 * }
 * .highlight.on-add {
 *   background:white;
 * }
 * .highlight.on {
 *   background:yellow;
 * }
 * .highlight.on-remove {
 *   background:black;
 * }
 * </style>
 * ```
 *
 * We can also make use of CSS keyframes by placing them within the CSS classes.
 *
 *
 * ### CSS Staggering Animations
 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
 *
 * ```css
 * .my-animation.ng-enter {
 *   /&#42; standard transition code &#42;/
 *   transition: 1s linear all;
 *   opacity:0;
 * }
 * .my-animation.ng-enter-stagger {
 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
 *   transition-delay: 0.1s;
 *
 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
 *     to not accidentally inherit a delay property from another CSS class &#42;/
 *   transition-duration: 0s;
 * }
 * .my-animation.ng-enter.ng-enter-active {
 *   /&#42; standard transition styles &#42;/
 *   opacity:1;
 * }
 * ```
 *
 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
 *
 * The following code will issue the **ng-leave-stagger** event on the element provided:
 *
 * ```js
 * var kids = parent.children();
 *
 * $animate.leave(kids[0]); //stagger index=0
 * $animate.leave(kids[1]); //stagger index=1
 * $animate.leave(kids[2]); //stagger index=2
 * $animate.leave(kids[3]); //stagger index=3
 * $animate.leave(kids[4]); //stagger index=4
 *
 * window.requestAnimationFrame(function() {
 *   //stagger has reset itself
 *   $animate.leave(kids[5]); //stagger index=0
 *   $animate.leave(kids[6]); //stagger index=1
 *
 *   $scope.$digest();
 * });
 * ```
 *
 * Stagger animations are currently only supported within CSS-defined animations.
 *
 * ### The `ng-animate` CSS class
 *
 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
 *
 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
 *
 * ```css
 * .zipper.ng-animate {
 *   transition:0.5s linear all;
 * }
 * .zipper.ng-enter {
 *   opacity:0;
 * }
 * .zipper.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * .zipper.ng-leave {
 *   opacity:1;
 * }
 * .zipper.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
 * the CSS class once an animation has completed.)
 *
 *
 * ### The `ng-[event]-prepare` class
 *
 * This is a special class that can be used to prevent unwanted flickering / flash of content before
 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
 * before the actual animation starts (after waiting for a $digest).
 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
 *
 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
 * into elements that have class-based animations such as `ngClass`.
 *
 * ```html
 * <div ng-class="{red: myProp}">
 *   <div ng-class="{blue: myProp}">
 *     <div class="message" ng-if="myProp"></div>
 *   </div>
 * </div>
 * ```
 *
 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
 *
 * ```css
 * .message.ng-enter-prepare {
 *   opacity: 0;
 * }
 *
 * ```
 *
 * ## JavaScript-based Animations
 *
 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
 * `module.animation()` module function we can register the animation.
 *
 * Let's see an example of a enter/leave animation using `ngRepeat`:
 *
 * ```html
 * <div ng-repeat="item in items" class="slide">
 *   {{ item }}
 * </div>
 * ```
 *
 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     // make note that other events (like addClass/removeClass)
 *     // have different function input parameters
 *     enter: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *
 *       // remember to call doneFn so that angular
 *       // knows that the animation has concluded
 *     },
 *
 *     move: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *     },
 *
 *     leave: function(element, doneFn) {
 *       jQuery(element).fadeOut(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
 * greensock.js and velocity.js.
 *
 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
 *
 * ```html
 * <div ng-class="color" class="colorful">
 *   this box is moody
 * </div>
 * <button ng-click="color='red'">Change to red</button>
 * <button ng-click="color='blue'">Change to blue</button>
 * <button ng-click="color='green'">Change to green</button>
 * ```
 *
 * ```js
 * myModule.animation('.colorful', [function() {
 *   return {
 *     addClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     removeClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     setClass: function(element, addedClass, removedClass, doneFn) {
 *       // do some cool animation and call the doneFn
 *     }
 *   }
 * }]);
 * ```
 *
 * ## CSS + JS Animations Together
 *
 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of Angular,
 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
 * charge of the animation**:
 *
 * ```html
 * <div ng-if="bool" class="slide">
 *   Slide in and out
 * </div>
 * ```
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     enter: function(element, doneFn) {
 *       jQuery(element).slideIn(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * ```css
 * .slide.ng-enter {
 *   transition:0.5s linear all;
 *   transform:translateY(-100px);
 * }
 * .slide.ng-enter.ng-enter-active {
 *   transform:translateY(0);
 * }
 * ```
 *
 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
 * our own JS-based animation code:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
 *
 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
 * data into `$animateCss` directly:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true,
 *         addClass: 'maroon-setting',
 *         from: { height:0 },
 *         to: { height: 200 }
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Now we can fill in the rest via our transition CSS code:
 *
 * ```css
 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
 * .slide.ng-enter { transition:0.5s linear all; }
 *
 * /&#42; this extra CSS class will be absorbed into the transition
 * since the $animateCss code is adding the class &#42;/
 * .maroon-setting { background:red; }
 * ```
 *
 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
 *
 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
 *
 * ## Animation Anchoring (via `ng-animate-ref`)
 *
 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
 * structural areas of an application (like views) by pairing up elements using an attribute
 * called `ng-animate-ref`.
 *
 * Let's say for example we have two views that are managed by `ng-view` and we want to show
 * that there is a relationship between two components situated in within these views. By using the
 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
 * can then attach an animation, which is triggered when the view changes.
 *
 * Say for example we have the following template code:
 *
 * ```html
 * <!-- index.html -->
 * <div ng-view class="view-animation">
 * </div>
 *
 * <!-- home.html -->
 * <a href="#/banner-page">
 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * </a>
 *
 * <!-- banner-page.html -->
 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * ```
 *
 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
 * HTML contents to see if there is a match reference between any components in the view
 * that is leaving and the view that is entering. It will scan both the view which is being
 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
 * contain a matching ref value.
 *
 * The two images match since they share the same ref value. ngAnimate will now create a
 * transport element (which is a clone of the first image element) and it will then attempt
 * to animate to the position of the second image element in the next view. For the animation to
 * work a special CSS class called `ng-anchor` will be added to the transported element.
 *
 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
 * ngAnimate will handle the entire transition for us as well as the addition and removal of
 * any changes of CSS classes between the elements:
 *
 * ```css
 * .banner.ng-anchor {
 *   /&#42; this animation will last for 1 second since there are
 *          two phases to the animation (an `in` and an `out` phase) &#42;/
 *   transition:0.5s linear all;
 * }
 * ```
 *
 * We also **must** include animations for the views that are being entered and removed
 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
 *
 * ```css
 * .view-animation.ng-enter, .view-animation.ng-leave {
 *   transition:0.5s linear all;
 *   position:fixed;
 *   left:0;
 *   top:0;
 *   width:100%;
 * }
 * .view-animation.ng-enter {
 *   transform:translateX(100%);
 * }
 * .view-animation.ng-leave,
 * .view-animation.ng-enter.ng-enter-active {
 *   transform:translateX(0%);
 * }
 * .view-animation.ng-leave.ng-leave-active {
 *   transform:translateX(-100%);
 * }
 * ```
 *
 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
 * from its origin. Once that animation is over then the `in` stage occurs which animates the
 * element to its destination. The reason why there are two animations is to give enough time
 * for the enter animation on the new element to be ready.
 *
 * The example above sets up a transition for both the in and out phases, but we can also target the out or
 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
 *
 * ```css
 * .banner.ng-anchor-out {
 *   transition: 0.5s linear all;
 *
 *   /&#42; the scale will be applied during the out animation,
 *          but will be animated away when the in animation runs &#42;/
 *   transform: scale(1.2);
 * }
 *
 * .banner.ng-anchor-in {
 *   transition: 1s linear all;
 * }
 * ```
 *
 *
 *
 *
 * ### Anchoring Demo
 *
  <example module="anchoringExample"
           name="anchoringExample"
           id="anchoringExample"
           deps="angular-animate.js;angular-route.js"
           animations="true">
    <file name="index.html">
      <a href="#!/">Home</a>
      <hr />
      <div class="view-container">
        <div ng-view class="view"></div>
      </div>
    </file>
    <file name="script.js">
      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
        .config(['$routeProvider', function($routeProvider) {
          $routeProvider.when('/', {
            templateUrl: 'home.html',
            controller: 'HomeController as home'
          });
          $routeProvider.when('/profile/:id', {
            templateUrl: 'profile.html',
            controller: 'ProfileController as profile'
          });
        }])
        .run(['$rootScope', function($rootScope) {
          $rootScope.records = [
            { id: 1, title: 'Miss Beulah Roob' },
            { id: 2, title: 'Trent Morissette' },
            { id: 3, title: 'Miss Ava Pouros' },
            { id: 4, title: 'Rod Pouros' },
            { id: 5, title: 'Abdul Rice' },
            { id: 6, title: 'Laurie Rutherford Sr.' },
            { id: 7, title: 'Nakia McLaughlin' },
            { id: 8, title: 'Jordon Blanda DVM' },
            { id: 9, title: 'Rhoda Hand' },
            { id: 10, title: 'Alexandrea Sauer' }
          ];
        }])
        .controller('HomeController', [function() {
          //empty
        }])
        .controller('ProfileController', ['$rootScope', '$routeParams',
            function ProfileController($rootScope, $routeParams) {
          var index = parseInt($routeParams.id, 10);
          var record = $rootScope.records[index - 1];

          this.title = record.title;
          this.id = record.id;
        }]);
    </file>
    <file name="home.html">
      <h2>Welcome to the home page</h1>
      <p>Please click on an element</p>
      <a class="record"
         ng-href="#!/profile/{{ record.id }}"
         ng-animate-ref="{{ record.id }}"
         ng-repeat="record in records">
        {{ record.title }}
      </a>
    </file>
    <file name="profile.html">
      <div class="profile record" ng-animate-ref="{{ profile.id }}">
        {{ profile.title }}
      </div>
    </file>
    <file name="animations.css">
      .record {
        display:block;
        font-size:20px;
      }
      .profile {
        background:black;
        color:white;
        font-size:100px;
      }
      .view-container {
        position:relative;
      }
      .view-container > .view.ng-animate {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        min-height:500px;
      }
      .view.ng-enter, .view.ng-leave,
      .record.ng-anchor {
        transition:0.5s linear all;
      }
      .view.ng-enter {
        transform:translateX(100%);
      }
      .view.ng-enter.ng-enter-active, .view.ng-leave {
        transform:translateX(0%);
      }
      .view.ng-leave.ng-leave-active {
        transform:translateX(-100%);
      }
      .record.ng-anchor-out {
        background:red;
      }
    </file>
  </example>
 *
 * ### How is the element transported?
 *
 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
 * will become visible since the shim class will be removed.
 *
 * ### How is the morphing handled?
 *
 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
 * what CSS classes differ between the starting element and the destination element. These different CSS classes
 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
 * the cloned element is placed inside of root element which is likely close to the body element).
 *
 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
 *
 *
 * ## Using $animate in your directive code
 *
 * So far we've explored how to feed in animations into an Angular application, but how do we trigger animations within our own directives in our application?
 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
 * imagine we have a greeting box that shows and hides itself when the data changes
 *
 * ```html
 * <greeting-box active="onOrOff">Hi there</greeting-box>
 * ```
 *
 * ```js
 * ngModule.directive('greetingBox', ['$animate', function($animate) {
 *   return function(scope, element, attrs) {
 *     attrs.$observe('active', function(value) {
 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
 *     });
 *   });
 * }]);
 * ```
 *
 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
 * in our HTML code then we can trigger a CSS or JS animation to happen.
 *
 * ```css
 * /&#42; normally we would create a CSS class to reference on the element &#42;/
 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
 * ```
 *
 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
 * possible be sure to visit the {@link ng.$animate $animate service API page}.
 *
 *
 * ## Callbacks and Promises
 *
 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
 * ended by chaining onto the returned promise that animation method returns.
 *
 * ```js
 * // somewhere within the depths of the directive
 * $animate.enter(element, parent).then(function() {
 *   //the animation has completed
 * });
 * ```
 *
 * (Note that earlier versions of Angular prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
 * anymore.)
 *
 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
 * routing controller to hook into that:
 *
 * ```js
 * ngModule.controller('HomePageController', ['$animate', function($animate) {
 *   $animate.on('enter', ngViewElement, function(element) {
 *     // the animation for this route has completed
 *   }]);
 * }])
 * ```
 *
 * (Note that you will need to trigger a digest within the callback to get angular to notice any scope-related changes.)
 */

var copy;
var extend;
var forEach;
var isArray;
var isDefined;
var isElement;
var isFunction;
var isObject;
var isString;
var isUndefined;
var jqLite;
var noop;

/**
 * @ngdoc service
 * @name $animate
 * @kind object
 *
 * @description
 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
 *
 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
 */
angular.module('ngAnimate', [], function initAngularHelpers() {
  // Access helpers from angular core.
  // Do it inside a `config` block to ensure `window.angular` is available.
  noop        = angular.noop;
  copy        = angular.copy;
  extend      = angular.extend;
  jqLite      = angular.element;
  forEach     = angular.forEach;
  isArray     = angular.isArray;
  isString    = angular.isString;
  isObject    = angular.isObject;
  isUndefined = angular.isUndefined;
  isDefined   = angular.isDefined;
  isFunction  = angular.isFunction;
  isElement   = angular.isElement;
})
  .directive('ngAnimateSwap', ngAnimateSwapDirective)

  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
  .factory('$$rAFScheduler', $$rAFSchedulerFactory)

  .provider('$$animateQueue', $$AnimateQueueProvider)
  .provider('$$animation', $$AnimationProvider)

  .provider('$animateCss', $AnimateCssProvider)
  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)

  .provider('$$animateJs', $$AnimateJsProvider)
  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);


})(window, window.angular);

/**
 * @license AngularJS v1.6.1
 * (c) 2010-2016 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $sanitizeMinErr = angular.$$minErr('$sanitize');
var bind;
var extend;
var forEach;
var isDefined;
var lowercase;
var noop;
var htmlParser;
var htmlSanitizeWriter;

/**
 * @ngdoc module
 * @name ngSanitize
 * @description
 *
 * # ngSanitize
 *
 * The `ngSanitize` module provides functionality to sanitize HTML.
 *
 *
 * <div doc-module-components="ngSanitize"></div>
 *
 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
 */

/**
 * @ngdoc service
 * @name $sanitize
 * @kind function
 *
 * @description
 *   Sanitizes an html string by stripping all potentially dangerous tokens.
 *
 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
 *   then serialized back to properly escaped html string. This means that no unsafe input can make
 *   it into the returned string.
 *
 *   The whitelist for URL sanitization of attribute values is configured using the functions
 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
 *   `$compileProvider`}.
 *
 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
 *
 * @param {string} html HTML input.
 * @returns {string} Sanitized HTML.
 *
 * @example
   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
   <file name="index.html">
     <script>
         angular.module('sanitizeExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
             $scope.snippet =
               '<p style="color:blue">an html\n' +
               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
               'snippet</p>';
             $scope.deliberatelyTrustDangerousSnippet = function() {
               return $sce.trustAsHtml($scope.snippet);
             };
           }]);
     </script>
     <div ng-controller="ExampleController">
        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <td>Directive</td>
           <td>How</td>
           <td>Source</td>
           <td>Rendered</td>
         </tr>
         <tr id="bind-html-with-sanitize">
           <td>ng-bind-html</td>
           <td>Automatically uses $sanitize</td>
           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind-html="snippet"></div></td>
         </tr>
         <tr id="bind-html-with-trust">
           <td>ng-bind-html</td>
           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
           <td>
           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
&lt;/div&gt;</pre>
           </td>
           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
         </tr>
         <tr id="bind-default">
           <td>ng-bind</td>
           <td>Automatically escapes</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
       </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should sanitize the html snippet by default', function() {
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
     });

     it('should inline raw snippet if bound to a trusted value', function() {
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
         toBe("<p style=\"color:blue\">an html\n" +
              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
              "snippet</p>");
     });

     it('should escape snippet without any filter', function() {
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
              "snippet&lt;/p&gt;");
     });

     it('should update', function() {
       element(by.model('snippet')).clear();
       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
         toBe('new <b>text</b>');
       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
         'new <b onclick="alert(1)">text</b>');
       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
     });
   </file>
   </example>
 */


/**
 * @ngdoc provider
 * @name $sanitizeProvider
 * @this
 *
 * @description
 * Creates and configures {@link $sanitize} instance.
 */
function $SanitizeProvider() {
  var svgEnabled = false;

  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
    if (svgEnabled) {
      extend(validElements, svgElements);
    }
    return function(html) {
      var buf = [];
      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
      }));
      return buf.join('');
    };
  }];


  /**
   * @ngdoc method
   * @name $sanitizeProvider#enableSvg
   * @kind function
   *
   * @description
   * Enables a subset of svg to be supported by the sanitizer.
   *
   * <div class="alert alert-warning">
   *   <p>By enabling this setting without taking other precautions, you might expose your
   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
   *   link). Such behavior can then result in phishing incidents.</p>
   *
   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
   *   tags within the sanitized content:</p>
   *
   *   <br>
   *
   *   <pre><code>
   *   .rootOfTheIncludedContent svg {
   *     overflow: hidden !important;
   *   }
   *   </code></pre>
   * </div>
   *
   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
   * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
   *    without an argument or self for chaining otherwise.
   */
  this.enableSvg = function(enableSvg) {
    if (isDefined(enableSvg)) {
      svgEnabled = enableSvg;
      return this;
    } else {
      return svgEnabled;
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////
  // Private stuff
  //////////////////////////////////////////////////////////////////////////////////////////////////

  bind = angular.bind;
  extend = angular.extend;
  forEach = angular.forEach;
  isDefined = angular.isDefined;
  lowercase = angular.lowercase;
  noop = angular.noop;

  htmlParser = htmlParserImpl;
  htmlSanitizeWriter = htmlSanitizeWriterImpl;

  // Regular Expressions for parsing tags and attributes
  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
    // Match everything outside of normal chars and " (quote character)
    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;


  // Good source of info about elements and attributes
  // http://dev.w3.org/html5/spec/Overview.html#semantics
  // http://simon.html5.org/html-elements

  // Safe Void Elements - HTML5
  // http://dev.w3.org/html5/spec/Overview.html#void-elements
  var voidElements = toMap('area,br,col,hr,img,wbr');

  // Elements that you can, intentionally, leave open (and which close themselves)
  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
  var optionalEndTagBlockElements = toMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
      optionalEndTagInlineElements = toMap('rp,rt'),
      optionalEndTagElements = extend({},
                                              optionalEndTagInlineElements,
                                              optionalEndTagBlockElements);

  // Safe Block Elements - HTML5
  var blockElements = extend({}, optionalEndTagBlockElements, toMap('address,article,' +
          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));

  // Inline Elements - HTML5
  var inlineElements = extend({}, optionalEndTagInlineElements, toMap('a,abbr,acronym,b,' +
          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));

  // SVG Elements
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
  // They can potentially allow for arbitrary javascript to be executed. See #11290
  var svgElements = toMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
          'radialGradient,rect,stop,svg,switch,text,title,tspan');

  // Blocked Elements (will be stripped)
  var blockedElements = toMap('script,style');

  var validElements = extend({},
                                     voidElements,
                                     blockElements,
                                     inlineElements,
                                     optionalEndTagElements);

  //Attributes that have href and hence need to be sanitized
  var uriAttrs = toMap('background,cite,href,longdesc,src,xlink:href');

  var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
      'valign,value,vspace,width');

  // SVG attributes (without "id" and "name" attributes)
  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
  var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);

  var validAttrs = extend({},
                                  uriAttrs,
                                  svgAttrs,
                                  htmlAttrs);

  function toMap(str, lowercaseKeys) {
    var obj = {}, items = str.split(','), i;
    for (i = 0; i < items.length; i++) {
      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
    }
    return obj;
  }

  var inertBodyElement;
  (function(window) {
    var doc;
    if (window.document && window.document.implementation) {
      doc = window.document.implementation.createHTMLDocument('inert');
    } else {
      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
    }
    var docElement = doc.documentElement || doc.getDocumentElement();
    var bodyElements = docElement.getElementsByTagName('body');

    // usually there should be only one body element in the document, but IE doesn't have any, so we need to create one
    if (bodyElements.length === 1) {
      inertBodyElement = bodyElements[0];
    } else {
      var html = doc.createElement('html');
      inertBodyElement = doc.createElement('body');
      html.appendChild(inertBodyElement);
      doc.appendChild(html);
    }
  })(window);

  /**
   * @example
   * htmlParser(htmlString, {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * });
   *
   * @param {string} html string
   * @param {object} handler
   */
  function htmlParserImpl(html, handler) {
    if (html === null || html === undefined) {
      html = '';
    } else if (typeof html !== 'string') {
      html = '' + html;
    }
    inertBodyElement.innerHTML = html;

    //mXSS protection
    var mXSSAttempts = 5;
    do {
      if (mXSSAttempts === 0) {
        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
      }
      mXSSAttempts--;

      // strip custom-namespaced attributes on IE<=11
      if (window.document.documentMode) {
        stripCustomNsAttrs(inertBodyElement);
      }
      html = inertBodyElement.innerHTML; //trigger mXSS
      inertBodyElement.innerHTML = html;
    } while (html !== inertBodyElement.innerHTML);

    var node = inertBodyElement.firstChild;
    while (node) {
      switch (node.nodeType) {
        case 1: // ELEMENT_NODE
          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
          break;
        case 3: // TEXT NODE
          handler.chars(node.textContent);
          break;
      }

      var nextNode;
      if (!(nextNode = node.firstChild)) {
        if (node.nodeType === 1) {
          handler.end(node.nodeName.toLowerCase());
        }
        nextNode = node.nextSibling;
        if (!nextNode) {
          while (nextNode == null) {
            node = node.parentNode;
            if (node === inertBodyElement) break;
            nextNode = node.nextSibling;
            if (node.nodeType === 1) {
              handler.end(node.nodeName.toLowerCase());
            }
          }
        }
      }
      node = nextNode;
    }

    while ((node = inertBodyElement.firstChild)) {
      inertBodyElement.removeChild(node);
    }
  }

  function attrToMap(attrs) {
    var map = {};
    for (var i = 0, ii = attrs.length; i < ii; i++) {
      var attr = attrs[i];
      map[attr.name] = attr.value;
    }
    return map;
  }


  /**
   * Escapes all potentially dangerous characters, so that the
   * resulting string can be safely inserted into attribute or
   * element text.
   * @param value
   * @returns {string} escaped text
   */
  function encodeEntities(value) {
    return value.
      replace(/&/g, '&amp;').
      replace(SURROGATE_PAIR_REGEXP, function(value) {
        var hi = value.charCodeAt(0);
        var low = value.charCodeAt(1);
        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
      }).
      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
        return '&#' + value.charCodeAt(0) + ';';
      }).
      replace(/</g, '&lt;').
      replace(/>/g, '&gt;');
  }

  /**
   * create an HTML/XML writer which writes to buffer
   * @param {Array} buf use buf.join('') to get out sanitized html string
   * @returns {object} in the form of {
   *     start: function(tag, attrs) {},
   *     end: function(tag) {},
   *     chars: function(text) {},
   *     comment: function(text) {}
   * }
   */
  function htmlSanitizeWriterImpl(buf, uriValidator) {
    var ignoreCurrentElement = false;
    var out = bind(buf, buf.push);
    return {
      start: function(tag, attrs) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && blockedElements[tag]) {
          ignoreCurrentElement = tag;
        }
        if (!ignoreCurrentElement && validElements[tag] === true) {
          out('<');
          out(tag);
          forEach(attrs, function(value, key) {
            var lkey = lowercase(key);
            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
            if (validAttrs[lkey] === true &&
              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
              out(' ');
              out(key);
              out('="');
              out(encodeEntities(value));
              out('"');
            }
          });
          out('>');
        }
      },
      end: function(tag) {
        tag = lowercase(tag);
        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
          out('</');
          out(tag);
          out('>');
        }
        // eslint-disable-next-line eqeqeq
        if (tag == ignoreCurrentElement) {
          ignoreCurrentElement = false;
        }
      },
      chars: function(chars) {
        if (!ignoreCurrentElement) {
          out(encodeEntities(chars));
        }
      }
    };
  }


  /**
   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
   * to allow any of these custom attributes. This method strips them all.
   *
   * @param node Root element to process
   */
  function stripCustomNsAttrs(node) {
    while (node) {
      if (node.nodeType === window.Node.ELEMENT_NODE) {
        var attrs = node.attributes;
        for (var i = 0, l = attrs.length; i < l; i++) {
          var attrNode = attrs[i];
          var attrName = attrNode.name.toLowerCase();
          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
            node.removeAttributeNode(attrNode);
            i--;
            l--;
          }
        }
      }

      var nextNode = node.firstChild;
      if (nextNode) {
        stripCustomNsAttrs(nextNode);
      }

      node = node.nextSibling;
    }
  }
}

function sanitizeText(chars) {
  var buf = [];
  var writer = htmlSanitizeWriter(buf, noop);
  writer.chars(chars);
  return buf.join('');
}


// define ngSanitize module and register $sanitize service
angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);

/**
 * @ngdoc filter
 * @name linky
 * @kind function
 *
 * @description
 * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
 * plain email address links.
 *
 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
 *
 * @param {string} text Input text.
 * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
 *
 *    Can be one of:
 *
 *    - `object`: A map of attributes
 *    - `function`: Takes the url as a parameter and returns a map of attributes
 *
 *    If the map of attributes contains a value for `target`, it overrides the value of
 *    the target parameter.
 *
 *
 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
 *
 * @usage
   <span ng-bind-html="linky_expression | linky"></span>
 *
 * @example
   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
     <file name="index.html">
       <div ng-controller="ExampleController">
       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
       <table>
         <tr>
           <th>Filter</th>
           <th>Source</th>
           <th>Rendered</th>
         </tr>
         <tr id="linky-filter">
           <td>linky filter</td>
           <td>
             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
           </td>
           <td>
             <div ng-bind-html="snippet | linky"></div>
           </td>
         </tr>
         <tr id="linky-target">
          <td>linky target</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
          </td>
         </tr>
         <tr id="linky-custom-attributes">
          <td>linky custom attributes</td>
          <td>
            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
          </td>
          <td>
            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
          </td>
         </tr>
         <tr id="escaped-html">
           <td>no filter</td>
           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
           <td><div ng-bind="snippet"></div></td>
         </tr>
       </table>
     </file>
     <file name="script.js">
       angular.module('linkyExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.snippet =
             'Pretty text with some links:\n' +
             'http://angularjs.org/,\n' +
             'mailto:us@somewhere.org,\n' +
             'another@somewhere.org,\n' +
             'and one more: ftp://127.0.0.1/.';
           $scope.snippetWithSingleURL = 'http://angularjs.org/';
         }]);
     </file>
     <file name="protractor.js" type="protractor">
       it('should linkify the snippet with urls', function() {
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
       });

       it('should not linkify snippet without the linky filter', function() {
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
       });

       it('should update', function() {
         element(by.model('snippet')).clear();
         element(by.model('snippet')).sendKeys('new http://link.');
         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
             toBe('new http://link.');
         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
             .toBe('new http://link.');
       });

       it('should work with the target property', function() {
        expect(element(by.id('linky-target')).
            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
       });

       it('should optionally add custom attributes', function() {
        expect(element(by.id('linky-custom-attributes')).
            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
            toBe('http://angularjs.org/');
        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
       });
     </file>
   </example>
 */
angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
  var LINKY_URL_REGEXP =
        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
      MAILTO_REGEXP = /^mailto:/i;

  var linkyMinErr = angular.$$minErr('linky');
  var isDefined = angular.isDefined;
  var isFunction = angular.isFunction;
  var isObject = angular.isObject;
  var isString = angular.isString;

  return function(text, target, attributes) {
    if (text == null || text === '') return text;
    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);

    var attributesFn =
      isFunction(attributes) ? attributes :
      isObject(attributes) ? function getAttributesObject() {return attributes;} :
      function getEmptyAttributesObject() {return {};};

    var match;
    var raw = text;
    var html = [];
    var url;
    var i;
    while ((match = raw.match(LINKY_URL_REGEXP))) {
      // We can not end in these as they are sometimes found at the end of the sentence
      url = match[0];
      // if we did not match ftp/http/www/mailto then assume mailto
      if (!match[2] && !match[4]) {
        url = (match[3] ? 'http://' : 'mailto:') + url;
      }
      i = match.index;
      addText(raw.substr(0, i));
      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
      raw = raw.substring(i + match[0].length);
    }
    addText(raw);
    return $sanitize(html.join(''));

    function addText(text) {
      if (!text) {
        return;
      }
      html.push(sanitizeText(text));
    }

    function addLink(url, text) {
      var key, linkAttributes = attributesFn(url);
      html.push('<a ');

      for (key in linkAttributes) {
        html.push(key + '="' + linkAttributes[key] + '" ');
      }

      if (isDefined(target) && !('target' in linkAttributes)) {
        html.push('target="',
                  target,
                  '" ');
      }
      html.push('href="',
                url.replace(/"/g, '&quot;'),
                '">');
      addText(text);
      html.push('</a>');
    }
  };
}]);


})(window, window.angular);

/**
 * @license AngularJS v1.6.1
 * (c) 2010-2016 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* global ngTouchClickDirectiveFactory: false */

/**
 * @ngdoc module
 * @name ngTouch
 * @description
 *
 * # ngTouch
 *
 * The `ngTouch` module provides touch events and other helpers for touch-enabled devices.
 * The implementation is based on jQuery Mobile touch event handling
 * ([jquerymobile.com](http://jquerymobile.com/)).
 *
 *
 * See {@link ngTouch.$swipe `$swipe`} for usage.
 *
 * <div doc-module-components="ngTouch"></div>
 *
 */

// define ngTouch module
/* global -ngTouch */
var ngTouch = angular.module('ngTouch', []);

ngTouch.provider('$touch', $TouchProvider);

function nodeName_(element) {
  return angular.lowercase(element.nodeName || (element[0] && element[0].nodeName));
}

/**
 * @ngdoc provider
 * @name $touchProvider
 *
 * @description
 * The `$touchProvider` allows enabling / disabling {@link ngTouch.ngClick ngTouch's ngClick directive}.
 */
$TouchProvider.$inject = ['$provide', '$compileProvider'];
function $TouchProvider($provide, $compileProvider) {

  /**
   * @ngdoc method
   * @name  $touchProvider#ngClickOverrideEnabled
   *
   * @param {boolean=} enabled update the ngClickOverrideEnabled state if provided, otherwise just return the
   * current ngClickOverrideEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable {@link ngTouch.ngClick ngTouch's ngClick directive}. If enabled,
   * the default ngClick directive will be replaced by a version that eliminates the 300ms delay for
   * click events on browser for touch-devices.
   *
   * The default is `false`.
   *
   */
  var ngClickOverrideEnabled = false;
  var ngClickDirectiveAdded = false;
  // eslint-disable-next-line no-invalid-this
  this.ngClickOverrideEnabled = function(enabled) {
    if (angular.isDefined(enabled)) {

      if (enabled && !ngClickDirectiveAdded) {
        ngClickDirectiveAdded = true;

        // Use this to identify the correct directive in the delegate
        ngTouchClickDirectiveFactory.$$moduleName = 'ngTouch';
        $compileProvider.directive('ngClick', ngTouchClickDirectiveFactory);

        $provide.decorator('ngClickDirective', ['$delegate', function($delegate) {
          if (ngClickOverrideEnabled) {
            // drop the default ngClick directive
            $delegate.shift();
          } else {
            // drop the ngTouch ngClick directive if the override has been re-disabled (because
            // we cannot de-register added directives)
            var i = $delegate.length - 1;
            while (i >= 0) {
              if ($delegate[i].$$moduleName === 'ngTouch') {
                $delegate.splice(i, 1);
                break;
              }
              i--;
            }
          }

          return $delegate;
        }]);
      }

      ngClickOverrideEnabled = enabled;
      return this;
    }

    return ngClickOverrideEnabled;
  };

  /**
  * @ngdoc service
  * @name $touch
  * @kind object
  *
  * @description
  * Provides the {@link ngTouch.$touch#ngClickOverrideEnabled `ngClickOverrideEnabled`} method.
  *
  */
  // eslint-disable-next-line no-invalid-this
  this.$get = function() {
    return {
      /**
       * @ngdoc method
       * @name  $touch#ngClickOverrideEnabled
       *
       * @returns {*} current value of `ngClickOverrideEnabled` set in the {@link ngTouch.$touchProvider $touchProvider},
       * i.e. if {@link ngTouch.ngClick ngTouch's ngClick} directive is enabled.
       *
       * @kind function
       */
      ngClickOverrideEnabled: function() {
        return ngClickOverrideEnabled;
      }
    };
  };

}

/* global ngTouch: false */

    /**
     * @ngdoc service
     * @name $swipe
     *
     * @description
     * The `$swipe` service is a service that abstracts the messier details of hold-and-drag swipe
     * behavior, to make implementing swipe-related directives more convenient.
     *
     * Requires the {@link ngTouch `ngTouch`} module to be installed.
     *
     * `$swipe` is used by the `ngSwipeLeft` and `ngSwipeRight` directives in `ngTouch`.
     *
     * # Usage
     * The `$swipe` service is an object with a single method: `bind`. `bind` takes an element
     * which is to be watched for swipes, and an object with four handler functions. See the
     * documentation for `bind` below.
     */

ngTouch.factory('$swipe', [function() {
  // The total distance in any direction before we make the call on swipe vs. scroll.
  var MOVE_BUFFER_RADIUS = 10;

  var POINTER_EVENTS = {
    'mouse': {
      start: 'mousedown',
      move: 'mousemove',
      end: 'mouseup'
    },
    'touch': {
      start: 'touchstart',
      move: 'touchmove',
      end: 'touchend',
      cancel: 'touchcancel'
    },
    'pointer': {
      start: 'pointerdown',
      move: 'pointermove',
      end: 'pointerup',
      cancel: 'pointercancel'
    }
  };

  function getCoordinates(event) {
    var originalEvent = event.originalEvent || event;
    var touches = originalEvent.touches && originalEvent.touches.length ? originalEvent.touches : [originalEvent];
    var e = (originalEvent.changedTouches && originalEvent.changedTouches[0]) || touches[0];

    return {
      x: e.clientX,
      y: e.clientY
    };
  }

  function getEvents(pointerTypes, eventType) {
    var res = [];
    angular.forEach(pointerTypes, function(pointerType) {
      var eventName = POINTER_EVENTS[pointerType][eventType];
      if (eventName) {
        res.push(eventName);
      }
    });
    return res.join(' ');
  }

  return {
    /**
     * @ngdoc method
     * @name $swipe#bind
     *
     * @description
     * The main method of `$swipe`. It takes an element to be watched for swipe motions, and an
     * object containing event handlers.
     * The pointer types that should be used can be specified via the optional
     * third argument, which is an array of strings `'mouse'`, `'touch'` and `'pointer'`. By default,
     * `$swipe` will listen for `mouse`, `touch` and `pointer` events.
     *
     * The four events are `start`, `move`, `end`, and `cancel`. `start`, `move`, and `end`
     * receive as a parameter a coordinates object of the form `{ x: 150, y: 310 }` and the raw
     * `event`. `cancel` receives the raw `event` as its single parameter.
     *
     * `start` is called on either `mousedown`, `touchstart` or `pointerdown`. After this event, `$swipe` is
     * watching for `touchmove`, `mousemove` or `pointermove` events. These events are ignored until the total
     * distance moved in either dimension exceeds a small threshold.
     *
     * Once this threshold is exceeded, either the horizontal or vertical delta is greater.
     * - If the horizontal distance is greater, this is a swipe and `move` and `end` events follow.
     * - If the vertical distance is greater, this is a scroll, and we let the browser take over.
     *   A `cancel` event is sent.
     *
     * `move` is called on `mousemove`, `touchmove` and `pointermove` after the above logic has determined that
     * a swipe is in progress.
     *
     * `end` is called when a swipe is successfully completed with a `touchend`, `mouseup` or `pointerup`.
     *
     * `cancel` is called either on a `touchcancel` or `pointercancel`  from the browser, or when we begin scrolling
     * as described above.
     *
     */
    bind: function(element, eventHandlers, pointerTypes) {
      // Absolute total movement, used to control swipe vs. scroll.
      var totalX, totalY;
      // Coordinates of the start position.
      var startCoords;
      // Last event's position.
      var lastPos;
      // Whether a swipe is active.
      var active = false;

      pointerTypes = pointerTypes || ['mouse', 'touch', 'pointer'];
      element.on(getEvents(pointerTypes, 'start'), function(event) {
        startCoords = getCoordinates(event);
        active = true;
        totalX = 0;
        totalY = 0;
        lastPos = startCoords;
        if (eventHandlers['start']) {
          eventHandlers['start'](startCoords, event);
        }
      });
      var events = getEvents(pointerTypes, 'cancel');
      if (events) {
        element.on(events, function(event) {
          active = false;
          if (eventHandlers['cancel']) {
            eventHandlers['cancel'](event);
          }
        });
      }

      element.on(getEvents(pointerTypes, 'move'), function(event) {
        if (!active) return;

        // Android will send a touchcancel if it thinks we're starting to scroll.
        // So when the total distance (+ or - or both) exceeds 10px in either direction,
        // we either:
        // - On totalX > totalY, we send preventDefault() and treat this as a swipe.
        // - On totalY > totalX, we let the browser handle it as a scroll.

        if (!startCoords) return;
        var coords = getCoordinates(event);

        totalX += Math.abs(coords.x - lastPos.x);
        totalY += Math.abs(coords.y - lastPos.y);

        lastPos = coords;

        if (totalX < MOVE_BUFFER_RADIUS && totalY < MOVE_BUFFER_RADIUS) {
          return;
        }

        // One of totalX or totalY has exceeded the buffer, so decide on swipe vs. scroll.
        if (totalY > totalX) {
          // Allow native scrolling to take over.
          active = false;
          if (eventHandlers['cancel']) {
            eventHandlers['cancel'](event);
          }
          return;
        } else {
          // Prevent the browser from scrolling.
          event.preventDefault();
          if (eventHandlers['move']) {
            eventHandlers['move'](coords, event);
          }
        }
      });

      element.on(getEvents(pointerTypes, 'end'), function(event) {
        if (!active) return;
        active = false;
        if (eventHandlers['end']) {
          eventHandlers['end'](getCoordinates(event), event);
        }
      });
    }
  };
}]);

/* global ngTouch: false,
  nodeName_: false
*/

/**
 * @ngdoc directive
 * @name ngClick
 * @deprecated
 * sinceVersion="v1.5.0"
 * This directive is deprecated and **disabled** by default.
 * The directive will receive no further support and might be removed from future releases.
 * If you need the directive, you can enable it with the {@link ngTouch.$touchProvider $touchProvider#ngClickOverrideEnabled}
 * function. We also recommend that you migrate to [FastClick](https://github.com/ftlabs/fastclick).
 * To learn more about the 300ms delay, this [Telerik article](http://developer.telerik.com/featured/300-ms-click-delay-ios-8/)
 * gives a good overview.
 *
 * @description
 * A more powerful replacement for the default ngClick designed to be used on touchscreen
 * devices. Most mobile browsers wait about 300ms after a tap-and-release before sending
 * the click event. This version handles them immediately, and then prevents the
 * following click event from propagating.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * This directive can fall back to using an ordinary click event, and so works on desktop
 * browsers as well as mobile.
 *
 * This directive also sets the CSS class `ng-click-active` while the element is being held
 * down (by a mouse click or touch) so you can restyle the depressed element if you wish.
 *
 * @element ANY
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate
 * upon tap. (Event object is available as `$event`)
 *
 * @example
    <example module="ngClickExample" deps="angular-touch.js" name="ng-touch-ng-click">
      <file name="index.html">
        <button ng-click="count = count + 1" ng-init="count=0">
          Increment
        </button>
        count: {{ count }}
      </file>
      <file name="script.js">
        angular.module('ngClickExample', ['ngTouch']);
      </file>
    </example>
 */

var ngTouchClickDirectiveFactory = ['$parse', '$timeout', '$rootElement',
    function($parse, $timeout, $rootElement) {
  var TAP_DURATION = 750; // Shorter than 750ms is a tap, longer is a taphold or drag.
  var MOVE_TOLERANCE = 12; // 12px seems to work in most mobile browsers.
  var PREVENT_DURATION = 2500; // 2.5 seconds maximum from preventGhostClick call to click
  var CLICKBUSTER_THRESHOLD = 25; // 25 pixels in any dimension is the limit for busting clicks.

  var ACTIVE_CLASS_NAME = 'ng-click-active';
  var lastPreventedTime;
  var touchCoordinates;
  var lastLabelClickCoordinates;


  // TAP EVENTS AND GHOST CLICKS
  //
  // Why tap events?
  // Mobile browsers detect a tap, then wait a moment (usually ~300ms) to see if you're
  // double-tapping, and then fire a click event.
  //
  // This delay sucks and makes mobile apps feel unresponsive.
  // So we detect touchstart, touchcancel and touchend ourselves and determine when
  // the user has tapped on something.
  //
  // What happens when the browser then generates a click event?
  // The browser, of course, also detects the tap and fires a click after a delay. This results in
  // tapping/clicking twice. We do "clickbusting" to prevent it.
  //
  // How does it work?
  // We attach global touchstart and click handlers, that run during the capture (early) phase.
  // So the sequence for a tap is:
  // - global touchstart: Sets an "allowable region" at the point touched.
  // - element's touchstart: Starts a touch
  // (- touchcancel ends the touch, no click follows)
  // - element's touchend: Determines if the tap is valid (didn't move too far away, didn't hold
  //   too long) and fires the user's tap handler. The touchend also calls preventGhostClick().
  // - preventGhostClick() removes the allowable region the global touchstart created.
  // - The browser generates a click event.
  // - The global click handler catches the click, and checks whether it was in an allowable region.
  //     - If preventGhostClick was called, the region will have been removed, the click is busted.
  //     - If the region is still there, the click proceeds normally. Therefore clicks on links and
  //       other elements without ngTap on them work normally.
  //
  // This is an ugly, terrible hack!
  // Yeah, tell me about it. The alternatives are using the slow click events, or making our users
  // deal with the ghost clicks, so I consider this the least of evils. Fortunately Angular
  // encapsulates this ugly logic away from the user.
  //
  // Why not just put click handlers on the element?
  // We do that too, just to be sure. If the tap event caused the DOM to change,
  // it is possible another element is now in that position. To take account for these possibly
  // distinct elements, the handlers are global and care only about coordinates.

  // Checks if the coordinates are close enough to be within the region.
  function hit(x1, y1, x2, y2) {
    return Math.abs(x1 - x2) < CLICKBUSTER_THRESHOLD && Math.abs(y1 - y2) < CLICKBUSTER_THRESHOLD;
  }

  // Checks a list of allowable regions against a click location.
  // Returns true if the click should be allowed.
  // Splices out the allowable region from the list after it has been used.
  function checkAllowableRegions(touchCoordinates, x, y) {
    for (var i = 0; i < touchCoordinates.length; i += 2) {
      if (hit(touchCoordinates[i], touchCoordinates[i + 1], x, y)) {
        touchCoordinates.splice(i, i + 2);
        return true; // allowable region
      }
    }
    return false; // No allowable region; bust it.
  }

  // Global click handler that prevents the click if it's in a bustable zone and preventGhostClick
  // was called recently.
  function onClick(event) {
    if (Date.now() - lastPreventedTime > PREVENT_DURATION) {
      return; // Too old.
    }

    var touches = event.touches && event.touches.length ? event.touches : [event];
    var x = touches[0].clientX;
    var y = touches[0].clientY;
    // Work around desktop Webkit quirk where clicking a label will fire two clicks (on the label
    // and on the input element). Depending on the exact browser, this second click we don't want
    // to bust has either (0,0), negative coordinates, or coordinates equal to triggering label
    // click event
    if (x < 1 && y < 1) {
      return; // offscreen
    }
    if (lastLabelClickCoordinates &&
        lastLabelClickCoordinates[0] === x && lastLabelClickCoordinates[1] === y) {
      return; // input click triggered by label click
    }
    // reset label click coordinates on first subsequent click
    if (lastLabelClickCoordinates) {
      lastLabelClickCoordinates = null;
    }
    // remember label click coordinates to prevent click busting of trigger click event on input
    if (nodeName_(event.target) === 'label') {
      lastLabelClickCoordinates = [x, y];
    }

    // Look for an allowable region containing this click.
    // If we find one, that means it was created by touchstart and not removed by
    // preventGhostClick, so we don't bust it.
    if (checkAllowableRegions(touchCoordinates, x, y)) {
      return;
    }

    // If we didn't find an allowable region, bust the click.
    event.stopPropagation();
    event.preventDefault();

    // Blur focused form elements
    if (event.target && event.target.blur) {
      event.target.blur();
    }
  }


  // Global touchstart handler that creates an allowable region for a click event.
  // This allowable region can be removed by preventGhostClick if we want to bust it.
  function onTouchStart(event) {
    var touches = event.touches && event.touches.length ? event.touches : [event];
    var x = touches[0].clientX;
    var y = touches[0].clientY;
    touchCoordinates.push(x, y);

    $timeout(function() {
      // Remove the allowable region.
      for (var i = 0; i < touchCoordinates.length; i += 2) {
        if (touchCoordinates[i] === x && touchCoordinates[i + 1] === y) {
          touchCoordinates.splice(i, i + 2);
          return;
        }
      }
    }, PREVENT_DURATION, false);
  }

  // On the first call, attaches some event handlers. Then whenever it gets called, it creates a
  // zone around the touchstart where clicks will get busted.
  function preventGhostClick(x, y) {
    if (!touchCoordinates) {
      $rootElement[0].addEventListener('click', onClick, true);
      $rootElement[0].addEventListener('touchstart', onTouchStart, true);
      touchCoordinates = [];
    }

    lastPreventedTime = Date.now();

    checkAllowableRegions(touchCoordinates, x, y);
  }

  // Actual linking function.
  return function(scope, element, attr) {
    var clickHandler = $parse(attr.ngClick),
        tapping = false,
        tapElement,  // Used to blur the element after a tap.
        startTime,   // Used to check if the tap was held too long.
        touchStartX,
        touchStartY;

    function resetState() {
      tapping = false;
      element.removeClass(ACTIVE_CLASS_NAME);
    }

    element.on('touchstart', function(event) {
      tapping = true;
      tapElement = event.target ? event.target : event.srcElement; // IE uses srcElement.
      // Hack for Safari, which can target text nodes instead of containers.
      if (tapElement.nodeType === 3) {
        tapElement = tapElement.parentNode;
      }

      element.addClass(ACTIVE_CLASS_NAME);

      startTime = Date.now();

      // Use jQuery originalEvent
      var originalEvent = event.originalEvent || event;
      var touches = originalEvent.touches && originalEvent.touches.length ? originalEvent.touches : [originalEvent];
      var e = touches[0];
      touchStartX = e.clientX;
      touchStartY = e.clientY;
    });

    element.on('touchcancel', function(event) {
      resetState();
    });

    element.on('touchend', function(event) {
      var diff = Date.now() - startTime;

      // Use jQuery originalEvent
      var originalEvent = event.originalEvent || event;
      var touches = (originalEvent.changedTouches && originalEvent.changedTouches.length) ?
          originalEvent.changedTouches :
          ((originalEvent.touches && originalEvent.touches.length) ? originalEvent.touches : [originalEvent]);
      var e = touches[0];
      var x = e.clientX;
      var y = e.clientY;
      var dist = Math.sqrt(Math.pow(x - touchStartX, 2) + Math.pow(y - touchStartY, 2));

      if (tapping && diff < TAP_DURATION && dist < MOVE_TOLERANCE) {
        // Call preventGhostClick so the clickbuster will catch the corresponding click.
        preventGhostClick(x, y);

        // Blur the focused element (the button, probably) before firing the callback.
        // This doesn't work perfectly on Android Chrome, but seems to work elsewhere.
        // I couldn't get anything to work reliably on Android Chrome.
        if (tapElement) {
          tapElement.blur();
        }

        if (!angular.isDefined(attr.disabled) || attr.disabled === false) {
          element.triggerHandler('click', [event]);
        }
      }

      resetState();
    });

    // Hack for iOS Safari's benefit. It goes searching for onclick handlers and is liable to click
    // something else nearby.
    element.onclick = function(event) { };

    // Actual click handler.
    // There are three different kinds of clicks, only two of which reach this point.
    // - On desktop browsers without touch events, their clicks will always come here.
    // - On mobile browsers, the simulated "fast" click will call this.
    // - But the browser's follow-up slow click will be "busted" before it reaches this handler.
    // Therefore it's safe to use this directive on both mobile and desktop.
    element.on('click', function(event, touchend) {
      scope.$apply(function() {
        clickHandler(scope, {$event: (touchend || event)});
      });
    });

    element.on('mousedown', function(event) {
      element.addClass(ACTIVE_CLASS_NAME);
    });

    element.on('mousemove mouseup', function(event) {
      element.removeClass(ACTIVE_CLASS_NAME);
    });

  };
}];

/* global ngTouch: false */

/**
 * @ngdoc directive
 * @name ngSwipeLeft
 *
 * @description
 * Specify custom behavior when an element is swiped to the left on a touchscreen device.
 * A leftward swipe is a quick, right-to-left slide of the finger.
 * Though ngSwipeLeft is designed for touch-based devices, it will work with a mouse click and drag
 * too.
 *
 * To disable the mouse click and drag functionality, add `ng-swipe-disable-mouse` to
 * the `ng-swipe-left` or `ng-swipe-right` DOM Element.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * @element ANY
 * @param {expression} ngSwipeLeft {@link guide/expression Expression} to evaluate
 * upon left swipe. (Event object is available as `$event`)
 *
 * @example
    <example module="ngSwipeLeftExample" deps="angular-touch.js" name="ng-swipe-left">
      <file name="index.html">
        <div ng-show="!showActions" ng-swipe-left="showActions = true">
          Some list content, like an email in the inbox
        </div>
        <div ng-show="showActions" ng-swipe-right="showActions = false">
          <button ng-click="reply()">Reply</button>
          <button ng-click="delete()">Delete</button>
        </div>
      </file>
      <file name="script.js">
        angular.module('ngSwipeLeftExample', ['ngTouch']);
      </file>
    </example>
 */

/**
 * @ngdoc directive
 * @name ngSwipeRight
 *
 * @description
 * Specify custom behavior when an element is swiped to the right on a touchscreen device.
 * A rightward swipe is a quick, left-to-right slide of the finger.
 * Though ngSwipeRight is designed for touch-based devices, it will work with a mouse click and drag
 * too.
 *
 * Requires the {@link ngTouch `ngTouch`} module to be installed.
 *
 * @element ANY
 * @param {expression} ngSwipeRight {@link guide/expression Expression} to evaluate
 * upon right swipe. (Event object is available as `$event`)
 *
 * @example
    <example module="ngSwipeRightExample" deps="angular-touch.js" name="ng-swipe-right">
      <file name="index.html">
        <div ng-show="!showActions" ng-swipe-left="showActions = true">
          Some list content, like an email in the inbox
        </div>
        <div ng-show="showActions" ng-swipe-right="showActions = false">
          <button ng-click="reply()">Reply</button>
          <button ng-click="delete()">Delete</button>
        </div>
      </file>
      <file name="script.js">
        angular.module('ngSwipeRightExample', ['ngTouch']);
      </file>
    </example>
 */

function makeSwipeDirective(directiveName, direction, eventName) {
  ngTouch.directive(directiveName, ['$parse', '$swipe', function($parse, $swipe) {
    // The maximum vertical delta for a swipe should be less than 75px.
    var MAX_VERTICAL_DISTANCE = 75;
    // Vertical distance should not be more than a fraction of the horizontal distance.
    var MAX_VERTICAL_RATIO = 0.3;
    // At least a 30px lateral motion is necessary for a swipe.
    var MIN_HORIZONTAL_DISTANCE = 30;

    return function(scope, element, attr) {
      var swipeHandler = $parse(attr[directiveName]);

      var startCoords, valid;

      function validSwipe(coords) {
        // Check that it's within the coordinates.
        // Absolute vertical distance must be within tolerances.
        // Horizontal distance, we take the current X - the starting X.
        // This is negative for leftward swipes and positive for rightward swipes.
        // After multiplying by the direction (-1 for left, +1 for right), legal swipes
        // (ie. same direction as the directive wants) will have a positive delta and
        // illegal ones a negative delta.
        // Therefore this delta must be positive, and larger than the minimum.
        if (!startCoords) return false;
        var deltaY = Math.abs(coords.y - startCoords.y);
        var deltaX = (coords.x - startCoords.x) * direction;
        return valid && // Short circuit for already-invalidated swipes.
            deltaY < MAX_VERTICAL_DISTANCE &&
            deltaX > 0 &&
            deltaX > MIN_HORIZONTAL_DISTANCE &&
            deltaY / deltaX < MAX_VERTICAL_RATIO;
      }

      var pointerTypes = ['touch'];
      if (!angular.isDefined(attr['ngSwipeDisableMouse'])) {
        pointerTypes.push('mouse');
      }
      $swipe.bind(element, {
        'start': function(coords, event) {
          startCoords = coords;
          valid = true;
        },
        'cancel': function(event) {
          valid = false;
        },
        'end': function(coords, event) {
          if (validSwipe(coords)) {
            scope.$apply(function() {
              element.triggerHandler(eventName);
              swipeHandler(scope, {$event: event});
            });
          }
        }
      }, pointerTypes);
    };
  }]);
}

// Left is negative X-coordinate, right is positive.
makeSwipeDirective('ngSwipeLeft', -1, 'swipeleft');
makeSwipeDirective('ngSwipeRight', 1, 'swiperight');



})(window, window.angular);

//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (typeof define === 'function' && define.amd) {
    define('underscore', [], function() {
      return _;
    });
  }
}.call(this));

/*!
 * angular-translate - v2.18.1 - 2018-05-19
 * 
 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

/**
 * @ngdoc overview
 * @name pascalprecht.translate
 *
 * @description
 * The main module which holds everything together.
 */
runTranslate.$inject = ['$translate'];
$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
translateAttrDirective.$inject = ['$translate', '$rootScope'];
translateCloakDirective.$inject = ['$translate', '$rootScope'];
translateFilterFactory.$inject = ['$parse', '$translate'];
$translationCache.$inject = ['$cacheFactory'];
angular.module('pascalprecht.translate', ['ng'])
  .run(runTranslate);

function runTranslate($translate) {

  'use strict';

  var key = $translate.storageKey(),
    storage = $translate.storage();

  var fallbackFromIncorrectStorageValue = function () {
    var preferred = $translate.preferredLanguage();
    if (angular.isString(preferred)) {
      $translate.use(preferred);
      // $translate.use() will also remember the language.
      // So, we don't need to call storage.put() here.
    } else {
      storage.put(key, $translate.use());
    }
  };

  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';

  if (storage) {
    if (!storage.get(key)) {
      fallbackFromIncorrectStorageValue();
    } else {
      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
    }
  } else if (angular.isString($translate.preferredLanguage())) {
    $translate.use($translate.preferredLanguage());
  }
}

runTranslate.displayName = 'runTranslate';

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateSanitizationProvider
 *
 * @description
 *
 * Configurations for $translateSanitization
 */
angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);

function $translateSanitizationProvider () {

  'use strict';

  var $sanitize,
      $sce,
      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
      hasConfiguredStrategy = false,
      hasShownNoStrategyConfiguredWarning = false,
      strategies;

  /**
   * Definition of a sanitization strategy function
   * @callback StrategyFunction
   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
   * @return {string|object}
   */

  /**
   * @ngdoc property
   * @name strategies
   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Following strategies are built-in:
   * <dl>
   *   <dt>sanitize</dt>
   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
   *   <dt>escape</dt>
   *   <dd>Escapes HTML in the translation</dd>
   *   <dt>sanitizeParameters</dt>
   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
   *   <dt>escapeParameters</dt>
   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
   *   <dt>escaped</dt>
   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
   * </dl>
   *
   */

  strategies = {
    sanitize: function (value, mode/*, context*/) {
      if (mode === 'text') {
        value = htmlSanitizeValue(value);
      }
      return value;
    },
    escape: function (value, mode/*, context*/) {
      if (mode === 'text') {
        value = htmlEscapeValue(value);
      }
      return value;
    },
    sanitizeParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlSanitizeValue);
      }
      return value;
    },
    escapeParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlEscapeValue);
      }
      return value;
    },
    sce: function (value, mode, context) {
      if (mode === 'text') {
        value = htmlTrustValue(value);
      } else if (mode === 'params') {
        if (context !== 'filter') {
          // do html escape in filter context #1101
          value = mapInterpolationParameters(value, htmlEscapeValue);
        }
      }
      return value;
    },
    sceParameters: function (value, mode/*, context*/) {
      if (mode === 'params') {
        value = mapInterpolationParameters(value, htmlTrustValue);
      }
      return value;
    }
  };
  // Support legacy strategy name 'escaped' for backwards compatibility.
  // TODO should be removed in 3.0
  strategies.escaped = strategies.escapeParameters;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Adds a sanitization strategy to the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @param {StrategyFunction} strategyFunction - strategy function
   * @returns {object} this
   */
  this.addStrategy = function (strategyName, strategyFunction) {
    strategies[strategyName] = strategyFunction;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Removes a sanitization strategy from the list of known strategies.
   *
   * @param {string} strategyName - unique key for a strategy
   * @returns {object} this
   */
  this.removeStrategy = function (strategyName) {
    delete strategies[strategyName];
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
   * @methodOf pascalprecht.translate.$translateSanitizationProvider
   *
   * @description
   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
   *
   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
   * @returns {object} this
   */
  this.useStrategy = function (strategy) {
    hasConfiguredStrategy = true;
    currentStrategy = strategy;
    return this;
  };

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translateSanitization
   * @requires $injector
   * @requires $log
   *
   * @description
   * Sanitizes interpolation parameters and translated texts.
   *
   */
  this.$get = ['$injector', '$log', function ($injector, $log) {

    var cachedStrategyMap = {};

    var applyStrategies = function (value, mode, context, selectedStrategies) {
      angular.forEach(selectedStrategies, function (selectedStrategy) {
        if (angular.isFunction(selectedStrategy)) {
          value = selectedStrategy(value, mode, context);
        } else if (angular.isFunction(strategies[selectedStrategy])) {
          value = strategies[selectedStrategy](value, mode, context);
        } else if (angular.isString(strategies[selectedStrategy])) {
          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
            try {
              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
            } catch (e) {
              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
            }
          }
          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
        } else {
          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
        }
      });
      return value;
    };

    // TODO: should be removed in 3.0
    var showNoStrategyConfiguredWarning = function () {
      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
        hasShownNoStrategyConfiguredWarning = true;
      }
    };

    if ($injector.has('$sanitize')) {
      $sanitize = $injector.get('$sanitize');
    }
    if ($injector.has('$sce')) {
      $sce = $injector.get('$sce');
    }

    return {
      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#useStrategy
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
       *
       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
       */
      useStrategy: (function (self) {
        return function (strategy) {
          self.useStrategy(strategy);
        };
      })(this),

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translateSanitization#sanitize
       * @methodOf pascalprecht.translate.$translateSanitization
       *
       * @description
       * Sanitizes a value.
       *
       * @param {string|object} value The value which should be sanitized.
       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
       * @param {string} [context] The context of this call: filter, service. Default is service
       * @returns {string|object} sanitized value
       */
      sanitize: function (value, mode, strategy, context) {
        if (!currentStrategy) {
          showNoStrategyConfiguredWarning();
        }

        if (!strategy && strategy !== null) {
          strategy = currentStrategy;
        }

        if (!strategy) {
          return value;
        }

        if (!context) {
          context = 'service';
        }

        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
        return applyStrategies(value, mode, context, selectedStrategies);
      }
    };
  }];

  var htmlEscapeValue = function (value) {
    var element = angular.element('<div></div>');
    element.text(value); // not chainable, see #1044
    return element.html();
  };

  var htmlSanitizeValue = function (value) {
    if (!$sanitize) {
      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
    }
    return $sanitize(value);
  };

  var htmlTrustValue = function (value) {
    if (!$sce) {
      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
    }
    return $sce.trustAsHtml(value);
  };

  var mapInterpolationParameters = function (value, iteratee, stack) {
    if (angular.isDate(value)) {
      return value;
    } else if (angular.isObject(value)) {
      var result = angular.isArray(value) ? [] : {};

      if (!stack) {
        stack = [];
      } else {
        if (stack.indexOf(value) > -1) {
          throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
        }
      }

      stack.push(value);
      angular.forEach(value, function (propertyValue, propertyKey) {

        /* Skipping function properties. */
        if (angular.isFunction(propertyValue)) {
          return;
        }

        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
      });
      stack.splice(-1, 1); // remove last

      return result;
    } else if (angular.isNumber(value)) {
      return value;
    } else if (value === true || value === false) {
      return value;
    } else if (!angular.isUndefined(value) && value !== null) {
      return iteratee(value);
    } else {
      return value;
    }
  };
}

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateProvider
 * @description
 *
 * $translateProvider allows developers to register translation-tables, asynchronous loaders
 * and similar to configure translation behavior directly inside of a module.
 *
 */
angular.module('pascalprecht.translate')
  .constant('pascalprechtTranslateOverrider', {})
  .provider('$translate', $translate);

function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {

  'use strict';

  var $translationTable = {},
    $preferredLanguage,
    $availableLanguageKeys = [],
    $languageKeyAliases,
    $fallbackLanguage,
    $fallbackWasString,
    $uses,
    $nextLang,
    $storageFactory,
    $storageKey = $STORAGE_KEY,
    $storagePrefix,
    $missingTranslationHandlerFactory,
    $interpolationFactory,
    $interpolatorFactories = [],
    $loaderFactory,
    $cloakClassName = 'translate-cloak',
    $loaderOptions,
    $notFoundIndicatorLeft,
    $notFoundIndicatorRight,
    $postCompilingEnabled = false,
    $forceAsyncReloadEnabled = false,
    $nestedObjectDelimeter = '.',
    $isReady = false,
    $keepContent = false,
    loaderCache,
    directivePriority = 0,
    statefulFilter = true,
    postProcessFn,
    uniformLanguageTagResolver = 'default',
    languageTagResolver = {
      'default' : function (tag) {
        return (tag || '').split('-').join('_');
      },
      java : function (tag) {
        var temp = (tag || '').split('-').join('_');
        var parts = temp.split('_');
        return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
      },
      bcp47 : function (tag) {
        var temp = (tag || '').split('_').join('-');
        var parts = temp.split('-');

        switch (parts.length) {
          case 1: // language only
            parts[0] = parts[0].toLowerCase();
            break;
          case 2: // language-script or language-region
            parts[0] = parts[0].toLowerCase();
            if (parts[1].length === 4) { // parts[1] is script
              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
            } else { // parts[1] is region
              parts[1] = parts[1].toUpperCase();
            }
            break;
          case 3: // language-script-region
            parts[0] = parts[0].toLowerCase();
            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
            parts[2] = parts[2].toUpperCase();
            break;
          default:
            return temp;
        }

        return parts.join('-');
      },
      'iso639-1' : function (tag) {
        var temp = (tag || '').split('_').join('-');
        var parts = temp.split('-');
        return parts[0].toLowerCase();
      }
    };

  var version = '2.18.1';

  // tries to determine the browsers language
  var getFirstBrowserLanguage = function () {

    // internal purpose only
    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
      return pascalprechtTranslateOverrider.getLocale();
    }

    var nav = $windowProvider.$get().navigator,
      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
      i,
      language;

    // support for HTML 5.1 "navigator.languages"
    if (angular.isArray(nav.languages)) {
      for (i = 0; i < nav.languages.length; i++) {
        language = nav.languages[i];
        if (language && language.length) {
          return language;
        }
      }
    }

    // support for other well known properties in browsers
    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
      language = nav[browserLanguagePropertyKeys[i]];
      if (language && language.length) {
        return language;
      }
    }

    return null;
  };
  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';

  // tries to determine the browsers locale
  var getLocale = function () {
    var locale = getFirstBrowserLanguage() || '';
    if (languageTagResolver[uniformLanguageTagResolver]) {
      locale = languageTagResolver[uniformLanguageTagResolver](locale);
    }
    return locale;
  };
  getLocale.displayName = 'angular-translate/service: getLocale';

  /**
   * @name indexOf
   * @private
   *
   * @description
   * indexOf polyfill. Kinda sorta.
   *
   * @param {array} array Array to search in.
   * @param {string} searchElement Element to search for.
   *
   * @returns {int} Index of search element.
   */
  var indexOf = function (array, searchElement) {
    for (var i = 0, len = array.length; i < len; i++) {
      if (array[i] === searchElement) {
        return i;
      }
    }
    return -1;
  };

  /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */
  var trim = function () {
    return this.toString().replace(/^\s+|\s+$/g, '');
  };

  /**
   * @name lowercase
   * @private
   *
   * @description
   * Return the lowercase string only if the type is string
   *
   * @returns {string} The string all in lowercase
   */
  var lowercase = function (string) {
    return angular.isString(string) ? string.toLowerCase() : string;
  };

  var negotiateLocale = function (preferred) {
    if (!preferred) {
      return;
    }

    var avail = [],
      locale = lowercase(preferred),
      i = 0,
      n = $availableLanguageKeys.length;

    for (; i < n; i++) {
      avail.push(lowercase($availableLanguageKeys[i]));
    }

    // Check for an exact match in our list of available keys
    i = indexOf(avail, locale);
    if (i > -1) {
      return $availableLanguageKeys[i];
    }

    if ($languageKeyAliases) {
      var alias;
      for (var langKeyAlias in $languageKeyAliases) {
        if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
          var hasWildcardKey = false;
          var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
            lowercase(langKeyAlias) === lowercase(preferred);

          if (langKeyAlias.slice(-1) === '*') {
            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
          }
          if (hasExactKey || hasWildcardKey) {
            alias = $languageKeyAliases[langKeyAlias];
            if (indexOf(avail, lowercase(alias)) > -1) {
              return alias;
            }
          }
        }
      }
    }

    // Check for a language code without region
    var parts = preferred.split('_');

    if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
      return parts[0];
    }

    // If everything fails, return undefined.
    return;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translations
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a new translation table for specific language key.
   *
   * To register a translation table for specific language, pass a defined language
   * key as first parameter.
   *
   * <pre>
   *  // register translation table for language: 'de_DE'
   *  $translateProvider.translations('de_DE', {
   *    'GREETING': 'Hallo Welt!'
   *  });
   *
   *  // register another one
   *  $translateProvider.translations('en_US', {
   *    'GREETING': 'Hello world!'
   *  });
   * </pre>
   *
   * When registering multiple translation tables for for the same language key,
   * the actual translation table gets extended. This allows you to define module
   * specific translation which only get added, once a specific module is loaded in
   * your app.
   *
   * Invoking this method with no arguments returns the translation table which was
   * registered with no language key. Invoking it with a language key returns the
   * related translation table.
   *
   * @param {string} langKey A language key.
   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
   *
   */
  var translations = function (langKey, translationTable) {

    if (!langKey && !translationTable) {
      return $translationTable;
    }

    if (langKey && !translationTable) {
      if (angular.isString(langKey)) {
        return $translationTable[langKey];
      }
    } else {
      if (!angular.isObject($translationTable[langKey])) {
        $translationTable[langKey] = {};
      }
      angular.extend($translationTable[langKey], flatObject(translationTable));
    }
    return this;
  };

  this.translations = translations;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#cloakClassName
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the class name for `translate-cloak` directive.
   * Default class name is `translate-cloak`.
   *
   * @param {string} name translate-cloak class name
   */
  this.cloakClassName = function (name) {
    if (!name) {
      return $cloakClassName;
    }
    $cloakClassName = name;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   *
   * Let's you change the delimiter for namespaced translations.
   * Default delimiter is `.`.
   *
   * @param {string} delimiter namespace separator
   */
  this.nestedObjectDelimeter = function (delimiter) {
    if (!delimiter) {
      return $nestedObjectDelimeter;
    }
    $nestedObjectDelimeter = delimiter;
    return this;
  };

  /**
   * @name flatObject
   * @private
   *
   * @description
   * Flats an object. This function is used to flatten given translation data with
   * namespaces, so they are later accessible via dot notation.
   */
  var flatObject = function (data, path, result, prevKey) {
    var key, keyWithPath, keyWithShortPath, val;

    if (!path) {
      path = [];
    }
    if (!result) {
      result = {};
    }
    for (key in data) {
      if (!Object.prototype.hasOwnProperty.call(data, key)) {
        continue;
      }
      val = data[key];
      if (angular.isObject(val)) {
        flatObject(val, path.concat(key), result, key);
      } else {
        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
        if (path.length && key === prevKey) {
          // Create shortcut path (foo.bar == foo.bar.bar)
          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
          // Link it to original path
          result[keyWithShortPath] = '@:' + keyWithPath;
        }
        result[keyWithPath] = val;
      }
    }
    return result;
  };
  flatObject.displayName = 'flatObject';

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#addInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Adds interpolation services to angular-translate, so it can manage them.
   *
   * @param {object} factory Interpolation service factory
   */
  this.addInterpolation = function (factory) {
    $interpolatorFactories.push(factory);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use interpolation functionality of messageformat.js.
   * This is useful when having high level pluralization and gender selection.
   */
  this.useMessageFormatInterpolation = function () {
    return this.useInterpolation('$translateMessageFormatInterpolation');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useInterpolation
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which interpolation style to use as default, application-wide.
   * Simply pass a factory/service name. The interpolation service has to implement
   * the correct interface.
   *
   * @param {string} factory Interpolation service name.
   */
  this.useInterpolation = function (factory) {
    $interpolationFactory = factory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Simply sets a sanitation strategy type.
   *
   * @param {string} value Strategy type.
   */
  this.useSanitizeValueStrategy = function (value) {
    $translateSanitizationProvider.useStrategy(value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#preferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use for translation
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **prefer**.
   * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
   *
   * @param {string} langKey A language key.
   */
  this.preferredLanguage = function (langKey) {
    if (langKey) {
      setupPreferredLanguage(langKey);
      return this;
    }
    return $preferredLanguage;
  };
  var setupPreferredLanguage = function (langKey) {
    if (langKey) {
      $preferredLanguage = langKey;
    }
    return $preferredLanguage;
  };
  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found. E.g. when
   * setting the indicator as 'X' and one tries to translate a translation id
   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
   *
   * Internally this methods sets a left indicator and a right indicator using
   * `$translateProvider.translationNotFoundIndicatorLeft()` and
   * `$translateProvider.translationNotFoundIndicatorRight()`.
   *
   * **Note**: These methods automatically add a whitespace between the indicators
   * and the translation id.
   *
   * @param {string} indicator An indicator, could be any string.
   */
  this.translationNotFoundIndicator = function (indicator) {
    this.translationNotFoundIndicatorLeft(indicator);
    this.translationNotFoundIndicatorRight(indicator);
    return this;
  };

  /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found left to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */
  this.translationNotFoundIndicatorLeft = function (indicator) {
    if (!indicator) {
      return $notFoundIndicatorLeft;
    }
    $notFoundIndicatorLeft = indicator;
    return this;
  };

  /**
   * ngdoc function
   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets an indicator which is used when a translation isn't found right to the
   * translation id.
   *
   * @param {string} indicator An indicator.
   */
  this.translationNotFoundIndicatorRight = function (indicator) {
    if (!indicator) {
      return $notFoundIndicatorRight;
    }
    $notFoundIndicatorRight = indicator;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which of the registered translation tables to use when missing translations
   * at initial startup by passing a language key. Similar to `$translateProvider#use`
   * only that it says which language to **fallback**.
   *
   * @param {string||array} langKey A language key.
   *
   */
  this.fallbackLanguage = function (langKey) {
    fallbackStack(langKey);
    return this;
  };

  var fallbackStack = function (langKey) {
    if (langKey) {
      if (angular.isString(langKey)) {
        $fallbackWasString = true;
        $fallbackLanguage = [langKey];
      } else if (angular.isArray(langKey)) {
        $fallbackWasString = false;
        $fallbackLanguage = langKey;
      }
      if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
        $fallbackLanguage.push($preferredLanguage);
      }

      return this;
    } else {
      if ($fallbackWasString) {
        return $fallbackLanguage[0];
      } else {
        return $fallbackLanguage;
      }
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#use
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Set which translation table to use for translation by given language key. When
   * trying to 'use' a language which isn't provided, it'll throw an error.
   *
   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
   * does the job too.
   *
   * @param {string} langKey A language key.
   */
  this.use = function (langKey) {
    if (langKey) {
      if (!$translationTable[langKey] && (!$loaderFactory)) {
        // only throw an error, when not loading translation data asynchronously
        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
      }
      $uses = langKey;
      return this;
    }
    return $uses;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
   *
   * @returns {string} the current client/browser language key
   */
  this.resolveClientLocale = function () {
    return getLocale();
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storageKey
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells the module which key must represent the choosed language by a user in the storage.
   *
   * @param {string} key A key for the storage.
   */
  var storageKey = function (key) {
    if (!key) {
      if ($storagePrefix) {
        return $storagePrefix + $storageKey;
      }
      return $storageKey;
    }
    $storageKey = key;
    return this;
  };

  this.storageKey = storageKey;

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useUrlLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
   *
   * @param {string} url Url
   * @param {Object=} options Optional configuration object
   */
  this.useUrlLoader = function (url, options) {
    return this.useLoader('$translateUrlLoader', angular.extend({url : url}, options));
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
   *
   * @param {Object=} options Optional configuration object
   */
  this.useStaticFilesLoader = function (options) {
    return this.useLoader('$translateStaticFilesLoader', options);
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoader
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use any other service as loader.
   *
   * @param {string} loaderFactory Factory name to use
   * @param {Object=} options Optional configuration object
   */
  this.useLoader = function (loaderFactory, options) {
    $loaderFactory = loaderFactory;
    $loaderOptions = options || {};
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLocalStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
   *
   */
  this.useLocalStorage = function () {
    return this.useStorage('$translateLocalStorage');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useCookieStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
   */
  this.useCookieStorage = function () {
    return this.useStorage('$translateCookieStorage');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useStorage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use custom service as storage layer.
   */
  this.useStorage = function (storageFactory) {
    $storageFactory = storageFactory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#storagePrefix
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets prefix for storage key.
   *
   * @param {string} prefix Storage key prefix
   */
  this.storagePrefix = function (prefix) {
    if (!prefix) {
      return prefix;
    }
    $storagePrefix = prefix;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to use built-in log handler when trying to translate
   * a translation Id which doesn't exist.
   *
   * This is actually a shortcut method for `useMissingTranslationHandler()`.
   *
   */
  this.useMissingTranslationHandlerLog = function () {
    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Expects a factory name which later gets instantiated with `$injector`.
   * This method can be used to tell angular-translate to use a custom
   * missingTranslationHandler. Just build a factory which returns a function
   * and expects a translation id as argument.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.useMissingTranslationHandler('customHandler');
   *  });
   *
   *  app.factory('customHandler', function (dep1, dep2) {
   *    return function (translationId) {
   *      // something with translationId and dep1 and dep2
   *    };
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */
  this.useMissingTranslationHandler = function (factory) {
    $missingTranslationHandlerFactory = factory;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#usePostCompiling
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If post compiling is enabled, all translated values will be processed
   * again with AngularJS' $compile.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.usePostCompiling(true);
   *  });
   * </pre>
   *
   * @param {string} factory Factory name
   */
  this.usePostCompiling = function (value) {
    $postCompilingEnabled = !(!value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If force async reload is enabled, async loader will always be called
   * even if $translationTable already contains the language key, adding
   * possible new entries to the $translationTable.
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.forceAsyncReload(true);
   *  });
   * </pre>
   *
   * @param {boolean} value - valid values are true or false
   */
  this.forceAsyncReload = function (value) {
    $forceAsyncReloadEnabled = !(!value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate which language tag should be used as a result when determining
   * the current browser language.
   *
   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
   *
   * <pre>
   * $translateProvider
   *   .uniformLanguageTag('bcp47')
   *   .determinePreferredLanguage()
   * </pre>
   *
   * The resolver currently supports:
   * * default
   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_us
   * * java
   *     like default, but the second part will be always in uppercase
   *     en-US => en_US
   *     en_US => en_US
   *     en-us => en_US
   * * BCP 47 (RFC 4646 & 4647)
   *     EN => en
   *     en-US => en-US
   *     en_US => en-US
   *     en-us => en-US
   *     sr-latn => sr-Latn
   *     sr-latn-rs => sr-Latn-RS
   *
   * See also:
   * * http://en.wikipedia.org/wiki/IETF_language_tag
   * * http://www.w3.org/International/core/langtags/
   * * http://tools.ietf.org/html/bcp47
   *
   * @param {string|object} options - options (or standard)
   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
   */
  this.uniformLanguageTag = function (options) {

    if (!options) {
      options = {};
    } else if (angular.isString(options)) {
      options = {
        standard : options
      };
    }

    uniformLanguageTagResolver = options.standard;

    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Tells angular-translate to try to determine on its own which language key
   * to set as preferred language. When `fn` is given, angular-translate uses it
   * to determine a language key, otherwise it uses the built-in `getLocale()`
   * method.
   *
   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
   * `[lang]` depending on what the browser provides.
   *
   * Use this method at your own risk, since not all browsers return a valid
   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
   *
   * @param {Function=} fn Function to determine a browser's locale
   */
  this.determinePreferredLanguage = function (fn) {

    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();

    if (!$availableLanguageKeys.length) {
      $preferredLanguage = locale;
    } else {
      $preferredLanguage = negotiateLocale(locale) || locale;
    }

    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a set of language keys the app will work with. Use this method in
   * combination with
   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
   * When available languages keys are registered, angular-translate
   * tries to find the best fitting language key depending on the browsers locale,
   * considering your language key convention.
   *
   * @param {object} languageKeys Array of language keys the your app will use
   * @param {object=} aliases Alias map.
   */
  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
    if (languageKeys) {
      $availableLanguageKeys = languageKeys;
      if (aliases) {
        $languageKeyAliases = aliases;
      }
      return this;
    }
    return $availableLanguageKeys;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#useLoaderCache
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Registers a cache for internal $http based loaders.
   * {@link pascalprecht.translate.$translationCache $translationCache}.
   * When false the cache will be disabled (default). When true or undefined
   * the cache will be a default (see $cacheFactory). When an object it will
   * be treat as a cache object itself: the usage is $http({cache: cache})
   *
   * @param {object} cache boolean, string or cache-object
   */
  this.useLoaderCache = function (cache) {
    if (cache === false) {
      // disable cache
      loaderCache = undefined;
    } else if (cache === true) {
      // enable cache using AJS defaults
      loaderCache = true;
    } else if (typeof(cache) === 'undefined') {
      // enable cache using default
      loaderCache = '$translationCache';
    } else if (cache) {
      // enable cache using given one (see $cacheFactory)
      loaderCache = cache;
    }
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#directivePriority
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Sets the default priority of the translate directive. The standard value is `0`.
   * Calling this function without an argument will return the current value.
   *
   * @param {number} priority for the translate-directive
   */
  this.directivePriority = function (priority) {
    if (priority === undefined) {
      // getter
      return directivePriority;
    } else {
      // setter with chaining
      directivePriority = priority;
      return this;
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#statefulFilter
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
   * have to explicit define this behavior.
   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
   * meaning being stateful.
   * Calling this function without an argument will return the current value.
   *
   * @param {boolean} state - defines the state of the filter
   */
  this.statefulFilter = function (state) {
    if (state === undefined) {
      // getter
      return statefulFilter;
    } else {
      // setter with chaining
      statefulFilter = state;
      return this;
    }
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#postProcess
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * The post processor will be intercept right after the translation result. It can modify the result.
   *
   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
   */
  this.postProcess = function (fn) {
    if (fn) {
      postProcessFn = fn;
    } else {
      postProcessFn = undefined;
    }
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateProvider#keepContent
   * @methodOf pascalprecht.translate.$translateProvider
   *
   * @description
   * If keepContent is set to true than translate directive will always use innerHTML
   * as a default translation
   *
   * Example:
   * <pre>
   *  app.config(function ($translateProvider) {
   *    $translateProvider.keepContent(true);
   *  });
   * </pre>
   *
   * @param {boolean} value - valid values are true or false
   */
  this.keepContent = function (value) {
    $keepContent = !(!value);
    return this;
  };

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translate
   * @requires $interpolate
   * @requires $log
   * @requires $rootScope
   * @requires $q
   *
   * @description
   * The `$translate` service is the actual core of angular-translate. It expects a translation id
   * and optional interpolate parameters to translate contents.
   *
   * <pre>
   *  $translate('HEADLINE_TEXT').then(function (translation) {
   *    $scope.translatedText = translation;
   *  });
   * </pre>
   *
   * @param {string|array} translationId A token which represents a translation id
   *                                     This can be optionally an array of translation ids which
   *                                     results that the function returns an object where each key
   *                                     is the translation id and the value the translation.
   * @param {object=} [interpolateParams={}] An object hash for dynamic values
   * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
   * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
   *                                        as default text in case it is not found in any configured language
   * @param {string=} [forceLanguage=false] A language to be used instead of the current language
   * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
   * @returns {object} promise
   */
  this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {

    var Storage,
      defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
      pendingLoader = false,
      interpolatorHashMap = {},
      langPromises = {},
      fallbackIndex,
      startFallbackIteration;

    var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
      if (!$uses && $preferredLanguage) {
        $uses = $preferredLanguage;
      }
      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

      // Check forceLanguage is present
      if (forceLanguage) {
        loadTranslationsIfMissing(forceLanguage);
      }

      // Duck detection: If the first argument is an array, a bunch of translations was requested.
      // The result is an object.
      if (angular.isArray(translationId)) {
        // Inspired by Q.allSettled by Kris Kowal
        // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
        // This transforms all promises regardless resolved or rejected
        var translateAll = function (translationIds) {
          var results = {}; // storing the actual results
          var promises = []; // promises to wait for
          // Wraps the promise a) being always resolved and b) storing the link id->value
          var translate = function (translationId) {
            var deferred = $q.defer();
            var regardless = function (value) {
              results[translationId] = value;
              deferred.resolve([translationId, value]);
            };
            // we don't care whether the promise was resolved or rejected; just store the values
            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
            return deferred.promise;
          };
          for (var i = 0, c = translationIds.length; i < c; i++) {
            promises.push(translate(translationIds[i]));
          }
          // wait for all (including storing to results)
          return $q.all(promises).then(function () {
            // return the results
            return results;
          });
        };
        return translateAll(translationId);
      }

      var deferred = $q.defer();

      // trim off any whitespace
      if (translationId) {
        translationId = trim.apply(translationId);
      }

      var promiseToWaitFor = (function () {
        var promise = langPromises[uses] || langPromises[$preferredLanguage];

        fallbackIndex = 0;

        if ($storageFactory && !promise) {
          // looks like there's no pending promise for $preferredLanguage or
          // $uses. Maybe there's one pending for a language that comes from
          // storage.
          var langKey = Storage.get($storageKey);
          promise = langPromises[langKey];

          if ($fallbackLanguage && $fallbackLanguage.length) {
            var index = indexOf($fallbackLanguage, langKey);
            // maybe the language from storage is also defined as fallback language
            // we increase the fallback language index to not search in that language
            // as fallback, since it's probably the first used language
            // in that case the index starts after the first element
            fallbackIndex = (index === 0) ? 1 : 0;

            // but we can make sure to ALWAYS fallback to preferred language at least
            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
              $fallbackLanguage.push($preferredLanguage);
            }
          }
        }
        return promise;
      }());

      if (!promiseToWaitFor) {
        // no promise to wait for? okay. Then there's no loader registered
        // nor is a one pending for language that comes from storage.
        // We can just translate.
        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
      } else {
        var promiseResolved = function () {
          // $uses may have changed while waiting
          if (!forceLanguage) {
            uses = $uses;
          }
          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
        };
        promiseResolved.displayName = 'promiseResolved';

        promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
      }
      return deferred.promise;
    };

    /**
     * @name applyNotFoundIndicators
     * @private
     *
     * @description
     * Applies not fount indicators to given translation id, if needed.
     * This function gets only executed, if a translation id doesn't exist,
     * which is why a translation id is expected as argument.
     *
     * @param {string} translationId Translation id.
     * @returns {string} Same as given translation id but applied with not found
     * indicators.
     */
    var applyNotFoundIndicators = function (translationId) {
      // applying notFoundIndicators
      if ($notFoundIndicatorLeft) {
        translationId = [$notFoundIndicatorLeft, translationId].join(' ');
      }
      if ($notFoundIndicatorRight) {
        translationId = [translationId, $notFoundIndicatorRight].join(' ');
      }
      return translationId;
    };

    /**
     * @name useLanguage
     * @private
     *
     * @description
     * Makes actual use of a language by setting a given language key as used
     * language and informs registered interpolators to also use the given
     * key as locale.
     *
     * @param {string} key Locale key.
     */
    var useLanguage = function (key) {
      $uses = key;

      // make sure to store new language key before triggering success event
      if ($storageFactory) {
        Storage.put($translate.storageKey(), $uses);
      }

      $rootScope.$emit('$translateChangeSuccess', {language : key});

      // inform default interpolator
      defaultInterpolator.setLocale($uses);

      var eachInterpolator = function (interpolator, id) {
        interpolatorHashMap[id].setLocale($uses);
      };
      eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';

      // inform all others too!
      angular.forEach(interpolatorHashMap, eachInterpolator);
      $rootScope.$emit('$translateChangeEnd', {language : key});
    };

    /**
     * @name loadAsync
     * @private
     *
     * @description
     * Kicks off registered async loader using `$injector` and applies existing
     * loader options. When resolved, it updates translation tables accordingly
     * or rejects with given language key.
     *
     * @param {string} key Language key.
     * @return {Promise} A promise.
     */
    var loadAsync = function (key) {
      if (!key) {
        throw 'No language key specified for loading.';
      }

      var deferred = $q.defer();

      $rootScope.$emit('$translateLoadingStart', {language : key});
      pendingLoader = true;

      var cache = loaderCache;
      if (typeof(cache) === 'string') {
        // getting on-demand instance of loader
        cache = $injector.get(cache);
      }

      var loaderOptions = angular.extend({}, $loaderOptions, {
        key : key,
        $http : angular.extend({}, {
          cache : cache
        }, $loaderOptions.$http)
      });

      var onLoaderSuccess = function (data) {
        var translationTable = {};
        $rootScope.$emit('$translateLoadingSuccess', {language : key});

        if (angular.isArray(data)) {
          angular.forEach(data, function (table) {
            angular.extend(translationTable, flatObject(table));
          });
        } else {
          angular.extend(translationTable, flatObject(data));
        }
        pendingLoader = false;
        deferred.resolve({
          key : key,
          table : translationTable
        });
        $rootScope.$emit('$translateLoadingEnd', {language : key});
      };
      onLoaderSuccess.displayName = 'onLoaderSuccess';

      var onLoaderError = function (key) {
        $rootScope.$emit('$translateLoadingError', {language : key});
        deferred.reject(key);
        $rootScope.$emit('$translateLoadingEnd', {language : key});
      };
      onLoaderError.displayName = 'onLoaderError';

      $injector.get($loaderFactory)(loaderOptions)
        .then(onLoaderSuccess, onLoaderError);

      return deferred.promise;
    };

    if ($storageFactory) {
      Storage = $injector.get($storageFactory);

      if (!Storage.get || !Storage.put) {
        throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
      }
    }

    // if we have additional interpolations that were added via
    // $translateProvider.addInterpolation(), we have to map'em
    if ($interpolatorFactories.length) {
      var eachInterpolationFactory = function (interpolatorFactory) {
        var interpolator = $injector.get(interpolatorFactory);
        // setting initial locale for each interpolation service
        interpolator.setLocale($preferredLanguage || $uses);
        // make'em recognizable through id
        interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
      };
      eachInterpolationFactory.displayName = 'interpolationFactoryAdder';

      angular.forEach($interpolatorFactories, eachInterpolationFactory);
    }

    /**
     * @name getTranslationTable
     * @private
     *
     * @description
     * Returns a promise that resolves to the translation table
     * or is rejected if an error occurred.
     *
     * @param langKey
     * @returns {Q.promise}
     */
    var getTranslationTable = function (langKey) {
      var deferred = $q.defer();
      if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
        deferred.resolve($translationTable[langKey]);
      } else if (langPromises[langKey]) {
        var onResolve = function (data) {
          translations(data.key, data.table);
          deferred.resolve(data.table);
        };
        onResolve.displayName = 'translationTableResolver';
        langPromises[langKey].then(onResolve, deferred.reject);
      } else {
        deferred.reject();
      }
      return deferred.promise;
    };

    /**
     * @name getFallbackTranslation
     * @private
     *
     * @description
     * Returns a promise that will resolve to the translation
     * or be rejected if no translation was found for the language.
     * This function is currently only used for fallback language translation.
     *
     * @param langKey The language to translate to.
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {Q.promise}
     */
    var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var deferred = $q.defer();

      var onResolve = function (translationTable) {
        if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
          Interpolator.setLocale(langKey);
          var translation = translationTable[translationId];
          if (translation.substr(0, 2) === '@:') {
            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
              .then(deferred.resolve, deferred.reject);
          } else {
            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);

            deferred.resolve(interpolatedValue);

          }
          Interpolator.setLocale($uses);
        } else {
          deferred.reject();
        }
      };
      onResolve.displayName = 'fallbackTranslationResolver';

      getTranslationTable(langKey).then(onResolve, deferred.reject);

      return deferred.promise;
    };

    /**
     * @name getFallbackTranslationInstant
     * @private
     *
     * @description
     * Returns a translation
     * This function is currently only used for fallback language translation.
     *
     * @param langKey The language to translate to.
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy sanitize strategy override
     *
     * @returns {string} translation
     */
    var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var result, translationTable = $translationTable[langKey];

      if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
        Interpolator.setLocale(langKey);
        result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
        result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
        // workaround for TrustedValueHolderType
        if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
          var result2 = result.$$unwrapTrustedValue();
          if (result2.substr(0, 2) === '@:') {
            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
          }
        } else if (result.substr(0, 2) === '@:') {
          return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
        }
        Interpolator.setLocale($uses);
      }

      return result;
    };


    /**
     * @name translateByHandler
     * @private
     *
     * Translate by missing translation handler.
     *
     * @param translationId
     * @param interpolateParams
     * @param defaultTranslationText
     * @param sanitizeStrategy sanitize strategy override
     *
     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
     * absent
     */
    var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
      // If we have a handler factory - we might also call it here to determine if it provides
      // a default text for a translationid that can't be found anywhere in our tables
      if ($missingTranslationHandlerFactory) {
        return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
      } else {
        return translationId;
      }
    };

    /**
     * @name resolveForFallbackLanguage
     * @private
     *
     * Recursive helper function for fallbackTranslation that will sequentially look
     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
     *
     * @param fallbackLanguageIndex
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param defaultTranslationText
     * @param sanitizeStrategy
     * @returns {Q.promise} Promise that will resolve to the translation.
     */
    var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
      var deferred = $q.defer();

      if (fallbackLanguageIndex < $fallbackLanguage.length) {
        var langKey = $fallbackLanguage[fallbackLanguageIndex];
        getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
          function (data) {
            deferred.resolve(data);
          },
          function () {
            // Look in the next fallback language for a translation.
            // It delays the resolving by passing another promise to resolve.
            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
          }
        );
      } else {
        // No translation found in any fallback language
        // if a default translation text is set in the directive, then return this as a result
        if (defaultTranslationText) {
          deferred.resolve(defaultTranslationText);
        } else {
          var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);

          // if no default translation is set and an error handler is defined, send it to the handler
          // and then return the result if it isn't undefined
          if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
            deferred.resolve(missingTranslationHandlerTranslation);
          } else {
            deferred.reject(applyNotFoundIndicators(translationId));
          }
        }
      }
      return deferred.promise;
    };

    /**
     * @name resolveForFallbackLanguageInstant
     * @private
     *
     * Recursive helper function for fallbackTranslation that will sequentially look
     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
     *
     * @param fallbackLanguageIndex
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {string} translation
     */
    var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      var result;

      if (fallbackLanguageIndex < $fallbackLanguage.length) {
        var langKey = $fallbackLanguage[fallbackLanguageIndex];
        result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
        if (!result && result !== '') {
          result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
        }
      }
      return result;
    };

    /**
     * Translates with the usage of the fallback languages.
     *
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param defaultTranslationText
     * @param sanitizeStrategy
     * @returns {Q.promise} Promise, that resolves to the translation.
     */
    var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
      // Start with the fallbackLanguage with index 0
      return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
    };

    /**
     * Translates with the usage of the fallback languages.
     *
     * @param translationId
     * @param interpolateParams
     * @param Interpolator
     * @param sanitizeStrategy
     * @returns {String} translation
     */
    var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
      // Start with the fallbackLanguage with index 0
      return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
    };

    var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {

      var deferred = $q.defer();

      var table = uses ? $translationTable[uses] : $translationTable,
        Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;

      // if the translation id exists, we can just interpolate it
      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
        var translation = table[translationId];

        // If using link, rerun $translate with linked translationId and return it
        if (translation.substr(0, 2) === '@:') {

          $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
            .then(deferred.resolve, deferred.reject);
        } else {
          //
          var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
          resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
          deferred.resolve(resolvedTranslation);
        }
      } else {
        var missingTranslationHandlerTranslation;
        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
        if ($missingTranslationHandlerFactory && !pendingLoader) {
          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
        }

        // since we couldn't translate the inital requested translation id,
        // we try it now with one or more fallback languages, if fallback language(s) is
        // configured.
        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
          fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
            .then(function (translation) {
              deferred.resolve(translation);
            }, function (_translationId) {
              deferred.reject(applyNotFoundIndicators(_translationId));
            });
        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          if (defaultTranslationText) {
            deferred.resolve(defaultTranslationText);
          } else {
            deferred.resolve(missingTranslationHandlerTranslation);
          }
        } else {
          if (defaultTranslationText) {
            deferred.resolve(defaultTranslationText);
          } else {
            deferred.reject(applyNotFoundIndicators(translationId));
          }
        }
      }
      return deferred.promise;
    };

    var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {

      var result, table = uses ? $translationTable[uses] : $translationTable,
        Interpolator = defaultInterpolator;

      // if the interpolation id exists use custom interpolator
      if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
        Interpolator = interpolatorHashMap[interpolationId];
      }

      // if the translation id exists, we can just interpolate it
      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
        var translation = table[translationId];

        // If using link, rerun $translate with linked translationId and return it
        if (translation.substr(0, 2) === '@:') {
          result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
        } else {
          result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
          result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
        }
      } else {
        var missingTranslationHandlerTranslation;
        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
        if ($missingTranslationHandlerFactory && !pendingLoader) {
          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
        }

        // since we couldn't translate the inital requested translation id,
        // we try it now with one or more fallback languages, if fallback language(s) is
        // configured.
        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
          fallbackIndex = 0;
          result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          result = missingTranslationHandlerTranslation;
        } else {
          result = applyNotFoundIndicators(translationId);
        }
      }

      return result;
    };

    var clearNextLangAndPromise = function (key) {
      if ($nextLang === key) {
        $nextLang = undefined;
      }
      langPromises[key] = undefined;
    };

    var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
      var fn = postProcessFn;

      if (fn) {

        if (typeof(fn) === 'string') {
          // getting on-demand instance
          fn = $injector.get(fn);
        }
        if (fn) {
          return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
        }
      }

      return resolvedTranslation;
    };

    var loadTranslationsIfMissing = function (key) {
      if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
        langPromises[key] = loadAsync(key).then(function (translation) {
          translations(translation.key, translation.table);
          return translation;
        });
      }
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#preferredLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key for the preferred language.
     *
     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
     *
     * @return {string} preferred language key
     */
    $translate.preferredLanguage = function (langKey) {
      if (langKey) {
        setupPreferredLanguage(langKey);
      }
      return $preferredLanguage;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#cloakClassName
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the configured class name for `translate-cloak` directive.
     *
     * @return {string} cloakClassName
     */
    $translate.cloakClassName = function () {
      return $cloakClassName;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the configured delimiter for nested namespaces.
     *
     * @return {string} nestedObjectDelimeter
     */
    $translate.nestedObjectDelimeter = function () {
      return $nestedObjectDelimeter;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#fallbackLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key for the fallback languages or sets a new fallback stack.
     * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
     *
     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
     *
     * @return {string||array} fallback language key
     */
    $translate.fallbackLanguage = function (langKey) {
      if (langKey !== undefined && langKey !== null) {
        fallbackStack(langKey);

        // as we might have an async loader initiated and a new translation language might have been defined
        // we need to add the promise to the stack also. So - iterate.
        if ($loaderFactory) {
          if ($fallbackLanguage && $fallbackLanguage.length) {
            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
              if (!langPromises[$fallbackLanguage[i]]) {
                langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
              }
            }
          }
        }
        $translate.use($translate.use());
      }
      if ($fallbackWasString) {
        return $fallbackLanguage[0];
      } else {
        return $fallbackLanguage;
      }

    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#useFallbackLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Sets the first key of the fallback language stack to be used for translation.
     * Therefore all languages in the fallback array BEFORE this key will be skipped!
     *
     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
     * get back to the whole stack
     */
    $translate.useFallbackLanguage = function (langKey) {
      if (langKey !== undefined && langKey !== null) {
        if (!langKey) {
          startFallbackIteration = 0;
        } else {
          var langKeyPosition = indexOf($fallbackLanguage, langKey);
          if (langKeyPosition > -1) {
            startFallbackIteration = langKeyPosition;
          }
        }

      }

    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#proposedLanguage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the language key of language that is currently loaded asynchronously.
     *
     * @return {string} language key
     */
    $translate.proposedLanguage = function () {
      return $nextLang;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#storage
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns registered storage.
     *
     * @return {object} Storage
     */
    $translate.storage = function () {
      return Storage;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#negotiateLocale
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns a language key based on available languages and language aliases. If a
     * language key cannot be resolved, returns undefined.
     *
     * If no or a falsy key is given, returns undefined.
     *
     * @param {string} [key] Language key
     * @return {string|undefined} Language key or undefined if no language key is found.
     */
    $translate.negotiateLocale = negotiateLocale;

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#use
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Tells angular-translate which language to use by given language key. This method is
     * used to change language at runtime. It also takes care of storing the language
     * key in a configured store to let your app remember the choosed language.
     *
     * When trying to 'use' a language which isn't available it tries to load it
     * asynchronously with registered loaders.
     *
     * Returns promise object with loaded language file data or string of the currently used language.
     *
     * If no or a falsy key is given it returns the currently used language key.
     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
     * @example
     * $translate.use("en_US").then(function(data){
       *   $scope.text = $translate("HELLO");
       * });
     *
     * @param {string=} key Language key
     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
     */
    $translate.use = function (key) {
      if (!key) {
        return $uses;
      }

      var deferred = $q.defer();
      deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"

      $rootScope.$emit('$translateChangeStart', {language : key});

      // Try to get the aliased language key
      var aliasedKey = negotiateLocale(key);
      // Ensure only registered language keys will be loaded
      if ($availableLanguageKeys.length > 0 && !aliasedKey) {
        return $q.reject(key);
      }

      if (aliasedKey) {
        key = aliasedKey;
      }

      // if there isn't a translation table for the language we've requested,
      // we load it asynchronously
      $nextLang = key;
      if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
        langPromises[key] = loadAsync(key).then(function (translation) {
          translations(translation.key, translation.table);
          deferred.resolve(translation.key);
          if ($nextLang === key) {
            useLanguage(translation.key);
          }
          return translation;
        }, function (key) {
          $rootScope.$emit('$translateChangeError', {language : key});
          deferred.reject(key);
          $rootScope.$emit('$translateChangeEnd', {language : key});
          return $q.reject(key);
        });
        langPromises[key]['finally'](function () {
          clearNextLangAndPromise(key);
        })['catch'](angular.noop); // we don't care about errors (clearing)
      } else if (langPromises[key]) {
        // we are already loading this asynchronously
        // resolve our new deferred when the old langPromise is resolved
        langPromises[key].then(function (translation) {
          if ($nextLang === translation.key) {
            useLanguage(translation.key);
          }
          deferred.resolve(translation.key);
          return translation;
        }, function (key) {
          // find first available fallback language if that request has failed
          if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
          } else {
            return deferred.reject(key);
          }
        });
      } else {
        deferred.resolve(key);
        useLanguage(key);
      }

      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#resolveClientLocale
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
     *
     * @returns {string} the current client/browser language key
     */
    $translate.resolveClientLocale = function () {
      return getLocale();
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#storageKey
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the key for the storage.
     *
     * @return {string} storage key
     */
    $translate.storageKey = function () {
      return storageKey();
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether post compiling is enabled or not
     *
     * @return {bool} storage key
     */
    $translate.isPostCompilingEnabled = function () {
      return $postCompilingEnabled;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether force async reload is enabled or not
     *
     * @return {boolean} forceAsyncReload value
     */
    $translate.isForceAsyncReloadEnabled = function () {
      return $forceAsyncReloadEnabled;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isKeepContent
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether keepContent or not
     *
     * @return {boolean} keepContent value
     */
    $translate.isKeepContent = function () {
      return $keepContent;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#refresh
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
     * the module will drop all existent translation tables and load new version of those which
     * are currently in use.
     *
     * Refresh means that the module will drop target translation table and try to load it again.
     *
     * In case there are no loaders registered the refresh() method will throw an Error.
     *
     * If the module is able to refresh translation tables refresh() method will broadcast
     * $translateRefreshStart and $translateRefreshEnd events.
     *
     * @example
     * // this will drop all currently existent translation tables and reload those which are
     * // currently in use
     * $translate.refresh();
     * // this will refresh a translation table for the en_US language
     * $translate.refresh('en_US');
     *
     * @param {string} langKey A language key of the table, which has to be refreshed
     *
     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
     * process is finished successfully, and reject if not.
     */
    $translate.refresh = function (langKey) {
      if (!$loaderFactory) {
        throw new Error('Couldn\'t refresh translation table, no loader registered!');
      }

      $rootScope.$emit('$translateRefreshStart', {language : langKey});

      var deferred = $q.defer(), updatedLanguages = {};

      //private helper
      function loadNewData(languageKey) {
        var promise = loadAsync(languageKey);
        //update the load promise cache for this language
        langPromises[languageKey] = promise;
        //register a data handler for the promise
        promise.then(function (data) {
            //clear the cache for this language
            $translationTable[languageKey] = {};
            //add the new data for this language
            translations(languageKey, data.table);
            //track that we updated this language
            updatedLanguages[languageKey] = true;
          },
          //handle rejection to appease the $q validation
          angular.noop);
        return promise;
      }

      //set up post-processing
      deferred.promise.then(
        function () {
          for (var key in $translationTable) {
            if ($translationTable.hasOwnProperty(key)) {
              //delete cache entries that were not updated
              if (!(key in updatedLanguages)) {
                delete $translationTable[key];
              }
            }
          }
          if ($uses) {
            useLanguage($uses);
          }
        },
        //handle rejection to appease the $q validation
        angular.noop
      )['finally'](
        function () {
          $rootScope.$emit('$translateRefreshEnd', {language : langKey});
        }
      );

      if (!langKey) {
        // if there's no language key specified we refresh ALL THE THINGS!
        var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
        if ($uses && languagesToReload.indexOf($uses) === -1) {
          languagesToReload.push($uses);
        }
        $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);

      } else if ($translationTable[langKey]) {
        //just refresh the specified language cache
        loadNewData(langKey).then(deferred.resolve, deferred.reject);

      } else {
        deferred.reject();
      }

      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#instant
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns a translation instantly from the internal state of loaded translation. All rules
     * regarding the current language, the preferred language of even fallback languages will be
     * used except any promise handling. If a language was not found, an asynchronous loading
     * will be invoked in the background.
     *
     * @param {string|array} translationId A token which represents a translation id
     *                                     This can be optionally an array of translation ids which
     *                                     results that the function's promise returns an object where
     *                                     each key is the translation id and the value the translation.
     * @param {object=} [interpolateParams={}] Params
     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
     *
     * @return {string|object} translation
     */
    $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {

      // we don't want to re-negotiate $uses
      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;

      // Detect undefined and null values to shorten the execution and prevent exceptions
      if (translationId === null || angular.isUndefined(translationId)) {
        return translationId;
      }

      // Check forceLanguage is present
      if (forceLanguage) {
        loadTranslationsIfMissing(forceLanguage);
      }

      // Duck detection: If the first argument is an array, a bunch of translations was requested.
      // The result is an object.
      if (angular.isArray(translationId)) {
        var results = {};
        for (var i = 0, c = translationId.length; i < c; i++) {
          results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
        }
        return results;
      }

      // We discarded unacceptable values. So we just need to verify if translationId is empty String
      if (angular.isString(translationId) && translationId.length < 1) {
        return translationId;
      }

      // trim off any whitespace
      if (translationId) {
        translationId = trim.apply(translationId);
      }

      var result, possibleLangKeys = [];
      if ($preferredLanguage) {
        possibleLangKeys.push($preferredLanguage);
      }
      if (uses) {
        possibleLangKeys.push(uses);
      }
      if ($fallbackLanguage && $fallbackLanguage.length) {
        possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
      }
      for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
        var possibleLangKey = possibleLangKeys[j];
        if ($translationTable[possibleLangKey]) {
          if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
          }
        }
        if (typeof result !== 'undefined') {
          break;
        }
      }

      if (!result && result !== '') {
        if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
          result = applyNotFoundIndicators(translationId);
        } else {
          // Return translation of default interpolator if not found anything.
          result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);

          // looks like the requested translation id doesn't exists.
          // Now, if there is a registered handler for missing translations and no
          // asyncLoader is pending, we execute the handler
          var missingTranslationHandlerTranslation;
          if ($missingTranslationHandlerFactory && !pendingLoader) {
            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
          }

          if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
            result = missingTranslationHandlerTranslation;
          }
        }
      }

      return result;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#versionInfo
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the current version information for the angular-translate library
     *
     * @return {string} angular-translate version
     */
    $translate.versionInfo = function () {
      return version;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#loaderCache
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns the defined loaderCache.
     *
     * @return {boolean|string|object} current value of loaderCache
     */
    $translate.loaderCache = function () {
      return loaderCache;
    };

    // internal purpose only
    $translate.directivePriority = function () {
      return directivePriority;
    };

    // internal purpose only
    $translate.statefulFilter = function () {
      return statefulFilter;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#isReady
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
     *
     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
     *
     * @return {boolean} current value of ready
     */
    $translate.isReady = function () {
      return $isReady;
    };

    var $onReadyDeferred = $q.defer();
    $onReadyDeferred.promise.then(function () {
      $isReady = true;
    });

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#onReady
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
     *
     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
     *
     * @param {Function=} fn Function to invoke when service is ready
     * @return {object} Promise resolved when service is ready
     */
    $translate.onReady = function (fn) {
      var deferred = $q.defer();
      if (angular.isFunction(fn)) {
        deferred.promise.then(fn);
      }
      if ($isReady) {
        deferred.resolve();
      } else {
        $onReadyDeferred.promise.then(deferred.resolve);
      }
      return deferred.promise;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * This function simply returns the registered language keys being defined before in the config phase
     * With this, an application can use the array to provide a language selection dropdown or similar
     * without any additional effort
     *
     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
     */
    $translate.getAvailableLanguageKeys = function () {
      if ($availableLanguageKeys.length > 0) {
        return $availableLanguageKeys;
      }
      return null;
    };

    /**
     * @ngdoc function
     * @name pascalprecht.translate.$translate#getTranslationTable
     * @methodOf pascalprecht.translate.$translate
     *
     * @description
     * Returns translation table by the given language key.
     *
     * Unless a language is provided it returns a translation table of the current one.
     * Note: If translation dictionary is currently downloading or in progress
     * it will return null.
     *
     * @param {string} langKey A token which represents a translation id
     *
     * @return {object} a copy of angular-translate $translationTable
     */
    $translate.getTranslationTable = function (langKey) {
      langKey = langKey || $translate.use();
      if (langKey && $translationTable[langKey]) {
        return angular.copy($translationTable[langKey]);
      }
      return null;
    };

    // Whenever $translateReady is being fired, this will ensure the state of $isReady
    var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
      $onReadyDeferred.resolve();
      globalOnReadyListener(); // one time only
      globalOnReadyListener = null;
    });
    var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
      $onReadyDeferred.resolve();
      globalOnChangeListener(); // one time only
      globalOnChangeListener = null;
    });

    if ($loaderFactory) {

      // If at least one async loader is defined and there are no
      // (default) translations available we should try to load them.
      if (angular.equals($translationTable, {})) {
        if ($translate.use()) {
          $translate.use($translate.use());
        }
      }

      // Also, if there are any fallback language registered, we start
      // loading them asynchronously as soon as we can.
      if ($fallbackLanguage && $fallbackLanguage.length) {
        var processAsyncResult = function (translation) {
          translations(translation.key, translation.table);
          $rootScope.$emit('$translateChangeEnd', {language : translation.key});
          return translation;
        };
        for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
          var fallbackLanguageId = $fallbackLanguage[i];
          if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
          }
        }
      }
    } else {
      $rootScope.$emit('$translateReady', {language : $translate.use()});
    }

    return $translate;
  }];
}

$translate.displayName = 'displayName';

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translateDefaultInterpolation
 * @requires $interpolate
 *
 * @description
 * Uses angular's `$interpolate` services to interpolate strings against some values.
 *
 * Be aware to configure a proper sanitization strategy.
 *
 * See also:
 * * {@link pascalprecht.translate.$translateSanitization}
 *
 * @return {object} $translateDefaultInterpolation Interpolator service
 */
angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);

function $translateDefaultInterpolation ($interpolate, $translateSanitization) {

  'use strict';

  var $translateInterpolator = {},
      $locale,
      $identifier = 'default';

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Sets current locale (this is currently not use in this interpolation).
   *
   * @param {string} locale Language key or locale.
   */
  $translateInterpolator.setLocale = function (locale) {
    $locale = locale;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Returns an identifier for this interpolation service.
   *
   * @returns {string} $identifier
   */
  $translateInterpolator.getInterpolationIdentifier = function () {
    return $identifier;
  };

  /**
   * @deprecated will be removed in 3.0
   * @see {@link pascalprecht.translate.$translateSanitization}
   */
  $translateInterpolator.useSanitizeValueStrategy = function (value) {
    $translateSanitization.useStrategy(value);
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
   *
   * @description
   * Interpolates given value agains given interpolate params using angulars
   * `$interpolate` service.
   *
   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
   *
   * @param {string} value translation
   * @param {object} [interpolationParams={}] interpolation params
   * @param {string} [context=undefined] current context (filter, directive, service)
   * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
   * @param {string} translationId current translationId
   *
   * @returns {string} interpolated string
   */
  $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
    interpolationParams = interpolationParams || {};
    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);

    var interpolatedText;
    if (angular.isNumber(value)) {
      // numbers are safe
      interpolatedText = '' + value;
    } else if (angular.isString(value)) {
      // strings must be interpolated (that's the job here)
      interpolatedText = $interpolate(value)(interpolationParams);
      interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
    } else {
      // neither a number or a string, cant interpolate => empty string
      interpolatedText = '';
    }

    return interpolatedText;
  };

  return $translateInterpolator;
}

$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';

angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translate
 * @requires $interpolate,
 * @requires $compile,
 * @requires $parse,
 * @requires $rootScope
 * @restrict AE
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses $translate service to translate the translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate Translation id which could be either string or interpolated string.
 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
 * @param {string=} translate-default will be used unless translation was successful
 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre translate="TRANSLATION_ID"></pre>
        <pre translate>TRANSLATION_ID</pre>
        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
        <pre translate="{{translationId}}"></pre>
        <pre translate>{{translationId}}</pre>
        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
        }).preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
    <file name="scenario.js">
      it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('Hello there!');

          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.attr('title')).toBe('Hello there!');

          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
          $rootScope.$digest();
          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
        });
      });
    </file>
   </example>
 */
.directive('translate', translateDirective);
function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {

  'use strict';

  /**
   * @name trim
   * @private
   *
   * @description
   * trim polyfill
   *
   * @returns {string} The string stripped of whitespace from both ends
   */
  var trim = function() {
    return this.toString().replace(/^\s+|\s+$/g, '');
  };

  /**
   * @name lowercase
   * @private
   *
   * @description
   * Return the lowercase string only if the type is string
   *
   * @returns {string} The string all in lowercase
   */
  var lowercase = function (string) {
    return angular.isString(string) ? string.toLowerCase() : string;
  };

  return {
    restrict: 'AE',
    scope: true,
    priority: $translate.directivePriority(),
    compile: function (tElement, tAttr) {

      var translateValuesExist = (tAttr.translateValues) ?
        tAttr.translateValues : undefined;

      var translateInterpolation = (tAttr.translateInterpolation) ?
        tAttr.translateInterpolation : undefined;

      var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
        tAttr.translateSanitizeStrategy : undefined;

      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);

      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';

      return function linkFn(scope, iElement, iAttr) {

        scope.interpolateParams = {};
        scope.preText = '';
        scope.postText = '';
        scope.translateNamespace = getTranslateNamespace(scope);
        var translationIds = {};

        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
          // initial setup
          if (iAttr.translateValues) {
            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
          }
          // initially fetch all attributes if existing and fill the params
          if (translateValueExist) {
            for (var attr in tAttr) {
              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
                var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
                interpolateParams[attributeName] = tAttr[attr];
              }
            }
          }
        };

        // Ensures any change of the attribute "translate" containing the id will
        // be re-stored to the scope's "translationId".
        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
        var observeElementTranslation = function (translationId) {

          // Remove any old watcher
          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
            observeElementTranslation._unwatchOld();
            observeElementTranslation._unwatchOld = undefined;
          }

          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
            var iElementText = trim.apply(iElement.text());

            // Resolve translation id by inner html if required
            var interpolateMatches = iElementText.match(interpolateRegExp);
            // Interpolate translation id if required
            if (angular.isArray(interpolateMatches)) {
              scope.preText = interpolateMatches[1];
              scope.postText = interpolateMatches[3];
              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
              var watcherMatches = iElementText.match(watcherRegExp);
              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
                  translationIds.translate = newValue;
                  updateTranslations();
                });
              }
            } else {
              // do not assigne the translation id if it is empty.
              translationIds.translate = !iElementText ? undefined : iElementText;
            }
          } else {
            translationIds.translate = translationId;
          }
          updateTranslations();
        };

        var observeAttributeTranslation = function (translateAttr) {
          iAttr.$observe(translateAttr, function (translationId) {
            translationIds[translateAttr] = translationId;
            updateTranslations();
          });
        };

        // initial setup with values
        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);

        var firstAttributeChangedEvent = true;
        iAttr.$observe('translate', function (translationId) {
          if (typeof translationId === 'undefined') {
            // case of element "<translate>xyz</translate>"
            observeElementTranslation('');
          } else {
            // case of regular attribute
            if (translationId !== '' || !firstAttributeChangedEvent) {
              translationIds.translate = translationId;
              updateTranslations();
            }
          }
          firstAttributeChangedEvent = false;
        });

        for (var translateAttr in iAttr) {
          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
            observeAttributeTranslation(translateAttr);
          }
        }

        iAttr.$observe('translateDefault', function (value) {
          scope.defaultText = value;
          updateTranslations();
        });

        if (translateSanitizeStrategyExist) {
          iAttr.$observe('translateSanitizeStrategy', function (value) {
            scope.sanitizeStrategy = $parse(value)(scope.$parent);
            updateTranslations();
          });
        }

        if (translateValuesExist) {
          iAttr.$observe('translateValues', function (interpolateParams) {
            if (interpolateParams) {
              scope.$parent.$watch(function () {
                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
              });
            }
          });
        }

        if (translateValueExist) {
          var observeValueAttribute = function (attrName) {
            iAttr.$observe(attrName, function (value) {
              var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
              scope.interpolateParams[attributeName] = value;
            });
          };
          for (var attr in iAttr) {
            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
              observeValueAttribute(attr);
            }
          }
        }

        // Master update function
        var updateTranslations = function () {
          for (var key in translationIds) {
            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
            }
          }
        };

        // Put translation processing function outside loop
        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
          if (translationId) {
            // if translation id starts with '.' and translateNamespace given, prepend namespace
            if (translateNamespace && translationId.charAt(0) === '.') {
              translationId = translateNamespace + translationId;
            }

            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
              .then(function (translation) {
                applyTranslation(translation, scope, true, translateAttr);
              }, function (translationId) {
                applyTranslation(translationId, scope, false, translateAttr);
              });
          } else {
            // as an empty string cannot be translated, we can solve this using successful=false
            applyTranslation(translationId, scope, false, translateAttr);
          }
        };

        var applyTranslation = function (value, scope, successful, translateAttr) {
          if (!successful) {
            if (typeof scope.defaultText !== 'undefined') {
              value = scope.defaultText;
            }
          }
          if (translateAttr === 'translate') {
            // default translate into innerHTML
            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
              iElement.empty().append(scope.preText + value + scope.postText);
            }
            var globallyEnabled = $translate.isPostCompilingEnabled();
            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
              $compile(iElement.contents())(scope);
            }
          } else {
            // translate attribute
            var attributeName = iAttr.$attr[translateAttr];
            if (attributeName.substr(0, 5) === 'data-') {
              // ensure html5 data prefix is stripped
              attributeName = attributeName.substr(5);
            }
            attributeName = attributeName.substr(15);
            iElement.attr(attributeName, value);
          }
        };

        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
          scope.$watch('interpolateParams', updateTranslations, true);
        }

        // Replaced watcher on translateLanguage with event listener
        scope.$on('translateLanguageChanged', updateTranslations);

        // Ensures the text will be refreshed after the current language was changed
        // w/ $translate.use(...)
        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

        // ensure translation will be looked up at least one
        if (iElement.text().length) {
          if (iAttr.translate) {
            observeElementTranslation(iAttr.translate);
          } else {
            observeElementTranslation('');
          }
        } else if (iAttr.translate) {
          // ensure attribute will be not skipped
          observeElementTranslation(iAttr.translate);
        }
        updateTranslations();
        scope.$on('$destroy', unbind);
      };
    }
  };
}

/**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */
function getTranslateNamespace(scope) {
  'use strict';
  if (scope.translateNamespace) {
    return scope.translateNamespace;
  }
  if (scope.$parent) {
    return getTranslateNamespace(scope.$parent);
  }
}

translateDirective.displayName = 'translateDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translate-attr
 * @restrict A
 *
 * @description
 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
 * Internally it uses `translate` service to translate translation id. It possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}',
        }).preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
    <file name="scenario.js">
      it('should translate', function () {
        inject(function ($rootScope, $compile) {
          $rootScope.translationId = 'TRANSLATION_ID';

          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
          $rootScope.$digest();
          expect(element.attr('placeholder)).toBe('Hello there!');
          expect(element.attr('title)).toBe('The following value is dynamic: 5');
        });
      });
    </file>
   </example>
 */
.directive('translateAttr', translateAttrDirective);
function translateAttrDirective($translate, $rootScope) {

  'use strict';

  return {
    restrict: 'A',
    priority: $translate.directivePriority(),
    link: function linkFn(scope, element, attr) {

      var translateAttr,
          translateValues,
          translateSanitizeStrategy,
          previousAttributes = {};

      // Main update translations function
      var updateTranslations = function () {
        angular.forEach(translateAttr, function (translationId, attributeName) {
          if (!translationId) {
            return;
          }
          previousAttributes[attributeName] = true;

          // if translation id starts with '.' and translateNamespace given, prepend namespace
          if (scope.translateNamespace && translationId.charAt(0) === '.') {
            translationId = scope.translateNamespace + translationId;
          }
          $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
            .then(function (translation) {
              element.attr(attributeName, translation);
            }, function (translationId) {
              element.attr(attributeName, translationId);
            });
        });

        // Removing unused attributes that were previously used
        angular.forEach(previousAttributes, function (flag, attributeName) {
          if (!translateAttr[attributeName]) {
            element.removeAttr(attributeName);
            delete previousAttributes[attributeName];
          }
        });
      };

      // Watch for attribute changes
      watchAttribute(
        scope,
        attr.translateAttr,
        function (newValue) { translateAttr = newValue; },
        updateTranslations
      );
      // Watch for value changes
      watchAttribute(
        scope,
        attr.translateValues,
        function (newValue) { translateValues = newValue; },
        updateTranslations
      );
      // Watch for sanitize strategy changes
      watchAttribute(
        scope,
        attr.translateSanitizeStrategy,
        function (newValue) { translateSanitizeStrategy = newValue; },
        updateTranslations
      );

      if (attr.translateValues) {
        scope.$watch(attr.translateValues, updateTranslations, true);
      }

      // Replaced watcher on translateLanguage with event listener
      scope.$on('translateLanguageChanged', updateTranslations);

      // Ensures the text will be refreshed after the current language was changed
      // w/ $translate.use(...)
      var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);

      updateTranslations();
      scope.$on('$destroy', unbind);
    }
  };
}

function watchAttribute(scope, attribute, valueCallback, changeCallback) {
  'use strict';
  if (!attribute) {
    return;
  }
  if (attribute.substr(0, 2) === '::') {
    attribute = attribute.substr(2);
  } else {
    scope.$watch(attribute, function(newValue) {
      valueCallback(newValue);
      changeCallback();
    }, true);
  }
  valueCallback(scope.$eval(attribute));
}

translateAttrDirective.displayName = 'translateAttrDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateCloak
 * @requires $translate
 * @restrict A
 *
 * $description
 * Adds a `translate-cloak` class name to the given element where this directive
 * is applied initially and removes it, once a loader has finished loading.
 *
 * This directive can be used to prevent initial flickering when loading translation
 * data asynchronously.
 *
 * The class name is defined in
 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
 *
 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
 *                                  or hiding the cloak. Basically it relies on the translation
 *                                  resolve.
 */
.directive('translateCloak', translateCloakDirective);

function translateCloakDirective($translate, $rootScope) {

  'use strict';

  return {
    compile : function (tElement) {
      var applyCloak = function (element) {
          element.addClass($translate.cloakClassName());
        },
        removeCloak = function (element) {
          element.removeClass($translate.cloakClassName());
        };
      applyCloak(tElement);

      return function linkFn(scope, iElement, iAttr) {
        //Create bound functions that incorporate the active DOM element.
        var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
        if (iAttr.translateCloak && iAttr.translateCloak.length) {
          // Register a watcher for the defined translation allowing a fine tuned cloak
          iAttr.$observe('translateCloak', function (translationId) {
            $translate(translationId).then(iRemoveCloak, iApplyCloak);
          });
          $rootScope.$on('$translateChangeSuccess', function () {
            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
          });
        } else {
          $translate.onReady(iRemoveCloak);
        }
      };
    }
  };
}

translateCloakDirective.displayName = 'translateCloakDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateNamespace
 * @restrict A
 *
 * @description
 * Translates given translation id either through attribute or DOM content.
 * Internally it uses `translate` filter to translate translation id. It is possible to
 * pass an optional `translate-values` object literal as string into translation id.
 *
 * @param {string=} translate namespace name which could be either string or interpolated string.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div translate-namespace="CONTENT">

        <div>
            <h1 translate>.HEADERS.TITLE</h1>
            <h1 translate>.HEADERS.WELCOME</h1>
        </div>

        <div translate-namespace=".HEADERS">
            <h1 translate>.TITLE</h1>
            <h1 translate>.WELCOME</h1>
        </div>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en',{
          'TRANSLATION_ID': 'Hello there!',
          'CONTENT': {
            'HEADERS': {
                TITLE: 'Title'
            }
          },
          'CONTENT.HEADERS.WELCOME': 'Welcome'
        }).preferredLanguage('en');

      });

    </file>
   </example>
 */
.directive('translateNamespace', translateNamespaceDirective);

function translateNamespaceDirective() {

  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function () {
      return {
        pre: function (scope, iElement, iAttrs) {
          scope.translateNamespace = _getTranslateNamespace(scope);

          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
            scope.translateNamespace += iAttrs.translateNamespace;
          } else {
            scope.translateNamespace = iAttrs.translateNamespace;
          }
        }
      };
    }
  };
}

/**
 * Returns the scope's namespace.
 * @private
 * @param scope
 * @returns {string}
 */
function _getTranslateNamespace(scope) {
  'use strict';
  if (scope.translateNamespace) {
    return scope.translateNamespace;
  }
  if (scope.$parent) {
    return _getTranslateNamespace(scope.$parent);
  }
}

translateNamespaceDirective.displayName = 'translateNamespaceDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc directive
 * @name pascalprecht.translate.directive:translateLanguage
 * @restrict A
 *
 * @description
 * Forces the language to the directives in the underlying scope.
 *
 * @param {string=} translate language that will be negotiated.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div>

        <div>
            <h1 translate>HELLO</h1>
        </div>

        <div translate-language="de">
            <h1 translate>HELLO</h1>
        </div>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider
          .translations('en',{
            'HELLO': 'Hello world!'
          })
          .translations('de',{
            'HELLO': 'Hallo Welt!'
          })
          .preferredLanguage('en');

      });

    </file>
   </example>
 */
.directive('translateLanguage', translateLanguageDirective);

function translateLanguageDirective() {

  'use strict';

  return {
    restrict: 'A',
    scope: true,
    compile: function () {
      return function linkFn(scope, iElement, iAttrs) {

        iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
          scope.translateLanguage = newTranslateLanguage;
        });

        scope.$watch('translateLanguage', function(){
          scope.$broadcast('translateLanguageChanged');
        });
      };
    }
  };
}

translateLanguageDirective.displayName = 'translateLanguageDirective';

angular.module('pascalprecht.translate')
/**
 * @ngdoc filter
 * @name pascalprecht.translate.filter:translate
 * @requires $parse
 * @requires pascalprecht.translate.$translate
 * @function
 *
 * @description
 * Uses `$translate` service to translate contents. Accepts interpolate parameters
 * to pass dynamized values though translation.
 *
 * @param {string} translationId A translation id to be translated.
 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
 *
 * @returns {string} Translated text.
 *
 * @example
   <example module="ngView">
    <file name="index.html">
      <div ng-controller="TranslateCtrl">

        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
        <pre>{{ translationId | translate }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>

      </div>
    </file>
    <file name="script.js">
      angular.module('ngView', ['pascalprecht.translate'])

      .config(function ($translateProvider) {

        $translateProvider.translations('en', {
          'TRANSLATION_ID': 'Hello there!',
          'WITH_VALUES': 'The following value is dynamic: {{value}}'
        });
        $translateProvider.preferredLanguage('en');

      });

      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
        $scope.translationId = 'TRANSLATION_ID';

        $scope.values = {
          value: 78
        };
      });
    </file>
   </example>
 */
.filter('translate', translateFilterFactory);

function translateFilterFactory($parse, $translate) {

  'use strict';

  var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
    if (!angular.isObject(interpolateParams)) {
      var ctx = this || {
        '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
        };
      interpolateParams = $parse(interpolateParams)(ctx);
    }

    return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
  };

  if ($translate.statefulFilter()) {
    translateFilter.$stateful = true;
  }

  return translateFilter;
}

translateFilterFactory.displayName = 'translateFilterFactory';

angular.module('pascalprecht.translate')

/**
 * @ngdoc object
 * @name pascalprecht.translate.$translationCache
 * @requires $cacheFactory
 *
 * @description
 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
 * can load translation tables directly into the cache by consuming the
 * `$translationCache` service directly.
 *
 * @return {object} $cacheFactory object.
 */
  .factory('$translationCache', $translationCache);

function $translationCache($cacheFactory) {

  'use strict';

  return $cacheFactory('translations');
}

$translationCache.displayName = '$translationCache';
return 'pascalprecht.translate';

}));

;(function () {
	'use strict';

	/**
	 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
	 *
	 * @codingstandard ftlabs-jsv2
	 * @copyright The Financial Times Limited [All Rights Reserved]
	 * @license MIT License (see LICENSE.txt)
	 */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/


	/**
	 * Instantiate fast-clicking listeners on the specified layer.
	 *
	 * @constructor
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
		 * Whether a click is currently being tracked.
		 *
		 * @type boolean
		 */
		this.trackingClick = false;


		/**
		 * Timestamp for when click tracking started.
		 *
		 * @type number
		 */
		this.trackingClickStart = 0;


		/**
		 * The element being tracked for a click.
		 *
		 * @type EventTarget
		 */
		this.targetElement = null;


		/**
		 * X-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartX = 0;


		/**
		 * Y-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartY = 0;


		/**
		 * ID of the last touch, retrieved from Touch.identifier.
		 *
		 * @type number
		 */
		this.lastTouchIdentifier = 0;


		/**
		 * Touchmove boundary, beyond which a click will be cancelled.
		 *
		 * @type number
		 */
		this.touchBoundary = options.touchBoundary || 10;


		/**
		 * The FastClick layer.
		 *
		 * @type Element
		 */
		this.layer = layer;

		/**
		 * The minimum time between tap(touchstart and touchend) events
		 *
		 * @type number
		 */
		this.tapDelay = options.tapDelay || 200;

		/**
		 * The maximum time for a tap
		 *
		 * @type number
		 */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function() { return method.apply(context, arguments); };
		}


		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function(type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function(type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
						if (!event.propagationStopped) {
							callback(event);
						}
					}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function(event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
	* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
	*
	* @type boolean
	*/
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
	 * Android requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;


	/**
	 * iOS requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;


	/**
	 * iOS 4 requires an exception for select elements.
	 *
	 * @type boolean
	 */
	var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);


	/**
	 * iOS 6.0-7.* requires the target element to be manually derived
	 *
	 * @type boolean
	 */
	var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);

	/**
	 * BlackBerry requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
	 * Determine whether a given element requires a native click.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element needs a native click
	 */
	FastClick.prototype.needsClick = function(target) {
		switch (target.nodeName.toLowerCase()) {

		// Don't send a synthetic click to disabled inputs (issue #62)
		case 'button':
		case 'select':
		case 'textarea':
			if (target.disabled) {
				return true;
			}

			break;
		case 'input':

			// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
			if ((deviceIsIOS && target.type === 'file') || target.disabled) {
				return true;
			}

			break;
		case 'label':
		case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
		case 'video':
			return true;
		}

		return (/\bneedsclick\b/).test(target.className);
	};


	/**
	 * Determine whether a given element requires a call to focus to simulate click into element.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	 */
	FastClick.prototype.needsFocus = function(target) {
		switch (target.nodeName.toLowerCase()) {
		case 'textarea':
			return true;
		case 'select':
			return !deviceIsAndroid;
		case 'input':
			switch (target.type) {
			case 'button':
			case 'checkbox':
			case 'file':
			case 'image':
			case 'radio':
			case 'submit':
				return false;
			}

			// No point in attempting to focus disabled inputs
			return !target.disabled && !target.readOnly;
		default:
			return (/\bneedsfocus\b/).test(target.className);
		}
	};


	/**
	 * Send a click event to the specified element.
	 *
	 * @param {EventTarget|Element} targetElement
	 * @param {Event} event
	 */
	FastClick.prototype.sendClick = function(targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function(targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};


	/**
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.focus = function(targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};


	/**
	 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	 *
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.updateScrollParent = function(targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};


	/**
	 * @param {EventTarget} targetElement
	 * @returns {Element|EventTarget}
	 */
	FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};


	/**
	 * On touch start, record the position and scroll offset.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchStart = function(event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};


	/**
	 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.touchHasMoved = function(event) {
		var touch = event.changedTouches[0], boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};


	/**
	 * Update the last position.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchMove = function(event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};


	/**
	 * Attempt to find the labelled control for the given label element.
	 *
	 * @param {EventTarget|HTMLLabelElement} labelElement
	 * @returns {Element|null}
	 */
	FastClick.prototype.findControl = function(labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};


	/**
	 * On touch end, determine whether to send a click event at once.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchEnd = function(event) {
		var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};


	/**
	 * On touch cancel, stop tracking the click.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.onTouchCancel = function() {
		this.trackingClick = false;
		this.targetElement = null;
	};


	/**
	 * Determine mouse events which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onMouse = function(event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};


	/**
	 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	 * an actual click which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onClick = function(event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};


	/**
	 * Remove all FastClick's event listeners.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.destroy = function() {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};


	/**
	 * Check whether FastClick is needed.
	 *
	 * @param {Element} layer The layer to listen on
	 */
	FastClick.notNeeded = function(layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

			// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};


	/**
	 * Factory method for creating a FastClick object
	 *
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	FastClick.attach = function(layer, options) {
		return new FastClick(layer, options);
	};


	if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {

		// AMD. Register as an anonymous module.
		define(function() {
			return FastClick;
		});
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = FastClick.attach;
		module.exports.FastClick = FastClick;
	} else {
		window.FastClick = FastClick;
	}
}());

/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 2.5.0 - 2017-01-28
 * License: MIT
 */angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse","ui.bootstrap.tabindex","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.isClass","ui.bootstrap.datepicker","ui.bootstrap.position","ui.bootstrap.datepickerPopup","ui.bootstrap.debounce","ui.bootstrap.multiMap","ui.bootstrap.dropdown","ui.bootstrap.stackedMap","ui.bootstrap.modal","ui.bootstrap.paging","ui.bootstrap.pager","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);
angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html","uib/template/accordion/accordion.html","uib/template/alert/alert.html","uib/template/carousel/carousel.html","uib/template/carousel/slide.html","uib/template/datepicker/datepicker.html","uib/template/datepicker/day.html","uib/template/datepicker/month.html","uib/template/datepicker/year.html","uib/template/datepickerPopup/popup.html","uib/template/modal/window.html","uib/template/pager/pager.html","uib/template/pagination/pagination.html","uib/template/tooltip/tooltip-html-popup.html","uib/template/tooltip/tooltip-popup.html","uib/template/tooltip/tooltip-template-popup.html","uib/template/popover/popover-html.html","uib/template/popover/popover-template.html","uib/template/popover/popover.html","uib/template/progressbar/bar.html","uib/template/progressbar/progress.html","uib/template/progressbar/progressbar.html","uib/template/rating/rating.html","uib/template/tabs/tab.html","uib/template/tabs/tabset.html","uib/template/timepicker/timepicker.html","uib/template/typeahead/typeahead-match.html","uib/template/typeahead/typeahead-popup.html"]);
angular.module('ui.bootstrap.collapse', [])

  .directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function($animate, $q, $parse, $injector) {
    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
    return {
      link: function(scope, element, attrs) {
        var expandingExpr = $parse(attrs.expanding),
          expandedExpr = $parse(attrs.expanded),
          collapsingExpr = $parse(attrs.collapsing),
          collapsedExpr = $parse(attrs.collapsed),
          horizontal = false,
          css = {},
          cssTo = {};

        init();

        function init() {
          horizontal = !!('horizontal' in attrs);
          if (horizontal) {
            css = {
              width: ''
            };
            cssTo = {width: '0'};
          } else {
            css = {
              height: ''
            };
            cssTo = {height: '0'};
          }
          if (!scope.$eval(attrs.uibCollapse)) {
            element.addClass('in')
              .addClass('collapse')
              .attr('aria-expanded', true)
              .attr('aria-hidden', false)
              .css(css);
          }
        }

        function getScrollFromElement(element) {
          if (horizontal) {
            return {width: element.scrollWidth + 'px'};
          }
          return {height: element.scrollHeight + 'px'};
        }

        function expand() {
          if (element.hasClass('collapse') && element.hasClass('in')) {
            return;
          }

          $q.resolve(expandingExpr(scope))
            .then(function() {
              element.removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', true)
                .attr('aria-hidden', false);

              if ($animateCss) {
                $animateCss(element, {
                  addClass: 'in',
                  easing: 'ease',
                  css: {
                    overflow: 'hidden'
                  },
                  to: getScrollFromElement(element[0])
                }).start()['finally'](expandDone);
              } else {
                $animate.addClass(element, 'in', {
                  css: {
                    overflow: 'hidden'
                  },
                  to: getScrollFromElement(element[0])
                }).then(expandDone);
              }
            }, angular.noop);
        }

        function expandDone() {
          element.removeClass('collapsing')
            .addClass('collapse')
            .css(css);
          expandedExpr(scope);
        }

        function collapse() {
          if (!element.hasClass('collapse') && !element.hasClass('in')) {
            return collapseDone();
          }

          $q.resolve(collapsingExpr(scope))
            .then(function() {
              element
              // IMPORTANT: The width must be set before adding "collapsing" class.
              // Otherwise, the browser attempts to animate from width 0 (in
              // collapsing class) to the given width here.
                .css(getScrollFromElement(element[0]))
                // initially all panel collapse have the collapse class, this removal
                // prevents the animation from jumping to collapsed state
                .removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', false)
                .attr('aria-hidden', true);

              if ($animateCss) {
                $animateCss(element, {
                  removeClass: 'in',
                  to: cssTo
                }).start()['finally'](collapseDone);
              } else {
                $animate.removeClass(element, 'in', {
                  to: cssTo
                }).then(collapseDone);
              }
            }, angular.noop);
        }

        function collapseDone() {
          element.css(cssTo); // Required so that collapse works when animation is disabled
          element.removeClass('collapsing')
            .addClass('collapse');
          collapsedExpr(scope);
        }

        scope.$watch(attrs.uibCollapse, function(shouldCollapse) {
          if (shouldCollapse) {
            collapse();
          } else {
            expand();
          }
        });
      }
    };
  }]);

angular.module('ui.bootstrap.tabindex', [])

.directive('uibTabindexToggle', function() {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      attrs.$observe('disabled', function(disabled) {
        attrs.$set('tabindex', disabled ? -1 : null);
      });
    }
  };
});

angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex'])

.constant('uibAccordionConfig', {
  closeOthers: true
})

.controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function($scope, $attrs, accordionConfig) {
  // This array keeps track of the accordion groups
  this.groups = [];

  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
  this.closeOthers = function(openGroup) {
    var closeOthers = angular.isDefined($attrs.closeOthers) ?
      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
    if (closeOthers) {
      angular.forEach(this.groups, function(group) {
        if (group !== openGroup) {
          group.isOpen = false;
        }
      });
    }
  };

  // This is called from the accordion-group directive to add itself to the accordion
  this.addGroup = function(groupScope) {
    var that = this;
    this.groups.push(groupScope);

    groupScope.$on('$destroy', function(event) {
      that.removeGroup(groupScope);
    });
  };

  // This is called from the accordion-group directive when to remove itself
  this.removeGroup = function(group) {
    var index = this.groups.indexOf(group);
    if (index !== -1) {
      this.groups.splice(index, 1);
    }
  };
}])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
.directive('uibAccordion', function() {
  return {
    controller: 'UibAccordionController',
    controllerAs: 'accordion',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion.html';
    }
  };
})

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
.directive('uibAccordionGroup', function() {
  return {
    require: '^uibAccordion',         // We need this directive to be inside an accordion
    transclude: true,              // It transcludes the contents of the directive into the template
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
    },
    scope: {
      heading: '@',               // Interpolate the heading attribute onto this scope
      panelClass: '@?',           // Ditto with panelClass
      isOpen: '=?',
      isDisabled: '=?'
    },
    controller: function() {
      this.setHeading = function(element) {
        this.heading = element;
      };
    },
    link: function(scope, element, attrs, accordionCtrl) {
      element.addClass('panel');
      accordionCtrl.addGroup(scope);

      scope.openClass = attrs.openClass || 'panel-open';
      scope.panelClass = attrs.panelClass || 'panel-default';
      scope.$watch('isOpen', function(value) {
        element.toggleClass(scope.openClass, !!value);
        if (value) {
          accordionCtrl.closeOthers(scope);
        }
      });

      scope.toggleOpen = function($event) {
        if (!scope.isDisabled) {
          if (!$event || $event.which === 32) {
            scope.isOpen = !scope.isOpen;
          }
        }
      };

      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
      scope.headingId = id + '-tab';
      scope.panelId = id + '-panel';
    }
  };
})

// Use accordion-heading below an accordion-group to provide a heading containing HTML
.directive('uibAccordionHeading', function() {
  return {
    transclude: true,   // Grab the contents to be used as the heading
    template: '',       // In effect remove this element!
    replace: true,
    require: '^uibAccordionGroup',
    link: function(scope, element, attrs, accordionGroupCtrl, transclude) {
      // Pass the heading to the accordion-group controller
      // so that it can be transcluded into the right place in the template
      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
    }
  };
})

// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
.directive('uibAccordionTransclude', function() {
  return {
    require: '^uibAccordionGroup',
    link: function(scope, element, attrs, controller) {
      scope.$watch(function() { return controller[attrs.uibAccordionTransclude]; }, function(heading) {
        if (heading) {
          var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
          elem.html('');
          elem.append(heading);
        }
      });
    }
  };

  function getHeaderSelectors() {
      return 'uib-accordion-header,' +
          'data-uib-accordion-header,' +
          'x-uib-accordion-header,' +
          'uib\\:accordion-header,' +
          '[uib-accordion-header],' +
          '[data-uib-accordion-header],' +
          '[x-uib-accordion-header]';
  }
});

angular.module('ui.bootstrap.alert', [])

.controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function($scope, $element, $attrs, $interpolate, $timeout) {
  $scope.closeable = !!$attrs.close;
  $element.addClass('alert');
  $attrs.$set('role', 'alert');
  if ($scope.closeable) {
    $element.addClass('alert-dismissible');
  }

  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
    $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;

  if (dismissOnTimeout) {
    $timeout(function() {
      $scope.close();
    }, parseInt(dismissOnTimeout, 10));
  }
}])

.directive('uibAlert', function() {
  return {
    controller: 'UibAlertController',
    controllerAs: 'alert',
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/alert/alert.html';
    },
    transclude: true,
    scope: {
      close: '&'
    }
  };
});

angular.module('ui.bootstrap.buttons', [])

.constant('uibButtonConfig', {
  activeClass: 'active',
  toggleEvent: 'click'
})

.controller('UibButtonsController', ['uibButtonConfig', function(buttonConfig) {
  this.activeClass = buttonConfig.activeClass || 'active';
  this.toggleEvent = buttonConfig.toggleEvent || 'click';
}])

.directive('uibBtnRadio', ['$parse', function($parse) {
  return {
    require: ['uibBtnRadio', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'buttons',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
      var uncheckableExpr = $parse(attrs.uibUncheckable);

      element.find('input').css({display: 'none'});

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        var isActive = element.hasClass(buttonsCtrl.activeClass);

        if (!isActive || angular.isDefined(attrs.uncheckable)) {
          scope.$apply(function() {
            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
            ngModelCtrl.$render();
          });
        }
      });

      if (attrs.uibUncheckable) {
        scope.$watch(uncheckableExpr, function(uncheckable) {
          attrs.$set('uncheckable', uncheckable ? '' : undefined);
        });
      }
    }
  };
}])

.directive('uibBtnCheckbox', function() {
  return {
    require: ['uibBtnCheckbox', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'button',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      element.find('input').css({display: 'none'});

      function getTrueValue() {
        return getCheckboxValue(attrs.btnCheckboxTrue, true);
      }

      function getFalseValue() {
        return getCheckboxValue(attrs.btnCheckboxFalse, false);
      }

      function getCheckboxValue(attribute, defaultValue) {
        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
      }

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        scope.$apply(function() {
          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
          ngModelCtrl.$render();
        });
      });
    }
  };
});

angular.module('ui.bootstrap.carousel', [])

.controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function($scope, $element, $interval, $timeout, $animate) {
  var self = this,
    slides = self.slides = $scope.slides = [],
    SLIDE_DIRECTION = 'uib-slideDirection',
    currentIndex = $scope.active,
    currentInterval, isPlaying;

  var destroyed = false;
  $element.addClass('carousel');

  self.addSlide = function(slide, element) {
    slides.push({
      slide: slide,
      element: element
    });
    slides.sort(function(a, b) {
      return +a.slide.index - +b.slide.index;
    });
    //if this is the first slide or the slide is set to active, select it
    if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
      if ($scope.$currentTransition) {
        $scope.$currentTransition = null;
      }

      currentIndex = slide.index;
      $scope.active = slide.index;
      setActive(currentIndex);
      self.select(slides[findSlideIndex(slide)]);
      if (slides.length === 1) {
        $scope.play();
      }
    }
  };

  self.getCurrentIndex = function() {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].slide.index === currentIndex) {
        return i;
      }
    }
  };

  self.next = $scope.next = function() {
    var newIndex = (self.getCurrentIndex() + 1) % slides.length;

    if (newIndex === 0 && $scope.noWrap()) {
      $scope.pause();
      return;
    }

    return self.select(slides[newIndex], 'next');
  };

  self.prev = $scope.prev = function() {
    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;

    if ($scope.noWrap() && newIndex === slides.length - 1) {
      $scope.pause();
      return;
    }

    return self.select(slides[newIndex], 'prev');
  };

  self.removeSlide = function(slide) {
    var index = findSlideIndex(slide);

    //get the index of the slide inside the carousel
    slides.splice(index, 1);
    if (slides.length > 0 && currentIndex === index) {
      if (index >= slides.length) {
        currentIndex = slides.length - 1;
        $scope.active = currentIndex;
        setActive(currentIndex);
        self.select(slides[slides.length - 1]);
      } else {
        currentIndex = index;
        $scope.active = currentIndex;
        setActive(currentIndex);
        self.select(slides[index]);
      }
    } else if (currentIndex > index) {
      currentIndex--;
      $scope.active = currentIndex;
    }

    //clean the active value when no more slide
    if (slides.length === 0) {
      currentIndex = null;
      $scope.active = null;
    }
  };

  /* direction: "prev" or "next" */
  self.select = $scope.select = function(nextSlide, direction) {
    var nextIndex = findSlideIndex(nextSlide.slide);
    //Decide direction if it's not given
    if (direction === undefined) {
      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
    }
    //Prevent this user-triggered transition from occurring if there is already one in progress
    if (nextSlide.slide.index !== currentIndex &&
      !$scope.$currentTransition) {
      goNext(nextSlide.slide, nextIndex, direction);
    }
  };

  /* Allow outside people to call indexOf on slides array */
  $scope.indexOfSlide = function(slide) {
    return +slide.slide.index;
  };

  $scope.isActive = function(slide) {
    return $scope.active === slide.slide.index;
  };

  $scope.isPrevDisabled = function() {
    return $scope.active === 0 && $scope.noWrap();
  };

  $scope.isNextDisabled = function() {
    return $scope.active === slides.length - 1 && $scope.noWrap();
  };

  $scope.pause = function() {
    if (!$scope.noPause) {
      isPlaying = false;
      resetTimer();
    }
  };

  $scope.play = function() {
    if (!isPlaying) {
      isPlaying = true;
      restartTimer();
    }
  };

  $element.on('mouseenter', $scope.pause);
  $element.on('mouseleave', $scope.play);

  $scope.$on('$destroy', function() {
    destroyed = true;
    resetTimer();
  });

  $scope.$watch('noTransition', function(noTransition) {
    $animate.enabled($element, !noTransition);
  });

  $scope.$watch('interval', restartTimer);

  $scope.$watchCollection('slides', resetTransition);

  $scope.$watch('active', function(index) {
    if (angular.isNumber(index) && currentIndex !== index) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].slide.index === index) {
          index = i;
          break;
        }
      }

      var slide = slides[index];
      if (slide) {
        setActive(index);
        self.select(slides[index]);
        currentIndex = index;
      }
    }
  });

  function getSlideByIndex(index) {
    for (var i = 0, l = slides.length; i < l; ++i) {
      if (slides[i].index === index) {
        return slides[i];
      }
    }
  }

  function setActive(index) {
    for (var i = 0; i < slides.length; i++) {
      slides[i].slide.active = i === index;
    }
  }

  function goNext(slide, index, direction) {
    if (destroyed) {
      return;
    }

    angular.extend(slide, {direction: direction});
    angular.extend(slides[currentIndex].slide || {}, {direction: direction});
    if ($animate.enabled($element) && !$scope.$currentTransition &&
      slides[index].element && self.slides.length > 1) {
      slides[index].element.data(SLIDE_DIRECTION, slide.direction);
      var currentIdx = self.getCurrentIndex();

      if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
        slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
      }

      $scope.$currentTransition = true;
      $animate.on('addClass', slides[index].element, function(element, phase) {
        if (phase === 'close') {
          $scope.$currentTransition = null;
          $animate.off('addClass', element);
        }
      });
    }

    $scope.active = slide.index;
    currentIndex = slide.index;
    setActive(index);

    //every time you change slides, reset the timer
    restartTimer();
  }

  function findSlideIndex(slide) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].slide === slide) {
        return i;
      }
    }
  }

  function resetTimer() {
    if (currentInterval) {
      $interval.cancel(currentInterval);
      currentInterval = null;
    }
  }

  function resetTransition(slides) {
    if (!slides.length) {
      $scope.$currentTransition = null;
    }
  }

  function restartTimer() {
    resetTimer();
    var interval = +$scope.interval;
    if (!isNaN(interval) && interval > 0) {
      currentInterval = $interval(timerFn, interval);
    }
  }

  function timerFn() {
    var interval = +$scope.interval;
    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
      $scope.next();
    } else {
      $scope.pause();
    }
  }
}])

.directive('uibCarousel', function() {
  return {
    transclude: true,
    controller: 'UibCarouselController',
    controllerAs: 'carousel',
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/carousel.html';
    },
    scope: {
      active: '=',
      interval: '=',
      noTransition: '=',
      noPause: '=',
      noWrap: '&'
    }
  };
})

.directive('uibSlide', ['$animate', function($animate) {
  return {
    require: '^uibCarousel',
    restrict: 'A',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/slide.html';
    },
    scope: {
      actual: '=?',
      index: '=?'
    },
    link: function (scope, element, attrs, carouselCtrl) {
      element.addClass('item');
      carouselCtrl.addSlide(scope, element);
      //when the scope is destroyed then remove the slide from the current slides array
      scope.$on('$destroy', function() {
        carouselCtrl.removeSlide(scope);
      });

      scope.$watch('active', function(active) {
        $animate[active ? 'addClass' : 'removeClass'](element, 'active');
      });
    }
  };
}])

.animation('.item', ['$animateCss',
function($animateCss) {
  var SLIDE_DIRECTION = 'uib-slideDirection';

  function removeClass(element, className, callback) {
    element.removeClass(className);
    if (callback) {
      callback();
    }
  }

  return {
    beforeAddClass: function(element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element,
          directionClass + ' ' + direction, done);
        element.addClass(direction);

        $animateCss(element, {addClass: directionClass})
          .start()
          .done(removeClassFn);

        return function() {
          stopped = true;
        };
      }
      done();
    },
    beforeRemoveClass: function (element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element, directionClass, done);

        $animateCss(element, {addClass: directionClass})
          .start()
          .done(removeClassFn);

        return function() {
          stopped = true;
        };
      }
      done();
    }
  };
}]);

angular.module('ui.bootstrap.dateparser', [])

.service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', 'filterFilter', function($log, $locale, dateFilter, orderByFilter, filterFilter) {
  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

  var localeId;
  var formatCodeToRegex;

  this.init = function() {
    localeId = $locale.id;

    this.parsers = {};
    this.formatters = {};

    formatCodeToRegex = [
      {
        key: 'yyyy',
        regex: '\\d{4}',
        apply: function(value) { this.year = +value; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'yyyy');
        }
      },
      {
        key: 'yy',
        regex: '\\d{2}',
        apply: function(value) { value = +value; this.year = value < 69 ? value + 2000 : value + 1900; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'yy');
        }
      },
      {
        key: 'y',
        regex: '\\d{1,4}',
        apply: function(value) { this.year = +value; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'y');
        }
      },
      {
        key: 'M!',
        regex: '0?[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) {
          var value = date.getMonth();
          if (/^[0-9]$/.test(value)) {
            return dateFilter(date, 'MM');
          }

          return dateFilter(date, 'M');
        }
      },
      {
        key: 'MMMM',
        regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'MMMM'); }
      },
      {
        key: 'MMM',
        regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'MMM'); }
      },
      {
        key: 'MM',
        regex: '0[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) { return dateFilter(date, 'MM'); }
      },
      {
        key: 'M',
        regex: '[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) { return dateFilter(date, 'M'); }
      },
      {
        key: 'd!',
        regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) {
          var value = date.getDate();
          if (/^[1-9]$/.test(value)) {
            return dateFilter(date, 'dd');
          }

          return dateFilter(date, 'd');
        }
      },
      {
        key: 'dd',
        regex: '[0-2][0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) { return dateFilter(date, 'dd'); }
      },
      {
        key: 'd',
        regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) { return dateFilter(date, 'd'); }
      },
      {
        key: 'EEEE',
        regex: $locale.DATETIME_FORMATS.DAY.join('|'),
        formatter: function(date) { return dateFilter(date, 'EEEE'); }
      },
      {
        key: 'EEE',
        regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
        formatter: function(date) { return dateFilter(date, 'EEE'); }
      },
      {
        key: 'HH',
        regex: '(?:0|1)[0-9]|2[0-3]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'HH'); }
      },
      {
        key: 'hh',
        regex: '0[0-9]|1[0-2]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'hh'); }
      },
      {
        key: 'H',
        regex: '1?[0-9]|2[0-3]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'H'); }
      },
      {
        key: 'h',
        regex: '[0-9]|1[0-2]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'h'); }
      },
      {
        key: 'mm',
        regex: '[0-5][0-9]',
        apply: function(value) { this.minutes = +value; },
        formatter: function(date) { return dateFilter(date, 'mm'); }
      },
      {
        key: 'm',
        regex: '[0-9]|[1-5][0-9]',
        apply: function(value) { this.minutes = +value; },
        formatter: function(date) { return dateFilter(date, 'm'); }
      },
      {
        key: 'sss',
        regex: '[0-9][0-9][0-9]',
        apply: function(value) { this.milliseconds = +value; },
        formatter: function(date) { return dateFilter(date, 'sss'); }
      },
      {
        key: 'ss',
        regex: '[0-5][0-9]',
        apply: function(value) { this.seconds = +value; },
        formatter: function(date) { return dateFilter(date, 'ss'); }
      },
      {
        key: 's',
        regex: '[0-9]|[1-5][0-9]',
        apply: function(value) { this.seconds = +value; },
        formatter: function(date) { return dateFilter(date, 's'); }
      },
      {
        key: 'a',
        regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
        apply: function(value) {
          if (this.hours === 12) {
            this.hours = 0;
          }

          if (value === 'PM') {
            this.hours += 12;
          }
        },
        formatter: function(date) { return dateFilter(date, 'a'); }
      },
      {
        key: 'Z',
        regex: '[+-]\\d{4}',
        apply: function(value) {
          var matches = value.match(/([+-])(\d{2})(\d{2})/),
            sign = matches[1],
            hours = matches[2],
            minutes = matches[3];
          this.hours += toInt(sign + hours);
          this.minutes += toInt(sign + minutes);
        },
        formatter: function(date) {
          return dateFilter(date, 'Z');
        }
      },
      {
        key: 'ww',
        regex: '[0-4][0-9]|5[0-3]',
        formatter: function(date) { return dateFilter(date, 'ww'); }
      },
      {
        key: 'w',
        regex: '[0-9]|[1-4][0-9]|5[0-3]',
        formatter: function(date) { return dateFilter(date, 'w'); }
      },
      {
        key: 'GGGG',
        regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
        formatter: function(date) { return dateFilter(date, 'GGGG'); }
      },
      {
        key: 'GGG',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'GGG'); }
      },
      {
        key: 'GG',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'GG'); }
      },
      {
        key: 'G',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'G'); }
      }
    ];

    if (angular.version.major >= 1 && angular.version.minor > 4) {
      formatCodeToRegex.push({
        key: 'LLLL',
        regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'LLLL'); }
      });
    }
  };

  this.init();

  function getFormatCodeToRegex(key) {
    return filterFilter(formatCodeToRegex, {key: key}, true)[0];
  }

  this.getParser = function (key) {
    var f = getFormatCodeToRegex(key);
    return f && f.apply || null;
  };

  this.overrideParser = function (key, parser) {
    var f = getFormatCodeToRegex(key);
    if (f && angular.isFunction(parser)) {
      this.parsers = {};
      f.apply = parser;
    }
  }.bind(this);

  function createParser(format) {
    var map = [], regex = format.split('');

    // check for literal values
    var quoteIndex = format.indexOf('\'');
    if (quoteIndex > -1) {
      var inLiteral = false;
      format = format.split('');
      for (var i = quoteIndex; i < format.length; i++) {
        if (inLiteral) {
          if (format[i] === '\'') {
            if (i + 1 < format.length && format[i+1] === '\'') { // escaped single quote
              format[i+1] = '$';
              regex[i+1] = '';
            } else { // end of literal
              regex[i] = '';
              inLiteral = false;
            }
          }
          format[i] = '$';
        } else {
          if (format[i] === '\'') { // start of literal
            format[i] = '$';
            regex[i] = '';
            inLiteral = true;
          }
        }
      }

      format = format.join('');
    }

    angular.forEach(formatCodeToRegex, function(data) {
      var index = format.indexOf(data.key);

      if (index > -1) {
        format = format.split('');

        regex[index] = '(' + data.regex + ')';
        format[index] = '$'; // Custom symbol to define consumed part of format
        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
          regex[i] = '';
          format[i] = '$';
        }
        format = format.join('');

        map.push({
          index: index,
          key: data.key,
          apply: data.apply,
          matcher: data.regex
        });
      }
    });

    return {
      regex: new RegExp('^' + regex.join('') + '$'),
      map: orderByFilter(map, 'index')
    };
  }

  function createFormatter(format) {
    var formatters = [];
    var i = 0;
    var formatter, literalIdx;
    while (i < format.length) {
      if (angular.isNumber(literalIdx)) {
        if (format.charAt(i) === '\'') {
          if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
            formatters.push(constructLiteralFormatter(format, literalIdx, i));
            literalIdx = null;
          }
        } else if (i === format.length) {
          while (literalIdx < format.length) {
            formatter = constructFormatterFromIdx(format, literalIdx);
            formatters.push(formatter);
            literalIdx = formatter.endIdx;
          }
        }

        i++;
        continue;
      }

      if (format.charAt(i) === '\'') {
        literalIdx = i;
        i++;
        continue;
      }

      formatter = constructFormatterFromIdx(format, i);

      formatters.push(formatter.parser);
      i = formatter.endIdx;
    }

    return formatters;
  }

  function constructLiteralFormatter(format, literalIdx, endIdx) {
    return function() {
      return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
    };
  }

  function constructFormatterFromIdx(format, i) {
    var currentPosStr = format.substr(i);
    for (var j = 0; j < formatCodeToRegex.length; j++) {
      if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
        var data = formatCodeToRegex[j];
        return {
          endIdx: i + data.key.length,
          parser: data.formatter
        };
      }
    }

    return {
      endIdx: i + 1,
      parser: function() {
        return currentPosStr.charAt(0);
      }
    };
  }

  this.filter = function(date, format) {
    if (!angular.isDate(date) || isNaN(date) || !format) {
      return '';
    }

    format = $locale.DATETIME_FORMATS[format] || format;

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.formatters[format]) {
      this.formatters[format] = createFormatter(format);
    }

    var formatters = this.formatters[format];

    return formatters.reduce(function(str, formatter) {
      return str + formatter(date);
    }, '');
  };

  this.parse = function(input, format, baseDate) {
    if (!angular.isString(input) || !format) {
      return input;
    }

    format = $locale.DATETIME_FORMATS[format] || format;
    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.parsers[format]) {
      this.parsers[format] = createParser(format, 'apply');
    }

    var parser = this.parsers[format],
        regex = parser.regex,
        map = parser.map,
        results = input.match(regex),
        tzOffset = false;
    if (results && results.length) {
      var fields, dt;
      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
        fields = {
          year: baseDate.getFullYear(),
          month: baseDate.getMonth(),
          date: baseDate.getDate(),
          hours: baseDate.getHours(),
          minutes: baseDate.getMinutes(),
          seconds: baseDate.getSeconds(),
          milliseconds: baseDate.getMilliseconds()
        };
      } else {
        if (baseDate) {
          $log.warn('dateparser:', 'baseDate is not a valid date');
        }
        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
      }

      for (var i = 1, n = results.length; i < n; i++) {
        var mapper = map[i - 1];
        if (mapper.matcher === 'Z') {
          tzOffset = true;
        }

        if (mapper.apply) {
          mapper.apply.call(fields, results[i]);
        }
      }

      var datesetter = tzOffset ? Date.prototype.setUTCFullYear :
        Date.prototype.setFullYear;
      var timesetter = tzOffset ? Date.prototype.setUTCHours :
        Date.prototype.setHours;

      if (isValid(fields.year, fields.month, fields.date)) {
        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
          dt = new Date(baseDate);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours, fields.minutes,
            fields.seconds, fields.milliseconds);
        } else {
          dt = new Date(0);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours || 0, fields.minutes || 0,
            fields.seconds || 0, fields.milliseconds || 0);
        }
      }

      return dt;
    }
  };

  // Check if date is valid for specific month (and year for February).
  // Month: 0 = Jan, 1 = Feb, etc
  function isValid(year, month, date) {
    if (date < 1) {
      return false;
    }

    if (month === 1 && date > 28) {
      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
    }

    if (month === 3 || month === 5 || month === 8 || month === 10) {
      return date < 31;
    }

    return true;
  }

  function toInt(str) {
    return parseInt(str, 10);
  }

  this.toTimezone = toTimezone;
  this.fromTimezone = fromTimezone;
  this.timezoneToOffset = timezoneToOffset;
  this.addDateMinutes = addDateMinutes;
  this.convertTimezoneToLocal = convertTimezoneToLocal;

  function toTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
  }

  function fromTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
  }

  //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
  function timezoneToOffset(timezone, fallback) {
    timezone = timezone.replace(/:/g, '');
    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
  }

  function addDateMinutes(date, minutes) {
    date = new Date(date.getTime());
    date.setMinutes(date.getMinutes() + minutes);
    return date;
  }

  function convertTimezoneToLocal(date, timezone, reverse) {
    reverse = reverse ? -1 : 1;
    var dateTimezoneOffset = date.getTimezoneOffset();
    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
  }
}]);

// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
// at most one element.
angular.module('ui.bootstrap.isClass', [])
.directive('uibIsClass', [
         '$animate',
function ($animate) {
  //                    11111111          22222222
  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
  //                    11111111           22222222
  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;

  var dataPerTracked = {};

  return {
    restrict: 'A',
    compile: function(tElement, tAttrs) {
      var linkedScopes = [];
      var instances = [];
      var expToData = {};
      var lastActivated = null;
      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
      var onExp = onExpMatches[2];
      var expsStr = onExpMatches[1];
      var exps = expsStr.split(',');

      return linkFn;

      function linkFn(scope, element, attrs) {
        linkedScopes.push(scope);
        instances.push({
          scope: scope,
          element: element
        });

        exps.forEach(function(exp, k) {
          addForExp(exp, scope);
        });

        scope.$on('$destroy', removeScope);
      }

      function addForExp(exp, scope) {
        var matches = exp.match(IS_REGEXP);
        var clazz = scope.$eval(matches[1]);
        var compareWithExp = matches[2];
        var data = expToData[exp];
        if (!data) {
          var watchFn = function(compareWithVal) {
            var newActivated = null;
            instances.some(function(instance) {
              var thisVal = instance.scope.$eval(onExp);
              if (thisVal === compareWithVal) {
                newActivated = instance;
                return true;
              }
            });
            if (data.lastActivated !== newActivated) {
              if (data.lastActivated) {
                $animate.removeClass(data.lastActivated.element, clazz);
              }
              if (newActivated) {
                $animate.addClass(newActivated.element, clazz);
              }
              data.lastActivated = newActivated;
            }
          };
          expToData[exp] = data = {
            lastActivated: null,
            scope: scope,
            watchFn: watchFn,
            compareWithExp: compareWithExp,
            watcher: scope.$watch(compareWithExp, watchFn)
          };
        }
        data.watchFn(scope.$eval(compareWithExp));
      }

      function removeScope(e) {
        var removedScope = e.targetScope;
        var index = linkedScopes.indexOf(removedScope);
        linkedScopes.splice(index, 1);
        instances.splice(index, 1);
        if (linkedScopes.length) {
          var newWatchScope = linkedScopes[0];
          angular.forEach(expToData, function(data) {
            if (data.scope === removedScope) {
              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
              data.scope = newWatchScope;
            }
          });
        } else {
          expToData = {};
        }
      }
    }
  };
}]);
angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass'])

.value('$datepickerSuppressError', false)

.value('$datepickerLiteralWarning', true)

.constant('uibDatepickerConfig', {
  datepickerMode: 'day',
  formatDay: 'dd',
  formatMonth: 'MMMM',
  formatYear: 'yyyy',
  formatDayHeader: 'EEE',
  formatDayTitle: 'MMMM yyyy',
  formatMonthTitle: 'yyyy',
  maxDate: null,
  maxMode: 'year',
  minDate: null,
  minMode: 'day',
  monthColumns: 3,
  ngModelOptions: {},
  shortcutPropagation: false,
  showWeeks: true,
  yearColumns: 5,
  yearRows: 4
})

.controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser',
  function($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
  var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl;
      ngModelOptions = {},
      watchListeners = [];

  $element.addClass('uib-datepicker');
  $attrs.$set('role', 'application');

  if (!$scope.datepickerOptions) {
    $scope.datepickerOptions = {};
  }

  // Modes chain
  this.modes = ['day', 'month', 'year'];

  [
    'customClass',
    'dateDisabled',
    'datepickerMode',
    'formatDay',
    'formatDayHeader',
    'formatDayTitle',
    'formatMonth',
    'formatMonthTitle',
    'formatYear',
    'maxDate',
    'maxMode',
    'minDate',
    'minMode',
    'monthColumns',
    'showWeeks',
    'shortcutPropagation',
    'startingDay',
    'yearColumns',
    'yearRows'
  ].forEach(function(key) {
    switch (key) {
      case 'customClass':
      case 'dateDisabled':
        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
        break;
      case 'datepickerMode':
        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ?
          $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
        break;
      case 'formatDay':
      case 'formatDayHeader':
      case 'formatDayTitle':
      case 'formatMonth':
      case 'formatMonthTitle':
      case 'formatYear':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
          $interpolate($scope.datepickerOptions[key])($scope.$parent) :
          datepickerConfig[key];
        break;
      case 'monthColumns':
      case 'showWeeks':
      case 'shortcutPropagation':
      case 'yearColumns':
      case 'yearRows':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
          $scope.datepickerOptions[key] : datepickerConfig[key];
        break;
      case 'startingDay':
        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
          self.startingDay = $scope.datepickerOptions.startingDay;
        } else if (angular.isNumber(datepickerConfig.startingDay)) {
          self.startingDay = datepickerConfig.startingDay;
        } else {
          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
        }

        break;
      case 'maxDate':
      case 'minDate':
        $scope.$watch('datepickerOptions.' + key, function(value) {
          if (value) {
            if (angular.isDate(value)) {
              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.getOption('timezone'));
            } else {
              if ($datepickerLiteralWarning) {
                $log.warn('Literal date support has been deprecated, please switch to date object usage');
              }

              self[key] = new Date(dateFilter(value, 'medium'));
            }
          } else {
            self[key] = datepickerConfig[key] ?
              dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.getOption('timezone')) :
              null;
          }

          self.refreshView();
        });

        break;
      case 'maxMode':
      case 'minMode':
        if ($scope.datepickerOptions[key]) {
          $scope.$watch(function() { return $scope.datepickerOptions[key]; }, function(value) {
            self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
            if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) ||
              key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
              $scope.datepickerMode = self[key];
              $scope.datepickerOptions.datepickerMode = self[key];
            }
          });
        } else {
          self[key] = $scope[key] = datepickerConfig[key] || null;
        }

        break;
    }
  });

  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if (angular.isDefined($attrs.ngDisabled)) {
    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function(disabled) {
      $scope.disabled = disabled;
      self.refreshView();
    }));
  }

  $scope.isActive = function(dateObject) {
    if (self.compare(dateObject.date, self.activeDate) === 0) {
      $scope.activeDateId = dateObject.uid;
      return true;
    }
    return false;
  };

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelOptions = extractOptions(ngModelCtrl);

    if ($scope.datepickerOptions.initDate) {
      self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.getOption('timezone')) || new Date();
      $scope.$watch('datepickerOptions.initDate', function(initDate) {
        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.getOption('timezone'));
          self.refreshView();
        }
      });
    } else {
      self.activeDate = new Date();
    }

    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
    this.activeDate = !isNaN(date) ?
      dateParser.fromTimezone(date, ngModelOptions.getOption('timezone')) :
      dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));

    ngModelCtrl.$render = function() {
      self.render();
    };
  };

  this.render = function() {
    if (ngModelCtrl.$viewValue) {
      var date = new Date(ngModelCtrl.$viewValue),
          isValid = !isNaN(date);

      if (isValid) {
        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
      } else if (!$datepickerSuppressError) {
        $log.error('Datepicker directive: "ng-model" value must be a Date object');
      }
    }
    this.refreshView();
  };

  this.refreshView = function() {
    if (this.element) {
      $scope.selectedDt = null;
      this._refreshView();
      if ($scope.activeDt) {
        $scope.activeDateId = $scope.activeDt.uid;
      }

      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
      date = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
      ngModelCtrl.$setValidity('dateDisabled', !date ||
        this.element && !this.isDisabled(date));
    }
  };

  this.createDateObject = function(date, format) {
    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
    model = dateParser.fromTimezone(model, ngModelOptions.getOption('timezone'));
    var today = new Date();
    today = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
    var time = this.compare(date, today);
    var dt = {
      date: date,
      label: dateParser.filter(date, format),
      selected: model && this.compare(date, model) === 0,
      disabled: this.isDisabled(date),
      past: time < 0,
      current: time === 0,
      future: time > 0,
      customClass: this.customClass(date) || null
    };

    if (model && this.compare(date, model) === 0) {
      $scope.selectedDt = dt;
    }

    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
      $scope.activeDt = dt;
    }

    return dt;
  };

  this.isDisabled = function(date) {
    return $scope.disabled ||
      this.minDate && this.compare(date, this.minDate) < 0 ||
      this.maxDate && this.compare(date, this.maxDate) > 0 ||
      $scope.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode});
  };

  this.customClass = function(date) {
    return $scope.customClass({date: date, mode: $scope.datepickerMode});
  };

  // Split array into smaller arrays
  this.split = function(arr, size) {
    var arrays = [];
    while (arr.length > 0) {
      arrays.push(arr.splice(0, size));
    }
    return arrays;
  };

  $scope.select = function(date) {
    if ($scope.datepickerMode === self.minMode) {
      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.getOption('timezone')) : new Date(0, 0, 0, 0, 0, 0, 0);
      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
      dt = dateParser.toTimezone(dt, ngModelOptions.getOption('timezone'));
      ngModelCtrl.$setViewValue(dt);
      ngModelCtrl.$render();
    } else {
      self.activeDate = date;
      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);

      $scope.$emit('uib:datepicker.mode');
    }

    $scope.$broadcast('uib:datepicker.focus');
  };

  $scope.move = function(direction) {
    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
    self.activeDate.setFullYear(year, month, 1);
    self.refreshView();
  };

  $scope.toggleMode = function(direction) {
    direction = direction || 1;

    if ($scope.datepickerMode === self.maxMode && direction === 1 ||
      $scope.datepickerMode === self.minMode && direction === -1) {
      return;
    }

    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);

    $scope.$emit('uib:datepicker.mode');
  };

  // Key event mapper
  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

  var focusElement = function() {
    self.element[0].focus();
  };

  // Listen for focus requests from popup directive
  $scope.$on('uib:datepicker.focus', focusElement);

  $scope.keydown = function(evt) {
    var key = $scope.keys[evt.which];

    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
      return;
    }

    evt.preventDefault();
    if (!self.shortcutPropagation) {
      evt.stopPropagation();
    }

    if (key === 'enter' || key === 'space') {
      if (self.isDisabled(self.activeDate)) {
        return; // do nothing
      }
      $scope.select(self.activeDate);
    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
      $scope.toggleMode(key === 'up' ? 1 : -1);
    } else {
      self.handleKeyDown(key, evt);
      self.refreshView();
    }
  };

  $element.on('keydown', function(evt) {
    $scope.$apply(function() {
      $scope.keydown(evt);
    });
  });

  $scope.$on('$destroy', function() {
    //Clear all watch listeners on destroy
    while (watchListeners.length) {
      watchListeners.shift()();
    }
  });

  function setMode(mode) {
    $scope.datepickerMode = mode;
    $scope.datepickerOptions.datepickerMode = mode;
  }

  function extractOptions(ngModelCtrl) {
    var ngModelOptions;

    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
      // guarantee a value
      ngModelOptions = ngModelCtrl.$options ||
        $scope.datepickerOptions.ngModelOptions ||
        datepickerConfig.ngModelOptions ||
        {};

      // mimic 1.6+ api
      ngModelOptions.getOption = function (key) {
        return ngModelOptions[key];
      };
    } else { // in angular >=1.6 $options is always present
      // ng-model-options defaults timezone to null; don't let its precedence squash a non-null value
      var timezone = ngModelCtrl.$options.getOption('timezone') ||
        ($scope.datepickerOptions.ngModelOptions ? $scope.datepickerOptions.ngModelOptions.timezone : null) ||
        (datepickerConfig.ngModelOptions ? datepickerConfig.ngModelOptions.timezone : null);

      // values passed to createChild override existing values
      ngModelOptions = ngModelCtrl.$options // start with a ModelOptions instance
        .createChild(datepickerConfig.ngModelOptions) // lowest precedence
        .createChild($scope.datepickerOptions.ngModelOptions)
        .createChild(ngModelCtrl.$options) // highest precedence
        .createChild({timezone: timezone}); // to keep from squashing a non-null value
    }

    return ngModelOptions;
  }
}])

.controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  this.step = { months: 1 };
  this.element = $element;
  function getDaysInMonth(year, month) {
    return month === 1 && year % 4 === 0 &&
      (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
  }

  this.init = function(ctrl) {
    angular.extend(ctrl, this);
    scope.showWeeks = ctrl.showWeeks;
    ctrl.refreshView();
  };

  this.getDates = function(startDate, n) {
    var dates = new Array(n), current = new Date(startDate), i = 0, date;
    while (i < n) {
      date = new Date(current);
      dates[i++] = date;
      current.setDate(current.getDate() + 1);
    }
    return dates;
  };

  this._refreshView = function() {
    var year = this.activeDate.getFullYear(),
      month = this.activeDate.getMonth(),
      firstDayOfMonth = new Date(this.activeDate);

    firstDayOfMonth.setFullYear(year, month, 1);

    var difference = this.startingDay - firstDayOfMonth.getDay(),
      numDisplayedFromPreviousMonth = difference > 0 ?
        7 - difference : - difference,
      firstDate = new Date(firstDayOfMonth);

    if (numDisplayedFromPreviousMonth > 0) {
      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
    }

    // 42 is the number of days on a six-week calendar
    var days = this.getDates(firstDate, 42);
    for (var i = 0; i < 42; i ++) {
      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
        secondary: days[i].getMonth() !== month,
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.labels = new Array(7);
    for (var j = 0; j < 7; j++) {
      scope.labels[j] = {
        abbr: dateFilter(days[j].date, this.formatDayHeader),
        full: dateFilter(days[j].date, 'EEEE')
      };
    }

    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
    scope.rows = this.split(days, 7);

    if (scope.showWeeks) {
      scope.weekNumbers = [];
      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
          numWeeks = scope.rows.length;
      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
        scope.weekNumbers.push(
          getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
      }
    }
  };

  this.compare = function(date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  function getISO8601WeekNumber(date) {
    var checkDate = new Date(date);
    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
    var time = checkDate.getTime();
    checkDate.setMonth(0); // Compare with Jan 1
    checkDate.setDate(1);
    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
  }

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getDate();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - 7;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + 7;
    } else if (key === 'pageup' || key === 'pagedown') {
      var month = this.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
      this.activeDate.setMonth(month, 1);
      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
    } else if (key === 'home') {
      date = 1;
    } else if (key === 'end') {
      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
    }
    this.activeDate.setDate(date);
  };
}])

.controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  this.step = { years: 1 };
  this.element = $element;

  this.init = function(ctrl) {
    angular.extend(ctrl, this);
    ctrl.refreshView();
  };

  this._refreshView = function() {
    var months = new Array(12),
        year = this.activeDate.getFullYear(),
        date;

    for (var i = 0; i < 12; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(year, i, 1);
      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
    scope.rows = this.split(months, this.monthColumns);
    scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
  };

  this.compare = function(date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getMonth();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - this.monthColumns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + this.monthColumns;
    } else if (key === 'pageup' || key === 'pagedown') {
      var year = this.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
      this.activeDate.setFullYear(year);
    } else if (key === 'home') {
      date = 0;
    } else if (key === 'end') {
      date = 11;
    }
    this.activeDate.setMonth(date);
  };
}])

.controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  var columns, range;
  this.element = $element;

  function getStartingYear(year) {
    return parseInt((year - 1) / range, 10) * range + 1;
  }

  this.yearpickerInit = function() {
    columns = this.yearColumns;
    range = this.yearRows * columns;
    this.step = { years: range };
  };

  this._refreshView = function() {
    var years = new Array(range), date;

    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(start + i, 0, 1);
      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = [years[0].label, years[range - 1].label].join(' - ');
    scope.rows = this.split(years, columns);
    scope.columns = columns;
  };

  this.compare = function(date1, date2) {
    return date1.getFullYear() - date2.getFullYear();
  };

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getFullYear();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - columns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + columns;
    } else if (key === 'pageup' || key === 'pagedown') {
      date += (key === 'pageup' ? - 1 : 1) * range;
    } else if (key === 'home') {
      date = getStartingYear(this.activeDate.getFullYear());
    } else if (key === 'end') {
      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
    }
    this.activeDate.setFullYear(date);
  };
}])

.directive('uibDatepicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
    },
    scope: {
      datepickerOptions: '=?'
    },
    require: ['uibDatepicker', '^ngModel'],
    restrict: 'A',
    controller: 'UibDatepickerController',
    controllerAs: 'datepicker',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      datepickerCtrl.init(ngModelCtrl);
    }
  };
})

.directive('uibDaypicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/day.html';
    },
    require: ['^uibDatepicker', 'uibDaypicker'],
    restrict: 'A',
    controller: 'UibDaypickerController',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        daypickerCtrl = ctrls[1];

      daypickerCtrl.init(datepickerCtrl);
    }
  };
})

.directive('uibMonthpicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/month.html';
    },
    require: ['^uibDatepicker', 'uibMonthpicker'],
    restrict: 'A',
    controller: 'UibMonthpickerController',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        monthpickerCtrl = ctrls[1];

      monthpickerCtrl.init(datepickerCtrl);
    }
  };
})

.directive('uibYearpicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/year.html';
    },
    require: ['^uibDatepicker', 'uibYearpicker'],
    restrict: 'A',
    controller: 'UibYearpickerController',
    link: function(scope, element, attrs, ctrls) {
      var ctrl = ctrls[0];
      angular.extend(ctrl, ctrls[1]);
      ctrl.yearpickerInit();

      ctrl.refreshView();
    }
  };
});

angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods for working with the DOM.
 * It is meant to be used where we need to absolute-position elements in
 * relation to another element (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
    /**
     * Used by scrollbarWidth() function to cache scrollbar's width.
     * Do not access this variable directly, use scrollbarWidth() instead.
     */
    var SCROLLBAR_WIDTH;
    /**
     * scrollbar on body and html element in IE and Edge overlay
     * content and should be considered 0 width.
     */
    var BODY_SCROLLBAR_WIDTH;
    var OVERFLOW_REGEX = {
      normal: /(auto|scroll)/,
      hidden: /(auto|scroll|hidden)/
    };
    var PLACEMENT_REGEX = {
      auto: /\s?auto?\s?/i,
      primary: /^(top|bottom|left|right)$/,
      secondary: /^(top|bottom|left|right|center)$/,
      vertical: /^(top|bottom)$/
    };
    var BODY_REGEX = /(HTML|BODY)/;

    return {

      /**
       * Provides a raw DOM element from a jQuery/jQLite element.
       *
       * @param {element} elem - The element to convert.
       *
       * @returns {element} A HTML element.
       */
      getRawNode: function(elem) {
        return elem.nodeName ? elem : elem[0] || elem;
      },

      /**
       * Provides a parsed number for a style property.  Strips
       * units and casts invalid numbers to 0.
       *
       * @param {string} value - The style value to parse.
       *
       * @returns {number} A valid number.
       */
      parseStyle: function(value) {
        value = parseFloat(value);
        return isFinite(value) ? value : 0;
      },

      /**
       * Provides the closest positioned ancestor.
       *
       * @param {element} element - The element to get the offest parent for.
       *
       * @returns {element} The closest positioned ancestor.
       */
      offsetParent: function(elem) {
        elem = this.getRawNode(elem);

        var offsetParent = elem.offsetParent || $document[0].documentElement;

        function isStaticPositioned(el) {
          return ($window.getComputedStyle(el).position || 'static') === 'static';
        }

        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
          offsetParent = offsetParent.offsetParent;
        }

        return offsetParent || $document[0].documentElement;
      },

      /**
       * Provides the scrollbar width, concept from TWBS measureScrollbar()
       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
       * In IE and Edge, scollbar on body and html element overlay and should
       * return a width of 0.
       *
       * @returns {number} The width of the browser scollbar.
       */
      scrollbarWidth: function(isBody) {
        if (isBody) {
          if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
            var bodyElem = $document.find('body');
            bodyElem.addClass('uib-position-body-scrollbar-measure');
            BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
            BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
            bodyElem.removeClass('uib-position-body-scrollbar-measure');
          }
          return BODY_SCROLLBAR_WIDTH;
        }

        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
          $document.find('body').append(scrollElem);
          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
          scrollElem.remove();
        }

        return SCROLLBAR_WIDTH;
      },

      /**
       * Provides the padding required on an element to replace the scrollbar.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**scrollbarWidth**: the width of the scrollbar</li>
       *     <li>**widthOverflow**: whether the the width is overflowing</li>
       *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
       *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
       *     <li>**heightOverflow**: whether the the height is overflowing</li>
       *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
       *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
       *   </ul>
       */
      scrollbarPadding: function(elem) {
        elem = this.getRawNode(elem);

        var elemStyle = $window.getComputedStyle(elem);
        var paddingRight = this.parseStyle(elemStyle.paddingRight);
        var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
        var scrollParent = this.scrollParent(elem, false, true);
        var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));

        return {
          scrollbarWidth: scrollbarWidth,
          widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
          right: paddingRight + scrollbarWidth,
          originalRight: paddingRight,
          heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
          bottom: paddingBottom + scrollbarWidth,
          originalBottom: paddingBottom
         };
      },

      /**
       * Checks to see if the element is scrollable.
       *
       * @param {element} elem - The element to check.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       *
       * @returns {boolean} Whether the element is scrollable.
       */
      isScrollable: function(elem, includeHidden) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var elemStyle = $window.getComputedStyle(elem);
        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
      },

      /**
       * Provides the closest scrollable ancestor.
       * A port of the jQuery UI scrollParent method:
       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
       *
       * @param {element} elem - The element to find the scroll parent of.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       * @param {boolean=} [includeSelf=false] - Should the element being passed be
       * included in the scrollable llokup.
       *
       * @returns {element} A HTML element.
       */
      scrollParent: function(elem, includeHidden, includeSelf) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var documentEl = $document[0].documentElement;
        var elemStyle = $window.getComputedStyle(elem);
        if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
          return elem;
        }
        var excludeStatic = elemStyle.position === 'absolute';
        var scrollParent = elem.parentElement || documentEl;

        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
          return documentEl;
        }

        while (scrollParent.parentElement && scrollParent !== documentEl) {
          var spStyle = $window.getComputedStyle(scrollParent);
          if (excludeStatic && spStyle.position !== 'static') {
            excludeStatic = false;
          }

          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
            break;
          }
          scrollParent = scrollParent.parentElement;
        }

        return scrollParent;
      },

      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/ - distance to closest positioned
       * ancestor.  Does not account for margins by default like jQuery position.
       *
       * @param {element} elem - The element to caclulate the position on.
       * @param {boolean=} [includeMargins=false] - Should margins be accounted
       * for, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of offset parent</li>
       *     <li>**left**: distance to left edge of offset parent</li>
       *   </ul>
       */
      position: function(elem, includeMagins) {
        elem = this.getRawNode(elem);

        var elemOffset = this.offset(elem);
        if (includeMagins) {
          var elemStyle = $window.getComputedStyle(elem);
          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
        }
        var parent = this.offsetParent(elem);
        var parentOffset = {top: 0, left: 0};

        if (parent !== $document[0].documentElement) {
          parentOffset = this.offset(parent);
          parentOffset.top += parent.clientTop - parent.scrollTop;
          parentOffset.left += parent.clientLeft - parent.scrollLeft;
        }

        return {
          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
          top: Math.round(elemOffset.top - parentOffset.top),
          left: Math.round(elemOffset.left - parentOffset.left)
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/ - distance to viewport.  Does
       * not account for borders, margins, or padding on the body
       * element.
       *
       * @param {element} elem - The element to calculate the offset on.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of viewport</li>
       *     <li>**right**: distance to bottom edge of viewport</li>
       *   </ul>
       */
      offset: function(elem) {
        elem = this.getRawNode(elem);

        var elemBCR = elem.getBoundingClientRect();
        return {
          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
        };
      },

      /**
       * Provides offset distance to the closest scrollable ancestor
       * or viewport.  Accounts for border and scrollbar width.
       *
       * Right and bottom dimensions represent the distance to the
       * respective edge of the viewport element.  If the element
       * edge extends beyond the viewport, a negative value will be
       * reported.
       *
       * @param {element} elem - The element to get the viewport offset for.
       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
       * of the first scrollable element, default is false.
       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
       * be accounted for, default is true.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: distance to the top content edge of viewport element</li>
       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
       *     <li>**left**: distance to the left content edge of viewport element</li>
       *     <li>**right**: distance to the right content edge of viewport element</li>
       *   </ul>
       */
      viewportOffset: function(elem, useDocument, includePadding) {
        elem = this.getRawNode(elem);
        includePadding = includePadding !== false ? true : false;

        var elemBCR = elem.getBoundingClientRect();
        var offsetBCR = {top: 0, left: 0, bottom: 0, right: 0};

        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
        var offsetParentBCR = offsetParent.getBoundingClientRect();

        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
        if (offsetParent === $document[0].documentElement) {
          offsetBCR.top += $window.pageYOffset;
          offsetBCR.left += $window.pageXOffset;
        }
        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;

        if (includePadding) {
          var offsetParentStyle = $window.getComputedStyle(offsetParent);
          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
        }

        return {
          top: Math.round(elemBCR.top - offsetBCR.top),
          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
          left: Math.round(elemBCR.left - offsetBCR.left),
          right: Math.round(offsetBCR.right - elemBCR.right)
        };
      },

      /**
       * Provides an array of placement values parsed from a placement string.
       * Along with the 'auto' indicator, supported placement strings are:
       *   <ul>
       *     <li>top: element on top, horizontally centered on host element.</li>
       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
       *     <li>left: element on left, vertically centered on host element.</li>
       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
       *     <li>right: element on right, vertically centered on host element.</li>
       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
       *   </ul>
       * A placement string with an 'auto' indicator is expected to be
       * space separated from the placement, i.e: 'auto bottom-left'  If
       * the primary and secondary placement values do not match 'top,
       * bottom, left, right' then 'top' will be the primary placement and
       * 'center' will be the secondary placement.  If 'auto' is passed, true
       * will be returned as the 3rd value of the array.
       *
       * @param {string} placement - The placement string to parse.
       *
       * @returns {array} An array with the following values
       * <ul>
       *   <li>**[0]**: The primary placement.</li>
       *   <li>**[1]**: The secondary placement.</li>
       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
       * </ul>
       */
      parsePlacement: function(placement) {
        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
        if (autoPlace) {
          placement = placement.replace(PLACEMENT_REGEX.auto, '');
        }

        placement = placement.split('-');

        placement[0] = placement[0] || 'top';
        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
          placement[0] = 'top';
        }

        placement[1] = placement[1] || 'center';
        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
          placement[1] = 'center';
        }

        if (autoPlace) {
          placement[2] = true;
        } else {
          placement[2] = false;
        }

        return placement;
      },

      /**
       * Provides coordinates for an element to be positioned relative to
       * another element.  Passing 'auto' as part of the placement parameter
       * will enable smart placement - where the element fits. i.e:
       * 'auto left-top' will check to see if there is enough space to the left
       * of the hostElem to fit the targetElem, if not place right (same for secondary
       * top placement).  Available space is calculated using the viewportOffset
       * function.
       *
       * @param {element} hostElem - The element to position against.
       * @param {element} targetElem - The element to position.
       * @param {string=} [placement=top] - The placement for the targetElem,
       *   default is 'top'. 'center' is assumed as secondary placement for
       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
       *   <ul>
       *     <li>top</li>
       *     <li>top-right</li>
       *     <li>top-left</li>
       *     <li>bottom</li>
       *     <li>bottom-left</li>
       *     <li>bottom-right</li>
       *     <li>left</li>
       *     <li>left-top</li>
       *     <li>left-bottom</li>
       *     <li>right</li>
       *     <li>right-top</li>
       *     <li>right-bottom</li>
       *   </ul>
       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
       *   be calculated from the body element, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: Value for targetElem top.</li>
       *     <li>**left**: Value for targetElem left.</li>
       *     <li>**placement**: The resolved placement.</li>
       *   </ul>
       */
      positionElements: function(hostElem, targetElem, placement, appendToBody) {
        hostElem = this.getRawNode(hostElem);
        targetElem = this.getRawNode(targetElem);

        // need to read from prop to support tests.
        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');

        placement = this.parsePlacement(placement);

        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
        var targetElemPos = {top: 0, left: 0, placement: ''};

        if (placement[2]) {
          var viewportOffset = this.viewportOffset(hostElem, appendToBody);

          var targetElemStyle = $window.getComputedStyle(targetElem);
          var adjustedSize = {
            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
          };

          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
                         placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
                         placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
                         placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
                         placement[0];

          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
                         placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
                         placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
                         placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
                         placement[1];

          if (placement[1] === 'center') {
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
                placement[1] = 'left';
              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
                placement[1] = 'right';
              }
            } else {
              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
                placement[1] = 'top';
              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
                placement[1] = 'bottom';
              }
            }
          }
        }

        switch (placement[0]) {
          case 'top':
            targetElemPos.top = hostElemPos.top - targetHeight;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left - targetWidth;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width;
            break;
        }

        switch (placement[1]) {
          case 'top':
            targetElemPos.top = hostElemPos.top;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
            break;
          case 'center':
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
            } else {
              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
            }
            break;
        }

        targetElemPos.top = Math.round(targetElemPos.top);
        targetElemPos.left = Math.round(targetElemPos.left);
        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];

        return targetElemPos;
      },

      /**
       * Provides a way to adjust the top positioning after first
       * render to correctly align element to top after content
       * rendering causes resized element height
       *
       * @param {array} placementClasses - The array of strings of classes
       * element should have.
       * @param {object} containerPosition - The object with container
       * position information
       * @param {number} initialHeight - The initial height for the elem.
       * @param {number} currentHeight - The current height for the elem.
       */
      adjustTop: function(placementClasses, containerPosition, initialHeight, currentHeight) {
        if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
          return {
            top: containerPosition.top - currentHeight + 'px'
          };
        }
      },

      /**
       * Provides a way for positioning tooltip & dropdown
       * arrows when using placement options beyond the standard
       * left, right, top, or bottom.
       *
       * @param {element} elem - The tooltip/dropdown element.
       * @param {string} placement - The placement for the elem.
       */
      positionArrow: function(elem, placement) {
        elem = this.getRawNode(elem);

        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
        if (!innerElem) {
          return;
        }

        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');

        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
        if (!arrowElem) {
          return;
        }

        var arrowCss = {
          top: '',
          bottom: '',
          left: '',
          right: ''
        };

        placement = this.parsePlacement(placement);
        if (placement[1] === 'center') {
          // no adjustment necessary - just reset styles
          angular.element(arrowElem).css(arrowCss);
          return;
        }

        var borderProp = 'border-' + placement[0] + '-width';
        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];

        var borderRadiusProp = 'border-';
        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
          borderRadiusProp += placement[0] + '-' + placement[1];
        } else {
          borderRadiusProp += placement[1] + '-' + placement[0];
        }
        borderRadiusProp += '-radius';
        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];

        switch (placement[0]) {
          case 'top':
            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'bottom':
            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'left':
            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'right':
            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
            break;
        }

        arrowCss[placement[1]] = borderRadius;

        angular.element(arrowElem).css(arrowCss);
      }
    };
  }]);

angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position'])

.value('$datepickerPopupLiteralWarning', true)

.constant('uibDatepickerPopupConfig', {
  altInputFormats: [],
  appendToBody: false,
  clearText: 'Clear',
  closeOnDateSelection: true,
  closeText: 'Done',
  currentText: 'Today',
  datepickerPopup: 'yyyy-MM-dd',
  datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
  html5Types: {
    date: 'yyyy-MM-dd',
    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
    'month': 'yyyy-MM'
  },
  onOpenFocus: true,
  showButtonBar: true,
  placement: 'auto bottom-left'
})

.controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning',
function($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
  var cache = {},
    isHtml5DateInput = false;
  var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
    datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl, scrollParentEl,
    ngModel, ngModelOptions, $popup, altInputFormats, watchListeners = [];

  this.init = function(_ngModel_) {
    ngModel = _ngModel_;
    ngModelOptions = extractOptions(ngModel);
    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ?
      $scope.$parent.$eval($attrs.closeOnDateSelection) :
      datepickerPopupConfig.closeOnDateSelection;
    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ?
      $scope.$parent.$eval($attrs.datepickerAppendToBody) :
      datepickerPopupConfig.appendToBody;
    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ?
      $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ?
      $attrs.datepickerPopupTemplateUrl :
      datepickerPopupConfig.datepickerPopupTemplateUrl;
    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ?
      $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
    altInputFormats = angular.isDefined($attrs.altInputFormats) ?
      $scope.$parent.$eval($attrs.altInputFormats) :
      datepickerPopupConfig.altInputFormats;

    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ?
      $scope.$parent.$eval($attrs.showButtonBar) :
      datepickerPopupConfig.showButtonBar;

    if (datepickerPopupConfig.html5Types[$attrs.type]) {
      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
      isHtml5DateInput = true;
    } else {
      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
      $attrs.$observe('uibDatepickerPopup', function(value, oldValue) {
        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
        // Invalidate the $modelValue to ensure that formatters re-run
        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
        if (newDateFormat !== dateFormat) {
          dateFormat = newDateFormat;
          ngModel.$modelValue = null;

          if (!dateFormat) {
            throw new Error('uibDatepickerPopup must have a date format specified.');
          }
        }
      });
    }

    if (!dateFormat) {
      throw new Error('uibDatepickerPopup must have a date format specified.');
    }

    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
      throw new Error('HTML5 date input types do not support custom formats.');
    }

    // popup element used to display calendar
    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');

    popupEl.attr({
      'ng-model': 'date',
      'ng-change': 'dateSelection(date)',
      'template-url': datepickerPopupTemplateUrl
    });

    // datepicker element
    datepickerEl = angular.element(popupEl.children()[0]);
    datepickerEl.attr('template-url', datepickerTemplateUrl);

    if (!$scope.datepickerOptions) {
      $scope.datepickerOptions = {};
    }

    if (isHtml5DateInput) {
      if ($attrs.type === 'month') {
        $scope.datepickerOptions.datepickerMode = 'month';
        $scope.datepickerOptions.minMode = 'month';
      }
    }

    datepickerEl.attr('datepicker-options', 'datepickerOptions');

    if (!isHtml5DateInput) {
      // Internal API to maintain the correct ng-invalid-[key] class
      ngModel.$$parserName = 'date';
      ngModel.$validators.date = validator;
      ngModel.$parsers.unshift(parseDate);
      ngModel.$formatters.push(function(value) {
        if (ngModel.$isEmpty(value)) {
          $scope.date = value;
          return value;
        }

        if (angular.isNumber(value)) {
          value = new Date(value);
        }

        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));

        return dateParser.filter($scope.date, dateFormat);
      });
    } else {
      ngModel.$formatters.push(function(value) {
        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
        return value;
      });
    }

    // Detect changes in the view from the text box
    ngModel.$viewChangeListeners.push(function() {
      $scope.date = parseDateString(ngModel.$viewValue);
    });

    $element.on('keydown', inputKeydownBind);

    $popup = $compile(popupEl)($scope);
    // Prevent jQuery cache memory leak (template is now redundant after linking)
    popupEl.remove();

    if (appendToBody) {
      $document.find('body').append($popup);
    } else {
      $element.after($popup);
    }

    $scope.$on('$destroy', function() {
      if ($scope.isOpen === true) {
        if (!$rootScope.$$phase) {
          $scope.$apply(function() {
            $scope.isOpen = false;
          });
        }
      }

      $popup.remove();
      $element.off('keydown', inputKeydownBind);
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);

      //Clear all watch listeners on destroy
      while (watchListeners.length) {
        watchListeners.shift()();
      }
    });
  };

  $scope.getText = function(key) {
    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
  };

  $scope.isDisabled = function(date) {
    if (date === 'today') {
      date = dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
    }

    var dates = {};
    angular.forEach(['minDate', 'maxDate'], function(key) {
      if (!$scope.datepickerOptions[key]) {
        dates[key] = null;
      } else if (angular.isDate($scope.datepickerOptions[key])) {
        dates[key] = new Date($scope.datepickerOptions[key]);
      } else {
        if ($datepickerPopupLiteralWarning) {
          $log.warn('Literal date support has been deprecated, please switch to date object usage');
        }

        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
      }
    });

    return $scope.datepickerOptions &&
      dates.minDate && $scope.compare(date, dates.minDate) < 0 ||
      dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
  };

  $scope.compare = function(date1, date2) {
    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
  };

  // Inner change
  $scope.dateSelection = function(dt) {
    $scope.date = dt;
    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
    $element.val(date);
    ngModel.$setViewValue(date);

    if (closeOnDateSelection) {
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.keydown = function(evt) {
    if (evt.which === 27) {
      evt.stopPropagation();
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.select = function(date, evt) {
    evt.stopPropagation();

    if (date === 'today') {
      var today = new Date();
      if (angular.isDate($scope.date)) {
        date = new Date($scope.date);
        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
      } else {
        date = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
        date.setHours(0, 0, 0, 0);
      }
    }
    $scope.dateSelection(date);
  };

  $scope.close = function(evt) {
    evt.stopPropagation();

    $scope.isOpen = false;
    $element[0].focus();
  };

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if ($attrs.ngDisabled) {
    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(disabled) {
      $scope.disabled = disabled;
    }));
  }

  $scope.$watch('isOpen', function(value) {
    if (value) {
      if (!$scope.disabled) {
        $timeout(function() {
          positionPopup();

          if (onOpenFocus) {
            $scope.$broadcast('uib:datepicker.focus');
          }

          $document.on('click', documentClickBind);

          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
          if (appendToBody || $position.parsePlacement(placement)[2]) {
            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
            if (scrollParentEl) {
              scrollParentEl.on('scroll', positionPopup);
            }
          } else {
            scrollParentEl = null;
          }

          angular.element($window).on('resize', positionPopup);
        }, 0, false);
      } else {
        $scope.isOpen = false;
      }
    } else {
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);
    }
  });

  function cameltoDash(string) {
    return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
  }

  function parseDateString(viewValue) {
    var date = dateParser.parse(viewValue, dateFormat, $scope.date);
    if (isNaN(date)) {
      for (var i = 0; i < altInputFormats.length; i++) {
        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
        if (!isNaN(date)) {
          return date;
        }
      }
    }
    return date;
  }

  function parseDate(viewValue) {
    if (angular.isNumber(viewValue)) {
      // presumably timestamp to date object
      viewValue = new Date(viewValue);
    }

    if (!viewValue) {
      return null;
    }

    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
      return viewValue;
    }

    if (angular.isString(viewValue)) {
      var date = parseDateString(viewValue);
      if (!isNaN(date)) {
        return dateParser.toTimezone(date, ngModelOptions.getOption('timezone'));
      }
    }

    return ngModelOptions.getOption('allowInvalid') ? viewValue : undefined;
  }

  function validator(modelValue, viewValue) {
    var value = modelValue || viewValue;

    if (!$attrs.ngRequired && !value) {
      return true;
    }

    if (angular.isNumber(value)) {
      value = new Date(value);
    }

    if (!value) {
      return true;
    }

    if (angular.isDate(value) && !isNaN(value)) {
      return true;
    }

    if (angular.isString(value)) {
      return !isNaN(parseDateString(value));
    }

    return false;
  }

  function documentClickBind(event) {
    if (!$scope.isOpen && $scope.disabled) {
      return;
    }

    var popup = $popup[0];
    var dpContainsTarget = $element[0].contains(event.target);
    // The popup node may not be an element node
    // In some browsers (IE) only element nodes have the 'contains' function
    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
      $scope.$apply(function() {
        $scope.isOpen = false;
      });
    }
  }

  function inputKeydownBind(evt) {
    if (evt.which === 27 && $scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function() {
        $scope.isOpen = false;
      });
      $element[0].focus();
    } else if (evt.which === 40 && !$scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function() {
        $scope.isOpen = true;
      });
    }
  }

  function positionPopup() {
    if ($scope.isOpen) {
      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
      var position = $position.positionElements($element, dpElement, placement, appendToBody);
      dpElement.css({top: position.top + 'px', left: position.left + 'px'});
      if (dpElement.hasClass('uib-position-measure')) {
        dpElement.removeClass('uib-position-measure');
      }
    }
  }

  function extractOptions(ngModelCtrl) {
    var ngModelOptions;

    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
      // guarantee a value
      ngModelOptions = angular.isObject(ngModelCtrl.$options) ?
        ngModelCtrl.$options :
        {
          timezone: null
        };

      // mimic 1.6+ api
      ngModelOptions.getOption = function (key) {
        return ngModelOptions[key];
      };
    } else { // in angular >=1.6 $options is always present
      ngModelOptions = ngModelCtrl.$options;
    }

    return ngModelOptions;
  }

  $scope.$on('uib:datepicker.mode', function() {
    $timeout(positionPopup, 0, false);
  });
}])

.directive('uibDatepickerPopup', function() {
  return {
    require: ['ngModel', 'uibDatepickerPopup'],
    controller: 'UibDatepickerPopupController',
    scope: {
      datepickerOptions: '=?',
      isOpen: '=?',
      currentText: '@',
      clearText: '@',
      closeText: '@'
    },
    link: function(scope, element, attrs, ctrls) {
      var ngModel = ctrls[0],
        ctrl = ctrls[1];

      ctrl.init(ngModel);
    }
  };
})

.directive('uibDatepickerPopupWrap', function() {
  return {
    restrict: 'A',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
    }
  };
});

angular.module('ui.bootstrap.debounce', [])
/**
 * A helper, internal service that debounces a function
 */
  .factory('$$debounce', ['$timeout', function($timeout) {
    return function(callback, debounceTime) {
      var timeoutPromise;

      return function() {
        var self = this;
        var args = Array.prototype.slice.call(arguments);
        if (timeoutPromise) {
          $timeout.cancel(timeoutPromise);
        }

        timeoutPromise = $timeout(function() {
          callback.apply(self, args);
        }, debounceTime);
      };
    };
  }]);

angular.module('ui.bootstrap.multiMap', [])
/**
 * A helper, internal data structure that stores all references attached to key
 */
  .factory('$$multiMap', function() {
    return {
      createNew: function() {
        var map = {};

        return {
          entries: function() {
            return Object.keys(map).map(function(key) {
              return {
                key: key,
                value: map[key]
              };
            });
          },
          get: function(key) {
            return map[key];
          },
          hasKey: function(key) {
            return !!map[key];
          },
          keys: function() {
            return Object.keys(map);
          },
          put: function(key, value) {
            if (!map[key]) {
              map[key] = [];
            }

            map[key].push(value);
          },
          remove: function(key, value) {
            var values = map[key];

            if (!values) {
              return;
            }

            var idx = values.indexOf(value);

            if (idx !== -1) {
              values.splice(idx, 1);
            }

            if (!values.length) {
              delete map[key];
            }
          }
        };
      }
    };
  });

angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position'])

.constant('uibDropdownConfig', {
  appendToOpenClass: 'uib-dropdown-open',
  openClass: 'open'
})

.service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function($document, $rootScope, $$multiMap) {
  var openScope = null;
  var openedContainers = $$multiMap.createNew();

  this.isOnlyOpen = function(dropdownScope, appendTo) {
    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var openDropdown = openedDropdowns.reduce(function(toClose, dropdown) {
        if (dropdown.scope === dropdownScope) {
          return dropdown;
        }

        return toClose;
      }, {});
      if (openDropdown) {
        return openedDropdowns.length === 1;
      }
    }

    return false;
  };

  this.open = function(dropdownScope, element, appendTo) {
    if (!openScope) {
      $document.on('click', closeDropdown);
    }

    if (openScope && openScope !== dropdownScope) {
      openScope.isOpen = false;
    }

    openScope = dropdownScope;

    if (!appendTo) {
      return;
    }

    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var openedScopes = openedDropdowns.map(function(dropdown) {
        return dropdown.scope;
      });
      if (openedScopes.indexOf(dropdownScope) === -1) {
        openedContainers.put(appendTo, {
          scope: dropdownScope
        });
      }
    } else {
      openedContainers.put(appendTo, {
        scope: dropdownScope
      });
    }
  };

  this.close = function(dropdownScope, element, appendTo) {
    if (openScope === dropdownScope) {
      $document.off('click', closeDropdown);
      $document.off('keydown', this.keybindFilter);
      openScope = null;
    }

    if (!appendTo) {
      return;
    }

    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var dropdownToClose = openedDropdowns.reduce(function(toClose, dropdown) {
        if (dropdown.scope === dropdownScope) {
          return dropdown;
        }

        return toClose;
      }, {});
      if (dropdownToClose) {
        openedContainers.remove(appendTo, dropdownToClose);
      }
    }
  };

  var closeDropdown = function(evt) {
    // This method may still be called during the same mouse event that
    // unbound this event handler. So check openScope before proceeding.
    if (!openScope || !openScope.isOpen) { return; }

    if (evt && openScope.getAutoClose() === 'disabled') { return; }

    if (evt && evt.which === 3) { return; }

    var toggleElement = openScope.getToggleElement();
    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    if (evt && openScope.getAutoClose() === 'outsideClick' &&
      dropdownElement && dropdownElement[0].contains(evt.target)) {
      return;
    }

    openScope.focusToggleElement();
    openScope.isOpen = false;

    if (!$rootScope.$$phase) {
      openScope.$apply();
    }
  };

  this.keybindFilter = function(evt) {
    if (!openScope) {
      // see this.close as ESC could have been pressed which kills the scope so we can not proceed
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    var toggleElement = openScope.getToggleElement();
    var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
    var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
    if (evt.which === 27) {
      evt.stopPropagation();
      openScope.focusToggleElement();
      closeDropdown();
    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
      evt.preventDefault();
      evt.stopPropagation();
      openScope.focusDropdownEntry(evt.which);
    }
  };
}])

.controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
  var self = this,
    scope = $scope.$new(), // create a child scope so we are not polluting original one
    templateScope,
    appendToOpenClass = dropdownConfig.appendToOpenClass,
    openClass = dropdownConfig.openClass,
    getIsOpen,
    setIsOpen = angular.noop,
    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
    keynavEnabled = false,
    selectedOption = null,
    body = $document.find('body');

  $element.addClass('dropdown');

  this.init = function() {
    if ($attrs.isOpen) {
      getIsOpen = $parse($attrs.isOpen);
      setIsOpen = getIsOpen.assign;

      $scope.$watch(getIsOpen, function(value) {
        scope.isOpen = !!value;
      });
    }

    keynavEnabled = angular.isDefined($attrs.keyboardNav);
  };

  this.toggle = function(open) {
    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
    if (angular.isFunction(setIsOpen)) {
      setIsOpen(scope, scope.isOpen);
    }

    return scope.isOpen;
  };

  // Allow other directives to watch status
  this.isOpen = function() {
    return scope.isOpen;
  };

  scope.getToggleElement = function() {
    return self.toggleElement;
  };

  scope.getAutoClose = function() {
    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
  };

  scope.getElement = function() {
    return $element;
  };

  scope.isKeynavEnabled = function() {
    return keynavEnabled;
  };

  scope.focusDropdownEntry = function(keyCode) {
    var elems = self.dropdownMenu ? //If append to body is used.
      angular.element(self.dropdownMenu).find('a') :
      $element.find('ul').eq(0).find('a');

    switch (keyCode) {
      case 40: {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = 0;
        } else {
          self.selectedOption = self.selectedOption === elems.length - 1 ?
            self.selectedOption :
            self.selectedOption + 1;
        }
        break;
      }
      case 38: {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = elems.length - 1;
        } else {
          self.selectedOption = self.selectedOption === 0 ?
            0 : self.selectedOption - 1;
        }
        break;
      }
    }
    elems[self.selectedOption].focus();
  };

  scope.getDropdownElement = function() {
    return self.dropdownMenu;
  };

  scope.focusToggleElement = function() {
    if (self.toggleElement) {
      self.toggleElement[0].focus();
    }
  };

  function removeDropdownMenu() {
    $element.append(self.dropdownMenu);
  }

  scope.$watch('isOpen', function(isOpen, wasOpen) {
    var appendTo = null,
      appendToBody = false;

    if (angular.isDefined($attrs.dropdownAppendTo)) {
      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
      if (appendToEl) {
        appendTo = angular.element(appendToEl);
      }
    }

    if (angular.isDefined($attrs.dropdownAppendToBody)) {
      var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
      if (appendToBodyValue !== false) {
        appendToBody = true;
      }
    }

    if (appendToBody && !appendTo) {
      appendTo = body;
    }

    if (appendTo && self.dropdownMenu) {
      if (isOpen) {
        appendTo.append(self.dropdownMenu);
        $element.on('$destroy', removeDropdownMenu);
      } else {
        $element.off('$destroy', removeDropdownMenu);
        removeDropdownMenu();
      }
    }

    if (appendTo && self.dropdownMenu) {
      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
        css,
        rightalign,
        scrollbarPadding,
        scrollbarWidth = 0;

      css = {
        top: pos.top + 'px',
        display: isOpen ? 'block' : 'none'
      };

      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
      if (!rightalign) {
        css.left = pos.left + 'px';
        css.right = 'auto';
      } else {
        css.left = 'auto';
        scrollbarPadding = $position.scrollbarPadding(appendTo);

        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
          scrollbarWidth = scrollbarPadding.scrollbarWidth;
        }

        css.right = window.innerWidth - scrollbarWidth -
          (pos.left + $element.prop('offsetWidth')) + 'px';
      }

      // Need to adjust our positioning to be relative to the appendTo container
      // if it's not the body element
      if (!appendToBody) {
        var appendOffset = $position.offset(appendTo);

        css.top = pos.top - appendOffset.top + 'px';

        if (!rightalign) {
          css.left = pos.left - appendOffset.left + 'px';
        } else {
          css.right = window.innerWidth -
            (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
        }
      }

      self.dropdownMenu.css(css);
    }

    var openContainer = appendTo ? appendTo : $element;
    var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
    var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
    var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);

    if (hasOpenClass === !isOpen) {
      var toggleClass;
      if (appendTo) {
        toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
      } else {
        toggleClass = isOpen ? 'addClass' : 'removeClass';
      }
      $animate[toggleClass](openContainer, dropdownOpenClass).then(function() {
        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
          toggleInvoker($scope, { open: !!isOpen });
        }
      });
    }

    if (isOpen) {
      if (self.dropdownMenuTemplateUrl) {
        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
          templateScope = scope.$new();
          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
            var newEl = dropdownElement;
            self.dropdownMenu.replaceWith(newEl);
            self.dropdownMenu = newEl;
            $document.on('keydown', uibDropdownService.keybindFilter);
          });
        });
      } else {
        $document.on('keydown', uibDropdownService.keybindFilter);
      }

      scope.focusToggleElement();
      uibDropdownService.open(scope, $element, appendTo);
    } else {
      uibDropdownService.close(scope, $element, appendTo);
      if (self.dropdownMenuTemplateUrl) {
        if (templateScope) {
          templateScope.$destroy();
        }
        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
        self.dropdownMenu.replaceWith(newEl);
        self.dropdownMenu = newEl;
      }

      self.selectedOption = null;
    }

    if (angular.isFunction(setIsOpen)) {
      setIsOpen($scope, isOpen);
    }
  });
}])

.directive('uibDropdown', function() {
  return {
    controller: 'UibDropdownController',
    link: function(scope, element, attrs, dropdownCtrl) {
      dropdownCtrl.init();
    }
  };
})

.directive('uibDropdownMenu', function() {
  return {
    restrict: 'A',
    require: '?^uibDropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
        return;
      }

      element.addClass('dropdown-menu');

      var tplUrl = attrs.templateUrl;
      if (tplUrl) {
        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
      }

      if (!dropdownCtrl.dropdownMenu) {
        dropdownCtrl.dropdownMenu = element;
      }
    }
  };
})

.directive('uibDropdownToggle', function() {
  return {
    require: '?^uibDropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl) {
        return;
      }

      element.addClass('dropdown-toggle');

      dropdownCtrl.toggleElement = element;

      var toggleDropdown = function(event) {
        event.preventDefault();

        if (!element.hasClass('disabled') && !attrs.disabled) {
          scope.$apply(function() {
            dropdownCtrl.toggle();
          });
        }
      };

      element.on('click', toggleDropdown);

      // WAI-ARIA
      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
      scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
        element.attr('aria-expanded', !!isOpen);
      });

      scope.$on('$destroy', function() {
        element.off('click', toggleDropdown);
      });
    }
  };
});

angular.module('ui.bootstrap.stackedMap', [])
/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
  .factory('$$stackedMap', function() {
    return {
      createNew: function() {
        var stack = [];

        return {
          add: function(key, value) {
            stack.push({
              key: key,
              value: value
            });
          },
          get: function(key) {
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                return stack[i];
              }
            }
          },
          keys: function() {
            var keys = [];
            for (var i = 0; i < stack.length; i++) {
              keys.push(stack[i].key);
            }
            return keys;
          },
          top: function() {
            return stack[stack.length - 1];
          },
          remove: function(key) {
            var idx = -1;
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                idx = i;
                break;
              }
            }
            return stack.splice(idx, 1)[0];
          },
          removeTop: function() {
            return stack.pop();
          },
          length: function() {
            return stack.length;
          }
        };
      }
    };
  });
angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
/**
 * Pluggable resolve mechanism for the modal resolve resolution
 * Supports UI Router's $resolve service
 */
  .provider('$uibResolve', function() {
    var resolve = this;
    this.resolver = null;

    this.setResolver = function(resolver) {
      this.resolver = resolver;
    };

    this.$get = ['$injector', '$q', function($injector, $q) {
      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
      return {
        resolve: function(invocables, locals, parent, self) {
          if (resolver) {
            return resolver.resolve(invocables, locals, parent, self);
          }

          var promises = [];

          angular.forEach(invocables, function(value) {
            if (angular.isFunction(value) || angular.isArray(value)) {
              promises.push($q.resolve($injector.invoke(value)));
            } else if (angular.isString(value)) {
              promises.push($q.resolve($injector.get(value)));
            } else {
              promises.push($q.resolve(value));
            }
          });

          return $q.all(promises).then(function(resolves) {
            var resolveObj = {};
            var resolveIter = 0;
            angular.forEach(invocables, function(value, key) {
              resolveObj[key] = resolves[resolveIter++];
            });

            return resolveObj;
          });
        }
      };
    }];
  })

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
  .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
  function($animate, $injector, $modalStack) {
    return {
      restrict: 'A',
      compile: function(tElement, tAttrs) {
        tElement.addClass(tAttrs.backdropClass);
        return linkFn;
      }
    };

    function linkFn(scope, element, attrs) {
      if (attrs.modalInClass) {
        $animate.addClass(element, attrs.modalInClass);

        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
          var done = setIsAsync();
          if (scope.modalOptions.animation) {
            $animate.removeClass(element, attrs.modalInClass).then(done);
          } else {
            done();
          }
        });
      }
    }
  }])

  .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
  function($modalStack, $q, $animateCss, $document) {
    return {
      scope: {
        index: '@'
      },
      restrict: 'A',
      transclude: true,
      templateUrl: function(tElement, tAttrs) {
        return tAttrs.templateUrl || 'uib/template/modal/window.html';
      },
      link: function(scope, element, attrs) {
        element.addClass(attrs.windowTopClass || '');
        scope.size = attrs.size;

        scope.close = function(evt) {
          var modal = $modalStack.getTop();
          if (modal && modal.value.backdrop &&
            modal.value.backdrop !== 'static' &&
            evt.target === evt.currentTarget) {
            evt.preventDefault();
            evt.stopPropagation();
            $modalStack.dismiss(modal.key, 'backdrop click');
          }
        };

        // moved from template to fix issue #2280
        element.on('click', scope.close);

        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
        // We can detect that by using this property in the template associated with this directive and then use
        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
        scope.$isRendered = true;

        // Deferred object that will be resolved when this modal is rendered.
        var modalRenderDeferObj = $q.defer();
        // Resolve render promise post-digest
        scope.$$postDigest(function() {
          modalRenderDeferObj.resolve();
        });

        modalRenderDeferObj.promise.then(function() {
          var animationPromise = null;

          if (attrs.modalInClass) {
            animationPromise = $animateCss(element, {
              addClass: attrs.modalInClass
            }).start();

            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
              var done = setIsAsync();
              $animateCss(element, {
                removeClass: attrs.modalInClass
              }).start().then(done);
            });
          }


          $q.when(animationPromise).then(function() {
            // Notify {@link $modalStack} that modal is rendered.
            var modal = $modalStack.getTop();
            if (modal) {
              $modalStack.modalRendered(modal.key);
            }

            /**
             * If something within the freshly-opened modal already has focus (perhaps via a
             * directive that causes focus) then there's no need to try to focus anything.
             */
            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
              var inputWithAutofocus = element[0].querySelector('[autofocus]');
              /**
               * Auto-focusing of a freshly-opened modal element causes any child elements
               * with the autofocus attribute to lose focus. This is an issue on touch
               * based devices which will show and then hide the onscreen keyboard.
               * Attempts to refocus the autofocus element via JavaScript will not reopen
               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
               * the modal element if the modal does not contain an autofocus element.
               */
              if (inputWithAutofocus) {
                inputWithAutofocus.focus();
              } else {
                element[0].focus();
              }
            }
          });
        });
      }
    };
  }])

  .directive('uibModalAnimationClass', function() {
    return {
      compile: function(tElement, tAttrs) {
        if (tAttrs.modalAnimation) {
          tElement.addClass(tAttrs.uibModalAnimationClass);
        }
      }
    };
  })

  .directive('uibModalTransclude', ['$animate', function($animate) {
    return {
      link: function(scope, element, attrs, controller, transclude) {
        transclude(scope.$parent, function(clone) {
          element.empty();
          $animate.enter(clone, element);
        });
      }
    };
  }])

  .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
    '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
    function($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
      var OPENED_MODAL_CLASS = 'modal-open';

      var backdropDomEl, backdropScope;
      var openedWindows = $$stackedMap.createNew();
      var openedClasses = $$multiMap.createNew();
      var $modalStack = {
        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
      };
      var topModalIndex = 0;
      var previousTopOpenedModal = null;
      var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';

      //Modal focus behavior
      var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
        'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
        'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
      var scrollbarPadding;
      var SNAKE_CASE_REGEXP = /[A-Z]/g;

      // TODO: extract into common dependency with tooltip
      function snake_case(name) {
        var separator = '-';
        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
          return (pos ? separator : '') + letter.toLowerCase();
        });
      }

      function isVisible(element) {
        return !!(element.offsetWidth ||
          element.offsetHeight ||
          element.getClientRects().length);
      }

      function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
          if (openedWindows.get(opened[i]).value.backdrop) {
            topBackdropIndex = i;
          }
        }

        // If any backdrop exist, ensure that it's index is always
        // right below the top modal
        if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
          topBackdropIndex = topModalIndex;
        }
        return topBackdropIndex;
      }

      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
        if (backdropScope) {
          backdropScope.index = newBackdropIndex;
        }
      });

      function removeModalWindow(modalInstance, elementToReceiveFocus) {
        var modalWindow = openedWindows.get(modalInstance).value;
        var appendToElement = modalWindow.appendTo;

        //clean up the stack
        openedWindows.remove(modalInstance);
        previousTopOpenedModal = openedWindows.top();
        if (previousTopOpenedModal) {
          topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
        }

        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
          openedClasses.remove(modalBodyClass, modalInstance);
          var areAnyOpen = openedClasses.hasKey(modalBodyClass);
          appendToElement.toggleClass(modalBodyClass, areAnyOpen);
          if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
            if (scrollbarPadding.originalRight) {
              appendToElement.css({paddingRight: scrollbarPadding.originalRight + 'px'});
            } else {
              appendToElement.css({paddingRight: ''});
            }
            scrollbarPadding = null;
          }
          toggleTopWindowClass(true);
        }, modalWindow.closedDeferred);
        checkRemoveBackdrop();

        //move focus to specified element if available, or else to body
        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
          elementToReceiveFocus.focus();
        } else if (appendToElement.focus) {
          appendToElement.focus();
        }
      }

      // Add or remove "windowTopClass" from the top window in the stack
      function toggleTopWindowClass(toggleSwitch) {
        var modalWindow;

        if (openedWindows.length() > 0) {
          modalWindow = openedWindows.top().value;
          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
        }
      }

      function checkRemoveBackdrop() {
        //remove backdrop if no longer needed
        if (backdropDomEl && backdropIndex() === -1) {
          var backdropScopeRef = backdropScope;
          removeAfterAnimate(backdropDomEl, backdropScope, function() {
            backdropScopeRef = null;
          });
          backdropDomEl = undefined;
          backdropScope = undefined;
        }
      }

      function removeAfterAnimate(domEl, scope, done, closedDeferred) {
        var asyncDeferred;
        var asyncPromise = null;
        var setIsAsync = function() {
          if (!asyncDeferred) {
            asyncDeferred = $q.defer();
            asyncPromise = asyncDeferred.promise;
          }

          return function asyncDone() {
            asyncDeferred.resolve();
          };
        };
        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

        // Note that it's intentional that asyncPromise might be null.
        // That's when setIsAsync has not been called during the
        // NOW_CLOSING_EVENT broadcast.
        return $q.when(asyncPromise).then(afterAnimating);

        function afterAnimating() {
          if (afterAnimating.done) {
            return;
          }
          afterAnimating.done = true;

          $animate.leave(domEl).then(function() {
            if (done) {
              done();
            }

            domEl.remove();
            if (closedDeferred) {
              closedDeferred.resolve();
            }
          });

          scope.$destroy();
        }
      }

      $document.on('keydown', keydownListener);

      $rootScope.$on('$destroy', function() {
        $document.off('keydown', keydownListener);
      });

      function keydownListener(evt) {
        if (evt.isDefaultPrevented()) {
          return evt;
        }

        var modal = openedWindows.top();
        if (modal) {
          switch (evt.which) {
            case 27: {
              if (modal.value.keyboard) {
                evt.preventDefault();
                $rootScope.$apply(function() {
                  $modalStack.dismiss(modal.key, 'escape key press');
                });
              }
              break;
            }
            case 9: {
              var list = $modalStack.loadFocusElementList(modal);
              var focusChanged = false;
              if (evt.shiftKey) {
                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
                  focusChanged = $modalStack.focusLastFocusableElement(list);
                }
              } else {
                if ($modalStack.isFocusInLastItem(evt, list)) {
                  focusChanged = $modalStack.focusFirstFocusableElement(list);
                }
              }

              if (focusChanged) {
                evt.preventDefault();
                evt.stopPropagation();
              }

              break;
            }
          }
        }
      }

      $modalStack.open = function(modalInstance, modal) {
        var modalOpener = $document[0].activeElement,
          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

        toggleTopWindowClass(false);

        // Store the current top first, to determine what index we ought to use
        // for the current top modal
        previousTopOpenedModal = openedWindows.top();

        openedWindows.add(modalInstance, {
          deferred: modal.deferred,
          renderDeferred: modal.renderDeferred,
          closedDeferred: modal.closedDeferred,
          modalScope: modal.scope,
          backdrop: modal.backdrop,
          keyboard: modal.keyboard,
          openedClass: modal.openedClass,
          windowTopClass: modal.windowTopClass,
          animation: modal.animation,
          appendTo: modal.appendTo
        });

        openedClasses.put(modalBodyClass, modalInstance);

        var appendToElement = modal.appendTo,
            currBackdropIndex = backdropIndex();

        if (currBackdropIndex >= 0 && !backdropDomEl) {
          backdropScope = $rootScope.$new(true);
          backdropScope.modalOptions = modal;
          backdropScope.index = currBackdropIndex;
          backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
          backdropDomEl.attr({
            'class': 'modal-backdrop',
            'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
            'uib-modal-animation-class': 'fade',
            'modal-in-class': 'in'
          });
          if (modal.backdropClass) {
            backdropDomEl.addClass(modal.backdropClass);
          }

          if (modal.animation) {
            backdropDomEl.attr('modal-animation', 'true');
          }
          $compile(backdropDomEl)(backdropScope);
          $animate.enter(backdropDomEl, appendToElement);
          if ($uibPosition.isScrollable(appendToElement)) {
            scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
            if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
              appendToElement.css({paddingRight: scrollbarPadding.right + 'px'});
            }
          }
        }

        var content;
        if (modal.component) {
          content = document.createElement(snake_case(modal.component.name));
          content = angular.element(content);
          content.attr({
            resolve: '$resolve',
            'modal-instance': '$uibModalInstance',
            close: '$close($value)',
            dismiss: '$dismiss($value)'
          });
        } else {
          content = modal.content;
        }

        // Set the top modal index based on the index of the previous top modal
        topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
        angularDomEl.attr({
          'class': 'modal',
          'template-url': modal.windowTemplateUrl,
          'window-top-class': modal.windowTopClass,
          'role': 'dialog',
          'aria-labelledby': modal.ariaLabelledBy,
          'aria-describedby': modal.ariaDescribedBy,
          'size': modal.size,
          'index': topModalIndex,
          'animate': 'animate',
          'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
          'tabindex': -1,
          'uib-modal-animation-class': 'fade',
          'modal-in-class': 'in'
        }).append(content);
        if (modal.windowClass) {
          angularDomEl.addClass(modal.windowClass);
        }

        if (modal.animation) {
          angularDomEl.attr('modal-animation', 'true');
        }

        appendToElement.addClass(modalBodyClass);
        if (modal.scope) {
          // we need to explicitly add the modal index to the modal scope
          // because it is needed by ngStyle to compute the zIndex property.
          modal.scope.$$topModalIndex = topModalIndex;
        }
        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);

        openedWindows.top().value.modalDomEl = angularDomEl;
        openedWindows.top().value.modalOpener = modalOpener;

        applyAriaHidden(angularDomEl);

        function applyAriaHidden(el) {
          if (!el || el[0].tagName === 'BODY') {
            return;
          }

          getSiblings(el).forEach(function(sibling) {
            var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
              ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);

            if (!ariaHiddenCount) {
              ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
            }

            sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
            sibling.setAttribute('aria-hidden', 'true');
          });

          return applyAriaHidden(el.parent());

          function getSiblings(el) {
            var children = el.parent() ? el.parent().children() : [];

            return Array.prototype.filter.call(children, function(child) {
              return child !== el[0];
            });
          }
        }
      };

      function broadcastClosing(modalWindow, resultOrReason, closing) {
        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
      }

      function unhideBackgroundElements() {
        Array.prototype.forEach.call(
          document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'),
          function(hiddenEl) {
            var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
              newHiddenCount = ariaHiddenCount - 1;
            hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);

            if (!newHiddenCount) {
              hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
              hiddenEl.removeAttribute('aria-hidden');
            }
          }
        );
      }

      $modalStack.close = function(modalInstance, result) {
        var modalWindow = openedWindows.get(modalInstance);
        unhideBackgroundElements();
        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.resolve(result);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }

        return !modalWindow;
      };

      $modalStack.dismiss = function(modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance);
        unhideBackgroundElements();
        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.reject(reason);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismissAll = function(reason) {
        var topModal = this.getTop();
        while (topModal && this.dismiss(topModal.key, reason)) {
          topModal = this.getTop();
        }
      };

      $modalStack.getTop = function() {
        return openedWindows.top();
      };

      $modalStack.modalRendered = function(modalInstance) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow) {
          modalWindow.value.renderDeferred.resolve();
        }
      };

      $modalStack.focusFirstFocusableElement = function(list) {
        if (list.length > 0) {
          list[0].focus();
          return true;
        }
        return false;
      };

      $modalStack.focusLastFocusableElement = function(list) {
        if (list.length > 0) {
          list[list.length - 1].focus();
          return true;
        }
        return false;
      };

      $modalStack.isModalFocused = function(evt, modalWindow) {
        if (evt && modalWindow) {
          var modalDomEl = modalWindow.value.modalDomEl;
          if (modalDomEl && modalDomEl.length) {
            return (evt.target || evt.srcElement) === modalDomEl[0];
          }
        }
        return false;
      };

      $modalStack.isFocusInFirstItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[0];
        }
        return false;
      };

      $modalStack.isFocusInLastItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[list.length - 1];
        }
        return false;
      };

      $modalStack.loadFocusElementList = function(modalWindow) {
        if (modalWindow) {
          var modalDomE1 = modalWindow.value.modalDomEl;
          if (modalDomE1 && modalDomE1.length) {
            var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
            return elements ?
              Array.prototype.filter.call(elements, function(element) {
                return isVisible(element);
              }) : elements;
          }
        }
      };

      return $modalStack;
    }])

  .provider('$uibModal', function() {
    var $modalProvider = {
      options: {
        animation: true,
        backdrop: true, //can also be false or 'static'
        keyboard: true
      },
      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
        function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
          var $modal = {};

          function getTemplatePromise(options) {
            return options.template ? $q.when(options.template) :
              $templateRequest(angular.isFunction(options.templateUrl) ?
                options.templateUrl() : options.templateUrl);
          }

          var promiseChain = null;
          $modal.getPromiseChain = function() {
            return promiseChain;
          };

          $modal.open = function(modalOptions) {
            var modalResultDeferred = $q.defer();
            var modalOpenedDeferred = $q.defer();
            var modalClosedDeferred = $q.defer();
            var modalRenderDeferred = $q.defer();

            //prepare an instance of a modal to be injected into controllers and returned to a caller
            var modalInstance = {
              result: modalResultDeferred.promise,
              opened: modalOpenedDeferred.promise,
              closed: modalClosedDeferred.promise,
              rendered: modalRenderDeferred.promise,
              close: function (result) {
                return $modalStack.close(modalInstance, result);
              },
              dismiss: function (reason) {
                return $modalStack.dismiss(modalInstance, reason);
              }
            };

            //merge and clean up options
            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
            modalOptions.resolve = modalOptions.resolve || {};
            modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

            if (!modalOptions.appendTo.length) {
              throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
            }

            //verify options
            if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
              throw new Error('One of component or template or templateUrl options is required.');
            }

            var templateAndResolvePromise;
            if (modalOptions.component) {
              templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
            } else {
              templateAndResolvePromise =
                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
            }

            function resolveWithTemplate() {
              return templateAndResolvePromise;
            }

            // Wait for the resolution of the existing promise chain.
            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
            // Then add to $modalStack and resolve opened.
            // Finally clean up the chain variable if no subsequent modal has overwritten it.
            var samePromise;
            samePromise = promiseChain = $q.all([promiseChain])
              .then(resolveWithTemplate, resolveWithTemplate)
              .then(function resolveSuccess(tplAndVars) {
                var providedScope = modalOptions.scope || $rootScope;

                var modalScope = providedScope.$new();
                modalScope.$close = modalInstance.close;
                modalScope.$dismiss = modalInstance.dismiss;

                modalScope.$on('$destroy', function() {
                  if (!modalScope.$$uibDestructionScheduled) {
                    modalScope.$dismiss('$uibUnscheduledDestruction');
                  }
                });

                var modal = {
                  scope: modalScope,
                  deferred: modalResultDeferred,
                  renderDeferred: modalRenderDeferred,
                  closedDeferred: modalClosedDeferred,
                  animation: modalOptions.animation,
                  backdrop: modalOptions.backdrop,
                  keyboard: modalOptions.keyboard,
                  backdropClass: modalOptions.backdropClass,
                  windowTopClass: modalOptions.windowTopClass,
                  windowClass: modalOptions.windowClass,
                  windowTemplateUrl: modalOptions.windowTemplateUrl,
                  ariaLabelledBy: modalOptions.ariaLabelledBy,
                  ariaDescribedBy: modalOptions.ariaDescribedBy,
                  size: modalOptions.size,
                  openedClass: modalOptions.openedClass,
                  appendTo: modalOptions.appendTo
                };

                var component = {};
                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};

                if (modalOptions.component) {
                  constructLocals(component, false, true, false);
                  component.name = modalOptions.component;
                  modal.component = component;
                } else if (modalOptions.controller) {
                  constructLocals(ctrlLocals, true, false, true);

                  // the third param will make the controller instantiate later,private api
                  // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
                  ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
                  if (modalOptions.controllerAs && modalOptions.bindToController) {
                    ctrlInstance = ctrlInstantiate.instance;
                    ctrlInstance.$close = modalScope.$close;
                    ctrlInstance.$dismiss = modalScope.$dismiss;
                    angular.extend(ctrlInstance, {
                      $resolve: ctrlLocals.$scope.$resolve
                    }, providedScope);
                  }

                  ctrlInstance = ctrlInstantiate();

                  if (angular.isFunction(ctrlInstance.$onInit)) {
                    ctrlInstance.$onInit();
                  }
                }

                if (!modalOptions.component) {
                  modal.content = tplAndVars[0];
                }

                $modalStack.open(modalInstance, modal);
                modalOpenedDeferred.resolve(true);

                function constructLocals(obj, template, instanceOnScope, injectable) {
                  obj.$scope = modalScope;
                  obj.$scope.$resolve = {};
                  if (instanceOnScope) {
                    obj.$scope.$uibModalInstance = modalInstance;
                  } else {
                    obj.$uibModalInstance = modalInstance;
                  }

                  var resolves = template ? tplAndVars[1] : tplAndVars;
                  angular.forEach(resolves, function(value, key) {
                    if (injectable) {
                      obj[key] = value;
                    }

                    obj.$scope.$resolve[key] = value;
                  });
                }
            }, function resolveError(reason) {
              modalOpenedDeferred.reject(reason);
              modalResultDeferred.reject(reason);
            })['finally'](function() {
              if (promiseChain === samePromise) {
                promiseChain = null;
              }
            });

            return modalInstance;
          };

          return $modal;
        }
      ]
    };

    return $modalProvider;
  });

angular.module('ui.bootstrap.paging', [])
/**
 * Helper internal service for generating common controller code between the
 * pager and pagination components
 */
.factory('uibPaging', ['$parse', function($parse) {
  return {
    create: function(ctrl, $scope, $attrs) {
      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
      ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
      ctrl._watchers = [];

      ctrl.init = function(ngModelCtrl, config) {
        ctrl.ngModelCtrl = ngModelCtrl;
        ctrl.config = config;

        ngModelCtrl.$render = function() {
          ctrl.render();
        };

        if ($attrs.itemsPerPage) {
          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function(value) {
            ctrl.itemsPerPage = parseInt(value, 10);
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }));
        } else {
          ctrl.itemsPerPage = config.itemsPerPage;
        }

        $scope.$watch('totalItems', function(newTotal, oldTotal) {
          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }
        });
      };

      ctrl.calculateTotalPages = function() {
        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
        return Math.max(totalPages || 0, 1);
      };

      ctrl.render = function() {
        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
      };

      $scope.selectPage = function(page, evt) {
        if (evt) {
          evt.preventDefault();
        }

        var clickAllowed = !$scope.ngDisabled || !evt;
        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
          if (evt && evt.target) {
            evt.target.blur();
          }
          ctrl.ngModelCtrl.$setViewValue(page);
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.getText = function(key) {
        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
      };

      $scope.noPrevious = function() {
        return $scope.page === 1;
      };

      $scope.noNext = function() {
        return $scope.page === $scope.totalPages;
      };

      ctrl.updatePage = function() {
        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

        if ($scope.page > $scope.totalPages) {
          $scope.selectPage($scope.totalPages);
        } else {
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.$on('$destroy', function() {
        while (ctrl._watchers.length) {
          ctrl._watchers.shift()();
        }
      });
    }
  };
}]);

angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])

.controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function($scope, $attrs, uibPaging, uibPagerConfig) {
  $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;

  uibPaging.create(this, $scope, $attrs);
}])

.constant('uibPagerConfig', {
  itemsPerPage: 10,
  previousText: '« Previous',
  nextText: 'Next »',
  align: true
})

.directive('uibPager', ['uibPagerConfig', function(uibPagerConfig) {
  return {
    scope: {
      totalItems: '=',
      previousText: '@',
      nextText: '@',
      ngDisabled: '='
    },
    require: ['uibPager', '?ngModel'],
    restrict: 'A',
    controller: 'UibPagerController',
    controllerAs: 'pager',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/pager/pager.html';
    },
    link: function(scope, element, attrs, ctrls) {
      element.addClass('pager');
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
        return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPagerConfig);
    }
  };
}]);

angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
.controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
  var ctrl = this;
  // Setup configuration parameters
  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
    rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
    forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
    boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
    pageLabel = angular.isDefined($attrs.pageLabel) ? function(idx) { return $scope.$parent.$eval($attrs.pageLabel, {$page: idx}); } : angular.identity;
  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
  $attrs.$set('role', 'menu');

  uibPaging.create(this, $scope, $attrs);

  if ($attrs.maxSize) {
    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function(value) {
      maxSize = parseInt(value, 10);
      ctrl.render();
    }));
  }

  // Create page object used in template
  function makePage(number, text, isActive) {
    return {
      number: number,
      text: text,
      active: isActive
    };
  }

  function getPages(currentPage, totalPages) {
    var pages = [];

    // Default page limits
    var startPage = 1, endPage = totalPages;
    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

    // recompute if maxSize
    if (isMaxSized) {
      if (rotate) {
        // Current page is displayed in the middle of the visible ones
        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
        endPage = startPage + maxSize - 1;

        // Adjust if limit is exceeded
        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = endPage - maxSize + 1;
        }
      } else {
        // Visible pages are paginated with maxSize
        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

        // Adjust last page if limit is exceeded
        endPage = Math.min(startPage + maxSize - 1, totalPages);
      }
    }

    // Add page number links
    for (var number = startPage; number <= endPage; number++) {
      var page = makePage(number, pageLabel(number), number === currentPage);
      pages.push(page);
    }

    // Add links to move between page sets
    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
      if (startPage > 1) {
        if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
        var previousPageSet = makePage(startPage - 1, '...', false);
        pages.unshift(previousPageSet);
      }
        if (boundaryLinkNumbers) {
          if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
            var secondPageLink = makePage(2, '2', false);
            pages.unshift(secondPageLink);
          }
          //add the first page
          var firstPageLink = makePage(1, '1', false);
          pages.unshift(firstPageLink);
        }
      }

      if (endPage < totalPages) {
        if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
        var nextPageSet = makePage(endPage + 1, '...', false);
        pages.push(nextPageSet);
      }
        if (boundaryLinkNumbers) {
          if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
            pages.push(secondToLastPageLink);
          }
          //add the last page
          var lastPageLink = makePage(totalPages, totalPages, false);
          pages.push(lastPageLink);
        }
      }
    }
    return pages;
  }

  var originalRender = this.render;
  this.render = function() {
    originalRender();
    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
      $scope.pages = getPages($scope.page, $scope.totalPages);
    }
  };
}])

.constant('uibPaginationConfig', {
  itemsPerPage: 10,
  boundaryLinks: false,
  boundaryLinkNumbers: false,
  directionLinks: true,
  firstText: 'First',
  previousText: 'Previous',
  nextText: 'Next',
  lastText: 'Last',
  rotate: true,
  forceEllipses: false
})

.directive('uibPagination', ['$parse', 'uibPaginationConfig', function($parse, uibPaginationConfig) {
  return {
    scope: {
      totalItems: '=',
      firstText: '@',
      previousText: '@',
      nextText: '@',
      lastText: '@',
      ngDisabled:'='
    },
    require: ['uibPagination', '?ngModel'],
    restrict: 'A',
    controller: 'UibPaginationController',
    controllerAs: 'pagination',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/pagination/pagination.html';
    },
    link: function(scope, element, attrs, ctrls) {
      element.addClass('pagination');
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
         return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
    }
  };
}]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])

/**
 * The $tooltip service creates tooltip- and popover-like directives as well as
 * houses global options for them.
 */
.provider('$uibTooltip', function() {
  // The default options tooltip and popover.
  var defaultOptions = {
    placement: 'top',
    placementClassPrefix: '',
    animation: true,
    popupDelay: 0,
    popupCloseDelay: 0,
    useContentExp: false
  };

  // Default hide triggers for each show trigger
  var triggerMap = {
    'mouseenter': 'mouseleave',
    'click': 'click',
    'outsideClick': 'outsideClick',
    'focus': 'blur',
    'none': ''
  };

  // The options specified to the provider globally.
  var globalOptions = {};

  /**
   * `options({})` allows global configuration of all tooltips in the
   * application.
   *
   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
   *     // place tooltips left instead of top by default
   *     $tooltipProvider.options( { placement: 'left' } );
   *   });
   */
	this.options = function(value) {
		angular.extend(globalOptions, value);
	};

  /**
   * This allows you to extend the set of trigger mappings available. E.g.:
   *
   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
   */
  this.setTriggers = function setTriggers(triggers) {
    angular.extend(triggerMap, triggers);
  };

  /**
   * This is a helper function for translating camel-case to snake_case.
   */
  function snake_case(name) {
    var regexp = /[A-Z]/g;
    var separator = '-';
    return name.replace(regexp, function(letter, pos) {
      return (pos ? separator : '') + letter.toLowerCase();
    });
  }

  /**
   * Returns the actual instance of the $tooltip service.
   * TODO support multiple triggers
   */
  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
    var openedTooltips = $$stackedMap.createNew();
    $document.on('keyup', keypressListener);

    $rootScope.$on('$destroy', function() {
      $document.off('keyup', keypressListener);
    });

    function keypressListener(e) {
      if (e.which === 27) {
        var last = openedTooltips.top();
        if (last) {
          last.value.close();
          last = null;
        }
      }
    }

    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
      options = angular.extend({}, defaultOptions, globalOptions, options);

      /**
       * Returns an object of show and hide triggers.
       *
       * If a trigger is supplied,
       * it is used to show the tooltip; otherwise, it will use the `trigger`
       * option passed to the `$tooltipProvider.options` method; else it will
       * default to the trigger supplied to this directive factory.
       *
       * The hide trigger is based on the show trigger. If the `trigger` option
       * was passed to the `$tooltipProvider.options` method, it will use the
       * mapped trigger from `triggerMap` or the passed trigger if the map is
       * undefined; otherwise, it uses the `triggerMap` value of the show
       * trigger; else it will just use the show trigger.
       */
      function getTriggers(trigger) {
        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
        var hide = show.map(function(trigger) {
          return triggerMap[trigger] || trigger;
        });
        return {
          show: show,
          hide: hide
        };
      }

      var directiveName = snake_case(ttType);

      var startSym = $interpolate.startSymbol();
      var endSym = $interpolate.endSymbol();
      var template =
        '<div '+ directiveName + '-popup ' +
          'uib-title="' + startSym + 'title' + endSym + '" ' +
          (options.useContentExp ?
            'content-exp="contentExp()" ' :
            'content="' + startSym + 'content' + endSym + '" ') +
          'origin-scope="origScope" ' +
          'class="uib-position-measure ' + prefix + '" ' +
          'tooltip-animation-class="fade"' +
          'uib-tooltip-classes ' +
          'ng-class="{ in: isOpen }" ' +
          '>' +
        '</div>';

      return {
        compile: function(tElem, tAttrs) {
          var tooltipLinker = $compile(template);

          return function link(scope, element, attrs, tooltipCtrl) {
            var tooltip;
            var tooltipLinkedScope;
            var transitionTimeout;
            var showTimeout;
            var hideTimeout;
            var positionTimeout;
            var adjustmentTimeout;
            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
            var triggers = getTriggers(undefined);
            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
            var ttScope = scope.$new(true);
            var repositionScheduled = false;
            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
            var observers = [];
            var lastPlacement;

            var positionTooltip = function() {
              // check if tooltip exists and is not empty
              if (!tooltip || !tooltip.html()) { return; }

              if (!positionTimeout) {
                positionTimeout = $timeout(function() {
                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
                  var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                  var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
                  var placementClasses = ttPosition.placement.split('-');

                  if (!tooltip.hasClass(placementClasses[0])) {
                    tooltip.removeClass(lastPlacement.split('-')[0]);
                    tooltip.addClass(placementClasses[0]);
                  }

                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
                  }

                  adjustmentTimeout = $timeout(function() {
                    var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                    var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
                    if (adjustment) {
                      tooltip.css(adjustment);
                    }
                    adjustmentTimeout = null;
                  }, 0, false);

                  // first time through tt element will have the
                  // uib-position-measure class or if the placement
                  // has changed we need to position the arrow.
                  if (tooltip.hasClass('uib-position-measure')) {
                    $position.positionArrow(tooltip, ttPosition.placement);
                    tooltip.removeClass('uib-position-measure');
                  } else if (lastPlacement !== ttPosition.placement) {
                    $position.positionArrow(tooltip, ttPosition.placement);
                  }
                  lastPlacement = ttPosition.placement;

                  positionTimeout = null;
                }, 0, false);
              }
            };

            // Set up the correct scope to allow transclusion later
            ttScope.origScope = scope;

            // By default, the tooltip is not open.
            // TODO add ability to start tooltip opened
            ttScope.isOpen = false;

            function toggleTooltipBind() {
              if (!ttScope.isOpen) {
                showTooltipBind();
              } else {
                hideTooltipBind();
              }
            }

            // Show the tooltip with delay if specified, otherwise show it immediately
            function showTooltipBind() {
              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                return;
              }

              cancelHide();
              prepareTooltip();

              if (ttScope.popupDelay) {
                // Do nothing if the tooltip was already scheduled to pop-up.
                // This happens if show is triggered multiple times before any hide is triggered.
                if (!showTimeout) {
                  showTimeout = $timeout(show, ttScope.popupDelay, false);
                }
              } else {
                show();
              }
            }

            function hideTooltipBind() {
              cancelShow();

              if (ttScope.popupCloseDelay) {
                if (!hideTimeout) {
                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
                }
              } else {
                hide();
              }
            }

            // Show the tooltip popup element.
            function show() {
              cancelShow();
              cancelHide();

              // Don't show empty tooltips.
              if (!ttScope.content) {
                return angular.noop;
              }

              createTooltip();

              // And show the tooltip.
              ttScope.$evalAsync(function() {
                ttScope.isOpen = true;
                assignIsOpen(true);
                positionTooltip();
              });
            }

            function cancelShow() {
              if (showTimeout) {
                $timeout.cancel(showTimeout);
                showTimeout = null;
              }

              if (positionTimeout) {
                $timeout.cancel(positionTimeout);
                positionTimeout = null;
              }
            }

            // Hide the tooltip popup element.
            function hide() {
              if (!ttScope) {
                return;
              }

              // First things first: we don't show it anymore.
              ttScope.$evalAsync(function() {
                if (ttScope) {
                  ttScope.isOpen = false;
                  assignIsOpen(false);
                  // And now we remove it from the DOM. However, if we have animation, we
                  // need to wait for it to expire beforehand.
                  // FIXME: this is a placeholder for a port of the transitions library.
                  // The fade transition in TWBS is 150ms.
                  if (ttScope.animation) {
                    if (!transitionTimeout) {
                      transitionTimeout = $timeout(removeTooltip, 150, false);
                    }
                  } else {
                    removeTooltip();
                  }
                }
              });
            }

            function cancelHide() {
              if (hideTimeout) {
                $timeout.cancel(hideTimeout);
                hideTimeout = null;
              }

              if (transitionTimeout) {
                $timeout.cancel(transitionTimeout);
                transitionTimeout = null;
              }
            }

            function createTooltip() {
              // There can only be one tooltip element per directive shown at once.
              if (tooltip) {
                return;
              }

              tooltipLinkedScope = ttScope.$new();
              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
                if (appendToBody) {
                  $document.find('body').append(tooltip);
                } else {
                  element.after(tooltip);
                }
              });

              openedTooltips.add(ttScope, {
                close: hide
              });

              prepObservers();
            }

            function removeTooltip() {
              cancelShow();
              cancelHide();
              unregisterObservers();

              if (tooltip) {
                tooltip.remove();
                
                tooltip = null;
                if (adjustmentTimeout) {
                  $timeout.cancel(adjustmentTimeout);
                }
              }

              openedTooltips.remove(ttScope);
              
              if (tooltipLinkedScope) {
                tooltipLinkedScope.$destroy();
                tooltipLinkedScope = null;
              }
            }

            /**
             * Set the initial scope values. Once
             * the tooltip is created, the observers
             * will be added to keep things in sync.
             */
            function prepareTooltip() {
              ttScope.title = attrs[prefix + 'Title'];
              if (contentParse) {
                ttScope.content = contentParse(scope);
              } else {
                ttScope.content = attrs[ttType];
              }

              ttScope.popupClass = attrs[prefix + 'Class'];
              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
              var placement = $position.parsePlacement(ttScope.placement);
              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];

              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
            }

            function assignIsOpen(isOpen) {
              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
                isOpenParse.assign(scope, isOpen);
              }
            }

            ttScope.contentExp = function() {
              return ttScope.content;
            };

            /**
             * Observe the relevant attributes.
             */
            attrs.$observe('disabled', function(val) {
              if (val) {
                cancelShow();
              }

              if (val && ttScope.isOpen) {
                hide();
              }
            });

            if (isOpenParse) {
              scope.$watch(isOpenParse, function(val) {
                if (ttScope && !val === ttScope.isOpen) {
                  toggleTooltipBind();
                }
              });
            }

            function prepObservers() {
              observers.length = 0;

              if (contentParse) {
                observers.push(
                  scope.$watch(contentParse, function(val) {
                    ttScope.content = val;
                    if (!val && ttScope.isOpen) {
                      hide();
                    }
                  })
                );

                observers.push(
                  tooltipLinkedScope.$watch(function() {
                    if (!repositionScheduled) {
                      repositionScheduled = true;
                      tooltipLinkedScope.$$postDigest(function() {
                        repositionScheduled = false;
                        if (ttScope && ttScope.isOpen) {
                          positionTooltip();
                        }
                      });
                    }
                  })
                );
              } else {
                observers.push(
                  attrs.$observe(ttType, function(val) {
                    ttScope.content = val;
                    if (!val && ttScope.isOpen) {
                      hide();
                    } else {
                      positionTooltip();
                    }
                  })
                );
              }

              observers.push(
                attrs.$observe(prefix + 'Title', function(val) {
                  ttScope.title = val;
                  if (ttScope.isOpen) {
                    positionTooltip();
                  }
                })
              );

              observers.push(
                attrs.$observe(prefix + 'Placement', function(val) {
                  ttScope.placement = val ? val : options.placement;
                  if (ttScope.isOpen) {
                    positionTooltip();
                  }
                })
              );
            }

            function unregisterObservers() {
              if (observers.length) {
                angular.forEach(observers, function(observer) {
                  observer();
                });
                observers.length = 0;
              }
            }

            // hide tooltips/popovers for outsideClick trigger
            function bodyHideTooltipBind(e) {
              if (!ttScope || !ttScope.isOpen || !tooltip) {
                return;
              }
              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
                hideTooltipBind();
              }
            }

            // KeyboardEvent handler to hide the tooltip on Escape key press
            function hideOnEscapeKey(e) {
              if (e.which === 27) {
                hideTooltipBind();
              }
            }

            var unregisterTriggers = function() {
              triggers.show.forEach(function(trigger) {
                if (trigger === 'outsideClick') {
                  element.off('click', toggleTooltipBind);
                } else {
                  element.off(trigger, showTooltipBind);
                  element.off(trigger, toggleTooltipBind);
                }
                element.off('keypress', hideOnEscapeKey);
              });
              triggers.hide.forEach(function(trigger) {
                if (trigger === 'outsideClick') {
                  $document.off('click', bodyHideTooltipBind);
                } else {
                  element.off(trigger, hideTooltipBind);
                }
              });
            };

            function prepTriggers() {
              var showTriggers = [], hideTriggers = [];
              var val = scope.$eval(attrs[prefix + 'Trigger']);
              unregisterTriggers();

              if (angular.isObject(val)) {
                Object.keys(val).forEach(function(key) {
                  showTriggers.push(key);
                  hideTriggers.push(val[key]);
                });
                triggers = {
                  show: showTriggers,
                  hide: hideTriggers
                };
              } else {
                triggers = getTriggers(val);
              }

              if (triggers.show !== 'none') {
                triggers.show.forEach(function(trigger, idx) {
                  if (trigger === 'outsideClick') {
                    element.on('click', toggleTooltipBind);
                    $document.on('click', bodyHideTooltipBind);
                  } else if (trigger === triggers.hide[idx]) {
                    element.on(trigger, toggleTooltipBind);
                  } else if (trigger) {
                    element.on(trigger, showTooltipBind);
                    element.on(triggers.hide[idx], hideTooltipBind);
                  }
                  element.on('keypress', hideOnEscapeKey);
                });
              }
            }

            prepTriggers();

            var animation = scope.$eval(attrs[prefix + 'Animation']);
            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;

            var appendToBodyVal;
            var appendKey = prefix + 'AppendToBody';
            if (appendKey in attrs && attrs[appendKey] === undefined) {
              appendToBodyVal = true;
            } else {
              appendToBodyVal = scope.$eval(attrs[appendKey]);
            }

            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

            // Make sure tooltip is destroyed and removed.
            scope.$on('$destroy', function onDestroyTooltip() {
              unregisterTriggers();
              removeTooltip();
              ttScope = null;
            });
          };
        }
      };
    };
  }];
})

// This is mostly ngInclude code but with a custom scope
.directive('uibTooltipTemplateTransclude', [
         '$animate', '$sce', '$compile', '$templateRequest',
function ($animate, $sce, $compile, $templateRequest) {
  return {
    link: function(scope, elem, attrs) {
      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);

      var changeCounter = 0,
        currentScope,
        previousElement,
        currentElement;

      var cleanupLastIncludeContent = function() {
        if (previousElement) {
          previousElement.remove();
          previousElement = null;
        }

        if (currentScope) {
          currentScope.$destroy();
          currentScope = null;
        }

        if (currentElement) {
          $animate.leave(currentElement).then(function() {
            previousElement = null;
          });
          previousElement = currentElement;
          currentElement = null;
        }
      };

      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function(src) {
        var thisChangeId = ++changeCounter;

        if (src) {
          //set the 2nd param to true to ignore the template request error so that the inner
          //contents and scope can be cleaned up.
          $templateRequest(src, true).then(function(response) {
            if (thisChangeId !== changeCounter) { return; }
            var newScope = origScope.$new();
            var template = response;

            var clone = $compile(template)(newScope, function(clone) {
              cleanupLastIncludeContent();
              $animate.enter(clone, elem);
            });

            currentScope = newScope;
            currentElement = clone;

            currentScope.$emit('$includeContentLoaded', src);
          }, function() {
            if (thisChangeId === changeCounter) {
              cleanupLastIncludeContent();
              scope.$emit('$includeContentError', src);
            }
          });
          scope.$emit('$includeContentRequested', src);
        } else {
          cleanupLastIncludeContent();
        }
      });

      scope.$on('$destroy', cleanupLastIncludeContent);
    }
  };
}])

/**
 * Note that it's intentional that these classes are *not* applied through $animate.
 * They must not be animated as they're expected to be present on the tooltip on
 * initialization.
 */
.directive('uibTooltipClasses', ['$uibPosition', function($uibPosition) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      // need to set the primary position so the
      // arrow has space during position measure.
      // tooltip.positionTooltip()
      if (scope.placement) {
        // // There are no top-left etc... classes
        // // in TWBS, so we need the primary position.
        var position = $uibPosition.parsePlacement(scope.placement);
        element.addClass(position[0]);
      }

      if (scope.popupClass) {
        element.addClass(scope.popupClass);
      }

      if (scope.animation) {
        element.addClass(attrs.tooltipAnimationClass);
      }
    }
  };
}])

.directive('uibTooltipPopup', function() {
  return {
    restrict: 'A',
    scope: { content: '@' },
    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
  };
})

.directive('uibTooltip', [ '$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
}])

.directive('uibTooltipTemplatePopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&', originScope: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
  };
})

.directive('uibTooltipTemplate', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}])

.directive('uibTooltipHtmlPopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
  };
})

.directive('uibTooltipHtml', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, and selector delegatation.
 */
angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])

.directive('uibPopoverTemplatePopup', function() {
  return {
    restrict: 'A',
    scope: { uibTitle: '@', contentExp: '&', originScope: '&' },
    templateUrl: 'uib/template/popover/popover-template.html'
  };
})

.directive('uibPopoverTemplate', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('uibPopoverHtmlPopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&', uibTitle: '@' },
    templateUrl: 'uib/template/popover/popover-html.html'
  };
})

.directive('uibPopoverHtml', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('uibPopoverPopup', function() {
  return {
    restrict: 'A',
    scope: { uibTitle: '@', content: '@' },
    templateUrl: 'uib/template/popover/popover.html'
  };
})

.directive('uibPopover', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopover', 'popover', 'click');
}]);

angular.module('ui.bootstrap.progressbar', [])

.constant('uibProgressConfig', {
  animate: true,
  max: 100
})

.controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function($scope, $attrs, progressConfig) {
  var self = this,
      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;

  this.bars = [];
  $scope.max = getMaxOrDefault();

  this.addBar = function(bar, element, attrs) {
    if (!animate) {
      element.css({'transition': 'none'});
    }

    this.bars.push(bar);

    bar.max = getMaxOrDefault();
    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';

    bar.$watch('value', function(value) {
      bar.recalculatePercentage();
    });

    bar.recalculatePercentage = function() {
      var totalPercentage = self.bars.reduce(function(total, bar) {
        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
        return total + bar.percent;
      }, 0);

      if (totalPercentage > 100) {
        bar.percent -= totalPercentage - 100;
      }
    };

    bar.$on('$destroy', function() {
      element = null;
      self.removeBar(bar);
    });
  };

  this.removeBar = function(bar) {
    this.bars.splice(this.bars.indexOf(bar), 1);
    this.bars.forEach(function (bar) {
      bar.recalculatePercentage();
    });
  };

  //$attrs.$observe('maxParam', function(maxParam) {
  $scope.$watch('maxParam', function(maxParam) {
    self.bars.forEach(function(bar) {
      bar.max = getMaxOrDefault();
      bar.recalculatePercentage();
    });
  });

  function getMaxOrDefault () {
    return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
  }
}])

.directive('uibProgress', function() {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    require: 'uibProgress',
    scope: {
      maxParam: '=?max'
    },
    templateUrl: 'uib/template/progressbar/progress.html'
  };
})

.directive('uibBar', function() {
  return {
    replace: true,
    transclude: true,
    require: '^uibProgress',
    scope: {
      value: '=',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/bar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, element, attrs);
    }
  };
})

.directive('uibProgressbar', function() {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    scope: {
      value: '=',
      maxParam: '=?max',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/progressbar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, angular.element(element.children()[0]), {title: attrs.title});
    }
  };
});

angular.module('ui.bootstrap.rating', [])

.constant('uibRatingConfig', {
  max: 5,
  stateOn: null,
  stateOff: null,
  enableReset: true,
  titles: ['one', 'two', 'three', 'four', 'five']
})

.controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function($scope, $attrs, ratingConfig) {
  var ngModelCtrl = { $setViewValue: angular.noop },
    self = this;

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.push(function(value) {
      if (angular.isNumber(value) && value << 0 !== value) {
        value = Math.round(value);
      }

      return value;
    });

    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
    this.enableReset = angular.isDefined($attrs.enableReset) ?
      $scope.$parent.$eval($attrs.enableReset) : ratingConfig.enableReset;
    var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
      tmpTitles : ratingConfig.titles;

    var ratingStates = angular.isDefined($attrs.ratingStates) ?
      $scope.$parent.$eval($attrs.ratingStates) :
      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
    $scope.range = this.buildTemplateObjects(ratingStates);
  };

  this.buildTemplateObjects = function(states) {
    for (var i = 0, n = states.length; i < n; i++) {
      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
    }
    return states;
  };

  this.getTitle = function(index) {
    if (index >= this.titles.length) {
      return index + 1;
    }

    return this.titles[index];
  };

  $scope.rate = function(value) {
    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
      var newViewValue = self.enableReset && ngModelCtrl.$viewValue === value ? 0 : value;
      ngModelCtrl.$setViewValue(newViewValue);
      ngModelCtrl.$render();
    }
  };

  $scope.enter = function(value) {
    if (!$scope.readonly) {
      $scope.value = value;
    }
    $scope.onHover({value: value});
  };

  $scope.reset = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.onLeave();
  };

  $scope.onKeydown = function(evt) {
    if (/(37|38|39|40)/.test(evt.which)) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
    }
  };

  this.render = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.title = self.getTitle($scope.value - 1);
  };
}])

.directive('uibRating', function() {
  return {
    require: ['uibRating', 'ngModel'],
    restrict: 'A',
    scope: {
      readonly: '=?readOnly',
      onHover: '&',
      onLeave: '&'
    },
    controller: 'UibRatingController',
    templateUrl: 'uib/template/rating/rating.html',
    link: function(scope, element, attrs, ctrls) {
      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
      ratingCtrl.init(ngModelCtrl);
    }
  };
});

angular.module('ui.bootstrap.tabs', [])

.controller('UibTabsetController', ['$scope', function ($scope) {
  var ctrl = this,
    oldIndex;
  ctrl.tabs = [];

  ctrl.select = function(index, evt) {
    if (!destroyed) {
      var previousIndex = findTabIndex(oldIndex);
      var previousSelected = ctrl.tabs[previousIndex];
      if (previousSelected) {
        previousSelected.tab.onDeselect({
          $event: evt,
          $selectedIndex: index
        });
        if (evt && evt.isDefaultPrevented()) {
          return;
        }
        previousSelected.tab.active = false;
      }

      var selected = ctrl.tabs[index];
      if (selected) {
        selected.tab.onSelect({
          $event: evt
        });
        selected.tab.active = true;
        ctrl.active = selected.index;
        oldIndex = selected.index;
      } else if (!selected && angular.isDefined(oldIndex)) {
        ctrl.active = null;
        oldIndex = null;
      }
    }
  };

  ctrl.addTab = function addTab(tab) {
    ctrl.tabs.push({
      tab: tab,
      index: tab.index
    });
    ctrl.tabs.sort(function(t1, t2) {
      if (t1.index > t2.index) {
        return 1;
      }

      if (t1.index < t2.index) {
        return -1;
      }

      return 0;
    });

    if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
      var newActiveIndex = findTabIndex(tab.index);
      ctrl.select(newActiveIndex);
    }
  };

  ctrl.removeTab = function removeTab(tab) {
    var index;
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].tab === tab) {
        index = i;
        break;
      }
    }

    if (ctrl.tabs[index].index === ctrl.active) {
      var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
        index - 1 : index + 1 % ctrl.tabs.length;
      ctrl.select(newActiveTabIndex);
    }

    ctrl.tabs.splice(index, 1);
  };

  $scope.$watch('tabset.active', function(val) {
    if (angular.isDefined(val) && val !== oldIndex) {
      ctrl.select(findTabIndex(val));
    }
  });

  var destroyed;
  $scope.$on('$destroy', function() {
    destroyed = true;
  });

  function findTabIndex(index) {
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].index === index) {
        return i;
      }
    }
  }
}])

.directive('uibTabset', function() {
  return {
    transclude: true,
    replace: true,
    scope: {},
    bindToController: {
      active: '=?',
      type: '@'
    },
    controller: 'UibTabsetController',
    controllerAs: 'tabset',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/tabs/tabset.html';
    },
    link: function(scope, element, attrs) {
      scope.vertical = angular.isDefined(attrs.vertical) ?
        scope.$parent.$eval(attrs.vertical) : false;
      scope.justified = angular.isDefined(attrs.justified) ?
        scope.$parent.$eval(attrs.justified) : false;
    }
  };
})

.directive('uibTab', ['$parse', function($parse) {
  return {
    require: '^uibTabset',
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/tabs/tab.html';
    },
    transclude: true,
    scope: {
      heading: '@',
      index: '=?',
      classes: '@?',
      onSelect: '&select', //This callback is called in contentHeadingTransclude
                          //once it inserts the tab's content into the dom
      onDeselect: '&deselect'
    },
    controller: function() {
      //Empty controller so other directives can require being 'under' a tab
    },
    controllerAs: 'tab',
    link: function(scope, elm, attrs, tabsetCtrl, transclude) {
      scope.disabled = false;
      if (attrs.disable) {
        scope.$parent.$watch($parse(attrs.disable), function(value) {
          scope.disabled = !! value;
        });
      }

      if (angular.isUndefined(attrs.index)) {
        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function(t) { return t.index; })) + 1;
        } else {
          scope.index = 0;
        }
      }

      if (angular.isUndefined(attrs.classes)) {
        scope.classes = '';
      }

      scope.select = function(evt) {
        if (!scope.disabled) {
          var index;
          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
            if (tabsetCtrl.tabs[i].tab === scope) {
              index = i;
              break;
            }
          }

          tabsetCtrl.select(index, evt);
        }
      };

      tabsetCtrl.addTab(scope);
      scope.$on('$destroy', function() {
        tabsetCtrl.removeTab(scope);
      });

      //We need to transclude later, once the content container is ready.
      //when this link happens, we're inside a tab heading.
      scope.$transcludeFn = transclude;
    }
  };
}])

.directive('uibTabHeadingTransclude', function() {
  return {
    restrict: 'A',
    require: '^uibTab',
    link: function(scope, elm) {
      scope.$watch('headingElement', function updateHeadingElement(heading) {
        if (heading) {
          elm.html('');
          elm.append(heading);
        }
      });
    }
  };
})

.directive('uibTabContentTransclude', function() {
  return {
    restrict: 'A',
    require: '^uibTabset',
    link: function(scope, elm, attrs) {
      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;

      //Now our tab is ready to be transcluded: both the tab heading area
      //and the tab content area are loaded.  Transclude 'em both.
      tab.$transcludeFn(tab.$parent, function(contents) {
        angular.forEach(contents, function(node) {
          if (isTabHeading(node)) {
            //Let tabHeadingTransclude know.
            tab.headingElement = node;
          } else {
            elm.append(node);
          }
        });
      });
    }
  };

  function isTabHeading(node) {
    return node.tagName && (
      node.hasAttribute('uib-tab-heading') ||
      node.hasAttribute('data-uib-tab-heading') ||
      node.hasAttribute('x-uib-tab-heading') ||
      node.tagName.toLowerCase() === 'uib-tab-heading' ||
      node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
      node.tagName.toLowerCase() === 'x-uib-tab-heading' ||
      node.tagName.toLowerCase() === 'uib:tab-heading'
    );
  }
});

angular.module('ui.bootstrap.timepicker', [])

.constant('uibTimepickerConfig', {
  hourStep: 1,
  minuteStep: 1,
  secondStep: 1,
  showMeridian: true,
  showSeconds: false,
  meridians: null,
  readonlyInput: false,
  mousewheel: true,
  arrowkeys: true,
  showSpinners: true,
  templateUrl: 'uib/template/timepicker/timepicker.html'
})

.controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
  var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
  var selected = new Date(),
    watchers = [],
    ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
    meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
    padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;

  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
  $element.removeAttr('tabindex');

  this.init = function(ngModelCtrl_, inputs) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.unshift(function(modelValue) {
      return modelValue ? new Date(modelValue) : null;
    });

    var hoursInputEl = inputs.eq(0),
        minutesInputEl = inputs.eq(1),
        secondsInputEl = inputs.eq(2);

    hoursModelCtrl = hoursInputEl.controller('ngModel');
    minutesModelCtrl = minutesInputEl.controller('ngModel');
    secondsModelCtrl = secondsInputEl.controller('ngModel');

    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;

    if (mousewheel) {
      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
    if (arrowkeys) {
      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
  };

  var hourStep = timepickerConfig.hourStep;
  if ($attrs.hourStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function(value) {
      hourStep = +value;
    }));
  }

  var minuteStep = timepickerConfig.minuteStep;
  if ($attrs.minuteStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
      minuteStep = +value;
    }));
  }

  var min;
  watchers.push($scope.$parent.$watch($parse($attrs.min), function(value) {
    var dt = new Date(value);
    min = isNaN(dt) ? undefined : dt;
  }));

  var max;
  watchers.push($scope.$parent.$watch($parse($attrs.max), function(value) {
    var dt = new Date(value);
    max = isNaN(dt) ? undefined : dt;
  }));

  var disabled = false;
  if ($attrs.ngDisabled) {
    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(value) {
      disabled = value;
    }));
  }

  $scope.noIncrementHours = function() {
    var incrementedSelected = addMinutes(selected, hourStep * 60);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementHours = function() {
    var decrementedSelected = addMinutes(selected, -hourStep * 60);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementMinutes = function() {
    var incrementedSelected = addMinutes(selected, minuteStep);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementMinutes = function() {
    var decrementedSelected = addMinutes(selected, -minuteStep);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementSeconds = function() {
    var incrementedSelected = addSeconds(selected, secondStep);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementSeconds = function() {
    var decrementedSelected = addSeconds(selected, -secondStep);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noToggleMeridian = function() {
    if (selected.getHours() < 12) {
      return disabled || addMinutes(selected, 12 * 60) > max;
    }

    return disabled || addMinutes(selected, -12 * 60) < min;
  };

  var secondStep = timepickerConfig.secondStep;
  if ($attrs.secondStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function(value) {
      secondStep = +value;
    }));
  }

  $scope.showSeconds = timepickerConfig.showSeconds;
  if ($attrs.showSeconds) {
    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function(value) {
      $scope.showSeconds = !!value;
    }));
  }

  // 12H / 24H mode
  $scope.showMeridian = timepickerConfig.showMeridian;
  if ($attrs.showMeridian) {
    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
      $scope.showMeridian = !!value;

      if (ngModelCtrl.$error.time) {
        // Evaluate from template
        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
          selected.setHours(hours);
          refresh();
        }
      } else {
        updateTemplate();
      }
    }));
  }

  // Get $scope.hours in 24H mode if valid
  function getHoursFromTemplate() {
    var hours = +$scope.hours;
    var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
      hours >= 0 && hours < 24;
    if (!valid || $scope.hours === '') {
      return undefined;
    }

    if ($scope.showMeridian) {
      if (hours === 12) {
        hours = 0;
      }
      if ($scope.meridian === meridians[1]) {
        hours = hours + 12;
      }
    }
    return hours;
  }

  function getMinutesFromTemplate() {
    var minutes = +$scope.minutes;
    var valid = minutes >= 0 && minutes < 60;
    if (!valid || $scope.minutes === '') {
      return undefined;
    }
    return minutes;
  }

  function getSecondsFromTemplate() {
    var seconds = +$scope.seconds;
    return seconds >= 0 && seconds < 60 ? seconds : undefined;
  }

  function pad(value, noPad) {
    if (value === null) {
      return '';
    }

    return angular.isDefined(value) && value.toString().length < 2 && !noPad ?
      '0' + value : value.toString();
  }

  // Respond on mousewheel spin
  this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    var isScrollingUp = function(e) {
      if (e.originalEvent) {
        e = e.originalEvent;
      }
      //pick correct delta variable depending on event
      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
      return e.detail || delta > 0;
    };

    hoursInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
      }
      e.preventDefault();
    });

    minutesInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
      }
      e.preventDefault();
    });

     secondsInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
      }
      e.preventDefault();
    });
  };

  // Respond on up/down arrowkeys
  this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    hoursInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementHours();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementHours();
          $scope.$apply();
        }
      }
    });

    minutesInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementMinutes();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementMinutes();
          $scope.$apply();
        }
      }
    });

    secondsInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementSeconds();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementSeconds();
          $scope.$apply();
        }
      }
    });
  };

  this.setupInputEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    if ($scope.readonlyInput) {
      $scope.updateHours = angular.noop;
      $scope.updateMinutes = angular.noop;
      $scope.updateSeconds = angular.noop;
      return;
    }

    var invalidate = function(invalidHours, invalidMinutes, invalidSeconds) {
      ngModelCtrl.$setViewValue(null);
      ngModelCtrl.$setValidity('time', false);
      if (angular.isDefined(invalidHours)) {
        $scope.invalidHours = invalidHours;
        if (hoursModelCtrl) {
          hoursModelCtrl.$setValidity('hours', false);
        }
      }

      if (angular.isDefined(invalidMinutes)) {
        $scope.invalidMinutes = invalidMinutes;
        if (minutesModelCtrl) {
          minutesModelCtrl.$setValidity('minutes', false);
        }
      }

      if (angular.isDefined(invalidSeconds)) {
        $scope.invalidSeconds = invalidSeconds;
        if (secondsModelCtrl) {
          secondsModelCtrl.$setValidity('seconds', false);
        }
      }
    };

    $scope.updateHours = function() {
      var hours = getHoursFromTemplate(),
        minutes = getMinutesFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(true);
        } else {
          refresh('h');
        }
      } else {
        invalidate(true);
      }
    };

    hoursInputEl.on('blur', function(e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.hours === null || $scope.hours === '') {
        invalidate(true);
      } else if (!$scope.invalidHours && $scope.hours < 10) {
        $scope.$apply(function() {
          $scope.hours = pad($scope.hours, !padHours);
        });
      }
    });

    $scope.updateMinutes = function() {
      var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(undefined, true);
        } else {
          refresh('m');
        }
      } else {
        invalidate(undefined, true);
      }
    };

    minutesInputEl.on('blur', function(e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.minutes === null) {
        invalidate(undefined, true);
      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
        $scope.$apply(function() {
          $scope.minutes = pad($scope.minutes);
        });
      }
    });

    $scope.updateSeconds = function() {
      var seconds = getSecondsFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(seconds)) {
        selected.setSeconds(seconds);
        refresh('s');
      } else {
        invalidate(undefined, undefined, true);
      }
    };

    secondsInputEl.on('blur', function(e) {
      if (modelIsEmpty()) {
        makeValid();
      } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
        $scope.$apply( function() {
          $scope.seconds = pad($scope.seconds);
        });
      }
    });

  };

  this.render = function() {
    var date = ngModelCtrl.$viewValue;

    if (isNaN(date)) {
      ngModelCtrl.$setValidity('time', false);
      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
    } else {
      if (date) {
        selected = date;
      }

      if (selected < min || selected > max) {
        ngModelCtrl.$setValidity('time', false);
        $scope.invalidHours = true;
        $scope.invalidMinutes = true;
      } else {
        makeValid();
      }
      updateTemplate();
    }
  };

  // Call internally when we know that model is valid.
  function refresh(keyboardChange) {
    makeValid();
    ngModelCtrl.$setViewValue(new Date(selected));
    updateTemplate(keyboardChange);
  }

  function makeValid() {
    if (hoursModelCtrl) {
      hoursModelCtrl.$setValidity('hours', true);
    }

    if (minutesModelCtrl) {
      minutesModelCtrl.$setValidity('minutes', true);
    }

    if (secondsModelCtrl) {
      secondsModelCtrl.$setValidity('seconds', true);
    }

    ngModelCtrl.$setValidity('time', true);
    $scope.invalidHours = false;
    $scope.invalidMinutes = false;
    $scope.invalidSeconds = false;
  }

  function updateTemplate(keyboardChange) {
    if (!ngModelCtrl.$modelValue) {
      $scope.hours = null;
      $scope.minutes = null;
      $scope.seconds = null;
      $scope.meridian = meridians[0];
    } else {
      var hours = selected.getHours(),
        minutes = selected.getMinutes(),
        seconds = selected.getSeconds();

      if ($scope.showMeridian) {
        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
      }

      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
      if (keyboardChange !== 'm') {
        $scope.minutes = pad(minutes);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];

      if (keyboardChange !== 's') {
        $scope.seconds = pad(seconds);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
    }
  }

  function addSecondsToSelected(seconds) {
    selected = addSeconds(selected, seconds);
    refresh();
  }

  function addMinutes(selected, minutes) {
    return addSeconds(selected, minutes*60);
  }

  function addSeconds(date, seconds) {
    var dt = new Date(date.getTime() + seconds * 1000);
    var newDate = new Date(date);
    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
    return newDate;
  }

  function modelIsEmpty() {
    return ($scope.hours === null || $scope.hours === '') &&
      ($scope.minutes === null || $scope.minutes === '') &&
      (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
  }

  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
    $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;

  $scope.incrementHours = function() {
    if (!$scope.noIncrementHours()) {
      addSecondsToSelected(hourStep * 60 * 60);
    }
  };

  $scope.decrementHours = function() {
    if (!$scope.noDecrementHours()) {
      addSecondsToSelected(-hourStep * 60 * 60);
    }
  };

  $scope.incrementMinutes = function() {
    if (!$scope.noIncrementMinutes()) {
      addSecondsToSelected(minuteStep * 60);
    }
  };

  $scope.decrementMinutes = function() {
    if (!$scope.noDecrementMinutes()) {
      addSecondsToSelected(-minuteStep * 60);
    }
  };

  $scope.incrementSeconds = function() {
    if (!$scope.noIncrementSeconds()) {
      addSecondsToSelected(secondStep);
    }
  };

  $scope.decrementSeconds = function() {
    if (!$scope.noDecrementSeconds()) {
      addSecondsToSelected(-secondStep);
    }
  };

  $scope.toggleMeridian = function() {
    var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

    if (!$scope.noToggleMeridian()) {
      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
      } else {
        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
      }
    }
  };

  $scope.blur = function() {
    ngModelCtrl.$setTouched();
  };

  $scope.$on('$destroy', function() {
    while (watchers.length) {
      watchers.shift()();
    }
  });
}])

.directive('uibTimepicker', ['uibTimepickerConfig', function(uibTimepickerConfig) {
  return {
    require: ['uibTimepicker', '?^ngModel'],
    restrict: 'A',
    controller: 'UibTimepickerController',
    controllerAs: 'timepicker',
    scope: {},
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
    },
    link: function(scope, element, attrs, ctrls) {
      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (ngModelCtrl) {
        timepickerCtrl.init(ngModelCtrl, element.find('input'));
      }
    }
  };
}]);

angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
  .factory('uibTypeaheadParser', ['$parse', function($parse) {
    //                      000001111111100000000000002222222200000000000000003333333333333330000000000044444444000
    var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
    return {
      parse: function(input) {
        var match = input.match(TYPEAHEAD_REGEXP);
        if (!match) {
          throw new Error(
            'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
              ' but got "' + input + '".');
        }

        return {
          itemName: match[3],
          source: $parse(match[4]),
          viewMapper: $parse(match[2] || match[1]),
          modelMapper: $parse(match[1])
        };
      }
    };
  }])

  .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
    function(originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
    var HOT_KEYS = [9, 13, 27, 38, 40];
    var eventDebounceTime = 200;
    var modelCtrl, ngModelOptions;
    //SUPPORTED ATTRIBUTES (OPTIONS)

    //minimal no of characters that needs to be entered before typeahead kicks-in
    var minLength = originalScope.$eval(attrs.typeaheadMinLength);
    if (!minLength && minLength !== 0) {
      minLength = 1;
    }

    originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
        minLength = !newVal && newVal !== 0 ? 1 : newVal;
    });

    //minimal wait time after last character typed before typeahead kicks-in
    var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

    //should it restrict model values to the ones selected from the popup only?
    var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
    originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
      isEditable = newVal !== false;
    });

    //binding to a variable that indicates if matches are being retrieved asynchronously
    var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

    //a function to determine if an event should cause selection
    var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function(scope, vals) {
      var evt = vals.$event;
      return evt.which === 13 || evt.which === 9;
    };

    //a callback executed when a match is selected
    var onSelectCallback = $parse(attrs.typeaheadOnSelect);

    //should it select highlighted popup value when losing focus?
    var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

    //binding to a variable that indicates if there were no results after the query is completed
    var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

    var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

    var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

    var appendTo = attrs.typeaheadAppendTo ?
      originalScope.$eval(attrs.typeaheadAppendTo) : null;

    var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

    //If input matches an item of the list exactly, select it automatically
    var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

    //binding to a variable that indicates if dropdown is open
    var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;

    var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

    //INTERNAL VARIABLES

    //model setter executed upon match selection
    var parsedModel = $parse(attrs.ngModel);
    var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
    var $setModelValue = function(scope, newValue) {
      if (angular.isFunction(parsedModel(originalScope)) &&
        ngModelOptions.getOption('getterSetter')) {
        return invokeModelSetter(scope, {$$$p: newValue});
      }

      return parsedModel.assign(scope, newValue);
    };

    //expressions used by typeahead
    var parserResult = typeaheadParser.parse(attrs.uibTypeahead);

    var hasFocus;

    //Used to avoid bug in iOS webview where iOS keyboard does not fire
    //mousedown & mouseup events
    //Issue #3699
    var selected;

    //create a child scope for the typeahead directive so we are not polluting original scope
    //with typeahead-specific data (matches, query etc.)
    var scope = originalScope.$new();
    var offDestroy = originalScope.$on('$destroy', function() {
      scope.$destroy();
    });
    scope.$on('$destroy', offDestroy);

    // WAI-ARIA
    var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
    element.attr({
      'aria-autocomplete': 'list',
      'aria-expanded': false,
      'aria-owns': popupId
    });

    var inputsContainer, hintInputElem;
    //add read-only input to show hint
    if (showHint) {
      inputsContainer = angular.element('<div></div>');
      inputsContainer.css('position', 'relative');
      element.after(inputsContainer);
      hintInputElem = element.clone();
      hintInputElem.attr('placeholder', '');
      hintInputElem.attr('tabindex', '-1');
      hintInputElem.val('');
      hintInputElem.css({
        'position': 'absolute',
        'top': '0px',
        'left': '0px',
        'border-color': 'transparent',
        'box-shadow': 'none',
        'opacity': 1,
        'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
        'color': '#999'
      });
      element.css({
        'position': 'relative',
        'vertical-align': 'top',
        'background-color': 'transparent'
      });

      if (hintInputElem.attr('id')) {
        hintInputElem.removeAttr('id'); // remove duplicate id if present.
      }
      inputsContainer.append(hintInputElem);
      hintInputElem.after(element);
    }

    //pop-up element used to display matches
    var popUpEl = angular.element('<div uib-typeahead-popup></div>');
    popUpEl.attr({
      id: popupId,
      matches: 'matches',
      active: 'activeIdx',
      select: 'select(activeIdx, evt)',
      'move-in-progress': 'moveInProgress',
      query: 'query',
      position: 'position',
      'assign-is-open': 'assignIsOpen(isOpen)',
      debounce: 'debounceUpdate'
    });
    //custom item template
    if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
      popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
    }

    if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
      popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
    }

    var resetHint = function() {
      if (showHint) {
        hintInputElem.val('');
      }
    };

    var resetMatches = function() {
      scope.matches = [];
      scope.activeIdx = -1;
      element.attr('aria-expanded', false);
      resetHint();
    };

    var getMatchId = function(index) {
      return popupId + '-option-' + index;
    };

    // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
    // This attribute is added or removed automatically when the `activeIdx` changes.
    scope.$watch('activeIdx', function(index) {
      if (index < 0) {
        element.removeAttr('aria-activedescendant');
      } else {
        element.attr('aria-activedescendant', getMatchId(index));
      }
    });

    var inputIsExactMatch = function(inputValue, index) {
      if (scope.matches.length > index && inputValue) {
        return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
      }

      return false;
    };

    var getMatchesAsync = function(inputValue, evt) {
      var locals = {$viewValue: inputValue};
      isLoadingSetter(originalScope, true);
      isNoResultsSetter(originalScope, false);
      $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
        //it might happen that several async queries were in progress if a user were typing fast
        //but we are interested only in responses that correspond to the current view value
        var onCurrentRequest = inputValue === modelCtrl.$viewValue;
        if (onCurrentRequest && hasFocus) {
          if (matches && matches.length > 0) {
            scope.activeIdx = focusFirst ? 0 : -1;
            isNoResultsSetter(originalScope, false);
            scope.matches.length = 0;

            //transform labels
            for (var i = 0; i < matches.length; i++) {
              locals[parserResult.itemName] = matches[i];
              scope.matches.push({
                id: getMatchId(i),
                label: parserResult.viewMapper(scope, locals),
                model: matches[i]
              });
            }

            scope.query = inputValue;
            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
            //due to other elements being rendered
            recalculatePosition();

            element.attr('aria-expanded', true);

            //Select the single remaining option if user input matches
            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                $$debounce(function() {
                  scope.select(0, evt);
                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
              } else {
                scope.select(0, evt);
              }
            }

            if (showHint) {
              var firstLabel = scope.matches[0].label;
              if (angular.isString(inputValue) &&
                inputValue.length > 0 &&
                firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
                hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
              } else {
                hintInputElem.val('');
              }
            }
          } else {
            resetMatches();
            isNoResultsSetter(originalScope, true);
          }
        }
        if (onCurrentRequest) {
          isLoadingSetter(originalScope, false);
        }
      }, function() {
        resetMatches();
        isLoadingSetter(originalScope, false);
        isNoResultsSetter(originalScope, true);
      });
    };

    // bind events only if appendToBody params exist - performance feature
    if (appendToBody) {
      angular.element($window).on('resize', fireRecalculating);
      $document.find('body').on('scroll', fireRecalculating);
    }

    // Declare the debounced function outside recalculating for
    // proper debouncing
    var debouncedRecalculate = $$debounce(function() {
      // if popup is visible
      if (scope.matches.length) {
        recalculatePosition();
      }

      scope.moveInProgress = false;
    }, eventDebounceTime);

    // Default progress type
    scope.moveInProgress = false;

    function fireRecalculating() {
      if (!scope.moveInProgress) {
        scope.moveInProgress = true;
        scope.$digest();
      }

      debouncedRecalculate();
    }

    // recalculate actual position and set new values to scope
    // after digest loop is popup in right position
    function recalculatePosition() {
      scope.position = appendToBody ? $position.offset(element) : $position.position(element);
      scope.position.top += element.prop('offsetHeight');
    }

    //we need to propagate user's query so we can higlight matches
    scope.query = undefined;

    //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
    var timeoutPromise;

    var scheduleSearchWithTimeout = function(inputValue) {
      timeoutPromise = $timeout(function() {
        getMatchesAsync(inputValue);
      }, waitTime);
    };

    var cancelPreviousTimeout = function() {
      if (timeoutPromise) {
        $timeout.cancel(timeoutPromise);
      }
    };

    resetMatches();

    scope.assignIsOpen = function (isOpen) {
      isOpenSetter(originalScope, isOpen);
    };

    scope.select = function(activeIdx, evt) {
      //called from within the $digest() cycle
      var locals = {};
      var model, item;

      selected = true;
      locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
      model = parserResult.modelMapper(originalScope, locals);
      $setModelValue(originalScope, model);
      modelCtrl.$setValidity('editable', true);
      modelCtrl.$setValidity('parse', true);

      onSelectCallback(originalScope, {
        $item: item,
        $model: model,
        $label: parserResult.viewMapper(originalScope, locals),
        $event: evt
      });

      resetMatches();

      //return focus to the input element if a match was selected via a mouse click event
      // use timeout to avoid $rootScope:inprog error
      if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
        $timeout(function() { element[0].focus(); }, 0, false);
      }
    };

    //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
    element.on('keydown', function(evt) {
      //typeahead is open and an "interesting" key was pressed
      if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
        return;
      }

      var shouldSelect = isSelectEvent(originalScope, {$event: evt});

      /**
       * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
       * or
       * shift + tab is pressed to bring focus to the previous element
       * then clear the results
       */
      if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {
        resetMatches();
        scope.$digest();
        return;
      }

      evt.preventDefault();
      var target;
      switch (evt.which) {
        case 27: // escape
          evt.stopPropagation();

          resetMatches();
          originalScope.$digest();
          break;
        case 38: // up arrow
          scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
          scope.$digest();
          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
          target.parentNode.scrollTop = target.offsetTop;
          break;
        case 40: // down arrow
          scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
          scope.$digest();
          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
          target.parentNode.scrollTop = target.offsetTop;
          break;
        default:
          if (shouldSelect) {
            scope.$apply(function() {
              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                $$debounce(function() {
                  scope.select(scope.activeIdx, evt);
                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
              } else {
                scope.select(scope.activeIdx, evt);
              }
            });
          }
      }
    });

    element.on('focus', function (evt) {
      hasFocus = true;
      if (minLength === 0 && !modelCtrl.$viewValue) {
        $timeout(function() {
          getMatchesAsync(modelCtrl.$viewValue, evt);
        }, 0);
      }
    });

    element.on('blur', function(evt) {
      if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
        selected = true;
        scope.$apply(function() {
          if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
            $$debounce(function() {
              scope.select(scope.activeIdx, evt);
            }, scope.debounceUpdate.blur);
          } else {
            scope.select(scope.activeIdx, evt);
          }
        });
      }
      if (!isEditable && modelCtrl.$error.editable) {
        modelCtrl.$setViewValue();
        scope.$apply(function() {
          // Reset validity as we are clearing
          modelCtrl.$setValidity('editable', true);
          modelCtrl.$setValidity('parse', true);
        });
        element.val('');
      }
      hasFocus = false;
      selected = false;
    });

    // Keep reference to click handler to unbind it.
    var dismissClickHandler = function(evt) {
      // Issue #3973
      // Firefox treats right click as a click on document
      if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
        resetMatches();
        if (!$rootScope.$$phase) {
          originalScope.$digest();
        }
      }
    };

    $document.on('click', dismissClickHandler);

    originalScope.$on('$destroy', function() {
      $document.off('click', dismissClickHandler);
      if (appendToBody || appendTo) {
        $popup.remove();
      }

      if (appendToBody) {
        angular.element($window).off('resize', fireRecalculating);
        $document.find('body').off('scroll', fireRecalculating);
      }
      // Prevent jQuery cache memory leak
      popUpEl.remove();

      if (showHint) {
          inputsContainer.remove();
      }
    });

    var $popup = $compile(popUpEl)(scope);

    if (appendToBody) {
      $document.find('body').append($popup);
    } else if (appendTo) {
      angular.element(appendTo).eq(0).append($popup);
    } else {
      element.after($popup);
    }

    this.init = function(_modelCtrl) {
      modelCtrl = _modelCtrl;
      ngModelOptions = extractOptions(modelCtrl);

      scope.debounceUpdate = $parse(ngModelOptions.getOption('debounce'))(originalScope);

      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
      modelCtrl.$parsers.unshift(function(inputValue) {
        hasFocus = true;

        if (minLength === 0 || inputValue && inputValue.length >= minLength) {
          if (waitTime > 0) {
            cancelPreviousTimeout();
            scheduleSearchWithTimeout(inputValue);
          } else {
            getMatchesAsync(inputValue);
          }
        } else {
          isLoadingSetter(originalScope, false);
          cancelPreviousTimeout();
          resetMatches();
        }

        if (isEditable) {
          return inputValue;
        }

        if (!inputValue) {
          // Reset in case user had typed something previously.
          modelCtrl.$setValidity('editable', true);
          return null;
        }

        modelCtrl.$setValidity('editable', false);
        return undefined;
      });

      modelCtrl.$formatters.push(function(modelValue) {
        var candidateViewValue, emptyViewValue;
        var locals = {};

        // The validity may be set to false via $parsers (see above) if
        // the model is restricted to selected values. If the model
        // is set manually it is considered to be valid.
        if (!isEditable) {
          modelCtrl.$setValidity('editable', true);
        }

        if (inputFormatter) {
          locals.$model = modelValue;
          return inputFormatter(originalScope, locals);
        }

        //it might happen that we don't have enough info to properly render input value
        //we need to check for this situation and simply return model value if we can't apply custom formatting
        locals[parserResult.itemName] = modelValue;
        candidateViewValue = parserResult.viewMapper(originalScope, locals);
        locals[parserResult.itemName] = undefined;
        emptyViewValue = parserResult.viewMapper(originalScope, locals);

        return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
      });
    };

    function extractOptions(ngModelCtrl) {
      var ngModelOptions;

      if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
        // guarantee a value
        ngModelOptions = ngModelCtrl.$options || {};

        // mimic 1.6+ api
        ngModelOptions.getOption = function (key) {
          return ngModelOptions[key];
        };
      } else { // in angular >=1.6 $options is always present
        ngModelOptions = ngModelCtrl.$options;
      }

      return ngModelOptions;
    }
  }])

  .directive('uibTypeahead', function() {
    return {
      controller: 'UibTypeaheadController',
      require: ['ngModel', 'uibTypeahead'],
      link: function(originalScope, element, attrs, ctrls) {
        ctrls[1].init(ctrls[0]);
      }
    };
  })

  .directive('uibTypeaheadPopup', ['$$debounce', function($$debounce) {
    return {
      scope: {
        matches: '=',
        query: '=',
        active: '=',
        position: '&',
        moveInProgress: '=',
        select: '&',
        assignIsOpen: '&',
        debounce: '&'
      },
      replace: true,
      templateUrl: function(element, attrs) {
        return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
      },
      link: function(scope, element, attrs) {
        scope.templateUrl = attrs.templateUrl;

        scope.isOpen = function() {
          var isDropdownOpen = scope.matches.length > 0;
          scope.assignIsOpen({ isOpen: isDropdownOpen });
          return isDropdownOpen;
        };

        scope.isActive = function(matchIdx) {
          return scope.active === matchIdx;
        };

        scope.selectActive = function(matchIdx) {
          scope.active = matchIdx;
        };

        scope.selectMatch = function(activeIdx, evt) {
          var debounce = scope.debounce();
          if (angular.isNumber(debounce) || angular.isObject(debounce)) {
            $$debounce(function() {
              scope.select({activeIdx: activeIdx, evt: evt});
            }, angular.isNumber(debounce) ? debounce : debounce['default']);
          } else {
            scope.select({activeIdx: activeIdx, evt: evt});
          }
        };
      }
    };
  }])

  .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
    return {
      scope: {
        index: '=',
        match: '=',
        query: '='
      },
      link: function(scope, element, attrs) {
        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
        $templateRequest(tplUrl).then(function(tplContent) {
          var tplEl = angular.element(tplContent.trim());
          element.replaceWith(tplEl);
          $compile(tplEl)(scope);
        });
      }
    };
  }])

  .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
    var isSanitizePresent;
    isSanitizePresent = $injector.has('$sanitize');

    function escapeRegexp(queryToEscape) {
      // Regex: capture the whole query string and replace it with the string that will be used to match
      // the results, for example if the capture is "a" the result will be \a
      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }

    function containsHtml(matchItem) {
      return /<.*>/g.test(matchItem);
    }

    return function(matchItem, query) {
      if (!isSanitizePresent && containsHtml(matchItem)) {
        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
      }
      matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
      if (!isSanitizePresent) {
        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
      }
      return matchItem;
    };
  }]);

angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/accordion/accordion-group.html",
    "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
    "  <h4 class=\"panel-title\">\n" +
    "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
    "  </h4>\n" +
    "</div>\n" +
    "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
    "  <div class=\"panel-body\" ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/accordion/accordion.html",
    "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
}]);

angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/alert/alert.html",
    "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
    "  <span aria-hidden=\"true\">&times;</span>\n" +
    "  <span class=\"sr-only\">Close</span>\n" +
    "</button>\n" +
    "<div ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/carousel/carousel.html",
    "<div class=\"carousel-inner\" ng-transclude></div>\n" +
    "<a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-class=\"{ disabled: isPrevDisabled() }\" ng-show=\"slides.length > 1\">\n" +
    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
    "  <span class=\"sr-only\">previous</span>\n" +
    "</a>\n" +
    "<a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-class=\"{ disabled: isNextDisabled() }\" ng-show=\"slides.length > 1\">\n" +
    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
    "  <span class=\"sr-only\">next</span>\n" +
    "</a>\n" +
    "<ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
    "  <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
    "    <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
    "  </li>\n" +
    "</ol>\n" +
    "");
}]);

angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/carousel/slide.html",
    "<div class=\"text-center\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/datepicker.html",
    "<div ng-switch=\"datepickerMode\">\n" +
    "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" +
    "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" +
    "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/day.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/month.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/year.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepickerPopup/popup.html",
    "<ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
    "  <li ng-transclude></li>\n" +
    "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
    "    <span class=\"btn-group pull-left\">\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
    "    </span>\n" +
    "    <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("uib/template/modal/window.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/modal/window.html",
    "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
    "");
}]);

angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/pager/pager.html",
    "<li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
    "<li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
    "");
}]);

angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/pagination/pagination.html",
    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\"\n" +
    "  uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/popover/popover-html.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/popover/popover-template.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\"\n" +
    "      uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "      tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/popover/popover.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/progressbar/bar.html",
    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/progressbar/progress.html",
    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
}]);

angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/progressbar/progressbar.html",
    "<div class=\"progress\">\n" +
    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/rating/rating.html",
    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" +
    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" +
    "</span>\n" +
    "");
}]);

angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tabs/tab.html",
    "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" +
    "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
    "</li>\n" +
    "");
}]);

angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tabs/tabset.html",
    "<div>\n" +
    "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
    "  <div class=\"tab-content\">\n" +
    "    <div class=\"tab-pane\"\n" +
    "         ng-repeat=\"tab in tabset.tabs\"\n" +
    "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
    "         uib-tab-content-transclude=\"tab\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/timepicker/timepicker.html",
    "<table class=\"uib-timepicker\">\n" +
    "  <tbody>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" +
    "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
    "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" +
    "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
    "    </tr>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-match.html",
    "<a href\n" +
    "   tabindex=\"-1\"\n" +
    "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" +
    "   ng-attr-title=\"{{match.label}}\"></a>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-popup.html",
    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
    "    <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" +
    "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
    "    </li>\n" +
    "</ul>\n" +
    "");
}]);
angular.module('ui.bootstrap.carousel').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>'); angular.$$uibCarouselCss = true; });
angular.module('ui.bootstrap.datepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'); angular.$$uibDatepickerCss = true; });
angular.module('ui.bootstrap.position').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'); angular.$$uibPositionCss = true; });
angular.module('ui.bootstrap.datepickerPopup').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerpopupCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'); angular.$$uibDatepickerpopupCss = true; });
angular.module('ui.bootstrap.tooltip').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>'); angular.$$uibTooltipCss = true; });
angular.module('ui.bootstrap.timepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>'); angular.$$uibTimepickerCss = true; });
angular.module('ui.bootstrap.typeahead').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'); angular.$$uibTypeaheadCss = true; });
/**
 * Bento v1.12.1
 * Built on: 2017-09-19T10:03:53-0400
 * Copyright 2017 Thomson Reuters
 * Maintained by Chi Gao, Joe Huang, Aaron Mendez
 */
(function(angular){
  'use strict';
  //Register Bento.UI
  window.bento = angular.module('bento.ui',[
    'ngAnimate',
    'bento.modern.ui',
    'bento.services',
    'bento.busyloader',
    'bento.append.to.parent',
    'bento.carousel',
    'bento.combobox',
    'bento.contextualheader',
    'bento.cookie',
    'bento.fileselector',
    'bento.inputblur',
    'bento.numberinput',
    'bento.off.canvas.menu',
    'bento.pagination',
    'bento.reset',
    'bento.select',
    'bento.splittergroup',
    'bento.tagsinput',
    'bento.test',
    'bento.translate',
    'bento.table',
    'bento.toggle',
    'bento.toolbar',
    'bento.tree',
    'bento.wizard',
    'bento.nav.toolbar',
    'bento.progressbar',
    'bento.tabs',
    'bento.transferbox',
    'bento.multiselectoverlay',
    'bento.dropdown.append.to.parent',
    'bento.alert',
    'bento.datepicker.rome',
    'bento.megamenu',
    'bento.universeFilter',
    'bento.uib.datepicker.addon'
  ]).config(['$logProvider', function($logProvider){
    $logProvider.debugEnabled(false);
  }]);

  angular.module('bento.modern',['bento.ui']);

  bento.version = {release:'1.12.1',nightly:'N/A',codeName:'sanshoku'};

})(window.angular);

angular.module('bento.modern.ui', ['../templates/alerts/bento_alert_container.html', '../templates/alerts/bento_alert.html', '../templates/carousel/bento-carousel-card-default.html', '../templates/combobox/bento-combobox-container.html', '../templates/combobox/bento-combobox-header-template.html', '../templates/combobox/bento-combobox.html', '../templates/contextual_header/bento-contextual-header.html', '../templates/file_selector/bento-file-selector.html', '../templates/multiselect_list/bento-multiselect-list.html', '../templates/multiselect_overlay/bento-multiselect-overlay.html', '../templates/pagination/bento-pagination.html', '../templates/progressbar/bento-progressbar.html', '../templates/spread/bento-spread.html', '../templates/tags_input/bento-tags-input-pill.html', '../templates/tags_input/bento-tags-input.html', '../templates/toggle/bento-toggle.html', '../templates/toolbar/bento-toolbar.html', '../templates/transfer_box/bento-flexgrid-transferbox-base.html', '../templates/transfer_box/bento-flexgrid-transferbox-grid.html', '../templates/tree/bento-tree.html', 'uib/template/accordion/accordion-group.html', '../templates/universe_filter/bento-universe-filter.html']);

angular.module("../templates/alerts/bento_alert_container.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/alerts/bento_alert_container.html",
    "<div class=\"alert-container refresh-data\"\n" +
    "     aria-label=\"{{'BENTO_UI_ALERT_DESCRIPTION' | bentoTranslate}}\"\n" +
    "     tabindex=\"-1\">\n" +
    "  <div ng-repeat=\"alert in bentoAlertObject\"\n" +
    "       bento-alert-message=\"alert\"\n" +
    "       bento-alert-message-index=\"$index\"\n" +
    "       rel=\"bento-alert-{{$index}}\"\n" +
    "       bento-test=\"alert-{{$index}}\"\n" +
    "  >\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("../templates/alerts/bento_alert.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/alerts/bento_alert.html",
    "<div class=\"bento-alert-container bento-animate\">\n" +
    "    <div class=\"alert bento-alert\"\n" +
    "         bento-alert-index=\"{{bentoAlertMessageIndex}}\"\n" +
    "         ng-class=\"['alert-' + (bentoAlertMessage.type || 'warning'), bentoAlertMessage.closeable ? 'alert-dismissable' : null]\"\n" +
    "         role=\"alert\"\n" +
    "        >\n" +
    "      <button ng-show=\"bentoAlertMessage.closeable\"\n" +
    "              type=\"button\"\n" +
    "              class=\"close\"\n" +
    "              ng-click=\"closeBentoAlert()\"\n" +
    "              bento-test=\"button-close\"\n" +
    "              aria-label=\"{{ 'BENTO_UI_ALERT_CLOSE_BUTTON' | bentoTranslate}}\"\n" +
    "      >\n" +
    "        <span aria-hidden=\"true\"><i class=\"bento-icon-close-x\"></i></span>\n" +
    "      </button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "");
}]);

angular.module("../templates/carousel/bento-carousel-card-default.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/carousel/bento-carousel-card-default.html",
    "<div class=\"bento-carousel-card-recent\">\n" +
    "  <i class=\"bento-icon-newtab carousel-newtab-cta\" \n" +
    "     ng-click=\"newTabClick($event)\"\n" +
    "     ng-if=\"!hideNewTabIcon\"></i>\n" +
    "  <div ng-if=\"enablePopover &&\n" +
    "   ((cardName && cardName.length>0) || (cardSecondaryName && cardSecondaryName.length>0))\"\n" +
    "       class=\"bento-carousel-card-recent-header\"\n" +
    "       uib-popover=\"{{cardSecondaryName + ' '}}\"\n" +
    "       popover-title=\"{{cardName}}\"\n" +
    "       popover-placement=\"top\"\n" +
    "       popover-trigger=\"outsideClick\"\n" +
    "       ng-click=\"onHeaderClick($event)\">\n" +
    "    <!-- Content -->\n" +
    "    <h4 ng-if=\"cardName && cardName.length>0\" class=\"label\" ng-bind=\"cardName\"></h4>\n" +
    "    <h4 ng-if=\"cardSecondaryName && cardSecondaryName.length>0\" class=\"label\" ng-bind=\"cardSecondaryName\"></h4>\n" +
    "  </div>\n" +
    "  <div ng-if=\"!enablePopover &&\n" +
    "    ((cardName && cardName.length>0) || (cardSecondaryName && cardSecondaryName.length>0))\"\n" +
    "       class=\"bento-carousel-card-recent-header\" \n" +
    "       ng-click=\"onHeaderClick($event)\">\n" +
    "    <!-- Content -->\n" +
    "    <h4 ng-if=\"cardName && cardName.length>0\" class=\"label\" ng-bind=\"cardName\"></h4>\n" +
    "    <h4 ng-if=\"cardSecondaryName && cardSecondaryName.length>0\" class=\"label\" ng-bind=\"cardSecondaryName\"></h4>\n" +
    "  </div>\n" +
    "  <div class=\"content\" ng-include=\"cardTemplateUrl\"></div>\n" +
    "  <div class=\"foot\">\n" +
    "    <div ng-if=\"date\" class=\"time\" ng-bind=\"date | bentoTranslate | bentoStringReplace: '_NUMBER_' : dDay\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "        ");
}]);

angular.module("../templates/combobox/bento-combobox-container.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/combobox/bento-combobox-container.html",
    "<div class=\"bento-combobox-container\">\n" +
    "  <ul class=\"bento-combobox-container-header\"\n" +
    "      ng-if=\"!!headers\"\n" +
    "  >\n" +
    "    <li bento-combobox-header-template=\"headerTemplate\"\n" +
    "        ng-repeat=\"header in headers track by $index\"\n" +
    "        $header=\"header\"\n" +
    "        $index=\"{{$index}}\"\n" +
    "        bento-test=\"header-{{$index}}\"\n" +
    "    >\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "  <div class=\"bento-combobox-container-body\"\n" +
    "\n" +
    "  >\n" +
    "    <ul ng-if=\"!isTable\"\n" +
    "        class=\"bento-combobox-container-list\">\n" +
    "      <li ng-repeat=\"item in data track by $index\"\n" +
    "          class=\"bento-combobox-container-item\" tabindex=\"-1\"\n" +
    "      >\n" +
    "        <bento-combobox-row-template\n" +
    "            ng-class=\"{selected: selectedIndex == $index}\"\n" +
    "            ng-click=\"selectItem($index)\"\n" +
    "            rel=\"row-{{$index}}\"\n" +
    "            $item=\"item\"\n" +
    "            $index=\"$index\"\n" +
    "            $label-name=\"labelName\"\n" +
    "            row-template=\"rowTemplate()\"\n" +
    "            bento-test=\"item-{{$index}}\"\n" +
    "        ></bento-combobox-row-template>\n" +
    "      </li>\n" +
    "\n" +
    "    </ul>\n" +
    "    <ul ng-if=\"isTable\"\n" +
    "        class=\"bento-combobox-container-list\">\n" +
    "      <li ng-repeat=\"item in data track by $index\"\n" +
    "          class=\"bento-combobox-container-item\" tabindex=\"-1\"\n" +
    "      >\n" +
    "        <bento-combobox-row-template\n" +
    "            ng-class=\"{selected: selectedIndex == $index}\"\n" +
    "            ng-click=\"selectItem($index)\"\n" +
    "            rel=\"row-{{$index}}\"\n" +
    "            $item=\"item\"\n" +
    "            $index=\"$index\"\n" +
    "            $label-name=\"labelName\"\n" +
    "            headers=\"headers\"\n" +
    "            row-template=\"rowTemplate()\"\n" +
    "            bento-test=\"item-{{$index}}\"\n" +
    "        ></bento-combobox-row-template>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "  <bento-combobox-footer\n" +
    "      ng-if=\"$parent.footerOptions() && $parent.footerOptions().buttons\"\n" +
    "      class=\"bento-combobox-container-list\"\n" +
    "      template-url=\"{{footerTemplateUrl()}}\"\n" +
    "  ></bento-combobox-footer>\n" +
    "</div>");
}]);

angular.module("../templates/combobox/bento-combobox-header-template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/combobox/bento-combobox-header-template.html",
    "<li class=\"bento-combobox-container-header-label\"></li>");
}]);

angular.module("../templates/combobox/bento-combobox.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/combobox/bento-combobox.html",
    "<div class=\"bento-combobox bento-select form-control\"\n" +
    "     ng-class=\"{'open': isContainerVisible, 'no-value': !inputValue}\"\n" +
    "     tabindex = '-1'\n" +
    "    >\n" +
    "  <input class=\"form-control {{inputClasses}}\"\n" +
    "         type=\"text\"\n" +
    "         placeholder=\"{{placeholder}}\"\n" +
    "         autocomplete=\"off\"\n" +
    "         aria-autocomplete=\"none\"\n" +
    "         ng-keyup=\"onInputKeyup($event);\"\n" +
    "         ng-keypress=\"onInputKeypress($event)\"\n" +
    "         ng-keydown=\"onInputKeyDown($event);\"\n" +
    "         ng-show=\"searchable()\"\n" +
    "         ng-readonly=\"attrs.readonly\"\n" +
    "         ng-disabled=\"ngDisabled()\"\n" +
    "         ng-model=\"inputLabel\"\n" +
    "         bento-test=\"input\"\n" +
    "         />\n" +
    "\n" +
    "  <div class=\"input-label form-control\"\n" +
    "       ng-class=\"{'disabled': ngDisabled()}\"\n" +
    "       ng-if=\"!searchable()\"\n" +
    "       ng-keyup=\"onInputKeyup($event);\"\n" +
    "       ng-keydown=\"onInputKeyDown($event);\"\n" +
    "       ng-disabled=\"ngDisabled()\"\n" +
    "       ng-click=\"onButtonClick($event)\"\n" +
    "       tabindex=\"0\"\n" +
    "      >\n" +
    "    {{inputLabel}}\n" +
    "  </div>\n" +
    "  <div class=\"placeholder\"\n" +
    "       ng-class=\"{'disabled': ngDisabled()}\"\n" +
    "       ng-if=\"!searchable() && (!inputLabel || inputLabel.length === 0)\"\n" +
    "       ng-disabled=\"ngDisabled()\"\n" +
    "       >\n" +
    "    {{placeholder}}\n" +
    "  </div>\n" +
    "  <div bento-busy-loader=\"loadingData\" \n" +
    "       bento-busy-loader-size=\"small\" \n" +
    "       class=\"preloader\"\n" +
    "       bento-test=\"busy-loader\"></div>\n" +
    "\n" +
    "  <div class=\"btn\"\n" +
    "       tabindex=\"-1\"\n" +
    "       ng-class=\"{'disabled':ngDisabled()}\"\n" +
    "       ng-show=\"!attrs.readonly\"\n" +
    "       ng-click=\"onButtonClick($event)\"\n" +
    "      >\n" +
    "    <i ng-class=\"{'bento-icon-caret-up':isContainerVisible,'bento-icon-caret-down':!isContainerVisible}\"></i>\n" +
    "  </div>\n" +
    "  <div bento-combobox-container\n" +
    "       id=\"{{uid}}\"\n" +
    "       class=\"bento-append-to-parent\"\n" +
    "       data=\"data\"\n" +
    "       selected-index=\"selectedIndex\"\n" +
    "       headers=\"headers\"\n" +
    "       header-template=\"headerTemplate\"\n" +
    "       is-table=\"!!headers\"\n" +
    "       label-name=\"labelName\"\n" +
    "       on-item-click=\"onItemClick(index)\"\n" +
    "       controller=\"containerCtrl\"\n" +
    "       row-template=\"rowTemplate()\"\n" +
    "       on-end-of-scroll=\"onEndOfScroll()\"\n" +
    "       footer-template-url=\"footerOptions().templateUrl\"\n" +
    "      ></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../templates/contextual_header/bento-contextual-header.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/contextual_header/bento-contextual-header.html",
    "<div class=\"bento-contextual-header-inner\">\n" +
    "  <button class=\"bch-back-button\"\n" +
    "          ng-if=\"!hideBackBtn()\"\n" +
    "          ng-click=\"onBackBtnClick()\"\n" +
    "          ng-disabled=\"backBtnDisabled()\"\n" +
    "  >\n" +
    "    <i class=\"bento-icon-arrow-left\"></i>\n" +
    "  </button>\n" +
    "  <div class=\"bch-main-container\">\n" +
    "    <div class=\"bch-header\"\n" +
    "         ng-class=\"getHeaderWidthClass()\"\n" +
    "         ng-repeat=\"header in contextualHeaderData().headers | limitTo:3 track by $index\"\n" +
    "    >\n" +
    "      <div class=\"bch-header-icon\" ng-if=\"header.icon\" ng-switch=\"isImage(header.icon)\">\n" +
    "        <img ng-switch-when=\"true\" ng-src=\"{{header.icon}}\" class=\"bch-header-img\"></img>\n" +
    "        <i ng-switch-default ng-class=\"header.icon\"></i>\n" +
    "      </div>\n" +
    "      <div class=\"bch-header-title-container\">\n" +
    "        <div class=\"bch-header-title\">{{header.title}}</div>\n" +
    "        <div ng-if=\"header.subtitle!=undefined\" \n" +
    "             data-subtitle-id=\"{{$index}}\"\n" +
    "             class=\"bch-header-subtitle\"\n" +
    "             uib-tooltip=\"{{header.subtitle}}\"\n" +
    "             tooltip-placement=\"bottom\"\n" +
    "             tooltip-enable=\"isTooltipEnabled($index)\"\n" +
    "        >{{header.subtitle}}\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"bch-right-container\" ng-if=\"contextualHeaderData().button\">\n" +
    "    <button class=\"btn btn-primary btn-sm\"\n" +
    "            ng-click=\"onRightButtonClick()\"\n" +
    "            ng-disabled=\"contextualHeaderData().button.disabled\"\n" +
    "    >{{contextualHeaderData().button.text}}\n" +
    "    </button>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../templates/file_selector/bento-file-selector.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/file_selector/bento-file-selector.html",
    "<div class=\"bento-file-selector\" ng-class=\"{'bento-file-selector-progress-percentage':showProgressPercentage}\">\n" +
    "  <div class=\"sr-only\" tabindex=\"0\">\n" +
    "    {{'BENTO_UI_FILE_SELECTOR_DESCRIPTION' | bentoTranslate}}\n" +
    "  </div>\n" +
    "  <span class=\"header\">{{'BENTO_UI_FILE_SELECTOR_DROP_FILED_LABEL' | bentoTranslate : dropFieldLabel}}</span><br/>\n" +
    "  <button class=\"btn btn-primary\"\n" +
    "          ng-click=\"onBrowseClick($event)\"\n" +
    "          role=\"button\"\n" +
    "          type=\"button\"\n" +
    "          bento-test=\"browse-button\"\n" +
    "          aria-label=\"{{ 'BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON' | bentoTranslate }}\"\n" +
    "          ng-disabled=\"disableBrowseButton\"\n" +
    "      >\n" +
    "    <span>{{'BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON_LABEL' | bentoTranslate : browseButtonLabel}}</span>\n" +
    "    <i class=\"bento-icon-chevron-right\"></i>\n" +
    "  </button>\n" +
    "  <div class=\"filename-container\">\n" +
    "    <div class=\"sr-only bento-file-selector-post-removal-message\" tabindex=\"-1\">\n" +
    "    {{'BENTO_UI_FILE_SELECTOR_REMOVE_COMPLETE' | bentoTranslate | bentoStringReplace: '_FILE_NAME_' :fileRemoved}}\n" +
    "  </div>\n" +
    "    <div  ng-if=\"showSelected\"\n" +
    "          class=\"btn btn-default bento-file-selector-filename\"\n" +
    "          ng-repeat=\"file in ngModel track by $index\"\n" +
    "          ng-disabled=\"disabledFiles[$index] && disableFilesDuringUpload\"\n" +
    "          ng-class=\"{loading:disabledFiles[$index]}\"\n" +
    "          rel=\"file_{{$index}}\">\n" +
    "      <span\n" +
    "        tabindex=\"0\"\n" +
    "        class=\"bento-file-selector-filename-label\"\n" +
    "        aria-label=\"{{'BENTO_UI_FILE_SELECTOR_FILE_NAME' | bentoTranslate | bentoStringReplace:'_FILE_NAME_': file.name | bentoStringReplace:'_NUM_FILES_':ngModel.length | bentoStringReplace:'_FILE_NUMBER_':($index+1)}} {{showFileSize? '(' + (file.size | bentoFileSizeFilter) + ')' : ''}} {{(fileProgresses[$index] >= 0 && fileProgresses[$index] < 100)? ('BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_PROGRESS' | bentoTranslate) : (fileProgresses[$index]) ? ('BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_COMPLETE' | bentoTranslate) : ''}}\"\n" +
    "        >{{file.name}}{{showFileSize? ' (' + (file.size | bentoFileSizeFilter) + ')' : ''}}</span>\n" +
    "      <button ng-click=\"onRemoveClick($index)\"\n" +
    "         role=\"button\"\n" +
    "         aria-label=\"{{'BENTO_UI_FILE_SELECTOR_REMOVE_BUTTON' | bentoTranslate | bentoStringReplace:'_FILE_NAME_':file.name}}\"\n" +
    "         tabindex=\"0\"\n" +
    "         class=\"bento-icon-close-circle\"\n" +
    "         ng-disabled=\"disabledFiles[$index] && disableFilesDuringUpload\"\n" +
    "          >\n" +
    "      </button>\n" +
    "      <div class=\"bento-file-selector-file-progress-bg\" ng-style=\"{width: fileProgresses[$index] + '%'}\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"bento-progressbar\">\n" +
    "    <div uib-progressbar value=\"uploadProgressPercentage\" type=\"success\"></div>\n" +
    "  </div>\n" +
    "  <div class=\"bento-file-selector-progress-percentage-label\">{{uploadProgressPercentage}}%</div>\n" +
    "</div>");
}]);

angular.module("../templates/multiselect_list/bento-multiselect-list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/multiselect_list/bento-multiselect-list.html",
    "<div class=\"bento-multiselect-list\">\n" +
    "  <div class=\"bento-multiselect-list-item bento-multiselect-search\">\n" +
    "    <div class=\"pills\">\n" +
    "      <ul class=\"nav nav-pills\" role=\"tablist\">\n" +
    "        <li ng-class=\"{active:!showSelected}\"><a ng-click=\"setShowSelected(false)\" role=\"tab\" bento-test=\"show-all\" href>\n" +
    "          {{'BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL' | bentoTranslate:showAllText}}\n" +
    "        </a></li>\n" +
    "        <li ng-class=\"{active:showSelected}\"><a ng-click=\"setShowSelected(true)\" role=\"tab\" bento-test=\"show-selected\" href>\n" +
    "          {{'BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED' | bentoTranslate:showSelectedText}}\n" +
    "        </a></li>\n" +
    "      </ul>\n" +
    "    </div>\n" +
    "    <input bento-reset\n" +
    "           type=\"text\"\n" +
    "           class=\"form-control\"\n" +
    "           ng-model=\"searchTerm\"\n" +
    "           ng-change=\"onSearchChange()\"\n" +
    "           aria-label=\"{{'BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL' | bentoTranslate}}\"\n" +
    "        />\n" +
    "  </div>\n" +
    "  <div class=\"bento-multiselect-list-scroll-pane\" \n" +
    "       bento-busy-loader=\"!listData()\"\n" +
    "       bento-busy-loader-size=\"small\"\n" +
    "       >\n" +
    "    <button type=\"button\" \n" +
    "            class=\"bento-multiselect-list-item\"\n" +
    "            ng-click=\"onSelectAllClick()\"\n" +
    "            ng-class=\"{selected:selectAll}\"\n" +
    "            ng-show=\"!showSelected && filteredItems && filteredItems.length > 0\"\n" +
    "            bento-test=\"select-all\"\n" +
    "            aria-label=\"select all\"\n" +
    "            role=\"checkbox\"\n" +
    "            aria-checked=\"{{selectAll? true : false}}\"\n" +
    "            >\n" +
    "      <i \n" +
    "        class=\"bento-multiselect-checkbox\"\n" +
    "        ng-class=\"{'bento-icon-checkmark':selectAll}\">\n" +
    "      </i>\n" +
    "      <span>({{'BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL' | bentoTranslate:selectAllText}})</span>\n" +
    "    </button>\n" +
    "    <button type=\"button\"\n" +
    "            class=\"bento-multiselect-list-item\"\n" +
    "            ng-click=\"onItemClick(item)\"\n" +
    "            ng-repeat=\"item in filteredItems | multiselectShowSelected:showSelected:checkedUid track by $index\"\n" +
    "            ng-class=\"{selected:item[checkedUid]}\"\n" +
    "            title=\"{{item.name}}\"\n" +
    "            role=\"checkbox\"\n" +
    "            bento-test=\"item-{{$index}}\"\n" +
    "            aria-label=\"{{item.name}}\"\n" +
    "            aria-checked=\"{{item[checkedUid]? true : false}}\"\n" +
    "            >\n" +
    "      <i \n" +
    "        class=\"bento-multiselect-checkbox\"\n" +
    "        ng-class=\"{'bento-icon-checkmark':item[checkedUid]}\">\n" +
    "      </i>\n" +
    "      <span ng-bind-html=\"htmlEntities(item.name) | highlight:searchTerm.name\"></span>\n" +
    "    </button>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("../templates/multiselect_overlay/bento-multiselect-overlay.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/multiselect_overlay/bento-multiselect-overlay.html",
    "<div class=\"bento-multiselect-overlay-inner\">\n" +
    "  <div bento-side-overlay\n" +
    "       side=\"{{!!side? side : 'right'}}\"\n" +
    "       on-done=\"onDoneClick()\"\n" +
    "       overlay-height=\"multiselectListMaxHeight\"\n" +
    "       done-button-text=\"{{doneButtonText}}\"\n" +
    "       tabindex=\"-1\" \n" +
    "      >\n" +
    "    <button bento-side-overlay-toggle \n" +
    "            class=\"btn btn-default\" \n" +
    "            ng-disabled=\"isDisabled\"\n" +
    "            bento-test=\"button-toggle\"\n" +
    "            aria-label=\"{{'BENTO_UI_MULTISELECT_OVERLAY_DESCRIPTION' | bentoTranslate}}\"\n" +
    "            type=\"button\">{{\n" +
    "      selectedItemCount === 0 ?\n" +
    "      ('BENTO_UI_MULTISELECT_OVERLAY_SELECT' | bentoTranslate:selectButtonText)\n" +
    "      :\n" +
    "      ('BENTO_UI_MULTISELECT_OVERLAY_EDIT' | bentoTranslate:editButtonText)\n" +
    "      }}\n" +
    "    </button>\n" +
    "    <div bento-side-overlay-content \n" +
    "         tabindex=\"-1\" \n" +
    "         aria-label=\"{{'BENTO_UI_MULTISELECT_OVERLAY_CONTENT_DESCRIPTION' | bentoTranslate}} {{\n" +
    "      selectedItemCount === 0 ?\n" +
    "      ('BENTO_UI_MULTISELECT_OVERLAY_SELECT' | bentoTranslate:selectButtonText)\n" +
    "      :\n" +
    "      ('BENTO_UI_MULTISELECT_OVERLAY_EDIT' | bentoTranslate:editButtonText)\n" +
    "      }}\">\n" +
    "      <div bento-multiselect-list\n" +
    "           list-data=\"listData()\"\n" +
    "           on-change=\"onListChange()\"\n" +
    "           selected-items=\"selectedItems\"\n" +
    "           max-allowed-height=\"multiselectListMaxHeight\"\n" +
    "           select-all-text=\"{{selectAllText}}\"\n" +
    "           show-all-text=\"{{showAllText}}\"\n" +
    "           show-selected-text=\"{{showSelectedText}}\"\n" +
    "           sort=\"sort\"\n" +
    "           sort-reverse=\"sortReverse\"\n" +
    "           class=\"fill\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <span bento-test=\"label\" class=\"bento-multiselect-overlay-label\" tabindex=\"-1\">{{\n" +
    "    selectedItemCount === 0 ?\n" +
    "    ''\n" +
    "    :\n" +
    "    (selectedItemCount === 1 ?\n" +
    "      firstItemName\n" +
    "      :\n" +
    "    selectedItemCount === listData().length ?\n" +
    "        ('BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO' | bentoTranslate:allSelectedInfoText\n" +
    "        | bentoStringReplace:'NUMBER':ngModel.length)\n" +
    "        :\n" +
    "        ('BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO' | bentoTranslate:selectedInfoText\n" +
    "        | bentoStringReplace:'NUMBER':selectedItemCount)\n" +
    "    ) + '&nbsp;&nbsp;&nbsp;'\n" +
    "    }}</span>\n" +
    "  </div>\n" +
    "");
}]);

angular.module("../templates/pagination/bento-pagination.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/pagination/bento-pagination.html",
    "<ul class=\"bento-pagination\" ng-class=\"{'is-narrow':VM.goIconVisible}\">\n" +
    "  <li ng-if=\"VM.boundaryLinks!==false\" class=\"paginate_button first first_button\"\n" +
    "      ng-disabled=\"currentPage <= 1||VM.maxPage <= 1\" \n" +
    "      ng-class=\"{disabled: currentPage <= 1||VM.maxPage <= 1}\"\n" +
    "      bento-test=\"first-button\"\n" +
    "  >\n" +
    "    <a href ng-click=\"goToPage(1)\" ng-keypress=\"goToPage(1)\" class=\"btn btn-default\"><span class=\"bento-icon-chevron-first-left\"></span></a>\n" +
    "  </li>\n" +
    "  <li ng-if=\"directionLinks()!==false\" class=\"paginate_button previous\"\n" +
    "      ng-disabled=\"currentPage <= 1||VM.maxPage <= 1\" \n" +
    "      ng-class=\"{first_button: !VM.boundaryLinks, disabled: currentPage <= 1||VM.maxPage <= 1}\"\n" +
    "      bento-test=\"previous-button\"\n" +
    "  >\n" +
    "    <a href ng-click=\"goToPage(currentPage-1)\" ng-keypress=\"goToPage(currentPage-1)\" class=\"btn btn-default\"><span class=\"bento-icon-chevron-left\"></span></a>\n" +
    "  </li>\n" +
    "  <li ng-if=\"directionLinks()!==false\" class=\"paginate_button next\"\n" +
    "      ng-disabled=\"currentPage === VM.maxPage||VM.maxPage <= 1\" \n" +
    "      ng-class=\"{last_button: !VM.boundaryLinks, small_margin: VM.lastButtonSmallMargin, disabled: currentPage === VM.maxPage||VM.maxPage <= 1}\"\n" +
    "      bento-test=\"next-button\"\n" +
    "  >\n" +
    "    <a href ng-click=\"goToPage(currentPage+1)\" ng-keypress=\"goToPage(currentPage+1)\" class=\"btn btn-default\"><span class=\"bento-icon-chevron-right\"></span></a>\n" +
    "  </li>\n" +
    "  <li ng-if=\"VM.boundaryLinks!==false\" class=\"paginate_button last last_button\"\n" +
    "      ng-disabled=\"currentPage === VM.maxPage||VM.maxPage <= 1\" \n" +
    "      ng-class=\"{disabled: currentPage === VM.maxPage||VM.maxPage <= 1,small_margin: VM.lastButtonSmallMargin}\"\n" +
    "      bento-test=\"last-button\"\n" +
    "  >\n" +
    "    <a href ng-click=\"goToPage('max')\" ng-keypress=\"goToPage('max')\" class=\"btn btn-default\"><span class=\"bento-icon-chevron-last-right\"></span></a>\n" +
    "  </li>\n" +
    "  <li class=\"paginate_input_wrap\" ng-if=\"VM.goBtnVisible && VM.maxPage > 1\">\n" +
    "        <span class=\"input-group paginate-input-group\">\n" +
    "            <input type=\"text\" class=\"form-control\" placeholder=\"{{currentPage}}\" ng-model=\"VM.tgtPage\"\n" +
    "                   ng-keypress=\"keySelectPage($event, VM.tgtPage)\"\n" +
    "                   bento-test=\"page-input\"\n" +
    "            >\n" +
    "            <span class=\"input-group-btn paginate_input_wrap\">\n" +
    "            <button class=\"go btn btn-default btn-sq\" ng-click=\"goToPage(VM.tgtPage)\"\n" +
    "                    bento-test=\"go-button\"\n" +
    "            >\n" +
    "              <i class=\"bento-icon-arrow-curved-right\" ng-if=\"VM.goIconVisible\"></i>\n" +
    "              {{VM.goIconVisible ? '':'BENTO_UI_PAGINATION_GO_BUTTON' | bentoTranslate:goToText}}\n" +
    "              </button>\n" +
    "            </span>\n" +
    "        </span>\n" +
    "  </li>\n" +
    "  <li class=\"paginate-bento-select\">\n" +
    "    <div data-bento-select>\n" +
    "      <select class=\"form-control\" ng-model=\"itemsPerPage\"\n" +
    "              ng-options=\"item.value as item.label for item in itemsArray\"\n" +
    "              bento-test=\"items-per-page-select\"\n" +
    "      >\n" +
    "      </select>\n" +
    "    </div>\n" +
    "  </li>\n" +
    "  <li class=\"paginate_info\" ng-if=\"VM.maxPage > 0\">\n" +
    "        <span class=\"ng-scope ng-binding\" bento-test=\"info-label\">{{\n" +
    "            'BENTO_UI_PAGINATION_INFO_PAGE_TEXT'\n" +
    "            | bentoTranslate:infoPageText\n" +
    "            | bentoStringReplace:'_PAGE_':currentPage\n" +
    "            | bentoStringReplace:'_PAGES_': Math.ceil(totalItems / itemsPerPage)\n" +
    "            }} </span>\n" +
    "  </li>\n" +
    "  <li class=\"paginate_info_select\" ng-if=\"VM.maxPage > 0\">\n" +
    "        <span class=\"ng-scope ng-binding\" bento-test=\"info-select-label\">{{\n" +
    "            'BENTO_UI_PAGINATION_INFO_TEXT'\n" +
    "            | bentoTranslate:infoText\n" +
    "            | bentoStringReplace:'_START_':(currentPage - 1) * itemsPerPage + 1\n" +
    "            | bentoStringReplace:'_END_':(totalItems < (itemsPerPage * currentPage)) ? totalItems : (itemsPerPage * currentPage)\n" +
    "            | bentoStringReplace:'_MAX_':totalItems\n" +
    "            }} </span>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("../templates/progressbar/bento-progressbar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/progressbar/bento-progressbar.html",
    "<div class=\"progressbar-cell\"><uib-progressbar animate=\"animate\" value=\"dynamic\" type=\"{{barType}}\"></uib-progressbar></div>\n" +
    "<div class=\"value-cell\">{{dynamic}}%</div>\n" +
    "");
}]);

angular.module("../templates/spread/bento-spread.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/spread/bento-spread.html",
    "<div id=\"ss\" class=\"bento-spreadjs\"></div>");
}]);

angular.module("../templates/tags_input/bento-tags-input-pill.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/tags_input/bento-tags-input-pill.html",
    "<div tabindex=\"-1\"\n" +
    "     class=\"bento-tags-input-pill\"\n" +
    "     ng-class=\"getClass()\"\n" +
    "     title=\"{{label}}\"\n" +
    "    >\n" +
    "  <i class=\"bento-icon-edit\" \n" +
    "     ng-mousedown=\"onEditClick($event)\" \n" +
    "     ng-if=\"!isEditing && editable && !ngReadonly\"\n" +
    "     bento-test=\"edit-icon\"\n" +
    "     ></i>\n" +
    "  <span\n" +
    "      class=\"bento-tags-input-pill-label\"\n" +
    "      ng-hide=\"isEditing\"\n" +
    "      bento-test=\"label\"\n" +
    "      >{{label}}</span>\n" +
    "  <i class=\"bento-icon-close-circle\" \n" +
    "     ng-click=\"onCloseClick($event)\" \n" +
    "     ng-if=\"!isEditing && !ngReadonly\"\n" +
    "     bento-test=\"close\"\n" +
    "     ></i>\n" +
    "  <input ng-model=\"editLabel\"\n" +
    "         ng-trim=\"false\"\n" +
    "         ng-keydown=\"onKeydown($event)\"\n" +
    "         ng-blur=\"onInputBlur($event)\"\n" +
    "         type=\"text\"\n" +
    "         ng-show=\"isEditing\"\n" +
    "         bento-test=\"input-edit\"\n" +
    "         />\n" +
    "    <span class=\"bento-tags-input-pill-size-ref\">{{editLabel | bentoTagsInputPillFilter}}</span>\n" +
    "</div>");
}]);

angular.module("../templates/tags_input/bento-tags-input.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/tags_input/bento-tags-input.html",
    "<div class=\"bento-tags-input form-control\"\n" +
    "     ng-class=\"getClass()\"\n" +
    "     tabindex=\"-1\"\n" +
    "     ng-keydown=\"onKeydown($event)\"\n" +
    "     ng-focus=\"onElementFocus()\"\n" +
    "    >\n" +
    "  <div ng-repeat=\"tag in ngModel track by $index\"\n" +
    "       tag=\"tag\"\n" +
    "       bento-tags-input-pill\n" +
    "       editable=\"editable\"\n" +
    "       index=\"$index\"\n" +
    "       is-active=\"$index === activePill\"\n" +
    "       label=\"tag[propertyName]\"\n" +
    "       length=\"ngModel.length\"\n" +
    "       ng-blur=\"onPillBlur($index)\"\n" +
    "       ng-disabled=\"ngDisabled\"\n" +
    "       ng-focus=\"onPillFocus($index)\"\n" +
    "       on-close=\"onPillClose(index)\"\n" +
    "       on-delete-left=\"onPillDeleteLeft(index)\"\n" +
    "       on-delete-right=\"onPillDeleteRight(index)\"\n" +
    "       on-edit=\"onPillEdit(index)\"\n" +
    "       on-move-left=\"onPillMoveLeft(index)\"\n" +
    "       on-move-right=\"onPillMoveRight(index)\"\n" +
    "       on-pill-change=\"onPillChange(index,label)\"\n" +
    "       on-redundant-tag=\"onPillRedundant(index, isRedundant)\"\n" +
    "       on-tag-length=\"onPillTagLength(index, isValidLength)\"\n" +
    "       resize-callback=\"resizeInput(rect)\"\n" +
    "       ng-readonly=\"ngReadonly\"\n" +
    "       bento-test=\"tag-pill-{{$index}}\"\n" +
    "      ></div>\n" +
    "  <input class=\"bento-tags-input-text\"\n" +
    "         ng-disabled=\"ngDisabled\"\n" +
    "         ng-model=\"inputText\"\n" +
    "         ng-focus=\"onInputFocus()\"\n" +
    "         ng-keypress=\"onKeypress($event)\"\n" +
    "         ng-keyup=\"onKeyup($event)\"\n" +
    "         ng-show=\"!ngReadonly && !disableKeyInput\"\n" +
    "         placeholder=\"{{(!ngModel || ngModel.length === 0)? placeholder: ''}}\"\n" +
    "         type=\"text\"\n" +
    "         bento-test=\"input-tag\"\n" +
    "      />\n" +
    "  <input class=\"bento-tags-input-text-hidden\"\n" +
    "         ng-disabled=\"ngDisabled\"\n" +
    "         ng-show=\"!ngReadonly && !disableKeyInput\"\n" +
    "         ng-focus=\"onHiddenInputFocus()\"\n" +
    "      />\n" +
    "</div>");
}]);

angular.module("../templates/toggle/bento-toggle.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/toggle/bento-toggle.html",
    "<div class=\"bento-toggle\"\n" +
    "     tabindex=\"0\"\n" +
    "     ng-class=\"{on : ngModel}\"\n" +
    "     aria-label=\"{{ngModel? ('BENTO_UI_TOGGLE_ON' | bentoTranslate) : ('BENTO_UI_TOGGLE_OFF' | bentoTranslate)}}\"\n" +
    "     ng-keydown=\"onKeydown($event)\"\n" +
    "  >\n" +
    "  <div class=\"bento-toggle-nob\"></div>\n" +
    "</div>");
}]);

angular.module("../templates/toolbar/bento-toolbar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/toolbar/bento-toolbar.html",
    "<div ng-transclude=\"navbarLeft\" class=\"toolbar-navbar-left\" role=\"group\">\n" +
    "</div>\n" +
    "<ul class=\"nav navbar-nav\" role=\"menu\">\n" +
    "  <li ng-disabled=\"button.disabled\" \n" +
    "      ng-attr-uib-dropdown=\"angular.isDefined(button.dropdown) || undefined\" \n" +
    "      ng-if=\"button.isVisible\"\n" +
    "      bento-toolbar-button\n" +
    "      ng-class=\"{'transparent':button.isTransparent===true,'active':button.active}\"\n" +
    "      ng-repeat=\"button in bentoToolbarCtrl.tData\"\n" +
    "      data-button-id=\"{{$index}}\"\n" +
    "      bento-toolbar-ng-repeat-complete\n" +
    "      >\n" +
    "    <!-- if no dropdown, and regular button -->\n" +
    "    <a ng-if=\"!button.dropdown\" \n" +
    "       href=\"\" \n" +
    "       role=\"menuitem\"\n" +
    "       ng-class=\"{'disabled':button.disabled}\"\n" +
    "       ng-click=\"button.disabled||button.action()\"\n" +
    "       tabindex=\"{{button.disabled ? -1: 0}}\">\n" +
    "      <i ng-if=\"button.icon\" class=\"{{button.icon}}\"></i>{{button.label}}\n" +
    "\n" +
    "    </a>\n" +
    "    <!-- if there's a dropdown -->\n" +
    "    <a ng-if=\"button.dropdown\" \n" +
    "       href=\"\"\n" +
    "       class=\"dropdown-toggle\" \n" +
    "       role=\"menuitem\"\n" +
    "       ng-disabled=\"button.disabled\"\n" +
    "       ng-click=\"button.disabled||$event.preventDefault()\"\n" +
    "       tabindex=\"{{button.disabled ? -1: 0}}\"\n" +
    "       uib-dropdown-toggle>\n" +
    "      <i ng-if=\"button.icon\" class=\"{{button.icon}}\"></i>{{button.label}}\n" +
    "    </a>\n" +
    "    <ul ng-if=\"button.dropdown\" class=\"dropdown-menu\" role=\"menu\">\n" +
    "      <li ng-disabled=\"subBtn.disabled\" \n" +
    "          ng-repeat=\"subBtn in button.dropdown\"\n" +
    "          >\n" +
    "        <span ng-if=\"subBtn.separated\" class=\"divider\" role=\"separator\"></span>\n" +
    "        <a href=\"\" \n" +
    "           role=\"menuitem\"\n" +
    "           ng-click=\"subBtn.disabled||subBtn.action()\"\n" +
    "           tabindex=\"{{subBtn.disabled ? -1: 0}}\">\n" +
    "          <i ng-if=\"subBtn.icon\" class=\"{{subBtn.icon}}\"></i>{{subBtn.label}}\n" +
    "        </a>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "  <!-- more button -->\n" +
    "  <li ng-if=\"bentoToolbarCtrl.moreVisible\" style=\"opacity:0;\" class=\"more-button dropdown\" data-more-buttons=\"true\" bento-toolbar-button uib-dropdown>\n" +
    "    <a href=\"\" \n" +
    "       class=\"dropdown-toggle\"\n" +
    "       role=\"menuitem\"\n" +
    "       uib-dropdown-toggle\n" +
    "       tabindex=\"0\"\n" +
    "    >{{ bentoToolbarCtrl.moreButtonLabel || \"BENTO_UI_TOOLBAR_MORE\" | bentoTranslate }}\n" +
    "    </a>\n" +
    "    <ul class=\"more-dropdown-menu dropdown-menu\" ng-click=\"$event.stopPropagation()\" role=\"menu\">\n" +
    "      <li ng-disabled=\"button.disabled\" \n" +
    "          ng-repeat=\"button in bentoToolbarCtrl.tData\"\n" +
    "          ng-if=\"!button.isVisible\"\n" +
    "          ng-class=\"{'toolbar-dropdown-close':bentoToolbarDropdownCtrl.isOpen!=undefined&&bentoToolbarDropdownCtrl.isOpen===false,'toolbar-dropdown-open':bentoToolbarDropdownCtrl.isOpen===true, 'dropdown':button.dropdown}\"\n" +
    "          ng-attr-bento-toolbar-dropdown=\"angular.isDefined(button.dropdown) || undefined\" \n" +
    "          >\n" +
    "        <!-- if no dropdown, and regular button -->\n" +
    "        <span ng-if=\"button.separated\" class=\"divider\" role=\"separator\"></span>\n" +
    "        <a ng-if=\"!button.dropdown\" \n" +
    "           href=\"\" \n" +
    "           role=\"menuitem\"\n" +
    "           ng-click=\"button.disabled||button.action()\"\n" +
    "           tabindex=\"{{button.disabled ? -1: 0}}\">\n" +
    "          <i ng-if=\"button.icon\" class=\"{{button.icon}}\"></i>{{button.label}}\n" +
    "        </a>\n" +
    "        <!-- if there's a dropdown -->\n" +
    "        <a ng-if=\"button.dropdown\" \n" +
    "           href=\"\"\n" +
    "           role=\"menuitem\"\n" +
    "           class=\"toolbar-dropdown-toggle\" \n" +
    "           ng-disabled=\"button.disabled\"\n" +
    "           aria-haspopup=\"true\"\n" +
    "           aria-expanded=\"{{bentoToolbarDropdownCtrl.isOpen}}\"\n" +
    "           ng-attr-tabindex=\"button.disabled ? undefined: 0\"\n" +
    "           ng-click=\"$event.preventDefault();bentoToolbarDropdownCtrl.toggle(button)\">\n" +
    "          <i ng-if=\"button.icon\" class=\"{{button.icon}}\"></i>{{button.label}}\n" +
    "        </a>\n" +
    "        <ul ng-if=\"button.dropdown\" class=\"toolbar-dropdown-menu\" role=\"menu\">\n" +
    "          <li ng-disabled=\"subBtn.disabled\" \n" +
    "              ng-repeat=\"subBtn in button.dropdown\"\n" +
    "              >\n" +
    "            <span ng-if=\"subBtn.separated\" class=\"divider\" role=\"separator\"></span>\n" +
    "            <a href=\"\" \n" +
    "               role=\"menuitem\"\n" +
    "               ng-click=\"subBtn.disabled||subBtn.action()\"\n" +
    "               tabindex=\"{{subBtn.disabled ? -1: 0}}\">\n" +
    "              <i ng-if=\"subBtn.icon\" class=\"{{subBtn.icon}}\"></i>{{subBtn.label}}\n" +
    "            </a>\n" +
    "          </li>\n" +
    "        </ul>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "<div ng-transclude class=\"toolbar-navbar-right\" role=\"group\">\n" +
    "</div>\n" +
    "");
}]);

angular.module("../templates/transfer_box/bento-flexgrid-transferbox-base.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/transfer_box/bento-flexgrid-transferbox-base.html",
    "<div class=\"bento-transferbox\" ng-class=\"{'force-desktop':desktopMode,'no-pagination':hidePagination}\" ng-style=\"bentoTransferBoxCtrl.style\" >\n" +
    "  <div id=\"main-splitter-group\"\n" +
    "       data-bento-splitter-group\n" +
    "       data-left-width=\"60%\"\n" +
    "       data-is-left-collapsed=\"toggleRight\"\n" +
    "       data-collapsed=\"false\"\n" +
    "       data-resizable=\"true\"\n" +
    "       data-on-resize=\"bentoTransferBoxCtrl.onSplitterResize()\"\n" +
    "       data-no-collapse=\"true\"\n" +
    "       class=\"dark\">\n" +
    "    <div data-bento-splitter-group-left>\n" +
    "        <div bento-flexgrid-tbox\n" +
    "          column-definitions=\"bentoTransferBoxCtrl.columnDefinitions\"\n" +
    "          grid-data=\"bentoTransferBoxCtrl.gridDataOne\"\n" +
    "          config=\"bentoTransferBoxCtrl.config\"\n" +
    "          transfer-items=\"bentoTransferBoxCtrl.checkItemsOne(items,gridData)\"\n" +
    "          show-filters=\"showFilters\"\n" +
    "          hide-pagination=\"hidePagination\"\n" +
    "          desktop-mode=\"desktopMode\"\n" +
    "          control=\"bentoTransferBoxCtrl.box1\"\n" +
    "          disable-transfer=\"bentoTransferBoxCtrl.config.disableTransfer\"\n" +
    "          grid-template-url=\"gridTemplateUrl\"\n" +
    "          box-one=\"true\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <section data-bento-splitter-group-main>\n" +
    "        <div bento-flexgrid-tbox\n" +
    "          column-definitions=\"bentoTransferBoxCtrl.columnDefinitions\"\n" +
    "          grid-data=\"bentoTransferBoxCtrl.gridDataTwo\"\n" +
    "          config=\"bentoTransferBoxCtrl.config\"\n" +
    "          show-filters=\"showFilters\"\n" +
    "          hide-pagination=\"hidePagination\"\n" +
    "          desktop-mode=\"desktopMode\"\n" +
    "          transfer-items='bentoTransferBoxCtrl.checkItemsTwo(items,gridData)'\n" +
    "          disable-transfer=\"bentoTransferBoxCtrl.config.disableTransfer\"\n" +
    "          grid-template-url=\"gridTemplateUrl\"\n" +
    "          control=\"bentoTransferBoxCtrl.box2\">\n" +
    "        </div>\n" +
    "    </section>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("../templates/transfer_box/bento-flexgrid-transferbox-grid.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/transfer_box/bento-flexgrid-transferbox-grid.html",
    "<div class=\"no-padding\">\n" +
    "<!-- box one header -->\n" +
    " <div ng-if=\"bentoFlexgridTboxCtrl.boxOne\" class=\"transferbox-header\">\n" +
    "  <div class=\"transferbox-header-info pull-left\" ng-show=\"bentoFlexgridTboxCtrl.config.boxOneInfoShown\">\n" +
    "    <h5 class=\"transferbox-header-title\">{{\n" +
    "      bentoFlexgridTboxCtrl.config.boxOneTitle\n" +
    "      }}</h5>\n" +
    "    <!-- INFO TEXT ONE -->\n" +
    "    <div class=\"transferbox-select-info\">{{\n" +
    "      bentoFlexgridTboxCtrl.selectedItems.length > 0 ?\n" +
    "      (BENTO_UI_TRANSFER_BOX_INFO_TEXT\n" +
    "      | bentoTranslate:bentoFlexgridTboxCtrl.config.infoText\n" +
    "      | bentoStringReplace:'_SELECTED_':bentoFlexgridTboxCtrl.selectedItems.length\n" +
    "      | bentoStringReplace:'_TOTAL_':bentoFlexgridTboxCtrl.config.totalItems)\n" +
    "      :\n" +
    "      bentoFlexgridTboxCtrl.config.totalselectedItems;\n" +
    "      }}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <button class=\"btn pull-right transferbox-btn\"\n" +
    "          ng-class=\"{'btn-primary':bentoFlexgridTboxCtrl.selectedItems.length>0,'btn-default':!bentoFlexgridTboxCtrl.selectedItems.length}\"\n" +
    "          ng-disabled=\"bentoFlexgridTboxCtrl.selectedItems.length<=0 || disableTransfer\"\n" +
    "          ng-click=\"bentoFlexgridTboxCtrl.transferItems()\">{{bentoFlexgridTboxCtrl.config.transferBtnTextOne ? \n" +
    "    ('BENTO_UI_TRANSFER_BOX_BTN_TEXT_ONE' | bentoTranslate:bentoFlexgridTboxCtrl.config.transferBtnTextOne) :\n" +
    "    ('BENTO_UI_TRANSFER_BOX_BTN_TEXT' | bentoTranslate:bentoFlexgridTboxCtrl.config.transferBtnText)\n" +
    "    }}<span class=\"bento-icon-chevron-right\"></span></button>\n" +
    "</div>\n" +
    "<!-- box two header -->\n" +
    "<div ng-if=\"!bentoFlexgridTboxCtrl.boxOne\" class=\"transferbox-header\">\n" +
    "  <button class=\"btn transferbox-btn pull-left\"\n" +
    "          ng-disabled=\"bentoFlexgridTboxCtrl.selectedItems.length<=0 || disableTransfer\"\n" +
    "          ng-click=\"bentoFlexgridTboxCtrl.transferItems()\"\n" +
    "          ng-class=\"{'btn-primary':bentoFlexgridTboxCtrl.selectedItems.length>0,'btn-default':!bentoFlexgridTboxCtrl.selectedItems.length}\"><span\n" +
    "      class=\"bento-icon-chevron-left\"></span>{{bentoFlexgridTboxCtrl.config.transferBtnTextTwo ?\n" +
    "    ('BENTO_UI_TRANSFER_BOX_BTN_TEXT_TWO' | bentoTranslate:bentoFlexgridTboxCtrl.config.transferBtnTextTwo) : ('BENTO_UI_TRANSFER_BOX_BTN_TEXT' | bentoTranslate:bentoFlexgridTboxCtrl.config.transferBtnText)\n" +
    "    }}</button>\n" +
    "  <div class=\"transferbox-header-info pull-right\" ng-show=\"bentoFlexgridTboxCtrl.config.boxTwoInfoShown\">\n" +
    "    <h5 class=\"transferbox-header-title\">{{\n" +
    "      bentoFlexgridTboxCtrl.config.boxTwoTitle\n" +
    "      }}</h5>\n" +
    "\n" +
    "    <!-- INFO TEXT TWO -->\n" +
    "    <div class=\"transferbox-select-info pull-right\">{{\n" +
    "      bentoFlexgridTboxCtrl.selectedItems.length > 0 ?\n" +
    "      ('BENTO_UI_TRANSFER_BOX_INFO_TEXT'\n" +
    "      | bentoTranslate:bentoFlexgridTboxCtrl.config.infoText\n" +
    "      | bentoStringReplace:'_SELECTED_':bentoFlexgridTboxCtrl.selectedItems.length\n" +
    "      | bentoStringReplace:'_TOTAL_':bentoFlexgridTboxCtrl.config.totalItems)\n" +
    "      :\n" +
    "      bentoFlexgridTboxCtrl.config.totalAssignedItems\n" +
    "      }}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "<wj-flex-grid\n" +
    "      control=\"bentoFlexgridTboxCtrl.flexGrid\"\n" +
    "      items-source=\"bentoFlexgridTboxCtrl.config.collectionView\"\n" +
    "      initialized=\"bentoFlexgridTboxCtrl.initialized(s,e)\"\n" +
    "      class=\"bento-flex-grid\"\n" +
    "      headers-visibility=\"Column\"\n" +
    "      sort-row-index=\"0\"\n" +
    "      item-formatter=\"bentoFlexgridTboxCtrl.itemFormatter\"\n" +
    "      ng-style=\"{'height':bentoFlexgridTboxCtrl.config.height-bentoFlexgridTboxCtrl.config.offsetHeight+bentoFlexgridTboxCtrl.config.paginationOffsetHeight+'px'}\">\n" +
    "    <wj-flex-grid-column \n" +
    "      header=\"\" \n" +
    "      binding=\"bentoTboxSelect\" \n" +
    "      min-width=\"40\" \n" +
    "      width=\"40\" \n" +
    "      is-read-only=\"true\" \n" +
    "      allow-dragging=\"false\">\n" +
    "      <wj-flex-grid-cell-template cell-type=\"ColumnHeader\">\n" +
    "        &nbsp;\n" +
    "      </wj-flex-grid-cell-template>\n" +
    "      <wj-flex-grid-cell-template\n" +
    "        cell-type=\"Cell\">\n" +
    "          <i \n" +
    "            ng-click=\"$item.bentoTboxSelect = !$item.bentoTboxSelect;bentoFlexgridTboxCtrl.onCheckBoxChange();\"\n" +
    "            ng-model=\"$item.bentoTboxSelect\" \n" +
    "            class=\"bento-flex-grid-checkbox\"\n" +
    "            ng-class=\"{'bento-icon-checkmark':$item.bentoTboxSelect}\">\n" +
    "          </i>\n" +
    "      </wj-flex-grid-cell-template>\n" +
    "    </wj-flex-grid-column>\n" +
    "    <wj-flex-grid-column \n" +
    "        ng-repeat=\"col in bentoFlexgridTboxCtrl.config.columnDefinitions\" \n" +
    "        ng-if=\"col.binding != 'bentoTboxSelect'\"\n" +
    "        min-width=\"{{col.minWidth || '80'}}\" \n" +
    "        width=\"{{col.width || '*'}}\" \n" +
    "        header=\"{{col.header}}\" \n" +
    "        binding=\"{{col.binding}}\"\n" +
    "        visible=\"{{col.visible || true}}\"\n" +
    "        data-type=\"{{col.dataType}}\"\n" +
    "        format=\"{{col.format}}\"\n" +
    "        allow-sorting=\"{{col.allowSorting || true}}\"\n" +
    "        allow-dragging=\"{{col.allowDragging || true}}\"\n" +
    "        is-read-only=\"{{col.isReadOnly || false}}\"\n" +
    "        bento-flexgrid-tbox-input-filter=\"showFilters!=false && col.filter ? col.filter : undefined\"\n" +
    "        bento-flexgrid-tbox-input-filter-text=\"col.filterText\">\n" +
    "         <wj-flex-grid-cell-template\n" +
    "            cell-type=\"ColumnHeader\">\n" +
    "            <!-- Column Headers in Row 0, manually add back sort icons -->\n" +
    "            <div ng-if=\"$row.index===0\">{{$col.header}} <i ng-class=\"{'bento-icon-chevron-down':$col.currentSort==='-', 'bento-icon-chevron-up':$col.currentSort==='+'}\"></i></div>\n" +
    "            <!-- Column Header with Select -->\n" +
    "            <div ng-if=\"$row.index===1&&col.filter&&col.filter.type==='select'\">\n" +
    "              <div data-bento-select>\n" +
    "                <select name=\"mySelect\" \n" +
    "                  class=\"form-control\" \n" +
    "                  ng-model=\"col.selectText\" \n" +
    "                  ng-change=\"bentoFlexgridTboxCtrl.updateFilter($col.binding)\"\n" +
    "                  tabindex=\"0\">\n" +
    "                  <option ng-repeat=\"item in col.filter.options\" value=\"{{item.value}}\">{{item.name}}</option>\n" +
    "                </select>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </wj-flex-grid-cell-template>\n" +
    "          <wj-flex-grid-cell-template\n" +
    "            ng-repeat=\"ct in col.cellTemplates\"\n" +
    "            ng-if=\"col.cellTemplates\"\n" +
    "            cell-type=\"{{ct.type}}\">\n" +
    "            <ng-include src=\"ct.templateUrl\">\n" +
    "            </ng-include>\n" +
    "          </wj-flex-grid-cell-template>\n" +
    "    </wj-flex-grid-column>\n" +
    "  </wj-flex-grid>\n" +
    "  <div bento-pagination\n" +
    "       ng-if=\"!hidePagination\"\n" +
    "       page=\"bentoFlexgridTboxCtrl.config.page\"\n" +
    "       items-array=\"ctx.itemPerPageOptions\"\n" +
    "       total-items=\"bentoFlexgridTboxCtrl.config.totalItems\"\n" +
    "       items-per-page=\"bentoFlexgridTboxCtrl.config.pageSize\"\n" +
    "       info-text=\"{{bentoFlexgridTboxCtrl.config.paginationInfoText}}\"\n" +
    "       info-page-text=\"{{bentoFlexgridTboxCtrl.config.paginationInfoPageText}}\"\n" +
    "       go-text=\"{{bentoFlexgridTboxCtrl.config.paginationGoText}}\"\n" +
    "       class=\"\">\n" +
    "  </div>\n" +
    "  <div ng-if=\"showFilters!=false\" class=\"input-filter-container\"></div>\n" +
    "</div>");
}]);

angular.module("../templates/tree/bento-tree.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/tree/bento-tree.html",
    "<div class=\"bento-tree-branch\">\n" +
    "  <ul class=\"bento-tree-branch-base\">\n" +
    "    <li ng-repeat=\"node in treeModel\"\n" +
    "        class=\"bento-tree-node\"\n" +
    "        ng-class=\"getNodeSelectionClass(node)\"\n" +
    "        id=\"{{getTreeId(node)}}\"\n" +
    "        role=\"treeitem\">\n" +
    "      <div class=\"expand-button-compiled\"\n" +
    "           ng-if=\"node[nodeChildren]\"\n" +
    "           ng-click=\"toggleSelect(node)\">\n" +
    "        <div ng-class=\"{'bento-icon-caret-down':!node.collapsed,'bento-icon-caret-right':node.collapsed}\"></div>\n" +
    "      </div>\n" +
    "      <i ng-class=\"node[treeIcon]\" ng-if=\"!!node[treeIcon]\" ng-click=\"toggleSelect(node)\"></i>\n" +
    "      <input type=\"checkbox\"\n" +
    "             id=\"{{getTreeId(node)}}-checkbox\"\n" +
    "             class=\"bento-tree-check-box\"\n" +
    "             ng-if=\"useCheckbox && !node.hideCheckbox\"\n" +
    "             ng-model=\"node[checkboxModel]\"\n" +
    "             ng-click=\"checkboxClick(node)\"\n" +
    "             ng-disabled=\"node.disabled || treeDisabled\"\n" +
    "             tabindex=\"{{selectAsCheck? '-1' : '0'}}\"\n" +
    "             aria-labelledby=\"{{getTreeId(node)}}-label\"\n" +
    "      />\n" +
    "      <i class=\"{{node[secondTreeIcon]}} bento-tree-icon second-tree-icon\"\n" +
    "         ng-if=\"!!node[secondTreeIcon]\"\n" +
    "         ng-click=\"toggleSelect(node)\"\n" +
    "      ></i>\n" +
    "      <span ng-bind-html=\"node[treeLabel]\"\n" +
    "            ng-click=\"labelSelect(node)\"\n" +
    "            ng-keydown=\"onTreeItemKeydown($event, node)\"\n" +
    "            ng-keyup=\"onTreeItemKeyup($event, node)\"\n" +
    "            class=\"bento-tree-item-cta\"\n" +
    "            id=\"{{getTreeId(node)}}-label\"\n" +
    "            aria-label=\"{{node[treeLabel] | bentoStripHtml}}{{\n" +
    "            node.items.length > 0 ? ' ' +\n" +
    "              (node.collapsed ?\n" +
    "                ('BENTO_UI_TREE_COLLAPSED'|bentoTranslate) : ('BENTO_UI_TREE_EXPANDED'|bentoTranslate))\n" +
    "              : ''\n" +
    "            }}\"\n" +
    "            tabindex=\"0\"\n" +
    "      ></span>\n" +
    "      <div bento-tree\n" +
    "           ng-if=\"node[nodeChildren]\"\n" +
    "           uib-collapse=\"node.collapsed\"\n" +
    "           tree-icon=\"{{treeIcon}}\"\n" +
    "           tree-model=\"node[nodeChildren]\"\n" +
    "           tree-collapsed=\"treeCollapsed\"\n" +
    "           tree-label=\"{{treeLabel}}\"\n" +
    "           node-children=\"{{nodeChildren}}\"\n" +
    "           collapsing-callback=\"collapsingCallback\"\n" +
    "           expanding-callback=\"expandingCallback\"\n" +
    "           select-callback=\"selectCallback\"\n" +
    "           multi-select=\"multiSelect\"\n" +
    "           use-checkbox=\"useCheckbox\"\n" +
    "           checkbox-model=\"{{checkboxModel}}\"\n" +
    "           select-model=\"{{selectModel}}\"\n" +
    "           selectable-model=\"{{selectableModel}}\"\n" +
    "           second-tree-icon=\"{{secondTreeIcon}}\"\n" +
    "           on-checkbox-change=\"onCheckboxChange\"\n" +
    "           select-as-check=\"selectAsCheck\"\n" +
    "           tree-selection-helper=\"treeSelectionHelper\"\n" +
    "           expand-only-model=\"{{expandOnlyModel}}\"\n" +
    "           tree-disabled=\"node.disabled || treeDisabled\"\n" +
    "      >\n" +
    "      </div>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>");
}]);

angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/accordion/accordion-group.html",
    "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-class=\"{open: isOpen}\" ng-keypress=\"toggleOpen($event)\">\n" +
    "  <h4 class=\"panel-title\">\n" +
    "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><i ng-class=\"isOpen === true ? 'bento-icon-minus-plain' : 'bento-icon-plus-plain'\" ></i><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
    "  </h4>\n" +
    "</div>\n" +
    "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
    "  <div class=\"panel-body\" ng-transclude></div>\n" +
    "</div>");
}]);

angular.module("../templates/universe_filter/bento-universe-filter.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("../templates/universe_filter/bento-universe-filter.html",
    "<div class=\"bento-uni-filter row\" ng-class=\"{'has-back-btn':bentoUniverseFilterCtrl.hasBackBtn}\">\n" +
    "	<div class=\"bento-uni-filter_back-btn\" \n" +
    "		ng-if=\"bentoUniverseFilterCtrl.hasBackBtn\" \n" +
    "		ng-disabled=\"bentoUniverseFilterCtrl.backButtonDisabled\" \n" +
    "		ng-click=\"bentoUniverseFilterCtrl.onBackButtonClick()\"\n" +
    "		ng-keypress=\"($event.which === 13)?bentoUniverseFilterCtrl.onBackButtonClick():0\"\n" +
    "		tabindex=\"0\">\n" +
    "		<i class=\"bento-icon-arrow-left\"></i>\n" +
    "	</div>\n" +
    "	<div class=\"bento-uni-filter_item\" \n" +
    "		ng-repeat=\"item in bentoUniverseFilterCtrl.filterItems | limitTo: 4\" \n" +
    "		ng-class=\"{'col-xs-12':bentoUniverseFilterCtrl.filterItems.length===1,'col-xs-6':bentoUniverseFilterCtrl.filterItems.length===2,'col-xs-4':bentoUniverseFilterCtrl.filterItems.length===3,'col-xs-3':bentoUniverseFilterCtrl.filterItems.length>=4,'selected':bentoUniverseFilterCtrl.selectedName===item.name}\"\n" +
    "		ng-click=\"bentoUniverseFilterCtrl.openModal(item)\"\n" +
    "		ng-keypress=\"($event.which === 13)?bentoUniverseFilterCtrl.openModal(item):0\"\n" +
    "		tabindex=\"0\">\n" +
    "		<div class=\"bento-uni-filter_item-header\">{{item.name}}</div>\n" +
    "		<div class=\"bento-uni-filter_item-text\" bento-universe-filter-ellipsis bento-ellipsis-text=\"item.selectedName || bentoUniverseFilterCtrl.selectText\" data-uib-tooltip=\"{{item.selectedName || bentoUniverseFilterCtrl.selectText}}\" tooltip-placement=\"bottom\"></div>\n" +
    "		<i class=\"bento-uni-filter_carat bento-icon-caret-down\"></i>\n" +
    "	</div>\n" +
    "</div>\n" +
    "<script type=\"text/ng-template\" id=\"bentoUniFilterModal.html\">\n" +
    "	<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"closeModal()\" ng-keypress=\"($event.which === 13)?closeModal():0\" tabindex=\"0\">\n" +
    "    <i class=\"bento-icon-close-x\"></i>\n" +
    "  </button>\n" +
    "  <div class=\"modal-header\">\n" +
    "    Select {{filterItem.name}}\n" +
    "  </div>\n" +
    "  <div class=\"modal-body\">\n" +
    "    <ul class=\"bento-uni-filter_modal-list\">\n" +
    "    	<li ng-repeat=\"item in filterItem.items\" ng-click=\"selectItem(item, filterItem)\" ng-keypress=\"($event.which === 13)?selectItem(item, filterItem):0\" tabindex=\"0\">{{item.name}}</li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "</script>");
}]);

(function(angular){

  'use strict';

  angular.module('bento.cookie',[])
    .provider('$bentoCookie', function(){

      this.getCookie = _getCookie;

      this.$get = [function(){
        return {
          getCookie : _getCookie
        };
      }];

      function _getCookie(cookieName, defaultValue){
        var cookie = (document.cookie.match('(^|; )' + cookieName + '=([^;]*)') || 0)[2];

        if((cookie === null || cookie === '' || typeof cookie === 'undefined') && !!defaultValue){
          cookie = defaultValue;
        }

        return cookie;
      }
    });

})(window.angular);

/* jshint -W044 */
(function (angular) {

  'use strict';

  // This greatly helps finding out the current JS file / Bento Frameworks location
  // and a possible solution to bundling issues with the i18n files
  var jsScripts = document.getElementsByTagName("script");
  var currentJSFileSrc = jsScripts[jsScripts.length - 1].src;

  /**
   * Bento Service Module
   */
  angular.module('bento.services', ['ui.bootstrap.tooltip'])
  /**
   * Config the whole framework
   */
    .config([
        '$animateProvider',
        '$uibTooltipProvider',
        function ($animateProvider, $uibTooltipProvider) {
          // Register `ng-animate-disabled` as a class to turn off ng-animate
          $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled).)*$/);

          // Add UIB Tooltip trigger
          $uibTooltipProvider.setTriggers({'touchstart': 'touchstart'});

          // This is redundant but we'll use it for the time been
          var msTouchEnabled = window.navigator.msMaxTouchPoints;
          var generalTouchEnabled = "ontouchstart" in document.createElement("div");

          if (msTouchEnabled || generalTouchEnabled) {
            angular.element(document.getElementsByTagName('body')).addClass('touch');
          }

          var os = getOS();

          angular.element(document.getElementsByTagName('body')).addClass(os);

          var browser = getBrowser();

          angular.element(document.getElementsByTagName('body')).addClass(browser.browser);
          angular.element(document.getElementsByTagName('body')).addClass(browser.browserVersion);
        }
      ]
    )
    /**
     * FILTER: Highlight a substring that matches the value and return it with <strong></strong>
     */
    .filter('highlight', function () {

      /**
       * @param str - input string
       * @param value - search string
       * @param bypass - bypass highlighting
       */
      return function (_str, value, bypass) {

        if (value === '' || typeof value === 'undefined' || bypass) {
          return _str;
        }

        var str = _str || '';
        var newStr;
        var re = new RegExp('(' + value.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + ')', 'gi');
        newStr = str.replace(re, '<span class="matching-text-highlight">$&</span>');

        return newStr;
      };
    })
    /**
     * Find and replace a subString within a string
     */
    .filter('bentoStringReplace', function () {
      return function (str, find, replace) {
        if (str) {
          return str.replace(find, replace);
        }
        return;
      }
    })
    /**
     * Strip HTML from a string
     */
    .filter('bentoStripHtml', function () {
      return function (str) {
        return str ? String(str).replace(/<[^>]+>/gm, '') : '';
      }
    })
    /**
     * BentoService Factory to provide various services and utilities
     */
    .factory('$bentoServices', [
      '$window',
      '$timeout',
      function ($window, $timeout) {
        return {
          // Returns current IE version
          getIEVersion          : getIEVersion,
          // rAF for animation
          rAF                   : RAFProvider,
          // Detect retina displays
          retina                : $window.devicePixelRatio > 1,
          // Check if the device is touch supported
          isTouchSupported      : isTouchSupported,
          // Generate a numeric uniqueID
          generateUID           : generateUID,
          // Fire scope.$apply safely
          safeApply             : safeApply,
          // Check if a keyCode is printable
          isPrintableKeyCode    : isPrintableKeyCode,
          // Check if desktop
          isDesktop             : isDesktop,
          // Remove all browser selections
          removeBrowserSelection: removeBrowserSelection,
          // Find focussable elements in element
          findFocussable        : findFocussable,
          // Find tabbable elements in element
          findTabbable          : findTabbable,
          // Find if the element is visible on the stage
          isVisible             : isVisible,
          // Loop tabble elements in an element
          loopTabbables         : loopTabbables,
          // Find if RTL
          isRTL                 : isRTL
        };

        /**
         * Loop tabbable elements in a given element
         * Caution: USE THIS WISELY
         * @param  {jqLite Element} element - The container element
         */
        function loopTabbables($element) {
          $element[0].addEventListener('keydown', function (event) {
            if (event.keyCode === 9) {
              var tabbables = findTabbable($element[0]);
              if (event.shiftKey) {
                if (tabbables.indexOf(event.target) === 0) {
                  tabbables[tabbables.length - 1].focus();
                  event.preventDefault();
                  event.stopPropagation();
                }
              } else {
                if (tabbables.indexOf(event.target) === tabbables.length - 1 && tabbables[0]) {
                  tabbables[0].focus();
                  event.preventDefault();
                  event.stopPropagation();
                }
              }
            }
          });
        }

        /**
         * Find focussable elements in an element
         * @param  {htmlElement} element - container htmlElement
         * @return {array}         array of elements that are focussable
         */
        function findFocussable(element) {
          var els     = element.querySelectorAll('a,input,select,textarea,button,[tabindex]'),
              elArray = [],
              el;

          for (var i = 0, len = els.length; i < len; i++) {
            el = els[i];
            if (isVisible(el) && (!el.hasAttribute('disabled') || el.nodeName === 'A')) {
              elArray.push(el);
            }
          }

          return elArray;
        }

        /**
         * Find tabbable element in an element
         * @param  {htmlElement} element - container htmlElement
         * @return {array}          array of elements that are tabbable
         */
        function findTabbable(element) {
          var elArray = findFocussable(element);

          return elArray.filter(function (item, index) {
            var a = item.getAttribute('tabindex');
            if (!a || a != -1) {
              return true;
            }
          });
        }

        function isVisible(element) {
          return !(element.offsetWidth === 0 && element.offsetHeight === 0);
        }

        /**
         * Remove all browser selections
         */
        function removeBrowserSelection() {
          // Remove all text selections from the document
          if (window.getSelection) {
            // Chrome & Safari
            if (window.getSelection().empty) {
              window.getSelection().empty();
            } else
            // Firefox
            if (window.getSelection().removeAllRanges) {
              window.getSelection().removeAllRanges();
            }
          } else
          // IE
          if (document.selection) {
            document.selection.empty();
          }
        }

        /**
         * isDesktop
         * @returns {boolean}
         *
         * Check if current device is desktop
         *
         */
        function isDesktop() {
          var os = getOS();
          return os != 'android' && os != 'ios';
        }

        /**
         * isTouchSupported
         * @returns {boolean}
         *
         * Check of the current device is touch friendly
         *
         */
        function isTouchSupported() {
          var msTouchEnabled = window.navigator.msMaxTouchPoints;
          var generalTouchEnabled = "ontouchstart" in document.createElement("div");

          return msTouchEnabled || generalTouchEnabled;
        }

        /**
         * safeApply a function on a scope
         * @param scope
         * @param fn
         *
         */
        function safeApply(scope, fn) {
          var phase;
          if (scope && scope.$root) {
            phase = scope.$root.$$phase;
          }
          if (phase === '$apply' || phase === '$digest' || typeof phase === 'undefined') {
            if (fn && (typeof(fn) === 'function')) {
              fn();
            }
          } else {
            scope.$apply(fn);
          }
        }

        /**
         * getIEVersion
         * @returns {number}
         *
         * Returns the version of Internet Explorer or a -1
         * (indicating the use of another browser).
         */
        function getIEVersion() {
          var rv = -1; // Return value assumes failure.
          var ua;
          var re;
          if (navigator.appName === 'Microsoft Internet Explorer') {

            ua = navigator.userAgent;
            re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) !== null) {
              rv = parseFloat(RegExp.$1);
            }
          } else if (navigator.appName === 'Netscape') {
            ua = navigator.userAgent;
            re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) !== null) {
              rv = parseFloat(RegExp.$1);
            }
          }

          return rv;
        }

        /**
         * Generate an unique numeric ID
         */
        function generateUID() {
          return Math.round(Math.random() * 10000000).toString() + Math.round(Math.random() * 10000000).toString();
        }

        /**
         * This is a port to angularJS v1.2.11 and up $$rAF for temporary use
         * @param callBackFunc
         * @returns {Function}
         * @constructor
         */
        function RAFProvider(callBackFunc) {

          var requestAnimationFrame = $window.requestAnimationFrame ||
            $window.webkitRequestAnimationFrame ||
            $window.mozRequestAnimationFrame;

          var cancelAnimationFrame = $window.cancelAnimationFrame ||
            $window.webkitCancelAnimationFrame ||
            $window.mozCancelAnimationFrame ||
            $window.webkitCancelRequestAnimationFrame;

          var rafSupported = !!requestAnimationFrame;
          if (rafSupported) {
            var id = requestAnimationFrame(callBackFunc);
            return function () {
              cancelAnimationFrame(id);
            };
          } else {
            var timer = $timeout(callBackFunc, 16.66, false); // 1000 / 60 = 16.666
            return function () {
              $timeout.cancel(timer);
            };
          }
        }

        /**
         * Check if a keyCode is printable
         * @param keyCode
         * @returns {boolean}
         */
        function isPrintableKeyCode(keyCode) {
          return (keyCode > 47 && keyCode < 58) || // number keys
            keyCode === 32 || keyCode === 13 || // spacebar & return key(s) (if you want to allow carriage returns)
            (keyCode > 64 && keyCode < 91) || // letter keys
            (keyCode > 95 && keyCode < 112) || // numpad keys
            (keyCode > 185 && keyCode < 193) || // ;=,-./` (in order)
            (keyCode > 218 && keyCode < 223);   // [\]' (in order)
        }

        /**
         * Determine if dir is set to RTL
         * @return {boolean}
         */
        function isRTL(element){
          var value = false;
          if(window.getComputedStyle(element || document.body,null).getPropertyValue('direction')==='rtl'){
            value = true;
          }
          return value;
        }
      }])
    /**
     * Help directive recursions without running into stack overflow on string replace
     */
    .factory('$recursionHelper', ['$compile', function ($compile) {
      return {
        /**
         * Manually compiles the element, fixing the recursion loop.
         * @param element
         * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
         * @returns An object containing the linking functions.
         */
        compile: function (element, link) {
          // Normalize the link parameter
          if (angular.isFunction(link)) {
            link = {post: link};
          }

          // Break the recursion loop by removing the contents
          var contents = element.contents().remove();
          var compiledContents;
          return {
            pre : (link && link.pre) ? link.pre : null,
            /**
             * Compiles and re-adds the contents
             */
            post: function (scope, element) {
              // Compile the contents
              if (!compiledContents) {
                compiledContents = $compile(contents);
              }
              // Re-add the compiled contents to the element
              compiledContents(scope, function (clone) {
                element.append(clone);
              });

              // Call the post-linking function, if any
              if (link && link.post) {
                link.post.apply(null, arguments);
              }
            }
          };
        }
      };
    }])
    /**
     * Provider: Provide Bento JS Root
     */
    .provider('$bentoJSRoot', function () {
      var bentoJSRootLink;
      var _this = this;

      /**
       * configAngularTranslateProvider
       * @param componentName
       * @param $translateProvider
       * @param $bentoTranslateLoaderProvider
       * @param defaultLanguage
       *
       * Configures $translateProvider for multilingual support
       */
      this.configAngularTranslateProvider = function (componentName, $translateProvider, $bentoTranslateLoaderProvider, defaultLanguage) {
        //Setup Bento Translate Loader
        //
        // Concert Example:
        //
        // $bentoTranslateLoaderProvider.addURLPattern('components/languages/lang-{lang}.js');
        //
        $bentoTranslateLoaderProvider.addURLPattern(_this.getBentoJSRoot(componentName) + 'i18n/' + componentName + '-{lang}.json');

        // Use Bento Translate Loader
        $translateProvider.useLoader('$bentoTranslateLoader');

        // Default all languages to en_us for the time been
        if (!!defaultLanguage) {
          $translateProvider.preferredLanguage(defaultLanguage.replace('-', '_').toLowerCase());
        } else {
          $translateProvider.preferredLanguage('en');
        }

        $translateProvider.translationNotFoundIndicatorLeft('!');
        $translateProvider.translationNotFoundIndicatorRight('!');

        $translateProvider.fallbackLanguage(defaultLanguage);
      };

      /**
       * getBentoJSRoot
       * @param elementName
       * @returns {string}
       */
      this.getBentoJSRoot = getBentoJSRoot;

      function getBentoJSRoot(elementName) {
        var bentoLinks = document.querySelectorAll('script[src]');  //document.querySelector('script[src~="/bento-"');
        var index = -1;
        for (var i = 0; i < bentoLinks.length; i++) {

          if (bentoLinks[i].attributes['src'].value.search('/' + elementName) != -1) {
            index = i;
            break;
          } else if (bentoLinks[i].attributes['src'].value.search('components/bento-modern.') != -1) {
            index = i;
            break;
          }
        }

        // currentJSFileSrc is a Global variable to this JS file
        // Check if bento.ui is loaded individually
        var bentoLinkTemp = (index === -1) ?
          // Death start approach
          currentJSFileSrc.split('/') :
          // Found it!
          bentoLinks[index].src.split('/');
        bentoLinkTemp.pop();
        bentoJSRootLink = bentoLinkTemp.join('/') + '/';

        return bentoJSRootLink;
      }

      /**
       * Turn on or of Full Console Error reporting where Chrome omits most of the outputs
       * @param bool
       */
      this.turnOnFullErrorReporting = function (bool) {
        if (bool) {
          //Chrome passes the error object (5th param) which we must use since it now truncates the Msg (1st param).
          window.onerror = function (errorMsg, url, lineNumber, columnNumber, errorObject) {
            var errMsg;
            //check the errorObject as IE and FF don't pass it through (yet)
            if (errorObject && errorObject !== undefined) {
              errMsg = errorObject.message;
            }
            else {
              errMsg = errorMsg;
            }
            window.console.log('Full Error: ' + errMsg);
          };
        } else {
          window.onerror = null;
        }
      };

      this.$get = [function () {
        if (typeof bentoJSRootLink === 'undefined') {
          getBentoJSRoot(currentJSFileSrc);
        }
        return bentoJSRootLink;
      }];
    });

  function getOS() {
    // Adding os name to body
    var OSName = navigator.appVersion;
    var os = 'unknown-os';
    if (OSName.indexOf("Win") !== -1) {
      os = 'win';
    } else if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
      os = 'ios';
    } else if (OSName.indexOf("Mac") !== -1) {
      os = 'mac';
    } else if (navigator.userAgent.toLowerCase().indexOf("android") > -1) {
      os = 'android';
    } else if (OSName.indexOf("X11") !== -1) {
      os = 'unix';
    } else if (OSName.indexOf("Linux") !== -1) {
      os = 'linux';
    } else if (OSName.indexOf("SunOS") !== -1) {
      os = 'solaris';
    }
    return os;
  }

  function getBrowser() {
    // Adding brower name and version to body
    var isOpera        = !!window.opera || (navigator && navigator.userAgent.indexOf(' OPR/') >= 0),
        isFirefox      = typeof InstallTrigger !== 'undefined',
        isSafari       = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0,
        isMobileSafari = (navigator.userAgent && (navigator.userAgent.search("Mobile") > -1) && (navigator.userAgent.search("Safari") > -1)),
        isiOSChrome    = navigator.userAgent.match('CriOS'),
        isChrome       = !!window.chrome && !isOpera,
        isIE           = /*@cc_on!@*/false || !!document.documentMode,
        browser        = 'unknown-browser',
        browserVersion = 'unknown-browser-version',
        version;

    var os = getOS();

    try{
      if (isiOSChrome) {
        browser = 'ios_chrome';
        browserVersion = browser + navigator.userAgent.match(/CriOS\/(\d+)/i)[1];
      } else if (isMobileSafari && os !== 'android') {
        browser = 'mobile_safari';
        browserVersion = browser + navigator.userAgent.match(/version\/(\d+)/i)[1];
      } else if (isOpera) {
        browser = 'opera';
        browserVersion = browser + (window.opera ? window.opera.version() : navigator.userAgent.match(/opr\/(\d+)/i)[1]);
      } else if (isFirefox && navigator.userAgent) {
        browser = 'firefox';
        browserVersion = browser + navigator.userAgent.match(/firefox\/(\d+)/i)[1];
      } else if (isSafari && navigator.userAgent.search(/version/i) !== -1) {
        browser = 'safari';
        browserVersion = browser + navigator.userAgent.match(/version\/(\d+)/i)[1];
      } else if (isChrome && navigator.userAgent) {
        browser = 'chrome';
        version = navigator.userAgent.match(/chrome\/(\d+)/i);
        // Android Jellybean and below don't have Chrome/[version] parameter so we skip them
        if (version) {
          browserVersion = browser + navigator.userAgent.match(/chrome\/(\d+)/i)[1];
        }
      } else if (isIE && navigator.userAgent) {
        browser = 'ie';
        if (navigator.userAgent.search('like Gecko') !== -1) {
          browserVersion = browser + '11';
        } else {
          browserVersion = browser + navigator.userAgent.match(/msie\ (\d+)/i)[1];
        }
      } else if (isOpera) {
        browser = 'opera';
        if (window.opera) {
          browserVersion = browser + window.opera.version();
        } else {
          browserVersion = browser + navigator.userAgent.match(/ OPR\/(\d+)/i)[1];
        }
      } //else if(os !== 'android' &&)
    } catch (e){
      // This browser is unknown;
    }

    return {
      browser       : browser,
      browserVersion: browserVersion
    }
  }

})(window.angular);

(function() {
  'use strict';

  angular.module('bento.services')
    .service('flexGridSetUpService', flexGridSetUpService);

  flexGridSetUpService.$inject = ['$rootScope', '$timeout'];

  function flexGridSetUpService($rootScope, $timeout) {
    var self = this;
    var ON_MULTI_SELECT = 'onMultiSelect';
    this.multiSelectPanelObj = {}

    this.setUpCulture = function(){
      wijmo.culture.FlexGridFilter = {
        // filter
        ascending: '\u2191 Ascending',
        descending: '\u2193 Descending',
        apply: 'Apply',
        clear: 'Clear',
        conditions: 'Filter by Condition',
        values: 'Filter by Value',
        // value filter
        search: 'Search',
        selectAll: 'Select All',
        null: '(nothing)',
        // condition filter
        header: 'Show items where the value',
        and: 'And',
        or: 'Or',
        stringOperators: [
          { name: '(not set)', op: null },
          { name: 'Equals', op: 0 /* EQ */ },
          { name: 'Does not equal', op: 1 /* NE */ },
          { name: 'Begins with', op: 6 /* BW */ },
          { name: 'Ends with', op: 7 /* EW */ },
          { name: 'Contains', op: 8 /* CT */ },
          { name: 'Does not contain', op: 9 /* NC */ }
        ],
        numberOperators: [
          { name: '(not set)', op: null },
          { name: 'Equals', op: 0 /* EQ */ },
          { name: 'Does not equal', op: 1 /* NE */ },
          { name: 'Is Greater than', op: 2 /* GT */ },
          { name: 'Is Greater than or equal to', op: 3 /* GE */ },
          { name: 'Is Less than', op: 4 /* LT */ },
          { name: 'Is Less than or equal to', op: 5 /* LE */ }
        ],
        dateOperators: [
          { name: '(not set)', op: null },
          { name: 'Equals', op: 0 /* EQ */ },
          { name: 'Is Before', op: 4 /* LT */ },
          { name: 'Is After', op: 2 /* GT */ }
        ],
        booleanOperators: [
          { name: '(not set)', op: null },
          { name: 'Equals', op: 0 /* EQ */ },
          { name: 'Does not equal', op: 1 /* NE */ }
        ]
      };
    }

    this.updateFlexGridRowHeight = function(grid, height, headHeight) {
      height = height || 48;
      grid.rows.defaultSize = height;
      var headerHeight = 48;
      for (var i = 0, total = grid.columnHeaders.rows.length; i < total; i++) {
        grid.columnHeaders.rows[i].height = headHeight && headHeight[i] ? headHeight[i] : headerHeight;
      }
    };

    this.setUpRowHeader = function(panel, r, c, cell) {
      if (panel.cellType == wijmo.grid.CellType.RowHeader) {
        cell.style.textAlign = 'right';
        cell.textContent = (r + 1).toString();
      }
    };

    this.initFilters = function(grid, gridFilter, filteredCols) {
      if (!gridFilter) {
        gridFilter = new wijmo.grid.filter.FlexGridFilter(grid);
        // gridFilter.filterColumns = filteredCols;
        // grid.autoSizeColumns();
        self.toggleFilter(false, gridFilter, filteredCols);
      }
      return gridFilter;
    };

    this.setUpActions = function(panel, r, c, cell, header) {
      var col = panel.columns[c];
      if (col.header === header) {
        cell.className += " cell-actions";
      }
    };

    this.addClassToColumnByHeader = function(panel, r, c, cell, header, className) {
      var col = panel.columns[c];
      if (col.header === header) {
        cell.className += " " + className;
      }
    };

    this.addClassToColumnByBinding = function(panel, r, c, cell, binding, className) {
      var col = panel.columns[c];
      if (col.binding === binding) {
        cell.className += " " + className;
      }
    };

    this.setUpColumnVisibility = function(flex, colBindings, colNum) {
      if (flex && colBindings.length > 0) {
        var columnBindingsToggle = [];
        var columnVis = {};
        // var colBindings = Object.keys(data[0]);
        var ttl = colBindings.length;
        var cols = colNum ? colNum : 5;
        var rows = Math.ceil(ttl / cols);
        var count = 0;
        for (var i = 0; i < cols; i++) {
          columnBindingsToggle[i] = [];
          for (var j = 0; j < rows; j++) {
            columnBindingsToggle[i][j] = colBindings[count];
            count++;
            if (count >= ttl) {
              break;
            }
          }
        }
        for (var i = 0; i < colBindings.length; i++) {
          columnVis[colBindings[i].binding] = true;
        }
        return {
          columnBindingsToggle: columnBindingsToggle,
          columnVis: columnVis
        }
      }
    }

    this.toggleFilter = function(filtersHidden, gridFilter, filteredCols) {
      //if flexgrid available
      if (gridFilter) {
        //get FlexGridFilter, defined in initGrid
        var f = gridFilter;
        if (f) {
          //if filters are hidden, clear the grid filter
          if(filtersHidden){
            f.clear();
          }
          //iterate through columns to filtered
          for (var i = 0, il = filteredCols.length; i < il; i++) {
            //get column and column filter
            var col = f.grid.columns.getColumn(filteredCols[i].binding),
                cf = col ? f.getColumnFilter(col, true) : {};
            //switch filterType to 0 if filters hidden, otherwise to filterType defined in model
            cf.filterType = filtersHidden ? 0 : filteredCols[i].filterType;
          }

        }
        //refresh grid
        f.grid.refresh();
      }

    }


  }
})();
(function (angular, window, undefined) {

  'use strict';

  angular.module('bento.inputblur', [])
  // Supporting directive for input fields
    .directive('input',directiveFunction)
    // Supporting directive for textarea fields
    .directive('textarea',directiveFunction);

  directiveFunction.$inject = ['$bentoServices'];

  /**
   * Input Blur and Textarea blur directive definition
   * @param $bentoServices
   * @returns {{restrict: string, require: string, link: Function}}
   */
  function directiveFunction($bentoServices) {
    return {
      restrict: 'E',
      require : '?ngModel',
      link    : function (scope, element, attr, control) {
        if (!control) {
          return;
        }

        element.on('focus', function () {
          // Using safe apply to comply bug [CXUI-289]
          $bentoServices.safeApply(scope,function () {
            element.addClass('has-focus');
            control.hasFocus = true;
          });
        });

        element.on('blur', function () {
          // Using safe apply to comply bug [CXUI-289]
          $bentoServices.safeApply(scope,function () {
            element.removeClass('has-focus');
            element.addClass('has-visited');
            control.hasFocus = false;
            control.hasVisited = true;
          });
        });

        // extend $setPristine()
        if (!!control.$setPristine) {
          control.$setPristineUsedByBentoInputBlur = control.$setPristine;

          control.$setPristine = function () {
            // called Super function
            control.$setPristineUsedByBentoInputBlur();
            // Resetting hasVisited flag

            $bentoServices.safeApply(scope,function () {
              element.removeClass('has-visited');
              control.hasVisited = false;
            });
          };
        }
      }
    };
  }
})(window.angular, window);
/* jshint -W016 */
(function (window, angular, undefined) {

  'use strict';

  angular.module('bento.busyloader', ['bento.services', 'bento.translate'])
  /**
   * Config to add $http interceptions
   */
    .config([
      '$provide',
      '$httpProvider',
      function ($provide, $httpProvider) {

        /**
         * Register a new interceptor for Busy Loader for auto show and hide
         */
        $provide.factory('bentoBusyLoaderHttpInterceptor', [
          '$q',
          '$log',
          function ($q, $log) {

            /**
             * Get a BentoBusyLoader from the config file, undefined otherwise
             * @param config
             * @returns {*}
             */
            var getBusyLoader = function (config) {
              // There is nothing assigned to config
              if (typeof config === 'undefined') {
                return undefined;
              }

              // Make sure busyLoader is assigned as part of the config object
              // And the object is a `BentoBusyLoader` instance
              if (!!config.busyLoader) {
                return config.busyLoader;
              } else {
                return undefined;
              }
            };

            /**
             * Show the Busy Loader referenced from the config object
             * @param config
             */
            var showBusyLoader = function (config) {
              var busyLoader = getBusyLoader(config);

              if (!!busyLoader) {
                busyLoader.show(config.showDelay || 0);
              }
            };

            /**
             * Hides the Busy Loader referenced from the config object
             * @param config
             */
            var hideBusyLoader = function (config) {
              var busyLoader = getBusyLoader(config);

              if (!!busyLoader) {
                busyLoader.hide(config.hideDelay || 0);
              }
            };

            /**
             * Return all $http interception results
             */
            return {
              // optional method
              'request': function (config) {
                // do something on success
                showBusyLoader(config);
                return config;
              },

              // optional method
              'requestError': function (rejection) {
                // do something on error
                //hideBusyLoader(rejection.config);

                return $q.reject(rejection);
              },

              // optional method
              'response': function (response) {
                // do something on success
                hideBusyLoader(response.config);
                return response;
              },

              // optional method
              'responseError': function (rejection) {
                // do something on error
                // hideBusyLoader(rejection.config);

                return $q.reject(rejection);
              }
            };

          }]);

        // Push the interceptor to $httpProvider.interceptor stack
        $httpProvider.interceptors.push('bentoBusyLoaderHttpInterceptor');

      }
    ])
    /**
     * Provides Busy Loader services
     */
    .factory('$bentoBusyLoader', [
      '$timeout',
      '$log',
      '$q',
      '$bentoServices',
      '$bentoTranslate',
      function ($timeout, $log, $q, $bentoServices, $bentoTranslate) {

        // Busy Loader Object
        function BentoBusyLoader(_dom, _size) {
          // Normalize DOM type
          var dom                = typeof _dom === 'string' ? document.querySelector(_dom) : _dom,
              bgSize             = '',
              canvasSize,
              loaderSize,
              isPositionedStatic = false,
              showTimeoutID,
              hideTimeoutID,
              self               = this
          ;

          _size = _size? _size:'default';

          // Now we can set the size of the spinner animation
          switch (_size) {
            case 'small' :
              canvasSize = 24;
              break;
            default:
              canvasSize = 75;
          }


          // Create loader dom elements
          var loader  = angular.element('<div tabindex="0" ' +
            'class="' + ['bento-busyloader-blocker', bgSize].join(' ') + '">' +
            '<div class="bento-busyloader-wrapper"><div class="bento-busyloader-inner">' +
            '<svg ' +
            'class="bento-busyloader-svg bento-busyloader-svg-'+_size+'" preserveAspectRatio="none"' +
            //'width="' + canvasSize + '" height="' + canvasSize + '"' +
            'viewBox="0 0 '+canvasSize+' '+canvasSize+'"' +
            '></svg>' +
            '</div></div>' +
            '</div>'),

              // Insert loader HTML code into the DOM
              mainDom = angular.element(dom),
              mainDomPosition,
              blocker = angular.element('<div tabindex="0" class="bento-busyloader-front-blocker"></div>')
          ;

          // SR Support
          applySR();
          function applySR() {
            $bentoTranslate.translate('BENTO_UI_BUSY_LOADER_LOADING')
              .then(function (value) {
                loader.attr('aria-label', value);
                blocker.attr('aria-label', value);
              });
          }

          $bentoTranslate.onChange(applySR);
          loader.on('$destroy', function () {
            $bentoTranslate.removeOnChange(applySR);
          });

          loader[0].addEventListener('keydown', function (event) {
            // Bypass the content from tabbing
            if (event.shiftKey && event.keyCode === 9) {
              blocker[0].focus();
            }
          });

          blocker[0].addEventListener('keydown', function (event) {
            // Bypass the content from tabbing
            if (!event.shiftKey && event.keyCode === 9) {
              loader[0].focus();
            }
          });

          this.show = function (delay) {
            var deferred = $q.defer();
            var _delay = (typeof delay === 'undefined') ? 0 : parseInt(delay, 10);

            // Clear any previous $timeout IDs
            $timeout.cancel(hideTimeoutID);

            showTimeoutID = $timeout(function () {
              // Adding loader
              mainDom.append(loader);
              mainDom.prepend(blocker);

              // Clear any previous $timeout IDs
              $timeout.cancel(showTimeoutID);

              // Make parent container 'relative' when it is static
              mainDomPosition = window.getComputedStyle(mainDom[0]).position.trim();

              // Check and assign `relative` position where it is at default, `static`
              if (mainDomPosition.length === 0 || mainDomPosition === 'static') {
                mainDom[0].style.position = 'relative';
                isPositionedStatic = true;
              }

              // svg render disabled
              startAnimate();

              deferred.resolve('Busy Loader is now bocking content');

              /*
               Gain focus if necessary and
               ONLY gains focus when this loader is an overlay
               */
              self.activeElement = document.activeElement;

              if (mainDom[0].contains(self.activeElement)) {
                loader[0].focus();
              } else {
                self.activeElement = undefined;
              }

            }, _delay);

            return deferred.promise;
          };

          this.hide = function (delay) {
            var _delay = (typeof delay === 'undefined') ? 0 : parseInt(delay, 10);
            var deferred = $q.defer();

            // Clear any previous $timeout IDs
            $timeout.cancel(hideTimeoutID);

            hideTimeoutID = $timeout(function () {
              // Clear any previous $timeout IDs
              $timeout.cancel(showTimeoutID);

              // Put static positioning back
              if (isPositionedStatic) {
                mainDom[0].style.position = null;
              }

              stopAnimate();

              deferred.resolve('Busy Loader is now hidden');

              /*
               Return focus if necessary
               */
              if (self.activeElement
                && (document.activeElement === loader[0] || document.activeElement === blocker[0])// focus hasn't
                                                                                                  // changed during
                                                                                                  // loading phase
              ) {
                self.activeElement.focus();
              }

              loader.remove();
              blocker.remove();
            }, _delay);

            return deferred.promise;

          };

          // svg spinner animation code
          // rFA is used for animation part to minimize CPU load
          var svg,
              intervalDelay   = 150,
              currentArcIndex = 0,
              arcs            = [],
              setIntID,
              radius          = canvasSize / 2,
              segments        = 8,
              stroke          = radius * 0.40,
              gap             = 7;

          /**
           * Start animation
           */
          function startAnimate() {
            clearInterval(setIntID);
            setIntID = setInterval(tick, intervalDelay);
          }

          /**
           * Stop animation
           */
          function stopAnimate() {
            clearInterval(setIntID);
          }

          /**
           *
           */
          function tick() {
            var arc = arcs[currentArcIndex];
            currentArcIndex = (currentArcIndex - 1 + arcs.length) % arcs.length;

            arc.setAttribute('class', 'bento-busyloader-arc bento-busyloader-arc-alt');

            setTimeout(function () {
              arc.setAttribute('class', 'bento-busyloader-arc');
            }, 200);
          }

          // Spinner init
          function initSpinner() {
            var arcSize = 360 / segments,
                arc
            ;
            svg = angular.element(loader[0].getElementsByTagName('svg')[0]);
            //svg is not ready when render is called by apps
            if (!svg) {
              return;
            }
            for (var i = 0; i < segments; i++) {
              arc = getSegment(i, arcSize, gap, stroke, radius);
              arcs.push(arc);
              svg.append(arc);
            }
          }

          function getSegment(segNum, arcSize, gap, stroke, radius) {
            var nRadius = radius - stroke * 0.5,
                startD  = getRadianFromDegree((segNum * arcSize + gap * 0.5)),
                endD    = getRadianFromDegree(segNum * arcSize + arcSize - gap * 0.5),
                d       = (radius + Math.sin(startD) * (radius - stroke * 0.5)) + ' ' +  // X1
                  (radius + Math.cos(startD) * (radius - stroke * 0.5)) + ' ' + // Y1
                  'A ' + nRadius + ' ' + nRadius + ' 0 0 0 ' + // min point
                  (radius + Math.sin(endD) * nRadius) + ' ' + // X2
                  (radius + Math.cos(endD) * nRadius), // Y1
                path    = document.createElementNS('http://www.w3.org/2000/svg', 'path')
            ;
            path.setAttribute('d', 'M' + d);
            path.setAttribute('stroke-width', stroke);
            path.setAttribute('fill', 'none');
            path.setAttribute('class', 'bento-busyloader-arc');

            return path;
          }

          function getRadianFromDegree(degrees) {
            return degrees * (Math.PI / 180);
          }

          initSpinner();
        }

        var getNewLoader = function (dom, size) {
          return new BentoBusyLoader(dom, size);
        };

        // Finally return the actual loader
        return {
          getNewLoader: getNewLoader
        };
      }])
    .directive('bentoBusyLoader', [
      '$bentoBusyLoader',
      '$log',
      function ($bentoBusyLoader, $log) {
        return {
          scope: {
            bentoBusyLoader    : '=',  //get Busy Loader state
            bentoBusyLoaderSize: '@' //define the size of BL
          },
          link : function (scope, element, attr) {

            var busyLoader = $bentoBusyLoader.getNewLoader(element, scope.bentoBusyLoaderSize);

            // Watch loader variable
            scope.$watch('bentoBusyLoader', function (newVal) {
              if (newVal) {
                busyLoader.show();
              } else {
                busyLoader.hide();
              }
            });
          } // end of link
        };
      }
    ])
    .directive('busyLoader', [
      '$bentoBusyLoader',
      '$log',
      function ($bentoBusyLoader, $log) {
        return {
          scope: {
            busyLoader    : '=',  //get Busy Loader state
            busyLoaderSize: '@' //define the size of BL
          },
          link : function (scope, element, attr) {

            $log.warn('`busy-loader` directive is deprecated, use `bento-busy-loader`.');

            var busyLoader = $bentoBusyLoader.getNewLoader(element, scope.busyLoaderSize);

            // Watch loader variable
            scope.$watch('busyLoader', function (newVal) {
              if (newVal) {
                busyLoader.show();
              } else {
                busyLoader.hide();
              }
            });
          } // end of link
        };
      }
    ])
  ;
})(window, window.angular);

(function () {
  'use strict';

  angular.module('bento.carousel', ['bento.services'])
  /**
   * Main Bento Carousel Directive
   */
    .directive('bentoCarousel', [
      function () {
        return {
          scope     : false,
          restrict  : 'EA',
          controller: 'bentoCarouselController',
          link      : bentoCarouselLink
        }
      }
    ])
    .controller('bentoCarouselController', bentoCarouselMainController)
    /**
     * Bento Carousel Card Directive
     * Defines card class and as a parent of card templates
     */
    .directive('bentoCarouselCard',
      function () {
        return {
          //require: '^bentoCarousel',
          restrict: 'EA',
          scope   : false,
          link    : bentoCarouselCardLink
        }
      }
    );

  /**
   * Bento Carousel Card Directive Main Link
   * @param scope
   * @param element
   * @param attrs
   * @param ctrl
   */
  function bentoCarouselCardLink(scope, element, attrs, ctrl) {
    attrs.$addClass('bento-carousel-card');
    //attrs.$set('tabindex', '0');
    attrs.$set('role', 'card');
  }

  /**
   * bentoCarouselMainController for main directive
   */
  bentoCarouselMainController.$inject = [
    '$scope',
    '$element',
    '$timeout',
    '$rootScope',
    '$compile',
    '$attrs',
    '$bentoServices'];
  function bentoCarouselMainController($scope, $element, $timeout, $rootScope, $compile, $attrs, $bentoServices) {
    // init variables
    var ctrl = this;
    var slideshowTimeout = 5000;
    var slideshowTimeoutPromise;
    var cardHeightStyle = document.createElement('style');
    ctrl.localScope = $rootScope.$new();
    ctrl.localScope.dots = ['active'];

    if($attrs.slideshow){
      $timeout(autoChangeSlides);
    }

    var scrollXTimeout;
    var cardMargin = 20;
    var currentPage = 0;
    ctrl.dom = {};
    ctrl.dom.mainContainer = angular.element($element[0].querySelector('ul'));

    // Dom change after all scopes are linked
    $timeout(function () {
      ctrl.dom.mainContainer.wrap('<div class="bento-carousel-container"></div>');
    });

    ctrl.dom.leftArrow = angular.element(
      '<div class="bento-carousel-left-arrow bento-carousel-arrow" ' +
      'ng-show="showLeftArrow && !hideArrows" ' +
      'ng-click="onLeftArrowClick()">' +
      '<i class="bento-icon-chevron-left"></i>' +
      '</div>');
    ctrl.dom.rightArrow = angular.element(
      '<div class="bento-carousel-right-arrow bento-carousel-arrow" ' +
      'ng-show="showRightArrow  && !hideArrows" ' +
      'ng-click="onRightArrowClick();">' +
      '<i class="bento-icon-chevron-right"></i>' +
      '</div>');
    ctrl.dom.dots = angular.element(
      '<div class="bento-carousel-dots">' +
      '<button class="bento-carousel-dot {{dot}}" ' +
      'ng-click="onDotClick($index)" ' +
      'ng-repeat="dot in dots track by $index">' +
      '</button></div>');

    ctrl.localScope.onLeftArrowClick = function () {
      var dX = ctrl.dom.mainContainer.children()[0].offsetWidth * 0.5;
      scrollTo(ctrl.dom.mainContainer[0].scrollLeft - dX);

      if($attrs.slideshow){
        $timeout.cancel(slideshowTimeoutPromise);
        slideshowTimeoutPromise = $timeout(autoChangeSlides, slideshowTimeout + 1000);
      }
    };

    ctrl.localScope.onRightArrowClick = function (isAuto) {
      var dX = ctrl.dom.mainContainer.children()[0].offsetWidth * 1.5;
      scrollTo(ctrl.dom.mainContainer[0].scrollLeft + dX);

      if($attrs.slideshow && !isAuto){
        $timeout.cancel(slideshowTimeoutPromise);
        slideshowTimeoutPromise = $timeout(autoChangeSlides, slideshowTimeout + 1000);
      }
    };

    ctrl.localScope.onDotClick = function (page) {
      //reset all dots
      for (var i = 0; i < ctrl.localScope.dots.length; i++) {
        ctrl.localScope.dots[i] = '';
      }
      // activate the current page dot
      ctrl.localScope.dots[page] = 'active';

      // scroll to the new page
      scrollTo(ctrl.dom.mainContainer[0].offsetWidth * page);
    };

    $compile(ctrl.dom.leftArrow)(ctrl.localScope);
    $compile(ctrl.dom.rightArrow)(ctrl.localScope);
    $element.append(ctrl.dom.leftArrow);
    $element.append(ctrl.dom.rightArrow);

    $compile(ctrl.dom.dots)(ctrl.localScope);
    $element.append(ctrl.dom.dots);

    // inject card height with variable binding
    $element[0].parentNode.insertBefore(cardHeightStyle, $element[0]);

    // Watch children size to refresh rendering for dots
    $scope.$watch(function () {
      return ctrl.dom.mainContainer.children().length
    }, function (numChildren) {
      // Always make sure that AngularJS has finished rendering the children
      $timeout(function () {
        updateDotsAndArrows();
      });
    });

    // Watch children heights
    $scope.$watch(function(){
      var children = ctrl.dom.mainContainer.children();
      var maxHeight = 0;
      var h;
      for(var i=0; i<children.length; i++){
        h = children[i].firstElementChild.offsetHeight;
        if(h > maxHeight){
          maxHeight = h;
        }
      }
      return maxHeight;
    }, function(newHeight){
      cardHeightStyle.innerHTML = '.bento-carousel .bento-carousel-card{height:'+newHeight+'px}';
    });

    // Watch windows resize
    var timeoutID = 0;
    angular.element(window).on('resize', onWindowResize);

    // Function to fire on window resize
    function onWindowResize(){
      $timeout.cancel(timeoutID);
      timeoutID = $timeout(function () {
        updateDotsAndArrows();
        $bentoServices.safeApply(ctrl.localScope);
      }, 500);
    }

    ctrl.dom.mainContainer.on('scroll', function () {
      $timeout.cancel(timeoutID);
      timeoutID = $timeout(function () {
        updateDotsAndArrows();
        $bentoServices.safeApply(ctrl.localScope);
      }, 100);
    });

    // Listen to mouseenter and mouseleave to enable and disable slideshow
    ctrl.dom.mainContainer.on('mouseenter', function(event){
      if($attrs.slideshow){
        $timeout.cancel(slideshowTimeoutPromise);
      }
    });

    ctrl.dom.mainContainer.on('mouseleave', function(event){
      if($attrs.slideshow){
        slideshowTimeoutPromise = $timeout(autoChangeSlides, slideshowTimeout);
      }
    });

    // Function for slideshow
    function autoChangeSlides(){
      var container = ctrl.dom.mainContainer[0];
      var safeNumX = container.scrollWidth - container.offsetWidth;
      $timeout.cancel(slideshowTimeoutPromise);

      if(container.scrollLeft  === safeNumX){
        scrollTo(0);
      }else{
        ctrl.localScope.onRightArrowClick(true);
      }


      slideshowTimeoutPromise = $timeout(autoChangeSlides, slideshowTimeout);
    }

    // Animate scrolling
    function scrollTo(numX) {
      $timeout.cancel(scrollXTimeout);
      if (numX < 0) {
        numX = 0;
      }
      var container = ctrl.dom.mainContainer[0];
      // Prevent from over scroll effect
      var safeNumX = container.scrollWidth - container.offsetWidth;
      // last page
      if (safeNumX < numX) {
        numX = safeNumX;
      }
      // snap to a cell
      else if (numX !== 0) {
        // find and align with card
        var cardIndexToShow = 0;
        var cards = ctrl.dom.mainContainer.children();
        for (var i = 0; i < cards.length; i++) {
          if (cards[i].offsetLeft > numX) {
            cardIndexToShow = i - 1;
            break;
          }
        }
        numX = cards[cardIndexToShow].offsetLeft - cardMargin * 0.5;
      }
      // animate scrolling
      scrollToAnimate(numX, 500, container);
    }

    // using RAF with (x-1)^3+1 curve easing
    function scrollToAnimate(scrollX, duration, container, originalTime, originalX, dX) {
      if(typeof originalTime === 'undefined'){
        originalTime = new Date();
        originalX = container.scrollLeft;
        dX = scrollX-originalX;
      }

      var currentTime = new Date();
      var dTimeRatio = Math.pow((currentTime.getTime() - originalTime.getTime()) / duration -1, 3) + 1; // (x-1)^3 + 1
      var distanceByRatio = dTimeRatio * dX;

      if (Math.abs(dX - distanceByRatio) < 1) {
        container.scrollLeft = scrollX;
      } else {
        container.scrollLeft = originalX + distanceByRatio;
        $bentoServices.rAF(function(){
          scrollToAnimate(scrollX, duration, container, originalTime, originalX, dX);
        });
      }
    }

    function updateDotsAndArrows() {
      var container = ctrl.dom.mainContainer[0];

      if (container.scrollWidth === container.offsetWidth) {
        ctrl.localScope.dots = ['active'];
        currentPage = 0;
      } else {
        var newDots = [];
        var numPages = Math.ceil(container.scrollWidth / container.offsetWidth);
        currentPage = Math.ceil(container.scrollLeft / container.offsetWidth);
        for (var i = 0; i < numPages; i++) {
          newDots.push('');
        }
        newDots[currentPage] = 'active';
        ctrl.localScope.dots = newDots;
      }

      // Show hide arrows
      ctrl.localScope.showLeftArrow = (container.scrollLeft > 0);
      ctrl.localScope.showRightArrow = (container.scrollLeft + container.offsetWidth < container.scrollWidth);

    }

    // on $destroy cleanup
    $element.on('$destroy',function(){
      // remove window resize listener and its timeout
      $timeout.cancel(timeoutID);
      angular.element(window).off('resize', onWindowResize);
    });
  }

  /**
   * Bento Carousel driective link function
   * @param scope
   * @param element
   * @param attrs
   * @param ctrl
   */
  function bentoCarouselLink(scope, element, attrs, ctrl) {
    attrs.$addClass('bento-carousel');
    // Determine if need to hide arrows
    ctrl.localScope.hideArrows = !!attrs.hideArrows && attrs.hideArrows.toLowerCase() === 'true';
    ctrl.localScope.arrowOffset = !!attrs.arrowOffset ? attrs.arrowOffset : '0';

    // Update arrow offset
    ctrl.dom.leftArrow[0].style.left = '-'+ctrl.localScope.arrowOffset;
    ctrl.dom.rightArrow[0].style.right = '-'+ctrl.localScope.arrowOffset;

    // Adding gutter size override
    var customStyling;

    // Adjust gutter size
    if (!!attrs.gutterSize) {
      customStyling = '.bento-carousel-container>ul>li{' +
        'margin-right:' + attrs.gutterSize +
        '}';
    }
    // Change indicator color
    if (!!attrs.indicatorColor) {
      customStyling += '.bento-carousel-dots .bento-carousel-dot{' +
        'border:1px solid ' + attrs.indicatorColor +
        '}';
      customStyling += '.bento-carousel-dots .bento-carousel-dot.active{' +
        'background:' + attrs.indicatorColor +
        '}';
    }

    var styleNode = document.createElement('style');
    styleNode.innerHTML = customStyling;

    element[0].parentNode.insertBefore(styleNode,element[0]);
  }

})();
(function () {
  'use strict';
  angular.module('bento.carousel')
    .directive('bentoCarouselCardTemplate', [
      '$timeout',
      function ($timeout) {
        return {
          scope   : {
            cardData          : '=',  // Card Data
            cardName          : '=',  // This Card's Main Name
            cardSecondaryName : '=?', // This Card's Secondary Name
            cardTimestamp     : '=',  // Time stamp in [Date] object
            cardTemplateUrl   : '=',  // URL to the card inner template
            hideNewTabIcon    : '=',  // Show/Hide new tab icon
            onNewTabClick     : '&',  // Tab click callback
            enablePopover     : '='   // Enable/Disable Popover
          },
          templateUrl: '../templates/carousel/bento-carousel-card-default.html'
          ,
          link    : function (scope) {
            /**
             * Fire tab click callback function
             * @param $event
             */
            scope.newTabClick = function ($event) {
              scope.onNewTabClick({cardData: scope.cardData});
              $event.stopPropagation();
              $event.preventDefault();
            };

            /**
             * Set the main name from car templates
             * @param name
             */
            scope.setName = function(name){
              scope.cardName = name;
            };

            /**
             * Set secondary name from car templates
             * @param name
             */
            scope.setSecondaryName = function(name){
              scope.cardSecondaryName = name;
            };

            /**
             * PRIVATE DO NOT CHANGE
             */

            /**
             * Bottom Day feedback calculation and updates
             */
            var today, tempToday, oldDay, updateTimeout;

            // Initiate
            calcDays();

            // Clean timeout queue
            scope.$on('$destroy', function () {
              $timeout.cancel(updateTimeout);
            });

            /**
             * Calculate the time difference and update the `date` label for hourly date
             */
            function calcDays() {



              if(scope.cardTimestamp && scope.cardTimestamp.getDate) {
                tempToday = new Date();
                today = new Date(
                  tempToday.getUTCFullYear(),
                  tempToday.getUTCMonth(),
                  tempToday.getUTCDate());
                oldDay = new Date(
                  scope.cardTimestamp.getUTCFullYear(),
                  scope.cardTimestamp.getUTCMonth(),
                  scope.cardTimestamp.getUTCDate());

                scope.dDay = Math.floor((today.getTime() - oldDay.getTime())/ (86400000));

                // `scope.date` is assigned with Bento Translate label
                if (scope.dDay === 0) {
                  scope.date = 'BENTO_UI_TODAY';
                }
                else if (scope.dDay === 1) {
                  scope.date = 'BENTO_UI_YESTERDAY';
                } else {
                  scope.date = 'BENTO_UI_N_DAY_AGO';
                }
              }else{
                scope.date = null;
              }

              // Calculate for the next update
              // Every update should be at the first second of each hour
              var secondsUntilNextUpdate = (60 - today.getMinutes()) * 60 - today.getSeconds() + 1;
              updateTimeout = $timeout(calcDays, secondsUntilNextUpdate * 1000);

            }

            scope.onHeaderClick = function (event) {
              event.stopPropagation();
              event.preventDefault();
            }
          }
        }
      }])
})();

(function (angular, undefined) {

  "use strict";

  var comboboxApp = angular.module('bento.combobox', [
    'ngSanitize',
    'bento.services',
    'bento.busyloader',
    'bento.translate'
  ]);

  comboboxApp
  /**
   * CONSTANTS
   */
    .constant('COMBOBOX_PAGE_UP', -1)  // Page up direction
    .constant('COMBOBOX_PAGE_DOWN', 1) // page down direction
    /**
     * DIRECTIVE: bentoCombobox
     */
    .directive('bentoCombobox', [
      '$document',
      '$timeout',
      '$parse',
      '$bentoServices',
      function ($document, $timeout, $parse, $bentoServices) {
        return {
          require    : ['ngModel', '?flexgridControl'],
          scope      : {
            getData                : '&',
            headers                : '=',     // headers
            headerIndex            : '=?',    // header index to be displayed in the input field
            headerTemplate         : '=',     // Template support for headers
            ignoreInputClick       : '&',     // To ignore click even for the input field
            inputLabel             : '=?inputText',
            labelName              : '@',
            minSearchCharacterCount: '=?',    // Determines minimum character count to trigger
                                              // server search
            ngDisabled             : '&',
            ngHide                 : '&',     // Track ng-hide
            ngModel                : '=',
            ngShow                 : '&',     // Track ng-show
            onChange               : '&',
            placeholder            : '@',
            resetListOnSelect      : '&',     // Flag to determine whether to reset the list when a
                                              // selection is made
            revertOnInvalidInput   : '&',     // Revert selection on invalid inputs
            rowTemplate            : '&',     // Custom row template for this Combobox
            searchable             : '&',     // Check if this is searchable
            searchKeydownTimeout   : '&',     // Expose local `searchKeydownTimeout` to let dev to
                                              // control the delay
            type                   : '&',     // Table or normal
            useServer              : '&',
            controller             : '=?',    // controller to trigger internal instructions
            searchFunction         : '&',     // before the search starts
            // Footer Attributes to be forwarded
            footerOptions          : '&',     // Footer Object
          },
          templateUrl: function (element, attrs) {
            return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/combobox/bento-combobox.html';
          },
          replace    : true,
          link       : /**
           * Main Link function for Bento Combobox
           * @param scope
           * @param element
           * @param attrs
           * @param controllers
           */
          function comboboxMainLink(scope, element, attrs, controllers) {
            var controller      = controllers[0],
                flexgridControl = controllers[1];

            // Initialize scope variables
            scope.data = [];
            scope.selectedIndex = -1;
            scope.uid = 'bento-combobox-' + $bentoServices.generateUID();
            scope.minSearchCharacterCount = scope.minSearchCharacterCount || 1;

            scope.attrs = attrs; // link attrs for template to use

            // Initialize header index when header exists
            if (scope.headers) {
              // No header Index
              if (typeof scope.headerIndex === 'undefined') {
                if (typeof scope.labelName === 'undefined') {
                  scope.headerIndex = scope.headers[0];
                } else {
                  scope.headerIndex = 0;
                }
              }
            }

            // Set ng-form element state flags
            controller.$setUntouched();
            controller.$setPristine();

            // local variabled
            var $input     = angular.element(element[0].querySelector('input')),
                getLabel   = $parse(scope.labelName),
                blurTimeout,
                baseData,
                // `useServer` variabled
                focused    = false,
                isFullData = false,
                page       = 0,
                initLoad   = true,
                searchFunc
            ;

            // Check if there is a custom search function assigned
            if (attrs.searchFunction) {
              searchFunc = scope.searchFunction;
            }
            // Use default case insensitive global search
            else {
              searchFunc = function (obj) {
                return obj.string.toLowerCase().indexOf(obj.search.toLowerCase()) > -1;
              }
            }

            // Kick off initial data retrieval
            getData();

            // Add element event listener
            element.on('focusin', onInputFocus);
            element.on('focusout', onInputBlur);
            $input.on('click touchend', onInputClick);

            // Add destroy listener to Scope to make sure that the listeners are cleaned properly
            scope.$on('$destroy', function () {
              element.off('focusin', onInputFocus);
              element.off('focusout', onInputBlur);
              $input.off('click touchend', onInputClick);
              $input = undefined;
              document.removeEventListener('mousedown', onAppendToParentDocClick);
              document.removeEventListener('touchstart', onAppendToParentDocClick);
              window.removeEventListener('resize', onWindowResize);
            });

            window.addEventListener('resize', onWindowResize);

            function onWindowResize() {
              // Align header if there is any
              if (scope.containerCtrl) {
                scope.containerCtrl.align();
              }
            }

            // Watch ngModel to update the inputLabel accordingly
            var ignoreNgModelWatchOnce = false;
            scope.$watch('ngModel', function (object, previousObject) {
              // Nothing needs to be updated even when `ngModel` changes from `undefined` to `null`
              // or vice versa.
              // Use loose comparison here to match `undefined` with `null`
              if (!object && object == previousObject) return;

              // update Label
              if (!ignoreNgModelWatchOnce) {
                scope.inputLabel = getLabelText(object);
              }
              ignoreNgModelWatchOnce = false;

              inputLabelWatchIgnoreOnce = true;
            });

            // initialize controller object
            scope.controller = {
              reload      : function () {
                // Reset all internal references
                isFullData = false;
                baseData = undefined;
                autoSelectCatchUp = false;
                page = 0;
                scope.selectedIndex = -1;
                scope.data = [];
                scope.loadingData = false;
                controller.$setUntouched();
                controller.$setPristine();
                getData();
              },
              setTextField: function (str) {
                scope.inputLabel = str;
              }
            };

            function onAppendToParentDocClick(event) {
              var dropdownContainer = document.getElementById(scope.uid);
              if (dropdownContainer.contains(event.target) || event.target === dropdownContainer) {
                // Clear blur timeout
                $timeout.cancel(blurTimeout);
                ignoreBlur = true;

                if (event.type === 'mousedown') {
                  // Only prevent default from clicking for mouse
                  // Otherwise, the dropdown does not scroll on touch devices
                  event.stopPropagation();
                  event.preventDefault();
                }
              }
            }

            /**
             * When the dropdown is clicked
             * @return {[type]} [description]
             */
            var ignoreBlur;
            scope.onContainerMousedown = function () {
              // Clear blur timeout
              $timeout.cancel(blurTimeout);
              ignoreBlur = true;
            };

            /**
             * When the Dropdown button is clicked
             */
            scope.onButtonClick = function () {
              // Clear timeouts
              $timeout.cancel(blurTimeout);

              // Toggle container visibility
              showContainer(!scope.isContainerVisible);

              if (scope.isContainerVisible) {
                $input[0].select();
                if (scope.inputLabel) {
                  $input[0].setSelectionRange(scope.inputLabel.length, scope.inputLabel.length);
                }
              }

              // Safe apply the change to the scope
              $bentoServices.safeApply(scope);
            };

            /**
             * Callback function when an item is clicked
             * @param index
             */
            scope.onItemClick = function (index, ignoreFocus) {

              if (!ignoreFocus) {
                $timeout.cancel(blurTimeout);
                $input[0].focus();
              }

              // Combobox ngModel will be changed, there for the directive is now "dirty"
              controller.$setDirty();

              // Clear the keyboard dirty flag from the same data gets updated multiple time
              scope.isDirty = false;

              // Update input label immediately
              scope.inputLabel = getLabelText(scope.data[index]);

              // Skip watch & search
              inputLabelWatchIgnoreOnce = true;

              // Hide container
              showContainer(false);

              // Make no changes and fire no callbacks
              if (index > -1 && angular.equals(scope.ngModel, scope.data[index])) {
                if (!scope.useServer() && baseData) {
                  scope.data = baseData;
                  baseData = undefined;
                }

                return;
              }

              // update model
              scope.ngModel = scope.data[index];
              ignoreNgModelWatchOnce = true;

              // Fire onChange event
              scope.onChange({item: scope.data[index]});

              // Reset server searche flags for next refresh
              if (scope.useServer()) {
                isFullData = false;
                page = 0;

                // We do not get new data here ONLY when a valid selection is made
                // since the second enter for give and yeild a different result
                // since `scope.selectedIndex` is not updated here and it needs to be reserved on
                // `blur`
                if (index === -1) {
                  getData();
                }

              } else if (!scope.useServer()) {
                if (baseData) {
                  scope.data = baseData;
                  baseData = undefined;
                }
                scope.selectedIndex = scope.data.indexOf(scope.ngModel);
              }
            };

            /**
             * Get Label Text
             * @param  {object} row Row object in an array
             * @return {string}     Label to be displayed in textinput
             */
            function getLabelText(row) {
              var label = getLabel(row);
              if (typeof label === 'undefined' && !!row) {
                label = row;
              }

              if (typeof label === 'object') {
                label = label[scope.headerIndex];
              }

              return label;
            }

            /**
             * When the expand Carat is clicked
             */
            function onInputClick(event) {
              event.stopPropagation();
              event.preventDefault();

              // Clear timeouts
              $timeout.cancel(blurTimeout);
              $input[0].select();

              // ignore input click
              if (scope.ignoreInputClick()) {
                return;
              }

              // Toggle container visibility
              showContainer(!scope.isContainerVisible);

              // Safe apply the change to the scope
              $bentoServices.safeApply(scope);
            }

            var inputLabelWatchIgnoreOnce = false;
            var isKeyboardInteraction = false;
            scope.$watch('inputLabel', inputLabelWatch);

            function inputLabelWatch(str) {
              if (!str || str.length === 0) {
                scope.selectedIndex = -1;
                str = '';
              }

              if (attrs.required && str.length === 0) {
                controller.$setValidity('required', false);
              } else {
                controller.$setValidity('required', true);
              }

              if (!initLoad && !inputLabelWatchIgnoreOnce && isKeyboardInteraction) {
                scope.isDirty = true;
                search(str);
              } else {
                initLoad = false;
                inputLabelWatchIgnoreOnce = false;
              }

              isKeyboardInteraction = false;
            }

            /**
             * When a key is pressed on the Input Field
             * @param $event
             */
            scope.onInputKeypress = function ($event) {
              // FF fires Keypress on all keys including un-printable characters...
              // 9 : Tab
              // 13: Enter
              if (
                $event.keyCode !== 9
                && $event.keyCode !== 13
              ) {
                scope.isDirty = true;
              }
            };

            /**
             * When a key is down on the Input Field
             * @param $event
             */
            scope.onInputKeyDown = function ($event) {
              // An user interaction is recorded
              controller.$setDirty();
              isKeyboardInteraction = true;

              inputLabelWatchIgnoreOnce = false; // don't ignore keyboard interaction

              // bypass all instructions
              if (attrs.readonly) {
                return;
              }

              var keyCode = $event.keyCode;

              switch (keyCode) {
                // Enter Key
                case 13:
                  if (scope.isDirty) {
                    if (scope.selectedIndex > -1 || !scope.revertOnInvalidInput()) {
                      scope.onItemClick(scope.selectedIndex);
                    } else {
                      resetSelection();
                    }
                  }
                  $event.stopPropagation();
                  $event.preventDefault();
                  break;
                // TAB key
                case 9:
                  // do nothing for now
                  break;
                // Arrow Key  down
                case 40:
                  $event.stopPropagation();
                  $event.preventDefault();
                  // Alt + Arrow Key behavior
                  // Recrouce: https://www.w3.org/TR/2009/WD-wai-aria-practices-20090224/#combobox
                  if ($event.ALT || !scope.isContainerVisible) {
                    showContainer(!scope.isContainerVisible);
                    break;
                  }

                  if (
                    scope.data.length > 0 &&
                    (!scope.useServer() ||
                      (scope.useServer() && isFullData) ||
                      (scope.useServer() && scope.selectedIndex < scope.data.length - 1)
                    )
                  ) {
                    scope.selectedIndex = (scope.selectedIndex + 1) % scope.data.length;
                  }
                  showContainer(true);
                  scope.isDirty = true;

                  break;
                // Arrow Key Up
                case 38:
                  $event.stopPropagation();
                  $event.preventDefault();

                  // Alt + Arrow Key behavior
                  // Recrouce: https://www.w3.org/TR/2009/WD-wai-aria-practices-20090224/#combobox
                  if ($event.ALT || !scope.isContainerVisible) {
                    showContainer(!scope.isContainerVisible);
                    break;
                  }
                  if (scope.data.length > 0) {
                    scope.selectedIndex = scope.selectedIndex < 0 ? 0 : scope.selectedIndex;
                    scope.selectedIndex = (scope.selectedIndex - 1 + scope.data.length) % scope.data.length;
                  }
                  showContainer(true);
                  scope.isDirty = true;
                  break;
                // Home
                case 36:
                  if (scope.data.length > 0) {
                    scope.selectedIndex = 0;
                  }
                  scope.isDirty = true;
                  $event.stopPropagation();
                  $event.preventDefault();
                  break;
                // End
                case 35:
                  if (scope.data.length > 0) {
                    scope.selectedIndex = scope.data.length - 1;
                  }
                  scope.isDirty = true;
                  $event.stopPropagation();
                  $event.preventDefault();
                  break;
                // Page up
                case 33:
                  if (scope.data.length > 0) {
                    scope.selectedIndex -= 8;
                    scope.selectedIndex = scope.selectedIndex < 0 ? 0 : scope.selectedIndex;
                  }
                  scope.isDirty = true;
                  $event.stopPropagation();
                  $event.preventDefault();
                  break;
                //Page Down
                case 34:
                  if (scope.data.length > 0) {
                    scope.selectedIndex += 8;
                    scope.selectedIndex = scope.selectedIndex >= scope.data.length ? scope.data.length - 1 : scope.selectedIndex;
                  }
                  scope.isDirty = true;
                  $event.stopPropagation();
                  $event.preventDefault();
                  break;
                // ESC Key
                case 27:
                  resetSelection();
                  $event.stopPropagation();
                  $event.preventDefault();
                  break;
                // Left & Right arrow keys
                // This has brought up by <scott.gilliamv>, Dec 12, 2016 on Slack @bento-forum
                // > Hello, in  the bento-combobox, arrowing left or right in the input field and
                // then leaving > the field causes the selectedIndex to be reset to -1.   Can we
                // add the left/right arrow keys > to onInputKeyDown to do nothing instead of
                // defaulting to setting the isDirty flag which causes > the above behavior in
                // onInputBlur because it thinks its dirty eventhough nothing has changed?
                case 37:
                case 39:
                  // do nothing
                  break;
                // All other key downs
                default:
                  scope.isDirty = true;
                  break;
              }

              // Update ngModel dirty flag
              if (scope.isDirty) {
                controller.$setDirty();
              }
            };

            /**
             * When a key is released from the keyboard
             * @param $event
             */
            scope.onInputKeyup = function ($event) {
              // bypass all instructions
              if (attrs.readonly) {
                return;
              }

              var keyCode = $event.keyCode;
              switch (keyCode) {
                // Enter Key
                case 13:
                  // Stop a FORM from submitting
                  $event.stopPropagation();
                  $event.preventDefault();
                  break;
                // Tab Key
                case 9:
                  break;
              }

              isKeyboardInteraction = false;

            };

            /**
             * When focused out from this Combobox
             * @param $event
             */
            var autoSelectCatchUp;

            function onInputBlur($event) {
              focused = false;
              // bypass all instructions
              if (attrs.readonly || ignoreBlur) {
                ignoreBlur = false;
                return;
              }

              // Ignore all key entry delays
              $timeout.cancel(keyEntryDelayTimeoutId);

              blurTimeout = $timeout(function () {
                if (scope.isDirty) {
                  if (scope.selectedIndex > -1) {
                    if (scope.loadingData) {
                      autoSelectCatchUp = true;
                    } else {
                      scope.onItemClick(scope.selectedIndex, true);
                    }
                  } else {

                    if (scope.revertOnInvalidInput()) {
                      resetSelection();
                    } else {
                      scope.ngModel = undefined;
                      scope.inputLabel = '';
                      cleanSelectionData();
                      // Fire onChange event with an undefined object
                      scope.onChange({item: undefined});
                    }

                  }

                  // Update ngModel dirty flag
                  controller.$setDirty();

                  //Reset data here to refresh the dropdown
                  if (scope.useServer() && scope.isDirty) {
                    // Reset page number so that a fresh set of data will be requested
                    page = 0;
                    getData();
                  }

                  // Reset the internal dirty flag until next user keypress
                  scope.isDirty = false;
                }

                // Reset index
                scope.selectedIndex = -1;
                showContainer(false);
                controller.$setTouched();
              }, 100);

              if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
              }
            }

            /**
             * When focused in to this Combobox
             */
            function onInputFocus() {
              $timeout.cancel(blurTimeout);
              focused = true;
            }

            /**
             * Callback function when the list is at the end of scroll
             */
            scope.onEndOfScroll = function () {
              // Only applies to server enabled environement
              // This instance must be idle
              if (scope.useServer() && !scope.loadingData) {
                getData(currentSearchTerm);
              }
            };

            /**
             * Reset selection to the previous one
             */
            function resetSelection() {
              // Do not watch the reset change for once
              scope.inputLabel = getLabelText(scope.ngModel);
              cleanSelectionData();
            }

            /**
             * Clean selection data without touch the inputlabel & ngModel
             */
            function cleanSelectionData() {
              scope.selectedIndex = -1;
              scope.isDirty = false;
              search('');
              inputLabelWatchIgnoreOnce = true;
              // Hide container
              showContainer(false);
            }

            /**
             * Get data from callback
             * @param page
             * @param search
             */
            var missedSearchTerm; // use a stack
            var currentSearchTerm = '';
            var currentGetDataID;

            function getData(search) {
              currentSearchTerm = search || '';

              // Need to ignore getData until the preivous getData request is finished
              if (scope.loadingData) {
                missedSearchTerm = currentSearchTerm;
                return;
              } else if (isFullData) {
                return;
              }

              // Generate UID for this get data
              var getDataID = $bentoServices.generateUID();
              // For promise validation
              currentGetDataID = getDataID;

              missedSearchTerm = undefined;

              var dataObj = scope.getData({
                page  : page || 0,
                search: search || ''
              });

              scope.loadingData = true;

              // Check if the returned data is an array or not
              if (Array.isArray(dataObj)) {
                if (page === 0) {
                  scope.data = dataObj;
                } else {
                  // Directly assign
                  scope.data = scope.data.concat(dataObj);
                }
                scope.loadingData = false;

                if (autoSelectCatchUp) {
                  if (scope.inputLabel.length > 0) {
                    scope.selectedIndex = 0;
                    scope.onItemClick(0, true);
                    autoSelectCatchUp = false;
                  } else {
                    scope.ngModel = undefined;
                  }

                  autoSelectCatchUp = false;
                }

                // In case it's a lazyload
                if (dataObj.length > 0) {
                  page++;
                } else {
                  isFullData = true;
                }
              }
              // This is promise
              else if (dataObj && dataObj.then) {

                dataObj.then(
                  function (data) {
                    // This dataset is no longer valid
                    if (getDataID !== currentGetDataID) {
                      return;
                    }

                    scope.loadingData = false;
                    if (page === 0) {
                      scope.data = [];

                      // There is no need to scroll to top even the container dropdown isn't ready
                      // New container will have scrollToTop => 0 anyways...
                      if (scope.containerCtrl) {
                        scope.containerCtrl.scrollToTop();
                      }
                    }
                    scope.data = scope.data.concat(data);

                    // There is a pending getData (mostly a new search)
                    if (missedSearchTerm !== undefined) {
                      page = 0;
                      isFullData = false;
                      getData(missedSearchTerm);
                      return;
                    } else
                    // There is data
                    if (data.length > 0) {
                      // prepare for the next request
                      page++;

                      if (autoSelectCatchUp) {
                        if (scope.inputLabel.length > 0) {
                          scope.selectedIndex = 0;
                          scope.onItemClick(0, true);
                        } else {
                          scope.ngModel = undefined;
                        }
                        autoSelectCatchUp = false;
                      }
                    } else
                    // Empty result and there is no need to load more data and select
                    {
                      scope.selectedIndex = -1;
                      isFullData = true;
                      autoSelectCatchUp = false;
                    }

                    // Align after the data is populated and rendered
                    if (scope.containerCtrl) {
                      $timeout(scope.containerCtrl.align, 10);
                    }
                  },
                  function (message) {
                    scope.loadingData = false;
                    isFullData = true;

                    // Reset data array if there is no result on page 0
                    if (page === 0) {
                      scope.data = [];
                    }
                  }
                );
              } else {
                // None qualitfied data is returned.
                // We stop loading here
                isFullData = true;
                scope.loadingData = false;

                // Reset data array if there is no result on page 0
                if (page === 0) {
                  scope.data = [];
                }
              }
              $bentoServices.safeApply(scope);
            }

            /**
             * Show/Hide the container
             * @param bool
             */
            function showContainer(bool) {
              // Ignore if bool is not changed
              if (scope.isContainerVisible === bool || scope.ngDisabled() || attrs.readonly) {
                return;
              }

              // Only applies doc event listeners when `bento-append-to-parent` is enabled
              if (attrs.bentoAppendToParent) {
                console.log('append to add');
                if (bool) {
                  document.addEventListener('mousedown', onAppendToParentDocClick);
                  document.addEventListener('touchstart', onAppendToParentDocClick);
                } else {
                  document.removeEventListener('mousedown', onAppendToParentDocClick);
                  document.removeEventListener('touchstart', onAppendToParentDocClick);
                }
              }

              // Align header if there is any
              if (scope.containerCtrl) {
                scope.containerCtrl.align();
              }
              // Set show/hide flag variable
              scope.isContainerVisible = bool;
              scope.$emit("append_to_parent_show_list", scope.isContainerVisible, scope.uid);
            }

            /**
             * Search through data labels and list result
             */
            var keyEntryDelayTimeoutId = 0;

            function search(str) {
              // Normalize undefined value to an empty string
              if (typeof str === 'undefined') {
                str = '';
              }

              if (scope.searchable() &&
                (scope.minSearchCharacterCount <= str.length || str.length === 0)
              ) {
                showContainer(true);

                if (!scope.useServer()) {
                  if (!baseData) {
                    baseData = scope.data;
                  }

                  var newArray = [],
                      i, iLen, row, rowLabel
                  ;

                  // No entry
                  // IGNORE THE RESET
                  if (!str || str.trim().length === 0) {
                    scope.selectedIndex = -1;
                    scope.data = baseData;
                    return;
                  }

                  for (i = 0, iLen = baseData.length; i < iLen; i++) {
                    row = baseData[i];
                    rowLabel = scope.labelName ? row[scope.labelName] : row;

                    // Search column if there are some
                    if (typeof rowLabel === 'object') {
                      var isNumKey = Array.isArray(rowLabel);

                      for (var key in rowLabel) {
                        if (searchFunc({
                            string: rowLabel[key],
                            search: str,
                            column: isNumKey ? Number(key) : key,
                            row   : row
                          })) {
                          newArray.push(row);
                          break;
                        }
                      }
                    } else if (searchFunc({
                        string: rowLabel,
                        search: str,
                        column: 0,
                        row   : row
                      })) {
                      newArray.push(row);
                    }
                  }

                  // Reset `selectedIndex` to auto select only if the input field is not empty
                  if (newArray.length > 0) {
                    scope.selectedIndex = 0;
                  } else {
                    // nothing to select
                    scope.selectedIndex = -1;
                  }

                  // Feed new Array
                  scope.data = newArray;
                  showContainer(true);

                  // Need to align the columns during search to avoid jumping
                  // when there is a scrollbar
                  $timeout(scope.containerCtrl.align);
                }
                // Server search
                else {
                  $timeout.cancel(keyEntryDelayTimeoutId);
                  keyEntryDelayTimeoutId = $timeout(function () {
                    page = 0;
                    isFullData = false;
                    // Auto select when there is a string in the input field
                    if (scope.inputLabel && scope.inputLabel.length > 0) {
                      scope.selectedIndex = 0;
                    }
                    // Empty string gets no selection
                    else {
                      scope.selectedIndex = -1;
                    }

                    // Because of the 200 mil delay we need to find out if the search is done after
                    // blur
                    if (str.length > 0 && !focused) {
                      autoSelectCatchUp = true;
                    }
                    getData(str || '');

                  }, scope.searchKeydownTimeout() || 200);
                }
              }
            }
          }
        };
      }])

    /**
     * Bento Combobox Container Directive
     * For Combobox 1.x
     */
    .directive('bentoComboboxContainer', [
      '$timeout',
      function ($timeout) {
        return {
          replace    : true,
          scope      : {
            selectedIndex    : '=',
            headers          : '=',
            headerTemplate   : '=',
            data             : '=',
            isTable          : '=',
            labelName        : '=',
            onItemClick      : '&',
            controller       : '=',
            onEndOfScroll    : '&',
            rowTemplate      : '&',
            footerTemplateUrl: '&?'
          },
          templateUrl: function (element, attrs) {
            return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/combobox/bento-combobox-container.html';
          },
          link       : function bentoComboboxContainerListLink(scope, element) {
            scope.selectedIndex = typeof scope.selectedIndex === 'undefined' ? -1 : scope.selectedIndex;
            var container = element[0].querySelector('.bento-combobox-container-body');

            // Listen to scrolling for lazy loading
            container.addEventListener('scroll', function () {
              // fire end of scroll event
              if (container.scrollTop + container.offsetHeight >= container.scrollHeight) {
                scope.onEndOfScroll();
              }
            });

            scope.selectItem = function (index) {
              scope.selectedIndex = index;
              scope.onItemClick({index: index});
            };

            scope.$watch('selectedIndex', function (value) {
              if (value > -1 && container && scope.data && scope.data.length > 0) {

                // Wait until rendering is finished.
                $timeout(function () {
                  var item = element[0].querySelector('[rel="row-' + value + '"]');
                  // Make sure the selected item/row is in view
                  if (item.offsetTop < container.scrollTop) {
                    container.scrollTop = item.offsetTop;
                  } else if (item.offsetTop + item.offsetHeight > container.scrollTop + container.offsetHeight) {
                    container.scrollTop = item.offsetTop + item.offsetHeight - container.offsetHeight;
                    if (value === scope.data.length - 1) {
                      scope.onEndOfScroll();
                    }
                  }
                });
              }
            });

            // Create a controller for the parent directive to access
            scope.controller = {
              scrollToTop: scrollToTop,
              align      : alignColumns // Align the header and columns
            };

            // Dropdown load helpers
            function scrollToTop() {
              container.scrollTop = 0;
            }

            function alignColumns() {
              if (scope.data && scope.data.length > 0) {
                var rowObj = element[0].querySelector('.bento-combobox-container-item bento-combobox-row-template');
                var header = element[0].querySelector('.bento-combobox-container-header');
                if (!rowObj || !header) {
                  return;
                }
                var row     = rowObj.children,
                    headers = header.children,
                    i, len
                ;

                // reset header widths
                for (i = 0, len = headers.length; i < len; i++) {
                  headers[i].style.width = 'auto';
                  headers[i].style.opacity = '0';
                  // Make sure the headers don't overlap
                  headers[i].style.minWidth = headers[i].offsetWidth + 'px';
                }

                // delayed render
                $timeout(function () {
                  var offsetWidth;
                  for (i = 0, len = headers.length; i < len; i++) {
                    offsetWidth = row[i].offsetWidth;
                    // Make sure the min width inline with the header columns
                    row[i].style.minWidth = headers[i].offsetWidth;
                    // Align header widths
                    headers[i].style.width = offsetWidth === 0 ? 'auto' : row[i].offsetWidth + 'px';
                    headers[i].style.opacity = '1';
                  }
                });
              }
            }
          }
        }
      }
    ])

    /**
     * Bento Combobox Header Template Directive
     * For Combobox 1.x
     */
    .directive('bentoComboboxHeaderTemplate', [
      '$compile',
      function ($compile) {
        return {
          replace    : true,
          templateUrl: '../templates/combobox/bento-combobox-header-template.html',
          scope      : {
            bentoComboboxHeaderTemplate: '&',     // Custom header template string/array
            $header                    : '&',     // item object
            $index                     : '@'      // an index of this column to refer the template
                                                  // array
          },
          link       : function (scope, element) {
            var defaultRowTemplate = '<span>{{$header()}}</span>',
                template           = defaultRowTemplate;

            if (typeof scope.bentoComboboxHeaderTemplate() === 'string') {
              template = '<span>' + scope.bentoComboboxHeaderTemplate() + '</span>';
            } else if (Array.isArray(scope.bentoComboboxHeaderTemplate())) {
              template = '<span>' + scope.bentoComboboxHeaderTemplate()[scope.$index] + '</span>';
            }

            if (!template) {
              template = defaultRowTemplate;
            }

            template = angular.element(template);

            $compile(template)(scope);
            element.append(template);
          }
        };
      }
    ]);

  /**
   * Bento Combobox Footer Directive
   * For Combobox 1.x
   */
  var comboboxFooterDefaultTemplate =
        '<div class="bento-combobox-footer-row">' +
        '<div class="bento-combobox-footer-item" ng-repeat="button in footerOptions.buttons track by $index">' +
        '<div class="bento-combobox-footer-item-inner">' +
        '<a ng-click="onButtonAction(button)"' +
        ' tabindex="{{onTabList() ? \'0\' : \'-1\'}}"' +
        ' ng-keydown="onFooterItemKeydown($event, button)">' +
        '<i ng-if="button.icon" ng-class="button.icon"></i> ' +
        '{{button.label | bentoStringReplace:\'_ITEM_\': values.input || button.defaultItemLabel}}</a>' +
        '</div>' +
        '</div>' +
        '</div>';

  comboboxApp.directive('bentoComboboxFooter', [
    '$compile',
    '$templateCache',
    function ($compile, $templateCache) {
      return {
        restrict: 'EA',
        template: '',
        link    : function (scope, element, attrs) {
          var template,
              $templateEl = angular.element(document.createElement('div'));

          if (attrs.templateUrl && attrs.templateUrl.length) {
            template = $templateCache.get(attrs.templateUrl);
          } else {
            template = comboboxFooterDefaultTemplate;
          }
          $templateEl.addClass('bento-combobox-footer-inner');
          $templateEl.html(template);
          $compile($templateEl)(scope);

          element.append($templateEl);

          // Create Keycode ref
          var KeyCodes      = {
                TAB   : 9,
                RETURN: 13,
                SPACE : 32,
                ALT   : 18,
                UP    : 38,
                DOWN  : 40,
                ESCAPE: 27
              },
              comboboxScope = scope.$parent.$parent;

          // Get options
          scope.footerOptions = comboboxScope.footerOptions();
          // Init object
          scope.values = {};

          // Set up the watch for input update
          // otherwise, there is no need to watch the input label.
          scope.$watch(function () {
              return comboboxScope.inputLabel;
            },
            function () {
              scope.values.input = getComboboxInputLabel();
            });

          scope.onButtonAction = function (button) {
            var value = scope.values.input || '';

            // Make that the default item label is not forwarded to the callback
            if (button.defaultItemLabel &&
              value.toLowerCase() === button.defaultItemLabel.toLowerCase()
            ) {
              value = '';
            }

            // Call button action
            button.action(value);

            // Clear input label and set the Combobox to dirty
            if (button.clearInputOnAction) {
              comboboxScope.inputLabel = '';
              comboboxScope.isDirty = false;
            }

            // Collapse the list container by default
            if (button.collapseOnAction || typeof button.collapseOnAction == 'undefined') {
              comboboxScope.onButtonClick();
            }
          };

          scope.onFooterItemKeydown = function ($event, button) {
            switch ($event.keyCode) {
              case KeyCodes.SPACE:
              case KeyCodes.RETURN:
                scope.onButtonAction(button);
                $event.preventDefault();
                $event.stopPropagation();
                break;
            }
          };

          // TODO: assign to scope to make unit testing easier
          scope.bentoOnInputKeyDown = comboboxScope.onInputKeyDown;
          comboboxScope.onInputKeyDown = function ($event) {
            if (scope.footerOptions) {
              switch ($event.keyCode) {
                case KeyCodes.RETURN:
                case KeyCodes.TAB:
                  // comboboxScope.data holds the search results in the combo.
                  // Only trigger add on the fly if the search results are empty.
                  if (comboboxScope.data.length === 0) {
                    var button;
                    for (var i = 0, len = scope.footerOptions.buttons.length; i < len; i++) {
                      button = scope.footerOptions.buttons[i];
                      if (button.actionOnValueUpdate) {
                        scope.onButtonAction(button);
                      }
                    }
                    return;
                  }
                  break;
                //deprecated: this will be deprecated on the next update of bento
                case KeyCodes.UP:
                case KeyCodes.DOWN:
                  if ($event.ALT) {
                    comboboxScope.onButtonClick();
                    $event.preventDefault();
                    $event.stopPropagation();
                    return;
                  }
                  break;
                //end here
              }
            }
            scope.bentoOnInputKeyDown.call(scope.bentoOnInputKeyDown, $event);
          };

          // Determine if the CTAs are tabbable
          scope.onTabList = function () {
            if (comboboxScope.isContainerVisible) {
              if (comboboxScope.data.length < 1 || !comboboxScope.inputLabel) {
                return true;
              }
            }
            return false;
          };

          // Get Text from the input label of the Combobox
          function getComboboxInputLabel() {
            // If the dropdown is open a item may be selected
            var selectedItem = comboboxScope.data[comboboxScope.selectedIndex];
            var itemLabel = null;
            var inputString = null;
            // If an item is selected get the displayed property, otherwise the selected item is
            // the ngModel (the user is not interacting with the combobox when selectedItem is the
            // model)
            if (angular.isObject(selectedItem)) {
              itemLabel = selectedItem[comboboxScope.labelName];

              if (Array.isArray(itemLabel)) {
                // This is a grid layout we need to find the right label string
                itemLabel = itemLabel[comboboxScope.headerIndex].toLowerCase();
              } else {
                // Label is a normal string
                itemLabel = itemLabel.toLowerCase();
              }

            } else if (angular.isObject(comboboxScope.ngModel) && comboboxScope.ngModel.hasOwnProperty(comboboxScope.labelName)) {
              selectedItem = comboboxScope.ngModel;
              itemLabel = comboboxScope.ngModel[comboboxScope.labelName].toLowerCase();
            }
            // If the user typed something in the combobox input
            if (angular.isString(comboboxScope.inputLabel)) {
              inputString = comboboxScope.inputLabel.toLowerCase();
            }
            // Use the text in the combobox input if there is not a selected item with the same
            // text, otherwise use the default text
            if (comboboxScope.inputLabel && (!angular.isObject(selectedItem) || itemLabel !== inputString)) {
              return comboboxScope.inputLabel;
            } else {
              return scope.defaultAddText;
            }
          }
        }
      };
    }
  ])

  /**
   * Bento Combobox Row Template Directive
   * For Combobox 1.x
   */
    .component('bentoComboboxRowTemplate', {
      bindings    : {
        rowTemplate: '<',     // Custom row template
        $item      : '<',     // item object
        $labelName : '<',     // variable name used to display row
        $index     : '<',     // an index of this item
        headers    : '<'
      },
      //template    : '',
      controllerAs: '$row',
      controller  : [
        '$scope',
        '$compile',
        '$element',
        function ($scope, $compile, $element) {
          var $row = this;

          $row.$onInit = function () {
            var defaultRowTemplate                  =
                  '<span class="combobox-default-row">{{$row.$labelName? $row.$item[$row.$labelName]:$row.$item}}</span>',
                defaultGridTemplate                 =
                  '<span class="combobox-grid-column" ng-repeat="cell in $row.$item[$row.$labelName]">{{cell}}</span>',
                defaultGridTemplateWithoutLabelName =
                  '<span class="combobox-grid-column-no-ln" ng-repeat="header in $row.headers">{{$row.$item[header]}}</span>',
                template                            = defaultRowTemplate;

            if ($row.rowTemplate) {
              template = $row.rowTemplate;
            } else
            // Grid
            if (Array.isArray($row.headers)) {
              if ($row.$labelName) {
                template = defaultGridTemplate;
              } else {
                template = defaultGridTemplateWithoutLabelName;
              }
            }
            var templateEl = angular.element(template);

            $compile(templateEl)($scope);
            $element.append(templateEl);
          };
        }]
    });

})(window.angular);
(function (angular, undefined) {
  'use strict';

  angular
    .module('bento.contextualheader', [
      'bento.services'
    ])
    .directive('bentoContextualHeader', bentoContextualHeader);

  bentoContextualHeader.$inject = ['$timeout', '$compile', '$window'];

  function bentoContextualHeader() {
    return {
      restrict   : 'EA',
      scope      : {
        contextualHeaderData: '&',
        onBackBtnClick      : '&',
        backBtnDisabled     : '&',
        hideBackBtn         : '&'
      },
      templateUrl: function (element, attrs) {
        return angular.isDefined(attrs.templateUrl) ?
          attrs.templateUrl : '../templates/contextual_header/bento-contextual-header.html';
      },
      link       : function (scope, element, attrs) {
        element.addClass('bento-contextual-header');
        var mainItem = element[0].querySelector('.bch-main-container');

        // Detect header width based on the total count of the headers
        scope.getHeaderWidthClass = function(){
          var length = scope.contextualHeaderData().headers.length;
          if(length > 2){
            return 'col-xs-4';
          }else if(length > 1){
            return 'col-xs-6';
          }
          return 'col-md-12'
        };

        // Right button click CTA
        scope.onRightButtonClick = function(){
          var button = scope.contextualHeaderData().button;
          if(button && button.action){
            button.action();
          }
        };

        // Return the condition whether the subtitle needs a tooltip
        scope.isTooltipEnabled = function(index){
          var selector = 'div[data-subtitle-id="'+index+'"]';
          var el = element[0].querySelector(selector);
          return (el && el.offsetWidth < el.scrollWidth);
        };

        // Check if the str is an image url
        scope.isImage = function(str){
          var reg = /[^\s]+(\.(jpg|png|gif|bmp|svg)$)/;
          return reg.test(str);
        };

      }
    };
  }
})(window.angular);
(function (angular, window, undefined) {

  'use strict';

  angular.module('bento.fileselector', ['bento.busyloader', 'bento.services', 'bento.translate'])
    .directive('bentoFileSelector', [
      function () {
        return {
          controller : 'fileSelectorController',
          controllerAs: 'bentoFileSelectorCtrl',
          replace    : true,
          scope      : {
            ngModel                 : '=?',   // List of selected files
            accept                  : '@',    // Accept file types
            fileType                : '@',    // Limit the type of file that needs to be selected
            onFileSelect            : '&',    // Callback when a file is selected
            onFileRemove            : '&',    // Callback when the selected file's reference is removed from this
                                              // directive
            multiple                : '=',    // (Boolean) for multiple file selections
            appendOnSelection       : '=',    // (Boolean) append new files onto the existing list
            showSelected            : '=',    // Show selected files in the view
            showFileSize            : '=',    // Show file size info
            uploadProgress          : '=',    // Upload progress variable
            showProgressPercentage  : '=',    // Show upload progress percentage
            disableFilesDuringUpload: '=?',   // Disable file buttons from being removed during upload
            dropFieldLabel          : '@',    // Override to the drop field text
            browseButtonLabel       : '@'     // Override to the upload button
          },
          templateUrl: function(element, attrs) {
            return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/file_selector/bento-file-selector.html';
          },
        };
      }
    ])
    .filter('bentoFileSizeFilter', function () {
      return function (value) {
        var output = '0 Byte';
        if (value < 1000) {
          output = value + 'B';
        } else if (value < 100000) {
          output = Math.round(value / 100) / 10 + 'KB';
        } else if (value < 1000000) {
          output = Math.round(value / 1000) + 'KB';
        } else if (value < 100000000) {
          output = Math.round(value / 100000) / 10 + 'MB';
        } else if (value < 1000000000) {
          output = Math.round(value / 1000000) + 'MB';
        } else if (value < 100000000000) {
          output = Math.round(value / 100000000) / 10 + 'GB';
        } else if (value < 1000000000000) {
          output = Math.round(value / 1000000000) + 'GB';
        } else if (value < 100000000000000) {
          output = Math.round(value / 100000000000) / 10 + 'TB';
        } else if (value < 1000000000000000) {
          output = Math.round(value / 1000000000000) + 'TB';
        }

        return output;
      }
    })
    .factory('$fileSelectorServices', [
      '$bentoServices',
      function ($bentoServices) {

        /**
         * Parse a File out from the file list and forward it back to the callback function
         * @param scope
         * @param files
         * @param callback
         * @param fileType
         */
        var parseFiles = function (scope, files, callback, fileType) {

          // Ignore non-file selection
          if (typeof files === 'undefined') {
            return;
          }

          var originalFiles = (scope.multiple) ? files : [files[0]]; //1 element when `mutiple` is NOT `true`

          var selectedFiles = [];
          for (var i = 0; i < originalFiles.length; i++) {
            var file = originalFiles[i];
            if (isValidFileType(file, fileType)) {
              selectedFiles.push(file);
            }
          }

          // Determine if it needs to append to the existing file array or not
          if (scope.appendOnSelection && Array.isArray(scope.ngModel) && scope.multiple) {
            scope.ngModel = scope.ngModel.concat(selectedFiles);
          } else {
            // Add a file reference to scope
            scope.ngModel = selectedFiles;
            scope.disabledFiles = [];
            scope.fileProgresses = [];
          }

          // Since this is a single file uploader for this version
          // Only the first element will be included into the callback function
          if (!!callback) {
            callback({
              files: selectedFiles
            });
          }

          $bentoServices.safeApply(scope);

        };

        /**
         * Determine if the first element in files has the right file type
         * @param file
         * @param fileTypes
         * @returns {boolean}
         */
        var isValidFileType = function (file, fileTypes) {
          var _ft = (!!fileTypes) ? fileTypes.trim() : '';
          var fileNameBreakDown = file.name.split('.');
          var fileExtension = fileNameBreakDown[fileNameBreakDown.length - 1];

          // This is no filetype specified
          if (typeof _ft === 'undefined' || _ft.length === 0) {
            return true;
          }

          // Check if this file extension exists in fileTypes string
          if (fileTypes.search(fileExtension) !== -1) {
            return true;
          }

          // File extension does not exist in the fileTypes
          return false;
        };

        /**
         * Resets variables for the selector
         * @param scope
         */
        var resetFileSelector = function (scope) {
          scope.ngModel = undefined;
        };

        /**
         * Construct a new file input
         * @param scope
         * @returns {*}
         */
        var getFileInput = function (scope) {
          var accept    = (scope.accept && scope.accept.length > 1) ?
            ' accept="' + scope.accept + '"' : '',
              fileInput = angular.element(
                '<input type="file" name="fileselect[]"' +
                ' class="sr-only" tabindex="-1"' +
                accept +
                (!!scope.multiple ? ' multiple' : '') +
                ' bento-test="input-file"' +
                ' />');

          return fileInput;
        };

        return {
          resetFileSelector: resetFileSelector,
          isValidFileType  : isValidFileType,
          parseFiles       : parseFiles,
          getFileInput     : getFileInput
        };

      }
    ])
    .controller('fileSelectorController', [
      '$scope',
      '$element',
      '$timeout',
      '$compile',
      '$bentoServices',
      '$fileSelectorServices',
      '$log',
      function ($scope, $element, $timeout, $compile, $bentoServices, $fileSelectorServices, $log) {

        // Initialize fileInput
        var fileInput = $fileSelectorServices.getFileInput($scope);
        // post removal message SR element
        var postRemovalMessage = $element[0].querySelector('.bento-file-selector-post-removal-message');
        // File input field file change callback
        fileInput.on('change', onFileInputChange);
        $element.append(fileInput);

        if (typeof $scope.disableFilesDuringUpload === 'undefined') {
          $scope.disableFilesDuringUpload = true
        }

        // Need to compile when everything else is ready
        $timeout(function () {
          $compile(fileInput)($scope);
        });

        // Init variable
        $scope.disabledFiles = [];

        // Browse button click and trigger file input
        $scope.onBrowseClick = function ($event) {

          // Use native dispatch for IEs
          if ($bentoServices.getIEVersion() !== -1) {
            // Using the native dispatcher on click for the file selector
            var clickEvent = document.createEvent('Event');
            clickEvent.initEvent('click', true, true);
            fileInput[0].dispatchEvent(clickEvent);
          } else {
            // Otherwise simple
            fileInput[0].click();
          }

          if ($event) {
            $event.stopPropagation();
            $event.preventDefault();
          }
        };

        // Watch Selected files count when removing
        $scope.$watch(function () {
            return !!$scope.ngModel ? $scope.ngModel.length : 0;
          },
          function (newVal, oldVal) {
            if (newVal < oldVal) {
              // Create a new  input field for the next file selection
              var newFileInput = $fileSelectorServices.getFileInput($scope);

              // Need to compile when everything else is ready
              $timeout(function () {
                $compile(fileInput)($scope);
              });

              newFileInput.on('change', onFileInputChange);

              // Replace the old fileInput with the new one
              fileInput.off('change', onFileInputChange);
              fileInput.replaceWith(newFileInput);
              fileInput = newFileInput;
            }
          });

        // User clicks on the file name remove icon
        // Removes the file name pill and notify the
        // parent controller if there is a callback function `onFileRemove()`
        $scope.onRemoveClick = function ($index) {
          var fileToBeRemoved = $scope.ngModel[$index];

          $scope.ngModel.splice($index, 1);
          $scope.fileRemoved = fileToBeRemoved.name;

          postRemovalMessage.focus();

          if (!!$scope.onFileRemove) {
            $scope.onFileRemove({
              file: fileToBeRemoved
            });
          }
        };

        // Add drag and drop event listeners
        $element[0].addEventListener('dragover', function (event) {
          $element.addClass('dragged-over');

          // prevent browsers to open the file
          event.stopPropagation();
          event.preventDefault();

        });

        // When user drags the file away from the dropping area
        $element[0].addEventListener('dragleave', function (event) {
          $element.removeClass('dragged-over');
        });

        // When user drops a files into the dropping area
        $element[0].addEventListener('drop', function (event) {
          $element.removeClass('dragged-over');

          $fileSelectorServices.parseFiles(
            $scope,
            event.dataTransfer.files,
            $scope.onFileSelect,
            $scope.fileType);

          // prevent browsers to open the file
          event.stopPropagation();
          event.preventDefault();
        });

        // Upload progress
        var uploadProgressTickPromise;
        $scope.uploadProgressPercentage = 0;
        $scope.$watchCollection('uploadProgress', function (progress) {
          uploadProgressTick();
        });

        function uploadProgressTick() {
          $timeout.cancel(uploadProgressTickPromise);
          uploadProgressTickPromise = $timeout(function () {
            var progress = $scope.uploadProgress;
            if (progress && progress.length > 0) {
              if (!Array.isArray(progress)) {
                $element.removeClass('bento-file-selector-in-progress');
                $log.error('Bento File Selector: incorrect "upload-progross" data structure.\nUse [{file:<type File>, position:<type Number - bytes uploaded>},...]')
              } else if (progress.length > 0) {
                var totalFileSize = 0,
                    totalPosition = 0,
                    fileObj, fileIndex
                ;

                if (!$scope.appendOnSelection) {
                  $scope.disableBrowseButton = true;
                }

                // calculate the percentage and file disabled states
                for (var i in progress) {
                  fileObj = progress[i];
                  fileIndex = $scope.ngModel.indexOf(fileObj.file);

                  // No need to
                  if (fileIndex === -1) {
                    continue;
                  } else {

                    totalFileSize += fileObj.file.size;
                    totalPosition += fileObj.position;

                    if (fileObj.file.size > fileObj.position) {
                      $scope.disabledFiles[fileIndex] = true;
                    } else {
                      $scope.disabledFiles[fileIndex] = false;
                    }

                    $scope.fileProgresses[fileIndex] = Math.floor(fileObj.position / fileObj.file.size * 100);
                  }
                }

                $scope.uploadProgressPercentage = Math.floor(totalPosition / totalFileSize * 100);

                // update the progress bar view based on the current progress percentage
                if (
                  $scope.uploadProgressPercentage >= 100
                  || totalFileSize === 0 // No more files
                ) {
                  $element.removeClass('bento-file-selector-in-progress');
                  $scope.disableBrowseButton = false;
                  // remove all progress references
                  $scope.uploadProgress = [];

                  // reset progress bar after hiding
                  $timeout(function () {
                    $scope.uploadProgressPercentage = 0;
                  }, 1000);
                } else if ($scope.uploadProgressPercentage >= 0) {
                  if (!$element.hasClass('bento-file-selector-in-progress')) {
                    $element.addClass('bento-file-selector-in-progress');
                  }
                  uploadProgressTick();
                }
              }
            } else {
              $element.removeClass('bento-file-selector-in-progress');
              $scope.disableBrowseButton = false;
              $scope.disabledFiles = [];
            }
          }, 500); // $timeout
        }

        // Callback
        function onFileInputChange(event) {
          $fileSelectorServices.parseFiles(
            $scope,
            event.target.files,
            $scope.onFileSelect,
            $scope.fileType);

          $timeout(function () {
            // focus to the first file label
            if ($scope.showSelected) {
              $element[0].querySelector('.bento-file-selector-filename-label').focus();
            }
          }, 100);
        }

      }
    ])
  ;

})(window.angular, window);

(function (window, angular) {
  var timeout;
  /* Directive */
  angular.module('bento.megamenu', [])
    .directive('megamenu', [
      '$timeout',
      function ($timeout) {
        timeout = $timeout;
        return {
          restrict: 'AC',
          scope   : false,
          link    : megamenuLinkFunc
        }
      }]);

  /**
   * Megamenu Main link function
   * @param scope
   * @param element
   * @param attrs
   * @param controller
   */
  function megamenuLinkFunc(scope, element, attrs, controller) {

    var isMemberOfToolbar = false,
        toolbar,
        currentItem,
        submenu
    ;

    // make sure this directive has the right class name for CSS to kick in
    element.addClass('megamenu');

    /**
     * Takeover Megamenu
     */
    // Check if this is an `takeover` element
    if (attrs.takeover && attrs.takeover.trim() === 'true') {
      /*
      Instead of restructure the current DOM element AKA "dropdown-menu",
      We will create a new element after this and move everything over.
      At the same time, $watch the original element and see if its content gets repopulated or not
       */
      // check if this megamenu is part of a toolbar
      var tmpEl = element[0],
          takeoverMenu
      ;


      // Walk up the DOM tree to find out if this `takeover` is part of a navbar
      do {
        if (tmpEl.className.search('global-subnav') > -1) {
          // Bingo
          // This `takeover` is a Nav (Tool)Bar member
          isMemberOfToolbar = true;
          toolbar = tmpEl;
        }
        tmpEl = tmpEl.parentNode;
      } while (tmpEl.tagName !== 'BODY' && !isMemberOfToolbar);


      // Only a Nav (Tool)Bar member can become the actual `takeover` directive.
      // Otherwise, nothing is executed below.
      if (isMemberOfToolbar) {

        // Hide the origina megamenu
        element.removeClass('dropdown-menu');
        element.addClass('ng-hide');

        // Create and add the new menu
        takeoverMenu = angular.element('<ul class="dropdown-menu megamenu megamenu-takeover"></ul>')
        element.after(takeoverMenu);

        // Declare the entire menu item is a `megamenu-takeover-dropdown`
        angular.element(element[0].parentElement).addClass('megamenu-takeover-dropdown');

        // Check if this dropdow is expanded or not
        scope.$watch(function () {
          return element.hasClass('open');
        }, function (isOpen) {
          // clean columns when closed
          if (!isOpen) {
            cleanColumns();

            // Clean global var `submenu`
            if (submenu) {
              submenu.removeAttr('style');
            }

            // Remove active state to the current `submenu` item
            if (currentItem) {
              angular.element(currentItem).removeClass('active');
            }
          }
        });

        // Restructure the menu as a `takeover` element
        scope.$watch(function(){
          return element[0].textContent;
        }, function(){
          // Wait for all the variables bindings are rendered
          timeout(function(){
            restructureMenu(element, takeoverMenu);
          },0);
        });
      }

      /**
       * Cleans all the columns except for the submenu header column
       * 'megamenu-takeover-header'
       */
      function cleanColumns() {
        var columnsToRemove = takeoverMenu[0].querySelectorAll('.column.submenu');

        for (i = 0, len = columnsToRemove.length; i < len; i++) {
          column = columnsToRemove[i];
          column.parentNode.removeChild(column);
        }
      }

      /**
       * Event Handler when a submenu header is click or hovered
       * @param currentTarget
       * @param element
       */
      function onHeaderHover(currentTarget, element) {
        // clean the previous columns if there is any
        var columns = [],
            links   = currentTarget.links,
            i, len, column;

        // Clean before preceeding
        cleanColumns();

        // Clean `megamenu-takeover-header`
        submenu.removeAttr('style');

        // create new column(s)
        var currentColumn;
        for (i = 0, len = links.length; i < len; i++) {
          if (!currentColumn) {
            currentColumn = angular.element('<li class="column submenu"></li>');
            element.append(currentColumn);
            columns.push(currentColumn);
          }

          currentColumn.append(links[i]);

          // Make new column if content overflows
          if (currentColumn[0].offsetHeight > submenu[0].offsetHeight) {
            currentColumn = angular.element('<li class="column submenu"></li>');
            element.append(currentColumn);

            columns.push(currentColumn);
            currentColumn.append(links[i]);
          }

          // This column is overflowing to the next row.
          // It needs to be removed and to be rendered differently
          if (currentColumn[0].offsetTop > submenu[0].offsetTop) {
            columns.pop();
            currentColumn[0].parentElement.removeChild(currentColumn[0]);
            // New render
            renderOnlyIntoGivenColumns(columns, links);
            break;
          }
        }
      }

      /**
       * Re-render the submenu items into give columns
       * @param columns
       * @param links
       * @param submenu
       */
      function renderOnlyIntoGivenColumns(columns, links) {
        var columnItemCount = Math.ceil(links.length / columns.length);
        var currentColumnIndex = 0;

        // Start to put links into the current column that is indexed
        for (var i = 0, len = links.length; i < len; i++) {
          if (i >= columnItemCount * (currentColumnIndex + 1)) {
            currentColumnIndex++;
          }
          if(columns[currentColumnIndex]){
            columns[currentColumnIndex].append(links[i]);
            // Need to redo the rearranging with less columns
            if (columns[currentColumnIndex][0].offsetTop > submenu[0].offsetTop) {
              columns.pop();
              renderOnlyIntoGivenColumns(columns, links);
              break;
            }
          }
        }

        if(columns[0]) {
          submenu.css('height', columns[0][0].offsetHeight + 'px');
        }
      }

      /**
       * Restructuring the current Menu
       * @param element
       */
      function restructureMenu(element, takeoverMenu) {
        var linkCollection = [], links, link;
        var liEls = element[0].querySelectorAll('li.column');
        var $liEl;
        var lastActive;

        // we do not restructure when there is nothing in the original dropdown-menu
        if(liEls.length === 0){
          return;
        }

        // Reset takeoverMenu
        takeoverMenu[0].innerHTML = '';

        // Generate a new DOM structure for this `Takeover` megamenu
        submenu = angular.element('<li class="column"><ul></ul></li>');
        takeoverMenu.append(submenu);
        submenu.find('ul').append(liEls);

        // Remove all categorized links into memory/`links` variable
        for (var i = 0, len = liEls.length; i < len; i++) {
          links = liEls[i].querySelectorAll('a');
          linkCollection.push(links);

          // Create a reference for its submenu links
          liEls[i].links = links;

          // Remove all the links and to use later
          for (var j = 0, lenJ = links.length; j < lenJ; j++) {
            link = links[j];
            link.parentElement.removeChild(link);
          }

          // Add style to headers
          $liEl = angular.element(liEls[i]);
          $liEl.removeClass('column');
          $liEl.addClass('megamenu-takeover-header');
          $liEl.attr('tabindex', 0);
          $liEl.append('<i class="bento-icon-chevron-right"></i>');

          // Support `hover` `click` and `touch` so that there is no delay
          $liEl.on('click mouseover touchstart focus', function (e) {
            // Just execute this even listener once without
            // any additional clicking interference
            e.stopPropagation();
            e.preventDefault();

            // Reset the previous `active` category menu header
            if (lastActive) {
              lastActive.removeClass('active');
            }

            lastActive = angular.element(e.currentTarget);
            lastActive.addClass('active');

            // Update global var
            currentItem = e.currentTarget;

            // Fire the actual code for submenu header hover event handler
            onHeaderHover(currentItem, takeoverMenu);
          });
        }
      }
    }
    /**
     * Normal Megamenu
     */
    else {
      // no need to proceed as megamenu leaves on CSS natively
      // Need to add resize code

      var windowResizeTimer, vw, toggleRect, toggleButton;

      toggleButton = element[0].parentElement.querySelector('[uib-dropdown-toggle]');

      window.addEventListener('resize', onWindowResize);

      function onWindowResize(e) {

        timeout.cancel(windowResizeTimer);
        timeout(timedResize,100);
      }

      function timedResize(){
        vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (vw < 600) {
          toggleRect = toggleButton.getBoundingClientRect();
          element.addClass('megamenu-mobile');
          element.css('width', vw + 'px');

          if(toggleRect.left < 20){
            element.css('max-width',(vw - toggleRect.left - 20)+'px');
            element.css('left', 0);
          }else{
            element.css('max-width',(vw - 40)+'px');
            element.css('left', (20 - toggleRect.left) + 'px');
          }

        }else{
          element.removeClass('megamenu-mobile');
          element.attr('style','');
        }
      }

      // Clear
      element.on('$destroy', function () {
        window.removeEventListener('resize', onWindowResize);
      });

      timedResize();
    }

  }
})(window, angular);
(function (angular, window) {
  'use strict';
  // GLOBAL CONSTANTS
  var CHECKED_STAT = '__buimsoChecked';

  angular.module('bento.multiselectoverlay', ['bento.services', 'bento.translate'])
    .directive('bentoMultiselectOverlay', [
      '$timeout',
      function ($timeout) {
        return {
          require    : 'ngModel',
          scope      : {
            ngModel                    : '=', // in Array
            listData                   : '&', // List data array in `{name:string, data:object}` format
            side                       : '@', // Side where the overlay shows ['left : 'right']
            sort                       : '=', // (boolean) turn on / off sorting
            sortReverse                : '=', // (boolean) sort in reverse order or not
            doneButtonText             : '@', // Text for Done button
            selectAllText              : '@', // Text for Select All checkbox
            showAllText                : '@', // Text for Show All tab
            showSelectedText           : '@', // Text for Show Selected tab
            selectButtonText           : '@', // Text for select
            editButtonText             : '@', // Text for Edit
            selectedInfoText           : '@', // Text for Info text next to the Edit button
            allSelectedInfoText        : '@', // Text Pattern for Info text when all items are selected
            revertSelectionsOnDismissal: '=' // Flag to revert to the previous selections when clicked outside of the
                                             // component
          },
          templateUrl: function (element, attrs) {
            return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/multiselect_overlay/bento-multiselect-overlay.html';
          },
          link       : function (scope, element, attrs, ngModelController) {
            var lastArray     = Array.isArray(scope.ngModel) ? scope.ngModel.slice() : [],
                mainLabel     = element[0].querySelector('.bento-multiselect-overlay-label'),
                sideOverlayEl = element[0].querySelector('.bento-side-overlay'),
                cancelNgModelWatch;

            // initialize ngModel properties
            ngModelController.$setPristine();
            ngModelController.$setUntouched();

            // Override the isEmpty definition
            ngModelController.$isEmpty = function (val) {
              if (scope.ngModel && scope.ngModel.length === 0) {
                return true;
              } else if (!scope.ngModel) {
                return true;
              }
              return false;
            };

            // Initiate internal variables
            scope.selectedItemCount = 0;
            scope.selectedItems = [];
            scope.firstItemName = (scope.selectedItemCount > 0) ? scope.ngModel[0].name : '';

            scope.onDoneClick = function (isDismissal) {
              var revertAndDismissal = scope.revertSelectionsOnDismissal && isDismissal;

              if (revertAndDismissal) {
                // revert selection in the list
                scope.selectedItems = ngModelController.$modelValue.slice();
                mainLabel.focus();
              } else if (!arrayEqual(scope.selectedItems, ngModelController.$modelValue)) {

                // update ngModel
                scope.ngModel = scope.selectedItems && scope.selectedItems.length? scope.selectedItems.slice():[];
                ngModelController.$setViewValue(scope.ngModel);
                ngModelController.$commitViewValue();

                // Make this component dirty
                ngModelController.$setDirty();
              }

              // Set the component to be touched
              ngModelController.$setTouched();

            };

            attrs.$observe('disabled', function (bool) {
              scope.isDisabled = bool;
            });

            scope.onListChange = function () {
              ngModelController.$setTouched();
            };

            // Start watching `ngModel`
            watchNgModel();

            /**
             * Initiate `ngModel` watch
             */
            function watchNgModel(){
              if(cancelNgModelWatch){
                cancelNgModelWatch();
              }

              cancelNgModelWatch = scope.$watchCollection('ngModel', function (newModel) {

                if(!arrayEqual(newModel,scope.selectedItems)){
                  // after ngModel is updated internally
                  scope.selectedItems = newModel? newModel.slice() : [];
                }

                var length = newModel? newModel.length : 0;
                scope.selectedItemCount = length;
                scope.firstItemName = (length > 0) ? scope.ngModel[0].name : '';

              });
            }
          }
        };
      }
    ])

    /**
     * Sub Directive
     * Bento Side Overlay and elements
     */
    .directive('bentoSideOverlay', [
      '$timeout',
      '$parse',
      function ($timeout, $parse) {
        return {
          scope   : false,
          restrict: 'A',
          link    : function (scope, element, attrs, controller) {
            // properties and pointer to do the geo calculations
            var $body                    = angular.element(document.body),
                overlayMargin            = 20,
                side                     = attrs.side ? attrs.side.trim() : 'right',
                $toggleButton            = angular.element(element[0].querySelector('.bento-side-overlay-toggle')),
                $overlayContainer        = angular.element(element[0].querySelector('[bento-side-overlay-content]')),
                $overlayContainerWrapper =
                  angular.element(element[0].querySelector('.bento-side-overlay-container-wrapper')),
                $overlayFooter           =
                  angular.element(element[0].querySelector('.bento-side-overlay-container-footer')),
                overlayHeight            = 0,
                $doneButton              =
                  angular.element(element[0].querySelector('.bento-side-overlay-container-footer-done')),
                $cancelButton            =
                  angular.element(element[0].querySelector('.bento-side-overlay-container-footer-cancel')),
                scrollableParent         = getScrollableParent(element[0].parentElement),
                scrollableParentScrollTop
            ;

            // Init directive CSS classes
            element.addClass('bento-side-overlay');
            element.addClass((side === 'right') ? 'bento-side-overlay-right' : 'bento-side-overlay-left');

            // Toggle button listener
            $toggleButton.on('click', function ($event) {
              if (!element.hasClass('open')) {
                element.addClass('open');

                $timeout(function () {
                  // `click` should not be used since the items clicked in the overlay could disappear before
                  // the window recieves its event
                  window.addEventListener('mousedown', onWindowClick);

                  // Render after the overlay is not hidden on stage
                  renderOverlay();

                  // Focus on the overlay
                  $overlayContainer[0].focus();
                });

                // disable the parent scroll from double scrolling
                scrollableParentScrollTop = scrollableParent.scrollTop;
                window.addEventListener('wheel', preventWheelScroll);
                window.addEventListener('keydown', preventKeyScroll);

              } else {
                onDoneClick($event);
              }
            });

            // Done button listener and function
            $doneButton.on('click touchend', onDoneClick);

            // Cancel Button listener and function
            $cancelButton.on('click touchend', function (event) {
              onDoneClick(event, true);
            });

            // Keyboar event listener for keyboard supports
            element[0].addEventListener('keydown', function (event) {
              switch (event.keyCode) {
                // 'ESC'
                case 27:
                  if (element.hasClass('open')) {
                    onDoneClick(event, true);
                  }
                  break;
              }
            });

            var scrollPane;

            $timeout(function () {
              // Get El reference of the scrollpane when ready
              scrollPane = element[0].querySelector('.bento-multiselect-list-scroll-pane');
            }, 100);

            function preventWheelScroll(event) {
              if (!scrollPane) {
                scrollPane = element[0].querySelector('.bento-multiselect-list-scroll-pane');
              }

              var scrollTop = scrollPane.scrollTop,
                  deltaY    = event.deltaY;

              if ((!scrollPane.contains(event.target) && event.target !== scrollPane)
                || (deltaY < 0 && scrollTop === 0)
                || (deltaY > 0 && (scrollTop + scrollPane.offsetHeight >= scrollPane.scrollHeight))
              ) {
                event.stopPropagation();
                event.preventDefault();
              }

              scrollableParent.scrollTop = scrollableParentScrollTop;
            }

            // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
            // left: 37, up: 38, right: 39, down: 40,
            var keysToPrevent = {
              32: 0, 33: 1, 34: 1, 35: 1, 36: 1, 37: 1, 38: 1, 40: 1
            };

            function preventKeyScroll(event) {
              if (keysToPrevent[event.keyCode]) {
                event.preventDefault();
                event.stopPropagation();
              }
            }

            // jQuery event Listener
            function onDoneClick(event, isDismissal) {
              if (event) {
                event.stopPropagation();
                event.preventDefault();
              }

              element.removeClass('open');
              $overlayContainerWrapper.removeClass('show-overlay');

              window.removeEventListener('wheel', preventWheelScroll);
              window.removeEventListener('keydown', preventKeyScroll);

              // remove window listener
              window.removeEventListener('mousedown', onWindowClick);

              // focus back to the toggle button
              $toggleButton[0].focus();

              if (!!attrs.onDone) {
                var funcName = attrs.onDone.replace('()', '').trim();
                // fire callback function
                if (!!scope[funcName]) {
                  scope[funcName](isDismissal);
                  // notify NG digest
                  scope.$apply();
                }
              }

              $toggleButton.after($overlayContainerWrapper);
            }

            // Window (aka Done) click listener function
            function onWindowClick(event) {
              if (!element[0].contains(event.target) && !$overlayContainerWrapper[0].contains(event.target)) {
                onDoneClick(event, true);
              }
            }

            // Watch and assign overlay height
            if (!!attrs.overlayHeight) {
              scope.$watch(function () {
                return scope[attrs.overlayHeight.trim()];
              }, function (newHeight) {
                overlayHeight = newHeight;
              });
            }

            // Watch and adjust footer height when switching `force-desktop` class
            scope.$watch(function () {
              return $overlayFooter[0].offsetHeight;
            }, function (newHeight) {
              $overlayContainer.css('padding-bottom', newHeight + 'px');
            });

            // Get the parent where there is scrolling or <body>
            function getScrollableParent(el) {
              if (el === null) {
                return;
              }

              var overflowY = window.getComputedStyle(el).getPropertyValue('overflow-y');
              var overflow = window.getComputedStyle(el).getPropertyValue('overflow');

              if (overflowY === 'auto' || overflowY === 'scroll' || overflow === 'auto' || overflow === 'scroll') {
                return el;
              } else if (el.nodeName === 'BODY') {
                return el;
              } else {
                return getScrollableParent(el.parentElement);
              }
            }

            // Find out how far the toggle is away from it's scrolling parent
            function getElementOffsetFrom(element, parentElement) {
              var parentRect = parentElement.getBoundingClientRect();
              var toggleRect = element.getBoundingClientRect();

              // Return the relative RECT of the toggle button to the given parent
              return {
                left  : toggleRect.left - parentRect.left,
                right : parentRect.right - toggleRect.right,
                top   : toggleRect.top - parentRect.top,
                bottom: parentRect.bottom - toggleRect.bottom,
                width : toggleRect.width,
                height: toggleRect.height
              };
            }

            // Render and position overlay
            var getOverlayHeightWith = $parse(attrs.overlayHeight),
                windowResizeTimeout  = 0;

            /**
             * Event Listener when the window is resizing
             * @param e
             */
            function onWindowResize(e) {

              if (element.hasClass('open')) {
                $timeout.cancel(windowResizeTimeout);
                windowResizeTimeout = $timeout(
                  renderOverlay,
                  100
                );
              }
            }

            // Attach windows resize code
            window.addEventListener('resize', onWindowResize);
            // Make sure to remove the listener when this component is destroyed
            scope.$on('$destroy', function () {
              window.removeEventListener('resize', onWindowResize);
              $overlayContainerWrapper.remove();
            });

            function renderOverlay() {
              var parentElement = $overlayContainerWrapper,
                  viewport      = {
                    width : Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
                    height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
                  };

              if (viewport.width < 601 || viewport.height < 421) {
                parentElement.addClass('bento-side-overlay-container-wrapper-fixed open');
                $body.append($overlayContainerWrapper);
                $doneButton.addClass('btn-primary');
                $doneButton.removeClass('btn-default');
              } else {
                parentElement.removeClass('bento-side-overlay-container-wrapper-fixed open');
                $toggleButton.after($overlayContainerWrapper);
                $doneButton.addClass('btn-default');
                $doneButton.removeClass('btn-primary');

                var maxOverlayHeight      = scrollableParent.offsetHeight - overlayMargin * 2,
                    overlayInnerHeight    = !!attrs.overlayHeight ? getOverlayHeightWith(scope) : -1,
                    toggleOffset          = getElementOffsetFrom($toggleButton[0], scrollableParent),
                    toggleOffsetTop       = toggleOffset.top -
                      (document.documentElement.scrollTop || document.body.scrollTop),
                    toggleCenterOffsetTop = toggleOffsetTop + $toggleButton[0].offsetHeight * 0.5,

                    // check toggle button location and realign if needed
                    // for better layout spacing
                    allowedTopSpacing     = overlayMargin + 25,
                    overlayHeight,
                    targetOverlayTop;

                // adjust overlay height based on the scrollable container or body
                if (overlayInnerHeight > 0) {
                  // overlayHeight is bigger than max-height
                  if (overlayInnerHeight > maxOverlayHeight - $overlayFooter[0].offsetHeight) {
                    $overlayContainer.css('max-height', maxOverlayHeight + 'px');
                  } else {
                    $overlayContainer.css('max-height', (overlayInnerHeight + $overlayFooter[0].offsetHeight) + 'px');
                  }
                } else {
                  $overlayContainer.css('max-height', maxOverlayHeight + 'px');
                }

                // Get the overlay height of max is updated
                overlayHeight = $overlayContainer[0].offsetHeight;

                //when the scrollable is <BODY>
                if (scrollableParent.tagName === 'BODY') {

                  // We need to scroll up a little bit
                  if (toggleCenterOffsetTop < allowedTopSpacing) {
                    // IE
                    if (document.documentMode) {
                      document.documentElement.scrollTop = toggleOffset.top - allowedTopSpacing;
                    }
                    // Other browsers
                    else {
                      scrollableParent.scrollTop = toggleOffset.top - allowedTopSpacing;
                    }
                    toggleCenterOffsetTop = allowedTopSpacing + $toggleButton[0].offsetHeight * 0.5;
                  } else
                  // We need to scroll down a little
                  if (toggleCenterOffsetTop > scrollableParent.offsetHeight - allowedTopSpacing) {
                    // IE
                    if (document.documentMode) {
                      document.documentElement.scrollTop = (toggleOffset.top + $toggleButton[0].offsetHeight) -
                        scrollableParent.offsetHeight +
                        allowedTopSpacing;
                    }
                    // Other Broswers
                    else {
                      scrollableParent.scrollTop = (toggleOffset.top + $toggleButton[0].offsetHeight) -
                        scrollableParent.offsetHeight +
                        allowedTopSpacing;
                    }
                    toggleCenterOffsetTop = scrollableParent.offsetHeight - allowedTopSpacing -
                      $toggleButton[0].offsetHeight * 0.5;
                  }

                  // Set default
                  targetOverlayTop = -overlayHeight * 0.5;

                  // Make sure the overlay is not overflowing the top
                  if (-targetOverlayTop > toggleCenterOffsetTop - overlayMargin) {
                    targetOverlayTop = -(toggleCenterOffsetTop - overlayMargin + $toggleButton[0].offsetHeight * 0.25);
                  } else
                  // Make sure the overlay is not overflowing the bottom
                  if (overlayHeight + targetOverlayTop > scrollableParent.offsetHeight - toggleCenterOffsetTop - overlayMargin) {
                    targetOverlayTop = scrollableParent.offsetHeight - toggleCenterOffsetTop - overlayMargin -
                      overlayHeight - $toggleButton[0].offsetHeight * 0.25;
                  }
                }
                // Scrollable is other
                else {
                  // We need to scroll up a little bit
                  if (toggleOffset.bottom < allowedTopSpacing) {
                    scrollableParent.scrollTop += allowedTopSpacing - toggleOffset.bottom;
                  }
                  // We need to scroll down a little
                  else if (toggleOffset.top < allowedTopSpacing) {
                    scrollableParent.scrollTop -= allowedTopSpacing - toggleOffset.top;
                  }

                  var overlayLocalRect = getElementOffsetFrom($overlayContainer[0], scrollableParent);

                  // set default
                  targetOverlayTop = -$overlayContainer[0].offsetHeight * 0.5;

                  // Make sure the overlay is not overflowing the top
                  if (targetOverlayTop < overlayMargin) {
                    targetOverlayTop = $overlayContainer[0].offsetTop - overlayLocalRect.top + overlayMargin;
                  } else
                  // Make sure the overlay is not overflowing the bottom
                  if (overlayLocalRect.bottom + targetOverlayTop < overlayMargin) {
                    targetOverlayTop = $overlayContainer[0].offsetTop + overlayLocalRect.bottom - overlayMargin;
                  }

                  if (targetOverlayTop > -$doneButton[0].offsetHeight * 0.5 - overlayMargin) {
                    targetOverlayTop = -$doneButton[0].offsetHeight * 0.5 - overlayMargin;
                  } else if (targetOverlayTop + overlayLocalRect.height < $doneButton[0].offsetHeight * 0.5 + overlayMargin) {
                    targetOverlayTop = -overlayLocalRect.height + $doneButton[0].offsetHeight * 0.5 + overlayMargin;
                  }
                }

                $overlayContainer.css('top', targetOverlayTop + 'px');
              }

              // animate in
              if (!$overlayContainerWrapper.hasClass('show-overlay')) {
                $timeout(function () {
                  $overlayContainerWrapper.addClass('show-overlay');
                });
              }
            }

            function getOffsetFromParent(child, parent) {
              if (!parent.contains(child) || parent === child) {
                return {left: 0, top: 0};
              } else {
                var offset = getOffsetFromParent(child.offsetParent, parent);
                return {
                  left: child.offsetLeft + offset.left,
                  top : child.offsetTop + offset.top
                }
              }
            }
          }
        };
      }
    ])
    // THe actual toggle button
    .directive('bentoSideOverlayToggle', [
      function () {
        return {
          restrict: 'A',
          scope   : false,
          link    : function (scope, element, attrs) {
            // only add class
            element.addClass('bento-side-overlay-toggle noselect');
          }
        };

      }
    ])
    // Redering to the actual toggle
    // Might need templateUrl later
    .directive('bentoSideOverlayContent', [
      '$compile',
      '$timeout',
      '$bentoServices',
      function ($compile, $timeout, $bentoServices) {
        return {
          restrict: 'A',
          scope   : false,
          link    : function (scope, element) {
            element.addClass('bento-side-overlay-container');
            element.wrap('<div class="bento-side-overlay-container-wrapper"></div>');

            // Add arrows
            var leftArrow  = '<div class="bento-side-overlay-left-arrow">' +
              '<svg height="35" width="20">' +
              '<polygon points="21,0 0.5,17.5 21,35" class="bento-side-overlay-triangle" />' +
              '</svg>' +
              '</div>',
                rightArrow = '<div class="bento-side-overlay-right-arrow">' +
                  '<svg height="35" width="20">' +
                  '<polygon points="-1,0 19.5,17.5 -1,35" class="bento-side-overlay-triangle" />' +
                  '</svg>' +
                  '</div>';
            element.after(leftArrow);
            element.after(rightArrow);

            // Add footer
            var footer = angular.element('<div class="bento-side-overlay-container-footer">\
              <button class="btn btn-primary bento-side-overlay-container-footer-done" \
              aria-label="{{\'BENTO_UI_MULTISELECT_OVERLAY_DONE_DESCRIPTION\' | bentoTranslate}}"\
              type="button">' +
              '{{ "BENTO_UI_MULTISELECT_OVERLAY_DONE" | bentoTranslate:doneButtonText }}</button>\
              <button class="btn btn-default bento-side-overlay-container-footer-cancel" \
              aria-label="{{\'BENTO_UI_MULTISELECT_OVERLAY_CANCEL_DESCRIPTION\' | bentoTranslate}}"\
              type="button">' +
              '{{ "BENTO_UI_MULTISELECT_OVERLAY_CANCEL" | bentoTranslate }}</button>\
              </div>');

            $compile(footer)(scope);
            element.append(footer);
            // Loops tabs within
            $bentoServices.loopTabbables(element);
          }
        };
      }
    ])

    /**
     * Sub Directive
     * Bento MultiSelect List
     */

    /*
     * Show only the selected item base on the flag
     */
    .filter('multiselectShowSelected', function () {
      return function (itemArray, flag, uid) {
        if (flag) {
          var arr = [];
          for (var i = 0; i < itemArray.length; i++) {
            var item = itemArray[i];

            if (getItemChecked(item, uid)) {
              arr.push(item);
            }
          }
          return arr;
        }

        return itemArray;
      };
    })
    .directive('bentoMultiselectList', [
      '$timeout',
      '$bentoServices',
      '$filter',
      function ($timeout, $bentoServices, $filter) {
        return {
          templateUrl: function (element, attrs) {
            return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/multiselect_list/bento-multiselect-list.html';
          },
          scope      : {
            listData        : '&',
            onChange        : '&',
            selectedItems   : '=',
            side            : '@',
            selectAllText   : '@',
            showAllText     : '@',
            showSelectedText: '@',
            sort            : '=',  // (boolean) sort
            sortReverse     : '=', // (boolean) sort reverse
            maxAllowedHeight: '=?' // Get the total height of the scrolling for external use
          },
          link       : function (scope, element, attrs) {
            var firstLoad = true
            ;

            scope.filteredItems = [];
            scope.checkedUid = CHECKED_STAT + $bentoServices.generateUID();

            if (typeof scope.selectedItems === 'undefined') {
              scope.selectedItems = [];
            }
            scope.searchTerm = '';

            // showSelectedCallback
            scope.setShowSelected = function (bool) {
              // change focus
              element[0].querySelector('.bento-multiselect-search input').focus();
              scope.showSelected = bool;
            };

            // Helper
            function redefineAllChecked() {
              // Check whether to show the check to "Select All" checkbox
              if (hasAllChecked(scope.filteredItems, scope.checkedUid)) {
                scope.selectAll = true;
              } else {
                scope.selectAll = false;
              }
            }

            function refreshList() {
              // Dataset is not ready
              if (typeof scope.listData() === 'undefined') {
                return;
              }

              var value = scope.searchTerm;
              if (!value || typeof value.length === 'undefined' || value.length === 0) {
                scope.filteredItems = scope.sort ? $filter('orderBy')(scope.listData(), 'name', scope.sortReverse) :
                  scope.listData().slice();
              } else {
                scope.filteredItems = scope.sort ?
                  $filter('orderBy')(searchArray(value, scope.listData(), 'name'), 'name', scope.sortReverse) :
                  searchArray(value, scope.listData(), 'name');
              }

              redefineAllChecked();
            }

            scope.onSearchChange = function () {
              refreshList();
            };

            scope.$watchCollection(function () {
              return scope.listData();
            }, function (value) {
              refreshList();
            });

            // Helper

            scope.$watchCollection('selectedItems', function (newArray, oldArray) {
              var i, len;

              for (i = 0, len = oldArray.length; Array.isArray(oldArray) && i < len; i++) {
                setItemChecked(oldArray[i], false, scope.checkedUid);
              }

              if (newArray) {
                for (i = 0, len = newArray.length; i < len; i++) {
                  setItemChecked(newArray[i], true, scope.checkedUid);
                }
              }

              redefineAllChecked();

              // Fire a callback
              if (!firstLoad) {
                scope.onChange();
              } else {
                firstLoad = false;
              }
            });

            var searchBar  = element[0].querySelector('.bento-multiselect-search'),
                scrollPane = element[0].querySelector('.bento-multiselect-list-scroll-pane');

            element.addClass('bento-multiselect-list-wrapper');

            //Watch the top offset of `.bento-multiselect-list-scroll-pane`
            scope.$watch(function () {
              return searchBar.offsetHeight;
            }, function (newHeight) {
              scrollPane.style.top = newHeight + 'px';

              // Update maxAllowedHeight
              scope.maxAllowedHeight = searchBar.offsetHeight + scrollPane.scrollHeight;
            });

            /**
             * Triggers select and deselect all items
             */
            scope.onSelectAllClick = function () {

              scope.selectAll = !scope.selectAll;

              if (scope.selectAll) {
                scope.selectedItems = [];
                for (var i = 0; i < scope.filteredItems.length; i++) {
                  var item = scope.filteredItems[i];
                  scope.selectedItems.push(item);
                }
              } else {
                scope.selectedItems = [];
              }
            };

            /**
             * Update checked status when an item is clicked
             * @param item
             */
            scope.onItemClick = function (item) {
              var selectItemIndex = scope.selectedItems.indexOf(item);

              if (selectItemIndex === -1) {
                scope.selectedItems.push(item);
              } else {
                scope.selectedItems.splice(selectItemIndex, 1);
              }
            };

            /**
             * Like htmlentities in PHP, it change special characters such as (>) into their encoded values (&lt;)
             */
            scope.htmlEntities = function (str) {
              return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
            };

            // Get Max height
            $timeout(function () {
              scope.maxAllowedHeight = searchBar.offsetHeight + scrollPane.scrollHeight;
            });
          }
        };
      }
    ]);

  // helper classes
  /**
   * See if the array has all items checked
   * @param  {Array}  a Array to check
   * @return {Boolean}
   */
  function hasAllChecked(a, uid) {
    var len = a.length;

    // Empty array
    if (len === 0) {
      return false;
    }

    for (var i = 0; i < len; i++) {
      if (!getItemChecked(a[i], uid)) {
        return false;
      }
    }
    return true;
  }

  /**
   * check if the two arrays have the same child in order
   **/
  function arrayEqual(a1, a2) {

    if (
      (!a1 && !a2) ||
      (a1 && a1.length === 0 && !a2 ) ||
      (!a1 && a2 && a2.length === 0) ||
      (a1 === a2)
    ) {
      // Both arrays are undefined or
      // one of the arrays is undefined and the other has length that is 0
      return true;
    }

    if ((a1 && a1.length > 0 && !a2 ) || (!a1 && a2 && a2.length > 0)) {
      // one of the arrays is undefined and the other has length > 0
      return false
    }

    if (a1.length != a2.length) {
      // Two arrays have difference lengths
      return false;
    }

    // Need to sort the two arrays
    var a1S = a1.slice().sort(function(a,b){
          return a.name > b.name;
        }),
        a2S = a2.slice().sort(function(a,b){
          return a.name > b.name;
        });

    for (var i = 0, len = a1S.length; i < len; i++) {
      // Do the
      if (a1S[i] != a2S[i]) {
        return false;
      }
    }
    return true;
  }

  /**
   * Search and return an array of found items
   * @param  {String} search - Search term
   * @param  {Array}  array  - Array to search from
   * @param  {String} label  - Label of the variable to search from each object
   * @return {Array}         - Found objects in an array
   */
  function searchArray(search, array, label) {
    var found     = [],
        item,
        searchLow = search.toLowerCase();

    // Linear search
    for (var i = 0, len = array.length; i < len; i++) {
      item = array[i];
      if (item[label].toLowerCase().indexOf(searchLow) > -1) {
        found.push(item);
      }
    }

    return found;
  }

  /**
   * Set a item checked/unchecked
   * @param {object}  obj  the item object
   * @param {boolean} flag
   */
  function setItemChecked(obj, flag, checkedUid) {
    obj[checkedUid] = flag;
  }

  /**
   * Get an item check state
   * @param  {object}      obj Item object
   * @param  {uid}         uid Unique ID
   * @return {boolean}     checked/unchecked
   */
  function getItemChecked(obj, checkedUid) {
    return obj[checkedUid];
  }
})
(window.angular, window);
(function(angular) {
  'use strict';

  //Define bentoUI App object
  angular
    .module('bento.nav.toolbar', ['bento.translate', 'bento.services', 'bento.reset', 'bento.cookie'])
    .constant('bentoNavToolbarConfig', {
      addAccessibilityToMenu: function(menuItem) {
        if (!menuItem) return;
        menuItem.setAttribute('role', 'menu');
        var menuChildren = angular.element(menuItem).children();
        //set ARIA roles for 'more' buttons
        for (var i = 0, total = menuChildren.length; i < total; i++) {
          var el = menuChildren[i];
          if (el) {
            this.addAccessibilityToListElements(el);

            el.setAttribute('role', 'menuitem');
            if (angular.element(el).hasClass('divider')) {
              el.setAttribute('role', 'separator');
            }
          }
        }
      },
      addAccessibilityToListElements: function(listItem) {
        if (!listItem) return;
        var anchorButton = listItem.getElementsByTagName('a')[0];
        var listElement = angular.element(listItem);

        if (anchorButton) {
          anchorButton.setAttribute('role', 'button');

          if (listElement.hasClass('active')) {
            anchorButton.setAttribute('aria-checked', 'true');
          }
          if (listElement.hasClass('disabled') || (listItem.attributes['disabled'] && listItem.attributes['disabled'].value === 'disabled')) {
            anchorButton.setAttribute('aria-disabled', 'true');
          }
        }
      },
      disableMenuButtons: function(menuItem) {
        if (!menuItem) {
          return;
        }
        var menuChildren = angular.element(menuItem).children();
        for (var i = 0, total = menuChildren.length; i < total; i++) {
          var el = menuChildren[i];
          if (el) {
            el.setAttribute('tabindex', '-1');
            var anchorButton = el.getElementsByTagName('a')[0];
            if (anchorButton) {
              anchorButton.setAttribute('tabindex', '-1');
            }
          }
        }
      },
      enableMenuButtons: function(menuItem) {
        if (!menuItem) {
          return;
        }
        var menuChildren = angular.element(menuItem).children();
        for (var i = 0, total = menuChildren.length; i < total; i++) {
          var el = menuChildren[i];
          if (el) {
            el.removeAttribute('tabindex');
            var anchorButton = el.getElementsByTagName('a')[0];
            if (anchorButton) {
              anchorButton.removeAttribute('tabindex');
            }
          }
        }
      },

    })
    .controller('bentoNavToolbarController', ['$scope',
      function($scope) {

      }
    ])
    .directive('toolbarDropdown', ['$parse', '$window', '$timeout', '$compile', 'bentoNavToolbarConfig',
      function($parse, $window, $timeout, $compile, config) {
        return {
          restrict: 'C',
          scope: false,
          link: function(scope, element) {
            var isToggledOpen = false;
            var toolbarMenu = element[0].querySelector('ul.toolbar-dropdown-menu');
            var toggleElement = element[0].querySelector('a.toolbar-dropdown-toggle');

            element.addClass('toolbar-dropdown-close');
            element.removeClass('toolbar-dropdown-open');

            toggleElement.setAttribute('aria-expanded', 'false');

            config.disableMenuButtons(toolbarMenu);
            scope.$on('$destroy', onDestroy);
            element.on('$destroy', onDestroy);

            function closeMenu(el) {
              element.addClass('toolbar-dropdown-close');
              element.removeClass('toolbar-dropdown-open');
              el.setAttribute('aria-expanded', 'false');
              config.disableMenuButtons(toolbarMenu);
            }
            angular.element(toggleElement).bind('click', function() {
              //if element has attribute disabled, do not toggle open
              if (toggleElement.attributes['disabled'] && toggleElement.attributes['disabled'].value === 'disabled') {
                return;
              } else if (toggleElement.parentNode.attributes['disabled'] && toggleElement.parentNode.attributes['disabled'].value === 'disabled') {
                return;
              }
              if (isToggledOpen) {
                closeMenu(this);
              } else {
                element.addClass('toolbar-dropdown-open');
                element.removeClass('toolbar-dropdown-close');
                toggleElement.setAttribute('aria-expanded', 'true');
                config.enableMenuButtons(toolbarMenu);
              }
              isToggledOpen = !isToggledOpen;
            });

            //watch if dropdown toggle or toggle parent (list item) has attribute disabled
            if (toggleElement.attributes['ng-disabled']) {
              scope.$watch(function() {
                return toggleElement.attributes['disabled'];
              }, disableToggle);
            } else if (toggleElement.parentNode.attributes['ng-disabled']) {
              scope.$watch(function() {
                return toggleElement.parentNode.attributes['disabled']
              }, disableToggle);
            }

            function onDestroy() {
              angular.element(toggleElement).unbind('click');
            };
            //ARIA
            config.addAccessibilityToMenu(toolbarMenu);

            function disableToggle(newValue) {
              if (newValue && newValue.value === 'disabled') {
                closeMenu(toggleElement);
                isToggledOpen = false;
                return;
              }
            }
          }
        };
      }
    ])
    .directive('bentoNgRepeatComplete', ['$timeout',
      function($timeout) {
        return {
          restrict: 'A',
          require: '^bentoNavToolbar',
          link: function(scope, element, attr, ctrl) {
            if (scope.$last === true) {
              $timeout(function() {
                ctrl.onRepeatComplete();
                // scope.$emit('bentoNgRepeatComplete');
              });
            }
          }
        }
      }
    ])
    .directive('bentoNavToolbar', ['$parse', '$window', '$timeout', '$compile', 'bentoNavToolbarConfig',
      function($parse, $window, $timeout, $compile, config) {
        return {
          restrict: 'EA',
          scope: {
            control: '=?'
          },
          controller: 'bentoNavToolbarController',
          link: function(scope, element, attrs, ctrl) {
            // localization
            var moreLabel = '{{ "BENTO_UI_NAV_TOOLBAR_MORE" | bentoTranslate }}';
            // if more button is explicit, use the attribute's value
            if (attrs.moreButtonLabel !== undefined) {
              scope._moreButtonLabel = attrs.moreButtonLabel;
              moreLabel = '{{_moreButtonLabel}}'
              attrs.$observe('moreButtonLabel', function(val) {
                scope._moreButtonLabel = val;
              });
            }

            //http://stackoverflow.com/questions/16881478/how-to-call-a-method-defined-in-an-angularjs-directive
            scope.internalControl = scope.control || {};

            scope.internalControl.refresh = function() {
              onRefresh();
            }
            scope.$on('$destroy', onDestroy);
            element.on('$destroy', onDestroy);
            // scope.$on('bentoNgRepeatComplete',onRepeatComplete);
            scope.$on('bentoToolbarRefresh', onRefresh);
            scope.$on('bentoToolbarRefreshInit', onRefreshInit)
            ctrl.onRepeatComplete = onRepeatComplete;
            //template for "more" dropdown
            var moreTemplate = '<li class="dropdown" data-more-buttons="true" uib-dropdown>' +
              '    <a href="" class="dropdown-toggle" role="button" uib-dropdown-toggle>' + moreLabel + '</a>' +
              '    <ul role="menu" class="more-dropdown-menu dropdown-menu" ng-click="$event.stopPropagation()">' +
              '    </ul>' +
              '</li>';

            var menuList,
                moreButton,
                moreWidth,
                mainContainer,
                rightContainer,
                buttonArray,
                moreContainer,
                moreIndex,
                children,
                dropdownButtons,
                initTimeout;

            function setUpVars() {
              //get main '<ul>' element and append "more" dropdown
              menuList = element[0].querySelector('ul.nav.navbar-nav');

              if(!menuList){
                var ulElement = document.createElement('ul');
                ulElement.className = "nav navbar-nav";
                menuList = element[0].appendChild(ulElement);
              }

              if (!element[0].querySelector('[data-more-buttons]')) {
                menuList.insertAdjacentHTML('beforeend', moreTemplate);
                var moreElement = menuList.lastChild;
                $compile(moreElement)(scope);
              }
              //set up initial vars
              moreButton = element[0].querySelector('[data-more-buttons]'); //more button
              moreButton.style.opacity = 0;
              moreWidth = moreButton ? moreButton.offsetWidth : 0; //width of more button
              mainContainer = angular.element(menuList); //main '<ul>' element as angular object
              rightContainer = element[0].querySelector('.navbar-right'); //search container
              buttonArray = []; //array of buttons
              moreContainer = moreButton.querySelector('ul.dropdown-menu'); //'<ul>' element of 'more' dropdown
              //children of main '<ul>' element
              children = mainContainer.children();
              //array of all dropdowns that are not 'more' button
              dropdownButtons = [];
            }
            setUpVars();

            //before initializing buttons, clear any previously generated elements
            function cleanUp() {
              var toolbarDropDowns = element[0].querySelectorAll('.toolbar-dropdown');
              for(var i=0,ttl=toolbarDropDowns.length;i<ttl;i++){
                toolbarDropDowns[i].parentNode.removeChild(toolbarDropDowns[i]);
              }
            }
            //init buttons, determine initial widths

            function initButtons() {
              cleanUp();
              setUpVars();

              if (!element[0].hasAttribute('role')) {
                element[0].setAttribute('role', 'toolbar');
              }

              var buttonElement, originalElement;

              menuList.setAttribute('role', 'menu');

              //determine initial order and widths of buttons
              for (var i = 0, total = children.length; i < total; i++) {
                var el = children[i];
                var innerEl = el.children[0];

                var width = getTotalWidth(el) + 5;

                //set data attributes with order and widths
                el.setAttribute('data-button-id', i);
                el.setAttribute('data-button-width', width);

                //clean up ng-repeats and ng-attr-dropdown, if any
                el.removeAttribute('ng-repeat');
                el.removeAttribute('ng-attr-dropdown');
                el.removeAttribute('ng-attr-uib-dropdown');



                //ARIA
                config.addAccessibilityToListElements(el);

                buttonArray[i] = el;

                //if element is a dropdown, clone it for use in the 'more' dropdown as
                //a nested dropdown with different behavior
                var $el = angular.element(el);

                if (!el.hasAttribute('dropdown')&&!el.hasAttribute('uib-dropdown')) {
                  $el.removeClass('dropdown');
                } else if ($el.hasClass('dropdown') && !el.hasAttribute('data-more-buttons') && !$el.hasClass('static-item')) {
                  buttonElement = $el.clone()[0];
                  originalElement = el;


                  var obj = {
                    'buttonElement': buttonElement,
                    'originalElement': originalElement
                  };
                  dropdownButtons.push(obj);

                  //ARIA
                  var dropElement = el.querySelector('.dropdown-menu');
                  config.addAccessibilityToMenu(dropElement);
                }
              }

              //iterate through the cloned dropdowns and append to dom
              for (var i = 0, total = dropdownButtons.length; i < total; i++) {
                buttonElement = dropdownButtons[i].buttonElement;
                originalElement = dropdownButtons[i].originalElement;
                //append it to DOM
                originalElement.parentNode.insertBefore(buttonElement, originalElement);

                var origScope = angular.element(originalElement).scope();


                //get the order id
                var id = buttonElement.getAttribute('data-button-id');
                //remove the data attribute for button-id
                buttonElement.removeAttribute('data-button-id');
                //set new data attribute with same order id, will be used later
                //in adjustButtons() to determine placement in "more" dropdown
                buttonElement.setAttribute('data-dropdown-id', id);
                //set width data attribute to 0, just in case
                buttonElement.setAttribute('data-button-width', 0);
                //hide it until later when it's displayed in the 'more' dropdown
                buttonElement.style.display = 'none';

                //alter the class names so it doesn't get compiled as regular dropdown
                //it will compile as new toolbar-dropdown directive instead
                buttonElement = angular.element(buttonElement);

                var hasDropdown = buttonElement.hasClass('dropdown');
                if (hasDropdown) {
                  buttonElement.removeClass('dropdown');
                  buttonElement.removeAttr('dropdown');
                  buttonElement.removeAttr('uib-dropdown');
                  buttonElement.addClass('toolbar-dropdown');
                  //remove ng-repeat before recompiling
                  buttonElement.removeAttr('ng-repeat');

                  var dropdownMenu = buttonElement[0].querySelector('ul.dropdown-menu');
                  var origDropDownMenu = originalElement.querySelector('ul.dropdown-menu');

                  var dropdownMenuChildren = dropdownMenu ? dropdownMenu.children : [];
                  var origDropDownMenuChildren = origDropDownMenu ? origDropDownMenu.children : [];

                  //Clean up any ng-repeats before it get's compiled again
                  for (var j = 0, len = dropdownMenuChildren.length; j < len; j++) {
                    var ddChild = dropdownMenuChildren[j];
                    if (ddChild) {
                      var ddChildElement = angular.element(ddChild);
                      var hasRepeat = ddChildElement.attr('ng-repeat');
                      if (hasRepeat != undefined) {
                        ddChildElement.removeAttr('ng-repeat');
                        var oScope = angular.element(origDropDownMenuChildren[j]).scope();


                        $compile(ddChild)(oScope);
                        // //find ng-click and remove before compiling again
                        var ddChildClick = ddChild.querySelector('[ng-click]');
                        angular.element(ddChildClick).removeAttr('ng-click');
                      }

                    }
                  }

                  //rename dropdown menu and dropdown toggle to custom class, and remove ng-if before recompiling
                  angular.element(dropdownMenu).removeClass('dropdown-menu').addClass('toolbar-dropdown-menu').removeAttr('ng-if');
                  var dropdownToggle = buttonElement[0].querySelector('a[dropdown-toggle]')||buttonElement[0].querySelector('a[uib-dropdown-toggle]');
                  angular.element(dropdownToggle).removeAttr('dropdown-toggle').removeAttr('uib-dropdown-toggle').addClass('toolbar-dropdown-toggle').removeClass('dropdown-toggle').removeAttr('ng-if');

                }
                $compile(buttonElement)(origScope);
                //compile the toolbar-dropdown directive
                //$compile(buttonElement)(origScope);
              }

              //after all the index of buttons are set, cache the index of more button
              moreIndex = moreButton.getAttribute('data-button-id');

              //window resize listener
              angular.element($window).bind('resize', onWindowResize);
              //scope.$watch(getElementWidth, onWindowResize);
            }

            function getElementWidth() {
              return element[0].offsetWidth;
            }

            function getTotalWidth(el) {
              var style = el.currentStyle || window.getComputedStyle(el);

              var width = el.offsetWidth +
                parseFloat(style.paddingLeft) +
                parseFloat(style.paddingRight) +
                parseFloat(style.marginLeft != "auto" ? style.marginLeft : 0) +
                parseFloat(style.marginRight != "auto" ? style.marginRight : 0);
              return width;
            }

            function resetButtons(){
              setUpVars();
              for (var i = 0, total = children.length; i < total; i++) {
                var el = children[i];
                el.style = 'block';
              }
            }
            //shifts buttons between main container and more container on window resize
            function adjustButtons(reset) {
              var containerWidth = reset ? 100000 : element[0].offsetWidth,
                  childrenWidth = moreWidth,
                  rightWidth = rightContainer ? getTotalWidth(rightContainer) : 0,
                  diffWidth = containerWidth - rightWidth - 20,
                  mainButtonArray = [],
                  moreButtonArray = [];

              moreWidth = moreButton ? moreButton.offsetWidth : 0;

              //if there are no right container, pull-right dropdown-menu
              moreButton.style.opacity = 0;
              var moreDropdownMenu = element[0].querySelector('.more-dropdown-menu');

              if (moreDropdownMenu) {
                if (rightWidth === 0) {
                  angular.element(moreDropdownMenu).parent().addClass("dropdown-menu-right");
                } else {
                  angular.element(moreDropdownMenu).parent().removeClass("dropdown-menu-right");
                }
              }

              //iterate through all the buttons
              for (var index = 0, total = buttonArray.length; index < total; index++) {
                var el = buttonArray[index];
                if (el.getAttribute('data-more-buttons') !== 'true') {
                  var buttonWidth = Number(el.getAttribute('data-button-width'));
                  // buttonWidth = buttonWidth ? buttonWidth : el.offsetWidth;
                  childrenWidth += buttonWidth;
                  var buttonItem = buttonArray[index];
                  var buttonElement = angular.element(buttonItem);
                  var dropdownItem;

                  //if sum of all button widths is greater than window
                  //shift them into 'more' dropdown
                  if (!angular.element(el).hasClass('static-item')) {
                    if (childrenWidth > diffWidth && !angular.element(el).hasClass('display-text')) {
                      buttonItem.setAttribute('role', 'menuitem');
                      moreButtonArray.push(buttonItem);

                      //switch dropdowns
                      if (buttonElement.hasClass('dropdown')) {
                        //get related toolbar-dropdown component
                        var id = buttonItem.getAttribute('data-button-id');
                        id = '[data-dropdown-id="' + id + '"]';
                        dropdownItem = element[0].querySelector(id);
                        buttonItem.style.display = 'none';
                        dropdownItem.style.display = 'block';
                        moreButtonArray.push(dropdownItem);
                      }
                    } else {
                      //if window is wider then sum of all button widths combined
                      //shift buttons out of 'more' dropdown and back into 'main' container
                      buttonItem.removeAttribute('role');
                      mainButtonArray.push(buttonItem);

                      //switch dropdowns
                      if (buttonElement.hasClass('dropdown')) {
                        var id = buttonItem.getAttribute('data-button-id');
                        id = '[data-dropdown-id="' + id + '"]';
                        dropdownItem = element[0].querySelector(id);
                        buttonItem.style.display = 'block';
                        dropdownItem.style.display = 'none';
                        mainButtonArray.push(dropdownItem);
                      }
                    }
                  }
                }
              }

              var moreButtonCount = moreButtonArray.length - 1;
              //iterate through 'more' button array and add to DOM
              while (moreButtonCount >= 0) {
                moreContainer.insertBefore(moreButtonArray[moreButtonCount], moreContainer.firstChild);
                moreButtonCount--;
              }

              //iterate through 'main' button array and add to DOM
              for (var i = 0, total = mainButtonArray.length; i < total; i++) {
                mainContainer.append(mainButtonArray[i]);
                //shift more button to correct place
                var buttonIndex = mainButtonArray[i].getAttribute('data-button-id');
                if (moreIndex > buttonIndex) {
                  mainContainer.append(moreButton);
                }
              }
              //make sure more button is last child
              mainContainer.append(moreButton);

              //display or hide 'more' button
              if (!angular.element(moreContainer).children().length) {
                moreButton.style.display = 'none';
              } else {
                moreButton.style.display = 'block';
                moreButton.style.opacity = 1;
              }

            }

            function onWindowResize() {
              $timeout(function() {
                adjustButtons();
              });
            }

            function onDestroy() {
              angular.element($window).unbind('resize', onWindowResize);
              $timeout.cancel(initTimeout);
            }

            function onRefresh() {
              initTimeout = $timeout(function() {
                adjustButtons(true);
                initButtons();
                adjustButtons();
              })
            }
            function onRefreshInit() {
              initTimeout = $timeout(function() {
                resetButtons();
                initButtons();
                $timeout(function(){
                  adjustButtons();
                });
              })
            }
            function onRepeatComplete() {
              //initial set up
              initTimeout = $timeout(function() {
                initButtons();
                adjustButtons();
              });
            }

            if (!attrs.deferInit) {
              //initial set up
              initTimeout = $timeout(function() {
                initButtons();
                adjustButtons();
              });
            }

          }


        };
      }
    ]);
})(window.angular);
(function (window, angular, undefined) {
  'use strict';

  //Define bentoUI App object
  angular.module('bento.numberinput', ['bento.services'])
    .factory('$bentoNumberInputHelper', [

      function () {

        function alignButtons($element, _upButton, _downButton) {
          var parentElement = $element[0].parentNode;
          parentElement.style.width = $element[0].offsetWidth + 'px';
          parentElement.style.height = $element[0].offsetHeight + 'px';
        }

        function updateModelWithStep(model, step, max, min, decimalSep) {
          var value  = Number(String(model).replace(decimalSep, '.')),
              maxNum = Number(max),
              minNum = Number(min);

          if (typeof model === 'undefined') {
            value = 0;
          }

          value = Math.round((Number(value) + step) * 1000000000000) / 1000000000000;

          if (typeof max != 'undefined' && value > maxNum) {
            value = maxNum;
          } else if (typeof min != 'undefined' && value < minNum) {
            value = minNum;
          }

          return String(value).replace('.', decimalSep);
        }

        return {
          alignButtons       : alignButtons,
          updateModelWithStep: updateModelWithStep
        };

      }
    ])
    .directive('bentoNumberInput', [
      '$bentoNumberInputHelper',
      '$bentoServices',
      '$locale',
      '$bentoTranslate',
      '$timeout',
      '$log',
      function ($bentoNumberInputHelper, $bentoServices, $locale, $bentoTranslate, $timeout, $log) {
        return {
          restrict  : 'A',
          require   : 'ngModel',
          replace   : false,
          transclude: true,
          link      : function ($scope, $element, $attrs, ngModelCtrl) {

            // Due to type="number" has limitations retrieving invalid input,
            // we need to change it back to "text"
            if ($attrs.type.toLowerCase() == 'number') {
              $log.warn('Bento.UI: `bento-number-input` must ' +
                'be implemented as `<... type="text" ... />` in order to work properly');
            }

            // Error notification
            if (typeof $attrs.min != 'undefined'
              && typeof $attrs.max != 'undefined'
              && Number($attrs.min) > Number($attrs.max)) {
              $log.error('Bento.UI: `bento-number-input` "max" value must be larger than "min" value');
            }

            // Locale Related
            var decimalSeparatorTranslateLabel = 'BENTO_NUMBER_INPUT_DECIMAL_SEPARATOR';
            var decimalSep = '.';  // default

            // Decide which decimal separator to use
            if ($attrs.decimalSeparator) {
              // Directive has its specified
              decimalSep = $attrs.decimalSeparator;
            } else {
              // Lookup Bento Translate dictionary first
              // NOTE: the translation needs to be pre-defined before this directive is loaded
              $bentoTranslate.translate(decimalSeparatorTranslateLabel)
                .then(bentoTranslateReady);
            }

            // Listen to Bento Translate Onchange when a new translation is ready
            $bentoTranslate.onChange(bentoTranslateOnChange);

            /**
             * Callback to bentoTranslate onchange
             */
            function bentoTranslateOnChange() {
              $bentoTranslate.translate(decimalSeparatorTranslateLabel)
                .then(bentoTranslateReady);
            }

            /**
             * Get the translated decimal separator and update the model
             * @param value
             */
            function bentoTranslateReady(value) {
              if (value != decimalSeparatorTranslateLabel) {
                // Bento Translate defined
                decimalSep = value;
              } else {
                // Use Angular $locale service
                decimalSep = $locale.NUMBER_FORMATS.DECIMAL_SEP;
              }

              // Update ngModelView with the new decimal separator if there is a predefined number
              if (!isNaN(ngModelCtrl.$modelValue)) {
                ngModelCtrl.$setViewValue(String(ngModelCtrl.$modelValue).replace('.', decimalSep));
                ngModelCtrl.$commitViewValue();
                ngModelCtrl.$render();
              }
            }

            var uid = $bentoServices.generateUID();
            var step = Number($attrs.step) || 1;
            var previousValue = '';
            var _upButton = angular.element('<div ' +
              'id="bento-number-input-button-up-' + uid + '" ' +
              'class="bento-number-input-button bento-number-input-button-up">' +
              '<i class="bento-icon-chevron-up"></i>' +
              '</div>'
            );
            var _downButton = angular.element('<div ' +
              'id="bento-number-input-button-up-' + uid + '" ' +
              'class="bento-number-input-button bento-number-input-button-down">' +
              '<i class="bento-icon-chevron-down"></i>' +
              '</div>'
            );

            // Adding parser to handle decimal separator on commit
            ngModelCtrl.$parsers.push(function (value) {
              return typeof value == 'undefined' || value.length === 0 ? undefined : Number(value.replace(decimalSep, '.'));
            });

            // Adding formatter to handle decimal separator on ng-model update
            ngModelCtrl.$formatters.push(function (value) {
              return typeof value == 'undefined' ? '' : String(value).replace('.', decimalSep);
            });

            // Add validator for min and max validation
            ngModelCtrl.$validators.min = function (modelValue) {
              if (typeof $attrs.min == 'undefined') {
                return true;
              }

              return modelValue >= Number($attrs.min);
            };

            ngModelCtrl.$validators.max = function (modelValue) {
              if (typeof $attrs.max == 'undefined') {
                return true;
              }

              return modelValue <= Number($attrs.max);
            };

            // Check max and min to block from additional input
            $element.on('input', function (event) {
              setModelValue(event.currentTarget.value);
            });

            /**
             * Prevent non number input related keypress
             */
            $element[0].addEventListener('keypress', function (event) {
              var char = String.fromCharCode(event.charCode);
              var modelVale = event.currentTarget.value;

              if ((isNaN(char)
                  && event.charCode > 0
                  && char !== '-'
                  && char !== decimalSep
                  && event.charCode != 13)// Enter key on chrome
                || (char == '-' && modelVale.indexOf(char) > -1) //IE 9
                || (char == decimalSep && modelVale.indexOf(char) > -1) //IE 9
                || (char == '-' && event.currentTarget.selectionStart > 0)
              ) {
                event.preventDefault();
                event.stopPropagation();
              }
            });

            /**
             * Watch element height for responsiveness
             */
            $scope.$watch(function () {
              return $element[0].offsetTop;
            }, function (top) {
              _upButton.css('top', top + 'px');
              _downButton.css('top', top + 'px');
            });

            $element[0].addEventListener('paste', function (event) {
              isPasted = true;
            });

            $element[0].addEventListener('keydown', function (event) {
              var target = event.currentTarget,
                  val;

              // 38 up
              // 40 down
              if (event.keyCode === 38) {
                val = $bentoNumberInputHelper
                  .updateModelWithStep(ngModelCtrl.$viewValue, step, $attrs.max, $attrs.min, decimalSep);
                setModelValue(val);
              } else if (event.keyCode === 40) {
                val = $bentoNumberInputHelper
                  .updateModelWithStep(ngModelCtrl.$viewValue, -step, $attrs.max, $attrs.min, decimalSep);
                setModelValue(val);
              } else if (event.keyCode !== 37 && event.keyCode !== 39) {
                setModelValue(target.value);
              }
            });

            //Parse step into a number
            step = Number(step);

            var pointerDown              = 'mousedown touchstart',
                pointerUp                = 'mouseup touchend',
                defaultRepeatDelayAmount = 125,
                initRepeatDelay          = 1000,
                isPasted                 = false,
                repeatDelayAmount,
                delay,
                timeoutProcess,
                direction;

            /**
             * Repeater for Up/Down arrow keys or buttons
             * @param isInitDelay
             */
            function onUpDownTimer(isInitDelay) {
              inputButtonRepeat();

              if (isInitDelay) {
                repeatDelayAmount = defaultRepeatDelayAmount;
                delay = initRepeatDelay;
              } else {
                delay = (delay <= 20) ? 20 : repeatDelayAmount -= 2;
              }

              timeoutProcess = $timeout(onUpDownTimer, delay);
            }

            //On up arrow click
            _upButton.on(pointerDown, function (e) {
              // kill event for right click
              if (e.which == 3) {
                return false;
              }

              // Repeat direction
              direction = step;

              var cElement = $element.context || $element[0];
              if (cElement && !cElement.disabled) {
                onUpDownTimer(true);

                angular.element(window).one(pointerUp, function (e) {
                  $timeout.cancel(timeoutProcess);
                  e.preventDefault();
                  e.stopPropagation();
                });
              }

              e.preventDefault();
              e.stopPropagation();
            });

            //On down arrow click
            _downButton.on(pointerDown, function (e) {
              // kill event for right click
              if (e.which == 3) {
                return false;
              }

              // Repeat direction
              direction = -step;

              var cElement = $element.context || $element[0];
              if (cElement && !cElement.disabled) {
                onUpDownTimer(true);

                angular.element(window).one(pointerUp, function () {
                  $timeout.cancel(timeoutProcess);
                });
              }

              e.preventDefault();
              e.stopPropagation();
            });

            function inputButtonRepeat() {
              var val = $bentoNumberInputHelper
                .updateModelWithStep(ngModelCtrl.$modelValue, direction, $attrs.max, $attrs.min, decimalSep);
              setModelValue(val);
            }

            // Check how many digits that this input field will have
            var maxDigits = typeof $attrs.max != 'undefined' ? $attrs.max.length : 6;
            var digitClass = ' six-digit';

            if (!!$attrs.min && $attrs.min.length > maxDigits) {
              maxDigits = $attrs.min.length;
            }

            if (maxDigits <= 3) {
              digitClass = ' two-digit';
            }

            // Determine if this directive follows bootstrap's `form-control` CSS
            $element.wrap('<span class="bento-number-input-wrapper' +
              ($element.hasClass('form-control') ? ' full-width' : '') +
              digitClass +
              '"></span>');

            // We still need form-control styling
            $element.addClass('form-control');
            $element.after(_downButton);
            $element.after(_upButton);

            // When the DOM element is removed from the page cancel
            // any possible pending triggers
            $scope.$on(
              "$destroy",
              function (event) {
                // Stop arrow press repeater
                $timeout.cancel(timeoutProcess);
                // Remove bentoTranslate callback
                $bentoTranslate.removeOnChange(bentoTranslateOnChange);
              }
            );

            /**
             * Validate the current string and correct its input
             * @param value
             * @returns {object}
             */
            function validateValue(value) {
              var hasMax      = typeof $attrs.max != 'undefined',
                  hasMin      = typeof $attrs.min != 'undefined',
                  vNum        = Number(value),
                  max         = Number(hasMax ? $attrs.max : Number.POSITIVE_INFINITY),
                  min         = Number(hasMin ? $attrs.min : Number.NEGATIVE_INFINITY),
                  maxDigits   = hasMax ? String($attrs.max).length : 20,
                  minDigits   = hasMin ? String($attrs.min).length : 21,
                  valueLength = value.length,
                  isRollback  = false,
                  newNum      = Number(value);

              if (typeof value === 'undefined'
                || valueLength === 0) {
                newNum = '';
              } else if ((isNaN(vNum) && value != '-')
                ||
                (vNum > max || vNum < min)
              ) {
                if (isPasted) {
                  // we need to do concat the value
                  newNum = (vNum > max) ?
                    value.slice(0, maxDigits) :
                    value.slice(0, minDigits)
                } else if (
                  (vNum > max && ((valueLength >= maxDigits && max >= 0) || valueLength >= minDigits))
                  || (vNum < min && ((valueLength >= minDigits && min < 0) || valueLength >= maxDigits))
                  || (min < 0 && max < 0 && vNum >= 0)
                ) {
                  // Rollback when out of bound
                  newNum = previousValue;
                  isRollback = true;
                }
              } else if (value.indexOf('-') === 0 || value.indexOf('.') > -1) {

                if (min >= 0 && max >= 0 && value.indexOf('-') > -1) {
                  // Minus sign is used when max and min are all positive
                  newNum = previousValue;
                  isRollback = true;
                } else {
                  // OK to add both minus sign and default decimal separator
                  newNum = value.trim();
                }
              }

              return {
                number    : newNum,
                isRollback: isRollback
              };
            }

            /**
             * Set value to ngModel
             * @param value
             */
            function setModelValue(value) {
              // Normalize localization
              value = String(value).replace(decimalSep, '.').trim();  // Convert decimal separator back to period

              // No need to update the ngModel since there is no change in string
              if (value == previousValue) {
                return;
              }

              // Proceed with number validation
              var newVal = validateValue(value);
              var newValStr     = String(newVal.number).replace('.', decimalSep),
                  input         = $element[0],
                  caratPosStart = newVal.isRollback ? input.selectionStart - 1 : input.selectionStart,
                  caratPosEnd   = input.selectionEnd;
              ;

              previousValue = newVal.number;
              isPasted = false;

              ngModelCtrl.$setViewValue(newValStr, 'inputvalidate');
              ngModelCtrl.$commitViewValue();
              ngModelCtrl.$render();

              // make sure to bring the selection back after setting the value after rendering
              input.setSelectionRange(caratPosStart, caratPosEnd);
            }
          }
        };
      }
    ]);

})(window, window.angular);
(function (window, angular, undefined) {
  'use strict';

//Define bentoUI App object
  angular.module('bento.off.canvas.menu', [])
  /**
   * Bento Off Canvas Menu Main Controller
   */
    .controller('bentoOffCanvasMenuController', [
      '$scope',
      '$element',
      function ($scope, $element) {

      }
    ])
    /**
     * Bento Off Canvas Menu Main Directive
     */
    .directive('bentoOffCanvasMenu', [
      '$parse',
      '$bentoServices',
      '$timeout',
      function ($parse, $bentoServices, $timeout) {
        /**
         * Main Off Canvas Menu Directive
         */
        return {
          restrict  : 'AE',
          scope     : false,
          controller: 'bentoOffCanvasMenuController',
          link      : function (scope, element, attrs, controller) {
            // Getters
            var expandedLeftGetter, expandedRightGetter;
            var expandedLeftLocal, expandedRightLocal;
            element.addClass('bento-off-canvas-menu');

            if (!!attrs.type && attrs.type === 'push') {
              element.addClass('push-over');
            } else {
              element.addClass('default');
            }

            //Get menu object from DOM
            var $menu = angular.element(element[0].querySelector('.bento-off-canvas-menu-aside'));
            var $menuRight = angular.element(element[0].querySelector('.bento-off-canvas-menu-aside-right'));
            var $menuHeader, $menuHeaderRight;
            var $menuCloseButton, $menuRightCloseButton, $hambugerButton;

            //Get navbar object from DOM
            var $navbar = angular.element(element[0].querySelector('.bento-off-canvas-menu-topbar'));

            //Get content object from DOM
            var $content = angular.element(querySelector(element[0], '.bento-off-canvas-menu-content'));

            // Trnasition listeners
            $menu.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(event){
              if(!element.hasClass('expanded')){
                $menu.addClass('ng-hide');
                $hambugerButton[0].focus();
              }
            });

            $menuRight.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(event){
              if(!element.hasClass('expanded-right')){
                $menuRight.addClass('ng-hide');
              }
            });

            // Left menu ESC key listener
            $menu[0].addEventListener('keyup', function(event){
              if(event.keyCode === 27){
                setLeftExpand(false);
              }
            });

            if ($navbar.length === 0) {
              $content.css('top', '0');
            } else {
              $hambugerButton = angular.element('<button class="bento-off-canvas-menu-button" role="button" aria-label="Open side menu"><i class="bento-icon-hamburger-menu"></i></button>')
              $navbar.prepend($hambugerButton);
              $hambugerButton.on('click', onMenuClick);
            }

            //Add hamburger icon to navbar

            //Add Overlay
            var $overlay = angular.element('<div class="bento-off-canvas-menu-content-overlay"></div>');
            //Adding click actions to menuButton and .bento-off-canvas-menu-content
            $overlay.on('click', onContentClick);

            //Inject a fake background to the menu so it fully extends to the bottom of the page
            // Construct Memu DOM

            // LEFT
            element.append($overlay);


            if ($menu.length > 0) {
              $menu.after('<div class="bento-off-canvas-menu-aside-bg"></div>');
              $menuCloseButton = angular.element('<button class="bento-off-canvas-menu-close-button" role="button" aria-label="Close Side Menu">&times;</button>');
              $menuHeader = angular.element('<div class="bento-off-canvas-menu-header"></div>');
              $menuHeader.append($menuCloseButton);
              $menuHeader.append(['<div class="bento-off-canvas-menu-header-title">', (!!attrs.menuTitle ? attrs.menuTitle : 'Menu'), '</div>'].join(''));
              $menu.prepend($menuHeader);
              $menu.on('click', function (event) {

                if ((event.target.nodeName === 'A' || event.target.nodeName === 'BUTTON' || isParentClickable(event.target))
                  && !event.target.parentNode.hasAttribute('disabled')
                  && !event.target.hasAttribute('bento-off-canvas-menu-aside')
                ) {
                  //auto collapse left aside menu
                  setLeftExpand(false);
                }
              });

              if (attrs.menuTitle) {
                attrs.$observe('menuTitle', function (newValue) {
                  $menuHeader[0].querySelector('.bento-off-canvas-menu-header-title').innerHTML = newValue;
                });
              }
            }

            //Helper function
            // Check if
            function isParentClickable(node){
              var n = node;
              while(n.className.search('bento-off-canvas-menu-aside') === -1 && typeof n !== 'undefined'){
                if(n.nodeName === 'A' || n.nodeName === 'BODY'){
                  return true;
                }
                n = n.parentNode;
              }
              return false;
            }

            // RIGHT
            if ($menuRight.length > 0) {
              $menuRightCloseButton = angular.element('<button class="bento-off-canvas-menu-close-button">&times;</button>');
              $menuHeaderRight = angular.element('<div class="bento-off-canvas-menu-header"></div>');
              $menuHeaderRight.append($menuRightCloseButton);
              $menuRight.prepend($menuHeaderRight);
              $menuRight.after('<div class="bento-off-canvas-menu-aside-bg-right"></div>');
              $menuRightCloseButton.on('click', function (event) {
                setRightExpand(false);
              })
            }

            // Add watchers for expand and collapse
            if (attrs.isExpanded) {
              expandedLeftGetter = $parse(attrs.isExpanded);
            }
            scope.$watch(function () {
                return expandedLeftGetter ? expandedLeftGetter(scope) : expandedLeftLocal;
              },
              function (exp) {
                toggleLeftMenu(exp);
              });

            if (attrs.isExpandedRight) {
              expandedRightGetter = $parse(attrs.isExpandedRight);
            }
            scope.$watch(function () {
                return expandedRightGetter ? expandedRightGetter(scope) : expandedRightLocal;
              },
              function (exp) {
                toggleRightMenu(exp);
              });

            /**
             * Toggle Left Menu
             * @param expanded
             */
            function toggleLeftMenu(expanded) {
              if (expanded) {
                setRightExpand(false);
                $menu.removeClass('ng-hide');
                $timeout(function(){
                  // Animation only works when ng-hide is completely removed
                  element.addClass('expanded');
                  $timeout(function(){
                    $menu[0].focus();
                  },200);
                  element[0].scrollTop = 0;
                  if ($menu.length > 0) {
                    $menu[0].scrollTop = 0;
                  }
                });

              } else if(!element.hasClass('expanded')){
                $menu.addClass('ng-hide');
              } else{
                element.removeClass('expanded');
              }
            }

            /**
             * Toggle Right Menu
             * @param expanded
             */
            function toggleRightMenu(expanded) {
              if (expanded) {
                setLeftExpand(false);
                $menuRight.removeClass('ng-hide');
                $timeout(function(){
                  element.addClass('expanded-right');
                  $timeout(function(){
                    $menuRight[0].focus();
                  },200);
                });

                if ($menuRight.length > 0) {
                  $menuRight[0].scrollTop = 0;
                }
              } else if(!element.hasClass('expanded-right')){
                $menuRight.addClass('ng-hide');
              } else {
                element.removeClass('expanded-right');
              }

            }

            //When the hamburger menu is clicked
            function onMenuClick() {
              setLeftExpand(!expandedLeftLocal);
            }

            //Fires when the content is clicked
            //Check and retract the Off Canvas Menu
            function onContentClick() {
              setLeftExpand(false);
              setRightExpand(false);
            }

            /**
             * Set left menu expand state
             * @param b (bool)
             */
            function setLeftExpand(b) {
              if (expandedLeftGetter) {
                expandedLeftGetter.assign(scope, b);
              }
              expandedLeftLocal = b;

              $bentoServices.safeApply(scope);
            }

            /**
             * Set right menu expand state
             * @param b
             */
            function setRightExpand(b) {
              if (expandedRightGetter) {
                expandedRightGetter.assign(scope, b);
              }
              expandedRightLocal = b;

              $bentoServices.safeApply(scope);
            }
          }
        };
      }])
    /**
     * Bento Off Canvas Menu Aside Directive
     */
    .directive('bentoOffCanvasMenuAside',['$bentoServices', function ($bentoServices) {
      return {
        scope  : false,
        require: '^bentoOffCanvasMenu',
        template: '<div class="bento-off-canvas-menu-aside" ng-transclude tabindex="-1"></div>',
        transclude: true,
        replace: true,
        link   : function (scope, element, attrs) {
          $bentoServices.loopTabbables(element);
        }
      };
    }])
    /**
     * Bento Off Canvas Menu Aside Right Directive
     */
    .directive('bentoOffCanvasMenuAsideRight',['$bentoServices', function ($bentoServices) {
      return {
        scope  : false,
        require: '^bentoOffCanvasMenu',
        template: '<div class="bento-off-canvas-menu-aside-right" ng-transclude tabindex="-1"></div>',
        transclude: true,
        replace: true,
        link   : function (scope, element, attrs) {
        }
      };
    }])
    /**
     * Bento Off Canvas Menu Top Navbar
     */
    .directive('bentoOffCanvasMenuTopbar', function () {
      return {
        scope  : false,
        require: '^bentoOffCanvasMenu',
        link   : function (scope, element, attrs, controller) {
          element.addClass('bento-off-canvas-menu-topbar');
        }
      };
    })
    /**
     * Bento Off Canvas Menu Main Content
     */
    .directive('bentoOffCanvasMenuContent', function () {
      return {
        scope  : false,
        require: '^bentoOffCanvasMenu',
        link   : function (scope, element, attrs, controller) {
          element.addClass('bento-off-canvas-menu-content');
        }
      };
    });

  // Helper functions
  function querySelector(element, queryString) {
    var obj = element.querySelector(queryString);

    // Return if obj is not null
    if (typeof obj !== 'undefined' && obj) {
      return obj;
    } else {
      obj = element.querySelector(queryString.replace('div[', 'div[data-'));
      return obj;
    }

  }
})(window, window.angular);
(function(angular, window) {
  'use strict';
  //Define bentoUI App object
  var bentoPaginageApp = angular.module('bento.pagination', ['bento.services', 'bento.select', 'bento.cookie', 'bento.translate']);
  //Directive
  bentoPaginageApp
    .controller('bentoPaginationController',bentoPaginationController)
    .directive('bentoPagination', bentoPagination);

  function bentoPaginationController(){
    return this;
  }
  bentoPagination.$inject = ['$parse', '$q', '$window'];

  function bentoPagination($parse, $q, $window) {
    return {
      restrict: 'EA',
      scope: {
        currentPage: '=page',
        totalItems: '=',
        itemsPerPage: '=?',
        infoText: '@', // String
        infoPageText: '@', // String
        goToText: '@', // String
        directionLinks: '&',
        boundaryLinks: '&',
        itemsArray: '=?',
        onChange: '&',
        onChangeSize: '&',
        eventTracking: '&',
        onSelectPage: '&'
      },
      templateUrl: function(element, attrs) {
        return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/pagination/bento-pagination.html'
      },
      controller: 'bentoPaginationController',
      controllerAs: 'bentoPaginationCtrl',
      replace: true,
      link: function(scope, el, attrs, paginationCtrl) {
        // Link Math lib to template
        scope.Math = Math;


        var trackedEvent = {
          eventName: 'default',
          value: '-1'
        };
        var onChangeEvent = {
          page: 1
        };
        var sizeChangeEvent = {
          size: -1
        };

        paginationCtrl = scope.VM = {
          currentPage: 1,
          tgtPage: 1,
          maxPage: 1,
          itemsPerPage: 10,
          itemsPerPageHistory: 10,
          itemsArray: [{
            value: 10,
            label: 10
          }, {
            value: 25,
            label: 25
          }, {
            value: 50,
            label: 50
          }, {
            value: 100,
            label: 100
          }],
          goBtnVisible: true,
          goIconVisible: false,
          boundaryLinks: true,
          directionLinks: true,
          lastButtonSmallMargin: false
        };

        Object.keys(scope.VM).forEach(function(el, i) { //ignores interpolated attributes
          attrs[el] = (typeof(attrs[el]) == 'undefined') ? scope.VM[el] : attrs[el];
          // scope[el] = (typeof(scope[el]) == "undefined") ? scope.VM[el] : scope[el];
        });
        scope.VM.boundaryLinks = typeof attrs.boundaryLinks == 'string' ? JSON.parse(attrs.boundaryLinks.toLowerCase()) : true;
        scope.VM.itemsPerPageHistory = scope.itemsPerPage;
        scope.VM.maxPage = Math.ceil(scope.totalItems / scope.itemsPerPage);

        //set default itemsArray if needed
        scope.itemsArray = scope.itemsArray ? scope.itemsArray : scope.VM.itemsArray;

        var renderComponent = function() {
          scope.VM.tgtPage = scope.currentPage;
          scope.VM.maxPage = Math.ceil(scope.totalItems / scope.itemsPerPage);
          scope.eventTracking(trackedEvent);
          if (scope.currentPage != onChangeEvent.page) {
            onChangeEvent.page = scope.currentPage;
            scope.onChange(onChangeEvent);
          }
        };
        scope.renderComponent = renderComponent; //used only to test this function.
        angular.element($window).on('resize', onWindowResize);
        scope.$watch(function() {
          return el[0].offsetWidth;
        }, onElementResize);
        scope.$on('$destroy', onDestroy);

        scope.$watch('itemsPerPage', function(newValue, oldValue) {
          // Yes, this happens on $watch()...
          if (newValue === oldValue) {
            return;
          }
          trackedEvent.eventName = "items per page changed";
          trackedEvent.value = scope.itemsPerPage;
          sizeChangeEvent.size = scope.itemsPerPage;
          scope.onChangeSize(sizeChangeEvent);

          // No change when the current page is 1
          if (scope.currentPage === 1 || (angular.isDefined(attrs.pageOverride)&&attrs.pageOverride == "true")) {
            renderComponent();
          } else {
            scope.currentPage = 1;
          }
        });

        scope.$watch('currentPage', function(newVal,oldVal) {
          if(newVal !== oldVal){
            renderComponent();
          }
        });

        scope.$watch('totalItems', function() {
          trackedEvent.eventName = "total items changed";
          trackedEvent.value = scope.totalItems;
          renderComponent();
        });

        attrs.$observe('infoPageText', function(value) {
          if (value) {
            renderComponent();
          }
        });
        attrs.$observe('infoText', function(value) {
          if (value) {
            renderComponent();
          }
        });
        attrs.$observe('goToText', function(value) {
          if (value) {
            renderComponent();
          }
        });


        scope.keySelectPage = function(ev, page) {
          ev = (ev) ? ev : window.event;
          if (ev.which === 13) {
            scope.goToPage(page);
          }
        };

        scope.goToPage = function(n) {
          //if there are no items, disable pagination
          if(scope.totalItems<=0){
            return;
          }
          if (n === "max") {
            scope.currentPage = scope.VM.maxPage;
          } else {
            scope.currentPage = (!isNaN(parseInt(n)) && n > 0 && n <= scope.VM.maxPage) ? parseInt(n) : scope.currentPage;
          }
          trackedEvent.eventName = "current page value modification";
          trackedEvent.value = "input value => " + n + " value@ " + scope.currentPage;
        };

        function onWindowResize() {
          scope.$apply();
        }

        function onElementResize(width) {
          if (!width) return;
          if (width < 550) {
            scope.VM.lastButtonSmallMargin = true;
            if (width < 420) {
              scope.VM.boundaryLinks = false;
              if (width < 290) {
                scope.VM.goBtnVisible = false;
              } else {
                scope.VM.goIconVisible = true;
                scope.VM.goBtnVisible = true;
              }
            } else {
              scope.VM.goIconVisible = false;
              scope.VM.goBtnVisible = true;
              checkBoundaryLinks();
            }
          } else {
            scope.VM.goIconVisible = false;
            scope.VM.goBtnVisible = true;
            checkBoundaryLinks();
            scope.VM.lastButtonSmallMargin = false;
          }
        }

        function checkBoundaryLinks() {
          scope.VM.boundaryLinks = typeof attrs.boundaryLinks == 'string' ? JSON.parse(attrs.boundaryLinks.toLowerCase()) : true;
        }

        function onDestroy() {
          angular.element($window).off('resize', onWindowResize);
        }

      }
    };
  }
})(window.angular, window);
(function (window, angular, undefined) {
  'use strict';

// Define bentoUI App object
  angular.module('bento.reset', ['bento.services'])

  /**
   * Main Bento Reset factory
   */
    .factory('$bentoResetFactory', [
      '$bentoServices',
      function ($bentoServices) {
        var isRTL = $bentoServices.isRTL();
        /**
         * Align the clear button to the input field
         * @param inputElement
         * @param clearButton
         */
        var alignClearButton = function (inputElement, clearButton) {

          var position = 'left';

          if(isRTL){
            position = 'right';
          }
          // set left
          clearButton.css(position,
            (inputElement[0].offsetWidth - clearButton[0].offsetWidth + inputElement[0].offsetLeft) + 'px'
          );

          // set top
          clearButton.css('top',
            (inputElement[0].offsetTop + (inputElement[0].offsetHeight - clearButton[0].offsetHeight) * 0.5) + 'px'
          );

        };

        /**
         * Show and hide clear button and adjust input fields right padding
         * @param inputElement
         * @param clearButton
         * @param value
         */
        var showAndHideButton = function (inputElement, clearButton, value) {
          // Hide clearButton where is the input field is empty
          // or it is not focused
          if (typeof value === 'undefined' || value === null || value.length === 0) {
            clearButton.addClass('hide');
            inputElement.removeClass('bento-reset-dirty');
            window.removeEventListener('resize', windowResizeEventHandler);
          } else if (clearButton.hasClass('hide')) {
            clearButton.removeClass('hide');
            inputElement.addClass('bento-reset-dirty');
            // Realign clear button is there is any change
            alignClearButton(inputElement, clearButton);
            window.addEventListener('resize', windowResizeEventHandler);
          }

          // Private event handler
          // Check clear button location when window is resizing
          function windowResizeEventHandler(event) {
            alignClearButton(inputElement, clearButton);
          }
        };

        // Return all services
        return {
          alignClearButton : alignClearButton,
          showAndHideButton: showAndHideButton
        };

      }])
    /**
     * Directive: Bento Reset
     */
    .directive('bentoReset', [
      '$window', '$timeout', '$bentoResetFactory', '$parse','$bentoServices',
      function ($window, $timeout, $bentoResetFactory, $parse, $bentoServices) {

        return {
          restrict: 'A',
          require : 'ngModel',
          replace : false,
          scope   : false,
          link    : function (scope, element, attrs, ngModelController) {
            var override    = (attrs.closeButtonIconClass) ? attrs.closeButtonIconClass : 'bento-icon-close-x',
                clearButton = angular.element(
                  '<div class="' +
                  [
                    'bento-reset-close-button',
                    'hide',
                    override
                  ].join(' ') +
                  '" tabindex="-1"></div>'
                );

            var getter = $parse(attrs.ngModel);

            // Add class
            element.addClass('bento-reset');

            scope.$watch(function(){
              return getter(scope);
            }, function (newVal) {
              $bentoResetFactory.showAndHideButton(element, clearButton, newVal);
            }, true);

            if(typeof attrs.bentoResetAlwaysOn === 'undefined') {

              // Listen to input field `change` and `focus` and show / hide clear button
              element.on('focus', function () {
                $bentoResetFactory.showAndHideButton(element, clearButton, getter(scope));
              });

              // Listen to input field blur
              // update: `event.relatedTarget` is not available on `blur` use `focusout` instead with IE9
              element.on('focusout', function (event) {
                if (event.relatedTarget !== clearButton[0]) {
                  // We need to use timeout to make sure clearBottom is clicked
                  // even `event.relatedTarget` is NULL <-- FF security
                  $timeout(function () {
                    clearButton.addClass('hide');
                  }, 10);
                }
              });
            }

            // On clear button click
            // Clear input field
            clearButton.on('mousedown touchstart', function (event) {
              ngModelController.$setViewValue('', 'reset');
              ngModelController.$render();
              clearButton.addClass('hide');
              $bentoServices.safeApply(scope);

              // bring the focus back to the input field after one digest cycle
              $timeout(function(){
                element[0].focus();
              });

            });

            // Initialize the location of the clear button
            $timeout(function () {
              $bentoResetFactory.alignClearButton(element, clearButton);
            });

            // Add clearButton after the input field
            element.after(clearButton);
          }
        };
      }
    ]);
})(window, window.angular);
(function (window, angular, undefined) {
  'use strict';

//Define bentoUI App object
  angular.module('bento.select', ['ui.bootstrap'])
    .directive('bentoSelect', function () {
      return {
        restrict  : 'A',
        scope     : false,
        link      : function(scope, element, attrs, controller){
          var select = element[0].querySelector('select');
          var tabindex = '0';
          element.addClass('bento-select');

          scope.$watch(function(){
            if(select){
              return select.getAttribute('readonly');
            }
          }, function(v){
            if(select){
              if(v){
                tabindex = select.getAttribute('tabindex') || 0;
                select.setAttribute('tabindex', '-1');
              }else{
                select.setAttribute('tabindex', tabindex);
              }
            }
          });


          // Add IE and Firefox version for better UI look and feel
          if (window.navigator.userAgent.search(/MSIE 9/gi) !== -1) {
            element.addClass('ie9');
          } else if (window.navigator.userAgent.search(/MSIE 10/gi) !== -1) {
            element.addClass('ie10');
          } else if (window.navigator.userAgent.search(/Firefox/gi) !== -1) {
            element.addClass('firefox');
            element.append('<div class="bento-select-border"></div>');
          }

          // Add button decoration
          element.append('<div class="btn"><span class="bento-icon-caret-down"></span></div>');
          element.append('<div class="bento-select-overlay"></div>');
        }
      };
    });

})(window, window.angular);





(function (window, angular, undefined) {

  'use strict';

  var directiveName = 'bentoSplitterGroup';
  var bentSplitterGroupApp = angular.module('bento.splittergroup', ['bento.services', 'bento.translate']);

  var HANDLE_DEFAULT = '<svg version="1.1" ' +
    'class="bento-splitter-handle-default" ' +
    'id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" ' +
    'viewBox="0 0 13 73" enable-background="new 0 0 13 73" xml:space="preserve">' +
    '<g>' +
    '<g>' +
    '<path class="splitter-group-handle-border" d="M5.4,57.3c6.1-1.4,5.6-8.9,5.6-8.9V36.5V24.6c0,0,0.5-7.5-5.6-8.9C0,14.3,0,11,0,11v25.5V62 ' +
    'C0,61.9,0,58.6,5.4,57.3z"/>' +
    '<path class="splitter-group-handle-bg" d="M4.8,55.8c5.3-1.3,4.8-7.1,4.8-7.1V36.5V24.4c0,0,0.5-5.9-4.8-7.1C0,16.1,0,13.9,0,13.9v22.6v22.4 ' +
    'C0,58.9,0,56.9,4.8,55.8z"/>' +
    '</g>' +
    '<polygon class="splitter-group-handle-triangle" points="3,32.4 8.3,36.5 3,40.6 	"/>' +
    '</g>' +
    '</svg>'
  ;
  var HANDLE_MOVE = '<svg class="bento-splitter-handle-move" ' +
    'version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" ' +
    'viewBox="0 0 13 73" enable-background="new 0 0 13 73" xml:space="preserve">' +
    '<g>' +
    '<g>' +
    '<rect y="15" class="splitter-group-handle-border" width="13" height="43"/>' +
    '<rect y="16" class="splitter-group-handle-bg" width="13" height="41"/>' +
    '</g>' +
    '<g>' +
    '<polygon class="splitter-group-handle-triangle" points="6,39.6 3,36.5 6,33.4"/>' +
    '<polygon class="splitter-group-handle-triangle" points="7.1,33.4 10.1,36.5 7.1,39.6"/>' +
    '</g>' +
    '</g>' +
    '</svg>';


  var LEFT     = 'left',
      RIGHT    = 'right',
      TOP      = 'top',
      BOTTOM   = 'bottom',
      C_LEFT   = 'Left',
      C_RIGHT  = 'Right',
      C_TOP    = 'Top',
      C_BOTTOM = 'Bottom',
      DIRECTIVE_NAME_SPACE = 'bento-splitter-group-';

  // Convert side variable to "C_" prfixed side variable (eg. LEFT -> C_LEFT)
  function C_(side) {
    return side.charAt(0).toUpperCase() + side.slice(1);
  }

  bentSplitterGroupApp
  /**
   * A notification factory to let the controllers in the left, middle and right panels to
   * communicate with each other
   *
   * This also helps with Left and Right panel collapses and expansions
   */
    .factory('splitterGroupNotification', function () {
      var notificationStack = [];
      /**
       * Add a splitter group notification
       * @param nName - Notification name
       * @param func - Notification function
       * @param uid - (Optional) unique ID
       */
      var addNotification = function (nName, func, uid) {
        // Check if notification with `nName` exists or create a new `nName` stack
        if (typeof notificationStack[nName] === 'undefined') {
          notificationStack[nName] = [];
        }

        notificationStack[nName].push(
          {
            func: func,
            uid : uid
          }
        );
      };

      /**
       * Remove a splitter group notification
       * @param nName - Notification name
       * @param func - Notification function
       * @param uid - (Optional) unique ID
       */
      var removeNotification = function (nName, func, uid) {
        // If `nName` notification does not exist
        // Do nothing.
        if (typeof notificationStack[nName] === 'undefined') {
          return;
        }

        var nNameStack = notificationStack[nName];

        var index = 0;
        var notification;
        // Remove the matching notification
        while (index < nNameStack.length) {
          notification = nNameStack[index];
          if (notification.func === func &&
            notification.uid === uid) {
            nNameStack.splice(index, 1);
          } else {
            index++;
          }
        }
      };

      /**
       * Notify through the notification center
       * @param nName - Notification name
       * @param uid - (Optional)
       * @param data - (Optional)
       */
      var notify = function (nName, uid, data) {
        // If `nName` notification does not exist
        // Do nothing.
        if (typeof notificationStack[nName] === 'undefined') {
          return;
        }

        var nNameStack = notificationStack[nName];

        for (var i = 0; i < nNameStack.length; i++) {
          var notification = nNameStack[i];
          if (typeof uid === 'undefined' ||
            uid === null ||
            notification.uid === uid
          ) {
            notification.func(data);
          }
        }
      };

      // Regiter notification functions to factory
      return {
        addNotification   : addNotification,
        removeNotification: removeNotification,
        notify            : notify
      };
    })
    .factory('splitterGroupMainHelper', ['$window', '$timeout', function ($window, $timeout) {
      /**
       * parse side pane width from a string
       * @param element
       * @param width
       * @returns number
       */
      var parseWidth = function (element, width) {
        return parseLength(element, width, 'w');
      };

      /**
       * parse top/bottom pane height from a string
       * @param element
       * @param width
       * @returns number
       */
      var parseHeight = function (element, height) {
        return parseLength(element, height, 'h');
      };

      function parseLength(element, length, scaleDirection) {
        if (typeof length === 'number') {
          return length;
        } else if (typeof length === 'undefined') {
          return -1;
        }

        var lengthType = length.search('%') > -1 ? '%' : 'px';
        var lengthInt = parseInt(length);

        if (lengthType === '%') {
          if (scaleDirection === 'w') {
            return element[0].offsetWidth * lengthInt / 100;
          } else {
            return element[0].offsetHeight * lengthInt / 100;
          }
        }

        return lengthInt;
      }

      return {
        parseWidth : parseWidth,
        parseHeight: parseHeight
      };
    }])
    /**
     * Main Controller to Splitter Group directive
     */
    .controller('bentoSplitterGroupMainController', [
      '$scope',
      '$element',
      '$window',
      'splitterGroupMainHelper',
      '$bentoServices',
      '$timeout',
      function ($scope, $element, $window, splitterGroupMainHelper, $bentoServices, $timeout) {

        var ctrl = this;

        // Check if the browser is IE 9
        if ($bentoServices.getIEVersion() === 9) {
          $element.addClass('ie9');
        }

        $element.addClass('bento-splitter-group');

        // Add `no-collapse` class when this directive is not collapsable
        if (!!$scope.noCollapse()) {
          $element.addClass('no-collapse');
        }

        // Determine if user is clicking on the left handle or not

        /* Global Helper */
        ctrl.hasHandle = function (side) {
          return $scope['splitter' + side] && $scope['splitter' + side].length;
        };

        //Align left & right panes and handles based on the side
        ctrl.alignLeftRightPanes = function (C_SIDE, pos) {
          var SIDE = C_SIDE.toLowerCase(),
              openedSide = 'opened-' + SIDE,
              posPx;

          alignSide(C_LEFT);
          alignSide(C_RIGHT);

          function alignSide(C_SIDE){
            if (ctrl.hasHandle(C_SIDE)) {
              posPx = $element.hasClass(openedSide) ? ($scope['splitHandle' + C_SIDE][0].offsetWidth + pos) + 'px'
                : $scope['splitHandle' + C_SIDE][0].offsetWidth + 'px';
              $scope['splitHandle' + C_SIDE][0].style[SIDE] =
                $scope['splitter' + C_SIDE][0].style[SIDE] =
                  posPx;
            }
          }
        };

        ctrl.toggleSide = function (SIDE) {
          SIDE = !!SIDE ? SIDE : $scope.actionOn;
          var C_SIDE = C_(SIDE);

          // Bypass click when this directive is not collapsable
          if (!!$scope.noCollapse()) {
            return;
          }

          // Do the actual action to its open-close
          if ($element.hasClass('opened-' + SIDE)) {
            ctrl.closePanel(C_SIDE);
            $scope['is' + C_SIDE + 'Collapsed'] = true;
          } else {
            ctrl.openPanel(C_SIDE);
            $scope['is' + C_SIDE + 'Collapsed'] = false;
          }

          $bentoServices.safeApply($scope);
        };

        // Helper
        // get event target side
        function getEventSide(event){
          return $scope.actionOn;
        }

        /**
         * Execute mouse click
         * @param event
         */
        ctrl.onHandleClick = function (event) {
          ctrl.toggleSide(getEventSide(event));
        };

        /**
         * Execute keyboard event
         * @param  {event} event
         */
        ctrl.onHandleKeyup = function (event){
          // Enter or Space
          if(event.keyCode === 32 || event.keyCode === 13){
            ctrl.toggleSide(getEventSide(event));
          }
        };

        // Helper functions used with the above logic for `ctrl.onHandleClick`
        ctrl.openPanel = function (C_SIDE) {
          var SIDE = C_SIDE.toLowerCase();
          var length = SIDE + ((C_SIDE == C_TOP || C_SIDE == C_BOTTOM) ? 'Height' : 'Width');

          $scope['splitter' + C_SIDE].css('display', 'block');

          $timeout(function(){
            $element.addClass('opened-' + SIDE);

            $scope['splitter' + C_SIDE].css(SIDE, '0');
            $scope.splitterMain.css(SIDE, $scope[length]);
            $scope['splitHandle' + C_SIDE].css(SIDE, $scope[length]);

            if (SIDE == TOP || SIDE == BOTTOM) {
              ctrl.alignLeftRightPanes(C_SIDE, parseInt($scope[length].replace('px', '')));
            }
          });
        };

        // Helper functions used with the above logic for `ctrl.onHandleClick`
        ctrl.closePanel = function (C_SIDE) {
          var SIDE = C_SIDE.toLowerCase();
          var length = SIDE + ((C_SIDE == C_TOP || C_SIDE == C_BOTTOM) ? 'Height' : 'Width');

          $element.removeClass('opened-' + SIDE);

          $scope['splitter' + C_SIDE].css(SIDE, '-' + $scope[length]);
          $scope.splitterMain.css(SIDE, '0');
          $scope['splitHandle' + C_SIDE].css(SIDE, '0');

          if (SIDE == TOP || SIDE == BOTTOM) {
            ctrl.alignLeftRightPanes(C_SIDE, 0);
          }

          $timeout(function(){
            $scope['splitter' + C_SIDE].css('display', 'none');
          }, 200)
        };

        //Initialize window resize elements
        $scope.leftMaxWidthPx = splitterGroupMainHelper.parseWidth($element, $scope.leftMaxWidth);
        $scope.rightMaxWidthPx = splitterGroupMainHelper.parseWidth($element, $scope.rightMaxWidth);
        $scope.topMaxHeightPx = splitterGroupMainHelper.parseHeight($element, $scope.topMaxHeight);
        $scope.bottomMaxHeightPx = splitterGroupMainHelper.parseHeight($element, $scope.bottomMaxHeight);

        var $w = angular.element($window);

        // Adding resize listener if there is a maxDraggable variable assigned
        if ($scope.leftMaxWidthPx > -1 || $scope.rightMaxWidthPx > -1) {
          $w.on('resize', onWindowsResize);
          $element.on('$destroy', function () {
            $w.off('resize', onWindowsResize);
          });
        }

        /**
         * check the width of left and right panels to make sure they are not oversized based on the
         * max draggable settings
         * @param $event
         */
        function onWindowsResize($event) {
          $scope.leftMaxWidthPx = splitterGroupMainHelper.parseWidth($element, $scope.leftMaxWidth);
          $scope.rightMaxWidthPx = splitterGroupMainHelper.parseWidth($element, $scope.rightMaxWidth);
          $scope.topMaxHeightPx = splitterGroupMainHelper.parseHeight($element, $scope.topMaxHeight);
          $scope.bottomMaxHeightPx = splitterGroupMainHelper.parseHeight($element, $scope.bottomMaxHeight);

          // LEFT
          if ($scope.leftMaxWidthPx > -1 && ctrl.hasHandle(C_LEFT)) {
            if (parseInt($scope.leftWidth) > $scope.leftMaxWidthPx) {
              $scope.leftWidth = $scope.leftMaxWidthPx + 'px';
              $scope.splitterLeft[0].style.width = $scope.leftWidth;
            }

            if ($scope.splitHandleLeft[0].offsetLeft > $scope.leftMaxWidthPx) {
              $scope.splitterMain[0].style.left =
                $scope.splitHandleLeft[0].style.left =
                  $scope.leftWidth;
            }
          }

          // RIGHT
          if ($scope.rightMaxWidthPx > -1 && ctrl.hasHandle(C_RIGHT)) {
            if (parseInt($scope.rightWidth) > $scope.rightMaxWidthPx) {
              $scope.rightWidth = $scope.rightMaxWidthPx + 'px';
              $scope.splitterRight[0].style.width = $scope.rightWidth;
            }

            if ($element[0].offsetWidth - $scope.splitHandleRight[0].offsetLeft -
              $scope.splitHandleRight[0].offsetWidth > $scope.leftMaxWidthPx) {
              $scope.splitterMain[0].style.right =
                $scope.splitHandleRight[0].style.right =
                  $scope.rightWidth;
            }
          }

          // TOP
          if ($scope.topMaxHeightPx > -1 && ctrl.hasHandle(C_TOP)) {
            if (parseInt($scope.topHeight) > $scope.topMaxHeightPx) {
              $scope.topHeight = $scope.topMaxHeightPx + 'px';
              $scope.splitterTop[0].style.height = $scope.topHeight;
            }

            if ($scope.splitHandleTop[0].offsetTop > $scope.topMaxHeightPx) {
              $scope.splitterMain[0].style.top =
                $scope.splitHandleTop[0].style.top =
                  $scope.topHeight;
            }

            ctrl.alignLeftRightPanes(C_TOP, parseInt($scope.topHeight.replace('px', '')));
          }

          // BOTTOM
          if ($scope.bottomMaxHeightPx > -1 && ctrl.hasHandle(C_BOTTOM)) {
            if (parseInt($scope.bottomHeight) > $scope.bottomMaxHeightPx) {
              $scope.bottomHeight = $scope.bottomMaxHeightPx + 'px';
              $scope.splitterBottom[0].style.height = $scope.bottomHeight;
            }

            if ($element[0].offsetHeight - $scope.splitHandleBottom[0].offsetTop -
              $scope.splitHandleBottom[0].offsetHeight > $scope.bottomMaxHeightPx) {
              $scope.splitterMain[0].style.bottom =
                $scope.splitHandleRight[0].style.bottom =
                  $scope.bottomHeight;
            }

            ctrl.alignLeftRightPanes(C_BOTTOM, parseInt($scope.bottomHeight.replace('px', '')));
          }
        }

        //Initialize dragging variables
        var draggingClassTimeout;
        var isDragging = false;
        var lastMousePos; // is used to track mose X movement
        var initialHandlePos;
        var elementSize;
        var handleSize;
        var screenDirection;

        /**
         * When the mouse is pressed down on the handle
         * @param event
         */
        $scope.onHandleDown = function (event) {
          var offsetProp;

          // Prevent the other event
          event.stopPropagation();
          event.preventDefault();

          if (event.currentTarget.className.search('handle-' + LEFT) > -1) {
            $scope.actionOn = LEFT;
            offsetProp = 'offsetWidth';
            screenDirection = 'screenX';
          } else if (event.currentTarget.className.search('handle-' + RIGHT) > -1) {
            $scope.actionOn = RIGHT;
            offsetProp = 'offsetWidth';
            screenDirection = 'screenX';
          } else if (event.currentTarget.className.search('handle-' + TOP) > -1) {
            $scope.actionOn = TOP;
            offsetProp = 'offsetHeight';
            screenDirection = 'screenY';
          } else {
            $scope.actionOn = BOTTOM;
            offsetProp = 'offsetHeight';
            screenDirection = 'screenY';
          }

          var C_SIDE = C_($scope.actionOn);

          elementSize = $element[0][offsetProp];
          handleSize = $scope['splitHandle' + C_SIDE][0][offsetProp];

          // Show pane on drag
          $scope['splitter' + C_SIDE].css('display', 'block');

          //Calculate lastMousePosition
          lastMousePos = (event.touches && event.touches.length > 0) ?
            event.touches[0][screenDirection] :event[screenDirection];

          switch ($scope.actionOn) {
            case LEFT:
              initialHandlePos = $scope.splitHandleLeft[0].offsetLeft;
              break;
            case RIGHT:
              initialHandlePos = $scope.splitHandleRight[0].offsetLeft + $scope.splitHandleRight[0].offsetWidth;
              break;
            case TOP:
              initialHandlePos = $scope.splitHandleTop[0].offsetTop;
              break;
            case BOTTOM:
              initialHandlePos = $scope.splitHandleBottom[0].offsetTop + $scope.splitHandleBottom[0].offsetHeight;
              break;
          }

          $element.addClass('unselectable');


          //start to track mouse move
          //touch devices are disabled for now.
          if (!!$scope.resizable() && (event.type === 'mousedown' || event.type === 'touchstart')) {
            $w.on('touchmove mousemove', $scope.onHandleMove);

            // on Destroy just in case the splitter group is destroyed while moving
            $element.on('$destroy', function () {
              $w.off('touchmove mousemove', $scope.onHandleMove);
            });

            $element.addClass(DIRECTIVE_NAME_SPACE+'handle-pointer-down');

            draggingClassTimeout = $timeout(function () {
              $element.addClass('dragging-' + $scope.actionOn);
            }, 300);
          }
          //track mouse up
          $w.one('touchend mouseup', $scope.onHandleUp);
        };

        /**
         * When mouse is released within the window
         * @param event
         */
        $scope.onHandleUp = function (event) {
          //angular.element(event.target).on('click',ctrl.onHandleClick);
          event.preventDefault();
          event.stopPropagation();

          $timeout.cancel(draggingClassTimeout);
          var dragging = 'dragging-';
          $element.removeClass(dragging + TOP);
          $element.removeClass(dragging + BOTTOM);
          $element.removeClass(dragging + LEFT);
          $element.removeClass(dragging + RIGHT);
          $element.removeClass(DIRECTIVE_NAME_SPACE+'handle-pointer-down');

          $bentoServices.removeBrowserSelection();


          //If the user didn't drag mouse pointer and released it inside of the splitter
          //It would be treated as a click
          if (!isDragging && event.target.className && !$scope.noCollapse()) {
            ctrl.onHandleClick(event);
            // Dispatch click tracking event
            $scope.eventTracking({
              eventName: 'splitter_group_click'
            });
          }
          // Normalize width and heights
          else {
            // helper class
            var normalize = function (C_SIDE, offset) {
              var SIDE        = C_SIDE.toLowerCase(),
                  orientation = (C_SIDE == C_LEFT || C_SIDE == C_RIGHT) ? 'Width' : 'Height',
                  length      = SIDE + orientation,
                  $splitter   = $scope['splitter' + C_SIDE];

              offset = (offset < 50) ? 0 : offset;
              // update offset width or height
              $scope[length] = (offset < 50) ? $scope[length] : offset + 'px';

              // Close
              if (offset === 0) {
                handleTargetPos = 0;
                // Restore previous pane width/height
                $splitter.css(orientation.toLowerCase(), $scope[length]);
                ctrl.closePanel(C_SIDE);
                $scope['is' + C_SIDE + 'Collapsed'] = true;
              } else {
                $element.addClass( 'opened-' + SIDE);
                $scope['is' + C_SIDE + 'Collapsed'] = false;
              }

              $bentoServices.safeApply($scope);
            };

            //Normalize leftWidth
            switch ($scope.actionOn) {
              case LEFT:
                normalize(C_LEFT, $scope.splitHandleLeft[0].offsetLeft);
                break;
              case RIGHT:
                normalize(C_RIGHT, elementSize - $scope.splitHandleRight[0].offsetLeft - $scope.splitHandleRight[0].offsetWidth);
                break;
              case TOP:
                normalize(C_TOP, $scope.splitHandleTop[0].offsetTop);
                break;
              case BOTTOM:
                normalize(C_BOTTOM, elementSize - $scope.splitHandleBottom[0].offsetTop - $scope.splitHandleBottom[0].offsetHeight);
                break;
            }
            // Dispatch drag tracking event
            $scope.eventTracking({
              eventName: 'splitter_group_drag'
            });

            normalize = null;
          }

          $element.removeClass('unselectable');
          //stop move
          $w.off('touchmove mousemove', $scope.onHandleMove);

          //turn on down
          $scope['splitHandle' + C_($scope.actionOn)].one('touchstart mousedown', $scope.onHandleDown);

          //reset dragging flag
          isDragging = false;

          // Fire onResize Callback
          if (!!$scope.onResize) {
            $scope.onResize({
              side: $scope.actionOn
            });
          }
        };

        var handleTargetPos;
        var dPos;

        //Animate dragging using window.requestAnimationFrame for optimal performance
        var animateDragging = function () {
          var C_SIDE = C_($scope.actionOn);
          var targetPosPx = handleTargetPos + 'px';
          var orientation;

          if (handleTargetPos > 0 && dPos !== 0) {

            orientation = (C_SIDE == C_LEFT || C_SIDE == C_RIGHT) ? 'width' : 'height';

            $scope.splitterMain[0].style[$scope.actionOn] =
              $scope['splitHandle' + C_SIDE][0].style[$scope.actionOn] =
                $scope['splitter' + C_SIDE][0].style[orientation] =
                  targetPosPx;

            if (orientation == 'height') {
              ctrl.alignLeftRightPanes(C_SIDE, handleTargetPos);
            }

            // Fire onResize Callback
            if (!!$scope.onResize) {
              $scope.onResize({
                side: $scope.actionOn
              });
            }
          }

          if (isDragging) {
            $bentoServices.rAF(animateDragging);
          }
        };

        /**
         * Track on window mousemove
         * @param event
         */
        $scope.onHandleMove = function (event) {
          var touchObject = (event.touches && event.touches.length > 0)? event.touches[0] : event;
          var currentMousePos = touchObject[screenDirection];
          var SIDE = $scope.actionOn;
          var C_SIDE = C_(SIDE);
          var C_orientation = (SIDE == LEFT || SIDE == RIGHT) ? 'Width' : 'Height';
          var maxLength = $scope[SIDE + 'Max' + C_orientation + 'Px'];

          // Prevent the screen from scrolling on touch devices
          event.preventDefault();
          event.stopPropagation();

          $bentoServices.removeBrowserSelection();

          if (lastMousePos !== currentMousePos) {
            // Calculate dPos for rendering
            dPos = currentMousePos - lastMousePos;
            handleTargetPos = (initialHandlePos + dPos);
            handleTargetPos = (SIDE == LEFT || SIDE == TOP) ? handleTargetPos : elementSize - handleTargetPos;
            handleTargetPos = (handleTargetPos < 0) ? 0 : handleTargetPos;
            handleTargetPos = (handleTargetPos > elementSize - handleSize) ? elementSize - handleSize : handleTargetPos;

            // Check draggable area so the oppsited handles don't overlap
            if (SIDE === LEFT && ctrl.hasHandle(C_RIGHT) &&
              handleTargetPos > $scope.splitHandleRight[0].offsetLeft - handleSize) {
              handleTargetPos = $scope.splitHandleRight[0].offsetLeft - handleSize;
            } else if (SIDE == RIGHT && ctrl.hasHandle(C_LEFT) &&
              handleTargetPos > elementSize - $scope.splitHandleLeft[0].offsetLeft - handleSize * 2) {
              handleTargetPos = elementSize - $scope.splitHandleLeft[0].offsetLeft - handleSize * 2;
            } else if (SIDE === TOP && ctrl.hasHandle(C_BOTTOM) &&
              handleTargetPos > $scope.splitHandleBottom[0].offsetTop - handleSize) {
              handleTargetPos = $scope.splitHandleBottom[0].offsetTop - handleSize;
            } else if (SIDE == BOTTOM && ctrl.hasHandle(C_TOP) &&
              handleTargetPos > elementSize - $scope.splitHandleTop[0].offsetTop - handleSize * 2) {
              handleTargetPos = elementSize - $scope.splitHandleTop[0].offsetTop - handleSize * 2;
            }

            if (!isDragging) {
              $bentoServices.rAF(animateDragging);
            }

            // Need to 'open' the splitter group when the handle is moved out
            if (handleTargetPos > 0 && !$element.hasClass('opened-' + SIDE)) {
              $element.addClass( 'opened-' + SIDE);
              $scope['splitter' + C_SIDE][0].style[SIDE] = '0';
            }

            // Lock handleTargetPos if there is a dragging limit here
            if (maxLength > -1 && handleTargetPos > maxLength) {
              handleTargetPos = maxLength;
            }

            //flag isDragging
            isDragging = true;
          }
        };
      }])
    /**
     * Splitter Group directive declaration
     */
    .directive(directiveName, [
      '$timeout',
      '$log',
      'splitterGroupNotification',
      'splitterGroupMainHelper',
      '$compile',
      function ($timeout, $log, splitterGroupNotification, splitterGroupMainHelper, $compile) {

        return {
          restrict  : 'A',
          replace   : false,
          scope     : {
            _bottomHeight    : '@bottomHeight', //Set the default width to the bottom pane
            _leftWidth       : '@leftWidth',  //Set the default width to the left pane
            _rightWidth      : '@rightWidth', //Set the default width to the right pane
            _topHeight       : '@topHeight', //Set the default width to the top pane
            autoResize       : '=',  // Option to auto-resize the parent container with the content of this SG
            bottomMaxHeight  : '@',  //Set max draggable height of the bottom panel
            eventTracking    : '&',  //Dispatch external event handlers
            isLeftCollapsed  : '=?',  //Default to false if doesn't exist
            isRightCollapsed : '=?',  //Default to false if doesn't exist
            isTopCollapsed   : '=?',  //Default to false if doesn't exist
            isBottomCollapsed: '=?',  //Default to false if doesn't exist
            leftMaxWidth     : '@',  //Set max draggable width of the left panel
            noCollapse       : '&',  //Making the splitter group to be only resizable but not collapsable on Left
            onResize         : '&',  //Callback for resize
            resizable        : '&',  //This enables the dragging function to the handle bar
            rightMaxWidth    : '@',  //Set max draggable width of the right panel
            topMaxHeight     : '@'   //Set max draggable height of the top panel
          },
          controller: 'bentoSplitterGroupMainController',
          link      : function ($scope, $element, $attrs, ctrl) {
            // Set default width to both left, right, top & bottom
            if (typeof $scope._leftWidth === 'undefined' || $scope._leftWidth === null) {
              $scope.leftWidth = '300px';
            } else {
              $scope.leftWidth = $scope._leftWidth;
            }

            if (typeof $scope._rightWidth === 'undefined' || $scope._rightWidth === null) {
              $scope.rightWidth = '300px';
            } else {
              $scope.rightWidth = $scope._rightWidth;
            }

            if (typeof $scope._topHeight === 'undefined' || $scope._topHeight === null) {
              $scope.topHeight = '300px';
            } else {
              $scope.topHeight = $scope._topHeight;
            }

            if (typeof $scope._bottomHeight === 'undefined' || $scope._bottomHeight === null) {
              $scope.bottomHeight = '300px';
            } else {
              $scope.bottomHeight = $scope._bottomHeight;
            }

            // Make sure the intial leftWidth doesn't exceed the leftMaxWidth
            if ($scope.leftMaxWidthPx > -1 &&
              splitterGroupMainHelper.parseWidth($element, $scope.leftWidth) > $scope.leftMaxWidthPx) {
              $scope.leftWidth = $scope.leftMaxWidthPx + 'px';
            }

            // Make sure the intial rightWidth doesn't exceed the rightMaxWidth
            if ($scope.rightMaxWidthPx > -1 &&
              splitterGroupMainHelper.parseWidth($element, $scope.rightWidth) > $scope.rightMaxWidthPx) {
              $scope.rightWidth = $scope.rightMaxWidthPx + 'px';
            }

            if ($scope.topMaxHeightPx > -1 &&
              splitterGroupMainHelper.parseHeight($element, $scope.topHeight) > $scope.topMaxHeightPx) {
              $scope.topHeight = $scope.topMaxHeightPx + 'px';
            }

            // Make sure the intial rightWidth doesn't exceed the rightMaxWidth
            if ($scope.bottomMaxHeightPx > -1 &&
              splitterGroupMainHelper.parseHeight($element, $scope.bottomHeight) > $scope.bottomMaxHeightPx) {
              $scope.bottomHeight = $scope.bottomMaxHeightPx + 'px';
            }

            var mainPaneInner = $element[0].querySelector('.'+DIRECTIVE_NAME_SPACE+'main-inner');

            // Main SR object
            var srObj = angular.element('<info class="sr-only" tabindex="0">{{ "BENTO_UI_SPLITTER_GROUP" | bentoTranslate}}</info>');
            $compile(srObj)($scope);
            $element.prepend(srObj);

            //Get the children elements from the splitter group DOM structure
            var getDomEl = function (side) {
              var children = $element.children(),
                  $sideEl, $foundSideEl
              ;

              angular.forEach(children,function(sideEl){
                $sideEl = angular.element(sideEl);
                if($sideEl.hasClass(DIRECTIVE_NAME_SPACE + side)){
                  $foundSideEl = $sideEl;
                }
              });

              return $foundSideEl;
            };

            $scope.splitterLeft = getDomEl(LEFT);
            $scope.splitterRight = getDomEl(RIGHT);
            $scope.splitterTop = getDomEl(TOP);
            $scope.splitterBottom = getDomEl(BOTTOM);
            $scope.splitterMain = getDomEl('main');

            getDomEl = null;

            /* Inject splitter buttons */
            // helper function
            var handleInject = function (C_SIDE) {

              // Handle doesn't exist
              if (!ctrl.hasHandle(C_SIDE)) {
                return;
              }

              var SIDE              = C_SIDE.toLowerCase(),
                  splitHandleSide   = 'splitHandle' + C_SIDE,
                  splitterSide      = 'splitter' + C_SIDE,
                  length            = (C_SIDE == C_TOP || C_SIDE == C_BOTTOM) ? SIDE + 'Height' : SIDE + 'Width',
                  lengthOrientation = (length.search('Height') > -1) ? 'height' : 'width';

              $scope[splitHandleSide] =
                angular.element('<button class="bento-splitter-handle bento-splitter-handle-' + SIDE + '" '+
                  'tabindex="0" type="button" aria-label="{{ \'BENTO_UI_SPLITTER_GROUP_'+SIDE.toUpperCase()+
                  '_BAR\' | bentoTranslate}}">' +
                  HANDLE_DEFAULT + HANDLE_MOVE +
                  '</button>');

              // Append the handle after each pane
              $scope[splitterSide][0].parentNode.insertBefore($scope[splitHandleSide][0],$scope[splitterSide][0]);

              $compile($scope[splitHandleSide])($scope);
              // Initialize pane initial position
              $scope[splitterSide].css(lengthOrientation, $scope[length]);
              $scope[splitterSide].css(SIDE, '-' + $scope[length]);
              // Initialize splitHandle listener
              $scope[splitHandleSide].one('touchstart mousedown', $scope.onHandleDown);
              $scope[splitHandleSide][0].addEventListener('keyup', ctrl.onHandleKeyup);
              mainPaneInner.className += ' has-' + SIDE + '-pane';

              // Assign Notifications
              splitterGroupNotification.addNotification(
                'open' + C_SIDE,
                function () {
                  if (!$element.hasClass('opened-' + SIDE)) {
                    $scope.actionOn = SIDE;
                    ctrl.onHandleClick(null);
                  }
                },
                $attrs.id
              );

              splitterGroupNotification.addNotification(
                'close' + C_SIDE,
                function () {
                  if ($element.hasClass('opened-' + SIDE)) {
                    $scope.actionOn = SIDE;
                    ctrl.onHandleClick(null);
                  }
                },
                $attrs.id
              );
            };

            handleInject(C_TOP);
            handleInject(C_LEFT);
            handleInject(C_RIGHT);
            handleInject(C_BOTTOM);
            handleInject = null; // clear memory

            function isSideCollapsed(SIDE, collapsed) {
              var C_SIDE = C_(SIDE);
              var isOpened = $element.hasClass('opened-' + SIDE);

              if (!ctrl.hasHandle(C_SIDE) || !!collapsed !== isOpened) {
                return;
              }
              // Default to open
              if (collapsed && $element.hasClass('opened-' + SIDE)) {
                ctrl.closePanel(C_SIDE);
              } else {
                ctrl.openPanel(C_SIDE);
              }
            }

            $scope.$watch('isLeftCollapsed', function (collapsed) {
              isSideCollapsed(LEFT, collapsed);
            });

            $scope.$watch('isRightCollapsed', function (collapsed) {
              isSideCollapsed(RIGHT, collapsed);
            });

            $scope.$watch('isTopCollapsed', function (collapsed) {
              isSideCollapsed(TOP, collapsed);
            });

            $scope.$watch('isBottomCollapsed', function (collapsed) {
              isSideCollapsed(BOTTOM, collapsed);
            });

            function getSideContainer(side){
              var children = $element.children(), $el;
              for(var i=0,len=children.length; i<len; i++){
                $el = angular.element(children[i]);
                if($el.hasClass(DIRECTIVE_NAME_SPACE+side)){
                  return $el[0];
                }
              }
            }

            // Auto-resize the parent container
            if (!!$scope.autoResize) {
              // Get DOM Reference
              var parentContainer = $element[0].parentNode;
              var leftContainer = getSideContainer(LEFT);
              var mainContainer = $element[0].querySelector('.'+DIRECTIVE_NAME_SPACE+'main-inner');
              var rightContainer = getSideContainer(RIGHT);
              // Preserve the parent original height when this
              // directive shrinks too small
              parentContainer.style.minHeight = parentContainer.offsetHeight + 'px';

              // Adding padding to left, main and right containers
              // and set overflow-y to hidden width one parent class
              $element.addClass('auto-resize');

              // Adding three marker objects to determine where the last line is
              var markerLeft;
              var markerRight;
              var markerMain;

              if (!!leftContainer) {
                markerLeft = document.createElement('div');
                markerLeft.classNames = 'clearfix';
                leftContainer.appendChild(markerLeft);
              }

              markerMain = document.createElement('div');
              markerMain.classNames = 'clearfix';
              mainContainer.appendChild(markerMain);

              if (!!rightContainer) {
                markerRight = document.createElement('div');
                markerRight.classNames = 'clearfix';
                rightContainer.appendChild(markerRight);
              }

              // Watch the three containers and return the most height
              // and adjust their parent container
              $scope.$watch(
                function () {
                  var newHeight = Math.max(
                    !!markerLeft ? markerLeft.offsetTop : 0,
                    !!markerRight ? markerRight.offsetTop : 0,
                    !!markerMain ? markerMain.offsetTop : 0
                  );
                  return newHeight;
                },
                function (newValue) {
                  parentContainer.style.height = (newValue + 24) + 'px';
                });
            }

            //Add the transition class to the left and main pane
            //0.5second after the page is rendered
            //because IE renders the animation on the main pane when
            //the left pane is opened
            $timeout(function () {
              if (ctrl.hasHandle(C_LEFT)) {
                $scope.splitterLeft.addClass('animate');
              }
              if (ctrl.hasHandle(C_RIGHT)) {
                $scope.splitterRight.addClass('animate');
              }
              if (ctrl.hasHandle(C_TOP)) {
                $scope.splitterTop.addClass('animate');
              }
              if (ctrl.hasHandle(C_BOTTOM)) {
                $scope.splitterBottom.addClass('animate');
              }

              $element.addClass(DIRECTIVE_NAME_SPACE+'ready');

              $scope.splitterMain.addClass('animate');
            }, 500);
          }
        };
      }
    ])
    .directive(directiveName + C_LEFT,['$bentoTranslate', function ($bentoTranslate) {
      return {
        require : '^' + directiveName,
        restrict: 'A',
        scope   : false,
        link    : function (scope, element, attr) {
          element.addClass(DIRECTIVE_NAME_SPACE + LEFT);
          element[0].setAttribute('tabindex','0');
          // Aria and translation
          updateAria();
          function updateAria(){
            $bentoTranslate.translate('BENTO_UI_SPLITTER_GROUP_LEFT_PANEL').then(function(value){
              element[0].setAttribute('aria-label',value);
            });
          }
          $bentoTranslate.onChange(updateAria);
          scope.$on('$destroy',function(){
            $bentoTranslate.removeOnChange(updateAria);
          });
        }
      };
    }])
    .directive(directiveName + C_RIGHT,['$bentoTranslate', function ($bentoTranslate) {
      return {
        require : '^' + directiveName,
        restrict: 'A',
        scope   : false,
        link    : function (scope, element, attr) {
          element.addClass(DIRECTIVE_NAME_SPACE + RIGHT);
          element[0].setAttribute('tabindex','0');
          // Aria and translation
          updateAria();
          function updateAria(){
            $bentoTranslate.translate('BENTO_UI_SPLITTER_GROUP_RIGHT_PANEL').then(function(value){
              element[0].setAttribute('aria-label',value);
            });
          }
          $bentoTranslate.onChange(updateAria);
          scope.$on('$destroy',function(){
            $bentoTranslate.removeOnChange(updateAria);
          });
        }
      };
    }])
    .directive(directiveName + C_TOP,['$bentoTranslate', function ($bentoTranslate) {
      return {
        require : '^' + directiveName,
        restrict: 'A',
        scope   : false,
        link    : function (scope, element, attr) {
          element.addClass(DIRECTIVE_NAME_SPACE + TOP);
          element[0].setAttribute('tabindex','0');
          // Aria and translation
          updateAria();
          function updateAria(){
            $bentoTranslate.translate('BENTO_UI_SPLITTER_GROUP_TOP_PANEL').then(function(value){
              element[0].setAttribute('aria-label',value);
            });
          }
          $bentoTranslate.onChange(updateAria);
          scope.$on('$destroy',function(){
            $bentoTranslate.removeOnChange(updateAria);
          });
        }
      };
    }])
    .directive(directiveName + C_BOTTOM,['$bentoTranslate', function ($bentoTranslate) {
      return {
        require : '^' + directiveName,
        restrict: 'A',
        scope   : false,
        link    : function (scope, element, attr) {
          element.addClass(DIRECTIVE_NAME_SPACE + BOTTOM);
          element[0].setAttribute('tabindex','0');
          // Aria and translation
          updateAria();
          function updateAria(){
            $bentoTranslate.translate('BENTO_UI_SPLITTER_GROUP_BOTTOM_PANEL').then(function(value){
              element[0].setAttribute('aria-label',value);
            });
          }
          $bentoTranslate.onChange(updateAria);
          scope.$on('$destroy',function(){
            $bentoTranslate.removeOnChange(updateAria);
          });
        }
      };
    }])
    .directive(directiveName + 'Main',['$bentoTranslate', function ($bentoTranslate) {
      return {
        require   : '^' + directiveName,
        restrict  : 'A',
        replace   : true,
        transclude: true,
        template  : '<section class="'+DIRECTIVE_NAME_SPACE+'main" tabindex="0" roe="main">' +
        '<div class="'+DIRECTIVE_NAME_SPACE+'main-inner" ng-transclude></div>' +
        '</section>',
        scope     : false,
        link      : function (scope, element, attr) {
          element[0].setAttribute('tabindex','0');
          // Aria and translation
          updateAria()
          function updateAria(){
            $bentoTranslate.translate('BENTO_UI_SPLITTER_GROUP_MAIN_PANEL').then(function(value){
              element[0].setAttribute('aria-label',value);
            });
          }
          $bentoTranslate.onChange(updateAria);
          scope.$on('$destroy',function(){
            $bentoTranslate.removeOnChange(updateAria);
          });
        }
      };
    }]);

})(window, window.angular);
(function (window, angular, undefined) {

  'use strict';

  // Template override
  angular.module("template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
    $templateCache.put("template/tabs/tab.html",
      '<li ng-class="{active: active, disabled: disabled}">\n' +
      '  <a href bento-test="anchor" ng-click="select()" uib-tab-heading-transclude>{{heading}}</a>\n' +
      '</li>\n' +
      '');
  }]);

  angular.module('bento.tabs', ['bento.services'])
    .directive('uibTabset', tabsetDirective)
    .directive('uibTab', tabDirective);

  tabsetDirective.$inject = ['$compile', '$bentoServices', '$timeout'];
  /**
   * Tabset directive extension
   */
  function tabsetDirective($compile, $bentoServices, $timeout) {
    return {
      require : 'uibTabset',
      priority: 1,
      link    : function (scope, element, attrs, controller) {
        var localScope = scope.$new();
        element.addClass('bento-tabset');

        // Vertical tabs will be ignored from this directive extension
        if (!element.hasClass('tabs-top') && !element.hasClass('tabs-bottom')) {
          return;
        }

        // Variable declaration
        var tabs         = element[0].querySelector('ul.nav'),
            btnLeftMost  = angular.element(
              '<button ng-disabled="disableLeftArrows" ng-click="onLeftMostClick()" class="btn btn-default bento-tabset-nav-button left-most">' +
              '<i class="bento-icon-chevron-first-left"></i></button>'),
            btnLeft      = angular.element(
              '<button ng-disabled="disableLeftArrows" ng-click="onLeftClick()" class="btn btn-default bento-tabset-nav-button left">' +
              '<i class="bento-icon-chevron-left"></i></button>'),
            btnRight     = angular.element(
              '<button ng-disabled="disableRightArrows" ng-click="onRightClick()" class="btn btn-default bento-tabset-nav-button right">' +
              '<i class="bento-icon-chevron-right"></i></button>'),
            btnRightMost = angular.element(
              '<button ng-disabled="disableRightArrows" ng-click="onRightMostClick()" class="btn btn-default bento-tabset-nav-button right-most">' +
              '<i class="bento-icon-chevron-last-right"></i></button>'),

            btnContainer = angular.element('<div class="bento-tabset-nav-button-container"></div>'),
            isAnimating,
            currentTab,
            lastTab;

        localScope.disableLeftArrows = false;
        localScope.disableRightArrows = false;

        // Button listeners
        localScope.onLeftMostClick = function () {
          scroll(0);
        };

        localScope.onLeftClick = function () {
          currentTab = getCurrentTab();
          scrollToTab(currentTab.previousElementSibling);
        };

        localScope.onRightClick = function () {
          currentTab = getCurrentTab();
          scrollToTab(currentTab.nextElementSibling);
        };

        localScope.onRightMostClick = function () {
          scroll(tabs.scrollWidth - tabs.offsetWidth);
        };

        // Watch tab container scroll width
        scope.$watch(function () {
          return tabs.scrollWidth;
        }, function () {
          inspectWidth();
        });

        // Watch tab active states and autoscroll if neccessary
        var lastActiveIndex;

        scope.$watch(function () {
          var activeIndex = 0;
          var count = 0;
          controller.tabs.forEach(function (item, index) {
            if (item.active) {
              count++;
              activeIndex = index;
            }
          });

          if (count === 1) {
            lastActiveIndex = activeIndex;
          }

          return lastActiveIndex;
        }, function (activeIndex) {

          // Bypass if the tabs are not ready
          // This happens when the tabs are dynamically rendered when Tab is initiated but the data is not
          // BENTO-152
          if (typeof activeIndex === 'undefined') {
            return;
          }

          // Scroll needs to come in after components rendering
          $timeout(function () {
            var tabChildren = tabs.children,
                activeTab   = tabChildren[activeIndex],
                tabLeft     = activeTab.offsetLeft,
                tabRight    = tabLeft + activeTab.offsetWidth,
                tabsWidth   = tabs.offsetWidth -
                  parseInt(getComputedStyle(tabChildren[tabChildren.length - 1]).marginRight.replace('px', ''))
            ;

            if (tabLeft < tabs.scrollLeft) {
              scrollToTab(activeTab);
            } else if (tabRight > tabs.scrollLeft + tabsWidth) {
              scroll(tabRight - tabsWidth);
            }
          })

        });

        btnContainer.append(btnLeftMost);
        btnContainer.append(btnLeft);
        btnContainer.append(btnRight);
        btnContainer.append(btnRightMost);

        $compile(btnContainer)(localScope);

        element.prepend(btnContainer);

        angular.element(window).on('resize', inspectWidth);

        /**
         * Inspect the tab container width and scrollWidth and see if it's scrollable
         */
        function inspectWidth(event) {
          // Tabs are not redered yet...
          if (tabs.children.length < 1) {
            return;
          }

          var sWidth      = tabs.scrollWidth,
              width       = tabs.offsetWidth,
              children    = tabs.children,
              hasScroll   = element.hasClass('bento-tabset-h-scrollable'),
              rightMargin = parseInt(getComputedStyle(children[children.length-1]).marginRight.replace('px', ''));
          ;

          if (hasScroll && sWidth <= width + rightMargin) {
            element.removeClass('bento-tabset-h-scrollable');
          } else if (!hasScroll && sWidth > width + rightMargin && rightMargin < 100) {
            element.addClass('bento-tabset-h-scrollable');
          }

          validateButtons();
        }

        /**
         * $destroy listener for cleanup
         */
        scope.$on('$destroy', function () {
          angular.element(window).off('resize', inspectWidth);
          localScope.$destroy();
        });

        /**
         * Scroll tab container to the given tab
         * @param tab
         */
        function scrollToTab(tab) {
          if (!tab) {
            return;
          }

          var scrollLeft = tab.offsetLeft;

          scroll(scrollLeft);
        }

        function getLeftPadding() {
          return parseInt(getComputedStyle(tabs).paddingLeft.replace('px', ''));
        }

        function validateButtons(to) {
          var scrollLeft = typeof to === 'undefined' ? tabs.scrollLeft : to;

          if (scrollLeft <= 1) {
            localScope.disableLeftArrows = true;
          } else {
            localScope.disableLeftArrows = false;
          }

          if (scrollLeft >= tabs.scrollWidth - tabs.offsetWidth) {
            localScope.disableRightArrows = true;
          } else {
            localScope.disableRightArrows = false;
          }

          $bentoServices.safeApply(localScope);
        }

        // Scroll To Timer
        var startTime;
        var scrollFrom;
        var scrollTo;
        var scrollDelta;

        /**
         * Scroll the tab bar to a position
         * @param scrollLeft
         * @param time
         */
        function scroll(scrollLeftTo, time) {

          validateButtons(scrollLeftTo);

          time = (!!time) ? time : 200;

          // Initialize animation
          startTime = _getTime();
          scrollFrom = tabs.scrollLeft;
          scrollTo = scrollLeftTo;
          scrollDelta = scrollTo - scrollFrom;

          // Skip starting a new animation thread
          if (isAnimating) {
            return;
          }

          // Update flag
          isAnimating = true;
          // Start animate
          _scrollAnimate(time);

        }

        var _scrollLeft;

        function _scrollAnimate(time) {
          _scrollLeft = scrollFrom + scrollDelta * _ease((_getTime() - startTime) / time);
          tabs.scrollLeft = _scrollLeft;

          if (Math.abs(_scrollLeft - scrollTo) <= 1) {
            tabs.scrollLeft = scrollTo;
            isAnimating = false;
          } else {
            // Use rAF to generate the next frame
            $bentoServices.rAF(function () {
              _scrollAnimate(time);
            });
          }
        }

        var _tempDate;

        function _getTime() {
          _tempDate = new Date();
          return _tempDate.getTime();
        }

        /**
         * Get ease ration based on time ratio wi
         * @param timeRatio - 0.0 to 1.0
         * @param ease - easing factor
         * @returns {number}
         * @private
         */
        function _ease(timeRatio) {
          return -(Math.pow(timeRatio - 1, 4)) + 1;
        }

        /**
         * Get the current tab that is in the first position
         * @returns {*}
         */
        function getCurrentTab() {
          var leftPadding = getLeftPadding(),
              i, len, center, tab,
              children    = tabs.children,
              scrollLeft  = tabs.scrollLeft + leftPadding,
              found
          ;

          for (i = 0, len = children.length; i < len; i++) {
            tab = children[i];
            center = tab.offsetLeft + tab.offsetWidth * 0.5;

            if (center > scrollLeft && center < scrollLeft + tab.offsetWidth) {
              found = tab;
              break;
            }
          }

          return found;
        }

      }
    }
  }

  tabDirective.$inject = ['$compile', '$log'];
  /**
   * Tabset tab directive extension
   * @returns {{require: string, priority: number, link: link}}
   */
  function tabDirective($compile, $log) {
    return {
      require : 'uibTab',
      priority: -1,
      link    : function (scope, element, attrs, controllers) {
        if (typeof attrs.count !== 'undefined') {
          // Deprecation warning message
          $log.warn('uib-tab: "count" is deprecated. See "tabset" documentation for the use of <uib-tab-heading></uib-tab-heading>');

          var $count = angular.element('<span class="badge" aria-hidden="false">{{count}}</span>');
          var isoScope = scope.$new();
          $compile($count)(isoScope);

          element.find('a').append($count);

          attrs.$observe('count', function (newValue) {
            isoScope.count = newValue;
          });

          scope.$on('$destroy', function () {
            isoScope.$destroy();
          });
        }
      }
    }
  }

})(window, angular);

(function (angular, window) {
  'use strict';

  var BTI_TYPE_STRING = 'string',
      BTI_TYPE_OPERATOR = 'operator',
      BTI_TYPE_NUMBER = 'number',
      defaults = {
        minTagLength: 2,
        propertyName: 'name',
        allowedOperators: '-+=/*%[]()!~&|<>'
      };

  angular.module('bento.tagsinput', [])
  /**
   * Bento Tags Input Directive
   */
    .directive('bentoTagsInput', [
      '$timeout',
      function ($timeout) {
        return {
          scope      : {
            addOnComma: '=?',  // Add a tag on comma key
            addOnEnter: '=?',  // Add on enter key
            addOnSpace: '=?',  // Add on space bar
            editable  : '=?',  // Flag to editable pills
            minTagLength: '=?', // Minimum Tag length
            ngModel     : '=',  // Tags in array
            onTagAdded  : '&',  // Event handler - when a tag is added
            onTagAddStart: '&',  // Event handler - when a tag is being added
            onTagEdited  : '&',  // Event handler - when a tag is edited
            onTagInvalidInput  : '&',  // Event handler - when a tag input is invalid
            onTagRemoved : '&',  // Event handler - when a tag is removed
            onTagRemoveStart: '&',  // Event handler - when a tag is being removed
            placeholder     : '@',  // Placeholder for the input field
            useOperators    : '=?', // Use Math Operators
            allowedOperators : '=?', // String of the operators to use
            replaceSpacesWithDashes: '=',  // If the spaces are replaced with spaces
            replaceSpacesWithUnderscores: '=?',  // If the spaces are replaced with underscores
            tagPropertyName             : '@?', // Property name of each pill
            ngDisabled                  : '=?', // ngDisabled
            ngReadonly                  : '=?', // ngReadonly
            disableKeyInput             : '=?'  // disable keyboard interaction
          },
          require: ['ngModel', 'bentoTagsInput'],
          replace: true,
          templateUrl: function(element, attrs) {
            return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/tags_input/bento-tags-input.html';
          },
          controller : ['$scope', '$element',
            function ($scope, $element) {
              // Set default
              $scope.propertyName = typeof $scope.tagPropertyName === 'undefined' ?
                defaults.propertyName : $scope.tagPropertyName;
              $scope.minTagLength = typeof $scope.minTagLength === 'undefined' ?
                defaults.minTagLength : $scope.minTagLength;
              $scope.allowedOperators = typeof $scope.allowedOperators === 'undefined' ?
                defaults.allowedOperators : $scope.allowedOperators;
              var self = this;

              self.setEditingMode = function (bool) {
                $scope.isPillEditing = bool;
                angular.element($element[0].querySelector('.bento-tags-input-text')).css('width', 60+'px');
              };

              self.setActivePill = function (index) {
                $scope.activePill = index;
              };

              self.hasRedundancy = function (tag, ignoreTagIndex) {
                return $scope.ngModel.some(function (value, index, array) {
                  if (index === ignoreTagIndex) {
                    return false;
                  }

                  return value[$scope.propertyName] === tag.trim();
                });
              };

              self.validate = function (tag) {
                var v = {
                  isValidLength:false,
                  type: BTI_TYPE_STRING
                };
                tag = tag.trim();
                v.name = tag;

                // operator related inspection
                if($scope.useOperators){
                  var allowedOperators = $scope.allowedOperators;
                  v.type = BTI_TYPE_OPERATOR;
                  v.isValidLength = true;

                  if(!isNaN(Number(tag))){
                    v.type = BTI_TYPE_NUMBER;
                  }else{
                    for(var i=0,len=tag.length; i<len; i++){
                      if(allowedOperators.indexOf(tag.charAt(i)) < 0){
                        v.type = BTI_TYPE_STRING;
                        if(tag.length >= $scope.minTagLength){
                          v.isValidLength = true;
                        }else{
                          v.isValidLength = false;
                        }
                      }
                    }
                  }
                } else
                // length based inspection
                if(tag.length >= $scope.minTagLength){
                  v.isValidLength = true;
                }

                return v;
              }
            }
          ],
          controllerAs: 'bentoTagsInputCtrl',
          link       : /**
           * Link funcion of bento-tags-input directive
           * @param scope
           * @param element
           * @param attrs
           * @param controllers
           */
          function (scope, element, attrs, controllers) {
            var ngModelController = controllers[0];
            var controller = controllers[1];
            var $input = angular.element(element[0].querySelector('.bento-tags-input-text'));
            var $hiddenInput = angular.element(element[0].querySelector('.bento-tags-input-text-hidden'));
            var goBlur = true;
            var t;
            var textBeforeKeypress;

            // init ngModel form element conditions
            ngModelController.$setPristine();
            ngModelController.$setUntouched();

            // Set Defaults
            scope.activePill = -1;
            scope.addOnComma = typeof scope.addOnComma === 'undefined' ? true : scope.addOnComma;
            scope.addOnEnter = typeof scope.addOnEnter === 'undefined' ? true : scope.addOnEnter;
            scope.ngModel = scope.ngModel ? scope.ngModel : [];

            scope.$watch(function () {
              return scope.ngModel ? scope.ngModel.length : 0;
            }, function (modelSize) {
              if (attrs.required) {
                if (modelSize === 0) {
                  ngModelController.$setValidity('required', false);
                } else {
                  ngModelController.$setValidity('required', true);
                }
              }
            });

            scope.$watch('editable', function () {
              if ($input) {
                $input.css('width', 60+'px');
              }
            });

            /**
             * When a user focus out from this input
             **/
            element.on('focusout', function (event) {
              element.removeClass('bento-tags-input-focused');

              // Only goBlur is set to true
              // Workaround in order to work with various browsers
              if (goBlur) {
                ngModelController.$setTouched();

                t = scope.inputText ? scope.inputText : '';
                if (t.length === 0) {
                  return;
                }
                addTagToModel(t);
              }
            });

            /**
             * On a pillfocus
             * @param index
             */
            scope.onPillFocus = function (index) {
              if(scope.ngReadonly){
                return;
              }
              scope.activePill = index;
              element.addClass('bento-tags-input-focused');
            };

            /**
             * Callback when entering pill edit mode
             * @param index
             */
            scope.onPillEdit = function (index) {
              element.addClass('bento-tags-input-focused');
            };

            /**
             * On a pillblur
             * @param index
             */
            scope.onPillBlur = function (index) {
              scope.activePill = -1;
              element.removeClass('bento-tags-input-focused');
            };

            /**
             * Callback when a pill demends to move selections to the left
             * @param index
             */
            scope.onPillMoveLeft = function (index) {
              $hiddenInput.focus();
            };

            /**
             * Callback when a pill demends to move selections to the left
             * @param index
             */
            scope.onPillMoveRight = function (index) {
              $hiddenInput.focus();
            };

            /**
             * Callback when a pill demends to move selections to the left
             * @param index
             * TODO: doesn't play well with ng-repeat
             */
            scope.onPillDeleteLeft = function (index) {
//              if (index > 0) {
//                scope.ngModel.splice(index - 1, 1);
//              }
            };

            /**
             * Callback when a pill demends to move selections to the left
             * @param index
             * TODO: doesn't play well with ng-repeat
             */
            scope.onPillDeleteRight = function (index) {
//              if (index === scope.ngModel.length - 1 && scope.inputText) {
//                scope.inputText = scope.inputText.substring(1);
//              } else {
//                scope.ngModel.splice(index+1,1);
//              }
            };

            /**
             * Return form element based default classes for NG
             * @returns {string}
             */
            scope.getClass = function () {
              return ''
            };

            /**
             * Get focus event
             */
            scope.onElementFocus = function () {
              goBlur = false;
              $input[0].focus();
              goBlur = true;
            };

            /**
             * Callback function to when a pill's content is changed
             * @param label
             * @param index
             */
            scope.onPillChange = function (index, label) {
              // This label is completely removed
              if (!label || label.length === 0) {
                var toBeRemovedTag = scope.ngModel[index];

                decideTagRemoval(
                  toBeRemovedTag,
                  function () {
                    // remove tag from ngModel array
                    scope.ngModel.splice(scope.ngModel.indexOf(toBeRemovedTag), 1);

                    // Fire callback
                    scope.onTagRemoved({tag: toBeRemovedTag});
                  }
                ); // decideTagRemoval

              } else {
                scope.ngModel[index][scope.propertyName] = label;
                // Fire callback
                scope.onTagEdited({tag: scope.ngModel[index]});
              }

              // resize the main input field
              if (scope.ngModel && scope.ngModel.length > 0) {
                var pills = element[0].querySelectorAll('.bento-tags-input-pill:not(.ng-leave)');
                var rect = pills[pills.length - 1].getBoundingClientRect();
                calculateInputField(rect);
              } else {
                calculateInputField(0);
              }
            };

            /**
             * Callback from pills redundancy report
             * @param index
             * @param isRedundant
             */
            scope.onPillRedundant = function (index, isRedundant) {
              if (isRedundant) {
                ngModelController.$setValidity('tags-input-redundant', false);
              } else {
                ngModelController.$setValidity('tags-input-redundant', true);
              }
            };

            /**
             * Callback from pills' length report
             * @param index
             * @param invalidLength
             */
            scope.onPillTagLength = function (index, isValidLength) {
              if (!isValidLength) {
                ngModelController.$setValidity('tags-input-invalid-length', false);
              } else {
                ngModelController.$setValidity('tags-input-invalid-length', true);
              }
            };

            /**
             * When a key is entered into the input field
             * Auto resize input field as user types
             * @param event
             */
            scope.onKeypress = function (event) {
              if (scope.isPillEditing) {
                return;
              }
              var width = (scope.inputText) ? (scope.inputText.length) * 9 : 60;
              $input.css('width', width + 'px');
            };

            /**
             * Callback when a key is up in the input field
             * @param event
             */
            scope.onKeyup = function (event) {
              if(scope.ngReadonly){
                return;
              }

              if (textBeforeKeypress !== scope.inputText) {
                ngModelController.$setDirty();

                ngModelController.$setValidity('tags-input-length', true);
                ngModelController.$setValidity('tags-input-redundant', true);
                $input.removeClass('tags-input-invalid');
              }
            };

            /**
             * On keydown in the directive
             * @param event
             */
            scope.onKeydown = function (event) {
              if(scope.ngReadonly){
                return;
              }

              textBeforeKeypress = scope.inputText;
              if (scope.isPillEditing) {
                return;
              }
              // Enter: 13
              // Left: 37
              // Right: 39
              // Delete: 46
              // Backspace: 8
              // Tab: 9
              // Comma: 188
              // Space: 32
              if (
                // Enter
              (scope.addOnEnter && event.keyCode === 13) ||
              // Space
              (scope.addOnSpace && event.keyCode === 32) ||
              // Comma
              (scope.addOnComma && event.keyCode === 188)) {
                if (scope.inputText) {
                  t = scope.inputText;
                  if (t.length === 0) {
                    return;
                  }

                  // unrelate to NG
                  $timeout(function () {
                    goBlur = false;
                    $input[0].focus();
                    goBlur = true;
                  }, 10);

                  addTagToModel(t);

                  event.stopPropagation();
                  event.preventDefault();
                }
              } else if (event.keyCode === 37) {
                if ($input[0].selectionStart === 0) {
                  goBlur = false;
                  $hiddenInput[0].focus();
                  goBlur = true;

                  if (scope.activePill === -1) {
                    scope.activePill = scope.ngModel.length - 1;
                  } else if (scope.activePill > 0) {
                    scope.activePill--;
                  }
                  event.stopPropagation();
                  event.preventDefault();
                }

              } else if (event.keyCode === 39) {
                if (scope.activePill === scope.ngModel.length - 1) {
                  $timeout(function () {
                    goBlur = false;
                    $input[0].focus();
                    goBlur = true;
                  }, 10);
                } else if (scope.activePill != -1) {
                  scope.activePill++
                }

                if (document.activeElement !== $input[0]) {
                  event.stopPropagation();
                  event.preventDefault();
                }

              } else if (event.keyCode == 46 || event.keyCode == 8) {
                if (scope.activePill != -1) {
                  scope.onPillClose(scope.activePill);

                  if (scope.activePill === scope.ngModel.length) {
                    scope.activePill = scope.ngModel.length - 1;
                  }

                  if (scope.activePill === -1) {
                    $timeout(function () {
                      $input[0].focus()
                    }, 10);
                  }
                  event.preventDefault();
                  event.stopPropagation();
                } else if (event.keyCode === 8 && $input[0].selectionStart === 0 && $input[0].selectionEnd === 0) {
                  scope.onPillClose(scope.ngModel.length - 1);
                } else {
                  $input.css('width', ((scope.inputText) ? scope.inputText.length * 9 : 0 ) + 'px')
                }
              } else if (
                // Tab
              event.keyCode === 9
              ) {
                if (scope.inputText) {
                  t = scope.inputText;
                  if (t.length === 0) {
                    return;
                  }
                  addTagToModel(t);
                  event.preventDefault();
                  event.stopPropagation();
                }
                scope.activePill = -1;
              }
            };

            /**
             * Decide to whether add the item or not
             * @param tag
             * @param callback
             */
            function decideTagAddition(tag, callback) {
              var okToAdd = scope.onTagAddStart({tag: tag});

              // `okToAdd` is a promise
              if (typeof okToAdd === 'object' && okToAdd.then) {
                // Resolve or reject
                okToAdd.then(
                  function () {
                    callback(tag);
                  });
              } else
              // Boolean
              if (typeof okToAdd === 'undefined' || okToAdd) {
                callback(tag);
              }
            }

            /**
             * Decide whether we should remove the tag based on `onTagRemoveStart` callback function
             * @param tag
             * @param callback
             */
            function decideTagRemoval(tag, callback) {
              var okToRemove = scope.onTagRemoveStart({tag: tag});

              // `okToRemove` is a promise
              if (typeof okToRemove === 'object' && okToRemove.then) {
                // Resolve or reject
                okToRemove.then(
                  function () {
                    callback(tag);
                  });
              } else
              // Boolean
              // Only add when there is no onTagRemoveStart callback or returned `true`
              if (typeof okToRemove === 'undefined' || okToRemove) {
                callback(tag);
              }
            }

            /**
             * Add a new Tag to the array
             * @param tag
             */
            function addTagToModel(tag) {
              var isValidTag = true;
              var validation = controller.validate(tag)

              if (scope.replaceSpacesWithDashes) {
                tag = tag.replace(/ /g, "-");
              } else if (scope.replaceSpacesWithUnderscores) {
                tag = tag.replace(/ /g, "_");
              }

              // Check if the tag is too short
              // Or there is a repeated one
              if (!validation.isValidLength) {
                $input.addClass('tags-input-invalid');
                ngModelController.$setValidity('tags-input-length', false);
                isValidTag = false;
              }

              if (!scope.useOperators && controller.hasRedundancy(tag)) {
                // error notification
                $input.addClass('tags-input-invalid');
                ngModelController.$setValidity('tags-input-redundant', false);
                validation.isRedundant = true;
                isValidTag = false;
              }

              if (isValidTag) {
                var newTag = {};
                newTag[scope.propertyName] = tag;
                newTag.type = validation.type;

                // findout if we can add this new tag
                decideTagAddition(
                  newTag,
                  function () {
                    scope.ngModel.push(newTag);
                    scope.inputText = '';
                    $input.css('width', '0');

                    // Fire tagAdded event handler
                    scope.onTagAdded({tag: newTag});
                  }
                ); //decideTagAddition
              }else{
                // fire invalidicity callback
                scope.onTagInvalidInput({
                  tag:validation
                });
              }
            }

            scope.onInputFocus = function () {
              scope.activePill = -1;
              element.addClass('bento-tags-input-focused');
            };

            scope.onHiddenInputFocus = function () {
              element.addClass('bento-tags-input-focused');
            };

            scope.onPillClose = function (index) {
              var tagToBeRemoved = scope.ngModel[index];

              // Need to confirm removal
              decideTagRemoval(
                tagToBeRemoved,
                function () {
                  $timeout(function () {
                    scope.ngModel.splice(scope.ngModel.indexOf(tagToBeRemoved), 1);

                    if (scope.ngModel.length > 0) {
                      var pills = element[0].querySelectorAll('.bento-tags-input-pill:not(.ng-leave)');
                      var rect = pills[pills.length - 1].getBoundingClientRect();
                      calculateInputField(rect);
                    } else {
                      calculateInputField(0);
                    }

                    // focus back to the text-field for additional user input
                    $input[0].focus();

                    // Fire callback
                    scope.onTagRemoved({tag: tagToBeRemoved});
                  }, 100);

                  // Set dirty
                  ngModelController.$setDirty();
                  ngModelController.$setTouched();
                }
              );
            }; // decideTagRemoval

            scope.resizeInput = function (rect) {
              if (rect) {
                calculateInputField(rect);
              } else {
                var pill = element[0].querySelector('.bento-tags-input-pill:last-of-type');
                calculateInputField(pill.getBoundingClientRect());
              }
            };

            function calculateInputField(rect) {
              var elRect = element[0].getBoundingClientRect();
              var targetWidth = elRect.width - ( rect.left - elRect.left) - rect.width - 30;
              targetWidth = targetWidth < 60 || rect === 0 ? '60px' : targetWidth + 'px';
              $input.css('width', targetWidth);
            }
          }
        }
      }
    ])
    /**
     * To accommodate multiple spaces in pills
     */
    .filter('bentoTagsInputPillFilter', function () {
      return function (input) {

        if (input) {
          // \u00A0 is the unicode for &nbsp;
          return input.replace(/ /g, '\u00A0');
        } else {
          return input;
        }
      }
    })
    /**
     * Bento Tags Input Pill Sub-Directive
     */
    .directive('bentoTagsInputPill', [
      '$timeout',
      function ($timeout) {
        return {
          scope      : {
            label   : '=',
            editable: '=',
            index   : '=',
            isActive: '=',
            length  : '=',
            onEdit  : '&',
            onClose : '&',
            resizeCallback: '&',
            onPillChange  : '&',
            onMoveLeft    : '&',
            onMoveRight   : '&',
            onDeleteLeft  : '&',
            onDeleteRight : '&',
            onRedundantTag: '&',
            onTagLength   : '&',
            tag           : '=',
            ngReadonly    : '='
          },
          templateUrl: function(element, attrs) {
            return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/tags_input/bento-tags-input-pill.html';
          },
          require    : '^bentoTagsInput',
          replace    : true,
          link       : /**
           * Link function of bento-tags-input-pill directive
           * @param scope
           * @param element
           * @param attr
           * @param controller
           */
          function (scope, element, attr, controller) {
            var $input,
                sizeRef = element[0].querySelector('.bento-tags-input-pill-size-ref'),
                isRedundant, isValidLength, validation;

            scope.isEditing = false;
            validation = controller.validate(scope.label);
            scope.tag.type = validation.type;

            /**
             * Watch the change of the label and make size adjustments
             */
            scope.$watch('editLabel', function (newLabel) {
              // Only adjust when it's in editing mode
              if (scope.isEditing && sizeRef && $input) {
                $input.css('width', (sizeRef.offsetWidth + 2) + 'px');
                scope.resizeCallback();
                isRedundant = controller.hasRedundancy(newLabel, scope.index);
                validation = controller.validate(newLabel);
                isValidLength = validation.isValidLength;
                scope.tag.type = validation.type;
                scope.onRedundantTag({index: scope.index, isRedundant: isRedundant});
                scope.onTagLength({index: scope.index, isValidLength: isValidLength});

                if (isRedundant || !isValidLength) {
                  element.addClass('bento-tags-input-pill-invalid');
                } else {
                  element.removeClass('bento-tags-input-pill-invalid');
                }
              }
            });

            /**
             * On pill edit keypress
             * @param event
             */
            scope.onKeypress = function (event) {

            };

            /**
             * On pill edit keydown
             * @param event
             */
            scope.onKeydown = function (event) {
              // Left key 37
              // Right key 39
              switch (event.keyCode) {
                case 37:
                  if ($input[0].selectionStart === 0 && $input[0].selectionEnd === 0) {
                    scope.onMoveLeft({index: scope.index, label: scope.label});
                  }
                  break;
                case 39:
                  if ($input[0].selectionStart === scope.label.length) {
                    scope.onMoveRight({index: scope.index, label: scope.label});
                  }
                  break;
                // Enter
                case 13:
                  // Firing blur to make the change permanent
                  scope.onInputBlur();
                  event.stopPropagation();
                  event.preventDefault();
                  break;
                // Backspace
                case 8:
                  if ($input[0].selectionStart === 0 && scope.index > 0) {
                    scope.onDeleteLeft({index: scope.index});
                  }
                  break;
                // Delete key
                case 46:
                  if ($input[0].selectionStart === scope.label.length) {
                    scope.onDeleteRight({index: scope.index});
                  }
                  break;
              }
            };

            /**
             * Returns a class for this component
             * @returns {*}
             */
            scope.getClass = function () {
              var c = 'ready ';

              if (scope.isActive) {
                c += 'active ';
              }

              if (!scope.isEditing) {
                c += 'btn btn-default ';
              }

              c += 'bti-pill-type-'+scope.tag.type;

              return c;
            };

            /**
             * Callback when the pill input is on focus
             * @param event
             */
            scope.onInputFocus = function (event) {

            };

            /**
             * When user forcuses out from the edit input field
             * @param event
             */
            scope.onInputBlur = function (event) {
              // Turn off editing mode
              scope.isEditing = false;
              controller.setEditingMode(false);

              // To avoid jump in some browsers
              $input.addClass('ng-hide');

              // Reset error & label to previous state on blur
              if (isRedundant || !isValidLength) {
                isRedundant = false;
                isValidLength = true;
                scope.onRedundantTag({index: scope.index, isRedundant: isRedundant});
                scope.onTagLength({index: scope.index, isValidLength: isValidLength});
                element.removeClass('bento-tags-input-pill-invalid');
              } else {
                scope.label = scope.editLabel.trim();

                // Fire callback function
                $timeout(function(){
                  scope.onPillChange({
                    label: scope.label,
                    index: scope.index
                  });
                });

              }

            };

            /**
             * On edit icon click
             * @param event
             */
            scope.onEditClick = function (event) {

              // ignore if this is not editable
              if (!scope.editable) {
                return;
              }

              scope.isEditing = true;
              scope.editLabel = scope.label;

              $timeout(function () {
                $input = angular.element(element[0].querySelector('input'));
                $input.css('width', sizeRef.offsetWidth+'px');

                // Wait a bit more for focus
                $timeout(function () {
                  $input[0].select();
                  controller.setEditingMode(true);
                  controller.setActivePill(scope.index);
                  scope.onEdit({index: scope.index});
                }, 100);

              });

              event.stopPropagation();
              event.preventDefault();
            };

            /**
             * On close button click
             * @param event
             */
            scope.onCloseClick = function (event) {
              event.preventDefault();
              event.stopPropagation();
              scope.onClose({index: scope.index});
            };
          }
        }
      }
    ])
  ;

})(angular, window);
(function (undefined) {
  'use strict';

  angular.module('bento.test', [])
    .directive('bentoTest', bentoTestDirFunc)
    .provider('bentoTest', bentoTestProvider)
    .controller('bentoTestDirController', bentoTestDirController)
  ;

  bentoTestDirFunc.$inject = ['bentoTest', '$timeout'];
  /**
   * QE Test directive definition and link
   * @returns {{link: link}}
   */
  function bentoTestDirFunc(bentoTest, $timeout) {
    return {
      controller: 'bentoTestDirController', // API used for children links
      restrict  : 'A', // Attribute ONLY
      require   : ['bentoTest', '^^?bentoTest'],
      link      : function (scope, element, attrs, controllers) {
        var ctrl       = controllers[0],
            parentCtrl = controllers[1],
            isIsolated,
            localWatchCancel,
            idWatchCancel
        ;

        $timeout(function(){
          element[0].removeAttribute('bento-test');
          element[0].removeAttribute('bento-test-attribute-name');
          element[0].removeAttribute('bento-test-isolate');
        });

        if (!bentoTest.isEnabled) {
          // In case Bento Test is enabled again
          bentoTest._onUnmuteOnce(init);
        }else{
          // First time
          init();
        }

        /**
         * Init Link logics
         */
        function init() {
          bentoTest._onMuteOnce(mute);
          ctrl.setParentController(parentCtrl);

          // $watch local elementName & assign
          localWatchCancel = scope.$watch(
            function () {
              return ctrl.elementName;
            },
            function (elName) {
              // Only update it when `bento-test` has a value
              if ((typeof attrs.bentoTest === 'string') && attrs.bentoTest.length > 0) {
                attrs.$set(ctrl.getInheritedAttributeName(), elName);
              }
            }
          );

          // Define isolation value
          isIsolated = (typeof attrs.bentoTestIsolate !== 'undefined') ?
            scope.$eval(attrs.bentoTestIsolate) : bentoTest.isolateByDefault;

          // Test ID needs to be pulled ONLY after all rendering is done
          $timeout(function () {
            if (parentCtrl && !isIsolated) {
              // Watch & update test id if its parent's id changes
              idWatchCancel = scope.$watch(function () {
                  return parentCtrl.elementName;
                },
                function (newElName) {
                  if(newElName){
                    ctrl.addParentElementName(newElName);
                  }
                });
            }
          });
        }

        function mute() {
          localWatchCancel();
          idWatchCancel && idWatchCancel();

          isIsolated =
            localWatchCancel =
              idWatchCancel =
                null;

          bentoTest._onUnmuteOnce(init);
        }

        // Destroy
        scope.$on('$destroy', function () {
          bentoTest._removeCallback(init, mute);
        });
      }
    }
  }

  bentoTestDirController.$inject = ['$scope', '$attrs', '$element', '$timeout', 'bentoTest'];
  /**
   * Bento Test directive controller
   * @param $scope
   * @param $attrs
   */
  function bentoTestDirController($scope, $attrs, $element, $timeout, bentoTest) {
    var ctrl             = this,
        attributeName, inheritedAttributeName,
        childControllers = [],
        parentController,
        cancelDirObserve,
        cancelAttrObserve
    ;

    if (!bentoTest.isEnabled) {
      bentoTest._onUnmuteOnce(init);
    }else{
      init();
    }

    ctrl.addParentElementName = function (parentElName) {

      if (parentElName.length > 0 && ctrl.elementID.length > 0) {
        parentElName += '-';
      }

      ctrl.elementName = parentElName + ctrl.elementID;
    };

    // Add child controller
    ctrl.addChildController = function (childController) {
      if (childControllers.indexOf(childController) === -1) {
        childController.setInheritedAttributeName(ctrl.getInheritedAttributeName());
        childControllers.push(childController);
      }
    };

    // Remove a child controller
    ctrl.removeChildController = function (childController) {
      var index;
      if (index = childControllers.indexOf(childController) > -1) {
        childControllers.splice(index, 1);
      }
    };

    // Set parent controller
    ctrl.setParentController = function (controller) {
      // No need to set parent when this element has its own test attribute name
      if ($attrs.bentoTestAttributeName) {
        return;
      }

      removeFromParentController();
      if (controller) {
        parentController = controller;
        parentController.addChildController(ctrl);
      }
    };

    // Set attribute name
    ctrl.setAttributeName = function (aName) {
      attributeName = aName;
      removeFromParentController();
      ctrl.setInheritedAttributeName(aName);
    };

    // Set Inherited Attribute Name
    ctrl.setInheritedAttributeName = function (aName) {
      // No need to update
      if(aName == inheritedAttributeName) return;

      // Only update when `bento-test` has a value
      if ((typeof $attrs.bentoTest === 'string') && $attrs.bentoTest.length > 0) {
        // get the current El test name
        var elTestName = $attrs[ctrl.getInheritedAttributeName()];
        // Remove old attribute name
        $attrs.$set(ctrl.getInheritedAttributeName(), null);

        // The test value to the new attribute name
        $attrs.$set(aName, elTestName);
      }

      inheritedAttributeName = aName;

      updateChildControllers();
    };

    // Get Inherited Attribute Name
    ctrl.getInheritedAttributeName = function () {
      return inheritedAttributeName || bentoTest.attributeName;
    };

    // Get attribute name
    ctrl.getAttributeName = function () {
      return attributeName || bentoTest.attributeName;
    };

    // Destroy
    $scope.$on('$destroy', function () {
      removeFromParentController();
      bentoTest._removeCallback(init, mute);
    });


    /**
     * Mute Bento Test
     */
    function mute() {
      cancelDirObserve && cancelDirObserve();
      cancelAttrObserve && cancelAttrObserve();

      var attributeToRemove = inheritedAttributeName || bentoTest.attributeName;

      attributeName =
        inheritedAttributeName =
          parentController =
            cancelDirObserve =
              cancelAttrObserve = undefined;
      childControllers = [];

      attributeToRemove = attributeToRemove.replace(/([A-Z])/g, function($1){return "-"+$1.toLowerCase();});

      $element[0].removeAttribute(attributeToRemove);
      bentoTest._onUnmuteOnce(init);
    }


    /**
     * Init controller
     */
    function init() {
      // Add mute listener
      bentoTest._onMuteOnce(mute);
      // Initialize variables
      ctrl.elementID = $attrs.bentoTest;
      ctrl.elementName = $attrs.bentoTest;

      cancelDirObserve = $attrs.$observe('bentoTest', function () {
        ctrl.elementID = $attrs.bentoTest;
        ctrl.elementName = $attrs.bentoTest;
        ctrl.componentName = undefined;

        $timeout(function () {
          $element[0].removeAttribute('bento-test');
        });
      });

      cancelAttrObserve = $attrs.$observe('bentoTestAttributeName', function (newAttributeName) {
        if (newAttributeName) {
          ctrl.setAttributeName(newAttributeName);
        }
      });
    }

    // Remove `ctrl` controller from its parent controller
    function removeFromParentController() {
      if (parentController) {
        parentController.removeChildController(ctrl);
      }
    }

    // Update child controllers
    function updateChildControllers() {
      var child;
      for (var i = 0, len = childControllers.length; i < len; i++) {
        child = childControllers[i];
        child.setInheritedAttributeName(inheritedAttributeName);
      }
    }
  }


  // Main API
  var bentoTestAPI = {
    attributeName: 'bentoTestId',
    isEnabled: false,
    isolateByDefault: false,
    enable: function(){
      bentoTestAPI.unmute();
    },
    disable: function(){
      bentoTestAPI.mute()
    },
    /**
     * Mute all Bento Test directives
     */
    mute: function(){
      bentoTestAPI.isEnabled = false;

      // Call mute callbacks
      // NOTE all callbacks get removed onces called
      if (Array.isArray(bentoTestMuteStack) && bentoTestMuteStack.length) {
        do {
          // pop and call
          bentoTestMuteStack.shift()();
        } while (bentoTestMuteStack[0]);
      }
    },
    /**
     * Unmute all tests
     */
    unmute: function(){
      bentoTestAPI.isEnabled = true;

      // Call onmute callbacks
      // NOTE all callbacks get removed onces called
      if (Array.isArray(bentoTestUnmuteStack) && bentoTestUnmuteStack.length) {
        do {
          // pop and call
          bentoTestUnmuteStack.shift()();
        } while (bentoTestUnmuteStack[0]);
      }
    },
    // Private functions
    // Mute callback
    _onMuteOnce  : function(func){
      if (!bentoTestMuteStack) {
        bentoTestMuteStack = [];
      }

      if (bentoTestMuteStack.indexOf(func) == -1) {
        bentoTestMuteStack.push(func);
      }
    },
    // Unmute callback
    _onUnmuteOnce: function(func){
      if (!bentoTestUnmuteStack) {
        bentoTestUnmuteStack = [];
      }

      if (bentoTestUnmuteStack.indexOf(func) == -1) {
        bentoTestUnmuteStack.push(func);
      }
    },
    // Remove callback
    _removeCallback: function(init,mute){
      var index;
      if(bentoTestMuteStack && ((index = bentoTestMuteStack.indexOf(mute)) > -1)){
        bentoTestMuteStack.splice(index,1);
      }
      if(bentoTestUnmuteStack && ((index = bentoTestUnmuteStack.indexOf(init)) > -1)){
        bentoTestUnmuteStack.splice(index,1);
      }
    }
  };

  var bentoTestMuteStack = [], bentoTestUnmuteStack = [];

  // Implement bentoTestProvider Getter and setters

  /**
   * Implement bentoTestProvider Getter and setters
   */
  // `attributeName`
  Object.defineProperty(bentoTestProvider.prototype,'attributeName',{
    set: function(name){
      bentoTestAPI.attributeName = name;
    },
    get: function(){
      return bentoTestAPI.attributeName;
    }
  });
  // `isEnabled`
  Object.defineProperty(bentoTestProvider.prototype,'isEnabled',{
    set: function(bool){
      bentoTestAPI.isEnabled = bool;
    },
    get: function(){
      return bentoTestAPI.isEnabled;
    }
  });
  // `isolateByDefault`
  Object.defineProperty(bentoTestProvider.prototype,'isolateByDefault',{
    set: function(bool){
      bentoTestAPI.isolateByDefault = bool;
    },
    get: function(){
      return bentoTestAPI.isolateByDefault;
    }
  });

  /**
   * QE Test Provider & its service
   */
  function bentoTestProvider() {

    // Detect and automatically turn on forge
    // Forge support infomation
    // `window.theforge.bentoTest` [boolean]
    this.isEnabled = !!window.theforge && window.theforge.bentoTest;


    // Register global API to turn the test on or off
    window.bento = window.bento || {};
    window.bento.enableBentoTest = bentoTestAPI.unmute;
    window.bento.disableBentoTest = bentoTestAPI.mute;

    // Expose API
    this.$get = [function () {
      return bentoTestAPI;
    }];
  }
})();
(function (window, angular, undefined) {

  'use strict';

  angular.module('bento.toggle', ['bento.services'])
  /**
   * Directive declaration
   */
    .directive('bentoToggle', ['$bentoServices', function ($bentoServices) {

      return {
        restrict   : 'A',
        replace    : true,
        require    : 'ngModel',
        scope      : {
          ngModel    : '=',
          onChange   : '&',
          lockToState: '=',
          isLocked   : '&'
        },
        templateUrl: '../templates/toggle/bento-toggle.html',
        link       : function (scope, element, attrs, ngModelController) {

          if (typeof scope.ngModel === 'undefined') {
            scope.ngModel = false;
          }

          /**
           * Swipe gestures
           */
          var startDragging = false;
          var startX = 0;
          var triggeringDX = element[0].offsetWidth * 0.3; //trigering distance when mouse or touch
                                                           // is moved
          var pointerDown;
          var pointerMove;
          var pointerUp;
          var hasPointerDownListener = false;
          scope.isTouch = $bentoServices.isTouchSupported();

          pointerDown = 'touchstart mousedown';
          pointerMove = 'touchmove mousemove';
          pointerUp = 'touchend mouseup';

          element.on(pointerDown, touchdown);
          hasPointerDownListener = true;
          scope.onKeydown = function (event) {
            if (event.keyCode === 32 || event.keyCode === 13) // Space
            {
              toggle(event);
            }
          };

          /**
           * Touchdown / Mousedown
           * @param event
           */

          function touchdown(event) {

            // ignore toggle event when this is locked
            if (scope.isLocked()) {
              return;
            }

            // ignore user event if there is a one-way lock
            if (typeof scope.lockToState !== 'undefined') {
              if ((scope.lockToState && scope.ngModel) ||
                (!scope.lockToState && !scope.ngModel)) {

                return;
              }
            }

            startDragging = true;
            startX = !!event.originalEvent && event.originalEvent.touches ?
              event.originalEvent.touches[0].pageX : event.pageX;

            element.on(pointerMove, touchmove);
            element.on(pointerUp, toggle);
            element.off(pointerDown, touchdown);
            hasPointerDownListener = false;

            event.stopPropagation(); //disable mousedown on touch devices
          }

          /**
           * Turn ON or OFF based on mouse/touch `x` swipes
           * @param event
           */
          function touchmove(event) {
            var dX = !!event.originalEvent && event.originalEvent.touches ?
              event.originalEvent.touches[0].pageX - startX : event.pageX - startX;
            var absDX = Math.abs(dX);

            // Check deltaX to define ON or OFF
            if (absDX > triggeringDX) {
              if (dX > 0) {
                scope.ngModel = true;
              } else {
                scope.ngModel = false;
              }

              element.off(pointerMove, touchmove);
              element.off(pointerUp, toggle);

              if (!hasPointerDownListener) {
                element.on(pointerDown, touchdown);
                hasPointerDownListener = true;
              }

              // Fire external onChange callback function
              if (!!scope.onChange) {
                scope.onChange({value: scope.ngModel});
              }

              scope.$apply();
              event.stopPropagation(); //disable mousedown on touch devices

            }
            // <FALLBACK> Toggle on touch devices
            // incase draggable area is way too small for fat fingers
            else if (scope.isTouch) {
              toggle(event);
            }
          }

          /**
           * Toggle this main directive
           */
          function toggle(event) {

            // ignore toggle event when this is locked
            if (scope.isLocked()) {
              return;
            }

            // ignore user event if there is a one-way lock
            // double assurance
            if (typeof scope.lockToState !== 'undefined') {
              if ((scope.lockToState && scope.ngModel) ||
                (!scope.lockToState && !scope.ngModel)
              ) {

                return;
              }
            }


            scope.ngModel = !scope.ngModel;

            ngModelController.$setDirty();
            ngModelController.$setTouched();

            // Fire external onChange callback function
            if (!!scope.onChange) {
              scope.onChange({value: scope.ngModel});
            }

            // update listeners
            element.off(pointerMove, touchmove);
            element.off(pointerUp, toggle);

            if (!hasPointerDownListener) {
              element.on(pointerDown, touchdown);
              hasPointerDownListener = true;
            }

            $bentoServices.safeApply(scope);

            event.stopPropagation(); //disable mousedown on touch devices
            event.preventDefault();
          }

        }
      };
    }]);

})(window, window.angular);

(function(angular, undefined) {
  'use strict';
  angular
    .module('bento.toolbar', ['bento.translate', 'bento.services', 'bento.reset', 'bento.cookie'])
    .controller('BentoToolbarController', BentoToolbarController)
    .directive('bentoToolbar', bentoToolbar)
    .directive('bentoToolbarButton', bentoToolbarButton)
    .directive('bentoToolbarDropdown', bentoToolbarDropdown)
    .directive('bentoToolbarNgRepeatComplete', bentoToolbarNgRepeatComplete);

  BentoToolbarController.$inject = ['$scope', '$element', '$timeout'];

  function BentoToolbarController($scope, $element, $timeout) {
    var vm = this;
    vm.initialized = false;
    vm.moreVisible = true;
    vm.moreWidth = 100;
    var repeatTimeout;
    vm.init = function() {
      if(vm.tData){
        vm.tData.map(function(item) {
          item.isVisible = true;
          item.isTransparent = true;
          return item;
        });
      }
      vm.moreVisible = true;
      vm.moreWidth = 100;
      var moreButton = $element[0].querySelector('li.more-button');
      if (moreButton) {
        moreButton.style.opacity = 0;
      }

    }
    vm.onRepeatComplete = function() {
      $timeout.cancel(repeatTimeout);
      repeatTimeout = $timeout(function(){
        vm.moreVisible = true;
        //when ng repeat is completed, all list elements are rendered in DOM
        //get list element's widths and set in button data
        var children = $element[0].querySelector('ul.nav.navbar-nav').children;
        if(vm.tData){
          vm.tData.map(function(item, index) {
            if (children[index]) {
              item.width = children[index].getAttribute('data-button-width');
            }

            return item;
          });
        }
        var moreButton = $element[0].querySelector('li.more-button');
        if (moreButton) {
          vm.moreWidth = +moreButton.getAttribute('data-button-width');
        }

        //adjust button in toolbar
        //initialized flag is to prevent window resize
        //from calling adjustButtons first
        vm.initialized = true;
        vm.adjustButtons();
      },10);
    };

    //Watch toolbar data, and set privately used
    //tData, add custom properties isVisible, isTransparent
    $scope.$watch(function() {
        return (vm.toolbarData);
      },
      function onToolbarData(newValue, oldValue) {
        if (newValue) {
          vm.tData = angular.copy(newValue);
          vm.init();
        }
      }, true);
  }
  bentoToolbar.$inject = ['$timeout', '$window'];

  function bentoToolbar($timeout, $window) {
    return {
      restrict: 'A',
      scope: {},
      transclude: {
        'navbarLeft': '?navbarLeft',
        'navbarRight': '?navbarRight'
      },
      controller: 'BentoToolbarController',
      controllerAs: 'bentoToolbarCtrl',
      bindToController: {
        'toolbarData': '=',
        'moreButtonLabel': '='
      },
      templateUrl: function(element, attrs) {
        return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/toolbar/bento-toolbar.html';
      },
      link: function(scope, element, attrs, toolbarCtrl) {
        var resizeTimer,initTimeout;

        toolbarCtrl.adjustButtons = adjustButtons;

        angular.element($window).bind('resize', onElementResize);
        //scope.$watch(getElementWidth, onElementResize);
        scope.$on('$destroy', onDestroy);
        element.on('$destroy', onDestroy);

        function getElementWidth() {
          return element[0].offsetWidth;
        }

        function onWindowResize() {
          scope.$apply();
        }

        function onElementResize(width) {
          if (resizeTimer) {
            $timeout.cancel(resizeTimer);
          }
          resizeTimer = $timeout(function() {
            adjustButtons();
          });
        }
        scope.$on('bentoToolbarRefresh', onRefresh)

        function onRefresh() {
          initTimeout = $timeout(function() {
            toolbarCtrl.init();
          })
        }

        function onDestroy() {
          angular.element($window).unbind('resize', onWindowResize);
          $timeout.cancel(initTimeout);
        }

        function adjustButtons() {
          if (!toolbarCtrl.initialized) {
            return;
          }
          if(!toolbarCtrl.tData || toolbarCtrl.tData.length===0){
            return;
          }

          var tData = toolbarCtrl.tData; //toolbar button data
          var totalWidth = 0; //reset total width of cumulative button widths
          var elWidth = getElementWidth(); //get width of toolbar container
          var navBarRightWidth = +element[0]
            .querySelector('div.toolbar-navbar-right')
            .offsetWidth; //get width of right nav
          var navBarLeftWidth = +element[0]
            .querySelector('div.toolbar-navbar-left')
            .offsetWidth; //get width of right nav
          var moreWidth = toolbarCtrl.moreWidth; //get width of more button
          var pad = 5; //extra pad
          var staticWidth = 0;
          if (tData) {
            //Iterate through buttons,
            //and display if cumulative width is
            //less than container width
            for (var i = 0, il = tData.length; i < il; i++) {
              var td = tData[i];
              if(!td.width){
                return;
              }
              if(td.static){
                staticWidth += +td.width;
              }
              totalWidth += +td.width;
              var accumulatedWidth = (totalWidth + moreWidth + pad + navBarRightWidth + navBarLeftWidth);
              var targetWidth = (elWidth - staticWidth)
              if (accumulatedWidth < targetWidth) {
                td.isVisible = true;
                td.isTransparent = false;
              } else {
                td.isVisible = false;
                td.isTransparent = true;
              }
              if(td.static){
                td.isVisible = true;
                td.isTransparent = false;
              }
            }
            toolbarCtrl.moreVisible = true;
            var moreButton = element[0].querySelector('li.more-button');
            if (moreButton) {
              moreButton.style.opacity = 1;
            }
            if (tData[il - 1].isVisible === true) {
              if (totalWidth + pad + navBarRightWidth + navBarLeftWidth < elWidth) {
                toolbarCtrl.moreVisible = false;
              }
            }
          }
        }
      }
    }
  }
  bentoToolbarButton.$inject = ['$timeout'];

  function bentoToolbarButton($timeout) {
    return {
      restrict: 'A',
      require: '^bentoToolbar',
      link: function(scope, element, attr, ctrl) {
        var width = getTotalWidth(element[0]);
        var el = element[0];
        scope.$watch(function() {
          return el.offsetWidth;
        }, function(newValue, oldValue) {
          width = getTotalWidth(element[0]);
          el.setAttribute('data-button-width', width);
          ctrl.onRepeatComplete();
        });

        function getTotalWidth(el) {
          var style = el.currentStyle || window.getComputedStyle(el);
          var width = Math.ceil(el.offsetWidth) +
            parseFloat(style.paddingLeft) +
            parseFloat(style.paddingRight) +
            parseFloat(style.marginLeft != "auto" ? style.marginLeft : 0) +
            parseFloat(style.marginRight != "auto" ? style.marginRight : 0);
          return width;
        }
      }
    }
  }
  bentoToolbarNgRepeatComplete.$inject = ['$timeout'];

  function bentoToolbarNgRepeatComplete($timeout) {
    return {
      restrict: 'A',
      require: '^bentoToolbar',
      link: function(scope, element, attr, ctrl) {
        if (scope.$last === true) {
          $timeout(function() {
            ctrl.onRepeatComplete(element);
          });
        }
      }
    }
  }

  bentoToolbarDropdown.$inject = ['$parse', '$window', '$timeout', '$compile'];

  function bentoToolbarDropdown($parse, $window, $timeout, $compile) {
    return {
      restrict: 'A',
      controller: function() {
        var vm = this;
        vm.isOpen = false;
        vm.toggle = function(button) {
          if (!button.disabled) {
            vm.isOpen = !vm.isOpen;
          }
        }
      },
      controllerAs: 'bentoToolbarDropdownCtrl',
      bindToController: {},
      link: function(scope, element, attrs, ctrl) {

      }
    };
  }

})(window.angular);
(function(angular){

  'use strict';

  var translateApp = angular.module('bento.services');

  translateApp
    .provider('$bentoTranslateLoader',function(){
      var urlPatterns = [];

      // Pushing a new pattern onto the pattern stack for loading later
      this.addURLPattern = function(pattern){
        urlPatterns.push(pattern);
      };

      /**
       * Loader Factory
       * @type {*[]}
       */
      this.$get = ['$http', '$q', function($http, $q){
        // return loaderFn
        return function (options) {

          var deferred = $q.defer();
          var filePatternArray = urlPatterns.slice(0);
          var languageData = {};
          var counter = 0;

          loadLanguageFile();

          function loadLanguageFile(){
            // pop and get the top time from the stack
            var url = filePatternArray.pop().replace('{lang}',options.key);
            $http({method: 'GET', url: url}).
            then(function(res) {
              // this callback will be called asynchronously
              // when the response is available
              addAndCheckFile(res.data);
            }).
            catch(function(res) {
              // called asynchronously if an error occurs
              // or server returns response with an error status.
              addAndCheckFile();
            });
          }

          function addAndCheckFile(data){

            if(!!data) {
              for (var key in data) {
                if(!!data[key]) {
                  languageData[key] = data[key];
                  counter += 1;
                }
              }
            }

            if(filePatternArray.length > 0){
              loadLanguageFile();
            }else{
              if(counter > 0){
                deferred.resolve(languageData);
              }else{
                deferred.reject(options.key);
              }
            }
          }
          return deferred.promise;
        };
      }];
    });

})(window.angular);

(function () {

  /*
   DO NOT CHANGE!!
   This is Bento.UI's default translation variable.
   All new translations must be updated or overwritten with its API.

   See: http://bento.ui.int.thomsonreuters.com/#/components/translate
   Default Locale: `en-us`
   */
  var BENTO_TRANSLATE_DEFAULT = {
    // Component Translations
    "BENTO_UI_ALERT_DESCRIPTION"                      : "You have alerts, press tab key to continue.",
    "BENTO_UI_ALERT_CLOSE_BUTTON"                     : "Close alert.",
    "BENTO_UI_BUSY_LOADER_LOADING"                    : "Loading content. ",
    "BENTO_UI_FILE_SELECTOR_DESCRIPTION"              : "This is file selector, press Tab key to proceed to the browse button",
    "BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON"            : "Press enter key to Browse file",
    "BENTO_UI_FILE_SELECTOR_BROWSE_BUTTON_LABEL"      : "Browse for File",
    "BENTO_UI_FILE_SELECTOR_DROP_FILED_LABEL"         : "Drag a File Here or",
    "BENTO_UI_FILE_SELECTOR_FILE_NAME"                : "File _FILE_NUMBER_ of _NUM_FILES_, file name: _FILE_NAME_",
    "BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_PROGRESS"     : " loading",
    "BENTO_UI_FILE_SELECTOR_FILE_UPLOAD_COMPLETE"     : " loading complete",
    "BENTO_UI_FILE_SELECTOR_REMOVE_BUTTON"            : "Remove _FILE_NAME_",
    "BENTO_UI_FILE_SELECTOR_REMOVE_COMPLETE"          : "_FILE_NAME_ is removed",
    "BENTO_UI_MULTISELECT_OVERLAY_DESCRIPTION"        : "Multiselect menu, press Enter key to start selecting.",
    "BENTO_UI_MULTISELECT_OVERLAY_CONTENT_DESCRIPTION": "Tab to navigate through the content. Enter key to select or toggle.  Escape key to dismiss the selection.",
    "BENTO_UI_MULTISELECT_OVERLAY_ALL_SELECTED_INFO"  : "All (NUMBER) selected",
    "BENTO_UI_MULTISELECT_OVERLAY_CANCEL"             : "Cancel",
    "BENTO_UI_MULTISELECT_OVERLAY_CANCEL_DESCRIPTION" : "Enter key or space bar to confirm and cancel the selections.",
    "BENTO_UI_MULTISELECT_OVERLAY_DONE"               : "Done",
    "BENTO_UI_MULTISELECT_OVERLAY_DONE_DESCRIPTION"   : "Enter key or space bar to confirm and apply the selections.",
    "BENTO_UI_MULTISELECT_OVERLAY_EDIT"               : "Edit",
    "BENTO_UI_MULTISELECT_OVERLAY_SELECT"             : "Select",
    "BENTO_UI_MULTISELECT_OVERLAY_SELECT_ALL"         : "Select All",
    "BENTO_UI_MULTISELECT_OVERLAY_SELECTED_INFO"      : "NUMBER selected",
    "BENTO_UI_MULTISELECT_OVERLAY_SHOW_ALL"           : "Show All",
    "BENTO_UI_MULTISELECT_OVERLAY_SHOW_SELECTED"      : "Show Selected",
    "BENTO_UI_MULTISELECT_OVERLAY_SEARCH_LABEL"       : "Search Item Text Field",
    "BENTO_UI_NAV_TOOLBAR_MORE"                       : "More",
    "BENTO_UI_PAGINATION_GO_BUTTON"                   : "Go",
    "BENTO_UI_PAGINATION_INFO_PAGE_TEXT"              : "Page _PAGE_ of _PAGES_",
    "BENTO_UI_PAGINATION_INFO_TEXT"                   : "_START_ to _END_ of _MAX_",
    "BENTO_UI_SPLITTER_GROUP"                         : "This is a splitter group, press Tab key to proceed to its contents.",
    "BENTO_UI_SPLITTER_GROUP_TOP_BAR"                 : "Splitter Group top group bar, press space bar to expand or collapse this panel.",
    "BENTO_UI_SPLITTER_GROUP_BOTTOM_BAR"              : "Splitter Group bottom group bar, press space bar to expand or collapse this panel.",
    "BENTO_UI_SPLITTER_GROUP_LEFT_BAR"                : "Splitter Group left group bar, press space bar to expand or collapse this panel.",
    "BENTO_UI_SPLITTER_GROUP_RIGHT_BAR"               : "Splitter Group right group bar, press space bar to expand or collapse this panel.",
    "BENTO_UI_SPLITTER_GROUP_TOP_PANEL"               : "Splitter Group top panel, press Tab key to proceed.",
    "BENTO_UI_SPLITTER_GROUP_BOTTOM_PANEL"            : "Splitter Group bottom panel, press Tab key to proceed.",
    "BENTO_UI_SPLITTER_GROUP_LEFT_PANEL"              : "Splitter Group left panel, press Tab key to proceed.",
    "BENTO_UI_SPLITTER_GROUP_RIGHT_PANEL"             : "Splitter Group right panel, press Tab key to proceed.",
    "BENTO_UI_SPLITTER_GROUP_MAIN_PANEL"              : "Splitter Group main panel, press Tab key to proceed.",
    "BENTO_UI_TOGGLE_ON"                              : "Toggle is on. Space bar to turn it off",
    "BENTO_UI_TOGGLE_OFF"                             : "Toggle is off. Space bar to turn it on",
    "BENTO_UI_TOOLBAR_MORE"                           : "More",
    "BENTO_UI_TRANSFER_BOX_BTN_TEXT_ONE"              : "Transfer",
    "BENTO_UI_TRANSFER_BOX_BTN_TEXT_TWO"              : "Transfer",
    "BENTO_UI_TRANSFER_BOX_BTN_TEXT"                  : "Transfer",
    "BENTO_UI_TRANSFER_BOX_INFO_TEXT"                 : "_SELECTED_ of _TOTAL_ Checked",
    "BENTO_UI_TREE_EXPANDED"                          : "expanded",
    "BENTO_UI_TREE_COLLAPSED"                         : "collapsed",
    "BENTO_UI_WIZARD_DESCRIPTION"                     : "Wizard to complete a process. Tab key to proceed to wizard steps.  Enter key to select each wizard step and its content.",
    "BENTO_UI_WIZARD_STEP_NAME"                       : "Wizard Step Title.",
    "BENTO_UI_WIZARD_BUTTON_CANCEL"                   : "Cancel",
    "BENTO_UI_WIZARD_BUTTON_CANCEL_DESCRIPTION"       : "Cancel",
    "BENTO_UI_WIZARD_BUTTON_DONE"                     : "Done",
    "BENTO_UI_WIZARD_BUTTON_DONE_DESCRIPTION"         : "Done with the last step.",
    "BENTO_UI_WIZARD_BUTTON_NEXT"                     : "Next",
    "BENTO_UI_WIZARD_BUTTON_NEXT_DESCRIPTION"         : "Proceed to next step.",
    "BENTO_UI_WIZARD_BUTTON_PREVIOUS"                 : "Previous",
    "BENTO_UI_WIZARD_BUTTON_PREVIOUS_DESCRIPTION"     : "Back to previous step.",
    // Static translations
    "BENTO_UI_TODAY"                                  : "Today",
    "BENTO_UI_TOMORROW"                               : "Tomorrow",
    "BENTO_UI_YESTERDAY"                              : "Yesterday",
    "BENTO_UI_N_DAY_AGO"                              : "_NUMBER_ Days Ago",

  };

  angular.module('bento.translate', ['bento.services'])
  /**
   * Setting up the translate
   */
    .run([
      '$bentoTranslate',
      function ($bentoTranslate) {

        $bentoTranslate.setTranslation(
          BENTO_TRANSLATE_DEFAULT,
          true // To avoid $apply in init cycle since the first cycle will be automatically applied.
        );

      }])
    /**
     * Bento Translate Main Filter
     */
    .filter('bentoTranslate', [
      '$bentoTranslate',
      function ($bentoTranslate) {

        function bentoTranslateFilter(label, override) {

          // Use override
          if (!!override && override.trim().length > 0) {
            return override;
          }

          return $bentoTranslate._translate(label);
        }

        bentoTranslateFilter.$stateful = true;

        return bentoTranslateFilter;
      }])
    /**
     * Factory to support various useful functions
     */
    .factory('$bentoTranslate', [
      '$http',
      '$bentoServices',
      '$rootScope',
      '$q',
      '$log',
      function ($http, $bentoServices, $rootScope, $q, $log) {
        var _data         = {},
            isLoading     = true,
            promiseStack  = [],
            callbackStack = [];

        // Add a callback to stack
        function onChange(fn) {
          callbackStack.push(fn);
        }

        // Remove a callback from stack
        function removeOnChange(fn) {
          var i = callbackStack.indexOf(fn);
          if (i > -1) {
            callbackStack.splice(i, 1);
          }
        }

        // Set custom data
        function set(data, bypassApply) {
          for (var key in data) {
            _data[key] = data[key];
          }
          isLoading = false;

          _fireCallbacks();

          // To avoid apply conflicts in init cycle
          if (!bypassApply) {
            $bentoServices.safeApply($rootScope);
          }
        }

        // Add translation key
        function add(key, translation) {
          if (hasData()) {
            _data[key] = translation;
            _fireCallbacks();
          }
        }

        // Get custom data
        function get() {
          return _data;
        }

        // Load a new set of translation
        function load(url) {
          isLoading = true;
          $http.get(url)
            .then(function (res) {
              isLoading = false;
              set(res.data);
              resolvePromises(true);
              $bentoServices.safeApply($rootScope);
            })
            .catch(function () {
              $log.error('Bento Translate: Unable to load ' + url);
              resolvePromises(false);
              isLoading = false;
            })
        }

        // Has translation in this factory/service
        function hasData() {
          return !!_data;
        }

        // Resolve all promises
        function resolvePromises() {
          var p;
          while (promiseStack.length > 0) {
            p = promiseStack.pop();
            p.deferred.resolve(_translate(p.label));
          }
        }

        // Public API for translate
        function translate(label) {
          var deferred = $q.defer();

          // Still loading translation need to wait
          if (isLoading) {
            promiseStack.push({label: label, deferred: deferred});
          } else {
            deferred.resolve(_translate(label));
          }

          return deferred.promise;
        }

        // Private API for translate
        // Offers instant possible translation
        // Not suiTable for server loadings
        function _translate(label) {
          if (hasData()) {
            if (_data[label]) {
              return _data[label];
            } else {
              return label;
            }
          } else {
            return label;
          }
        }

        // fire all callbacks
        function _fireCallbacks() {
          for (var i in callbackStack) {
            callbackStack[i]();
          }
        }

        return {
          add           : add,
          getTranslation: get,
          hasTranslation: hasData,
          load          : load,
          onChange      : onChange,
          removeOnChange: removeOnChange,
          setTranslation: set,
          translate     : translate,
          //Private API
          _translate    : _translate
        };
      }
    ])
  ;

})();

(function() {
  'use strict';

  angular.module('bento.transferbox', [
    'bento.cookie',
    'bento.translate'
  ])
    .controller('bentoFlexgridTransferBoxController', transferboxController)
    .directive('bentoFlexgridTransferbox', transferbox)

  transferboxController.$inject = ['$timeout', '$scope', '$window', 'flexGridSetUpService'];

  function transferboxController($timeout, $scope, $window, flexGridSetUpService) {
    var vm = this;
    /**** CONFIG ***/
    vm.config = {
      boxOneTitle: "Available Users",
      boxTwoTitle: "Selected Users",
      infoText: undefined,
      transferBtnText: undefined,
      transferBtnTextOne: undefined,
      transferBtnTextTwo: undefined,
      paginationInfoText: undefined,
      paginationGoText: undefined,
      paginationInfoPageText: undefined,
      boxOneInfoShown: true,
      boxTwoInfoShown: true,
      disableTransfer: false
    };
    vm.transferItems = transferItems;
    vm.style = {
      height: vm.config.height + 'px'
    }
    $scope.$watch('columnDefinitions', function(columnDefinitions) {
      vm.columnDefinitions = columnDefinitions;
    });
    $scope.$watch('height', function(height) {
      vm.config.height = height;
      vm.style.height = height + 'px';
    });
    $scope.$watchCollection('boxOneItemSource', function(data) {
      vm.gridDataOne = data
    });
    $scope.$watchCollection('boxTwoItemSource', function(data) {
      vm.gridDataTwo = data
    });

    var gridOneWatch = $scope.$watch(function() {
      return vm.box1;
    }, function(box1) {
      if (box1) {
        if (typeof $scope.control === "object") {
          $scope.control.gridOne = box1;
        }
        gridOneWatch();
      }
    });
    var gridTwoWatch = $scope.$watch(function() {
      return vm.box2;
    }, function(box2) {
      if (box2) {
        if (typeof $scope.control === "object") {
          $scope.control.gridTwo = box2;
        }
        gridTwoWatch();
      }
    });
    vm.onSplitterResize = function onSplitterResize() {
      $timeout(function() {
        $scope.$broadcast('bentoTransferBoxResize')
      });
    }

    vm.checkItemsOne = function (items, gridData){
      if (!!$scope.onBeforeTransfer) {
        $scope.onBeforeTransfer({
          fromData: items,
          toData: gridData,
          transferItemsFn: vm.transferItemsOne
        });
      } else {
        vm.transferItemsOne(items,gridData);
      }
    }
    vm.checkItemsTwo = function (items, gridData){
      if (!!$scope.onBeforeTransfer) {
        // $scope.onBeforeTransfer(items, gridData, vm.transferItemsTwo);
        $scope.onBeforeTransfer({
          fromData: items,
          toData: gridData,
          transferItemsFn: vm.transferItemsTwo
        });
      } else {
        vm.transferItemsTwo(items,gridData);
      }
    }
    vm.transferItemsOne = function (items, gridData) {
      vm.gridDataTwo = items.concat(vm.gridDataTwo);
      vm.gridDataOne = gridData;
      vm.transferItems();
    }
    vm.transferItemsTwo = function (items, gridData) {
      vm.gridDataOne = items.concat(vm.gridDataOne);
      vm.gridDataTwo = gridData;
      vm.transferItems();
    }

    function transferItems() {
      // //strip out select property
      // vm.gridDataOne.forEach(function(obj) {
      //     delete obj.bentoTboxSelect;
      // });
      // vm.gridDataTwo.forEach(function(obj) {
      //     delete obj.bentoTboxSelect;
      //     console.log('strip',obj)
      // });

      $scope.boxOneItemSource = vm.gridDataOne;
      $scope.boxTwoItemSource = vm.gridDataTwo;

      $scope.onTransfer({
        gridDataOne: vm.gridDataOne,
        gridDataTwo: vm.gridDataTwo
      });
    }
  }

  transferbox.$inject = ['$timeout'];

  function transferbox($timeout) {
    return {
      restrict: 'AE',
      scope: {
        boxOneItemSource: '=',
        boxTwoItemSource: '=',
        columnDefinitions: '=',
        control: '=?',
        desktopMode: '=?',
        boxOneTitle: '@',
        boxTwoTitle: '@',
        infoText: '@',
        transferBtnText: '@',
        transferBtnTextOne: '@',
        transferBtnTextTwo: '@',
        height: '=',
        hidePagination: '=?',
        onBeforeTransfer: '&?',
        onTransfer: '&',
        uniqueKey: '@',
        paginationInfoText: '@',
        paginationGoText: '@',
        paginationInfoPageText: '@',
        showFilters: '=?',
        gridTemplateUrl: '=?',
        disableTransfer: '=?'
      },
      controller: 'bentoFlexgridTransferBoxController',
      controllerAs: 'bentoTransferBoxCtrl',
      templateUrl: function(element, attrs) {
        return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/transfer_box/bento-flexgrid-transferbox-base.html';
      },
      replace: true,
      link: function(scope, element, attrs, tBoxCtrl) {
        for (var key in tBoxCtrl.config) {
          if (key in attrs.$attr) {
            tBoxCtrl.config[key] = attrs[key];
          }
        }
        attrs.$observe('boxOneTitle', function(title) {
          tBoxCtrl.config.boxOneTitle = title;
        });
        attrs.$observe('boxTwoTitle', function(title) {
          tBoxCtrl.config.boxTwoTitle = title;
        });
        scope.$watch('disableTransfer', function(disableTransfer){
          tBoxCtrl.config.disableTransfer = disableTransfer;
        })
        scope.control = {
          toggleAll: toggleAll
        };
        function toggleAll(box) {
          if (box === 1) {
            if (tBoxCtrl.box1) {
              tBoxCtrl.box1.toggleAll();
            }
          } else {
            if (tBoxCtrl.box2) {
              tBoxCtrl.box2.toggleAll();
            }
          }
        }

      }
    }
  }
}());
(function(undefined) {
  'use strict';

  angular.module('bento.transferbox')
    .controller('bentoFlexgridTBoxController', tboxController)
    .directive('bentoFlexgridTbox', tbox)

  tboxController.$inject = ['$timeout', '$scope', '$element', 'flexGridSetUpService'];

  function tboxController($timeout, $scope, $element, flexGridSetUpService) {
    if (typeof wijmo === 'undefined') {
      return;
    }
    var vm = this;
    var hasInitialized = false;
    var hasPaginized = false;
    var multiSelectPanelObj;
    var columnHeaderCheckBox = undefined;
    /**** CONFIG ***/
    vm.defaults = {
      page: 1,
      pageSize: 25,
      collectionView: undefined,
      offsetHeight: 160,
      paginationOffsetHeight: 96
    };
    vm.selectedItems = [];
    //Watch config file from base
    $scope.$watch('config', function(config) {
      vm.config = angular.extend(angular.copy(vm.defaults), config);
    });
    //watch titles
    $scope.$watch('config.boxOneTitle', function(title) {
      vm.config.boxOneTitle = title
    });
    $scope.$watch('config.boxTwoTitle', function(title) {
      vm.config.boxTwoTitle = title
    });
    //flag for first transfer box grid,
    //used in template for display left or right aligned titles and buttons
    $scope.$watch('boxOne', function(boxOne) {
      vm.boxOne = boxOne;
    });
    $scope.$on('$destroy', vm.onDestroy);
    vm.flexGrid = undefined;
    vm.togglePagination = togglePagination;
    vm.columnHeaderCheckBoxClickHandler = clickHandler;
    vm.initialized = function(s, e) {
      //console.log('init',s);
    }

    vm.itemFormatter = function(panel, r, c, cell) {
      setUpMultiSelect(panel, r, c, cell, 'bentoTboxSelect');
    }
    vm.transferItems = function() {
      //Seperate the row items to selected and non selected arrays

      var sourceCollection = vm.config.collectionView.sourceCollection;
      vm.selectedItems = [];
      var gridItems = [];
      var sCount = 0,
          gCount = 0;
      for (var i = 0, ttl = sourceCollection.length; i < ttl; i++) {
        var item = sourceCollection[i];
        if (item.bentoTboxSelect === true) {
          vm.selectedItems[sCount] = item;
          sCount++;
        } else {
          gridItems[gCount] = item;
          gCount++;
        }
      }
      $scope.transferItems({
        items: vm.selectedItems,
        gridData: gridItems
      });

    };
    vm.onDestroy = function() {
      if ($scope.showFilters != false &&
        vm.config &&
        vm.config.collectionView
      ) {
        vm.config.collectionView.collectionChanged.removeHandler(onCollectionChanged);
      }
    }
    vm.onCheckBoxChange = onCheckBoxChange;

    vm.toggleAll = function() {
      vm.columnHeaderCheckBoxClickHandler();
    }
    //listens to event to refresh grid
    $scope.$on('bentoTransferBoxResize', function onTransferBoxResize() {
      if (vm.flexGrid) {
        vm.flexGrid.invalidate();
      }
    });

    $scope.$watch('hidePagination', togglePagination);

    //watch for initialization of grid
    var removeFlexGridWatch = $scope.$watch(
      function() {
        return vm.flexGrid
      },
      function(grid) {
        if (!grid || hasInitialized) return;
        if (!$scope.hidePagination) {
          setUpPagination(grid);
        } else {
          vm.config.paginationOffsetHeight = vm.defaults.paginationOffsetHeight;
        }

        if ($scope.showFilters != false) {
          $scope.setUpFilters(grid);
        }
        if (typeof $scope.control === "object") {
          $scope.control.flexGrid = grid;
        }

        if ($scope.hidePagination) {
          grid.deferResizing = true;
        }
        updateRowHeight();
        hasInitialized = true;
        removeFlexGridWatch();
      }
    );

    // Init render
    // Force the grid to render when it is initialized when hidden with CSS
    var removeInitRenderWatch = $scope.$watch(
      function() {
        return $element[0].offsetWidth;
      },
      function(width) {
        if (width > 0 && vm.flexGrid) {
          vm.flexGrid.invalidate();
          removeInitRenderWatch();
        }
      }
    );

    $scope.$watch('desktopMode', function(desktopMode) {
      updateRowHeight();
    });

    function updateRowHeight() {
      if (!vm.flexGrid) {
        return;
      }
      if (!!$scope.desktopMode) {
        flexGridSetUpService.updateFlexGridRowHeight(vm.flexGrid, 30, [36, 38]);
        vm.config.offsetHeight = 130;
        if ($scope.hidePagination) {
          vm.config.offsetHeight = 150;
        }
      } else {
        flexGridSetUpService.updateFlexGridRowHeight(vm.flexGrid, 48, [48, 56]);
        vm.config.offsetHeight = 160;
      }
    }
    $scope.$watch('columnDefinitions', function(columnDefinitions) {
      vm.config.columnDefinitions = angular.copy(columnDefinitions);
      var selectColumnDefinition = {
        binding: 'bentoTboxSelect',
        header: ' ',
        visible: true,
        minWidth: 40,
        width: 40
      }
      vm.config.columnDefinitions.unshift(selectColumnDefinition);
    }, true);
    $scope.$watchCollection('gridData', function(data) {
      if (Array.isArray(data)) {

        data.forEach(function(obj) {
          obj.bentoTboxSelect = false;
        });

        if (vm.config.collectionView) {
          delete vm.config.collectionView;
        }

        vm.config.collectionView = new wijmo.collections.CollectionView(data);

        if ($scope.showFilters != false) {
          //Set up collection view filter
          vm.config.collectionView.filter = customCollectionViewFilter;
          //Set up handling for collection changed
          vm.config.collectionView.collectionChanged.addHandler(onCollectionChanged);
        }

        //refresh to get filtered items totalItemCount
        vm.config.collectionView.refresh();
        onCheckBoxChange();
        $timeout(function() {
          if (vm.config.collectionView) {
            vm.config.totalItems = vm.config.collectionView.totalItemCount;
            if (!$scope.hidePagination) {
              vm.config.collectionView.pageSize = vm.config.pageSize;
            } else {
              vm.config.pageSize = vm.config.collectionView.sourceCollection.length;
              vm.config.collectionView.pageSize = vm.config.pageSize;
            }
            //on Transfer, keep grid page from resetting to first page, keep it the same page
            if (vm.config.page <= 0) {
              vm.config.page = 1;
            }

            var newPageCount = vm.config.collectionView.pageCount;
            if (newPageCount < vm.config.page) {
              vm.config.page = newPageCount;
            }

            vm.config.collectionView.moveToPage(vm.config.page - 1);
          }
        });
      }
    });

    function onCheckBoxChange() {
      vm.selectedItems = vm.config.collectionView.sourceCollection.filter(function(item) {
        return (item.bentoTboxSelect === true);
      });
      updateColumnHeaderCheckbox();
    }

    function updateColumnHeaderCheckbox() {
      if (vm.flexGrid) {
        var cnt = 0;
        var ttl = vm.flexGrid.rows.length;
        for (var i = 0; i < ttl; i++) {
          if (vm.flexGrid.getCellData(i, 0) == true) {
            cnt++;
          }
        }
        if (multiSelectPanelObj && multiSelectPanelObj.cb) {
          multiSelectPanelObj.cb.checked = cnt > 0;
          multiSelectPanelObj.cb.indeterminate = cnt > 0 && cnt < ttl;
          if (multiSelectPanelObj.cb.indeterminate === true) {
            multiSelectPanelObj.cbElement.className = 'bento-flex-grid-checkbox bento-icon-minus-plain';
          } else if (multiSelectPanelObj.cb.checked === true) {
            multiSelectPanelObj.cbElement.className = 'bento-flex-grid-checkbox bento-icon-checkmark';
          } else {
            multiSelectPanelObj.cbElement.className = 'bento-flex-grid-checkbox';
          }
        }
      }
    }

    function setUpPagination(flexGrid) {
      if (flexGrid && !hasPaginized) {
        $scope.$watch(function() {
          return vm.config.page;
        }, function(page) {
          if (flexGrid.collectionView) {
            flexGrid.collectionView.moveToPage(page - 1);
          }
        });

        $scope.$watch(function() {
          return vm.config.pageSize;
        }, function(pageSize) {
          if (flexGrid && flexGrid.collectionView) {
            flexGrid.collectionView.pageSize = pageSize;
          }
        });
        hasPaginized = true;
      }
    }

    function togglePagination(pagination) {
      var hidePagination = pagination || $scope.hidePagination;
      if (!hidePagination) {
        setUpPagination(vm.flexGrid);
        vm.config.pageSize = vm.defaults.pageSize;
        if (vm.flexGrid && vm.flexGrid.collectionView) {
          vm.flexGrid.collectionView.pageSize = vm.config.pageSize;
        }
        vm.config.paginationOffsetHeight = 0;
        if ($scope.desktopMode) {
          vm.config.offsetHeight = 130;
        }
      } else {
        if (vm.config.collectionView) {
          vm.config.pageSize = vm.config.collectionView.sourceCollection.length;
          vm.config.collectionView.pageSize = vm.config.pageSize;
        }
        if (vm.flexGrid) {
          vm.flexGrid.deferResizing = true;
        }
        vm.config.page = 1;
        vm.config.paginationOffsetHeight = vm.defaults.paginationOffsetHeight;
        if ($scope.desktopMode) {
          vm.config.offsetHeight = 150;
        }
      }
    }

    function setUpMultiSelect(panel, r, c, cell, binding) {
      var flex = panel.grid;
      var col = flex.columns[c];
      // check that this is a boolean column
      if (panel.cellType !== wijmo.grid.CellType.RowHeader &&
        col &&
        col.dataType == wijmo.DataType.Boolean &&
        col.binding === binding) {
        //For column header checkbox only
        if (panel.cellType == wijmo.grid.CellType.ColumnHeader) {
          if (r == 0) {
            // prevent sorting on click
            col.allowSorting = false;
            // create and initialize checkbox
            //

            // create and initialize checkbox
            cell.innerHTML = '<i></i>';
            var cb = {};
            var cbElement = cell.firstChild;

            cbElement.removeEventListener('click', clickHandler);
            cbElement.addEventListener('click', clickHandler);
            multiSelectPanelObj = {
              panel: panel,
              r: r,
              c: c,
              cell: cell,
              flex: flex,
              col: col,
              cb: cb,
              cbElement: cbElement
            }
            updateColumnHeaderCheckbox();
          }
        }
        //add col-select class to whole column cell
        cell.className += ' col-select';
      }
    };

    function clickHandler(e) {
      if (e) {
        e.stopPropagation();
      }
      multiSelectPanelObj.cb.checked = !multiSelectPanelObj.cb.checked;
      if (multiSelectPanelObj.cb.checked === true) {
        multiSelectPanelObj.cbElement.className = 'bento-flex-grid-checkbox bento-icon-checkmark';
      } else {
        multiSelectPanelObj.cbElement.className = 'bento-flex-grid-checkbox';
      }
      multiSelectPanelObj.flex.beginUpdate();
      for (var i = 0, ttl = multiSelectPanelObj.flex.rows.length; i < ttl; i++) {
        multiSelectPanelObj.flex.setCellData(i, multiSelectPanelObj.c, multiSelectPanelObj.cb.checked);
      }
      multiSelectPanelObj.flex.endUpdate();
      onCheckBoxChange();
    }

    //FILTER
    vm.updateFilter = function(id) {
      $scope.updateFilter(id);
    }

    function customCollectionViewFilter(item) {
      var val = null;
      var itemkey = null;

      for (var i = 0, il = vm.config.columnDefinitions.length; i < il; i++) {
        var col = vm.config.columnDefinitions[i];
        if ('dateObj' in col && col.dateObj) {
          val = formatDate(col.dateObj);
          itemkey = formatDate(item[col.binding]);
        } else if ('filterText' in col && col.filterText) {
          val = col.filterText;
          itemkey = item[col.binding];
        } else if ('selectText' in col && col.selectText) {
          val = col.selectText;
          if (val === 'All') {
            val = undefined;
          }
          itemkey = item[col.binding];
        } else if ('comboboxObj' in col && col.comboboxObj) {
          val = col.comboboxObj.name;
          if (val === 'All') {
            val = undefined;
          }
          itemkey = item[col.binding];
        }
        if (!val) {
          continue;
        }
        val = String(val);

        if (String(itemkey).toLowerCase().indexOf(val.toLowerCase()) < 0) {
          return false;
        }
      }

      // all passed
      return true;
    };
    //On Collection Changed, update total items to sync pagination
    function onCollectionChanged(cv) {
      //get grid's collection view total item count
      vm.config.totalItems = cv.totalItemCount;
    }
  }

  tbox.$inject = ['$timeout', '$templateCache', '$compile', '$parse'];

  function tbox($timeout, $templateCache, $compile, $parse) {
    return {
      restrict: 'AE',
      scope: {
        gridData: '=',
        config: '=',
        columnDefinitions: '=',
        desktopMode: '=?',
        boxOne: '=?',
        showFilters: '=?',
        hidePagination: '=?',
        transferItems: '&',
        control: '=',
        gridTemplateUrl: '=?',
        disableTransfer: '=?'
      },
      controller: 'bentoFlexgridTBoxController',
      controllerAs: 'bentoFlexgridTboxCtrl',
      templateUrl: function(element, attrs) {
        return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/transfer_box/bento-flexgrid-transferbox-grid.html';
      },
      replace: true,
      link: function(scope, element, attrs, tBoxCtrl) {
        if (typeof wijmo === 'undefined') {
          console.warn('Bento TransferBox relies on Wijmo FlexGrid, please make sure Wijmo files are included')
          return;
        }

        //If
        scope.$watch('gridTemplateUrl', function(tUrl) {
          if (tUrl) {
            var templateCache = $templateCache.get(tUrl);
            $timeout(function() {
              element.html(templateCache);
              $compile(element.contents())(scope);
            })
          }
        });
        var filterTimeout;

        scope.control = {
          toggleAll: tBoxCtrl.toggleAll
        };
        tBoxCtrl.onInputFocus = onInputFocus;
        scope.setUpFilters = function setUpFilters(grid) {
          //Add new column header row for filters
          var row = new wijmo.grid.Row();
          grid.columnHeaders.rows.insert(1, row);
        }



        scope.updateFilter = function updateFilter(id) {

          if (filterTimeout) {
            $timeout.cancel(filterTimeout);
          }
          filterTimeout = $timeout(function() {
            if (tBoxCtrl.config.collectionView) {
              tBoxCtrl.config.collectionView.refresh();
            }
            tBoxCtrl.config.page = 1;
            $timeout(function() {
              var focusedID = '.transferbox-' + id;
              setFocus(focusedID);
            }, 100);
          }, 300);
        }

        function onInputFocus(col, evt) {
          var focusedID = '.transferbox-' + col.binding;
          setFocus(focusedID);
        }

        function setFocus(focusedID) {
          var focused = element[0].querySelector(focusedID);
          if (focused) {
            focused.focus();
            var strLength = focused.value.length;
            focused.setSelectionRange(strLength, strLength);
          }
        }
      }
    }
  }
}());
angular.module('bento.transferbox')
  .controller('bentoFlexgridTBoxInputFilterController', tboxInputFilterController)
  .directive('bentoFlexgridTboxInputFilter', tboxInputFilter);


tboxInputFilterController.$inject = ['$timeout', '$scope', '$element']
/**
 * [tboxInputFilterController Input Filter Directive's Controller]
 * @param  {[type]} $timeout [description]
 * @param  {[type]} $scope   [description]
 * @param  {[type]} $element [description]
 * @return {[type]}          [description]
 */
function tboxInputFilterController($timeout, $scope, $element) {
  var vm = this;
  var inputTimeout;

  $scope.$on('$destroy',vm.onDestroy);

  $timeout(function() {
    if (vm.bentoFlexgridTboxInputFilter && vm.bentoFlexgridTboxInputFilter.type === 'input') {
      vm.initFilter();
    }
  });
  /**
   * [initFilter create input text field and add relevant event handling]
   * @return {[type]} [description]
   */
  vm.initFilter = function() {
    //DOM maninpulation in controller, but it's ok, it's a directive's controller
    //create input element
    vm.inputTextElement = document.createElement('input');
    vm.inputTextElement.type = "text";
    vm.inputTextElement.className = "form-control";
    //create input container element
    vm.inputElement = document.createElement('div');
    vm.inputElement.className = "input-filter";
    vm.inputElement.appendChild(vm.inputTextElement); //append input element into container
    vm.el = $element[0]; //get column element
    vm.eGrid = vm.el.parentElement; //get grid element
    vm.containerElement = vm.eGrid.parentElement; //get transfer box element
    vm.att = vm.el.attributes['binding']; //get binding attribute
    vm.filterContainer = vm.containerElement.querySelector('.input-filter-container');
    vm.filterContainer.appendChild(vm.inputElement); //append input container into transferbox element
    vm.inputTextElement.addEventListener('input', vm.onTextInput) //add event listener to input
    vm.inputTextElement.addEventListener('keyup', vm.onTextInput)
    vm.grid = wijmo.Control.getControl(vm.eGrid); //get grid control
    wijmo.assert(vm.grid instanceof wijmo.grid.FlexGrid);
    vm.col = vm.grid.columns.getColumn(vm.att.value); //get grid column
    wijmo.assert(vm.col instanceof wijmo.grid.Column);
    vm.grid.updatedView.addHandler(vm.resizeFilter); //add grid event handling when grid view is updated
  }


  /**
   * [resizeFilter - Resize and position input text field to it's column header]
   * @return {[type]} [description]
   */
  vm.resizeFilter = function() {
    var rc = vm.grid.columnHeaders.getCellBoundingRect(1, vm.col.index);
    var containerRect = vm.containerElement.getBoundingClientRect();
    //set input field position
    wijmo.setCss(vm.inputElement, {
      position: 'absolute',
      left: rc.left - containerRect.left,
      top: 0,
      width: rc.width,
      height: vm.grid.columnHeaders.rows[1].renderHeight,
      borderRadius: '0px'
    });
    //set container's position
    wijmo.setCss(vm.filterContainer, {
      position: 'absolute',
      overflow: 'hidden',
      zIndex:1,
      top: rc.top - containerRect.top,
      width: vm.grid.clientSize.width,
      height: vm.grid.columnHeaders.rows[1].renderHeight
    })
  }

  /**
   * [onTextInput - handler for input event]
   * @param  {[type]} e [event]
   * @return {[type]}   [description]
   */
  vm.onTextInput = function(e) {
    //throttle events
    if (inputTimeout) {
      $timeout.cancel(inputTimeout)
    }
    //update two-way bound col.filterText
    $timeout(function(){
      vm.bentoFlexgridTboxInputFilterText = e.target.value;
    });
    inputTimeout = $timeout(function() {
      //let the filter in the bento-flexgrid-transferbox-grid-ng.js take it's filtering effect
      // console.log('text',vm.bentoFlexgridTboxInputFilterText)
      vm.grid.collectionView.refresh();
    }, 200);
  }

  vm.onDestroy = function (){
    if(vm.grid){
      vm.grid.updatedView.removeHandler(vm.resizeFilter);
    }
    vm.inputTextElement.removeEventListener('input', vm.onTextInput);
    vm.inputTextElement.removeEventListener('keyup', vm.onTextInput);
  }
}

/**
 * [tboxInputFilter Directive, all functions in controller]
 * @return {[type]} [description]
 */
function tboxInputFilter() {
  return {
    restrict: 'A',
    priority: 110,
    controller: tboxInputFilterController,
    controllerAs: 'flexGridInputFilterCtrl',
    bindToController: {
      bentoFlexgridTboxInputFilter: '=',
      bentoFlexgridTboxInputFilterText: '='
    },
    link: function(scope, element, attrs, ctrl) {

    }
  }
}
(function (angular, undefined) {
  "use strict";

  var CHECKBOX = '-checkbox';

  // Provides lazy loading to enhance initial load time
  angular.module('bento.tree', ['bento.services'])
  // Bento Tree Directive
    .directive('bentoTree', [
      '$compile',
      '$timeout',
      'treeSelection',
      'treeHelper',
      '$recursionHelper',
      function ($compile, $timeout, treeSelection, treeHelper, $recursionHelper) {

        return {
          restrict    : 'A',
          scope       : {
            checkboxModel      : '@',
            collapsingCallback : '=', // Two way binding is needed for direct function reference
            expandingCallback  : '=', // Two way binding is needed for direct function reference
            expandOnlyModel    : '@', // Model to determine if the current node can only expand and collapse
            multiSelect        : '=',
            nodeChildren       : '@',
            onCheckboxChange   : '=', // Two way binding is needed for direct function reference
            secondTreeIcon     : '@',
            selectableModel    : '@', // Model to determine if the node is selectable or not
            selectAsCheck      : '=',
            selectCallback     : '=', // Two way binding is needed for direct function reference
            selectModel        : '@', // Selection Model
            treeCollapsed      : '=',
            treeDisabled       : '=', // Private API
            treeIcon           : '@',
            treeId             : '@',
            treeLabel          : '@',
            treeModel          : '=',
            treeSelectionHelper: '=?', // **Internal Use** forwarded TreeSelectionHelper
            useCheckbox        : '=',
          },
          templateUrl : function (element, attrs) {
            return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/tree/bento-tree.html'
          },
          replace     : true,
          compile     : function (element) {
            // Use the compile function from the RecursionHelper,
            // And return the linking function(s) which it returns
            return $recursionHelper.compile(element);
          },
          controller  : 'mainTreeController',
          controllerAs: 'bentoTreeCtrl',
        };
      }
    ])
    // Tree selection factory
    .factory('treeSelection', function () {

      var TreeSelectionHelper = function () {
        var self = this;

        this.node = [];

        this.setRootElement = function (treeRootElement) {
          self.rootElement = treeRootElement;
        };

        this.getRootElement = function () {
          return self.rootElement;
        };

        this.getClickableNodes = function () {
          if (self.rootElement) {
            var nodes        = self.rootElement[0].querySelectorAll('.bento-tree-item-cta'),
                visibleNodes = [],
                node
            ;

            // find out if the nodes are clickable aka visible
            for (var i = 0, len = nodes.length; i < len; i++) {
              node = nodes[i];
              if (node.offsetWidth > 0 && node.offsetHeight > 0) {
                visibleNodes.push(node);
              }
            }

            return visibleNodes;
          }
        };

        this.findElement = function (array, child, lable, id) {
          var flag = false;
          for (var i = array.length - 1; i >= 0; i--) {
            if ((array[i])[lable] === id) {
              this.clearNodes();
              flag = true;
              if (typeof array[i].collapsed === 'undefined') {
                array[i].collapsed = false;
              }
              array[i].selected = 'selected';
              this.updateSelection(array[i]);
              break;
            } else {
              if (angular.isArray((array[i])[child])) {
                flag = this.findElement((array[i])[child], child, lable, id);
                if (flag) {
                  if (typeof array[i].collapsed === 'undefined') {
                    array[i].collapsed = false;
                  }
                  break;
                }
              }
            }
          }
          return flag;
        };

        this.updateSelection = function (_node) {
          if (this.node.indexOf(_node) === -1) {
            this.node.push(_node);
          }
        };

        this.getSelection = function () {
          return this.node;
        };

        this.removeSelection = function (_node) {
          var index = this.node.indexOf(_node);
          this.node.splice(index, 1);
        };

        this.clearNodes = function (node, itemsProp) {

          // Clear all
          // We need to clear everything
          if (typeof node == 'undefined') {
            this.node = [];
            return;
          }

          // Clearing only the selected node and its childnNodes
          var items = node[itemsProp],
              index = this.node.indexOf(node);

          // We remove nodes
          if (index > -1) {
            this.node.splice(index, 1);
          }

          if (Array.isArray(items)) {
            for (var i = 0, len = items.length; i < len; i++) {
              self.clearNodes(items[i], itemsProp);
            }
          }
        };

        this.findSelectElement = function (node, child, lable, id) {
          return this.getSelection();
        };

      };

      var getHelper = function () {
        return new TreeSelectionHelper();
      };

      return {
        getHelper: getHelper
      };
    })

    // Tree Helper factory
    .factory('treeHelper', function () {

      /**
       * Adjust Tree Minimum width
       * @param $element
       *
       * This function will find the widest element and set the minimum width
       * to the root element
       */
      function adjustMinWidth($element) {
        var spanVariables = $element[0].getElementsByTagName('span');
        var widest = 0;
        var padding = 10;

        for (var i = 0; i < spanVariables.length; i++) {
          var span = spanVariables[i];
          var totalWidth = getOffsetUntilRoot(span, $element[0]) + span.offsetWidth;

          if (totalWidth > widest) {
            widest = totalWidth;
          }
        }

        $element.css('min-width', (widest + padding) + 'px');
      }

      /**
       * Get the Boolean from a node selection
       * @param scope
       * @param node
       */
      function getSelectModelValue(scope, node) {
        if (typeof scope.selectModel === 'undefined' ||
          (typeof scope.selectModel === 'string' && scope.selectModel === '')) {
          return node._selected;
        }
        return node[scope.selectModel];
      }

      /**
       * Set the Selection Boolean to a node
       * @param scope
       * @param node
       */
      function setSelectModelValue(scope, node, value) {
        if (typeof scope.selectModel === 'undefined' ||
          (typeof scope.selectModel === 'string' && scope.selectModel === '')) {
          node._selected = value;
        } else {
          node[scope.selectModel] = value;
        }
      }

      /**
       * Check / Uncheck offspring of a node based on its status
       * @param node
       * @param nodeChildrenName
       * @param checkboxModelName
       * @param checked
       */
      function checkOffspring(node, nodeChildrenName, checkboxModelName, checked) {
        // Node is disabled don't check it's offspring
        if (node.disabled) {
          return;
        }

        if (typeof checked !== 'undefined') {
          if (!node.hideCheckbox) {
            node[checkboxModelName] = checked;
            node._indeterminate = false;
            document.getElementById(node.$$bentoTreeId + CHECKBOX).indeterminate = false;
          }
        }

        // recursively check/uncheck the offspring of node
        if (!!node[nodeChildrenName] && node[nodeChildrenName].length > 0) {
          var hasCheckedChildren = false;
          for (var i = 0; i < node[nodeChildrenName].length; i++) {
            hasCheckedChildren = checkOffspring(
              node[nodeChildrenName][i],
              nodeChildrenName,
              checkboxModelName,
              node[checkboxModelName]) || hasCheckedChildren;
          }

          //indeterminate the current checkbox
          if (hasCheckedChildren && !node[checkboxModelName]) {
            node._indeterminate = true;
            var treeEl = document.getElementById(node.$$bentoTreeId + CHECKBOX);
            if (treeEl) {
              treeEl.indeterminate = true;
            }
          }
        }

        return node[checkboxModelName] || node._indeterminate;
      }

      /**
       * Help to check / uncheck / indeterminate check boxes on one root branch
       * @param node
       * @param nodeChildrenName
       * @param checkboxModelName
       */
      function indeterminateRoot(scope, nodeChildrenName, checkboxModelName) {
        var nodeScope  = scope,
            parentScope = // walk up the scope hierarchy
              (nodeScope &&
                nodeScope.$parent &&
                nodeScope.$parent.$parent) ?
                nodeScope.$parent.$parent.$parent : undefined,
            parentNode = (parentScope && parentScope.node)? parentScope.node : undefined;

        if (!!parentNode) {
          //check siblings and see if checked
          var siblings = parentNode[nodeChildrenName];
          var hasChecked = false;
          var hasUnchecked = false;
          var hasIndeterminate = false;
          for (var i = 0; i < siblings.length; i++) {
            var _node = siblings[i];

            // Ignore .hideCheckbox nodes
            if (_node.hideCheckbox) {
              continue;
            }

            if (_node._indeterminate) {
              hasIndeterminate = true;
            } else if (!_node[checkboxModelName]) {
              hasUnchecked = true;
            } else {
              hasChecked = true;
            }
          }

          // There are three conditions
          // 1. All siblings are checked without indeterminate
          // 2. None of the siblings are checked without indeterminate
          // 3. Some siblings are checked with indeterminate
          var checkbox = document.getElementById(parentNode.$$bentoTreeId + CHECKBOX) || {};

          // Case 1:
          if (!hasUnchecked && hasChecked && !hasIndeterminate) {
            parentNode[checkboxModelName] = true;
            checkbox.indeterminate = false;
            parentNode._indeterminate = false;
          } else
          // Case 2:
          if (hasUnchecked && !hasChecked && !hasIndeterminate) {
            parentNode[checkboxModelName] = false;
            checkbox.indeterminate = false;
            parentNode._indeterminate = false;
          } else
          // Case 3:
          if ((hasUnchecked && hasChecked) || hasIndeterminate) {
            parentNode[checkboxModelName] = false;
            parentNode._indeterminate = true;
            checkbox.indeterminate = true;
          }

          // recursive
          indeterminateRoot(parentScope, nodeChildrenName, checkboxModelName);
        }
      }

      /**
       * Get tree root element
       * @param  {element} element - current element that is part of the tree
       * @return {element} root element
       */
      function getTreeRootElement(element) {
        return el;
      }

      //Private
      function getOffsetUntilRoot(node, rootNode) {

        if (node.parentNode.parentNode === rootNode) {
          return node.offsetLeft - rootNode.offsetLeft;
        } else {
          return node.offsetLeft + getOffsetUntilRoot(node.parentNode, rootNode);
        }

      }

      return {
        adjustMinWidth     : adjustMinWidth,
        indeterminateRoot  : indeterminateRoot,
        checkOffspring     : checkOffspring,
        getSelectModelValue: getSelectModelValue,
        setSelectModelValue: setSelectModelValue,
        getTreeRootElement : getTreeRootElement
      };
    })
    // Main Tree Controller
    .controller('mainTreeController', [
      '$scope',
      '$element',
      'treeSelection',
      'treeHelper',
      '$timeout',
      function ($scope, $element, treeSelection, treeHelper, $timeout) {


        // treeId defines the root of this tree
        if (typeof $scope.treeSelectionHelper === 'undefined') {
          $scope.treeSelectionHelper = treeSelection.getHelper();
          $scope.treeSelectionHelper.setRootElement($element);

          // Add a root class
          $element.addClass('bento-tree-root');

          // Watch main data object to re-adjust the width
          $scope.$watchCollection('treeModel', function (newTreeModel) {
            // Tree model is not ready
            if (typeof newTreeModel === 'undefined') {
              return;
            }

            $timeout(function () {
              treeHelper.adjustMinWidth($element);
              // Update checks
              for (var j = 0; j < $scope.treeModel.length; j++) {
                treeHelper.checkOffspring($scope.treeModel[j], $scope.nodeChildren, $scope.checkboxModel);
              }
            });

            processTree(newTreeModel)
          });
        }

        function processTree(treeModel) {
          var i, len;

          //check to see if we need to collapse by default
          if (treeModel.length > 0) {
            var children = treeModel;
            if (typeof $scope.treeCollapsed === 'undefined') {
              for (i = 0, len = children.length; i < len; i++) {
                if (typeof children[i].collapsed === 'undefined') {
                  children[i].collapsed = false;
                }
              }
            } else {
              for (i = 0, len = children.length; i < len; i++) {
                if (typeof children[i].collapsed === 'undefined') {
                  children[i].collapsed = $scope.treeCollapsed;
                }
              }
            }
          }

          /*
           performs the necessary action if the data model contains the value for selected
           */
          $timeout(function () {
            $scope.treeSelectionHelper.clearNodes();
            updateSelectionInfo(treeModel);
          });

          /**
           * Update node selection info in helper
           * @param treeNodeCollection
           */
          function updateSelectionInfo(treeNodeCollection) {
            for (var i = 0; i < treeNodeCollection.length; i++) {
              var nodeModel = treeNodeCollection[i];
              if (treeHelper.getSelectModelValue($scope, nodeModel)) {
                $scope.labelSelect(nodeModel);
                $scope.treeSelectionHelper.updateSelection(nodeModel);
              }

              if (nodeModel[$scope.nodeChildren] && Array.isArray(nodeModel[$scope.nodeChildren])) {
                updateSelectionInfo(nodeModel[$scope.nodeChildren]);
              }
            }
          }
        }

        /**
         * Generate Tree ID on the fly and preserve previously created node ID
         * @param node
         * @returns {string|*}
         */
        $scope.getTreeId=function(node){
          if (typeof node.$$bentoTreeId === 'undefined') {
            node.$$bentoTreeId = 'bento-tree-node-' + Math.round(Math.random() * 1000000000000);
          }
          return node.$$bentoTreeId;
        };

        /**
         * On check box change
         *
         * We need to use `ng-click` instead of `ng-chage` due to odd behaviors on IE browsers
         * where `indeterminate` state click does not count as a "change state"
         *
         * Because `ng-click` fires before the model changes it's variable, we need to update the
         * tree models when rendering is done
         *
         */
        $scope.checkboxClick = function (_node) {
          // Bypass if this node and branch is disabled
          if ($scope.treeModel.disabled || $scope.treeDisabled) {
            return;
          }

          var parentScope = this.$parent,
              node     = _node || parentScope.node,
              checkbox = document.getElementById(node.$$bentoTreeId + CHECKBOX);

          // remove indeterminate
          node._indeterminate = false;
          if (checkbox) {
            checkbox.indeterminate = false;
          }

          // setting timeout here to make sure that all models are updated
          $timeout(function () {
            // check all children
            treeHelper.checkOffspring(node, $scope.nodeChildren, $scope.checkboxModel);

            // indeterminate the whole branch to check / uncheck / indeterminate checkboxes
            treeHelper.indeterminateRoot(parentScope, $scope.nodeChildren, $scope.checkboxModel);

            // Fire callback
            if (!!$scope.onCheckboxChange) {
              $scope.onCheckboxChange(node);
            }
          });
        };

        /**
         * Select and de-select a node based on `multiSelect` flag
         */
        $scope.labelSelect = function (node) {
          // Bypass if this node and branch is disabled
          if ($scope.treeModel.disabled || $scope.treeDisabled) {
            return;
          }

          var elementNode = typeof(node) === "undefined" ? this.node : node;

          if (typeof $scope.selectableModel !== 'undefined' &&
            typeof node[$scope.selectableModel] === 'boolean' && !node[$scope.selectableModel]
          ) {
            return;
          }

          // Forward click action to the checkbox when doing select as check
          if (!!$scope.selectAsCheck) {
            elementNode[$scope.checkboxModel] = !elementNode[$scope.checkboxModel];
            $scope.checkboxClick(elementNode);
            return;
          } else
          // Forward a label select as tree toggle
          if (!!$scope.expandOnlyModel && elementNode[$scope.expandOnlyModel]) {
            $scope.toggleSelect(elementNode);
            return;
          }

          // Fire select callback and bypass if it returns a `false`
          if (!!$scope.selectCallback) {
            var reply = $scope.selectCallback(elementNode);
            // replay is `false`
            if (typeof reply === 'boolean' && !reply) {
              return;
            }
          }

          //here where we would set multi select
          var currentNode = $scope.treeSelectionHelper.getSelection();
          if (!$scope.multiSelect) {
            angular.forEach(currentNode, function (node) {
              treeHelper.setSelectModelValue($scope, node, false);
            });
            $scope.treeSelectionHelper.removeSelection(elementNode);
            treeHelper.setSelectModelValue($scope, elementNode, true);
            $scope.treeSelectionHelper.updateSelection(elementNode);
          } else {
            var nodeArray = currentNode.filter(function (node) {
              if (node === elementNode) {
                treeHelper.setSelectModelValue($scope, node, false);
                return true;
              }
              return false;
            });
            if (nodeArray.length > 0) {
              treeHelper.setSelectModelValue($scope, nodeArray[0], false);
              $scope.treeSelectionHelper.removeSelection(elementNode);
            } else {
              treeHelper.setSelectModelValue($scope, elementNode, true);
              $scope.treeSelectionHelper.updateSelection(elementNode);
            }
          }

        };

        /**
         * On tree item keyboard key press
         * @param  {event} event Keyboard event
         * @return {}
         */
        $scope.onTreeItemKeydown = function (event, node) {
          /*
           37: left
           38: top
           39: right
           40: down
           */
          switch (event.keyCode) {
            case 13:
            case 32:
              event.preventDefault();
              event.stopPropagation();
              break;
            case 37: // left
              // collapse node
              if (!node.collapsed && node.items.length > 0) {
                node.collapsed = true;
                fireCollapseCallback(node);
              }
              // move up one level and focus the parent node
              else if ($scope.$parent.node) {
                $scope
                  .treeSelectionHelper
                  .getRootElement()[0]
                  .querySelector('#' + $scope.$parent.node.$$bentoTreeId + ' > .bento-tree-item-cta')
                  .focus();
              }

              event.preventDefault();
              event.stopPropagation();
              break;
            case 38: // top
              fucusToAvailableNodeWith(event.currentTarget, -1);
              event.preventDefault();
              event.stopPropagation();
              break;
            case 39: // right
              if (node.items.length > 0) {
                if (node.collapsed) {
                  node.collapsed = false;
                  fireCollapseCallback(node);

                  // Auto focus the first child node
                  // Similar to Windows File Explorer
                  $timeout(function () {
                    fucusToAvailableNodeWith(event.currentTarget, 1);
                  });
                }
                else {
                  fucusToAvailableNodeWith(event.currentTarget, 1);
                }
              }
              event.preventDefault();
              event.stopPropagation();
              break;
            case 40: // down
              fucusToAvailableNodeWith(event.currentTarget, 1);
              event.preventDefault();
              event.stopPropagation();
              break;
          }
        };

        function fucusToAvailableNodeWith(currentNode, step) {
          var currentIndex, ctaArray;
          ctaArray = $scope.treeSelectionHelper.getClickableNodes();
          currentIndex = ctaArray.indexOf(currentNode);
          ctaArray[(currentIndex + ctaArray.length + step) % ctaArray.length].focus();
        }

        /**
         * Node keyboard event listener on keyup
         * @param event
         * @param node
         */
        $scope.onTreeItemKeyup = function (event, node) {
          if (event.keyCode === 13 || event.keyCode === 32) {
            $scope.labelSelect(node);
          }
        };

        /**
         * This method is used by the Template to get node CSS class
         * @param node
         */
        $scope.getNodeSelectionClass = function (node) {
          var css = '';

          // See if this node is selected
          if (treeHelper.getSelectModelValue($scope, node)) {
            css = 'selected';
          } else {
            css = '';
          }

          // If this node is selectable
          if (typeof $scope.selectableModel === 'undefined' ||
            typeof node[$scope.selectableModel] === 'undefined' ||
            (typeof node[$scope.selectableModel] === 'boolean' && node[$scope.selectableModel])) {
            css += ' bento-selectable';
          }

          // If this node is disabled
          if (node.disabled) {
            css += ' bento-tree-disabled';
          }

          return css;
        };

        /**
         * Expand or Collapse a branch
         */
        $scope.toggleSelect = function (node) {
          node.collapsed = !node.collapsed;
          fireCollapseCallback(node);
        };

        function fireCollapseCallback(node) {
          if (!node.collapsed) {
            // Make sure if the callback exists
            if (typeof $scope.expandingCallback !== 'undefined' && $scope.expandingCallback) {
              $scope.expandingCallback(node);
            }
          } else {
            // Make sure if the callback exists
            if (typeof $scope.collapsingCallback !== 'undefined' && $scope.collapsingCallback) {
              $scope.collapsingCallback(node);
            }
          }
        }

        /**
         * not used at the moment
         */
        $scope.loadMore = function () {
          $scope.limitAmount += 20;
          treeHelper.adjustMinWidth($element);
        };

        /**
         * Clean memory
         */
        $scope.$on('$destroy', function (event) {
          if ($element.hasClass('bento-tree-root')) {
            $scope.treeSelectionHelper.clearNodes($scope.node, $scope.nodeChildren);
          }

          treeHelper.adjustMinWidth($element);
        });
      }
    ])

    /**
     * Directive for lazy loading
     */
    .directive('lastWatch', [
      '$timeout',
      function ($timeout) {
        return {
          restrict: 'A',
          link    : function (scope) {
            scope.$watch('$last', function (value) {
              if (value) {
                $timeout(function () {
                  scope.$parent.loadMore();
                });
              }
            });
          }
        };
      }
    ]);
}(window.angular));

(function (window, angular, undefined) {
  'use strict';

  /**
   * @ngdoc directive
   * @name bentoWizrd
   * @description
   *
   * # bentoWizrd
   *
   * The `bentoWizrd` directive provides directive objects to mimic off canvas menue behavior.
   *
   *   */

    // Global setting variables

  var GAP = 37;  // in pixels
  var WINDOW_RESIZE_DELAY = 300; // in milliseconds
  var MAX_STEP_BOX_WIDTH = 350; // in pixels
  var STEP_PADDING = 0;  // in pixels
  var TRANSITION_DURATION = 200; // in ms

// Define bentoUI App object
  angular.module('bento.wizard', ['ui.bootstrap', 'bento.services', 'bento.cookie', 'bento.translate'])
    .controller('wizardMainController', ['$scope', '$rootScope', '$element',
      function ($scope, $rootScope, $element) {
        // initialize variables
        $scope.isLeftArrowDisabled = true;
        $scope.isRightArrowDisabled = true;

        $element.addClass('bento-wizard');

        // Add SR content HTML
        $scope.wizardDesciption = angular.element('<span tabindex="0" class="sr-only">{{\'BENTO_UI_WIZARD_DESCRIPTION\' | bentoTranslate}}</span>');

        // For a controller to control to assign the current step
        // to this wizard directive
        if (typeof $scope.currentStep === 'undefined') {
          // Default current step to 0
          $scope.currentStep = 0;
        }
        $scope.previousStep = 0;

        // Set side-arrows true by default
        $scope._useSideArrows = !!(typeof $scope.useSideArrows === 'undefined' || $scope.useSideArrows === 'true');

        // Left and Right Arrow clicks
        $scope.onLeftArrowClick = function () {
          var scrollPane = $scope.$ul[0].parentElement;
          // Can scroll the whole pane
          if ($scope.leftIndex >= $scope.displayCount) {
            $scope.leftIndex = $scope.leftIndex - $scope.displayCount;
          }
          // Scroll to 0
          else {
            $scope.leftIndex = 0;
          }

          $scope.scrollLeftTo(scrollPane, $scope.leftIndex);
          $scope.updateLeftRightArrows();
        };

        $scope.onRightArrowClick = function () {
          var scrollPane = $scope.$ul[0].parentElement;
          // Can scroll the whole pane
          if (($scope.numSteps - $scope.leftIndex - $scope.displayCount) >= $scope.displayCount) {
            $scope.leftIndex = $scope.leftIndex + $scope.displayCount;
          }
          // Scroll all the way to the right
          else {
            $scope.leftIndex = $scope.numSteps - $scope.displayCount;
          }

          $scope.scrollLeftTo(scrollPane, $scope.leftIndex);
          $scope.updateLeftRightArrows();
        };

        // Watch step disabled states
        $scope.$watchCollection(
          function () {
            var states = [],
                children;

            if ($scope.$ul) {
              children = $scope.$ul.children();
              for (var i = 0, len = children.length; i < len; i++) {
                states.push(children[i].getAttribute('disabled'));
              }
            }

            return states;
          },
          function (states) {
            var children;

            if ($scope.$ul) {
              children = $scope.$ul.children();
            }

            for (var i = 0, len = states.length; i < len; i++) {
              if (states[i]) {
                children[i].removeAttribute('tabindex');
              } else {
                children[i].setAttribute('tabindex', 0);
              }
            }
          }
        );

        // Watch step states
        $scope.$watch(function () {
          var steps      = $element[0].querySelectorAll('.bento-wizard-step'),
              step,
              // true: enabled
              // false: disabled
              // .p: previous button
              // .n: next button
              stepStates = {p: true, n: true};

          //Check previous
          if ($scope.currentStep > 0 && steps[$scope.currentStep - 1]) {
            stepStates.p = steps[$scope.currentStep - 1].getAttribute('disabled') == undefined;
          } else {
            stepStates.p = true;
          }

          //Check next
          if ($scope.currentStep < steps.length - 1 && steps[$scope.currentStep + 1]) {
            stepStates.n = steps[$scope.currentStep + 1].getAttribute('disabled') == undefined;
          } else {
            stepStates.n = true;
          }

          return stepStates;

        }, function (stepStates) {
          // Set button disabled states

          $scope.buttonNextDisabled = !stepStates.n;
          $scope.buttonPreviousDisabled = !stepStates.p;
        }, true);

        // Previous and Next button clicks
        $scope.onPreviousClick = function () {
          if ($scope.currentStep === 0) {
            return;
          }

          $scope.isUserAction = true;
          $scope.currentStep = parseInt($scope.currentStep, 10) - 1;
          // focus on the main content
          $scope.content[0].focus();
        };

        $scope.onNextClick = function () {
          if ($scope.currentStep === $scope.stepList.length - 1) {
            return;
          }

          $scope.isUserAction = true;
          $scope.currentStep = parseInt($scope.currentStep, 10) + 1;
          // focus on the main content
          $scope.content[0].focus();
        };

        // Done button click
        $scope.onDoneClick = function () {
          $scope.isUserAction = true;
          $scope.onFinish();
        };

        // A step is clicked on the top step nav
        $scope.onStepClick = function (step) {

          // ignore the step that is already selected
          if (step === $scope.currentStep) {
            return;
          }

          $scope.isUserAction = true;
          $scope.currentStep = step;
        };

      }])
    .directive('bentoWizard', [
      '$compile',
      '$timeout',
      '$window',
      '$log',
      '$bentoServices',
      function ($compile, $timeout, $window, $log, $bentoServices) {
        return {
          restrict  : 'AEC',
          replace   : false,
          scope     : {
            onChange              : '&',  // Fire onChange() when a wizard step is changed.
            onFinish              : '&',  // Fire onFinish() when the whole wizard is finished
            onCancel              : '&',  // Fire onCancel() when the "Cancel" button is clicked
            useSideArrows         : '@',  // Check if we need to use arrows
            currentStep           : '=?', // Listen to step value change
            totalStep             : '=?', // Expose the total number of steps
            demoMode              : '@',  // A mode to disable focus
            isDoneButtonDisabled  : '&',  // Expose showButtonDone
            hideDefaultButtons    : '&',  // Hide "Previous", "Next" and "Done" buttons
            hidePreviousButton    : '&',  // Hide "Previous" button
            hideNextButton        : '&',  // Hide "Next" button
            hideDoneButton        : '&',  // Hide "Done" button
            showCancelButton      : '&',  // Show "Cancel" button
            isCancelButtonDisabled: '&',  // Disable "Cancel" button
          },
          controller: 'wizardMainController',
          link      : function (scope, element) {
            // This flag is used when a use dynamically change the currentStep and return false
            // onChange() So that the updateStep() doesn't fire in the watch
            var isCurrentSetpReset = false;
            // For windows resize
            var resizeTimeout = 0;
            scope.isUserAction = false;

            element.addClass('ng-hide');

            // Render wizard when all rendering is done
            $timeout(function () {

              // Basic rendering
              // update the step layouts the first time
              $timeout(renderStepWidth, 1);
              // need to re-render the second path in case the scroll bar showed/hided
              $timeout(renderStepWidth, 2);

              // Watch element width and render it's width
              angular.element($window).on('resize', onWindowResize);

              // localization
              var cancelButtonLabel = "{{ 'BENTO_UI_WIZARD_BUTTON_CANCEL' | bentoTranslate }}";
              var nextButtonLabel = "{{ 'BENTO_UI_WIZARD_BUTTON_NEXT' | bentoTranslate }}";
              var previousButtonLabel = "{{ 'BENTO_UI_WIZARD_BUTTON_PREVIOUS' | bentoTranslate }}";
              var doneButtonLabel = "{{ 'BENTO_UI_WIZARD_BUTTON_DONE' | bentoTranslate }}";
              var cancelButtonLabelDescription = "{{ 'BENTO_UI_WIZARD_BUTTON_CANCEL_DESCRIPTION' | bentoTranslate }}";
              var nextButtonLabelDescription = "{{ 'BENTO_UI_WIZARD_BUTTON_NEXT_DESCRIPTION' | bentoTranslate }}";
              var previousButtonLabelDescription = "{{ 'BENTO_UI_WIZARD_BUTTON_PREVIOUS_DESCRIPTION' | bentoTranslate }}";
              var doneButtonLabelDescription = "{{ 'BENTO_UI_WIZARD_BUTTON_DONE_DESCRIPTION' | bentoTranslate }}";

              // Content pointers
              scope.content = angular.element(element[0].querySelector('.contents'));
              scope.contents = scope.content.children();

              // Add cancel button
              var buttonCancel = angular.element(
                '<button role="button" class="btn btn-cancel btn-default btn-action pull-left" ' +
                'role="button" aria-label="' + cancelButtonLabelDescription + '" ' +
                'title="' + cancelButtonLabelDescription + '"' +
                'ng-click="onCancel({step:currentStep})" ' +
                'ng-if="!hideDefaultButtons() && showCancelButton()" ' +
                'ng-disabled="isCancelButtonDisabled()"' +
                'bento-test="button-cancel"' +
                '>' +
                cancelButtonLabel +
                '</button>'
              );

              // Add previous and next buttons
              var buttonNext = angular.element(
                '<button role="button" class="btn btn-next btn-primary btn-action pull-right" ' +
                'role="button" aria-label="' + nextButtonLabelDescription + '" ' +
                'title="' + nextButtonLabelDescription + '"' +
                'ng-show="showButtonNext" ng-click="onNextClick()" ' +
                'ng-if="!hideDefaultButtons() && !hideNextButton()" ' +
                'ng-disabled="buttonNextDisabled"' +
                'bento-test="button-next"' +
                '>' +
                nextButtonLabel +
                ' <i class="bento-icon-chevron-right"></i></button>'
              );
              var buttonPrevious = angular.element(
                '<button role="button" class="btn btn-previous btn-default pull-right" ' +
                'role="button" aria-label="' + previousButtonLabelDescription + '" ' +
                'ng-show="showButtonPrevious" ng-click="onPreviousClick()" ' +
                'title="' + previousButtonLabelDescription + '"' +
                'ng-if="!hideDefaultButtons() && !hidePreviousButton()" ' +
                'ng-disabled="buttonPreviousDisabled"' +
                'bento-test="button-previous">' +
                '<i class="bento-icon-chevron-left"></i> ' +
                previousButtonLabel +
                '</button>'
              );
              var buttonDone = angular.element(
                '<button class="btn btn-primary btn-action pull-right" ' +
                'role="button" aria-label="' + doneButtonLabelDescription + '"' +
                'title="' + doneButtonLabelDescription + '"' +
                'ng-disabled="isDoneButtonDisabled()"' +
                'ng-show="showButtonDone" ng-click="onDoneClick()"' +
                'ng-if="!hideDefaultButtons() && !hideDoneButton()" ' +
                'bento-test="button-done"' +
                '>' +
                doneButtonLabel +
                '</button>'
              );
              scope.$buttonNext = buttonNext;
              scope.$buttonPrevious = buttonPrevious;
              scope.$buttonDone = buttonDone;

              // Add top left and right arrows
              var arrowLeft = angular.element(
                '<button class="wizard-arrow arrow-left"' +
                ' role="button" aria-label="Left Arrow"' +
                ' alt="Show previous step headers"' +
                ' ng-disabled="isLeftArrowDisabled"' +
                ' tabindex="-1"' +
                ' ng-click="onLeftArrowClick()">' +
                ' <i class="bento-icon-chevron-large-left"></i>' +
                '</button>'
              );
              var arrowRight = angular.element(
                '<button class="wizard-arrow arrow-right"' +
                ' role="button" aria-label="Right Arrow"' +
                ' alt="Show next step headers"' +
                ' ng-disabled="isRightArrowDisabled"' +
                ' tabindex="-1"' +
                ' ng-click="onRightArrowClick()">' +
                ' <i class="bento-icon-chevron-large-right"></i>' +
                '</button>'
              );

              scope.$arrowLeft = arrowLeft;
              scope.$arrowRight = arrowRight;
              // Compile description
              $compile(scope.wizardDesciption)(scope);

              // Compile ng-clicks
              $compile(buttonCancel)(scope);
              $compile(buttonDone)(scope);
              $compile(buttonNext)(scope);
              $compile(buttonPrevious)(scope);
              $compile(arrowLeft)(scope);
              $compile(arrowRight)(scope);

              // POST DOM injection
              // Update model reference to be used in controller
              scope.$ul = angular.element(element[0].querySelector('.steps'));
              scope.stepList = scope.$ul.children();

              // Add the two buttons to content
              scope.content.after(buttonPrevious);
              scope.content.after(buttonDone);
              scope.content.after(buttonNext);
              scope.content.after(buttonCancel);
              scope.$ul.after(arrowLeft);
              scope.$ul.after(arrowRight);
              scope.$ul.attr('tabindex', -1);

              // Add description
              scope.$ul[0].parentElement.insertBefore(scope.wizardDesciption[0], scope.$ul[0]);

              // Add CSS class to the main container
              element.addClass('bento-wizard');

              // Assign Step Class Name with bento-wizard name spage
              scope.$ul.wrap('<div class="bento-wizard-steps" role="tablist"/>');

              processSteps();

              // Add scope.$ul keyboard listeners
              scope.$ul[0].addEventListener('keydown', function (event) {
                switch (event.keyCode) {
                  // Space & Enter
                  case 32:
                  case 13:
                    event.stopPropagation();
                    event.preventDefault();
                    break;
                }
              });

              // Add scope.$ul keyboard listeners
              scope.$ul[0].addEventListener('keyup', function (event) {
                switch (event.keyCode) {
                  // Space & Enter
                  case 32:
                  case 13:
                    onStepClick(event, true);
                    event.stopPropagation();
                    event.preventDefault();
                    break;
                  // Tab & shift-tab
                  case 9:
                  case 16:
                    var boxWidth  = scope.$ul.children()[0].offsetWidth,
                        leftCount = Math.round(scope.$ul[0].parentElement.scrollLeft / boxWidth);

                    scope.leftIndex = leftCount;
                    scope.updateLeftRightArrows();
                    break;
                }
              });

              // Add click event listeners to steps
              //scope.stepList.on('click', onStepClick);

              // init buttons
              scope.showButtonNext = (scope.stepList.length !== 1);
              scope.showButtonPrevious = false;
              scope.showButtonDone = (scope.stepList.length === 1);

              // setup content
              scope.content.attr('tabindex', -1);

              // Start to watch the currentStep variable change and
              // update wizards GUI
              scope.$watch('currentStep', function (newValue, oldValue) {
                scope.previousStep = oldValue;
                if (!isCurrentSetpReset) {
                  updateStep();
                } else {
                  isCurrentSetpReset = false;
                }
              });

              // Watch the count to the steps to see if there is anything changed
              var ulChildren = scope.$ul.children();
              scope.$watch(
                function () {
                  setTimeout(function () {
                    // Custom watch - gets fired for watch digest cycle but needs to be after
                    // rendering

                    // As reported on HUB issue #1
                    // https://thehub.thomsonreuters.com/thread/127898?sr=stream&ru=1145180
                    // New algorithm is implemented to reslove this issue when dynamic array had the
                    // same size when changing
                    var newUlChildren     = scope.$ul.children(),
                        i, len, hasChange = false;

                    if (ulChildren.length !== newUlChildren.length) {
                      ulChildren = newUlChildren;
                      hasChange = true;
                    } else {
                      for (i = 0, len = ulChildren.length; i < len; i++) {
                        if (ulChildren[i] !== newUlChildren[i]) {
                          ulChildren = newUlChildren;
                          hasChange = true;
                          break;
                        }
                      }
                    }

                    if (hasChange) {

                      // Update step length
                      scope.totalStep = ulChildren.length;

                      // Update Step List
                      updateStep();

                      // Add event listeners and classes to newly restored steps
                      processSteps();

                      // Need to re-render the width of the steps when adding or removing a step
                      renderStepWidth();
                    }

                  });

                  // return dummy
                  return 0;
                },
                function () {
                });

              // Skin steps
              function processSteps() {
                var stepHeaderHTML = '<div class="sr-only">{{\'BENTO_UI_WIZARD_STEP_NAME\' | bentoTranslate}}' +
                  '</div><div class="bento-wizard-step-count"></div>';
                // insert prefix number to a step <li> where it's not initialized
                for (var i = 0; i < scope.stepList.length; i++) {
                  var $li = angular.element(scope.stepList[i]);
                  if (!$li.hasClass('bento-wizard-step')) {
                    $li.addClass('bento-wizard-step');
                    $li.attr('role', 'tab');
                    // add counter and screen reader
                    $li.prepend($compile(angular.element(stepHeaderHTML))(scope));
                    // Add click event handler
                    $li.on('click', onStepClick);
                  }
                }
              }

              // Click function
              function onStepClick(event, target) {
                var currentTarget = target ? event.target : event.currentTarget;
                // ignore the click even if this step is disabled
                if (currentTarget.getAttribute('disabled')) {
                  return;
                }

                var index = 0;
                for (var i = 0; i < scope.stepList.length; i++) {
                  if (scope.stepList[i] === currentTarget) {
                    index = i;
                    break;
                  }
                }

                scope.onStepClick(index);
                scope.$apply();

                // Focus on the content after selection
                scope.content[0].focus();
              }

              // Show the whole module
              element.removeClass('ng-hide');
            }); // End of $timeout

            // Private function
            function updateStep() {
              var step = parseInt(scope.currentStep, 10);

              // Make sure the new step is a number
              step = isNaN(step) ? 0 : step;

              // Update the step and content references
              scope.stepList = scope.$ul.children();
              scope.contents = scope.content.children();

              // Reset currentStep if it is out of range
              if (scope.currentStep >= scope.stepList.length) {
                scope.currentStep = scope.stepList.length - 1;
              }

              // Fire event and forward step variable over
              if (typeof scope.onChange !== 'undefined' && scope.isUserAction) {
                if (scope.onChange({step: step}) === false) {
                  // Bypassed wizard update by user
                  step = scope.currentStep = scope.previousStep;
                  isCurrentSetpReset = true;
                }

                scope.isUserAction = false;
              }

              var previous$li;
              for (var i = 0; i < scope.stepList.length; i++) {
                var $li = angular.element(scope.stepList[i]);
                $li.removeClass('previous');
                if (i === step) {
                  $li.addClass('selected');
                  if (typeof previous$li !== 'undefined') {
                    previous$li.addClass('previous');
                  }
                } else {
                  $li.removeClass('selected');
                }

                previous$li = $li;
              }

              previous$li = null;

              // show & hide buttons
              scope.showButtonNext = !!((scope.stepList.length > 1) && (step < scope.stepList.length - 1));
              scope.showButtonPrevious = !!((scope.stepList.length > 1) && (step > 0));
              scope.showButtonDone = !!((scope.stepList.length === 1) || (step === scope.stepList.length - 1));

              // show & hide contents
              for (var j = 0; j < scope.contents.length; j++) {
                var $content = angular.element(scope.contents[j]);
                if (j === step) {
                  $content.removeClass('ng-hide');
                } else {
                  $content.addClass('ng-hide');
                }
              }

              updateStepContainerOffset();
            }

            // Update step location
            function updateStepContainerOffset() {
              scope.currentStep = parseInt(scope.currentStep, 10);

              if (isNaN(scope.currentStep)) {
                $log.warn('Wizard: `current-step` is not an integer ');
                scope.currentStep = 0;
              }

              // Variables to be used for calculation
              var offsetWidth       = (element.hasClass('side-arrows')) ?
                element[0].offsetWidth - GAP * 2 : element[0].offsetWidth,
                  stepArray         = scope.stepList,
                  scrollPane        = scope.$ul[0].parentElement,
                  currentScrollLeft = scrollPane.scrollLeft,
                  previousObj       = (scope.currentStep === 0) ?
                    null :
                    stepArray[scope.currentStep - 1],
                  currentStepObj    = stepArray[scope.currentStep],
                  nextObj           = (scope.currentStep === stepArray.length - 1) ?
                    null :
                    stepArray[scope.currentStep + 1],
                  left              = (previousObj) ?
                    previousObj.offsetLeft - currentScrollLeft :
                    0,
                  right             = (nextObj) ?
                    offsetWidth - nextObj.offsetLeft - nextObj.offsetWidth + currentScrollLeft :
                    0;

              // to delete
              var currentLeft = currentStepObj.offsetLeft;
              var currentRight = offsetWidth - currentStepObj.offsetLeft - currentStepObj.offsetWidth + currentScrollLeft;

              // find the left index
              scope.leftIndex = 0;
              for (var i = 0; i < stepArray.length; i++) {
                var step = stepArray[i];
                if (step.offsetLeft <= currentScrollLeft && step.offsetLeft + step.offsetWidth > currentScrollLeft) {
                  scope.leftIndex = i;
                  break;
                }
              }

              // Better UX
              // Check if the next or the previous step object is out side of the OL
              // Bring it bring if not
              if (left < 0) {
                scope.leftIndex = scope.currentStep - 1;
              } else if (right < 0) {
                scope.leftIndex = scope.currentStep + 2 - scope.displayCount;
              }

              // Again double check if the current object is in the container viewport or not
              // If not, bring it in.
              if (currentLeft < currentScrollLeft && scope.leftIndex > 0) {
                scope.leftIndex = scope.currentStep;

              } else if (currentRight < 0) {
                scope.leftIndex = scope.currentStep - scope.displayCount + 1;
              }

              scope.scrollLeftTo(scope.$ul[0].parentElement, scope.leftIndex);

              scope.updateLeftRightArrows();
            }

            // Render boxes' width
            function renderStepWidth() {
              var width = element[0].offsetWidth;

              // Set the total step object to be displayed
              // in wizard viewport based on its width
              var numSteps = scope.stepList.length;
              var displayCount = (numSteps > 4) ? 4 : numSteps; // Default step count

              // Refine displayCount based on the width and numSteps
              if (width < 720 && displayCount > 2) {
                displayCount = 2;
              } else if (width < 960 && displayCount > 3) {
                displayCount = 3;
              } else if (MAX_STEP_BOX_WIDTH * displayCount + (displayCount - 1 ) * STEP_PADDING < width &&
                numSteps > displayCount) {
                displayCount = Math.ceil(width / MAX_STEP_BOX_WIDTH);
              }

              // Update displayCount for controller to use
              scope.displayCount = displayCount;
              // Add numSteps for controller to use
              scope.numSteps = numSteps;

              if (scope._useSideArrows) {
                if (displayCount < numSteps) {
                  element.addClass('side-arrows');
                  width = element[0].offsetWidth - GAP * 2;
                } else {
                  element.removeClass('side-arrows');
                }
              }

              // Set list container width based on the total step count
              // and their widths
              var boxWidth = (width - (displayCount - 1) * STEP_PADDING) / displayCount;
              scope.stepList = scope.$ul.children();

              //Cap the step box width
              if (numSteps == displayCount &&
                MAX_STEP_BOX_WIDTH * numSteps < width - 100 &&
                boxWidth > MAX_STEP_BOX_WIDTH
              ) {
                boxWidth = MAX_STEP_BOX_WIDTH;
              }

              scope.$ul.css('width', (scope.stepList.length * (boxWidth + STEP_PADDING)) + "px");
              scope.stepList.css('width', boxWidth + 'px');

              //Reset all height classes
              //angular.element(scope.stepList).removeClass('flat');
              angular.element(scope.stepList).removeClass('narrow');
              //scope.$arrowLeft.removeClass('flat');
              //scope.$arrowRight.removeClass('flat');

              //if (boxWidth > 310) {
              angular.element(scope.stepList).addClass('flat');
              scope.$arrowLeft.addClass('flat');
              scope.$arrowRight.addClass('flat');
              //} else if (boxWidth < 220) {
              // angular.element(scope.stepList).addClass('narrow');
              //}

              updateStepContainerOffset();
            }

            // Enable and Disable left and right arrows based on current
            // step position
            scope.updateLeftRightArrows = function () {

              if (typeof scope.displayCount === 'undefined') {
                return;
              }

              if (scope.leftIndex === 0) {
                scope.$arrowLeft.attr('disabled', 'disabled');
              } else {
                scope.$arrowLeft.removeAttr('disabled');
              }

              if (scope.leftIndex + scope.displayCount >= scope.numSteps) {
                scope.$arrowRight.attr('disabled', 'disabled');
              } else {
                scope.$arrowRight.removeAttr('disabled');
              }

              angular.element(scope.stepList).removeClass('most-right');

              if (element[0].offsetWidth <= scope.displayCount * MAX_STEP_BOX_WIDTH) {
                angular.element(scope.stepList[scope.leftIndex + scope.displayCount - 1]).addClass('most-right');
              }
            };

            // Scroll Animation for the header
            var initScrollLeft,
                dScrollLeft,
                scrollStartTime,
                targetScrollLeft
            ;

            scope.scrollLeftTo = function (scrollPane, toLeftIndex) {
              initScrollLeft = scrollPane.scrollLeft;
              targetScrollLeft = scope.$ul.children()[0].offsetWidth * toLeftIndex;
              dScrollLeft = targetScrollLeft - initScrollLeft;
              scrollStartTime = new Date();

              scrollAnimate(scrollPane);
            };

            // Quad transition
            function scrollAnimate(scrollPane) {
              var currentTime = new Date(),
                  dTimeRatio  = Math.pow((currentTime.getTime() - scrollStartTime.getTime()) / TRANSITION_DURATION - 1, 3) + 1, // (x-1)^3 + 1
                  dScroll     = dScrollLeft * dTimeRatio;

              if (Math.abs(targetScrollLeft - scrollPane.scrollLeft) < 3) {
                scrollPane.scrollLeft = initScrollLeft + dScrollLeft;
              } else {
                scrollPane.scrollLeft = initScrollLeft + dScroll;
                $bentoServices.rAF(function () {
                  scrollAnimate(scrollPane);
                })
              }
            }

            // Window resize function
            function onWindowResize() {
              // Set a timeout to minimize performance issue
              $timeout.cancel(resizeTimeout);
              resizeTimeout = $timeout(renderStepWidth, WINDOW_RESIZE_DELAY);
            }

            // Destroy with garbage collection
            scope.$on('$destroy', function () {
              //remove window listener
              angular.element($window).off('resize', onWindowResize);
            });

          }
        };
      }]);
})(window, window.angular);

(function(angular, undefined) {
  'use strict';

  angular
    .module('bento.progressbar', [
      'bento.services',
    ])
    .controller('BentoProgressbarController', ['$scope',
      function($scope) {
        $scope.$watch('value', function(val) {
          $scope.dynamic = val;
        }, true)
        $scope.$watch('type', function(val) {
          $scope.barType = val;
        }, true)
      }
    ])
    .directive('bentoProgressbar', [
      function() {
        return {
          restrict: 'EA',
          scope: {
            value: '=',
            animate: '=',
            type: '='
          },
          templateUrl: '../templates/progressbar/bento-progressbar.html',
          controller: 'BentoProgressbarController',
          link: function(scope, element, attrs) {
            console.warn('bento-progressbar: Warning! This directive has been deprecated. Please use uib-progressbar instead. Please see Bento 1.3.0 changelog for more info.');
          }
        };
      }
    ])
})(window.angular);
(function (window, angular, undefined) {

  "use strict";

  angular.module('bento.append.to.parent', ['bento.services'])
    .directive('bentoAppendToParent', ['$log', '$bentoServices', function ($log, $bentoServices) {
      return {
        link: function(scope, element, attrs, ctrl) {

          /*
          * flag to make sure its not appended to the parent element more than once
          */
          var elementAttached = false;

          /*
          * The element where 'append-to-parent' is added
          */
          var thisElement = element[0];

          /*
          * Patch for IE 9 - If the appendToContainer's position is static, need to make it relative.
          */
          var oldAppendToContainerPosition = "";

          var appendTo = attrs.bentoAppendToParent;
          if(appendTo.length <= 0) { //default it to body
            appendTo = "body";
          }

          var appendToContainer = document.querySelector(appendTo);
          if(!appendToContainer) { //to make it work between site and dev
            appendTo = "body";
            appendToContainer = document.querySelector(appendTo);
          }

          /*
          * This element holds/contains the list element (ul/ol)
          */
          var listContainerElement = element[0].querySelector('.bento-append-to-parent');
          if(!listContainerElement || listContainerElement === undefined) {
            $log.warn('bento-append-to-parent: Container class does not have "bento-append-to-parent" class');
            return;
          }else{
            //reset it since it could be a directive with "replace=true;"
            listContainerElement = null;
          }

          /*
          * Directive along with its used will emit 'append_to_parent_show_list' event when the list needs to be shown or hidden
          */
          scope.$on("append_to_parent_show_list", function (e, flag, id) {
            if(typeof flag !== 'boolean') {
              $log.warn('bento-append-to-parent: "append_to_parent_show_list" flag needs to be boolean');
              return;
            }

            if(!listContainerElement){
              listContainerElement = element[0].querySelector('.bento-append-to-parent');
            }

            if(id && listContainerElement.getAttribute('id') != id){
              // Do nothing when the element ids don't match
              return;
            }

            if(flag) { //list is visible
              updateContainerPosition();
            } else { //list is hidden
              resetContainerPosition();
            }
          });

          window.addEventListener('resize', onWindowResize); // resize - event listener
          function onWindowResize(event) {
            if(listContainerElement && listContainerElement.style.zIndex === 10) {
              updateContainerPosition();
            }
          }

          /*
          * 1. Append list container element to its parent (specified by append-to-parent)
          * 2. Calculate list container element's placement position when it needs to be shown
          */
          function updateContainerPosition() {
            var rect = thisElement.getBoundingClientRect();
            var appendToContainerRect = appendToContainer.getBoundingClientRect();

            if(!listContainerElement){
              listContainerElement = element[0].querySelector('.bento-append-to-parent');
            }

            listContainerElement.style.top = ((rect.top+rect.height-appendToContainerRect.top)-2)+'px';
            listContainerElement.style.left = rect.left-appendToContainerRect.left+'px';
            listContainerElement.style.right = 'auto';
            listContainerElement.style.minWidth = rect.width+'px';
            listContainerElement.style.zIndex = 10;

            // Dropdown menu alignments
            if(element.hasClass('dropdown-menu-left')) {
              angular.element(listContainerElement).addClass('dropdown-menu-left');
            }else if(element.hasClass('dropdown-menu-right')) {
              angular.element(listContainerElement).addClass('dropdown-menu-right');
              listContainerElement.style.left = 'auto';
              listContainerElement.style.right = appendToContainerRect.right-rect.right+'px';
            } else if(element.hasClass('dropdown')) {
              listContainerElement.style.left = rect.left+rect.width/2-appendToContainerRect.left+'px';
              listContainerElement.style.top = ((rect.top+rect.height-appendToContainerRect.top)+10)+'px';
            }

            if(!elementAttached) { //logic to attach only once

              // Check if the browser is IE 9
              if ($bentoServices.getIEVersion() === 9) {
                var style = window.getComputedStyle(appendToContainer, null);

                if(style.position.length <= 0 || style.position === 'static') {
                  oldAppendToContainerPosition = style.position;
                  appendToContainer.style.position = 'relative';
                }
              }

              appendToContainer.appendChild(listContainerElement);
              elementAttached = true;
            }
          }

          /*
          * reset all style
          */
          function resetContainerPosition() {

            // Skip this function when `listContainerElement` is not ready
            if(typeof listContainerElement == 'undefined' || !listContainerElement){
              return
            }

            listContainerElement.style.top = "-6999px";
            listContainerElement.style.left = "-6999px";
            listContainerElement.style.width = "auto";
            listContainerElement.style.zIndex = -999;
          }

          /*
          * Remove the child when the directive is destroyed.
          * Otherwise if attached to 'body', duplicate children (zombies) will
          * be seen when the body element is inspected.
          */
          scope.$on('$destroy', function() {
            window.removeEventListener('resize', onWindowResize);
            if(elementAttached && appendToContainer) {
              appendToContainer.removeChild(listContainerElement);

              // Check if the browser is IE 9
              if ($bentoServices.getIEVersion() === 9) {
                appendToContainer.style.position = oldAppendToContainerPosition;
              }
            }
          });

        } //link
      }; //return

    }]); //bentoAppendToBody directive
})(window, window.angular);
(function (window, angular, undefined) {

  'use strict';

  angular.module('bento.dropdown.append.to.parent', [])


  /**
   * Directive declaration
   */
    .directive('bentoDropdownAppendToParent', [
      '$timeout',
      function ($timeout) {
        return {
          require: '^uibDropdown',
          link: function (scope, element, attrs, dropdownCtrl) {

            var listContainerElement = angular.element(element[0].querySelector('.dropdown-menu'));

            if(listContainerElement) {
              listContainerElement.addClass('bento-append-to-parent');
              $timeout(function(){
                if(listContainerElement){
                  listContainerElement.css('min-width','');
                }
              })

            }

            scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
              if(typeof isOpen === 'boolean') {
                scope.$emit("append_to_parent_show_list", isOpen);
                if (isOpen){
                  listContainerElement.addClass('show');
                }else{
                  listContainerElement.removeClass('show');
                }
              }
            });

            // Garbage collection
            element.on('$destroy',function(){
              if(listContainerElement){
                var el = listContainerElement[0];
                if(el.parentNode){
                  el.parentNode.removeChild(el);
                  listContainerElement = null;
                }
              }
            });
          }
        };
      }]);
})(window, window.angular);

(function (window, angular, undefined) {
  'use strict';

  angular.module('bento.alert', ['bento.services', 'bento.translate'])

    .controller('BentoAlertController', [
      '$scope',
      '$element',
      '$timeout',
      '$bentoServices',
      function ($scope, $element, $timeout, $bentoServices) {
        var controller = this;
        // Access through controller
        controller.closeBentoAlert = function (alert) {

          var index = $scope.bentoAlertObject.indexOf(alert),
              a     = $element[0].querySelector('div[rel="bento-alert-' + index + '"]'),
              el
          ;

          /* Update focus */
          // Will be no more alerts
          if ($scope.bentoAlertObject.length === 1) {
            $scope.$container.attr('tabindex', '');
            if ($scope.activeElement) {
              $scope.activeElement.focus();
              $scope.activeElement = undefined;
            }
          }
          // Deleting that last alert
          else if (index === $scope.bentoAlertObject.length - 1) {
            el = $element[0].querySelector('div[rel="bento-alert-' + (index - 1) + '"] .alert > span');
          } else {
            el = $element[0].querySelector('div[rel="bento-alert-' + (index + 1) + '"] .alert > span');
          }

          // fire close callback function [BENTO-478]
          $scope.closeAlertCallback({$index: index});

          // A timeout event has already dismissed this alert
          // We skip everything...
          if (a && a.style) {
            a.style.height = a.offsetHeight + 'px';
            $timeout(function () {
              $scope.bentoAlertObject.splice(index, 1);
              el ? el.focus() : 0;
            });
          }
        };

        // From Link

        var container = $element[0].querySelector('.alert-container');
        $scope.$container = angular.element(container);

        $bentoServices.loopTabbables($scope.$container);

        getFirstScrollableParent();

        $scope.$on('$destroy', function () {
          document.removeEventListener('keydown', onDocumentKeydown);
        });

        document.addEventListener('keydown', onDocumentKeydown);

        function onDocumentKeydown(event) {
          // Will react to tab only
          if (event.keyCode === 9) {
            var children = $scope.$container.children();
            if (children.length > 0) {
              if (!(container === event.target || container.contains(event.target))) {
                container.setAttribute('tabindex', '-1');
                $scope.activeElement = document.activeElement;
                container.focus();
                event.preventDefault();
                event.stopPropagation();
              }
            }
          }
        }

        // Keyup to listen to delete and backspace
        $element[0].addEventListener('keydown', function (event) {
          var index;
          switch (event.keyCode) {
            // DEL and BackSpace
            case 46:
            case 8:
              var alertDoms = $element[0].querySelectorAll('.bento-alert-container');
              for (var i = 0, len = alertDoms.length; i < len; i++) {
                if (alertDoms[i].contains(document.activeElement)) {
                  controller.closeBentoAlert($scope.bentoAlertObject[i]);
                  event.stopPropagation();
                  event.preventDefault();
                  break;
                }
              }
              break;
            case 38: // Up Arrow Key
              index = getCurrentAlertFocusIndex();
              setFocusToAlert(
                (index === -1) ?
                  $scope.bentoAlertObject.length - 1
                  :
                  (index + $scope.bentoAlertObject.length - 1) % $scope.bentoAlertObject.length);
              event.preventDefault();
              break;
            case 40: // Down Arrow Key
              index = getCurrentAlertFocusIndex();
              setFocusToAlert(
                (index === -1) ?
                  0
                  :
                  (index + 1) % $scope.bentoAlertObject.length);
              event.preventDefault();
              break;
          }
        });

        function getCurrentAlertFocusIndex() {
          var alerts = $element[0].querySelectorAll('.bento-alert');
          for (var i = 0, len = alerts.length; i < len; i++) {
            if (alerts[i].contains(document.activeElement)) {
              return i;
            }
          }

          return -1;
        }

        function setFocusToAlert(index) {
          $element[0].querySelector('div[rel="bento-alert-' + index + '"] .alert > span').focus();
        }

        $scope.$watch('align', function () {
          if (!!$scope.align) {
            if ($scope.align === 'right') {
              container.className = 'alert-container right';
            } else if ($scope.align === 'left') {
              container.className = 'alert-container left';
            } else {
              container.className = 'alert-container';
            }
          }
        });

        // Find the first parent that scrolls
        function getFirstScrollableParent(domEl) {
          var style = window.getComputedStyle(document.querySelector('html'));
        }

        // Update body scrolling position
        function updateScrollingPosition(event) {
          var targetTop = 20;
          var scroll = getScroll();
          if (scroll.top < 90) {
            targetTop = 90 - scroll.top;
          }

          if (targetTop < 20) {
            targetTop = '20';
          }
          container.style.top = targetTop + 'px';
        }

      }
    ])
    .directive('bentoAlert', [
      '$bentoServices',
      function ($bentoServices) {
        return {
          restrict    : 'EA',
          controller  : 'BentoAlertController',
          controllerAs: 'bentoAlertCtrl',
          templateUrl : function (element, attrs) {
            return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/alerts/bento_alert_container.html';
          },
          scope       : {
            bentoAlertObject: '=',
            closeAlertCallback : '&bentoAlertClose',
            align           : '@'
          } //$scope
        }; //return
      } //function compile, timeout
    ])
    .directive('bentoAlertMessage', [
      '$timeout',
      '$compile',
      function ($timeout, $compile) {
        return {
          templateUrl: function (element, attrs) {
            return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/alerts/bento_alert.html';
          },
          require    : '^bentoAlert',
          replace    : true,
          scope      : {
            bentoAlertMessage     : '=',
            bentoAlertMessageIndex: '='
          },
          link       : function (scope, element, attr, controller) {
            // Original parent scope that declares Bento Alert
            var appScope = scope
                  .$parent // ng-repeat
                  .$parent // Bento Alert
                  .$parent,// App Scope
                // We need to compile the message content against the original Application scope
                message  = $compile(
                  '<span class="bento-alert-message-content" tabindex="0">' +
                  scope.bentoAlertMessage.msg + '</span>'
                )(appScope)
            ;

            // Prepend the compile message into the alert DOM
            angular.element(element[0].querySelector('.bento-alert')).prepend(message);

            // There is a timeout
            if (typeof scope.bentoAlertMessage.timeout !== 'undefined') {
              var alertTimeout = Number(scope.bentoAlertMessage.timeout);
              // Fire the timeout

              $timeout(function () {
                controller.closeBentoAlert(scope.bentoAlertMessage);
              }, alertTimeout); //timeout
            }

            // Close Bento Alert
            scope.closeBentoAlert = function () {
              controller.closeBentoAlert(scope.bentoAlertMessage);
            };
          }
        }
      }]);

  // helper class to get document scrolling
  function getScroll() {
    var doc = document.documentElement;
    var left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    return {top: top, left: left};
  }

})(window, window.angular);

function BentoScrollable(dom) {
  var s = this,
      topPadding,
      touchStart,
      touchEnd,
      touchMove;
  s.SCROLL_WIDTH = 10;
  s.dom = dom;
  s.init = init;
  s.onScroll = onScrollListener;
  s.render = render;
  s.height = height;
  s.callbackStack = [];

  // Private variables
  s._scrollTop = 0;
  s._scrollLeft = 0;
  s._domSize = {};
  s._scrollableSize = {};
  s.offsetTop = 0;
  s.needToPreventScroll = false;

  s.init();

  /**
   * setScrollable Height
   * @param containerHeight
   */
  function height(containerHeight) {
    if (typeof containerHeight !== 'undefined') {
      s.dom.style.height = [containerHeight, 'px'].join('');
    } else {
      return s.dom.offsetHeight;
    }
  }

  /**
   * Render scrollable pane and scrollbar when layouts change
   * @param width
   * @param height
   */
  function render(width, height, top) {
    topPadding = (typeof top !== 'undefined') ? top : topPadding
    s.offsetTop = top || s.offsetTop;
    s._scrollableSize.width = width;
    s._scrollableSize.height = height;
    s.hScrollRange = width - s.dom.offsetWidth;
    s.vScrollRange = height - s.dom.offsetHeight + topPadding + s.SCROLL_WIDTH;

    var domClassArray = s.dom.className.split(' ');

    // check if the content is smaller than scrollable
    s.hScrollRange = s.hScrollRange > 1 ? s.hScrollRange : 0;
    s.vScrollRange = s.vScrollRange > 1 ? s.vScrollRange : 0;

    // Horizontal
    if (s.hScrollRange <= 0) {
      if (domClassArray.indexOf('bento-scrollable-no-h') === -1) {
        domClassArray.push('bento-scrollable-no-h')
      }
      s.sbH.dom.style.display = 'none';
      s.dom.style.height = '100%';
      s.hScrollRange = width - s.dom.offsetWidth;
    } else {
      var index = domClassArray.indexOf('bento-scrollable-no-h');
      if (index > -1) {
        domClassArray.splice(index, 1);
      }
      s.dom.style.height = 'calc(100% - ' + s.SCROLL_WIDTH + 'px)';
      s.sbH.dom.style.display = 'block';
    }

    // Vertical
    if (s.vScrollRange <= 0) {
      if (domClassArray.indexOf('bento-scrollable-no-v') === -1) {
        domClassArray.push('bento-scrollable-no-v')
      }
      s.sbV.dom.style.display = 'none';
      s.dom.style.width = '100%';
      s.vScrollRange = height - s.dom.offsetHeight + s.offsetTop + s.SCROLL_WIDTH;
    } else {
      var index = domClassArray.indexOf('bento-scrollable-no-v');
      if (index > -1) {
        domClassArray.splice(index, 1);
      }
      s.sbV.dom.style.display = 'block';
      s.dom.style.width = 'calc(100% - ' + s.SCROLL_WIDTH + 'px)';
      s.vScrollRange = height - s.dom.offsetHeight + s.offsetTop;
    }

    // check if the content is smaller than scrollable
    s.hScrollRange = s.hScrollRange > 1 ? s.hScrollRange : 0;
    s.vScrollRange = s.vScrollRange > 1 ? s.vScrollRange : 0;

    s.dom.className = domClassArray.join(' ');

    // Making scroll bars full length when the other doesn't present
    if (s.sbV.dom.style.display == 'none' && s.sbH.dom.style.display) {
      if (s.sbH.dom.className.search(' full') === -1) {
        s.sbH.dom.className += ' full';
      }
    } else {
      s.sbH.dom.className = s.sbH.dom.className.replace(' full', '');
    }

    if (s.sbH.dom.style.display == 'none' && s.sbV.dom.style.display) {
      if (s.sbV.dom.className.search(' full') === -1) {
        s.sbV.dom.className += ' full';
      }
    } else {
      s.sbV.dom.className = s.sbV.dom.className.replace(' full', '');
    }

    // Check if there is an content size change
    // In this case there might be over scrolling so we need to correct it
    s._scrollLeft = s._scrollLeft > s.hScrollRange ? s.hScrollRange : s._scrollLeft;
    s._scrollTop = s._scrollTop > s.vScrollRange ? s.vScrollRange : s._scrollTop;

    // update scroll bar sizes
    s.sbH.setScrollableRange(s.dom, width);
    s.sbV.setScrollableRange(s.dom, height);
    s.sbH.setScrollRatio(s._scrollLeft / s.hScrollRange);
    s.sbV.setScrollRatio(s._scrollTop / s.vScrollRange);

    // Fire scrolling event to notify scrolling change
    var e = {
      scrollLeft       : s._scrollLeft,
      scrollTop        : s._scrollTop,
      scrollHeightRange: s.vScrollRange,
      scrollWidthRange : s.hScrollRange
    };

    // Callback functions first
    fireCallbacks(e);
  }

  function onScrollListener(objectWithOnScroll) {
    s.callbackStack.push(objectWithOnScroll);
  }

  /**
   * Regular scroll
   * @param event
   * @private
   */
  function _onScroll(event) {
    var nScrolls = normalizeScrolls(s._scrollTop + event.deltaY, s._scrollLeft + event.deltaX);
    var tRatio = s._scrollTop / s.vScrollRange,
        lRatio = s._scrollLeft / s.hScrollRange;

    event.scrollLeft = nScrolls.scrollLeft;
    event.scrollTop = nScrolls.scrollTop;
    event.scrollHeightRange = s.vScrollRange;
    event.scrollWidthRange = s.hScrollRange;

    // Callback functions first
    fireCallbacks(event);

    // Render the scrolling
    s._scrollTop = nScrolls.scrollTop;
    s._scrollLeft = nScrolls.scrollLeft;

    s.sbH.setScrollRatio(lRatio);
    s.sbV.setScrollRatio(tRatio);

    // Check and see if the current scroll needs to be prevented or not
    checkAndPreventScrollEvent(event,nScrolls,event.deltaX,event.deltaY);
  }

  /**
   * listener for horizontal scroll
   * @param event
   */
  function onHorizontalScroll(event) {
    var nScrolls = normalizeScrolls(s._scrollTop, s.hScrollRange * event.scrollRatio);
    event.scrollLeft = nScrolls.scrollLeft;
    event.scrollTop = nScrolls.scrollTop;
    // Callback functions first
    fireCallbacks(event);
    s._scrollLeft = nScrolls.scrollLeft;
  }

  /**
   * Listener for vertical scroll
   * @param event
   */
  function onVerticalScroll(event) {
    var nScrolls = normalizeScrolls(s.vScrollRange * event.scrollRatio, s._scrollLeft);
    event.scrollLeft = nScrolls.scrollLeft;
    event.scrollTop = nScrolls.scrollTop;
    event.scrollHeightRange = s.vScrollRange;
    event.scrollWidthRange = s.hScrollRange;
    // Callback functions first
    fireCallbacks(event);
    s._scrollTop = nScrolls.scrollTop;
  }

  /**
   * Touch Event when dragging starts
   * @param event
   */
  var oTouchX, oTouchY, oTouchTop, oTouchLeft, oMoved;

  function onDomTouchStart(event) {
    var target,
        touch = event.changedTouches ? // `changedTouches` is available on Windows touch surfaces
          event.changedTouches[0] : event
    ;

    oMoved = false;
    oTouchX = touch.pageX ? touch.pageX : touch.clientX;
    oTouchY = touch.pageY ? touch.pageY : touch.clientY;
    oTouchTop = s._scrollTop;
    oTouchLeft = s._scrollLeft;

    // MS IE related
    if (msGesture) {
      target = event.currentTarget;
      msGesture.addPointer(event.pointerId);
    } else {
      target = document.body;
    }

    if (!event.pointerType || event.pointerType != 'mouse') {
      s.needToPreventScroll = true;

      target.addEventListener(touchMove, onDomTouchMove);
      target.addEventListener(touchEnd, onDomTouchEnd, true);
    }
  }

  /**
   * Touch Event when dragging
   * @param event
   */
  function onDomTouchMove(event) {
    var touch = event.changedTouches ? // `changedTouches` is available on Windows touch surfaces
      event.changedTouches[0] : event,
        dX    = (touch.pageX ? touch.pageX : touch.clientX) - oTouchX,
        dY    = (touch.pageY ? touch.pageY : touch.clientY) - oTouchY;

    var nScrolls = normalizeScrolls(oTouchTop - dY, oTouchLeft - dX),
        scroll = {};
    scroll.scrollLeft = nScrolls.scrollLeft;
    scroll.scrollTop = nScrolls.scrollTop;
    scroll.scrollHeightRange = s.vScrollRange;
    scroll.scrollWidthRange = s.hScrollRange;

    oMoved = true;

    // Callback functions first
    fireCallbacks(scroll);

    // Render scrolling
    s._scrollTop = nScrolls.scrollTop;
    s._scrollLeft = nScrolls.scrollLeft;

    s.sbH.setScrollRatio(nScrolls.scrollLeft / s.hScrollRange);
    s.sbV.setScrollRatio(nScrolls.scrollTop / s.vScrollRange);

    // Check and see if the native scroll events should be prevented
    checkAndPreventScrollEvent(event,nScrolls,-dX,-dY);
  }

  /**
   * Prevent native browser scrolls based on the current scrolling state
   * @param event
   * @param scrolls
   * @param dX
   * @param dY
   */
  function checkAndPreventScrollEvent(event, scrolls, dX, dY){
    var orientation = Math.abs(dX) > Math.abs(dY) ? 'h' : 'v',
        direction = orientation === 'h'? dX:dY;

    if(orientation === 'h'
      && s.sbH.dom.style.display !== 'none' // When there is a horizontal scroll
      && dX !== 0 // To prevent ghost scrolling
    ){
      // Only prevent scrolling propagation when the direction and the scrolling
      if(
        (direction > 0 && scrolls.scrollLeft < s.hScrollRange) ||
        (direction < 0 && scrolls.scrollLeft > 0)
      ){
        preventDefaultEvent(event);
      }
    }else if(orientation === 'v'
      && s.sbV.dom.style.display !== 'none'
      && dY !== 0
    ){
      // Only prevent scrolling propagation when the direction and the scrolling
      if(
        (direction > 0 && scrolls.scrollTop < s.vScrollRange) ||
        (direction < 0 && scrolls.scrollTop > 0)
      ){
        preventDefaultEvent(event);
      }
    }
  }

  /**
   * Need to prevent click to be fired when dragging the screen on touch devices
   * @param event
   */
  function preventClickEvent(event) {
    if (oMoved) {
      preventDefaultEvent(event);
    }
  }

  /**
   * Touch Event when dragging ends
   * @param event
   */
  function onDomTouchEnd(event) {
    var target = event.currentTarget;

    target.removeEventListener(touchMove, onDomTouchMove);
    target.removeEventListener(touchEnd, onDomTouchEnd, true);

    // Only prevent clicking when the touch is moved
    if(oMoved){
      preventClickEvent(event);
    }
  }

  /**
   * Prevent default event
   * @param  {Event} event default event object
   * @return {N/A}       N/A
   */
  function preventDefaultEvent(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  /**
   * batch fire callback functions
   * @param event
   */
  function fireCallbacks(event) {

    if (s.sbH.dom.style.display === 'none') {
      event.scrollLeft = 0;
    }

    if (s.sbV.dom.style.display === 'none') {
      event.scrollTop = 0;
    }

    for (var i = 0; i < s.callbackStack.length; i++) {
      s.callbackStack[i](event);
    }
  }

  /**
   * Normalize scrollTop and scrollLeft based on the vertical and horizontal scrolling range
   * @param scrollTop
   * @param scrollLeft
   * @returns {{scrollTop: *, scrollLeft: *}}
   */
  function normalizeScrolls(scrollTop, scrollLeft) {
    // Normalize scrollTop and scrollLeft
    if (scrollTop < 0 || isNaN(scrollTop)) {
      scrollTop = 0;
    } else if (scrollTop > s.vScrollRange) {
      scrollTop = s.vScrollRange;
    }
    if (scrollLeft < 0) {
      scrollLeft = 0;
    } else if (scrollLeft > s.hScrollRange) {
      scrollLeft = s.hScrollRange;
    }
    return {scrollTop: scrollTop, scrollLeft: scrollLeft};
  }

  /**
   * Initialize scrollable
   */

  var msGesture;

  function init() {

    // IE 11+ & Win 8+
    if (window.navigator.pointerEnabled && typeof MSGesture !== 'undefined') {
      touchStart = 'pointerdown';
      touchMove = 'MSGestureChange';
      touchEnd = 'MSGestureEnd';
    }
    // IE 10 & Wiun 8+
    else if (window.navigator.msPointerEnabled && typeof MSGesture !== 'undefined') {
      touchStart = 'MSPointerDown';
      touchMove = 'MSGestureChange';
      touchEnd = 'MSGestureEnd';
    }
    else {
      touchStart = 'touchstart';
      touchMove = 'touchmove';
      touchEnd = 'touchend';
    }

    // IE touch related
    if (typeof MSGesture !== 'undefined') {
      msGesture = new MSGesture();
      msGesture.target = s.dom;
    }

    s.sbH = new BentoScrollBar('bottom', s.SCROLL_WIDTH);
    s.sbV = new BentoScrollBar('right', s.SCROLL_WIDTH);

    s._domSize.width = s.dom.offsetWidth;
    s._domSize.height = s.dom.offsetHeight;

    //s.dom.style.width = s.dom.style.height = 'calc(100% - ' + s.SCROLL_WIDTH + 'px)';

    // After()
    s.dom.parentNode.insertBefore(s.sbH.dom, s.dom.nextSibling);
    s.dom.parentNode.insertBefore(s.sbV.dom, s.dom.nextSibling);

    s.sbH.onScroll(onHorizontalScroll);
    s.sbV.onScroll(onVerticalScroll);

    s.dom.className += ' bento-scrollable';
    // Add wheel or scroll events
    s.dom.addEventListener('wheel', _onScroll);

    // Track Touch Swipes
    s.dom.addEventListener(touchStart, onDomTouchStart);

    // Window resize
    window.addEventListener('resize', function (event) {
      // No need to resize since the scrollable is not even visible
      // no need to render
      if (s.dom.offsetWidth === 0 || s.dom.offsetHeight === 0) {
        return;
      }

      if (s._domSize.width !== s.dom.offsetWidth || s._domSize.height !== s.dom.offsetHeight) {
        s._domSize.width = s.dom.offsetWidth;
        s._domSize.height = s.dom.offsetHeight;

        render(s._scrollableSize.width, s._scrollableSize.height);

        // Fire both scrolling even to re-render
        var nScrolls = normalizeScrolls(s.vScrollRange * s.sbV.ratio, s.hScrollRange * s.sbH.ratio);
        nScrolls.scrollHeightRange = s.vScrollRange;
        nScrolls.scrollWidthRange = s.hScrollRange;
        // Callback functions first
        fireCallbacks(nScrolls);
        s._scrollTop = nScrolls.scrollTop;
        s._scrollLeft = nScrolls.scrollLeft;
      }
    });
  }
}


function BentoScrollBar(position, width) {
  var sb = this;
  var callbackStack = [];
  var sbVNobSize,
      sbHNobSize,
      sbVSize,
      sbHSize,
      sbVRange,
      sbHRange;
  var _width = !!width ? width : 15;
  sb.dom = document.createElement('DIV');
  sb.nob = document.createElement('DIV');
  sb.bg = document.createElement('DIV');
  sb.setScrollRatio = setScrollRatio;
  sb.onScroll = addScrollCallbacks;
  sb.setScrollableRange = setScrollableRange;
  sb.init = init;
  sb.ratio = 0;
  sb.init();

  /**
   * Set scroll with ratio
   * @param ratio
   */
  function setScrollRatio(ratio){
    sb.ratio = ratio > 1? 1:ratio;
    if(position === 'right'){
      sb.nob.style.top = sbVRange*sb.ratio + 'px';
    }else
    if(position === 'bottom'){
      sb.nob.style.left = sbHRange*sb.ratio + 'px';
    }
  }

  /**
   * Add Callback functions to callback stack
   * @param callback
   */
  function addScrollCallbacks(callback){
    callbackStack.push(callback);
  }

  /**
   * Adjust Scrollable Range based on the dom inner and outer size
   * @param dom
   */
  function setScrollableRange(dom, size) {
    var ratio, newSize;
    if (position === 'right') {
      sbVSize = sb.dom.offsetHeight;
      ratio = dom.offsetHeight / size;
      newSize = sbVSize * ratio;
      newSize = (newSize < _width) ? _width : newSize;
      newSize = (newSize > sbVSize - _width)? sbVSize - _width : newSize;
      sb.nob.style.height = newSize + 'px';
      sbVNobSize = sb.nob.offsetHeight;
      sbVRange = sbVSize - sbVNobSize;
      if(sb.nob.offsetTop > sbVRange){
        sb.nob.style.top = sbVRange + 'px';
      }


    } else if (position === 'bottom') {
      sbHSize = sb.dom.offsetWidth;
      ratio = dom.offsetWidth / size;
      newSize = sbHSize * ratio;
      newSize = (newSize < _width) ? _width : newSize;
      newSize = (newSize > sbHSize - _width)?sbHSize - _width : newSize;
      sb.nob.style.width = newSize + 'px';
      sbHNobSize = sb.nob.offsetWidth;
      sbHRange = sbHSize - sbHNobSize;
      if(sb.nob.offsetLeft > sbHRange){
        sb.nob.style.left = sbHRange + 'px';
      }
    }
  }

  /**
   * Listener for Mouse Down and Touch Down
   * @param event
   */
  var oSVal,
      oSNobVal;

  function onMouseDown(event) {
    if (position === 'bottom') {
      window.addEventListener('touchmove', onMouseMoveH);
      window.addEventListener('mousemove', onMouseMoveH);
      oSVal = event.pageX;
      oSNobVal = sb.nob.offsetLeft;
    } else if (position === 'right') {
      window.addEventListener('touchmove', onMouseMoveV);
      window.addEventListener('mousemove', onMouseMoveV);
      oSVal = event.pageY;
      oSNobVal = sb.nob.offsetTop;
    }

    window.addEventListener('touchend', onMouseUp);
    window.addEventListener('mouseup', onMouseUp);

    event.preventDefault();
    event.stopPropagation();
  }

  /**
   * Listner for Mouse Move & Touch Move in Vertical Direction
   * @param event
   */
  function onMouseMoveV(event) {
    var sVal = event.pageY;
    var ratio = processScrollerMoveEvent(oSVal, sVal, oSNobVal, 'Top', sbVNobSize, sbVSize, sbVRange);
    fireCallbacks(event, ratio);
    event.preventDefault();
    event.stopPropagation();
  }

  /**
   * Listener for Mouse Move & Touch Move in Horizontal Direction
   * @param event
   */
  function onMouseMoveH(event) {
    var sVal = event.pageX;
    var ratio = processScrollerMoveEvent(oSVal, sVal, oSNobVal, 'Left', sbHNobSize, sbHSize, sbHRange);
    fireCallbacks(event, ratio);
    event.preventDefault();
    event.stopPropagation();
  }

  /**
   * Process the Nob location and return scroll ratio [0.0 ~ 1.0]
   * @param oVal
   * @param sVal
   * @param cssPos
   * @param nobSize
   * @param barSize
   * @param range
   * @returns {number} - A ratio of how much that is needed to scroll
   */
  function processScrollerMoveEvent(oVal, sVal, oSNobOffsetVal, cssPos, nobSize, barSize, range) {
    //get dX
    var dX = sVal - oVal;
    var targetX;

    if (oSNobOffsetVal + dX < 0) {
      targetX = 0;
    } else if (oSNobOffsetVal + dX > range) {
      targetX = range;
    }else{
      targetX = oSNobOffsetVal + dX;
    }


    sb.nob.style[cssPos.toLowerCase()] = targetX + 'px';
    return targetX / range;
  }

  /**
   * Listener for Mouse Up & Touch End
   * @param event
   */
  function onMouseUp(event) {

    // Remove motion listeners to keep window listener stack clean
    window.removeEventListener('touchmove', onMouseMoveH);
    window.removeEventListener('mousemove', onMouseMoveH);
    window.removeEventListener('touchmove', onMouseMoveV);
    window.removeEventListener('mousemove', onMouseMoveV);
    window.removeEventListener('touchend', onMouseUp);
    window.removeEventListener('mouseup', onMouseUp);

    event.preventDefault();
    event.stopPropagation();
  }

  /**
   * Adjust nob position when BG is clicked
   * @param event
   */
  function onBGMouseDown(event) {
    var ratio,
        sVal,
        oSVal,
        oSNobVal;

    if (position === 'bottom') {
      sVal = event.pageX;
      oSNobVal = sb.nob.offsetLeft;
      oSVal = oSNobVal + sbHNobSize * 0.5;
      ratio = processScrollerMoveEvent(oSVal, sVal, oSNobVal, 'Left', sbHNobSize, sbHSize, sbHRange);
    } else if (position === 'right') {
      sVal = event.pageY;
      oSNobVal = sb.nob.offsetTop;
      oSVal = oSNobVal + sbVNobSize * 0.5;
      ratio = processScrollerMoveEvent(oSVal, sVal, oSNobVal, 'Top', sbVNobSize, sbVSize, sbVRange);
    }

    fireCallbacks(event, ratio);
    event.preventDefault();
    event.stopPropagation();
  }

  /**
   * Fire callback functions from the callback stack and pass the scrolling ratio
   * @param event
   * @param ratio
   */
  function fireCallbacks(event, ratio){
    // No scroll change
    if(sb.ratio === ratio){
      return;
    }
    sb.ratio = event.scrollRatio = ratio;
    for(var i=0; i<callbackStack.length; i++){
      callbackStack[i](event);
    }
  }

  /**
   * Initialization
   */
  function init() {
    sb.dom.className = 'bento-scrollbar';
    sb.nob.className = 'bento-scrollbar-nob';
    sb.bg.className = 'bento-scrollbar-bg';
    sb.dom.appendChild(sb.bg);
    sb.dom.appendChild(sb.nob);

    if (position === 'right') {
      sb.dom.className += ' vertical';
      sb.nob.style.width =
        sb.dom.style.width = _width + 'px';
    } else if (position === 'bottom') {
      sb.dom.className += ' horizontal';
      sb.nob.style.height =
        sb.dom.style.height = _width + 'px';
    }

    // Add eventlistener to nob
    sb.nob.addEventListener('touchstart', onMouseDown);
    sb.nob.addEventListener('mousedown', onMouseDown);
    sb.bg.addEventListener('touchstart', onBGMouseDown);
    sb.bg.addEventListener('mousedown', onBGMouseDown);

  }
}
function BentoTableCell(parent, isHeader) {
  var cell = this;
  cell.dom = document.createElement('DIV');
  cell.dom.className = 'bento-table-cell';
  cell.parent = parent;
  cell.dom.cell = this;
  cell.html = setHtml;
  cell.setTop = setTop;
  cell.setBottom = setBottom;
  cell.setLeft = setLeft;
  cell.setRight = setRight;
  cell.getWidth = getWidth;
  cell.setWidth = setWidth;
  cell.destroy = destroy;
  cell.setIndex = setIndex;
  cell.addClass = addClass;
  cell.removeClass = removeClass;
  cell.hasClass = hasClass;
  cell.setType = setType;
  cell.getType = getType;
  cell.setData = setData;
  cell.getData = getData;

  // Private
  var headerPlate;
  var headerContent;
  var type;
  var data;

  init();

  // Private
  var _classes = [cell.dom.className];

  function setData(d) {
    data = d;
  }

  function getData() {
    return data;
  }

  function setType(t) {
    if (type) {
      cell.removeClass(type);
    }
    type = t;
    cell.addClass(type);
  }

  function getType() {
    return type;
  }

  function addClass(className) {
    if (_classes.indexOf(className) < 0) {
      _classes.push(className);
      cell.dom.className = _classes.join(' ');
    }
  }

  function hasClass(className) {
    return _classes.indexOf(className) > -1
  }

  function removeClass(className) {
    var index = _classes.indexOf(className);
    if (index > -1) {
      _classes.splice(index, 1);
      cell.dom.className = _classes.join(' ');
    }
  }


  function setHtml(html) {
    if (isHeader) {
      if (typeof html === 'string' || typeof html === 'number') {
        headerContent.innerHTML = html;
      } else {
        headerContent.innerHTML = '';
        headerContent.appendChild(html);
      }
    } else if (typeof html !== 'undefined') {
      if (typeof html === 'string' || typeof html === 'number') {
        cell.dom.innerHTML = html;
      } else {
        cell.dom.innerHTML = '';
        cell.dom.appendChild(html);
      }
    } else{
      cell.dom.innerHTML = '';
    }
  }

  function setIndex(col, row) {
    cell.col = col;
    cell.row = row;
  }

  function setTop(topCell) {
    cell.top = topCell;
  }

  function setBottom(bottomCell) {
    cell.bottom = bottomCell;
  }

  function setLeft(leftCell) {
    cell.left = leftCell;
  }

  function setRight(rightCell) {
    cell.right = rightCell;
  }

  function getWidth() {
    return cell.dom.offsetWidth;
  }

  function setWidth(width) {
    cell.dom.style.width = width + 'px';
  }

  function destroy() {
    delete cell.dom;
    cell.top = null;
    cell.bottom = null;
    cell.left = null;
    cell.right = null;
    cell.parent = null;

    //AngularJS code
    if(data && data.scope){
      // Destroy NG code to prevent NG related memory leak
      data.scope.$destroy();
    }

    data = null;
  }

  function init() {
    if (isHeader) {
      headerPlate = document.createElement('DIV');
      headerPlate.className = 'bt-header-cell-plate';
      headerContent = document.createElement('DIV');
      cell.dom.appendChild(headerContent);
      cell.dom.appendChild(headerPlate);
    }
  }
}
var BentoTableCore;

(function () {
  BentoTableCore = _BentoTableCore;
  _BentoTableCore.prototype.addColumn = addColumn;
  _BentoTableCore.prototype.addNewColumn = addNewColumn;
  _BentoTableCore.prototype.addRow = addRow;
  _BentoTableCore.prototype.calcGridColSizeArray = calcGridColSizeArray;
  _BentoTableCore.prototype.calcGridRowSizeArray = calcGridRowSizeArray;
  _BentoTableCore.prototype.fastForwardCol = fastForwardCol;
  _BentoTableCore.prototype.fastForwardRow = fastForwardRow;
  _BentoTableCore.prototype.fireCellRenderRequestCallbackWithArray = fireCellRenderRequestCallbackWithArray;
  _BentoTableCore.prototype.getColSizes = getColSizes;
  _BentoTableCore.prototype.getFirstRow = getFirstRow;
  _BentoTableCore.prototype.getLastRow = getLastRow;
  _BentoTableCore.prototype.getNumRows = getNumRows;
  _BentoTableCore.prototype.getRowSizes = getRowSizes;
  _BentoTableCore.prototype.getTableHeight = getTableHeight;
  _BentoTableCore.prototype.getTableWidth = getTableWidth;
  _BentoTableCore.prototype.init = init;
  _BentoTableCore.prototype.linkRows = linkRows;
  _BentoTableCore.prototype.onHeaderClick = onHeaderClick; // event
  _BentoTableCore.prototype.onRowClick = onRowClick; // event
  _BentoTableCore.prototype.onScrollAtBottom = onScrollAtBottom; // event
  _BentoTableCore.prototype.pushRow = pushRow;
  _BentoTableCore.prototype.refreshScrollBars = refreshScrollBars;
  _BentoTableCore.prototype.removeColumn = removeColumn;
  _BentoTableCore.prototype.removeLastColumn = removeLastColumn;
  _BentoTableCore.prototype.removeLastRow = removeLastRow;
  _BentoTableCore.prototype.removeRow = removeRow;
  _BentoTableCore.prototype.render = render;
  _BentoTableCore.prototype.requestCellContent = requestCellContent;
  _BentoTableCore.prototype.requestHeaderContent = requestHeaderContent;
  _BentoTableCore.prototype.requestFrozenCellContent = requestFrozenCellContent;
  _BentoTableCore.prototype.rewindCol = rewindCol;
  _BentoTableCore.prototype.reset = reset;
  _BentoTableCore.prototype.rewindRow = rewindRow;
  _BentoTableCore.prototype.selectRow = selectRow; // number
  _BentoTableCore.prototype.selectFrozenRow = selectFrozenRow; // number
  _BentoTableCore.prototype.setColSizes = setColSizes;
  _BentoTableCore.prototype.setColumnWidth = setColumnWidth; // number
  _BentoTableCore.prototype.setGridSize = setGridSize;
  _BentoTableCore.prototype.setRowHeight = setRowHeight; // number
  _BentoTableCore.prototype.setRowSizes = setRowSizes;
  _BentoTableCore.prototype.toggleRow = toggleRow; // number
  _BentoTableCore.prototype.toggleFrozenRow = toggleFrozenRow; // number
  _BentoTableCore.prototype.deselectRow = deselectRow; // number
  _BentoTableCore.prototype.deselectFrozenRow = deselectFrozenRow; // number
  _BentoTableCore.prototype.unshiftRow = unshiftRow;
  _BentoTableCore.prototype.updateRowWithIndex = updateRowWithIndex;
  _BentoTableCore.prototype.addFrozenRow = addFrozenRow;
  _BentoTableCore.prototype.removeFrozenRow = removeFrozenRow;
  _BentoTableCore.prototype.renderHeaderCell = renderHeaderCell;


  // Private
  _BentoTableCore.prototype._headerCellClick = _headerCellClick;
  _BentoTableCore.prototype._onHeaderColumnResize = _onHeaderColumnResize;
  _BentoTableCore.prototype._onRowClick = _onRowClick;
  _BentoTableCore.prototype._onScroll = _onScroll;

  /**
   * Constructore
   * @param dom
   * @param options
   * @private
   */
  function _BentoTableCore(dom, options) {
    var self = this;
    // API

    // row and column size reference array
    /* "this.rowSizes" is an array where each element is an array and represents the following
     * ----------------
     * 0. Row Height
     * 1. Total Height includeing this row
     * 2. (Bool) selected toggle
     *
     */

    this.rowSizes = [];
    this.frozenRowSizes = [];
    this.colSizes = [];
    this.ready = false;

    // Default values
    this.options = {
      rowHeight : options.rowHeight || 30,
      colWidth  : options.colWidth || 100,
      border    : options.border || 1,
      header    : options.header || {resize: false},
      autoHeight: options.autoHeight
    };

    // private variable declaration
    this._currentHIndex = 0;
    this._currentVIndex = 0;
    this._dom = dom;
    this._domWidth = 0.0;
    this._headerClickCallbackStack = [];
    this._headerHeight = 0;
    this._requestCellContentCallback = null;
    this._requestFrozenCellContentCallback = null;
    this._requestHeaderContentCallback = null;
    this._rowClickCallbackStack = [];
    this._rows = [];
    this._scrollLeft = 0.0;
    this._scrollTop = 0.0;

    // Creating sub components
    this.header = new BentoTableHeader(this.options.colWidth, this.options.rowHeight, this.options.header);
    this.scrollable = new BentoScrollable(this._dom);
    this.pane = document.createElement('DIV');
    this.pane.className = 'bento-table-inner';
    this._dom.appendChild(this.pane);
    this._dom.appendChild(this.header.dom);
    this.scrollable.onScroll(function (event) {
      self._onScroll(event);
    });
  }

  // Render Header Cell
  function renderHeaderCell(headerCell, colObj, scope, compile){
    this.header.renderCell(headerCell, colObj, scope, compile);
  }

  /**
   * Reset table content without distroying column definitions
   */
  function reset(){
    this.rowSizes=[];
    this.header.reset();
    for(var i= 0,len=this._rows.length;i<len;i++){
      this._rows[i].clear();
    }
  }

  /**
   * Add a frozen row object
   */
  function addFrozenRow() {
    if (this.header) {
      this.header.addFrozenRow();
    }
  }

  /**
   * Remove a frozen row object
   */
  function removeFrozenRow(index) {
    if (this.header) {
      this.header.removeFrozenRow(index);
    }
  }

  /**
   * Adding scroll at bottom callback
   * @param callback
   */
  function onScrollAtBottom(callback) {
    if (typeof this._scrollAtBottomCallbacks === 'undefined') {
      this._scrollAtBottomCallbacks = [];
    }

    // To avoid adding the same callback instance
    if (this._scrollAtBottomCallbacks.indexOf(callback) > -1) {
      return;
    }

    this._scrollAtBottomCallbacks.push(callback);
  }

  /**
   * Set Column width
   * @param col - Could be either integer to arary
   * @param width - Width to the given colIndex from `col` can be array
   */
  function setColumnWidth(colData, widthData) {
    var col, width, smallestCol = this.colSizes.length;

    if (!Array.isArray(colData)) {
      colData = [colData];
      widthData = [widthData];
    }

    for (var i = 0, len = colData.length; i < len; i++) {
      col = colData[i];
      width = widthData[i];

      if (col < smallestCol) {
        smallestCol = col;
      }

      if (this.colSizes[col]) {
        var cell = this.getFirstRow().getFirstCell();
        var fCCell = cell,
            fRCell;
        do {
          cell = cell.right;
          if (cell.col == col) {
            fRCell = cell;
            // Set width to all cell in the same column
            do {
              cell.dom.style.width = width + 'px';
              cell = cell.bottom;
            } while (cell !== fRCell);

            // update column width index
            this.colSizes[col][0] = width;
          }
        } while (cell !== fCCell)
      }
    }

    this.calcGridColSizeArray(smallestCol);
    this.render();
  }

  function updateCellCSS(cell) {
    if (cell.col === 0) {
      cell.addClass('bt-row-head');
    } else {
      cell.removeClass('bt-row-head');
    }
  }

  function setRowHeight(rowIndex, height) {
    if (this.rowSizes[rowIndex]) {
      this.rowSizes[rowIndex][0] = height;
      this.calcGridRowSizeArray(rowIndex);
      //Find the row and adjust its height if it's in viewport
      var row;
      for (var i = 0; i < this._rows; i++) {
        row = this._rows[i];
        if (row.row === row) {
          row.dom.style.height = height + 'px';
        }
      }
      this.render();
    }
  }

  function addColumn(col, count, width) {
    for (var i = 0; i < (count || 1); i++) {
      this.colSizes.splice(col, 0, [width || this.options.colWidth, 0]);
    }
    this.calcGridColSizeArray(col);
    this.render();
  }

  function addRow(row, count, height) {
    for (var i = 0; i < (count || 1); i++) {
      this.rowSizes.splice(row, 0, [height || this.options.rowHeight, 0]);
    }
    this.calcGridRowSizeArray(row);
    this.render();
  }

  function removeRow(row, count) {
    this.rowSizes.splice(row, count || 1);
    this.calcGridRowSizeArray(row);
    this.render();
  }

  function removeColumn(col, count) {
    this.colSizes.splice(col, count || 1);
    this.calcGridColSizeArray(col);
    this.render();
  }

  function calcGridRowSizeArray(index, isFrozen) {
    var array = isFrozen ? this.frozenRowSizes : this.rowSizes;
    var height = index === 0 ? 0 : array[index - 1][1];
    var size = array.length;
    for (var i = index; i < size; i++) {
      height += array[i][0];
      array[i][1] = height;
    }
  }

  function calcGridColSizeArray(index) {
    var width = index === 0 ? 0 : this.colSizes[index - 1][1];
    var size = this.colSizes.length;
    for (var i = index; i < size; i++) {
      width += this.colSizes[i][0];
      this.colSizes[i][1] = width;
    }
  }

  function requestCellContent(callback) {
    this._requestCellContentCallback = callback;
  }

  function requestHeaderContent(callback) {
    this._requestHeaderContentCallback = callback;
  }

  function requestFrozenCellContent(callback) {
    this._requestFrozenCellContentCallback = callback;
  }

  function getColSizes() {
    return this.colSizes;
  }

  function setColSizes(array) {
    this.colSizes = array;
  }

  function getRowSizes() {
    return this.rowSizes;
  }

  function setRowSizes(array) {
    this.rowSizes = array;
  }

  function _onScroll(event) {
    var index, vIndex, hIndex, fIndex;
    var dHIndex = 0,
        dVIndex = 0,
        cWidth = 0,
        i,
        j,
        len
    ;
    var renderStack = [],
        headerRenderStack = [],
        freezeRenderStack = []
    ;

    // Check if need to fire scroll at bottom or not
    if (this._scrollAtBottomCallbacks && event.scrollHeightRange - event.scrollTop < 500) {
      for (i = 0, len = this._scrollAtBottomCallbacks.length; i < len; i++) {
        this._scrollAtBottomCallbacks[i](event);
      }
    }

    // H Scroll
    if (this._scrollLeft !== event.scrollLeft) {
      this._scrollLeft = event.scrollLeft;
      index = bSearchIndexByScroll(this.colSizes, event.scrollLeft);
      this.header.dom.style.left =
        this.pane.style.marginLeft = (
          this.colSizes[index][1] - this.colSizes[index][0] - this._scrollLeft
        ) + 'px';
      dHIndex = index - this._currentHIndex;
      this._currentHIndex = index;
    }

    // V Scroll
    if (this._scrollTop !== event.scrollTop
      && this.rowSizes.length
    ) {
      this._scrollTop = event.scrollTop;
      index = bSearchIndexByScroll(this.rowSizes, event.scrollTop);
      this.pane.style.marginTop = (
        this.rowSizes[index][1] - this.rowSizes[index][0] - this._scrollTop
      ) + 'px';
      dVIndex = index - this._currentVIndex;
      this._currentVIndex = index;
    }

    var cSize = this.getFirstRow().getNumCells(),
        rSize = this.getNumRows(),
        cell, hCell, fCell;

    //Total this.render
    if (Math.abs(dHIndex) > cSize || Math.abs(dVIndex) > rSize) {
      hCell = this.header.row.getFirstCell();
      cell = this.getFirstRow().getFirstCell();
      for (i = 0; i < rSize; i++) {
        vIndex = this._currentVIndex + i;
        if (vIndex < this.rowSizes.length) {
          this.updateRowWithIndex(cell.parent, vIndex);
          for (j = 0; j < cSize; j++) {
            hIndex = this._currentHIndex + j;
            cWidth = this.colSizes[hIndex] ? [this.colSizes[hIndex][0], 'px'].join('') : '';
            if (hIndex < this.colSizes.length) {
              cell.setIndex(hIndex, vIndex);
              cell.dom.style.width = cWidth;
              renderStack.push(cell);
            }

            // Only execute once
            if (i === 0 && hIndex < this.colSizes.length) {
              hCell.setIndex(hIndex, 0);
              hCell.dom.style.width = cWidth;
              headerRenderStack.push(hCell);
              __getFreezeCellRenderStackFromHeader(freezeRenderStack, hCell, cWidth);
            }

            hCell = hCell.right;
            cell = cell.right;
          }
        }else{
          for (j = 0; j < cSize; j++) {
            cell.html('');
            cell = cell.right;
          }
        }
        cell = cell.bottom;
      }
    } else {
      // horizontal Scrolling
      //FF
      if (dHIndex > 0) {
        // Get first cell
        hCell = this.header.row.getFirstCell();
        cell = this.getFirstRow().getFirstCell();
        hIndex = this._currentHIndex + cSize - dHIndex;
        // Column
        for (i = 0; i < dHIndex; i++) {
          index = hIndex + i;
          cWidth = this.colSizes[index] ? [this.colSizes[index][0], 'px'].join('') : null;
          // Row
          for (j = 0; j < rSize; j++) {
            if (index < this.colSizes.length && cell.row < this.rowSizes.length) {
              cell.setIndex(index, cell.row);
              cell.dom.style.width = cWidth;
              renderStack.push(cell);
            } else {
              cell.html('');
            }
            cell = cell.bottom;
          }
          if (index < this.colSizes.length) {
            hCell.setIndex(index, 0);
            hCell.dom.style.width = cWidth;
            headerRenderStack.push(hCell);
            __getFreezeCellRenderStackFromHeader(freezeRenderStack, hCell, cWidth);
          }

          cell = cell.right;
          hCell = hCell.right;
          this.fastForwardCol();
        }
      } else
      //RW
      if (dHIndex < 0) {
        //get first row last Cell
        hCell = this.header.row.getLastCell();
        cell = this.getFirstRow().getLastCell();
        hIndex = this._currentHIndex - dHIndex;
        // Column
        for (i = -1; i >= dHIndex; i--) {
          index = hIndex + i;
          cWidth = this.colSizes[index][0] + 'px';
          // Row
          for (j = 0; j < rSize; j++) {
            if (cell.row < this.rowSizes.length) {
              cell.setIndex(index, cell.row);
              cell.dom.style.width = cWidth;
              renderStack.push(cell);
            }
            cell = cell.bottom;
          }
          hCell.setIndex(index, 0);
          hCell.dom.style.width = cWidth;
          headerRenderStack.push(hCell);
          __getFreezeCellRenderStackFromHeader(freezeRenderStack, hCell, cWidth);

          hCell = hCell.left;
          cell = cell.left;
          this.rewindCol();
        }
      }

      // Vertical Scrolling
      //FF
      if (dVIndex > 0) {
        // Get first cell
        cell = this.getFirstRow().getFirstCell();
        vIndex = this._currentVIndex + rSize - dVIndex;
        // Row
        for (i = 0; i < dVIndex; i++) {
          index = vIndex + i;
          if (index < this.rowSizes.length && cell.col < this.colSizes.length) {
            this.updateRowWithIndex(cell.parent, index);
            // Column
            for (j = 0; j < cSize; j++) {
              if (cell.col < this.colSizes.length) {
                cell.setIndex(cell.col, index);
                if (renderStack.indexOf(cell) === -1) {
                  renderStack.push(cell);
                }
              }
              cell = cell.right;
            }
            cell = cell.bottom;

          }
          this.fastForwardRow();
        }
      } else
      //RW
      if (dVIndex < 0) {
        //get first row last Cell
        cell = this.getLastRow().getFirstCell();
        vIndex = this._currentVIndex - dVIndex;
        // Row
        for (i = -1; i >= dVIndex; i--) {
          index = vIndex + i;
          this.updateRowWithIndex(cell.parent, index);
          // Column
          for (j = 0; j < cSize; j++) {
            if (cell.col < this.colSizes.length) {
              cell.setIndex(cell.col, index);
              if (renderStack.indexOf(cell) === -1) {
                renderStack.push(cell);
              }
            }
            cell = cell.right;

          }
          cell = cell.top;
          this.rewindRow();
        }
      }
    } // End of main if statement

    // callback for cell this.rendering
    this.fireCellRenderRequestCallbackWithArray(renderStack, headerRenderStack, freezeRenderStack);
    renderStack = null;
    headerRenderStack = null;
    freezeRenderStack = null;
  }

  /**
   * Get a render stack for frozen column using a header cell as a column reference
   * @param hCell
   * @param cWidth
   * @private
   */
  function __getFreezeCellRenderStackFromHeader(freezeRenderStack, hCell, cWidth) {
    if (hCell === hCell.top) {
      return;
    }

    var fIndex = 0,
        fCell
    ;

    fCell = hCell.bottom;
    while (fCell !== hCell) {
      fCell.setIndex(hCell.col, fIndex);
      fCell.dom.style.width = cWidth;
      freezeRenderStack.push(fCell);
      // next frozen cell in this column
      fCell = fCell.bottom;
      fIndex++;

    }
  }

  function updateRowWithIndex(row, index) {
    row.dom.style.height = this.rowSizes[index][0] + 'px';
    // set row index
    row.setRow(index);
  }

  function fireCellRenderRequestCallbackWithArray(arr, headerArr, frozenArr) {
    var i, len, cell;
    for (i = 0, len = arr.length; i < len; i++) {
      cell = arr[i];
      cell.parent.addClass('dirty');
      updateCellCSS(cell);
      this._requestCellContentCallback(arr[i]);
    }

    for (i = 0, len = headerArr.length; i < len; i++) {
      cell = headerArr[i];
      updateCellCSS(cell);
      this._requestHeaderContentCallback(headerArr[i]);
    }

    for (i = 0, len = frozenArr.length; i < len; i++) {
      cell = frozenArr[i];
      cell.parent.addClass('dirty');
      updateCellCSS(cell);
      this._requestFrozenCellContentCallback(frozenArr[i]);
    }
  }

  /**
   * Find the index of an array from its scroll
   * @param arr
   * @param scroll
   * @returns (int)
   */
  function bSearchIndexByScroll(arr, scroll) {
    if (scroll <= 0 || arr.length === 0) {
      return 0;
    }

    // Using three pivot points
    var lP = 0,
        rP = arr.length - 1,
        cR,
        notFound = true;

    while (notFound) {
      cR = Math.floor((lP + rP) * 0.5);
      //console.log(scroll,lP,cR,rP);
      //Compare cR
      if (arr[cR][1] > scroll) {
        if (arr[cR][1] - arr[cR][0] <= scroll) {
          notFound = false;
        } else {
          rP = cR;
        }
      } else {
        lP = cR;
      }
    }
    return cR
  }

  function setGridSize(row, col) {
    var height = this.rowSizes.length === 0 ? 0 : this.rowSizes[this.rowSizes.length - 1][1],
        width = this.colSizes.length === 0 ? 0 : this.colSizes[this.colSizes.length - 1][1],
        h = this.options.rowHeight,
        w = this.options.colWidth;

    // Add new row indexes
    if (row > this.rowSizes.length) {
      for (var i = this.rowSizes.length; i < row; i++) {
        height += h;
        this.rowSizes.push([h, height]);
      }
    } else
    // Slice the current array to match with the new row count
    if (row < this.rowSizes.length) {
      this.rowSizes = this.rowSizes.slice(0, row);
    }

    // Add new col indexes
    if (col > this.colSizes.length) {
      for (var j = this.colSizes.length; j < col; j++) {
        width += w;
        this.colSizes.push([w, width]);
      }
    } else
    // Slice the current array to match with the new col count
    if (col < this.colSizes.length) {
      this.colSizes = this.colSizes.slice(0, col);
    }
  }

  function refreshScrollBars() {

    this.scrollable.render(
      this.colSizes.length ? this.colSizes[this.colSizes.length - 1][1] : 0,
      this.rowSizes.length ? this.rowSizes[this.rowSizes.length - 1][1] : 0,
      this.header.dom.offsetHeight
    );
  }

  function render(deepRender) {
    var cSize = this.getFirstRow().getNumCells(),
        rSize = this.getNumRows(),
        cWidth,
        cell, hCell, fCell, hIndex, vIndex, fIndex, i, j, len,
        renderStack = [],
        headerRenderStack = [],
        freezeRenderStack = []
    ;

    if (deepRender) {
      this.calcGridRowSizeArray(0);
    }

    if (this.options.autoHeight) {
      if (rSize < this.rowSizes.length) {
        var newRow;
        for (i = 0, len = this.rowSizes.length - rSize; i < len; i++) {
          newRow = new BentoTableRow(cSize, this.options.colWidth, this.options.rowHeight);
          this.pushRow(newRow, true);
        }

        rSize = this.rowSizes.length;
      }

      // resize table

      var newHeight =  (this.rowSizes.length? this.rowSizes[this.rowSizes.length - 1][1] : 0)
        + this.header.dom.offsetHeight
        + this.scrollable.SCROLL_WIDTH;
      this._dom.style.height = newHeight + 'px';
      this.scrollable.height(newHeight);

      //need to set the parent height
      this._dom.parentElement.style.position = 'relative';
      this._dom.parentElement.style.height = newHeight + 'px';
    }

    this._domWidth = this._dom.offsetWidth;

    // Set header padding in the main area
    this._dom.style.paddingTop = this.header.dom.offsetHeight + 'px';

    //Total this.render
    cell = this.getFirstRow().getFirstCell();
    hCell = this.header.row.getFirstCell();

    for (i = 0; i < rSize; i++) {
      vIndex = this._currentVIndex + i;
      // out of boundary check
      if (vIndex < this.rowSizes.length) {
        this.updateRowWithIndex(cell.parent, vIndex);
        for (j = 0; j < cSize; j++) {
          // out of boundary check
          hIndex = this._currentHIndex + j;
          if (hIndex >= this.colSizes.length) {

          } else {
            cWidth = this.colSizes[hIndex][0] + 'px';
            cell.setIndex(hIndex, vIndex);
            cell.dom.style.width = cWidth;
            renderStack.push(cell);
          }
          cell = cell.right;

          // Only execute once
          if (i === 0 && hIndex < this.colSizes.length) {
            hCell.setIndex(hIndex, 0);
            hCell.dom.style.width = cWidth;
            headerRenderStack.push(hCell);
            __getFreezeCellRenderStackFromHeader(freezeRenderStack, hCell, cWidth);

            hCell = hCell.right;
          }
        }
      }else{
        // Erase the empty cells
        for (j = 0; j < cSize; j++) {
          if(j === 0){
            cell.parent.clearClasses();
          }

          cell.html('');
          cell = cell.right;
        }
      }
      cell = cell.bottom;
    }

    this.refreshScrollBars();
    this.fireCellRenderRequestCallbackWithArray(renderStack, headerRenderStack, freezeRenderStack);
    renderStack = null;
    headerRenderStack = null;
    freezeRenderStack = null;
  }

  function getTableWidth() {
    return this.colSizes.reduce(function (a, b) {
      return a + b
    });
  }

  function getTableHeight() {
    return this.rowSizes.reduce(function (a, b) {
      return a + b
    });
  }

  /**
   * Row and Column rotations
   */
  function fastForwardRow() {
    this.pushRow(this.getFirstRow());
  }

  function rewindRow() {
    this.unshiftRow(this.getLastRow());
  }

  function fastForwardCol() {
    var row, i, len, hCell, fCell;
    for (i = 0, len = this._rows.length; i < len; i++) {
      row = this._rows[i];
      row.push(row.getFirstCell());
    }

    // header
    hCell = this.header.row.getFirstCell();
    this.header.row.push(hCell);

    // Frozen rows
    fCell = hCell.bottom;
    while (fCell !== hCell) {
      fCell.parent.push(fCell);
      fCell = fCell.bottom;
    }
  }

  function rewindCol() {
    var row, i, len, hCell, fCell;
    for (i = 0, len = this._rows.length; i < len; i++) {
      row = this._rows[i];
      row.unshift(row.getLastCell());
    }

    //header
    hCell = this.header.row.getLastCell();
    this.header.row.unshift(hCell);

    // Frozen rows
    fCell = hCell.bottom;
    while (fCell !== hCell) {
      fCell.parent.unshift(fCell);
      fCell = fCell.bottom;
    }
  }

  function getFirstRow() {
    return this.pane.firstElementChild.row;
  }

  function getLastRow() {
    return this.pane.lastElementChild.row;
  }

  /**
   * Column and row operations
   */
  function pushRow(row, isNew) {
    if (isNew) {
      this.linkRows(row);
      var table = this;
      row.dom.addEventListener('click', function (event) {
        event.row = row;
        table._onRowClick(event);
      });
    }
    this.pane.appendChild(row.dom);
  }

  function unshiftRow(row, isNew) {
    if (isNew) {
      this.linkRows(row);
    }
    this.pane.insertBefore(row.dom, this.pane.firstChild);
  }

  function getNumRows() {
    return this._rows.length;
  }

  function removeLastRow() {
    var row = this.getLastRow();
    this.pane.removeChild(row.dom);
    this._rows.splice(this._rows.indexOf(row), 1);
    row.destroy();
  }

  function removeLastColumn() {
    for (var i = 0; i < this._rows; i++) {
      this._rows[i].removeLastCell();
    }
  }

  function addNewColumn() {
    var fCell, cell, lCell;
    for (var i = 0; i < this._rows.length; i++) {
      cell = new BentoTableCell(this._rows[i]);
      if (typeof fCell === 'undefined') {
        fCell = cell;
      }

      if (lCell) {
        lCell.setBottom(cell);
        cell.setTop(lCell);
      }
      this._rows[i].push(cell);
      lCell = cell;
    }

    fCell.setTop(cell);
    cell.setBottom(fCell);
  }

  function onHeaderClick(callback) {
    this._headerClickCallbackStack.push(callback);
  }

  function _headerCellClick(event) {
    event.cell = event.currentTarget.cell;
    for (var i = 0, len = this._headerClickCallbackStack.length; i < len; i++) {
      this._headerClickCallbackStack[i](event);
    }
  }

  function onRowClick(callback) {
    this.header.onRowClick(callback);
    this._rowClickCallbackStack.push(callback);
  }

  // Fire RowClick callback functions
  function _onRowClick(event) {
    this._rowClickCallbackStack.forEach(function (callback) {
      var row = event.currentTarget.row;
      event.rowIndex = row.row;
      event.row = row;
      callback(event);
    })
  }

  function deselectRow(rowIndex, isFrozen) {
    var rows = isFrozen ? this.header.frozenRows : this._rows;
    var rowSizes = isFrozen ? this.frozenRowSizes : this.rowSizes;
    if (rowIndex < rowSizes.length) {
      // update index
      // Find and update row is it presents in the viewport
      for (var i = 0, len = rows.length; i < len; i++) {
        if (rows[i].row === rowIndex) {
          rows[i].removeClass('bt-row-selected');
          break;
        }
      }
    }
  }

  function selectRow(rowIndex, isFrozen) {
    var rows = isFrozen ? this.header.frozenRows : this._rows;
    var rowSizes = isFrozen ? this.frozenRowSizes : this.rowSizes;
    if (rowIndex < rowSizes.length)
    // update index

    // Find and update row is it presents in the viewport
      for (var i = 0, len = rows.length; i < len; i++) {
        if (rows[i].row === rowIndex) {
          rows[i].addClass('bt-row-selected');
          break;
        }
      }

  }

  function toggleRow(rowIndex, isFrozen) {
    var rows = isFrozen ? this.header.frozenRows : this._rows;
    var rowSizes = isFrozen ? this.frozenRowSizes : this.rowSizes;

    if (rowIndex < rowSizes.length) {
      // Find and update row is it presents in the viewport
      for (var i = 0, len = rows.length; i < len; i++) {
        if (rows[i].row === rowIndex) {
          return rows[i].toggleClass('bt-row-selected');
          break;
        }
      }
    }
  }

  function deselectFrozenRow(rowDom) {
    rowDom.row.removeClass('bt-row-selected');
  }

  function selectFrozenRow(rowDom) {
    rowDom.row.addClass('bt-row-selected');
  }

  function toggleFrozenRow(rowDom) {
    rowDom.row.toggleClass('bt-row-selected');
  }

  // Resize column
  function _onHeaderColumnResize(event) {
    this.setColumnWidth(event.col, event.width);
  }

  /**
   * Link all cells in current row with other cells that are in the same column
   * @param row
   */
  function linkRows(row) {
    this._rows.push(row);
    if (this._rows.length > 1) {
      var fRow = this.getFirstRow();
      var lRow = this.getLastRow();
      var numCol = fRow.getNumCells();
      var cell,
          fCell,
          lCell;

      for (var i = 0; i < numCol; i++) {
        cell = row.getNthCell(i);
        fCell = fRow.getNthCell(i);
        lCell = lRow.getNthCell(i);

        fCell.setTop(cell);
        lCell.setBottom(cell);
        cell.setTop(lCell);
        cell.setBottom(fCell);
      }
    }
  }

  /**
   * Initialize Table
   */
  function init() {
    var table = this;
    var numRows = Math.ceil(this._dom.offsetHeight / this.options.rowHeight) + 5;
    var numCols = Math.ceil(this._dom.offsetWidth / this.options.colWidth) + 5;

    numRows = numRows === 0 ? 1 : numRows;
    numCols = numCols === 0 ? 1 : numCols;

    var t = this;

    var row;

    for (var i = 0; i < numRows; i++) {
      row = new BentoTableRow(numCols, this.options.colWidth, this.options.rowHeight);
      //row.setClassName(isOddRow? 'odd' : 'even');
      this.pushRow(row, true);
    }

    this.header.setNumColumns(numCols, function (e) {
      table._headerCellClick(e);
    });
    this.header.onColumnResize(function (e) {
      table._onHeaderColumnResize(e)
    });

    this.ready = true;
  }
})();




var BentoTableHelper;

(function () {
  'use strict';

  // Public API
  BentoTableHelper = _BentoTableHelper;
  BentoTableHelper.prototype.applyTableOptions = applyTableOptions;
  BentoTableHelper.prototype.concatData = concatData;
  BentoTableHelper.prototype.getDataForRender = getDataForRender;
  BentoTableHelper.prototype.freezeRow = freezeRow;
  BentoTableHelper.prototype.getCellByIndex = getCellByIndex;
  BentoTableHelper.prototype.getColumnByIndex = getColumnByIndex;
  BentoTableHelper.prototype.getDataColunmIndex = getDataColunmIndex;
  BentoTableHelper.prototype.getNumCols = getNumCols;
  BentoTableHelper.prototype.getNumRows = getNumRows;
  BentoTableHelper.prototype.getRowByIndex = getRowByIndex;
  BentoTableHelper.prototype.init = init;
  BentoTableHelper.prototype.parseColumnDefinitions = parseColumnDefinitions;
  BentoTableHelper.prototype.removeColumnIndex = removeColumnIndex;
  BentoTableHelper.prototype.removeFrozenRecords = removeFrozenRecords;
  BentoTableHelper.prototype.renderCell = renderCell;
  BentoTableHelper.prototype.renderCellDefault = renderCellDefault;
  BentoTableHelper.prototype.renderFrozenCell = renderFrozenCell;
  BentoTableHelper.prototype.reset = reset;
  BentoTableHelper.prototype.sort = sort;
  BentoTableHelper.prototype.onRowClick = onRowClick;
  BentoTableHelper.prototype.unfreezeRow = unfreezeRow;
  BentoTableHelper.prototype.updateObjectsForRender = updateObjectsForRender;
  BentoTableHelper.prototype.fireRowClickCallbacks = fireRowClickCallbacks;

  // Private API
  BentoTableHelper.prototype._prepSort = _prepSort;

  function _BentoTableHelper(data, bentoTable, options, scope, compile, attrs) {
    var helper = this;
    // Class variables
    this._columnIndexRefArray = null;
    this._sorter = new BentoTableSort(bentoTable);

    // local variables
    this._cColumn = null;
    this._scope = scope;
    this._options = options;
    this._compile = compile;
    this._attrs = attrs;
    this._cColumnTemplate = null;
    this._columnTemplateStack = [];
    this._columnTypeObjs = {
      number  : new BentoTableNumberColumn(),
      default : new BentoTableDefaultColumn(),
      checkbox: new BentoTableCheckBoxColumn()
    };

    this._table = bentoTable;
    this._cellObj = null;
    this._rowObj = null;
    this._data = data;
    this._frozenRows = [];

    this._colWidthArray = [];
    this._colIndexArray = [];

    this._rowClickCallbacks = [];

    this._table.onRowClick(function(event){
      helper.fireRowClickCallbacks(event);
    });
  }

  /**
   * Initialization
   */
  function init(colOffset) {
    this._colOffset = colOffset? colOffset : 0;
    this.parseColumnDefinitions(this._data.columns);
  }

  /**
   * Get ordered data for render
   * @returns {*}
   */
  function getDataForRender(){
    return this._data.data;
  }


  /**
   * Reset helper
   */
  function reset(){
    this._cellObj = null;
    this._frozenRows = [];
    this._rowObj = null;
  }

  /**
   * Public function to add table row clicks
   * @param callback
   */
  function onRowClick(callback){
    this._rowClickCallbacks.push(callback);
  }

  function fireRowClickCallbacks(event){
    for(var i= 0, len=this._rowClickCallbacks.length; i<len; i++){
      this._rowClickCallbacks[i](event);
    }
  }

  /**
   * Concat two data arrays then return the new array
   * @param mainData
   * @param newData
   */
  function concatData(mainData, newData){
    return this._data.data = mainData.concat(newData);
  }

  /**
   * Remove frozen records from sourceData
   * IMPORTANT: sourceData needs to be sourced by tableCol
   * @param sourceData (array)
   * @param tableCol (number)
   */
  function removeFrozenRecords(sourceData, tableCol, desc){
    var col = this._data.columns[this.getDataColunmIndex(tableCol)].name,
        fRow, dRow, index, val
    ;
    // find the approx index for the match
    for(var i=0,len=this._frozenRows.length; i<len; i++){
      fRow = this._frozenRows[i];
      val = fRow[col];
      // Find the index to be removed
      index = this._sorter.findIndex(
        sourceData,
        function(l,r){
          if(desc){
            return l[col] >= val && val >= r[col];
          }else{
            return l[col] <= val && val <= r[col];
          }
        },
        function(f,l){
          if(desc){
            return f[col] < val || val < l[col];
          }else{
            return l[col] < val || val < f[col];
          }
        },
        true
      );


      // search linearly for the exact matching data since there might be multiple rows with the same col value
      while((dRow = sourceData[index]) && fRow[col] === dRow[col]){
        //found matching

        if(isEqual(fRow, dRow)){
          fRow['__btDataIndex'] = index;
          sourceData.splice(index,1);
          break;
        }
        index++;
      }
    }

    return sourceData;
  }

  // Check if two arrays are equal based on numbered indexes
  function isEqual(a,b){
    var equal = true;
    for (var i= 0, len= a.length; i<len; i++) {
      if(a[i] !== b[i]){
        equal = false;
        break;
      }
    }

    return equal;
  }

  /**
   * Freeze a row
   * @param row - row data object
   * @param noRender - do not render
   * @param mainData - (Array optional)
   */
  function freezeRow(row, noRender, mainData) {
    if (this._frozenRows.indexOf(row) > -1) {
      console.warn('Bento Table: This row is already frozen.');
      return;
    }

    // Remove row from base data
    var dataArray = mainData || this._data.data,
        index = dataArray.indexOf(row)
    ;

    dataArray.splice(index, 1);

    // Add a bookmark as the position in Data
    row['__btDataIndex'] = index;

    // Add row to the frozen row
    this._frozenRows.push(row);
    this._table.addFrozenRow();

    // Remove and add row size from rowSizes to frozenRowSizes in BentoTable
    this._table.frozenRowSizes.push(this._table.rowSizes.splice(index, 1)[0]);

    // Calculate row size indexes
    this._table.calcGridRowSizeArray(0, true);
    this._table.calcGridRowSizeArray(index);

    // Will render
    if (!noRender) {
      // Sort if necessary before rendering
      if (typeof this._sortedDataColIndex !== 'undefined') {
        var col = this._sortedDataColIndex;
        var data;
        if (this._sortedDesc) {
          //frozen rows
          data = this._sorter.sort(this._frozenRows, this._table.frozenRowSizes, function (a, b) {
            return a[col] < b[col];
          });
        } else {
          //frozen rows
          data = this._sorter.sort(this._frozenRows, this._table.frozenRowSizes, function (a, b) {
            return a[col] > b[col];
          });
        }

        this._frozenRows = data.rows;
        this._table.frozenRowSizes = data.rowSizes;
      }

      this._table.render();
      this._table.refreshScrollBars();
    }
  }

  /**
   * Unfreeze a row
   * @param row - row data object
   * @param mainData - (Array optional)
   */
  function unfreezeRow(row, noRender, mainData) {
    // Remove frozen row
    var index,
        rowSize,
        dataArray = mainData || this._data.data;
    ;
    index = this._frozenRows.indexOf(row);

    // The row doesn't exit in the frozen area
    if (index < 0) {
      console.warn('Bento Table: This row is already unfrozen.');
      return;
    }

    this._frozenRows.splice(index, 1);
    this._table.removeFrozenRow(index);
    rowSize = this._table.frozenRowSizes.splice(index, 1)[0];

    // Add back to data
    // Condition 1: check if there is a sort -> use b-search to insert
    // Condition 2: No Sort

    //[Condition 1]
    if (typeof this._sortedDataColIndex !== 'undefined') {
      var col = this._sortedDataColIndex
      ;
      // Descending
      if (this._sortedDesc) {
        index = this._sorter.findIndex(dataArray, function (a, b) {
            return a[col] >= row[col] && row[col] >= b[col];
          },
          function (a, b) {
            // too small
            if (row[col] > a[col]) {
              return -1;
            } else
            // too big
            if (row[col] < b[col]) {
              return 1;
            } else {
              return 0
            }
          }
        );

      }
      // Ascending
      else {
        index = this._sorter.findIndex(dataArray, function (a, b) {
            return a[col] <= row[col] && row[col] <= b[col];
          },
          function (a, b) {
            // too small
            if (row[col] < a[col]) {
              return -1;
            } else
            // too big
            if (row[col] > b[col]) {
              return 1;
            } else {
              return 0
            }
          });
      }
    } else
    // [Condition 2]
    // insert the row back to its original location in the data array
    // no need to worry about the sorting for now because it'll be resorted
    if (typeof row['__btDataIndex'] !== 'undefined') {
      index = row['__btDataIndex'];
    } else {
      index = 0;
    }

    delete row['__btDataIndex'];
    // Insert the row back and update the rowSize
    dataArray.splice(index, 0, row);
    this._table.rowSizes.splice(index, 0, rowSize);

    // Calculate row size indexes
    this._table.calcGridRowSizeArray(0, true);
    this._table.calcGridRowSizeArray(index);

    if (!noRender) {
      this._table.render();
      this._table.refreshScrollBars();
    }
  }

  /**
   * Renders an object to BentoCell
   * @param cell - (BentoCell) cell to be rendered
   *
   * This will be overridden based on the type of the object
   */
  function renderCell(cell) {
    if(this.updateObjectsForRender(cell, false)) {
      this.renderCellDefault(cell);
      cell.parent.applyClasses();
    }
  }

  /**
   * Render a frozen cell from frozen row array
   * @param cell
   */
  function renderFrozenCell(cell) {
    if(this.updateObjectsForRender(cell, true)) {
      this.renderCellDefault(cell);
      cell.parent.applyClasses();
    }
  }

  /**
   * Most default cell dom rendering based on template and other column types
   * @param cell
   */
  function renderCellDefault(cell) {
    if (this._cColumn.type === 'template' && !!this._cColumn.template) {
      this._cColumnTemplate = this._columnTemplateStack[this._cColumn.template];
      // Create custom template the first time
      if (typeof this._cColumnTemplate === 'undefined') {
        this._cColumnTemplate = new BentoTableCellTemplateColumn(this._scope, this._compile, this._attrs.bentoTable);
        this._cColumnTemplate.setTemplate(document.getElementById(this._cColumn.template).textContent);
        this._columnTemplateStack[this._cColumn.template] = this._cColumnTemplate;
      }
      //use template to render
      this._cColumnTemplate.applyContentToCell(this._cellObj, cell, this._rowObj);
    } else if (!!this._cColumn.type && this._columnTypeObjs[this._cColumn.type]) {
      this._columnTypeObjs[this._cColumn.type].applyContentToCell(this._cellObj, cell);
    } else {
      this._columnTypeObjs.default.applyContentToCell(this._cellObj, cell);
    }
  }

  /**
   * Prepare objects for cell render
   * @param cell
   * @param isFrozen
   * @returns {boolean} - OK to render
   */
  function updateObjectsForRender(cell, isFrozen) {
    var col = cell.col;
    if(this._cColumn = this.getColumnByIndex(col)) {
      this._rowObj = this.getRowByIndex(cell.row, isFrozen);
      this._cellObj = this.getCellByIndex(cell.row, this._cColumn, isFrozen);
      return true;
    }else{
      return false;
    }
  }

  /**
   * Sort data based on the colIndex and order
   * @param colIndex (number)
   * @param desc (bool)
   * @param isInfiniteScroll (bool)
   */
  function sort(colName, desc, isInfiniteScroll) {
    var col = colName,
        data, frozenData
    ;
    this._prepSort(col, desc);
    // descending sort
    if (desc) {
      if(!isInfiniteScroll) {
        data = this._sorter.sort(this._data.data, this._table.rowSizes, function (a, b) {
          return a[col] < b[col];
        });
      }

      //frozen rows
      frozenData = this._sorter.sort(this._frozenRows, this._table.frozenRowSizes, function (a, b) {
        return a[col] < b[col];
      });
    }
    // ascending sort
    else {
      if(!isInfiniteScroll) {
        data = this._sorter.sort(this._data.data, this._table.rowSizes, function (a, b) {
          return a[col] > b[col];
        });
      }

      //frozen rows
      frozenData = this._sorter.sort(this._frozenRows, this._table.frozenRowSizes, function (a, b) {
        return a[col] > b[col];
      });
    }

    if(!isInfiniteScroll) {
      this._data.data = data.rows;
      this._table.rowSizes = data.rowSizes;
    }else{
      this._data.data = [];
      this._table.rowSizes = [];
    }

    this._frozenRows = frozenData.rows;
    this._table.frozenRowSizes = frozenData.rowSizes;
  }

  /**
   * Prepare for sorting
   * This function will store sorting config for later use this function needs to be called
   * everytime when a sort is fired, even it is an override function
   * Will be used by the follow functions:
   *  - unfreezeRow
   *
   * @param col
   * @param desc
   * @private
   */
  function _prepSort(col, desc) {
    this._sortedDataColIndex = col;
    this._sortedDesc = desc;
  }

  /**
   * Get a row data array by row index
   * @param rowIndex
   * @returns {*} - row data array
   */
  function getRowByIndex(rowIndex, isFrozen) {
    return isFrozen ? this._frozenRows[rowIndex] : this._data.data[rowIndex];
  }

  /**
   * Get Column object based on the table column index
   * @param colIndex
   * @returns {*}
   */
  function getColumnByIndex(colIndex) {
    return this._data.columns[this._columnIndexRefArray[colIndex]];
  }

  /**
   * Get a cell data object from Table row and column indexes
   * @param rowIndex
   * @param colIndex
   * @returns {*}
   */
  function getCellByIndex(rowIndex, columnObj, isFrozen) {
    return this.getRowByIndex(rowIndex, isFrozen)[columnObj.name];
  }

  /**
   * Get total rows for table to render
   * @returns {number}
   */
  function getNumRows() {
    return this._data.data.length;
  }

  /**
   * Gets the total number of columns that should be rendered
   * @returns {number}
   */
  function getNumCols() {
    return this._columnIndexRefArray.length;
  }

  /**
   * Remove Column index from reference
   * @param colIndex
   */
  function removeColumnIndex(colIndex) {
    var index = this._columnIndexRefArray.indexOf(colIndex);
    if (index > -1) {
      this._columnIndexRefArray.splice(index, 1);
    }
  }

  /**
   * Return an original column index from the table index
   * @param tableColumnIndex
   * @returns {number}
   */
  function getDataColunmIndex(tableColumnIndex) {
    return this._columnIndexRefArray[tableColumnIndex];
  }

  /**
   * Apply options to table
   */
  function applyTableOptions() {
    // Update initial column width
    this._table.setColumnWidth(this._colIndexArray, this._colWidthArray);

    this._colIndexArray = null;
    this._colWidthArray = null;

    delete this._colIndexArray;
    delete this._colWidthArray;
  }

  /**
   * Parse columns based on the `hide` prameters
   * @param columns
   */
  function parseColumnDefinitions(columns) {
    this._columnIndexRefArray = [];
    var colDef, i, len;
    var offsetColWidth = this._options.rowSelectColumnWidth? this._options.rowSelectColumnWidth : 40;


    if(this._colOffset > 0){
      for(i=0,len=this._colOffset; i<len; i++){
        this._colIndexArray.push(0); // spacer
        this._colWidthArray.push(offsetColWidth); // default
        this._columnIndexRefArray.push(0);
      }
    }


    for (i = 0, len = columns.length; i < len; i++) {
      colDef = columns[i];
      if (colDef.hide !== true) {

        if (colDef.width && colDef.width > 0) {
          this._colIndexArray.push(this._columnIndexRefArray.length);
          this._colWidthArray.push(colDef.width);
        }
        this._columnIndexRefArray.push(i);
      }
    }
  }
})();
var bentoTableApp = bentoTableApp;

(function(angular){

  bentoTableApp = bentoTableApp || angular.module('bento.table',[]);

  bentoTableApp
    .factory('tableFacotry', function(){
      return{
        /**
         * Build sort object for the controller to use
         * @param sortAttr
         * @param header
         *
         * sortAttr needs to be either a Boolean or an Object
         *
         * Boolean: decides if all the columns are sortable or not
         *
         * Object:
         *    -
         *
         */
        buildSortOptions : function(sortAttr, header){

          if(typeof header != 'undefined' && header) {

            var sortOptions = [];
            var noSortArray = [];
            var initSort = {
              column : -1,
              direction: 'asc'
            };


            //Get the noSort reference ready
            if(typeof sortAttr.noSort != 'undefined'){
              var noSortData = sortAttr.noSort.splice(',');
              for(var i = 0; i < noSortData.length; i++){
                noSortArray[parseInt(noSortData[i])] = true;
              }
            }

            //See if there is an initial sort value specified
            if(typeof sortAttr.initSort != 'undefined'){
              initSort.column = parseInt(sortAttr.initSort.column);
              initSort.direction = (sortAttr.initSort.direction == 'desc') ? 'desc' : 'asc';
            }

            //Construct the confuguration
            for(var i = 0; i < header.length; i++) {
              var option = {};

              if (typeof sortAttr == 'boolean') {
                option.sortable = sortAttr;
              } else if (typeof sortAttr == 'object') {
                option.sortable = (noSortArray[i] === true) ? false : true;
              } else {
                option.sortable = true;
              }

              sortOptionspush(option);

            }

            return {
              initSort : iniSort,
              options  : sortOptions
            };

          }
        }
      }

    });

})(window.angular);

/**
 * Constructor
 * @param data
 * @param bentoTable
 * @param options
 * @param scope
 * @param $compile
 * @param attrs
 * @private
 */
function BentoTableGroupingHelper(data, bentoTable, options, scope, $compile, attrs) {
  BentoTableHelper.apply(this, arguments);
  var helper = this;

  // Variables
  this._groupingArray = null; // Array to sort groups in group hierarchy
  this._rowRefArray = null; // Main reference to show what is in the table viewport in order
  this._groupColName = null;  // Column index that is actually grouping the whole table
  this._table = bentoTable; // table reference to (BentoTable) object
  this._dataSize = this._data.data.length;
  this._rowPropertyMap = null // Row property map
  this._rowPropertyRefArray = null; // Fallback: Reference to link row and its properties
  this._rowPropertyArray = null; // Fallback: Refernce to row properties defined by `this._rowPropertyRefArray`

  this._table.onRowClick(function (event) {
    helper._onRowClick(event)
  });

  // Private constant label variables
  var uid = [Math.round(Math.random() * 100000), Math.round(Math.random() * 100000)].join('');
  this._labelBTDataIndex = ['__btDataIndex', uid].join('');
  this._labelBTGroupParent = ['_btGroupParent', uid].join('');
  this._labelBTRowRefDataIndex = ['__btRowRefDataIndex', uid].join('');
  this._labelBTGroupMember = ['_btGroupMember', uid].join('');
}

(function (undefined) {
  'use strict';
  // Inherit from BentoTableHelper
  BentoTableGroupingHelper.prototype = Object.create(BentoTableHelper.prototype);
  BentoTableGroupingHelper.prototype.constructor = BentoTableGroupingHelper;

  //Method Overrides
  BentoTableGroupingHelper.prototype.getRowByIndex = getRowByIndex;
  BentoTableGroupingHelper.prototype.getCellByIndex = getCellByIndex;
  BentoTableGroupingHelper.prototype.getDataForRender = getDataForRender;
  BentoTableGroupingHelper.prototype.getNumRows = getNumRows;
  BentoTableGroupingHelper.prototype.renderCell = renderCell;
  BentoTableGroupingHelper.prototype.concatData = concatData;
  BentoTableGroupingHelper.prototype.sort = sort;
  BentoTableGroupingHelper.prototype.freezeRow = freezeRow;
  BentoTableGroupingHelper.prototype.unfreezeRow = unfreezeRow;
  BentoTableGroupingHelper.prototype.fireRowClickCallbacks = fireRowClickCallbacks;
  BentoTableGroupingHelper.prototype.getParentVariableName = getParentVariableName;

  //New Method
  BentoTableGroupingHelper.prototype.setGrouping = setGrouping;
  BentoTableGroupingHelper.prototype.expandRow = expandRow;
  BentoTableGroupingHelper.prototype.collapseRow = collapseRow;
  BentoTableGroupingHelper.prototype.getRowProperty = getRowProperty;
  BentoTableGroupingHelper.prototype.setRowProperty = setRowProperty;
  BentoTableGroupingHelper.prototype.deleteRowProperty = deleteRowProperty;

  //Private Methods
  BentoTableGroupingHelper.prototype._buildRowRefArray = _buildRowRefArray;
  BentoTableGroupingHelper.prototype._onRowClick = _onRowClick;

  /**
   * Expose group parent variable for other helpers to use
   * @returns {string|*|BentoTableGroupingHelper._labelBTGroupParent}
   */
  function getParentVariableName() {
    return this._labelBTGroupParent;
  }

  /**
   * Freeze a row and it needs to be a group-member
   * @param row
   * @param noRender - do not render
   * @param mainData - (Array optional)
   */
  function freezeRow(row, noRender) {
    if (typeof row === 'object') {
      if (this._frozenRows.indexOf(row) > -1) {
        console.warn('Bento Table: This row is already frozen.');
        return;
      }

      this._frozenRows.push(row);

      // Remove row from base data
      var
        index
      ;

      if (this.getRowProperty(row, this._labelBTGroupParent)) {
        this.setRowProperty(
          row, this._labelBTDataIndex,
          this.getRowProperty(row, this._labelBTGroupParent).removeMember(row, this._labelBTGroupParent));
      } else {
        index = this._groupingArray.indexOf(row);
        this._groupingArray.splice(index, 1);
        this.setRowProperty(row, this._labelBTDataIndex, index);
        this.setRowProperty(row, this._labelBTRowRefDataIndex, this._rowRefArray.indexOf(row));
      }

      index = this._rowRefArray.indexOf(row);
      this._table.addFrozenRow();

      this._rowRefArray.splice(index, 1);
      this._table.removeRow(index, 1);

      // TODO: update the sizes

    } else {
      console.warn('Bento Table: Can not freeze a group.');
    }
  }

  /**
   * Unfreeze a row and put it back to the group
   * @param row
   */
  function unfreezeRow(row) {
    if (this._frozenRows.indexOf(row) === -1) {
      console.warn('Bento Table: this row is not frozen.')
      return;
    }

    var index, col, rowCol;
    // This row is part of a group
    if (this.getRowProperty(row, this._labelBTGroupParent)) {

      var group = this.getRowProperty(row, this._labelBTGroupParent);

      if (typeof this._sortedDataColIndex !== 'undefined') {
        col = this._sortedDataColIndex;
        rowCol = this.getRowProperty(row, col);
        if (this._sortedDesc) {
          index = this._sorter.findIndex(
            group.members,
            function (a, b) {
              return this.getRowProperty(a, col) >= rowCol && rowCol >= this.getRowProperty(b, col);
            },
            function (a, b) {
              if (this.getRowProperty(a, col) < rowCol) {
                return -1;
              }
              if (this.getRowProperty(b, col) > rowCol) {
                return 1;
              }
              return 0;
            }
          );
        } else {
          index = this._sorter.findIndex(
            group.members,
            function (a, b) {
              return this.getRowProperty(a, col) <= rowCol && rowCol <= this.getRowProperty(b, col);
            },
            function (a, b) {
              if (this.getRowProperty(a, col) > rowCol) {
                return -1;
              }
              if (this.getRowProperty(b, col) < rowCol) {
                return 1;
              }
              return 0;
            }
          );
        }
        group.addMember(row, index, this._labelBTGroupParent, this);
      } else {
        // not sorted
        group.addMember(
          row,
          this.getRowProperty(row, this._labelBTDataIndex),
          this._labelBTGroupParent,
          this);
      }

      this._buildRowRefArray();

      if (group.isExpanded) {
        index = this._rowRefArray.indexOf(group);
        this._table.addRow(index == 0 ? 0 : index - 1, 1);
      } else {
        this._table.render();
      }
    }
    else {

      // This is an independent row
      if (typeof this._sortedDataColIndex !== 'undefined') {

        col = this._sortedDataColIndex;
        rowCol = this.getRowProperty(row, col);
        if (this._sortedDesc) {
          index = this._sorter.findIndex(
            this._groupingArray,
            function (a, b) {
              if (a instanceof BentoTableGroupingRow) {
                a = (a.row) ? this.getRowProperty(a.row, col) : a.name;
              } else {
                a = this.getRowProperty(a, col);
              }
              if (b instanceof BentoTableGroupingRow) {
                b = (b.row) ? this.getRowProperty(b.row, col) : b.name;
              } else {
                b = this.getRowProperty(b, col);
              }
              return a >= rowCol && rowCol >= b;
            },
            function (a, b) {
              if (a instanceof BentoTableGroupingRow) {
                a = (a.row) ? this.getRowProperty(a.row, col) : a.name;
              } else {
                a = this.getRowProperty(a, col);
              }
              if (b instanceof BentoTableGroupingRow) {
                b = (b.row) ? this.getRowProperty(b.row, col) : b.name;
              } else {
                b = this.getRowProperty(b, col)
              }

              if (a < rowCol) {
                return -1;
              }
              if (b > rowCol) {
                return 1;
              }
              return 0;
            }
          );
        } else {
          index = this._sorter.findIndex(
            this._groupingArray,
            function (a, b) {
              if (a instanceof BentoTableGroupingRow) {
                a = (a.row) ? this.getRowProperty(a.row, col) : a.name;
              } else {
                a = this.getRowProperty(a, col);
              }
              if (b instanceof BentoTableGroupingRow) {
                b = (b.row) ? this.getRowProperty(b.row, col) : b.name;
              } else {
                b = this.getRowProperty(b, col)
              }
              return a <= rowCol && rowCol <= b;
            },
            function (a, b) {
              if (a instanceof BentoTableGroupingRow) {
                a = (a.row) ? this.getRowProperty(a.row, col) : a.name;
              } else {
                a = this.getRowProperty(a, col);
              }

              if (b instanceof BentoTableGroupingRow) {
                b = (b.row) ? this.getRowProperty(b.row, col) : b.name;
              } else {
                b = this.getRowProperty(b, col)
              }

              if (a > rowCol) {
                return -1;
              }
              if (b < rowCol) {
                return 1;
              }
              return 0;
            }
          );
        }
        this._groupingArray.splice(index, 0, row);
      } else {
        // not sorted
        var rowProp = this.getRowProperty(row, this._labelBTRowRefDataIndex);
        index = rowProp ? rowProp : 0;
        this._groupingArray.splice(rowProp, 0, row);
      }

      this._buildRowRefArray();
      // insert this row back to refArray
      this._table.addRow(index, 1);
    }

    this.deleteRowProperty(row, this._labelBTDataIndex);
    this.deleteRowProperty(row, this._labelBTRowRefDataIndex);

    this._frozenRows.splice(this._frozenRows.indexOf(row), 1);
    this._table.removeFrozenRow();
    this._table.render();
    this._table.refreshScrollBars();
  }

  /**
   * Concat new data to the main data
   * @param data
   * @param newData
   * @returns {*}
   */
  function concatData(mainData, newData) {
    //We need to update _groupingArray and _rowRefArray with new rows
    // Grouping process
    this._data.data = mainData.concat(newData);
    this.setGrouping(this._data.data, this._options.group.by, this._options.group.expanded, this._options.group.referencingTo);
    return this._data.data;
  }

  /**
   * Fires row click
   * @param event
   * @private
   */
  function fireRowClickCallbacks(event) {
    // Find current col of clicked row

    // We do not fire row click even on group header rows
    var colIndex = __findColFromRowClick(event);
    if (colIndex === false || (event.row.hasClass('bt-group') && colIndex >= this._colOffset)) {
      return;
    }

    BentoTableHelper.prototype.fireRowClickCallbacks.call(this, event);
  }

  /**
   * Helper function to find the col index that is clicked on a row
   * @param event
   */
  function __findColFromRowClick(event) {
    var obj = event.target;
    while (obj && typeof obj.cell === 'undefined') {
      obj = obj.parentElement;
    }

    return obj ? obj.cell.col : false;
  }

  /**
   * Returns a data array for render (override)
   * @returns {*}
   */
  function getDataForRender() {
    return this._rowRefArray;
  }

  /**
   * Handles events when a row is clicked
   * @param event
   */
  function _onRowClick(event) {
    // we do not expand or collapse row if clicked col is in the column offset indexes
    var colIndex = __findColFromRowClick(event);
    if (colIndex === false || (__findColFromRowClick(event) < this._colOffset)) {
      return
    }

    var row = event.row;

    // This row needs to be a group header
    // AND the first column is clicked
    if (row.hasClass('bt-group')) {
      // Expand and Collapse Row for row grouping
      row.toggleClass('bt-group-expanded');
      if (row.hasClass('bt-group-expanded')) {
        this.expandRow(event.rowIndex);
      } else {
        this.collapseRow(event.rowIndex);
      }
    }

    event.preventDefault();
    event.stopPropagation();
  }

  /**
   * Renders an object to BentoCell
   * @param cell - (BentoCell) cell to be rendered
   *
   * This will be overridden based on the type of the object
   */
  function renderCell(cell) {
    this.updateObjectsForRender(cell, false);
    if (this._rowObj instanceof BentoTableGroupingRow) {
      // clear
      if (cell.col - this._colOffset === 0) {
        cell.parent.removeClass('bt-group-member', true);
        cell.parent.addClass('bt-group', true);

        cell.addClass('bt-group-row-head', true);
        if (this._rowObj.isExpanded) {
          cell.parent.addClass('bt-group-expanded', true);
        }
        if (this._rowObj.row) {
          cell.parent.addClass('bt-group-leader', true);
          this.renderCellDefault(cell);
        } else {
          cell.html(this._rowObj.name);
        }
      } else {

        cell.removeClass('bt-row-head', true);
        // only render for group leader row
        if (this._rowObj.row) {
          this.renderCellDefault(cell);
        }
      }
    } else {
      cell.parent.removeClass('bt-group', true);
      cell.parent.removeClass('bt-group-expanded', true);
      cell.parent.removeClass('bt-group-leader', true);
      try {
        if (this.getRowProperty(this._rowObj, this._labelBTGroupMember)) {
          cell.parent.addClass('bt-group-member', true);
          if (cell.col - this._colOffset === 0) {
            cell.addClass('bt-group-row-head', true);
          } else {
            cell.removeClass('bt-group-row-head', true);
          }
        } else {
          if (cell.col - this._colOffset === 0) {
            cell.parent.removeClass('bt-group-member', true);
          }
        }
      } catch (e) {
        console.error(e);
      }
      this.renderCellDefault(cell);
    }

    cell.parent.applyClasses();
  }

  /**
   * Sort the current grouped table
   * @param this._sorter - (BentoTableSort) object
   * @param colName - (number) column index that needs to be sorted
   * @param desc - (bool) Descending
   */
  function sort(colName, desc) {
    var cIndex = colName;
    var i, len, group;
    this._prepSort(colName, desc);
    // descending sort
    if (desc) {
      // sort grouping array
      this._groupingArray = this._sorter.sort(this._groupingArray, null, function (a, b) {

        if (a instanceof BentoTableGroupingRow) {
          a = (a.row) ? a.row[cIndex] : a.name;
        } else {
          a = a[cIndex]
        }

        if (b instanceof BentoTableGroupingRow) {
          b = (b.row) ? b.row[cIndex] : b.name;
        } else {
          b = b[cIndex]
        }

        return a < b;
      }).rows;

      // sort the members in each group
      for (i = 0, len = this._groupingArray.length; i < len; i++) {
        group = this._groupingArray[i];
        if (group instanceof BentoTableGroupingRow) {
          group.members = this._sorter.sort(group.members, null, function (a, b) {
            return a[cIndex] < b[cIndex];
          }).rows;
        }
      }

    }
    // ascending sort
    else {
      // sort grouping array
      this._groupingArray = this._sorter.sort(this._groupingArray, null, function (a, b) {

        if (a instanceof BentoTableGroupingRow) {
          a = (a.row) ? a.row[cIndex] : a.name;
        } else {
          a = a[cIndex]
        }

        if (b instanceof BentoTableGroupingRow) {
          b = (b.row) ? b.row[cIndex] : b.name;
        } else {
          b = b[cIndex]
        }

        return a > b;
      }).rows;

      // sort the members in each group
      for (i = 0, len = this._groupingArray.length; i < len; i++) {
        group = this._groupingArray[i];
        if (group instanceof BentoTableGroupingRow) {
          group.members = this._sorter.sort(group.members, null, function (a, b) {
            return a[cIndex] > b[cIndex];
          }).rows;
        }
      }
    }

    // Rebuild `rowRefArray` for redering
    this._buildRowRefArray();
  }

  /**
   * Get cell by given row and column indexes
   * @param col
   * @param rowIndex
   * @returns {BentoTableGroupingRow || cell || null}
   */
  function getCellByIndex(rowIndex, col, isFrozen) {
    var row = isFrozen ? this._frozenRows[rowIndex] : this._rowRefArray[rowIndex];

    if (row instanceof BentoTableGroupingRow) {
      if (row.row) {
        return row.row[col.name];
      } else {
        if (col === 0) {
          return row.name;
        } else {
          return null;
        }
      }
    } else {
      try {
        return row[col.name];
      } catch (e) {
        console.error(e);
      }
    }
  }

  /**
   * Expand a row
   * @param rowIndex
   *
   * rowIndex has to reference to a BentoTableGroupingRow
   */
  function expandRow(rowIndex) {
    var group = this._rowRefArray[rowIndex];
    if (group instanceof BentoTableGroupingRow && !group.isExpanded) {
      var i,
          length = group.members.length;
      group.isExpanded = true;

      for (i = 0; i < length; i++) {
        this._rowRefArray.splice(rowIndex + 1 + i, 0, group.members[i]);
      }

      this._table.addRow(rowIndex, length);
    }
  }

  /**
   * Collapse a row
   * @param rowIndex
   *
   * rowIndex has to reference to a BentoTableGroupingRow
   */
  function collapseRow(rowIndex) {
    var group = this._rowRefArray[rowIndex];
    if (group instanceof BentoTableGroupingRow && group.isExpanded) {
      var i,
          length = group.members.length;
      group.isExpanded = false;
      for (i = 0; i < length; i++) {
        this._rowRefArray.splice(rowIndex + 1, 1);
      }

      this._table.removeRow(rowIndex, length);
    }
  }

  /**
   * Setup grouping references and indexes
   * @param groupBy - (number) Column Index
   * @param isExpanded - (bool) Check if all groups are expanded or not
   * @param groupedByColumnContent - (bool) check if grouping is based on who column content is
   * @param groupFlag
   *
   * We do one group for now
   */
  function setGrouping(sourceData, groupBy, isExpanded, referencingTo) {
    var tempArray = [], groupByObj, type, i, length, row;
    this._groupColName = groupBy;

    // Determine browser support for Map
    if (Map) {
      console.log('use Map');
      this._rowPropertyMap = new Map();
    }
    // IE10 and lower
    else {
      console.log('use fallback');
      this._rowPropertyRefArray = [];
      this._rowPropertyArray = [];
    }

    this._groupingArray = [];

    // Grouping
    length = sourceData.length;

    // There is parent / child relationship
    if (typeof referencingTo !== 'undefined') {
      /*
       Logic: 3 step approach
       1. Create an array with all children rows categorized by parent referencingTo parameter
       2. Create an array with all isolated rows
       3. Combine the two array with parent-child relationship
       */
      var childrenArray = [];
      var childArray;
      // Separate children and parent-to-bes
      for (i = 0; i < length; i++) {
        row = sourceData[i];
        groupByObj = row[this._groupColName];
        type = typeof groupByObj;

        if ((type === 'number') || (type === 'string' && groupByObj.length > 0)) {
          childArray = childrenArray[groupByObj];
          if (typeof childArray === 'undefined') {
            childArray = [];
            childrenArray[groupByObj] = childArray;
          }
          // Mark this row as a member
          this.setRowProperty(row, this._labelBTGroupMember, true);
          childArray.push(row);
        } else {
          tempArray.push(row);
        }
      }

      // Combine the two arrays
      var childrenGroup;
      for (i = 0, length = tempArray.length; i < length; i++) {
        row = tempArray[i];
        if (childrenArray[row[referencingTo]]) {
          childrenGroup = childrenArray[row[referencingTo]];
          childrenGroup['_tempGroupLeader'] = true;
          childrenGroup['_leader'] = row;
          this.setRowProperty(row, '_btGroup', true);
          tempArray[i] = childrenGroup;
        }
      }
    }
    else {
      for (i = 0; i < length; i++) {
        row = sourceData[i];
        groupByObj = row[this._groupColName];
        if (typeof tempArray[groupByObj] === 'undefined') {
          tempArray[groupByObj] = [];
          tempArray[groupByObj]['_tempGroupLeader'] = true;
        }
        this.setRowProperty(row, this._labelBTGroupMember, true);
        tempArray[groupByObj].push(row);
      }
    }

    // Put Grouping to index
    var group, groupArr;
    for (var key in tempArray) {
      groupArr = tempArray[key];
      if (Array.isArray(groupArr) && groupArr['_tempGroupLeader']) {
        group = new BentoTableGroupingRow(key, isExpanded);
        group.addMembers(tempArray[key], this._labelBTGroupParent, this);
        if (groupArr['_leader']) {
          group.row = groupArr['_leader'];
        }
      } else {
        // There is no children
        group = groupArr;
      }
      // Using array since it's faster than Object referencing
      this._groupingArray.push(group);
    }

    // Build RefArray
    this._buildRowRefArray();

    // Remove column index that's been grouped by
    this.removeColumnIndex(groupBy);
  }

  /**
   * Get number of rows
   * @returns {number}
   */
  function getNumRows() {
    //check if row is changed
    if (this._dataSize !== this._data.data.length) {
      // update reference array

      this._dataSize = this._data.data.length;
    }

    return this._rowRefArray.length;
  }

  /**
   * Return row object from Data by new rowNumber
   * @param rowNum (number)
   */
  function getRowByIndex(rowIndex, isFrozen) {
    return isFrozen ? this._frozenRows[rowIndex] : this._rowRefArray[rowIndex];
  }

  /**
   * Get property of a row
   * @param row
   * @param label
   * @returns {*}
   */
  function getRowProperty(row, label) {
    var prop;
    prop = Map ?
      this._rowPropertyMap.get(row)
      : this._rowPropertyArray[
        this._rowPropertyRefArray.indexOf(row)
        ];

    if (prop) {
      return prop[label];
    }
    return prop;
  }

  /**
   * Set proerty of a row
   * @param row
   * @param label
   * @param value
   */
  function setRowProperty(row, label, value) {

    if (Map) {
      var prop;
      if (!this._rowPropertyMap.has(row)) {
        prop = {};
        this._rowPropertyMap.set(row, prop);
      } else {
        prop = this._rowPropertyMap.get(row);
      }
      prop[label] = value
      return;
    }

    // Fallback for IE10 and lower
    var index = this._rowPropertyRefArray.indexOf(row);
    if (index == -1) {
      index = this._rowPropertyRefArray.length;
      this._rowPropertyRefArray.push(row);
      this._rowPropertyArray[index] = {};
    }
    this._rowPropertyArray[index][label] = value;
  }

  /**
   * Delete a row property
   * @param row
   * @param label
   */
  function deleteRowProperty(row, label) {
    if (Map) {
      delete this._rowPropertyMap.get(row)[label];
    }
    // Fallback: IE10 and lower
    else {
      delete this._rowPropertyArray[
        this._rowPropertyRefArray.indexOf(row)
        ][label];
    }

  }

  // Private functions
  /**
   * Build this._rowRefArray for table rendering
   */
  function _buildRowRefArray() {
    this._rowRefArray = [];

    for (var i = 0, length = this._groupingArray.length, group; i < length; i++) {
      group = this._groupingArray[i];
      this._rowRefArray.push(group);
      if (group.isExpanded) {
        for (var j = 0, lengthJ = group.members.length; j < lengthJ; j++) {
          this._rowRefArray.push(group.members[j]);
        }
      }
    }
  }
})();

var BentoTableGroupingRow;

(function () {
  'use strict';

  BentoTableGroupingRow = b;
  b.prototype.addMember = addMember;
  b.prototype.addMembers = addMembers;
  b.prototype.removeMember = removeMember;

  /**
   * Constructor
   * @param name
   * @param isExpanded
   */
  function b(name, isExpanded) {
    this.name = name;
    this.members = [];
    this.isExpanded = isExpanded;
    this.row = null; // init row
  }

  /**
   * Removing a member from this group
   * @param member
   * @returns {boolean}
   */
  function removeMember(member, parentLabel) {
    var index = this.members.indexOf(member);

    if (index > -1) {
      this.members.splice(index, 1);
      return index;
    } else {
      return false;
    }
  }

  /**
   * Adding a member to this group
   * @param member (*)
   */
  function addMember(member, index, parentLabel, tableGroupHelper) {
    tableGroupHelper.setRowProperty(member, parentLabel, this);
    if (typeof index !== 'undefined') {
      // Put the member back to `index` position in this group
      this.members.splice(index, 0, member);
    } else {
      this.members.push(member);
    }
  }

  /**
   * Adding multiple members to this group
   * @param members (array)
   */
  function addMembers(members, parentLabel, tableGroupHelper) {
    for (var i = 0, len = members.length; i < len; i++) {
      tableGroupHelper.setRowProperty(members[i], parentLabel, this);
    }
    this.members = this.members.concat(members)
  }
})();



function BentoTableHeader(width, height, options) {
  'use strict';

  var h = this;

  // API
  h.setNumColumns = setNumColumns;
  h.reset = reset;
  h.renderCell = renderCell;
  h.onColumnResize = onColumnResize;
  h.removeFrozenRow = removeFrozenRow;
  h.addFrozenRow = addFrozenRow;
  h.onRowClick = onRowClick;
  h.frozenRows = [];
  this.options = options;

  init();

  var resizeBar;
  var _columnResizeCallbackStack = [];
  var _rowClickCallback = [];
  var isResizing = false;

  /**
   * Remove header classes and frozen rows
   */
  function reset(){
    this.frozenRows.forEach(function(row){
      row.remove();
    });
    h.row.removeClass('bt-row-selected');

    var fCell = h.row.getFirstCell();
    var tempCell = fCell;

    do{
      tempCell.top = tempCell.bottom = tempCell;
      tempCell = tempCell.right;
    }
    while(tempCell !== fCell)
  }

  /**
   * Append row click callback to stack
   * @param callback
   */
  function onRowClick(callback) {
    _rowClickCallback.push(callback);
  }

  function _onRowClick(event) {
    var i, len,
        rows = h.dom.querySelectorAll('.bt-frozen-row');
    ;
    event.isFrozen = true;

    for (i = 0, len = rows.length; i < len; i++) {
      if (rows.item(i) === event.currentTarget) {
        event.rowIndex = i;
        break;
      }
    }

    for (i = 0, len = _rowClickCallback.length; i < len; i++) {
      _rowClickCallback[i](event);
    }
  }

  /**
   * Render a header cell
   * @param headerCell
   * @param colOffset
   */
  function renderCell(headerCell, colObj,scope,compile) {

    headerCell.html(colObj.label);

    /* IE issue with the cache */
    /*if(typeof this._headerCellCache === 'undefined'){
      this._headerCellCache = [];
    }

    if(this._headerCellCache[headerCell.col]){
      console.log('doing cache', this._headerCellCache[headerCell.col]);
      headerCell.html(this._headerCellCache[headerCell.col][0]);
    }else{
      var cellDOM = angular.element(['<div>',colObj.label,'</div>'].join(''));
      compile(cellDOM)(scope);
      this._headerCellCache[headerCell.col] = cellDOM;
      headerCell.html(cellDOM[0]);
    }*/
  }

  /**
   * Remove a frozen row
   */
  function removeFrozenRow(index) {
    var index = index ? index : 0;
    // Remove only when there is at least one frozen row
    var rows = h.dom.querySelectorAll('.bt-frozen-row'),
        rowToRemove = rows[index];
    if (rowToRemove) {
      h.frozenRows.splice(index,1);
      rowToRemove.parentElement.removeChild(rowToRemove);
      rowToRemove.removeEventListener('click', _onRowClick);
      // According to BentoTableRow API
      // destroy() will relinke the top and bottom cells
      rowToRemove.row.destroy();

      for(var i=index,len= h.frozenRows.length; i<len; i++){
        h.frozenRows[i].row = i;
      }
    }
  }

  /**
   * Add a frozen row
   */
  function addFrozenRow() {
    var numCol = h.row.dom.childElementCount;
    var newRow = new BentoTableRow(numCol, width, height);
    newRow.addClass('bt-frozen-row');
    newRow.dom.addEventListener('click', _onRowClick);

    // Add row DOM
    h.dom.appendChild(newRow.dom);

    newRow.row = h.frozenRows.length;
    h.frozenRows.push(newRow);

    // Link row
    var headerCells = h.row.dom.children;
    var rowCells = newRow.dom.children;
    for (var i = 0, len = headerCells.length, hCell, rCell; i < len; i++) {
      hCell = headerCells[i].cell;
      rCell = rowCells[i].cell;
      hCell.top.bottom = rCell;
      rCell.top = hCell.top;
      hCell.top = rCell;
      rCell.bottom = hCell;
    }
  }

  /**
   * Set number of columns for this header
   * @param num
   * @param clickCallback
   */
  function setNumColumns(num, clickCallback) {
    if (typeof h.row === 'undefined') {
      h.row = new BentoTableRow(num, width, height, clickHijack(clickCallback), true); // start with one cell
      h.dom.appendChild(h.row.dom);

      // Add touch down events
      var cells = h.row.dom.children,
          cellDom;
      for (var i = 0; i < cells.length; i++) {
        cellDom = cells[i];
        cellDom.addEventListener('touchstart', onCellMouseDown);
        cellDom.addEventListener('mousedown', onCellMouseDown);
        cellDom.cell.top = cellDom.cell;
        cellDom.cell.bottom = cellDom.cell;
      }
    }
    else {
      var dCount = num - h.row.getNumCells();
      var cell;
      if (dCount > 0) {
        for (var i = 0; i < dCount; i++) {
          cell = new BentoTableCell(h.row, true);
          cell.dom.addEventListener('touchstart', onCellMouseDown);
          cell.dom.addEventListener('mousedown', onCellMouseDown);
          cell.top = cell;
          cell.bottom = cell;
          h.row.push(cell, true, clickHijack(clickCallback));
        }
      }
    }
  }

  /**
   * Hijack Header callbacks
   * @param callback
   * @returns {Function}
   */
  function clickHijack(callback) {
    if (callback) {
      return function (event) {
        // It was a resizing
        // no need to fire callback
        if (isResizing) {
          isResizing = false;
        } else {
          callback(event)
        }
      }
    }
  }

  function onColumnResize(callback) {
    _columnResizeCallbackStack.push(callback);
  }

  // Event Listeners
  var oldX, dX, localX, cellX;
  var cellBoundry, cellRightBound, resizingCol;

  function onCellMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
    resizingCol = event.currentTarget; // Type: Cell.dom
    cellBoundry = resizingCol.getBoundingClientRect();
    cellRightBound = cellBoundry.left + cellBoundry.width;

    //Check if user click the most right 8px of this header cell
    if (event.pageX > cellRightBound - 8 && event.pageX <= cellRightBound && h.options.resize) {
      window.addEventListener('touchmove', onHeaderMouseMouse);
      window.addEventListener('mousemove', onHeaderMouseMouse);
      window.addEventListener('touchend', onHeaderMouseUp);
      window.addEventListener('mouseup', onHeaderMouseUp);
      oldX = event.pageX;
      dX = true;
    }
  }

  function onHeaderMouseMouse(event) {
    cellX = event.pageX - cellBoundry.left;
    // not allowing the cell to be 50px or less wide
    if (cellX < 50) {
      return;
    }

    dX = event.pageX - oldX;
    oldX = event.pageX;
    //show bar
    if (resizeBar.style.display === 'none') {
      resizeBar.style.display = 'block';
      h.dom.setAttribute('data-resizing', '1');
    }

    localX = resizingCol.offsetLeft + cellX;
    resizeBar.style.left = localX;

    event.preventDefault();
    event.stopPropagation();
  }

  function onHeaderMouseUp(event) {
    event.preventDefault();
    event.stopPropagation();

    // Fire resize callback
    if (typeof dX === 'number') {
      var width = resizeBar.offsetLeft - resizingCol.offsetLeft;

      resizingCol.style.width = width + 'px';

      _columnResizeCallbackStack.forEach(function (callback) {
        event.col = resizingCol.cell.col;
        event.width = width;
        callback(event);
      });
      isResizing = true;

      // Reset resizing flag in a moment
      setTimeout(function () {
        isResizing = false
      }, 100);
    }

    resizeBar.style.display = 'none';
    h.dom.removeAttribute('data-resizing');
    // Remove all listeners excpet mousedown & touchstart
    window.removeEventListener('touchmove', onHeaderMouseMouse);
    window.removeEventListener('mousemove', onHeaderMouseMouse);
    window.removeEventListener('touchend', onHeaderMouseUp);
    window.removeEventListener('mouseup', onHeaderMouseUp);
  }

  // initilization
  function init() {
    h.dom = document.createElement('DIV');
    h.dom.className = 'bento-table-header';

    if (h.options.resize) {
      resizeBar = document.createElement('DIV');
      resizeBar.className = 'bt-header-resize-bar';
      resizeBar.style.display = 'none';
      h.dom.appendChild(resizeBar);
      h.dom.className += ' bt-header-is-resizable';
    }
  }

}
(function () {

  var bentoTableApp = angular.module('bento.table', []);

  bentoTableApp
    .controller('bentoTableController', [
      '$scope',
      '$element',
      '$log',
      function ($scope, $element, $log) {
      }])
    .directive('bentoTable', [
      '$compile',
      '$log',
      '$timeout',
      function ($compile, $log, $timeout) {
        return {
          restrict  : 'A',
          scope     : false,
          replace   : true,//
          template  : [
            '<div class="bento-table">',
            ' <div class="bento-table-body">',
            ' </div>',
            '</div>'].join("\n"),
          controller: 'bentoTableController',
          link      : function (scope, element, attrs) {
            // Init
            var data = {data: []},
                body,
                table,
                tableHelper,
                tableRowSelectHelper,
                getSourceData,
                options,
                initialLoad = true,
                state = {},
                colOffset = 0;

            var localScope = scope.$new(false); // inherit from parent
            var control;

            localScope.freezeRow = freezeRow;
            localScope.unfreezeRow = unfreezeRow;

            if (typeof attrs.columnDefinitions === 'undefined') {
              $log.error('Bento Table: Parameter "column-definitions" is missing.')
              return;
            }

            data.columns = scope.$eval(attrs.columnDefinitions);

            // Pulic controls
            if (typeof attrs.bentoTableControl !== 'undefined') {
              control = scope.$eval(attrs.bentoTableControl);
              control.freezeRow = freezeRow;
              control.unfreezeRow = unfreezeRow;
              control.reloadTable = reloadTable;
            }

            // Check basic parameters
            if (typeof attrs.sourceDataCallback === 'undefined') {
              $log.error('Bento Table: Parameter of "source-data-callback" is missing.');
              return;
            }

            getSourceData = scope.$eval(attrs.sourceDataCallback);

            if (typeof getSourceData !== 'function') {
              $log.error('Bento Table: Type of parameter variable `' + attrs.sourceDataCallback + '` is incorrect. It needs to be `function(){return promise}`');
              return;
            }

            init();

            // Get first set of data
            getSourceData(state.currentPage, state.recordsPerPage, state.sortKey, state.sortDirection)
              .then(getDataSuccess, getDataFail);

            // Reload table
            function reloadTable(){
              data.data = [];
              tableHelper.reset();
              table.reset();
              if(tableRowSelectHelper){
                tableRowSelectHelper.clear();
              }
              getSourceData(state.currentPage, state.recordsPerPage, state.sortKey, state.sortDirection)
                .then(getDataSuccess, getDataFail);
            }

            // Freeze a row
            function freezeRow(row) {
              tableHelper.freezeRow(row);
            }

            // Unfreeze a row
            function unfreezeRow(row) {
              tableHelper.unfreezeRow(row);
            }

            function getDataSuccess(newData) {
              // Data is not ready
//              if (typeof newData === 'undefined' || newData.length === 0) {
//                $log.error('Bento Table: Provided source data is either undefined or empty.');
//                return;
//              }

              data.data = tableHelper.concatData(data.data, newData);

              if (table.ready) {
                prepareData();
              }

              // fire dataready callback
              if (!!attrs.sourceDataReadyCallback) {
                var cb = scope.$eval(attrs.sourceDataReadyCallback);
                if (cb) {
                  cb();
                }
              }
            }

            function prepareData() {
              var colOffset = 0;
              var numCols;

              numCols = tableHelper.getNumCols();

              table.setGridSize(tableHelper.getNumRows(), numCols);

              // Fire selected row getter
              if(tableRowSelectHelper){
                if(attrs.getSelectedRows){
                  var getSelectedRows = scope.$eval(attrs.getSelectedRows);
                  getSelectedRows().then(function(selectedRowsObj){

                    tableRowSelectHelper.preSelectRows(
                      table,
                      tableHelper.getDataForRender(),
                      selectedRowsObj.data,
                      selectedRowsObj.key);

                    table.render();
                    // fire selection callback
                    fireRowSelectCallback();
                  });
                }
              }

              if(!options.infiniteScroll && state.sortKey && state.sortDirection){
                tableHelper.sort(state.sortKey, state.sortDirection === 'desc', options.infiniteScroll);
                table.calcGridRowSizeArray(0);
              }

              table.render();


              if (initialLoad) {
                // This includes table.render();
                tableHelper.applyTableOptions();
                initialLoad = null;
              }
            }

            function getDataFail(message) {
              $log.warn(message);
            }

            /*Header*/

            var _col = 0;
            var colSort = [];
            var colObj;
            table.requestHeaderContent(function (headerCell) {
              if (tableRowSelectHelper && headerCell.col === 0) {
                tableRowSelectHelper.renderCell(headerCell);
              } else {
                renderHeader(headerCell);
              }
            });

            function renderHeader(headerCell) {
              _col = headerCell.col;
              colObj = tableHelper.getColumnByIndex(_col);

              if (colObj) {
                table.renderHeaderCell(headerCell, colObj, localScope, $compile);
                if (colSort[_col] === 1) {
                  headerCell.dom.setAttribute('data-sort', 'bt-sort-asc')
                } else if (colSort[_col] === 2) {
                  headerCell.dom.setAttribute('data-sort', 'bt-sort-desc')
                } else {
                  headerCell.dom.removeAttribute('data-sort');
                }
              } else {
                headerCell.dom.removeAttribute('data-sort');
                headerCell.dom.innerHTML = '';
              }
            }

            //header click and sorting
            table.onHeaderClick(function (event) {
              var cell = event.cell, // type: BentoCell in Header
                  col = cell.col,
                  column,
                  desc = false
              ;

              // Bypass
              if (tableRowSelectHelper && col === 0) {
                var row = cell.parent,
                    selectedClass = 'bt-row-selected'
                ;
                row.toggleClass(selectedClass);

                if (row.hasClass(selectedClass)) {
                  tableRowSelectHelper.addRows(tableHelper.getDataForRender());
                } else {
                  tableRowSelectHelper.deselectAllRows(tableHelper.getDataForRender());
                }

                table.render();

                fireRowSelectCallback();

                return;
              }


              column = tableHelper.getColumnByIndex(col);

              // Check and sort the current clicked column
              if (column.sort ||
                typeof column.sort === 'undefined') {
                // Other normal sorting
                if (cell.dom.getAttribute('data-sort') === 'bt-sort-asc') {
                  removeSortingClass(cell);
                  cell.dom.setAttribute('data-sort', 'bt-sort-desc');
                  tableHelper.sort(column.name, true, options.infiniteScroll);
                  colSort = [];
                  colSort[col] = 2; //Desc
                  state.sortKey = column.name;
                  state.sortDirection = 'desc';
                  desc = true;
                } else {
                  removeSortingClass(cell);
                  cell.dom.setAttribute('data-sort', 'bt-sort-asc');
                  tableHelper.sort(column.name, false, options.infiniteScroll);
                  colSort = [];
                  colSort[col] = 1; //Asc
                  state.sortKey = column.name;
                  state.sortDirection = 'asc';
                }

                if (options.infiniteScroll) {
                  // Need to request a new set of data
                  data.data = [];
                  state.currentPage = 0;
                  getSourceData(state.currentPage, state.recordsPerPage, state.sortKey, state.sortDirection)
                    .then(function (data) {
                      //Find and remove record(s) that is(are) frozen
                      data = tableHelper.removeFrozenRecords(data, col, desc);
                      getDataSuccess(data)
                    }, getDataFail);
                } else {
                  // Render table (Deep Render Mode)
                  table.render(true);
                  scope.$apply();
                }
              }
            });

            // clean sorting class names
            function removeSortingClass(cell) {
              var fCell = cell;
              do {
                cell.dom.setAttribute('data-sort', '');
                cell = cell.right;
              } while (cell !== fCell)
            }

            /*
             Frozen Cell
             */
            table.requestFrozenCellContent(function (cell) {
              if (tableRowSelectHelper && cell.col === 0) {
                var row = tableHelper.getRowByIndex(cell.row, true);
                tableRowSelectHelper.renderCell(cell);
                if(row && row[tableRowSelectHelper._selectedLabel]){
                  cell.parent.addClass('bt-row-selected', true);
                }else{
                  cell.parent.removeClass('bt-row-selected', true);
                }
              } else {
                tableHelper.renderFrozenCell(cell);
              }
            });

            /*
             Cell
             */

            table.requestCellContent(function (cell) {
              if (tableRowSelectHelper && cell.col === 0) {
                var row = tableHelper.getRowByIndex(cell.row);
                tableRowSelectHelper.renderCell(cell);

                if(row[tableRowSelectHelper._selectedLabel]){
                  cell.parent.addClass('bt-row-selected', true);
                  cell.parent.removeClass('bt-row-indeterminate', true);
                }else if(row[tableRowSelectHelper._indeterminateLabel]){
                  cell.parent.removeClass('bt-row-selected', true);
                  cell.parent.addClass('bt-row-indeterminate', true);
                }else{
                  cell.parent.removeClass('bt-row-selected', true);
                  cell.parent.removeClass('bt-row-indeterminate', true);
                }
              } else {
                tableHelper.renderCell(cell);
              }
            });

            var onRowClickCallback = scope.$eval(attrs.rowClick);

            // On row click
            function onRowClick(event) {
              var row = tableHelper.getRowByIndex(event.rowIndex, event.isFrozen),
                  isSelected;

              if (tableRowSelectHelper && event.target.className === 'bt-check-box') {

                if (!tableRowSelectHelper.isRowSelected(row)) {
                  tableRowSelectHelper.add(row, true);
                } else {
                  tableRowSelectHelper.remove(row, true);
                  table.header.dom.querySelector('.bento-table-row').row.removeClass('bt-row-selected');
                }

                $timeout(function(){table.render()});


                fireRowSelectCallback();
              }

              /**
               * Fire callback and return the original row object or BentoTableRow object
               */
              if (onRowClickCallback) {
                onRowClickCallback(row);
              }
            }

            // Fire select row callback
            function fireRowSelectCallback() {
              if (attrs.sourceDataSelectCallback) {
                scope.$eval(attrs.sourceDataSelectCallback)(tableRowSelectHelper.getSelection());
              }
            }

            function init() {
              body = element[0].querySelector('.bento-table-body');
              options = (!!attrs.options) ? scope.$eval(attrs.options) : {rowHeight: 30, colWidth: 150};
              state.currentPage = 0;
              state.recordsPerPage = options.recordsPerPage || 50;

              table = new BentoTable(body, options);

              // initialize row selection
              if (options.rowSelect) {
                tableRowSelectHelper = new BentoTableRowSelectHelper(table);
                colOffset += tableRowSelectHelper.colOffset;
              }

              // Getting helper
              if (typeof tableHelper === 'undefined') {
                if (options.group) {
                  // Grouping table helper
                  tableHelper = new BentoTableGroupingHelper(data, table, options, localScope, $compile, attrs);
                } else {
                  // Default table helper
                  tableHelper = new BentoTableHelper(data, table, options, localScope, $compile, attrs);
                }
                tableHelper.init(colOffset);
                tableHelper.onRowClick(onRowClick);
              }

              if (options.rowSelect) {
                tableRowSelectHelper.addHelper(tableHelper);
              }

              // infinite scroll initialization
              if (options.infiniteScroll) {
                var promise;
                table.onScrollAtBottom(function (event) {

                  if (!promise) {
                    var newPage = state.currentPage + 1;
                    promise = getSourceData(newPage, state.recordsPerPage, state.sortKey, state.sortDirection);
                    promise.then(function (data) {
                      state.currentPage = newPage;
                      getDataSuccess(data);
                      promise = null;
                    }, getDataFail);
                  }
                });
              }

              // Make sure when the table is ready
              var tableInitWatch = scope.$watch(function () {
                  return {height: body.offsetHeight, width: body.offsetWidth};
                },
                function (size) {
                  if (size.height > 0 && size.width > 0) {
                    table.init();

                    if (data.data.length > 0) {
                      prepareData();
                    }
                    // release one time watch
                    tableInitWatch();
                  }
                }
                ,
                true // need to deepwatch this object
              )
            }
          }
        };
      }]);
})();

function BentoTableRowSelectHelper(table, tableHelper) {
  var uid = Math.round(Math.random() * 100000000);
  this.colOffset = 1;
  this._selection = [];
  this._table = table;
  this._selectedLabel = '_btSelectedRow' + uid;
  this._indeterminateLabel = '_btSelectIndeterminate' + uid;
  this._tableHelper = tableHelper;
}

(function () {
  BentoTableRowSelectHelper.prototype.renderCell = renderCell;
  BentoTableRowSelectHelper.prototype.add = add;
  BentoTableRowSelectHelper.prototype.addHelper = addHelper;
  BentoTableRowSelectHelper.prototype.remove = remove;
  BentoTableRowSelectHelper.prototype.clear = clear;
  BentoTableRowSelectHelper.prototype.addRows = addRows;
  BentoTableRowSelectHelper.prototype.getSelection = getSelection;
  BentoTableRowSelectHelper.prototype.isRowSelected = isRowSelected;
  BentoTableRowSelectHelper.prototype.deselectAllRows = deselectAllRows;
  BentoTableRowSelectHelper.prototype.preSelectRows = preSelectRows;

  /**
   * Help to check if a row is selected or not
   * @param row
   * @returns {*}
   */
  function isRowSelected(row) {
    return row[this._selectedLabel];
  }

  /**
   * Add a table helper to reference it's functions
   * @param tableHelper
   */
  function addHelper(tableHelper) {
    this._tableHelper = tableHelper;
  }

  /**
   *
   * @param table (BentoTable) - BentoTable instance for rendering
   * @param dataArray (array) - Original Data array
   * @param selectedDataArray (array) - Selected rows in array
   * @param keyToCompare (object) - Unique key to compare the arrays
   */
  function preSelectRows(table, dataArray, selectedDataArray, keyToCompare) {

    if (
      typeof selectedDataArray === 'undefined' ||
      typeof keyToCompare === 'undefined' || !Array.isArray(selectedDataArray)
    ) {
      console.warn(
        'BentoTable: Getter `getSelectedRows` mis-formed.',
        '{key: (string)|(number), data: (array)}');
      return;
    }

    // Find and add selected row(s)
    var key, i, j, iLen, jLen, row;
    for (i = 0, iLen = selectedDataArray.length; i < iLen; i++) {
      key = selectedDataArray[i][keyToCompare];

      for (j = 0, jLen = dataArray.length; j < jLen; j++) {
        row = dataArray[j];
        if (row[keyToCompare] == key) {
          this.add(dataArray[j]);

          // Update table rendering flag for row selections
          table.rowSizes[j][2] = true;
          break;
        }
      }
    }
  }

  /**
   * Get a copy of the current selection
   * @returns {Array}
   */
  function getSelection() {
    var newArr = [];
    for (var i = 0, len = this._selection.length; i < len; i++) {
      newArr.push(this._selection[i]);
    }
    return newArr;
  }

  /**
   * Select all rows in the table
   */
  function addRows(rows) {
    var i, len;

    var row;
    for (i = 0, len = rows.length; i < len; i++) {
      row = rows[i];
      this.add(row);
    }
  }

  /**
   * Deselect all row
   */
  function deselectAllRows(rows) {
    var i, len;
    for (i = 0, len = rows.length; i < len; i++) {
      this.remove(rows[i]);
    }

    this._selection = [];
  }

  /**
   * Add row to selection
   * @param row
   */
  function add(row, checkParent) {
    row[this._selectedLabel] = true;
    if (row instanceof BentoTableGroupingRow) {
      for (var i = 0, len = row.members.length; i < len; i++) {
        this.add(row.members[i]);
      }
      __checkGroupSelectionStates(row, this);
    } else {
      if (this._selection.indexOf(row) === -1) {
        this._selection.push(row);
      }

      if (checkParent && this._tableHelper instanceof BentoTableGroupingHelper) {
        __checkGroupSelectionStates(
          this._tableHelper.getRowProperty(row, this._tableHelper.getParentVariableName())
          ,
          this);
      }
    }
  }

  /**
   * Check if a group is fully checked or not
   * @param btGroup
   * @private
   */
  function __checkGroupSelectionStates(btGroup, self) {

    var allSelected = true;
    var noneSelected = true;
    btGroup.members.forEach(function (item, i) {
      if (item[self._selectedLabel]) {
        noneSelected = false;
      } else {
        allSelected = false;
      }
    });

    if (allSelected) {
      btGroup[self._selectedLabel] = true;
      delete btGroup[self._indeterminateLabel];
    } else if (noneSelected) {

      delete btGroup[self._indeterminateLabel];
      delete btGroup[self._selectedLabel];
    } else {
      delete btGroup[self._selectedLabel];
      btGroup[self._indeterminateLabel] = true;
    }
  }

  /**
   * Remove a row from selection
   * @param row
   */
  function remove(row, checkParent) {
    var index = this._selection.indexOf(row);

    delete row[this._selectedLabel];

    if (row instanceof BentoTableGroupingRow) {
      for (var i = 0, len = row.members.length; i < len; i++) {
        this.remove(row.members[i]);
      }
      __checkGroupSelectionStates(row, this);
    } else {
      if (index > -1) {
        this._selection.splice(this._selection.indexOf(row), 1);
      }

      // Check group selection states
      if (checkParent && this._tableHelper instanceof BentoTableGroupingHelper) {
        __checkGroupSelectionStates(
          this._tableHelper.getRowProperty(row, this._tableHelper.getParentVariableName())
          , this);
      }
    }

  }

  /**
   * Remove all selection
   * @returns {Array}
   */
  function clear() {
    for (i = 0, len = this._selection.length; i < len; i++) {
      delete this._selection[i][this._selectedLabel];
    }
    return this._selection = [];
  }

  /**
   * Render selection cell
   * @param cell
   */
  function renderCell(cell) {
    cell.html('<div class="bt-check-box"></div>');
  }

})();
var BentoTableRow;

(function(){

  BentoTableRow = Row;
  Row.prototype.push = push;
  Row.prototype.unshift = unshift;
  Row.prototype.getFirstCell = getFirstCell;
  Row.prototype.getLastCell = getLastCell;
  Row.prototype.getNthCell = getNthCell;
  Row.prototype.getNumCells = getNumCells;
  Row.prototype.destroy = destroy;
  Row.prototype.setRow = setRowIndex;
  Row.prototype.remove = remove;
  Row.prototype.removeLastCell = removeLastCell;
  Row.prototype.addClass = addClass;
  Row.prototype.hasClass = hasClass;
  Row.prototype.removeClass = removeClass;
  Row.prototype.applyClasses = applyClasses;
  Row.prototype.clearClasses = clearClasses;
  Row.prototype.toggleClass = toggleClass;
  Row.prototype.setLinkages = setLinkages;
  Row.prototype.clear = clear;


  Object.defineProperty(Row.prototype, 'isFrozen',{get:isFrozen});


  // Private
  Row.prototype._init = init;

  /**
   * Constructer
   * @param initNumColumns
   * @param width
   * @param height
   * @param cellClickCallback
   * @param isHeader
   * @constructor
   */
  function Row(initNumColumns, width, height, cellClickCallback, isHeader) {

    this.dom = document.createElement('DIV');
    this.dom.row = this;

    // Private
    this._classes = [''];
    this._changed = false;
    this.initNumColumns = initNumColumns;
    this.width = width;
    this.height = height;
    this.cellClickCallback = cellClickCallback;
    this.isHeader = isHeader;

    this._init();
  }

  function clear(){
    this._classes = [];
    this.addClass('bento-table-row');
    var children = this.dom.children;
    for(var i= 0, len=children.length;i<len;i++){
      children[i].innerHTML = '';
    }
  }

  /**
   * Remove row from the parent element
   */
  function remove(){
    if(this.dom.parentElement) {
      this.dom.parentElement.removeChild(this.dom);
    }
  }

  /**
   * Check if this row is frozen or not
   * @returns {*}
   */
  function isFrozen(){
    return this.hasClass('bt-frozen-row');
  }

  /**
   * Toggles a class name on and off
   * @param className
   * @returns {boolean} to tell either the class is applied or not
   */
  function toggleClass(className){
    if(this.hasClass(className)){
      this.removeClass(className);
      return false;
    }else{
      this.addClass(className);
      return true;
    }
  }

  /**
   * Add a CSS Class to this row
   * @param className
   * @param doNotApply - do not apply the new class to the actual element
   */
  function addClass(className, doNotApply){

    if(this._classes.indexOf(className) < 0){
      this._classes.push(className);
      if(doNotApply){this._changed=true; return}
      this.dom.className = this._classes.join(' ');
    }
  }

  /**
   * Check if this row has a given class
   * @param className
   * @returns {boolean}
   */
  function hasClass(className){
    return this._classes.indexOf(className) > -1;
  }

  /**
   * Remove a CSS class from this row
   * @param className
   * @param doNotApply - do not apply the new class to the actual element
   */
  function removeClass(className, doNotApply){
    var index = this._classes.indexOf(className);
    if(index > -1){
      this._classes.splice(index,1);
      if(doNotApply){this._changed=true; return}
      this.dom.className = this._classes.join(' ');
    }
  }

  /**
   * Clear all CSS classes
   * @param doNotApply - do not apply the new class to the actual element
   */
  function clearClasses(doNotApply){
    this._classes = [this._classes[0]];

    if(doNotApply){this._changed=true; return}
    this.dom.className = this._classes[0];
  }

  /**
   * Apply all CSS classes to the element at once
   */
  function applyClasses(){
    if(this._changed) {
      this._changed = false;
      this.dom.className = this._classes.join(' ');
    }
  }

  /**
   * Push a cell to this row and link it
   * @param cell
   * @param isNew
   * @param callback
   */
  function push(cell, isNew, callback) {
    this.setLinkages(cell, isNew);
    this.dom.appendChild(cell.dom);

    if(callback){
      cell.dom.addEventListener('click',callback);
    }
  }

  /**
   * Set row index
   * @param index
   */
  function setRowIndex(index){
    this.row = index;
  }

  /**
   * Unshift a cell to this row
   * @param cell
   * @param isNew
   */
  function unshift(cell, isNew) {
    this.setLinkages(cell, isNew);
    this.dom.insertBefore(cell.dom, this.dom.firstChild);
  }

  /**
   * Gets the first DOM cell from the current row
   * @returns {BentoTableCell}
   */
  function getFirstCell() {
    return this.dom.firstElementChild.cell;
  }

  /**
   * Gets the last DOM cell from the current row
   * @returns (BentoTableCell)
   */
  function getLastCell() {
    return this.dom.lastElementChild.cell;
  }

  /**
   * Get's the (n)th cell from the current row
   * @param index
   * @returns {BentoTableCell}
   */
  function getNthCell(index) {
    return this.dom.children[index].cell;
  }

  /**
   * Get the total number of cells in this row
   * @returns {Number}
   */
  function getNumCells() {
    return this.dom.childElementCount;
  }

  /**
   * Destroy this row
   */
  function destroy() {
    var child;
    // delete children
    while (this.dom.childElementCount > 0) {
      child = this.dom.firstElementChild.cell;

      if(child.top) {
        child.top.setBottom(child.bottom);
      }

      if(child.bottom) {
        child.bottom.setTop(child.top);
      }
      this.dom.removeChild(child.dom);
      child.destroy();
    }
    child = null;
    delete this.dom;
  }

  function removeLastCell(){
    var cell = this.getLastCell();
    cell.removeEventListener(this.cellClickCallback);
    if(cell.left) {
      cell.left.setRight(cell.right);
    }

    if(cell.right){
      cell.right.setLeft(cell.left);
    }

    this.dom.removeChild(cell.dom);
    cell.destroy();
  }

  function init(){
    var cell, i, len;

    for (i = 0; i < this.initNumColumns; i++) {
      cell = new BentoTableCell(this, this.isHeader);
      if(this.width){
        cell.dom.style.width = this.width + 'px';
      }
      this.push(cell, true, this.cellClickCallback);
    }

    var children = this.dom.children;
    for (i = 0, len = children.length; i < len; i++) {
      cell = children[i].cell;
    }

    if(this.height){
      this.dom.style.height = this.height + 'px';
    }

    this._classes.pop();
    this.addClass('bento-table-row');
  }

  /**
   * Set linkages to all cells with a new cell
   * @param cell - Cell object
   * @param isNew - Tell is cell is a new object
   */
  function setLinkages(cell, isNew) {
    if (this.dom.childElementCount > 0 && isNew) {
      var fCell = this.getFirstCell();
      var lCell = this.getLastCell();

      fCell.setLeft(cell);
      lCell.setRight(cell);
      cell.setLeft(lCell);
      cell.setRight(fCell);
    }
  }
})();





function BentoTableSort(table) {
  var bh = this;
  var btRowArray;
  bh.sort = heapSort;
  bh.findIndex = findIndex;

  /**
   * Find the index of an object within a sorted array
   * @param arr
   * @param isBetween - (bool)
   * @param outOfBound - number of index when found otherwise false
   * @returns {*}
   */
  function findIndex(arr, isBetween, outOfBound, outOfBoundAsNotFound) {
    var left = 0,
        right = arr.length - 1,
        middle = Math.floor((left + right) * 0.5),
        bound = outOfBound(arr[left], arr[right]);
    ;

    if (outOfBoundAsNotFound && bound) {
      return -1;
    } else if (bound === -1 || bound === 1) {
      return bound > 0 ? arr.length : 0;
    }

    while (left !== middle) {
      if (isBetween(arr[left], arr[middle])) {
        right = middle;
      } else {
        left = middle;
      }
      middle = Math.floor((left + right) * 0.5);
    }
    return left + 1;
  }

  /**
   * Sort an array based a column (index : col)
   * @param arr
   * @param col
   *
   * Using BlockSort
   * http://en.wikipedia.org/wiki/Block_sort
   */

  /**
   * Finds the correct place of given element in given max heap.
   *
   * @private
   * @param {Array} array Array.
   * @param {Number} index Index of the element which palce in
   * the max heap should be found.
   * @param {Number} heapSize Size of the heap.
   * @param {function} cmp Comparison function.
   */
  function heapify(array, btRowArray, index, heapSize, cmp) {
    var left = 2 * index + 1;
    var right = 2 * index + 2;
    var largest = index;
    if (left < heapSize && cmp(array[left], array[index]) > 0) {
      largest = left;
    }
    if (right < heapSize && cmp(array[right], array[largest]) > 0) {
      largest = right;
    }
    if (largest !== index) {
      var temp = array[index];
      var temp2 = btRowArray[index];
      array[index] = array[largest];
      btRowArray[index] = btRowArray[largest];
      array[largest] = temp;
      btRowArray[largest] = temp2;
      heapify(array, btRowArray, largest, heapSize, cmp);
    }
  }

  /**
   * Builds max heap from given array.
   *
   * @private
   * @param {Array} array Array which should be turned into max heap.
   * @param {function} cmp Comparison function.
   * @return {Array} array Array turned into max heap.
   */
  function buildMaxHeap(array, btRowArray, cmp) {
    for (var i = Math.floor(array.length / 2); i >= 0; i -= 1) {
      heapify(array, btRowArray, i, array.length, cmp);
    }
    return array;
  }

  /**
   * Heapsort. Turns the input array into max
   * heap and after that sorts it.<br><br>
   * Time complexity: O(N log N).
   *
   * @example
   *
   * var sort = require('path-to-algorithms/src' +
   * '/sorting/heapsort').heapSort;
   * console.log(sort([2, 5, 1, 0, 4])); // [ 0, 1, 2, 4, 5 ]
   *
   * @public
   * @module sorting/heapsort
   * @param {Array} array Input array.
   * @param {Function} cmp Optional. A function that defines an
   * alternative sort order. The function should return a negative,
   * zero, or positive value, depending on the arguments.
   * @return {Object} Sorted array.
   */
  function heapSort(array, rowArray, cmp) {
    cmp = cmp || comparator;
    var size = array.length;
    var temp, temp2;
    btRowArray = rowArray? rowArray:[];

    buildMaxHeap(array, btRowArray, cmp);
    for (var i = array.length - 1; i > 0; i -= 1) {
      temp = array[0];
      temp2 = btRowArray[0];
      array[0] = array[i];
      btRowArray[0] = btRowArray[i];
      array[i] = temp;
      btRowArray[i] = temp2;
      size -= 1;
      heapify(array, btRowArray, 0, size, cmp);
    }

    return {rows: array, rowSizes: btRowArray};
  }

  function comparator(a, b) {
    return a - b;
  }

}
var BentoTable;

(function(){

  BentoTable = _BentoTable;
  _BentoTable.prototype = Object.create(BentoTableCore.prototype);
  _BentoTable.prototype.constructor = _BentoTable;

  function _BentoTable(dom, options){
    BentoTableCore.apply(this,arguments);
  }
})();



var BentoTableDefaultColumn;

(function(){

  'user strict';
  BentoTableDefaultColumn = _BentoTableDefaultColumn;
  BentoTableDefaultColumn.prototype.applyContentToCell = applyContentToCell;
  BentoTableDefaultColumn.prototype.applyContentToCellWithType = applyContentToCellWithType;

  // Constructor
  function _BentoTableDefaultColumn(){
  }

  /**
   * Apply HTML content to a BentoCell object
   * @param content
   * @param cell
   */
  function applyContentToCell(content, cell){
    applyContentToCellWithType(content, cell, 'bt-cell-default');
  }

  /**
   * Apply HTML content to a BentoCell object with a unique type
   * @param content
   * @param cell
   * @param type
   */
  function applyContentToCellWithType(content, cell, type){
    if(type){
      cell.setType(type);
    }
    cell.html(content);
  }
})();

var BentoTableCellTemplateColumn;

(function(){
  BentoTableCellTemplateColumn = btCellTemplate;
  btCellTemplate.prototype = Object.create(BentoTableDefaultColumn.prototype);
  btCellTemplate.prototype.constructor = btCellTemplate;

  // Override
  btCellTemplate.prototype.applyContentToCell = applyContentToCell;
  btCellTemplate.prototype.setTemplate = setTemplate;

  /**
   * Constructor
   * @param scope
   * @param compile
   * @param dataName
   */
  function btCellTemplate(scope, compile, dataName){
    BentoTableDefaultColumn.apply(this, arguments);
    this._scope = scope;
    this._compile = compile;
    this._dataName = dataName;
    this._template = null;
  }

  /**
   * Set Template of this column
   * @param tpl
   */
  function setTemplate(tpl){
    if(typeof tpl === 'string') {
      this._template = tpl;
    }else{
      var tmp = document.createElement("div");
      tmp.appendChild(tpl);
      this._template = tmp.innerHTML;
      tmp = null;
    }
  }

  /**
   * Override on Apply content to Cell
   * @param content
   * @param cell
   * @param item
   */
  function applyContentToCell(content, cell, row){
    var data;
    if(!!(data = cell.getData())){
      // Destroy old scope and render new
      data.element.remove(); // jqLite
      data.scope.$destroy();
    }
    data = {
      // Inherit from the parent scope
      scope: this._scope.$new()
    };

    // Using $item to define the row
    data.scope.$row = row;
    data.scope.$item = content;
    data.element = this._compile(this._template)(data.scope);

    // Only $digest locally
    if(!data.scope.$root.$$phase) {
      data.scope.$digest();
    }

    // Keep reference
    cell.setData(data);

    // Content has to be true or false
    this.applyContentToCellWithType(data.element[0],cell,'bt-cell-template');
  }

})();


var BentoTableCheckBoxColumn;

(function(){
  BentoTableCheckBoxColumn = _BTCheckBoxColumn;
  BentoTableCheckBoxColumn.prototype = Object.create(BentoTableDefaultColumn.prototype);
  BentoTableCheckBoxColumn.prototype.constructor = BentoTableCheckBoxColumn;
  // Methods
  BentoTableCheckBoxColumn.prototype.applyContentToCell = applyContentToCell;

  function _BTCheckBoxColumn(){
    BentoTableDefaultColumn.apply(this, arguments);

    var col = this;
    // Override
    col.applyContentToCell = applyContentToCell;
  }

  function applyContentToCell(content, cell){
    // Content has to be true or false
    this.applyContentToCellWithType(content,cell,'bt-checkbox-cell');
  }

})();
function BentoTableNumberColumn(){
  BentoTableNumberColumn.prototype = new BentoTableDefaultColumn();
  BentoTableDefaultColumn.apply(this, arguments);

  var col = this;
  // Override
  col.applyContentToCell = applyContentToCell;

  function applyContentToCell(content, cell){
    col.applyContentToCellWithType(content,cell,'bt-number-cell');
  }

}
(function() {
  'use strict';
  /**
   * Rome DatePicker Directive
   */

  angular.module('bento.datepicker.rome', [])
    .controller('RomeDatePickerController', romeController)
    .directive('bentoDatePicker', romeDirective);
  /**
   * [$inject]
   * @type {Array}
   */
  romeController.$inject = ['$scope', '$attrs', '$timeout'];
  /**
   * [romeController - controller for bentoDatePicker directive]
   * @param  {[object]} $scope
   * @param  {[object]} $attrs
   * @param  {[object]} $timeout
   * @return {[object]}          [controller object]
   */
  function romeController($scope, $attrs, $timeout) {
    var vm = this;

    vm.initInputFormat = function() {
      if ($scope.options && $scope.options.inputFormat) {
        vm.inputFormat = $scope.options.inputFormat;
      } else if (moment && moment.localeData() && moment.localeData()._longDateFormat) {
        var dtFormat = moment.localeData()._longDateFormat;
        vm.inputFormat = dtFormat.L || dtFormat.LL || dtFormat.LLL || dtFormat.LLLL;
      }
    }
    //WATCHERS
    //watch directive's is-open attribute
    $scope.$watch('isOpen', function(newVal, oldVal) {
      var datepicker = $scope.control;
      if (datepicker === undefined || newVal == oldVal) return;
      if (newVal) {
        datepicker.setValue(new Date(vm.ngModelCtrl.$modelValue));
        datepicker.show();
      } else {
        datepicker.hide();
        $timeout(function() {
          vm.validate();
        });
      }
    });

    //watch directive's locale attribute
    $scope.$watch('locale', function(locale) {
      var datepicker = $scope.control;
      if (locale && datepicker) {
        //use moment locale config
        moment.locale(locale);
        var localeData = moment.localeData();
        var inputFormat;
        if (localeData && localeData._longDateFormat && localeData._longDateFormat.L) {
          inputFormat = localeData._longDateFormat.L
        }

        if ($scope.options.time != false && localeData && localeData._longDateFormat && localeData._longDateFormat.LT) {
          inputFormat += " " + localeData._longDateFormat.LT;
        }

        $timeout(function() {
          //need to nullify these options to let
          //moment's locale config object to take over
          $scope.options.inputFormat = inputFormat;
          $scope.options.weekdayFormat = undefined;
          $scope.options.weekStart = undefined;
          vm.inputFormat = $scope.options.inputFormat;
          //let scope options $watch kick in for the rest
        });
      }
    });

    vm.validate = function() {
      var date = moment(vm.ngModelCtrl.$viewValue, vm.inputFormat);

      if (date && date.isValid()) {
        vm.ngModelCtrl.$setValidity('bentoDatePicker', true);
      } else {
        vm.ngModelCtrl.$setValidity('bentoDatePicker', false);
      }
    }
    vm.update = function(date) {
      if(!date && $scope.control && $scope.control.getDate()){
        date = $scope.control.getDate();
      }

      if (date) {
        var formattedDate = moment(date).format(vm.inputFormat);
        vm.ngModelCtrl.$setViewValue(moment(date).format(vm.inputFormat));
        vm.ngModelCtrl.$render();
        $scope.date = date;
        $scope.dateFormatted = formattedDate;
      }
    }
  }

  /**
   * [$inject description]
   * @type {Array}
   */
  romeDirective.$inject = ['$timeout'];
  /**
   * [romeDirective bentoDatePicker directive]
   * @param  {[object]} $timeout [description]
   * @return {[object]}          [directive object]
   */
  function romeDirective($timeout) {
    var directive = {
      restrict: 'EA',
      require: ['ngModel', 'bentoDatePicker'],
      scope: {
        options: '=',
        date: '=?', //can be deprecated,
        dateFormatted: '=?',
        isOpen: '=?',
        control: '=?',
        locale: '=?',
        appendTo: '=?',
        validFormats: '=?'
      },
      controller: 'RomeDatePickerController',
      link: fnLink
    };

    /**
     * [fnLink directive link function]
     * @param  {[object]} scope   [description]
     * @param  {[object]} element [description]
     * @param  {[object]} attrs   [description]
     * @param  {[object]} ctrl    [description]
     * @param  {[object]} $parse  [description]
     * @return {[object]}         [description]
     */
    function fnLink(scope, element, attrs, ctrl, $parse) {

      //ctrl returns an array of ngModel's controller and directive's controller
      var self = this;
      var ngModelCtrl = ctrl[0];
      var romeCtrl = ctrl[1];


      romeCtrl.ngModelCtrl = ngModelCtrl;

      //attach datepicker to another input (to avoid conflict with ngModel input)
      var inputElement = document.createElement("input");
      inputElement.type = "text";
      inputElement.style.position = "absolute";
      inputElement.style.left = "0";
      inputElement.style.height = "100%";
      inputElement.style.opacity = "0";
      inputElement.tabIndex = "-1";
      inputElement.style.zIndex = "-1";
      element.parent().append(inputElement);

      var datepicker, headerElement;

      //place datepicker init in timeout for when scope.options is ready
      $timeout(function() {
        datepicker = rome(inputElement, scope.options);
        romeCtrl.initInputFormat();
        //create header element
        headerElement = createHeaderElement(scope, datepicker);
        //assign datepicker to control attribute (for use in app's controller if needed)
        scope.control = datepicker;
        //see if there are more than one month to display
        checkMonthsToDisplay(datepicker, scope.options);
        //assign keyDown function to rome controller
        romeCtrl.onKeydown = onKeydown;

        //BIND EVENTS
        //add keydown events to directive
        element[0].addEventListener('keydown', romeCtrl.onKeydown);
        //add blur event to directive
        element.on('blur', onBlur);
        //Destroy event
        scope.$on('$destroy', onDestroy);
        element.on('$destroy', onDestroy);
        //add event handling for datepicker events
        addDatePickerEvents(scope, datepicker, headerElement, romeCtrl, element);

        ngModelCtrl.$formatters.push(function(modelValue) {
          if (!romeCtrl.inputFormat || !modelValue) return "";
          var retVal = moment(modelValue).format(romeCtrl.inputFormat);
          scope.dateFormatted = retVal;
          return retVal;
        });

        ngModelCtrl.$parsers.push(function(viewValue) {
          var date = moment(viewValue, romeCtrl.inputFormat);
          var retVal = (date && date.isValid()) ? date.toDate() : "";
          scope.dateFormatted = retVal ? viewValue : "";
          return retVal;
        });

        romeCtrl.update(ngModelCtrl.$modelValue);
      });

      romeCtrl.update();

      // Key event mapper
      var keys = {
        9: 'tab',
        13: 'enter',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down'
      };




      //WATCH EVENTS
      scope.$watchCollection('options', onOptionsChanged);


      //keydown handling (event added to element in link function)
      function onKeydown(evt) {
        var key = keys[evt.which];

        clearErrorMsg();

        if (!key || evt.shiftKey || evt.altKey) {
          return;
        }

        if (key === 'enter' || key === 'tab') {
          //check if date is valid
          $timeout(function() {
            element[0].blur();
            datepicker.hide();
            scope.isOpen = false;
          });
        } else {
          handleKeyDown(key, evt);
        }
      };

      //blur handling
      function onBlur(evt) {
        $timeout(function() {
          // romeCtrl.update();
          romeCtrl.validate();
        });
      }

      function handleKeyDown(key, evt) {
        var date = datepicker.getDate();

        if (!date) {
          date = new Date;
        }

        var m = moment(date);

        if (key === 'left') {
          m.subtract(1, 'day');
        } else if (key === 'up') {
          m.subtract(7, 'day');
        } else if (key === 'right') {
          m.add(1, 'day');
        } else if (key === 'down') {
          m.add(7, 'day');
        } else if (key === 'pageup') {
          m.subtract(1, 'month');
        } else if (key === 'pagedown') {
          m.add(1, 'month');
        } else if (key === 'home') {
          m.startOf('month');
        } else if (key === 'end') {
          m.endOf('month');
        }
        $timeout(function() {
          var momentDate = m.toDate();
          datepicker.setValue(momentDate);
          scope.date = momentDate;
          ngModelCtrl.$modelValue = momentDate;
        });
      };


      function showErrorMsg() {
        ngModelCtrl.$setValidity('bentoDatePicker', false)
      }

      function clearErrorMsg() {
        ngModelCtrl.$setValidity('bentoDatePicker', true)
      }

      function onDestroy() {
        if (scope.isOpen == true) {
          $timeout(function() {
            scope.isOpen = false;
          });
        }
        element[0].removeEventListener('keydown', romeCtrl.onKeydown);
        element.off('blur', onBlur);
        datepicker.destroy();
      }
      //watch directive's options attribute
      function onOptionsChanged(newVal, oldVal) {
        if (newVal && !angular.equals(newVal, oldVal)) {
          //make new datepicker
          datepicker.options(newVal);
          //check if multi months
          checkMonthsToDisplay(datepicker, newVal);
          //add header element
          headerElement = createHeaderElement(scope, datepicker);
          //add events
          addDatePickerEvents(scope, datepicker, headerElement, romeCtrl, element);
          //return datepicker to scope
          scope.control = datepicker;
        }
      }
    }

    /**
     * [checkMonthsToDisplay private function to check if multi-months class should be added]
     * @param  {[object]} datepicker [datepicker object]
     * @param  {[object]} options    [datepicker options object]
     */
    function checkMonthsToDisplay(datepicker, options) {
      if (options && options.monthsInCalendar && options.monthsInCalendar > 1) {
        angular.element(datepicker.container).addClass("rd-container-has-multi-months");
      } else {
        angular.element(datepicker.container).removeClass("rd-container-has-multi-months");
      }
    }

    /**
     * [createHeaderElement append header element to datepicker popup]
     * @param  {[object]} scope      [directive scope]
     * @param  {[object]} datepicker [datepicker object]
     * @return {[DOM element]}       [header DOM element]
     */
    function createHeaderElement(scope, datepicker) {
      var headerElement = document.createElement("div");
      headerElement.className = "rd-header";
      var dateElement = datepicker.container.querySelector('rd-date');
      datepicker.container.insertBefore(headerElement, dateElement);
      return headerElement;
    }

    /**
     * [addDatePickerEvents add datepicker callback handling to datepicker events]
     * @param {[object]} scope         [directive scope]
     * @param {[object]} datepicker    [datepicker object]
     * @param {[DOM element]} headerElement [header DOM element]
     * @param {[object]} ctrl          [directive controller]
     */
    function addDatePickerEvents(scope, datepicker, headerElement, ctrl, element) {
      //Handle datepicker's data event
      datepicker.on('data', onData);
      //Handle datepicker's hide event for the 'is-open' toggle logic
      datepicker.on('hide', onHide);
      //Handle datepicker's hide event for the 'is-open' toggle logic
      datepicker.on('show', onShow);

      function onData(value) {
        ctrl.update();
      }

      function onHide() {
        $timeout(function() {
          scope.isOpen = false;
        });
      }

      function onShow() {
        $timeout(function() {
          scope.isOpen = true;

          headerElement.innerText = datepicker.getDateString() ? datepicker.getDateString() : "";
          if(headerElement.innerText === ""){
            headerElement.style.display = "none";
          } else {
            headerElement.style.display = "block";
          }
          //If append, attach to element
          var calendar = datepicker.container;

          if (scope.appendTo) {
            var parent = document.querySelector(scope.appendTo);
            parent.appendChild(calendar);
            calendar.style.left = (parseInt(calendar.style.left) - parent.offsetLeft + parent.scrollLeft) + 'px';
            calendar.style.top = (parseInt(calendar.style.top) - parent.offsetTop + parent.scrollTop) + 'px';
          }
          calendar.focus();
        });
      }
    }
    return directive;
  }
})();
(function (angular, window, undefined) {
  "use strict";

  angular.module('bento.uib.datepicker.addon', [])
  /**
   * uib-datepicker-popup-wrap Addon
   */
    .directive('uibDatepickerPopupWrap',
      [
        '$timeout',
        function ($timeout) {
          return {
            scope: false,
            priority: -1,
            link: function(scope,element){
              var timeoutPromise,
                  $previousSibling = angular.element(element[0].previousSibling),
                  $body = angular.element(document.body);

              // Detection and placement
              detectViewport();

              // Add/Remove window listener
              window.addEventListener('resize',onWindowResize);
              scope.$on('$destroy',function(){
                $timeout.cancel(timeoutPromise);
                window.removeEventListener('resize',onWindowResize);
              });

              function onWindowResize(){
                $timeout.cancel(timeoutPromise);
                timeoutPromise = $timeout(detectViewport,100);
              }

              function detectViewport(){
                var vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                if(vw < 601){
                  $body.prepend(element);
                  element.addClass('uib-datepicker-fixed');
                }else{
                  $previousSibling.after(element);
                  element.removeClass('uib-datepicker-fixed');
                }
              }
            }
          }
        }
      ]);

})(angular, window);
(function(angular, undefined) {
  'use strict';

  angular
    .module('bento.universeFilter', [
      'bento.services',
    ])
    .directive('bentoUniverseFilter', bentoUniverseFilter)
    .directive('bentoUniverseFilterEllipsis', bentoUniverseFilterEllipsis)
    .controller('bentoUniverseFilterController', bentoUniverseFilterController)
    .controller('BentoUniverseFilterModalCtrl', bentoUniverseFilterModalCtrl);

  bentoUniverseFilter.$inject = ['$timeout', '$compile', '$window'];

  function bentoUniverseFilter($timeout, $compile, $window) {
    return {
      restrict: 'EA',
      require: ['ngModel', 'bentoUniverseFilter'],
      scope: {
        onBackBtnClick: '&?',
        backBtnDisabled: '=?',
        onFilterItemChanged: '&?',
        selectText: '=?'
      },
      controller: 'bentoUniverseFilterController',
      controllerAs: 'bentoUniverseFilterCtrl',
      templateUrl: function(element, attrs) {
        return angular.isDefined(attrs.templateUrl) ? attrs.templateUrl : '../templates/universe_filter/bento-universe-filter.html';
      },
      compile: function(tElem, tAttrs) {
        return {
          post: postLink,
        }

        function postLink(scope, element, attrs, ctrl) {
          var ngModelCtrl = ctrl[0];
          var filterCtrl = ctrl[1];
          var selectedItems = [];

          //watch ngModelCtrl
          scope.$watch(function() {
            return ngModelCtrl.$modelValue;
          }, onModelChange, true);

          //back button
          scope.$watch('backBtnDisabled', onBackBtnDisabled);

          filterCtrl.onBackButtonClick = function($event) {
            scope.onBackBtnClick();
          }
          if (attrs.onBackBtnClick) {
            filterCtrl.hasBackBtn = true;
          }

          function onBackBtnDisabled(newValue) {
            filterCtrl.backButtonDisabled = newValue;
          }

          //model changed
          function onModelChange(newValue, oldValue) {
            if (newValue) {
              if(newValue !== oldValue){
                var selectedItem = checkForSelectedItems(newValue);
                if(selectedItem){
                  scope.onFilterItemChanged({filterItems:newValue,selectedItem:selectedItem});
                }
              }
              filterCtrl.filterItems = newValue;
            }
          }
          /**
           * Check to see which item is currently selected
           */
          function checkForSelectedItems(items){
            var selectedItem;
            for(var i=0,ttl=items.length;i<ttl;i++){
              if(selectedItems[i]){
                if(String(selectedItems[i]) !== String(items[i].selectedName)){
                  selectedItem = items[i];
                  selectedItems[i] = items[i].selectedName;
                  break;
                }
                selectedItems[i] = items[i].selectedName;
              } else if(items[i].selectedName){
                selectedItem = items[i];
                selectedItems[i] = items[i].selectedName;
                break;
              } else {
                selectedItems[i] = items[i].selectedName;
              }
            }
            return selectedItem;
          }
          //Window resize
          angular.element($window).bind('resize', onWindowResize);
          scope.$watch(getElementWidth, onWindowResize);

          function getElementWidth() {
            return element[0].offsetWidth;
          }

          function onWindowResize() {
            $timeout(function() {
              filterCtrl.checkTextOverflow();
            });
          }

          //Destroy
          scope.$on('$destroy', onDestroy);
          element.on('$destroy', onDestroy);

          function onDestroy() {
            angular.element($window).unbind('resize', onWindowResize);
          }


        }
      }
    };
  }

  bentoUniverseFilterController.$inject = ['$scope', '$element', '$attrs','$uibModal', '$timeout'];

  function bentoUniverseFilterController($scope, $element, $attrs, $uibModal, $timeout) {
    var vm = this;
    vm.selectText = $scope.selectText || 'Select';
    //Modal Events
    vm.openModal = function(filterItem) {
      vm.selectedName = filterItem.name;
      var modalInstance = $uibModal.open({
        templateUrl: filterItem.modalTemplateUrl || $attrs.modalTemplateUrl || 'bentoUniFilterModal.html',
        controller: filterItem.modalController || $attrs.modalController || 'BentoUniverseFilterModalCtrl',
        windowClass: 'bento-uni-filter_modal',
        resolve: {
          filterItem: function() {
            return filterItem;
          }
        },
      });
      modalInstance.result.then(function(result) {
        vm.selectedName = undefined;
        $timeout(function() {
          checkTextOverflow();
        });
      }, function(reason) {
        vm.selectedName = undefined;
      });
    }
    vm.checkTextOverflow = checkTextOverflow;
    function checkTextOverflow() {
      $scope.$broadcast('bentoUniverFilterCheckEllipsis');
    }

  }
  bentoUniverseFilterEllipsis.$inject = ['$window'];

  function bentoUniverseFilterEllipsis($window) {
    return {
      restrict: 'EA',
      scope: {
        bentoEllipsisText: '='
      },
      compile: function(tElem, tAttrs) {
        return {
          post: postLink,
        }

        function postLink(scope, element, attrs) {
          scope.$watch('bentoEllipsisText', checkEllipsis);
          scope.$on('bentoUniverFilterCheckEllipsis', checkEllipsis);

          function checkEllipsis() {
            var txtElem = element[0];
            var str = scope.bentoEllipsisText;
            txtElem.innerHTML = str;
            txtElem.style.pointerEvents = "";
            if ((txtElem.scrollHeight - 1) > txtElem.clientHeight) {
              while ((txtElem.scrollHeight - 1) > txtElem.clientHeight) {
                var lastIndex = str.lastIndexOf(" ");
                str = str.substring(0, lastIndex);
                txtElem.innerHTML = str + "&hellip;";
                if (lastIndex <= 1) {
                  break;
                }
              }
            } else {
              //disable tooltip if full display of label
              txtElem.style.pointerEvents = "none";
            }
          }
        }
      }
    }
  }
  //Default Modal
  bentoUniverseFilterModalCtrl.$inject = ['$scope', '$uibModalInstance', 'filterItem'];

  function bentoUniverseFilterModalCtrl($scope, $uibModalInstance, filterItem) {
    $scope.filterItem = filterItem;

    $scope.selectItem = function(item, filterItem) {
      filterItem.selectedName = item.name;
      $uibModalInstance.close(item);
    }

    $scope.closeModal = function() {
      $uibModalInstance.dismiss('close');
    }
  }
})(window.angular);
/*
    *
    * Wijmo Library 5.20173.409
    * http://wijmo.com/
    *
    * Copyright(c) GrapeCity, Inc.  All rights reserved.
    *
    * Licensed under the GrapeCity Commercial License.
    * sales@wijmo.com
    * wijmo.com/products/wijmo-5/license/
    *
    */
/**
 * Contains utilities used by all controls and modules, as well as the
 * @see:Control and @see:Event classes.
 */
var wijmo;
(function (wijmo) {
    'use strict';
    // major (ECMAScript version required).
    // year/trimester.
    // sequential
    var _VERSION = '5.20173.409';
    /**
     * Gets the version of the Wijmo library that is currently loaded.
     */
    function getVersion() {
        return _VERSION;
    }
    wijmo.getVersion = getVersion;
    /**
     * Specifies constants that represent keyboard codes.
     *
     * This enumeration is useful when handling <b>keyDown</b> events.
     */
    var Key;
    (function (Key) {
        /** The backspace key. */
        Key[Key["Back"] = 8] = "Back";
        /** The tab key. */
        Key[Key["Tab"] = 9] = "Tab";
        /** The enter key. */
        Key[Key["Enter"] = 13] = "Enter";
        /** The escape key. */
        Key[Key["Escape"] = 27] = "Escape";
        /** The space key. */
        Key[Key["Space"] = 32] = "Space";
        /** The page up key. */
        Key[Key["PageUp"] = 33] = "PageUp";
        /** The page down key. */
        Key[Key["PageDown"] = 34] = "PageDown";
        /** The end key. */
        Key[Key["End"] = 35] = "End";
        /** The home key. */
        Key[Key["Home"] = 36] = "Home";
        /** The left arrow key. */
        Key[Key["Left"] = 37] = "Left";
        /** The up arrow key. */
        Key[Key["Up"] = 38] = "Up";
        /** The right arrow key. */
        Key[Key["Right"] = 39] = "Right";
        /** The down arrow key. */
        Key[Key["Down"] = 40] = "Down";
        /** The delete key. */
        Key[Key["Delete"] = 46] = "Delete";
        /** The F1 key. */
        Key[Key["F1"] = 112] = "F1";
        /** The F2 key. */
        Key[Key["F2"] = 113] = "F2";
        /** The F3 key. */
        Key[Key["F3"] = 114] = "F3";
        /** The F4 key. */
        Key[Key["F4"] = 115] = "F4";
        /** The F5 key. */
        Key[Key["F5"] = 116] = "F5";
        /** The F6 key. */
        Key[Key["F6"] = 117] = "F6";
        /** The F7 key. */
        Key[Key["F7"] = 118] = "F7";
        /** The F8 key. */
        Key[Key["F8"] = 119] = "F8";
        /** The F9 key. */
        Key[Key["F9"] = 120] = "F9";
        /** The F10 key. */
        Key[Key["F10"] = 121] = "F10";
        /** The F11 key. */
        Key[Key["F11"] = 122] = "F11";
        /** The F12 key. */
        Key[Key["F12"] = 123] = "F12";
    })(Key = wijmo.Key || (wijmo.Key = {}));
    /**
     * Specifies constants that represent data types.
     *
     * Use the @see:getType method to get a @see:DataType from a value.
     */
    var DataType;
    (function (DataType) {
        /** Object (anything). */
        DataType[DataType["Object"] = 0] = "Object";
        /** String. */
        DataType[DataType["String"] = 1] = "String";
        /** Number. */
        DataType[DataType["Number"] = 2] = "Number";
        /** Boolean. */
        DataType[DataType["Boolean"] = 3] = "Boolean";
        /** Date (date and time). */
        DataType[DataType["Date"] = 4] = "Date";
        /** Array. */
        DataType[DataType["Array"] = 5] = "Array";
    })(DataType = wijmo.DataType || (wijmo.DataType = {}));
    /**
     * Casts a value to a type if possible.
     *
     * @param value Value to cast.
     * @param type Type or interface name to cast to.
     * @return The value passed in if the cast was successful, null otherwise.
     */
    function tryCast(value, type) {
        // null doesn't implement anything
        if (value == null) {
            return null;
        }
        // test for interface implementation (IQueryInterface)
        if (isString(type)) {
            return isFunction(value.implementsInterface) && value.implementsInterface(type) ? value : null;
        }
        // regular type test
        return value instanceof type ? value : null;
    }
    wijmo.tryCast = tryCast;
    /**
     * Determines whether an object is a primitive type (string, number, Boolean, or Date).
     *
     * @param value Value to test.
     */
    function isPrimitive(value) {
        return isString(value) || isNumber(value) || isBoolean(value) || isDate(value);
    }
    wijmo.isPrimitive = isPrimitive;
    /**
     * Determines whether an object is a string.
     *
     * @param value Value to test.
     */
    function isString(value) {
        return typeof (value) == 'string';
    }
    wijmo.isString = isString;
    /**
     * Determines whether a string is null, empty, or whitespace only.
     *
     * @param value Value to test.
     */
    function isNullOrWhiteSpace(value) {
        return value == null ? true : value.replace(/\s/g, '').length < 1;
    }
    wijmo.isNullOrWhiteSpace = isNullOrWhiteSpace;
    /**
     * Determines whether an object is a number.
     *
     * @param value Value to test.
     */
    function isNumber(value) {
        return typeof (value) == 'number';
    }
    wijmo.isNumber = isNumber;
    /**
     * Determines whether an object is an integer.
     *
     * @param value Value to test.
     */
    function isInt(value) {
        return isNumber(value) && value == Math.round(value);
    }
    wijmo.isInt = isInt;
    /**
     * Determines whether an object is a Boolean.
     *
     * @param value Value to test.
     */
    function isBoolean(value) {
        return typeof (value) == 'boolean';
    }
    wijmo.isBoolean = isBoolean;
    /**
     * Determines whether an object is a function.
     *
     * @param value Value to test.
     */
    function isFunction(value) {
        return typeof (value) == 'function';
    }
    wijmo.isFunction = isFunction;
    /**
     * Determines whether an object is undefined.
     *
     * @param value Value to test.
     */
    function isUndefined(value) {
        return typeof value == 'undefined';
    }
    wijmo.isUndefined = isUndefined;
    /**
     * Determines whether an object is a Date.
     *
     * @param value Value to test.
     */
    function isDate(value) {
        return value instanceof Date && !isNaN(value.getTime());
    }
    wijmo.isDate = isDate;
    /**
     * Determines whether an object is an Array.
     *
     * @param value Value to test.
     */
    function isArray(value) {
        return value instanceof Array || // doesn't work on different windows
            Array.isArray(value) || // doesn't work on derived classes
            Object.prototype.toString.call(value) === '[object Array]'; // always works
        // for a detailed discussion see
        // http://perfectionkills.com/instanceof-considered-harmful-or-how-to-write-a-robust-isarray/
    }
    wijmo.isArray = isArray;
    /**
     * Determines whether a value is an object
     * (as opposed to a value type, an array, or a Date).
     *
     * @param value Value to test.
     */
    function isObject(value) {
        return value != null && typeof value == 'object' && !isDate(value) && !isArray(value);
    }
    wijmo.isObject = isObject;
    /**
     * Determines whether an object is empty
     * (contains no enumerable properties).
     *
     * @param obj Object to test.
     */
    function isEmpty(obj) {
        for (var k in obj)
            return false;
        return true;
    }
    wijmo.isEmpty = isEmpty;
    /**
     * Creates a new unique id for an element by adding sequential
     * numbers to a given base id.
     *
     * @param baseId String to use as a basis for generating the unique id.
     */
    function getUniqueId(baseId) {
        var newId = baseId;
        for (var i = 0; document.getElementById(newId) != null; i++) {
            newId = baseId + i; // new unique id
        }
        return newId;
    }
    wijmo.getUniqueId = getUniqueId;
    /**
     * Converts mouse or touch event arguments into a @see:Point in page coordinates.
     */
    function mouseToPage(e) {
        // accept Point objects
        if (e instanceof Point) {
            return e;
        }
        // accept touch events
        if (e.touches && e.touches.length > 0) {
            e = e.touches[0];
        }
        // accept mouse events
        // The pageX/Y properties may return wrong values (e.g. Android with zoomed screens); 
        // so we get the client coordinates and apply the page offset ourselves instead.
        if (isNumber(e.clientX) && isNumber(e.clientY)) {
            return new Point(e.clientX + pageXOffset, e.clientY + pageYOffset);
        }
        //if (isNumber(e.pageX) && isNumber(e.pageY)) {
        //    return new Point(e.pageX, e.pageY);
        //}
        // wrong parameter type...
        throw 'Mouse or touch event expected.';
    }
    wijmo.mouseToPage = mouseToPage;
    /**
     * Gets the type of a value.
     *
     * @param value Value to test.
     * @return A @see:DataType value representing the type of the value passed in.
     */
    function getType(value) {
        if (isNumber(value))
            return DataType.Number;
        if (isBoolean(value))
            return DataType.Boolean;
        if (isDate(value))
            return DataType.Date;
        if (isString(value))
            return DataType.String;
        if (isArray(value))
            return DataType.Array;
        return DataType.Object;
    }
    wijmo.getType = getType;
    /**
     * Changes the type of a value.
     *
     * If the conversion fails, the original value is returned. To check if a
     * conversion succeeded, you should check the type of the returned value.
     *
     * @param value Value to convert.
     * @param type @see:DataType to convert the value to.
     * @param format Format to use when converting to or from strings.
     * @return The converted value, or the original value if a conversion was not possible.
     */
    function changeType(value, type, format) {
        if (value != null) {
            // convert strings to numbers, dates, or booleans
            if (isString(value)) {
                switch (type) {
                    case DataType.Number:
                        var num = wijmo.Globalize.parseFloat(value, format);
                        return isNaN(num) ? value : num;
                    case DataType.Date:
                        var date = wijmo.Globalize.parseDate(value, format);
                        if (!date && !format && value) {
                            date = new Date(value); // fallback on JavaScript parser
                        }
                        return date && isFinite(date.getTime()) ? date : value;
                    case DataType.Boolean:
                        switch (value.toLowerCase()) {
                            case 'true': return true;
                            case 'false': return false;
                        }
                        return value; // TFS 125067
                }
            }
            // convert anything to string
            if (type == DataType.String) {
                return wijmo.Globalize.format(value, format);
            }
        }
        // did not convert...
        //console.log('did not convert "' + value + '" to type ' + DataType[type]);
        return value;
    }
    wijmo.changeType = changeType;
    /**
     * Rounds or truncates a number to a specified precision.
     *
     * @param value Value to round or truncate.
     * @param prec Number of decimal digits for the result.
     * @param truncate Whether to truncate or round the original value.
     */
    function toFixed(value, prec, truncate) {
        if (truncate) {
            var str = value.toString(), decPos = str.indexOf('.');
            if (str.indexOf('e') < 0 && decPos > -1) {
                str = str.substr(0, decPos + 1 + prec);
                value = parseFloat(str);
            }
        }
        else {
            var str = value.toFixed(prec);
            value = parseFloat(str);
        }
        return value;
    }
    wijmo.toFixed = toFixed;
    /**
     * Replaces each format item in a specified string with the text equivalent of an
     * object's value.
     *
     * The function works by replacing parts of the <b>formatString</b> with the pattern
     * '{name:format}' with properties of the <b>data</b> parameter. For example:
     *
     * <pre>
     * var data = { name: 'Joe', amount: 123456 };
     * var msg = wijmo.format('Hello {name}, you won {amount:n2}!', data);
     * </pre>
     *
     * The @see:format function supports pluralization. If the format string is a
     * JSON-encoded object with 'count' and 'when' properties, the method uses
     * the 'count' parameter of the data object to select the appropriate format
     * from the 'when' property. For example:
     *
     * <pre>
     * var fmt = {
     *     count: 'count',
     *     when: {
     *         0: 'No items selected.',
     *         1: 'One item is selected.',
     *         2: 'A pair is selected.',
     *         'other': '{count:n0} items are selected.'
     *     }
     * }
     * fmt = JSON.stringify(fmt);
     * console.log(wijmo.format(fmt, { count: 0 })); // No items selected.
     * console.log(wijmo.format(fmt, { count: 1 })); // One item is selected.
     * console.log(wijmo.format(fmt, { count: 2 })); // A pair is selected.
     * console.log(wijmo.format(fmt, { count: 12 })); 12 items are selected.
     * </pre>
     *
     * The optional <b>formatFunction</b> allows you to customize the content by
     * providing context-sensitive formatting. If provided, the format function
     * gets called for each format element and gets passed the data object, the
     * parameter name, the format, and the value; it should return an output string.
     * For example:
     *
     * <pre>
     * var data = { name: 'Joe', amount: 123456 };
     * var msg = wijmo.format('Hello {name}, you won {amount:n2}!', data,
     *     function (data, name, fmt, val) {
     *         if (wijmo.isString(data[name])) {
     *             val = wijmo.escapeHtml(data[name]);
     *         }
     *         return val;
     *     }
     * );
     * </pre>
     *
     * @param format A composite format string.
     * @param data The data object used to build the string.
     * @param formatFunction An optional function used to format items in context.
     * @return The formatted string.
     */
    function format(format, data, formatFunction) {
        format = asString(format);
        // pluralize
        if (format.match(/\{.*"count".*:.*"when".*:.*\}/)) {
            try {
                var pluralized = JSON.parse(format);
                if (isString(pluralized.count)) {
                    var count = data[pluralized.count], when = pluralized.when;
                    if (isNumber(count) && isObject(when)) {
                        var pluralizedFormat = when[count] || when.other;
                        if (isString(pluralizedFormat)) {
                            format = pluralizedFormat;
                        }
                    }
                }
            }
            catch (x) { }
        }
        // apply format
        return format.replace(/\{(.*?)(:(.*?))?\}/g, function (match, name, x, fmt) {
            var val = match;
            if (name && name[0] != '{' && data) {
                // get the value
                val = data[name];
                // apply static format
                if (fmt) {
                    val = wijmo.Globalize.format(val, fmt);
                }
                // apply format function
                if (formatFunction) {
                    val = formatFunction(data, name, fmt, val);
                }
            }
            return val == null ? '' : val;
        });
    }
    wijmo.format = format;
    /**
     * Clamps a value between a minimum and a maximum.
     *
     * @param value Original value.
     * @param min Minimum allowed value.
     * @param max Maximum allowed value.
     */
    function clamp(value, min, max) {
        if (value != null) {
            if (max != null && value > max)
                value = max;
            if (min != null && value < min)
                value = min;
        }
        return value;
    }
    wijmo.clamp = clamp;
    /**
     * Copies properties from an object to another.
     *
     * This method is typically used to initialize controls and other Wijmo objects
     * by setting their properties and assigning event handlers.
     *
     * The destination object must define all the properties defined in the source,
     * or an error will be thrown.
     *
     * @param dst The destination object.
     * @param src The source object.
     */
    function copy(dst, src) {
        if (src) {
            for (var key in src) {
                if (key[0] != '_') {
                    assert(key in dst, 'Unknown property "' + key + '".');
                    var value = src[key];
                    if (!dst._copy || !dst._copy(key, value)) {
                        if (dst[key] instanceof wijmo.Event && isFunction(value)) {
                            dst[key].addHandler(value); // add event handler
                        }
                        else if (isObject(value) && !(value instanceof Element) && dst[key] && key != 'itemsSource') {
                            copy(dst[key], value); // copy sub-objects
                        }
                        else {
                            dst[key] = value; // assign values
                        }
                    }
                }
            }
        }
    }
    wijmo.copy = copy;
    /**
     * Throws an exception if a condition is false.
     *
     * @param condition Condition expected to be true.
     * @param msg Message of the exception if the condition is not true.
     */
    function assert(condition, msg) {
        if (!condition) {
            throw '** Assertion failed in Wijmo: ' + msg;
        }
    }
    wijmo.assert = assert;
    /**
     * Outputs a message to indicate a member has been deprecated.
     *
     * @param oldMember Member that has been deprecated.
     * @param newMember Member that replaces the one that has been deprecated.
     */
    function _deprecated(oldMember, newMember) {
        console.error('** WARNING: "' + oldMember + '" has been deprecated; please use "' + newMember + '" instead.');
    }
    wijmo._deprecated = _deprecated;
    /**
     * Asserts that a value is a string.
     *
     * @param value Value supposed to be a string.
     * @param nullOK Whether null values are acceptable.
     * @return The string passed in.
     */
    function asString(value, nullOK) {
        if (nullOK === void 0) { nullOK = true; }
        assert((nullOK && value == null) || isString(value), 'String expected.');
        return value;
    }
    wijmo.asString = asString;
    /**
     * Asserts that a value is a number.
     *
     * @param value Value supposed to be numeric.
     * @param nullOK Whether null values are acceptable.
     * @param positive Whether to accept only positive numeric values.
     * @return The number passed in.
     */
    function asNumber(value, nullOK, positive) {
        if (nullOK === void 0) { nullOK = false; }
        if (positive === void 0) { positive = false; }
        assert((nullOK && value == null) || isNumber(value), 'Number expected.');
        if (positive && value && value < 0)
            throw 'Positive number expected.';
        return value;
    }
    wijmo.asNumber = asNumber;
    /**
     * Asserts that a value is an integer.
     *
     * @param value Value supposed to be an integer.
     * @param nullOK Whether null values are acceptable.
     * @param positive Whether to accept only positive integers.
     * @return The number passed in.
     */
    function asInt(value, nullOK, positive) {
        if (nullOK === void 0) { nullOK = false; }
        if (positive === void 0) { positive = false; }
        assert((nullOK && value == null) || isInt(value), 'Integer expected.');
        if (positive && value && value < 0)
            throw 'Positive integer expected.';
        return value;
    }
    wijmo.asInt = asInt;
    /**
     * Asserts that a value is a Boolean.
     *
     * @param value Value supposed to be Boolean.
     * @param nullOK Whether null values are acceptable.
     * @return The Boolean passed in.
     */
    function asBoolean(value, nullOK) {
        if (nullOK === void 0) { nullOK = false; }
        assert((nullOK && value == null) || isBoolean(value), 'Boolean expected.');
        return value;
    }
    wijmo.asBoolean = asBoolean;
    /**
     * Asserts that a value is a Date.
     *
     * @param value Value supposed to be a Date.
     * @param nullOK Whether null values are acceptable.
     * @return The Date passed in.
     */
    function asDate(value, nullOK) {
        if (nullOK === void 0) { nullOK = false; }
        // parse strings into dates using RFC 3339 pattern ([yyyy-MM-dd] [hh:mm[:ss]])
        if (isString(value)) {
            var dt = changeType(value, DataType.Date, 'r');
            if (isDate(dt)) {
                value = dt;
            }
        }
        assert((nullOK && value == null) || isDate(value), 'Date expected.');
        return value;
    }
    wijmo.asDate = asDate;
    /**
     * Asserts that a value is a function.
     *
     * @param value Value supposed to be a function.
     * @param nullOK Whether null values are acceptable.
     * @return The function passed in.
     */
    function asFunction(value, nullOK) {
        if (nullOK === void 0) { nullOK = true; }
        assert((nullOK && value == null) || isFunction(value), 'Function expected.');
        return value;
    }
    wijmo.asFunction = asFunction;
    /**
     * Asserts that a value is an array.
     *
     * @param value Value supposed to be an array.
     * @param nullOK Whether null values are acceptable.
     * @return The array passed in.
     */
    function asArray(value, nullOK) {
        if (nullOK === void 0) { nullOK = true; }
        assert((nullOK && value == null) || isArray(value), 'Array expected.');
        return value;
    }
    wijmo.asArray = asArray;
    /**
     * Asserts that a value is an instance of a given type.
     *
     * @param value Value to be checked.
     * @param type Type of value expected.
     * @param nullOK Whether null values are acceptable.
     * @return The value passed in.
     */
    function asType(value, type, nullOK) {
        if (nullOK === void 0) { nullOK = false; }
        value = tryCast(value, type);
        assert(nullOK || value != null, type + ' expected.');
        return value;
    }
    wijmo.asType = asType;
    /**
     * Asserts that a value is a valid setting for an enumeration.
     *
     * @param value Value supposed to be a member of the enumeration.
     * @param enumType Enumeration to test for.
     * @param nullOK Whether null values are acceptable.
     * @return The value passed in.
     */
    function asEnum(value, enumType, nullOK) {
        if (nullOK === void 0) { nullOK = false; }
        if (value == null && nullOK)
            return null;
        var e = enumType[value];
        assert(e != null, 'Invalid enum value.');
        return isNumber(e) ? e : value;
    }
    wijmo.asEnum = asEnum;
    /**
     * Asserts that a value is an @see:ICollectionView or an Array.
     *
     * @param value Array or @see:ICollectionView.
     * @param nullOK Whether null values are acceptable.
     * @return The @see:ICollectionView that was passed in or a @see:CollectionView
     * created from the array that was passed in.
     */
    function asCollectionView(value, nullOK) {
        if (nullOK === void 0) { nullOK = true; }
        if (value == null && nullOK) {
            return null;
        }
        var cv = tryCast(value, 'ICollectionView');
        if (cv != null) {
            return cv;
        }
        if (!isArray(value)) {
            assert(false, 'Array or ICollectionView expected.');
        }
        return new wijmo.collections.CollectionView(value);
    }
    wijmo.asCollectionView = asCollectionView;
    /**
     * Checks whether an @see:ICollectionView is defined and not empty.
     *
     * @param value @see:ICollectionView to check.
     */
    function hasItems(value) {
        return value != null && value.items != null && value.items.length > 0;
    }
    wijmo.hasItems = hasItems;
    /**
     * Converts a camel-cased string into a header-type string by capitalizing the first letter
     * and adding spaces before uppercase characters preceded by lower-case characters.
     *
     * For example, 'somePropertyName' becomes 'Some Property Name'.
     *
     * @param text String to convert to header case.
     */
    function toHeaderCase(text) {
        return text && text.length
            ? text[0].toUpperCase() + text.substr(1).replace(/([a-z])([A-Z])/g, '$1 $2')
            : '';
    }
    wijmo.toHeaderCase = toHeaderCase;
    /**
     * Escapes a string by replacing HTML characters as text entities.
     *
     * Strings entered by uses should always be escaped before they are displayed
     * in HTML pages. This ensures page integrity and prevents HTML/javascript
     * injection attacks.
     *
     * @param text Text to escape.
     * @return An HTML-escaped version of the original string.
     */
    function escapeHtml(text) {
        if (isString(text)) {
            text = text.replace(/[&<>"'\/]/g, function (s) {
                return _ENTITYMAP[s];
            });
        }
        return text;
    }
    wijmo.escapeHtml = escapeHtml;
    var _ENTITYMAP = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;'
    };
    /**
     * Checks whether an element has a class.
     *
     * @param e Element to check.
     * @param className Class to check for.
     */
    function hasClass(e, className) {
        // NOTE: using e.getAttribute('class') instead of e.classNames
        // so this works with SVG as well as regular HTML elements.
        // NOTE: don't use word boundaries because class names may have 
        // hyphens and other non-word boundary characters
        if (e && e.getAttribute) {
            var rx = new RegExp('(\\s|^)' + className + '(\\s|$)');
            return e && rx.test(e.getAttribute('class'));
        }
        return false;
    }
    wijmo.hasClass = hasClass;
    /**
     * Removes a class from an element.
     *
     * @param e Element that will have the class removed.
     * @param className Class to remove from the element.
     */
    function removeClass(e, className) {
        if (e && className && e.setAttribute) {
            var classes = className.split(' ');
            for (var i = 0; i < classes.length; i++) {
                var cls = classes[i];
                if (hasClass(e, cls)) {
                    var rx = new RegExp('((\\s|^)' + cls + '(\\s|$))', 'g'), cn = e.getAttribute('class');
                    cn = cn.replace(rx, ' ').replace(/ +/g, ' ').trim();
                    if (cn) {
                        e.setAttribute('class', cn);
                    }
                    else {
                        e.removeAttribute('class');
                    }
                }
            }
        }
    }
    wijmo.removeClass = removeClass;
    /**
     * Adds a class to an element.
     *
     * @param e Element that will have the class added.
     * @param className Class to add to the element.
     */
    function addClass(e, className) {
        if (e && className && e.setAttribute) {
            var classes = className.split(' ');
            for (var i = 0; i < classes.length; i++) {
                var cls = classes[i];
                if (!hasClass(e, cls)) {
                    var cn = e.getAttribute('class');
                    e.setAttribute('class', cn ? cn + ' ' + cls : cls);
                }
            }
        }
    }
    wijmo.addClass = addClass;
    /**
     * Adds or removes a class to or from an element.
     *
     * @param e Element that will have the class added.
     * @param className Class to add or remove.
     * @param addOrRemove Whether to add or remove the class. If not provided, the class is toggled.
     * Use true to add class to element and false to remove class from element.
     */
    function toggleClass(e, className, addOrRemove) {
        if (addOrRemove == null) {
            addOrRemove = !hasClass(e, className);
        }
        if (addOrRemove) {
            addClass(e, className);
        }
        else {
            removeClass(e, className);
        }
    }
    wijmo.toggleClass = toggleClass;
    /**
     * Sets or clears an attribute on an element.
     *
     * @param e Element that will be updated.
     * @param name Name of the attribute to add or remove.
     * @param value Value of the attribute, or null to remove the attribute
     * from the element.
     * @param keep Whether to keep original attribute if present.
     */
    function setAttribute(e, name, value, keep) {
        if (value != null) {
            if (!keep || !e.getAttribute(name)) {
                e.setAttribute(name, value.toString());
            }
        }
        else {
            e.removeAttribute(name);
        }
    }
    wijmo.setAttribute = setAttribute;
    /**
     * Sets the start and end positions of a selection in a text field.
     *
     * This method is similar to the native @see:setSelectionRange method
     * in HTMLInputElement objects, except it checks for conditions that
     * may cause exceptions (element not in the DOM, disabled, or hidden).
     *
     * @param start Offset into the text field for the start of the selection.
     * @param end Offset into the text field for the end of the selection.
     */
    function setSelectionRange(e, start, end) {
        if (end === void 0) { end = start; }
        e = asType(e, HTMLInputElement);
        if (contains(document.body, e) && !e.disabled && e.style.display != 'none') {
            try {
                // use 'backward' to keep the start in view (but not in Edge! TFS 228053)
                e.setSelectionRange(asNumber(start), asNumber(end), wijmo.isIE() ? null : 'backward');
                // focus needed in Chrome (TFS 124102, 142672) 
                // and after setRange (TFS 228053)
                e.focus();
            }
            catch (x) { }
        }
    }
    wijmo.setSelectionRange = setSelectionRange;
    /**
     * Safely removes an element from the DOM tree.
     *
     * @param e Element to remove from the DOM tree.
     */
    function removeChild(e) {
        return e && e.parentNode
            ? e.parentNode.removeChild(e)
            : null;
    }
    wijmo.removeChild = removeChild;
    /**
     * Gets a reference to the element that contains the focus,
     * accounting for shadow document fragments.
     */
    function getActiveElement() {
        var ae = document.activeElement;
        if (ae) {
            // account for shadowRoot: https://github.com/w3c/webcomponents/issues/358)
            var shadowRoot = ae['shadowRoot'];
            if (shadowRoot && shadowRoot.activeElement) {
                ae = shadowRoot.activeElement;
            }
        }
        return ae;
    }
    wijmo.getActiveElement = getActiveElement;
    /**
     * Moves the focus to the next/previous/first focusable child within
     * a given parent element.
     *
     * @param parent Parent element.
     * @param offset Offset to use when moving the focus (use zero to focus on the first focusable child).
     */
    function moveFocus(parent, offset) {
        // build array of focusable elements (including divs but not spans: TFS 255732)
        var focusable = _getFocusableElements(parent);
        // calculate focus index
        var index = 0;
        if (offset) {
            var i = focusable.indexOf(getActiveElement());
            if (i > -1) {
                index = (i + offset + focusable.length) % focusable.length; // TFS 152269, 152163
            }
        }
        // move focus to element at the focus index
        if (index < focusable.length) {
            var el = focusable[index];
            el.focus();
            if (el instanceof HTMLInputElement) {
                el.select(); // TFS 190336
            }
        }
    }
    wijmo.moveFocus = moveFocus;
    // get an array with focusable child elements
    function _getFocusableElements(parent) {
        var focusable = [], tags = 'input,select,textarea,button,a,div', // TFS 255732: divs, no spans
        elements = parent.querySelectorAll(tags);
        for (var i = 0; i < elements.length; i++) {
            var el = elements[i];
            // check that the element is visible and focusable
            if (el.offsetHeight > 0 && el.tabIndex > -1 &&
                !el.disabled && !closest(el, '[disabled],.wj-state-disabled')) {
                // IE defaults tabindex to zero, other browsers to -1
                if (wijmo.isIE() && !el.hasAttribute('tabindex')) {
                    // skip divs without explicit tab index
                    if (el instanceof HTMLDivElement) {
                        continue;
                    }
                    // skip cell elements with no tabindex in FlexGrid controls
                    // with keyActionTab set to 'None'
                    var grid_1 = wijmo.Control.getControl(closest(el, '.wj-flexgrid'));
                    if (grid_1 && grid_1['keyActionTab'] == 0) {
                        continue;
                    }
                }
                // add controls and elements without child focusable elements
                if (wijmo.Control.getControl(el) || !_getFocusableElements(el).length) {
                    focusable.push(el);
                }
            }
        }
        return focusable;
    }
    // ** jQuery replacement methods
    /**
     * Gets an element from a jQuery-style selector.
     *
     * @param selector An element, a query selector string, or a jQuery object.
     */
    function getElement(selector) {
        // check if the selector is an instance of Element rather than HTMLElement,
        // so this works with SVG elements too (TFS 216148)
        if (selector instanceof Element)
            return selector;
        if (isString(selector))
            return document.querySelector(selector);
        if (selector && selector.jquery)
            return selector[0];
        return null;
    }
    wijmo.getElement = getElement;
    /**
     * Creates an element from an HTML string.
     *
     * @param html HTML fragment to convert into an HTMLElement.
     * @param appendTo Optional HTMLElement to append the new element to.
     * @return The new element.
     */
    function createElement(html, appendTo) {
        var div = document.createElement('div');
        div.innerHTML = html;
        if (div.children.length == 1) {
            div = div.children[0];
        }
        if (appendTo) {
            appendTo.appendChild(div);
        }
        return div;
    }
    wijmo.createElement = createElement;
    /**
     * Sets the text content of an element.
     *
     * @param e Element that will have its content updated.
     * @param text Plain text to be assigned to the element.
     */
    function setText(e, text) {
        e.textContent = text || ''; // TFS 285180 (keep it simple)
    }
    wijmo.setText = setText;
    /**
     * Checks whether an HTML element contains another.
     *
     * @param parent Parent element.
     * @param child Child element.
     * @return True if the parent element contains the child element.
     */
    function contains(parent, child) {
        for (var e = child; e && parent;) {
            if (e === parent)
                return true; // found!
            e = e.parentNode || e['host']; // move up to parent node or host (shadow DOM)
        }
        return false;
    }
    wijmo.contains = contains;
    /**
     * Finds the closest ancestor (including the original element) that satisfies a selector.
     *
     * @param e Element where the search should start.
     * @param selector A string containing a selector expression to match elements against.
     * @return The closest ancestor that satisfies the selector, or null if not found.
     */
    function closest(e, selector) {
        var matches = e ? (e.matches || e.webkitMatchesSelector || e.mozMatchesSelector || e.msMatchesSelector) : null;
        if (matches) {
            for (; e; e = e.parentNode) {
                if (e instanceof Element && matches.call(e, selector)) {
                    return e;
                }
            }
        }
        return null;
    }
    wijmo.closest = closest;
    /**
     * Finds the closest ancestor (including the original element) that satisfies a class selector.
     *
     * @param e Element where the search should start.
     * @param className A string containing the class name to match elements against.
     * @return The closest ancestor that has the specified class name, or null if not found.
     */
    function closestClass(e, className) {
        return closest(e, '.' + className);
    }
    wijmo.closestClass = closestClass;
    /**
     * Enables or disables an element.
     *
     * @param e Element to enable or disable.
     * @param value Whether to enable or disable the element.
     */
    function enable(e, value) {
        // update wj-state-disabled class and disabled attribute on the element
        var disabled = !value;
        toggleClass(e, 'wj-state-disabled', disabled);
        setAttribute(e, 'disabled', disabled ? 'true' : null);
        // update disabled attribute on inner input elements (TFS 190939)
        var inputs = e.querySelectorAll('input');
        for (var i = 0; i < inputs.length; i++) {
            var input_1 = inputs[i];
            if (value) {
                input_1.removeAttribute('disabled');
            }
            else {
                input_1.setAttribute('disabled', 'true');
            }
        }
    }
    wijmo.enable = enable;
    /**
     * Gets the bounding rectangle of an element in page coordinates.
     *
     * This is similar to the <b>getBoundingClientRect</b> function,
     * except that uses viewport coordinates, which change when the
     * document scrolls.
     */
    function getElementRect(e) {
        var rc = e.getBoundingClientRect();
        return new Rect(rc.left + pageXOffset, rc.top + pageYOffset, rc.width, rc.height);
    }
    wijmo.getElementRect = getElementRect;
    /**
     * Modifies the style of an element by applying the properties specified in an object.
     *
     * @param e Element or array of elements whose style will be modified.
     * @param css Object containing the style properties to apply to the element.
     */
    function setCss(e, css) {
        // apply to arrays
        if (e instanceof Array) {
            for (var i = 0; i < e.length; i++) {
                setCss(e[i], css);
            }
            return;
        }
        // apply to elements
        if (e && e.style) {
            var s = e.style;
            for (var p in css) {
                // add pixel units to numeric geometric properties
                var val = css[p];
                if (typeof (val) == 'number' &&
                    p.match(/width|height|left|top|right|bottom|size|padding|margin'/i)) {
                    val = val + 'px';
                }
                // set the attribute if it changed
                if (s[p] != val) {
                    s[p] = val.toString();
                }
            }
        }
    }
    wijmo.setCss = setCss;
    /**
     * Calls a function on a timer with a parameter varying between zero and one.
     *
     * Use this function to create animations by modifying document properties
     * or styles on a timer.
     *
     * For example, the code below changes the opacity of an element from zero
     * to one in one second:
     * <pre>var element = document.getElementById('someElement');
     * animate(function(pct) {
     *   element.style.opacity = pct;
     * }, 1000);</pre>
     *
     * The function returns an interval ID that you can use to stop the
     * animation. This is typically done when you are starting a new animation
     * and wish to suspend other on-going animations on the same element.
     * For example, the code below keeps track of the interval ID and clears
     * if before starting a new animation:
     * <pre>var element = document.getElementById('someElement');
     * if (this._animInterval) {
     *   clearInterval(this._animInterval);
     * }
     * var self = this;
     * self._animInterval = animate(function(pct) {
     *   element.style.opacity = pct;
     *   if (pct == 1) {
     *     self._animInterval = null;
     *   }
     * }, 1000);</pre>
     *
     * @param apply Callback function that modifies the document.
     * The function takes a single parameter that represents a percentage.
     * @param duration The duration of the animation, in milliseconds.
     * @param step The interval between animation frames, in milliseconds.
     * @return An interval id that you can use to suspend the animation.
     */
    function animate(apply, duration, step) {
        if (duration === void 0) { duration = wijmo.Control._ANIM_DEF_DURATION; }
        if (step === void 0) { step = wijmo.Control._ANIM_DEF_STEP; }
        apply = asFunction(apply);
        duration = asNumber(duration, false, true);
        step = asNumber(step, false, true);
        var start = Date.now();
        var timer = setInterval(function () {
            var pct = Math.min(1, (Date.now() - start) / duration); // linear
            pct = Math.sin(pct * Math.PI / 2); // easeOutSin
            pct *= pct; // swing
            requestAnimationFrame(function () {
                apply(pct);
            });
            if (pct >= 1) {
                clearInterval(timer);
            }
        }, step);
        return timer;
    }
    wijmo.animate = animate;
    // ** utility classes
    /**
     * Class that represents a point (with x and y coordinates).
     */
    var Point = /** @class */ (function () {
        /**
         * Initializes a new instance of the @see:Point class.
         *
         * @param x X coordinate of the new Point.
         * @param y Y coordinate of the new Point.
         */
        function Point(x, y) {
            if (x === void 0) { x = 0; }
            if (y === void 0) { y = 0; }
            this.x = asNumber(x);
            this.y = asNumber(y);
        }
        /**
         * Returns true if a @see:Point has the same coordinates as this @see:Point.
         *
         * @param pt @see:Point to compare to this @see:Point.
         */
        Point.prototype.equals = function (pt) {
            return (pt instanceof Point) && this.x == pt.x && this.y == pt.y;
        };
        /**
         * Creates a copy of this @see:Point.
         */
        Point.prototype.clone = function () {
            return new Point(this.x, this.y);
        };
        return Point;
    }());
    wijmo.Point = Point;
    /**
     * Class that represents a size (with width and height).
     */
    var Size = /** @class */ (function () {
        /**
         * Initializes a new instance of the @see:Size class.
         *
         * @param width Width of the new @see:Size.
         * @param height Height of the new @see:Size.
         */
        function Size(width, height) {
            if (width === void 0) { width = 0; }
            if (height === void 0) { height = 0; }
            this.width = asNumber(width);
            this.height = asNumber(height);
        }
        /**
         * Returns true if a @see:Size has the same dimensions as this @see:Size.
         *
         * @param sz @see:Size to compare to this @see:Size.
         */
        Size.prototype.equals = function (sz) {
            return (sz instanceof Size) && this.width == sz.width && this.height == sz.height;
        };
        /**
         * Creates a copy of this @see:Size.
         */
        Size.prototype.clone = function () {
            return new Size(this.width, this.height);
        };
        return Size;
    }());
    wijmo.Size = Size;
    /**
     * Class that represents a rectangle (with left, top, width, and height).
     */
    var Rect = /** @class */ (function () {
        /**
         * Initializes a new instance of the @see:Rect class.
         *
         * @param left Left coordinate of the new @see:Rect.
         * @param top Top coordinate of the new @see:Rect.
         * @param width Width of the new @see:Rect.
         * @param height Height of the new @see:Rect.
         */
        function Rect(left, top, width, height) {
            this.left = asNumber(left);
            this.top = asNumber(top);
            this.width = asNumber(width);
            this.height = asNumber(height);
        }
        Object.defineProperty(Rect.prototype, "right", {
            /**
             * Gets the right coordinate of this @see:Rect.
             */
            get: function () {
                return this.left + this.width;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Rect.prototype, "bottom", {
            /**
             * Gets the bottom coordinate of this @see:Rect.
             */
            get: function () {
                return this.top + this.height;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Returns true if a @see:Rect has the same coordinates and dimensions
         * as this @see:Rect.
         *
         * @param rc @see:Rect to compare to this @see:Rect.
         */
        Rect.prototype.equals = function (rc) {
            return (rc instanceof Rect) && this.left == rc.left && this.top == rc.top && this.width == rc.width && this.height == rc.height;
        };
        /**
         * Creates a copy of this @see:Rect.
         */
        Rect.prototype.clone = function () {
            return new Rect(this.left, this.top, this.width, this.height);
        };
        /**
         * Creates a @see:Rect from <b>ClientRect</b> or <b>SVGRect</b> objects.
         *
         * @param rc Rectangle obtained by a call to the DOM's <b>getBoundingClientRect</b>
         * or <b>GetBoundingBox</b> methods.
         */
        Rect.fromBoundingRect = function (rc) {
            if (rc.left != null) {
                return new Rect(rc.left, rc.top, rc.width, rc.height);
            }
            else if (rc.x != null) {
                return new Rect(rc.x, rc.y, rc.width, rc.height);
            }
            else {
                assert(false, 'Invalid source rectangle.');
            }
        };
        /**
         * Gets a rectangle that represents the union of two rectangles.
         *
         * @param rc1 First rectangle.
         * @param rc2 Second rectangle.
         */
        Rect.union = function (rc1, rc2) {
            var x = Math.min(rc1.left, rc2.left), y = Math.min(rc1.top, rc2.top), right = Math.max(rc1.right, rc2.right), bottom = Math.max(rc1.bottom, rc2.bottom);
            return new Rect(x, y, right - x, bottom - y);
        };
        /**
         * Gets a rectangle that represents the intersection of two rectangles.
         *
         * @param rc1 First rectangle.
         * @param rc2 Second rectangle.
         */
        Rect.intersection = function (rc1, rc2) {
            var x = Math.max(rc1.left, rc2.left), y = Math.max(rc1.top, rc2.top), right = Math.min(rc1.right, rc2.right), bottom = Math.min(rc1.bottom, rc2.bottom);
            return new Rect(x, y, right - x, bottom - y);
        };
        /**
         * Determines whether the rectangle contains a given point or rectangle.
         *
         * @param pt The @see:Point or @see:Rect to ckeck.
         */
        Rect.prototype.contains = function (pt) {
            if (pt instanceof Point) {
                return pt.x >= this.left && pt.x <= this.right &&
                    pt.y >= this.top && pt.y <= this.bottom;
            }
            else if (pt instanceof Rect) {
                var rc2 = pt;
                return rc2.left >= this.left && rc2.right <= this.right &&
                    rc2.top >= this.top && rc2.bottom <= this.bottom;
            }
            else {
                assert(false, 'Point or Rect expected.');
            }
        };
        /**
         * Creates a rectangle that results from expanding or shrinking a rectangle by the specified amounts.
         *
         * @param dx The amount by which to expand or shrink the left and right sides of the rectangle.
         * @param dy The amount by which to expand or shrink the top and bottom sides of the rectangle.
         */
        Rect.prototype.inflate = function (dx, dy) {
            return new Rect(this.left - dx, this.top - dy, this.width + 2 * dx, this.height + 2 * dy);
        };
        return Rect;
    }());
    wijmo.Rect = Rect;
    /**
     * Provides date and time utilities.
     */
    var DateTime = /** @class */ (function () {
        function DateTime() {
        }
        /**
         * Gets a new Date that adds the specified number of days to a given Date.
         *
         * @param value Original date.
         * @param days Number of days to add to the given date.
         */
        DateTime.addDays = function (value, days) {
            return DateTime.newDate(value.getFullYear(), value.getMonth(), value.getDate() + days);
        };
        /**
         * Gets a new Date that adds the specified number of months to a given Date.
         *
         * @param value Original date.
         * @param months Number of months to add to the given date.
         */
        DateTime.addMonths = function (value, months) {
            return DateTime.newDate(value.getFullYear(), value.getMonth() + months, value.getDate());
        };
        /**
         * Gets a new Date that adds the specified number of years to a given Date.
         *
         * @param value Original date.
         * @param years Number of years to add to the given date.
         */
        DateTime.addYears = function (value, years) {
            return DateTime.newDate(value.getFullYear() + years, value.getMonth(), value.getDate());
        };
        /**
         * Gets a new Date that adds the specified number of hours to a given Date.
         *
         * @param value Original date.
         * @param hours Number of hours to add to the given date.
         */
        DateTime.addHours = function (value, hours) {
            return DateTime.newDate(value.getFullYear(), value.getMonth(), value.getDate(), value.getHours() + hours);
        };
        /**
         * Gets a new Date that adds the specified number of minutes to a given Date.
         *
         * @param value Original date.
         * @param minutes Number of minutes to add to the given date.
         */
        DateTime.addMinutes = function (value, minutes) {
            return DateTime.newDate(value.getFullYear(), value.getMonth(), value.getDate(), value.getHours(), value.getMinutes() + minutes);
        };
        /**
         * Gets a new Date that adds the specified number of seconds to a given Date.
         *
         * @param value Original date.
         * @param seconds Number of seconds to add to the given date.
         */
        DateTime.addSeconds = function (value, seconds) {
            return DateTime.newDate(value.getFullYear(), value.getMonth(), value.getDate(), value.getHours(), value.getMinutes(), value.getSeconds() + seconds);
        };
        /**
         * Returns true if two Date objects refer to the same date (ignoring time).
         *
         * @param d1 First date.
         * @param d2 Second date.
         */
        DateTime.sameDate = function (d1, d2) {
            return isDate(d1) && isDate(d2) &&
                d1.getFullYear() == d2.getFullYear() &&
                d1.getMonth() == d2.getMonth() &&
                d1.getDate() == d2.getDate();
        };
        /**
         * Returns true if two Date objects refer to the same time (ignoring date).
         *
         * @param d1 First date.
         * @param d2 Second date.
         */
        DateTime.sameTime = function (d1, d2) {
            return isDate(d1) && isDate(d2) &&
                d1.getHours() == d2.getHours() &&
                d1.getMinutes() == d2.getMinutes() &&
                d1.getSeconds() == d2.getSeconds();
        };
        /**
         * Returns true if two Date objects refer to the same date and time.
         *
         * @param d1 First date.
         * @param d2 Second date.
         */
        DateTime.equals = function (d1, d2) {
            return isDate(d1) && isDate(d2) && d1.getTime() == d2.getTime();
        };
        /**
         * Gets a Date object with the date and time set on two Date objects.
         *
         * @param date Date object that contains the date (day/month/year).
         * @param time Date object that contains the time (hour:minute:second).
         */
        DateTime.fromDateTime = function (date, time) {
            if (!date && !time)
                return null;
            if (!date)
                date = time;
            if (!time)
                time = date;
            return DateTime.newDate(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
        };
        /**
         * Converts a calendar date to a fiscal date using the current culture.
         *
         * @param date Calendar date.
         * @param govt Whether to use the government or corporate fiscal year.
         */
        DateTime.toFiscal = function (date, govt) {
            var cal = wijmo.culture.Globalize.calendar;
            return isArray(cal.fiscalYearOffsets)
                ? DateTime.addMonths(date, -cal.fiscalYearOffsets[govt ? 0 : 1])
                : date;
        };
        /**
         * Converts a fiscal year date to a calendar date using the current culture.
         *
         * @param date Fiscal year date.
         * @param govt Whether to use the government or corporate fiscal year.
         */
        DateTime.fromFiscal = function (date, govt) {
            var cal = wijmo.culture.Globalize.calendar;
            return isArray(cal.fiscalYearOffsets)
                ? DateTime.addMonths(date, +cal.fiscalYearOffsets[govt ? 0 : 1])
                : date;
        };
        /**
         * Gets a new Date object instance.
         *
         * @param year Integer value representing the year, defaults to current year.
         * @param month Integer value representing the month (0-11), defaults to current month.
         * @param day Integer value representing the day (1-31), defaults to current day.
         * @param hour Integer value representing the hour, defaults to zero.
         * @param min Integer value representing the minute, defaults to zero.
         * @param sec Integer value representing the second, defaults to zero.
         * @param ms Integer value representing the millisecond, defaults to zero.
         */
        DateTime.newDate = function (year, month, day, hour, min, sec, ms) {
            // get defaults
            if (year == null || month == null || day == null) {
                var today = new Date();
                if (year == null)
                    year = today.getFullYear();
                if (month == null)
                    month = today.getMonth();
                if (day == null)
                    day = today.getDate();
            }
            if (hour == null)
                hour = 0;
            if (min == null)
                min = 0;
            if (sec == null)
                sec = 0;
            if (ms == null)
                ms = 0;
            // create date
            var dt = new Date(year, month, day, hour, min, sec, ms);
            // fix year adjustment in JavaScript's Date constructor
            var dty = dt.getFullYear();
            if (year < 100 && dty >= 1900) {
                dt.setFullYear(dt.getFullYear() - 1900);
            }
            // return the new date
            return dt;
        };
        /**
         * Creates a copy of a given Date object.
         *
         * @param date Date object to copy.
         */
        DateTime.clone = function (date) {
            return DateTime.fromDateTime(date, date);
        };
        return DateTime;
    }());
    wijmo.DateTime = DateTime;
    /**
     * Performs HTTP requests.
     *
     * @param url String containing the URL to which the request is sent.
     * @param settings An optional object used to configure the request.
     *
     * The <b>settings</b> object may contain the following:
     *
     * <table>
     * <tr>
     *   <td><b>method</b></td>
     *   <td>The HTTP method to use for the request (e.g. "POST", "GET", "PUT").
     *       The default is "GET".</td>
     * </tr>
     * <tr>
     *   <td><b>data</b></td>
     *   <td>Data to be sent to the server. It is appended to the url for GET requests,
     *       and converted to a string for other requests.</td>
     * </tr>
     * <tr>
     *   <td><b>async</b></td>
     *   <td>By default, all requests are sent asynchronously (i.e. this is set to true by default).
     *       If you need synchronous requests, set this option to false.</td>
     * </tr>
     * <tr>
     *   <td><b>success</b></td>
     *   <td>A function to be called if the request succeeds.
     *       The function gets passed a single parameter of type <b>XMLHttpRequest</b>.</td>
     * </tr>
     * <tr>
     *   <td><b>error</b></td>
     *   <td>A function to be called if the request fails.
     *       The function gets passed a single parameter of type <b>XMLHttpRequest</b>.</td>
     * </tr>
     * <tr>
     *   <td><b>complete</b></td>
     *   <td>A function to be called when the request finishes (after success and error callbacks are executed).
     *       The function gets passed a single parameter of type <b>XMLHttpRequest</b>.</td>
     * </tr>
     * <tr>
     *   <td><b>beforeSend</b></td>
     *   <td>A function to be called immediately before the request us sent.
     *       The function gets passed a single parameter of type <b>XMLHttpRequest</b>.</td>
     * </tr>
     * <tr>
     *   <td><b>requestHeaders</b></td>
     *   <td>A JavaScript object containing key/value pairs to be added to the request
     *       headers.</td>
     * </tr>
     * <tr>
     *   <td><b>user</b></td>
     *   <td>A username to be used with <b>XMLHttpRequest</b> in response to an HTTP access
     *       authentication request.</td>
     * </tr>
     * <tr>
     *   <td><b>password</b></td>
     *   <td>A password to be used with <b>XMLHttpRequest</b> in response to an HTTP access
     *       authentication request.</td>
     * </tr>
     * </table>
     *
     * Use the <b>success</b> to obtain the result of the request which is provided in
     * the callback's <b>XMLHttpRequest</b> parameter. For example, the code below uses
     * the @see:httpRequest method to retrieve a list of customers from an OData service:
     *
     * <pre>wijmo.httpRequest('http://services.odata.org/Northwind/Northwind.svc/Customers?$format=json', {
     *   success: function (xhr) {
     *     var response = JSON.parse(xhr.response),
     *         customers = response.value;
     *     // do something with the customers...
     *   }
     * });</pre>
     *
     * @return The <b>XMLHttpRequest</b> object used to perform the request.
     */
    function httpRequest(url, settings) {
        if (!settings)
            settings = {};
        // select method and basic options
        var method = settings.method ? asString(settings.method).toUpperCase() : 'GET', asynk = settings.async != null ? asBoolean(settings.async) : true, data = settings.data;
        // convert data to url parameters for GET requests
        if (data != null && method == 'GET') {
            var s = [];
            for (var k in data) {
                var val = data[k];
                if (isDate(val)) {
                    val = val.toJSON();
                }
                s.push(k + '=' + val);
            }
            if (s.length) {
                var sep = url.indexOf('?') < 0 ? '?' : '&';
                url += sep + s.join('&');
            }
            data = null;
        }
        // create the request
        var xhr = new XMLHttpRequest();
        xhr['URL_DEBUG'] = url; // add some debug info
        // if the data is not a string, stringify it
        var isJson = false;
        if (data != null && !isString(data)) {
            isJson = isObject(data);
            data = JSON.stringify(data);
        }
        // callbacks
        xhr.onload = function () {
            if (xhr.readyState == 4) {
                if (xhr.status < 300) {
                    if (settings.success) {
                        asFunction(settings.success)(xhr);
                    }
                }
                else if (settings.error) {
                    asFunction(settings.error)(xhr);
                }
                if (settings.complete) {
                    asFunction(settings.complete)(xhr);
                }
            }
        };
        xhr.onerror = function () {
            if (isFunction(settings.error)) {
                settings.error(xhr);
            }
            else {
                throw 'HttpRequest Error: ' + xhr.status + ' ' + xhr.statusText;
            }
        };
        // send the request
        xhr.open(method, url, asynk, settings.user, settings.password);
        if (settings.user && settings.password) {
            xhr.setRequestHeader('Authorization', 'Basic ' + btoa(settings.user + ':' + settings.password));
        }
        if (isJson) {
            xhr.setRequestHeader('Content-Type', 'application/json');
        }
        if (settings.requestHeaders) {
            for (var key in settings.requestHeaders) {
                xhr.setRequestHeader(key, settings.requestHeaders[key]);
            }
        }
        if (isNumber(settings.timeout)) {
            xhr.timeout = settings.timeout;
        }
        if (isFunction(settings.beforeSend)) {
            settings.beforeSend(xhr);
        }
        xhr.send(data);
        // return the request
        return xhr;
    }
    wijmo.httpRequest = httpRequest;
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    'use strict';
    /**
     * Gets or sets an object that contains all localizable strings in the Wijmo library.
     *
     * The culture selector is a two-letter string that represents an
     * <a href='http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes'>ISO 639 culture</a>.
     */
    wijmo.culture = window['wijmo'].culture || {
        Globalize: {
            numberFormat: {
                '.': '.',
                ',': ',',
                percent: { pattern: ['-n %', 'n %'] },
                currency: { decimals: 2, symbol: '$', pattern: ['($n)', '$n'] }
            },
            calendar: {
                '/': '/',
                ':': ':',
                firstDay: 0,
                days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                daysAbbr: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                monthsAbbr: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                am: ['AM', 'A'],
                pm: ['PM', 'P'],
                eras: ['A.D.', 'B.C.'],
                patterns: {
                    d: 'M/d/yyyy', D: 'dddd, MMMM dd, yyyy',
                    f: 'dddd, MMMM dd, yyyy h:mm tt', F: 'dddd, MMMM dd, yyyy h:mm:ss tt',
                    t: 'h:mm tt', T: 'h:mm:ss tt',
                    M: 'MMMM d', m: 'MMMM d',
                    Y: 'MMMM, yyyy', y: 'MMMM, yyyy',
                    g: 'M/d/yyyy h:mm tt', G: 'M/d/yyyy h:mm:ss tt',
                    s: 'yyyy"-"MM"-"dd"T"HH":"mm":"ss',
                    o: 'yyyy"-"MM"-"dd"T"HH":"mm":"ss"."fffffffK',
                    O: 'yyyy"-"MM"-"dd"T"HH":"mm":"ss"."fffffffK',
                    U: 'dddd, MMMM dd, yyyy h:mm:ss tt'
                },
                fiscalYearOffsets: [-3, -3]
            }
        }
    };
    /**
     * Class that implements formatting and parsing of numbers and Dates.
     *
     * By default, @see:Globalize uses the American English culture.
     * To switch cultures, include the appropriate <b>wijmo.culture.*.js</b>
     * file after the wijmo files.
     */
    var Globalize = /** @class */ (function () {
        function Globalize() {
        }
        /**
         * Formats a number or a date.
         *
         * The format strings used with the @see:format function are similar to
         * the ones used by <b>Globalize.js</b> and by the .NET Globalization
         * library. The tables below contains links that describe the formats
         * available:
         *
         * <ul>
         * <li><a href="http://msdn.microsoft.com/en-us/library/dwhawy9k(v=vs.110).aspx">
         *      Standard Numeric Format Strings</a></li>
         * <li><a href="http://msdn.microsoft.com/en-us/library/az4se3k1(v=vs.110).aspx">
         *      Standard Date and Time Format Strings</a></li>
         * <li><a href="http://msdn.microsoft.com/en-us/library/8kb3ddd4(v=vs.110).aspx">
         *      Custom Date and Time Format Strings</a></li>
         * </ul>
         *
         * @param value Number or Date to format (all other types are converted to strings).
         * @param format Format string to use when formatting numbers or dates.
         * @param trim Whether to remove trailing zeros from numeric results.
         * @param truncate Whether to truncate the numeric values rather than round them.
         * @return A string representation of the given value.
         */
        Globalize.format = function (value, format, trim, truncate) {
            // format numbers and dates, convert others to string
            if (wijmo.isString(value)) {
                return value;
            }
            else if (wijmo.isNumber(value)) {
                format = format || (value == Math.round(value) ? 'n0' : 'n2');
                return Globalize.formatNumber(value, format, trim, truncate);
            }
            else if (wijmo.isDate(value)) {
                format = format || 'd';
                return Globalize.formatDate(value, format);
            }
            else {
                return value != null ? value.toString() : '';
            }
        };
        /**
         * Formats a number using the current culture.
         *
         * The @see:formatNumber method accepts most .NET-style
         * <a href="http://msdn.microsoft.com/en-us/library/dwhawy9k(v=vs.110).aspx">
         * Standard Numeric Format Strings</a>, except for the 'e' and 'x' formats
         * (scientific notation and hexadecimal) which are not supported.
         *
         * Numeric format strings take the form <i>Axxsscc</i>, where:
         * <ul>
         * <li>
         *  <i>A</i> is a single case-insensitive alphabetic character called the
         *  format specifier.</li>
         * <li>
         *  <i>xx</i> is an optional integer called the precision specifier.
         *  The precision specifier affects the number of digits in the result.</li>
         * <li>
         *  <i>ss</i> is an optional string used to scale the number. If provided,
         *  it must consist of commas. The number is divided by 1000 for each comma
         *  specified.</li>
         * <li>
         *  <i>cc</i> is an optional string used to override the currency symbol
         *  when formatting currency values. This is useful when formatting
         *  currency values for cultures different than the current default
         *  (for example, when formatting Euro or Yen values in applications
         *  that use the English culture).</li>
         * </ul>
         *
         * The following table describes the standard numeric format specifiers and
         * displays sample output produced by each format specifier for the default
         * culture.
         *
         * <b>n</b> Number: <code>formatNumber(1234.5, 'n2') => '1,234.50'</code><br/>
         * <b>f</b> Fixed-point: <code>formatNumber(1234.5, 'f2') => '1234.50'</code><br/>
         * <b>g</b> General (no trailing zeros): <code>formatNumber(1234.5, 'g2') => '1234.5'</code><br/>
         * <b>d</b> Decimal (integers): <code>formatNumber(-1234, 'd6') => '-001234'</code><br/>
         * <b>x</b> Hexadecimal (integers): <code>formatNumber(1234, 'x6') => '0004d2'</code><br/>
         * <b>c</b> Currency: <code>formatNumber(1234, 'c') => '$ 1,234.00'</code><br/>
         * <b>p</b> Percent: <code>formatNumber(0.1234, 'p2') => '12.34 %'</code>
         *
         * The scaling specifier is especially useful when charting large values. For
         * example, the markup below creates a chart that plots population versus GDP.
         * The raw data expresses the population is units and the GDP in millions.
         * The scaling specified in the axes formats causes the chart to show population
         * in millions and GDP in trillions:
         *
         * <pre>&lt;wj-flex-chart
         *   items-source="countriesGDP" binding-x="pop" chart-type="Scatter"&gt;
         *   &lt;wj-flex-chart-series
         *     name="GDP" binding="gdp"&gt;&lt;/wj-flex-chart-series&gt;
         *   &lt;wj-flex-chart-axis
         *     wj-property="axisX" title="Population (millions)"
         *     format="n0,,"&gt;
         *   &lt;/wj-flex-chart-axis&gt;
         *   &lt;wj-flex-chart-axis
         *     wj-property="axisY" title="GDP (US$ trillions)"
         *     format="c0,,"&gt;
         *   &lt;/wj-flex-chart-axis&gt;
         * &lt;/wj-flex-chart&gt;</pre>
         *
         * @param value Number to format.
         * @param format .NET-style standard numeric format string (e.g. 'n2', 'c4', 'p0', 'g2', 'd2').
         * @param trim Whether to remove trailing zeros from the result.
         * @param truncate Whether to truncate the value rather than round it.
         * @return A string representation of the given number.
         */
        Globalize.formatNumber = function (value, format, trim, truncate) {
            value = wijmo.asNumber(value);
            format = wijmo.asString(format);
            var nf = wijmo.culture.Globalize.numberFormat, m = format ? format.match(/([a-z])(\d*)(,*)(.*)/i) : null, f1 = m ? m[1].toLowerCase() : 'n', prec = (m && m[2]) ? parseInt(m[2]) : (f1 == 'c') ? nf.currency.decimals : value == Math.round(value) ? 0 : 2, scale = (m && m[3]) ? 3 * m[3].length : 0, curr = (m && m[4]) ? m[4] : nf.currency.symbol, dp = nf['.'], ts = nf[','], result;
            // scale (,:thousands ,,:millions ,,,:billions)
            if (scale) {
                value /= Math.pow(10, scale);
            }
            // d, x: integers/hexadecimal
            if (f1 == 'd' || f1 == 'x') {
                result = Math.round(Math.abs(value)).toString(f1 == 'd' ? 10 : 16);
                while (result.length < prec) {
                    result = '0' + result;
                }
                if (value < 0) {
                    result = '-' + result;
                }
                if (format && format[0] == 'X') {
                    result = result.toUpperCase();
                }
                return result;
            }
            // p: percentage
            if (f1 == 'p') {
                value = Globalize._mul100(value); // TFS 210383
                value = wijmo.toFixed(value, prec, truncate); // TFS 227998
                //value = toFixed(value * 100, prec, truncate); // TFS 147585
            }
            // truncate value
            if (truncate && f1 != 'p') {
                value = wijmo.toFixed(value, prec, true);
            }
            // get result
            result = Globalize._toFixedStr((f1 == 'c' || f1 == 'p')
                ? Math.abs(value)
                : value, prec);
            // g: remove trailing zeros
            if ((trim || f1 == 'g') && result.indexOf('.') > -1) {
                result = result.replace(/(\.[0-9]*?)0+$/g, '$1');
                result = result.replace(/\.$/, '');
            }
            // replace decimal point
            if (dp != '.') {
                result = result.replace('.', dp);
            }
            // n, c, p: thousand separators
            if (ts && (f1 == 'n' || f1 == 'c' || f1 == 'p')) {
                var idx = result.indexOf(dp), rx = /\B(?=(\d\d\d)+(?!\d))/g;
                result = idx > -1
                    ? result.substr(0, idx).replace(rx, ts) + result.substr(idx)
                    : result.replace(rx, ts);
            }
            // c: currency pattern
            if (f1 == 'c') {
                var pat = nf.currency.pattern[value < 0 ? 0 : 1];
                if (curr == '\u200B') {
                    curr = '';
                }
                result = pat.replace('n', result).replace('$', curr);
            }
            // p: percentage pattern
            if (f1 == 'p') {
                var pat = nf.percent.pattern[value < 0 ? 0 : 1];
                result = pat.replace('n', result);
            }
            // done
            return result;
        };
        /**
         * Formats a date using the current culture.
         *
         * The @see:format parameter contains a .NET-style
         * <a href="http://msdn.microsoft.com/en-us/library/8kb3ddd4(v=vs.110).aspx">Date format string</a>
         * with the following additions:
         * <ul>
         *  <li><i>Q, q</i> Calendar quarter.</li>
         *  <li><i>U</i> Fiscal quarter (government).</li>
         *  <li><i>u</i> Fiscal quarter (private sector).</li>
         *  <li><i>EEEE, EEE, EE, E</i> Fiscal year (government).</li>
         *  <li><i>eeee, eee, ee, e</i> Fiscal year (private sector).</li>
         * </ul>
         *
         * For example:
         *
         * <pre>
         * var d = new Date(2015, 9, 1); // Oct 1, 2015
         * console.log(wijmo.Globalize.format(d, '"FY"EEEE"Q"U') + ' (US culture)');
         * &gt; FY2016Q1 (US culture)
         * </pre>
         *
         * @param value Number or Date to format.
         * @param format .NET-style Date format string.
         * @return A string representation of the given date.
         */
        Globalize.formatDate = function (value, format) {
            value = wijmo.asDate(value);
            // culture-invariant formats
            switch (format) {
                case 'r':
                case 'R':
                    return value.toUTCString();
                case 'u':
                    return value.toISOString().replace(/\.\d{3}/, '');
            }
            // expand pre-defined formats
            format = Globalize._expandFormat(format);
            // parse the format string and build return value
            var parts = Globalize._parseDateFormat(format), str = '';
            for (var i = 0; i < parts.length; i++) {
                str += Globalize._formatDatePart(value, format, parts[i]);
            }
            // all done
            return str;
        };
        /**
         * Parses a string into an integer.
         *
         * @param value String to convert to an integer.
         * @param format Format to use when parsing the number.
         * @return The integer represented by the given string,
         * or <b>NaN</b> if the string cannot be parsed into an integer.
         */
        Globalize.parseInt = function (value, format) {
            return Math.round(Globalize.parseFloat(value, format));
        };
        /**
         * Parses a string into a floating point number.
         *
         * @param value String to convert to a number.
         * @param format Format to use when parsing the number.
         * @return The floating point number represented by the given string,
         * or <b>NaN</b> if the string cannot be parsed into a floating point number.
         */
        Globalize.parseFloat = function (value, format) {
            var neg = value.indexOf('-') > -1 || (value.indexOf('(') > -1 && value.indexOf(')') > -1) ? -1 : +1, pct = value.indexOf('%') > -1 ? .01 : 1, m = format ? format.match(/,+/) : null, scale = m ? m[0].length * 3 : 0;
            // hex
            if (format && (format[0] == 'x' || format[0] == 'X')) {
                value = value.replace(/[^0-9a-f]+.*$/gi, ''); // truncate at first invalid char
                return parseInt(value, 16) * neg * pct * Math.pow(10, scale);
            }
            // decimal
            var dp = wijmo.culture.Globalize.numberFormat['.'], rx = new RegExp('[^\\d\\' + dp + ']', 'g'), val = value.replace(rx, '').replace(dp, '.'); // remove non-digits, replace decimal point
            return parseFloat(val) * neg * pct * Math.pow(10, scale);
        };
        /**
         * Parses a string into a Date.
         *
         * Two-digit years are converted to full years based on the value of the
         * calendar's <b>twoDigitYearMax</b> property. By default, this is set to
         * 2029, meaning two-digit values of 30 to 99 are parsed as 19**, and values
         * from zero to 29 are parsed as 20**.
         *
         * You can change this threshold by assigning a new value to the calendar.
         * For example:
         *
         * <pre>// get calendar
         * var cal = wijmo.culture.Globalize.calendar;
         *
         * // default threshold is 2029, so "30" is parsed as 1930
         * cal.twoDigitYearMax = 2029;
         * var d1 = wijmo.Globalize.parseDate('30/12', 'yy/MM'); // dec 1930
         *
         * // changing threshold to 2100, so all values are parsed as 20**
         * cal.twoDigitYearMax = 2100;
         * var d2 = wijmo.Globalize.parseDate('30/12', 'yy/MM'); // dec 2030</pre>
         *
         * @param value String to convert to a Date.
         * @param format Format string used to parse the date.
         * @return The date represented by the given string, or null if the string
         * cannot be parsed into a Date.
         */
        Globalize.parseDate = function (value, format) {
            // make sure we have a value
            value = wijmo.asString(value);
            if (!value) {
                return null;
            }
            // culture-invariant formats
            if (format == 'u') {
                return new Date(value);
            }
            // parse using RFC 3339 pattern ([yyyy-MM-dd] [hh:mm[:ss]])
            var d;
            if (format == 'R' || format == 'r') {
                var rx = /(([0-9]+)\-([0-9]+)\-([0-9]+))?\s?(([0-9]+):([0-9]+)(:([0-9]+))?)?/, match = value.match(rx);
                if (match[1] || match[5]) {
                    d = match[1] // parse date
                        ? new Date(parseInt(match[2]), parseInt(match[3]) - 1, parseInt(match[4]))
                        : new Date();
                    if (match[5]) {
                        d.setHours(parseInt(match[6]));
                        d.setMinutes(parseInt(match[7]));
                        d.setSeconds(match[8] ? parseInt(match[9]) : 0);
                    }
                }
                else {
                    d = new Date(value);
                }
                return !isNaN(d.getTime()) ? d : null;
            }
            // expand the format
            format = Globalize._expandFormat(format ? format : 'd');
            // get format parts and data parts
            //
            // cjk: chars, http://www.rikai.com/library/kanjitables/kanji_codes.unicode.shtml
            // rxf: format (no dots in strings: 'mm.dd.yyyy' => ['mm', 'dd', 'yyyy']).
            // rxv: value (dots OK in strings: 'A.D' => 'A.D', but not by themselves)
            var cal = wijmo.culture.Globalize.calendar, cjk = Globalize._CJK, rxv = new RegExp('(\\' + cal['/'] + ')|(\\' + cal[':'] + ')|' + // date/time separators
                '(\\d+)|' + // digits
                '([' + cjk + '\\.]{2,})|' + // strings with dots
                '([' + cjk + ']+)', // strings with no dots
            'gi'), vparts = value.match(rxv), fparts = Globalize._parseDateFormat(format), offset = 0, year = -1, month = 0, day = 1, hour = 0, min = 0, tzm = 0, sec = 0, ms = 0, era = -1, hasDayName, hasDay, hasQuarter, hasMonth, hasFullYear, fiscalFmt;
            // basic validation (TFS 81465, 128359)
            if (!vparts || !vparts.length || !fparts || !fparts.length) {
                return null;
            }
            // parse each element
            for (var i = 0; i < fparts.length && vparts; i++) {
                var vpi = i - offset, pval = (vpi > -1 && vpi < vparts.length) ? vparts[vpi] : '', plen = fparts[i].length;
                switch (fparts[i]) {
                    // ** year
                    case 'EEEE':
                    case 'EEE':
                    case 'EE':
                    case 'E': // fiscal (govt)
                    case 'eeee':
                    case 'eee':
                    case 'ee':
                    case 'e':// fiscal (corp)
                        fiscalFmt = fparts[i];
                    // ** fall through **
                    case 'yyyy':
                    case 'yyy':
                    case 'yy':
                    case 'y':// calendar
                        if (plen > 1 && pval.length > plen) {
                            vparts[vpi] = pval.substr(plen);
                            pval = pval.substr(0, plen);
                            offset++;
                        }
                        year = parseInt(pval);
                        hasFullYear = pval.length == 4; // TFS 279266
                        break;
                    // ** month
                    case 'MMMM':
                    case 'MMM':
                        hasMonth = true;
                        var monthName = pval.toLowerCase();
                        month = -1;
                        for (var j = 0; j < 12; j++) {
                            if (cal.months[j].toLowerCase().indexOf(monthName) == 0) {
                                month = j;
                                break;
                            }
                        }
                        if (month > -1) {
                            break;
                        }
                    // FALL THROUGH: 
                    // and try parsing month as a number
                    // so users can type "1/2" instead of "1/February"
                    case 'MM':
                    case 'M':
                        hasMonth = true;
                        if (plen > 1 && pval.length > plen) {
                            vparts[vpi] = pval.substr(plen);
                            pval = pval.substr(0, plen);
                            offset++;
                        }
                        month = parseInt(pval) - 1;
                        break;
                    // ** day
                    case 'dddd':
                    case 'ddd':
                        hasDayName = true;
                        break; // skip day names
                    case 'dd':
                    case 'd':
                        if (plen > 1 && pval.length > plen) {
                            vparts[vpi] = pval.substr(plen);
                            pval = pval.substr(0, plen);
                            offset++;
                        }
                        day = parseInt(pval);
                        hasDay = true;
                        break;
                    // ** hour
                    case 'hh':
                    case 'h':
                        if (plen > 1 && pval.length > plen) {
                            vparts[vpi] = pval.substr(plen);
                            pval = pval.substr(0, plen);
                            offset++;
                        }
                        hour = parseInt(pval);
                        hour = hour == 12 ? 0 : hour; // 0-12, 12 == midnight
                        break;
                    case 'HH':
                        if (plen > 1 && pval.length > plen) {
                            vparts[vpi] = pval.substr(plen);
                            pval = pval.substr(0, plen);
                            offset++;
                        }
                        hour = parseInt(pval); // 0-24
                        break;
                    case 'H':
                        hour = parseInt(pval); // 0-24
                        break;
                    // ** minute
                    case 'mm':
                    case 'm':
                        if (plen > 1 && pval.length > plen) {
                            vparts[vpi] = pval.substr(plen);
                            pval = pval.substr(0, plen);
                            offset++;
                        }
                        min = parseInt(pval);
                        break;
                    // ** second
                    case 'ss':
                    case 's':
                        if (plen > 1 && pval.length > plen) {
                            vparts[vpi] = pval.substr(plen);
                            pval = pval.substr(0, plen);
                            offset++;
                        }
                        sec = parseInt(pval);
                        break;
                    // ** millisecond
                    case 'fffffff':
                    case 'FFFFFFF':
                    case 'ffffff':
                    case 'FFFFFF':
                    case 'fffff':
                    case 'FFFFF':
                    case 'ffff':
                    case 'FFFF':
                    case 'fff':
                    case 'FFF':
                    case 'ff':
                    case 'FF':
                    case 'f':
                    case 'F':
                        ms = parseInt(pval) / Math.pow(10, plen - 3);
                        break;
                    // ** am/pm
                    case 'tt':
                    case 't':
                        pval = pval.toUpperCase();
                        if (hour < 12 && cal.pm.indexOf(pval) > -1) {
                            hour += 12;
                        }
                        break;
                    // ** quarter
                    case 'q':
                    case 'Q':
                    case 'u':
                    case 'U':
                        hasQuarter = true;
                        break;
                    // ** era
                    case 'ggg':
                    case 'gg':
                    case 'g':
                        era = cal.eras.length > 1 ? Globalize._getEra(pval, cal) : -1;
                        break;
                    // ** localized separators (TFS 131320)
                    case cal['/']:
                    case cal[':']:
                        if (pval && pval != fparts[i]) {
                            return null; // present and wrong separator
                        }
                        break;
                    // ** time zone (skip )
                    case 'K':
                        break;
                    // ** all else: if not a match, keep using the same pval
                    default:
                        if (Globalize._unquote(fparts[i]).trim() != pval.trim()) {
                            offset++;
                        }
                        break;
                }
            }
            // allow dates with no times even if the format requires times
            if (hasMonth && hasDay) {
                if (isNaN(hour))
                    hour = 0;
                if (isNaN(min))
                    min = 0;
                if (isNaN(sec))
                    sec = 0;
            }
            // basic validation
            if (month < 0 || month > 11 || isNaN(month) ||
                day < 0 || day > 31 || isNaN(day) ||
                hour < 0 || hour > 24 || isNaN(hour) ||
                min < 0 || min > 60 || isNaN(min) ||
                sec < 0 || sec > 60 || isNaN(sec)) {
                return null;
            }
            // convert fiscal year to calendar year
            if (fiscalFmt) {
                if (!hasMonth) {
                    return null;
                }
                var cal_1 = wijmo.culture.Globalize.calendar;
                if (wijmo.isArray(cal_1.fiscalYearOffsets)) {
                    var govt = fiscalFmt[0] == 'E', fiscalMonth = month - cal_1.fiscalYearOffsets[govt ? 0 : 1];
                    year += (fiscalMonth > 11) ? -1 : (fiscalMonth < 0) ? +1 : 0;
                }
            }
            // if the day name was specified but the day wasn't, the result is meaningless
            if (hasDayName && !hasDay) {
                return null;
            }
            // if the quarter was specified but the month wasn't, the result is meaningless
            if (hasQuarter && !hasMonth) {
                return null;
            }
            // if the year was not specified, use the current year (as Globalize.js)
            if (year < 0) {
                year = new Date().getFullYear();
            }
            // apply era offset if any, or adjust for two-digit years (see Calendar.TwoDigitYearMax)
            if (era > -1) {
                year = year + cal.eras[era].start.getFullYear() - 1;
            }
            else if (year < 100 && !hasFullYear) {
                var max = wijmo.isNumber(cal.twoDigitYearMax) ? cal.twoDigitYearMax : 2029;
                year += (year + 2000 < max) ? 2000 : 1900;
            }
            // return result
            d = wijmo.DateTime.newDate(year, month, day, hour, min + tzm, sec, ms);
            return isNaN(d.getTime()) ? null : d;
        };
        /**
         * Gets the first day of the week according to the current culture.
         *
         * The value returned is between zero (Sunday) and six (Saturday).
         */
        Globalize.getFirstDayOfWeek = function () {
            var fdw = wijmo.culture.Globalize.calendar.firstDay;
            return fdw ? fdw : 0;
        };
        /**
         * Gets the symbol used as a decimal separator in numbers.
         */
        Globalize.getNumberDecimalSeparator = function () {
            var ndc = wijmo.culture.Globalize.numberFormat['.'];
            return ndc ? ndc : '.';
        };
        // ** implementation
        // similar to JavaScript's toFixed, but smarter about appending
        // zeros when that's all that's needed (TFS 286926)
        Globalize._toFixedStr = function (num, digits) {
            var str = num.toString(), decPos = str.indexOf('.'), xZeros = digits - (str.length - decPos) + 1;
            return str.indexOf('e') < 0 && decPos > -1 && xZeros >= 0
                ? str + Array(xZeros + 1).join('0')
                : num.toFixed(digits);
        };
        // unquotes a string
        Globalize._unquote = function (s) {
            if (s.length > 1 && s[0] == s[s.length - 1]) {
                if (s[0] == '\'' || s[0] == '\"') {
                    return s.substr(1, s.length - 2);
                }
            }
            return s;
        };
        Globalize._parseDateFormat = function (format) {
            // use cache whenever possible
            if (format in Globalize._dateFormatParts) {
                return Globalize._dateFormatParts[format];
            }
            // parse the format
            var parts = [], str = '', start, end;
            if (format) {
                for (start = 0; start > -1 && start < format.length; start++) {
                    var c = format[start];
                    if (c == '\'' || c == '"') {
                        end = format.indexOf(c, start + 1); // keep quotes to distinguish from regular date parts
                        if (end > -1) {
                            parts.push(format.substring(start, end + 1));
                            start = end;
                            continue;
                        }
                    }
                    end = start + 1;
                    for (; end < format.length; end++) {
                        if (format[end] != c)
                            break;
                    }
                    parts.push(format.substring(start, end));
                    start = end - 1;
                }
            }
            // cache and return
            Globalize._dateFormatParts[format] = parts;
            return parts;
        };
        // format a date part into a string
        Globalize._formatDatePart = function (d, format, part) {
            var cal = wijmo.culture.Globalize.calendar, era = 0, year = 0, ff = 0, fd, plen = part.length;
            switch (part) {
                // ** year
                case 'yyyy':
                case 'yyy':
                case 'yy':
                case 'y': // calendar year
                case 'EEEE':
                case 'EEE':
                case 'EE':
                case 'E': // fiscal year (govt)
                case 'eeee':
                case 'eee':
                case 'ee':
                case 'e':// fiscal year (corporate)
                    // get the year (calendar or fiscal)
                    fd = part[0] == 'E' ? wijmo.DateTime.toFiscal(d, true) :
                        part[0] == 'e' ? wijmo.DateTime.toFiscal(d, false) :
                            d;
                    year = fd.getFullYear();
                    // if the calendar has multiple eras and the format specifies an era,
                    // then adjust the year to count from the start of the era.
                    // if the format has no era, then use the regular (Western) year.
                    if (cal.eras.length > 1 && format.indexOf('g') > -1) {
                        era = Globalize._getEra(d, cal);
                        if (era > -1) {
                            year = year - cal.eras[era].start.getFullYear() + 1;
                        }
                    }
                    // adjust number of digits (TFS 276489)
                    var y = part.length < 3 ? year % 100
                        : part.length == 3 ? year % 1000
                            : year;
                    return Globalize._zeroPad(y, part.length);
                //return Globalize._zeroPad(year, 4).substr(4 - part.length);
                // ** month
                case 'MMMMM':
                    return cal.monthsAbbr[d.getMonth()][0]; // Month initial (not in .NET, but may be useful)
                case 'MMMM':
                    return cal.months[d.getMonth()];
                case 'MMM':
                    return cal.monthsAbbr[d.getMonth()];
                case 'MM':
                case 'M':
                    return Globalize._zeroPad(d.getMonth() + 1, plen);
                // ** day
                case 'dddd':
                    return cal.days[d.getDay()];
                case 'ddd':
                    return cal.daysAbbr[d.getDay()];
                case 'dd':
                    return Globalize._zeroPad(d.getDate(), 2);
                case 'd':
                    return d.getDate().toString();
                // ** hour
                case 'hh':
                case 'h':
                    return Globalize._zeroPad(Globalize._h12(d), plen);
                case 'HH':
                case 'H':
                    return Globalize._zeroPad(d.getHours(), plen);
                // ** minute
                case 'mm':
                case 'm':
                    return Globalize._zeroPad(d.getMinutes(), plen);
                // ** second
                case 'ss':
                case 's':
                    return Globalize._zeroPad(d.getSeconds(), plen);
                // ** millisecond
                case 'fffffff':
                case 'FFFFFFF':
                case 'ffffff':
                case 'FFFFFF':
                case 'fffff':
                case 'FFFFF':
                case 'ffff':
                case 'FFFF':
                case 'fff':
                case 'FFF':
                case 'ff':
                case 'FF':
                case 'f':
                case 'F':
                    ff = d.getMilliseconds() * Math.pow(10, plen - 3);
                    return part[0] == 'f' ? Globalize._zeroPad(ff, plen) : ff.toFixed(0);
                // ** am/pm
                case 'tt':
                    return d.getHours() < 12 ? cal.am[0] : cal.pm[0];
                case 't':
                    return d.getHours() < 12 ? cal.am[1] : cal.pm[1];
                // ** quarter
                case 'q':
                case 'Q':// quarter (calendar)
                    return (Math.floor(d.getMonth() / 3) + 1).toString();
                case 'u':
                case 'U':// quarter (fiscal: U: govt; u: corp)
                    fd = wijmo.DateTime.toFiscal(d, part == 'U');
                    return (Math.floor(fd.getMonth() / 3) + 1).toString();
                // ** era
                case 'ggg':
                case 'gg':
                case 'g':
                    if (cal.eras.length > 1) {
                        era = Globalize._getEra(d, cal);
                        if (era > -1) {
                            return part == 'ggg' ? cal.eras[era].name : part == 'gg' ? cal.eras[era].name[0] : cal.eras[era].symbol;
                        }
                    }
                    return cal.eras[0];
                // ** localized separators
                case ':':
                case '/':
                    return cal[part];
                // ** time zone
                case 'K':
                    var tz = d.toString().match(/(\+|\-)(\d{2})(\d{2})/);
                    return tz ? tz[1] + tz[2] + tz[3] : '';
                case 'zzz':
                case 'zz':
                case 'z':
                    var tzo = -d.getTimezoneOffset(), ret = void 0;
                    switch (part) {
                        case 'zzz':// Hours and minutes offset from UTC ('-07:00')
                            ret = Globalize.format(tzo / 60, 'd2', false, true) + cal[':'] +
                                Globalize.format(tzo % 60, 'd2', false, true);
                            break;
                        case 'zz':// Hours offset from UTC, with a leading zero for a single- digit value ('07')
                            ret = Globalize.format(tzo / 60, 'd2', false, true);
                            break;
                        case 'z':
                            ret = Globalize.format(tzo / 60, 'd', false, true);
                            break;
                    }
                    return tzo >= 0 ? '+' + ret : ret; // add plus sign if needed
            }
            // unquote part
            if (plen > 1 && part[0] == part[plen - 1]) {
                if (part[0] == '\"' || part[0] == '\'') {
                    return part.substr(1, plen - 2);
                }
            }
            // return part
            return part;
        };
        // get a date's era (used only in Japanese locales)
        Globalize._getEra = function (d, cal) {
            if (wijmo.isDate(d)) {
                for (var i = 0; i < cal.eras.length; i++) {
                    if (d >= cal.eras[i].start) {
                        return i;
                    }
                }
            }
            else if (wijmo.isString(d)) {
                for (var i = 0; i < cal.eras.length; i++) {
                    if (cal.eras[i].name) {
                        if (cal.eras[i].name.indexOf(d) == 0 || cal.eras[i].symbol.indexOf(d) == 0) {
                            return i;
                        }
                    }
                }
            }
            return -1; // not found
        };
        // expand date pattern into full date format
        Globalize._expandFormat = function (format) {
            var fmt = wijmo.culture.Globalize.calendar.patterns[format];
            return fmt ? fmt : format;
        };
        // format a number with leading zeros
        Globalize._zeroPad = function (num, places) {
            var n = num.toFixed(0), zero = places - n.length + 1;
            return zero > 0 ? Array(zero).join('0') + n : n;
        };
        // format an hour to 12 or 24 hour base depending on the calendar
        Globalize._h12 = function (d) {
            var cal = wijmo.culture.Globalize.calendar, h = d.getHours();
            if (cal.am && cal.am[0]) {
                h = h % 12;
                if (h == 0)
                    h = 12;
            }
            return h;
        };
        // multiply a number by 100 without round-off errors (sigh: TFS 210383)
        Globalize._mul100 = function (n) {
            var str = n.toString(), pos = str.indexOf('.');
            // we don't do scientific notation
            if (str.indexOf('e') > -1) {
                return n * 100;
            }
            // multiply string by 100
            if (pos < 0) {
                str += '00';
            }
            else {
                pos += 2;
                str = str.replace('.', '') + '00';
                str = str.substr(0, pos) + '.' + str.substr(pos);
            }
            // parse string
            return parseFloat(str);
        };
        // Chinese/Japanese/Korean characters
        // http://www.rikai.com/library/kanjitables/kanji_codes.unicode.shtml
        // http://www.programminginkorean.com/programming/hangul-in-unicode/
        // NOTE: using 'replace' to keep minifier from switching the escaped Unicode chars into real Unicode.
        // NOTE: will have to expand for other cultures? (Arabic/Hebrew/Hindi etc?)
        Globalize._CJK = 'a-z' +
            'u00c0-u017fu3000-u30ffu4e00-u9faf'.replace(/u/g, '\\u') + // cj
            'u1100-u11ffu3130-u318fua960-ua97fuac00-ud7afud7b0-ud7ff'.replace(/u/g, '\\u'); // k
        // parse a date format string into its parts
        Globalize._dateFormatParts = {};
        return Globalize;
    }());
    wijmo.Globalize = Globalize;
    // Destined for external modules support. Called by culture files to sync global and local 'culture' vars.
    function _updateCulture() {
        wijmo.culture = window['wijmo'].culture;
    }
    wijmo._updateCulture = _updateCulture;
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    'use strict';
    /**
     * Provides binding to complex properties (e.g. 'customer.address.city')
     */
    var Binding = /** @class */ (function () {
        /**
         * Initializes a new instance of the @see:Binding class.
         *
         * @param path Name of the property to bind to.
         */
        function Binding(path) {
            this.path = path;
        }
        Object.defineProperty(Binding.prototype, "path", {
            /**
             * Gets or sets the path for the binding.
             *
             * In the simplest case, the path is the name of the property of the source
             * object to use for the binding (e.g. 'street').
             *
             * Sub-properties of a property can be specified by a syntax similar to that
             * used in JavaScript (e.g. 'address.street').
             */
            get: function () {
                return this._path;
            },
            set: function (value) {
                this._path = value;
                this._parts = value ? value.split('.') : []; // e.g. 'customer.balance'
                for (var i = 0; i < this._parts.length; i++) {
                    var part = this._parts[i], ib = part.indexOf('['); // e.g. 'customer.balance[0]'
                    if (ib > -1) {
                        this._parts[i] = part.substr(0, ib);
                        this._parts.splice(++i, 0, parseInt(part.substr(ib + 1)));
                    }
                }
                this._key = this._parts.length == 1 ? this._parts[0] : null;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Gets the binding value for a given object.
         *
         * If the object does not contain the property specified by the
         * binding @see:path, the method returns null.
         *
         * @param object The object that contains the data to be retrieved.
         */
        Binding.prototype.getValue = function (object) {
            if (object) {
                // optimize common case
                if (this._key) {
                    return object[this._key];
                }
                // handle case where property name has a decimal point (TFS 139176, 257829)
                if (this._path && this._path in object) {
                    return object[this._path];
                }
                // traverse path for complex properties
                for (var i = 0; i < this._parts.length && object; i++) {
                    object = object[this._parts[i]];
                }
            }
            return object;
        };
        /**
         * Sets the binding value on a given object.
         *
         * If the object does not contain the property specified by the
         * binding @see:path, the value is not set.
         *
         * @param object The object that contains the data to be set.
         * @param value Data value to set.
         */
        Binding.prototype.setValue = function (object, value) {
            if (object) {
                // handle simple cases (and cases where the property name has a decimal point)
                if (this._path in object) {
                    object[this._path] = value;
                    return;
                }
                // traverse parts for complex properties
                for (var i = 0; i < this._parts.length - 1; i++) {
                    object = object[this._parts[i]];
                    if (object == null) {
                        return;
                    }
                }
                // make the assignment
                object[this._parts[this._parts.length - 1]] = value;
            }
        };
        return Binding;
    }());
    wijmo.Binding = Binding;
})(wijmo || (wijmo = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var wijmo;
(function (wijmo) {
    'use strict';
    /*
     * Represents an event handler (private class)
     */
    var EventHandler = /** @class */ (function () {
        function EventHandler(handler, self) {
            this.handler = handler;
            this.self = self;
        }
        return EventHandler;
    }());
    /**
     * Represents an event.
     *
     * Wijmo events are similar to .NET events. Any class may define events by
     * declaring them as fields. Any class may subscribe to events using the
     * event's @see:addHandler method and unsubscribe using the @see:removeHandler
     * method.
     *
     * Wijmo event handlers take two parameters: <i>sender</i> and <i>args</i>.
     * The first is the object that raised the event, and the second is an object
     * that contains the event parameters.
     *
     * Classes that define events follow the .NET pattern where for every event
     * there is an <i>on[EVENTNAME]</i> method that raises the event. This pattern
     * allows derived classes to override the <i>on[EVENTNAME]</i> method and
     * handle the event before and/or after the base class raises the event.
     * Derived classes may even suppress the event by not calling the base class
     * implementation.
     *
     * For example, the TypeScript code below overrides the <b>onValueChanged</b>
     * event for a control to perform some processing before and after the
     * <b>valueChanged</b> event fires:
     *
     * <pre>// override base class
     * onValueChanged(e: EventArgs) {
     *   // execute some code before the event fires
     *   console.log('about to fire valueChanged');
     *   // optionally, call base class to fire the event
     *   super.onValueChanged(e);
     *   // execute some code after the event fired
     *   console.log('valueChanged event just fired');
     * }</pre>
     */
    var Event = /** @class */ (function () {
        function Event() {
            this._handlers = [];
        }
        /**
         * Adds a handler to this event.
         *
         * @param handler Function invoked when the event is raised.
         * @param self Object that defines the event handler
         * (accessible as 'this' from the handler code).
         */
        Event.prototype.addHandler = function (handler, self) {
            handler = wijmo.asFunction(handler);
            this._handlers.push(new EventHandler(handler, self));
        };
        /**
         * Removes a handler from this event.
         *
         * @param handler Function invoked when the event is raised.
         * @param self Object that defines the event handler (accessible as 'this' from the handler code).
         */
        Event.prototype.removeHandler = function (handler, self) {
            handler = wijmo.asFunction(handler);
            for (var i = 0; i < this._handlers.length; i++) {
                var l = this._handlers[i];
                if (l.handler == handler || handler == null) {
                    if (l.self == self || self == null) {
                        this._handlers.splice(i, 1);
                        if (handler && self) {
                            break;
                        }
                    }
                }
            }
        };
        /**
         * Removes all handlers associated with this event.
         */
        Event.prototype.removeAllHandlers = function () {
            this._handlers.length = 0;
        };
        /**
         * Raises this event, causing all associated handlers to be invoked.
         *
         * @param sender Source object.
         * @param args Event parameters.
         */
        Event.prototype.raise = function (sender, args) {
            if (args === void 0) { args = EventArgs.empty; }
            for (var i = 0; i < this._handlers.length; i++) {
                var l = this._handlers[i];
                l.handler.call(l.self, sender, args);
            }
        };
        Object.defineProperty(Event.prototype, "hasHandlers", {
            /**
             * Gets a value that indicates whether this event has any handlers.
             */
            get: function () {
                return this._handlers.length > 0;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Event.prototype, "handlerCount", {
            /**
             * Gets the number of handlers added to this event.
             */
            get: function () {
                return this._handlers.length;
            },
            enumerable: true,
            configurable: true
        });
        return Event;
    }());
    wijmo.Event = Event;
    /**
     * Base class for event arguments.
     */
    var EventArgs = /** @class */ (function () {
        function EventArgs() {
        }
        /**
         * Provides a value to use with events that do not have event data.
         */
        EventArgs.empty = new EventArgs();
        return EventArgs;
    }());
    wijmo.EventArgs = EventArgs;
    /**
     * Provides arguments for cancellable events.
     */
    var CancelEventArgs = /** @class */ (function (_super) {
        __extends(CancelEventArgs, _super);
        function CancelEventArgs() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /**
             * Gets or sets a value that indicates whether the event should be canceled.
             */
            _this.cancel = false;
            return _this;
        }
        return CancelEventArgs;
    }(EventArgs));
    wijmo.CancelEventArgs = CancelEventArgs;
    /**
     * Provides arguments for property change events.
     */
    var PropertyChangedEventArgs = /** @class */ (function (_super) {
        __extends(PropertyChangedEventArgs, _super);
        /**
         * Initializes a new instance of the @see:PropertyChangedEventArgs class.
         *
         * @param propertyName The name of the property whose value changed.
         * @param oldValue The old value of the property.
         * @param newValue The new value of the property.
         */
        function PropertyChangedEventArgs(propertyName, oldValue, newValue) {
            var _this = _super.call(this) || this;
            _this._name = propertyName;
            _this._oldVal = oldValue;
            _this._newVal = newValue;
            return _this;
        }
        Object.defineProperty(PropertyChangedEventArgs.prototype, "propertyName", {
            /**
             * Gets the name of the property whose value changed.
             */
            get: function () {
                return this._name;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PropertyChangedEventArgs.prototype, "oldValue", {
            /**
             * Gets the old value of the property.
             */
            get: function () {
                return this._oldVal;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PropertyChangedEventArgs.prototype, "newValue", {
            /**
             * Gets the new value of the property.
             */
            get: function () {
                return this._newVal;
            },
            enumerable: true,
            configurable: true
        });
        return PropertyChangedEventArgs;
    }(EventArgs));
    wijmo.PropertyChangedEventArgs = PropertyChangedEventArgs;
    /**
     * Provides arguments for @see:XMLHttpRequest error events.
     */
    var RequestErrorEventArgs = /** @class */ (function (_super) {
        __extends(RequestErrorEventArgs, _super);
        /**
         * Initializes a new instance of the @see:RequestErrorEventArgs class.
         *
         * @param xhr The @see:XMLHttpRequest that detected the error.
         * The status and statusText properties of the request object
         * contain details about the error.
         * @param msg Optional error message.
         */
        function RequestErrorEventArgs(xhr, msg) {
            var _this = _super.call(this) || this;
            _this._xhr = xhr;
            _this._msg = msg;
            return _this;
        }
        Object.defineProperty(RequestErrorEventArgs.prototype, "request", {
            /**
             * Gets a reference to the @see:XMLHttpRequest that detected the error.
             *
             * The status and statusText properties of the request object contain
             * details about the error.
             */
            get: function () {
                return this._xhr;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(RequestErrorEventArgs.prototype, "message", {
            /**
             * Gets or sets an error message to display to the user.
             */
            get: function () {
                return this._msg;
            },
            set: function (value) {
                this._msg = value;
            },
            enumerable: true,
            configurable: true
        });
        return RequestErrorEventArgs;
    }(CancelEventArgs));
    wijmo.RequestErrorEventArgs = RequestErrorEventArgs;
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    'use strict';
    /**
     * Base class for all Wijmo controls.
     *
     * The @see:Control class handles the association between DOM elements and the
     * actual control. Use the @see:hostElement property to get the DOM element
     * that is hosting a control, or the @see:getControl method to get the control
     * hosted in a given DOM element.
     *
     * The @see:Control class also provides a common pattern for invalidating and
     * refreshing controls, for updating the control layout when its size changes,
     * and for handling the HTML templates that define the control structure.
     */
    var Control = /** @class */ (function () {
        /**
         * Initializes a new instance of the @see:Control class and attaches it to a DOM element.
         *
         * @param element The DOM element that will host the control, or a selector for the host element (e.g. '#theCtrl').
         * @param options JavaScript object containing initialization data for the control.
         * @param invalidateOnResize Whether the control should be invalidated when it is resized.
         */
        function Control(element, options, invalidateOnResize) {
            if (options === void 0) { options = null; }
            if (invalidateOnResize === void 0) { invalidateOnResize = false; }
            var _this = this;
            this._pristine = true; // the control has not been changed
            this._focus = false; // whether the control currently contains the focus
            this._updating = 0; // update count (no refreshes while > 0)
            this._fullUpdate = false; // in case there are multiple calls to invalidate(x)
            /**
             * Occurs when the control gets the focus.
             */
            this.gotFocus = new wijmo.Event();
            /**
             * Occurs when the control loses the focus.
             */
            this.lostFocus = new wijmo.Event();
            /**
             * Occurs when the control is about to refresh its contents.
             */
            this.refreshing = new wijmo.Event();
            /**
             * Occurs after the control has refreshed its contents.
             */
            this.refreshed = new wijmo.Event();
            Control._updateWme();
            // check that the element is not in use
            wijmo.assert(Control.getControl(element) == null, 'Element is already hosting a control.');
            // get the host element
            var host = wijmo.getElement(element);
            wijmo.assert(host != null, 'Cannot find the host element.');
            // save host and original content (to restore on dispose)
            this._orgOuter = host.outerHTML;
            this._orgTag = host.tagName;
            this._orgAtts = host.attributes;
            // save host attributes, replace <input> and <select> elements with <div>
            if (host.tagName == 'INPUT' || host.tagName == 'SELECT') {
                host = this._replaceWithDiv(host);
            }
            // save host element and store control instance in element
            // (to retrieve with Control.getControl(element))
            this._e = host;
            host[Control._CTRL_KEY] = this;
            // update layout when user resizes the browser
            if (invalidateOnResize == true) {
                this._szCtl = new wijmo.Size(host.offsetWidth, host.offsetHeight);
                var hr = this._handleResize.bind(this);
                this.addEventListener(window, 'resize', hr);
            }
            // update focus state on focus and blur events
            var toFocus;
            this.addEventListener(host, 'focus', function (e) {
                if (toFocus)
                    clearTimeout(toFocus);
                toFocus = setTimeout(function () {
                    toFocus = null;
                    _this._updateFocusState();
                }, Control._FOCUS_INTERVAL);
            }, true);
            this.addEventListener(host, 'blur', function (e) {
                if (toFocus)
                    clearTimeout(toFocus);
                toFocus = setTimeout(function () {
                    toFocus = null;
                    _this._updateFocusState();
                }, Control._FOCUS_INTERVAL);
            }, true);
            // handle disabled controls 
            // (pointer-events requires IE11, doesn't prevent wheel at all)
            var hd = this._handleDisabled.bind(this);
            this.addEventListener(host, 'mousedown', hd, true);
            this.addEventListener(host, 'mouseup', hd, true);
            this.addEventListener(host, 'click', hd, true);
            this.addEventListener(host, 'dblclick', hd, true);
            this.addEventListener(host, 'keydown', hd, true);
            this.addEventListener(host, 'wheel', hd, wijmo.getEventOptions(true, true));
            // keep track of touch actions at the document level
            // (no need to add/remove event handlers to every Wijmo control)
            if (Control._touching == null) {
                Control._touching = false;
                if ('ontouchstart' in window || 'onpointerdown' in window) {
                    var b = document.body, ts = this._handleTouchStart, te = this._handleTouchEnd, opt = wijmo.getEventOptions(true, true);
                    if ('ontouchstart' in window) {
                        b.addEventListener('touchstart', ts, opt);
                        b.addEventListener('touchend', te, opt);
                        b.addEventListener('touchcancel', te, opt);
                        b.addEventListener('touchleave', te, opt);
                    }
                    else if ('onpointerdown' in window) {
                        b.addEventListener('pointerdown', ts, opt);
                        b.addEventListener('pointerup', te, opt);
                        b.addEventListener('pointerout', te, opt);
                        b.addEventListener('pointercancel', te, opt);
                        b.addEventListener('pointerleave', te, opt);
                    }
                }
            }
        }
        /**
         * Gets the HTML template used to create instances of the control.
         *
         * This method traverses up the class hierarchy to find the nearest ancestor that
         * specifies a control template. For example, if you specify a prototype for the
         * @see:ComboBox control, it will override the template defined by the @see:DropDown
         * base class.
         */
        Control.prototype.getTemplate = function () {
            for (var p = Object.getPrototypeOf(this); p; p = Object.getPrototypeOf(p)) {
                var tpl = p.constructor.controlTemplate;
                if (tpl) {
                    return tpl;
                }
            }
            return null;
        };
        /**
         * Applies the template to a new instance of a control, and returns the root element.
         *
         * This method should be called by constructors of templated controls.
         * It is responsible for binding the template parts to the
         * corresponding control members.
         *
         * For example, the code below applies a template to an instance
         * of an @see:InputNumber control. The template must contain elements
         * with the 'wj-part' attribute set to 'input', 'btn-inc', and 'btn-dec'.
         * The control members '_tbx', '_btnUp', and '_btnDn' will be assigned
         * references to these elements.
         *
         * <pre>this.applyTemplate('wj-control wj-inputnumber', template, {
         *   _tbx: 'input',
         *   _btnUp: 'btn-inc',
         *   _btnDn: 'btn-dec'
         * }, 'input');</pre>
         *
         * @param classNames Names of classes to add to the control's host element.
         * @param template An HTML string that defines the control template.
         * @param parts A dictionary of part variables and their names.
         * @param namePart Name of the part to be named after the host element. This
         * determines how the control submits data when used in forms.
         */
        Control.prototype.applyTemplate = function (classNames, template, parts, namePart) {
            var _this = this;
            var host = this._e;
            // apply standard classes to host element
            if (classNames) {
                wijmo.addClass(host, classNames);
            }
            // convert string into HTML template and append to host
            var tpl = null;
            if (template) {
                tpl = wijmo.createElement(template, host);
            }
            // copy key attributes from the host element (name, validation)
            // to inner input element
            // NOTE 1: do this only if there is a single input element in the template
            // NOTE 2: do not copy 'type' since it causes issues in Chrome: TFS 84900, 84901
            var inputs = host.querySelectorAll('input'), input = (inputs.length == 1 ? inputs[0] : null);
            if (input) {
                this._copyAttributes(input, host.attributes, Control._rxInputAtts);
                this._copyAttributes(input, this._orgAtts, Control._rxInputAtts);
            }
            // change 'for' attribute of labels targeting the host element 
            // to target the inner input element instead (needed for Chrome and FF)
            if (input && host.id) {
                // get root element (may be a component not yet in the DOM)
                var root = host;
                while (root.parentElement) {
                    root = root.parentElement;
                }
                // get label that applies to this control
                var label = root.querySelector('label[for="' + host.id + '"]');
                if (label instanceof HTMLLabelElement) {
                    var newId = wijmo.getUniqueId(host.id + '_input');
                    input.id = newId; // set id of inner input element
                    label.htmlFor = newId; // change 'for' attribute to match new id
                }
            }
            // fire 'change' events on behalf of inner input elements (TFS 190946)
            if (input) {
                var evtChange_1 = document.createEvent('HTMLEvents'), orgVal_1 = input.value;
                evtChange_1.initEvent('change', true, false);
                this.addEventListener(input, 'input', function () {
                    _this._pristine = false;
                    orgVal_1 = input.value;
                }, true);
                this.gotFocus.addHandler(function () {
                    orgVal_1 = input.value;
                });
                this.lostFocus.addHandler(function () {
                    if (_this._pristine) {
                        _this._pristine = false;
                        _this._updateState(); // to update wj-state-invalid
                    }
                    if (orgVal_1 != input.value) {
                        input.dispatchEvent(evtChange_1);
                    }
                });
            }
            // if the control has an input element, set its tabindex to -1 so 
            // the back tab key will work properly.
            // otherwise, make sure the host can get the focus
            // http://wijmo.com/topic/shift-tab-not-working-for-input-controls-in-ff-and-chrome/, TFS 123457
            if (input) {
                host.tabIndex = -1;
            }
            else if (!host.getAttribute('tabindex')) {
                host.tabIndex = 0;
            }
            // initialize state (empty/invalid)
            this._updateState();
            // bind control variables to template parts
            if (parts) {
                for (var part in parts) {
                    var wjPart = parts[part];
                    this[part] = tpl.querySelector('[wj-part="' + wjPart + '"]');
                    // look in the root as well (querySelector doesn't...)
                    if (this[part] == null && tpl.getAttribute('wj-part') == wjPart) {
                        this[part] = tpl;
                    }
                    // make sure we found the part
                    if (this[part] == null) {
                        throw 'Missing template part: "' + wjPart + '"';
                    }
                    // copy/move attributes from host to input element
                    if (wjPart == namePart) {
                        // copy parent element's name attribute to the namePart element
                        // (to send data when submitting forms).
                        var key = 'name', att = host.attributes[key];
                        if (att && att.value) {
                            this[part].setAttribute(key, att.value);
                        }
                        // transfer access key
                        key = 'accesskey';
                        att = host.attributes[key];
                        if (att && att.value) {
                            this[part].setAttribute(key, att.value);
                            host.removeAttribute(key);
                        }
                    }
                }
            }
            // return template
            return tpl;
        };
        /**
         * Disposes of the control by removing its association with the host element.
         *
         * The @see:dispose method automatically removes any event listeners added
         * with the @see:addEventListener method.
         *
         * Calling the @see:dispose method is important in applications that create
         * and remove controls dynamically. Failing to dispose of the controls may
         * cause memory leaks.
         */
        Control.prototype.dispose = function () {
            // dispose of any child controls
            var cc = this._e.querySelectorAll('.wj-control');
            for (var i = 0; i < cc.length; i++) {
                var ctl = Control.getControl(cc[i]);
                if (ctl) {
                    ctl.dispose();
                }
            }
            // cancel any pending refreshes
            if (this._toInv) {
                clearTimeout(this._toInv);
                this._toInv = null;
            }
            // remove all HTML event listeners
            this.removeEventListener();
            // remove all Wijmo event listeners 
            // (without getting the value for all properties)
            for (var prop in this) {
                if (prop.length > 2 && prop.indexOf('on') == 0) {
                    var evt = this[prop[2].toLowerCase() + prop.substr(3)];
                    if (evt instanceof wijmo.Event) {
                        evt.removeAllHandlers();
                    }
                }
            }
            // if the control has a collectionView property, remove handlers to stop receiving notifications
            // REVIEW: perhaps optimize by caching the CollectionView properties?
            var cv = this['collectionView'];
            if (cv instanceof wijmo.collections.CollectionView) {
                for (var prop in cv) {
                    var evt = cv[prop];
                    if (evt instanceof wijmo.Event) {
                        evt.removeHandler(null, this);
                    }
                }
            }
            // restore original content
            if (this._e.parentNode) {
                this._e.outerHTML = this._orgOuter;
            }
            // done
            this._e[Control._CTRL_KEY] = null;
            this._e = this._orgOuter = this._orgTag = null;
        };
        /**
         * Gets the control that is hosted in a given DOM element.
         *
         * @param element The DOM element that is hosting the control, or a selector for the host element (e.g. '#theCtrl').
         */
        Control.getControl = function (element) {
            var e = wijmo.getElement(element);
            return e ? wijmo.asType(e[Control._CTRL_KEY], Control, true) : null;
        };
        Object.defineProperty(Control.prototype, "hostElement", {
            /**
             * Gets the DOM element that is hosting the control.
             */
            get: function () {
                return this._e;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Control.prototype, "rightToLeft", {
            /**
             * Gets a value indicating whether the control is hosted in an element
             * with right-to-left layout.
             */
            get: function () {
                if (this._rtlDir == null) {
                    this._rtlDir = this._e
                        ? getComputedStyle(this._e).direction == 'rtl'
                        : false;
                }
                return this._rtlDir;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Sets the focus to this control.
         */
        Control.prototype.focus = function () {
            if (this._e) {
                this._e.focus();
            }
        };
        /**
         * Checks whether this control contains the focused element.
         */
        Control.prototype.containsFocus = function () {
            var host = this._e, ae = wijmo.getActiveElement();
            // test for disposed controls
            if (!host) {
                return false;
            }
            // travel up the tree...
            for (var e = ae; e;) {
                if (e == host) {
                    return true;
                }
                e = e[Control._OWNR_KEY] || e.parentElement;
            }
            // no deal...
            return false;
        };
        /**
         * Invalidates the control causing an asynchronous refresh.
         *
         * @param fullUpdate Whether to update the control layout as well as the content.
         */
        Control.prototype.invalidate = function (fullUpdate) {
            var _this = this;
            if (fullUpdate === void 0) { fullUpdate = true; }
            this._rtlDir = null;
            this._fullUpdate = this._fullUpdate || fullUpdate;
            if (this._toInv) {
                clearTimeout(this._toInv);
                this._toInv = null;
            }
            if (!this.isUpdating) {
                this._toInv = setTimeout(function () {
                    _this.refresh(_this._fullUpdate);
                    _this._toInv = null;
                }, Control._REFRESH_INTERVAL);
            }
        };
        /**
         * Refreshes the control.
         *
         * @param fullUpdate Whether to update the control layout as well as the content.
         */
        Control.prototype.refresh = function (fullUpdate) {
            var _this = this;
            if (fullUpdate === void 0) { fullUpdate = true; }
            // raise refreshing/ed events
            if (!this.isUpdating) {
                this.onRefreshing();
                setTimeout(function () {
                    _this.onRefreshed();
                });
            }
            // update internal variables
            if (!this.isUpdating && this._toInv) {
                clearTimeout(this._toInv);
                this._toInv = null;
                this._rtlDir = null;
                this._fullUpdate = false;
                Control._updateWme();
            }
            // derived classes should override this...
        };
        /**
         * Invalidates all Wijmo controls contained in an HTML element.
         *
         * Use this method when your application has dynamic panels that change
         * the control's visibility or dimensions. For example, splitters, accordions,
         * and tab controls usually change the visibility of its content elements.
         * In this case, failing to notify the controls contained in the element
         * may cause them to stop working properly.
         *
         * If this happens, you must handle the appropriate event in the dynamic
         * container and call the @see:Control.invalidateAll method so the contained
         * Wijmo controls will update their layout information properly.
         *
         * @param e Container element. If set to null, all Wijmo controls
         * on the page will be invalidated.
         */
        Control.invalidateAll = function (e) {
            if (!e)
                e = document.body;
            if (e.children) {
                for (var i = 0; i < e.children.length; i++) {
                    Control.invalidateAll(e.children[i]);
                }
            }
            var ctl = Control.getControl(e);
            if (ctl) {
                ctl.invalidate();
            }
        };
        /**
         * Refreshes all Wijmo controls contained in an HTML element.
         *
         * This method is similar to @see:invalidateAll, except the controls
         * are updated immediately rather than after an interval.
         *
         * @param e Container element. If set to null, all Wijmo controls
         * on the page will be invalidated.
         */
        Control.refreshAll = function (e) {
            if (!e)
                e = document.body;
            if (e.children) {
                for (var i = 0; i < e.children.length; i++) {
                    Control.refreshAll(e.children[i]);
                }
            }
            var ctl = Control.getControl(e);
            if (ctl) {
                ctl.refresh();
            }
        };
        /**
         * Disposes of all Wijmo controls contained in an HTML element.
         *
         * @param e Container element.
         */
        Control.disposeAll = function (e) {
            var ctl = Control.getControl(e);
            if (ctl) {
                ctl.dispose();
            }
            else if (e.children) {
                for (var i = 0; i < e.children.length; i++) {
                    Control.disposeAll(e.children[i]);
                }
            }
        };
        /**
         * Suspends notifications until the next call to @see:endUpdate.
         */
        Control.prototype.beginUpdate = function () {
            this._updating++;
        };
        /**
         * Resumes notifications suspended by calls to @see:beginUpdate.
         */
        Control.prototype.endUpdate = function () {
            this._updating--;
            if (this._updating <= 0) {
                this.invalidate();
            }
        };
        Object.defineProperty(Control.prototype, "isUpdating", {
            /**
             * Gets a value that indicates whether the control is currently being updated.
             */
            get: function () {
                return this._updating > 0;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Executes a function within a @see:beginUpdate/@see:endUpdate block.
         *
         * The control will not be updated until the function has been executed.
         * This method ensures @see:endUpdate is called even if the function throws
         * an exception.
         *
         * @param fn Function to be executed.
         */
        Control.prototype.deferUpdate = function (fn) {
            try {
                this.beginUpdate();
                fn();
            }
            finally {
                this.endUpdate();
            }
        };
        Object.defineProperty(Control.prototype, "isTouching", {
            /**
             * Gets a value that indicates whether the control is currently handling a touch event.
             */
            get: function () {
                return Control._touching;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Control.prototype, "isDisabled", {
            /**
             * Gets or sets a value that determines whether the control is disabled.
             *
             * Disabled controls cannot get mouse or keyboard events.
             */
            get: function () {
                return this._e && this._e.getAttribute('disabled') != null;
            },
            set: function (value) {
                value = wijmo.asBoolean(value, true);
                if (value != this.isDisabled) {
                    wijmo.enable(this._e, !value);
                }
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Initializes the control by copying the properties from a given object.
         *
         * This method allows you to initialize controls using plain data objects
         * instead of setting the value of each property in code.
         *
         * For example:
         * <pre>
         * grid.initialize({
         *   itemsSource: myList,
         *   autoGenerateColumns: false,
         *   columns: [
         *     { binding: 'id', header: 'Code', width: 130 },
         *     { binding: 'name', header: 'Name', width: 60 }
         *   ]
         * });
         * // is equivalent to
         * grid.itemsSource = myList;
         * grid.autoGenerateColumns = false;
         * // etc.
         * </pre>
         *
         * The initialization data is type-checked as it is applied. If the
         * initialization object contains unknown property names or invalid
         * data types, this method will throw.
         *
         * @param options Object that contains the initialization data.
         */
        Control.prototype.initialize = function (options) {
            if (options) {
                wijmo.copy(this, options); // no deferUpdate/async stuff here!
            }
        };
        /**
         * Adds an event listener to an element owned by this @see:Control.
         *
         * The control keeps a list of attached listeners and their handlers,
         * making it easier to remove them when the control is disposed (see the
         * @see:dispose and @see:removeEventListener methods).
         *
         * Failing to remove event listeners may cause memory leaks.
         *
         * @param target Target element for the event.
         * @param type String that specifies the event.
         * @param fn Function to execute when the event occurs.
         * @param capture Whether the listener is capturing.
         */
        Control.prototype.addEventListener = function (target, type, fn, capture) {
            if (capture === void 0) { capture = false; }
            if (target) {
                target.addEventListener(type, fn, capture);
                if (this._listeners == null) {
                    this._listeners = [];
                }
                this._listeners.push({ target: target, type: type, fn: fn, capture: capture });
            }
        };
        /**
         * Removes one or more event listeners attached to elements owned by this @see:Control.
         *
         * @param target Target element for the event. If null, removes listeners attached to all targets.
         * @param type String that specifies the event. If null, removes listeners attached to all events.
         * @param fn Handler to remove. If null, removes all handlers.
         * @param capture Whether the listener is capturing. If null, removes capturing and non-capturing listeners.
         * @return The number of listeners removed.
         */
        Control.prototype.removeEventListener = function (target, type, fn, capture) {
            var cnt = 0;
            if (this._listeners) {
                for (var i = 0; i < this._listeners.length; i++) {
                    var l = this._listeners[i];
                    if (target == null || target == l.target) {
                        if (type == null || type == l.type) {
                            if (fn == null || fn == l.fn) {
                                if (capture == null || capture == l.capture) {
                                    l.target.removeEventListener(l.type, l.fn, l.capture);
                                    this._listeners.splice(i, 1);
                                    i--;
                                    cnt++;
                                }
                            }
                        }
                    }
                }
            }
            return cnt;
        };
        /**
         * Raises the @see:gotFocus event.
         */
        Control.prototype.onGotFocus = function (e) {
            this.gotFocus.raise(this, e);
        };
        /**
         * Raises the @see:lostFocus event.
         */
        Control.prototype.onLostFocus = function (e) {
            this.lostFocus.raise(this, e);
        };
        /**
         * Raises the @see:refreshing event.
         */
        Control.prototype.onRefreshing = function (e) {
            this.refreshing.raise(this, e);
        };
        /**
         * Raises the @see:refreshed event.
         */
        Control.prototype.onRefreshed = function (e) {
            this.refreshed.raise(this, e);
        };
        // ** implementation
        // check whether the control has pending updates
        Control.prototype._hasPendingUpdates = function () {
            return this._toInv != null;
        };
        // update watermark element
        Control._updateWme = function () {
        };
        // invalidates the control when its size changes
        Control.prototype._handleResize = function () {
            if (this._e.parentElement) {
                var sz = new wijmo.Size(this._e.offsetWidth, this._e.offsetHeight);
                if (!sz.equals(this._szCtl)) {
                    this._szCtl = sz;
                    this.invalidate();
                }
            }
        };
        // update focus state and raise got/lost focus events
        // for this control and all its ancestors in the DOM tree
        Control.prototype._updateFocusState = function () {
            // Chrome requires a timeout here because the focus may go to the body
            // when the user clicks elements with tabindex < 0 (TFS 255011)
            setTimeout(function () {
                var e = wijmo.EventArgs.empty, hasFocus = [];
                // losing focus
                var hadFocus = document.body.querySelectorAll('.wj-state-focused');
                for (var i = 0; i < hadFocus.length; i++) {
                    var ctl = Control.getControl(hadFocus[i]);
                    if (ctl && ctl._focus && !ctl.containsFocus()) {
                        ctl._focus = false;
                        ctl._updateState();
                        ctl.onLostFocus(e);
                    }
                }
                // getting focus
                var ae = wijmo.getActiveElement();
                if (ae) {
                    for (var host = ae; host;) {
                        var ctl = Control.getControl(host);
                        if (ctl && !ctl._focus && ctl.containsFocus()) {
                            ctl._focus = true;
                            ctl._updateState();
                            ctl.onGotFocus(e);
                        }
                        host = host[Control._OWNR_KEY] || host.parentElement;
                    }
                }
            });
        };
        // update state attributes for this control (focused, empty, invalid)
        Control.prototype._updateState = function () {
            var host = this.hostElement;
            if (host) {
                wijmo.toggleClass(host, 'wj-state-focused', this._focus);
                var input_1 = host.querySelector('input');
                if (input_1 instanceof HTMLInputElement) {
                    wijmo.toggleClass(host, 'wj-state-empty', input_1.value.length == 0);
                    wijmo.toggleClass(host, 'wj-state-readonly', input_1.readOnly);
                    var vm = input_1.validationMessage; // may be null in IE9 (TFS 204492)
                    wijmo.toggleClass(host, 'wj-state-invalid', !this._pristine && vm != null && vm.length > 0);
                    // ** don't: the control might be editable even if the 
                    // input element is readonly
                    //setAttribute(host, 'aria-readonly', input.readOnly ? true : null);
                }
            }
        };
        // keep track of touch events
        Control.prototype._handleTouchStart = function (e) {
            if (e.pointerType == null || e.pointerType == 'touch') {
                Control._touching = true;
            }
        };
        Control.prototype._handleTouchEnd = function (e) {
            if (e.pointerType == null || e.pointerType == 'touch') {
                setTimeout(function () {
                    Control._touching = false;
                }, 400); // 300ms click event delay on IOS, plus some safety
            }
        };
        // suppress mouse and keyboard events if the control is disabled
        // (pointer-events requires IE11, doesn't prevent wheel at all)
        Control.prototype._handleDisabled = function (e) {
            if (this.isDisabled) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
            }
        };
        // replaces an element with a div element, copying the child elements 
        // and the 'id' and 'style' attributes from the original element
        Control.prototype._replaceWithDiv = function (element) {
            // replace the element
            var div = document.createElement('div');
            element.parentElement.replaceChild(div, element);
            // copy children
            div.innerHTML = element.innerHTML;
            // copy original attributes to host element
            this._copyAttributes(div, element.attributes, /id|style|class/i);
            // return new div
            return div;
        };
        // apply given attributes to an input element
        Control.prototype._copyAttributes = function (e, atts, names) {
            if (e) {
                for (var i = 0; i < atts.length; i++) {
                    var name_1 = atts[i].name;
                    if (name_1.match(names)) {
                        e.setAttribute(name_1, atts[i].value);
                    }
                }
            }
        };
        Control._REFRESH_INTERVAL = 10; // interval between invalidation and refresh
        Control._FOCUS_INTERVAL = 20; // interval between focus/blur events and state update: >0, <200: TFS 100250, 112599, 115816, 195150
        Control._ANIM_DEF_DURATION = 400; // default animation duration (ms)
        Control._ANIM_DEF_STEP = 35; // default animation step (ms)
        Control._CLICK_DELAY = 800; // interval before repeat-clicking starts (ms)
        Control._CLICK_REPEAT = 75; // interval between repeat-clicks (ms)
        Control._CLIPBOARD_DELAY = 100; // interval used for clipboard operations (ms)
        Control._CTRL_KEY = '$WJ-CTRL'; // key used to store control reference in host element
        Control._OWNR_KEY = '$WJ-OWNR'; // popup owner key
        Control._SCRL_KEY = '$WJ-SCRL'; // popup scroll listener key
        // attributes to be copied from host element to inner input element
        // tabindex requires some extra handling, see applyTemplate for details
        Control._rxInputAtts = /name|tabindex|placeholder|autofocus|autocomplete|autocorrect|autocapitalize|spellcheck|readonly|minlength|maxlength|pattern|type/i;
        return Control;
    }());
    wijmo.Control = Control;
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    'use strict';
    /**
     * Specifies the type of aggregate to calculate over a group of values.
     */
    var Aggregate;
    (function (Aggregate) {
        /**
         * No aggregate.
         */
        Aggregate[Aggregate["None"] = 0] = "None";
        /**
         * Returns the sum of the numeric values in the group.
         */
        Aggregate[Aggregate["Sum"] = 1] = "Sum";
        /**
         * Returns the count of non-null values in the group.
         */
        Aggregate[Aggregate["Cnt"] = 2] = "Cnt";
        /**
         * Returns the average value of the numeric values in the group.
         */
        Aggregate[Aggregate["Avg"] = 3] = "Avg";
        /**
         * Returns the maximum value in the group.
         */
        Aggregate[Aggregate["Max"] = 4] = "Max";
        /**
         * Returns the minimum value in the group.
         */
        Aggregate[Aggregate["Min"] = 5] = "Min";
        /**
         * Returns the difference between the maximum and minimum numeric values in the group.
         */
        Aggregate[Aggregate["Rng"] = 6] = "Rng";
        /**
         * Returns the sample standard deviation of the numeric values in the group
         * (uses the formula based on n-1).
         */
        Aggregate[Aggregate["Std"] = 7] = "Std";
        /**
         * Returns the sample variance of the numeric values in the group
         * (uses the formula based on n-1).
         */
        Aggregate[Aggregate["Var"] = 8] = "Var";
        /**
         * Returns the population standard deviation of the values in the group
         * (uses the formula based on n).
         */
        Aggregate[Aggregate["StdPop"] = 9] = "StdPop";
        /**
         * Returns the population variance of the values in the group
         * (uses the formula based on n).
         */
        Aggregate[Aggregate["VarPop"] = 10] = "VarPop";
        /**
         * Returns the count of all values in the group (including nulls).
         */
        Aggregate[Aggregate["CntAll"] = 11] = "CntAll";
        /**
         * Returns the first non-null value in the group.
         */
        Aggregate[Aggregate["First"] = 12] = "First";
        /**
         * Returns the last non-null value in the group.
         */
        Aggregate[Aggregate["Last"] = 13] = "Last";
    })(Aggregate = wijmo.Aggregate || (wijmo.Aggregate = {}));
    /**
     * Calculates an aggregate value from the values in an array.
     *
     * @param aggType Type of aggregate to calculate.
     * @param items Array with the items to aggregate.
     * @param binding Name of the property to aggregate on (in case the items are not simple values).
     */
    function getAggregate(aggType, items, binding) {
        var cnt = 0, cntn = 0, sum = 0, sum2 = 0, min = null, max = null, last = null, bnd = binding ? new wijmo.Binding(binding) : null;
        // special case: overall count (including nulls)
        aggType = wijmo.asEnum(aggType, Aggregate);
        if (aggType == Aggregate.CntAll) {
            return items.length;
        }
        // calculate aggregate
        for (var i = 0; i < items.length; i++) {
            // get item/value
            var val = items[i];
            if (bnd) {
                val = bnd.getValue(val);
                //assert(!isUndefined(val), 'item does not define property "' + binding + '".');
            }
            // special case: first value
            if (aggType == Aggregate.First) {
                return val;
            }
            // aggregate
            if (val != null) {
                cnt++;
                if (min == null || val < min) {
                    min = val;
                }
                if (max == null || val > max) {
                    max = val;
                }
                last = val;
                if (wijmo.isNumber(val) && !isNaN(val)) {
                    cntn++;
                    sum += val;
                    sum2 += val * val;
                }
                else if (wijmo.isBoolean(val)) {
                    cntn++;
                    if (val == true) {
                        sum++;
                        sum2++;
                    }
                }
            }
        }
        // return result
        var avg = cntn == 0 ? 0 : sum / cntn;
        switch (aggType) {
            case Aggregate.Avg:
                return avg;
            case Aggregate.Cnt:
                return cnt;
            case Aggregate.Max:
                return max;
            case Aggregate.Min:
                return min;
            case Aggregate.Rng:
                return max - min;
            case Aggregate.Sum:
                return sum;
            case Aggregate.VarPop:
                return cntn <= 1 ? 0 : sum2 / cntn - avg * avg;
            case Aggregate.StdPop:
                return cntn <= 1 ? 0 : Math.sqrt(sum2 / cntn - avg * avg);
            case Aggregate.Var:
                return cntn <= 1 ? 0 : (sum2 / cntn - avg * avg) * cntn / (cntn - 1);
            case Aggregate.Std:
                return cntn <= 1 ? 0 : Math.sqrt((sum2 / cntn - avg * avg) * cntn / (cntn - 1));
            case Aggregate.Last:
                return last;
        }
        // should never get here...
        throw 'Invalid aggregate type.';
    }
    wijmo.getAggregate = getAggregate;
})(wijmo || (wijmo = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Defines interfaces and classes related to data, including the @see:ICollectionView
 * interface, @see:CollectionView and @see:ObservableArray classes.
 */
var wijmo;
(function (wijmo) {
    var collections;
    (function (collections) {
        'use strict';
        /**
         * Describes the action that caused the @see:INotifyCollectionChanged.collectionChanged
         * event to fire.
         */
        var NotifyCollectionChangedAction;
        (function (NotifyCollectionChangedAction) {
            /** An item was added to the collection. */
            NotifyCollectionChangedAction[NotifyCollectionChangedAction["Add"] = 0] = "Add";
            /** An item was removed from the collection. */
            NotifyCollectionChangedAction[NotifyCollectionChangedAction["Remove"] = 1] = "Remove";
            /** An item was changed or replaced. */
            NotifyCollectionChangedAction[NotifyCollectionChangedAction["Change"] = 2] = "Change";
            /**
             * Several items changed simultaneously
             * (for example, the collection was sorted, filtered, or grouped).
             */
            NotifyCollectionChangedAction[NotifyCollectionChangedAction["Reset"] = 3] = "Reset";
        })(NotifyCollectionChangedAction = collections.NotifyCollectionChangedAction || (collections.NotifyCollectionChangedAction = {}));
        /**
         * Provides data for the @see:INotifyCollectionChanged.collectionChanged event.
         */
        var NotifyCollectionChangedEventArgs = /** @class */ (function (_super) {
            __extends(NotifyCollectionChangedEventArgs, _super);
            /**
             * Initializes a new instance of the @see:NotifyCollectionChangedEventArgs class.
             *
             * @param action Type of action that caused the event to fire.
             * @param item Item that was added or changed.
             * @param index Index of the item.
             */
            function NotifyCollectionChangedEventArgs(action, item, index) {
                if (action === void 0) { action = NotifyCollectionChangedAction.Reset; }
                if (item === void 0) { item = null; }
                if (index === void 0) { index = -1; }
                var _this = _super.call(this) || this;
                _this.action = action;
                _this.item = item;
                _this.index = index;
                return _this;
            }
            /**
             * Provides a reset notification.
             */
            NotifyCollectionChangedEventArgs.reset = new NotifyCollectionChangedEventArgs(NotifyCollectionChangedAction.Reset);
            return NotifyCollectionChangedEventArgs;
        }(wijmo.EventArgs));
        collections.NotifyCollectionChangedEventArgs = NotifyCollectionChangedEventArgs;
        /**
         * Describes a sorting criterion.
         */
        var SortDescription = /** @class */ (function () {
            /**
             * Initializes a new instance of the @see:SortDescription class.
             *
             * @param property Name of the property to sort on.
             * @param ascending Whether to sort in ascending order.
             */
            function SortDescription(property, ascending) {
                this._bnd = new wijmo.Binding(property);
                this._asc = ascending;
            }
            Object.defineProperty(SortDescription.prototype, "property", {
                /**
                 * Gets the name of the property used to sort.
                 */
                get: function () {
                    return this._bnd.path;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(SortDescription.prototype, "ascending", {
                /**
                 * Gets a value that determines whether to sort the values in ascending order.
                 */
                get: function () {
                    return this._asc;
                },
                enumerable: true,
                configurable: true
            });
            return SortDescription;
        }());
        collections.SortDescription = SortDescription;
        /**
         * Provides data for the @see:IPagedCollectionView.pageChanging event
         */
        var PageChangingEventArgs = /** @class */ (function (_super) {
            __extends(PageChangingEventArgs, _super);
            /**
             * Initializes a new instance of the @see:PageChangingEventArgs class.
             *
             * @param newIndex Index of the page that is about to become current.
             */
            function PageChangingEventArgs(newIndex) {
                var _this = _super.call(this) || this;
                _this.newPageIndex = newIndex;
                return _this;
            }
            return PageChangingEventArgs;
        }(wijmo.CancelEventArgs));
        collections.PageChangingEventArgs = PageChangingEventArgs;
        /**
         * Represents a base class for types defining grouping conditions.
         *
         * The concrete class which is commonly used for this purpose is
         * @see:PropertyGroupDescription.
         */
        var GroupDescription = /** @class */ (function () {
            function GroupDescription() {
            }
            /**
             * Returns the group name for the given item.
             *
             * @param item The item to get group name for.
             * @param level The zero-based group level index.
             * @return The name of the group the item belongs to.
             */
            GroupDescription.prototype.groupNameFromItem = function (item, level) {
                return '';
            };
            /**
             * Returns a value that indicates whether the group name and the item name
             * match (which implies that the item belongs to the group).
             *
             * @param groupName The name of the group.
             * @param itemName The name of the item.
             * @return True if the names match; otherwise, false.
             */
            GroupDescription.prototype.namesMatch = function (groupName, itemName) {
                return groupName === itemName;
            };
            return GroupDescription;
        }());
        collections.GroupDescription = GroupDescription;
        /**
         * Describes the grouping of items using a property name as the criterion.
         *
         * For example, the code below causes a @see:CollectionView to group items
         * by the value of their 'country' property:
         * <pre>
         * var cv = new wijmo.collections.CollectionView(items);
         * var gd = new wijmo.collections.PropertyGroupDescription('country');
         * cv.groupDescriptions.push(gd);
         * </pre>
         *
         * You may also specify a callback function that generates the group name.
         * For example, the code below causes a @see:CollectionView to group items
         * by the first letter of the value of their 'country' property:
         * <pre>
         * var cv = new wijmo.collections.CollectionView(items);
         * var gd = new wijmo.collections.PropertyGroupDescription('country',
         *   function(item, propName) {
         *     return item[propName][0]; // return country's initial
         * });
         * cv.groupDescriptions.push(gd);
         * </pre>
         */
        var PropertyGroupDescription = /** @class */ (function (_super) {
            __extends(PropertyGroupDescription, _super);
            /**
             * Initializes a new instance of the @see:PropertyGroupDescription class.
             *
             * @param property The name of the property that specifies
             * which group an item belongs to.
             * @param converter A callback function that takes an item and
             * a property name and returns the group name. If not specified,
             * the group name is the property value for the item.
             */
            function PropertyGroupDescription(property, converter) {
                var _this = _super.call(this) || this;
                _this._bnd = new wijmo.Binding(property);
                _this._converter = converter;
                return _this;
            }
            Object.defineProperty(PropertyGroupDescription.prototype, "propertyName", {
                /**
                 * Gets the name of the property that is used to determine which
                 * group an item belongs to.
                 */
                get: function () {
                    return this._bnd.path;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Returns the group name for the given item.
             *
             * @param item The item to get group name for.
             * @param level The zero-based group level index.
             * @return The name of the group the item belongs to.
             */
            PropertyGroupDescription.prototype.groupNameFromItem = function (item, level) {
                return this._converter
                    ? this._converter(item, this.propertyName)
                    : this._bnd.getValue(item);
            };
            /**
             * Returns a value that indicates whether the group name and the item name
             * match (which implies that the item belongs to the group).
             *
             * @param groupName The name of the group.
             * @param itemName The name of the item.
             * @return True if the names match; otherwise, false.
             */
            PropertyGroupDescription.prototype.namesMatch = function (groupName, itemName) {
                return groupName === itemName;
            };
            return PropertyGroupDescription;
        }(GroupDescription));
        collections.PropertyGroupDescription = PropertyGroupDescription;
    })(collections = wijmo.collections || (wijmo.collections = {}));
})(wijmo || (wijmo = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var wijmo;
(function (wijmo) {
    var collections;
    (function (collections) {
        'use strict';
        /**
         * Base class for Array classes with notifications.
         */
        var ArrayBase = /** @class */ (function (_super) {
            __extends(ArrayBase, _super);
            /**
             * Initializes a new instance of the @see:ArrayBase class.
             */
            function ArrayBase() {
                var _this = this;
                if (!canChangePrototype) {
                    _this = _super.call(this) || this;
                }
                else {
                    _this.length = 0;
                }
                return _this;
            }
            return ArrayBase;
        }(Array));
        collections.ArrayBase = ArrayBase;
        var canChangePrototype = true;
        try {
            ArrayBase.prototype = Array.prototype;
            canChangePrototype = ArrayBase.prototype === Array.prototype; // check in case where assignment was just ignored
        }
        catch (e) {
            canChangePrototype = false;
        }
        // In ES6 without this Symbol.species property, the methods returning an array will return instance
        // of the derived class instead of a native Array.
        var symb = window['Symbol'];
        if (!canChangePrototype && symb && symb.species) {
            Object.defineProperty(ArrayBase, symb.species, {
                get: function () { return Array; },
                enumerable: false,
                configurable: false
            });
        }
        /**
         * Array that sends notifications on changes.
         *
         * The class raises the @see:collectionChanged event when changes are made with
         * the push, pop, splice, insert, or remove methods.
         *
         * Warning: Changes made by assigning values directly to array members or to the
         * length of the array do not raise the @see:collectionChanged event.
         */
        var ObservableArray = /** @class */ (function (_super) {
            __extends(ObservableArray, _super);
            /**
             * Initializes a new instance of the @see:ObservableArray class.
             *
             * @param data Array containing items used to populate the @see:ObservableArray.
             */
            function ObservableArray(data) {
                var _this = _super.call(this) || this;
                _this._updating = 0;
                // ** INotifyCollectionChanged
                /**
                 * Occurs when the collection changes.
                 */
                _this.collectionChanged = new wijmo.Event();
                // initialize the array
                if (data) {
                    data = wijmo.asArray(data);
                    _this._updating++;
                    for (var i = 0; i < data.length; i++) {
                        _this.push(data[i]);
                    }
                    _this._updating--;
                }
                return _this;
            }
            /**
             * Adds one or more items to the end of the array.
             *
             * @param ...item One or more items to add to the array.
             * @return The new length of the array.
             */
            ObservableArray.prototype.push = function () {
                var item = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    item[_i] = arguments[_i];
                }
                var length = this.length;
                for (var i = 0; item && i < item.length; i++) {
                    length = _super.prototype.push.call(this, item[i]);
                    if (!this._updating) {
                        this._raiseCollectionChanged(collections.NotifyCollectionChangedAction.Add, item[i], length - 1);
                    }
                }
                return length;
            };
            /*
             * Removes the last item from the array.
             *
             * @return The item that was removed from the array.
             */
            ObservableArray.prototype.pop = function () {
                var item = _super.prototype.pop.call(this);
                this._raiseCollectionChanged(collections.NotifyCollectionChangedAction.Remove, item, this.length);
                return item;
            };
            /**
             * Removes and/or adds items to the array.
             *
             * @param index Position where items will be added or removed.
             * @param count Number of items to remove from the array.
             * @param item Item to add to the array.
             * @return An array containing the removed elements.
             */
            ObservableArray.prototype.splice = function (index, count, item) {
                var rv;
                if (count && item) {
                    rv = _super.prototype.splice.call(this, index, count, item);
                    if (count == 1) {
                        this._raiseCollectionChanged(collections.NotifyCollectionChangedAction.Change, item, index);
                    }
                    else {
                        this._raiseCollectionChanged();
                    }
                    return rv;
                }
                else if (item) {
                    rv = _super.prototype.splice.call(this, index, 0, item);
                    this._raiseCollectionChanged(collections.NotifyCollectionChangedAction.Add, item, index);
                    return rv;
                }
                else {
                    rv = _super.prototype.splice.call(this, index, count);
                    if (count == 1) {
                        this._raiseCollectionChanged(collections.NotifyCollectionChangedAction.Remove, rv[0], index);
                    }
                    else {
                        this._raiseCollectionChanged();
                    }
                    return rv;
                }
            };
            /**
             * Creates a shallow copy of a portion of an array.
             *
             * @param begin Position where the copy starts.
             * @param end Position where the copy ends.
             * @return A shallow copy of a portion of an array.
             */
            ObservableArray.prototype.slice = function (begin, end) {
                return _super.prototype.slice.call(this, begin, end);
            };
            /**
             * Searches for an item in the array.
             *
             * @param searchElement Element to locate in the array.
             * @param fromIndex The index where the search should start.
             * @return The index of the item in the array, or -1 if the item was not found.
             */
            ObservableArray.prototype.indexOf = function (searchElement, fromIndex) {
                return _super.prototype.indexOf.call(this, searchElement, fromIndex);
            };
            /**
             * Sorts the elements of the array in place.
             *
             * @param compareFn Specifies a function that defines the sort order.
             * If specified, the function should take two arguments and should return
             * -1, +1, or 0 to indicate the first argument is smaller, greater than,
             * or equal to the second argument.
             * If omitted, the array is sorted in dictionary order according to the
             * string conversion of each element.
             * @return A copy of the sorted array.
             */
            ObservableArray.prototype.sort = function (compareFn) {
                var rv = _super.prototype.sort.call(this, compareFn);
                this._raiseCollectionChanged();
                return rv;
            };
            /**
             * Inserts an item at a specific position in the array.
             *
             * @param index Position where the item will be added.
             * @param item Item to add to the array.
             */
            ObservableArray.prototype.insert = function (index, item) {
                this.splice(index, 0, item);
            };
            /**
             * Removes an item from the array.
             *
             * @param item Item to remove.
             * @return True if the item was removed, false if it wasn't found in the array.
             */
            ObservableArray.prototype.remove = function (item) {
                var index = this.indexOf(item);
                if (index > -1) {
                    this.removeAt(index);
                    return true;
                }
                return false;
            };
            /**
             * Removes an item at a specific position in the array.
             *
             * @param index Position of the item to remove.
             */
            ObservableArray.prototype.removeAt = function (index) {
                this.splice(index, 1);
            };
            /**
             * Assigns an item at a specific position in the array.
             *
             * @param index Position where the item will be assigned.
             * @param item Item to assign to the array.
             */
            ObservableArray.prototype.setAt = function (index, item) {
                // make sure we have enough elements to set at the right index!
                if (index > this.length) {
                    this.length = index;
                }
                // go ahead and splice now
                this.splice(index, 1, item);
            };
            /**
             * Removes all items from the array.
             */
            ObservableArray.prototype.clear = function () {
                if (this.length !== 0) {
                    this.splice(0, this.length); // safer than setting length = 0
                    //this.length = 0; // fastest way to clear an array
                    this._raiseCollectionChanged();
                }
            };
            /**
             * Suspends notifications until the next call to @see:endUpdate.
             */
            ObservableArray.prototype.beginUpdate = function () {
                this._updating++;
            };
            /**
             * Resumes notifications suspended by a call to @see:beginUpdate.
             */
            ObservableArray.prototype.endUpdate = function () {
                if (this._updating > 0) {
                    this._updating--;
                    if (this._updating == 0) {
                        this._raiseCollectionChanged();
                    }
                }
            };
            Object.defineProperty(ObservableArray.prototype, "isUpdating", {
                /**
                 * Gets a value that indicates whether notifications are currently suspended
                 * (see @see:beginUpdate and @see:endUpdate).
                 */
                get: function () {
                    return this._updating > 0;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Executes a function within a @see:beginUpdate/@see:endUpdate block.
             *
             * The collection will not be refreshed until the function finishes.
             * This method ensures @see:endUpdate is called even if the function throws
             * an exception.
             *
             * @param fn Function to be executed without updates.
             */
            ObservableArray.prototype.deferUpdate = function (fn) {
                try {
                    this.beginUpdate();
                    fn();
                }
                finally {
                    this.endUpdate();
                }
            };
            // ** IQueryInterface
            /**
             * Returns true if the caller queries for a supported interface.
             *
             * @param interfaceName Name of the interface to look for.
             * @return True if the caller queries for a supported interface.
             */
            ObservableArray.prototype.implementsInterface = function (interfaceName) {
                return interfaceName == 'INotifyCollectionChanged';
            };
            /**
             * Raises the @see:collectionChanged event.
             *
             * @param e Contains a description of the change.
             */
            ObservableArray.prototype.onCollectionChanged = function (e) {
                if (e === void 0) { e = collections.NotifyCollectionChangedEventArgs.reset; }
                if (!this.isUpdating) {
                    this.collectionChanged.raise(this, e);
                }
            };
            // creates event args and calls onCollectionChanged
            ObservableArray.prototype._raiseCollectionChanged = function (action, item, index) {
                if (action === void 0) { action = collections.NotifyCollectionChangedAction.Reset; }
                if (!this.isUpdating) {
                    var e = new collections.NotifyCollectionChangedEventArgs(action, item, index);
                    this.onCollectionChanged(e);
                }
            };
            return ObservableArray;
        }(ArrayBase));
        collections.ObservableArray = ObservableArray;
    })(collections = wijmo.collections || (wijmo.collections = {}));
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    var collections;
    (function (collections) {
        'use strict';
        /**
         * Class that implements the @see:ICollectionView interface to expose data in
         * regular JavaScript arrays.
         *
         * The @see:CollectionView class implements the following interfaces:
         * <ul>
         *   <li>@see:ICollectionView: provides current record management,
         *       custom sorting, filtering, and grouping.</li>
         *   <li>@see:IEditableCollectionView: provides methods for editing,
         *       adding, and removing items.</li>
         *   <li>@see:IPagedCollectionView: provides paging.</li>
         * </ul>
         *
         * To use the @see:CollectionView class, start by declaring it and passing a
         * regular array as a data source. Then configure the view using the
         * @see:filter, @see:sortDescriptions, @see:groupDescriptions, and
         * @see:pageSize properties. Finally, access the view using the @see:items
         * property. For example:
         *
         * <pre>// create a new CollectionView
         * var cv = new wijmo.collections.CollectionView(myArray);
         *
         * // sort items by amount in descending order
         * var sd = new wijmo.collections.SortDescription('amount', false);
         * cv.sortDescriptions.push(sd);
         *
         * // show only items with amounts greater than 100
         * cv.filter = function(item) { return item.amount &gt; 100 };
         *
         * // show the sorted, filtered result on the console
         * for (var i = 0; i &lt; cv.items.length; i++) {
         *   var item = cv.items[i];
         *   console.log(i + ': ' + item.name + ' ' + item.amount);
         * }</pre>
         */
        var CollectionView = /** @class */ (function () {
            /**
             * Initializes a new instance of the @see:CollectionView class.
             *
             * @param sourceCollection Array that serves as a source for this
             * @see:CollectionView.
             * @param options JavaScript object containing initialization data for the control.
             */
            function CollectionView(sourceCollection, options) {
                var _this = this;
                this._idx = -1;
                this._srtDsc = new collections.ObservableArray();
                this._grpDesc = new collections.ObservableArray();
                this._newItem = null;
                this._edtItem = null;
                this._pgSz = 0;
                this._pgIdx = 0;
                this._updating = 0;
                this._stableSort = false;
                this._canFilter = true;
                this._canGroup = true;
                this._canSort = true;
                this._canAddNew = true;
                this._canCancelEdit = true;
                this._canRemove = true;
                this._canChangePage = true;
                this._trackChanges = false;
                this._chgAdded = new collections.ObservableArray();
                this._chgRemoved = new collections.ObservableArray();
                this._chgEdited = new collections.ObservableArray();
                // ** INotifyCollectionChanged
                /**
                 * Occurs when the collection changes.
                 */
                this.collectionChanged = new wijmo.Event();
                /**
                 * Occurs before the value of the @see:sourceCollection property changes.
                 */
                this.sourceCollectionChanging = new wijmo.Event();
                /**
                 * Occurs after the value of the @see:sourceCollection property changes.
                 */
                this.sourceCollectionChanged = new wijmo.Event();
                /**
                 * Occurs after the current item changes.
                 */
                this.currentChanged = new wijmo.Event();
                /**
                 * Occurs before the current item changes.
                 */
                this.currentChanging = new wijmo.Event();
                /**
                * Occurs after the page index changes.
                */
                this.pageChanged = new wijmo.Event();
                /**
                 * Occurs before the page index changes.
                 */
                this.pageChanging = new wijmo.Event();
                // check that sortDescriptions contains SortDescriptions
                this._srtDsc.collectionChanged.addHandler(function () {
                    var arr = _this._srtDsc;
                    for (var i = 0; i < arr.length; i++) {
                        wijmo.assert(arr[i] instanceof collections.SortDescription, 'sortDescriptions array must contain SortDescription objects.');
                    }
                    if (_this.canSort) {
                        _this.refresh();
                    }
                });
                // check that groupDescriptions contains GroupDescriptions
                this._grpDesc.collectionChanged.addHandler(function () {
                    var arr = _this._grpDesc;
                    for (var i = 0; i < arr.length; i++) {
                        wijmo.assert(arr[i] instanceof collections.GroupDescription, 'groupDescriptions array must contain GroupDescription objects.');
                    }
                    if (_this.canGroup) {
                        _this.refresh();
                    }
                });
                // initialize the source collection
                this.sourceCollection = sourceCollection ? sourceCollection : new collections.ObservableArray();
                // apply options
                if (options) {
                    this.beginUpdate();
                    wijmo.copy(this, options);
                    this.endUpdate();
                }
            }
            // method used in JSON-style initialization
            CollectionView.prototype._copy = function (key, value) {
                if (key == 'sortDescriptions') {
                    this.sortDescriptions.clear();
                    var arr = wijmo.asArray(value);
                    for (var i = 0; i < arr.length; i++) {
                        var val = arr[i];
                        if (wijmo.isString(val)) {
                            val = new collections.SortDescription(val, true);
                        }
                        this.sortDescriptions.push(val);
                    }
                    return true;
                }
                if (key == 'groupDescriptions') {
                    this.groupDescriptions.clear();
                    var arr = wijmo.asArray(value);
                    for (var i = 0; i < arr.length; i++) {
                        var val = arr[i];
                        if (wijmo.isString(val)) {
                            val = new collections.PropertyGroupDescription(val);
                        }
                        this.groupDescriptions.push(val);
                    }
                    return true;
                }
                return false;
            };
            Object.defineProperty(CollectionView.prototype, "newItemCreator", {
                /**
                 * Gets or sets a function that creates new items for the collection.
                 *
                 * If the creator function is not supplied, the @see:CollectionView
                 * will try to create an uninitialized item of the appropriate type.
                 *
                 * If the creator function is supplied, it should be a function that
                 * takes no parameters and returns an initialized object of the proper
                 * type for the collection.
                 */
                get: function () {
                    return this._itemCreator;
                },
                set: function (value) {
                    this._itemCreator = wijmo.asFunction(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "sortConverter", {
                /**
                 * Gets or sets a function used to convert values when sorting.
                 *
                 * If provided, the function should take as parameters a
                 * @see:SortDescription, a data item, and a value to convert,
                 * and should return the converted value.
                 *
                 * This property provides a way to customize sorting. For example,
                 * the @see:FlexGrid control uses it to sort mapped columns by
                 * display value instead of by raw value.
                 *
                 * For example, the code below causes a @see:CollectionView to
                 * sort the 'country' property, which contains country code integers,
                 * using the corresponding country names:
                 *
                 * <pre>var countries = 'US,Germany,UK,Japan,Italy,Greece'.split(',');
                 * collectionView.sortConverter = function (sd, item, value) {
                 *   if (sd.property == 'countryMapped') {
                 *     value = countries[value]; // convert country id into name
                 *   }
                 *   return value;
                 * }</pre>
                 */
                get: function () {
                    return this._srtCvt;
                },
                set: function (value) {
                    if (value != this._srtCvt) {
                        this._srtCvt = wijmo.asFunction(value, true);
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "sortComparer", {
                /**
                 * Gets or sets a function used to compare values when sorting.
                 *
                 * If provided, the sort comparer function should take as parameters
                 * two values of any type, and should return -1, 0, or +1 to indicate
                 * whether the first value is smaller than, equal to, or greater than
                 * the second. If the sort comparer returns null, the standard built-in
                 * comparer is used.
                 *
                 * This @see:sortComparer property allows you to use custom comparison
                 * algorithms that in some cases result in sorting sequences that are
                 * more consistent with user's expectations than plain string comparisons.
                 *
                 * For example, see
                 * <a href="http://www.davekoelle.com/alphanum.html">Dave Koele's Alphanum algorithm</a>.
                 * It breaks up strings into chunks composed of strings or numbers, then
                 * sorts number chunks in value order and string chunks in ASCII order.
                 * Dave calls the result a "natural sorting order".
                 *
                 * The example below shows a typical use for the @see:sortComparer property:
                 * <pre>// create a CollectionView with a custom sort comparer
                 * var dataCustomSort = new wijmo.collections.CollectionView(data, {
                 *   sortComparer: function (a, b) {
                 *     return wijmo.isString(a) && wijmo.isString(b)
                 *       ? alphanum(a, b) // custom comparer used for strings
                 *       : null; // use default comparer used for everything else
                 *   }
                 * });</pre>
                 */
                get: function () {
                    return this._srtCmp;
                },
                set: function (value) {
                    if (value != this._srtCmp) {
                        this._srtCmp = wijmo.asFunction(value, true);
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "useStableSort", {
                /**
                 * Gets or sets whether to use a stable sort algorithm.
                 *
                 * Stable sorting algorithms maintain the relative order of records with equal keys.
                 * For example, consider a collection of objects with an "Amount" field.
                 * If you sort the collection by "Amount", a stable sort will keep the original
                 * order of records with the same Amount value.
                 *
                 * This property is false by default, which causes the @see:CollectionView to use
                 * JavaScript's built-in sort method, which is very fast but not stable. Setting
                 * the @see:useStableSort property to true increases sort times by 30% to 50%, which
                 * can be significant for large collections.
                 */
                get: function () {
                    return this._stableSort;
                },
                set: function (value) {
                    this._stableSort = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Calculates an aggregate value for the items in this collection.
             *
             * @param aggType Type of aggregate to calculate.
             * @param binding Property to aggregate on.
             * @param currentPage Whether to include only items on the current page.
             * @return The aggregate value.
             */
            CollectionView.prototype.getAggregate = function (aggType, binding, currentPage) {
                var items = currentPage ? this._pgView : this._view;
                return wijmo.getAggregate(aggType, items, binding);
            };
            Object.defineProperty(CollectionView.prototype, "trackChanges", {
                /**
                 * Gets or sets a value that determines whether the control should
                 * track changes to the data.
                 *
                 * If @see:trackChanges is set to true, the @see:CollectionView keeps
                 * track of changes to the data and exposes them through the
                 * @see:itemsAdded, @see:itemsRemoved, and @see:itemsEdited collections.
                 *
                 * Tracking changes is useful in situations where you need to update
                 * the server after the user has confirmed that the modifications are
                 * valid.
                 *
                 * After committing or cancelling changes, use the @see:clearChanges method
                 * to clear the @see:itemsAdded, @see:itemsRemoved, and @see:itemsEdited
                 * collections.
                 *
                 * The @see:CollectionView only tracks changes made when the proper
                 * @see:CollectionView methods are used (@see:editItem/@see:commitEdit,
                 * @see:addNew/@see:commitNew, and @see:remove).
                 * Changes made directly to the data are not tracked.
                 */
                get: function () {
                    return this._trackChanges;
                },
                set: function (value) {
                    this._trackChanges = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "itemsAdded", {
                /**
                 * Gets an @see:ObservableArray containing the records that were added to
                 * the collection since @see:trackChanges was enabled.
                 */
                get: function () {
                    return this._chgAdded;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "itemsRemoved", {
                /**
                 * Gets an @see:ObservableArray containing the records that were removed from
                 * the collection since @see:trackChanges was enabled.
                 */
                get: function () {
                    return this._chgRemoved;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "itemsEdited", {
                /**
                 * Gets an @see:ObservableArray containing the records that were edited in
                 * the collection since @see:trackChanges was enabled.
                 */
                get: function () {
                    return this._chgEdited;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Clears all changes by removing all items in the @see:itemsAdded,
             * @see:itemsRemoved, and @see:itemsEdited collections.
             *
             * Call this method after committing changes to the server or
             * after refreshing the data from the server.
             */
            CollectionView.prototype.clearChanges = function () {
                this._chgAdded.clear();
                this._chgRemoved.clear();
                this._chgEdited.clear();
            };
            // ** IQueryInterface
            /**
             * Returns true if the caller queries for a supported interface.
             *
             * @param interfaceName Name of the interface to look for.
             */
            CollectionView.prototype.implementsInterface = function (interfaceName) {
                switch (interfaceName) {
                    case 'ICollectionView':
                    case 'IEditableCollectionView':
                    case 'IPagedCollectionView':
                    case 'INotifyCollectionChanged':
                        return true;
                }
                return false;
            };
            Object.defineProperty(CollectionView.prototype, "getError", {
                // ** INotifyDataErrorInfo
                /**
                 * Gets or sets a callback that determines whether a specific property
                 * of an item contains validation errors.
                 *
                 * If provided, the callback should take two parameters containing the
                 * item and the property to validate, and should return a string describing
                 * the error (or null if there are no errors).
                 *
                 * For example:
                 *
                 * <pre>var view = new wijmo.collections.CollectionView(data, {
                 *     getError: function (item, property) {
                 *         switch (property) {
                 *             case 'country':
                 *                 return countries.indexOf(item.country) &lt; 0
                 *                     ? 'Invalid Country'
                 *                     : null;
                 *             case 'downloads':
                 *             case 'sales':
                 *             case 'expenses':
                 *                 return item[property] &lt; 0
                 *                     ? 'Cannot be negative!'
                 *                     : null;
                 *             case 'active':
                 *                 return item.active && item.country.match(/US|UK/)
                 *                     ? 'No active items allowed in the US or UK!'
                 *                     : null;
                 *         }
                 *         return null;
                 *     }
                 * });</pre>
                 */
                get: function () {
                    return this._getError;
                },
                set: function (value) {
                    this._getError = wijmo.asFunction(value);
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Raises the @see:collectionChanged event.
             *
             * @param e Contains a description of the change.
             */
            CollectionView.prototype.onCollectionChanged = function (e) {
                if (e === void 0) { e = collections.NotifyCollectionChangedEventArgs.reset; }
                // track changes applied to items outside of edit/add/commitEdit blocks (TFS 204805, 264395)
                if (e.action == collections.NotifyCollectionChangedAction.Change &&
                    !this._committing && !this._canceling &&
                    e.item != this.currentEditItem &&
                    e.item != this.currentAddItem) {
                    this._trackItemChanged(e.item);
                }
                // raise the event as usual
                this.collectionChanged.raise(this, e);
            };
            // creates event args and calls onCollectionChanged
            CollectionView.prototype._raiseCollectionChanged = function (action, item, index) {
                if (action === void 0) { action = collections.NotifyCollectionChangedAction.Reset; }
                //console.log('** collection changed: ' + NotifyCollectionChangedAction[action] + ' **');
                var e = new collections.NotifyCollectionChangedEventArgs(action, item, index);
                this.onCollectionChanged(e);
            };
            // notify of changes to an item
            CollectionView.prototype._notifyItemChanged = function (item) {
                var e = new collections.NotifyCollectionChangedEventArgs(collections.NotifyCollectionChangedAction.Change, item, this.items.indexOf(item));
                this.onCollectionChanged(e);
            };
            /**
             * Raises the @see:sourceCollectionChanging event.
             *
             * @param e @see:CancelEventArgs that contains the event data.
             */
            CollectionView.prototype.onSourceCollectionChanging = function (e) {
                this.sourceCollectionChanging.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:sourceCollectionChanged event.
             */
            CollectionView.prototype.onSourceCollectionChanged = function (e) {
                this.sourceCollectionChanged.raise(this, e);
            };
            Object.defineProperty(CollectionView.prototype, "canFilter", {
                // ** ICollectionView
                /**
                 * Gets a value that indicates whether this view supports filtering via the
                 * @see:filter property.
                 */
                get: function () {
                    return this._canFilter;
                },
                set: function (value) {
                    this._canFilter = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "canGroup", {
                /**
                 * Gets a value that indicates whether this view supports grouping via the
                 * @see:groupDescriptions property.
                 */
                get: function () {
                    return this._canGroup;
                },
                set: function (value) {
                    this._canGroup = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "canSort", {
                /**
                 * Gets a value that indicates whether this view supports sorting via the
                 * @see:sortDescriptions property.
                 */
                get: function () {
                    return this._canSort;
                },
                set: function (value) {
                    this._canSort = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "currentItem", {
                /**
                 * Gets or sets the current item in the view.
                 */
                get: function () {
                    return this._pgView && this._idx > -1 && this._idx < this._pgView.length
                        ? this._pgView[this._idx]
                        : null;
                },
                set: function (value) {
                    this.moveCurrentTo(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "currentPosition", {
                /**
                 * Gets the ordinal position of the current item in the view.
                 */
                get: function () {
                    return this._idx;
                },
                set: function (value) {
                    this.moveCurrentToPosition(wijmo.asNumber(value));
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "filter", {
                /**
                 * Gets or sets a callback used to determine if an item is suitable for
                 * inclusion in the view.
                 *
                 * The callback function should return true if the item passed in as a
                 * parameter should be included in the view.
                 *
                 * NOTE: If the filter function needs a scope (i.e. a meaningful 'this'
                 * value) remember to set the filter using the 'bind' function to specify
                 * the 'this' object. For example:
                 * <pre>
                 *   collectionView.filter = this._filter.bind(this);
                 * </pre>
                 */
                get: function () {
                    return this._filter;
                },
                set: function (value) {
                    if (this._filter != value) {
                        this._filter = wijmo.asFunction(value);
                        if (this.canFilter) {
                            this.refresh();
                        }
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "groupDescriptions", {
                /**
                 * Gets a collection of @see:GroupDescription objects that describe how the
                 * items in the collection are grouped in the view.
                 */
                get: function () {
                    return this._grpDesc;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "groups", {
                /**
                 * Gets an array of @see:CollectionViewGroup objects that represents the
                 * top-level groups.
                 */
                get: function () {
                    return this._groups;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "isEmpty", {
                /**
                 * Gets a value that indicates whether this view contains no items.
                 */
                get: function () {
                    return !this._pgView || !this._pgView.length;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "sortDescriptions", {
                /**
                 * Gets an array of @see:SortDescription objects that describe how the items
                 * in the collection are sorted in the view.
                 */
                get: function () {
                    return this._srtDsc;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "sourceCollection", {
                /**
                 * Gets or sets the underlying (unfiltered and unsorted) collection.
                 */
                get: function () {
                    return this._src;
                },
                set: function (sourceCollection) {
                    if (sourceCollection != this._src) {
                        // raise changing event
                        if (!this.onSourceCollectionChanging(new wijmo.CancelEventArgs())) {
                            return;
                        }
                        // keep track of current index
                        var index = this.currentPosition;
                        // commit pending changes
                        this.commitEdit();
                        this.commitNew();
                        // disconnect old source
                        if (this._ncc != null) {
                            this._ncc.collectionChanged.removeHandler(this._sourceChanged);
                        }
                        // connect new source
                        this._src = wijmo.asArray(sourceCollection, false);
                        this._ncc = wijmo.tryCast(this._src, 'INotifyCollectionChanged');
                        if (this._ncc) {
                            this._ncc.collectionChanged.addHandler(this._sourceChanged, this);
                        }
                        // clear any changes
                        this.clearChanges();
                        // refresh view
                        this.refresh();
                        this.moveCurrentToFirst();
                        // raise changed event
                        this.onSourceCollectionChanged();
                        // if we have no items, notify listeners that the current index changed
                        if (this.currentPosition < 0 && index > -1) {
                            this.onCurrentChanged();
                        }
                    }
                },
                enumerable: true,
                configurable: true
            });
            // handle notifications from the source collection
            CollectionView.prototype._sourceChanged = function (s, e) {
                if (this._updating <= 0) {
                    this.refresh(); // TODO: optimize
                }
            };
            /**
             * Returns a value indicating whether a given item belongs to this view.
             *
             * @param item Item to seek.
             */
            CollectionView.prototype.contains = function (item) {
                return this._pgView.indexOf(item) > -1;
            };
            /**
             * Sets the specified item to be the current item in the view.
             *
             * @param item Item that will become current.
             */
            CollectionView.prototype.moveCurrentTo = function (item) {
                return this.moveCurrentToPosition(this._pgView.indexOf(item));
            };
            /**
             * Sets the first item in the view as the current item.
             */
            CollectionView.prototype.moveCurrentToFirst = function () {
                return this.moveCurrentToPosition(0);
            };
            /**
             * Sets the last item in the view as the current item.
             */
            CollectionView.prototype.moveCurrentToLast = function () {
                return this.moveCurrentToPosition(this._pgView.length - 1);
            };
            /**
             * Sets the item before the current item in the view as the current item.
             */
            CollectionView.prototype.moveCurrentToPrevious = function () {
                return this._idx > 0 ? this.moveCurrentToPosition(this._idx - 1) : false;
            };
            /**
             * Sets the item after the current item in the view as the current item.
             */
            CollectionView.prototype.moveCurrentToNext = function () {
                return this.moveCurrentToPosition(this._idx + 1);
            };
            /**
             * Sets the item at the specified index in the view as the current item.
             *
             * @param index Index of the item that will become current.
             */
            CollectionView.prototype.moveCurrentToPosition = function (index) {
                if (index >= -1 && index < this._pgView.length && index != this._idx) {
                    var e = new wijmo.CancelEventArgs();
                    if (this.onCurrentChanging(e)) {
                        // when moving away from current edit/new item, commit
                        var item = this._pgView[index];
                        if (this._edtItem && item != this._edtItem) {
                            this.commitEdit();
                        }
                        if (this._newItem && item != this._newItem) {
                            this.commitNew();
                        }
                        // update currency
                        this._idx = index;
                        this.onCurrentChanged();
                    }
                }
                return this._idx == index;
            };
            /**
             * Re-creates the view using the current sort, filter, and group parameters.
             */
            CollectionView.prototype.refresh = function () {
                // not while updating, adding, or editing
                if (this._updating > 0 || this._newItem || this._edtItem) {
                    return;
                }
                // perform the refresh
                this._performRefresh();
                // notify listeners
                this.onCollectionChanged();
            };
            // performs the refresh (without issuing notifications)
            CollectionView.prototype._performRefresh = function () {
                // not while updating...
                if (this._updating > 0) {
                    return;
                }
                // benchmark
                //let start = new Date();
                // save current item
                var current = this.currentItem;
                // apply filter
                this._view = this._src
                    ? this._performFilter(this._src)
                    : [];
                // apply sort
                if (this.canSort && this._srtDsc.length > 0) {
                    if (this._view == this._src) {
                        this._view = this._src.slice();
                    }
                    this._performSort(this._view);
                }
                // apply grouping
                this._groups = this.canGroup ? this._createGroups(this._view) : null;
                this._fullGroups = this._groups;
                if (this._groups) {
                    this._view = this._mergeGroupItems(this._groups);
                }
                // apply paging
                this._pgIdx = wijmo.clamp(this._pgIdx, 0, this.pageCount - 1);
                this._pgView = this._getPageView();
                // update groups to take paging into account
                if (this._groups && this.pageCount > 1) {
                    this._groups = this._createGroups(this._pgView);
                    this._mergeGroupItems(this._groups);
                }
                // restore current item
                var index = this._pgView.indexOf(current);
                if (index < 0) {
                    index = Math.min(this._idx, this._pgView.length - 1);
                }
                this._idx = index;
                // save group digest to optimize updates (TFS 109119)
                this._digest = this._getGroupsDigest(this.groups);
                // raise currentChanged if needed
                if (this.currentItem !== current) {
                    this.onCurrentChanged();
                }
                //let now = new Date();
                //console.log('refreshed in ' + (now.getTime() - start.getTime()) / 1000 + ' seconds');
            };
            // sorts an array in-place using the current sort descriptions
            CollectionView.prototype._performSort = function (items) {
                if (this._stableSort) {
                    // stable sort (nice, but 30-50% slower)
                    // https://bugs.chromium.org/p/v8/issues/detail?id=90
                    var arrIndexed = items.map(function (item, index) { return { item: item, index: index }; }), compare_1 = this._compareItems();
                    arrIndexed.sort(function (a, b) {
                        var r = compare_1(a.item, b.item);
                        return r == 0 ? a.index - b.index : r;
                    });
                    for (var i = 0; i < items.length; i++) {
                        items[i] = arrIndexed[i].item;
                    }
                }
                else {
                    // regular sort, not stable but very fast
                    items.sort(this._compareItems());
                }
            };
            // this function is used in some of our samples, so
            // if we remove it or change its name some things will break...
            CollectionView.prototype._compareItems = function () {
                var srtDsc = this._srtDsc, srtCvt = this._srtCvt, srtCmp = this._srtCmp, init = true, cmp = 0;
                return function (a, b) {
                    for (var i = 0; i < srtDsc.length; i++) {
                        // get values
                        var sd = srtDsc[i], v1 = sd._bnd.getValue(a), v2 = sd._bnd.getValue(b);
                        // custom converter function (before changing case! TFS 149638)
                        if (srtCvt) {
                            v1 = srtCvt(sd, a, v1, init);
                            v2 = srtCvt(sd, b, v2, false);
                            init = false;
                        }
                        // custom comparison function (TFS 151665)
                        if (srtCmp) {
                            cmp = srtCmp(v1, v2);
                            if (cmp != null) {
                                return sd.ascending ? +cmp : -cmp;
                            }
                        }
                        // check for NaN (isNaN returns true for NaN but also for non-numbers)
                        if (v1 !== v1)
                            v1 = null;
                        if (v2 !== v2)
                            v2 = null;
                        // ignore case when sorting unless the values are strings that only differ in case
                        // (to keep the sort consistent, TFS 131135)
                        if (typeof (v1) === 'string' && typeof (v2) === 'string') {
                            var lc1 = v1.toLowerCase(), lc2 = v2.toLowerCase();
                            if (lc1 != lc2) {
                                v1 = lc1;
                                v2 = lc2;
                            }
                        }
                        // nulls always at the bottom (like excel)
                        if (v1 != null && v2 == null)
                            return -1;
                        if (v1 == null && v2 != null)
                            return +1;
                        // compare the values (at last!)
                        cmp = (v1 < v2) ? -1 : (v1 > v2) ? +1 : 0;
                        if (cmp != 0) {
                            return sd.ascending ? +cmp : -cmp;
                        }
                    }
                    return 0;
                };
            };
            // returns an array filtered using the current filter definition
            CollectionView.prototype._performFilter = function (items) {
                return this.canFilter && this._filter
                    ? items.filter(this._filter, this)
                    : items;
            };
            /**
             * Raises the @see:currentChanged event.
             */
            CollectionView.prototype.onCurrentChanged = function (e) {
                if (e === void 0) { e = wijmo.EventArgs.empty; }
                this.currentChanged.raise(this, e);
            };
            /**
             * Raises the @see:currentChanging event.
             *
             * @param e @see:CancelEventArgs that contains the event data.
             */
            CollectionView.prototype.onCurrentChanging = function (e) {
                this.currentChanging.raise(this, e);
                return !e.cancel;
            };
            Object.defineProperty(CollectionView.prototype, "items", {
                /**
                 * Gets items in the view.
                 */
                get: function () {
                    return this._pgView;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Suspend refreshes until the next call to @see:endUpdate.
             */
            CollectionView.prototype.beginUpdate = function () {
                this._updating++;
            };
            /**
             * Resume refreshes suspended by a call to @see:beginUpdate.
             */
            CollectionView.prototype.endUpdate = function () {
                this._updating--;
                if (this._updating <= 0) {
                    this.refresh();
                }
            };
            Object.defineProperty(CollectionView.prototype, "isUpdating", {
                /**
                 * Gets a value that indicates whether notifications are currently suspended
                 * (see @see:beginUpdate and @see:endUpdate).
                 */
                get: function () {
                    return this._updating > 0;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Executes a function within a @see:beginUpdate/@see:endUpdate block.
             *
             * The collection will not be refreshed until the function finishes.
             * This method ensures @see:endUpdate is called even if the function throws
             * an exception.
             *
             * @param fn Function to be executed without updates.
             */
            CollectionView.prototype.deferUpdate = function (fn) {
                try {
                    this.beginUpdate();
                    fn();
                }
                finally {
                    this.endUpdate();
                }
            };
            Object.defineProperty(CollectionView.prototype, "canAddNew", {
                // ** IEditableCollectionView
                /**
                 * Gets a value that indicates whether a new item can be added to the collection.
                 */
                get: function () {
                    return this._canAddNew;
                },
                set: function (value) {
                    this._canAddNew = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "canCancelEdit", {
                /**
                 * Gets a value that indicates whether the collection view can discard pending changes
                 * and restore the original values of an edited object.
                 */
                get: function () {
                    return this._canCancelEdit;
                },
                set: function (value) {
                    this._canCancelEdit = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "canRemove", {
                /**
                 * Gets a value that indicates whether items can be removed from the collection.
                 */
                get: function () {
                    return this._canRemove;
                },
                set: function (value) {
                    this._canRemove = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "currentAddItem", {
                /**
                 * Gets the item that is being added during the current add transaction.
                 */
                get: function () {
                    return this._newItem;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "currentEditItem", {
                /**
                 * Gets the item that is being edited during the current edit transaction.
                 */
                get: function () {
                    return this._edtItem;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "isAddingNew", {
                /**
                 * Gets a value that indicates whether an add transaction is in progress.
                 */
                get: function () {
                    return this._newItem != null;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "isEditingItem", {
                /**
                 * Gets a value that indicates whether an edit transaction is in progress.
                 */
                get: function () {
                    return this._edtItem != null;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Begins an edit transaction of the specified item.
             *
             * @param item Item to be edited.
             */
            CollectionView.prototype.editItem = function (item) {
                // commit pending changes if not already editing/adding this item
                if (item != this._edtItem && this.moveCurrentTo(item)) {
                    this.commitEdit();
                    this._edtItem = item;
                    this._edtClone = {};
                    this._extend(this._edtClone, this._edtItem);
                }
            };
            /**
             * Ends the current edit transaction and saves the pending changes.
             */
            CollectionView.prototype.commitEdit = function () {
                var item = this._edtItem;
                if (item != null) {
                    // start committing
                    this._committing = true;
                    // check if anything really changed
                    var sameContent = this._sameContent(item, this._edtClone);
                    // clean up state
                    this._edtItem = null;
                    this._edtClone = null;
                    // refresh to update the edited item
                    var index = this._pgView.indexOf(item), digest = this._digest;
                    this._performRefresh();
                    // track changes (before notifying)
                    if (!sameContent) {
                        this._trackItemChanged(item);
                    }
                    // notify (single item change or full refresh)
                    if (this._pgView.indexOf(item) == index && digest == this._digest) {
                        this._raiseCollectionChanged(collections.NotifyCollectionChangedAction.Change, item, index);
                    }
                    else {
                        this._raiseCollectionChanged(); // full refresh
                    }
                    // done committing
                    this._committing = false;
                }
            };
            /**
             * Ends the current edit transaction and, if possible,
             * restores the original value to the item.
             */
            CollectionView.prototype.cancelEdit = function () {
                var item = this._edtItem;
                if (item != null) {
                    this._edtItem = null;
                    // honor canCancelEdit
                    if (!this.canCancelEdit) {
                        wijmo.assert(false, 'cannot cancel edits (canCancelEdit == false).');
                        return;
                    }
                    // check that we can do this (TFS 110168)
                    var index = this._src.indexOf(item);
                    if (index < 0 || !this._edtClone) {
                        return;
                    }
                    // restore original item value
                    this._extend(this._src[index], this._edtClone);
                    this._edtClone = null;
                    // notify listeners
                    this._canceling = true;
                    this._raiseCollectionChanged(collections.NotifyCollectionChangedAction.Change, item, index);
                    this._canceling = false;
                }
            };
            /**
             * Creates a new item and adds it to the collection.
             *
             * This method takes no parameters. It creates a new item, adds it to the
             * collection, and defers refresh operations until the new item is
             * committed using the @see:commitNew method or canceled using the
             * @see:cancelNew method.
             *
             * The code below shows how the @see:addNew method is typically used:
             *
             * <pre>
             * // create the new item, add it to the collection
             * var newItem = view.addNew();
             * // initialize the new item
             * newItem.id = getFreshId();
             * newItem.name = 'New Customer';
             * // commit the new item so the view can be refreshed
             * view.commitNew();
             * </pre>
             *
             * You can also add new items by pushing them into the @see:sourceCollection
             * and then calling the @see:refresh method. The main advantage of @see:addNew
             * is in user-interactive scenarios (like adding new items in a data grid),
             * because it gives users the ability to cancel the add operation. It also
             * prevents the new item from being sorted or filtered out of view until the
             * add operation is committed.
             *
             * @return The item that was added to the collection.
             */
            CollectionView.prototype.addNew = function () {
                // sanity
                if (arguments.length > 0) {
                    wijmo.assert(false, 'addNew does not take any parameters, it creates the new items.');
                }
                // commit pending changes
                this.commitEdit();
                this.commitNew();
                // honor canAddNew
                if (!this.canAddNew) {
                    wijmo.assert(false, 'cannot add items (canAddNew == false).');
                    return null;
                }
                // create new item
                var item = null, src = this.sourceCollection;
                if (this.newItemCreator) {
                    item = this.newItemCreator();
                }
                else if (src && src.length) {
                    item = new src[0].constructor();
                }
                else {
                    item = {};
                }
                if (item != null) {
                    // remember the new item
                    this._newItem = item;
                    // add the new item to the collection
                    this._updating++;
                    this._src.push(item); // **
                    this._updating--;
                    // add the new item to the bottom of the current view
                    if (this._pgView != this._src) {
                        this._pgView.push(item);
                    }
                    // add the new item to the last group and to the data items
                    if (this.groups && this.groups.length) {
                        var g = this.groups[this.groups.length - 1];
                        g.items.push(item);
                        while (g.groups && g.groups.length) {
                            g = g.groups[g.groups.length - 1];
                            g.items.push(item);
                        }
                    }
                    // notify listeners
                    this._raiseCollectionChanged(collections.NotifyCollectionChangedAction.Add, item, this._pgView.length - 1);
                    // select the new item
                    this.moveCurrentTo(item);
                }
                // done
                return this._newItem;
            };
            /**
             * Ends the current add transaction and saves the pending new item.
             */
            CollectionView.prototype.commitNew = function () {
                var item = this._newItem;
                if (item != null) {
                    // clean up state
                    this._newItem = null;
                    // refresh to update the new item
                    var index = this._pgView.indexOf(item), digest = this._digest;
                    this._performRefresh();
                    // track changes (before notifying)
                    if (this._trackChanges) {
                        var idx = this._chgEdited.indexOf(item);
                        if (idx > -1) {
                            this._chgEdited.removeAt(idx);
                        }
                        if (this._chgAdded.indexOf(item) < 0) {
                            this._chgAdded.push(item);
                        }
                    }
                    // notify (full refresh if the item moved)
                    if (this._pgView.indexOf(item) == index && digest == this._digest) {
                        this._raiseCollectionChanged(collections.NotifyCollectionChangedAction.Change, item, index);
                    }
                    else {
                        this._raiseCollectionChanged(); // full refresh
                    }
                }
            };
            /**
             * Ends the current add transaction and discards the pending new item.
             */
            CollectionView.prototype.cancelNew = function () {
                var item = this._newItem;
                if (item != null) {
                    this.remove(item);
                }
            };
            /**
             * Removes the specified item from the collection.
             *
             * @param item Item to be removed from the collection.
             */
            CollectionView.prototype.remove = function (item) {
                // handle cases where the user is adding or editing items
                var pendingNew = (item == this._newItem);
                if (pendingNew) {
                    this._newItem = null;
                }
                if (item == this._edtItem) {
                    this.cancelEdit();
                }
                // honor canRemove
                if (!this.canRemove) {
                    wijmo.assert(false, 'cannot remove items (canRemove == false).');
                    return;
                }
                // find item
                var index = this._src.indexOf(item);
                if (index > -1) {
                    // get current item to notify later
                    var current = this.currentItem;
                    // remove item from source collection
                    this._updating++;
                    this._src.splice(index, 1); // **
                    this._updating--;
                    // refresh to update the removed item
                    //let index = this._pgView.indexOf(item);
                    var digest = this._digest;
                    this._performRefresh();
                    // track changes (before notifying)
                    if (this._trackChanges) {
                        // removing something that was added
                        var idxAdded = this._chgAdded.indexOf(item);
                        if (idxAdded > -1) {
                            this._chgAdded.removeAt(idxAdded);
                        }
                        // removing something that was edited
                        var idxEdited = this._chgEdited.indexOf(item);
                        if (idxEdited > -1) {
                            this._chgEdited.removeAt(idxEdited);
                        }
                        // add to removed list unless it was pending and not added in this session
                        var idxRemoved = this._chgRemoved.indexOf(item);
                        if (idxRemoved < 0 && !pendingNew && idxAdded < 0) {
                            this._chgRemoved.push(item);
                        }
                    }
                    // notify (item removed or full refresh) (TFS 85001)
                    var sorted = this.sortDescriptions.length > 0, // JavaScript sort is not stable...
                    paged = this.pageSize > 0 && this._pgIdx > -1;
                    if (sorted || paged || digest != this._getGroupsDigest(this.groups)) {
                        this._raiseCollectionChanged();
                    }
                    else {
                        this._raiseCollectionChanged(collections.NotifyCollectionChangedAction.Remove, item, index);
                    }
                    // raise currentChanged if needed
                    if (this.currentItem !== current) {
                        this.onCurrentChanged();
                    }
                }
            };
            /**
             * Removes the item at the specified index from the collection.
             *
             * @param index Index of the item to be removed from the collection.
             * The index is relative to the view, not to the source collection.
             */
            CollectionView.prototype.removeAt = function (index) {
                index = wijmo.asInt(index);
                this.remove(this._pgView[index]);
            };
            // track changes applied to an item (not necessarily the current edit item)
            CollectionView.prototype._trackItemChanged = function (item) {
                if (this._trackChanges) {
                    // make sure the item is in the collection
                    var items = this.sourceCollection; // TFS 256563
                    if (items && items.indexOf(item) > -1) {
                        var idx = this._chgEdited.indexOf(item), chg = collections.NotifyCollectionChangedAction.Change;
                        if (idx < 0 && this._chgAdded.indexOf(item) < 0) {
                            this._chgEdited.push(item);
                        }
                        else if (idx > -1) {
                            var e = new collections.NotifyCollectionChangedEventArgs(chg, item, idx);
                            this._chgEdited.onCollectionChanged(e);
                        }
                        else {
                            idx = this._chgAdded.indexOf(item);
                            if (idx > -1) {
                                var e = new collections.NotifyCollectionChangedEventArgs(chg, item, idx);
                                this._chgAdded.onCollectionChanged(e);
                            }
                        }
                    }
                }
            };
            // extends an object (shallow copy)
            CollectionView.prototype._extend = function (dst, src) {
                for (var key in src) {
                    dst[key] = src[key];
                }
            };
            // checks whether two objects have the same content
            CollectionView.prototype._sameContent = function (dst, src) {
                for (var key in src) {
                    if (!this._sameValue(dst[key], src[key])) {
                        return false;
                    }
                }
                for (var key in dst) {
                    if (!this._sameValue(dst[key], src[key])) {
                        return false;
                    }
                }
                return true;
            };
            // checks whether two values are the same
            CollectionView.prototype._sameValue = function (v1, v2) {
                return v1 === v2 || wijmo.DateTime.equals(v1, v2);
            };
            Object.defineProperty(CollectionView.prototype, "canChangePage", {
                // ** IPagedCollectionView
                /**
                 * Gets a value that indicates whether the @see:pageIndex value can change.
                 */
                get: function () {
                    return this._canChangePage;
                },
                set: function (value) {
                    this._canChangePage = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "isPageChanging", {
                /**
                 * Gets a value that indicates whether the page index is changing.
                 */
                get: function () {
                    return false;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "itemCount", {
                /**
                 * Gets the total number of items in the view taking paging into account.
                 */
                get: function () {
                    return this._pgView.length;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "pageIndex", {
                /**
                 * Gets the zero-based index of the current page.
                 */
                get: function () {
                    return this._pgIdx;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "pageSize", {
                /**
                 * Gets or sets the number of items to display on a page.
                 */
                get: function () {
                    return this._pgSz;
                },
                set: function (value) {
                    if (value != this._pgSz) {
                        this._pgSz = wijmo.asInt(value);
                        this.refresh();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "totalItemCount", {
                /**
                 * Gets the total number of items in the view before paging is applied.
                 */
                get: function () {
                    return this._view.length;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionView.prototype, "pageCount", {
                /**
                 * Gets the total number of pages.
                 */
                get: function () {
                    return this.pageSize ? Math.ceil(this.totalItemCount / this.pageSize) : 1;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Sets the first page as the current page.
             *
             * @return True if the page index was changed successfully.
             */
            CollectionView.prototype.moveToFirstPage = function () {
                return this.moveToPage(0);
            };
            /**
             * Sets the last page as the current page.
             *
             * @return True if the page index was changed successfully.
             */
            CollectionView.prototype.moveToLastPage = function () {
                return this.moveToPage(this.pageCount - 1);
            };
            /**
             * Moves to the page before the current page.
             *
             * @return True if the page index was changed successfully.
             */
            CollectionView.prototype.moveToPreviousPage = function () {
                return this.moveToPage(this.pageIndex - 1);
            };
            /**
             * Moves to the page after the current page.
             *
             * @return True if the page index was changed successfully.
             */
            CollectionView.prototype.moveToNextPage = function () {
                return this.moveToPage(this.pageIndex + 1);
            };
            /**
             * Moves to the page at the specified index.
             *
             * @param index Index of the page to move to.
             * @return True if the page index was changed successfully.
             */
            CollectionView.prototype.moveToPage = function (index) {
                var newIndex = wijmo.clamp(index, 0, this.pageCount - 1);
                if (newIndex != this._pgIdx) {
                    // honor canChangePage
                    if (!this.canChangePage) {
                        wijmo.assert(false, 'cannot change pages (canChangePage == false).');
                    }
                    // raise pageChanging
                    var e = new collections.PageChangingEventArgs(newIndex);
                    if (this.onPageChanging(e)) {
                        // change the page
                        this._pgIdx = newIndex;
                        this._pgView = this._getPageView();
                        this._idx = 0;
                        // raise collectionChanged, or refresh if grouping
                        if (!this.groupDescriptions || this.groupDescriptions.length == 0) {
                            this.onCollectionChanged();
                        }
                        else {
                            this.refresh();
                        }
                        // raise pageChanged
                        this.onPageChanged();
                    }
                }
                return this._pgIdx == index;
            };
            /**
             * Raises the @see:pageChanged event.
             */
            CollectionView.prototype.onPageChanged = function (e) {
                if (e === void 0) { e = wijmo.EventArgs.empty; }
                this.pageChanged.raise(this, e);
            };
            /**
             * Raises the @see:pageChanging event.
             *
             * @param e @see:PageChangingEventArgs that contains the event data.
             */
            CollectionView.prototype.onPageChanging = function (e) {
                this.pageChanging.raise(this, e);
                return !e.cancel;
            };
            // gets the full group that corresponds to a paged group view
            CollectionView.prototype._getFullGroup = function (g) {
                // look for the group by level and name
                // this gets the full (unpaged) and updated group (TFS 109119)
                var fg = this._getGroupByPath(this._fullGroups, g.level, g._path);
                if (fg != null) {
                    g = fg;
                }
                // return the group
                return g;
            };
            // gets a group from a collection by path
            CollectionView.prototype._getGroupByPath = function (groups, level, path) {
                for (var i = 0; i < groups.length; i++) {
                    var g = groups[i];
                    if (g.level == level && g._path == path) {
                        return g;
                    }
                    if (g.level < level && path.indexOf(g._path) == 0) {
                        g = this._getGroupByPath(g.groups, level, path);
                        if (g != null) {
                            return g;
                        }
                    }
                }
                return null;
            };
            // gets the list that corresponds to the current page
            CollectionView.prototype._getPageView = function () {
                // not paging? return the whole view
                if (this.pageSize <= 0 || this._pgIdx < 0) {
                    return this._view;
                }
                // slice the current page out of the view
                var start = this._pgSz * this._pgIdx, end = Math.min(start + this._pgSz, this._view.length);
                return this._view.slice(start, end);
            };
            // creates a grouped view of the current page
            CollectionView.prototype._createGroups = function (items) {
                // not grouping? return null
                if (!this._grpDesc || !this._grpDesc.length) {
                    return null;
                }
                // build group tree
                var root = [], maps = {}, map = null;
                for (var i = 0; i < items.length; i++) {
                    // get the item
                    var item = items[i], groups = root, levels = this._grpDesc.length;
                    // add this item to the tree
                    var path = '';
                    for (var level = 0; level < levels; level++) {
                        // get the group name for this level
                        var gd = this._grpDesc[level], name_1 = gd.groupNameFromItem(item, level), last = level == levels - 1;
                        // get the group map for this level (optimization)
                        map = maps[path];
                        if (!map && wijmo.isPrimitive(name_1)) {
                            map = {};
                            maps[path] = map;
                        }
                        // get or create the group
                        var group = this._getGroup(gd, groups, map, name_1, level, last);
                        // keep group path (all names in the hierarchy)
                        path += '/' + name_1;
                        group._path = path;
                        // add data items to last level groups
                        if (last) {
                            group.items.push(item);
                        }
                        // move on to the next group
                        groups = group.groups;
                    }
                }
                // done
                return root;
            };
            // gets a string digest of the current groups 
            // this is used to check whether changes require a full refresh
            CollectionView.prototype._getGroupsDigest = function (groups) {
                var digest = '';
                for (var i = 0; groups != null && i < groups.length; i++) {
                    var g = groups[i];
                    digest += '{' + g.name + ':' + (g.items ? g.items.length : '*');
                    if (g.groups.length > 0) {
                        digest += ',';
                        digest += this._getGroupsDigest(g.groups);
                    }
                    digest += '}';
                }
                return digest;
            };
            // gets an array that contains all the children for a list of groups
            // NOTE: use "push.apply" instead of "concat" for much better performance
            // NOTE2: use explicit loop for even better performance and to avoid stack overflows (TFS 15921)
            CollectionView.prototype._mergeGroupItems = function (groups) {
                var items = [];
                for (var i = 0; i < groups.length; i++) {
                    var g = groups[i];
                    if (!g._isBottomLevel) {
                        var groupItems = this._mergeGroupItems(g.groups);
                        //g._items.push.apply(g._items, groupItems);
                        for (var a = 0, len = groupItems.length; a < len; a++) {
                            g._items.push(groupItems[a]);
                        }
                    }
                    //items.push.apply(items, g._items);
                    for (var a = 0, len = g._items.length; a < len; a++) {
                        items.push(g._items[a]);
                    }
                }
                return items;
            };
            // finds or creates a group
            CollectionView.prototype._getGroup = function (gd, groups, map, name, level, isBottomLevel) {
                var g;
                // find existing group
                if (map && wijmo.isPrimitive(name)) {
                    g = map[name];
                    if (g) {
                        return g;
                    }
                }
                else {
                    for (var i = 0; i < groups.length; i++) {
                        if (gd.namesMatch(groups[i].name, name)) {
                            return groups[i];
                        }
                    }
                }
                // not found, create now
                var group = new CollectionViewGroup(gd, name, level, isBottomLevel);
                groups.push(group);
                // add group to map
                if (map) {
                    map[name] = group;
                }
                // done
                return group;
            };
            return CollectionView;
        }());
        collections.CollectionView = CollectionView;
        /**
         * Represents a group created by a @see:CollectionView object based on
         * its @see:CollectionView.groupDescriptions property.
         */
        var CollectionViewGroup = /** @class */ (function () {
            /**
             * Initializes a new instance of the @see:CollectionViewGroup class.
             *
             * @param groupDescription @see:GroupDescription that owns the new group.
             * @param name Name of the new group.
             * @param level Level of the new group.
             * @param isBottomLevel Whether this group has any subgroups.
             */
            function CollectionViewGroup(groupDescription, name, level, isBottomLevel) {
                this._gd = groupDescription;
                this._name = name;
                this._level = level;
                this._isBottomLevel = isBottomLevel;
                this._groups = [];
                this._items = [];
            }
            Object.defineProperty(CollectionViewGroup.prototype, "name", {
                /*
                 * Gets the name of this group.
                 */
                get: function () {
                    return this._name;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionViewGroup.prototype, "level", {
                /*
                 * Gets the level of this group.
                 */
                get: function () {
                    return this._level;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionViewGroup.prototype, "isBottomLevel", {
                /*
                 * Gets a value that indicates whether this group has any subgroups.
                 */
                get: function () {
                    return this._isBottomLevel;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionViewGroup.prototype, "items", {
                /*
                 * Gets an array containing the items included in this group (including all subgroups).
                 */
                get: function () {
                    return this._items;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionViewGroup.prototype, "groups", {
                /*
                 * Gets an array containing the this group's subgroups.
                 */
                get: function () {
                    return this._groups;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CollectionViewGroup.prototype, "groupDescription", {
                /*
                 * Gets the @see:GroupDescription that owns this group.
                 */
                get: function () {
                    return this._gd;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Calculates an aggregate value for the items in this group.
             *
             * @param aggType Type of aggregate to calculate.
             * @param binding Property to aggregate on.
             * @param view CollectionView that owns this group.
             * @return The aggregate value.
             */
            CollectionViewGroup.prototype.getAggregate = function (aggType, binding, view) {
                var cv = wijmo.tryCast(view, CollectionView), group = cv ? cv._getFullGroup(this) : this;
                return wijmo.getAggregate(aggType, group.items, binding);
            };
            return CollectionViewGroup;
        }());
        collections.CollectionViewGroup = CollectionViewGroup;
    })(collections = wijmo.collections || (wijmo.collections = {}));
})(wijmo || (wijmo = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var wijmo;
(function (wijmo) {
    'use strict';
    /**
     * Provides a pop-up window that displays additional information about elements on the page.
     *
     * The @see:Tooltip class can be used in two modes:
     *
     * <b>Automatic Mode:</b> Use the @see:setTooltip method to connect the @see:Tooltip to
     * one or more elements on the page. The @see:Tooltip will automatically monitor events
     * and display the tooltips when the user performs actions that trigger the tooltip.
     * For example:
     *
     * <pre>var tt = new wijmo.Tooltip();
     * tt.setTooltip('#menu', 'Select commands.');
     * tt.setTooltip('#tree', 'Explore the hierarchy.');
     * tt.setTooltip('#chart', '#idChartTooltip');</pre>
     *
     * <b>Manual Mode:</b> The caller is responsible for showing and hiding the tooltip
     * using the @see:show and @see:hide methods. For example:
     *
     * <pre>var tt = new wijmo.Tooltip();
     * element.addEventListener('click', function () {
     *   if (tt.isVisible) {
     *     tt.hide();
     *   } else {
     *     tt.show(element, 'This is an important element!');
     *   }
     * });</pre>
     */
    var Tooltip = /** @class */ (function () {
        /**
         * Initializes a new instance of the @see:Tooltip class.
         *
         * @param options JavaScript object containing initialization data for the @see:Tooltip.
         */
        function Tooltip(options) {
            this._showAutoTipBnd = this._showAutoTip.bind(this);
            this._hideAutoTipBnd = this._hideAutoTip.bind(this);
            // property storage
            this._html = true;
            this._gap = 6;
            this._showAtMouse = false;
            this._showDelay = 500; // http://msdn.microsoft.com/en-us/library/windows/desktop/bb760404(v=vs.85).aspx
            this._hideDelay = 0; // do not hide
            this._tips = [];
            /**
             * Occurs before the tooltip content is displayed.
             *
             * The event handler may customize the tooltip content or suppress the
             * tooltip display by changing the event parameters.
             */
            this.popup = new wijmo.Event();
            wijmo.copy(this, options);
        }
        // object model
        /**
         * Assigns tooltip content to a given element on the page.
         *
         * The same tooltip may be used to display information for any number
         * of elements on the page. To remove the tooltip from an element,
         * call @see:setTooltip and specify null for the content.
         *
         * @param element Element, element ID, or control that the tooltip explains.
         * @param content Tooltip content or ID of the element that contains the tooltip content.
         */
        Tooltip.prototype.setTooltip = function (element, content) {
            // get element and tooltip content
            element = wijmo.getElement(element);
            content = this._getContent(content);
            // remove old version from list
            var i = this._indexOf(element);
            if (i > -1) {
                this._detach(element);
                this._tips.splice(i, 1);
            }
            // add new version to list
            if (content) {
                this._attach(element);
                this._tips.push({ element: element, content: content });
            }
        };
        /**
         * Gets the tooltip content associated with a given element.
         *
         * @param element Element, element ID, or control that the tooltip explains.
         * @return Tooltip content associated with the given element.
         */
        Tooltip.prototype.getTooltip = function (element) {
            element = wijmo.getElement(element);
            var tips = this._tips;
            for (var i = 0; i < tips.length; i++) {
                if (tips[i].element == element) {
                    return tips[i].content;
                }
            }
            return null;
        };
        /**
         * Shows the tooltip with the specified content, next to the specified element.
         *
         * @param element Element, element ID, or control that the tooltip explains.
         * @param content Tooltip content or ID of the element that contains the tooltip content.
         * @param bounds Optional element that defines the bounds of the area that the tooltip
         * targets. If not provided, the bounds of the element are used (as reported by the
         * <b>getBoundingClientRect</b> method).
         */
        Tooltip.prototype.show = function (element, content, bounds) {
            // get element and tooltip content
            element = wijmo.getElement(element);
            content = this._getContent(content);
            if (!bounds) {
                bounds = wijmo.Rect.fromBoundingRect(element.getBoundingClientRect());
            }
            // create tooltip element if necessary
            var tip = Tooltip._eTip;
            if (!tip) {
                tip = Tooltip._eTip = document.createElement('div');
                wijmo.addClass(tip, 'wj-tooltip');
                tip.style.visibility = 'none';
            }
            // set tooltip content
            this._setContent(content);
            // fire event to allow customization
            var e = new TooltipEventArgs(content);
            this.onPopup(e);
            // if not canceled and content is present, show tooltip
            if (e.content && !e.cancel) {
                // update tooltip content with custom content, if any
                document.body.appendChild(tip); // (to get tip size correctly)
                this._setContent(e.content);
                tip.style.minWidth = '';
                // apply gap and align to the center of the reference element
                bounds = new wijmo.Rect(bounds.left - (tip.offsetWidth - bounds.width) / 2, bounds.top - this.gap, tip.offsetWidth, bounds.height + 2 * this.gap);
                // show tooltip
                wijmo.showPopup(tip, bounds, true);
                // hide when the mouse goes down
                document.addEventListener('mousedown', this._hideAutoTipBnd);
            }
        };
        /**
         * Hides the tooltip if it is currently visible.
         */
        Tooltip.prototype.hide = function () {
            // hide the tip
            var tip = Tooltip._eTip;
            if (tip) {
                wijmo.removeChild(tip);
                tip.innerHTML = '';
            }
            // remove the event listener we added on show (TFS 288390)
            document.removeEventListener('mousedown', this._hideAutoTipBnd);
        };
        /**
         * Removes all tooltips associated with this @see:Tooltip instance.
         */
        Tooltip.prototype.dispose = function () {
            var _this = this;
            this._tips.forEach(function (item) {
                _this._detach(item.element);
            });
            this._tips.splice(0, this._tips.length);
        };
        Object.defineProperty(Tooltip.prototype, "isVisible", {
            /**
             * Gets a value that determines whether the tooltip is currently visible.
             */
            get: function () {
                var tip = Tooltip._eTip;
                return tip != null && tip.parentElement != null && tip.offsetWidth > 0; // TFS 302981
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Tooltip.prototype, "isContentHtml", {
            /**
             * Gets or sets a value that determines whether the tooltip contents
             * should be displayed as plain text or as HTML.
             */
            get: function () {
                return this._html;
            },
            set: function (value) {
                this._html = wijmo.asBoolean(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Tooltip.prototype, "gap", {
            /**
             * Gets or sets the distance between the tooltip and the target element.
             */
            get: function () {
                return this._gap;
            },
            set: function (value) {
                this._gap = wijmo.asNumber(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Tooltip.prototype, "showAtMouse", {
            /**
             * Gets or sets a value that determines whether the tooltip should be
             * positioned with respect to the mouse position rather than the
             * target element.
             */
            get: function () {
                return this._showAtMouse;
            },
            set: function (value) {
                this._showAtMouse = wijmo.asBoolean(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Tooltip.prototype, "showDelay", {
            /**
             * Gets or sets the delay, in milliseconds, before showing the tooltip after the
             * mouse enters the target element.
             */
            get: function () {
                return this._showDelay;
            },
            set: function (value) {
                this._showDelay = wijmo.asInt(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Tooltip.prototype, "hideDelay", {
            /**
             * Gets or sets the delay, in milliseconds, before hiding the tooltip after the
             * mouse leaves the target element.
             */
            get: function () {
                return this._hideDelay;
            },
            set: function (value) {
                this._hideDelay = wijmo.asInt(value);
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Raises the @see:popup event.
         *
         * @param e @see:TooltipEventArgs that contains the event data.
         */
        Tooltip.prototype.onPopup = function (e) {
            if (this.popup) {
                this.popup.raise(this, e);
            }
            return !e.cancel;
        };
        // implementation
        // finds an element in the auto-tooltip list
        Tooltip.prototype._indexOf = function (e) {
            for (var i = 0; i < this._tips.length; i++) {
                if (this._tips[i].element == e) {
                    return i;
                }
            }
            return -1;
        };
        // add event listeners to show and hide tooltips for an element
        Tooltip.prototype._attach = function (e) {
            e.addEventListener('mouseenter', this._showAutoTipBnd);
            e.addEventListener('mouseleave', this._hideAutoTipBnd);
            e.addEventListener('click', this._showAutoTipBnd);
        };
        // remove event listeners used to show and hide tooltips for an element
        Tooltip.prototype._detach = function (e) {
            e.removeEventListener('mouseenter', this._showAutoTipBnd);
            e.removeEventListener('mouseleave', this._hideAutoTipBnd);
            e.removeEventListener('click', this._showAutoTipBnd);
        };
        // shows an automatic tooltip
        Tooltip.prototype._showAutoTip = function (e) {
            var _this = this;
            // not if prevented
            if (e.defaultPrevented) {
                return;
            }
            // hide and close if click is not a touch
            if (e.type == 'click' && !wijmo.Control._touching) {
                this._hideAutoTip();
                return;
            }
            // show tip
            var showDelay = e.type == 'mouseenter' ? this._showDelay : 0;
            this._clearTimeouts();
            this._toShow = setTimeout(function () {
                var i = _this._indexOf(e.target);
                if (i > -1) {
                    var tip = _this._tips[i], bounds = _this._showAtMouse ? new wijmo.Rect(e.clientX, e.clientY, 0, 0) : null;
                    _this.show(tip.element, tip.content, bounds);
                    if (_this._hideDelay > 0) {
                        _this._toHide = setTimeout(function () {
                            _this.hide();
                        }, _this._hideDelay);
                    }
                }
            }, showDelay);
        };
        // hides an automatic tooltip
        Tooltip.prototype._hideAutoTip = function () {
            this._clearTimeouts();
            this.hide();
        };
        // clears the timeouts used to show and hide automatic tooltips
        Tooltip.prototype._clearTimeouts = function () {
            if (this._toShow) {
                clearTimeout(this._toShow);
                this._toShow = null;
            }
            if (this._toHide) {
                clearTimeout(this._toHide);
                this._toHide = null;
            }
        };
        // gets content that may be a string or an element id
        Tooltip.prototype._getContent = function (content) {
            content = wijmo.asString(content);
            if (content && content[0] == '#') {
                var e = wijmo.getElement(content);
                if (e) {
                    content = e.innerHTML;
                }
            }
            return content;
        };
        // assigns content to the tooltip element
        Tooltip.prototype._setContent = function (content) {
            var tip = Tooltip._eTip;
            if (tip) {
                if (this.isContentHtml) {
                    tip.innerHTML = content;
                }
                else {
                    tip.textContent = content;
                }
            }
        };
        return Tooltip;
    }());
    wijmo.Tooltip = Tooltip;
    // helper class to hold element/tooltip information
    var ElementContent = /** @class */ (function () {
        function ElementContent() {
        }
        return ElementContent;
    }());
    /**
     * Provides arguments for the @see:Tooltip.popup event.
     */
    var TooltipEventArgs = /** @class */ (function (_super) {
        __extends(TooltipEventArgs, _super);
        /**
         * Initializes a new instance of the @see:TooltipEventArgs class.
         *
         * @param content String to show in the tooltip.
         */
        function TooltipEventArgs(content) {
            var _this = _super.call(this) || this;
            _this._content = wijmo.asString(content);
            return _this;
        }
        Object.defineProperty(TooltipEventArgs.prototype, "content", {
            /**
             * Gets or sets the content to show in the tooltip.
             *
             * This parameter can be used while handling the @see:Tooltip.popup
             * event to modify the content of the tooltip.
             */
            get: function () {
                return this._content;
            },
            set: function (value) {
                this._content = wijmo.asString(value);
            },
            enumerable: true,
            configurable: true
        });
        return TooltipEventArgs;
    }(wijmo.CancelEventArgs));
    wijmo.TooltipEventArgs = TooltipEventArgs;
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    'use strict';
    /**
     * Represents a color.
     *
     * The @see:Color class parses colors specified as CSS strings and exposes
     * their red, green, blue, and alpha channels as read-write properties.
     *
     * The @see:Color class also provides @see:fromHsb and @see:fromHsl methods
     * for creating colors using the HSB and HSL color models instead of RGB,
     * as well as @see:getHsb and @see:getHsl methods for retrieving the color
     * components using those color models.
     *
     * Finally, the @see:Color class provides an @see:interpolate method that
     * creates colors by interpolating between two colors using the HSL model.
     * This method is especially useful for creating color animations with the
     * @see:animate method.
     */
    var Color = /** @class */ (function () {
        /**
         * Initializes a new @see:Color from a CSS color specification.
         *
         * @param color CSS color specification.
         */
        function Color(color) {
            // fields
            this._r = 0;
            this._g = 0;
            this._b = 0;
            this._a = 1;
            if (color) {
                this._parse(color);
            }
        }
        Object.defineProperty(Color.prototype, "r", {
            /**
             * Gets or sets the red component of this @see:Color,
             * in a range from 0 to 255.
             */
            get: function () {
                return this._r;
            },
            set: function (value) {
                this._r = wijmo.clamp(wijmo.asNumber(value), 0, 255);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Color.prototype, "g", {
            /**
             * Gets or sets the green component of this @see:Color,
             * in a range from 0 to 255.
             */
            get: function () {
                return this._g;
            },
            set: function (value) {
                this._g = wijmo.clamp(wijmo.asNumber(value), 0, 255);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Color.prototype, "b", {
            /**
             * Gets or sets the blue component of this @see:Color,
             * in a range from 0 to 255.
             */
            get: function () {
                return this._b;
            },
            set: function (value) {
                this._b = wijmo.clamp(wijmo.asNumber(value), 0, 255);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Color.prototype, "a", {
            /**
             * Gets or sets the alpha component of this @see:Color,
             * in a range from 0 to 1 (zero is transparent, one is solid).
             */
            get: function () {
                return this._a;
            },
            set: function (value) {
                this._a = wijmo.clamp(wijmo.asNumber(value), 0, 1);
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Returns true if a @see:Color has the same value as this @see:Color.
         *
         * @param clr @see:Color to compare to this @see:Color.
         */
        Color.prototype.equals = function (clr) {
            return (clr instanceof Color) &&
                this.r == clr.r && this.g == clr.g && this.b == clr.b &&
                this.a == clr.a;
        };
        /**
         * Gets a string representation of this @see:Color.
         */
        Color.prototype.toString = function () {
            var a = Math.round(this.a * 100);
            return a > 99
                ? '#' + ((1 << 24) + (this.r << 16) + (this.g << 8) + this.b).toString(16).slice(1)
                : 'rgba(' + this.r + ',' + this.g + ',' + this.b + ',' + (a / 100) + ')';
        };
        /**
         * Creates a new @see:Color using the specified RGBA color channel values.
         *
         * @param r Value for the red channel, from 0 to 255.
         * @param g Value for the green channel, from 0 to 255.
         * @param b Value for the blue channel, from 0 to 255.
         * @param a Value for the alpha channel, from 0 to 1.
         */
        Color.fromRgba = function (r, g, b, a) {
            if (a === void 0) { a = 1; }
            var c = new Color(null);
            c.r = Math.round(wijmo.clamp(wijmo.asNumber(r), 0, 255));
            c.g = Math.round(wijmo.clamp(wijmo.asNumber(g), 0, 255));
            c.b = Math.round(wijmo.clamp(wijmo.asNumber(b), 0, 255));
            c.a = wijmo.clamp(wijmo.asNumber(a), 0, 1);
            return c;
        };
        /**
         * Creates a new @see:Color using the specified HSB values.
         *
         * @param h Hue value, from 0 to 1.
         * @param s Saturation value, from 0 to 1.
         * @param b Brightness value, from 0 to 1.
         * @param a Alpha value, from 0 to 1.
         */
        Color.fromHsb = function (h, s, b, a) {
            if (a === void 0) { a = 1; }
            var rgb = Color._hsbToRgb(wijmo.clamp(wijmo.asNumber(h), 0, 1), wijmo.clamp(wijmo.asNumber(s), 0, 1), wijmo.clamp(wijmo.asNumber(b), 0, 1));
            return Color.fromRgba(rgb[0], rgb[1], rgb[2], a);
        };
        /**
         * Creates a new @see:Color using the specified HSL values.
         *
         * @param h Hue value, from 0 to 1.
         * @param s Saturation value, from 0 to 1.
         * @param l Lightness value, from 0 to 1.
         * @param a Alpha value, from 0 to 1.
         */
        Color.fromHsl = function (h, s, l, a) {
            if (a === void 0) { a = 1; }
            var rgb = Color._hslToRgb(wijmo.clamp(wijmo.asNumber(h), 0, 1), wijmo.clamp(wijmo.asNumber(s), 0, 1), wijmo.clamp(wijmo.asNumber(l), 0, 1));
            return Color.fromRgba(rgb[0], rgb[1], rgb[2], a);
        };
        /**
         * Creates a new @see:Color from a CSS color string.
         *
         * @param value String containing a CSS color specification.
         * @return A new @see:Color, or null if the string cannot be parsed into a color.
         */
        Color.fromString = function (value) {
            var c = new Color(null);
            return c._parse(wijmo.asString(value)) ? c : null;
        };
        /**
         * Gets an array with this color's HSB components.
         */
        Color.prototype.getHsb = function () {
            return Color._rgbToHsb(this.r, this.g, this.b);
        };
        /**
         * Gets an array with this color's HSL components.
         */
        Color.prototype.getHsl = function () {
            return Color._rgbToHsl(this.r, this.g, this.b);
        };
        /**
         * Creates a @see:Color by interpolating between two colors.
         *
         * @param c1 First color.
         * @param c2 Second color.
         * @param pct Value between zero and one that determines how close the
         * interpolation should be to the second color.
         */
        Color.interpolate = function (c1, c2, pct) {
            // sanity
            pct = wijmo.clamp(wijmo.asNumber(pct), 0, 1);
            // convert rgb to hsl
            var h1 = Color._rgbToHsl(c1.r, c1.g, c1.b), h2 = Color._rgbToHsl(c2.r, c2.g, c2.b);
            // interpolate
            var qct = 1 - pct, alpha = c1.a * qct + c2.a * pct, h3 = [
                h1[0] * qct + h2[0] * pct,
                h1[1] * qct + h2[1] * pct,
                h1[2] * qct + h2[2] * pct
            ];
            // convert back to rgb
            var rgb = Color._hslToRgb(h3[0], h3[1], h3[2]);
            return Color.fromRgba(rgb[0], rgb[1], rgb[2], alpha);
        };
        /**
         * Gets the closest opaque color to a given color.
         *
         * @param c @see:Color to be converted to an opaque color
         * (the color may also be specified as a string).
         * @param bkg Background color to use when removing the transparency
         * (defaults to white).
         */
        Color.toOpaque = function (c, bkg) {
            // get color
            c = wijmo.isString(c) ? Color.fromString(c) : wijmo.asType(c, Color);
            // no alpha? no work
            if (c.a == 1)
                return c;
            // get background
            bkg = bkg == null ? Color.fromRgba(255, 255, 255, 1) :
                wijmo.isString(bkg) ? Color.fromString(bkg) :
                    wijmo.asType(bkg, Color);
            // interpolate in RGB space
            var p = c.a, q = 1 - p;
            return Color.fromRgba(c.r * p + bkg.r * q, c.g * p + bkg.g * q, c.b * p + bkg.b * q);
        };
        // ** implementation
        // parses a color string into r/b/g/a
        Color.prototype._parse = function (c) {
            // case-insensitive
            c = c.toLowerCase();
            // 'transparent' is a special case:
            // https://developer.mozilla.org/en-US/docs/Web/CSS/color_value
            if (c == 'transparent') {
                this._r = this._g = this._b = this._a = 0;
                return true;
            }
            // let browser parse stuff we don't handle
            if (c && c.indexOf('#') != 0 && c.indexOf('rgb') != 0 && c.indexOf('hsl') != 0) {
                var e = document.createElement('div');
                e.style.color = c;
                var cc = e.style.color;
                if (cc == c) {
                    cc = window.getComputedStyle(e).color; // then get computed style
                    if (!cc) {
                        document.body.appendChild(e); // then add element to document
                        cc = window.getComputedStyle(e).color; // and try again
                        wijmo.removeChild(e);
                    }
                }
                c = cc.toLowerCase();
            }
            // parse #RGB/#RRGGBB
            if (c.indexOf('#') == 0) {
                if (c.length == 4) {
                    this.r = parseInt(c[1] + c[1], 16);
                    this.g = parseInt(c[2] + c[2], 16);
                    this.b = parseInt(c[3] + c[3], 16);
                    this.a = 1;
                    return true;
                }
                else if (c.length == 7) {
                    this.r = parseInt(c.substr(1, 2), 16);
                    this.g = parseInt(c.substr(3, 2), 16);
                    this.b = parseInt(c.substr(5, 2), 16);
                    this.a = 1;
                    return true;
                }
                return false;
            }
            // parse rgb/rgba
            if (c.indexOf('rgb') == 0) {
                var op = c.indexOf('('), ep = c.indexOf(')');
                if (op > -1 && ep > -1) {
                    var p = c.substr(op + 1, ep - (op + 1)).split(',');
                    if (p.length > 2) {
                        this.r = parseInt(p[0]);
                        this.g = parseInt(p[1]);
                        this.b = parseInt(p[2]);
                        this.a = p.length > 3 ? parseFloat(p[3]) : 1;
                        return true;
                    }
                }
            }
            // parse hsl/hsla
            if (c.indexOf('hsl') == 0) {
                var op = c.indexOf('('), ep = c.indexOf(')');
                if (op > -1 && ep > -1) {
                    var p = c.substr(op + 1, ep - (op + 1)).split(',');
                    if (p.length > 2) {
                        var h = parseInt(p[0]) / 360, s = parseInt(p[1]), l = parseInt(p[2]);
                        if (p[1].indexOf('%') > -1)
                            s /= 100;
                        if (p[2].indexOf('%') > -1)
                            l /= 100;
                        var rgb = Color._hslToRgb(h, s, l);
                        this.r = rgb[0];
                        this.g = rgb[1];
                        this.b = rgb[2];
                        this.a = p.length > 3 ? parseFloat(p[3]) : 1;
                        return true;
                    }
                }
            }
            // failed to parse
            return false;
        };
        /**
         * Converts an HSL color value to RGB.
         *
         * @param h The hue (between zero and one).
         * @param s The saturation (between zero and one).
         * @param l The lightness (between zero and one).
         * @return An array containing the R, G, and B values (between zero and 255).
         */
        Color._hslToRgb = function (h, s, l) {
            wijmo.assert(h >= 0 && h <= 1 && s >= 0 && s <= 1 && l >= 0 && l <= 1, 'bad HSL values');
            var r, g, b;
            if (s == 0) {
                r = g = b = l; // achromatic
            }
            else {
                var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                var p = 2 * l - q;
                r = Color._hue2rgb(p, q, h + 1 / 3);
                g = Color._hue2rgb(p, q, h);
                b = Color._hue2rgb(p, q, h - 1 / 3);
            }
            return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
        };
        Color._hue2rgb = function (p, q, t) {
            if (t < 0)
                t += 1;
            if (t > 1)
                t -= 1;
            if (t < 1 / 6)
                return p + (q - p) * 6 * t;
            if (t < 1 / 2)
                return q;
            if (t < 2 / 3)
                return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        };
        /**
         * Converts an RGB color value to HSL.
         *
         * @param r The value of the red channel (between zero and 255).
         * @param g The value of the green channel (between zero and 255).
         * @param b The value of the blue channel (between zero and 255).
         * @return An array containing the H, S, and L values (between zero and one).
         */
        Color._rgbToHsl = function (r, g, b) {
            wijmo.assert(r >= 0 && r <= 255 && g >= 0 && g <= 255 && b >= 0 && b <= 255, 'bad RGB values');
            r /= 255, g /= 255, b /= 255;
            var max = Math.max(r, g, b), min = Math.min(r, g, b), h, s, l = (max + min) / 2;
            if (max == min) {
                h = s = 0;
            }
            else {
                var d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch (max) {
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                }
                h /= 6;
            }
            return [h, s, l];
        };
        /**
         * Converts an RGB color value to HSB.
         *
         * @param r The value of the red channel (between zero and 255).
         * @param g The value of the green channel (between zero and 255).
         * @param b The value of the blue channel (between zero and 255).
         * @return An array containing the H, S, and B values (between zero and one).
         */
        Color._rgbToHsb = function (r, g, b) {
            wijmo.assert(r >= 0 && r <= 255 && g >= 0 && g <= 255 && b >= 0 && b <= 255, 'bad RGB values');
            var hsl = Color._rgbToHsl(r, g, b);
            return Color._hslToHsb(hsl[0], hsl[1], hsl[2]);
        };
        /**
         * Converts an HSB color value to RGB.
         *
         * @param h The hue (between zero and one).
         * @param s The saturation (between zero and one).
         * @param b The brightness (between zero and one).
         * @return An array containing the R, G, and B values (between zero and 255).
         */
        Color._hsbToRgb = function (h, s, b) {
            //assert(h >= 0 && h <= 1 && s >= 0 && s <= 1 && b >= 0 && b <= 1, 'bad HSB values');
            var hsl = Color._hsbToHsl(h, s, b);
            return Color._hslToRgb(hsl[0], hsl[1], hsl[2]);
        };
        /**
         * Converts an HSB color value to HSL.
         *
         * @param h The hue (between zero and one).
         * @param s The saturation (between zero and one).
         * @param b The brightness (between zero and one).
         * @return An array containing the H, S, and L values (between zero and one).
         */
        Color._hsbToHsl = function (h, s, b) {
            wijmo.assert(h >= 0 && h <= 1 && s >= 0 && s <= 1 && b >= 0 && b <= 1, 'bad HSB values');
            var ll = wijmo.clamp(b * (2 - s) / 2, 0, 1), div = 1 - Math.abs(2 * ll - 1), ss = wijmo.clamp(div > 0 ? b * s / div : s /*0*/, 0, 1);
            wijmo.assert(!isNaN(ll) && !isNaN(ss), 'bad conversion to HSL');
            return [h, ss, ll];
        };
        /**
         * Converts an HSL color value to HSB.
         *
         * @param h The hue (between zero and one).
         * @param s The saturation (between zero and one).
         * @param l The lightness (between zero and one).
         * @return An array containing the H, S, and B values (between zero and one).
         */
        Color._hslToHsb = function (h, s, l) {
            wijmo.assert(h >= 0 && h <= 1 && s >= 0 && s <= 1 && l >= 0 && l <= 1, 'bad HSL values');
            var bb = wijmo.clamp(l == 1 ? 1 : (2 * l + s * (1 - Math.abs(2 * l - 1))) / 2, 0, 1), ss = wijmo.clamp(bb > 0 ? 2 * (bb - l) / bb : s /*0*/, 0, 1);
            wijmo.assert(!isNaN(bb) && !isNaN(ss), 'bad conversion to HSB');
            return [h, ss, bb];
        };
        return Color;
    }());
    wijmo.Color = Color;
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    'use strict';
    /**
     * Static class that provides utility methods for clipboard operations.
     *
     * The @see:Clipboard class provides static @see:copy and @see:paste methods
     * that can be used by controls to customize the clipboard content during
     * clipboard operations.
     *
     * For example, the code below shows how a control could intercept the
     * clipboard shortcut keys and provide custom clipboard handling:
     *
     * <pre>
     * rootElement.addEventListener('keydown', function(e) {
     *   // copy: ctrl+c or ctrl+Insert
     *   if (e.ctrlKey && (e.keyCode == 67 || e.keyCode == 45)) {
     *     var text = this.getClipString();
     *     Clipboard.copy(text);
     *     return;
     *   }
     *   // paste: ctrl+v or shift+Insert
     *   if ((e.ctrlKey && e.keyCode == 86) || (e.shiftKey && e.keyCode == 45)) {
     *     Clipboard.paste(function (text) {
     *       this.setClipString(text);
     *     });
     *     return;
     *   }
     * });</pre>
     */
    var Clipboard = /** @class */ (function () {
        function Clipboard() {
        }
        /**
         * Copies a string to the clipboard.
         *
         * This method only works if invoked immediately after the user
         * pressed a clipboard copy command (such as ctrl+c).
         *
         * @param text Text to copy to the clipboard.
         */
        Clipboard.copy = function (text) {
            Clipboard._copyPaste(wijmo.asString(text), null);
        };
        /**
         * Gets a string from the clipboard.
         *
         * This method only works if invoked immediately after the user
         * pressed a clipboard paste command (such as ctrl+v).
         *
         * @param callback Function called when the clipboard content
         * has been retrieved. The function receives the clipboard
         * content as a parameter.
         */
        Clipboard.paste = function (callback) {
            Clipboard._copyPaste(null, wijmo.asFunction(callback));
        };
        // ** implementation
        Clipboard._copyPaste = function (copyText, pasteCallback) {
            // get active element to restore later
            var activeElement = wijmo.getActiveElement();
            // find parent for temporary input element
            // (body may not be focusable when modal dialogs are used..., TFS 202992)
            var parent = wijmo.closest(activeElement, '.wj-control');
            while (parent && wijmo.Control.getControl(parent)) {
                parent = parent.parentElement;
            }
            parent = parent || document.body;
            // if we have a parent, add hidden textarea to copy/paste
            if (parent) {
                // create, initialize, select hidden textarea
                var html = '<textarea class="wj-clipboard" style="position:fixed;opacity:0"/>', el_1 = wijmo.createElement(html, parent);
                if (wijmo.isString(copyText)) {
                    el_1.value = copyText;
                }
                el_1.select();
                // ignore keyboard input to hidden textarea (TFS 151939)
                el_1.onkeydown = function (e) {
                    e.preventDefault();
                };
                // wait, clean up, invoke paste callback
                setTimeout(function () {
                    activeElement.focus();
                    wijmo.removeChild(el_1);
                    if (wijmo.isFunction(pasteCallback)) {
                        pasteCallback(el_1.value);
                    }
                }, wijmo.Control._CLIPBOARD_DELAY);
            }
        };
        return Clipboard;
    }());
    wijmo.Clipboard = Clipboard;
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    'use strict';
    /**
     * Shows an element as a popup.
     *
     * The popup element becomes a child of the body element,
     * and is positioned above or below a reference rectangle,
     * depending on how much room is available.
     *
     * The reference rectangle may be specified as one of the following:
     *
     * <dl class="dl-horizontal">
     *   <dt>HTMLElement</dt>
     *   <dd>The bounding rectangle of the element.</dd>
     *   <dt>MouseEvent</dt>
     *   <dd>The bounding rectangle of the event's target element.</dd>
     *   <dt>Rect</dt>
     *   <dd>The given rectangle.</dd>
     *   <dt>null</dt>
     *   <dd>No reference rectangle; the popup is centered on the window.</dd>
     * </dl>
     *
     * Call the @see:hidePopup method to hide the popup.
     *
     * @param popup Element to show as a popup.
     * @param ref Reference element or rectangle used to position the popup.
     * @param above Position popup above the reference rectangle if possible.
     * @param fadeIn Use a fade-in animation to make the popup appear gradually.
     * @param copyStyles Copy font and color styles from reference element.
     * @return An interval id that you can use to suspend the fade-in animation.
     */
    function showPopup(popup, ref, above, fadeIn, copyStyles) {
        if (ref === void 0) { ref = null; }
        if (above === void 0) { above = false; }
        if (fadeIn === void 0) { fadeIn = false; }
        if (copyStyles === void 0) { copyStyles = true; }
        // calculate popup's parent element
        var parent = document.body;
        if (ref instanceof HTMLElement) {
            // 1 - make sure the reference is in the DOM
            if (!wijmo.contains(document.body, ref)) {
                return;
            }
            // 2 - adjust the parent to account for ancestors with fixed position
            // or dialog role (TFS 243224)
            for (var e = ref; e; e = e.parentElement) {
                if (e.getAttribute('role') == 'dialog' || // TFS 274224
                    getComputedStyle(e).position == 'fixed') {
                    parent = e;
                    break;
                }
            }
        }
        // add the popup to the DOM so we can measure it
        // make sure the popup is the last child of the parent element
        // do this only if necessary, it affects the focus and rendering order (TFS 268902)
        if (popup.offsetHeight && popup.offsetWidth && wijmo.contains(parent, popup)) {
            // visible and in the right container, no need to append
        }
        else if (parent.lastChild != popup) {
            parent.appendChild(popup);
        }
        // compute popup offset (scroll/pinch zoom: TFS 202906, 300174, 303015, 304114, 303317)
        var ptOffset = new wijmo.Point(pageXOffset, pageYOffset), doc = document.documentElement, pinchZoom = doc.clientWidth / window.innerWidth;
        if (parent != document.body || pinchZoom > 1.005) {
            var elParent = parent == document.body ? document.documentElement : popup.offsetParent, rcParent = elParent.getBoundingClientRect();
            ptOffset = new wijmo.Point(elParent.scrollLeft - rcParent.left, elParent.scrollTop - rcParent.top);
        }
        // copy style elements from ref element to popup
        // (the popup is not a child of the ref element)
        if (ref instanceof HTMLElement && copyStyles) {
            var sref = getComputedStyle(ref), bkg = new wijmo.Color(sref.backgroundColor);
            if (bkg.a) {
                wijmo.setCss(popup, {
                    color: sref.color,
                    backgroundColor: sref.backgroundColor,
                    fontFamily: sref.fontFamily,
                    fontSize: sref.fontSize,
                    fontWeight: sref.fontWeight,
                    fontStyle: sref.fontStyle
                });
            }
        }
        // make sure popup is visible so we can measure it
        wijmo.setCss(popup, {
            position: 'absolute',
            display: ''
        });
        // update layout for any Wijmo controls in the popup
        wijmo.Control.refreshAll(popup);
        // compute margins, size
        var sp = getComputedStyle(popup), my = parseFloat(sp.marginTop) + parseFloat(sp.marginBottom), mx = parseFloat(sp.marginLeft) + parseFloat(sp.marginRight), sz = new wijmo.Size(popup.offsetWidth + mx, popup.offsetHeight + my);
        // ref can be a mouse event, a point, an element, or a rect
        var pos = new wijmo.Point(), rc = null, scrWid = doc.clientWidth, //innerWidth,
        scrHei = doc.clientHeight; //innerHeight;
        if (ref && ref.clientX != null && ref.clientY != null && ref.pageX != null && ref.pageY != null) {
            if (ref.clientX <= 0 && ref.clientY <= 0 && ref.target) {
                // this looks like a fake mouse event (e.g. context menu key),
                // so use the event target as a reference TFS 117115
                rc = ref.target.getBoundingClientRect();
            }
            else {
                // use ref.page*-page*Offset instead of ref.client*, 
                // which should be the same but gives wrong results in some scenarios 
                // (e.g.pinch - zoomed Chrome / Android)
                pos.x = Math.max(0, ref.pageX - pageXOffset);
                pos.y = Math.max(0, ref.pageY - pageYOffset);
                //pos.x = Math.max(0, ref.clientX);
                //pos.y = Math.max(0, ref.clientY);
            }
        }
        else if (ref instanceof wijmo.Point) {
            pos = ref;
        }
        else if (ref instanceof HTMLElement) {
            rc = ref.getBoundingClientRect();
        }
        else if (ref && ref.top != null && ref.left != null) {
            rc = ref;
        }
        else if (ref == null) {
            pos.x = Math.max(0, (scrWid - sz.width) / 2);
            pos.y = Math.max(0, Math.round((scrHei - sz.height) / 2 * .7));
        }
        else {
            throw 'Invalid ref parameter.';
        }
        // calculate min width for the popup
        var minWidth = parseFloat(sp.minWidth);
        // if we have a rect, position popup above or below the rect
        if (rc) {
            var spcAbove = rc.top, spcBelow = scrHei - rc.bottom, rtl = getComputedStyle(popup).direction == 'rtl';
            if (rtl) {
                pos.x = Math.max(0, rc.right - sz.width);
            }
            else {
                pos.x = Math.max(0, Math.min(rc.left, scrWid - sz.width));
            }
            if (above) {
                pos.y = spcAbove > sz.height || spcAbove > spcBelow
                    ? Math.max(0, rc.top - sz.height)
                    : rc.bottom;
            }
            else {
                pos.y = spcBelow > sz.height || spcBelow > spcAbove
                    ? rc.bottom
                    : Math.max(0, rc.top - sz.height);
            }
            // make popup at least as wide as the element
            minWidth = Math.max(minWidth, rc.width);
            // calculate scrollbar width to adjust in IE (TFS 222947)
            if (wijmo.isIE()) {
                var sbWidth = popup.offsetWidth - (popup.clientWidth + parseInt(sp.borderLeftWidth) + parseInt(sp.borderRightWidth));
                minWidth -= sbWidth;
            }
        }
        else {
            var extra = 20;
            if (pos.y + sz.height > scrHei - extra) {
                pos.y = Math.max(0, scrHei - extra - sz.height);
            }
            if (pos.x + sz.width > scrWid - extra) {
                pos.x = Math.max(0, scrWid - extra - sz.width);
            }
        }
        // update popup position
        var css = {
            left: pos.x + ptOffset.x,
            top: pos.y + ptOffset.y,
            minWidth: minWidth,
            zIndex: 1500 // Bootstrap dialogs use 1050
        };
        // apply fade in effect
        var anim = null;
        if (fadeIn) {
            popup.style.opacity = '0';
            anim = wijmo.animate(function (pct) {
                popup.style.opacity = (pct == 1) ? '' : pct.toString();
            });
        }
        // add owner element information
        if (ref instanceof HTMLElement) {
            popup[wijmo.Control._OWNR_KEY] = ref;
        }
        // show it
        wijmo.setCss(popup, css);
        // hide the popup if the user scrolls an ancestor other than the body (TFS 284767)
        var anchor = ref instanceof MouseEvent ? ref.target : ref;
        if (anchor instanceof HTMLElement && anchor.parentElement != document.body) {
            var start_1 = Date.now(), bounds_1 = anchor.getBoundingClientRect(), scrlHandler = new wijmo.Control(document.createElement('div'));
            popup[wijmo.Control._SCRL_KEY] = scrlHandler;
            scrlHandler.addEventListener(document, 'scroll', function (e) {
                if (Date.now() - start_1 > 100) {
                    if (wijmo.contains(document, anchor) && !wijmo.contains(popup, e.target)) {
                        if (e.target != document || (ref != null && popup.style.position == 'fixed')) {
                            var newBounds = anchor.getBoundingClientRect(), dx = Math.abs(newBounds.left - bounds_1.left), dy = Math.abs(newBounds.top - bounds_1.top);
                            if (dx > 1 || dy > 1) {
                                _hidePopup(popup, true);
                            }
                        }
                    }
                }
            }, true);
        }
        // all done, return animation
        return anim;
    }
    wijmo.showPopup = showPopup;
    /**
     * Hides a popup element previously displayed with the @see:showPopup
     * method.
     *
     * @param popup Popup element to hide.
     * @param remove Whether to remove the popup from the DOM or just to hide it.
     * This parameter may be a boolean or a callback function that gets invoked
     * after the popup has been removed from the DOM.
     * @param fadeOut Whether to use a fade-out animation to make the popup disappear gradually.
     * @return An interval id that you can use to suspend the fade-out animation.
     */
    function hidePopup(popup, remove, fadeOut) {
        if (remove === void 0) { remove = true; }
        if (fadeOut === void 0) { fadeOut = false; }
        var anim = null;
        if (fadeOut) {
            anim = wijmo.animate(function (pct) {
                popup.style.opacity = (1 - pct).toString();
                if (pct == 1) {
                    _hidePopup(popup, remove);
                    popup.style.opacity = '';
                }
            });
        }
        else {
            _hidePopup(popup, remove);
        }
        return anim;
    }
    wijmo.hidePopup = hidePopup;
    function _hidePopup(popup, remove) {
        // hide the popup
        popup.style.display = 'none';
        if (remove && popup.parentElement) {
            setTimeout(function () {
                if (popup.style.display == 'none') {
                    wijmo.removeChild(popup);
                    if (wijmo.isFunction(remove)) {
                        remove();
                    }
                }
            }, wijmo.Control._FOCUS_INTERVAL * 2);
        }
        // remove scroll event handler
        var scrlHandler = popup[wijmo.Control._SCRL_KEY];
        if (scrlHandler instanceof wijmo.Control) {
            scrlHandler.dispose();
        }
        // remove popup keys
        delete popup[wijmo.Control._SCRL_KEY];
        delete popup[wijmo.Control._OWNR_KEY];
    }
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    'use strict';
    // Note: The Edge browser had an issue that prevented this component
    // from working correctly (see link below); that bug has been fixed
    // and the PrintDocument component now works fine with Edge.
    //  https://connect.microsoft.com/IE/Feedback/Details/1589775
    /**
     * Class that enables the creation of custom documents for printing.
     *
     * The @see:PrintDocument class makes it easy to create documents for printing or
     * exporting to PDF. Most browsers allow you to select the paper size, orientation,
     * margins, and whether to include page headers and footers.
     *
     * To use, instantiate a @see:PrintDocument, add content using the @see:append
     * method, and finish by calling the @see:print method.
     *
     * For example:
     * <pre>// create the document
     * var doc = new wijmo.PrintDocument({
     *   title: 'PrintDocument Test'
     * });
     * // add some simple text
     * doc.append('&lt;h1&gt;Printing Example&lt;/h1&gt;');
     * doc.append('&lt;p&gt;This document was created using the &lt;b&gt;PrintDocument&lt;/b&gt; class.&lt;/p&gt;');
     * // add some existing elements
     * doc.append(document.getElementById('gaugeControl'));
     * // print the document (or export it to PDF)
     * doc.print();</pre>
     */
    var PrintDocument = /** @class */ (function () {
        // ** ctor
        /**
         * Initializes a new instance of the @see:PrintDocument class.
         *
         * @param options JavaScript object containing initialization data for the @see:PrintDocument.
         */
        function PrintDocument(options) {
            this._copyCss = true;
            if (options != null) {
                wijmo.copy(this, options);
            }
        }
        Object.defineProperty(PrintDocument.prototype, "title", {
            // ** object model
            /**
             * Gets or sets the document title.
             *
             * Setting this property to null causes the @see:PrintDocument
             * to use the title from the current document.
             */
            get: function () {
                return this._title;
            },
            set: function (value) {
                this._title = wijmo.asString(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PrintDocument.prototype, "copyCss", {
            /**
             * Gets or sets a value that determines whether the @see:PrintDocument should include the CSS
             * style sheets defined in the main document.
             */
            get: function () {
                return this._copyCss;
            },
            set: function (value) {
                this._copyCss = wijmo.asBoolean(value);
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Adds a CSS style sheet to the document.
         *
         * @param href URL of the CSS file that should be added to the document.
         */
        PrintDocument.prototype.addCSS = function (href) {
            if (!this._css) {
                this._css = [];
            }
            this._css.push(href);
        };
        /**
         * Appends an HTML element or string to the document.
         *
         * @param child HTML element or string to append to the document.
         */
        PrintDocument.prototype.append = function (child) {
            var doc = this._getDocument(), body = doc.body, err = false;
            if (body) {
                if (wijmo.isString(child)) {
                    body.appendChild(wijmo.createElement(child));
                }
                else if (child instanceof Node) {
                    var clone = this._cloneNode(child);
                    body.appendChild(clone);
                }
                else {
                    err = true;
                }
            }
            else {
                if (wijmo.isString(child)) {
                    doc.write(child);
                }
                else if (child instanceof HTMLElement) {
                    var clone = this._cloneNode(child);
                    doc.write(clone.outerHTML);
                }
                else {
                    err = true;
                }
            }
            if (err) {
                wijmo.assert(false, 'child parameter should be an HTML node or an HTML string.');
            }
        };
        /**
         * Prints the document.
         */
        PrintDocument.prototype.print = function () {
            var _this = this;
            if (this._iframe) {
                // close the document
                this._close();
                // give it some time before printing/disposing (important!!!)
                setTimeout(function () {
                    // clean up using afterprint event if possible (not in FireFox: TFS 260289)
                    var wnd = _this._iframe.contentWindow, afterprint = 'onafterprint' in wnd && !wijmo.isFirefox();
                    if (afterprint) {
                        wnd.onafterprint = function () {
                            wijmo.removeChild(_this._iframe);
                            _this._iframe = null;
                        };
                    }
                    // print the document
                    // use execCommand if possible (TFS 277516, 277894)
                    if (document.queryCommandSupported('print')) {
                        wnd.document.execCommand('print', false, null);
                    }
                    else {
                        wnd.focus();
                        wnd.print();
                    }
                    // clean up after printing if afterprint event is not available or usable (Chrome/Firefox)
                    if (!afterprint) {
                        wijmo.removeChild(_this._iframe);
                        _this._iframe = null;
                    }
                }, 100);
            }
        };
        // ** implementation
        // clone a node including the value property on SELECT and TEXTAREA elements
        // see: https://stackoverflow.com/questions/742810/clone-isnt-cloning-select-values
        PrintDocument.prototype._cloneNode = function (child) {
            var clone = child.cloneNode(true);
            if (child instanceof HTMLElement && clone instanceof HTMLElement) {
                var tags = ['select', 'textarea'];
                tags.forEach(function (tag) {
                    var childEl = child.querySelectorAll(tag), cloneEl = clone.querySelectorAll(tag);
                    for (var i = 0; i < childEl.length; i++) {
                        cloneEl[i]['value'] = childEl[i]['value'];
                    }
                });
            }
            return clone;
        };
        // gets a reference to the print document
        PrintDocument.prototype._getDocument = function () {
            // create iframe if needed
            if (!this._iframe) {
                this._iframe = document.createElement('iframe');
                wijmo.addClass(this._iframe, 'wj-printdocument');
                wijmo.setCss(this._iframe, {
                    position: 'fixed',
                    left: 10000,
                    top: 10000
                });
                document.body.appendChild(this._iframe);
                var doc = this._iframe.contentDocument;
                // open the document and add a body element (to work in Firefox)
                // also, set body position to 'static' to prevent inheriting frame's 'fixed' 
                // position which would prevent printing multiple pages in Ionic apps
                doc.write('<body style="position:static"/>');
            }
            return this._iframe.contentDocument;
        };
        // closes the print document before printing
        PrintDocument.prototype._close = function () {
            // close document before applying title and style sheets
            var doc = this._getDocument();
            doc.close();
            // add title
            doc.title = this.title != null
                ? this.title
                : document.title;
            // replace whitespace-only title with non-breaking space (TFS 281035, 292059)
            // https://stackoverflow.com/questions/23556255/how-can-i-have-a-blank-title-page
            if (!doc.title || !doc.title.trim()) {
                doc.title = '\u00A0';
            }
            // add main document style sheets
            if (this._copyCss) {
                var links = document.head.querySelectorAll('link');
                for (var i = 0; i < links.length; i++) {
                    var link = links[i];
                    if (link.href.match(/\.css$/i) && link.rel.match(/stylesheet/i)) {
                        var xhr = wijmo.httpRequest(link.href, { async: false });
                        this._addStyle(xhr.responseText);
                    }
                }
                var styles = document.head.querySelectorAll('STYLE');
                for (var i = 0; i < styles.length; i++) {
                    this._addStyle(styles[i].textContent);
                }
            }
            // add extra style sheets
            if (this._css) {
                for (var i = 0; i < this._css.length; i++) {
                    var es = doc.createElement('style'), xhr = wijmo.httpRequest(this._css[i], { async: false });
                    es.textContent = xhr.responseText;
                    doc.head.appendChild(es);
                }
            }
        };
        PrintDocument.prototype._addStyle = function (style) {
            var doc = this._getDocument(), es = doc.createElement('style');
            es.textContent = style;
            doc.head.appendChild(es);
        };
        return PrintDocument;
    }());
    wijmo.PrintDocument = PrintDocument;
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    'use strict';
    /**
     * Class that provides masking services to an HTMLInputElement.
     */
    var _MaskProvider = /** @class */ (function () {
        /**
         * Initializes a new instance of the @see:_MaskProvider class.
         *
         * @param input Input element to be masked.
         * @param mask Input mask.
         * @param promptChar Character used to indicate input positions.
         */
        function _MaskProvider(input, mask, promptChar) {
            if (mask === void 0) { mask = null; }
            if (promptChar === void 0) { promptChar = '_'; }
            this._promptChar = '_';
            this._mskArr = [];
            this._full = true;
            this._hbInput = this._input.bind(this);
            this._hbKeyDown = this._keydown.bind(this);
            this._hbKeyPress = this._keypress.bind(this);
            this._hbCompositionStart = this._compositionstart.bind(this);
            this._hbCompositionEnd = this._compositionend.bind(this);
            this.mask = mask;
            this.input = input;
            this.promptChar = promptChar;
            this._connect(true);
            // raise input event on input element after applying mask (TFS 298529)
            this._evtInput = document.createEvent('HTMLEvents');
            this._evtInput.initEvent('input', true, false);
        }
        Object.defineProperty(_MaskProvider.prototype, "input", {
            /**
             * Gets or sets the Input element to be masked.
             */
            get: function () {
                return this._tbx;
            },
            set: function (value) {
                this._connect(false);
                this._tbx = value;
                this._connect(true);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(_MaskProvider.prototype, "mask", {
            /**
             * Gets or sets the input mask used to validate input.
             */
            get: function () {
                return this._msk;
            },
            set: function (value) {
                if (value != this._msk) {
                    this._msk = wijmo.asString(value, true);
                    this._parseMask();
                    this._valueChanged();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(_MaskProvider.prototype, "promptChar", {
            /**
             * Gets or sets the input mask used to validate input.
             */
            get: function () {
                return this._promptChar;
            },
            set: function (value) {
                if (value != this._promptChar) {
                    this._promptChar = wijmo.asString(value, false);
                    wijmo.assert(this._promptChar.length == 1, 'promptChar must be a string with length 1.');
                    this._valueChanged();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(_MaskProvider.prototype, "maskFull", {
            /**
             * Gets a value that indicates whether the mask has been completely filled.
             */
            get: function () {
                return this._full;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * Gets an array with the position of the first and last wildcard characters in the mask.
         */
        _MaskProvider.prototype.getMaskRange = function () {
            return this._mskArr.length ? [this._firstPos, this._lastPos] : [0, this._tbx.value.length - 1];
        };
        /**
         * Gets the raw value of the editor, excluding prompts and literals.
         */
        _MaskProvider.prototype.getRawValue = function () {
            var text = this._tbx.value, ret = '';
            // no mask? it's all raw
            if (!this.mask) {
                return text;
            }
            // get raw input (no literals or prompts)
            for (var i = 0; i < this._mskArr.length && i < text.length; i++) {
                if (!this._mskArr[i].literal && text[i] != this._promptChar) {
                    ret += text[i];
                }
            }
            // done
            return ret;
        };
        /**
         * Updates the control mask and content.
         */
        _MaskProvider.prototype.refresh = function () {
            this._parseMask();
            this._valueChanged();
        };
        // ** event handlers
        // apply mask and update cursor position after any changes
        _MaskProvider.prototype._input = function (e) {
            var _this = this;
            if (this._composing) {
                e.stopImmediatePropagation(); // no input events while composing
            }
            else {
                setTimeout(function () {
                    _this._valueChanged();
                });
            }
        };
        // special handling for backspacing over literals
        _MaskProvider.prototype._keydown = function (e) {
            // ignore backspaces before first wildcard (TFS 199372, 199901)
            if (e.keyCode == wijmo.Key.Back) {
                var start = this._tbx.selectionStart, end = this._tbx.selectionEnd;
                if (start <= this._firstPos && end == start) {
                    e.preventDefault();
                    this._backSpace = false;
                    return;
                }
            }
            // handle backspacing over literals
            this._backSpace = (e.keyCode == wijmo.Key.Back);
        };
        // prevent flicker when invalid keys are pressed
        // NOTE: IE on Windows Phone 8.x does not raise keypress!!!
        _MaskProvider.prototype._keypress = function (e) {
            if (!e.ctrlKey && !e.metaKey && !e.altKey && !this._composing && this._preventKey(e.charCode)) {
                e.preventDefault();
            }
        };
        // handle IME composition
        _MaskProvider.prototype._compositionstart = function (e) {
            this._composing = true;
        };
        _MaskProvider.prototype._compositionend = function (e) {
            var _this = this;
            if (this._composing) {
                this._composing = false;
                setTimeout(function () {
                    if (_this._valueChanged()) {
                        _this._tbx.dispatchEvent(_this._evtInput);
                    }
                });
            }
        };
        // ** implementation
        // prevent a key from being handled if it is invalid
        _MaskProvider.prototype._preventKey = function (charCode) {
            if (charCode && this._mskArr.length) {
                var tbx = this._tbx, start = tbx.selectionStart, key = String.fromCharCode(charCode);
                // make sure we're at a placeholder
                if (start < this._firstPos) {
                    start = this._firstPos;
                    wijmo.setSelectionRange(tbx, start);
                }
                // past the end?
                if (start >= this._mskArr.length) {
                    return true;
                }
                // skip over literals and validate templates (TFS 117584)
                var m = this._mskArr[start];
                if (m.literal) {
                    this._validatePosition(start);
                }
                else if (m.wildCard != key && !this._isCharValid(m.wildCard, key)) {
                    return true;
                }
            }
            // key seems OK, do not prevent
            return false;
        };
        // connect or disconnect event handlers for the input element
        _MaskProvider.prototype._connect = function (connect) {
            var tbx = this._tbx;
            if (tbx) {
                if (connect) {
                    this._autoComplete = tbx.autocomplete;
                    this._spellCheck = tbx.spellcheck;
                    tbx.autocomplete = 'off'; // important for mobile browsers (including Chrome/Android)
                    tbx.spellcheck = false; // no spell-checking on masked inputs
                    tbx.addEventListener('input', this._hbInput);
                    tbx.addEventListener('keydown', this._hbKeyDown, true);
                    tbx.addEventListener('keypress', this._hbKeyPress, true);
                    tbx.addEventListener('compositionstart', this._hbCompositionStart, true);
                    tbx.addEventListener('compositionend', this._hbCompositionEnd, true);
                    tbx.addEventListener('blur', this._hbCompositionEnd, true); // Safari does not finish composition on blur (TFS 236810)
                    this._valueChanged();
                }
                else {
                    tbx.autocomplete = this._autoComplete;
                    tbx.spellcheck = this._spellCheck;
                    tbx.removeEventListener('input', this._hbInput);
                    tbx.removeEventListener('keydown', this._hbKeyDown, true);
                    tbx.removeEventListener('keypress', this._hbKeyPress, true);
                    tbx.removeEventListener('compositionstart', this._hbCompositionStart, true);
                    tbx.removeEventListener('compositionend', this._hbCompositionEnd, true);
                    tbx.removeEventListener('blur', this._hbCompositionEnd, true);
                }
            }
        };
        // apply the mask keeping the cursor position and the focus
        _MaskProvider.prototype._valueChanged = function () {
            // sanity
            if (!this._tbx || !this._msk) {
                return false;
            }
            // keep track of selection start, character at selection
            var tbx = this._tbx, wasEmpty = tbx.value.length < 2, start = tbx.selectionStart, oldChar = (start > 0) ? tbx.value[start - 1] : '', oldValue = tbx.value;
            // apply the mask
            tbx.value = this._applyMask();
            // handle case when the string was empty and the mask
            // doesn't start with a wildcard (e.g. "(000)-0000")
            if (wasEmpty) {
                start = this._firstPos + 1;
            }
            // backtrack if the original character was replaced with a prompt
            var newChar = (start > 0) ? tbx.value[start - 1] : '';
            if (start > 0 && newChar == this._promptChar && oldChar != this.promptChar) {
                start--;
            }
            // if the start was at the end of the original value, move it
            // to where the match ended (e.g. "123456" -> "0000-0000-0000")
            if (start == oldValue.length) {
                start = this._matchEnd;
            }
            // validate the position based on the cursor position or on
            // where the match ended
            this._validatePosition(start);
            // update validity state?
            // not yet... if/when we do this, we have to be consistent
            //tbx.setCustomValidity(this.maskFull ? '' : 'The mask is not full.')
            // done
            return oldValue != tbx.value;
        };
        // applies the mask to the current text content, returns the result 
        // this is usually a valid string with the same length as the mask, unless 
        // (a) there's no mask, or 
        // (b) there's no text and the input is not required
        _MaskProvider.prototype._applyMask = function () {
            // assume we're complete
            this._full = true;
            this._matchEnd = 0;
            // no mask? accept everything
            var text = this._tbx.value;
            if (!this._msk) {
                return text;
            }
            // no text OK if not required
            if (!text && !this._tbx.required) {
                return text;
            }
            // handle vague literals (could be interpreted as content)
            var ret = '', pos = 0, promptChar = this._promptChar;
            text = this._handleVagueLiterals(text);
            // build output string based on current content and mask
            for (var i = 0; i < this._mskArr.length; i++) {
                // get mask element
                var m = this._mskArr[i], c = m.literal;
                // if this is a literal, match with text at cursor
                if (c && c == text[pos]) {
                    pos++;
                }
                // if it is a wildcard, match with text starting at the cursor
                if (m.wildCard) {
                    c = promptChar;
                    if (text) {
                        var j = pos;
                        for (; j < text.length; j++) {
                            if (this._isCharValid(m.wildCard, text[j])) {
                                // get character to add to return value
                                c = text[j];
                                switch (m.charCase) {
                                    case '>':
                                        c = c.toUpperCase();
                                        break;
                                    case '<':
                                        c = c.toLowerCase();
                                        break;
                                }
                                // keep track of where the matching ended
                                if (c != promptChar) {
                                    this._matchEnd = ret.length + 1;
                                }
                                // move on
                                break;
                            }
                        }
                        pos = j + 1;
                    }
                    // still prompt? then the mask is not full
                    if (c == promptChar) {
                        this._full = false;
                    }
                }
                // add to output
                ret += c;
            }
            // done applying mask, return result
            return ret;
        };
        // fix text to handle vague literals (that could be interpreted as content)
        _MaskProvider.prototype._handleVagueLiterals = function (text) {
            // looks like a paste, don't mess with it (TFS 139412, 145560)
            if (text.length > this._mskArr.length + 1) {
                return text;
            }
            // see if we're shrinking or growing
            var delta = text.length - this._mskArr.length;
            if (delta != 0 && text.length > 1) {
                // see if we have a 'vague' literal
                var badIndex = -1, start = Math.max(0, this._tbx.selectionStart - delta);
                for (var i = start; i < this._mskArr.length; i++) {
                    if (this._mskArr[i].vague) {
                        badIndex = i;
                        break;
                    }
                }
                // we do, so handle it
                if (badIndex > -1) {
                    //console.log(' text: [' + text + ']');
                    if (delta < 0) {
                        var pad = Array(1 - delta).join(this._promptChar), index = badIndex + delta;
                        if (index > -1) {
                            text = text.substr(0, index) + pad + text.substr(index);
                        }
                    }
                    else {
                        while (badIndex > 0 && this._mskArr[badIndex - 1].literal) {
                            badIndex--;
                        }
                        text = text.substr(0, badIndex) + text.substr(badIndex + delta);
                    }
                    //console.log('fixed: [' + text + ']');
                }
            }
            // done
            return text;
        };
        // checks whether a character is valid for a given mask character
        _MaskProvider.prototype._isCharValid = function (mask, c) {
            var ph = this._promptChar;
            switch (mask) {
                // regular wildcards
                case '0':// Digit
                    return (c >= '0' && c <= '9') || c == ph;
                case '9':// Digit or space
                    return (c >= '0' && c <= '9') || c == ' ' || c == ph;
                case '#':// Digit, sign, or space
                    return (c >= '0' && c <= '9') || c == ' ' || c == '+' || c == '-' || c == ph;
                case 'L':// Letter
                    return (c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z') || c == ph;
                case 'l':// Letter or space
                    return (c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z') || c == ' ' || c == ph;
                case 'A':// Alphanumeric
                    return (c >= '0' && c <= '9') || (c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z') || c == ph;
                case 'a':// Alphanumeric or space
                    return (c >= '0' && c <= '9') || (c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z') || c == ' ' || c == ph;
                // Katakana/Hiragana wildcards
                case '\uff19':// DBCS Digit
                    return (c >= '\uFF10' && c <= '\uff19') || c == ph;
                case '\uff2a': // DBCS Hiragana
                case '\uff27':// DBCS big Hiragana
                    if (mask == '\uff27' && _MaskProvider._X_DBCS_BIG_HIRA.indexOf(c) > -1)
                        return false; // exceptions
                    return (c >= '\u3041' && c <= '\u3096') || c == ph;
                case '\uff2b': // DBCS Katakana
                case '\uff2e':// DBCS big Katakana
                    if (mask == '\uff2e' && _MaskProvider._X_DBCS_BIG_KATA.indexOf(c) > -1)
                        return false; // exceptions
                    return (c >= '\u30a1' && c <= '\u30fa') || c == ph;
                case '\uff3a':// Any DBCS
                    return (c <= '\u0021' || c >= '\u00ff') || c == ph;
                case 'H':// Any SBCS
                    return (c >= '\u0021' && c <= '\u00ff') || c == ph;
                case 'K': // SBCS Katakana
                case 'N':// SBCS big Katakana
                    if (mask == 'N' && _MaskProvider._X_SBCS_BIG_KATA.indexOf(c) > -1)
                        return false; // exceptions
                    return (c >= '\uff66' && c <= '\uff9f') || c == ph;
            }
            return false;
        };
        // skip over literals
        _MaskProvider.prototype._validatePosition = function (start) {
            var msk = this._mskArr;
            // skip left if the last key pressed was a backspace
            if (this._backSpace) {
                while (start > 0 && start < msk.length && msk[start - 1].literal) {
                    start--;
                }
            }
            // skip right over literals
            if (start == 0 || !this._backSpace) {
                while (start < msk.length && msk[start].literal) {
                    start++;
                }
            }
            // move selection to start
            if (wijmo.getActiveElement() == this._tbx) {
                wijmo.setSelectionRange(this._tbx, start);
            }
            // no longer backspacing
            this._backSpace = false;
        };
        // parse mask into internal mask, literals, and case
        _MaskProvider.prototype._parseMask = function () {
            // clear internal mask info
            this._mskArr = [];
            this._firstPos = -1;
            this._lastPos = -1;
            // parse new mask
            var msk = this._msk, currCase = '|', c;
            for (var i = 0; msk && i < msk.length; i++) {
                switch (msk[i]) {
                    // wildcards
                    case '0': // digit.
                    case '9': // Digit or space.
                    case '#': // Digit, sign, or space.
                    case 'A': // Alphanumeric.
                    case 'a': // Alphanumeric or space.
                    case 'L': // Letter.
                    case 'l': // Letter or space.
                    // Katakana/Hiragana wildcards
                    case '\uff19': // DBCS Digit.
                    case '\uff2a': // DBCS Hiragana.
                    case '\uff27': // DBCS big Hiragana.
                    case '\uff2b': // DBCS Katakana.
                    case '\uff2e': // DBCS big Katakana.
                    case '\uff3a': // Any DBCS
                    case 'K': // SBCS Katakana.
                    case 'N': // SBCS big Katakana.
                    case 'H':// Any SBCS character.
                        if (this._firstPos < 0) {
                            this._firstPos = this._mskArr.length;
                        }
                        this._lastPos = this._mskArr.length;
                        this._mskArr.push(new _MaskElement(msk[i], currCase));
                        break;
                    // localized literals
                    case '.': // Decimal separator.
                    case ',': // Thousands separator.
                    case ':': // Time separator.
                    case '/': // Date separator.
                    case '$':// Currency symbol.
                        switch (msk[i]) {
                            case '.':
                            case ',':
                                c = wijmo.culture.Globalize.numberFormat[msk[i]];
                                break;
                            case ':':
                            case '/':
                                c = wijmo.culture.Globalize.calendar[msk[i]];
                                break;
                            case '$':
                                c = wijmo.culture.Globalize.numberFormat.currency.symbol;
                                break;
                        }
                        for (var j = 0; j < c.length; j++) {
                            this._mskArr.push(new _MaskElement(c[j]));
                        }
                        break;
                    // case-shifting
                    case '<': // Shift down (converts characters that follow to lowercase).
                    case '>': // Shift up (converts characters that follow to uppercase).
                    case '|':// Disable any previous shifts.
                        currCase = msk[i];
                        break;
                    // literals
                    case '\\':// Escape next character into literal.
                        if (i < msk.length - 1)
                            i++;
                        this._mskArr.push(new _MaskElement(msk[i]));
                        break;
                    default:// All others: Literals.
                        this._mskArr.push(new _MaskElement(msk[i]));
                        break;
                }
            }
            // keep track of vague (ambiguous) literals
            for (var i = 0; i < this._mskArr.length; i++) {
                var elem = this._mskArr[i];
                if (elem.literal) {
                    for (var j = 0; j < i; j++) {
                        var m = this._mskArr[j];
                        if (m.wildCard && this._isCharValid(m.wildCard, elem.literal)) {
                            elem.vague = true;
                            break;
                        }
                    }
                }
            }
        };
        // big DBCS/SBCS exception lists
        _MaskProvider._X_DBCS_BIG_HIRA = '\u3041\u3043\u3045\u3047\u3049\u3063\u3083\u3085\u3087\u308e\u3095\u3096';
        _MaskProvider._X_DBCS_BIG_KATA = '\u30a1\u30a3\u30a5\u30a7\u30a9\u30c3\u30e3\u30e5\u30e7\u30ee\u30f5\u30f6';
        _MaskProvider._X_SBCS_BIG_KATA = '\uff67\uff68\uff69\uff6a\uff6b\uff6c\uff6d\uff6e\uff6f';
        return _MaskProvider;
    }());
    wijmo._MaskProvider = _MaskProvider;
    /**
     * Class that contains information about a position in an input mask.
     */
    var _MaskElement = /** @class */ (function () {
        /**
         * Initializes a new instance of the @see:_MaskElement class.
         *
         * @param wildcardOrLiteral Wildcard or literal character
         * @param charCase Whether to convert wildcard matches to upper or lowercase.
         */
        function _MaskElement(wildcardOrLiteral, charCase) {
            if (charCase) {
                this.wildCard = wildcardOrLiteral;
                this.charCase = charCase;
            }
            else {
                this.literal = wildcardOrLiteral;
            }
        }
        return _MaskElement;
    }());
    wijmo._MaskElement = _MaskElement;
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    'use strict';
    /**
     * Class that provides repeat-clicking on behalf of an HTMLElement
     * (typically a button).
     */
    var _ClickRepeater = /** @class */ (function () {
        /**
         * Initializes a new instance of the @see:_ClickRepeater class.
         *
         * @param element Element that will raise click events while the mouse is down.
         */
        function _ClickRepeater(element) {
            this._isDown = false;
            this._mousedownBnd = this._mousedown.bind(this);
            this._mouseupBnd = this._mouseup.bind(this);
            this._onClickBnd = this._onClick.bind(this);
            this.element = element;
            this._connect(true);
        }
        Object.defineProperty(_ClickRepeater.prototype, "element", {
            /**
             * Gets or sets the element that will raise click events while the mouse is down.
             */
            get: function () {
                return this._e;
            },
            set: function (value) {
                this._connect(false);
                this._e = wijmo.asType(value, HTMLElement, true);
                this._connect(true);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(_ClickRepeater.prototype, "disabled", {
            /**
             * Gets or sets a value that determines whether this repeater is disabled.
             */
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this._disabled = wijmo.asBoolean(value);
            },
            enumerable: true,
            configurable: true
        });
        // ** implementation
        // connect or disconnect event handlers for the input element
        _ClickRepeater.prototype._connect = function (connect) {
            if (this._e) {
                var mousedown = 'mousedown';
                if (connect) {
                    this._e.addEventListener(mousedown, this._mousedownBnd);
                }
                else {
                    this._e.removeEventListener(mousedown, this._mousedownBnd);
                }
            }
        };
        // clear any pending timeOuts
        _ClickRepeater.prototype._clearTimeouts = function () {
            if (this._toRepeat) {
                clearInterval(this._toRepeat);
                this._toRepeat = null;
            }
            if (this._toDelay) {
                clearInterval(this._toDelay);
                this._toDelay = null;
            }
        };
        // start clicking on mousedown
        _ClickRepeater.prototype._mousedown = function (e) {
            var _this = this;
            if (this._isDown) {
                this._mouseup(null);
            }
            if (!this._disabled) {
                this._isDown = true;
                _ClickRepeater._stopEvents.forEach(function (evt) {
                    document.addEventListener(evt, _this._mouseupBnd);
                });
                this._clearTimeouts();
                this._toDelay = setTimeout(function () {
                    if (_this._isDown) {
                        _this._onClick();
                        _this._toRepeat = setTimeout(_this._onClickBnd, wijmo.Control._CLICK_REPEAT);
                    }
                }, wijmo.Control._CLICK_DELAY);
            }
        };
        // stop clicking on mouseup
        _ClickRepeater.prototype._mouseup = function (e) {
            var _this = this;
            if (this._isDown && e && e.type == 'mouseup') {
                e.preventDefault();
            }
            _ClickRepeater._stopEvents.forEach(function (evt) {
                document.removeEventListener(evt, _this._mouseupBnd);
            });
            this._clearTimeouts();
            this._isDown = false;
        };
        // raise click event
        _ClickRepeater.prototype._onClick = function () {
            this._e.click();
            this._clearTimeouts();
            if (this._isDown) {
                this._toRepeat = setTimeout(this._onClickBnd, wijmo.Control._CLICK_REPEAT);
            }
        };
        _ClickRepeater._stopEvents = ['mouseup', 'mouseout', 'keydown'];
        return _ClickRepeater;
    }());
    wijmo._ClickRepeater = _ClickRepeater;
})(wijmo || (wijmo = {}));

//
// IE9 polyfills
var wijmo;
(function (wijmo) {
    'use strict';
    // expose mobile flag to callers that need it
    var _isMobile = navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i) != null;
    function isMobile() {
        return _isMobile;
    }
    wijmo.isMobile = isMobile;
    // expose Firefox flag to callers that need it
    var _isFF = navigator.userAgent.match(/Firefox\//) != null;
    function isFirefox() {
        return _isFF;
    }
    wijmo.isFirefox = isFirefox;
    // expose Safari flag to callers that need it
    var _isSafari = navigator.userAgent.match(/^((?!chrome|android).)*safari/i) != null;
    function isSafari() {
        return _isSafari;
    }
    wijmo.isSafari = isSafari;
    // expose IE flag to callers that need it
    var _isIE = navigator.userAgent.match(/MSIE |Trident\/|Edge\//) != null;
    function isIE() {
        return _isIE;
    }
    wijmo.isIE = isIE;
    // expose IE9 flag to callers that need it
    var _isIE9 = false;
    function isIE9() {
        return _isIE9;
    }
    wijmo.isIE9 = isIE9;
    // detect passive event support
    // https://developers.google.com/web/updates/2016/06/passive-event-listeners
    var _supportsPassive = false;
    document.addEventListener('test', function (_) { }, {
        get passive() {
            _supportsPassive = true;
            return true;
        }
    });
    function getEventOptions(capture, passive) {
        return _supportsPassive
            ? { capture: capture, passive: passive }
            : capture;
    }
    wijmo.getEventOptions = getEventOptions;
    // set allowed effect, data
    function _startDrag(dataTransfer, effectAllowed) {
        dataTransfer.effectAllowed = effectAllowed;
        if (isFirefox()) {
            dataTransfer.setData('text', '');
        }
    }
    wijmo._startDrag = _startDrag;
    // implement HTML5 drag-drop behavior in IE9.
    if (document.doctype && navigator.appVersion.indexOf('MSIE 9') > -1) {
        // remember this is IE9...
        _isIE9 = true;
        // TFS 140812: 'selectstart' does not work in popup dialogs, so use 'mousemove'
        // instead. It's less efficient but it works, and this only matters in IE9.
        document.addEventListener('mousemove', function (e) {
            if (e.which == 1) {
                var ctl = wijmo.closest(e.target, '.wj-control');
                if (ctl && !ctl.style.cursor) {
                    for (var el = e.target; el; el = el.parentNode) {
                        if (el.attributes && el.attributes['draggable']) {
                            el.dragDrop();
                            return false;
                        }
                    }
                }
            }
        });
    }
    // implement requestAnimationFrame/cancelAnimationFrame in IE9.
    // https://gist.github.com/rma4ok/3371337
    var raf = 'requestAnimationFrame', caf = 'cancelAnimationFrame';
    if (!window[raf]) {
        var expectedTime_1 = 0;
        window[raf] = function (callback) {
            var currentTime = Date.now(), adjustedDelay = 16 - (currentTime - expectedTime_1), delay = adjustedDelay > 0 ? adjustedDelay : 0;
            expectedTime_1 = currentTime + delay;
            return setTimeout(function () {
                callback(expectedTime_1);
            }, delay);
        };
        window[caf] = clearTimeout;
    }
})(wijmo || (wijmo = {}));


/*
    *
    * Wijmo Library 5.20173.409
    * http://wijmo.com/
    *
    * Copyright(c) GrapeCity, Inc.  All rights reserved.
    *
    * Licensed under the GrapeCity Commercial License.
    * sales@wijmo.com
    * wijmo.com/products/wijmo-5/license/
    *
    */
///<wijmo-soft-import from="wijmo.input"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// enable use of EcmaScript6 maps
//declare var Map: any;
// initialize groupHeaderFormat
wijmo.culture.FlexGrid = window['wijmo'].culture.FlexGrid || {
    groupHeaderFormat: '{name}: <b>{value}</b> ({count:n0} items)'
};
/**
 * Defines the @see:FlexGrid control and associated classes.
 *
 * The example below creates a @see:FlexGrid control and binds it to a
 * 'data' array. The grid has four columns, specified by explicitly
 * populating the grid's @see:FlexGrid.columns array.
 *
 * @fiddle:6GB66
 */
var wijmo;
(function (wijmo) {
    var grid;
    (function (grid) {
        'use strict';
        /**
         * Specifies constants that define the visibility of row and column headers.
         */
        var HeadersVisibility;
        (function (HeadersVisibility) {
            /** No header cells are displayed. */
            HeadersVisibility[HeadersVisibility["None"] = 0] = "None";
            /** Only column header cells are displayed. */
            HeadersVisibility[HeadersVisibility["Column"] = 1] = "Column";
            /** Only row header cells are displayed. */
            HeadersVisibility[HeadersVisibility["Row"] = 2] = "Row";
            /** Both column and row header cells are displayed. */
            HeadersVisibility[HeadersVisibility["All"] = 3] = "All";
        })(HeadersVisibility = grid.HeadersVisibility || (grid.HeadersVisibility = {}));
        /**
         * The @see:FlexGrid control provides a powerful and flexible way to
         * display and edit data in a tabular format.
         *
         * The @see:FlexGrid control is a full-featured grid, providing all the
         * features you are used to including several selection modes, sorting,
         * column reordering, grouping, filtering, editing, custom cells,
         * XAML-style star-sizing columns, row and column virtualization, etc.
         *
         * The @see:FlexGrid control supports the following keyboard commands:
         *
         * <table>
         *   <thead>
         *     <tr><th>Key Combination</th><th>Action</th></tr>
         *   </thead>
         *   <tbody>
         *     <tr><td>Shift + Space</td><td>Select row</td></tr>
         *     <tr><td>Control + Space</td><td>Select column</td></tr>
         *     <tr><td>F2</td><td>Start editing the current cell</td></tr>
         *     <tr><td>Space</td><td>Start editing or toggle checkbox</td></tr>
         *     <tr><td>Control + A</td><td>Select the entire grid contents</td></tr>
         *     <tr><td>Left/Right</td><td>Select the cell to the left/right of the selection, collapse/expand group rows</td></tr>
         *     <tr><td>Shift + Left/Right</td><td>Extend the selection to include the next cell to the left/right of the selection</td></tr>
         *     <tr><td>Up/Down</td><td>Select the next cell above or below the selection</td></tr>
         *     <tr><td>Shift + Up/Down</td><td>Extend the selection to include the cell above or below the selection</td></tr>
         *     <tr><td>Alt + Up/Down</td><td>Drop down the listbox editor for the current cell</td></tr>
         *     <tr><td>PageUp/Down</td><td>Select the cell one page above or below the selection</td></tr>
         *     <tr><td>Shift + PageUp/Down</td><td>Extend the selection to include the cell one page above or below the selection</td></tr>
         *     <tr><td>Alt + PageUp/Down</td><td>Move the selection to the first or last row</td></tr>
         *     <tr><td>Shift + Alt + PageUp/Down</td><td>Extend the selection to include the first or last row</td></tr>
         *     <tr><td>Home/End</td><td>Move the selection to the first or last column</td></tr>
         *     <tr><td>Shift + Home/End</td><td>Extend the selection to include the first or last column</td></tr>
         *     <tr><td>Ctrl + Home/End</td><td>Move the selection to the first/last row and column</td></tr>
         *     <tr><td>Shift + Ctrl + Home/End</td><td>Extend the selection to include the first/last row and column</td></tr>
         *     <tr><td>Escape</td><td>Cancel current cell or row editing operation</td></tr>
         *     <tr><td>Tab</td><td>Move the selection to the next focusable element on the page (by default, can be overridden using the @see:keyActionTab property)</td></tr>
         *     <tr><td>Enter</td><td>Exit editing mode and move the selection to the cell below the current one (by default, can be overridden using the @see:keyActionEnter property)</td></tr>
         *     <tr><td>Delete, Backspace</td><td>Delete the currently selected rows (if the @see:allowDelete property is set to true), or clear the content of the selected cells (if the values are not required).</td></tr>
         *     <tr><td>Control + C or Control + Insert</td><td>Copy the selection to the clipboard (if the @see:autoClipboard property is set to true)</td></tr>
         *     <tr><td>Control + V or Shift + Insert</td><td>Paste the content of the clipboard into the selected area (if the @see:autoClipboard property is set to true)</td></tr>
         *   </tbody>
         * </table>
         *
         * @fiddle:6GB66
         */
        var FlexGrid = /** @class */ (function (_super) {
            __extends(FlexGrid, _super);
            /**
             * Initializes a new instance of the @see:FlexGrid class.
             *
             * @param element The DOM element that will host the control, or a selector for the host element (e.g. '#theCtrl').
             * @param options JavaScript object containing initialization data for the control.
             */
            function FlexGrid(element, options) {
                var _this = _super.call(this, element, null, true) || this;
                /*private*/ _this._szClient = new wijmo.Size(0, 0);
                /*private*/ _this._ptScrl = new wijmo.Point(0, 0); // accessible to GridPanel
                /*private*/ _this._cellPadding = 3; // accessible to CellFactory
                /*private*/ _this._clipToScreen = false;
                // property storage
                _this._autoGenCols = true;
                _this._autoClipboard = true;
                _this._readOnly = false;
                _this._indent = 14;
                _this._autoSizeMode = grid.AutoSizeMode.Both;
                _this._hdrVis = HeadersVisibility.All;
                _this._alSorting = true;
                _this._alAddNew = false;
                _this._alDelete = false;
                _this._alResizing = grid.AllowResizing.Columns;
                _this._alDragging = grid.AllowDragging.Columns;
                _this._alMerging = grid.AllowMerging.None;
                _this._ssHdr = HeadersVisibility.None;
                _this._shSort = true;
                _this._shGroups = true;
                _this._shAlt = true;
                _this._shErr = true;
                _this._shDropDown = true;
                _this._valEdt = true;
                _this._deferResizing = false;
                _this._pSel = true; // preserve selection state
                _this._pOutline = true; // preserve outline state
                _this._vt = 0; // virtualization threshold
                //#endregion
                //--------------------------------------------------------------------------
                //#region ** events
                /**
                 * Occurs after the grid has been bound to a new items source.
                 */
                _this.itemsSourceChanging = new wijmo.Event();
                /**
                 * Occurs after the grid has been bound to a new items source.
                 */
                _this.itemsSourceChanged = new wijmo.Event();
                /**
                 * Occurs after the control has scrolled.
                 */
                _this.scrollPositionChanged = new wijmo.Event();
                /**
                 * Occurs before selection changes.
                 */
                _this.selectionChanging = new wijmo.Event();
                /**
                 * Occurs after selection changes.
                 */
                _this.selectionChanged = new wijmo.Event();
                /**
                 * Occurs before the grid rows are bound to items in the data source.
                 */
                _this.loadingRows = new wijmo.Event();
                /**
                 * Occurs after the grid rows have been bound to items in the data source.
                 */
                _this.loadedRows = new wijmo.Event();
                /**
                 * Occurs before the grid updates its internal layout.
                 */
                _this.updatingLayout = new wijmo.Event();
                /**
                 * Occurs after the grid has updated its internal layout.
                 */
                _this.updatedLayout = new wijmo.Event();
                /**
                 * Occurs as columns are resized.
                 */
                _this.resizingColumn = new wijmo.Event();
                /**
                 * Occurs when the user finishes resizing a column.
                 */
                _this.resizedColumn = new wijmo.Event();
                /**
                 * Occurs before the user auto-sizes a column by double-clicking the
                 * right edge of a column header cell.
                 */
                _this.autoSizingColumn = new wijmo.Event();
                /**
                 * Occurs after the user auto-sizes a column by double-clicking the
                 * right edge of a column header cell.
                 */
                _this.autoSizedColumn = new wijmo.Event();
                /**
                 * Occurs when the user starts dragging a column.
                 */
                _this.draggingColumn = new wijmo.Event();
                /**
                 * Occurs as the user drags a column to a new position.
                 *
                 * The handler may cancel the event to prevent users from
                 * dropping columns at certain positions. For example:
                 *
                 * <pre>// remember column being dragged
                 * flex.draggingColumn.addHandler(function (s, e) {
                 *     theColumn = s.columns[e.col].binding;
                 * });
                 *
                 * // prevent 'sales' column from being dragged to index 0
                 * s.draggingColumnOver.addHandler(function (s, e) {
                 *     if (theColumn == 'sales' && e.col == 0) {
                 *         e.cancel = true;
                 *     }
                 * });</pre>
                 */
                _this.draggingColumnOver = new wijmo.Event();
                /**
                 * Occurs when the user finishes dragging a column.
                 */
                _this.draggedColumn = new wijmo.Event();
                /**
                 * Occurs as rows are resized.
                 */
                _this.resizingRow = new wijmo.Event();
                /**
                 * Occurs when the user finishes resizing rows.
                 */
                _this.resizedRow = new wijmo.Event();
                /**
                 * Occurs before the user auto-sizes a row by double-clicking the
                 * bottom edge of a row header cell.
                 */
                _this.autoSizingRow = new wijmo.Event();
                /**
                 * Occurs after the user auto-sizes a row by double-clicking the
                 * bottom edge of a row header cell.
                 */
                _this.autoSizedRow = new wijmo.Event();
                /**
                 * Occurs when the user starts dragging a row.
                 */
                _this.draggingRow = new wijmo.Event();
                /**
                 * Occurs as the user drags a row to a new position.
                 */
                _this.draggingRowOver = new wijmo.Event();
                /**
                 * Occurs when the user finishes dragging a row.
                 */
                _this.draggedRow = new wijmo.Event();
                /**
                 * Occurs when a group is about to be expanded or collapsed.
                 */
                _this.groupCollapsedChanging = new wijmo.Event();
                /**
                 * Occurs after a group has been expanded or collapsed.
                 */
                _this.groupCollapsedChanged = new wijmo.Event();
                /**
                 * Occurs before the user applies a sort by clicking on a column header.
                 */
                _this.sortingColumn = new wijmo.Event();
                /**
                 * Occurs after the user applies a sort by clicking on a column header.
                 */
                _this.sortedColumn = new wijmo.Event();
                /**
                 * Occurs before a cell enters edit mode.
                 */
                _this.beginningEdit = new wijmo.Event();
                /**
                 * Occurs when an editor cell is created and before it becomes active.
                 */
                _this.prepareCellForEdit = new wijmo.Event();
                /**
                 * Occurs when a cell edit is ending.
                 *
                 * You can use this event to perform validation and prevent invalid edits.
                 * For example, the code below prevents users from entering values that
                 * do not contain the letter 'a'. The code demonstrates how you can obtain
                 * the old and new values before the edits are applied.
                 *
                 * <pre>function cellEditEnding (sender, e) {
                 *   // get old and new values
                 *   var flex = sender,
                 *       oldVal = flex.getCellData(e.row, e.col),
                 *       newVal = flex.activeEditor.value;
                 *   // cancel edits if newVal doesn't contain 'a'
                 *   e.cancel = newVal.indexOf('a') &lt; 0;
                 * }</pre>
                 *
                 * Setting the @see:CellEditEndingEventArgs.cancel parameter to
                 * true causes the grid to discard the edited value and keep the
                 * cell's original value.
                 *
                 * If you also set the @see:CellEditEndingEventArgs.stayInEditMode
                 * parameter to true, the grid will remain in edit mode so the user
                 * can correct invalid entries before committing the edits.
                 */
                _this.cellEditEnding = new wijmo.Event();
                /**
                 * Occurs when a cell edit has been committed or canceled.
                 */
                _this.cellEditEnded = new wijmo.Event();
                /**
                 * Occurs before a row enters edit mode.
                 */
                _this.rowEditStarting = new wijmo.Event();
                /**
                 * Occurs after a row enters edit mode.
                 */
                _this.rowEditStarted = new wijmo.Event();
                /**
                 * Occurs when a row edit is ending, before the changes are committed or canceled.
                 *
                 * This event can be used in conjunction with the @see:rowEditStarted event to
                 * implement deep-binding edit undos. For example:
                 *
                 * <pre>// save deep bound values when editing starts
                 * var itemData = {};
                 * s.rowEditStarted.addHandler(function (s, e) {
                 *   var item = s.collectionView.currentEditItem;
                 *   itemData = {};
                 *   s.columns.forEach(function (col) {
                 *     if (col.binding.indexOf('.') &gt; -1) { // deep binding
                 *       var binding = new wijmo.Binding(col.binding);
                 *       itemData[col.binding] = binding.getValue(item);
                 *     }
                 *   })
                 * });
                 *
                 * // restore deep bound values when edits are canceled
                 * s.rowEditEnded.addHandler(function (s, e) {
                 *   if (e.cancel) { // edits were canceled by the user
                 *     var item = s.collectionView.currentEditItem;
                 *     for (var k in itemData) {
                 *       var binding = new wijmo.Binding(k);
                 *       binding.setValue(item, itemData[k]);
                 *     }
                 *   }
                 *   itemData = {};
                 * });</pre>
                 */
                _this.rowEditEnding = new wijmo.Event();
                /**
                 * Occurs when a row edit has been committed or canceled.
                 */
                _this.rowEditEnded = new wijmo.Event();
                /**
                 * Occurs when the user creates a new item by editing the new row template
                 * (see the @see:allowAddNew property).
                 *
                 * The event handler may customize the content of the new item or cancel
                 * the new item creation.
                 */
                _this.rowAdded = new wijmo.Event();
                /**
                 * Occurs when the user is deleting a selected row by pressing the Delete
                 * key (see the @see:allowDelete property).
                 *
                 * The event handler may cancel the row deletion.
                 */
                _this.deletingRow = new wijmo.Event();
                /**
                 * Occurs after the user has deleted a row by pressing the Delete
                 * key (see the @see:allowDelete property).
                 */
                _this.deletedRow = new wijmo.Event();
                /**
                 * Occurs when the user is copying the selection content to the
                 * clipboard by pressing one of the clipboard shortcut keys
                 * (see the @see:autoClipboard property).
                 *
                 * The event handler may cancel the copy operation.
                 */
                _this.copying = new wijmo.Event();
                /**
                 * Occurs after the user has copied the selection content to the
                 * clipboard by pressing one of the clipboard shortcut keys
                 * (see the @see:autoClipboard property).
                 */
                _this.copied = new wijmo.Event();
                /**
                 * Occurs when the user is pasting content from the clipboard
                 * by pressing one of the clipboard shortcut keys
                 * (see the @see:autoClipboard property).
                 *
                 * The event handler may cancel the copy operation.
                 */
                _this.pasting = new wijmo.Event();
                /**
                 * Occurs after the user has pasted content from the
                 * clipboard by pressing one of the clipboard shortcut keys
                 * (see the @see:autoClipboard property).
                 */
                _this.pasted = new wijmo.Event();
                /**
                 * Occurs when the user is pasting content from the clipboard
                 * into a cell (see the @see:autoClipboard property).
                 *
                 * The event handler may cancel the copy operation.
                 */
                _this.pastingCell = new wijmo.Event();
                /**
                 * Occurs after the user has pasted content from the
                 * clipboard into a cell (see the @see:autoClipboard property).
                 */
                _this.pastedCell = new wijmo.Event();
                /**
                 * Occurs when an element representing a cell has been created.
                 *
                 * This event can be used to format cells for display. It is similar
                 * in purpose to the @see:itemFormatter property, but has the advantage
                 * of allowing multiple independent handlers.
                 *
                 * For example, this code removes the 'wj-wrap' class from cells in
                 * group rows:
                 *
                 * <pre>flex.formatItem.addHandler(function (s, e) {
                 *   if (flex.rows[e.row] instanceof wijmo.grid.GroupRow) {
                 *     wijmo.removeClass(e.cell, 'wj-wrap');
                 *   }
                 * });</pre>
                 */
                _this.formatItem = new wijmo.Event();
                /**
                 * Occurs when the grid starts creating/updating the elements that
                 * make up the current view.
                 */
                _this.updatingView = new wijmo.Event();
                /**
                 * Occurs when the grid finishes creating/updating the elements that
                 * make up the current view.
                 *
                 * The grid updates the view in response to several actions, including:
                 *
                 * <ul>
                 * <li>refreshing the grid or its data source,</li>
                 * <li>adding, removing, or changing rows or columns,</li>
                 * <li>resizing or scrolling the grid,</li>
                 * <li>changing the selection.</li>
                 * </ul>
                 */
                _this.updatedView = new wijmo.Event();
                // sort converter used to sort mapped columns by display value
                _this._mappedColumns = null;
                var host = _this.hostElement;
                // make sure we have no border radius if the browser is IE/Edge
                // (rounded borders **kill** scrolling perf!!!!)
                if (wijmo.isIE()) {
                    host.style.borderRadius = '0px';
                }
                // instantiate and apply template
                var tpl = _this.getTemplate();
                _this.applyTemplate('wj-control wj-flexgrid wj-content', tpl, {
                    _root: 'root',
                    _eSz: 'sz',
                    _eCt: 'cells',
                    _fCt: 'fcells',
                    _eTL: 'tl',
                    _eBL: 'bl',
                    _eCHdr: 'ch',
                    _eRHdr: 'rh',
                    _eCFtr: 'cf',
                    _eTLCt: 'tlcells',
                    _eBLCt: 'blcells',
                    _eCHdrCt: 'chcells',
                    _eCFtrCt: 'cfcells',
                    _eRHdrCt: 'rhcells',
                    _eMarquee: 'marquee',
                    _eFocus: 'focus'
                });
                // save tabindex, make host non-focusable
                _this._tabIndex = host.tabIndex;
                host.tabIndex = -1;
                // calculate default row height
                var defRowHei = _this._getDefaultRowHeight();
                // build the control
                _this.deferUpdate(function () {
                    // create row and column collections
                    _this._rows = new grid.RowCollection(_this, defRowHei);
                    _this._cols = new grid.ColumnCollection(_this, defRowHei * 4);
                    _this._hdrRows = new grid.RowCollection(_this, defRowHei);
                    _this._hdrCols = new grid.ColumnCollection(_this, Math.round(defRowHei * 1.25));
                    _this._ftrRows = new grid.RowCollection(_this, defRowHei);
                    // create grid panels
                    _this._gpTL = new grid.GridPanel(_this, grid.CellType.TopLeft, _this._hdrRows, _this._hdrCols, _this._eTLCt);
                    _this._gpCHdr = new grid.GridPanel(_this, grid.CellType.ColumnHeader, _this._hdrRows, _this._cols, _this._eCHdrCt);
                    _this._gpRHdr = new grid.GridPanel(_this, grid.CellType.RowHeader, _this._rows, _this._hdrCols, _this._eRHdrCt);
                    _this._gpCells = new grid.GridPanel(_this, grid.CellType.Cell, _this._rows, _this._cols, _this._eCt);
                    _this._gpBL = new grid.GridPanel(_this, grid.CellType.BottomLeft, _this._ftrRows, _this._hdrCols, _this._eBLCt);
                    _this._gpCFtr = new grid.GridPanel(_this, grid.CellType.ColumnFooter, _this._ftrRows, _this._cols, _this._eCFtrCt);
                    // add row and column headers
                    _this._hdrRows.push(new grid.Row());
                    _this._hdrCols.push(new grid.Column());
                    _this._hdrCols[0].align = 'center';
                    // initialize control
                    _this._cf = new grid.CellFactory();
                    _this._keyHdl = new grid._KeyboardHandler(_this);
                    _this._mouseHdl = new grid._MouseHandler(_this);
                    _this._edtHdl = new grid._EditHandler(_this);
                    _this._selHdl = new grid._SelectionHandler(_this);
                    _this._addHdl = new grid._AddNewHandler(_this);
                    _this._mrgMgr = new grid.MergeManager(_this);
                    _this._bndSortConverter = _this._sortConverter.bind(_this);
                    _this._bndScroll = _this._scroll.bind(_this);
                    // apply grid role to host element
                    wijmo.setAttribute(_this.cells.hostElement, 'role', 'grid', true);
                    // initialize SelectionMode
                    _this.selectionMode = grid.SelectionMode.CellRange;
                    // apply options after grid has been initialized
                    _this.initialize(options);
                });
                // update content when user scrolls the control
                _this.addEventListener(_this._root, 'scroll', function (e) {
                    if (_this._updateScrollPosition()) {
                        _this.finishEditing();
                        _this._updateContent(true);
                    }
                });
                // when you click an element with tabIndex < 0, Chrome and Firefox
                // move the focus to the body, which seems like the right thing to do.
                // IE gives the focus to the element even with tabIndex < 0, 
                // so let's fix that inconsistency here! // TFS 270776
                _this.addEventListener(host, 'focus', function (e) {
                    if (host.tabIndex > -1) {
                        var target = e.target;
                        if (target instanceof HTMLElement && target.tabIndex < 0) {
                            _this._setFocus(true); // force focus into valid element
                            return;
                        }
                    }
                }, true);
                return _this;
            }
            // reset rcBounds when window is resized
            // (even if the control size didn't change, because it may have moved: TFS 112961)
            FlexGrid.prototype._handleResize = function () {
                this._rcBounds = null;
                _super.prototype._handleResize.call(this);
            };
            Object.defineProperty(FlexGrid.prototype, "headersVisibility", {
                //--------------------------------------------------------------------------
                //#region ** object model
                /**
                 * Gets or sets a value that determines whether the row and column headers
                 * are visible.
                 */
                get: function () {
                    return this._hdrVis;
                },
                set: function (value) {
                    if (value != this._hdrVis) {
                        this._hdrVis = wijmo.asEnum(value, HeadersVisibility);
                        this.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "stickyHeaders", {
                /**
                 * Gets or sets a value that determines whether column headers should remain
                 * visible when the user scrolls the document.
                 */
                get: function () {
                    return this._stickyHdr;
                },
                set: function (value) {
                    if (value != this._stickyHdr) {
                        this._stickyHdr = wijmo.asBoolean(value);
                        this._updateStickyHeaders();
                        this.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "preserveSelectedState", {
                /**
                 * Gets or sets a value that determines whether the grid should preserve
                 * the selected state of rows when the data is refreshed.
                 */
                get: function () {
                    return this._pSel;
                },
                set: function (value) {
                    this._pSel = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "preserveOutlineState", {
                /**
                 * Gets or sets a value that determines whether the grid should preserve
                 * the expanded/collapsed state of nodes when the data is refreshed.
                 *
                 * The @see:preserveOutlineState property implementation is based on
                 * JavaScript's @see:Map object, which is not available in IE 9 or 10.
                 */
                get: function () {
                    return this._pOutline;
                },
                set: function (value) {
                    this._pOutline = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "virtualizationThreshold", {
                /**
                 * Gets or sets the minimum number of rows required to enable virtualization.
                 *
                 * This property is set to zero by default, meaning virtualization is always
                 * enabled. This improves binding performance and memory requirements, at the
                 * expense of a small performance decrease while scrolling.
                 *
                 * If your grid has a small number of rows (about 50 to 100), you may be able to
                 * improve scrolling performance by setting this property to a slightly higher
                 * value (like 150). This will disable virtualization and will slow down binding,
                 * but may improve perceived scroll performance.
                 *
                 * Setting this property to values higher than 200 is not recommended. Loading
                 * times will become too long; the grid will freeze for a few seconds while
                 * creating cells for all rows, and the browser will become slow because of
                 * the large number of elements on the page.
                 */
                get: function () {
                    return this._vt;
                },
                set: function (value) {
                    this._vt = wijmo.asNumber(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "autoGenerateColumns", {
                /**
                 * Gets or sets a value that determines whether the grid should generate columns
                 * automatically based on the @see:itemsSource.
                 *
                 * The column generation depends on the @see:itemsSource property containing
                 * at least one item. This data item is inspected and a column is created and
                 * bound to each property that contains a primitive value (number, string,
                 * Boolean, or Date).
                 *
                 * Properties set to null do not generate columns, because the grid would
                 * have no way of guessing the appropriate type. In this type of scenario,
                 * you should set the @see:autoGenerateColumns property to false and create
                 * the columns explicitly. For example:
                 *
                 * <pre>var grid = new wijmo.grid.FlexGrid('#theGrid', {
                 *   autoGenerateColumns: false, // data items may contain null values
                 *   columns: [                  // so define columns explicitly
                 *     { binding: 'name', header: 'Name', type: 'String' },
                 *     { binding: 'amount', header: 'Amount', type: 'Number' },
                 *     { binding: 'date', header: 'Date', type: 'Date' },
                 *     { binding: 'active', header: 'Active', type: 'Boolean' }
                 *   ],
                 *   itemsSource: customers
                 * });</pre>
                 */
                get: function () {
                    return this._autoGenCols;
                },
                set: function (value) {
                    this._autoGenCols = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "autoClipboard", {
                /**
                 * Gets or sets a value that determines whether the grid should handle
                 * clipboard shortcuts.
                 *
                 * The clipboard shortcuts are as follows:
                 *
                 * <dl class="dl-horizontal">
                 *   <dt>ctrl+C, ctrl+Ins</dt>    <dd>Copy grid selection to clipboard.</dd>
                 *   <dt>ctrl+V, shift+Ins</dt>   <dd>Paste clipboard text to grid selection.</dd>
                 * </dl>
                 *
                 * Only visible rows and columns are included in clipboard operations.
                 *
                 * Read-only cells are not affected by paste operations.
                 */
                get: function () {
                    return this._autoClipboard;
                },
                set: function (value) {
                    this._autoClipboard = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "columnLayout", {
                /**
                 * Gets or sets a JSON string that defines the current column layout.
                 *
                 * The column layout string represents an array with the columns and their
                 * properties. It can be used to persist column layouts defined by users so
                 * they are preserved across sessions, and can also be used to implement undo/redo
                 * functionality in applications that allow users to modify the column layout.
                 *
                 * The column layout string does not include <b>dataMap</b> properties, because
                 * data maps are not serializable.
                 */
                get: function () {
                    var props = FlexGrid._getSerializableProperties(grid.Column), defs = new grid.Column(), proxyCols = [];
                    // populate array with proxy columns
                    // save only primitive value and non-default settings
                    // don't save 'size', we are already saving 'width'
                    for (var i = 0; i < this.columns.length; i++) {
                        var col = this.columns[i], proxyCol = {};
                        for (var j = 0; j < props.length; j++) {
                            var prop = props[j], value = col[prop];
                            if (value != defs[prop] && wijmo.isPrimitive(value) && prop != 'size') {
                                proxyCol[prop] = value;
                            }
                        }
                        proxyCols.push(proxyCol);
                    }
                    // return JSON string with proxy columns
                    return JSON.stringify({ columns: proxyCols });
                },
                set: function (value) {
                    var colOptions = JSON.parse(wijmo.asString(value));
                    if (!colOptions || colOptions.columns == null) {
                        throw 'Invalid columnLayout data.';
                    }
                    this.columns.clear();
                    this.initialize(colOptions);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "isReadOnly", {
                /**
                 * Gets or sets a value that determines whether the user can modify
                 * cell values using the mouse and keyboard.
                 */
                get: function () {
                    return this._readOnly;
                },
                set: function (value) {
                    if (value != this._readOnly) {
                        this._readOnly = wijmo.asBoolean(value);
                        this.finishEditing();
                        this.invalidate(true); // TFS 79965
                        this._addHdl.updateNewRowTemplate(); // TFS 97544
                        wijmo.toggleClass(this.hostElement, 'wj-state-readonly', this.isReadOnly);
                        this._setAria('readonly', this.isReadOnly ? 'true' : null);
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "imeEnabled", {
                /**
                 * Gets or sets a value that determines whether the grid should support
                 * Input Method Editors (IME) while not in edit mode.
                 *
                 * This property is relevant only for sites/applications in Japanese,
                 * Chinese, Korean, and other languages that require IME support.
                 */
                get: function () {
                    return this._imeHdl != null;
                },
                set: function (value) {
                    if (value != this.imeEnabled) {
                        if (this._imeHdl) {
                            this._imeHdl.dispose();
                            this._imeHdl = null;
                        }
                        if (value) {
                            this._imeHdl = new grid._ImeHandler(this);
                        }
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "allowResizing", {
                /**
                 * Gets or sets a value that determines whether users may resize
                 * rows and/or columns with the mouse.
                 *
                 * If resizing is enabled, users can resize columns by dragging
                 * the right edge of column header cells, or rows by dragging the
                 * bottom edge of row header cells.
                 *
                 * Users may also double-click the edge of the header cells to
                 * automatically resize rows and columns to fit their content.
                 * The auto-size behavior can be customized using the @see:autoSizeMode
                 * property.
                 */
                get: function () {
                    return this._alResizing;
                },
                set: function (value) {
                    this._alResizing = wijmo.asEnum(value, grid.AllowResizing);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "deferResizing", {
                /**
                 * Gets or sets a value that determines whether row and column resizing
                 * should be deferred until the user releases the mouse button.
                 *
                 * By default, @see:deferResizing is set to false, causing rows and columns
                 * to be resized as the user drags the mouse. Setting this property to true
                 * causes the grid to show a resizing marker and to resize the row or column
                 * only when the user releases the mouse button.
                 */
                get: function () {
                    return this._deferResizing;
                },
                set: function (value) {
                    this._deferResizing = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "autoSizeMode", {
                /**
                 * Gets or sets which cells should be taken into account when auto-sizing a
                 * row or column.
                 *
                 * This property controls what happens when users double-click the edge of
                 * a column header.
                 *
                 * By default, the grid will automatically set the column width based on the
                 * content of the header and data cells in the column. This property allows
                 * you to change that to include only the headers or only the data.
                 */
                get: function () {
                    return this._autoSizeMode;
                },
                set: function (value) {
                    this._autoSizeMode = wijmo.asEnum(value, grid.AutoSizeMode);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "quickAutoSize", {
                /**
                 * Gets or sets a value that determines whether the grid should optimize
                 * performance over precision when auto-sizing columns.
                 *
                 * Setting this property to false disables quick auto-sizing. Setting
                 * it to true enables the feature, subject to the value of each column's
                 * @see:wijmo.grid.Column.quickAutoSize property. Setting it to null
                 * (the default value) enables the feature for grids that don't have a
                 * custom @see:itemFormatter or handlers attached to the @see:formatItem
                 * event.
                 */
                get: function () {
                    return this._quickSize;
                },
                set: function (value) {
                    this._quickSize = wijmo.asBoolean(value, true);
                },
                enumerable: true,
                configurable: true
            });
            FlexGrid.prototype._getQuickAutoSize = function () {
                return wijmo.isBoolean(this._quickSize)
                    ? this._quickSize
                    : !this.formatItem.hasHandlers && this.itemFormatter == null;
            };
            Object.defineProperty(FlexGrid.prototype, "allowSorting", {
                /**
                 * Gets or sets a value that determines whether users are allowed to sort columns
                 * by clicking the column header cells.
                 */
                get: function () {
                    return this._alSorting;
                },
                set: function (value) {
                    this._alSorting = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "allowAddNew", {
                /**
                 * Gets or sets a value that indicates whether the grid should provide a new row
                 * template so users can add items to the source collection.
                 *
                 * The new row template will not be displayed if the @see:isReadOnly property
                 * is set to true.
                 */
                get: function () {
                    return this._alAddNew;
                },
                set: function (value) {
                    if (value != this._alAddNew) {
                        this._alAddNew = wijmo.asBoolean(value);
                        this._addHdl.updateNewRowTemplate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "newRowAtTop", {
                /**
                 * Gets or sets a value that indicates whether the new row template should be
                 * located at the top of the grid or at the bottom.
                 *
                 * If you set the @see:newRowAtTop property to true, and you want the new
                 * row template to remain visible at all times, set the @see:frozenRows
                 * property to one. This will freeze the new row template at the top so
                 * it won't scroll off the view.
                 *
                 * The new row template will be displayed only if the @see:allowAddNew property
                 * is set to true and if the @see:itemsSource object supports adding new items.
                 */
                get: function () {
                    return this._addHdl.newRowAtTop;
                },
                set: function (value) {
                    this._addHdl.newRowAtTop = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "allowDelete", {
                /**
                 * Gets or sets a value that indicates whether the grid should delete
                 * selected rows when the user presses the Delete key.
                 *
                 * Selected rows will not be deleted if the @see:isReadOnly property
                 * is set to true.
                 */
                get: function () {
                    return this._alDelete;
                },
                set: function (value) {
                    if (value != this._alDelete) {
                        this._alDelete = wijmo.asBoolean(value);
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "allowMerging", {
                /**
                 * Gets or sets which parts of the grid provide cell merging.
                 */
                get: function () {
                    return this._alMerging;
                },
                set: function (value) {
                    if (value != this._alMerging) {
                        this._alMerging = wijmo.asEnum(value, grid.AllowMerging);
                        this.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "showSelectedHeaders", {
                /**
                 * Gets or sets a value that indicates whether the grid should
                 * add class names to indicate selected header cells.
                 */
                get: function () {
                    return this._ssHdr;
                },
                set: function (value) {
                    if (value != this._ssHdr) {
                        this._ssHdr = wijmo.asEnum(value, HeadersVisibility);
                        this.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "showMarquee", {
                /**
                 * Gets or sets a value that indicates whether the grid should
                 * display a marquee element around the current selection.
                 */
                get: function () {
                    return !this._eMarquee.style.display;
                },
                set: function (value) {
                    if (value != this.showMarquee) {
                        var s = this._eMarquee.style;
                        s.visibility = 'collapse'; // show only after positioning
                        s.display = wijmo.asBoolean(value) ? '' : 'none';
                        this.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "showSort", {
                /**
                 * Gets or sets a value that determines whether the grid should display
                 * sort indicators in the column headers.
                 *
                 * Sorting is controlled by the @see:ICollectionView.sortDescriptions
                 * property of the @see:ICollectionView object used as a the grid's
                 * @see:itemsSource.
                 */
                get: function () {
                    return this._shSort;
                },
                set: function (value) {
                    if (value != this._shSort) {
                        this._shSort = wijmo.asBoolean(value);
                        this.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "showGroups", {
                /**
                 * Gets or sets a value that determines whether the grid should insert group
                 * rows to delimit data groups.
                 *
                 * Data groups are created by modifying the @see:ICollectionView.groupDescriptions
                 * property of the @see:ICollectionView object used as a the grid's @see:itemsSource.
                 */
                get: function () {
                    return this._shGroups;
                },
                set: function (value) {
                    if (value != this._shGroups) {
                        this._shGroups = wijmo.asBoolean(value);
                        this._bindGrid(false);
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "showAlternatingRows", {
                /**
                 * Gets or sets a value that determines whether the grid should add the 'wj-alt'
                 * class to cells in alternating rows.
                 *
                 * Setting this property to false disables alternate row styles without any
                 * changes to the CSS.
                 */
                get: function () {
                    return this._shAlt;
                },
                set: function (value) {
                    if (value != this._shAlt) {
                        this._shAlt = wijmo.asBoolean(value);
                        this.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "showErrors", {
                /**
                 * Gets or sets a value that determines whether the grid should add the 'wj-state-invalid'
                 * class to cells that contain validation errors, and tooltips with error descriptions.
                 *
                 * The grid detects validation errors using the @see:itemValidator property or
                 * the @see:CollectionView.getError property on the grid's @see:itemsSource.
                 */
                get: function () {
                    return this._shErr;
                },
                set: function (value) {
                    if (value != this._shErr) {
                        this._clearCells();
                        this._shErr = wijmo.asBoolean(value);
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "itemValidator", {
                /**
                 * Gets or sets a validator function to determine whether cells contain
                 * valid data.
                 *
                 * If specified, the validator function should take two parameters containing
                 * the cell's row and column indices, and should return a string containing
                 * the error description.
                 *
                 * This property is especially useful when dealing with unbound grids,
                 * since bound grids can be validated using the @see:CollectionView.getError
                 * property instead.
                 *
                 * This example shows how you could prevent cells from containing the same
                 * data as the cell immediately above it:
                 * <pre>// check that the cell above doesn't contain the same value as this one
                 * theGrid.itemValidator = function (row, col) {
                 *   if (row &gt; 0) {
                 *     var valThis = theGrid.getCellData(row, col, false),
                 *         valPrev = theGrid.getCellData(row - 1, col, false);
                 *     if (valThis != null && valThis == valPrev) {
                 *       return 'This is a duplicate value...'
                 *     }
                 *   }
                 *   return null; // no errors
                 * }</pre>
                 */
                get: function () {
                    return this._itemValidator;
                },
                set: function (value) {
                    if (value != this.itemValidator) {
                        this._itemValidator = wijmo.asFunction(value);
                        this.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "validateEdits", {
                /**
                 * Gets or sets a value that determines whether the grid should remain
                 * in edit mode when the user tries to commit edits that fail validation.
                 *
                 * The grid detects validation errors by calling the @see:CollectionView.getError
                 * method on the grid's @see:itemsSource.
                 */
                get: function () {
                    return this._valEdt;
                },
                set: function (value) {
                    this._valEdt = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "groupHeaderFormat", {
                /**
                 * Gets or sets the format string used to create the group header content.
                 *
                 * The string may contain any text, plus the following replacement strings:
                 * <ul>
                 *   <li><b>{name}</b>: The name of the property being grouped on.</li>
                 *   <li><b>{value}</b>: The value of the property being grouped on.</li>
                 *   <li><b>{level}</b>: The group level.</li>
                 *   <li><b>{count}</b>: The total number of items in this group.</li>
                 * </ul>
                 *
                 * If a column is bound to the grouping property, the column header is used
                 * to replace the <code>{name}</code> parameter, and the column's format and
                 * data maps are used to calculate the <code>{value}</code> parameter.
                 * If no column is available, the group information is used instead.
                 *
                 * You may add invisible columns bound to the group properties in order to
                 * customize the formatting of the group header cells.
                 *
                 * The default value for this property is<br/>
                 * <code>'{name}: &lt;b&gt;{value}&lt;/b&gt;({count:n0} items)'</code>,
                 * which creates group headers similar to<br/>
                 * <code>'Country: <b>UK</b> (12 items)'</code> or<br/>
                 * <code>'Country: <b>Japan</b> (8 items)'</code>.
                 */
                get: function () {
                    return this._gHdrFmt;
                },
                set: function (value) {
                    if (value != this._gHdrFmt) {
                        this._gHdrFmt = wijmo.asString(value);
                        this._bindGrid(false);
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "allowDragging", {
                /**
                 * Gets or sets a value that determines whether users are allowed to drag
                 * rows and/or columns with the mouse.
                 */
                get: function () {
                    return this._alDragging;
                },
                set: function (value) {
                    if (value != this._alDragging) {
                        this._alDragging = wijmo.asEnum(value, grid.AllowDragging);
                        this.invalidate(); // to re-create row/col headers
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "itemsSource", {
                /**
                 * Gets or sets the array or @see:ICollectionView that contains items shown on the grid.
                 */
                get: function () {
                    return this._items;
                },
                set: function (value) {
                    if (value != this._items) {
                        var e = new wijmo.CancelEventArgs();
                        if (this.onItemsSourceChanging(e)) {
                            // unbind current collection view
                            if (this._cv) {
                                var view = wijmo.tryCast(this._cv, wijmo.collections.CollectionView);
                                if (view && view.sortConverter == this._bndSortConverter) {
                                    view.sortConverter = null;
                                }
                                this._cv.currentChanged.removeHandler(this._cvCurrentChanged, this);
                                this._cv.collectionChanged.removeHandler(this._cvCollectionChanged, this);
                                this._cv = null;
                            }
                            // save new data source and collection view
                            this._items = value;
                            this._cv = this._getCollectionView(value);
                            this._lastCount = 0;
                            // bind new collection view
                            if (this._cv) {
                                this._cv.currentChanged.addHandler(this._cvCurrentChanged, this);
                                this._cv.collectionChanged.addHandler(this._cvCollectionChanged, this);
                                var view = wijmo.tryCast(this._cv, wijmo.collections.CollectionView);
                                if (view && !view.sortConverter) {
                                    view.sortConverter = this._bndSortConverter;
                                }
                            }
                            // bind grid
                            this._bindGrid(true);
                            // initialize ListBox selection mode
                            var sm = grid.SelectionMode;
                            if (this.selectionMode == sm.ListBox) {
                                this.selectionMode = sm.CellRange;
                                this.selectionMode = sm.ListBox;
                            }
                            // raise itemsSourceChanged
                            this.onItemsSourceChanged(e);
                        }
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "collectionView", {
                /**
                 * Gets the @see:ICollectionView that contains the grid data.
                 */
                get: function () {
                    return this._cv;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "editableCollectionView", {
                /**
                 * Gets the @see:IEditableCollectionView that contains the grid data.
                 */
                get: function () {
                    return wijmo.tryCast(this._cv, 'IEditableCollectionView');
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "childItemsPath", {
                /**
                 * Gets or sets the name of the property (or properties) used to generate
                 * child rows in hierarchical grids.
                 *
                 * Set this property to a string to specify the name of the property that
                 * contains an item's child items (e.g. <code>'items'</code>).
                 *
                 * If items at different levels child items with different names, then
                 * set this property to an array containing the names of the properties
                 * that contain child items et each level
                 * (e.g. <code>[ 'accounts', 'checks', 'earnings' ]</code>).
                 *
                 * @fiddle:t0ncmjwp
                 */
                get: function () {
                    return this._childItemsPath;
                },
                set: function (value) {
                    if (value != this._childItemsPath) {
                        wijmo.assert(value == null || wijmo.isArray(value) || wijmo.isString(value), 'childItemsPath should be an array or a string.');
                        this._childItemsPath = value;
                        this._bindGrid(true);
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "rowHeaderPath", {
                /**
                 * Gets or sets the name of the property used to create row header
                 * cells.
                 *
                 * Row header cells are not visible or selectable. They are meant
                 * for use with accessibility tools.
                 */
                get: function () {
                    return this._rowHdrPath ? this._rowHdrPath.path : null;
                },
                set: function (value) {
                    if (value != this.rowHeaderPath) {
                        value = wijmo.asString(value);
                        this._rowHdrPath = value ? new wijmo.Binding(value) : null;
                        this.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "cells", {
                /**
                 * Gets the @see:GridPanel that contains the data cells.
                 */
                get: function () {
                    return this._gpCells;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "columnHeaders", {
                /**
                 * Gets the @see:GridPanel that contains the column header cells.
                 */
                get: function () {
                    return this._gpCHdr;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "columnFooters", {
                /**
                 * Gets the @see:GridPanel that contains the column footer cells.
                 *
                 * The @see:columnFooters panel appears below the grid cells, to the
                 * right of the @see:bottomLeftCells panel. It can be used to display
                 * summary information below the grid data.
                 *
                 * The example below shows how you can add a row to the @see:columnFooters
                 * panel to display summary data for columns that have the
                 * @see:Column.aggregate property set:
                 *
                 * <pre>function addFooterRow(flex) {
                 *   // create a GroupRow to show aggregates
                 *   var row = new wijmo.grid.GroupRow();
                 *
                 *   // add the row to the column footer panel
                 *   flex.columnFooters.rows.push(row);
                 *
                 *   // show a sigma on the header
                 *   flex.bottomLeftCells.setCellData(0, 0, '\u03A3');
                 * }</pre>
                 */
                get: function () {
                    return this._gpCFtr;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "rowHeaders", {
                /**
                 * Gets the @see:GridPanel that contains the row header cells.
                 */
                get: function () {
                    return this._gpRHdr;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "topLeftCells", {
                /**
                 * Gets the @see:GridPanel that contains the top left cells
                 * (to the left of the column headers).
                 */
                get: function () {
                    return this._gpTL;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "bottomLeftCells", {
                /**
                 * Gets the @see:GridPanel that contains the bottom left cells.
                 *
                 * The @see:bottomLeftCells panel appears below the row headers, to the
                 * left of the @see:columnFooters panel.
                 */
                get: function () {
                    return this._gpBL;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "rows", {
                /**
                 * Gets the grid's row collection.
                 */
                get: function () {
                    return this._rows;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "columns", {
                /**
                 * Gets the grid's column collection.
                 */
                get: function () {
                    return this._cols;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Gets a column by name or by binding.
             *
             * The method searches the column by name. If a column with the given name
             * is not found, it searches by binding. The searches are case-sensitive.
             *
             * @param name The name or binding to find.
             * @return The column with the specified name or binding, or null if not found.
             */
            FlexGrid.prototype.getColumn = function (name) {
                return this.columns.getColumn(name);
            };
            Object.defineProperty(FlexGrid.prototype, "frozenRows", {
                /**
                 * Gets or sets the number of frozen rows.
                 *
                 * Frozen rows do not scroll vertically, but the cells they contain
                 * may be selected and edited.
                 */
                get: function () {
                    return this.rows.frozen;
                },
                set: function (value) {
                    this.rows.frozen = value;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "frozenColumns", {
                /**
                 * Gets or sets the number of frozen columns.
                 *
                 * Frozen columns do not scroll horizontally, but the cells they contain
                 * may be selected and edited.
                 */
                get: function () {
                    return this.columns.frozen;
                },
                set: function (value) {
                    this.columns.frozen = value;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "cloneFrozenCells", {
                /**
                 * Gets or sets a value that determines whether the FlexGrid should
                 * clone frozen cells and show then in a separate element to improve
                 * perceived performance while scrolling.
                 *
                 * This property is set to null by default, which causes the grid
                 * to select the best setting depending on the browser.
                 */
                get: function () {
                    return this._fzClone;
                },
                set: function (value) {
                    if (value != this.cloneFrozenCells) {
                        this._fzClone = wijmo.asBoolean(value, true);
                        this.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "sortRowIndex", {
                /**
                 * Gets or sets the index of row in the column header panel that
                 * shows and changes the current sort.
                 *
                 * This property is set to null by default, causing the last row
                 * in the @see:columnHeaders panel to act as the sort row.
                 */
                get: function () {
                    return this._sortRowIndex;
                },
                set: function (value) {
                    if (value != this._sortRowIndex) {
                        this._sortRowIndex = wijmo.asNumber(value, true);
                        this.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "scrollPosition", {
                /**
                 * Gets or sets a @see:Point that represents the value of the grid's scrollbars.
                 */
                get: function () {
                    return this._ptScrl.clone();
                },
                set: function (pt) {
                    var root = this._root, left = -pt.x;
                    // IE/Chrome/FF handle scrollLeft differently under RTL:
                    // Chrome reverses direction, FF uses negative values, IE does the right thing (nothing)
                    if (this.rightToLeft) {
                        switch (FlexGrid._getRtlMode()) {
                            case 'rev':
                                left = (root.scrollWidth - root.clientWidth) + pt.x;
                                break;
                            case 'neg':
                                left = pt.x;
                                break;
                            default:
                                left = -pt.x;
                                break;
                        }
                    }
                    root.scrollLeft = left;
                    root.scrollTop = -pt.y;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "clientSize", {
                /**
                 * Gets the client size of the control (control size minus headers and scrollbars).
                 */
                get: function () {
                    return this._szClient;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "controlRect", {
                /**
                 * Gets the bounding rectangle of the control in page coordinates.
                 */
                get: function () {
                    if (!this._rcBounds) {
                        this._rcBounds = wijmo.getElementRect(this._root);
                    }
                    return this._rcBounds;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "scrollSize", {
                /**
                 * Gets the size of the grid content in pixels.
                 */
                get: function () {
                    return new wijmo.Size(this._gpCells.width, this._heightBrowser);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "viewRange", {
                /**
                 * Gets the range of cells currently in view.
                 */
                get: function () {
                    return this._gpCells.viewRange;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "cellFactory", {
                /**
                 * Gets or sets the @see:CellFactory that creates and updates cells for this grid.
                 */
                get: function () {
                    return this._cf;
                },
                set: function (value) {
                    if (value != this._cf) {
                        this._clearCells(); // TFS 280538
                        this._cf = wijmo.asType(value, grid.CellFactory, false);
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "itemFormatter", {
                /**
                 * Gets or sets a formatter function used to customize cells on this grid.
                 *
                 * The formatter function can add any content to any cell. It provides
                 * complete flexibility over the appearance and behavior of grid cells.
                 *
                 * If specified, the function should take four parameters: the @see:GridPanel
                 * that contains the cell, the row and column indices of the cell, and the
                 * HTML element that represents the cell. The function will typically change
                 * the <b>innerHTML</b> property of the cell element.
                 *
                 * For example:
                 * <pre>
                 * flex.itemFormatter = function(panel, r, c, cell) {
                 *   if (panel.cellType == CellType.Cell) {
                 *     // draw sparklines in the cell
                 *     var col = panel.columns[c];
                 *     if (col.name == 'sparklines') {
                 *       cell.innerHTML = getSparklike(panel, r, c);
                 *     }
                 *   }
                 * }
                 * </pre>
                 *
                 * Note that the FlexGrid recycles cells, so if your @see:itemFormatter
                 * modifies the cell's style attributes, you must make sure that it resets
                 * these attributes for cells that should not have them. For example:
                 *
                 * <pre>
                 * flex.itemFormatter = function(panel, r, c, cell) {
                 *   // reset attributes we are about to customize
                 *   var s = cell.style;
                 *   s.color = '';
                 *   s.backgroundColor = '';
                 *   // customize color and backgroundColor attributes for this cell
                 *   ...
                 * }
                 * </pre>
                 *
                 * If you have a scenario where multiple clients may want to customize the
                 * grid rendering (for example when creating directives or re-usable libraries),
                 * consider using the @see:formatItem event instead. The event allows multiple
                 * clients to attach their own handlers.
                 */
                get: function () {
                    return this._itemFormatter;
                },
                set: function (value) {
                    if (value != this._itemFormatter) {
                        this._clearCells(); // TFS 280538
                        this._itemFormatter = wijmo.asFunction(value);
                    }
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Gets a value that indicates whether a given cell can be edited.
             *
             * @param r Index of the row that contains the cell.
             * @param c Index of the column that contains the cell.
             */
            FlexGrid.prototype.canEditCell = function (r, c) {
                return this._edtHdl._allowEditing(r, c);
            };
            /**
             * Gets the value stored in a cell in the scrollable area of the grid.
             *
             * @param r Index of the row that contains the cell.
             * @param c Index of the column that contains the cell.
             * @param formatted Whether to format the value for display.
             */
            FlexGrid.prototype.getCellData = function (r, c, formatted) {
                return this.cells.getCellData(r, c, formatted);
            };
            /**
             * Gets a the bounds of a cell element in viewport coordinates.
             *
             * This method returns the bounds of cells in the @see:cells
             * panel (scrollable data cells). To get the bounds of cells
             * in other panels, use the @see:getCellBoundingRect method
             * in the appropriate @see:GridPanel object.
             *
             * The returned value is a @see:Rect object which contains the
             * position and dimensions of the cell in viewport coordinates.
             * The viewport coordinates are the same used by the
             * <a href="https://developer.mozilla.org/en-US/docs/Web/API/Element.getBoundingClientRect">getBoundingClientRect</a>
             * method.
             *
             * @param r Index of the row that contains the cell.
             * @param c Index of the column that contains the cell.
             * @param raw Whether to return the rectangle in raw panel coordinates
             * as opposed to viewport coordinates.
             */
            FlexGrid.prototype.getCellBoundingRect = function (r, c, raw) {
                return this.cells.getCellBoundingRect(r, c, raw);
            };
            /**
             * Sets the value of a cell in the scrollable area of the grid.
             *
             * @param r Index of the row that contains the cell.
             * @param c Index, name, or binding of the column that contains the cell.
             * @param value Value to store in the cell.
             * @param coerce Whether to change the value automatically to match the column's data type.
             * @param invalidate Whether to invalidate the grid to show the change.
             * @return True if the value was stored successfully, false otherwise.
             */
            FlexGrid.prototype.setCellData = function (r, c, value, coerce, invalidate) {
                if (coerce === void 0) { coerce = true; }
                if (invalidate === void 0) { invalidate = true; }
                return this.cells.setCellData(r, c, value, coerce, invalidate);
            };
            /**
             * Gets a @see:wijmo.grid.HitTestInfo object with information about a given point.
             *
             * For example:
             *
             * <pre>// hit test a point when the user clicks on the grid
             * flex.hostElement.addEventListener('click', function (e) {
             *   var ht = flex.hitTest(e.pageX, e.pageY);
             *   console.log('you clicked a cell of type "' +
             *     wijmo.grid.CellType[ht.cellType] + '".');
             * });</pre>
             *
             * @param pt @see:Point to investigate, in page coordinates, or a MouseEvent object, or x coordinate of the point.
             * @param y Y coordinate of the point in page coordinates (if the first parameter is a number).
             * @return A @see:wijmo.grid.HitTestInfo object with information about the point.
             */
            FlexGrid.prototype.hitTest = function (pt, y) {
                if (wijmo.isNumber(pt) && wijmo.isNumber(y)) {
                    pt = new wijmo.Point(pt, y);
                }
                if (wijmo.isBoolean(y) && y) {
                    this._rcBounds = null;
                }
                return new grid.HitTestInfo(this, pt);
            };
            /**
             * Gets the content of a @see:CellRange as a string suitable for
             * copying to the clipboard.
             *
             * Hidden rows and columns are not included in the clip string.
             *
             * @param rng @see:CellRange to copy. If omitted, the current selection is used.
             */
            FlexGrid.prototype.getClipString = function (rng) {
                return this._edtHdl.getClipString(rng);
            };
            /**
             * Parses a string into rows and columns and applies the content to a given range.
             *
             * Hidden rows and columns are skipped.
             *
             * @param text Tab and newline delimited text to parse into the grid.
             * @param rng @see:CellRange to copy. If omitted, the current selection is used.
             */
            FlexGrid.prototype.setClipString = function (text, rng) {
                this._edtHdl.setClipString(text, rng);
            };
            /**
             * Overridden to set the focus to the grid without scrolling the
             * whole grid into view.
             */
            FlexGrid.prototype.focus = function () {
                this._setFocus(false);
            };
            /**
             * Disposes of the control by removing its association with the host element.
             */
            FlexGrid.prototype.dispose = function () {
                // cancel any pending edits, close drop-down list
                this.finishEditing(true);
                // remove itemsSource so it doesn't have references to our
                // change event handlers that would prevent the grid from being
                // garbage-collected.
                this.itemsSource = null;
                // allow base class
                _super.prototype.dispose.call(this);
            };
            /**
             * Refreshes the grid display.
             *
             * @param fullUpdate Whether to update the grid layout and content, or just the content.
             */
            FlexGrid.prototype.refresh = function (fullUpdate) {
                if (fullUpdate === void 0) { fullUpdate = true; }
                // always call base class to handle being/endUpdate logic
                _super.prototype.refresh.call(this, fullUpdate);
                // close any open drop-downs
                this.finishEditing();
                // on full updates, get missing column types based on bindings and
                // update scroll position in case the control just became visible
                // and IE wrongly reset the element's scroll position to the origin
                // http://wijmo.com/topic/flexgrid-refresh-issue-when-hidden/
                if (fullUpdate) {
                    this._updateColumnTypes();
                    this.scrollPosition = this._ptScrl; // update element to match grid
                    // accessibility: expose visible row and column counts since we're virtualizing things
                    //this._setAria('rowcount', this._getFixedRowCount() + this.rows.visibleLength);
                    //this._setAria('colcount', this.columns.visibleLength);
                }
                // go refresh the cells
                this.refreshCells(fullUpdate);
            };
            /**
             * Refreshes the grid display.
             *
             * @param fullUpdate Whether to update the grid layout and content, or just the content.
             * @param recycle Whether to recycle existing elements.
             * @param state Whether to keep existing elements and update their state.
             */
            FlexGrid.prototype.refreshCells = function (fullUpdate, recycle, state) {
                if (!this.isUpdating) {
                    if (fullUpdate) {
                        this._updateLayout();
                    }
                    else {
                        this._updateContent(recycle, state);
                    }
                }
            };
            /**
             * Resizes a column to fit its content.
             *
             * @param c Index of the column to resize.
             * @param header Whether the column index refers to a regular or a header row.
             * @param extra Extra spacing, in pixels.
             */
            FlexGrid.prototype.autoSizeColumn = function (c, header, extra) {
                if (header === void 0) { header = false; }
                if (extra === void 0) { extra = 4; }
                this.autoSizeColumns(c, c, header, extra);
            };
            /**
             * Resizes a range of columns to fit their content.
             *
             * The grid will always measure all rows in the current view range, plus up to 2,000 rows
             * not currently in view. If the grid contains a large amount of data (say 50,000 rows),
             * then not all rows will be measured since that could potentially take a long time.
             *
             * @param firstColumn Index of the first column to resize (defaults to the first column).
             * @param lastColumn Index of the last column to resize (defaults to the last column).
             * @param header Whether the column indices refer to regular or header columns.
             * @param extra Extra spacing, in pixels.
             */
            FlexGrid.prototype.autoSizeColumns = function (firstColumn, lastColumn, header, extra) {
                var _this = this;
                if (header === void 0) { header = false; }
                if (extra === void 0) { extra = 4; }
                var max = 0, pHdr = header ? this.topLeftCells : this.columnHeaders, pFtr = header ? this.bottomLeftCells : this.columnFooters, pCells = header ? this.rowHeaders : this.cells, rowRange = this.viewRange;
                // initialize parameters
                firstColumn = firstColumn == null ? 0 : wijmo.asInt(firstColumn);
                lastColumn = lastColumn == null ? pCells.columns.length - 1 : wijmo.asInt(lastColumn);
                // choose row range to measure
                // (viewrange by default, everything if we have only a few items)
                rowRange.row = Math.max(0, rowRange.row - 1000);
                rowRange.row2 = Math.min(rowRange.row2 + 1000, this.rows.length - 1);
                // finish editing and perform auto-sizing
                if (this.finishEditing()) {
                    this.columns.deferUpdate(function () {
                        // make sure content element width is set
                        wijmo.setCss(_this._eCt, { width: _this._gpCells.width });
                        // create element to measure content
                        var eMeasure = document.createElement('div');
                        eMeasure.setAttribute(FlexGrid._WJS_MEASURE, 'true');
                        eMeasure.style.visibility = 'hidden';
                        pCells.hostElement.parentElement.appendChild(eMeasure);
                        // create 2d context for quick measuring
                        var ctx = _this._getCanvasContext();
                        // measure cells in the range
                        for (var c = firstColumn; c <= lastColumn && c > -1 && c < pCells.columns.length; c++) {
                            var col = pCells.columns[c];
                            if (col.isVisible) {
                                // get max width
                                max = 0;
                                // headers/footers
                                if (_this.autoSizeMode & grid.AutoSizeMode.Headers) {
                                    for (var r = 0; r < pHdr.rows.length; r++) {
                                        if (pHdr.rows[r].isVisible) {
                                            var w = _this._getDesiredWidth(pHdr, r, c, eMeasure);
                                            max = Math.max(max, w);
                                        }
                                    }
                                    for (var r = 0; r < pFtr.rows.length; r++) {
                                        if (pFtr.rows[r].isVisible) {
                                            var w = _this._getDesiredWidth(pFtr, r, c, eMeasure);
                                            max = Math.max(max, w);
                                        }
                                    }
                                }
                                // cells
                                if (_this.autoSizeMode & grid.AutoSizeMode.Cells) {
                                    if (rowRange.isValid) {
                                        if (col._getQuickAutoSize()) {
                                            var r = _this._getWidestRow(pCells, rowRange, c, ctx), w = _this._getDesiredWidth(pCells, r, c, eMeasure);
                                            max = Math.max(max, w);
                                        }
                                        else {
                                            for (var r = rowRange.row; r <= rowRange.row2 && r < pCells.rows.length; r++) {
                                                if (pCells.rows[r].isVisible) {
                                                    var w = _this._getDesiredWidth(pCells, r, c, eMeasure);
                                                    max = Math.max(max, w);
                                                }
                                            }
                                        }
                                    }
                                }
                                // set size
                                col.width = max + extra + 2;
                            }
                        }
                        // done with measuring element
                        _this.cellFactory.disposeCell(eMeasure);
                        wijmo.removeChild(eMeasure);
                    });
                }
            };
            /**
             * Resizes a row to fit its content.
             *
             * @param r Index of the row to resize.
             * @param header Whether the row index refers to a regular or a header row.
             * @param extra Extra spacing, in pixels.
             */
            FlexGrid.prototype.autoSizeRow = function (r, header, extra) {
                if (header === void 0) { header = false; }
                if (extra === void 0) { extra = 0; }
                this.autoSizeRows(r, r, header, extra);
            };
            /**
             * Resizes a range of rows to fit their content.
             *
             * @param firstRow Index of the first row to resize.
             * @param lastRow Index of the last row to resize.
             * @param header Whether the row indices refer to regular or header rows.
             * @param extra Extra spacing, in pixels.
             */
            FlexGrid.prototype.autoSizeRows = function (firstRow, lastRow, header, extra) {
                var _this = this;
                if (header === void 0) { header = false; }
                if (extra === void 0) { extra = 0; }
                var max = 0, pHdr = header ? this.topLeftCells : this.rowHeaders, pCells = header ? this.columnHeaders : this.cells;
                // initialize parameters
                header = wijmo.asBoolean(header);
                extra = wijmo.asNumber(extra);
                firstRow = firstRow == null ? 0 : wijmo.asInt(firstRow);
                lastRow = lastRow == null ? pCells.rows.length - 1 : wijmo.asInt(lastRow);
                // finish editing and perform auto-sizing
                if (this.finishEditing()) {
                    this.rows.deferUpdate(function () {
                        // make sure content element width is set
                        wijmo.setCss(_this._eCt, { width: _this._gpCells.width });
                        // create element to measure content
                        var eMeasure = document.createElement('div');
                        eMeasure.setAttribute(FlexGrid._WJS_MEASURE, 'true');
                        eMeasure.style.visibility = 'hidden';
                        pCells.hostElement.appendChild(eMeasure);
                        // measure cells in the range
                        var cache = {};
                        for (var r = firstRow; r <= lastRow && r > -1 && r < pCells.rows.length; r++) {
                            var row = pCells.rows[r];
                            if (row.isVisible) {
                                // get max height
                                max = 0;
                                // headers
                                if (_this.autoSizeMode & grid.AutoSizeMode.Headers) {
                                    for (var c = 0; c < pHdr.columns.length; c++) {
                                        if (pHdr.columns[c].isVisible > 0) {
                                            var h = _this._getDesiredHeight(pHdr, r, c, eMeasure);
                                            max = Math.max(max, h);
                                        }
                                    }
                                }
                                // cells
                                if (_this.autoSizeMode & grid.AutoSizeMode.Cells) {
                                    var first = true;
                                    for (var c = 0; c < pCells.columns.length; c++) {
                                        var col = pCells.columns[c], quick = col._getQuickAutoSize();
                                        if (col.isVisible) {
                                            // measure the first column, anything with wrapping, cssClass, boolean, or not quick
                                            if (first || col.wordWrap || col.cssClass || col.dataType == wijmo.DataType.Boolean || !quick) {
                                                var h = void 0;
                                                if (quick) {
                                                    var key = {
                                                        col: c,
                                                        content: col.dataType == wijmo.DataType.Number ? '1' : pCells.getCellData(r, c, true)
                                                    };
                                                    var strKey = JSON.stringify(key);
                                                    h = cache[strKey];
                                                    if (h == null) {
                                                        h = _this._getDesiredHeight(pCells, r, c, eMeasure);
                                                        cache[strKey] = h;
                                                    }
                                                }
                                                else {
                                                    h = _this._getDesiredHeight(pCells, r, c, eMeasure);
                                                }
                                                max = Math.max(max, h);
                                                first = false;
                                            }
                                        }
                                    }
                                }
                                // update size
                                pCells.rows[r].height = max + extra;
                            }
                        }
                        // done with measuring element
                        _this.cellFactory.disposeCell(eMeasure);
                        wijmo.removeChild(eMeasure);
                    });
                }
            };
            Object.defineProperty(FlexGrid.prototype, "treeIndent", {
                /**
                 * Gets or sets the indent used to offset row groups of different levels.
                 */
                get: function () {
                    return this._indent;
                },
                set: function (value) {
                    if (value != this._indent) {
                        this._indent = wijmo.asNumber(value, false, true);
                        this.columns.onCollectionChanged();
                    }
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Collapses all the group rows to a given level.
             *
             * @param level Maximum group level to show.
             */
            FlexGrid.prototype.collapseGroupsToLevel = function (level) {
                // finish editing first (this may change the collection)
                if (this.finishEditing()) {
                    // set collapsed state for all rows in the grid
                    var rows_1 = this.rows;
                    rows_1.deferUpdate(function () {
                        for (var r = 0; r < rows_1.length; r++) {
                            var gr = wijmo.tryCast(rows_1[r], grid.GroupRow);
                            if (gr) {
                                gr.isCollapsed = gr.level >= level;
                            }
                        }
                    });
                }
            };
            Object.defineProperty(FlexGrid.prototype, "selectionMode", {
                /**
                 * Gets or sets the current selection mode.
                 */
                get: function () {
                    return this._selHdl.selectionMode;
                },
                set: function (value) {
                    if (value != this.selectionMode) {
                        this._clearCells();
                        this._selHdl.selectionMode = wijmo.asEnum(value, grid.SelectionMode);
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "selection", {
                /**
                 * Gets or sets the current selection.
                 */
                get: function () {
                    return this._selHdl.selection.clone();
                },
                set: function (value) {
                    this._selHdl.selection = value;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Selects a cell range and optionally scrolls it into view.
             *
             * @param rng Range to select.
             * @param show Whether to scroll the new selection into view.
             */
            FlexGrid.prototype.select = function (rng, show) {
                if (show === void 0) { show = true; }
                this._selHdl.select(rng, show);
            };
            /**
             * Gets a @see:SelectedState value that indicates the selected state of a cell.
             *
             * @param r Row index of the cell to inspect.
             * @param c Column index of the cell to inspect.
             */
            FlexGrid.prototype.getSelectedState = function (r, c) {
                return this.cells.getSelectedState(r, c, null);
            };
            Object.defineProperty(FlexGrid.prototype, "selectedRows", {
                /**
                 * Gets or sets an array containing the rows that are currently selected.
                 *
                 * Note: this property can be read in all selection modes, but it can be
                 * set only when @see:selectionMode is set to <b>SelectionMode.ListBox</b>.
                 */
                get: function () {
                    var rows = [];
                    if (this.selectionMode == grid.SelectionMode.ListBox) {
                        for (var i = 0; i < this.rows.length; i++) {
                            if (this.rows[i].isSelected) {
                                rows.push(this.rows[i]);
                            }
                        }
                    }
                    else if (this.rows.length) {
                        var sel = this.selection;
                        for (var i = sel.topRow; i > -1 && i <= sel.bottomRow; i++) {
                            rows.push(this.rows[i]);
                        }
                    }
                    return rows;
                },
                set: function (value) {
                    var _this = this;
                    wijmo.assert(this.selectionMode == grid.SelectionMode.ListBox, 'This property can be set only in ListBox mode.');
                    value = wijmo.asArray(value);
                    this.deferUpdate(function () {
                        for (var i = 0, first = true; i < _this.rows.length; i++) {
                            var row = _this.rows[i], sel = value && value.indexOf(row) > -1;
                            if (sel && first) {
                                first = false;
                                _this.select(i, _this.selection.col);
                            }
                            row.isSelected = sel;
                        }
                    });
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "selectedItems", {
                /**
                 * Gets or sets an array containing the data items that are currently selected.
                 *
                 * Note: this property can be read in all selection modes, but it can be
                 * set only when @see:selectionMode is set to <b>SelectionMode.ListBox</b>.
                 */
                get: function () {
                    var items = this.selectedRows;
                    for (var i = 0; i < items.length; i++) {
                        items[i] = items[i].dataItem;
                    }
                    return items;
                },
                set: function (value) {
                    var _this = this;
                    wijmo.assert(this.selectionMode == grid.SelectionMode.ListBox, 'This property can be set only in ListBox mode.');
                    value = wijmo.asArray(value);
                    this.deferUpdate(function () {
                        for (var i = 0, first = true; i < _this.rows.length; i++) {
                            var row = _this.rows[i], sel = value && value.indexOf(row.dataItem) > -1;
                            if (sel && first) {
                                first = false;
                                _this.select(i, _this.selection.col);
                            }
                            row.isSelected = sel;
                        }
                    });
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Scrolls the grid to bring a specific cell into view.
             *
             * Negative row and column indices are ignored, so if you call
             *
             * <pre>grid.scrollIntoView(200, -1);</pre>
             *
             * The grid will scroll vertically to show row 200, and will not
             * scroll horizontally.
             *
             * @param r Index of the row to scroll into view.
             * @param c Index of the column to scroll into view.
             * @param refresh Optional parameter that determines whether the grid
             * should refresh to show the new scroll position immediately.
             * @return True if the grid scrolled.
             */
            FlexGrid.prototype.scrollIntoView = function (r, c, refresh) {
                // make sure our dimensions are set and up-to-date
                if (this._maxOffsetY == null) {
                    this._updateLayout();
                }
                // and go to work
                var sp = this.scrollPosition, wid = this._szClient.width, hei = this._szClient.height - this._gpCFtr.rows.getTotalSize(), ptFrz = this.cells._getFrozenPos();
                // calculate row offset
                r = wijmo.asInt(r);
                if (r > -1 && r < this._rows.length && r >= this._rows.frozen) {
                    var row = this._rows[r], pct = this.cells.height > hei ? Math.round(row.pos / (this.cells.height - hei) * 100) / 100 : 0, offsetY = Math.round(this._maxOffsetY * pct), rpos = row.pos - offsetY, rbot = rpos + row.renderSize; // important!!! (no -1, +1)
                    if (rbot > hei - sp.y) {
                        sp.y = Math.max(-rpos, hei - rbot);
                    }
                    if (rpos - ptFrz.y < -sp.y) {
                        sp.y = -(rpos - ptFrz.y);
                    }
                }
                // calculate column offset
                c = wijmo.asInt(c);
                if (c > -1 && c < this._cols.length && c >= this._cols.frozen) {
                    var col = this._cols[c], rgt = col.pos + col.renderSize;
                    if (rgt > -sp.x + wid) {
                        sp.x = Math.max(-col.pos, wid - rgt);
                    }
                    if (col.pos - ptFrz.x < -sp.x) {
                        sp.x = -(col.pos - ptFrz.x);
                    }
                }
                // update scroll position
                if (!sp.equals(this._ptScrl)) {
                    this.scrollPosition = sp;
                    if (refresh) {
                        this._updateScrollPosition();
                        this.refresh();
                    }
                    return true;
                }
                // no change
                return false;
            };
            /**
             * Checks whether a given CellRange is valid for this grid's row and column collections.
             *
             * @param rng Range to check.
             */
            FlexGrid.prototype.isRangeValid = function (rng) {
                return rng.isValid && rng.bottomRow < this.rows.length && rng.rightCol < this.columns.length;
            };
            /**
             * Starts editing a given cell.
             *
             * Editing in the @see:FlexGrid is similar to editing in Excel:
             * Pressing F2 or double-clicking a cell puts the grid in <b>full-edit</b> mode.
             * In this mode, the cell editor remains active until the user presses Enter, Tab,
             * or Escape, or until he moves the selection with the mouse. In full-edit mode,
             * pressing the cursor keys does not cause the grid to exit edit mode.
             *
             * Typing text directly into a cell puts the grid in <b>quick-edit mode</b>.
             * In this mode, the cell editor remains active until the user presses Enter,
             * Tab, or Escape, or any arrow keys.
             *
             * Full-edit mode is normally used to make changes to existing values.
             * Quick-edit mode is normally used for entering new data quickly.
             *
             * While editing, the user can toggle between full and quick modes by
             * pressing the F2 key.
             *
             * @param fullEdit Whether to stay in edit mode when the user presses the cursor keys. Defaults to true.
             * @param r Index of the row to be edited. Defaults to the currently selected row.
             * @param c Index of the column to be edited. Defaults to the currently selected column.
             * @param focus Whether to give the editor the focus when editing starts. Defaults to true.
             * @return True if the edit operation started successfully.
             */
            FlexGrid.prototype.startEditing = function (fullEdit, r, c, focus) {
                if (fullEdit === void 0) { fullEdit = true; }
                return this._edtHdl.startEditing(fullEdit, r, c, focus);
            };
            /**
             * Commits any pending edits and exits edit mode.
             *
             * @param cancel Whether pending edits should be canceled or committed.
             * @return True if the edit operation finished successfully.
             */
            FlexGrid.prototype.finishEditing = function (cancel) {
                if (cancel === void 0) { cancel = false; }
                return this._edtHdl.finishEditing(cancel);
            };
            Object.defineProperty(FlexGrid.prototype, "activeEditor", {
                /**
                 * Gets the <b>HTMLInputElement</b> that represents the cell editor currently active.
                 */
                get: function () {
                    return this._edtHdl.activeEditor;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "editRange", {
                /**
                 * Gets a @see:CellRange that identifies the cell currently being edited.
                 */
                get: function () {
                    return this._edtHdl.editRange;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "mergeManager", {
                /**
                 * Gets or sets the @see:MergeManager object responsible for determining how cells
                 * should be merged.
                 */
                get: function () {
                    return this._mrgMgr;
                },
                set: function (value) {
                    if (value != this._mrgMgr) {
                        this._mrgMgr = wijmo.asType(value, grid.MergeManager, true);
                        this.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Gets a @see:CellRange that specifies the merged extent of a cell
             * in a @see:GridPanel.
             *
             * @param p The @see:GridPanel that contains the range.
             * @param r Index of the row that contains the cell.
             * @param c Index of the column that contains the cell.
             * @param clip Whether to clip the merged range to the grid's current view range.
             * @return A @see:CellRange that specifies the merged range, or null if the cell is not merged.
             */
            FlexGrid.prototype.getMergedRange = function (p, r, c, clip) {
                if (clip === void 0) { clip = true; }
                return this._mrgMgr ? this._mrgMgr.getMergedRange(p, r, c, clip) : null;
            };
            Object.defineProperty(FlexGrid.prototype, "keyActionTab", {
                /**
                 * Gets or sets the action to perform when the TAB key is pressed.
                 *
                 * The default setting for this property is @see:KeyAction.None,
                 * which causes the browser to select the next or previous controls
                 * on the page when the TAB key is pressed. This is the recommended
                 * setting to improve page accessibility.
                 *
                 * In previous versions, the default was set to @see:KeyAction.Cycle,
                 * which caused the control to move the selection across and down
                 * the grid. This is the standard Excel behavior, but is not good
                 * for accessibility.
                 *
                 * There is also a @see:KeyAction.CycleOut setting that causes the
                 * selection to move through the cells (as @see:KeyAction.Cycle),
                 * and then on to the next/previous control on the page when the
                 * last or first cells are selected.
                 */
                get: function () {
                    return this._keyHdl._kaTab;
                },
                set: function (value) {
                    this._keyHdl._kaTab = wijmo.asEnum(value, grid.KeyAction);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "keyActionEnter", {
                /**
                 * Gets or sets the action to perform when the ENTER key is pressed.
                 *
                 * The default setting for this property is @see:KeyAction.MoveDown,
                 * which causes the control to move the selection to the next row.
                 * This is the standard Excel behavior.
                 */
                get: function () {
                    return this._keyHdl._kaEnter;
                },
                set: function (value) {
                    this._keyHdl._kaEnter = wijmo.asEnum(value, grid.KeyAction);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(FlexGrid.prototype, "showDropDown", {
                /**
                 * Gets or sets a value that indicates whether the grid adds drop-down
                 * buttons to the cells in columns that have the @see:Column.showDropDown
                 * property set to true.
                 *
                 * The drop-down buttons are shown only on columns that have a @see:Column.dataMap
                 * set and are editable. Clicking on the drop-down buttons causes the grid
                 * to show a list where users can select the value for the cell.
                 *
                 * Cell drop-downs require the wijmo.input module to be loaded.
                 */
                get: function () {
                    return this._shDropDown;
                },
                set: function (value) {
                    if (value != this._shDropDown) {
                        this._shDropDown = wijmo.asBoolean(value, true);
                        this.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Toggles the drop-down list-box associated with the currently selected
             * cell.
             *
             * This method can be used to show the drop-down list automatically
             * when the cell enters edit mode, or when the user presses certain
             * keys.
             *
             * For example, this code causes the grid to show the drop-down list
             * whenever the grid enters edit mode:
             * <pre>// show the drop-down list when the grid enters edit mode
             * theGrid.beginningEdit = function () {
             *   theGrid.toggleDropDownList();
             * }</pre>
             *
             * This code causes the grid to show the drop-down list when the grid
             * enters edit mode after the user presses the space bar:
             * <pre> // show the drop-down list when the user presses the space bar
             * theGrid.hostElement.addEventListener('keydown', function (e) {
             *   if (e.keyCode == 32) {
             *     e.preventDefault();
             *     theGrid.toggleDropDownList();
             *   }
             * }, true);</pre>
             */
            FlexGrid.prototype.toggleDropDownList = function () {
                if (!this._tglDropDown) {
                    this._tglDropDown = true;
                    this._edtHdl._toggleListBox(null);
                    this._tglDropDown = false;
                }
            };
            /**
             * Raises the @see:itemsSourceChanged event.
             *
             * @param e @see:CancelEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onItemsSourceChanging = function (e) {
                this.itemsSourceChanging.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:itemsSourceChanged event.
             */
            FlexGrid.prototype.onItemsSourceChanged = function (e) {
                this.itemsSourceChanged.raise(this, e);
            };
            /**
             * Raises the @see:scrollPositionChanged event.
             */
            FlexGrid.prototype.onScrollPositionChanged = function (e) {
                this.scrollPositionChanged.raise(this, e);
            };
            /**
             * Raises the @see:selectionChanging event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onSelectionChanging = function (e) {
                this.selectionChanging.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:selectionChanged event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onSelectionChanged = function (e) {
                this.selectionChanged.raise(this, e);
            };
            /**
             * Raises the @see:loadingRows event.
             *
             * @param e @see:CancelEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onLoadingRows = function (e) {
                this.loadingRows.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:loadedRows event.
             */
            FlexGrid.prototype.onLoadedRows = function (e) {
                this.loadedRows.raise(this, e);
            };
            /**
             * Raises the @see:updatingLayout event.
             *
             * @param e @see:CancelEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onUpdatingLayout = function (e) {
                this.updatingLayout.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:updatedLayout event.
             */
            FlexGrid.prototype.onUpdatedLayout = function (e) {
                this.updatedLayout.raise(this, e);
            };
            /**
             * Raises the @see:resizingColumn event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onResizingColumn = function (e) {
                this.resizingColumn.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:resizedColumn event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onResizedColumn = function (e) {
                this.resizedColumn.raise(this, e);
            };
            /**
             * Raises the @see:autoSizingColumn event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onAutoSizingColumn = function (e) {
                this.autoSizingColumn.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:autoSizedColumn event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onAutoSizedColumn = function (e) {
                this.autoSizedColumn.raise(this, e);
            };
            /**
             * Raises the @see:draggingColumn event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onDraggingColumn = function (e) {
                this.draggingColumn.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:draggingColumnOver event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onDraggingColumnOver = function (e) {
                this.draggingColumnOver.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:draggedColumn event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onDraggedColumn = function (e) {
                this.draggedColumn.raise(this, e);
            };
            /**
             * Raises the @see:resizingRow event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onResizingRow = function (e) {
                this.resizingRow.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:resizedRow event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onResizedRow = function (e) {
                this.resizedRow.raise(this, e);
            };
            /**
             * Raises the @see:autoSizingRow event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onAutoSizingRow = function (e) {
                this.autoSizingRow.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:autoSizedRow event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onAutoSizedRow = function (e) {
                this.autoSizedRow.raise(this, e);
            };
            /**
             * Raises the @see:draggingRow event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onDraggingRow = function (e) {
                this.draggingRow.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:draggingRowOver event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onDraggingRowOver = function (e) {
                this.draggingRowOver.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:draggedRow event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onDraggedRow = function (e) {
                this.draggedRow.raise(this, e);
            };
            /**
             * Raises the @see:groupCollapsedChanging event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onGroupCollapsedChanging = function (e) {
                this.groupCollapsedChanging.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:groupCollapsedChanged event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onGroupCollapsedChanged = function (e) {
                this.groupCollapsedChanged.raise(this, e);
            };
            /**
             * Raises the @see:sortingColumn event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onSortingColumn = function (e) {
                this.sortingColumn.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:sortedColumn event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onSortedColumn = function (e) {
                this.sortedColumn.raise(this, e);
            };
            /**
             * Raises the @see:beginningEdit event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onBeginningEdit = function (e) {
                this.beginningEdit.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:prepareCellForEdit event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onPrepareCellForEdit = function (e) {
                this.prepareCellForEdit.raise(this, e);
            };
            /**
             * Raises the @see:cellEditEnding event.
             *
             * @param e @see:CellEditEndingEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onCellEditEnding = function (e) {
                this.cellEditEnding.raise(this, e);
                return !e.cancel && !e.stayInEditMode;
            };
            /**
             * Raises the @see:cellEditEnded event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onCellEditEnded = function (e) {
                this.cellEditEnded.raise(this, e);
            };
            /**
             * Raises the @see:rowEditStarting event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onRowEditStarting = function (e) {
                this.rowEditStarting.raise(this, e);
            };
            /**
             * Raises the @see:rowEditStarted event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onRowEditStarted = function (e) {
                this.rowEditStarted.raise(this, e);
            };
            /**
             * Raises the @see:rowEditEnding event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onRowEditEnding = function (e) {
                this.rowEditEnding.raise(this, e);
            };
            /**
             * Raises the @see:rowEditEnded event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onRowEditEnded = function (e) {
                this.rowEditEnded.raise(this, e);
            };
            /**
             * Raises the @see:rowAdded event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onRowAdded = function (e) {
                this.rowAdded.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:deletingRow event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onDeletingRow = function (e) {
                this.deletingRow.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:deletedRow event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onDeletedRow = function (e) {
                this.deletedRow.raise(this, e);
            };
            /**
             * Raises the @see:copying event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onCopying = function (e) {
                this.copying.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:copied event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onCopied = function (e) {
                this.copied.raise(this, e);
            };
            /**
             * Raises the @see:pasting event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onPasting = function (e) {
                this.pasting.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:pasted event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onPasted = function (e) {
                this.pasted.raise(this, e);
            };
            /**
             * Raises the @see:pastingCell event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onPastingCell = function (e) {
                this.pastingCell.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:pastedCell event.
             *
             * @param e @see:CellRangeEventArgs that contains the event data.
             */
            FlexGrid.prototype.onPastedCell = function (e) {
                this.pastedCell.raise(this, e);
            };
            /**
             * Raises the @see:formatItem event.
             *
             * @param e @see:FormatItemEventArgs that contains the event data.
             */
            FlexGrid.prototype.onFormatItem = function (e) {
                this.formatItem.raise(this, e);
            };
            /**
             * Raises the @see:updatingView event.
             *
             * @param e @see:CancelEventArgs that contains the event data.
             * @return True if the event was not canceled.
             */
            FlexGrid.prototype.onUpdatingView = function (e) {
                this.updatingView.raise(this, e);
                return !e.cancel;
            };
            /**
             * Raises the @see:updatedView event.
             */
            FlexGrid.prototype.onUpdatedView = function (e) {
                this.updatedView.raise(this, e);
            };
            //#endregion
            //--------------------------------------------------------------------------
            //#region ** implementation
            // gets a value that determines whether the grid should display validation errors
            FlexGrid.prototype._getShowErrors = function () {
                return this.showErrors && this._hasValidation;
            };
            // gets a value that determines whether the grid can detect validation errors
            FlexGrid.prototype._getHasValidation = function () {
                return this._hasValidation;
            };
            // gets an error message for a cell
            FlexGrid.prototype._getError = function (p, r, c) {
                // get errors from grid's itemValidator
                if (wijmo.isFunction(this.itemValidator)) {
                    if (p == this.cells) {
                        return this.itemValidator(r, c);
                    }
                    else if (p == this.rowHeaders) {
                        for (c = 0; c < this.columns.length; c++) {
                            var error = this.itemValidator(r, c);
                            if (error) {
                                return error;
                            }
                        }
                    }
                }
                // get errors from CollectionView
                var view = this._cv, getError = view ? view['getError'] : null;
                if (wijmo.isFunction(getError)) {
                    var rows = p.rows, cols = this.columns, item = rows[r].dataItem;
                    if (item) {
                        for (; r < rows.length && rows[r].dataItem == item; r++) {
                            if (p == this.cells) {
                                var bcol = this._getBindingColumn(this.cells, r, cols[c]);
                                return getError(item, bcol.binding);
                            }
                            else if (p == this.rowHeaders) {
                                for (c = 0; c < cols.length; c++) {
                                    var bcol = this._getBindingColumn(this.cells, r, cols[c]), error = getError(item, bcol.binding);
                                    if (error) {
                                        return error;
                                    }
                                }
                            }
                        }
                    }
                }
                // no errors...
                return null;
            };
            // set the value of an ARIA attribute on the element playing grid role
            FlexGrid.prototype._setAria = function (name, value) {
                wijmo.setAttribute(this.cells.hostElement, 'aria-' + name, value);
            };
            // move focus to the proper grid element (TFS 264268, 261336, 265198)
            FlexGrid.prototype._setFocus = function (force) {
                if (this.hostElement) {
                    if (force || !this.containsFocus()) {
                        var ae = wijmo.getActiveElement(), eFocus = this._eFocus, ti = 'tabindex';
                        if (this.activeEditor) {
                            if (!wijmo.contains(this.activeEditor, ae)) {
                                this.activeEditor.focus(); // TFS 299364
                                eFocus.removeAttribute(ti);
                            }
                        }
                        else if (this._activeCell) {
                            if (!wijmo.contains(this._activeCell, ae)) {
                                if (ae != this._root) {
                                    this._activeCell.tabIndex = this._tabIndex;
                                    this._activeCell.focus(); // TFS 299364
                                    eFocus.removeAttribute(ti);
                                }
                            }
                        }
                        else {
                            if (!wijmo.contains(eFocus, ae)) {
                                eFocus.tabIndex = this._tabIndex;
                                eFocus.focus();
                            }
                        }
                        // make sure we got the focus
                        if (!this.containsFocus()) {
                            eFocus.tabIndex = this._tabIndex;
                            eFocus.focus();
                        }
                    }
                }
            };
            // set the focus to an element without scrolling
            FlexGrid.prototype._setFocusNoScroll = function (e) {
                // REVIEW: is this worth it?
                // check whether the element is clipped
                //let clipped = false,
                //    rc = e.getBoundingClientRect();
                //for (let p = e.parentElement; p && !clipped; p = p.parentElement) {
                //    if (getComputedStyle(p).overflow != 'visible') {
                //        let rcp = p.getBoundingClientRect();
                //        if (rcp.left > rc.left || rcp.right < rc.right) clipped = true;
                //        if (rcp.top > rc.top  || rcp.bottom < rc.bottom) clipped = true;
                //    }
                //}
                // save state to restore later
                var sp = this.scrollPosition, st = e.style, pos = st.position;
                // set position and focus on the element (TFS 293739)
                st.position = 'fixed';
                e.tabIndex = this._tabIndex;
                e.focus();
                // restore position after setting the focus
                st.position = pos;
                this.scrollPosition = sp;
                // make sure the host didn't scroll (TFS 265197)
                var host = this.hostElement;
                host.scrollTop = host.scrollLeft = 0;
            };
            // measure the control's default row height based on current styles
            FlexGrid.prototype._getDefaultRowHeight = function () {
                // make sure our host element is in the DOM (TFS 305275)
                var host = this.hostElement, body = document.body, root = null;
                if (body && !wijmo.contains(body, host)) {
                    for (var p = host; p; p = p.parentElement) {
                        root = p;
                    }
                    if (root) {
                        body.appendChild(root);
                    }
                }
                // get row height taking styles/padding into account
                var defRowHei = this._eFocus.scrollHeight + 2;
                if (defRowHei <= 6 || isNaN(defRowHei)) {
                    defRowHei = 28;
                }
                // remove root from body if we added it
                if (root) {
                    wijmo.removeChild(root);
                }
                // done
                return defRowHei;
            };
            // measure the default cell padding based on current styles
            FlexGrid.prototype._getDefaultCellPadding = function () {
                var cs = getComputedStyle(this._eFocus);
                return parseInt(this.rightToLeft ? cs.paddingRight : cs.paddingLeft);
            };
            // gets the collection view associated with an itemsSource object
            FlexGrid.prototype._getCollectionView = function (value) {
                return wijmo.asCollectionView(value);
            };
            // gets a 2d canvas context to measure strings
            FlexGrid.prototype._getCanvasContext = function () {
                var canvas = document.createElement('canvas'), ctx = canvas.getContext('2d'), cs = getComputedStyle(this.hostElement);
                ctx.font = cs.fontSize + ' ' + cs.fontFamily.split(',')[0];
                return ctx;
            };
            // gets the row with widest content for a given column
            FlexGrid.prototype._getWidestRow = function (p, rowRange, col, ctx) {
                var row = 0, maxWid = 0, isBoolean = p.columns[col].dataType == wijmo.DataType.Boolean;
                for (var r = rowRange.row; r <= rowRange.row2; r++) {
                    if (p.rows[r].isVisible) {
                        var str = p.getCellData(r, col, true), wid = ctx.measureText(str).width;
                        if (wid > maxWid) {
                            maxWid = wid;
                            row = r;
                        }
                        if (isBoolean) {
                            break;
                        }
                    }
                }
                return row;
            };
            // measures the desired width of a cell
            FlexGrid.prototype._getDesiredWidth = function (p, r, c, e) {
                var rng = this.getMergedRange(p, r, c), s = e.style;
                this.cellFactory.updateCell(p, r, c, e, rng);
                s.width = s.top = s.left = ''; // TFS 278942
                return e.offsetWidth / ((rng && rng.columnSpan > 1) ? rng.columnSpan : 1);
            };
            // measures the desired height of a cell
            FlexGrid.prototype._getDesiredHeight = function (p, r, c, e) {
                var rng = this.getMergedRange(p, r, c), s = e.style;
                this.cellFactory.updateCell(p, r, c, e, rng);
                s.height = s.top = s.left = ''; // TFS 278942
                return e.offsetHeight / ((rng && rng.rowSpan > 1) ? rng.rowSpan : 1);
            };
            // gets the index of the sort row, with special handling for nulls
            FlexGrid.prototype._getSortRowIndex = function () {
                return this._sortRowIndex != null
                    ? this._sortRowIndex
                    : this.columnHeaders.rows.length - 1;
            };
            FlexGrid.prototype._sortConverter = function (sd, item, value, init) {
                var col;
                // initialize mapped column dictionary
                if (init) {
                    this._mappedColumns = null;
                    if (this._cv) {
                        var sds = this._cv.sortDescriptions;
                        for (var i = 0; i < sds.length; i++) {
                            col = this.getColumn(sds[i].property);
                            if (col && col.dataMap) {
                                if (!this._mappedColumns) {
                                    this._mappedColumns = {};
                                }
                                this._mappedColumns[col.binding] = col.dataMap;
                            }
                        }
                    }
                    // prioritize the column that was clicked
                    // (in case multiple columns map the same property)
                    if (this._mouseHdl._htDown && this._mouseHdl._htDown.col > -1) {
                        col = this.columns[this._mouseHdl._htDown.col];
                        if (this._mappedColumns && col.dataMap) {
                            this._mappedColumns[col.binding] = col.dataMap;
                        }
                    }
                }
                // convert value if we have a map
                if (this._mappedColumns) {
                    var map = this._mappedColumns[sd.property];
                    if (map && map.sortByDisplayValues) {
                        value = map.getDisplayValue(value);
                    }
                }
                // return the value to use for sorting
                return value;
            };
            // binds the grid to the current data source.
            FlexGrid.prototype._bindGrid = function (full) {
                var _this = this;
                this.deferUpdate(function () {
                    // do a full binding if we didn't have any data when we did it the first time
                    if (_this._lastCount == 0 && wijmo.hasItems(_this._cv)) {
                        full = true;
                    }
                    // save selected state
                    var selItems, isListBox = _this.selectionMode == grid.SelectionMode.ListBox;
                    if (_this.preserveSelectedState && isListBox && !_this.childItemsPath) {
                        selItems = _this.selectedItems;
                    }
                    // save collapsed state
                    var collapsedMap;
                    if (_this.preserveOutlineState && wijmo.isFunction(window['Map']) && _this.rows.maxGroupLevel > -1) {
                        collapsedMap = new Map();
                        for (var i = 0; i < _this.rows.length; i++) {
                            var gr = _this.rows[i];
                            if (gr instanceof grid.GroupRow && gr.isCollapsed && gr.dataItem) {
                                var key = gr.dataItem;
                                if (key instanceof wijmo.collections.CollectionViewGroup) {
                                    key = key._path;
                                }
                                collapsedMap.set(key, true);
                            }
                        }
                    }
                    // update columns
                    if (full) {
                        _this.columns.deferUpdate(function () {
                            _this._bindColumns();
                        });
                    }
                    // update rows
                    var e = new wijmo.CancelEventArgs();
                    if (_this.onLoadingRows(e)) {
                        _this.rows.deferUpdate(function () {
                            _this._bindRows();
                        });
                        _this.onLoadedRows(e);
                    }
                    // restore/initialize ListBox selection
                    var cnt = 0;
                    if (selItems && selItems.length) {
                        for (var i = 0; i < _this.rows.length && cnt < selItems.length; i++) {
                            if (selItems.indexOf(_this.rows[i].dataItem) > -1) {
                                _this.rows[i].isSelected = true;
                                cnt++;
                            }
                        }
                    }
                    // failed to restore ListBox selection by object, update by index
                    if (isListBox && cnt == 0 && _this._lastCount > 0) {
                        var sel = _this.selection;
                        for (var i = sel.topRow; i <= sel.bottomRow && i > -1 && i < _this.rows.length; i++) {
                            _this.rows[i].isSelected = true;
                        }
                    }
                    // restore collapsed state
                    if (collapsedMap) {
                        _this.rows.deferUpdate(function () {
                            for (var i = 0; i < _this.rows.length; i++) {
                                var gr = _this.rows[i];
                                if (gr instanceof grid.GroupRow) {
                                    var key = gr.dataItem;
                                    if (key instanceof wijmo.collections.CollectionViewGroup) {
                                        key = key._path;
                                    }
                                    if (collapsedMap.get(key)) {
                                        gr.isCollapsed = true;
                                    }
                                }
                            }
                        });
                    }
                    // save item count for next time
                    if (!_this._lastCount && _this._cv && _this._cv.items) {
                        _this._lastCount = _this._cv.items.length;
                    }
                });
                // update selection in case we have no rows
                if (!this.rows.length) {
                    var sel = this._selHdl.selection;
                    sel.row = sel.row2 = -1;
                }
                // update selection with source view
                if (this._cv) {
                    this._syncSelection(true);
                }
            };
            // update grid rows to sync with data source
            /*protected*/ FlexGrid.prototype._cvCollectionChanged = function (sender, e) {
                // auto-generate if necessary
                if (this.autoGenerateColumns && this.columns.length == 0) {
                    this._bindGrid(true);
                    return;
                }
                // hierarchical binding: re-create all rows
                if (this.childItemsPath && e.action != wijmo.collections.NotifyCollectionChangedAction.Change) {
                    this._bindGrid(false);
                    return;
                }
                // synchronize grid with updated CollectionView
                switch (e.action) {
                    // an item has changed, invalidate the grid to show the changes
                    // this will also update aggregates and the edit indicator
                    case wijmo.collections.NotifyCollectionChangedAction.Change:
                        this.invalidate();
                        return;
                    // an item has been added, insert a row
                    case wijmo.collections.NotifyCollectionChangedAction.Add:
                        if (e.index == this._cv.items.length - 1) {
                            var index_1 = this.rows.length;
                            if (this.rows[index_1 - 1] instanceof grid._NewRowTemplate) {
                                index_1--;
                            }
                            this.rows.insert(index_1, new grid.Row(e.item));
                            return;
                        }
                        wijmo.assert(false, 'added item should be the last one.');
                        break;
                    // an item has been removed, delete the row
                    case wijmo.collections.NotifyCollectionChangedAction.Remove:
                        var index = this._findRow(e.item);
                        if (index > -1) {
                            this.rows.removeAt(index);
                            this._syncSelection(false);
                            return;
                        }
                        wijmo.assert(false, 'removed item not found in grid.');
                        break;
                }
                // reset (sort, new source, etc): re-create all rows
                this._bindGrid(false);
            };
            // update selection to sync with data source
            FlexGrid.prototype._cvCurrentChanged = function (s, e) {
                this._syncSelection(false);
            };
            // synchronize grid selection with collection view
            FlexGrid.prototype._syncSelection = function (force) {
                if (this._cv && this.selectionMode != grid.SelectionMode.None) {
                    // get grid's current item
                    var sel = this.selection, item = sel.row > -1 && sel.row < this.rows.length
                        ? this.rows[sel.row].dataItem
                        : null;
                    // groups are not regular data items (TFS 142470)
                    if (item instanceof wijmo.collections.CollectionViewGroup) {
                        item = null;
                    }
                    // if it doesn't match the view's, move the selection to match
                    if (item != this._cv.currentItem || force) {
                        // and not while adding items to a tree (TFS 269678)
                        if (!this.childItemsPath || !this.editableCollectionView || !this.editableCollectionView.currentAddItem) {
                            var index = this._getRowIndex(this._cv.currentPosition);
                            if (index != sel.row || !this.childItemsPath) {
                                sel.row = sel.row2 = index;
                                this.select(sel, false);
                                if (this.selectionMode) {
                                    this.scrollIntoView(sel.row, -1);
                                }
                            }
                        }
                    }
                }
            };
            // convert CollectionView index to row index
            FlexGrid.prototype._getRowIndex = function (index) {
                if (this._cv) {
                    // look up item, then scan rows to find it
                    if (index > -1) {
                        var item = this._cv.items[index];
                        for (; index < this.rows.length; index++) {
                            if (this.rows[index].dataItem === item) {
                                return index;
                            }
                        }
                        return -1; // item not found, shouldn't happen!
                    }
                    else {
                        // empty grid except for new row template? select that
                        if (this.rows.length == 1 && this.rows[0] instanceof grid._NewRowTemplate) {
                            return 0;
                        }
                        // no item to look up, so return current unbound row (group header)
                        // or -1 (no selection)
                        var index_2 = this.selection.row, row = index_2 > -1 ? this.rows[index_2] : null;
                        return row && (row instanceof grid.GroupRow || row.dataItem == null)
                            ? index_2
                            : -1;
                    }
                }
                // not bound
                return this.selection.row;
            };
            // convert row index to CollectionView index
            FlexGrid.prototype._getCvIndex = function (index) {
                if (this._cv && index > -1 && index < this.rows.length) {
                    var items = this._cv.items, item = this.rows[index].dataItem;
                    index = Math.min(index, items.length - 1);
                    for (; index > -1; index--) {
                        if (items[index] === item) {
                            return index;
                        }
                    }
                }
                return -1;
            };
            // gets the index of the row that represents a given data item
            FlexGrid.prototype._findRow = function (data) {
                for (var i = 0; i < this.rows.length; i++) {
                    if (this.rows[i].dataItem == data) {
                        return i;
                    }
                }
                return -1;
            };
            // re-arranges the child HTMLElements within this grid.
            FlexGrid.prototype._updateLayout = function () {
                // raise updatingLayout event
                var e = new wijmo.CancelEventArgs();
                if (!this.onUpdatingLayout(e)) {
                    return;
                }
                // remember whether this grid can validate its contents (TFS 299026)
                this._hasValidation =
                    wijmo.isFunction(this._itemValidator) ||
                        (this._cv && wijmo.isFunction(this._cv['getError']));
                // compute content height, max height supported by browser,
                // and max offset so things match up when you scroll all the way down.
                var tlw = (this._hdrVis & HeadersVisibility.Row) ? this._hdrCols.getTotalSize() : 0, tlh = (this._hdrVis & HeadersVisibility.Column) ? this._hdrRows.getTotalSize() : 0, blh = this._ftrRows.getTotalSize(), heightReal = this._rows.getTotalSize() + blh;
                // make sure scrollbars are functional even if we have no rows (TFS 110441)
                if (heightReal < 1) {
                    heightReal = 1;
                }
                // keep track of relevant variables
                this._heightBrowser = Math.min(heightReal, FlexGrid._getMaxSupportedCssHeight());
                this._maxOffsetY = Math.max(0, heightReal - this._heightBrowser);
                // compute default cell padding
                this._cellPadding = this._getDefaultCellPadding();
                // top of the footer divs
                var ftrTop = this._heightBrowser + tlh - blh;
                // cell panel size (dimensions should not be zero or scrollbars won't work)
                // this can happen in grids that have header cells but no scrollable cells
                var cellWid = this._gpCells.width, cellHei = this._heightBrowser;
                if (!cellWid && this.rows.length)
                    cellWid = 0.1;
                if (!cellHei && this.columns.length)
                    cellHei = 0.1;
                // set sizes that do *not* depend on scrollbars being visible
                if (this.rightToLeft) {
                    wijmo.setCss(this._eTL, { right: 0, top: 0, width: tlw, height: tlh });
                    wijmo.setCss(this._eCHdr, { right: tlw, top: 0, height: tlh });
                    wijmo.setCss(this._eRHdr, { right: 0, top: tlh, width: tlw });
                    wijmo.setCss(this._eCt, { right: tlw, top: tlh, width: cellWid, height: cellHei });
                    wijmo.setCss(this._fCt, { right: tlw, top: tlh });
                    wijmo.setCss(this._eBL, { right: 0, top: ftrTop, width: tlw, height: blh });
                    wijmo.setCss(this._eCFtr, { right: tlw, top: ftrTop, height: blh });
                }
                else {
                    wijmo.setCss(this._eTL, { left: 0, top: 0, width: tlw, height: tlh });
                    wijmo.setCss(this._eCHdr, { left: tlw, top: 0, height: tlh });
                    wijmo.setCss(this._eRHdr, { left: 0, top: tlh, width: tlw });
                    wijmo.setCss(this._eCt, { left: tlw, top: tlh, width: cellWid, height: cellHei });
                    wijmo.setCss(this._fCt, { left: tlw, top: tlh });
                    wijmo.setCss(this._eBL, { left: 0, top: ftrTop, width: tlw, height: blh });
                    wijmo.setCss(this._eCFtr, { left: tlw, top: ftrTop, height: blh });
                }
                // update sticky headers
                if (this._stickyHdr) {
                    this._updateStickyHeaders();
                }
                // adjust header z-index when using frozen cells (TFS 263911)
                var zIndex = (this.frozenRows || this.frozenColumns) ? '3' : '';
                wijmo.setCss([this._eTL, this._eBL, this._eCHdr, this._eCFtr, this._eRHdr, this._eMarquee], {
                    zIndex: zIndex
                });
                // update auto-sizer element
                var root = this._root, sbW = root.offsetWidth - root.clientWidth, sbH = root.offsetHeight - root.clientHeight;
                wijmo.setCss(this._eSz, {
                    width: tlw + sbW + this._gpCells.width,
                    height: tlh + sbH + this._heightBrowser
                });
                // update star sizes and re-adjust content width to handle round-offs
                var clientWidth = null;
                if (this.columns._updateStarSizes(root.clientWidth - tlw)) {
                    clientWidth = root.clientWidth;
                    wijmo.setCss(this._eCt, { width: this._gpCells.width });
                }
                // store control size
                this._szClient = new wijmo.Size(root.clientWidth - tlw, root.clientHeight - tlh);
                this._rcBounds = null;
                // update window scroll handler (sticky headers, window clipping)
                this._updateScrollHandler();
                // update content
                this._updateContent(false);
                // update auto-sizer element after refreshing content
                sbW = root.offsetWidth - root.clientWidth;
                sbH = root.offsetHeight - root.clientHeight;
                wijmo.setCss(this._eSz, {
                    width: tlw + sbW + this._gpCells.width,
                    height: tlh + sbH + this._heightBrowser
                });
                // update client size after refreshing content
                this._szClient = new wijmo.Size(root.clientWidth - tlw, root.clientHeight - tlh);
                // adjust star sizes to account for vertical scrollbars
                if (clientWidth && clientWidth != root.clientWidth) {
                    if (this.columns._updateStarSizes(root.clientWidth - tlw)) {
                        wijmo.setCss(this._eCt, { width: this._gpCells.width });
                        this._updateContent(false);
                    }
                }
                // set sizes that *do* depend on scrollbars being visible
                wijmo.setCss([this._eCHdr, this._eCFtr, this._fCt], { width: this._szClient.width });
                wijmo.setCss([this._eRHdr, this._fCt], { height: this._szClient.height });
                // adjust top of footer panel
                if (blh) {
                    ftrTop = Math.min(ftrTop, this._szClient.height + tlh - blh);
                    wijmo.setCss([this._eBL, this._eCFtr], { top: ftrTop });
                }
                // raise the event
                this.onUpdatedLayout(e);
            };
            // update the top of the header elements to remain visible 
            // when the user scrolls the window
            FlexGrid.prototype._updateStickyHeaders = function () {
                var stuck = false, offset = 0;
                // calculate offset
                if (this._stickyHdr) {
                    var maxTop = 0, thisTop = null;
                    for (var el = this.hostElement; el; el = el.parentElement) {
                        var rc = el.getBoundingClientRect();
                        if (thisTop == null) {
                            thisTop = rc.top;
                        }
                        maxTop = Math.max(maxTop, rc.top);
                    }
                    thisTop = Math.max(0, maxTop - thisTop - 1);
                    offset = -thisTop;
                    stuck = thisTop > 0;
                    this._rcBounds = null; // TFS 285201
                }
                // apply offset
                this._eTL.style.top = this._eCHdr.style.top = stuck ? (-offset + 'px') : '';
                wijmo.toggleClass(this._eTL, FlexGrid._WJS_STICKY, stuck);
                wijmo.toggleClass(this._eCHdr, FlexGrid._WJS_STICKY, stuck);
            };
            // attaches/removes handler for window scroll event depending
            // on whether we have sticky headers or doc-level virtual DOM (clip to screen)
            FlexGrid.prototype._updateScrollHandler = function () {
                this._clipToScreen = this._getClipToScreen();
                var needScrollHandler = this._stickyHdr || this._clipToScreen;
                if (needScrollHandler != this._scrollHandlerAttached) {
                    this._scrollHandlerAttached = needScrollHandler;
                    if (needScrollHandler) {
                        this.addEventListener(window, 'scroll', this._bndScroll, true);
                    }
                    else {
                        this.removeEventListener(window, 'scroll', this._bndScroll, true);
                    }
                }
            };
            // gets a value that determines whether the viewRange should be clipped
            // to the browser window (in addition to the control rect)
            /*private*/ FlexGrid.prototype._getClipToScreen = function () {
                // check that we have enough rows
                if (this.rows.length <= FlexGrid._MIN_VIRT_ROWS) {
                    return false;
                }
                // check that we don't have scrollbars
                if (this._root.clientHeight != this._root.scrollHeight) {
                    return false;
                }
                // check that we are not in a scrollable container
                for (var host = this.hostElement; host && host != document.documentElement; host = host.parentElement) {
                    var cs = getComputedStyle(host);
                    if (cs.overflow == 'auto') {
                        return false;
                    }
                }
                // clip cells to screen
                return true;
                //return this.rows.length > FlexGrid._MIN_VIRT_ROWS &&
                //    this.hostElement && this.hostElement.parentElement == document.body &&
                //    this._root.clientHeight == this._root.scrollHeight; // TFS 281413
            };
            // handle window scroll events to update sticky headers and window clipping
            FlexGrid.prototype._scroll = function (e) {
                var _this = this;
                if (wijmo.contains(e.target, this.hostElement)) {
                    // window-level virtualization
                    if (this._clipToScreen) {
                        if (this._afScrl) {
                            cancelAnimationFrame(this._afScrl);
                        }
                        this._afScrl = requestAnimationFrame(function () {
                            _this._afScrl = null;
                            _this.finishEditing();
                            _this._updateContent(true);
                        });
                    }
                    // sticky headers
                    if (this._stickyHdr) {
                        if (this._afSticky) {
                            cancelAnimationFrame(this._afSticky);
                        }
                        this._afSticky = requestAnimationFrame(function () {
                            _this._afSticky = null;
                            var e = new wijmo.CancelEventArgs();
                            if (_this.onUpdatingLayout(e)) {
                                _this._updateStickyHeaders();
                                _this.onUpdatedLayout(e);
                            }
                        });
                    }
                }
            };
            // updates the scrollPosition property based on the element's scroll position
            // note that IE/Chrome/FF handle scrollLeft differently under RTL:
            // - Chrome reverses direction,
            // - FF uses negative values, 
            // - IE does the right thing (nothing)
            FlexGrid.prototype._updateScrollPosition = function () {
                var root = this._root, top = root.scrollTop, left = root.scrollLeft;
                if (this.rightToLeft && FlexGrid._getRtlMode() == 'rev') {
                    left = (root.scrollWidth - root.clientWidth) - left;
                }
                var pt = new wijmo.Point(-Math.abs(left), -top);
                // save new value and raise event
                if (!this._ptScrl.equals(pt)) {
                    this._ptScrl = pt;
                    this.onScrollPositionChanged();
                    return true;
                }
                // no change...
                return false;
            };
            // updates the cell elements within this grid.
            FlexGrid.prototype._updateContent = function (recycle, state) {
                var ae = wijmo.getActiveElement(), host = this.hostElement, elFocus = wijmo.contains(host, ae) ? ae : null, oldActiveCell = this._activeCell;
                // raise updatingView event
                var e = new wijmo.CancelEventArgs();
                if (!this.onUpdatingView(e)) {
                    return;
                }
                // calculate offset to work around IE limitations
                this._offsetY = 0;
                if (this._heightBrowser > this._szClient.height) {
                    var pct = Math.round((-this._ptScrl.y) / (this._heightBrowser - this._szClient.height) * 100) / 100;
                    this._offsetY = Math.round(this._maxOffsetY * pct);
                }
                // update scroll position and then cells (TFS 144263, 152757)
                this._updateScrollPosition();
                var newActiveCell = this._gpCells._updateContent(recycle, state, this._offsetY);
                // update visible headers
                if (this._hdrVis & HeadersVisibility.Column) {
                    if (!state || (this._ssHdr & HeadersVisibility.Column)) {
                        this._gpCHdr._updateContent(recycle, state, 0);
                    }
                }
                if (this._hdrVis & HeadersVisibility.Row) {
                    if (!state || (this._ssHdr & HeadersVisibility.Row)) {
                        this._gpRHdr._updateContent(recycle, state, this._offsetY);
                    }
                }
                if (this._hdrVis && !state) {
                    this._gpTL._updateContent(recycle, state, 0);
                }
                // update column footers
                if (this._gpCFtr.rows.length) {
                    this._gpBL._updateContent(recycle, state, 0);
                    this._gpCFtr._updateContent(recycle, state, 0);
                }
                // update marquee position
                if (this.showMarquee) {
                    var sel = this._selHdl.selection, marquee = this._eMarquee;
                    if (!this.isRangeValid(sel)) {
                        wijmo.setCss(marquee, {
                            left: 0,
                            top: 0,
                            width: 0,
                            height: 0,
                            visibility: 'collapse'
                        });
                    }
                    else {
                        var rcm = this._getMarqueeRect(sel), host_1 = this.cells.hostElement, mc = marquee.firstChild, dx = marquee.offsetWidth - mc.offsetWidth, dy = marquee.offsetHeight - mc.offsetHeight;
                        wijmo.setCss(marquee, {
                            left: rcm.left + host_1.offsetLeft - dx / 2,
                            top: rcm.top + host_1.offsetTop - dy / 2,
                            width: rcm.width + dx,
                            height: rcm.height + dy,
                            visibility: rcm.width > 0 && rcm.height > 0 ? '' : 'collapse'
                        });
                    }
                }
                // update frozen cell div used in non-Chrome browsers
                if (this._useFrozenDiv()) {
                    // copy frozen cells into their own container
                    this._updateFrozenCells(state);
                    // make sure frozen cells are not tabbable (doesn't work well..,)
                    if (newActiveCell && wijmo.hasClass(newActiveCell, 'wj-frozen')) {
                        newActiveCell = null;
                    }
                }
                // save new active cell
                this._activeCell = newActiveCell;
                // restore/update focus
                if (elFocus) {
                    if (elFocus != this._root &&
                        elFocus != this._eFocus &&
                        wijmo.contains(this.hostElement, elFocus) &&
                        !wijmo.contains(this.cells.hostElement, elFocus)) {
                        // set the focus (if necessary, TFS 300233)
                        if (document.activeElement != elFocus) {
                            elFocus.focus();
                        }
                        // refresh input element selection (needed only in IE, TFS 261680)
                        if (wijmo.isIE() &&
                            elFocus instanceof HTMLInputElement &&
                            !elFocus.type.match(/checkbox|radio|range/i)) {
                            var ss = elFocus.selectionStart, se = elFocus.selectionEnd;
                            elFocus.setSelectionRange(ss, se);
                        }
                    }
                    else {
                        var force = newActiveCell != oldActiveCell; // TFS 278868
                        this._setFocus(force);
                    }
                }
                // make sure the grid didn't scroll out of whack in Safari/Mac (TFS 305904)
                if (host) {
                    if (host.scrollTop) {
                        host.scrollTop = 0;
                    }
                    if (host.firstElementChild.scrollTop) {
                        host.firstElementChild.scrollTop = 0;
                    }
                }
                // update tabindex attribute on old and new active cells
                if (!elFocus && newActiveCell) {
                    newActiveCell.tabIndex = this._tabIndex;
                }
                if (oldActiveCell && oldActiveCell != newActiveCell) {
                    oldActiveCell.removeAttribute('tabindex');
                }
                // make sure hit-testing works
                this._rcBounds = null;
                // done updating the view
                this.onUpdatedView(e);
            };
            // removes all cells from this grid (true/hard recycle, TFS 280538)
            FlexGrid.prototype._clearCells = function () {
                for (var k in this) {
                    if (k[0] == '_') {
                        var p = this[k];
                        if (p instanceof grid.GridPanel) {
                            p._clearCells();
                        }
                    }
                }
                this.invalidate();
            };
            // use a separate div for frozen cells in IE/Firefox/Mobile browsers
            // this improves perceived performance by reducing flicker 
            // when scrolling with frozen cells.
            /*private*/ FlexGrid.prototype._useFrozenDiv = function () {
                return wijmo.isBoolean(this._fzClone)
                    ? this._fzClone
                    : wijmo.isIE() || wijmo.isFirefox() || wijmo.isMobile();
            };
            // copy frozen cells into their own container
            FlexGrid.prototype._updateFrozenCells = function (state) {
                if (!this.frozenRows && !this.frozenColumns) {
                    // clear frozen cells (TFS 237203)
                    wijmo.setText(this._fCt, null);
                }
                else {
                    // copy state without re-creating cells (TFS 221355)
                    var frozen = this._eCt.querySelectorAll('.wj-frozen');
                    if (state && this._fCt.children.length == frozen.length) {
                        for (var i = 0; i < frozen.length; i++) {
                            this._fCt.children[i].className = frozen[i].className;
                        }
                        return;
                    }
                    // clone frozen cells
                    wijmo.setText(this._fCt, null);
                    if (!this.activeEditor) {
                        for (var i = 0; i < frozen.length; i++) {
                            var cell = frozen[i].cloneNode(true);
                            cell.style.pointerEvents = 'auto';
                            this._fCt.appendChild(cell);
                        }
                    }
                }
            };
            // get marquee rectangle (accounting for merging, freezing, RTL)
            FlexGrid.prototype._getMarqueeRect = function (rng) {
                // get selection corner cells (accounting for merging)
                var m1 = this.getMergedRange(this.cells, rng.topRow, rng.leftCol) || new grid.CellRange(rng.topRow, rng.leftCol), m2 = this.getMergedRange(this.cells, rng.bottomRow, rng.rightCol) || new grid.CellRange(rng.bottomRow, rng.rightCol);
                // get cell client rectangles
                var rc1 = this.cells.getCellBoundingRect(m1.topRow, m1.leftCol, true), rc2 = this.cells.getCellBoundingRect(m2.bottomRow, m2.rightCol, true);
                // adjust for frozen rows
                if (this.rows.frozen) {
                    var fzr = Math.min(this.rows.length, this.rows.frozen), rcf = this.cells.getCellBoundingRect(fzr - 1, 0, true);
                    if (rng.topRow >= fzr && rc1.top < rcf.bottom) {
                        rc1.top = rcf.bottom;
                    }
                    if (rng.bottomRow >= fzr && rc2.bottom < rcf.bottom) {
                        rc2.height = rcf.bottom - rc2.top;
                    }
                }
                // adjust for frozen columns
                if (this.columns.frozen) {
                    var fzc = Math.min(this.columns.length, this.columns.frozen), rcf = this.cells.getCellBoundingRect(0, fzc - 1, true);
                    if (this.rightToLeft) {
                        if (rng.leftCol >= fzc && rc1.right > rcf.left) {
                            rc1.left = rcf.left - rc1.width;
                        }
                        if (rng.rightCol >= fzc && rc2.left > rcf.left) {
                            rc2.left = rcf.left;
                        }
                    }
                    else {
                        if (rng.leftCol >= fzc && rc1.left < rcf.right) {
                            rc1.left = rcf.right;
                        }
                        if (rng.rightCol >= fzc && rc2.right < rcf.right) {
                            rc2.width = rcf.right - rc2.left;
                        }
                    }
                }
                // return marquee rect
                return this.rightToLeft
                    ? new wijmo.Rect(rc2.left, rc1.top, rc1.right - rc2.left, rc2.bottom - rc1.top)
                    : new wijmo.Rect(rc1.left, rc1.top, rc2.right - rc1.left, rc2.bottom - rc1.top);
            };
            // bind columns
            /*protected*/ FlexGrid.prototype._bindColumns = function () {
                // remove old auto-generated columns
                for (var i = 0; i < this.columns.length; i++) {
                    var col = this.columns[i];
                    if (col._getFlag(grid.RowColFlags.AutoGenerated)) {
                        this.columns.removeAt(i);
                        i--;
                    }
                }
                // get first item to infer data types
                var view = this._cv, sc = view ? view.sourceCollection : null, item = sc && sc.length ? sc[0] : null;
                // auto-generate new columns
                // (skipping unwanted types: array and object)
                if (item && this.autoGenerateColumns) {
                    for (var key in item) {
                        var value = null; // look for the first non-null value
                        for (var index = 0; index < sc.length && index < 1000 && value == null; index++) {
                            value = sc[index][key];
                            if (wijmo.isPrimitive(value)) {
                                var col = new grid.Column();
                                col._setFlag(grid.RowColFlags.AutoGenerated, true);
                                col.binding = col.name = key;
                                col.header = wijmo.toHeaderCase(key);
                                col.dataType = wijmo.getType(value);
                                if (col.dataType == wijmo.DataType.Number) {
                                    col.width = 80;
                                }
                                var pdesc = Object.getOwnPropertyDescriptor(item, key);
                                if (pdesc && !pdesc.writable && !wijmo.isFunction(pdesc.set)) {
                                    col._setFlag(grid.RowColFlags.ReadOnly, true);
                                }
                                this.columns.push(col);
                            }
                        }
                    }
                }
                // update missing column types
                this._updateColumnTypes();
            };
            // update missing column types to match data
            /*protected*/ FlexGrid.prototype._updateColumnTypes = function () {
                var view = this._cv;
                if (wijmo.hasItems(view)) {
                    var item = view.items[0], cols = this.columns;
                    for (var i = 0; i < cols.length; i++) {
                        var col = cols[i];
                        if (col.dataType == null && col._binding) {
                            col.dataType = wijmo.getType(col._binding.getValue(item));
                        }
                    }
                }
            };
            // get the binding column 
            // (in the MultiRow grid, each physical column may contain several binding columns)
            /*protected*/ FlexGrid.prototype._getBindingColumn = function (p, r, c) {
                return c;
            };
            // get the row header path
            /*protected*/ FlexGrid.prototype._getRowHeaderPath = function () {
                return this._rowHdrPath;
            };
            // bind rows
            /*protected*/ FlexGrid.prototype._bindRows = function () {
                // clear rows
                this.rows.clear();
                // re-populate
                var view = this._cv;
                if (view && view.items) {
                    var list = view.items, groups = view.groups;
                    // bind to hierarchical sources (childItemsPath)
                    if (this.childItemsPath) {
                        for (var i = 0; i < list.length; i++) {
                            this._addNode(list, i, 0);
                        }
                        // bind to grouped sources
                    }
                    else if (groups != null && groups.length > 0 && this.showGroups) {
                        for (var i = 0; i < groups.length; i++) {
                            this._addGroup(groups[i]);
                        }
                        // bind to regular sources
                    }
                    else {
                        for (var i = 0; i < list.length; i++) {
                            this._addBoundRow(list, i);
                        }
                    }
                }
            };
            /*protected*/ FlexGrid.prototype._addBoundRow = function (items, index) {
                this.rows.push(new grid.Row(items[index]));
            };
            /*protected*/ FlexGrid.prototype._addNode = function (items, index, level) {
                var gr = new grid.GroupRow(), path = this.childItemsPath, prop = wijmo.isArray(path) ? path[level] : path, item = items[index], children = item[prop];
                // add main node
                gr.dataItem = item;
                gr.level = level;
                this.rows.push(gr);
                // add child nodes
                if (wijmo.isArray(children)) {
                    for (var i = 0; i < children.length; i++) {
                        this._addNode(children, i, level + 1);
                    }
                }
            };
            FlexGrid.prototype._addGroup = function (g) {
                // add group row
                var gr = new grid.GroupRow();
                gr.level = g.level;
                gr.dataItem = g;
                this.rows.push(gr);
                // add child rows
                if (g.isBottomLevel) {
                    var items = g.items;
                    for (var i = 0; i < items.length; i++) {
                        this._addBoundRow(items, i);
                    }
                }
                else {
                    for (var i = 0; i < g.groups.length; i++) {
                        this._addGroup(g.groups[i]);
                    }
                }
            };
            // gets a list of the properties defined by a class and its ancestors
            // that have getters, setters, and whose names don't start with '_'.
            FlexGrid._getSerializableProperties = function (obj) {
                var arr = [];
                // travel up class hierarchy saving public properties that can be get/set.
                // NOTE: use getPrototypeOf instead of __proto__ for IE9 compatibility.
                for (obj = obj.prototype; obj != Object.prototype; obj = Object.getPrototypeOf(obj)) {
                    var names = Object.getOwnPropertyNames(obj);
                    for (var i = 0; i < names.length; i++) {
                        var name_1 = names[i], pd = Object.getOwnPropertyDescriptor(obj, name_1);
                        if (pd && pd.set && pd.get && name_1[0] != '_' &&
                            !name_1.match(/disabled|required/)) {
                            arr.push(name_1);
                        }
                    }
                }
                // done
                return arr;
            };
            // method used in JSON-style initialization
            FlexGrid.prototype._copy = function (key, value) {
                if (key == 'columns') {
                    this.columns.clear();
                    var arr = wijmo.asArray(value);
                    for (var i = 0; i < arr.length; i++) {
                        var c = new grid.Column();
                        wijmo.copy(c, arr[i]);
                        this.columns.push(c);
                    }
                    return true;
                }
                return false;
            };
            // checked whether an object is an input element
            FlexGrid.prototype._isInputElement = function (e) {
                if (e instanceof HTMLElement) {
                    // contentEditable elements want the mouse as well
                    if (e.contentEditable == 'true') {
                        return true;
                    }
                    // added 'OPTION' just for Firefox SELECT elements...
                    var m = e.tagName.match(/^(BUTTON|A|INPUT|TEXTAREA|SELECT|OPTION)$/i);
                    return m && m.length > 0;
                }
                return false;
            };
            // checks whether an element should receive input without being bothered by the grid
            FlexGrid.prototype._wantsInput = function (e) {
                return this._isInputElement(e) &&
                    !this.activeEditor &&
                    !this._edtHdl._isNativeCheckbox(e) && // TFS 284014
                    !wijmo.hasClass(e, 'wj-grid-ime') && // IME element
                    wijmo.contains(document.body, e); // not a disposed editor
            };
            FlexGrid._getMaxSupportedCssHeight = function () {
                if (!FlexGrid._maxCssHeight) {
                    // set limit based on browser (most efficient)
                    var maxHeight = 33500000; // Chrome
                    if (wijmo.isIE()) {
                        maxHeight = 1500000;
                    }
                    else if (wijmo.isFirefox()) {
                        maxHeight = 17500000;
                    }
                    FlexGrid._maxCssHeight = maxHeight;
                    // actual test, causes some layout thrashing
                    //let maxHeight = 1e6,
                    //    testUpTo = 60e6,
                    //    div = document.createElement('div');
                    //div.style.visibility = 'hidden';
                    //document.body.appendChild(div);
                    //for (let test = maxHeight; test <= testUpTo; test += 500000) {
                    //    div.style.height = test + 'px';
                    //    if (div.offsetHeight != test) break;
                    //    maxHeight = test;
                    //}
                    //removeChild(div);
                    //FlexGrid._maxCssHeight = maxHeight;
                }
                return FlexGrid._maxCssHeight;
            };
            FlexGrid._getRtlMode = function () {
                if (!FlexGrid._rtlMode) {
                    var el = wijmo.createElement('<div dir="rtl" style="visibility:hidden;width:100px;height:100px;overflow:auto">' +
                        '<div style="width:2000px;height:2000px"></div>' +
                        '</div>');
                    document.body.appendChild(el);
                    var sl = el.scrollLeft;
                    el.scrollLeft = -1000;
                    var sln = el.scrollLeft;
                    wijmo.removeChild(el);
                    FlexGrid._rtlMode = sln < 0 ? 'neg' : sl > 0 ? 'rev' : 'std';
                }
                return FlexGrid._rtlMode;
            };
            // constants
            FlexGrid._WJS_STICKY = 'wj-state-sticky';
            FlexGrid._WJS_MEASURE = 'wj-state-measuring';
            FlexGrid._WJS_UPDATING = 'wj-state-updating';
            FlexGrid._MIN_VIRT_ROWS = 200; // min rows required for window virtualization
            /**
             * Gets or sets the template used to instantiate @see:FlexGrid controls.
             */
            FlexGrid.controlTemplate = '<div style="position:relative;width:100%;height:100%;overflow:hidden;max-width:inherit;max-height:inherit">' +
                '<div wj-part="focus" aria-hidden="true" class="wj-cell" style="position:fixed;opacity:0;pointer-events:none;left:-10px">0</div>' +
                '<div wj-part="root" style="position:absolute;width:100%;height:100%;overflow:auto;-webkit-overflow-scrolling:touch;max-width:inherit;max-height:inherit">' + // cell container
                '<div wj-part="cells" class="wj-cells" style="position:absolute"></div>' + // cells
                '<div wj-part="marquee" aria-hidden="true" class="wj-marquee" style="display:none;pointer-events:none;">' + // marquee
                '<div style="width:100%;height:100%"></div>' +
                '</div>' +
                '</div>' +
                '<div wj-part="fcells" aria-hidden="true" class="wj-cells" style="position:absolute;pointer-events:none;overflow:hidden"></div>' + // frozen cells
                '<div wj-part="rh" aria-hidden="true" style="position:absolute;overflow:hidden;outline:none">' + // row header container
                '<div wj-part="rhcells" class="wj-rowheaders" style="position:relative"></div>' + // row header cells
                '</div>' +
                '<div wj-part="cf" aria-hidden="true" style="position:absolute;overflow:hidden;outline:none">' + // col footer container
                '<div wj-part="cfcells" class="wj-colfooters" style="position:relative"></div>' + // col footer cells
                '</div>' +
                '<div wj-part="ch" aria-hidden="true" style="position:absolute;overflow:hidden;outline:none">' + // col header container
                '<div wj-part="chcells" class="wj-colheaders" style="position:relative"></div>' + // col header cells
                '</div>' +
                '<div wj-part="bl" aria-hidden="true" style="position:absolute;overflow:hidden;outline:none">' + // bottom-left container 
                '<div wj-part="blcells" class="wj-bottomleft" style="position:relative"></div>' + // top-left cells
                '</div>' +
                '<div wj-part="tl" aria-hidden="true" style="position:absolute;overflow:hidden;outline:none">' + // top-left container
                '<div wj-part="tlcells" class="wj-topleft" style="position:relative"></div>' + // top-left cells
                '</div>' +
                '<div wj-part="sz" aria-hidden="true" style="position:relative;visibility:hidden"></div>' + // auto sizing
                '</div>';
            return FlexGrid;
        }(wijmo.Control));
        grid.FlexGrid = FlexGrid;
    })(grid = wijmo.grid || (wijmo.grid = {}));
})(wijmo || (wijmo = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var wijmo;
(function (wijmo) {
    var grid;
    (function (grid) {
        'use strict';
        /**
         * Provides arguments for @see:CellRange events.
         */
        var CellRangeEventArgs = /** @class */ (function (_super) {
            __extends(CellRangeEventArgs, _super);
            /**
             * Initializes a new instance of the @see:CellRangeEventArgs class.
             *
             * @param p @see:GridPanel that contains the range.
             * @param rng Range of cells affected by the event.
             * @param data Data related to the event.
             */
            function CellRangeEventArgs(p, rng, data) {
                var _this = _super.call(this) || this;
                _this._p = wijmo.asType(p, grid.GridPanel);
                _this._rng = wijmo.asType(rng, grid.CellRange);
                _this._data = data;
                return _this;
            }
            Object.defineProperty(CellRangeEventArgs.prototype, "panel", {
                /**
                 * Gets the @see:GridPanel affected by this event.
                 */
                get: function () {
                    return this._p;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CellRangeEventArgs.prototype, "range", {
                /**
                 * Gets the @see:CellRange affected by this event.
                 */
                get: function () {
                    return this._rng.clone();
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CellRangeEventArgs.prototype, "row", {
                /**
                 * Gets the row affected by this event.
                 */
                get: function () {
                    return this._rng.row;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CellRangeEventArgs.prototype, "col", {
                /**
                 * Gets the column affected by this event.
                 */
                get: function () {
                    return this._rng.col;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CellRangeEventArgs.prototype, "data", {
                /**
                 * Gets or sets the data associated with the event.
                 */
                get: function () {
                    return this._data;
                },
                set: function (value) {
                    this._data = value;
                },
                enumerable: true,
                configurable: true
            });
            return CellRangeEventArgs;
        }(wijmo.CancelEventArgs));
        grid.CellRangeEventArgs = CellRangeEventArgs;
        /**
         * Provides arguments for the @see:FlexGrid.formatItem event.
         */
        var FormatItemEventArgs = /** @class */ (function (_super) {
            __extends(FormatItemEventArgs, _super);
            /**
            * Initializes a new instance of the @see:FormatItemEventArgs class.
            *
            * @param p @see:GridPanel that contains the range.
            * @param rng Range of cells affected by the event.
            * @param cell Element that represents the grid cell to be formatted.
            */
            function FormatItemEventArgs(p, rng, cell) {
                var _this = _super.call(this, p, rng) || this;
                _this._cell = wijmo.asType(cell, HTMLElement);
                return _this;
            }
            Object.defineProperty(FormatItemEventArgs.prototype, "cell", {
                /**
                 * Gets a reference to the element that represents the grid cell to be formatted.
                 */
                get: function () {
                    return this._cell;
                },
                enumerable: true,
                configurable: true
            });
            return FormatItemEventArgs;
        }(CellRangeEventArgs));
        grid.FormatItemEventArgs = FormatItemEventArgs;
        /**
         * Provides arguments for the @see:FlexGrid.cellEditEnding event.
         */
        var CellEditEndingEventArgs = /** @class */ (function (_super) {
            __extends(CellEditEndingEventArgs, _super);
            function CellEditEndingEventArgs() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this._stayInEditMode = false;
                _this._refresh = true;
                return _this;
            }
            Object.defineProperty(CellEditEndingEventArgs.prototype, "stayInEditMode", {
                /**
                 * Gets or sets whether the cell should remain in edit mode instead
                 * of finishing the edits.
                 */
                get: function () {
                    return this._stayInEditMode;
                },
                set: function (value) {
                    this._stayInEditMode = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CellEditEndingEventArgs.prototype, "refresh", {
                /**
                 * Gets or sets a value that determines whether the grid should refresh
                 * all its contents after the edits are done.
                 */
                get: function () {
                    return this._refresh;
                },
                set: function (value) {
                    this._refresh = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            return CellEditEndingEventArgs;
        }(CellRangeEventArgs));
        grid.CellEditEndingEventArgs = CellEditEndingEventArgs;
    })(grid = wijmo.grid || (wijmo.grid = {}));
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    var grid;
    (function (grid) {
        'use strict';
        /**
         * Specifies constants that define the type of cell in a @see:GridPanel.
         */
        var CellType;
        (function (CellType) {
            /** Unknown or invalid cell type. */
            CellType[CellType["None"] = 0] = "None";
            /** Regular data cell. */
            CellType[CellType["Cell"] = 1] = "Cell";
            /** Column header cell. */
            CellType[CellType["ColumnHeader"] = 2] = "ColumnHeader";
            /** Row header cell. */
            CellType[CellType["RowHeader"] = 3] = "RowHeader";
            /** Top-left cell. */
            CellType[CellType["TopLeft"] = 4] = "TopLeft";
            /** Column footer cell. */
            CellType[CellType["ColumnFooter"] = 5] = "ColumnFooter";
            /** Bottom left cell (at the intersection of the row header and column footer cells). **/
            CellType[CellType["BottomLeft"] = 6] = "BottomLeft";
        })(CellType = grid.CellType || (grid.CellType = {}));
        /**
         * Represents a logical part of the grid, such as the column headers, row headers,
         * and scrollable data part.
         */
        var GridPanel = /** @class */ (function () {
            /**
             * Initializes a new instance of the @see:GridPanel class.
             *
             * @param g The @see:FlexGrid object that owns the panel.
             * @param cellType The type of cell in the panel.
             * @param rows The rows displayed in the panel.
             * @param cols The columns displayed in the panel.
             * @param host The HTMLElement that hosts the cells in the control.
             */
            function GridPanel(g, cellType, rows, cols, host) {
                this._offsetY = 0;
                this._g = wijmo.asType(g, grid.FlexGrid);
                this._ct = wijmo.asInt(cellType);
                this._rows = wijmo.asType(rows, grid.RowCollection);
                this._cols = wijmo.asType(cols, grid.ColumnCollection);
                this._e = wijmo.asType(host, HTMLElement);
                this._vrb = new grid.CellRange();
            }
            Object.defineProperty(GridPanel.prototype, "grid", {
                /**
                 * Gets the grid that owns the panel.
                 */
                get: function () {
                    return this._g;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(GridPanel.prototype, "cellType", {
                /**
                 * Gets the type of cell contained in the panel.
                 */
                get: function () {
                    return this._ct;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(GridPanel.prototype, "viewRange", {
                /**
                 * Gets a @see:CellRange that indicates the range of cells currently visible on the panel.
                 */
                get: function () {
                    return this._getViewRange();
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(GridPanel.prototype, "width", {
                /**
                 * Gets the total width of the content in the panel.
                 */
                get: function () {
                    return this._cols.getTotalSize();
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(GridPanel.prototype, "height", {
                /**
                 * Gets the total height of the content in this panel.
                 */
                get: function () {
                    return this._rows.getTotalSize();
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(GridPanel.prototype, "rows", {
                /**
                 * Gets the panel's row collection.
                 */
                get: function () {
                    return this._rows;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(GridPanel.prototype, "columns", {
                /**
                 * Gets the panel's column collection.
                 */
                get: function () {
                    return this._cols;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Gets the value stored in a cell in the panel.
             *
             * @param r The row index of the cell.
             * @param c The index, name, or binding of the column that contains the cell.
             * @param formatted Whether to format the value for display.
             */
            GridPanel.prototype.getCellData = function (r, c, formatted) {
                var row = this._rows[wijmo.asNumber(r, false, true)], col, value = null;
                // get column index by name or binding
                if (wijmo.isString(c)) {
                    c = this._cols.indexOf(c);
                    if (c < 0) {
                        throw 'Invalid column name or binding.';
                    }
                }
                // get column
                col = this._cols[wijmo.asNumber(c, false, true)];
                // get binding column (MultiRow grid may have multiple display columns for each physical column)
                var bcol = this._g ? this._g._getBindingColumn(this, r, col) : col;
                // get bound value from data item using binding
                if (bcol.binding && row.dataItem &&
                    !(row.dataItem instanceof wijmo.collections.CollectionViewGroup)) {
                    value = bcol._binding.getValue(row.dataItem);
                }
                else if (row._ubv) {
                    value = row._ubv[col._hash];
                }
                // special values for row and column headers, aggregates
                if (value == null) {
                    switch (this._ct) {
                        case CellType.ColumnHeader:
                            if (r == this._rows.length - 1 || bcol != col) {
                                value = bcol.header;
                            }
                            break;
                        case CellType.ColumnFooter:
                            if (bcol.aggregate != wijmo.Aggregate.None && row instanceof grid.GroupRow) {
                                var view = this._g.collectionView;
                                if (view) {
                                    var cv = wijmo.tryCast(view, wijmo.collections.CollectionView);
                                    value = cv
                                        ? cv.getAggregate(bcol.aggregate, bcol.binding)
                                        : wijmo.getAggregate(bcol.aggregate, view.items, bcol.binding);
                                }
                            }
                            break;
                        case CellType.Cell:
                            if (bcol.aggregate != wijmo.Aggregate.None && row instanceof grid.GroupRow) {
                                var group = wijmo.tryCast(row.dataItem, wijmo.collections.CollectionViewGroup);
                                if (group) {
                                    value = group.getAggregate(bcol.aggregate, bcol.binding, this._g.collectionView);
                                }
                            }
                            break;
                    }
                }
                // format value if requested, never return null
                if (formatted) {
                    if (this.cellType == CellType.Cell && bcol.dataMap) {
                        value = bcol.dataMap.getDisplayValue(value);
                    }
                    value = value != null ? wijmo.Globalize.format(value, bcol.format) : '';
                }
                // done
                return value;
            };
            /**
             * Sets the content of a cell in the panel.
             *
             * @param r The index of the row that contains the cell.
             * @param c The index, name, or binding of the column that contains the cell.
             * @param value The value to store in the cell.
             * @param coerce Whether to change the value automatically to match the column's data type.
             * @param invalidate Whether to invalidate the grid to show the change.
             * @return Returns true if the value is stored successfully, false otherwise (failed cast).
             */
            GridPanel.prototype.setCellData = function (r, c, value, coerce, invalidate) {
                if (coerce === void 0) { coerce = true; }
                if (invalidate === void 0) { invalidate = true; }
                var row = this._rows[wijmo.asNumber(r, false, true)], col;
                // get column index by name or binding
                if (wijmo.isString(c)) {
                    c = this._cols.indexOf(c);
                    if (c < 0) {
                        throw 'Invalid column name or binding.';
                    }
                }
                // get column
                col = this._cols[wijmo.asNumber(c, false, true)];
                // get binding column (MultiRow grid may have multiple display columns for each physical column)
                var bcol = this._g ? this._g._getBindingColumn(this, r, col) : col;
                // handle dataMap, coercion, type-checking
                if (this._ct == CellType.Cell) {
                    // honor dataMap
                    if (bcol.dataMap && value != null) {
                        if (bcol.isRequired || value != '') {
                            var map = bcol.dataMap, key = map.getKeyValue(value);
                            if (key == null && map.getDisplayValue(null) == null) {
                                if (!map.isEditable || map.displayMemberPath != map.selectedValuePath) {
                                    return false; // not on map, not editable? cancel edits
                                }
                            }
                            else {
                                value = key; // got the key, use it instead of the value
                            }
                        }
                    }
                    // get target type
                    var targetType = wijmo.DataType.Object;
                    if (bcol.dataType) {
                        targetType = bcol.dataType;
                    }
                    else {
                        var current = this.getCellData(r, c, false);
                        targetType = wijmo.getType(current);
                    }
                    // honor 'isRequired' property
                    if (wijmo.isBoolean(bcol.isRequired)) {
                        if (!bcol.isRequired && (value === '' || value === null)) {
                            value = null; // setting to null
                            coerce = false;
                        }
                        else if (bcol.isRequired && (value === '' || value === null)) {
                            return false; // value is required
                        }
                    }
                    // coerce type if required
                    if (coerce) {
                        value = wijmo.changeType(value, targetType, bcol.format);
                        if (targetType != wijmo.DataType.Object && wijmo.getType(value) != targetType) {
                            return false; // wrong data type
                        }
                    }
                }
                // store value
                if (row.dataItem && bcol.binding) {
                    var binding = bcol._binding, item = row.dataItem, oldValue = binding.getValue(item);
                    if (value !== oldValue && !wijmo.DateTime.equals(value, oldValue)) {
                        // set the value
                        binding.setValue(item, value);
                        // track changes in CollectionView if this is not the current edit item (e.g. when pasting)
                        var view = this._g.collectionView;
                        if (view instanceof wijmo.collections.CollectionView && item != view.currentEditItem) {
                            var e = new wijmo.collections.NotifyCollectionChangedEventArgs(wijmo.collections.NotifyCollectionChangedAction.Change, item, view.items.indexOf(item));
                            view.onCollectionChanged(e);
                        }
                    }
                }
                else {
                    if (!row._ubv)
                        row._ubv = {};
                    row._ubv[col._hash] = value;
                }
                // invalidate
                if (invalidate && this._g) {
                    this._g.invalidate();
                }
                // done
                return true;
            };
            /**
             * Gets a cell's bounds in viewport coordinates.
             *
             * The returned value is a @see:Rect object which contains the position and dimensions
             * of the cell in viewport coordinates.
             * The viewport coordinates are the same as those used by the
             * <a href="https://developer.mozilla.org/en-US/docs/Web/API/Element.getBoundingClientRect"
             * target="_blank">getBoundingClientRect</a> method.
             *
             * @param r The index of the row that contains the cell.
             * @param c The index of the column that contains the cell.
             * @param raw Whether to return the rectangle in raw panel coordinates as opposed to viewport coordinates.
             */
            GridPanel.prototype.getCellBoundingRect = function (r, c, raw) {
                // get rect in panel coordinates
                var row = this.rows[r], col = this.columns[c], rc = new wijmo.Rect(col.pos, row.pos, col.renderSize, row.renderSize);
                // adjust for rtl
                if (this._g.rightToLeft) {
                    rc.left = this.hostElement.clientWidth - rc.right;
                    // account for scrollbars (in Chrome only: TFS 240091)
                    if (!wijmo.isIE() && !wijmo.isFirefox()) {
                        var root = this.hostElement.parentElement;
                        rc.left -= root.offsetWidth - root.clientWidth;
                    }
                }
                // adjust for panel position
                if (!raw) {
                    var rcp = this.hostElement.getBoundingClientRect();
                    rc.left += rcp.left;
                    rc.top += rcp.top - this._offsetY;
                }
                // account for frozen rows/columns (TFS 105593)
                if (r < this.rows.frozen) {
                    rc.top -= this._g.scrollPosition.y;
                }
                if (c < this.columns.frozen) {
                    rc.left -= this._g.scrollPosition.x * (this._g.rightToLeft ? -1 : +1);
                }
                // done
                return rc;
            };
            /**
             * Gets the element that represents a cell within this @see:GridPanel.
             *
             * If the cell is not currently in view, this method returns null.
             *
             * @param r The index of the row that contains the cell.
             * @param c The index of the column that contains the cell.
             */
            GridPanel.prototype.getCellElement = function (r, c) {
                var rows = this.hostElement.children, nrows = Math.min(r + 2, rows.length);
                for (var i = 0; i < nrows; i++) {
                    var row = rows[i].children, ncols = Math.min(c + 2, row.length);
                    for (var j = 0; j < ncols; j++) {
                        var cell = row[j], index = cell[GridPanel._INDEX_KEY];
                        if (index) {
                            if ((index.row == r && index.col == c) ||
                                (index.rng && index.rng.contains(r, c))) {
                                return cell;
                            }
                        }
                    }
                }
                return null;
            };
            /**
             * Gets a @see:SelectedState value that indicates the selected state of a cell.
             *
             * @param r Row index of the cell to inspect.
             * @param c Column index of the cell to inspect.
             * @param rng @see:CellRange that contains the cell to inspect.
             */
            GridPanel.prototype.getSelectedState = function (r, c, rng) {
                var g = this._g, mode = g.selectionMode, sel = g._selHdl.selection, sm = grid.SelectionMode, ss = grid.SelectedState;
                if (mode != sm.None) {
                    switch (this._ct) {
                        // regular cells
                        case CellType.Cell:
                            // handle merged ranges
                            if (!rng) {
                                rng = g.getMergedRange(this, r, c);
                            }
                            if (rng) {
                                if (rng.contains(sel.row, sel.col)) {
                                    return g.showMarquee ? ss.None : ss.Cursor;
                                }
                                else if (rng.intersects(sel)) {
                                    return ss.Selected;
                                }
                            }
                            // cursor (if not showing marquee)
                            if (sel.row == r && sel.col == c) {
                                return g.showMarquee ? ss.None : ss.Cursor;
                            }
                            // special case: row/col selected property
                            if (g.rows[r].isSelected || g.columns[c].isSelected) {
                                return ss.Selected;
                            }
                            // special case for merged cells with row-style selection (TFS 294209)
                            if (rng) {
                                switch (mode) {
                                    case sm.Row:
                                    case sm.RowRange:
                                    case sm.ListBox:
                                        if (rng.containsRow(sel.row)) {
                                            return ss.Selected;
                                        }
                                }
                            }
                            // adjust for selection mode
                            sel = g._selHdl._adjustSelection(sel);
                            // ListBox mode (already checked for selected rows/cols)
                            if (mode == grid.SelectionMode.ListBox) {
                                return ss.None;
                            }
                            // regular ranges
                            return sel.containsRow(r) && sel.containsColumn(c)
                                ? ss.Selected
                                : ss.None;
                        // column headers
                        case CellType.ColumnHeader:
                            if (g.showSelectedHeaders & grid.HeadersVisibility.Column) {
                                if (g.columns[c].isSelected || sel.containsColumn(c) || sel.intersectsColumn(rng)) {
                                    if (rng)
                                        r = rng.bottomRow;
                                    if (r == this.rows.length - 1) {
                                        return ss.Selected;
                                    }
                                }
                            }
                            break;
                        // row headers
                        case CellType.RowHeader:
                            if (g.showSelectedHeaders & grid.HeadersVisibility.Row) {
                                if (g.rows[r].isSelected || sel.containsRow(r) || sel.intersectsRow(rng)) {
                                    if (rng)
                                        c = rng.rightCol;
                                    if (c == this.columns.length - 1) {
                                        return ss.Selected;
                                    }
                                }
                            }
                            break;
                    }
                }
                // not selected
                return ss.None;
            };
            Object.defineProperty(GridPanel.prototype, "hostElement", {
                /**
                 * Gets the host element for the panel.
                 */
                get: function () {
                    return this._e;
                },
                enumerable: true,
                configurable: true
            });
            // ** implementation
            /* -- do not document, this is internal --
             * Gets the Y offset for cells in the panel.
             */
            GridPanel.prototype._getOffsetY = function () {
                return this._offsetY;
            };
            /* -- do not document, this is internal --
             * Updates the cell elements in the panel.
             * @param recycle Whether to recycle existing elements or start from scratch.
             * @param state Whether to keep existing elements and update their state.
             * @param offsetY Scroll position to use when updating the panel.
             */
            GridPanel.prototype._updateContent = function (recycle, state, offsetY) {
                var g = this._g, host = this._e, rows = this._rows, cols = this._cols, ct = this._ct;
                // scroll headers into position
                if (ct == CellType.ColumnHeader || ct == CellType.ColumnFooter || ct == CellType.RowHeader) {
                    var sp = g._ptScrl, s = host.style;
                    if (ct == CellType.RowHeader) {
                        s.top = sp.y + 'px';
                    }
                    else {
                        if (g.rightToLeft) {
                            s.right = sp.x + 'px';
                        }
                        else {
                            s.left = sp.x + 'px';
                        }
                    }
                }
                // update offset (and don't recycle if it changed!)
                if (this._offsetY != offsetY) {
                    recycle = false;
                    this._offsetY = offsetY;
                }
                // calculate new unbuffered view range
                var vru = this._getViewRange();
                // calculate new buffered view range
                var vrb = vru;
                if (rows.length <= g.virtualizationThreshold) {
                    vrb = new grid.CellRange(0, 0, rows.length - 1, cols.length - 1);
                }
                else {
                    if (vrb.isValid && g.isTouching) {
                        var sz = 6;
                        vrb = new grid.CellRange(Math.max(vru.row - sz, rows.frozen), Math.max(vru.col - 1, cols.frozen), Math.min(vru.row2 + sz, rows.length - 1), Math.min(vru.col2 + 1, cols.length - 1));
                    }
                }
                // done if recycling, not updating state, and old range contains new (unbuffered)
                // this happens a lot while scrolling by small amounts (< 1 cell)
                if (recycle && !state && this._vrb.contains(vru) && !rows.frozen && !cols.frozen) {
                    return this._activeCell;
                }
                // if not recycling or if the range changed, can't just update state
                if (!recycle || !vrb.equals(this._vrb)) {
                    state = false;
                }
                // reorder cells to optimize scrolling (headers too)
                if (recycle && !state && this._ct != CellType.TopLeft) {
                    this._reorderCells(vrb, this._vrb);
                }
                // reset active cell
                this._activeCell = null;
                // save new ranges
                this._vru = vru;
                this._vrb = vrb;
                // save cell factory
                this._cf = g.cellFactory;
                // add dummy column header row to cells panel
                // (for accessibility only)
                var ctr = 0;
                if (this._ct == CellType.Cell) {
                    ctr = this._renderColHdrRow(vrb, state);
                }
                // go create/update the cells
                for (var r = 0; r < rows.frozen && r < rows.length; r++) {
                    ctr = this._renderRow(r, vrb, state, ctr);
                }
                for (var r = vrb.topRow; r <= vrb.bottomRow && r > -1; r++) {
                    ctr = this._renderRow(r, vrb, state, ctr);
                }
                // remove extra rows
                while (host.childElementCount > ctr) {
                    var row = host.lastElementChild;
                    host.removeChild(row);
                    this._removeExtraCells(row, 0);
                }
                // done
                return this._activeCell;
            };
            // update header panel scroll position
            GridPanel.prototype._updateScrollPosition = function () {
                var g = this._g, sp = g._ptScrl, s = this.hostElement.style;
                if (this.cellType == CellType.RowHeader) {
                    s.top = sp.y + 'px';
                }
                else {
                    if (g.rightToLeft) {
                        s.right = sp.x + 'px';
                    }
                    else {
                        s.left = sp.x + 'px';
                    }
                }
            };
            // clear all cell elements
            GridPanel.prototype._clearCells = function () {
                var host = this.hostElement;
                for (var i = host.childElementCount - 1; i >= 0; i--) {
                    var row = host.children[i];
                    host.removeChild(row);
                    for (var j = row.childElementCount - 1; j >= 0; j--) {
                        this._cf.disposeCell(row.children[j]);
                    }
                }
            };
            // reorder cells within the panel to optimize scrolling performance
            // NOTE: the elements being re-ordered (rows) must be absolutely positioned,
            // or Chrome may change the scrollPosition and cause flicker (TFS 261344)
            GridPanel.prototype._reorderCells = function (rngNew, rngOld) {
                // sanity
                if (this._rows.frozen > 0 || this._cols.frozen > 0 ||
                    rngNew.columnSpan != rngOld.columnSpan || rngNew.rowSpan != rngOld.rowSpan ||
                    !rngOld.isValid || !rngNew.isValid || !rngNew.intersects(rngOld)) {
                    return;
                }
                // vertical scrolling
                if (rngNew.row != rngOld.row) {
                    var delta = rngNew.row - rngOld.row, limit = Math.max(1, rngNew.rowSpan - 1), host = this._e;
                    if (delta != 0 && Math.abs(delta) < limit) {
                        // keep fake column header row in view
                        var first = this._ct == CellType.Cell ? 1 : 0, cnt = host.childElementCount;
                        // down:
                        // remove rows from the top and append to bottom
                        if (delta > 0) {
                            var start = first, end = Math.min(first + delta, cnt - 1), rng = this._createRange(start, end);
                            if (rng && end < cnt - 1) {
                                host.appendChild(rng.extractContents());
                            }
                        }
                        // up:
                        // remove rows from the bottom and insert at the top
                        if (delta < 0) {
                            var end = cnt, start = Math.max(first, end + delta), rng = this._createRange(start, end);
                            if (rng && start > first) {
                                var ref = host.children[first];
                                host.insertBefore(rng.extractContents(), ref);
                            }
                        }
                    }
                }
            };
            // creates a range of cells that can be moved to optimize rendering
            GridPanel.prototype._createRange = function (start, end) {
                var rng, cnt = this._e.childElementCount;
                if (end > start && end <= cnt && start > -1) {
                    rng = document.createRange();
                    rng.setStart(this._e, start);
                    rng.setEnd(this._e, end);
                }
                return rng;
            };
            // renders a hidden header row that keeps accessibility tools happy
            GridPanel.prototype._renderColHdrRow = function (rng, state) {
                // create row element, add to panel
                var row = this._e.children[0];
                if (!row) {
                    row = wijmo.createElement('<div class="wj-row" tabindex="-1" role="row"></div>', this._e);
                }
                wijmo.setAttribute(row, 'aria-selected', null);
                // add row header cell
                var ctc = 0, rhBinding = this._g._getRowHeaderPath();
                if (rhBinding) {
                    ctc = this._renderRowHdrCell(row, -1, rhBinding.path);
                }
                // add cells to visible columns
                for (var c = 0; c < this.columns.frozen && c < this.columns.length; c++) {
                    ctc = this._renderColHdrCell(row, c, rng, state, ctc);
                }
                for (var c = rng.leftCol; c <= rng.rightCol && c > -1; c++) {
                    ctc = this._renderColHdrCell(row, c, rng, state, ctc);
                }
                // remove extra cells from header row (TFS 260932)
                this._removeExtraCells(row, ctc);
                // created a row
                return 1;
            };
            // renders a cell in the hidden header row that keeps accessibility tools happy
            GridPanel.prototype._renderColHdrCell = function (row, c, rng, state, ctr) {
                // skip hidden columns
                var col = this.columns[c];
                if (col.renderSize <= 0) {
                    return ctr;
                }
                // try recycling a cell
                var cell = row.children[ctr];
                // create or recycle cell
                if (!cell) {
                    cell = wijmo.createElement('<div class="wj-cell" tabindex="-1" role="columnheader"></div>', row);
                }
                // set cell content and style
                if (!state) {
                    cell.textContent = this.columns[c].header;
                    wijmo.setCss(cell, {
                        position: 'fixed',
                        top: -32000,
                        height: .1,
                        left: col.pos,
                        width: col.renderWidth,
                        overflow: 'hidden',
                        opacity: '0',
                        pointerEvents: 'none'
                    });
                }
                // accessibility https://www.w3.org/TR/wai-aria-1.1/#aria-sort
                var g = this.grid;
                if (g.allowSorting) {
                    var attVal = 'none', bcol = g._getBindingColumn(this, 0, col);
                    switch (bcol.currentSort) {
                        case '+':
                            attVal = 'ascending';
                            break;
                        case '-':
                            attVal = 'descending';
                            break;
                    }
                    wijmo.setAttribute(cell, 'aria-sort', attVal);
                }
                // set cell index
                //setAttribute(cell, 'aria-colindex', col.visibleIndex + 1);
                cell[GridPanel._INDEX_KEY] = { row: -1, col: c, panel: this };
                // done
                return ctr + 1;
            };
            // renders a row header cell
            GridPanel.prototype._renderRowHdrCell = function (row, r, value) {
                // create or recycle cell
                var cell = row.children[0];
                if (!cell) {
                    cell = wijmo.createElement('<div class="wj-cell" tabindex="-1"></div>', row);
                }
                // set cell content and style
                cell.setAttribute('role', r < 0 ? 'columnheader' : 'rowheader');
                cell.textContent = value ? value.toString() : '';
                wijmo.setCss(cell, {
                    position: 'fixed',
                    left: -32000,
                    top: -32000,
                    width: .1,
                    height: .1,
                    overflow: 'hidden',
                    opacity: '0'
                });
                cell[GridPanel._INDEX_KEY] = { row: r, col: -1, panel: this };
                // done
                return 1;
            };
            // renders a row
            GridPanel.prototype._renderRow = function (r, rng, state, ctr) {
                // skip invisible rows
                var g = this._g, gr = this.rows[r], sz = gr.renderSize;
                if (sz <= 0) {
                    return ctr;
                }
                // create row element, add to panel
                var row = this._e.children[ctr];
                if (!row) {
                    row = wijmo.createElement('<div class="wj-row" tabindex="-1"></div>', this._e);
                    if (this._ct == CellType.Cell) {
                        row.setAttribute('role', 'row');
                    }
                }
                // accessibility
                // (MS request: tag selected rows in ListBox mode)
                if (this._ct == CellType.Cell) {
                    var sm = grid.SelectionMode;
                    switch (g.selectionMode) {
                        case sm.Row:
                        case sm.RowRange:
                        case sm.ListBox:
                            var selected = gr.isSelected || this._g._selHdl.selection.containsRow(r);
                            wijmo.setAttribute(row, 'aria-selected', selected ? true : false);
                    }
                }
                // add row header cell
                var ctc = 0;
                if (this._ct == CellType.Cell) {
                    var rhBinding = this._g._getRowHeaderPath();
                    if (rhBinding) {
                        ctc = this._renderRowHdrCell(row, r, rhBinding.getValue(gr.dataItem));
                    }
                }
                // add cells to visible columns
                for (var c = 0; c < this.columns.frozen && c < this.columns.length; c++) {
                    ctc = this._renderCell(row, r, c, rng, state, ctc);
                }
                for (var c = rng.leftCol; c <= rng.rightCol && c > -1; c++) {
                    ctc = this._renderCell(row, r, c, rng, state, ctc);
                }
                // remove extra cells from this row
                this._removeExtraCells(row, ctc);
                // done
                return ctr + 1;
            };
            // renders a cell
            GridPanel.prototype._renderCell = function (row, r, c, rng, state, ctr) {
                // skip over cells that have been merged over
                var g = this._g, mrng = g.getMergedRange(this, r, c);
                if (mrng) {
                    for (var over = Math.max(rng.row, mrng.row); over < r; over++) {
                        if (this.rows[over].isVisible)
                            return ctr;
                    }
                    for (var over = Math.max(rng.col, mrng.col); over < c; over++) {
                        if (this.columns[over].isVisible)
                            return ctr;
                    }
                }
                // skip hidden and non-merged columns
                var col = this.columns[c];
                if (col.renderSize <= 0) {
                    if (!mrng || mrng.getRenderSize(this).width <= 0) {
                        return ctr;
                    }
                }
                // keep track of selected cell
                var selected = false;
                if (this.cellType == CellType.Cell) {
                    var sel = g._selHdl.selection;
                    selected = (sel.row == r && sel.col == c) || (mrng && mrng.contains(sel.row, sel.col));
                }
                // try recycling a cell
                var cell = row.children[ctr];
                // update selected state
                var selState = this.getSelectedState(r, c, mrng), ss = grid.SelectedState;
                if (cell && state) {
                    wijmo.toggleClass(cell, 'wj-state-selected', selState == ss.Cursor);
                    wijmo.toggleClass(cell, 'wj-state-multi-selected', selState == ss.Selected);
                    if (selected) {
                        this._activeCell = cell;
                    }
                    return ctr + 1;
                }
                // create or recycle cell
                if (!cell) {
                    cell = document.createElement('div');
                    cell.tabIndex = -1; // default in Chrome, but not in IE...
                    if (this._ct == CellType.Cell) {
                        cell.setAttribute('role', 'gridcell');
                    }
                    row.appendChild(cell);
                }
                // accessibility
                if (selected) {
                    this._activeCell = cell;
                }
                // set/update cell content/style
                g.cellFactory.updateCell(this, r, c, cell, mrng);
                // store cell coordinates in the cell
                cell[GridPanel._INDEX_KEY] = { row: r, col: c, rng: mrng, panel: this };
                // accessibility
                //if (this._ct == CellType.Cell) {
                //    setAttribute(cell, 'aria-selected', selected || selState != ss.None);
                //    setAttribute(cell, 'aria-readonly', !g.canEditCell(r, c) ? true : null);
                //    setAttribute(cell, 'aria-colindex', col.visibleIndex + 1);
                //    setAttribute(cell, 'aria-rowspan', mrng && mrng.rowSpan > 1 ? mrng.rowSpan : null);
                //    setAttribute(cell, 'aria-colspan', mrng && mrng.columnSpan > 1 ? mrng.columnSpan : null);
                //}
                // done
                return ctr + 1;
            };
            // remove extra cells from a row element
            GridPanel.prototype._removeExtraCells = function (row, count) {
                while (row.childElementCount > count) {
                    var cell = row.lastElementChild;
                    row.removeChild(cell);
                    this._cf.disposeCell(cell);
                }
            };
            // gets the range of cells currently visible
            GridPanel.prototype._getViewRange = function () {
                var g = this._g, sp = g._ptScrl, rows = this._rows, cols = this._cols, rng = new grid.CellRange(0, 0, rows.length - 1, cols.length - 1);
                // calculate row range
                if (this._ct == CellType.Cell || this._ct == CellType.RowHeader) {
                    var y = -sp.y + this._offsetY, h = g._szClient.height, fz = Math.min(rows.frozen, rows.length - 1);
                    // account for frozen rows
                    if (fz > 0) {
                        var fzs = rows[fz - 1].pos;
                        y += fzs;
                        h -= fzs;
                    }
                    // set row range
                    rng.row = Math.min(rows.length - 1, Math.max(rows.frozen, rows.getItemAt(y + 1)));
                    rng.row2 = rows.getItemAt(y + h + 1); // TFS 273979
                    // clip to screen (in case user didn't limit the grid height)
                    if (g._clipToScreen) {
                        var rc = g.hostElement.getBoundingClientRect();
                        if (rc.top < 0) {
                            rng.row = Math.max(rng.row, rows.getItemAt(-rc.top - g._ptScrl.y) - 1);
                            //console.log('top row => ' + rng.row);
                        }
                        if (rc.bottom > innerHeight) {
                            rng.row2 = Math.min(rng.row2, rows.getItemAt(-rc.top - g._ptScrl.y + innerHeight) + 1);
                            //console.log('bot row => ' + rng.row2);
                        }
                    }
                }
                // calculate column range
                if (this._ct == CellType.Cell || this._ct == CellType.ColumnHeader) {
                    var x = -sp.x, w = g._szClient.width, fz = Math.min(cols.frozen, cols.length - 1);
                    // account for frozen columns
                    if (fz > 0) {
                        var fzs = cols[fz - 1].pos;
                        x += fzs;
                        w -= fzs;
                    }
                    // set column range
                    rng.col = Math.min(cols.length - 1, Math.max(cols.frozen, cols.getItemAt(x + 1)));
                    rng.col2 = cols.getItemAt(x + w + 1); // TFS 273979
                }
                // handle case where all rows/cols are frozen
                if (rows.length <= rows.frozen) {
                    rng.row = rng.row2 = -1;
                }
                if (cols.length <= cols.frozen) {
                    rng.col = rng.col2 = -1;
                }
                // return the viewRange
                return rng;
            };
            // gets the point where the frozen area ends
            GridPanel.prototype._getFrozenPos = function () {
                var fzr = this._rows.frozen, fzc = this._cols.frozen, fzrow = fzr > 0 ? this._rows[fzr - 1] : null, fzcol = fzc > 0 ? this._cols[fzc - 1] : null, fzy = fzrow ? fzrow.pos + fzrow.renderSize : 0, fzx = fzcol ? fzcol.pos + fzcol.renderSize : 0;
                return new wijmo.Point(fzx, fzy);
            };
            // attach index information to cell elements
            // cell[_INDEX_KEY] = { row: r, col: c, panel: this }
            GridPanel._INDEX_KEY = 'wj-cell-index';
            return GridPanel;
        }());
        grid.GridPanel = GridPanel;
    })(grid = wijmo.grid || (wijmo.grid = {}));
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    var grid;
    (function (grid) {
        'use strict';
        /**
         * Creates HTML elements that represent cells within a @see:FlexGrid control.
         */
        var CellFactory = /** @class */ (function () {
            function CellFactory() {
            }
            /**
             * Creates or updates a cell in the grid.
             *
             * @param p The @see:GridPanel that contains the cell.
             * @param r The index of the row that contains the cell.
             * @param c The index of the column that contains the cell.
             * @param cell The element that represents the cell.
             * @param rng The @see:CellRange object that contains the cell's
             * merged range, or null if the cell is not merged.
             * @param updateContent Whether to update the cell's content as
             * well as its position and style.
             */
            CellFactory.prototype.updateCell = function (p, r, c, cell, rng, updateContent) {
                var g = p.grid, rtl = g.rightToLeft, ct = p.cellType, rows = p.rows, cols = p.columns, row = rows[r], col = cols[c], r2 = r, c2 = c, gr = (row instanceof grid.GroupRow ? row : null), nr = (row instanceof grid._NewRowTemplate ? row : null), cellWidth = col.renderWidth, cellHeight = row.renderHeight, cl = 'wj-cell', css = { display: '' };
                // clear cells that have child elements before re-using them
                // this is a workaround for a bug in IE that affects templates
                // strangely, setting the cell's innerHTML to '' doesn't help...
                if (updateContent != false && cell.firstElementChild) {
                    if (cell.childNodes.length != 1 || cell.firstElementChild.type != 'checkbox') {
                        cell.textContent = '';
                    }
                }
                // adjust for merged ranges
                if (rng && !rng.isSingleCell) {
                    r = rng.row;
                    c = rng.col;
                    r2 = rng.row2;
                    c2 = rng.col2;
                    row = rows[r];
                    col = cols[c];
                    gr = row instanceof grid.GroupRow ? row : null;
                    var sz = rng.getRenderSize(p);
                    cellHeight = sz.height;
                    cellWidth = sz.width;
                }
                // get column to use for binding (usually the same as col, but not on MultiRow)
                var bcol = g._getBindingColumn(p, r, col);
                // use checkboxes if the dataType is Boolean and there's no dataMap
                var checkBox = bcol.dataType == wijmo.DataType.Boolean && !bcol.dataMap;
                // get cell position accounting for frozen rows/columns
                // in non-Chrome browsers, frozen cells: will be moved to a fixed div, 
                // so adjust the scroll position for that
                // in Chrome, they will remain in the cells div, so adjust for that instead
                // (not when editing...)
                var cpos = col.pos, rpos = row.pos;
                if (g._useFrozenDiv() && ct == grid.CellType.Cell && !g.editRange) {
                    if (r < rows.frozen && c >= cols.frozen) {
                        cpos += g._ptScrl.x;
                    }
                    if (c < cols.frozen && r >= rows.frozen) {
                        rpos += g._ptScrl.y;
                    }
                }
                else {
                    if (r < rows.frozen) {
                        rpos -= g._ptScrl.y;
                    }
                    if (c < cols.frozen) {
                        cpos -= g._ptScrl.x;
                    }
                }
                // size and position
                if (rtl) {
                    css.right = cpos + 'px';
                }
                else {
                    css.left = cpos + 'px';
                }
                css.top = (rpos - p._getOffsetY()) + 'px';
                css.width = cellWidth + 'px';
                css.height = cellHeight + 'px';
                // set z-index for frozen cells in all panels
                // (we're rendering in natural order for accessibility)
                css.zIndex = '';
                if (r < rows.frozen || c < cols.frozen) {
                    css.zIndex = (r < rows.frozen && c < cols.frozen) ? 2 : 1;
                }
                // selector classes that only apply to regular cells
                if (ct == grid.CellType.Cell) {
                    if (gr) {
                        cl += ' wj-group';
                    }
                    if (g.showAlternatingRows && row.visibleIndex % 2 != 0) {
                        if (!rng || (rng.row == rng.row2)) {
                            cl += ' wj-alt';
                        }
                    }
                    if (r < rows.frozen || c < cols.frozen) {
                        cl += ' wj-frozen';
                    }
                    if (nr) {
                        cl += ' wj-new';
                    }
                    if (row.cssClass) {
                        cl += ' ' + row.cssClass;
                    }
                    if (bcol.cssClass) {
                        cl += ' ' + bcol.cssClass;
                    }
                }
                else {
                    cl += ' wj-header';
                    if (g.showAlternatingRows && r % 2 != 0) {
                        cl += ' wj-header-alt';
                    }
                }
                // errors
                if (ct == grid.CellType.Cell || ct == grid.CellType.RowHeader) {
                    if (g._getShowErrors()) {
                        var error = g._getError(p, r, c);
                        wijmo.setAttribute(cell, 'title', error);
                        if (error) {
                            cl += ' wj-state-invalid';
                        }
                    }
                }
                // selected state
                var selState = p.getSelectedState(r, c, rng);
                if (selState != grid.SelectedState.None && // selected states don't apply to
                    ct == grid.CellType.Cell && !checkBox && // scrollable cells without checkboxes
                    g.editRange && g.editRange.contains(r, c)) {
                    selState = grid.SelectedState.None;
                }
                switch (selState) {
                    case grid.SelectedState.Cursor:
                        cl += ' wj-state-selected';
                        break;
                    case grid.SelectedState.Selected:
                        cl += ' wj-state-multi-selected';
                        break;
                }
                // frozen area boundary
                if (r2 == rows.frozen - 1) {
                    cl += ' wj-frozen-row';
                }
                if (c2 == cols.frozen - 1) {
                    cl += ' wj-frozen-col';
                }
                // word-wrapping
                if (bcol.wordWrap || row.wordWrap) {
                    cl += ' wj-wrap';
                }
                // alignment
                css.textAlign = bcol.getAlignment();
                // padding (TFS 229194)
                css.paddingLeft = css.paddingRight = css.paddingTop = css.paddingBottom = '';
                // group row indentation
                if (ct == grid.CellType.Cell) {
                    if (g.rows.maxGroupLevel > -1) {
                        if (c == g.columns.firstVisibleIndex && g.treeIndent) {
                            var level = gr ? Math.max(0, gr.level) : (g.rows.maxGroupLevel + 1), indent = g.treeIndent * level + g._cellPadding;
                            if (rtl) {
                                css.paddingRight = indent + 'px';
                            }
                            else {
                                css.paddingLeft = indent + 'px';
                            }
                        }
                    }
                }
                // cell content
                if (updateContent != false) {
                    var data = p.getCellData(r, c, false), content = p.getCellData(r, c, true);
                    if (ct == grid.CellType.Cell && c == g.columns.firstVisibleIndex &&
                        gr && gr.hasChildren && !this._isEditingCell(g, r, c)) {
                        // collapse/expand outline
                        if (!content) {
                            content = gr.getGroupHeader();
                        }
                        cell.innerHTML = this._getTreeIcon(gr) + ' ' + content;
                        css.textAlign = '';
                    }
                    else if (ct == grid.CellType.ColumnHeader && bcol.currentSort && g.showSort && (r2 == g._getSortRowIndex() || bcol != col)) {
                        // add sort class names to allow easier customization
                        cl += ' wj-sort-' + (bcol.currentSort == '+' ? 'asc' : 'desc');
                        // column header with sort sign
                        cell.innerHTML = wijmo.escapeHtml(content) + '&nbsp;' + this._getSortIcon(bcol);
                    }
                    else if (ct == grid.CellType.RowHeader && c == g.rowHeaders.columns.length - 1 && !content) {
                        // edit/new item template indicators
                        // (using glyphs for extra CSS control)
                        var ecv = g.editableCollectionView, editItem = ecv ? ecv.currentEditItem : null;
                        if (editItem && row.dataItem == editItem) {
                            cell.innerHTML = '<span class="wj-glyph-pencil"></span>'; // item being edited
                        }
                        else if (row instanceof grid._NewRowTemplate) {
                            cell.innerHTML = '<span class="wj-glyph-asterisk"></span>'; // new row template
                        }
                    }
                    else if (ct == grid.CellType.Cell &&
                        bcol.dataType == wijmo.DataType.Boolean && !bcol.dataMap &&
                        (!gr || wijmo.isBoolean(data))) {
                        // re-use/create checkbox
                        // (re-using allows selecting and checking/unchecking with a single click)
                        var chk = cell.firstChild;
                        if (!(chk instanceof HTMLInputElement) || chk.type != 'checkbox') {
                            cell.innerHTML = '<input type="checkbox" class="wj-cell-check" tabindex="-1"/>';
                            chk = cell.firstChild;
                        }
                        // initialize/update checkbox value
                        chk.checked = data == true ? true : false;
                        chk.indeterminate = data == null;
                        // disable checkbox if it is not editable (so user can't click it)
                        chk.disabled = !g.canEditCell(r, c);
                        if (chk.disabled) {
                            chk.style.cursor = 'default';
                        }
                        // assign editor to grid
                        if (g.editRange && g.editRange.contains(r, c)) {
                            g._edtHdl._edt = chk;
                        }
                    }
                    else if (ct == grid.CellType.Cell && this._isEditingCell(g, r, c)) {
                        // select input type (important for mobile devices)
                        var inpType = bcol.inputType;
                        if (!bcol.inputType) {
                            inpType = bcol.dataType == wijmo.DataType.Number && !bcol.dataMap ? 'tel' : 'text';
                        }
                        // get editor value (use full precision when editing floating point values)
                        // this is pretty tricky: TFS 123276, 134218, 135336, 250306
                        if (!bcol.dataMap && !bcol.mask) {
                            var val = p.getCellData(r, c, false);
                            if (wijmo.isNumber(val)) {
                                var str = val.toString(), fmt = bcol.format; // TFS 255421
                                if (fmt && val != Math.round(val)) {
                                    var dec = str.match(/\.(\d+)/)[1].length; // decimals in value
                                    fmt = fmt.replace(/([a-z])(\d*)(.*)/ig, '$01' + dec + '$3');
                                }
                                content = wijmo.Globalize.formatNumber(val, fmt, true);
                            }
                        }
                        // create/initialize editor
                        cell.innerHTML = '<input type="' + inpType + '" class="wj-grid-editor wj-form-control">';
                        var edt = cell.children[0];
                        edt.value = content;
                        edt.required = bcol.getIsRequired();
                        if (bcol.maxLength) {
                            edt.maxLength = bcol.maxLength;
                        }
                        edt.style.textAlign = bcol.getAlignment(); // right-align numbers when editing
                        css.paddingTop = css.paddingBottom = '0px'; // no padding on cell div (the editor has it)
                        // apply mask, if any
                        if (bcol.mask) {
                            new wijmo._MaskProvider(edt, bcol.mask);
                        }
                        // assign editor to grid
                        g._edtHdl._edt = edt;
                    }
                    else {
                        // regular content
                        if (ct == grid.CellType.Cell && (row.isContentHtml || bcol.isContentHtml)) {
                            cell.innerHTML = content;
                        }
                        else {
                            cell.textContent = content || '';
                        }
                    }
                    // add drop-down element to the cell if the column:
                    // a) has a dataMap,
                    // b) has showDropDown set to not false (null or true)
                    // c) is editable
                    if (ct == grid.CellType.Cell && wijmo.input && bcol.dataMap && g.showDropDown &&
                        bcol.showDropDown != false && g.canEditCell(r, c)) {
                        // create icon once
                        if (!CellFactory._ddIcon) {
                            CellFactory._ddIcon = wijmo.createElement('<div role="button" class="' + CellFactory._WJC_DROPDOWN + '">' +
                                '<span class="wj-glyph-down"></span>' +
                                '</div>');
                        }
                        // clone icon and add clone to cell
                        var dd = CellFactory._ddIcon.cloneNode(true);
                        cell.appendChild(dd);
                    }
                }
                // make row/col headers draggable
                var draggable = false;
                switch (ct) {
                    case grid.CellType.RowHeader:
                        draggable = !gr && !nr && row.allowDragging && (g.allowDragging & grid.AllowDragging.Rows) != 0;
                        wijmo.setAttribute(cell, 'draggable', draggable ? 'true' : null);
                        break;
                    case grid.CellType.ColumnHeader:
                        draggable = col.allowDragging && (g.allowDragging & grid.AllowDragging.Columns) != 0;
                        wijmo.setAttribute(cell, 'draggable', draggable ? 'true' : null);
                        break;
                }
                // apply class list to cell
                if (cell.className != cl) {
                    cell.className = cl;
                }
                // apply style to cell
                // setCss(cell, css); // ** inlining for performance **
                var style = cell.style;
                for (var k in css) {
                    style[k] = css[k];
                }
                // clip editor to client area (TFS 279553, 245830)
                if (g._edtHdl._edt && g._edtHdl._edt.parentElement == cell) {
                    var root = g._root, rcRoot = root.getBoundingClientRect(), rcCell = cell.getBoundingClientRect(), maxHei = rcRoot.top + root.clientHeight - rcCell.top, maxWid = rcRoot.left + root.clientWidth - rcCell.left;
                    if (rcCell.height > maxHei) {
                        cell.style.height = maxHei + 'px';
                    }
                    if (rcCell.width > maxWid) {
                        cell.style.width = maxWid + 'px';
                    }
                }
                // customize the cell
                if (g.itemFormatter) {
                    g.itemFormatter(p, r, c, cell);
                }
                if (g.formatItem.hasHandlers) {
                    var rng_1 = CellFactory._fmtRng;
                    if (!rng_1) {
                        rng_1 = CellFactory._fmtRng = new grid.CellRange(r, c, r2, c2);
                    }
                    else {
                        rng_1.setRange(r, c, r2, c2);
                    }
                    var e = new grid.FormatItemEventArgs(p, rng_1, cell);
                    g.onFormatItem(e);
                }
            };
            /**
             * Disposes of a cell element and releases all resources associated with it.
             *
             * @param cell The element that represents the cell.
             */
            CellFactory.prototype.disposeCell = function (cell) {
                // no action needed for standard cells...
            };
            /**
             * Gets the value of the editor currently being used.
             *
             * @param g @see:FlexGrid that owns the editor.
             */
            CellFactory.prototype.getEditorValue = function (g) {
                var edt = g._edtHdl._edt;
                if (edt instanceof HTMLInputElement) {
                    if (edt.type == 'checkbox') {
                        return edt.checked;
                    }
                    var maxLen = edt.maxLength; // needed when editing IME: TFS 291896
                    if (wijmo.isNumber(maxLen) && maxLen > -1 && edt.value.length > maxLen) {
                        return edt.value.substr(0, maxLen);
                    }
                    return edt.value;
                }
                return null;
            };
            // ** implementation
            // determines whether the grid is currently editing a cell
            CellFactory.prototype._isEditingCell = function (g, r, c) {
                return g.editRange && g.editRange.contains(r, c);
            };
            // get an element to create a collapse/expand icon
            // NOTE: the _WJC_COLLAPSE class is used by the mouse handler to identify
            // the collapse/expand button/element.
            CellFactory.prototype._getTreeIcon = function (gr) {
                var glyph = 'wj-glyph-' +
                    (gr.isCollapsed ? '' : 'down-') +
                    (gr.grid.rightToLeft ? 'left' : 'right');
                return '<span role="button" class="' + CellFactory._WJC_COLLAPSE + ' ' + glyph + '"></span>';
            };
            // get an element to create a sort up/down icon
            CellFactory.prototype._getSortIcon = function (col) {
                return '<span class="wj-glyph-' + (col.currentSort == '+' ? 'up' : 'down') + '"></span>';
            };
            CellFactory._WJC_COLLAPSE = 'wj-elem-collapse';
            CellFactory._WJC_DROPDOWN = 'wj-elem-dropdown';
            return CellFactory;
        }());
        grid.CellFactory = CellFactory;
    })(grid = wijmo.grid || (wijmo.grid = {}));
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    var grid;
    (function (grid) {
        'use strict';
        /**
         * Represents a rectangular group of cells defined by two row indices and
         * two column indices.
         */
        var CellRange = /** @class */ (function () {
            /**
             * Initializes a new instance of the @see:CellRange class.
             *
             * @param r The index of the first row in the range (defaults to -1).
             * @param c The index of the first column in the range (defaults to -1).
             * @param r2 The index of the last row in the range (defaults to <b>r</b>).
             * @param c2 The index of the last column in the range (defaults to <b>c</b>).
             */
            function CellRange(r, c, r2, c2) {
                if (r === void 0) { r = -1; }
                if (c === void 0) { c = -1; }
                if (r2 === void 0) { r2 = r; }
                if (c2 === void 0) { c2 = c; }
                this.setRange(r, c, r2, c2);
            }
            /**
             * Initializes an existing @see:CellRange.
             *
             * @param r The index of the first row in the range (defaults to -1).
             * @param c The index of the first column in the range (defaults to -1).
             * @param r2 The index of the last row in the range (defaults to <b>r</b>).
             * @param c2 The index of the last column in the range (defaults to <b>c</b>).
             */
            CellRange.prototype.setRange = function (r, c, r2, c2) {
                if (r === void 0) { r = -1; }
                if (c === void 0) { c = -1; }
                if (r2 === void 0) { r2 = r; }
                if (c2 === void 0) { c2 = c; }
                this._row = wijmo.asInt(r);
                this._col = wijmo.asInt(c);
                this._row2 = wijmo.asInt(r2);
                this._col2 = wijmo.asInt(c2);
            };
            Object.defineProperty(CellRange.prototype, "row", {
                /**
                 * Gets or sets the index of the first row in the range.
                 */
                get: function () {
                    return this._row;
                },
                set: function (value) {
                    this._row = wijmo.asInt(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CellRange.prototype, "col", {
                /**
                 * Gets or sets the index of the first column in the range.
                 */
                get: function () {
                    return this._col;
                },
                set: function (value) {
                    this._col = wijmo.asInt(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CellRange.prototype, "row2", {
                /**
                 * Gets or sets the index of the second row in the range.
                 */
                get: function () {
                    return this._row2;
                },
                set: function (value) {
                    this._row2 = wijmo.asInt(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CellRange.prototype, "col2", {
                /**
                 * Gets or sets the index of the second column in the range.
                 */
                get: function () {
                    return this._col2;
                },
                set: function (value) {
                    this._col2 = wijmo.asInt(value);
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Creates a copy of the range.
             */
            CellRange.prototype.clone = function () {
                return new CellRange(this._row, this._col, this._row2, this._col2);
            };
            Object.defineProperty(CellRange.prototype, "rowSpan", {
                /**
                 * Gets the number of rows in the range.
                 */
                get: function () {
                    return Math.abs(this._row2 - this._row) + 1;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CellRange.prototype, "columnSpan", {
                /**
                 * Gets the number of columns in the range.
                 */
                get: function () {
                    return Math.abs(this._col2 - this._col) + 1;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CellRange.prototype, "topRow", {
                /**
                 * Gets the index of the top row in the range.
                 */
                get: function () {
                    return Math.min(this._row, this._row2);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CellRange.prototype, "bottomRow", {
                /**
                 * Gets the index of the bottom row in the range.
                 */
                get: function () {
                    return Math.max(this._row, this._row2);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CellRange.prototype, "leftCol", {
                /**
                 * Gets the index of the leftmost column in the range.
                 */
                get: function () {
                    return Math.min(this._col, this._col2);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CellRange.prototype, "rightCol", {
                /**
                 * Gets the index of the rightmost column in the range.
                 */
                get: function () {
                    return Math.max(this._col, this._col2);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CellRange.prototype, "isValid", {
                /**
                 * Checks whether the range contains valid row and column indices
                 * (row and column values are zero or greater).
                 */
                get: function () {
                    return this._row > -1 && this._col > -1 && this._row2 > -1 && this._col2 > -1;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(CellRange.prototype, "isSingleCell", {
                /**
                 * Checks whether this range corresponds to a single cell (beginning and ending rows have
                 * the same index, and beginning and ending columns have the same index).
                 */
                get: function () {
                    return this._row == this._row2 && this._col == this._col2;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Checks whether the range contains another range or a specific cell.
             *
             * @param r The CellRange object or row index to find.
             * @param c The column index (required if the r parameter is not a CellRange object).
             */
            CellRange.prototype.contains = function (r, c) {
                // first parameter may be a cell range
                var rng = wijmo.tryCast(r, CellRange);
                if (rng) {
                    return rng.topRow >= this.topRow && rng.bottomRow <= this.bottomRow &&
                        rng.leftCol >= this.leftCol && rng.rightCol <= this.rightCol;
                }
                // check specific cell
                if (wijmo.isInt(r) && wijmo.isInt(c)) {
                    return r >= this.topRow && r <= this.bottomRow &&
                        c >= this.leftCol && c <= this.rightCol;
                }
                // anything else is an error
                throw 'contains expects a CellRange or row/column indices.';
            };
            /**
             * Checks whether the range contains a given row.
             *
             * @param r The index of the row to find.
             */
            CellRange.prototype.containsRow = function (r) {
                return wijmo.asInt(r) >= this.topRow && r <= this.bottomRow;
            };
            /**
             * Checks whether the range contains a given column.
             *
             * @param c The index of the column to find.
             */
            CellRange.prototype.containsColumn = function (c) {
                return wijmo.asInt(c) >= this.leftCol && c <= this.rightCol;
            };
            /**
             * Checks whether the range intersects another range.
             *
             * @param rng The CellRange object to check.
             */
            CellRange.prototype.intersects = function (rng) {
                return this.intersectsRow(rng) && this.intersectsColumn(rng);
            };
            /**
             * Checks whether the range intersects the rows in another range.
             *
             * @param rng The CellRange object to check.
             */
            CellRange.prototype.intersectsRow = function (rng) {
                return rng && !(this.bottomRow < rng.topRow || this.topRow > rng.bottomRow);
            };
            /**
             * Checks whether the range intersects the columns in another range.
             *
             * @param rng The CellRange object to check.
             */
            CellRange.prototype.intersectsColumn = function (rng) {
                return rng && !(this.rightCol < rng.leftCol || this.leftCol > rng.rightCol);
            };
            /**
             * Gets the rendered size of this range.
             *
             * @param p The @see:GridPanel object that contains the range.
             * @return A @see:Size object that represents the sum of row heights and column widths in the range.
             */
            CellRange.prototype.getRenderSize = function (p) {
                var sz = new wijmo.Size(0, 0);
                if (this.isValid) {
                    for (var r = this.topRow; r <= this.bottomRow; r++) {
                        sz.height += p.rows[r].renderSize;
                    }
                    for (var c = this.leftCol; c <= this.rightCol; c++) {
                        sz.width += p.columns[c].renderSize;
                    }
                }
                return sz;
            };
            /**
             * Checks whether the range equals another range.
             *
             * @param rng The CellRange object to compare to this range.
             */
            CellRange.prototype.equals = function (rng) {
                return (rng instanceof CellRange) &&
                    this._row == rng._row && this._col == rng._col &&
                    this._row2 == rng._row2 && this._col2 == rng._col2;
            };
            return CellRange;
        }());
        grid.CellRange = CellRange;
    })(grid = wijmo.grid || (wijmo.grid = {}));
})(wijmo || (wijmo = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var wijmo;
(function (wijmo) {
    var grid;
    (function (grid_1) {
        'use strict';
        /**
         * Specifies flags that represent the state of a grid row or column.
         */
        var RowColFlags;
        (function (RowColFlags) {
            /** The row or column is visible. */
            RowColFlags[RowColFlags["Visible"] = 1] = "Visible";
            /** The row or column can be resized. */
            RowColFlags[RowColFlags["AllowResizing"] = 2] = "AllowResizing";
            /** The row or column can be dragged to a new position with the mouse. */
            RowColFlags[RowColFlags["AllowDragging"] = 4] = "AllowDragging";
            /** The row or column can contain merged cells. */
            RowColFlags[RowColFlags["AllowMerging"] = 8] = "AllowMerging";
            /** The column can be sorted by clicking its header with the mouse. */
            RowColFlags[RowColFlags["AllowSorting"] = 16] = "AllowSorting";
            /** The column was generated automatically. */
            RowColFlags[RowColFlags["AutoGenerated"] = 32] = "AutoGenerated";
            /** The group row is collapsed. */
            RowColFlags[RowColFlags["Collapsed"] = 64] = "Collapsed";
            /** The row has a parent group that is collapsed. */
            RowColFlags[RowColFlags["ParentCollapsed"] = 128] = "ParentCollapsed";
            /** The row or column is selected. */
            RowColFlags[RowColFlags["Selected"] = 256] = "Selected";
            /** The row or column is read-only (cannot be edited). */
            RowColFlags[RowColFlags["ReadOnly"] = 512] = "ReadOnly";
            /** Cells in this row or column contain HTML text. */
            RowColFlags[RowColFlags["HtmlContent"] = 1024] = "HtmlContent";
            /** Cells in this row or column may contain wrapped text. */
            RowColFlags[RowColFlags["WordWrap"] = 2048] = "WordWrap";
            /** Cells in this column have templates. */
            RowColFlags[RowColFlags["HasTemplate"] = 4096] = "HasTemplate";
            /** Default settings for new rows. */
            RowColFlags[RowColFlags["RowDefault"] = 3] = "RowDefault";
            /** Default settings for new columns. */
            RowColFlags[RowColFlags["ColumnDefault"] = 23] = "ColumnDefault";
        })(RowColFlags = grid_1.RowColFlags || (grid_1.RowColFlags = {}));
        /**
         * An abstract class that serves as a base for the @see:Row and @see:Column classes.
         */
        var RowCol = /** @class */ (function () {
            function RowCol() {
                this._list = null;
                this._pos = 0;
                this._idx = -1;
                this._vidx = -1;
            }
            Object.defineProperty(RowCol.prototype, "visible", {
                /**
                 * Gets or sets a value that indicates whether the row or column is visible.
                 */
                get: function () {
                    return this._getFlag(RowColFlags.Visible);
                },
                set: function (value) {
                    this._setFlag(RowColFlags.Visible, value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowCol.prototype, "isVisible", {
                /**
                 * Gets a value that indicates whether the row or column is visible and not collapsed.
                 *
                 * This property is read-only. To change the visibility of a
                 * row or column, use the @see:visible property instead.
                 */
                get: function () {
                    // if visible is false, we're not visible
                    if (!this._getFlag(RowColFlags.Visible)) {
                        return false;
                    }
                    // if the parent node is collapsed and this is not a new row, we're not visible
                    if (this._getFlag(RowColFlags.ParentCollapsed) && !(this instanceof grid_1._NewRowTemplate)) {
                        return false;
                    }
                    // looks like we're visible
                    return true;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowCol.prototype, "pos", {
                /**
                 * Gets the position of the row or column.
                 */
                get: function () {
                    if (this._list && this._list._dirty) {
                        this._list._update();
                    }
                    return this._pos;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowCol.prototype, "index", {
                /**
                 * Gets the index of the row or column in the parent collection.
                 */
                get: function () {
                    if (this._list && this._list._dirty) {
                        this._list._update();
                    }
                    return this._idx;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowCol.prototype, "visibleIndex", {
                /**
                 * Gets the index of the row or column in the parent collection
                 * ignoring invisible elements (@see:isVisible).
                 */
                get: function () {
                    if (this._list && this._list._dirty) {
                        this._list._update();
                    }
                    return this.isVisible ? this._vidx : -1;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowCol.prototype, "size", {
                /**
                 * Gets or sets the size of the row or column.
                 * Setting this property to null or negative values causes the element to use the
                 * parent collection's default size.
                 */
                get: function () {
                    return this._sz;
                },
                set: function (value) {
                    if (value != this._sz) {
                        this._sz = wijmo.asNumber(value, true);
                        this.onPropertyChanged();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowCol.prototype, "renderSize", {
                /**
                 * Gets the render size of the row or column.
                 * This property accounts for visibility, default size, and min and max sizes.
                 */
                get: function () {
                    if (!this.isVisible) {
                        return 0;
                    }
                    var sz = this._sz, list = this._list;
                    // list default/min/max (TFS 242535)
                    if (list) {
                        if (sz == null || sz < 0) {
                            sz = Math.round((list).defaultSize);
                        }
                        if (list.minSize != null && sz < list.minSize) {
                            sz = list.minSize;
                        }
                        if (list.maxSize != null && sz > list.maxSize) {
                            sz = list.maxSize;
                        }
                    }
                    // this min/max
                    if (this._szMin != null && sz < this._szMin) {
                        sz = this._szMin;
                    }
                    if (this._szMax != null && sz > this._szMax) {
                        sz = this._szMax;
                    }
                    // done
                    return Math.round(sz);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowCol.prototype, "allowResizing", {
                /**
                 * Gets or sets a value that indicates whether the user can resize the row or column with the mouse.
                 */
                get: function () {
                    return this._getFlag(RowColFlags.AllowResizing);
                },
                set: function (value) {
                    this._setFlag(RowColFlags.AllowResizing, value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowCol.prototype, "allowDragging", {
                /**
                 * Gets or sets a value that indicates whether the user can move the row or column to a new position with the mouse.
                 */
                get: function () {
                    return this._getFlag(RowColFlags.AllowDragging);
                },
                set: function (value) {
                    this._setFlag(RowColFlags.AllowDragging, value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowCol.prototype, "allowMerging", {
                /**
                 * Gets or sets a value that indicates whether cells in the row or column can be merged.
                 */
                get: function () {
                    return this._getFlag(RowColFlags.AllowMerging);
                },
                set: function (value) {
                    this._setFlag(RowColFlags.AllowMerging, value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowCol.prototype, "isSelected", {
                /**
                 * Gets or sets a value that indicates whether the row or column is selected.
                 */
                get: function () {
                    return this._getFlag(RowColFlags.Selected);
                },
                set: function (value) {
                    //this._setFlag(RowColFlags.Selected, value);
                    // set flag quietly, then update selection (faster than full invalidation)
                    if (this._setFlag(RowColFlags.Selected, value, true)) {
                        var g = this.grid;
                        if (g) {
                            g.refreshCells(false, true, true);
                        }
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowCol.prototype, "isReadOnly", {
                /**
                 * Gets or sets a value that indicates whether cells in the row or column can be edited.
                 */
                get: function () {
                    return this._getFlag(RowColFlags.ReadOnly);
                },
                set: function (value) {
                    this._setFlag(RowColFlags.ReadOnly, value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowCol.prototype, "isContentHtml", {
                /**
                 * Gets or sets a value that indicates whether cells in this row or column
                 * contain HTML content rather than plain text.
                 */
                get: function () {
                    return this._getFlag(RowColFlags.HtmlContent);
                },
                set: function (value) {
                    if (this.isContentHtml != value) {
                        this._setFlag(RowColFlags.HtmlContent, value);
                        if (this.grid) {
                            this.grid.invalidate();
                        }
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowCol.prototype, "wordWrap", {
                /**
                 * Gets or sets a value that indicates whether cells in the row or column wrap their content.
                 */
                get: function () {
                    return this._getFlag(RowColFlags.WordWrap);
                },
                set: function (value) {
                    this._setFlag(RowColFlags.WordWrap, value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowCol.prototype, "cssClass", {
                /**
                 * Gets or sets a CSS class name to use when rendering
                 * non-header cells in the row or column.
                 */
                get: function () {
                    return this._cssClass;
                },
                set: function (value) {
                    if (value != this._cssClass) {
                        this._cssClass = wijmo.asString(value);
                        if (this.grid) {
                            this.grid.invalidate();
                        }
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowCol.prototype, "grid", {
                /**
                 * Gets the @see:FlexGrid that owns the row or column.
                 */
                get: function () {
                    return this._list ? this._list._g : null;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowCol.prototype, "collectionView", {
                /**
                 * Gets the @see:ICollectionView bound to this row or column.
                 */
                get: function () {
                    return this.grid ? this.grid.collectionView : null;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Marks the owner list as dirty and refreshes the owner grid.
             */
            RowCol.prototype.onPropertyChanged = function () {
                if (this._list) {
                    this._list._dirty = true;
                    this.grid.invalidate();
                }
            };
            // Gets the value of a flag.
            RowCol.prototype._getFlag = function (flag) {
                return (this._f & flag) != 0;
            };
            // Sets the value of a flag, with optional notification.
            RowCol.prototype._setFlag = function (flag, value, quiet) {
                if (value != this._getFlag(flag)) {
                    this._f = value ? (this._f | flag) : (this._f & ~flag);
                    if (!quiet) {
                        this.onPropertyChanged();
                    }
                    return true;
                }
                return false;
            };
            return RowCol;
        }());
        grid_1.RowCol = RowCol;
        /**
         * Represents a column on the grid.
         */
        var Column = /** @class */ (function (_super) {
            __extends(Column, _super);
            /**
             * Initializes a new instance of the @see:Column class.
             *
             * @param options Initialization options for the column.
             */
            function Column(options) {
                var _this = _super.call(this) || this;
                _this._f = RowColFlags.ColumnDefault;
                _this._hash = Column._ctr.toString(36); // unique column key (used for unbound rows)
                Column._ctr++;
                if (options) {
                    wijmo.copy(_this, options);
                }
                return _this;
            }
            Object.defineProperty(Column.prototype, "name", {
                /**
                 * Gets or sets the name of the column.
                 *
                 * The column name can be used to retrieve the column using the
                 * @see:FlexGrid.getColumn method.
                 */
                get: function () {
                    return this._name;
                },
                set: function (value) {
                    this._name = value;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "dataType", {
                /**
                 * Gets or sets the type of value stored in the column.
                 *
                 * Values are coerced into the proper type when editing the grid.
                 */
                get: function () {
                    return this._type;
                },
                set: function (value) {
                    if (this._type != value) {
                        this._type = wijmo.asEnum(value, wijmo.DataType);
                        if (this.grid) {
                            this.grid.invalidate();
                        }
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "isRequired", {
                /**
                 * Gets or sets a value that determines whether values in the column
                 * are required.
                 *
                 * By default, this property is set to null, which means values
                 * are required, but non-masked string columns may contain empty
                 * strings.
                 *
                 * When set to true, values are required and empty strings are
                 * not allowed.
                 *
                 * When set to false, null values and empty strings are allowed.
                 */
                get: function () {
                    return this._required;
                },
                set: function (value) {
                    this._required = wijmo.asBoolean(value, true);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "showDropDown", {
                /**
                 * Gets or sets a value that indicates whether the grid adds drop-down
                 * buttons to the cells in this column.
                 *
                 * The drop-down buttons are shown only if the column has a @see:dataMap
                 * set and is editable. Clicking on the drop-down buttons causes the grid
                 * to show a list where users can select the value for the cell.
                 *
                 * Cell drop-downs require the wijmo.input module to be loaded.
                 */
                get: function () {
                    return this._showDropDown;
                },
                set: function (value) {
                    if (value != this._showDropDown) {
                        this._showDropDown = wijmo.asBoolean(value, true);
                        if (this.grid) {
                            this.grid.invalidate();
                        }
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "dropDownCssClass", {
                /**
                 * Gets or sets a CSS class name to add to drop-downs in this column.
                 *
                 * The drop-down buttons are shown only if the column has a @see:dataMap
                 * set and is editable. Clicking on the drop-down buttons causes the grid
                 * to show a list where users can select the value for the cell.
                 *
                 * Cell drop-downs require the wijmo.input module to be loaded.
                 */
                get: function () {
                    return this._ddCssClass;
                },
                set: function (value) {
                    this._ddCssClass = wijmo.asString(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "inputType", {
                /**
                 * Gets or sets the "type" attribute of the HTML input element used to edit values
                 * in this column.
                 *
                 * By default, this property is set to "tel" for numeric columns, and to "text" for
                 * all other non-boolean column types. The "tel" input type causes mobile devices
                 * to show a numeric keyboard that includes a negative sign and a decimal separator.
                 *
                 * Use this property to change the default setting if the default does not work well
                 * for the current culture, device, or application. In these cases, try setting the
                 * property to "number" or simply "text."
                 */
                get: function () {
                    return this._inpType;
                },
                set: function (value) {
                    this._inpType = wijmo.asString(value, true);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "mask", {
                /**
                 * Gets or sets a mask to use while editing values in this column.
                 *
                 * The mask format is the same used by the @see:wijmo.input.InputMask
                 * control.
                 *
                 * If specified, the mask must be compatible with the value of
                 * the @see:format property. For example, the mask '99/99/9999' can
                 * be used for entering dates formatted as 'MM/dd/yyyy'.
                 */
                get: function () {
                    return this._mask;
                },
                set: function (value) {
                    this._mask = wijmo.asString(value, true);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "maxLength", {
                /**
                 * Gets or sets the maximum number of characters that the can
                 * be entered into the cell.
                 *
                 * Set this property to null to allow entry of any number of
                 * characters.
                 */
                get: function () {
                    return this._maxLen;
                },
                set: function (value) {
                    this._maxLen = wijmo.asNumber(value, true, true);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "binding", {
                /**
                 * Gets or sets the name of the property the column is bound to.
                 */
                get: function () {
                    return this._binding ? this._binding.path : null;
                },
                set: function (value) {
                    if (value != this.binding) {
                        var path = wijmo.asString(value);
                        this._binding = path ? new wijmo.Binding(path) : null;
                        if (!this._type && this.grid && this._binding) {
                            var view = this.grid.collectionView;
                            if (view && view.sourceCollection && view.sourceCollection.length) {
                                var item = view.sourceCollection[0];
                                this._type = wijmo.getType(this._binding.getValue(item));
                            }
                        }
                        this.onPropertyChanged();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "sortMemberPath", {
                /**
                 * Gets or sets the name of the property to use when sorting this column.
                 *
                 * Use this property in cases where you want the sorting to be performed
                 * based on values other than the ones specified by the @see:binding property.
                 *
                 * Setting this property is null causes the grid to use the value of the
                 * @see:binding property to sort the column.
                 */
                get: function () {
                    return this._bindingSort ? this._bindingSort.path : null;
                },
                set: function (value) {
                    if (value != this.sortMemberPath) {
                        var path = wijmo.asString(value);
                        this._bindingSort = path ? new wijmo.Binding(path) : null;
                        this.onPropertyChanged();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "width", {
                /**
                 * Gets or sets the width of the column.
                 *
                 * Column widths may be positive numbers (sets the column width in pixels),
                 * null or negative numbers (uses the collection's default column width), or
                 * strings in the format '{number}*' (star sizing).
                 *
                 * The star-sizing option performs a XAML-style dynamic sizing where column
                 * widths are proportional to the number before the star. For example, if
                 * a grid has three columns with widths "100", "*", and "3*", the first column
                 * will be 100 pixels wide, the second will take up 1/4th of the remaining
                 * space, and the last will take up the remaining 3/4ths of the remaining space.
                 *
                 * Star-sizing allows you to define columns that automatically stretch to fill
                 * the width available. For example, set the width of the last column to "*"
                 * and it will automatically extend to fill the entire grid width so there's
                 * no empty space. You may also want to set the column's @see:minWidth property
                 * to prevent the column from getting too narrow.
                 */
                get: function () {
                    if (this._szStar != null) {
                        return this._szStar;
                    }
                    else {
                        return this.size;
                    }
                },
                set: function (value) {
                    if (Column._parseStarSize(value) != null) {
                        this._szStar = value;
                        this.onPropertyChanged();
                    }
                    else {
                        this._szStar = null;
                        this.size = wijmo.asNumber(value, true);
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "minWidth", {
                /**
                 * Gets or sets the minimum width of the column.
                 */
                get: function () {
                    return this._szMin;
                },
                set: function (value) {
                    if (value != this._szMin) {
                        this._szMin = wijmo.asNumber(value, true, true);
                        this.onPropertyChanged();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "maxWidth", {
                /**
                 * Gets or sets the maximum width of the column.
                 */
                get: function () {
                    return this._szMax;
                },
                set: function (value) {
                    if (value != this._szMax) {
                        this._szMax = wijmo.asNumber(value, true, true);
                        this.onPropertyChanged();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "quickAutoSize", {
                /**
                 * Gets or sets a value that determines whether the grid should optimize
                 * performance over precision when auto-sizing this column.
                 *
                 * Setting this property to false disables quick auto-sizing for this column.
                 * Setting it to true enables the feature, subject to the value of the grid's
                 * @see:wijmo.grid.FlexGrid.quickAutoSize property.
                 * Setting it to null (the default value) enables the feature for columns
                 * that display plain text and don't have templates.
                 */
                get: function () {
                    return this._quickSize;
                },
                set: function (value) {
                    this._quickSize = wijmo.asBoolean(value, true);
                },
                enumerable: true,
                configurable: true
            });
            Column.prototype._getQuickAutoSize = function () {
                if (!this.grid._getQuickAutoSize()) {
                    return false;
                }
                return wijmo.isBoolean(this._quickSize)
                    ? this._quickSize
                    : !this.isContentHtml && !this._getFlag(RowColFlags.HasTemplate);
            };
            Object.defineProperty(Column.prototype, "renderWidth", {
                /**
                 * Gets the render width of the column.
                 *
                 * The value returned takes into account the column's visibility, default size, and min and max sizes.
                 */
                get: function () {
                    return this.renderSize;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "align", {
                /**
                 * Gets or sets the horizontal alignment of items in the column.
                 *
                 * The default value for this property is null, which causes the grid to select
                 * the alignment automatically based on the column's @see:dataType (numbers are
                 * right-aligned, Boolean values are centered, and other types are left-aligned).
                 *
                 * If you want to override the default alignment, set this property
                 * to 'left', 'right', or 'center'.
                 */
                get: function () {
                    return this._align;
                },
                set: function (value) {
                    if (this._align != value) {
                        this._align = value;
                        this.onPropertyChanged();
                    }
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Gets the actual column alignment.
             *
             * Returns the value of the @see:align property if it is not null, or
             * selects the alignment based on the column's @see:dataType.
             */
            Column.prototype.getAlignment = function () {
                var value = this._align;
                if (value == null) {
                    value = '';
                    if (!this._map) {
                        switch (this._type) {
                            case wijmo.DataType.Boolean:
                                value = 'center';
                                break;
                            case wijmo.DataType.Number:
                                value = 'right';
                                break;
                        }
                    }
                }
                return value;
            };
            /**
             * Gets a value that determines whether the column is required.
             *
             * Returns the value of the @see:isRequired property if it is not null, or
             * determines the required status based on the column's @see:dataType.
             *
             * By default, string columns are not required unless they have an associated
             * @see:dataMap or @see:mask; all other data types are required.
             */
            Column.prototype.getIsRequired = function () {
                if (this._required != null) {
                    return this._required;
                }
                if (this.dataType == wijmo.DataType.String) {
                    return (this.dataMap != null) || (this._mask && this._mask.length > 0);
                }
                return true;
            };
            Object.defineProperty(Column.prototype, "header", {
                /**
                 * Gets or sets the text displayed in the column header.
                 */
                get: function () {
                    return this._hdr ? this._hdr : this.binding;
                },
                set: function (value) {
                    if (this._hdr != value) {
                        this._hdr = value;
                        this.onPropertyChanged();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "dataMap", {
                /**
                 * Gets or sets the @see:DataMap used to convert raw values into display
                 * values for the column.
                 *
                 * Columns with an associated @see:dataMap show drop-down buttons that
                 * can be used for quick editing. If you do not want to show the drop-down
                 * buttons, set the column's @see:showDropDown property to false.
                 *
                 * Cell drop-downs require the wijmo.input module to be loaded.
                 */
                get: function () {
                    return this._map;
                },
                set: function (value) {
                    if (this._map != value) {
                        // disconnect old map
                        if (this._map) {
                            this._map.mapChanged.removeHandler(this.onPropertyChanged, this);
                        }
                        // convert arrays into DataMaps
                        if (wijmo.isArray(value)) {
                            value = new grid_1.DataMap(value, null, null);
                        }
                        // set new map
                        this._map = wijmo.asType(value, grid_1.DataMap, true);
                        // connect new map
                        if (this._map) {
                            this._map.mapChanged.addHandler(this.onPropertyChanged, this);
                        }
                        this.onPropertyChanged();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "format", {
                /**
                 * Gets or sets the format string used to convert raw values into display
                 * values for the column (see @see:Globalize).
                 */
                get: function () {
                    return this._fmt;
                },
                set: function (value) {
                    if (this._fmt != value) {
                        this._fmt = value;
                        this.onPropertyChanged();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "allowSorting", {
                /**
                 * Gets or sets a value that indicates whether the user can sort the column by clicking its header.
                 */
                get: function () {
                    return this._getFlag(RowColFlags.AllowSorting);
                },
                set: function (value) {
                    this._setFlag(RowColFlags.AllowSorting, value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "currentSort", {
                /**
                 * Gets a string that describes the current sorting applied to the column.
                 * Possible values are '+' for ascending order, '-' for descending order, or
                 * null for unsorted columns.
                 */
                get: function () {
                    if (this.grid && this.grid.collectionView && this.grid.collectionView.canSort) {
                        var sds = this.grid.collectionView.sortDescriptions;
                        for (var i = 0; i < sds.length; i++) {
                            if (sds[i].property == this._getBindingSort()) {
                                return sds[i].ascending ? '+' : '-';
                            }
                        }
                    }
                    return null;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Column.prototype, "aggregate", {
                /**
                 * Gets or sets the @see:Aggregate to display in the group header rows
                 * for the column.
                 */
                get: function () {
                    return this._agg != null ? this._agg : wijmo.Aggregate.None;
                },
                set: function (value) {
                    if (value != this._agg) {
                        this._agg = wijmo.asEnum(value, wijmo.Aggregate);
                        this.onPropertyChanged();
                    }
                },
                enumerable: true,
                configurable: true
            });
            // gets the binding used for sorting (sortMemberPath if specified, binding ow)
            /*protected*/ Column.prototype._getBindingSort = function () {
                return this.sortMemberPath ? this.sortMemberPath :
                    this.binding ? this.binding :
                        null;
            };
            // parses a string in the format '<number>*' and returns the number (or null if the parsing fails).
            Column._parseStarSize = function (value) {
                if (wijmo.isString(value) && value.length > 0 && value[value.length - 1] == '*') {
                    var sz = value.length == 1 ? 1 : value.substr(0, value.length - 1) * 1;
                    if (sz > 0 && !isNaN(sz)) {
                        return sz;
                    }
                }
                return null;
            };
            Column._ctr = 0;
            return Column;
        }(RowCol));
        grid_1.Column = Column;
        /**
         * Represents a row in the grid.
         */
        var Row = /** @class */ (function (_super) {
            __extends(Row, _super);
            /**
             * Initializes a new instance of the @see:Row class.
             *
             * @param dataItem The data item that this row is bound to.
             */
            function Row(dataItem) {
                var _this = _super.call(this) || this;
                _this._f = RowColFlags.ColumnDefault;
                _this._data = dataItem;
                return _this;
            }
            Object.defineProperty(Row.prototype, "dataItem", {
                /**
                 * Gets or sets the item in the data collection that the item is bound to.
                 */
                get: function () {
                    return this._data;
                },
                set: function (value) {
                    this._data = value;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Row.prototype, "height", {
                /**
                 * Gets or sets the height of the row.
                 * Setting this property to null or negative values causes the element to use the
                 * parent collection's default size.
                 */
                get: function () {
                    return this.size;
                },
                set: function (value) {
                    this.size = value;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Row.prototype, "renderHeight", {
                /**
                 * Gets the render height of the row.
                 *
                 * The value returned takes into account the row's visibility, default size, and min and max sizes.
                 */
                get: function () {
                    return this.renderSize;
                },
                enumerable: true,
                configurable: true
            });
            return Row;
        }(RowCol));
        grid_1.Row = Row;
        /**
         * Represents a row that serves as a header for a group of rows.
         */
        var GroupRow = /** @class */ (function (_super) {
            __extends(GroupRow, _super);
            /**
             * Initializes a new instance of the @see:GroupRow class.
             */
            function GroupRow() {
                var _this = _super.call(this) || this;
                _this._level = -1;
                _this.isReadOnly = true; // group rows are read-only by default
                return _this;
            }
            Object.defineProperty(GroupRow.prototype, "level", {
                /**
                 * Gets or sets the hierarchical level of the group associated with the GroupRow.
                 */
                get: function () {
                    return this._level;
                },
                set: function (value) {
                    wijmo.asInt(value);
                    if (value != this._level) {
                        this._level = value;
                        this.onPropertyChanged();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(GroupRow.prototype, "hasChildren", {
                /**
                 * Gets a value that indicates whether the group row has child rows.
                 */
                get: function () {
                    if (this.grid != null && this._list != null) {
                        // get the next row
                        this._list._update();
                        var rNext = this.index < this._list.length - 1
                            ? this._list[this.index + 1]
                            : null;
                        // check if it's a group row or a new row template
                        var gr = wijmo.tryCast(rNext, GroupRow), nr = wijmo.tryCast(rNext, grid_1._NewRowTemplate);
                        // return true if there is a next row and 
                        // it's a data row or a deeper group row
                        return rNext != null && nr == null && (gr == null || gr.level > this.level);
                    }
                    return true;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(GroupRow.prototype, "isCollapsed", {
                /**
                 * Gets or sets a value that indicates whether the GroupRow is collapsed
                 * (child rows are hidden) or expanded (child rows are visible).
                 */
                get: function () {
                    return this._getFlag(RowColFlags.Collapsed);
                },
                set: function (value) {
                    wijmo.asBoolean(value);
                    if (value != this.isCollapsed && this._list != null) {
                        this._setCollapsed(value);
                    }
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Gets the header text for this @see:GroupRow.
             */
            GroupRow.prototype.getGroupHeader = function () {
                var grid = this.grid, fmt = grid.groupHeaderFormat ? grid.groupHeaderFormat : wijmo.culture.FlexGrid.groupHeaderFormat, group = wijmo.tryCast(this.dataItem, wijmo.collections.CollectionViewGroup);
                if (group && fmt) {
                    // get group info
                    var propName = group.groupDescription['propertyName'], value = group.name, col = grid.getColumn(propName);
                    // customize with column info if possible
                    var isHtml = this.isContentHtml; // TFS 114902
                    if (col) {
                        isHtml = isHtml || col.isContentHtml;
                        if (col.header) {
                            propName = col.header;
                        }
                        if (col.dataMap) {
                            value = col.dataMap.getDisplayValue(value);
                        }
                        else if (col.format) {
                            value = wijmo.Globalize.format(value, col.format);
                        }
                    }
                    // get count including all items (including items not on the current page,
                    // as calculated when setting Column.Aggregate TFS 195467)
                    var count = group.getAggregate(wijmo.Aggregate.CntAll, null, grid.collectionView);
                    //let count = group.items.length;
                    // build header text
                    return wijmo.format(fmt, {
                        name: wijmo.escapeHtml(propName),
                        value: isHtml ? value : wijmo.escapeHtml(value),
                        level: group.level,
                        count: count
                    });
                }
                return '';
            };
            // sets the collapsed/expanded state of a group row
            GroupRow.prototype._setCollapsed = function (collapsed) {
                var _this = this;
                var g = this.grid, rows = g.rows, rng = this.getCellRange(), e = new grid_1.CellRangeEventArgs(g.cells, new grid_1.CellRange(this.index, -1)), gr;
                // fire GroupCollapsedChanging
                g.onGroupCollapsedChanging(e);
                // if user canceled, or edits failed, bail out
                if (e.cancel) {
                    return;
                }
                // apply new value
                g.deferUpdate(function () {
                    // collapse/expand this group
                    _this._setFlag(RowColFlags.Collapsed, collapsed);
                    for (var r = rng.topRow + 1; r <= rng.bottomRow && r > -1 && r < rows.length; r++) {
                        // apply state to this row
                        rows[r]._setFlag(RowColFlags.ParentCollapsed, collapsed);
                        // if this is a group, skip range to preserve the original state
                        gr = wijmo.tryCast(rows[r], GroupRow);
                        if (gr != null && gr.isCollapsed) {
                            r = gr.getCellRange().bottomRow;
                        }
                    }
                });
                // fire GroupCollapsedChanged
                g.onGroupCollapsedChanged(e);
            };
            /**
             * Gets a @see:CellRange object that contains all of the rows in the group represented
             * by this @see:GroupRow and all of the columns in the grid.
             */
            GroupRow.prototype.getCellRange = function () {
                var rows = this._list, top = this.index, bottom = rows.length - 1;
                for (var r = top + 1; r <= bottom; r++) {
                    var gr = wijmo.tryCast(rows[r], GroupRow);
                    if (gr != null && gr.level <= this.level) {
                        bottom = r - 1;
                        break;
                    }
                }
                return new grid_1.CellRange(top, 0, bottom, this.grid.columns.length - 1);
            };
            return GroupRow;
        }(Row));
        grid_1.GroupRow = GroupRow;
        /**
         * Abstract class that serves as a base for row and column collections.
         */
        var RowColCollection = /** @class */ (function (_super) {
            __extends(RowColCollection, _super);
            /**
             * Initializes a new instance of the @see:RowColCollection class.
             *
             * @param g The @see:FlexGrid that owns the collection.
             * @param defaultSize The default size of the elements in the collection.
             */
            function RowColCollection(g, defaultSize) {
                var _this = _super.call(this) || this;
                _this._frozen = 0;
                _this._vlen = 0;
                _this._szDef = 28;
                _this._szTot = 0;
                _this._dirty = false;
                _this._g = wijmo.asType(g, grid_1.FlexGrid);
                _this._szDef = wijmo.asNumber(defaultSize, false, true);
                return _this;
            }
            Object.defineProperty(RowColCollection.prototype, "defaultSize", {
                /**
                 * Gets or sets the default size of elements in the collection.
                 */
                get: function () {
                    return this._szDef;
                },
                set: function (value) {
                    if (this._szDef != value) {
                        this._szDef = wijmo.asNumber(value, false, true);
                        this._dirty = true;
                        this._g.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowColCollection.prototype, "frozen", {
                /**
                 * Gets or sets the number of frozen rows or columns in the collection.
                 *
                 * Frozen rows and columns do not scroll, and instead remain at the top or left of
                 * the grid, next to the fixed cells. Unlike fixed cells, however, frozen
                 * cells may be selected and edited like regular cells.
                 */
                get: function () {
                    return this._frozen;
                },
                set: function (value) {
                    if (value != this._frozen) {
                        this._frozen = wijmo.asNumber(value, false, true);
                        this._dirty = true;
                        this._g.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Checks whether a row or column is frozen.
             *
             * @param index The index of the row or column to check.
             */
            RowColCollection.prototype.isFrozen = function (index) {
                return index < this.frozen;
            };
            Object.defineProperty(RowColCollection.prototype, "minSize", {
                /**
                 * Gets or sets the minimum size of elements in the collection.
                 */
                get: function () {
                    return this._szMin;
                },
                set: function (value) {
                    if (value != this._szMin) {
                        this._szMin = wijmo.asNumber(value, true, true);
                        this._dirty = true;
                        this._g.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(RowColCollection.prototype, "maxSize", {
                /**
                 * Gets or sets the maximum size of elements in the collection.
                 */
                get: function () {
                    return this._szMax;
                },
                set: function (value) {
                    if (value != this._szMax) {
                        this._szMax = wijmo.asNumber(value, true, true);
                        this._dirty = true;
                        this._g.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Gets the total size of the elements in the collection.
             */
            RowColCollection.prototype.getTotalSize = function () {
                if (this._dirty) {
                    this._update();
                }
                return this._szTot;
            };
            Object.defineProperty(RowColCollection.prototype, "visibleLength", {
                /**
                 * Gets the number of visible elements in the collection (@see:Row.isVisible).
                 */
                get: function () {
                    if (this._dirty) {
                        this._update();
                    }
                    return this._vlen;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Gets the index of the element at a given physical position.
             * @param position Position of the item in the collection, in pixels.
             */
            RowColCollection.prototype.getItemAt = function (position) {
                // update if necessary
                if (this._dirty) {
                    this._update();
                }
                // shortcut for common case
                if (position <= 0 && this.length > 0) {
                    return 0;
                }
                // round to improve precision when pinch-zooming
                position = Math.round(position);
                // binary search
                // REVIEW: is this worth it? might be better to use a simpler method?
                // could assume constant height and use a for/loop after that...
                var len = this.length, min = 0, max = len - 1, cur, item;
                while (min <= max) {
                    cur = (min + max) >>> 1;
                    item = this[cur];
                    if (item._pos > position && cur > 0) {
                        max = cur - 1;
                    }
                    else if (item._pos + item.renderSize <= position && cur < len - 1) {
                        min = cur + 1;
                    }
                    else {
                        // skip invisible elements
                        while (cur > 0 && !this[cur].visible) {
                            cur--;
                        }
                        while (cur < len - 1 && !this[cur].visible) {
                            cur++;
                        }
                        // done
                        return cur;
                    }
                }
                // not found, return max
                return max;
            };
            /**
             * Finds the next visible cell for a selection change.
             * @param index Starting index for the search.
             * @param move Type of move (size and direction).
             * @param pageSize Size of a page (in case the move is a page up/down).
             */
            RowColCollection.prototype.getNextCell = function (index, move, pageSize) {
                var i;
                switch (move) {
                    case grid_1.SelMove.Next:
                        for (i = index + 1; i < this.length; i++) {
                            if (this[i].renderSize > 0)
                                return i;
                        }
                        break;
                    case grid_1.SelMove.Prev:
                        for (i = index - 1; i >= 0; i--) {
                            if (this[i].renderSize > 0)
                                return i;
                        }
                        break;
                    case grid_1.SelMove.End:
                        for (i = this.length - 1; i >= 0; i--) {
                            if (this[i].renderSize > 0)
                                return i;
                        }
                        break;
                    case grid_1.SelMove.Home:
                        for (i = 0; i < this.length; i++) {
                            if (this[i].renderSize > 0)
                                return i;
                        }
                        break;
                    case grid_1.SelMove.NextPage:
                        i = this.getItemAt(this[index].pos + pageSize);
                        return i < 0 ? this.getNextCell(index, grid_1.SelMove.End, pageSize) : // bad index, go to last item
                            i == index && i < this.length - 1 ? i + 1 : // page too small, go to next item
                                i;
                    case grid_1.SelMove.PrevPage:
                        i = this.getItemAt(this[index].pos - pageSize);
                        return i < 0 ? this.getNextCell(index, grid_1.SelMove.Home, pageSize) : // bad index, go to first item
                            i == index && i > 0 ? i - 1 : // page too small, go to previous item
                                i;
                }
                return index;
            };
            /**
             * Checks whether an element can be moved from one position to another.
             *
             * @param src The index of the element to move.
             * @param dst The position to which to move the element, or specify -1 to append the element.
             * @return Returns true if the move is valid, false otherwise.
             */
            RowColCollection.prototype.canMoveElement = function (src, dst) {
                // no move?
                if (dst == src) {
                    return false;
                }
                // invalid move?
                if (src < 0 || src >= this.length || dst >= this.length) {
                    return false;
                }
                // illegal move?
                if (dst < 0)
                    dst = this.length - 1;
                var start = Math.min(src, dst), end = Math.max(src, dst);
                for (var i = start; i <= end; i++) {
                    if (!this[i].allowDragging) {
                        return false;
                    }
                }
                // can't move anything past the new row template (TFS 109012)
                if (this[dst] instanceof grid_1._NewRowTemplate) {
                    return false;
                }
                // all seems OK
                return true;
            };
            /**
             * Moves an element from one position to another.
             * @param src Index of the element to move.
             * @param dst Position where the element should be moved to (-1 to append).
             */
            RowColCollection.prototype.moveElement = function (src, dst) {
                if (this.canMoveElement(src, dst)) {
                    var e = this[src];
                    this.removeAt(src);
                    if (dst < 0)
                        dst = this.length;
                    this.insert(dst, e);
                }
            };
            /**
             * Keeps track of dirty state and invalidate grid on changes.
             */
            RowColCollection.prototype.onCollectionChanged = function (e) {
                if (e === void 0) { e = wijmo.collections.NotifyCollectionChangedEventArgs.reset; }
                this._dirty = true;
                this._g.invalidate();
                _super.prototype.onCollectionChanged.call(this, e);
            };
            /**
             * Appends an item to the array.
             *
             * @param item Item to add to the array.
             * @return The new length of the array.
             */
            RowColCollection.prototype.push = function (item) {
                item._list = this;
                return _super.prototype.push.call(this, item);
            };
            /**
             * Removes or adds items to the array.
             *
             * @param index Position where items are added or removed.
             * @param count Number of items to remove from the array.
             * @param item Item to add to the array.
             * @return An array containing the removed elements.
             */
            RowColCollection.prototype.splice = function (index, count, item) {
                if (item) {
                    item._list = this;
                }
                return _super.prototype.splice.call(this, index, count, item);
            };
            /**
             * Suspends notifications until the next call to @see:endUpdate.
             */
            RowColCollection.prototype.beginUpdate = function () {
                // make sure we're up-to-date before suspending the updates
                this._update();
                // OK, now it's OK to suspend things
                _super.prototype.beginUpdate.call(this);
            };
            // updates the index, size and position of the elements in the array.
            RowColCollection.prototype._update = function () {
                // update only if we're dirty *and* if the collection is not in an update block.
                // this is important for performance, especially when expanding/collapsing nodes.
                if (this._dirty && !this.isUpdating) {
                    this._dirty = false;
                    var vlen = 0, pos = 0, sz = void 0, rc = void 0;
                    for (var i = 0; i < this.length; i++) {
                        rc = this[i];
                        rc._idx = i;
                        rc._vidx = vlen;
                        rc._list = this;
                        rc._pos = pos;
                        sz = rc.renderSize;
                        if (sz > 0) {
                            pos += sz;
                            vlen++;
                        }
                    }
                    this._vlen = vlen;
                    this._szTot = pos;
                    return true;
                }
                return false;
            };
            return RowColCollection;
        }(wijmo.collections.ObservableArray));
        grid_1.RowColCollection = RowColCollection;
        /**
         * Represents a collection of @see:Column objects in a @see:FlexGrid control.
         */
        var ColumnCollection = /** @class */ (function (_super) {
            __extends(ColumnCollection, _super);
            function ColumnCollection() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this._firstVisible = -1;
                return _this;
            }
            /**
             * Gets a column by name or by binding.
             *
             * The method searches the column by name. If a column with the given name
             * is not found, it searches by binding. The searches are case-sensitive.
             *
             * @param name The name or binding to find.
             * @return The column with the specified name or binding, or null if not found.
             */
            ColumnCollection.prototype.getColumn = function (name) {
                var index = wijmo.isNumber(name) ? name : this.indexOf(name);
                return index > -1 ? this[index] : null;
            };
            /**
             * Gets the index of a column by name or binding.
             *
             * The method searches the column by name. If a column with the given name
             * is not found, it searches by binding. The searches are case-sensitive.
             *
             * @param name The name or binding to find.
             * @return The index of column with the specified name or binding, or -1 if not found.
             */
            ColumnCollection.prototype.indexOf = function (name) {
                // direct lookup
                if (name instanceof Column) {
                    return _super.prototype.indexOf.call(this, name);
                }
                // by name
                for (var i = 0; i < this.length; i++) {
                    if (this[i].name == name) {
                        return i;
                    }
                }
                // by binding
                for (var i = 0; i < this.length; i++) {
                    if (this[i].binding == name) {
                        return i;
                    }
                }
                return -1;
            };
            Object.defineProperty(ColumnCollection.prototype, "firstVisibleIndex", {
                /**
                 * Gets the index of the first visible column (where the outline tree is displayed).
                 */
                get: function () {
                    if (this._dirty) {
                        this._update();
                    }
                    return this._firstVisible;
                },
                enumerable: true,
                configurable: true
            });
            // override to keep track of first visible column (and later to handle star sizes)
            ColumnCollection.prototype._update = function () {
                if (_super.prototype._update.call(this)) {
                    this._firstVisible = -1;
                    for (var i = 0; i < this.length; i++) {
                        if ((this[i]).visible) {
                            this._firstVisible = i;
                            break;
                        }
                    }
                    return true;
                }
                return false;
            };
            // update the width of the columns with star sizes
            ColumnCollection.prototype._updateStarSizes = function (szAvailable) {
                var starCount = 0, lastStarCol;
                // count stars, remove fixed size columns from available size
                for (var i = 0; i < this.length; i++) {
                    var col = this[i];
                    if (col.isVisible) {
                        if (col._szStar) {
                            starCount += Column._parseStarSize(col._szStar);
                            lastStarCol = col;
                        }
                        else {
                            szAvailable -= col.renderWidth;
                        }
                    }
                }
                // update width of star columns
                if (lastStarCol) {
                    var lastWidth = szAvailable;
                    for (var i = 0; i < this.length; i++) {
                        var col = this[i];
                        if (col.isVisible) {
                            if (col._szStar) {
                                if (col == lastStarCol && lastWidth > 0) {
                                    col._sz = lastWidth; // to avoid round-off errors...
                                }
                                else {
                                    col._sz = Math.max(0, Math.round(Column._parseStarSize(col._szStar) / starCount * szAvailable));
                                    lastWidth -= col.renderWidth;
                                }
                            }
                        }
                    }
                    this._dirty = true;
                    this._update();
                    return true;
                }
                // no star sizes...
                return false;
            };
            return ColumnCollection;
        }(RowColCollection));
        grid_1.ColumnCollection = ColumnCollection;
        /**
         * Represents a collection of @see:Row objects in a @see:FlexGrid control.
         */
        var RowCollection = /** @class */ (function (_super) {
            __extends(RowCollection, _super);
            function RowCollection() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this._maxLevel = -1;
                return _this;
            }
            Object.defineProperty(RowCollection.prototype, "maxGroupLevel", {
                /**
                 * Gets the maximum group level in the grid.
                 *
                 * @return The maximum group level or -1 if the grid has no group rows.
                 */
                get: function () {
                    if (this._dirty) {
                        this._update();
                    }
                    return this._maxLevel;
                },
                enumerable: true,
                configurable: true
            });
            // override to keep track of the maximum group level
            RowCollection.prototype._update = function () {
                if (_super.prototype._update.call(this)) {
                    this._maxLevel = -1;
                    for (var i = 0; i < this.length; i++) {
                        var gr = wijmo.tryCast(this[i], GroupRow);
                        if (gr && gr.level > this._maxLevel) {
                            this._maxLevel = gr.level;
                        }
                    }
                    return true;
                }
                return false;
            };
            return RowCollection;
        }(RowColCollection));
        grid_1.RowCollection = RowCollection;
    })(grid = wijmo.grid || (wijmo.grid = {}));
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    var grid;
    (function (grid_1) {
        'use strict';
        /**
         * Contains information about the part of a @see:FlexGrid control
         * at a given position on the page.
         */
        var HitTestInfo = /** @class */ (function () {
            /**
             * Initializes a new instance of the @see:wijmo.grid.HitTestInfo class.
             *
             * @param grid The @see:FlexGrid control, @see:GridPanel, or cell element
             * to investigate.
             * @param pt The @see:Point object in page coordinates to investigate.
             */
            function HitTestInfo(grid, pt) {
                this._row = -1;
                this._col = -1;
                this._edge = 0; // left, top, right, bottom: 1, 2, 4, 8
                var g;
                // get cell info from cell element
                if (grid instanceof Element) {
                    var cell = wijmo.closest(grid, '.wj-cell'), index = cell ? cell[grid_1.GridPanel._INDEX_KEY] : null;
                    if (index) {
                        this._row = index.row;
                        this._col = index.col;
                        this._rng = index.rng;
                        this._p = index.panel;
                        this._g = index.panel.grid;
                    }
                    return;
                }
                // get owner grid
                if (grid instanceof grid_1.FlexGrid) {
                    g = this._g = grid;
                }
                else if (grid instanceof grid_1.GridPanel) {
                    this._p = grid;
                    g = this._g = this._p.grid;
                }
                else {
                    throw 'First parameter should be a FlexGrid or GridPanel.';
                }
                // reset control bounds on mousedown just to be sure
                var mouseEvent;
                if (pt instanceof MouseEvent) {
                    mouseEvent = pt;
                    if (pt.type == 'mousedown') {
                        g._rcBounds = null;
                    }
                }
                // get the hit-test point in page coordinates
                pt = wijmo.mouseToPage(pt);
                this._pt = pt.clone();
                // get the variables we need
                var rc = g.controlRect, sz = g._szClient, tlp = g.topLeftCells, etl = g._eTL, hdrVis = g.headersVisibility, hve = grid_1.HeadersVisibility, tlWid = (hdrVis & hve.Row) ? tlp.columns.getTotalSize() : 0, tlHei = (hdrVis & hve.Column) ? tlp.rows.getTotalSize() : 0, tlHeiSticky = (hdrVis & hve.Column) ? tlHei + etl.offsetTop : 0, ebl = g._eBL, blHei = ebl.offsetHeight;
                // convert page to control coordinates (TFS 229880)
                pt.x -= rc.left;
                pt.y -= rc.top;
                // account for right to left
                if (this._g.rightToLeft) {
                    pt.x = rc.width - pt.x;
                }
                // find out which panel was clicked
                if (!this._p &&
                    pt.x >= 0 && pt.y >= etl.offsetTop &&
                    sz && pt.x <= sz.width + tlWid && pt.y <= sz.height + tlHeiSticky) {
                    if (pt.y < tlHeiSticky) {
                        this._p = pt.x < tlWid ? g.topLeftCells : g.columnHeaders;
                    }
                    else if (pt.y < ebl.offsetTop) {
                        this._p = pt.x < tlWid ? g.rowHeaders : g.cells;
                    }
                    else {
                        this._p = pt.x < tlWid ? g.bottomLeftCells : g.columnFooters;
                    }
                }
                // if we have a panel, get the coordinates
                if (this._p != null) {
                    // account for frozen rows/cols
                    var rows = this._p.rows, cols = this._p.columns, ct = this._p.cellType, cte = grid_1.CellType, ptFrz = this._p._getFrozenPos(), totHei = (ct == cte.TopLeft || ct == cte.ColumnHeader) ? tlHei :
                        (ct == cte.BottomLeft || ct == cte.ColumnFooter) ? blHei :
                            rows.getTotalSize(), totWid = (ct == cte.TopLeft || ct == cte.BottomLeft || ct == cte.RowHeader) ? tlWid :
                        cols.getTotalSize();
                    // adjust y for scrolling/freezing
                    if (ct == cte.RowHeader || ct == cte.Cell) {
                        pt.y -= tlHei; // discount header height without 'stickiness'
                        if (pt.y > ptFrz.y || ptFrz.y <= 0) {
                            pt.y -= g._ptScrl.y;
                            pt.y += this._p._getOffsetY(); // account for IE's CSS limitations...
                        }
                    }
                    else if (ct == cte.BottomLeft || ct == cte.ColumnFooter) {
                        pt.y -= ebl.offsetTop;
                    }
                    // adjust x for scrolling/freezing
                    if (ct == cte.ColumnHeader || ct == cte.Cell || ct == cte.ColumnFooter) {
                        pt.x -= tlWid;
                        if (pt.x > ptFrz.x || ptFrz.x <= 0) {
                            pt.x -= g._ptScrl.x;
                        }
                    }
                    // enable mouse operations while in "sticky" mode
                    if (ct == cte.ColumnHeader || ct == cte.TopLeft) {
                        pt.y -= (tlHeiSticky - tlHei);
                    }
                    // get edge size (larger if touching)
                    this._edge = 0;
                    var szEdge = HitTestInfo._SZEDGE[this._g.isTouching ? 1 : 0];
                    if (this._g.isTouching) {
                        szEdge = HitTestInfo._SZEDGE[1];
                        pt.x -= szEdge / 2;
                    }
                    // get row and column
                    this._row = pt.y > totHei ? -1 : rows.getItemAt(pt.y);
                    this._col = pt.x > totWid ? -1 : cols.getItemAt(pt.x);
                    if (this._row < 0 || this._col < 0) {
                        this._p = null;
                        return;
                    }
                    // get edges
                    if (this._col > -1) {
                        var col = cols[this._col];
                        if (pt.x - col.pos <= szEdge) {
                            this._edge |= 1; // left
                        }
                        if (col.pos + col.renderSize - pt.x <= szEdge) {
                            this._edge |= 4; // right
                        }
                    }
                    if (this._row > -1) {
                        var row = rows[this._row];
                        if (pt.y - row.pos <= szEdge) {
                            this._edge |= 2; // top
                        }
                        if (row.pos + row.renderSize - pt.y <= szEdge) {
                            this._edge |= 8; // bottom
                        }
                    }
                }
                // check coordinates since calculations aren't 100% accurate when pinch-zooming...
                // REVIEW: does this make sense? maybe we should fix this in the mouseToPage method instead?
                if (!(this._edge & 8) && mouseEvent instanceof MouseEvent) {
                    var cell = wijmo.closest(mouseEvent.target, '.wj-cell'), index = cell ? cell[grid_1.GridPanel._INDEX_KEY] : null;
                    if (index && !index.rng && index.panel == this._p && this._row != index.row) {
                        this._row = index.row;
                    }
                }
            }
            Object.defineProperty(HitTestInfo.prototype, "point", {
                /**
                 * Gets the point in control coordinates that this @see:wijmo.grid.HitTestInfo refers to.
                 */
                get: function () {
                    return this._pt;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(HitTestInfo.prototype, "cellType", {
                /**
                 * Gets the type of cell found at the specified position.
                 */
                get: function () {
                    return this._p ? this._p.cellType : grid.CellType.None;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(HitTestInfo.prototype, "panel", {
                /**
                 * Gets the @see:GridPanel that this @see:HitTestInfo refers to.
                 */
                get: function () {
                    return this._p;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(HitTestInfo.prototype, "grid", {
                /**
                 * Gets the @see:FlexGrid that this @see:HitTestInfo refers to.
                 */
                get: function () {
                    return this._p ? this._p.grid : null;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(HitTestInfo.prototype, "row", {
                /**
                 * Gets the row index of the cell at the specified position.
                 */
                get: function () {
                    return this._row;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(HitTestInfo.prototype, "col", {
                /**
                 * Gets the column index of the cell at the specified position.
                 */
                get: function () {
                    return this._col;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(HitTestInfo.prototype, "range", {
                /**
                 * Gets the cell range at the specified position.
                 */
                get: function () {
                    if (!this._rng) {
                        this._rng = new grid_1.CellRange(this._row, this._col);
                    }
                    return this._rng;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(HitTestInfo.prototype, "edgeLeft", {
                /**
                 * Gets a value that indicates whether the mouse is near the left edge of the cell.
                 */
                get: function () {
                    return (this._edge & 1) != 0;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(HitTestInfo.prototype, "edgeTop", {
                /**
                 * Gets a value that indicates whether the mouse is near the top edge of the cell.
                 */
                get: function () {
                    return (this._edge & 2) != 0;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(HitTestInfo.prototype, "edgeRight", {
                /**
                 * Gets a value that indicates whether the mouse is near the right edge of the cell.
                 */
                get: function () {
                    return (this._edge & 4) != 0;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(HitTestInfo.prototype, "edgeBottom", {
                /**
                 * Gets a value that indicates whether the mouse is near the bottom edge of the cell.
                 */
                get: function () {
                    return (this._edge & 8) != 0;
                },
                enumerable: true,
                configurable: true
            });
            HitTestInfo._SZEDGE = [5, 30]; // distance to cell border (mouse, touch)
            return HitTestInfo;
        }());
        grid_1.HitTestInfo = HitTestInfo;
    })(grid = wijmo.grid || (wijmo.grid = {}));
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    var grid;
    (function (grid) {
        'use strict';
        /**
         * Specifies constants that define which areas of the grid support cell merging.
         */
        var AllowMerging;
        (function (AllowMerging) {
            /** No merging. */
            AllowMerging[AllowMerging["None"] = 0] = "None";
            /** Merge scrollable cells. */
            AllowMerging[AllowMerging["Cells"] = 1] = "Cells";
            /** Merge column headers. */
            AllowMerging[AllowMerging["ColumnHeaders"] = 2] = "ColumnHeaders";
            /** Merge row headers. */
            AllowMerging[AllowMerging["RowHeaders"] = 4] = "RowHeaders";
            /** Merge column and row headers. */
            AllowMerging[AllowMerging["AllHeaders"] = 6] = "AllHeaders";
            /** Merge all areas. */
            AllowMerging[AllowMerging["All"] = 7] = "All";
        })(AllowMerging = grid.AllowMerging || (grid.AllowMerging = {}));
        /**
         * Defines the @see:FlexGrid's cell merging behavior.
         *
         * An instance of this class is automatically created and assigned to
         * the grid's @see:FlexGrid.mergeManager property to implement the
         * grid's default merging behavior.
         *
         * If you want to customize the default merging behavior, create a class
         * that derives from @see:MergeManager and override the @see:getMergedRange
         * method.
         */
        var MergeManager = /** @class */ (function () {
            /**
             * Initializes a new instance of the @see:MergeManager class.
             *
             * @param g The @see:FlexGrid object that owns this @see:MergeManager.
             */
            function MergeManager(g) {
                this._g = g;
            }
            /**
             * Gets a @see:CellRange that specifies the merged extent of a cell
             * in a @see:GridPanel.
             *
             * @param p The @see:GridPanel that contains the range.
             * @param r The index of the row that contains the cell.
             * @param c The index of the column that contains the cell.
             * @param clip Whether to clip the merged range to the grid's current view range.
             * @return A @see:CellRange that specifies the merged range, or null if the cell is not merged.
             */
            MergeManager.prototype.getMergedRange = function (p, r, c, clip) {
                if (clip === void 0) { clip = true; }
                var rng, vr, ct = p.cellType, cols = p.columns, rows = p.rows, row = rows[r], col = cols[c];
                // no merging in new row template (TFS 82235)
                if (row instanceof grid._NewRowTemplate) {
                    return null;
                }
                // merge cells in group rows
                if (row instanceof grid.GroupRow && row.dataItem instanceof wijmo.collections.CollectionViewGroup) {
                    rng = new grid.CellRange(r, c);
                    // expand left and right preserving aggregates
                    if (col.aggregate == wijmo.Aggregate.None) {
                        while (rng.col > 0 &&
                            cols[rng.col - 1].aggregate == wijmo.Aggregate.None &&
                            rng.col != cols.frozen) {
                            rng.col--;
                        }
                        while (rng.col2 < cols.length - 1 &&
                            cols[rng.col2 + 1].aggregate == wijmo.Aggregate.None &&
                            rng.col2 + 1 != cols.frozen) {
                            rng.col2++;
                        }
                    }
                    // don't start range with invisible columns
                    while (rng.col < c && !cols[rng.col].visible) {
                        rng.col++;
                    }
                    // return merged range
                    return rng.isSingleCell ? null : rng;
                }
                // honor grid's allowMerging setting
                var done = false;
                switch (this._g.allowMerging) {
                    case AllowMerging.None:
                        done = true;
                        break;
                    case AllowMerging.Cells:
                        done = ct != grid.CellType.Cell;
                        break;
                    case AllowMerging.ColumnHeaders:
                        done = ct != grid.CellType.ColumnHeader && ct != grid.CellType.TopLeft;
                        break;
                    case AllowMerging.RowHeaders:
                        done = ct != grid.CellType.RowHeader && ct != grid.CellType.TopLeft;
                        break;
                    case AllowMerging.AllHeaders:
                        done = ct == grid.CellType.Cell;
                        break;
                }
                if (done) {
                    return null;
                }
                // merge up and down columns
                if (cols[c].allowMerging) {
                    rng = new grid.CellRange(r, c);
                    // clip to current viewport
                    var rMin = 0, rMax = rows.length - 1;
                    if (r >= rows.frozen) {
                        if (clip && (ct == grid.CellType.Cell || ct == grid.CellType.RowHeader)) {
                            vr = p._getViewRange();
                            rMin = vr.topRow;
                            rMax = vr.bottomRow;
                        }
                    }
                    else {
                        rMax = rows.frozen - 1;
                    }
                    // expand up and down
                    for (var tr = r - 1; tr >= rMin && this._mergeCell(p, tr, c, r, c); tr--) {
                        rng.row = tr;
                    }
                    for (var br = r + 1; br <= rMax && this._mergeCell(p, r, c, br, c); br++) {
                        rng.row2 = br;
                    }
                    // don't start range with invisible rows
                    while (rng.row < r && !rows[rng.row].visible) {
                        rng.row++;
                    }
                    // done
                    if (!rng.isSingleCell) {
                        return rng;
                    }
                }
                // merge left and right along rows
                if (rows[r].allowMerging) {
                    rng = new grid.CellRange(r, c);
                    // get merging limits
                    var cMin = 0, cMax = cols.length - 1;
                    if (c >= cols.frozen) {
                        if (clip && (ct == grid.CellType.Cell || ct == grid.CellType.ColumnHeader)) {
                            vr = p._getViewRange();
                            cMin = vr.leftCol;
                            cMax = vr.rightCol;
                        }
                    }
                    else {
                        cMax = cols.frozen - 1;
                    }
                    // expand left and right
                    for (var cl = c - 1; cl >= cMin && this._mergeCell(p, r, cl, r, c); cl--) {
                        rng.col = cl;
                    }
                    for (var cr = c + 1; cr <= cMax && this._mergeCell(p, r, c, r, cr); cr++) {
                        rng.col2 = cr;
                    }
                    // don't start range with invisible columns
                    while (rng.col < c && !cols[rng.col].visible) {
                        rng.col++;
                    }
                    // done
                    if (!rng.isSingleCell) {
                        return rng;
                    }
                }
                // no merging...
                return null;
            };
            // check whether two cells should be merged
            MergeManager.prototype._mergeCell = function (p, r1, c1, r2, c2) {
                // group rows and new row templates are handled separately
                var row1 = p.rows[r1], row2 = p.rows[r2];
                if (row1 instanceof grid.GroupRow || row1 instanceof grid._NewRowTemplate ||
                    row2 instanceof grid.GroupRow || row2 instanceof grid._NewRowTemplate) {
                    return false;
                }
                // no merging across freezing boundaries
                if (r1 != r2 && p.rows.isFrozen(r1) != p.rows.isFrozen(r2)) {
                    return false;
                }
                if (c1 != c2 && p.columns.isFrozen(c1) != p.columns.isFrozen(c2)) {
                    return false;
                }
                // no vertical merging if the range is already merged horizontally
                if (r1 != r2) {
                    if (c1 > 0) {
                        if ((row1.allowMerging && this._mergeCell(p, r1, c1 - 1, r1, c1)) ||
                            (row2.allowMerging && this._mergeCell(p, r2, c1 - 1, r2, c1))) {
                            return false;
                        }
                    }
                    if (c2 < p.columns.length - 1) {
                        if ((row1.allowMerging && this._mergeCell(p, r1, c2, r1, c2 + 1)) ||
                            (row2.allowMerging && this._mergeCell(p, r2, c2, r2, c2 + 1))) {
                            return false;
                        }
                    }
                }
                // no merging if the data is different
                if (p.getCellData(r1, c1, true) != p.getCellData(r2, c2, true)) {
                    return false;
                }
                // OK to merge
                return true;
            };
            return MergeManager;
        }());
        grid.MergeManager = MergeManager;
    })(grid = wijmo.grid || (wijmo.grid = {}));
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    var grid;
    (function (grid) {
        'use strict';
        /**
         * Represents a data map for use with a column's @see:Column.dataMap property.
         *
         * Data maps provide the grid with automatic look up capabilities. For example,
         * you may want to display a customer name instead of his ID, or a color name
         * instead of its RGB value.
         *
         * The code below binds a grid to a collection of products, then assigns a
         * @see:DataMap to the grid's 'CategoryID' column so the grid displays the
         * category names rather than the raw IDs.
         *
         * The grid takes advantage of data maps also for editing. If the <b>wijmo.input</b>
         * module is loaded, then when editing data-mapped columns the grid will show
         * a drop-down list containing the values on the map.
         *
         * <pre>
         * // bind grid to products
         * var flex = new wijmo.grid.FlexGrid();
         * flex.itemsSource = products;
         * // map CategoryID column to show category name instead of ID
         * var col = flex.columns.getColumn('CategoryID');
         * col.dataMap = new wijmo.grid.DataMap(categories, 'CategoryID', 'CategoryName');
         * </pre>
         *
         * In general, data maps apply to whole columns. However, there are situations
         * where you may want to restrict the options available for a cell based on a
         * value on a different column. For example, if you have "Country" and "City"
         * columns, you will probably want to restrict the cities based on the current
         * country.
         *
         * There are two ways you can implement these "dynamic" data maps:
         *
         * <ol>
         *   <li>
         *     If the @see:DataMap is just a list of strings, you can change it before
         *     the grid enters edit mode. In this case, the cells contain the string
         *     being displayed, and changing the map won't affect other cells in the
         *     same column.
         *     This fiddle demonstrates:
         *     <a href="http://jsfiddle.net/Wijmo5/8brL80r8/">show me</a>.
         *   </li>
         *   <li>
         *     If the @see:DataMap is a real map (stores key values in the cells, shows
         *     a corresponding string), then you can apply a filter to restrict the
         *     values shown in the drop-down. The @see:DataMap will still contain the
         *     same keys and values, so other cells in the same column won't be disturbed
         *     by the filter.
         *     This fiddle demonstrates:
         *     <a href="http://jsfiddle.net/Wijmo5/xborLd4t/">show me</a>.
         *   </li>
         * </ol>
         *
         * In some cases, you may want to create a @see:DataMap to represent an enumeration.
         * This can be done with the following code:
         *
         * <pre>// build a DataMap for a given enum
         *  function getDataMap(enumClass) {
         *      var pairs = [];
         *      for (var key in enumClass) {
         *          var val = parseInt(key);
         *          if (!isNaN(val)) {
         *              pairs.push({ key: val, name: enumClass[val] });
         *          }
         *      }
         *      return new wijmo.grid.DataMap(pairs, 'key', 'name');
         * }</pre>
         */
        var DataMap = /** @class */ (function () {
            /**
             * Initializes a new instance of the @see:DataMap class.
             *
             * @param itemsSource An array or @see:ICollectionView that contains the items to map.
             * @param selectedValuePath The name of the property that contains the keys (data values).
             * @param displayMemberPath The name of the property to use as the visual representation of the items.
             */
            function DataMap(itemsSource, selectedValuePath, displayMemberPath) {
                /**
                 * Occurs when the map data changes.
                 */
                this.mapChanged = new wijmo.Event();
                // turn arrays into real maps
                if (wijmo.isArray(itemsSource) && !selectedValuePath && !displayMemberPath) {
                    var arr = [];
                    for (var i = 0; i < itemsSource.length; i++) {
                        arr.push({ value: itemsSource[i] });
                    }
                    itemsSource = arr;
                    selectedValuePath = displayMemberPath = 'value';
                }
                // initialize map
                this._cv = wijmo.asCollectionView(itemsSource);
                this._keyPath = wijmo.asString(selectedValuePath, false);
                this._displayPath = wijmo.asString(displayMemberPath, false);
                // notify listeners when the map changes
                this._cv.collectionChanged.addHandler(this.onMapChanged, this);
            }
            Object.defineProperty(DataMap.prototype, "sortByDisplayValues", {
                /**
                 * Gets or sets a value that determines whether to use mapped (display)
                 * or raw values when sorting the data.
                 */
                get: function () {
                    return this._sortByKey != true;
                },
                set: function (value) {
                    this._sortByKey = !wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(DataMap.prototype, "collectionView", {
                /**
                 * Gets the @see:ICollectionView object that contains the map data.
                 */
                get: function () {
                    return this._cv;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(DataMap.prototype, "selectedValuePath", {
                /**
                 * Gets the name of the property to use as a key for the item (data value).
                 */
                get: function () {
                    return this._keyPath;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(DataMap.prototype, "displayMemberPath", {
                /**
                 * Gets the name of the property to use as the visual representation of the item.
                 */
                get: function () {
                    return this._displayPath;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Gets the key that corresponds to a given display value.
             *
             * @param displayValue The display value of the item to retrieve.
             */
            DataMap.prototype.getKeyValue = function (displayValue) {
                var index = this._indexOf(displayValue, this._displayPath, false);
                return index > -1 ? this._cv.sourceCollection[index][this._keyPath] : null;
            };
            /**
             * Gets the display value that corresponds to a given key.
             *
             * @param key The key of the item to retrieve.
             */
            DataMap.prototype.getDisplayValue = function (key) {
                if (!this._hash) {
                    this._hash = {};
                    var arr = this._cv.sourceCollection;
                    if (arr && this._keyPath && this._displayPath) {
                        for (var i = arr.length - 1; i >= 0; i--) {
                            var item = arr[i], k = item[this._keyPath], v = item[this._displayPath];
                            this._hash[k] = v;
                        }
                    }
                }
                var value = this._hash[key];
                return value != null ? value : key;
                // old version: slow sequential lookup, orders of magnitude slower than hash
                //let index = this._indexOf(key, this._keyPath, true);
                //return index > -1 ? this._cv.sourceCollection[index][this._displayPath] : key;
            };
            /**
             * Gets an array with all of the display values on the map.
             *
             * @param dataItem Data item for which to get the display items.
             * This parameter is optional. If not provided, all possible display
             * values should be returned.
             */
            DataMap.prototype.getDisplayValues = function (dataItem) {
                var values = [];
                if (this._cv && this._displayPath) {
                    var items = this._cv.items; // << list filtered/sorted values
                    for (var i = 0; i < items.length; i++) {
                        values.push(items[i][this._displayPath]);
                    }
                }
                return values;
            };
            /**
             * Gets an array with all of the keys on the map.
             */
            DataMap.prototype.getKeyValues = function () {
                var values = [];
                if (this._cv && this._keyPath) {
                    var items = this._cv.items; // << list filtered/sorted values
                    for (var i = 0; i < items.length; i++) {
                        values.push(items[i][this._keyPath]);
                    }
                }
                return values;
            };
            Object.defineProperty(DataMap.prototype, "isEditable", {
                /**
                 * Gets or sets a value that indicates whether users should be allowed to enter
                 * values that are not present on the @see:DataMap.
                 *
                 * In order for a @see:DataMap to be editable, the @see:selectedValuePath and
                 * @see:displayMemberPath must be set to the same value.
                 */
                get: function () {
                    return this._editable;
                },
                set: function (value) {
                    this._editable = wijmo.asBoolean(value);
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Raises the @see:mapChanged event.
             */
            DataMap.prototype.onMapChanged = function (e) {
                this._hash = null;
                this.mapChanged.raise(this, e);
            };
            // implementation
            // gets the index of a value in the sourceCollection (not the view)
            // if the value appears multiple times, returns the first that is not
            // filtered out of view
            DataMap.prototype._indexOf = function (value, path, caseSensitive) {
                var index = -1, firstMatch = -1;
                if (this._cv && path) {
                    var sval = value != null ? value.toString() : '', lcval = caseSensitive ? sval : sval.toLowerCase();
                    // look for items
                    var items = this._cv.sourceCollection;
                    for (var i = 0; i < items.length; i++) {
                        var item = items[i], val = item[path];
                        // straight comparison
                        if (val == value) {
                            index = i;
                        }
                        else if (!caseSensitive && val.length == lcval.length && val.toLowerCase() == lcval) {
                            index = i;
                        }
                        else if (val != null && val.toString() == sval) {
                            index = i;
                        }
                        // if this is a match and the item passes the filter, we're done
                        if (index == i) {
                            if (!this._cv.filter || this._cv.filter(item)) {
                                return index;
                            }
                            else if (firstMatch < 0) {
                                firstMatch = index;
                            }
                        }
                    }
                }
                // return the first match we found (in sourceCollection but filtered out of view)
                return firstMatch;
            };
            return DataMap;
        }());
        grid.DataMap = DataMap;
    })(grid = wijmo.grid || (wijmo.grid = {}));
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    var grid;
    (function (grid) {
        'use strict';
        /**
         * Specifies constants that define the selection behavior.
         */
        var SelectionMode;
        (function (SelectionMode) {
            /** The user cannot select cells using the mouse or keyboard. */
            SelectionMode[SelectionMode["None"] = 0] = "None";
            /** The user can select only a single cell at a time. */
            SelectionMode[SelectionMode["Cell"] = 1] = "Cell";
            /** The user can select contiguous blocks of cells. */
            SelectionMode[SelectionMode["CellRange"] = 2] = "CellRange";
            /** The user can select a single row at a time. */
            SelectionMode[SelectionMode["Row"] = 3] = "Row";
            /** The user can select contiguous rows. */
            SelectionMode[SelectionMode["RowRange"] = 4] = "RowRange";
            /** The user can select non-contiguous rows. */
            SelectionMode[SelectionMode["ListBox"] = 5] = "ListBox";
        })(SelectionMode = grid.SelectionMode || (grid.SelectionMode = {}));
        /**
         * Specifies constants that represent the selected state of a cell.
         */
        var SelectedState;
        (function (SelectedState) {
            /** The cell is not selected. */
            SelectedState[SelectedState["None"] = 0] = "None";
            /** The cell is selected but is not the active cell. */
            SelectedState[SelectedState["Selected"] = 1] = "Selected";
            /** The cell is selected and is the active cell. */
            SelectedState[SelectedState["Cursor"] = 2] = "Cursor";
        })(SelectedState = grid.SelectedState || (grid.SelectedState = {}));
        /**
         * Specifies constants that represent a type of movement for the selection.
         */
        var SelMove;
        (function (SelMove) {
            /** Do not change the selection. */
            SelMove[SelMove["None"] = 0] = "None";
            /** Select the next visible cell. */
            SelMove[SelMove["Next"] = 1] = "Next";
            /** Select the previous visible cell. */
            SelMove[SelMove["Prev"] = 2] = "Prev";
            /** Select the first visible cell in the next page. */
            SelMove[SelMove["NextPage"] = 3] = "NextPage";
            /** Select the first visible cell in the previous page. */
            SelMove[SelMove["PrevPage"] = 4] = "PrevPage";
            /** Select the first visible cell. */
            SelMove[SelMove["Home"] = 5] = "Home";
            /** Select the last visible cell. */
            SelMove[SelMove["End"] = 6] = "End";
            /** Select the next visible cell skipping rows if necessary. */
            SelMove[SelMove["NextCell"] = 7] = "NextCell";
            /** Select the previous visible cell skipping rows if necessary. */
            SelMove[SelMove["PrevCell"] = 8] = "PrevCell";
        })(SelMove = grid.SelMove || (grid.SelMove = {}));
        /**
         * Handles the grid's selection.
         */
        var _SelectionHandler = /** @class */ (function () {
            /**
             * Initializes a new instance of the @see:_SelectionHandler class.
             *
             * @param g @see:FlexGrid that owns this @see:_SelectionHandler.
             */
            function _SelectionHandler(g) {
                this._sel = new grid.CellRange(0, 0);
                this._mode = SelectionMode.CellRange;
                this._g = g;
            }
            Object.defineProperty(_SelectionHandler.prototype, "selectionMode", {
                /**
                 * Gets or sets the current selection mode.
                 */
                get: function () {
                    return this._mode;
                },
                set: function (value) {
                    if (value != this._mode) {
                        // update ListBox selection when switching modes
                        var sm = SelectionMode;
                        if (value == sm.ListBox || this._mode == sm.ListBox) {
                            var rows = this._g.rows;
                            for (var i = 0; i < rows.length; i++) {
                                var row = rows[i], sel = (value == SelectionMode.ListBox) ? this._sel.containsRow(i) : false;
                                row._setFlag(grid.RowColFlags.Selected, sel, true);
                            }
                        }
                        // collapse selection when switching to None/Cell/Row modes (TFS 130691)
                        switch (value) {
                            case sm.None:
                                this._sel.setRange(-1, -1);
                                break;
                            case sm.Cell:
                                this._sel.row2 = this._sel.row;
                                this._sel.col2 = this._sel.col;
                                break;
                            case sm.Row:
                                this._sel.row2 = this._sel.row;
                                break;
                        }
                        // apply new mode
                        this._mode = value;
                        this._g.invalidate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(_SelectionHandler.prototype, "selection", {
                /**
                 * Gets or sets the current selection.
                 */
                get: function () {
                    return this._sel;
                },
                set: function (value) {
                    this.select(value);
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Selects a cell range and optionally scrolls it into view.
             *
             * @param rng Range to select.
             * @param show Whether to scroll the new selection into view.
             */
            _SelectionHandler.prototype.select = function (rng, show) {
                if (show === void 0) { show = true; }
                // allow passing in row and column indices
                if (wijmo.isNumber(rng) && wijmo.isNumber(show)) {
                    rng = new grid.CellRange(rng, show);
                    show = true;
                }
                rng = wijmo.asType(rng, grid.CellRange);
                // get old and new selections
                var g = this._g, oldSel = this._sel, newSel = rng, lbMode = false, sm = SelectionMode;
                // adjust for selection mode
                switch (g.selectionMode) {
                    // Cell mode: collapse range into single cell
                    case sm.Cell:
                        rng.row2 = rng.row;
                        rng.col2 = rng.col;
                        break;
                    // Row mode: collapse range into single row
                    case sm.Row:
                        rng.row2 = rng.row;
                        break;
                    // ListBox mode: remember because handling is quite different
                    case sm.ListBox:
                        lbMode = true;
                        break;
                }
                // check if the selection really is changing
                // (special handling for ListBox mode when re-selecting items)
                var noChange = newSel.equals(oldSel);
                if (lbMode && newSel.row > -1 && !g.rows[newSel.row].isSelected) {
                    noChange = false;
                }
                // no change? done
                if (noChange) {
                    if (show) {
                        g.scrollIntoView(newSel.row, newSel.col);
                    }
                    return;
                }
                // raise selectionChanging event
                var e = new grid.CellRangeEventArgs(g.cells, newSel);
                if (!g.onSelectionChanging(e)) {
                    return;
                }
                // ListBox mode: update Selected flag and refresh to show changes
                // (MS request: only if the selected row changed)
                if (lbMode) {
                    if (newSel.row != oldSel.row || // different row
                        newSel.rowSpan > 1 || oldSel.rowSpan > 1) {
                        for (var i = 0; i < g.rows.length; i++) {
                            g.rows[i]._setFlag(grid.RowColFlags.Selected, newSel.containsRow(i), true);
                        }
                        g.refreshCells(false, true, true);
                    }
                }
                // validate selection after the change
                newSel.row = Math.min(newSel.row, g.rows.length - 1);
                newSel.row2 = Math.min(newSel.row2, g.rows.length - 1);
                // update selection
                this._sel = newSel;
                // show the new selection
                g.refreshCells(false, true, true);
                if (show) {
                    g.scrollIntoView(newSel.row, newSel.col);
                }
                // update collectionView cursor
                if (g.collectionView) {
                    var index = g._getCvIndex(newSel.row);
                    g.collectionView.moveCurrentToPosition(index);
                }
                // raise selectionChanged event
                g.onSelectionChanged(e);
            };
            /**
             * Moves the selection by a specified amount in the vertical and horizontal directions.
             * @param rowMove How to move the row selection.
             * @param colMove How to move the column selection.
             * @param extend Whether to extend the current selection or start a new one.
             */
            _SelectionHandler.prototype.moveSelection = function (rowMove, colMove, extend) {
                var row, col, g = this._g, rows = g.rows, cols = g.columns, rng = this._getReferenceCell(rowMove, colMove, extend), pageSize = Math.max(0, g._szClient.height - g.columnHeaders.height);
                // handle next cell with wrapping
                if (colMove == SelMove.NextCell) {
                    col = cols.getNextCell(rng.col, SelMove.Next, pageSize);
                    row = rng.row;
                    if (col == rng.col) {
                        row = rows.getNextCell(row, SelMove.Next, pageSize);
                        if (row > rng.row) {
                            col = cols.getNextCell(0, SelMove.Next, pageSize);
                            col = cols.getNextCell(col, SelMove.Prev, pageSize);
                        }
                    }
                    g.select(row, col);
                }
                else if (colMove == SelMove.PrevCell) {
                    col = cols.getNextCell(rng.col, SelMove.Prev, pageSize);
                    row = rng.row;
                    if (col == rng.col) {
                        row = rows.getNextCell(row, SelMove.Prev, pageSize);
                        if (row < rng.row) {
                            col = cols.getNextCell(cols.length - 1, SelMove.Prev, pageSize);
                            col = cols.getNextCell(col, SelMove.Next, pageSize);
                        }
                    }
                    g.select(row, col);
                }
                else {
                    // get target row, column
                    row = rows.getNextCell(rng.row, rowMove, pageSize);
                    col = cols.getNextCell(rng.col, colMove, pageSize);
                    // extend or select
                    if (extend) {
                        var sel = g._selHdl._sel;
                        g.select(new grid.CellRange(row, col, sel.row2, sel.col2));
                    }
                    else {
                        g.select(row, col);
                    }
                }
            };
            // get reference cell for selection change, taking merging into account
            _SelectionHandler.prototype._getReferenceCell = function (rowMove, colMove, extend) {
                var g = this._g, sel = g._selHdl._sel, rng = g.getMergedRange(g.cells, sel.row, sel.col);
                // not merging? use selection as a reference
                if (!rng || rng.isSingleCell) {
                    return sel;
                }
                // clone range and set reference cell within the range
                rng = rng.clone();
                switch (rowMove) {
                    case SelMove.Next:
                    case SelMove.NextCell:
                        rng.row = rng.bottomRow;
                        break;
                    case SelMove.None:
                        rng.row = sel.row;
                        break;
                }
                switch (colMove) {
                    case SelMove.Next:
                    case SelMove.NextCell:
                        rng.col = rng.rightCol;
                        break;
                    case SelMove.None:
                        rng.col = sel.col;
                        break;
                }
                // done
                return rng;
            };
            // adjusts a selection to reflect the current selection mode
            /*private*/ _SelectionHandler.prototype._adjustSelection = function (rng) {
                switch (this._mode) {
                    case SelectionMode.Cell:
                        return new grid.CellRange(rng.row, rng.col, rng.row, rng.col);
                    case SelectionMode.Row:
                        return new grid.CellRange(rng.row, 0, rng.row, this._g.columns.length - 1);
                    case SelectionMode.RowRange:
                    case SelectionMode.ListBox:
                        return new grid.CellRange(rng.row, 0, rng.row2, this._g.columns.length - 1);
                }
                return rng;
            };
            return _SelectionHandler;
        }());
        grid._SelectionHandler = _SelectionHandler;
    })(grid = wijmo.grid || (wijmo.grid = {}));
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    var grid;
    (function (grid) {
        'use strict';
        /**
         * Specifies constants that define the action to perform when special
         * keys such as ENTER and TAB are pressed.
         */
        var KeyAction;
        (function (KeyAction) {
            /** No special action (let the browser handle the key). */
            KeyAction[KeyAction["None"] = 0] = "None";
            /** Move the selection to the next row. */
            KeyAction[KeyAction["MoveDown"] = 1] = "MoveDown";
            /** Move the selection to the next column. */
            KeyAction[KeyAction["MoveAcross"] = 2] = "MoveAcross";
            /** Move the selection to the next column, then wrap to the next row. */
            KeyAction[KeyAction["Cycle"] = 3] = "Cycle";
            /** Move the selection to the next column, then wrap to the next row, then out of the control. */
            KeyAction[KeyAction["CycleOut"] = 4] = "CycleOut";
        })(KeyAction = grid.KeyAction || (grid.KeyAction = {}));
        /**
         * Handles the grid's keyboard commands.
         */
        var _KeyboardHandler = /** @class */ (function () {
            /**
             * Initializes a new instance of the @see:_KeyboardHandler class.
             *
             * @param g @see:FlexGrid that owns this @see:_KeyboardHandler.
             */
            function _KeyboardHandler(g) {
                this._kaTab = KeyAction.None;
                this._kaEnter = KeyAction.MoveDown;
                this._g = g;
                var host = g.hostElement;
                g.addEventListener(host, 'keypress', this._keypress.bind(this));
                g.addEventListener(host, 'keydown', this._keydown.bind(this));
            }
            // handles the key down event (selection)
            /*private*/ _KeyboardHandler.prototype._keydown = function (e) {
                var g = this._g, sel = g.selection, ctrl = e.ctrlKey || e.metaKey, shift = e.shiftKey, target = e.target, handled = true;
                // reset alt-down flag
                this._altDown = false;
                // allow input elements that don't belong to us to handle keys (TFS 131138, 191989)
                if (g._wantsInput(e.target)) {
                    return;
                }
                // sanity (before pre-processing: TFS 272449)
                if (!g.isRangeValid(sel) || e.defaultPrevented) {
                    return;
                }
                // pre-process keys while editor is active
                if (g.activeEditor && g._edtHdl._keydown(e)) {
                    return;
                }
                // get the variables we need
                var gr = wijmo.tryCast(g.rows[sel.row], grid.GroupRow), ecv = g.editableCollectionView, keyCode = e.keyCode;
                // handle clipboard
                if (g.autoClipboard) {
                    // copy: ctrl+c or ctrl+Insert
                    if (ctrl && (keyCode == 67 || keyCode == 45)) {
                        var args = new grid.CellRangeEventArgs(g.cells, sel);
                        if (g.onCopying(args)) {
                            var text = g.getClipString() + '\r\n'; // TFS 228046
                            wijmo.Clipboard.copy(text);
                            g.onCopied(args);
                        }
                        e.stopPropagation();
                        return;
                    }
                    // paste: ctrl+v or shift+Insert
                    if ((ctrl && keyCode == 86) || (shift && keyCode == 45)) {
                        if (!g.isReadOnly) {
                            var args_1 = new grid.CellRangeEventArgs(g.cells, sel);
                            if (g.onPasting(args_1)) {
                                wijmo.Clipboard.paste(function (text) {
                                    g.setClipString(text);
                                    g.onPasted(args_1);
                                });
                            }
                        }
                        e.stopPropagation();
                        return;
                    }
                }
                // reverse left/right keys when rendering in right-to-left
                if (g.rightToLeft) {
                    switch (keyCode) {
                        case wijmo.Key.Left:
                            keyCode = wijmo.Key.Right;
                            break;
                        case wijmo.Key.Right:
                            keyCode = wijmo.Key.Left;
                            break;
                    }
                }
                // default key handling 
                // https://www.w3.org/TR/wai-aria-practices-1.1/#grid
                var smv = grid.SelMove, sm = grid.SelectionMode;
                switch (keyCode) {
                    // shift-space: select row
                    // ctrl-space: select column
                    // else start editing, toggle checkboxes
                    case wijmo.Key.Space:
                        if (shift && sel.isValid) {
                            switch (g.selectionMode) {
                                case sm.CellRange:
                                case sm.Row:
                                case sm.RowRange:
                                case sm.ListBox:
                                    g.select(new grid.CellRange(sel.row, 0, sel.row, g.columns.length - 1));
                                    break;
                            }
                        }
                        else if (ctrl && sel.isValid) {
                            switch (g.selectionMode) {
                                case sm.CellRange:
                                    g.select(new grid.CellRange(0, sel.col, g.rows.length - 1, sel.col));
                                    break;
                            }
                        }
                        else {
                            handled = this._startEditing(true, e);
                            if (handled) {
                                setTimeout(function () {
                                    var edt = g.activeEditor;
                                    if (edt) {
                                        if (edt.disabled || edt.readOnly) {
                                            g.finishEditing();
                                        }
                                        else if (edt.type == 'checkbox') {
                                            edt.checked = !edt.checked;
                                            g.finishEditing();
                                        }
                                        else {
                                            wijmo.setSelectionRange(edt, edt.value.length);
                                        }
                                    }
                                });
                            }
                        }
                        break;
                    // ctrl+A: select all
                    case 65:
                        if (ctrl) {
                            switch (g.selectionMode) {
                                case sm.CellRange:
                                case sm.Row:
                                case sm.RowRange:
                                case sm.ListBox:
                                    g.select(new grid.CellRange(0, 0, g.rows.length - 1, g.columns.length - 1));
                                    break;
                            }
                        }
                        else {
                            handled = false;
                        }
                        break;
                    // left/right
                    case wijmo.Key.Left:
                        if (ctrl || e.altKey) {
                            handled = false;
                        }
                        else {
                            if (sel.isValid && sel.col == 0 && gr != null && !gr.isCollapsed && gr.hasChildren) {
                                gr.isCollapsed = true;
                            }
                            else {
                                this._moveSel(smv.None, ctrl ? smv.Home : smv.Prev, shift);
                            }
                        }
                        break;
                    case wijmo.Key.Right:
                        if (ctrl || e.altKey) {
                            handled = false;
                        }
                        else {
                            if (sel.isValid && sel.col == 0 && gr != null && gr.isCollapsed) {
                                gr.isCollapsed = false;
                            }
                            else {
                                this._moveSel(smv.None, ctrl ? smv.End : smv.Next, shift);
                            }
                        }
                        break;
                    // up/down move selection, alt-up/down toggles the listbox
                    case wijmo.Key.Up:
                        if (ctrl) {
                            handled = false;
                        }
                        else {
                            this._altDown = e.altKey;
                            if (e.altKey) {
                                handled = g._edtHdl._toggleListBox(e);
                            }
                            else {
                                this._moveSel(smv.Prev, smv.None, shift);
                            }
                        }
                        break;
                    case wijmo.Key.Down:
                        if (ctrl) {
                            handled = false;
                        }
                        else {
                            this._altDown = e.altKey;
                            if (e.altKey) {
                                handled = g._edtHdl._toggleListBox(e);
                            }
                            else {
                                this._moveSel(smv.Next, smv.None, shift);
                            }
                        }
                        break;
                    // page up/down
                    // +alt for top/bottom (+ctrl is used to switch tabs in Chrome)
                    case wijmo.Key.PageUp:
                        this._altDown = e.altKey;
                        this._moveSel(e.altKey ? smv.Home : smv.PrevPage, smv.None, shift);
                        break;
                    case wijmo.Key.PageDown:
                        this._altDown = e.altKey;
                        this._moveSel(e.altKey ? smv.End : smv.NextPage, smv.None, shift);
                        break;
                    // home/end
                    case wijmo.Key.Home:
                        this._moveSel(ctrl ? smv.Home : smv.None, smv.Home, shift);
                        break;
                    case wijmo.Key.End:
                        this._moveSel(ctrl ? smv.End : smv.None, smv.End, shift);
                        break;
                    // tab
                    case wijmo.Key.Tab:
                        handled = this._performKeyAction(g.keyActionTab, shift);
                        break;
                    // Enter
                    case wijmo.Key.Enter:
                        handled = this._performKeyAction(g.keyActionEnter, shift);
                        if (!shift && ecv && ecv.currentEditItem != null) {
                            g._edtHdl._commitRowEdits();
                        }
                        break;
                    // Escape: cancel edits/row addition
                    case wijmo.Key.Escape:
                        handled = false;
                        if (ecv) {
                            if (ecv.currentAddItem || ecv.currentEditItem) {
                                // fire rowEditEnding/Ended events with cancel set to true
                                // the event handlers can use this to restore deep bindings
                                var ee = new grid.CellRangeEventArgs(g.cells, g.selection);
                                ee.cancel = true;
                                g.onRowEditEnding(ee);
                                if (ecv.currentAddItem) {
                                    ecv.cancelNew();
                                }
                                if (ecv.currentEditItem) {
                                    ecv.cancelEdit();
                                }
                                g.onRowEditEnded(ee);
                                handled = true; // TFS 261795
                            }
                        }
                        g._mouseHdl.resetMouseState();
                        break;
                    // Delete selection
                    // Mac keyboards don't have a Delete key, so honor Back here as well
                    case wijmo.Key.Delete:
                    case wijmo.Key.Back:
                        handled = this._deleteSel(e);
                        break;
                    // F2/F4: editing
                    case wijmo.Key.F2:
                        handled = this._startEditing(true, e);
                        break;
                    case wijmo.Key.F4:
                        handled = g._edtHdl._toggleListBox(e);
                        break;
                    // everything else
                    default:
                        handled = false;
                        break;
                }
                if (handled) {
                    if (!g.containsFocus()) {
                        g.focus(); // http://wijmo.com/topic/angular-2-focus-issue-with-wj-input-number-as-rendering-cell-of-flexgrid/
                    }
                    e.preventDefault();
                    e.stopPropagation();
                }
            };
            // handle a special key according to a KeyAction value
            _KeyboardHandler.prototype._performKeyAction = function (action, shift) {
                var ka = KeyAction, smv = grid.SelMove;
                switch (action) {
                    case ka.MoveDown:
                        this._moveSel(shift ? smv.Prev : smv.Next, smv.None, false);
                        return true;
                    case ka.MoveAcross:
                        this._moveSel(smv.None, shift ? smv.Prev : smv.Next, false);
                        return true;
                    case ka.Cycle:
                        this._moveSel(smv.None, shift ? smv.PrevCell : smv.NextCell, false);
                        return true;
                    case ka.CycleOut:
                        var sel = this._g.selection;
                        this._moveSel(smv.None, shift ? smv.PrevCell : smv.NextCell, false);
                        return !sel.equals(this._g.selection);
                }
                return false;
            };
            // handles the key press event (start editing or try auto-complete)
            _KeyboardHandler.prototype._keypress = function (e) {
                // allow input elements that don't belong to us to handle keys (TFS 131138, 191989)
                var g = this._g;
                if (g._wantsInput(e.target) || e.defaultPrevented) {
                    return;
                }
                // prevent smiley that appears when the user presses alt-down
                if (this._altDown) {
                    e.preventDefault();
                    return;
                }
                // forward key to editor (auto-complete) or handle ourselves
                if (g.activeEditor) {
                    g._edtHdl._keypress(e);
                }
                else if (e.charCode > wijmo.Key.Space) {
                    if (this._startEditing(false, e) && g.activeEditor) {
                        //let edt = g.activeEditor; // grid's built-in editor
                        //if (edt && edt.type != 'checkbox' && edt == getActiveElement()) {
                        var edt = wijmo.getActiveElement(); // any editor (TFS 296961/Firefox)
                        if (edt instanceof HTMLInputElement && edt.type != 'checkbox') {
                            var sel = g._selHdl.selection, txt = g.getCellData(sel.row, sel.col, true), val = g.getCellData(sel.row, sel.col, false);
                            // initialize editor with char typed, preserve percent sign
                            edt.value = String.fromCharCode(e.charCode);
                            if (wijmo.isNumber(val) && txt.indexOf('%') > -1) {
                                edt.value += '%';
                            }
                            // start editing
                            wijmo.setSelectionRange(edt, 1);
                            edt.dispatchEvent(g._edtHdl._evtInput); // to apply mask (TFS 131232)
                            g._edtHdl._keypress(e); // to start auto-complete
                            // we're done with this event
                            e.preventDefault();
                        }
                    }
                }
            };
            // move the selection
            _KeyboardHandler.prototype._moveSel = function (rowMove, colMove, extend) {
                if (this._g.selectionMode != grid.SelectionMode.None) {
                    this._g._selHdl.moveSelection(rowMove, colMove, extend);
                }
            };
            // delete the selected rows
            _KeyboardHandler.prototype._deleteSel = function (evt) {
                var g = this._g, ecv = g.editableCollectionView, sel = g.selection, rows = g.rows, selRows = [], rng = new grid.CellRange(), e = new grid.CellEditEndingEventArgs(g.cells, rng, evt), sm = grid.SelectionMode;
                // if g.allowDelete and ecv.canRemove, and not editing/adding, (TFS 87718)
                // and the grid allows deleting items, then delete selected rows
                if (g.allowDelete && !g.isReadOnly &&
                    (ecv == null || (ecv.canRemove && !ecv.isAddingNew && !ecv.isEditingItem))) {
                    // get selected rows
                    switch (g.selectionMode) {
                        case sm.CellRange:
                            if (sel.leftCol == 0 && sel.rightCol == g.columns.length - 1) {
                                for (var i = sel.topRow; i > -1 && i <= sel.bottomRow; i++) {
                                    selRows.push(rows[i]);
                                }
                            }
                            break;
                        case sm.ListBox:
                            for (var i = 0; i < rows.length; i++) {
                                if (rows[i].isSelected) {
                                    selRows.push(rows[i]);
                                }
                            }
                            break;
                        case sm.Row:
                            if (sel.topRow > -1) {
                                selRows.push(rows[sel.topRow]);
                            }
                            break;
                        case sm.RowRange:
                            for (var i = sel.topRow; i > -1 && i <= sel.bottomRow; i++) {
                                selRows.push(rows[i]);
                            }
                            break;
                    }
                }
                // finish with row deletion
                if (selRows.length > 0) {
                    // begin updates
                    g.deferUpdate(function () {
                        if (ecv)
                            ecv.beginUpdate();
                        // delete selected rows
                        for (var i = selRows.length - 1; i >= 0; i--) {
                            var r = selRows[i];
                            rng.setRange(r.index, -1);
                            if (g.onDeletingRow(e)) {
                                if (ecv && r.dataItem) {
                                    ecv.remove(r.dataItem);
                                }
                                else {
                                    g.rows.removeAt(r.index);
                                }
                                g.onDeletedRow(e);
                            }
                        }
                        // finish updates
                        if (ecv)
                            ecv.endUpdate();
                    });
                    // make sure one row is selected in ListBox mode (TFS 82683)
                    if (g.selectionMode == sm.ListBox) {
                        var index = g.selection.row;
                        if (index > -1 && index < g.rows.length) {
                            g.rows[index].isSelected = true;
                        }
                    }
                    // handle childItemsPath (TFS 87577)
                    if (g.childItemsPath && g.collectionView) {
                        g.collectionView.refresh();
                    }
                    // all done
                    return true;
                }
                // delete cell content (if there is any) (TFS 94178, 228047)
                if (!g.isReadOnly && selRows.length == 0) {
                    // delete selected cells
                    var ecvUpdating_1 = false, sp_1 = g.scrollPosition;
                    g.deferUpdate(function () {
                        // looping through rows
                        for (var sr = sel.topRow; sr <= sel.bottomRow; sr++) {
                            var row = g.rows[sr];
                            if (!row.isReadOnly) {
                                // looping through columns
                                for (var sc = sel.leftCol; sc <= sel.rightCol; sc++) {
                                    var bcol = g._getBindingColumn(g.cells, sr, g.columns[sc]);
                                    if (!bcol.getIsRequired() && !bcol.isReadOnly) {
                                        if (g.getCellData(sr, sc, true)) {
                                            rng.setRange(sr, sc);
                                            e.cancel = false;
                                            if (g.onBeginningEdit(e)) {
                                                if (ecv) {
                                                    if (!ecvUpdating_1) {
                                                        ecvUpdating_1 = true;
                                                        ecv.beginUpdate();
                                                    }
                                                    ecv.editItem(row.dataItem);
                                                    g._edtHdl._edItem = ecv.currentEditItem;
                                                }
                                                g.setCellData(sr, sc, '', true, false); // TFS 118470
                                                g.onCellEditEnding(e);
                                                g.onCellEditEnded(e);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        // restore selection/scroll position
                        g.selection = sel;
                        g.scrollPosition = sp_1;
                        // done updating
                        if (ecvUpdating_1) {
                            ecv.endUpdate();
                        }
                    });
                    // all done
                    return true;
                }
                // no deletion
                return false;
            };
            // start editing and pass the event that caused the edit to start
            _KeyboardHandler.prototype._startEditing = function (fullEdit, evt, r, c) {
                return this._g._edtHdl.startEditing(fullEdit, r, c, true, evt);
            };
            return _KeyboardHandler;
        }());
        grid._KeyboardHandler = _KeyboardHandler;
    })(grid = wijmo.grid || (wijmo.grid = {}));
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    var grid;
    (function (grid) {
        'use strict';
        // allow resizing by dragging regular cells as well as headers
        var _AR_ALLCELLS = 4;
        var _WJC_DRAGSRC = 'wj-state-dragsrc';
        /**
         * Specifies constants that define the row/column sizing behavior.
         */
        var AllowResizing;
        (function (AllowResizing) {
            /** The user may not resize rows or columns. */
            AllowResizing[AllowResizing["None"] = 0] = "None";
            /** The user may resize columns by dragging the edge of the column headers. */
            AllowResizing[AllowResizing["Columns"] = 1] = "Columns";
            /** The user may resize rows by dragging the edge of the row headers. */
            AllowResizing[AllowResizing["Rows"] = 2] = "Rows";
            /** The user may resize rows and columns by dragging the edge of the headers. */
            AllowResizing[AllowResizing["Both"] = 3] = "Both";
            /** The user may resize columns by dragging the edge of any cell. */
            AllowResizing[AllowResizing["ColumnsAllCells"] = AllowResizing.Columns | _AR_ALLCELLS] = "ColumnsAllCells";
            /** The user may resize rows by dragging the edge of any cell. */
            AllowResizing[AllowResizing["RowsAllCells"] = AllowResizing.Rows | _AR_ALLCELLS] = "RowsAllCells";
            /** The user may resize rows and columns by dragging the edge of any cell. */
            AllowResizing[AllowResizing["BothAllCells"] = AllowResizing.Both | _AR_ALLCELLS] = "BothAllCells"; // 7
        })(AllowResizing = grid.AllowResizing || (grid.AllowResizing = {}));
        /**
         * Specifies constants that define the row/column auto-sizing behavior.
         */
        var AutoSizeMode;
        (function (AutoSizeMode) {
            /** Autosizing is disabled. */
            AutoSizeMode[AutoSizeMode["None"] = 0] = "None";
            /** Autosizing accounts for header cells. */
            AutoSizeMode[AutoSizeMode["Headers"] = 1] = "Headers";
            /** Autosizing accounts for data cells. */
            AutoSizeMode[AutoSizeMode["Cells"] = 2] = "Cells";
            /** Autosizing accounts for header and data cells. */
            AutoSizeMode[AutoSizeMode["Both"] = 3] = "Both";
        })(AutoSizeMode = grid.AutoSizeMode || (grid.AutoSizeMode = {}));
        /**
         * Specifies constants that define the row/column dragging behavior.
         */
        var AllowDragging;
        (function (AllowDragging) {
            /** The user may not drag rows or columns. */
            AllowDragging[AllowDragging["None"] = 0] = "None";
            /** The user may drag columns. */
            AllowDragging[AllowDragging["Columns"] = 1] = "Columns";
            /** The user may drag rows. */
            AllowDragging[AllowDragging["Rows"] = 2] = "Rows";
            /** The user may drag rows and columns. */
            AllowDragging[AllowDragging["Both"] = 3] = "Both";
        })(AllowDragging = grid.AllowDragging || (grid.AllowDragging = {}));
        /**
         * Handles the grid's mouse commands.
         */
        var _MouseHandler = /** @class */ (function () {
            /**
             * Initializes a new instance of the @see:_MouseHandler class.
             *
             * @param g @see:FlexGrid that owns this @see:_MouseHandler.
             */
            function _MouseHandler(g) {
                var _this = this;
                this._tsLast = 0;
                var host = g.hostElement;
                this._g = g;
                // create target indicator element
                this._dvMarker = wijmo.createElement('<div class="wj-marker">&nbsp;</div>');
                // mouse events:
                // when the user presses the mouse on the control, hook up handlers to 
                // mouse move/up on the *document*, and unhook on mouse up.
                // this simulates a mouse capture (nice idea from ngGrid).
                // note: use 'document' since 'window' doesn't work on Android.
                g.addEventListener(host, 'mousedown', function (e) {
                    // to make sure hit testing has up-to-date info
                    g._rcBounds = null;
                    // start actions on left button only: TFS 114623
                    if (!e.defaultPrevented && e.button == 0) {
                        // get the focus now, without scrolling (TFS 261336, 275042, 275694, 271845, 289442)
                        var target = e.target;
                        if (!g.containsFocus()) {
                            var eFocus = target instanceof HTMLElement && target.tabIndex > -1 ? target : g._eFocus;
                            g._setFocusNoScroll(eFocus);
                        }
                        // and make sure the grid gets the focus at some point
                        // (in case the target element is not focusable, happens in Chrome)
                        // (TFS 81949, 102177, 120430, 265730, 265207, 267167)
                        setTimeout(function () {
                            if (!e.defaultPrevented) {
                                g.focus();
                            }
                        });
                        // check whether the target belongs to another nested grid: TFS 200695
                        var pGrid = wijmo.closest(e.target, '.wj-flexgrid');
                        // allow input elements that don't belong to us to handle the mouse
                        // but select the cell anyway, or scroll it into view if it's a header
                        if (pGrid != g.hostElement || (!g.activeEditor && g._isInputElement(target))) {
                            // if the target already has the focus or is an option button, skip
                            //if (getActiveElement() == target || target.tagName == 'OPTION') {
                            //    return;
                            //}
                            // select/scroll to show the focused element
                            var ht = g.hitTest(e);
                            switch (ht.cellType) {
                                case grid.CellType.Cell:
                                    g.select(ht.range);
                                    break;
                                case grid.CellType.ColumnHeader:
                                case grid.CellType.ColumnFooter:
                                    g.scrollIntoView(-1, ht.col);
                                    break;
                                case grid.CellType.RowHeader:
                                    g.scrollIntoView(ht.row, -1);
                                    break;
                            }
                            // let the target handle the event
                            return;
                        }
                        // the event belongs to us, let's handle it
                        //if (!this._isDown) { // IE11/Win7 may not fire mouseup on scrollbars (TFS 299308)
                        // sanity
                        g.removeEventListener(document, 'mousemove');
                        g.removeEventListener(document, 'mouseup');
                        // connect
                        g.addEventListener(document, 'mousemove', mouseMove);
                        g.addEventListener(document, 'mouseup', mouseUp);
                        // mouse is down
                        _this._isDown = true;
                        _this._mousedown(e);
                    }
                });
                var mouseMove = function (e) {
                    _this._mousemove(e);
                };
                var mouseUp = function (e) {
                    _this._isDown = false;
                    g.removeEventListener(document, 'mousemove');
                    g.removeEventListener(document, 'mouseup');
                    _this._mouseup(e);
                };
                // remember time of last mouse up (TFS 286845)
                g.addEventListener(host, 'mouseup', function (e) {
                    _this._tsLast = Date.now();
                });
                // make sure hit testing has up-to-date info (TFS 293738)
                g.addEventListener(host, 'mouseenter', function (e) {
                    g._rcBounds = null;
                });
                // offer to resize on mousemove (pressing the button not required)
                g.addEventListener(host, 'mousemove', this._hover.bind(this));
                // handle double-click to auto-size rows/columns
                g.addEventListener(host, 'dblclick', this._dblclick.bind(this));
                // handle click events (in an accessible way)
                g.addEventListener(host, 'click', this._click.bind(this));
                // prevent user from selecting grid content (as text)
                g.addEventListener(host, 'selectstart', function (e) {
                    if (!g._isInputElement(e.target)) {
                        e.preventDefault();
                    }
                });
                // custom handling for wheel events (TFS 250507)
                g.addEventListener(host, 'wheel', function (e) {
                    var root = g.cells.hostElement.parentElement, delta = e.deltaY;
                    if (delta && !e.ctrlKey && !e.metaKey && root.scrollHeight > root.offsetHeight) {
                        if (wijmo.closest(e.target, '.wj-flexgrid') == g.hostElement) {
                            switch (e.deltaMode) {
                                case 1:// by line
                                    root.scrollTop += g.rows.defaultSize * (delta < 0 ? -1 : +1);
                                    break;
                                case 2:// by page
                                    root.scrollTop += root.clientHeight * (delta < 0 ? -1 : +1);
                                    break;
                                case 0: // by pixel
                                default:
                                    if (wijmo.isSafari()) {
                                        delta = wijmo.clamp(delta, -150, 150); // limit delta on Mac/Safari
                                        //delta /= 2; // ?
                                    }
                                    root.scrollTop += delta;
                                    break;
                            }
                            e.preventDefault();
                            e.stopImmediatePropagation();
                        }
                    }
                });
                // row and column dragging
                g.addEventListener(host, 'dragstart', this._dragstart.bind(this));
                g.addEventListener(host, 'dragover', this._dragover.bind(this));
                g.addEventListener(host, 'dragleave', this._dragover.bind(this));
                g.addEventListener(host, 'drop', this._drop.bind(this));
                g.addEventListener(host, 'dragend', this._dragend.bind(this));
                // touch resizing
                this._enableTouchResizing();
            }
            /**
             * Resets the mouse state.
             */
            _MouseHandler.prototype.resetMouseState = function () {
                // because dragEnd fires too late in Firefox...
                if (this._dragSource) {
                    wijmo.removeClass(this._dragSource, _WJC_DRAGSRC);
                }
                this._showDragMarker(null);
                // reset cursor state (if the grid hasn't been disposed)
                var host = this._g.hostElement;
                if (host) {
                    host.style.cursor = '';
                }
                // remove event listeners just in case
                var g = this._g;
                g.removeEventListener(document, 'mousemove');
                g.removeEventListener(document, 'mouseup');
                // remember time of last mouse event
                this._tsLast = Date.now();
                // reset everything else
                this._eMouse = null;
                this._isDown = null;
                this._htDown = null;
                this._lbSelRows = null;
                this._szRowCol = null;
                this._szArgs = null;
                this._dragSource = null;
            };
            // enable row/columm resizing on touch devices
            _MouseHandler.prototype._enableTouchResizing = function () {
                var _this = this;
                var g = this._g, host = g.hostElement, touchEvents = 'ontouchstart' in window ? ['touchstart', 'touchmove', 'touchend'] :
                    'onpointerdown' in window ? ['pointerdown', 'pointermove', 'pointerup'] :
                        null;
                if (touchEvents) {
                    g.addEventListener(host, touchEvents[0], function (e) {
                        if (e.pointerType == null || e.pointerType == 'touch') {
                            if (!wijmo.closest(e.target, '.wj-elem-filter')) {
                                var cell = wijmo.closest(e.target, '.wj-cell');
                                if (cell instanceof HTMLElement) {
                                    g._rcBounds = null;
                                    _this._htDown = null;
                                    _this._hover(e);
                                    if (_this._szRowCol) {
                                        // required in IE/Edge:
                                        cell.removeAttribute('draggable');
                                        host.style.touchAction = 'none';
                                        _this._mousedown(e);
                                        e.preventDefault();
                                    }
                                }
                            }
                        }
                    });
                    g.addEventListener(host, touchEvents[1], function (e) {
                        if (e.pointerType == null || e.pointerType == 'touch') {
                            if (_this._szRowCol) {
                                _this._mousemove(e);
                                e.preventDefault();
                            }
                        }
                    });
                    g.addEventListener(host, touchEvents[2], function (e) {
                        wijmo.Control._touching = false;
                        if (e.pointerType == null || e.pointerType == 'touch') {
                            if (_this._szRowCol) {
                                // finish resizing or raise click event to select (TFS 292033)
                                if (_this._szArgs) {
                                    _this._finishResizing(_this._eMouse);
                                }
                                else {
                                    var cell = wijmo.closest(e.target, '.wj-cell');
                                    if (cell instanceof HTMLElement) {
                                        cell.click();
                                    }
                                }
                                // done with the mouse
                                _this.resetMouseState();
                                host.style.touchAction = '';
                            }
                        }
                    });
                }
            };
            // handles the mouse down event
            _MouseHandler.prototype._mousedown = function (e) {
                // get the element under the mouse
                var g = this._g, ht = g.hitTest(e), ct = ht.cellType, ctrlKey = e.ctrlKey || e.metaKey;
                // remember selection when mouse went down
                this._selDown = g.selection;
                // clicking on the cells panel
                if (ht.panel == g.cells) {
                    // handle drop-down items (even on editors, TFS 266120)
                    if (wijmo.closestClass(e.target, grid.CellFactory._WJC_DROPDOWN)) {
                        g._edtHdl._toggleListBox(e, ht.range);
                        e.preventDefault();
                        return;
                    }
                    // if the user clicked an active editor, let the editor handle things
                    if (g.editRange && g.editRange.contains(ht.range)) {
                        return;
                    }
                }
                // ignore clicks on focused input elements (TFS 135271)
                var ae = wijmo.getActiveElement();
                if (e.target == ae && g._isInputElement(e.target)) {
                    return;
                }
                // ignore clicks on unknown areas
                if (ct == grid.CellType.None) {
                    g._edtHdl._commitRowEdits(); // TFS 229996
                    return;
                }
                // check where the mouse is
                this._htDown = ht;
                this._eMouse = e;
                // handle resizing
                if (this._szRowCol != null) {
                    if (ae != g._eFocus) {
                        g._eFocus.tabIndex = 0; // TFS 284222
                        g._eFocus.focus();
                    }
                    this._handleResizing(e);
                    return;
                }
                // starting cell selection? special handling for ListBox mode
                switch (ct) {
                    case grid.CellType.Cell:
                        if (ctrlKey && g.selectionMode == grid.SelectionMode.ListBox) {
                            this._startListBoxSelection(ht.row);
                        }
                        this._mouseSelect(e, e.shiftKey);
                        break;
                    case grid.CellType.RowHeader:
                        if ((this._g.allowDragging & AllowDragging.Rows) == 0) {
                            if (ctrlKey && g.selectionMode == grid.SelectionMode.ListBox) {
                                this._startListBoxSelection(ht.row);
                            }
                            this._mouseSelect(e, e.shiftKey);
                        }
                        break;
                }
                // handle collapse/expand (after selecting the cell)
                if (ct == grid.CellType.Cell && g.rows.maxGroupLevel > -1) {
                    if (wijmo.closestClass(e.target, grid.CellFactory._WJC_COLLAPSE)) {
                        var gr = wijmo.tryCast(g.rows[ht.row], grid.GroupRow);
                        if (gr) {
                            if (ctrlKey) {
                                g.collapseGroupsToLevel(gr.isCollapsed ? gr.level + 1 : gr.level);
                            }
                            else {
                                gr.isCollapsed = !gr.isCollapsed;
                            }
                            this.resetMouseState();
                            return;
                        }
                    }
                }
            };
            // handles the mouse move event
            _MouseHandler.prototype._mousemove = function (e) {
                if (this._htDown != null) {
                    // in case we lost the focus or the button (TFS 145149)
                    // note that e.buttons is not supported in Safari, and
                    // e.which only works correctly (like e.buttons) in Chrome.
                    if (e.buttons == 0) {
                        //console.log('lost the mouse?');
                        if (this._eMouse && (e.timeStamp - this._eMouse.timeStamp > 600)) {
                            //console.log('yes, resetting...: ' + (e.timeStamp - this._eMouse.timeStamp));
                            this.resetMouseState();
                            return;
                        }
                    }
                    // handle the event as usual
                    this._eMouse = e;
                    if (this._szRowCol) {
                        this._handleResizing(e);
                    }
                    else {
                        switch (this._htDown.cellType) {
                            case grid.CellType.Cell:
                                this._mouseSelect(e, true);
                                break;
                            case grid.CellType.RowHeader:
                                if ((this._g.allowDragging & AllowDragging.Rows) == 0) {
                                    this._mouseSelect(e, true);
                                }
                                break;
                        }
                    }
                }
            };
            // handles the mouse up event
            _MouseHandler.prototype._mouseup = function (e) {
                // IE raises mouseup while touch-dragging...???
                if (this._g.isTouching) {
                    if (this._dragSource || e.target instanceof HTMLHtmlElement) {
                        return;
                    }
                }
                // select all cells, finish resizing, sorting
                var g = this._g, ht = g.hitTest(e), htd = this._htDown, sm = grid.SelectionMode;
                if (htd && !e.defaultPrevented) {
                    // finish resizing
                    if (this._szArgs) {
                        this._finishResizing(e);
                    }
                    else if (htd.panel == g.topLeftCells && !this._szArgs) {
                        if (ht.panel == htd.panel && ht.row == htd.row && ht.col == htd.col) {
                            if (g.rows.length && g.columns.length) {
                                switch (g.selectionMode) {
                                    case sm.CellRange:
                                    case sm.RowRange:
                                    case sm.ListBox:
                                        g.select(new grid.CellRange(0, 0, g.rows.length - 1, g.columns.length - 1));
                                        break;
                                }
                            }
                        }
                    }
                    else if (htd.panel == g.columnHeaders && !e['dataTransfer']) {
                        if (ht.panel == htd.panel && ht.col == htd.col && !ht.edgeRight && ht.col > -1) {
                            this._clickSort(e, ht);
                        }
                    }
                    else if (htd.panel == g.cells) {
                        if (!e.ctrlKey && !e.metaKey && !e.shiftKey) {
                            if (ht.panel == htd.panel && ht.range.equals(htd.range)) {
                                if (g.selection.equals(this._selDown)) {
                                    g._edtHdl.startEditing(true, ht.row, ht.col, true, e);
                                }
                            }
                        }
                    }
                }
                // done with the mouse
                this.resetMouseState();
            };
            // handle automation-style click events
            // we assume the event is automation-style (el.click()) if:
            // 1) The interval between the click and the previous mouse event is > 50ms
            // 2) The event is not an IE touch-click (pointerType == '')
            _MouseHandler.prototype._click = function (e) {
                if (Date.now() - this._tsLast > 50 && !e['pointerType']) {
                    this._handleClick(e);
                }
            };
            _MouseHandler.prototype._handleClick = function (e) {
                var g = this._g, target = e.target, ht = new grid.HitTestInfo(target, null);
                if (!e.defaultPrevented && ht.grid == g && !g._isInputElement(target)) {
                    // clicking on top-left panel to select the whole grid
                    if (ht.panel == g.topLeftCells) {
                        g.select(new grid.CellRange(0, 0, g.rows.length - 1, g.columns.length - 1));
                    }
                    else if (ht.panel == g.columnHeaders) {
                        this._clickSort(e, ht);
                    }
                    else if (ht.panel == g.rowHeaders) {
                        g.select(new grid.CellRange(ht.row, 0, ht.row, g.columns.length - 1));
                    }
                    else if (ht.panel == g.cells) {
                        // sort by clicking hidden header row
                        if (ht.row < 0) {
                            this._clickSort(e, ht);
                        }
                        else if (wijmo.closestClass(target, grid.CellFactory._WJC_COLLAPSE)) {
                            var gr = g.rows[ht.row];
                            if (gr instanceof wijmo.grid.GroupRow) {
                                if (e.ctrlKey) {
                                    g.collapseGroupsToLevel(gr.isCollapsed ? gr.level + 1 : gr.level);
                                }
                                else {
                                    gr.isCollapsed = !gr.isCollapsed;
                                }
                            }
                        }
                        else if (wijmo.closestClass(target, grid.CellFactory._WJC_DROPDOWN)) {
                            g._edtHdl._toggleListBox(e, ht.range);
                        }
                        else {
                            g.select(ht.range);
                        }
                    }
                }
            };
            // flips the sort order when a column header is clicked
            _MouseHandler.prototype._clickSort = function (e, ht) {
                var g = this._g, cv = g.collectionView, ctrlKey = e.ctrlKey || e.metaKey;
                // check that the grid and collectionView support sorting
                if (!cv || !cv.canSort || !g.allowSorting) {
                    return;
                }
                // get row and column to sort
                // row < 0 indicates the hidden column header cells
                var row = ht.range.bottomRow, col = ht.panel.columns[ht.col], bcol = g._getBindingColumn(ht.panel, ht.row, col), bindingSort = bcol ? bcol._getBindingSort() : null;
                //if ((row > -1 && row != g._getSortRowIndex()) && col == bcol) { TFS 301159
                //    return;
                //}
                // check that the column can be sorted
                if (!bcol.allowSorting || !bindingSort) {
                    return;
                }
                // get current sort order
                var sds = ht.grid.collectionView.sortDescriptions, asc = null;
                for (var i = 0; i < sds.length; i++) {
                    if (sds[i].property == bindingSort) {
                        asc = !sds[i].ascending;
                        break;
                    }
                }
                // no current sort
                if (asc == null) {
                    // can't remove sort from unsorted column
                    if (ctrlKey) {
                        return;
                    }
                    // default sort is ascending
                    asc = true;
                }
                // sort the column
                var args = new grid.CellRangeEventArgs(ht.panel, ht.range);
                if (g.onSortingColumn(args)) {
                    // commit pending edits or the sort won't work...
                    g._edtHdl._commitRowEdits();
                    // collapse the selection (or not? TFS 280208)
                    //let sel = g.selection;
                    //sel.row2 = sel.row;
                    //g.select(sel, false);
                    // apply the sort
                    if (ctrlKey) {
                        sds.clear();
                    }
                    else {
                        sds.splice(0, sds.length, new wijmo.collections.SortDescription(bindingSort, asc));
                    }
                    // all done!
                    g.onSortedColumn(args);
                }
            };
            // handles double-clicks
            _MouseHandler.prototype._dblclick = function (e) {
                var g = this._g, ht = g.hitTest(e), ct = ht.cellType, sel = g.selection, rng = ht.range, args;
                // ignore if already handled
                if (e.defaultPrevented) {
                    return;
                }
                // auto-size columns
                if (ht.edgeRight && (g.allowResizing & AllowResizing.Columns)) {
                    if (ct == grid.CellType.ColumnHeader || (ct == grid.CellType.Cell && (g.allowResizing & _AR_ALLCELLS))) {
                        e.preventDefault();
                        if (e.ctrlKey && sel.containsColumn(ht.col)) {
                            rng = sel;
                        }
                        for (var c = rng.leftCol; c <= rng.rightCol; c++) {
                            if (g.columns[c].allowResizing) {
                                args = new grid.CellRangeEventArgs(g.cells, new grid.CellRange(-1, c));
                                if (g.onAutoSizingColumn(args) && g.onResizingColumn(args)) {
                                    g.autoSizeColumn(c);
                                    g.onResizedColumn(args);
                                    g.onAutoSizedColumn(args);
                                }
                            }
                        }
                    }
                    else if (ct == grid.CellType.TopLeft) {
                        if (ht.panel.columns[ht.col].allowResizing) {
                            e.preventDefault();
                            args = new grid.CellRangeEventArgs(ht.panel, new grid.CellRange(-1, ht.col));
                            if (g.onAutoSizingColumn(args) && g.onResizingColumn(args)) {
                                g.autoSizeColumn(ht.col, true);
                                g.onAutoSizedColumn(args);
                                g.onResizedColumn(args);
                            }
                        }
                    }
                    this.resetMouseState();
                    return;
                }
                // auto-size rows
                if (ht.edgeBottom && (g.allowResizing & AllowResizing.Rows)) {
                    if (ct == grid.CellType.RowHeader || (ct == grid.CellType.Cell && (g.allowResizing & _AR_ALLCELLS))) {
                        if (e.ctrlKey && sel.containsRow(ht.row)) {
                            rng = sel;
                        }
                        for (var r = rng.topRow; r <= rng.bottomRow; r++) {
                            if (g.rows[r].allowResizing) {
                                args = new grid.CellRangeEventArgs(g.cells, new grid.CellRange(r, -1));
                                if (g.onAutoSizingRow(args) && g.onResizingRow(args)) {
                                    g.autoSizeRow(r);
                                    g.onResizedRow(args);
                                    g.onAutoSizedRow(args);
                                }
                            }
                        }
                    }
                    else if (ct == grid.CellType.TopLeft) {
                        if (ht.panel.rows[ht.row].allowResizing) {
                            args = new grid.CellRangeEventArgs(ht.panel, new grid.CellRange(ht.row, -1));
                            if (g.onAutoSizingRow(args) && g.onResizingRow(args)) {
                                g.autoSizeRow(ht.row, true);
                                g.onResizedRow(args);
                                g.onAutoSizedRow(args);
                            }
                        }
                    }
                    this.resetMouseState();
                    return;
                }
            };
            // offer to resize rows/columns
            _MouseHandler.prototype._hover = function (e) {
                // make sure we're hovering
                if (this._htDown == null) {
                    var g = this._g, ht = g.hitTest(e), p = ht.panel, ct = ht.cellType, cursor = '';
                    // find which row/column is being resized
                    this._szRowCol = null;
                    if (ct == grid.CellType.ColumnHeader || ct == grid.CellType.TopLeft || (ct == grid.CellType.Cell && (g.allowResizing & _AR_ALLCELLS))) {
                        if (ht.edgeRight && (g.allowResizing & AllowResizing.Columns) != 0) {
                            this._szRowCol = this._getResizeCol(ht);
                        }
                    }
                    if (ct == grid.CellType.RowHeader || ct == grid.CellType.TopLeft || (ct == grid.CellType.Cell && (g.allowResizing & _AR_ALLCELLS))) {
                        if (ht.edgeBottom && (g.allowResizing & AllowResizing.Rows) != 0) {
                            this._szRowCol = this._getResizeRow(ht);
                        }
                    }
                    // keep track of element to resize and original size
                    if (this._szRowCol instanceof grid.Column) {
                        cursor = 'col-resize';
                    }
                    else if (this._szRowCol instanceof grid.Row) {
                        cursor = 'row-resize';
                    }
                    this._szStart = this._szRowCol ? this._szRowCol.renderSize : 0;
                    // update the cursor to provide user feedback
                    g.hostElement.style.cursor = cursor;
                    // done
                    return ht;
                }
                // no hit-test
                return null;
            };
            _MouseHandler.prototype._getResizeCol = function (ht) {
                // start with the column under the mouse
                var cols = ht.panel.columns, col = cols[ht.col];
                // if the next column in the panel is visible but collapsed, switch
                for (var c = ht.col + 1; c < cols.length; c++) {
                    var newCol = cols[c];
                    if (newCol.visible) {
                        if (newCol.size < 1) {
                            col = newCol;
                        }
                        break;
                    }
                }
                // if this is the last column on a fixed panel, and the first
                // column on the cells panel is visible but collapsed, switch
                if (ht.col == cols.length - 1) {
                    if (ht.cellType == grid.CellType.TopLeft || ht.cellType == grid.CellType.RowHeader) {
                        cols = this._g.columns;
                        for (var c = 0; c < cols.length; c++) {
                            var newCol = cols[c];
                            if (newCol.visible) {
                                if (newCol.size < 1) {
                                    col = newCol;
                                }
                                break;
                            }
                        }
                    }
                }
                // return the column we got
                return col.allowResizing ? col : null;
            };
            _MouseHandler.prototype._getResizeRow = function (ht) {
                // start with the row under the mouse
                var rows = ht.panel.rows, row = rows[ht.row];
                // if the next row in the panel is visible but collapsed, switch
                for (var r = ht.row + 1; r < rows.length; r++) {
                    var newRow = rows[r];
                    if (newRow.visible) {
                        if (newRow.size < 1) {
                            row = newRow;
                        }
                        break;
                    }
                }
                // if this is the last row on a fixed panel, and the first
                // row on the cells panel is visible but collapsed, switch
                if (ht.row == rows.length - 1) {
                    if (ht.cellType == grid.CellType.TopLeft || ht.cellType == grid.CellType.ColumnHeader) {
                        rows = this._g.rows;
                        for (var r = 0; r < rows.length; r++) {
                            var newRow = rows[r];
                            if (newRow.visible) {
                                if (newRow.size < 1) {
                                    row = newRow;
                                }
                                break;
                            }
                        }
                    }
                }
                // return the column we got
                return row.allowResizing ? row : null;
            };
            // handles mouse moves while the button is pressed on the cell area
            _MouseHandler.prototype._mouseSelect = function (e, extend) {
                var _this = this;
                var g = this._g;
                if (this._htDown && this._htDown.panel && g.selectionMode != grid.SelectionMode.None) {
                    // handle the selection
                    var ht = new grid.HitTestInfo(this._htDown.panel, e);
                    this._handleSelection(ht, extend);
                    // keep calling this if the user keeps the mouse outside the control without moving it
                    // but don't do this in IE9, it can keep scrolling forever... TFS 110374
                    // NOTE: doesn't seem to be an issue anymore, but keep the check just in case.
                    if (!wijmo.isIE9() && e.button >= 0 && e.target != g._root) {
                        ht = new grid.HitTestInfo(g, e);
                        if (ht.cellType != grid.CellType.Cell && ht.cellType != grid.CellType.RowHeader) {
                            setTimeout(function () {
                                _this._mouseSelect(_this._eMouse, extend);
                            }, 100);
                        }
                    }
                }
            };
            // handles row and column resizing
            _MouseHandler.prototype._handleResizing = function (e) {
                // prevent browser from selecting cell content
                e.preventDefault();
                // resizing column
                if (this._szRowCol instanceof grid.Column) {
                    var g = this._g, pageX = wijmo.mouseToPage(e).x, // to support touch
                    sz = Math.round(Math.max(_MouseHandler._SZ_MIN, this._szStart + (pageX - this._htDown.point.x) * (g.rightToLeft ? -1 : 1)));
                    if (this._szRowCol.renderSize != sz) {
                        if (this._szArgs == null) {
                            var panel = g.rowHeaders.columns.indexOf(this._szRowCol) > -1 ? g.rowHeaders : g.cells;
                            this._szArgs = new grid.CellRangeEventArgs(panel, new grid.CellRange(-1, this._szRowCol.index));
                        }
                        this._szArgs.cancel = false;
                        if (g.onResizingColumn(this._szArgs)) {
                            if (g.deferResizing) {
                                this._showResizeMarker(sz);
                            }
                            else {
                                this._szRowCol.width = sz;
                            }
                        }
                    }
                }
                // resizing row
                if (this._szRowCol instanceof grid.Row) {
                    var g = this._g, pageY = wijmo.mouseToPage(e).y, // to support touch
                    sz = Math.round(Math.max(_MouseHandler._SZ_MIN, this._szStart + (pageY - this._htDown.point.y)));
                    if (this._szRowCol.renderSize != sz) {
                        if (this._szArgs == null) {
                            var panel = g.columnHeaders.rows.indexOf(this._szRowCol) > -1 ? g.columnHeaders : g.cells;
                            this._szArgs = new grid.CellRangeEventArgs(panel, new grid.CellRange(this._szRowCol.index, -1));
                        }
                        this._szArgs.cancel = false;
                        if (g.onResizingRow(this._szArgs)) {
                            if (g.deferResizing) {
                                this._showResizeMarker(sz);
                            }
                            else {
                                this._szRowCol.height = sz;
                            }
                        }
                    }
                }
            };
            // handles row and column dragging
            _MouseHandler.prototype._dragstart = function (e) {
                var g = this._g, ht = this._htDown;
                // make sure this is event is ours
                if (!ht) {
                    return;
                }
                // get drag source element (if we're not resizing)
                this._dragSource = null;
                if (!this._szRowCol) {
                    var args = new grid.CellRangeEventArgs(ht.panel, ht.range);
                    if (ht.cellType == grid.CellType.ColumnHeader && (g.allowDragging & AllowDragging.Columns) &&
                        ht.col > -1 && g.columns[ht.col].allowDragging) {
                        if (g.onDraggingColumn(args)) {
                            this._dragSource = e.target;
                        }
                        else {
                            e.preventDefault(); // TFS 241962
                        }
                    }
                    else if (ht.cellType == grid.CellType.RowHeader && (g.allowDragging & AllowDragging.Rows) &&
                        ht.row > -1 && g.rows[ht.row].allowDragging) {
                        var row = g.rows[ht.row];
                        if (!(row instanceof grid.GroupRow) && !(row instanceof grid._NewRowTemplate)) {
                            if (g.onDraggingRow(args)) {
                                this._dragSource = e.target;
                            }
                            else {
                                e.preventDefault(); // TFS 241962
                            }
                        }
                    }
                }
                // if we have a valid source, start dragging and stop propagation
                if (this._dragSource && e.dataTransfer && !e.defaultPrevented) {
                    // start dragging and stop propagation (TFS 120810)
                    wijmo._startDrag(e.dataTransfer, 'move');
                    e.stopPropagation();
                    // style source element
                    wijmo.addClass(this._dragSource, _WJC_DRAGSRC);
                    // suspend updates while dragging
                    g.beginUpdate();
                    this._updating = true;
                }
            };
            _MouseHandler.prototype._dragend = function (e) {
                // restore updates after dragging
                if (this._updating) {
                    this._g.endUpdate();
                    this._updating = false;
                }
                // always reset the mouse state
                this.resetMouseState();
            };
            _MouseHandler.prototype._dragover = function (e) {
                var g = this._g, ht = g.hitTest(e), valid = false;
                // check whether the move is valid
                var args = new grid.CellRangeEventArgs(g.cells, ht.range);
                if (this._htDown && ht.cellType == this._htDown.cellType) {
                    if (ht.cellType == grid.CellType.ColumnHeader) {
                        args.cancel = !g.columns.canMoveElement(this._htDown.col, ht.col);
                        valid = g.onDraggingColumnOver(args);
                    }
                    else if (ht.cellType == grid.CellType.RowHeader) {
                        args.cancel = !g.rows.canMoveElement(this._htDown.row, ht.row);
                        valid = g.onDraggingRowOver(args);
                    }
                }
                // if valid, prevent default to allow drop
                if (valid) {
                    e.dataTransfer.dropEffect = 'move';
                    this._showDragMarker(ht);
                    e.preventDefault();
                    e.stopPropagation(); // prevent scrolling on Android
                }
                else {
                    this._showDragMarker(null);
                }
            };
            _MouseHandler.prototype._drop = function (e) {
                var g = this._g, ht = g.hitTest(e);
                // move the row/col to a new position
                if (this._htDown && ht.cellType == this._htDown.cellType) {
                    var sel = g.selection, args = new grid.CellRangeEventArgs(g.cells, ht.range, this._htDown);
                    if (ht.cellType == grid.CellType.ColumnHeader) {
                        g.columns.moveElement(this._htDown.col, ht.col);
                        g.select(sel.row, ht.col);
                        g.onDraggedColumn(args);
                    }
                    else if (ht.cellType == grid.CellType.RowHeader) {
                        g.rows.moveElement(this._htDown.row, ht.row);
                        g.select(ht.row, sel.col);
                        g.onDraggedRow(args);
                    }
                }
                this.resetMouseState();
            };
            // updates the marker to show the new size of the row/col being resized
            _MouseHandler.prototype._showResizeMarker = function (sz) {
                var g = this._g;
                // add marker element to panel
                var t = this._dvMarker, host = g.cells.hostElement;
                if (t.parentElement != host) {
                    host.appendChild(t);
                }
                // update marker position
                var ct = this._szArgs.panel.cellType, css;
                if (this._szRowCol instanceof grid.Column) {
                    css = {
                        left: this._szRowCol.pos + sz - 1,
                        top: -1000,
                        right: '',
                        bottom: 0,
                        width: 3,
                        height: ''
                    };
                    if (g.rightToLeft) {
                        css.left = host.clientWidth - css.left - css.width;
                    }
                    if (ct == grid.CellType.TopLeft || ct == grid.CellType.RowHeader) {
                        css.left -= g.topLeftCells.hostElement.offsetWidth;
                    }
                }
                else {
                    css = {
                        left: -1000,
                        top: this._szRowCol.pos + sz - 1,
                        right: 0,
                        bottom: '',
                        width: '',
                        height: 3,
                    };
                    if (ct == grid.CellType.TopLeft || ct == grid.CellType.ColumnHeader) {
                        css.top -= g.topLeftCells.hostElement.offsetHeight;
                    }
                }
                // apply new position
                wijmo.setCss(t, css);
            };
            // updates the marker to show the position where the row/col will be inserted
            _MouseHandler.prototype._showDragMarker = function (ht) {
                var g = this._g;
                // remove target indicator if no HitTestInfo
                var t = this._dvMarker;
                if (!ht || !ht.panel) {
                    wijmo.removeChild(t);
                    this._rngTarget = null;
                    return;
                }
                // avoid work/flicker
                if (ht.range.equals(this._rngTarget)) {
                    return;
                }
                this._rngTarget = ht.range;
                // add marker element to panel
                var host = ht.panel.hostElement;
                if (t.parentElement != host) {
                    host.appendChild(t);
                }
                // update marker position
                var css = {
                    left: 0,
                    top: 0,
                    width: 6,
                    height: 6,
                    right: '',
                    bottom: ''
                };
                switch (ht.cellType) {
                    case grid.CellType.ColumnHeader:
                        css.height = ht.panel.height;
                        var col = g.columns[ht.col];
                        css.left = col.pos - css.width / 2;
                        if (ht.col > this._htDown.col) {
                            css.left += col.renderWidth;
                        }
                        if (g.rightToLeft) {
                            css.left = t.parentElement.clientWidth - css.left - css.width;
                        }
                        break;
                    case grid.CellType.RowHeader:
                        css.width = ht.panel.width;
                        var row = g.rows[ht.row];
                        css.top = row.pos - css.height / 2;
                        if (ht.row > this._htDown.row) {
                            css.top += row.renderHeight;
                        }
                        break;
                }
                // update marker
                wijmo.setCss(t, css);
            };
            // raises the ResizedRow/Column events and 
            // applies the new size to the selection if the control key is pressed
            _MouseHandler.prototype._finishResizing = function (e) {
                var g = this._g, sel = g.selection, args = this._szArgs, ctrl = this._eMouse && this._eMouse.ctrlKey; // TFS 290725
                if (args && !args.cancel) {
                    // finish column sizing
                    if (args.col > -1) {
                        // apply new size, fire event
                        var rc = args.col, pageX = wijmo.mouseToPage(e).x, sz = Math.round(Math.max(_MouseHandler._SZ_MIN, this._szStart + (pageX - this._htDown.point.x) * (this._g.rightToLeft ? -1 : 1)));
                        args.panel.columns[rc].width = Math.round(sz);
                        g.onResizedColumn(args);
                        // apply new size to selection if the control key is pressed
                        if (ctrl && this._htDown.cellType == grid.CellType.ColumnHeader && sel.containsColumn(rc)) {
                            for (var c = sel.leftCol; c <= sel.rightCol; c++) {
                                if (g.columns[c].allowResizing && c != rc) {
                                    args = new grid.CellRangeEventArgs(g.cells, new grid.CellRange(-1, c));
                                    if (g.onResizingColumn(args)) {
                                        g.columns[c].size = g.columns[rc].size;
                                        g.onResizedColumn(args);
                                    }
                                }
                            }
                        }
                    }
                    // finish row sizing
                    if (args.row > -1) {
                        // apply new size, fire event
                        var rc = args.row, pageY = wijmo.mouseToPage(e).y, sz = Math.round(Math.max(_MouseHandler._SZ_MIN, this._szStart + (pageY - this._htDown.point.y)));
                        args.panel.rows[rc].height = Math.round(sz);
                        g.onResizedRow(args);
                        // apply new size to selection if the control key is pressed
                        if (ctrl && this._htDown.cellType == grid.CellType.RowHeader && sel.containsRow(rc)) {
                            for (var r = sel.topRow; r <= sel.bottomRow; r++) {
                                if (g.rows[r].allowResizing && r != rc) {
                                    args = new grid.CellRangeEventArgs(g.cells, new grid.CellRange(r, -1));
                                    if (g.onResizingRow(args)) {
                                        g.rows[r].size = g.rows[rc].size;
                                        g.onResizedRow(args);
                                    }
                                }
                            }
                        }
                    }
                }
            };
            // starts ListBox selection by keeping track of which rows were selected 
            // when the action started
            _MouseHandler.prototype._startListBoxSelection = function (row) {
                var rows = this._g.rows;
                this._lbSelState = !rows[row].isSelected;
                this._lbSelRows = {};
                for (var r = 0; r < rows.length; r++) {
                    if (rows[r].isSelected) {
                        this._lbSelRows[r] = true;
                    }
                }
            };
            // handles mouse selection
            _MouseHandler.prototype._handleSelection = function (ht, extend) {
                var g = this._g, rows = g.rows, sel = g._selHdl.selection, rng = new grid.CellRange(ht.row, ht.col);
                // check that the selection is valid
                if (ht.row > -1 && ht.col > -1) {
                    if (this._lbSelRows != null) {
                        // special handling for ListBox mode
                        var changed = false;
                        rng = new grid.CellRange(ht.row, ht.col, this._htDown.row, this._htDown.col);
                        for (var r = 0; r < rows.length; r++) {
                            var selected = rng.containsRow(r) ? this._lbSelState : this._lbSelRows[r] != null;
                            if (selected != rows[r].isSelected) {
                                var e = new grid.CellRangeEventArgs(g.cells, new grid.CellRange(r, sel.col, r, sel.col2));
                                if (g.onSelectionChanging(e)) {
                                    rows[r]._setFlag(grid.RowColFlags.Selected, selected, true);
                                    changed = true;
                                    //rows[r].isSelected = selected; // this invalidates
                                    g.onSelectionChanged(e);
                                }
                            }
                        }
                        // if the selection changed, refresh cells to show the change
                        if (changed) {
                            g.refreshCells(false, true, true);
                        }
                        // and scroll the selection into view
                        g.scrollIntoView(ht.row, ht.col);
                    }
                    else {
                        // row headers, select the whole row
                        if (ht.cellType == grid.CellType.RowHeader) {
                            rng.col = 0;
                            rng.col2 = g.columns.length - 1;
                        }
                        // extend range if that was asked
                        if (extend) {
                            rng.row2 = sel.row2;
                            rng.col2 = sel.col2;
                        }
                        // select
                        g.select(rng);
                    }
                }
            };
            _MouseHandler._SZ_MIN = 0; // minimum size allowed when resizing rows/cols
            return _MouseHandler;
        }());
        grid._MouseHandler = _MouseHandler;
    })(grid = wijmo.grid || (wijmo.grid = {}));
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    var grid;
    (function (grid) {
        'use strict';
        // identifier for checkbox
        var _WJC_CHECKBOX = 'wj-cell-check';
        /**
         * Handles the grid's editing.
         */
        var _EditHandler = /** @class */ (function () {
            /**
             * Initializes a new instance of the @see:_EditHandler class.
             *
             * @param g @see:FlexGrid that owns this @see:_EditHandler.
             */
            function _EditHandler(g) {
                var _this = this;
                this._fullEdit = false;
                this._list = null;
                this._g = g;
                // raise input event when selecting from ListBox
                this._evtInput = document.createEvent('HTMLEvents');
                this._evtInput.initEvent('input', true, false);
                // finish editing when selection changes (commit row edits if row changed)
                g.selectionChanging.addHandler(function (s, e) {
                    if (_this.finishEditing()) {
                        var oldrow = g._selHdl.selection.row;
                        if (oldrow != e.row) {
                            var len = g.rows.length, olditem = oldrow > -1 && oldrow < len ? g.rows[oldrow].dataItem : null, newitem = e.row > -1 && e.row < len ? g.rows[e.row].dataItem : null;
                            if (olditem != newitem) {
                                _this._commitRowEdits();
                            }
                        }
                    }
                    else {
                        e.cancel = true; // staying in edit mode, keep selection
                    }
                });
                // commit row edits when losing focus
                g.lostFocus.addHandler(function () {
                    if (!g.containsFocus()) {
                        var ae = wijmo.getActiveElement(); // TFS 121877, 122033 Bootstrap modal issue
                        if (!ae || getComputedStyle(ae).position != 'fixed') {
                            _this._commitRowEdits();
                        }
                    }
                });
                // commit edits when clicking non-cells (e.g. sort, drag, resize),
                // start editing when clicking on checkboxes
                g.addEventListener(g.hostElement, 'mousedown', function (e) {
                    // start actions on left button only: TFS 114623
                    if (e.defaultPrevented || e.button != 0) {
                        return;
                    }
                    // not while resizing...
                    if (g._mouseHdl._szRowCol) {
                        return;
                    }
                    // handle the event as usual
                    var sel = g.selection, ht = g.hitTest(e);
                    if (ht.cellType != grid.CellType.Cell && ht.cellType != grid.CellType.None) {
                        // finish editing when clicking on headers (to select/sort/drag)
                        _this.finishEditing();
                    }
                    else if (ht.cellType != grid.CellType.None) {
                        // start editing when clicking on checkboxes that are not the active editor
                        // NOTE: we check for the 'wj-cell-check' class to determine whether the
                        // checkbox is native and not custom content (formatItem/template) TFS 221442
                        var edt = wijmo.tryCast(e.target, HTMLInputElement);
                        if (_this._isNativeCheckbox(edt)) {
                            if (edt != _this.activeEditor) {
                                e.preventDefault();
                                if (_this.startEditing(false, ht.row, ht.col, true, e)) {
                                    edt = _this.activeEditor;
                                }
                            }
                            if (edt && edt.type == 'checkbox' && !edt.disabled && !edt.readOnly) {
                                edt.checked = !edt.checked;
                                edt.focus(); // TFS 135943
                                _this.finishEditing();
                            }
                        }
                    }
                }, true);
                // disable clicks on native checkboxes (already handled on mousedown, TFS 283750)
                g.addEventListener(g.hostElement, 'click', function (e) {
                    if (_this._isNativeCheckbox(e.target)) {
                        e.preventDefault();
                    }
                });
            }
            /**
             * Starts editing a given cell.
             *
             * @param fullEdit Whether to stay in edit mode when the user presses the cursor keys. Defaults to false.
             * @param r Index of the row to be edited. Defaults to the currently selected row.
             * @param c Index of the column to be edited. Defaults to the currently selected column.
             * @param focus Whether to give the editor the focus. Defaults to true.
             * @param evt Event that triggered this action (usually a keypress or keydown).
             * @return True if the edit operation started successfully.
             */
            _EditHandler.prototype.startEditing = function (fullEdit, r, c, focus, evt) {
                if (fullEdit === void 0) { fullEdit = true; }
                // default row/col to current selection
                var g = this._g;
                r = wijmo.asNumber(r, true, true);
                c = wijmo.asNumber(c, true, true);
                if (r == null) {
                    r = g.selection.row;
                }
                if (c == null) {
                    c = g.selection.col;
                }
                // default focus to true
                if (focus == null) {
                    focus = true;
                }
                // check that the cell is editable
                if (!this._allowEditing(r, c)) {
                    return false;
                }
                // get edit range
                var rng = g.getMergedRange(g.cells, r, c, false);
                if (!rng) {
                    rng = new grid.CellRange(r, c);
                }
                // get item to be edited
                var item = g.rows[r].dataItem;
                // make sure cell is selected
                g.select(rng, true);
                // check that we still have the same item after moving the selection (TFS 110143)
                if (!g.rows[r] || item != g.rows[r].dataItem) {
                    return false;
                }
                // no work if we are already editing this cell
                if (rng.equals(this._rng)) {
                    return true;
                }
                // make sure we're not editing another cell
                if (this.activeEditor && !this.finishEditing()) {
                    return false;
                }
                // start editing cell
                var e = new grid.CellRangeEventArgs(g.cells, rng, evt);
                if (!g.onBeginningEdit(e)) {
                    return false;
                }
                // start editing item
                var ecv = g.editableCollectionView, itemEditStarting = false;
                if (ecv) {
                    item = g.rows[r].dataItem;
                    itemEditStarting = item != ecv.currentEditItem;
                    if (itemEditStarting) {
                        g.onRowEditStarting(e);
                    }
                    ecv.editItem(item);
                    if (itemEditStarting) {
                        g.onRowEditStarted(e);
                        this._edItem = item;
                    }
                }
                // save editing parameters
                this._fullEdit = wijmo.asBoolean(fullEdit);
                this._rng = rng;
                this._list = null;
                var map = g.columns[c].dataMap;
                if (map) {
                    this._list = map.getDisplayValues(item);
                }
                // create editor
                if (rng.isSingleCell) {
                    this._updateEditorCell(r, c, itemEditStarting);
                }
                else {
                    g.refresh(false);
                }
                // initialize editor
                var edt = this._edt;
                if (edt) {
                    // prepare cell for edit
                    if (edt.type == 'checkbox') {
                        this._fullEdit = false; // no full edit on checkboxes...
                    }
                    else if (focus) {
                        // handle percentages consistently (TFS 273043)
                        if (wijmo.isNumber(g.getCellData(r, c, false)) && edt.value.indexOf('%') > -1) {
                            var val = edt.value, start = 0, end = val.length;
                            while (end > 0 && val[end - 1] == '%')
                                end--;
                            while (start < end && val[start] == '%')
                                start++;
                            wijmo.setSelectionRange(edt, start, end);
                        }
                        else {
                            wijmo.setSelectionRange(edt, 0, edt.value.length);
                        }
                        // set the focus without scrolling
                        //edt.focus();
                        g._setFocusNoScroll(edt);
                    }
                    // prepare cell for edit
                    g.onPrepareCellForEdit(e);
                    // don't start editing with disabled editors
                    if (edt.disabled || edt.readOnly) {
                        return false;
                    }
                }
                // done
                return edt != null && !edt.disabled && !edt.readOnly;
            };
            /**
             * Commits any pending edits and exits edit mode.
             *
             * @param cancel Whether pending edits should be canceled or committed.
             * @return True if the edit operation finished successfully.
             */
            _EditHandler.prototype.finishEditing = function (cancel) {
                if (cancel === void 0) { cancel = false; }
                // make sure we're editing
                var edt = this._edt;
                if (!edt) {
                    this._removeListBox();
                    return true;
                }
                // get parameters
                var g = this._g, rng = this._rng, e = new grid.CellEditEndingEventArgs(g.cells, rng), focus = g.containsFocus();
                // commit changes to focused custom editors TFS 229139, 203106
                var cstEdtHost = g.hostElement.querySelector('.wj-control.wj-state-focused');
                if (cstEdtHost) {
                    var cstEdt = wijmo.Control.getControl(cstEdtHost);
                    if (cstEdt) {
                        cstEdt.onLostFocus(e);
                    }
                }
                // validate edits
                e.cancel = cancel;
                if (!cancel && g.validateEdits) {
                    var error = this._getValidationError();
                    if (error) {
                        e.cancel = true;
                        var cell_1 = edt.parentElement;
                        if (cell_1) {
                            wijmo.toggleClass(cell_1, 'wj-state-invalid', true);
                            cell_1.title = error;
                            e.stayInEditMode = true;
                        }
                    }
                }
                // stay in edit mode if validation fails and stayInEditMode is true
                if (!g.onCellEditEnding(e) && e.stayInEditMode) {
                    if (focus) {
                        setTimeout(function () {
                            edt.select();
                        });
                    }
                    else {
                        edt.select();
                    }
                    return false; // continue editing
                }
                // apply edits
                if (!e.cancel) {
                    // save original value so user can check it in the cellEditEnded event
                    e.data = g.cells.getCellData(rng.topRow, rng.leftCol, false);
                    // apply value to the range
                    var value = g.cellFactory.getEditorValue(g);
                    for (var r = rng.topRow; r <= rng.bottomRow && r < g.rows.length; r++) {
                        for (var c = rng.leftCol; c <= rng.rightCol && c < g.columns.length; c++) {
                            g.cells.setCellData(r, c, value, true, false);
                        }
                    }
                }
                // dispose of editor
                this._edt = null;
                this._rng = null;
                this._list = null;
                this._removeListBox();
                // move focus from editor to cell if needed (265366)
                var cell = wijmo.closest(edt, '.wj-cell');
                if (wijmo.contains(cell, wijmo.getActiveElement())) {
                    cell.focus();
                }
                // refresh to replace the editor with regular content
                if (e.cancel || !e.refresh) {
                    this._updateEditorCell(rng.row, rng.col, false);
                }
                else {
                    g.refresh(false);
                }
                // restore focus
                if (focus) {
                    g.focus();
                }
                // edit ended
                g.onCellEditEnded(e);
                // done
                return true;
            };
            Object.defineProperty(_EditHandler.prototype, "activeEditor", {
                /**
                 * Gets the <b>HTMLInputElement</b> that represents the cell editor currently active.
                 */
                get: function () {
                    return this._edt;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(_EditHandler.prototype, "editRange", {
                /**
                 * Gets a @see:CellRange that identifies the cell currently being edited.
                 */
                get: function () {
                    return this._rng;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Gets the content of a @see:CellRange as a string suitable for
             * copying to the clipboard.
             *
             * Hidden rows and columns are not included in the clip string.
             *
             * @param rng @see:CellRange to copy. If omitted, the current selection is used.
             */
            _EditHandler.prototype.getClipString = function (rng) {
                var g = this._g, clipString = '', firstRow = true, firstCell = true, sm = grid.SelectionMode;
                // get the source range (taking selection mode into account)
                if (!rng) {
                    rng = g.selection;
                    switch (g.selectionMode) {
                        // row modes: expand range to cover all columns
                        case sm.Row:
                        case sm.RowRange:
                            rng.col = 0;
                            rng.col2 = g.columns.length - 1;
                            break;
                        // ListBox mode: scan rows and copy selected ones
                        case sm.ListBox:
                            rng.col = 0;
                            rng.col2 = g.columns.length - 1;
                            for (var i = 0; i < g.rows.length; i++) {
                                if (g.rows[i].isSelected && g.rows[i].isVisible) {
                                    rng.row = rng.row2 = i;
                                    if (clipString)
                                        clipString += '\n';
                                    clipString += this.getClipString(rng);
                                }
                            }
                            return clipString;
                    }
                }
                // scan rows
                rng = wijmo.asType(rng, grid.CellRange);
                for (var r = rng.topRow; r <= rng.bottomRow; r++) {
                    // skip invisible, add separator
                    if (!g.rows[r].isVisible)
                        continue;
                    if (!firstRow)
                        clipString += '\n';
                    firstRow = false;
                    // scan cells
                    for (var c = rng.leftCol, firstCell_1 = true; c <= rng.rightCol; c++) {
                        // skip invisible, add separator
                        if (!g.columns[c].isVisible)
                            continue;
                        if (!firstCell_1)
                            clipString += '\t';
                        firstCell_1 = false;
                        // append cell (handling tabs, new lines, and double quotes TFS 243258)
                        var cell = g.cells.getCellData(r, c, true).toString();
                        cell = cell.replace(/\t/g, ' ');
                        if (cell.indexOf('\n') > -1) {
                            cell = '"' + cell.replace(/"/g, '""') + '"';
                        }
                        clipString += cell;
                    }
                }
                // done
                return clipString;
            };
            /**
             * Parses a string into rows and columns and applies the content to a given range.
             *
             * Hidden rows and columns are skipped.
             *
             * @param text Tab and newline delimited text to parse into the grid.
             * @param rng @see:CellRange to copy. If omitted, the current selection is used.
             */
            _EditHandler.prototype.setClipString = function (text, rng) {
                var _this = this;
                var g = this._g;
                // get the target range (taking selection mode into account)
                var autoRange = rng == null, sm = grid.SelectionMode;
                if (!rng) {
                    rng = g.selection;
                    switch (g.selectionMode) {
                        case sm.Row:
                        case sm.RowRange:
                        case sm.ListBox:
                            rng.col = 0;
                            rng.col2 = g.columns.length - 1;
                            break;
                    }
                }
                rng = wijmo.asType(rng, grid.CellRange);
                // parse clip string into cells
                var rows = this._parseClipString(wijmo.asString(text));
                if (autoRange && !rng.isSingleCell && rows.length) {
                    this._expandClipRows(rows, rng);
                }
                // keep track of paste range to select later
                var rngPaste = new grid.CellRange(rng.topRow, rng.leftCol);
                // copy lines to rows
                var ecv = g.editableCollectionView, row = rng.topRow, pasted = false, e;
                g.deferUpdate(function () {
                    // prepare to update data source
                    if (ecv) {
                        ecv.beginUpdate();
                    }
                    for (var i = 0; i < rows.length && row < g.rows.length; i++, row++) {
                        // skip invisible row, keep clip line
                        if (!g.rows[row].isVisible) {
                            i--;
                            continue;
                        }
                        // copy cells to columns
                        var cells = rows[i], col = rng.leftCol;
                        for (var j = 0; j < cells.length && col < g.columns.length; j++, col++) {
                            // skip invisible column, keep clip cell
                            if (!g.columns[col].isVisible) {
                                j--;
                                continue;
                            }
                            // assign cell
                            if (_this._allowEditing(row, col)) {
                                // raise events so user can cancel the paste
                                e = new grid.CellRangeEventArgs(g.cells, new grid.CellRange(row, col), cells[j]);
                                if (g.onPastingCell(e)) {
                                    if (ecv) {
                                        ecv.editItem(g.rows[row].dataItem);
                                        _this._edItem = ecv.currentEditItem; // TFS 267863
                                    }
                                    if (g.cells.setCellData(row, col, e.data)) {
                                        g.onPastedCell(e);
                                        pasted = true;
                                    }
                                }
                                // update paste range
                                rngPaste.row2 = Math.max(rngPaste.row2, row);
                                rngPaste.col2 = Math.max(rngPaste.col2, col);
                            }
                        }
                    }
                    // done updating data source
                    if (ecv) {
                        ecv.endUpdate();
                    }
                    // select pasted range
                    g.select(rngPaste);
                });
            };
            // ** implementation
            // check whether an input element is our native checkbox editor
            /*private*/ _EditHandler.prototype._isNativeCheckbox = function (edt) {
                return edt instanceof HTMLInputElement && // input element
                    edt.type == 'checkbox' && // checkbox
                    !edt.disabled && !edt.readOnly && // editable (TFS 257521)
                    wijmo.hasClass(edt, _WJC_CHECKBOX) && // default check editor (TFS 221442)
                    wijmo.closest(edt, '.wj-flexgrid') == this._g.hostElement; // this grid (TFS 223806)
            };
            // break a string into rows and cells accounting for quoted breaks
            /*private*/ _EditHandler.prototype._parseClipString = function (text) {
                var rows = [];
                // replace \r\n with \n and \r with \n
                text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
                // trim trailing \n's at the end of the string
                text = text.replace(/\n+$/g, '');
                // parse string into rows and cells
                var start = 0, end = 0;
                for (start = 0; start < text.length; start++) {
                    var quoted = text[start] == '"' && text[start + 1] >= ' ', quoting = false, done = false;
                    for (end = start; end < text.length && !done; end++) {
                        var char = text[end];
                        switch (char) {
                            case '"':
                                if (quoted) {
                                    quoting = !quoting;
                                }
                                break;
                            case '\t':
                            case '\n':
                                if (!quoting) {
                                    this._parseClipCell(rows, text, start, end, char == '\n');
                                    start = end;
                                    done = true;
                                }
                                break;
                        }
                    }
                    // handle last cell
                    if (end == text.length) {
                        this._parseClipCell(rows, text, start, text.length, false);
                        break;
                    }
                }
                // handle empty strings (TFS 268282)
                if (rows.length == 0) {
                    rows.push(['']);
                }
                // return parse results
                return rows;
            };
            _EditHandler.prototype._parseClipCell = function (rows, text, start, end, newRow) {
                // add first row if necessary
                if (!rows.length) {
                    rows.push([]);
                }
                // get cell content (possibly quoted)
                var cell = text.substr(start, end - start), len = cell.length;
                if (len > 1 && cell[0] == '"' && cell[len - 1] == '"') {
                    cell = cell.substr(1, len - 2);
                    cell = cell.replace(/""/g, '"');
                }
                // append cell to last row
                rows[rows.length - 1].push(cell);
                // add new row
                if (newRow) {
                    rows.push([]);
                }
            };
            // expand clip string to get Excel-like paste behavior
            /*private*/ _EditHandler.prototype._expandClipRows = function (rows, rng) {
                // get clip string dimensions and cells
                var srcRows = rows.length, srcCols = 0;
                for (var i = 0; i < srcRows; i++) {
                    srcCols = Math.max(srcCols, rows[i].length);
                    ;
                }
                // get destination size (visible rows/cols only, TFS 238478, 238479)
                var g = this._g, dstRows = 0, dstCols = 0;
                for (var r = rng.topRow; r <= rng.bottomRow; r++) {
                    if (g.rows[r].isVisible) {
                        dstRows++;
                    }
                }
                for (var c = rng.leftCol; c <= rng.rightCol; c++) {
                    if (g.columns[c].isVisible) {
                        dstCols++;
                    }
                }
                // expand if destination size is a multiple of source size (like Excel)
                if (dstRows > 1 || dstCols > 1) {
                    if (dstRows == 1)
                        dstRows = srcRows;
                    if (dstCols == 1)
                        dstCols = srcCols;
                    if (dstCols % srcCols == 0 && dstRows % srcRows == 0) {
                        // append columns
                        for (var c = srcCols; c < dstCols; c++) {
                            for (var r = 0; r < srcRows; r++) {
                                rows[r].push(rows[r % srcRows][c % srcCols]);
                            }
                        }
                        // append rows
                        for (var r = srcRows; r < dstRows; r++) {
                            rows.push(rows[r % srcRows]);
                        }
                    }
                }
            };
            // update the editor cell (when starting/finishing edits)
            _EditHandler.prototype._updateEditorCell = function (r, c, updateHdr) {
                var g = this._g, edt = g.cells.getCellElement(r, c), frozen = g._useFrozenDiv() && (r < g.frozenRows || c < g.frozenColumns);
                if (edt && !frozen && !g._hasPendingUpdates()) {
                    this._updateCell(edt);
                    updateHdr = updateHdr || g._getHasValidation();
                    if (updateHdr && (g.headersVisibility & grid.HeadersVisibility.Row)) {
                        var p = g.rowHeaders, hdrIndex = p.columns.length - 1, hdrCell = p.getCellElement(r, hdrIndex);
                        if (hdrCell) {
                            this._updateCell(hdrCell);
                        }
                    }
                }
                else {
                    g.refresh(false);
                }
            };
            // updates a cell on the grid
            _EditHandler.prototype._updateCell = function (cell) {
                var ht = new grid.HitTestInfo(cell, null), clsUpdating = grid.FlexGrid._WJS_UPDATING;
                if (ht.panel) {
                    wijmo.addClass(cell, clsUpdating); // force update
                    ht.grid.cellFactory.updateCell(ht.panel, ht.row, ht.col, cell, ht.range);
                    wijmo.removeClass(cell, clsUpdating);
                }
            };
            // gets a validation error for the cell currently being edited
            _EditHandler.prototype._getValidationError = function () {
                var g = this._g;
                if (g._getHasValidation()) {
                    var r = this._rng.row, c = this._rng.col, newVal = g.cellFactory.getEditorValue(g), oldVal = g.getCellData(r, c, false);
                    if (g.setCellData(r, c, newVal, true, false)) {
                        var error = g._getError(g.cells, r, c);
                        g.setCellData(r, c, oldVal, true, false);
                        return error;
                    }
                }
                // no errors found
                return null;
            };
            // checks whether a cell can be edited
            /*private*/ _EditHandler.prototype._allowEditing = function (r, c) {
                var g = this._g;
                if (g.isReadOnly || g.selectionMode == grid.SelectionMode.None)
                    return false;
                if (r < 0 || r >= g.rows.length || g.rows[r].isReadOnly || !g.rows[r].isVisible)
                    return false;
                if (c < 0 || c >= g.columns.length)
                    return false;
                var col = g._getBindingColumn(g.cells, r, g.columns[c]);
                if (!col || col.isReadOnly || !col.isVisible)
                    return false;
                return true;
            };
            // finish editing the current item
            /*private*/ _EditHandler.prototype._commitRowEdits = function () {
                var g = this._g;
                if (this.finishEditing() && this._edItem) {
                    var ecv = g.editableCollectionView;
                    if (ecv && ecv.currentEditItem) {
                        var e = new grid.CellRangeEventArgs(g.cells, g.selection);
                        g.onRowEditEnding(e);
                        ecv.commitEdit();
                        g.onRowEditEnded(e);
                    }
                    this._edItem = null;
                }
            };
            // handles keyDown events while editing
            // returns true if the key was handled, false if the grid should handle it
            /*private*/ _EditHandler.prototype._keydown = function (e) {
                switch (e.keyCode) {
                    // F2 toggles edit mode
                    case wijmo.Key.F2:
                        this._fullEdit = !this._fullEdit;
                        e.preventDefault();
                        return true;
                    // F4 toggles ListBox
                    case wijmo.Key.F4:
                        this._toggleListBox(e);
                        e.preventDefault();
                        return true;
                    // space toggles checkboxes
                    case wijmo.Key.Space:
                        var edt = this._edt;
                        if (edt && edt.type == 'checkbox' && !edt.disabled && !edt.readOnly) {
                            edt.checked = !edt.checked;
                            this.finishEditing();
                            e.preventDefault();
                        }
                        return true;
                    // enter, tab, escape finish editing
                    case wijmo.Key.Enter:
                    case wijmo.Key.Tab:
                        e.preventDefault();
                        return !this.finishEditing(); // let grid handle key if editing finished
                    case wijmo.Key.Escape:
                        e.preventDefault();
                        this.finishEditing(true);
                        return true;
                    // cursor keys: ListBox selection/finish editing if not in full edit mode
                    case wijmo.Key.Up:
                    case wijmo.Key.Down:
                    case wijmo.Key.Left:
                    case wijmo.Key.Right:
                    case wijmo.Key.PageUp:
                    case wijmo.Key.PageDown:
                    case wijmo.Key.Home:
                    case wijmo.Key.End:
                        // if the ListBox is active, let it handle the key
                        if (this._lbx) {
                            return this._keydownListBox(e);
                        }
                        // open ListBox on alt up/down
                        if (e.altKey) {
                            switch (e.keyCode) {
                                case wijmo.Key.Up:
                                case wijmo.Key.Down:
                                    this._toggleListBox(e);
                                    e.preventDefault();
                                    return true;
                            }
                        }
                        // finish editing if not in full-edit mode
                        if (!this._fullEdit) {
                            if (this.finishEditing()) {
                                return false;
                            }
                        }
                }
                // key has been handled
                return true;
            };
            // handles keydown events when ListBox is visible
            _EditHandler.prototype._keydownListBox = function (e) {
                var handled = true;
                if (this._lbx) {
                    switch (e.keyCode) {
                        case wijmo.Key.Up:
                            if (e.altKey) {
                                this._toggleListBox(e);
                            }
                            else if (this._lbx.selectedIndex > 0) {
                                this._lbx.selectedIndex--;
                            }
                            break;
                        case wijmo.Key.Down:
                            if (e.altKey) {
                                this._toggleListBox(e);
                            }
                            else {
                                this._lbx.selectedIndex++;
                            }
                            break;
                        case wijmo.Key.Home:
                        case wijmo.Key.PageUp:
                            this._lbx.selectedIndex = 0;
                            break;
                        case wijmo.Key.End:
                        case wijmo.Key.PageDown:
                            this._lbx.selectedIndex = this._lbx.collectionView.items.length - 1;
                            break;
                        default:
                            handled = false;
                            break;
                    }
                }
                // if handled, we're done
                if (handled) {
                    e.preventDefault();
                    return true;
                }
                // return false to let the grid handle the key
                return false;
            };
            // handles keyPress events while editing
            /*private*/ _EditHandler.prototype._keypress = function (e) {
                // auto-complete based on dataMap
                var edt = this._edt;
                if (edt && edt.type != 'checkbox' && // e.target == edt && // start matching right away!
                    this._list && this._list.length > 0 && e.charCode >= 32) {
                    // get text up to selection start
                    var start = edt.selectionStart, text = edt.value.substr(0, start);
                    // add the new char if the source element is the editor
                    // (but not if the source element is the grid!)
                    if (e.target == edt) {
                        start++;
                        text += String.fromCharCode(e.charCode);
                    }
                    // convert to lower-case for matching
                    text = text.toLowerCase();
                    // look for a match
                    for (var i = 0; i < this._list.length; i++) {
                        if (this._list[i].toLowerCase().indexOf(text) == 0) {
                            // found the match, update text and selection
                            edt.value = this._list[i];
                            wijmo.setSelectionRange(edt, start, this._list[i].length);
                            edt.dispatchEvent(this._evtInput);
                            // eat the key and be done
                            e.preventDefault();
                            break;
                        }
                    }
                }
            };
            // shows the drop-down element for a cell (if it is not already visible)
            /*private*/ _EditHandler.prototype._toggleListBox = function (evt, rng) {
                var g = this._g, sel = g._selHdl.selection;
                // if a range was not specified, use current selection
                if (!rng) {
                    rng = sel;
                }
                // close select element if any; if this is the same cell, we're done
                if (this._lbx) {
                    this._removeListBox();
                    if (sel.contains(rng)) {
                        if (g.activeEditor) {
                            g.activeEditor.focus();
                        }
                        else if (!g.containsFocus()) {
                            g.focus();
                        }
                        return true;
                    }
                }
                // if this was a touch, give focus to ListBox to hide soft keyboard
                var lbxFocus = g.isTouching;
                // check that we have a drop-down
                var bcol = g._getBindingColumn(g.cells, rng.row, g.columns[rng.col]);
                if (!wijmo.input || !bcol.dataMap || bcol.showDropDown === false) {
                    return false;
                }
                // start editing so we can position the select element
                if (!wijmo.input || !this.startEditing(true, rng.row, rng.col, !lbxFocus, evt)) {
                    return false;
                }
                // create and initialize the ListBox
                this._lbx = this._createListBox();
                this._lbx.showSelection();
                if (lbxFocus) {
                    this._lbx.focus();
                }
                return true;
            };
            // create the ListBox and add it to the document
            _EditHandler.prototype._createListBox = function () {
                var _this = this;
                var g = this._g, rng = this._rng, row = g.rows[rng.row], col = g._getBindingColumn(g.cells, rng.row, g.columns[rng.col]), div = document.createElement('div'), lbx = new wijmo.input.ListBox(div);
                // just in case
                this._removeListBox();
                // configure ListBox
                wijmo.addClass(div, 'wj-dropdown-panel wj-grid-listbox');
                lbx.maxHeight = row.renderHeight * 4;
                lbx.isContentHtml = col.isContentHtml;
                lbx.itemsSource = col.dataMap.getDisplayValues(row.dataItem);
                lbx.selectedValue = g.activeEditor
                    ? g.activeEditor.value
                    : g.getCellData(rng.row, rng.col, true);
                wijmo.addClass(div, col.dropDownCssClass);
                // close ListBox on clicks
                lbx.addEventListener(lbx.hostElement, 'click', function () {
                    _this._removeListBox();
                    g.focus(); // TFS 222950
                    _this.finishEditing();
                });
                // close ListBox when losing focus
                lbx.lostFocus.addHandler(function () {
                    _this._removeListBox();
                });
                // update editor when the selected index changes
                lbx.selectedIndexChanged.addHandler(function () {
                    var edt = g.activeEditor;
                    if (edt) {
                        edt.value = _this._lbx.selectedValue;
                        edt.dispatchEvent(_this._evtInput);
                        wijmo.setSelectionRange(edt, 0, edt.value.length);
                    }
                });
                // show the popup
                var cell = g.cells.getCellElement(rng.row, rng.col);
                if (cell) {
                    wijmo.showPopup(div, cell, false, false, false);
                }
                else {
                    wijmo.showPopup(div, g.getCellBoundingRect(rng.row, rng.col));
                    div[wijmo.Control._OWNR_KEY] = g.hostElement; // remember who owns the listbox
                }
                // done
                return lbx;
            };
            // remove the ListBox element from the DOM and disconnect its event handlers
            _EditHandler.prototype._removeListBox = function () {
                var lbx = this._lbx;
                if (lbx) {
                    this._lbx = null;
                    wijmo.hidePopup(lbx.hostElement, function () {
                        lbx.dispose();
                    });
                }
            };
            return _EditHandler;
        }());
        grid._EditHandler = _EditHandler;
    })(grid = wijmo.grid || (wijmo.grid = {}));
})(wijmo || (wijmo = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var wijmo;
(function (wijmo) {
    var grid;
    (function (grid) {
        'use strict';
        /**
         * Manages the new row template used to add rows to the grid.
         */
        var _AddNewHandler = /** @class */ (function () {
            /**
             * Initializes a new instance of the @see:_AddNewHandler class.
             *
             * @param g @see:FlexGrid that owns this @see:_AddNewHandler.
             */
            function _AddNewHandler(g) {
                this._nrt = new _NewRowTemplate();
                this._g = g;
                this._keydownBnd = this._keydown.bind(this);
                this._attach();
            }
            Object.defineProperty(_AddNewHandler.prototype, "newRowAtTop", {
                /**
                 * Gets or sets a value that indicates whether the new row template should be located
                 * at the top of the grid or at the bottom.
                 */
                get: function () {
                    return this._top;
                },
                set: function (value) {
                    if (value != this.newRowAtTop) {
                        this._top = wijmo.asBoolean(value);
                        this.updateNewRowTemplate();
                    }
                },
                enumerable: true,
                configurable: true
            });
            /**
             * Updates the new row template to ensure it's visible only if the grid is
             * bound to a data source that supports adding new items, and that it is
             * in the right position.
             */
            _AddNewHandler.prototype.updateNewRowTemplate = function () {
                // get variables
                var g = this._g, ecv = g.editableCollectionView, rows = g.rows;
                // see if we need a new row template
                var needTemplate = ecv && ecv.canAddNew && g.allowAddNew && !g.isReadOnly;
                // get current template index
                var index = rows.indexOf(this._nrt), newRowPos = this._top ? 0 : rows.length - 1, insert = false;
                // update template position
                if (!needTemplate && index > -1) {
                    var sel = g.selection; // move selection away from the row being deleted
                    if (sel.row == index) {
                        g.select(sel.row - 1, sel.col);
                    }
                    rows.removeAt(index);
                }
                else if (needTemplate) {
                    if (index < 0) {
                        insert = true;
                    }
                    else if (index != newRowPos) {
                        rows.removeAt(index);
                        insert = true;
                    }
                    // add the new row template at the proper position
                    if (insert) {
                        if (this._top) {
                            rows.insert(0, this._nrt);
                        }
                        else {
                            rows.push(this._nrt);
                        }
                    }
                    // make sure the new row template is not collapsed
                    if (this._nrt) {
                        this._nrt._setFlag(grid.RowColFlags.ParentCollapsed, false);
                    }
                }
            };
            // ** implementation
            // add/remove handlers to manage the new row template
            /*protected*/ _AddNewHandler.prototype._attach = function () {
                var g = this._g;
                if (g) {
                    g.beginningEdit.addHandler(this._beginningEdit, this);
                    g.pastingCell.addHandler(this._beginningEdit, this);
                    g.rowEditEnded.addHandler(this._rowEditEnded, this);
                    g.loadedRows.addHandler(this.updateNewRowTemplate, this);
                    g.hostElement.addEventListener('keydown', this._keydownBnd, true);
                }
            };
            /*protected*/ _AddNewHandler.prototype._detach = function () {
                var g = this._g;
                if (g) {
                    g.beginningEdit.removeHandler(this._beginningEdit);
                    g.pastingCell.removeHandler(this._beginningEdit);
                    g.rowEditEnded.removeHandler(this._rowEditEnded);
                    g.loadedRows.removeHandler(this.updateNewRowTemplate);
                    g.hostElement.removeEventListener('keydown', this._keydownBnd, true);
                }
            };
            // cancel new row at top addition on Escape (same as new row at bottom)
            /*protected*/ _AddNewHandler.prototype._keydown = function (e) {
                if (!e.defaultPrevented && e.keyCode == wijmo.Key.Escape) {
                    if (this._g.activeEditor == null && this._top && this._nrt.dataItem) {
                        this._nrt.dataItem = null;
                        this._g.invalidate();
                    }
                }
            };
            // beginning edit, add new item if necessary
            /*protected*/ _AddNewHandler.prototype._beginningEdit = function (sender, e) {
                if (!e.cancel) {
                    var row = this._g.rows[e.row];
                    if (wijmo.tryCast(row, _NewRowTemplate)) {
                        var ecv = this._g.editableCollectionView;
                        if (ecv && ecv.canAddNew) {
                            // add new row at the top
                            if (this._top) {
                                if (this._nrt.dataItem == null) {
                                    // create new item
                                    var newItem = null, src = ecv.sourceCollection, creator = ecv['newItemCreator'];
                                    if (wijmo.isFunction(creator)) {
                                        newItem = creator();
                                    }
                                    else if (src && src.length) {
                                        newItem = new src[0].constructor();
                                    }
                                    else {
                                        newItem = {};
                                    }
                                    // assign new item to new row template
                                    this._nrt.dataItem = newItem;
                                }
                                // add new row at the bottom (TFS 145498)
                            }
                            else {
                                var newItem = (ecv.currentAddItem && ecv.currentAddItem == row.dataItem)
                                    ? ecv.currentAddItem
                                    : ecv.addNew();
                                ecv.moveCurrentTo(newItem);
                                this.updateNewRowTemplate();
                                // update now to ensure the editor will get a fresh layout (TFS 96705)
                                this._g.refresh(true);
                                // fire row added event (user can customize the new row or cancel)
                                this._g.onRowAdded(e);
                                if (e.cancel) {
                                    ecv.cancelNew();
                                }
                            }
                        }
                    }
                }
            };
            // row has been edited, commit if this is the new row
            /*protected*/ _AddNewHandler.prototype._rowEditEnded = function (sender, e) {
                var _this = this;
                var ecv = this._g.editableCollectionView, item = this._nrt.dataItem;
                if (ecv) {
                    // adding at the bottom
                    if (ecv.isAddingNew) {
                        ecv.commitNew();
                        // adding at the top
                    }
                    else if (item && !e.cancel) {
                        // clear row template data
                        this._nrt.dataItem = null;
                        // add new item to collection view
                        var newItem = ecv.addNew();
                        for (var k in item) {
                            newItem[k] = item[k];
                        }
                        // fire row added event (user can customize the new row or cancel)
                        this._g.onRowAdded(e);
                        if (e.cancel) {
                            ecv.cancelNew();
                        }
                        else {
                            ecv.commitNew();
                        }
                        // move selection back to new row template
                        setTimeout(function () {
                            _this._g.select(0, _this._g.columns.firstVisibleIndex);
                            _this.updateNewRowTemplate(); // needed when adding the first row
                        }, 20);
                    }
                }
            };
            return _AddNewHandler;
        }());
        grid._AddNewHandler = _AddNewHandler;
        /**
         * Represents a row template used to add items to the source collection.
         */
        var _NewRowTemplate = /** @class */ (function (_super) {
            __extends(_NewRowTemplate, _super);
            function _NewRowTemplate() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return _NewRowTemplate;
        }(grid.Row));
        grid._NewRowTemplate = _NewRowTemplate;
    })(grid = wijmo.grid || (wijmo.grid = {}));
})(wijmo || (wijmo = {}));

var wijmo;
(function (wijmo) {
    var grid;
    (function (grid) {
        'use strict';
        /**
         * Implements a hidden input element so users can choose IME modes when
         * the FlexGrid has focus, and start composing before the grid enters
         * edit mode.
         */
        var _ImeHandler = /** @class */ (function () {
            //--------------------------------------------------------------------------
            //#region ** ctor
            /**
             * Initializes a new instance of the @see:_ImeHandler class and attaches it to a @see:FlexGrid.
             *
             * @param g @see:FlexGrid that this @see:_ImeHandler will be attached to.
             */
            function _ImeHandler(g) {
                this._g = g;
                // create hidden input focus element
                this._tbx = wijmo.createElement('<input class="wj-grid-editor wj-form-control wj-grid-ime"/>');
                wijmo.setCss(this._tbx, _ImeHandler._cssHidden);
                // add IME input to the grid, update the focus
                g.cells.hostElement.parentElement.appendChild(this._tbx);
                this._updateImeFocus();
                // attach event handlers
                var host = g.hostElement;
                g.addEventListener(this._tbx, 'compositionstart', this._compositionstart.bind(this));
                g.addEventListener(host, 'blur', this._updateImeFocus.bind(this), true);
                g.addEventListener(host, 'focus', this._updateImeFocus.bind(this), true);
                g.addEventListener(host, 'mousedown', this._mousedown.bind(this), true);
                g.addEventListener(host, 'mouseup', this._mouseup.bind(this), true);
                g.cellEditEnded.addHandler(this._cellEditEnded, this);
                g.selectionChanged.addHandler(this._updateImeFocus, this);
            }
            //#endregion
            //--------------------------------------------------------------------------
            //#region ** object model
            /**
             * Disposes of this @see:_ImeHandler.
             */
            _ImeHandler.prototype.dispose = function () {
                var g = this._g, host = g.hostElement;
                // remove event listeners
                g.removeEventListener(this._tbx, 'compositionstart');
                g.removeEventListener(host, 'blur');
                g.removeEventListener(host, 'focus');
                g.removeEventListener(host, 'mousedown');
                g.removeEventListener(host, 'mouseup');
                g.cellEditEnded.removeHandler(this._cellEditEnded);
                g.selectionChanged.removeHandler(this._updateImeFocus);
                // remove IME input from grid
                wijmo.removeChild(this._tbx);
            };
            //#endregion
            //--------------------------------------------------------------------------
            //#region ** implementation
            // hide IME input after editing
            _ImeHandler.prototype._cellEditEnded = function () {
                wijmo.setCss(this._tbx, _ImeHandler._cssHidden);
                this._tbx.value = '';
            };
            // show IME input as current editor when composition starts
            _ImeHandler.prototype._compositionstart = function () {
                var _this = this;
                var g = this._g;
                if (g.activeEditor == null) {
                    var sel = g._selHdl.selection;
                    if (g.startEditing(false, sel.row, sel.col, false)) {
                        // adjust for merged cells (TFS 270497)
                        sel = g.editRange;
                        // get editor position
                        var host = g.cells.hostElement, left = g.columns[sel.col].pos + host.offsetLeft, top_1 = g.rows[sel.row].pos + host.offsetTop, rc = g.getCellBoundingRect(sel.row, sel.col);
                        if (!sel.isSingleCell) {
                            var cell = g.cells.getCellElement(sel.row, sel.col);
                            rc.width = cell.offsetWidth;
                            rc.height = cell.offsetHeight;
                        }
                        // account for frozen cells (TFS 239266, 272145)
                        if (sel.row < g.frozenRows) {
                            top_1 += host.parentElement.scrollTop;
                        }
                        if (sel.col < g.frozenColumns) {
                            left += host.parentElement.scrollLeft;
                        }
                        var edt_1 = g.activeEditor, zIndex = edt_1 && edt_1.parentElement ? edt_1.parentElement.style.zIndex : '';
                        // position the editor
                        wijmo.setCss(this._tbx, {
                            position: 'absolute',
                            pointerEvents: '',
                            opacity: '',
                            left: left,
                            top: top_1,
                            width: rc.width - 1,
                            height: rc.height - 1,
                            zIndex: zIndex
                        });
                        // copy validation attributes (including maxLength, TFS 276818)
                        if (edt_1 instanceof HTMLInputElement) {
                            var atts = ['minLength', 'maxLength', 'pattern'];
                            atts.forEach(function (att) {
                                wijmo.setAttribute(_this._tbx, att, edt_1.getAttribute(att));
                            });
                        }
                        // and make it the active editor
                        g._edtHdl._edt = this._tbx;
                    }
                }
            };
            // enable/disable IME on mousedown/up (TFS 194411)
            _ImeHandler.prototype._mousedown = function (e) {
                this._mouseDown = true;
                this._updateImeFocus();
            };
            _ImeHandler.prototype._mouseup = function (e) {
                this._mouseDown = false;
                this._updateImeFocus();
            };
            // transfer focus from grid to IME input
            _ImeHandler.prototype._updateImeFocus = function () {
                var g = this._g, ae = wijmo.getActiveElement();
                if (!g.activeEditor && !g.isTouching && !this._mouseDown &&
                    wijmo.contains(g.hostElement, ae)) {
                    var tbx = this._tbx;
                    if (this._enableIme()) {
                        if (ae != tbx) {
                            tbx.disabled = false;
                            tbx.select();
                        }
                    }
                    else {
                        tbx.disabled = true;
                    }
                }
            };
            // checks whether IME should be enabled for the current selection
            _ImeHandler.prototype._enableIme = function () {
                var g = this._g, sel = g.selection, col = sel.isValid ? g._getBindingColumn(g.cells, sel.row, g.columns[sel.col]) : null;
                // can't edit? can't use IME
                if (!g.canEditCell(sel.row, sel.col)) {
                    return false;
                }
                // disable IME for boolean cells (with checkboxes)
                if (!col || col.dataType == wijmo.DataType.Boolean) {
                    return false;
                }
                // seems OK to use IME
                return true;
            };
            _ImeHandler._cssHidden = {
                position: 'fixed',
                pointerEvents: 'none',
                opacity: 0,
                left: -10,
                top: -10,
                width: 0
            };
            return _ImeHandler;
        }());
        grid._ImeHandler = _ImeHandler;
    })(grid = wijmo.grid || (wijmo.grid = {}));
})(wijmo || (wijmo = {}));


/*
    *
    * Wijmo Library 5.20173.409
    * http://wijmo.com/
    *
    * Copyright(c) GrapeCity, Inc.  All rights reserved.
    *
    * Licensed under the GrapeCity Commercial License.
    * sales@wijmo.com
    * wijmo.com/products/wijmo-5/license/
    *
    */
///<wijmo-soft-import from="wijmo.chart.analytics"/>
///<wijmo-soft-import from="wijmo.chart.animation"/>
///<wijmo-soft-import from="wijmo.chart.annotation"/>
///<wijmo-soft-import from="wijmo.chart.finance.analytics"/>
///<wijmo-soft-import from="wijmo.chart.finance"/>
///<wijmo-soft-import from="wijmo.chart.hierarchical"/>
///<wijmo-soft-import from="wijmo.chart.interaction"/>
///<wijmo-soft-import from="wijmo.chart.radar"/>
///<wijmo-soft-import from="wijmo.chart"/>
///<wijmo-soft-import from="wijmo.gauge"/>
///<wijmo-soft-import from="wijmo.grid.detail"/>
///<wijmo-soft-import from="wijmo.grid.filter"/>
///<wijmo-soft-import from="wijmo.grid.grouppanel"/>
///<wijmo-soft-import from="wijmo.grid.multirow"/>
///<wijmo-soft-import from="wijmo.grid.pdf"/>
///<wijmo-soft-import from="wijmo.grid.sheet"/>
///<wijmo-soft-import from="wijmo.grid"/>
///<wijmo-soft-import from="wijmo.grid.xlsx"/>
///<wijmo-soft-import from="wijmo.input"/>
///<wijmo-soft-import from="wijmo.metaFactory"/>
///<wijmo-soft-import from="wijmo.odata"/>
///<wijmo-soft-import from="wijmo.olap"/>
///<wijmo-soft-import from="wijmo.pdf"/>
///<wijmo-soft-import from="wijmo.xlsx"/>
///<wijmo-soft-import from="wijmo.viewer"/>
///<wijmo-soft-import from="wijmo.nav"/>
var wijmo;
(function (wijmo) {
    // prevent double loading
    //if (wijmo && wijmo.interop) {
    //    return;
    //}
    var meta;
    (function (meta) {
        /*
            Represents shared metadata (control properties/events descriptions) used by interop services like
            Angular directives and Knockout custom bindings.

            Control metadata is retrieved using the getMetaData method by passing the control's metaDataId (see the
            method description for details).

            Descriptor objects are created using the CreateProp, CreateEvent and CreateComplexProp static methods.

            The specific interop service should create a class derived from ControlMetaFactory and override these methods to
            create descriptors of the platform specific types (see the wijmo.angular.MetaFactory class as an example).

            To initialize platform specific properties of the descriptors an interop services can use the findProp, findEvent and
            findComplexProp methods to find a necessary descriptor object by name.
        */
        var ControlMetaFactory = /** @class */ (function () {
            function ControlMetaFactory() {
            }
            // Creates a property descriptor object. A specific interop service should override this method in the derived
            // metadata factory class to create platform specific descriptor object.
            ControlMetaFactory.CreateProp = function (propertyName, propertyType, changeEvent, enumType, isNativeControlProperty, priority) {
                return new PropDescBase(propertyName, propertyType, changeEvent, enumType, isNativeControlProperty, priority);
            };
            // Creates an event descriptor object. A specific interop service should override this method in the derived
            // metadata factory class to create platform specific descriptor object.
            ControlMetaFactory.CreateEvent = function (eventName, isPropChanged) {
                return new EventDescBase(eventName, isPropChanged);
            };
            // Creates a complex property descriptor object. A specific interop service should override this method in the derived
            // metadata factory class to create platform specific descriptor object.
            ControlMetaFactory.CreateComplexProp = function (propertyName, isArray, ownsObject) {
                return new ComplexPropDescBase(propertyName, isArray, ownsObject);
            };
            // Finds a property descriptor by the property name in the specified array.
            ControlMetaFactory.findProp = function (propName, props) {
                return this.findInArr(props, 'propertyName', propName);
            };
            // Finds an event descriptor by the event name in the specified array.
            ControlMetaFactory.findEvent = function (eventName, events) {
                return this.findInArr(events, 'eventName', eventName);
            };
            // Finds a complex property descriptor by the property name in the specified array.
            ControlMetaFactory.findComplexProp = function (propName, props) {
                return this.findInArr(props, 'propertyName', propName);
            };
            /*
                Returns metadata for the control by its metadata ID.In the most cases the control type (constructor function)
                is used as metadata ID. In cases where this is not applicable an arbitrary object can be used as an ID, e.g.
                'MenuItem' string is used as the ID for Menu Item.

                The sets of descriptors returned for the specific metadata ID take into account the controls inheritance chain
                and include metadata defined for the control's base classes.
                In case of a control that has no a base class metadata you create its metadata object with a constructor:
                return new MetaDataBase(... descriptor arrays ...);

                If the control has the base control metadata then you create its metadata object by a recursive call to
                the getMetaData method with the base control's metadata ID passed, and add the controls own metadata to
                the returned object using the 'add' method. E.g. for the ComboBox derived from the DropDown this looks like:
                return this.getMetaData(wijmo.input.DropDown).add(... descriptor arrays ...);

                The specific platforms provide the following implementations of the metadata ID support:

                Angular
                =======
                The WjDirective._getMetaDataId method returns a metadata ID. By default it returns a value of the
                WjDirective._controlConstructor property. Because of this approach it's reasonable to override the
                _controlConstructor property even in the abstract classes like WjDropDown, in this case it's not necessary
                to override the _getMetaDataId method itself.
                ----------------
                WARNING: if you override the _getMetaDataId method, don't forget to override it in the derived classes!
                ----------------
                You usually need to override the _getMetaDataId method only for classes like WjMenuItem and WjCollectionViewNavigator
                for which the _controlConstructor as an ID approach doesn't work.

                Knockout
                ========
                TBD
            */
            ControlMetaFactory.getMetaData = function (metaDataId) {
                switch (metaDataId) {
                    // wijmo.Control *************************************************************
                    case wijmo.Control:
                        return new MetaDataBase([
                            this.CreateProp('isDisabled', PropertyType.Boolean),
                        ], [
                            this.CreateEvent('gotFocus'),
                            this.CreateEvent('lostFocus')
                        ]);
                    // wijmo.input *************************************************************
                    case wijmo.input && wijmo.input.DropDown:
                        return this.getMetaData(wijmo.Control).add([
                            this.CreateProp('isDroppedDown', PropertyType.Boolean, 'isDroppedDownChanged'),
                            this.CreateProp('showDropDownButton', PropertyType.Boolean),
                            this.CreateProp('autoExpandSelection', PropertyType.Boolean),
                            this.CreateProp('placeholder', PropertyType.String),
                            this.CreateProp('dropDownCssClass', PropertyType.String),
                            this.CreateProp('isAnimated', PropertyType.Boolean),
                            this.CreateProp('isReadOnly', PropertyType.Boolean),
                            this.CreateProp('isRequired', PropertyType.Boolean),
                            this.CreateProp('text', PropertyType.String, 'textChanged', null, true, 1000) // textChanged
                        ], [
                            this.CreateEvent('isDroppedDownChanging'),
                            this.CreateEvent('isDroppedDownChanged', true),
                            this.CreateEvent('textChanged', true)
                        ]);
                    case wijmo.input && wijmo.input.ComboBox:
                        return this.getMetaData(wijmo.input.DropDown).add([
                            this.CreateProp('displayMemberPath', PropertyType.String),
                            this.CreateProp('selectedValuePath', PropertyType.String),
                            this.CreateProp('headerPath', PropertyType.String),
                            this.CreateProp('isContentHtml', PropertyType.Boolean),
                            this.CreateProp('isEditable', PropertyType.Boolean),
                            this.CreateProp('maxDropDownHeight', PropertyType.Number),
                            this.CreateProp('maxDropDownWidth', PropertyType.Number),
                            this.CreateProp('itemFormatter', PropertyType.Function),
                            this.CreateProp('itemsSource', PropertyType.Any, '', null, true, 900),
                            this.CreateProp('selectedIndex', PropertyType.Number, 'selectedIndexChanged', null, true, 1000),
                            this.CreateProp('selectedItem', PropertyType.Any, 'selectedIndexChanged', null, true, 1000),
                            this.CreateProp('selectedValue', PropertyType.Any, 'selectedIndexChanged', null, true, 1000),
                        ], [
                            this.CreateEvent('formatItem'),
                            this.CreateEvent('selectedIndexChanged', true)
                        ])
                            .addOptions({ ngModelProperty: 'selectedValue' });
                    case wijmo.input && wijmo.input.AutoComplete:
                        return this.getMetaData(wijmo.input.ComboBox).add([
                            this.CreateProp('delay', PropertyType.Number),
                            this.CreateProp('maxItems', PropertyType.Number),
                            this.CreateProp('minLength', PropertyType.Number),
                            this.CreateProp('cssMatch', PropertyType.String),
                            this.CreateProp('itemsSourceFunction', PropertyType.Function),
                            this.CreateProp('searchMemberPath', PropertyType.String)
                        ]);
                    case wijmo.input && wijmo.input.Calendar:
                        return this.getMetaData(wijmo.Control).add([
                            this.CreateProp('monthView', PropertyType.Boolean),
                            this.CreateProp('showHeader', PropertyType.Boolean),
                            this.CreateProp('itemFormatter', PropertyType.Function),
                            this.CreateProp('itemValidator', PropertyType.Function),
                            this.CreateProp('firstDayOfWeek', PropertyType.Number),
                            this.CreateProp('max', PropertyType.Date),
                            this.CreateProp('min', PropertyType.Date),
                            this.CreateProp('formatYearMonth', PropertyType.String),
                            this.CreateProp('formatDayHeaders', PropertyType.String),
                            this.CreateProp('formatDays', PropertyType.String),
                            this.CreateProp('formatYear', PropertyType.String),
                            this.CreateProp('formatMonths', PropertyType.String),
                            this.CreateProp('selectionMode', PropertyType.Enum, '', wijmo.input.DateSelectionMode),
                            this.CreateProp('isReadOnly', PropertyType.Boolean),
                            this.CreateProp('value', PropertyType.Date, 'valueChanged'),
                            // displayMonth should go after 'value'!
                            this.CreateProp('displayMonth', PropertyType.Date, 'displayMonthChanged'),
                        ], [
                            this.CreateEvent('valueChanged', true),
                            this.CreateEvent('displayMonthChanged', true),
                            this.CreateEvent('formatItem', false)
                        ])
                            .addOptions({ ngModelProperty: 'value' });
                    case wijmo.input && wijmo.input.ColorPicker:
                        return this.getMetaData(wijmo.Control).add([
                            this.CreateProp('showAlphaChannel', PropertyType.Boolean),
                            this.CreateProp('showColorString', PropertyType.Boolean),
                            this.CreateProp('palette', PropertyType.Any),
                            this.CreateProp('value', PropertyType.String, 'valueChanged')
                        ], [
                            this.CreateEvent('valueChanged', true)
                        ])
                            .addOptions({ ngModelProperty: 'value' });
                    case wijmo.input && wijmo.input.ListBox:
                        return this.getMetaData(wijmo.Control).add([
                            this.CreateProp('isContentHtml', PropertyType.Boolean),
                            this.CreateProp('maxHeight', PropertyType.Number),
                            this.CreateProp('selectedValuePath', PropertyType.String),
                            this.CreateProp('itemFormatter', PropertyType.Function),
                            this.CreateProp('displayMemberPath', PropertyType.String),
                            this.CreateProp('checkedMemberPath', PropertyType.String),
                            this.CreateProp('itemsSource', PropertyType.Any),
                            this.CreateProp('selectedIndex', PropertyType.Number, 'selectedIndexChanged'),
                            this.CreateProp('selectedItem', PropertyType.Any, 'selectedIndexChanged'),
                            this.CreateProp('selectedValue', PropertyType.Any, 'selectedIndexChanged'),
                            this.CreateProp('checkedItems', PropertyType.Any, 'checkedItemsChanged'),
                        ], [
                            this.CreateEvent('formatItem', false),
                            this.CreateEvent('itemsChanged', true),
                            //AlexI: isPropChanged must be true, in order to run a digest and update bound expressions
                            this.CreateEvent('itemChecked', true),
                            this.CreateEvent('selectedIndexChanged', true),
                            this.CreateEvent('checkedItemsChanged', true),
                        ])
                            .addOptions({ ngModelProperty: 'selectedValue' });
                    case 'ItemTemplate':
                        return new MetaDataBase([], [], [], undefined, undefined, undefined, 'owner');
                    case wijmo.input && wijmo.input.Menu:
                        return this.getMetaData(wijmo.input.ComboBox).add([
                            this.CreateProp('header', PropertyType.String),
                            this.CreateProp('commandParameterPath', PropertyType.String),
                            this.CreateProp('commandPath', PropertyType.String),
                            this.CreateProp('isButton', PropertyType.Boolean),
                            //this.CreateProp('value', PropertyType.Any, 'selectedIndexChanged', null, false, 1000)
                            this.CreateProp('value', PropertyType.Any, 'itemClicked', null, false, 1000)
                        ], [
                            this.CreateEvent('itemClicked')
                        ]);
                    case 'MenuItem':
                        return new MetaDataBase([
                            //TBD: check whether they should be two-way
                            //this.CreateProp('value', PropertyType.String, BindingMode.TwoWay),
                            //this.CreateProp('cmd', PropertyType.String, BindingMode.TwoWay),
                            //this.CreateProp('cmdParam', PropertyType.String, BindingMode.TwoWay)
                            this.CreateProp('value', PropertyType.Any, ''),
                            this.CreateProp('cmd', PropertyType.Any, ''),
                            this.CreateProp('cmdParam', PropertyType.Any, '')
                        ], [], [], 'itemsSource', true);
                    case 'MenuSeparator':
                        return new MetaDataBase([], [], [], 'itemsSource', true);
                    case wijmo.input && wijmo.input.InputDate:
                        return this.getMetaData(wijmo.input.DropDown).add([
                            this.CreateProp('selectionMode', PropertyType.Enum, '', wijmo.input.DateSelectionMode),
                            this.CreateProp('format', PropertyType.String),
                            this.CreateProp('mask', PropertyType.String),
                            this.CreateProp('max', PropertyType.Date),
                            this.CreateProp('min', PropertyType.Date),
                            this.CreateProp('inputType', PropertyType.String),
                            this.CreateProp('value', PropertyType.Date, 'valueChanged', null, true, 1000),
                            this.CreateProp('itemValidator', PropertyType.Function),
                            this.CreateProp('itemFormatter', PropertyType.Function)
                        ], [
                            this.CreateEvent('valueChanged', true)
                        ])
                            .addOptions({ ngModelProperty: 'value' });
                    case wijmo.input && wijmo.input.InputDateTime:
                        return this.getMetaData(wijmo.input.InputDate).add([
                            this.CreateProp('timeMax', PropertyType.Date),
                            this.CreateProp('timeMin', PropertyType.Date),
                            this.CreateProp('timeStep', PropertyType.Number),
                            this.CreateProp('timeFormat', PropertyType.String),
                        ])
                            .addOptions({ ngModelProperty: 'value' });
                    case wijmo.input && wijmo.input.InputNumber:
                        return this.getMetaData(wijmo.Control).add([
                            this.CreateProp('showSpinner', PropertyType.Boolean),
                            this.CreateProp('repeatButtons', PropertyType.Boolean),
                            this.CreateProp('max', PropertyType.Number),
                            this.CreateProp('min', PropertyType.Number),
                            this.CreateProp('step', PropertyType.Number),
                            this.CreateProp('isRequired', PropertyType.Boolean),
                            this.CreateProp('placeholder', PropertyType.String),
                            this.CreateProp('inputType', PropertyType.String),
                            this.CreateProp('format', PropertyType.String),
                            this.CreateProp('isReadOnly', PropertyType.Boolean),
                            this.CreateProp('value', PropertyType.Number, 'valueChanged'),
                            this.CreateProp('text', PropertyType.String, 'textChanged')
                        ], [
                            this.CreateEvent('valueChanged', true),
                            this.CreateEvent('textChanged', true)
                        ])
                            .addOptions({ ngModelProperty: 'value' });
                    case wijmo.input && wijmo.input.InputMask:
                        return this.getMetaData(wijmo.Control).add([
                            this.CreateProp('mask', PropertyType.String),
                            this.CreateProp('isRequired', PropertyType.Boolean),
                            this.CreateProp('promptChar', PropertyType.String),
                            this.CreateProp('placeholder', PropertyType.String),
                            this.CreateProp('rawValue', PropertyType.String, 'valueChanged'),
                            this.CreateProp('value', PropertyType.String, 'valueChanged')
                        ], [
                            this.CreateEvent('valueChanged', true),
                        ])
                            .addOptions({ ngModelProperty: 'value' });
                    case wijmo.input && wijmo.input.InputTime:
                        return this.getMetaData(wijmo.input.ComboBox).add([
                            this.CreateProp('max', PropertyType.Date),
                            this.CreateProp('min', PropertyType.Date),
                            this.CreateProp('step', PropertyType.Number),
                            this.CreateProp('format', PropertyType.String),
                            this.CreateProp('mask', PropertyType.String),
                            this.CreateProp('inputType', PropertyType.String),
                            this.CreateProp('value', PropertyType.Date, 'valueChanged', null, true, 1000),
                        ], [
                            this.CreateEvent('valueChanged', true)
                        ])
                            .addOptions({ ngModelProperty: 'value' });
                    case wijmo.input && wijmo.input.InputColor:
                        return this.getMetaData(wijmo.input.DropDown).add([
                            this.CreateProp('showAlphaChannel', PropertyType.Boolean),
                            this.CreateProp('value', PropertyType.String, 'valueChanged')
                        ], [
                            this.CreateEvent('valueChanged', true)
                        ])
                            .addOptions({ ngModelProperty: 'value' });
                    case wijmo.input && wijmo.input.Popup:
                        return this.getMetaData(wijmo.Control).add([
                            this.CreateProp('owner', PropertyType.String),
                            this.CreateProp('showTrigger', PropertyType.Enum, '', wijmo.input.PopupTrigger),
                            this.CreateProp('hideTrigger', PropertyType.Enum, '', wijmo.input.PopupTrigger),
                            this.CreateProp('fadeIn', PropertyType.Boolean),
                            this.CreateProp('fadeOut', PropertyType.Boolean),
                            this.CreateProp('isDraggable', PropertyType.Boolean),
                            this.CreateProp('dialogResultEnter', PropertyType.String),
                            this.CreateProp('modal', PropertyType.Boolean),
                            this.CreateProp('removeOnHide', PropertyType.Boolean)
                        ], [
                            this.CreateEvent('showing'),
                            this.CreateEvent('shown'),
                            this.CreateEvent('hiding'),
                            this.CreateEvent('hidden'),
                        ]);
                    case wijmo.input && wijmo.input.MultiSelect:
                        return this.getMetaData(wijmo.input.ComboBox).add([
                            this.CreateProp('checkedMemberPath', PropertyType.String),
                            this.CreateProp('maxHeaderItems', PropertyType.Number),
                            this.CreateProp('headerFormat', PropertyType.String),
                            this.CreateProp('headerFormatter', PropertyType.Function),
                            this.CreateProp('showSelectAllCheckbox', PropertyType.Boolean),
                            this.CreateProp('selectAllLabel', PropertyType.String),
                            // initialized after itemsSource but before selectedXXX
                            this.CreateProp('checkedItems', PropertyType.Any, 'checkedItemsChanged', BindingMode.TwoWay, true, 950),
                        ], [
                            this.CreateEvent('checkedItemsChanged', true)
                        ])
                            .addOptions({ ngModelProperty: 'checkedItems' });
                    case 'CollectionViewNavigator':
                        return new MetaDataBase([
                            this.CreateProp('cv', PropertyType.Any)
                        ]);
                    case 'CollectionViewPager':
                        return new MetaDataBase([
                            this.CreateProp('cv', PropertyType.Any)
                        ]);
                    case wijmo.input && wijmo.input.MultiAutoComplete:
                        return this.getMetaData(wijmo.input.AutoComplete).add([
                            this.CreateProp('maxSelectedItems', PropertyType.Number),
                            this.CreateProp('selectedMemberPath', PropertyType.String, '', null, true, 950),
                            this.CreateProp('selectedItems', PropertyType.Any, 'selectedItemsChanged'),
                        ], [
                            this.CreateEvent('selectedItemsChanged', true)
                        ])
                            .addOptions({ ngModelProperty: 'selectedItems' });
                    // wijmo.grid *************************************************************
                    case wijmo.grid && wijmo.grid.FlexGrid:
                        return this.getMetaData(wijmo.Control).add([
                            this.CreateProp('newRowAtTop', PropertyType.Boolean),
                            this.CreateProp('allowAddNew', PropertyType.Boolean),
                            this.CreateProp('allowDelete', PropertyType.Boolean),
                            this.CreateProp('allowDragging', PropertyType.Enum, '', wijmo.grid.AllowDragging),
                            this.CreateProp('allowMerging', PropertyType.Enum, '', wijmo.grid.AllowMerging),
                            this.CreateProp('allowResizing', PropertyType.Enum, '', wijmo.grid.AllowResizing),
                            this.CreateProp('allowSorting', PropertyType.Boolean),
                            this.CreateProp('quickAutoSize', PropertyType.Boolean),
                            this.CreateProp('autoSizeMode', PropertyType.Enum, '', wijmo.grid.AutoSizeMode),
                            this.CreateProp('autoGenerateColumns', PropertyType.Boolean),
                            this.CreateProp('childItemsPath', PropertyType.Any),
                            this.CreateProp('groupHeaderFormat', PropertyType.String),
                            this.CreateProp('headersVisibility', PropertyType.Enum, '', wijmo.grid.HeadersVisibility),
                            this.CreateProp('showSelectedHeaders', PropertyType.Enum, '', wijmo.grid.HeadersVisibility),
                            this.CreateProp('showMarquee', PropertyType.Boolean),
                            this.CreateProp('itemFormatter', PropertyType.Function),
                            this.CreateProp('isReadOnly', PropertyType.Boolean),
                            this.CreateProp('imeEnabled', PropertyType.Boolean),
                            this.CreateProp('mergeManager', PropertyType.Any),
                            // REVIEW: This breaks the grid too, see TFS 82636
                            //this.CreateProp('scrollPosition', PropertyType.Any, '='),
                            // REVIEW: this screws up the grid when selectionMode == ListBox.
                            // When the directive applies a selection to the grid and selectionMode == ListBox,
                            // the grid clears the row[x].isSelected properties of rows that are not in the selection.
                            // I think a possible fix would be for the directive to not set the grid's selection if it
                            // is the same range as the current selection property. I cannot do that in the grid because
                            // when the user does it, this side-effect is expected.
                            //this.CreateProp('selection', PropertyType.Any, '='),
                            //this.CreateProp('columnLayout', ...),
                            this.CreateProp('selectionMode', PropertyType.Enum, '', wijmo.grid.SelectionMode),
                            this.CreateProp('showGroups', PropertyType.Boolean),
                            this.CreateProp('showSort', PropertyType.Boolean),
                            this.CreateProp('showDropDown', PropertyType.Boolean),
                            this.CreateProp('showAlternatingRows', PropertyType.Boolean),
                            this.CreateProp('showErrors', PropertyType.Boolean),
                            this.CreateProp('validateEdits', PropertyType.Boolean),
                            this.CreateProp('treeIndent', PropertyType.Number),
                            this.CreateProp('itemsSource', PropertyType.Any),
                            this.CreateProp('autoClipboard', PropertyType.Boolean),
                            this.CreateProp('frozenRows', PropertyType.Number),
                            this.CreateProp('frozenColumns', PropertyType.Number),
                            this.CreateProp('cloneFrozenCells', PropertyType.Boolean),
                            this.CreateProp('deferResizing', PropertyType.Boolean),
                            this.CreateProp('sortRowIndex', PropertyType.Number),
                            this.CreateProp('stickyHeaders', PropertyType.Boolean),
                            this.CreateProp('preserveSelectedState', PropertyType.Boolean),
                            this.CreateProp('preserveOutlineState', PropertyType.Boolean),
                            this.CreateProp('keyActionTab', PropertyType.Enum, '', wijmo.grid.KeyAction),
                            this.CreateProp('keyActionEnter', PropertyType.Enum, '', wijmo.grid.KeyAction),
                            this.CreateProp('rowHeaderPath', PropertyType.String),
                            this.CreateProp('virtualizationThreshold', PropertyType.Number)
                        ], [
                            // Cell events
                            this.CreateEvent('beginningEdit'),
                            this.CreateEvent('cellEditEnded'),
                            this.CreateEvent('cellEditEnding'),
                            this.CreateEvent('prepareCellForEdit'),
                            this.CreateEvent('formatItem'),
                            // Column events
                            this.CreateEvent('resizingColumn'),
                            this.CreateEvent('resizedColumn'),
                            this.CreateEvent('autoSizingColumn'),
                            this.CreateEvent('autoSizedColumn'),
                            this.CreateEvent('draggingColumn'),
                            this.CreateEvent('draggingColumnOver'),
                            this.CreateEvent('draggedColumn'),
                            this.CreateEvent('sortingColumn'),
                            this.CreateEvent('sortedColumn'),
                            // Row Events
                            this.CreateEvent('resizingRow'),
                            this.CreateEvent('resizedRow'),
                            this.CreateEvent('autoSizingRow'),
                            this.CreateEvent('autoSizedRow'),
                            this.CreateEvent('draggingRow'),
                            this.CreateEvent('draggingRowOver'),
                            this.CreateEvent('draggedRow'),
                            this.CreateEvent('deletingRow'),
                            this.CreateEvent('deletedRow'),
                            this.CreateEvent('loadingRows'),
                            this.CreateEvent('loadedRows'),
                            this.CreateEvent('rowEditStarting'),
                            this.CreateEvent('rowEditStarted'),
                            this.CreateEvent('rowEditEnding'),
                            this.CreateEvent('rowEditEnded'),
                            this.CreateEvent('rowAdded'),
                            this.CreateEvent('groupCollapsedChanged'),
                            this.CreateEvent('groupCollapsedChanging'),
                            this.CreateEvent('itemsSourceChanged', true),
                            this.CreateEvent('selectionChanging'),
                            this.CreateEvent('selectionChanged', true),
                            this.CreateEvent('scrollPositionChanged', false),
                            this.CreateEvent('updatingView'),
                            this.CreateEvent('updatedView'),
                            this.CreateEvent('updatingLayout'),
                            this.CreateEvent('updatedLayout'),
                            // Clipboard events
                            this.CreateEvent('pasting'),
                            this.CreateEvent('pasted'),
                            this.CreateEvent('pastingCell'),
                            this.CreateEvent('pastedCell'),
                            this.CreateEvent('copying'),
                            this.CreateEvent('copied')
                        ]);
                    case wijmo.grid && wijmo.grid.Column:
                        return new MetaDataBase([
                            this.CreateProp('name', PropertyType.String),
                            this.CreateProp('dataMap', PropertyType.Any),
                            this.CreateProp('dataType', PropertyType.Enum, '', wijmo.DataType),
                            this.CreateProp('binding', PropertyType.String),
                            this.CreateProp('sortMemberPath', PropertyType.String),
                            this.CreateProp('format', PropertyType.String),
                            this.CreateProp('header', PropertyType.String),
                            this.CreateProp('width', PropertyType.Number),
                            this.CreateProp('maxLength', PropertyType.Number),
                            this.CreateProp('minWidth', PropertyType.Number),
                            this.CreateProp('maxWidth', PropertyType.Number),
                            this.CreateProp('align', PropertyType.String),
                            this.CreateProp('allowDragging', PropertyType.Boolean),
                            this.CreateProp('allowSorting', PropertyType.Boolean),
                            this.CreateProp('allowResizing', PropertyType.Boolean),
                            this.CreateProp('allowMerging', PropertyType.Boolean),
                            this.CreateProp('aggregate', PropertyType.Enum, '', wijmo.Aggregate),
                            this.CreateProp('isReadOnly', PropertyType.Boolean),
                            this.CreateProp('cssClass', PropertyType.String),
                            this.CreateProp('isContentHtml', PropertyType.Boolean),
                            this.CreateProp('isSelected', PropertyType.Boolean, 'grid.selectionChanged'),
                            this.CreateProp('visible', PropertyType.Boolean),
                            this.CreateProp('wordWrap', PropertyType.Boolean),
                            this.CreateProp('mask', PropertyType.String),
                            this.CreateProp('inputType', PropertyType.String),
                            this.CreateProp('isRequired', PropertyType.Boolean),
                            this.CreateProp('showDropDown', PropertyType.Boolean),
                            this.CreateProp('dropDownCssClass', PropertyType.String),
                            this.CreateProp('quickAutoSize', PropertyType.Boolean),
                        ], [], [], 'columns', true);
                    case 'FlexGridCellTemplate':
                        return new MetaDataBase([
                            this.CreateProp('cellType', PropertyType.String, '', null, false),
                            this.CreateProp('cellOverflow', PropertyType.String, ''),
                            this.CreateProp('forceFullEdit', PropertyType.Boolean),
                        ], [], [], undefined, undefined, undefined, 'owner');
                    case wijmo.grid && wijmo.grid.filter && wijmo.grid.filter.FlexGridFilter:
                        return new MetaDataBase([
                            this.CreateProp('showFilterIcons', PropertyType.Boolean),
                            this.CreateProp('showSortButtons', PropertyType.Boolean),
                            this.CreateProp('defaultFilterType', PropertyType.Enum, '', wijmo.grid.filter.FilterType),
                            this.CreateProp('filterColumns', PropertyType.Any),
                        ], [
                            this.CreateEvent('filterChanging'),
                            this.CreateEvent('filterChanged'),
                            this.CreateEvent('filterApplied')
                        ], [], undefined, undefined, undefined, '');
                    case wijmo.grid && wijmo.grid.grouppanel && wijmo.grid.grouppanel.GroupPanel:
                        return this.getMetaData(wijmo.Control).add([
                            this.CreateProp('hideGroupedColumns', PropertyType.Boolean),
                            this.CreateProp('maxGroups', PropertyType.Number),
                            this.CreateProp('placeholder', PropertyType.String),
                            this.CreateProp('grid', PropertyType.Any),
                        ]);
                    case wijmo.grid && wijmo.grid.detail && wijmo.grid.detail.FlexGridDetailProvider:
                        return new MetaDataBase([
                            this.CreateProp('maxHeight', PropertyType.Number),
                            this.CreateProp('detailVisibilityMode', PropertyType.Enum, '', wijmo.grid.detail.DetailVisibilityMode),
                            this.CreateProp('rowHasDetail', PropertyType.Function),
                            this.CreateProp('isAnimated', PropertyType.Boolean),
                        ], [], [], undefined, undefined, undefined, '');
                    case wijmo.grid && wijmo.grid.sheet && wijmo.grid.sheet.FlexSheet:
                        return this.getMetaData(wijmo.grid.FlexGrid).add([
                            this.CreateProp('isTabHolderVisible', PropertyType.Boolean),
                            this.CreateProp('selectedSheetIndex', PropertyType.Number, 'selectedSheetChanged'),
                        ], [
                            this.CreateEvent('selectedSheetChanged', true),
                            this.CreateEvent('draggingRowColumn'),
                            this.CreateEvent('droppingRowColumn'),
                            this.CreateEvent('loaded'),
                            this.CreateEvent('unknownFunction'),
                            this.CreateEvent('sheetCleared')
                        ]);
                    case wijmo.grid && wijmo.grid.sheet && wijmo.grid.sheet.Sheet:
                        return new MetaDataBase([
                            this.CreateProp('name', PropertyType.String),
                            this.CreateProp('itemsSource', PropertyType.Any),
                            this.CreateProp('visible', PropertyType.Boolean),
                            this.CreateProp('rowCount', PropertyType.Number, '', null, false),
                            this.CreateProp('columnCount', PropertyType.Number, '', null, false)
                        ], [
                            this.CreateEvent('nameChanged'),
                        ])
                            .addOptions({ parentReferenceProperty: '' });
                    case wijmo.grid && wijmo.grid.multirow && wijmo.grid.multirow.MultiRow:
                        return this.getMetaData(wijmo.grid.FlexGrid).add([
                            this.CreateProp('layoutDefinition', PropertyType.Any),
                            this.CreateProp('centerHeadersVertically', PropertyType.Boolean),
                            this.CreateProp('collapsedHeaders', PropertyType.Boolean),
                            this.CreateProp('showHeaderCollapseButton', PropertyType.Boolean)
                        ]);
                    // Chart *************************************************************
                    case wijmo.chart && wijmo.chart.FlexChartBase:
                        return this.getMetaData(wijmo.Control).add([
                            this.CreateProp('binding', PropertyType.String),
                            this.CreateProp('footer', PropertyType.String),
                            this.CreateProp('header', PropertyType.String),
                            this.CreateProp('selectionMode', PropertyType.Enum, '', wijmo.chart.SelectionMode),
                            this.CreateProp('palette', PropertyType.Any),
                            this.CreateProp('plotMargin', PropertyType.Any),
                            this.CreateProp('footerStyle', PropertyType.Any),
                            this.CreateProp('headerStyle', PropertyType.Any),
                            this.CreateProp('tooltipContent', PropertyType.String, '', null, false),
                            this.CreateProp('itemsSource', PropertyType.Any)
                        ], [
                            this.CreateEvent('rendering'),
                            this.CreateEvent('rendered'),
                            this.CreateEvent('selectionChanged', true),
                        ]);
                    case wijmo.chart && wijmo.chart.FlexChartCore:
                        return this.getMetaData(wijmo.chart.FlexChartBase).add([
                            this.CreateProp('bindingX', PropertyType.String),
                            // this.CreateProp('chartType', PropertyType.Enum, '', wijmo.chart.ChartType),
                            this.CreateProp('interpolateNulls', PropertyType.Boolean),
                            this.CreateProp('legendToggle', PropertyType.Boolean),
                            this.CreateProp('symbolSize', PropertyType.Number),
                            this.CreateProp('options', PropertyType.Any),
                            this.CreateProp('selection', PropertyType.Any, 'selectionChanged'),
                            this.CreateProp('itemFormatter', PropertyType.Function),
                            this.CreateProp('labelContent', PropertyType.String, '', null, false),
                        ], [
                            this.CreateEvent('seriesVisibilityChanged'),
                        ], [
                            this.CreateComplexProp('axisX', false, false),
                            this.CreateComplexProp('axisY', false, false),
                            this.CreateComplexProp('axes', true),
                            this.CreateComplexProp('plotAreas', true)
                        ]);
                    case wijmo.chart && wijmo.chart.FlexChart:
                        return this.getMetaData(wijmo.chart.FlexChartCore).add([
                            this.CreateProp('chartType', PropertyType.Enum, '', wijmo.chart.ChartType),
                            this.CreateProp('rotated', PropertyType.Boolean),
                            this.CreateProp('stacking', PropertyType.Enum, '', wijmo.chart.Stacking),
                        ]);
                    case wijmo.chart && wijmo.chart.FlexPie:
                        return this.getMetaData(wijmo.chart.FlexChartBase).add([
                            this.CreateProp('bindingName', PropertyType.String),
                            this.CreateProp('innerRadius', PropertyType.Number),
                            this.CreateProp('isAnimated', PropertyType.Boolean),
                            this.CreateProp('offset', PropertyType.Number),
                            this.CreateProp('reversed', PropertyType.Boolean),
                            this.CreateProp('startAngle', PropertyType.Number),
                            this.CreateProp('selectedItemPosition', PropertyType.Enum, '', wijmo.chart.Position),
                            this.CreateProp('selectedItemOffset', PropertyType.Number),
                            this.CreateProp('itemFormatter', PropertyType.Function),
                            this.CreateProp('labelContent', PropertyType.String, '', null, false),
                        ]);
                    case wijmo.chart && wijmo.chart.FlexPie && wijmo.chart.hierarchical && wijmo.chart.hierarchical.Sunburst:
                        return this.getMetaData(wijmo.chart.FlexChartBase).add([
                            this.CreateProp('bindingName', PropertyType.Any),
                            this.CreateProp('innerRadius', PropertyType.Number),
                            this.CreateProp('isAnimated', PropertyType.Boolean),
                            this.CreateProp('offset', PropertyType.Number),
                            this.CreateProp('reversed', PropertyType.Boolean),
                            this.CreateProp('startAngle', PropertyType.Number),
                            this.CreateProp('selectedItemPosition', PropertyType.Enum, '', wijmo.chart.Position),
                            this.CreateProp('selectedItemOffset', PropertyType.Number),
                            this.CreateProp('itemFormatter', PropertyType.Function),
                            this.CreateProp('labelContent', PropertyType.String, '', null, false),
                            this.CreateProp('childItemsPath', PropertyType.Any)
                        ]);
                    case wijmo.chart && wijmo.chart.hierarchical && wijmo.chart.hierarchical.TreeMap:
                        return this.getMetaData(wijmo.chart.FlexChartBase).add([
                            this.CreateProp('bindingName', PropertyType.Any),
                            this.CreateProp('maxDepth', PropertyType.Number),
                            this.CreateProp('type', PropertyType.Enum, '', wijmo.chart.hierarchical.TreeMapType),
                            this.CreateProp('labelContent', PropertyType.String, '', null, false),
                            this.CreateProp('childItemsPath', PropertyType.Any)
                        ]);
                    case wijmo.chart && wijmo.chart.Axis:
                        return new MetaDataBase([
                            this.CreateProp('axisLine', PropertyType.Boolean),
                            this.CreateProp('format', PropertyType.String),
                            this.CreateProp('labels', PropertyType.Boolean),
                            this.CreateProp('majorGrid', PropertyType.Boolean),
                            this.CreateProp('majorTickMarks', PropertyType.Enum, '', wijmo.chart.TickMark),
                            this.CreateProp('majorUnit', PropertyType.Number),
                            this.CreateProp('max', PropertyType.Number),
                            this.CreateProp('min', PropertyType.Number),
                            this.CreateProp('position', PropertyType.Enum, '', wijmo.chart.Position),
                            this.CreateProp('reversed', PropertyType.Boolean),
                            this.CreateProp('title', PropertyType.String),
                            this.CreateProp('labelAngle', PropertyType.Number),
                            this.CreateProp('minorGrid', PropertyType.Boolean),
                            this.CreateProp('minorTickMarks', PropertyType.Enum, '', wijmo.chart.TickMark),
                            this.CreateProp('minorUnit', PropertyType.Number),
                            this.CreateProp('origin', PropertyType.Number),
                            this.CreateProp('logBase', PropertyType.Number),
                            this.CreateProp('plotArea', PropertyType.Any),
                            this.CreateProp('labelAlign', PropertyType.String),
                            this.CreateProp('name', PropertyType.String),
                            this.CreateProp('overlappingLabels', PropertyType.Enum, '', wijmo.chart.OverlappingLabels),
                            this.CreateProp('labelPadding', PropertyType.Number),
                            this.CreateProp('itemFormatter', PropertyType.Function),
                            this.CreateProp('itemsSource', PropertyType.Any),
                            this.CreateProp('binding', PropertyType.String),
                        ], [
                            this.CreateEvent('rangeChanged'),
                        ], [], 'axes', true); //use wj-property attribute on directive to define axisX or axisY
                    case wijmo.chart && wijmo.chart.Legend:
                        return new MetaDataBase([
                            this.CreateProp('position', PropertyType.Enum, '', wijmo.chart.Position),
                            this.CreateProp('title', PropertyType.String),
                            this.CreateProp('titleAlign', PropertyType.String)
                        ], [], [], 'legend', false, false, '');
                    case wijmo.chart && wijmo.chart.DataLabelBase:
                        return new MetaDataBase([
                            this.CreateProp('content', PropertyType.Any, ''),
                            this.CreateProp('border', PropertyType.Boolean),
                            this.CreateProp('offset', PropertyType.Number),
                            this.CreateProp('connectingLine', PropertyType.Boolean),
                        ], [
                            this.CreateEvent('rendering'),
                        ], [], 'dataLabel', false, false);
                    case wijmo.chart && wijmo.chart.DataLabel:
                        return this.getMetaData(wijmo.chart.DataLabelBase).add([
                            this.CreateProp('position', PropertyType.Enum, '', wijmo.chart.LabelPosition),
                        ]);
                    case wijmo.chart && wijmo.chart.PieDataLabel:
                        return this.getMetaData(wijmo.chart.DataLabelBase).add([
                            this.CreateProp('position', PropertyType.Enum, '', wijmo.chart.PieLabelPosition),
                        ]);
                    case wijmo.chart && wijmo.chart.SeriesBase:
                        return new MetaDataBase([
                            this.CreateProp('axisX', PropertyType.Any),
                            this.CreateProp('axisY', PropertyType.Any),
                            this.CreateProp('binding', PropertyType.String),
                            this.CreateProp('bindingX', PropertyType.String),
                            this.CreateProp('cssClass', PropertyType.String),
                            this.CreateProp('name', PropertyType.String),
                            this.CreateProp('style', PropertyType.Any),
                            this.CreateProp('altStyle', PropertyType.Any),
                            this.CreateProp('symbolMarker', PropertyType.Enum, '', wijmo.chart.Marker),
                            this.CreateProp('symbolSize', PropertyType.Number),
                            this.CreateProp('symbolStyle', PropertyType.Any),
                            this.CreateProp('visibility', PropertyType.Enum, 'chart.seriesVisibilityChanged', wijmo.chart.SeriesVisibility),
                            this.CreateProp('itemsSource', PropertyType.Any),
                        ], [
                            this.CreateEvent('rendering'),
                            this.CreateEvent('rendered')
                        ], [
                            this.CreateComplexProp('axisX', false, true),
                            this.CreateComplexProp('axisY', false, true),
                        ], 'series', true);
                    case wijmo.chart && wijmo.chart.Series:
                        return this.getMetaData(wijmo.chart.SeriesBase).add([
                            this.CreateProp('chartType', PropertyType.Enum, '', wijmo.chart.ChartType)
                        ]);
                    case wijmo.chart && wijmo.chart.LineMarker:
                        return new MetaDataBase([
                            this.CreateProp('isVisible', PropertyType.Boolean),
                            this.CreateProp('seriesIndex', PropertyType.Number),
                            this.CreateProp('horizontalPosition', PropertyType.Number),
                            this.CreateProp('content', PropertyType.Function),
                            this.CreateProp('verticalPosition', PropertyType.Number),
                            this.CreateProp('alignment', PropertyType.Enum, '', wijmo.chart.LineMarkerAlignment),
                            this.CreateProp('lines', PropertyType.Enum, '', wijmo.chart.LineMarkerLines),
                            this.CreateProp('interaction', PropertyType.Enum, '', wijmo.chart.LineMarkerInteraction),
                            this.CreateProp('dragLines', PropertyType.Boolean),
                            this.CreateProp('dragThreshold', PropertyType.Number),
                            this.CreateProp('dragContent', PropertyType.Boolean),
                        ], [
                            this.CreateEvent('positionChanged'),
                        ], [], undefined, undefined, undefined, '');
                    case wijmo.chart && wijmo.chart.DataPoint:
                        return new MetaDataBase([
                            this.CreateProp('x', PropertyType.AnyPrimitive),
                            this.CreateProp('y', PropertyType.AnyPrimitive)
                        ], [], [], '');
                    case wijmo.chart && wijmo.chart.annotation && wijmo.chart.annotation.AnnotationLayer:
                        return new MetaDataBase([], [], [], undefined, undefined, undefined, '');
                    case 'FlexChartAnnotation':
                        return new MetaDataBase([
                            this.CreateProp('type', PropertyType.String, '', null, false),
                            this.CreateProp('attachment', PropertyType.Enum, '', wijmo.chart.annotation.AnnotationAttachment),
                            this.CreateProp('position', PropertyType.Enum, '', wijmo.chart.annotation.AnnotationPosition),
                            this.CreateProp('point', PropertyType.Any),
                            this.CreateProp('seriesIndex', PropertyType.Number),
                            this.CreateProp('pointIndex', PropertyType.Number),
                            this.CreateProp('offset', PropertyType.Any),
                            this.CreateProp('style', PropertyType.Any),
                            this.CreateProp('isVisible', PropertyType.Boolean),
                            this.CreateProp('tooltip', PropertyType.String),
                            this.CreateProp('text', PropertyType.String),
                            this.CreateProp('content', PropertyType.String),
                            this.CreateProp('name', PropertyType.String),
                            this.CreateProp('width', PropertyType.Number),
                            this.CreateProp('height', PropertyType.Number),
                            this.CreateProp('start', PropertyType.Any),
                            this.CreateProp('end', PropertyType.Any),
                            this.CreateProp('radius', PropertyType.Number),
                            this.CreateProp('length', PropertyType.Number),
                            this.CreateProp('href', PropertyType.String)
                        ], [], [
                            this.CreateComplexProp('point', false, true),
                            this.CreateComplexProp('start', false, true),
                            this.CreateComplexProp('end', false, true),
                            this.CreateComplexProp('points', true),
                        ], 'items', true);
                    case wijmo.chart && wijmo.chart.interaction && wijmo.chart.interaction.RangeSelector:
                        return new MetaDataBase([
                            this.CreateProp('isVisible', PropertyType.Boolean),
                            this.CreateProp('min', PropertyType.Number),
                            this.CreateProp('max', PropertyType.Number),
                            this.CreateProp('orientation', PropertyType.Enum, '', wijmo.chart.interaction.Orientation),
                            this.CreateProp('seamless', PropertyType.Boolean),
                            this.CreateProp('minScale', PropertyType.Number),
                            this.CreateProp('maxScale', PropertyType.Number),
                        ], [
                            this.CreateEvent('rangeChanged'),
                        ], [], undefined, undefined, undefined, '');
                    case wijmo.chart && wijmo.chart.interaction && wijmo.chart.interaction.ChartGestures:
                        return new MetaDataBase([
                            this.CreateProp('mouseAction', PropertyType.Enum, '', wijmo.chart.interaction.MouseAction),
                            this.CreateProp('interactiveAxes', PropertyType.Enum, '', wijmo.chart.interaction.InteractiveAxes),
                            this.CreateProp('enable', PropertyType.Boolean),
                            this.CreateProp('scaleX', PropertyType.Number),
                            this.CreateProp('scaleY', PropertyType.Number),
                            this.CreateProp('posX', PropertyType.Number),
                            this.CreateProp('posY', PropertyType.Number),
                        ], [], [], undefined, undefined, undefined, '');
                    case wijmo.chart && wijmo.chart.animation && wijmo.chart.animation.ChartAnimation:
                        return new MetaDataBase([
                            this.CreateProp('animationMode', PropertyType.Enum, '', wijmo.chart.animation.AnimationMode),
                            this.CreateProp('easing', PropertyType.Enum, '', wijmo.chart.animation.Easing),
                            this.CreateProp('duration', PropertyType.Number),
                            this.CreateProp('axisAnimation', PropertyType.Boolean)
                        ], [], [], undefined, undefined, undefined, '');
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.FinancialChart:
                        return this.getMetaData(wijmo.chart.FlexChartCore).add([
                            this.CreateProp('chartType', PropertyType.Enum, '', wijmo.chart.finance.FinancialChartType),
                        ]);
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.FinancialSeries:
                        return this.getMetaData(wijmo.chart.SeriesBase).add([
                            this.CreateProp('chartType', PropertyType.Enum, '', wijmo.chart.finance.FinancialChartType)
                        ]);
                    case wijmo.chart && wijmo.chart.radar && wijmo.chart.radar.FlexRadar:
                        return this.getMetaData(wijmo.chart.FlexChartCore).add([
                            this.CreateProp('chartType', PropertyType.Enum, '', wijmo.chart.radar.RadarChartType),
                            this.CreateProp('startAngle', PropertyType.Number),
                            this.CreateProp('totalAngle', PropertyType.Number),
                            this.CreateProp('reversed', PropertyType.Boolean),
                            this.CreateProp('stacking', PropertyType.Enum, '', wijmo.chart.Stacking)
                        ]);
                    case wijmo.chart && wijmo.chart.radar && wijmo.chart.radar.FlexRadarSeries:
                        return this.getMetaData(wijmo.chart.SeriesBase).add([
                            this.CreateProp('chartType', PropertyType.Enum, '', wijmo.chart.radar.RadarChartType)
                        ]);
                    case wijmo.chart && wijmo.chart.radar && wijmo.chart.radar.FlexRadarAxis:
                        return this.getMetaData(wijmo.chart.Axis);
                    case wijmo.chart && wijmo.chart.analytics && wijmo.chart.analytics.TrendLineBase:
                        return this.getMetaData(wijmo.chart.SeriesBase).add([
                            this.CreateProp('sampleCount', PropertyType.Number)
                        ]);
                    case wijmo.chart && wijmo.chart.analytics && wijmo.chart.analytics.TrendLine:
                        return this.getMetaData(wijmo.chart.analytics.TrendLineBase).add([
                            this.CreateProp('order', PropertyType.Number),
                            this.CreateProp('fitType', PropertyType.Enum, '', wijmo.chart.analytics.TrendLineFitType)
                        ]);
                    case wijmo.chart && wijmo.chart.analytics && wijmo.chart.analytics.MovingAverage:
                        return this.getMetaData(wijmo.chart.analytics.TrendLineBase).add([
                            this.CreateProp('period', PropertyType.Number),
                            this.CreateProp('type', PropertyType.Enum, '', wijmo.chart.analytics.MovingAverageType)
                        ]);
                    case wijmo.chart && wijmo.chart.analytics && wijmo.chart.analytics.FunctionSeries:
                        return this.getMetaData(wijmo.chart.analytics.TrendLineBase).add([
                            this.CreateProp('min', PropertyType.Number),
                            this.CreateProp('max', PropertyType.Number),
                        ]);
                    case wijmo.chart && wijmo.chart.analytics && wijmo.chart.analytics.YFunctionSeries:
                        return this.getMetaData(wijmo.chart.analytics.FunctionSeries).add([
                            this.CreateProp('func', PropertyType.Function),
                        ]);
                    case wijmo.chart && wijmo.chart.analytics && wijmo.chart.analytics.ParametricFunctionSeries:
                        return this.getMetaData(wijmo.chart.analytics.FunctionSeries).add([
                            //Add func property for xFunc property in angular1.
                            //Attribute names beginning with "x-" is reserved for user agent use, 'x-func' is parsed to 'func'
                            //Set func value to xFunc property in WjFlexChartParametricFunctionSeries._initProps function in wijmo.angular.chart.ts file.
                            this.CreateProp('func', PropertyType.Function),
                            this.CreateProp('xFunc', PropertyType.Function),
                            this.CreateProp('yFunc', PropertyType.Function),
                        ]);
                    case wijmo.chart && wijmo.chart.analytics && wijmo.chart.analytics.Waterfall:
                        return this.getMetaData(wijmo.chart.SeriesBase).add([
                            this.CreateProp('relativeData', PropertyType.Boolean),
                            this.CreateProp('start', PropertyType.Number),
                            this.CreateProp('startLabel', PropertyType.String),
                            this.CreateProp('showTotal', PropertyType.Boolean),
                            this.CreateProp('totalLabel', PropertyType.String),
                            this.CreateProp('showIntermediateTotal', PropertyType.Boolean),
                            this.CreateProp('intermediateTotalPositions', PropertyType.Any),
                            this.CreateProp('intermediateTotalLabels', PropertyType.Any),
                            this.CreateProp('connectorLines', PropertyType.Boolean),
                            this.CreateProp('styles', PropertyType.Any)
                        ]);
                    case wijmo.chart && wijmo.chart.analytics && wijmo.chart.analytics.BoxWhisker:
                        return this.getMetaData(wijmo.chart.SeriesBase).add([
                            this.CreateProp('quartileCalculation', PropertyType.Enum, '', wijmo.chart.analytics.QuartileCalculation),
                            this.CreateProp('groupWidth', PropertyType.Number),
                            this.CreateProp('gapWidth', PropertyType.Number),
                            this.CreateProp('showMeanLine', PropertyType.Boolean),
                            this.CreateProp('meanLineStyle', PropertyType.Any),
                            this.CreateProp('showMeanMarker', PropertyType.Boolean),
                            this.CreateProp('meanMarkerStyle', PropertyType.Any),
                            this.CreateProp('showInnerPoints', PropertyType.Boolean),
                            this.CreateProp('showOutliers', PropertyType.Boolean)
                        ]);
                    case wijmo.chart && wijmo.chart.analytics && wijmo.chart.analytics.ErrorBar:
                        return this.getMetaData(wijmo.chart.Series).add([
                            this.CreateProp('errorBarStyle', PropertyType.Any),
                            this.CreateProp('value', PropertyType.Any),
                            this.CreateProp('errorAmount', PropertyType.Enum, '', wijmo.chart.analytics.ErrorAmount),
                            this.CreateProp('endStyle', PropertyType.Enum, '', wijmo.chart.analytics.ErrorBarEndStyle),
                            this.CreateProp('direction', PropertyType.Enum, '', wijmo.chart.analytics.ErrorBarDirection)
                        ]);
                    case wijmo.chart && wijmo.chart.PlotArea:
                        return new MetaDataBase([
                            this.CreateProp('column', PropertyType.Number),
                            this.CreateProp('height', PropertyType.String),
                            this.CreateProp('name', PropertyType.String),
                            this.CreateProp('row', PropertyType.Number),
                            this.CreateProp('style', PropertyType.Any),
                            this.CreateProp('width', PropertyType.String),
                        ], [], [], 'plotAreas', true);
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.analytics && wijmo.chart.finance.analytics.Fibonacci:
                        return this.getMetaData(wijmo.chart.SeriesBase).add([
                            this.CreateProp('high', PropertyType.Number),
                            this.CreateProp('low', PropertyType.Number),
                            this.CreateProp('labelPosition', PropertyType.Enum, '', wijmo.chart.LabelPosition),
                            this.CreateProp('levels', PropertyType.Any),
                            this.CreateProp('minX', PropertyType.AnyPrimitive),
                            this.CreateProp('maxX', PropertyType.AnyPrimitive),
                            this.CreateProp('uptrend', PropertyType.Boolean)
                        ]);
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.analytics && wijmo.chart.finance.analytics.FibonacciTimeZones:
                        return this.getMetaData(wijmo.chart.SeriesBase).add([
                            this.CreateProp('startX', PropertyType.Any),
                            this.CreateProp('endX', PropertyType.Any),
                            this.CreateProp('labelPosition', PropertyType.Enum, '', wijmo.chart.LabelPosition),
                            this.CreateProp('levels', PropertyType.Any)
                        ]);
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.analytics && wijmo.chart.finance.analytics.FibonacciArcs:
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.analytics && wijmo.chart.finance.analytics.FibonacciFans:
                        return this.getMetaData(wijmo.chart.SeriesBase).add([
                            this.CreateProp('start', PropertyType.Any),
                            this.CreateProp('end', PropertyType.Any),
                            this.CreateProp('labelPosition', PropertyType.Enum, '', wijmo.chart.LabelPosition),
                            this.CreateProp('levels', PropertyType.Any)
                        ]);
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.analytics && wijmo.chart.finance.analytics.OverlayIndicatorBase:
                        return this.getMetaData(wijmo.chart.SeriesBase);
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.analytics && wijmo.chart.finance.analytics.SingleOverlayIndicatorBase:
                        return this.getMetaData(wijmo.chart.finance.analytics.OverlayIndicatorBase).add([
                            this.CreateProp('period', PropertyType.Number)
                        ]);
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.analytics && wijmo.chart.finance.analytics.MacdBase:
                        return this.getMetaData(wijmo.chart.finance.analytics.OverlayIndicatorBase).add([
                            this.CreateProp('fastPeriod', PropertyType.Number),
                            this.CreateProp('slowPeriod', PropertyType.Number),
                            this.CreateProp('smoothingPeriod', PropertyType.Number)
                        ]);
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.analytics && wijmo.chart.finance.analytics.Macd:
                        return this.getMetaData(wijmo.chart.finance.analytics.MacdBase).add([
                            this.CreateProp('styles', PropertyType.Any)
                        ]);
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.analytics && wijmo.chart.finance.analytics.MacdHistogram:
                        return this.getMetaData(wijmo.chart.finance.analytics.MacdBase);
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.analytics && wijmo.chart.finance.analytics.ATR:
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.analytics && wijmo.chart.finance.analytics.RSI:
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.analytics && wijmo.chart.finance.analytics.WilliamsR:
                        return this.getMetaData(wijmo.chart.finance.analytics.SingleOverlayIndicatorBase);
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.analytics && wijmo.chart.finance.analytics.CCI:
                        return this.getMetaData(wijmo.chart.finance.analytics.SingleOverlayIndicatorBase).add([
                            this.CreateProp('constant', PropertyType.Number)
                        ]);
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.analytics && wijmo.chart.finance.analytics.Stochastic:
                        return this.getMetaData(wijmo.chart.finance.analytics.OverlayIndicatorBase).add([
                            this.CreateProp('dPeriod', PropertyType.Number),
                            this.CreateProp('kPeriod', PropertyType.Number),
                            this.CreateProp('smoothingPeriod', PropertyType.Number),
                            this.CreateProp('styles', PropertyType.Any)
                        ]);
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.analytics && wijmo.chart.finance.analytics.Envelopes:
                        return this.getMetaData(wijmo.chart.finance.analytics.OverlayIndicatorBase).add([
                            this.CreateProp('period', PropertyType.Number),
                            this.CreateProp('size', PropertyType.Number),
                            this.CreateProp('type', PropertyType.Enum, '', wijmo.chart.finance.analytics.MovingAverageType)
                        ]);
                    case wijmo.chart && wijmo.chart.finance && wijmo.chart.finance.analytics && wijmo.chart.finance.analytics.BollingerBands:
                        return this.getMetaData(wijmo.chart.finance.analytics.OverlayIndicatorBase).add([
                            this.CreateProp('period', PropertyType.Number),
                            this.CreateProp('multiplier', PropertyType.Number)
                        ]);
                    // *************************** Gauge *************************************************************
                    //case 'Gauge':
                    case wijmo.gauge && wijmo.gauge.Gauge:
                        return this.getMetaData(wijmo.Control).add([
                            this.CreateProp('value', PropertyType.Number, 'valueChanged'),
                            this.CreateProp('min', PropertyType.Number),
                            this.CreateProp('max', PropertyType.Number),
                            this.CreateProp('origin', PropertyType.Number),
                            this.CreateProp('isReadOnly', PropertyType.Boolean),
                            this.CreateProp('step', PropertyType.Number),
                            this.CreateProp('format', PropertyType.String),
                            this.CreateProp('thickness', PropertyType.Number),
                            this.CreateProp('hasShadow', PropertyType.Boolean),
                            this.CreateProp('isAnimated', PropertyType.Boolean),
                            this.CreateProp('showText', PropertyType.Enum, '', wijmo.gauge.ShowText),
                            this.CreateProp('showTicks', PropertyType.Boolean),
                            this.CreateProp('showRanges', PropertyType.Boolean),
                            this.CreateProp('thumbSize', PropertyType.Number),
                            this.CreateProp('tickSpacing', PropertyType.Number),
                            this.CreateProp('getText', PropertyType.Function)
                        ], [
                            this.CreateEvent('valueChanged', true)
                        ], [
                            this.CreateComplexProp('ranges', true),
                            this.CreateComplexProp('pointer', false, false),
                            this.CreateComplexProp('face', false, false)
                        ])
                            .addOptions({ ngModelProperty: 'value' });
                    //case 'LinearGauge':
                    case wijmo.gauge && wijmo.gauge.LinearGauge:
                        return this.getMetaData(wijmo.gauge.Gauge).add([
                            this.CreateProp('direction', PropertyType.Enum, '', wijmo.gauge.GaugeDirection)
                        ]);
                    case wijmo.gauge && wijmo.gauge.BulletGraph:
                        return this.getMetaData(wijmo.gauge.LinearGauge).add([
                            this.CreateProp('target', PropertyType.Number),
                            this.CreateProp('good', PropertyType.Number),
                            this.CreateProp('bad', PropertyType.Number)
                        ]);
                    case wijmo.gauge && wijmo.gauge.RadialGauge:
                        return this.getMetaData(wijmo.gauge.Gauge).add([
                            this.CreateProp('autoScale', PropertyType.Boolean),
                            this.CreateProp('startAngle', PropertyType.Number),
                            this.CreateProp('sweepAngle', PropertyType.Number)
                        ]);
                    case wijmo.gauge && wijmo.gauge.Range:
                        return new MetaDataBase([
                            this.CreateProp('color', PropertyType.String),
                            this.CreateProp('min', PropertyType.Number),
                            this.CreateProp('max', PropertyType.Number),
                            this.CreateProp('name', PropertyType.String),
                            this.CreateProp('thickness', PropertyType.Number)
                        ], [], [], 'ranges', true);
                    // *************************** Olap *************************************************************
                    case wijmo.olap && wijmo.olap.PivotGrid:
                        return this.getMetaData(wijmo.grid.FlexGrid).add([
                            this.CreateProp('showDetailOnDoubleClick', PropertyType.Boolean),
                            this.CreateProp('customContextMenu', PropertyType.Boolean),
                            this.CreateProp('collapsibleSubtotals', PropertyType.Boolean),
                            this.CreateProp('centerHeadersVertically', PropertyType.Boolean),
                            this.CreateProp('showColumnFieldHeaders', PropertyType.Boolean),
                            this.CreateProp('showRowFieldHeaders', PropertyType.Boolean),
                        ]);
                    case wijmo.olap && wijmo.olap.PivotChart:
                        return this.getMetaData(wijmo.Control).add([
                            this.CreateProp('chartType', PropertyType.Enum, '', wijmo.olap.PivotChartType),
                            this.CreateProp('showHierarchicalAxes', PropertyType.Boolean),
                            this.CreateProp('showTotals', PropertyType.Boolean),
                            this.CreateProp('showTitle', PropertyType.Boolean),
                            this.CreateProp('showLegend', PropertyType.Enum, '', wijmo.olap.LegendVisibility),
                            this.CreateProp('legendPosition', PropertyType.Enum, '', wijmo.chart.Position),
                            this.CreateProp('stacking', PropertyType.Enum, '', wijmo.chart.Stacking),
                            this.CreateProp('maxSeries', PropertyType.Number),
                            this.CreateProp('maxPoints', PropertyType.Number),
                            this.CreateProp('itemsSource', PropertyType.Any),
                        ]);
                    case wijmo.olap && wijmo.olap.PivotPanel:
                        return this.getMetaData(wijmo.Control).add([
                            this.CreateProp('autoGenerateFields', PropertyType.Boolean),
                            this.CreateProp('viewDefinition', PropertyType.String),
                            this.CreateProp('engine', PropertyType.Any),
                            this.CreateProp('itemsSource', PropertyType.Any),
                            this.CreateProp('showFieldIcons', PropertyType.Boolean),
                            this.CreateProp('restrictDragging', PropertyType.Boolean),
                        ], [
                            this.CreateEvent('itemsSourceChanged'),
                            this.CreateEvent('viewDefinitionChanged'),
                            this.CreateEvent('updatingView'),
                            this.CreateEvent('updatedView')
                        ]);
                    case wijmo.olap && wijmo.olap.PivotField:
                        return new MetaDataBase([
                            this.CreateProp('binding', PropertyType.String),
                            this.CreateProp('header', PropertyType.String),
                            this.CreateProp('dataType', PropertyType.Enum, '', wijmo.DataType),
                        ], [], [], '', true, true, '');
                    // *************************** ReportViewer *************************************************************
                    case wijmo.viewer && wijmo.viewer.ViewerBase:
                        return new MetaDataBase([
                            this.CreateProp('serviceUrl', PropertyType.String),
                            this.CreateProp('filePath', PropertyType.String),
                            this.CreateProp('fullScreen', PropertyType.Boolean, 'fullScreenChanged'),
                            this.CreateProp('zoomFactor', PropertyType.Number, 'zoomFactorChanged'),
                            this.CreateProp('mouseMode', PropertyType.Enum, 'mouseModeChanged', wijmo.viewer.MouseMode),
                            this.CreateProp('selectMouseMode', PropertyType.Boolean, 'selectMouseModeChanged'),
                            this.CreateProp('viewMode', PropertyType.Enum, 'viewModeChanged', wijmo.viewer.ViewMode),
                        ], [
                            this.CreateEvent('pageIndexChanged'),
                            this.CreateEvent('viewModeChanged'),
                            this.CreateEvent('mouseModeChanged'),
                            this.CreateEvent('selectMouseModeChanged'),
                            this.CreateEvent('fullScreenChanged'),
                            this.CreateEvent('zoomFactorChanged', true),
                            this.CreateEvent('queryLoadingData')
                        ]);
                    case wijmo.viewer && wijmo.viewer.ReportViewer:
                        return this.getMetaData(wijmo.viewer.ViewerBase).add([
                            this.CreateProp('paginated', PropertyType.Boolean),
                            this.CreateProp('reportName', PropertyType.String),
                        ]);
                    // *************************** PdfViewer *************************************************************
                    case wijmo.viewer && wijmo.viewer.PdfViewer:
                        return this.getMetaData(wijmo.viewer.ViewerBase);
                    // *************************** TreeView *************************************************************
                    case wijmo.nav && wijmo.nav.TreeView:
                        return this.getMetaData(wijmo.Control).add([
                            this.CreateProp('childItemsPath', PropertyType.Any),
                            this.CreateProp('displayMemberPath', PropertyType.Any),
                            this.CreateProp('imageMemberPath', PropertyType.Any),
                            this.CreateProp('isContentHtml', PropertyType.Boolean),
                            this.CreateProp('showCheckboxes', PropertyType.Boolean),
                            this.CreateProp('autoCollapse', PropertyType.Boolean),
                            this.CreateProp('isAnimated', PropertyType.Boolean),
                            this.CreateProp('isReadOnly', PropertyType.Boolean),
                            this.CreateProp('allowDragging', PropertyType.Boolean),
                            this.CreateProp('expandOnClick', PropertyType.Boolean),
                            this.CreateProp('lazyLoadFunction', PropertyType.Function),
                            this.CreateProp('itemsSource', PropertyType.Any),
                            this.CreateProp('selectedItem', PropertyType.Any, 'selectedItemChanged'),
                            this.CreateProp('selectedNode', PropertyType.Any, 'selectedItemChanged'),
                            this.CreateProp('checkedItems', PropertyType.Any, 'checkedItemsChanged'),
                        ], [
                            this.CreateEvent('itemsSourceChanged', true),
                            this.CreateEvent('loadingItems'),
                            this.CreateEvent('loadedItems'),
                            this.CreateEvent('itemClicked'),
                            this.CreateEvent('selectedItemChanged'),
                            this.CreateEvent('checkedItemsChanged', true),
                            this.CreateEvent('isCollapsedChanging'),
                            this.CreateEvent('isCollapsedChanged'),
                            this.CreateEvent('isCheckedChanging'),
                            this.CreateEvent('isCheckedChanged'),
                            this.CreateEvent('formatItem'),
                            this.CreateEvent('dragStart'),
                            this.CreateEvent('dragOver'),
                            this.CreateEvent('drop'),
                            this.CreateEvent('dragEnd'),
                            this.CreateEvent('nodeEditStarting'),
                            this.CreateEvent('nodeEditStarted'),
                            this.CreateEvent('nodeEditEnding'),
                            this.CreateEvent('nodeEditEnded')
                        ]);
                }
                return new MetaDataBase([]);
            };
            // For the specified class reference returns its name as a string, e.g.
            // getClassName(wijmo.input.ComboBox) returns 'ComboBox'.
            ControlMetaFactory.getClassName = function (classRef) {
                return (classRef.toString().match(/function (.+?)\(/) || [, ''])[1];
            };
            // Returns a camel case representation of the dash delimited name.
            ControlMetaFactory.toCamelCase = function (s) {
                return s.toLowerCase().replace(/-(.)/g, function (match, group1) {
                    return group1.toUpperCase();
                });
            };
            ControlMetaFactory.findInArr = function (arr, propName, value) {
                for (var i in arr) {
                    if (arr[i][propName] === value) {
                        return arr[i];
                    }
                }
                return null;
            };
            return ControlMetaFactory;
        }());
        meta.ControlMetaFactory = ControlMetaFactory;
        // Describes a scope property: name, type, binding mode.
        // Also defines enum type and custom watcher function extender
        var PropDescBase = /** @class */ (function () {
            // Initializes a new instance of a PropDesc
            function PropDescBase(propertyName, propertyType, /*bindingMode: BindingMode = BindingMode.OneWay*/ changeEvent, enumType, isNativeControlProperty, priority) {
                if (isNativeControlProperty === void 0) { isNativeControlProperty = true; }
                if (priority === void 0) { priority = 0; }
                this._priority = 0;
                this._propertyName = propertyName;
                this._propertyType = propertyType;
                //this._bindingMode = bindingMode;
                this._changeEvent = changeEvent;
                this._enumType = enumType;
                this._isNativeControlProperty = isNativeControlProperty;
                this._priority = priority;
            }
            Object.defineProperty(PropDescBase.prototype, "propertyName", {
                // Gets the property name
                get: function () {
                    return this._propertyName;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(PropDescBase.prototype, "propertyType", {
                // Gets the property type (number, string, boolean, enum, or any)
                get: function () {
                    return this._propertyType;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(PropDescBase.prototype, "changeEvent", {
                get: function () {
                    return this._changeEvent;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(PropDescBase.prototype, "enumType", {
                // Gets the property enum type
                get: function () { return this._enumType; },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(PropDescBase.prototype, "bindingMode", {
                // Gets the property binding mode
                get: function () {
                    //return this._bindingMode;
                    return this.changeEvent ? BindingMode.TwoWay : BindingMode.OneWay;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(PropDescBase.prototype, "isNativeControlProperty", {
                // Gets whether the property belongs to the control is just to the directive
                get: function () {
                    return this._isNativeControlProperty;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(PropDescBase.prototype, "priority", {
                // Gets an initialization priority. Properties with higher priority are assigned to directive's underlying control
                // property later than properties with lower priority. Properties with the same priority are assigned in the order of
                // their index in the _props collection.
                get: function () {
                    return this._priority;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(PropDescBase.prototype, "shouldUpdateSource", {
                // Indicates whether a bound 'controller' property should be updated on this property change (i.e. two-way binding).
                get: function () {
                    return this.bindingMode === BindingMode.TwoWay && this.propertyType != PropertyType.EventHandler;
                },
                enumerable: true,
                configurable: true
            });
            PropDescBase.prototype.initialize = function (options) {
                wijmo.copy(this, options);
            };
            // Casts value to the property type
            PropDescBase.prototype.castValueToType = function (value) {
                if (value == undefined) {
                    return value;
                }
                var type = this.propertyType, pt = PropertyType;
                if (type === pt.AnyPrimitive) {
                    if (!wijmo.isString(value)) {
                        return value;
                    }
                    if (value === 'true' || value === 'false') {
                        type = pt.Boolean;
                    }
                    else {
                        castVal = +value;
                        if (!isNaN(castVal)) {
                            return castVal;
                        }
                        var castVal = this._parseDate(value);
                        if (!wijmo.isString(castVal)) {
                            return castVal;
                        }
                        return value;
                    }
                }
                switch (type) {
                    case pt.Number:
                        if (typeof value == 'string') {
                            if (value.indexOf('*') >= 0) {
                                return value;
                            }
                            if (value.trim() === '') {
                                return null;
                            }
                        }
                        return +value; // cast to number
                    case pt.Boolean:
                        if (value === 'true') {
                            return true;
                        }
                        if (value === 'false') {
                            return false;
                        }
                        return !!value; // cast to bool
                    case pt.String:
                        return value + ''; // cast to string
                    case pt.Date:
                        return this._parseDate(value);
                    case pt.Enum:
                        if (typeof value === 'number') {
                            return value;
                        }
                        return this.enumType[value];
                    default:
                        return value;
                }
            };
            // Parsing DateTime values from string
            PropDescBase.prototype._parseDate = function (value) {
                if (value && wijmo.isString(value)) {
                    // For by-val attributes Angular converts a Date object to a
                    // string wrapped in quotation marks, so we strip them.
                    value = value.replace(/["']/g, '');
                    // parse date/time using RFC 3339 pattern
                    var dt = wijmo.changeType(value, wijmo.DataType.Date, 'r');
                    if (wijmo.isDate(dt)) {
                        return dt;
                    }
                }
                return value;
            };
            return PropDescBase;
        }());
        meta.PropDescBase = PropDescBase;
        // Property types as used in the PropDesc class.
        var PropertyType;
        (function (PropertyType) {
            PropertyType[PropertyType["Boolean"] = 0] = "Boolean";
            PropertyType[PropertyType["Number"] = 1] = "Number";
            PropertyType[PropertyType["Date"] = 2] = "Date";
            PropertyType[PropertyType["String"] = 3] = "String";
            // Allows a value of any primitive type above, that can be parsed from string
            PropertyType[PropertyType["AnyPrimitive"] = 4] = "AnyPrimitive";
            PropertyType[PropertyType["Enum"] = 5] = "Enum";
            PropertyType[PropertyType["Function"] = 6] = "Function";
            PropertyType[PropertyType["EventHandler"] = 7] = "EventHandler";
            PropertyType[PropertyType["Any"] = 8] = "Any";
        })(PropertyType = meta.PropertyType || (meta.PropertyType = {}));
        // Gets a value that indicates whether the specified type is simple (true) or complex (false).
        function isSimpleType(type) {
            return type <= PropertyType.Enum;
        }
        meta.isSimpleType = isSimpleType;
        var BindingMode;
        (function (BindingMode) {
            BindingMode[BindingMode["OneWay"] = 0] = "OneWay";
            BindingMode[BindingMode["TwoWay"] = 1] = "TwoWay";
        })(BindingMode = meta.BindingMode || (meta.BindingMode = {}));
        // Describes a scope event
        var EventDescBase = /** @class */ (function () {
            // Initializes a new instance of an EventDesc
            function EventDescBase(eventName, isPropChanged) {
                this._eventName = eventName;
                this._isPropChanged = isPropChanged;
            }
            Object.defineProperty(EventDescBase.prototype, "eventName", {
                // Gets the event name
                get: function () {
                    return this._eventName;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(EventDescBase.prototype, "isPropChanged", {
                // Gets whether this event is a property change notification
                get: function () {
                    return this._isPropChanged === true;
                },
                enumerable: true,
                configurable: true
            });
            return EventDescBase;
        }());
        meta.EventDescBase = EventDescBase;
        // Describe property info for nested directives.
        var ComplexPropDescBase = /** @class */ (function () {
            function ComplexPropDescBase(propertyName, isArray, ownsObject) {
                if (ownsObject === void 0) { ownsObject = false; }
                this.isArray = false;
                this._ownsObject = false;
                this.propertyName = propertyName;
                this.isArray = isArray;
                this._ownsObject = ownsObject;
            }
            Object.defineProperty(ComplexPropDescBase.prototype, "ownsObject", {
                get: function () {
                    return this.isArray || this._ownsObject;
                },
                enumerable: true,
                configurable: true
            });
            return ComplexPropDescBase;
        }());
        meta.ComplexPropDescBase = ComplexPropDescBase;
        // Stores a control metadata as arrays of property, event and complex property descriptors.
        var MetaDataBase = /** @class */ (function () {
            function MetaDataBase(props, events, complexProps, parentProperty, isParentPropertyArray, ownsObject, parentReferenceProperty, ngModelProperty) {
                this._props = [];
                this._events = [];
                this._complexProps = [];
                this.props = props;
                this.events = events;
                this.complexProps = complexProps;
                this.parentProperty = parentProperty;
                this.isParentPropertyArray = isParentPropertyArray;
                this.ownsObject = ownsObject;
                this.parentReferenceProperty = parentReferenceProperty;
                this.ngModelProperty = ngModelProperty;
            }
            Object.defineProperty(MetaDataBase.prototype, "props", {
                get: function () {
                    return this._props;
                },
                set: function (value) {
                    this._props = value || [];
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(MetaDataBase.prototype, "events", {
                get: function () {
                    return this._events;
                },
                set: function (value) {
                    this._events = value || [];
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(MetaDataBase.prototype, "complexProps", {
                get: function () {
                    return this._complexProps;
                },
                set: function (value) {
                    this._complexProps = value || [];
                },
                enumerable: true,
                configurable: true
            });
            // Adds the specified arrays to the end of corresponding arrays of this object, and overwrite the simple properties
            // if specified. Returns 'this'.
            MetaDataBase.prototype.add = function (props, events, complexProps, parentProperty, isParentPropertyArray, ownsObject, parentReferenceProperty, ngModelProperty) {
                return this.addOptions({
                    props: props,
                    events: events,
                    complexProps: complexProps,
                    parentProperty: parentProperty,
                    isParentPropertyArray: isParentPropertyArray,
                    ownsObject: ownsObject,
                    parentReferenceProperty: parentReferenceProperty,
                    ngModelProperty: ngModelProperty
                });
                //this._props = this._props.concat(props || []);
                //this._events = this._events.concat(events || []);
                //this._complexProps = this._complexProps.concat(complexProps || []);
                //if (parentProperty !== undefined) {
                //    this.parentProperty = parentProperty;
                //}
                //if (isParentPropertyArray !== undefined) {
                //    this.isParentPropertyArray = isParentPropertyArray;
                //}
                //if (ownsObject !== undefined) {
                //    this.ownsObject = ownsObject;
                //}
                //if (parentReferenceProperty !== undefined) {
                //    this.parentReferenceProperty = parentReferenceProperty;
                //}
                //if (ngModelProperty !== undefined) {
                //    this.ngModelProperty = ngModelProperty;
                //}
                //return this;
            };
            MetaDataBase.prototype.addOptions = function (options) {
                for (var prop in options) {
                    var thisValue = this[prop], optionsValue = options[prop];
                    if (thisValue instanceof Array) {
                        this[prop] = thisValue.concat(optionsValue || []);
                    }
                    else if (optionsValue !== undefined) {
                        this[prop] = optionsValue;
                    }
                }
                return this;
            };
            // Prepares a raw defined metadata for a usage, for example sorts the props array on priority.
            MetaDataBase.prototype.prepare = function () {
                // stable sort of props on priority
                var baseArr = [].concat(this._props);
                this._props.sort(function (a, b) {
                    var ret = a.priority - b.priority;
                    if (!ret) {
                        ret = baseArr.indexOf(a) - baseArr.indexOf(b);
                    }
                    return ret;
                });
            };
            return MetaDataBase;
        }());
        meta.MetaDataBase = MetaDataBase;
    })(meta = wijmo.meta || (wijmo.meta = {}));
})(wijmo || (wijmo = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var wijmo;
(function (wijmo) {
    var angular;
    (function (angular) {
        var MetaFactory = /** @class */ (function (_super) {
            __extends(MetaFactory, _super);
            function MetaFactory() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            // Override to return wijmo.angular.PropDesc
            MetaFactory.CreateProp = function (propertyName, propertyType, changeEvent, enumType, isNativeControlProperty, priority) {
                return new PropDesc(propertyName, propertyType, changeEvent, enumType, isNativeControlProperty, priority);
            };
            // Override to return wijmo.angular.EventDesc
            MetaFactory.CreateEvent = function (eventName, isPropChanged) {
                return new EventDesc(eventName, isPropChanged);
            };
            // Override to return wijmo.angular.ComplexPropDesc
            MetaFactory.CreateComplexProp = function (propertyName, isArray, ownsObject) {
                return new ComplexPropDesc(propertyName, isArray, ownsObject);
            };
            // Typecast override.
            MetaFactory.findProp = function (propName, props) {
                return wijmo.meta.ControlMetaFactory.findProp(propName, props);
            };
            // Typecast override.
            MetaFactory.findEvent = function (eventName, events) {
                return wijmo.meta.ControlMetaFactory.findEvent(eventName, events);
            };
            // Typecast override.
            MetaFactory.findComplexProp = function (propName, props) {
                return wijmo.meta.ControlMetaFactory.findComplexProp(propName, props);
            };
            return MetaFactory;
        }(wijmo.meta.ControlMetaFactory));
        angular.MetaFactory = MetaFactory;
        // Describes a scope property: name, type, binding mode. 
        // Also defines enum type and custom watcher function extender
        var PropDesc = /** @class */ (function (_super) {
            __extends(PropDesc, _super);
            // Initializes a new instance of a PropDesc
            function PropDesc(propertyName, propertyType, changeEvent, enumType, isNativeControlProperty, priority) {
                var _this = _super.call(this, propertyName, propertyType, changeEvent, enumType, isNativeControlProperty, priority) || this;
                _this._scopeBindingMode = _this.propertyType === wijmo.meta.PropertyType.EventHandler ? '&' :
                    (_this.bindingMode == wijmo.meta.BindingMode.OneWay &&
                        wijmo.meta.isSimpleType(_this.propertyType) ? '@' : '=');
                return _this;
            }
            Object.defineProperty(PropDesc.prototype, "scopeBindingMode", {
                // Gets or sets the property binding mode ('@' - by val, '=' - by ref, '&' - expression)
                get: function () {
                    return this._scopeBindingMode;
                },
                set: function (value) {
                    this._scopeBindingMode = value;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(PropDesc.prototype, "customHandler", {
                // Defines a custom handler function called before assigning a new value to the control property.
                // The handler may optionally return a 'true' value that indicates that assignment is handled 
                // by the handler and prevents the directive from performing the assignment by itself.
                get: function () {
                    return this._customHandler;
                },
                set: function (value) {
                    this._customHandler = value;
                },
                enumerable: true,
                configurable: true
            });
            return PropDesc;
        }(wijmo.meta.PropDescBase));
        angular.PropDesc = PropDesc;
        // Describes a scope event
        var EventDesc = /** @class */ (function (_super) {
            __extends(EventDesc, _super);
            function EventDesc() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return EventDesc;
        }(wijmo.meta.EventDescBase));
        angular.EventDesc = EventDesc;
        // Describes property info for nested directives.
        var ComplexPropDesc = /** @class */ (function (_super) {
            __extends(ComplexPropDesc, _super);
            function ComplexPropDesc() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return ComplexPropDesc;
        }(wijmo.meta.ComplexPropDescBase));
        angular.ComplexPropDesc = ComplexPropDesc;
    })(angular = wijmo.angular || (wijmo.angular = {}));
})(wijmo || (wijmo = {}));

//
// AngularJS base directive class
//
var wijmo;
(function (wijmo) {
    var angular;
    (function (angular) {
        // Base class for AngularJS directives (abstract class).
        var WjDirective = /** @class */ (function () {
            // Initializes a new instance of the DirectiveBase class 
            function WjDirective() {
                // Tells directive to replace or not original tag with the template
                this.replace = true;
                // Defines the way directive can be used in HTML
                this.restrict = 'E'; // all directives are HTML elements
                // Defines directive's template
                this.template = '<div />';
                // Tells directive to move content into template element marked with
                // 'ng-transclude' attribute
                this.transclude = false;
                //#endregion Settings
                // Directive property map
                // Holds PropDesc[] array with Wijmo control's properties available in directive's scope
                this._props = [];
                // Directive events map
                // Holds EventDesc[] array with Wijmo control's events available in directive's scope
                this._events = [];
                // Property descriptions used by nested directives.
                this._complexProps = [];
                var self = this;
                this._dirId = (++WjDirective._dirIdCounter) + '';
                this.link = this._postLinkFn();
                this.controller = ['$scope', '$parse', '$element', function ($scope, $parse, $element) {
                        // 'this' points to the controller instance here
                        self._$parse = $parse;
                        $element[0][WjDirective._elemScopeProp] = $scope;
                        this[WjDirective._cntrlScopeProp] = $scope;
                        $scope[WjDirective._scopeChildrenProp] = [];
                        self._controllerImpl(this, $scope, $element);
                    }];
                this._initDirective();
            }
            // TS 2.2.1 bug(?) workaround:
            // error TS2448: Build: Block-scoped variable '_versionOk' used before its declaration.
            // _versionOk should be declared before its usage
            // Determines whether the specified version is not older than the current Angular version.
            WjDirective._versionOk = function (minVer) {
                var angVer = window['angular'].version;
                var angVerParts = [angVer.major, angVer.minor, angVer.dot];
                var verParts = minVer.split(".");
                if (verParts.length !== angVerParts.length)
                    throw 'Unrecognizable version number.';
                for (var i = 0; i < verParts.length; i++) {
                    if (angVerParts[i] < verParts[i]) {
                        return false;
                    }
                    else if (angVerParts[i] > verParts[i]) {
                        return true;
                    }
                }
                return true;
            };
            Object.defineProperty(WjDirective.prototype, "_controlConstructor", {
                // Gets the constructor for the related Wijmo control. 
                // Abstract member, must be overridden in inherited class
                get: function () {
                    throw 'Abstract method call';
                },
                enumerable: true,
                configurable: true
            });
            // Gets the metadata ID, see the wijmo.meta.getMetaData method description for details.
            WjDirective.prototype._getMetaDataId = function () {
                return this._controlConstructor;
            };
            // Gets directive metadata.
            WjDirective.prototype._getMetaData = function () {
                return angular.MetaFactory.getMetaData(this._getMetaDataId());
            };
            // Initializes DDO properties
            WjDirective.prototype._initDirective = function () {
                this._initSharedMeta();
                this._prepareProps();
                this._initEvents();
                this._initScopeEvents();
                this._initScopeDescription();
            };
            // Initialize _props, _events and _complexProps with the shared metadata from wijmo.meta.ControlMetaFactory.
            WjDirective.prototype._initSharedMeta = function () {
                var meta = this._getMetaData();
                this._props = meta.props;
                this._events = meta.events;
                this._complexProps = meta.complexProps;
                this._property = meta.parentProperty;
                this._isPropertyArray = meta.isParentPropertyArray;
                this._ownObject = meta.ownsObject;
                this._parentReferenceProperty = meta.parentReferenceProperty;
                this._ngModelProperty = meta.ngModelProperty;
            };
            // Initializes control's property map. Abstract member, must be overridden in inherited class
            WjDirective.prototype._initProps = function () {
            };
            // Initializes control's event map. Abstract member, must be overridden in inherited class
            WjDirective.prototype._initEvents = function () {
            };
            // Creates and returns WjLink instance pertain to the directive.
            WjDirective.prototype._createLink = function () {
                return new WjLink();
            };
            // Implements a controller body, override it to implement a custom controller logic.
            // controller - a pointer to controller object.
            // scope - controller (and corresponding WjLink) scope.
            //
            // The DDO.controller property is occupied by our wrapper that creates a controller with the _cntrlScope property assigned
            // to the controller's scope. The wrapper then calls this method that is intended to implement a custom controller logic.
            WjDirective.prototype._controllerImpl = function (controller, scope, tElement) {
            };
            // Initializes control owned by the directive 
            WjDirective.prototype._initControl = function (element) {
                // Try to create Wijmo Control if directive is related to any
                try {
                    var controlConstructor = this._controlConstructor;
                    var control = new controlConstructor(element);
                    return control;
                }
                // if not - do nothing
                catch (e) {
                    // Do nothing. Return 'undefined' explicitly
                    return undefined;
                }
            };
            // Indicates whether this directive can operate as a child directive.
            WjDirective.prototype._isChild = function () {
                return this._isParentInitializer() || this._isParentReferencer();
            };
            // Indicates whether this directive operates as a child directive that initializes a property of its parent.
            WjDirective.prototype._isParentInitializer = function () {
                return this._property != undefined;
            };
            // Indicates whether this directive operates as a child directive that references a parent in its property or
            // a constructor.
            WjDirective.prototype._isParentReferencer = function () {
                return this._parentReferenceProperty != undefined;
            };
            // For the specified scope/control property name returns its corresponding directive tag attribute name.
            WjDirective.prototype._scopeToAttrName = function (scopeName) {
                var alias = this.scope[scopeName];
                if (alias) {
                    var bindMarkLen = 1, aliasLen = alias.length;
                    if (aliasLen < 2) {
                        return scopeName;
                    }
                    if (alias.charAt(1) === '?') {
                        bindMarkLen = 2;
                    }
                    if (aliasLen === bindMarkLen) {
                        return scopeName;
                    }
                    return alias.substr(bindMarkLen);
                }
                return scopeName;
            };
            WjDirective.prototype._getComplexPropDesc = function (propName) {
                return angular.MetaFactory.findComplexProp(propName, this._complexProps);
            };
            // Extends control's property map with events
            // Do not confuse with _initEvents(), which is abstract.
            WjDirective.prototype._initScopeEvents = function () {
                for (var i in this._events) {
                    var event = this._events[i];
                    this._props.push(new angular.PropDesc(event.eventName, wijmo.meta.PropertyType.EventHandler));
                }
            };
            // Creates isolated scope based on directive property map
            WjDirective.prototype._initScopeDescription = function () {
                var props = this._props, scope = {}, 
                // 1.1.1
                byRefMark = WjDirective._optionalAttr ? '=?' : '=';
                // fill result object with control properties
                if (props != null) {
                    var prop;
                    for (var i = 0; i < props.length; i++) {
                        prop = props[i];
                        scope[prop.propertyName] = prop.scopeBindingMode;
                        //1.1.1
                        if (WjDirective._optionalAttr && prop.scopeBindingMode == '=')
                            scope[prop.propertyName] = '=?';
                    }
                }
                // add property for control
                scope['control'] = byRefMark;
                scope[WjDirective._initPropAttr] = byRefMark;
                scope[WjDirective._initEventAttr] = '&';
                scope[WjDirective._parPropAttr] = '@';
                scope[WjDirective._wjModelPropAttr] = '@';
                // save result
                this.scope = scope;
            };
            // Returns the directive's 'link' function.
            // This is a virtual method, can be overridden by derived classes.
            // @param beforeLinkDelegate Delegate to run before the link function
            // @param afterLinkDelegate Delegate to run after the link function
            // @return Directive's link function
            WjDirective.prototype._postLinkFn = function () {
                var self = this;
                // Final directive link function
                var linkFunction = function (scope, tElement, tAttrs, controller) {
                    var link = self._createLink();
                    link.directive = self;
                    link.scope = scope;
                    link.tElement = tElement;
                    link.tAttrs = tAttrs;
                    if (wijmo.isArray(controller)) {
                        var parEl = tElement.parent();
                        // If working Angular version supports the isolateScope function then we use it, because in this case
                        // the scope function returns a non-isolated scope; otherwise we use scope that returns an isolated scope
                        // in this case.
                        // isolateScope()/scope() will return undefined in case of disabled debug data
                        // ( $compileProvider.debugInfoEnabled(false) ). So we store and retrieve
                        // the scope from the DOM element ourselves.
                        //var scopeFunc: Function = parEl.isolateScope || parEl.scope;
                        //var parScope = scopeFunc.call(parEl);
                        var parScope = parEl[0][WjDirective._elemScopeProp];
                        for (var i in controller) {
                            var curCntrl = controller[i];
                            if (curCntrl != undefined) {
                                //if (!link.controller) {
                                if (curCntrl[WjDirective._cntrlScopeProp] === scope) {
                                    //require parent controller by name
                                    curCntrl = tElement.parent().controller(self._stripRequire(+i));
                                }
                                if (curCntrl && curCntrl[WjDirective._cntrlScopeProp] === parScope) {
                                    link.controller = curCntrl;
                                    break;
                                    //continue;
                                }
                                //}
                            }
                        }
                    }
                    else {
                        link.controller = controller;
                    }
                    link.ngModel = tElement.controller('ngModel');
                    link._link();
                };
                return linkFunction;
            };
            // Gathers PropertyDesc(s) and sorts them (using stable sort) in a priority order.
            WjDirective.prototype._prepareProps = function () {
                // gather property descriptors
                this._initProps();
                // stable sort on priority
                var baseArr = [].concat(this._props);
                this._props.sort(function (a, b) {
                    var ret = a.priority - b.priority;
                    if (!ret) {
                        ret = baseArr.indexOf(a) - baseArr.indexOf(b);
                    }
                    return ret;
                });
            };
            // For the 'require' property represented by an array, returns its value at the specified index stripped of a leading specifier.
            WjDirective.prototype._stripRequire = function (index) {
                if (!this._stripReq) {
                    this._stripReq = [];
                    this._stripReq.length = this['require'].length;
                }
                if (!this._stripReq[index]) {
                    var patt = /^[^A-Za-z]*(.*)/;
                    var res = patt.exec(this['require'][index]);
                    this._stripReq[index] = res ? res[1] : '';
                }
                return this._stripReq[index];
            };
            // Gets a directive unique ID
            WjDirective.prototype._getId = function () {
                return this._dirId;
            };
            // removes ng-transclude from the specified elements and all its child elements
            WjDirective._removeTransclude = function (html) {
                if (!html) {
                    return html;
                }
                var root = document.createElement('div');
                root.innerHTML = html;
                var transNodes = root.querySelectorAll('[ng-transclude]');
                [].forEach.call(transNodes, function (elem, idx) {
                    elem.removeAttribute('ng-transclude');
                });
                return root.innerHTML;
            };
            // Name of the child directive attribute defining a parent property name to assign to.
            WjDirective._parPropAttr = 'wjProperty';
            // Name of the attribute that allows to specify an alternative control property controlled by the ng-model directive.
            WjDirective._wjModelPropAttr = 'wjModelProperty';
            // Name of the attribute that provides the 'initialized' state value.
            WjDirective._initPropAttr = 'isInitialized';
            // Name of the attribute representing the 'initialized' event.
            WjDirective._initEventAttr = 'initialized';
            // Name of the property storing a reference to controller (link) scope in controllers.
            WjDirective._cntrlScopeProp = '_cntrlScope';
            // Name of the property storing a reference to a scope in DOM element.
            WjDirective._elemScopeProp = '_elemCntrl';
            // Name of the property in controller storing a reference to a link owning this controller.
            // Warning: the name must begin with '$', in order to not break tools like ng-inspector - this differentiate
            // special scope properties from scope's data properties.
            WjDirective._cntrlLinkProp = '$_thisLink';
            // Name of the scope property storing a collection of child links.
            WjDirective._scopeChildrenProp = '$_childLinks';
            // Name of an attribute storing a directive ID
            WjDirective._dirIdAttr = 'wj-directive-id';
            // Indicates whether optional scope attributes ('=?') are supported by the current version of Angular.
            WjDirective._optionalAttr = WjDirective._versionOk("1.1.4");
            // Indicates whether DDO.template function is supported by the current version of Angular.
            WjDirective._dynaTemplates = WjDirective._optionalAttr;
            // Attribute prefixes stripped by Angular
            WjDirective._angStripPrefixes = ['data', 'x'];
            WjDirective._dirIdCounter = 0;
            return WjDirective;
        }());
        angular.WjDirective = WjDirective;
        var WjLink = /** @class */ (function () {
            function WjLink() {
                // Hash containing <property name> - true pairs for scope properties that can't be assigned.
                this._nonAssignable = {};
                // Hash containing <property name> - PropDesc pairs for all properties that have defined tag attributes.
                this._definedProps = {};
                // Hash containing <event name> - EventDesc pairs for all events that have defined tag attributes.
                this._definedEvents = {};
                // Hash containing <property name> - any pairs containing previous scope values for the $watch function. 
                this._oldValues = {};
                /* private */ this._isInitialized = false;
                this._hasTriggeredInitialized = false;
                this._isNgModelInitialized = false;
                this._scopeSuspend = 0;
                this._suspendedEvents = [];
                this._areChlildrenReady = false;
                this._isDestroyed = false;
                // #region 'initialized' stuff
                this._isAppliedToParent = false;
            }
            WjLink.prototype._link = function () {
                var dir = this.directive, self = this;
                this.tElement[0].setAttribute(WjDirective._dirIdAttr, dir._getId());
                this.directiveTemplateElement = dir.replace ? this.tElement : window['angular'].element(this.tElement.children()[0]);
                this._initNonAssignable();
                if (this._isChild()) {
                    //Defines initial _parentPropDesc, which can be overridden later in the _parentReady method.
                    this._parentPropDesc = new angular.ComplexPropDesc(dir._property, dir._isPropertyArray, dir._ownObject);
                    // Register this link as a child in the parent link's scope and postpone initialization
                    this.controller[WjDirective._cntrlScopeProp][WjDirective._scopeChildrenProp].push(this);
                    var parentScope = this.controller[WjDirective._cntrlScopeProp], parentLink = parentScope[WjDirective._cntrlLinkProp];
                    if (parentLink && parentLink._areChlildrenReady) {
                        this._parentReady(parentLink);
                    }
                }
                else {
                    this._createInstance();
                    this._notifyReady();
                    this._prepareControl();
                }
                this._destroyEhUnreg = this.scope.$on('$destroy', function (event) {
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        args[_i - 1] = arguments[_i];
                    }
                    self._destroy();
                });
            };
            // This method can be overridden to implement custom application of child directives. Child directives are already 
            // initialized at this moment. 
            WjLink.prototype._onChildrenReady = function () {
            };
            WjLink.prototype._createInstance = function () {
                this.control = this._initControl();
                this._safeApply(this.scope, 'control', this.control);
            };
            // This method is called by the parent link for the child link to notify that parent link's control is created.
            WjLink.prototype._parentReady = function (parentLink) {
                if (!this._isChild())
                    return;
                var self = this;
                // In case where parent property name is defined via attribute by a user, in early Angular versions (e.g. 1.1.1)
                // the scope is not initialized with attribute values defined on directive tag. To manage this we watch this attribute
                // and init the link when its value appears.
                if (this._isAttrDefined(WjDirective._parPropAttr) && !this.scope[WjDirective._parPropAttr]) {
                    this.scope.$watch(WjDirective._parPropAttr, function () {
                        self._parentReady(parentLink);
                    });
                    return;
                }
                var parProp = this._getParentProp();
                //Override _parentPropDesc if it's defined for the servicing property in the parent link's directive.
                var parPropDescOverride = parentLink.directive._getComplexPropDesc(parProp);
                if (parPropDescOverride) {
                    this._parentPropDesc = parPropDescOverride;
                }
                else {
                    this._parentPropDesc.propertyName = parProp;
                }
                this.parent = parentLink;
                if (this._useParentObj()) {
                    this.control = parentLink.control[parProp];
                    this._safeApply(this.scope, 'control', this.control);
                }
                else {
                    this._createInstance();
                }
                this._notifyReady();
                this._prepareControl();
                this._initParent();
                this.directiveTemplateElement[0].style.display = 'none';
                this._appliedToParent();
            };
            // Assigns/adds this directive's object to the parent object.
            WjLink.prototype._initParent = function () {
                if (this._useParentObj())
                    return;
                var dir = this.directive, propName = this._getParentProp(), parCtrl = this.parent.control, ctrl = this.control;
                if (this._isParentInitializer()) {
                    if (this._isParentArray()) {
                        // insert child at correct index, which is the same as an index of the directive element amid sibling directives
                        // of the same type
                        var parArr = parCtrl[propName], linkIdx = this._getIndex();
                        if (linkIdx < 0 || linkIdx >= parArr.length) {
                            linkIdx = parArr.length;
                        }
                        parArr.splice(linkIdx, 0, ctrl);
                        var self = this;
                        this._siblingInsertedEH = this._siblingInserted.bind(this);
                        this.tElement[0].addEventListener('DOMNodeInserted', this._siblingInsertedEH);
                    }
                    else {
                        parCtrl[propName] = ctrl;
                    }
                }
                if (this._isParentReferencer() && !this._parentInCtor()) {
                    ctrl[this._getParentReferenceProperty()] = parCtrl;
                }
            };
            // Performes directive removal (currently called for child directives only).
            WjLink.prototype._destroy = function () {
                if (this._isDestroyed) {
                    return;
                }
                this._isDestroyed = true;
                var control = this.control;
                if (this._destroyEhUnreg) {
                    //this._destroyEhUnreg();
                    this._destroyEhUnreg = null;
                }
                if (this._siblingInsertedEH) {
                    this.tElement[0].removeEventListener('DOMNodeInserted', this._siblingInsertedEH);
                }
                if (this._isParentArray() && !this.parent._isDestroyed) {
                    var parControl = this.parent.control, parProp = this._getParentProp();
                    if (parControl && parProp && control) {
                        var parArr = parControl[parProp];
                        if (parArr) {
                            var idx = parArr.indexOf(control);
                            if (idx >= 0) {
                                parArr.splice(idx, 1);
                            }
                        }
                    }
                }
                this.tElement[0][WjDirective._elemScopeProp] = null;
                if (control instanceof wijmo.Control) {
                    // We call dispose() with a delay, to get directives such as ng-if/ng-repeat a chance to remove its child subtree
                    // before the control will be disposed. Otherwise, Control.dispose() replaces its host element with an assignment 
                    // to outerHTML, that creates an element clone in its parent with a different pointer, not the one that
                    // ng-if stores locally, so this clone is out of ng-if control and stays in DOM forever.
                    setTimeout(function () {
                        if (control.hostElement) {
                            control.dispose();
                        }
                    }, 0);
                }
            };
            WjLink.prototype._siblingInserted = function (e) {
                if (e.target === this.tElement[0]) {
                    var lIdx = this._getIndex(), parArr = this.parent.control[this._getParentProp()], ctrl = this.control, arrIdx = parArr.indexOf(ctrl);
                    if (lIdx >= 0 && arrIdx >= 0 && lIdx !== arrIdx) {
                        parArr.splice(arrIdx, 1);
                        lIdx = Math.min(lIdx, parArr.length);
                        parArr.splice(lIdx, 0, ctrl);
                    }
                }
            };
            // Notify child links after this directive was attached to its control.
            WjLink.prototype._notifyReady = function () {
                // Notify child links
                //
                this.scope[WjDirective._cntrlLinkProp] = this;
                //
                var childLinks = [].concat(this.scope[WjDirective._scopeChildrenProp]);
                for (var i = 0; i < childLinks.length; i++) {
                    childLinks[i]._parentReady(this);
                }
                // Clear children list to free references for GC.
                //childLinks.length = 0; //cleared one by one by the _childInitialized method
                this._areChlildrenReady = true;
                this._onChildrenReady();
            };
            // Creates a control instance owned by the directive. 
            WjLink.prototype._initControl = function () {
                return this.directive._initControl(this._parentInCtor() ? this.parent.control : this.directiveTemplateElement[0]);
            };
            // Defines scope's default values, registers properties watchers and event handlers
            WjLink.prototype._prepareControl = function () {
                this._addEventHandlers();
                this._addWatchers();
            };
            // Sets control's default values to scope properties
            WjLink.prototype._setupScopeWithControlProperties = function () {
                var prop, name, scopeValue, controlValue, control = this.control, scope = this.scope, props = this.directive._props;
                for (var i = 0; i < props.length; i++) {
                    prop = props[i];
                    if (prop.scopeBindingMode === '=' && prop.isNativeControlProperty && prop.shouldUpdateSource) {
                        name = prop.propertyName;
                        scopeValue = scope[name];
                        controlValue = control[name];
                        var isFunction = prop.propertyType == wijmo.meta.PropertyType.Function;
                        var isEventHandler = prop.propertyType == wijmo.meta.PropertyType.EventHandler;
                        if (this._canApply(scope, prop.propertyName) && controlValue != scopeValue && !isFunction && !isEventHandler) {
                            scope[prop.propertyName] = controlValue;
                        }
                    }
                }
                if (!scope['$root'].$$phase) {
                    scope.$apply();
                }
            };
            WjLink.prototype._initNonAssignable = function () {
                var parse = this.directive._$parse, scopeDef = this.directive.scope, 
                //props = Object.getOwnPropertyNames(scopeDef),
                binding;
                for (var name in scopeDef) {
                    if (scopeDef[name].charAt(0) === '=') {
                        binding = this.tAttrs[this.directive._scopeToAttrName(name)];
                        if (binding === undefined || parse(binding).assign == undefined) {
                            this._nonAssignable[name] = true;
                        }
                    }
                }
            };
            WjLink.prototype._suspendScope = function () {
                this._scopeSuspend++;
            };
            WjLink.prototype._resumeScope = function () {
                if (this._scopeSuspend > 0) {
                    if (--this._scopeSuspend === 0 && this._suspendedEvents.length > 0) {
                        this._updateScope();
                    }
                }
            };
            WjLink.prototype._isScopeSuspended = function () {
                return this._scopeSuspend > 0;
            };
            WjLink.prototype._isAttrDefined = function (name) {
                return this.tAttrs.$attr[this.directive._scopeToAttrName(name)] != null;
            };
            // Called by child link when its fully initialized
            WjLink.prototype._childInitialized = function (child) {
                var childLinks = this.scope[WjDirective._scopeChildrenProp], idx = childLinks.indexOf(child);
                if (idx >= 0) {
                    childLinks.splice(idx, 1);
                    this._checkRaiseInitialized();
                }
            };
            // Called after first watch on this links has worked out.
            WjLink.prototype._thisInitialized = function () {
                this._checkRaiseInitialized();
            };
            // Called after this control and all its child directives were initialized.
            WjLink.prototype._initialized = function () {
            };
            // For the child link, called after this link has applied (added to array, assigned) its object to the parent.
            WjLink.prototype._appliedToParent = function () {
                this._isAppliedToParent = true;
                this._checkRaiseInitialized();
            };
            WjLink.prototype._checkRaiseInitialized = function () {
                if (!this._hasTriggeredInitialized && this.scope[WjDirective._scopeChildrenProp].length === 0 && this._isInitialized
                    && (!this._isChild() || this._isAppliedToParent)) {
                    this._hasTriggeredInitialized = true;
                    this._initialized();
                    // set the scope isInitialized property to true
                    this._safeApply(this.scope, WjDirective._initPropAttr, true);
                    // raise the initialized event
                    var handler = this.scope[WjDirective._initEventAttr], self = this;
                    if (handler) {
                        // delay the event to allow the 'isInitialized' property value be propagated to a controller scope before 
                        // the event is raised
                        setTimeout(function () {
                            handler({ s: self.control, e: undefined });
                        }, 0);
                    }
                    //notify parent
                    if (this._isChild() && this.parent) {
                        this.parent._childInitialized(this);
                    }
                }
            };
            //#endregion 'initialized' stuff
            // Adds watchers for scope properties to update control values
            WjLink.prototype._addWatchers = function () {
                var self = this, props = this.directive._props, scope = this.scope;
                if (!props) {
                    return;
                }
                if (this.ngModel) {
                    var ngModel = this.ngModel;
                    // Patch: in Angular 1.3+ these classes are initially set but then removed by Angular,
                    // probably because directive's replace=true ???
                    if (ngModel.$pristine) {
                        wijmo.addClass(this.tElement[0], 'ng-pristine');
                    }
                    if (ngModel.$valid) {
                        wijmo.addClass(this.tElement[0], 'ng-valid');
                    }
                    if (ngModel.$untouched) {
                        wijmo.addClass(this.tElement[0], 'ng-untouched');
                    }
                    // end patch
                    ngModel.$render = this._ngModelRender.bind(this);
                    this._updateNgModelPropDesc();
                    if (this._isAttrDefined(WjDirective._wjModelPropAttr)) {
                        scope.$watch(WjDirective._wjModelPropAttr, function () {
                            self._updateNgModelPropDesc();
                            self._ngModelRender();
                        });
                    }
                }
                var i, name, prop;
                for (i = 0; i < props.length; i++) {
                    prop = props[i];
                    name = prop.propertyName;
                    if (prop.propertyType !== wijmo.meta.PropertyType.EventHandler && this._isAttrDefined(name)) {
                        this._definedProps[name] = prop;
                    }
                }
                var control = this.control;
                scope.$watch(function (scope) {
                    if (self._isDestroyed) {
                        return;
                    }
                    try {
                        var assignValues = {};
                        for (var name in self._definedProps) {
                            if (scope[name] !== self._oldValues[name]) {
                                assignValues[name] = scope[name];
                            }
                        }
                        for (var name in assignValues) {
                            var newVal = assignValues[name], oldVal = self._oldValues[name];
                            if (newVal !== oldVal) {
                                self._oldValues[name] = newVal;
                                if (self._isInitialized || newVal !== undefined) {
                                    // get value from scope
                                    var prop = self._definedProps[name], value = self._nullOrValue(self._castValueToType(newVal, prop));
                                    // check that the control value is out-of-date
                                    var oldCtrlVal = control[name];
                                    if (oldCtrlVal != value) {
                                        // invoke custom handler (if any) to handle the change
                                        var handled = false;
                                        if (prop.customHandler != null) {
                                            handled = prop.customHandler(scope, control, value, oldCtrlVal, self);
                                        }
                                        // apply value to control if it's a native property
                                        // (as opposed to directive-only property) and if custom handler
                                        // didn't signal that the assignment is already handled
                                        if (prop.isNativeControlProperty && handled !== true) {
                                            control[name] = value;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    finally {
                        if (!self._isInitialized) {
                            self._isNgModelInitialized = true;
                            //TBD: apply it according to the associated property's priority order
                            if (self.ngModel) {
                                if (self.ngModel.$viewValue !== undefined) {
                                    self._ngModelRender();
                                }
                                else if (self._ngModelPropDesc) {
                                    self.ngModel.$setViewValue(control[self._ngModelPropDesc.propertyName]);
                                    self.ngModel.$setPristine();
                                }
                            }
                            self._isInitialized = true;
                            self._setupScopeWithControlProperties();
                            self._thisInitialized();
                        }
                    }
                });
            };
            // Adds handlers for control events
            WjLink.prototype._addEventHandlers = function () {
                var i, event, evList = this.directive._events;
                for (i = 0; i < evList.length; i++) {
                    event = evList[i];
                    this._addEventHandler(event); // avoiding 'i' closure
                }
            };
            WjLink.prototype._addEventHandler = function (eventDesc) {
                var self = this, eventName = eventDesc.eventName, controlEvent = this.control[eventName];
                // check that the event name is valid
                if (controlEvent == null) {
                    throw 'Event "' + eventName + '" not found in ' + self.constructor.name;
                }
                var isDefined = this._isAttrDefined(eventName);
                if (isDefined) {
                    this._definedEvents[eventName] = eventDesc;
                }
                else if (!eventDesc.isPropChanged) {
                    // don't subscribe if event is neither subscribed nor "isPropChanged" event.
                    return;
                }
                var scope = this.scope, props = this.directive._props, control = this.control;
                // add the event handler
                controlEvent.addHandler(function (s, e) {
                    var eventInfo = { eventDesc: eventDesc, s: s, e: e };
                    if (self._isScopeSuspended()) {
                        self._suspendedEvents.push(eventInfo);
                    }
                    else {
                        self._updateScope(eventInfo);
                    }
                }, control);
            };
            // Updates scope values with control values for two-way bindings.
            WjLink.prototype._updateScope = function (eventInfo) {
                if (eventInfo === void 0) { eventInfo = null; }
                if (this._isDestroyed) {
                    return;
                }
                // apply changes to scope
                var update = eventInfo ? eventInfo.eventDesc.isPropChanged :
                    this._suspendedEvents.some(function (value) {
                        return value.eventDesc.isPropChanged;
                    }), self = this;
                //var hasChanges = false;
                if (update) {
                    var props = this.directive._props;
                    for (var i = 0; i < props.length; i++) {
                        var p = props[i];
                        if (p.scopeBindingMode == '=' && p.isNativeControlProperty && p.shouldUpdateSource) {
                            var name = p.propertyName, value = this.control[name];
                            if (this._shouldApply(this.scope, name, value)) {
                                this.scope[name] = value;
                                //
                                this.directive._$parse(this.tAttrs[this.directive._scopeToAttrName(name)]).assign(this.scope.$parent, value);
                                //
                                //hasChanges = true;
                            }
                            if (this._ngModelPropDesc && this._isInitialized &&
                                this._ngModelPropDesc.propertyName == name && this.ngModel.$viewValue !== value) {
                                this.ngModel.$setViewValue(value);
                            }
                        }
                    }
                }
                var raiseEvents = function () {
                    var suspEvArr = eventInfo ? [eventInfo] : this._suspendedEvents;
                    //for (var i in suspEvArr) { 
                    for (var i = 0; i < suspEvArr.length; i++) {
                        var suspInfo = suspEvArr[i], eventName = suspInfo.eventDesc.eventName, scopeHandler = this.scope[eventName];
                        if (self._definedEvents[eventName] && scopeHandler) {
                            scopeHandler({ s: suspInfo.s, e: suspInfo.e });
                        }
                    }
                    if (!eventInfo) {
                        this._suspendedEvents.length = 0;
                    }
                }.bind(this);
                if (update) {
                    if (!this.scope['$root'].$$phase) {
                        this.scope.$apply();
                        //raiseEvents();
                    }
                    else {
                        // We may be in a call to directive's scope $watch finalizing the digest, so there is a chance that 
                        // there will be no more digests and changes made here to directive scope will not propagate to controller
                        // scope. To manage with this we initiate one more digest cycle by adding a dummy watch to the scope.
                        // We don't use setTimeout($apply(), 0) for this purpose to guarantee that all changes will be applied
                        // in this digest where we are now.
                        var dispose = this.scope.$watch('value', function () {
                            // dispose the watch right away
                            dispose();
                            //raiseEvents();
                        });
                    }
                }
                raiseEvents();
            };
            // ngModel.$render function implementation
            WjLink.prototype._ngModelRender = function () {
                if (!this._isNgModelInitialized) {
                    return;
                }
                var viewValue = this.ngModel.$viewValue, propDesc = this._ngModelPropDesc;
                if (!propDesc || viewValue === undefined && !this._isInitialized) {
                    return;
                }
                var value = this._nullOrValue(this._castValueToType(viewValue, propDesc));
                if (viewValue !== this.control[propDesc.propertyName]) {
                    this.control[propDesc.propertyName] = viewValue;
                }
            };
            // Casts value to the property type
            WjLink.prototype._castValueToType = function (value, prop) {
                return prop.castValueToType(value);
                //if (value == undefined) {
                //    //return undefined;
                //    return value;
                //}
                //var type = prop.propertyType;
                //switch (type) {
                //    case wijmo.meta.PropertyType.Number:
                //        if (typeof value == 'string') {
                //            if (value.indexOf('*') >= 0) { // hack for star width ('*', '2*'...)
                //                return value;
                //            }
                //            if (value.trim() === '') { // binding to an empty html input means null
                //                return null;
                //            }
                //        }
                //        return +value; // cast to number
                //    case wijmo.meta.PropertyType.Boolean:
                //        if (value === 'true') {
                //            return true;
                //        }
                //        if (value === 'false') {
                //            return false;
                //        }
                //        return !!value; // cast to bool
                //    case wijmo.meta.PropertyType.String:
                //        return value + ''; // cast to string
                //    case wijmo.meta.PropertyType.Date:
                //        return this._parseDate(value);
                //    case wijmo.meta.PropertyType.Enum:
                //        if (typeof value === 'number') {
                //            return value;
                //        }
                //        return prop.enumType[value];
                //    default:
                //        return value;
                //}
            };
            //// Parsing DateTime values from string
            //private _parseDate(value) {
            //    if (value && wijmo.isString(value)) {
            //        // For by-val attributes Angular converts a Date object to a
            //        // string wrapped in quotation marks, so we strip them.
            //        value = value.replace(/["']/g, '');
            //        // parse date/time using RFC 3339 pattern
            //        var dt = changeType(value, DataType.Date, 'r');
            //        if (isDate(dt)) {
            //            return dt;
            //        }
            //    }
            //    return value;
            //}
            //Determines whether this is a child link.
            //NOTE: functionality is *not* based on _parentPropDesc
            WjLink.prototype._isChild = function () {
                return this.directive._isChild();
            };
            // Indicates whether this directive operates as a child directive that initializes a property of its parent.
            WjLink.prototype._isParentInitializer = function () {
                return this.directive._isParentInitializer();
            };
            // Indicates whether this directive operates as a child directive that references a parent in its property or
            // a constructor.
            WjLink.prototype._isParentReferencer = function () {
                return this.directive._isParentReferencer();
            };
            //For the child directives returns parent's property name that it services. Property name defined via
            //the wjProperty attribute of directive tag has priority over the directive._property definition.
            //NOTE: functionality is *not* based on _parentPropDesc
            WjLink.prototype._getParentProp = function () {
                return this._isParentInitializer() ? this.scope[WjDirective._parPropAttr] || this.directive._property : undefined;
            };
            // For a child directive, the name of the property of the directive's underlying object that receives the reference
            // to the parent, or an empty string that indicates that the reference to the parent should be passed as the 
            // underlying object's constructor parameter.
            WjLink.prototype._getParentReferenceProperty = function () {
                return this.directive._parentReferenceProperty;
            };
            // Determines whether the child link uses an object created by the parent property, instead of creating it by
            // itself, and thus object's initialization should be delayed until parent link's control is created.
            //IMPORTANT: functionality is *based* on _parentPropDesc
            WjLink.prototype._useParentObj = function () {
                return !this._isParentReferencer() &&
                    this._isParentInitializer() && !this._parentPropDesc.isArray && !this._parentPropDesc.ownsObject;
            };
            // For the child link, determines whether the servicing parent property is an array.
            //IMPORTANT: functionality is *based* on _parentPropDesc
            WjLink.prototype._isParentArray = function () {
                return this._isParentInitializer() && this._parentPropDesc.isArray;
            };
            // For the child referencer directive, indicates whether the parent should be passed as a parameter the object
            // constructor.
            WjLink.prototype._parentInCtor = function () {
                return this._isParentReferencer() && this._getParentReferenceProperty() == '';
            };
            WjLink.prototype._getNgModelProperty = function () {
                return this.scope[WjDirective._wjModelPropAttr] || this.directive._ngModelProperty;
            };
            WjLink.prototype._updateNgModelPropDesc = function () {
                var ngModelProp = this._getNgModelProperty();
                this._ngModelPropDesc = wijmo.isNullOrWhiteSpace(ngModelProp) ?
                    null :
                    angular.MetaFactory.findProp(ngModelProp, this.directive._props);
            };
            // apply value to scope and notify
            WjLink.prototype._safeApply = function (scope, name, value) {
                // check that value and scope are defined, and that value changed
                if (this._shouldApply(scope, name, value)) {
                    // apply new value to scope and notify
                    scope[name] = value;
                    if (!scope.$root.$$phase) {
                        scope.$apply();
                    }
                    return true;
                }
                return false;
            };
            // Detrmines whether value should be assigned to scope[name], depending on optional attribute support in current Angular version.
            WjLink.prototype._shouldApply = function (scope, name, value) {
                return this._canApply(scope, name) && value != scope[name];
            };
            // Detrmines whether scope[name] can be safely updated without getting an exception.
            WjLink.prototype._canApply = function (scope, name) {
                return !this._nonAssignable[name];
            };
            // Returns null for undefined or null value; otherwise, the original value.
            WjLink.prototype._nullOrValue = function (value) {
                return value != undefined ? value : null;
            };
            // Gets an index of this link among another links pertain to the same directive type.
            WjLink.prototype._getIndex = function () {
                var thisEl = this.tElement[0], parEl = thisEl.parentElement;
                // If parentElement is null, e.g. because this element is temporary in DocumentFragment, the index
                // of the element isn't relevant to the item's position in the array, so we return -1 and thus force
                // a calling code to not reposition the item in the array at all.  
                if (!parEl) {
                    return -1;
                }
                var siblings = parEl.childNodes, idx = -1, dirId = this.directive._getId();
                for (var i = 0; i < siblings.length; i++) {
                    var curEl = siblings[i];
                    if (curEl.nodeType == 1 && curEl.getAttribute(WjDirective._dirIdAttr) == dirId) {
                        ++idx;
                        if (curEl === thisEl) {
                            return idx;
                        }
                    }
                }
                return -1;
            };
            return WjLink;
        }());
        angular.WjLink = WjLink;
    })(angular = wijmo.angular || (wijmo.angular = {}));
})(wijmo || (wijmo = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
//
// AngularJS directives for wijmo module
//
var wijmo;
(function (wijmo) {
    var angular;
    (function (angular) {
        //#region "Container directives registration"
        var wijmoContainers = window['angular'].module('wj.container', []);
        wijmoContainers.directive('wjTooltip', [function () {
                return new WjTooltip();
            }]);
        wijmoContainers.directive('wjValidationError', [function () {
                return new WjValidationError();
            }]);
        //#endregion "Container directives definitions"
        //#region "Container directives classes"
        /**
         * AngularJS directive for the @see:Tooltip class.
         *
         * Use the <b>wj-tooltip</b> directive to add tooltips to elements on the page.
         * The wj-tooltip directive supports HTML content, smart positioning, and touch.
         *
         * The wj-tooltip directive is specified as a parameter added to the
         * element that the tooltip applies to. The parameter value is the tooltip
         * text or the id of an element that contains the text. For example:
         *
         * <pre>&lt;p wj-tooltip="#fineprint" &gt;
         *     Regular paragraph content...&lt;/p&gt;
         * ...
         * &lt;div id="fineprint" style="display:none"&gt;
         *   &lt;h3&gt;Important Note&lt;/h3&gt;
         *   &lt;p&gt;
         *     Data for the current quarter is estimated
         *     by pro-rating etc.&lt;/p&gt;
         * &lt;/div&gt;</pre>
         */
        var WjTooltip = /** @class */ (function (_super) {
            __extends(WjTooltip, _super);
            // Initializes a new instance of WjTooltip
            function WjTooltip() {
                var _this = _super.call(this) || this;
                _this.restrict = 'A';
                _this.template = '';
                return _this;
            }
            Object.defineProperty(WjTooltip.prototype, "_controlConstructor", {
                // Returns Wijmo Tooltip control constructor
                get: function () {
                    return wijmo.Tooltip;
                },
                enumerable: true,
                configurable: true
            });
            WjTooltip.prototype._initControl = function (element) {
                return new wijmo.Tooltip();
            };
            WjTooltip.prototype._createLink = function () {
                return new WjTooltipLink();
            };
            return WjTooltip;
        }(angular.WjDirective));
        var WjTooltipLink = /** @class */ (function (_super) {
            __extends(WjTooltipLink, _super);
            function WjTooltipLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            //override
            WjTooltipLink.prototype._link = function () {
                _super.prototype._link.call(this);
                var tt = this.control, // hack as Tooltip is not Control
                self = this;
                this.tAttrs.$observe('wjTooltip', function (value) {
                    tt.setTooltip(self.tElement[0], value);
                });
            };
            return WjTooltipLink;
        }(angular.WjLink));
        /**
         * AngularJS directive for custom validations based on expressions.
         *
         * The <b>wj-validation-error</b> directive supports both AngularJS and native HTML5
         * validation mechanisms. It accepts an arbitrary AngularJS expression that should return
         * an error message string in case of the invalid input and an empty string if the input is valid.
         *
         * For AngularJS validation it should be used together with the <b>ng-model</b> directive.
         * In this case the <b>wj-validation-error</b> directive reports an error using a call
         * to the <b>NgModelController.$setValidity</b> method with the <b>wjValidationError</b> error key ,
         * in the same way as it happens with AngularJS native and custom validation directives.
         *
         * For HTML5 validation, the <b>wj-validation-error</b> directive sets the error state to the
         * element using the <b>setCustomValidity</b> method from the HTML5 validation API. For example:
         *
         * <pre>&lt;p&gt;HTML5 validation:&lt;/p&gt;
         * &lt;form&gt;
         *     &lt;input type="password"
         *         placeholder="Password"
         *         name="pwd" ng-model="thePwd"
         *         required minlength="2" /&gt;
         *     &lt;input type="password"
         *         placeholder="Check Password"
         *         name="chk" ng-model="chkPwd"
         *         wj-validation-error="chkPwd != thePwd ? 'Passwords don\'t match' : ''" /&gt;
         * &lt;/form&gt;
         *
         * &lt;p&gt;AngularJS validation:&lt;/p&gt;
         * &lt;form name="ngForm" novalidate&gt;
         *     &lt;input type="password"
         *         placeholder="Password"
         *         name="pwd" ng-model="thePwd"
         *         required minlength="2" /&gt;
         *     &lt;input type="password"
         *         placeholder="Check Password"
         *         name="chk" ng-model="chkPwd"
         *         wj-validation-error="chkPwd != thePwd" /&gt;
         *     &lt;div
         *         ng-show="ngForm.chk.$error.wjValidationError && !ngForm.chk.$pristine"&gt;
         *         Sorry, the passwords don't match.
         *     &lt;/div&gt;
         * &lt;/form&gt;</pre>
         *
         */
        var WjValidationError = /** @class */ (function (_super) {
            __extends(WjValidationError, _super);
            // Initializes a new instance of WjValidationError
            function WjValidationError() {
                var _this = _super.call(this) || this;
                _this.restrict = 'A';
                _this.template = '';
                _this.require = 'ngModel';
                _this.scope = false;
                return _this;
            }
            WjValidationError.prototype._postLinkFn = function () {
                return function (scope, tElement, tAttrs, controller) {
                    // scope, elm, attrs, ctl
                    // directive name
                    var dn = 'wjValidationError';
                    // update valid state when the expression result changes
                    scope.$watch(tAttrs[dn], function (errorMsg) {
                        // get input element to validate
                        var e = (tElement[0].tagName == 'INPUT' ? tElement[0] : tElement[0].querySelector('input'));
                        // accept booleans as well as strings
                        if (typeof (errorMsg) == 'boolean') {
                            errorMsg = errorMsg ? 'error' : '';
                        }
                        // HTML5 validation
                        if (e && e.setCustomValidity) {
                            e.setCustomValidity(errorMsg);
                        }
                        // AngularJS validation
                        if (controller) {
                            controller.$setValidity(dn, errorMsg ? false : true);
                        }
                    });
                };
            };
            WjValidationError.prototype._getMetaDataId = function () {
                return 'ValidationError';
            };
            return WjValidationError;
        }(angular.WjDirective));
        //#endregion "Container directives classes"
    })(angular = wijmo.angular || (wijmo.angular = {}));
})(wijmo || (wijmo = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
//
// AngularJS directives for wijmo.input module
//
var wijmo;
(function (wijmo) {
    var angular;
    (function (angular) {
        //#region "Input directives registration"
        var wijmoInput = window['angular'].module('wj.input', []); // angular module for Wijmo inputs
        // register only if module is loaded
        if (wijmo.input && wijmo.input.InputNumber) {
            wijmoInput.directive('wjAutoComplete', ['$compile', function ($compile) {
                    return new WjAutoComplete($compile);
                }]);
            wijmoInput.directive('wjCalendar', [function () {
                    return new WjCalendar();
                }]);
            wijmoInput.directive('wjColorPicker', [function () {
                    return new WjColorPicker();
                }]);
            wijmoInput.directive('wjComboBox', ['$compile', function ($compile) {
                    return new WjComboBox($compile);
                }]);
            wijmoInput.directive('wjInputDate', [function () {
                    return new WjInputDate();
                }]);
            wijmoInput.directive('wjInputDateTime', [function () {
                    return new WjInputDateTime();
                }]);
            wijmoInput.directive('wjInputNumber', [function () {
                    return new WjInputNumber();
                }]);
            wijmoInput.directive('wjInputMask', [function () {
                    return new WjInputMask();
                }]);
            wijmoInput.directive('wjInputTime', ['$compile', function ($compile) {
                    return new WjInputTime($compile);
                }]);
            wijmoInput.directive('wjInputColor', [function () {
                    return new WjInputColor();
                }]);
            wijmoInput.directive('wjListBox', [function () {
                    return new WjListBox();
                }]);
            wijmoInput.directive('wjItemTemplate', ['$compile', function ($compile) {
                    return new WjItemTemplate($compile);
                }]);
            wijmoInput.directive('wjMenu', ['$compile', function ($compile) {
                    return new WjMenu($compile);
                }]);
            wijmoInput.directive('wjMenuItem', [function ($compile) {
                    return new WjMenuItem();
                }]);
            wijmoInput.directive('wjMenuSeparator', [function () {
                    return new WjMenuSeparator();
                }]);
            wijmoInput.directive('wjContextMenu', [function () {
                    return new WjContextMenu();
                }]);
            wijmoInput.directive('wjCollectionViewNavigator', [function () {
                    return new WjCollectionViewNavigator();
                }]);
            wijmoInput.directive('wjCollectionViewPager', [function () {
                    return new WjCollectionViewPager();
                }]);
            wijmoInput.directive('wjPopup', [function () {
                    return new WjPopup();
                }]);
            wijmoInput.directive('wjMultiSelect', ['$compile', function ($compile) {
                    return new WjMultiSelect($compile);
                }]);
            wijmoInput.directive('wjMultiAutoComplete', ['$compile', function ($compile) {
                    return new WjMultiAutoComplete($compile);
                }]);
        }
        //#endregion "Input directives definitions"
        //#region "Input directives classes"
        // DropDown control directive
        // Provides base setup for all directives related to controls derived from DropDown
        // Abstract class, not for use in markup
        var WjDropDown = /** @class */ (function (_super) {
            __extends(WjDropDown, _super);
            function WjDropDown() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(WjDropDown.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.input.DropDown;
                },
                enumerable: true,
                configurable: true
            });
            return WjDropDown;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:ComboBox control.
         *
         * Use the <b>wj-combo-box</b> directive to add <b>ComboBox</b> controls to your AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;p&gt;Here is a ComboBox control:&lt;/p&gt;
         * &lt;wj-combo-box
         *   text="theCountry"
         *   items-source="countries"
         *   is-editable="false"
         *   placeholder="country"&gt;
         * &lt;/wj-combo-box&gt;</pre>
         *
         * The example below creates a <b>ComboBox</b> control and binds it to a 'countries' array
         * exposed by the controller. The <b>ComboBox</b> searches for the country as the user
         * types. The <b>isEditable</b> property is set to false, so the user is forced to
         * select one of the items in the list.
         *
         * @fiddle:37GHw
         *
         * The <b>wj-combo-box</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>ng-model</dt>      <dd><code>@</code> Binds the control's <b>selectedValue</b> property using the ng-model Angular
         *                          directive. Binding the property using the ng-model directive provides standard benefits
         *                          like validation, adding the control's state to the form instance, and so on. To redefine
         *                          properties on a control that is bound by the ng-model directive, use the wj-model-property
         *                          attribute.</dd>
         *   <dt>wj-model-property</dt>  <dd><code>@</code> Specifies a control property that is bound to a scope using the
         *                               <b>ng-model</b> directive.</dd>
         *   <dt>control</dt>              <dd><code>=</code> A reference to the @see:ComboBox control created by this directive.</dd>
         *   <dt>display-member-path</dt>  <dd><code>@</code> The name of the property to use as the visual representation of the items.</dd>
         *   <dt>is-content-html</dt>      <dd><code>@</code> A value indicating whether the drop-down list displays the items as plain text or as HTML.</dd>
         *   <dt>is-dropped-down</dt>      <dd><code>@</code> A value indicating whether the drop down list is currently visible.</dd>
         *   <dt>is-editable</dt>          <dd><code>@</code> A value indicating whether the user can enter values not present on the list.</dd>
         *   <dt>initialized</dt>          <dd><code>&</code> This event occurs after the binding has finished initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt>       <dd><code>=</code> A value indicating whether the binding has finished initializing the control with attribute values.</dd>
         *   <dt>item-formatter</dt>       <dd><code>=</code> A function used to customize the values shown in the drop-down list.</dd>
         *   <dt>items-source</dt>         <dd><code>=</code> An array or @see:ICollectionView that contains items to show in the list.</dd>
         *   <dt>max-drop-down-height</dt> <dd><code>@</code> The maximum height of the drop-down list.</dd>
         *   <dt>max-drop-down-width</dt>  <dd><code>@</code> The maximum width of the drop-down list.</dd>
         *   <dt>placeholder</dt>          <dd><code>@</code> A string shown as a hint when the control is empty.</dd>
         *   <dt>is-required</dt>          <dd><code>@</code> A value indicating whether to prevent null values.</dd>
         *   <dt>show-drop-down-button</dt><dd><code>@</code> A value indicating whether the control displays a drop-down button.</dd>
         *   <dt>selected-index</dt>       <dd><code>=</code> The index of the currently selected item in the drop-down list.</dd>
         *   <dt>selected-item</dt>        <dd><code>=</code> The currently selected item in the drop-down list.</dd>
         *   <dt>selected-value</dt>       <dd><code>=</code> The value of the selected item, obtained using the <b>selected-value-path</b>.</dd>
         *   <dt>selected-value-path</dt>  <dd><code>@</code> The name of the property used to get the <b>selected-value</b> from the <b>selected-item</b>.</dd>
         *   <dt>text</dt>                 <dd><code>=</code> The text to show in the control.</dd>
         *   <dt>is-dropped-down-changing</dt> <dd><code>&</code> The @see:ComboBox.isDroppedDownChanging event handler.</dd>
         *   <dt>is-dropped-down-changed</dt>  <dd><code>&</code> The @see:ComboBox.isDroppedDownChanged event handler.</dd>
         *   <dt>selected-index-changed</dt>   <dd><code>&</code> The @see:ComboBox.selectedIndexChanged event handler.</dd>
         *   <dt>got-focus</dt>            <dd><code>&</code> The @see:ComboBox.gotFocus event handler.</dd>
         *   <dt>lost-focus</dt>           <dd><code>&</code> The @see:ComboBox.lostFocus event handler.</dd>
         *   <dt>text-changed</dt>         <dd><code>&</code> The @see:ComboBox.textChanged event handler.</dd>
         * </dl>
         */
        var WjComboBox = /** @class */ (function (_super) {
            __extends(WjComboBox, _super);
            function WjComboBox($compile) {
                var _this = _super.call(this) || this;
                _this._$compile = $compile;
                _this.template = '<div ng-transclude />';
                _this.transclude = true;
                return _this;
            }
            Object.defineProperty(WjComboBox.prototype, "_controlConstructor", {
                // Gets the Combobox control constructor
                get: function () {
                    return wijmo.input.ComboBox;
                },
                enumerable: true,
                configurable: true
            });
            return WjComboBox;
        }(WjDropDown));
        /**
         * AngularJS directive for the @see:AutoComplete control.
         *
         * Use the <b>wj-auto-complete</b> directive to add <b>AutoComplete</b> controls to your
         * AngularJS applications. Note that directive and parameter names must be
         * formatted as lower-case with dashes instead of camel-case. For example:
         *
         * <pre>&lt;p&gt;Here is an AutoComplete control:&lt;/p&gt;
         * &lt;wj-auto-complete
         *   text="theCountry"
         *   items-source="countries"
         *   is-editable="false"
         *   placeholder="country"&gt;
         * &lt;/wj-auto-complete&gt;</pre>
         *
         * The example below creates an <b>AutoComplete</b> control and binds it to a 'countries' array
         * exposed by the controller. The <b>AutoComplete</b> searches for the country as the user
         * types, and narrows down the list of countries that match the current input.
         *
         * @fiddle:37GHw
         *
         * The <b>wj-auto-complete</b> directive extends @see:WjComboBox with the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>css-match</dt>            <dd><code>@</code> The name of the CSS class used to highlight
         *                                 parts of the content that match the search terms.</dd>
         *   <dt>delay</dt>                <dd><code>@</code> The amount of delay in milliseconds between
         *                                 when a keystroke occurs and when the search is performed.</dd>
         *   <dt>items-source-function</dt><dd><code>=</code> A function that provides the items
         *                                 dynamically as the user types.</dd>
         *   <dt>max-items</dt>            <dd><code>@</code> The maximum number of items to display
         *                                 in the dropdown.</dd>
         *   <dt>min-length</dt>           <dd><code>@</code> The minimum input length to require before
         *                                 triggering autocomplete suggestions.</dd>
         * </dl>
         */
        var WjAutoComplete = /** @class */ (function (_super) {
            __extends(WjAutoComplete, _super);
            function WjAutoComplete($compile) {
                return _super.call(this, $compile) || this;
            }
            Object.defineProperty(WjAutoComplete.prototype, "_controlConstructor", {
                // Gets AutoComplete control constructor
                get: function () {
                    return wijmo.input.AutoComplete;
                },
                enumerable: true,
                configurable: true
            });
            return WjAutoComplete;
        }(WjComboBox));
        /**
         * AngularJS directive for the @see:Calendar control.
         *
         * Use the <b>wj-calendar</b> directive to add <b>Calendar</b> controls to your
         * AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;p&gt;Here is a Calendar control:&lt;/p&gt;
         * &lt;wj-calendar
         *   value="theDate"&gt;
         * &lt;/wj-calendar&gt;</pre>
         *
         * @fiddle:46PhD
         *
         * This example creates a <b>Calendar</b> control and binds it to a 'date' variable
         * exposed by the controller. The range of dates that may be selected is limited
         * by the <b>min</b> and <b>max</b> properties.
         *
         * The <b>wj-calendar</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>ng-model</dt>      <dd><code>@</code> Binds the control's <b>value</b> property using the ng-model Angular
         *                          directive. Binding the property using the ng-model directive provides standard benefits
         *                          like validation, adding the control's state to the form instance, and so on. To redefine
         *                          properties on a control that is bound by the ng-model directive, use the wj-model-property
         *                          attribute.</dd>
         *   <dt>wj-model-property</dt>  <dd><code>@</code> Specifies a control property that is bound to a scope using the
         *                               <b>ng-model</b> directive.</dd>
         *   <dt>control</dt>        <dd><code>=</code> A reference to the @see:Calendar control
         *                           created by this directive.</dd>
         *   <dt>display-month</dt>  <dd><code>=</code> The month being displayed in the calendar.</dd>
         *   <dt>first-day-of-week</dt> <dd><code>@</code> The first day of the week.</dd>
         *   <dt>initialized</dt>          <dd><code>&</code> This event occurs after the binding has finished
         *                                 initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt>       <dd><code>=</code> A value indicating whether the binding has finished
         *                                 initializing the control with attribute values. </dd>
         *   <dt>item-formatter</dt> <dd><code>=</code> The function used to customize the dates
         *                           shown in the calendar.</dd>
         *   <dt>max</dt>            <dd><code>@</code> The latest valid date (string in the
         *                           format "yyyy-MM-dd").</dd>
         *   <dt>min</dt>            <dd><code>@</code> The earliest valid date (string in the
         *                           format "yyyy-MM-dd").</dd>
         *   <dt>month-view</dt>     <dd><code>@</code> A value indicating whether the control displays
         *                           a month or the entire year.</dd>
         *   <dt>show-header</dt>    <dd><code>@</code> A value indicating whether the control displays
         *                           the header area.</dd>
         *   <dt>value</dt>          <dd><code>=</code> The date being edited.</dd>
         *   <dt>got-focus</dt>      <dd><code>&</code> The @see:Calendar.gotFocus event handler.</dd>
         *   <dt>lost-focus</dt>     <dd><code>&</code> The @see:Calendar.lostFocus event handler.</dd>
         *   <dt>value-changed</dt>  <dd><code>&</code> The @see:Calendar.valueChanged event handler.</dd>
         * </dl>
         *
         * If provided, the <b>min</b> and <b>max</b> attributes are strings in the format
         * "yyyy-MM-dd." Technically, you can use any full date as defined in the W3C
         * <a href="http://tools.ietf.org/html/rfc3339" target="_blank">[RFC 3339]</a>,
         * which is also the format used with regular HTML5 input elements.
         */
        var WjCalendar = /** @class */ (function (_super) {
            __extends(WjCalendar, _super);
            function WjCalendar() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(WjCalendar.prototype, "_controlConstructor", {
                // Gets the Calendar control constructor
                get: function () {
                    return wijmo.input.Calendar;
                },
                enumerable: true,
                configurable: true
            });
            return WjCalendar;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:ColorPicker control.
         *
         * Use the <b>wj-color-picker</b> directive to add <b>ColorPicker</b> controls to your
         * AngularJS applications. Note that directive and parameter names must be
         * formatted as lower-case with dashes instead of camel-case. For example:
         *
         * <pre>&lt;p&gt;Here is a ColorPicker control:&lt;/p&gt;
         * &lt;wj-color-picker
         *   value="theColor"
         *   show-alpha-channel="false"&gt;
         * &lt;/wj-color-picker&gt;</pre>
         *
         * The <b>wj-color-picker</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>ng-model</dt>      <dd><code>@</code> Binds the control's <b>value</b> property using the ng-model Angular
         *                          directive. Binding the property using the ng-model directive provides standard benefits
         *                          like validation, adding the control's state to the form instance, and so on. To redefine
         *                          properties on a control that is bound by the ng-model directive, use the wj-model-property
         *                          attribute.</dd>
         *   <dt>wj-model-property</dt>  <dd><code>@</code> Specifies a control property that is bound to a scope using the
         *                               <b>ng-model</b> directive.</dd>
         *   <dt>control</dt>           <dd><code>=</code> A reference to the @see:ColorPicker
         *                              control created by this directive.</dd>
         *   <dt>initialized</dt>          <dd><code>&</code> This event occurs after the binding has finished
         *                                 initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt>       <dd><code>=</code> A value indicating whether the binding has finished
         *                                 initializing the control with attribute values. </dd>
         *   <dt>show-alpha-channel</dt><dd><code>@</code> A value indicating whether the control
         *                              displays the alpha channel (transparency) editor.</dd>
         *   <dt>show-color-string</dt> <dd><code>@</code> A value indicating whether the control
         *                              displays a string representation of the color being edited.</dd>
         *   <dt>palette</dt>           <dd><code>=</code> An array with ten color values to use
         *                              as the palette.</dd>
         *   <dt>value</dt>             <dd><code>=</code> The color being edited.</dd>
         *   <dt>got-focus</dt>         <dd><code>&</code> The @see:ColorPicker.gotFocus event handler.</dd>
         *   <dt>lost-focus</dt>        <dd><code>&</code> The @see:ColorPicker.lostFocus event handler.</dd>
         *   <dt>value-changed</dt>     <dd><code>&</code> The @see:ColorPicker.valueChanged event handler.</dd>
         * </dl>
         */
        var WjColorPicker = /** @class */ (function (_super) {
            __extends(WjColorPicker, _super);
            function WjColorPicker() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(WjColorPicker.prototype, "_controlConstructor", {
                // Gets the ColorPicker control constructor
                get: function () {
                    return wijmo.input.ColorPicker;
                },
                enumerable: true,
                configurable: true
            });
            return WjColorPicker;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:ListBox control.
         *
         * Use the <b>wj-list-box</b> directive to add @see:ListBox controls to your
         * AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>b&gt;Here is a ListBox control:&lt;/p&gt;
         * &lt;wj-list-box
         *   selected-item="theCountry"
         *   items-source="countries"
         *   placeholder="country"&gt;
         * &lt;/wj-list-box&gt;</pre>
         *
         * The example below creates a <b>ListBox</b> control and binds it to a 'countries' array
         * exposed by the controller. The value selected is bound to the 'theCountry'
         * controller property using the <b>selected-item</b> attribute.
         *
         * @fiddle:37GHw
         *
         * The <b>wj-list-box</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>ng-model</dt>      <dd><code>@</code> Binds the control's <b>selectedValue</b> property using the ng-model Angular
         *                          directive. Binding the property using the ng-model directive provides standard benefits
         *                          like validation, adding the control's state to the form instance, and so on. To redefine
         *                          properties on a control that is bound by the ng-model directive, use the wj-model-property
         *                          attribute.</dd>
         *   <dt>wj-model-property</dt>  <dd><code>@</code> Specifies a control property that is bound to a scope using the
         *                               <b>ng-model</b> directive.</dd>
         *   <dt>control</dt>              <dd><code>=</code> A reference to the @see:ListBox
         *                                 control created by this directive.</dd>
         *   <dt>display-member-path</dt>  <dd><code>@</code> The property to use as the visual
         *                                 representation of the items.</dd>
         *   <dt>is-content-html</dt>      <dd><code>@</code> A value indicating whether items
         *                                 contain plain text or HTML.</dd>
         *   <dt>initialized</dt>          <dd><code>&</code> This event occurs after the binding has finished
         *                                 initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt>       <dd><code>=</code> A value indicating whether the binding has finished
         *                                 initializing the control with attribute values. </dd>
         *   <dt>item-formatter</dt>       <dd><code>=</code> A function used to customize the
         *                                 values to show in the list.</dd>
         *   <dt>items-source</dt>         <dd><code>=</code> An array or @see:ICollectionView
         *                                 that contains the list items.</dd>
         *   <dt>max-height</dt>           <dd><code>@</code> The maximum height of the list.</dd>
         *   <dt>selected-index</dt>       <dd><code>=</code> The index of the currently selected
         *                                 item.</dd>
         *   <dt>selected-item</dt>        <dd><code>=</code> The item that is currently selected.</dd>
         *   <dt>selected-value</dt>       <dd><code>=</code> The value of the <b>selected-item</b>
         *                                 obtained using the <b>selected-value-path</b>.</dd>
         *   <dt>selected-value-path</dt>  <dd><code>@</code> The property used to get the
         *                                 <b>selected-value</b> from the <b>selected-item</b>.</dd>
         *   <dt>got-focus</dt>            <dd><code>&</code> The @see:ListBox.gotFocus event handler.</dd>
         *   <dt>lost-focus</dt>           <dd><code>&</code> The @see:ListBox.lostFocus event handler.</dd>
         *   <dt>items-changed</dt>        <dd><code>&</code> The @see:ListBox.itemsChanged event handler.</dd>
         *   <dt>selected-index-changed</dt> <dd><code>&</code> The @see:ListBox.selectedIndexChanged event handler.</dd>
         * </dl>
         *
         * The <b>wj-list-box</b> directive may contain @see:WjItemTemplate child directive.
         */
        var WjListBox = /** @class */ (function (_super) {
            __extends(WjListBox, _super);
            function WjListBox() {
                var _this = _super.call(this) || this;
                _this.transclude = true;
                _this.template = '<div ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjListBox.prototype, "_controlConstructor", {
                // Gets the ListBox control constructor
                get: function () {
                    return wijmo.input.ListBox;
                },
                enumerable: true,
                configurable: true
            });
            return WjListBox;
        }(angular.WjDirective));
        /**
         * AngularJS directive for @see:ListBox and @see:Menu item templates.
         *
         * The <b>wj-item-template</b> directive must be contained in a @see:WjListBox
         * or @see:WjMenu directives.
         *
         * The <b>wj-item-template</b> directive defines a template for items of <b>ListBox</b>
         * and data-bound <b>Menu</b> controls.
         * The template may contain an arbitrary HTML fragment with AngularJS bindings and directives.
         * In addition to any properties available in a controller, the local <b>$item</b>,
         * <b>$itemIndex</b> and <b>$control</b> template variables can be used in AngularJS bindings
         * that refer to the data item, its index, and the owner control.
         *
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;p&gt;Here is a ListBox control with an item template:&lt;/p&gt;
         * &lt;wj-list-box items-source="musicians"&gt;
         *     &lt;wj-item-template&gt;
         *         {&#8203;{$itemIndex}}. &lt;b&gt;{&#8203;{$item.name}}&lt;/b&gt;
         *         &lt;br /&gt;
         *         &lt;img ng-src="{&#8203;{$item.photo}}"/&gt;
         *     &lt;/wj-item-template&gt;
         * &lt;/wj-list-box&gt;</pre>
         */
        var WjItemTemplate = /** @class */ (function (_super) {
            __extends(WjItemTemplate, _super);
            function WjItemTemplate($compile) {
                var _this = _super.call(this) || this;
                _this._$compile = $compile;
                _this.require = ['?^wjListBox', '?^wjMenu'];
                // The same approach like in WjFlexGridColumn
                _this['terminal'] = true;
                if (angular.WjDirective._dynaTemplates) {
                    _this.transclude = false;
                    _this['priority'] = 100;
                    _this.template = function (tElement, tAttrs) {
                        tAttrs[WjItemTemplate._itemTemplateProp] = tElement[0].innerHTML;
                        return '<div />';
                    };
                }
                else {
                    _this.transclude = true;
                    _this.template = '<div ng-transclude/>';
                }
                return _this;
            }
            WjItemTemplate.prototype._initControl = function (element) {
                return {};
            };
            WjItemTemplate.prototype._createLink = function () {
                return new WjItemTemplateLink();
            };
            WjItemTemplate.prototype._getMetaDataId = function () {
                return 'ItemTemplate';
            };
            WjItemTemplate._itemTemplateProp = '$__wjItemTemplate';
            WjItemTemplate._itemScopeProp = '$_itemScope';
            return WjItemTemplate;
        }(angular.WjDirective));
        var WjItemTemplateLink = /** @class */ (function (_super) {
            __extends(WjItemTemplateLink, _super);
            function WjItemTemplateLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            WjItemTemplateLink.prototype._initParent = function () {
                _super.prototype._initParent.call(this);
                // get column template (HTML content)
                var dynaTempl = this.tAttrs[WjItemTemplate._itemTemplateProp], ownerControl = this.parent.control, listBox = this._getListBox();
                this.itemTemplate = dynaTempl != null ? dynaTempl : angular.WjDirective._removeTransclude(this.tElement[0].innerHTML);
                listBox.formatItem.addHandler(this._fmtItem, this);
                listBox.loadingItems.addHandler(this._loadingItems, this);
                if (this.parent._isInitialized) {
                    ownerControl.invalidate();
                }
            };
            WjItemTemplateLink.prototype._destroy = function () {
                var ownerControl = this.parent && this.parent.control, listBox = this._getListBox();
                if (listBox) {
                    listBox.formatItem.removeHandler(this._fmtItem, this);
                    listBox.loadingItems.removeHandler(this._loadingItems, this);
                }
                _super.prototype._destroy.call(this);
                this._tmplLink = null;
                if (ownerControl) {
                    ownerControl.invalidate();
                }
            };
            WjItemTemplateLink.prototype._loadingItems = function (s) {
                var items = s.hostElement.getElementsByClassName('wj-listbox-item');
                for (var i = items.length - 1; i >= 0; i--) {
                    var itemEl = items[i], itemScope = itemEl[WjItemTemplate._itemScopeProp];
                    if (itemScope) {
                        itemEl[WjItemTemplate._itemScopeProp] = null;
                        itemScope.$destroy();
                    }
                }
            };
            WjItemTemplateLink.prototype._fmtItem = function (s, e) {
                if (!this._tmplLink) {
                    this._tmplLink = this.directive._$compile(
                    //'<div style="display:none">' + this.itemTemplate + '</div>');
                    '<div>' + this.itemTemplate + '</div>');
                }
                var itemEl = e.item, itemScope = this.scope.$parent.$new();
                itemEl[WjItemTemplate._itemScopeProp] = itemScope;
                itemScope['$control'] = s;
                itemScope['$item'] = e.data;
                itemScope['$itemIndex'] = e.index;
                var clonedElement = this._tmplLink(itemScope, function (clonedEl, scope) { })[0];
                //var dispose = itemScope.$watch(function (scope) {
                //    dispose();
                //    clonedElement.style.display = '';
                //});
                if (itemEl.childNodes.length === 1) {
                    itemEl.replaceChild(clonedElement, itemEl.firstChild);
                }
                else {
                    itemEl.textContent = '';
                    itemEl.appendChild(clonedElement);
                }
                var lag = 40;
                clearTimeout(this._closingApplyTimeOut);
                this._closingApplyTimeOut = setTimeout(function () {
                    if (!itemScope['$root'].$$phase) {
                        itemScope.$apply();
                    }
                }, lag);
            };
            WjItemTemplateLink._invalidateControl = function (parentControl) {
                if (parentControl) {
                    parentControl.invalidate();
                }
            };
            // Gets a ListBox control whose items are templated, it maybe the control itself or internal ListBox used by controls like
            // ComboBox.
            WjItemTemplateLink.prototype._getListBox = function () {
                var ownerControl = this.parent && this.parent.control;
                if (ownerControl) {
                    return ownerControl instanceof wijmo.input.ListBox ? ownerControl : ownerControl.listBox;
                }
                return null;
            };
            return WjItemTemplateLink;
        }(angular.WjLink));
        /**
         * AngularJS directive for the @see:Menu control.
         *
         * Use the <b>wj-menu</b> directive to add drop-down menus to your AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;p&gt;Here is a Menu control used as a value picker:&lt;/p&gt;
         * &lt;wj-menu header="Tax" value="tax"&gt;
         *   &lt;wj-menu-item value="0"&gt;Exempt&lt;/wj-menu-item&gt;
         *   &lt;wj-menu-item value=".05"&gt;5%&lt;/wj-menu-item&gt;
         *   &lt;wj-menu-item value=".1"&gt;10%&lt;/wj-menu-item&gt;
         *   &lt;wj-menu-item value=".15"&gt;15%&lt;/wj-menu-item&gt;
         * &lt;/wj-menu&gt;</pre>
         *
         * @fiddle:Wc5Mq
         *
         * This example creates three <b>Menu</b> controls. The first is used as a value picker,
         * the second uses a list of commands with parameters, and the third is a group of
         * three menus handled by an <b>itemClicked</b> function in the controller.
         *
         * The <b>wj-menu</b> directive extends @see:WjComboBox with the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>command-path</dt>          <dd><code>@</code> The command to be executed when the item is clicked.</dd>
         *   <dt>command-parameter-path</dt><dd><code>@</code> The name of the property that contains command parameters.</dd>
         *   <dt>header</dt>                <dd><code>@</code> The text shown on the control.</dd>
         *   <dt>is-button</dt>             <dd><code>@</code> Whether the menu should react to clicks on its header area.</dd>
         *   <dt>value</dt>                 <dd><code>@</code> The value of the selected <b>wj-menu-item</b> value property. </dd>
         *   <dt>item-clicked</dt>          <dd><code>&</code> The @see:Menu.itemClicked event handler.</dd>
         *   <dt>got-focus</dt>             <dd><code>&</code> The @see:Menu.gotFocus event handler.</dd>
         *   <dt>lost-focus</dt>            <dd><code>&</code> The @see:Menu.lostFocus event handler.</dd>
         * </dl>
         *
         *The <b>wj-menu</b> directive may contain the following child directives:
         *@see:WjMenuItem, @see:WjMenuSeparator and @see:WjItemTemplate(in case of data-bound Menu control).
         */
        var WjMenu = /** @class */ (function (_super) {
            __extends(WjMenu, _super);
            // Initializes a new instance of a WjMenu
            function WjMenu($compile) {
                return _super.call(this, $compile) || this;
            }
            Object.defineProperty(WjMenu.prototype, "_controlConstructor", {
                // Gets the Menu control constructor
                get: function () {
                    return wijmo.input.Menu;
                },
                enumerable: true,
                configurable: true
            });
            WjMenu.prototype._createLink = function () {
                return new WjMenuLink();
            };
            // WjMenu property map
            WjMenu.prototype._initProps = function () {
                _super.prototype._initProps.call(this);
                var self = this; // store this in closure as .apply() call overrides the reference
                var valueDesc = angular.MetaFactory.findProp('value', this._props);
                valueDesc.customHandler = function (scope, control, value, oldValue, link) {
                    self.updateControlValue(scope, control, link);
                };
            };
            WjMenu.prototype.updateControlValue = function (scope, control, link) {
                if (scope.value != null) {
                    control.selectedValue = scope.value;
                    link.directive.updateHeader(scope, control, link);
                }
            };
            // if the scope has a value, show it in the header
            WjMenu.prototype.updateHeader = function (scope, control, link) {
                control.header = scope.header || '';
                var selItem = control.selectedItem;
                if (typeof (scope.value) != 'undefined' && selItem && control.displayMemberPath) {
                    var itemLink = selItem[WjMenuItem._itemLinkProp];
                    var currentValue = itemLink ? itemLink.linkedContent.innerHTML : selItem[control.displayMemberPath];
                    if (currentValue != null) {
                        control.header += ': <b>' + currentValue + '</b>';
                    }
                }
            };
            return WjMenu;
        }(WjComboBox));
        var WjMenuLink = /** @class */ (function (_super) {
            __extends(WjMenuLink, _super);
            function WjMenuLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            WjMenuLink.prototype._initControl = function () {
                var self = this, control = new wijmo.input.Menu(this.directiveTemplateElement[0], {
                    itemsSource: new wijmo.collections.ObservableArray(),
                    selectedIndex: 0,
                    itemClicked: function () {
                        if (!self._safeApply(self.scope, 'value', control.selectedValue)) {
                            // this is necessary to ensure a digest after command's code was executed,
                            // because this code may change controller scope properties
                            if (!self.scope['$root'].$$phase) {
                                self.scope.$apply();
                            }
                        }
                        self.directive.updateHeader(self.scope, control, self);
                    }.bind(self),
                });
                control.listBox.formatItem.addHandler(self._fmtItem, this);
                control.listBox.loadingItems.addHandler(this._loadingItems, this);
                return control;
            };
            WjMenuLink.prototype._initialized = function () {
                this.directive.updateControlValue(this.scope, this.control, this);
            };
            WjMenuLink.prototype._fmtItem = function (s, e) {
                var itemLink = e.data[WjMenuItem._itemLinkProp];
                if (!itemLink) {
                    return;
                }
                if (!itemLink.contentLink) {
                    itemLink.contentLink = this.directive._$compile(
                    //'<div style="display:none">' + itemLink.itemTemplate + '</div>');
                    '<div>' + itemLink.itemTemplate + '</div>');
                }
                var self = this, itemEl = e.item, itemScope = itemLink.scope.$parent.$new();
                itemEl[WjMenuItem._itemScopeProp] = itemScope;
                itemScope['$control'] = this.control;
                itemScope['$item'] = e.data;
                itemScope['$itemIndex'] = e.index;
                var clonedElement = itemLink.linkedContent = itemLink.contentLink(itemScope, function (clonedEl, scope) { })[0];
                if (itemLink.isSeparator) {
                    wijmo.addClass(itemEl, 'wj-state-disabled');
                }
                if (itemEl.childNodes.length === 1) {
                    itemEl.replaceChild(clonedElement, itemEl.firstChild);
                }
                else {
                    itemEl.textContent = '';
                    itemEl.appendChild(clonedElement);
                }
                var lag = 40;
                clearTimeout(this._closingApplyTimeOut);
                this._closingApplyTimeOut = setTimeout(function () {
                    if (!itemScope['$root'].$$phase) {
                        itemScope.$apply();
                    }
                    // update header with a resolved linked content of a selected item
                    // if there is a selected item (TFS 193428)
                    if (self.control.selectedItem) {
                        self.directive.updateHeader(self.scope, self.control, self);
                    }
                }, lag);
            };
            WjMenuLink.prototype._loadingItems = function (s) {
                var items = s.hostElement.getElementsByClassName('wj-listbox-item');
                for (var i = items.length - 1; i >= 0; i--) {
                    var itemEl = items[i], itemScope = itemEl[WjMenuItem._itemScopeProp];
                    if (itemScope) {
                        itemEl[WjItemTemplate._itemScopeProp] = null;
                        itemScope.$destroy();
                    }
                }
            };
            return WjMenuLink;
        }(angular.WjLink));
        angular.WjMenuLink = WjMenuLink;
        /**
         * AngularJS directive for menu items.
         *
         * The <b>wj-menu-item</b> directive must be contained in a @see:WjMenu directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>cmd</dt>       <dd><code>=</code> The function to execute in the controller
         *                      when the item is clicked.</dd>
         *   <dt>cmd-param</dt>  <dd><code>=</code> The parameter passed to the <b>cmd</b> function
         *                      when the item is clicked.</dd>
         *   <dt>value</dt>     <dd><code>=</code> The value to select when the item is clicked
         *                      (use either this or <b>cmd</b>).</dd>
         * </dl>
         *
         * The content displayed by the item may contain an arbitrary HTML fragment with AngularJS bindings and directives.
         * You can also use <b>ng-repeat</b> and <b>ng-if</b> directives to populate the items in the Menu control.
         * In addition to any properties available in a controller, the local <b>$item</b>,
         * <b>$itemIndex</b> and <b>$control</b> template variables can be used in AngularJS bindings
         * that refer to the data item, its index, and the owner control.
         */
        var WjMenuItem = /** @class */ (function (_super) {
            __extends(WjMenuItem, _super);
            function WjMenuItem() {
                var _this = _super.call(this) || this;
                _this.require = '^wjMenu';
                // The same approach like in WjFlexGridColumn
                _this['terminal'] = true;
                if (angular.WjDirective._dynaTemplates) {
                    _this.transclude = false;
                    _this['priority'] = 100;
                    _this.template = function (tElement, tAttrs) {
                        tAttrs[WjItemTemplate._itemTemplateProp] = tElement[0].innerHTML;
                        return '<div />';
                    };
                }
                else {
                    _this.transclude = true;
                    _this.template = '<div ng-transclude/>';
                }
                return _this;
            }
            WjMenuItem.prototype._createLink = function () {
                return new WjMenuItemLink(false);
            };
            WjMenuItem.prototype._getMetaDataId = function () {
                return 'MenuItem';
            };
            WjMenuItem.prototype._getId = function () {
                return WjMenuItem._directiveId;
            };
            WjMenuItem._itemTemplateProp = '$__wjMenuItemTemplate';
            WjMenuItem._itemScopeProp = '$_menuItemScope';
            WjMenuItem._itemLinkProp = '$_menuItemLink';
            WjMenuItem._directiveId = 'menuItemDir';
            return WjMenuItem;
        }(angular.WjDirective));
        // Used for both WjMenuItem and WjMenuSeparator
        var WjMenuItemLink = /** @class */ (function (_super) {
            __extends(WjMenuItemLink, _super);
            // parameter indicates whether the link is used with WjMenuItem and WjMenuSeparator.
            function WjMenuItemLink(isSeparator) {
                var _this = _super.call(this) || this;
                _this.isSeparator = isSeparator;
                return _this;
            }
            WjMenuItemLink.prototype._initControl = function () {
                var dynaTempl = this.tAttrs[WjItemTemplate._itemTemplateProp];
                this.itemTemplate = this.isSeparator ?
                    '<div class="wj-state-disabled" style="width:100%;height:1px;background-color:lightgray"/>' :
                    dynaTempl != null ? dynaTempl : angular.WjDirective._removeTransclude(this.tElement[0].innerHTML);
                var ret = { value: null, cmd: null, cmdParam: null, header: this.itemTemplate };
                ret[WjMenuItem._itemLinkProp] = this;
                return ret;
            };
            WjMenuItemLink.prototype._initParent = function () {
                _super.prototype._initParent.call(this);
                var ownerControl = this.parent.control;
                if (ownerControl.itemsSource.length == 1 && ownerControl.selectedIndex < 0) {
                    ownerControl.selectedIndex = 0;
                }
                if (!ownerControl.displayMemberPath) {
                    ownerControl.displayMemberPath = 'header';
                }
                if (!ownerControl.selectedValuePath) {
                    ownerControl.selectedValuePath = 'value';
                }
                if (!ownerControl.commandPath) {
                    ownerControl.commandPath = 'cmd';
                }
                if (!ownerControl.commandParameterPath) {
                    ownerControl.commandParameterPath = 'cmdParam';
                }
            };
            WjMenuItemLink.prototype._destroy = function () {
                var ownerControl = this.parent && this.parent.control;
                _super.prototype._destroy.call(this);
                if (ownerControl) {
                    ownerControl.invalidate();
                }
            };
            return WjMenuItemLink;
        }(angular.WjLink));
        /**
         * AngularJS directive for menu separators.
         *
         * The <b>wj-menu-item-separator</b> directive must be contained in a @see:WjMenu directive.
         * It adds a non-selectable separator to the menu, and has no attributes.
         */
        var WjMenuSeparator = /** @class */ (function (_super) {
            __extends(WjMenuSeparator, _super);
            // Initializes a new instance of a WjMenuSeparator
            function WjMenuSeparator() {
                var _this = _super.call(this) || this;
                _this.template = '<span />';
                _this.require = '^wjMenu';
                return _this;
            }
            WjMenuSeparator.prototype._getMetaDataId = function () {
                return 'MenuSeparator';
            };
            WjMenuSeparator.prototype._createLink = function () {
                return new WjMenuItemLink(true);
            };
            WjMenuSeparator.prototype._getId = function () {
                return WjMenuItem._directiveId;
            };
            return WjMenuSeparator;
        }(angular.WjDirective));
        /**
         * AngularJS directive for context menus.
         *
         * Use the <b>wj-context-menu</b> directive to add context menus to elements
         * on the page. The wj-context-menu directive is based on the <b>wj-menu</b>
         * directive; it displays a popup menu when the user performs a context menu
         * request on an element (usually a right-click).
         *
         * The wj-context-menu directive is specified as a parameter added to the
         * element that the context menu applies to. The parameter value is a
         * selector for the element that contains the menu. For example:
         *
         * <pre>&lt;!-- paragraph with a context menu --&gt;
         *&lt;p wj-context-menu="#idMenu" &gt;
         *  This paragraph has a context menu.&lt;/p&gt;
         *
         *&lt;!-- define the context menu (hidden and with an id) --&gt;
         *&lt;wj-menu id="idMenu" ng-show="false"&gt;
         *  &lt;wj-menu-item cmd="cmdOpen" cmd-param ="1"&gt;Open...&lt;/wj-menu-item&gt;
         *  &lt;wj-menu-item cmd="cmdSave" cmd-param="2"&gt;Save &lt;/wj-menu-item&gt;
         *  &lt;wj-menu-item cmd="cmdSave" cmd-param="3"&gt;Save As...&lt;/wj-menu-item&gt;
         *  &lt;wj-menu-item cmd="cmdNew" cmd-param ="4"&gt;New...&lt;/wj-menu-item&gt;
         *  &lt;wj-menu-separator&gt;&lt;/wj-menu-separator&gt;
         *  &lt;wj-menu-item cmd="cmdExit" cmd-param="5"&gt;Exit&lt;/wj-menu-item&gt;
         *&lt;/wj-menu &gt;</pre>
         */
        var WjContextMenu = /** @class */ (function (_super) {
            __extends(WjContextMenu, _super);
            // Initializes a new instance of a WjContextMenu
            function WjContextMenu() {
                var _this = _super.call(this) || this;
                _this.template = undefined;
                //this.require = '^wjMenu';
                _this.restrict = 'A';
                _this.scope = false;
                return _this;
            }
            WjContextMenu.prototype._getMetaDataId = function () {
                return 'WjContextMenu';
            };
            // Gets the WjContextMenu's link function. Overrides parent member
            WjContextMenu.prototype._postLinkFn = function () {
                return function (scope, tElement, tAttrs) {
                    // get context menu and drop-down list
                    var host = wijmo.getElement(tAttrs['wjContextMenu']);
                    // show the drop-down list in response to the contextmenu command
                    tElement[0].addEventListener('contextmenu', function (e) {
                        var menu = wijmo.Control.getControl(host), dropDown = menu.dropDown;
                        if (menu && dropDown && !wijmo.closest(e.target, '[disabled]')) {
                            e.preventDefault();
                            menu.owner = tElement[0];
                            menu.show(e);
                        }
                    });
                };
            };
            return WjContextMenu;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:InputDate control.
         *
         * Use the <b>wj-input-date</b> directive to add @see:InputDate controls to your
         * AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;p&gt;Here is an InputDate control:&lt;/p&gt;
         * &lt;wj-input-date
         *   value="theDate"
         *   format="M/d/yyyy"&gt;
         * &lt;/wj-input-date&gt;</pre>
         *
         * The example below shows a <b>Date</b> value (that includes date and time information)
         * using an @see:InputDate and an @see:InputTime control. Notice how both controls
         * are bound to the same controller variable, and each edits the appropriate information
         * (either date or time). The example also shows a @see:Calendar control that can be
         * used to select the date with a single click.
         *
         * @fiddle:46PhD
         *
         * The <b>wj-input-date</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>ng-model</dt>      <dd><code>@</code> Binds the control's <b>value</b> property using the ng-model Angular
         *                          directive. Binding the property using the ng-model directive provides standard benefits
         *                          like validation, adding the control's state to the form instance, and so on. To redefine
         *                          properties on a control that is bound by the ng-model directive, use the wj-model-property
         *                          attribute.</dd>
         *   <dt>wj-model-property</dt>  <dd><code>@</code> Specifies a control property that is bound to a scope using the <b>ng-model</b> directive.</dd>
         *   <dt>control</dt>            <dd><code>=</code> A reference to the @see:InputDate control created by this directive.</dd>
         *   <dt>format</dt>             <dd><code>@</code> The format used to display the date being edited (see @see:Globalize).</dd>
         *   <dt>mask</dt>               <dd><code>@</code> The mask used to validate the input as the user types (see @see:wijmo.input.InputMask).</dd>
         *   <dt>is-dropped-down</dt>    <dd><code>@</code> A value indicating whether the drop-down is currently visible.</dd>
         *   <dt>initialized</dt>        <dd><code>&</code> This event occurs after the binding has finished initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt>     <dd><code>=</code> A value indicating whether the binding has finished initializing the control with attribute values. </dd>
         *   <dt>max</dt>                <dd><code>@</code> The latest valid date (a string in the format "yyyy-MM-dd").</dd>
         *   <dt>min</dt>                <dd><code>@</code> The earliest valid date (a string in the format "yyyy-MM-dd").</dd>
         *   <dt>placeholder</dt>        <dd><code>@</code> The string to show as a hint when the control is empty.</dd>
         *   <dt>is-required</dt>        <dd><code>@</code> A value indicating whether to prevent null values.</dd>
         *   <dt>show-drop-down-button</dt><dd><code>@</code> A value indicating whether the control displays a drop-down button.</dd>
         *   <dt>text</dt>               <dd><code>=</code> The text to show in the control.</dd>
         *   <dt>value</dt>              <dd><code>=</code> The date being edited.</dd>
         *   <dt>got-focus</dt>          <dd><code>&</code> The @see:InputDate.gotFocus event handler.</dd>
         *   <dt>lost-focus</dt>         <dd><code>&</code> The @see:InputDate.lostFocus event handler.</dd>
         *   <dt>is-dropped-down-changing</dt> <dd><code>&</code> The @see:InputDate.isDroppedDownChanging event handler.</dd>
         *   <dt>is-dropped-down-changed </dt> <dd><code>&</code> The @see:InputDate.isDroppedDownChanged event handler.</dd>
         *   <dt>text-changed</dt>       <dd><code>&</code> The @see:InputDate.textChanged event handler.</dd>
         *   <dt>value-changed</dt>      <dd><code>&</code> The @see:InputDate.valueChanged event handler.</dd>
         * </dl>
         *
         * If provided, the <b>min</b> and <b>max</b> attributes are strings in the format
         * "yyyy-MM-dd". Technically, you can use any full date as defined in the W3C
         * <a href="http://tools.ietf.org/html/rfc3339" target="_blank">[RFC 3339]</a>, which is also
         * the format used with regular HTML5 input elements.
         */
        var WjInputDate = /** @class */ (function (_super) {
            __extends(WjInputDate, _super);
            function WjInputDate() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(WjInputDate.prototype, "_controlConstructor", {
                // Gets the InputDate control constructor
                get: function () {
                    return wijmo.input.InputDate;
                },
                enumerable: true,
                configurable: true
            });
            return WjInputDate;
        }(WjDropDown));
        /**
         * AngularJS directive for the @see:InputDateTime control.
         *
         * Use the <b>wj-input-date-time</b> directive to add @see:InputDateTime controls to your
         * AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;p&gt;Here is an InputDateTime control:&lt;/p&gt;
         * &lt;wj-input-date-time
         *   value="theDate"
         *   format="M/d/yyyy"&gt;
         * &lt;/wj-input-date-time&gt;</pre>
         *
         * The <b>wj-input-date-time</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>ng-model</dt>      <dd><code>@</code> Binds the control's <b>value</b> property using the ng-model Angular
         *                          directive. Binding the property using the ng-model directive provides standard benefits
         *                          like validation, adding the control's state to the form instance, and so on. To redefine
         *                          properties on a control that is bound by the ng-model directive, use the wj-model-property
         *                          attribute.</dd>
         *   <dt>wj-model-property</dt>  <dd><code>@</code> Specifies a control property that is bound to a scope using the <b>ng-model</b> directive.</dd>
         *   <dt>control</dt>            <dd><code>=</code> A reference to the @see:InputDate control created by this directive.</dd>
         *   <dt>format</dt>             <dd><code>@</code> The format used to display the date being edited (see @see:Globalize).</dd>
         *   <dt>mask</dt>               <dd><code>@</code> The mask used to validate the input as the user types (see @see:wijmo.input.InputMask).</dd>
         *   <dt>is-dropped-down</dt>    <dd><code>@</code> A value indicating whether the drop-down is currently visible.</dd>
         *   <dt>initialized</dt>        <dd><code>&</code> This event occurs after the binding has finished initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt>     <dd><code>=</code> A value indicating whether the binding has finished initializing the control with attribute values. </dd>
         *   <dt>max</dt>                <dd><code>@</code> The latest valid date (a string in the format "yyyy-MM-dd").</dd>
         *   <dt>min</dt>                <dd><code>@</code> The earliest valid date (a string in the format "yyyy-MM-dd").</dd>
         *   <dt>placeholder</dt>        <dd><code>@</code> The string to show as a hint when the control is empty.</dd>
         *   <dt>is-required</dt>        <dd><code>@</code> A value indicating whether to prevent null values.</dd>
         *   <dt>show-drop-down-button</dt><dd><code>@</code> A value indicating whether the control displays a drop-down button.</dd>
         *   <dt>text</dt>               <dd><code>=</code> The text to show in the control.</dd>
         *   <dt>timeMax</dt>            <dd><code>@</code> The earliest valid time (a string in the format "hh:mm").</dd>
         *   <dt>timeMin</dt>            <dd><code>@</code> The latest valid time (a string in the format "hh:mm").</dd>
         *   <dt>timeStep</dt>           <dd><code>@</code> The number of minutes between entries in the drop-down list.</dd>
         *   <dt>timeFormat</dt>         <dd><code>@</code> The format sting used to show values in the time drop-down list.</dd>
         *   <dt>value</dt>              <dd><code>=</code> The date being edited.</dd>
         *   <dt>got-focus</dt>          <dd><code>&</code> The @see:InputDateTime.gotFocus event handler.</dd>
         *   <dt>lost-focus</dt>         <dd><code>&</code> The @see:InputDateTime.lostFocus event handler.</dd>
         *   <dt>is-dropped-down-changing</dt> <dd><code>&</code> The @see:InputDateTime.isDroppedDownChanging event handler.</dd>
         *   <dt>is-dropped-down-changed </dt> <dd><code>&</code> The @see:InputDateTime.isDroppedDownChanged event handler.</dd>
         *   <dt>text-changed</dt>       <dd><code>&</code> The @see:InputDateTime.textChanged event handler.</dd>
         *   <dt>value-changed</dt>      <dd><code>&</code> The @see:InputDateTime.valueChanged event handler.</dd>
         * </dl>
         */
        var WjInputDateTime = /** @class */ (function (_super) {
            __extends(WjInputDateTime, _super);
            function WjInputDateTime() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(WjInputDateTime.prototype, "_controlConstructor", {
                // Gets the InputDateTime control constructor
                get: function () {
                    return wijmo.input.InputDateTime;
                },
                enumerable: true,
                configurable: true
            });
            return WjInputDateTime;
        }(WjInputDate));
        /**
         * AngularJS directive for the @see:InputNumber control.
         *
         * Use the <b>wj-input-number</b> directive to add <b>InputNumber</b> controls to your
         * AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;p&gt;Here is an InputNumber control:&lt;/p&gt;
         * &lt;wj-input-number
         *   value="theNumber"
         *   min="0"
         *   max="10"
         *   format="n0"
         *   placeholder="number between zero and ten"&gt;
         * &lt;/wj-input-number&gt;</pre>
         *
         * The example below creates several <b>InputNumber</b> controls and shows the effect
         * of using different formats, ranges, and step values.
         *
         * @fiddle:u7HpD
         *
         * The <b>wj-input-number</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>ng-model</dt>      <dd><code>@</code> Binds the control's <b>value</b> property using the ng-model Angular
         *                          directive. Binding the property using the ng-model directive provides standard benefits
         *                          like validation, adding the control's state to the form instance, and so on. To redefine
         *                          properties on a control that is bound by the ng-model directive, use the wj-model-property
         *                          attribute.</dd>
         *   <dt>wj-model-property</dt>  <dd><code>@</code> Specifies a control property that is bound to a scope using the <b>ng-model</b> directive.</dd>
         *   <dt>control</dt>       <dd><code>=</code> A reference to the @see:InputNumber control created by this directive.</dd>
         *   <dt>format</dt>        <dd><code>@</code> The format used to display the number (see @see:Globalize).</dd>
         *   <dt>input-type</dt>    <dd><code>@</code> The "type" attribute of the HTML input element hosted by the control.</dd>
         *   <dt>initialized</dt>   <dd><code>&</code> This event occurs after the binding has finished initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt><dd><code>=</code> A value indicating whether the binding has finished initializing the control with attribute values. </dd>
         *   <dt>max</dt>           <dd><code>@</code> The largest valid number.</dd>
         *   <dt>min</dt>           <dd><code>@</code> The smallest valid number.</dd>
         *   <dt>place-holder</dt>  <dd><code>@</code> The string to show as a hint when the control is empty.</dd>
         *   <dt>is-required</dt>   <dd><code>@</code> A value indicating whether to prevent null values.</dd>
         *   <dt>show-spinner</dt>  <dd><code>@</code> A value indicating whether to display spinner buttons to change the value by <b>step</b> units.</dd>
         *   <dt>step</dt>          <dd><code>@</code> The amount to add or subtract to the value when the user clicks the spinner buttons.</dd>
         *   <dt>text</dt>          <dd><code>=</code> The text to show in the control.</dd>
         *   <dt>value</dt>         <dd><code>=</code> The number being edited.</dd>
         *   <dt>got-focus</dt>     <dd><code>&</code> The @see:InputNumber.gotFocus event handler.</dd>
         *   <dt>lost-focus</dt>    <dd><code>&</code> The @see:InputNumber.lostFocus event handler.</dd>
         *   <dt>text-changed</dt>  <dd><code>&</code> The @see:InputNumber.textChanged event handler.</dd>
         *   <dt>value-changed</dt> <dd><code>&</code> The @see:InputNumber.valueChanged event handler.</dd>
         * </dl>
         */
        var WjInputNumber = /** @class */ (function (_super) {
            __extends(WjInputNumber, _super);
            function WjInputNumber() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(WjInputNumber.prototype, "_controlConstructor", {
                // Gets the InputNumber control constructor
                get: function () {
                    return wijmo.input.InputNumber;
                },
                enumerable: true,
                configurable: true
            });
            return WjInputNumber;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:InputMask control.
         *
         * Use the <b>wj-input-mask</b> directive to add @see:InputMask controls to your
         * AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;p&gt;Here is an InputMask control:&lt;/p&gt;
         * &lt;wj-input-mask
         *   mask="99/99/99"
         *   mask-placeholder="*"&gt;
         * &lt;/wj-input-mask&gt;</pre>
         *
         * The <b>wj-input-mask</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>ng-model</dt>      <dd><code>@</code> Binds the control's <b>value</b> property using the ng-model Angular
         *                          directive. Binding the property using the ng-model directive provides standard benefits
         *                          like validation, adding the control's state to the form instance, and so on. To redefine
         *                          properties on a control that is bound by the ng-model directive, use the wj-model-property
         *                          attribute.</dd>
         *   <dt>wj-model-property</dt> <dd><code>@</code> Specifies a control property that is bound to a scope using the <b>ng-model</b> directive.</dd>
         *   <dt>control</dt>           <dd><code>=</code> A reference to the @see:InputNumber control created by this directive.</dd>
         *   <dt>initialized</dt>       <dd><code>&</code> This event occurs after the binding has finished initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt>    <dd><code>=</code> A value indicating whether the binding has finished initializing the control with attribute values. </dd>
         *   <dt>mask</dt>              <dd><code>@</code> The string mask used to format the value as the user types.</dd>
         *   <dt>prompt-char</dt>       <dd><code>@</code> A character used to show input locations within the mask.</dd>
         *   <dt>place-holder</dt>      <dd><code>@</code> The string to show as a hint when the control is empty.</dd>
         *   <dt>value</dt>             <dd><code>=</code> The string being edited.</dd>
         *   <dt>raw-value</dt>         <dd><code>=</code> The string being edited, excluding literal and prompt characters.</dd>
         *   <dt>got-focus</dt>         <dd><code>&</code> The @see:InputMask.gotFocus event handler.</dd>
         *   <dt>lost-focus</dt>        <dd><code>&</code> The @see:InputMask.lostFocus event handler.</dd>
         *   <dt>value-changed</dt>     <dd><code>&</code> The @see:InputMask.valueChanged event handler.</dd>
         * </dl>
         */
        var WjInputMask = /** @class */ (function (_super) {
            __extends(WjInputMask, _super);
            function WjInputMask() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(WjInputMask.prototype, "_controlConstructor", {
                // Gets the InputMask control constructor
                get: function () {
                    return wijmo.input.InputMask;
                },
                enumerable: true,
                configurable: true
            });
            return WjInputMask;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:InputTime control.
         *
         * Use the <b>wj-input-time</b> directive to add <b>InputTime</b> controls to your AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;p&gt;Here is an InputTime control:&lt;/p&gt;
         * &lt;wj-input-time
         *   value="theDate"
         *   format="h:mm tt"
         *   min="09:00" max="17:00"
         *   step="15"&gt;
         * &lt;/wj-input-time&gt;</pre>
         *
         * @fiddle:46PhD
         *
         * This example edits a <b>Date</b> value (that includes date and time information)
         * using an @see:InputDate and an InputTime control. Notice how both controls
         * are bound to the same controller variable, and each edits the appropriate information
         * (either date or time). The example also shows a @see:Calendar control that can be
         * used to select the date with a single click.
         *
         * The <b>wj-input-time</b> directive extends @see:WjComboBox with the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>ng-model</dt>      <dd><code>@</code> Binds the control's <b>value</b> property using the ng-model Angular
         *                          directive. Binding the property using the ng-model directive provides standard benefits
         *                          like validation, adding the control's state to the form instance, and so on. To redefine
         *                          properties on a control that is bound by the ng-model directive, use the wj-model-property
         *                          attribute.</dd>
         *   <dt>wj-model-property</dt><dd><code>@</code> Specifies a control property that is bound to a scope using the <b>ng-model</b> directive.</dd>
         *   <dt>control</dt>       <dd><code>=</code> A reference to the @see:InputDate control created by this directive.</dd>
         *   <dt>format</dt>        <dd><code>@</code> The format used to display the selected time.</dd>
         *   <dt>mask</dt>          <dd><code>@</code> A mask used to validate the input as the user types (see @see:InputMask).</dd>
         *   <dt>max</dt>           <dd><code>@</code> The earliest valid time (a string in the format "hh:mm").</dd>
         *   <dt>min</dt>           <dd><code>@</code> The latest valid time (a string in the format "hh:mm").</dd>
         *   <dt>step</dt>          <dd><code>@</code> The number of minutes between entries in the drop-down list.</dd>
         *   <dt>value</dt>         <dd><code>=</code> The time being edited (as a Date object).</dd>
         *   <dt>value-changed</dt> <dd><code>&</code> The@see: valueChanged event handler.</dd>
         * </dl>
         *
         * If provided, the <b>min</b> and <b>max</b> attributes are strings in the format
         * "hh:mm". Technically, you can use any full date as defined in the W3C
         * <a href="http://tools.ietf.org/html/rfc3339" target="_blank">[RFC 3339]</a>, which is also the format
         * used with regular HTML5 input elements.
         */
        var WjInputTime = /** @class */ (function (_super) {
            __extends(WjInputTime, _super);
            function WjInputTime($compile) {
                return _super.call(this, $compile) || this;
            }
            Object.defineProperty(WjInputTime.prototype, "_controlConstructor", {
                // Gets the InputTime control constructor
                get: function () {
                    return wijmo.input.InputTime;
                },
                enumerable: true,
                configurable: true
            });
            return WjInputTime;
        }(WjComboBox));
        /**
         * AngularJS directive for the @see:InputColor control.
         *
         * Use the <b>wj-input-color</b> directive to add @see:InputColor controls to your
         * AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;p&gt;Here is an InputColor control:&lt;/p&gt;
         * &lt;wj-input-color
         *   value="theColor"
         *   show-alpha-channel="false"&gt;
         * &lt;/wj-input-color&gt;</pre>
         *
         * The <b>wj-input-color</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>ng-model</dt>      <dd><code>@</code> Binds the control's <b>value</b> property using the ng-model Angular
         *                          directive. Binding the property using the ng-model directive provides standard benefits
         *                          like validation, adding the control's state to the form instance, and so on. To redefine
         *                          properties on a control that is bound by the ng-model directive, use the wj-model-property
         *                          attribute.</dd>
         *   <dt>wj-model-property</dt>     <dd><code>@</code> Specifies a control property that is bound to a scope using the <b>ng-model</b> directive.</dd>
         *   <dt>control</dt>               <dd><code>=</code> A reference to the InputColor control created by this directive.</dd>
         *   <dt>is-dropped-down</dt>       <dd><code>@</code> A value indicating whether the drop-down is currently visible.</dd>
         *   <dt>initialized</dt>           <dd><code>&</code> This event occurs after the binding has finished initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt>        <dd><code>=</code> A value indicating whether the binding has finished initializing the control with attribute values. </dd>
         *   <dt>show-alpha-channel</dt>    <dd><code>@</code> A value indicating whether the drop-down displays the alpha channel (transparency) editor.</dd>
         *   <dt>placeholder</dt>           <dd><code>@</code> The string to show as a hint when the control is empty.</dd>
         *   <dt>is-required</dt>           <dd><code>@</code> A value indicating whether to prevent null values.</dd>
         *   <dt>show-drop-down-button</dt> <dd><code>@</code> A value indicating whether the control displays a drop-down button.</dd>
         *   <dt>text</dt>                  <dd><code>=</code> The text to show in the control.</dd>
         *   <dt>value</dt>                 <dd><code>=</code> The color being edited.</dd>
         *   <dt>got-focus</dt>             <dd><code>&</code> The @see:InputColor.gotFocus event handler.</dd>
         *   <dt>lost-focus</dt>            <dd><code>&</code> The @see:InputColor.lostFocus event handler.</dd>
         *   <dt>is-dropped-down-changing</dt><dd><code>&</code> The @see:InputColor.isDroppedDownChanging event handler.</dd>
         *   <dt>is-dropped-down-changed</dt><dd><code>&</code> The @see:InputColor.isDroppedDownChanged event handler.</dd>
         *   <dt>text-changed</dt>          <dd><code>&</code> The @see:InputColor.textChanged event handler.</dd>
         *   <dt>value-changed</dt>         <dd><code>&</code> The @see:InputColor.valueChanged event handler.</dd>
         * </dl>
         */
        var WjInputColor = /** @class */ (function (_super) {
            __extends(WjInputColor, _super);
            function WjInputColor() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(WjInputColor.prototype, "_controlConstructor", {
                // Gets the InputColor control constructor
                get: function () {
                    return wijmo.input.InputColor;
                },
                enumerable: true,
                configurable: true
            });
            return WjInputColor;
        }(WjDropDown));
        /**
         * AngularJS directive for the @see:Popup control.
         *
         * Use the <b>wj-popup</b> directive to add @see:Popup controls to your
         * AngularJS applications.
         *
         * The popup content may be specified inside the <b>wj-popup</b> tag, and can
         * contain an arbitrary HTML fragment with AngularJS bindings and directives.
         *
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;p&gt;Here is a Popup control triggered by a button:&lt;/p&gt;
         * &lt;button id="btn2" type="button"&gt;
         *     Click to show Popup
         * &lt;/button&gt;
         * &lt;wj-popup owner="#btn2" show-trigger="Click" hide-trigger="Blur"&gt;
         *     &lt;h3&gt;
         *         Salutation
         *     &lt;/h3&gt;
         *     &lt;div class="popover-content"&gt;
         *         Hello {&#8203;{firstName}} {&#8203;{lastName}}
         *     &lt;/div&gt;
         * &lt;/wj-popup&gt;</pre>
         *
         * The <b>wj-popup</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>control</dt>         <dd><code>=</code> A reference to the Popup control created by this directive.</dd>
         *   <dt>fade-in</dt>         <dd><code>@</code> A boolean value that determines whether popups should be shown using a fade-in animation.</dd>
         *   <dt>fade-out</dt>        <dd><code>@</code> A boolean value that determines whether popups should be hidden using a fade-out animation.</dd>
         *   <dt>hide-trigger</dt>    <dd><code>@</code> A @see:PopupTrigger value defining the action that hides the @see:Popup.</dd>
         *   <dt>initialized</dt>     <dd><code>&</code> This event occurs after the binding has finished initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt>  <dd><code>=</code> A value indicating whether the binding has finished initializing the control with attribute values. </dd>
         *   <dt>owner</dt>           <dd><code>@</code> A CSS selector referencing an element that controls the popup visibility.</dd>
         *   <dt>show-trigger</dt>    <dd><code>@</code> A @see:PopupTrigger value defining the action that shows the @see:Popup.</dd>
         *   <dt>modal</dt>           <dd><code>@</code> A boolean value that determines whether the @see:Popup should be displayed as a modal dialog.</dd>
         *   <dt>got-focus</dt>       <dd><code>&</code> The @see:Popup.gotFocus event handler.</dd>
         *   <dt>lost-focus</dt>      <dd><code>&</code> The @see:Popup.lostFocus event handler.</dd>
         *   <dt>showing</dt>         <dd><code>&</code> The @see:Popup.showing event handler.</dd>
         *   <dt>shown</dt>           <dd><code>&</code> The @see:Popup.shown event handler.</dd>
         *   <dt>hiding</dt>          <dd><code>&</code> The @see:Popup.hiding event handler.</dd>
         *   <dt>hidden</dt>          <dd><code>&</code> The @see:Popup.hidden event handler.</dd>
         * </dl>
         */
        var WjPopup = /** @class */ (function (_super) {
            __extends(WjPopup, _super);
            function WjPopup() {
                var _this = _super.call(this) || this;
                _this.transclude = true;
                _this.template = '<div ng-transclude/>';
                return _this;
            }
            Object.defineProperty(WjPopup.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.input.Popup;
                },
                enumerable: true,
                configurable: true
            });
            WjPopup.prototype._initProps = function () {
                _super.prototype._initProps.call(this);
                angular.MetaFactory.findProp('owner', this._props).customHandler =
                    function (scope, control, value, oldValue, link) {
                        // set modal if not specified
                        var modal = scope['modal'];
                        if (modal == null) {
                            // not specified, make it modal if it has no owner 
                            control['modal'] = value ? false : true;
                        }
                    };
            };
            return WjPopup;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:MultiSelect control.
         *
         * Use the <b>wj-multi-select</b> directive to add <b>MultiSelect</b> controls to your AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;p&gt;Here is a MultiSelect bound to a collection of objects:&lt;/p&gt;
         * &lt;wj-multi-select
         *     placeholder="Select Countries"
         *     items-source="ctx.items"
         *     header-format="{count} countries selected"
         *     display-Member-path="country"
         *     checked-Member-path="selected"&gt;
         * &lt;/wj-multi-select&gt;</pre>
         *
         * The <b>wj-multi-select</b> directive extends @see:WjComboBox with the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>checked-member-path</dt>  <dd><code>@</code> The name of the property used to control the checkboxes placed next to each item.</dd>
         *   <dt>header-format</dt>        <dd><code>@</code> The format string used to create the header content when the control has more than <b>maxHeaderItems</b> items checked.</dd>
         *   <dt>header-formatter</dt>     <dd><code>=</code> A function that gets the HTML in the control header.</dd>
         *   <dt>max-header-items</dt>     <dd><code>@</code> The maximum number of items to display on the control header.</dd>
         *   <dt>checked-items-changed</dt><dd><code>&</code> The @see:MultiSelect.checkedItemsChanged event handler.</dd>
         * </dl>
         */
        var WjMultiSelect = /** @class */ (function (_super) {
            __extends(WjMultiSelect, _super);
            function WjMultiSelect($compile) {
                return _super.call(this, $compile) || this;
            }
            Object.defineProperty(WjMultiSelect.prototype, "_controlConstructor", {
                // Gets the InputColor control constructor
                get: function () {
                    return wijmo.input.MultiSelect;
                },
                enumerable: true,
                configurable: true
            });
            return WjMultiSelect;
        }(WjComboBox));
        /**
         * AngularJS directive for the @see:MultiAutoComplete control.
         *
         * Use the <b>wj-multi-auto-complete</b> directive to add <b>MultiAutoComplete</b> controls to your AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;p&gt;Here is a InputTags bound to a collection of objects:&lt;/p&gt;
         * &lt;wj-multi-auto-complete
         *     max-selected-items="8"
         *     items-source="ctx.items"
         *     selected-Member-path="selected"&gt;
         * &lt;/wj-multi-auto-complete&gt;</pre>
    
         * The <b>wj-multi-auto-complete</b> directive extends @see:WjAutoComplete with the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>max-selected-items</dt>   <dd><code>@</code> The maximum number of items that can be selected.</dd>
         *   <dt>selected-member-path</dt> <dd><code>@</code> The name of the property used to control which
         *                                 item will be selected.</dd>
         *   <dt>selected-items</dt>       <dd><code>@</code> An array containing the items that are currently selected.
         *   <dt>selected-items-changed</dt> <dd><code>&</code> The @see:MultiAutoComplete.selectedItemsChanged event handler.</dd>
         * </dl>
         */
        var WjMultiAutoComplete = /** @class */ (function (_super) {
            __extends(WjMultiAutoComplete, _super);
            function WjMultiAutoComplete($compile) {
                return _super.call(this, $compile) || this;
            }
            Object.defineProperty(WjMultiAutoComplete.prototype, "_controlConstructor", {
                // Gets the MultiAutoComplete control constructor
                get: function () {
                    return wijmo.input.MultiAutoComplete;
                },
                enumerable: true,
                configurable: true
            });
            return WjMultiAutoComplete;
        }(WjAutoComplete));
        /**
         * AngularJS directive for an @see:ICollectionView navigator element.
         *
         * Use the <b>wj-collection-view-navigator</b> directive to add an element that allows users to
         * navigate through the items in an @see:ICollectionView.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>Here is a CollectionViewNavigator:&lt;/p&gt;
         * &lt;wj-collection-view-navigator
         *   cv="myCollectionView"&gt;
         * &lt;/wj-collection-view-navigator&gt;</pre>
         *
         * @fiddle:s8tT4
         *
         * This example creates a CollectionView with 100,000 items and 20 items per page.
         * It defines a navigator to select the current page, another to select the current item,
         * and shows the data in a @see:FlexGrid.
         *
         * The <b>wj-collection-view-navigator</b> directive has a single attribute:
         *
         * <dl class="dl-horizontal">
         *   <dt>cv</dt>  <dd><code>=</code> A reference to the @see:ICollectionView object to navigate.</dd>
         * </dl>
         */
        var WjCollectionViewNavigator = /** @class */ (function (_super) {
            __extends(WjCollectionViewNavigator, _super);
            // Initializes a new instance of a WjCollectionViewNavigator
            function WjCollectionViewNavigator() {
                var _this = _super.call(this) || this;
                _this.template = '<div class="wj-control wj-content wj-pager">' +
                    '<div class="wj-input-group">' +
                    '<span class="wj-input-group-btn">' +
                    '<button class="wj-btn wj-btn-default" type="button"' +
                    ' ng-click="cv.moveCurrentToFirst()"' +
                    ' ng-disabled="cv.currentPosition <= 0">' +
                    '<span class="wj-glyph-left" style="margin-right:-4px"></span>' +
                    '<span class="wj-glyph-left"></span>' +
                    ' </button>' +
                    '</span>' +
                    '<span class="wj-input-group-btn">' +
                    ' <button class="wj-btn wj-btn-default" type="button"' +
                    ' ng-click="cv.moveCurrentToPrevious()"' +
                    ' ng-disabled="cv.currentPosition <= 0">' +
                    '<span class="wj-glyph-left"></span>' +
                    ' </button>' +
                    '</span>' +
                    '<input type="text" class="wj-form-control" value="' +
                    ' {{cv.currentPosition + 1 | number}} / {{cv.itemCount | number}}' +
                    ' " disabled />' +
                    '<span class="wj-input-group-btn">' +
                    '<button class="wj-btn wj-btn-default" type="button"' +
                    ' ng-click="cv.moveCurrentToNext()"' +
                    ' ng-disabled="cv.currentPosition >= cv.itemCount - 1">' +
                    '<span class="wj-glyph-right"></span>' +
                    '</button>' +
                    '</span>' +
                    '<span class="wj-input-group-btn">' +
                    '<button class="wj-btn wj-btn-default" type="button"' +
                    ' ng-click="cv.moveCurrentToLast()"' +
                    ' ng-disabled="cv.currentPosition >= cv.itemCount - 1">' +
                    '<span class="wj-glyph-right"></span>' +
                    '<span class="wj-glyph-right" style="margin-left:-4px"></span>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>';
                return _this;
            }
            WjCollectionViewNavigator.prototype._getMetaDataId = function () {
                return 'CollectionViewNavigator';
            };
            // Gets the WjCollectionViewNavigator directive's link function. Overrides parent member
            WjCollectionViewNavigator.prototype._postLinkFn = function () {
                return function (scope, tElement, tAttrs, dropDownController) {
                };
            };
            return WjCollectionViewNavigator;
        }(angular.WjDirective));
        /**
         * AngularJS directive for an @see:ICollectionView pager element.
         *
         * Use the <b>wj-collection-view-pager</b> directive to add an element that allows users to
         * navigate through the pages in a paged @see:ICollectionView.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>Here is a CollectionViewPager:&lt;/p&gt;
         * &lt;wj-collection-view-pager
         *   cv="myCollectionView"&gt;
         * &lt;/wj-collection-view-pager&gt;</pre>
         *
         * @fiddle:s8tT4
         *
         * This example creates a CollectionView with 100,000 items and 20 items per page.
         * It defines a navigator to select the current page, another to select the current item,
         * and shows the data in a @see:FlexGrid.
         *
         * The <b>wj-collection-view-pager</b> directive has a single attribute:
         *
         * <dl class="dl-horizontal">
         *   <dt>cv</dt>  <dd><code>=</code> A reference to the paged @see:ICollectionView object to navigate.</dd>
         * </dl>
         */
        var WjCollectionViewPager = /** @class */ (function (_super) {
            __extends(WjCollectionViewPager, _super);
            // Initializes a new instance of a WjCollectionViewPager
            function WjCollectionViewPager() {
                var _this = _super.call(this) || this;
                _this.template = '<div class="wj-control wj-content wj-pager">' +
                    '<div class="wj-input-group">' +
                    '<span class="wj-input-group-btn">' +
                    '<button class="wj-btn wj-btn-default" type="button"' +
                    'ng-click="cv.moveToFirstPage()"' +
                    'ng-disabled="cv.pageIndex <= 0">' +
                    '<span class="wj-glyph-left" style="margin-right:-4px"></span>' +
                    '<span class="wj-glyph-left"></span>' +
                    '</button>' +
                    '</span>' +
                    '<span class="wj-input-group-btn">' +
                    '<button class="wj-btn wj-btn-default" type="button"' +
                    'ng-click="cv.moveToPreviousPage()"' +
                    'ng-disabled="cv.pageIndex <= 0">' +
                    '<span class="wj-glyph-left"></span>' +
                    '</button>' +
                    '</span>' +
                    '<input type="text" class="wj-form-control" value="' +
                    '{{cv.pageIndex + 1 | number}} / {{cv.pageCount | number}}' +
                    '" disabled />' +
                    '<span class="wj-input-group-btn">' +
                    '<button class="wj-btn wj-btn-default" type="button"' +
                    'ng-click="cv.moveToNextPage()"' +
                    'ng-disabled="cv.pageIndex >= cv.pageCount - 1">' +
                    '<span class="wj-glyph-right"></span>' +
                    '</button>' +
                    '</span>' +
                    '<span class="wj-input-group-btn">' +
                    '<button class="wj-btn wj-btn-default" type="button"' +
                    'ng-click="cv.moveToLastPage()"' +
                    'ng-disabled="cv.pageIndex >= cv.pageCount - 1">' +
                    '<span class="wj-glyph-right"></span>' +
                    '<span class="wj-glyph-right" style="margin-left:-4px"></span>' +
                    '</button>' +
                    '</span>' +
                    '</div>' +
                    '</div>';
                return _this;
            }
            WjCollectionViewPager.prototype._getMetaDataId = function () {
                return 'CollectionViewPager';
            };
            // Gets the WjCollectionViewPager directive's link function. Overrides parent member
            WjCollectionViewPager.prototype._postLinkFn = function () {
                return function (scope, tElement, tAttrs, dropDownController) {
                };
            };
            return WjCollectionViewPager;
        }(angular.WjDirective));
        //#endregion "Input directives classes"
    })(angular = wijmo.angular || (wijmo.angular = {}));
})(wijmo || (wijmo = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
//
// AngularJS directives for wijmo.chart module
//
var wijmo;
(function (wijmo) {
    var angular;
    (function (angular) {
        //#region "Charts directives registration"
        var wijmoChart = window['angular'].module('wj.chart', []);
        // register only if module is loaded
        if (wijmo.chart && wijmo.chart.FlexChart) {
            wijmoChart.directive('wjFlexChart', [function () {
                    return new WjFlexChart();
                }]);
            wijmoChart.directive('wjFlexChartAxis', [function () {
                    return new WjFlexChartAxis();
                }]);
            wijmoChart.directive('wjFlexChartSeries', [function () {
                    return new WjFlexChartSeries();
                }]);
            wijmoChart.directive('wjFlexChartLegend', [function () {
                    return new WjFlexChartLegend();
                }]);
            wijmoChart.directive('wjFlexChartDataLabel', [function () {
                    return new WjFlexChartDataLabel();
                }]);
            wijmoChart.directive('wjFlexPieDataLabel', [function () {
                    return new WjFlexPieDataLabel();
                }]);
            wijmoChart.directive('wjFlexChartLineMarker', [function () {
                    return new WjFlexChartLineMarker();
                }]);
            wijmoChart.directive('wjFlexChartPlotArea', [function () {
                    return new WjFlexChartPlotArea();
                }]);
            wijmoChart.directive('wjFlexChartDataPoint', [function () {
                    return new WjFlexChartDataPoint();
                }]);
            if (wijmo.chart.interaction) {
                wijmoChart.directive('wjFlexChartRangeSelector', [function () {
                        return new WjFlexChartRangeSelector();
                    }]);
                wijmoChart.directive('wjFlexChartGestures', [function () {
                        return new WjFlexChartChartGestures();
                    }]);
                wijmoChart.directive('wjFlexChartChartGestures', [function () {
                        return new WjFlexChartChartGestures();
                    }]);
            }
            if (wijmo.chart.annotation) {
                wijmoChart.directive('wjFlexChartAnnotationLayer', [function () {
                        return new WjFlexChartAnnotationLayer();
                    }]);
                wijmoChart.directive('wjFlexChartAnnotation', [function () {
                        return new WjFlexChartAnnotation();
                    }]);
            }
            wijmoChart.directive('wjFlexPie', [function () {
                    return new WjFlexPie();
                }]);
            if (wijmo.chart.hierarchical) {
                wijmoChart.directive('wjSunburst', [function () {
                        return new WjSunburst();
                    }]);
                wijmoChart.directive('wjTreeMap', [function () {
                        return new WjTreeMap();
                    }]);
            }
            if (wijmo.chart.radar) {
                wijmoChart.directive('wjFlexRadar', [function () {
                        return new WjFlexRadar();
                    }]);
                wijmoChart.directive('wjFlexRadarSeries', [function () {
                        return new WjFlexRadarSeries();
                    }]);
            }
            if (wijmo.chart.finance) {
                wijmoChart.directive('wjFinancialChart', [function () {
                        return new WjFinancialChart();
                    }]);
                wijmoChart.directive('wjFinancialChartSeries', [function () {
                        return new WjFinancialChartSeries();
                    }]);
                if (wijmo.chart.finance.analytics) {
                    wijmoChart.directive('wjFlexChartFibonacci', [function () {
                            return new WjFlexChartFibonacci();
                        }]);
                    wijmoChart.directive('wjFlexChartFibonacciArcs', [function () {
                            return new WjFlexChartFibonacciArcs();
                        }]);
                    wijmoChart.directive('wjFlexChartFibonacciFans', [function () {
                            return new WjFlexChartFibonacciFans();
                        }]);
                    wijmoChart.directive('wjFlexChartFibonacciTimeZones', [function () {
                            return new WjFlexChartFibonacciTimeZones();
                        }]);
                    wijmoChart.directive('wjFlexChartAtr', [function () {
                            return new WjFlexChartAtr();
                        }]);
                    wijmoChart.directive('wjFlexChartCci', [function () {
                            return new WjFlexChartCci();
                        }]);
                    wijmoChart.directive('wjFlexChartRsi', [function () {
                            return new WjFlexChartRsi();
                        }]);
                    wijmoChart.directive('wjFlexChartWilliamsR', [function () {
                            return new WjFlexChartWilliamsR();
                        }]);
                    wijmoChart.directive('wjFlexChartMacd', [function () {
                            return new WjFlexChartMacd();
                        }]);
                    wijmoChart.directive('wjFlexChartMacdHistogram', [function () {
                            return new WjFlexChartMacdHistogram();
                        }]);
                    wijmoChart.directive('wjFlexChartStochastic', [function () {
                            return new WjFlexChartStochastic();
                        }]);
                    wijmoChart.directive('wjFlexChartBollingerBands', [function () {
                            return new WjFlexChartBollingerBands();
                        }]);
                    wijmoChart.directive('wjFlexChartEnvelopes', [function () {
                            return new WjFlexChartEnvelopes();
                        }]);
                }
            }
            if (wijmo.chart.analytics) {
                wijmoChart.directive('wjFlexChartTrendLine', [function () {
                        return new WjFlexChartTrendLine();
                    }]);
                wijmoChart.directive('wjFlexChartMovingAverage', [function () {
                        return new WjFlexChartMovingAverage();
                    }]);
                wijmoChart.directive('wjFlexChartYFunctionSeries', [function () {
                        return new WjFlexChartYFunctionSeries();
                    }]);
                wijmoChart.directive('wjFlexChartParametricFunctionSeries', [function () {
                        return new WjFlexChartParametricFunctionSeries();
                    }]);
                wijmoChart.directive('wjFlexChartWaterfall', [function () {
                        return new WjFlexChartWaterfall();
                    }]);
                wijmoChart.directive('wjFlexChartBoxWhisker', [function () {
                        return new WjFlexChartBoxWhisker();
                    }]);
                wijmoChart.directive('wjFlexChartErrorBar', [function () {
                        return new WjFlexChartErrorBar();
                    }]);
            }
            if (wijmo.chart.animation) {
                wijmoChart.directive('wjFlexChartAnimation', [function () {
                        return new WjFlexChartAnimation();
                    }]);
            }
        }
        //#endregion "Charts directives definitions"
        //#region "Charts directives classes"
        // Base class for WjFlexCore and FlexPie directives with common prop and event dictionaries
        var WjFlexChartBase = /** @class */ (function (_super) {
            __extends(WjFlexChartBase, _super);
            // Initializes a new instance of a WjFlexChart
            function WjFlexChartBase() {
                var _this = _super.call(this) || this;
                var self = _this;
                _this.template = '<div ng-transclude />';
                _this.transclude = true;
                return _this;
            }
            Object.defineProperty(WjFlexChartBase.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.FlexChartBase;
                },
                enumerable: true,
                configurable: true
            });
            WjFlexChartBase.prototype._initProps = function () {
                _super.prototype._initProps.call(this);
                var self = this; // store this in closure as .apply() call overrides the reference
                var tooltipDesc = angular.MetaFactory.findProp('tooltipContent', this._props);
                tooltipDesc.customHandler = function (scope, control, value, oldValue, link) {
                    if (value != null) {
                        control.tooltip.content = value;
                    }
                };
            };
            return WjFlexChartBase;
        }(angular.WjDirective));
        // Base class for WjFlexChart and WjFinancialChart
        var WjFlexChartCore = /** @class */ (function (_super) {
            __extends(WjFlexChartCore, _super);
            function WjFlexChartCore() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(WjFlexChartCore.prototype, "_controlConstructor", {
                // gets the Wijmo FlexChart control constructor
                get: function () {
                    return wijmo.chart.FlexChartCore;
                },
                enumerable: true,
                configurable: true
            });
            WjFlexChartCore.prototype._initProps = function () {
                _super.prototype._initProps.call(this);
                var self = this; // store this in closure as .apply() call overrides the reference
                var lblContentDesc = angular.MetaFactory.findProp('labelContent', this._props);
                lblContentDesc.customHandler = function (scope, control, value, oldValue, link) {
                    if (value != null) {
                        control.dataLabel.content = value;
                    }
                };
            };
            return WjFlexChartCore;
        }(WjFlexChartBase));
        /**
         * AngularJS directive for the @see:FlexChart control.
         *
         * Use the <b>wj-flex-chart</b> directive to add charts to your AngularJS applications.
         * Note that directive and parameter names must be formatted using lower-case letters
         * with dashes instead of camel case. For example:
         *
         * <pre>&lt;p&gt;Here is a FlexChart control:&lt;/p&gt;
         * &lt;wj-flex-chart
         *   style="height:300px"
         *   items-source="data"
         *   binding-x="country"&gt;
         *   &lt;wj-flex-chart-axis
         *     wj-property="axisY"
         *     major-unit="5000"&gt;
         *   &lt;/wj-flex-chart-axis&gt;
         *   &lt;wj-flex-chart-series
         *     binding="sales"
         *     name="Sales"&gt;
         *   &lt;/wj-flex-chart-series&gt;
         *   &lt;wj-flex-chart-series
         *     binding="expenses"
         *     name="Expenses"&gt;
         *   &lt;/wj-flex-chart-series&gt;
         *   &lt;wj-flex-chart-series
         *     binding="downloads"
         *     name="Downloads"
         *     chart-type="LineSymbols"&gt;
         *   &lt;/wj-flex-chart-series&gt;
         * &lt;/wj-flex-chart&gt;</pre>
         *
         * The example below creates a @see:FlexChart control and binds it to a 'data' array
         * exposed by the controller. The chart has three series objects, each corresponding to
         * a property in the objects contained in the source array. The last series in the
         * example uses the 'chart-type' attribute to override the default chart type used
         * for the other series objects.
         *
         * @fiddle:QNb9X
         *
         * The wj-flex-chart directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>           <dd><code>@</code> The name of the property that contains Y
         *                              values for the chart. You can override this at the series level.</dd>
         *   <dt>binding-x</dt>         <dd><code>@</code> The name of the property that contains X
         *                              values for the chart. You can override this at the series level.</dd>
         *   <dt>chart-type</dt>        <dd><code>@</code> The default chart type to use in rendering series
         *                              objects. You can override this at the series level. See @see:ChartType.</dd>
         *   <dt>control</dt>           <dd><code>=</code> A reference to the @see:FlexChart control
         *                              that this directive creates.</dd>
         *   <dt>footer</dt>            <dd><code>@</code> The text to display in the chart footer (plain
         *                              text).</dd>
         *   <dt>footer-style</dt>       <dd><code>=</code> The style to apply to the chart footer.</dd>
         *   <dt>header</dt>            <dd><code>@</code> The text to display in the chart header (plain
         *                              text).</dd>
         *   <dt>header-style</dt>      <dd><code>=</code> The style to apply to the chart header.</dd>
         *   <dt>initialized</dt>       <dd><code>&</code> This event occurs after the binding has finished
         *                              initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt><dd><code>=</code> A value indicating whether the binding has finished
         *                              initializing the control with attribute values. </dd>
         *   <dt>interpolate-nulls</dt> <dd><code>@</code> The value indicating whether to interpolate or
         *                              leave gaps when there are null values in the data.</dd>
         *   <dt>item-formatter</dt>    <dd><code>=</code> The formatter function that customizes the
         *                              appearance of data points.</dd>
         *   <dt>items-source</dt>      <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                              the data used to create the chart.</dd>
         *   <dt>legend-toggle</dt>     <dd><code>@</code> The value indicating whether clicking legend items
         *                              toggles series visibility.</dd>
         *   <dt>options</dt>           <dd><code>=</code> Chart options that only apply to certain chart types.
         *                              See <b>options</b> under @see:FlexChart for details.</dd>
         *   <dt>palette</dt>           <dd><code>=</code> An array that contains the default colors used for
         *                              displaying each series.</dd>
         *   <dt>plot-margin</dt>       <dd><code>=</code> The number of pixels of space to leave between the
         *                              edges of the control and the plot area, or CSS-style margins.</dd>
         *   <dt>rotated</dt>           <dd><code>@</code> The value indicating whether to flip the axes so that
         *                              X is vertical and Y is horizontal.</dd>
         *   <dt>selection</dt>         <dd><code>=</code> The series object that is selected.</dd>
         *   <dt>selection-mode</dt>    <dd><code>@</code> The @see:SelectionMode value indicating whether or what is
         *                              selected when the user clicks a series.</dd>
         *   <dt>stacking</dt>          <dd><code>@</code> The @see:Stacking value indicating whether or how series
         *                              objects are stacked or plotted independently.</dd>
         *   <dt>symbol-size</dt>       <dd><code>@</code> The size of the symbols used to render data points in Scatter,
         *                              LineSymbols, and SplineSymbols charts, in pixels. You can override
         *                              this at the series level.</dd>
         *   <dt>tooltip-content</dt>   <dd><code>@</code> The value to display in the
         *                              @see:ChartTooltip content property.</dd>
         *   <dt>got-focus</dt>         <dd><code>&</code> The @see:FlexChart.gotFocus event handler.</dd>
         *   <dt>lost-focus</dt>        <dd><code>&</code> The @see:FlexChart.lostFocus event handler.</dd>
         *   <dt>rendering</dt>         <dd><code>&</code> The @see:FlexChart.rendering event handler.</dd>
         *   <dt>rendered</dt>          <dd><code>&</code> The @see:FlexChart.rendered event handler.</dd>
         *   <dt>series-visibility-changed</dt>
         *                              <dd><code>&</code> The @see:FlexChart.seriesVisibilityChanged event handler.</dd>
         *   <dt>selection-changed</dt> <dd><code>&</code> The @see:FlexChart.selectionChanged event handler.</dd>
         * </dl>
         *
         * The wj-flex-chart directive may contain the following child directives:
         * @see:WjFlexChartAxis, @see:WjFlexChartSeries, @see:WjFlexChartLegend and @see:WjFlexChartDataLabel.
         */
        var WjFlexChart = /** @class */ (function (_super) {
            __extends(WjFlexChart, _super);
            function WjFlexChart() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(WjFlexChart.prototype, "_controlConstructor", {
                // gets the Wijmo FlexChart control constructor
                get: function () {
                    return wijmo.chart.FlexChart;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChart;
        }(WjFlexChartCore));
        /**
         * AngularJS directive for the @see:FlexChart @see:Axis object.
         *
         * The <b>wj-flex-chart-axis</b> directive must be contained in a @see:WjFlexChart directive or @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>wj-property</dt>     <dd><code>@</code> Defines the @see:FlexChart property name,
         *                            axis-x or axis-y, to initialize with the directive.</dd>
         *   <dt>axis-line</dt>       <dd><code>@</code> The value indicating whether the axis line is visible.</dd>
         *   <dt>binding</dt>         <dd><code>@</code> Gets or sets the comma-separated property names for
         *                            the @see:wijmo.chart.Axis.itemsSource property to use in axis labels.
         *                            The first name specifies the value on the axis, the second represents
         *                            the corresponding axis label. The default value is 'value,text'.</dd>
         *   <dt>format</dt>          <dd><code>@</code> The format string used for the axis labels
         *                            (see @see:Globalize).</dd>
         *   <dt>item-formatter</dt>  <dd><code>=</code> The formatter function that customizes the
         *                            appearance of axis labels.</dd>
         *   <dt>items-source</dt>    <dd><code>=</code> The items source for the axis labels.</dd>
         *   <dt>labels</dt>          <dd><code>@</code> The value indicating whether the axis labels are visible.</dd>
         *   <dt>label-angle</dt>     <dd><code>@</code> The rotation angle of axis labels in degrees.</dd>
         *   <dt>label-align</dt>     <dd><code>@</code> The alignment of axis labels.</dd>
         *   <dt>label-padding</dt>   <dd><code>@</code> The padding of axis labels.</dd>
         *   <dt>major-grid</dt>      <dd><code>@</code> The value indicating whether the axis includes grid lines.</dd>
         *   <dt>major-tick-marks</dt><dd><code>@</code> Defines the appearance of tick marks on the axis
         *                            (see @see:TickMark).</dd>
         *   <dt>major-unit</dt>      <dd><code>@</code> The number of units between axis labels.</dd>
         *   <dt>max</dt>             <dd><code>@</code> The minimum value shown on the axis.</dd>
         *   <dt>min</dt>             <dd><code>@</code> The maximum value shown on the axis.</dd>
         *   <dt>minor-grid</dt>      <dd><code>@</code> The value indicating whether the axis includes minor grid lines.</dd>
         *   <dt>minor-tick-marks</dt><dd><code>@</code> Defines the appearance of minor tick marks on the axis
         *                            (see @see:TickMark).</dd>
         *   <dt>minor-unit</dt>      <dd><code>@</code> The number of units between minor axis ticks.</dd>
         *   <dt>origin</dt>          <dd><code>@</code> The axis origin.</dd>
         *   <dt>overlappingLabels</dt><dd><code>@</code> The @see:OverlappingLabels value indicating how to handle the overlapping axis labels.</dd>
         *   <dt>position</dt>        <dd><code>@</code> The @see:Position value indicating the position of the axis.</dd>
         *   <dt>reversed</dt>        <dd><code>@</code> The value indicating whether the axis is reversed (top to
         *                            bottom or right to left).</dd>
         *   <dt>title</dt>           <dd><code>@</code> The title text shown next to the axis.</dd>
         * </dl>
         */
        var WjFlexChartAxis = /** @class */ (function (_super) {
            __extends(WjFlexChartAxis, _super);
            // Initializes a new instance of a WjFlexCharAxis.
            function WjFlexChartAxis() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFlexChartSeries', '?^wjFinancialChartSeries', '?^wjFlexChart', '?^wjFinancialChart', '?^wjFlexRadar'];
                _this.template = '<div class="wjFlexChartAxis" />';
                return _this;
            }
            Object.defineProperty(WjFlexChartAxis.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.Axis;
                },
                enumerable: true,
                configurable: true
            });
            WjFlexChartAxis.prototype._initControl = function (element) {
                return _super.prototype._initControl.call(this, undefined);
            };
            return WjFlexChartAxis;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:FlexChart @see:Legend object.
         *
         * The <b>wj-flex-chart-legend</b> directive must be contained in a @see:WjFlexChart directive, @see:WjFlexPie directive or @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>position</dt>       <dd><code>@</code> The @see:Position value indicating the position of the
         *                           legend.</dd>
         * </dl>
         *
         * The example below shows how you can use the wj-flex-chart-legend directive
         * to change the position of the chart legend:
         *
         * <pre>&lt;wj-flex-chart
         *   items-source="data"
         *   binding-x="country"&gt;
         *   &lt;wj-flex-chart-axis
         *       wj-property="axisY"
         *       major-unit="5000"&gt;
         *     &lt;/wj-flex-chart-axis&gt;
         *     &lt;wj-flex-chart-series
         *       binding="sales"
         *       name="Sales"&gt;
         *     &lt;/wj-flex-chart-series&gt;
         *   &lt;wj-flex-chart-legend
         *     position="Bottom"&gt;
         *   &lt;/wj-flex-chart-legend&gt;
         * &lt;/wj-flex-chart&gt;</pre>
         */
        var WjFlexChartLegend = /** @class */ (function (_super) {
            __extends(WjFlexChartLegend, _super);
            // Initializes a new instance of a WjFlexChartLegend.
            function WjFlexChartLegend() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFlexChart', '?^wjFlexPie', '?^wjSunburst', '?^wjFinancialChart', '?^wjFlexRadar'];
                _this.template = '<div />';
                return _this;
            }
            Object.defineProperty(WjFlexChartLegend.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.Legend;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartLegend;
        }(angular.WjDirective));
        // abstract
        var WjFlexChartDataLabelBase = /** @class */ (function (_super) {
            __extends(WjFlexChartDataLabelBase, _super);
            function WjFlexChartDataLabelBase() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFlexChart', '?^wjFlexPie', '?^wjSunburst', '?^wjTreeMap'];
                _this.template = '<div />';
                return _this;
            }
            Object.defineProperty(WjFlexChartDataLabelBase.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.DataLabelBase;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartDataLabelBase;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:FlexChart @see:DataLabel object.
         *
         * The <b>wj-flex-chart-data-label</b> directive must be contained in a @see:WjFlexChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>content</dt>       <dd><code>=</code> A string or function that gets or sets the content of the data labels.</dd>
         *   <dt>border</dt>        <dd><code>@</code> Gets or sets a value indicating whether the data labels have borders.</dd>
         *   <dt>position</dt>      <dd><code>@</code> The @see:LabelPosition value indicating the position of the data labels.</dd>
         * </dl>
         */
        var WjFlexChartDataLabel = /** @class */ (function (_super) {
            __extends(WjFlexChartDataLabel, _super);
            function WjFlexChartDataLabel() {
                var _this = _super.call(this) || this;
                _this.require = ['^wjFlexChart', '?^wjTreeMap'];
                return _this;
            }
            Object.defineProperty(WjFlexChartDataLabel.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.DataLabel;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartDataLabel;
        }(WjFlexChartDataLabelBase));
        /**
         * AngularJS directive for the @see:FlexPie @see:PieDataLabel object.
         *
         * The <b>wj-flex-pie-data-label</b> directive must be contained in a @see:WjFlexPie directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>content</dt>       <dd><code>=</code> A string or function that gets or sets the content of the data labels.</dd>
         *   <dt>border</dt>        <dd><code>@</code> Gets or sets a value indicating whether the data labels have borders.</dd>
         *   <dt>position</dt>      <dd><code>@</code> The @see:PieLabelPosition value indicating the position of the data labels.</dd>
         * </dl>
         */
        var WjFlexPieDataLabel = /** @class */ (function (_super) {
            __extends(WjFlexPieDataLabel, _super);
            function WjFlexPieDataLabel() {
                var _this = _super.call(this) || this;
                _this.require = ['^wjFlexPie', '?^wjSunburst'];
                return _this;
            }
            Object.defineProperty(WjFlexPieDataLabel.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.PieDataLabel;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexPieDataLabel;
        }(WjFlexChartDataLabelBase));
        // abstract for FlexChart and FinancialChart series
        var WjSeriesBase = /** @class */ (function (_super) {
            __extends(WjSeriesBase, _super);
            function WjSeriesBase() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFlexChart', '?^wjFinancialChart', '?^wjFlexRadar'];
                _this.template = '<div class="wjSeriesBase" ng-transclude />';
                _this.transclude = true;
                return _this;
            }
            Object.defineProperty(WjSeriesBase.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.SeriesBase;
                },
                enumerable: true,
                configurable: true
            });
            WjSeriesBase.prototype._initControl = function (element) {
                return _super.prototype._initControl.call(this, undefined);
            };
            WjSeriesBase.prototype._getId = function () {
                // fixes issue with ordering of series that
                // are of different types
                return 'series';
            };
            return WjSeriesBase;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:FlexChart @see:Series object.
         *
         * The <b>wj-flex-chart-series</b> directive must be contained in a @see:WjFlexChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>axis-x</dt>       <dd><code>@</code> X-axis for the series.</dd>
         *   <dt>axis-y</dt>       <dd><code>@</code> Y-axis for the series.</dd>
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>chart-type</dt>   <dd><code>@</code> The chart type to use in rendering objects for this series
         *                         objects. This value overrides the default chart type set on the chart. See
         *                         @see:ChartType.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>altStyle</dt>     <dd><code>=</code> The series alternative style.</dd>
         *   <dt>symbol-marker</dt><dd><code>@</code> The shape of marker to use for the series. This value
         *                         overrides the default marker set on the chart. See @see:Marker.</dd>
         *   <dt>symbol-size</dt>  <dd><code>@</code> The size of the symbols used to render data points in this series
         *                         for Scatter, LineSymbols, and SplineSymbols charts, in pixels.
         *                         This value overrides any settings at the chart level.</dd>
         *   <dt>symbol-style</dt> <dd><code>=</code> The style of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts.
         *                         This value overrides any settings at the chart level.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         * </dl>
         *
         * In most cases, the <b>wj-flex-chart-series</b> specifies only the <b>name</b> and <b>binding</b> properties.
         * The remaining values are inherited from the parent <b>wj-flex-chart</b> directive.
         */
        var WjFlexChartSeries = /** @class */ (function (_super) {
            __extends(WjFlexChartSeries, _super);
            // Initializes a new instance of a WjFlexChartSeries
            function WjFlexChartSeries() {
                var _this = _super.call(this) || this;
                _this.require = '^wjFlexChart';
                _this.template = '<div class="wjFlexChartSeries" ng-transclude />';
                return _this;
                //this.transclude = true;
            }
            Object.defineProperty(WjFlexChartSeries.prototype, "_controlConstructor", {
                // Returns constructor of related Wijmo object. Abstract member, must be overridden in inherited class
                get: function () {
                    return wijmo.chart.Series;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartSeries;
        }(WjSeriesBase));
        /**
         * AngularJS directive for the @see:FlexChart @see:LineMarker object.
         *
         * The <b>wj-flex-line-marker</b> directive must be contained in a @see:WjFlexChart directive or @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>is-visible</dt>             <dd><code>@</code> The value indicating whether the LineMarker is visible.</dd>
         *   <dt>series-index</dt>           <dd><code>@</code> The index of the series in the chart in which the LineMarker appears.</dd>
         *   <dt>horizontal-position</dt>    <dd><code>@</code> The horizontal position of the LineMarker relative to the plot area.</dd>
         *   <dt>content</dt>               <dd><code>@</code> The function that allows you to customize the text content of the LineMarker.</dd>
         *   <dt>vertical-position</dt>      <dd><code>@</code> The vertical position of the LineMarker relative to the plot area.</dd>
         *   <dt>alignment</dt>             <dd><code>@</code> The @see:LineMarkerAlignment value indicating the alignment of the LineMarker content.</dd>
         *   <dt>lines</dt>                 <dd><code>@</code> The @see:LineMarkerLines value indicating the appearance of the LineMarker's lines.</dd>
         *   <dt>interaction</dt>           <dd><code>@</code> The @see:LineMarkerInteraction value indicating the interaction mode of the LineMarker.</dd>
         *   <dt>drag-threshold</dt>         <dd><code>@</code> The maximum distance from the horizontal or vertical line that you can drag the marker.</dd>
         *   <dt>drag-content</dt>           <dd><code>@</code> The value indicating whether you can drag the content of the marker when the interaction mode is "Drag".</dd>
         *   <dt>drag-lines</dt>             <dd><code>@</code> The value indicating whether the lines are linked when you drag the horizontal or vertical line when the interaction mode is "Drag".</dd>
         * </dl>
         */
        var WjFlexChartLineMarker = /** @class */ (function (_super) {
            __extends(WjFlexChartLineMarker, _super);
            // Initializes a new instance of a WjFlexChartLineMarker
            function WjFlexChartLineMarker() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFlexChart', '?^wjFinancialChart'];
                return _this;
            }
            Object.defineProperty(WjFlexChartLineMarker.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.LineMarker;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartLineMarker;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:FlexChart @see:DataPoint object.
         *
         * The <b>wj-flex-chart-data-point</b> directive must be contained in a
         * @see:WjFlexChartAnnotation directive. The property of the parent directive's object
         * where <b>wj-flex-data-point</b> should assign a value is specified in the
         * <b>wj-property</b> attribute.
         *
         * The directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *
         *   <dt>wj-property</dt>        <dd><code>@</code> The name of the parent directive object's property where the
         *                                <b>DataPoint</b> will be assigned.</dd>
         *   <dt>x</dt>                  <dd><code>@</code> x coordinate, can be a numeric or date value.</dd>
         *   <dt>y</dt>                  <dd><code>@</code> y coordinate, can be a numeric or date value.</dd>
         * </dl>
         */
        var WjFlexChartDataPoint = /** @class */ (function (_super) {
            __extends(WjFlexChartDataPoint, _super);
            // Initializes a new instance of a WjFlexChartDataPoint
            function WjFlexChartDataPoint() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFlexChartAnnotation'];
                return _this;
            }
            Object.defineProperty(WjFlexChartDataPoint.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.DataPoint;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartDataPoint;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:FlexChart @see:AnnotationLayer object.
         *
         * The <b>wj-flex-chart-annotation-layer</b> directive must be contained in a @see:WjFlexChart directive
         * or @see:WjFinancialChart directive.
         *
         */
        var WjFlexChartAnnotationLayer = /** @class */ (function (_super) {
            __extends(WjFlexChartAnnotationLayer, _super);
            // Initializes a new instance of a WjFlexChartAnnotationLayer
            function WjFlexChartAnnotationLayer() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFlexChart', '?^wjFinancialChart'];
                _this.template = '<div class="wjFlexChartAnnotationLayer" ng-transclude />';
                _this.transclude = true;
                return _this;
            }
            Object.defineProperty(WjFlexChartAnnotationLayer.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.annotation.AnnotationLayer;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartAnnotationLayer;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:FlexChart @see:wijmo.chart.animation.ChartAnimation object.
         *
         * The <b>wj-flex-chart-animation</b> directive must be contained in a @see:WjFlexChart or @see:WjFlexPie or @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>animation-mode</dt>     <dd><code>@</code> The value indicating whether the plot points animate one at a time, series by series, or all at once.</dd>
         *   <dt>easing</dt>           <dd><code>@</code> The value indicating the easing function applied to the animation.</dd>
         *   <dt>duration</dt>           <dd><code>@</code> The value indicating the length of entire animation in milliseconds.</dd>
         *   <dt>axis-animation</dt>           <dd><code>@</code> The value indicating whether the axis animation is enabled.</dd>
         * </dl>
         */
        var WjFlexChartAnimation = /** @class */ (function (_super) {
            __extends(WjFlexChartAnimation, _super);
            // Initializes a new instance of a WjFlexChartRangeSelector
            function WjFlexChartAnimation() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFlexChart', '?^wjFlexPie', '?^wjSunburst', '?^wjFinancialChart', '?^wjFlexRadar'];
                return _this;
            }
            Object.defineProperty(WjFlexChartAnimation.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.animation.ChartAnimation;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartAnimation;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the annotations.
         *
         * The <b>wj-flex-chart-annotation</b> directive must be contained in a
         * @see:WjFlexChartAnnotationLayer directive.
         *
         * The <b>wj-flex-chart-annotation</b> directive is used to represent all types of
         * possible annotation shapes like <b>Circle</b>, <b>Rectangle</b>, <b>Polygon</b>
         * and so on. The type of annotation shape is specified
         * in the directive's <b>type</b> attribute.
         *
         * The directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *
         *   <dt>type</dt>                  <dd><code>@</code> The class name of the annotation shape represented by the directive.
         *                                      The possible values are @see:Circle, @see:Ellipse, @see:Image, @see:Line, @see:Polygon,
         *                                      @see:Rectangle, @see:Square, @see:Text.</dd>
         *   <dt>attachment</dt>            <dd><code>@</code> An @see:AnnotationAttachment value defining the attachment of the annotation.
         *                                      </dd>
         *   <dt>content</dt>               <dd><code>@</code> The text of the <b>Circle</b>, <b>Ellipse</b>, <b>Image</b>, <b>Line</b>,
         *                                      <b>Polygon</b>, <b>Rectangle</b> or <b>Square</b> annotation.</dd>
         *   <dt>end</dt>                   <dd><code>@</code> The end point of the <b>Line</b> annotation.</dd>
         *   <dt>height</dt>                <dd><code>@</code> The height of the <b>Ellipse</b>, <b>Image</b> or <b>Rectangle</b> annotation.</dd>
         *   <dt>href</dt>                  <dd><code>@</code> The href of the <b>Image</b> annotation.</dd>
         *   <dt>is-visible</dt>             <dd><code>@</code> The visibility of the annotation.</dd>
         *   <dt>length</dt>                <dd><code>@</code> The length of the <b>Square</b> annotation.</dd>
         *   <dt>name</dt>                  <dd><code>@</code> The name of the annotation.</dd>
         *   <dt>offset</dt>                <dd><code>@</code> The offset of the annotation.</dd>
         *   <dt>point</dt>                 <dd><code>@</code> The point of the annotation, the coordinate space of the point depends on the <b>attachment</b>  property value.
         *                                      The property works for <b>Circle</b>, <b>Ellipse</b>, <b>Image</b>, <b>Rectangle</b>, <b>Square</b>
         *                                      and <b>Text</b> annotation.</dd>
         *   <dt>point-index</dt>           <dd><code>@</code> The index of the data point in the specified series where the annotation is attached to.</dd>
         *   <dt>position</dt>              <dd><code>@</code> An @see:AnnotationPosition value defining the position of the annotation
         *                                      relative to the <b>point</b>.</dd>
         *   <dt>radius</dt>                <dd><code>@</code> The radius of the <b>Circle</b> annotation.</dd>
         *   <dt>series-index</dt>          <dd><code>@</code> The index of the data series where the annotation is attached to.</dd>
         *   <dt>start</dt>                 <dd><code>@</code> The start point of the <b>Line</b> annotation.</dd>
         *   <dt>style</dt>                 <dd><code>@</code> The style of the annotation.</dd>
         *   <dt>text</dt>                  <dd><code>@</code> The text of the <b>Text</b> annotation.</dd>
         *   <dt>tooltip</dt>               <dd><code>@</code> The tooltip of the annotation.</dd>
         *   <dt>width</dt>                 <dd><code>@</code> The width of the <b>Ellipse</b>, <b>Image</b> or <b>Rectangle</b> annotation.</dd>
         * </dl>
         */
        var WjFlexChartAnnotation = /** @class */ (function (_super) {
            __extends(WjFlexChartAnnotation, _super);
            // Initializes a new instance of a WjFlexChartAnnotation
            function WjFlexChartAnnotation() {
                var _this = _super.call(this) || this;
                _this.require = '^wjFlexChartAnnotationLayer';
                _this.template = '<div class="wjFlexChartAnnotation" ng-transclude />';
                _this.transclude = true;
                return _this;
            }
            WjFlexChartAnnotation.prototype._createLink = function () {
                return new WjFlexChartAnnotationLink();
            };
            WjFlexChartAnnotation.prototype._getMetaDataId = function () {
                return 'FlexChartAnnotation';
            };
            return WjFlexChartAnnotation;
        }(angular.WjDirective));
        var WjFlexChartAnnotationLink = /** @class */ (function (_super) {
            __extends(WjFlexChartAnnotationLink, _super);
            function WjFlexChartAnnotationLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            WjFlexChartAnnotationLink.prototype._initControl = function () {
                return new wijmo.chart.annotation[this.scope['type']]();
            };
            return WjFlexChartAnnotationLink;
        }(angular.WjLink));
        /**
         * AngularJS directive for the @see:FlexChart @see:wijmo.chart.interaction.RangeSelector object.
         *
         * The <b>wj-flex-chart-range-selector</b> directive must be contained in a @see:WjFlexChart directive or @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>is-visible</dt>     <dd><code>@</code> The value indicating whether the RangeSelector is visible.</dd>
         *   <dt>min</dt>           <dd><code>@</code> The minimum value of the range.</dd>
         *   <dt>max</dt>           <dd><code>@</code> The maximum value of the range.</dd>
         *   <dt>orientation</dt>   <dd><code>@</code> The orientation of the RangeSelector.</dd>
         *   <dt>seamless</dt>      <dd><code>@</code> The value indicating whether the minimal and maximal handler will move seamlessly.</dd>
         *   <dt>min-scale</dt>      <dd><code>@</code> the valid minimum range of the RangeSelector.</dd>
         *   <dt>max-scale</dt>      <dd><code>@</code> the valid maximum range of the RangeSelector.</dd>
         * </dl>
         */
        var WjFlexChartRangeSelector = /** @class */ (function (_super) {
            __extends(WjFlexChartRangeSelector, _super);
            // Initializes a new instance of a WjFlexChartRangeSelector
            function WjFlexChartRangeSelector() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFlexChart', '?^wjFinancialChart'];
                return _this;
            }
            Object.defineProperty(WjFlexChartRangeSelector.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.interaction.RangeSelector;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartRangeSelector;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:FlexChart @see:wijmo.chart.interaction.ChartGestures object.
         *
         * The <b>wj-flex-chart-gestures</b> directive must be contained in a @see:WjFlexChart directive or @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>mouse-action</dt>     <dd><code>@</code> The value indicating mouse action is zooming or panning.</dd>
         *   <dt>interactive-axes</dt> <dd><code>@</code> The value indicating which axis is interactive.</dd>
         *   <dt>enable</dt>          <dd><code>@</code> The value indicating the gestures action is enabled or not.</dd>
         *   <dt>scale-x</dt>          <dd><code>@</code> The value indicating axisX initial range between Min and Max.</dd>
         *   <dt>scale-y</dt>          <dd><code>@</code> The value indicating axisY initial range between Min and Max.</dd>
         *   <dt>pos-x</dt>            <dd><code>@</code> The value indicating initial position on the axisX.</dd>
         *   <dt>pos-y</dt>            <dd><code>@</code> The value indicating initial position on the axisY.</dd>
         * </dl>
         */
        var WjFlexChartChartGestures = /** @class */ (function (_super) {
            __extends(WjFlexChartChartGestures, _super);
            // Initializes a new instance of a WjFlexChartChartGestures
            function WjFlexChartChartGestures() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFlexChart', '?^wjFinancialChart'];
                return _this;
            }
            Object.defineProperty(WjFlexChartChartGestures.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.interaction.ChartGestures;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartChartGestures;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:FlexPie control.
         *
         * <dl class="dl-horizontal">
         *   <dt>items-source</dt>      <dd><code>=</code> An array or @see:ICollectionView
         *                              object that contains data for the chart.</dd>
         *   <dt>binding</dt>           <dd><code>@</code> The name of the property that
         *                              contains item values.</dd>
         *   <dt>binding-name</dt>      <dd><code>@</code> The name of the property that
         *                              contains item names.</dd>
         *   <dt>footer</dt>            <dd><code>@</code> The text to display in the chart footer (plain
         *                              text).</dd>
         *   <dt>footer-style</dt>       <dd><code>=</code> The style to apply to the chart footer.</dd>
         *   <dt>header</dt>            <dd><code>@</code> The text to display in the chart header (plain
         *                              text).</dd>
         *   <dt>header-style</dt>      <dd><code>=</code> The style to apply to the chart header.</dd>
         *   <dt>initialized</dt>       <dd><code>&</code> This event occurs after the binding has finished
         *                              initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt><dd><code>=</code> A value indicating whether the binding has finished
         *                              initializing the control with attribute values. </dd>
         *   <dt>inner-radius</dt>      <dd><code>@</code> The size of the hole inside the
         *                              pie, measured as a fraction of the pie radius.</dd>
         *   <dt>is-animated</dt>       <dd><code>@</code> A value indicating whether to use animation
         *                              to move selected items to the selectedItemPosition.</dd>
         *   <dt>item-formatter</dt>    <dd><code>=</code> The formatter function that customizes the
         *                              appearance of data points.</dd>
         *   <dt>offset</dt>            <dd><code>@</code> The extent to which pie slices are pulled
         *                              out from the center, as a fraction of the pie radius.</dd>
         *   <dt>palette</dt>           <dd><code>=</code> An array that contains the default colors used for
         *                              displaying pie slices.</dd>
         *   <dt>plot-margin</dt>       <dd><code>=</code> The number of pixels of space to leave between the
         *                              edges of the control and the plot area, or CSS-style margins.</dd>
         *   <dt>reversed</dt>          <dd><code>@</code> A value indicating whether to draw pie
         *                              slices in a counter-clockwise direction.</dd>
         *   <dt>start-angle</dt>       <dd><code>@</code> The starting angle for pie slices,
         *                              measured clockwise from the 9 o'clock position.</dd>
         *   <dt>selected-item-offset</dt>
         *                              <dd><code>@</code> The extent to which the selected pie slice is
         *                              pulled out from the center, as a fraction of the pie radius.</dd>
         *   <dt>selected-item-position</dt>
         *                              <dd><code>@</code> The @see:Position value indicating where to display
         *                              the selected slice.</dd>
         *   <dt>selection-mode</dt>    <dd><code>@</code> The @see:SelectionMode value indicating whether or what is
         *                              selected when the user clicks a series.</dd>
         *   <dt>tooltip-content</dt>   <dd><code>@</code> The value to display in the
         *                              @see:ChartTooltip content property.</dd>
         *   <dt>got-focus</dt>         <dd><code>&</code> The @see:FlexPie.gotFocus event handler.</dd>
         *   <dt>lost-focus</dt>        <dd><code>&</code> The @see:FlexPie.lostFocus event handler.</dd>
         *   <dt>rendering</dt>         <dd><code>&</code> The @see:FlexPie.rendering event handler.</dd>
         *   <dt>rendered</dt>          <dd><code>&</code> The @see:FlexPie.rendered event handler.</dd>
         * </dl>
         *
         * The wj-flex-pie directive may contain the following child directives:
         * @see:WjFlexChartLegend and @see:WjFlexPieDataLabel.
         */
        var WjFlexPie = /** @class */ (function (_super) {
            __extends(WjFlexPie, _super);
            function WjFlexPie() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(WjFlexPie.prototype, "_controlConstructor", {
                // gets the Wijmo FlexPie control constructor
                get: function () {
                    return wijmo.chart.FlexPie;
                },
                enumerable: true,
                configurable: true
            });
            WjFlexPie.prototype._initProps = function () {
                _super.prototype._initProps.call(this);
                var self = this; // store this in closure as .apply() call overrides the reference
                var lblContentDesc = angular.MetaFactory.findProp('labelContent', this._props);
                lblContentDesc.customHandler = function (scope, control, value, oldValue, link) {
                    if (value != null) {
                        control.dataLabel.content = value;
                    }
                };
            };
            return WjFlexPie;
        }(WjFlexChartBase));
        /**
         * AngularJS directive for the @see:Sunburst control.
         *
         * <dl class="dl-horizontal">
         *   <dt>child-items-path</dt>  <dd><code>=</code> An array or string object used to generate child items in hierarchical data.</dd>
         * </dl>
         *
         */
        var WjSunburst = /** @class */ (function (_super) {
            __extends(WjSunburst, _super);
            function WjSunburst() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(WjSunburst.prototype, "_controlConstructor", {
                // gets the Wijmo Sunburst control constructor
                get: function () {
                    return wijmo.chart.hierarchical.Sunburst;
                },
                enumerable: true,
                configurable: true
            });
            return WjSunburst;
        }(WjFlexPie));
        /**
         * AngularJS directive for the @see:TreeMap control.
         *
         * <dl class="dl-horizontal">
         *   <dt>items-source</dt>      <dd><code>=</code> An array or @see:ICollectionView
         *                              object that contains data for the chart.</dd>
         *   <dt>binding</dt>           <dd><code>@</code> The name of the property that
         *                              contains item values.</dd>
         *   <dt>binding-name</dt>      <dd><code>@</code> The name of the property that
         *                              contains item names. It should be an array or a string.</dd>
         *   <dt>footer</dt>            <dd><code>@</code> The text to display in the chart footer (plain
         *                              text).</dd>
         *   <dt>footer-style</dt>       <dd><code>=</code> The style to apply to the chart footer.</dd>
         *   <dt>header</dt>            <dd><code>@</code> The text to display in the chart header (plain
         *                              text).</dd>
         *   <dt>header-style</dt>      <dd><code>=</code> The style to apply to the chart header.</dd>
         *   <dt>initialized</dt>       <dd><code>&</code> This event occurs after the binding has finished
         *                              initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt>    <dd><code>=</code> A value indicating whether the binding has finished
         *                              initializing the control with attribute values. </dd>
         *   <dt>type</dt>              <dd><code>@</code> The type of the TreeMap.</dd>
         *   <dt>child-items-path</dt>  <dd><code>@</code> A value indicating the name of the property (or properties) used to generate
         *                              child items in hierarchical data.</dd>
         *   <dt>max-depth</dt>         <dd><code>=</code> The maximum number of node levels to show in the current view.</dd>
         *   <dt>palette</dt>           <dd><code>=</code> An array that contains the default colors used for
         *                              displaying TreeMap items.</dd>
         *   <dt>plot-margin</dt>       <dd><code>=</code> The number of pixels of space to leave between the
         *                              edges of the control and the plot area, or CSS-style margins.</dd>
         *   <dt>tooltip-content</dt>   <dd><code>@</code> The value to display in the
         *                              @see:ChartTooltip content property.</dd>
         *   <dt>label-content</dt>     <dd><code>@</code> The value to display in the
         *                              @see:DataLabel content property.</dd>
         *   <dt>rendering</dt>         <dd><code>&</code> The @see:FlexPie.rendering event handler.</dd>
         *   <dt>rendered</dt>          <dd><code>&</code> The @see:FlexPie.rendered event handler.</dd>
         * </dl>
         *
         * The wj-tree-map directive may contain the following child directives:
         * @see:WjFlexChartLegend and @see:WjFlexChartDataLabel.
         */
        var WjTreeMap = /** @class */ (function (_super) {
            __extends(WjTreeMap, _super);
            function WjTreeMap() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(WjTreeMap.prototype, "_controlConstructor", {
                // gets the Wijmo TreeMap control constructor
                get: function () {
                    return wijmo.chart.hierarchical.TreeMap;
                },
                enumerable: true,
                configurable: true
            });
            WjTreeMap.prototype._initProps = function () {
                _super.prototype._initProps.call(this);
                var self = this; // store this in closure as .apply() call overrides the reference
                var lblContentDesc = angular.MetaFactory.findProp('labelContent', this._props);
                lblContentDesc.customHandler = function (scope, control, value, oldValue, link) {
                    if (value != null) {
                        control.dataLabel.content = value;
                    }
                };
            };
            return WjTreeMap;
        }(WjFlexChartBase));
        /**
         * AngularJS directive for the @see:FlexRadar control.
         *
         * Use the <b>wj-flex-radar</b> directive to add radar charts to your AngularJS applications.
         * Note that directive and parameter names must be formatted using lower-case letters
         * with dashes instead of camel case.
         *
         * The wj-flex-radar directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>           <dd><code>@</code> The name of the property that contains Y
         *                              values for the chart. You can override this at the series level.</dd>
         *   <dt>binding-x</dt>         <dd><code>@</code> The name of the property that contains X
         *                              values for the chart. You can override this at the series level.</dd>
         *   <dt>chart-type</dt>        <dd><code>@</code> The default chart type to use in rendering series
         *                              objects. You can override this at the series level. See @see:RadarChartType.</dd>
         *   <dt>control</dt>           <dd><code>=</code> A reference to the @see:FlexRadar control
         *                              that this directive creates.</dd>
         *   <dt>footer</dt>            <dd><code>@</code> The text to display in the chart footer (plain
         *                              text).</dd>
         *   <dt>footer-style</dt>       <dd><code>=</code> The style to apply to the chart footer.</dd>
         *   <dt>header</dt>            <dd><code>@</code> The text to display in the chart header (plain
         *                              text).</dd>
         *   <dt>header-style</dt>      <dd><code>=</code> The style to apply to the chart header.</dd>
         *   <dt>initialized</dt>       <dd><code>&</code> This event occurs after the binding has finished
         *                              initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt><dd><code>=</code> A value indicating whether the binding has finished
         *                              initializing the control with attribute values. </dd>
         *   <dt>interpolate-nulls</dt> <dd><code>@</code> The value indicating whether to interpolate or
         *                              leave gaps when there are null values in the data.</dd>
         *   <dt>item-formatter</dt>    <dd><code>=</code> The formatter function that customizes the
         *                              appearance of data points.</dd>
         *   <dt>items-source</dt>      <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                              the data used to create the chart.</dd>
         *   <dt>legend-toggle</dt>     <dd><code>@</code> The value indicating whether clicking legend items
         *                              toggles series visibility.</dd>
         *   <dt>options</dt>           <dd><code>=</code> Chart @see:FlexChart.options that only apply to certain
         *                              chart types.</dd>
         *   <dt>palette</dt>           <dd><code>=</code> An array that contains the default colors used for
         *                              displaying each series.</dd>
         *   <dt>plot-margin</dt>       <dd><code>=</code> The number of pixels of space to leave between the
         *                              edges of the control and the plot area, or CSS-style margins.</dd>
         *   <dt>stacking</dt>          <dd><code>@</code> The @see:Stacking value indicating whether or how series
         *                              objects are stacked or plotted independently.</dd>
         *   <dt>reversed</dt>          <dd><code>@</code> The @see:FlexRadar.reversed value indicating whether angles are reversed
         *                              (counter-clockwise).</dd>
         *   <dt>startAngle</dt>        <dd><code>@</code> The @see:FlexRadar.startAngle value indicating the starting angle for the radar in degrees.</dd>
         *   <dt>totalAngle</dt>        <dd><code>@</code> The @see:FlexRadar.totalAngle value indicating the total angle for the radar in degrees.</dd>
         *   <dt>symbol-size</dt>       <dd><code>@</code> The size of the symbols used to render data points in Scatter,
         *                              LineSymbols, and SplineSymbols charts, in pixels. You can override
         *                              this at the series level.</dd>
         *   <dt>tooltip-content</dt>   <dd><code>@</code> The value to display in the
         *                              @see:ChartTooltip content property.</dd>
         *   <dt>rendering</dt>         <dd><code>&</code> The @see:FlexRadar.rendering event handler.</dd>
         *   <dt>rendered</dt>          <dd><code>&</code> The @see:FlexRadar.rendered event handler.</dd>
         *   <dt>series-visibility-changed</dt>
         *                              <dd><code>&</code> The @see:FlexRadar.seriesVisibilityChanged event handler.</dd>
         * </dl>
         *
         * The wj-flex-radar directive may contain the following child directives:
         * @see:WjFlexChartAxis, @see:WjFlexRadarSeries, @see:WjFlexChartLegend and @see:WjFlexChartDataLabel.
         */
        var WjFlexRadar = /** @class */ (function (_super) {
            __extends(WjFlexRadar, _super);
            function WjFlexRadar() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(WjFlexRadar.prototype, "_controlConstructor", {
                // gets the Wijmo FlexRadar control constructor
                get: function () {
                    return wijmo.chart.radar.FlexRadar;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexRadar;
        }(WjFlexChartCore));
        /**
         * AngularJS directive for the @see:FinancialChart @see:FinancialSeries object.
         *
         * The <b>wj-financial-chart-series</b> directive must be contained in a @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>axis-x</dt>       <dd><code>@</code> X-axis for the series.</dd>
         *   <dt>axis-y</dt>       <dd><code>@</code> Y-axis for the series.</dd>
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>chart-type</dt>   <dd><code>@</code> The chart type to use in rendering objects for this series
         *                         objects. This value overrides the default chart type set on the chart. See
         *                         @see:FinancialChartType.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>altStyle</dt>     <dd><code>=</code> The series alternative style.</dd>
         *   <dt>symbol-marker</dt><dd><code>@</code> The shape of marker to use for the series. This value
         *                         overrides the default marker set on the chart. See @see:Marker.</dd>
         *   <dt>symbol-size</dt>  <dd><code>@</code> The size of the symbols used to render data points in this
         *                         series for Scatter, LineSymbols, and SplineSymbols charts, in pixels.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>symbol-style</dt> <dd><code>=</code> The style of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         * </dl>
         *
         * In most cases, the <b>wj-financial-chart-series</b> specifies the <b>name</b> and <b>binding</b> properties only.
         * The remaining values are inherited from the parent <b>wj-financial-chart</b> directive.
         */
        var WjFlexRadarSeries = /** @class */ (function (_super) {
            __extends(WjFlexRadarSeries, _super);
            // Initializes a new instance of a WjFinancialChartSeries
            function WjFlexRadarSeries() {
                var _this = _super.call(this) || this;
                _this.require = '^wjFlexRadar';
                _this.template = '<div class="wjFlexRadarSeries" ng-transclude />';
                return _this;
                //this.transclude = true;
            }
            Object.defineProperty(WjFlexRadarSeries.prototype, "_controlConstructor", {
                // Returns constructor of related Wijmo object. Abstract member, must be overridden in inherited class
                get: function () {
                    return wijmo.chart.radar.FlexRadarSeries;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexRadarSeries;
        }(WjSeriesBase));
        /**
         * AngularJS directive for the @see:FlexRadar @see:FlexRadarAxis @see:Axis object.
         *
         * The <b>wj-flex-radar-axis</b> directive must be contained in a @see:WjFlexRadar directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>wj-property</dt>     <dd><code>@</code> Defines the @see:FlexChart property name,
         *                            axis-x or axis-y, to initialize with the directive.</dd>
         *   <dt>axis-line</dt>       <dd><code>@</code> The value indicating whether the axis line is visible.</dd>
         *   <dt>binding</dt>         <dd><code>@</code> Gets or sets the comma-separated property names for
         *                            the @see:wijmo.chart.Axis.itemsSource property to use in axis labels.
         *                            The first name specifies the value on the axis, the second represents
         *                            the corresponding axis label. The default value is 'value,text'.</dd>
         *   <dt>format</dt>          <dd><code>@</code> The format string used for the axis labels
         *                            (see @see:wijmo.Globalize).</dd>
         *   <dt>item-formatter</dt>  <dd><code>=</code> The formatter function that customizes the
         *                            appearance of axis labels.</dd>
         *   <dt>items-source</dt>    <dd><code>=</code> The items source for the axis labels.</dd>
         *   <dt>labels</dt>          <dd><code>@</code> The value indicating whether the axis labels are visible.</dd>
         *   <dt>label-angle</dt>     <dd><code>@</code> The rotation angle of axis labels in degrees.</dd>
         *   <dt>label-align</dt>     <dd><code>@</code> The alignment of axis labels.</dd>
         *   <dt>label-padding</dt>   <dd><code>@</code> The padding of axis labels.</dd>
         *   <dt>major-grid</dt>      <dd><code>@</code> The value indicating whether the axis includes grid lines.</dd>
         *   <dt>major-tick-marks</dt><dd><code>@</code> Defines the appearance of tick marks on the axis
         *                            (see @see:TickMark).</dd>
         *   <dt>major-unit</dt>      <dd><code>@</code> The number of units between axis labels.</dd>
         *   <dt>max</dt>             <dd><code>@</code> The minimum value shown on the axis.</dd>
         *   <dt>min</dt>             <dd><code>@</code> The maximum value shown on the axis.</dd>
         *   <dt>minor-grid</dt>      <dd><code>@</code> The value indicating whether the axis includes minor grid lines.</dd>
         *   <dt>minor-tick-marks</dt><dd><code>@</code> Defines the appearance of minor tick marks on the axis
         *                            (see @see:TickMark).</dd>
         *   <dt>minor-unit</dt>      <dd><code>@</code> The number of units between minor axis ticks.</dd>
         *   <dt>origin</dt>          <dd><code>@</code> The axis origin.</dd>
         *   <dt>overlappingLabels</dt><dd><code>@</code> The @see:OverlappingLabels value indicating how to handle the overlapping axis labels.</dd>
         *   <dt>position</dt>        <dd><code>@</code> The @see:Position value indicating the position of the axis.</dd>
         *   <dt>title</dt>           <dd><code>@</code> The title text shown next to the axis.</dd>
         * </dl>
         */
        var WjFlexRadarAxis = /** @class */ (function (_super) {
            __extends(WjFlexRadarAxis, _super);
            // Initializes a new instance of a WjFlexCharAxis.
            function WjFlexRadarAxis() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFlexRadarSeries', '?^wjFlexRadar'];
                _this.template = '<div class="wjFlexRadarAxis" />';
                return _this;
            }
            Object.defineProperty(WjFlexRadarAxis.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.radar.FlexRadarAxis;
                },
                enumerable: true,
                configurable: true
            });
            WjFlexRadarAxis.prototype._initControl = function (element) {
                return _super.prototype._initControl.call(this, undefined);
            };
            return WjFlexRadarAxis;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:FinancialChart control.
         *
         * Use the <b>wj-financial-chart</b> directive to add financial charts to your AngularJS applications.
         * Note that directive and parameter names must be formatted using lower-case letters
         * with dashes instead of camel case.
         *
         * The wj-financial-chart directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>           <dd><code>@</code> The name of the property that contains Y
         *                              values for the chart. You can override this at the series level.</dd>
         *   <dt>binding-x</dt>         <dd><code>@</code> The name of the property that contains X
         *                              values for the chart. You can override this at the series level.</dd>
         *   <dt>chart-type</dt>        <dd><code>@</code> The default chart type to use in rendering series
         *                              objects. You can override this at the series level. See @see:FinancialChartType.</dd>
         *   <dt>control</dt>           <dd><code>=</code> A reference to the @see:FinancialChart control
         *                              that this directive creates.</dd>
         *   <dt>footer</dt>            <dd><code>@</code> The text to display in the chart footer (plain
         *                              text).</dd>
         *   <dt>footer-style</dt>       <dd><code>=</code> The style to apply to the chart footer.</dd>
         *   <dt>header</dt>            <dd><code>@</code> The text to display in the chart header (plain
         *                              text).</dd>
         *   <dt>header-style</dt>      <dd><code>=</code> The style to apply to the chart header.</dd>
         *   <dt>initialized</dt>       <dd><code>&</code> This event occurs after the binding has finished
         *                              initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt><dd><code>=</code> A value indicating whether the binding has finished
         *                              initializing the control with attribute values. </dd>
         *   <dt>interpolate-nulls</dt> <dd><code>@</code> The value indicating whether to interpolate or
         *                              leave gaps when there are null values in the data.</dd>
         *   <dt>item-formatter</dt>    <dd><code>=</code> The formatter function that customizes the
         *                              appearance of data points.</dd>
         *   <dt>items-source</dt>      <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                              the data used to create the chart.</dd>
         *   <dt>legend-toggle</dt>     <dd><code>@</code> The value indicating whether clicking legend items
         *                              toggles series visibility.</dd>
         *   <dt>options</dt>           <dd><code>=</code> Chart options that only apply to certain chart types.
         *                              See <b>options</b> under @see:FinancialChart for details.</dd>
         *   <dt>palette</dt>           <dd><code>=</code> An array that contains the default colors used for
         *                              displaying each series.</dd>
         *   <dt>plot-margin</dt>       <dd><code>=</code> The number of pixels of space to leave between the
         *                              edges of the control and the plot area, or CSS-style margins.</dd>
         *   <dt>selection</dt>         <dd><code>=</code> The series object that is selected.</dd>
         *   <dt>selection-mode</dt>    <dd><code>@</code> The @see:SelectionMode value indicating whether or what is
         *                              selected when the user clicks a series.</dd>
         *   <dt>symbol-size</dt>       <dd><code>@</code> The size of the symbols used to render data
         *                              points in Scatter, LineSymbols, and SplineSymbols charts, in pixels. You can override
         *                              this at the series level.</dd>
         *   <dt>tooltip-content</dt>   <dd><code>@</code> The value to display in the
         *                              @see:ChartTooltip content property.</dd>
         *   <dt>got-focus</dt>         <dd><code>&</code> The @see:FinancialChart.gotFocus event handler.</dd>
         *   <dt>lost-focus</dt>        <dd><code>&</code> The @see:FinancialChart.lostFocus event handler.</dd>
         *   <dt>rendering</dt>         <dd><code>&</code> The @see:FinancialChart.rendering event handler.</dd>
         *   <dt>rendered</dt>          <dd><code>&</code> The @see:FinancialChart.rendered event handler.</dd>
         *   <dt>series-visibility-changed</dt>
         *                              <dd><code>&</code> The @see:FinancialChart.seriesVisibilityChanged event handler.</dd>
         *   <dt>selection-changed</dt> <dd><code>&</code> The @see:FinancialChart.selectionChanged event handler.</dd>
         * </dl>
         *
         * The wj-financial-chart directive may contain the following child directives:
         * @see:WjFlexChartAxis, @see:WjFlexChartSeries, @see:WjFlexChartLegend and @see:WjFlexChartDataLabel.
         */
        var WjFinancialChart = /** @class */ (function (_super) {
            __extends(WjFinancialChart, _super);
            function WjFinancialChart() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(WjFinancialChart.prototype, "_controlConstructor", {
                // gets the Wijmo FinancialChart control constructor
                get: function () {
                    return wijmo.chart.finance.FinancialChart;
                },
                enumerable: true,
                configurable: true
            });
            return WjFinancialChart;
        }(WjFlexChartCore));
        /**
         * AngularJS directive for the @see:FinancialChart @see:FinancialSeries object.
         *
         * The <b>wj-financial-chart-series</b> directive must be contained in a @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>axis-x</dt>       <dd><code>@</code> X-axis for the series.</dd>
         *   <dt>axis-y</dt>       <dd><code>@</code> Y-axis for the series.</dd>
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>chart-type</dt>   <dd><code>@</code> The chart type to use in rendering objects for this series
         *                         objects. This value overrides the default chart type set on the chart. See
         *                         @see:FinancialChartType.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>altStyle</dt>     <dd><code>=</code> The series alternative style.</dd>
         *   <dt>symbol-marker</dt><dd><code>@</code> The shape of marker to use for the series. This value
         *                         overrides the default marker set on the chart. See @see:Marker.</dd>
         *   <dt>symbol-size</dt>  <dd><code>@</code> The size of the symbols used to render data points in this
         *                         series for Scatter, LineSymbols, and SplineSymbols charts, in pixels.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>symbol-style</dt> <dd><code>=</code> The style of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         * </dl>
         *
         * In most cases, the <b>wj-financial-chart-series</b> specifies the <b>name</b> and <b>binding</b> properties only.
         * The remaining values are inherited from the parent <b>wj-financial-chart</b> directive.
         */
        var WjFinancialChartSeries = /** @class */ (function (_super) {
            __extends(WjFinancialChartSeries, _super);
            // Initializes a new instance of a WjFinancialChartSeries
            function WjFinancialChartSeries() {
                var _this = _super.call(this) || this;
                _this.require = '^wjFinancialChart';
                _this.template = '<div class="wjFinancialChartSeries" ng-transclude />';
                return _this;
                //this.transclude = true;
            }
            Object.defineProperty(WjFinancialChartSeries.prototype, "_controlConstructor", {
                // Returns constructor of related Wijmo object. Abstract member, must be overridden in inherited class
                get: function () {
                    return wijmo.chart.finance.FinancialSeries;
                },
                enumerable: true,
                configurable: true
            });
            return WjFinancialChartSeries;
        }(WjSeriesBase));
        // abstract for FlexChart and FinancialChart trendlines
        var WjTrendLineBase = /** @class */ (function (_super) {
            __extends(WjTrendLineBase, _super);
            function WjTrendLineBase() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFlexChart', '?^wjFinancialChart'];
                _this.template = '<div class="wjTrendLineBase" ng-transclude />';
                return _this;
                //this.transclude = true;
            }
            Object.defineProperty(WjTrendLineBase.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.analytics.TrendLineBase;
                },
                enumerable: true,
                configurable: true
            });
            return WjTrendLineBase;
        }(WjSeriesBase));
        /**
         * AngularJS directive for the @see:FlexChart and @see:FinancialChart @see:TrendLine object.
         *
         * The <b>wj-flex-chart-trend-line</b> directive must be contained in a @see:WjFlexChart or @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>chart-type</dt>   <dd><code>@</code> The chart type to use in rendering objects for this series
         *                         objects. This value overrides the default chart type set on the chart. See
         *                         @see:ChartType.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>symbol-marker</dt><dd><code>@</code> The shape of marker to use for the series. This value
         *                         overrides the default marker set on the chart. See @see:Marker.</dd>
         *   <dt>symbol-size</dt>  <dd><code>@</code> The size of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts, in pixels.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>symbol-style</dt> <dd><code>=</code> The style of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         *   <dt>sample-count</dt> <dd><code>@</code> The sample count for the calculation.</dd>
         *   <dt>fit-type</dt>     <dd><code>@</code> The @see:TrendLineFitType value for the trend line.</dd>
         *   <dt>order</dt>        <dd><code>@</code> The number of terms in a polynomial or fourier equation.</dd>
         * </dl>
         *
         */
        var WjFlexChartTrendLine = /** @class */ (function (_super) {
            __extends(WjFlexChartTrendLine, _super);
            function WjFlexChartTrendLine() {
                var _this = _super.call(this) || this;
                //this.require = ['?^wjFlexChart', '?^wjFinancialChart'];
                _this.template = '<div class="wjTrendLine" ng-transclude />';
                return _this;
                //this.transclude = true;
            }
            Object.defineProperty(WjFlexChartTrendLine.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.analytics.TrendLine;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartTrendLine;
        }(WjTrendLineBase));
        /**
         * AngularJS directive for the @see:FlexChart and @see:FinancialChart @see:MovingAverage object.
         *
         * The <b>wj-flex-chart-moving-average</b> directive must be contained in a @see:WjFlexChart or @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>chart-type</dt>   <dd><code>@</code> The chart type to use in rendering objects for this series
         *                         objects. This value overrides the default chart type set on the chart. See
         *                         @see:ChartType.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>symbol-marker</dt><dd><code>@</code> The shape of marker to use for the series. This value
         *                         overrides the default marker set on the chart. See @see:Marker.</dd>
         *   <dt>symbol-size</dt>  <dd><code>@</code> The size of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts, in pixels.
         *                         This value overrides any set at the chart level.</dd>
         *   <dt>symbol-style</dt> <dd><code>=</code> The style of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         *   <dt>type</dt>         <dd><code>@</code> The @see:MovingAverageType value for the moving average series.</dd>
         *   <dt>period</dt>       <dd><code>@</code> The period for the moving average calculation.</dd>
         * </dl>
         *
         */
        var WjFlexChartMovingAverage = /** @class */ (function (_super) {
            __extends(WjFlexChartMovingAverage, _super);
            function WjFlexChartMovingAverage() {
                var _this = _super.call(this) || this;
                //this.require = ['?^wjFlexChart', '?^wjFinancialChart'];
                _this.template = '<div class="wjMovingAverage" ng-transclude />';
                return _this;
                //this.transclude = true;
            }
            Object.defineProperty(WjFlexChartMovingAverage.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.analytics.MovingAverage;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartMovingAverage;
        }(WjTrendLineBase));
        /**
         * AngularJS directive for the @see:FlexChart and @see:FinancialChart @see:YFunctionSeries object.
         *
         * The <b>wj-flex-chart-y-function-series</b> directive must be contained in a @see:WjFlexChart or @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>chart-type</dt>   <dd><code>@</code> The chart type to use in rendering objects for this series
         *                         objects. This value overrides the default chart type set on the chart. See
         *                         @see:ChartType.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>symbol-marker</dt><dd><code>@</code> The shape of marker to use for the series. This value
         *                         overrides the default marker set on the chart. See @see:Marker.</dd>
         *   <dt>symbol-size</dt>  <dd><code>@</code> The size of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts, in pixels.
         *                         This value overrides any set at the chart level.</dd>
         *   <dt>symbol-style</dt> <dd><code>=</code> The style of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         *   <dt>sample-count</dt> <dd><code>@</code> The sample count for the calculation.</dd>
         *   <dt>min</dt>       <dd><code>@</code> The minimum value of the parameter for calculating a function.</dd>
         *   <dt>max</dt>       <dd><code>@</code> The maximum value of the parameter for calculating a function.</dd>
         *   <dt>func</dt>       <dd><code>@</code> The function used to calculate Y value.</dd>
         * </dl>
         *
         */
        var WjFlexChartYFunctionSeries = /** @class */ (function (_super) {
            __extends(WjFlexChartYFunctionSeries, _super);
            function WjFlexChartYFunctionSeries() {
                var _this = _super.call(this) || this;
                //this.require = ['?^wjFlexChart', '?^wjFinancialChart'];
                _this.template = '<div class="wjYFunctionSeries" ng-transclude />';
                return _this;
                //this.transclude = true;
            }
            Object.defineProperty(WjFlexChartYFunctionSeries.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.analytics.YFunctionSeries;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartYFunctionSeries;
        }(WjTrendLineBase));
        /**
         * AngularJS directive for the @see:FlexChart and @see:FinancialChart @see:WjFlexChartParametricFunctionSeries object.
         *
         * The <b>wj-flex-chart-parametric-function-series</b> directive must be contained in a @see:WjFlexChart or @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>chart-type</dt>   <dd><code>@</code> The chart type to use in rendering objects for this series
         *                         objects. This value overrides the default chart type set on the chart. See
         *                         @see:ChartType.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>symbol-marker</dt><dd><code>@</code> The shape of marker to use for the series. This value
         *                         overrides the default marker set on the chart. See @see:Marker.</dd>
         *   <dt>symbol-size</dt>  <dd><code>@</code> The size of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts, in pixels.
         *                         This value overrides any set at the chart level.</dd>
         *   <dt>symbol-style</dt> <dd><code>=</code> The style of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         *   <dt>sample-count</dt> <dd><code>@</code> The sample count for the calculation.</dd>
         *   <dt>min</dt>       <dd><code>@</code> The minimum value of the parameter for calculating a function.</dd>
         *   <dt>max</dt>       <dd><code>@</code> The maximum value of the parameter for calculating a function.</dd>
         *   <dt>x-func</dt>       <dd><code>@</code> The function used to calculate the x value.</dd>
         *   <dt>y-func</dt>       <dd><code>@</code> The function used to calculate the y value.</dd>
         * </dl>
         *
         */
        var WjFlexChartParametricFunctionSeries = /** @class */ (function (_super) {
            __extends(WjFlexChartParametricFunctionSeries, _super);
            function WjFlexChartParametricFunctionSeries() {
                var _this = _super.call(this) || this;
                //this.require = ['?^wjFlexChart', '?^wjFinancialChart'];
                _this.template = '<div class="wjParametricFunctionSeries" ng-transclude />';
                return _this;
                //this.transclude = true;
            }
            Object.defineProperty(WjFlexChartParametricFunctionSeries.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.analytics.ParametricFunctionSeries;
                },
                enumerable: true,
                configurable: true
            });
            WjFlexChartParametricFunctionSeries.prototype._initProps = function () {
                _super.prototype._initProps.call(this);
                var self = this; // store this in closure as .apply() call overrides the reference
                var funcDesc = angular.MetaFactory.findProp('func', this._props);
                funcDesc.customHandler = function (scope, control, value, oldValue, link) {
                    if (value != null) {
                        control.xFunc = value;
                    }
                };
            };
            return WjFlexChartParametricFunctionSeries;
        }(WjTrendLineBase));
        /**
         * AngularJS directive for the @see:FlexChart and @see:FinancialChart @see:Waterfall object.
         *
         * The <b>wj-flex-chart-waterfall</b> directive must be contained in a @see:WjFlexChart or @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         *   <dt>relative-data</dt> <dd><code>@</code> The value that determines whether the given data is relative.</dd>
         *   <dt>start</dt>        <dd><code>@</code> The value of the start bar.</dd>
         *   <dt>start-label</dt>  <dd><code>@</code> The label of the start bar.</dd>
         *   <dt>show-total</dt>   <dd><code>@</code> The value that determines whether the show the total bar.</dd>
         *   <dt>total-label</dt>  <dd><code>@</code> The label of the total bar.</dd>
         *   <dt>show-intermediate-total</dt>      <dd><code>@</code> The value that determines whether to show the intermediate total bar.</dd>
         *   <dt>intermediate-total-positions</dt> <dd><code>@</code> The value that contains the index for positions of the intermediate total bar.</dd>
         *   <dt>intermediate-total-labels</dt>    <dd><code>@</code> The value that contains the label of the intermediate total bar.</dd>
         *   <dt>connector-lines</dt>  <dd><code>@</code> The value that determines whether to show connector lines.</dd>
         *   <dt>styles</dt>       <dd><code>@</code> The value of the waterfall styles.</dd>
         * </dl>
         */
        var WjFlexChartWaterfall = /** @class */ (function (_super) {
            __extends(WjFlexChartWaterfall, _super);
            function WjFlexChartWaterfall() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFlexChart', '?^wjFinancialChart'];
                _this.template = '<div class="wjWaterfall" ng-transclude />';
                return _this;
                //this.transclude = true;
            }
            Object.defineProperty(WjFlexChartWaterfall.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.analytics.Waterfall;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartWaterfall;
        }(WjSeriesBase));
        /**
         * AngularJS directive for the @see:FlexChart and @see:FinancialChart @see:BoxWhisker object.
         *
         * The <b>wj-flex-chart-box-whisker</b> directive must be contained in a @see:WjFlexChart or @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         *   <dt>quartile-calculation</dt> <dd><code>@</code> The value that specifies the quartile calculation for the Box&Whisker chart.</dd>
         *   <dt>group-width</dt>        <dd><code>@</code> The value that determines the group width as a percentage for the Box&Whisker chart.</dd>
         *   <dt>gap-width</dt>  <dd><code>@</code> The value that determines the gap width as a percentage for the Box&Whisker chart.</dd>
         *   <dt>show-mean-line</dt>   <dd><code>@</code> The value that determines whether to show the mean line for the Box&Whisker chart.</dd>
         *   <dt>mean-line-style</dt>  <dd><code>@</code> The value that specifies the style for the mean line.</dd>
         *   <dt>show-mean-marker</dt>      <dd><code>@</code> The value that determines whether to show the mean marker for the Box&Whisker chart.</dd>
         *   <dt>mean-marker-style</dt> <dd><code>@</code> The value that specifies the style for the mean marker.</dd>
         *   <dt>show-inner-points</dt>    <dd><code>@</code> The value that determines whether to show the inner points for the Box&Whisker chart.</dd>
         *   <dt>show-outliers</dt>  <dd><code>@</code> The value that determines whether to show the outliers for the Box&Whisker chart.</dd>
         * </dl>
         *
         */
        var WjFlexChartBoxWhisker = /** @class */ (function (_super) {
            __extends(WjFlexChartBoxWhisker, _super);
            function WjFlexChartBoxWhisker() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFlexChart', '?^wjFinancialChart'];
                _this.template = '<div class="wjBoxWhisker" ng-transclude />';
                return _this;
                //this.transclude = true;
            }
            Object.defineProperty(WjFlexChartBoxWhisker.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.analytics.BoxWhisker;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartBoxWhisker;
        }(WjSeriesBase));
        /**
         * AngularJS directive for the @see:FlexChart @see:ErrorBar object.
         *
         * The <b>wj-flex-chart-error-bar</b> directive must be contained in a @see:WjFlexChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         *   <dt>error-bar-style</dt> <dd><code>@</code> The value that specifies the ErrorBar style.</dd>
         *   <dt>value</dt>        <dd><code>@</code> The value that specifies the error value of the series.</dd>
         *   <dt>error-amount</dt>  <dd><code>@</code> The value that specifies the error amount of the series.</dd>
         *   <dt>end-style</dt>   <dd><code>@</code> The value that specifies the end style of the series.</dd>
         *   <dt>direction</dt>  <dd><code>@</code> The value that specifies the direction of the series.</dd>
         * </dl>
         *
         */
        var WjFlexChartErrorBar = /** @class */ (function (_super) {
            __extends(WjFlexChartErrorBar, _super);
            function WjFlexChartErrorBar() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFlexChart'];
                _this.template = '<div class="wjErrorBar" ng-transclude />';
                return _this;
                //this.transclude = true;
            }
            Object.defineProperty(WjFlexChartErrorBar.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.analytics.ErrorBar;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartErrorBar;
        }(WjFlexChartSeries));
        var WjFlexChartPlotArea = /** @class */ (function (_super) {
            __extends(WjFlexChartPlotArea, _super);
            // Initializes a new instance of a WjFlexChartPlotArea.
            function WjFlexChartPlotArea() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFlexChartPlotArea', '?^wjFlexChart', '?^wjFinancialChart'];
                _this.template = '<div class="wjFlexChartPlotArea" />';
                return _this;
            }
            Object.defineProperty(WjFlexChartPlotArea.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.PlotArea;
                },
                enumerable: true,
                configurable: true
            });
            WjFlexChartPlotArea.prototype._initControl = function (element) {
                return _super.prototype._initControl.call(this, undefined);
            };
            return WjFlexChartPlotArea;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:FinancialChart @see:Fibonacci object.
         *
         * The <b>wj-flex-chart-fibonacci</b> directive must be contained in a @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>high</dt>         <dd><code>@</code> The high value of @see:Fibonacci tool.</dd>
         *   <dt>labelPosition</dt> <dd><code>@</code> The label position for levels in @see:Fibonacci tool.</dd>
         *   <dt>levels</dt>       <dd><code>@</code> The levels value of @see:Fibonacci tool.</dd>
         *   <dt>low</dt>          <dd><code>@</code> The low value of @see:Fibonacci tool.</dd>
         *   <dt>minX</dt>         <dd><code>@</code> The x minimum value of @see:Fibonacci tool.</dd>
         *   <dt>maxX</dt>         <dd><code>@</code> The x maximum value of @see:Fibonacci tool.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>altStyle</dt>     <dd><code>=</code> The series alternative style.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         *   <dt>uptrend</dt>      <dd><code>@</code> The value indicating whether to create uptrending @see:Fibonacci tool.</dd>
         * </dl>
         *
         */
        var WjFlexChartFibonacci = /** @class */ (function (_super) {
            __extends(WjFlexChartFibonacci, _super);
            // Initializes a new instance of a WjFlexChartFibonacci
            function WjFlexChartFibonacci() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFinancialChart'];
                _this.template = '<div class="wjFlexChartFibonacci" ng-transclude />';
                return _this;
                //this.transclude = true;
            }
            Object.defineProperty(WjFlexChartFibonacci.prototype, "_controlConstructor", {
                // Returns constructor of related Wijmo object. Abstract member, must be overridden in inherited class
                get: function () {
                    return wijmo.chart.finance.analytics.Fibonacci;
                },
                enumerable: true,
                configurable: true
            });
            WjFlexChartFibonacci.prototype._initControl = function (element) {
                return _super.prototype._initControl.call(this, undefined);
            };
            return WjFlexChartFibonacci;
        }(WjSeriesBase));
        /**
         * AngularJS directive for the @see:FinancialChart @see:FibonacciArcs object.
         *
         * The <b>wj-flex-chart-fibonacci-arcs</b> directive must be contained in a @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>labelPosition</dt> <dd><code>@</code> The @see:LabelPosition for levels in @see:FibonacciArcs tool.</dd>
         *   <dt>levels</dt>       <dd><code>@</code> The levels value of @see:FibonacciArcs tool.</dd>
         *   <dt>start-x</dt>       <dd><code>@</code> The starting X value of @see:FibonacciArcs tool.</dd>
         *   <dt>end-x</dt>         <dd><code>@</code> The ending X value of @see:FibonacciArcs tool.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>altStyle</dt>     <dd><code>=</code> The series alternative style.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         * </dl>
         *
         */
        var WjFlexChartFibonacciArcs = /** @class */ (function (_super) {
            __extends(WjFlexChartFibonacciArcs, _super);
            function WjFlexChartFibonacciArcs() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFinancialChart'];
                _this.template = '<div class="wjFlexChartFibonacciArcs" ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjFlexChartFibonacciArcs.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.finance.analytics.FibonacciArcs;
                },
                enumerable: true,
                configurable: true
            });
            WjFlexChartFibonacciArcs.prototype._initControl = function (element) {
                return _super.prototype._initControl.call(this, undefined);
            };
            return WjFlexChartFibonacciArcs;
        }(WjSeriesBase));
        /**
          * AngularJS directive for the @see:FinancialChart @see:FibonacciFans object.
          *
          * The <b>wj-flex-chart-fibonacci-fans</b> directive must be contained in a @see:WjFinancialChart directive.
          * It supports the following attributes:
          *
          * <dl class="dl-horizontal">
          *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
          *                         series. This value overrides any binding set for the chart.</dd>
          *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
          *                         series. This value overrides any binding set for the chart.</dd>
          *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
          *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
          *                         data for this series.</dd>
          *   <dt>labelPosition</dt> <dd><code>@</code> The @see:LabelPosition for levels in @see:FibonacciFans tool.</dd>
          *   <dt>levels</dt>       <dd><code>@</code> The levels value of @see:FibonacciFans tool.</dd>
          *   <dt>start</dt>        <dd><code>@</code> The starting @see:DataPoint of @see:FibonacciFans tool.</dd>
          *   <dt>end</dt>          <dd><code>@</code> The ending @see:DataPoint of @see:FibonacciFans tool.</dd>
          *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
          *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
          *                         style object as an object. See the section on ngAttr attribute bindings in
          *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
          *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
          *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
          *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
          *   <dt>altStyle</dt>     <dd><code>=</code> The series alternative style.</dd>
          *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
          *                         display the series.</dd>
          * </dl>
          *
          */
        var WjFlexChartFibonacciFans = /** @class */ (function (_super) {
            __extends(WjFlexChartFibonacciFans, _super);
            function WjFlexChartFibonacciFans() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFinancialChart'];
                _this.template = '<div class="wjFlexChartFibonacciFans" ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjFlexChartFibonacciFans.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.finance.analytics.FibonacciFans;
                },
                enumerable: true,
                configurable: true
            });
            WjFlexChartFibonacciFans.prototype._initControl = function (element) {
                return _super.prototype._initControl.call(this, undefined);
            };
            return WjFlexChartFibonacciFans;
        }(WjSeriesBase));
        /**
         * AngularJS directive for the @see:FinancialChart @see:FibonacciTimeZones object.
         *
         * The <b>wj-flex-chart-fibonacci-time-zones</b> directive must be contained in a @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>labelPosition</dt> <dd><code>@</code> The @see:LabelPosition for levels in @see:FibonacciTimeZones tool.</dd>
         *   <dt>levels</dt>       <dd><code>@</code> The levels value of @see:FibonacciTimeZones tool.</dd>
         *   <dt>startX</dt>       <dd><code>@</code> The starting X value of @see:FibonacciTimeZones tool.</dd>
         *   <dt>endX</dt>         <dd><code>@</code> The ending X value of @see:FibonacciTimeZones tool.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>altStyle</dt>     <dd><code>=</code> The series alternative style.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         * </dl>
         *
         */
        var WjFlexChartFibonacciTimeZones = /** @class */ (function (_super) {
            __extends(WjFlexChartFibonacciTimeZones, _super);
            function WjFlexChartFibonacciTimeZones() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFinancialChart'];
                _this.template = '<div class="wjFlexChartFibonacciTimeZones" ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjFlexChartFibonacciTimeZones.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.finance.analytics.FibonacciTimeZones;
                },
                enumerable: true,
                configurable: true
            });
            WjFlexChartFibonacciTimeZones.prototype._initControl = function (element) {
                return _super.prototype._initControl.call(this, undefined);
            };
            return WjFlexChartFibonacciTimeZones;
        }(WjSeriesBase));
        // abstract for FinancialChart's overlays and indicators
        var WjBaseOverlayIndicator = /** @class */ (function (_super) {
            __extends(WjBaseOverlayIndicator, _super);
            function WjBaseOverlayIndicator() {
                var _this = _super.call(this) || this;
                _this.require = '^wjFinancialChart';
                _this.template = '<div class="wjBaseOverlayIndicator" ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjBaseOverlayIndicator.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.finance.analytics.OverlayIndicatorBase;
                },
                enumerable: true,
                configurable: true
            });
            return WjBaseOverlayIndicator;
        }(WjSeriesBase));
        // abstract for FinancialChart's overlays and indicators
        var WjBaseSingleOverlayIndicator = /** @class */ (function (_super) {
            __extends(WjBaseSingleOverlayIndicator, _super);
            function WjBaseSingleOverlayIndicator() {
                var _this = _super.call(this) || this;
                _this.template = '<div class="wjBaseSingleOverlayIndicator" ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjBaseSingleOverlayIndicator.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.finance.analytics.SingleOverlayIndicatorBase;
                },
                enumerable: true,
                configurable: true
            });
            return WjBaseSingleOverlayIndicator;
        }(WjBaseOverlayIndicator));
        /**
         * AngularJS directive for the @see:FinancialChart @see:ATR object.
         *
         * The <b>wj-flex-chart-atr</b> directive must be contained in a @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>symbol-marker</dt><dd><code>@</code> The shape of marker to use for the series. This value
         *                         overrides the default marker set on the chart. See @see:Marker.</dd>
         *   <dt>symbol-size</dt>  <dd><code>@</code> The size of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts, in pixels.
         *                         This value overrides any set at the chart level.</dd>
         *   <dt>symbol-style</dt> <dd><code>=</code> The style of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         *   <dt>period</dt>       <dd><code>@</code> The period for the average true range calculation.</dd>
         * </dl>
         *
         */
        var WjFlexChartAtr = /** @class */ (function (_super) {
            __extends(WjFlexChartAtr, _super);
            function WjFlexChartAtr() {
                var _this = _super.call(this) || this;
                _this.template = '<div class="wjFlexChartAtr" ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjFlexChartAtr.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.finance.analytics.ATR;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartAtr;
        }(WjBaseSingleOverlayIndicator));
        /**
         * AngularJS directive for the @see:FinancialChart @see:CCI object.
         *
         * The <b>wj-flex-chart-cci</b> directive must be contained in a @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>symbol-marker</dt><dd><code>@</code> The shape of marker to use for the series. This value
         *                         overrides the default marker set on the chart. See @see:Marker.</dd>
         *   <dt>symbol-size</dt>  <dd><code>@</code> The size of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts, in pixels.
         *                         This value overrides any set at the chart level.</dd>
         *   <dt>symbol-style</dt> <dd><code>=</code> The style of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         *   <dt>period</dt>       <dd><code>@</code> The period for the commodity channel index calculation.</dd>
         * </dl>
         *
         */
        var WjFlexChartCci = /** @class */ (function (_super) {
            __extends(WjFlexChartCci, _super);
            function WjFlexChartCci() {
                var _this = _super.call(this) || this;
                _this.template = '<div class="wjFlexChartCci" ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjFlexChartCci.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.finance.analytics.CCI;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartCci;
        }(WjBaseSingleOverlayIndicator));
        /**
         * AngularJS directive for the @see:FinancialChart @see:RSI object.
         *
         * The <b>wj-flex-chart-rsi</b> directive must be contained in a @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>symbol-marker</dt><dd><code>@</code> The shape of marker to use for the series. This value
         *                         overrides the default marker set on the chart. See @see:Marker.</dd>
         *   <dt>symbol-size</dt>  <dd><code>@</code> The size of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts, in pixels.
         *                         This value overrides any set at the chart level.</dd>
         *   <dt>symbol-style</dt> <dd><code>=</code> The style of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         *   <dt>period</dt>       <dd><code>@</code> The period for the relative strength index calculation.</dd>
         * </dl>
         *
         */
        var WjFlexChartRsi = /** @class */ (function (_super) {
            __extends(WjFlexChartRsi, _super);
            function WjFlexChartRsi() {
                var _this = _super.call(this) || this;
                _this.template = '<div class="wjFlexChartRsi" ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjFlexChartRsi.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.finance.analytics.RSI;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartRsi;
        }(WjBaseSingleOverlayIndicator));
        /**
         * AngularJS directive for the @see:FinancialChart @see:WilliamsR object.
         *
         * The <b>wj-flex-chart-williams-r</b> directive must be contained in a @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>symbol-marker</dt><dd><code>@</code> The shape of marker to use for the series. This value
         *                         overrides the default marker set on the chart. See @see:Marker.</dd>
         *   <dt>symbol-size</dt>  <dd><code>@</code> The size of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts, in pixels.
         *                         This value overrides any set at the chart level.</dd>
         *   <dt>symbol-style</dt> <dd><code>=</code> The style of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         *   <dt>period</dt>       <dd><code>@</code> The period for the Williams %R calculation.</dd>
         * </dl>
         *
         */
        var WjFlexChartWilliamsR = /** @class */ (function (_super) {
            __extends(WjFlexChartWilliamsR, _super);
            function WjFlexChartWilliamsR() {
                var _this = _super.call(this) || this;
                _this.template = '<div class="wjFlexChartWilliamsR" ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjFlexChartWilliamsR.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.finance.analytics.WilliamsR;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartWilliamsR;
        }(WjBaseSingleOverlayIndicator));
        // base for MACD
        var WjFlexChartMacdBase = /** @class */ (function (_super) {
            __extends(WjFlexChartMacdBase, _super);
            function WjFlexChartMacdBase() {
                var _this = _super.call(this) || this;
                _this.template = '<div class="wjFlexChartBaseMacd" ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjFlexChartMacdBase.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.finance.analytics.MacdBase;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartMacdBase;
        }(WjBaseOverlayIndicator));
        /**
         * AngularJS directive for the @see:FinancialChart @see:Macd object.
         *
         * The <b>wj-flex-chart-macd</b> directive must be contained in a @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>styles/dt>        <dd><code></code> The styles for the MACD and Signal lines.</dd>
         *   <dt>symbol-marker</dt><dd><code>@</code> The shape of marker to use for the series. This value
         *                         overrides the default marker set on the chart. See @see:Marker.</dd>
         *   <dt>symbol-size</dt>  <dd><code>@</code> The size of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts, in pixels.
         *                         This value overrides any set at the chart level.</dd>
         *   <dt>symbol-style</dt> <dd><code>=</code> The style of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         *   <dt>fast-period</dt>  <dd><code>@</code>  The fast moving average period for the MACD calculation.</dd>
         *   <dt>slow-period</dt>  <dd><code>@</code> The slow moving average period for the MACD calculation.</dd>
         *   <dt>signal-smoothing-period/dt>    <dd><code>@</code> The smoothing period for the MACD calculation.</dd>
         * </dl>
         *
         */
        var WjFlexChartMacd = /** @class */ (function (_super) {
            __extends(WjFlexChartMacd, _super);
            function WjFlexChartMacd() {
                var _this = _super.call(this) || this;
                _this.template = '<div class="wjFlexChartMacd" ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjFlexChartMacd.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.finance.analytics.Macd;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartMacd;
        }(WjFlexChartMacdBase));
        /**
         * AngularJS directive for the @see:FinancialChart @see:MacdHistogram object.
         *
         * The <b>wj-flex-chart-macd-histogram</b> directive must be contained in a @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>symbol-marker</dt><dd><code>@</code> The shape of marker to use for the series. This value
         *                         overrides the default marker set on the chart. See @see:Marker.</dd>
         *   <dt>symbol-size</dt>  <dd><code>@</code> The size of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts, in pixels.
         *                         This value overrides any set at the chart level.</dd>
         *   <dt>symbol-style</dt> <dd><code>=</code> The style of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         *   <dt>fast-period</dt>  <dd><code>@</code>  The fast moving average period for the MACD calculation.</dd>
         *   <dt>slow-period</dt>  <dd><code>@</code> The slow moving average period for the MACD calculation.</dd>
         *   <dt>signal-smoothing-period/dt>    <dd><code>@</code> The smoothing period for the MACD calculation.</dd>
         * </dl>
         *
         */
        var WjFlexChartMacdHistogram = /** @class */ (function (_super) {
            __extends(WjFlexChartMacdHistogram, _super);
            function WjFlexChartMacdHistogram() {
                var _this = _super.call(this) || this;
                _this.template = '<div class="wjFlexChartMacdHistogram" ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjFlexChartMacdHistogram.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.finance.analytics.MacdHistogram;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartMacdHistogram;
        }(WjFlexChartMacdBase));
        /**
         * AngularJS directive for the @see:FinancialChart @see:Stochastic object.
         *
         * The <b>wj-flex-chart-stochastic</b> directive must be contained in a @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>styles/dt>        <dd><code></code> The styles for the %K and %D lines.</dd>
         *   <dt>symbol-marker</dt><dd><code>@</code> The shape of marker to use for the series. This value
         *                         overrides the default marker set on the chart. See @see:Marker.</dd>
         *   <dt>symbol-size</dt>  <dd><code>@</code> The size of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts, in pixels.
         *                         This value overrides any set at the chart level.</dd>
         *   <dt>symbol-style</dt> <dd><code>=</code> The style of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         *   <dt>k-period</dt>     <dd><code>@</code>  The period for the %K calculation.</dd>
         *   <dt>d-period</dt>     <dd><code>@</code>  The period for the %D calculation.</dd>
         *   <dt>smoothing-period</dt>     <dd><code>@</code>  The smoothing period for the %K calculation.</dd>
         * </dl>
         *
         */
        var WjFlexChartStochastic = /** @class */ (function (_super) {
            __extends(WjFlexChartStochastic, _super);
            function WjFlexChartStochastic() {
                var _this = _super.call(this) || this;
                _this.template = '<div class="wjFlexChartStochastic" ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjFlexChartStochastic.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.finance.analytics.Stochastic;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartStochastic;
        }(WjBaseOverlayIndicator));
        /**
         * AngularJS directive for the @see:FinancialChart @see:BollingerBands object.
         *
         * The <b>wj-flex-chart-bollinger-bands</b> directive must be contained in a @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>symbol-marker</dt><dd><code>@</code> The shape of marker to use for the series. This value
         *                         overrides the default marker set on the chart. See @see:Marker.</dd>
         *   <dt>symbol-size</dt>  <dd><code>@</code> The size of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts, in pixels.
         *                         This value overrides any set at the chart level.</dd>
         *   <dt>symbol-style</dt> <dd><code>=</code> The style of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         *   <dt>period</dt>       <dd><code>@</code>  The period for the Bollinger Bands calculation.</dd>
         *   <dt>multiplier/dt>    <dd><code>@</code> The standard deviation multiplier for the Bollinger Bands calculation.</dd>
         * </dl>
         *
         */
        var WjFlexChartBollingerBands = /** @class */ (function (_super) {
            __extends(WjFlexChartBollingerBands, _super);
            function WjFlexChartBollingerBands() {
                var _this = _super.call(this) || this;
                _this.template = '<div class="wjFlexChartBollingerBands" ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjFlexChartBollingerBands.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.finance.analytics.BollingerBands;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartBollingerBands;
        }(WjBaseOverlayIndicator));
        /**
         * AngularJS directive for the @see:FinancialChart @see:Envelopes object.
         *
         * The <b>wj-flex-chart-envelopes</b> directive must be contained in a @see:WjFinancialChart directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>binding</dt>      <dd><code>@</code> The name of the property that contains Y values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>binding-x</dt>    <dd><code>@</code> The name of the property that contains X values for the
         *                         series. This value overrides any binding set for the chart.</dd>
         *   <dt>css-class</dt>    <dd><code>@</code> The CSS class to use for the series.</dd>
         *   <dt>items-source</dt> <dd><code>=</code> An array or @see:ICollectionView object that contains
         *                         data for this series.</dd>
         *   <dt>name</dt>         <dd><code>@</code> The name of the series to show in the legend.</dd>
         *   <dt>style</dt>        <dd><code>=</code> The series style. Use ng-attr-style to specify the series
         *                         style object as an object. See the section on ngAttr attribute bindings in
         *                         <a target="_blank" href="https://docs.angularjs.org/guide/directive">
         *                         AngularJS Creating Custom Directives</a> and the <a target="_blank" href=
         *                         "http://demos.wijmo.com/5/Angular/FlexChartIntro/FlexChartIntro/#Styling">
         *                         FlexChart 101 Styling Series</a> sample for more information.</dd>
         *   <dt>symbol-marker</dt><dd><code>@</code> The shape of marker to use for the series. This value
         *                         overrides the default marker set on the chart. See @see:Marker.</dd>
         *   <dt>symbol-size</dt>  <dd><code>@</code> The size of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts, in pixels.
         *                         This value overrides any set at the chart level.</dd>
         *   <dt>symbol-style</dt> <dd><code>=</code> The style of the symbols used to render data
         *                         points in this series for Scatter, LineSymbols, and SplineSymbols charts.
         *                         This value overrides any setting at the chart level.</dd>
         *   <dt>visibility</dt>   <dd><code>=</code> The @see:SeriesVisibility value indicating whether and where to
         *                         display the series.</dd>
         *   <dt>period</dt>       <dd><code>@</code>  The period for the moving average envelopes calculation.</dd>
         *   <dt>size/dt>          <dd><code>@</code> The size of the moving average envelopes.</dd>
         *   <dt>type/dt>          <dd><code>@</code> The @see:MovingAverageType of the moving average to be used for the envelopes.</dd>
         * </dl>
         *
         */
        var WjFlexChartEnvelopes = /** @class */ (function (_super) {
            __extends(WjFlexChartEnvelopes, _super);
            function WjFlexChartEnvelopes() {
                var _this = _super.call(this) || this;
                _this.template = '<div class="wjFlexChartEnvelopes" ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjFlexChartEnvelopes.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.chart.finance.analytics.Envelopes;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexChartEnvelopes;
        }(WjBaseOverlayIndicator));
        //#endregion "Chart directives classes"
    })(angular = wijmo.angular || (wijmo.angular = {}));
})(wijmo || (wijmo = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
//
// AngularJS directives for wijmo.gauge module
//
var wijmo;
(function (wijmo) {
    var angular;
    (function (angular) {
        //#region "Gauge directives registration"
        var wijmoGauge = window['angular'].module('wj.gauge', []);
        // register only if module is loaded
        if (wijmo.gauge && wijmo.gauge.LinearGauge) {
            wijmoGauge.directive('wjLinearGauge', [function () {
                    return new WjLinearGauge();
                }]);
            wijmoGauge.directive('wjBulletGraph', [function () {
                    return new WjBulletGraph();
                }]);
            wijmoGauge.directive('wjRadialGauge', [function () {
                    return new WjRadialGauge();
                }]);
            wijmoGauge.directive('wjRange', [function () {
                    return new WjRange();
                }]);
        }
        //#endregion "Gauge directives definitions"
        //#region "Gauge directives classes"
        // Gauge control directive
        // Provides base setup for all directives related to controls derived from Gauge
        // Abstract class, not for use in markup
        var WjGauge = /** @class */ (function (_super) {
            __extends(WjGauge, _super);
            // Creates a new instance of a WjGauge
            function WjGauge() {
                var _this = _super.call(this) || this;
                _this.template = '<div ng-transclude />';
                _this.transclude = true;
                return _this;
            }
            Object.defineProperty(WjGauge.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.gauge.Gauge;
                },
                enumerable: true,
                configurable: true
            });
            return WjGauge;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:LinearGauge control.
         *
         * Use the <b>wj-linear-gauge</b> directive to add linear gauges to your AngularJS applications.
         * Note that directive and parameter names must be formatted in lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;wj-linear-gauge
         *   value="ctx.gauge.value"
         *   show-text="Value"
         *   is-read-only="false"&gt;
         *   &lt;wj-range
         *     wj-property="pointer"
         *     thickness="0.2"&gt;
         *     &lt;wj-range
         *       min="0"
         *       max="33"
         *       color="green"&gt;
         *     &lt;/wj-range&gt;
         *     &lt;wj-range
         *       min="33"
         *       max="66"
         *       color="yellow"&gt;
         *     &lt;/wj-range&gt;
         *     &lt;wj-range
         *       min="66"
         *       max="100"
         *       color="red"&gt;
         *     &lt;/wj-range&gt;
         *   &lt;/wj-range&gt;
         * &lt;/wj-linear-gauge&gt;</pre>
         *
         * The <b>wj-linear-gauge</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>ng-model</dt>      <dd><code>@</code> Binds the control's <b>value</b> property using the ng-model Angular
         *                          directive. Binding the property using the ng-model directive provides standard benefits
         *                          like validation, adding the control's state to the form instance, and so on. To redefine
         *                          properties on a control that is bound by the ng-model directive, use the wj-model-property
         *                          attribute.</dd>
         *   <dt>wj-model-property</dt>  <dd><code>@</code> Specifies a control property that is bound to a scope using the
         *                               <b>ng-model</b> directive.</dd>
         *   <dt>control</dt>       <dd><code>=</code> A reference to the @see:LinearGauge
         *                          control created by this directive.</dd>
         *   <dt>direction</dt>     <dd><code>@</code> The @see:GaugeDirection value in
         *                          which the gauge fills as the value grows.</dd>
         *   <dt>format</dt>        <dd><code>@</code> The format string used for displaying
         *                          the gauge values as text.</dd>
         *   <dt>has-shadow</dt>    <dd><code>@</code> A value indicating whether the gauge
         *                          displays a shadow effect.</dd>
         *   <dt>initialized</dt>   <dd><code>&</code> This event occurs after the binding has finished
         *                          initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt> <dd><code>=</code> A value indicating whether the binding has finished
         *                           initializing the control with attribute values. </dd>
         *   <dt>is-animated</dt>   <dd><code>@</code> A value indicating whether the gauge
         *                          animates value changes.</dd>
         *   <dt>is-read-only</dt>  <dd><code>@</code> A value indicating whether users are
         *                          prevented from editing the value.</dd>
         *   <dt>min</dt>           <dd><code>@</code> The minimum value that the gauge
         *                          can display.</dd>
         *   <dt>max</dt>           <dd><code>@</code> The maximum value that the gauge
         *                          can display.</dd>
         *   <dt>show-text</dt>     <dd><code>@</code> The @see:ShowText value indicating
         *                          which values display as text within the gauge.</dd>
         *   <dt>step</dt>          <dd><code>@</code> The amount to add or subtract to the value
         *                          property when the user presses the arrow keys.</dd>
         *   <dt>thickness</dt>     <dd><code>@</code> The thickness of the gauge, on a scale
         *                          of zero to one.</dd>
         *   <dt>value</dt>         <dd><code>=</code> The value displayed on the gauge.</dd>
         *   <dt>got-focus</dt>     <dd><code>&</code> The @see:LinearGauge.gotFocus event handler.</dd>
         *   <dt>lost-focus</dt>    <dd><code>&</code> The @see:LinearGauge.lostFocus event handler.</dd>
         * </dl>
         *
         * The <b>wj-linear-gauge</b> directive may contain one or more @see:WjRange directives.
         *
         * @fiddle:t842jozb
         */
        var WjLinearGauge = /** @class */ (function (_super) {
            __extends(WjLinearGauge, _super);
            // Initializes a new instance of a WjLinearGauge
            function WjLinearGauge() {
                return _super.call(this) || this;
            }
            Object.defineProperty(WjLinearGauge.prototype, "_controlConstructor", {
                // gets the Wijmo LinearGauge control constructor
                get: function () {
                    return wijmo.gauge.LinearGauge;
                },
                enumerable: true,
                configurable: true
            });
            return WjLinearGauge;
        }(WjGauge));
        /**
         * AngularJS directive for the @see:BulletGraph control.
         *
         * Use the <b>wj-bullet-graph</b> directive to add bullet graphs to your AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;wj-bullet-graph
         *   value="ctx.gauge.value"
         *   min="0" max="10"
         *   target="{&#8203;{item.target}}"
         *   bad="{&#8203;{item.target * .75}}"
         *   good="{&#8203;{item.target * 1.25}}"&gt;
         * &lt;/wj-bullet-graph&gt;</pre>
         *
         * The <b>wj-bullet-graph</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>control</dt>       <dd><code>=</code> A reference to the BulletGraph control
         *                          created by this directive.</dd>
         *   <dt>direction</dt>     <dd><code>@</code> The @see:GaugeDirection value
         *                          indicating which direction the gauge fills as the value grows.</dd>
         *   <dt>initialized</dt>   <dd><code>&</code> This event occurs after the binding has finished
         *                          initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt> <dd><code>=</code> A value indicating whether the binding has finished
         *                           initializing the control with attribute values. </dd>
         *   <dt>target</dt>        <dd><code>@</code> The target value for the measure.</dd>
         *   <dt>good</dt>          <dd><code>@</code> A reference value considered good for the
         *                          measure.</dd>
         *   <dt>bad</dt>           <dd><code>@</code> A reference value considered bad for the
         *                          measure.</dd>
         *   <dt>value</dt>         <dd><code>=</code> The actual value of the measure.</dd>
         * </dl>
         *
         * The <b>wj-bullet-graph</b> directive may contain one or more @see:WjRange directives.
         *
         * @fiddle:8uxb1vwf
         */
        var WjBulletGraph = /** @class */ (function (_super) {
            __extends(WjBulletGraph, _super);
            // Initializes a new instance of a WjBulletGraph
            function WjBulletGraph() {
                return _super.call(this) || this;
            }
            Object.defineProperty(WjBulletGraph.prototype, "_controlConstructor", {
                // gets the Wijmo BulletGraph control constructor
                get: function () {
                    return wijmo.gauge.BulletGraph;
                },
                enumerable: true,
                configurable: true
            });
            return WjBulletGraph;
        }(WjLinearGauge));
        /**
         * AngularJS directive for the @see:RadialGauge control.
         *
         * Use the <b>wj-radial-gauge</b> directive to add radial gauges to your AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>Here is a &lt;b&gt;RadialGauge&lt;/b&gt; control:&lt;/p&gt;
         * &lt;wj-radial-gauge
         *   style="height:300px"
         *   value="count"
         *   min="0" max="10"
         *   is-read-only="false"&gt;
         * &lt;/wj-radial-gauge&gt;</pre>
         *
         * The <b>wj-radial-gauge</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>ng-model</dt>      <dd><code>@</code> Binds the control's <b>value</b> property using the ng-model Angular
         *                          directive. Binding the property using the ng-model directive provides standard benefits
         *                          like validation, adding the control's state to the form instance, and so on. To redefine
         *                          properties on a control that is bound by the ng-model directive, use the wj-model-property
         *                          attribute.</dd>
         *   <dt>wj-model-property</dt>  <dd><code>@</code> Specifies a control property that is bound to a scope using the
         *                               <b>ng-model</b> directive.</dd>
         *   <dt>control</dt>       <dd><code>=</code> A reference to the RadialGauge
         *                          control created by this directive.</dd>
         *   <dt>auto-scale</dt>    <dd><code>@</code> A value indicating whether the gauge
         *                          scales the display to fill the host element.</dd>
         *   <dt>format</dt>        <dd><code>@</code> The format string used for displaying
         *                          gauge values as text.</dd>
         *   <dt>has-shadow</dt>    <dd><code>@</code> A value indicating whether the gauge
         *                          displays a shadow effect.</dd>
         *   <dt>initialized</dt>   <dd><code>&</code> This event occurs after the binding has finished
         *                          initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt> <dd><code>=</code> A value indicating whether the binding has finished
         *                           initializing the control with attribute values. </dd>
         *   <dt>is-animated</dt>   <dd><code>@</code> A value indicating whether the gauge
         *                          animates value changes.</dd>
         *   <dt>is-read-only</dt>  <dd><code>@</code> A value indicating whether users are
         *                          prevented from editing the value.</dd>
         *   <dt>min</dt>           <dd><code>@</code> The minimum value that the gauge
         *                          can display.</dd>
         *   <dt>max</dt>           <dd><code>@</code> The maximum value that the gauge
         *                          can display.</dd>
         *   <dt>show-text</dt>     <dd><code>@</code> A @see:ShowText value indicating
         *                          which values display as text within the gauge.</dd>
         *   <dt>step</dt>          <dd><code>@</code> The amount to add or subtract to the
         *                          value property when the user presses the arrow keys.</dd>
         *   <dt>start-angle</dt>   <dd><code>@</code> The starting angle for the gauge, in
         *                          degreees, measured clockwise from the 9 o'clock position.</dd>
         *   <dt>sweep-angle</dt>   <dd><code>@</code> The sweeping angle for the gauge in degrees
         *                          (may be positive or negative).</dd>
         *   <dt>thickness</dt>     <dd><code>@</code> The thickness of the gauge, on a scale
         *                          of zero to one.</dd>
         *   <dt>value</dt>         <dd><code>=</code> The value displayed on the gauge.</dd>
         *   <dt>got-focus</dt>     <dd><code>&</code> The @see:RadialGauge.gotFocus event handler.</dd>
         *   <dt>lost-focus</dt>    <dd><code>&</code> The @see:RadialGauge.lostFocus event handler.</dd>
         * </dl>
         *
         * The <b>wj-radial-gauge</b> directive may contain one or more @see:WjRange directives.
         *
         * @fiddle:7ec2144u
         */
        var WjRadialGauge = /** @class */ (function (_super) {
            __extends(WjRadialGauge, _super);
            // Initializes a new instance of a WjRadialGauge
            function WjRadialGauge() {
                return _super.call(this) || this;
            }
            Object.defineProperty(WjRadialGauge.prototype, "_controlConstructor", {
                // gets the Wijmo RadialGauge control constructor
                get: function () {
                    return wijmo.gauge.RadialGauge;
                },
                enumerable: true,
                configurable: true
            });
            return WjRadialGauge;
        }(WjGauge));
        /**
         * AngularJS directive for the @see:Range object.
         *
         * The <b>wj-range</b> directive must be contained in a @see:WjLinearGauge, @see:WjRadialGauge
         * or @see:WjBulletGraph directive. It adds the Range object to the 'ranges' array property
         * of the parent directive. You may also initialize other Range type properties of the parent
         * directive by specifying the property name with the wj-property attribute.
         *
         * For example:
         * <pre>&lt;wj-radial-gauge
         *     min="0"
         *     max="200"
         *     step="20"
         *     value="theValue"
         *     is-read-only="false"&gt;
         *     &lt;wj-range
         *       min="0"
         *       max="100"
         *       color="red"&gt;
         *     &lt;/wj-range&gt;
         *     &lt;wj-range
         *       min="100"
         *       max="200"
         *       color="green"&gt;
         *     &lt;/wj-range&gt;
         *     &lt;wj-range
         *       wj-property="pointer"
         *       color="blue"&gt;
         *     &lt;/wj-range&gt;
         * &lt;/wj-radial-gauge&gt;</pre>
         *
         * The <b>wj-range</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>min</dt>           <dd><code>@</code> The minimum value in the range.</dd>
         *   <dt>max</dt>           <dd><code>@</code> The maximum value in the range.</dd>
         *   <dt>color</dt>         <dd><code>@</code> The color used to display the range.</dd>
         *   <dt>thickness</dt>     <dd><code>@</code> The thickness of the range, on a scale
         *                          of zero to one.</dd>
         *   <dt>name</dt>          <dd><code>@</code> The name of the range.</dd>
         *   <dt>wj-property</dt>   <dd><code>@</code> The name of the property to initialize
         *                          with this directive.</dd>
         * </dl>
         */
        var WjRange = /** @class */ (function (_super) {
            __extends(WjRange, _super);
            // Initializes a new instance of a WjRange
            function WjRange() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjLinearGauge', '?^wjRadialGauge', '?^wjBulletGraph'];
                _this.template = '<div ng-transclude />';
                _this.transclude = true;
                // set up as a child directive
                _this._property = 'ranges';
                _this._isPropertyArray = true;
                return _this;
            }
            Object.defineProperty(WjRange.prototype, "_controlConstructor", {
                // Returns constructor of related Wijmo object. Abstract member, must be overridden in inherited class
                get: function () {
                    return wijmo.gauge.Range;
                },
                enumerable: true,
                configurable: true
            });
            return WjRange;
        }(angular.WjDirective));
        //#endregion "Gauge directives classes"
    })(angular = wijmo.angular || (wijmo.angular = {}));
})(wijmo || (wijmo = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
//
// AngularJS directives for wijmo.grid module
//
var wijmo;
(function (wijmo) {
    var angular;
    (function (angular) {
        var wijmoGrid = window['angular'].module('wj.grid', []);
        //if (!wijmo.grid) {
        //    return;
        //}
        //#region "Grid directives registration"
        //var wijmoGrid = window['angular'].module('wj.grid', []);
        // register only if module is loaded
        if (wijmo.grid && wijmo.grid.FlexGrid) {
            wijmoGrid.directive('wjFlexGrid', ['$compile', '$interpolate', function ($compile, $interpolate) {
                    return new WjFlexGrid($compile, $interpolate);
                }]);
            wijmoGrid.directive('wjFlexGridColumn', ['$compile', function ($compile) {
                    return new WjFlexGridColumn($compile);
                }]);
            wijmoGrid.directive('wjFlexGridCellTemplate', [function () {
                    return new WjFlexGridCellTemplate();
                }]);
            if (wijmo.grid.filter) {
                wijmoGrid.directive('wjFlexGridFilter', [function () {
                        return new WjFlexGridFilter();
                    }]);
            }
            if (wijmo.grid.grouppanel) {
                wijmoGrid.directive('wjGroupPanel', [function () {
                        return new WjGroupPanel();
                    }]);
            }
            if (wijmo.grid.detail) {
                wijmoGrid.directive('wjFlexGridDetail', ['$compile', function ($compile) {
                        return new WjFlexGridDetail($compile);
                    }]);
            }
            if (wijmo.grid.sheet) {
                wijmoGrid.directive('wjFlexSheet', ['$compile', '$interpolate', function ($compile, $interpolate) {
                        return new WjFlexSheet($compile, $interpolate);
                    }]);
                wijmoGrid.directive('wjSheet', [function () {
                        return new WjSheet();
                    }]);
            }
            if (wijmo.grid.multirow) {
                wijmoGrid.directive('wjMultiRow', ['$compile', '$interpolate', function ($compile, $interpolate) {
                        return new WjMultiRow($compile, $interpolate);
                    }]);
            }
        }
        //#endregion "Grid directives definitions"
        //#region "Grid directives classes"
        /**
            * AngularJS directive for the @see:FlexGrid control.
            *
            * Use the <b>wj-flex-grid</b> directive to add grids to your AngularJS applications.
            * Note that directive and parameter names must be formatted as lower-case with dashes
            * instead of camel-case. For example:
            *
            * <pre>&lt;p&gt;Here is a FlexGrid control:&lt;/p&gt;
            * &lt;wj-flex-grid items-source="data"&gt;
            *   &lt;wj-flex-grid-column
            *     header="Country"
            *     binding="country"&gt;
            *   &lt;/wj-flex-grid-column&gt;
            *   &lt;wj-flex-grid-column
            *     header="Sales"
            *     binding="sales"&gt;
            *   &lt;/wj-flex-grid-column&gt;
            *   &lt;wj-flex-grid-column
            *     header="Expenses"
            *     binding="expenses"&gt;
            *   &lt;/wj-flex-grid-column&gt;
            *   &lt;wj-flex-grid-column
            *     header="Downloads"
            *     binding="downloads"&gt;
            *   &lt;/wj-flex-grid-column&gt;
            * &lt;/wj-flex-grid&gt;</pre>
            *
            * The example below creates a FlexGrid control and binds it to a 'data' array
            * exposed by the controller. The grid has three columns, each corresponding to
            * a property of the objects contained in the source array.
            *
            * @fiddle:QNb9X
            *
            * The <b>wj-flex-grid</b> directive supports the following attributes:
            *
            * <dl class="dl-horizontal">
            *   <dt>allow-add-new</dt>              <dd><code>@</code> A value indicating whether to show a new row
            *                                     template so users can add items to the source collection.</dd>
            *   <dt>allow-delete</dt>             <dd><code>@</code> A value indicating whether the grid deletes the
            *                                     selected rows when the Delete key is pressed.</dd>
            *   <dt>allow-dragging</dt>           <dd><code>@</code> An @see:AllowDragging value indicating
            *                                     whether and how the user can drag rows and columns with the mouse.</dd>
            *   <dt>allow-merging</dt>            <dd><code>@</code> An @see:AllowMerging value indicating
            *                                     which parts of the grid provide cell merging.</dd>
            *   <dt>allow-resizing</dt>           <dd><code>@</code> An @see:AllowResizing value indicating
            *                                     whether users are allowed to resize rows and columns with the mouse.</dd>
            *   <dt>allow-sorting</dt>            <dd><code>@</code> A boolean value indicating whether users can sort
            *                                     columns by clicking the column headers.</dd>
            *   <dt>auto-generate-columns</dt>    <dd><code>@</code> A boolean value indicating whether the grid generates
            *                                     columns automatically based on the <b>items-source</b>.</dd>
            *   <dt>child-items-path</dt>         <dd><code>@</code> The name of the property used to generate
            *                                     child rows in hierarchical grids (or an array of property names if items
            *                                     at different hierarchical levels use different names for their child items).</dd>
            *   <dt>control</dt>                  <dd><code>=</code> A reference to the @see:FlexGrid control
            *                                     created by this directive.</dd>
            *   <dt>defer-resizing</dt>           <dd><code>=</code> A boolean value indicating whether row and column
            *                                     resizing should be deferred until the user releases the mouse button.</dd>
            *   <dt>frozen-columns</dt>           <dd><code>@</code> The number of frozen (non-scrollable) columns in the grid.</dd>
            *   <dt>frozen-rows</dt>              <dd><code>@</code> The number of frozen (non-scrollable) rows in the grid.</dd>
            *   <dt>group-header-format</dt>      <dd><code>@</code> The format string used to create the group
            *                                     header content.</dd>
            *   <dt>headers-visibility</dt>       <dd><code>=</code> A @see:HeadersVisibility value
            *                                     indicating whether the row and column headers are visible. </dd>
            *   <dt>ime-enabled</dt>              <dd><code>@</code> Gets or sets a value that determines whether the grid should
            *                                     support Input Method Editors (IME) while not in edit mode.</dd>
            *   <dt>initialized</dt>              <dd><code>&</code> This event occurs after the binding has finished
            *                                     initializing the control with attribute values.</dd>
            *   <dt>is-initialized</dt>           <dd><code>=</code> A value indicating whether the binding has finished
            *                                     initializing the control with attribute values. </dd>
            *   <dt>item-formatter</dt>           <dd><code>=</code> A function that customizes
            *                                     cells on this grid.</dd>
            *   <dt>items-source</dt>             <dd><code>=</code> An array or @see:ICollectionView object that
            *                                     contains the items shown on the grid.</dd>
            *   <dt>is-read-only</dt>             <dd><code>@</code> A boolean value indicating whether the user is
            *                                     prevented from editing grid cells by typing into them.</dd>
            *   <dt>merge-manager</dt>            <dd><code>=</code> A @see:MergeManager object that specifies
            *                                     the merged extent of the specified cell.</dd>
            *   <dt>selection-mode</dt>           <dd><code>@</code> A @see:SelectionMode value
            *                                     indicating whether and how the user can select cells.</dd>
            *   <dt>show-groups</dt>              <dd><code>@</code> A boolean value indicating whether to insert group
            *                                     rows to delimit data groups.</dd>
            *   <dt>show-sort</dt>                <dd><code>@</code> A boolean value indicating whether to display sort
            *                                     indicators in the column headers.</dd>
            *   <dt>sort-row-index</dt>           <dd><code>@</code> A number specifying the index of row in the column
            *                                     header panel that shows and changes the current sort.</dd>
            *   <dt>tree-indent</dt>              <dd><code>@</code> The indentation, in pixels, used to offset row
            *                                     groups of different levels.</dd>
            *   <dt>beginning-edit</dt>           <dd><code>&</code> Handler for the @see:FlexGrid.beginningEdit event.</dd>
            *   <dt>cell-edit-ended</dt>          <dd><code>&</code> Handler for the @see:FlexGrid.cellEditEnded event.</dd>
            *   <dt>cell-edit-ending</dt>         <dd><code>&</code> Handler for the @see:FlexGrid.cellEditEnding event.</dd>
            *   <dt>prepare-cell-for-edit</dt>    <dd><code>&</code> Handler for the @see:FlexGrid.prepareCellForEdit event.</dd>
            *   <dt>resizing-column</dt>          <dd><code>&</code> Handler for the @see:FlexGrid.resizingColumn event.</dd>
            *   <dt>resized-column</dt>           <dd><code>&</code> Handler for the @see:FlexGrid.resizedColumn event.</dd>
            *   <dt>dragged-column</dt>           <dd><code>&</code> Handler for the @see:FlexGrid.draggedColumn event.</dd>
            *   <dt>dragging-column</dt>          <dd><code>&</code> Handler for the @see:FlexGrid.draggingColumn event.</dd>
            *   <dt>sorted-column</dt>            <dd><code>&</code> Handler for the @see:FlexGrid.sortedColumn event.</dd>
            *   <dt>sorting-column</dt>           <dd><code>&</code> Handler for the @see:FlexGrid.sortingColumn event.</dd>
            *   <dt>deleting-row</dt>             <dd><code>&</code> Handler for the @see:FlexGrid.deletingRow event.</dd>
            *   <dt>dragging-row</dt>             <dd><code>&</code> Handler for the @see:FlexGrid.draggingRow event.</dd>
            *   <dt>dragged-row</dt>              <dd><code>&</code> Handler for the @see:FlexGrid.draggedRow event.</dd>
            *   <dt>resizing-row</dt>             <dd><code>&</code> Handler for the @see:FlexGrid.resizingRow event.</dd>
            *   <dt>resized-row</dt>              <dd><code>&</code> Handler for the @see:FlexGrid.resizedRow event.</dd>
            *   <dt>row-added</dt>                <dd><code>&</code> Handler for the @see:FlexGrid.rowAdded event.</dd>
            *   <dt>row-edit-ended</dt>           <dd><code>&</code> Handler for the @see:FlexGrid.rowEditEnded event.</dd>
            *   <dt>row-edit-ending</dt>          <dd><code>&</code> Handler for the @see:FlexGrid.rowEditEnding event.</dd>
            *   <dt>loaded-rows</dt>              <dd><code>&</code> Handler for the @see:FlexGrid.loadedRows event.</dd>
            *   <dt>loading-rows</dt>             <dd><code>&</code> Handler for the @see:FlexGrid.loadingRows event.</dd>
            *   <dt>group-collapsed-changed</dt>  <dd><code>&</code> Handler for the @see:FlexGrid.groupCollapsedChanged event.</dd>
            *   <dt>group-collapsed-changing</dt> <dd><code>&</code> Handler for the @see:FlexGrid.groupCollapsedChanging event.</dd>
            *   <dt>items-source-changed</dt>     <dd><code>&</code> Handler for the @see:FlexGrid.itemsSourceChanged event.</dd>
            *   <dt>selection-changing</dt>       <dd><code>&</code> Handler for the @see:FlexGrid.selectionChanging event.</dd>
            *   <dt>selection-changed</dt>        <dd><code>&</code> Handler for the @see:FlexGrid.selectionChanged event.</dd>
            *   <dt>got-focus</dt>                <dd><code>&</code> Handler for the @see:FlexGrid.gotFocus event.</dd>
            *   <dt>lost-focus</dt>               <dd><code>&</code> Handler for the @see:FlexGrid.lostFocus event.</dd>
            *   <dt>scroll-position-changed</dt>  <dd><code>&</code> Handler for the @see:FlexGrid.scrollPositionChanged event.</dd>
            * </dl>
            *
            * The <b>wj-flex-grid</b> directive may contain @see:WjFlexGridColumn, @see:WjFlexGridCellTemplate and
            * @see:WjFlexGridDetail child directives.
            */
        var WjFlexGrid = /** @class */ (function (_super) {
            __extends(WjFlexGrid, _super);
            // Initializes a new instance of a WjFlexGrid
            function WjFlexGrid($compile, $interpolate) {
                var _this = _super.call(this) || this;
                _this._$compile = $compile;
                _this._$interpolate = $interpolate;
                var self = _this;
                //super();
                _this.transclude = true;
                _this.template = '<div ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjFlexGrid.prototype, "_controlConstructor", {
                // Gets the Wijmo FlexGrid control constructor
                get: function () {
                    return wijmo.grid.FlexGrid;
                },
                enumerable: true,
                configurable: true
            });
            WjFlexGrid.prototype._createLink = function () {
                return new WjFlexGridLink();
            };
            // Initializes WjFlexGrid property map
            WjFlexGrid.prototype._initProps = function () {
                var childPathDesc = angular.MetaFactory.findProp('childItemsPath', this._props);
                childPathDesc.scopeBindingMode = '@';
                childPathDesc.customHandler = function (scope, control, value, oldValue, link) {
                    if (value) {
                        value = value.trim();
                        if (value && value[0] === '[') {
                            var arr = scope.$parent.$eval(value);
                            control['childItemsPath'] = arr;
                            return true;
                        }
                    }
                    return false;
                };
            };
            return WjFlexGrid;
        }(angular.WjDirective));
        angular.WjFlexGrid = WjFlexGrid;
        var WjFlexGridLink = /** @class */ (function (_super) {
            __extends(WjFlexGridLink, _super);
            function WjFlexGridLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            WjFlexGridLink.prototype._initControl = function () {
                var grid = _super.prototype._initControl.call(this);
                new DirectiveCellFactory(grid, this);
                return grid;
            };
            return WjFlexGridLink;
        }(angular.WjLink));
        angular.WjFlexGridLink = WjFlexGridLink;
        // Mockup for CellFactory, to allow DirectiveCellFactory be loaded in case of absent wijmo.grid module.
        var gridModule = wijmo.grid && wijmo.grid.CellFactory;
        if (!gridModule) {
            wijmo.grid = {};
            wijmo.grid.CellFactory = function () { };
        }
        var DirectiveCellFactory = /** @class */ (function (_super) {
            __extends(DirectiveCellFactory, _super);
            function DirectiveCellFactory(grid, gridLink) {
                var _this = _super.call(this) || this;
                _this._lastApplyTimeStamp = 0;
                _this._noApplyLag = false;
                _this._startingEditing = false;
                _this._cellStampCounter = 0;
                _this._composing = false;
                _this._grid = grid;
                _this._gridLink = gridLink;
                _this._rowHeightUpdates = new _RowHeightUpdateQueue(_this);
                // init _templateTypes
                if (!DirectiveCellFactory._templateTypes) {
                    DirectiveCellFactory._templateTypes = [];
                    for (var templateType in CellTemplateType) {
                        if (isNaN(templateType)) {
                            DirectiveCellFactory._templateTypes.push(templateType);
                        }
                    }
                }
                // override grid's cell factory
                var self = _this;
                _this._baseCf = grid.cellFactory;
                grid.cellFactory = _this;
                // initialize input event dispatcher
                _this._evtInput = document.createEvent('HTMLEvents');
                _this._evtInput.initEvent('input', true, false);
                // initialize change event dispatcher
                _this._evtChange = document.createEvent('HTMLEvents');
                _this._evtChange.initEvent('change', true, false);
                // initialize blur event dispatcher
                _this._evtBlur = document.createEvent('HTMLEvents');
                _this._evtBlur.initEvent('blur', false, false);
                // no $apply() lag while editing
                grid.prepareCellForEdit.addHandler(function (s, e) {
                    self._noApplyLag = true;
                });
                grid.cellEditEnded.addHandler(function (s, e) {
                    // If column has no cell edit template, clear _editChar buffer.
                    if (e.range.col < 0 ||
                        !grid.columns[e.range.col][WjFlexGridCellTemplate._getTemplContextProp(CellTemplateType.CellEdit)]) {
                        self._editChar = null;
                    }
                    setTimeout(function () {
                        self._noApplyLag = false;
                    }, 300);
                });
                grid.beginningEdit.addHandler(function (s, e) {
                    // if editing is started by a user interaction (e.data != null), and not by pressing
                    // a char key, clear the char buffer, because it may contain previous key presses 
                    // that didn't cause editing starting (like typing to a read-only cell, or like)
                    if (e.data && (!(e.data instanceof KeyboardEvent) || e.data.charCode <= 32)) {
                        self._editChar = null;
                    }
                    self._startingEditing = true;
                });
                grid.hostElement.addEventListener('keydown', function (e) {
                    self._startingEditing = false;
                }, true);
                grid.hostElement.addEventListener('keypress', function (e) {
                    var char = e.charCode > 32 ? String.fromCharCode(e.charCode) : null;
                    if (char && wijmo.closest(e.target, '.wj-flexgrid') === grid.hostElement) {
                        // Grid's _KeyboardHandler may receive 'keypress' before or after this handler (observed at least in IE,
                        // not clear why this happens). So both grid.activeEditor and _startingEditing (the latter is initialized in
                        // beginningEdit and cleared in 'keydown') participate in detecting whether this char has initialized a cell
                        // editing.
                        if (!grid.activeEditor || self._startingEditing) {
                            self._editChar = char;
                        }
                        else if (self._editChar) {
                            self._editChar += char;
                        }
                    }
                }, true);
                grid.hostElement.addEventListener('compositionstart', function (e) {
                    self._composing = true;
                }, true);
                grid.hostElement.addEventListener('compositionend', function (e) {
                    self._composing = false;
                }, true);
                return _this;
            }
            DirectiveCellFactory.prototype.updateCell = function (panel, rowIndex, colIndex, cell, rng) {
                var _this = this;
                this._cellStampCounter = (this._cellStampCounter + 1) % 10000000;
                var cellStamp = cell[DirectiveCellFactory._cellStampProp] = this._cellStampCounter;
                // restore overflow for any cell
                if (cell.style.overflow) {
                    cell.style.overflow = '';
                }
                var self = this, grid = panel.grid, editRange = grid.editRange, templateType, row = panel.rows[rowIndex], dataItem = row.dataItem, isGridCtx = false, needCellValue = false, isEdit = false, isCvGroup = false;
                // determine template type
                switch (panel.cellType) {
                    case wijmo.grid.CellType.Cell:
                        if (editRange && editRange.row === rowIndex && editRange.col === colIndex) {
                            templateType = CellTemplateType.CellEdit;
                            needCellValue = isEdit = true;
                        }
                        else if (row instanceof wijmo.grid.GroupRow) {
                            isCvGroup = dataItem instanceof wijmo.collections.CollectionViewGroup;
                            var isHierNonGroup = !(isCvGroup || row.hasChildren);
                            if (colIndex == panel.columns.firstVisibleIndex) {
                                templateType = isHierNonGroup ? CellTemplateType.Cell : CellTemplateType.GroupHeader;
                            }
                            else {
                                templateType = isHierNonGroup ? CellTemplateType.Cell : CellTemplateType.Group;
                                needCellValue = true;
                            }
                        }
                        else if (!(wijmo.grid['detail'] && wijmo.grid['detail'].DetailRow &&
                            (row instanceof wijmo.grid['detail'].DetailRow))) {
                            templateType = CellTemplateType.Cell;
                        }
                        break;
                    case wijmo.grid.CellType.ColumnHeader:
                        templateType = CellTemplateType.ColumnHeader;
                        break;
                    case wijmo.grid.CellType.RowHeader:
                        templateType = grid.collectionView &&
                            grid.collectionView.currentEditItem === dataItem
                            ? CellTemplateType.RowHeaderEdit
                            : CellTemplateType.RowHeader;
                        isGridCtx = true;
                        break;
                    case wijmo.grid.CellType.TopLeft:
                        templateType = CellTemplateType.TopLeft;
                        isGridCtx = true;
                        break;
                    case wijmo.grid.CellType.ColumnFooter:
                        templateType = CellTemplateType.ColumnFooter;
                        needCellValue = true;
                        break;
                    case wijmo.grid.CellType.BottomLeft:
                        templateType = CellTemplateType.BottomLeft;
                        isGridCtx = true;
                        break;
                }
                var isUpdated = false;
                if (templateType != null) {
                    var col = (isCvGroup && templateType == CellTemplateType.GroupHeader ?
                        grid.getColumn(dataItem.groupDescription['propertyName']) :
                        (colIndex >= 0 && colIndex < panel.columns.length ? panel.columns[colIndex] : null));
                    if (col) {
                        var templContextProp = WjFlexGridCellTemplate._getTemplContextProp(templateType), templContext = (isGridCtx ? grid : col)[templContextProp];
                        // maintain template inheritance
                        if (!templContext) {
                            if (templateType === CellTemplateType.RowHeaderEdit) {
                                templateType = CellTemplateType.RowHeader;
                                templContextProp = WjFlexGridCellTemplate._getTemplContextProp(templateType);
                                templContext = grid[templContextProp];
                            }
                            else if (templateType === CellTemplateType.Group || templateType === CellTemplateType.GroupHeader) {
                                if (!isCvGroup) {
                                    templateType = CellTemplateType.Cell;
                                    templContextProp = WjFlexGridCellTemplate._getTemplContextProp(templateType);
                                    templContext = col[templContextProp];
                                }
                            }
                        }
                        if (templContext) {
                            // apply directive template and style
                            var tpl = self._getCellTemplate(templContext.cellTemplate), cellStyle = templContext.cellStyle, cellClass = templContext.cellClass, isTpl = !wijmo.isNullOrWhiteSpace(tpl), isStyle = !wijmo.isNullOrWhiteSpace(cellStyle), isClass = !wijmo.isNullOrWhiteSpace(cellClass), cellValue;
                            if (needCellValue) {
                                cellValue = panel.getCellData(rowIndex, colIndex, false);
                            }
                            // apply cell template
                            if (isTpl) {
                                var measureAttr = cell.getAttribute(wijmo.grid.FlexGrid._WJS_MEASURE), isMeasuring = measureAttr && measureAttr.toLowerCase() === 'true';
                                isUpdated = true;
                                if (isEdit) {
                                    this._baseCf.updateCell(panel, rowIndex, colIndex, cell, rng, true);
                                }
                                // if this is false then we can't reuse previously cached scope and linked tree.
                                var cellContext = (cell[templContextProp] || {}), isForeignCell = cellContext.column !== col || !cellContext.cellScope || !cellContext.cellScope.$root, isImeInput = isEdit && this._composing && grid.imeEnabled;
                                // create a new cell scope, as a child of the column's parent scope 
                                // (which could be ng-repeat with its specific properties), 
                                // or reuse the one created earlier for this cell and cached in the 
                                // cellContext.cellScope property. 
                                // in any case initialize the scope with cell specific properties.
                                var cellScope = cellContext.cellScope;
                                if (isForeignCell) {
                                    this._doDisposeCell(cell);
                                    cellContext.cellScope = cellScope = templContext.templLink.scope.$parent.$new();
                                    cellContext.column = col;
                                    cell[templContextProp] = cellContext;
                                }
                                var scopeChanged = cellScope.$row !== row || cellScope.$col !== col || cellScope.$item !== dataItem ||
                                    cellScope.$value !== cellValue;
                                if (scopeChanged) {
                                    self._initCellScope(cellScope, row, col, dataItem, cellValue);
                                }
                                // compile column template to get a link function, or reuse the 
                                // link function got earlier for this column and cached in the 
                                // templContext.cellLink property. 
                                var cellLink = templContext.cellLink;
                                if (!cellLink) {
                                    cellLink = templContext.cellLink = this._gridLink.directive._$compile('<div style="display:none"' + (isStyle ? ' ng-style="' + cellStyle + '"' : '') +
                                        (isClass ? ' ng-class="' + cellClass + '"' : '') + '>' + tpl + '</div>');
                                    //'<div ' + (isStyle ? ' ng-style="' + cellStyle + '"' : '') + '>' + tpl + '</div>');
                                }
                                // link the cell template to the cell scope and get a bound DOM 
                                // subtree to use as the cell content, 
                                // or reuse the bound subtree linked earlier and cached in the 
                                // cellContext.clonedElement property.
                                // we pass a clone function to the link function to force it to 
                                // return a clone of the template.
                                var clonedElement = cellContext.clonedElement;
                                if (isForeignCell) {
                                    //register watch before link, it'll then unhide the root element before linked element binding
                                    var dispose = cellScope.$watch(function (scope) {
                                        if (!clonedElement) {
                                            return;
                                        }
                                        dispose();
                                        clonedElement[0].style.display = '';
                                        // This resolves the problem with non-painting header cells in IE, whose reason
                                        // is unclear (appeared after we started to add invisible clonedElement). 
                                        // We change some style property, which forces IE to repaint the cell, 
                                        // and after some delay restore its original value.
                                        if (panel.cellType === wijmo.grid.CellType.ColumnHeader || panel.cellType === wijmo.grid.CellType.TopLeft) {
                                            var clonedStyle = clonedElement[0].style, prevColor = clonedStyle.outlineColor, prevWidth = clonedStyle.outlineWidth;
                                            clonedStyle.outlineColor = 'white';
                                            clonedStyle.outlineWidth = '0px';
                                            setTimeout(function () {
                                                clonedStyle.outlineColor = prevColor;
                                                clonedStyle.outlineWidth = prevWidth;
                                            }, 0);
                                        }
                                        //clonedElement[0].style.visibility = 'visible';
                                    });
                                    cellContext.clonedElement = clonedElement = cellLink(cellScope, function (clonedEl, scope) { });
                                    //clonedElement[0].style.display = 'none';
                                    //clonedElement[0].style.visibility = 'collapse';
                                }
                                // insert the bound content subtree to the cell, 
                                // after $apply to prevent flickering.
                                // TBD: check whether this code is really necessary
                                if (isMeasuring /*&& clonedElement[0].style.display == 'none'*/) {
                                    clonedElement[0].style.display = '';
                                }
                                var replaceFirst = false;
                                if (isEdit) {
                                    var rootEl = cell.firstElementChild;
                                    if (rootEl) {
                                        // set focus to cell, because hiding a focused element may move focus to a page body
                                        // that will force Grid to finish editing.
                                        if (!isImeInput) {
                                            cell.focus();
                                        }
                                        rootEl.style.display = 'none';
                                        //cell.textContent = '';
                                    }
                                }
                                else {
                                    replaceFirst = cell.childNodes.length == 1;
                                    if (!replaceFirst) {
                                        cell.textContent = '';
                                    }
                                }
                                if (replaceFirst) {
                                    if (clonedElement[0] !== cell.firstChild) {
                                        cell.replaceChild(clonedElement[0], cell.firstChild);
                                    }
                                }
                                else {
                                    cell.appendChild(clonedElement[0]);
                                }
                                if (templContext.cellOverflow) {
                                    cell.style.overflow = templContext.cellOverflow;
                                }
                                var lag = 40, closingLag = 10;
                                if (this._closingApplyTimeOut) {
                                    clearTimeout(this._closingApplyTimeOut);
                                }
                                self._rowHeightUpdates.add({ panel: panel, cell: cell, rng: rng, cellStamp: cellStamp });
                                if (isMeasuring || editRange || this._noApplyLag || scopeChanged && (Date.now() - this._lastApplyTimeStamp) > lag) {
                                    clearTimeout(this._closingApplyTimeOut);
                                    if (cellScope.$root && !cellScope.$root.$$phase) {
                                        cellScope.$apply();
                                    }
                                    if (!editRange && !isMeasuring) {
                                        self._rowHeightUpdates.execute();
                                    }
                                    this._lastApplyTimeStamp = Date.now();
                                }
                                else {
                                    clearTimeout(this._closingApplyTimeOut);
                                    this._closingApplyTimeOut = setTimeout(function () {
                                        clearTimeout(this._closingApplyTimeOut);
                                        if (cellScope.$root && !cellScope.$root.$$phase) {
                                            cellScope.$apply();
                                        }
                                        self._rowHeightUpdates.execute();
                                    }, closingLag);
                                }
                                if (!isImeInput) {
                                    // increase row height if cell doesn't fit in the current row height.
                                    setTimeout(function () {
                                        //var cellHeight = cell.scrollHeight,
                                        //    panelRows = panel.rows;
                                        //if (rowIndex < panelRows.length && panelRows[rowIndex].renderHeight < cellHeight) {
                                        //    panelRows.defaultSize = cellHeight;
                                        if (self._updateRowHeight(panel, cell, rng, cellStamp)) {
                                            if (isEdit) {
                                                self._rowHeightUpdates.clear();
                                                var isFullEdit = self._isFullEdit();
                                                grid.refresh();
                                                grid.startEditing(isFullEdit);
                                                return;
                                            }
                                            //} else if (isEdit && !contains(clonedElement[0], wijmo.getActiveElement())) {
                                        }
                                        else if (isEdit) {
                                            self._initEditInput(cellContext, templContext, null);
                                        }
                                    }, 0);
                                }
                                else if (isEdit) {
                                    setTimeout(function () {
                                        if (isImeInput) {
                                            _this._initImeEditInput(cellContext, templContext);
                                        }
                                        else {
                                            _this._initEditInput(cellContext, templContext, null);
                                        }
                                    }, 0);
                                }
                                if (isEdit) {
                                    self._cellEditorScope = cellScope;
                                    var editEndingEH = function (s, e) {
                                        grid.cellEditEnding.removeHandler(editEndingEH);
                                        // Move focus out of the current input element, in order to let it to save
                                        // its value (necessary for controls like InputDate that can't update value immediately
                                        // as user typing).
                                        // We do it via event emulation, instead of moving focus to another element,
                                        // because in IE an element doesn't fit in time to receive the 'blur' event.
                                        if (!e.stayInEditMode) {
                                            var activeElement = wijmo.getActiveElement();
                                            if (activeElement) {
                                                activeElement.dispatchEvent(self._evtBlur);
                                            }
                                            // We need to move focus nevertheless, because without this grid may lose focus at all in IE.
                                            cell.focus();
                                        }
                                        if (!(e.cancel || e.stayInEditMode)) {
                                            e.cancel = true;
                                            panel.grid.setCellData(rowIndex, colIndex, cellScope.$value);
                                        }
                                        // close all open dropdowns 
                                        var dropDowns = cell.querySelectorAll('.wj-dropdown');
                                        [].forEach.call(dropDowns, function (el) {
                                            var ctrl = wijmo.Control.getControl(el);
                                            if (ctrl && ctrl instanceof wijmo.input.DropDown) {
                                                ctrl.isDroppedDown = false;
                                            }
                                        });
                                    };
                                    // subscribe the handler to the cellEditEnding event
                                    grid.cellEditEnding.addHandler(editEndingEH);
                                    grid.cellEditEnded.addHandler(function () {
                                        self._cellEditorScope = null;
                                    });
                                }
                                else {
                                    this._baseCf.updateCell(panel, rowIndex, colIndex, cell, rng, false);
                                }
                            }
                        }
                    }
                }
                if (!isUpdated) {
                    this._doDisposeCell(cell);
                    this._baseCf.updateCell(panel, rowIndex, colIndex, cell, rng);
                }
                // apply cell style
                if (!isTpl && (isStyle || isClass)) {
                    // build cell style object
                    var cellScopeSt = self._initCellScope({}, row, col, dataItem, cellValue), style = isStyle ? this._gridLink.scope.$parent.$eval(cellStyle, cellScopeSt) : null, classObj = isClass ? this._gridLink.scope.$parent.$eval(cellClass, cellScopeSt) : null;
                    // apply style to cell
                    if (style || classObj) {
                        var rootElement = document.createElement('div');
                        // copy elements instead of innerHTML in order to keep bindings 
                        // in templated cells
                        while (cell.firstChild) {
                            rootElement.appendChild(cell.firstChild);
                        }
                        cell.appendChild(rootElement);
                        // apply style
                        if (style) {
                            for (var key in style) {
                                rootElement.style[key] = style[key];
                            }
                        }
                        // apply classes
                        if (classObj) {
                            var classArr = (wijmo.isArray(classObj) ? classObj : [classObj]), clStr = '';
                            for (var i = 0; i < classArr.length; i++) {
                                var curPart = classArr[i];
                                if (curPart) {
                                    if (wijmo.isString(curPart)) {
                                        clStr += ' ' + curPart;
                                    }
                                    else {
                                        for (var clName in curPart) {
                                            if (curPart[clName]) {
                                                clStr += ' ' + clName;
                                            }
                                        }
                                    }
                                }
                            }
                            rootElement.className = clStr;
                        }
                    }
                }
            };
            DirectiveCellFactory.prototype.getEditorValue = function (g) {
                if (this._cellEditorScope) {
                    return this._cellEditorScope.$value;
                }
                else {
                    return _super.prototype.getEditorValue.call(this, g);
                }
            };
            DirectiveCellFactory.prototype.disposeCell = function (cell) {
                this._doDisposeCell(cell);
            };
            DirectiveCellFactory.prototype._doDisposeCell = function (cell) {
                var ttm = DirectiveCellFactory._templateTypes;
                for (var i = 0; i < ttm.length; i++) {
                    var templContextProp = WjFlexGridCellTemplate._getTemplContextProp(CellTemplateType[ttm[i]]), cellContext = (cell[templContextProp]);
                    if (cellContext && cellContext.cellScope && cellContext.cellScope.$root) {
                        cellContext.cellScope.$destroy();
                        // this is necessary to avoid a memory leak probably caused by JQLite implementation.
                        if (cellContext.clonedElement) {
                            cellContext.clonedElement.remove();
                            cellContext.clonedElement = null;
                        }
                        cell[templContextProp] = null;
                    }
                }
            };
            DirectiveCellFactory.prototype._updateRowHeight = function (panel, cell, rng, cellStamp) {
                var cellHeight = cell.scrollHeight, panelRows = panel.rows, rowSpan = rng && rng.rowSpan || 1;
                if (cellStamp === cell[DirectiveCellFactory._cellStampProp] && (panelRows.defaultSize * rowSpan) < cellHeight) {
                    panelRows.defaultSize = cellHeight / rowSpan;
                    return true;
                }
                return false;
            };
            DirectiveCellFactory.prototype._initCellScope = function (scope, row, col, dataItem, cellValue) {
                scope.$row = row;
                scope.$col = col;
                scope.$item = dataItem;
                scope.$value = cellValue;
                return scope;
            };
            DirectiveCellFactory.prototype._getCellTemplate = function (tpl) {
                if (tpl) {
                    tpl = tpl.replace(/ class\=\"ng\-scope\"( \"ng\-binding\")?/g, '');
                    tpl = tpl.replace(/<span>\s*<\/span>/g, '');
                    tpl = tpl.trim();
                }
                return tpl;
            };
            DirectiveCellFactory.prototype._isFullEdit = function () {
                var grid = this._grid;
                return !grid.activeEditor || grid._edtHdl._fullEdit;
            };
            DirectiveCellFactory.prototype._setFullEdit = function (templContext) {
                var grid = this._grid;
                if (templContext.forceFullEdit && grid.activeEditor) {
                    grid._edtHdl._fullEdit = true;
                }
            };
            DirectiveCellFactory.prototype._initEditInput = function (cellContext, templContext, initialValue) {
                var _this = this;
                // make sure we're in full edit mode (so editor gets cursor keys: TFS 288442)
                this._setFullEdit(templContext);
                // Find first visible input element and focus it. 
                var input = this._findInitialInput(cellContext);
                if (input) {
                    var inpFocusEh_1 = function () {
                        input.removeEventListener('focus', inpFocusEh_1);
                        //setTimeout(() => {
                        // at this moment control had to select the whole content
                        setTimeout(function () {
                            var value = initialValue != null ? initialValue : _this._editChar;
                            if (value) {
                                //let caretPos = input.selectionStart + value.length;
                                input.value = value;
                                _this._editChar = null;
                                //DirectiveCellFactory._setSelectionRange(input, input.value.length);
                                DirectiveCellFactory._setSelectionRange(input, value.length, value.length);
                                // ngModel doesn't listen to the 'input' event
                                // in IE, so we send 'change' event instead, 
                                // but only for inputs which are not parts
                                // of Wijmo controls.
                                if (DirectiveCellFactory.isNgIE &&
                                    !(wijmo.hasClass(input, 'wj-form-control') ||
                                        input.getAttribute('wj-part'))) {
                                    input.dispatchEvent(_this._evtChange);
                                }
                                else {
                                    input.dispatchEvent(_this._evtInput);
                                }
                                //setTimeout(() => {
                                //    // at this moment control had to process 'input' event,
                                //    // even if it happens asynchronously 
                                //    setTimeout(() => {
                                //        //TBD: should use wijmo.setSelectionRange which needs adaption to HTMLTextAreaElement
                                //        //wijmo.setSelectionRange(input,
                                //        //    Math.min(caretPos, input.value.length), input.value.length);
                                //        DirectiveCellFactory._setSelectionRange(input,
                                //            Math.min(caretPos, input.value.length), input.value.length);
                                //    }, 0);
                                //}, 0);
                            }
                        }, DirectiveCellFactory._FOCUS_INTERVAL);
                        //}, 50);
                    };
                    input.addEventListener('focus', inpFocusEh_1);
                    input.focus();
                }
            };
            DirectiveCellFactory.prototype._initImeEditInput = function (cellContext, templContext) {
                var _this = this;
                var imeEditor = wijmo.getActiveElement();
                if (imeEditor && (imeEditor instanceof HTMLInputElement) && wijmo.hasClass(imeEditor, 'wj-grid-ime')) {
                    var compEndEh_1 = function (e) {
                        imeEditor.removeEventListener('compositionend', compEndEh_1);
                        wijmo.setCss(imeEditor, wijmo.grid._ImeHandler._cssHidden);
                        _this._initEditInput(cellContext, templContext, imeEditor.value);
                    };
                    imeEditor.addEventListener('compositionend', compEndEh_1);
                    // position/size the editor
                    var templateInput = this._findInitialInput(cellContext);
                    if (templateInput) {
                        var tRect = templateInput.getBoundingClientRect(), imeRect = imeEditor.getBoundingClientRect(), imeStyle = window.getComputedStyle(imeEditor), imeStyleLeft = parseFloat(imeStyle.left), imeStyleTop = parseFloat(imeStyle.top);
                        wijmo.setCss(imeEditor, {
                            left: (imeStyleLeft + tRect.left - imeRect.left) + 'px',
                            top: (imeStyleTop + tRect.top - imeRect.top) + 'px',
                            width: tRect.width + 'px',
                            height: tRect.height + 'px'
                        });
                    }
                }
            };
            DirectiveCellFactory.prototype._findInitialInput = function (cellContext) {
                var inputs = cellContext.clonedElement[0].querySelectorAll('input,textarea');
                if (inputs) {
                    for (var i = 0; i < inputs.length; i++) {
                        var input = inputs[i], inpSt = window.getComputedStyle(input);
                        if (inpSt.display !== 'none' && inpSt.visibility === 'visible') {
                            return input;
                        }
                    }
                }
                return null;
            };
            DirectiveCellFactory._setSelectionRange = function (e, start, end) {
                if (end === void 0) { end = start; }
                //e = asType(e, HTMLInputElement);
                if (wijmo.contains(document.body, e) && !e.disabled && e.style.display != 'none') {
                    try {
                        // use 'backward' to keep the start in view (but not in Edge! TFS 228053)
                        e.setSelectionRange(wijmo.asNumber(start), wijmo.asNumber(end), wijmo.isIE() ? null : 'backward');
                        // focus needed in Chrome (TFS 124102, 142672) 
                        // and after setRange (TFS 228053)
                        e.focus();
                    }
                    catch (x) { }
                }
            };
            DirectiveCellFactory._cellStampProp = '__wjCellStamp';
            DirectiveCellFactory._FOCUS_INTERVAL = wijmo.Control._FOCUS_INTERVAL + 20;
            // Determine whether we are in IE (but not in Edge) in the same way as Ng does it.
            // The approach is based on this:
            // http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
            DirectiveCellFactory.isNgIE = !!document['documentMode'];
            return DirectiveCellFactory;
        }(wijmo.grid.CellFactory));
        var _RowHeightUpdateQueue = /** @class */ (function () {
            function _RowHeightUpdateQueue(cellFactory) {
                this._requests = [];
                this._timeOuts = [];
                this._cellFactory = cellFactory;
            }
            _RowHeightUpdateQueue.prototype.add = function (request) {
                this._requests.push(request);
            };
            _RowHeightUpdateQueue.prototype.execute = function () {
                var requests = this._requests;
                while (requests.length > 0) {
                    var request = this._requests.shift(), self = this;
                    var timeOut = (function (request) {
                        return setTimeout(function () {
                            if (self._cellFactory._updateRowHeight(request.panel, request.cell, request.rng, request.cellStamp)) {
                                self.clear();
                            }
                            else {
                                var toIdx = self._timeOuts.indexOf(timeOut);
                                if (toIdx > -1) {
                                    self._timeOuts.splice(toIdx, 1);
                                }
                            }
                        }, 0);
                    })(request);
                    this._timeOuts.push(timeOut);
                }
            };
            _RowHeightUpdateQueue.prototype.clear = function () {
                this._requests.splice(0, this._requests.length);
                this._clearTimeouts();
            };
            _RowHeightUpdateQueue.prototype._clearTimeouts = function () {
                var timeOuts = this._timeOuts;
                for (var i = 0; i < timeOuts.length; i++) {
                    clearTimeout(timeOuts[i]);
                }
                timeOuts.splice(0, timeOuts.length);
            };
            return _RowHeightUpdateQueue;
        }());
        // Remove wijmo.grid mockup after DirectiveCellFactory has been loaded.
        if (!gridModule) {
            wijmo.grid = null;
        }
        /**
         * AngularJS directive for the @see:Column object.
         *
         * The <b>wj-flex-grid-column</b> directive must be contained in a @see:WjFlexGrid directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>aggregate</dt>         <dd><code>@</code> The @see:Aggregate object to display in
         *                              the group header rows for this column.</dd>
         *   <dt>align</dt>             <dd><code>@</code> The string value that sets the horizontal
         *                              alignment of items in the column to left, right, or center.</dd>
         *   <dt>allow-dragging</dt>    <dd><code>@</code> The value indicating whether the user can move
         *                              the column to a new position with the mouse.</dd>
         *   <dt>allow-sorting</dt>     <dd><code>@</code> The value indicating whether the user can sort
         *                              the column by clicking its header.</dd>
         *   <dt>allow-resizing</dt>    <dd><code>@</code> The value indicating whether the user can
         *                              resize the column with the mouse.</dd>
         *   <dt>allow-merging</dt>     <dd><code>@</code> The value indicating whether the user can merge
         *                              cells in the column.</dd>
         *   <dt>binding</dt>           <dd><code>@</code> The name of the property to which the column is
         *                              bound.</dd>
         *   <dt>css-class</dt>         <dd><code>@</code> The name of a CSS class to use when
         *                              rendering the column.</dd>
         *   <dt>data-map</dt>          <dd><code>=</code> The @see:DataMap object to use to convert raw
         *                              values into display values for the column.</dd>
         *   <dt>data-type</dt>         <dd><code>@</code> The enumerated @see:DataType value that indicates
         *                              the type of value stored in the column.</dd>
         *   <dt>format</dt>            <dd><code>@</code> The format string to use to convert raw values
         *                              into display values for the column (see @see:Globalize).</dd>
         *   <dt>header</dt>            <dd><code>@</code> The string to display in the column header.</dd>
         *   <dt>input-type</dt>        <dd><code>@</code> The type attribute to specify the input element
         *                              used to edit values in the column. The default is "tel" for numeric
         *                              columns, and "text" for all other non-Boolean columns.</dd>
         *   <dt>is-content-html</dt>   <dd><code>@</code> The value indicating whether cells in the column
         *                              contain HTML content rather than plain text.</dd>
         *   <dt>is-read-only</dt>      <dd><code>@</code> The value indicating whether the user is prevented
         *                              from editing values in the column.</dd>
         *   <dt>is-selected</dt>       <dd><code>@</code> The value indicating whether the column is selected.</dd>
         *   <dt>mask</dt>              <dd><code>@</code> The mask string used to edit values in the
         *                              column.</dd>
         *   <dt>max-width</dt>         <dd><code>@</code> The maximum width for the column.</dd>
         *   <dt>min-width</dt>         <dd><code>@</code> The minimum width for the column.</dd>
         *   <dt>name</dt>              <dd><code>@</code> The column name. You can use it to retrieve the
         *                              column.</dd>
         *   <dt>is-required</dt>       <dd><code>@</code> The value indicating whether the column must contain
         *                              non-null values.</dd>
         *   <dt>show-drop-down</dt>    <dd><code>@</code> The value indicating whether to show drop-down buttons
         *                              for editing based on the column's @see:DataMap.</dd>
         *   <dt>visible</dt>           <dd><code>@</code> The value indicating whether the column is visible.</dd>
         *   <dt>width</dt>             <dd><code>@</code> The width of the column in pixels or as a
         *                              star value.</dd>
         *   <dt>word-wrap</dt>         <dd><code>@</code> The value indicating whether cells in the column wrap
         *                              their content.</dd>
         * </dl>
         *
         * Any html content within the <b>wj-flex-grid-column</b> directive is treated as a template for the cells in that column.
         * The template is applied only to regular cells. If you wish to apply templates to specific cell types such as
         * column or group headers, then please see the @see:WjFlexGridCellTemplate directive.
         *
         * The following example creates two columns with a template and a conditional style:
         *
         * @fiddle:5L423
         *
         * The <b>wj-flex-grid-column</b> directive may contain @see:WjFlexGridCellTemplate child directives.
         */
        var WjFlexGridColumn = /** @class */ (function (_super) {
            __extends(WjFlexGridColumn, _super);
            // Initializes a new instance of a WjGridColumn
            function WjFlexGridColumn($compile) {
                var _this = _super.call(this) || this;
                _this._$compile = $compile;
                // The 'data-map' HTML attribute is converted to 'map' by Angular, so we give it the 'map' alias.
                _this.scope["dataMap"] += "map";
                _this.scope["dataType"] += "type";
                _this.require = '^wjFlexGrid';
                _this['terminal'] = true;
                // If Angular supports template definition via a function (available starting with ver. 1.1.4) then we utilize this
                // possibility, because this is the only entry point where we have an access to an unprocessed version of a column 
                // cell template with element level directives definitions in their original state.
                if (angular.WjDirective._dynaTemplates) {
                    // must be false, otherwise directive's subtree will no be available in the template function
                    _this.transclude = false;
                    // should be less then at ng-repeat/ng-if etc (to let them take a control over a column directive creation), 
                    // but bigger than at ordinal directives (like ng-style, to not allow them to evaluate during the column directive
                    // linking).
                    _this['priority'] = 100;
                    _this.template = function (tElement, tAttrs) {
                        // stores cell template definition, tAttrs is the only object that allows us to share a data
                        // with the link function.
                        tAttrs[WjFlexGridColumn._colTemplateProp] = tElement[0].innerHTML;
                        return '<div class="wjGridColumn"/>';
                    };
                    // under old Angular work in the degraded mode without element level directives support, 
                    // retrieve cell template in the link function where element level directives are already compiled.
                }
                else {
                    _this.transclude = true;
                    _this.template = '<div class="wjGridColumn" ng-transclude/>';
                }
                return _this;
            }
            Object.defineProperty(WjFlexGridColumn.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.grid.Column;
                },
                enumerable: true,
                configurable: true
            });
            WjFlexGridColumn.prototype._initControl = function (element) {
                return new wijmo.grid.Column();
            };
            WjFlexGridColumn.prototype._createLink = function () {
                return new WjFlexGridColumnLink();
            };
            WjFlexGridColumn._colTemplateProp = '$__wjColTemplate';
            WjFlexGridColumn._colWjLinkProp = '$__wjLink';
            WjFlexGridColumn._cellCtxProp = '$_cellCtxProp';
            return WjFlexGridColumn;
        }(angular.WjDirective));
        var WjFlexGridColumnLink = /** @class */ (function (_super) {
            __extends(WjFlexGridColumnLink, _super);
            function WjFlexGridColumnLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            WjFlexGridColumnLink.prototype._initParent = function () {
                var grid = this.parent.control;
                if (grid.autoGenerateColumns) {
                    grid.autoGenerateColumns = false;
                    this._safeApply(this.scope, 'autoGenerateColumns', false);
                    grid.columns.clear();
                }
                _super.prototype._initParent.call(this);
                // Assign cell template defined without WjFlexGridCellTemplate tag if the latter was not specified.
                var cellCtxProp = WjFlexGridCellTemplate._getTemplContextProp(CellTemplateType.Cell), cellCtxByTag = this.control[cellCtxProp], cellCtxWoTag = this[WjFlexGridColumn._cellCtxProp];
                if (!cellCtxByTag && cellCtxWoTag) {
                    this.control[cellCtxProp] = cellCtxWoTag;
                }
                this.control[WjFlexGridColumn._colWjLinkProp] = this;
            };
            WjFlexGridColumnLink.prototype._link = function () {
                // get column template (HTML content)
                var rootEl = this.tElement[0], dynaTempl = this.tAttrs[WjFlexGridColumn._colTemplateProp], template = dynaTempl != null ? dynaTempl : angular.WjDirective._removeTransclude(rootEl.innerHTML), cellTemplContext = {};
                if (!wijmo.isNullOrWhiteSpace(template)) {
                    //this.control['cellTemplate'] = template;
                    var templRoot = document.createElement('div');
                    templRoot.innerHTML = template;
                    var childElements = [];
                    [].forEach.call(templRoot.children, function (value) {
                        childElements.push(value);
                    });
                    var linkScope;
                    for (var i = 0; i < childElements.length; i++) {
                        var curTempl = childElements[i];
                        if (curTempl.tagName.toLocaleLowerCase() === WjFlexGridCellTemplate._tagName) {
                            if (!linkScope) {
                                //linkScope = this.scope.$parent;
                                linkScope = this.scope.$parent.$new();
                            }
                            // remove cell template directive from cell's template
                            templRoot.removeChild(curTempl);
                            // compile and link cell template directive
                            rootEl.appendChild(curTempl);
                            this.directive._$compile(curTempl)(linkScope);
                        }
                    }
                    var cleanCellTempl = templRoot.innerHTML;
                    if (!wijmo.isNullOrWhiteSpace(cleanCellTempl)) {
                        cellTemplContext.cellTemplate = cleanCellTempl;
                    }
                }
                // get column style
                var style = this.tAttrs['ngStyle'], ngClass = this.tAttrs['ngClass'];
                if (style) {
                    cellTemplContext.cellStyle = style;
                }
                if (ngClass) {
                    cellTemplContext.cellClass = ngClass;
                }
                if (cellTemplContext.cellTemplate || cellTemplContext.cellStyle || cellTemplContext.cellClass) {
                    cellTemplContext.templLink = this;
                    this[WjFlexGridColumn._cellCtxProp] = cellTemplContext;
                }
                _super.prototype._link.call(this);
            };
            return WjFlexGridColumnLink;
        }(angular.WjLink));
        /**
         * Defines the type of cell to which the template applies.
         * This value is specified in the <b>cell-type</b> attribute
         * of the @see:WjFlexGridCellTemplate directive.
         */
        var CellTemplateType;
        (function (CellTemplateType) {
            /** Defines a regular (data) cell. */
            CellTemplateType[CellTemplateType["Cell"] = 0] = "Cell";
            /** Defines a cell in edit mode. */
            CellTemplateType[CellTemplateType["CellEdit"] = 1] = "CellEdit";
            /** Defines a column header cell. */
            CellTemplateType[CellTemplateType["ColumnHeader"] = 2] = "ColumnHeader";
            /** Defines a row header cell. */
            CellTemplateType[CellTemplateType["RowHeader"] = 3] = "RowHeader";
            /** Defines a row header cell in edit mode. */
            CellTemplateType[CellTemplateType["RowHeaderEdit"] = 4] = "RowHeaderEdit";
            /** Defines a top left cell. */
            CellTemplateType[CellTemplateType["TopLeft"] = 5] = "TopLeft";
            /** Defines a group header cell in a group row. */
            CellTemplateType[CellTemplateType["GroupHeader"] = 6] = "GroupHeader";
            /** Defines a regular cell in a group row. */
            CellTemplateType[CellTemplateType["Group"] = 7] = "Group";
            /** Defines a column footer cell. */
            CellTemplateType[CellTemplateType["ColumnFooter"] = 8] = "ColumnFooter";
            /** Defines a bottom left cell (at the intersection of the row header and column footer cells). **/
            CellTemplateType[CellTemplateType["BottomLeft"] = 9] = "BottomLeft";
        })(CellTemplateType = angular.CellTemplateType || (angular.CellTemplateType = {}));
        /**
         * AngularJS directive for the @see:FlexGrid cell templates.
         *
         * The <b>wj-flex-grid-cell-template</b> directive defines a template for a certain
         * cell type in @see:FlexGrid, and must contain a <b>cell-type</b> attribute that
         * specifies the @see:CellTemplateType. Depending on the template's cell type,
         * the <b>wj-flex-grid-cell-template</b> directive must be a child of either @see:WjFlexGrid
         * or @see:WjFlexGridColumn directives.
         *
         * Column-specific cell templates must be contained in <b>wj-flex-grid-column</b>
         * directives, and cells that are not column-specific (like row header or top left cells)
         * must be contained in the <b>wj-flex-grid directive</b>.
         *
         * In addition to an HTML fragment, <b>wj-flex-grid-cell-template</b> directives may
         * contain an <b>ng-style</b> or <b>ng-class</b> attribute that provides conditional formatting for cells.
         *
         * Both the <b>ng-style/ng-class</b> attributes and the HTML fragment can use the <b>$col</b>,
         * <b>$row</b> and <b>$item</b> template variables that refer to the @see:Column,
         * @see:Row and <b>Row.dataItem</b> objects pertaining to the cell.
         *
         * For cell types like <b>Group</b> and <b>CellEdit</b>, an additional <b>$value</b>
         * variable containing an unformatted cell value is provided. For example, here is a
         * FlexGrid control with templates for row headers and for the Country column's regular
         * and column header cells:
         *
         * <pre>&lt;wj-flex-grid items-source="data"&gt;
         *   &lt;wj-flex-grid-cell-template cell-type="RowHeader"&gt;
         *     {&#8203;{$row.index}}
         *   &lt;/wj-flex-grid-cell-template&gt;
         *   &lt;wj-flex-grid-cell-template cell-type="RowHeaderEdit"&gt;
         *     ...
         *   &lt;/wj-flex-grid-cell-template&gt;
         * &nbsp;
         *   &lt;wj-flex-grid-column header="Country" binding="country"&gt;
         *     &lt;wj-flex-grid-cell-template cell-type="ColumnHeader"&gt;
         *       &lt;img ng-src="resources/globe.png" /&gt;
         *         {&#8203;{$col.header}}
         *       &lt;/wj-flex-grid-cell-template&gt;
         *       &lt;wj-flex-grid-cell-template cell-type="Cell"&gt;
         *         &lt;img ng-src="resources/{&#8203;{$item.country}}.png" /&gt;
         *         {&#8203;{$item.country}}
         *       &lt;/wj-flex-grid-cell-template&gt;
         *     &lt;/wj-flex-grid-column&gt;
         *   &lt;wj-flex-grid-column header="Sales" binding="sales"&gt;&lt;/wj-flex-grid-column&gt;
         * &lt;/wj-flex-grid&gt;</pre>
         *
         * For more detailed information on specific cell type templates refer to the
         * documentation for the @see:CellTemplateType enumeration.
         *
         * Note that the <b>wj-flex-grid-column</b> directive may also contain arbitrary content
         * that is treated as a template for a regular data cell (<i>cell-type="Cell"</i>). But if
         * a <b>wj-flex-grid-cell-template</b> directive exists and is set to <i>cell-type="Cell"</i>
         * under the <b>wj-flex-grid-column</b> directive, it takes priority and overrides the
         * arbitrary content.
         *
         * The <b>wj-flex-grid-cell-template</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>cell-type</dt>
         *   <dd><code>@</code>
         *     The @see:CellTemplateType value defining the type of cell the template applies to.
         *   </dd>
         *   <dt>cell-overflow</dt>
         *   <dd><code>@</code>
         *     Defines the <b>style.overflow</b> property value for cells.
         *   </dd>
         *   <dt>force-full-edit</dt>
         *   <dd><code>@</code>
         *     For cell edit templates, indicates whether cell editing forcibly starts in full edit mode,
         *     regardless of how the editing was initiated. In full edit mode pressing cursor keys don't finish editing.
         *     Defaults to true.
         *   </dd>
         * </dl>
         *
         * The <b>cell-type</b> attribute takes any of the following enumerated values:
         *
         * <b>Cell</b>
         *
         * Defines a regular (data) cell template. Must be a child of the @see:WjFlexGridColumn directive.
         * For example, this cell template shows flags in the Country column's cells:
         *
         * <pre>&lt;wj-flex-grid-column header="Country" binding="country"&gt;
         *   &lt;wj-flex-grid-cell-template cell-type="Cell"&gt;
         *     &lt;img ng-src="resources/{&#8203;{$item.country}}.png" /&gt;
         *     {&#8203;{$item.country}}
         *   &lt;/wj-flex-grid-cell-template&gt;
         * &lt;/wj-flex-grid-column&gt;</pre>
         *
         * For a hierarchical @see:FlexGrid (that is, one with the <b>childItemsPath</b> property
         * specified), if no <b>Group</b> template is provided, non-header cells in group rows in
         * this @see:Column also use this template.
         *
         * <b>CellEdit</b>
         *
         * Defines a template for a cell in edit mode. Must be a child of the @see:WjFlexGridColumn directive.
         * This cell type has an additional <b>$value</b> property available for binding. It contains the
         * original cell value before editing, and the updated value after editing.
     
         * For example, here is a template that uses the Wijmo @see:InputNumber control as an editor
         * for the "Sales" column:
         *
         * <pre>&lt;wj-flex-grid-column header="Sales" binding="sales"&gt;
         *   &lt;wj-flex-grid-cell-template cell-type="CellEdit"&gt;
         *     &lt;wj-input-number value="$value" step="1"&gt;&lt;/wj-input-number&gt;
         *   &lt;/wj-flex-grid-cell-template&gt;
         * &lt;/wj-flex-grid-column&gt;</pre>
         *
         * <b>ColumnHeader</b>
         *
         * Defines a template for a column header cell. Must be a child of the @see:WjFlexGridColumn directive.
         * For example, this template adds an image to the header of the "Country" column:
         *
         * <pre>&lt;wj-flex-grid-column header="Country" binding="country"&gt;
         *   &lt;wj-flex-grid-cell-template cell-type="ColumnHeader"&gt;
         *     &lt;img ng-src="resources/globe.png" /&gt;
         *     {&#8203;{$col.header}}
         *   &lt;/wj-flex-grid-cell-template&gt;
         * &lt;/wj-flex-grid-column&gt;</pre>
         *
         * <b>RowHeader</b>
         *
         * Defines a template for a row header cell. Must be a child of the @see:WjFlexGrid directive.
         * For example, this template shows row indices in the row headers:
         *
         * <pre>&lt;wj-flex-grid items-source="data"&gt;
         *   &lt;wj-flex-grid-cell-template cell-type="RowHeader"&gt;
         *     {&#8203;{$row.index}}
         *   &lt;/wj-flex-grid-cell-template&gt;
         * &lt;/wj-flex-grid&gt;</pre>
         *
         * Note that this template is applied to a row header cell, even if it is in a row that is
         * in edit mode. In order to provide an edit-mode version of a row header cell with alternate
         * content, define the <b>RowHeaderEdit</b> template.
         *
         * <b>RowHeaderEdit</b>
         *
         * Defines a template for a row header cell in edit mode. Must be a child of the
         * @see:WjFlexGrid directive. For example, this template shows dots in the header
         * of rows being edited:
         *
         * <pre>&lt;wj-flex-grid items-source="data"&gt;
         *   &lt;wj-flex-grid-cell-template cell-type="RowHeaderEdit"&gt;
         *       ...
         *   &lt;/wj-flex-grid-cell-template&gt;
         * &lt;/wj-flex-grid&gt;</pre>
         *
         * To add the standard edit-mode indicator to cells where the <b>RowHeader</b> template
         * applies, use the following <b>RowHeaderEdit</b> template:
         *
         * <pre>&lt;wj-flex-grid items-source="data"&gt;
         *   &lt;wj-flex-grid-cell-template cell-type="RowHeaderEdit"&gt;
         *     {&#8203;{&amp;#x270e;}}
         *   &lt;/wj-flex-grid-cell-template&gt;
         * &lt;/wj-flex-grid&gt;</pre>
         *
         * <b>TopLeft</b>
         *
         * Defines a template for the top left cell. Must be a child of the @see:WjFlexGrid directive.
         * For example, this template shows a down/right glyph in the top-left cell of the grid:
         *
         * <pre>&lt;wj-flex-grid items-source="data"&gt;
         *   &lt;wj-flex-grid-cell-template cell-type="TopLeft"&gt;
         *     &lt;span class="wj-glyph-down-right"&gt;&lt;/span&gt;
         *   &lt;/wj-flex-grid-cell-template&gt;
         * &lt;/wj-flex-grid&gt;</pre>
         *
         * <p><b>GroupHeader</b></p>
         *
         * Defines a template for a group header cell in a @see:GroupRow, Must be a child of the @see:WjFlexGridColumn directive.
         *
         * The <b>$row</b> variable contains an instance of the <b>GroupRow</b> class. If the grouping comes
         * from the a @see:CollectionView, the <b>$item</b> variable references the @see:CollectionViewGroup object.
         *
         * For example, this template uses a checkbox element as an expand/collapse toggle:
         *
         * <pre>&lt;wj-flex-grid-column header="Country" binding="country"&gt;
         *   &lt;wj-flex-grid-cell-template cell-type="GroupHeader"&gt;
         *     &lt;input type="checkbox" ng-model="$row.isCollapsed"/&gt;
         *     {&#8203;{$item.name}} ({&#8203;{$item.items.length}} items)
         *   &lt;/wj-flex-grid-cell-template&gt;
         * &lt;/wj-flex-grid-column&gt;</pre>
         *
         * <b>Group</b>
         *
         * Defines a template for a regular cell (not a group header) in a @see:GroupRow. Must be a child of the
         * @see:WjFlexGridColumn directive. This cell type has an additional <b>$value</b> varible available for
         * binding. In cases where columns have the <b>aggregate</b> property specified, it contains the unformatted
         * aggregate value.
         *
         * For example, this template shows an aggregate's value and kind for group row cells in the "Sales"
         * column:
         *
         * <pre>&lt;wj-flex-grid-column header="Sales" binding="sales" aggregate="Avg"&gt;
         *   &lt;wj-flex-grid-cell-template cell-type="Group"&gt;
         *     Average: {&#8203;{$value | number:2}}
         *   &lt;/wj-flex-grid-cell-template&gt;
         * &lt;/wj-flex-grid-column&gt;</pre>
        *
        * <b>ColumnFooter</b>
        *
        * Defines a template for a regular cell in a <b>columnFooters</b> panel. Must be a child of the
        * @see:WjFlexGridColumn directive. This cell type has an additional <b>$value</b>
        * property available for binding that contains a cell value.
        *
        * For example, this template shows aggregate's value and kind for a footer cell in the "Sales"
        * column:
        *
        * <pre>&lt;wj-flex-grid-column header="Sales" binding="sales" aggregate="Avg"&gt;
        *   &lt;wj-flex-grid-cell-template cell-type="ColumnFooter"&gt;
        *     Average: {&#8203;{$value | number:2}}
        *   &lt;/wj-flex-grid-cell-template&gt;
        * &lt;/wj-flex-grid-column&gt;</pre>
        *
        * <b>BottomLeft</b>
        *
        * Defines a template for the bottom left cells (at the intersection of the row header and column footer cells).
        * Must be a child of the @see:WjFlexGrid directive.
        * For example, this template shows a sigma glyph in the bottom-left cell of the grid:
        *
        * <pre>&lt;wj-flex-grid items-source="data"&gt;
        *   &lt;wj-flex-grid-cell-template cell-type="BottomLeft"&gt;
        *    &amp;#931;
        *   &lt;/wj-flex-grid-cell-template&gt;
        * &lt;/wj-flex-grid&gt;</pre>
         */
        var WjFlexGridCellTemplate = /** @class */ (function (_super) {
            __extends(WjFlexGridCellTemplate, _super);
            function WjFlexGridCellTemplate() {
                var _this = _super.call(this) || this;
                _this.require = ['?^wjFlexGridColumn', '?^wjFlexGrid'];
                // The same approach like in WjFlexGridColumn
                _this['terminal'] = true;
                if (angular.WjDirective._dynaTemplates) {
                    _this.transclude = false;
                    _this['priority'] = 100;
                    _this.template = function (tElement, tAttrs) {
                        tAttrs[WjFlexGridColumn._colTemplateProp] = tElement[0].innerHTML;
                        return '<div />';
                    };
                }
                else {
                    _this.transclude = true;
                    _this.template = '<div ng-transclude/>';
                }
                return _this;
            }
            // returns the name of the property on control instance that stores info for the specified cell template type.
            WjFlexGridCellTemplate._getTemplContextProp = function (templateType) {
                return '$__cellTempl' + CellTemplateType[templateType];
            };
            WjFlexGridCellTemplate.prototype._initControl = function (element) {
                return {};
            };
            WjFlexGridCellTemplate.prototype._createLink = function () {
                return new WjFlexGridCellTemplateLink();
            };
            WjFlexGridCellTemplate.prototype._getMetaDataId = function () {
                return 'FlexGridCellTemplate';
            };
            WjFlexGridCellTemplate._tagName = 'wj-flex-grid-cell-template';
            return WjFlexGridCellTemplate;
        }(angular.WjDirective));
        var WjFlexGridCellTemplateLink = /** @class */ (function (_super) {
            __extends(WjFlexGridCellTemplateLink, _super);
            function WjFlexGridCellTemplateLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            WjFlexGridCellTemplateLink.prototype._initParent = function () {
                _super.prototype._initParent.call(this);
                var cts = this.scope['cellType'], cellType;
                if (cts) {
                    cellType = CellTemplateType[cts];
                }
                else {
                    return;
                }
                // get column template (HTML content)
                var dynaTempl = this.tAttrs[WjFlexGridColumn._colTemplateProp], template = dynaTempl != null ? dynaTempl : angular.WjDirective._removeTransclude(this.tElement[0].innerHTML), control = this.control;
                if (!wijmo.isNullOrWhiteSpace(template)) {
                    control.cellTemplate = template;
                }
                // get column style
                var style = this.tAttrs['ngStyle'], ngClass = this.tAttrs['ngClass'];
                //editorAutoFocus = this.tAttrs['editorAutoFocus'];
                if (style) {
                    control.cellStyle = style;
                }
                if (ngClass) {
                    control.cellClass = ngClass;
                }
                if (!this.tAttrs['forceFullEdit']) {
                    control.forceFullEdit = true;
                }
                //control.editorAutoFocus = editorAutoFocus
                //    ? wijmo.changeType(editorAutoFocus, wijmo.DataType.Boolean, '') :
                //    true;
                if (control.cellTemplate || control.cellStyle || control.cellClass) {
                    control.templLink = this;
                    var parentCtrl = this.parent.control;
                    parentCtrl[WjFlexGridCellTemplate._getTemplContextProp(cellType)] = control;
                    if (parentCtrl instanceof wijmo.grid.Column) {
                        // TBD: set to false when removed
                        parentCtrl._setFlag(wijmo.grid.RowColFlags.HasTemplate, true);
                    }
                }
                WjFlexGridCellTemplateLink._invalidateGrid(this.parent.control);
            };
            WjFlexGridCellTemplateLink.prototype._destroy = function () {
                var parentControl = this.parent && this.parent.control, cts = this.scope['cellType'];
                _super.prototype._destroy.call(this);
                if (cts) {
                    parentControl[WjFlexGridCellTemplate._getTemplContextProp(CellTemplateType[cts])] = undefined;
                    WjFlexGridCellTemplateLink._invalidateGrid(parentControl);
                }
            };
            WjFlexGridCellTemplateLink._invalidateGrid = function (parentControl) {
                var grid = parentControl;
                if (grid) {
                    if (grid instanceof wijmo.grid.Column) {
                        grid = grid.grid;
                    }
                    if (grid) {
                        grid.invalidate();
                    }
                }
            };
            return WjFlexGridCellTemplateLink;
        }(angular.WjLink));
        /**
         * AngularJS directive for the @see:FlexGridFilter object.
         *
         * The <b>wj-flex-grid-filter</b> directive must be contained in a @see:WjFlexGrid directive. For example:
         *
         * <pre>&lt;p&gt;Here is a FlexGrid control with column filters:&lt;/p&gt;
         * &lt;wj-flex-grid items-source="data"&gt;
         *   &lt;wj-flex-grid-filter filter-columns="['country', 'expenses']"&gt;&lt;/wj-flex-grid-filter&gt;
         * &nbsp;
         *   &lt;wj-flex-grid-column
         *     header="Country"
         *     binding="country"&gt;
         *   &lt;/wj-flex-grid-column&gt;
         *   &lt;wj-flex-grid-column
         *     header="Sales"
         *     binding="sales"&gt;
         *   &lt;/wj-flex-grid-column&gt;
         *   &lt;wj-flex-grid-column
         *     header="Expenses"
         *     binding="expenses"&gt;
         *   &lt;/wj-flex-grid-column&gt;
         *   &lt;wj-flex-grid-column
         *     header="Downloads"
         *     binding="downloads"&gt;
         *   &lt;/wj-flex-grid-column&gt;
         *  &lt;/wj-flex-grid&gt;</pre>
         *
         * The <b>wj-flex-grid-filter</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>filter-columns</dt>    <dd><code>=</code> An array containing the names or bindings of the columns
         *                              to filter.</dd>
         *   <dt>show-filter-icons</dt> <dd><code>@</code>  The value indicating whether filter editing buttons
         *                              appear in the grid's column headers.</dd>
         *   <dt>filter-changing</dt>   <dd><code>&</code> Handler for the @see:FlexGridFilter.filterChanging event.</dd>
         *   <dt>filter-changed</dt>    <dd><code>&</code> Handler for the @see:FlexGridFilter.filterChanged event.</dd>
         *   <dt>filter-applied</dt>    <dd><code>&</code> Handler for the @see:FlexGridFilter.filterApplied event.</dd>
         * </dl>
         */
        var WjFlexGridFilter = /** @class */ (function (_super) {
            __extends(WjFlexGridFilter, _super);
            // Initializes a new instance of a WjGridColumn
            function WjFlexGridFilter() {
                var _this = _super.call(this) || this;
                _this.require = '^wjFlexGrid';
                //this.transclude = true;
                _this.template = '<div />';
                return _this;
            }
            Object.defineProperty(WjFlexGridFilter.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.grid.filter.FlexGridFilter;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexGridFilter;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:GroupPanel control.
         *
         * The <b>wj-group-panel</b> directive connects to the <b>FlexGrid</b> control via the <b>grid</b> property.
         * For example:
         *
         * <pre>&lt;p&gt;Here is a FlexGrid control with GroupPanel:&lt;/p&gt;
         * &nbsp;
         * &lt;wj-group-panel grid="flex" placeholder="Drag columns here to create groups."&gt;&lt;/wj-group-panel&gt;
         * &nbsp;
         * &lt;wj-flex-grid control="flex" items-source="data"&gt;
         *   &lt;wj-flex-grid-column
         *     header="Country"
         *     binding="country"&gt;
         *   &lt;/wj-flex-grid-column&gt;
         *   &lt;wj-flex-grid-column
         *     header="Sales"
         *     binding="sales"&gt;
         *   &lt;/wj-flex-grid-column&gt;
         *   &lt;wj-flex-grid-column
         *     header="Expenses"
         *     binding="expenses"&gt;
         *   &lt;/wj-flex-grid-column&gt;
         *   &lt;wj-flex-grid-column
         *     header="Downloads"
         *     binding="downloads"&gt;
         *   &lt;/wj-flex-grid-column&gt;
         * &lt;/wj-flex-grid&gt;</pre>
         *
         * The <b>wj-group-panel</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>grid</dt>                      <dd><code>@</code>The <b>FlexGrid</b> that is connected to this <b>GroupPanel</b>.</dd>
         *   <dt>hide-grouped-columns</dt>      <dd><code>@</code>A value indicating whether the panel hides grouped columns
         *                                      in the owner grid.</dd>
         *   <dt>max-groups</dt>                <dd><code>@</code>The maximum number of groups allowed.</dd>
         *   <dt>placeholder</dt>               <dd><code>@</code>A string to display in the control when it
         *                                      contains no groups.</dd>
         *   <dt>got-focus</dt>                 <dd><code>&</code> Handler for the @see:GroupPanel.gotFocus event.</dd>
         *   <dt>lost-focus</dt>                <dd><code>&</code> Handler for the @see:GroupPanel.lostFocus event.</dd>
         * </dl>
         *
         */
        var WjGroupPanel = /** @class */ (function (_super) {
            __extends(WjGroupPanel, _super);
            function WjGroupPanel() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(WjGroupPanel.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.grid.grouppanel.GroupPanel;
                },
                enumerable: true,
                configurable: true
            });
            return WjGroupPanel;
        }(angular.WjDirective));
        /**
         * AngularJS directive for @see:FlexGrid @see:DetailRow templates.
         *
         * The <b>wj-flex-grid-detail</b> directive must be contained in a
         * <b>wj-flex-grid</b> directive.
         *
         * The <b>wj-flex-grid-detail</b> directive represents a @see:FlexGridDetailProvider
         * object that maintains detail rows visibility, with detail rows content defined as
         * an arbitrary HTML fragment within the directive tag. The fragment may contain
         * AngularJS bindings and directives.
         * In addition to any properties available in a controller, the local <b>$row</b> and
         * <b>$item</b> template variables can be used in AngularJS bindings that refer to
         * the detail row's parent @see:Row and <b>Row.dataItem</b> objects. For example:
         *
         * <pre>&lt;p&gt;Here is a detail row with a nested FlexGrid:&lt;/p&gt;
         * &nbsp;
         * &lt;wj-flex-grid
         *   items-source="categories"&gt;
         *   &lt;wj-flex-grid-column header="Name" binding="CategoryName"&gt;&lt;/wj-flex-grid-column&gt;
         *   &lt;wj-flex-grid-column header="Description" binding="Description" width="*"&gt;&lt;/wj-flex-grid-column&gt;
         *   &lt;wj-flex-grid-detail max-height="250" detail-visibility-mode="detailMode"&gt;
         *     &lt;wj-flex-grid
         *       items-source="getProducts($item.CategoryID)"
         *       headers-visibility="Column"&gt;
         *     &lt;/wj-flex-grid&gt;
         *   &lt;/wj-flex-grid-detail&gt;
         * &lt;/wj-flex-grid&gt;</pre>
         *
         * A reference to a <b>FlexGridDetailProvider</b> object represented by the
         * <b>wj-flex-grid-detail</b> directive can be retrieved in a usual way by binding
         * to the directive's <b>control</b> property. This makes all the API provided by
         * <b>FlexGridDetailProvider</b> available for usage in the template, giving you total
         * control over the user experience. The following example adds a custom show/hide toggle
         * to the Name column cells, and a Hide Detail button to the detail row. These elements call
         * the <b>FlexGridDetailProvider</b>, <b>hideDetail</b> and <b>showDetail</b> methods in
         * their <b>ng-click</b> bindings to implement the custom show/hide logic:
         *
         * <pre>&lt;p&gt;Here is a FlexGrid with custom show/hide detail elements:&lt;/p&gt;
         * &nbsp;
         * &lt;wj-flex-grid
         *   items-source="categories"
         *   headers-visibility="Column"
         *   selection-mode="Row"&gt;
         *   &lt;wj-flex-grid-column header="Name" binding="CategoryName" is-read-only="true" width="200"&gt;
         *     &lt;img ng-show="dp.isDetailVisible($row)" ng-click="dp.hideDetail($row)" src="resources/hide.png" /&gt;
         *     &lt;img ng-hide="dp.isDetailVisible($row)" ng-click="dp.showDetail($row, true)" src="resources/show.png" /&gt;
         *     {&#8203;{$item.CategoryName}}
         *   &lt;/wj-flex-grid-column&gt;
         *   &lt;wj-flex-grid-column header="Description" binding="Description" width="2*"&gt;&lt;/wj-flex-grid-column&gt;
         *   &lt;wj-flex-grid-detail control="dp" detail-visibility-mode="Code"&gt;
         *     &lt;div style="padding:12px;background-color:#cee6f7"&gt;
         *       ID: &lt;b&gt;{&#8203;{$item.CategoryID}}&lt;/b&gt;&lt;br /&gt;
         *       Name: &lt;b&gt;{&#8203;{$item.CategoryName}}&lt;/b&gt;&lt;br /&gt;
         *       Description: &lt;b&gt;{&#8203;{$item.Description}}&lt;/b&gt;&lt;br /&gt;
         *       &lt;button class="btn btn-default" ng-click="dp.hideDetail($row)"&gt;Hide Detail&lt;/button&gt;
         *     &lt;/div&gt;
         *   &lt;/wj-flex-grid-detail&gt;
         * &lt;/wj-flex-grid&gt;</pre>
         *
         * The <b>wj-flex-grid-detail</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>control</dt>                <dd><code>=</code> A reference to the @see:FlexGridDetailProvider object
         *                                   created by this directive.</dd>
         *   <dt>detail-visibility-mode</dt> <dd><code>@</code>A @see:DetailVisibilityMode value that determines when
         *                                   to display the row details.</dd>
         *   <dt>max-height</dt>             <dd><code>@</code>The maximum height of the detail rows, in pixels.</dd>
         *   <dt>row-has-detail</dt>         <dd><code>=</code>The callback function that determines whether a row
         *                                       has details.</dd>
         * </dl>
         *
         */
        var WjFlexGridDetail = /** @class */ (function (_super) {
            __extends(WjFlexGridDetail, _super);
            function WjFlexGridDetail($compile) {
                var _this = _super.call(this) || this;
                _this._$compile = $compile;
                _this.require = '^wjFlexGrid';
                // The same approach like in WjFlexGridColumn
                _this['terminal'] = true;
                if (angular.WjDirective._dynaTemplates) {
                    _this.transclude = false;
                    _this['priority'] = 100;
                    _this.template = function (tElement, tAttrs) {
                        tAttrs[WjFlexGridDetail._detailTemplateProp] = tElement[0].innerHTML;
                        return '<div />';
                    };
                }
                else {
                    _this.transclude = true;
                    _this.template = '<div ng-transclude/>';
                }
                return _this;
            }
            Object.defineProperty(WjFlexGridDetail.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.grid.detail.FlexGridDetailProvider;
                },
                enumerable: true,
                configurable: true
            });
            WjFlexGridDetail.prototype._createLink = function () {
                return new WjFlexGridDetailLink();
            };
            WjFlexGridDetail._detailTemplateProp = '$__wjDetailTemplate';
            WjFlexGridDetail._detailScopeProp = '$_detailScope';
            return WjFlexGridDetail;
        }(angular.WjDirective));
        var WjFlexGridDetailLink = /** @class */ (function (_super) {
            __extends(WjFlexGridDetailLink, _super);
            function WjFlexGridDetailLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            WjFlexGridDetailLink.prototype._initParent = function () {
                _super.prototype._initParent.call(this);
                // get column template (HTML content)
                var self = this, dynaTempl = this.tAttrs[WjFlexGridDetail._detailTemplateProp], dp = this.control;
                this.itemTemplate = this._getCellTemplate(dynaTempl != null ? dynaTempl :
                    angular.WjDirective._removeTransclude(this.tElement[0].innerHTML));
                var tpl = this._getCellTemplate(this.itemTemplate);
                this._tmplLink = this.directive._$compile('<div>' + tpl + '</div>');
                // show detail when asked to
                dp.createDetailCell = function (row, col) {
                    // create detail row scope and link it
                    var cellScope = self._getCellScope(self.scope.$parent, row, col), clonedElement = self._tmplLink(cellScope, function (clonedEl, scope) { })[0];
                    clonedElement[angular.WjDirective._elemScopeProp] = cellScope;
                    // add the linked tree to the DOM tree, in order to get correct height in FlexGridDetailProvider's formatItem
                    dp.grid.hostElement.appendChild(clonedElement);
                    // apply the cell scope
                    if (cellScope.$root && !cellScope.$root.$$phase) {
                        cellScope.$apply();
                    }
                    // remove cell element from the DOM tree and return it to caller
                    clonedElement.parentElement.removeChild(clonedElement);
                    return clonedElement;
                };
                // dispose detail scope when asked to
                dp.disposeDetailCell = function (row) {
                    if (row.detail) {
                        // can't use scope() with disabled debugging
                        //window['angular'].element(row.detail).scope().$destroy();
                        var scope = row.detail[angular.WjDirective._elemScopeProp];
                        if (scope) {
                            scope.$destroy();
                        }
                    }
                };
                if (this.parent._isInitialized && this.control) {
                    this.control.invalidate();
                }
            };
            WjFlexGridDetailLink.prototype._destroy = function () {
                var ownerControl = this.parent && this.parent.control, dp = this.control;
                dp.createDetailCell = null;
                dp.disposeDetailCell = null;
                _super.prototype._destroy.call(this);
                this._tmplLink = null;
                if (ownerControl) {
                    ownerControl.invalidate();
                }
            };
            // helper functions
            WjFlexGridDetailLink.prototype._getCellScope = function (parentScope, row, col) {
                var ret = parentScope.$new();
                ret.$row = row;
                ret.$col = col;
                ret.$item = row.dataItem;
                return ret;
            };
            WjFlexGridDetailLink.prototype._getCellTemplate = function (tpl) {
                if (tpl) {
                    tpl = tpl.replace(/ng\-style/g, 'style');
                    tpl = tpl.replace(/ class\=\"ng\-scope\"( \"ng\-binding\")?/g, '');
                    tpl = tpl.replace(/<span>\s*<\/span>/g, '');
                }
                return tpl;
            };
            return WjFlexGridDetailLink;
        }(angular.WjLink));
        /**
         * AngularJS directive for the @see:FlexSheet control.
         *
         * Use the <b>wj-flex-sheet</b> directive to add <b>FlexSheet</b> controls to your AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;p&gt;Here is a FlexSheet control with one bound and two unbound sheets:&lt;/p&gt;
         * &lt;wj-flex-sheet&gt;
         *    &lt;wj-sheet name="Country" items-source="ctx.data"&gt;&lt;/wj-sheet&gt;
         *    &lt;wj-sheet name="Report" row-count="25" column-count="13"&gt;&lt;/wj-sheet&gt;
         *    &lt;wj-sheet name="Formulas" row-count="310" column-count="10"&gt;&lt;/wj-sheet&gt;
         * &lt;/wj-flex-sheet&gt;</pre>
         *
         * The <b>wj-flex-sheet</b> directive extends @see:WjFlexGrid with the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>control</dt>                   <dd><code>=</code> A reference to the @see:FlexSheet control created by this directive.</dd>
         *   <dt>is-tab-holder-visible</dt>     <dd><code>@</code> A value indicating whether the sheet tabs holder is visible. </dd>
         *   <dt>selected-sheet-index</dt>      <dd><code>=</code> Gets or sets the index of the current sheet in the @see:FlexSheet. </dd>
         *   <dt>dragging-row-column</dt>       <dd><code>&</code> Handler for the @see:FlexSheet.draggingRowColumn event.</dd>
         *   <dt>dropping-row-column</dt>       <dd><code>&</code> Handler for the @see:FlexSheet.droppingRowColumn event.</dd>
         *   <dt>selected-sheet-changed</dt>    <dd><code>&</code> Handler for the @see:FlexSheet.selectedSheetChanged event.</dd>
         * </dl>
         *
         * The <b>wj-flex-sheet</b> directive may contain @see:WjSheet child directives.
         */
        var WjFlexSheet = /** @class */ (function (_super) {
            __extends(WjFlexSheet, _super);
            function WjFlexSheet($compile, $interpolate) {
                return _super.call(this, $compile, $interpolate) || this;
            }
            Object.defineProperty(WjFlexSheet.prototype, "_controlConstructor", {
                // Gets the Wijmo FlexSheet control constructor
                get: function () {
                    return wijmo.grid.sheet.FlexSheet;
                },
                enumerable: true,
                configurable: true
            });
            return WjFlexSheet;
        }(WjFlexGrid));
        /**
         * AngularJS directive for the @see:Sheet object.
         *
         * The <b>wj-sheet</b> directive must be contained in a @see:WjFlexSheet directive.
         * It supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>name</dt>               <dd><code>@</code> The name of the sheet.
         *   <dt>row-count</dt>          <dd><code>@</code> The initial number of rows in the unbound sheet.
         *                               Changes done to this attribute have no effect after the @see:Sheet was initialized by AngularJS.
         *   <dt>column-count</dt>       <dd><code>@</code> The initial number of columns in the unbound sheet.
         *                               Changes done to this attribute have no effect after the @see:Sheet was initialized by AngularJS.
         *   <dt>items-source</dt>       <dd><code>=</code> The data source for the data bound sheet.
         *                               Changes done to this attribute have no effect after the @see:Sheet was initialized by AngularJS.
         *   <dt>visible</dt>            <dd><code>@</code> A value indicating whether the sheet is visible.
         *   <dt>name-changed</dt>       <dd><code>&</code> Handler for the @see:Sheet.nameChanged event.</dd>
         * </dl>
         */
        var WjSheet = /** @class */ (function (_super) {
            __extends(WjSheet, _super);
            function WjSheet() {
                var _this = _super.call(this) || this;
                _this.require = '^wjFlexSheet';
                return _this;
            }
            Object.defineProperty(WjSheet.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.grid.sheet.Sheet;
                },
                enumerable: true,
                configurable: true
            });
            WjSheet.prototype._createLink = function () {
                return new WjSheetLink();
            };
            return WjSheet;
        }(angular.WjDirective));
        var WjSheetLink = /** @class */ (function (_super) {
            __extends(WjSheetLink, _super);
            function WjSheetLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            WjSheetLink.prototype._initControl = function () {
                var sheet = _super.prototype._initControl.call(this), scope = this.scope, flexSheet = this.parent.control;
                sheet.name = scope['name'];
                if (scope['itemsSource']) {
                    sheet.itemsSource = scope['itemsSource'];
                }
                else {
                    sheet.rowCount = +scope['rowCount'];
                    sheet.columnCount = +scope['columnCount'];
                }
                flexSheet.sheets.push(sheet);
                sheet.selectionRanges.push(flexSheet.selection);
                return sheet;
            };
            return WjSheetLink;
        }(angular.WjLink));
        /**
         * AngularJS directive for the @see:MultiRow control.
         *
         * Use the <b>wj-multi-row</b> directive to add <b>MultiRow</b> controls to your AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case.
         *
         * The <b>wj-multi-row</b> directive extends @see:WjFlexGrid with the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>control</dt>                    <dd><code>=</code> A reference to the @see:MultiRow control created by this directive.</dd>
         *   <dt>layout-definition</dt>          <dd><code>@</code> A value defines the layout of the rows used to display each data item.</dd>
         *   <dt>collapsed-headers</dt>          <dd><code>@</code> Gets or sets a value that determines whether column headers should be
         *                                       collapsed and displayed as a single row displaying the group headers.</dd>
         *   <dt>center-headers-vertically</dt>  <dd><code>@</code> Gets or sets a value that determines whether the content of cells
         *                                       that span multiple rows should be vertically centered.</dd>
         *   <dt>show-header-collapse-button</dt><dd><code>@</code> Gets or sets a value that determines whether the grid should
         *                                       display a button in the column header panel to allow users to collapse and expand the column headers.</dd>
         * </dl>
         */
        var WjMultiRow = /** @class */ (function (_super) {
            __extends(WjMultiRow, _super);
            function WjMultiRow($compile, $interpolate) {
                return _super.call(this, $compile, $interpolate) || this;
            }
            Object.defineProperty(WjMultiRow.prototype, "_controlConstructor", {
                // Gets the Wijmo MultiRow control constructor
                get: function () {
                    return wijmo.grid.multirow.MultiRow;
                },
                enumerable: true,
                configurable: true
            });
            return WjMultiRow;
        }(WjFlexGrid));
        //#endregion "Grid directives classes"
    })(angular = wijmo.angular || (wijmo.angular = {}));
})(wijmo || (wijmo = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
//
// AngularJS directives for wijmo.olap module
//
var wijmo;
(function (wijmo) {
    var angular;
    (function (angular) {
        var wijmoOlap = window['angular'].module('wj.olap', ['wj.grid', 'wj.chart']);
        // register only if module is loaded
        if (wijmo.olap && wijmo.olap.PivotGrid) {
            wijmoOlap.directive('wjPivotGrid', ['$compile', '$interpolate', function ($compile, $interpolate) {
                    return new WjPivotGrid($compile, $interpolate);
                }]);
            wijmoOlap.directive('wjPivotChart', [function () {
                    return new WjPivotChart();
                }]);
            wijmoOlap.directive('wjPivotPanel', [function () {
                    return new WjPivotPanel();
                }]);
            //wijmoOlap.directive('wjPivotField', [function () {
            //    return new WjPivotField();
            //}]);
        }
        /**
         * AngularJS directive for the @see:PivotGrid control.
         *
         * Use the <b>wj-pivot-grid</b> and <b>wj-pivot-panel</b> directives
         * to add pivot tables to your AngularJS applications.
         *
         * Directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;wj-pivot-panel
         *     control="thePanel"
         *     items-source="rawData"&gt;
         * &lt;/wj-pivot-panel&gt;
         * &lt;wj-pivot-grid
         *     items-source="thePanel"
         *     show-detail-on-double-click="false"
         *     custom-context-menu="true"&gt;
         * &lt;/wj-pivot-grid&gt;</pre>
         *
         * The <b>wj-pivot-grid</b> directive extends the <b>wj-flex-grid</b> directive
         * and adds support for the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>items-source</dt>                  <dd>Gets or sets the @see:PivotPanel that defines the view
         *                                              displayed by this @see:PivotGrid.</dd>
         *   <dt>show-detail-on-double-click</dt>   <dd>Gets or sets whether the grid should show a popup containing the
         *                                              detail records when the user double-clicks a cell.</dd>
         *   <dt>custom-context-menu</dt>           <dd>Gets or sets whether the grid should provide a custom context menu
         *                                              with commands for changing field settings and showing detail records.</dd>
         *   <dt>collapsible-subtotals</dt>         <dd>Gets or sets whether the grid should allow users to collapse and
         *                                              expand subtotal groups of rows and columns.</dd>
         *   <dt>center-headers-vertically</dt>     <dd>Gets or sets whether the content of header cells should be vertically centered.</dd>
         * </dl>
         */
        var WjPivotGrid = /** @class */ (function (_super) {
            __extends(WjPivotGrid, _super);
            function WjPivotGrid($compile, $interpolate) {
                return _super.call(this, $compile, $interpolate) || this;
            }
            Object.defineProperty(WjPivotGrid.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.olap.PivotGrid;
                },
                enumerable: true,
                configurable: true
            });
            return WjPivotGrid;
        }(angular.WjFlexGrid));
        angular.WjPivotGrid = WjPivotGrid;
        /**
         * AngularJS directive for the @see:PivotChart control.
         *
         * Use the <b>wj-pivot-chart</b> and <b>wj-pivot-panel</b> directives
         * to add pivot charts to your AngularJS applications.
         *
         * Directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;wj-pivot-panel
         *     control="thePanel"
         *     items-source="rawData"&gt;
         * &lt;/wj-pivot-panel&gt;
         * &lt;wj-pivot-chart
         *     items-source="thePanel"
         *     chart-type="Bar"
         *     max-series="10"
         *     max-points="100"&gt;
         * &lt;/wj-pivot-chart&gt;</pre>
         *
         * The <b>wj-pivot-chart</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>items-source</dt>                  <dd>Gets or sets the @see:PivotPanel that defines the view
         *                                              displayed by this @see:PivotChart.</dd>
         *   <dt>chart-type</dt>                    <dd>Gets or sets a @see:PivotChartType value that defines
         *                                              the type of chart to display.</dd>
         *   <dt>show-hierarchical-axes</dt>        <dd>Gets or sets whether the chart should group axis annotations for grouped data.</dd>
         *   <dt>stacking</dt>                      <dd>Gets or sets a @see:Stacking value that determines whether and how the series
         *                                              objects are stacked.</dd>
         *   <dt>show-totals</dt>                   <dd>Gets or sets a whether the chart should include only totals.</dd>
         *   <dt>max-series</dt>                    <dd>Gets or sets the maximum number of data series to be shown in the chart.</dd>
         *   <dt>max-points</dt>                    <dd>Gets or sets the maximum number of points to be shown in each series.</dd>
         * </dl>
         */
        var WjPivotChart = /** @class */ (function (_super) {
            __extends(WjPivotChart, _super);
            function WjPivotChart() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(WjPivotChart.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.olap.PivotChart;
                },
                enumerable: true,
                configurable: true
            });
            return WjPivotChart;
        }(angular.WjDirective));
        angular.WjPivotChart = WjPivotChart;
        /**
         * AngularJS directive for the @see:PivotPanel control.
         *
         * Use the <b>wj-pivot-panel</b> directive as a data source for
         * <b>wj-pivot-grid</b> and <b>wj-pivot-chart</b> directives
         * to add pivot tables and charts to your AngularJS applications.
         *
         * Directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;wj-pivot-panel
         *     control="thePanel"
         *     items-source="rawData"&gt;
         * &lt;/wj-pivot-panel&gt;
         * &lt;wj-pivot-grid
         *     items-source="thePanel"
         *     show-detail-on-double-click="false"
         *     custom-context-menu="true"&gt;
         * &lt;/wj-pivot-grid&gt;</pre>
         *
         * The <b>wj-pivot-panel</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>items-source</dt>                  <dd>Gets or sets the raw data used to generate pivot views.</dd>
         *   <dt>auto-generate-fields</dt>          <dd>Gets or sets whether the panel should populate its fields
         *                                              collection automatically based on the @see:PivotPanel.itemsSource.</dd>
         *   <dt>view-definition</dt>               <dd>Gets or sets the current pivot view definition as a JSON string.</dd>
         *   <dt>engine</dt>                        <dd>Gets a reference to the @see:PivotEngine that summarizes the data.</dd>
         * </dl>
         */
        var WjPivotPanel = /** @class */ (function (_super) {
            __extends(WjPivotPanel, _super);
            function WjPivotPanel() {
                var _this = _super.call(this) || this;
                _this.transclude = true;
                _this.template = '<div ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjPivotPanel.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.olap.PivotPanel;
                },
                enumerable: true,
                configurable: true
            });
            return WjPivotPanel;
        }(angular.WjDirective));
        angular.WjPivotPanel = WjPivotPanel;
        //export class WjPivotField extends WjDirective {
        //    constructor() {
        //        super();
        //        this.require = '^wjPivotPanel';
        //        this.template = '<div />';
        //    }
        //    get _controlConstructor() {
        //        return wijmo.olap.PivotField;
        //    }
        //    _initControl(element: any): any {
        //        // 'element' is a parent PivotPanel here
        //        return new wijmo.olap.PivotField(<wijmo.olap.PivotEngine>(<wijmo.olap.PivotPanel>element).engine, '');
        //    }
        //}
    })(angular = wijmo.angular || (wijmo.angular = {}));
})(wijmo || (wijmo = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
//
// AngularJS directives for wijmo.viewer module
//
var wijmo;
(function (wijmo) {
    var angular;
    (function (angular) {
        //#region "Viewer directives registration"
        var wijmoViewer = window['angular'].module('wj.viewer', []);
        // register only if module is loaded
        if (wijmo.viewer && wijmo.viewer.ReportViewer) {
            wijmoViewer.directive('wjReportViewer', [function () {
                    return new WjReportViewer();
                }]);
        }
        if (wijmo.viewer && wijmo.viewer.PdfViewer) {
            wijmoViewer.directive('wjPdfViewer', [function () {
                    return new WjPdfViewer();
                }]);
        }
        //#endregion "ReportViewer directives definitions"
        //#region "ReportViewer directives classes"
        // Viewer control directive
        // Provides base setup for all directives related to controls derived from ViewerBase
        // Abstract class, not for use in markup
        var WjViewerBase = /** @class */ (function (_super) {
            __extends(WjViewerBase, _super);
            // Creates a new instance of a WjViewerBase
            function WjViewerBase() {
                var _this = _super.call(this) || this;
                _this.template = '<div ng-transclude />';
                _this.transclude = true;
                return _this;
            }
            Object.defineProperty(WjViewerBase.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.viewer.ViewerBase;
                },
                enumerable: true,
                configurable: true
            });
            return WjViewerBase;
        }(angular.WjDirective));
        /**
         * AngularJS directive for the @see:ReportViewer control.
         *
         * Use the <b>wj-report-viewer</b> directive to add report viewer to your AngularJS applications.
         * Note that directive and parameter names must be formatted in lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;wj-report-viewer paginated="true"
         *   service-url="ctx.serviceUrl"
         *   file-path="ctx.path"
         *   report-name="ctx.reportName"&gt;
         * &lt;/wj-report-viewer;</pre>
         *
         * The <b>wj-report-viewer</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>service-url</dt>  <dd><code>@</code>A value indicating the address of C1 Web API service. </dd>
         *   <dt>file-path</dt>  <dd><code>@</code> A value indicating full path to the document on the server.</dd>
         *   <dt>report-name</dt>   <dd><code>@</code> For FlexReport, sets it with the
         *                          report name defined in the FlexReport definition file.
         *                          For SSRS report, please leave it as empty string. </dd>
         *   <dt>control</dt>       <dd><code>=</code> A reference to the @see:ReportViewer
         *                          control created by this directive. </dd>
         *   <dt>full-screen</dt>   <dd><code>@</code> A value indicating whether viewer is under full screen mode. </dd>
         *   <dt>zoom-factor</dt>   <dd><code>@</code> A value indicating the current zoom factor to
         *                           show the document pages </dd>
         *   <dt>mouse-mode</dt>  <dd><code>@</code> A value indicating the mouse behavior.</dd>
         *   <dt>initialized</dt>   <dd><code>&</code> This event occurs after the binding has finished
         *                          initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt> <dd><code>=</code> A value indicating whether the binding has finished
         *                           initializing the control with attribute values. </dd>
         *   <dt>view-mode</dt>   <dd><code>@</code> A value indicating how to show the document pages. </dd>
         *   <dt>paginated</dt>    <dd><code>@</code> A value indicating whether the content should
         *                          be represented as set of fixed sized pages.</dd>
         *   <dt>page-index-changed</dt>     <dd><code>&</code> The @see:ReportViewer.pageIndexChanged event handler.</dd>
         *   <dt>view-mode-changed</dt>    <dd><code>&</code> The @see:ReportViewer.viewModeChanged event handler.</dd>
         *   <dt>mouse-mode-changed</dt>    <dd><code>&</code> The @see:ReportViewer.mouseModeChanged event handler.</dd>
         *   <dt>full-screen-changed</dt>    <dd><code>&</code> The @see:ReportViewer.fullScreenChanged event handler.</dd>
         *   <dt>zoom-factor-changed</dt>    <dd><code>&</code> The @see:ReportViewer.zoomFactorChanged event handler.</dd>
         *   <dt>query-loading-data</dt>    <dd><code>&</code> The @see:ReportViewer.queryLoadingData event handler.</dd>
         * </dl>
         */
        var WjReportViewer = /** @class */ (function (_super) {
            __extends(WjReportViewer, _super);
            // Initializes a new instance of a WjReportViewer
            function WjReportViewer() {
                return _super.call(this) || this;
            }
            Object.defineProperty(WjReportViewer.prototype, "_controlConstructor", {
                // gets the Wijmo ReportViewer control constructor
                get: function () {
                    return wijmo.viewer.ReportViewer;
                },
                enumerable: true,
                configurable: true
            });
            return WjReportViewer;
        }(WjViewerBase));
        /**
         * AngularJS directive for the @see:PdfViewer control.
         *
         * Use the <b>wj-pdf-viewer</b> directive to add pdf viewer to your AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;wj-pdf-viewer  paginated="false"
         *   service-url="ctx.serviceUrl"
         *   file-path="ctx.path"
         *   report-name="ctx.reportName"&gt;
         * &lt;/wj-pdf-viewer;</pre>
         *
         * The <b>wj-pdf-viewer</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>service-url</dt>  <dd><code>@</code>A value indicating the address of C1 Web API service. </dd>
         *   <dt>file-path</dt>  <dd><code>@</code> A value indicating full path to the document on the server.</dd>
         *   <dt>control</dt>       <dd><code>=</code> A reference to the @see:PdfViewer
         *                          control created by this directive. </dd>
         *   <dt>full-screen</dt>   <dd><code>@</code> A value indicating whether viewer is under full screen mode. </dd>
         *   <dt>zoom-factor</dt>   <dd><code>@</code> A value indicating the current zoom factor to
         *                           show the document pages </dd>
         *   <dt>mouse-mode</dt>  <dd><code>@</code>  A value indicating the mouse behavior.</dd>
         *   <dt>initialized</dt>   <dd><code>&</code> This event occurs after the binding has finished
         *                          initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt> <dd><code>=</code> A value indicating whether the binding has finished
         *                           initializing the control with attribute values. </dd>
         *   <dt>view-mode</dt>   <dd><code>@</code> A value indicating how to show the document pages. </dd>
         *   <dt>page-index-changed</dt>     <dd><code>&</code> The @see:PdfViewer.pageIndexChanged event handler.</dd>
         *   <dt>view-mode-changed</dt>    <dd><code>&</code> The @see:PdfViewer.viewModeChanged event handler.</dd>
         *   <dt>mouse-mode-changed</dt>    <dd><code>&</code> The @see:PdfViewer.mouseModeChanged event handler.</dd>
         *   <dt>full-screen-changed</dt>    <dd><code>&</code> The @see:PdfViewer.fullScreenChanged event handler.</dd>
         *   <dt>zoom-factor-changed</dt>    <dd><code>&</code> The @see:PdfViewer.zoomFactorChanged event handler.</dd>
         *   <dt>query-loading-data</dt>    <dd><code>&</code> The @see:PdfViewer.queryLoadingData event handler.</dd>
         * </dl>
         */
        var WjPdfViewer = /** @class */ (function (_super) {
            __extends(WjPdfViewer, _super);
            // Initializes a new instance of a WjPdfViewer
            function WjPdfViewer() {
                return _super.call(this) || this;
            }
            Object.defineProperty(WjPdfViewer.prototype, "_controlConstructor", {
                // gets the Wijmo PdfViewer control constructor
                get: function () {
                    return wijmo.viewer.PdfViewer;
                },
                enumerable: true,
                configurable: true
            });
            return WjPdfViewer;
        }(WjViewerBase));
        //#endregion "Viewer directives classes"
    })(angular = wijmo.angular || (wijmo.angular = {}));
})(wijmo || (wijmo = {}));

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
//
// AngularJS directives for wijmo.nav module
//
var wijmo;
(function (wijmo) {
    var angular;
    (function (angular) {
        //#region "TreeView directives registration"
        var wijmoViewer = window['angular'].module('wj.nav', []);
        // register only if module is loaded
        if (wijmo.nav && wijmo.nav.TreeView) {
            wijmoViewer.directive('wjTreeView', [function () {
                    return new WjTreeView();
                }]);
        }
        //#endregion "Nav directives definitions"
        //#region "TreeView directives classes"
        /**
         * AngularJS directive for the @see:TreeView control.
         *
         * Use the <b>wj-tree-view</b> directive to add TreeView to your AngularJS applications.
         * Note that directive and parameter names must be formatted as lower-case with dashes
         * instead of camel-case. For example:
         *
         * <pre>&lt;wj-tree-view  items-source="items"
         *   display-member-path="ctx.displayMemberPath"
         *   child-items-path="ctx.childItemsPath"
         *   is-animated="ctx.isAnimated"&gt;
         * &lt;wj-tree-view;</pre>
         *
         * The <b>wj-tree-view</b> directive supports the following attributes:
         *
         * <dl class="dl-horizontal">
         *   <dt>items-source</dt>          <dd><code>=</code>An array that contains the @see:TreeView items. </dd>
         *   <dt>child-items-path</dt>      <dd><code>@</code> A value indicating the name of the property (or properties)
         *                                  that contains the child items for each node.</dd>
         *   <dt>control</dt>               <dd><code>=</code> A reference to the @see:TreeView
         *                                  control created by this directive. </dd>
         *   <dt>display-member-path</dt>   <dd><code>@</code> A value indicating the name of the property (or properties)
         *                                  to use as the visual representation of the nodes. </dd>
         *   <dt>image-member-path</dt>     <dd><code>@</code> A value indicating the name of the property (or properties) to
         *                                  use as a source of images for the nodes. </dd>
         *   <dt>is-content-html</dt>       <dd><code>@</code> A value indicating whether whether items
         *                                  are bound to plain text or HTML. </dd>
         *   <dt>initialized</dt>           <dd><code>&</code> This event occurs after the binding has finished
         *                                  initializing the control with attribute values.</dd>
         *   <dt>is-initialized</dt>        <dd><code>=</code> A value indicating whether the binding has finished
         *                                  initializing the control with attribute values. </dd>
         *   <dt>show-checkboxes</dt>       <dd><code>@</code> A value determines whether the @see:TreeView should
         *                                  add checkboxes to nodes and manage their state.</dd>
         *   <dt>auto-collapse</dt>         <dd><code>@</code> A value determines if sibling nodes should be collapsed
         *                                  when a node is expanded.</dd>
         *   <dt>is-animated</dt>           <dd><code>@</code> A value indicating whether to use animations when expanding
         *                                  or collapsing nodes.</dd>
         *   <dt>is-readOnly</dt>           <dd><code>@</code> A value determines whether users can edit the text in the
         *                                  nodes.</dd>
         *   <dt>allow-dragging</dt>        <dd><code>@</code> A value determines whether users can drag and drop nodes
         *                                  within the @see:TreeView.</dd>
         *   <dt>expand-on-click</dt>       <dd><code>@</code> A value determines whether to expand collapsed nodes when
         *                                  the user clicks the node header.</dd>
         *   <dt>selected-item</dt>         <dd><code>@</code> A value indicating the data item that is currently
         *                                  selected.</dd>
         *   <dt>selected-node</dt>         <dd><code>@</code> A value indicating @see:TreeNode that is currently
         *                                  selected.</dd>
         *   <dt>checked-items</dt>         <dd><code>@</code> An array containing the items that are currently
         *                                  checked.</dd>
         *   <dt>lazy-load-function</dt>   <dd><code>=</code> A function that loads child nodes on demand.</dd>
         *   <dt>items-source-changed</dt>  <dd><code>&</code> The @see:TreeView.itemsSourceChanged event handler.</dd>
         *   <dt>loading-items</dt>         <dd><code>&</code> The @see:TreeView.loadingItems event handler.</dd>
         *   <dt>loaded-items</dt>          <dd><code>&</code> The @see:TreeView.loadedItems event handler.</dd>
         *   <dt>item-clicked</dt>          <dd><code>&</code> The @see:TreeView.itemClicked event handler.</dd>
         *   <dt>selected-item-changed</dt> <dd><code>&</code> The @see:TreeView.selectedItemChanged event handler.</dd>
         *   <dt>checked-items-Changed</dt> <dd><code>&</code> The @see:TreeView.checkedItemsChanged event handler.</dd>
         *   <dt>is-collapsed-changing</dt> <dd><code>&</code> The @see:TreeView.isCollapsedChanging event handler.</dd>
         *   <dt>is-collapsed-changed</dt>  <dd><code>&</code> The @see:TreeView.isCollapsedChanged event handler.</dd>
         *   <dt>is-checked-changing</dt>   <dd><code>&</code> The @see:TreeView.isCheckedChanging event handler.</dd>
         *   <dt>is-checked-changed</dt>    <dd><code>&</code> The @see:TreeView.isCheckedChanged event handler.</dd>
         *   <dt>format-item</dt>           <dd><code>&</code> The @see:TreeView.formatItem event handler.</dd>
         *   <dt>drag-start</dt>            <dd><code>&</code> The @see:TreeView.dragStart event handler.</dd>
         *   <dt>drag-over</dt>             <dd><code>&</code> The @see:TreeView.dragOver event handler.</dd>
         *   <dt>drop</dt>                  <dd><code>&</code> The @see:TreeView.drop event handler.</dd>
         *   <dt>drag-end</dt>              <dd><code>&</code> The @see:TreeView.dragEnd event handler.</dd>
         *   <dt>node-edit-starting</dt>    <dd><code>&</code> The @see:TreeView.nodeEditStarting event handler.</dd>
         *   <dt>node-edit-started</dt>     <dd><code>&</code> The @see:TreeView.nodeEditStarted event handler.</dd>
         *   <dt>node-edit-ending</dt>      <dd><code>&</code> The @see:TreeView.nodeEditEnding event handler.</dd>
         *   <dt>node-edit-ended</dt>       <dd><code>&</code> The @see:TreeView.nodeEditEnded event handler.</dd>
         * </dl>
         */
        var WjTreeView = /** @class */ (function (_super) {
            __extends(WjTreeView, _super);
            function WjTreeView() {
                var _this = _super.call(this) || this;
                _this.transclude = true;
                _this.template = '<div ng-transclude />';
                return _this;
            }
            Object.defineProperty(WjTreeView.prototype, "_controlConstructor", {
                get: function () {
                    return wijmo.nav.TreeView;
                },
                enumerable: true,
                configurable: true
            });
            return WjTreeView;
        }(angular.WjDirective));
        //#endregion "TreeView directives classes"
    })(angular = wijmo.angular || (wijmo.angular = {}));
})(wijmo || (wijmo = {}));

/**
 * Contains AngularJS directives for the Wijmo controls.
 *
 * The directives allow you to add Wijmo controls to
 * <a href="https://angularjs.org/" target="_blank">AngularJS</a>
 * applications using simple markup in HTML pages.
 *
 * You can use directives as regular HTML tags in the page markup. The
 * tag name corresponds to the control name, prefixed with "wj-," and the
 * attributes correspond to the names of control properties and events.
 *
 * All control, property, and event names within directives follow
 * the usual AngularJS convention of replacing camel-casing with hyphenated
 * lower-case names.
 *
 * AngularJS directive parameters come in three flavors, depending on the
 * type of binding they use. The table below describes each one:
 *
 * <dl class="dl-horizontal">
 *   <dt><code>@</code></dt>   <dd>By value, or one-way binding. The attribute
 *                             value is interpreted as a literal.</dd>
 *   <dt><code>=</code></dt>   <dd>By reference, or two-way binding. The
 *                             attribute value is interpreted as an expression.</dd>
 *   <dt><code>&</code></dt>   <dd>Function binding. The attribute value
 *                             is interpreted as a function call, including the parameters.</dd>
 * </dl>
 *
 * For more details on the different binding types, please see <a href=
 * "http://weblogs.asp.net/dwahlin/creating-custom-angularjs-directives-part-2-isolate-scope"
 * target="_blank"> Dan Wahlin's blog on directives</a>.
 *
 * The documentation does not describe directive events because they are identical to
 * the control events, and the binding mode is always the same (function binding).
 *
 * To illustrate, here is the markup used to create a @see:ComboBox control:
 *
 * <pre>&lt;wj-combo-box
 *   text="ctx.theCountry"
 *   items-source="ctx.countries"
 *   is-editable="true"
 *   selected-index-changed="ctx.selChanged(s, e)"&gt;
 * &lt;/wj-combo-box&gt;</pre>
 *
 * Notice that the <b>text</b> property of the @see:ComboBox is bound to a controller
 * variable called "ctx.theCountry." The binding goes two ways; changes in the control
 * update the scope, and changes in the scope update the control. To
 * initialize the <b>text</b> property with a string constant, enclose
 * the attribute value in single quotes (for example, <code>text="'constant'"</code>).
 *
 * Notice also that the <b>selected-index-changed</b> event is bound to a controller
 * method called "selChanged," and that the binding includes the two event parameters
 * (without the parameters, the method is not called).
 * Whenever the control raises the event, the directive invokes the controller method.
 *
 * All Wijmo Angular directives include an "initialized" event that is
 * raised after the control has been added to the page and initialized.
 * You can use this event to perform additional initialization in addition
 * to setting properties in markup. For example:
 *
 * <pre>&lt;wj-flex-grid initialized="initGrid(s,e)"&gt;
 * &lt;/wj-flex-grid&gt;</pre>
 *
 * <pre>// controller
 * $scope.initGrid: function(s, e) {
 *
 *   // assign a custom MergeManager to the grid
 *   s.mergeManager = new CustomMergeManager(s);
 *
 * }</pre>
 */
var wijmo;
(function (wijmo) {
    var angular;
    (function (angular) {
        // define the wijmo module with all dependencies
        var wijModule = window['angular'].module('wj', ['wj.input', 'wj.grid', 'wj.chart', 'wj.container', 'wj.gauge',
            'wj.olap', 'wj.viewer', 'wj.nav']);
    })(angular = wijmo.angular || (wijmo.angular = {}));
})(wijmo || (wijmo = {}));


//! moment.js

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCa = moment.defineLocale('fr-ca', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    return frCa;

})));

//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enCa = moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;

})));

//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));

//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enAu = moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;

})));

//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));

//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ptBr = moment.defineLocale('pt-br', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'poucos segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return ptBr;

})));

//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

})));

// Copyright (c) Microsoft Open Technologies, Inc. All rights reserved. See License.txt in the project root for license information.

;(function (undefined) {

  var objectTypes = {
    'boolean': false,
    'function': true,
    'object': true,
    'number': false,
    'string': false,
    'undefined': false
  };

  var root = (objectTypes[typeof window] && window) || this,
    freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports,
    freeModule = objectTypes[typeof module] && module && !module.nodeType && module,
    moduleExports = freeModule && freeModule.exports === freeExports && freeExports,
    freeGlobal = objectTypes[typeof global] && global;
  
  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal)) {
    root = freeGlobal;
  }

  var Rx = { 
      internals: {}, 
      config: {
        Promise: root.Promise // Detect if promise exists
      },
      helpers: { }
  };
    
  // Defaults
  var noop = Rx.helpers.noop = function () { },
    identity = Rx.helpers.identity = function (x) { return x; },
    pluck = Rx.helpers.pluck = function (property) { return function (x) { return x[property]; }; },
    just = Rx.helpers.just = function (value) { return function () { return value; }; },    
    defaultNow = Rx.helpers.defaultNow = Date.now,
    defaultComparer = Rx.helpers.defaultComparer = function (x, y) { return isEqual(x, y); },
    defaultSubComparer = Rx.helpers.defaultSubComparer = function (x, y) { return x > y ? 1 : (x < y ? -1 : 0); },
    defaultKeySerializer = Rx.helpers.defaultKeySerializer = function (x) { return x.toString(); },
    defaultError = Rx.helpers.defaultError = function (err) { throw err; },
    isPromise = Rx.helpers.isPromise = function (p) { return !!p && typeof p.then === 'function' && p.then !== Rx.Observable.prototype.then; },
    asArray = Rx.helpers.asArray = function () { return Array.prototype.slice.call(arguments); },
    not = Rx.helpers.not = function (a) { return !a; };

  // Errors
  var sequenceContainsNoElements = 'Sequence contains no elements.';
  var argumentOutOfRange = 'Argument out of range';
  var objectDisposed = 'Object has been disposed';
  function checkDisposed() { if (this.isDisposed) { throw new Error(objectDisposed); } }  
  
  // Shim in iterator support
  var $iterator$ = (typeof Symbol === 'object' && Symbol.iterator) ||
    '_es6shim_iterator_';
  // Firefox ships a partial implementation using the name @@iterator.
  // https://bugzilla.mozilla.org/show_bug.cgi?id=907077#c14
  // So use that name if we detect it.
  if (root.Set && typeof new root.Set()['@@iterator'] === 'function') {
    $iterator$ = '@@iterator';
  }
  var doneEnumerator = { done: true, value: undefined };

  /** `Object#toString` result shortcuts */
  var argsClass = '[object Arguments]',
    arrayClass = '[object Array]',
    boolClass = '[object Boolean]',
    dateClass = '[object Date]',
    errorClass = '[object Error]',
    funcClass = '[object Function]',
    numberClass = '[object Number]',
    objectClass = '[object Object]',
    regexpClass = '[object RegExp]',
    stringClass = '[object String]';

  var toString = Object.prototype.toString,
    hasOwnProperty = Object.prototype.hasOwnProperty,  
    supportsArgsClass = toString.call(arguments) == argsClass, // For less <IE9 && FF<4
    suportNodeClass,
    errorProto = Error.prototype,
    objectProto = Object.prototype,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

  try {
      suportNodeClass = !(toString.call(document) == objectClass && !({ 'toString': 0 } + ''));
  } catch(e) {
      suportNodeClass = true;
  }

  var shadowedProps = [
    'constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'
  ];

  var nonEnumProps = {};
  nonEnumProps[arrayClass] = nonEnumProps[dateClass] = nonEnumProps[numberClass] = { 'constructor': true, 'toLocaleString': true, 'toString': true, 'valueOf': true };
  nonEnumProps[boolClass] = nonEnumProps[stringClass] = { 'constructor': true, 'toString': true, 'valueOf': true };
  nonEnumProps[errorClass] = nonEnumProps[funcClass] = nonEnumProps[regexpClass] = { 'constructor': true, 'toString': true };
  nonEnumProps[objectClass] = { 'constructor': true };

  var support = {};
  (function () {
    var ctor = function() { this.x = 1; },
      props = [];

    ctor.prototype = { 'valueOf': 1, 'y': 1 };
    for (var key in new ctor) { props.push(key); }      
    for (key in arguments) { }

    // Detect if `name` or `message` properties of `Error.prototype` are enumerable by default.
    support.enumErrorProps = propertyIsEnumerable.call(errorProto, 'message') || propertyIsEnumerable.call(errorProto, 'name');

    // Detect if `prototype` properties are enumerable by default.
    support.enumPrototypes = propertyIsEnumerable.call(ctor, 'prototype');

    // Detect if `arguments` object indexes are non-enumerable
    support.nonEnumArgs = key != 0;

    // Detect if properties shadowing those on `Object.prototype` are non-enumerable.
    support.nonEnumShadows = !/valueOf/.test(props);
  }(1));

  function isObject(value) {
    // check if the value is the ECMAScript language type of Object
    // http://es5.github.io/#x8
    // and avoid a V8 bug
    // https://code.google.com/p/v8/issues/detail?id=2291
    var type = typeof value;
    return value && (type == 'function' || type == 'object') || false;
  }

  function keysIn(object) {
    var result = [];
    if (!isObject(object)) {
      return result;
    }
    if (support.nonEnumArgs && object.length && isArguments(object)) {
      object = slice.call(object);
    }
    var skipProto = support.enumPrototypes && typeof object == 'function',
        skipErrorProps = support.enumErrorProps && (object === errorProto || object instanceof Error);

    for (var key in object) {
      if (!(skipProto && key == 'prototype') &&
          !(skipErrorProps && (key == 'message' || key == 'name'))) {
        result.push(key);
      }
    }

    if (support.nonEnumShadows && object !== objectProto) {
      var ctor = object.constructor,
          index = -1,
          length = shadowedProps.length;

      if (object === (ctor && ctor.prototype)) {
        var className = object === stringProto ? stringClass : object === errorProto ? errorClass : toString.call(object),
            nonEnum = nonEnumProps[className];
      }
      while (++index < length) {
        key = shadowedProps[index];
        if (!(nonEnum && nonEnum[key]) && hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
    }
    return result;
  }

  function internalFor(object, callback, keysFunc) {
    var index = -1,
      props = keysFunc(object),
      length = props.length;

    while (++index < length) {
      var key = props[index];
      if (callback(object[key], key, object) === false) {
        break;
      }
    }
    return object;
  }   

  function internalForIn(object, callback) {
    return internalFor(object, callback, keysIn);
  }

  function isNode(value) {
    // IE < 9 presents DOM nodes as `Object` objects except they have `toString`
    // methods that are `typeof` "string" and still can coerce nodes to strings
    return typeof value.toString != 'function' && typeof (value + '') == 'string';
  }

  function isArguments(value) {
    return (value && typeof value == 'object') ? toString.call(value) == argsClass : false;
  }

  // fallback for browsers that can't detect `arguments` objects by [[Class]]
  if (!supportsArgsClass) {
    isArguments = function(value) {
      return (value && typeof value == 'object') ? hasOwnProperty.call(value, 'callee') : false;
    };
  }

  function isFunction(value) {
    return typeof value == 'function' || false;
  }

  // fallback for older versions of Chrome and Safari
  if (isFunction(/x/)) {
    isFunction = function(value) {
      return typeof value == 'function' && toString.call(value) == funcClass;
    };
  }        

  var isEqual = Rx.internals.isEqual = function (x, y) {
    return deepEquals(x, y, [], []); 
  };

  /** @private
   * Used for deep comparison
   **/
  function deepEquals(a, b, stackA, stackB) {
    // exit early for identical values
    if (a === b) {
      // treat `+0` vs. `-0` as not equal
      return a !== 0 || (1 / a == 1 / b);
    }

    var type = typeof a,
        otherType = typeof b;

    // exit early for unlike primitive values
    if (a === a && (a == null || b == null ||
        (type != 'function' && type != 'object' && otherType != 'function' && otherType != 'object'))) {
      return false;
    }

    // compare [[Class]] names
    var className = toString.call(a),
        otherClass = toString.call(b);

    if (className == argsClass) {
      className = objectClass;
    }
    if (otherClass == argsClass) {
      otherClass = objectClass;
    }
    if (className != otherClass) {
      return false;
    }
    switch (className) {
      case boolClass:
      case dateClass:
        // coerce dates and booleans to numbers, dates to milliseconds and booleans
        // to `1` or `0` treating invalid dates coerced to `NaN` as not equal
        return +a == +b;

      case numberClass:
        // treat `NaN` vs. `NaN` as equal
        return (a != +a)
          ? b != +b
          // but treat `-0` vs. `+0` as not equal
          : (a == 0 ? (1 / a == 1 / b) : a == +b);

      case regexpClass:
      case stringClass:
        // coerce regexes to strings (http://es5.github.io/#x15.10.6.4)
        // treat string primitives and their corresponding object instances as equal
        return a == String(b);
    }
    var isArr = className == arrayClass;
    if (!isArr) {

      // exit for functions and DOM nodes
      if (className != objectClass || (!support.nodeClass && (isNode(a) || isNode(b)))) {
        return false;
      }
      // in older versions of Opera, `arguments` objects have `Array` constructors
      var ctorA = !support.argsObject && isArguments(a) ? Object : a.constructor,
          ctorB = !support.argsObject && isArguments(b) ? Object : b.constructor;

      // non `Object` object instances with different constructors are not equal
      if (ctorA != ctorB &&
            !(hasOwnProperty.call(a, 'constructor') && hasOwnProperty.call(b, 'constructor')) &&
            !(isFunction(ctorA) && ctorA instanceof ctorA && isFunction(ctorB) && ctorB instanceof ctorB) &&
            ('constructor' in a && 'constructor' in b)
          ) {
        return false;
      }
    }
    // assume cyclic structures are equal
    // the algorithm for detecting cyclic structures is adapted from ES 5.1
    // section 15.12.3, abstract operation `JO` (http://es5.github.io/#x15.12.3)
    var initedStack = !stackA;
    stackA || (stackA = []);
    stackB || (stackB = []);

    var length = stackA.length;
    while (length--) {
      if (stackA[length] == a) {
        return stackB[length] == b;
      }
    }
    var size = 0;
    result = true;

    // add `a` and `b` to the stack of traversed objects
    stackA.push(a);
    stackB.push(b);

    // recursively compare objects and arrays (susceptible to call stack limits)
    if (isArr) {
      // compare lengths to determine if a deep comparison is necessary
      length = a.length;
      size = b.length;
      result = size == length;

      if (result) {
        // deep compare the contents, ignoring non-numeric properties
        while (size--) {
          var index = length,
              value = b[size];

          if (!(result = deepEquals(a[size], value, stackA, stackB))) {
            break;
          }
        }
      }
    }
    else {
      // deep compare objects using `forIn`, instead of `forOwn`, to avoid `Object.keys`
      // which, in this case, is more costly
      internalForIn(b, function(value, key, b) {
        if (hasOwnProperty.call(b, key)) {
          // count the number of properties.
          size++;
          // deep compare each property value.
          return (result = hasOwnProperty.call(a, key) && deepEquals(a[key], value, stackA, stackB));
        }
      });

      if (result) {
        // ensure both objects have the same number of properties
        internalForIn(a, function(value, key, a) {
          if (hasOwnProperty.call(a, key)) {
            // `size` will be `-1` if `a` has more properties than `b`
            return (result = --size > -1);
          }
        });
      }
    }
    stackA.pop();
    stackB.pop();

    return result;
  }
    var slice = Array.prototype.slice;
    function argsOrArray(args, idx) {
        return args.length === 1 && Array.isArray(args[idx]) ?
            args[idx] :
            slice.call(args);
    }
    var hasProp = {}.hasOwnProperty;

    /** @private */
    var inherits = this.inherits = Rx.internals.inherits = function (child, parent) {
        function __() { this.constructor = child; }
        __.prototype = parent.prototype;
        child.prototype = new __();
    };

    /** @private */    
    var addProperties = Rx.internals.addProperties = function (obj) {
        var sources = slice.call(arguments, 1);
        for (var i = 0, len = sources.length; i < len; i++) {
            var source = sources[i];
            for (var prop in source) {
                obj[prop] = source[prop];
            }
        }
    };

    // Rx Utils
    var addRef = Rx.internals.addRef = function (xs, r) {
        return new AnonymousObservable(function (observer) {
            return new CompositeDisposable(r.getDisposable(), xs.subscribe(observer));
        });
    };

    // Collection polyfills
    function arrayInitialize(count, factory) {
        var a = new Array(count);
        for (var i = 0; i < count; i++) {
            a[i] = factory();
        }
        return a;
    }

    // Collections
    var IndexedItem = function (id, value) {
        this.id = id;
        this.value = value;
    };

    IndexedItem.prototype.compareTo = function (other) {
        var c = this.value.compareTo(other.value);
        if (c === 0) {
            c = this.id - other.id;
        }
        return c;
    };

    // Priority Queue for Scheduling
    var PriorityQueue = Rx.internals.PriorityQueue = function (capacity) {
        this.items = new Array(capacity);
        this.length = 0;
    };

    var priorityProto = PriorityQueue.prototype;
    priorityProto.isHigherPriority = function (left, right) {
        return this.items[left].compareTo(this.items[right]) < 0;
    };

    priorityProto.percolate = function (index) {
        if (index >= this.length || index < 0) {
            return;
        }
        var parent = index - 1 >> 1;
        if (parent < 0 || parent === index) {
            return;
        }
        if (this.isHigherPriority(index, parent)) {
            var temp = this.items[index];
            this.items[index] = this.items[parent];
            this.items[parent] = temp;
            this.percolate(parent);
        }
    };

    priorityProto.heapify = function (index) {
        if (index === undefined) {
            index = 0;
        }
        if (index >= this.length || index < 0) {
            return;
        }
        var left = 2 * index + 1,
            right = 2 * index + 2,
            first = index;
        if (left < this.length && this.isHigherPriority(left, first)) {
            first = left;
        }
        if (right < this.length && this.isHigherPriority(right, first)) {
            first = right;
        }
        if (first !== index) {
            var temp = this.items[index];
            this.items[index] = this.items[first];
            this.items[first] = temp;
            this.heapify(first);
        }
    };
    
    priorityProto.peek = function () {  return this.items[0].value; };

    priorityProto.removeAt = function (index) {
        this.items[index] = this.items[--this.length];
        delete this.items[this.length];
        this.heapify();
    };

    priorityProto.dequeue = function () {
        var result = this.peek();
        this.removeAt(0);
        return result;
    };

    priorityProto.enqueue = function (item) {
        var index = this.length++;
        this.items[index] = new IndexedItem(PriorityQueue.count++, item);
        this.percolate(index);
    };

    priorityProto.remove = function (item) {
        for (var i = 0; i < this.length; i++) {
            if (this.items[i].value === item) {
                this.removeAt(i);
                return true;
            }
        }
        return false;
    };
    PriorityQueue.count = 0;
    /**
     * Represents a group of disposable resources that are disposed together.
     * @constructor
     */
    var CompositeDisposable = Rx.CompositeDisposable = function () {
        this.disposables = argsOrArray(arguments, 0);
        this.isDisposed = false;
        this.length = this.disposables.length;
    };

    var CompositeDisposablePrototype = CompositeDisposable.prototype;

    /**
     * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
     * @param {Mixed} item Disposable to add.
     */    
    CompositeDisposablePrototype.add = function (item) {
        if (this.isDisposed) {
            item.dispose();
        } else {
            this.disposables.push(item);
            this.length++;
        }
    };

    /**
     * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
     * @param {Mixed} item Disposable to remove.
     * @returns {Boolean} true if found; false otherwise.
     */
    CompositeDisposablePrototype.remove = function (item) {
        var shouldDispose = false;
        if (!this.isDisposed) {
            var idx = this.disposables.indexOf(item);
            if (idx !== -1) {
                shouldDispose = true;
                this.disposables.splice(idx, 1);
                this.length--;
                item.dispose();
            }

        }
        return shouldDispose;
    };

    /**
     *  Disposes all disposables in the group and removes them from the group.  
     */
    CompositeDisposablePrototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            var currentDisposables = this.disposables.slice(0);
            this.disposables = [];
            this.length = 0;

            for (var i = 0, len = currentDisposables.length; i < len; i++) {
                currentDisposables[i].dispose();
            }
        }
    };

    /**
     * Removes and disposes all disposables from the CompositeDisposable, but does not dispose the CompositeDisposable.
     */   
    CompositeDisposablePrototype.clear = function () {
        var currentDisposables = this.disposables.slice(0);
        this.disposables = [];
        this.length = 0;
        for (var i = 0, len = currentDisposables.length; i < len; i++) {
            currentDisposables[i].dispose();
        }
    };

    /**
     * Determines whether the CompositeDisposable contains a specific disposable.    
     * @param {Mixed} item Disposable to search for.
     * @returns {Boolean} true if the disposable was found; otherwise, false.
     */    
    CompositeDisposablePrototype.contains = function (item) {
        return this.disposables.indexOf(item) !== -1;
    };

    /**
     * Converts the existing CompositeDisposable to an array of disposables
     * @returns {Array} An array of disposable objects.
     */  
    CompositeDisposablePrototype.toArray = function () {
        return this.disposables.slice(0);
    };
    
    /**
     * Provides a set of static methods for creating Disposables.
     *
     * @constructor 
     * @param {Function} dispose Action to run during the first call to dispose. The action is guaranteed to be run at most once.
     */
    var Disposable = Rx.Disposable = function (action) {
        this.isDisposed = false;
        this.action = action || noop;
    };

    /** Performs the task of cleaning up resources. */     
    Disposable.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.action();
            this.isDisposed = true;
        }
    };

    /**
     * Creates a disposable object that invokes the specified action when disposed.
     * @param {Function} dispose Action to run during the first call to dispose. The action is guaranteed to be run at most once.
     * @return {Disposable} The disposable object that runs the given action upon disposal.
     */
    var disposableCreate = Disposable.create = function (action) { return new Disposable(action); };

    /** 
     * Gets the disposable that does nothing when disposed. 
     */
    var disposableEmpty = Disposable.empty = { dispose: noop };

    var BooleanDisposable = (function () {
        function BooleanDisposable (isSingle) {
            this.isSingle = isSingle;
            this.isDisposed = false;
            this.current = null;
        }

        var booleanDisposablePrototype = BooleanDisposable.prototype;

        /**
         * Gets the underlying disposable.
         * @return The underlying disposable.
         */
        booleanDisposablePrototype.getDisposable = function () {
            return this.current;
        };

        /**
         * Sets the underlying disposable.
         * @param {Disposable} value The new underlying disposable.
         */  
        booleanDisposablePrototype.setDisposable = function (value) {
            if (this.current && this.isSingle) {
                throw new Error('Disposable has already been assigned');
            }

            var shouldDispose = this.isDisposed, old;
            if (!shouldDispose) {
                old = this.current;
                this.current = value;
            }
            if (old) {
                old.dispose();
            }
            if (shouldDispose && value) {
                value.dispose();
            }
        };

        /** 
         * Disposes the underlying disposable as well as all future replacements.
         */
        booleanDisposablePrototype.dispose = function () {
            var old;
            if (!this.isDisposed) {
                this.isDisposed = true;
                old = this.current;
                this.current = null;
            }
            if (old) {
                old.dispose();
            }
        };

        return BooleanDisposable;
    }());

    /**
     * Represents a disposable resource which only allows a single assignment of its underlying disposable resource.
     * If an underlying disposable resource has already been set, future attempts to set the underlying disposable resource will throw an Error.
     */
    var SingleAssignmentDisposable = Rx.SingleAssignmentDisposable = (function (super_) {
        inherits(SingleAssignmentDisposable, super_);

        function SingleAssignmentDisposable() {
            super_.call(this, true);
        }

        return SingleAssignmentDisposable;
    }(BooleanDisposable));

    /**
     * Represents a disposable resource whose underlying disposable resource can be replaced by another disposable resource, causing automatic disposal of the previous underlying disposable resource.
     */
    var SerialDisposable = Rx.SerialDisposable = (function (super_) {
        inherits(SerialDisposable, super_);

        function SerialDisposable() {
            super_.call(this, false);
        }

        return SerialDisposable;
    }(BooleanDisposable));

    /**
     * Represents a disposable resource that only disposes its underlying disposable resource when all dependent disposable objects have been disposed.
     */  
    var RefCountDisposable = Rx.RefCountDisposable = (function () {

        function InnerDisposable(disposable) {
            this.disposable = disposable;
            this.disposable.count++;
            this.isInnerDisposed = false;
        }

        InnerDisposable.prototype.dispose = function () {
            if (!this.disposable.isDisposed) {
                if (!this.isInnerDisposed) {
                    this.isInnerDisposed = true;
                    this.disposable.count--;
                    if (this.disposable.count === 0 && this.disposable.isPrimaryDisposed) {
                        this.disposable.isDisposed = true;
                        this.disposable.underlyingDisposable.dispose();
                    }
                }
            }
        };

        /**
         * Initializes a new instance of the RefCountDisposable with the specified disposable.
         * @constructor
         * @param {Disposable} disposable Underlying disposable.
          */
        function RefCountDisposable(disposable) {
            this.underlyingDisposable = disposable;
            this.isDisposed = false;
            this.isPrimaryDisposed = false;
            this.count = 0;
        }

        /** 
         * Disposes the underlying disposable only when all dependent disposables have been disposed 
         */
        RefCountDisposable.prototype.dispose = function () {
            if (!this.isDisposed) {
                if (!this.isPrimaryDisposed) {
                    this.isPrimaryDisposed = true;
                    if (this.count === 0) {
                        this.isDisposed = true;
                        this.underlyingDisposable.dispose();
                    }
                }
            }
        };

        /**
         * Returns a dependent disposable that when disposed decreases the refcount on the underlying disposable.      
         * @returns {Disposable} A dependent disposable contributing to the reference count that manages the underlying disposable's lifetime.
         */        
        RefCountDisposable.prototype.getDisposable = function () {
            return this.isDisposed ? disposableEmpty : new InnerDisposable(this);
        };

        return RefCountDisposable;
    })();

    function ScheduledDisposable(scheduler, disposable) {
        this.scheduler = scheduler;
        this.disposable = disposable;
        this.isDisposed = false;
    }

    ScheduledDisposable.prototype.dispose = function () {
        var parent = this;
        this.scheduler.schedule(function () {
            if (!parent.isDisposed) {
                parent.isDisposed = true;
                parent.disposable.dispose();
            }
        });
    };

    var ScheduledItem = Rx.internals.ScheduledItem = function (scheduler, state, action, dueTime, comparer) {
        this.scheduler = scheduler;
        this.state = state;
        this.action = action;
        this.dueTime = dueTime;
        this.comparer = comparer || defaultSubComparer;
        this.disposable = new SingleAssignmentDisposable();
    }

    ScheduledItem.prototype.invoke = function () {
        this.disposable.setDisposable(this.invokeCore());
    };

    ScheduledItem.prototype.compareTo = function (other) {
        return this.comparer(this.dueTime, other.dueTime);
    };

    ScheduledItem.prototype.isCancelled = function () {
        return this.disposable.isDisposed;
    };

    ScheduledItem.prototype.invokeCore = function () {
        return this.action(this.scheduler, this.state);
    };

    /** Provides a set of static properties to access commonly used schedulers. */
    var Scheduler = Rx.Scheduler = (function () {

        /** 
         * @constructor 
         * @private
         */
        function Scheduler(now, schedule, scheduleRelative, scheduleAbsolute) {
            this.now = now;
            this._schedule = schedule;
            this._scheduleRelative = scheduleRelative;
            this._scheduleAbsolute = scheduleAbsolute;
        }

        function invokeRecImmediate(scheduler, pair) {
            var state = pair.first, action = pair.second, group = new CompositeDisposable(),
            recursiveAction = function (state1) {
                action(state1, function (state2) {
                    var isAdded = false, isDone = false,
                    d = scheduler.scheduleWithState(state2, function (scheduler1, state3) {
                        if (isAdded) {
                            group.remove(d);
                        } else {
                            isDone = true;
                        }
                        recursiveAction(state3);
                        return disposableEmpty;
                    });
                    if (!isDone) {
                        group.add(d);
                        isAdded = true;
                    }
                });
            };
            recursiveAction(state);
            return group;
        }

        function invokeRecDate(scheduler, pair, method) {
            var state = pair.first, action = pair.second, group = new CompositeDisposable(),
            recursiveAction = function (state1) {
                action(state1, function (state2, dueTime1) {
                    var isAdded = false, isDone = false,
                    d = scheduler[method].call(scheduler, state2, dueTime1, function (scheduler1, state3) {
                        if (isAdded) {
                            group.remove(d);
                        } else {
                            isDone = true;
                        }
                        recursiveAction(state3);
                        return disposableEmpty;
                    });
                    if (!isDone) {
                        group.add(d);
                        isAdded = true;
                    }
                });
            };
            recursiveAction(state);
            return group;
        }

        function invokeAction(scheduler, action) {
            action();
            return disposableEmpty;
        }

        var schedulerProto = Scheduler.prototype;

        /**
         * Returns a scheduler that wraps the original scheduler, adding exception handling for scheduled actions.       
         * @param {Function} handler Handler that's run if an exception is caught. The exception will be rethrown if the handler returns false.
         * @returns {Scheduler} Wrapper around the original scheduler, enforcing exception handling.
         */        
        schedulerProto.catchException = schedulerProto['catch'] = function (handler) {
            return new CatchScheduler(this, handler);
        };
        
        /**
         * Schedules a periodic piece of work by dynamically discovering the scheduler's capabilities. The periodic task will be scheduled using window.setInterval for the base implementation.       
         * @param {Number} period Period for running the work periodically.
         * @param {Function} action Action to be executed.
         * @returns {Disposable} The disposable object used to cancel the scheduled recurring action (best effort).
         */        
        schedulerProto.schedulePeriodic = function (period, action) {
            return this.schedulePeriodicWithState(null, period, function () {
                action();
            });
        };

        /**
         * Schedules a periodic piece of work by dynamically discovering the scheduler's capabilities. The periodic task will be scheduled using window.setInterval for the base implementation.       
         * @param {Mixed} state Initial state passed to the action upon the first iteration.
         * @param {Number} period Period for running the work periodically.
         * @param {Function} action Action to be executed, potentially updating the state.
         * @returns {Disposable} The disposable object used to cancel the scheduled recurring action (best effort).
         */
        schedulerProto.schedulePeriodicWithState = function (state, period, action) {
            var s = state, id = setInterval(function () {
                s = action(s);
            }, period);
            return disposableCreate(function () {
                clearInterval(id);
            });
        };

        /**
         * Schedules an action to be executed.        
         * @param {Function} action Action to execute.
         * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
         */
        schedulerProto.schedule = function (action) {
            return this._schedule(action, invokeAction);
        };

        /**
         * Schedules an action to be executed.    
         * @param state State passed to the action to be executed.
         * @param {Function} action Action to be executed.
         * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
         */
        schedulerProto.scheduleWithState = function (state, action) {
            return this._schedule(state, action);
        };

        /**
         * Schedules an action to be executed after the specified relative due time.       
         * @param {Function} action Action to execute.
         * @param {Number} dueTime Relative time after which to execute the action.
         * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
         */
        schedulerProto.scheduleWithRelative = function (dueTime, action) {
            return this._scheduleRelative(action, dueTime, invokeAction);
        };

        /**
         * Schedules an action to be executed after dueTime.     
         * @param state State passed to the action to be executed.
         * @param {Function} action Action to be executed.
         * @param {Number} dueTime Relative time after which to execute the action.
         * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
         */
        schedulerProto.scheduleWithRelativeAndState = function (state, dueTime, action) {
            return this._scheduleRelative(state, dueTime, action);
        };

        /**
         * Schedules an action to be executed at the specified absolute due time.    
         * @param {Function} action Action to execute.
         * @param {Number} dueTime Absolute time at which to execute the action.
         * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
          */
        schedulerProto.scheduleWithAbsolute = function (dueTime, action) {
            return this._scheduleAbsolute(action, dueTime, invokeAction);
        };

        /**
         * Schedules an action to be executed at dueTime.     
         * @param {Mixed} state State passed to the action to be executed.
         * @param {Function} action Action to be executed.
         * @param {Number}dueTime Absolute time at which to execute the action.
         * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
         */
        schedulerProto.scheduleWithAbsoluteAndState = function (state, dueTime, action) {
            return this._scheduleAbsolute(state, dueTime, action);
        };

        /**
         * Schedules an action to be executed recursively.
         * @param {Function} action Action to execute recursively. The parameter passed to the action is used to trigger recursive scheduling of the action.
         * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
         */
        schedulerProto.scheduleRecursive = function (action) {
            return this.scheduleRecursiveWithState(action, function (_action, self) {
                _action(function () {
                    self(_action);
                });
            });
        };

        /**
         * Schedules an action to be executed recursively.     
         * @param {Mixed} state State passed to the action to be executed.
         * @param {Function} action Action to execute recursively. The last parameter passed to the action is used to trigger recursive scheduling of the action, passing in recursive invocation state.
         * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
         */
        schedulerProto.scheduleRecursiveWithState = function (state, action) {
            return this.scheduleWithState({ first: state, second: action }, function (s, p) {
                return invokeRecImmediate(s, p);
            });
        };

        /**
         * Schedules an action to be executed recursively after a specified relative due time.     
         * @param {Function} action Action to execute recursively. The parameter passed to the action is used to trigger recursive scheduling of the action at the specified relative time.
         * @param {Number}dueTime Relative time after which to execute the action for the first time.
         * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
         */
        schedulerProto.scheduleRecursiveWithRelative = function (dueTime, action) {
            return this.scheduleRecursiveWithRelativeAndState(action, dueTime, function (_action, self) {
                _action(function (dt) {
                    self(_action, dt);
                });
            });
        };

        /**
         * Schedules an action to be executed recursively after a specified relative due time.  
         * @param {Mixed} state State passed to the action to be executed.
         * @param {Function} action Action to execute recursively. The last parameter passed to the action is used to trigger recursive scheduling of the action, passing in the recursive due time and invocation state.
         * @param {Number}dueTime Relative time after which to execute the action for the first time.
         * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
         */
        schedulerProto.scheduleRecursiveWithRelativeAndState = function (state, dueTime, action) {
            return this._scheduleRelative({ first: state, second: action }, dueTime, function (s, p) {
                return invokeRecDate(s, p, 'scheduleWithRelativeAndState');
            });
        };

        /**
         * Schedules an action to be executed recursively at a specified absolute due time.    
         * @param {Function} action Action to execute recursively. The parameter passed to the action is used to trigger recursive scheduling of the action at the specified absolute time.
         * @param {Number}dueTime Absolute time at which to execute the action for the first time.
         * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
         */
        schedulerProto.scheduleRecursiveWithAbsolute = function (dueTime, action) {
            return this.scheduleRecursiveWithAbsoluteAndState(action, dueTime, function (_action, self) {
                _action(function (dt) {
                    self(_action, dt);
                });
            });
        };

        /**
         * Schedules an action to be executed recursively at a specified absolute due time.     
         * @param {Mixed} state State passed to the action to be executed.
         * @param {Function} action Action to execute recursively. The last parameter passed to the action is used to trigger recursive scheduling of the action, passing in the recursive due time and invocation state.
         * @param {Number}dueTime Absolute time at which to execute the action for the first time.
         * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
         */
        schedulerProto.scheduleRecursiveWithAbsoluteAndState = function (state, dueTime, action) {
            return this._scheduleAbsolute({ first: state, second: action }, dueTime, function (s, p) {
                return invokeRecDate(s, p, 'scheduleWithAbsoluteAndState');
            });
        };

        /** Gets the current time according to the local machine's system clock. */
        Scheduler.now = defaultNow;

        /**
         * Normalizes the specified TimeSpan value to a positive value.
         * @param {Number} timeSpan The time span value to normalize.
         * @returns {Number} The specified TimeSpan value if it is zero or positive; otherwise, 0
         */   
        Scheduler.normalize = function (timeSpan) {
            if (timeSpan < 0) {
                timeSpan = 0;
            }
            return timeSpan;
        };

        return Scheduler;
    }());

    var normalizeTime = Scheduler.normalize;
    
    var SchedulePeriodicRecursive = Rx.internals.SchedulePeriodicRecursive = (function () {
        function tick(command, recurse) {
            recurse(0, this._period);
            try {
                this._state = this._action(this._state);
            } catch (e) {
                this._cancel.dispose();
                throw e;
            }
        }

        function SchedulePeriodicRecursive(scheduler, state, period, action) {
            this._scheduler = scheduler;
            this._state = state;
            this._period = period;
            this._action = action;
        }

        SchedulePeriodicRecursive.prototype.start = function () {
            var d = new SingleAssignmentDisposable();
            this._cancel = d;
            d.setDisposable(this._scheduler.scheduleRecursiveWithRelativeAndState(0, this._period, tick.bind(this)));

            return d;
        };

        return SchedulePeriodicRecursive;
    }());

  /**
   * Gets a scheduler that schedules work immediately on the current thread.
   */    
  var immediateScheduler = Scheduler.immediate = (function () {

    function scheduleNow(state, action) { return action(this, state); }

    function scheduleRelative(state, dueTime, action) {
      var dt = normalizeTime(dt);
      while (dt - this.now() > 0) { }
      return action(this, state);
    }

    function scheduleAbsolute(state, dueTime, action) {
      return this.scheduleWithRelativeAndState(state, dueTime - this.now(), action);
    }

    return new Scheduler(defaultNow, scheduleNow, scheduleRelative, scheduleAbsolute);
  }());

    /** 
     * Gets a scheduler that schedules work as soon as possible on the current thread.
     */
    var currentThreadScheduler = Scheduler.currentThread = (function () {
        var queue;

        function runTrampoline (q) {
            var item;
            while (q.length > 0) {
                item = q.dequeue();
                if (!item.isCancelled()) {
                    // Note, do not schedule blocking work!
                    while (item.dueTime - Scheduler.now() > 0) {
                    }
                    if (!item.isCancelled()) {
                        item.invoke();
                    }
                }
            }            
        }

        function scheduleNow(state, action) {
            return this.scheduleWithRelativeAndState(state, 0, action);
        }

        function scheduleRelative(state, dueTime, action) {
            var dt = this.now() + Scheduler.normalize(dueTime),
                    si = new ScheduledItem(this, state, action, dt),
                    t;
            if (!queue) {
                queue = new PriorityQueue(4);
                queue.enqueue(si);
                try {
                    runTrampoline(queue);
                } catch (e) { 
                    throw e;
                } finally {
                    queue = null;
                }
            } else {
                queue.enqueue(si);
            }
            return si.disposable;
        }

        function scheduleAbsolute(state, dueTime, action) {
            return this.scheduleWithRelativeAndState(state, dueTime - this.now(), action);
        }

        var currentScheduler = new Scheduler(defaultNow, scheduleNow, scheduleRelative, scheduleAbsolute);
        currentScheduler.scheduleRequired = function () { return queue === null; };
        currentScheduler.ensureTrampoline = function (action) {
            if (queue === null) {
                return this.schedule(action);
            } else {
                return action();
            }
        };

        return currentScheduler;
    }());

  
  var scheduleMethod, clearMethod = noop;
  (function () {

      var reNative = RegExp('^' +
        String(toString)
          .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
          .replace(/toString| for [^\]]+/g, '.*?') + '$'
      );

      var setImmediate = typeof (setImmediate = freeGlobal && moduleExports && freeGlobal.setImmediate) == 'function' &&
        !reNative.test(setImmediate) && setImmediate,
        clearImmediate = typeof (clearImmediate = freeGlobal && moduleExports && freeGlobal.clearImmediate) == 'function' &&
        !reNative.test(clearImmediate) && clearImmediate;

      function postMessageSupported () {
        // Ensure not in a worker
        if (!root.postMessage || root.importScripts) { return false; }
        var isAsync = false, 
            oldHandler = root.onmessage;
        // Test for async
        root.onmessage = function () { isAsync = true; };
        root.postMessage('','*');
        root.onmessage = oldHandler;

        return isAsync;
      }

      // Use in order, nextTick, setImmediate, postMessage, MessageChannel, script readystatechanged, setTimeout
      if (typeof process !== 'undefined' && {}.toString.call(process) === '[object process]') {
        scheduleMethod = process.nextTick;
      } else if (typeof setImmediate === 'function') {
        scheduleMethod = setImmediate;
        clearMethod = clearImmediate;
      } else if (postMessageSupported()) {
          var MSG_PREFIX = 'ms.rx.schedule' + Math.random(),
            tasks = {},
            taskId = 0;

          function onGlobalPostMessage(event) {
            // Only if we're a match to avoid any other global events
            if (typeof event.data === 'string' && event.data.substring(0, MSG_PREFIX.length) === MSG_PREFIX) {
              var handleId = event.data.substring(MSG_PREFIX.length),
                action = tasks[handleId];
              action();
              delete tasks[handleId];
            }
          }

          if (root.addEventListener) {
            root.addEventListener('message', onGlobalPostMessage, false);
          } else {
            root.attachEvent('onmessage', onGlobalPostMessage, false);
          }

          scheduleMethod = function (action) {
            var currentId = taskId++;
            tasks[currentId] = action;
            root.postMessage(MSG_PREFIX + currentId, '*');
          };
      } else if (!!root.MessageChannel) {
          var channel = new root.MessageChannel(),
            channelTasks = {},
            channelTaskId = 0;

          channel.port1.onmessage = function (event) {
            var id = event.data,
              action = channelTasks[id];
            action();
            delete channelTasks[id];
          };

          scheduleMethod = function (action) {
            var id = channelTaskId++;
            channelTasks[id] = action;
            channel.port2.postMessage(id);     
          };
      } else if ('document' in root && 'onreadystatechange' in root.document.createElement('script')) {
          
        scheduleMethod = function (action) {
          var scriptElement = root.document.createElement('script');
          scriptElement.onreadystatechange = function () { 
            action();
            scriptElement.onreadystatechange = null;
            scriptElement.parentNode.removeChild(scriptElement);
            scriptElement = null;  
          };
          root.document.documentElement.appendChild(scriptElement);  
        };

      } else {
        scheduleMethod = function (action) { return setTimeout(action, 0); };
        clearMethod = clearTimeout;
      }
  }());

  /** 
   * Gets a scheduler that schedules work via a timed callback based upon platform.
   */
  var timeoutScheduler = Scheduler.timeout = (function () {

    function scheduleNow(state, action) {
        var scheduler = this,
          disposable = new SingleAssignmentDisposable();
        var id = scheduleMethod(function () {
          if (!disposable.isDisposed) {
            disposable.setDisposable(action(scheduler, state));
          }
        });
        return new CompositeDisposable(disposable, disposableCreate(function () {
          clearMethod(id);
        }));
    }

    function scheduleRelative(state, dueTime, action) {
        var scheduler = this,
          dt = Scheduler.normalize(dueTime);
        if (dt === 0) {
          return scheduler.scheduleWithState(state, action);
        }
        var disposable = new SingleAssignmentDisposable();
        var id = setTimeout(function () {
          if (!disposable.isDisposed) {
            disposable.setDisposable(action(scheduler, state));
          }
        }, dt);
        return new CompositeDisposable(disposable, disposableCreate(function () {
          clearTimeout(id);
        }));
    }

    function scheduleAbsolute(state, dueTime, action) {
      return this.scheduleWithRelativeAndState(state, dueTime - this.now(), action);
    }

    return new Scheduler(defaultNow, scheduleNow, scheduleRelative, scheduleAbsolute);
  })();

    /** @private */
    var CatchScheduler = (function (_super) {

        function localNow() {
            return this._scheduler.now();
        }

        function scheduleNow(state, action) {
            return this._scheduler.scheduleWithState(state, this._wrap(action));
        }

        function scheduleRelative(state, dueTime, action) {
            return this._scheduler.scheduleWithRelativeAndState(state, dueTime, this._wrap(action));
        }

        function scheduleAbsolute(state, dueTime, action) {
            return this._scheduler.scheduleWithAbsoluteAndState(state, dueTime, this._wrap(action));
        }

        inherits(CatchScheduler, _super);

        /** @private */
        function CatchScheduler(scheduler, handler) {
            this._scheduler = scheduler;
            this._handler = handler;
            this._recursiveOriginal = null;
            this._recursiveWrapper = null;
            _super.call(this, localNow, scheduleNow, scheduleRelative, scheduleAbsolute);
        }

        /** @private */
        CatchScheduler.prototype._clone = function (scheduler) {
            return new CatchScheduler(scheduler, this._handler);
        };

        /** @private */
        CatchScheduler.prototype._wrap = function (action) {
            var parent = this;
            return function (self, state) {
                try {
                    return action(parent._getRecursiveWrapper(self), state);
                } catch (e) {
                    if (!parent._handler(e)) { throw e; }
                    return disposableEmpty;
                }
            };
        };

        /** @private */
        CatchScheduler.prototype._getRecursiveWrapper = function (scheduler) {
            if (this._recursiveOriginal !== scheduler) {
                this._recursiveOriginal = scheduler;
                var wrapper = this._clone(scheduler);
                wrapper._recursiveOriginal = scheduler;
                wrapper._recursiveWrapper = wrapper;
                this._recursiveWrapper = wrapper;
            }
            return this._recursiveWrapper;
        };

        /** @private */
        CatchScheduler.prototype.schedulePeriodicWithState = function (state, period, action) {
            var self = this, failed = false, d = new SingleAssignmentDisposable();

            d.setDisposable(this._scheduler.schedulePeriodicWithState(state, period, function (state1) {
                if (failed) { return null; }
                try {
                    return action(state1);
                } catch (e) {
                    failed = true;
                    if (!self._handler(e)) { throw e; }
                    d.dispose();
                    return null;
                }
            }));

            return d;
        };

        return CatchScheduler;
    }(Scheduler));

    /**
     *  Represents a notification to an observer.
     */
    var Notification = Rx.Notification = (function () {
        function Notification(kind, hasValue) { 
            this.hasValue = hasValue == null ? false : hasValue;
            this.kind = kind;
        }

        var NotificationPrototype = Notification.prototype;

        /**
         * Invokes the delegate corresponding to the notification or the observer's method corresponding to the notification and returns the produced result.
         * 
         * @memberOf Notification
         * @param {Any} observerOrOnNext Delegate to invoke for an OnNext notification or Observer to invoke the notification on..
         * @param {Function} onError Delegate to invoke for an OnError notification.
         * @param {Function} onCompleted Delegate to invoke for an OnCompleted notification.
         * @returns {Any} Result produced by the observation.
         */
        NotificationPrototype.accept = function (observerOrOnNext, onError, onCompleted) {
            if (arguments.length === 1 && typeof observerOrOnNext === 'object') {
                return this._acceptObservable(observerOrOnNext);
            }
            return this._accept(observerOrOnNext, onError, onCompleted);
        };

        /**
         * Returns an observable sequence with a single notification.
         * 
         * @memberOf Notification
         * @param {Scheduler} [scheduler] Scheduler to send out the notification calls on.
         * @returns {Observable} The observable sequence that surfaces the behavior of the notification upon subscription.
         */
        NotificationPrototype.toObservable = function (scheduler) {
            var notification = this;
            scheduler || (scheduler = immediateScheduler);
            return new AnonymousObservable(function (observer) {
                return scheduler.schedule(function () {
                    notification._acceptObservable(observer);
                    if (notification.kind === 'N') {
                        observer.onCompleted();
                    }
                });
            });
        };

        return Notification;
    })();

    /**
     * Creates an object that represents an OnNext notification to an observer.
     * @param {Any} value The value contained in the notification.
     * @returns {Notification} The OnNext notification containing the value.
     */
    var notificationCreateOnNext = Notification.createOnNext = (function () {

        function _accept (onNext) {
            return onNext(this.value);
        }

        function _acceptObservable(observer) {
            return observer.onNext(this.value);
        }

        function toString () {
            return 'OnNext(' + this.value + ')';
        }

        return function (value) {
            var notification = new Notification('N', true);
            notification.value = value;
            notification._accept = _accept;
            notification._acceptObservable = _acceptObservable;
            notification.toString = toString;
            return notification;
        };
    }());

    /**
     * Creates an object that represents an OnError notification to an observer.
     * @param {Any} error The exception contained in the notification.
     * @returns {Notification} The OnError notification containing the exception.
     */
    var notificationCreateOnError = Notification.createOnError = (function () {

        function _accept (onNext, onError) {
            return onError(this.exception);
        }

        function _acceptObservable(observer) {
            return observer.onError(this.exception);
        }

        function toString () {
            return 'OnError(' + this.exception + ')';
        }

        return function (exception) {
            var notification = new Notification('E');
            notification.exception = exception;
            notification._accept = _accept;
            notification._acceptObservable = _acceptObservable;
            notification.toString = toString;
            return notification;
        };
    }());

    /**
     * Creates an object that represents an OnCompleted notification to an observer.
     * @returns {Notification} The OnCompleted notification.
     */
    var notificationCreateOnCompleted = Notification.createOnCompleted = (function () {

        function _accept (onNext, onError, onCompleted) {
            return onCompleted();
        }

        function _acceptObservable(observer) {
            return observer.onCompleted();
        }

        function toString () {
            return 'OnCompleted()';
        }

        return function () {
            var notification = new Notification('C');
            notification._accept = _accept;
            notification._acceptObservable = _acceptObservable;
            notification.toString = toString;
            return notification;
        };
    }());

  var Enumerator = Rx.internals.Enumerator = function (next) {
    this._next = next;
  };

  Enumerator.prototype.next = function () {
    return this._next();
  };

  Enumerator.prototype[$iterator$] = function () { return this; }

  var Enumerable = Rx.internals.Enumerable = function (iterator) {
    this._iterator = iterator;
  };

  Enumerable.prototype[$iterator$] = function () {
    return this._iterator();
  };

  Enumerable.prototype.concat = function () {
    var sources = this;
    return new AnonymousObservable(function (observer) {
      var e;
      try {
        e = sources[$iterator$]();
      } catch(err) {
        observer.onError();
        return;
      }

      var isDisposed, 
        subscription = new SerialDisposable();
      var cancelable = immediateScheduler.scheduleRecursive(function (self) {
        var currentItem;
        if (isDisposed) { return; }

        try {
          currentItem = e.next();
        } catch (ex) {
          observer.onError(ex);
          return;
        }

        if (currentItem.done) {
          observer.onCompleted();
          return;
        }

        // Check if promise
        var currentValue = currentItem.value;
        isPromise(currentValue) && (currentValue = observableFromPromise(currentValue));

        var d = new SingleAssignmentDisposable();
        subscription.setDisposable(d);
        d.setDisposable(currentValue.subscribe(
          observer.onNext.bind(observer),
          observer.onError.bind(observer),
          function () { self(); })
        );
      });

      return new CompositeDisposable(subscription, cancelable, disposableCreate(function () {
        isDisposed = true;
      }));
    });
  };

  Enumerable.prototype.catchException = function () {
    var sources = this;
    return new AnonymousObservable(function (observer) {
      var e;
      try {
        e = sources[$iterator$]();
      } catch(err) {
        observer.onError();
        return;
      }

      var isDisposed, 
        lastException,
        subscription = new SerialDisposable();
      var cancelable = immediateScheduler.scheduleRecursive(function (self) {
        if (isDisposed) { return; }

        var currentItem;
        try {
          currentItem = e.next();
        } catch (ex) {
          observer.onError(ex);
          return;
        }

        if (currentItem.done) {
          if (lastException) {
            observer.onError(lastException);
          } else {
            observer.onCompleted();
          }
          return;
        }

        // Check if promise
        var currentValue = currentItem.value;
        isPromise(currentValue) && (currentValue = observableFromPromise(currentValue));        

        var d = new SingleAssignmentDisposable();
        subscription.setDisposable(d);
        d.setDisposable(currentValue.subscribe(
          observer.onNext.bind(observer),
          function (exn) {
            lastException = exn;
            self();
          },
          observer.onCompleted.bind(observer)));
      });
      return new CompositeDisposable(subscription, cancelable, disposableCreate(function () {
        isDisposed = true;
      }));
    });
  };

  var enumerableRepeat = Enumerable.repeat = function (value, repeatCount) {
    if (repeatCount == null) { repeatCount = -1; }
    return new Enumerable(function () {
      var left = repeatCount;
      return new Enumerator(function () {
        if (left === 0) { return doneEnumerator; }
        if (left > 0) { left--; }
        return { done: false, value: value };
      });
    });
  };

  var enumerableFor = Enumerable.forEach = function (source, selector, thisArg) {
    selector || (selector = identity);
    return new Enumerable(function () {
      var index = -1;
      return new Enumerator(
        function () {
          return ++index < source.length ?
            { done: false, value: selector.call(thisArg, source[index], index, source) } :
            doneEnumerator;
        });
    });
  };

  /**
   * Supports push-style iteration over an observable sequence.
   */
  var Observer = Rx.Observer = function () { };

  /**
   *  Creates a notification callback from an observer.
   *  
   * @param observer Observer object.
   * @returns The action that forwards its input notification to the underlying observer.
   */
  Observer.prototype.toNotifier = function () {
    var observer = this;
    return function (n) {
      return n.accept(observer);
    };
  };

  /**
   *  Hides the identity of an observer.

   * @returns An observer that hides the identity of the specified observer. 
   */   
  Observer.prototype.asObserver = function () {
    return new AnonymousObserver(this.onNext.bind(this), this.onError.bind(this), this.onCompleted.bind(this));
  };

  /**
   *  Checks access to the observer for grammar violations. This includes checking for multiple OnError or OnCompleted calls, as well as reentrancy in any of the observer methods.
   *  If a violation is detected, an Error is thrown from the offending observer method call.
   *  
   * @returns An observer that checks callbacks invocations against the observer grammar and, if the checks pass, forwards those to the specified observer.
   */    
  Observer.prototype.checked = function () { return new CheckedObserver(this); };

  /**
   *  Creates an observer from the specified OnNext, along with optional OnError, and OnCompleted actions.
   *  
   * @static
   * @memberOf Observer
   * @param {Function} [onNext] Observer's OnNext action implementation.
   * @param {Function} [onError] Observer's OnError action implementation.
   * @param {Function} [onCompleted] Observer's OnCompleted action implementation.
   * @returns {Observer} The observer object implemented using the given actions.
   */
  var observerCreate = Observer.create = function (onNext, onError, onCompleted) {
    onNext || (onNext = noop);
    onError || (onError = defaultError);
    onCompleted || (onCompleted = noop);
    return new AnonymousObserver(onNext, onError, onCompleted);
  };

  /**
   *  Creates an observer from a notification callback.
   *  
   * @static
   * @memberOf Observer
   * @param {Function} handler Action that handles a notification.
   * @returns The observer object that invokes the specified handler using a notification corresponding to each message it receives.
   */
  Observer.fromNotifier = function (handler) {
    return new AnonymousObserver(function (x) {
      return handler(notificationCreateOnNext(x));
    }, function (exception) {
      return handler(notificationCreateOnError(exception));
    }, function () {
      return handler(notificationCreateOnCompleted());
    });
  };

  /**
   * Schedules the invocation of observer methods on the given scheduler.
   * @param {Scheduler} scheduler Scheduler to schedule observer messages on.
   * @returns {Observer} Observer whose messages are scheduled on the given scheduler.
   */
  Observer.notifyOn = function (scheduler) {
    return new ObserveOnObserver(scheduler, this);
  };
  
    /**
     * Abstract base class for implementations of the Observer class.
     * This base class enforces the grammar of observers where OnError and OnCompleted are terminal messages. 
     */
    var AbstractObserver = Rx.internals.AbstractObserver = (function (_super) {
        inherits(AbstractObserver, _super);

        /**
         * Creates a new observer in a non-stopped state.
         *
         * @constructor
         */
        function AbstractObserver() {
            this.isStopped = false;
            _super.call(this);
        }

        /**
         * Notifies the observer of a new element in the sequence.
         *  
         * @memberOf AbstractObserver
         * @param {Any} value Next element in the sequence. 
         */
        AbstractObserver.prototype.onNext = function (value) {
            if (!this.isStopped) {
                this.next(value);
            }
        };

        /**
         * Notifies the observer that an exception has occurred.
         * 
         * @memberOf AbstractObserver
         * @param {Any} error The error that has occurred.     
         */    
        AbstractObserver.prototype.onError = function (error) {
            if (!this.isStopped) {
                this.isStopped = true;
                this.error(error);
            }
        };

        /**
         * Notifies the observer of the end of the sequence.
         */    
        AbstractObserver.prototype.onCompleted = function () {
            if (!this.isStopped) {
                this.isStopped = true;
                this.completed();
            }
        };

        /**
         * Disposes the observer, causing it to transition to the stopped state.
         */
        AbstractObserver.prototype.dispose = function () {
            this.isStopped = true;
        };

        AbstractObserver.prototype.fail = function (e) {
            if (!this.isStopped) {
                this.isStopped = true;
                this.error(e);
                return true;
            }

            return false;
        };

        return AbstractObserver;
    }(Observer));

  /**
   * Class to create an Observer instance from delegate-based implementations of the on* methods.
   */
  var AnonymousObserver = Rx.AnonymousObserver = (function (_super) {
    inherits(AnonymousObserver, _super);

    /**
     * Creates an observer from the specified OnNext, OnError, and OnCompleted actions.
     * @param {Any} onNext Observer's OnNext action implementation.
     * @param {Any} onError Observer's OnError action implementation.
     * @param {Any} onCompleted Observer's OnCompleted action implementation.  
     */      
    function AnonymousObserver(onNext, onError, onCompleted) {
      _super.call(this);
      this._onNext = onNext;
      this._onError = onError;
      this._onCompleted = onCompleted;
    }

    /**
     * Calls the onNext action.
     * @param {Any} value Next element in the sequence.   
     */     
    AnonymousObserver.prototype.next = function (value) {
      this._onNext(value);
    };

    /**
     * Calls the onError action.
     * @param {Any} error The error that has occurred.   
     */     
    AnonymousObserver.prototype.error = function (exception) {
      this._onError(exception);
    };

    /**
     *  Calls the onCompleted action.
     */        
    AnonymousObserver.prototype.completed = function () {
      this._onCompleted();
    };

    return AnonymousObserver;
  }(AbstractObserver));

    var CheckedObserver = (function (_super) {
        inherits(CheckedObserver, _super);

        function CheckedObserver(observer) {
            _super.call(this);
            this._observer = observer;
            this._state = 0; // 0 - idle, 1 - busy, 2 - done
        }

        var CheckedObserverPrototype = CheckedObserver.prototype;

        CheckedObserverPrototype.onNext = function (value) {
            this.checkAccess();
            try {
                this._observer.onNext(value);
            } catch (e) { 
                throw e;                
            } finally {
                this._state = 0;
            }
        };

        CheckedObserverPrototype.onError = function (err) {
            this.checkAccess();
            try {
                this._observer.onError(err);
            } catch (e) { 
                throw e;                
            } finally {
                this._state = 2;
            }
        };

        CheckedObserverPrototype.onCompleted = function () {
            this.checkAccess();
            try {
                this._observer.onCompleted();
            } catch (e) { 
                throw e;                
            } finally {
                this._state = 2;
            }
        };

        CheckedObserverPrototype.checkAccess = function () {
            if (this._state === 1) { throw new Error('Re-entrancy detected'); }
            if (this._state === 2) { throw new Error('Observer completed'); }
            if (this._state === 0) { this._state = 1; }
        };

        return CheckedObserver;
    }(Observer));

  var ScheduledObserver = Rx.internals.ScheduledObserver = (function (_super) {
    inherits(ScheduledObserver, _super);

    function ScheduledObserver(scheduler, observer) {
      _super.call(this);
      this.scheduler = scheduler;
      this.observer = observer;
      this.isAcquired = false;
      this.hasFaulted = false;
      this.queue = [];
      this.disposable = new SerialDisposable();
    }

    ScheduledObserver.prototype.next = function (value) {
      var self = this;
      this.queue.push(function () {
        self.observer.onNext(value);
      });
    };

    ScheduledObserver.prototype.error = function (exception) {
      var self = this;
      this.queue.push(function () {
        self.observer.onError(exception);
      });
    };

    ScheduledObserver.prototype.completed = function () {
      var self = this;
      this.queue.push(function () {
        self.observer.onCompleted();
      });
    };

    ScheduledObserver.prototype.ensureActive = function () {
      var isOwner = false, parent = this;
      if (!this.hasFaulted && this.queue.length > 0) {
        isOwner = !this.isAcquired;
        this.isAcquired = true;
      }
      if (isOwner) {
        this.disposable.setDisposable(this.scheduler.scheduleRecursive(function (self) {
          var work;
          if (parent.queue.length > 0) {
            work = parent.queue.shift();
          } else {
            parent.isAcquired = false;
            return;
          }
          try {
            work();
          } catch (ex) {
            parent.queue = [];
            parent.hasFaulted = true;
            throw ex;
          }
          self();
        }));
      }
    };

    ScheduledObserver.prototype.dispose = function () {
      _super.prototype.dispose.call(this);
      this.disposable.dispose();
    };

    return ScheduledObserver;
  }(AbstractObserver));

    /** @private */
    var ObserveOnObserver = (function (_super) {
        inherits(ObserveOnObserver, _super);

        /** @private */ 
        function ObserveOnObserver() {
            _super.apply(this, arguments);
        }

        /** @private */ 
        ObserveOnObserver.prototype.next = function (value) {
            _super.prototype.next.call(this, value);
            this.ensureActive();
        };

        /** @private */ 
        ObserveOnObserver.prototype.error = function (e) {
            _super.prototype.error.call(this, e);
            this.ensureActive();
        };

        /** @private */ 
        ObserveOnObserver.prototype.completed = function () {
            _super.prototype.completed.call(this);
            this.ensureActive();
        };

        return ObserveOnObserver;
    })(ScheduledObserver);

  var observableProto;

  /**
   * Represents a push-style collection.
   */
  var Observable = Rx.Observable = (function () {

    function Observable(subscribe) {
      this._subscribe = subscribe;
    }

    observableProto = Observable.prototype;

    /**
     *  Subscribes an observer to the observable sequence.
     *  
     * @example
     *  1 - source.subscribe();
     *  2 - source.subscribe(observer);
     *  3 - source.subscribe(function (x) { console.log(x); });
     *  4 - source.subscribe(function (x) { console.log(x); }, function (err) { console.log(err); });
     *  5 - source.subscribe(function (x) { console.log(x); }, function (err) { console.log(err); }, function () { console.log('done'); });
     *  @param {Mixed} [observerOrOnNext] The object that is to receive notifications or an action to invoke for each element in the observable sequence.
     *  @param {Function} [onError] Action to invoke upon exceptional termination of the observable sequence.
     *  @param {Function} [onCompleted] Action to invoke upon graceful termination of the observable sequence.
     *  @returns {Diposable} The source sequence whose subscriptions and unsubscriptions happen on the specified scheduler. 
     */
    observableProto.subscribe = observableProto.forEach = function (observerOrOnNext, onError, onCompleted) {
      var subscriber = typeof observerOrOnNext === 'object' ?
        observerOrOnNext :
        observerCreate(observerOrOnNext, onError, onCompleted);

      return this._subscribe(subscriber);
    };

    return Observable;
  })();

     /**
     *  Wraps the source sequence in order to run its observer callbacks on the specified scheduler.
     * 
     *  This only invokes observer callbacks on a scheduler. In case the subscription and/or unsubscription actions have side-effects
     *  that require to be run on a scheduler, use subscribeOn.
     *          
     *  @param {Scheduler} scheduler Scheduler to notify observers on.
     *  @returns {Observable} The source sequence whose observations happen on the specified scheduler.     
     */
    observableProto.observeOn = function (scheduler) {
        var source = this;
        return new AnonymousObservable(function (observer) {
            return source.subscribe(new ObserveOnObserver(scheduler, observer));
        });
    };

     /**
     *  Wraps the source sequence in order to run its subscription and unsubscription logic on the specified scheduler. This operation is not commonly used;
     *  see the remarks section for more information on the distinction between subscribeOn and observeOn.

     *  This only performs the side-effects of subscription and unsubscription on the specified scheduler. In order to invoke observer
     *  callbacks on a scheduler, use observeOn.

     *  @param {Scheduler} scheduler Scheduler to perform subscription and unsubscription actions on.
     *  @returns {Observable} The source sequence whose subscriptions and unsubscriptions happen on the specified scheduler.
     */
    observableProto.subscribeOn = function (scheduler) {
        var source = this;
        return new AnonymousObservable(function (observer) {
            var m = new SingleAssignmentDisposable(), d = new SerialDisposable();
            d.setDisposable(m);
            m.setDisposable(scheduler.schedule(function () {
                d.setDisposable(new ScheduledDisposable(scheduler, source.subscribe(observer)));
            }));
            return d;
        });
    };

  /**
   * Converts a Promise to an Observable sequence
   * @param {Promise} An ES6 Compliant promise.
   * @returns {Observable} An Observable sequence which wraps the existing promise success and failure.
   */
  var observableFromPromise = Observable.fromPromise = function (promise) {
    return new AnonymousObservable(function (observer) {
      promise.then(
        function (value) {
          observer.onNext(value);
          observer.onCompleted();
        }, 
        function (reason) {
          observer.onError(reason);
        });

      return function () {
        if (promise && promise.abort) {
          promise.abort();
        }
      }
    });
  };
    /*
     * Converts an existing observable sequence to an ES6 Compatible Promise
     * @example
     * var promise = Rx.Observable.return(42).toPromise(RSVP.Promise);
     * 
     * // With config
     * Rx.config.Promise = RSVP.Promise;
     * var promise = Rx.Observable.return(42).toPromise();
     * @param {Function} [promiseCtor] The constructor of the promise. If not provided, it looks for it in Rx.config.Promise.
     * @returns {Promise} An ES6 compatible promise with the last value from the observable sequence.
     */
    observableProto.toPromise = function (promiseCtor) {
        promiseCtor || (promiseCtor = Rx.config.Promise);
        if (!promiseCtor) {
            throw new Error('Promise type not provided nor in Rx.config.Promise');
        }
        var source = this;
        return new promiseCtor(function (resolve, reject) {
            // No cancellation can be done
            var value, hasValue = false;
            source.subscribe(function (v) {
                value = v;
                hasValue = true;
            }, function (err) {
                reject(err);
            }, function () {
                if (hasValue) {
                    resolve(value);
                }
            });
        });
    };
  /**
   * Creates a list from an observable sequence.
   * @returns An observable sequence containing a single element with a list containing all the elements of the source sequence.  
   */
  observableProto.toArray = function () {
    var self = this;
    return new AnonymousObservable(function(observer) {
      var arr = [];
      return self.subscribe(
        arr.push.bind(arr),
        observer.onError.bind(observer),
        function () {
          observer.onNext(arr);
          observer.onCompleted();
        });
    });
  };

    /**
     *  Creates an observable sequence from a specified subscribe method implementation.
     *  
     * @example
     *  var res = Rx.Observable.create(function (observer) { return function () { } );
     *  var res = Rx.Observable.create(function (observer) { return Rx.Disposable.empty; } ); 
     *  var res = Rx.Observable.create(function (observer) { } ); 
     *  
     * @param {Function} subscribe Implementation of the resulting observable sequence's subscribe method, returning a function that will be wrapped in a Disposable.
     * @returns {Observable} The observable sequence with the specified implementation for the Subscribe method.
     */
    Observable.create = Observable.createWithDisposable = function (subscribe) {
        return new AnonymousObservable(subscribe);
    };

  /**
   *  Returns an observable sequence that invokes the specified factory function whenever a new observer subscribes.
   *  
   * @example
   *  var res = Rx.Observable.defer(function () { return Rx.Observable.fromArray([1,2,3]); });    
   * @param {Function} observableFactory Observable factory function to invoke for each observer that subscribes to the resulting sequence or Promise.
   * @returns {Observable} An observable sequence whose observers trigger an invocation of the given observable factory function.
   */
  var observableDefer = Observable.defer = function (observableFactory) {
    return new AnonymousObservable(function (observer) {
      var result;
      try {
        result = observableFactory();
      } catch (e) {
        return observableThrow(e).subscribe(observer);
      }
      isPromise(result) && (result = observableFromPromise(result));
      return result.subscribe(observer);
    });
  };

    /**
     *  Returns an empty observable sequence, using the specified scheduler to send out the single OnCompleted message.
     *  
     * @example
     *  var res = Rx.Observable.empty();  
     *  var res = Rx.Observable.empty(Rx.Scheduler.timeout);  
     * @param {Scheduler} [scheduler] Scheduler to send the termination call on.
     * @returns {Observable} An observable sequence with no elements.
     */
    var observableEmpty = Observable.empty = function (scheduler) {
        scheduler || (scheduler = immediateScheduler);
        return new AnonymousObservable(function (observer) {
            return scheduler.schedule(function () {
                observer.onCompleted();
            });
        });
    };

  /**
   *  Converts an array to an observable sequence, using an optional scheduler to enumerate the array.
   *  
   * @example
   *  var res = Rx.Observable.fromArray([1,2,3]);
   *  var res = Rx.Observable.fromArray([1,2,3], Rx.Scheduler.timeout);
   * @param {Scheduler} [scheduler] Scheduler to run the enumeration of the input sequence on.
   * @returns {Observable} The observable sequence whose elements are pulled from the given enumerable sequence.
   */
  var observableFromArray = Observable.fromArray = function (array, scheduler) {
    scheduler || (scheduler = currentThreadScheduler);
    return new AnonymousObservable(function (observer) {
      var count = 0, len = array.length;
      return scheduler.scheduleRecursive(function (self) {
        if (count < len) {
          observer.onNext(array[count++]);
          self();
        } else {
          observer.onCompleted();
        }
      });
    });
  };

  /**
   *  Converts an iterable into an Observable sequence
   *  
   * @example
   *  var res = Rx.Observable.fromIterable(new Map());
   *  var res = Rx.Observable.fromIterable(new Set(), Rx.Scheduler.timeout);
   * @param {Scheduler} [scheduler] Scheduler to run the enumeration of the input sequence on.
   * @returns {Observable} The observable sequence whose elements are pulled from the given generator sequence.
   */
  Observable.fromIterable = function (iterable, scheduler) {
    scheduler || (scheduler = currentThreadScheduler);
    return new AnonymousObservable(function (observer) {
      var iterator;
      try {
        iterator = iterable[$iterator$]();
      } catch (e) {
        observer.onError(e);
        return;
      }

      return scheduler.scheduleRecursive(function (self) {
        var next;
        try {
          next = iterator.next();
        } catch (err) {
          observer.onError(err);
          return;
        }

        if (next.done) {
          observer.onCompleted();
        } else {
          observer.onNext(next.value);
          self();
        }
      });
    });
  };

    /**
     *  Generates an observable sequence by running a state-driven loop producing the sequence's elements, using the specified scheduler to send out observer messages.
     *  
     * @example
     *  var res = Rx.Observable.generate(0, function (x) { return x < 10; }, function (x) { return x + 1; }, function (x) { return x; });
     *  var res = Rx.Observable.generate(0, function (x) { return x < 10; }, function (x) { return x + 1; }, function (x) { return x; }, Rx.Scheduler.timeout);
     * @param {Mixed} initialState Initial state.
     * @param {Function} condition Condition to terminate generation (upon returning false).
     * @param {Function} iterate Iteration step function.
     * @param {Function} resultSelector Selector function for results produced in the sequence.
     * @param {Scheduler} [scheduler] Scheduler on which to run the generator loop. If not provided, defaults to Scheduler.currentThread.
     * @returns {Observable} The generated sequence.
     */
    Observable.generate = function (initialState, condition, iterate, resultSelector, scheduler) {
        scheduler || (scheduler = currentThreadScheduler);
        return new AnonymousObservable(function (observer) {
            var first = true, state = initialState;
            return scheduler.scheduleRecursive(function (self) {
                var hasResult, result;
                try {
                    if (first) {
                        first = false;
                    } else {
                        state = iterate(state);
                    }
                    hasResult = condition(state);
                    if (hasResult) {
                        result = resultSelector(state);
                    }
                } catch (exception) {
                    observer.onError(exception);
                    return;
                }
                if (hasResult) {
                    observer.onNext(result);
                    self();
                } else {
                    observer.onCompleted();
                }
            });
        });
    };

    /**
     *  Returns a non-terminating observable sequence, which can be used to denote an infinite duration (e.g. when using reactive joins).
     * @returns {Observable} An observable sequence whose observers will never get called.
     */
    var observableNever = Observable.never = function () {
        return new AnonymousObservable(function () {
            return disposableEmpty;
        });
    };

  /**
   *  This method creates a new Observable instance with a variable number of arguments, regardless of number or type of the arguments.
   * @example
   *  var res = Rx.Observable.of(1,2,3);
   * @returns {Observable} The observable sequence whose elements are pulled from the given arguments.
   */
  Observable.of = function () {
    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    return observableFromArray(args);
  };

  /**
   *  This method creates a new Observable instance with a variable number of arguments, regardless of number or type of the arguments. 
   * @example
   *  var res = Rx.Observable.of(1,2,3);
   * @param {Scheduler} scheduler A scheduler to use for scheduling the arguments.
   * @returns {Observable} The observable sequence whose elements are pulled from the given arguments.
   */
  var observableOf = Observable.ofWithScheduler = function (scheduler) {
    var len = arguments.length - 1, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i + 1]; }
    return observableFromArray(args, scheduler);
  };

    /**
     *  Generates an observable sequence of integral numbers within a specified range, using the specified scheduler to send out observer messages.
     *  
     * @example
     *  var res = Rx.Observable.range(0, 10);
     *  var res = Rx.Observable.range(0, 10, Rx.Scheduler.timeout);
     * @param {Number} start The value of the first integer in the sequence.
     * @param {Number} count The number of sequential integers to generate.
     * @param {Scheduler} [scheduler] Scheduler to run the generator loop on. If not specified, defaults to Scheduler.currentThread.
     * @returns {Observable} An observable sequence that contains a range of sequential integral numbers.
     */
    Observable.range = function (start, count, scheduler) {
        scheduler || (scheduler = currentThreadScheduler);
        return new AnonymousObservable(function (observer) {
            return scheduler.scheduleRecursiveWithState(0, function (i, self) {
                if (i < count) {
                    observer.onNext(start + i);
                    self(i + 1);
                } else {
                    observer.onCompleted();
                }
            });
        });
    };

    /**
     *  Generates an observable sequence that repeats the given element the specified number of times, using the specified scheduler to send out observer messages.
     *  
     * @example
     *  var res = Rx.Observable.repeat(42);
     *  var res = Rx.Observable.repeat(42, 4);
     *  3 - res = Rx.Observable.repeat(42, 4, Rx.Scheduler.timeout);
     *  4 - res = Rx.Observable.repeat(42, null, Rx.Scheduler.timeout);
     * @param {Mixed} value Element to repeat.
     * @param {Number} repeatCount [Optiona] Number of times to repeat the element. If not specified, repeats indefinitely.
     * @param {Scheduler} scheduler Scheduler to run the producer loop on. If not specified, defaults to Scheduler.immediate.
     * @returns {Observable} An observable sequence that repeats the given element the specified number of times.
     */
    Observable.repeat = function (value, repeatCount, scheduler) {
        scheduler || (scheduler = currentThreadScheduler);
        if (repeatCount == null) {
            repeatCount = -1;
        }
        return observableReturn(value, scheduler).repeat(repeatCount);
    };

  /**
   *  Returns an observable sequence that contains a single element, using the specified scheduler to send out observer messages.
   *  There is an alias called 'just', and 'returnValue' for browsers <IE9.
   *  
   * @example
   *  var res = Rx.Observable.return(42);
   *  var res = Rx.Observable.return(42, Rx.Scheduler.timeout);
   * @param {Mixed} value Single element in the resulting observable sequence.
   * @param {Scheduler} scheduler Scheduler to send the single element on. If not specified, defaults to Scheduler.immediate.
   * @returns {Observable} An observable sequence containing the single specified element.
   */
  var observableReturn = Observable['return'] = Observable.returnValue = Observable.just = function (value, scheduler) {
    scheduler || (scheduler = immediateScheduler);
    return new AnonymousObservable(function (observer) {
      return scheduler.schedule(function () {
        observer.onNext(value);
        observer.onCompleted();
      });
    });
  };

    /**
     *  Returns an observable sequence that terminates with an exception, using the specified scheduler to send out the single onError message.
     *  There is an alias to this method called 'throwException' for browsers <IE9.
     *  
     * @example
     *  var res = Rx.Observable.throwException(new Error('Error'));
     *  var res = Rx.Observable.throwException(new Error('Error'), Rx.Scheduler.timeout);
     * @param {Mixed} exception An object used for the sequence's termination.
     * @param {Scheduler} scheduler Scheduler to send the exceptional termination call on. If not specified, defaults to Scheduler.immediate.
     * @returns {Observable} The observable sequence that terminates exceptionally with the specified exception object.
     */
    var observableThrow = Observable['throw'] = Observable.throwException = function (exception, scheduler) {
        scheduler || (scheduler = immediateScheduler);
        return new AnonymousObservable(function (observer) {
            return scheduler.schedule(function () {
                observer.onError(exception);
            });
        });
    };

  /**
   *  Constructs an observable sequence that depends on a resource object, whose lifetime is tied to the resulting observable sequence's lifetime.
   *  
   * @example
   *  var res = Rx.Observable.using(function () { return new AsyncSubject(); }, function (s) { return s; });
   * @param {Function} resourceFactory Factory function to obtain a resource object.
   * @param {Function} observableFactory Factory function to obtain an observable sequence that depends on the obtained resource.
   * @returns {Observable} An observable sequence whose lifetime controls the lifetime of the dependent resource object.
   */
  Observable.using = function (resourceFactory, observableFactory) {
    return new AnonymousObservable(function (observer) {
      var disposable = disposableEmpty, resource, source;
      try {
        resource = resourceFactory();
        if (resource) {
          disposable = resource;
        }
        source = observableFactory(resource);
      } catch (exception) {
        return new CompositeDisposable(observableThrow(exception).subscribe(observer), disposable);
      }
      return new CompositeDisposable(source.subscribe(observer), disposable);
    });
  };

  /**
   * Propagates the observable sequence or Promise that reacts first.
   * @param {Observable} rightSource Second observable sequence or Promise.
   * @returns {Observable} {Observable} An observable sequence that surfaces either of the given sequences, whichever reacted first.
   */  
  observableProto.amb = function (rightSource) {
    var leftSource = this;
    return new AnonymousObservable(function (observer) {
      var choice,
        leftChoice = 'L', rightChoice = 'R',
        leftSubscription = new SingleAssignmentDisposable(),
        rightSubscription = new SingleAssignmentDisposable();

      isPromise(rightSource) && (rightSource = observableFromPromise(rightSource));

      function choiceL() {
        if (!choice) {
          choice = leftChoice;
          rightSubscription.dispose();
        }
      }

      function choiceR() {
        if (!choice) {
          choice = rightChoice;
          leftSubscription.dispose();
        }
      }

      leftSubscription.setDisposable(leftSource.subscribe(function (left) {
        choiceL();
        if (choice === leftChoice) {
          observer.onNext(left);
        }
      }, function (err) {
        choiceL();
        if (choice === leftChoice) {
          observer.onError(err);
        }
      }, function () {
        choiceL();
        if (choice === leftChoice) {
          observer.onCompleted();
        }
      }));

      rightSubscription.setDisposable(rightSource.subscribe(function (right) {
        choiceR();
        if (choice === rightChoice) {
          observer.onNext(right);
        }
      }, function (err) {
        choiceR();
        if (choice === rightChoice) {
          observer.onError(err);
        }
      }, function () {
        choiceR();
        if (choice === rightChoice) {
          observer.onCompleted();
        }
      }));

      return new CompositeDisposable(leftSubscription, rightSubscription);
    });
  };

  /**
   * Propagates the observable sequence or Promise that reacts first.
   *
   * @example
   * var = Rx.Observable.amb(xs, ys, zs);
   * @returns {Observable} An observable sequence that surfaces any of the given sequences, whichever reacted first.
   */  
  Observable.amb = function () {
    var acc = observableNever(),
      items = argsOrArray(arguments, 0);
    function func(previous, current) {
      return previous.amb(current);
    }
    for (var i = 0, len = items.length; i < len; i++) {
      acc = func(acc, items[i]);
    }
    return acc;
  };

  function observableCatchHandler(source, handler) {
    return new AnonymousObservable(function (observer) {
      var d1 = new SingleAssignmentDisposable(), subscription = new SerialDisposable();
      subscription.setDisposable(d1);
      d1.setDisposable(source.subscribe(observer.onNext.bind(observer), function (exception) {
        var d, result;
        try {
          result = handler(exception);
        } catch (ex) {
          observer.onError(ex);
          return;
        }
        isPromise(result) && (result = observableFromPromise(result));

        d = new SingleAssignmentDisposable();
        subscription.setDisposable(d);
        d.setDisposable(result.subscribe(observer));
      }, observer.onCompleted.bind(observer)));
      
      return subscription;
    });
  }

  /**
   * Continues an observable sequence that is terminated by an exception with the next observable sequence.
   * @example
   * 1 - xs.catchException(ys)
   * 2 - xs.catchException(function (ex) { return ys(ex); })
   * @param {Mixed} handlerOrSecond Exception handler function that returns an observable sequence given the error that occurred in the first sequence, or a second observable sequence used to produce results when an error occurred in the first sequence.
   * @returns {Observable} An observable sequence containing the first sequence's elements, followed by the elements of the handler sequence in case an exception occurred.
   */      
  observableProto['catch'] = observableProto.catchException = function (handlerOrSecond) {
    return typeof handlerOrSecond === 'function' ?
      observableCatchHandler(this, handlerOrSecond) :
      observableCatch([this, handlerOrSecond]);
  };

    /**
     * Continues an observable sequence that is terminated by an exception with the next observable sequence.
     * 
     * @example
     * 1 - res = Rx.Observable.catchException(xs, ys, zs);
     * 2 - res = Rx.Observable.catchException([xs, ys, zs]);
     * @returns {Observable} An observable sequence containing elements from consecutive source sequences until a source sequence terminates successfully.
     */
    var observableCatch = Observable.catchException = Observable['catch'] = function () {
        var items = argsOrArray(arguments, 0);
        return enumerableFor(items).catchException();
    };

  /**
   * Merges the specified observable sequences into one observable sequence by using the selector function whenever any of the observable sequences or Promises produces an element.
   * This can be in the form of an argument list of observables or an array.
   *
   * @example
   * 1 - obs = observable.combineLatest(obs1, obs2, obs3, function (o1, o2, o3) { return o1 + o2 + o3; });
   * 2 - obs = observable.combineLatest([obs1, obs2, obs3], function (o1, o2, o3) { return o1 + o2 + o3; });
   * @returns {Observable} An observable sequence containing the result of combining elements of the sources using the specified result selector function. 
   */
  observableProto.combineLatest = function () {
    var args = slice.call(arguments);
    if (Array.isArray(args[0])) {
      args[0].unshift(this);
    } else {
      args.unshift(this);
    }
    return combineLatest.apply(this, args);
  };

  /**
   * Merges the specified observable sequences into one observable sequence by using the selector function whenever any of the observable sequences or Promises produces an element.
   * 
   * @example
   * 1 - obs = Rx.Observable.combineLatest(obs1, obs2, obs3, function (o1, o2, o3) { return o1 + o2 + o3; });
   * 2 - obs = Rx.Observable.combineLatest([obs1, obs2, obs3], function (o1, o2, o3) { return o1 + o2 + o3; });     
   * @returns {Observable} An observable sequence containing the result of combining elements of the sources using the specified result selector function.
   */
  var combineLatest = Observable.combineLatest = function () {
    var args = slice.call(arguments), resultSelector = args.pop();
    
    if (Array.isArray(args[0])) {
      args = args[0];
    }

    return new AnonymousObservable(function (observer) {
      var falseFactory = function () { return false; },
        n = args.length,
        hasValue = arrayInitialize(n, falseFactory),
        hasValueAll = false,
        isDone = arrayInitialize(n, falseFactory),
        values = new Array(n);

      function next(i) {
        var res;
        hasValue[i] = true;
        if (hasValueAll || (hasValueAll = hasValue.every(identity))) {
          try {
            res = resultSelector.apply(null, values);
          } catch (ex) {
            observer.onError(ex);
            return;
          }
          observer.onNext(res);
        } else if (isDone.filter(function (x, j) { return j !== i; }).every(identity)) {
          observer.onCompleted();
        }
      }

      function done (i) {
        isDone[i] = true;
        if (isDone.every(identity)) {
          observer.onCompleted();
        }
      }

      var subscriptions = new Array(n);
      for (var idx = 0; idx < n; idx++) {
        (function (i) {
          var source = args[i], sad = new SingleAssignmentDisposable();
          isPromise(source) && (source = observableFromPromise(source));
          sad.setDisposable(source.subscribe(function (x) {
            values[i] = x;
            next(i);
          }, observer.onError.bind(observer), function () {
            done(i);
          }));
          subscriptions[i] = sad;
        }(idx));
      }

      return new CompositeDisposable(subscriptions);
    });
  };

    /**
     * Concatenates all the observable sequences.  This takes in either an array or variable arguments to concatenate.
     * 
     * @example
     * 1 - concatenated = xs.concat(ys, zs);
     * 2 - concatenated = xs.concat([ys, zs]);
     * @returns {Observable} An observable sequence that contains the elements of each given sequence, in sequential order. 
     */ 
    observableProto.concat = function () {
        var items = slice.call(arguments, 0);
        items.unshift(this);
        return observableConcat.apply(this, items);
    };

    /**
     * Concatenates all the observable sequences.
     * 
     * @example
     * 1 - res = Rx.Observable.concat(xs, ys, zs);
     * 2 - res = Rx.Observable.concat([xs, ys, zs]);
     * @returns {Observable} An observable sequence that contains the elements of each given sequence, in sequential order. 
     */
    var observableConcat = Observable.concat = function () {
        var sources = argsOrArray(arguments, 0);
        return enumerableFor(sources).concat();
    };  

    /**
     * Concatenates an observable sequence of observable sequences.
     * @returns {Observable} An observable sequence that contains the elements of each observed inner sequence, in sequential order. 
     */ 
    observableProto.concatObservable = observableProto.concatAll =function () {
        return this.merge(1);
    };

    /**
     * Merges an observable sequence of observable sequences into an observable sequence, limiting the number of concurrent subscriptions to inner sequences.
     * Or merges two observable sequences into a single observable sequence.
     * 
     * @example
     * 1 - merged = sources.merge(1);
     * 2 - merged = source.merge(otherSource);  
     * @param {Mixed} [maxConcurrentOrOther] Maximum number of inner observable sequences being subscribed to concurrently or the second observable sequence.
     * @returns {Observable} The observable sequence that merges the elements of the inner sequences. 
     */ 
    observableProto.merge = function (maxConcurrentOrOther) {
        if (typeof maxConcurrentOrOther !== 'number') {
            return observableMerge(this, maxConcurrentOrOther);
        }
        var sources = this;
        return new AnonymousObservable(function (observer) {
            var activeCount = 0,
                group = new CompositeDisposable(),
                isStopped = false,
                q = [],
                subscribe = function (xs) {
                    var subscription = new SingleAssignmentDisposable();
                    group.add(subscription);

                    // Check for promises support
                    if (isPromise(xs)) { xs = observableFromPromise(xs); }

                    subscription.setDisposable(xs.subscribe(observer.onNext.bind(observer), observer.onError.bind(observer), function () {
                        var s;
                        group.remove(subscription);
                        if (q.length > 0) {
                            s = q.shift();
                            subscribe(s);
                        } else {
                            activeCount--;
                            if (isStopped && activeCount === 0) {
                                observer.onCompleted();
                            }
                        }
                    }));
                };
            group.add(sources.subscribe(function (innerSource) {
                if (activeCount < maxConcurrentOrOther) {
                    activeCount++;
                    subscribe(innerSource);
                } else {
                    q.push(innerSource);
                }
            }, observer.onError.bind(observer), function () {
                isStopped = true;
                if (activeCount === 0) {
                    observer.onCompleted();
                }
            }));
            return group;
        });
    };

    /**
     * Merges all the observable sequences into a single observable sequence.  
     * The scheduler is optional and if not specified, the immediate scheduler is used.
     * 
     * @example
     * 1 - merged = Rx.Observable.merge(xs, ys, zs);
     * 2 - merged = Rx.Observable.merge([xs, ys, zs]);
     * 3 - merged = Rx.Observable.merge(scheduler, xs, ys, zs);
     * 4 - merged = Rx.Observable.merge(scheduler, [xs, ys, zs]);    
     * @returns {Observable} The observable sequence that merges the elements of the observable sequences. 
     */  
    var observableMerge = Observable.merge = function () {
        var scheduler, sources;
        if (!arguments[0]) {
            scheduler = immediateScheduler;
            sources = slice.call(arguments, 1);
        } else if (arguments[0].now) {
            scheduler = arguments[0];
            sources = slice.call(arguments, 1);
        } else {
            scheduler = immediateScheduler;
            sources = slice.call(arguments, 0);
        }
        if (Array.isArray(sources[0])) {
            sources = sources[0];
        }
        return observableFromArray(sources, scheduler).mergeObservable();
    };   

  /**
   * Merges an observable sequence of observable sequences into an observable sequence.
   * @returns {Observable} The observable sequence that merges the elements of the inner sequences.   
   */  
  observableProto.mergeObservable = observableProto.mergeAll =function () {
    var sources = this;
    return new AnonymousObservable(function (observer) {
      var group = new CompositeDisposable(),
        isStopped = false,
        m = new SingleAssignmentDisposable();

      group.add(m);
      m.setDisposable(sources.subscribe(function (innerSource) {
        var innerSubscription = new SingleAssignmentDisposable();
        group.add(innerSubscription);

        // Check if Promise or Observable
        if (isPromise(innerSource)) {
            innerSource = observableFromPromise(innerSource);
        }

        innerSubscription.setDisposable(innerSource.subscribe(function (x) {
            observer.onNext(x);
        }, observer.onError.bind(observer), function () {
            group.remove(innerSubscription);
            if (isStopped && group.length === 1) { observer.onCompleted(); }
        }));
      }, observer.onError.bind(observer), function () {
        isStopped = true;
        if (group.length === 1) { observer.onCompleted(); }
      }));
      return group;
    });
  };

  /**
   * Continues an observable sequence that is terminated normally or by an exception with the next observable sequence.
   * @param {Observable} second Second observable sequence used to produce results after the first sequence terminates.
   * @returns {Observable} An observable sequence that concatenates the first and second sequence, even if the first sequence terminates exceptionally.
   */
  observableProto.onErrorResumeNext = function (second) {
    if (!second) {
      throw new Error('Second observable is required');
    }
    return onErrorResumeNext([this, second]);
  };

  /**
   * Continues an observable sequence that is terminated normally or by an exception with the next observable sequence.
   * 
   * @example
   * 1 - res = Rx.Observable.onErrorResumeNext(xs, ys, zs);
   * 1 - res = Rx.Observable.onErrorResumeNext([xs, ys, zs]);
   * @returns {Observable} An observable sequence that concatenates the source sequences, even if a sequence terminates exceptionally.   
   */
  var onErrorResumeNext = Observable.onErrorResumeNext = function () {
    var sources = argsOrArray(arguments, 0);
    return new AnonymousObservable(function (observer) {
      var pos = 0, subscription = new SerialDisposable(),
      cancelable = immediateScheduler.scheduleRecursive(function (self) {
        var current, d;
        if (pos < sources.length) {
          current = sources[pos++];
          isPromise(current) && (current = observableFromPromise(current));
          d = new SingleAssignmentDisposable();
          subscription.setDisposable(d);
          d.setDisposable(current.subscribe(observer.onNext.bind(observer), function () {
              self();
          }, function () {
              self();
          }));
        } else {
          observer.onCompleted();
        }
      });
      return new CompositeDisposable(subscription, cancelable);
    });
  };

  /**
   * Returns the values from the source observable sequence only after the other observable sequence produces a value.
   * @param {Observable | Promise} other The observable sequence or Promise that triggers propagation of elements of the source sequence.
   * @returns {Observable} An observable sequence containing the elements of the source sequence starting from the point the other sequence triggered propagation.    
   */
  observableProto.skipUntil = function (other) {
    var source = this;
    return new AnonymousObservable(function (observer) {
      var isOpen = false;
      var disposables = new CompositeDisposable(source.subscribe(function (left) {
        isOpen && observer.onNext(left);
      }, observer.onError.bind(observer), function () {
        isOpen && observer.onCompleted();
      }));

      isPromise(other) && (other = observableFromPromise(other));

      var rightSubscription = new SingleAssignmentDisposable();
      disposables.add(rightSubscription);
      rightSubscription.setDisposable(other.subscribe(function () {
        isOpen = true;
        rightSubscription.dispose();
      }, observer.onError.bind(observer), function () {
        rightSubscription.dispose();
      }));

      return disposables;
    });
  };

    /**
     * Transforms an observable sequence of observable sequences into an observable sequence producing values only from the most recent observable sequence.
     * @returns {Observable} The observable sequence that at any point in time produces the elements of the most recent inner observable sequence that has been received.  
     */
    observableProto['switch'] = observableProto.switchLatest = function () {
        var sources = this;
        return new AnonymousObservable(function (observer) {
            var hasLatest = false,
                innerSubscription = new SerialDisposable(),
                isStopped = false,
                latest = 0,
                subscription = sources.subscribe(function (innerSource) {
                    var d = new SingleAssignmentDisposable(), id = ++latest;
                    hasLatest = true;
                    innerSubscription.setDisposable(d);

                    // Check if Promise or Observable
                    if (isPromise(innerSource)) {
                        innerSource = observableFromPromise(innerSource);
                    }

                    d.setDisposable(innerSource.subscribe(function (x) {
                        if (latest === id) {
                            observer.onNext(x);
                        }
                    }, function (e) {
                        if (latest === id) {
                            observer.onError(e);
                        }
                    }, function () {
                        if (latest === id) {
                            hasLatest = false;
                            if (isStopped) {
                                observer.onCompleted();
                            }
                        }
                    }));
                }, observer.onError.bind(observer), function () {
                    isStopped = true;
                    if (!hasLatest) {
                        observer.onCompleted();
                    }
                });
            return new CompositeDisposable(subscription, innerSubscription);
        });
    };

  /**
   * Returns the values from the source observable sequence until the other observable sequence produces a value.
   * @param {Observable | Promise} other Observable sequence or Promise that terminates propagation of elements of the source sequence.
   * @returns {Observable} An observable sequence containing the elements of the source sequence up to the point the other sequence interrupted further propagation.   
   */
  observableProto.takeUntil = function (other) {
    var source = this;
    return new AnonymousObservable(function (observer) {
      isPromise(other) && (other = observableFromPromise(other));
      return new CompositeDisposable(
        source.subscribe(observer),
        other.subscribe(observer.onCompleted.bind(observer), observer.onError.bind(observer), noop)
      );
    });
  };

  function zipArray(second, resultSelector) {
    var first = this;
    return new AnonymousObservable(function (observer) {
      var index = 0, len = second.length;
      return first.subscribe(function (left) {
        if (index < len) {
          var right = second[index++], result;
          try {
            result = resultSelector(left, right);
          } catch (e) {
            observer.onError(e);
            return;
          }
          observer.onNext(result);
        } else {
          observer.onCompleted();
        }
      }, observer.onError.bind(observer), observer.onCompleted.bind(observer));
    });
  }    

  /**
   * Merges the specified observable sequences into one observable sequence by using the selector function whenever all of the observable sequences or an array have produced an element at a corresponding index.
   * The last element in the arguments must be a function to invoke for each series of elements at corresponding indexes in the sources.
   *
   * @example
   * 1 - res = obs1.zip(obs2, fn);
   * 1 - res = x1.zip([1,2,3], fn);  
   * @returns {Observable} An observable sequence containing the result of combining elements of the sources using the specified result selector function. 
   */   
  observableProto.zip = function () {
    if (Array.isArray(arguments[0])) {
      return zipArray.apply(this, arguments);
    }
    var parent = this, sources = slice.call(arguments), resultSelector = sources.pop();
    sources.unshift(parent);
    return new AnonymousObservable(function (observer) {
      var n = sources.length,
        queues = arrayInitialize(n, function () { return []; }),
        isDone = arrayInitialize(n, function () { return false; });
        
      function next(i) {
        var res, queuedValues;
        if (queues.every(function (x) { return x.length > 0; })) {
          try {
            queuedValues = queues.map(function (x) { return x.shift(); });
            res = resultSelector.apply(parent, queuedValues);
          } catch (ex) {
            observer.onError(ex);
            return;
          }
          observer.onNext(res);
        } else if (isDone.filter(function (x, j) { return j !== i; }).every(identity)) {
          observer.onCompleted();
        }
      };

      function done(i) {
        isDone[i] = true;
        if (isDone.every(function (x) { return x; })) {
          observer.onCompleted();
        }
      }

      var subscriptions = new Array(n);
      for (var idx = 0; idx < n; idx++) {
        (function (i) {
          var source = sources[i], sad = new SingleAssignmentDisposable();
          isPromise(source) && (source = observableFromPromise(source));
          sad.setDisposable(source.subscribe(function (x) {
            queues[i].push(x);
            next(i);
          }, observer.onError.bind(observer), function () {
            done(i);
          }));
          subscriptions[i] = sad;
        })(idx);
      }

      return new CompositeDisposable(subscriptions);
    });
  };
    /**
     * Merges the specified observable sequences into one observable sequence by using the selector function whenever all of the observable sequences have produced an element at a corresponding index.
     * @param arguments Observable sources.
     * @param {Function} resultSelector Function to invoke for each series of elements at corresponding indexes in the sources.
     * @returns {Observable} An observable sequence containing the result of combining elements of the sources using the specified result selector function.
     */
    Observable.zip = function () {
        var args = slice.call(arguments, 0),
            first = args.shift();
        return first.zip.apply(first, args);
    };

    /**
     * Merges the specified observable sequences into one observable sequence by emitting a list with the elements of the observable sequences at corresponding indexes.
     * @param arguments Observable sources.
     * @returns {Observable} An observable sequence containing lists of elements at corresponding indexes.
     */
    Observable.zipArray = function () {
        var sources = argsOrArray(arguments, 0);
        return new AnonymousObservable(function (observer) {
            var n = sources.length,
              queues = arrayInitialize(n, function () { return []; }),
              isDone = arrayInitialize(n, function () { return false; });

            function next(i) {
                if (queues.every(function (x) { return x.length > 0; })) {
                    var res = queues.map(function (x) { return x.shift(); });
                    observer.onNext(res);
                } else if (isDone.filter(function (x, j) { return j !== i; }).every(identity)) {
                    observer.onCompleted();
                    return;
                }
            };

            function done(i) {
                isDone[i] = true;
                if (isDone.every(identity)) {
                    observer.onCompleted();
                    return;
                }
            }

            var subscriptions = new Array(n);
            for (var idx = 0; idx < n; idx++) {
                (function (i) {
                    subscriptions[i] = new SingleAssignmentDisposable();
                    subscriptions[i].setDisposable(sources[i].subscribe(function (x) {
                        queues[i].push(x);
                        next(i);
                    }, observer.onError.bind(observer), function () {
                        done(i);
                    }));
                })(idx);
            }

            var compositeDisposable = new CompositeDisposable(subscriptions);
            compositeDisposable.add(disposableCreate(function () {
                for (var qIdx = 0, qLen = queues.length; qIdx < qLen; qIdx++) {
                    queues[qIdx] = [];
                }
            }));
            return compositeDisposable;
        });
    };

    /**
     *  Hides the identity of an observable sequence.
     * @returns {Observable} An observable sequence that hides the identity of the source sequence.    
     */
    observableProto.asObservable = function () {
        var source = this;
        return new AnonymousObservable(function (observer) {
            return source.subscribe(observer);
        });
    };

  /**
   *  Projects each element of an observable sequence into zero or more buffers which are produced based on element count information.
   *  
   * @example
   *  var res = xs.bufferWithCount(10);
   *  var res = xs.bufferWithCount(10, 1);
   * @param {Number} count Length of each buffer.
   * @param {Number} [skip] Number of elements to skip between creation of consecutive buffers. If not provided, defaults to the count.
   * @returns {Observable} An observable sequence of buffers.    
   */
  observableProto.bufferWithCount = function (count, skip) {
    if (typeof skip !== 'number') {
      skip = count;
    }
    return this.windowWithCount(count, skip).selectMany(function (x) {
      return x.toArray();
    }).where(function (x) {
      return x.length > 0;
    });
  };

    /**
     * Dematerializes the explicit notification values of an observable sequence as implicit notifications.
     * @returns {Observable} An observable sequence exhibiting the behavior corresponding to the source sequence's notification values.
     */ 
    observableProto.dematerialize = function () {
        var source = this;
        return new AnonymousObservable(function (observer) {
            return source.subscribe(function (x) {
                return x.accept(observer);
            }, observer.onError.bind(observer), observer.onCompleted.bind(observer));
        });
    };

    /**
     *  Returns an observable sequence that contains only distinct contiguous elements according to the keySelector and the comparer.
     *  
     *  var obs = observable.distinctUntilChanged();
     *  var obs = observable.distinctUntilChanged(function (x) { return x.id; });
     *  var obs = observable.distinctUntilChanged(function (x) { return x.id; }, function (x, y) { return x === y; });
     *
     * @param {Function} [keySelector] A function to compute the comparison key for each element. If not provided, it projects the value.
     * @param {Function} [comparer] Equality comparer for computed key values. If not provided, defaults to an equality comparer function.
     * @returns {Observable} An observable sequence only containing the distinct contiguous elements, based on a computed key value, from the source sequence.   
     */
    observableProto.distinctUntilChanged = function (keySelector, comparer) {
        var source = this;
        keySelector || (keySelector = identity);
        comparer || (comparer = defaultComparer);
        return new AnonymousObservable(function (observer) {
            var hasCurrentKey = false, currentKey;
            return source.subscribe(function (value) {
                var comparerEquals = false, key;
                try {
                    key = keySelector(value);
                } catch (exception) {
                    observer.onError(exception);
                    return;
                }
                if (hasCurrentKey) {
                    try {
                        comparerEquals = comparer(currentKey, key);
                    } catch (exception) {
                        observer.onError(exception);
                        return;
                    }
                }
                if (!hasCurrentKey || !comparerEquals) {
                    hasCurrentKey = true;
                    currentKey = key;
                    observer.onNext(value);
                }
            }, observer.onError.bind(observer), observer.onCompleted.bind(observer));
        });
    };

    /**
     *  Invokes an action for each element in the observable sequence and invokes an action upon graceful or exceptional termination of the observable sequence.
     *  This method can be used for debugging, logging, etc. of query behavior by intercepting the message stream to run arbitrary actions for messages on the pipeline.
     *  
     * @example
     *  var res = observable.doAction(observer);
     *  var res = observable.doAction(onNext);
     *  var res = observable.doAction(onNext, onError);
     *  var res = observable.doAction(onNext, onError, onCompleted);
     * @param {Mixed} observerOrOnNext Action to invoke for each element in the observable sequence or an observer.
     * @param {Function} [onError]  Action to invoke upon exceptional termination of the observable sequence. Used if only the observerOrOnNext parameter is also a function.
     * @param {Function} [onCompleted]  Action to invoke upon graceful termination of the observable sequence. Used if only the observerOrOnNext parameter is also a function.
     * @returns {Observable} The source sequence with the side-effecting behavior applied.   
     */
    observableProto['do'] = observableProto.doAction = function (observerOrOnNext, onError, onCompleted) {
        var source = this, onNextFunc;
        if (typeof observerOrOnNext === 'function') {
            onNextFunc = observerOrOnNext;
        } else {
            onNextFunc = observerOrOnNext.onNext.bind(observerOrOnNext);
            onError = observerOrOnNext.onError.bind(observerOrOnNext);
            onCompleted = observerOrOnNext.onCompleted.bind(observerOrOnNext);
        }
        return new AnonymousObservable(function (observer) {
            return source.subscribe(function (x) {
                try {
                    onNextFunc(x);
                } catch (e) {
                    observer.onError(e);
                }
                observer.onNext(x);
            }, function (exception) {
                if (!onError) {
                    observer.onError(exception);
                } else {
                    try {
                        onError(exception);
                    } catch (e) {
                        observer.onError(e);
                    }
                    observer.onError(exception);
                }
            }, function () {
                if (!onCompleted) {
                    observer.onCompleted();
                } else {
                    try {
                        onCompleted();
                    } catch (e) {
                        observer.onError(e);
                    }
                    observer.onCompleted();
                }
            });
        });
    };

  /**
   *  Invokes a specified action after the source observable sequence terminates gracefully or exceptionally.
   *  
   * @example
   *  var res = observable.finallyAction(function () { console.log('sequence ended'; });
   * @param {Function} finallyAction Action to invoke after the source observable sequence terminates.
   * @returns {Observable} Source sequence with the action-invoking termination behavior applied. 
   */  
  observableProto['finally'] = observableProto.finallyAction = function (action) {
    var source = this;
    return new AnonymousObservable(function (observer) {
      var subscription;
      try {
        subscription = source.subscribe(observer);
      } catch (e) {
        action();
        throw e;
      }
      return disposableCreate(function () {
        try {
          subscription.dispose();
        } catch (e) { 
          throw e;                    
        } finally {
          action();
        }
      });
    });
  };

    /**
     *  Ignores all elements in an observable sequence leaving only the termination messages.
     * @returns {Observable} An empty observable sequence that signals termination, successful or exceptional, of the source sequence.    
     */
    observableProto.ignoreElements = function () {
        var source = this;
        return new AnonymousObservable(function (observer) {
            return source.subscribe(noop, observer.onError.bind(observer), observer.onCompleted.bind(observer));
        });
    };

    /**
     *  Materializes the implicit notifications of an observable sequence as explicit notification values.
     * @returns {Observable} An observable sequence containing the materialized notification values from the source sequence.
     */    
    observableProto.materialize = function () {
        var source = this;
        return new AnonymousObservable(function (observer) {
            return source.subscribe(function (value) {
                observer.onNext(notificationCreateOnNext(value));
            }, function (e) {
                observer.onNext(notificationCreateOnError(e));
                observer.onCompleted();
            }, function () {
                observer.onNext(notificationCreateOnCompleted());
                observer.onCompleted();
            });
        });
    };

    /**
     *  Repeats the observable sequence a specified number of times. If the repeat count is not specified, the sequence repeats indefinitely.
     *  
     * @example
     *  var res = repeated = source.repeat();
     *  var res = repeated = source.repeat(42);
     * @param {Number} [repeatCount]  Number of times to repeat the sequence. If not provided, repeats the sequence indefinitely.
     * @returns {Observable} The observable sequence producing the elements of the given sequence repeatedly.   
     */
    observableProto.repeat = function (repeatCount) {
        return enumerableRepeat(this, repeatCount).concat();
    };

    /**
     *  Repeats the source observable sequence the specified number of times or until it successfully terminates. If the retry count is not specified, it retries indefinitely.
     *  
     * @example
     *  var res = retried = retry.repeat();
     *  var res = retried = retry.repeat(42);
     * @param {Number} [retryCount]  Number of times to retry the sequence. If not provided, retry the sequence indefinitely.
     * @returns {Observable} An observable sequence producing the elements of the given sequence repeatedly until it terminates successfully. 
     */
    observableProto.retry = function (retryCount) {
        return enumerableRepeat(this, retryCount).catchException();
    };

    /**
     *  Applies an accumulator function over an observable sequence and returns each intermediate result. The optional seed value is used as the initial accumulator value.
     *  For aggregation behavior with no intermediate results, see Observable.aggregate.
     * @example
     *  var res = source.scan(function (acc, x) { return acc + x; });
     *  var res = source.scan(0, function (acc, x) { return acc + x; });
     * @param {Mixed} [seed] The initial accumulator value.
     * @param {Function} accumulator An accumulator function to be invoked on each element.
     * @returns {Observable} An observable sequence containing the accumulated values.
     */
    observableProto.scan = function () {
        var hasSeed = false, seed, accumulator, source = this;
        if (arguments.length === 2) {
            hasSeed = true;
            seed = arguments[0];
            accumulator = arguments[1];        
        } else {
            accumulator = arguments[0];
        }
        return new AnonymousObservable(function (observer) {
            var hasAccumulation, accumulation, hasValue;
            return source.subscribe (
                function (x) {
                    try {
                        if (!hasValue) {
                            hasValue = true;
                        }
     
                        if (hasAccumulation) {
                            accumulation = accumulator(accumulation, x);
                        } else {
                            accumulation = hasSeed ? accumulator(seed, x) : x;
                            hasAccumulation = true;
                        }                    
                    } catch (e) {
                        observer.onError(e);
                        return;
                    }
     
                    observer.onNext(accumulation);
                },
                observer.onError.bind(observer),
                function () {
                    if (!hasValue && hasSeed) {
                        observer.onNext(seed);
                    }
                    observer.onCompleted();
                }
            );
        });
    };

    /**
     *  Bypasses a specified number of elements at the end of an observable sequence.
     * @description
     *  This operator accumulates a queue with a length enough to store the first `count` elements. As more elements are
     *  received, elements are taken from the front of the queue and produced on the result sequence. This causes elements to be delayed.     
     * @param count Number of elements to bypass at the end of the source sequence.
     * @returns {Observable} An observable sequence containing the source sequence elements except for the bypassed ones at the end.   
     */
    observableProto.skipLast = function (count) {
        var source = this;
        return new AnonymousObservable(function (observer) {
            var q = [];
            return source.subscribe(function (x) {
                q.push(x);
                if (q.length > count) {
                    observer.onNext(q.shift());
                }
            }, observer.onError.bind(observer), observer.onCompleted.bind(observer));
        });
    };

    /**
     *  Prepends a sequence of values to an observable sequence with an optional scheduler and an argument list of values to prepend.
     *  
     *  var res = source.startWith(1, 2, 3);
     *  var res = source.startWith(Rx.Scheduler.timeout, 1, 2, 3);
     *  
     * @memberOf Observable#
     * @returns {Observable} The source sequence prepended with the specified values.  
     */
    observableProto.startWith = function () {
        var values, scheduler, start = 0;
        if (!!arguments.length && 'now' in Object(arguments[0])) {
            scheduler = arguments[0];
            start = 1;
        } else {
            scheduler = immediateScheduler;
        }
        values = slice.call(arguments, start);
        return enumerableFor([observableFromArray(values, scheduler), this]).concat();
    };

    /**
     *  Returns a specified number of contiguous elements from the end of an observable sequence, using an optional scheduler to drain the queue.
     *  
     * @example
     *  var res = source.takeLast(5);
     *  var res = source.takeLast(5, Rx.Scheduler.timeout);
     *  
     * @description
     *  This operator accumulates a buffer with a length enough to store elements count elements. Upon completion of
     *  the source sequence, this buffer is drained on the result sequence. This causes the elements to be delayed.
     * @param {Number} count Number of elements to take from the end of the source sequence.
     * @param {Scheduler} [scheduler] Scheduler used to drain the queue upon completion of the source sequence.
     * @returns {Observable} An observable sequence containing the specified number of elements from the end of the source sequence.
     */   
    observableProto.takeLast = function (count, scheduler) {
        return this.takeLastBuffer(count).selectMany(function (xs) { return observableFromArray(xs, scheduler); });
    };

    /**
     *  Returns an array with the specified number of contiguous elements from the end of an observable sequence.
     *  
     * @description
     *  This operator accumulates a buffer with a length enough to store count elements. Upon completion of the
     *  source sequence, this buffer is produced on the result sequence.       
     * @param {Number} count Number of elements to take from the end of the source sequence.
     * @returns {Observable} An observable sequence containing a single array with the specified number of elements from the end of the source sequence.
     */
    observableProto.takeLastBuffer = function (count) {
        var source = this;
        return new AnonymousObservable(function (observer) {
            var q = [];
            return source.subscribe(function (x) {
                q.push(x);
                if (q.length > count) {
                    q.shift();
                }
            }, observer.onError.bind(observer), function () {
                observer.onNext(q);
                observer.onCompleted();
            });
        });
    };

    /**
     *  Projects each element of an observable sequence into zero or more windows which are produced based on element count information.
     *  
     *  var res = xs.windowWithCount(10);
     *  var res = xs.windowWithCount(10, 1);
     * @param {Number} count Length of each window.
     * @param {Number} [skip] Number of elements to skip between creation of consecutive windows. If not specified, defaults to the count.
     * @returns {Observable} An observable sequence of windows.  
     */
    observableProto.windowWithCount = function (count, skip) {
        var source = this;
        if (count <= 0) {
            throw new Error(argumentOutOfRange);
        }
        if (arguments.length === 1) {
            skip = count;
        }
        if (skip <= 0) {
            throw new Error(argumentOutOfRange);
        }
        return new AnonymousObservable(function (observer) {
            var m = new SingleAssignmentDisposable(),
                refCountDisposable = new RefCountDisposable(m),
                n = 0,
                q = [],
                createWindow = function () {
                    var s = new Subject();
                    q.push(s);
                    observer.onNext(addRef(s, refCountDisposable));
                };
            createWindow();
            m.setDisposable(source.subscribe(function (x) {
                var s;
                for (var i = 0, len = q.length; i < len; i++) {
                    q[i].onNext(x);
                }
                var c = n - count + 1;
                if (c >= 0 && c % skip === 0) {
                    s = q.shift();
                    s.onCompleted();
                }
                n++;
                if (n % skip === 0) {
                    createWindow();
                }
            }, function (exception) {
                while (q.length > 0) {
                    q.shift().onError(exception);
                }
                observer.onError(exception);
            }, function () {
                while (q.length > 0) {
                    q.shift().onCompleted();
                }
                observer.onCompleted();
            }));
            return refCountDisposable;
        });
    };

    function concatMap(selector) {
      return this.map(function (x, i) {
        var result = selector(x, i);
        return isPromise(result) ? observableFromPromise(result) : result;
      }).concatAll();
    }

    function concatMapObserver(onNext, onError, onCompleted) {
      var source = this;
      return new AnonymousObservable(function (observer) {
        var index = 0;

        return source.subscribe(
          function (x) {
            observer.onNext(onNext(x, index++));
          },
          function (err) {
            observer.onNext(onError(err));
            observer.completed();
          }, 
          function () {
            observer.onNext(onCompleted());
            observer.onCompleted();
          });
      }).concatAll();
    }

    /**
     *  One of the Following:
     *  Projects each element of an observable sequence to an observable sequence and merges the resulting observable sequences into one observable sequence.
     *  
     * @example
     *  var res = source.selectMany(function (x) { return Rx.Observable.range(0, x); });
     *  Or:
     *  Projects each element of an observable sequence to an observable sequence, invokes the result selector for the source element and each of the corresponding inner sequence's elements, and merges the results into one observable sequence.
     *  
     *  var res = source.selectMany(function (x) { return Rx.Observable.range(0, x); }, function (x, y) { return x + y; });
     *  Or:
     *  Projects each element of the source observable sequence to the other observable sequence and merges the resulting observable sequences into one observable sequence.
     *  
     *  var res = source.selectMany(Rx.Observable.fromArray([1,2,3]));
     * @param selector A transform function to apply to each element or an observable sequence to project each element from the 
     * source sequence onto which could be either an observable or Promise.
     * @param {Function} [resultSelector]  A transform function to apply to each element of the intermediate sequence.
     * @returns {Observable} An observable sequence whose elements are the result of invoking the one-to-many transform function collectionSelector on each element of the input sequence and then mapping each of those sequence elements and their corresponding source element to a result element.   
     */
    observableProto.selectConcat = observableProto.concatMap = function (selector, resultSelector) {
      if (resultSelector) {
          return this.concatMap(function (x, i) {
            var selectorResult = selector(x, i),
              result = isPromise(selectorResult) ? observableFromPromise(selectorResult) : selectorResult;

            return result.map(function (y) {
              return resultSelector(x, y, i);
            });
          });
      }
      if (typeof selector === 'function') {
        return concatMap.call(this, selector);
      }
      return concatMap.call(this, function () {
        return selector;
      });
    };

    /**
     *  Returns the elements of the specified sequence or the specified value in a singleton sequence if the sequence is empty.
     *  
     *  var res = obs = xs.defaultIfEmpty();
     *  2 - obs = xs.defaultIfEmpty(false);
     *      
     * @memberOf Observable#
     * @param defaultValue The value to return if the sequence is empty. If not provided, this defaults to null.
     * @returns {Observable} An observable sequence that contains the specified default value if the source is empty; otherwise, the elements of the source itself. 
     */
    observableProto.defaultIfEmpty = function (defaultValue) {
        var source = this;
        if (defaultValue === undefined) {
            defaultValue = null;
        }
        return new AnonymousObservable(function (observer) {
            var found = false;
            return source.subscribe(function (x) {
                found = true;
                observer.onNext(x);
            }, observer.onError.bind(observer), function () {
                if (!found) {
                    observer.onNext(defaultValue);
                }
                observer.onCompleted();
            });
        });
    };

    /**
     *  Returns an observable sequence that contains only distinct elements according to the keySelector and the comparer.
     *  Usage of this operator should be considered carefully due to the maintenance of an internal lookup structure which can grow large. 
     * 
     * @example
     *  var res = obs = xs.distinct();
     *  2 - obs = xs.distinct(function (x) { return x.id; });
     *  2 - obs = xs.distinct(function (x) { return x.id; }, function (x) { return x.toString(); });  
     * @param {Function} [keySelector]  A function to compute the comparison key for each element.
     * @param {Function} [keySerializer]  Used to serialize the given object into a string for object comparison.
     * @returns {Observable} An observable sequence only containing the distinct elements, based on a computed key value, from the source sequence.
     */
   observableProto.distinct = function (keySelector, keySerializer) {
        var source = this;
        keySelector || (keySelector = identity);
        keySerializer || (keySerializer = defaultKeySerializer);
        return new AnonymousObservable(function (observer) {
            var hashSet = {};
            return source.subscribe(function (x) {
                var key, serializedKey, otherKey, hasMatch = false;
                try {
                    key = keySelector(x);
                    serializedKey = keySerializer(key);
                } catch (exception) {
                    observer.onError(exception);
                    return;
                }
                for (otherKey in hashSet) {
                    if (serializedKey === otherKey) {
                        hasMatch = true;
                        break;
                    }
                }
                if (!hasMatch) {
                    hashSet[serializedKey] = null;
                    observer.onNext(x);
                }
            }, observer.onError.bind(observer), observer.onCompleted.bind(observer));
        });
    };

    /**
     *  Groups the elements of an observable sequence according to a specified key selector function and comparer and selects the resulting elements by using a specified function.
     *  
     * @example
     *  var res = observable.groupBy(function (x) { return x.id; });
     *  2 - observable.groupBy(function (x) { return x.id; }), function (x) { return x.name; });
     *  3 - observable.groupBy(function (x) { return x.id; }), function (x) { return x.name; }, function (x) { return x.toString(); });
     * @param {Function} keySelector A function to extract the key for each element.
     * @param {Function} [elementSelector]  A function to map each source element to an element in an observable group.
     * @param {Function} [keySerializer]  Used to serialize the given object into a string for object comparison.
     * @returns {Observable} A sequence of observable groups, each of which corresponds to a unique key value, containing all elements that share that same key value.    
     */
    observableProto.groupBy = function (keySelector, elementSelector, keySerializer) {
        return this.groupByUntil(keySelector, elementSelector, function () {
            return observableNever();
        }, keySerializer);
    };

    /**
     *  Groups the elements of an observable sequence according to a specified key selector function.
     *  A duration selector function is used to control the lifetime of groups. When a group expires, it receives an OnCompleted notification. When a new element with the same
     *  key value as a reclaimed group occurs, the group will be reborn with a new lifetime request.
     *  
     * @example
     *  var res = observable.groupByUntil(function (x) { return x.id; }, null,  function () { return Rx.Observable.never(); });
     *  2 - observable.groupBy(function (x) { return x.id; }), function (x) { return x.name; },  function () { return Rx.Observable.never(); });
     *  3 - observable.groupBy(function (x) { return x.id; }), function (x) { return x.name; },  function () { return Rx.Observable.never(); }, function (x) { return x.toString(); });
     * @param {Function} keySelector A function to extract the key for each element.
     * @param {Function} durationSelector A function to signal the expiration of a group.
     * @param {Function} [keySerializer]  Used to serialize the given object into a string for object comparison.
     * @returns {Observable} 
     *  A sequence of observable groups, each of which corresponds to a unique key value, containing all elements that share that same key value.
     *  If a group's lifetime expires, a new group with the same key value can be created once an element with such a key value is encoutered.
     *      
     */
    observableProto.groupByUntil = function (keySelector, elementSelector, durationSelector, keySerializer) {
        var source = this;
        elementSelector || (elementSelector = identity);
        keySerializer || (keySerializer = defaultKeySerializer);
        return new AnonymousObservable(function (observer) {
            var map = {},
                groupDisposable = new CompositeDisposable(),
                refCountDisposable = new RefCountDisposable(groupDisposable);
            groupDisposable.add(source.subscribe(function (x) {
                var duration, durationGroup, element, fireNewMapEntry, group, key, serializedKey, md, writer, w;
                try {
                    key = keySelector(x);
                    serializedKey = keySerializer(key);
                } catch (e) {
                    for (w in map) {
                        map[w].onError(e);
                    }
                    observer.onError(e);
                    return;
                }
                fireNewMapEntry = false;
                try {
                    writer = map[serializedKey];
                    if (!writer) {
                        writer = new Subject();
                        map[serializedKey] = writer;
                        fireNewMapEntry = true;
                    }
                } catch (e) {
                    for (w in map) {
                        map[w].onError(e);
                    }
                    observer.onError(e);
                    return;
                }
                if (fireNewMapEntry) {
                    group = new GroupedObservable(key, writer, refCountDisposable);
                    durationGroup = new GroupedObservable(key, writer);
                    try {
                        duration = durationSelector(durationGroup);
                    } catch (e) {
                        for (w in map) {
                            map[w].onError(e);
                        }
                        observer.onError(e);
                        return;
                    }
                    observer.onNext(group);
                    md = new SingleAssignmentDisposable();
                    groupDisposable.add(md);
                    var expire = function  () {
                        if (serializedKey in map) {
                            delete map[serializedKey];
                            writer.onCompleted();
                        }
                        groupDisposable.remove(md);
                    };
                    md.setDisposable(duration.take(1).subscribe(noop, function (exn) {
                        for (w in map) {
                            map[w].onError(exn);
                        }
                        observer.onError(exn);
                    }, function () {
                        expire();
                    }));
                }
                try {
                    element = elementSelector(x);
                } catch (e) {
                    for (w in map) {
                        map[w].onError(e);
                    }
                    observer.onError(e);
                    return;
                }
                writer.onNext(element);
            }, function (ex) {
                for (var w in map) {
                    map[w].onError(ex);
                }
                observer.onError(ex);
            }, function () {
                for (var w in map) {
                    map[w].onCompleted();
                }
                observer.onCompleted();
            }));
            return refCountDisposable;
        });
    };

    /**
     *  Projects each element of an observable sequence into a new form by incorporating the element's index.
     * @param {Function} selector A transform function to apply to each source element; the second parameter of the function represents the index of the source element.
     * @param {Any} [thisArg] Object to use as this when executing callback.
     * @returns {Observable} An observable sequence whose elements are the result of invoking the transform function on each element of source. 
     */
    observableProto.select = observableProto.map = function (selector, thisArg) {
        var parent = this;
        return new AnonymousObservable(function (observer) {
            var count = 0;
            return parent.subscribe(function (value) {
                var result;
                try {
                    result = selector.call(thisArg, value, count++, parent);
                } catch (exception) {
                    observer.onError(exception);
                    return;
                }
                observer.onNext(result);
            }, observer.onError.bind(observer), observer.onCompleted.bind(observer));
        });
    };

    /**
     * Retrieves the value of a specified property from all elements in the Observable sequence.
     * @param {String} property The property to pluck.
     * @returns {Observable} Returns a new Observable sequence of property values.
     */
    observableProto.pluck = function (property) {
        return this.select(function (x) { return x[property]; });
    };

    function selectMany(selector) {
      return this.select(function (x, i) {
        var result = selector(x, i);
        return isPromise(result) ? observableFromPromise(result) : result;
      }).mergeObservable();
    }

    function selectManyObserver(onNext, onError, onCompleted) {
      var source = this;
      return new AnonymousObservable(function (observer) {
        var index = 0;

        return source.subscribe(
          function (x) {
            observer.onNext(onNext(x, index++));
          },
          function (err) {
            observer.onNext(onError(err));
            observer.completed();
          }, 
          function () {
            observer.onNext(onCompleted());
            observer.onCompleted();
          });
      }).mergeAll();
    }

    /**
     *  One of the Following:
     *  Projects each element of an observable sequence to an observable sequence and merges the resulting observable sequences into one observable sequence.
     *  
     * @example
     *  var res = source.selectMany(function (x) { return Rx.Observable.range(0, x); });
     *  Or:
     *  Projects each element of an observable sequence to an observable sequence, invokes the result selector for the source element and each of the corresponding inner sequence's elements, and merges the results into one observable sequence.
     *  
     *  var res = source.selectMany(function (x) { return Rx.Observable.range(0, x); }, function (x, y) { return x + y; });
     *  Or:
     *  Projects each element of the source observable sequence to the other observable sequence and merges the resulting observable sequences into one observable sequence.
     *  
     *  var res = source.selectMany(Rx.Observable.fromArray([1,2,3]));
     * @param selector A transform function to apply to each element or an observable sequence to project each element from the 
     * source sequence onto which could be either an observable or Promise.
     * @param {Function} [resultSelector]  A transform function to apply to each element of the intermediate sequence.
     * @returns {Observable} An observable sequence whose elements are the result of invoking the one-to-many transform function collectionSelector on each element of the input sequence and then mapping each of those sequence elements and their corresponding source element to a result element.   
     */
    observableProto.selectMany = observableProto.flatMap = function (selector, resultSelector) {
      if (resultSelector) {
          return this.selectMany(function (x, i) {
            var selectorResult = selector(x, i),
              result = isPromise(selectorResult) ? observableFromPromise(selectorResult) : selectorResult;

            return result.select(function (y) {
              return resultSelector(x, y, i);
            });
          });
      }
      if (typeof selector === 'function') {
        return selectMany.call(this, selector);
      }
      return selectMany.call(this, function () {
        return selector;
      });
    };

    /**
     *  Projects each element of an observable sequence into a new sequence of observable sequences by incorporating the element's index and then 
     *  transforms an observable sequence of observable sequences into an observable sequence producing values only from the most recent observable sequence.
     * @param {Function} selector A transform function to apply to each source element; the second parameter of the function represents the index of the source element.
     * @param {Any} [thisArg] Object to use as this when executing callback.
     * @returns {Observable} An observable sequence whose elements are the result of invoking the transform function on each element of source producing an Observable of Observable sequences 
     *  and that at any point in time produces the elements of the most recent inner observable sequence that has been received.
     */
    observableProto.selectSwitch = observableProto.flatMapLatest = observableProto.switchMap = function (selector, thisArg) {
        return this.select(selector, thisArg).switchLatest();
    };

    /**
     * Bypasses a specified number of elements in an observable sequence and then returns the remaining elements.
     * @param {Number} count The number of elements to skip before returning the remaining elements.
     * @returns {Observable} An observable sequence that contains the elements that occur after the specified index in the input sequence.   
     */
    observableProto.skip = function (count) {
        if (count < 0) {
            throw new Error(argumentOutOfRange);
        }
        var observable = this;
        return new AnonymousObservable(function (observer) {
            var remaining = count;
            return observable.subscribe(function (x) {
                if (remaining <= 0) {
                    observer.onNext(x);
                } else {
                    remaining--;
                }
            }, observer.onError.bind(observer), observer.onCompleted.bind(observer));
        });
    };

    /**
     *  Bypasses elements in an observable sequence as long as a specified condition is true and then returns the remaining elements.
     *  The element's index is used in the logic of the predicate function.
     *  
     *  var res = source.skipWhile(function (value) { return value < 10; });
     *  var res = source.skipWhile(function (value, index) { return value < 10 || index < 10; });
     * @param {Function} predicate A function to test each element for a condition; the second parameter of the function represents the index of the source element.
     * @param {Any} [thisArg] Object to use as this when executing callback.     
     * @returns {Observable} An observable sequence that contains the elements from the input sequence starting at the first element in the linear series that does not pass the test specified by predicate.   
     */
    observableProto.skipWhile = function (predicate, thisArg) {
        var source = this;
        return new AnonymousObservable(function (observer) {
            var i = 0, running = false;
            return source.subscribe(function (x) {
                if (!running) {
                    try {
                        running = !predicate.call(thisArg, x, i++, source);
                    } catch (e) {
                        observer.onError(e);
                        return;
                    }
                }
                if (running) {
                    observer.onNext(x);
                }
            }, observer.onError.bind(observer), observer.onCompleted.bind(observer));
        });
    };

    /**
     *  Returns a specified number of contiguous elements from the start of an observable sequence, using the specified scheduler for the edge case of take(0).
     *  
     *  var res = source.take(5);
     *  var res = source.take(0, Rx.Scheduler.timeout);
     * @param {Number} count The number of elements to return.
     * @param {Scheduler} [scheduler] Scheduler used to produce an OnCompleted message in case <paramref name="count count</paramref> is set to 0.
     * @returns {Observable} An observable sequence that contains the specified number of elements from the start of the input sequence.  
     */
    observableProto.take = function (count, scheduler) {
        if (count < 0) {
            throw new Error(argumentOutOfRange);
        }
        if (count === 0) {
            return observableEmpty(scheduler);
        }
        var observable = this;
        return new AnonymousObservable(function (observer) {
            var remaining = count;
            return observable.subscribe(function (x) {
                if (remaining > 0) {
                    remaining--;
                    observer.onNext(x);
                    if (remaining === 0) {
                        observer.onCompleted();
                    }
                }
            }, observer.onError.bind(observer), observer.onCompleted.bind(observer));
        });
    };

    /**
     *  Returns elements from an observable sequence as long as a specified condition is true.
     *  The element's index is used in the logic of the predicate function.
     *  
     * @example
     *  var res = source.takeWhile(function (value) { return value < 10; });
     *  var res = source.takeWhile(function (value, index) { return value < 10 || index < 10; });
     * @param {Function} predicate A function to test each element for a condition; the second parameter of the function represents the index of the source element.
     * @param {Any} [thisArg] Object to use as this when executing callback.     
     * @returns {Observable} An observable sequence that contains the elements from the input sequence that occur before the element at which the test no longer passes.  
     */
    observableProto.takeWhile = function (predicate, thisArg) {
        var observable = this;
        return new AnonymousObservable(function (observer) {
            var i = 0, running = true;
            return observable.subscribe(function (x) {
                if (running) {
                    try {
                        running = predicate.call(thisArg, x, i++, observable);
                    } catch (e) {
                        observer.onError(e);
                        return;
                    }
                    if (running) {
                        observer.onNext(x);
                    } else {
                        observer.onCompleted();
                    }
                }
            }, observer.onError.bind(observer), observer.onCompleted.bind(observer));
        });
    };

    /**
     *  Filters the elements of an observable sequence based on a predicate by incorporating the element's index.
     *  
     * @example
     *  var res = source.where(function (value) { return value < 10; });
     *  var res = source.where(function (value, index) { return value < 10 || index < 10; });
     * @param {Function} predicate A function to test each source element for a condition; the second parameter of the function represents the index of the source element.
     * @param {Any} [thisArg] Object to use as this when executing callback.
     * @returns {Observable} An observable sequence that contains elements from the input sequence that satisfy the condition.   
     */
    observableProto.where = observableProto.filter = function (predicate, thisArg) {
        var parent = this;
        return new AnonymousObservable(function (observer) {
            var count = 0;
            return parent.subscribe(function (value) {
                var shouldRun;
                try {
                    shouldRun = predicate.call(thisArg, value, count++, parent);
                } catch (exception) {
                    observer.onError(exception);
                    return;
                }
                if (shouldRun) {
                    observer.onNext(value);
                }
            }, observer.onError.bind(observer), observer.onCompleted.bind(observer));
        });
    };

  /*
   * Performs a exclusive waiting for the first to finish before subscribing to another observable.
   * Observables that come in between subscriptions will be dropped on the floor.
   * @returns {Observable} A exclusive observable with only the results that happen when subscribed.
   */
  observableProto.exclusive = function () {
    var sources = this;
    return new AnonymousObservable(function (observer) {
      var hasCurrent = false,
        isStopped = false,
        m = new SingleAssignmentDisposable(),
        g = new CompositeDisposable();

      g.add(m);

      m.setDisposable(sources.subscribe(
        function (innerSource) {
          if (!hasCurrent) {
            hasCurrent = true;
            
            isPromise(innerSource) && (innerSource = observableFromPromise(innerSource));

            var innerSubscription = new SingleAssignmentDisposable();
            g.add(innerSubscription);

            innerSubscription.setDisposable(innerSource.subscribe(
              observer.onNext.bind(observer),
              observer.onError.bind(observer),
              function () {
                g.remove(innerSubscription);
                hasCurrent = false;
                if (isStopped && g.length === 1) {
                  observer.onCompleted();
                }
            }));
          }
        },
        observer.onError.bind(observer),
        function () {
          isStopped = true;
          if (!hasCurrent && g.length === 1) { 
            observer.onCompleted();
          }
        }));

      return g;
    });
  };
  /*
   * Performs a exclusive map waiting for the first to finish before subscribing to another observable.
   * Observables that come in between subscriptions will be dropped on the floor.
   * @param {Function} selector Selector to invoke for every item in the current subscription.
   * @param {Any} [thisArg] An optional context to invoke with the selector parameter.
   * @returns {Observable} An exclusive observable with only the results that happen when subscribed.
   */
  observableProto.exclusiveMap = function (selector, thisArg) {
    var sources = this;
    return new AnonymousObservable(function (observer) {
      var index = 0,
        hasCurrent = false,
        isStopped = true,
        m = new SingleAssignmentDisposable(),
        g = new CompositeDisposable();

      g.add(m);

      m.setDisposable(sources.subscribe(
        function (innerSource) {

          if (!hasCurrent) {
            hasCurrent = true;          

            innerSubscription = new SingleAssignmentDisposable();
            g.add(innerSubscription);

            isPromise(innerSource) && (innerSource = observableFromPromise(innerSource));      

            innerSubscription.setDisposable(innerSource.subscribe(
              function (x) {
                var result;
                try {
                  result = selector.call(thisArg, x, index++, innerSource);
                } catch (e) {
                  observer.onError(e);
                  return;
                }

                observer.onNext(result);
              },
              observer.onError.bind(observer),
              function () {
                g.remove(innerSubscription);
                hasCurrent = false;

                if (isStopped && g.length === 1) {
                  observer.onCompleted();
                }
              }));
          }
        }, 
        observer.onError.bind(observer),
        function () {
          isStopped = true;
          if (g.length === 1 && !hasCurrent) {
            observer.onCompleted();
          }
        }));
      return g;
    });
  };
  var AnonymousObservable = Rx.AnonymousObservable = (function (__super__) {
    inherits(AnonymousObservable, __super__);

    // Fix subscriber to check for undefined or function returned to decorate as Disposable
    function fixSubscriber(subscriber) {
      if (typeof subscriber === 'undefined') {
        subscriber = disposableEmpty;
      } else if (typeof subscriber === 'function') {
        subscriber = disposableCreate(subscriber);
      }

      return subscriber;
    }

    function AnonymousObservable(subscribe) {
      if (!(this instanceof AnonymousObservable)) {
        return new AnonymousObservable(subscribe);
      }

      function s(observer) {
        var setDisposable = function () {
          try {
            autoDetachObserver.setDisposable(fixSubscriber(subscribe(autoDetachObserver)));
          } catch (e) {
            if (!autoDetachObserver.fail(e)) {
              throw e;
            } 
          }
        };

        var autoDetachObserver = new AutoDetachObserver(observer);
        if (currentThreadScheduler.scheduleRequired()) {
          currentThreadScheduler.schedule(setDisposable);
        } else {
          setDisposable();
        }

        return autoDetachObserver;
      }

      __super__.call(this, s);
    }

    return AnonymousObservable;

  }(Observable));

    /** @private */
    var AutoDetachObserver = (function (_super) {
        inherits(AutoDetachObserver, _super);

        function AutoDetachObserver(observer) {
            _super.call(this);
            this.observer = observer;
            this.m = new SingleAssignmentDisposable();
        }

        var AutoDetachObserverPrototype = AutoDetachObserver.prototype;

        AutoDetachObserverPrototype.next = function (value) {
            var noError = false;
            try {
                this.observer.onNext(value);
                noError = true;
            } catch (e) { 
                throw e;                
            } finally {
                if (!noError) {
                    this.dispose();
                }
            }
        };

        AutoDetachObserverPrototype.error = function (exn) {
            try {
                this.observer.onError(exn);
            } catch (e) { 
                throw e;                
            } finally {
                this.dispose();
            }
        };

        AutoDetachObserverPrototype.completed = function () {
            try {
                this.observer.onCompleted();
            } catch (e) { 
                throw e;                
            } finally {
                this.dispose();
            }
        };

        AutoDetachObserverPrototype.setDisposable = function (value) { this.m.setDisposable(value); };
        AutoDetachObserverPrototype.getDisposable = function (value) { return this.m.getDisposable(); };
        /* @private */
        AutoDetachObserverPrototype.disposable = function (value) {
            return arguments.length ? this.getDisposable() : setDisposable(value);
        };

        AutoDetachObserverPrototype.dispose = function () {
            _super.prototype.dispose.call(this);
            this.m.dispose();
        };

        return AutoDetachObserver;
    }(AbstractObserver));

    /** @private */
    var GroupedObservable = (function (_super) {
        inherits(GroupedObservable, _super);

        function subscribe(observer) {
            return this.underlyingObservable.subscribe(observer);
        }

        /** 
         * @constructor
         * @private
         */
        function GroupedObservable(key, underlyingObservable, mergedDisposable) {
            _super.call(this, subscribe);
            this.key = key;
            this.underlyingObservable = !mergedDisposable ?
                underlyingObservable :
                new AnonymousObservable(function (observer) {
                    return new CompositeDisposable(mergedDisposable.getDisposable(), underlyingObservable.subscribe(observer));
                });
        }

        return GroupedObservable;
    }(Observable));

    /** @private */
    var InnerSubscription = function (subject, observer) {
        this.subject = subject;
        this.observer = observer;
    };

    /**
     * @private
     * @memberOf InnerSubscription
     */
    InnerSubscription.prototype.dispose = function () {
        if (!this.subject.isDisposed && this.observer !== null) {
            var idx = this.subject.observers.indexOf(this.observer);
            this.subject.observers.splice(idx, 1);
            this.observer = null;
        }
    };

    /**
     *  Represents an object that is both an observable sequence as well as an observer.
     *  Each notification is broadcasted to all subscribed observers.
     */
    var Subject = Rx.Subject = (function (_super) {
        function subscribe(observer) {
            checkDisposed.call(this);
            if (!this.isStopped) {
                this.observers.push(observer);
                return new InnerSubscription(this, observer);
            }
            if (this.exception) {
                observer.onError(this.exception);
                return disposableEmpty;
            }
            observer.onCompleted();
            return disposableEmpty;
        }

        inherits(Subject, _super);

        /**
         * Creates a subject.
         * @constructor
         */      
        function Subject() {
            _super.call(this, subscribe);
            this.isDisposed = false,
            this.isStopped = false,
            this.observers = [];
        }

        addProperties(Subject.prototype, Observer, {
            /**
             * Indicates whether the subject has observers subscribed to it.
             * @returns {Boolean} Indicates whether the subject has observers subscribed to it.
             */         
            hasObservers: function () {
                return this.observers.length > 0;
            },
            /**
             * Notifies all subscribed observers about the end of the sequence.
             */                          
            onCompleted: function () {
                checkDisposed.call(this);
                if (!this.isStopped) {
                    var os = this.observers.slice(0);
                    this.isStopped = true;
                    for (var i = 0, len = os.length; i < len; i++) {
                        os[i].onCompleted();
                    }

                    this.observers = [];
                }
            },
            /**
             * Notifies all subscribed observers about the exception.
             * @param {Mixed} error The exception to send to all observers.
             */               
            onError: function (exception) {
                checkDisposed.call(this);
                if (!this.isStopped) {
                    var os = this.observers.slice(0);
                    this.isStopped = true;
                    this.exception = exception;
                    for (var i = 0, len = os.length; i < len; i++) {
                        os[i].onError(exception);
                    }

                    this.observers = [];
                }
            },
            /**
             * Notifies all subscribed observers about the arrival of the specified element in the sequence.
             * @param {Mixed} value The value to send to all observers.
             */                 
            onNext: function (value) {
                checkDisposed.call(this);
                if (!this.isStopped) {
                    var os = this.observers.slice(0);
                    for (var i = 0, len = os.length; i < len; i++) {
                        os[i].onNext(value);
                    }
                }
            },
            /**
             * Unsubscribe all observers and release resources.
             */                
            dispose: function () {
                this.isDisposed = true;
                this.observers = null;
            }
        });

        /**
         * Creates a subject from the specified observer and observable.
         * @param {Observer} observer The observer used to send messages to the subject.
         * @param {Observable} observable The observable used to subscribe to messages sent from the subject.
         * @returns {Subject} Subject implemented using the given observer and observable.
         */
        Subject.create = function (observer, observable) {
            return new AnonymousSubject(observer, observable);
        };

        return Subject;
    }(Observable));

    /**
     *  Represents the result of an asynchronous operation.
     *  The last value before the OnCompleted notification, or the error received through OnError, is sent to all subscribed observers.
     */   
    var AsyncSubject = Rx.AsyncSubject = (function (_super) {

        function subscribe(observer) {
            checkDisposed.call(this);
            
            if (!this.isStopped) {
                this.observers.push(observer);
                return new InnerSubscription(this, observer);
            }

            var ex = this.exception,
                hv = this.hasValue,
                v = this.value;

            if (ex) {
                observer.onError(ex);
            } else if (hv) {
                observer.onNext(v);
                observer.onCompleted();
            } else {
                observer.onCompleted();
            }

            return disposableEmpty;
        }

        inherits(AsyncSubject, _super);

        /**
         * Creates a subject that can only receive one value and that value is cached for all future observations.
         * @constructor
         */ 
        function AsyncSubject() {
            _super.call(this, subscribe);

            this.isDisposed = false;
            this.isStopped = false;
            this.value = null;
            this.hasValue = false;
            this.observers = [];
            this.exception = null;
        }

        addProperties(AsyncSubject.prototype, Observer, {
            /**
             * Indicates whether the subject has observers subscribed to it.
             * @returns {Boolean} Indicates whether the subject has observers subscribed to it.
             */         
            hasObservers: function () {
                checkDisposed.call(this);
                return this.observers.length > 0;
            },
            /**
             * Notifies all subscribed observers about the end of the sequence, also causing the last received value to be sent out (if any).
             */ 
            onCompleted: function () {
                var o, i, len;
                checkDisposed.call(this);
                if (!this.isStopped) {
                    this.isStopped = true;
                    var os = this.observers.slice(0),
                        v = this.value,
                        hv = this.hasValue;

                    if (hv) {
                        for (i = 0, len = os.length; i < len; i++) {
                            o = os[i];
                            o.onNext(v);
                            o.onCompleted();
                        }
                    } else {
                        for (i = 0, len = os.length; i < len; i++) {
                            os[i].onCompleted();
                        }
                    }

                    this.observers = [];
                }
            },
            /**
             * Notifies all subscribed observers about the exception.
             * @param {Mixed} error The exception to send to all observers.
             */ 
            onError: function (exception) {
                checkDisposed.call(this);
                if (!this.isStopped) {
                    var os = this.observers.slice(0);
                    this.isStopped = true;
                    this.exception = exception;

                    for (var i = 0, len = os.length; i < len; i++) {
                        os[i].onError(exception);
                    }

                    this.observers = [];
                }
            },
            /**
             * Sends a value to the subject. The last value received before successful termination will be sent to all subscribed and future observers.
             * @param {Mixed} value The value to store in the subject.
             */             
            onNext: function (value) {
                checkDisposed.call(this);
                if (!this.isStopped) {
                    this.value = value;
                    this.hasValue = true;
                }
            },
            /**
             * Unsubscribe all observers and release resources.
             */
            dispose: function () {
                this.isDisposed = true;
                this.observers = null;
                this.exception = null;
                this.value = null;
            }
        });

        return AsyncSubject;
    }(Observable));

    /** @private */
    var AnonymousSubject = (function (_super) {
        inherits(AnonymousSubject, _super);

        function subscribe(observer) {
            return this.observable.subscribe(observer);
        }

        /**
         * @private
         * @constructor
         */
        function AnonymousSubject(observer, observable) {
            _super.call(this, subscribe);
            this.observer = observer;
            this.observable = observable;
        }

        addProperties(AnonymousSubject.prototype, Observer, {
            /**
             * @private
             * @memberOf AnonymousSubject#
            */
            onCompleted: function () {
                this.observer.onCompleted();
            },
            /**
             * @private
             * @memberOf AnonymousSubject#
            */            
            onError: function (exception) {
                this.observer.onError(exception);
            },
            /**
             * @private
             * @memberOf AnonymousSubject#
            */            
            onNext: function (value) {
                this.observer.onNext(value);
            }
        });

        return AnonymousSubject;
    }(Observable));

    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        root.Rx = Rx;

        define(function() {
            return Rx;
        });
    } else if (freeExports && freeModule) {
        // in Node.js or RingoJS
        if (moduleExports) {
            (freeModule.exports = Rx).Rx = Rx;
        } else {
          freeExports.Rx = Rx;
        }
    } else {
        // in a browser or Rhino
        root.Rx = Rx;
    }
}.call(this));
angular.module('fef', [
]);

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefColspan', FefColspan);
    /**
     * @ngdoc directive
     * @name fefColspan
     *
     * @param {expression} fefColspan The main argument is the value of the colspan you want to bind to.
     *
     * @description
     * Sets the colspan attribute on the attached element to the value of the evaluated main argument.
     * This is useful only in that it does not cause html validation errors, as would setting
     * colspan="{{interpolated expression}}" which would do the same thing.
     */
    function FefColspan() {
        var directive = {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                var _updateView = function() {
                    element.attr('colspan', scope.$eval(attrs.fefColspan));
                };
                scope.$watch(attrs.fefColspan, _updateView);
                _updateView();
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefEnter', FefEnter);
    /**
     * @ngdoc directive
     * @name fefEnter
     *
     * @param {expression} fefEnter the main argument is an expression to evaluate.
     *
     * @description
     * Binds keydown events for key 13 (The enter key) to the evaluation of the
     * main argument as an expression on scope. Used in our directives, for
     * instance, to open/close a dropdown when the user presses enter.
     */
    function FefEnter() {
        var directive = {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                var expression = attrs.fefEnter;
                element.on('keydown', function(event) {
                    if (event.which === 13) {
                        scope.$apply(function() {
                            scope.$eval(expression);
                        });
                        // Cancel any further event propegation
                        return false;
                    }
                    return true;
                });
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefFocusOnEvent', FefFocusOnEvent);

    FefFocusOnEvent.$inject = ['fef.Utils'];
    /**
     * @ngdoc directive
     * @name fefFocusOnEvent
     * @requires fef.Utils
     * @param {expression} fefFocusOnEvent the main argument is an expression to evaluate.
     *
     * @directive
     * Directive to listen for an event on scope (specified as an argument)
     * and focus the element whenever the event fires. Does a $scope.$on on
     * the element's scope, given the main argument as the event name, and
     * gives the element focus when that event occurs. $broadcast that event
     * from the element's scope (or one of its parent scopes), or $emit it from
     * a child scope under the element, to cause the element to gain focus.
     */
    function FefFocusOnEvent(utils) {
        var directive = {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                var eventName = attrs.fefFocusOnEvent;
                var focused = false;
                if (!utils.exists(eventName)) {
                    throw new Error('fefFocusOnEvent requires an event argument');
                }

                scope.$on(eventName, function() {
                    focused = false;
                    element.bind('focus', function(event) {
                        focused = true;
                        element.unbind(event);
                    });

                    element.focus();

                    // If we are in a headless browser, focus() won't do anything. But we still want to fire the events.
                    // So, if the focus event hasn't yet been fired, do that here.
                    if (!focused) {
                        element.triggerHandler('focus');
                    }
                });
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefFormatOnBlur', FefFormatOnBlur);

    FefFormatOnBlur.$inject = ['fef.Utils'];
    /**
     * @ngdoc directive
     * @name fefFormatOnBlur
     * @requires ng.ngModel
     * @requires fef.Utils
     * @priority 10
     * @param {expression=} fef-format-on-blur-change an expression to evaluate at the time of the blur event
     *  if and only if a model change occurred between the previous focus event and the blur event.
     *
     * @description
     * Binds to the blur event and works with ngModel to reformat the view value after a blur. Useful in cases where
     * a value converter directive accepts multiple input formats that are different from the output format (e.g. dates).
     * Also, this directive filters ngChange events to just those in which the model value is valid, and upon blur -
     * remembers the initial value or the last valid value and restores that value if the model value is invalid at the
     * time of the blur. This behavior was included in this directive due to event timing difficulties in making them
     * separate directives.
     */
    function FefFormatOnBlur(utils) {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            priority: 10,
            link: function postLink(scope, element, attrs, ctrl) {
                // optional onChange expression for ngChange at blur time
                var onChangeAtBlur = attrs.fefFormatOnBlurChange;

                // preserve the value at time of focus
                var originalValue;
                var originalInvalid;

                // this parser reverts the model value to the
                // original value at the time of focus if the current
                // value is invalid. This filters ng-change and model
                // value pushes from ngModel to only valid values (or the original
                // value prior to binding)
                ctrl.$parsers.push(function(input) {
                    if (ctrl.$invalid) {
                        return originalValue;
                    }
                    return input;
                });

                // when we receive focus, capture the current $viewValue
                element.bind('focus', function() {
                    originalValue = ctrl.$modelValue;
                    originalInvalid = ctrl.$invalid;
                });

                // when we lose focus, revert to old value if new value is invalid,
                // then reformat the view.
                element.bind('blur', function() {
                    var i;
                    scope.$digest(); // JEB: do we need this?

                    // re-run the formatter chain on the $modelValue
                    ctrl.$viewValue = ctrl.$modelValue;
                    for (i = ctrl.$formatters.length - 1; i >= 0; i = i - 1) {
                        ctrl.$viewValue = ctrl.$formatters[i](ctrl.$viewValue);
                    }

                    // reset the validity
                    if (angular.isDefined(originalInvalid) && !originalInvalid) {
                        angular.forEach(ctrl.$error, function(p, k) {
                            ctrl.$setValidity(k, true);
                        });
                    }

                    // re-render the view
                    ctrl.$render();

                    // if there is an onChangeAtBlur expression specified
                    // and the original value doesn't equal the current value
                    // then evaluate the expression.
                    if (utils.exists(onChangeAtBlur) &&
                        !angular.equals(originalValue, ctrl.$modelValue)) {
                        scope.$apply(onChangeAtBlur);
                    }
                });
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefMaxlength', FefMaxlength);

    FefMaxlength.$inject = ['fef.Utils']
        /**
         * @ngdoc directive
         * @name fefMaxlength
         * @requires fef.Utils
         * @param {expression} fefMaxlength the main argument is an expression which is evaluated to a
         *  number or string (containing an un-formatted number).
         *
         * @description
         * Unlike the angular directive (or argument to the ngInput directive),
         * this directive actually adds the "maxlength" attribute to the element.
         * To remove the attribute, the expression should evaluate to null,
         * undefined, or a blank string.
         */
    function FefMaxlength(utils) {
        var directive = {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                var _updateView = function() {
                    var value = scope.$eval(attrs.fefMaxlength);
                    if (utils.exists(value)) {
                        value = value.toString();
                    }
                    if (utils.stringIsNonBlank(value)) {
                        element.attr('maxlength', scope.$eval(attrs.fefMaxlength).toString());
                    } else {
                        element.removeAttr('maxlength');
                    }
                };
                scope.$watch(attrs.fefMaxlength, _updateView);
                _updateView();
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';
    angular.module('fef')
        .directive('fefTabStop', FefTabStop);

    FefTabStop.$inject = ['fef.Utils'];
    /**
     * @ngdoc directive
     * @name fefTabStop
     * @restrict A
     * @requires fef.Utils
     *
     * @param {expression} fefTabStop The main argument is the expression to evaluate,
     * which should evaluate to a truthy or falsy value.
     *
     * @description
     * This directive is a simple on/off switch for tab-stop. If expression evaluates to truthy, then the tabindex
     * attribute is removed from the element. If it evaluates to falsy, then the tabindex attribute is added to the
     * element with a value of -1 (i.e. the element is skipped). This directive assumes you are using the browser
     * to determine tab-order automatically.
     */
    function FefTabStop(utils) {
        var directive = {
            restrict: 'A',
            link: function postLink(scope, element, attrs) {
                scope.$watch(attrs.fefTabStop, function(value) {
                    var result = utils.toBoolean(value);

                    if (result) {
                        attrs.$set('tabindex', undefined);
                    } else {
                        attrs.$set('tabindex', '-1');
                    }
                });
            }
        };
        return directive;
    }
}());

(function() {
    'use strict';

    /**
     * @ngdoc filter
     * @name <%= _.camelize(appname) %>.filter:<%= _.camelize(name) %>
     * @function
     * @description
     * # <%= _.camelize(name) %>
     * Filter in the <%= _.camelize(appname) %>.
     */
    angular.module('fef')
        .filter('fefMaxchars', FefMaxchars);

    function FefMaxchars() {
        var filter = function(input, numMaxChars) {
            var numMaxCharsInt = parseInt(numMaxChars, 10);
            if (input.length > numMaxCharsInt) {
                return input.substr(0, numMaxCharsInt) + '...';
            } else {
                return input;
            }
        };
        return function(input, numMaxChars) {
            return filter(input, numMaxChars);
        };
    }
}());

(function() {
    'use strict';

    /**
     * @ngdoc filter
     * @name fefOrElse
     *
     * @param {string} fefOrElse The main argument is a fallback value to use if the input is null or
     * undefined.
     *
     * @description:
     * Will return input, unless input is undefined or null, in which case
     * the argument (the fallback value) is returned.
     *
     * @example
       <example>
         <file name="index.html">
           <input data-ng-model="value" data-ng-init="value = null" /><br />
           <h1>value with filter: {{value | fefOrElse:'default value'}}</h1>
         </file>
       </example>
       <h1>{{data.name | fefOrElse:'Unknown'}}</h1>
     */
    angular.module('fef')
        .filter('fefOrElse', FefOrElse);

    function FefOrElse() {
        var filter = function(input, fallBackValue) {
            if (typeof input === 'undefined' || input === null) {
                return fallBackValue;
            } else {
                return input;
            }
        };
        return function(input, fallBackValue) {
            return filter(input, fallBackValue);
        };
    }
}());
(function () {
    'use strict';

    angular.module('fef')
        .service('fef.dataBindingUtils', DataBindingUtils);
    DataBindingUtils.$inject = ['$parse'];
    function DataBindingUtils ($parse) {
        this.makeOnChangeFuncWithHistory = function (scope, expression, listener) {
            var oldValue;
            var expressionFunc = $parse(expression);
            var updateOldValue = function() {
                oldValue = angular.copy(expressionFunc(scope));
            };

            updateOldValue();

            scope.$watch(expression, function(_oldValue, _newValue) {
                if (!angular.equals(_oldValue, _newValue)) {
                    updateOldValue();
                }
            });

            return function() {
                try {
                    listener(expressionFunc(scope), oldValue);
                } finally {
                    updateOldValue();
                }
            };
        };
    }

}());

(function () {
	'use strict';
	angular.module('fef')
		.provider('fefLog', FefLogProvider);

	function FefLogProvider() {
		var _$log;

		var levels = ['none', 'error', 'warn', 'info', 'log', 'debug'];
		var baseConfig = {
			rootname : 'fef',
			consoleThreshold: 4,
			consoleTimestamp: false,
			httpThreshold: 1,
			httpPath: null,
			httpAuthorization: null,
			delay: 250
		};
		var rootGuid = trmrguid();
		var namedConfigs = {};
		var $window, $location;

		function setInit(_window, _location, _log) {
			$window = _window;
			$location = _location;
			_$log = _$log || _log
		}

		function thresholdFromString(value) {
			var i;
			for (i = 0; i < levels.length; i++) {
				if (levels[i] == value.toLowerCase()) {
					return i;
				}
			}

			return -1;
		}

		function validateConfig(config) {
			if (typeof config.consoleThreshold == 'string') {
				config.consoleThreshold = thresholdFromString(config.consoleThreshold);
			}
			if (typeof config.consoleThreshold != 'number' || config.consoleThreshold < 0 || config.consoleThreshold > 5) {
				config.consoleThreshold = 4;
			}

			if (typeof config.httpThreshold == 'string') {
				config.httpThreshold = thresholdFromString(config.httpThreshold);
			}
			if (typeof config.httpThreshold != 'number' || config.httpThreshold < 0 || config.httpThreshold > 5) {
				config.httpThreshold = 1;
			}
		}
		// won't allow new properties tp pollute config object
		function extendConfig(base, extended) {
			var keys = Object.keys(base);
			angular.forEach(keys, function (item) {
				// check for undefined explicitly so 0 and false will work
				if (extended[item] !== undefined) {
					base[item] = extended[item];
				}
			});
		}
		function configure(newConfig, name) {
			var cfg, key;

			if (!angular.isUndefined(newConfig)) {
				if (name && name.length) {
					key = ([baseConfig.rootname].concat(name)).join(':');
					cfg = namedConfigs[key];
					if (!cfg) {
						cfg = namedConfigs[key] = {
							consoleThreshold: baseConfig.consoleThreshold,
							httpThreshold: baseConfig.httpThreshold
						};
					}

					if (newConfig === null) {
						delete namedConfigs[key];
						cfg = baseConfig;
					} else {
						// will only override consoleThreshold & httpThreshold
						extendConfig(cfg, newConfig);
						validateConfig(cfg);
					}

					// return clone of configuration object
					return angular.extend({}, baseConfig, cfg);

				} else {
					extendConfig(baseConfig, newConfig);
					validateConfig(baseConfig);
				}
			}

			// return clone of configuration object
			return angular.extend({}, baseConfig);
		}

		/*jshint bitwise: true*/
		function trmrguid() {
			return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
				var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
		}

		function generatePageGuid($http, pagename) {
			rootGuid = trmrguid();
			$http.defaults.headers.common['x-cobalt-pcid'] = rootGuid;

			var data = createLogData(baseConfig.rootname);
			data.level = 'page';
			data.pageName = (typeof pagename == 'string' ? pagename : 'UNKNOWN');
			logHttp(data);
		}

		var logBuffer = [];
		function logHttp(logData) {
			if (baseConfig.httpPath) {
				if (logBuffer.length == 0) {
				//*** DO NOT COPY THE PATTERN BELOW
					// use setTimeout/XMLHttpRequest instead of $timeout/$http to avoid circular exceptions/errors
					setTimeout(function () {
						var logRequest = new XMLHttpRequest();
						logRequest.open('POST', baseConfig.httpPath);
						logRequest.setRequestHeader('x-cobalt-pcid', rootGuid);
						logRequest.setRequestHeader('Content-Type', 'application/json'); // ;charset=UTF-8
						if (baseConfig.httpAuthorization) {
							logRequest.setRequestHeader('Authorization', baseConfig.httpAuthorization);
						}
						logRequest.send(JSON.stringify({version: '0.1', items: logBuffer}));

						logBuffer = [];
					}, baseConfig.delay);
				//***
				}
				logBuffer.push(logData);
			}
		}

		function createLogData (name) {
			var timestamp = (new Date()).toISOString();

			var data = {
				root: rootGuid,
				name: name,
				timestamp: timestamp
			};
			if ($location) {
				data['url'] = $location.absUrl();
			}

			return data;
		}

		// from angular.js source code
		function formatError(arg) {
			if (arg instanceof Error) {
				if (arg.stack) {
					arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
						? 'Error: ' + arg.message + '\n' + arg.stack
						: arg.stack;
				} else if (arg.sourceURL) {
					arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
				}
			}
			return arg;
		}

		function executeLogFn(args, logFn, level, name) {
			name = ([baseConfig.rootname].concat(name)).join(':');
			var logData = createLogData(name);
			var cfg = namedConfigs[name] || baseConfig;
			var timestamp = '';

			// HTTP logging
			if (baseConfig.httpPath && level <= cfg.httpThreshold) {
				var i, messages = [];
				for (i = 0; i < args.length; i++) {
					messages.push(args[i].toString());
				}

				logData.level = levels[level];
				logData.messages = messages;

				if (args[0] instanceof Error && $window.printStackTrace) {
					// requires stacktrace.js
					//logData['stacktrace'] = $window.printStackTrace({e: args[0]});
				}

				if (args[0] instanceof Error) {
					if (args[0].stack) {
						logData['stacktrace'] = formatError(args[0]);
					}
				}

				logHttp(logData);
			}

			// console logging
			if (level <= cfg.consoleThreshold) {

				// prepend an ISO timestamp and logger to the original log message
				if (cfg.consoleTimestamp) {
					timestamp = logData.timestamp + ' ';
				}
				if (angular.isString(args[0])) {
					args[0] = timestamp + '[' + name + '] ' + args[0];
				} else {
					args.unshift(timestamp + '[' + name + '] ');
				}

				logFn.apply(null, args);
			}
		}

		/**
		 * Wrap original log function
		 */
		function wrapLogFn(logFn, level, name) {
			var wrappedLogFn = function () {
				var args = Array.prototype.slice.call(arguments);
				return executeLogFn(args, logFn, level, name || ['$log']);
			};

			// support angular-mocks which assumes log messages captured in an array
			// https://github.com/angular/bower-angular-mocks/blob/master/angular-mocks.js
			wrappedLogFn.logs = [ ];

			return wrappedLogFn;
		}

		/**
		 * Generate name-specific logger instance
		 */
		function getLogger() {
			var name = Array.prototype.slice.call(arguments) || [];

			return {
				log: wrapLogFn(_$log.log, 4, name),
				info: wrapLogFn(_$log.info, 3, name),
				warn: wrapLogFn(_$log.warn, 2, name),
				debug: wrapLogFn(_$log.debug, 5, name),
				error: wrapLogFn(_$log.error, 1, name)
			};
		}

		this.enhance$log = function ($log, moduleName) {
			// capture the original functions of $log
			_$log = (function ($log) {
				return {
					log: $log.log,
					info: $log.info,
					warn: $log.warn,
					debug: $log.debug,
					error: $log.error
				};
			})($log);

			$log.debug = wrapLogFn($log.debug, 5);
			$log.log = wrapLogFn($log.log, 4);
			$log.info = wrapLogFn($log.info, 3);
			$log.warn = wrapLogFn($log.warn, 2);
			$log.error = wrapLogFn($log.error, 1);

			return $log;
		};

		this.$get = ['$window','$location', '$http', '$log', function ($window, $location, $http, $log) {
			var fefLog = {};

			setInit($window, $location, $log);

			fefLog.configure = configure;

			fefLog.getLogger = getLogger;

			fefLog.pageguid = function (pagename) {
				if (pagename) {
					generatePageGuid($http, pagename);
				}

				return rootGuid;
			};
/*
	// FUTURE usage concept - need to design a well behaved promise based API
			fefLog.component = function (options, promise) {
				var then = Date.now();
				var data = createLogData(baseConfig.rootname);
				delete data.url;
				data.componentName = options.name;
				data.level = 'component';
				return promise.then(function(result) {
					data.duration = (Date.now() - then);
					logHttp(data);
					return result;
				}, function(reason) {
					data.duration = (Date.now() - then);
					data.error = 1;
					logHttp(data);
					return reason;
				});
			};
*/
			return fefLog;
		}];
	}
})();
(function() {
    'use strict';
    angular.module('fef')
        .provider('fefLogger', FefLogProvider);
    function FefLogProvider() {
        var config = {
            consoleThreshold: 4,
            httpThreshold: 1,
            httpDomain: undefined,
            httpPath: '/demo/logs',
            delay: 250
        };
        var resource;

        var rootname = 'fef';
        var rootGuid = trmrguid();
        var $window, $location;

        function setInit(_window, _location) {
            $window = _window;
            $location = _location;
        }
        function formatError(arg, name) {
            if (arg instanceof Error) {
                if (arg.stack) {
                    arg = (arg.message && arg.stack.indexOf(arg.message) === -1) ? 'Error: ' + 
                    arg.message + '\n' + arg.stack : arg.stack;
                } else if (arg.sourceURL) {
                    arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
                }
            }
            return '[' + name+ '] ' + arg;
        }

        function consoleLog(type, parent, name) {
            var console = $window.console || {},
                logFn = console[type] || console.log || angular.noop;
            if (logFn.apply) {
                var args = [];
                angular.forEach(parent, function(arg) {
                    args.push(formatError(arg, name));
                });
                logFn.apply(console, args);
            }
        }

        function configure(_conf) {
            if (!_conf.consoleThreshold || !(_conf.consoleThreshold >= 1 && _conf.consoleThreshold <= 5)) {
                _conf.consoleThreshold = 4;
            }
            if (!_conf.httpThreshold || !(_conf.httpThreshold >= 1 && _conf.httpThreshold <= 5)) {
                _conf.httpThreshold = 1;
            }
            var keys = Object.keys(config);
            angular.forEach(keys, function (item) {
                if(_conf[item]){
                    config[item] = _conf[item];
                }
                
            });
        }

        function setResource(_resouce) {
            resource = _resouce;
        }

        function formatMessage(_type, level, name) {
                return function () {
                    var timestamp = (new Date()).toISOString();
                    var module = rootname;
                    if (name) {
                        module = module + ':' + name;
                    }
                    var log = {
                        root: rootGuid,
                        timestamp: timestamp,
                        message: [].slice.call(arguments) || '',
                        level: _type,
                        url: $location.absUrl(),
                        name: module
                    };
                    if (arguments[0] instanceof Error && window.printStackTrace) {
                        log.stacktrace = window.printStackTrace({
                            e: arguments[0]
                        });
                    }
                    if (config.httpPath && level <= config.httpThreshold) {
                        resource.save(log);
                    }
                    if (level <= config.consoleThreshold) {
                        switch (level) {
                        case 5:
                            consoleLog('debug',arguments, module);
                            break;
                        case 4:
                            consoleLog('log',arguments, module);
                            break;
                        case 3:
                            consoleLog('info',arguments, module);
                            break;
                        case 2:
                            consoleLog('warn',arguments, module);
                            break;
                        case 1:
                            consoleLog('error',arguments, module);
                            break;
                        }

                    }

                };
            }
            /*jshint bitwise: true*/
        function trmrguid() {
            return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }

        return {
            configure: configure,
            $get: ['$resource', '$location', '$window', function($resource, $location,$window) {
                var urlPath = config.httpPath;
                if(config.httpDomain){
                    urlPath = 'http://' + config.httpDomain + urlPath;
                }
                var WS = $resource(urlPath,
                    null, {
                        save: {
                            method: 'POST',
                            headers: {
                                common: {
                                    'x-cobalt-pcid': trmrguid()
                                }
                            }
                        }
                    });
                setResource(WS);
                setInit($window, $location);
                return {
                    debug: formatMessage('debug', 5),
                    log: formatMessage('log', 4),
                    info: formatMessage('info', 3),
                    warn: formatMessage('warn', 2),
                    error: formatMessage('error', 1),
                    getLogger: function(value) {
                        if (arguments.length > 1) {
                            var temp = Array.apply(null, arguments);
                            value = temp.join(':');
                        }
                        return {
                            debug: formatMessage('debug', 5, value),
                            log: formatMessage('log', 4,value),
                            info: formatMessage('info', 3, value),
                            warn: formatMessage('warn', 2, value),
                            error: formatMessage('error', 1, value)
                        };
                    }

                };
            }]
        };
    }

}());

(function() {
    'use strict';

    angular.module('fef')
        .service('fef.PromiseUtils', PromiseUtils);
    PromiseUtils.$inject = ['$q', '$timeout', 'fef.Utils'];

    function Throttler($q, $timeout, utils, invokeFunc, throttleDelay) {
        /// <summary>[Private] Internal implementation of fef.PromiseUtils.throttle</summary>
        /// <param name="$q" type="$q"></param>
        /// <param name="throttleDelay" type="Number"></param>
        /// <param name="invokeFunc" type="Function"></param>

        this._counter = 0;
        this.invoke = function(arg) {
            /// <signature>
            /// <summary>Kicks off the throttled action after the specified delay,
            /// but only if another invoke is not called again prior to the end of the delay.</summary>
            /// <returns type="Promise">A promise that is resolved if the invokeFunc is executed
            /// as a result of THIS invoke, else rejected if another invoke call cancels this one</returns>
            /// </signature>
            var self = this;
            var _deferred = $q.defer();
            if (!utils.exists(throttleDelay) || throttleDelay === 0) {
                invokeFunc(arg);
                _deferred.resolve({});
            } else {
                // works best for throttleDelays large enough to eliminate
                // the possibility of Number overflow.
                var _curCounter = self._counter + 1;
                this._counter = _curCounter;
                $timeout(function() {
                    if (_curCounter === self._counter) {
                        invokeFunc(arg);
                        _deferred.resolve({});
                    } else {
                        _deferred.reject({});
                    }
                }, throttleDelay);
            }
            return _deferred.promise;
        };
    }

    function PromiseUtils($q, $timeout, utils) {
        /// <param name="$q" type="$q" />

        this.parseRetryInfoJSON = function(statusCode, retryInfoJSON) {
            /// <signature>
            /// <summary>Utility to parse retry information from JSON in a common
            ///  format. </summary>
            /// <param name="statusCode" type="number" />
            /// <param name="retryInfoJSON" type="String" />
            /// <returns type="Object">The parsed retry information</returns>
            /// </signature>
            var ret = {
                retry: utils.exists(statusCode) && (statusCode === '503' || statusCode === 503)
            };

            if (utils.stringIsNonBlank(retryInfoJSON)) {
                try {
                    var body = JSON.parse(retryInfoJSON);
                    if (utils.exists(body)) {
                        if (utils.exists(body.retry)) {
                            ret.retry = (body.retry ? true : false) || ret.retry;
                        }
                        if (angular.isNumber(body.retryInMs)) {
                            ret.retryInMs = body.retryInMs;
                        }
                    }
                } catch (e) {
                    ret = null;
                }
            }
            return ret;
        };

        this.throttle = function(invokeFunc, throttleDelay) {
            /// <signature>
            /// <summary>Creates a Throttler object with an invoke function which
            /// you can call multiple times (e.g. in response to an ngChange event).
            /// The invokeFunc you pass in will be called, but only after throttleDelay,
            /// and only if no other invoke call is made within that time. Use this to,
            /// for instance, throttle live search requests or auto-fill services.
            /// </summary>
            /// <param name="invokeFunc" type="Function">The function to be executed.</param>
            /// <param name="throttleDelay" type="number">The amount of time in ms to wait before
            /// calling invokeFunc.</param>
            /// <returns type="fef.Throttler">An object with an invoke function which can be
            ///  called multiple times within throttleDelay, but results in only one call of
            ///  invokeFunc for that time window.</returns>
            /// </signature>

            return new Throttler($q, $timeout, utils, invokeFunc, throttleDelay);
        };

        this.resolvedPromise = function(value, delay) {
            /// <signature>
            /// <summary>Utility to get a resolved promise, optionally after
            ///   delay.</summary>
            /// <param name="value" type="Object">The value to resolve with.</param>
            /// <param name="delay" type="number" optional="true">Optional delay, in ms. If
            ///  no delay given, the returned promise will be resolved immediately.</param>
            /// <returns type="Promise">A Promise that will resolve with the exact
            ///  value you specify. If you specify a delay, the promise will be resolved
            ///  asynchronously after the delay you specify, in ms.</returns>
            /// </signature>
            var _resolvedPromiseImpl = function(_value) {
                var d = $q.defer();
                d.resolve(_value);
                return d.promise;
            };

            if (!utils.exists(delay)) {
                return _resolvedPromiseImpl(value);
            } else {
                return $timeout(function() {}, delay).then(function() {
                    return _resolvedPromiseImpl(value);
                });
            }
        };

        this.retry = function(retryFunc, retryCount, promise, parseRetryFunc) {
            /// <signature>
            /// <summary>Utility to attempt an action, and retry that action up to retryCount times
            ///  if unsuccessful.</summary>
            /// <param name="retryFunc" type="Function">A function which returns a promise. This
            ///  function will be called once initially, if you don't specify an initial promise,
            ///  and once afterward for each retry attempt.</param>
            /// <param name="retryCount" type="number">The number of times to retry the retryFunc.</param>
            /// <param name="promise" type="Promise">If you have an existing promise you'd like
            ///  to retry, pass it along here. Otherwise, pass null and retryFunc will be
            ///  called once to create the initial promise. </param>
            /// <param name="parseRetryFunc(error_Object)" type="Function">A function taking a single
            ///  argument (the error value of the promise) and returns a normalized retry info object,
            ///  used to determine whether to retry or not.</param>
            /// <returns type="Promise">A promise that resolves with the value of the original promise,
            ///  if successful after the retry attempts, else it returns the error result of the last
            ///  retry attempt promise.</returns>
            /// </signature>
            var self = this;

            // default retryCount to 2
            if (!utils.exists(retryCount) || !angular.isNumber(retryCount)) {
                retryCount = 2;
            }

            // create the promise if it doesn't exist already. This makes
            // it so the calling code can pass an anonymous function for
            // retryFunc, which is convenient.
            if (!utils.exists(promise)) {
                promise = retryFunc();
            }

            // use a reasonable default retry info parser
            if (!utils.exists(parseRetryFunc)) {
                parseRetryFunc = function(value) {
                    if (angular.isString(value)) {
                        return self.parseRetryInfoJSON(value);
                    } else {
                        return value;
                    }
                };
            }

            // if we have no more retries, then we'll return the original promise
            var ret = promise;
            if (retryCount > 0) {
                // we have some retries left, so intercept errors and retry if
                // the error indicates the request can be retried.
                ret = ret.then(null, function(error) {
                    var retryInfo = parseRetryFunc(error);
                    if (utils.exists(retryInfo)) {
                        // error response indicates we should attempt to retry
                        if (utils.exists(retryInfo.retryInMs) && typeof retryInfo.retryInMs === 'number') {
                            // delay the retry by the amount specified in the error response
                            return $timeout(function() {}, retryInfo.retryInMs).then(
                                function() {
                                    return self.retry(retryFunc, retryCount - 1, retryFunc(), parseRetryFunc);
                                });
                        } else {
                            // no explicit retry time specified in the response, so retry immediately
                            return self.retry(retryFunc, retryCount - 1, retryFunc(), parseRetryFunc);
                        }
                    } else {
                        // assume not a retryable error, throw it again.
                        return $q.reject(error);
                    }
                });
            } // else, we return the promise directly.
            return ret;
        };
    }

}());

(function() {
    'use strict';

    angular.module('fef')
        .service('fef.SanityChecks', SanityChecks);
    SanityChecks.$inject = [];

    function SanityChecks() {
        /**
         * @ngdoc method
         * @name fef.SanityChecks#checkConstructorUsage
         * @description Throws an error if the constructor function was called without
         * the new keyword. This could lead to inadvertently assigning global variables.
         *
         * @param {Object} _this Pass 'this' from the constructor function.
         * @param {function} constructor Pass a reference to the constructor function.
         */
        this.checkConstructorUsage = function(_this, constructor) {
            if (!(_this instanceof constructor)) {
                throw new Error('Constructor called as a function');
            }
        };
    }

}());

(function() {
    'use strict';

    angular.module('fef')
        .service('fef.Utils', Utils);
    Utils.$inject = [];

    function Utils() {
        var self = this;
        this.guid = function() {
            /// <summary>Creates a random guid string</summary>
            /// <returns type='String' />
            var s4 = function() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            };
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        };

        this.exists = function(value) {
            /// <signature>
            /// <summary>Utility to check if a value is defined and non-null.</summary>
            /// <param name='value' type='Object' />
            /// <returns type='Boolean'>True, if value is defined and non-null.
            ///  False otherwise.</returns>
            /// </signature>
            return typeof value !== 'undefined' && value !== null;
        };

        // TODO: stringIsNonBlank and stringReplaceAll - should we move these to a new StringUtils service?

        this.stringIsNonBlank = function(value) {
            /// <signature>
            /// <summary>Utility to check if a value is a defined and non-null string
            /// with non-zero length.</summary>
            /// <param name='value' type='String' />
            /// <returns type='Boolean'>True, if value is defined and non-null and a string
            /// of length greater than zero. False otherwise.</returns>
            /// </signature>
            return typeof value === 'string' && value.length > 0;
        };

        this.stringReplaceAll = function(sourceString, find, replace) {
            /// <signature>
            /// <summary>This is a global replace all within a string. Use this in
            /// place of the built-in function on strings when you want to replace all
            /// instances instead of the first one.</summary>
            /// <param name='sourceString' type='String'>The source string you want to work on.</param>
            /// <param name='find' type='String'>The substring to replace from sourceString.</param>
            /// <param name='replace' type='String'>The string to replace find with.</param>
            /// </signature>
            if (!self.exists(sourceString) || !self.exists(find) || !self.exists(replace)) {
                throw new Error('fef.Utils.stringReplaceAll: invalid argument(s)');
            }
            return sourceString.replace(new RegExp(find, 'g'), replace);
        };

        this.toBoolean = function(value) {
            /// <signature>
            /// <summary>Very lenient string-to-boolean converter.</summary>
            /// <param name='value' type='String' />
            /// <returns type='Boolean'></returns>
            /// </signature>
            if (value && value.length !== 0) {
                var v = angular.lowercase('' + value);
                value = !(v === 'f' || v === '0' || v === 'false' || v === 'no' || v === 'n' || v === '[]');
            } else {
                value = false;
            }
            return value;
        };

        this.nonEmptyStrings = function(array) {
            /// <summary>Creates a new array of strings from an existing array by filtering
            ///  out all null, undefined, empty string, and non-string values from the
            ///  original array.</summary>
            /// <param name='array' type='Array'>The original array.</param>
            /// <returns type='Array'>A new Array.</returns>

            return array.filter(this.stringIsNonBlank);
        };

        this.joinNonEmptyStrings = function(prefix, separator, args) {
            /// <summary>Creates a string out of an array of strings by first filtering out
            ///  the empty and non-string values of the original array, and if there are
            ///  any remaining strings in the array, prefixes the result with the specified
            ///  prefix, followed by the join of the remaining non-empty strings using
            ///  the specified separator. If no strings are left after filtering, an empty
            ///  string is returned.</summary>
            /// <param name='prefix' type='String'>The desired prefix of the result.</param>
            /// <param name='separator' type='String'>The desired separator to use when joining the
            ///  remaining non-empty strings after the prefix.</param>
            /// <param name='args' type='Array'>The original array.</param>
            /// <returns type='String'>A new string.</returns>
            var ret = '';
            if (!this.exists(prefix) || !this.exists(separator) || !this.exists(args)) {
                throw 'fef.Utils.joinNonEmptyStrings: arguments must not be null.';
            }
            if (!angular.isString(prefix) || !angular.isString(separator)) {
                throw 'fef.Utils.joinNonEmptyStrings: prefix and separator arguments must be strings.';
            }
            if (!angular.isArray(args)) {
                throw 'fef.Utils.joinNonEmptyStrings: args must be an array.';
            }
            var filtered = this.nonEmptyStrings(args);
            if (filtered.length > 0) {
                ret = prefix + filtered.join(separator);
            }
            return ret;
        };
    }

}());

(function() {
    'use strict';

    angular.module('fef')
        .service('DeprecatedNoticeService', DeprecatedNoticeService);
    DeprecatedNoticeService.$inject = [];

    function DeprecatedNoticeService() {
        this.notify = function(deprecatedComponent, replacementComponent) {
            return 'The ' + deprecatedComponent +
                ' has been deprecated. Please use the ' +
                replacementComponent +
                ' directive available in the Bento Modern' +
                'Toolset: http://modern.centralux.int.thomsonreuters.com:8888';

        };
    }

}());

(function() {
    'use strict';

    angular.module('fef')
        .service('fef.EmailService', EmailService);
    EmailService.$inject = [];

    function EmailService() {
        this.validate = function(email) {
            var emailTest = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!email) { //test for empty
                return 'Email cannot be empty.';
            } else if (!emailTest.test(email)) //test for valid format
            {
                return 'Email format is not valid.';
            } else {
                return true;
            }

        };
    }

}());

/**
 * @license Angulartics
 * (c) 2013 Luis Farzati http://luisfarzati.github.io/angulartics
 * License: MIT
 */
(function(angular, analytics) {
'use strict';

var angulartics = window.angulartics || (window.angulartics = {});
angulartics.waitForVendorCount = 0;
angulartics.waitForVendorApi = function (objectName, delay, containsField, registerFn, onTimeout) {
  if (!onTimeout) { angulartics.waitForVendorCount++; }
  if (!registerFn) { registerFn = containsField; containsField = undefined; }
  if (!Object.prototype.hasOwnProperty.call(window, objectName) || (containsField !== undefined && window[objectName][containsField] === undefined)) {
    setTimeout(function () { angulartics.waitForVendorApi(objectName, delay, containsField, registerFn, true); }, delay);
  }
  else {
    angulartics.waitForVendorCount--;
    registerFn(window[objectName]);
  }
};

/**
 * @ngdoc overview
 * @name angulartics
 */
angular.module('angulartics', [])
.provider('$analytics', $analytics)
.run(['$rootScope', '$window', '$analytics', '$injector', $analyticsRun])
.directive('analyticsOn', ['$analytics', analyticsOn])
.config(['$provide', exceptionTrack]);

function $analytics() {
  var settings = {
    pageTracking: {
      autoTrackFirstPage: true,
      autoTrackVirtualPages: true,
      trackRelativePath: false,
      autoBasePath: false,
      basePath: '',
      excludedRoutes: []
    },
    eventTracking: {},
    bufferFlushDelay: 1000, // Support only one configuration for buffer flush delay to simplify buffering
    trackExceptions: false,
    developerMode: false // Prevent sending data in local/development environment
  };

  // List of known handlers that plugins can register themselves for
  var knownHandlers = [
    'pageTrack',
    'eventTrack',
    'exceptionTrack',
    'setAlias',
    'setUsername',
    'setUserProperties',
    'setUserPropertiesOnce',
    'setSuperProperties',
    'setSuperPropertiesOnce',
    'incrementProperty',
    'userTimings'
  ];
  // Cache and handler properties will match values in 'knownHandlers' as the buffering functons are installed.
  var cache = {};
  var handlers = {};
  var handlerOptions = {};

  // General buffering handler
  function bufferedHandler(handlerName){
    return function(){
      if(angulartics.waitForVendorCount){
        if(!cache[handlerName]){ cache[handlerName] = []; }
        cache[handlerName].push(arguments);
      }
    };
  }

  // As handlers are installed by plugins, they get pushed into a list and invoked in order.
  function updateHandlers(handlerName, fn, options){
    if(!handlers[handlerName]){
      handlers[handlerName] = [];
    }
    handlers[handlerName].push(fn);
    handlerOptions[fn] = options;
    return function(){
      var handlerArgs = Array.prototype.slice.apply(arguments);
      return this.$inject(['$q', angular.bind(this, function($q) {
        return $q.all(handlers[handlerName].map(function(handlerFn) {
          var options = handlerOptions[handlerFn] || {};
          if (options.async) {
            var deferred = $q.defer();
            var currentArgs = angular.copy(handlerArgs);
            currentArgs.unshift(deferred.resolve);
            handlerFn.apply(this, currentArgs);
            return deferred.promise;
          } else{
            return $q.when(handlerFn.apply(this, handlerArgs));
          }
        }, this));
      })]);
    };
  }

  // The api (returned by this provider) gets populated with handlers below.
  var api = {
    settings: settings
  };

  // Will run setTimeout if delay is > 0
  // Runs immediately if no delay to make sure cache/buffer is flushed before anything else.
  // Plugins should take care to register handlers by order of precedence.
  function onTimeout(fn, delay){
    if(delay){
      setTimeout(fn, delay);
    } else {
      fn();
    }
  }

  var provider = {
    $get: ['$injector', function($injector) {
      return apiWithInjector($injector);
    }],
    api: api,
    settings: settings,
    virtualPageviews: function (value) { this.settings.pageTracking.autoTrackVirtualPages = value; },
    excludeRoutes: function(routes) { this.settings.pageTracking.excludedRoutes = routes; },
    firstPageview: function (value) { this.settings.pageTracking.autoTrackFirstPage = value; },
    withBase: function (value) {
      this.settings.pageTracking.basePath = (value) ? angular.element(document).find('base').attr('href') : '';
    },
    withAutoBase: function (value) { this.settings.pageTracking.autoBasePath = value; },
    trackExceptions: function (value) { this.settings.trackExceptions = value; },
    developerMode: function(value) { this.settings.developerMode = value; }
  };

  // General function to register plugin handlers. Flushes buffers immediately upon registration according to the specified delay.
  function register(handlerName, fn, options){
    // Do not add a handler if developerMode is true
    if (settings.developerMode) {
        return;
    }
    api[handlerName] = updateHandlers(handlerName, fn, options);
    var handlerSettings = settings[handlerName];
    var handlerDelay = (handlerSettings) ? handlerSettings.bufferFlushDelay : null;
    var delay = (handlerDelay !== null) ? handlerDelay : settings.bufferFlushDelay;
    angular.forEach(cache[handlerName], function (args, index) {
      onTimeout(function () { fn.apply(this, args); }, index * delay);
    });
  }

  function capitalize(input) {
      return input.replace(/^./, function (match) {
          return match.toUpperCase();
      });
  }

  //provide a method to inject services into handlers
  var apiWithInjector = function(injector) {
    return angular.extend(api, {
      '$inject': injector.invoke
    });
  };

  // Adds to the provider a 'register#{handlerName}' function that manages multiple plugins and buffer flushing.
  function installHandlerRegisterFunction(handlerName){
    var registerName = 'register'+capitalize(handlerName);
    provider[registerName] = function(fn, options){
      register(handlerName, fn, options);
    };
    api[handlerName] = updateHandlers(handlerName, bufferedHandler(handlerName));
  }

  // Set up register functions for each known handler
  angular.forEach(knownHandlers, installHandlerRegisterFunction);
  for (var key in provider) {
    this[key] = provider[key];
  }
}

function $analyticsRun($rootScope, $window, $analytics, $injector) {
  function matchesExcludedRoute(url) {
    for (var i = 0; i < $analytics.settings.pageTracking.excludedRoutes.length; i++) {
      var excludedRoute = $analytics.settings.pageTracking.excludedRoutes[i];
      if ((excludedRoute instanceof RegExp && excludedRoute.test(url)) || url.indexOf(excludedRoute) > -1) {
        return true;
      }
    }
    return false;
  }

  function pageTrack(url, $location) {
    if (!matchesExcludedRoute(url)) {
      $analytics.pageTrack(url, $location);
    }
  }

  if ($analytics.settings.pageTracking.autoTrackFirstPage) {
    $injector.invoke(['$location', function ($location) {
      /* Only track the 'first page' if there are no routes or states on the page */
      var noRoutesOrStates = true;
      if ($injector.has('$route')) {
         var $route = $injector.get('$route');
         if ($route) {
          for (var route in $route.routes) {
            noRoutesOrStates = false;
            break;
          }
         } else if ($route === null){
          noRoutesOrStates = false;
         }
      } else if ($injector.has('$state')) {
        var $state = $injector.get('$state');
        for (var state in $state.get()) {
          noRoutesOrStates = false;
          break;
        }
      }
      if (noRoutesOrStates) {
        if ($analytics.settings.pageTracking.autoBasePath) {
          $analytics.settings.pageTracking.basePath = $window.location.pathname;
        }
        if ($analytics.settings.pageTracking.trackRelativePath) {
          var url = $analytics.settings.pageTracking.basePath + $location.url();
          pageTrack(url, $location);
        } else {
          pageTrack($location.absUrl(), $location);
        }
      }
    }]);
  }

  if ($analytics.settings.pageTracking.autoTrackVirtualPages) {
    $injector.invoke(['$location', function ($location) {
      if ($analytics.settings.pageTracking.autoBasePath) {
        /* Add the full route to the base. */
        $analytics.settings.pageTracking.basePath = $window.location.pathname + "#";
      }
      var noRoutesOrStates = true;
      if ($injector.has('$route')) {
        var $route = $injector.get('$route');
        if ($route) {
          for (var route in $route.routes) {
            noRoutesOrStates = false;
            break;
          }
        } else if ($route === null){
          noRoutesOrStates = false;
        }
        $rootScope.$on('$routeChangeSuccess', function (event, current) {
          if (current && (current.$$route||current).redirectTo) return;
          var url = $analytics.settings.pageTracking.basePath + $location.url();
          pageTrack(url, $location);
        });
      }
      if ($injector.has('$state') && !$injector.has('$transitions')) {
        noRoutesOrStates = false;
        $rootScope.$on('$stateChangeSuccess', function (event, current) {
          var url = $analytics.settings.pageTracking.basePath + $location.url();
          pageTrack(url, $location);
        });
      }
      if ($injector.has('$state') && $injector.has('$transitions')) {
        noRoutesOrStates = false;
        $injector.invoke(['$transitions', function($transitions) {
          $transitions.onSuccess({}, ['$transition$', function($transition$) {
            var transitionOptions = $transition$.options();

            // only track for transitions that would have triggered $stateChangeSuccess
            if (transitionOptions.notify) {
              var url = $analytics.settings.pageTracking.basePath + $location.url();
              pageTrack(url, $location);
            }
          }]);
        }]);
      }
      if (noRoutesOrStates) {
        $rootScope.$on('$locationChangeSuccess', function (event, current) {
          if (current && (current.$$route || current).redirectTo) return;
          if ($analytics.settings.pageTracking.trackRelativePath) {
            var url = $analytics.settings.pageTracking.basePath + $location.url();
            pageTrack(url, $location);
          } else {
            pageTrack($location.absUrl(), $location);
          }
        });
      }
    }]);
  }
  if ($analytics.settings.developerMode) {
    angular.forEach($analytics, function(attr, name) {
      if (typeof attr === 'function') {
        $analytics[name] = function(){};
      }
    });
  }
}

function analyticsOn($analytics) {
  return {
    restrict: 'A',
    link: function ($scope, $element, $attrs) {
      var eventType = $attrs.analyticsOn || 'click';
      var trackingData = {};

      angular.forEach($attrs.$attr, function(attr, name) {
        if (isProperty(name)) {
          trackingData[propertyName(name)] = $attrs[name];
          $attrs.$observe(name, function(value){
            trackingData[propertyName(name)] = value;
          });
        }
      });

      angular.element($element[0]).bind(eventType, function ($event) {
        var eventName = $attrs.analyticsEvent || inferEventName($element[0]);
        trackingData.eventType = $event.type;

        if($attrs.analyticsIf){
          if(! $scope.$eval($attrs.analyticsIf)){
            return; // Cancel this event if we don't pass the analytics-if condition
          }
        }
        // Allow components to pass through an expression that gets merged on to the event properties
        // eg. analytics-properites='myComponentScope.someConfigExpression.$analyticsProperties'
        if($attrs.analyticsProperties){
          angular.extend(trackingData, $scope.$eval($attrs.analyticsProperties));
        }
        $analytics.eventTrack(eventName, trackingData);
      });
    }
  };
}

function exceptionTrack($provide) {
  $provide.decorator('$exceptionHandler', ['$delegate', '$injector', function ($delegate, $injector) {
    return function (error, cause) {
      var result = $delegate(error, cause);
      var $analytics = $injector.get('$analytics');
      if ($analytics.settings.trackExceptions) {
        $analytics.exceptionTrack(error, cause);
      }
      return result;
    };
  }]);
}

function isCommand(element) {
  return ['a:','button:','button:button','button:submit','input:button','input:submit'].indexOf(
    element.tagName.toLowerCase()+':'+(element.type||'')) >= 0;
}

function inferEventType(element) {
  if (isCommand(element)) return 'click';
  return 'click';
}

function inferEventName(element) {
  if (isCommand(element)) return element.innerText || element.value;
  return element.id || element.name || element.tagName;
}

function isProperty(name) {
  return name.substr(0, 9) === 'analytics' && ['On', 'Event', 'If', 'Properties', 'EventType'].indexOf(name.substr(9)) === -1;
}

function propertyName(name) {
  var s = name.slice(9); // slice off the 'analytics' prefix
  if (typeof s !== 'undefined' && s!==null && s.length > 0) {
    return s.substring(0, 1).toLowerCase() + s.substring(1);
  }
  else {
    return s;
  }
}
})(angular);

/*!
 * angular-translate - v2.18.1 - 2018-05-19
 * 
 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function () {
      return (factory());
    });
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    factory();
  }
}(this, function () {

angular.module('pascalprecht.translate')
/**
 * @ngdoc object
 * @name pascalprecht.translate.$translatePartialLoaderProvider
 *
 * @description
 * By using a $translatePartialLoaderProvider you can configure a list of a needed
 * translation parts directly during the configuration phase of your application's
 * lifetime. All parts you add by using this provider would be loaded by
 * angular-translate at the startup as soon as possible.
 */
  .provider('$translatePartialLoader', $translatePartialLoader);

function $translatePartialLoader() {

  'use strict';

  /**
   * @constructor
   * @name Part
   *
   * @description
   * Represents Part object to add and set parts at runtime.
   */
  function Part(name, priority, urlTemplate) {
    this.name = name;
    this.isActive = true;
    this.tables = {};
    this.priority = priority || 0;
    this.langPromises = {};
    this.urlTemplate = urlTemplate;
  }

  /**
   * @name parseUrl
   * @method
   *
   * @description
   * Returns a parsed url template string and replaces given target lang
   * and part name it.
   *
   * @param {string|function} urlTemplate - Either a string containing an url pattern (with
   *                                        '{part}' and '{lang}') or a function(part, lang)
   *                                        returning a string.
   * @param {string} targetLang - Language key for language to be used.
   * @return {string} Parsed url template string
   */
  Part.prototype.parseUrl = function (urlTemplate, targetLang) {
    if (angular.isFunction(urlTemplate)) {
      return urlTemplate(this.name, targetLang);
    }
    return urlTemplate.replace(/\{part\}/g, this.name).replace(/\{lang\}/g, targetLang);
  };

  Part.prototype.getTable = function (lang, $q, $http, $httpOptions, urlTemplate, errorHandler) {

    //locals
    var self = this;
    var lastLangPromise = this.langPromises[lang];
    var deferred = $q.defer();

    //private helper helpers
    var fetchData = function () {
      return $http(
        angular.extend({
            method : 'GET',
            url : self.parseUrl(self.urlTemplate || urlTemplate, lang)
          },
          $httpOptions)
      );
    };

    //private helper
    var handleNewData = function (data) {
      self.tables[lang] = data;
      deferred.resolve(data);
    };

    //private helper
    var rejectDeferredWithPartName = function () {
      deferred.reject(self.name);
    };

    //private helper
    var tryGettingThisTable = function () {
      //data fetching logic
      fetchData().then(
        function (result) {
          handleNewData(result.data);
        },
        function (errorResponse) {
          if (errorHandler) {
            errorHandler(self.name, lang, errorResponse).then(handleNewData, rejectDeferredWithPartName);
          } else {
            rejectDeferredWithPartName();
          }
        });
    };

    //loading logic
    if (!this.tables[lang]) {
      //let's try loading the data
      if (!lastLangPromise) {
        //this is the first request - just go ahead and hit the server
        tryGettingThisTable();
      } else {
        //this is an additional request after one or more unfinished or failed requests
        //chain the deferred off the previous request's promise so that this request conditionally executes
        //if the previous request succeeds then the result will be passed through, but if it fails then this request will try again and hit the server
        lastLangPromise.then(deferred.resolve, tryGettingThisTable);
      }
      //retain a reference to the last promise so we can continue the chain if another request is made before any succeed
      //you can picture the promise chain as a singly-linked list (formed by the .then handler queues) that's traversed by the execution context
      this.langPromises[lang] = deferred.promise;
    }
    else {
      //the part has already been loaded - if lastLangPromise is also undefined then the table has been populated using setPart
      //this breaks the promise chain because we're not tying langDeferred's outcome to a previous call's promise handler queues, but we don't care because there's no asynchronous execution context to keep track of anymore
      deferred.resolve(this.tables[lang]);
    }
    return deferred.promise;
  };

  var parts = {};

  function hasPart(name) {
    return Object.prototype.hasOwnProperty.call(parts, name);
  }

  function isStringValid(str) {
    return angular.isString(str) && str !== '';
  }

  function isPartAvailable(name) {
    if (!isStringValid(name)) {
      throw new TypeError('Invalid type of a first argument, a non-empty string expected.');
    }

    return (hasPart(name) && parts[name].isActive);
  }

  function deepExtend(dst, src) {
    for (var property in src) {
      if (src[property] && src[property].constructor &&
        src[property].constructor === Object) {
        dst[property] = dst[property] || {};
        deepExtend(dst[property], src[property]);
      } else {
        dst[property] = src[property];
      }
    }
    return dst;
  }

  function getPrioritizedParts() {
    var prioritizedParts = [];
    for (var part in parts) {
      if (parts[part].isActive) {
        prioritizedParts.push(parts[part]);
      }
    }
    prioritizedParts.sort(function (a, b) {
      return a.priority - b.priority;
    });
    return prioritizedParts;
  }


  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#addPart
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Registers a new part of the translation table to be loaded once the
   * `angular-translate` gets into runtime phase. It does not actually load any
   * translation data, but only registers a part to be loaded in the future.
   *
   * @param {string} name A name of the part to add
   * @param {int} [priority=0] Sets the load priority of this part.
   *
   * @returns {object} $translatePartialLoaderProvider, so this method is chainable
   * @throws {TypeError} The method could throw a **TypeError** if you pass the param
   * of the wrong type. Please, note that the `name` param has to be a
   * non-empty **string**.
   */
  this.addPart = function (name, priority, urlTemplate) {
    if (!isStringValid(name)) {
      throw new TypeError('Couldn\'t add part, part name has to be a string!');
    }

    if (!hasPart(name)) {
      parts[name] = new Part(name, priority, urlTemplate);
    }
    parts[name].isActive = true;

    return this;
  };

  /**
   * @ngdocs function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#setPart
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Sets a translation table to the specified part. This method does not make the
   * specified part available, but only avoids loading this part from the server.
   *
   * @param {string} lang A language of the given translation table
   * @param {string} part A name of the target part
   * @param {object} table A translation table to set to the specified part
   *
   * @return {object} $translatePartialLoaderProvider, so this method is chainable
   * @throws {TypeError} The method could throw a **TypeError** if you pass params
   * of the wrong type. Please, note that the `lang` and `part` params have to be a
   * non-empty **string**s and the `table` param has to be an object.
   */
  this.setPart = function (lang, part, table) {
    if (!isStringValid(lang)) {
      throw new TypeError('Couldn\'t set part.`lang` parameter has to be a string!');
    }
    if (!isStringValid(part)) {
      throw new TypeError('Couldn\'t set part.`part` parameter has to be a string!');
    }
    if (typeof table !== 'object' || table === null) {
      throw new TypeError('Couldn\'t set part. `table` parameter has to be an object!');
    }

    if (!hasPart(part)) {
      parts[part] = new Part(part);
      parts[part].isActive = false;
    }

    parts[part].tables[lang] = table;
    return this;
  };

  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#deletePart
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Removes the previously added part of the translation data. So, `angular-translate` will not
   * load it at the startup.
   *
   * @param {string} name A name of the part to delete
   *
   * @returns {object} $translatePartialLoaderProvider, so this method is chainable
   *
   * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
   * type. Please, note that the `name` param has to be a non-empty **string**.
   */
  this.deletePart = function (name) {
    if (!isStringValid(name)) {
      throw new TypeError('Couldn\'t delete part, first arg has to be string.');
    }

    if (hasPart(name)) {
      parts[name].isActive = false;
    }

    return this;
  };


  /**
   * @ngdoc function
   * @name pascalprecht.translate.$translatePartialLoaderProvider#isPartAvailable
   * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
   *
   * @description
   * Checks if the specific part is available. A part becomes available after it was added by the
   * `addPart` method. Available parts would be loaded from the server once the `angular-translate`
   * asks the loader to that.
   *
   * @param {string} name A name of the part to check
   *
   * @returns {boolean} Returns **true** if the part is available now and **false** if not.
   *
   * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
   * type. Please, note that the `name` param has to be a non-empty **string**.
   */
  this.isPartAvailable = isPartAvailable;

  /**
   * @ngdoc object
   * @name pascalprecht.translate.$translatePartialLoader
   *
   * @requires $q
   * @requires $http
   * @requires $injector
   * @requires $rootScope
   * @requires $translate
   *
   * @description
   *
   * @param {object} options Options object
   *
   * @throws {TypeError}
   */
  this.$get = ['$rootScope', '$injector', '$q', '$http', '$log',
    function ($rootScope, $injector, $q, $http, $log) {

      /**
       * @ngdoc event
       * @name pascalprecht.translate.$translatePartialLoader#$translatePartialLoaderStructureChanged
       * @eventOf pascalprecht.translate.$translatePartialLoader
       * @eventType broadcast on root scope
       *
       * @description
       * A $translatePartialLoaderStructureChanged event is called when a state of the loader was
       * changed somehow. It could mean either some part is added or some part is deleted. Anyway when
       * you get this event the translation table is not longer current and has to be updated.
       *
       * @param {string} name A name of the part which is a reason why the event was fired
       */

      var service = function (options) {
        if (!isStringValid(options.key)) {
          throw new TypeError('Unable to load data, a key is not a non-empty string.');
        }

        if (!isStringValid(options.urlTemplate) && !angular.isFunction(options.urlTemplate)) {
          throw new TypeError('Unable to load data, a urlTemplate is not a non-empty string or not a function.');
        }

        var errorHandler = options.loadFailureHandler;
        if (errorHandler !== undefined) {
          if (!angular.isString(errorHandler)) {
            throw new Error('Unable to load data, a loadFailureHandler is not a string.');
          } else {
            errorHandler = $injector.get(errorHandler);
          }
        }

        var loaders = [],
          prioritizedParts = getPrioritizedParts();

        angular.forEach(prioritizedParts, function (part) {
          loaders.push(
            part.getTable(options.key, $q, $http, options.$http, options.urlTemplate, errorHandler)
          );
          part.urlTemplate = part.urlTemplate || options.urlTemplate;
        });

        // workaround for #1781
        var structureHasBeenChangedWhileLoading = false;
        var dirtyCheckEventCloser = $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
          structureHasBeenChangedWhileLoading = true;
        });

        return $q.all(loaders)
          .then(function () {
            dirtyCheckEventCloser();
            if (structureHasBeenChangedWhileLoading) {
              if (!options.__retries) {
                // the part structure has been changed while loading (the origin ones)
                // this can happen if an addPart/removePart has been invoked right after a $translate.use(lang)
                // TODO maybe we can optimize this with the actual list of missing parts
                options.__retries = (options.__retries || 0) + 1;
                return service(options);
              } else {
                // the part structure has been changed again while loading (retried one)
                // because this could an infinite loop, this will not load another one again
                $log.warn('The partial loader has detected a multiple structure change (with addPort/removePart) ' +
                  'while loading translations. You should consider using promises of $translate.use(lang) and ' +
                  '$translate.refresh(). Also parts should be added/removed right before an explicit refresh ' +
                  'if possible.');
              }
            }
            var table = {};
            prioritizedParts = getPrioritizedParts();
            angular.forEach(prioritizedParts, function (part) {
              deepExtend(table, part.tables[options.key]);
            });
            return table;
          }, function () {
            dirtyCheckEventCloser();
            return $q.reject(options.key);
          });
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#addPart
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Registers a new part of the translation table. This method does not actually perform any xhr
       * requests to get translation data. The new parts will be loaded in order of priority from the server next time
       * `angular-translate` asks the loader to load translations.
       *
       * @param {string} name A name of the part to add
       * @param {int} [priority=0] Sets the load priority of this part.
       *
       * @returns {object} $translatePartialLoader, so this method is chainable
       *
       * @fires {$translatePartialLoaderStructureChanged} The $translatePartialLoaderStructureChanged
       * event would be fired by this method in case the new part affected somehow on the loaders
       * state. This way it means that there are a new translation data available to be loaded from
       * the server.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
       * type. Please, note that the `name` param has to be a non-empty **string**.
       */
      service.addPart = function (name, priority, urlTemplate) {
        if (!isStringValid(name)) {
          throw new TypeError('Couldn\'t add part, first arg has to be a string');
        }

        if (!hasPart(name)) {
          parts[name] = new Part(name, priority, urlTemplate);
          $rootScope.$emit('$translatePartialLoaderStructureChanged', name);
        } else if (!parts[name].isActive) {
          parts[name].isActive = true;
          $rootScope.$emit('$translatePartialLoaderStructureChanged', name);
        }

        return service;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#deletePart
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Deletes the previously added part of the translation data. The target part could be deleted
       * either logically or physically. When the data is deleted logically it is not actually deleted
       * from the browser, but the loader marks it as not active and prevents it from affecting on the
       * translations. If the deleted in such way part is added again, the loader will use the
       * previously loaded data rather than loading it from the server once more time. But if the data
       * is deleted physically, the loader will completely remove all information about it. So in case
       * of recycling this part will be loaded from the server again.
       *
       * @param {string} name A name of the part to delete
       * @param {boolean=} [removeData=false] An indicator if the loader has to remove a loaded
       * translation data physically. If the `removeData` if set to **false** the loaded data will not be
       * deleted physically and might be reused in the future to prevent an additional xhr requests.
       *
       * @returns {object} $translatePartialLoader, so this method is chainable
       *
       * @fires {$translatePartialLoaderStructureChanged} The $translatePartialLoaderStructureChanged
       * event would be fired by this method in case a part deletion process affects somehow on the
       * loaders state. This way it means that some part of the translation data is now deprecated and
       * the translation table has to be recompiled with the remaining translation parts.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass some param of the
       * wrong type. Please, note that the `name` param has to be a non-empty **string** and
       * the `removeData` param has to be either **undefined** or **boolean**.
       */
      service.deletePart = function (name, removeData) {
        if (!isStringValid(name)) {
          throw new TypeError('Couldn\'t delete part, first arg has to be string');
        }

        if (removeData === undefined) {
          removeData = false;
        } else if (typeof removeData !== 'boolean') {
          throw new TypeError('Invalid type of a second argument, a boolean expected.');
        }

        if (hasPart(name)) {
          var wasActive = parts[name].isActive;
          if (removeData) {
            var $translate = $injector.get('$translate');
            var cache = $translate.loaderCache();
            if (typeof(cache) === 'string') {
              // getting on-demand instance of loader
              cache = $injector.get(cache);
            }
            // Purging items from cache...
            if (typeof(cache) === 'object') {
              angular.forEach(parts[name].tables, function (value, key) {
                cache.remove(parts[name].parseUrl(parts[name].urlTemplate, key));
              });
            }
            delete parts[name];
          } else {
            parts[name].isActive = false;
          }
          if (wasActive) {
            $rootScope.$emit('$translatePartialLoaderStructureChanged', name);
          }
        }

        return service;
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#isPartLoaded
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Checks if the registered translation part is loaded into the translation table.
       *
       * @param {string} name A name of the part
       * @param {string} lang A key of the language
       *
       * @returns {boolean} Returns **true** if the translation of the part is loaded to the translation table and **false** if not.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
       * type. Please, note that the `name` and `lang` params have to be non-empty **string**.
       */
      service.isPartLoaded = function (name, lang) {
        return angular.isDefined(parts[name]) && angular.isDefined(parts[name].tables[lang]);
      };

      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#getRegisteredParts
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Gets names of the parts that were added with the `addPart`.
       *
       * @returns {array} Returns array of registered parts, if none were registered then an empty array is returned.
       */
      service.getRegisteredParts = function () {
        var registeredParts = [];
        angular.forEach(parts, function (p) {
          if (p.isActive) {
            registeredParts.push(p.name);
          }
        });
        return registeredParts;
      };


      /**
       * @ngdoc function
       * @name pascalprecht.translate.$translatePartialLoader#isPartAvailable
       * @methodOf pascalprecht.translate.$translatePartialLoader
       *
       * @description
       * Checks if a target translation part is available. The part becomes available just after it was
       * added by the `addPart` method. Part's availability does not mean that it was loaded from the
       * server, but only that it was added to the loader. The available part might be loaded next
       * time the loader is called.
       *
       * @param {string} name A name of the part to delete
       *
       * @returns {boolean} Returns **true** if the part is available now and **false** if not.
       *
       * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
       * type. Please, note that the `name` param has to be a non-empty **string**.
       */
      service.isPartAvailable = isPartAvailable;

      return service;

    }];

}

$translatePartialLoader.displayName = '$translatePartialLoader';
return 'pascalprecht.translate';

}));

/**
 * State-based routing for AngularJS
 * @version v0.4.3
 * @link http://angular-ui.github.com/
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */

/* commonjs package manager support (eg componentjs) */
if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
  module.exports = 'ui.router';
}

(function (window, angular, undefined) {
/*jshint globalstrict:true*/
/*global angular:false*/
'use strict';

var isDefined = angular.isDefined,
    isFunction = angular.isFunction,
    isString = angular.isString,
    isObject = angular.isObject,
    isArray = angular.isArray,
    forEach = angular.forEach,
    extend = angular.extend,
    copy = angular.copy,
    toJson = angular.toJson;

function inherit(parent, extra) {
  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
}

function merge(dst) {
  forEach(arguments, function(obj) {
    if (obj !== dst) {
      forEach(obj, function(value, key) {
        if (!dst.hasOwnProperty(key)) dst[key] = value;
      });
    }
  });
  return dst;
}

/**
 * Finds the common ancestor path between two states.
 *
 * @param {Object} first The first state.
 * @param {Object} second The second state.
 * @return {Array} Returns an array of state names in descending order, not including the root.
 */
function ancestors(first, second) {
  var path = [];

  for (var n in first.path) {
    if (first.path[n] !== second.path[n]) break;
    path.push(first.path[n]);
  }
  return path;
}

/**
 * IE8-safe wrapper for `Object.keys()`.
 *
 * @param {Object} object A JavaScript object.
 * @return {Array} Returns the keys of the object as an array.
 */
function objectKeys(object) {
  if (Object.keys) {
    return Object.keys(object);
  }
  var result = [];

  forEach(object, function(val, key) {
    result.push(key);
  });
  return result;
}

/**
 * IE8-safe wrapper for `Array.prototype.indexOf()`.
 *
 * @param {Array} array A JavaScript array.
 * @param {*} value A value to search the array for.
 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
 */
function indexOf(array, value) {
  if (Array.prototype.indexOf) {
    return array.indexOf(value, Number(arguments[2]) || 0);
  }
  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
  from = (from < 0) ? Math.ceil(from) : Math.floor(from);

  if (from < 0) from += len;

  for (; from < len; from++) {
    if (from in array && array[from] === value) return from;
  }
  return -1;
}

/**
 * Merges a set of parameters with all parameters inherited between the common parents of the
 * current state and a given destination state.
 *
 * @param {Object} currentParams The value of the current state parameters ($stateParams).
 * @param {Object} newParams The set of parameters which will be composited with inherited params.
 * @param {Object} $current Internal definition of object representing the current state.
 * @param {Object} $to Internal definition of object representing state to transition to.
 */
function inheritParams(currentParams, newParams, $current, $to) {
  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];

  for (var i in parents) {
    if (!parents[i] || !parents[i].params) continue;
    parentParams = objectKeys(parents[i].params);
    if (!parentParams.length) continue;

    for (var j in parentParams) {
      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
      inheritList.push(parentParams[j]);
      inherited[parentParams[j]] = currentParams[parentParams[j]];
    }
  }
  return extend({}, inherited, newParams);
}

/**
 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
 *
 * @param {Object} a The first object.
 * @param {Object} b The second object.
 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
 *                     it defaults to the list of keys in `a`.
 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
 */
function equalForKeys(a, b, keys) {
  if (!keys) {
    keys = [];
    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
  }

  for (var i=0; i<keys.length; i++) {
    var k = keys[i];
    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
  }
  return true;
}

/**
 * Returns the subset of an object, based on a list of keys.
 *
 * @param {Array} keys
 * @param {Object} values
 * @return {Boolean} Returns a subset of `values`.
 */
function filterByKeys(keys, values) {
  var filtered = {};

  forEach(keys, function (name) {
    filtered[name] = values[name];
  });
  return filtered;
}

// like _.indexBy
// when you know that your index values will be unique, or you want last-one-in to win
function indexBy(array, propName) {
  var result = {};
  forEach(array, function(item) {
    result[item[propName]] = item;
  });
  return result;
}

// extracted from underscore.js
// Return a copy of the object only containing the whitelisted properties.
function pick(obj) {
  var copy = {};
  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
  forEach(keys, function(key) {
    if (key in obj) copy[key] = obj[key];
  });
  return copy;
}

// extracted from underscore.js
// Return a copy of the object omitting the blacklisted properties.
function omit(obj) {
  var copy = {};
  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
  for (var key in obj) {
    if (indexOf(keys, key) == -1) copy[key] = obj[key];
  }
  return copy;
}

function pluck(collection, key) {
  var result = isArray(collection) ? [] : {};

  forEach(collection, function(val, i) {
    result[i] = isFunction(key) ? key(val) : val[key];
  });
  return result;
}

function filter(collection, callback) {
  var array = isArray(collection);
  var result = array ? [] : {};
  forEach(collection, function(val, i) {
    if (callback(val, i)) {
      result[array ? result.length : i] = val;
    }
  });
  return result;
}

function map(collection, callback) {
  var result = isArray(collection) ? [] : {};

  forEach(collection, function(val, i) {
    result[i] = callback(val, i);
  });
  return result;
}

// issue #2676 #2889
function silenceUncaughtInPromise (promise) {
  return promise.then(undefined, function() {}) && promise;
}

/**
 * @ngdoc overview
 * @name ui.router.util
 *
 * @description
 * # ui.router.util sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 *
 */
angular.module('ui.router.util', ['ng']);

/**
 * @ngdoc overview
 * @name ui.router.router
 * 
 * @requires ui.router.util
 *
 * @description
 * # ui.router.router sub-module
 *
 * This module is a dependency of other sub-modules. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 */
angular.module('ui.router.router', ['ui.router.util']);

/**
 * @ngdoc overview
 * @name ui.router.state
 * 
 * @requires ui.router.router
 * @requires ui.router.util
 *
 * @description
 * # ui.router.state sub-module
 *
 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
 * in your angular app (use {@link ui.router} module instead).
 * 
 */
angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);

/**
 * @ngdoc overview
 * @name ui.router
 *
 * @requires ui.router.state
 *
 * @description
 * # ui.router
 * 
 * ## The main module for ui.router 
 * There are several sub-modules included with the ui.router module, however only this module is needed
 * as a dependency within your angular app. The other modules are for organization purposes. 
 *
 * The modules are:
 * * ui.router - the main "umbrella" module
 * * ui.router.router - 
 * 
 * *You'll need to include **only** this module as the dependency within your angular app.*
 * 
 * <pre>
 * <!doctype html>
 * <html ng-app="myApp">
 * <head>
 *   <script src="js/angular.js"></script>
 *   <!-- Include the ui-router script -->
 *   <script src="js/angular-ui-router.min.js"></script>
 *   <script>
 *     // ...and add 'ui.router' as a dependency
 *     var myApp = angular.module('myApp', ['ui.router']);
 *   </script>
 * </head>
 * <body>
 * </body>
 * </html>
 * </pre>
 */
angular.module('ui.router', ['ui.router.state']);

angular.module('ui.router.compat', ['ui.router']);

/**
 * @ngdoc object
 * @name ui.router.util.$resolve
 *
 * @requires $q
 * @requires $injector
 *
 * @description
 * Manages resolution of (acyclic) graphs of promises.
 */
$Resolve.$inject = ['$q', '$injector'];
function $Resolve(  $q,    $injector) {
  
  var VISIT_IN_PROGRESS = 1,
      VISIT_DONE = 2,
      NOTHING = {},
      NO_DEPENDENCIES = [],
      NO_LOCALS = NOTHING,
      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
  

  /**
   * @ngdoc function
   * @name ui.router.util.$resolve#study
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Studies a set of invocables that are likely to be used multiple times.
   * <pre>
   * $resolve.study(invocables)(locals, parent, self)
   * </pre>
   * is equivalent to
   * <pre>
   * $resolve.resolve(invocables, locals, parent, self)
   * </pre>
   * but the former is more efficient (in fact `resolve` just calls `study` 
   * internally).
   *
   * @param {object} invocables Invocable objects
   * @return {function} a function to pass in locals, parent and self
   */
  this.study = function (invocables) {
    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
    var invocableKeys = objectKeys(invocables || {});
    
    // Perform a topological sort of invocables to build an ordered plan
    var plan = [], cycle = [], visited = {};
    function visit(value, key) {
      if (visited[key] === VISIT_DONE) return;
      
      cycle.push(key);
      if (visited[key] === VISIT_IN_PROGRESS) {
        cycle.splice(0, indexOf(cycle, key));
        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
      }
      visited[key] = VISIT_IN_PROGRESS;
      
      if (isString(value)) {
        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
      } else {
        var params = $injector.annotate(value);
        forEach(params, function (param) {
          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
        });
        plan.push(key, value, params);
      }
      
      cycle.pop();
      visited[key] = VISIT_DONE;
    }
    forEach(invocables, visit);
    invocables = cycle = visited = null; // plan is all that's required
    
    function isResolve(value) {
      return isObject(value) && value.then && value.$$promises;
    }
    
    return function (locals, parent, self) {
      if (isResolve(locals) && self === undefined) {
        self = parent; parent = locals; locals = null;
      }
      if (!locals) locals = NO_LOCALS;
      else if (!isObject(locals)) {
        throw new Error("'locals' must be an object");
      }       
      if (!parent) parent = NO_PARENT;
      else if (!isResolve(parent)) {
        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
      }
      
      // To complete the overall resolution, we have to wait for the parent
      // promise and for the promise for each invokable in our plan.
      var resolution = $q.defer(),
          result = silenceUncaughtInPromise(resolution.promise),
          promises = result.$$promises = {},
          values = extend({}, locals),
          wait = 1 + plan.length/3,
          merged = false;

      silenceUncaughtInPromise(result);
          
      function done() {
        // Merge parent values we haven't got yet and publish our own $$values
        if (!--wait) {
          if (!merged) merge(values, parent.$$values); 
          result.$$values = values;
          result.$$promises = result.$$promises || true; // keep for isResolve()
          delete result.$$inheritedValues;
          resolution.resolve(values);
        }
      }
      
      function fail(reason) {
        result.$$failure = reason;
        resolution.reject(reason);
      }

      // Short-circuit if parent has already failed
      if (isDefined(parent.$$failure)) {
        fail(parent.$$failure);
        return result;
      }
      
      if (parent.$$inheritedValues) {
        merge(values, omit(parent.$$inheritedValues, invocableKeys));
      }

      // Merge parent values if the parent has already resolved, or merge
      // parent promises and wait if the parent resolve is still in progress.
      extend(promises, parent.$$promises);
      if (parent.$$values) {
        merged = merge(values, omit(parent.$$values, invocableKeys));
        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
        done();
      } else {
        if (parent.$$inheritedValues) {
          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
        }        
        parent.then(done, fail);
      }
      
      // Process each invocable in the plan, but ignore any where a local of the same name exists.
      for (var i=0, ii=plan.length; i<ii; i+=3) {
        if (locals.hasOwnProperty(plan[i])) done();
        else invoke(plan[i], plan[i+1], plan[i+2]);
      }
      
      function invoke(key, invocable, params) {
        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
        var invocation = $q.defer(), waitParams = 0;
        function onfailure(reason) {
          invocation.reject(reason);
          fail(reason);
        }
        // Wait for any parameter that we have a promise for (either from parent or from this
        // resolve; in that case study() will have made sure it's ordered before us in the plan).
        forEach(params, function (dep) {
          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
            waitParams++;
            promises[dep].then(function (result) {
              values[dep] = result;
              if (!(--waitParams)) proceed();
            }, onfailure);
          }
        });
        if (!waitParams) proceed();
        function proceed() {
          if (isDefined(result.$$failure)) return;
          try {
            invocation.resolve($injector.invoke(invocable, self, values));
            invocation.promise.then(function (result) {
              values[key] = result;
              done();
            }, onfailure);
          } catch (e) {
            onfailure(e);
          }
        }
        // Publish promise synchronously; invocations further down in the plan may depend on it.
        promises[key] = silenceUncaughtInPromise(invocation.promise);
      }
      
      return result;
    };
  };
  
  /**
   * @ngdoc function
   * @name ui.router.util.$resolve#resolve
   * @methodOf ui.router.util.$resolve
   *
   * @description
   * Resolves a set of invocables. An invocable is a function to be invoked via 
   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
   * An invocable can either return a value directly,
   * or a `$q` promise. If a promise is returned it will be resolved and the 
   * resulting value will be used instead. Dependencies of invocables are resolved 
   * (in this order of precedence)
   *
   * - from the specified `locals`
   * - from another invocable that is part of this `$resolve` call
   * - from an invocable that is inherited from a `parent` call to `$resolve` 
   *   (or recursively
   * - from any ancestor `$resolve` of that parent).
   *
   * The return value of `$resolve` is a promise for an object that contains 
   * (in this order of precedence)
   *
   * - any `locals` (if specified)
   * - the resolved return values of all injectables
   * - any values inherited from a `parent` call to `$resolve` (if specified)
   *
   * The promise will resolve after the `parent` promise (if any) and all promises 
   * returned by injectables have been resolved. If any invocable 
   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
   * same error. A rejection of a `parent` promise (if specified) will likewise be 
   * propagated immediately. Once the `$resolve` promise has been rejected, no 
   * further invocables will be called.
   * 
   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
   * to throw an error. As a special case, an injectable can depend on a parameter 
   * with the same name as the injectable, which will be fulfilled from the `parent` 
   * injectable of the same name. This allows inherited values to be decorated. 
   * Note that in this case any other injectable in the same `$resolve` with the same
   * dependency would see the decorated value, not the inherited value.
   *
   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
   * exception.
   *
   * Invocables are invoked eagerly as soon as all dependencies are available. 
   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
   *
   * As a special case, an invocable can be a string, in which case it is taken to 
   * be a service name to be passed to `$injector.get()`. This is supported primarily 
   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
   * routes.
   *
   * @param {object} invocables functions to invoke or 
   * `$injector` services to fetch.
   * @param {object} locals  values to make available to the injectables
   * @param {object} parent  a promise returned by another call to `$resolve`.
   * @param {object} self  the `this` for the invoked methods
   * @return {object} Promise for an object that contains the resolved return value
   * of all invocables, as well as any inherited and local values.
   */
  this.resolve = function (invocables, locals, parent, self) {
    return this.study(invocables)(locals, parent, self);
  };
}

angular.module('ui.router.util').service('$resolve', $Resolve);



/**
 * @ngdoc object
 * @name ui.router.util.$templateFactoryProvider
 *
 * @description
 * Provider for $templateFactory. Manages which template-loading mechanism to
 * use, and will default to the most recent one ($templateRequest on Angular
 * versions starting from 1.3, $http otherwise).
 */
function TemplateFactoryProvider() {
  var shouldUnsafelyUseHttp = angular.version.minor < 3;

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactoryProvider#shouldUnsafelyUseHttp
   * @methodOf ui.router.util.$templateFactoryProvider
   *
   * @description
   * Forces $templateFactory to use $http instead of $templateRequest. This
   * might cause XSS, as $http doesn't enforce the regular security checks for
   * templates that have been introduced in Angular 1.3. Note that setting this
   * to false on Angular older than 1.3.x will crash, as the $templateRequest
   * service (and the security checks) are not implemented on these versions.
   *
   * See the $sce documentation, section
   * <a href="https://docs.angularjs.org/api/ng/service/$sce#impact-on-loading-templates">
   * Impact on loading templates</a> for more details about this mechanism.
   *
   * @param {boolean} value
   */
  this.shouldUnsafelyUseHttp = function(value) {
    shouldUnsafelyUseHttp = !!value;
  };

  /**
   * @ngdoc object
   * @name ui.router.util.$templateFactory
   *
   * @requires $http
   * @requires $templateCache
   * @requires $injector
   *
   * @description
   * Service. Manages loading of templates.
   */
  this.$get = ['$http', '$templateCache', '$injector', function($http, $templateCache, $injector){
    return new TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp);}];
}


/**
 * @ngdoc object
 * @name ui.router.util.$templateFactory
 *
 * @requires $http
 * @requires $templateCache
 * @requires $injector
 *
 * @description
 * Service. Manages loading of templates.
 */
function TemplateFactory($http, $templateCache, $injector, shouldUnsafelyUseHttp) {

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromConfig
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a configuration object. 
   *
   * @param {object} config Configuration object for which to load a template. 
   * The following properties are search in the specified order, and the first one 
   * that is defined is used to create the template:
   *
   * @param {string|object} config.template html string template or function to 
   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
   * @param {string|object} config.templateUrl url to load or a function returning 
   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
   * @param {Function} config.templateProvider function to invoke via 
   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
   * @param {object} params  Parameters to pass to the template function.
   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
   * via a `templateProvider`. Defaults to `{ params: params }`.
   *
   * @return {string|object}  The template html as a string, or a promise for 
   * that string,or `null` if no template is configured.
   */
  this.fromConfig = function (config, params, locals) {
    return (
      isDefined(config.template) ? this.fromString(config.template, params) :
      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
      null
    );
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromString
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template from a string or a function returning a string.
   *
   * @param {string|object} template html template as a string or function that 
   * returns an html template as a string.
   * @param {object} params Parameters to pass to the template function.
   *
   * @return {string|object} The template html as a string, or a promise for that 
   * string.
   */
  this.fromString = function (template, params) {
    return isFunction(template) ? template(params) : template;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromUrl
   * @methodOf ui.router.util.$templateFactory
   * 
   * @description
   * Loads a template from the a URL via `$http` and `$templateCache`.
   *
   * @param {string|Function} url url of the template to load, or a function 
   * that returns a url.
   * @param {Object} params Parameters to pass to the url function.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */
  this.fromUrl = function (url, params) {
    if (isFunction(url)) url = url(params);
    if (url == null) return null;
    else {
      if(!shouldUnsafelyUseHttp) {
        return $injector.get('$templateRequest')(url);
      } else {
        return $http
          .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
          .then(function(response) { return response.data; });
      }
    }
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$templateFactory#fromProvider
   * @methodOf ui.router.util.$templateFactory
   *
   * @description
   * Creates a template by invoking an injectable provider function.
   *
   * @param {Function} provider Function to invoke via `$injector.invoke`
   * @param {Object} params Parameters for the template.
   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
   * `{ params: params }`.
   * @return {string|Promise.<string>} The template html as a string, or a promise 
   * for that string.
   */
  this.fromProvider = function (provider, params, locals) {
    return $injector.invoke(provider, null, locals || { params: params });
  };
}

angular.module('ui.router.util').provider('$templateFactory', TemplateFactoryProvider);

var $$UMFP; // reference to $UrlMatcherFactoryProvider

/**
 * @ngdoc object
 * @name ui.router.util.type:UrlMatcher
 *
 * @description
 * Matches URLs against patterns and extracts named parameters from the path or the search
 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
 * do not influence whether or not a URL is matched, but their values are passed through into
 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
 *
 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
 * syntax, which optionally allows a regular expression for the parameter to be specified:
 *
 * * `':'` name - colon placeholder
 * * `'*'` name - catch-all placeholder
 * * `'{' name '}'` - curly placeholder
 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
 *
 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
 * must be unique within the pattern (across both path and search parameters). For colon
 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
 * number of characters other than '/'. For catch-all placeholders the path parameter matches
 * any number of characters.
 *
 * Examples:
 *
 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
 * * `'/user/{id:[^/]*}'` - Same as the previous example.
 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
 *   parameter consists of 1 to 8 hex digits.
 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
 *   path into the parameter 'path'.
 * * `'/files/*path'` - ditto.
 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
 *
 * @param {string} pattern  The pattern to compile into a matcher.
 * @param {Object} config  A configuration object hash:
 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
 *   an existing UrlMatcher
 *
 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
 *
 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
 *   non-null) will start with this prefix.
 *
 * @property {string} source  The pattern that was passed into the constructor
 *
 * @property {string} sourcePath  The path portion of the source property
 *
 * @property {string} sourceSearch  The search portion of the source property
 *
 * @property {string} regex  The constructed regex that will be used to match against the url when
 *   it is time to determine which url will match.
 *
 * @returns {Object}  New `UrlMatcher` object
 */
function UrlMatcher(pattern, config, parentMatcher) {
  config = extend({ params: {} }, isObject(config) ? config : {});

  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
  //   '*' name
  //   ':' name
  //   '{' name '}'
  //   '{' name ':' regexp '}'
  // The regular expression is somewhat complicated due to the need to allow curly braces
  // inside the regular expression. The placeholder regexp breaks down as follows:
  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
  //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
  //    [^{}\\]+                       - anything other than curly braces or backslash
  //    \\.                            - a backslash escape
  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
      searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
      compiled = '^', last = 0, m,
      segments = this.segments = [],
      parentParams = parentMatcher ? parentMatcher.params : {},
      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
      paramNames = [];

  function addParameter(id, type, config, location) {
    paramNames.push(id);
    if (parentParams[id]) return parentParams[id];
    if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
    params[id] = new $$UMFP.Param(id, type, config, location);
    return params[id];
  }

  function quoteRegExp(string, pattern, squash, optional) {
    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
    if (!pattern) return result;
    switch(squash) {
      case false: surroundPattern = ['(', ')' + (optional ? "?" : "")]; break;
      case true:
        result = result.replace(/\/$/, '');
        surroundPattern = ['(?:\/(', ')|\/)?'];
      break;
      default:    surroundPattern = ['(' + squash + "|", ')?']; break;
    }
    return result + surroundPattern[0] + pattern + surroundPattern[1];
  }

  this.source = pattern;

  // Split into static segments separated by path parameter placeholders.
  // The number of segments is always 1 more than the number of parameters.
  function matchDetails(m, isSearch) {
    var id, regexp, segment, type, cfg, arrayMode;
    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
    cfg         = config.params[id];
    segment     = pattern.substring(last, m.index);
    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);

    if (regexp) {
      type      = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
    }

    return {
      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
    };
  }

  var p, param, segment;
  while ((m = placeholder.exec(pattern))) {
    p = matchDetails(m, false);
    if (p.segment.indexOf('?') >= 0) break; // we're into the search part

    param = addParameter(p.id, p.type, p.cfg, "path");
    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
    segments.push(p.segment);
    last = placeholder.lastIndex;
  }
  segment = pattern.substring(last);

  // Find any search parameter names and remove them from the last segment
  var i = segment.indexOf('?');

  if (i >= 0) {
    var search = this.sourceSearch = segment.substring(i);
    segment = segment.substring(0, i);
    this.sourcePath = pattern.substring(0, last + i);

    if (search.length > 0) {
      last = 0;
      while ((m = searchPlaceholder.exec(search))) {
        p = matchDetails(m, true);
        param = addParameter(p.id, p.type, p.cfg, "search");
        last = placeholder.lastIndex;
        // check if ?&
      }
    }
  } else {
    this.sourcePath = pattern;
    this.sourceSearch = '';
  }

  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
  segments.push(segment);

  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
  this.prefix = segments[0];
  this.$$paramNames = paramNames;
}

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#concat
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns a new matcher for a pattern constructed by appending the path part and adding the
 * search parameters of the specified pattern to this pattern. The current pattern is not
 * modified. This can be understood as creating a pattern for URLs that are relative to (or
 * suffixes of) the current pattern.
 *
 * @example
 * The following two matchers are equivalent:
 * <pre>
 * new UrlMatcher('/user/{id}?q').concat('/details?date');
 * new UrlMatcher('/user/{id}/details?q&date');
 * </pre>
 *
 * @param {string} pattern  The pattern to append.
 * @param {Object} config  An object hash of the configuration for the matcher.
 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
 */
UrlMatcher.prototype.concat = function (pattern, config) {
  // Because order of search parameters is irrelevant, we can add our own search
  // parameters to the end of the new pattern. Parse the new pattern by itself
  // and then join the bits together, but it's much easier to do this on a string level.
  var defaultConfig = {
    caseInsensitive: $$UMFP.caseInsensitive(),
    strict: $$UMFP.strictMode(),
    squash: $$UMFP.defaultSquashPolicy()
  };
  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
};

UrlMatcher.prototype.toString = function () {
  return this.source;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#exec
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Tests the specified path against this matcher, and returns an object containing the captured
 * parameter values, or null if the path does not match. The returned object contains the values
 * of any search parameters that are mentioned in the pattern, but their value may be null if
 * they are not present in `searchParams`. This means that search parameters are always treated
 * as optional.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
 *   x: '1', q: 'hello'
 * });
 * // returns { id: 'bob', q: 'hello', r: null }
 * </pre>
 *
 * @param {string} path  The URL path to match, e.g. `$location.path()`.
 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
 * @returns {Object}  The captured parameter values.
 */
UrlMatcher.prototype.exec = function (path, searchParams) {
  var m = this.regexp.exec(path);
  if (!m) return null;
  searchParams = searchParams || {};

  var paramNames = this.parameters(), nTotal = paramNames.length,
    nPath = this.segments.length - 1,
    values = {}, i, j, cfg, paramName;

  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");

  function decodePathArray(string) {
    function reverseString(str) { return str.split("").reverse().join(""); }
    function unquoteDashes(str) { return str.replace(/\\-/g, "-"); }

    var split = reverseString(string).split(/-(?!\\)/);
    var allReversed = map(split, reverseString);
    return map(allReversed, unquoteDashes).reverse();
  }

  var param, paramVal;
  for (i = 0; i < nPath; i++) {
    paramName = paramNames[i];
    param = this.params[paramName];
    paramVal = m[i+1];
    // if the param value matches a pre-replace pair, replace the value before decoding.
    for (j = 0; j < param.replace.length; j++) {
      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
    }
    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
    values[paramName] = param.value(paramVal);
  }
  for (/**/; i < nTotal; i++) {
    paramName = paramNames[i];
    values[paramName] = this.params[paramName].value(searchParams[paramName]);
    param = this.params[paramName];
    paramVal = searchParams[paramName];
    for (j = 0; j < param.replace.length; j++) {
      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
    }
    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
    values[paramName] = param.value(paramVal);
  }

  return values;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#parameters
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Returns the names of all path and search parameters of this pattern in an unspecified order.
 *
 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
 *    pattern has no parameters, an empty array is returned.
 */
UrlMatcher.prototype.parameters = function (param) {
  if (!isDefined(param)) return this.$$paramNames;
  return this.params[param] || null;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#validates
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Checks an object hash of parameters to validate their correctness according to the parameter
 * types of this `UrlMatcher`.
 *
 * @param {Object} params The object hash of parameters to validate.
 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
 */
UrlMatcher.prototype.validates = function (params) {
  return this.params.$$validates(params);
};

/**
 * @ngdoc function
 * @name ui.router.util.type:UrlMatcher#format
 * @methodOf ui.router.util.type:UrlMatcher
 *
 * @description
 * Creates a URL that matches this pattern by substituting the specified values
 * for the path and search parameters. Null values for path parameters are
 * treated as empty strings.
 *
 * @example
 * <pre>
 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
 * // returns '/user/bob?q=yes'
 * </pre>
 *
 * @param {Object} values  the values to substitute for the parameters in this pattern.
 * @returns {string}  the formatted URL (path and optionally search part).
 */
UrlMatcher.prototype.format = function (values) {
  values = values || {};
  var segments = this.segments, params = this.parameters(), paramset = this.params;
  if (!this.validates(values)) return null;

  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];

  function encodeDashes(str) { // Replace dashes with encoded "\-"
    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
  }

  for (i = 0; i < nTotal; i++) {
    var isPathParam = i < nPath;
    var name = params[i], param = paramset[name], value = param.value(values[name]);
    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
    var squash = isDefaultValue ? param.squash : false;
    var encoded = param.type.encode(value);

    if (isPathParam) {
      var nextSegment = segments[i + 1];
      var isFinalPathParam = i + 1 === nPath;

      if (squash === false) {
        if (encoded != null) {
          if (isArray(encoded)) {
            result += map(encoded, encodeDashes).join("-");
          } else {
            result += encodeURIComponent(encoded);
          }
        }
        result += nextSegment;
      } else if (squash === true) {
        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
        result += nextSegment.match(capture)[1];
      } else if (isString(squash)) {
        result += squash + nextSegment;
      }

      if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
    } else {
      if (encoded == null || (isDefaultValue && squash !== false)) continue;
      if (!isArray(encoded)) encoded = [ encoded ];
      if (encoded.length === 0) continue;
      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
      result += (search ? '&' : '?') + (name + '=' + encoded);
      search = true;
    }
  }

  return result;
};

/**
 * @ngdoc object
 * @name ui.router.util.type:Type
 *
 * @description
 * Implements an interface to define custom parameter types that can be decoded from and encoded to
 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
 * objects when matching or formatting URLs, or comparing or validating parameter values.
 *
 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
 * information on registering custom types.
 *
 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
 *        properties will override the default methods and/or pattern in `Type`'s public interface.
 * @example
 * <pre>
 * {
 *   decode: function(val) { return parseInt(val, 10); },
 *   encode: function(val) { return val && val.toString(); },
 *   equals: function(a, b) { return this.is(a) && a === b; },
 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
 *   pattern: /\d+/
 * }
 * </pre>
 *
 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
 *           coming from a substring of a URL.
 *
 * @returns {Object}  Returns a new `Type` object.
 */
function Type(config) {
  extend(this, config);
}

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#is
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Detects whether a value is of a particular type. Accepts a native (decoded) value
 * and determines whether it matches the current `Type` object.
 *
 * @param {*} val  The value to check.
 * @param {string} key  Optional. If the type check is happening in the context of a specific
 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
 */
Type.prototype.is = function(val, key) {
  return true;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#encode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
 * only needs to be a representation of `val` that has been coerced to a string.
 *
 * @param {*} val  The value to encode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
 */
Type.prototype.encode = function(val, key) {
  return val;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#decode
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Converts a parameter value (from URL string or transition param) to a custom/native value.
 *
 * @param {string} val  The URL parameter value to decode.
 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
 *        meta-programming of `Type` objects.
 * @returns {*}  Returns a custom representation of the URL parameter value.
 */
Type.prototype.decode = function(val, key) {
  return val;
};

/**
 * @ngdoc function
 * @name ui.router.util.type:Type#equals
 * @methodOf ui.router.util.type:Type
 *
 * @description
 * Determines whether two decoded values are equivalent.
 *
 * @param {*} a  A value to compare against.
 * @param {*} b  A value to compare against.
 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
 */
Type.prototype.equals = function(a, b) {
  return a == b;
};

Type.prototype.$subPattern = function() {
  var sub = this.pattern.toString();
  return sub.substr(1, sub.length - 2);
};

Type.prototype.pattern = /.*/;

Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };

/** Given an encoded string, or a decoded object, returns a decoded object */
Type.prototype.$normalize = function(val) {
  return this.is(val) ? val : this.decode(val);
};

/*
 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
 * e.g.:
 * - urlmatcher pattern "/path?{queryParam[]:int}"
 * - url: "/path?queryParam=1&queryParam=2
 * - $stateParams.queryParam will be [1, 2]
 * if `mode` is "auto", then
 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
 */
Type.prototype.$asArray = function(mode, isSearch) {
  if (!mode) return this;
  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");

  function ArrayType(type, mode) {
    function bindTo(type, callbackName) {
      return function() {
        return type[callbackName].apply(type, arguments);
      };
    }

    // Wrap non-array value as array
    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
    // Unwrap array value for "auto" mode. Return undefined for empty array.
    function arrayUnwrap(val) {
      switch(val.length) {
        case 0: return undefined;
        case 1: return mode === "auto" ? val[0] : val;
        default: return val;
      }
    }
    function falsey(val) { return !val; }

    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
    function arrayHandler(callback, allTruthyMode) {
      return function handleArray(val) {
        if (isArray(val) && val.length === 0) return val;
        val = arrayWrap(val);
        var result = map(val, callback);
        if (allTruthyMode === true)
          return filter(result, falsey).length === 0;
        return arrayUnwrap(result);
      };
    }

    // Wraps type (.equals) functions to operate on each value of an array
    function arrayEqualsHandler(callback) {
      return function handleArray(val1, val2) {
        var left = arrayWrap(val1), right = arrayWrap(val2);
        if (left.length !== right.length) return false;
        for (var i = 0; i < left.length; i++) {
          if (!callback(left[i], right[i])) return false;
        }
        return true;
      };
    }

    this.encode = arrayHandler(bindTo(type, 'encode'));
    this.decode = arrayHandler(bindTo(type, 'decode'));
    this.is     = arrayHandler(bindTo(type, 'is'), true);
    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
    this.pattern = type.pattern;
    this.$normalize = arrayHandler(bindTo(type, '$normalize'));
    this.name = type.name;
    this.$arrayMode = mode;
  }

  return new ArrayType(this, mode);
};



/**
 * @ngdoc object
 * @name ui.router.util.$urlMatcherFactory
 *
 * @description
 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
 * is also available to providers under the name `$urlMatcherFactoryProvider`.
 */
function $UrlMatcherFactory() {
  $$UMFP = this;

  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;

  // Use tildes to pre-encode slashes.
  // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
  // and bidirectional encoding/decoding fails.
  // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
  function valToString(val) { return val != null ? val.toString().replace(/(~|\/)/g, function (m) { return {'~':'~~', '/':'~2F'}[m]; }) : val; }
  function valFromString(val) { return val != null ? val.toString().replace(/(~~|~2F)/g, function (m) { return {'~~':'~', '~2F':'/'}[m]; }) : val; }

  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
    "string": {
      encode: valToString,
      decode: valFromString,
      // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
      // In 0.2.x, string params are optional by default for backwards compat
      is: function(val) { return val == null || !isDefined(val) || typeof val === "string"; },
      pattern: /[^/]*/
    },
    "int": {
      encode: valToString,
      decode: function(val) { return parseInt(val, 10); },
      is: function(val) { return val !== undefined && val !== null && this.decode(val.toString()) === val; },
      pattern: /-?\d+/
    },
    "bool": {
      encode: function(val) { return val ? 1 : 0; },
      decode: function(val) { return parseInt(val, 10) !== 0; },
      is: function(val) { return val === true || val === false; },
      pattern: /0|1/
    },
    "date": {
      encode: function (val) {
        if (!this.is(val))
          return undefined;
        return [ val.getFullYear(),
          ('0' + (val.getMonth() + 1)).slice(-2),
          ('0' + val.getDate()).slice(-2)
        ].join("-");
      },
      decode: function (val) {
        if (this.is(val)) return val;
        var match = this.capture.exec(val);
        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
      },
      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
    },
    "json": {
      encode: angular.toJson,
      decode: angular.fromJson,
      is: angular.isObject,
      equals: angular.equals,
      pattern: /[^/]*/
    },
    "any": { // does not encode/decode
      encode: angular.identity,
      decode: angular.identity,
      equals: angular.equals,
      pattern: /.*/
    }
  };

  function getDefaultConfig() {
    return {
      strict: isStrictMode,
      caseInsensitive: isCaseInsensitive
    };
  }

  function isInjectable(value) {
    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
  }

  /**
   * [Internal] Get the default value of a parameter, which may be an injectable function.
   */
  $UrlMatcherFactory.$$getDefaultValue = function(config) {
    if (!isInjectable(config.value)) return config.value;
    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
    return injector.invoke(config.value);
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URL matching should be case sensitive (the default behavior), or not.
   *
   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
   * @returns {boolean} the current value of caseInsensitive
   */
  this.caseInsensitive = function(value) {
    if (isDefined(value))
      isCaseInsensitive = value;
    return isCaseInsensitive;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#strictMode
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Defines whether URLs should match trailing slashes, or not (the default behavior).
   *
   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
   * @returns {boolean} the current value of strictMode
   */
  this.strictMode = function(value) {
    if (isDefined(value))
      isStrictMode = value;
    return isStrictMode;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Sets the default behavior when generating or matching URLs with default parameter values.
   *
   * @param {string} value A string that defines the default parameter URL squashing behavior.
   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
   *             the parameter value from the URL and replace it with this string.
   */
  this.defaultSquashPolicy = function(value) {
    if (!isDefined(value)) return defaultSquashPolicy;
    if (value !== true && value !== false && !isString(value))
      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
    defaultSquashPolicy = value;
    return value;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#compile
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
   *
   * @param {string} pattern  The URL pattern.
   * @param {Object} config  The config object hash.
   * @returns {UrlMatcher}  The UrlMatcher.
   */
  this.compile = function (pattern, config) {
    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#isMatcher
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
   *
   * @param {Object} object  The object to perform the type check against.
   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
   *          implementing all the same methods.
   */
  this.isMatcher = function (o) {
    if (!isObject(o)) return false;
    var result = true;

    forEach(UrlMatcher.prototype, function(val, name) {
      if (isFunction(val)) {
        result = result && (isDefined(o[name]) && isFunction(o[name]));
      }
    });
    return result;
  };

  /**
   * @ngdoc function
   * @name ui.router.util.$urlMatcherFactory#type
   * @methodOf ui.router.util.$urlMatcherFactory
   *
   * @description
   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
   * generate URLs with typed parameters.
   *
   * @param {string} name  The type name.
   * @param {Object|Function} definition   The type definition. See
   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
   *        runtime starts.  The result of this function is merged into the existing `definition`.
   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
   *
   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
   *
   * @example
   * This is a simple example of a custom type that encodes and decodes items from an
   * array, using the array index as the URL-encoded value:
   *
   * <pre>
   * var list = ['John', 'Paul', 'George', 'Ringo'];
   *
   * $urlMatcherFactoryProvider.type('listItem', {
   *   encode: function(item) {
   *     // Represent the list item in the URL using its corresponding index
   *     return list.indexOf(item);
   *   },
   *   decode: function(item) {
   *     // Look up the list item by index
   *     return list[parseInt(item, 10)];
   *   },
   *   is: function(item) {
   *     // Ensure the item is valid by checking to see that it appears
   *     // in the list
   *     return list.indexOf(item) > -1;
   *   }
   * });
   *
   * $stateProvider.state('list', {
   *   url: "/list/{item:listItem}",
   *   controller: function($scope, $stateParams) {
   *     console.log($stateParams.item);
   *   }
   * });
   *
   * // ...
   *
   * // Changes URL to '/list/3', logs "Ringo" to the console
   * $state.go('list', { item: "Ringo" });
   * </pre>
   *
   * This is a more complex example of a type that relies on dependency injection to
   * interact with services, and uses the parameter name from the URL to infer how to
   * handle encoding and decoding parameter values:
   *
   * <pre>
   * // Defines a custom type that gets a value from a service,
   * // where each service gets different types of values from
   * // a backend API:
   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
   *
   *   // Matches up services to URL parameter names
   *   var services = {
   *     user: Users,
   *     post: Posts
   *   };
   *
   *   return {
   *     encode: function(object) {
   *       // Represent the object in the URL using its unique ID
   *       return object.id;
   *     },
   *     decode: function(value, key) {
   *       // Look up the object by ID, using the parameter
   *       // name (key) to call the correct service
   *       return services[key].findById(value);
   *     },
   *     is: function(object, key) {
   *       // Check that object is a valid dbObject
   *       return angular.isObject(object) && object.id && services[key];
   *     }
   *     equals: function(a, b) {
   *       // Check the equality of decoded objects by comparing
   *       // their unique IDs
   *       return a.id === b.id;
   *     }
   *   };
   * });
   *
   * // In a config() block, you can then attach URLs with
   * // type-annotated parameters:
   * $stateProvider.state('users', {
   *   url: "/users",
   *   // ...
   * }).state('users.item', {
   *   url: "/{user:dbObject}",
   *   controller: function($scope, $stateParams) {
   *     // $stateParams.user will now be an object returned from
   *     // the Users service
   *   },
   *   // ...
   * });
   * </pre>
   */
  this.type = function (name, definition, definitionFn) {
    if (!isDefined(definition)) return $types[name];
    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");

    $types[name] = new Type(extend({ name: name }, definition));
    if (definitionFn) {
      typeQueue.push({ name: name, def: definitionFn });
      if (!enqueue) flushTypeQueue();
    }
    return this;
  };

  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
  function flushTypeQueue() {
    while(typeQueue.length) {
      var type = typeQueue.shift();
      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
      angular.extend($types[type.name], injector.invoke(type.def));
    }
  }

  // Register default types. Store them in the prototype of $types.
  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
  $types = inherit($types, {});

  /* No need to document $get, since it returns this */
  this.$get = ['$injector', function ($injector) {
    injector = $injector;
    enqueue = false;
    flushTypeQueue();

    forEach(defaultTypes, function(type, name) {
      if (!$types[name]) $types[name] = new Type(type);
    });
    return this;
  }];

  this.Param = function Param(id, type, config, location) {
    var self = this;
    config = unwrapShorthand(config);
    type = getType(config, type, location);
    var arrayMode = getArrayMode();
    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
    var isOptional = config.value !== undefined;
    var squash = getSquashPolicy(config, isOptional);
    var replace = getReplace(config, arrayMode, isOptional, squash);

    function unwrapShorthand(config) {
      var keys = isObject(config) ? objectKeys(config) : [];
      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
      if (isShorthand) config = { value: config };
      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
      return config;
    }

    function getType(config, urlType, location) {
      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
      if (urlType) return urlType;
      if (!config.type) return (location === "config" ? $types.any : $types.string);

      if (angular.isString(config.type))
        return $types[config.type];
      if (config.type instanceof Type)
        return config.type;
      return new Type(config.type);
    }

    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
    function getArrayMode() {
      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
      return extend(arrayDefaults, arrayParamNomenclature, config).array;
    }

    /**
     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
     */
    function getSquashPolicy(config, isOptional) {
      var squash = config.squash;
      if (!isOptional || squash === false) return false;
      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
      if (squash === true || isString(squash)) return squash;
      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
    }

    function getReplace(config, arrayMode, isOptional, squash) {
      var replace, configuredKeys, defaultPolicy = [
        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
        { from: null, to: (isOptional || arrayMode ? undefined : "") }
      ];
      replace = isArray(config.replace) ? config.replace : [];
      if (isString(squash))
        replace.push({ from: squash, to: undefined });
      configuredKeys = map(replace, function(item) { return item.from; } );
      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
    }

    /**
     * [Internal] Get the default value of a parameter, which may be an injectable function.
     */
    function $$getDefaultValue() {
      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
      var defaultValue = injector.invoke(config.$$fn);
      if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue))
        throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
      return defaultValue;
    }

    /**
     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
     * default value, which may be the result of an injectable function.
     */
    function $value(value) {
      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
      function $replace(value) {
        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
        return replacement.length ? replacement[0] : value;
      }
      value = $replace(value);
      return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
    }

    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }

    extend(this, {
      id: id,
      type: type,
      location: location,
      array: arrayMode,
      squash: squash,
      replace: replace,
      isOptional: isOptional,
      value: $value,
      dynamic: undefined,
      config: config,
      toString: toString
    });
  };

  function ParamSet(params) {
    extend(this, params || {});
  }

  ParamSet.prototype = {
    $$new: function() {
      return inherit(this, extend(new ParamSet(), { $$parent: this}));
    },
    $$keys: function () {
      var keys = [], chain = [], parent = this,
        ignore = objectKeys(ParamSet.prototype);
      while (parent) { chain.push(parent); parent = parent.$$parent; }
      chain.reverse();
      forEach(chain, function(paramset) {
        forEach(objectKeys(paramset), function(key) {
            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
        });
      });
      return keys;
    },
    $$values: function(paramValues) {
      var values = {}, self = this;
      forEach(self.$$keys(), function(key) {
        values[key] = self[key].value(paramValues && paramValues[key]);
      });
      return values;
    },
    $$equals: function(paramValues1, paramValues2) {
      var equal = true, self = this;
      forEach(self.$$keys(), function(key) {
        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
        if (!self[key].type.equals(left, right)) equal = false;
      });
      return equal;
    },
    $$validates: function $$validate(paramValues) {
      var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
      for (i = 0; i < keys.length; i++) {
        param = this[keys[i]];
        rawVal = paramValues[keys[i]];
        if ((rawVal === undefined || rawVal === null) && param.isOptional)
          break; // There was no parameter value, but the param is optional
        normalized = param.type.$normalize(rawVal);
        if (!param.type.is(normalized))
          return false; // The value was not of the correct Type, and could not be decoded to the correct Type
        encoded = param.type.encode(normalized);
        if (angular.isString(encoded) && !param.type.pattern.exec(encoded))
          return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
      }
      return true;
    },
    $$parent: undefined
  };

  this.ParamSet = ParamSet;
}

// Register as a provider so it's available to other providers
angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);

/**
 * @ngdoc object
 * @name ui.router.router.$urlRouterProvider
 *
 * @requires ui.router.util.$urlMatcherFactoryProvider
 * @requires $locationProvider
 *
 * @description
 * `$urlRouterProvider` has the responsibility of watching `$location`. 
 * When `$location` changes it runs through a list of rules one by one until a 
 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
 *
 * There are several methods on `$urlRouterProvider` that make it useful to use directly
 * in your module config.
 */
$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
  var rules = [], otherwise = null, interceptDeferred = false, listener;

  // Returns a string that is a prefix of all strings matching the RegExp
  function regExpPrefix(re) {
    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
  }

  // Interpolates matched values into a String.replace()-style pattern
  function interpolate(pattern, match) {
    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
      return match[what === '$' ? 0 : Number(what)];
    });
  }

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#rule
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines rules that are used by `$urlRouterProvider` to find matches for
   * specific URLs.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // Here's an example of how you might allow case insensitive urls
   *   $urlRouterProvider.rule(function ($injector, $location) {
   *     var path = $location.path(),
   *         normalized = path.toLowerCase();
   *
   *     if (path !== normalized) {
   *       return normalized;
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {function} rule Handler function that takes `$injector` and `$location`
   * services as arguments. You can use them to return a valid path as a string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */
  this.rule = function (rule) {
    if (!isFunction(rule)) throw new Error("'rule' must be a function");
    rules.push(rule);
    return this;
  };

  /**
   * @ngdoc object
   * @name ui.router.router.$urlRouterProvider#otherwise
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Defines a path that is used when an invalid route is requested.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   // if the path doesn't match any of the urls you configured
   *   // otherwise will take care of routing the user to the
   *   // specified url
   *   $urlRouterProvider.otherwise('/index');
   *
   *   // Example of using function rule as param
   *   $urlRouterProvider.otherwise(function ($injector, $location) {
   *     return '/a/valid/url';
   *   });
   * });
   * </pre>
   *
   * @param {string|function} rule The url path you want to redirect to or a function 
   * rule that returns the url path. The function version is passed two params: 
   * `$injector` and `$location` services, and must return a url string.
   *
   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
   */
  this.otherwise = function (rule) {
    if (isString(rule)) {
      var redirect = rule;
      rule = function () { return redirect; };
    }
    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
    otherwise = rule;
    return this;
  };


  function handleIfMatch($injector, handler, match) {
    if (!match) return false;
    var result = $injector.invoke(handler, handler, { $match: match });
    return isDefined(result) ? result : true;
  }

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#when
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Registers a handler for a given url matching. 
   * 
   * If the handler is a string, it is
   * treated as a redirect, and is interpolated according to the syntax of match
   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
   *
   * If the handler is a function, it is injectable. It gets invoked if `$location`
   * matches. You have the option of inject the match object as `$match`.
   *
   * The handler can return
   *
   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
   *   will continue trying to find another one that matches.
   * - **string** which is treated as a redirect and passed to `$location.url()`
   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
   *     if ($state.$current.navigable !== state ||
   *         !equalForKeys($match, $stateParams) {
   *      $state.transitionTo(state, $match, false);
   *     }
   *   });
   * });
   * </pre>
   *
   * @param {string|object} what The incoming path that you want to redirect.
   * @param {string|function} handler The path you want to redirect your user to.
   */
  this.when = function (what, handler) {
    var redirect, handlerIsString = isString(handler);
    if (isString(what)) what = $urlMatcherFactory.compile(what);

    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
      throw new Error("invalid 'handler' in when()");

    var strategies = {
      matcher: function (what, handler) {
        if (handlerIsString) {
          redirect = $urlMatcherFactory.compile(handler);
          handler = ['$match', function ($match) { return redirect.format($match); }];
        }
        return extend(function ($injector, $location) {
          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
        }, {
          prefix: isString(what.prefix) ? what.prefix : ''
        });
      },
      regex: function (what, handler) {
        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");

        if (handlerIsString) {
          redirect = handler;
          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
        }
        return extend(function ($injector, $location) {
          return handleIfMatch($injector, handler, what.exec($location.path()));
        }, {
          prefix: regExpPrefix(what)
        });
      }
    };

    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };

    for (var n in check) {
      if (check[n]) return this.rule(strategies[n](what, handler));
    }

    throw new Error("invalid 'what' in when()");
  };

  /**
   * @ngdoc function
   * @name ui.router.router.$urlRouterProvider#deferIntercept
   * @methodOf ui.router.router.$urlRouterProvider
   *
   * @description
   * Disables (or enables) deferring location change interception.
   *
   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
   * defer a transition but maintain the current URL), call this method at configuration time.
   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
   * `$locationChangeSuccess` event handler.
   *
   * @example
   * <pre>
   * var app = angular.module('app', ['ui.router.router']);
   *
   * app.config(function ($urlRouterProvider) {
   *
   *   // Prevent $urlRouter from automatically intercepting URL changes;
   *   // this allows you to configure custom behavior in between
   *   // location changes and route synchronization:
   *   $urlRouterProvider.deferIntercept();
   *
   * }).run(function ($rootScope, $urlRouter, UserService) {
   *
   *   $rootScope.$on('$locationChangeSuccess', function(e) {
   *     // UserService is an example service for managing user state
   *     if (UserService.isLoggedIn()) return;
   *
   *     // Prevent $urlRouter's default handler from firing
   *     e.preventDefault();
   *
   *     UserService.handleLogin().then(function() {
   *       // Once the user has logged in, sync the current URL
   *       // to the router:
   *       $urlRouter.sync();
   *     });
   *   });
   *
   *   // Configures $urlRouter's listener *after* your custom listener
   *   $urlRouter.listen();
   * });
   * </pre>
   *
   * @param {boolean} defer Indicates whether to defer location change interception. Passing
            no parameter is equivalent to `true`.
   */
  this.deferIntercept = function (defer) {
    if (defer === undefined) defer = true;
    interceptDeferred = defer;
  };

  /**
   * @ngdoc object
   * @name ui.router.router.$urlRouter
   *
   * @requires $location
   * @requires $rootScope
   * @requires $injector
   * @requires $browser
   *
   * @description
   *
   */
  this.$get = $get;
  $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
  function $get(   $location,   $rootScope,   $injector,   $browser,   $sniffer) {

    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;

    function appendBasePath(url, isHtml5, absolute) {
      if (baseHref === '/') return url;
      if (isHtml5) return baseHref.slice(0, -1) + url;
      if (absolute) return baseHref.slice(1) + url;
      return url;
    }

    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
    function update(evt) {
      if (evt && evt.defaultPrevented) return;
      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
      lastPushedUrl = undefined;
      // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
      //if (ignoreUpdate) return true;

      function check(rule) {
        var handled = rule($injector, $location);

        if (!handled) return false;
        if (isString(handled)) $location.replace().url(handled);
        return true;
      }
      var n = rules.length, i;

      for (i = 0; i < n; i++) {
        if (check(rules[i])) return;
      }
      // always check otherwise last to allow dynamic updates to the set of rules
      if (otherwise) check(otherwise);
    }

    function listen() {
      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
      return listener;
    }

    if (!interceptDeferred) listen();

    return {
      /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#sync
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
       * with the transition by calling `$urlRouter.sync()`.
       *
       * @example
       * <pre>
       * angular.module('app', ['ui.router'])
       *   .run(function($rootScope, $urlRouter) {
       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
       *       // Halt state change from even starting
       *       evt.preventDefault();
       *       // Perform custom logic
       *       var meetsRequirement = ...
       *       // Continue with the update and state transition if logic allows
       *       if (meetsRequirement) $urlRouter.sync();
       *     });
       * });
       * </pre>
       */
      sync: function() {
        update();
      },

      listen: function() {
        return listen();
      },

      update: function(read) {
        if (read) {
          location = $location.url();
          return;
        }
        if ($location.url() === location) return;

        $location.url(location);
        $location.replace();
      },

      push: function(urlMatcher, params, options) {
         var url = urlMatcher.format(params || {});

        // Handle the special hash param, if needed
        if (url !== null && params && params['#']) {
            url += '#' + params['#'];
        }

        $location.url(url);
        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
        if (options && options.replace) $location.replace();
      },

      /**
       * @ngdoc function
       * @name ui.router.router.$urlRouter#href
       * @methodOf ui.router.router.$urlRouter
       *
       * @description
       * A URL generation method that returns the compiled URL for a given
       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
       *
       * @example
       * <pre>
       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
       *   person: "bob"
       * });
       * // $bob == "/about/bob";
       * </pre>
       *
       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
       * @param {object=} options Options object. The options are:
       *
       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
       *
       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
       */
      href: function(urlMatcher, params, options) {
        if (!urlMatcher.validates(params)) return null;

        var isHtml5 = $locationProvider.html5Mode();
        if (angular.isObject(isHtml5)) {
          isHtml5 = isHtml5.enabled;
        }

        isHtml5 = isHtml5 && $sniffer.history;
        
        var url = urlMatcher.format(params);
        options = options || {};

        if (!isHtml5 && url !== null) {
          url = "#" + $locationProvider.hashPrefix() + url;
        }

        // Handle special hash param, if needed
        if (url !== null && params && params['#']) {
          url += '#' + params['#'];
        }

        url = appendBasePath(url, isHtml5, options.absolute);

        if (!options.absolute || !url) {
          return url;
        }

        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
        port = (port === 80 || port === 443 ? '' : ':' + port);

        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
      }
    };
  }
}

angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);

/**
 * @ngdoc object
 * @name ui.router.state.$stateProvider
 *
 * @requires ui.router.router.$urlRouterProvider
 * @requires ui.router.util.$urlMatcherFactoryProvider
 *
 * @description
 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
 * on state.
 *
 * A state corresponds to a "place" in the application in terms of the overall UI and
 * navigation. A state describes (via the controller / template / view properties) what
 * the UI looks like and does at that place.
 *
 * States often have things in common, and the primary way of factoring out these
 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
 * nested states.
 *
 * The `$stateProvider` provides interfaces to declare these states for your app.
 */
$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {

  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';

  // Builds state properties from definition passed to registerState()
  var stateBuilder = {

    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
    // state.children = [];
    // if (parent) parent.children.push(state);
    parent: function(state) {
      if (isDefined(state.parent) && state.parent) return findState(state.parent);
      // regex matches any valid composite state name
      // would match "contact.list" but not "contacts"
      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
      return compositeName ? findState(compositeName[1]) : root;
    },

    // inherit 'data' from parent and override by own values (if any)
    data: function(state) {
      if (state.parent && state.parent.data) {
        state.data = state.self.data = inherit(state.parent.data, state.data);
      }
      return state.data;
    },

    // Build a URLMatcher if necessary, either via a relative or absolute URL
    url: function(state) {
      var url = state.url, config = { params: state.params || {} };

      if (isString(url)) {
        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
        return (state.parent.navigable || root).url.concat(url, config);
      }

      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
    },

    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
    navigable: function(state) {
      return state.url ? state : (state.parent ? state.parent.navigable : null);
    },

    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
    ownParams: function(state) {
      var params = state.url && state.url.params || new $$UMFP.ParamSet();
      forEach(state.params || {}, function(config, id) {
        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
      });
      return params;
    },

    // Derive parameters for this state and ensure they're a super-set of parent's parameters
    params: function(state) {
      var ownParams = pick(state.ownParams, state.ownParams.$$keys());
      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
    },

    // If there is no explicit multi-view configuration, make one up so we don't have
    // to handle both cases in the view directive later. Note that having an explicit
    // 'views' property will mean the default unnamed view properties are ignored. This
    // is also a good time to resolve view names to absolute names, so everything is a
    // straight lookup at link time.
    views: function(state) {
      var views = {};

      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
        view.resolveAs = view.resolveAs || state.resolveAs || '$resolve';
        views[name] = view;
      });
      return views;
    },

    // Keep a full path from the root down to this state as this is needed for state activation.
    path: function(state) {
      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
    },

    // Speed up $state.contains() as it's used a lot
    includes: function(state) {
      var includes = state.parent ? extend({}, state.parent.includes) : {};
      includes[state.name] = true;
      return includes;
    },

    $delegates: {}
  };

  function isRelative(stateName) {
    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
  }

  function findState(stateOrName, base) {
    if (!stateOrName) return undefined;

    var isStr = isString(stateOrName),
        name  = isStr ? stateOrName : stateOrName.name,
        path  = isRelative(name);

    if (path) {
      if (!base) throw new Error("No reference point given for path '"  + name + "'");
      base = findState(base);
      
      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;

      for (; i < pathLength; i++) {
        if (rel[i] === "" && i === 0) {
          current = base;
          continue;
        }
        if (rel[i] === "^") {
          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
          current = current.parent;
          continue;
        }
        break;
      }
      rel = rel.slice(i).join(".");
      name = current.name + (current.name && rel ? "." : "") + rel;
    }
    var state = states[name];

    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
      return state;
    }
    return undefined;
  }

  function queueState(parentName, state) {
    if (!queue[parentName]) {
      queue[parentName] = [];
    }
    queue[parentName].push(state);
  }

  function flushQueuedChildren(parentName) {
    var queued = queue[parentName] || [];
    while(queued.length) {
      registerState(queued.shift());
    }
  }

  function registerState(state) {
    // Wrap a new object around the state so we can store our private details easily.
    state = inherit(state, {
      self: state,
      resolve: state.resolve || {},
      toString: function() { return this.name; }
    });

    var name = state.name;
    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");

    // Get parent name
    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
        : (isString(state.parent)) ? state.parent
        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
        : '';

    // If parent is not registered yet, add state to queue and register later
    if (parentName && !states[parentName]) {
      return queueState(parentName, state.self);
    }

    for (var key in stateBuilder) {
      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
    }
    states[name] = state;

    // Register the state in the global state list and with $urlRouter if necessary.
    if (!state[abstractKey] && state.url) {
      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
          $state.transitionTo(state, $match, { inherit: true, location: false });
        }
      }]);
    }

    // Register any queued children
    flushQueuedChildren(name);

    return state;
  }

  // Checks text to see if it looks like a glob.
  function isGlob (text) {
    return text.indexOf('*') > -1;
  }

  // Returns true if glob matches current $state name.
  function doesStateMatchGlob (glob) {
    var globSegments = glob.split('.'),
        segments = $state.$current.name.split('.');

    //match single stars
    for (var i = 0, l = globSegments.length; i < l; i++) {
      if (globSegments[i] === '*') {
        segments[i] = '*';
      }
    }

    //match greedy starts
    if (globSegments[0] === '**') {
       segments = segments.slice(indexOf(segments, globSegments[1]));
       segments.unshift('**');
    }
    //match greedy ends
    if (globSegments[globSegments.length - 1] === '**') {
       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
       segments.push('**');
    }

    if (globSegments.length != segments.length) {
      return false;
    }

    return segments.join('') === globSegments.join('');
  }


  // Implicit root state that is always active
  root = registerState({
    name: '',
    url: '^',
    views: null,
    'abstract': true
  });
  root.navigable = null;


  /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#decorator
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Allows you to extend (carefully) or override (at your own peril) the 
   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
   * to add custom functionality to ui-router, for example inferring templateUrl 
   * based on the state name.
   *
   * When passing only a name, it returns the current (original or decorated) builder
   * function that matches `name`.
   *
   * The builder functions that can be decorated are listed below. Though not all
   * necessarily have a good use case for decoration, that is up to you to decide.
   *
   * In addition, users can attach custom decorators, which will generate new 
   * properties within the state's internal definition. There is currently no clear 
   * use-case for this beyond accessing internal states (i.e. $state.$current), 
   * however, expect this to become increasingly relevant as we introduce additional 
   * meta-programming features.
   *
   * **Warning**: Decorators should not be interdependent because the order of 
   * execution of the builder functions in non-deterministic. Builder functions 
   * should only be dependent on the state definition object and super function.
   *
   *
   * Existing builder functions and current return values:
   *
   * - **parent** `{object}` - returns the parent state object.
   * - **data** `{object}` - returns state data, including any inherited data that is not
   *   overridden by own values (if any).
   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
   *   or `null`.
   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
   *   navigable).
   * - **params** `{object}` - returns an array of state params that are ensured to 
   *   be a super-set of parent's params.
   * - **views** `{object}` - returns a views object where each key is an absolute view 
   *   name (i.e. "viewName@stateName") and each value is the config object 
   *   (template, controller) for the view. Even when you don't use the views object 
   *   explicitly on a state config, one is still created for you internally.
   *   So by decorating this builder function you have access to decorating template 
   *   and controller properties.
   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
   *   not including any params defined by ancestor states.
   * - **path** `{string}` - returns the full path from the root down to this state. 
   *   Needed for state activation.
   * - **includes** `{object}` - returns an object that includes every state that 
   *   would pass a `$state.includes()` test.
   *
   * @example
   * <pre>
   * // Override the internal 'views' builder with a function that takes the state
   * // definition, and a reference to the internal function being overridden:
   * $stateProvider.decorator('views', function (state, parent) {
   *   var result = {},
   *       views = parent(state);
   *
   *   angular.forEach(views, function (config, name) {
   *     var autoName = (state.name + '.' + name).replace('.', '/');
   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
   *     result[name] = config;
   *   });
   *   return result;
   * });
   *
   * $stateProvider.state('home', {
   *   views: {
   *     'contact.list': { controller: 'ListController' },
   *     'contact.item': { controller: 'ItemController' }
   *   }
   * });
   *
   * // ...
   *
   * $state.go('home');
   * // Auto-populates list and item views with /partials/home/contact/list.html,
   * // and /partials/home/contact/item.html, respectively.
   * </pre>
   *
   * @param {string} name The name of the builder function to decorate. 
   * @param {object} func A function that is responsible for decorating the original 
   * builder function. The function receives two parameters:
   *
   *   - `{object}` - state - The state config object.
   *   - `{object}` - super - The original builder function.
   *
   * @return {object} $stateProvider - $stateProvider instance
   */
  this.decorator = decorator;
  function decorator(name, func) {
    /*jshint validthis: true */
    if (isString(name) && !isDefined(func)) {
      return stateBuilder[name];
    }
    if (!isFunction(func) || !isString(name)) {
      return this;
    }
    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
      stateBuilder.$delegates[name] = stateBuilder[name];
    }
    stateBuilder[name] = func;
    return this;
  }

  /**
   * @ngdoc function
   * @name ui.router.state.$stateProvider#state
   * @methodOf ui.router.state.$stateProvider
   *
   * @description
   * Registers a state configuration under a given state name. The stateConfig object
   * has the following acceptable properties.
   *
   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
   * @param {object} stateConfig State configuration object.
   * @param {string|function=} stateConfig.template
   * <a id='template'></a>
   *   html template as a string or a function that returns
   *   an html template as a string which should be used by the uiView directives. This property 
   *   takes precedence over templateUrl.
   *   
   *   If `template` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
   *     applying the current state
   *
   * <pre>template:
   *   "<h1>inline template definition</h1>" +
   *   "<div ui-view></div>"</pre>
   * <pre>template: function(params) {
   *       return "<h1>generated template</h1>"; }</pre>
   * </div>
   *
   * @param {string|function=} stateConfig.templateUrl
   * <a id='templateUrl'></a>
   *
   *   path or function that returns a path to an html
   *   template that should be used by uiView.
   *   
   *   If `templateUrl` is a function, it will be called with the following parameters:
   *
   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
   *     applying the current state
   *
   * <pre>templateUrl: "home.html"</pre>
   * <pre>templateUrl: function(params) {
   *     return myTemplates[params.pageId]; }</pre>
   *
   * @param {function=} stateConfig.templateProvider
   * <a id='templateProvider'></a>
   *    Provider function that returns HTML content string.
   * <pre> templateProvider:
   *       function(MyTemplateService, params) {
   *         return MyTemplateService.getTemplate(params.pageId);
   *       }</pre>
   *
   * @param {string|function=} stateConfig.controller
   * <a id='controller'></a>
   *
   *  Controller fn that should be associated with newly
   *   related scope or the name of a registered controller if passed as a string.
   *   Optionally, the ControllerAs may be declared here.
   * <pre>controller: "MyRegisteredController"</pre>
   * <pre>controller:
   *     "MyRegisteredController as fooCtrl"}</pre>
   * <pre>controller: function($scope, MyService) {
   *     $scope.data = MyService.getData(); }</pre>
   *
   * @param {function=} stateConfig.controllerProvider
   * <a id='controllerProvider'></a>
   *
   * Injectable provider function that returns the actual controller or string.
   * <pre>controllerProvider:
   *   function(MyResolveData) {
   *     if (MyResolveData.foo)
   *       return "FooCtrl"
   *     else if (MyResolveData.bar)
   *       return "BarCtrl";
   *     else return function($scope) {
   *       $scope.baz = "Qux";
   *     }
   *   }</pre>
   *
   * @param {string=} stateConfig.controllerAs
   * <a id='controllerAs'></a>
   * 
   * A controller alias name. If present the controller will be
   *   published to scope under the controllerAs name.
   * <pre>controllerAs: "myCtrl"</pre>
   *
   * @param {string|object=} stateConfig.parent
   * <a id='parent'></a>
   * Optionally specifies the parent state of this state.
   *
   * <pre>parent: 'parentState'</pre>
   * <pre>parent: parentState // JS variable</pre>
   *
   * @param {object=} stateConfig.resolve
   * <a id='resolve'></a>
   *
   * An optional map&lt;string, function&gt; of dependencies which
   *   should be injected into the controller. If any of these dependencies are promises, 
   *   the router will wait for them all to be resolved before the controller is instantiated.
   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
   *   and the values of the resolved promises are injected into any controllers that reference them.
   *   If any  of the promises are rejected the $stateChangeError event is fired.
   *
   *   The map object is:
   *   
   *   - key - {string}: name of dependency to be injected into controller
   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
   *     it is injected and return value it treated as dependency. If result is a promise, it is 
   *     resolved before its value is injected into controller.
   *
   * <pre>resolve: {
   *     myResolve1:
   *       function($http, $stateParams) {
   *         return $http.get("/api/foos/"+stateParams.fooID);
   *       }
   *     }</pre>
   *
   * @param {string=} stateConfig.url
   * <a id='url'></a>
   *
   *   A url fragment with optional parameters. When a state is navigated or
   *   transitioned to, the `$stateParams` service will be populated with any 
   *   parameters that were passed.
   *
   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
   *   more details on acceptable patterns )
   *
   * examples:
   * <pre>url: "/home"
   * url: "/users/:userid"
   * url: "/books/{bookid:[a-zA-Z_-]}"
   * url: "/books/{categoryid:int}"
   * url: "/books/{publishername:string}/{categoryid:int}"
   * url: "/messages?before&after"
   * url: "/messages?{before:date}&{after:date}"
   * url: "/messages/:mailboxid?{before:date}&{after:date}"
   * </pre>
   *
   * @param {object=} stateConfig.views
   * <a id='views'></a>
   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
   * manually/explicitly.
   *
   * Examples:
   *
   * Targets three named `ui-view`s in the parent state's template
   * <pre>views: {
   *     header: {
   *       controller: "headerCtrl",
   *       templateUrl: "header.html"
   *     }, body: {
   *       controller: "bodyCtrl",
   *       templateUrl: "body.html"
   *     }, footer: {
   *       controller: "footCtrl",
   *       templateUrl: "footer.html"
   *     }
   *   }</pre>
   *
   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
   * <pre>views: {
   *     'header@top': {
   *       controller: "msgHeaderCtrl",
   *       templateUrl: "msgHeader.html"
   *     }, 'body': {
   *       controller: "messagesCtrl",
   *       templateUrl: "messages.html"
   *     }
   *   }</pre>
   *
   * @param {boolean=} [stateConfig.abstract=false]
   * <a id='abstract'></a>
   * An abstract state will never be directly activated,
   *   but can provide inherited properties to its common children states.
   * <pre>abstract: true</pre>
   *
   * @param {function=} stateConfig.onEnter
   * <a id='onEnter'></a>
   *
   * Callback function for when a state is entered. Good way
   *   to trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onEnter: function(MyService, $stateParams) {
   *     MyService.foo($stateParams.myParam);
   * }</pre>
   *
   * @param {function=} stateConfig.onExit
   * <a id='onExit'></a>
   *
   * Callback function for when a state is exited. Good way to
   *   trigger an action or dispatch an event, such as opening a dialog.
   * If minifying your scripts, make sure to explicitly annotate this function,
   * because it won't be automatically annotated by your build tools.
   *
   * <pre>onExit: function(MyService, $stateParams) {
   *     MyService.cleanup($stateParams.myParam);
   * }</pre>
   *
   * @param {boolean=} [stateConfig.reloadOnSearch=true]
   * <a id='reloadOnSearch'></a>
   *
   * If `false`, will not retrigger the same state
   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
   *   Useful for when you'd like to modify $location.search() without triggering a reload.
   * <pre>reloadOnSearch: false</pre>
   *
   * @param {object=} stateConfig.data
   * <a id='data'></a>
   *
   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
   *   prototypally inherited.  In other words, adding a data property to a state adds it to
   *   the entire subtree via prototypal inheritance.
   *
   * <pre>data: {
   *     requiredRole: 'foo'
   * } </pre>
   *
   * @param {object=} stateConfig.params
   * <a id='params'></a>
   *
   * A map which optionally configures parameters declared in the `url`, or
   *   defines additional non-url parameters.  For each parameter being
   *   configured, add a configuration object keyed to the name of the parameter.
   *
   *   Each parameter configuration object may contain the following properties:
   *
   *   - ** value ** - {object|function=}: specifies the default value for this
   *     parameter.  This implicitly sets this parameter as optional.
   *
   *     When UI-Router routes to a state and no value is
   *     specified for this parameter in the URL or transition, the
   *     default value will be used instead.  If `value` is a function,
   *     it will be injected and invoked, and the return value used.
   *
   *     *Note*: `undefined` is treated as "no default value" while `null`
   *     is treated as "the default value is `null`".
   *
   *     *Shorthand*: If you only need to configure the default value of the
   *     parameter, you may use a shorthand syntax.   In the **`params`**
   *     map, instead mapping the param name to a full parameter configuration
   *     object, simply set map it to the default parameter value, e.g.:
   *
   * <pre>// define a parameter's default value
   * params: {
   *     param1: { value: "defaultValue" }
   * }
   * // shorthand default values
   * params: {
   *     param1: "defaultValue",
   *     param2: "param2Default"
   * }</pre>
   *
   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
   *     treated as an array of values.  If you specified a Type, the value will be
   *     treated as an array of the specified Type.  Note: query parameter values
   *     default to a special `"auto"` mode.
   *
   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
   *     value (e.g.: `{ foo: '1' }`).
   *
   * <pre>params: {
   *     param1: { array: true }
   * }</pre>
   *
   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
   *     configured default squash policy.
   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
   *
   *   There are three squash settings:
   *
   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
   *       This can allow for cleaner looking URLs.
   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
   *
   * <pre>params: {
   *     param1: {
   *       value: "defaultId",
   *       squash: true
   * } }
   * // squash "defaultValue" to "~"
   * params: {
   *     param1: {
   *       value: "defaultValue",
   *       squash: "~"
   * } }
   * </pre>
   *
   *
   * @example
   * <pre>
   * // Some state name examples
   *
   * // stateName can be a single top-level name (must be unique).
   * $stateProvider.state("home", {});
   *
   * // Or it can be a nested state name. This state is a child of the
   * // above "home" state.
   * $stateProvider.state("home.newest", {});
   *
   * // Nest states as deeply as needed.
   * $stateProvider.state("home.newest.abc.xyz.inception", {});
   *
   * // state() returns $stateProvider, so you can chain state declarations.
   * $stateProvider
   *   .state("home", {})
   *   .state("about", {})
   *   .state("contacts", {});
   * </pre>
   *
   */
  this.state = state;
  function state(name, definition) {
    /*jshint validthis: true */
    if (isObject(name)) definition = name;
    else definition.name = name;
    registerState(definition);
    return this;
  }

  /**
   * @ngdoc object
   * @name ui.router.state.$state
   *
   * @requires $rootScope
   * @requires $q
   * @requires ui.router.state.$view
   * @requires $injector
   * @requires ui.router.util.$resolve
   * @requires ui.router.state.$stateParams
   * @requires ui.router.router.$urlRouter
   *
   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
   * you'd like to test against the current active state.
   * @property {object} current A reference to the state's config object. However 
   * you passed it in. Useful for accessing custom data.
   * @property {object} transition Currently pending transition. A promise that'll 
   * resolve or reject.
   *
   * @description
   * `$state` service is responsible for representing states as well as transitioning
   * between them. It also provides interfaces to ask for current state or even states
   * you're coming from.
   */
  this.$get = $get;
  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {

    var TransitionSupersededError = new Error('transition superseded');

    var TransitionSuperseded = silenceUncaughtInPromise($q.reject(TransitionSupersededError));
    var TransitionPrevented = silenceUncaughtInPromise($q.reject(new Error('transition prevented')));
    var TransitionAborted = silenceUncaughtInPromise($q.reject(new Error('transition aborted')));
    var TransitionFailed = silenceUncaughtInPromise($q.reject(new Error('transition failed')));

    // Handles the case where a state which is the target of a transition is not found, and the user
    // can optionally retry or defer the transition
    function handleRedirect(redirect, state, params, options) {
      /**
       * @ngdoc event
       * @name ui.router.state.$state#$stateNotFound
       * @eventOf ui.router.state.$state
       * @eventType broadcast on root scope
       * @description
       * Fired when a requested state **cannot be found** using the provided state name during transition.
       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
       *
       * @param {Object} event Event object.
       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
       * @param {State} fromState Current state object.
       * @param {Object} fromParams Current state params.
       *
       * @example
       *
       * <pre>
       * // somewhere, assume lazy.state has not been defined
       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
       *
       * // somewhere else
       * $scope.$on('$stateNotFound',
       * function(event, unfoundState, fromState, fromParams){
       *     console.log(unfoundState.to); // "lazy.state"
       *     console.log(unfoundState.toParams); // {a:1, b:2}
       *     console.log(unfoundState.options); // {inherit:false} + default options
       * })
       * </pre>
       */
      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);

      if (evt.defaultPrevented) {
        $urlRouter.update();
        return TransitionAborted;
      }

      if (!evt.retry) {
        return null;
      }

      // Allow the handler to return a promise to defer state lookup retry
      if (options.$retry) {
        $urlRouter.update();
        return TransitionFailed;
      }
      var retryTransition = $state.transition = $q.when(evt.retry);

      retryTransition.then(function() {
        if (retryTransition !== $state.transition) {
          $rootScope.$broadcast('$stateChangeCancel', redirect.to, redirect.toParams, state, params);
          return TransitionSuperseded;
        }
        redirect.options.$retry = true;
        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
      }, function() {
        return TransitionAborted;
      });
      $urlRouter.update();

      return retryTransition;
    }

    root.locals = { resolve: null, globals: { $stateParams: {} } };

    $state = {
      params: {},
      current: root.self,
      $current: root,
      transition: null
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#reload
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method that force reloads the current state. All resolves are re-resolved,
     * controllers reinstantiated, and events re-fired.
     *
     * @example
     * <pre>
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     $state.reload();
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>
     *
     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
     * @example
     * <pre>
     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
     * //and current state is 'contacts.detail.item'
     * var app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     //will reload 'contact.detail' and 'contact.detail.item' states
     *     $state.reload('contact.detail');
     *   }
     * });
     * </pre>
     *
     * `reload()` is just an alias for:
     * <pre>
     * $state.transitionTo($state.current, $stateParams, { 
     *   reload: true, inherit: false, notify: true
     * });
     * </pre>

     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */
    $state.reload = function reload(state) {
      return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true});
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#go
     * @methodOf ui.router.state.$state
     *
     * @description
     * Convenience method for transitioning to a new state. `$state.go` calls 
     * `$state.transitionTo` internally but automatically sets options to 
     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
     * This allows you to easily use an absolute or relative to path and specify 
     * only the parameters you'd like to update (while letting unspecified parameters 
     * inherit from the currently active ancestor states).
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.go('contact.detail');
     *   };
     * });
     * </pre>
     * <img src='../ngdoc_assets/StateGoExamples.png'/>
     *
     * @param {string} to Absolute state name or relative state path. Some examples:
     *
     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
     * - `$state.go('^')` - will go to a parent state
     * - `$state.go('^.sibling')` - will go to a sibling state
     * - `$state.go('.child.grandchild')` - will go to grandchild state
     *
     * @param {object=} params A map of the parameters that will be sent to the state, 
     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
     * defined parameters. Only parameters specified in the state definition can be overridden, new 
     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
     * will get you all current parameters, etc.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
     *    have changed.  It will reload the resolves and views of the current state and parent states.
     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
     *    the transition reloads the resolves and views for that matched state, and all its children states.
     *
     * @returns {promise} A promise representing the state of the new transition.
     *
     * Possible success values:
     *
     * - $state.current
     *
     * <br/>Possible rejection values:
     *
     * - 'transition superseded' - when a newer transition has been started after this one
     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
     *   when a `$stateNotFound` `event.retry` promise errors.
     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
     * - *resolve error* - when an error has occurred with a `resolve`
     *
     */
    $state.go = function go(to, params, options) {
      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#transitionTo
     * @methodOf ui.router.state.$state
     *
     * @description
     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
     *
     * @example
     * <pre>
     * var app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.transitionTo('contact.detail');
     *   };
     * });
     * </pre>
     *
     * @param {string} to State name.
     * @param {object=} toParams A map of the parameters that will be sent to the state,
     * will populate $stateParams.
     * @param {object=} options Options object. The options are:
     *
     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
     *    use this when you want to force a reload when *everything* is the same, including search params.
     *    if String, then will reload the state with the name given in reload, and any children.
     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
     *
     * @returns {promise} A promise representing the state of the new transition. See
     * {@link ui.router.state.$state#methods_go $state.go}.
     */
    $state.transitionTo = function transitionTo(to, toParams, options) {
      toParams = toParams || {};
      options = extend({
        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
      }, options || {});

      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
      var evt, toState = findState(to, options.relative);

      // Store the hash param for later (since it will be stripped out by various methods)
      var hash = toParams['#'];

      if (!isDefined(toState)) {
        var redirect = { to: to, toParams: toParams, options: options };
        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);

        if (redirectResult) {
          return redirectResult;
        }

        // Always retry once if the $stateNotFound was not prevented
        // (handles either redirect changed or state lazy-definition)
        to = redirect.to;
        toParams = redirect.toParams;
        options = redirect.options;
        toState = findState(to, options.relative);

        if (!isDefined(toState)) {
          if (!options.relative) throw new Error("No such state '" + to + "'");
          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
        }
      }
      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
      if (!toState.params.$$validates(toParams)) return TransitionFailed;

      toParams = toState.params.$$values(toParams);
      to = toState;

      var toPath = to.path;

      // Starting from the root of the path, keep all levels that haven't changed
      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];

      if (!options.reload) {
        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      } else if (isString(options.reload) || isObject(options.reload)) {
        if (isObject(options.reload) && !options.reload.name) {
          throw new Error('Invalid reload state object');
        }
        
        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
        if (options.reload && !reloadState) {
          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
        }

        while (state && state === fromPath[keep] && state !== reloadState) {
          locals = toLocals[keep] = state.locals;
          keep++;
          state = toPath[keep];
        }
      }

      // If we're going to the same state and all locals are kept, we've got nothing to do.
      // But clear 'transition', as we still want to cancel any other pending transitions.
      // TODO: We may not want to bump 'transition' if we're called from a location change
      // that we've initiated ourselves, because we might accidentally abort a legitimate
      // transition initiated from code?
      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
        if (hash) toParams['#'] = hash;
        $state.params = toParams;
        copy($state.params, $stateParams);
        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
        if (options.location && to.navigable && to.navigable.url) {
          $urlRouter.push(to.navigable.url, toParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
          $urlRouter.update(true);
        }
        $state.transition = null;
        return $q.when($state.current);
      }

      // Filter parameters before we pass them to event handlers etc.
      toParams = filterByKeys(to.params.$$keys(), toParams || {});
      
      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
      if (hash) toParams['#'] = hash;
      
      // Broadcast start event and cancel the transition if requested
      if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeStart
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when the state transition **begins**. You can use `event.preventDefault()`
         * to prevent the transition from happening and then the transition promise will be
         * rejected with a `'transition prevented'` value.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         *
         * @example
         *
         * <pre>
         * $rootScope.$on('$stateChangeStart',
         * function(event, toState, toParams, fromState, fromParams){
         *     event.preventDefault();
         *     // transitionTo() promise will be rejected with
         *     // a 'transition prevented' error
         * })
         * </pre>
         */
        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
          if ($state.transition == null) $urlRouter.update();
          return TransitionPrevented;
        }
      }

      // Resolve locals for the remaining states, but don't update any global state just
      // yet -- if anything fails to resolve the current state needs to remain untouched.
      // We also set up an inheritance chain for the locals here. This allows the view directive
      // to quickly look up the correct definition for each view in the current state. Even
      // though we create the locals object itself outside resolveState(), it is initially
      // empty and gets filled asynchronously. We need to keep track of the promise for the
      // (fully resolved) current locals, and pass this down the chain.
      var resolved = $q.when(locals);

      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
        locals = toLocals[l] = inherit(locals);
        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
      }

      // Once everything is resolved, we are ready to perform the actual transition
      // and return a promise for the new state. We also keep track of what the
      // current promise is, so that we can detect overlapping transitions and
      // keep only the outcome of the last transition.
      var transition = $state.transition = resolved.then(function () {
        var l, entering, exiting;

        if ($state.transition !== transition) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          return TransitionSuperseded;
        }

        // Exit 'from' states not kept
        for (l = fromPath.length - 1; l >= keep; l--) {
          exiting = fromPath[l];
          if (exiting.self.onExit) {
            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
          }
          exiting.locals = null;
        }

        // Enter 'to' states not kept
        for (l = keep; l < toPath.length; l++) {
          entering = toPath[l];
          entering.locals = toLocals[l];
          if (entering.self.onEnter) {
            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
          }
        }

        // Run it again, to catch any transitions in callbacks
        if ($state.transition !== transition) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          return TransitionSuperseded;
        }

        // Update globals in $state
        $state.$current = to;
        $state.current = to.self;
        $state.params = toParams;
        copy($state.params, $stateParams);
        $state.transition = null;

        if (options.location && to.navigable) {
          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
            $$avoidResync: true, replace: options.location === 'replace'
          });
        }

        if (options.notify) {
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeSuccess
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired once the state transition is **complete**.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         */
          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
        }
        $urlRouter.update(true);

        return $state.current;
      }).then(null, function (error) {
        // propagate TransitionSuperseded error without emitting $stateChangeCancel
        // as it was already emitted in the success handler above
        if (error === TransitionSupersededError) return TransitionSuperseded;

        if ($state.transition !== transition) {
          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
          return TransitionSuperseded;
        }

        $state.transition = null;
        /**
         * @ngdoc event
         * @name ui.router.state.$state#$stateChangeError
         * @eventOf ui.router.state.$state
         * @eventType broadcast on root scope
         * @description
         * Fired when an **error occurs** during transition. It's important to note that if you
         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
         * they will not throw traditionally. You must listen for this $stateChangeError event to
         * catch **ALL** errors.
         *
         * @param {Object} event Event object.
         * @param {State} toState The state being transitioned to.
         * @param {Object} toParams The params supplied to the `toState`.
         * @param {State} fromState The current state, pre-transition.
         * @param {Object} fromParams The params supplied to the `fromState`.
         * @param {Error} error The resolve error object.
         */
        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);

        if (!evt.defaultPrevented) {
          $urlRouter.update();
        }

        return $q.reject(error);
      });

      silenceUncaughtInPromise(transition);
      return transition;
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#is
     * @methodOf ui.router.state.$state
     *
     * @description
     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
     * but only checks for the full state name. If params is supplied then it will be
     * tested for strict equality against the current active params object, so all params
     * must match with none missing and no extras.
     *
     * @example
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // absolute name
     * $state.is('contact.details.item'); // returns true
     * $state.is(contactDetailItemStateObject); // returns true
     *
     * // relative name (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
     * </pre>
     *
     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
     * to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
     * test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it is the state.
     */
    $state.is = function is(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      var state = findState(stateOrName, options.relative);

      if (!isDefined(state)) { return undefined; }
      if ($state.$current !== state) { return false; }

      return !params || objectKeys(params).reduce(function(acc, key) {
        var paramDef = state.params[key];
        return acc && (!paramDef || paramDef.type.equals($stateParams[key], params[key]));
      }, true);
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#includes
     * @methodOf ui.router.state.$state
     *
     * @description
     * A method to determine if the current active state is equal to or is the child of the
     * state stateName. If any params are passed then they will be tested for a match as well.
     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
     *
     * @example
     * Partial and relative names
     * <pre>
     * $state.$current.name = 'contacts.details.item';
     *
     * // Using partial names
     * $state.includes("contacts"); // returns true
     * $state.includes("contacts.details"); // returns true
     * $state.includes("contacts.details.item"); // returns true
     * $state.includes("contacts.list"); // returns false
     * $state.includes("about"); // returns false
     *
     * // Using relative names (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
     * </pre>
     *
     * Basic globbing patterns
     * <pre>
     * $state.$current.name = 'contacts.details.item.url';
     *
     * $state.includes("*.details.*.*"); // returns true
     * $state.includes("*.details.**"); // returns true
     * $state.includes("**.item.**"); // returns true
     * $state.includes("*.details.item.url"); // returns true
     * $state.includes("*.details.*.url"); // returns true
     * $state.includes("*.details.*"); // returns false
     * $state.includes("item.**"); // returns false
     * </pre>
     *
     * @param {string} stateOrName A partial name, relative name, or glob pattern
     * to be searched for within the current state name.
     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
     * that you'd like to test against the current active state.
     * @param {object=} options An options object.  The options are:
     *
     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
     * .includes will test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it does include the state
     */
    $state.includes = function includes(stateOrName, params, options) {
      options = extend({ relative: $state.$current }, options || {});
      if (isString(stateOrName) && isGlob(stateOrName)) {
        if (!doesStateMatchGlob(stateOrName)) {
          return false;
        }
        stateOrName = $state.$current.name;
      }

      var state = findState(stateOrName, options.relative);
      if (!isDefined(state)) { return undefined; }
      if (!isDefined($state.$current.includes[state.name])) { return false; }
      if (!params) { return true; }

      var keys = objectKeys(params);
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i], paramDef = state.params[key];
        if (paramDef && !paramDef.type.equals($stateParams[key], params[key])) {
          return false;
        }
      }

      return objectKeys(params).reduce(function(acc, key) {
        var paramDef = state.params[key];
        return acc && !paramDef || paramDef.type.equals($stateParams[key], params[key]);
      }, true);
    };


    /**
     * @ngdoc function
     * @name ui.router.state.$state#href
     * @methodOf ui.router.state.$state
     *
     * @description
     * A url generation method that returns the compiled url for the given state populated with the given params.
     *
     * @example
     * <pre>
     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
     * </pre>
     *
     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
     * @param {object=} params An object of parameter values to fill the state's required parameters.
     * @param {object=} options Options object. The options are:
     *
     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
     *    ancestor with a valid url).
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
     *    defines which state to be relative from.
     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
     * 
     * @returns {string} compiled state url
     */
    $state.href = function href(stateOrName, params, options) {
      options = extend({
        lossy:    true,
        inherit:  true,
        absolute: false,
        relative: $state.$current
      }, options || {});

      var state = findState(stateOrName, options.relative);

      if (!isDefined(state)) return null;
      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
      
      var nav = (state && options.lossy) ? state.navigable : state;

      if (!nav || nav.url === undefined || nav.url === null) {
        return null;
      }
      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
        absolute: options.absolute
      });
    };

    /**
     * @ngdoc function
     * @name ui.router.state.$state#get
     * @methodOf ui.router.state.$state
     *
     * @description
     * Returns the state configuration object for any specific state or all states.
     *
     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
     * the requested state. If not provided, returns an array of ALL state configs.
     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
     * @returns {Object|Array} State configuration object or array of all objects.
     */
    $state.get = function (stateOrName, context) {
      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
      var state = findState(stateOrName, context || $state.$current);
      return (state && state.self) ? state.self : null;
    };

    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
      // Make a restricted $stateParams with only the parameters that apply to this state if
      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
      // we also need $stateParams to be available for any $injector calls we make during the
      // dependency resolution process.
      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
      var locals = { $stateParams: $stateParams };

      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
      // We're also including $stateParams in this; that way the parameters are restricted
      // to the set that should be visible to the state, and are independent of when we update
      // the global $state and $stateParams values.
      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
      var promises = [dst.resolve.then(function (globals) {
        dst.globals = globals;
      })];
      if (inherited) promises.push(inherited);

      function resolveViews() {
        var viewsPromises = [];

        // Resolve template and dependencies for all views.
        forEach(state.views, function (view, name) {
          var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
          injectables.$template = [ function () {
            return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
          }];

          viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
            // References to the controller (only instantiated at link time)
            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
              var injectLocals = angular.extend({}, injectables, dst.globals);
              result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
            } else {
              result.$$controller = view.controller;
            }
            // Provide access to the state itself for internal use
            result.$$state = state;
            result.$$controllerAs = view.controllerAs;
            result.$$resolveAs = view.resolveAs;
            dst[name] = result;
          }));
        });

        return $q.all(viewsPromises).then(function(){
          return dst.globals;
        });
      }

      // Wait for all the promises and then return the activation object
      return $q.all(promises).then(resolveViews).then(function (values) {
        return dst;
      });
    }

    return $state;
  }

  function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
    // Return true if there are no differences in non-search (path/object) params, false if there are differences
    function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
      // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
      function notSearchParam(key) {
        return fromAndToState.params[key].location != "search";
      }
      var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
      var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
      var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
      return nonQueryParamSet.$$equals(fromParams, toParams);
    }

    // If reload was not explicitly requested
    // and we're transitioning to the same state we're already in
    // and    the locals didn't change
    //     or they changed in a way that doesn't merit reloading
    //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
    // Then return true.
    if (!options.reload && to === from &&
      (locals === from.locals || (to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams)))) {
      return true;
    }
  }
}

angular.module('ui.router.state')
  .factory('$stateParams', function () { return {}; })
  .constant("$state.runtime", { autoinject: true })
  .provider('$state', $StateProvider)
  // Inject $state to initialize when entering runtime. #2574
  .run(['$injector', function ($injector) {
    // Allow tests (stateSpec.js) to turn this off by defining this constant
    if ($injector.get("$state.runtime").autoinject) {
      $injector.get('$state');
    }
  }]);


$ViewProvider.$inject = [];
function $ViewProvider() {

  this.$get = $get;
  /**
   * @ngdoc object
   * @name ui.router.state.$view
   *
   * @requires ui.router.util.$templateFactory
   * @requires $rootScope
   *
   * @description
   *
   */
  $get.$inject = ['$rootScope', '$templateFactory'];
  function $get(   $rootScope,   $templateFactory) {
    return {
      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
      /**
       * @ngdoc function
       * @name ui.router.state.$view#load
       * @methodOf ui.router.state.$view
       *
       * @description
       *
       * @param {string} name name
       * @param {object} options option object.
       */
      load: function load(name, options) {
        var result, defaults = {
          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
        };
        options = extend(defaults, options);

        if (options.view) {
          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
        }
        return result;
      }
    };
  }
}

angular.module('ui.router.state').provider('$view', $ViewProvider);

/**
 * @ngdoc object
 * @name ui.router.state.$uiViewScrollProvider
 *
 * @description
 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
 */
function $ViewScrollProvider() {

  var useAnchorScroll = false;

  /**
   * @ngdoc function
   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
   * @methodOf ui.router.state.$uiViewScrollProvider
   *
   * @description
   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
   * scrolling based on the url anchor.
   */
  this.useAnchorScroll = function () {
    useAnchorScroll = true;
  };

  /**
   * @ngdoc object
   * @name ui.router.state.$uiViewScroll
   *
   * @requires $anchorScroll
   * @requires $timeout
   *
   * @description
   * When called with a jqLite element, it scrolls the element into view (after a
   * `$timeout` so the DOM has time to refresh).
   *
   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
   */
  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
    if (useAnchorScroll) {
      return $anchorScroll;
    }

    return function ($element) {
      return $timeout(function () {
        $element[0].scrollIntoView();
      }, 0, false);
    };
  }];
}

angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-view
 *
 * @requires ui.router.state.$state
 * @requires $compile
 * @requires $controller
 * @requires $injector
 * @requires ui.router.state.$uiViewScroll
 * @requires $document
 *
 * @restrict ECA
 *
 * @description
 * The ui-view directive tells $state where to place your templates.
 *
 * @param {string=} name A view name. The name should be unique amongst the other views in the
 * same state. You can have views of the same name that live in different states.
 *
 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
 * scroll ui-view elements into view when they are populated during a state activation.
 *
 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
 *
 * @param {string=} onload Expression to evaluate whenever the view updates.
 *
 * @example
 * A view can be unnamed or named.
 * <pre>
 * <!-- Unnamed -->
 * <div ui-view></div>
 *
 * <!-- Named -->
 * <div ui-view="viewName"></div>
 * </pre>
 *
 * You can only have one unnamed view within any template (or root html). If you are only using a
 * single view and it is unnamed then you can populate it like so:
 * <pre>
 * <div ui-view></div>
 * $stateProvider.state("home", {
 *   template: "<h1>HELLO!</h1>"
 * })
 * </pre>
 *
 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#methods_state `views`}
 * config property, by name, in this case an empty name:
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * But typically you'll only use the views property if you name your view or have more than one view
 * in the same template. There's not really a compelling reason to name a view if its the only one,
 * but you could if you wanted, like so:
 * <pre>
 * <div ui-view="main"></div>
 * </pre>
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "main": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * Really though, you'll use views to set up multiple views:
 * <pre>
 * <div ui-view></div>
 * <div ui-view="chart"></div>
 * <div ui-view="data"></div>
 * </pre>
 *
 * <pre>
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     },
 *     "chart": {
 *       template: "<chart_thing/>"
 *     },
 *     "data": {
 *       template: "<data_thing/>"
 *     }
 *   }    
 * })
 * </pre>
 *
 * Examples for `autoscroll`:
 *
 * <pre>
 * <!-- If autoscroll present with no expression,
 *      then scroll ui-view into view -->
 * <ui-view autoscroll/>
 *
 * <!-- If autoscroll present with valid expression,
 *      then scroll ui-view into view if expression evaluates to true -->
 * <ui-view autoscroll='true'/>
 * <ui-view autoscroll='false'/>
 * <ui-view autoscroll='scopeVariable'/>
 * </pre>
 *
 * Resolve data:
 *
 * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
 * can be customized using [[ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
 *
 * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
 * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
 * depends on `$resolve` data.
 *
 * Example usage of $resolve in a view template
 * <pre>
 * $stateProvider.state('home', {
 *   template: '<my-component user="$resolve.user"></my-component>',
 *   resolve: {
 *     user: function(UserService) { return UserService.fetchUser(); }
 *   }
 * });
 * </pre>
 */
$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate', '$q'];
function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate,   $q) {

  function getService() {
    return ($injector.has) ? function(service) {
      return $injector.has(service) ? $injector.get(service) : null;
    } : function(service) {
      try {
        return $injector.get(service);
      } catch (e) {
        return null;
      }
    };
  }

  var service = getService(),
      $animator = service('$animator'),
      $animate = service('$animate');

  // Returns a set of DOM manipulation functions based on which Angular version
  // it should use
  function getRenderer(attrs, scope) {
    var statics = function() {
      return {
        enter: function (element, target, cb) { target.after(element); cb(); },
        leave: function (element, cb) { element.remove(); cb(); }
      };
    };

    if ($animate) {
      return {
        enter: function(element, target, cb) {
          if (angular.version.minor > 2) {
            $animate.enter(element, null, target).then(cb);
          } else {
            $animate.enter(element, null, target, cb);
          }
        },
        leave: function(element, cb) {
          if (angular.version.minor > 2) {
            $animate.leave(element).then(cb);
          } else {
            $animate.leave(element, cb);
          }
        }
      };
    }

    if ($animator) {
      var animate = $animator && $animator(scope, attrs);

      return {
        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
        leave: function(element, cb) { animate.leave(element); cb(); }
      };
    }

    return statics();
  }

  var directive = {
    restrict: 'ECA',
    terminal: true,
    priority: 400,
    transclude: 'element',
    compile: function (tElement, tAttrs, $transclude) {
      return function (scope, $element, attrs) {
        var previousEl, currentEl, currentScope, latestLocals,
            onloadExp     = attrs.onload || '',
            autoScrollExp = attrs.autoscroll,
            renderer      = getRenderer(attrs, scope),
            inherited     = $element.inheritedData('$uiView');

        scope.$on('$stateChangeSuccess', function() {
          updateView(false);
        });

        updateView(true);

        function cleanupLastView() {
          if (previousEl) {
            previousEl.remove();
            previousEl = null;
          }

          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }

          if (currentEl) {
            var $uiViewData = currentEl.data('$uiViewAnim');
            renderer.leave(currentEl, function() {
              $uiViewData.$$animLeave.resolve();
              previousEl = null;
            });

            previousEl = currentEl;
            currentEl = null;
          }
        }

        function updateView(firstTime) {
          var newScope,
              name            = getUiViewName(scope, attrs, $element, $interpolate),
              previousLocals  = name && $state.$current && $state.$current.locals[name];

          if (!firstTime && previousLocals === latestLocals) return; // nothing to do
          newScope = scope.$new();
          latestLocals = $state.$current.locals[name];

          /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoading
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           *
           * Fired once the view **begins loading**, *before* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */
          newScope.$emit('$viewContentLoading', name);

          var clone = $transclude(newScope, function(clone) {
            var animEnter = $q.defer(), animLeave = $q.defer();
            var viewAnimData = {
              $animEnter: animEnter.promise,
              $animLeave: animLeave.promise,
              $$animLeave: animLeave
            };

            clone.data('$uiViewAnim', viewAnimData);
            renderer.enter(clone, $element, function onUiViewEnter() {
              animEnter.resolve();
              if(currentScope) {
                currentScope.$emit('$viewContentAnimationEnded');
              }

              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
                $uiViewScroll(clone);
              }
            });
            cleanupLastView();
          });

          currentEl = clone;
          currentScope = newScope;
          /**
           * @ngdoc event
           * @name ui.router.state.directive:ui-view#$viewContentLoaded
           * @eventOf ui.router.state.directive:ui-view
           * @eventType emits on ui-view directive scope
           * @description
           * Fired once the view is **loaded**, *after* the DOM is rendered.
           *
           * @param {Object} event Event object.
           * @param {string} viewName Name of the view.
           */
          currentScope.$emit('$viewContentLoaded', name);
          currentScope.$eval(onloadExp);
        }
      };
    }
  };

  return directive;
}

$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
  return {
    restrict: 'ECA',
    priority: -400,
    compile: function (tElement) {
      var initial = tElement.html();
      if (tElement.empty) {
        tElement.empty();
      } else {
        // ng 1.0.0 doesn't have empty(), which cleans up data and handlers
        tElement[0].innerHTML = null;
      }

      return function (scope, $element, attrs) {
        var current = $state.$current,
            name = getUiViewName(scope, attrs, $element, $interpolate),
            locals  = current && current.locals[name];

        if (! locals) {
          $element.html(initial);
          $compile($element.contents())(scope);
          return;
        }

        $element.data('$uiView', { name: name, state: locals.$$state });
        $element.html(locals.$template ? locals.$template : initial);

        var resolveData = angular.extend({}, locals);
        scope[locals.$$resolveAs] = resolveData;

        var link = $compile($element.contents());

        if (locals.$$controller) {
          locals.$scope = scope;
          locals.$element = $element;
          var controller = $controller(locals.$$controller, locals);
          if (locals.$$controllerAs) {
            scope[locals.$$controllerAs] = controller;
            scope[locals.$$controllerAs][locals.$$resolveAs] = resolveData;
          }
          if (isFunction(controller.$onInit)) controller.$onInit();
          $element.data('$ngControllerController', controller);
          $element.children().data('$ngControllerController', controller);
        }

        link(scope);
      };
    }
  };
}

/**
 * Shared ui-view code for both directives:
 * Given scope, element, and its attributes, return the view's name
 */
function getUiViewName(scope, attrs, element, $interpolate) {
  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
  var uiViewCreatedBy = element.inheritedData('$uiView');
  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (uiViewCreatedBy ? uiViewCreatedBy.state.name : ''));
}

angular.module('ui.router.state').directive('uiView', $ViewDirective);
angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);

function parseStateRef(ref, current) {
  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
  if (preparsed) ref = current + '(' + preparsed[1] + ')';
  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
  return { state: parsed[1], paramExpr: parsed[3] || null };
}

function stateContext(el) {
  var stateData = el.parent().inheritedData('$uiView');

  if (stateData && stateData.state && stateData.state.name) {
    return stateData.state;
  }
}

function getTypeInfo(el) {
  // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
  var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
  var isForm = el[0].nodeName === "FORM";

  return {
    attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
    isAnchor: el.prop("tagName").toUpperCase() === "A",
    clickable: !isForm
  };
}

function clickHook(el, $state, $timeout, type, current) {
  return function(e) {
    var button = e.which || e.button, target = current();

    if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
      // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
      var transition = $timeout(function() {
        $state.go(target.state, target.params, target.options);
      });
      e.preventDefault();

      // if the state has no URL, ignore one preventDefault from the <a> directive.
      var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1: 0;

      e.preventDefault = function() {
        if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
      };
    }
  };
}

function defaultOpts(el, $state) {
  return { relative: stateContext(el) || $state.$current, inherit: true };
}

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref
 *
 * @requires ui.router.state.$state
 * @requires $timeout
 *
 * @restrict A
 *
 * @description
 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
 * URL, the directive will automatically generate & update the `href` attribute via
 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
 * the link will trigger a state transition with optional parameters.
 *
 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
 * handled natively by the browser.
 *
 * You can also use relative state paths within ui-sref, just like the relative
 * paths passed to `$state.go()`. You just need to be aware that the path is relative
 * to the state that the link lives in, in other words the state that loaded the
 * template containing the link.
 *
 * You can specify options to pass to {@link ui.router.state.$state#methods_go $state.go()}
 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
 * and `reload`.
 *
 * @example
 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
 * following template:
 * <pre>
 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
 *     </li>
 * </ul>
 * </pre>
 *
 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
 * <pre>
 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
 *     </li>
 * </ul>
 *
 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
 * </pre>
 *
 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
 */
$StateRefDirective.$inject = ['$state', '$timeout'];
function $StateRefDirective($state, $timeout) {
  return {
    restrict: 'A',
    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
    link: function(scope, element, attrs, uiSrefActive) {
      var ref    = parseStateRef(attrs.uiSref, $state.current.name);
      var def    = { state: ref.state, href: null, params: null };
      var type   = getTypeInfo(element);
      var active = uiSrefActive[1] || uiSrefActive[0];
      var unlinkInfoFn = null;
      var hookFn;

      def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});

      var update = function(val) {
        if (val) def.params = angular.copy(val);
        def.href = $state.href(ref.state, def.params, def.options);

        if (unlinkInfoFn) unlinkInfoFn();
        if (active) unlinkInfoFn = active.$$addStateInfo(ref.state, def.params);
        if (def.href !== null) attrs.$set(type.attr, def.href);
      };

      if (ref.paramExpr) {
        scope.$watch(ref.paramExpr, function(val) { if (val !== def.params) update(val); }, true);
        def.params = angular.copy(scope.$eval(ref.paramExpr));
      }
      update();

      if (!type.clickable) return;
      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
      element[element.on ? 'on' : 'bind']("click", hookFn);
      scope.$on('$destroy', function() {
        element[element.off ? 'off' : 'unbind']("click", hookFn);
      });
    }
  };
}

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-state
 *
 * @requires ui.router.state.uiSref
 *
 * @restrict A
 *
 * @description
 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
 * params and override options.
 *
 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#methods_href $state.href()}
 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
 */
$StateRefDynamicDirective.$inject = ['$state', '$timeout'];
function $StateRefDynamicDirective($state, $timeout) {
  return {
    restrict: 'A',
    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
    link: function(scope, element, attrs, uiSrefActive) {
      var type   = getTypeInfo(element);
      var active = uiSrefActive[1] || uiSrefActive[0];
      var group  = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
      var watch  = '[' + group.map(function(val) { return val || 'null'; }).join(', ') + ']';
      var def    = { state: null, params: null, options: null, href: null };
      var unlinkInfoFn = null;
      var hookFn;

      function runStateRefLink (group) {
        def.state = group[0]; def.params = group[1]; def.options = group[2];
        def.href = $state.href(def.state, def.params, def.options);

        if (unlinkInfoFn) unlinkInfoFn();
        if (active) unlinkInfoFn = active.$$addStateInfo(def.state, def.params);
        if (def.href) attrs.$set(type.attr, def.href);
      }

      scope.$watch(watch, runStateRefLink, true);
      runStateRefLink(scope.$eval(watch));

      if (!type.clickable) return;
      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
      element[element.on ? 'on' : 'bind']("click", hookFn);
      scope.$on('$destroy', function() {
        element[element.off ? 'off' : 'unbind']("click", hookFn);
      });
    }
  };
}


/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * A directive working alongside ui-sref to add classes to an element when the
 * related ui-sref directive's state is active, and removing them when it is inactive.
 * The primary use-case is to simplify the special appearance of navigation menus
 * relying on `ui-sref`, by having the "active" state's menu button appear different,
 * distinguishing it from the inactive menu items.
 *
 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
 * ui-sref-active found at the same level or above the ui-sref will be used.
 *
 * Will activate when the ui-sref's target state or any child state is active. If you
 * need to activate only when the ui-sref target state is active and *not* any of
 * it's children, then you will use
 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
 *
 * @example
 * Given the following template:
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item">
 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 *
 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
 * the resulting HTML will appear as (note the 'active' class):
 * <pre>
 * <ul>
 *   <li ui-sref-active="active" class="item active">
 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * The class name is interpolated **once** during the directives link time (any further changes to the
 * interpolated value are ignored).
 *
 * Multiple classes may be specified in a space-separated format:
 * <pre>
 * <ul>
 *   <li ui-sref-active='class1 class2 class3'>
 *     <a ui-sref="app.user">link</a>
 *   </li>
 * </ul>
 * </pre>
 *
 * It is also possible to pass ui-sref-active an expression that evaluates
 * to an object hash, whose keys represent active class names and whose
 * values represent the respective state names/globs.
 * ui-sref-active will match if the current active state **includes** any of
 * the specified state names/globs, even the abstract ones.
 *
 * @Example
 * Given the following template, with "admin" being an abstract state:
 * <pre>
 * <div ui-sref-active="{'active': 'admin.*'}">
 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
 * </div>
 * </pre>
 *
 * When the current state is "admin.roles" the "active" class will be applied
 * to both the <div> and <a> elements. It is important to note that the state
 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
 */

/**
 * @ngdoc directive
 * @name ui.router.state.directive:ui-sref-active-eq
 *
 * @requires ui.router.state.$state
 * @requires ui.router.state.$stateParams
 * @requires $interpolate
 *
 * @restrict A
 *
 * @description
 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
 * when the exact target state used in the `ui-sref` is active; no child states.
 *
 */
$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
function $StateRefActiveDirective($state, $stateParams, $interpolate) {
  return  {
    restrict: "A",
    controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
      var states = [], activeClasses = {}, activeEqClass, uiSrefActive;

      // There probably isn't much point in $observing this
      // uiSrefActive and uiSrefActiveEq share the same directive object with some
      // slight difference in logic routing
      activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);

      try {
        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
      } catch (e) {
        // Do nothing. uiSrefActive is not a valid expression.
        // Fall back to using $interpolate below
      }
      uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
      if (isObject(uiSrefActive)) {
        forEach(uiSrefActive, function(stateOrName, activeClass) {
          if (isString(stateOrName)) {
            var ref = parseStateRef(stateOrName, $state.current.name);
            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
          }
        });
      }

      // Allow uiSref to communicate with uiSrefActive[Equals]
      this.$$addStateInfo = function (newState, newParams) {
        // we already got an explicit state provided by ui-sref-active, so we
        // shadow the one that comes from ui-sref
        if (isObject(uiSrefActive) && states.length > 0) {
          return;
        }
        var deregister = addState(newState, newParams, uiSrefActive);
        update();
        return deregister;
      };

      $scope.$on('$stateChangeSuccess', update);

      function addState(stateName, stateParams, activeClass) {
        var state = $state.get(stateName, stateContext($element));
        var stateHash = createStateHash(stateName, stateParams);

        var stateInfo = {
          state: state || { name: stateName },
          params: stateParams,
          hash: stateHash
        };

        states.push(stateInfo);
        activeClasses[stateHash] = activeClass;

        return function removeState() {
          var idx = states.indexOf(stateInfo);
          if (idx !== -1) states.splice(idx, 1);
        };
      }

      /**
       * @param {string} state
       * @param {Object|string} [params]
       * @return {string}
       */
      function createStateHash(state, params) {
        if (!isString(state)) {
          throw new Error('state should be a string');
        }
        if (isObject(params)) {
          return state + toJson(params);
        }
        params = $scope.$eval(params);
        if (isObject(params)) {
          return state + toJson(params);
        }
        return state;
      }

      // Update route state
      function update() {
        for (var i = 0; i < states.length; i++) {
          if (anyMatch(states[i].state, states[i].params)) {
            addClass($element, activeClasses[states[i].hash]);
          } else {
            removeClass($element, activeClasses[states[i].hash]);
          }

          if (exactMatch(states[i].state, states[i].params)) {
            addClass($element, activeEqClass);
          } else {
            removeClass($element, activeEqClass);
          }
        }
      }

      function addClass(el, className) { $timeout(function () { el.addClass(className); }); }
      function removeClass(el, className) { el.removeClass(className); }
      function anyMatch(state, params) { return $state.includes(state.name, params); }
      function exactMatch(state, params) { return $state.is(state.name, params); }

      update();
    }]
  };
}

angular.module('ui.router.state')
  .directive('uiSref', $StateRefDirective)
  .directive('uiSrefActive', $StateRefActiveDirective)
  .directive('uiSrefActiveEq', $StateRefActiveDirective)
  .directive('uiState', $StateRefDynamicDirective);

/**
 * @ngdoc filter
 * @name ui.router.state.filter:isState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
 */
$IsStateFilter.$inject = ['$state'];
function $IsStateFilter($state) {
  var isFilter = function (state, params) {
    return $state.is(state, params);
  };
  isFilter.$stateful = true;
  return isFilter;
}

/**
 * @ngdoc filter
 * @name ui.router.state.filter:includedByState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
 */
$IncludedByStateFilter.$inject = ['$state'];
function $IncludedByStateFilter($state) {
  var includesFilter = function (state, params, options) {
    return $state.includes(state, params, options);
  };
  includesFilter.$stateful = true;
  return  includesFilter;
}

angular.module('ui.router.state')
  .filter('isState', $IsStateFilter)
  .filter('includedByState', $IncludedByStateFilter);
})(window, window.angular);
/**!
 * AngularJS file upload/drop directive and service with progress and abort
 * @author  Danial  <danial.farid@gmail.com>
 * @version 3.2.4
 */
(function () {

var key, i;
function patchXHR(fnName, newFn) {
    window.XMLHttpRequest.prototype[fnName] = newFn(window.XMLHttpRequest.prototype[fnName]);
}

if (window.XMLHttpRequest && !window.XMLHttpRequest.__isFileAPIShim) {
    patchXHR('setRequestHeader', function (orig) {
        return function (header, value) {
            if (header === '__setXHR_') {
                var val = value(this);
                // fix for angular < 1.2.0
                if (val instanceof Function) {
                    val(this);
                }
            } else {
                orig.apply(this, arguments);
            }
        }
    });
}

var angularFileUpload = angular.module('angularFileUpload', []);

angularFileUpload.version = '3.2.4';
angularFileUpload.service('$upload', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
    function sendHttp(config) {
        config.method = config.method || 'POST';
        config.headers = config.headers || {};
        config.transformRequest = config.transformRequest || function (data, headersGetter) {
            if (window.ArrayBuffer && data instanceof window.ArrayBuffer) {
                return data;
            }
            return $http.defaults.transformRequest[0](data, headersGetter);
        };
        var deferred = $q.defer();
        var promise = deferred.promise;

        config.headers['__setXHR_'] = function () {
            return function (xhr) {
                if (!xhr) return;
                config.__XHR = xhr;
                config.xhrFn && config.xhrFn(xhr);
                xhr.upload.addEventListener('progress', function (e) {
                    e.config = config;
                    deferred.notify ? deferred.notify(e) : promise.progress_fn && $timeout(function () {
                        promise.progress_fn(e)
                    });
                }, false);
                //fix for firefox not firing upload progress end, also IE8-9
                xhr.upload.addEventListener('load', function (e) {
                    if (e.lengthComputable) {
                        e.config = config;
                        deferred.notify ? deferred.notify(e) : promise.progress_fn && $timeout(function () {
                            promise.progress_fn(e)
                        });
                    }
                }, false);
            };
        };

        $http(config).then(function (r) {
            deferred.resolve(r)
        }, function (e) {
            deferred.reject(e)
        }, function (n) {
            deferred.notify(n)
        });

        promise.success = function (fn) {
            promise.then(function (response) {
                fn(response.data, response.status, response.headers, config);
            });
            return promise;
        };

        promise.error = function (fn) {
            promise.then(null, function (response) {
                fn(response.data, response.status, response.headers, config);
            });
            return promise;
        };

        promise.progress = function (fn) {
            promise.progress_fn = fn;
            promise.then(null, null, function (update) {
                fn(update);
            });
            return promise;
        };
        promise.abort = function () {
            if (config.__XHR) {
                $timeout(function () {
                    config.__XHR.abort();
                });
            }
            return promise;
        };
        promise.xhr = function (fn) {
            config.xhrFn = (function (origXhrFn) {
                return function () {
                    origXhrFn && origXhrFn.apply(promise, arguments);
                    fn.apply(promise, arguments);
                }
            })(config.xhrFn);
            return promise;
        };

        return promise;
    }

    this.upload = function (config) {
        config.headers = config.headers || {};
        config.headers['Content-Type'] = undefined;
        config.transformRequest = config.transformRequest ?
            (Object.prototype.toString.call(config.transformRequest) === '[object Array]' ?
                config.transformRequest : [config.transformRequest]) : [];
        config.transformRequest.push(function (data) {
            var formData = new FormData();
            var allFields = {};
            for (key in config.fields) {
                if (config.fields.hasOwnProperty(key)) {
                    allFields[key] = config.fields[key];
                }
            }
            if (data) allFields['data'] = data;

            if (config.formDataAppender) {
                for (key in allFields) {
                    if (allFields.hasOwnProperty(key)) {
                        config.formDataAppender(formData, key, allFields[key]);
                    }
                }
            } else {
                for (key in allFields) {
                    if (allFields.hasOwnProperty(key)) {
                        var val = allFields[key];
                        if (val !== undefined) {
                            if (Object.prototype.toString.call(val) === '[object String]') {
                                formData.append(key, val);
                            } else {
                                if (config.sendObjectsAsJsonBlob && typeof val === 'object') {
                                    formData.append(key, new Blob([val], {type: 'application/json'}));
                                } else {
                                    formData.append(key, JSON.stringify(val));
                                }
                            }

                        }
                    }
                }
            }

            if (config.file != null) {
                var fileFormName = config.fileFormDataName || 'file';

                if (Object.prototype.toString.call(config.file) === '[object Array]') {
                    var isFileFormNameString = Object.prototype.toString.call(fileFormName) === '[object String]';
                    for (i = 0; i < config.file.length; i++) {
                        formData.append(isFileFormNameString ? fileFormName : fileFormName[i], config.file[i],
                            (config.fileName && config.fileName[i]) || config.file[i].name);
                    }
                } else {
                    formData.append(fileFormName, config.file, config.fileName || config.file.name);
                }
            }
            return formData;
        });

        return sendHttp(config);
    };

    this.http = function (config) {
        return sendHttp(config);
    };
}]);

angularFileUpload.directive('ngFileSelect', ['$parse', '$timeout', '$compile',
    function ($parse, $timeout, $compile) {
        return {
            restrict: 'AEC',
            require: '?ngModel',
            link: function (scope, elem, attr, ngModel) {
                linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile);
            }
        }
    }]);

function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile) {
    function isInputTypeFile() {
        return elem[0].tagName.toLowerCase() === 'input' && elem.attr('type') && elem.attr('type').toLowerCase() === 'file';
    }

    var isUpdating = false;
    function changeFn(evt) {
        if (!isUpdating) {
            isUpdating = true;
            try {
                var fileList = evt.__files_ || (evt.target && evt.target.files);
                var files = [], rejFiles = [];

                var accept = $parse(attr.ngAccept);
                for (i = 0; i < fileList.length; i++) {
                    var file = fileList.item(i);
                    if (isAccepted(scope, accept, file, evt)) {
                        files.push(file);
                    } else {
                        rejFiles.push(file);
                    }
                }
                updateModel($parse, $timeout, scope, ngModel, attr,
                    attr.ngFileChange || attr.ngFileSelect, files, rejFiles, evt);
                if (files.length == 0) evt.target.value = files;
                if (evt.target && evt.target.getAttribute('__ngf_gen__')) {
                    angular.element(evt.target).remove();
                }
            } finally {
                isUpdating = false;
            }
        }
    }

    function bindAttrToFileInput(fileElem) {
        if (attr.ngMultiple) fileElem.attr('multiple', $parse(attr.ngMultiple)(scope));
        if (attr['accept']) fileElem.attr('accept', attr['accept']);
        if (attr.ngCapture) fileElem.attr('capture', $parse(attr.ngCapture)(scope));
        if (attr.ngDisabled) fileElem.attr('disabled', $parse(attr.ngDisabled)(scope));

        fileElem.bind('change', changeFn);
    }

    function createFileInput(evt) {
        if (elem.attr('disabled')) {
            return;
        }
        var fileElem = angular.element('<input type="file">');

        for (var i = 0; i < elem[0].attributes.length; i++) {
            var attribute = elem[0].attributes[i];
            fileElem.attr(attribute.name, attribute.value);
        }

        if (isInputTypeFile()) {
            elem.replaceWith(fileElem);
            elem = fileElem;
        } else {
            fileElem.css('width', '0px').css('height', '0px').css('position', 'absolute')
                .css('padding', 0).css('margin', 0).css('overflow', 'hidden')
                .attr('tabindex', '-1').css('opacity', 0).attr('__ngf_gen__', true);
            if (elem.__ngf_ref_elem__) elem.__ngf_ref_elem__.remove();
            elem.__ngf_ref_elem__ = fileElem;
            elem.parent()[0].insertBefore(fileElem[0], elem[0]);
            elem.css('overflow', 'hidden');
        }

        bindAttrToFileInput(fileElem);

        return fileElem;
    }

    function resetModel(evt) {
        updateModel($parse, $timeout, scope, ngModel, attr,
            attr.ngFileChange || attr.ngFileSelect, [], [], evt, true);
    }

    function clickHandler(evt) {
        var fileElem = createFileInput(evt);
        if (fileElem) {
            resetModel(evt);

            fileElem[0].click();
        }
        if (isInputTypeFile()) {
            elem.bind('click', clickHandler);
            evt.preventDefault()
        }
    }

    if (window.FileAPI && window.FileAPI.ngfFixIE) {
        window.FileAPI.ngfFixIE(elem, createFileInput, changeFn, resetModel);
    } else {
        elem.bind('click', clickHandler);
    }
}

angularFileUpload.directive('ngFileDrop', ['$parse', '$timeout', '$location', function ($parse, $timeout, $location) {
    return {
        restrict: 'AEC',
        require: '?ngModel',
        link: function (scope, elem, attr, ngModel) {
            linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $location);
        }
    }
}]);

angularFileUpload.directive('ngNoFileDrop', function () {
    return function (scope, elem) {
        if (dropAvailable()) elem.css('display', 'none')
    }
});

//for backward compatibility
angularFileUpload.directive('ngFileDropAvailable', ['$parse', '$timeout', function ($parse, $timeout) {
    return function (scope, elem, attr) {
        if (dropAvailable()) {
            var fn = $parse(attr['ngFileDropAvailable']);
            $timeout(function () {
                fn(scope);
            });
        }
    }
}]);

function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $location) {
    var available = dropAvailable();
    if (attr['dropAvailable']) {
        $timeout(function () {
            scope.dropAvailable ? scope.dropAvailable.value = available :
                scope.dropAvailable = available;
        });
    }
    if (!available) {
        if ($parse(attr.hideOnDropNotAvailable)(scope) == true) {
            elem.css('display', 'none');
        }
        return;
    }
    var leaveTimeout = null;
    var stopPropagation = $parse(attr.stopPropagation);
    var dragOverDelay = 1;
    var accept = $parse(attr.ngAccept);
    var disabled = $parse(attr.ngDisabled);
    var actualDragOverClass;

    elem[0].addEventListener('dragover', function (evt) {
        if (disabled(scope)) return;
        evt.preventDefault();
        if (stopPropagation(scope)) evt.stopPropagation();
        // handling dragover events from the Chrome download bar
        if (navigator.userAgent.indexOf("Chrome") > -1) {
            var b = evt.dataTransfer.effectAllowed;
            evt.dataTransfer.dropEffect = ('move' === b || 'linkMove' === b) ? 'move' : 'copy';
        }
        $timeout.cancel(leaveTimeout);
        if (!scope.actualDragOverClass) {
            actualDragOverClass = calculateDragOverClass(scope, attr, evt);
        }
        elem.addClass(actualDragOverClass);
    }, false);
    elem[0].addEventListener('dragenter', function (evt) {
        if (disabled(scope)) return;
        evt.preventDefault();
        if (stopPropagation(scope)) evt.stopPropagation();
    }, false);
    elem[0].addEventListener('dragleave', function () {
        if (disabled(scope)) return;
        leaveTimeout = $timeout(function () {
            elem.removeClass(actualDragOverClass);
            actualDragOverClass = null;
        }, dragOverDelay || 1);
    }, false);
    elem[0].addEventListener('drop', function (evt) {
        if (disabled(scope)) return;
        evt.preventDefault();
        if (stopPropagation(scope)) evt.stopPropagation();
        elem.removeClass(actualDragOverClass);
        actualDragOverClass = null;
        extractFiles(evt, function (files, rejFiles) {
            updateModel($parse, $timeout, scope, ngModel, attr,
                attr.ngFileChange || attr.ngFileDrop, files, rejFiles, evt)
        }, $parse(attr.allowDir)(scope) != false, attr.multiple || $parse(attr.ngMultiple)(scope));
    }, false);

    function calculateDragOverClass(scope, attr, evt) {
        var accepted = true;
        var items = evt.dataTransfer.items;
        if (items != null) {
            for (i = 0; i < items.length && accepted; i++) {
                accepted = accepted
                    && (items[i].kind == 'file' || items[i].kind == '')
                    && isAccepted(scope, accept, items[i], evt);
            }
        }
        var clazz = $parse(attr.dragOverClass)(scope, {$event: evt});
        if (clazz) {
            if (clazz.delay) dragOverDelay = clazz.delay;
            if (clazz.accept) clazz = accepted ? clazz.accept : clazz.reject;
        }
        return clazz || attr['dragOverClass'] || 'dragover';
    }

    function extractFiles(evt, callback, allowDir, multiple) {
        var files = [], rejFiles = [], items = evt.dataTransfer.items, processing = 0;

        function addFile(file) {
            if (isAccepted(scope, accept, file, evt)) {
                files.push(file);
            } else {
                rejFiles.push(file);
            }
        }

        if (items && items.length > 0 && $location.protocol() != 'file') {
            for (i = 0; i < items.length; i++) {
                if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
                    var entry = items[i].webkitGetAsEntry();
                    if (entry.isDirectory && !allowDir) {
                        continue;
                    }
                    if (entry != null) {
                        traverseFileTree(files, entry);
                    }
                } else {
                    var f = items[i].getAsFile();
                    if (f != null) addFile(f);
                }
                if (!multiple && files.length > 0) break;
            }
        } else {
            var fileList = evt.dataTransfer.files;
            if (fileList != null) {
                for (i = 0; i < fileList.length; i++) {
                    addFile(fileList.item(i));
                    if (!multiple && files.length > 0) break;
                }
            }
        }
        var delays = 0;
        (function waitForProcess(delay) {
            $timeout(function () {
                if (!processing) {
                    if (!multiple && files.length > 1) {
                        i = 0;
                        while (files[i].type == 'directory') i++;
                        files = [files[i]];
                    }
                    callback(files, rejFiles);
                } else {
                    if (delays++ * 10 < 20 * 1000) {
                        waitForProcess(10);
                    }
                }
            }, delay || 0)
        })();

        function traverseFileTree(files, entry, path) {
            if (entry != null) {
                if (entry.isDirectory) {
                    var filePath = (path || '') + entry.name;
                    addFile({name: entry.name, type: 'directory', path: filePath});
                    var dirReader = entry.createReader();
                    var entries = [];
                    processing++;
                    var readEntries = function () {
                        dirReader.readEntries(function (results) {
                            try {
                                if (!results.length) {
                                    for (i = 0; i < entries.length; i++) {
                                        traverseFileTree(files, entries[i], (path ? path : '') + entry.name + '/');
                                    }
                                    processing--;
                                } else {
                                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
                                    readEntries();
                                }
                            } catch (e) {
                                processing--;
                                console.error(e);
                            }
                        }, function () {
                            processing--;
                        });
                    };
                    readEntries();
                } else {
                    processing++;
                    entry.file(function (file) {
                        try {
                            processing--;
                            file.path = (path ? path : '') + file.name;
                            addFile(file);
                        } catch (e) {
                            processing--;
                            console.error(e);
                        }
                    }, function () {
                        processing--;
                    });
                }
            }
        }
    }
}

function dropAvailable() {
    var div = document.createElement('div');
    return ('draggable' in div) && ('ondrop' in div);
}

function updateModel($parse, $timeout, scope, ngModel, attr, fileChange, files, rejFiles, evt, noDelay) {
    function update() {
        if (ngModel) {
            $parse(attr.ngModel).assign(scope, files);
            $timeout(function () {
                ngModel && ngModel.$setViewValue(files != null && files.length == 0 ? null : files);
            });
        }
        if (attr.ngModelRejected) {
            $parse(attr.ngModelRejected).assign(scope, rejFiles);
        }
        if (fileChange) {
            $parse(fileChange)(scope, {
                $files: files,
                $rejectedFiles: rejFiles,
                $event: evt
            });

        }
    }
    if (noDelay) {
        update();
    } else {
        $timeout(function () {
            update();
        });
    }
}

function isAccepted(scope, accept, file, evt) {
    var val = accept(scope, {$file: file, $event: evt});
    if (val == null) {
        return true;
    }
    if (angular.isString(val)) {
        var regexp = new RegExp(globStringToRegex(val), 'gi')
        val = (file.type != null && file.type.match(regexp)) ||
        (file.name != null && file.name.match(regexp));
    }
    return val;
}

function globStringToRegex(str) {
    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
        return str.substring(1, str.length - 1);
    }
    var split = str.split(','), result = '';
    if (split.length > 1) {
        for (i = 0; i < split.length; i++) {
            result += '(' + globStringToRegex(split[i]) + ')';
            if (i < split.length - 1) {
                result += '|'
            }
        }
    } else {
        if (str.indexOf('.') == 0) {
            str = '*' + str;
        }
        result = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\' + '-]', 'g'), '\\$&') + '$';
        result = result.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
    }
    return result;
}

var ngFileUpload = angular.module('ngFileUpload', []);

for (key in angularFileUpload) {
    if (angularFileUpload.hasOwnProperty(key)) {
        ngFileUpload[key] = angularFileUpload[key];
    }
}

})();

/*!
 * ngImgCrop v0.3.2
 * https://github.com/alexk111/ngImgCrop
 *
 * Copyright (c) 2014 Alex Kaul
 * License: MIT
 *
 * Generated at Wednesday, December 3rd, 2014, 3:54:12 PM
 */
(function() {
'use strict';

var crop = angular.module('ngImgCrop', []);

crop.factory('cropAreaCircle', ['cropArea', function(CropArea) {
  var CropAreaCircle = function() {
    CropArea.apply(this, arguments);

    this._boxResizeBaseSize = 20;
    this._boxResizeNormalRatio = 0.9;
    this._boxResizeHoverRatio = 1.2;
    this._iconMoveNormalRatio = 0.9;
    this._iconMoveHoverRatio = 1.2;

    this._boxResizeNormalSize = this._boxResizeBaseSize*this._boxResizeNormalRatio;
    this._boxResizeHoverSize = this._boxResizeBaseSize*this._boxResizeHoverRatio;

    this._posDragStartX=0;
    this._posDragStartY=0;
    this._posResizeStartX=0;
    this._posResizeStartY=0;
    this._posResizeStartSize=0;

    this._boxResizeIsHover = false;
    this._areaIsHover = false;
    this._boxResizeIsDragging = false;
    this._areaIsDragging = false;
  };

  CropAreaCircle.prototype = new CropArea();

  CropAreaCircle.prototype._calcCirclePerimeterCoords=function(angleDegrees) {
    var hSize=this._size/2;
    var angleRadians=angleDegrees * (Math.PI / 180),
        circlePerimeterX=this._x + hSize * Math.cos(angleRadians),
        circlePerimeterY=this._y + hSize * Math.sin(angleRadians);
    return [circlePerimeterX, circlePerimeterY];
  };

  CropAreaCircle.prototype._calcResizeIconCenterCoords=function() {
    return this._calcCirclePerimeterCoords(-45);
  };

  CropAreaCircle.prototype._isCoordWithinArea=function(coord) {
    return Math.sqrt((coord[0]-this._x)*(coord[0]-this._x) + (coord[1]-this._y)*(coord[1]-this._y)) < this._size/2;
  };
  CropAreaCircle.prototype._isCoordWithinBoxResize=function(coord) {
    var resizeIconCenterCoords=this._calcResizeIconCenterCoords();
    var hSize=this._boxResizeHoverSize/2;
    return(coord[0] > resizeIconCenterCoords[0] - hSize && coord[0] < resizeIconCenterCoords[0] + hSize &&
           coord[1] > resizeIconCenterCoords[1] - hSize && coord[1] < resizeIconCenterCoords[1] + hSize);
  };

  CropAreaCircle.prototype._drawArea=function(ctx,centerCoords,size){
    ctx.arc(centerCoords[0],centerCoords[1],size/2,0,2*Math.PI);
  };

  CropAreaCircle.prototype.draw=function() {
    CropArea.prototype.draw.apply(this, arguments);

    // draw move icon
    this._cropCanvas.drawIconMove([this._x,this._y], this._areaIsHover?this._iconMoveHoverRatio:this._iconMoveNormalRatio);

    // draw resize cubes
    this._cropCanvas.drawIconResizeBoxNESW(this._calcResizeIconCenterCoords(), this._boxResizeBaseSize, this._boxResizeIsHover?this._boxResizeHoverRatio:this._boxResizeNormalRatio);
  };

  CropAreaCircle.prototype.processMouseMove=function(mouseCurX, mouseCurY) {
    var cursor='default';
    var res=false;

    this._boxResizeIsHover = false;
    this._areaIsHover = false;

    if (this._areaIsDragging) {
      this._x = mouseCurX - this._posDragStartX;
      this._y = mouseCurY - this._posDragStartY;
      this._areaIsHover = true;
      cursor='move';
      res=true;
      this._events.trigger('area-move');
    } else if (this._boxResizeIsDragging) {
        cursor = 'nesw-resize';
        var iFR, iFX, iFY;
        iFX = mouseCurX - this._posResizeStartX;
        iFY = this._posResizeStartY - mouseCurY;
        if(iFX>iFY) {
          iFR = this._posResizeStartSize + iFY*2;
        } else {
          iFR = this._posResizeStartSize + iFX*2;
        }

        this._size = Math.max(this._minSize, iFR);
        this._boxResizeIsHover = true;
        res=true;
        this._events.trigger('area-resize');
    } else if (this._isCoordWithinBoxResize([mouseCurX,mouseCurY])) {
        cursor = 'nesw-resize';
        this._areaIsHover = false;
        this._boxResizeIsHover = true;
        res=true;
    } else if(this._isCoordWithinArea([mouseCurX,mouseCurY])) {
        cursor = 'move';
        this._areaIsHover = true;
        res=true;
    }

    this._dontDragOutside();
    angular.element(this._ctx.canvas).css({'cursor': cursor});

    return res;
  };

  CropAreaCircle.prototype.processMouseDown=function(mouseDownX, mouseDownY) {
    if (this._isCoordWithinBoxResize([mouseDownX,mouseDownY])) {
      this._areaIsDragging = false;
      this._areaIsHover = false;
      this._boxResizeIsDragging = true;
      this._boxResizeIsHover = true;
      this._posResizeStartX=mouseDownX;
      this._posResizeStartY=mouseDownY;
      this._posResizeStartSize = this._size;
      this._events.trigger('area-resize-start');
    } else if (this._isCoordWithinArea([mouseDownX,mouseDownY])) {
      this._areaIsDragging = true;
      this._areaIsHover = true;
      this._boxResizeIsDragging = false;
      this._boxResizeIsHover = false;
      this._posDragStartX = mouseDownX - this._x;
      this._posDragStartY = mouseDownY - this._y;
      this._events.trigger('area-move-start');
    }
  };

  CropAreaCircle.prototype.processMouseUp=function(/*mouseUpX, mouseUpY*/) {
    if(this._areaIsDragging) {
      this._areaIsDragging = false;
      this._events.trigger('area-move-end');
    }
    if(this._boxResizeIsDragging) {
      this._boxResizeIsDragging = false;
      this._events.trigger('area-resize-end');
    }
    this._areaIsHover = false;
    this._boxResizeIsHover = false;

    this._posDragStartX = 0;
    this._posDragStartY = 0;
  };

  return CropAreaCircle;
}]);



crop.factory('cropAreaSquare', ['cropArea', function(CropArea) {
  var CropAreaSquare = function() {
    CropArea.apply(this, arguments);

    this._resizeCtrlBaseRadius = 10;
    this._resizeCtrlNormalRatio = 0.75;
    this._resizeCtrlHoverRatio = 1;
    this._iconMoveNormalRatio = 0.9;
    this._iconMoveHoverRatio = 1.2;

    this._resizeCtrlNormalRadius = this._resizeCtrlBaseRadius*this._resizeCtrlNormalRatio;
    this._resizeCtrlHoverRadius = this._resizeCtrlBaseRadius*this._resizeCtrlHoverRatio;

    this._posDragStartX=0;
    this._posDragStartY=0;
    this._posResizeStartX=0;
    this._posResizeStartY=0;
    this._posResizeStartSize=0;

    this._resizeCtrlIsHover = -1;
    this._areaIsHover = false;
    this._resizeCtrlIsDragging = -1;
    this._areaIsDragging = false;
  };

  CropAreaSquare.prototype = new CropArea();

  CropAreaSquare.prototype._calcSquareCorners=function() {
    var hSize=this._size/2;
    return [
      [this._x-hSize, this._y-hSize],
      [this._x+hSize, this._y-hSize],
      [this._x-hSize, this._y+hSize],
      [this._x+hSize, this._y+hSize]
    ];
  };

  CropAreaSquare.prototype._calcSquareDimensions=function() {
    var hSize=this._size/2;
    return {
      left: this._x-hSize,
      top: this._y-hSize,
      right: this._x+hSize,
      bottom: this._y+hSize
    };
  };

  CropAreaSquare.prototype._isCoordWithinArea=function(coord) {
    var squareDimensions=this._calcSquareDimensions();
    return (coord[0]>=squareDimensions.left&&coord[0]<=squareDimensions.right&&coord[1]>=squareDimensions.top&&coord[1]<=squareDimensions.bottom);
  };

  CropAreaSquare.prototype._isCoordWithinResizeCtrl=function(coord) {
    var resizeIconsCenterCoords=this._calcSquareCorners();
    var res=-1;
    for(var i=0,len=resizeIconsCenterCoords.length;i<len;i++) {
      var resizeIconCenterCoords=resizeIconsCenterCoords[i];
      if(coord[0] > resizeIconCenterCoords[0] - this._resizeCtrlHoverRadius && coord[0] < resizeIconCenterCoords[0] + this._resizeCtrlHoverRadius &&
         coord[1] > resizeIconCenterCoords[1] - this._resizeCtrlHoverRadius && coord[1] < resizeIconCenterCoords[1] + this._resizeCtrlHoverRadius) {
        res=i;
        break;
      }
    }
    return res;
  };

  CropAreaSquare.prototype._drawArea=function(ctx,centerCoords,size){
    var hSize=size/2;
    ctx.rect(centerCoords[0]-hSize,centerCoords[1]-hSize,size,size);
  };

  CropAreaSquare.prototype.draw=function() {
    CropArea.prototype.draw.apply(this, arguments);

    // draw move icon
    this._cropCanvas.drawIconMove([this._x,this._y], this._areaIsHover?this._iconMoveHoverRatio:this._iconMoveNormalRatio);

    // draw resize cubes
    var resizeIconsCenterCoords=this._calcSquareCorners();
    for(var i=0,len=resizeIconsCenterCoords.length;i<len;i++) {
      var resizeIconCenterCoords=resizeIconsCenterCoords[i];
      this._cropCanvas.drawIconResizeCircle(resizeIconCenterCoords, this._resizeCtrlBaseRadius, this._resizeCtrlIsHover===i?this._resizeCtrlHoverRatio:this._resizeCtrlNormalRatio);
    }
  };

  CropAreaSquare.prototype.processMouseMove=function(mouseCurX, mouseCurY) {
    var cursor='default';
    var res=false;

    this._resizeCtrlIsHover = -1;
    this._areaIsHover = false;

    if (this._areaIsDragging) {
      this._x = mouseCurX - this._posDragStartX;
      this._y = mouseCurY - this._posDragStartY;
      this._areaIsHover = true;
      cursor='move';
      res=true;
      this._events.trigger('area-move');
    } else if (this._resizeCtrlIsDragging>-1) {
      var xMulti, yMulti;
      switch(this._resizeCtrlIsDragging) {
        case 0: // Top Left
          xMulti=-1;
          yMulti=-1;
          cursor = 'nwse-resize';
          break;
        case 1: // Top Right
          xMulti=1;
          yMulti=-1;
          cursor = 'nesw-resize';
          break;
        case 2: // Bottom Left
          xMulti=-1;
          yMulti=1;
          cursor = 'nesw-resize';
          break;
        case 3: // Bottom Right
          xMulti=1;
          yMulti=1;
          cursor = 'nwse-resize';
          break;
      }
      var iFX = (mouseCurX - this._posResizeStartX)*xMulti;
      var iFY = (mouseCurY - this._posResizeStartY)*yMulti;
      var iFR;
      if(iFX>iFY) {
        iFR = this._posResizeStartSize + iFY;
      } else {
        iFR = this._posResizeStartSize + iFX;
      }
      var wasSize=this._size;
      this._size = Math.max(this._minSize, iFR);
      var posModifier=(this._size-wasSize)/2;
      this._x+=posModifier*xMulti;
      this._y+=posModifier*yMulti;
      this._resizeCtrlIsHover = this._resizeCtrlIsDragging;
      res=true;
      this._events.trigger('area-resize');
    } else {
      var hoveredResizeBox=this._isCoordWithinResizeCtrl([mouseCurX,mouseCurY]);
      if (hoveredResizeBox>-1) {
        switch(hoveredResizeBox) {
          case 0:
            cursor = 'nwse-resize';
            break;
          case 1:
            cursor = 'nesw-resize';
            break;
          case 2:
            cursor = 'nesw-resize';
            break;
          case 3:
            cursor = 'nwse-resize';
            break;
        }
        this._areaIsHover = false;
        this._resizeCtrlIsHover = hoveredResizeBox;
        res=true;
      } else if(this._isCoordWithinArea([mouseCurX,mouseCurY])) {
        cursor = 'move';
        this._areaIsHover = true;
        res=true;
      }
    }

    this._dontDragOutside();
    angular.element(this._ctx.canvas).css({'cursor': cursor});

    return res;
  };

  CropAreaSquare.prototype.processMouseDown=function(mouseDownX, mouseDownY) {
    var isWithinResizeCtrl=this._isCoordWithinResizeCtrl([mouseDownX,mouseDownY]);
    if (isWithinResizeCtrl>-1) {
      this._areaIsDragging = false;
      this._areaIsHover = false;
      this._resizeCtrlIsDragging = isWithinResizeCtrl;
      this._resizeCtrlIsHover = isWithinResizeCtrl;
      this._posResizeStartX=mouseDownX;
      this._posResizeStartY=mouseDownY;
      this._posResizeStartSize = this._size;
      this._events.trigger('area-resize-start');
    } else if (this._isCoordWithinArea([mouseDownX,mouseDownY])) {
      this._areaIsDragging = true;
      this._areaIsHover = true;
      this._resizeCtrlIsDragging = -1;
      this._resizeCtrlIsHover = -1;
      this._posDragStartX = mouseDownX - this._x;
      this._posDragStartY = mouseDownY - this._y;
      this._events.trigger('area-move-start');
    }
  };

  CropAreaSquare.prototype.processMouseUp=function(/*mouseUpX, mouseUpY*/) {
    if(this._areaIsDragging) {
      this._areaIsDragging = false;
      this._events.trigger('area-move-end');
    }
    if(this._resizeCtrlIsDragging>-1) {
      this._resizeCtrlIsDragging = -1;
      this._events.trigger('area-resize-end');
    }
    this._areaIsHover = false;
    this._resizeCtrlIsHover = -1;

    this._posDragStartX = 0;
    this._posDragStartY = 0;
  };

  return CropAreaSquare;
}]);

crop.factory('cropArea', ['cropCanvas', function(CropCanvas) {
  var CropArea = function(ctx, events) {
    this._ctx=ctx;
    this._events=events;

    this._minSize=80;

    this._cropCanvas=new CropCanvas(ctx);

    this._image=new Image();
    this._x = 0;
    this._y = 0;
    this._size = 200;
  };

  /* GETTERS/SETTERS */

  CropArea.prototype.getImage = function () {
    return this._image;
  };
  CropArea.prototype.setImage = function (image) {
    this._image = image;
  };

  CropArea.prototype.getX = function () {
    return this._x;
  };
  CropArea.prototype.setX = function (x) {
    this._x = x;
    this._dontDragOutside();
  };

  CropArea.prototype.getY = function () {
    return this._y;
  };
  CropArea.prototype.setY = function (y) {
    this._y = y;
    this._dontDragOutside();
  };

  CropArea.prototype.getSize = function () {
    return this._size;
  };
  CropArea.prototype.setSize = function (size) {
    this._size = Math.max(this._minSize, size);
    this._dontDragOutside();
  };

  CropArea.prototype.getMinSize = function () {
    return this._minSize;
  };
  CropArea.prototype.setMinSize = function (size) {
    this._minSize = size;
    this._size = Math.max(this._minSize, this._size);
    this._dontDragOutside();
  };

  /* FUNCTIONS */
  CropArea.prototype._dontDragOutside=function() {
    var h=this._ctx.canvas.height,
        w=this._ctx.canvas.width;
    if(this._size>w) { this._size=w; }
    if(this._size>h) { this._size=h; }
    if(this._x<this._size/2) { this._x=this._size/2; }
    if(this._x>w-this._size/2) { this._x=w-this._size/2; }
    if(this._y<this._size/2) { this._y=this._size/2; }
    if(this._y>h-this._size/2) { this._y=h-this._size/2; }
  };

  CropArea.prototype._drawArea=function() {};

  CropArea.prototype.draw=function() {
    // draw crop area
    this._cropCanvas.drawCropArea(this._image,[this._x,this._y],this._size,this._drawArea);
  };

  CropArea.prototype.processMouseMove=function() {};

  CropArea.prototype.processMouseDown=function() {};

  CropArea.prototype.processMouseUp=function() {};

  return CropArea;
}]);

crop.factory('cropCanvas', [function() {
  // Shape = Array of [x,y]; [0, 0] - center
  var shapeArrowNW=[[-0.5,-2],[-3,-4.5],[-0.5,-7],[-7,-7],[-7,-0.5],[-4.5,-3],[-2,-0.5]];
  var shapeArrowNE=[[0.5,-2],[3,-4.5],[0.5,-7],[7,-7],[7,-0.5],[4.5,-3],[2,-0.5]];
  var shapeArrowSW=[[-0.5,2],[-3,4.5],[-0.5,7],[-7,7],[-7,0.5],[-4.5,3],[-2,0.5]];
  var shapeArrowSE=[[0.5,2],[3,4.5],[0.5,7],[7,7],[7,0.5],[4.5,3],[2,0.5]];
  var shapeArrowN=[[-1.5,-2.5],[-1.5,-6],[-5,-6],[0,-11],[5,-6],[1.5,-6],[1.5,-2.5]];
  var shapeArrowW=[[-2.5,-1.5],[-6,-1.5],[-6,-5],[-11,0],[-6,5],[-6,1.5],[-2.5,1.5]];
  var shapeArrowS=[[-1.5,2.5],[-1.5,6],[-5,6],[0,11],[5,6],[1.5,6],[1.5,2.5]];
  var shapeArrowE=[[2.5,-1.5],[6,-1.5],[6,-5],[11,0],[6,5],[6,1.5],[2.5,1.5]];

  // Colors
  var colors={
    areaOutline: '#fff',
    resizeBoxStroke: '#fff',
    resizeBoxFill: '#444',
    resizeBoxArrowFill: '#fff',
    resizeCircleStroke: '#fff',
    resizeCircleFill: '#444',
    moveIconFill: '#fff'
  };

  return function(ctx){

    /* Base functions */

    // Calculate Point
    var calcPoint=function(point,offset,scale) {
        return [scale*point[0]+offset[0], scale*point[1]+offset[1]];
    };

    // Draw Filled Polygon
    var drawFilledPolygon=function(shape,fillStyle,centerCoords,scale) {
        ctx.save();
        ctx.fillStyle = fillStyle;
        ctx.beginPath();
        var pc, pc0=calcPoint(shape[0],centerCoords,scale);
        ctx.moveTo(pc0[0],pc0[1]);

        for(var p in shape) {
            if (p > 0) {
                pc=calcPoint(shape[p],centerCoords,scale);
                ctx.lineTo(pc[0],pc[1]);
            }
        }

        ctx.lineTo(pc0[0],pc0[1]);
        ctx.fill();
        ctx.closePath();
        ctx.restore();
    };

    /* Icons */

    this.drawIconMove=function(centerCoords, scale) {
      drawFilledPolygon(shapeArrowN, colors.moveIconFill, centerCoords, scale);
      drawFilledPolygon(shapeArrowW, colors.moveIconFill, centerCoords, scale);
      drawFilledPolygon(shapeArrowS, colors.moveIconFill, centerCoords, scale);
      drawFilledPolygon(shapeArrowE, colors.moveIconFill, centerCoords, scale);
    };

    this.drawIconResizeCircle=function(centerCoords, circleRadius, scale) {
      var scaledCircleRadius=circleRadius*scale;
      ctx.save();
      ctx.strokeStyle = colors.resizeCircleStroke;
      ctx.lineWidth = 2;
      ctx.fillStyle = colors.resizeCircleFill;
      ctx.beginPath();
      ctx.arc(centerCoords[0],centerCoords[1],scaledCircleRadius,0,2*Math.PI);
      ctx.fill();
      ctx.stroke();
      ctx.closePath();
      ctx.restore();
    };

    this.drawIconResizeBoxBase=function(centerCoords, boxSize, scale) {
      var scaledBoxSize=boxSize*scale;
      ctx.save();
      ctx.strokeStyle = colors.resizeBoxStroke;
      ctx.lineWidth = 2;
      ctx.fillStyle = colors.resizeBoxFill;
      ctx.fillRect(centerCoords[0] - scaledBoxSize/2, centerCoords[1] - scaledBoxSize/2, scaledBoxSize, scaledBoxSize);
      ctx.strokeRect(centerCoords[0] - scaledBoxSize/2, centerCoords[1] - scaledBoxSize/2, scaledBoxSize, scaledBoxSize);
      ctx.restore();
    };
    this.drawIconResizeBoxNESW=function(centerCoords, boxSize, scale) {
      this.drawIconResizeBoxBase(centerCoords, boxSize, scale);
      drawFilledPolygon(shapeArrowNE, colors.resizeBoxArrowFill, centerCoords, scale);
      drawFilledPolygon(shapeArrowSW, colors.resizeBoxArrowFill, centerCoords, scale);
    };
    this.drawIconResizeBoxNWSE=function(centerCoords, boxSize, scale) {
      this.drawIconResizeBoxBase(centerCoords, boxSize, scale);
      drawFilledPolygon(shapeArrowNW, colors.resizeBoxArrowFill, centerCoords, scale);
      drawFilledPolygon(shapeArrowSE, colors.resizeBoxArrowFill, centerCoords, scale);
    };

    /* Crop Area */

    this.drawCropArea=function(image, centerCoords, size, fnDrawClipPath) {
      var xRatio=image.width/ctx.canvas.width,
          yRatio=image.height/ctx.canvas.height,
          xLeft=centerCoords[0]-size/2,
          yTop=centerCoords[1]-size/2;

      ctx.save();
      ctx.strokeStyle = colors.areaOutline;
      ctx.lineWidth = 2;
      ctx.beginPath();
      fnDrawClipPath(ctx, centerCoords, size);
      ctx.stroke();
      ctx.clip();

      // draw part of original image
      if (size > 0) {
          ctx.drawImage(image, xLeft*xRatio, yTop*yRatio, size*xRatio, size*yRatio, xLeft, yTop, size, size);
      }

      ctx.beginPath();
      fnDrawClipPath(ctx, centerCoords, size);
      ctx.stroke();
      ctx.clip();

      ctx.restore();
    };

  };
}]);

/**
 * EXIF service is based on the exif-js library (https://github.com/jseidelin/exif-js)
 */

crop.service('cropEXIF', [function() {
  var debug = false;

  var ExifTags = this.Tags = {

      // version tags
      0x9000 : "ExifVersion",             // EXIF version
      0xA000 : "FlashpixVersion",         // Flashpix format version

      // colorspace tags
      0xA001 : "ColorSpace",              // Color space information tag

      // image configuration
      0xA002 : "PixelXDimension",         // Valid width of meaningful image
      0xA003 : "PixelYDimension",         // Valid height of meaningful image
      0x9101 : "ComponentsConfiguration", // Information about channels
      0x9102 : "CompressedBitsPerPixel",  // Compressed bits per pixel

      // user information
      0x927C : "MakerNote",               // Any desired information written by the manufacturer
      0x9286 : "UserComment",             // Comments by user

      // related file
      0xA004 : "RelatedSoundFile",        // Name of related sound file

      // date and time
      0x9003 : "DateTimeOriginal",        // Date and time when the original image was generated
      0x9004 : "DateTimeDigitized",       // Date and time when the image was stored digitally
      0x9290 : "SubsecTime",              // Fractions of seconds for DateTime
      0x9291 : "SubsecTimeOriginal",      // Fractions of seconds for DateTimeOriginal
      0x9292 : "SubsecTimeDigitized",     // Fractions of seconds for DateTimeDigitized

      // picture-taking conditions
      0x829A : "ExposureTime",            // Exposure time (in seconds)
      0x829D : "FNumber",                 // F number
      0x8822 : "ExposureProgram",         // Exposure program
      0x8824 : "SpectralSensitivity",     // Spectral sensitivity
      0x8827 : "ISOSpeedRatings",         // ISO speed rating
      0x8828 : "OECF",                    // Optoelectric conversion factor
      0x9201 : "ShutterSpeedValue",       // Shutter speed
      0x9202 : "ApertureValue",           // Lens aperture
      0x9203 : "BrightnessValue",         // Value of brightness
      0x9204 : "ExposureBias",            // Exposure bias
      0x9205 : "MaxApertureValue",        // Smallest F number of lens
      0x9206 : "SubjectDistance",         // Distance to subject in meters
      0x9207 : "MeteringMode",            // Metering mode
      0x9208 : "LightSource",             // Kind of light source
      0x9209 : "Flash",                   // Flash status
      0x9214 : "SubjectArea",             // Location and area of main subject
      0x920A : "FocalLength",             // Focal length of the lens in mm
      0xA20B : "FlashEnergy",             // Strobe energy in BCPS
      0xA20C : "SpatialFrequencyResponse",    //
      0xA20E : "FocalPlaneXResolution",   // Number of pixels in width direction per FocalPlaneResolutionUnit
      0xA20F : "FocalPlaneYResolution",   // Number of pixels in height direction per FocalPlaneResolutionUnit
      0xA210 : "FocalPlaneResolutionUnit",    // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
      0xA214 : "SubjectLocation",         // Location of subject in image
      0xA215 : "ExposureIndex",           // Exposure index selected on camera
      0xA217 : "SensingMethod",           // Image sensor type
      0xA300 : "FileSource",              // Image source (3 == DSC)
      0xA301 : "SceneType",               // Scene type (1 == directly photographed)
      0xA302 : "CFAPattern",              // Color filter array geometric pattern
      0xA401 : "CustomRendered",          // Special processing
      0xA402 : "ExposureMode",            // Exposure mode
      0xA403 : "WhiteBalance",            // 1 = auto white balance, 2 = manual
      0xA404 : "DigitalZoomRation",       // Digital zoom ratio
      0xA405 : "FocalLengthIn35mmFilm",   // Equivalent foacl length assuming 35mm film camera (in mm)
      0xA406 : "SceneCaptureType",        // Type of scene
      0xA407 : "GainControl",             // Degree of overall image gain adjustment
      0xA408 : "Contrast",                // Direction of contrast processing applied by camera
      0xA409 : "Saturation",              // Direction of saturation processing applied by camera
      0xA40A : "Sharpness",               // Direction of sharpness processing applied by camera
      0xA40B : "DeviceSettingDescription",    //
      0xA40C : "SubjectDistanceRange",    // Distance to subject

      // other tags
      0xA005 : "InteroperabilityIFDPointer",
      0xA420 : "ImageUniqueID"            // Identifier assigned uniquely to each image
  };

  var TiffTags = this.TiffTags = {
      0x0100 : "ImageWidth",
      0x0101 : "ImageHeight",
      0x8769 : "ExifIFDPointer",
      0x8825 : "GPSInfoIFDPointer",
      0xA005 : "InteroperabilityIFDPointer",
      0x0102 : "BitsPerSample",
      0x0103 : "Compression",
      0x0106 : "PhotometricInterpretation",
      0x0112 : "Orientation",
      0x0115 : "SamplesPerPixel",
      0x011C : "PlanarConfiguration",
      0x0212 : "YCbCrSubSampling",
      0x0213 : "YCbCrPositioning",
      0x011A : "XResolution",
      0x011B : "YResolution",
      0x0128 : "ResolutionUnit",
      0x0111 : "StripOffsets",
      0x0116 : "RowsPerStrip",
      0x0117 : "StripByteCounts",
      0x0201 : "JPEGInterchangeFormat",
      0x0202 : "JPEGInterchangeFormatLength",
      0x012D : "TransferFunction",
      0x013E : "WhitePoint",
      0x013F : "PrimaryChromaticities",
      0x0211 : "YCbCrCoefficients",
      0x0214 : "ReferenceBlackWhite",
      0x0132 : "DateTime",
      0x010E : "ImageDescription",
      0x010F : "Make",
      0x0110 : "Model",
      0x0131 : "Software",
      0x013B : "Artist",
      0x8298 : "Copyright"
  };

  var GPSTags = this.GPSTags = {
      0x0000 : "GPSVersionID",
      0x0001 : "GPSLatitudeRef",
      0x0002 : "GPSLatitude",
      0x0003 : "GPSLongitudeRef",
      0x0004 : "GPSLongitude",
      0x0005 : "GPSAltitudeRef",
      0x0006 : "GPSAltitude",
      0x0007 : "GPSTimeStamp",
      0x0008 : "GPSSatellites",
      0x0009 : "GPSStatus",
      0x000A : "GPSMeasureMode",
      0x000B : "GPSDOP",
      0x000C : "GPSSpeedRef",
      0x000D : "GPSSpeed",
      0x000E : "GPSTrackRef",
      0x000F : "GPSTrack",
      0x0010 : "GPSImgDirectionRef",
      0x0011 : "GPSImgDirection",
      0x0012 : "GPSMapDatum",
      0x0013 : "GPSDestLatitudeRef",
      0x0014 : "GPSDestLatitude",
      0x0015 : "GPSDestLongitudeRef",
      0x0016 : "GPSDestLongitude",
      0x0017 : "GPSDestBearingRef",
      0x0018 : "GPSDestBearing",
      0x0019 : "GPSDestDistanceRef",
      0x001A : "GPSDestDistance",
      0x001B : "GPSProcessingMethod",
      0x001C : "GPSAreaInformation",
      0x001D : "GPSDateStamp",
      0x001E : "GPSDifferential"
  };

  var StringValues = this.StringValues = {
      ExposureProgram : {
          0 : "Not defined",
          1 : "Manual",
          2 : "Normal program",
          3 : "Aperture priority",
          4 : "Shutter priority",
          5 : "Creative program",
          6 : "Action program",
          7 : "Portrait mode",
          8 : "Landscape mode"
      },
      MeteringMode : {
          0 : "Unknown",
          1 : "Average",
          2 : "CenterWeightedAverage",
          3 : "Spot",
          4 : "MultiSpot",
          5 : "Pattern",
          6 : "Partial",
          255 : "Other"
      },
      LightSource : {
          0 : "Unknown",
          1 : "Daylight",
          2 : "Fluorescent",
          3 : "Tungsten (incandescent light)",
          4 : "Flash",
          9 : "Fine weather",
          10 : "Cloudy weather",
          11 : "Shade",
          12 : "Daylight fluorescent (D 5700 - 7100K)",
          13 : "Day white fluorescent (N 4600 - 5400K)",
          14 : "Cool white fluorescent (W 3900 - 4500K)",
          15 : "White fluorescent (WW 3200 - 3700K)",
          17 : "Standard light A",
          18 : "Standard light B",
          19 : "Standard light C",
          20 : "D55",
          21 : "D65",
          22 : "D75",
          23 : "D50",
          24 : "ISO studio tungsten",
          255 : "Other"
      },
      Flash : {
          0x0000 : "Flash did not fire",
          0x0001 : "Flash fired",
          0x0005 : "Strobe return light not detected",
          0x0007 : "Strobe return light detected",
          0x0009 : "Flash fired, compulsory flash mode",
          0x000D : "Flash fired, compulsory flash mode, return light not detected",
          0x000F : "Flash fired, compulsory flash mode, return light detected",
          0x0010 : "Flash did not fire, compulsory flash mode",
          0x0018 : "Flash did not fire, auto mode",
          0x0019 : "Flash fired, auto mode",
          0x001D : "Flash fired, auto mode, return light not detected",
          0x001F : "Flash fired, auto mode, return light detected",
          0x0020 : "No flash function",
          0x0041 : "Flash fired, red-eye reduction mode",
          0x0045 : "Flash fired, red-eye reduction mode, return light not detected",
          0x0047 : "Flash fired, red-eye reduction mode, return light detected",
          0x0049 : "Flash fired, compulsory flash mode, red-eye reduction mode",
          0x004D : "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
          0x004F : "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
          0x0059 : "Flash fired, auto mode, red-eye reduction mode",
          0x005D : "Flash fired, auto mode, return light not detected, red-eye reduction mode",
          0x005F : "Flash fired, auto mode, return light detected, red-eye reduction mode"
      },
      SensingMethod : {
          1 : "Not defined",
          2 : "One-chip color area sensor",
          3 : "Two-chip color area sensor",
          4 : "Three-chip color area sensor",
          5 : "Color sequential area sensor",
          7 : "Trilinear sensor",
          8 : "Color sequential linear sensor"
      },
      SceneCaptureType : {
          0 : "Standard",
          1 : "Landscape",
          2 : "Portrait",
          3 : "Night scene"
      },
      SceneType : {
          1 : "Directly photographed"
      },
      CustomRendered : {
          0 : "Normal process",
          1 : "Custom process"
      },
      WhiteBalance : {
          0 : "Auto white balance",
          1 : "Manual white balance"
      },
      GainControl : {
          0 : "None",
          1 : "Low gain up",
          2 : "High gain up",
          3 : "Low gain down",
          4 : "High gain down"
      },
      Contrast : {
          0 : "Normal",
          1 : "Soft",
          2 : "Hard"
      },
      Saturation : {
          0 : "Normal",
          1 : "Low saturation",
          2 : "High saturation"
      },
      Sharpness : {
          0 : "Normal",
          1 : "Soft",
          2 : "Hard"
      },
      SubjectDistanceRange : {
          0 : "Unknown",
          1 : "Macro",
          2 : "Close view",
          3 : "Distant view"
      },
      FileSource : {
          3 : "DSC"
      },

      Components : {
          0 : "",
          1 : "Y",
          2 : "Cb",
          3 : "Cr",
          4 : "R",
          5 : "G",
          6 : "B"
      }
  };

  function addEvent(element, event, handler) {
      if (element.addEventListener) {
          element.addEventListener(event, handler, false);
      } else if (element.attachEvent) {
          element.attachEvent("on" + event, handler);
      }
  }

  function imageHasData(img) {
      return !!(img.exifdata);
  }

  function base64ToArrayBuffer(base64, contentType) {
      contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
      base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
      var binary = atob(base64);
      var len = binary.length;
      var buffer = new ArrayBuffer(len);
      var view = new Uint8Array(buffer);
      for (var i = 0; i < len; i++) {
          view[i] = binary.charCodeAt(i);
      }
      return buffer;
  }

  function objectURLToBlob(url, callback) {
      var http = new XMLHttpRequest();
      http.open("GET", url, true);
      http.responseType = "blob";
      http.onload = function(e) {
          if (this.status == 200 || this.status === 0) {
              callback(this.response);
          }
      };
      http.send();
  }

  function getImageData(img, callback) {
      function handleBinaryFile(binFile) {
          var data = findEXIFinJPEG(binFile);
          var iptcdata = findIPTCinJPEG(binFile);
          img.exifdata = data || {};
          img.iptcdata = iptcdata || {};
          if (callback) {
              callback.call(img);
          }
      }

      if (img.src) {
          if (/^data\:/i.test(img.src)) { // Data URI
              var arrayBuffer = base64ToArrayBuffer(img.src);
              handleBinaryFile(arrayBuffer);

          } else if (/^blob\:/i.test(img.src)) { // Object URL
              var fileReader = new FileReader();
              fileReader.onload = function(e) {
                  handleBinaryFile(e.target.result);
              };
              objectURLToBlob(img.src, function (blob) {
                  fileReader.readAsArrayBuffer(blob);
              });
          } else {
              var http = new XMLHttpRequest();
              http.onload = function() {
                  if (this.status == 200 || this.status === 0) {
                      handleBinaryFile(http.response);
                  } else {
                      throw "Could not load image";
                  }
                  http = null;
              };
              http.open("GET", img.src, true);
              http.responseType = "arraybuffer";
              http.send(null);
          }
      } else if (window.FileReader && (img instanceof window.Blob || img instanceof window.File)) {
          var fileReader = new FileReader();
          fileReader.onload = function(e) {
              if (debug) console.log("Got file of length " + e.target.result.byteLength);
              handleBinaryFile(e.target.result);
          };

          fileReader.readAsArrayBuffer(img);
      }
  }

  function findEXIFinJPEG(file) {
      var dataView = new DataView(file);

      if (debug) console.log("Got file of length " + file.byteLength);
      if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
          if (debug) console.log("Not a valid JPEG");
          return false; // not a valid jpeg
      }

      var offset = 2,
          length = file.byteLength,
          marker;

      while (offset < length) {
          if (dataView.getUint8(offset) != 0xFF) {
              if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
              return false; // not a valid marker, something is wrong
          }

          marker = dataView.getUint8(offset + 1);
          if (debug) console.log(marker);

          // we could implement handling for other markers here,
          // but we're only looking for 0xFFE1 for EXIF data

          if (marker == 225) {
              if (debug) console.log("Found 0xFFE1 marker");

              return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);

              // offset += 2 + file.getShortAt(offset+2, true);

          } else {
              offset += 2 + dataView.getUint16(offset+2);
          }

      }

  }

  function findIPTCinJPEG(file) {
      var dataView = new DataView(file);

      if (debug) console.log("Got file of length " + file.byteLength);
      if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
          if (debug) console.log("Not a valid JPEG");
          return false; // not a valid jpeg
      }

      var offset = 2,
          length = file.byteLength;

      var isFieldSegmentStart = function(dataView, offset){
          return (
              dataView.getUint8(offset) === 0x38 &&
              dataView.getUint8(offset+1) === 0x42 &&
              dataView.getUint8(offset+2) === 0x49 &&
              dataView.getUint8(offset+3) === 0x4D &&
              dataView.getUint8(offset+4) === 0x04 &&
              dataView.getUint8(offset+5) === 0x04
          );
      };

      while (offset < length) {

          if ( isFieldSegmentStart(dataView, offset )){

              // Get the length of the name header (which is padded to an even number of bytes)
              var nameHeaderLength = dataView.getUint8(offset+7);
              if(nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
              // Check for pre photoshop 6 format
              if(nameHeaderLength === 0) {
                  // Always 4
                  nameHeaderLength = 4;
              }

              var startOffset = offset + 8 + nameHeaderLength;
              var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);

              return readIPTCData(file, startOffset, sectionLength);

              break;

          }

          // Not the marker, continue searching
          offset++;

      }

  }
  var IptcFieldMap = {
      0x78 : 'caption',
      0x6E : 'credit',
      0x19 : 'keywords',
      0x37 : 'dateCreated',
      0x50 : 'byline',
      0x55 : 'bylineTitle',
      0x7A : 'captionWriter',
      0x69 : 'headline',
      0x74 : 'copyright',
      0x0F : 'category'
  };
  function readIPTCData(file, startOffset, sectionLength){
      var dataView = new DataView(file);
      var data = {};
      var fieldValue, fieldName, dataSize, segmentType, segmentSize;
      var segmentStartPos = startOffset;
      while(segmentStartPos < startOffset+sectionLength) {
          if(dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos+1) === 0x02){
              segmentType = dataView.getUint8(segmentStartPos+2);
              if(segmentType in IptcFieldMap) {
                  dataSize = dataView.getInt16(segmentStartPos+3);
                  segmentSize = dataSize + 5;
                  fieldName = IptcFieldMap[segmentType];
                  fieldValue = getStringFromDB(dataView, segmentStartPos+5, dataSize);
                  // Check if we already stored a value with this name
                  if(data.hasOwnProperty(fieldName)) {
                      // Value already stored with this name, create multivalue field
                      if(data[fieldName] instanceof Array) {
                          data[fieldName].push(fieldValue);
                      }
                      else {
                          data[fieldName] = [data[fieldName], fieldValue];
                      }
                  }
                  else {
                      data[fieldName] = fieldValue;
                  }
              }

          }
          segmentStartPos++;
      }
      return data;
  }

  function readTags(file, tiffStart, dirStart, strings, bigEnd) {
      var entries = file.getUint16(dirStart, !bigEnd),
          tags = {},
          entryOffset, tag,
          i;

      for (i=0;i<entries;i++) {
          entryOffset = dirStart + i*12 + 2;
          tag = strings[file.getUint16(entryOffset, !bigEnd)];
          if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
          tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
      }
      return tags;
  }

  function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
      var type = file.getUint16(entryOffset+2, !bigEnd),
          numValues = file.getUint32(entryOffset+4, !bigEnd),
          valueOffset = file.getUint32(entryOffset+8, !bigEnd) + tiffStart,
          offset,
          vals, val, n,
          numerator, denominator;

      switch (type) {
          case 1: // byte, 8-bit unsigned int
          case 7: // undefined, 8-bit byte, value depending on field
              if (numValues == 1) {
                  return file.getUint8(entryOffset + 8, !bigEnd);
              } else {
                  offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                  vals = [];
                  for (n=0;n<numValues;n++) {
                      vals[n] = file.getUint8(offset + n);
                  }
                  return vals;
              }

          case 2: // ascii, 8-bit byte
              offset = numValues > 4 ? valueOffset : (entryOffset + 8);
              return getStringFromDB(file, offset, numValues-1);

          case 3: // short, 16 bit int
              if (numValues == 1) {
                  return file.getUint16(entryOffset + 8, !bigEnd);
              } else {
                  offset = numValues > 2 ? valueOffset : (entryOffset + 8);
                  vals = [];
                  for (n=0;n<numValues;n++) {
                      vals[n] = file.getUint16(offset + 2*n, !bigEnd);
                  }
                  return vals;
              }

          case 4: // long, 32 bit int
              if (numValues == 1) {
                  return file.getUint32(entryOffset + 8, !bigEnd);
              } else {
                  vals = [];
                  for (n=0;n<numValues;n++) {
                      vals[n] = file.getUint32(valueOffset + 4*n, !bigEnd);
                  }
                  return vals;
              }

          case 5:    // rational = two long values, first is numerator, second is denominator
              if (numValues == 1) {
                  numerator = file.getUint32(valueOffset, !bigEnd);
                  denominator = file.getUint32(valueOffset+4, !bigEnd);
                  val = new Number(numerator / denominator);
                  val.numerator = numerator;
                  val.denominator = denominator;
                  return val;
              } else {
                  vals = [];
                  for (n=0;n<numValues;n++) {
                      numerator = file.getUint32(valueOffset + 8*n, !bigEnd);
                      denominator = file.getUint32(valueOffset+4 + 8*n, !bigEnd);
                      vals[n] = new Number(numerator / denominator);
                      vals[n].numerator = numerator;
                      vals[n].denominator = denominator;
                  }
                  return vals;
              }

          case 9: // slong, 32 bit signed int
              if (numValues == 1) {
                  return file.getInt32(entryOffset + 8, !bigEnd);
              } else {
                  vals = [];
                  for (n=0;n<numValues;n++) {
                      vals[n] = file.getInt32(valueOffset + 4*n, !bigEnd);
                  }
                  return vals;
              }

          case 10: // signed rational, two slongs, first is numerator, second is denominator
              if (numValues == 1) {
                  return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset+4, !bigEnd);
              } else {
                  vals = [];
                  for (n=0;n<numValues;n++) {
                      vals[n] = file.getInt32(valueOffset + 8*n, !bigEnd) / file.getInt32(valueOffset+4 + 8*n, !bigEnd);
                  }
                  return vals;
              }
      }
  }

  function getStringFromDB(buffer, start, length) {
      var outstr = "";
      for (var n = start; n < start+length; n++) {
          outstr += String.fromCharCode(buffer.getUint8(n));
      }
      return outstr;
  }

  function readEXIFData(file, start) {
      if (getStringFromDB(file, start, 4) != "Exif") {
          if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
          return false;
      }

      var bigEnd,
          tags, tag,
          exifData, gpsData,
          tiffOffset = start + 6;

      // test for TIFF validity and endianness
      if (file.getUint16(tiffOffset) == 0x4949) {
          bigEnd = false;
      } else if (file.getUint16(tiffOffset) == 0x4D4D) {
          bigEnd = true;
      } else {
          if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
          return false;
      }

      if (file.getUint16(tiffOffset+2, !bigEnd) != 0x002A) {
          if (debug) console.log("Not valid TIFF data! (no 0x002A)");
          return false;
      }

      var firstIFDOffset = file.getUint32(tiffOffset+4, !bigEnd);

      if (firstIFDOffset < 0x00000008) {
          if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset+4, !bigEnd));
          return false;
      }

      tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);

      if (tags.ExifIFDPointer) {
          exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
          for (tag in exifData) {
              switch (tag) {
                  case "LightSource" :
                  case "Flash" :
                  case "MeteringMode" :
                  case "ExposureProgram" :
                  case "SensingMethod" :
                  case "SceneCaptureType" :
                  case "SceneType" :
                  case "CustomRendered" :
                  case "WhiteBalance" :
                  case "GainControl" :
                  case "Contrast" :
                  case "Saturation" :
                  case "Sharpness" :
                  case "SubjectDistanceRange" :
                  case "FileSource" :
                      exifData[tag] = StringValues[tag][exifData[tag]];
                      break;

                  case "ExifVersion" :
                  case "FlashpixVersion" :
                      exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                      break;

                  case "ComponentsConfiguration" :
                      exifData[tag] =
                          StringValues.Components[exifData[tag][0]] +
                          StringValues.Components[exifData[tag][1]] +
                          StringValues.Components[exifData[tag][2]] +
                          StringValues.Components[exifData[tag][3]];
                      break;
              }
              tags[tag] = exifData[tag];
          }
      }

      if (tags.GPSInfoIFDPointer) {
          gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
          for (tag in gpsData) {
              switch (tag) {
                  case "GPSVersionID" :
                      gpsData[tag] = gpsData[tag][0] +
                          "." + gpsData[tag][1] +
                          "." + gpsData[tag][2] +
                          "." + gpsData[tag][3];
                      break;
              }
              tags[tag] = gpsData[tag];
          }
      }

      return tags;
  }

  this.getData = function(img, callback) {
      if ((img instanceof Image || img instanceof HTMLImageElement) && !img.complete) return false;

      if (!imageHasData(img)) {
          getImageData(img, callback);
      } else {
          if (callback) {
              callback.call(img);
          }
      }
      return true;
  }

  this.getTag = function(img, tag) {
      if (!imageHasData(img)) return;
      return img.exifdata[tag];
  }

  this.getAllTags = function(img) {
      if (!imageHasData(img)) return {};
      var a,
          data = img.exifdata,
          tags = {};
      for (a in data) {
          if (data.hasOwnProperty(a)) {
              tags[a] = data[a];
          }
      }
      return tags;
  }

  this.pretty = function(img) {
      if (!imageHasData(img)) return "";
      var a,
          data = img.exifdata,
          strPretty = "";
      for (a in data) {
          if (data.hasOwnProperty(a)) {
              if (typeof data[a] == "object") {
                  if (data[a] instanceof Number) {
                      strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
                  } else {
                      strPretty += a + " : [" + data[a].length + " values]\r\n";
                  }
              } else {
                  strPretty += a + " : " + data[a] + "\r\n";
              }
          }
      }
      return strPretty;
  }

  this.readFromBinaryFile = function(file) {
      return findEXIFinJPEG(file);
  }
}]);

crop.factory('cropHost', ['$document', 'cropAreaCircle', 'cropAreaSquare', 'cropEXIF', function($document, CropAreaCircle, CropAreaSquare, cropEXIF) {
  /* STATIC FUNCTIONS */

  // Get Element's Offset
  var getElementOffset=function(elem) {
      var box = elem.getBoundingClientRect();

      var body = document.body;
      var docElem = document.documentElement;

      var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
      var scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;

      var clientTop = docElem.clientTop || body.clientTop || 0;
      var clientLeft = docElem.clientLeft || body.clientLeft || 0;

      var top  = box.top +  scrollTop - clientTop;
      var left = box.left + scrollLeft - clientLeft;

      return { top: Math.round(top), left: Math.round(left) };
  };

  return function(elCanvas, opts, events){
    /* PRIVATE VARIABLES */

    // Object Pointers
    var ctx=null,
        image=null,
        theArea=null;

    // Dimensions
    var minCanvasDims=[100,100],
        maxCanvasDims=[300,300];

    // Result Image size
    var resImgSize=200;

    // Result Image type
    var resImgFormat='image/png';

    // Result Image quality
    var resImgQuality=null;

    /* PRIVATE FUNCTIONS */

    // Draw Scene
    function drawScene() {
      // clear canvas
      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

      if(image!==null) {
        // draw source image
        ctx.drawImage(image, 0, 0, ctx.canvas.width, ctx.canvas.height);

        ctx.save();

        // and make it darker
        ctx.fillStyle = 'rgba(0, 0, 0, 0.65)';
        ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

        ctx.restore();

        // draw Area
        theArea.draw();
      }
    }

    // Resets CropHost
    var resetCropHost=function() {
      if(image!==null) {
        theArea.setImage(image);
        var imageDims=[image.width, image.height],
            imageRatio=image.width/image.height,
            canvasDims=imageDims;

        if(canvasDims[0]>maxCanvasDims[0]) {
          canvasDims[0]=maxCanvasDims[0];
          canvasDims[1]=canvasDims[0]/imageRatio;
        } else if(canvasDims[0]<minCanvasDims[0]) {
          canvasDims[0]=minCanvasDims[0];
          canvasDims[1]=canvasDims[0]/imageRatio;
        }
        if(canvasDims[1]>maxCanvasDims[1]) {
          canvasDims[1]=maxCanvasDims[1];
          canvasDims[0]=canvasDims[1]*imageRatio;
        } else if(canvasDims[1]<minCanvasDims[1]) {
          canvasDims[1]=minCanvasDims[1];
          canvasDims[0]=canvasDims[1]*imageRatio;
        }
        elCanvas.prop('width',canvasDims[0]).prop('height',canvasDims[1]).css({'margin-left': -canvasDims[0]/2+'px', 'margin-top': -canvasDims[1]/2+'px'});

        theArea.setX(ctx.canvas.width/2);
        theArea.setY(ctx.canvas.height/2);
        theArea.setSize(Math.min(200, ctx.canvas.width/2, ctx.canvas.height/2));
      } else {
        elCanvas.prop('width',0).prop('height',0).css({'margin-top': 0});
      }

      drawScene();
    };

    /**
     * Returns event.changedTouches directly if event is a TouchEvent.
     * If event is a jQuery event, return changedTouches of event.originalEvent
     */
    var getChangedTouches=function(event){
      if(angular.isDefined(event.changedTouches)){
        return event.changedTouches;
      }else{
        return event.originalEvent.changedTouches;
      }
    };

    var onMouseMove=function(e) {
      if(image!==null) {
        var offset=getElementOffset(ctx.canvas),
            pageX, pageY;
        if(e.type === 'touchmove') {
          pageX=getChangedTouches(e)[0].pageX;
          pageY=getChangedTouches(e)[0].pageY;
        } else {
          pageX=e.pageX;
          pageY=e.pageY;
        }
        theArea.processMouseMove(pageX-offset.left, pageY-offset.top);
        drawScene();
      }
    };

    var onMouseDown=function(e) {
      e.preventDefault();
      e.stopPropagation();
      if(image!==null) {
        var offset=getElementOffset(ctx.canvas),
            pageX, pageY;
        if(e.type === 'touchstart') {
          pageX=getChangedTouches(e)[0].pageX;
          pageY=getChangedTouches(e)[0].pageY;
        } else {
          pageX=e.pageX;
          pageY=e.pageY;
        }
        theArea.processMouseDown(pageX-offset.left, pageY-offset.top);
        drawScene();
      }
    };

    var onMouseUp=function(e) {
      if(image!==null) {
        var offset=getElementOffset(ctx.canvas),
            pageX, pageY;
        if(e.type === 'touchend') {
          pageX=getChangedTouches(e)[0].pageX;
          pageY=getChangedTouches(e)[0].pageY;
        } else {
          pageX=e.pageX;
          pageY=e.pageY;
        }
        theArea.processMouseUp(pageX-offset.left, pageY-offset.top);
        drawScene();
      }
    };

    this.getResultImageDataURI=function() {
      var temp_ctx, temp_canvas;
      temp_canvas = angular.element('<canvas></canvas>')[0];
      temp_ctx = temp_canvas.getContext('2d');
      temp_canvas.width = resImgSize;
      temp_canvas.height = resImgSize;
      if(image!==null){
        temp_ctx.drawImage(image, (theArea.getX()-theArea.getSize()/2)*(image.width/ctx.canvas.width), (theArea.getY()-theArea.getSize()/2)*(image.height/ctx.canvas.height), theArea.getSize()*(image.width/ctx.canvas.width), theArea.getSize()*(image.height/ctx.canvas.height), 0, 0, resImgSize, resImgSize);
      }
      if (resImgQuality!==null ){
        return temp_canvas.toDataURL(resImgFormat, resImgQuality);
      }
      return temp_canvas.toDataURL(resImgFormat);
    };

    this.setNewImageSource=function(imageSource) {
      image=null;
      resetCropHost();
      events.trigger('image-updated');
      if(!!imageSource) {
        var newImage = new Image();
        if(imageSource.substring(0,4).toLowerCase()==='http') {
          newImage.crossOrigin = 'anonymous';
        }
        newImage.onload = function(){
          events.trigger('load-done');

          cropEXIF.getData(newImage,function(){
            var orientation=cropEXIF.getTag(newImage,'Orientation');

            if([3,6,8].indexOf(orientation)>-1) {
              var canvas = document.createElement("canvas"),
                  ctx=canvas.getContext("2d"),
                  cw = newImage.width, ch = newImage.height, cx = 0, cy = 0, deg=0;
              switch(orientation) {
                case 3:
                  cx=-newImage.width;
                  cy=-newImage.height;
                  deg=180;
                  break;
                case 6:
                  cw = newImage.height;
                  ch = newImage.width;
                  cy=-newImage.height;
                  deg=90;
                  break;
                case 8:
                  cw = newImage.height;
                  ch = newImage.width;
                  cx=-newImage.width;
                  deg=270;
                  break;
              }

              canvas.width = cw;
              canvas.height = ch;
              ctx.rotate(deg*Math.PI/180);
              ctx.drawImage(newImage, cx, cy);

              image=new Image();
              image.src = canvas.toDataURL("image/png");
            } else {
              image=newImage;
            }
            resetCropHost();
            events.trigger('image-updated');
          });
        };
        newImage.onerror=function() {
          events.trigger('load-error');
        };
        events.trigger('load-start');
        newImage.src=imageSource;
      }
    };

    this.setMaxDimensions=function(width, height) {
      maxCanvasDims=[width,height];

      if(image!==null) {
        var curWidth=ctx.canvas.width,
            curHeight=ctx.canvas.height;

        var imageDims=[image.width, image.height],
            imageRatio=image.width/image.height,
            canvasDims=imageDims;

        if(canvasDims[0]>maxCanvasDims[0]) {
          canvasDims[0]=maxCanvasDims[0];
          canvasDims[1]=canvasDims[0]/imageRatio;
        } else if(canvasDims[0]<minCanvasDims[0]) {
          canvasDims[0]=minCanvasDims[0];
          canvasDims[1]=canvasDims[0]/imageRatio;
        }
        if(canvasDims[1]>maxCanvasDims[1]) {
          canvasDims[1]=maxCanvasDims[1];
          canvasDims[0]=canvasDims[1]*imageRatio;
        } else if(canvasDims[1]<minCanvasDims[1]) {
          canvasDims[1]=minCanvasDims[1];
          canvasDims[0]=canvasDims[1]*imageRatio;
        }
        elCanvas.prop('width',canvasDims[0]).prop('height',canvasDims[1]).css({'margin-left': -canvasDims[0]/2+'px', 'margin-top': -canvasDims[1]/2+'px'});

        var ratioNewCurWidth=ctx.canvas.width/curWidth,
            ratioNewCurHeight=ctx.canvas.height/curHeight,
            ratioMin=Math.min(ratioNewCurWidth, ratioNewCurHeight);

        theArea.setX(theArea.getX()*ratioNewCurWidth);
        theArea.setY(theArea.getY()*ratioNewCurHeight);
        theArea.setSize(theArea.getSize()*ratioMin);
      } else {
        elCanvas.prop('width',0).prop('height',0).css({'margin-top': 0});
      }

      drawScene();

    };

    this.setAreaMinSize=function(size) {
      size=parseInt(size,10);
      if(!isNaN(size)) {
        theArea.setMinSize(size);
        drawScene();
      }
    };

    this.setResultImageSize=function(size) {
      size=parseInt(size,10);
      if(!isNaN(size)) {
        resImgSize=size;
      }
    };

    this.setResultImageFormat=function(format) {
      resImgFormat = format;
    };

    this.setResultImageQuality=function(quality){
      quality = parseFloat(quality);
      if (!isNaN(quality) && quality>=0 && quality<=1){
        resImgQuality = quality;
      }
    };

    this.setAreaType=function(type) {
      var curSize=theArea.getSize(),
          curMinSize=theArea.getMinSize(),
          curX=theArea.getX(),
          curY=theArea.getY();

      var AreaClass=CropAreaCircle;
      if(type==='square') {
        AreaClass=CropAreaSquare;
      }
      theArea = new AreaClass(ctx, events);
      theArea.setMinSize(curMinSize);
      theArea.setSize(curSize);
      theArea.setX(curX);
      theArea.setY(curY);

      // resetCropHost();
      if(image!==null) {
        theArea.setImage(image);
      }

      drawScene();
    };

    /* Life Cycle begins */

    // Init Context var
    ctx = elCanvas[0].getContext('2d');

    // Init CropArea
    theArea = new CropAreaCircle(ctx, events);

    // Init Mouse Event Listeners
    $document.on('mousemove',onMouseMove);
    elCanvas.on('mousedown',onMouseDown);
    $document.on('mouseup',onMouseUp);

    // Init Touch Event Listeners
    $document.on('touchmove',onMouseMove);
    elCanvas.on('touchstart',onMouseDown);
    $document.on('touchend',onMouseUp);

    // CropHost Destructor
    this.destroy=function() {
      $document.off('mousemove',onMouseMove);
      elCanvas.off('mousedown',onMouseDown);
      $document.off('mouseup',onMouseMove);

      $document.off('touchmove',onMouseMove);
      elCanvas.off('touchstart',onMouseDown);
      $document.off('touchend',onMouseMove);

      elCanvas.remove();
    };
  };

}]);


crop.factory('cropPubSub', [function() {
  return function() {
    var events = {};
    // Subscribe
    this.on = function(names, handler) {
      names.split(' ').forEach(function(name) {
        if (!events[name]) {
          events[name] = [];
        }
        events[name].push(handler);
      });
      return this;
    };
    // Publish
    this.trigger = function(name, args) {
      angular.forEach(events[name], function(handler) {
        handler.call(null, args);
      });
      return this;
    };
  };
}]);

crop.directive('imgCrop', ['$timeout', 'cropHost', 'cropPubSub', function($timeout, CropHost, CropPubSub) {
  return {
    restrict: 'E',
    scope: {
      image: '=',
      resultImage: '=',

      changeOnFly: '=',
      areaType: '@',
      areaMinSize: '=',
      resultImageSize: '=',
      resultImageFormat: '@',
      resultImageQuality: '=',

      onChange: '&',
      onLoadBegin: '&',
      onLoadDone: '&',
      onLoadError: '&'
    },
    template: '<canvas></canvas>',
    controller: ['$scope', function($scope) {
      $scope.events = new CropPubSub();
    }],
    link: function(scope, element/*, attrs*/) {
      // Init Events Manager
      var events = scope.events;

      // Init Crop Host
      var cropHost=new CropHost(element.find('canvas'), {}, events);

      // Store Result Image to check if it's changed
      var storedResultImage;

      var updateResultImage=function(scope) {
        var resultImage=cropHost.getResultImageDataURI();
        if(storedResultImage!==resultImage) {
          storedResultImage=resultImage;
          if(angular.isDefined(scope.resultImage)) {
            scope.resultImage=resultImage;
          }
          scope.onChange({$dataURI: scope.resultImage});
        }
      };

      // Wrapper to safely exec functions within $apply on a running $digest cycle
      var fnSafeApply=function(fn) {
        return function(){
          $timeout(function(){
            scope.$apply(function(scope){
              fn(scope);
            });
          });
        };
      };

      // Setup CropHost Event Handlers
      events
        .on('load-start', fnSafeApply(function(scope){
          scope.onLoadBegin({});
        }))
        .on('load-done', fnSafeApply(function(scope){
          scope.onLoadDone({});
        }))
        .on('load-error', fnSafeApply(function(scope){
          scope.onLoadError({});
        }))
        .on('area-move area-resize', fnSafeApply(function(scope){
          if(!!scope.changeOnFly) {
            updateResultImage(scope);
          }
        }))
        .on('area-move-end area-resize-end image-updated', fnSafeApply(function(scope){
          updateResultImage(scope);
        }));

      // Sync CropHost with Directive's options
      scope.$watch('image',function(){
        cropHost.setNewImageSource(scope.image);
      });
      scope.$watch('areaType',function(){
        cropHost.setAreaType(scope.areaType);
        updateResultImage(scope);
      });
      scope.$watch('areaMinSize',function(){
        cropHost.setAreaMinSize(scope.areaMinSize);
        updateResultImage(scope);
      });
      scope.$watch('resultImageSize',function(){
        cropHost.setResultImageSize(scope.resultImageSize);
        updateResultImage(scope);
      });
      scope.$watch('resultImageFormat',function(){
        cropHost.setResultImageFormat(scope.resultImageFormat);
        updateResultImage(scope);
      });
      scope.$watch('resultImageQuality',function(){
        cropHost.setResultImageQuality(scope.resultImageQuality);
        updateResultImage(scope);
      });

      // Update CropHost dimensions when the directive element is resized
      scope.$watch(
        function () {
          return [element[0].clientWidth, element[0].clientHeight];
        },
        function (value) {
          cropHost.setMaxDimensions(value[0],value[1]);
          updateResultImage(scope);
        },
        true
      );

      // Destroy CropHost Instance when the directive is destroying
      scope.$on('$destroy', function(){
          cropHost.destroy();
      });
    }
  };
}]);
}());
(function (angular) {
    'use strict';
    var app = angular.module('bluemoon.analytics', ['angulartics']);
})(window.angular);;/* globals TRAAC */
(function (angular) {
    'use strict';
    angular.module('bluemoon.analytics').provider('bluemoonAnalytics',
        ['$analyticsProvider', function ProvideAnalytics($analyticsProvider) {
            var isDataGoingToProd = false;
            var head = angular.element(document.getElementsByTagName('head')[0]);

            return ({
                sendAnalyticsToProd: sendAnalyticsToProd,
                loadTRAACLibrary: loadTRAACLibrary,
                configAngulartics: configureAngulartics,
                $get: instantiateAnalytics
            });

            //Public function asscessible during config cycle
            function sendAnalyticsToProd(newValue, callback) {
                isDataGoingToProd = newValue;
                var configObj = {
                    'version': '0.2.1',
                    'adapters': [
                        {
                            'type': 'Http',
                            'config': {
                                'url': 'https://collector-product-insight.thomsonreuters.com/v1/data',
                                'flush_period': 60000,
                                'headers': {
                                    'X-PRODUCT-INSIGHTS-TOKEN': 'd6PkzZ2pIRi3dANyr7IWORQcEww1qnSW'
                                } //dev-onvio-client Product Insight Project ID
                            }
                        }
                    ]
                };

                if (!isDataGoingToProd) {
                    //dev-bluemoon-client Product Insight Project ID
                    configObj
                        .adapters[0]
                        .config
                        .headers['X-PRODUCT-INSIGHTS-TOKEN'] = 'd6PkzZ2pIRi3dANyr7IWORQcEww1qnSW';
                }
                else {
                    //bluemoon-client Product Insight Project ID
                    configObj
                        .adapters[0]
                        .config
                        .headers['X-PRODUCT-INSIGHTS-TOKEN'] = 'vIVU3MIibpvd7DRjQGpdhSrRypYC66K1';
                }

                //Set the global object for the TRAAC JavaScript Library Config
                window.TRAAC_CONFIG = configObj;

                if (typeof callback === 'function' && callback()) {
                    callback();
                }
            }

            function loadTRAACLibrary(callback) {
                if (!window.TRAAC_CONFIG) {
                    console.error('Missing TRAAC config');
                }

                window.TRAAC = {
                    track: function (event) {
                        TRAAC_CONFIG.teq.push(event);
                    },
                    registerOnce: function (kvp) {
                        TRAAC_CONFIG.teq.push({
                            'method': 'registerOnce',
                            'p1': kvp
                        });
                    },
                    register: function (kvp) {
                        TRAAC_CONFIG.teq.push({
                            'method': 'register',
                            'p1': kvp
                        });
                    },
                    setUser: function (uid) {
                        TRAAC_CONFIG.teq.push({
                            'method': 'setUser',
                            'p1': uid
                        });
                    },
                    clearUser: function () {
                        TRAAC_CONFIG.teq.push({
                            'method': 'clearUser'
                        });
                    },
                    deRegister: function (key) {
                        TRAAC_CONFIG.teq.push({
                            'method': 'deRegister',
                            'p1': key
                        });
                    },
                    flush: function (callback, timeout) {
                        TRAAC_CONFIG.teq.push({
                            'method': 'flush',
                            'p1': callback,
                            'p2': timeout
                        });
                    }
                };

                window.TRAAC_CONFIG.teq = [];
                if (typeof callback === 'function' && callback()) {
                    callback();
                }
            }

            function configureAngulartics() {
                $analyticsProvider.registerSetUsername(function (userId) {
                    TRAAC.setUser(userId);
                });
                $analyticsProvider.registerSetSuperPropertiesOnce(function (properties) {
                    TRAAC.registerOnce(properties);
                });
                $analyticsProvider.registerSetSuperProperties(function (properties) {
                    TRAAC.register(properties);
                });
                $analyticsProvider.registerPageTrack(function (path, extraInfo) {
                    TRAAC.track(function () {
                        var metaD = breakupURL(path);
                        var event = TRAAC.keyValue('Page View', metaD);
                        return event.build();
                    });
                });
                $analyticsProvider.registerEventTrack(function (action, properties) {
                    TRAAC.track(function () {
                        var event = TRAAC.keyValue(action, properties);
                        return event.build();
                    });
                });

                function breakupURL(path) {
                    var tempParts = [];
                    var urlParts = path.split('/');
                    var urlData = {
                        page: '',
                        additionalPath: [],
                        urlParams: []
                    };

                    if (urlParts[0] === '' && urlParts[1] === '') { urlData.page = '/'; }
                    else {
                        for (var i = 1; i < urlParts.length; i++) {
                            if (urlParts[i].indexOf('?') === -1) {
                                if (i === 1) {
                                    urlData.page = urlParts[i];
                                }
                                else {
                                    urlData.additionalPath.push(urlParts[i]);
                                }
                            }
                            else {
                                if (i === 1) {
                                    tempParts = urlParts[i].split('?');
                                    if (typeof tempParts[0] !== 'undefined') { urlData.page = tempParts[0]; }
                                    if (typeof tempParts[1] !== 'undefined') {
                                        urlData.urlParams = tempParts[1].split('&');
                                    }
                                }
                                else {
                                    tempParts = urlParts[i].split('?');
                                    if (typeof tempParts[0] !== 'undefined') {
                                        urlData.additionalPath.push(tempParts[0]);
                                    }
                                    if (typeof tempParts[1] !== 'undefined') {
                                        urlData.urlParams = tempParts[1].split('&');
                                    }
                                }
                            }
                        }

                        urlData.additionalPath = urlData.additionalPath.join('/');
                    }
                    return urlData;
                }
            }

            //Provider Constructor -- defines whats available at app start
            function instantiateAnalytics() {
                return ({
                    sendDataToProdBucket: sendDataToProdBucket
                });

                //public function accessible at app start
                function sendDataToProdBucket(goingToProdBucket) {
                    isDataGoingToProd = goingToProdBucket;
                    if (!isDataGoingToProd) {
                        //dev-onvio-client Product Insight Project ID
                        window.TRAAC_CONFIG
                            .adapters[0]
                            .config
                            .headers['X-PRODUCT-INSIGHTS-TOKEN'] = 'OoPaJN9o9LiMIRIKQSUrU0pXeJA31jD6';
                    }
                    else {
                        //onvio-client Product Insight Project ID
                        window.TRAAC_CONFIG
                            .adapters[0]
                            .config
                            .headers['X-PRODUCT-INSIGHTS-TOKEN'] = 'kLDrdWPlNAzvKzMxTfbzaRjer333D2Lr';
                    }
                }
            }
        }]);
})(window.angular);
(function (window) {
    var TRAACcoreIntervalID = setInterval(function () {
        if (typeof window.TRAAC_CONFIG !== 'undefined') {
            clearInterval(TRAACcoreIntervalID);
            (function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["HttpAdapter"] = factory();
	else
		root["HttpAdapter"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var _superagent = __webpack_require__(1);

	var _superagent2 = _interopRequireDefault(_superagent);

	var HttpProvider = (function () {
		function HttpProvider(config) {
			_classCallCheck(this, HttpProvider);

			if (!config.url) {
				console.error('No HTTP end point supplied the HTTP Provider');
			}

			this.config = config;
			this.setFlushPeriod(config.flush_period);
			this.name = 'http';
			this.errorCount = 0;
			this.eventQueue = [];

			this.setEventTimeout();
		}

		_createClass(HttpProvider, [{
			key: 'setFlushPeriod',
			value: function setFlushPeriod(flush_period) {
				if (flush_period === undefined) {
					this.FLUSH_PERIOD = 1000 * 5;
				} else {
					this.FLUSH_PERIOD = flush_period;
				}
				this.async = this.FLUSH_PERIOD > 0;
			}
		}, {
			key: 'setEventTimeout',
			value: function setEventTimeout() {
				var _this = this;

				//If 5 consecutive errors, then set timeout to 1 minute to avoid unnecessary http traffic
				if (this.errorCount > 4) {
					console.log('setting timeout to 15 seconds to avoid unnecessary traffic');
					this.setFlushPeriod(15000);
				}

				if (this.async) {
					setTimeout(function () {
						_this.flushQueue();
					}, this.FLUSH_PERIOD);
				}
			}
		}, {
			key: 'flush',
			value: function flush() {
				this.flushQueue();
			}
		}, {
			key: 'track',
			value: function track(event, eventCBQueue) {
				var _this2 = this;

				//Copy the event object as up until now its stored as a reference
				var eventCopy = JSON.parse(JSON.stringify(event));
				this.processEvent(eventCopy);

				console.log('Queuing event "' + eventCopy['event-external-name'] + '" for eventual sending to HTTP end point ' + this.config.url + ' with data: ', eventCopy);

				eventCBQueue[event['event-id'] + '-http'] = new Promise(function (resolve) {

					_this2.eventQueue.push({
						event: eventCopy,
						callback: function callback() {
							resolve();
							delete eventCBQueue[event['event-id'] + '-http'];
						}
					});

					if (!_this2.async) {
						_this2.flushQueue();
					}
				});
			}
		}, {
			key: 'processEvent',
			value: function processEvent(event) {

				if (event.metadata) {

					for (var k = 0; k < event.metadata.length; k++) {
						//Strip out any ga_ keys
						if (event.metadata[k].key.indexOf('ga_') >= 0) {
							delete event.metadata[k];
						}
					}
				}

				delete event.tmpMetaData;
			}
		}, {
			key: 'flushQueue',
			value: function flushQueue() {
				var _this3 = this;

				if (this.eventQueue.length === 0) {
					this.setEventTimeout();
					return;
				}

				// Take local copy of current queue
				var localEventQueue = this.eventQueue;

				// then empty the main queue in case app pushes any more while we're servicing the REST call
				this.eventQueue = [];

				//Flatten for sending (remove the callbacks)
				var eventsToSend = [];
				for (var i = 0; i < localEventQueue.length; i++) {
					eventsToSend.push(localEventQueue[i].event);
				}

				var flushRequest = _superagent2['default'].post(this.config.url);

				if (this.config.headers) {
					for (var key in this.config.headers) {
						flushRequest.set(key, this.config.headers[key]);
					}
				}

				flushRequest.send(eventsToSend).withCredentials().end(function (error, response) {
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;

					try {

						for (var _iterator = localEventQueue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var _event = _step.value;

							_event.callback();
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator['return']) {
								_iterator['return']();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}

					if (error) {
						_this3.errorCount++;
						// On error, prepend eventsToSend back to the start of the eventQueue
						_this3.eventQueue = localEventQueue.concat(_this3.eventQueue);
						console.error("Couldn't POST " + eventsToSend.length + " events to " + _this3.config.url + ". Retrying shortly. Error: " + error);
						if (!_this3.async) {
							setTimeout(function () {
								_this3.flushQueue();
							}, 2000);
						}
					} else {
						_this3.errorCount = 0;
						_this3.setFlushPeriod(_this3.config.flush_period);
						console.log(eventsToSend.length + " events flushed to: " + _this3.config.url);
					}

					_this3.setEventTimeout();
				});
			}
		}]);

		return HttpProvider;
	})();

	exports['default'] = HttpProvider;
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */

	var Emitter = __webpack_require__(2);
	var reduce = __webpack_require__(3);
	var requestBase = __webpack_require__(4);
	var isObject = __webpack_require__(5);

	/**
	 * Root reference for iframes.
	 */

	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  root = this;
	}

	/**
	 * Noop.
	 */

	function noop(){};

	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */

	function isHost(obj) {
	  var str = {}.toString.call(obj);

	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}

	/**
	 * Expose `request`.
	 */

	var request = module.exports = __webpack_require__(6).bind(null, Request);

	/**
	 * Determine XHR.
	 */

	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  return false;
	};

	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */

	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */

	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    if (null != obj[key]) {
	      pushEncodedKeyValuePair(pairs, key, obj[key]);
	        }
	      }
	  return pairs.join('&');
	}

	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */

	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (Array.isArray(val)) {
	    return val.forEach(function(v) {
	      pushEncodedKeyValuePair(pairs, key, v);
	    });
	  }
	  pairs.push(encodeURIComponent(key)
	    + '=' + encodeURIComponent(val));
	}

	/**
	 * Expose serialization method.
	 */

	 request.serializeObject = serialize;

	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */

	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var parts;
	  var pair;

	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    parts = pair.split('=');
	    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
	  }

	  return obj;
	}

	/**
	 * Expose parser.
	 */

	request.parseString = parseString;

	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */

	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};

	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */

	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };

	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */

	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};

	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */

	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;

	  lines.pop(); // trailing CRLF

	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }

	  return fields;
	}

	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */

	function isJSON(mime) {
	  return /[\/+]json\b/.test(mime);
	}

	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */

	function type(str){
	  return str.split(/ *; */).shift();
	};

	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */

	function params(str){
	  return reduce(str.split(/ *; */), function(obj, str){
	    var parts = str.split(/ *= */)
	      , key = parts.shift()
	      , val = parts.shift();

	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};

	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */

	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  this.setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this.setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this.parseBody(this.text ? this.text : this.xhr.response)
	    : null;
	}

	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */

	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};

	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */

	Response.prototype.setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);

	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};

	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */

	Response.prototype.parseBody = function(str){
	  var parse = request.parse[this.type];
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};

	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */

	Response.prototype.setStatusProperties = function(status){
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }

	  var type = status / 100 | 0;

	  // status / class
	  this.status = this.statusCode = status;
	  this.statusType = type;

	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;

	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};

	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */

	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;

	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;

	  return err;
	};

	/**
	 * Expose `Response`.
	 */

	request.Response = Response;

	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */

	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;

	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
	      // issue #876: return the http status code if the response parsing fails
	      err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
	      return self.callback(err);
	    }

	    self.emit('response', res);

	    if (err) {
	      return self.callback(err, res);
	    }

	    if (res.status >= 200 && res.status < 300) {
	      return self.callback(err, res);
	    }

	    var new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	    new_err.original = err;
	    new_err.response = res;
	    new_err.status = res.status;

	    self.callback(new_err, res);
	  });
	}

	/**
	 * Mixin `Emitter` and `requestBase`.
	 */

	Emitter(Request.prototype);
	for (var key in requestBase) {
	  Request.prototype[key] = requestBase[key];
	}

	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */

	Request.prototype.abort = function(){
	  if (this.aborted) return;
	  this.aborted = true;
	  this.xhr.abort();
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};

	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};

	/**
	 * Set responseType to `val`. Presently valid responseTypes are 'blob' and 
	 * 'arraybuffer'.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};

	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};

	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.auth = function(user, pass, options){
	  if (!options) {
	    options = {
	      type: 'basic'
	    }
	  }

	  switch (options.type) {
	    case 'basic':
	      var str = btoa(user + ':' + pass);
	      this.set('Authorization', 'Basic ' + str);
	    break;

	    case 'auto':
	      this.username = user;
	      this.password = pass;
	    break;
	  }
	  return this;
	};

	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/

	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};

	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.attach = function(field, file, filename){
	  this._getFormData().append(field, file, filename || file.name);
	  return this;
	};

	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};

	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	  *      request.post('/user')
	  *        .send('name=tobi')
	  *        .send('species=ferret')
	  *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.send = function(data){
	  var obj = isObject(data);
	  var type = this._header['content-type'];

	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }

	  if (!obj || isHost(data)) return this;
	  if (!type) this.type('json');
	  return this;
	};

	/**
	 * @deprecated
	 */
	Response.prototype.parse = function serialize(fn){
	  if (root.console) {
	    console.warn("Client-side parse() method has been renamed to serialize(). This method is not compatible with superagent v2.0");
	  }
	  this.serialize(fn);
	  return this;
	};

	Response.prototype.serialize = function serialize(fn){
	  this._parser = fn;
	  return this;
	};

	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */

	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  fn(err, res);
	};

	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */

	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;

	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;

	  this.callback(err);
	};

	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */

	Request.prototype.timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};

	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */

	Request.prototype.withCredentials = function(){
	  this._withCredentials = true;
	  return this;
	};

	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */

	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var query = this._query.join('&');
	  var timeout = this._timeout;
	  var data = this._formData || this._data;

	  // store callback
	  this._callback = fn || noop;

	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;

	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }

	    if (0 == status) {
	      if (self.timedout) return self.timeoutError();
	      if (self.aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };

	  // progress
	  var handleProgress = function(e){
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = 'download';
	    self.emit('progress', e);
	  };
	  if (this.hasListeners('progress')) {
	    xhr.onprogress = handleProgress;
	  }
	  try {
	    if (xhr.upload && this.hasListeners('progress')) {
	      xhr.upload.onprogress = handleProgress;
	    }
	  } catch(e) {
	    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	    // Reported here:
	    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	  }

	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.timedout = true;
	      self.abort();
	    }, timeout);
	  }

	  // querystring
	  if (query) {
	    query = request.serializeObject(query);
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }

	  // initiate request
	  if (this.username && this.password) {
	    xhr.open(this.method, this.url, true, this.username, this.password);
	  } else {
	    xhr.open(this.method, this.url, true);
	  }

	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;

	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._parser || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
	    if (serialize) data = serialize(data);
	  }

	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }

	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }

	  // send stuff
	  this.emit('request', this);

	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};


	/**
	 * Expose `Request`.
	 */

	request.Request = Request;

	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */

	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};

	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */

	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};

	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */

	function del(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};

	request['del'] = del;
	request['delete'] = del;

	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */

	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};

	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */

	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};

	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */

	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */

	if (true) {
	  module.exports = Emitter;
	}

	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */

	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};

	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */

	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}

	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};

	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }

	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};

	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};

	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }

	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;

	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }

	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};

	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */

	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];

	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }

	  return this;
	};

	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */

	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};

	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */

	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 3 */
/***/ function(module, exports) {

	
	/**
	 * Reduce `arr` with `fn`.
	 *
	 * @param {Array} arr
	 * @param {Function} fn
	 * @param {Mixed} initial
	 *
	 * TODO: combatible error handling?
	 */

	module.exports = function(arr, fn, initial){  
	  var idx = 0;
	  var len = arr.length;
	  var curr = arguments.length == 3
	    ? initial
	    : arr[idx++];

	  while (idx < len) {
	    curr = fn.call(null, curr, arr[idx], ++idx, arr);
	  }
	  
	  return curr;
	};

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(5);

	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */

	exports.clearTimeout = function _clearTimeout(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};

	/**
	 * Force given parser
	 *
	 * Sets the body parser no matter type.
	 *
	 * @param {Function}
	 * @api public
	 */

	exports.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};

	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */

	exports.timeout = function timeout(ms){
	  this._timeout = ms;
	  return this;
	};

	/**
	 * Faux promise support
	 *
	 * @param {Function} fulfill
	 * @param {Function} reject
	 * @return {Request}
	 */

	exports.then = function then(fulfill, reject) {
	  return this.end(function(err, res) {
	    err ? reject(err) : fulfill(res);
	  });
	}

	/**
	 * Allow for extension
	 */

	exports.use = function use(fn) {
	  fn(this);
	  return this;
	}


	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */

	exports.get = function(field){
	  return this._header[field.toLowerCase()];
	};

	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */

	exports.getHeader = exports.get;

	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */

	exports.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};

	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	exports.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};

	/**
	 * Write the field `name` and `val` for "multipart/form-data"
	 * request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	exports.field = function(name, val) {
	  this._getFormData().append(name, val);
	  return this;
	};


/***/ },
/* 5 */
/***/ function(module, exports) {

	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */

	function isObject(obj) {
	  return null != obj && 'object' == typeof obj;
	}

	module.exports = isObject;


/***/ },
/* 6 */
/***/ function(module, exports) {

	// The node and browser modules expose versions of this with the
	// appropriate constructor function bound as first argument
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */

	function request(RequestConstructor, method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new RequestConstructor('GET', method).end(url);
	  }

	  // url first
	  if (2 == arguments.length) {
	    return new RequestConstructor('GET', method);
	  }

	  return new RequestConstructor(method, url);
	}

	module.exports = request;


/***/ }
/******/ ])
});
;(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(298);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";

	__webpack_require__(2);

	__webpack_require__(293);

	__webpack_require__(295);

	/* eslint max-len: 0 */

	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;

	// Should be removed in the next major release:

	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}

	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);

	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3);
	__webpack_require__(52);
	__webpack_require__(53);
	__webpack_require__(54);
	__webpack_require__(55);
	__webpack_require__(57);
	__webpack_require__(60);
	__webpack_require__(61);
	__webpack_require__(62);
	__webpack_require__(63);
	__webpack_require__(64);
	__webpack_require__(65);
	__webpack_require__(66);
	__webpack_require__(67);
	__webpack_require__(68);
	__webpack_require__(70);
	__webpack_require__(72);
	__webpack_require__(74);
	__webpack_require__(76);
	__webpack_require__(79);
	__webpack_require__(80);
	__webpack_require__(81);
	__webpack_require__(85);
	__webpack_require__(87);
	__webpack_require__(89);
	__webpack_require__(92);
	__webpack_require__(93);
	__webpack_require__(94);
	__webpack_require__(95);
	__webpack_require__(97);
	__webpack_require__(98);
	__webpack_require__(99);
	__webpack_require__(100);
	__webpack_require__(101);
	__webpack_require__(102);
	__webpack_require__(103);
	__webpack_require__(105);
	__webpack_require__(106);
	__webpack_require__(107);
	__webpack_require__(109);
	__webpack_require__(110);
	__webpack_require__(111);
	__webpack_require__(113);
	__webpack_require__(114);
	__webpack_require__(115);
	__webpack_require__(116);
	__webpack_require__(117);
	__webpack_require__(118);
	__webpack_require__(119);
	__webpack_require__(120);
	__webpack_require__(121);
	__webpack_require__(122);
	__webpack_require__(123);
	__webpack_require__(124);
	__webpack_require__(125);
	__webpack_require__(126);
	__webpack_require__(131);
	__webpack_require__(132);
	__webpack_require__(136);
	__webpack_require__(137);
	__webpack_require__(138);
	__webpack_require__(139);
	__webpack_require__(141);
	__webpack_require__(142);
	__webpack_require__(143);
	__webpack_require__(144);
	__webpack_require__(145);
	__webpack_require__(146);
	__webpack_require__(147);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(150);
	__webpack_require__(151);
	__webpack_require__(152);
	__webpack_require__(153);
	__webpack_require__(154);
	__webpack_require__(155);
	__webpack_require__(156);
	__webpack_require__(157);
	__webpack_require__(159);
	__webpack_require__(160);
	__webpack_require__(166);
	__webpack_require__(167);
	__webpack_require__(169);
	__webpack_require__(170);
	__webpack_require__(171);
	__webpack_require__(175);
	__webpack_require__(176);
	__webpack_require__(177);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(181);
	__webpack_require__(182);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(187);
	__webpack_require__(189);
	__webpack_require__(190);
	__webpack_require__(191);
	__webpack_require__(193);
	__webpack_require__(195);
	__webpack_require__(197);
	__webpack_require__(198);
	__webpack_require__(199);
	__webpack_require__(201);
	__webpack_require__(202);
	__webpack_require__(203);
	__webpack_require__(204);
	__webpack_require__(211);
	__webpack_require__(214);
	__webpack_require__(215);
	__webpack_require__(217);
	__webpack_require__(218);
	__webpack_require__(221);
	__webpack_require__(222);
	__webpack_require__(224);
	__webpack_require__(225);
	__webpack_require__(226);
	__webpack_require__(227);
	__webpack_require__(228);
	__webpack_require__(229);
	__webpack_require__(230);
	__webpack_require__(231);
	__webpack_require__(232);
	__webpack_require__(233);
	__webpack_require__(234);
	__webpack_require__(235);
	__webpack_require__(236);
	__webpack_require__(237);
	__webpack_require__(238);
	__webpack_require__(239);
	__webpack_require__(240);
	__webpack_require__(241);
	__webpack_require__(242);
	__webpack_require__(244);
	__webpack_require__(245);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(251);
	__webpack_require__(252);
	__webpack_require__(253);
	__webpack_require__(254);
	__webpack_require__(255);
	__webpack_require__(256);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(260);
	__webpack_require__(261);
	__webpack_require__(263);
	__webpack_require__(264);
	__webpack_require__(265);
	__webpack_require__(266);
	__webpack_require__(269);
	__webpack_require__(270);
	__webpack_require__(271);
	__webpack_require__(272);
	__webpack_require__(273);
	__webpack_require__(274);
	__webpack_require__(275);
	__webpack_require__(276);
	__webpack_require__(278);
	__webpack_require__(279);
	__webpack_require__(280);
	__webpack_require__(281);
	__webpack_require__(282);
	__webpack_require__(283);
	__webpack_require__(284);
	__webpack_require__(285);
	__webpack_require__(286);
	__webpack_require__(287);
	__webpack_require__(288);
	__webpack_require__(291);
	__webpack_require__(292);
	module.exports = __webpack_require__(9);

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(4)
	  , has            = __webpack_require__(5)
	  , DESCRIPTORS    = __webpack_require__(6)
	  , $export        = __webpack_require__(8)
	  , redefine       = __webpack_require__(18)
	  , META           = __webpack_require__(22).KEY
	  , $fails         = __webpack_require__(7)
	  , shared         = __webpack_require__(23)
	  , setToStringTag = __webpack_require__(24)
	  , uid            = __webpack_require__(19)
	  , wks            = __webpack_require__(25)
	  , wksExt         = __webpack_require__(26)
	  , wksDefine      = __webpack_require__(27)
	  , keyOf          = __webpack_require__(29)
	  , enumKeys       = __webpack_require__(42)
	  , isArray        = __webpack_require__(45)
	  , anObject       = __webpack_require__(12)
	  , toIObject      = __webpack_require__(32)
	  , toPrimitive    = __webpack_require__(16)
	  , createDesc     = __webpack_require__(17)
	  , _create        = __webpack_require__(46)
	  , gOPNExt        = __webpack_require__(49)
	  , $GOPD          = __webpack_require__(51)
	  , $DP            = __webpack_require__(11)
	  , $keys          = __webpack_require__(30)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;

	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};

	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};

	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};

	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });

	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(50).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(44).f  = $propertyIsEnumerable;
	  __webpack_require__(43).f = $getOwnPropertySymbols;

	  if(DESCRIPTORS && !__webpack_require__(28)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }

	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}

	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});

	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});

	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});

	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(10)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 4 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 5 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(7)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(4)
	  , core      = __webpack_require__(9)
	  , hide      = __webpack_require__(10)
	  , redefine  = __webpack_require__(18)
	  , ctx       = __webpack_require__(20)
	  , PROTOTYPE = 'prototype';

	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 9 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(11)
	  , createDesc = __webpack_require__(17);
	module.exports = __webpack_require__(6) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(12)
	  , IE8_DOM_DEFINE = __webpack_require__(14)
	  , toPrimitive    = __webpack_require__(16)
	  , dP             = Object.defineProperty;

	exports.f = __webpack_require__(6) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(6) && !__webpack_require__(7)(function(){
	  return Object.defineProperty(__webpack_require__(15)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13)
	  , document = __webpack_require__(4).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(13);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 17 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(4)
	  , hide      = __webpack_require__(10)
	  , has       = __webpack_require__(5)
	  , SRC       = __webpack_require__(19)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);

	__webpack_require__(9).inspectSource = function(it){
	  return $toString.call(it);
	};

	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 19 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(21);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 21 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(19)('meta')
	  , isObject = __webpack_require__(13)
	  , has      = __webpack_require__(5)
	  , setDesc  = __webpack_require__(11).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(7)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(11).f
	  , has = __webpack_require__(5)
	  , TAG = __webpack_require__(25)('toStringTag');

	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(23)('wks')
	  , uid        = __webpack_require__(19)
	  , Symbol     = __webpack_require__(4).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';

	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};

	$exports.store = store;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(25);

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(4)
	  , core           = __webpack_require__(9)
	  , LIBRARY        = __webpack_require__(28)
	  , wksExt         = __webpack_require__(26)
	  , defineProperty = __webpack_require__(11).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports = false;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(30)
	  , toIObject = __webpack_require__(32);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(31)
	  , enumBugKeys = __webpack_require__(41);

	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(5)
	  , toIObject    = __webpack_require__(32)
	  , arrayIndexOf = __webpack_require__(36)(false)
	  , IE_PROTO     = __webpack_require__(40)('IE_PROTO');

	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(33)
	  , defined = __webpack_require__(35);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(34);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 34 */
/***/ function(module, exports) {

	var toString = {}.toString;

	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 35 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(32)
	  , toLength  = __webpack_require__(37)
	  , toIndex   = __webpack_require__(39);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(38)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 38 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(38)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(23)('keys')
	  , uid    = __webpack_require__(19);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 41 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(30)
	  , gOPS    = __webpack_require__(43)
	  , pIE     = __webpack_require__(44);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 43 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 44 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(34);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(12)
	  , dPs         = __webpack_require__(47)
	  , enumBugKeys = __webpack_require__(41)
	  , IE_PROTO    = __webpack_require__(40)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(15)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(48).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};

	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(11)
	  , anObject = __webpack_require__(12)
	  , getKeys  = __webpack_require__(30);

	module.exports = __webpack_require__(6) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4).document && document.documentElement;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(32)
	  , gOPN      = __webpack_require__(50).f
	  , toString  = {}.toString;

	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];

	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};

	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(31)
	  , hiddenKeys = __webpack_require__(41).concat('length', 'prototype');

	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(44)
	  , createDesc     = __webpack_require__(17)
	  , toIObject      = __webpack_require__(32)
	  , toPrimitive    = __webpack_require__(16)
	  , has            = __webpack_require__(5)
	  , IE8_DOM_DEFINE = __webpack_require__(14)
	  , gOPD           = Object.getOwnPropertyDescriptor;

	exports.f = __webpack_require__(6) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(46)});

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(6), 'Object', {defineProperty: __webpack_require__(11).f});

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(6), 'Object', {defineProperties: __webpack_require__(47)});

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(32)
	  , $getOwnPropertyDescriptor = __webpack_require__(51).f;

	__webpack_require__(56)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(8)
	  , core    = __webpack_require__(9)
	  , fails   = __webpack_require__(7);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(58)
	  , $getPrototypeOf = __webpack_require__(59);

	__webpack_require__(56)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(35);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(5)
	  , toObject    = __webpack_require__(58)
	  , IE_PROTO    = __webpack_require__(40)('IE_PROTO')
	  , ObjectProto = Object.prototype;

	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(58)
	  , $keys    = __webpack_require__(30);

	__webpack_require__(56)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(56)('getOwnPropertyNames', function(){
	  return __webpack_require__(49).f;
	});

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(13)
	  , meta     = __webpack_require__(22).onFreeze;

	__webpack_require__(56)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(13)
	  , meta     = __webpack_require__(22).onFreeze;

	__webpack_require__(56)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(13)
	  , meta     = __webpack_require__(22).onFreeze;

	__webpack_require__(56)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(13);

	__webpack_require__(56)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(13);

	__webpack_require__(56)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(13);

	__webpack_require__(56)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(8);

	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(69)});

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(30)
	  , gOPS     = __webpack_require__(43)
	  , pIE      = __webpack_require__(44)
	  , toObject = __webpack_require__(58)
	  , IObject  = __webpack_require__(33)
	  , $assign  = Object.assign;

	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(7)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', {is: __webpack_require__(71)});

/***/ },
/* 71 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(73).set});

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(13)
	  , anObject = __webpack_require__(12);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(20)(Function.call, __webpack_require__(51).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(75)
	  , test    = {};
	test[__webpack_require__(25)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(18)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(34)
	  , TAG = __webpack_require__(25)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};

	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(8);

	$export($export.P, 'Function', {bind: __webpack_require__(77)});

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction  = __webpack_require__(21)
	  , isObject   = __webpack_require__(13)
	  , invoke     = __webpack_require__(78)
	  , arraySlice = [].slice
	  , factories  = {};

	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};

	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ },
/* 78 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(11).f
	  , createDesc = __webpack_require__(17)
	  , has        = __webpack_require__(5)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';

	var isExtensible = Object.isExtensible || function(){
	  return true;
	};

	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(6) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject       = __webpack_require__(13)
	  , getPrototypeOf = __webpack_require__(59)
	  , HAS_INSTANCE   = __webpack_require__(25)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(11).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(8)
	  , $parseInt = __webpack_require__(82);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(4).parseInt
	  , $trim     = __webpack_require__(83).trim
	  , ws        = __webpack_require__(84)
	  , hex       = /^[\-+]?0[xX]/;

	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8)
	  , defined = __webpack_require__(35)
	  , fails   = __webpack_require__(7)
	  , spaces  = __webpack_require__(84)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');

	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};

	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};

	module.exports = exporter;

/***/ },
/* 84 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(8)
	  , $parseFloat = __webpack_require__(86);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(4).parseFloat
	  , $trim       = __webpack_require__(83).trim;

	module.exports = 1 / $parseFloat(__webpack_require__(84) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(4)
	  , has               = __webpack_require__(5)
	  , cof               = __webpack_require__(34)
	  , inheritIfRequired = __webpack_require__(88)
	  , toPrimitive       = __webpack_require__(16)
	  , fails             = __webpack_require__(7)
	  , gOPN              = __webpack_require__(50).f
	  , gOPD              = __webpack_require__(51).f
	  , dP                = __webpack_require__(11).f
	  , $trim             = __webpack_require__(83).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(46)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;

	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};

	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(6) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(18)(global, NUMBER, $Number);
	}

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__(13)
	  , setPrototypeOf = __webpack_require__(73).set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(8)
	  , toInteger    = __webpack_require__(38)
	  , aNumberValue = __webpack_require__(90)
	  , repeat       = __webpack_require__(91)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';

	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};

	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(7)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(34);
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(38)
	  , defined   = __webpack_require__(35);

	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(8)
	  , $fails       = __webpack_require__(7)
	  , aNumberValue = __webpack_require__(90)
	  , $toPrecision = 1..toPrecision;

	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(8);

	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(8)
	  , _isFinite = __webpack_require__(4).isFinite;

	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(8);

	$export($export.S, 'Number', {isInteger: __webpack_require__(96)});

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(13)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(8);

	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(8)
	  , isInteger = __webpack_require__(96)
	  , abs       = Math.abs;

	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(8);

	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(8);

	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(8)
	  , $parseFloat = __webpack_require__(86);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(8)
	  , $parseInt = __webpack_require__(82);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(8)
	  , log1p   = __webpack_require__(104)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;

	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 104 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(8)
	  , $asinh  = Math.asinh;

	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}

	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(8)
	  , $atanh  = Math.atanh;

	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(8)
	  , sign    = __webpack_require__(108);

	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 108 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(8);

	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(8)
	  , exp     = Math.exp;

	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(8)
	  , $expm1  = __webpack_require__(112);

	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ },
/* 112 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(8)
	  , sign      = __webpack_require__(108)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);

	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};


	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(8)
	  , abs     = Math.abs;

	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(8)
	  , $imul   = Math.imul;

	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(7)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(8);

	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(8);

	$export($export.S, 'Math', {log1p: __webpack_require__(104)});

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(8);

	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(8);

	$export($export.S, 'Math', {sign: __webpack_require__(108)});

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(8)
	  , expm1   = __webpack_require__(112)
	  , exp     = Math.exp;

	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(7)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(8)
	  , expm1   = __webpack_require__(112)
	  , exp     = Math.exp;

	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(8);

	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(8)
	  , toIndex        = __webpack_require__(39)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;

	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(8)
	  , toIObject = __webpack_require__(32)
	  , toLength  = __webpack_require__(37);

	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(83)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(127)(true);

	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(128)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(38)
	  , defined   = __webpack_require__(35);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(28)
	  , $export        = __webpack_require__(8)
	  , redefine       = __webpack_require__(18)
	  , hide           = __webpack_require__(10)
	  , has            = __webpack_require__(5)
	  , Iterators      = __webpack_require__(129)
	  , $iterCreate    = __webpack_require__(130)
	  , setToStringTag = __webpack_require__(24)
	  , getPrototypeOf = __webpack_require__(59)
	  , ITERATOR       = __webpack_require__(25)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';

	var returnThis = function(){ return this; };

	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 129 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(46)
	  , descriptor     = __webpack_require__(17)
	  , setToStringTag = __webpack_require__(24)
	  , IteratorPrototype = {};

	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(10)(IteratorPrototype, __webpack_require__(25)('iterator'), function(){ return this; });

	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $at     = __webpack_require__(127)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(8)
	  , toLength  = __webpack_require__(37)
	  , context   = __webpack_require__(133)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];

	$export($export.P + $export.F * __webpack_require__(135)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(134)
	  , defined  = __webpack_require__(35);

	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(13)
	  , cof      = __webpack_require__(34)
	  , MATCH    = __webpack_require__(25)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(25)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(8)
	  , context  = __webpack_require__(133)
	  , INCLUDES = 'includes';

	$export($export.P + $export.F * __webpack_require__(135)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);

	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(91)
	});

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(8)
	  , toLength    = __webpack_require__(37)
	  , context     = __webpack_require__(133)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];

	$export($export.P + $export.F * __webpack_require__(135)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(140)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8)
	  , fails   = __webpack_require__(7)
	  , defined = __webpack_require__(35)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(140)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(140)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(140)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(140)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(140)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(140)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(140)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(140)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(140)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(140)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(140)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(140)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(8);

	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export     = __webpack_require__(8)
	  , toObject    = __webpack_require__(58)
	  , toPrimitive = __webpack_require__(16);

	$export($export.P + $export.F * __webpack_require__(7)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(8)
	  , fails   = __webpack_require__(7)
	  , getTime = Date.prototype.getTime;

	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};

	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(18)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(25)('toPrimitive')
	  , proto        = Date.prototype;

	if(!(TO_PRIMITIVE in proto))__webpack_require__(10)(proto, TO_PRIMITIVE, __webpack_require__(158));

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject    = __webpack_require__(12)
	  , toPrimitive = __webpack_require__(16)
	  , NUMBER      = 'number';

	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(8);

	$export($export.S, 'Array', {isArray: __webpack_require__(45)});

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(20)
	  , $export        = __webpack_require__(8)
	  , toObject       = __webpack_require__(58)
	  , call           = __webpack_require__(161)
	  , isArrayIter    = __webpack_require__(162)
	  , toLength       = __webpack_require__(37)
	  , createProperty = __webpack_require__(163)
	  , getIterFn      = __webpack_require__(164);

	$export($export.S + $export.F * !__webpack_require__(165)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(12);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(129)
	  , ITERATOR   = __webpack_require__(25)('iterator')
	  , ArrayProto = Array.prototype;

	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(11)
	  , createDesc      = __webpack_require__(17);

	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(75)
	  , ITERATOR  = __webpack_require__(25)('iterator')
	  , Iterators = __webpack_require__(129);
	module.exports = __webpack_require__(9).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(25)('iterator')
	  , SAFE_CLOSING = false;

	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }

	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export        = __webpack_require__(8)
	  , createProperty = __webpack_require__(163);

	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(7)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(8)
	  , toIObject = __webpack_require__(32)
	  , arrayJoin = [].join;

	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(33) != Object || !__webpack_require__(168)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(7);

	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export    = __webpack_require__(8)
	  , html       = __webpack_require__(48)
	  , cof        = __webpack_require__(34)
	  , toIndex    = __webpack_require__(39)
	  , toLength   = __webpack_require__(37)
	  , arraySlice = [].slice;

	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(7)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(8)
	  , aFunction = __webpack_require__(21)
	  , toObject  = __webpack_require__(58)
	  , fails     = __webpack_require__(7)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];

	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(168)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export  = __webpack_require__(8)
	  , $forEach = __webpack_require__(172)(0)
	  , STRICT   = __webpack_require__(168)([].forEach, true);

	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(20)
	  , IObject  = __webpack_require__(33)
	  , toObject = __webpack_require__(58)
	  , toLength = __webpack_require__(37)
	  , asc      = __webpack_require__(173);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(174);

	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13)
	  , isArray  = __webpack_require__(45)
	  , SPECIES  = __webpack_require__(25)('species');

	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $map    = __webpack_require__(172)(1);

	$export($export.P + $export.F * !__webpack_require__(168)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $filter = __webpack_require__(172)(2);

	$export($export.P + $export.F * !__webpack_require__(168)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $some   = __webpack_require__(172)(3);

	$export($export.P + $export.F * !__webpack_require__(168)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $every  = __webpack_require__(172)(4);

	$export($export.P + $export.F * !__webpack_require__(168)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $reduce = __webpack_require__(180);

	$export($export.P + $export.F * !__webpack_require__(168)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(21)
	  , toObject  = __webpack_require__(58)
	  , IObject   = __webpack_require__(33)
	  , toLength  = __webpack_require__(37);

	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8)
	  , $reduce = __webpack_require__(180);

	$export($export.P + $export.F * !__webpack_require__(168)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(8)
	  , $indexOf      = __webpack_require__(36)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(168)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(8)
	  , toIObject     = __webpack_require__(32)
	  , toInteger     = __webpack_require__(38)
	  , toLength      = __webpack_require__(37)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(168)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(8);

	$export($export.P, 'Array', {copyWithin: __webpack_require__(185)});

	__webpack_require__(186)('copyWithin');

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(58)
	  , toIndex  = __webpack_require__(39)
	  , toLength = __webpack_require__(37);

	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(25)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(10)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(8);

	$export($export.P, 'Array', {fill: __webpack_require__(188)});

	__webpack_require__(186)('fill');

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(58)
	  , toIndex  = __webpack_require__(39)
	  , toLength = __webpack_require__(37);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(8)
	  , $find   = __webpack_require__(172)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(186)(KEY);

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(8)
	  , $find   = __webpack_require__(172)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(186)(KEY);

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(192)('Array');

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(4)
	  , dP          = __webpack_require__(11)
	  , DESCRIPTORS = __webpack_require__(6)
	  , SPECIES     = __webpack_require__(25)('species');

	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(186)
	  , step             = __webpack_require__(194)
	  , Iterators        = __webpack_require__(129)
	  , toIObject        = __webpack_require__(32);

	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(128)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');

	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;

	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 194 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	var global            = __webpack_require__(4)
	  , inheritIfRequired = __webpack_require__(88)
	  , dP                = __webpack_require__(11).f
	  , gOPN              = __webpack_require__(50).f
	  , isRegExp          = __webpack_require__(134)
	  , $flags            = __webpack_require__(196)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;

	if(__webpack_require__(6) && (!CORRECT_NEW || __webpack_require__(7)(function(){
	  re2[__webpack_require__(25)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(18)(global, 'RegExp', $RegExp);
	}

	__webpack_require__(192)('RegExp');

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(12);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(198);
	var anObject    = __webpack_require__(12)
	  , $flags      = __webpack_require__(196)
	  , DESCRIPTORS = __webpack_require__(6)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];

	var define = function(fn){
	  __webpack_require__(18)(RegExp.prototype, TO_STRING, fn, true);
	};

	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(7)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(6) && /./g.flags != 'g')__webpack_require__(11).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(196)
	});

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(200)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(10)
	  , redefine = __webpack_require__(18)
	  , fails    = __webpack_require__(7)
	  , defined  = __webpack_require__(35)
	  , wks      = __webpack_require__(25);

	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(200)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(200)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(200)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(134)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(28)
	  , global             = __webpack_require__(4)
	  , ctx                = __webpack_require__(20)
	  , classof            = __webpack_require__(75)
	  , $export            = __webpack_require__(8)
	  , isObject           = __webpack_require__(13)
	  , aFunction          = __webpack_require__(21)
	  , anInstance         = __webpack_require__(205)
	  , forOf              = __webpack_require__(206)
	  , speciesConstructor = __webpack_require__(207)
	  , task               = __webpack_require__(208).set
	  , microtask          = __webpack_require__(209)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;

	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(25)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();

	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};

	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(210)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}

	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(24)($Promise, PROMISE);
	__webpack_require__(192)(PROMISE);
	Wrapper = __webpack_require__(9)[PROMISE];

	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(165)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 205 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(20)
	  , call        = __webpack_require__(161)
	  , isArrayIter = __webpack_require__(162)
	  , anObject    = __webpack_require__(12)
	  , toLength    = __webpack_require__(37)
	  , getIterFn   = __webpack_require__(164)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(12)
	  , aFunction = __webpack_require__(21)
	  , SPECIES   = __webpack_require__(25)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(20)
	  , invoke             = __webpack_require__(78)
	  , html               = __webpack_require__(48)
	  , cel                = __webpack_require__(15)
	  , global             = __webpack_require__(4)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(34)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(4)
	  , macrotask = __webpack_require__(208).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(34)(process) == 'process';

	module.exports = function(){
	  var head, last, notify;

	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };

	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }

	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(18);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(212);

	// 23.1 Map Objects
	module.exports = __webpack_require__(213)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP          = __webpack_require__(11).f
	  , create      = __webpack_require__(46)
	  , redefineAll = __webpack_require__(210)
	  , ctx         = __webpack_require__(20)
	  , anInstance  = __webpack_require__(205)
	  , defined     = __webpack_require__(35)
	  , forOf       = __webpack_require__(206)
	  , $iterDefine = __webpack_require__(128)
	  , step        = __webpack_require__(194)
	  , setSpecies  = __webpack_require__(192)
	  , DESCRIPTORS = __webpack_require__(6)
	  , fastKey     = __webpack_require__(22).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';

	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};

	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(4)
	  , $export           = __webpack_require__(8)
	  , redefine          = __webpack_require__(18)
	  , redefineAll       = __webpack_require__(210)
	  , meta              = __webpack_require__(22)
	  , forOf             = __webpack_require__(206)
	  , anInstance        = __webpack_require__(205)
	  , isObject          = __webpack_require__(13)
	  , fails             = __webpack_require__(7)
	  , $iterDetect       = __webpack_require__(165)
	  , setToStringTag    = __webpack_require__(24)
	  , inheritIfRequired = __webpack_require__(88);

	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }

	  setToStringTag(C, NAME);

	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);

	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

	  return C;
	};

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(212);

	// 23.2 Set Objects
	module.exports = __webpack_require__(213)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each         = __webpack_require__(172)(0)
	  , redefine     = __webpack_require__(18)
	  , meta         = __webpack_require__(22)
	  , assign       = __webpack_require__(69)
	  , weak         = __webpack_require__(216)
	  , isObject     = __webpack_require__(13)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;

	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};

	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};

	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(213)('WeakMap', wrapper, methods, weak, true, true);

	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll       = __webpack_require__(210)
	  , getWeak           = __webpack_require__(22).getWeak
	  , anObject          = __webpack_require__(12)
	  , isObject          = __webpack_require__(13)
	  , anInstance        = __webpack_require__(205)
	  , forOf             = __webpack_require__(206)
	  , createArrayMethod = __webpack_require__(172)
	  , $has              = __webpack_require__(5)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;

	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};

	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(216);

	// 23.4 WeakSet Objects
	__webpack_require__(213)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(8)
	  , $typed       = __webpack_require__(219)
	  , buffer       = __webpack_require__(220)
	  , anObject     = __webpack_require__(12)
	  , toIndex      = __webpack_require__(39)
	  , toLength     = __webpack_require__(37)
	  , isObject     = __webpack_require__(13)
	  , ArrayBuffer  = __webpack_require__(4).ArrayBuffer
	  , speciesConstructor = __webpack_require__(207)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';

	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});

	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});

	$export($export.P + $export.U + $export.F * __webpack_require__(7)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});

	__webpack_require__(192)(ARRAY_BUFFER);

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4)
	  , hide   = __webpack_require__(10)
	  , uid    = __webpack_require__(19)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;

	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');

	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}

	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(4)
	  , DESCRIPTORS    = __webpack_require__(6)
	  , LIBRARY        = __webpack_require__(28)
	  , $typed         = __webpack_require__(219)
	  , hide           = __webpack_require__(10)
	  , redefineAll    = __webpack_require__(210)
	  , fails          = __webpack_require__(7)
	  , anInstance     = __webpack_require__(205)
	  , toInteger      = __webpack_require__(38)
	  , toLength       = __webpack_require__(37)
	  , gOPN           = __webpack_require__(50).f
	  , dP             = __webpack_require__(11).f
	  , arrayFill      = __webpack_require__(188)
	  , setToStringTag = __webpack_require__(24)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;

	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};

	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};

	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};

	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};

	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};

	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };

	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };

	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }

	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	$export($export.G + $export.W + $export.F * !__webpack_require__(219).ABV, {
	  DataView: __webpack_require__(220).DataView
	});

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if(__webpack_require__(6)){
	  var LIBRARY             = __webpack_require__(28)
	    , global              = __webpack_require__(4)
	    , fails               = __webpack_require__(7)
	    , $export             = __webpack_require__(8)
	    , $typed              = __webpack_require__(219)
	    , $buffer             = __webpack_require__(220)
	    , ctx                 = __webpack_require__(20)
	    , anInstance          = __webpack_require__(205)
	    , propertyDesc        = __webpack_require__(17)
	    , hide                = __webpack_require__(10)
	    , redefineAll         = __webpack_require__(210)
	    , toInteger           = __webpack_require__(38)
	    , toLength            = __webpack_require__(37)
	    , toIndex             = __webpack_require__(39)
	    , toPrimitive         = __webpack_require__(16)
	    , has                 = __webpack_require__(5)
	    , same                = __webpack_require__(71)
	    , classof             = __webpack_require__(75)
	    , isObject            = __webpack_require__(13)
	    , toObject            = __webpack_require__(58)
	    , isArrayIter         = __webpack_require__(162)
	    , create              = __webpack_require__(46)
	    , getPrototypeOf      = __webpack_require__(59)
	    , gOPN                = __webpack_require__(50).f
	    , getIterFn           = __webpack_require__(164)
	    , uid                 = __webpack_require__(19)
	    , wks                 = __webpack_require__(25)
	    , createArrayMethod   = __webpack_require__(172)
	    , createArrayIncludes = __webpack_require__(36)
	    , speciesConstructor  = __webpack_require__(207)
	    , ArrayIterators      = __webpack_require__(193)
	    , Iterators           = __webpack_require__(129)
	    , $iterDetect         = __webpack_require__(165)
	    , setSpecies          = __webpack_require__(192)
	    , arrayFill           = __webpack_require__(188)
	    , arrayCopyWithin     = __webpack_require__(185)
	    , $DP                 = __webpack_require__(11)
	    , $GOPD               = __webpack_require__(51)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';

	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });

	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });

	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });

	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };

	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };

	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };

	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };

	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };

	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };

	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };

	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };

	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };

	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });

	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };

	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };

	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };

	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };

	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };

	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };

	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }

	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });

	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }

	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });

	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }

	    O[NAME] = TypedArray;

	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });

	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

	    $export($export.P, NAME, proto);

	    setSpecies(NAME);

	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});

	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});

	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});

	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});

	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(223)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(8)
	  , aFunction = __webpack_require__(21)
	  , anObject  = __webpack_require__(12)
	  , rApply    = (__webpack_require__(4).Reflect || {}).apply
	  , fApply    = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(7)(function(){
	  rApply(function(){});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    var T = aFunction(target)
	      , L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export    = __webpack_require__(8)
	  , create     = __webpack_require__(46)
	  , aFunction  = __webpack_require__(21)
	  , anObject   = __webpack_require__(12)
	  , isObject   = __webpack_require__(13)
	  , fails      = __webpack_require__(7)
	  , bind       = __webpack_require__(77)
	  , rConstruct = (__webpack_require__(4).Reflect || {}).construct;

	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function(){
	  function F(){}
	  return !(rConstruct(function(){}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function(){
	  rConstruct(function(){});
	});

	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(11)
	  , $export     = __webpack_require__(8)
	  , anObject    = __webpack_require__(12)
	  , toPrimitive = __webpack_require__(16);

	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(7)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(8)
	  , gOPD     = __webpack_require__(51).f
	  , anObject = __webpack_require__(12);

	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(8)
	  , anObject = __webpack_require__(12);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(130)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});

	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(51)
	  , getPrototypeOf = __webpack_require__(59)
	  , has            = __webpack_require__(5)
	  , $export        = __webpack_require__(8)
	  , isObject       = __webpack_require__(13)
	  , anObject       = __webpack_require__(12);

	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}

	$export($export.S, 'Reflect', {get: get});

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(51)
	  , $export  = __webpack_require__(8)
	  , anObject = __webpack_require__(12);

	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(8)
	  , getProto = __webpack_require__(59)
	  , anObject = __webpack_require__(12);

	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(8);

	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(8)
	  , anObject      = __webpack_require__(12)
	  , $isExtensible = Object.isExtensible;

	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(8);

	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(243)});

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(50)
	  , gOPS     = __webpack_require__(43)
	  , anObject = __webpack_require__(12)
	  , Reflect  = __webpack_require__(4).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(8)
	  , anObject           = __webpack_require__(12)
	  , $preventExtensions = Object.preventExtensions;

	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(11)
	  , gOPD           = __webpack_require__(51)
	  , getPrototypeOf = __webpack_require__(59)
	  , has            = __webpack_require__(5)
	  , $export        = __webpack_require__(8)
	  , createDesc     = __webpack_require__(17)
	  , anObject       = __webpack_require__(12)
	  , isObject       = __webpack_require__(13);

	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}

	$export($export.S, 'Reflect', {set: set});

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(8)
	  , setProto = __webpack_require__(73);

	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(8)
	  , $includes = __webpack_require__(36)(true);

	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	__webpack_require__(186)('includes');

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(8)
	  , $at     = __webpack_require__(127)(true);

	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8)
	  , $pad    = __webpack_require__(250);

	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(37)
	  , repeat   = __webpack_require__(91)
	  , defined  = __webpack_require__(35);

	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8)
	  , $pad    = __webpack_require__(250);

	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(83)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(83)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(8)
	  , defined     = __webpack_require__(35)
	  , toLength    = __webpack_require__(37)
	  , isRegExp    = __webpack_require__(134)
	  , getFlags    = __webpack_require__(196)
	  , RegExpProto = RegExp.prototype;

	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};

	__webpack_require__(130)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});

	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(27)('asyncIterator');

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(27)('observable');

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(8)
	  , ownKeys        = __webpack_require__(243)
	  , toIObject      = __webpack_require__(32)
	  , gOPD           = __webpack_require__(51)
	  , createProperty = __webpack_require__(163);

	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(8)
	  , $values = __webpack_require__(259)(false);

	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(30)
	  , toIObject = __webpack_require__(32)
	  , isEnum    = __webpack_require__(44).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(8)
	  , $entries = __webpack_require__(259)(true);

	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(8)
	  , toObject        = __webpack_require__(58)
	  , aFunction       = __webpack_require__(21)
	  , $defineProperty = __webpack_require__(11);

	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(6) && $export($export.P + __webpack_require__(262), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(28)|| !__webpack_require__(7)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(4)[K];
	});

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(8)
	  , toObject        = __webpack_require__(58)
	  , aFunction       = __webpack_require__(21)
	  , $defineProperty = __webpack_require__(11);

	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(6) && $export($export.P + __webpack_require__(262), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(8)
	  , toObject                 = __webpack_require__(58)
	  , toPrimitive              = __webpack_require__(16)
	  , getPrototypeOf           = __webpack_require__(59)
	  , getOwnPropertyDescriptor = __webpack_require__(51).f;

	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(6) && $export($export.P + __webpack_require__(262), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(8)
	  , toObject                 = __webpack_require__(58)
	  , toPrimitive              = __webpack_require__(16)
	  , getPrototypeOf           = __webpack_require__(59)
	  , getOwnPropertyDescriptor = __webpack_require__(51).f;

	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(6) && $export($export.P + __webpack_require__(262), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(8);

	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(267)('Map')});

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(75)
	  , from    = __webpack_require__(268);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(206);

	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(8);

	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(267)('Set')});

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(8);

	$export($export.S, 'System', {global: __webpack_require__(4)});

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(8)
	  , cof     = __webpack_require__(34);

	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);

	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);

	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);

	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);

	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(277)
	  , anObject                  = __webpack_require__(12)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;

	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__(211)
	  , $export = __webpack_require__(8)
	  , shared  = __webpack_require__(23)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(215)));

	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};

	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(277)
	  , anObject               = __webpack_require__(12)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;

	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(277)
	  , anObject               = __webpack_require__(12)
	  , getPrototypeOf         = __webpack_require__(59)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;

	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};

	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__(214)
	  , from                    = __webpack_require__(268)
	  , metadata                = __webpack_require__(277)
	  , anObject                = __webpack_require__(12)
	  , getPrototypeOf          = __webpack_require__(59)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;

	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};

	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(277)
	  , anObject               = __webpack_require__(12)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;

	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__(277)
	  , anObject                = __webpack_require__(12)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;

	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(277)
	  , anObject               = __webpack_require__(12)
	  , getPrototypeOf         = __webpack_require__(59)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;

	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};

	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(277)
	  , anObject               = __webpack_require__(12)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;

	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(277)
	  , anObject                  = __webpack_require__(12)
	  , aFunction                 = __webpack_require__(21)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;

	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(8)
	  , microtask = __webpack_require__(209)()
	  , process   = __webpack_require__(4).process
	  , isNode    = __webpack_require__(34)(process) == 'process';

	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(8)
	  , global      = __webpack_require__(4)
	  , core        = __webpack_require__(9)
	  , microtask   = __webpack_require__(209)()
	  , OBSERVABLE  = __webpack_require__(25)('observable')
	  , aFunction   = __webpack_require__(21)
	  , anObject    = __webpack_require__(12)
	  , anInstance  = __webpack_require__(205)
	  , redefineAll = __webpack_require__(210)
	  , hide        = __webpack_require__(10)
	  , forOf       = __webpack_require__(206)
	  , RETURN      = forOf.RETURN;

	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};

	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};

	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};

	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};

	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};

	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});

	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};

	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});

	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};

	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});

	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});

	hide($Observable.prototype, OBSERVABLE, function(){ return this; });

	$export($export.G, {Observable: $Observable});

	__webpack_require__(192)('Observable');

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(4)
	  , $export    = __webpack_require__(8)
	  , invoke     = __webpack_require__(78)
	  , partial    = __webpack_require__(289)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(290)
	  , invoke    = __webpack_require__(78)
	  , aFunction = __webpack_require__(21);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4);

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8)
	  , $task   = __webpack_require__(208);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__(193)
	  , redefine      = __webpack_require__(18)
	  , global        = __webpack_require__(4)
	  , hide          = __webpack_require__(10)
	  , Iterators     = __webpack_require__(129)
	  , wks           = __webpack_require__(25)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;

	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */

	!(function(global) {
	  "use strict";

	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }

	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);

	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);

	    return generator;
	  }
	  runtime.wrap = wrap;

	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }

	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";

	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};

	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}

	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }

	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };

	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };

	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };

	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }

	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }

	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }

	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }

	    var previousPromise;

	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }

	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }

	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }

	  defineIteratorMethods(AsyncIterator.prototype);

	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );

	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };

	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;

	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }

	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }

	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }

	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;

	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }

	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }

	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );

	          if (record.type === "throw") {
	            context.delegate = null;

	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }

	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;

	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }

	          context.delegate = null;
	        }

	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;

	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }

	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }

	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }

	        state = GenStateExecuting;

	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;

	          var info = {
	            value: record.arg,
	            done: context.done
	          };

	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }

	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }

	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);

	  Gp[iteratorSymbol] = function() {
	    return this;
	  };

	  Gp[toStringTagSymbol] = "Generator";

	  Gp.toString = function() {
	    return "[object Generator]";
	  };

	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };

	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }

	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }

	    this.tryEntries.push(entry);
	  }

	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }

	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }

	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();

	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }

	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };

	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }

	      if (typeof iterable.next === "function") {
	        return iterable;
	      }

	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }

	          next.value = undefined;
	          next.done = true;

	          return next;
	        };

	        return next.next = next;
	      }
	    }

	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;

	  function doneResult() {
	    return { value: undefined, done: true };
	  }

	  Context.prototype = {
	    constructor: Context,

	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;

	      this.tryEntries.forEach(resetTryEntry);

	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },

	    stop: function() {
	      this.done = true;

	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }

	      return this.rval;
	    },

	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }

	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }

	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;

	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }

	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");

	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }

	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },

	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }

	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }

	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;

	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }

	      return ContinueSentinel;
	    },

	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }

	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },

	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },

	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }

	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },

	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };

	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(294)))

/***/ },
/* 294 */
/***/ function(module, exports) {

	// shim for using process in browser

	var process = module.exports = {};
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;

	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = setTimeout(cleanUpNextTick);
	    draining = true;

	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    clearTimeout(timeout);
	}

	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        setTimeout(drainQueue, 0);
	    }
	};

	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};

	function noop() {}

	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;

	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};

	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(296);
	module.exports = __webpack_require__(9).RegExp.escape;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(8)
	  , $re     = __webpack_require__(297)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ },
/* 297 */
/***/ function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	__webpack_require__(299);

	var _helpersTypeCheck = __webpack_require__(303);

	var _helpersTypeCheck2 = _interopRequireDefault(_helpersTypeCheck);

	var _jsCookie = __webpack_require__(304);

	var _jsCookie2 = _interopRequireDefault(_jsCookie);

	var _modelEventsCore = __webpack_require__(305);

	var _modelEventsCore2 = _interopRequireDefault(_modelEventsCore);

	var _modelEventsProductSet = __webpack_require__(322);

	var _modelEventsProductSet2 = _interopRequireDefault(_modelEventsProductSet);

	var _modelEventsProductTransact = __webpack_require__(326);

	var _modelEventsProductTransact2 = _interopRequireDefault(_modelEventsProductTransact);

	var _modelEventsProductExpressInterestOn = __webpack_require__(327);

	var _modelEventsProductExpressInterestOn2 = _interopRequireDefault(_modelEventsProductExpressInterestOn);

	var _modelEventsProductAuthenticate = __webpack_require__(328);

	var _modelEventsProductAuthenticate2 = _interopRequireDefault(_modelEventsProductAuthenticate);

	var _modelEventsProductRefresh = __webpack_require__(329);

	var _modelEventsProductRefresh2 = _interopRequireDefault(_modelEventsProductRefresh);

	var _modelEventsProductPrint = __webpack_require__(330);

	var _modelEventsProductPrint2 = _interopRequireDefault(_modelEventsProductPrint);

	var _modelEventsProductSearch = __webpack_require__(331);

	var _modelEventsProductSearch2 = _interopRequireDefault(_modelEventsProductSearch);

	var _modelEventsProductUpdate = __webpack_require__(332);

	var _modelEventsProductUpdate2 = _interopRequireDefault(_modelEventsProductUpdate);

	var _modelEventsProductDelete = __webpack_require__(333);

	var _modelEventsProductDelete2 = _interopRequireDefault(_modelEventsProductDelete);

	var _modelEventsProductConsume = __webpack_require__(334);

	var _modelEventsProductConsume2 = _interopRequireDefault(_modelEventsProductConsume);

	var _modelEventsProductProduce = __webpack_require__(335);

	var _modelEventsProductProduce2 = _interopRequireDefault(_modelEventsProductProduce);

	var _modelEventsProductDownload = __webpack_require__(336);

	var _modelEventsProductDownload2 = _interopRequireDefault(_modelEventsProductDownload);

	var _modelEventsProductUIShow = __webpack_require__(337);

	var _modelEventsProductUIShow2 = _interopRequireDefault(_modelEventsProductUIShow);

	var _modelEventsProductUIHide = __webpack_require__(339);

	var _modelEventsProductUIHide2 = _interopRequireDefault(_modelEventsProductUIHide);

	var _modelEventsProductUIInteraction = __webpack_require__(340);

	var _modelEventsProductUIInteraction2 = _interopRequireDefault(_modelEventsProductUIInteraction);

	var _modelEventsProductUINavigation = __webpack_require__(341);

	var _modelEventsProductUINavigation2 = _interopRequireDefault(_modelEventsProductUINavigation);

	var _modelEventsProductKeyValue = __webpack_require__(342);

	var _modelEventsProductKeyValue2 = _interopRequireDefault(_modelEventsProductKeyValue);

	var _modelGenericObjectsUILocation = __webpack_require__(324);

	var _modelGenericObjectsUILocation2 = _interopRequireDefault(_modelGenericObjectsUILocation);

	var _modelGenericObjectsBusinessDomainDefinition = __webpack_require__(308);

	var _modelGenericObjectsBusinessDomainDefinition2 = _interopRequireDefault(_modelGenericObjectsBusinessDomainDefinition);

	var _modelGenericObjectsSingleContext = __webpack_require__(314);

	var _modelGenericObjectsSingleContext2 = _interopRequireDefault(_modelGenericObjectsSingleContext);

	var _modelGenericObjectsPiiKeyValue = __webpack_require__(313);

	var _modelGenericObjectsPiiKeyValue2 = _interopRequireDefault(_modelGenericObjectsPiiKeyValue);

	var _modelGenericObjectsBusinessDomainObject = __webpack_require__(309);

	var _modelGenericObjectsBusinessDomainObject2 = _interopRequireDefault(_modelGenericObjectsBusinessDomainObject);

	var _modelGenericObjectsRelatedEvent = __webpack_require__(320);

	var _modelGenericObjectsRelatedEvent2 = _interopRequireDefault(_modelGenericObjectsRelatedEvent);

	var _modelGenericObjectsRelatedBusinessDomainObject = __webpack_require__(321);

	var _modelGenericObjectsRelatedBusinessDomainObject2 = _interopRequireDefault(_modelGenericObjectsRelatedBusinessDomainObject);

	var _ProviderManager = __webpack_require__(343);

	var _ProviderManager2 = _interopRequireDefault(_ProviderManager);

	var TRAAC = (function () {
		function TRAAC() {
			_classCallCheck(this, TRAAC);

			this.setInitialReferrer();
			this.runAsyncEvents();

			window.traacProviderManager = new _ProviderManager2['default']();
			this.attachUnloadEvent();
		}

		_createClass(TRAAC, [{
			key: 'registerProvider',
			value: function registerProvider(name, config) {
				window.traacProviderManager.addProvider(name, config);
			}
		}, {
			key: 'attachUnloadEvent',
			value: function attachUnloadEvent() {
				var _this = this;

				window.addEventListener("unload", function () {
					_this.flush();
				});
			}
		}, {
			key: 'track',
			value: function track(eventBluePrint) {

				if (typeof eventBluePrint === 'function') {

					window.traacProviderManager.run('track', eventBluePrint.call(window));
				} else if (typeof eventBluePrint === 'object' && eventBluePrint.eventType) {

					var builtEvent = this[eventBluePrint.eventType](eventBluePrint.eventName, eventBluePrint.kvp).build();
					window.traacProviderManager.run('track', builtEvent);
				} else if (typeof eventBluePrint === 'object' && eventBluePrint['event-id']) {

					window.traacProviderManager.run('track', eventBluePrint);
				}
			}
		}, {
			key: 'flush',
			value: function flush(callback, timeout) {

				window.traacProviderManager.run('flush', {
					'callback': callback || function () {
						console.log('Event queue flushed');
					},
					'timeout': timeout || 700
				});
			}
		}, {
			key: 'register',
			value: function register(newSuperProps, once) {

				if (!newSuperProps || typeof newSuperProps != 'object') {
					console.warn('Registering super props failed. Invalid type:', (0, _helpersTypeCheck2['default'])(newSuperProps));
					return;
				}

				var currentSuperProps = _jsCookie2['default'].getJSON('traac'),
				    outputSuperProps = {};

				if (currentSuperProps) {
					for (var key in currentSuperProps) {
						outputSuperProps[key] = currentSuperProps[key];
					}
				}

				for (var key in newSuperProps) {

					//if new prop key already exists and once set - this could probably use some work!
					if (outputSuperProps[key] && once) {
						break;
					} else {
						outputSuperProps[key] = newSuperProps[key];
					}
				}

				_jsCookie2['default'].set('traac', outputSuperProps, { expires: 365 });
			}
		}, {
			key: 'registerOnce',
			value: function registerOnce(newSuperProps) {
				this.register(newSuperProps, true);
			}
		}, {
			key: 'deRegister',
			value: function deRegister(key) {

				var superProps = _jsCookie2['default'].getJSON('traac');

				if (!superProps || !superProps[key]) {
					return;
				}
				delete superProps[key];
				_jsCookie2['default'].set('traac', superProps, { expires: 365 });
			}
		}, {
			key: 'setUser',
			value: function setUser(userId) {
				_jsCookie2['default'].set('traacUserId', userId, { expires: 365 });
			}
		}, {
			key: 'clearUser',
			value: function clearUser() {
				_jsCookie2['default'].remove('traacUserId');
			}

			//TODO - This needs some serious testing as I believe there are edge cases where it won't work as planned
		}, {
			key: 'setInitialReferrer',
			value: function setInitialReferrer() {

				var props = _jsCookie2['default'].getJSON('traacRef') || {};

				var referringDomain = function referringDomain(referrer) {

					var splitReferrer = referrer.split("/");
					if (splitReferrer.length >= 3) {
						return splitReferrer[2];
					}
				};

				if (document.referrer) {

					if (props['initial-referring-domain']) {

						if (props['initial-referring-domain'] !== referringDomain(document.referrer)) {

							props['initial-referring-domain'] = referringDomain(document.referrer);
							props['initial-referrer'] = document.referrer;
						}
					} else {

						props['initial-referring-domain'] = referringDomain(document.referrer);
						props['initial-referrer'] = document.referrer;
					}
				} else {

					if (!props['initial-referring-domain']) {
						props['initial-referring-domain'] = '$direct';
						props['initial-referrer'] = '$direct';
					}
				}

				_jsCookie2['default'].set('traacRef', props, { expires: 365 });
			}
		}, {
			key: 'runAsyncEvents',
			value: function runAsyncEvents() {
				//Force this to run once everything else is done :)
				setTimeout((function () {

					for (var i = 0, len = TRAAC_CONFIG.teq.length; i < len; i++) {

						if (typeof TRAAC_CONFIG.teq[i] === 'object' && TRAAC_CONFIG.teq[i].method) {
							this[TRAAC_CONFIG.teq[i].method](TRAAC_CONFIG.teq[i].p1, TRAAC_CONFIG.teq[i].p2);
						} else {
							this.track(TRAAC_CONFIG.teq[i]);
						}
					}
				}).bind(this), 0);
			}
		}, {
			key: 'set',
			value: function set(eventExternalName) {
				return new _modelEventsProductSet2['default'](eventExternalName);
			}
		}, {
			key: 'transact',
			value: function transact(eventExternalName, success) {
				return new _modelEventsProductTransact2['default'](eventExternalName, success);
			}
		}, {
			key: 'expressInterestOn',
			value: function expressInterestOn(eventExternalName) {
				return new _modelEventsProductExpressInterestOn2['default'](eventExternalName);
			}
		}, {
			key: 'authenticate',
			value: function authenticate(eventExternalName, success, userId) {
				return new _modelEventsProductAuthenticate2['default'](eventExternalName, success, userId);
			}
		}, {
			key: 'refresh',
			value: function refresh(eventExternalName) {
				return new _modelEventsProductRefresh2['default'](eventExternalName);
			}
		}, {
			key: 'print',
			value: function print(eventExternalName) {
				return new _modelEventsProductPrint2['default'](eventExternalName);
			}
		}, {
			key: 'search',
			value: function search(eventExternalName) {
				return new _modelEventsProductSearch2['default'](eventExternalName);
			}
		}, {
			key: 'update',
			value: function update(eventExternalName) {
				return new _modelEventsProductUpdate2['default'](eventExternalName);
			}
		}, {
			key: 'delete',
			value: function _delete(eventExternalName) {
				return new _modelEventsProductDelete2['default'](eventExternalName);
			}
		}, {
			key: 'consume',
			value: function consume(eventExternalName) {
				return new _modelEventsProductConsume2['default'](eventExternalName);
			}
		}, {
			key: 'produce',
			value: function produce(eventExternalName) {
				return new _modelEventsProductProduce2['default'](eventExternalName);
			}
		}, {
			key: 'download',
			value: function download(eventExternalName) {
				return new _modelEventsProductDownload2['default'](eventExternalName);
			}
		}, {
			key: 'uiShow',
			value: function uiShow(eventExternalName, uiElementName, enclosingUILocation) {
				return new _modelEventsProductUIShow2['default'](eventExternalName, uiElementName, enclosingUILocation);
			}
		}, {
			key: 'uiHide',
			value: function uiHide(eventExternalName, uiElementName, enclosingUILocation) {
				return new _modelEventsProductUIHide2['default'](eventExternalName, uiElementName, enclosingUILocation);
			}
		}, {
			key: 'uiInteraction',
			value: function uiInteraction(eventExternalName, uiElementName, enclosingUILocation) {
				return new _modelEventsProductUIHide2['default'](eventExternalName, uiElementName, enclosingUILocation);
			}
		}, {
			key: 'uiNavigation',
			value: function uiNavigation(eventExternalName, uiLocationFrom, uiLocationTo) {
				return new _modelEventsProductUINavigation2['default'](eventExternalName, uiLocationFrom, uiLocationTo);
			}
		}, {
			key: 'keyValue',
			value: function keyValue(eventName, properties) {
				return new _modelEventsProductKeyValue2['default'](eventName, properties);
			}
		}, {
			key: 'getEventCoreObject',
			value: function getEventCoreObject() {
				return new _modelEventsCore2['default']();
			}
		}, {
			key: 'getUiLocationObject',
			value: function getUiLocationObject(name) {
				return new _modelGenericObjectsUILocation2['default'](name);
			}
		}, {
			key: 'getBusinessDomainDefinitionObject',
			value: function getBusinessDomainDefinitionObject(businessDomain, businessObjectType) {
				return new _modelGenericObjectsBusinessDomainDefinition2['default'](businessDomain, businessObjectType);
			}
		}, {
			key: 'getSingleContextObject',
			value: function getSingleContextObject(contextType) {
				return new _modelGenericObjectsSingleContext2['default'](contextType);
			}
		}, {
			key: 'getPiiKeyValueObject',
			value: function getPiiKeyValueObject(key, value) {
				return new _modelGenericObjectsPiiKeyValue2['default'](key, value);
			}
		}, {
			key: 'getBusinessDomainObject',
			value: function getBusinessDomainObject(businessDomainDefinition, objectId) {
				return new _modelGenericObjectsBusinessDomainObject2['default'](businessDomainDefinition, objectId);
			}
		}, {
			key: 'getRelatedEventObject',
			value: function getRelatedEventObject(relationshipType, relatedEventId) {
				return new _modelGenericObjectsRelatedEvent2['default'](relationshipType, relatedEventId);
			}
		}, {
			key: 'getRelatedBusinessDomainObject',
			value: function getRelatedBusinessDomainObject(relationshipType) {
				return new _modelGenericObjectsRelatedBusinessDomainObject2['default'](relationshipType);
			}
		}]);

		return TRAAC;
	})();

	window.TRAAC = new TRAAC();

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	var require;var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process, global, module) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
	 * @version   3.2.1
	 */

	(function() {
	    "use strict";
	    function lib$es6$promise$utils$$objectOrFunction(x) {
	      return typeof x === 'function' || (typeof x === 'object' && x !== null);
	    }

	    function lib$es6$promise$utils$$isFunction(x) {
	      return typeof x === 'function';
	    }

	    function lib$es6$promise$utils$$isMaybeThenable(x) {
	      return typeof x === 'object' && x !== null;
	    }

	    var lib$es6$promise$utils$$_isArray;
	    if (!Array.isArray) {
	      lib$es6$promise$utils$$_isArray = function (x) {
	        return Object.prototype.toString.call(x) === '[object Array]';
	      };
	    } else {
	      lib$es6$promise$utils$$_isArray = Array.isArray;
	    }

	    var lib$es6$promise$utils$$isArray = lib$es6$promise$utils$$_isArray;
	    var lib$es6$promise$asap$$len = 0;
	    var lib$es6$promise$asap$$vertxNext;
	    var lib$es6$promise$asap$$customSchedulerFn;

	    var lib$es6$promise$asap$$asap = function asap(callback, arg) {
	      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len] = callback;
	      lib$es6$promise$asap$$queue[lib$es6$promise$asap$$len + 1] = arg;
	      lib$es6$promise$asap$$len += 2;
	      if (lib$es6$promise$asap$$len === 2) {
	        // If len is 2, that means that we need to schedule an async flush.
	        // If additional callbacks are queued before the queue is flushed, they
	        // will be processed by this flush that we are scheduling.
	        if (lib$es6$promise$asap$$customSchedulerFn) {
	          lib$es6$promise$asap$$customSchedulerFn(lib$es6$promise$asap$$flush);
	        } else {
	          lib$es6$promise$asap$$scheduleFlush();
	        }
	      }
	    }

	    function lib$es6$promise$asap$$setScheduler(scheduleFn) {
	      lib$es6$promise$asap$$customSchedulerFn = scheduleFn;
	    }

	    function lib$es6$promise$asap$$setAsap(asapFn) {
	      lib$es6$promise$asap$$asap = asapFn;
	    }

	    var lib$es6$promise$asap$$browserWindow = (typeof window !== 'undefined') ? window : undefined;
	    var lib$es6$promise$asap$$browserGlobal = lib$es6$promise$asap$$browserWindow || {};
	    var lib$es6$promise$asap$$BrowserMutationObserver = lib$es6$promise$asap$$browserGlobal.MutationObserver || lib$es6$promise$asap$$browserGlobal.WebKitMutationObserver;
	    var lib$es6$promise$asap$$isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

	    // test for web worker but not in IE10
	    var lib$es6$promise$asap$$isWorker = typeof Uint8ClampedArray !== 'undefined' &&
	      typeof importScripts !== 'undefined' &&
	      typeof MessageChannel !== 'undefined';

	    // node
	    function lib$es6$promise$asap$$useNextTick() {
	      // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	      // see https://github.com/cujojs/when/issues/410 for details
	      return function() {
	        process.nextTick(lib$es6$promise$asap$$flush);
	      };
	    }

	    // vertx
	    function lib$es6$promise$asap$$useVertxTimer() {
	      return function() {
	        lib$es6$promise$asap$$vertxNext(lib$es6$promise$asap$$flush);
	      };
	    }

	    function lib$es6$promise$asap$$useMutationObserver() {
	      var iterations = 0;
	      var observer = new lib$es6$promise$asap$$BrowserMutationObserver(lib$es6$promise$asap$$flush);
	      var node = document.createTextNode('');
	      observer.observe(node, { characterData: true });

	      return function() {
	        node.data = (iterations = ++iterations % 2);
	      };
	    }

	    // web worker
	    function lib$es6$promise$asap$$useMessageChannel() {
	      var channel = new MessageChannel();
	      channel.port1.onmessage = lib$es6$promise$asap$$flush;
	      return function () {
	        channel.port2.postMessage(0);
	      };
	    }

	    function lib$es6$promise$asap$$useSetTimeout() {
	      return function() {
	        setTimeout(lib$es6$promise$asap$$flush, 1);
	      };
	    }

	    var lib$es6$promise$asap$$queue = new Array(1000);
	    function lib$es6$promise$asap$$flush() {
	      for (var i = 0; i < lib$es6$promise$asap$$len; i+=2) {
	        var callback = lib$es6$promise$asap$$queue[i];
	        var arg = lib$es6$promise$asap$$queue[i+1];

	        callback(arg);

	        lib$es6$promise$asap$$queue[i] = undefined;
	        lib$es6$promise$asap$$queue[i+1] = undefined;
	      }

	      lib$es6$promise$asap$$len = 0;
	    }

	    function lib$es6$promise$asap$$attemptVertx() {
	      try {
	        var r = require;
	        var vertx = __webpack_require__(301);
	        lib$es6$promise$asap$$vertxNext = vertx.runOnLoop || vertx.runOnContext;
	        return lib$es6$promise$asap$$useVertxTimer();
	      } catch(e) {
	        return lib$es6$promise$asap$$useSetTimeout();
	      }
	    }

	    var lib$es6$promise$asap$$scheduleFlush;
	    // Decide what async method to use to triggering processing of queued callbacks:
	    if (lib$es6$promise$asap$$isNode) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useNextTick();
	    } else if (lib$es6$promise$asap$$BrowserMutationObserver) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMutationObserver();
	    } else if (lib$es6$promise$asap$$isWorker) {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useMessageChannel();
	    } else if (lib$es6$promise$asap$$browserWindow === undefined && "function" === 'function') {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$attemptVertx();
	    } else {
	      lib$es6$promise$asap$$scheduleFlush = lib$es6$promise$asap$$useSetTimeout();
	    }
	    function lib$es6$promise$then$$then(onFulfillment, onRejection) {
	      var parent = this;

	      var child = new this.constructor(lib$es6$promise$$internal$$noop);

	      if (child[lib$es6$promise$$internal$$PROMISE_ID] === undefined) {
	        lib$es6$promise$$internal$$makePromise(child);
	      }

	      var state = parent._state;

	      if (state) {
	        var callback = arguments[state - 1];
	        lib$es6$promise$asap$$asap(function(){
	          lib$es6$promise$$internal$$invokeCallback(state, child, callback, parent._result);
	        });
	      } else {
	        lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection);
	      }

	      return child;
	    }
	    var lib$es6$promise$then$$default = lib$es6$promise$then$$then;
	    function lib$es6$promise$promise$resolve$$resolve(object) {
	      /*jshint validthis:true */
	      var Constructor = this;

	      if (object && typeof object === 'object' && object.constructor === Constructor) {
	        return object;
	      }

	      var promise = new Constructor(lib$es6$promise$$internal$$noop);
	      lib$es6$promise$$internal$$resolve(promise, object);
	      return promise;
	    }
	    var lib$es6$promise$promise$resolve$$default = lib$es6$promise$promise$resolve$$resolve;
	    var lib$es6$promise$$internal$$PROMISE_ID = Math.random().toString(36).substring(16);

	    function lib$es6$promise$$internal$$noop() {}

	    var lib$es6$promise$$internal$$PENDING   = void 0;
	    var lib$es6$promise$$internal$$FULFILLED = 1;
	    var lib$es6$promise$$internal$$REJECTED  = 2;

	    var lib$es6$promise$$internal$$GET_THEN_ERROR = new lib$es6$promise$$internal$$ErrorObject();

	    function lib$es6$promise$$internal$$selfFulfillment() {
	      return new TypeError("You cannot resolve a promise with itself");
	    }

	    function lib$es6$promise$$internal$$cannotReturnOwn() {
	      return new TypeError('A promises callback cannot return that same promise.');
	    }

	    function lib$es6$promise$$internal$$getThen(promise) {
	      try {
	        return promise.then;
	      } catch(error) {
	        lib$es6$promise$$internal$$GET_THEN_ERROR.error = error;
	        return lib$es6$promise$$internal$$GET_THEN_ERROR;
	      }
	    }

	    function lib$es6$promise$$internal$$tryThen(then, value, fulfillmentHandler, rejectionHandler) {
	      try {
	        then.call(value, fulfillmentHandler, rejectionHandler);
	      } catch(e) {
	        return e;
	      }
	    }

	    function lib$es6$promise$$internal$$handleForeignThenable(promise, thenable, then) {
	       lib$es6$promise$asap$$asap(function(promise) {
	        var sealed = false;
	        var error = lib$es6$promise$$internal$$tryThen(then, thenable, function(value) {
	          if (sealed) { return; }
	          sealed = true;
	          if (thenable !== value) {
	            lib$es6$promise$$internal$$resolve(promise, value);
	          } else {
	            lib$es6$promise$$internal$$fulfill(promise, value);
	          }
	        }, function(reason) {
	          if (sealed) { return; }
	          sealed = true;

	          lib$es6$promise$$internal$$reject(promise, reason);
	        }, 'Settle: ' + (promise._label || ' unknown promise'));

	        if (!sealed && error) {
	          sealed = true;
	          lib$es6$promise$$internal$$reject(promise, error);
	        }
	      }, promise);
	    }

	    function lib$es6$promise$$internal$$handleOwnThenable(promise, thenable) {
	      if (thenable._state === lib$es6$promise$$internal$$FULFILLED) {
	        lib$es6$promise$$internal$$fulfill(promise, thenable._result);
	      } else if (thenable._state === lib$es6$promise$$internal$$REJECTED) {
	        lib$es6$promise$$internal$$reject(promise, thenable._result);
	      } else {
	        lib$es6$promise$$internal$$subscribe(thenable, undefined, function(value) {
	          lib$es6$promise$$internal$$resolve(promise, value);
	        }, function(reason) {
	          lib$es6$promise$$internal$$reject(promise, reason);
	        });
	      }
	    }

	    function lib$es6$promise$$internal$$handleMaybeThenable(promise, maybeThenable, then) {
	      if (maybeThenable.constructor === promise.constructor &&
	          then === lib$es6$promise$then$$default &&
	          constructor.resolve === lib$es6$promise$promise$resolve$$default) {
	        lib$es6$promise$$internal$$handleOwnThenable(promise, maybeThenable);
	      } else {
	        if (then === lib$es6$promise$$internal$$GET_THEN_ERROR) {
	          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$GET_THEN_ERROR.error);
	        } else if (then === undefined) {
	          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
	        } else if (lib$es6$promise$utils$$isFunction(then)) {
	          lib$es6$promise$$internal$$handleForeignThenable(promise, maybeThenable, then);
	        } else {
	          lib$es6$promise$$internal$$fulfill(promise, maybeThenable);
	        }
	      }
	    }

	    function lib$es6$promise$$internal$$resolve(promise, value) {
	      if (promise === value) {
	        lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$selfFulfillment());
	      } else if (lib$es6$promise$utils$$objectOrFunction(value)) {
	        lib$es6$promise$$internal$$handleMaybeThenable(promise, value, lib$es6$promise$$internal$$getThen(value));
	      } else {
	        lib$es6$promise$$internal$$fulfill(promise, value);
	      }
	    }

	    function lib$es6$promise$$internal$$publishRejection(promise) {
	      if (promise._onerror) {
	        promise._onerror(promise._result);
	      }

	      lib$es6$promise$$internal$$publish(promise);
	    }

	    function lib$es6$promise$$internal$$fulfill(promise, value) {
	      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }

	      promise._result = value;
	      promise._state = lib$es6$promise$$internal$$FULFILLED;

	      if (promise._subscribers.length !== 0) {
	        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, promise);
	      }
	    }

	    function lib$es6$promise$$internal$$reject(promise, reason) {
	      if (promise._state !== lib$es6$promise$$internal$$PENDING) { return; }
	      promise._state = lib$es6$promise$$internal$$REJECTED;
	      promise._result = reason;

	      lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publishRejection, promise);
	    }

	    function lib$es6$promise$$internal$$subscribe(parent, child, onFulfillment, onRejection) {
	      var subscribers = parent._subscribers;
	      var length = subscribers.length;

	      parent._onerror = null;

	      subscribers[length] = child;
	      subscribers[length + lib$es6$promise$$internal$$FULFILLED] = onFulfillment;
	      subscribers[length + lib$es6$promise$$internal$$REJECTED]  = onRejection;

	      if (length === 0 && parent._state) {
	        lib$es6$promise$asap$$asap(lib$es6$promise$$internal$$publish, parent);
	      }
	    }

	    function lib$es6$promise$$internal$$publish(promise) {
	      var subscribers = promise._subscribers;
	      var settled = promise._state;

	      if (subscribers.length === 0) { return; }

	      var child, callback, detail = promise._result;

	      for (var i = 0; i < subscribers.length; i += 3) {
	        child = subscribers[i];
	        callback = subscribers[i + settled];

	        if (child) {
	          lib$es6$promise$$internal$$invokeCallback(settled, child, callback, detail);
	        } else {
	          callback(detail);
	        }
	      }

	      promise._subscribers.length = 0;
	    }

	    function lib$es6$promise$$internal$$ErrorObject() {
	      this.error = null;
	    }

	    var lib$es6$promise$$internal$$TRY_CATCH_ERROR = new lib$es6$promise$$internal$$ErrorObject();

	    function lib$es6$promise$$internal$$tryCatch(callback, detail) {
	      try {
	        return callback(detail);
	      } catch(e) {
	        lib$es6$promise$$internal$$TRY_CATCH_ERROR.error = e;
	        return lib$es6$promise$$internal$$TRY_CATCH_ERROR;
	      }
	    }

	    function lib$es6$promise$$internal$$invokeCallback(settled, promise, callback, detail) {
	      var hasCallback = lib$es6$promise$utils$$isFunction(callback),
	          value, error, succeeded, failed;

	      if (hasCallback) {
	        value = lib$es6$promise$$internal$$tryCatch(callback, detail);

	        if (value === lib$es6$promise$$internal$$TRY_CATCH_ERROR) {
	          failed = true;
	          error = value.error;
	          value = null;
	        } else {
	          succeeded = true;
	        }

	        if (promise === value) {
	          lib$es6$promise$$internal$$reject(promise, lib$es6$promise$$internal$$cannotReturnOwn());
	          return;
	        }

	      } else {
	        value = detail;
	        succeeded = true;
	      }

	      if (promise._state !== lib$es6$promise$$internal$$PENDING) {
	        // noop
	      } else if (hasCallback && succeeded) {
	        lib$es6$promise$$internal$$resolve(promise, value);
	      } else if (failed) {
	        lib$es6$promise$$internal$$reject(promise, error);
	      } else if (settled === lib$es6$promise$$internal$$FULFILLED) {
	        lib$es6$promise$$internal$$fulfill(promise, value);
	      } else if (settled === lib$es6$promise$$internal$$REJECTED) {
	        lib$es6$promise$$internal$$reject(promise, value);
	      }
	    }

	    function lib$es6$promise$$internal$$initializePromise(promise, resolver) {
	      try {
	        resolver(function resolvePromise(value){
	          lib$es6$promise$$internal$$resolve(promise, value);
	        }, function rejectPromise(reason) {
	          lib$es6$promise$$internal$$reject(promise, reason);
	        });
	      } catch(e) {
	        lib$es6$promise$$internal$$reject(promise, e);
	      }
	    }

	    var lib$es6$promise$$internal$$id = 0;
	    function lib$es6$promise$$internal$$nextId() {
	      return lib$es6$promise$$internal$$id++;
	    }

	    function lib$es6$promise$$internal$$makePromise(promise) {
	      promise[lib$es6$promise$$internal$$PROMISE_ID] = lib$es6$promise$$internal$$id++;
	      promise._state = undefined;
	      promise._result = undefined;
	      promise._subscribers = [];
	    }

	    function lib$es6$promise$promise$all$$all(entries) {
	      return new lib$es6$promise$enumerator$$default(this, entries).promise;
	    }
	    var lib$es6$promise$promise$all$$default = lib$es6$promise$promise$all$$all;
	    function lib$es6$promise$promise$race$$race(entries) {
	      /*jshint validthis:true */
	      var Constructor = this;

	      if (!lib$es6$promise$utils$$isArray(entries)) {
	        return new Constructor(function(resolve, reject) {
	          reject(new TypeError('You must pass an array to race.'));
	        });
	      } else {
	        return new Constructor(function(resolve, reject) {
	          var length = entries.length;
	          for (var i = 0; i < length; i++) {
	            Constructor.resolve(entries[i]).then(resolve, reject);
	          }
	        });
	      }
	    }
	    var lib$es6$promise$promise$race$$default = lib$es6$promise$promise$race$$race;
	    function lib$es6$promise$promise$reject$$reject(reason) {
	      /*jshint validthis:true */
	      var Constructor = this;
	      var promise = new Constructor(lib$es6$promise$$internal$$noop);
	      lib$es6$promise$$internal$$reject(promise, reason);
	      return promise;
	    }
	    var lib$es6$promise$promise$reject$$default = lib$es6$promise$promise$reject$$reject;


	    function lib$es6$promise$promise$$needsResolver() {
	      throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	    }

	    function lib$es6$promise$promise$$needsNew() {
	      throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	    }

	    var lib$es6$promise$promise$$default = lib$es6$promise$promise$$Promise;
	    /**
	      Promise objects represent the eventual result of an asynchronous operation. The
	      primary way of interacting with a promise is through its `then` method, which
	      registers callbacks to receive either a promise's eventual value or the reason
	      why the promise cannot be fulfilled.

	      Terminology
	      -----------

	      - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	      - `thenable` is an object or function that defines a `then` method.
	      - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	      - `exception` is a value that is thrown using the throw statement.
	      - `reason` is a value that indicates why a promise was rejected.
	      - `settled` the final resting state of a promise, fulfilled or rejected.

	      A promise can be in one of three states: pending, fulfilled, or rejected.

	      Promises that are fulfilled have a fulfillment value and are in the fulfilled
	      state.  Promises that are rejected have a rejection reason and are in the
	      rejected state.  A fulfillment value is never a thenable.

	      Promises can also be said to *resolve* a value.  If this value is also a
	      promise, then the original promise's settled state will match the value's
	      settled state.  So a promise that *resolves* a promise that rejects will
	      itself reject, and a promise that *resolves* a promise that fulfills will
	      itself fulfill.


	      Basic Usage:
	      ------------

	      ```js
	      var promise = new Promise(function(resolve, reject) {
	        // on success
	        resolve(value);

	        // on failure
	        reject(reason);
	      });

	      promise.then(function(value) {
	        // on fulfillment
	      }, function(reason) {
	        // on rejection
	      });
	      ```

	      Advanced Usage:
	      ---------------

	      Promises shine when abstracting away asynchronous interactions such as
	      `XMLHttpRequest`s.

	      ```js
	      function getJSON(url) {
	        return new Promise(function(resolve, reject){
	          var xhr = new XMLHttpRequest();

	          xhr.open('GET', url);
	          xhr.onreadystatechange = handler;
	          xhr.responseType = 'json';
	          xhr.setRequestHeader('Accept', 'application/json');
	          xhr.send();

	          function handler() {
	            if (this.readyState === this.DONE) {
	              if (this.status === 200) {
	                resolve(this.response);
	              } else {
	                reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	              }
	            }
	          };
	        });
	      }

	      getJSON('/posts.json').then(function(json) {
	        // on fulfillment
	      }, function(reason) {
	        // on rejection
	      });
	      ```

	      Unlike callbacks, promises are great composable primitives.

	      ```js
	      Promise.all([
	        getJSON('/posts'),
	        getJSON('/comments')
	      ]).then(function(values){
	        values[0] // => postsJSON
	        values[1] // => commentsJSON

	        return values;
	      });
	      ```

	      @class Promise
	      @param {function} resolver
	      Useful for tooling.
	      @constructor
	    */
	    function lib$es6$promise$promise$$Promise(resolver) {
	      this[lib$es6$promise$$internal$$PROMISE_ID] = lib$es6$promise$$internal$$nextId();
	      this._result = this._state = undefined;
	      this._subscribers = [];

	      if (lib$es6$promise$$internal$$noop !== resolver) {
	        typeof resolver !== 'function' && lib$es6$promise$promise$$needsResolver();
	        this instanceof lib$es6$promise$promise$$Promise ? lib$es6$promise$$internal$$initializePromise(this, resolver) : lib$es6$promise$promise$$needsNew();
	      }
	    }

	    lib$es6$promise$promise$$Promise.all = lib$es6$promise$promise$all$$default;
	    lib$es6$promise$promise$$Promise.race = lib$es6$promise$promise$race$$default;
	    lib$es6$promise$promise$$Promise.resolve = lib$es6$promise$promise$resolve$$default;
	    lib$es6$promise$promise$$Promise.reject = lib$es6$promise$promise$reject$$default;
	    lib$es6$promise$promise$$Promise._setScheduler = lib$es6$promise$asap$$setScheduler;
	    lib$es6$promise$promise$$Promise._setAsap = lib$es6$promise$asap$$setAsap;
	    lib$es6$promise$promise$$Promise._asap = lib$es6$promise$asap$$asap;

	    lib$es6$promise$promise$$Promise.prototype = {
	      constructor: lib$es6$promise$promise$$Promise,

	    /**
	      The primary way of interacting with a promise is through its `then` method,
	      which registers callbacks to receive either a promise's eventual value or the
	      reason why the promise cannot be fulfilled.

	      ```js
	      findUser().then(function(user){
	        // user is available
	      }, function(reason){
	        // user is unavailable, and you are given the reason why
	      });
	      ```

	      Chaining
	      --------

	      The return value of `then` is itself a promise.  This second, 'downstream'
	      promise is resolved with the return value of the first promise's fulfillment
	      or rejection handler, or rejected if the handler throws an exception.

	      ```js
	      findUser().then(function (user) {
	        return user.name;
	      }, function (reason) {
	        return 'default name';
	      }).then(function (userName) {
	        // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	        // will be `'default name'`
	      });

	      findUser().then(function (user) {
	        throw new Error('Found user, but still unhappy');
	      }, function (reason) {
	        throw new Error('`findUser` rejected and we're unhappy');
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	        // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	      });
	      ```
	      If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.

	      ```js
	      findUser().then(function (user) {
	        throw new PedagogicalException('Upstream error');
	      }).then(function (value) {
	        // never reached
	      }).then(function (value) {
	        // never reached
	      }, function (reason) {
	        // The `PedgagocialException` is propagated all the way down to here
	      });
	      ```

	      Assimilation
	      ------------

	      Sometimes the value you want to propagate to a downstream promise can only be
	      retrieved asynchronously. This can be achieved by returning a promise in the
	      fulfillment or rejection handler. The downstream promise will then be pending
	      until the returned promise is settled. This is called *assimilation*.

	      ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // The user's comments are now available
	      });
	      ```

	      If the assimliated promise rejects, then the downstream promise will also reject.

	      ```js
	      findUser().then(function (user) {
	        return findCommentsByAuthor(user);
	      }).then(function (comments) {
	        // If `findCommentsByAuthor` fulfills, we'll have the value here
	      }, function (reason) {
	        // If `findCommentsByAuthor` rejects, we'll have the reason here
	      });
	      ```

	      Simple Example
	      --------------

	      Synchronous Example

	      ```javascript
	      var result;

	      try {
	        result = findResult();
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```

	      Errback Example

	      ```js
	      findResult(function(result, err){
	        if (err) {
	          // failure
	        } else {
	          // success
	        }
	      });
	      ```

	      Promise Example;

	      ```javascript
	      findResult().then(function(result){
	        // success
	      }, function(reason){
	        // failure
	      });
	      ```

	      Advanced Example
	      --------------

	      Synchronous Example

	      ```javascript
	      var author, books;

	      try {
	        author = findAuthor();
	        books  = findBooksByAuthor(author);
	        // success
	      } catch(reason) {
	        // failure
	      }
	      ```

	      Errback Example

	      ```js

	      function foundBooks(books) {

	      }

	      function failure(reason) {

	      }

	      findAuthor(function(author, err){
	        if (err) {
	          failure(err);
	          // failure
	        } else {
	          try {
	            findBoooksByAuthor(author, function(books, err) {
	              if (err) {
	                failure(err);
	              } else {
	                try {
	                  foundBooks(books);
	                } catch(reason) {
	                  failure(reason);
	                }
	              }
	            });
	          } catch(error) {
	            failure(err);
	          }
	          // success
	        }
	      });
	      ```

	      Promise Example;

	      ```javascript
	      findAuthor().
	        then(findBooksByAuthor).
	        then(function(books){
	          // found books
	      }).catch(function(reason){
	        // something went wrong
	      });
	      ```

	      @method then
	      @param {Function} onFulfilled
	      @param {Function} onRejected
	      Useful for tooling.
	      @return {Promise}
	    */
	      then: lib$es6$promise$then$$default,

	    /**
	      `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	      as the catch block of a try/catch statement.

	      ```js
	      function findAuthor(){
	        throw new Error('couldn't find that author');
	      }

	      // synchronous
	      try {
	        findAuthor();
	      } catch(reason) {
	        // something went wrong
	      }

	      // async with promises
	      findAuthor().catch(function(reason){
	        // something went wrong
	      });
	      ```

	      @method catch
	      @param {Function} onRejection
	      Useful for tooling.
	      @return {Promise}
	    */
	      'catch': function(onRejection) {
	        return this.then(null, onRejection);
	      }
	    };
	    var lib$es6$promise$enumerator$$default = lib$es6$promise$enumerator$$Enumerator;
	    function lib$es6$promise$enumerator$$Enumerator(Constructor, input) {
	      this._instanceConstructor = Constructor;
	      this.promise = new Constructor(lib$es6$promise$$internal$$noop);

	      if (!this.promise[lib$es6$promise$$internal$$PROMISE_ID]) {
	        lib$es6$promise$$internal$$makePromise(this.promise);
	      }

	      if (lib$es6$promise$utils$$isArray(input)) {
	        this._input     = input;
	        this.length     = input.length;
	        this._remaining = input.length;

	        this._result = new Array(this.length);

	        if (this.length === 0) {
	          lib$es6$promise$$internal$$fulfill(this.promise, this._result);
	        } else {
	          this.length = this.length || 0;
	          this._enumerate();
	          if (this._remaining === 0) {
	            lib$es6$promise$$internal$$fulfill(this.promise, this._result);
	          }
	        }
	      } else {
	        lib$es6$promise$$internal$$reject(this.promise, lib$es6$promise$enumerator$$validationError());
	      }
	    }

	    function lib$es6$promise$enumerator$$validationError() {
	      return new Error('Array Methods must be provided an Array');
	    }

	    lib$es6$promise$enumerator$$Enumerator.prototype._enumerate = function() {
	      var length  = this.length;
	      var input   = this._input;

	      for (var i = 0; this._state === lib$es6$promise$$internal$$PENDING && i < length; i++) {
	        this._eachEntry(input[i], i);
	      }
	    };

	    lib$es6$promise$enumerator$$Enumerator.prototype._eachEntry = function(entry, i) {
	      var c = this._instanceConstructor;
	      var resolve = c.resolve;

	      if (resolve === lib$es6$promise$promise$resolve$$default) {
	        var then = lib$es6$promise$$internal$$getThen(entry);

	        if (then === lib$es6$promise$then$$default &&
	            entry._state !== lib$es6$promise$$internal$$PENDING) {
	          this._settledAt(entry._state, i, entry._result);
	        } else if (typeof then !== 'function') {
	          this._remaining--;
	          this._result[i] = entry;
	        } else if (c === lib$es6$promise$promise$$default) {
	          var promise = new c(lib$es6$promise$$internal$$noop);
	          lib$es6$promise$$internal$$handleMaybeThenable(promise, entry, then);
	          this._willSettleAt(promise, i);
	        } else {
	          this._willSettleAt(new c(function(resolve) { resolve(entry); }), i);
	        }
	      } else {
	        this._willSettleAt(resolve(entry), i);
	      }
	    };

	    lib$es6$promise$enumerator$$Enumerator.prototype._settledAt = function(state, i, value) {
	      var promise = this.promise;

	      if (promise._state === lib$es6$promise$$internal$$PENDING) {
	        this._remaining--;

	        if (state === lib$es6$promise$$internal$$REJECTED) {
	          lib$es6$promise$$internal$$reject(promise, value);
	        } else {
	          this._result[i] = value;
	        }
	      }

	      if (this._remaining === 0) {
	        lib$es6$promise$$internal$$fulfill(promise, this._result);
	      }
	    };

	    lib$es6$promise$enumerator$$Enumerator.prototype._willSettleAt = function(promise, i) {
	      var enumerator = this;

	      lib$es6$promise$$internal$$subscribe(promise, undefined, function(value) {
	        enumerator._settledAt(lib$es6$promise$$internal$$FULFILLED, i, value);
	      }, function(reason) {
	        enumerator._settledAt(lib$es6$promise$$internal$$REJECTED, i, reason);
	      });
	    };
	    function lib$es6$promise$polyfill$$polyfill() {
	      var local;

	      if (typeof global !== 'undefined') {
	          local = global;
	      } else if (typeof self !== 'undefined') {
	          local = self;
	      } else {
	          try {
	              local = Function('return this')();
	          } catch (e) {
	              throw new Error('polyfill failed because global object is unavailable in this environment');
	          }
	      }

	      var P = local.Promise;

	      if (P && Object.prototype.toString.call(P.resolve()) === '[object Promise]' && !P.cast) {
	        return;
	      }

	      local.Promise = lib$es6$promise$promise$$default;
	    }
	    var lib$es6$promise$polyfill$$default = lib$es6$promise$polyfill$$polyfill;

	    var lib$es6$promise$umd$$ES6Promise = {
	      'Promise': lib$es6$promise$promise$$default,
	      'polyfill': lib$es6$promise$polyfill$$default
	    };

	    /* global define:true module:true window: true */
	    if ("function" === 'function' && __webpack_require__(302)['amd']) {
	      !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return lib$es6$promise$umd$$ES6Promise; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== 'undefined' && module['exports']) {
	      module['exports'] = lib$es6$promise$umd$$ES6Promise;
	    } else if (typeof this !== 'undefined') {
	      this['ES6Promise'] = lib$es6$promise$umd$$ES6Promise;
	    }

	    lib$es6$promise$polyfill$$default();
	}).call(this);


	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(294), (function() { return this; }()), __webpack_require__(300)(module)))

/***/ },
/* 300 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 301 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 302 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 303 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	    value: true
	});

	exports['default'] = function (thing) {

	    if (typeof thing === 'object') {
	        if (thing.constructor && thing.constructor.name) {
	            return thing.constructor.name;
	        }
	    }

	    return typeof thing;
	};

	module.exports = exports['default'];

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.1.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}

		function init (converter) {
			function api (key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}

				// Write

				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);

					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}

					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}

					if (!converter.write) {
						value = encodeURIComponent(String(value))
							.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}

					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);

					return (document.cookie = [
						key, '=', value,
						attributes.expires && '; expires=' + attributes.expires.toUTCString(), // use expires attribute, max-age is not supported by IE
						attributes.path    && '; path=' + attributes.path,
						attributes.domain  && '; domain=' + attributes.domain,
						attributes.secure ? '; secure' : ''
					].join(''));
				}

				// Read

				if (!key) {
					result = {};
				}

				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;

				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var name = parts[0].replace(rdecode, decodeURIComponent);
					var cookie = parts.slice(1).join('=');

					if (cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}

					try {
						cookie = converter.read ?
							converter.read(cookie, name) : converter(cookie, name) ||
							cookie.replace(rdecode, decodeURIComponent);

						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}

						if (key === name) {
							result = cookie;
							break;
						}

						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}

				return result;
			}

			api.set = api;
			api.get = function (key) {
				return api(key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};

			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};

			api.withConverter = init;

			return api;
		}

		return init(function () {});
	}));


/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var _packageJson = __webpack_require__(306);

	var _packageJson2 = _interopRequireDefault(_packageJson);

	var _helpersTypeCheck = __webpack_require__(303);

	var _helpersTypeCheck2 = _interopRequireDefault(_helpersTypeCheck);

	var _jsCookie = __webpack_require__(304);

	var _jsCookie2 = _interopRequireDefault(_jsCookie);

	var _helpersUuid = __webpack_require__(307);

	var _helpersUuid2 = _interopRequireDefault(_helpersUuid);

	var _genericObjectsBusinessDomainDefinition = __webpack_require__(308);

	var _genericObjectsBusinessDomainDefinition2 = _interopRequireDefault(_genericObjectsBusinessDomainDefinition);

	var _genericObjectsBusinessDomainObject = __webpack_require__(309);

	var _genericObjectsBusinessDomainObject2 = _interopRequireDefault(_genericObjectsBusinessDomainObject);

	var _genericObjectsSingleContext = __webpack_require__(314);

	var _genericObjectsSingleContext2 = _interopRequireDefault(_genericObjectsSingleContext);

	var _constantsEventOriginator = __webpack_require__(316);

	var _constantsEventOriginator2 = _interopRequireDefault(_constantsEventOriginator);

	var _uaParserJs = __webpack_require__(317);

	var _uaParserJs2 = _interopRequireDefault(_uaParserJs);

	var _genericObjectsPiiValue = __webpack_require__(310);

	var _genericObjectsPiiValue2 = _interopRequireDefault(_genericObjectsPiiValue);

	var _genericObjectsPiiKeyValue = __webpack_require__(313);

	var _genericObjectsPiiKeyValue2 = _interopRequireDefault(_genericObjectsPiiKeyValue);

	var _helpersViewport = __webpack_require__(319);

	var _helpersViewport2 = _interopRequireDefault(_helpersViewport);

	var _genericObjectsRelatedEvent = __webpack_require__(320);

	var _genericObjectsRelatedEvent2 = _interopRequireDefault(_genericObjectsRelatedEvent);

	var _genericObjectsRelatedBusinessDomainObject = __webpack_require__(321);

	var _genericObjectsRelatedBusinessDomainObject2 = _interopRequireDefault(_genericObjectsRelatedBusinessDomainObject);

	var EventCore = (function () {
		function EventCore() {
			_classCallCheck(this, EventCore);

			this.model = {};
			this.model['event-id'] = (0, _helpersUuid2['default'])();
			this.model['event-id'] = (0, _helpersUuid2['default'])();
			this.model['tmpMetaData'] = {
				'flatteningMethod': 'concise'
			};
			this.setTimestamp(new Date());
			this.setSuperProperties();
			this.setUser();
		}

		_createClass(EventCore, [{
			key: 'revertFlatteningMethod',
			value: function revertFlatteningMethod() {
				this.model['tmpMetaData'].flatteningMethod = 'legacy';
			}
		}, {
			key: 'setPrimaryBusinessDomainObjectType',
			value: function setPrimaryBusinessDomainObjectType(businessDomainDefinition) {
				if (businessDomainDefinition instanceof _genericObjectsBusinessDomainDefinition2['default']) {
					this.model['primary-business-domain-object-type'] = businessDomainDefinition;
					this.revertFlatteningMethod();
				} else {
					console.warn('Invalid eventCore.primary-business-domain-object-type. Expected: BusinessDomainDefinition. Found: ' + (0, _helpersTypeCheck2['default'])(businessDomainDefinition));
				}
				return this;
			}
		}, {
			key: 'setTimestamp',
			value: function setTimestamp(dateTime) {
				if (dateTime) {
					if (typeof dateTime === 'number') {
						this.model['event-timestamp'] = dateTime;
					} else if (dateTime instanceof Date) {
						this.model['event-timestamp'] = dateTime.getTime() / 1000;
					} else {
						console.warn('Event timestamp should be of type number or Date object. FOUND: ' + (0, _helpersTypeCheck2['default'])(dateTime));
					}
				} else {
					this.model['event-timestamp'] = new Date().getTime() / 1000;
				}
				return this;
			}
		}, {
			key: 'setEventExternalName',
			value: function setEventExternalName(eventName) {
				this.model['event-external-name'] = eventName;
				return this;
			}
		}, {
			key: 'setUser',
			value: function setUser(businessDomain) {
				var userId = _jsCookie2['default'].get('traacUserId');

				if (userId) {
					var productContext = new _genericObjectsSingleContext2['default']('product');
					businessDomain = businessDomain || '';
					productContext.setUser(new _genericObjectsBusinessDomainObject2['default'](new _genericObjectsBusinessDomainDefinition2['default'](businessDomain, 'user'), new _genericObjectsPiiValue2['default'](userId)));
					this.setContext(productContext);
				}
			}
		}, {
			key: 'setEventOriginator',
			value: function setEventOriginator(eventOriginator) {
				if (_constantsEventOriginator2['default'].indexOf(eventOriginator) > -1) {
					this.model['event-originiator'] = eventOriginator;
					this.revertFlatteningMethod();
				} else {
					console.warn('Invalid Eventcore.event-originiator. Expected (one of): ' + _constantsEventOriginator2['default'] + '. Found: ' + eventOriginator);
				}

				return this;
			}
		}, {
			key: 'setRelatedEvents',
			value: function setRelatedEvents(relatedEvent) {
				if (relatedEvent instanceof _genericObjectsRelatedEvent2['default']) {
					this.model['related-events'] = this.model['related-events'] || [];
					this.model['related-events'].push(relatedEvent);
					this.revertFlatteningMethod();
				} else {
					console.warn('Invalid EventCore.related-event. Expected: RelatedEvent. Found: ' + (0, _helpersTypeCheck2['default'])(relatedEvent));
				}
				return this;
			}
		}, {
			key: 'setContext',
			value: function setContext(singleContext) {
				if (singleContext instanceof _genericObjectsSingleContext2['default']) {
					this.model['contexts'] = this.model['contexts'] || [];
					this.model['contexts'].push(singleContext);
				} else {
					console.warn('Invalid EventCore.context. Expected: SingleContext. Found: ' + (0, _helpersTypeCheck2['default'])(singleContext));
				}
				return this;
			}
		}, {
			key: 'setRelatedBusinessDomainObject',
			value: function setRelatedBusinessDomainObject(relatedBusinessDomain) {
				if (relatedBusinessDomain instanceof _genericObjectsRelatedBusinessDomainObject2['default']) {
					this.model['related-domain-objects'] = this.model['related-domain-objects'] || [];
					this.model['related-domain-objects'].push(relatedBusinessDomain);
					this.revertFlatteningMethod();
				} else {
					console.warn('Invalid EventCore.related-domain-object. Expected: RelatedBusinessDomainObject. Found: ' + (0, _helpersTypeCheck2['default'])(relatedBusinessDomain));
				}
				return this;
			}
		}, {
			key: 'setMetaData',
			value: function setMetaData(piiKeyValue) {
				if (piiKeyValue instanceof _genericObjectsPiiKeyValue2['default']) {
					this.model['metadata'] = this.model['metadata'] || [];
					this.model['metadata'].push(piiKeyValue);
				} else {
					console.warn('Invalid EventCore.metadata. Expected: PiiKeyValue. Found: ' + (0, _helpersTypeCheck2['default'])(piiKeyValue));
				}
				return this;
			}
		}, {
			key: 'setPlatformContext',
			value: function setPlatformContext() {
				var platform = new _uaParserJs2['default']();
				var platformContext = new _genericObjectsSingleContext2['default']('platform');
				platformContext.setMetaData(new _genericObjectsPiiKeyValue2['default']('browser', platform.getBrowser().name));
				platformContext.setMetaData(new _genericObjectsPiiKeyValue2['default']('browser-version', platform.getBrowser().version));
				platformContext.setMetaData(new _genericObjectsPiiKeyValue2['default']('os', platform.getOS().name));
				platformContext.setMetaData(new _genericObjectsPiiKeyValue2['default']('os-version', platform.getOS().version));
				platformContext.setMetaData(new _genericObjectsPiiKeyValue2['default']('user-agent', platform.getUA()));
				platformContext.setMetaData(new _genericObjectsPiiKeyValue2['default']('current-url', window.location.href));
				platformContext.setMetaData(new _genericObjectsPiiKeyValue2['default']('viewport-height', _helpersViewport2['default'].height));
				platformContext.setMetaData(new _genericObjectsPiiKeyValue2['default']('viewport-width', _helpersViewport2['default'].width));
				platformContext.setMetaData(new _genericObjectsPiiKeyValue2['default']('screen-height', screen.height));
				platformContext.setMetaData(new _genericObjectsPiiKeyValue2['default']('screen-width', screen.width));
				platformContext.setMetaData(new _genericObjectsPiiKeyValue2['default']('traac-sdk', 'javascript'));
				platformContext.setMetaData(new _genericObjectsPiiKeyValue2['default']('traac-sdk-version', _packageJson2['default'].version));
				platformContext.setMetaData(new _genericObjectsPiiKeyValue2['default']('traac-model-version', '2.2.6'));
				platformContext.setMetaData(new _genericObjectsPiiKeyValue2['default']('traac-flattening-method', this.model['tmpMetaData'].flatteningMethod));

				var referrerProps = _jsCookie2['default'].getJSON('traacRef');

				if (referrerProps) {
					for (var key in referrerProps) {
						platformContext.setMetaData(new _genericObjectsPiiKeyValue2['default'](key, referrerProps[key]));
					}
				}

				this.setContext(platformContext);
			}
		}, {
			key: 'setSuperProperties',
			value: function setSuperProperties() {
				var superProps = _jsCookie2['default'].getJSON('traac'),
				    productContext = new _genericObjectsSingleContext2['default']('product');

				if (superProps) {
					for (var key in superProps) {
						productContext.setMetaData(new _genericObjectsPiiKeyValue2['default'](key, superProps[key]));
					}
					this.setContext(productContext);
				}
			}
		}, {
			key: 'build',
			value: function build() {
				//Finally, just before build, set the platform context
				this.setPlatformContext();
				return this.model;
			}
		}]);

		return EventCore;
	})();

	exports['default'] = EventCore;
	module.exports = exports['default'];

/***/ },
/* 306 */
/***/ function(module, exports) {

	module.exports = {
		"name": "traac-web-core",
		"version": "0.4.9",
		"description": "Core library for web client traac integration.",
		"scripts": {
			"build-dev": "webpack",
			"build": "webpack && PROD_ENV=1 webpack"
		},
		"devDependencies": {
			"babel-core": "^5.8.25",
			"babel-loader": "^5.3.2",
			"json-loader": "^0.5.4",
			"node-libs-browser": "^0.5.3",
			"webpack": "^1.12.2"
		},
		"dependencies": {
			"babel-polyfill": "latest",
			"es5-shim": "^4.1.14",
			"es6-promise": "^3.1.2",
			"js-cookie": "^2.0.3",
			"ua-parser-js": "^0.7.9"
		}
	};

/***/ },
/* 307 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	exports['default'] = generateUuid;

	function generateUuid() {

		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0,
			    v = c == 'x' ? r : r & 0x3 | 0x8;
			return v.toString(16);
		});
	}

	module.exports = exports['default'];

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var _helpersTypeCheck = __webpack_require__(303);

	var _helpersTypeCheck2 = _interopRequireDefault(_helpersTypeCheck);

	var BusinessDomainDefinition = (function () {
		function BusinessDomainDefinition(businessDomain, businessObjectType) {
			_classCallCheck(this, BusinessDomainDefinition);

			this.setBusinessDomain(businessDomain);
			this.setBusinessObjectType(businessObjectType);
		}

		_createClass(BusinessDomainDefinition, [{
			key: 'setBusinessDomain',
			value: function setBusinessDomain(businessDomain) {
				if (typeof businessDomain === 'string') {
					this['business-domain'] = businessDomain;
				} else {
					console.warn('Business domain definition -> businessDomain expected string. Found: ' + (0, _helpersTypeCheck2['default'])(businessDomain));
				}
			}
		}, {
			key: 'setBusinessObjectType',
			value: function setBusinessObjectType(businessObjectType) {
				if (typeof businessObjectType === 'string') {
					this['business-object-type'] = businessObjectType;
				} else {
					console.warn('Business domain definition -> businessDomainObjectType expected string. Found: ' + (0, _helpersTypeCheck2['default'])(businessObjectType));
				}
			}
		}]);

		return BusinessDomainDefinition;
	})();

	exports['default'] = BusinessDomainDefinition;
	module.exports = exports['default'];

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var _BusinessDomainDefinition = __webpack_require__(308);

	var _BusinessDomainDefinition2 = _interopRequireDefault(_BusinessDomainDefinition);

	var _piiValue = __webpack_require__(310);

	var _piiValue2 = _interopRequireDefault(_piiValue);

	var _piiKeyValue = __webpack_require__(313);

	var _piiKeyValue2 = _interopRequireDefault(_piiKeyValue);

	var _helpersTypeCheck = __webpack_require__(303);

	var _helpersTypeCheck2 = _interopRequireDefault(_helpersTypeCheck);

	var BusinessDomainObject = (function () {
		function BusinessDomainObject(businessDomainDefinition, objectId) {
			_classCallCheck(this, BusinessDomainObject);

			this.setBusinessDomainType(businessDomainDefinition);
			this.setObjectId(objectId);
		}

		_createClass(BusinessDomainObject, [{
			key: 'setBusinessDomainType',
			value: function setBusinessDomainType(businessDomainType) {
				if (businessDomainType instanceof _BusinessDomainDefinition2['default']) {
					this['business-domain-type'] = businessDomainType;
				} else {
					console.warn('Business domain object type should be a BusinessDomainDefinition object. Current type: ' + (0, _helpersTypeCheck2['default'])(businessDomainType));
				}
			}
		}, {
			key: 'setObjectId',
			value: function setObjectId(objectId) {
				if (objectId instanceof _piiValue2['default']) {
					this['object-id'] = objectId;
				} else {
					console.warn('Business domain object id should be a PiiValue object. Current type: ' + (0, _helpersTypeCheck2['default'])(objectId));
				}
			}
		}, {
			key: 'setMetaData',
			value: function setMetaData(piiKeyValue) {
				if (piiKeyValue instanceof _piiKeyValue2['default']) {
					this.metadata = this.metadata || [];
					this.metadata.push(piiKeyValue);
				} else {
					console.warn('Business domain object meta data should be a PiiKeyValue object. Current type: ' + (0, _helpersTypeCheck2['default'])(piiKeyValue));
				}
			}
		}]);

		return BusinessDomainObject;
	})();

	exports['default'] = BusinessDomainObject;
	module.exports = exports['default'];

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Visibility = __webpack_require__(311);

	var _Visibility2 = _interopRequireDefault(_Visibility);

	var _helpersTypeCheck = __webpack_require__(303);

	var _helpersTypeCheck2 = _interopRequireDefault(_helpersTypeCheck);

	var PiiValue = (function (_PiiVisibility) {
		_inherits(PiiValue, _PiiVisibility);

		function PiiValue(value, visibility, mask) {
			_classCallCheck(this, PiiValue);

			_get(Object.getPrototypeOf(PiiValue.prototype), 'constructor', this).call(this, visibility, mask);
			if (value !== undefined) {
				this.setValue(value);
			}
		}

		_createClass(PiiValue, [{
			key: 'setValue',
			value: function setValue(value) {
				if ((0, _helpersTypeCheck2['default'])(value) === 'string' || (0, _helpersTypeCheck2['default'])(value) === 'number' || (0, _helpersTypeCheck2['default'])(value) === 'boolean' || Array.isArray(value)) {

					if (Array.isArray(value)) {
						//Now check if all elements in the array are a simple data type AND all the same type - TODO TEST THIS
						var valueLength = value.length;
						var newArrayType = undefined,
						    prevArrayType = undefined;

						for (var i = 0; i < valueLength; i++) {

							newArrayType = (0, _helpersTypeCheck2['default'])(value[i]);
							if (newArrayType != 'string' && newArrayType != 'number' && newArrayType != 'boolean') {
								console.warn('Unexpected value found in PiiValue array. Found: ' + (0, _helpersTypeCheck2['default'])(value[i]) + '. Expected: String/Boolean/Number');
								return;
							}

							if (i === 0) {
								prevArrayType = newArrayType;
							} else {
								if (newArrayType != prevArrayType) {
									console.warn('Unexpected value found in PiiValue array. All array values should be of the same type');
									return;
								}
							}
						}
					}

					this['value'] = value;
				} else {
					console.warn('Unexpected PiiValue. Found: ' + (0, _helpersTypeCheck2['default'])(value) + '. Expected: String/Boolean/Number/Array');
				}
			}
		}]);

		return PiiValue;
	})(_Visibility2['default']);

	exports['default'] = PiiValue;
	module.exports = exports['default'];

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var _constantsPiiVisibilityLevel = __webpack_require__(312);

	var _constantsPiiVisibilityLevel2 = _interopRequireDefault(_constantsPiiVisibilityLevel);

	var _helpersTypeCheck = __webpack_require__(303);

	var _helpersTypeCheck2 = _interopRequireDefault(_helpersTypeCheck);

	var PiiVisibility = (function () {
		function PiiVisibility(visibility, mask) {
			_classCallCheck(this, PiiVisibility);

			this.setVisibility(visibility || 'public');
			if (mask) {
				this.setMask(mask);
			}
		}

		_createClass(PiiVisibility, [{
			key: 'setVisibility',
			value: function setVisibility(visibility) {
				if (_constantsPiiVisibilityLevel2['default'].indexOf(visibility) > -1) {
					this.visibility = visibility;
				} else {
					console.warn('Invalid visibility type. FOUND: "' + visibility + '". EXPECTING ONE OF: ', _constantsPiiVisibilityLevel2['default']);
				}
			}
		}, {
			key: 'setMask',
			value: function setMask(mask) {
				if ((0, _helpersTypeCheck2['default'])(mask) === 'string') {
					this.mask = mask;
				} else {
					console.warn('Unexpected PiiVisibility mask. Found: ' + (0, _helpersTypeCheck2['default'])(mask) + '. Expected String.');
				}
			}
		}]);

		return PiiVisibility;
	})();

	exports['default'] = PiiVisibility;
	module.exports = exports['default'];

/***/ },
/* 312 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	exports['default'] = ['public', 'private', 'masked'];
	module.exports = exports['default'];

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Value = __webpack_require__(310);

	var _Value2 = _interopRequireDefault(_Value);

	var _helpersTypeCheck = __webpack_require__(303);

	var _helpersTypeCheck2 = _interopRequireDefault(_helpersTypeCheck);

	var PiiKeyValue = (function (_PiiValue) {
		_inherits(PiiKeyValue, _PiiValue);

		function PiiKeyValue(key, value, visibility, mask) {
			_classCallCheck(this, PiiKeyValue);

			_get(Object.getPrototypeOf(PiiKeyValue.prototype), 'constructor', this).call(this, value, visibility, mask);
			if (key) {
				this.setKey(key);
			}
		}

		_createClass(PiiKeyValue, [{
			key: 'setKey',
			value: function setKey(key) {
				if (typeof key === 'string') {
					this.key = key;
				} else {
					console.warn('Unexpected PiiValue key. Found: ' + (0, _helpersTypeCheck2['default'])(key) + '. Expected String.');
				}
			}
		}]);

		return PiiKeyValue;
	})(_Value2['default']);

	exports['default'] = PiiKeyValue;
	module.exports = exports['default'];

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var _constantsContext_type = __webpack_require__(315);

	var _constantsContext_type2 = _interopRequireDefault(_constantsContext_type);

	var _piiKeyValue = __webpack_require__(313);

	var _piiKeyValue2 = _interopRequireDefault(_piiKeyValue);

	var _BusinessDomainObject = __webpack_require__(309);

	var _BusinessDomainObject2 = _interopRequireDefault(_BusinessDomainObject);

	var _helpersTypeCheck = __webpack_require__(303);

	var _helpersTypeCheck2 = _interopRequireDefault(_helpersTypeCheck);

	var SingleContext = (function () {
		function SingleContext(contextType) {
			_classCallCheck(this, SingleContext);

			if (contextType) {
				this.setContextType(contextType);
			}
		}

		_createClass(SingleContext, [{
			key: 'setContextType',
			value: function setContextType(contextType) {
				if (_constantsContext_type2['default'].indexOf(contextType) > -1) {
					this['context-type'] = contextType;
				} else {
					console.warn('Invalid context type. FOUND: "' + contextType + '". EXPECTING ONE OF: ', _constantsContext_type2['default']);
				}
			}
		}, {
			key: 'setMetaData',
			value: function setMetaData(piiKeyValue) {
				if (piiKeyValue instanceof _piiKeyValue2['default']) {
					this.metadata = this.metadata || [];
					this.metadata.push(piiKeyValue);
				} else {
					console.warn('Single Context meta data should be a PiiKeyValue object. Current type: ' + (0, _helpersTypeCheck2['default'])(piiKeyValue));
				}
			}
		}, {
			key: 'setUser',
			value: function setUser(businessDomainObject) {
				if (businessDomainObject instanceof _BusinessDomainObject2['default']) {
					this.user = businessDomainObject;
				} else {
					console.warn('Single Context user should be a BusinessDomainObject object. Current type: ' + (0, _helpersTypeCheck2['default'])(businessDomainObject));
				}
			}
		}]);

		return SingleContext;
	})();

	exports['default'] = SingleContext;
	module.exports = exports['default'];

/***/ },
/* 315 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	exports['default'] = ['temporal', 'product', 'geospatial', 'platform'];
	module.exports = exports['default'];

/***/ },
/* 316 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	exports['default'] = ['user', 'business-process', 'system'];
	module.exports = exports['default'];

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * UAParser.js v0.7.10
	 * Lightweight JavaScript-based User-Agent string parser
	 * https://github.com/faisalman/ua-parser-js
	 *
	 * Copyright © 2012-2015 Faisal Salman <fyzlman@gmail.com>
	 * Dual licensed under GPLv2 & MIT
	 */

	(function (window, undefined) {

	    'use strict';

	    //////////////
	    // Constants
	    /////////////


	    var LIBVERSION  = '0.7.10',
	        EMPTY       = '',
	        UNKNOWN     = '?',
	        FUNC_TYPE   = 'function',
	        UNDEF_TYPE  = 'undefined',
	        OBJ_TYPE    = 'object',
	        STR_TYPE    = 'string',
	        MAJOR       = 'major', // deprecated
	        MODEL       = 'model',
	        NAME        = 'name',
	        TYPE        = 'type',
	        VENDOR      = 'vendor',
	        VERSION     = 'version',
	        ARCHITECTURE= 'architecture',
	        CONSOLE     = 'console',
	        MOBILE      = 'mobile',
	        TABLET      = 'tablet',
	        SMARTTV     = 'smarttv',
	        WEARABLE    = 'wearable',
	        EMBEDDED    = 'embedded';


	    ///////////
	    // Helper
	    //////////


	    var util = {
	        extend : function (regexes, extensions) {
	            for (var i in extensions) {
	                if ("browser cpu device engine os".indexOf(i) !== -1 && extensions[i].length % 2 === 0) {
	                    regexes[i] = extensions[i].concat(regexes[i]);
	                }
	            }
	            return regexes;
	        },
	        has : function (str1, str2) {
	          if (typeof str1 === "string") {
	            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
	          } else {
	            return false;
	          }
	        },
	        lowerize : function (str) {
	            return str.toLowerCase();
	        },
	        major : function (version) {
	            return typeof(version) === STR_TYPE ? version.split(".")[0] : undefined;
	        }
	    };


	    ///////////////
	    // Map helper
	    //////////////


	    var mapper = {

	        rgx : function () {

	            var result, i = 0, j, k, p, q, matches, match, args = arguments;

	            // loop through all regexes maps
	            while (i < args.length && !matches) {

	                var regex = args[i],       // even sequence (0,2,4,..)
	                    props = args[i + 1];   // odd sequence (1,3,5,..)

	                // construct object barebones
	                if (typeof result === UNDEF_TYPE) {
	                    result = {};
	                    for (p in props) {
	                        if (props.hasOwnProperty(p)){
	                            q = props[p];
	                            if (typeof q === OBJ_TYPE) {
	                                result[q[0]] = undefined;
	                            } else {
	                                result[q] = undefined;
	                            }
	                        }
	                    }
	                }

	                // try matching uastring with regexes
	                j = k = 0;
	                while (j < regex.length && !matches) {
	                    matches = regex[j++].exec(this.getUA());
	                    if (!!matches) {
	                        for (p = 0; p < props.length; p++) {
	                            match = matches[++k];
	                            q = props[p];
	                            // check if given property is actually array
	                            if (typeof q === OBJ_TYPE && q.length > 0) {
	                                if (q.length == 2) {
	                                    if (typeof q[1] == FUNC_TYPE) {
	                                        // assign modified match
	                                        result[q[0]] = q[1].call(this, match);
	                                    } else {
	                                        // assign given value, ignore regex match
	                                        result[q[0]] = q[1];
	                                    }
	                                } else if (q.length == 3) {
	                                    // check whether function or regex
	                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                                        // call function (usually string mapper)
	                                        result[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
	                                    } else {
	                                        // sanitize match using given regex
	                                        result[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
	                                    }
	                                } else if (q.length == 4) {
	                                        result[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
	                                }
	                            } else {
	                                result[q] = match ? match : undefined;
	                            }
	                        }
	                    }
	                }
	                i += 2;
	            }
	            return result;
	        },

	        str : function (str, map) {

	            for (var i in map) {
	                // check if array
	                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
	                    for (var j = 0; j < map[i].length; j++) {
	                        if (util.has(map[i][j], str)) {
	                            return (i === UNKNOWN) ? undefined : i;
	                        }
	                    }
	                } else if (util.has(map[i], str)) {
	                    return (i === UNKNOWN) ? undefined : i;
	                }
	            }
	            return str;
	        }
	    };


	    ///////////////
	    // String map
	    //////////////


	    var maps = {

	        browser : {
	            oldsafari : {
	                version : {
	                    '1.0'   : '/8',
	                    '1.2'   : '/1',
	                    '1.3'   : '/3',
	                    '2.0'   : '/412',
	                    '2.0.2' : '/416',
	                    '2.0.3' : '/417',
	                    '2.0.4' : '/419',
	                    '?'     : '/'
	                }
	            }
	        },

	        device : {
	            amazon : {
	                model : {
	                    'Fire Phone' : ['SD', 'KF']
	                }
	            },
	            sprint : {
	                model : {
	                    'Evo Shift 4G' : '7373KT'
	                },
	                vendor : {
	                    'HTC'       : 'APA',
	                    'Sprint'    : 'Sprint'
	                }
	            }
	        },

	        os : {
	            windows : {
	                version : {
	                    'ME'        : '4.90',
	                    'NT 3.11'   : 'NT3.51',
	                    'NT 4.0'    : 'NT4.0',
	                    '2000'      : 'NT 5.0',
	                    'XP'        : ['NT 5.1', 'NT 5.2'],
	                    'Vista'     : 'NT 6.0',
	                    '7'         : 'NT 6.1',
	                    '8'         : 'NT 6.2',
	                    '8.1'       : 'NT 6.3',
	                    '10'        : ['NT 6.4', 'NT 10.0'],
	                    'RT'        : 'ARM'
	                }
	            }
	        }
	    };


	    //////////////
	    // Regex map
	    /////////////


	    var regexes = {

	        browser : [[

	            // Presto based
	            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
	            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
	            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
	            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80

	            ], [NAME, VERSION], [

	            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
	            ], [[NAME, 'Opera'], VERSION], [

	            // Mixed
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,
	                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer

	            // Trident based
	            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
	                                                                                // Avant/IEMobile/SlimBrowser/Baidu
	            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

	            // Webkit/KHTML based
	            /(rekonq)\/([\w\.]+)*/i,                                            // Rekonq
	            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs)\/([\w\.-]+)/i
	                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS
	            ], [NAME, VERSION], [

	            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
	            ], [[NAME, 'IE'], VERSION], [

	            /(edge)\/((\d+)?[\w\.]+)/i                                          // Microsoft Edge
	            ], [NAME, VERSION], [

	            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
	            ], [[NAME, 'Yandex'], VERSION], [

	            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
	            ], [[NAME, /_/g, ' '], VERSION], [

	            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i,
	                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
	            /(qqbrowser)[\/\s]?([\w\.]+)/i
	                                                                                // QQBrowser
	            ], [NAME, VERSION], [

	            /(uc\s?browser)[\/\s]?([\w\.]+)/i,
	            /ucweb.+(ucbrowser)[\/\s]?([\w\.]+)/i,
	            /JUC.+(ucweb)[\/\s]?([\w\.]+)/i
	                                                                                // UCBrowser
	            ], [[NAME, 'UCBrowser'], VERSION], [

	            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
	            ], [[NAME, 'Dolphin'], VERSION], [

	            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
	            ], [[NAME, 'Chrome'], VERSION], [

	            /XiaoMi\/MiuiBrowser\/([\w\.]+)/i                                   // MIUI Browser
	            ], [VERSION, [NAME, 'MIUI Browser']], [

	            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)/i         // Android Browser
	            ], [VERSION, [NAME, 'Android Browser']], [

	            /FBAV\/([\w\.]+);/i                                                 // Facebook App for iOS
	            ], [VERSION, [NAME, 'Facebook']], [

	            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
	            ], [VERSION, [NAME, 'Firefox']], [

	            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
	            ], [VERSION, [NAME, 'Mobile Safari']], [

	            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
	            ], [VERSION, NAME], [

	            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
	            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

	            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
	            /(webkit|khtml)\/([\w\.]+)/i
	            ], [NAME, VERSION], [

	            // Gecko based
	            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
	            ], [[NAME, 'Netscape'], VERSION], [
	            /(swiftfox)/i,                                                      // Swiftfox
	            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
	                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
	            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,
	                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

	            // Other
	            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
	                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
	            /(links)\s\(([\w\.]+)/i,                                            // Links
	            /(gobrowser)\/?([\w\.]+)*/i,                                        // GoBrowser
	            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
	            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
	            ], [NAME, VERSION]

	            /* /////////////////////
	            // Media players BEGIN
	            ////////////////////////

	            , [

	            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
	            /(coremedia) v((\d+)[\w\._]+)/i
	            ], [NAME, VERSION], [

	            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
	            ], [NAME, VERSION], [

	            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
	            ], [NAME, VERSION], [

	            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
	                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
	                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
	            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
	            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
	            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
	            ], [NAME, VERSION], [
	            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
	            ], [NAME, VERSION], [

	            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
	            ], [[NAME, 'Flip Player'], VERSION], [

	            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
	                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
	            ], [NAME], [

	            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
	                                                                                // Gstreamer
	            ], [NAME, VERSION], [

	            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
	            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
	                                                                                // Java/urllib/requests/wget/cURL
	            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
	            ], [NAME, VERSION], [

	            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
	            ], [[NAME, /_/g, ' '], VERSION], [

	            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
	                                                                                // MPlayer SVN
	            ], [NAME, VERSION], [

	            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
	            ], [NAME, VERSION], [

	            /(mplayer)/i,                                                       // MPlayer (no other info)
	            /(yourmuze)/i,                                                      // YourMuze
	            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
	            ], [NAME], [

	            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
	            ], [NAME, VERSION], [

	            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
	            ], [NAME, VERSION], [

	            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
	            ], [NAME, VERSION], [

	            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
	            /(winamp)\s((\d+)[\w\.-]+)/i,
	            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
	            ], [NAME, VERSION], [

	            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
	                                                                                // inlight radio
	            ], [NAME], [

	            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
	                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
	                                                                                // SoundTap/Totem/Stagefright/Streamium
	            ], [NAME, VERSION], [

	            /(smp)((\d+)[\d\.]+)/i                                              // SMP
	            ], [NAME, VERSION], [

	            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
	            /(vlc)\/((\d+)[\w\.-]+)/i,
	            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
	            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
	            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
	            ], [NAME, VERSION], [

	            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
	            /(windows-media-player)\/((\d+)[\w\.-]+)/i
	            ], [[NAME, /-/g, ' '], VERSION], [

	            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
	                                                                                // Windows Media Server
	            ], [VERSION, [NAME, 'Windows']], [

	            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
	            ], [NAME, VERSION], [

	            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
	            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
	            ], [[NAME, 'rad.io'], VERSION]

	            //////////////////////
	            // Media players END
	            ////////////////////*/

	        ],

	        cpu : [[

	            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
	            ], [[ARCHITECTURE, 'amd64']], [

	            /(ia32(?=;))/i                                                      // IA32 (quicktime)
	            ], [[ARCHITECTURE, util.lowerize]], [

	            /((?:i[346]|x)86)[;\)]/i                                            // IA32
	            ], [[ARCHITECTURE, 'ia32']], [

	            // PocketPC mistakenly identified as PowerPC
	            /windows\s(ce|mobile);\sppc;/i
	            ], [[ARCHITECTURE, 'arm']], [

	            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
	            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

	            /(sun4\w)[;\)]/i                                                    // SPARC
	            ], [[ARCHITECTURE, 'sparc']], [

	            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
	                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
	            ], [[ARCHITECTURE, util.lowerize]]
	        ],

	        device : [[

	            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
	            ], [MODEL, VENDOR, [TYPE, TABLET]], [

	            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

	            /(apple\s{0,1}tv)/i                                                 // Apple TV
	            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

	            /(archos)\s(gamepad2?)/i,                                           // Archos
	            /(hp).+(touchpad)/i,                                                // HP TouchPad
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
	            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [

	            /(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i                               // Kindle Fire HD
	            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
	            /(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i                  // Fire Phone
	            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [

	            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
	            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
	            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

	            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
	            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|huawei|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
	                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Huawei/Meizu/Motorola/Polytron
	            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
	            /(asus)-?(\w+)/i                                                    // Asus
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
	            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
	                                                                                // Asus Tablets
	            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7)/i
	            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

	            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
	            /(sony)?(?:sgp.+)\sbuild\//i
	            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
	            /(?:sony)?(?:(?:(?:c|d)\d{4})|(?:so[-l].+))\sbuild\//i
	            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Phone'], [TYPE, MOBILE]], [

	            /\s(ouya)\s/i,                                                      // Ouya
	            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
	            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

	            /android.+;\s(shield)\sbuild/i                                      // Nvidia
	            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

	            /(playstation\s[34portablevi]+)/i                                   // Playstation
	            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

	            /(sprint\s(\w+))/i                                                  // Sprint Phones
	            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

	            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [

	            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
	            /(zte)-(\w+)*/i,                                                    // ZTE
	            /(alcatel|geeksphone|huawei|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i
	                                                                                // Alcatel/GeeksPhone/Huawei/Lenovo/Nexian/Panasonic/Sony
	            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [
	                
	            /(nexus\s9)/i                                                       // HTC Nexus 9
	            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

	            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
	            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
	            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
	            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

	                                                                                // Motorola
	            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
	            /mot[\s-]?(\w+)*/i,
	            /(XT\d{3,4}) build\//i,
	            /(nexus\s[6])/i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
	            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

	            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n8000|sgh-t8[56]9|nexus 10))/i,
	            /((SM-T\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
	            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-n900))/i,
	            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
	            /sec-((sgh\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [
	            /(samsung);smarttv/i
	            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [

	            /\(dtv[\);].+(aquos)/i                                              // Sharp
	            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
	            /sie-(\w+)*/i                                                       // Siemens
	            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

	            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
	            /(nokia)[\s_-]?([\w-]+)*/i
	            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

	            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
	            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

	            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
	            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
	            /(lg) netcast\.tv/i                                                 // LG SmartTV
	            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
	            /(nexus\s[45])/i,                                                   // LG
	            /lg[e;\s\/-]+(\w+)*/i
	            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

	            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
	            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

	            /linux;.+((jolla));/i                                               // Jolla
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

	            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
	            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

	            /android.+;\s(glass)\s\d/i                                          // Google Glass
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

	            /android.+(\w+)\s+build\/hm\1/i,                                        // Xiaomi Hongmi 'numeric' models
	            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,                   // Xiaomi Hongmi
	            /android.+(mi[\s\-_]*(?:one|one[\s_]plus)?[\s_]*(?:\d\w)?)\s+build/i    // Xiaomi Mi
	            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [

	            /\s(tablet)[;\/\s]/i,                                               // Unidentifiable Tablet
	            /\s(mobile)[;\/\s]/i                                                // Unidentifiable Mobile
	            ], [[TYPE, util.lowerize], VENDOR, MODEL]

	            /*//////////////////////////
	            // TODO: move to string map
	            ////////////////////////////

	            /(C6603)/i                                                          // Sony Xperia Z C6603
	            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	            /(C6903)/i                                                          // Sony Xperia Z 1
	            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [

	            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
	            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
	            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
	            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
	            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
	            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
	            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
	            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [

	            /(R1001)/i                                                          // Oppo R1001
	            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [
	            /(X9006)/i                                                          // Oppo Find 7a
	            ], [[MODEL, 'Find 7a'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	            /(R2001)/i                                                          // Oppo YOYO R2001
	            ], [[MODEL, 'Yoyo R2001'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	            /(R815)/i                                                           // Oppo Clover R815
	            ], [[MODEL, 'Clover R815'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
	             /(U707)/i                                                          // Oppo Find Way S
	            ], [[MODEL, 'Find Way S'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [

	            /(T3C)/i                                                            // Advan Vandroid T3C
	            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
	            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
	            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [

	            /(V972M)/i                                                          // ZTE V972M
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [

	            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
	            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
	            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	            
	            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
	            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [

	            /////////////
	            // END TODO
	            ///////////*/

	        ],

	        engine : [[

	            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
	            ], [VERSION, [NAME, 'EdgeHTML']], [

	            /(presto)\/([\w\.]+)/i,                                             // Presto
	            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
	            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
	            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
	            ], [NAME, VERSION], [

	            /rv\:([\w\.]+).*(gecko)/i                                           // Gecko
	            ], [VERSION, NAME]
	        ],

	        os : [[

	            // Windows based
	            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
	            ], [NAME, VERSION], [
	            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
	            /(windows\sphone(?:\sos)*|windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
	            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
	            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
	            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

	            // Mobile/Embedded OS
	            /\((bb)(10);/i                                                      // BlackBerry 10
	            ], [[NAME, 'BlackBerry'], VERSION], [
	            /(blackberry)\w*\/?([\w\.]+)*/i,                                    // Blackberry
	            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
	            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,
	                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
	            /linux;.+(sailfish);/i                                              // Sailfish OS
	            ], [NAME, VERSION], [
	            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i                 // Symbian
	            ], [[NAME, 'Symbian'], VERSION], [
	            /\((series40);/i                                                    // Series 40
	            ], [NAME], [
	            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
	            ], [[NAME, 'Firefox OS'], VERSION], [

	            // Console
	            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

	            // GNU/Linux based
	            /(mint)[\/\s\(]?(\w+)*/i,                                           // Mint
	            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
	            /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?([\w\.-]+)*/i,
	                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
	                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
	            /(hurd|linux)\s?([\w\.]+)*/i,                                       // Hurd/Linux
	            /(gnu)\s?([\w\.]+)*/i                                               // GNU
	            ], [NAME, VERSION], [

	            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
	            ], [[NAME, 'Chromium OS'], VERSION],[

	            // Solaris
	            /(sunos)\s?([\w\.]+\d)*/i                                           // Solaris
	            ], [[NAME, 'Solaris'], VERSION], [

	            // BSD based
	            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i                   // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
	            ], [NAME, VERSION],[

	            /(ip[honead]+)(?:.*os\s([\w]+)*\slike\smac|;\sopera)/i              // iOS
	            ], [[NAME, 'iOS'], [VERSION, /_/g, '.']], [

	            /(mac\sos\sx)\s?([\w\s\.]+\w)*/i,
	            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
	            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

	            // Other
	            /((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,                            // Solaris
	            /(haiku)\s(\w+)/i,                                                  // Haiku
	            /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,                               // AIX
	            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
	                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
	            /(unix)\s?([\w\.]+)*/i                                              // UNIX
	            ], [NAME, VERSION]
	        ]
	    };


	    /////////////////
	    // Constructor
	    ////////////////


	    var UAParser = function (uastring, extensions) {

	        if (!(this instanceof UAParser)) {
	            return new UAParser(uastring, extensions).getResult();
	        }

	        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
	        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;

	        this.getBrowser = function () {
	            var browser = mapper.rgx.apply(this, rgxmap.browser);
	            browser.major = util.major(browser.version);
	            return browser;
	        };
	        this.getCPU = function () {
	            return mapper.rgx.apply(this, rgxmap.cpu);
	        };
	        this.getDevice = function () {
	            return mapper.rgx.apply(this, rgxmap.device);
	        };
	        this.getEngine = function () {
	            return mapper.rgx.apply(this, rgxmap.engine);
	        };
	        this.getOS = function () {
	            return mapper.rgx.apply(this, rgxmap.os);
	        };
	        this.getResult = function() {
	            return {
	                ua      : this.getUA(),
	                browser : this.getBrowser(),
	                engine  : this.getEngine(),
	                os      : this.getOS(),
	                device  : this.getDevice(),
	                cpu     : this.getCPU()
	            };
	        };
	        this.getUA = function () {
	            return ua;
	        };
	        this.setUA = function (uastring) {
	            ua = uastring;
	            return this;
	        };
	        this.setUA(ua);
	        return this;
	    };

	    UAParser.VERSION = LIBVERSION;
	    UAParser.BROWSER = {
	        NAME    : NAME,
	        MAJOR   : MAJOR, // deprecated
	        VERSION : VERSION
	    };
	    UAParser.CPU = {
	        ARCHITECTURE : ARCHITECTURE
	    };
	    UAParser.DEVICE = {
	        MODEL   : MODEL,
	        VENDOR  : VENDOR,
	        TYPE    : TYPE,
	        CONSOLE : CONSOLE,
	        MOBILE  : MOBILE,
	        SMARTTV : SMARTTV,
	        TABLET  : TABLET,
	        WEARABLE: WEARABLE,
	        EMBEDDED: EMBEDDED
	    };
	    UAParser.ENGINE = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	    UAParser.OS = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };


	    ///////////
	    // Export
	    //////////


	    // check js environment
	    if (typeof(exports) !== UNDEF_TYPE) {
	        // nodejs env
	        if (typeof module !== UNDEF_TYPE && module.exports) {
	            exports = module.exports = UAParser;
	        }
	        exports.UAParser = UAParser;
	    } else {
	        // requirejs env (optional)
	        if ("function" === FUNC_TYPE && __webpack_require__(318)) {
	            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	                return UAParser;
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        } else {
	            // browser env
	            window.UAParser = UAParser;
	        }
	    }

	    // jQuery/Zepto specific (optional)
	    // Note: 
	    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
	    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
	    //   and we should catch that.
	    var $ = window.jQuery || window.Zepto;
	    if (typeof $ !== UNDEF_TYPE) {
	        var parser = new UAParser();
	        $.ua = parser.getResult();
	        $.ua.get = function() {
	            return parser.getUA();
	        };
	        $.ua.set = function (uastring) {
	            parser.setUA(uastring);
	            var result = parser.getResult();
	            for (var prop in result) {
	                $.ua[prop] = result[prop];
	            }
	        };
	    }

	})(typeof window === 'object' ? window : this);


/***/ },
/* 318 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;

	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 319 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	var w = window,
	    d = document,
	    e = d.documentElement,
	    g = d.getElementsByTagName('body')[0],
	    x = w.innerWidth || e.clientWidth || g.clientWidth,
	    y = w.innerHeight || e.clientHeight || g.clientHeight;

	exports['default'] = {
		'width': x,
		'height': y
	};
	module.exports = exports['default'];

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var _helpersTypeCheck = __webpack_require__(303);

	var _helpersTypeCheck2 = _interopRequireDefault(_helpersTypeCheck);

	var RelatedEvent = (function () {
		function RelatedEvent(relationshipType, relatedEventId) {
			_classCallCheck(this, RelatedEvent);

			this.setRelationshipType(relationshipType);
			this.setRelatedEventId(relatedEventId);
		}

		_createClass(RelatedEvent, [{
			key: 'setRelationshipType',
			value: function setRelationshipType(relationshipType) {
				if (typeof relationshipType === 'string') {
					this['relationship-type'] = relationshipType;
				} else {
					console.warn('RelatedEvent relationshipType should be a string. Tried setting to: ' + (0, _helpersTypeCheck2['default'])(relationshipType));
				}
			}
		}, {
			key: 'setRelatedEventId',
			value: function setRelatedEventId(relatedEventId) {
				if (typeof relatedEventId === 'string') {
					this['relationship-event-id'] = relatedEventId;
				} else {
					console.warn('RelatedEvent relationshipType should be a string. Tried setting to: ' + (0, _helpersTypeCheck2['default'])(relatedEventId));
				}
			}
		}]);

		return RelatedEvent;
	})();

	exports['default'] = RelatedEvent;
	module.exports = exports['default'];

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _BusinessDomainObject2 = __webpack_require__(309);

	var _BusinessDomainObject3 = _interopRequireDefault(_BusinessDomainObject2);

	var _helpersTypeCheck = __webpack_require__(303);

	var _helpersTypeCheck2 = _interopRequireDefault(_helpersTypeCheck);

	var RelatedBusinessDomainObject = (function (_BusinessDomainObject) {
		_inherits(RelatedBusinessDomainObject, _BusinessDomainObject);

		function RelatedBusinessDomainObject(relationshipType) {
			_classCallCheck(this, RelatedBusinessDomainObject);

			_get(Object.getPrototypeOf(RelatedBusinessDomainObject.prototype), 'constructor', this).call(this);
			if (relationshipType) {
				this.setRelationshipType(relationshipType);
			}
		}

		_createClass(RelatedBusinessDomainObject, [{
			key: 'setRelationshipType',
			value: function setRelationshipType(relationshipType) {
				if (typeof relationshipType === 'string') {
					this['relationship-type'] = relationshipType;
				} else {
					console.warn('RelatedBusinessDomainObject.relationshipType should be a string. Tried setting to: ' + (0, _helpersTypeCheck2['default'])(relationshipType));
				}
			}
		}]);

		return RelatedBusinessDomainObject;
	})(_BusinessDomainObject3['default']);

	exports['default'] = RelatedBusinessDomainObject;
	module.exports = exports['default'];

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Product = __webpack_require__(323);

	var _Product2 = _interopRequireDefault(_Product);

	var EventSet = (function (_EventProduct) {
		_inherits(EventSet, _EventProduct);

		function EventSet(eventExternalName) {
			_classCallCheck(this, EventSet);

			_get(Object.getPrototypeOf(EventSet.prototype), 'constructor', this).call(this);
			this.setEventExternalName(eventExternalName);
			this.setEventMetaAction('set');
		}

		return EventSet;
	})(_Product2['default']);

	exports['default'] = EventSet;
	module.exports = exports['default'];

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _helpersTypeCheck = __webpack_require__(303);

	var _helpersTypeCheck2 = _interopRequireDefault(_helpersTypeCheck);

	var _Core = __webpack_require__(305);

	var _Core2 = _interopRequireDefault(_Core);

	var _genericObjectsUILocation = __webpack_require__(324);

	var _genericObjectsUILocation2 = _interopRequireDefault(_genericObjectsUILocation);

	var _constantsEventMetaAction = __webpack_require__(325);

	var _constantsEventMetaAction2 = _interopRequireDefault(_constantsEventMetaAction);

	var EventProduct = (function (_EventCore) {
		_inherits(EventProduct, _EventCore);

		function EventProduct() {
			_classCallCheck(this, EventProduct);

			_get(Object.getPrototypeOf(EventProduct.prototype), 'constructor', this).call(this);
		}

		_createClass(EventProduct, [{
			key: 'setEventMetaAction',
			value: function setEventMetaAction(eventMetaAction) {
				if (_constantsEventMetaAction2['default'].indexOf(eventMetaAction) > -1) {
					this.model['event-meta-action'] = eventMetaAction;
					this.revertFlatteningMethod();
				} else {
					console.warn('Invalid EventProduct.event-meta-action. Expected (one of): ' + _constantsEventMetaAction2['default'] + '. Found: ' + eventMetaAction);
				}
				return this;
			}
		}, {
			key: 'setEventAction',
			value: function setEventAction(eventAction) {
				if (typeof eventAction === 'string') {
					this.model['event-action'] = eventAction;
					this.revertFlatteningMethod();
				} else {
					console.warn('Invalid EventProduct.event-action. Expected: String. Found: ' + (0, _helpersTypeCheck2['default'])(eventAction));
				}
				return this;
			}
		}, {
			key: 'setUiLocation',
			value: function setUiLocation(uiLocation) {
				if (uiLocation instanceof _genericObjectsUILocation2['default']) {
					this.model['ui-location'] = uiLocation;
					this.revertFlatteningMethod();
				} else {
					console.warn('Invalid EventProduct.ui-location. Expected: UILocation. Found: ' + (0, _helpersTypeCheck2['default'])(uiLocation));
				}
				return this;
			}
		}]);

		return EventProduct;
	})(_Core2['default']);

	exports['default'] = EventProduct;
	module.exports = exports['default'];

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var _helpersTypeCheck = __webpack_require__(303);

	var _helpersTypeCheck2 = _interopRequireDefault(_helpersTypeCheck);

	var UILocation = (function () {
		function UILocation(name) {
			_classCallCheck(this, UILocation);

			if (!name) {
				console.warn('No name provided when creating new UIElement');
				return;
			}
			this.setName(name);
		}

		_createClass(UILocation, [{
			key: 'setName',
			value: function setName(name) {
				if (typeof name === 'string') {
					this['name'] = name;
				} else {
					console.warn('UI Location name should be a string. Tried setting to: ' + (0, _helpersTypeCheck2['default'])(name));
				}
			}
		}]);

		return UILocation;
	})();

	exports['default'] = UILocation;
	module.exports = exports['default'];

/***/ },
/* 325 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	exports['default'] = ['ui-navigation', 'ui-interaction', 'ui-show', 'ui-hide', 'produce', 'download', 'consume', 'delete', 'update', 'search', 'print', 'refresh', 'authenticate', 'express-interest-on', 'set', 'transact', 'undefined'];
	module.exports = exports['default'];

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Product = __webpack_require__(323);

	var _Product2 = _interopRequireDefault(_Product);

	var EventTransact = (function (_EventProduct) {
		_inherits(EventTransact, _EventProduct);

		function EventTransact(eventExternalName, success) {
			_classCallCheck(this, EventTransact);

			_get(Object.getPrototypeOf(EventTransact.prototype), 'constructor', this).call(this);
			this.setEventExternalName(eventExternalName);
			this.model['success'] = success;
			this.setEventMetaAction('transact');
		}

		return EventTransact;
	})(_Product2['default']);

	exports['default'] = EventTransact;
	module.exports = exports['default'];

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Product = __webpack_require__(323);

	var _Product2 = _interopRequireDefault(_Product);

	var EventExpressInterestOn = (function (_EventProduct) {
		_inherits(EventExpressInterestOn, _EventProduct);

		function EventExpressInterestOn(eventExternalName) {
			_classCallCheck(this, EventExpressInterestOn);

			_get(Object.getPrototypeOf(EventExpressInterestOn.prototype), 'constructor', this).call(this);
			this.setEventExternalName(eventExternalName);
			this.setEventMetaAction('express-interest-on');
		}

		return EventExpressInterestOn;
	})(_Product2['default']);

	exports['default'] = EventExpressInterestOn;
	module.exports = exports['default'];

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Product = __webpack_require__(323);

	var _Product2 = _interopRequireDefault(_Product);

	var _genericObjectsBusinessDomainObject = __webpack_require__(309);

	var _genericObjectsBusinessDomainObject2 = _interopRequireDefault(_genericObjectsBusinessDomainObject);

	var _genericObjectsBusinessDomainDefinition = __webpack_require__(308);

	var _genericObjectsBusinessDomainDefinition2 = _interopRequireDefault(_genericObjectsBusinessDomainDefinition);

	var _genericObjectsPiiValue = __webpack_require__(310);

	var _genericObjectsPiiValue2 = _interopRequireDefault(_genericObjectsPiiValue);

	var EventAuthenticate = (function (_EventProduct) {
		_inherits(EventAuthenticate, _EventProduct);

		/**
	  * Sets the required event external name
	  * @param {String} eventExternalName
	  * @param {Boolean} [success] - Successful authentication
	  * @param {Number} [userId] - User ID
	  * @constructor
	  */

		function EventAuthenticate(eventExternalName, success, userId) {
			_classCallCheck(this, EventAuthenticate);

			_get(Object.getPrototypeOf(EventAuthenticate.prototype), 'constructor', this).call(this);
			this.setEventExternalName(eventExternalName);
			this.setEventMetaAction('authenticate');
			this.model['success'] = success;

			if (userId) {
				this.model['user'] = new _genericObjectsBusinessDomainObject2['default'](new _genericObjectsBusinessDomainDefinition2['default']('', 'user'), new _genericObjectsPiiValue2['default'](userId));
			}
		}

		return EventAuthenticate;
	})(_Product2['default']);

	exports['default'] = EventAuthenticate;
	module.exports = exports['default'];

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Product = __webpack_require__(323);

	var _Product2 = _interopRequireDefault(_Product);

	var EventRefresh = (function (_EventProduct) {
		_inherits(EventRefresh, _EventProduct);

		function EventRefresh(eventExternalName) {
			_classCallCheck(this, EventRefresh);

			_get(Object.getPrototypeOf(EventRefresh.prototype), 'constructor', this).call(this);
			this.setEventExternalName(eventExternalName);
			this.setEventMetaAction('refresh');
		}

		return EventRefresh;
	})(_Product2['default']);

	exports['default'] = EventRefresh;
	module.exports = exports['default'];

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Product = __webpack_require__(323);

	var _Product2 = _interopRequireDefault(_Product);

	var EventPrint = (function (_EventProduct) {
		_inherits(EventPrint, _EventProduct);

		function EventPrint(eventExternalName) {
			_classCallCheck(this, EventPrint);

			_get(Object.getPrototypeOf(EventPrint.prototype), 'constructor', this).call(this);
			this.setEventExternalName(eventExternalName);
			this.setEventMetaAction('print');
		}

		return EventPrint;
	})(_Product2['default']);

	exports['default'] = EventPrint;
	module.exports = exports['default'];

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Product = __webpack_require__(323);

	var _Product2 = _interopRequireDefault(_Product);

	var EventSearch = (function (_EventProduct) {
		_inherits(EventSearch, _EventProduct);

		function EventSearch(eventExternalName) {
			_classCallCheck(this, EventSearch);

			_get(Object.getPrototypeOf(EventSearch.prototype), 'constructor', this).call(this);
			this.setEventExternalName(eventExternalName);
			this.setEventMetaAction('search');
		}

		return EventSearch;
	})(_Product2['default']);

	exports['default'] = EventSearch;
	module.exports = exports['default'];

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Product = __webpack_require__(323);

	var _Product2 = _interopRequireDefault(_Product);

	var EventUpdate = (function (_EventProduct) {
		_inherits(EventUpdate, _EventProduct);

		function EventUpdate(eventExternalName) {
			_classCallCheck(this, EventUpdate);

			_get(Object.getPrototypeOf(EventUpdate.prototype), 'constructor', this).call(this);
			this.setEventExternalName(eventExternalName);
			this.setEventMetaAction('update');
		}

		return EventUpdate;
	})(_Product2['default']);

	exports['default'] = EventUpdate;
	module.exports = exports['default'];

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Product = __webpack_require__(323);

	var _Product2 = _interopRequireDefault(_Product);

	var EventDelete = (function (_EventProduct) {
		_inherits(EventDelete, _EventProduct);

		function EventDelete(eventExternalName) {
			_classCallCheck(this, EventDelete);

			_get(Object.getPrototypeOf(EventDelete.prototype), 'constructor', this).call(this);
			this.setEventExternalName(eventExternalName);
			this.setEventMetaAction('delete');
		}

		return EventDelete;
	})(_Product2['default']);

	exports['default'] = EventDelete;
	module.exports = exports['default'];

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Product = __webpack_require__(323);

	var _Product2 = _interopRequireDefault(_Product);

	var EventConsume = (function (_EventProduct) {
		_inherits(EventConsume, _EventProduct);

		function EventConsume(eventExternalName) {
			_classCallCheck(this, EventConsume);

			_get(Object.getPrototypeOf(EventConsume.prototype), 'constructor', this).call(this);
			this.setEventExternalName(eventExternalName);
			this.setEventMetaAction('consume');
		}

		return EventConsume;
	})(_Product2['default']);

	exports['default'] = EventConsume;
	module.exports = exports['default'];

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Product = __webpack_require__(323);

	var _Product2 = _interopRequireDefault(_Product);

	var EventProduce = (function (_EventProduct) {
		_inherits(EventProduce, _EventProduct);

		function EventProduce(eventExternalName) {
			_classCallCheck(this, EventProduce);

			_get(Object.getPrototypeOf(EventProduce.prototype), 'constructor', this).call(this);
			this.setEventExternalName(eventExternalName);
			this.setEventMetaAction('produce');
		}

		return EventProduce;
	})(_Product2['default']);

	exports['default'] = EventProduce;
	module.exports = exports['default'];

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Product = __webpack_require__(323);

	var _Product2 = _interopRequireDefault(_Product);

	var EventDownload = (function (_EventProduct) {
		_inherits(EventDownload, _EventProduct);

		function EventDownload(eventExternalName) {
			_classCallCheck(this, EventDownload);

			_get(Object.getPrototypeOf(EventDownload.prototype), 'constructor', this).call(this);
			this.setEventExternalName(eventExternalName);
			this.setEventMetaAction('download');
		}

		return EventDownload;
	})(_Product2['default']);

	exports['default'] = EventDownload;
	module.exports = exports['default'];

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Product = __webpack_require__(323);

	var _Product2 = _interopRequireDefault(_Product);

	var _genericObjectsUIElement = __webpack_require__(338);

	var _genericObjectsUIElement2 = _interopRequireDefault(_genericObjectsUIElement);

	var EventUIShow = (function (_EventProduct) {
		_inherits(EventUIShow, _EventProduct);

		function EventUIShow(eventExternalName, uiElementName, enclosingUILocation) {
			_classCallCheck(this, EventUIShow);

			_get(Object.getPrototypeOf(EventUIShow.prototype), 'constructor', this).call(this);
			this.setEventExternalName(eventExternalName);
			this.setEventMetaAction('ui-show');

			if (uiElementName) {
				this.setUIElement(uiElementName, enclosingUILocation);
			}
		}

		_createClass(EventUIShow, [{
			key: 'setUIElement',
			value: function setUIElement(uiElementName, enclosingUILocation) {
				this.model['ui-element'] = new _genericObjectsUIElement2['default'](uiElementName, enclosingUILocation);
			}
		}]);

		return EventUIShow;
	})(_Product2['default']);

	exports['default'] = EventUIShow;
	module.exports = exports['default'];

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var _helpersTypeCheck = __webpack_require__(303);

	var _helpersTypeCheck2 = _interopRequireDefault(_helpersTypeCheck);

	var _UILocation = __webpack_require__(324);

	var _UILocation2 = _interopRequireDefault(_UILocation);

	var UIElement = (function () {
		function UIElement(uiElementName, enclosingUILocation) {
			_classCallCheck(this, UIElement);

			if (!uiElementName) {
				console.warn('No name provided when creating new UIElement');
				return;
			}
			this.setName(uiElementName);

			if (enclosingUILocation) {
				this.setEnclosingUiLocation(enclosingUILocation);
			}
		}

		_createClass(UIElement, [{
			key: 'setName',
			value: function setName(name) {
				if (typeof name === 'string') {
					this['name'] = name;
				} else {
					console.warn('UI Location name should be a string. Tried setting to: ' + (0, _helpersTypeCheck2['default'])(name));
				}
			}
		}, {
			key: 'setEnclosingUiLocation',
			value: function setEnclosingUiLocation(uiLocation) {
				this['enclosingUILocation'] = new _UILocation2['default'](uiLocation);
			}
		}]);

		return UIElement;
	})();

	exports['default'] = UIElement;
	module.exports = exports['default'];

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Product = __webpack_require__(323);

	var _Product2 = _interopRequireDefault(_Product);

	var _genericObjectsUIElement = __webpack_require__(338);

	var _genericObjectsUIElement2 = _interopRequireDefault(_genericObjectsUIElement);

	var EventUIShow = (function (_EventProduct) {
		_inherits(EventUIShow, _EventProduct);

		function EventUIShow(eventExternalName, uiElementName, enclosingUILocation) {
			_classCallCheck(this, EventUIShow);

			_get(Object.getPrototypeOf(EventUIShow.prototype), 'constructor', this).call(this);
			this.setEventExternalName(eventExternalName);
			this.setEventMetaAction('ui-hide');

			if (uiElementName) {
				this.setUIElement(uiElementName, enclosingUILocation);
			}
		}

		_createClass(EventUIShow, [{
			key: 'setUIElement',
			value: function setUIElement(uiElementName, enclosingUILocation) {
				this.model['ui-element'] = new _genericObjectsUIElement2['default'](uiElementName, enclosingUILocation);
			}
		}]);

		return EventUIShow;
	})(_Product2['default']);

	exports['default'] = EventUIShow;
	module.exports = exports['default'];

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Product = __webpack_require__(323);

	var _Product2 = _interopRequireDefault(_Product);

	var _genericObjectsUIElement = __webpack_require__(338);

	var _genericObjectsUIElement2 = _interopRequireDefault(_genericObjectsUIElement);

	var EventUIInteraction = (function (_EventProduct) {
		_inherits(EventUIInteraction, _EventProduct);

		function EventUIInteraction(eventExternalName, uiElementName, enclosingUILocation) {
			_classCallCheck(this, EventUIInteraction);

			_get(Object.getPrototypeOf(EventUIInteraction.prototype), 'constructor', this).call(this);
			this.setEventExternalName(eventExternalName);
			this.setEventMetaAction('ui-interaction');

			if (uiElementName) {
				this.setUIElement(uiElementName, enclosingUILocation);
			}
		}

		_createClass(EventUIInteraction, [{
			key: 'setUIElement',
			value: function setUIElement(uiElementName, enclosingUILocation) {
				this.model['ui-element'] = new _genericObjectsUIElement2['default'](uiElementName, enclosingUILocation);
			}
		}]);

		return EventUIInteraction;
	})(_Product2['default']);

	exports['default'] = EventUIInteraction;
	module.exports = exports['default'];

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Product = __webpack_require__(323);

	var _Product2 = _interopRequireDefault(_Product);

	var _genericObjectsUILocation = __webpack_require__(324);

	var _genericObjectsUILocation2 = _interopRequireDefault(_genericObjectsUILocation);

	var EventUINavigation = (function (_EventProduct) {
		_inherits(EventUINavigation, _EventProduct);

		function EventUINavigation(eventExternalName, uiLocationFrom, uiLocationTo) {
			_classCallCheck(this, EventUINavigation);

			_get(Object.getPrototypeOf(EventUINavigation.prototype), 'constructor', this).call(this);
			this.setEventExternalName(eventExternalName);
			this.setEventMetaAction('ui-navigation');

			if (uiLocationFrom) {
				this.setUILocationFrom(uiLocationFrom);
			}

			if (uiLocationTo) {
				this.setUILocationTo(uiLocationTo);
			}
		}

		_createClass(EventUINavigation, [{
			key: 'setUILocationFrom',
			value: function setUILocationFrom(uiLocationFrom) {
				this.model['ui-location-from'] = new _genericObjectsUILocation2['default'](uiLocationFrom);
			}
		}, {
			key: 'setUILocationTo',
			value: function setUILocationTo(uiLocationTo) {
				this.model['ui-location-to'] = new _genericObjectsUILocation2['default'](uiLocationTo);
			}
		}]);

		return EventUINavigation;
	})(_Product2['default']);

	exports['default'] = EventUINavigation;
	module.exports = exports['default'];

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _Product = __webpack_require__(323);

	var _Product2 = _interopRequireDefault(_Product);

	var _modelGenericObjectsPiiKeyValue = __webpack_require__(313);

	var _modelGenericObjectsPiiKeyValue2 = _interopRequireDefault(_modelGenericObjectsPiiKeyValue);

	var KeyValue = (function (_EventProduct) {
		_inherits(KeyValue, _EventProduct);

		function KeyValue(eventExternalName, properties) {
			_classCallCheck(this, KeyValue);

			_get(Object.getPrototypeOf(KeyValue.prototype), 'constructor', this).call(this);
			this.setEventExternalName(eventExternalName);

			for (var key in properties) {
				if (properties.hasOwnProperty(key)) {
					var value = properties[key];
					this.setMetaData(new _modelGenericObjectsPiiKeyValue2['default'](key, value));
				}
			}
		}

		return KeyValue;
	})(_Product2['default']);

	exports['default'] = KeyValue;
	module.exports = exports['default'];

/***/ },
/* 343 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
		value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var ProviderManager = (function () {
		function ProviderManager() {
			_classCallCheck(this, ProviderManager);

			this.registeredProviders = [];
			this.registerConfiguredAdapters();
			this.eventCBQueue = [];
		}

		_createClass(ProviderManager, [{
			key: 'registerConfiguredAdapters',
			value: function registerConfiguredAdapters() {
				for (var i = 0, len = TRAAC_CONFIG.adapters.length; i < len; i++) {
					this.addProvider(TRAAC_CONFIG.adapters[i].type, TRAAC_CONFIG.adapters[i].config);
				}
			}
		}, {
			key: 'addProvider',
			value: function addProvider(type, config) {
				var provider = undefined;
				try {
					type += 'Adapter';
					provider = new window[type](config);
				} catch (e) {
					console.warn('Unknown provider type: "' + type + '". Have you included the respective provider library?');
					return;
				}
				this.registeredProviders.push(provider);
			}
		}, {
			key: 'run',
			value: function run(method, data) {
				var _this = this;

				for (var provider in this.registeredProviders) {
					if (this.registeredProviders.hasOwnProperty(provider)) {
						this.registeredProviders[provider][method](data, this.eventCBQueue);
					}
				}

				if (method === 'flush') {
					var promises;
					var key;

					(function () {

						var cbRun = false;

						setTimeout(function () {
							if (!cbRun) {
								cbRun = true;
								data.callback();
							}
						}, data.timeout);

						promises = [];

						for (key in _this.eventCBQueue) {
							if (_this.eventCBQueue.hasOwnProperty(key)) {
								promises.push(_this.eventCBQueue[key]);
							}
						}

						Promise.all(promises).then(function () {
							if (!cbRun) {
								cbRun = true;
								data.callback();
							}
						});
					})();
				}
			}
		}]);

		return ProviderManager;
	})();

	exports['default'] = ProviderManager;
	module.exports = exports['default'];

/***/ }
/******/ ])
});
;
        }
    }, 1000);
})(window);
/**
 * Thomson Reuters Authenticator Web Component v1.26.5
 * @license Copyright 2017 Thomson Reuters. All rights reserved.
 * Must support IE9+, Chrome, Firefox, Safari
 * Minimal dependencies
 */
/**
 * Console-polyfill.
 * @license MIT license.
 * https://github.com/paulmillr/console-polyfill
 * Make it safe to do console.log() always.
 * 0.2.3
 */
(function(global) {
  'use strict';
  if (!global.console) {
    global.console = {};
  }
  var con = global.console;
  var prop, method;
  var dummy = function() {};
  var properties = ['memory'];
  var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
     'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
     'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');
  while (prop = properties.pop()) if (!con[prop]) con[prop] = {};
  while (method = methods.pop()) if (typeof con[method] !== 'function') con[method] = dummy;
  // Using `this` for web workers & supports Browserify / Webpack.
})(typeof window === 'undefined' ? this : window);

/**
 * MDN CustomEvent polyfill IE9+
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
(function () {

  if ( typeof window.CustomEvent === "function" ) return false;

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;

})();

/**
 * MDN Array.from polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
// Production steps of ECMA-262, Edition 6, 22.1.2.1
// Reference: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-array.from
if (!Array.from) {
  Array.from = (function () {
    var toStr = Object.prototype.toString;
    var isCallable = function (fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function (value) {
      var number = Number(value);
      if (isNaN(number)) { return 0; }
      if (number === 0 || !isFinite(number)) { return number; }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function (value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike/*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }());
}

/**
 * classList.js: Cross-browser full element.classList implementation.
 * 2014-07-23
 *
 * By Eli Grey, http://eligrey.com
 * Public Domain.
 * NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
 */

/*global self, document, DOMException */

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js*/

if ("document" in self) {

// Full polyfill for browsers with no classList support
if (!("classList" in document.createElement("_"))) {

(function (view) {

"use strict";

if (!('Element' in view)) return;

var
    classListProp = "classList"
  , protoProp = "prototype"
  , elemCtrProto = view.Element[protoProp]
  , objCtr = Object
  , strTrim = String[protoProp].trim || function () {
    return this.replace(/^\s+|\s+$/g, "");
  }
  , arrIndexOf = Array[protoProp].indexOf || function (item) {
    var
        i = 0
      , len = this.length
    ;
    for (; i < len; i++) {
      if (i in this && this[i] === item) {
        return i;
      }
    }
    return -1;
  }
  // Vendors: please allow content code to instantiate DOMExceptions
  , DOMEx = function (type, message) {
    this.name = type;
    this.code = DOMException[type];
    this.message = message;
  }
  , checkTokenAndGetIndex = function (classList, token) {
    if (token === "") {
      throw new DOMEx(
          "SYNTAX_ERR"
        , "An invalid or illegal string was specified"
      );
    }
    if (/\s/.test(token)) {
      throw new DOMEx(
          "INVALID_CHARACTER_ERR"
        , "String contains an invalid character"
      );
    }
    return arrIndexOf.call(classList, token);
  }
  , ClassList = function (elem) {
    var
        trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
      , classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
      , i = 0
      , len = classes.length
    ;
    for (; i < len; i++) {
      this.push(classes[i]);
    }
    this._updateClassName = function () {
      elem.setAttribute("class", this.toString());
    };
  }
  , classListProto = ClassList[protoProp] = []
  , classListGetter = function () {
    return new ClassList(this);
  }
;
// Most DOMException implementations don't allow calling DOMException's toString()
// on non-DOMExceptions. Error's toString() is sufficient here.
DOMEx[protoProp] = Error[protoProp];
classListProto.item = function (i) {
  return this[i] || null;
};
classListProto.contains = function (token) {
  token += "";
  return checkTokenAndGetIndex(this, token) !== -1;
};
classListProto.add = function () {
  var
      tokens = arguments
    , i = 0
    , l = tokens.length
    , token
    , updated = false
  ;
  do {
    token = tokens[i] + "";
    if (checkTokenAndGetIndex(this, token) === -1) {
      this.push(token);
      updated = true;
    }
  }
  while (++i < l);

  if (updated) {
    this._updateClassName();
  }
};
classListProto.remove = function () {
  var
      tokens = arguments
    , i = 0
    , l = tokens.length
    , token
    , updated = false
    , index
  ;
  do {
    token = tokens[i] + "";
    index = checkTokenAndGetIndex(this, token);
    while (index !== -1) {
      this.splice(index, 1);
      updated = true;
      index = checkTokenAndGetIndex(this, token);
    }
  }
  while (++i < l);

  if (updated) {
    this._updateClassName();
  }
};
classListProto.toggle = function (token, force) {
  token += "";

  var
      result = this.contains(token)
    , method = result ?
      force !== true && "remove"
    :
      force !== false && "add"
  ;

  if (method) {
    this[method](token);
  }

  if (force === true || force === false) {
    return force;
  } else {
    return !result;
  }
};
classListProto.toString = function () {
  return this.join(" ");
};

if (objCtr.defineProperty) {
  var classListPropDesc = {
      get: classListGetter
    , enumerable: true
    , configurable: true
  };
  try {
    objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
  } catch (ex) { // IE 8 doesn't support enumerable:true
    if (ex.number === -0x7FF5EC54) {
      classListPropDesc.enumerable = false;
      objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
    }
  }
} else if (objCtr[protoProp].__defineGetter__) {
  elemCtrProto.__defineGetter__(classListProp, classListGetter);
}

}(self));

} else {
// There is full or partial native classList support, so just check if we need
// to normalize the add/remove and toggle APIs.

(function () {
  "use strict";

  var testElement = document.createElement("_");

  testElement.classList.add("c1", "c2");

  // Polyfill for IE 10/11 and Firefox <26, where classList.add and
  // classList.remove exist but support only one argument at a time.
  if (!testElement.classList.contains("c2")) {
    var createMethod = function(method) {
      var original = DOMTokenList.prototype[method];

      DOMTokenList.prototype[method] = function(token) {
        var i, len = arguments.length;

        for (i = 0; i < len; i++) {
          token = arguments[i];
          original.call(this, token);
        }
      };
    };
    createMethod('add');
    createMethod('remove');
  }

  testElement.classList.toggle("c3", false);

  // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
  // support the second argument.
  if (testElement.classList.contains("c3")) {
    var _toggle = DOMTokenList.prototype.toggle;

    DOMTokenList.prototype.toggle = function(token, force) {
      if (1 in arguments && !this.contains(token) === !force) {
        return force;
      } else {
        return _toggle.call(this, token);
      }
    };

  }

  testElement = null;
}());

}

}

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
                                   || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); },
              timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
}());

/**
 * MDN Element.matches() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector;
}
/**
 * MDN String trim polyfill
 * https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/String/trim
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  };
}

/**
 * MDN Array.isArray polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
if (!Array.isArray) {
  Array.isArray = function(arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
}

/**
 * MDN lastElementChild polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/lastElementChild
 */
// Source: https://github.com/Alhadis/Snippets/blob/master/js/polyfills/IE8-child-elements.js
if(!("lastElementChild" in document.documentElement)){
    Object.defineProperty(Element.prototype, "lastElementChild", {
        get: function(){
            for(var nodes = this.children, n, i = nodes.length - 1; i >= 0; --i)
                if(n = nodes[i], 1 === n.nodeType) return n;
            return null;
        }
    });
}

/**
 * MDN firstElementChild polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/firstElementChild
 */
// Source: https://github.com/Alhadis/Snippets/blob/master/js/polyfills/IE8-child-elements.js
if(!("firstElementChild" in document.documentElement)){
    Object.defineProperty(Element.prototype, "firstElementChild", {
        get: function(){
            for(var nodes = this.children, n, i = 0, l = nodes.length; i < l; ++i)
                if(n = nodes[i], 1 === n.nodeType) return n;
            return null;
        }
    });
}

/**
 * MDN previousElementSibling polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/NonDocumentTypeChildNode/previousElementSibling
 */
// Source: https://github.com/Alhadis/Snippets/blob/master/js/polyfills/IE8-child-elements.js
if(!("previousElementSibling" in document.documentElement)){
    Object.defineProperty(Element.prototype, "previousElementSibling", {
        get: function(){
            var e = this.previousSibling;
            while(e && 1 !== e.nodeType)
                e = e.previousSibling;
            return e;
        }
    });
}

/**
 * MDN nextElementSibling polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/NonDocumentTypeChildNode/nextElementSibling
 */
// Source: https://github.com/Alhadis/Snippets/blob/master/js/polyfills/IE8-child-elements.js
if(!("nextElementSibling" in document.documentElement)){
    Object.defineProperty(Element.prototype, "nextElementSibling", {
        get: function(){
            var e = this.nextSibling;
            while(e && 1 !== e.nodeType)
                e = e.nextSibling;
            return e;
        }
    });
}

/**
 * MDN Object.keys polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */

if (!Object.keys) {
  Object.keys = (function() {
    'use strict';
    var hasOwnProperty = Object.prototype.hasOwnProperty,
        hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
        dontEnums = [
          'toString',
          'toLocaleString',
          'valueOf',
          'hasOwnProperty',
          'isPrototypeOf',
          'propertyIsEnumerable',
          'constructor'
        ],
        dontEnumsLength = dontEnums.length;

    return function(obj) {
      if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
        throw new TypeError('Object.keys called on non-object');
      }

      var result = [], prop, i;

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  }());
}

/**
 * MDN Array forEach polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: http://es5.github.io/#x15.4.4.18
if (!Array.prototype.forEach) {

  Array.prototype.forEach = function(callback, thisArg) {

    var T, k;

    if (this === null) {
      throw new TypeError(' this is null or not defined');
    }

    // 1. Let O be the result of calling toObject() passing the
    // |this| value as the argument.
    var O = Object(this);

    // 2. Let lenValue be the result of calling the Get() internal
    // method of O with the argument "length".
    // 3. Let len be toUint32(lenValue).
    var len = O.length >>> 0;

    // 4. If isCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== "function") {
      throw new TypeError(callback + ' is not a function');
    }

    // 5. If thisArg was supplied, let T be thisArg; else let
    // T be undefined.
    if (arguments.length > 1) {
      T = thisArg;
    }

    // 6. Let k be 0
    k = 0;

    // 7. Repeat, while k < len
    while (k < len) {

      var kValue;

      // a. Let Pk be ToString(k).
      //    This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty
      //    internal method of O with argument Pk.
      //    This step can be combined with c
      // c. If kPresent is true, then
      if (k in O) {

        // i. Let kValue be the result of calling the Get internal
        // method of O with argument Pk.
        kValue = O[k];

        // ii. Call the Call internal method of callback with T as
        // the this value and argument list containing kValue, k, and O.
        callback.call(T, kValue, k, O);
      }
      // d. Increase k by 1.
      k++;
    }
    // 8. return undefined
  };
}

/**
 * MDN addEventListener polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * Any copyright is dedicated to the Public Domain. http://creativecommons.org/publicdomain/zero/1.0/
 */
(function() {
  if (!Event.prototype.preventDefault) {
    Event.prototype.preventDefault=function() {
      this.returnValue=false;
    };
  }
  if (!Event.prototype.stopPropagation) {
    Event.prototype.stopPropagation=function() {
      this.cancelBubble=true;
    };
  }
  if (!Element.prototype.addEventListener) {
    var eventListeners=[];

    var addEventListener=function(type,listener /*, useCapture (will be ignored) */) {
      var self=this;
      var wrapper=function(e) {
        e.target=e.srcElement;
        e.currentTarget=self;
        if (typeof listener.handleEvent != 'undefined') {
          listener.handleEvent(e);
        } else {
          listener.call(self,e);
        }
      };
      if (type=="DOMContentLoaded") {
        var wrapper2=function(e) {
          if (document.readyState=="complete") {
            wrapper(e);
          }
        };
        document.attachEvent("onreadystatechange",wrapper2);
        eventListeners.push({object:this,type:type,listener:listener,wrapper:wrapper2});

        if (document.readyState=="complete") {
          var e=new Event();
          e.srcElement=window;
          wrapper2(e);
        }
      } else {
        this.attachEvent("on"+type,wrapper);
        eventListeners.push({object:this,type:type,listener:listener,wrapper:wrapper});
      }
    };
    var removeEventListener=function(type,listener /*, useCapture (will be ignored) */) {
      var counter=0;
      while (counter<eventListeners.length) {
        var eventListener=eventListeners[counter];
        if (eventListener.object==this && eventListener.type==type && eventListener.listener==listener) {
          if (type=="DOMContentLoaded") {
            this.detachEvent("onreadystatechange",eventListener.wrapper);
          } else {
            this.detachEvent("on"+type,eventListener.wrapper);
          }
          eventListeners.splice(counter, 1);
          break;
        }
        ++counter;
      }
    };
    Element.prototype.addEventListener=addEventListener;
    Element.prototype.removeEventListener=removeEventListener;
    if (HTMLDocument) {
      HTMLDocument.prototype.addEventListener=addEventListener;
      HTMLDocument.prototype.removeEventListener=removeEventListener;
    }
    if (Window) {
      Window.prototype.addEventListener=addEventListener;
      Window.prototype.removeEventListener=removeEventListener;
    }
  }
})();
/*
 * underscore.template 0.1.7
 * Extracted template from Underscore, use '_.template' without full underscore source.
 * https://github.com/superRaytin/underscore.template
 *
 * Copyright 2015-present, Leon Shi
 * Released under the MIT license.
*/

!function e(r,n,t){function o(u,i){if(!n[u]){if(!r[u]){var c="function"==typeof require&&require;if(!i&&c)return c(u,!0);if(a)return a(u,!0);throw new Error("Cannot find module '"+u+"'")}var f=n[u]={exports:{}};r[u][0].call(f.exports,function(e){var n=r[u][1][e];return o(n?n:e)},f,f.exports,e,r,n,t)}return n[u].exports}for(var a="function"==typeof require&&require,u=0;u<t.length;u++)o(t[u]);return o}({1:[function(e,r,n){"use strict";function t(e,r,n){return a(e,r,n)}var o=e("./underscore.template"),a=o.template;t._=o,r.exports=t,"function"==typeof define&&define.amd?define(function(){return t}):("undefined"!=typeof window||"undefined"!=typeof navigator)&&(window.UnderscoreTemplate=t)},{"./underscore.template":2}],2:[function(e,r,n){"use strict";var t={},o=Array.prototype,a=Object.prototype,u=o.slice,i=a.toString,c=a.hasOwnProperty,f=o.forEach,l=Object.keys,s=Array.isArray,p=function(){},v=p.each=p.forEach=function(e,r,n){if(null!=e)if(f&&e.forEach===f)e.forEach(r,n);else if(e.length===+e.length){for(var o=0,a=e.length;a>o;o++)if(r.call(n,e[o],o,e)===t)return}else for(var u=p.keys(e),o=0,a=u.length;a>o;o++)if(r.call(n,e[u[o]],u[o],e)===t)return};p.keys=l||function(e){if(e!==Object(e))throw new TypeError("Invalid object");var r=[];for(var n in e)p.has(e,n)&&r.push(n);return r},p.defaults=function(e){return v(u.call(arguments,1),function(r){if(r)for(var n in r)void 0===e[n]&&(e[n]=r[n])}),e},p.isArray=s||function(e){return"[object Array]"===i.call(e)},p.has=function(e,r){if(!p.isArray(r))return null!=e&&c.call(e,r);for(var n=r.length,t=0;n>t;t++){var o=r[t];if(null==e||!c.call(e,o))return!1;e=e[o]}return!!n};var _={escape:{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;"}},h={escape:new RegExp("["+p.keys(_.escape).join("")+"]","g")};p.each(["escape"],function(e){p[e]=function(r){return null==r?"":(""+r).replace(h[e],function(r){return _[e][r]})}}),p.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var g=/(.)^/,y={"'":"'","\\":"\\","\r":"r","\n":"n","	":"t","\u2028":"u2028","\u2029":"u2029"},d=/\\|'|\r|\n|\t|\u2028|\u2029/g;p.template=function(e,r,n){var t;n=p.defaults({},n,p.templateSettings);var o=new RegExp([(n.escape||g).source,(n.interpolate||g).source,(n.evaluate||g).source].join("|")+"|$","g"),a=0,u="__p+='";e.replace(o,function(r,n,t,o,i){return u+=e.slice(a,i).replace(d,function(e){return"\\"+y[e]}),n&&(u+="'+\n((__t=("+n+"))==null?'':_.escape(__t))+\n'"),t&&(u+="'+\n((__t=("+t+"))==null?'':__t)+\n'"),o&&(u+="';\n"+o+"\n__p+='"),a=i+r.length,r}),u+="';\n",n.variable||(u="with(obj||{}){\n"+u+"}\n"),u="var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n"+u+"return __p;\n";try{t=new Function(n.variable||"obj","_",u)}catch(i){throw i.source=u,i}if(r)return t(r,p);var c=function(e){return t.call(this,e,p)};return c.source="function("+(n.variable||"obj")+"){\n"+u+"}",c},r.exports=p},{}]},{},[1]);!function a(b,c,d){function e(g,h){if(!c[g]){if(!b[g]){var i="function"==typeof require&&require;if(!h&&i)return i(g,!0);if(f)return f(g,!0);var j=new Error("Cannot find module '"+g+"'");throw j.code="MODULE_NOT_FOUND",j}var k=c[g]={exports:{}};b[g][0].call(k.exports,function(a){var c=b[g][1][a];return e(c?c:a)},k,k.exports,a,b,c,d)}return c[g].exports}for(var f="function"==typeof require&&require,g=0;g<d.length;g++)e(d[g]);return e}({1:[function(a,b,c){function d(a){this.message=a}function e(a){var b=String(a).replace(/=+$/,"");if(b.length%4==1)throw new d("'atob' failed: The string to be decoded is not correctly encoded.");for(var c,e,g=0,h=0,i="";e=b.charAt(h++);~e&&(c=g%4?64*c+e:e,g++%4)?i+=String.fromCharCode(255&c>>(-2*g&6)):0)e=f.indexOf(e);return i}var f="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";d.prototype=new Error,d.prototype.name="InvalidCharacterError",b.exports="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||e},{}],2:[function(a,b,c){function d(a){return decodeURIComponent(e(a).replace(/(.)/g,function(a,b){var c=b.charCodeAt(0).toString(16).toUpperCase();return c.length<2&&(c="0"+c),"%"+c}))}var e=a("./atob");b.exports=function(a){var b=a.replace(/-/g,"+").replace(/_/g,"/");switch(b.length%4){case 0:break;case 2:b+="==";break;case 3:b+="=";break;default:throw"Illegal base64url string!"}try{return d(b)}catch(c){return e(b)}}},{"./atob":1}],3:[function(a,b,c){"use strict";var d=a("./base64_url_decode");b.exports=function(a,b){if("string"!=typeof a)throw new Error("Invalid token specified");b=b||{};var c=b.header===!0?0:1;return JSON.parse(d(a.split(".")[c]))}},{"./base64_url_decode":2}],4:[function(a,b,c){(function(b){var c=a("./lib/index");"function"==typeof b.window.define&&b.window.define.amd?b.window.define("jwt_decode",function(){return c}):b.window&&(b.window.jwt_decode=c)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./lib/index":3}]},{},[4]);/**
 * @fileoverview
 * - Using the 'QRCode for Javascript library'
 * - Fixed dataset of 'QRCode for Javascript library' for support full-spec.
 * - this library has no dependencies.
 * 
 * @author davidshimjs
 * @see <a href="http://www.d-project.com/" target="_blank">http://www.d-project.com/</a>
 * @see <a href="http://jeromeetienne.github.com/jquery-qrcode/" target="_blank">http://jeromeetienne.github.com/jquery-qrcode/</a>
 */
var QRCode;

(function () {
	//---------------------------------------------------------------------
	// QRCode for JavaScript
	//
	// Copyright (c) 2009 Kazuhiko Arase
	//
	// URL: http://www.d-project.com/
	//
	// Licensed under the MIT license:
	//   http://www.opensource.org/licenses/mit-license.php
	//
	// The word "QR Code" is registered trademark of 
	// DENSO WAVE INCORPORATED
	//   http://www.denso-wave.com/qrcode/faqpatent-e.html
	//
	//---------------------------------------------------------------------
	function QR8bitByte(data) {
		this.mode = QRMode.MODE_8BIT_BYTE;
		this.data = data;
		this.parsedData = [];

		// Added to support UTF-8 Characters
		for (var i = 0, l = this.data.length; i < l; i++) {
			var byteArray = [];
			var code = this.data.charCodeAt(i);

			if (code > 0x10000) {
				byteArray[0] = 0xF0 | ((code & 0x1C0000) >>> 18);
				byteArray[1] = 0x80 | ((code & 0x3F000) >>> 12);
				byteArray[2] = 0x80 | ((code & 0xFC0) >>> 6);
				byteArray[3] = 0x80 | (code & 0x3F);
			} else if (code > 0x800) {
				byteArray[0] = 0xE0 | ((code & 0xF000) >>> 12);
				byteArray[1] = 0x80 | ((code & 0xFC0) >>> 6);
				byteArray[2] = 0x80 | (code & 0x3F);
			} else if (code > 0x80) {
				byteArray[0] = 0xC0 | ((code & 0x7C0) >>> 6);
				byteArray[1] = 0x80 | (code & 0x3F);
			} else {
				byteArray[0] = code;
			}

			this.parsedData.push(byteArray);
		}

		this.parsedData = Array.prototype.concat.apply([], this.parsedData);

		if (this.parsedData.length != this.data.length) {
			this.parsedData.unshift(191);
			this.parsedData.unshift(187);
			this.parsedData.unshift(239);
		}
	}

	QR8bitByte.prototype = {
		getLength: function (buffer) {
			return this.parsedData.length;
		},
		write: function (buffer) {
			for (var i = 0, l = this.parsedData.length; i < l; i++) {
				buffer.put(this.parsedData[i], 8);
			}
		}
	};

	function QRCodeModel(typeNumber, errorCorrectLevel) {
		this.typeNumber = typeNumber;
		this.errorCorrectLevel = errorCorrectLevel;
		this.modules = null;
		this.moduleCount = 0;
		this.dataCache = null;
		this.dataList = [];
	}

	QRCodeModel.prototype={addData:function(data){var newData=new QR8bitByte(data);this.dataList.push(newData);this.dataCache=null;},isDark:function(row,col){if(row<0||this.moduleCount<=row||col<0||this.moduleCount<=col){throw new Error(row+","+col);}
	return this.modules[row][col];},getModuleCount:function(){return this.moduleCount;},make:function(){this.makeImpl(false,this.getBestMaskPattern());},makeImpl:function(test,maskPattern){this.moduleCount=this.typeNumber*4+17;this.modules=new Array(this.moduleCount);for(var row=0;row<this.moduleCount;row++){this.modules[row]=new Array(this.moduleCount);for(var col=0;col<this.moduleCount;col++){this.modules[row][col]=null;}}
	this.setupPositionProbePattern(0,0);this.setupPositionProbePattern(this.moduleCount-7,0);this.setupPositionProbePattern(0,this.moduleCount-7);this.setupPositionAdjustPattern();this.setupTimingPattern();this.setupTypeInfo(test,maskPattern);if(this.typeNumber>=7){this.setupTypeNumber(test);}
	if(this.dataCache==null){this.dataCache=QRCodeModel.createData(this.typeNumber,this.errorCorrectLevel,this.dataList);}
	this.mapData(this.dataCache,maskPattern);},setupPositionProbePattern:function(row,col){for(var r=-1;r<=7;r++){if(row+r<=-1||this.moduleCount<=row+r)continue;for(var c=-1;c<=7;c++){if(col+c<=-1||this.moduleCount<=col+c)continue;if((0<=r&&r<=6&&(c==0||c==6))||(0<=c&&c<=6&&(r==0||r==6))||(2<=r&&r<=4&&2<=c&&c<=4)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}},getBestMaskPattern:function(){var minLostPoint=0;var pattern=0;for(var i=0;i<8;i++){this.makeImpl(true,i);var lostPoint=QRUtil.getLostPoint(this);if(i==0||minLostPoint>lostPoint){minLostPoint=lostPoint;pattern=i;}}
	return pattern;},createMovieClip:function(target_mc,instance_name,depth){var qr_mc=target_mc.createEmptyMovieClip(instance_name,depth);var cs=1;this.make();for(var row=0;row<this.modules.length;row++){var y=row*cs;for(var col=0;col<this.modules[row].length;col++){var x=col*cs;var dark=this.modules[row][col];if(dark){qr_mc.beginFill(0,100);qr_mc.moveTo(x,y);qr_mc.lineTo(x+cs,y);qr_mc.lineTo(x+cs,y+cs);qr_mc.lineTo(x,y+cs);qr_mc.endFill();}}}
	return qr_mc;},setupTimingPattern:function(){for(var r=8;r<this.moduleCount-8;r++){if(this.modules[r][6]!=null){continue;}
	this.modules[r][6]=(r%2==0);}
	for(var c=8;c<this.moduleCount-8;c++){if(this.modules[6][c]!=null){continue;}
	this.modules[6][c]=(c%2==0);}},setupPositionAdjustPattern:function(){var pos=QRUtil.getPatternPosition(this.typeNumber);for(var i=0;i<pos.length;i++){for(var j=0;j<pos.length;j++){var row=pos[i];var col=pos[j];if(this.modules[row][col]!=null){continue;}
	for(var r=-2;r<=2;r++){for(var c=-2;c<=2;c++){if(r==-2||r==2||c==-2||c==2||(r==0&&c==0)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}}}},setupTypeNumber:function(test){var bits=QRUtil.getBCHTypeNumber(this.typeNumber);for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[Math.floor(i/3)][i%3+this.moduleCount-8-3]=mod;}
	for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[i%3+this.moduleCount-8-3][Math.floor(i/3)]=mod;}},setupTypeInfo:function(test,maskPattern){var data=(this.errorCorrectLevel<<3)|maskPattern;var bits=QRUtil.getBCHTypeInfo(data);for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<6){this.modules[i][8]=mod;}else if(i<8){this.modules[i+1][8]=mod;}else{this.modules[this.moduleCount-15+i][8]=mod;}}
	for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<8){this.modules[8][this.moduleCount-i-1]=mod;}else if(i<9){this.modules[8][15-i-1+1]=mod;}else{this.modules[8][15-i-1]=mod;}}
	this.modules[this.moduleCount-8][8]=(!test);},mapData:function(data,maskPattern){var inc=-1;var row=this.moduleCount-1;var bitIndex=7;var byteIndex=0;for(var col=this.moduleCount-1;col>0;col-=2){if(col==6)col--;while(true){for(var c=0;c<2;c++){if(this.modules[row][col-c]==null){var dark=false;if(byteIndex<data.length){dark=(((data[byteIndex]>>>bitIndex)&1)==1);}
	var mask=QRUtil.getMask(maskPattern,row,col-c);if(mask){dark=!dark;}
	this.modules[row][col-c]=dark;bitIndex--;if(bitIndex==-1){byteIndex++;bitIndex=7;}}}
	row+=inc;if(row<0||this.moduleCount<=row){row-=inc;inc=-inc;break;}}}}};QRCodeModel.PAD0=0xEC;QRCodeModel.PAD1=0x11;QRCodeModel.createData=function(typeNumber,errorCorrectLevel,dataList){var rsBlocks=QRRSBlock.getRSBlocks(typeNumber,errorCorrectLevel);var buffer=new QRBitBuffer();for(var i=0;i<dataList.length;i++){var data=dataList[i];buffer.put(data.mode,4);buffer.put(data.getLength(),QRUtil.getLengthInBits(data.mode,typeNumber));data.write(buffer);}
	var totalDataCount=0;for(var i=0;i<rsBlocks.length;i++){totalDataCount+=rsBlocks[i].dataCount;}
	if(buffer.getLengthInBits()>totalDataCount*8){throw new Error("code length overflow. ("
	+buffer.getLengthInBits()
	+">"
	+totalDataCount*8
	+")");}
	if(buffer.getLengthInBits()+4<=totalDataCount*8){buffer.put(0,4);}
	while(buffer.getLengthInBits()%8!=0){buffer.putBit(false);}
	while(true){if(buffer.getLengthInBits()>=totalDataCount*8){break;}
	buffer.put(QRCodeModel.PAD0,8);if(buffer.getLengthInBits()>=totalDataCount*8){break;}
	buffer.put(QRCodeModel.PAD1,8);}
	return QRCodeModel.createBytes(buffer,rsBlocks);};QRCodeModel.createBytes=function(buffer,rsBlocks){var offset=0;var maxDcCount=0;var maxEcCount=0;var dcdata=new Array(rsBlocks.length);var ecdata=new Array(rsBlocks.length);for(var r=0;r<rsBlocks.length;r++){var dcCount=rsBlocks[r].dataCount;var ecCount=rsBlocks[r].totalCount-dcCount;maxDcCount=Math.max(maxDcCount,dcCount);maxEcCount=Math.max(maxEcCount,ecCount);dcdata[r]=new Array(dcCount);for(var i=0;i<dcdata[r].length;i++){dcdata[r][i]=0xff&buffer.buffer[i+offset];}
	offset+=dcCount;var rsPoly=QRUtil.getErrorCorrectPolynomial(ecCount);var rawPoly=new QRPolynomial(dcdata[r],rsPoly.getLength()-1);var modPoly=rawPoly.mod(rsPoly);ecdata[r]=new Array(rsPoly.getLength()-1);for(var i=0;i<ecdata[r].length;i++){var modIndex=i+modPoly.getLength()-ecdata[r].length;ecdata[r][i]=(modIndex>=0)?modPoly.get(modIndex):0;}}
	var totalCodeCount=0;for(var i=0;i<rsBlocks.length;i++){totalCodeCount+=rsBlocks[i].totalCount;}
	var data=new Array(totalCodeCount);var index=0;for(var i=0;i<maxDcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<dcdata[r].length){data[index++]=dcdata[r][i];}}}
	for(var i=0;i<maxEcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<ecdata[r].length){data[index++]=ecdata[r][i];}}}
	return data;};var QRMode={MODE_NUMBER:1<<0,MODE_ALPHA_NUM:1<<1,MODE_8BIT_BYTE:1<<2,MODE_KANJI:1<<3};var QRErrorCorrectLevel={L:1,M:0,Q:3,H:2};var QRMaskPattern={PATTERN000:0,PATTERN001:1,PATTERN010:2,PATTERN011:3,PATTERN100:4,PATTERN101:5,PATTERN110:6,PATTERN111:7};var QRUtil={PATTERN_POSITION_TABLE:[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],G15:(1<<10)|(1<<8)|(1<<5)|(1<<4)|(1<<2)|(1<<1)|(1<<0),G18:(1<<12)|(1<<11)|(1<<10)|(1<<9)|(1<<8)|(1<<5)|(1<<2)|(1<<0),G15_MASK:(1<<14)|(1<<12)|(1<<10)|(1<<4)|(1<<1),getBCHTypeInfo:function(data){var d=data<<10;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)>=0){d^=(QRUtil.G15<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)));}
	return((data<<10)|d)^QRUtil.G15_MASK;},getBCHTypeNumber:function(data){var d=data<<12;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)>=0){d^=(QRUtil.G18<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)));}
	return(data<<12)|d;},getBCHDigit:function(data){var digit=0;while(data!=0){digit++;data>>>=1;}
	return digit;},getPatternPosition:function(typeNumber){return QRUtil.PATTERN_POSITION_TABLE[typeNumber-1];},getMask:function(maskPattern,i,j){switch(maskPattern){case QRMaskPattern.PATTERN000:return(i+j)%2==0;case QRMaskPattern.PATTERN001:return i%2==0;case QRMaskPattern.PATTERN010:return j%3==0;case QRMaskPattern.PATTERN011:return(i+j)%3==0;case QRMaskPattern.PATTERN100:return(Math.floor(i/2)+Math.floor(j/3))%2==0;case QRMaskPattern.PATTERN101:return(i*j)%2+(i*j)%3==0;case QRMaskPattern.PATTERN110:return((i*j)%2+(i*j)%3)%2==0;case QRMaskPattern.PATTERN111:return((i*j)%3+(i+j)%2)%2==0;default:throw new Error("bad maskPattern:"+maskPattern);}},getErrorCorrectPolynomial:function(errorCorrectLength){var a=new QRPolynomial([1],0);for(var i=0;i<errorCorrectLength;i++){a=a.multiply(new QRPolynomial([1,QRMath.gexp(i)],0));}
	return a;},getLengthInBits:function(mode,type){if(1<=type&&type<10){switch(mode){case QRMode.MODE_NUMBER:return 10;case QRMode.MODE_ALPHA_NUM:return 9;case QRMode.MODE_8BIT_BYTE:return 8;case QRMode.MODE_KANJI:return 8;default:throw new Error("mode:"+mode);}}else if(type<27){switch(mode){case QRMode.MODE_NUMBER:return 12;case QRMode.MODE_ALPHA_NUM:return 11;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 10;default:throw new Error("mode:"+mode);}}else if(type<41){switch(mode){case QRMode.MODE_NUMBER:return 14;case QRMode.MODE_ALPHA_NUM:return 13;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 12;default:throw new Error("mode:"+mode);}}else{throw new Error("type:"+type);}},getLostPoint:function(qrCode){var moduleCount=qrCode.getModuleCount();var lostPoint=0;for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount;col++){var sameCount=0;var dark=qrCode.isDark(row,col);for(var r=-1;r<=1;r++){if(row+r<0||moduleCount<=row+r){continue;}
	for(var c=-1;c<=1;c++){if(col+c<0||moduleCount<=col+c){continue;}
	if(r==0&&c==0){continue;}
	if(dark==qrCode.isDark(row+r,col+c)){sameCount++;}}}
	if(sameCount>5){lostPoint+=(3+sameCount-5);}}}
	for(var row=0;row<moduleCount-1;row++){for(var col=0;col<moduleCount-1;col++){var count=0;if(qrCode.isDark(row,col))count++;if(qrCode.isDark(row+1,col))count++;if(qrCode.isDark(row,col+1))count++;if(qrCode.isDark(row+1,col+1))count++;if(count==0||count==4){lostPoint+=3;}}}
	for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount-6;col++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row,col+1)&&qrCode.isDark(row,col+2)&&qrCode.isDark(row,col+3)&&qrCode.isDark(row,col+4)&&!qrCode.isDark(row,col+5)&&qrCode.isDark(row,col+6)){lostPoint+=40;}}}
	for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount-6;row++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row+1,col)&&qrCode.isDark(row+2,col)&&qrCode.isDark(row+3,col)&&qrCode.isDark(row+4,col)&&!qrCode.isDark(row+5,col)&&qrCode.isDark(row+6,col)){lostPoint+=40;}}}
	var darkCount=0;for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount;row++){if(qrCode.isDark(row,col)){darkCount++;}}}
	var ratio=Math.abs(100*darkCount/moduleCount/moduleCount-50)/5;lostPoint+=ratio*10;return lostPoint;}};var QRMath={glog:function(n){if(n<1){throw new Error("glog("+n+")");}
	return QRMath.LOG_TABLE[n];},gexp:function(n){while(n<0){n+=255;}
	while(n>=256){n-=255;}
	return QRMath.EXP_TABLE[n];},EXP_TABLE:new Array(256),LOG_TABLE:new Array(256)};for(var i=0;i<8;i++){QRMath.EXP_TABLE[i]=1<<i;}
	for(var i=8;i<256;i++){QRMath.EXP_TABLE[i]=QRMath.EXP_TABLE[i-4]^QRMath.EXP_TABLE[i-5]^QRMath.EXP_TABLE[i-6]^QRMath.EXP_TABLE[i-8];}
	for(var i=0;i<255;i++){QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]]=i;}
	function QRPolynomial(num,shift){if(num.length==undefined){throw new Error(num.length+"/"+shift);}
	var offset=0;while(offset<num.length&&num[offset]==0){offset++;}
	this.num=new Array(num.length-offset+shift);for(var i=0;i<num.length-offset;i++){this.num[i]=num[i+offset];}}
	QRPolynomial.prototype={get:function(index){return this.num[index];},getLength:function(){return this.num.length;},multiply:function(e){var num=new Array(this.getLength()+e.getLength()-1);for(var i=0;i<this.getLength();i++){for(var j=0;j<e.getLength();j++){num[i+j]^=QRMath.gexp(QRMath.glog(this.get(i))+QRMath.glog(e.get(j)));}}
	return new QRPolynomial(num,0);},mod:function(e){if(this.getLength()-e.getLength()<0){return this;}
	var ratio=QRMath.glog(this.get(0))-QRMath.glog(e.get(0));var num=new Array(this.getLength());for(var i=0;i<this.getLength();i++){num[i]=this.get(i);}
	for(var i=0;i<e.getLength();i++){num[i]^=QRMath.gexp(QRMath.glog(e.get(i))+ratio);}
	return new QRPolynomial(num,0).mod(e);}};function QRRSBlock(totalCount,dataCount){this.totalCount=totalCount;this.dataCount=dataCount;}
	QRRSBlock.RS_BLOCK_TABLE=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]];QRRSBlock.getRSBlocks=function(typeNumber,errorCorrectLevel){var rsBlock=QRRSBlock.getRsBlockTable(typeNumber,errorCorrectLevel);if(rsBlock==undefined){throw new Error("bad rs block @ typeNumber:"+typeNumber+"/errorCorrectLevel:"+errorCorrectLevel);}
	var length=rsBlock.length/3;var list=[];for(var i=0;i<length;i++){var count=rsBlock[i*3+0];var totalCount=rsBlock[i*3+1];var dataCount=rsBlock[i*3+2];for(var j=0;j<count;j++){list.push(new QRRSBlock(totalCount,dataCount));}}
	return list;};QRRSBlock.getRsBlockTable=function(typeNumber,errorCorrectLevel){switch(errorCorrectLevel){case QRErrorCorrectLevel.L:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+0];case QRErrorCorrectLevel.M:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+1];case QRErrorCorrectLevel.Q:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+2];case QRErrorCorrectLevel.H:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+3];default:return undefined;}};function QRBitBuffer(){this.buffer=[];this.length=0;}
	QRBitBuffer.prototype={get:function(index){var bufIndex=Math.floor(index/8);return((this.buffer[bufIndex]>>>(7-index%8))&1)==1;},put:function(num,length){for(var i=0;i<length;i++){this.putBit(((num>>>(length-i-1))&1)==1);}},getLengthInBits:function(){return this.length;},putBit:function(bit){var bufIndex=Math.floor(this.length/8);if(this.buffer.length<=bufIndex){this.buffer.push(0);}
	if(bit){this.buffer[bufIndex]|=(0x80>>>(this.length%8));}
	this.length++;}};var QRCodeLimitLength=[[17,14,11,7],[32,26,20,14],[53,42,32,24],[78,62,46,34],[106,84,60,44],[134,106,74,58],[154,122,86,64],[192,152,108,84],[230,180,130,98],[271,213,151,119],[321,251,177,137],[367,287,203,155],[425,331,241,177],[458,362,258,194],[520,412,292,220],[586,450,322,250],[644,504,364,280],[718,560,394,310],[792,624,442,338],[858,666,482,382],[929,711,509,403],[1003,779,565,439],[1091,857,611,461],[1171,911,661,511],[1273,997,715,535],[1367,1059,751,593],[1465,1125,805,625],[1528,1190,868,658],[1628,1264,908,698],[1732,1370,982,742],[1840,1452,1030,790],[1952,1538,1112,842],[2068,1628,1168,898],[2188,1722,1228,958],[2303,1809,1283,983],[2431,1911,1351,1051],[2563,1989,1423,1093],[2699,2099,1499,1139],[2809,2213,1579,1219],[2953,2331,1663,1273]];
	
	function _isSupportCanvas() {
		return typeof CanvasRenderingContext2D != "undefined";
	}
	
	// android 2.x doesn't support Data-URI spec
	function _getAndroid() {
		var android = false;
		var sAgent = navigator.userAgent;
		
		if (/android/i.test(sAgent)) { // android
			android = true;
			var aMat = sAgent.toString().match(/android ([0-9]\.[0-9])/i);
			
			if (aMat && aMat[1]) {
				android = parseFloat(aMat[1]);
			}
		}
		
		return android;
	}
	
	var svgDrawer = (function() {

		var Drawing = function (el, htOption) {
			this._el = el;
			this._htOption = htOption;
		};

		Drawing.prototype.draw = function (oQRCode) {
			var _htOption = this._htOption;
			var _el = this._el;
			var nCount = oQRCode.getModuleCount();
			var nWidth = Math.floor(_htOption.width / nCount);
			var nHeight = Math.floor(_htOption.height / nCount);

			this.clear();

			function makeSVG(tag, attrs) {
				var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
				for (var k in attrs)
					if (attrs.hasOwnProperty(k)) el.setAttribute(k, attrs[k]);
				return el;
			}

			var svg = makeSVG("svg" , {'viewBox': '0 0 ' + String(nCount) + " " + String(nCount), 'width': '100%', 'height': '100%', 'fill': _htOption.colorLight});
			svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
			_el.appendChild(svg);

			svg.appendChild(makeSVG("rect", {"fill": _htOption.colorLight, "width": "100%", "height": "100%"}));
			svg.appendChild(makeSVG("rect", {"fill": _htOption.colorDark, "width": "1", "height": "1", "id": "template"}));

			for (var row = 0; row < nCount; row++) {
				for (var col = 0; col < nCount; col++) {
					if (oQRCode.isDark(row, col)) {
						var child = makeSVG("use", {"x": String(col), "y": String(row)});
						child.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#template")
						svg.appendChild(child);
					}
				}
			}
		};
		Drawing.prototype.clear = function () {
			while (this._el.hasChildNodes())
				this._el.removeChild(this._el.lastChild);
		};
		return Drawing;
	})();

	var useSVG = document.documentElement.tagName.toLowerCase() === "svg";

	// Drawing in DOM by using Table tag
	var Drawing = useSVG ? svgDrawer : !_isSupportCanvas() ? (function () {
		var Drawing = function (el, htOption) {
			this._el = el;
			this._htOption = htOption;
		};
			
		/**
		 * Draw the QRCode
		 * 
		 * @param {QRCode} oQRCode
		 */
		Drawing.prototype.draw = function (oQRCode) {
            var _htOption = this._htOption;
            var _el = this._el;
			var nCount = oQRCode.getModuleCount();
			var nWidth = Math.floor(_htOption.width / nCount);
			var nHeight = Math.floor(_htOption.height / nCount);
			var aHTML = ['<table style="border:0;border-collapse:collapse;">'];
			
			for (var row = 0; row < nCount; row++) {
				aHTML.push('<tr>');
				
				for (var col = 0; col < nCount; col++) {
					aHTML.push('<td style="border:0;border-collapse:collapse;padding:0;margin:0;width:' + nWidth + 'px;height:' + nHeight + 'px;background-color:' + (oQRCode.isDark(row, col) ? _htOption.colorDark : _htOption.colorLight) + ';"></td>');
				}
				
				aHTML.push('</tr>');
			}
			
			aHTML.push('</table>');
			_el.innerHTML = aHTML.join('');
			
			// Fix the margin values as real size.
			var elTable = _el.childNodes[0];
			var nLeftMarginTable = (_htOption.width - elTable.offsetWidth) / 2;
			var nTopMarginTable = (_htOption.height - elTable.offsetHeight) / 2;
			
			if (nLeftMarginTable > 0 && nTopMarginTable > 0) {
				elTable.style.margin = nTopMarginTable + "px " + nLeftMarginTable + "px";	
			}
		};
		
		/**
		 * Clear the QRCode
		 */
		Drawing.prototype.clear = function () {
			this._el.innerHTML = '';
		};
		
		return Drawing;
	})() : (function () { // Drawing in Canvas
		function _onMakeImage() {
			this._elImage.src = this._elCanvas.toDataURL("image/png");
			this._elImage.style.display = "block";
			this._elCanvas.style.display = "none";			
		}
		
		// Android 2.1 bug workaround
		// http://code.google.com/p/android/issues/detail?id=5141
		if (this._android && this._android <= 2.1) {
	    	var factor = 1 / window.devicePixelRatio;
	        var drawImage = CanvasRenderingContext2D.prototype.drawImage; 
	    	CanvasRenderingContext2D.prototype.drawImage = function (image, sx, sy, sw, sh, dx, dy, dw, dh) {
	    		if (("nodeName" in image) && /img/i.test(image.nodeName)) {
		        	for (var i = arguments.length - 1; i >= 1; i--) {
		            	arguments[i] = arguments[i] * factor;
		        	}
	    		} else if (typeof dw == "undefined") {
	    			arguments[1] *= factor;
	    			arguments[2] *= factor;
	    			arguments[3] *= factor;
	    			arguments[4] *= factor;
	    		}
	    		
	        	drawImage.apply(this, arguments); 
	    	};
		}
		
		/**
		 * Check whether the user's browser supports Data URI or not
		 * 
		 * @private
		 * @param {Function} fSuccess Occurs if it supports Data URI
		 * @param {Function} fFail Occurs if it doesn't support Data URI
		 */
		function _safeSetDataURI(fSuccess, fFail) {
            var self = this;
            self._fFail = fFail;
            self._fSuccess = fSuccess;

            // Check it just once
            if (self._bSupportDataURI === null) {
                var el = document.createElement("img");
                var fOnError = function() {
                    self._bSupportDataURI = false;

                    if (self._fFail) {
                        self._fFail.call(self);
                    }
                };
                var fOnSuccess = function() {
                    self._bSupportDataURI = true;

                    if (self._fSuccess) {
                        self._fSuccess.call(self);
                    }
                };

                el.onabort = fOnError;
                el.onerror = fOnError;
                el.onload = fOnSuccess;
                el.src = "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="; // the Image contains 1px data.
                return;
            } else if (self._bSupportDataURI === true && self._fSuccess) {
                self._fSuccess.call(self);
            } else if (self._bSupportDataURI === false && self._fFail) {
                self._fFail.call(self);
            }
		};
		
		/**
		 * Drawing QRCode by using canvas
		 * 
		 * @constructor
		 * @param {HTMLElement} el
		 * @param {Object} htOption QRCode Options 
		 */
		var Drawing = function (el, htOption) {
    		this._bIsPainted = false;
    		this._android = _getAndroid();
		
			this._htOption = htOption;
			this._elCanvas = document.createElement("canvas");
			this._elCanvas.width = htOption.width;
			this._elCanvas.height = htOption.height;
			el.appendChild(this._elCanvas);
			this._el = el;
			this._oContext = this._elCanvas.getContext("2d");
			this._bIsPainted = false;
			this._elImage = document.createElement("img");
			this._elImage.alt = "Scan me!";
			this._elImage.style.display = "none";
			this._el.appendChild(this._elImage);
			this._bSupportDataURI = null;
		};
			
		/**
		 * Draw the QRCode
		 * 
		 * @param {QRCode} oQRCode 
		 */
		Drawing.prototype.draw = function (oQRCode) {
            var _elImage = this._elImage;
            var _oContext = this._oContext;
            var _htOption = this._htOption;
            
			var nCount = oQRCode.getModuleCount();
			var nWidth = _htOption.width / nCount;
			var nHeight = _htOption.height / nCount;
			var nRoundedWidth = Math.round(nWidth);
			var nRoundedHeight = Math.round(nHeight);

			_elImage.style.display = "none";
			this.clear();
			
			for (var row = 0; row < nCount; row++) {
				for (var col = 0; col < nCount; col++) {
					var bIsDark = oQRCode.isDark(row, col);
					var nLeft = col * nWidth;
					var nTop = row * nHeight;
					_oContext.strokeStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
					_oContext.lineWidth = 1;
					_oContext.fillStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;					
					_oContext.fillRect(nLeft, nTop, nWidth, nHeight);
					
					// 안티 앨리어싱 방지 처리
					_oContext.strokeRect(
						Math.floor(nLeft) + 0.5,
						Math.floor(nTop) + 0.5,
						nRoundedWidth,
						nRoundedHeight
					);
					
					_oContext.strokeRect(
						Math.ceil(nLeft) - 0.5,
						Math.ceil(nTop) - 0.5,
						nRoundedWidth,
						nRoundedHeight
					);
				}
			}
			
			this._bIsPainted = true;
		};
			
		/**
		 * Make the image from Canvas if the browser supports Data URI.
		 */
		Drawing.prototype.makeImage = function () {
			if (this._bIsPainted) {
				_safeSetDataURI.call(this, _onMakeImage);
			}
		};
			
		/**
		 * Return whether the QRCode is painted or not
		 * 
		 * @return {Boolean}
		 */
		Drawing.prototype.isPainted = function () {
			return this._bIsPainted;
		};
		
		/**
		 * Clear the QRCode
		 */
		Drawing.prototype.clear = function () {
			this._oContext.clearRect(0, 0, this._elCanvas.width, this._elCanvas.height);
			this._bIsPainted = false;
		};
		
		/**
		 * @private
		 * @param {Number} nNumber
		 */
		Drawing.prototype.round = function (nNumber) {
			if (!nNumber) {
				return nNumber;
			}
			
			return Math.floor(nNumber * 1000) / 1000;
		};
		
		return Drawing;
	})();
	
	/**
	 * Get the type by string length
	 * 
	 * @private
	 * @param {String} sText
	 * @param {Number} nCorrectLevel
	 * @return {Number} type
	 */
	function _getTypeNumber(sText, nCorrectLevel) {			
		var nType = 1;
		var length = _getUTF8Length(sText);
		
		for (var i = 0, len = QRCodeLimitLength.length; i <= len; i++) {
			var nLimit = 0;
			
			switch (nCorrectLevel) {
				case QRErrorCorrectLevel.L :
					nLimit = QRCodeLimitLength[i][0];
					break;
				case QRErrorCorrectLevel.M :
					nLimit = QRCodeLimitLength[i][1];
					break;
				case QRErrorCorrectLevel.Q :
					nLimit = QRCodeLimitLength[i][2];
					break;
				case QRErrorCorrectLevel.H :
					nLimit = QRCodeLimitLength[i][3];
					break;
			}
			
			if (length <= nLimit) {
				break;
			} else {
				nType++;
			}
		}
		
		if (nType > QRCodeLimitLength.length) {
			throw new Error("Too long data");
		}
		
		return nType;
	}

	function _getUTF8Length(sText) {
		var replacedText = encodeURI(sText).toString().replace(/\%[0-9a-fA-F]{2}/g, 'a');
		return replacedText.length + (replacedText.length != sText ? 3 : 0);
	}
	
	/**
	 * @class QRCode
	 * @constructor
	 * @example 
	 * new QRCode(document.getElementById("test"), "http://jindo.dev.naver.com/collie");
	 *
	 * @example
	 * var oQRCode = new QRCode("test", {
	 *    text : "http://naver.com",
	 *    width : 128,
	 *    height : 128
	 * });
	 * 
	 * oQRCode.clear(); // Clear the QRCode.
	 * oQRCode.makeCode("http://map.naver.com"); // Re-create the QRCode.
	 *
	 * @param {HTMLElement|String} el target element or 'id' attribute of element.
	 * @param {Object|String} vOption
	 * @param {String} vOption.text QRCode link data
	 * @param {Number} [vOption.width=256]
	 * @param {Number} [vOption.height=256]
	 * @param {String} [vOption.colorDark="#000000"]
	 * @param {String} [vOption.colorLight="#ffffff"]
	 * @param {QRCode.CorrectLevel} [vOption.correctLevel=QRCode.CorrectLevel.H] [L|M|Q|H] 
	 */
	QRCode = function (el, vOption) {
		this._htOption = {
			width : 256, 
			height : 256,
			typeNumber : 4,
			colorDark : "#000000",
			colorLight : "#ffffff",
			correctLevel : QRErrorCorrectLevel.H
		};
		
		if (typeof vOption === 'string') {
			vOption	= {
				text : vOption
			};
		}
		
		// Overwrites options
		if (vOption) {
			for (var i in vOption) {
				this._htOption[i] = vOption[i];
			}
		}
		
		if (typeof el == "string") {
			el = document.getElementById(el);
		}

		if (this._htOption.useSVG) {
			Drawing = svgDrawer;
		}
		
		this._android = _getAndroid();
		this._el = el;
		this._oQRCode = null;
		this._oDrawing = new Drawing(this._el, this._htOption);
		
		if (this._htOption.text) {
			this.makeCode(this._htOption.text);	
		}
	};
	
	/**
	 * Make the QRCode
	 * 
	 * @param {String} sText link data
	 */
	QRCode.prototype.makeCode = function (sText) {
		this._oQRCode = new QRCodeModel(_getTypeNumber(sText, this._htOption.correctLevel), this._htOption.correctLevel);
		this._oQRCode.addData(sText);
		this._oQRCode.make();
		this._el.title = sText;
		this._oDrawing.draw(this._oQRCode);			
		this.makeImage();
	};
	
	/**
	 * Make the Image from Canvas element
	 * - It occurs automatically
	 * - Android below 3 doesn't support Data-URI spec.
	 * 
	 * @private
	 */
	QRCode.prototype.makeImage = function () {
		if (typeof this._oDrawing.makeImage == "function" && (!this._android || this._android >= 3)) {
			this._oDrawing.makeImage();
		}
	};
	
	/**
	 * Clear the QRCode
	 */
	QRCode.prototype.clear = function () {
		this._oDrawing.clear();
	};
	
	/**
	 * @name QRCode.CorrectLevel
	 */
	QRCode.CorrectLevel = QRErrorCorrectLevel;
})();
(function(window) {
  'use strict';

  var respHeaderParsePtn = /([^\r\n:]+):\s*([^\r\n]+)/g;
  var queryStrParsePtn = /([^=&]+)(?:=([^&]*))?/g;
  var intPtn = /^[1-9]\d*$/; // digits-only, not starting with 0
  var spacePtn = /^\s+$/;
  var insPosToTraversalMap = {
    beforebegin: 'previousElementSibling',
    afterbegin: 'firstElementChild',
    beforeend: 'lastElementChild',
    afterend: 'nextElementSibling',
  };

  var stateHistory;

  // variable height elem centering
  // use fieldset for component-wide disable support
  /* jshint multistr: true */
  var html = '\
    <fieldset id="trta1" class="tr-auth-dialog">\
      <div class="trta1-outer">\
        <!--img src="tr-logo.svg" class="trta1-logo trta1-print-only"-->\
        <div class="trta1-middle">\
          <div id="trta1-browsehappy">\
            <h1 t8>Thomson Reuters</h1>\
            <h2 t8>Your Browser is Outdated</h2>\
            <p t8>Using a browser that’s no longer supported by the vendor is a security risk. Click one of the links below to upgrade to a current browser.</p>\
            <ul>\
              <li id="trta1-chrome-upgrade-item"><a target="_blank" rel="noopener" href="https://www.google.com/chrome">Google Chrome</a></li>\
              <li id="trta1-firefox-upgrade-item"><a target="_blank" rel="noopener" href="https://www.firefox.com/">Mozilla Firefox</a></li>\
              <li id="trta1-edge-upgrade-item"><a target="_blank" rel="noopener" href="https://www.microsoft.com/en-us/windows/microsoft-edge">Microsoft Edge</a></li>\
              <li id="trta1-safari-upgrade-item"><a target="_blank" rel="noopener" href="https://www.apple.com/safari/">Safari</a></li>\
              <li id="trta1-ie-upgrade-item"><a target="_blank" rel="noopener" href="https://windows.microsoft.com/ie">Internet Explorer</a></li>\
            </ul>\
            <div class="trta1-btn-group">\
              <button t8 class="trta1-btn-primary trta1-outdated-browser-btn">Ignore warning</button>\
            </div>\
            <div class="trta1-icon-warning"></div>\
          </div>\
        </div>\
      </div>\
    </fieldset>\
  ';
  /* jshint multistr: false */

  /* translation fn */
  function getTranslateFn(locale) {
    locale = locale || 'en-US';
    return function(key) {
      var strings = window.trAuth.submodules.locales[locale];
      return (strings && strings[key.trim()]) || key.trim();
    };
  }

  function getRootElem() {
    return document.getElementById('trta1');
  }

  /* Utils */

  function isObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  }

  function isTagType(elem, tagType) {
    return elem.tagName.toLowerCase() === tagType.toLowerCase();
  }

  // based on angular.js baseExtend
  function objAssignDeep(dst) {
    for (var i = 1, ii = arguments.length; i < ii; ++i) {
      var obj = arguments[i];
      if (!isObject(obj) && !Array.isArray(obj)) continue;
      var keys = Object.keys(obj);
      for (var j = 0, jj = keys.length; j < jj; j++) {
        var key = keys[j];
        var src = obj[key];

        if (isObject(src)) {
          if (src.nodeName) {
            // don't deep clone dom nodes!
            dst[key] = src;
          } else {
            if (!isObject(dst[key])) dst[key] = Array.isArray(src) ? [] : {};
            objAssignDeep(dst[key], src);
          }
        } else {
          dst[key] = src;
        }
      }
    }
    return dst;
  }

  function seekObjPath(name, context, create) {
    var i, segs = name.split('.'), len = segs.length, seg, last = context || window;
    for (i = 0; i < len; i++) {
      seg = segs[i];
      if(!isObject(last[seg]) && !(create && typeof last[seg] === 'undefined')) return null;
      last = last[seg] = last[seg] || {};
    }
    return last;
  }

  // careful since this uses innerHTML to render
  function openPrintWindow(content, title) {
    var w = window.open('', 'trta1-print-window');
    w.document.body.innerHTML = content;
    if (title) w.document.title = title;
    // IWebBrowser2 control might fail
    try {
      if (w.focus) w.focus();
      if (w.print) w.print();
    } catch(e) {}
  }

  var errorEventTypePattern = /^trta1-[^*]+-error$/;
  function trigger(type, detail, target) {
    var event = new CustomEvent(type, { bubbles: true, cancelable: true, detail: detail });
    target = target || getRootElem() || window;

    // dispatch to browser
    target.dispatchEvent(event);

    // trigger wildcard error
    if (errorEventTypePattern.test(type)) {
      trigger('trta1-*-error', detail, target);
    }

    // log special events
    if (type.indexOf('tr') === 0) {
      if (window.trAuth.debug) {
        window.console.log(type, event);
      }
    }
  }

  function extractFormData(form, overrides) {
    var name, nameMap = overrides.namedFieldMap,
      namedFields = form.querySelectorAll('input[name], button[name], select[name], textarea[name]');

    return Array.from(namedFields).reduce(function(obj, namedField) {
      if (namedField.hasAttribute('tr-nosend')) { return obj; } // skip sending these fields
      name = nameMap && nameMap[namedField.name] || namedField.name;
      if (namedField.hasAttribute('tr-noconvert')) { // don't run fromString
        obj[name] = namedField.value;
      } else {
        obj[name] = fromString(namedField.value);
      }
      return obj;
    }, {});
  }

  function toFormUrlEncoded(obj) {
    return Object.keys(obj).reduce(function(prev, key) {
      if (obj[key] != null) { // coerce undefined
        prev.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
      }
      return prev;
    }, []).join('&').replace(/%20/g, '+');
  }

  function normalizeXhrResponse(xhr) {
    var headers = {}, contentType, data;

    if (xhr.getAllResponseHeaders)
      xhr.getAllResponseHeaders().replace(respHeaderParsePtn, function(pair, key, value) {
        headers[key.toLowerCase()] = value;
      });

    // if json, parse
    contentType = headers['content-type'];
    if (contentType && contentType.indexOf('application/json') === 0) {
      data = JSON.parse(xhr.responseText);
    } else {
      data = xhr.responseText;
    }

    return {
      // IE9 will sometimes return 1223 instead of 204, slege hammer it
      status: xhr.status === 1223 ? 204 : xhr.status,
      statusText: xhr.statusText,
      headers: headers,
      data: data
    };
  }

  // defensive get/set sugar for localStorage, mostly bc of this
  // https://kadoppe.com/archives/2013/04/ccleaner-ie-cookie-localstorage.html
  function store(key, value) {
    if (typeof value !== 'undefined') { // set
      try {
        return window.localStorage.setItem(key, value);
      } catch(e) {
        return undefined;
      }
    } else { // get
      try {
        return window.localStorage.getItem(key);
      } catch(e) {
        return null;
      }
    }
  }

  // does simple bool and int conversions e.g. 'true' -> true, '12' -> 12
  // assumes all field values should be trimmed of leading/trailing spaces
  function fromString(value) {
    if (typeof value !== 'string') return value;

    value = value.trim();
    if (value === 'true') value = true;
    else if (value === 'false') value = false;
    else if (intPtn.test(value)) {
      var num = parseInt(value, 10);
      if (!isNaN(num)) value = num;
    }
    return value;
  }

  function removeNodes(els) {
    if (!els || els.length === 0) return;
    if (typeof els.length === 'undefined') els.parentNode.removeChild(els);
    else Array.from(els).forEach(function(el) {
      el.parentNode.removeChild(el);
    });
  }

  function getFieldLabelTextNode(field) {
    // note: assumes label element contains field
    var label = closestTagName(field, 'label');
    if (!label) return null;
    var child = label.firstChild;
    while (child) {
      if (child.nodeType === 1) child = child.firstChild;
      if (child.nodeType === 3 && !spacePtn.test(child.nodeValue)) return child;
      child = child.nextSibling;
    }
  }

  function template(html, options) {
    return function(data) {
      return window.UnderscoreTemplate(html)(objAssignDeep({}, (options && options.templateData ? options.templateData : undefined), data));
    };
  }

  function walk(el, fn) {
    fn(el);
    el = el.firstElementChild;
    while(el) {
      walk(el, fn);
      el = el.nextElementSibling;
    }
  }

  function localizeElem(elem, $t) {
    walk(elem, function(el) {
      if (el.hasAttribute('t8')) {
        var title = el.getAttribute('title');
        var placeholder = el.getAttribute('placeholder');
        var ariaLabel = el.getAttribute('aria-label');

        if (title) {
          el.setAttribute('title', $t(title));
        }
        if (placeholder) {
          el.setAttribute('placeholder', $t(placeholder));
        }
        if (ariaLabel) {
          el.setAttribute('aria-label', $t(ariaLabel));
        }
        // note: since we are not using user supplied data we do not need to sanitize
        el.innerHTML = $t(el.innerHTML);
      }
    });
    return elem;
  }

  function toElem(html) {
    var container = document.createElement('div');
    // note: since we are not using user supplied data we do not need to sanitize
    container.innerHTML = html;
    return container.firstElementChild;
  }

  function renderTemplate(tmpl, data, target, position, locale) {
    var $t = getTranslateFn(locale);
    var html = (typeof tmpl === 'function') ? tmpl(objAssignDeep({}, data, { $t: $t, locale: locale })) : tmpl;
    var elem = toElem(html);
    var localizedElem = localizeElem(elem, $t);

    target = target || getRootElem().querySelector('.trta1-middle');
    position = position || 'beforeend';

    target.insertAdjacentElement(position, localizedElem);
    return target[insPosToTraversalMap[position]];
  }

  function loadScript(src) {
    var head = document.getElementsByTagName('head')[0],
      script = head.querySelector('script[src="' + src + '"]');

    // remove if found so we can get it to re-execute as some scripts need i.e. reCAPTCHA
    if (script) removeNodes(script);

    script = document.createElement('script');
    script.src = src;
    head.appendChild(script);
  }

  // exponential backoff in seconds
  function calcBackoff(attempts, min, max) {
    var delay = Math.round((1 / 2) * (Math.pow(2, attempts) - 1));
    min = min || 1; // 1s default min
    max = max || 300; // 5m default max
    return Math.min(max, Math.max(min, delay));
  }

  function requestTimeout(fn, delay) {
    var start = new Date().getTime(),
      handle = {};

    function loop(){
      var current = new Date().getTime(),
        delta = current - start;

      if (delta >= delay) {
        fn.call();
      } else {
        handle.value = window.requestAnimationFrame(loop);
      }
    }

    handle.value = window.requestAnimationFrame(loop);
    return handle;
  }

  function cancelRequestTimeout(handle) {
    window.cancelAnimationFrame(handle.value);
  }

  // delay and timeout in seconds
  function pollFormRequest(form, testFn, successFn, timeoutFn, errorFn, delay, timeout, leadingEdge, continueOnError) {
    var endTime = Number(new Date()) + (timeout || 40) * 1e3, // 40s default timeout
      typePrefix = (form.id || form.name) + '-',
      evtTypes = typePrefix + 'success ' + typePrefix + 'error',
      attempts = 0,
      adjustedDelay,
      timer,
      unlisten = listen(evtTypes, testResponse, form),
      cancelFn = function() {
        if (timer) {
          cancelRequestTimeout(timer);
          timer = null;
        }
        if (unlisten) {
          unlisten();
          unlisten = null;
        }
      };

    delay = delay || 2; // 2s default delay

    // prepare for possible trailing edge
    timer = requestTimeout(function() {
      // first attempt
      attempts++;
      trigger('submit', null, form);
    }, leadingEdge ? 0 : delay * 1e3);

    function testResponse(resp) {
      if (/-success$/.test(resp.type)) {
        if (testFn(resp)) { // if condition met, exit
          cancelFn();
          if (successFn) successFn(resp);
          return;
        }
        // success = no adjustment
        adjustedDelay = delay;
      } else { // error = exponentially backoff delay
        if (continueOnError !== true) {
          cancelFn();
          if (errorFn) errorFn(resp);
          return;
        }
        adjustedDelay = delay + calcBackoff(attempts);
      }
      if (Number(new Date()) < endTime) { // not timed out
        timer = requestTimeout(function() {
          attempts++;
          trigger('submit', null, form);
        }, adjustedDelay * 1e3);
      } else { // timed out
        cancelFn();
        if (timeoutFn) {
          // wait till next loop to get around async form request result firing after
          setTimeout(timeoutFn, 0, resp);
        }
        return;
      }
    }

    return cancelFn;
  }

  function makeFormRequest(form, options, successFn, errorFn, doneFn) {
    var overrides = options.formOverrides && options.formOverrides[form.name] || {};

    var method = overrides.method || form.getAttribute('method'),
      action = overrides.action || form.getAttribute('action');

    if (!method || !action) return;

    method = method.toUpperCase();

    var xhr = new XMLHttpRequest(),
      headers = objAssignDeep(
        {},
        options.headers,
        overrides.headers
      ),
      formData = objAssignDeep(
        { type: options.type, sp: options.sp },
        options.payload,
        overrides.payload,
        extractFormData(form, overrides)
      ),
      sendData, contentType;

    if (method === 'GET') {
      action += (action.indexOf('?') > -1 ? '&' : '?') + toFormUrlEncoded(formData);
    } else {
      contentType = headers['content-type'];

      if (contentType && contentType.indexOf('application/x-www-form-urlencoded') === 0) {
        sendData = toFormUrlEncoded(formData);
      } else { // detault to json
        sendData = JSON.stringify(formData);
      }
    }

    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        var resp = normalizeXhrResponse(xhr);
        if (overrides.statusMap && overrides.statusMap[resp.status]) {
          resp.status = overrides.statusMap[resp.status];
        }

        var isSuccess = resp.status >= 200 && resp.status <= 299;

        if (!isSuccess) {
          // note: we redirect on status 4xx rather than 3xx so we can drive it
          // from the client-side component avoiding CORS
          var isRedirect = getPrimaryErrorReason(resp) === 'REDIRECT';
          var locationHdr = resp.headers.location;

          if (isRedirect && locationHdr) {
            // redirect and exit
            location.href = locationHdr;
            return;
          }

          // put this here so we can modify normalized response obj
          // note: this works and the handler fires on next cycle, go figure
          xhr.ontimeout = function() {
            resp.status = 500; // normally 0, making 500 to trigger offline mode in desktop
            resp.statusText = 'timeout';
          };
        }

        // allow ontimeout a chance to refine resp by deferring events till next cycle
        setTimeout(function() {
          form.trAuthLastResponse = resp;
          if (isSuccess) {
            if (successFn) successFn(resp);
          } else {
            if (errorFn) errorFn(resp);
          }
          if (doneFn) doneFn(resp);
        }, 0);
      }
    };

    updateFormState(form, 'processing', options);
    xhr.open(method, action);
    xhr.timeout = overrides.timeout || 60000; // 60s
    // set headers
    Object.keys(headers).forEach(function(key) {
      xhr.setRequestHeader(key, headers[key]);
    });
    try {
      xhr.send(sendData);
    } catch(e) {
      errorFn();
    }
  }

  function getSecondaryError(resp) {
    var secondary, secondaries;
    if (resp.data && resp.data.errors && resp.data.errors.length) {
      secondaries = resp.data.errors.filter(function(err) {
        return !err.primary;
      });
      // if not marked, assume the first error is the primary
      secondary = (secondaries && secondaries[0]) || resp.data.errors[0];
    }
    return secondary;
  }

  function getPrimaryError(resp) {
    var primary, primaries;
    if (resp.data && resp.data.errors && resp.data.errors.length) {
      primaries = resp.data.errors.filter(function(err) {
        return err.primary;
      });
      // if not marked, assume the first error is the primary
      primary = (primaries && primaries[0]) || resp.data.errors[0];
    }
    return primary;
  }

  function getPrimaryErrorReason(resp) {
    var reason, primary = getPrimaryError(resp);
    if (primary) {
      reason = primary.reason;
    }
    return reason;
  }

  function getLastFormResp(form) {
    if (typeof form === 'string') {
      return document.forms[form].trAuthLastResponse;
    } else {
      return form.trAuthLastResponse;
    }
  }

  function getFormStateMsgs(form, options) {
    var formOverrideMsgs;
    // if there are overrides look them up
    if (options && options.formOverrides && options.formOverrides[form.name]) {
      formOverrideMsgs = options.formOverrides[form.name].formStateMessages;
    }
    // get reason to message map
    return objAssignDeep({}, options.formStateMessages, formOverrideMsgs || {});
  }

  function getFormStateMessage(form, state, options, detail) {
    var msg, reason, msgs,
      dfault = 'default'; // get around ie8 keyword prob after min

    if (isObject(detail)) {
      // if we have more error detail, use it
      // otherwise, use statusText
      // otherwise, use status (HTTP/2)
      reason = getPrimaryErrorReason(detail) || detail.statusText.toLowerCase() || detail.status.toString();
    } else if (typeof detail === 'string') {
      reason = detail;
    } else {
      reason = dfault;
    }

    if (options) {
      msgs = getFormStateMsgs(form, options);

      /*eslint dot-notation: ["error", { "allowKeywords": false }]*/
      msg = msgs[state] && (msgs[state][reason] || msgs[state][dfault]);
    }
    return msg;
  }

  // html disable attrib at a form level doesn't work but it will at the root fieldset
  function toggleFormDisable(form, state) {
    var root = getRootElem();
    if (typeof state !== 'boolean') state = !root.disabled;
    root[state ? 'setAttribute' : 'removeAttribute']('disabled', 'disabled');
  }

  function updateFormMsg(form, msg) {
      // safe way to avoid possible xss
      form.querySelector('.trta1-form-msg').textContent = msg;
  }

  // states: processing, success, error
  function updateFormState(form, state, options, detail) {
    var msg;

    // clear state classes
    form.classList.remove('trta1-processing', 'trta1-success', 'trta1-error');
    // remove error and validation msgs
    removeNodes(form.querySelectorAll('.trta1-form-msg, .trta1-validation-msg'));
    // clear disable or set for processing
    if (!form.classList.contains('trta1-nodisable')) {
      toggleFormDisable(form, state === 'processing');
    }

    // if default, return
    if (state === 'default') {
      form.classList.remove('trta1-submitted');
      return;
    }

    form.classList.add('trta1-' + state);
    msg = getFormStateMessage(form, state, options, detail);
    if (msg) {
      var msgContainer = document.createElement('div');
      msgContainer.classList.add('trta1-form-msg');
      form.insertAdjacentElement('afterbegin', msgContainer);
      updateFormMsg(form, msg);
    }

    // todo: remove form.id, need to fix login
    trigger((form.id || form.name) + '-' + state, detail, form);

    // change form on state
    var gotoForm = form.getAttribute('tr-goto-on' + state);
    if (gotoForm) {
      changeForm(gotoForm, form.parentElement, detail);
    }
  }

  function exitForm(form, detail) {
    if (!form) return;

    updateFormState(form, 'default'); // reset form state
    // form.reset(); // clear fields
    form.classList.remove('trta1-active-form');
    // todo: remove form.id, need to fix login
    trigger((form.id || form.name) + '-exit', detail, form);
  }

  function changeForm(formName, context, detail) {
    var form, prevForm;

    if (!formName) return false;

    context = context || getRootElem();
    prevForm = context.querySelector('.trta1-active-form');

    // handle $pecial targets
    switch (formName) {
      case 'trta1-$back':
        formName = stateHistory[stateHistory.length - 2];
        break;
      case 'trta1-$start':
        formName = stateHistory[0];
        break;
      case 'trta1-$close':
        trigger('tr-dialog-user-closed', {form: prevForm.name});
        exitForm(prevForm, detail);
        destroy();
        return;
      case 'trta1-$retry':
        trigger('submit', null, prevForm);
        return;
    }

    // resolve form
    if (typeof formName === 'string') {
      form = context.querySelector('form[name=' + formName + ']');
    } else {
      form = formName;
    }
    if (!form) return false;

    // exit prev
    exitForm(prevForm, detail);

    form.classList.add('trta1-active-form');
    stateHistory.push(formName);

    focusFirstEnabledField(form, function(field) {
      // primary buttons only
      if (isTagType(field, 'button')) return field.classList.contains('trta1-btn-primary');
      // empty fields only
      return field.value.length === 0;
    });

    // todo: remove form.id, need to fix login
    trigger((form.id || form.name) + '-enter', detail, form);

    // autosubmit
    if (form.getAttribute('tr-autosubmit') !== null) {
      trigger('submit', null, form);
    }

    return true;
  }

  function focusFirstEnabledField(context, filter) {
    var fields = context.querySelectorAll('input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])');
    var filtered, field;

    if (!fields.length) return;

    field = fields[0];

    // give time for autofill to complete
    setTimeout(function() {
      // filter inside timeout in case you are filtering on value
      if (filter) {
        filtered = Array.from(fields).filter(filter);
        field = filtered[0];
      }
      if (!field) return;

      // if focus and/or select is available use it
      // sometimes it's available but IWebBrowser2 control fails
      try {
        if (field.focus) field.focus();
        if (field.select) field.select();
      } catch(e) {}
    }, 250);
  }

  function processOverrides(options, rootElem) {
    if (options.formOverrides) {
      Object.keys(options.formOverrides).forEach(function(formName) {
        var form = rootElem.querySelector('form[name=' + formName + ']'), overrides;
        if (!form) return;

        overrides = options.formOverrides[formName];
        overrides.payload = overrides.payload || {};

        // process values
        if (overrides.values) {
          Object.keys(overrides.values).forEach(function(fieldName) {
            var value = overrides.values[fieldName];
            // jshint eqnull:true
            if (value == null) return;

            form.elements[fieldName].value = value;
          });
        }

        // process types
        if (overrides.types) {
          Object.keys(overrides.types).forEach(function(fieldName) {
            var value = overrides.types[fieldName];
            // jshint eqnull:true
            if (value == null) return;

            form.elements[fieldName].type = value;
          });
        }

        // process labels
        if (overrides.labels) {
          Object.keys(overrides.labels).forEach(function(fieldName) {
            var field = form.elements[fieldName];
            var value = overrides.labels[fieldName];
            // jshint eqnull:true
            if (!field || value == null) return;

            if (field.placeholder) field.placeholder = value;
            getFieldLabelTextNode(field).nodeValue = value;
          });
        }

        // process hide
        if (overrides.hide) {
          Object.keys(overrides.hide).forEach(function(fieldName) {
            var field = form.elements[fieldName];
            if (!field) return;

            field[overrides.hide[fieldName] ? 'setAttribute' : 'removeAttribute']('disabled', 'disabled');

            if (isTagType(field.parentElement, 'label')) {
              field = field.parentElement;
            }
            field.classList[overrides.hide[fieldName] ? 'add' : 'remove']('trta1-hide');
          });
        }

        // process disable
        if (overrides.disable) {
          Object.keys(overrides.disable).forEach(function(fieldName) {
            var field = form.elements[fieldName];
            if (!field) return;

            field[overrides.disable[fieldName] ? 'setAttribute' : 'removeAttribute']('disabled', 'disabled');
          });
        }
      });
    }
  }

  // expects typical format from location.search, i.e. expects leading '?'
  // no complex types supported e.g. Object, Array
  function parseQueryStr(qStr) {
    var qObj = {};
    qStr.substring(1).replace(/\+/g, ' ').replace(queryStrParsePtn, function(pair, key, value) {
      qObj[decodeURIComponent(key)] = fromString(decodeURIComponent(value));
    });
    return qObj;
  }

  function getValidationState(field) {
    for (var state in field.validity) {
      if (field.validity[state] === true) return state;
    }
  }

  function getValidationMessage(form, field, options) {
    var formOverrideMsgs;
    if (options.formOverrides && options.formOverrides[form.name]) {
      formOverrideMsgs = options.formOverrides[form.name].validationMessages;
    }
    var msgs = objAssignDeep({}, options.validationMessages, formOverrideMsgs);
    return msgs[getValidationState(field)] || field.validationMessage;
  }

  function clearFieldValidation(field, form) {
    removeNodes(form.querySelector('[name=' + field.name + '] + .trta1-validation-msg'));
  }

  function renderFieldValidation(field, form, options) {
    var msg, labelTextNode, labelText;
    var msgContainer = form.querySelector('[name=' + field.name + '] + .trta1-validation-msg');

    labelTextNode = getFieldLabelTextNode(field);
    labelText = labelTextNode && labelTextNode.nodeValue.trim() || 'This field';
    msg = getValidationMessage(form, field, options)
      .replace('{{label}}', labelText)
      .replace('{{title}}', field.title || options.state.$t('Invalid value entered.'));

    if (!msgContainer) {
      msgContainer = document.createElement('div');
      msgContainer.classList.add('trta1-validation-msg');
      field.insertAdjacentElement('afterend', msgContainer);
    }
    msgContainer.textContent = msg;
  }

  function validateForm(form, options) {
    if (!form.checkValidity) return true; // not supported, let server validate
    if (!form.classList.contains('trta1-submitted')) return;

    var isValid = form.checkValidity();

    // clear old msgs
    removeNodes(form.querySelectorAll('.trta1-validation-msg'));

    // if invalid, setup msgs
    if (!isValid) {
      Array.from(form.querySelectorAll('input:invalid, button:invalid, select:invalid, textarea:invalid')).forEach(function(field) {
        renderFieldValidation(field, form, options);
      });
    }

    return isValid;
  }

  function validateField(field, options) {
    if (!field.checkValidity) return true; // not supported, let server validate

    var form = closestTagName(field, 'form');
    if (!form.classList.contains('trta1-submitted')) return;

    var isValid = field.checkValidity();

    // if invalid, setup msgs
    if (!isValid) {
      renderFieldValidation(field, form, options);
    } else {
      clearFieldValidation(field, form);
    }

    return isValid;
  }

  function closestTagName(elem, tagName) {
    var parent = elem.parentElement;
    if (!parent) return null;
    if (isTagType(parent, tagName)) return parent;
    return closestTagName(parent, tagName);
  }

  function listen(types, fn, el, once) {
    el = el || getRootElem() || window;
    types.split(' ').forEach(function(type) {
      el.addEventListener(type, once ? function onceFn(evt) {
        unlisten(types, onceFn, el);
        fn.call(this, evt);
      } : fn, false);
    });
    return function() { unlisten(types, fn, el); };
  }

  function unlisten(types, fn, el) {
    el = el || getRootElem() || window;
    types.split(' ').forEach(function(type) {
      el.removeEventListener(type, fn, false);
    });
  }

  // here so IE8 parts are happy, since classList polyfill doesn't work
  function classListAdd(el, classes) {
    el.className += ' ' + classes;
  }

  var ieAgent = (function() {
    var msie = navigator.userAgent.match(/MSIE (\d+)/);
    var trident = navigator.userAgent.match(/Trident\/(\d+)/);
    var result = {
      ie: false,
      ver: 0,
      emul: 0,
      compat: false
    };

    if (msie) {
      result.ie = true;
      result.ver = result.emul = parseInt(msie[1], 10);
    }

    // IE8+ has the more accurate trident
    if (trident) {
      result.ie = true;
      result.ver = parseInt(trident[1], 10) + 4;
      result.emul = result.emul || result.ver;
    }

    result.compat = result.ver !== result.emul;

    return result;
  })();

  // note: only based on msie version for now
  function isBrowserSupported(options) {
    return !isUnsupportedBrowser(options);
  }
  function isOutdatedBrowser(options) {
    if (options.outdatedBrowser) return true;
    return ieAgent.ie && ieAgent.ver < options.minimumMsieWarn;
  }
  function isUnsupportedBrowser(options) {
    if (options.unsupportedBrowser) return true;
    return ieAgent.ie && ieAgent.ver < options.minimumMsie;
  }

  function inputPlaceholderIsSupported() {
    return 'placeholder' in document.createElement('input');
  }

  /* Setup */
  function moduleReady(context, options) {
    var h1 = context.querySelector('h1');
    if (options.title && h1) {
      h1.textContent = options.title;
    }

    processOverrides(options, context);

    // display start form from param or first named form
    // todo: remove deprecated startSection
    changeForm(options.startingForm || options.startSection || context.querySelector('form[name]'), context);
  }

  function getDefaultOptions(locale) {
    var $t = getTranslateFn(locale);
    return {
      minimumMsie: 11,
      minimumMsieWarn: 11,
      locale: 'en-US',
      headers: {
        'content-type': 'application/json;charset=utf-8',
        'accept': 'application/json'
      },
      formStateMessages: {
        'processing': {
          'default': $t('Please wait.')
        },
        'success': {
          'default': $t('Success!')
        },
        'error': {
          'default': $t('An unexpected error occurred. Please try again.'),
          /* Custom service error reasons */
          // this redirect error should not show up unless something went wrong
          'REDIRECT': $t('An unexpected error occurred while redirecting your request.'),
          /* Custom client-side keys */
          'timeout': $t('The server did not respond in time. Please try again.'),
          /* Http statusText.toLowerCase() for AWS since it lowercases response
             as well as status codes for HTTP/2 since it is missing statusText */
          'bad request': $t('An error occurred with your request. Please try again.'),
          '400': $t('An error occurred with your request. Please try again.'),
        }
      },
      // ValidityState keys
      validationMessages: {
        // 'badInput': '',
        // 'customError': '',
        'patternMismatch': '{{title}}',
        // 'rangeOverflow': '',
        // 'rangeUnderflow': '',
        // 'stepMismatch': '',
        // 'tooLong': '',
        'typeMismatch': $t('Please provide a valid {{label}}.'),
        'valueMissing': $t('{{label}} is required.')
      },
      state: {
        $t: $t,
        exitCode: 1 // unixy exit code: 0 success, !0 fail; default to fail
      }
    };
  }

  function init(options) {
    destroy();

    var rootElem = renderTemplate(template(html, options), options.templateData, options.targetElem || document.body, options.insertPosition, options.locale),
      browserSupported = isBrowserSupported(options);

    stateHistory = [];

    // component states
    if (isUnsupportedBrowser(options)) classListAdd(rootElem, 'trta1-unsupported-browser');
    else if (isOutdatedBrowser(options)) classListAdd(rootElem, 'trta1-outdated-browser');
    if (options.msieOnly) classListAdd(rootElem, 'trta1-msie-only');
    if (options.offline) classListAdd(rootElem, 'trta1-offline');
    if (!options.targetElem) classListAdd(rootElem, 'trta1-modal');

    if (options.title) {
      // note: use innerText instead of textContent because this is in the IE8 execution path
      rootElem.querySelector('h1').innerText = options.title;
    }

    if (browserSupported) {
      if (options.type || options.sp) {
        // yucky but necesary for backwards compatibility
        var type = /netfirm|csweb/.test(options.sp) ? options.sp : options.type;
        if(type === 'netfirm' && ( options.locale === 'en-CA' || options.locale === 'fr-CA' ) ) {
          type += 'dt';
        }
        rootElem.classList.add('trta1-type-' + type.toLowerCase());
      }

      if (!inputPlaceholderIsSupported()) rootElem.classList.add('trta1-placeholder-unsupported');

      listen('submit', function(evt) {
        var form = evt.target;
        evt.preventDefault();

        form.classList.add('trta1-submitted');

        if (!validateForm(form, options)) {
          focusFirstEnabledField(form, function(field) {
            return !field.validity.valid;
          });
          return;
        }

        // valid, make request
        makeFormRequest(
          form,
          options,
          function(resp) { updateFormState(form, 'success', options, resp); },
          function(resp) { updateFormState(form, 'error', options, resp); },
          function(resp) { trigger((form.id || form.name) + '-' + 'done', resp, form); }
        );
      });

      listen('input propertychange', function(evt) {
        var field = evt.target;
        validateField(field, options);
      });

      listen('click', function(evt) {
        var dest;

        if (rootElem.disabled) {
          evt.preventDefault();
          return;
        }

        dest = evt.target.getAttribute('data-trta1-dest');
        if (!dest) return;
        if (changeForm(dest)) {
          evt.preventDefault();
        }
      });

      // handle outdated browser ignore button click
      listen('click', function() {
        rootElem.classList.remove('trta1-outdated-browser');
      }, rootElem.querySelector('.trta1-outdated-browser-btn'));

    }

    classListAdd(document.documentElement, 'trta1-active');
    if (!options.targetElem) classListAdd(document.documentElement, 'trta1-modal-active');

    return browserSupported;
  }

  function destroy() {
    var rootElem = getRootElem();
    if (!rootElem) return;
    trigger('tr-dialog-before-destroy');
    removeNodes(rootElem);
    document.documentElement.classList.remove('trta1-active');
    document.documentElement.classList.remove('trta1-modal-active');
    stateHistory = [];
  }

  /* Export */
  // NOTE: trid is deprecated
  window.trAuth = window.trid = {
    version: '1.26.5',
    debug: false,
    locales: [],
    getRootElem: getRootElem,
    isBrowserSupported: isBrowserSupported,
    getDefaultOptions: getDefaultOptions,
    getTranslateFn: getTranslateFn,
    trigger: trigger,
    seekObjPath: seekObjPath,
    openPrintWindow: openPrintWindow,
    validateForm: validateForm,
    toggleFormDisable: toggleFormDisable,
    loadScript: loadScript,
    focusFirstEnabledField: focusFirstEnabledField,
    changeForm: changeForm,
    pollFormRequest: pollFormRequest,
    updateFormMsg: updateFormMsg,
    updateFormState: updateFormState,
    getLastFormResp: getLastFormResp,
    getFormStateMsgs: getFormStateMsgs,
    fromString: fromString,
    store: store,
    removeNodes: removeNodes,
    objAssignDeep: objAssignDeep,
    listen: listen,
    unlisten: unlisten,
    template: template,
    classListAdd: classListAdd,
    renderTemplate: renderTemplate,
    parseQueryStr: parseQueryStr,
    getPrimaryError: getPrimaryError,
    getSecondaryError: getSecondaryError,
    moduleReady: moduleReady,
    init: init,
    destroy: destroy,
    modules: {}
  };
})(window);
this.trAuth = this.trAuth || {};
this.trAuth.submodules = (function () {
  'use strict';

  var template = "<form name=\"trta1-mfa-approvecode\" method=\"post\" action=\"<%= authSvcHost %>/api/mfa/v1/requests/_id_/validate\" class=\"trta1-nodisable\" novalidate>\n  <div class=\"trta1-approve-push-only\">\n    <h3 t8>Check your device!</h3>\n    <div class=\"trta1-form-instructions\">\n      <p t8>Approve your request<br> in the Thomson Reuters Authenticator app</p>\n    </div>\n    <fieldset>\n      <p><span t8>Didn&apos;t get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or </span>\n        <input t8 required pattern=\"\\d{3,4}\\s?\\d{3,4}\" name=\"mfa-manual-code\" tr-nosend placeholder=\"Enter code\" autocomplete=\"off\" maxlength=\"9\"><button t8>Go</button>\n      </p>\n      <p t8>No phone? Contact your firm&apos;s administrator</p>\n    </fieldset>\n  </div>\n  <div class=\"trta1-approve-code-only\">\n    <h3 t8>Enter your authentication code</h3>\n    <div class=\"trta1-form-instructions\">\n      <p t8>Enter the authentication code displayed by your multi-factor device or provided to you.</p>\n      <p t8>You have set up the following multi-factor methods:</p>\n      <ul></ul>\n    </div>\n    <label><span t8>Code</span><br>\n      <input required pattern=\"\\d{3,4}\\s?\\d{3,4}\" name=\"mfa-manual-nonpush-code\" tr-nosend autocomplete=\"off\" maxlength=\"9\">\n    </label>\n    <button t8 class=\"trta1-btn-primary\">Go</button>\n  </div>\n  <div class=\"trta1-btn-group\">\n    <a t8 data-trta1-dest=\"<%= cancelDestForm %>\" href=\"javascript:void(0)\">Cancel Request</a>\n  </div>\n</form>\n";

  function init(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfa-approvecode]');

    trAuth.listen('trta1-mfa-approvecode-enter', function(evt) {
      var factors = trAuth.seekObjPath('formOverrides.trta1-mfa-notifydevice.payload', options).factors;
      var pushCodeInput = form.elements['mfa-manual-code'];
      var nonPushCodeInput = form.elements['mfa-manual-nonpush-code'];
      var factorNamesList = form.querySelector('.trta1-approve-code-only ul');
      var pushFactors = factors.filter(function(factor) {
        return factor.type === 'P'; // P = Push
      });
      var nonPushDeviceFactors = factors.filter(function(factor) {
        // H = Hardware device, A = Auth card, T = Third party TOTP app
        return /^(H|A|T)$/.test(factor.type);
      });
      // if no factors, error. Should only occur if MFA killswitch is on
      if(!pushFactors.length && !nonPushDeviceFactors.length) {
        trAuth.updateFormState(evt.target, 'error', options);
      }

      form.classList.add('trta1-approve-' + (pushFactors.length ? 'push' : 'code'));
      if (pushFactors.length) {
        pushCodeInput.required = true;
        nonPushCodeInput.required = false;
      } else {
        trAuth.removeNodes(factorNamesList.children);
        nonPushDeviceFactors.forEach(function(factor) {
          var li = document.createElement('li');
          li.textContent = factor.name;
          factorNamesList.appendChild(li);
        });

        pushCodeInput.required = false;
        nonPushCodeInput.required = true;
      }
      trAuth.focusFirstEnabledField(form, function(field) {
        return field.required === true;
      });
    }, rootElem);

    trAuth.listen('submit', function(evt) {
      var code = form.elements['mfa-manual-code'].value.replace(/\s/g, '') ||
        form.elements['mfa-manual-nonpush-code'].value.replace(/\s/g, '');
      var approveHdrs = trAuth.seekObjPath('formOverrides.trta1-mfa-approvecode.headers', options, true);
      var mfarId = trAuth.getLastFormResp('trta1-mfa-notifydevice').data.id;

      form.action = form.action.replace(/[^/]+(?=\/validate$)/, mfarId);

      approveHdrs.authorization = 'OTP ' + code;
    }, rootElem.querySelector('form[name=trta1-mfa-approvecode]'));

    trAuth.listen('trta1-mfa-approvecode-error', function(evt) {
      form.reset();
      trAuth.focusFirstEnabledField(form);
    }, rootElem);

    trAuth.listen('trta1-mfa-approvecode-exit', function(evt) {
      form.reset();
    }, rootElem);
  }

  var approveCode = {
    template: template,
    init: init
  };

  var enCA = {
    "CS Professional Suite Security Help": "DT Professional Suite Security Help",
    "Sign in with your NetStaff CS account": "Sign in with your DT Client Portal account",
    "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.": "To help protect the confidential data belonging to your firm and your clients, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.",
    "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.": "Your Thomson Reuters ID is the email address you use to sign in to your Onvio account."
  };

  var Password = "Contraseña";
  var Back = "Atrás";
  var OK = "Aceptar";
  var Reset = "Restablecer";
  var Retry = "Volver a intentarlo";
  var Cancel = "Cancelar";
  var Next = "Siguiente";
  var Go = "Continuar";
  var Close = "Cerrar";
  var Done = "Listo";
  var Choose = "Elegir";
  var Code = "Código";
  var Finish = "Finalizar";
  var Copy = "Copia";
  var Print = "Imprimir";
  var or = "o";
  var Download = "Descargar";
  var esAR = {
    "Email Address (Thomson Reuters ID)": "Correo Electrónico (Thomson Reuters ID)",
    "Sign in with your Thomson Reuters ID": "Inicie sesion con su Thomson Reuters ID",
    "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.": "Su Thomson Reuters ID es el correo electrónico para ingresar a Onvio y/o a su cuenta de CS Web (cs.thomsonreuters.com).",
    "Sign in with your NetStaff CS account": "Inicie sesion con su NetStaff CS cuenta",
    Password: Password,
    "Reset Password": "Restablecer Contraseña",
    "Manage Account": "Administrar Cuenta",
    "CS Professional Suite Security Help": "Ayuda con la seguridad de CS Professional Suite",
    "Need an account? Contact your administrator": "¿Necesita una cuenta? Comuníquese con el administrador",
    "ONVIO Sign In Security Help": "Ayuda con la seguridad del inicio de sesión en ONVIO",
    "Need an account? Please create a new account": "¿Necesita una cuenta? Cree una cuenta nueva",
    "Internet Access Required": "Se requiere acceso a Internet",
    "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.": "A fin de ayudar a proteger la información confidencial de su estudio contable y sus clientes, y de cumplir con los nuevos requisitos del IRS, Thomson Reuters agrega nombres de usuario y contraseñas al acceso a nuestros productos contables y tributarios.",
    "To sign in, please connect this computer to the internet then restart the application.": "Para iniciar sesión, conecte esta computadora a Internet y después vuelva a iniciar la aplicación.",
    "Learn more about these new security measures.": "Obtener más información sobre estas nuevas medidas de seguridad.",
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.": "Para que su estudio contable pueda obtener acceso a este software, uno de los administradores del estudio contable debe actualizar sus cuentas en <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.",
    "Learn More About New Security Measures": "Obtener más información sobre las nuevas medidas de seguridad",
    "Please enter your email address.": "Ingrese su dirección de correo electrónico.",
    "Please enter your login and email address.": "Ingrese su información de inicio de sesión y su dirección de correo electrónico.",
    Back: Back,
    "Reset My Password": "Restablecer mi contraseña",
    "Instructions for resetting your password have been sent to your registered email address.": "Se le han enviado instrucciones para restablecer su contraseña a la dirección de correo electrónico registrada.",
    "Go To Sign In": "Ir al inicio de sesión",
    "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Por favor, cree una nueva contraseña que cumpla <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">los requisitos</a>.",
    "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Su contraseña ha expirado. Por favor, cree una nueva que cumpla <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">los requisitos</a>.",
    "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:": "Su contraseña <strong>debe</strong> tener <span>al menos 8 caracteres</span>, incluyendo todo lo siguiente:",
    "At least 1 uppercase letter (A-Z)": "Al menos 1 letra mayúscula (A-Z)",
    "At least 1 lowercase letter (a-z)": "Al menos 1 letra minúscula (a-z)",
    "At least 1 digit (0-9)": "Al menos 1 dígito (0-9)",
    "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)": "Al menos 1 símbolo (e.g. ! @ # $ % ^ &amp; *)",
    "Your password should <strong>not</strong> use:": "Su contraseña <strong>no debe </strong> contener:",
    "Leading or trailing spaces": "Espacios al inicio o al final",
    "Words from the dictionary": "Palabras incluidas en el diccionario",
    "Your user ID": "Su código de usuario",
    "Sequential letters or numbers such as \"abc\" or \"123\"": "Letras o números consecutivos, tales como \"abc\" or \"123\"",
    "Show typing": "Mostrar Caracteres",
    "Hide typing": "Ocultar Caracteres",
    "New Password": "Contraseña Nueva",
    "Confirm New Password": "Confirmar Contraseña Nueva",
    "Change My Password": "Cambiar mi Contraseña",
    "You've successfully changed your password.": "Cambió correctamente su contraseña.",
    OK: OK,
    "Your password needs to be updated. Please <a href=\"<%= netfirmWebHost %>\" target=\"_blank\"> log in</a> and change your password.": "Su contraseña necesita ser actualizada. Por favor, <a href=\"<%= netfirmWebHost %>\" target=\"_blank\">inicie sesión</a> y cambie su contraseña.",
    "Back To Sign In": "Volver a Inicio de sesión",
    "Unlocking your account.": "Desbloqueo de la cuenta.",
    "Your password will expire soon": "Su contraseña caduca pronto",
    "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.": "Su contraseña caducará en <em id=\"trta1-pwdexpdays\">2</em> días.",
    "Your password will expire in <em>1</em> day.": "Su contraseña caduca dentro de <em>1</em> día.",
    "Your password will expire <em>today</em>.": "Su contraseña caduca <em>hoy</em>.",
    "Do you want to change it now?": "¿Desea cambiarla ahora?",
    "Change my password": "Cambiar mi contraseña",
    "Do it later": "Más tarde",
    "Your session is ending soon": "Su sesión finaliza pronto",
    "Your session will end in:": "Your session will end in:",
    Reset: Reset,
    "Multi-factor authentication required": "La autenticación de múltiples factores es obligatoria",
    "The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.": "El estudio requiere que se habilite la autenticación de múltiples factores antes de iniciar sesión. Por favor complete el asistente de configuración de autenticación de múltiples factores para continuar.",
    "Set Up Now": "Configurar Ahora",
    "Finding your paired device.": "Buscando el dispositivo sincronizado.",
    Retry: Retry,
    "Notifying your paired device.": "Notificando al dispositivo sincronizado.",
    "Check your device!": "Revise su dispositivo.",
    "Approve your request<br> in the Thomson Reuters Authenticator app": "Aprobar su solicitud<br> en la aplicación Thomson Reuters Authenticator",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>": "¿No recibió una notificación? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Reenvíe la notificación</a> o <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">introduzca un código</a>",
    "No phone? Contact your firm's administrator": "¿No tiene teléfono? Comuníquese con el administrador de su estudio contable",
    "Cancel Request": "Cancelar solicitud",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or": "¿No recibió una notificación? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Reenvíe la notificación</a> o",
    "Enter code": "Ingresar código",
    "Retrieving authentication token.": "Recuperando token de autenticación.",
    "You've been authenticated.": "Ya está autenticado.",
    "Please wait while we sign you into your account…": "Espere mientras se inicia la sesión en su cuenta...",
    "Multifactor authentication is currently unavailable.": "La autenticación de múltiples factores no está disponible en este momento.",
    "Thomson Reuters": "Thomson Reuters",
    "You are using an <strong>outdated</strong> browser. Please upgrade your browser to improve security.": "Está utilizando un navegador <strong>obsoleto</strong>. Actualice su navegador para mejorar la seguridad.",
    "Multi-factor Authentication Setup": "Configuración de autenticación de múltiples factores",
    "<strong>Increase security for your account</strong> Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "<strong>Mejore la seguridad de su cuenta</strong> Las contraseñas pueden ser descifradas por hackers, pero la autenticación de múltiples factores le suma otra capa de seguridad a su cuenta.",
    "<strong>How long will it take to set up?</strong> Minutes.": "<strong>¿Cuánto tiempo demora la configuración?</strong> Unos minutos.",
    "<strong>How will this affect me?</strong> You will need to approve each sign in request on your smartphone once a day and after each time you log out.": "<strong>¿En qué me afectará esto?</strong> Tendrá que aprobar cada solicitud de inicio de sesión con su teléfono inteligente una vez al día y cada vez que cierre sesión.",
    Cancel: Cancel,
    "Get Started": "Empezar",
    "Install the Thomson Reuters Authenticator app on your smartphone or tablet.": "Instale la aplicación Thomson Reuters Authenticator en su teléfono inteligente o tablet.",
    "Download on the Apple App Store": "Descarguela de la App Store de Apple",
    "Get it on Google Play": "Consígala en Google Play",
    Next: Next,
    "Generating QR code.": "Generando código QR.",
    "Open the Thomson Reuters Authenticator app and scan the QR code below.": "Abra la aplicación Thomson Reuters Authenticator y escanee el código QR de abajo.",
    "Retrieving device info.": "Recuperando información del dispositivo.",
    "You have paired your account with <strong id=\"trta1-mfs-devicename\">this device</strong>. You will need to approve each sign in request on this device once a day and after each time you log out.": "Sincronizó su cuenta con <strong id=\"trta1-mfs-devicename\">este dispositivo</strong>. Deberá aprobar cada solicitud de registro en este dispositivo una vez al día y después de cada vez que cierre la sesión.",
    "Got It": "Entendido",
    "Please wait…": "Espere...",
    "Enter your authentication code": "Ingrese el código de autenticación",
    "Invalid code. Please enter a valid authentication code.": "Código no válido  Ingrese un código de autenticación válido.",
    "Enter the code provided by your adminstrator": "Ingrese el código que le dio su administrador",
    "Set up your mobile device": "Configure su dispositivo móvil",
    "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.": "La contraseña debe tener un mínimo de 8 caracteres y contener al menos una letra mayúscula, una letra minúscula, un número y un símbolo, sin espacios iniciales o finales.",
    "Incorrect Email Address or Password. Please try again.": "Dirección de correo electrónico o contraseña incorrectos. Vuelva a intentarlo.",
    "Too many sign in attempts. Please check for unlock email or try later.": "Demasiados intentos de inicio de sesión. Verifique si su correo electrónico se encuentra bloqueado o intente nuevamente más tarde.",
    "Please change your password.": "Por favor, cambie su contraseña.",
    "Please complete the required fields.": "Por favor complete los campos requeridos.",
    "Your account has been deactivated. Please contact your administrator.": "Su cuenta ha sido desactivada. Por favor contáctese con su administrador.",
    "There was an error sending the email. Please try again.": "Se ha producido un error al enviar el correo electrónico. Vuelva a intentarlo. ",
    "Please choose a password you have not already used.": "Elija una contraseña que no haya utilizado con anterioridad.",
    "Your account has been unlocked.": "Su cuenta se ha desbloqueado.",
    "You've been signed out due to inactivity. Sign in to resume.": "Ha sido desconectado debido a su inactividad. Inicie sesión para reanudar.",
    "You've exceeded maximum usage time. Please sign in again.": "Ha excedido el tiempo máximo de uso. Inicie sesión nuevamente.",
    "Incorrect Login or Password. Please try again.": "Usuario o contraseña incorrectos. Vuelva a intentarlo.",
    "Missing data required to reset password. Please try again.": "Faltan los datos necesarios para restablecer la contraseña. Vuelva a intentarlo.",
    "Missing data required to unlock account. Please try again.": "Faltan los datos necesarios para desbloquear su cuenta. Vuelva a intentarlo.",
    "Timed out waiting for device approval. Resend notification or enter code.": "Tiempo de espera agotado para la aprobación del dispositivo. Reenvíe la notificación o introduzca un código.",
    "Invalid code. Please try again.": " Código inválido. Vuelva a intentarlo.",
    "Passwords Don't Match": "Las contraseñas no coinciden",
    "Please wait.": "Por favor espere.",
    "Success!": "¡Correcto!",
    "An unexpected error occurred. Please try again.": "Se ha producido un error inesperado. Vuelva a intentarlo.",
    "An unexpected error occurred while redirecting your request.": "Se ha producido un error inesperado al redireccionar la solicitud.",
    "The server did not respond in time. Please try again.": "El servidor no respondió a tiempo. Vuelva a intentarlo.",
    "An error occurred with your request. Please try again.": "Se ha producido un error en su solicitud. Vuelva a intentarlo.",
    "Please provide a valid {{label}}.": "Proporcione un {{label}} válido.",
    "{{label}} is required.": "{{label}} es requerido.",
    "Timed out waiting for scan. Please go back and try again.": "Tiempo de espera agotado. Por favor, regrese y vuelva a intentarlo.",
    "Your account is locked. Please contact your administrator.": "Su cuenta se encuentra bloqueada. Póngase en contacto con el administrador.",
    Go: Go,
    "Sorry, there was an issue on our end. Please try again.": "Hemos tenido un problema. Por favor, inténtelo de nuevo.",
    "Make your account even more secure!": "¡Haga que su cuenta sea aún más segura!",
    "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.": "Agregue un nivel adicional de seguridad en caso de que su contraseña se encuentre en peligro. Confirme su identidad mediante su dispositivo móvil.",
    "Learn more about multi-factor authentication.": "Más información acerca de la autenticación de múltiples factores.",
    "Remind Me Later": "Recordarme Más Tarde",
    Close: Close,
    Done: Done,
    "Update Password": "Actualizar Contraseña",
    "Please enter your email address to update your password.": "Por favor, ingrese su dirección de correo electrónico para actualizar su contraseña.",
    "Sign In": "Iniciar sesión",
    "Please provide a valid password.": "Proporcione una contraseña válida.",
    "Password contains prohibited characters.": "La constraseña posee caracteres no válidos.",
    "Password is too similar to a common or blacklisted password.": "Esta contraseña es similar a una contraseña muy común o en la lista de no permitidas.",
    "Ignore warning": "Ignorar esta advertencia",
    "Your browser is not supported for use with this application. Please try again using the latest version of one of the following browsers.": "Su navegador no es compatible para su uso con esta aplicación. Por favor intente de nuevo usando la última versión de uno de los siguientes navegadores.",
    "Using a browser that’s no longer supported by the vendor is a security risk. Click one of the links below to upgrade to a current browser.": "Usar un navegador que ya no es compatible con el proveedor es un riesgo de seguridad. Haga clic en uno de los enlaces a continuación para actualizar a un navegador actual.",
    "Your Browser is Outdated": "Su navegador no está actualizado",
    "A few minutes.": "Unos pocos minutos.",
    "After installing and opening the app, click Next.": "Después de instalar y abrir la aplicación, haga clic en Siguiente.",
    Choose: Choose,
    "Choose multi-factor option": "Elija la opción multifactor",
    Code: Code,
    "Download and install Thomson Reuters Authenticator app": "Descargue e instale la aplicación Thomson Reuters Authenticator",
    "Download and install an alternate multi-factor app": "Descargue e instale una aplicación alternativa de múltiples factores",
    "Enter the authentication code displayed by the Authenticator app.": "Ingrese el código de autenticación que muestra la aplicación Authenticator.",
    "Enter the code displayed by your alternate multi-factor app.": "Ingrese el código que muestra su aplicación de múltiples factores.",
    Finish: Finish,
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.": "Para que su estudio contable acceda a este software, uno de los administradores de su estudio debe actualizar sus cuentas en <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.",
    "How long will it take to set up?": "¿Cuánto tiempo demora la configuración?",
    "How will this affect me?": "¿En qué me afectará esto?",
    "Increase security for your account": "Aumente la seguridad de su cuenta",
    "Invalid value entered.": "Valor inválido ingresado.",
    "Learn more about third-party MFA apps": "Obtenga más información acerca de las aplicaciones de autenticación de múltiples factores de terceros",
    "Learn which MFA option is right for you": "Conozca la opción de autenticación de múltiples factores adecuada para usted",
    "My Multi-Factor App": "Mi aplicación de múltiples factores",
    "Name this multi-factor option": "Nombre esta opción de múltiples factores",
    "Need an account? Contact your administrator.": "¿Necesita una cuenta? Comuníquese con el administrador",
    "Need an account? Create one now.": "¿Necesita una cuenta? Cree una ahora",
    "Next steps after setting up MFA": "Próximos pasos después de configurar la autenticación de múltiples factores",
    "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.": "En su dispositivo móvil, abra la tienda de aplicaciones y descargue e instale la aplicación <b>Thomson Reuters Authenticator</b>.",
    "Open the <b>Thomson Reuters Authenticator app</b> on your mobile device and point your device's camera at your monitor to scan the code below.": "Abra la <b>aplicación Thomson Reuters Authenticator</b> en su dispositivo móvil y apunte la cámara de su dispositivo hacia su monitor para escanear el código siguiente.",
    "Pairing Successful!": "¡Sincronización exitosa!",
    "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "Mejore la seguridad de su cuenta. Las contraseñas pueden ser descifradas por hackers, pero la autenticación de múltiples factores le suma otra capa de seguridad a su cuenta.",
    "Receive notifications on your mobile device and sign in with a single touch.": "Reciba notificaciones en su dispositivo móvil e inicie sesión con un solo toque.",
    "Registering your device.": "Registrando su dispositivo",
    "Scan Code": "Escanear código",
    "Step 1": "Paso 1",
    "Step 2": "Paso 2",
    "Tell me how": "Dime cómo",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.": "El método alternativo debe ser compatible con una sola contraseña basada en el tiempo (TOTP). Descargue ahora en <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> o <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "This option requires you to enter a code each time you sign in.": "Esta opción requiere que ingrese un código cada vez que inicie sesión.",
    "Thomson Reuters Authenticator": "Authenticator de Thomson Reuters",
    "Use Thomson Reuters Authenticator (recommended)": "Utilice Thomson Reuters Authenticator (recomendado)",
    "Use a third-party multi-factor app": "Utilice una aplicación de múltiples factores de terceros",
    "Use your alternate multi-factor app to scan the code below.": "Use su aplicación alternativa de múltiples factores para escanear el código a continuación.",
    "Validate your alternate multi-factor app": "Valide su aplicación alternativa de múltiples factores",
    "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.": "Puede utilizar Thomson Reuters Authenticator (recomendado) o una aplicación de múltiples factores diferente.",
    "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.": "Ha configurado una autenticación de múltiples factores para su cuenta. Deberá aprobar cada solicitud de inicio de sesión en su dispositivo cada vez que inicie sesión con esta cuenta.",
    "You will need to approve each sign-in request on your device each time you sign in with this account.": "Deberá aprobar cada solicitud de inicio de sesión en su dispositivo cada vez que inicie sesión con esta cuenta.",
    "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.": "Su contraseña necesita ser actualizada. Por favor, <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">inicie sesión</a> y cambie su contraseña.",
    Copy: Copy,
    "Emergency Access Codes": "Códigos de acceso de emergencia",
    "Emergency codes copied to the clipboard for pasting to a safe place.": "Los códigos de emergencia fueron copiados en el portapapeles para pegarlos en un lugar seguro.",
    "Generating emergency codes.": "Generando códigos de emergencia.",
    "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.": "Si pierde el acceso a su dispositivo móvil, puede usar uno de estos códigos de emergencia para iniciar sesión en su cuenta. Cada código puede usarse solo una vez.",
    "Missing firmId parameter.": "Falta el parámetro firmId.",
    "Multi-Factor Authentication Setup": "Configuración de la autenticación de múltiples factores",
    Print: Print,
    "These codes are like the key to your office - keep them in a safe place only you can access!": "Estos códigos son como la llave de su oficina: ¡guárdelos en un lugar seguro al que solo usted pueda acceder!",
    "Use one of these codes when this device is inaccessible. Print or save the codes to a secure location. Each code can only be used once, but more codes can be generated in your account profile.": "Use uno de estos códigos cuando este dispositivo sea inaccesible. Imprima o guarde los códigos en una ubicación segura. Cada código solo se puede usar una vez, pero se pueden generar más códigos en su perfil de cuenta.",
    "You can generate more codes by signing in and accessing your profile.": "Puede generar más códigos iniciando sesión y accediendo a su perfil.",
    "Error copying emergency codes to the clipboard.": "Error al copiar códigos de emergencia al portapapeles.",
    "Enter the authentication code displayed by your multi-factor device or provided to you.": "Ingrese el código de autenticación que se muestra en su dispositivo de factores múltiples o que le ha sido proporcionado.",
    "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.": "Abra la <b>aplicación Thomson Reuters Authenticator</b> en su dispositivo móvil y apunte la cámara de su dispositivo hacia su monitor para escanear el código siguiente.",
    "You have set up the following multi-factor methods:": "Ha configurado los siguientes métodos de múltiples factores:",
    "Device ID": "Código del dispositivo",
    "Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.": "Ingrese el código del dispositivo de 9 caracteres que comienza con las letras TR de la parte posterior de su tarjeta Thomson Reuters Authenticator.",
    "Enter the one-time code displayed on your multi-factor device.": "Ingrese el código de único acceso que se muestra en su dispositivo de múltiples factores.",
    "Learn more about multi-factor devices": "Conozca más sobre dispositivos de múltiples factores",
    "Use a multi-factor device": "Utilice un dispositivo de múltiples factores",
    "Use a multi-factor device like a card that displays a code to enter.": "Utilice un dispositivo de múltiples factores como una tarjeta que muestra un código para ingresar.",
    "Validate your multi-factor device": "Valide su dispositivo de múltiples factores",
    "Incorrect Device ID or Code. Please try again.": "ID o código incorrecto del dispositivo. Por favor, vuelva a intentarlo.",
    "Thomson Reuters Authenticator Card": "Tarjeta de Authenticator de Thomson Reuters",
    "Save Emergency Access Codes": "Guardar códigos de acceso de emergencia",
    "Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile": "Guarde o imprima estos códigos en una ubicación segura para usar cuando su dispositivo MFA principal no esté disponible (por ejemplo, si obtiene un teléfono nuevo). Puede usar cada código solo una vez, pero puede generar más códigos en el perfil de su cuenta",
    or: or,
    Download: Download
  };

  var Password$1 = "Mot de passe";
  var Back$1 = "Retour";
  var OK$1 = "OK";
  var Reset$1 = "Réinitialiser";
  var Retry$1 = "Réessayez";
  var Cancel$1 = "Annuler";
  var Next$1 = "Suivant";
  var Go$1 = "Aller";
  var Close$1 = "Fermer";
  var Done$1 = "Terminé";
  var Choose$1 = "Choisir";
  var Code$1 = "Code";
  var Finish$1 = "Terminer";
  var Copy$1 = "Copier";
  var Print$1 = "Imprimer";
  var or$1 = "ou";
  var Download$1 = "Télécharger";
  var frCA = {
    "Email Address (Thomson Reuters ID)": "Adresse Courriel (Thomson Reuters ID)",
    "Sign in with your Thomson Reuters ID": "Connectez-vous avec votre Thomson Reuters ID",
    "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.": "Votre Thomson Reuters ID est l’adresse courriel que vous utilisez pour vous connecter à votre compte Onvio.",
    "Sign in with your NetStaff CS account": "Connectez-vous avec votre compte DT Portail-Client",
    Password: Password$1,
    "Reset Password": "Réinitialiser le mot de passe",
    "Manage Account": "Gestion de compte",
    "CS Professional Suite Security Help": "Aide relative à la sécurité de la Suite Professionnelle DT",
    "Need an account? Contact your administrator": "Besoin d’un compte? Contactez votre administrateur.",
    "ONVIO Sign In Security Help": "Aide relative à la sécurité de la connexion ONVIO",
    "Need an account? Please create a new account": "Besoin d’un compte? Veuillez créer un nouveau compte",
    "Internet Access Required": "Connexion Internet requise",
    "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.": "Pour aider à protéger les données confidentielles de votre cabinet et de vos clients, Thomson Reuters ajoute des noms d’utilisateurs et des mots de passe pour que vous puissiez avoir accès aux produits d’impôt et de comptabilité.",
    "To sign in, please connect this computer to the internet then restart the application.": "Pour vous connecter, veuillez connecter cet ordinateur à Internet et redémarrer l’application.",
    "Learn more about these new security measures.": "Renseignez-vous sur ces nouvelles mesures de sécurité.",
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.": "Pour que votre cabinet ait accès à ce logiciel, un des administrateurs de votre cabinet doit mettre à niveau les comptes.",
    "Learn More About New Security Measures": "Renseignez-vous sur les nouvelles mesures de sécurité",
    "Please enter your email address.": "Veuillez saisir votre adresse courriel.",
    "Please enter your login and email address.": "Veuillez saisir votre identifiant de connexion et votre adresse courriel.",
    Back: Back$1,
    "Reset My Password": "Réinitialiser mon mot de passe",
    "Instructions for resetting your password have been sent to your registered email address.": "Des directives pour réinitialiser votre mot de passe ont été envoyées à l’adresse courriel que vous avez enregistrée.",
    "Go To Sign In": "Allez dans Connexion",
    "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Veuillez créer un nouveau mot de passe qui répond aux <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">exigences</a>.",
    "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Votre mot de passe est échu. Veuillez en créer un nouveau qui répond aux <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">exigences</a>.",
    "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:": "Votre mot de passe <strong>doit</strong> comporter <span>au moins 8 caractères</span>, incluant tous les caractères suivants :",
    "At least 1 uppercase letter (A-Z)": "Au moins une lettre majuscule (A-Z)",
    "At least 1 lowercase letter (a-z)": "Au moins une lettre minuscule (a-z)",
    "At least 1 digit (0-9)": "Au moins un chiffre (0-9)",
    "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)": "Au moins un symbole (e.g. ! @ # $ % ^ &amp; *)",
    "Your password should <strong>not</strong> use:": "Votre mot de passe ne doit <strong>pas</strong> contenir :",
    "Leading or trailing spaces": "Des espaces à gauche ou à droite",
    "Words from the dictionary": "Des mots du dictionnaire",
    "Your user ID": "Votre ID utilisateur",
    "Sequential letters or numbers such as \"abc\" or \"123\"": "Des lettres ou des chiffres en séquence comme abc ou \"abc\" or \"123\"",
    "Show typing": "Afficher la saisie",
    "Hide typing": "Cacher la saisie",
    "New Password": "Nouveau mot de passe",
    "Confirm New Password": "Confirmer le nouveau mot de passe",
    "Change My Password": "Changer mon mot de passe",
    "You've successfully changed your password.": "Vous avez changé votre mot de passe avec succès.",
    OK: OK$1,
    "Your password needs to be updated. Please <a href=\"<%= netfirmWebHost %>\" target=\"_blank\"> log in</a> and change your password.": "Votre mot de passe doit être mis à jour. Veuillez vous <a href=\"<%= netfirmWebHost %>\" target=\"_blank\">connecter</a> et changer votre mot de passe.",
    "Back To Sign In": "Retour à la connexion",
    "Unlocking your account.": "Déverrouillage de votre compte.",
    "Your password will expire soon": "Votre mot de passe viendra bientôt à échéance",
    "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.": "Votre mot de passe arrive à échéance dans <em id=\"trta1-pwdexpdays\">2</em> jours.",
    "Your password will expire in <em>1</em> day.": "Votre mot de passe viendra à échéance dans <em>un</em> jour.",
    "Your password will expire <em>today</em>.": "Votre mot de passe vient à échéance <em>aujourd’hui</em>.",
    "Do you want to change it now?": "Voulez-vous le changer maintenant?",
    "Change my password": "Changer maintenant",
    "Do it later": "Plus tard",
    "Your session is ending soon": "Votre session se termine bientôt",
    "Your session will end in:": "Votre session se termine dans :",
    Reset: Reset$1,
    "Multi-factor authentication required": "Authentification multifacteurs requise",
    "The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.": "Le cabinet exige que vous activiez l'authentification multifacteurs avant de vous connecter. Veuillez compléter l'assistant de configuration de l'authentification multifacteurs pour continuer.",
    "Set Up Now": "Configurer",
    "Finding your paired device.": "Trouvez votre appareil jumelé.",
    Retry: Retry$1,
    "Notifying your paired device.": "Notification de votre appareil jumelé en cours.",
    "Check your device!": "Vérifiez votre appareil!",
    "Approve your request<br> in the Thomson Reuters Authenticator app": "Approuvez votre demande<br> dans l’application Thomson Reuters Authenticator",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>": "Vous n’avez pas reçu de notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Renvoyez une notification</a> ou <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">saisissez un code</a>",
    "No phone? Contact your firm's administrator": "Vous n’avez pas de téléphone? Contactez l’administrateur de votre cabinet",
    "Cancel Request": "Annuler la demande",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or": "Vous n’avez pas reçu de notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Renvoyez une notification</a> ou",
    "Enter code": "Saisissez le code",
    "Retrieving authentication token.": "Récupération du jeton d’authentification",
    "You've been authenticated.": "Vous avez été authentifié.",
    "Please wait while we sign you into your account…": "Veuillez patienter pendant que nous vous connectons à votre compte…",
    "Multifactor authentication is currently unavailable.": "L’authentification multifacteurs n’est présentement pas disponible.",
    "Thomson Reuters": "Thomson Reuters",
    "You are using an <strong>outdated</strong> browser. Please upgrade your browser to improve security.": "Vous utilisez un navigateur <strong>obsolète</strong>. Veuillez actualiser le navigateur pour améliorer la sécurité.",
    "Multi-factor Authentication Setup": "Configuration de l’authentification multifacteurs",
    "<strong>Increase security for your account</strong> Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "<strong>Augmentez la sécurité de votre compte</strong> Les mots de passe peuvent être piratés, mais utiliser l’authentification multifacteurs ajoute un autre niveau de sécurité à votre compte.",
    "<strong>How long will it take to set up?</strong> Minutes.": "<strong>Combien de temps prendra la configuration?</strong> Quelques minutes.",
    "<strong>How will this affect me?</strong> You will need to approve each sign in request on your smartphone once a day and after each time you log out.": "<strong>De quelle façon cela m’affectera-t-il?</strong> Vous devrez approuver chaque demande de connexion sur votre téléphone intelligent une fois par jour et après chaque déconnexion.",
    Cancel: Cancel$1,
    "Get Started": "Commencer",
    "Install the Thomson Reuters Authenticator app on your smartphone or tablet.": "Installez l’application Thomson Reuters Authenticator sur votre téléphone intelligent ou tablette.",
    "Download on the Apple App Store": "Téléchargez sur le magasin App Store d’Apple.",
    "Get it on Google Play": "Obtenez l’application sur Google Play",
    Next: Next$1,
    "Generating QR code.": "Génération d’un code QR.",
    "Open the Thomson Reuters Authenticator app and scan the QR code below.": "Ouvrez l’application Thomson Reuters Authenticator et balayez le code QR ci-dessous.",
    "Retrieving device info.": "Récupération des informations sur l’appareil",
    "You have paired your account with <strong id=\"trta1-mfs-devicename\">this device</strong>. You will need to approve each sign in request on this device once a day and after each time you log out.": "Vous avez jumelé votre compte avec <strong id=\"trta1-mfs-devicename\">cet appareil</strong>. Vous devrez approuver chaque demande d’ouverture de session sur cet appareil une fois par jour et après chaque déconnexion.",
    "Got It": "J’ai compris",
    "Please wait…": "Veuillez patienter…",
    "Enter your authentication code": "Saisissez votre code d’authentification",
    "Invalid code. Please enter a valid authentication code.": "Code invalide. Veuillez saisir un code d’authentification valide.",
    "Enter the code provided by your adminstrator": "Saisissez le code fourni par votre administrateur",
    "Set up your mobile device": "Configurez votre appareil mobile",
    "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.": "Le mot de passe doit comporter au moins 8 caractères et contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un symbole, sans espace avant ou arrière.",
    "Incorrect Email Address or Password. Please try again.": "Adresse électronique incorrecte ou mot de passe incorrect. Veuillez réessayer.",
    "Too many sign-in attempts. Please check for unlock email or try later.": "Trop de tentatives de connexion. Veuillez vérifier si vous avez reçu un courriel de déverrouillage ou essayez plus tard.",
    "Please change your password.": "Veuillez modifier votre mot de passe.",
    "Please complete the required fields.": "Veuillez remplir les champs requis.",
    "Your account has been deactivated. Please contact your administrator.": "Votre compte a été désactivé. Veuillez contacter votre administrateur.",
    "There was an error sending the email. Please try again.": "Une erreur s'est produite lors de l'envoi du courriel. Veuillez réessayer.",
    "Please choose a password you have not already used.": "Choisissez un mot de passe que vous n'avez pas déjà utilisé.",
    "Your account has been unlocked.": "Votre compte a été débloqué.",
    "You've been signed out due to inactivity. Sign in to resume.": "Vous avez été déconnecté en raison de l'inactivité. Connectez-vous pour reprendre.",
    "You've exceeded maximum usage time. Please sign in again.": "Vous avez dépassé le temps d'utilisation maximum. Veuillez vous connecter à nouveau.",
    "Incorrect Login or Password. Please try again.": "Identifiant ou mot de passe incorrect. Veuillez réessayer.",
    "Missing data required to reset password. Please try again.": "Données manquantes requises pour réinitialiser le mot de passe. Veuillez réessayer.",
    "Missing data required to unlock account. Please try again.": "Données manquantes requises pour déverrouiller le compte. Veuillez réessayer.",
    "Timed out waiting for device approval. Resend notification or enter code.": "Temporisé en attendant l'approbation de l'appareil. Renvoyez une notification ou saisissez un code.",
    "Invalid code. Please try again.": "Code invalide. Veuillez réessayer.",
    "Passwords Don't Match": "Les mots de passe ne correspondent pas",
    "Please wait.": "Veuillez patienter.",
    "Success!": "Succès!",
    "An unexpected error occurred. Please try again.": "Une erreur inattendue s’est produite. Veuillez réessayer.",
    "An unexpected error occurred while redirecting your request.": "Une erreur inattendue s'est produite lors de la redirection de votre demande.",
    "The server did not respond in time. Please try again.": "Le serveur n'a pas répondu à temps. Veuillez réessayer.",
    "An error occurred with your request. Please try again.": "Une erreur s'est produite avec votre demande. Veuillez réessayer.",
    "Please provide a valid {{label}}.": "Veuillez fournir un {{label}} valide.",
    "{{label}} is required.": "{{label}} est requis.",
    "Timed out waiting for scan. Please go back and try again.": "Temporisé en attente de numérisation. Veuillez revenir en arrière et réessayer.",
    "Your account is locked. Please contact your administrator.": "Votre compte est verrouillé. Veuillez contacter votre administrateur.",
    Go: Go$1,
    "Sorry, there was an issue on our end. Please try again.": "Désolé, nous avons éprouvé un problème de notre côté. Veuillez réessayer.",
    "Make your account even more secure!": "Sécurisez encore plus votre compte!",
    "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.": "Ajoutez un niveau de sécurité supplémentaire au cas où la sécurité de votre mot de passe s'avérait compromise. Confirmez votre identité à l'aide de votre appareil mobile.",
    "Learn more about multi-factor authentication.": "En savoir plus sur l'authentification multifacteurs.",
    "Remind Me Later": "Rappelez-moi plus tard",
    Close: Close$1,
    Done: Done$1,
    "Update Password": "Mettre à jour le mot de passe",
    "Please enter your email address to update your password.": "Veuillez saisir votre adresse courriel pour mettre à jour votre mot de passe.",
    "Sign In": "Se connecter",
    "Please provide a valid password.": "Veuillez fournir un mot de passe valide.",
    "Password contains prohibited characters.": "Le mot de passe contient des caractères interdits.",
    "Password is too similar to a common or blacklisted password.": "Ce mot de passe est trop similaire à un mot de passe commun ou interdit.",
    "Ignore warning": "Ignorer l'avertissement",
    "Your browser is not supported for use with this application. Please try again using the latest version of one of the following browsers.": "Votre navigateur n'est pas pris en charge avec cette application. Veuillez réessayer en utilisant la dernière version de l'un des navigateurs suivants.",
    "Using a browser that’s no longer supported by the vendor is a security risk. Click one of the links below to upgrade to a current browser.": "L'utilisation d'un navigateur qui n'est plus pris en charge par le fournisseur constitue un risque de sécurité. Cliquez sur l'un des liens ci-dessous pour passer à un navigateur plus récent.",
    "Your Browser is Outdated": "Votre navigateur est obsolète",
    "A few minutes.": "Quelques minutes.",
    "After installing and opening the app, click Next.": "Après avoir installé et ouvert l'application, cliquer sur Suivant.",
    Choose: Choose$1,
    "Choose multi-factor option": "Choisir l'option multifacteurs",
    Code: Code$1,
    "Download and install Thomson Reuters Authenticator app": "Télécharger et installer l'application Thomson Reuters Authenticator",
    "Download and install an alternate multi-factor app": "Télécharger et installer une autre application multifacteurs",
    "Enter the authentication code displayed by the Authenticator app.": "Saisir le code d'authentification affiché par l'application Authenticator.",
    "Enter the code displayed by your alternate multi-factor app.": "Saisir le code affiché par votre application multifacteurs alternative.",
    Finish: Finish$1,
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.": "Pour que votre entreprise puisse accéder à ce logiciel, l'un des administrateurs de votre entreprise doit mettre à niveau vos comptes sur <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.",
    "How long will it take to set up?": "Combien de temps prendra la configuration?",
    "How will this affect me?": "De quelle façon cela m’affectera-t-il?",
    "Increase security for your account": "Augmenter la sécurité de votre compte",
    "Invalid value entered.": "Valeur invalide saisie.",
    "Learn more about third-party MFA apps": "Pour en savoir plus sur les applications AFM tierces",
    "Learn which MFA option is right for you": "Découvrez quelle option AFM vous convient",
    "My Multi-Factor App": "Mon application multifacteurs",
    "Name this multi-factor option": "Nommer cette option multifacteurs",
    "Need an account? Contact your administrator.": "Besoin d’un compte? Contactez votre administrateur.",
    "Need an account? Create one now.": "Besoin d’un compte? Créez-en un maintenant",
    "Next steps after setting up MFA": "Prochaines étapes après avoir configuré l'AFM",
    "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.": "Sur votre appareil mobile, ouvrez la boutique d'applications, téléchargez et installez l'application <b>Thomson Reuters Authenticator</b>.",
    "Open the <b>Thomson Reuters Authenticator app</b> on your mobile device and point your device's camera at your monitor to scan the code below.": "Ouvrez l'application <b>Thomson Reuters Authenticator</b> sur votre appareil mobile et pointez l'appareil photo de votre appareil sur votre moniteur pour scanner le code ci-dessous.",
    "Pairing Successful!": "Appariement réussi !",
    "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "Les mots de passe peuvent être piratés, mais l'utilisation de l’authentification multifacteurs ajoute un niveau de sécurité supplémentaire à votre compte.",
    "Receive notifications on your mobile device and sign in with a single touch.": "Recevez des notifications sur votre appareil mobile et connectez-vous avec une seule touche.",
    "Registering your device.": "Enregistrer votre appareil.",
    "Scan Code": "Scanner le code",
    "Step 1": "Étape 1",
    "Step 2": "Étape 2",
    "Tell me how": "Dites-moi comment",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.": "L'autre méthode doit se conformer au mot de passe temporaire à usage unique (TOTP). Téléchargez maintenant à partir du <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">App Store d'Apple</a> ou de <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/us/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=en-us\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=en\">Google Play Store</a>.": "L'autre méthode doit se conformer au mot de passe temporaire à usage unique (TOTP). Téléchargez maintenant à partir du <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">App Store d'Apple</a> ou de <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/ca/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=fr-ca\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=fr-ca\">Google Play Store</a>.": "L'autre méthode doit se conformer au mot de passe temporaire à usage unique (TOTP). Téléchargez maintenant à partir du <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/fr/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=fr-ca\">App Store d'Apple</a> ou de <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=fr-ca\">Google Play Store</a>.",
    "This option requires you to enter a code each time you sign in.": "Cette option nécessite que vous saisissiez un code chaque fois que vous vous connectez.",
    "Thomson Reuters Authenticator": "Thomson Reuters Authenticator",
    "Use Thomson Reuters Authenticator (recommended)": "Utiliser Thomson Reuters Authenticator (recommandé)",
    "Use a third-party multi-factor app": "Utiliser une application multifacteurs tierce",
    "Use your alternate multi-factor app to scan the code below.": "Utiliser votre application multifacteurs alternative pour scanner le code ci-dessous.",
    "Validate your alternate multi-factor app": "Valider votre application multifacteurs alternative",
    "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.": "Vous pouvez utiliser Thomson Reuters Authenticator (recommandé) ou une autre application multifacteurs.",
    "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.": "Vous avez configuré l'authentification multifacteurs pour votre compte. Vous devrez approuver chaque requête de connexion sur votre appareil chaque fois que vous vous connectez avec ce compte.",
    "You will need to approve each sign-in request on your device each time you sign in with this account.": "Vous devrez approuver chaque requête de connexion sur votre appareil chaque fois que vous vous connectez avec ce compte.",
    "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.": "Votre mot de passe doit être mis à jour. Veuillez <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">vous connecter</a> et modifier votre mot de passe.",
    Copy: Copy$1,
    "Emergency Access Codes": "Codes d'accès d'urgence",
    "Emergency codes copied to the clipboard for pasting to a safe place.": "Codes d'urgence copiés dans le presse-papiers pour être collés dans un endroit sûr.",
    "Generating emergency codes.": "Générer des codes d'urgence",
    "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.": "Si vous perdez l'accès à votre appareil mobile, vous pouvez utiliser l'un de ces codes d'urgence pour vous connecter à votre compte. Chaque code ne peut être utilisé qu'une seule fois.",
    "Missing firmId parameter.": "Paramètre firmId manquant",
    "Multi-Factor Authentication Setup": "Configuration de l’authentification multifacteurs",
    Print: Print$1,
    "These codes are like the key to your office - keep them in a safe place only you can access!": "Ces codes sont comme la clé de votre bureau - gardez-les dans un endroit sûr auquel vous seul pouvez accéder!",
    "Use one of these codes when this device is inaccessible. Print or save the codes to a secure location. Each code can only be used once, but more codes can be generated in your account profile.": "Utilisez l'un de ces codes lorsque cet appareil est inaccessible. Imprimez ou enregistrez les codes dans un emplacement sécurisé. Chaque code ne peut être utilisé qu'une seule fois, mais d'autres codes peuvent être générés dans votre profil de compte.",
    "You can generate more codes by signing in and accessing your profile.": "Vous pouvez générer plus de codes en vous connectant et en accédant à votre profil.",
    "Error copying emergency codes to the clipboard.": "Erreur lors de la copie des codes d'urgence dans le presse-papiers.",
    "Enter the authentication code displayed by your multi-factor device or provided to you.": "Saisissez le code d'authentification affiché par votre appareil multifacteurs ou qui vous a été fourni.",
    "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.": "Ouvrez l'application <b>Thomson Reuters Authenticator</b> sur votre appareil mobile et pointez l'appareil photo de votre appareil sur votre moniteur pour scanner le code ci-dessous.",
    "You have set up the following multi-factor methods:": "Vous avez configuré les méthodes multifacteurs suivantes :",
    "Device ID": "Identifiant d'appareil",
    "Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.": "Saisissez l'identifiant d'appareil à 9 caractères commençant par les lettres TR à l'arrière de votre carte Thomson Reuters Authenticator.",
    "Enter the one-time code displayed on your multi-factor device.": "Saisissez le code unique affiché sur votre appareil multifacteurs.",
    "Learn more about multi-factor devices": "Pour en savoir plus sur les appareils multifacteurs",
    "Use a multi-factor device": "Utilisez un appareil multifacteurs",
    "Use a multi-factor device like a card that displays a code to enter.": "Utilisez un appareil multifacteur comme une carte qui affiche un code à saisir.",
    "Validate your multi-factor device": "Validez votre appareil multifacteurs",
    "Incorrect Device ID or Code. Please try again.": "Identifiant d'appareil ou code incorrect. Veuillez réessayer.",
    "Thomson Reuters Authenticator Card": "Carte Thomson Reuters Authenticator",
    "Save Emergency Access Codes": "Enregistrer les codes d'accès d'urgence",
    "Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile": "Enregistrez ou imprimez ces codes dans un emplacement sécurisé pour pouvoir les utiliser lorsque votre périphérique d'AFM principal n'est pas disponible (par exemple, si vous avez un nouveau téléphone). Vous ne pouvez utiliser chaque code qu'une seule fois, mais vous pouvez générer plus de codes dans votre profil de compte.",
    or: or$1,
    Download: Download$1
  };

  var Password$2 = "Wachtwoord";
  var Back$2 = "Terug";
  var OK$2 = "OK";
  var Reset$2 = "Resetten";
  var Retry$2 = "Opnieuw proberen";
  var Cancel$2 = "Annuleren";
  var Next$2 = "Volgende";
  var Go$2 = "Volgende";
  var Close$2 = "Afsluiten";
  var Done$2 = "Gereed";
  var Choose$2 = "Selecteer";
  var Code$2 = "Code";
  var Finish$2 = "Afwerking";
  var Copy$2 = "Kopiëren";
  var Print$2 = "Afdrukken";
  var nlNL = {
    "Email Address (Thomson Reuters ID)": "E-mailadres (Thomson Reuters ID)",
    "Sign in with your Thomson Reuters ID": "Meld u aan met uw Thomson Reuters ID",
    "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.": "Uw Thomson Reuters ID is het e-mailadres dat u gebruikt om u aan te melden bij uw Onvio- en / of CS Web-account (cs.thomsonreuters.com).",
    "Sign in with your NetStaff CS account": "Meld u aan met uw NetStaff CS account",
    Password: Password$2,
    "Reset Password": "Wachtwoord Resetten",
    "Manage Account": "Account beheren",
    "CS Professional Suite Security Help": "Helpfunctie Beveiliging CS Professional Suite",
    "Need an account? Contact your administrator": "Heeft u een account nodig? Neem contact op met uw beheerder",
    "ONVIO Sign In Security Help": "Helpfunctie Beveiliging ONVIO Inloggen",
    "Need an account? Please create a new account": "Heeft u een account nodig? Maak een nieuw account aan",
    "Internet Access Required": "Internetverbinding vereist",
    "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.": "Om de vertrouwelijke gegevens van uw kantoor en uw klanten te helpen beschermen en ter naleving van de nieuwe IRS-vereisten, voegt Thomson Reuters gebruikersnamen en wachtwoorden toe om toegang te krijgen tot onze Belasting &amp; Boekhouding producten.",
    "To sign in, please connect this computer to the internet then restart the application.": "Om in te loggen, verbind deze computer met het internet en herstart de toepassing.",
    "Learn more about these new security measures.": "Meer informatie over deze nieuwe beveiligingsmaatregelen.",
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.": "Om voor uw kantoor toegang te krijgen tot deze software, dient een van uw kantoorbeheerders uw accounts te upgraden voor <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.",
    "Learn More About New Security Measures": "Meer Informatie Over Nieuwe Beveiligingsmaatregelen",
    "Please enter your email address.": "Voer uw e-mailadres in.",
    "Please enter your login and email address.": "Voer uw login en e-mailadres in.",
    Back: Back$2,
    "Reset My Password": "Reset mijn wachtwoord",
    "Instructions for resetting your password have been sent to your registered email address.": "Instructies voor het resetten van uw wachtwoord zijn naar uw geregistreerde e-mailadres verzonden.",
    "Go To Sign In": "Ga naar inloggen",
    "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Maak een nieuw wachtwoord dat voldoet aan de <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">wensen</a>.",
    "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Je wachtwoord is verlopen. Maak een nieuwe die voldoet aan de <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">wensen</a>.",
    "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:": "Uw wachtwoord <strong>moet</strong> minstens <span>8 tekens</span> met inbegrip van alle van de volgende:",
    "At least 1 uppercase letter (A-Z)": "Ten minste 1 hoofdletter (A-Z)",
    "At least 1 lowercase letter (a-z)": "Ten minste 1 kleine letter (a-z)",
    "At least 1 digit (0-9)": "Ten minste 1 getal (0-9)",
    "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)": "Ten minste 1 symbool (e.g. ! @ # $ % ^ &amp; *)",
    "Your password should <strong>not</strong> use:": "Uw wachtwoord moet <strong>niet</strong> bevatten:",
    "Leading or trailing spaces": "Spaties ervoor of erna",
    "Words from the dictionary": "Woorden uit het woordenboek",
    "Your user ID": "Uw gebruikers-ID",
    "Sequential letters or numbers such as \"abc\" or \"123\"": "Opeenvolgende letters of getallen zoals \"abc\" or \"123\"",
    "Show typing": "Typen tonen",
    "Hide typing": "Typen verbergen",
    "New Password": "Nieuw wachtwoord",
    "Confirm New Password": "Bevestig nieuw wachtwoord",
    "Change My Password": "Wijzig mijn wachtwoord",
    "You've successfully changed your password.": "U hebt uw wachtwoord met succes gewijzigd.",
    OK: OK$2,
    "Your password needs to be updated. Please <a href=\"<%= netfirmWebHost %>\" target=\"_blank\"> log in</a> and change your password.": "Uw wachtwoord moet worden bijgewerkt. Gelieve <a href=\"<%= netfirmWebHost %>\" target=\"_blank\">inloggen</a> en uw wachtwoord te wijzigen.",
    "Back To Sign In": "Terug Naar Inloggen",
    "Unlocking your account.": "Bezig met het ontgrendelen van uw account.",
    "Your password will expire soon": "Uw wachtwoord zal binnenkort vervallen",
    "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.": "Uw wachtwoord zal verlopen in <em id=\"trta1-pwdexpdays\">2</em> dagen.",
    "Your password will expire in <em>1</em> day.": "Uw wachtwoord vervalt over <em>1</em> dag.",
    "Your password will expire <em>today</em>.": "Uw wachtwoord vervalt <em>vandaag</em>.",
    "Do you want to change it now?": "Wilt u het nu wijzigen?",
    "Change my password": "Wijzig mijn wachtwoord",
    "Do it later": "Doe het later",
    "Your session is ending soon": "Uw sessie zal spoedig vervallen",
    "Your session will end in:": "Your session will end in:",
    Reset: Reset$2,
    "Multi-factor authentication required": "Multi-factor authenticatie is vereist",
    "Your firm now requires all staff and administrators to sign in with multi-factor authentication.": "Uw kantoor vereist nu dat alle personeelsleden en beheerders inloggen met multi-factor authenticatie.",
    "You need to set up multi-factor authentication before continuing.": "U dient multi-factor authenticatie in te stellen voordat u verder gaat.",
    "Set Up Now": "Stel Nu In",
    "Finding your paired device.": "Zoeken naar uw gekoppelde apparaat.",
    Retry: Retry$2,
    "Notifying your paired device.": "Bezig met het sturen van een melding naar uw gekoppelde apparaat.",
    "Check your device!": "Controleer uw apparaat!",
    "Approve your request<br> in the Thomson Reuters Authenticator app": "Uw verzoek goedkeuren<br> in de Thomson Reuters Authenticator app",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>": "Geen melding ontvangen? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Stuur melding opnieuw</a> of <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">voer code in</a>",
    "No phone? Contact your firm's administrator": "Geen telefoon? Neem contact op met uw kantoorbeheerder",
    "Cancel Request": "Verzoek annuleren",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or": "Geen melding ontvangen? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Stuur melding opnieuw</a> of",
    "Enter code": "Code invoeren",
    "Retrieving authentication token.": "Bezig met het ophalen van authenticatietoken.",
    "Success!": "Succes!",
    "You've been authenticated.": "U bent geauthenticeerd.",
    "Please wait while we sign you into your account…": "Even geduld tewijl wij u inloggen op uw account…",
    "Multifactor authentication is currently unavailable.": "Multifactor authenticatie is op dit moment niet beschikbaar.",
    "Thomson Reuters": "Thomson Reuters",
    "You are using an <strong>outdated</strong> browser. Please upgrade your browser to improve security.": "U gebruikt een <strong>verouderde</strong> browser. Upgrade uw browser om de bescherming te verbeteren.",
    "Multi-factor Authentication Setup": "Multi-factor Authenticatie Instellen",
    "<strong>Increase security for your account</strong> Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "<strong>Verbeter de beveiliging van uw account</strong> Wachtwoorden kunnen worden gestolen, en multi-factor authenticatie voegt een extra beveiligingslaag toe aan uw account.",
    "<strong>How long will it take to set up?</strong> Minutes.": "<strong>Hoe lang duurt het om dit in te stellen?</strong> Minuten.",
    "<strong>How will this affect me?</strong> You will need to approve each sign in request on your smartphone once a day and after each time you log out.": "<strong>Welke consequenties heeft dit voor mij?</strong> U dient elk inlogverzoek op uw smartphone één keer per dag goed te keuren, en elke keer nadat u bent uitgelogd.",
    Cancel: Cancel$2,
    "Get Started": "Aan de slag",
    "Install the Thomson Reuters Authenticator app on your smartphone or tablet.": "Installeer de Thomson Reuters Authenticator app op uw smartphone of tablet.",
    "Download on the Apple App Store": "Downloaden in de Apple App Store",
    "Get it on Google Play": "Downloaden via Google Play",
    Next: Next$2,
    "Generating QR code.": "Bezig met het genereren van de QR-code.",
    "Open the Thomson Reuters Authenticator app and scan the QR code below.": "Open de Thomson Reuters Authenticator app en scan de hieronder vermelde QR-code hieronder.",
    "Retrieving device info.": "Bezig met het ophalen van apparaatgegevens.",
    "You have paired your account with <strong id=\"trta1-mfs-devicename\">this device</strong>. You will need to approve each sign in request on this device once a day and after each time you log out.": "U hebt uw account gekoppeld aan <strong id=\"trta1-mfs-devicename\">dit apparaat</strong>. U dient elke inlogpoging op dit apparaat eenmaal per dag en na elke keer dat u uitlogt goed te keuren.",
    "Got It": "Begrepen",
    "Please wait…": "Even geduld…",
    "Enter your authentication code": "Voer uw authenticatiecode in",
    "Invalid code. Please enter a valid authentication code.": "Ongeldige code. Voer een geldige authenticatiecode in.",
    "Enter the code provided by your adminstrator": "Voer de door uw beheerder verstrekte code in",
    "Set up your mobile device": "Stel uw mobiele apparaat in",
    "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.": "Wachtwoord moet minimaal 8 tekens bevatten en tenminste één hoofdletter, een kleine letter, een cijfer en een symbool bevatten, zonder voor- of achterliggende spaties.",
    "Incorrect Email Address or Password. Please try again.": "Incorrect e-mailadres of wachtwoord. Probeer het opnieuw.",
    "Too many sign in attempts. Please check for unlock email or try later.": "Te veel aanmeldpogingen. Controleer voor ontvangst van een ontgrendel e-mail of probeer het later.",
    "Please change your password.": "Wijzig alstublieft uw wachtwoord.",
    "Please complete the required fields.": "Vul alstublieft de vereiste velden in.",
    "Your account has been deactivated. Please contact your administrator.": "Uw account is gedeactiveerd. Neem contact op met uw beheerder.",
    "There was an error sending the email. Please try again.": "Er is een fout opgetreden bij het versturen van de e-mail. Probeer het opnieuw.",
    "Please choose a password you have not already used.": "Kies alstublieft een wachtwoord dat u nog niet hebt gebruikt.",
    "Your account has been unlocked.": "Uw account is ontgrendeld.",
    "You've been signed out due to inactivity. Sign in to resume.": "Je bent uitgelogd vanwege inactiviteit. Log in om door te gaan.",
    "You've exceeded maximum usage time. Please sign in again.": "U heeft de maximale gebruikstijd overschreden. Log opnieuw in.",
    "Incorrect Login or Password. Please try again.": "Onjuiste gebruikersnaam of wachtwoord. Probeer het opnieuw.",
    "Missing data required to reset password. Please try again.": "Ontbrekende gegevens die nodig zijn om wachtwoord te resetten. Probeer het opnieuw.",
    "Missing data required to unlock account. Please try again.": "Ontbrekende gegevens die nodig zijn om het account te ontgrendelen. Probeer het opnieuw.",
    "Timed out waiting for device approval. Resend notification or enter code.": "Wachten op apparaat goedkeuring time-out. Stuur melding opnieuw of voer code in.",
    "Invalid code. Please try again.": "Ongeldige code. Probeer het opnieuw.",
    "Passwords Don't Match": "Wachtwoorden komen niet overeen",
    "Please wait.": "Even geduld aub.",
    "An unexpected error occurred. Please try again.": "Er is een onverwachte fout opgetreden. Probeer het opnieuw.",
    "An unexpected error occurred while redirecting your request.": "Er is een onverwachte fout opgetreden tijdens het doorverwijzen van uw aanvraag.",
    "The server did not respond in time. Please try again.": "De server reageerde niet op tijd. Probeer het opnieuw.",
    "An error occurred with your request. Please try again.": "Er is een fout opgetreden bij uw aanvraag. Probeer het opnieuw.",
    "Please provide a valid {{label}}.": "Geef een geldige {{label}} op.",
    "{{label}} is required.": "{{label}} is verplicht.",
    "Timed out waiting for scan. Please go back and try again.": "Wachten op scan timed-out. Ga terug en probeer het opnieuw.",
    "Your account is locked. Please contact your administrator.": "Uw account is geblokkeerd. Neem contact op met uw beheerder.",
    Go: Go$2,
    "Sorry, there was an issue on our end. Please try again.": "Sorry, was er een probleem aan onze kant. Probeer het opnieuw.",
    "Make your account even more secure!": "Maak uw account nog veiliger!",
    "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.": "Voeg een extra beveiligingsniveau toe voor het geval dat uw wachtwoord ooit gecompromitteerd raakt. Bevestig uw identiteit met behulp van uw mobiele apparaat.",
    "Learn more about multi-factor authentication.": "Meer informatie over multi-factor authenticatie.",
    "Remind Me Later": "Herinner Me Later",
    Close: Close$2,
    Done: Done$2,
    "Update Password": "Wachtwoord Updaten",
    "Please enter your email address to update your password.": "Vul uw e-mailadres in om uw wachtwoord te updaten.",
    "Sign In": "Inloggen",
    "Please provide a valid password.": "Voer een geldig wachtwoord in.",
    "Password contains prohibited characters.": "Wachtwoord bevat verboden tekens.",
    "Password is too similar to a common or blacklisted password.": "Dit wachtwoord lijkt te veel op een gemeen of op de zwarte lijst gezet wachtwoord.",
    "Ignore warning": "Waarschuwing negeren",
    "Your browser is not supported for use with this application. Please try again using the latest version of one of the following browsers.": "Uw browser wordt niet ondersteund voor gebruik met deze applicatie. Probeer het opnieuw met de nieuwste versie van een van de volgende browsers.",
    "Using a browser that’s no longer supported by the vendor is a security risk. Click one of the links below to upgrade to a current browser.": "Het gebruik van een browser die niet meer door de leverancier wordt ondersteund, is een beveiligingsrisico. Klik op een van de onderstaande links om een upgrade naar een huidige browser uit te voeren.",
    "Your Browser is Outdated": "Uw browser is verouderd",
    "A few minutes.": "Een paar minuten?",
    "After installing and opening the app, click Next.": "Klik na het installeren en openen van de app op Volgende.",
    Choose: Choose$2,
    "Choose multi-factor option": "Kies een multi-factor optie",
    Code: Code$2,
    "Download and install Thomson Reuters Authenticator app": "Download en installeer de app Thomson Reuters Authenticator",
    "Download and install an alternate multi-factor app": "Download en installeer een alternatieve multi-factor-app",
    "Enter the authentication code displayed by the Authenticator app.": "Voer de verificatiecode in die wordt weergegeven door de Authenticator-app.",
    "Enter the code displayed by your alternate multi-factor app.": "Voer de code in die wordt weergegeven door uw alternatieve multi-factor app.",
    Finish: Finish$2,
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.": "Voor uw bedrijf om toegang tot deze software te krijgen, moet een van de beheerders van uw bedrijf uw accounts upgraden op <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.",
    "How long will it take to set up?": "Hoe lang duurt het om dit in te stellen?",
    "How will this affect me?": "Welke consequenties heeft dit voor mij?",
    "Increase security for your account": "Verhoog de beveiliging voor uw account",
    "Invalid value entered.": "Ongeldige waarde ingevoerd.",
    "Learn more about third-party MFA apps": "Meer informatie over MFA-apps van derden",
    "Learn which MFA option is right for you": "Ontdek welke MFA-optie voor u geschikt is",
    "My Multi-Factor App": "Mijn Multi-Factor-app",
    "Name this multi-factor option": "Noem deze multi-factoroptie",
    "Need an account? Contact your administrator.": "Heeft u een account nodig? Neem contact op met uw beheerder.",
    "Need an account? Create one now.": "Heeft u een account nodig? Maak deze nu aan.",
    "Next steps after setting up MFA": "Volgende stappen na het instellen van MFA",
    "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.": "Open de app store op uw mobiele apparaat en download en installeer de app <b>Thomson Reuters Authenticator</b>.",
    "Open the <b>Thomson Reuters Authenticator app</b> on your mobile device and point your device's camera at your monitor to scan the code below.": "Open de <b>Thomson Reuters Authenticator-app</b> op uw mobiele apparaat en richt de camera van uw apparaat op uw monitor om de onderstaande code te scannen.",
    "Pairing Successful!": "koppeling was succesvol.",
    "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "Verbeter de beveiliging van uw account Wachtwoorden kunnen worden gestolen, en multi-factor authenticatie voegt een extra beveiligingslaag toe aan uw account.",
    "Receive notifications on your mobile device and sign in with a single touch.": "Ontvang meldingen op uw mobiele apparaat en log in met één aanraking.",
    "Registering your device.": "Uw apparaat registreren.",
    "Scan Code": "scancode",
    "Step 1": "Stap 1",
    "Step 2": "Stap 2",
    "Tell me how": "Vertel me hoe",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.": "De alternatieve methode moet op tijd gebaseerd eenmalig wachtwoord (TOTP) zijn. Download nu op de <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> of <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "This option requires you to enter a code each time you sign in.": "Voor deze optie moet u elke keer dat u inlogt een code invoeren.",
    "Thomson Reuters Authenticator": "Thomson Reuters Authenticator",
    "Use Thomson Reuters Authenticator (recommended)": "Gebruik Thomson Reuters Authenticator (aanbevolen)",
    "Use a third-party multi-factor app": "Gebruik een multi-factor app van derden",
    "Use your alternate multi-factor app to scan the code below.": "Gebruik uw alternatieve multi-factor app om de onderstaande code te scannen.",
    "Validate your alternate multi-factor app": "Valideer uw alternatieve multi-factor-app",
    "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.": "U kunt Thomson Reuters Authenticator gebruiken (aanbevolen) of een andere app met meerdere factoren.",
    "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.": "U hebt multi-factor authenticatie voor uw account ingesteld. U moet elk aanmeldingsverzoek op uw apparaat goedkeuren telkens wanneer u inlogt met dit account.",
    "You will need to approve each sign-in request on your device each time you sign in with this account.": "U moet elk aanmeldingsverzoek op uw apparaat goedkeuren telkens wanneer u inlogt met dit account.",
    "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.": "Uw wachtwoord moet worden bijgewerkt. Gelieve <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">in te loggen</a> en uw wachtwoord te wijzigen.",
    Copy: Copy$2,
    "Emergency Access Codes": "Noodtoegangscodes",
    "Emergency codes copied to the clipboard for pasting to a safe place.": "Noodcodes gekopieerd naar het klembord om op een veilige plek te plakken.",
    "Generating emergency codes.": "Alarmcodes genereren.",
    "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.": "Als u de toegang tot uw mobiele apparaat verliest, kunt u een van deze noodcodes gebruiken om u aan te melden bij uw account. Elke code mag slechts één keer worden gebruikt.",
    "Missing firmId parameter.": "Ontbrekende firmId-parameter.",
    "Multi-Factor Authentication Setup": "Multi-factor Authenticatie Instellen",
    Print: Print$2,
    "These codes are like the key to your office - keep them in a safe place only you can access!": "Deze codes zijn als de sleutel tot uw kantoor - bewaar ze op een veilige plek die alleen toegankelijk is voor u!",
    "Use one of these codes when this device is inaccessible. Print or save the codes to a secure location. Each code can only be used once, but more codes can be generated in your account profile.": "Gebruik een van deze codes wanneer dit apparaat niet toegankelijk is. Druk de codes af of sla ze op naar een veilige locatie. Elke code kan slechts één keer worden gebruikt, maar er kunnen meer codes in uw accountprofiel worden gegenereerd.",
    "You can generate more codes by signing in and accessing your profile.": "U kunt meer codes genereren door u aan te melden en toegang te krijgen tot uw profiel.",
    "Error copying emergency codes to the clipboard.": "Fout bij het kopiëren van noodcodes naar het klembord.",
    "Enter the authentication code displayed by your multi-factor device or provided to you.": "Voer de verificatiecode in die wordt weergegeven door uw multi-factor apparaat of aan u wordt verstrekt.",
    "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.": "Open de app <b>Thomson Reuters Authenticator</b> op uw mobiele apparaat en richt de camera van uw apparaat op uw monitor om de onderstaande code te scannen.",
    "You have set up the following multi-factor methods:": "U hebt de volgende multifactormethoden ingesteld:"
  };

  var Password$3 = "Senha";
  var Back$3 = "Voltar";
  var OK$3 = "OK";
  var Reset$3 = "Redefinir";
  var Retry$3 = "Tentar novamente";
  var Cancel$3 = "Cancelar";
  var Next$3 = "Avançar";
  var Go$3 = "Continuar";
  var Close$3 = "Fechar";
  var Done$3 = "Concluído";
  var Choose$3 = "Escolher";
  var Code$3 = "Código";
  var Finish$3 = "Finalizar";
  var Copy$3 = "Copiar";
  var Print$3 = "Imprimir";
  var or$2 = "ou";
  var Download$2 = "Download";
  var ptBR = {
    "Email Address (Thomson Reuters ID)": "Endereço de E-mail (Thomson Reuters ID)",
    "Sign in with your Thomson Reuters ID": "Logue com seu Thomson Reuters ID",
    "Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.": "Seu Thomson Reuters ID é o endereço de e-mail que você utiliza para logar em sua conta Onvio e/ou CS Web (cs.thomsonreuters.com).",
    "Sign in with your NetStaff CS account": "Logue com seu NetStaff CS conta",
    Password: Password$3,
    "Reset Password": "Redefinir Senha",
    "Manage Account": "Gerenciar Conta",
    "CS Professional Suite Security Help": "Ajuda sobre Segurança do CS Professional Suite",
    "Need an account? Contact your administrator": "Precisa de uma conta? Entre em contato com seu administrador",
    "ONVIO Sign In Security Help": "Ajuda sobre Segurança de Registro do ONVIO",
    "Need an account? Please create a new account": "Precisa de uma conta? Crie uma conta nova",
    "Internet Access Required": "Acesso à Internet Exigido",
    "To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax &amp; Accounting products.": "Para ajudar a proteger os dados confidenciais que pertencem à sua empresa e a seus clientes, e cumprir com os novos requisitos de IRS, a Thomson Reuters está adicionando nomes de usuário e senhas para acessar nossos produtos Tributários &amp; Contábeis.",
    "To sign in, please connect this computer to the internet then restart the application.": "Para se registrar, conecte este computador à Internet e, em seguida, reinicie o aplicativo.",
    "Learn more about these new security measures.": "Saiba mais sobre essas novas medidas de segurança.",
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.": "Para que sua empresa acesse esse software, um dos administradores da sua empresa precisa fazer upgrade de suas contas em <a href=\"<%= cswebHost %>/myaccount\" target=\"_blank\">cs.thomsonreuters.com/myaccount</a>.",
    "Learn More About New Security Measures": "Saiba Mais sobre Novas Medidas de Segurança",
    "Please enter your email address.": "Insira seu endereço de e-mail.",
    "Please enter your login and email address.": "Insira seu login e endereço de e-mail.",
    Back: Back$3,
    "Reset My Password": "Redefinir Minha Senha",
    "Instructions for resetting your password have been sent to your registered email address.": "Instruções para a redefinição da sua senha foram enviadas para seu endereço de e-mail registrado.",
    "Go To Sign In": "Ir para Login",
    "Please create a new password that meets <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Por favor, crie uma nova senha que atenda <a id=\"trta1-toggle-pwd-requirements\" href=\"javascript:void(0)\">requisitos</a>.",
    "Your password has expired. Please create a new one that meets <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requirements</a>.": "Sua senha expirou. Por favor, crie uma nova que atenda <a id=\"trta1-toggle-expired-pwd-requirements\" href=\"javascript:void(0)\">requisitos</a>.",
    "Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:": "Sua senha <strong>deve</strong> ter <span>pelo menos 8 caracteres</span>, incluindo todos os seguintes:",
    "At least 1 uppercase letter (A-Z)": "Pelo menos 1 letra maiúscula (A-Z)",
    "At least 1 lowercase letter (a-z)": "Pelo menos 1 letra minúscula (a-z)",
    "At least 1 digit (0-9)": "Pelo menos 1 dígito (0-9)",
    "At least 1 symbol (e.g. ! @ # $ % ^ &amp; *)": "Pelo menos 1 símbolo (e.g. ! @ # $ % ^ &amp; *)",
    "Your password should <strong>not</strong> use:": "Sua senha <strong>não</strong> deve conter:",
    "Leading or trailing spaces": "Espaços iniciais ou finais",
    "Words from the dictionary": "Palavras do dicionário",
    "Your user ID": "Sua identificação de usuário",
    "Sequential letters or numbers such as \"abc\" or \"123\"": "Letras ou números sequenciais como \"abc\" or \"123\"",
    "Show typing": "Exibir digitação",
    "Hide typing": "Ocultar digitação",
    "New Password": "Nova Senha",
    "Confirm New Password": "Confirmar Nova Senha",
    "Change My Password": "Alterar Minha Senha",
    "You've successfully changed your password.": "Você alterou sua senha com êxito.",
    OK: OK$3,
    "Your password needs to be updated. Please <a href=\"<%= netfirmWebHost %>\" target=\"_blank\"> log in</a> and change your password.": "Sua senha precisa ser atualizada. Por favor <a href=\"<%= netfirmWebHost %>\" target=\"_blank\">login</a> e altere sua senha.",
    "Back To Sign In": "Retornar ao Login",
    "Unlocking your account.": "Desbloqueio da sua conta.",
    "Your password will expire soon": "Sua senha expirará em breve",
    "Your password will expire in <em id=\"trta1-pwdexpdays\">2</em> days.": "Sua senha expirará em <em id=\"trta1-pwdexpdays\">2</em> dias.",
    "Your password will expire in <em>1</em> day.": "Sua senha expirará em <em>1</em> dia.",
    "Your password will expire <em>today</em>.": "Sua senha expirará <em>hoje</em>.",
    "Do you want to change it now?": "Deseja alterá-la agora?",
    "Change my password": "Alterar minha senha",
    "Do it later": "Fazer isso depois",
    "Your session is ending soon": "Sua sessão será encerrada em breve",
    "Your session will end in:": "Your session will end in:",
    Reset: Reset$3,
    "Multi-factor authentication required": "Autenticação multifatores exigida",
    "The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.": "O escritório exige que você habilite a autenticação multi-fatores antes de fazer login. Por favor, complete o assistente de configuração de autenticação multi-fatores para continuar.",
    "Set Up Now": "Configurar Agora",
    "Finding your paired device.": "Localização do seu dispositivo emparelhado.",
    Retry: Retry$3,
    "Notifying your paired device.": "Notificar seu dispositivo emparelhado.",
    "Check your device!": "Verifique seu dispositivo!",
    "Approve your request<br> in the Thomson Reuters Authenticator app": "Aprovar sua solicitação<br> no aplicativo Thomson Reuters Authenticator",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">enter a code</a>": "Não recebeu uma notificação? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Reenvie a notificação</a> ou <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-approvecode\">insira o código</a>",
    "No phone? Contact your firm's administrator": "Está sem telefone? Entre em contato com o administrador da empresa",
    "Cancel Request": "Cancelar Solicitação",
    "Didn't get a notification? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Resend it</a> or": "Não recebeu uma notificação? <a href=\"javascript:void(0)\" data-trta1-dest=\"trta1-mfa-choosedevice\">Reenvie a notificação</a> ou",
    "Enter code": "Inserir código",
    "Retrieving authentication token.": "Recuperação do token de autenticação.",
    "Success!": "Sucesso!",
    "You've been authenticated.": "Você foi autenticado.",
    "Please wait while we sign you into your account…": "Espere enquanto registramos você em sua conta...",
    "Multifactor authentication is currently unavailable.": "No momento, a autenticação multifatores está indisponível.",
    "Thomson Reuters": "Thomson Reuters",
    "You are using an <strong>outdated</strong> browser. Please upgrade your browser to improve security.": "Você está usando um navegador <strong>desatualizado</strong>. Por favor, atualize seu navegador para aprimorar a segurança.",
    "Multi-factor Authentication Setup": "Configuração da Autenticação Multifatores",
    "<strong>Increase security for your account</strong> Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "<strong>Aumente a segurança da sua conta</strong> Senhas podem ser hackeadas, mas o uso da autenticação multifatores acrescenta outra camada de segurança à sua conta.",
    "<strong>How long will it take to set up?</strong> Minutes.": "<strong>Quanto tempo demorará para configurar?</strong> Minutos.",
    "<strong>How will this affect me?</strong> You will need to approve each sign in request on your smartphone once a day and after each time you log out.": "<strong>Como isso irá me afetar?</strong> Você precisará aprovar cada solicitação de login em seu smartphone uma vez por dia e depois de cada logout.",
    Cancel: Cancel$3,
    "Get Started": "Iniciar",
    "Install the Thomson Reuters Authenticator app on your smartphone or tablet.": "Instale o aplicativo Thomson Reuters Authenticator em seu smartphone ou tablet.",
    "Download on the Apple App Store": "Fazer Download na Apple App Store",
    "Get it on Google Play": "Obtê-lo no Google Play",
    Next: Next$3,
    "Generating QR code.": "Geração do código QR.",
    "Open the Thomson Reuters Authenticator app and scan the QR code below.": "Abra o aplicativo Thomson Reuters Authenticator e digitalize o código QR abaixo.",
    "Retrieving device info.": "Recuperação das informações do dispositivo.",
    "You have paired your account with <strong id=\"trta1-mfs-devicename\">this device</strong>. You will need to approve each sign in request on this device once a day and after each time you log out.": "Você emparelhou sua conta com <strong id=\"trta1-mfs-devicename\">nesse dispositivo</strong>. Você precisará aprovar cada solicitação de login nesse dispositivo uma vez por dia e depois de cada vez que você desconectar.",
    "Got It": "Entendi",
    "Please wait…": "Aguarde...",
    "Enter your authentication code": "Insira seu código de autenticação",
    "Invalid code. Please enter a valid authentication code.": "Código inválido. Insira um código de autenticação válido.",
    "Enter the code provided by your adminstrator": "Inserir o código fornecido pelo seu administrador",
    "Set up your mobile device": "Configurar seu dispositivo móvel",
    "Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.": "A senha deve ter um mínimo de 8 caracteres e conter pelo menos uma letra maiúscula, uma letra minúscula, um dígito e um símbolo, sem espaços no conteúdo.",
    "Incorrect Email Address or Password. Please try again.": "Endereço de email ou senha incorretos. Por favor, tente novamente.",
    "Too many sign in attempts. Please check for unlock email or try later.": "Muitas tentativas de login. Verifique se há e-mail de desbloqueio ou tente mais tarde.",
    "Please change your password.": "Por favor, altere sua senha.",
    "Please complete the required fields.": "Complete os campos obrigatórios.",
    "Your account has been deactivated. Please contact your administrator.": "Sua conta foi desativada. Entre em contato com seu administrador.",
    "There was an error sending the email. Please try again.": "Ocorreu um erro ao enviar o e-mail. Por favor, tente novamente.",
    "Please choose a password you have not already used.": "Escolha uma senha que você ainda não usou.",
    "Your account has been unlocked.": "Sua conta foi desbloqueada.",
    "You've been signed out due to inactivity. Sign in to resume.": "Você foi desconectado devido à inatividade. Faça login para continuar.",
    "You've exceeded maximum usage time. Please sign in again.": "Você excedeu o tempo máximo de uso. Faça login novamente.",
    "Incorrect Login or Password. Please try again.": "Login ou senha incorretos. Por favor, tente novamente.",
    "Missing data required to reset password. Please try again.": "Faltam dados obrigatórios para redefinir a senha. Por favor, tente novamente.",
    "Missing data required to unlock account. Please try again.": "Faltam dados obrigatórios para desbloquear sua conta. Por favor, tente novamente.",
    "Timed out waiting for device approval. Resend notification or enter code.": "Tempo de espera esgotado para aprovação do dispositivo. Reenvie a notificação ou insira o código.",
    "Invalid code. Please try again.": "Código inválido. Por favor, tente novamente.",
    "Passwords Don't Match": "As senhas não coincidem",
    "Please wait.": "Por favor, espere.",
    "An unexpected error occurred. Please try again.": "Um erro inesperado ocorreu. Por favor, tente novamente.",
    "An unexpected error occurred while redirecting your request.": "Ocorreu um erro inesperado ao redirecionar sua solicitação.",
    "The server did not respond in time. Please try again.": "O servidor não respondeu a tempo. Por favor, tente novamente.",
    "An error occurred with your request. Please try again.": "Ocorreu um erro com sua solicitação. Por favor, tente novamente.",
    "Please provide a valid {{label}}.": "Forneça um {{label}} válido.",
    "{{label}} is required.": "{{label}} é requerido.",
    "Timed out waiting for scan. Please go back and try again.": "Tempo de espera esgotado para varredura. Por favor volte e tente novamente.",
    "Your account is locked. Please contact your administrator.": "Su cuenta se encuentra bloqueada. Póngase en contacto con el administrador.",
    Go: Go$3,
    "Sorry, there was an issue on our end. Please try again.": "Desculpe, ocorreu um problema do nosso lado. Por favor, tente novamente.",
    "Make your account even more secure!": "Torne sua conta ainda mais segura!",
    "Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.": "Adicione um nível extra de segurança para caso sua senha seja comprometida. Confirme a sua identidade usando seu dispositivo móvel.",
    "Learn more about multi-factor authentication.": "Saiba mais sobre a autenticação de dois fatores.",
    "Remind Me Later": "Lembrar Mais Tarde",
    Close: Close$3,
    Done: Done$3,
    "Update Password": "Atualizar Senha",
    "Please enter your email address to update your password.": "Por favor, informe seu endereço de e-mail para atualizar sua senha.",
    "Sign In": "Entrar",
    "Please provide a valid password.": "Forneça uma senha válida.",
    "Password contains prohibited characters.": "A senha contém caracteres proibidos.",
    "Password is too similar to a common or blacklisted password.": "Esta senha é muito comum ou considerada como insegura.",
    "Ignore warning": "Ignorar aviso",
    "Your browser is not supported for use with this application. Please try again using the latest version of one of the following browsers.": "Seu navegador não é compatível para uso desta aplicação. Por favor, tente novamente usando a versão mais recente de um dos navegadores seguintes.",
    "Using a browser that’s no longer supported by the vendor is a security risk. Click one of the links below to upgrade to a current browser.": "Utilizar um navegador que não possui mais suporte pelo fornecedor é um risco a segurança. \n Clique em um dos links abaixo para atualizar para um navegador atual.",
    "Your Browser is Outdated": "Seu navegador está desatualizado",
    "A few minutes.": "Em alguns minutos",
    "After installing and opening the app, click Next.": "Depois de instalar e abrir o aplicativo, clique em Avançar.",
    Choose: Choose$3,
    "Choose multi-factor option": "Escolha a opção multi-fatores",
    Code: Code$3,
    "Download and install Thomson Reuters Authenticator app": "Baixe e instale o aplicativo Thomson Reuters Authenticator",
    "Download and install an alternate multi-factor app": "Baixe e instale um aplicativo de autentificação multi-fatores alternativo",
    "Enter the authentication code displayed by the Authenticator app.": "Digite o código de autenticação exibido pelo aplicativo Authenticator.",
    "Enter the code displayed by your alternate multi-factor app.": "Digite o código exibido pelo seu aplicativo multi-fatores alternativo.",
    Finish: Finish$3,
    "For your firm to access this software, one of your firm's administrators needs to upgrade your accounts at <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.": "Para sua empresa acessar esse software, um dos administradores do seu escritório precisa fazer a atualização das suas contas em <a target=\"_blank\" rel=\"noopener\" href=\"<%= cswebHost %>/myaccount\">cs.thomsonreuters.com/myaccount</a>.",
    "How long will it take to set up?": "Quanto tempo demorará para configurar?",
    "How will this affect me?": "Como isso irá me afetar?",
    "Increase security for your account": "Aumentar a segurança da sua conta",
    "Invalid value entered.": "Valor inválido digitado",
    "Learn more about third-party MFA apps": "Saiba mais sobre aplicativos MFA de terceiros",
    "Learn which MFA option is right for you": "Saiba qual é a opção de MFA certa para você",
    "My Multi-Factor App": "Meu aplicativo multi-fatores",
    "Name this multi-factor option": "Nomeie esta opção multi-fatores",
    "Need an account? Contact your administrator.": "Precisa de uma conta? Entre em contato com seu administrador",
    "Need an account? Create one now.": "Precisa de uma conta? Criar uma agora",
    "Next steps after setting up MFA": "Próximas etapas após configurar o MFA",
    "On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.": "No seu dispositivo móvel, abra a loja de aplicativos, baixe e instale o aplicativo <b>Thomson Reuters Authenticator</b>.",
    "Open the <b>Thomson Reuters Authenticator app</b> on your mobile device and point your device's camera at your monitor to scan the code below.": "Abra o <b>aplicativo Thomson Reuters Authenticator</b> no seu dispositivo móvel e aponte a câmera do seu dispositivo para o monitor para verificar o código abaixo.",
    "Pairing Successful!": "Emparelhamento bem sucedido!",
    "Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.": "Senhas podem ser hackeadas, mas o uso da autenticação multi-fatores acrescenta outra camada de segurança à sua conta.",
    "Receive notifications on your mobile device and sign in with a single touch.": "Receba notificações no seu dispositivo móvel e faça login com um único toque.",
    "Registering your device.": "Registrando seu dispositivo.",
    "Scan Code": "Digitalizar Código QR",
    "Step 1": "Passo 1",
    "Step 2": "Passo 2",
    "Tell me how": "Me diga como",
    "The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.": "O método alternativo deve ser compatível geração de chaves de validação baseadas no tempo (TOTP). Faça o download agora no <a target=\"_blank\" rel=\"noopener\" href=\"https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&amp;l=<%= appleStoreLangCode %>\">Apple App Store</a> or the <a target=\"_blank\" rel=\"noopener\" href=\"https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&amp;hl=<%= googleStoreLangCode %>\">Google Play Store</a>.",
    "This option requires you to enter a code each time you sign in.": "Essa opção exige que você insira um código toda vez que fizer login.",
    "Thomson Reuters Authenticator": "Thomson Reuters Authenticator",
    "Use Thomson Reuters Authenticator (recommended)": "Use o Thomson Reuters Authenticator (recomendado)",
    "Use a third-party multi-factor app": "Use um aplicativo de autenticação multi-fatores de terceiros",
    "Use your alternate multi-factor app to scan the code below.": "Use seu aplicativo de autenticação multi-fatores alternativo para digitalizar o código abaixo.",
    "Validate your alternate multi-factor app": "Valide seu aplicativo de autenticação multi-fatores alternativo",
    "You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.": "Você pode usar o Thomson Reuters Authenticator (recomendado) ou um aplicativo de autenticação multi-fatores diferente.",
    "You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.": "Você configurou a autenticação multi-fatores para sua conta. Você precisará aprovar cada solicitação de login no seu dispositivo sempre que fizer login com essa conta.",
    "You will need to approve each sign-in request on your device each time you sign in with this account.": "Você precisará aprovar cada solicitação de login no seu dispositivo sempre que fizer login com essa conta.",
    "Your password needs to be updated. Please <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">log in</a> and change your password.": "Sua senha precisa ser atualizada. <a target=\"_blank\" rel=\"noopener\" href=\"<%= netfirmWebHost %>\">Faça login</a> e altere sua senha.",
    Copy: Copy$3,
    "Emergency Access Codes": "Códigos de acesso de emergência",
    "Emergency codes copied to the clipboard for pasting to a safe place.": "Códigos de emergência copiados da área de transferência para colar em um local seguro.",
    "Generating emergency codes.": "Gerando códigos de emergência.",
    "If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.": "Se você perder o acesso no seu dispositivo móvel, poderá usar um desses códigos de emergência para fazer login na sua conta. Cada código pode ser usado apenas uma vez.",
    "Missing firmId parameter.": "Parâmetro de firmId ausente.",
    "Multi-Factor Authentication Setup": "Configuração da autenticação multi-fatores",
    Print: Print$3,
    "These codes are like the key to your office - keep them in a safe place only you can access!": "Esses códigos são como a chave do seu escritório - mantenha-os em um local seguro que só você pode acessar!",
    "Use one of these codes when this device is inaccessible. Print or save the codes to a secure location. Each code can only be used once, but more codes can be generated in your account profile.": "Utilize um desses códigos quando este dispositivo estiver inacessível. Imprima ou salve os códigos em um local seguro. Cada código só pode ser usado uma vez, mas mais códigos podem ser gerados no perfil da sua conta.",
    "You can generate more codes by signing in and accessing your profile.": "Você pode gerar mais códigos fazendo login e acessando seu perfil.",
    "Error copying emergency codes to the clipboard.": "Erro ao copiar códigos de emergência para a área de transferência.",
    "Enter the authentication code displayed by your multi-factor device or provided to you.": "Digite o código de autenticação exibido pelo seu dispositivo multi-fatores ou o código fornecido a você.",
    "Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.": "Abra o aplicativo <b>Thomson Reuters Authenticator</b> no seu dispositivo móvel e aponte a câmera do seu dispositivo para o monitor para escanear o código abaixo.",
    "You have set up the following multi-factor methods:": "Você configurou os seguintes métodos de multi-fatores:",
    "Device ID": "ID do dispositivo",
    "Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.": "Digite o ID do dispositivo com 9 caracteres, começando com as letras TR na parte de trás do seu cartão do Thomson Reuters Authenticator.",
    "Enter the one-time code displayed on your multi-factor device.": "Digite o código único exibido no seu dispositivo multifator.",
    "Learn more about multi-factor devices": "Saiba mais sobre dispositivos multifator",
    "Use a multi-factor device": "Use um dispositivo multifator",
    "Use a multi-factor device like a card that displays a code to enter.": "Use um dispositivo multifator que exibe um código para inserir como um cartão.",
    "Validate your multi-factor device": "Valide seu dispositivo multifator",
    "Incorrect Device ID or Code. Please try again.": "ID ou código do dispositivo incorreto. Por favor, tente novamente.",
    "Thomson Reuters Authenticator Card": "Cartão do Thomson Reuters Authenticator",
    "Save Emergency Access Codes": "Salvar códigos de acesso de emergência",
    "Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile": "Salve ou imprima esses códigos em um local seguro para uso quando seu dispositivo MFA principal estiver indisponível (por exemplo, se você estiver com um novo telefone). Você pode usar cada código apenas uma vez, mas pode gerar mais códigos no perfil da sua conta",
    or: or$2,
    Download: Download$2
  };

  var locales = {
    'en-CA': enCA,
    'es-AR': esAR,
    'fr-CA': frCA,
    'nl-NL': nlNL,
    'pt-BR': ptBR
  };

  var template$1 = "<form name=\"trta1-mfs-choosetype\">\n  <h3 t8>Choose multi-factor option</h3>\n  <div class=\"trta1-form-instructions\">\n    <p t8>You can use Thomson Reuters Authenticator (recommended), or a different multi-factor app.</p>\n    <p>\n      <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-trid-only trta1-type-onvio-only\" href=\"<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/staff/core/common/choosing-multi-factor-option.htm\">Learn which MFA option is right for you</a>\n      <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-csweb-only trta1-type-netfirm-only\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/choosing-multi-factor-option.htm\">Learn which MFA option is right for you</a>\n      <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-netfirmdt-only\" href=\"http://cs.thomsonreuters.com/ua/netfirm/admin_drtax_<%= dtHelpLocale %>/common/choosing-multi-factor-option.htm\">Learn which MFA option is right for you</a>\n    </p>\n  </div>\n  <div class=\"trta1-carousel\">\n    <button class=\"trta1-carousel-left-nav\">&lt;</button>\n    <ul>\n      <li class=\"mfs-choose-tr-auth-app trta1-carousel-item-selected\">\n        <h4 t8>Use Thomson Reuters Authenticator (recommended)</h4>\n        <div class=\"tr-auth-app-bg trta1-clearfix\">\n          <p t8>Receive notifications on your mobile device and sign in with a single touch.</p>\n          <button t8 class=\"trta1-btn-primary\" data-trta1-dest=\"trta1-mfs-install\">Choose</button>\n        </div>\n      </li>\n      <li class=\"mfs-choose-third-party-app\">\n        <h4 t8>Use a third-party multi-factor app</h4>\n        <div class=\"thirdparty-app-bg trta1-clearfix\">\n          <p t8>This option requires you to enter a code each time you sign in.</p>\n          <button t8 class=\"trta1-btn-primary\" data-trta1-dest=\"trta1-mfs-3p-install\">Choose</button>\n        </div>\n      </li>\n      <li class=\"mfs-choose-device\">\n        <h4 t8>Use a multi-factor device</h4>\n        <div class=\"device-bg trta1-clearfix\">\n          <p t8>Use a multi-factor device like a card that displays a code to enter.</p>\n          <button t8 class=\"trta1-btn-primary\" data-trta1-dest=\"trta1-mfs-pairdevice\">Choose</button>\n        </div>\n      </li>\n    </ul>\n    <button class=\"trta1-carousel-right-nav\">&gt;</button>\n  </div>\n  <div class=\"trta1-carousel-pos-indicator\"></div>\n  <div class=\"trta1-btn-group\">\n    <div><button t8 data-trta1-dest=\"trta1-mfs-intro\" type=\"button\">Back</button></div>\n  </div>\n</form>\n";

  var CAROUSEL_ITEM_SELECTED_CLASS = 'trta1-carousel-item-selected';
  var CAROUSEL_POS_SELECTED_CLASS = 'trta1-carousel-pos-selected';

  function init$1(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfs-choosetype]');
    var carouselLeftNav = form.querySelector('.trta1-carousel-left-nav');
    var carouselRightNav = form.querySelector('.trta1-carousel-right-nav');
    var carouselPosIndicator = form.querySelector('.trta1-carousel-pos-indicator');
    var carouselItemSelectedIdx = 0;
    var chooseDeviceOption = form.querySelector('.mfs-choose-device');
    var chooseThirdPartyAppOption = form.querySelector('.mfs-choose-third-party-app');

    // toggle showing device (card) option based on enableMFACards setting
    chooseDeviceOption.classList[options.enableMFACards ? 'remove' : 'add']('trta1-hide');
    // toggle showing device (third-party app) option based on enableThirdPartyApp setting
    chooseThirdPartyAppOption.classList[options.enableThirdPartyApp ? 'remove' : 'add']('trta1-hide');

    var visibleCarouselItems = form.querySelectorAll('.trta1-carousel li:not(.trta1-hide)');

    // create carousel indicators
    for (var i = 0; i < visibleCarouselItems.length; i++) {
      carouselPosIndicator.appendChild(document.createElement('button'));
    }
    if(visibleCarouselItems.length < 2) {
      carouselLeftNav.classList.add('trta1-hide');
      carouselRightNav.classList.add('trta1-hide');
      carouselPosIndicator.classList.add('trta1-hide');
    }

    // set first as selected
    carouselPosIndicator.firstElementChild.classList.add('trta1-carousel-pos-selected');

    trAuth.listen('click', function(evt) {
      if (evt.target.matches('.mfs-choose-tr-auth-app button')) {
        options.state.mfsChosenType = 'tr-app';
      } else if (evt.target.matches('.mfs-choose-third-party-app button')) {
        options.state.mfsChosenType = '3p-app';
      }
    }, form);

    trAuth.listen('click', function(evt) {
      selectRelativeCarouselItem('prev');
    }, carouselLeftNav);

    trAuth.listen('click', function(evt) {
      selectRelativeCarouselItem('next');
    }, carouselRightNav);

    trAuth.listen('click', function(evt) {
      if (evt.target.tagName.toLowerCase() !== 'button') { return; }
      var positions = Array.from(carouselPosIndicator.querySelectorAll('button'));
      selectCarouselItem(positions.indexOf(evt.target));
    }, carouselPosIndicator);

    function selectRelativeCarouselItem(direction) {
      var modifier = (direction === 'next') ? 1 : (direction === 'prev') ? -1 : 0;
      carouselItemSelectedIdx += modifier;
      var totalItems = visibleCarouselItems.length;
      carouselItemSelectedIdx = carouselItemSelectedIdx < 0 ? totalItems - 1 : carouselItemSelectedIdx;
      selectCarouselItem(carouselItemSelectedIdx % totalItems);
    }

    function selectCarouselItem(idx) {
      var items = visibleCarouselItems;
      var positions = carouselPosIndicator.querySelectorAll('button');
      form.querySelector('.' + CAROUSEL_ITEM_SELECTED_CLASS).classList.remove(CAROUSEL_ITEM_SELECTED_CLASS);
      form.querySelector('.' + CAROUSEL_POS_SELECTED_CLASS).classList.remove(CAROUSEL_POS_SELECTED_CLASS);
      items[idx].classList.add(CAROUSEL_ITEM_SELECTED_CLASS);
      positions[idx].classList.add(CAROUSEL_POS_SELECTED_CLASS);
    }
  }

  var chooseType = {
    template: template$1,
    init: init$1
  };

  var template$2 = "<form name=\"trta1-mfs-emergencycodes\" method=\"post\" action=\"<%= authSvcHost %>/api/mfa/v1/factors/emergency-codes\" tr-autosubmit novalidate>\n  <div class=\"trta1-processing-only trta1-error-only\">\n    <div class=\"trta1-form-instructions\">\n      <p t8>Generating emergency codes.</p>\n    </div>\n    <div class=\"trta1-btn-group\">\n      <div><button t8 data-trta1-dest=\"trta1-$close\" type=\"button\">Cancel</button></div>\n      <div><button t8 data-trta1-dest=\"trta1-$retry\">Retry</button></div>\n    </div>\n  </div>\n  <div class=\"trta1-success-only\">\n    <h3 t8>Save Emergency Access Codes</h3>\n    <div class=\"trta1-form-instructions\">\n      <p t8>Save or print these codes to a secure location for use when your primary MFA device is unavailable (e.g., if you get a new phone). You can use each code only once, but you can generate more codes in your account profile</p>\n      <p t8 class=\"trta1-print-only\">If you lose access to your mobile device, you can use one of these emergency codes to sign in to your account. Each code may be used only once.</p>\n      <p t8 class=\"trta1-print-only\">You can generate more codes by signing in and accessing your profile.</p>\n      <div>\n          <p class=\"trta1-icon-warning trta1-print\"></p>\n          <p t8 class=\"trta1-print\">These codes are like the key to your office - keep them in a safe place only you can access!</p>\n      </div>\n    </div>\n    <ul class=\"mfs-ecodes-list trta1-print\"></ul>\n    <ul class=\"mfs-ecodes-links\">\n      <li><button type=\"button\" t8 class=\"trta1-btn-primary mfs-ecodes-copy-btn\">Copy</button></li>\n      <span t8>or</span>\n      <li><button type=\"button\" t8 class=\"trta1-btn-primary mfs-ecodes-print-btn\">Print</button></li>\n    </ul>\n    <div t8 class=\"trta1-form-msg-warning mfs-ecodes-copied-msg\">Emergency codes copied to the clipboard for pasting to a safe place.</div>\n    <div t8 class=\"trta1-form-msg-error mfs-ecodes-copy-failed-msg\">Error copying emergency codes to the clipboard.</div>\n    <input type=\"hidden\" name=\"type\" value=\"C\">\n    <input type=\"hidden\" name=\"address\" value=\"COTP\">\n    <div class=\"trta1-btn-group\">\n      <div><button t8 data-trta1-dest=\"trta1-$close\" class=\"trta1-btn-secondary mfs-ecodes-done-btn\" disabled=\"disabled\">Done</button></div>\n    </div>\n  </div>\n</form>\n";

  function init$2(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfs-emergencycodes]');
    var codesList = form.querySelector('.mfs-ecodes-list');
    var printLink = form.querySelector('.mfs-ecodes-print-btn');
    var copyLink = form.querySelector('.mfs-ecodes-copy-btn');
    var copiedMsg = form.querySelector('.mfs-ecodes-copied-msg');
    var copyFailedMsg = form.querySelector('.mfs-ecodes-copy-failed-msg');
    var doneBtn = form.querySelector('.mfs-ecodes-done-btn');
    var exitBtn = rootElem.querySelector('.trta1-dialog-close');

    trAuth.listen('trta1-mfs-emergencycodes-success', function(evt) {
      options.state.emergencyCodesClipboardText = '';
      exitBtn.classList.add('trta1-hide');
      trAuth.removeNodes(codesList.childNodes);
      evt.detail.data.forEach(function(factor) {
        var li = document.createElement('li');
        var formattedSecret = factor.otpSecret.substring(0, 4) + ' ' + factor.otpSecret.substring(4);
        var text = document.createTextNode(formattedSecret + '\r');
        options.state.emergencyCodesClipboardText += formattedSecret + '\r\n';
        li.appendChild(text);
        codesList.appendChild(li);
      });
    }, rootElem);

    trAuth.listen('trta1-mfs-emergencycodes-error', function(evt) {
      // if user isn't yet fully authenticated, close and require auth
      if(evt.detail.status === 403){
        trAuth.changeForm('trta1-$close');
      }
    }, rootElem);

    trAuth.listen('click', function() {
      // enable Done button
      doneBtn['removeAttribute']('disabled', 'disabled');
      var html = '<style>\
      body { margin: 40px; font-family: sans-serif; }\
      .trta1-icon-warning:before { font-size: 1.5em; content: "⚠"; vertical-align: middle; }\
      ul { list-style: none; }\
      li:before { font-size: 1.5em; content: "☐"; vertical-align: baseline; margin: 5px; }\
    </style>';
      // Render print elements into a blank tab/window.
      // WARNING: no user generated content, otherwise there is an XSS risk!
      Array.from(rootElem.querySelectorAll('h1, h2')).concat(
        Array.from(form.querySelectorAll('h3, .trta1-print, .trta1-print-only'))
      ).forEach(function(el) {
        html += el.outerHTML;
      });
      trAuth.openPrintWindow(html, options.state.$t('Emergency Access Codes'));
    }, printLink);

    trAuth.listen('click', function() {
      copyReset();

      if ('clipboard' in window.navigator) {
        navigator.clipboard.writeText(options.state.emergencyCodesClipboardText)
          .then(copySuccess)
          .catch(clipboardCopyFallback);
      } else {
        clipboardCopyFallback();
      }
    }, copyLink);

    function clipboardCopyFallback() {
      var input = document.createElement('textarea');
      document.body.appendChild(input);
      input.value = options.state.emergencyCodesClipboardText;

      // sadly focus and select will sometimes fail in IWebBrowser2 (embedded)
      try {
        input.focus();
        input.select();
        // enable Done button
        doneBtn['removeAttribute']('disabled', 'disabled');
      } catch(e) {
        copyFail();
        return;
      }

      var success = document.execCommand('copy');
      document.body.removeChild(input);
      success ? copySuccess() : copyFail();
    }
    function copyReset() {
      copiedMsg.style.display = 'none';
      copyFailedMsg.style.display = 'none';
    }
    function copySuccess() {
      copiedMsg.classList.add('trta1-form-msg');
      copiedMsg.style.display = 'block';
      // enable Done button
      doneBtn['removeAttribute']('disabled', 'disabled');
    }
    function copyFail() {
      copyFailedMsg.classList.add('trta1-form-msg');
      copyFailedMsg.style.display = 'block';
    }
  }

  var emergencyCodes = {
    template: template$2,
    init: init$2
  };

  var template$3 = "<form name=\"trta1-mfs-pairdevice\" method=\"post\" action=\"<%= authSvcHost %>/api/mfa/v1/factors/device\" novalidate tr-goto-onsuccess=\"trta1-mfs-devicelookup\">\n  <h3 t8>Validate your multi-factor device</h3>\n  <div>\n    <h4 t8>Step 1</h4>\n    <p t8>Enter the 9-character device ID starting with the letters TR from the back of your Thomson Reuters Authenticator card.</p>\n    <p>\n      <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-trid-only trta1-type-onvio-only\" href=\"<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/staff/core/common/learn-about-multi-factor-devices.htm\">Learn more about multi-factor devices</a>\n      <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-csweb-only trta1-type-netfirm-only\" href=\"https://cs.thomsonreuters.com/ua/login_security/cs_us_en/learn-about-multi-factor-devices.htm\">Learn more about multi-factor devices</a>\n      <a t8 target=\"_blank\" rel=\"noopener\" class=\"trta1-type-csweb-only trta1-type-netfirm-only\" href=\"\">Learn more about multi-factor devices</a>\n    </p>\n    <label>\n      <div t8>Device ID</div>\n      <input required pattern=\"(t|T)(r|R)\\s?\\d{3}\\s?\\d{4}\" name=\"rawDeviceId\" autocomplete=\"off\" maxlength=\"11\" tr-nosend>\n    </label>\n  </div>\n  <div>\n    <h4 t8>Step 2</h4>\n    <p t8>Enter the one-time code displayed on your multi-factor device.</p>\n    <label>\n      <div t8>Code</div>\n      <input required pattern=\"\\d{3}\\s?\\d{3}\" name=\"rawCode\" autocomplete=\"off\" maxlength=\"7\" tr-nosend>\n    </label>\n  </div>\n  <input type=\"hidden\" name=\"type\" value=\"A\">\n  <input type=\"hidden\" name=\"deviceId\">\n  <input type=\"hidden\" name=\"code\" tr-noconvert>\n  <div class=\"trta1-btn-group\">\n    <div><button t8 data-trta1-dest=\"trta1-mfs-choosetype\" type=\"button\">Back</button></div>\n    <div class=\"trta1-next-btn-container\"><button t8 class=\"trta1-btn-primary\">Next</button></div>\n  </div>\n</form>\n";

  function init$3(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfs-pairdevice]');
    var rawDeviceIdInput = form.querySelector('[name=rawDeviceId]');
    var rawCodeInput = form.querySelector('[name=rawCode]');
    var deviceIdInput = form.querySelector('[name=deviceId]');
    var codeInput = form.querySelector('[name=code]');

    trAuth.listen('submit', function() {
      deviceIdInput.value = rawDeviceIdInput.value.replace(/\s/g, '').toUpperCase();
      codeInput.value = rawCodeInput.value.replace(/\s/g, '');
    }, form);

    trAuth.listen('trta1-mfs-pairdevice-success', function(evt) {
      // use state bag for factorData, so subsequent steps will have what they need
      options.state.factorData = evt.detail.data;
    }, rootElem);

    trAuth.listen('trta1-mfs-pairdevice-error', function() {
      trAuth.focusFirstEnabledField(form, function(field) {
        return field === rawCodeInput;
      });
    }, rootElem);

    trAuth.listen('trta1-mfs-pairdevice-exit', function() {
      form.reset();
    }, rootElem);
  }

  var pairDevice = {
    template: template$3,
    init: init$3
  };

  var template$4 = "<form name=\"trta1-mfs-registerdevice\" method=\"post\" action=\"<%= authSvcHost %>/api/mfa/v1/factors/_id_/register\" tr-goto-onsuccess=\"trta1-mfs-devicelookup\" tr-autosubmit novalidate>\n<div class=\"trta1-form-instructions\">\n  <p t8>Registering your device.</p>\n</div>\n<div class=\"trta1-btn-group\">\n  <div><button t8 data-trta1-dest=\"trta1-mfs-choosetype\" type=\"button\">Back</button></div>\n  <div><button t8 data-trta1-dest=\"trta1-$retry\">Retry</button></div>\n</div>\n</form>\n";

  function init$4(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfs-registerdevice]');

    trAuth.listen('submit', function(evt) {
      var factorData = options.state.factorData;
      var registerPayload = trAuth.seekObjPath('formOverrides.trta1-mfs-registerdevice.payload', options, true);
      var deviceName = options.state.mfsChosenType === 'tr-app-totp' ?
        options.state.$t('Thomson Reuters Authenticator'):
        options.state.$t('My Multi-Factor App');

      form.action = form.action.replace(/[^\/]+\/register$/, factorData.factorId + '/register');
      registerPayload.mfarId = factorData.mfarId;
      registerPayload.factor = { name: deviceName, address: '' };
    }, form);
  }

  var registerDevice = {
    template: template$4,
    init: init$4
  };

  var template$5 = "<form name=\"trta1-mfs-scancode\" method=\"get\" action=\"<%= authSvcHost %>/api/mfa/v1/requests/_id_\" class=\"trta1-nodisable\" novalidate>\n  <h3 t8 class=\"mfs-type-tr-app-only\">Scan Code</h3>\n  <h3 t8 class=\"mfs-type-3p-app-only\">Validate your alternate multi-factor app</h3>\n  <div class=\"mfs-type-tr-app-only\">\n    <p t8>Open the <b>Thomson Reuters Authenticator</b> app on your mobile device and point your device's camera at your monitor to scan the code below.</p>\n  </div>\n  <div class=\"mfs-type-3p-app-only\">\n    <h4 t8>Step 1</h4>\n    <p t8>Use your alternate multi-factor app to scan the code below.</p>\n  </div>\n  <div class=\"trta1-mfs-qrcode\"></div>\n  <div class=\"mfs-manual-code-container\">\n    <h4 t8 class=\"mfs-type-3p-app-only\">Step 2</h4>\n    <p t8 class=\"mfs-type-3p-app-only\">Enter the code displayed by your alternate multi-factor app.</p>\n    <p t8 class=\"mfs-type-tr-app-only\">Enter the authentication code displayed by the Authenticator app.</p>\n    <label>\n      <div t8>Code</div>\n      <input required pattern=\"\\d{3,4}\\s?\\d{3,4}\" name=\"mfs-manual-code\" autocomplete=\"off\" maxlength=\"9\" tr-nosend>\n    </label>\n  </div>\n  <div class=\"trta1-btn-group\">\n    <div><button t8 data-trta1-dest=\"trta1-mfs-choosetype\" type=\"button\">Back</button></div>\n    <div class=\"trta1-next-btn-container\"><button t8 class=\"trta1-btn-primary\">Next</button></div>\n  </div>\n</form>\n";

  function init$5(rootElem, options, trAuth) {
    var form = rootElem.querySelector('form[name=trta1-mfs-scancode]');
    var cancelScanPoll;

    trAuth.listen('trta1-mfs-scancode-enter', function(evt) {
      // if we haven't already gotten a code, go gen
      if (!options.state.qrCode) {
        trAuth.changeForm('trta1-mfs-gencode', rootElem);
        return;
      }

      var chosenType = options.state.mfsChosenType || 'tr-app';
      var manualCodeContainer = form.querySelector('.mfs-manual-code-container');
      var manualCode = manualCodeContainer.querySelector('[name=mfs-manual-code]');
      var factorData = options.state.factorData;
      var nextBtn = form.querySelector('.trta1-next-btn-container');

      // reset tr-app-totp to tr-app
      if (chosenType === 'tr-app-totp') options.state.mfsChosenType = 'tr-app';

      form.action = form.action.replace(/\/requests\/.*$/, '/requests/' + factorData.mfarId);
      form.classList.remove('mfs-type-tr-app', 'mfs-type-3p-app');
      form.classList.add('mfs-type-' + chosenType);

      if (chosenType === 'tr-app') {
        manualCodeContainer.style.display = 'none';
        nextBtn.style.display = 'none';

        manualCode.required = false;

        // poll for success
        cancelScanPoll = trAuth.pollFormRequest(
          form,
          // test fn
          function(evt) {
            return evt.detail.data.status === 'SUCCEEDED';
          },
          // success fn
          function() {
            options.state.qrCode = null; // once a request has been validated it is used up, wipe qrCode
            trAuth.changeForm('trta1-mfs-devicelookup', rootElem);
          },
          // timeout fn
          function() {
            trAuth.updateFormState(form, 'error', options, 'timeout');
            manualCodeContainer.style.display = 'block';
            manualCode.required = true;
            nextBtn.style.display = 'block';
            // switch to totp mode so user can enter code
            options.state.mfsChosenType = 'tr-app-totp';
          },
          null, // errorFn
          2, // delay
          120 // timeout seconds

          // roll with defaults for rest of params
          // leadingEdge = false, continueOnError = false
        );
      } else { // 3rd-party-app
        manualCodeContainer.style.display = 'block';
        nextBtn.style.display = 'block';
        manualCode.required = true;
      }

    }, rootElem);

    trAuth.listen('submit', function(evt) {
      var headers = trAuth.seekObjPath('formOverrides.trta1-mfs-scancode.headers', options, true),
        factorData = options.state.factorData;

      if (options.state.mfsChosenType === 'tr-app') {
        form.method = 'get';
        form.action = form.action.replace(/(\/validate)?$/, '');
        delete headers.authorization;

      } else { // type is 3p-app or tr-app-totp
        var code = form.elements['mfs-manual-code'].value.replace(/\s/g, '');
        form.method = 'post';
        form.action = form.action.replace(/(\/validate)?$/, '/validate');
        headers.authorization = 'OTP ' + code + ':' + factorData.factorId;
      }
    }, form);

    trAuth.listen('trta1-mfs-scancode-success', function(evt) {
      if (options.state.mfsChosenType === 'tr-app') return;
      // type is 3p-app or tr-app-totp
      form.reset();
      options.state.qrCode = null; // once a request has been validated it is used up, wipe qrCode
      trAuth.changeForm('trta1-mfs-registerdevice', rootElem);
    }, rootElem);

    trAuth.listen('trta1-mfs-scancode-error', function(evt) {
      form.reset();
      trAuth.focusFirstEnabledField(form);
    }, rootElem);

    trAuth.listen('trta1-mfs-scancode-exit', function(evt) {
      if (cancelScanPoll) {
        cancelScanPoll();
        cancelScanPoll = null;
      }
      form.reset();
    }, rootElem);
  }

  var scanCode = {
    template: template$5,
    init: init$5
  };

  var index = {
    approveCode: approveCode,
    locales: locales,
    chooseType: chooseType,
    emergencyCodes: emergencyCodes,
    pairDevice: pairDevice,
    registerDevice: registerDevice,
    scanCode: scanCode
  };

  return index;

}());
//# sourceMappingURL=bundle.js.map
(function(window) {
  'use strict';

  var trAuth = window.trAuth;

  var captchaApiTmpl = trAuth.template('https://www.google.com/recaptcha/api.js?hl=<%= gLangCode %>&onload=_trAuth_modules_auth_captchaReady&render=explicit');
  var gLangCodeMap = {
    'en-AU': 'en-GB',
    'en-CA': 'en-GB',
    'en-GB': 'en-GB',
    'en-IN': 'en-GB',
    'en-US': 'en',
    'es-AR': 'es-419',
    'fr-CA': 'fr-CA',
    'nl-NL': 'nl',
    'pt-BR': 'pt-BR'
  };

  var MFA_NAG_DISMISS_KEY = 'tr-auth-mfnag-dismissday';
  var MFA_SHOULD_NAG_KEY = 'tr-auth-mfnag-display';

  /* jshint multistr: true */
  var moduleTemplate = '\
    <section id="trid-auth">\
      <h1 t8>Thomson Reuters</h1>\
      <h2 t8 class="trta1-netfirm-subhead">Sign in with your NetStaff CS account</h2>\
      <h2 class="trta1-trid-subhead">\
        <span t8>Sign in with your Thomson Reuters ID</span>\
        <span class="trta1-icon-question"></span>\
        <p t8 class="trta1-trid-help trta1-visually-hidden">Your Thomson Reuters ID is the email address you use to sign in to your Onvio and/or CS Web (cs.thomsonreuters.com) accounts.</p>\
      </h2>\
      <form id="trta1-auth" name="trta1-signin" method="post" action="<%= authSvcHost %>/api/auth/v2/login" novalidate>\
        <label>\
          <span t8 id="tr-auth-uid-label" class="trta1-placeholder-label">Email Address (Thomson Reuters ID)</span>\
          <span class="trta1-icon-user">\
            <input t8 type="email" name="uid" aria-labelledby="tr-auth-uid-label" data-qe-id="trauth-signin-uid" placeholder="Email Address (Thomson Reuters ID)" required pattern=".*\\S+.*" maxlength="250" autocorrect="off" autocapitalize="off" spellcheck="false">\
          </span>\
        </label>\
        <label>\
          <span t8 id="tr-auth-pwd-label" class="trta1-placeholder-label">Password</span>\
          <span class="trta1-icon-lock">\
            <input t8 type="password" name="pwd" aria-labelledby="tr-auth-pwd-label" data-qe-id="trauth-signin-pwd" placeholder="Password" required pattern=".*\\S+.*" maxlength="50">\
          </span>\
          <span class="trta1-align-right"><a t8 id="trta1-resetpwd-link" data-trta1-dest="trta1-reqpwdreset" href="javascript:void(0)">Reset Password</a></span>\
        </label>\
        <div class="trta1-captcha-container"></div>\
        <div class="trta1-btn-group">\
          <button t8 name="signinBtn" data-qe-id="trauth-signin-btn" class="trta1-btn-primary" tr-nosend>Sign In</button>\
        </div>\
        <footer class="trta1-signin-trid-footer">\
          <a t8 target="_blank" rel="noopener" href="<%= cswebHost %>/myaccount/login.aspx">Manage Account</a><br>\
          <a t8 target="_blank" rel="noopener" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/cs-professional-suite-application-security-overview.htm">CS Professional Suite Security Help</a>\
          <p t8>Need an account? Contact your administrator.</p>\
        </footer>\
        <footer class="trta1-signin-netfirm-footer">\
          <a t8 target="_blank" rel="noopener" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/cs-professional-suite-application-security-overview.htm">CS Professional Suite Security Help</a>\
        </footer>\
        <footer class="trta1-signin-onvio-footer">\
          <a t8 target="_blank" rel="noopener" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/staff/core/setup/onvio-login-security-overview.htm">ONVIO Sign In Security Help</a>\
        </footer>\
        <footer class="trta1-signin-csweb-footer">\
          <a t8 href="<%= cswebHost %>/myaccount/nu.aspx">Need an account? Create one now.</a>\
        </footer>\
      </form>\
      <form name="trta1-mfnag">\
        <h3><p t8>Make your account even more secure!</p></h3>\
        <div class="trta1-form-instructions shield-bg">\
          <p t8>Add an additional level of security in case your password is ever compromised. Confirm your identity using your mobile device.</p>\
          <p class="trta1-cs-help"><a t8 target="_blank" rel="noopener" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/multi-factor-authentication-overview.htm">Learn more about multi-factor authentication.</a></p>\
          <p class="trta1-hide trta1-onvio-help"><a t8 target="_blank" rel="noopener" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/staff/core/common/mfa-reminder.htm">Learn more about multi-factor authentication.</a></p>\
          <p class="trta1-hide trta1-dt-help"><a t8 target="_blank" rel="noopener" href="http://cs.thomsonreuters.com/ua/netfirm/nc_drtax_<%= dtHelpLocale %>/common/drtax-mfa-overview.htm">Learn more about multi-factor authentication.</a></p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 id="trta1-mfs-later">Remind Me Later</button></div>\
          <div><button t8 class="trta1-btn-primary trta1-mfs-go">Set Up Now</button></div>\
        </div>\
      </form>\
      <form name="trta1-offlinerequirement">\
        <h3 t8 class="trta1-icon-warning">Internet Access Required</h3>\
        <div class="trta1-form-instructions">\
          <p t8>To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax & Accounting products.</p>\
          <p t8>To sign in, please connect this computer to the internet then restart the application.</p>\
          <p class="trta1-cs-help"><a t8 target="_blank" rel="noopener" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/cs-professional-suite-application-security-overview.htm">Learn more about these new security measures.</a></p>\
          <p class="trta1-hide trta1-onvio-help"><a t8 target="_blank" rel="noopener" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/staff/core/setup/onvio-login-security-overview.htm">Learn more about these new security measures.</a></p>\
        </div>\
      </form>\
      <form name="trta1-migrationcheck" method="get" action="<%= authSvcHost %>/api/auth/v1/firms/migration" tr-autosubmit tr-goto-onerror="trta1-signin" novalidate>\
      </form>\
      <form name="trta1-intro">\
        <div class="trta1-form-instructions">\
          <p t8>To help protect the confidential data belonging to your firm and your clients and to comply with new IRS requirements, Thomson Reuters is adding usernames and passwords to access our Tax & Accounting products.</p>\
          <p t8>For your firm to access this software, one of your firm&apos;s administrators needs to upgrade your accounts at <a target="_blank" rel="noopener" href="<%= cswebHost %>/myaccount">cs.thomsonreuters.com/myaccount</a>.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <a t8 target="_blank" rel="noopener" class="trta1-btn-primary" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/cs-professional-suite-application-security-overview.htm">Learn More About New Security Measures</a>\
        </div>\
      </form>\
      <form name="trta1-reqpwdreset" method="post" action="<%= authSvcHost %>/api/auth/v1/password/reset" tr-goto-onsuccess="trta1-pwdresetreqsent" novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Please enter your email address.</p>\
        </div>\
        <div class="trta1-form-instructions trta1-form-instructions-netfirm trta1-hide">\
          <p t8>Please enter your login and email address.</p>\
        </div>\
        <label><span t8>Email Address (Thomson Reuters ID)</span>\
          <input type="email" name="uid" required pattern=".*\\S+.*" maxlength="250" autocorrect="off" autocapitalize="off" spellcheck="false">\
        </label>\
        <label class="trta1-hide"><span t8>Email Address</span>\
          <input type="email" name="email" required maxlength="250" autocorrect="off" autocapitalize="off" spellcheck="false" disabled>\
        </label>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-$back" type="button">Back</button></div>\
          <div><button t8 class="trta1-btn-primary">Reset My Password</button></div>\
        </div>\
      </form>\
      <form name="trta1-pwdresetreqsent">\
        <div class="trta1-form-instructions">\
          <p t8>Instructions for resetting your password have been sent to your registered email address.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8 data-trta1-dest="trta1-signin" class="trta1-btn-primary">Go To Sign In</button>\
        </div>\
      </form>\
      <form name="trta1-pwdreset" method="put" action="<%= authSvcHost %>/api/auth/v1/password" tr-goto-onsuccess="trta1-pwdreset-complete" novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Please create a new password that meets <a id="trta1-toggle-pwd-requirements" href="javascript:void(0)">requirements</a>.</p>\
        </div>\
        <div class="trta1-form-instructions trta1-form-instructions-pwdexpired trta1-hide">\
          <p t8>Your password has expired. Please create a new one that meets <a id="trta1-toggle-expired-pwd-requirements" href="javascript:void(0)">requirements</a>.</p>\
        </div>\
        <div id="trta1-pwd-requirements" class="trta1-hide">\
          <p t8>Your password <strong>must</strong> have <span>at least 8 characters</span> including all of the following:</p>\
          <ul>\
            <li t8>At least 1 uppercase letter (A-Z)</li>\
            <li t8>At least 1 lowercase letter (a-z)</li>\
            <li t8>At least 1 digit (0-9)</li>\
            <li t8>At least 1 symbol (e.g. ! @ # $ % ^ & *)</li>\
          </ul>\
          <p t8>Your password should <strong>not</strong> use:</p>\
          <ul>\
            <li t8>Leading or trailing spaces</li>\
            <li t8>Words from the dictionary</li>\
            <li t8>Your user ID</li>\
            <li t8>Sequential letters or numbers such as "abc" or "123"</li>\
          </ul>\
        </div>\
        <span class="trta1-align-right">\
          <a t8 id="trta1-pwd-showtyping" href="javascript:void(0)">Show typing</a>\
          <a t8 id="trta1-pwd-hidetyping" class="trta1-hide" href="javascript:void(0)">Hide typing</a>\
        </span>\
        <label><span t8>New Password</span>\
          <input type="password" t8 name="pwd" pattern="^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[^A-Za-z\\d\\s])\\S.{6,}\\S$" required maxlength="50" title="Password must be a minimum of 8 characters and contain at least one uppercase letter, one lowercase letter, one digit, and one symbol, with no leading or trailing spaces.">\
        </label>\
        <label><span t8>Confirm New Password</span>\
          <input type="password" name="pwd2" required maxlength="50">\
        </label>\
        <div class="trta1-btn-group">\
          <button t8 class="trta1-btn-primary">Reset My Password</button>\
        </div>\
        <div class="trta1-btn-group trta1-btn-group-pwdexpired trta1-btn-group-pwdexpiring trta1-hide">\
          <div><button t8 data-trta1-dest="trta1-$back" type="button">Back</button></div>\
          <div><button t8 class="trta1-btn-primary">Change My Password</button></div>\
        </div>\
      </form>\
      <form name="trta1-pwdreset-complete">\
        <div class="trta1-form-instructions">\
          <p t8>You&apos;ve successfully changed your password.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8 data-trta1-dest="trta1-signin" class="trta1-btn-primary">Go To Sign In</button>\
        </div>\
        <div class="trta1-btn-group trta1-btn-group-authcomplete trta1-hide">\
          <button t8 id="trta1-pwdresetcompleteokbtn" class="trta1-btn-primary">OK</button>\
        </div>\
      </form>\
      <form name="trta1-pwdreset-netfirm">\
        <div class="trta1-form-instructions">\
          <p t8>Your password needs to be updated. Please <a target="_blank" rel="noopener" href="<%= netfirmWebHost %>">log in</a> and change your password.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8 data-trta1-dest="trta1-signin" class="trta1-btn-primary">Back To Sign In</button>\
        </div>\
        <div class="trta1-btn-group trta1-btn-group-authcomplete trta1-hide">\
          <button t8 id="trta1-pwdresetnetfirmokbtn" class="trta1-btn-primary">OK</button>\
        </div>\
      </form>\
      <form name="trta1-requnlock" method="put" action="<%= authSvcHost %>/api/auth/v1/login/unblock" tr-autosubmit tr-goto-onsuccess="trta1-requnlock-complete" novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Unlocking your account.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8 data-trta1-dest="trta1-signin" class="trta1-btn-primary">Go To Sign In</button>\
        </div>\
      </form>\
      <form name="trta1-requnlock-complete">\
        <div class="trta1-btn-group">\
          <button t8 data-trta1-dest="trta1-signin" class="trta1-btn-primary">Go To Sign In</button>\
        </div>\
      </form>\
       <form name="trta1-pwdexpiring">\
        <h3 t8>Your password will expire soon</h3>\
        <div class="trta1-form-instructions">\
          <p t8 id="trta1-pwdexpirestwoormoredays-txt">Your password will expire in <em id="trta1-pwdexpdays">2</em> days.</p>\
          <p t8 id="trta1-pwdexpiresoneday-txt" class="trta1-hide">Your password will expire in <em>1</em> day.</p>\
          <p t8 id="trta1-pwdexpireszerodays-txt" class="trta1-hide">Your password will expire <em>today</em>.</p>\
          <p t8>Do you want to change it now?</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 id="trta1-chgpwdnowbtn">Change my password</button></div>\
          <div><button t8 class="trta1-btn-primary" id="trta1-chgpwdlaterbtn">Do it later</button></div>\
        </div>\
      </form>\
      <form name="trta1-sessionending">\
        <h3 t8>Your session is ending soon</h3>\
        <div class="trta1-form-instructions">\
          <p t8>Your session will end in:</p>\
          <p id="trta1-signout-countdown">2:00</p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8 class="trta1-btn-primary">Reset</button>\
        </div>\
      </form>\
      <form name="trta1-mfsrequired">\
        <h3 t8>Multi-factor authentication required</h3>\
        <div class="trta1-form-instructions">\
          <p t8>The firm requires you to enable multi-factor authentication before signing in. Please complete the multi-factor authentication setup wizard to continue.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-$back" type="button">Back</button></div>\
          <div><button t8 class="trta1-btn-primary trta1-mfs-go">Set Up Now</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfa-choosedevice" method="get" action="<%= authSvcHost %>/api/mfa/v1/factors" tr-autosubmit novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Finding your paired device.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="<%= cancelDestForm %>" type="button">Cancel</button></div>\
          <div><button t8 data-trta1-dest="trta1-$retry">Retry</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfa-notifydevice" method="post" action="<%= authSvcHost %>/api/mfa/v1/requests" tr-autosubmit novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Notifying your paired device.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="<%= cancelDestForm %>" type="button">Cancel</button></div>\
          <div><button t8 data-trta1-dest="trta1-$retry">Retry</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfa-awaitapproval" method="get" action="<%= authSvcHost %>/api/mfa/v1/requests/_id_" class="trta1-nodisable" novalidate>\
        <h3 t8>Check your device!</h3>\
        <div class="trta1-form-instructions">\
          <p t8>Approve your request<br> in the Thomson Reuters Authenticator app</p>\
        </div>\
        <fieldset>\
          <p t8>Didn&apos;t get a notification? <a href="javascript:void(0)" data-trta1-dest="trta1-mfa-choosedevice">Resend it</a> or <a href="javascript:void(0)" data-trta1-dest="trta1-mfa-approvecode">enter a code</a>\
          </p>\
          <p t8>No phone? Contact your firm&apos;s administrator</p>\
        </fieldset>\
        <div class="trta1-btn-group">\
          <a t8 data-trta1-dest="<%= cancelDestForm %>" href="javascript:void(0)">Cancel Request</a>\
        </div>\
      </form>\
      <form name="trta1-mfa-retrievetoken" method="post" action="<%= authSvcHost %>/api/auth/v1/jwt/mfa/_id_" tr-autosubmit novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Retrieving authentication token.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="<%= cancelDestForm %>" type="button">Cancel</button></div>\
          <div><button t8 data-trta1-dest="trta1-$retry">Retry</button></div>\
        </div>\
      </form>\
      <form name="trta1-authcomplete">\
        <h3 t8 class="success-shield-bg">Success!</h3>\
        <div class="trta1-form-instructions">\
          <p t8>You\'ve been authenticated.</p>\
          <p t8 class="trta1-pleasewait">Please wait while we sign you into your account&hellip;</p>\
        </div>\
      </form>\
      <form name="trta1-mfa-unavailable">\
        <div class="trta1-form-instructions">\
          <p t8>Multifactor authentication is currently unavailable.</p>\
          <p t8 class="trta1-pleasewait">Please wait while we sign you into your account&hellip;</p>\
        </div>\
      </form>\
    ' +

    // Append templates for external es modules
    trAuth.submodules.approveCode.template +

      '<div class="trta1-debug"></div>\
    </section>\
  ';
  /* jshint multistr: false */

  function prepDataForMfaForms(opts, uid, jwt) {
    // set uid for device notify name
    var notifyPayload = trAuth.seekObjPath('formOverrides.trta1-mfa-notifydevice.payload', opts, true);
    notifyPayload.name = uid;

    if (jwt) {
      [
        'formOverrides.trta1-mfa-choosedevice.headers',
        'formOverrides.trta1-mfa-notifydevice.headers',
        'formOverrides.trta1-mfa-awaitapproval.headers',
        'formOverrides.trta1-mfa-retrievetoken.headers'
      ].forEach(function(overridePath) {
        trAuth.seekObjPath(overridePath, opts, true).authorization = 'Bearer ' + jwt;
      });
    }
  }

  function prepareAuthSuccessData(evt, opts) {
    var token, uds, data = null;

    if (!opts.offline) {
      token = evt.detail.data && evt.detail.data.tokenValue;
      uds = evt.detail.data && evt.detail.data.uds;
      if (token) {
        data = { data: {
          token: token,
          decodedToken: window.jwt_decode(token),
          uds: uds
        }};
      }
    }
    return data;
  }

  function init(options) {
    var rootElem, signinForm, pwdResetForm, pwdExpiringForm, resetPwds, signinUidInput, signinPwdInput,
      signinMsgs, captchaContainer, captchaRequired = false,
      reqPwdResetForm;

    options = options || { locale: 'en-US' };

    var $t = trAuth.getTranslateFn(options.locale);
    var defaultOptions = {
      type: 'trid',
      // Invisible reCAPTCHA site key
      captchaSiteKey: '6Ld74C0UAAAAAB9LpmSfVnvKYuHjWwqIlDLVAAJ2',
      captchaTheme: 'light',
      captchaSize: 'invisible',
      useCaptcha: true,
      templateData: {
        cswebHost: 'https://cs.thomsonreuters.com',
        onvioHelpDomain: 'https://onvio.us',
        authSvcHost: 'https://onvio.us',
        netfirmWebHost: 'https://secure.netlinksolution.com',
        cancelDestForm: 'trta1-$start'
      },
      flow: { type: 'auth', data: {} },
      formStateMessages: {
        'error': {
          /* Custom service reason keys */
          // https://git.sami.int.thomsonreuters.com/bluemoon/authentication-aggregator/blob/develop/authentication-aggregator-lib/src/main/java/com/tr/bluemoon/auth/LoginErrorCode.java
          'INVALID_CREDENTIALS': $t('Incorrect Email Address or Password. Please try again.'),
          'ACCOUNT_LOCKED_OUT': $t('Too many sign in attempts. Please check for unlock email or try later.'),
          'PASSWORD_EXPIRED': $t('Please change your password.'),
          // 'INVALID_CAPTCHA': '',
          'MISSING_PARAMETER': $t('Please complete the required fields.'),
          // 'USER_NOT_FOUND': '',
          'USER_INACTIVE': $t('Your account has been deactivated. Please contact your administrator.'),
          'EMAIL_SEND_ERROR': $t('There was an error sending the email. Please try again.'),
          // 'INVALID_TOKEN': '',
          'PASSWORD_ALREADY_USED': $t('Please choose a password you have not already used.'),
          // these should default to unknown error as something went wrong if you see them
          // 'MFA_SETUP_REQUIRED': '',
          // 'MFA_AUTHENTICATION_REQUIRED': '',
          'INVALID_PASSWORD_FORMAT': $t('Please change your password.'),
          // Firm is locked out.
          'FIRM_CREDIT_HOLD': $t('Your account is locked. Please contact your administrator.'),
          // Firm is locked out.
          'FIRM_LOCKED_OUT': $t('Your account is locked. Please contact your administrator.'),

          /* Custom client-side keys */
          'ourIssueTryAgain': $t('Sorry, there was an issue on our end. Please try again.'),
          'unlockAcct': $t('Your account has been unlocked.'),
          'inactivitySignout': $t('You\'ve been signed out due to inactivity. Sign in to resume.'),
          'forcedSignout': $t('You\'ve exceeded maximum usage time. Please sign in again.'),
          'invalidCredentialsNetfirm': $t('Incorrect Login or Password. Please try again.')
        }
      },
      formOverrides: {
        'trta1-signin': {
          statusMap: {
            '404': 500
          },
          formStateMessages: {
            'error': {
              'MISSING_PARAMETER_FIRM_ID': $t('Missing firmId parameter.'),
            }
          }
        },
        'trta1-pwdreset': {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
          formStateMessages: {
            'error': {
              'MISSING_PARAMETER': $t('Missing data required to reset password. Please try again.'),
              'PASSWORD_VIOLATES_RULES': $t('Please provide a valid password.'),
              'PASSWORD_CONTAINS_PROHIBITED_CHARS': $t('Password contains prohibited characters'),
              'PASSWORD_TOO_COMMON': $t('Password is too similar to a common or blacklisted password.'),
            }
          }
        },
        'trta1-requnlock': {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
          formStateMessages: {
            'error': {
              'MISSING_PARAMETER': $t('Missing data required to unlock account. Please try again.'),
            }
          }
        },
        'trta1-mfa-awaitapproval': {
          formStateMessages: {
            // only display form state msgs for error
            'processing': null,
            'success': null,
            'error': { 'timeout': $t('Timed out waiting for device approval. Resend notification or enter code.') }
          }
        },
        'trta1-mfa-approvecode': {
          formStateMessages: {
            'error': {
              'unauthorized': $t('Invalid code. Please try again.'),
              '401': $t('Invalid code. Please try again.')
            }
          }
        }
      }
    };

    options = trAuth.objAssignDeep({}, trAuth.getDefaultOptions(options.locale), defaultOptions, options);

    // setup flow data
    switch (options.flow.type) {
      case 'auth-elevated':
        if (!options.flow.data.jwt) break;
        options.startingForm = 'trta1-mfa-choosedevice';
        prepDataForMfaForms(options, options.flow.data.uid, options.flow.data.jwt);
        break;
      case 'auth-2nd-factor':
        if (!options.flow.data.jwt) break;
        options.startingForm = 'trta1-mfa-choosedevice';
        prepDataForMfaForms(options, options.flow.data.uid, options.flow.data.jwt);
        options.templateData.cancelDestForm = 'trta1-$close';
        break;
    }

    // if init of trid fails, exit
    if (!trAuth.init(options)) return;
    // add in computed template data, e.g. onvioHelpLangCode
    var templateData = trAuth.objAssignDeep({}, options.templateData, { onvioHelpLangCode: options.locale.toLowerCase().split('-').reverse().join('-'),  dtHelpLocale: options.locale.toLowerCase().split('-').reverse().join('_') });

    rootElem = trAuth.renderTemplate(trAuth.template(moduleTemplate, options), templateData, null, null, options.locale);

    // cached selectors
    signinForm = rootElem.querySelector('form[name=trta1-signin]');
    signinUidInput = signinForm.elements.uid;
    signinPwdInput = signinForm.elements.pwd;
    reqPwdResetForm = rootElem.querySelector('form[name="trta1-reqpwdreset"]');
    pwdResetForm = rootElem.querySelector('form[name="trta1-pwdreset"]');
    pwdExpiringForm = rootElem.querySelector('form[name="trta1-pwdexpiring"]');
    resetPwds = pwdResetForm.querySelectorAll('[name=pwd], [name=pwd2]');
    captchaContainer = signinForm.querySelector('.trta1-captcha-container');

    // initialize submodules
    trAuth.submodules.approveCode.init(rootElem, options, trAuth);

    // dynamic options
    if (options.type === 'netfirm') {
      // create if it doesn't exist
      signinMsgs = trAuth.seekObjPath('formOverrides.trta1-signin.formStateMessages.error', options, true);
      signinMsgs.INVALID_CREDENTIALS = defaultOptions.formStateMessages.error.invalidCredentialsNetfirm;
    }

    function storeSigninData(uid, pwd) {
      // save off values for post mfa success retrieval, #8442
      var signinVals = trAuth.seekObjPath('formOverrides.trta1-signin.values', options, true);
      signinVals.uid = uid || signinUidInput.value;
      signinVals.pwd = pwd || signinPwdInput.value;
    }
    function clearSigninData() {
      var signinVals = trAuth.seekObjPath('formOverrides.trta1-signin.values', options, true);
      // keep uid, so user doesn't have to enter it again
      // signinVals.uid = undefined;
      signinVals.pwd = undefined;
    }

    function loadRecaptcha(callback) {
      // if not offline and captcha is to be used and captcha not previously loaded, then load
      if (!options.offline && options.useCaptcha && !captchaRequired) {
        if (callback) {
          trAuth.listen('trta1-captcha-ready', function() {
            callback();
          }, rootElem, true);
        }
        captchaRequired = true;
        trAuth.toggleFormDisable(signinForm, true);
        trAuth.loadScript(captchaApiTmpl({ gLangCode: gLangCodeMap[options.locale] || 'en' }));
      }
    }

    // events
    trAuth.listen('trta1-auth-enter', function(evt) {
      // reset captcha if token has already been submitted (users coming from password reset or canceled MFA request)
      var captchaInput = captchaContainer.querySelector('#g-recaptcha-response');
      if (captchaInput && captchaInput.value) {
        window.grecaptcha.reset();
      }
      if (options.inactivitySignout === true)
        trAuth.updateFormState(evt.target, 'error', options, 'inactivitySignout');
      if (options.forcedSignout === true)
        trAuth.updateFormState(evt.target, 'error', options, 'forcedSignout');
    }, signinForm);

    trAuth.listen('submit', function(evt) {
      var form = evt.target;
      var captchaInput = captchaContainer.querySelector('#g-recaptcha-response');
      form.classList.add('trta1-submitted');

      if (!trAuth.validateForm(form, options)) {
        trAuth.focusFirstEnabledField(form, function(field) {
          return !field.validity.valid;
        });
        return;
      }

      // captcha IS satisfied
      if (captchaRequired && captchaInput && captchaInput.value) return;

      // captcha NEEDS to be satisfied
      if (captchaRequired) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        window.grecaptcha.execute();
      }
    }, signinForm);

    trAuth.listen('trta1-auth-exit', function() {
      signinPwdInput.value = '';
    }, signinForm);

    // CXG - New entry point for NetFirm MFA nag
    trAuth.listen('trta1-auth-mfnag', function(evt) {
      var detail  = { key: evt.detail.data.tokenValue };

      // create so that it can be used down the line...
      var data = { authSuccessEvt: { detail: { data: { tokenValue : evt.detail.data.tokenValue}}}};
      options.data = data;

      // save off values for post mfa success retrieval, #8442
      storeSigninData();

      prepDataForMfaForms(options, signinUidInput.value, detail.key);
      trAuth.changeForm('trta1-mfnag', rootElem, detail);
    }, signinForm);

    trAuth.listen('trta1-auth-error', function(evt) {
      var primaryError = trAuth.getPrimaryError(evt.detail), detail;

      // trigger auth section error event
      trAuth.trigger('tr-auth-error', evt.detail);

      if (!primaryError) return;

      detail  = { type: primaryError.reason, key: primaryError.key };

      // handle primary reason
      switch (detail.type) {
        case 'MISSING_PARAMETER':
          var msgs = trAuth.getFormStateMsgs(signinForm, options), msg;
          // we owe the server a captcha
          if (detail.key === 'g-recaptcha-response') {
            // we owe a captcha and our creds are invalid; update msg and load captcha
            if (trAuth.getSecondaryError(evt.detail).reason === 'INVALID_CREDENTIALS') {
              msg = msgs.error.INVALID_CREDENTIALS;
              trAuth.updateFormMsg(signinForm, msg);
              loadRecaptcha();
            } else { // we owe a captcha and creds are valid; load captcha and auto-retry
              // msg = msgs.error.ourIssueTryAgain; // msg we used prior to retry
              trAuth.updateFormState(signinForm, 'processing', options);
              loadRecaptcha(function() {
                trAuth.trigger('submit', null, signinForm);
              });
            }
          } else if (detail.key === 'firmId') {
            msg = msgs.error.MISSING_PARAMETER_FIRM_ID;
            trAuth.updateFormMsg(signinForm, msg);
          } else { // some other param is missing; validate
            trAuth.validateForm(signinForm, options);
          }
          break;
        case 'INVALID_CREDENTIALS':
          // assume pwd is invalid for user convenience
          trAuth.focusFirstEnabledField(signinForm, function(field) {
            return field === signinPwdInput;
          });
          break;
        case 'PASSWORD_EXPIRED':
        case 'INVALID_PASSWORD_FORMAT':
        case 'PASSWORD_VIOLATES_RULES':
        case 'PASSWORD_CONTAINS_PROHIBITED_CHARS':
        case 'PASSWORD_TOO_COMMON':
          // todo: when services support pwd reset for NF users remove this
          if (/^(netfirm|netfirmrest)$/i.test(primaryError.domain)) {
            trAuth.changeForm('trta1-pwdreset-netfirm', rootElem, detail);
            break;
          }
          trAuth.changeForm('trta1-pwdreset', rootElem, detail);
          break;
        case 'MFA_SETUP_REQUIRED':
          // save off values for post mfa success retrieval, #8442
          storeSigninData();

          prepDataForMfaForms(options, signinUidInput.value);
          trAuth.changeForm('trta1-mfsrequired', rootElem, detail);
          break;
        case 'MFA_AUTHENTICATION_REQUIRED':
          // save off values for post mfa success retrieval, #8442
          storeSigninData();

          prepDataForMfaForms(options, signinUidInput.value, detail.key);
          trAuth.changeForm('trta1-mfa-choosedevice', rootElem, detail);
          break;
      }
    }, signinForm);

    trAuth.listen('trta1-mfa-choosedevice-success', function(evt) {
      trAuth.changeForm('trta1-mfa-notifydevice', rootElem, evt.detail);
    }, rootElem);

    function shouldNag() {
      var store = trAuth.store(MFA_SHOULD_NAG_KEY);
      return store && (store === 'true');
    }

    // Responsible for kicking off the process of setting up MFA
    function setupMFA(formName, authKey) {
      trAuth.listen('click', function(evt) {
        evt.preventDefault();
        var uid = trAuth.seekObjPath('formOverrides.trta1-signin.values', options).uid;

        // unload auth, trigger mfs
        trAuth.modules.auth.destroy();
        trAuth.modules.mfs.init(trAuth.objAssignDeep({}, options, {
          title: null,
          startingForm: 'trta1-mfs-intro',
          templateData: {
            uid: uid
          },
          headers: {
            authorization: 'Bearer ' + authKey
          }
        }, options.mfsOptions));

        // listen once for close
        trAuth.listen('tr-dialog-user-closed', function(evt) {
          // let destroy finish
          setTimeout(function() {
            var opts = trAuth.objAssignDeep({}, options, {
              startingForm: 'trta1-signin'
            });

            // if we are closing after a successful device pairing
            if (evt.detail.form === 'trta1-mfs-emergencycodes') {
              opts.startingForm = 'trta1-mfa-choosedevice';
              opts.templateData.cancelDestForm = 'trta1-signin';
              opts.generateCodes = true;
              prepDataForMfaForms(opts, uid, authKey);
            } else {
              clearSigninData();
            }

            trAuth.modules.auth.init(opts);
          });
        }, null, true);

      }, rootElem.querySelector('form[name=' + formName + '] .trta1-mfs-go'), true);
    }

    function getMfNagKey() {
      var key, overrides, uid;

      // retrieve the uid
      overrides = options.formOverrides['trta1-signin'];
      if (overrides.values && overrides.values.uid) {
        uid = overrides.values.uid;
        key = MFA_NAG_DISMISS_KEY + '-' + uid;
      }

      return key;
    }

    function getMfarId() {
      return trAuth.getLastFormResp('trta1-mfa-notifydevice').data.id;
    }

    trAuth.listen('trta1-mfa-approvecode-success', function() {
      secondFactorRequestSuccessful(getMfarId());
    }, rootElem);

    function secondFactorRequestSuccessful(mfarId) {
      if (options.flow.type === 'auth-2nd-factor') {
        var token = options.flow.data.jwt;
        var detail = { data: {
          mfarId: mfarId,
          token: token,
          decodedToken: window.jwt_decode(token)
        }};

        options.state.exitCode = 0; // success

        // todo: deprecate; for now keep backwards compat with 1.23.0
        detail.data.jwt = token;
        trAuth.trigger('tr-auth-2nd-factor-success', detail);
        // end

        trAuth.trigger('tr-auth-success', detail);

        trAuth.modules.auth.destroy();
      } else { // get Onvio full priv JWT
        trAuth.changeForm('trta1-mfa-retrievetoken', rootElem);
      }
    }

    // .trta1-mfs-go button click
    trAuth.listen('trta1-mfsrequired-enter', function(evt) {
      setupMFA('trta1-mfsrequired', evt.detail.key);
    }, rootElem);

    trAuth.listen('trta1-auth-success', function() {
      storeSigninData();
      // remove recaptcha so it doesn't time out
      trAuth.removeNodes(captchaContainer);
    }, signinForm);

    trAuth.listen('trta1-migrationcheck-success', function(evt) {
      var destForm = evt.detail.data.migrationStarted === true ? 'trta1-signin' : 'trta1-intro';
      trAuth.changeForm(destForm, rootElem);
    }, rootElem);

    trAuth.listen('trta1-pwdreset-enter', function(evt) {
      var type = evt.detail && evt.detail.type,
        key = evt.detail && evt.detail.key,
        auth = evt.detail && evt.detail.auth,
        payload, headers;

      if (type === 'PASSWORD_EXPIRED') {
        pwdResetForm.classList.add('trta1-pwdexpired');
      } else if (type === 'PASSWORD_EXPIRING') {
        pwdResetForm.classList.add('trta1-pwdexpiring');
      }
      if (key) {
        payload = trAuth.seekObjPath('formOverrides.trta1-pwdreset.payload', options, true);
        payload.key = key;
      }
      if (auth) {
        headers = trAuth.seekObjPath('formOverrides.trta1-pwdreset.headers', options, true);
        headers.authorization = 'Bearer ' + auth;
        headers['content-type'] = 'application/json;charset=utf-8';
      }
    }, rootElem);

    trAuth.listen('trta1-pwdreset-exit', function() {
      // clean up state from trta1-pwdreset-enter
      pwdResetForm.classList.remove('trta1-pwdexpired');
      pwdResetForm.classList.remove('trta1-pwdexpiring');
    }, pwdResetForm);

    // trAuth.listen('trta1-pwdreset-success', function() {
      // todo: figure out a better way to do auto login after pwd reset
      // var uid = options.formOverrides['trta1-pwdreset'].payload.uid;
      // if (uid) {
      //   signinUidInput.value = uid;
      //   signinPwdInput.value = pwdResetForm.elements.pwd.value;
      //   trAuth.changeForm('trta1-signin', rootElem);
      //   trAuth.trigger('submit', null, signinForm);
      // } else {
      // }
    // }, pwdResetForm);

    trAuth.listen('trta1-reqpwdreset-enter', function() {
      // sync email/login from signin
      reqPwdResetForm.elements.uid.value = signinUidInput.value;
    }, reqPwdResetForm);

    trAuth.listen('trta1-requnlock-complete-enter', function(evt) {
      trAuth.updateFormState(evt.target, 'success', options, 'unlockAcct');
    }, rootElem);

    // validation for password reset pwd pwdconfirm match
    trAuth.listen('input propertychange', function(evt) {
      if (resetPwds[1].setCustomValidity) { // feature check so IE9 won't throw
        if(resetPwds[0].value !== resetPwds[1].value) {
          resetPwds[1].setCustomValidity($t('Passwords Don\'t Match'));
        } else {
          resetPwds[1].setCustomValidity('');
        }
      }
      if (evt.target === resetPwds[0]) {
        trAuth.trigger('propertychange', null, resetPwds[1]);
      }
    }, pwdResetForm);

    // show/hide toggles for pwdReset
    trAuth.listen('click', function(evt) {
      switch(evt.target.id) {
        case 'trta1-toggle-pwd-requirements':
        case 'trta1-toggle-expired-pwd-requirements':
          pwdResetForm.querySelector('#trta1-pwd-requirements').classList.toggle('trta1-hide');
          evt.preventDefault();
          break;
        case 'trta1-pwd-showtyping':
          Array.from(resetPwds).forEach(function(field) {
            field.type = 'text';
          });
          evt.target.classList.add('trta1-hide');
          evt.target.nextElementSibling.classList.remove('trta1-hide');
          evt.preventDefault();
          break;
        case 'trta1-pwd-hidetyping':
          Array.from(resetPwds).forEach(function(field) {
            field.type = 'password';
          });
          evt.target.classList.add('trta1-hide');
          evt.target.previousElementSibling.classList.remove('trta1-hide');
          evt.preventDefault();
          break;
      }
    }, pwdResetForm);

    // factor types
    // P=TRPushApp, T=3rdPartyTOTPApp, C=emergencyAccessCode, B=24hrBackupCode
    var factorTypeValue = { P: 1, T: 2, C: 3, B: 4 };
    var unsupportedFactorValue = 10;
    trAuth.listen('trta1-mfa-notifydevice-enter', function(evt) {
      var formPayload = trAuth.seekObjPath('formOverrides.trta1-mfa-notifydevice.payload', options, true);
      // copy and sort factors
      // so that the last 'push' device registered sorts to top
      formPayload.factors = evt.detail.data.slice().sort(function (a, b) {
        var aCreateDate = new Date(a.registered),
          bCreateDate = new Date(b.registered);

        // ascending order on factor value, descending order on create time
        // accommodate not-yet-supported factors
        return (factorTypeValue[a.type] || unsupportedFactorValue) - (factorTypeValue[b.type] || unsupportedFactorValue) ||
          bCreateDate.getTime() - aCreateDate.getTime();
      });
    }, rootElem);

    trAuth.listen('trta1-mfa-notifydevice-success', function(evt) {
      var formPayload = trAuth.seekObjPath('formOverrides.trta1-mfa-notifydevice.payload', options, true);
      var pushFactors = formPayload.factors.filter(function(factor) {
        return factor.type === 'P';
      });

      // Only occurs when killswitch is on. If so, trigger success
      if (evt.detail.data && evt.detail.data.status === 'SUCCEEDED'){
        options.flow.type = 'auth-2nd-factor'
        secondFactorRequestSuccessful();
        return;
      }

      trAuth.changeForm('trta1-mfa-' + (pushFactors.length ? 'awaitapproval': 'approvecode'), rootElem, evt.detail);
    }, rootElem);

    var cancelAwaitApprovalPoll;
    trAuth.listen('trta1-mfa-awaitapproval-enter', function(evt) {
      var form = evt.target;
      var mfarId = getMfarId();

      form.action = form.action.replace(/\/[^/]*$/, '/' + mfarId);

      // poll for success
      cancelAwaitApprovalPoll = trAuth.pollFormRequest(
        form,
        // test fn
        function(evt) {
          return evt.detail.data.status === 'SUCCEEDED';
        },
        // success fn
        function() {
          secondFactorRequestSuccessful(mfarId);
        },
        // timeout fn
        function() {
          trAuth.updateFormState(form, 'error', options, 'timeout');
        }
        // roll with defaults for rest of params
        // errorFn = null, delay = 2, timeout = 40, leadingEdge = false, continueOnError = false
      );

    }, rootElem);

    trAuth.listen('trta1-mfa-awaitapproval-exit', function() {
      if (cancelAwaitApprovalPoll) {
        cancelAwaitApprovalPoll();
        cancelAwaitApprovalPoll = null;
      }
    }, rootElem);

    trAuth.listen('trta1-mfa-retrievetoken-enter', function(evt) {
      var form = evt.target;
      form.action = form.action.replace(/\/[^/]*$/, '/' + getMfarId());
    }, rootElem);

    function getStartOfDaySysTime(sysTime) {
      return (new Date((new Date(sysTime || +new Date())).toDateString())).getTime();
    }

    /**
      Listener that will be called after successful login and/or multi-factor authentiation
      cxg
    **/
    trAuth.listen('trta1-auth-success trta1-mfa-retrievetoken-success', function(evt) {
      var exp = evt.detail.data.passwordExpiration,
        doMultiFactorNag = false,
        nextForm = 'trta1-authcomplete',
        daysTillExp,
        dismissDay,
        mfnagStoredDate,
        mfnagDismissDate,
        daysTillNag;

      // if authentication is successful (without mfa), need to check if we need to nag the user about setting up mfa
      if(!options.disableMfaNag && evt.type === 'trta1-auth-success') {
        var mfNagKey = getMfNagKey();
        // retrieve the stored dismiss date and compare it to today
        if(mfNagKey) {
          mfnagStoredDate = trAuth.store(mfNagKey);
        } else {
          mfnagStoredDate = trAuth.store(MFA_NAG_DISMISS_KEY);
        }
        //mfnagStoredDate = null;

        if(mfnagStoredDate === null) {
          // since we have no date, automatically nag
          doMultiFactorNag = true;
          nextForm = 'trta1-mfnag';
        } else {
          mfnagDismissDate = new Date(mfnagStoredDate);

          // calculate the number of days from dismiss day
          daysTillNag = Math.round(Math.abs(((new Date()).getTime() - mfnagDismissDate.getTime()) / (24 * 60 * 60 * 1000)));
          if(daysTillNag > 30) {
            doMultiFactorNag = true;
            nextForm = 'trta1-mfnag';
          }
        }
      }

      // store the mfa nag incase pwd expiration is needed
      trAuth.store(MFA_SHOULD_NAG_KEY, doMultiFactorNag.toString());

      // save off the successfully authentication event
      trAuth.seekObjPath('data', options, true).authSuccessEvt = evt;
      rootElem.classList.add('trta1-authcomplete');

      // check for password expiring soon
      if (typeof exp === 'number') {
        daysTillExp = Math.max(0, Math.round((getStartOfDaySysTime(exp) - getStartOfDaySysTime()) / (24 * 60 * 60 * 1000))); // 1 day in ms
        dismissDay = trAuth.store('tr-auth-pwdexp-dismissday');

        if (
          // 5 or less days
          daysTillExp <= 5 &&
          (
            // desktop and first launch (desktop can't use localStorage)
            (options.sp === 'csdesktop' && options.payload.launchReason === 'InitialLogin') ||
            // not desktop and not dismissed today
            (options.sp !== 'csdesktop' && dismissDay !== (new Date()).toDateString())
          )
        ) {
          nextForm = 'trta1-pwdexpiring';
          evt.detail.data.daysTillPwdExp = daysTillExp;
        }
      }
      // if codes are required, generate
      if(options.generateCodes) {
        var authKey = evt.detail.data.tokenValue;
        var uid = trAuth.seekObjPath('formOverrides.trta1-signin.values', options).uid;
        trAuth.modules.auth.destroy();
        trAuth.modules.mfs.init(trAuth.objAssignDeep({}, options, {
          title: null,
          startingForm: 'trta1-mfs-emergencycodes-check',
          templateData: {
            uid: uid
          },
          headers: {
            authorization: 'Bearer ' + authKey
          }
        }, options.mfsOptions));

        // listen once for close
        trAuth.listen('tr-dialog-user-closed', function(evt) {
          // let destroy finish
          setTimeout(function() {
            var opts = trAuth.objAssignDeep({}, options, {
              startingForm: 'trta1-signin'
            });

            // if we are closing after a successful device pairing
            if (evt.detail.form === 'trta1-mfs-emergencycodes' || evt.detail.form === 'trta1-mfs-emergencycodes-check') {
              opts.startingForm = 'trta1-authcomplete';
              var data = { authSuccessEvt: { detail: { data: { tokenValue : authKey}}}};
              opts.data = data;
              opts.templateData.cancelDestForm = 'trta1-signin';

              prepDataForMfaForms(opts, uid, authKey);
            } else {
              clearSigninData();
            }

            trAuth.modules.auth.init(opts);
          });
        }, null, true);
      }

      trAuth.changeForm(nextForm, rootElem, evt.detail);

    }, rootElem);

    /**
      Listener that will be called when the password reset completion screen is displayed
    **/
    trAuth.listen('click', function() {
      var nextForm = 'trta1-authcomplete';

      // need to check for mfa nag
      if(shouldNag()) {
        nextForm = 'trta1-mfnag';
      }

      trAuth.changeForm(nextForm, rootElem);

    }, rootElem.querySelector('#trta1-pwdresetcompleteokbtn'));

    trAuth.listen('click', function() {
      var nextForm = 'trta1-authcomplete';

      // need to check for mfa nag
      if(shouldNag()) {
        nextForm = 'trta1-mfnag';
      }

      trAuth.changeForm(nextForm, rootElem);

    }, rootElem.querySelector('#trta1-pwdresetnetfirmokbtn'));

    /**
      Listener that will be called when the mfa nag screen is displayed
    **/
    trAuth.listen('trta1-mfnag-enter', function(evt) {
      // CXG - I needed the ability to setup nag for NetFirm
      if(options.type === 'netfirm') {
        setupMFA('trta1-mfnag', evt.detail.key || evt.detail.data.tokenValue);
      } else {
        var authSuccessEvt = options.data.authSuccessEvt;
        setupMFA('trta1-mfnag', authSuccessEvt.detail.data.tokenValue);
      }
    }, rootElem);

    // setup mfa...do it later
    trAuth.listen('click', function(evt) {
      var mfNagKey = getMfNagKey();
      if(mfNagKey) {
        trAuth.store(mfNagKey, (new Date()).toDateString());
      } else {
        trAuth.store(MFA_NAG_DISMISS_KEY, (new Date()).toDateString());
      }

      var nextForm = 'trta1-authcomplete';
      trAuth.changeForm(nextForm, rootElem, evt.detail);

    }, rootElem.querySelector('#trta1-mfs-later'));


    trAuth.listen('trta1-pwdexpiring-enter', function(evt) {
      var daysTillExp = evt.detail && evt.detail.data.daysTillPwdExp;
      if (typeof daysTillExp !== 'number') return;

      pwdExpiringForm.querySelector('#trta1-pwdexpdays').textContent = daysTillExp;
      pwdExpiringForm.classList[daysTillExp === 0 ? 'add' : 'remove']('trta1-pwdexpireszerodays');
      pwdExpiringForm.classList[daysTillExp === 1 ? 'add' : 'remove']('trta1-pwdexpiresoneday');
    }, rootElem);

    // pwdexpiring do it later
    trAuth.listen('click', function() {
      trAuth.store('tr-auth-pwdexp-dismissday', (new Date()).toDateString());
      var nextForm = 'trta1-authcomplete';

      // need to check for mfa nag
      if(shouldNag()) {
        nextForm = 'trta1-mfnag';
      }

      trAuth.changeForm(nextForm, rootElem);

    }, rootElem.querySelector('#trta1-chgpwdlaterbtn'));

    // pwdexpiring change now
    trAuth.listen('click', function(evt) {
      evt.preventDefault();

      // todo: when services support pwd reset for NF users remove this
      if (/^(netfirm|netfirmrest)$/i.test(options.data.authSuccessEvt.detail.data.domain)) {
        trAuth.changeForm('trta1-pwdreset-netfirm', rootElem);
      } else {
        trAuth.changeForm('trta1-pwdreset', rootElem, {
          auth: options.data.authSuccessEvt.detail.data.tokenValue,
          type: 'PASSWORD_EXPIRING'
        });
      }
    }, rootElem.querySelector('#trta1-chgpwdnowbtn'));

    trAuth.listen('trta1-authcomplete-enter', function() {
      // set values in DOM for desktop to retrieve, #8442
      var form = rootElem.querySelector('form[name=trta1-signin]'),
        overrides = options.formOverrides['trta1-signin'];
      if (overrides.values) {
        Object.keys(overrides.values).forEach(function(fieldName) {
          var value = overrides.values[fieldName];
          // jshint eqnull:true
          if (value == null) return;

          form.elements[fieldName].value = value;
        });
      }

      setTimeout(function() {
        options.state.exitCode = 0; // success
        // trigger auth section success event
        trAuth.trigger('tr-auth-success', prepareAuthSuccessData(options.data.authSuccessEvt, options));

        // delay to next execution cycle so event can bubble
        setTimeout(function() {
          // blank out uid/pwd to keep things secure
          signinUidInput.value = '';
          signinPwdInput.value = '';
        });
      }, 125); // wait 1/8 beat
    }, rootElem);

    // Cleanup
    trAuth.listen('tr-dialog-before-destroy', dialogBeforeDestroy, null);
    function dialogBeforeDestroy() {
      trAuth.modules.auth.destroy(true);
    }
    trAuth.modules.auth.destroy = function(dialogTriggered) {
      if (rootElem) {
        trAuth.unlisten('tr-dialog-before-destroy', dialogBeforeDestroy, null);
        trAuth.trigger('tr-auth-exit', { data: { exitCode: options.state.exitCode }});
        document.documentElement.classList.remove('trta1-auth-active');
        rootElem = null;
      }
      if (!dialogTriggered) trAuth.destroy();
    };

    // export for recaptcha
    window._trAuth_modules_auth_captchaReady = function() {
      var captchaRespField;

      window._trAuth_modules_auth_captchaReady.widget_id = window.grecaptcha.render(
        captchaContainer,
        {
          sitekey: options.captchaSiteKey,
          size: options.captchaSize,
          theme: options.captchaTheme,
          callback: function() {
            if (options.captchaSize === 'invisible') {
              signinForm.elements.signinBtn.click();
            } else {
              trAuth.trigger('propertychange', null, captchaRespField);
            }
          }
        }
      );

      trAuth.toggleFormDisable(signinForm, false);

      if (options.captchaSize !== 'invisible') {
        captchaRespField = captchaContainer.querySelector('#g-recaptcha-response');
        captchaRespField.required = true;
        trAuth.validateForm(signinForm, options);
      }

      trAuth.trigger('trta1-captcha-ready', null, rootElem);
    };

    // setup debug
    if (options.payload && options.payload.firmId) {
      document.querySelector('.trta1-debug').textContent = 'fid:' + options.payload.firmId;
    }

    // ready
    document.documentElement.classList.add('trta1-auth-active');
    trAuth.trigger('tr-auth-ready', options);
    trAuth.moduleReady(rootElem, options);

    return trAuth.getRootElem();
  }

  trAuth.modules.auth = {
    init: init
  };

})(window);
(function(window) {
  'use strict';

  var trAuth = window.trAuth;

  var appleStoreLangCodeMap = {
    'en-US': 'en-us',
    'en-AU': 'en-us',
    'en-CA': 'en-us',
    'en-GB': 'en-us',
    'en-IN': 'en-us',
    'es-AR': 'es-mx',
    'fr-CA': 'fr-ca',
    'nl-NL': 'nl-nl',
    'pt-BR': 'pt-br'
  };
  var googleStoreLangCodeMap = {
    'en-US': 'en',
    'en-AU': 'en',
    'en-CA': 'en',
    'en-GB': 'en',
    'en-IN': 'en',
    'es-AR': 'es-419',
    'fr-CA': 'fr-ca',
    'nl-NL': 'nl',
    'pt-BR': 'pt-br'
  };

  var otpauthTemplate = 'otpauth://totp/<%= env %>Thomson%20Reuters%20ID:<%= uid %>?secret=<%= otpSecret %>&issuer=<%= env %>Thomson%20Reuters%20ID&algorithm=SHA1&digits=6&period=30&a=<%= factorId %>&m=<%= mfarId %>&url=<%= url %>';

  /* jshint multistr: true */
  var moduleTemplate = '\
    <section id="trta1-mfs">\
      <h1 t8 class="trta1-print-only">Thomson Reuters</h1>\
      <h2 t8>Multi-Factor Authentication Setup</h2>\
      <a data-trta1-dest="trta1-$close" class="trta1-dialog-close" href="javascript:void(0)" aria-label="Close">&times;</a>\
      <form name="trta1-mfs-intro">\
        <div class="trta1-form-instructions">\
          <h4 t8>Increase security for your account</h4>\
          <p t8>Passwords can be hacked, but using multi-factor authentication adds another layer of security to your account.</p>\
          <h4 t8>How long will it take to set up?</h4>\
          <p t8>A few minutes.</p>\
          <h4 t8>How will this affect me?</h4>\
          <p t8>You will need to approve each sign-in request on your device each time you sign in with this account.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-$close" type="button">Cancel</button></div>\
          <div><button t8 data-trta1-dest="trta1-mfs-choosetype" class="trta1-btn-primary">Get Started</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfs-install">\
        <h3 t8>Download and install Thomson Reuters Authenticator app</h3>\
        <div class="trta1-form-instructions">\
          <p t8>On your mobile device, open the app store and download and install the <b>Thomson Reuters Authenticator</b> app.</p>\
          <p>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-trid-only trta1-type-onvio-only" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/staff/core/common/thomson-reuters-authenticator-installation-and-permissions.htm">Tell me how</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirm-only trta1-type-csweb-only" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/thomson-reuters-authenticator-installation-and-permissions.htm">Tell me how</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirmdt-only" href="https://cs.thomsonreuters.com/ua/netfirm/nc_drtax_<%= dtHelpLocale %>/common/thomson-reuters-authenticator-installation-and-permissions.htm">Tell me how</a>\
          </p>\
          <ul class="shield-bg">\
            <li><a target="_blank" rel="noopener" class="trta1-appleStore-link" href="https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&l=<%= appleStoreLangCode %>" style="display:inline-block;overflow:hidden;background:url(//linkmaker.itunes.apple.com/assets/shared/badges/<%= appleStoreLangCode %>/appstore-lrg.svg) no-repeat;width:135px;height:40px;background-size:contain;"></a></li>\
            <li><a target="_blank" rel="noopener" class="trta1-googleStore-link" href="https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&hl=<%= googleStoreLangCode %>"><img src="https://play.google.com/intl/en_us/badges/images/generic/<%= googleStoreLangCode %>_badge_web_generic.png"></a></li>\
            <!--li><a t8 id="trta1-authapp-email-link" href="javascript:void(0)">Email me a link</a></li-->\
          </ul>\
          <p t8>After installing and opening the app, click Next.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-mfs-choosetype" type="button">Back</button></div>\
          <div><button t8 data-trta1-dest="trta1-mfs-gencode" class="trta1-btn-primary">Next</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfs-3p-install">\
        <h3 t8>Download and install an alternate multi-factor app</h3>\
        <div class="trta1-form-instructions">\
          <p>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-trid-only trta1-type-onvio-only" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/staff/core/common/learning-about-third-party-multi-factor-apps.htm">Learn more about third-party MFA apps</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirm-only trta1-type-csweb-only" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/learning-about-third-party-multi-factor-apps.htm">Learn more about third-party MFA apps</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirmdt-only" href="https://cs.thomsonreuters.com/ua/netfirm/nc_drtax_<%= dtHelpLocale %>/common/learning-about-third-party-multi-factor-apps.htm">Learn more about third-party MFA apps</a>\
          </p>\
          <p t8>The alternate method must be time-based one time password (TOTP) compliant. Download now at the <a target="_blank" rel="noopener" href="https://itunes.apple.com/<%= appleStoreCountryCode %>/app/thomson-reuters-authenticator/id1155604687?mt=8&l=<%= appleStoreLangCode %>">Apple App Store</a> or the <a target="_blank" rel="noopener" href="https://play.google.com/store/apps/details?id=com.thomsonreuters.trta.authenticator&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&hl=<%= googleStoreLangCode %>">Google Play Store</a>.</p>\
          <p t8 class="thirdparty-app-bg">After installing and opening the app, click Next.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-mfs-choosetype" type="button">Back</button></div>\
          <div><button t8 data-trta1-dest="trta1-mfs-gencode" class="trta1-btn-primary">Next</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfs-gencode" method="post" action="<%= authSvcHost %>/api/mfa/v1/factors" novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Generating QR code.</p>\
        </div>\
        <input type="hidden" name="type" value="T">\
        <input type="hidden" name="address" value="TOTP">\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="trta1-mfs-choosetype" type="button">Back</button></div>\
          <div><button t8 data-trta1-dest="trta1-$retry">Retry</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfs-devicelookup" method="get" action="<%= authSvcHost %>/api/mfa/v1/factors/_id_" tr-autosubmit tr-goto-onsuccess="trta1-mfs-paired" novalidate>\
        <div class="trta1-form-instructions">\
          <p t8>Retrieving device info.</p>\
        </div>\
        <div class="trta1-btn-group">\
          <div><button t8 data-trta1-dest="<%= cancelDestForm %>" type="button">Cancel</button></div>\
          <div><button t8 data-trta1-dest="trta1-$retry">Retry</button></div>\
        </div>\
      </form>\
      <form name="trta1-mfs-emergencycodes-check" method="get" action="<%= authSvcHost %>/api/mfa/v1/factors" tr-autosubmit novalidate>\
      </form>\
      <form name="trta1-mfs-paired" method="put" action="<%= authSvcHost %>/api/mfa/v1/factors/_id_" novalidate>\
        <div class="trta1-form-instructions">\
          <h3 t8 class="success-shield-bg">Pairing Successful!</h3>\
          <p t8>You have set up multi-factor authentication for your account. You will need to approve each sign-in request on your device each time you sign in with this account.</p>\
          <!--p t8>You have paired your account with <b id="trta1-mfs-devicename">this device</b>.</p>\
          <h4 t8>What can I expect?</h4>\
          <p t8>You will need to approve each sign-in request on your device each time you sign in with this account. To add or remove a paired device, go to your account settings.</p>\
          <h4 t8>What\'s left to do?</h4>\
          <p t8>Name your device. Confirm the pairing. Generate emergency access codes.</p>\
          <h4 t8>Need help?</h4>\
          <p><a t8 target="_blank" rel="noopener" href="">Learn more about the new security system.</a></p-->\
          <label><span t8>Name this multi-factor option</span>\
            <input type="text" name="device-name" required pattern=".*\\S+.*" maxlength="250" tr-nosend>\
          </label>\
          <p>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-trid-only trta1-type-onvio-only" href="<%= onvioHelpDomain %>/ua/help/<%= onvioHelpLangCode %>/staff/core/common/understanding-next-steps-after-multi-factor-authentication-setup.htm">Next steps after setting up MFA</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirm-only trta1-type-csweb-only" href="https://cs.thomsonreuters.com/ua/login_security/cs_us_en/understanding-next-steps-after-multi-factor-authentication-setup.htm">Next steps after setting up MFA</a>\
            <a t8 target="_blank" rel="noopener" class="trta1-type-netfirmdt-only" href="https://cs.thomsonreuters.com/ua/netfirm/nc_drtax_<%= dtHelpLocale %>/common/understanding-next-steps-after-multi-factor-authentication-setup.htm">Next steps after setting up MFA</a>\
          </p>\
        </div>\
        <div class="trta1-btn-group">\
          <button t8>Finish</button>\
        </div>\
      </form>\
    ' +

    // Append templates for external es modules
    trAuth.submodules.chooseType.template +
    trAuth.submodules.scanCode.template +
    trAuth.submodules.registerDevice.template +
    trAuth.submodules.emergencyCodes.template +
    trAuth.submodules.pairDevice.template +

    '</section>\
  ';
  /* jshint multistr: false */

  function init(options) {
    var rootElem, qrCodeContainer, deviceNameInput;

    options = options || { locale: 'en-US' };

    var $t = trAuth.getTranslateFn(options.locale);
    var defaultOptions = {
      type: 'trid',
      enableMFACards: true,
      enableThirdPartyApp: true,
      templateData: {
        authSvcHost: 'https://onvio.us',
        onvioHelpDomain: 'https://onvio.us',
        cancelDestForm: 'trta1-$start'
      },
      formOverrides: {
        'trta1-mfs-gencode': {
          payload: {
            name: 'device'
          }
        },
        'trta1-mfs-scancode': {
          formStateMessages: {
            // only display form state msgs for error
            'processing': null,
            'success': null,
            'error': {
              'timeout': $t('Timed out waiting for scan. Please go back and try again.'),
              'unauthorized': $t('Invalid code. Please try again.'),
              '401': $t('Invalid code. Please try again.')
            }
          }
        },
        'trta1-mfs-pairdevice': {
          formStateMessages: {
            'error': {
              'bad request': $t('Incorrect Device ID or Code. Please try again.'),
              '400': $t('Incorrect Device ID or Code. Please try again.'),
              'unauthorized': $t('Incorrect Device ID or Code. Please try again.'),
              '401': $t('Incorrect Device ID or Code. Please try again.')
            }
          }
        }
      }
    };

    options = trAuth.objAssignDeep({}, trAuth.getDefaultOptions(options.locale), defaultOptions, options);

    // if init of trid fails, exit
    if (!trAuth.init(options)) return;

    var tmplData = trAuth.objAssignDeep({}, options.templateData, {
      onvioHelpLangCode: options.locale.toLowerCase().split('-').reverse().join('-'),
      dtHelpLocale: options.locale.toLowerCase().split('-').reverse().join('_'),
      appleStoreCountryCode: options.locale.split('-')[1].toLowerCase(),
      appleStoreLangCode: appleStoreLangCodeMap[options.locale],
      googleStoreLangCode: googleStoreLangCodeMap[options.locale]
    });

    rootElem = trAuth.renderTemplate(trAuth.template(moduleTemplate, options), tmplData, null, null, options.locale);

    qrCodeContainer = rootElem.querySelector('.trta1-mfs-qrcode');
    deviceNameInput = rootElem.querySelector('form[name=trta1-mfs-paired] input[name=device-name]');

    // initialize submodules
    trAuth.submodules.chooseType.init(rootElem, options, trAuth);
    trAuth.submodules.scanCode.init(rootElem, options, trAuth);
    trAuth.submodules.registerDevice.init(rootElem, options, trAuth);
    trAuth.submodules.emergencyCodes.init(rootElem, options, trAuth);
    trAuth.submodules.pairDevice.init(rootElem, options, trAuth);

    trAuth.listen('trta1-mfs-gencode-enter', function(evt) {
      // if we've already got a code, continue
      if (options.state.qrCode) {
        trAuth.changeForm('trta1-mfs-scancode', rootElem);
        return;
      }

      trAuth.trigger('submit', null, evt.target);
    }, rootElem);

    trAuth.listen('trta1-mfs-gencode-success', function(evt) {
      var tmpl = otpauthTemplate,
        svcUrl = options.templateData.authSvcHost,
        qrTmplDataOverrides = { uid: encodeURIComponent(options.templateData.uid) },
        // note: not an ideal way to get ENV
        env = svcUrl.replace(/^https?:\/\/([^/]+).*$/, function(url, host) {
          env = host.split('.')[0];
          if (/^(ci|demo|qed)$/.test(env)) return env.toUpperCase() + '%20';
          if (/^(localhost(:\d+)?|\d+)$/.test(env)) return 'LOCAL';
          return ''; // leave PROD blank
        }),
        qrText;

      // use state bag for factorData, so subsequent steps will have what they need
      options.state.factorData = evt.detail.data;

      // add proper override data to qrText based on env
      if (env === 'LOCAL') {
        // default svc url to demo
        qrTmplDataOverrides.url = encodeURIComponent('https://demo.onvio.us');
        qrTmplDataOverrides.env = 'DEMO%20';
      } else { // otherwise
        qrTmplDataOverrides.url = encodeURIComponent(svcUrl);
        qrTmplDataOverrides.env = env;
      }

      qrText = trAuth.template(tmpl, options)(trAuth.objAssignDeep({}, evt.detail.data, qrTmplDataOverrides));
      // Clean up since QRCode lib won't if it created nodes previously
      while (qrCodeContainer.firstChild) {
        qrCodeContainer.removeChild(qrCodeContainer.firstChild);
      }
      options.state.qrCode = new window.QRCode(qrCodeContainer, {
          text: qrText,
          width: 207,
          height: 207,
          colorDark : "#000000",
          colorLight : "#ffffff",
          correctLevel : window.QRCode.CorrectLevel.L
      });

      // remove tooltip that qrCode puts in
      qrCodeContainer.removeAttribute('title');
      trAuth.changeForm('trta1-mfs-scancode', rootElem, evt.detail);
    }, rootElem);

    trAuth.listen('trta1-mfs-devicelookup-enter', function(evt) {
      var form = evt.target;
      form.action = form.action.replace(/\/[^/]*$/, '/' + options.state.factorData.factorId);
    }, rootElem);

    trAuth.listen('trta1-mfs-paired-enter', function(evt) {
      var form = evt.target;
      form.action = form.action.replace(/\/[^/]*$/, '/' + trAuth.getLastFormResp('trta1-mfs-devicelookup').data.id);
      var deviceName = evt.detail.data && evt.detail.data.name || options.state.$t('Thomson Reuters Authenticator Card');
      if (deviceName) {
        // plug device name into paragraph
        // rootElem.querySelector('#trta1-mfs-devicename').textContent = deviceName;
        deviceNameInput.value = deviceName;
      }
    }, rootElem);

    trAuth.listen('submit', function() {
      var factor = trAuth.getLastFormResp('trta1-mfs-devicelookup').data;
      factor.name = deviceNameInput.value;
      trAuth.seekObjPath('formOverrides.trta1-mfs-paired', options, true).payload = factor;
    }, rootElem.querySelector('form[name=trta1-mfs-paired]'));

    trAuth.listen('trta1-mfs-paired-success', function(evt) {
      trAuth.changeForm('trta1-mfs-emergencycodes-check', rootElem, evt.detail);
    }, rootElem);

    trAuth.listen('trta1-mfs-emergencycodes-check-success', function(evt){
      var hasCodes = false;
      var hasCodes = evt.detail.data && evt.detail.data.filter(function(factor){
        return factor.type === 'C';
      }).length > 0;
      if(!hasCodes) {
        trAuth.changeForm('trta1-mfs-emergencycodes', rootElem, evt.detail);
      } else {
        // go to success
        options.state.exitCode = 0; // success
        trAuth.trigger('tr-mfs-success');
        // pause for 1/2 beat before closing dialog so user can see success
        setTimeout(trAuth.changeForm, 500, 'trta1-$close');
      }
    }, rootElem);

    // Cleanup
    trAuth.listen('tr-dialog-before-destroy', dialogBeforeDestroy, null);
    function dialogBeforeDestroy() {
      trAuth.modules.mfs.destroy(true);
    }
    trAuth.modules.mfs.destroy = function(dialogTriggered) {
      if (rootElem) {
        trAuth.unlisten('tr-dialog-before-destroy', dialogBeforeDestroy, null);
        trAuth.trigger('tr-mfs-exit', { data: { exitCode: options.state.exitCode }});
        document.documentElement.classList.remove('trta1-mfs-active');
        rootElem = null;
      }
      if (!dialogTriggered) trAuth.destroy();
    };

    document.documentElement.classList.add('trta1-mfs-active');
    trAuth.trigger('tr-mfs-ready');
    trAuth.moduleReady(rootElem, options);
    return trAuth.getRootElem();
  }

  trAuth.modules.mfs = {
    init: init
  };

})(window);

/*! matchMedia() polyfill - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas, David Knight. MIT license */

window.matchMedia || (window.matchMedia = function() {
    "use strict";

    // For browsers that support matchMedium api such as IE 9 and webkit
    var styleMedia = (window.styleMedia || window.media);

    // For those that don't support matchMedium
    if (!styleMedia) {
        var style       = document.createElement('style'),
            script      = document.getElementsByTagName('script')[0],
            info        = null;

        style.type  = 'text/css';
        style.id    = 'matchmediajs-test';

        if (!script) {
          document.head.appendChild(style);
        } else {
          script.parentNode.insertBefore(style, script);
        }

        // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
        info = ('getComputedStyle' in window) && window.getComputedStyle(style, null) || style.currentStyle;

        styleMedia = {
            matchMedium: function(media) {
                var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';

                // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
                if (style.styleSheet) {
                    style.styleSheet.cssText = text;
                } else {
                    style.textContent = text;
                }

                // Test if media query is true or false
                return info.width === '1px';
            }
        };
    }

    return function(media) {
        return {
            matches: styleMedia.matchMedium(media || 'all'),
            media: media || 'all'
        };
    };
}());

/*! matchMedia() polyfill addListener/removeListener extension. Author & copyright (c) 2012: Scott Jehl. MIT license */
(function(){
    // Bail out for browsers that have addListener support
    if (window.matchMedia && window.matchMedia('all').addListener) {
        return false;
    }

    var localMatchMedia = window.matchMedia,
        hasMediaQueries = localMatchMedia('only all').matches,
        isListening     = false,
        timeoutID       = 0,    // setTimeout for debouncing 'handleChange'
        queries         = [],   // Contains each 'mql' and associated 'listeners' if 'addListener' is used
        handleChange    = function(evt) {
            // Debounce
            clearTimeout(timeoutID);

            timeoutID = setTimeout(function() {
                for (var i = 0, il = queries.length; i < il; i++) {
                    var mql         = queries[i].mql,
                        listeners   = queries[i].listeners || [],
                        matches     = localMatchMedia(mql.media).matches;

                    // Update mql.matches value and call listeners
                    // Fire listeners only if transitioning to or from matched state
                    if (matches !== mql.matches) {
                        mql.matches = matches;

                        for (var j = 0, jl = listeners.length; j < jl; j++) {
                            listeners[j].call(window, mql);
                        }
                    }
                }
            }, 30);
        };

    window.matchMedia = function(media) {
        var mql         = localMatchMedia(media),
            listeners   = [],
            index       = 0;

        mql.addListener = function(listener) {
            // Changes would not occur to css media type so return now (Affects IE <= 8)
            if (!hasMediaQueries) {
                return;
            }

            // Set up 'resize' listener for browsers that support CSS3 media queries (Not for IE <= 8)
            // There should only ever be 1 resize listener running for performance
            if (!isListening) {
                isListening = true;
                window.addEventListener('resize', handleChange, true);
            }

            // Push object only if it has not been pushed already
            if (index === 0) {
                index = queries.push({
                    mql         : mql,
                    listeners   : listeners
                });
            }

            listeners.push(listener);
        };

        mql.removeListener = function(listener) {
            for (var i = 0, il = listeners.length; i < il; i++){
                if (listeners[i] === listener){
                    listeners.splice(i, 1);
                }
            }
        };

        return mql;
    };
}());

/*
 * matchmedia-ng (c) 2014 Jason Kulatunga, Inc. | http://analogj.mit-license.org/
 */
(function(window, angular, undefined) {
'use strict';

angular.module("matchmedia-ng", []).
    provider('matchmedia', function (){

        ///////////////////////////////////////////////////////////////////////
        // Configuration
        ///////////////////////////////////////////////////////////////////////
        /**
         *
         * these settings can be changed by injecting matchmediaProvider into
         * the config function of your module and
         * changing the matchmediaProvider.rules with your own rule key value
         * pairs E.G.

         *  angular.module('app').config(['matchmediaProvider', function (matchmediaProvider) {
         *      matchmediaProvider.rules.phone = "(max-width: 500px)";
         *      matchmediaProvider.rules.desktop: = "(max-width: 1500px)";
         *  }]);
         *
         * default values taken from twitter bootstrap :
         * https://github.com/twitter/bootstrap/blob/master/less/responsive-utilities.less
         */
        var matchmedia = {
            rules: {
                print : "print",
                screen : "screen",
                phone : "(max-width: 767px)",
                tablet : "(min-width: 768px) and (max-width: 979px)",
                desktop : "(min-width: 980px)",
                portrait : "(orientation: portrait)",
                landscape : "(orientation: landscape)"
            }
        };
        matchmedia.$get = ['$window','safeApply', 'logger', function($window, safeApply, logger) {

            logger.log('Creating matchmedia');

            ///////////////////////////////////////////////////////////////////////
            // Private Methods
            ///////////////////////////////////////////////////////////////////////
            function createSafeListener(cb, $scope){
                return function(mediaQueryList){
                    safeApply(function() {
                        cb(mediaQueryList);
                    },$scope);
                };
            }

            ///////////////////////////////////////////////////////////////////////
            // Public Methods
            ///////////////////////////////////////////////////////////////////////
            //should never be called directly, but is available for custom calls.
            var matchmediaService = {};

            /**
             * @param {string} query media query to listen on.
             * @param {function(mediaQueryList)} listener Function to call when the media query is matched.
             * @returns {function()} Returns a deregistration function for this listener.
             */
            matchmediaService.on = function(query, listener, $scope) {
                var supportsMatchMedia = $window.matchMedia !== undefined && !!$window.matchMedia('all').addListener;
                if(supportsMatchMedia) {
                    logger.log('adding listener for query: '+ query);
                    var mediaQueryList = $window.matchMedia(query);
                    var handler = createSafeListener(listener, $scope);
                    mediaQueryList.addListener(handler);
                    //immediately return the current mediaQueryList;
                    handler(mediaQueryList);

                    return function() {
                        logger.log('removing listener from query: '+ query);
                        mediaQueryList.removeListener(handler);

                    };
                }
            };
            /**
             * @param {string} query media query to test.
             * @returns {mediaQueryList} Returns a boolean.
             */
            matchmediaService.is = function(query) {
                logger.log('test query: '+ query);
                return $window.matchMedia(query).matches;
            };



            ///////////////////////////////////////////////////////////////////////
            // Aliased Methods
            ///////////////////////////////////////////////////////////////////////
            matchmediaService.onPrint = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.print,listener, $scope);
            };
            matchmediaService.onScreen = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.screen,listener, $scope);
            };
            matchmediaService.onPhone = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.phone,listener, $scope);
            };
            matchmediaService.onTablet = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.tablet,listener, $scope);
            };
            matchmediaService.onDesktop = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.desktop,listener, $scope);
            };
            matchmediaService.onPortrait = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.portrait,listener, $scope);
            };
            matchmediaService.onLandscape = function(listener, $scope){
                return matchmediaService.on(matchmedia.rules.landscape,listener, $scope);
            };

            matchmediaService.isPrint = function(){
                return matchmediaService.is(matchmedia.rules.print);
            };
            matchmediaService.isScreen = function(){
                return matchmediaService.is(matchmedia.rules.screen);
            };
            matchmediaService.isPhone = function(){
                return matchmediaService.is(matchmedia.rules.phone);
            };
            matchmediaService.isTablet = function(){
                return matchmediaService.is(matchmedia.rules.tablet);
            };
            matchmediaService.isDesktop = function(){
                return matchmediaService.is(matchmedia.rules.desktop);
            };
            matchmediaService.isPortrait = function(){
                return matchmediaService.is(matchmedia.rules.portrait);
            };
            matchmediaService.isLandscape = function(){
                return matchmediaService.is(matchmedia.rules.landscape);
            };
            return matchmediaService;
        }];
        return matchmedia;
    })
    .directive('ajMatchmedia', ['matchmedia', function(matchmedia) {
        return {
            restrict: 'E',
            scope: {
                'queryListener': '&',
                'queryMatches': '='
            },
            link: function(scope, element, attrs, controllers) {
                var deregister;

                if (attrs.on && attrs.queryListener) {
                    if (attrs.on.slice(0, 2) === 'on' && matchmedia[attrs.on] !== 'undefined') {
                        deregister = matchmedia[attrs.on](function(mediaQueryList) {
                            scope.queryListener({mediaQueryList: mediaQueryList});
                        });
                    } else {
                        deregister = matchmedia.on(attrs.on, function(mediaQueryList) {
                            scope.queryListener({mediaQueryList: mediaQueryList});
                        });
                    }
                    scope.$on('$destroy', deregister);
                } else if (attrs.is && attrs.queryMatches) {
                    if (attrs.is.slice(0, 2) === 'is' && matchmedia[attrs.is] !== 'undefined') {
                        scope.queryMatches = matchmedia[attrs.is]();
                    } else {
                        scope.queryMatches = matchmedia.is(attrs.is);
                    }
                }
            }
        };
    }])
    .factory('safeApply', ['$rootScope',function($rootScope) {
        return function(fn, $scope) {
            $scope = $scope || $rootScope;
            var phase = $scope.$root.$$phase;
            if(phase == '$apply' || phase == '$digest') {
                if (fn) {
                    $scope.$eval(fn);
                }
            } else {
                if (fn) {
                    $scope.$apply(fn);
                } else {
                    $scope.$apply();
                }
            }
        };
    }])
    .provider('logger', function(){
        this.DEVMODE = false;

        this.setDEVMODE = function(devmode){
            this.DEVMODE = devmode;
        };

        this.$get = ['$window', '$log', function($window, $log) {
            var DEVMODE = this.DEVMODE;
            var logger = {};
            logger.log = function(){
                if (DEVMODE) $log.info(arguments);
            };
            logger.always = function(){
                $log.info(arguments);
            };
            return logger;
        }];
    });
})(window, window.angular);

/**
 * @license
 * NavMore <https://github.com/pinkhominid/navmore>
 * A navigation list decorator that produces a responsive horizontal nav menu.
 * Written with ES5 and CSS3. No dependencies.
 *
 * Copyright pinkhominid
 * Released under MIT License <https://raw.githubusercontent.com/pinkhominid/navmore/master/LICENSE>
 *
 * Chrome/Firefox/Safari/Opera/Edge/IE11
 *
 * TODO
 * fix msie
 * support keyboard navigation
 * support varied nav item tags
 * improve animation
 * calc'ed height of droplist
 * a way to denote items outside of viewport in sub-lists (e.g. gradients)
 */

;(function(window) {
  var document = window.document;

  window.navmore = function(nav) {
    var mainList = nav.querySelector('ul');
    var moreItem = createElementFromString('<li class="hidden"><a class="navmore-moreitem" href="javascript:void(0)">More&hellip;</a><ul></ul></li>');
    var moreList = moreItem.querySelector('ul');
    var navItemTagNames = 'A, H1'; // NOTE: css currently supports A, H1
    var selected;
    var unthrottleResize;

    function init() {
      mainList.appendChild(moreItem);
      nav.classList.add('navmore');

      // Public API
      nav.navmore = {
        reset: reorgNav, // recalc/rerender nav items
        collapse: collapse, // collapse dropped menus
        getSelected: getSelected, // get selected hierarchy as array [leaf, ..., root]
        setSelected: setSelected, // set selected leaf item then update hierarchy
        setMoreItemText: setMoreItemText, // update the text for the more item
        destroy: destroy // cleanup all traces of navmore
      };

      // listeners
      unthrottleResize = throttle('resize', 'optimizedResize');
      window.addEventListener('optimizedResize', reorgNav, false);
      window.addEventListener('click', handleTap, false);

      /* bootstrap */
      reorgNav();
    }

    /* BEHAVIORS */

    function isFlex() {
      return nav.classList.contains('navmore-flex') || nav.classList.contains('navmore-flexgrow');
    }

    function isNavLeafItem(target) {
      // has href and not javascript:void(0)
      return target.href && target.href.indexOf('http') === 0;
    }

    function handleTap(e) {
      // retarget tap to account for nested elements
      var target = retargetBubbleEventByTagName(e, mainList, navItemTagNames);
      if (!target) {
        collapse();
        return;
      }

      var isLeaf = isNavLeafItem(target);

      // toggle tapped navItem focus
      if (!isLeaf && isItemFocused(target)) {
        // clear focus for tapped navItem and all descendants
        forEachDescendantsByTagName(target.parentNode, navItemTagNames, blurItem);
        return;
      }

      collapse();

      if (isLeaf) {
        setSelected(target);
      } else { // is branch
        // focus ancestor navItems
        forEachAncestorSiblingsByTagName(target, mainList, 'UL', navItemTagNames, focusItem);
        // focus tapped navItem
        focusItem(target);
      }
    }

    function getLastMainItem() {
      var lastMainItem = moreList.parentElement.previousElementSibling;
      return lastMainItem ? lastMainItem.firstElementChild : null;
    }

    function getFirstMoreItem() {
      var firstMoreItem = moreList.firstElementChild;
      return firstMoreItem ? firstMoreItem.firstElementChild : null;
    }

    function reorgNav() {
      var lastMainItem = getLastMainItem(),
        firstMoreItem = getFirstMoreItem();

      // move items from moreList to mainList
      while (firstMoreItem && (!lastMainItem || !isOverflowing(lastMainItem))) {
        mainList.insertBefore(firstMoreItem.parentElement, moreItem);

        lastMainItem = firstMoreItem;
        firstMoreItem = getFirstMoreItem();
        // update while removing from moreList in the case More item itself overflows the list
        updateMoreItemHidden();
      }
      // move items from mainList to moreList
      while (lastMainItem && isOverflowing(lastMainItem)) {
        moreList.insertBefore(lastMainItem.parentElement, moreList.firstElementChild);

        lastMainItem = getLastMainItem();
        // update while adding to moreList in the case More item itself overflows the list
        updateMoreItemHidden();
      }
      // updates
      if (moreList.childElementCount > 0 && selected) {
        // refresh selected
        setSelected(selected);
      }
    }

    function updateMoreItemHidden() {
        moreItem.classList[moreList.childElementCount === 0 ? 'add' : 'remove']('hidden');
    }

    function isOverflowing(lastMainItem) {
      if (isFlex()) {
        return getAutoClientWidth(lastMainItem) > lastMainItem.clientWidth;
      } else {
        return mainList.scrollWidth > mainList.clientWidth;
      }
    }

    function collapse() {
      // clear focus for all navItems
      forEachDescendantsByTagName(mainList, navItemTagNames, blurItem);
    }

    function setSelected(item) {
      // clear selected for all navItems
      forEachDescendantsByTagName(mainList, navItemTagNames, deselectItem);

      if (!item) {
        selected = null;
      } else if (item && hasTagName(item, navItemTagNames) && isNavLeafItem(item)) {
        // store selected
        selected = item;
        // mark navItem as selected
        selectItem(item);
        // mark ancestor navItems as selected
        forEachAncestorSiblingsByTagName(item, mainList, 'UL', navItemTagNames, selectItem);
      }

      return nav;
    }

    /* returns array of selected items ordered from leaf (bottom) to root (top) */
    function getSelected() {
      return Array.prototype.slice.call(mainList.querySelectorAll('.selected')).reverse();
    }

    function setMoreItemText(text) {
      moreItem.firstChild.textContent = text;
      reorgNav();
    }

    function destroy() {
      mainList.removeChild(moreItem);
      nav.classList.remove('navmore');

      delete nav.navmore;

      unthrottleResize();
      window.removeEventListener('optimizedResize', reorgNav, false);
      window.removeEventListener('click', handleTap, false);
    }

    /* BOOTSTRAP */
    init();

    return nav;
  };

  /* UTILS */

  // from MDN with modifications
  // https://developer.mozilla.org/en-US/docs/Web/Events/resize
  function throttle(type, name, obj) {
    obj = obj || window;
    var running = false;
    var func = function() {
      if (running) { return; }
      running = true;
      requestAnimationFrame(function() {
        triggerEvent(name, obj);
        running = false;
      });
    };
    var removeFunc = function() {
      obj.removeEventListener(type, func);
    };
    obj.addEventListener(type, func, false);
    return removeFunc;
  }

  // MDN
  function triggerEvent(name, obj) {
    var evt;
    try { evt = new CustomEvent(name); }
    catch(e) {
      evt = document.createEvent('Event');
      evt.initEvent(name, true, true);
    }
    obj.dispatchEvent(evt);
  }

  function createElementFromString(s) {
    var div = document.createElement('div');
    div.innerHTML = s;
    return div.firstChild;
  }

  function getAutoClientWidth(el) {
    var text = el.textContent.trim(),
      style = window.getComputedStyle(el),
      /* get font values separately for firefox :( */
      font = [
        style.getPropertyValue('font-weight'),
        style.getPropertyValue('font-size'),
        style.getPropertyValue('font-family')
      ],
      padLeft = parseInt(style.getPropertyValue('padding-left')),
      padRight = parseInt(style.getPropertyValue('padding-right'));

    return Math.floor(getTextWidth(text, font.join(' ')) + padLeft + padRight);
  }

  // http://stackoverflow.com/a/21015393
  function getTextWidth(text, font) {
    // re-use canvas object for better performance
    var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'));
    var context = canvas.getContext('2d');
    context.font = font;
    var metrics = context.measureText(text);
    return metrics.width;
  }

  function hasTagName(node, tagNames) {
    // tagNames is comma delimited
    return tagNames.split(/\s*,\s*/).indexOf(node.tagName) > -1;
  }

  function retargetBubbleEventByTagName(evt, stopNode, tagNames) {
    var target = evt.target;
    if (!target.nodeType || !stopNode.contains(target)) return null;
    if (!hasTagName(target, tagNames)) {
      return getClosestAncestorByTagName(target, stopNode, tagNames);
    }
    return target;
  }

  function getClosestAncestorByTagName(startNode, stopNode, tagNames) {
    while (startNode) {
      startNode = startNode.parentNode;
      if (!stopNode.contains(startNode) || startNode === stopNode) {
        break;
      }
      if (hasTagName(startNode, tagNames)) {
        return startNode;
      }
    }
    return null;
  }

  function forEachDescendantsByTagName(startNode, tagNames, fn) {
    var descendants = startNode.querySelectorAll(tagNames), i;
    for (i = 0; i < descendants.length; i++) {
      fn(descendants[i]);
    }
  }

  function forEachAncestorSiblingsByTagName(startNode, stopNode, ancestorTags, focusTags, fn) {
    var ancestor, i, node;
    do {
      ancestor = getClosestAncestorByTagName(startNode, stopNode, ancestorTags);
      if (ancestor) {
        for (i = 0; i < ancestor.parentNode.children.length; i++) {
          node = ancestor.parentNode.children[i];
          if (hasTagName(node, focusTags)) {
            fn(node);
          }
        }
      }
      startNode = ancestor;
    } while (startNode);
  }

  function focusItem(item) {
    item.classList.add('focused');
  }

  function isItemFocused(item) {
    return item.classList.contains('focused');
  }

  function blurItem(item) {
    item.classList.remove('focused');
  }

  function selectItem(item) {
    item.classList.add('selected');
  }

  function deselectItem(item) {
    item.classList.remove('selected');
  }

})(window);

(function(w){
    'use strict';
    // https://gist.github.com/joelambert/1002116
    /**
     * Behaves the same as setInterval except uses requestAnimationFrame() where possible for better performance
     * @param {function} fn The callback function
     * @param {int} delay The delay in milliseconds
     */
    w.requestInterval = function(fn, delay){
        var start = new Date().getTime(),
            handle = {};

        function loop(){
            var current = new Date().getTime(),
                delta = current - start;

            if(delta >= delay) {
                fn.call();
                start = new Date().getTime();
            }

            handle.value = w.requestAnimationFrame(loop);
        }

        handle.value = w.requestAnimationFrame(loop);
        return handle;
    };

    /**
     * Behaves the same as clearInterval except uses cancelRequestAnimationFrame() where possible for better performance
     * @param {(int|object)} handle The callback function
     */
    w.clearRequestInterval = function(handle){
        w.cancelAnimationFrame(handle.value);
    };
})(window);

// http://james.padolsey.com/javascript/element-datastorage/
(function(w){
    'use strict';

    var cache = [0],
        expando = 'data' + (+new Date());

    function data(elem) {

        var cacheIndex = elem[expando],
            nextCacheIndex = cache.length;

        if(!cacheIndex) {
            cacheIndex = elem[expando] = nextCacheIndex;
            cache[cacheIndex] = {};
        }

        return cache[cacheIndex];

    }

    w.bmDataCache = data;

})(window);

/* Adapted from https://github.com/thorst/jquery-idletimer

MIT License

Copyright (c) 2013 Paul Irish

Permission is hereby granted, free of charge, to any person
obtaining a copy of this software and associated documentation
files (the "Software"), to deal in the Software without
restriction, including without limitation the rights to use,
copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the
Software is furnished to do so, subject to the following
conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
OTHER DEALINGS IN THE SOFTWARE. */
(function(w){
    'use strict';

    w.bmIdleTimer = function(firstParam, elem){
        var opts;

        if(typeof firstParam === 'object'){
            opts = firstParam;
            firstParam = null;
        } else if(typeof firstParam === 'number'){
            opts = { timeout: firstParam };
            firstParam = null;
        }

        // element to watch
        elem = elem || document;
        opts = opts || {};

        opts = extendObject({
            idle: false,                // indicates if the user is idle
            timeout: 30000,             // the amount of time (ms) before the user is considered idle
            events: [
                'mousemove',
                'keydown',
                'wheel',
                'DOMMouseScroll',
                'mousewheel',
                'mousedown',
                'touchstart',
                'touchmove',
                'MSPointerDown',
                'MSPointerMove'
            ] // define active events
        }, opts);

        var obj = w.bmDataCache(elem).idleTimerObj || {};

        /* (intentionally not documented)
         * Toggles the idle state and fires an appropriate event.
         * @return {void}
         */
        // var toggleIdleState = function(e){
        var toggleIdleState = function(){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            // toggle the state
            obj.idle = !obj.idle;

            // store toggle state date time
            obj.olddate = +new Date();

            // create a custom event, with state and name space
            var evt;
            var evtName = (obj.idle ? 'idle' : 'active') + '.bmIdleTimer';

            // create custom event based on browser support
            try {
                evt = new CustomEvent(evtName);
            } catch(e) {
                evt = document.createEvent('Event');
                evt.initEvent(evtName, true, true);
            }

            // trigger event on object with elem and copy of obj
            elem.dispatchEvent(evt, extendObject({}, obj));
        };

        /**
         * Handle event triggers
         * @return {void}
         * @method event
         * @static
         */
        var handleEvent = function(e){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            // this is already paused, ignore events for now
            if(obj.remaining !== null){
                return;
            }

            /*
            mousemove is kinda buggy, it can be triggered when it should be idle.
            Typically is happening between 115 - 150 milliseconds after idle triggered.
            @psyafter & @kaellis report "always triggered if using modal (jQuery ui, with overlay)"
            @thorst has similar issues on ios7 "after $.scrollTop() on text area"
            */
            if (e.type === 'mousemove') {
                // if coord are same, it didn't move
                if (e.pageX === obj.pageX && e.pageY === obj.pageY) {
                    return;
                }
                // if coord don't exist how could it move
                if (typeof e.pageX === 'undefined' && typeof e.pageY === 'undefined') {
                    return;
                }
                // under 200 ms is hard to do, and you would have to stop, as continuous activity will bypass this
                var elapsed = (+new Date()) - obj.olddate;
                if (elapsed < 200) {
                    return;
                }
            }

            // clear any existing timeout
            clearTimeout(obj.tId);

            // if the idle timer is enabled, flip
            if (obj.idle) {
                toggleIdleState(e);
            }

            // store when user was last active
            obj.lastActive = +new Date();

            // update mouse coord
            obj.pageX = e.pageX;
            obj.pageY = e.pageY;

            // set a new timeout
            obj.tId = setTimeout(toggleIdleState, obj.timeout);
        };

        /**
         * Restore initial settings and restart timer
         * @return {void}
         * @method reset
         * @static
         */
        var reset = function(){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            // reset settings
            obj.idle = obj.idleBackup;
            obj.olddate = +new Date();
            obj.lastActive = obj.olddate;
            obj.remaining = null;

            // reset Timers
            clearTimeout(obj.tId);
            if (!obj.idle) {
                obj.tId = setTimeout(toggleIdleState, obj.timeout);
            }
        };

        /**
         * Store remaining time, stop timer
         * You can pause from an idle OR active state
         * @return {void}
         * @method pause
         * @static
         */
        var pause = function(){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            // this is already paused
            if(obj.remaining !== null){ return; }

            // define how much is left on the timer
            obj.remaining = obj.timeout - ((+new Date()) - obj.olddate);

            // clear any existing timeout
            clearTimeout(obj.tId);
        };

        /**
         * Start timer with remaining value
         * @return {void}
         * @method resume
         * @static
         */
        var resume = function(){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            // this isn't paused yet
            if(obj.remaining === null){ return; }

            // start timer
            if (!obj.idle){
                obj.tId = setTimeout(toggleIdleState, obj.remaining);
            }

            // clear remaining
            obj.remaining = null;
        };

        /**
         * Stops the idle timer. This removes appropriate event handlers
         * and cancels any pending timeouts.
         * @return {void}
         * @method destroy
         * @static
         */
        var destroy = function(){
            //clear any pending timeouts
            var obj = w.bmDataCache(elem).idleTimerObj || {};
            clearTimeout(obj.tId);

            //Remove data
            delete w.bmDataCache(elem).idleTimerObj;

            //detach the event handlers
            opts.events.forEach(function(eventName){
                elem.removeEventListener(eventName, idleTimerHandler);
            });
        };

        /**
        * Returns the time until becoming idle
        * @return {number}
        * @method remainingtime
        * @static
        */
        var remainingtime = function(){
            var obj = w.bmDataCache(elem).idleTimerObj || {};

            //If idle there is no time remaining
            if (obj.idle){ return 0; }

            //If its paused just return that
            if (obj.remaining !== null){ return obj.remaining; }

            //Determine remaining, if negative idle didn't finish flipping, just return 0
            var remaining = obj.timeout - ((+new Date()) - obj.lastActive);
            if(remaining < 0){ remaining = 0; }

            //If this is paused return that number, else return current remaining
            return remaining;
        };

        // determine which function to call
        if(firstParam === null && typeof obj.idle !== 'undefined'){
            // they think they want to init, but it already is, just reset
            reset();
            return elem;
        } else if(firstParam === null){
            // they want to init
        } else if(firstParam !== null && typeof obj.idle === 'undefined'){
            // they want to do something, but it isnt init
            // not sure the best way to handle this
            return false;
        } else if(firstParam === 'destroy'){
            destroy();
            return elem;
        } else if(firstParam === 'pause'){
            pause();
            return elem;
        } else if(firstParam === 'resume'){
            resume();
            return elem;
        } else if(firstParam === 'reset'){
            reset();
            return elem;
        } else if(firstParam === 'getRemainingTime'){
            return remainingtime();
        } else if(firstParam === 'getElapsedTime'){
            return (+new Date()) - obj.olddate;
        } else if(firstParam === 'getLastActiveTime'){
            return obj.lastActive;
        } else if(firstParam === 'isIdle'){
            return obj.idle;
        }

        /* (intentionally not documented)
         * Handles a user event indicating that the user isn't idle. namespaced with internal idleTimer
         * @param {Event} event A DOM2-normalized event object.
         * @return {void}
         */
        opts.events.forEach(function(eventName){
            // elem.addEventListener(eventName + '._idleTimer', idleTimerHandler, false);
            elem.addEventListener(eventName, idleTimerHandler, false);
        });

        // Internal Object Properties, This isn't all necessary, but we
        // explicitly define all keys here so we know what we are working with
        obj = extendObject({}, {
            olddate : +new Date(),          // the last time state changed
            lastActive: +new Date(),       // the last time timer was active
            idle : opts.idle,               // current state
            idleBackup : opts.idle,         // backup of idle parameter since it gets modified
            timeout : opts.timeout,         // the interval to change state
            remaining : null,               // how long until state changes
            tId : null,                     // the idle timer setTimeout
            pageX : null,                   // used to store the mouse coord
            pageY : null
        });

        // set a timeout to toggle state. May wish to omit this in some situations
        if (!obj.idle) {
            obj.tId = setTimeout(toggleIdleState, obj.timeout);
        }

        // store our instance on the object
        w.bmDataCache(elem).idleTimerObj = obj;

        return elem;

        /////////////

        // Extend a JavaScript object with the key/value pairs of another.
        // https://plainjs.com/javascript/utilities/merge-two-javascript-objects-19/
        function extendObject(obj, src) {
            Object.keys(src).forEach(function(key){
                obj[key] = src[key];
            });

            return obj;
        }

        function idleTimerHandler(e){
            handleEvent(e);
        }
    };
})(window);

(function(w){
    'use strict';

    /**
     * var jid = q.push(function (done, data) { console.log(data); done(); }, 30000, 'hello world!'); // log 'hello world!' every 30 secs
     * q.stop(jid); // disable specified job
     * q.start(jid); // enabled specified job
     * q.stop(); // disable all jobs
     * q.start(); // enable all jobs
     */
    w.bmJobQueue = function(resolution){
        var tId, q = [], self = this,
        // use Joe Lambert's requestInterval if available
        intervalFn = w.requestInterval || setInterval,
        clearFn = w.clearRequestInterval || clearInterval;

        resolution = resolution || 5000;

        // if we have the bmIdleTimer plugin, make Q smarter about idle states
        if(w.bmIdleTimer && w.bmDataCache){
          // does the document element already have idleTimer data
          if(!w.bmDataCache(w.document).idleTimerObj){
            w.bmIdleTimer(180000); // make sure it's started, 3 min idle
          }

          // event listeners to respond to bmIdleTimer events
          w.document.addEventListener('idle.bmIdleTimer', function(){ self.stop(); }, false);
          w.document.addEventListener('active.bmIdleTimer', function(){ self.start(); }, false);
        }

        this.push = function(fn, interval, data, context){
            var job;

            if(fn){
                if(!q.length){
                    self.start(); // start processing once we get first job
                }

                job = {fn: fn, interval: interval || 0, context: context || window, enabled: 1, running: 0, last: 0, data: data };
                runJob(job);
                q.push(job);

                return q.length; // jobId
            } else {
                return null;
            }
        };

        this.start = function(jobId){
            var job;
            if(jobId){
                job = q[jobId - 1];

                if(job){
                    job.enabled = 1;
                }
            } else if(!tId){
                mainLoop();
                tId = intervalFn(mainLoop, resolution);
            }
        };

        this.stop = function(jobId){
            var job;

            if(jobId){
                job = q[jobId - 1];

                if(job){
                  job.enabled = 0;
                }
            } else if(tId){
                clearFn(tId); tId = null;
            }
        };

        this.remove = function(jobId){
            if(jobId){
              q[jobId - 1] = null;
            }
        };

        this.update = function(jobId, fn, interval, data, context){
            var job;

            if(jobId){
                job = q[jobId - 1];

                if(job){
                    job.fn = fn || job.fn;
                    job.interval = interval !== undefined ? interval : job.interval;
                    job.data = data !== undefined ? data : job.data;
                    job.context = context !== undefined ? context : job.context;
                }
            }
        };

        /////////////

        function mainLoop(){
            var i, job;

            for (i = 0; i < q.length; i++){
                job = q[i];

                if(job && job.enabled && !job.running && (+new Date() - job.last >= job.interval)){
                    runJob(job);
                }
            }
        }

        function runJob(job){
            job.running = 1;
            job.fn.call(job.context, function (){ // callback
                job.running = 0;
                job.last = +new Date();
            }, job.data);
        }
    };
})(window);

/**
 * Top-level module for bluemoon-components
 */
(function(window, angular) {
    'use strict';

    // The following is an HTTPS guarantee for all Blue Moon apps.
    // The ideal, of course, is this happens via server redirect.
    if (window.location.protocol === 'http:') {
        // TODO: copied from environment.js, needs to DRYed and broken out to be available immediately
        var hostname = location.hostname.toLowerCase(),
            isCiEnv = /^ci\./.test(hostname),
            isLocalEnv = /^(localhost|0\.0\.0\.0|127\.0\.0\.1)$/.test(hostname);

        if (!isCiEnv && !isLocalEnv) { // limit to DEMO+
            window.location.protocol = 'https';
        }
    }

    // blank module for dev, overwritten for dist
    angular.module('bluemoon.components.templates', []);

    angular.module('bluemoon.components', [
        'bluemoon.components.templates',
        'bluemoon.components.app',
        'bluemoon.components.header',
        'bluemoon.components.staffHeader',
        'bluemoon.components.nav',
        'bluemoon.components.main',
        'bluemoon.components.busyLoader',
        'bluemoon.components.bluemoonForceDesktop',
        'bluemoon.components.i18n',
        'bluemoon.components.bluemoonRequiredMark',
        'bluemoon.components.modal',
        'bluemoon.help',
        'bmPermission',
        'bmLicense',
        'bmAccess',
        'bmEnvironment',
        'bmUser',
        'bmUserTermsSignatory',
        'bmPreferenceService',
        'bmImageUploadModal',
        'bmProfilePhoto',
        'bmViewPortalBanner'
    ]);

})(window, window.angular);

(function(angular) {
    'use strict';

    var util = {

        // http://stackoverflow.com/a/8809472
        generateUUID: function() {
            /* jshint ignore:start */
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (d + Math.random() * 16)%16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r&0x7 | 0x8)).toString(16);
            });
            return uuid;
            /* jshint ignore:end */
        },

        // TRMR gotta be different
        generateTRMRGUID: function(uuid) {
            if (!uuid) { uuid = util.generateUUID(); }
            return uuid.replace(/-/g, '');
        },

        // Simple cookie handling (doesn't encode/decode)
        cookie: function(key, val, path, infinite) {
            if (val === undefined) { // get
                return (document.cookie.match('(^|; )' + key + '=([^;]*)') || 0)[2];
            }

            var pathSeg = path ? '; path=' + path : '';
            var expiresSeg = infinite ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '';

            if (val === null) { // delete
                document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT' + pathSeg;
            } else { // set
                document.cookie = key + '=' + val + pathSeg + expiresSeg;
            }
        },

        // Given an object tree, return flat Array of dot-notated, compound keys
        // (e.g. {a1:{b1:'x',b2:{c1:'y'}},a2:'z'} -> ['a1.b1','a1.b2.c1','a2'])
        flattenKeys: function(obj, filter) {
            var flat = [];
            function traverse(obj, key) {
                var compound;
                for (var prop in obj) {
                    compound = key ? key + '.' + prop : prop;
                    if (typeof obj[prop] === 'object') {
                        traverse(obj[prop], compound);
                    } else {
                        if (filter) {
                            if (!filter(obj, prop, compound)) { continue; }
                        }
                        flat.push(compound);
                    }
                }
            }
            traverse(obj);
            return flat;
        },

        // overwritten by angular.extend
        extend: function() {
            throw new Error('Not implemented.');
        },

        // http://stackoverflow.com/a/9229821
        // some consumers don't use underscore/lodash
        uniq: function(a) {
            var seen = {};
            var out = [];
            var len = a.length;
            var j = 0;
            for(var i = 0; i < len; i++) {
                 var item = a[i];
                 if(seen[item] !== 1) {
                       seen[item] = 1;
                       out[j++] = item;
                 }
            }
            return out;
        },

        // safe way to decode html entities in a string w/o opening yourself up to script injection
        decodeHtmlEntities: function(str) {
            var txt = document.createElement('textarea');
            txt.innerHTML = str;
            return txt.value;
        },

        isNullOrEmpty: function(str){
            return angular.isUndefined(str) || str === null || str === '';
        },

        // https://developer.mozilla.org/en-US/docs/Web/API/Location
        parseUri: function(href){
            if(util.isNullOrEmpty(href)){
                return undefined;
            }

            var url = document.createElement('a');
            url.href = href;
            return url;

            // url.href;      https://developer.mozilla.org/en-US/search?q=URL#search-results-close-container
            // url.protocol;  https:
            // url.host;      developer.mozilla.org
            // url.hostname;  developer.mozilla.org
            // url.port;      (blank - https assumes port 443)
            // url.pathname;  /en-US/search
            // url.search;    ?q=URL
            // url.hash;      #search-results-close-container
            // url.origin;    https://developer.mozilla.org
        },
        /**
         * https://gist.github.com/maxwihlborg/1911a28f988444db3ddc
         * Simple debounce function; usage:
         *
         * Create a function that only can be called once every 500 ms
         *
         *      var df = debounce(function() {
         *          ... func body ...
         *      }, 500)
         *
         * Bind the function to an event
         *
         *      document.addEventListener('keydown', df);
         *
         * @param fn   {function} function you want to debounce
         * @param wait {number}   interval wait in ms
         */
        debounce: function(fn, wait) {
            var timeout;
            return function() {
                var ctx = this, args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(function() {
                    fn.apply(ctx, args);
                }, wait || 100);
            };
        }
    };

    /* ANGULAR */
    util.extend = angular.extend;

    angular.module('bluemoon.components.util', [])
        .value('bmUtil', util);

})(window.angular);

(function(window, angular){
    'use strict';

    angular.module('bluemoon.components.i18n', ['pascalprecht.translate', 'bluemoon.components.util', 'bmEnvironment'])

        .config(['$httpProvider', '$translateProvider', 'bmEnvCountryDefaultLang', function($httpProvider, $translateProvider, countryDefaultLang) {
            $httpProvider.interceptors.push('bmHttpAcceptLangInterceptor');

            $translateProvider.useStorage('languageStorageManager');
            $translateProvider.preferredLanguage(countryDefaultLang);
            $translateProvider.fallbackLanguage('en-US');
        }])

        .value('bmLanguageCookieName', 'BMLanguageCode')

        .factory(
            'languageStorageManager',
            ['bmUtil', 'bmLanguageCookieName', 'bmEnvCountryDefaultLang', function(bmUtil, bmLanguageCookieName, defaultLang) {

                var factory = {};

                var languageCookieOptions = {
                    name: bmLanguageCookieName,
                    path: '/',
                    infinite: 'true',
                };

                function set(name, value){
                    // Override any cookie name passed in
                    name = languageCookieOptions.name;
                    bmUtil.cookie(name, value, languageCookieOptions.path, languageCookieOptions.infinite);
                }

                factory.set = set;
                factory.put = set;

                factory.get = function(name){
                    // Override any cookie name passed in
                    name = languageCookieOptions.name;
                    return bmUtil.cookie(name) || defaultLang;
                };

                return factory;
            }]
        )

        .factory('bmLanguageManager', ['$q', '$translate', 'languageStorageManager', 'bmEnvironment', 'bmEnvCountryDefaultLang',
            function($q, $translate, languageStorageManager, bmEnvironment, bmEnvCountryDefaultLang){

            var factory = {
                getLoadedLanguageAsync: getLoadedLanguageAsync,
                getLanguagesAsync: getLanguagesAsync,
                setUserLanguageAsync: setUserLanguageAsync,
                getCurrentLanguage: getCurrentTranslateLanguageCode,
                updatedUserLanguage: ''
            };

            var languageLoadRetry = 0;

            return factory;

            //////////

            function getLoadedLanguageAsync(){
                var currentLanguage;
                var currentLanguageCode = getCurrentTranslateLanguageCode();

                return bmEnvironment.getSupportedLanguagesAsync().then(function(languages){
                    if(angular.isUndefined(languages) || languages.length === 0){
                        return { code: bmEnvCountryDefaultLang };
                    }

                    for(var counter = 0; counter < languages.length; counter++){
                        if(languages[counter].code === currentLanguageCode){
                            currentLanguage = languages[counter];
                            break;
                        }
                    }

                    // Was a current supported language found?
                    if(angular.isDefined(currentLanguage)){
                        return currentLanguage;
                    }

                    languageLoadRetry++;

                    // Avoid an endless loop
                    if(languageLoadRetry > 1){
                        return { code: bmEnvCountryDefaultLang };
                    }

                    // Set translate to default language and try again
                    return $translate.use(bmEnvCountryDefaultLang).then(function(){
                        return getLoadedLanguageAsync();
                    });
                });
            }

            function getLanguagesAsync(includeLoadedLanguage){
                return getLanguageListAsync(includeLoadedLanguage).then(function(languages){
                    return languages;
                });
            }

            function setUserLanguageAsync(languageCode){
                var deferred, curr = getCurrentTranslateLanguageCode();
                if (curr !== languageCode) {
                    return $translate.use(languageCode).then(function(){
                        languageStorageManager.set('BMLanguageCode', languageCode);
                        factory.updatedUserLanguage = languageCode;
                    });
                } else {
                    deferred = $q.defer();
                    deferred.resolve();
                    return deferred.promise;
                }
            }

            //////////

            function getLanguageListAsync(includeLoadedLanguage){
                var languageList = [];

                return getLoadedLanguageAsync().then(function(currentLanguage){
                    var currentLanguageCode = currentLanguage.code;

                    return bmEnvironment.getSupportedLanguagesAsync().then(function(languages){
                        if(angular.isUndefined(languages)){
                            return languageList;
                        }

                        for(var counter = 0; counter < languages.length; counter++){
                            if(languages[counter].code === currentLanguageCode && !includeLoadedLanguage){
                                continue;
                            }

                            // Get the translated description for the loaded language
                            angular.extend(languages[counter], getTranslatedDescription(languages[counter], currentLanguageCode));

                            languageList.push(languages[counter]);
                        }

                        return languageList;
                    });
                });
            }

            function getCurrentTranslateLanguageCode(){
                var currentLanguageCode = $translate.proposedLanguage();

                if(angular.isUndefined(currentLanguageCode)){
                    currentLanguageCode = $translate.use();
                }

                return currentLanguageCode;
            }

            function getTranslatedDescription(language, translateCode){
                // Default to the language description itself
                var description = {
                    translatedDescription: language.description
                };

                if(angular.isUndefined(language.translations)){
                    return description;
                }

                for(var counter = 0; counter < language.translations.length; counter++){
                    if(language.translations[counter].code === translateCode){
                        description.translatedDescription = language.translations[counter].description;
                        break;
                    }
                }

                return description;
            }
        }])

        .directive('bmLanguageSelect', ['bmLanguageManager', '$timeout', function(bmLanguageManager, $timeout){
            return {
                restrict: 'E',
                replace: true,
                templateUrl: 'components/i18n/language-select.2js.html',
                scope: {
                    selectedLanguageCode: '=',
                    name: '@',
                    includeEmptyOption: '&',
                    selectionRequired: '&',
                    onChange: '&',
                    ngDisabled: '='
                },
                link: function (scope, element) {
                    function loadLangList() {
                        bmLanguageManager.getLanguagesAsync(true).then(function(languages){
                            scope.languageList = languages;

                            // Create local scope in order to not overwrite data bound scope value
                            scope.selectedLanguage = {
                                code: scope.selectedLanguageCode
                            };
                        });
                    }

                    loadLangList();

                    scope.$watch('selectedLanguageCode', function(newValue, oldValue) {
                        if (newValue && newValue !== oldValue) {
                            scope.selectedLanguage = {
                                code: newValue
                            };

                            scope.selectionChanged();
                        }
                    });

                    scope.$on('bmLanguageChangeSuccess', loadLangList);

                    // Set watches here so can actually pass attribute as a boolean
                    scope.$watch('includeEmptyOption()', function(newValue){
                        scope.showEmpty = newValue;
                    });

                    scope.$watch('selectionRequired()', function(newValue){
                        scope.required = newValue;
                    });

                    scope.$watch('ngDisabled', function(newValue){
                        scope.disabled = newValue;
                    });

                    scope.selectionChanged = function(){
                        // Set data bound value to new selection
                        scope.selectedLanguageCode = scope.selectedLanguage.code;

                        if(typeof scope.onChange !== 'undefined'){
                            // Hack to have model updated before change is fired (ngModelOptions failed)
                            $timeout(function(){
                                scope.onChange({ language: scope.selectedLanguageCode });
                            }, 0);
                        }
                    };

                    // copied straight from bento select control
                    // Add IE and Firefox version for better UI look and feel
                    if (window.navigator.userAgent.search(/MSIE 9/gi) !== -1) {
                      element.addClass('ie9');
                    } else if (window.navigator.userAgent.search(/MSIE 10/gi) !== -1) {
                      element.addClass('ie10');
                    } else if (window.navigator.userAgent.search(/Firefox/gi) !== -1) {
                      element.addClass('firefox');
                      element.append('<div class="bento-select-border"></div>');
                    }
                }
            };
        }])

        //  This is a workaround for https://github.com/angular-translate/angular-translate/issues/855
        .service('GlobalTranslateRefreshService', ['$translate', function($translate) {

            var _translationRefreshPromise;

            this.refresh = function() {
                return !_translationRefreshPromise ?
                    (_translationRefreshPromise = $translate.refresh()) :
                    _translationRefreshPromise;
            };
        }])

        .run(['$rootScope', function($rootScope){
            $rootScope.$on('$translateChangeSuccess', function(event, args){
                $rootScope.$broadcast('bmLanguageChangeSuccess', { language: args.language });
            });
        }])

        .service('bmHttpAcceptLangInterceptor', HttpAcceptLangInterceptor);

    function HttpAcceptLangInterceptor(languageStorageManager) {
        this.request = function(conf) {
            if (!conf.headers['Accept-Language']) {
                var lang = languageStorageManager.get();

                if (lang) {
                    conf.headers['Accept-Language'] = lang;
                }
            }
            return conf;
        };
    }

    HttpAcceptLangInterceptor.$inject = ['languageStorageManager'];
})(window, window.angular);

(function(MessageFormat){
    'use strict';

    if (MessageFormat && MessageFormat.plurals) {
        // This is similar to the "en" entry from version 0.3.1 of the messageformat.js file
        MessageFormat.plurals.xx = function (n) {
            return n === 1 ? 'one' : 'other';
        };
    }

})(window.MessageFormat);

/**
 * Blue Moon Components - session module
 */
(function(angular) {
    'use strict';

    var tokenType = 'UDSLongToken',
        staffDestUrl = '/staff/',
        clientDestUrl = '/client/',
        atendimentoClientDestUrl = '/atendimento-client/',
        clientBetaDestUrl = '/clientcenter/',
        employeeDestUrl = '/samba-employee-center/',
        employerDestUrl = '/samba-employer-center/',
        esalesCustomerDestUrl = '/samba-esales-customer-center/',
        destinationQueryStringKey = 'd',
        destinationStorageKey = 'bmViewPortalReturnUrl',
        clientMyPayOnboardingUrl = '/uspayrollonboarding/center/#/views/client',
        refAccountantMyPayOnboardingUrl = '/uspayrollonboarding/center/#/views/accountant',
        viewPortalUrl = '/api/security/v2/sessions/view-portal',
        exitViewPortalUrl = '/api/security/v1/sessions/view-portal/exit',
        checkPointARUrl = '/sso/',
        sambaDestUrl = '/smb/',
        cookiePath = '/',
        grantsMap = {
            // staff
            'Applications.Onvio': 'staff',
            'OnvioSetup.Contacts': 'staff.setup.contacts',
            'OnvioSetup.Messages': 'staff.setup.messages',
            'OnvioSetup.Appearances': 'staff.setup.appearances',
            'OnvioSetup.Offices': 'staff.setup.offices',
            'OnvioSetup.Staff': 'staff.setup.staff',
            'OnvioSetup.Clients': 'staff.setup.clients',
            'OnvioSetup.Firm': 'staff.setup.firm',
            'OnvioDrive.Documents': 'staff.documents',
            'OnvioDrive.FirmDocuments': 'staff.documents.firm',
            'OnvioDrive.MyDocuments': 'staff.documents.my',
            'OnvioDrive.ClientDocuments': 'staff.documents.client',
            // client
            'Platform.ccVnext': 'client.beta',
            'Applications.OnvioClientHub': 'client',
            'OnvioClientDrive.Drive': 'client.documents',
            'TaxCenter.Tax': 'client.tax',
            'MyPayClientOnboarding.ClientOnboarding' : 'client.mypayonboarding',
            'MyPayOnboarding.ReferringAccountant': 'staff.mypayonboarding.refaccountant',
            'Applications.Samba' : 'samba',
            // employee
            'SaMBa.Employee': 'samba.employee.center',
            // employer
            'SaMBa.Employer': 'samba.employer.center',
            //esales
            'SaMBa.ESalesCenter': 'samba.employer.center',
            'SaMBa.ESalesCustomerCenter': 'samba.esales.customer.center',
            // csadmin
            'AuthApp.UberAdmin': 'csadmin',
            'AuthApp.Admin': 'csadmin',
            'AuthApp.Staff': 'csadmin'
        },
        userUrl =  '/api/profiles/v1/users';

    // Use separate data object to eliminate circular dependencies in interceptors
    function AuthenticatedSessionData($q) {
        var self = this;

        this.deferred = {
            all: $q.defer(),
            meta: $q.defer(),
            bindings: $q.defer()
        };

        // synchronous access
        this.meta = {};
        this.bindings = {};

        // asynchronous access
        this.get = function() {
            return self.deferred.all.promise;
        };
        this.getMeta = function() {
            return self.deferred.meta.promise;
        };
        this.getBindings = function() {
            return self.deferred.bindings.promise;
        };
    }

    function AuthenticatedSession(
        $window,
        $document,
        $log,
        $location,
        $q,
        $http,
        $rootScope,
        $uibModal,
        httpAuthInterceptor,
        sessionMetadataUrl,
        sessionMetadataUrlV2,
        sessionBindingsUrl,
        authWaypointUrl,
        defaultDestinationUrl,
        ssoUrl,
        ssoTokenKey,
        authenticatedSessionData,
        bmUtil,
        bmTheme,
        bmLanguageManager,
        bmEnvironmentConst,
        bmEnvironment,
        bmAccess,
        csWebLoginUriMap) {

        var unloadCancelledTimeout;
        var self = this;
        var destroying = false;

        // data
        self.data = authenticatedSessionData;

        // methods
        self.create = create;
        self.createWithJwt = createWithJwt;
        self.createWithOptions = createWithOptions;
        self.createWithLongToken = createWithLongToken;
        self.createViaSsoToken = createViaSsoToken;
        self.load = load;
        self.loadMeta = loadMeta;
        self.loadBindings = loadBindings;
        self.destroy = destroy;
        self.getRequestedDestination = getRequestedDestination;
        self.viewPortal = viewPortal;
        self.exitViewPortal = exitViewPortal;
        self.switchAccountWithLongToken = switchAccountWithLongToken;

        function create(uid, pwd, beforeRedirectAction) {
            var options = {data: {
                username: uid,
                password: pwd
            }};
            return createWithOptions(options, beforeRedirectAction);
        }

        function createViaSsoToken(token) {
            var options = {
                method: 'GET',
                url: ssoUrl + '?' + ssoTokenKey + '=' + token
            };
            return createWithOptions(options);
        }

        function createWithJwt(jwt) {
            return createWithOptions({
                method: 'POST',
                url: '/api/security/v2/sessions/jwt',
                headers: { Authorization: 'Bearer ' + jwt }
            });
        }

        function createWithOptions(options, beforeRedirectAction) {
            var defaultOptions = {
                method: 'POST',
                url: sessionMetadataUrlV2,
                bmNoAuth: true
            };
            var promise = $http(angular.extend(defaultOptions, options));

            // if attempting to create a new session, dump old token
            bmUtil.cookie(tokenType, null);

            promise.then(function(resp) {
                createWithLongToken(resp.data.LongToken, beforeRedirectAction);
            });

            return promise;
        }

        function createWithLongToken(longToken, beforeRedirectAction){
            var preferredDest = getRequestedDestination($location);

            // success, propagate token to apps in other tabs/windows
            bmUtil.cookie(tokenType, longToken, cookiePath);

            updateUserLanguage().then(function() {
                if (!preferredDest) {
                    // get bindings to determine where to send user
                    loadBindings().then(function (){
                        self.destUrl = '';
                        var grants = self.data.bindings.Grants,
                            access = self.data.bindings.Access;

                        if (isSamba(grants)) {
                            self.destUrl = sambaDestUrl;
                        } else if (isCheckPoint()){
                            //Redirect at checkpointAr login url with SSO Token
                            beforeRedirectAction = evaluateBeforeDirectionExecution.bind(self, beforeRedirectAction, longToken);
                        } else if (isStaff(grants)){
                            self.destUrl = staffDestUrl;
                        } else if(isMyPayOnboardingClient(grants)) {
                            self.destUrl = clientMyPayOnboardingUrl;
                        } else if (isClientBeta(grants, access)) {
                            self.destUrl = clientBetaDestUrl;
                        } else if (isAtendimentoClient(grants)) {
                            self.destUrl = atendimentoClientDestUrl;
                        } else if (isClient(grants)) {
                            self.destUrl = clientDestUrl;
                        } else if(isMyPayOnboardingRefAccountant(grants)) {
                            self.destUrl = refAccountantMyPayOnboardingUrl;
                        } else if (isEmployee(grants)) {
                            self.destUrl = employeeDestUrl;
                        } else if (isEmployer(grants)) {
                            self.destUrl = employerDestUrl;
                        } else if (isEsalesCustomerCenter(grants)){
                            self.destUrl = esalesCustomerDestUrl;
                        } else if (isStaffDocumentsBasic(grants)){
                            // OnvioDocumentsBasic
                            self.destUrl = staffDestUrl;
                        } else if (isCsAdmin(grants)) {
                            // redirect to an actual CSWeb uri - #8747
                            self.destUrl = csWebLoginUriMap[bmEnvironmentConst.type];
                        }
                        if(beforeRedirectAction) {
                            beforeRedirectAction().finally(function afterAction() {
                                // goto destination page after completion of promise
                                gotoDestinationPage($window, $location, self.destUrl || defaultDestinationUrl);
                            });
                        } else {
                            // goto destination page
                            gotoDestinationPage($window, $location, self.destUrl || defaultDestinationUrl);
                        }
                    });
                } else {
                    if(beforeRedirectAction) {
                        beforeRedirectAction().finally(function afterAction() {
                            // goto destination page after completion of promise
                            gotoDestinationPage($window, $location, defaultDestinationUrl);
                        });
                    } else {
                        // goto destination page
                        gotoDestinationPage($window, $location, defaultDestinationUrl);
                    }
                }
            });
        }

        function switchAccountWithLongToken(longToken, beforeRedirectAction){
            // dump old token
            bmUtil.cookie(tokenType, null);

            // propagate new token to apps in other tabs/windows
            bmUtil.cookie(tokenType, longToken, cookiePath);

            updateUserLanguage().then(function() {
                // get bindings to determine where to send user
                // purposely set cache to false in order to get updated token
                loadBindings({ cache: false }).then(function (){
                    var destUrl,
                        grants = self.data.bindings.Grants,
                        access = self.data.bindings.Access;

                    if (isSamba(grants)) {
                        destUrl = sambaDestUrl;
                    } else if (isStaff(grants)){
                        destUrl = staffDestUrl;
                    } else if(isMyPayOnboardingClient(grants)) {
                        destUrl = clientMyPayOnboardingUrl;
                    } else if (isClientBeta(grants, access)) {
                        destUrl = clientBetaDestUrl;
                    } else if (isAtendimentoClient(grants)) {
                        destUrl = atendimentoClientDestUrl;
                    } else if (isClient(grants)) {
                        destUrl = clientDestUrl;
                    } else if(isMyPayOnboardingRefAccountant(grants)) {
                        destUrl = refAccountantMyPayOnboardingUrl;
                    } else if (isEmployee(grants)) {
                        destUrl = employeeDestUrl;
                    } else if (isEmployer(grants)) {
                        destUrl = employerDestUrl;
                    } else if (isEsalesCustomerCenter(grants)){
                        destUrl = esalesCustomerDestUrl;
                    } else if (isStaffDocumentsBasic(grants)){
                        // OnvioDocumentsBasic
                        destUrl = staffDestUrl;
                    } else if (isCsAdmin(grants)) {
                        // redirect to an actual CSWeb uri - #8747
                        destUrl = csWebLoginUriMap[bmEnvironmentConst.type];
                    }

                    if(beforeRedirectAction) {
                        beforeRedirectAction().finally(function afterAction() {
                            // goto destination page after completion of promise
                            gotoDestinationPage($window, $location, destUrl || defaultDestinationUrl);
                        });
                    } else {
                        // goto destination page
                        gotoDestinationPage($window, $location, destUrl || defaultDestinationUrl);
                    }
                });
            });
        }

        function viewPortal(contactId, companyId, userId) {
            var req = $http.post(viewPortalUrl, { id: contactId, companyId: companyId, userId: userId });
            req.then(
                function(resp) {
                    // replace session token with new impersonated session token
                    bmUtil.cookie(tokenType, resp.data.LongToken, cookiePath);
                    // store full origin url so we can return
                    window.sessionStorage.setItem(destinationStorageKey, location.href);
                    // TODO: don't hardcode destination, look up and take them to home context
                    bmAccess.has('ClientCenterVnext').then(function() {
                        window.location.href = clientBetaDestUrl;
                    }).catch(function() {
                        if (bmEnvironment.isBrCountryCode()){
                            window.location.href = atendimentoClientDestUrl;
                        } else {
                            window.location.href = clientDestUrl;
                        }
                    });
                },
                function(resp) {
                    if (resp.status === 403 && !!resp.data && !!resp.data.message && resp.data.message === 'CC_USER_HAS_BETA') {
                        resp.config.global = false;

                        window.location.href = clientBetaDestUrl;
                    }
                }
            );
            return req;
        }

        function exitViewPortal() {
            var req = $http.post(exitViewPortalUrl);
            req.then(function(resp) {
                // replace session token with new impersonated session token
                bmUtil.cookie(tokenType, resp.data.LongToken, cookiePath);
                // return to origin url or staff
                var returnUrl = window.sessionStorage.getItem(destinationStorageKey) || staffDestUrl;
                window.sessionStorage.removeItem(destinationStorageKey);
                window.location.href = returnUrl;
            });
            return req;
        }

        function updateUserLanguage() {
            var promise, lang = bmLanguageManager.updatedUserLanguage;

            if (lang) {
                promise = loadMeta().then(function(resp) {
                    return $http({
                        method: 'PUT', // PATCH?
                        url: userUrl + '/' + resp.data.PrismGuid,
                        data: { language: lang }
                    });
                });
            } else {
                var deferred = $q.defer();
                deferred.resolve();
                promise = deferred.promise;
            }

            return promise;
        }

        function isStaff(grants) {
            return grants.indexOf('staff') > -1;
        }

        function isClientBeta(grants, access) {
            return ((grants.indexOf('client.beta') > -1) || (access.indexOf('ClientCenterVnext') > -1)) && isClient(grants);
        }

        function isAtendimentoClient(grants) {
            return grants.indexOf('client') > -1 && !isStaff(grants) && bmEnvironment.isBrCountryCode();
        }

        function isClient(grants) {
            return grants.indexOf('client') > -1 && !isStaff(grants);
        }

        function isMyPayOnboardingClient(grants){
            return grants.indexOf('client.mypayonboarding') > -1 && !isStaff(grants);
        }

        function isMyPayOnboardingRefAccountant(grants){
            return grants.indexOf('staff.mypayonboarding.refaccountant') > -1;
        }

        function isSamba(grants){
            return grants.indexOf('samba') > -1 && !isMyPayOnboardingClient(grants) && !isEmployee(grants) && !isEmployer(grants) &&!isEsalesCustomerCenter(grants);
        }

        function isEmployee(grants){
            return grants.indexOf('samba.employee.center') > -1;
        }

        function isEmployer(grants){
            return grants.indexOf('samba.employer.center') > -1;
        }

        function isEsalesCustomerCenter(grants){
            return grants.indexOf('samba.esales.customer.center') > -1;
        }

        function isStaffDocumentsBasic(grants){
            return grants.indexOf('staff.setup.firm') > -1 && grants.indexOf('staff.setup.clients') > -1;
        }

        function isCsAdmin(grants){
            return grants.indexOf('csadmin') > -1;
        }

        function isCheckPoint(){
            return $location.search().mafUrl;
        }

        function evaluateBeforeDirectionExecution(beforeRedirectAction, longToken){
            if(beforeRedirectAction){
                 return beforeRedirectAction()
                 .then(setAuthCheckpointUrl.bind(self, longToken));
             } else {
                  return setAuthCheckpointUrl(longToken);
             }
        }

        function setAuthCheckpointUrl(longToken){
            var defer = $q.defer();
            getCheckpointARSso(longToken).then(function(ssoUrl){
                self.destUrl = getCheckpointUrl(ssoUrl);
                defer.resolve();
            });
            return defer.promise;
        }

        // Get SSO token with UDS Long token for CheckpointAR vertical
        function getCheckpointARSso(longToken) {
            return $http({
                method: 'POST',
                url: '/api/security/v1/sso',
                data: {
                    Vertical: 'CheckpointAR',
                    Path: checkPointARUrl
                },
                headers: { Authorization: 'UDSLongToken' + longToken }
            });
        }

        //Return checkpoint url with mafUrl and SSOTotken
        function getCheckpointUrl(SsoUrl){
            return SsoUrl.data.Url + '&redirect=' + $location.search().mafUrl;
        }

        function loadMeta(conf) {
            var meta = $http.get(sessionMetadataUrl, angular.extend({ cache: true }, conf));

            // refresh
            if (conf && conf.cache === false && self.data.meta.CreatedDateTime) {
                self.data.meta = {};
                self.data.deferred.meta = $q.defer();
                self.data.deferred.all = $q.defer();
            }

            meta.then(function(resp) {
                var data = resp.data;

                // convenience data
                if (data.FirstName) {
                    data.FullName = data.FirstName + ' ' + data.LastName;
                    data.Initials = data.FirstName.charAt(0) + data.LastName.charAt(0);
                } else {
                    data.FullName = data.LastName;
                    data.Initials = data.LastName.charAt(0);
                }

                self.data.meta = data;
                self.data.deferred.meta.resolve(data);

                return data;
            }, function(resp) {
                self.data.deferred.meta.reject(resp);
            });

            return meta;
        }

        function loadBindings(conf) {
            var bindings = $http.get(sessionBindingsUrl, angular.extend({ cache: true }, conf));

            // refresh
            if (conf && conf.cache === false && self.data.bindings.ApplicationConfiguration) {
                self.data.bindings = {};
                self.data.deferred.bindings = $q.defer();
                self.data.deferred.all = $q.defer();
            }

            bindings.then(function(resp) {
                var data = resp.data,
                    frpMap = data.FeatureResourcePermissions.FeatureResourcePermissionsMap,
                    iacs = data.InfrastructureAccessControls;

                // add grants array for convenience
                data.Grants = bmUtil.flattenKeys(frpMap, filterGrants).map(function(key) {
                    return grantsMap[key];
                });

                // add iac array
                data.Access = iacs;

                // persist theme identifier (companyId) in a cookie for pre-auth branding (e.g. login page)
                if (isClient(data.Grants) || isStaff(data.Grants)) {
                    bmTheme.persistTheme(data.ApplicationConfiguration.CompanyId);
                }

                self.data.bindings = data;
                self.data.deferred.bindings.resolve(data);

                return data;
            }, function(resp) {
                self.data.deferred.bindings.reject(resp);
            });

            return bindings;
        }

        function load(conf) {
            var meta = loadMeta(conf),
                bindings = loadBindings(conf),
                all = $q.all([meta, bindings]);

            all.then(function() {
                self.data.deferred.all.resolve(authenticatedSessionData);
            }, function(resp) {
                self.data.deferred.all.reject(resp);
            });

            return self.data.deferred.all.promise;
        }

        function filterGrants(obj, prop) {
            return obj[prop] === 'Granted';
        }

        function destroy(waypointUrl) {
            destroying = true;

            // goto login page, no return dest
            gotoWaypointPage($window, waypointUrl || authWaypointUrl);

            // goto login page, set return dest to current url - no hash location
            // gotoWaypointPage($window, authWaypointUrl, $window.location.href.split('#')[0]);
        }

        function getRequestedDestination() {
            var dest = $location.search()[destinationQueryStringKey], hash;
            if (dest) {
                hash = $location.hash();
                if (hash) {
                    // concat hash for full dest
                    dest = dest + '#' + hash;
                }
                dest = decodeURIComponent(dest);
            }
            return dest;
        }

        function gotoDestinationPage($window, $location, fallbackUrl) {
            $window.location.href = getRequestedDestination($location) || fallbackUrl;
        }

        $window.addEventListener('beforeunload', function() {
            unloadCancelledTimeout = $window.setTimeout(function() {
                // unload was cancelled, reset state
                destroying = false;
            }, 1000);
        }, false);

        $window.addEventListener('unload', function() {
            var token;
            $window.clearTimeout(unloadCancelledTimeout);
            if (destroying) {
                token = bmUtil.cookie(tokenType);
                bmUtil.cookie(tokenType, null);
                // make synchronous session delete request ($http can't do sync)
                // to guarantee this occurs before unloading
                var req = new $window.XMLHttpRequest();
                req.open('DELETE', sessionMetadataUrl, false); // false = synchronous
                req.setRequestHeader('Authorization', tokenType + ' ' + token);
                req.send(null);
                $log.info('Sorry, while we are aware that synchronous XHR is generally bad, in this case it is intentional.');
            }
        }, false);
    }

    function HttpAnalyticsInterceptor(bmUtil, $rootScope) {
        this.request = function(conf) {
            var callId = bmUtil.generateUUID();
            var chainId = bmUtil.generateUUID();
            conf.headers['x-call-id'] = callId;
            conf.headers['x-chain-id'] = chainId;
            $rootScope.$emit('$httpRequestEvent', {
                url: conf.url,
                method: conf.method,
                'x-call-id': callId,
                'x-chain-id': chainId
            });
            return conf;
        };
    }

    function HttpTimeoutInterceptor(httpTimeout) {
        this.request = function(conf) {
            if (angular.isUndefined(conf.timeout)) {
                conf.timeout = httpTimeout;
            }
            return conf;
        };
    }

    function HttpAuthInterceptorProvider() {
        var redirect = true,
            auth = true;

        this.auth = function(val) {
            auth = val;
        };
        this.redirect = function(val) {
            redirect = val;
        };

        this.$get = ['$window', '$document', '$q', 'authWaypointUrl', 'bmUtil', function($window, $document, $q, authWaypointUrl, bmUtil) {
            return {
                request: function(conf) {
                    if (auth && conf.bmNoAuth !== true) {
                        var token = bmUtil.cookie(tokenType);

                        if (token) {
                            conf.headers.Authorization = tokenType + ' ' + token;
                        }
                    }
                    return conf;
                },
                responseError: function(resp) {
                    if (resp.status === 401 && redirect && resp.config.bmAuthRedirect !== false) {
                        // don't get caught up in the global error handler
                        resp.config.global = false;
                        // goto login page, set return dest to current url
                        gotoWaypointPage($window, authWaypointUrl, $window.location.href);
                    }
                    return $q.reject(resp);
                }
            };
        }];
    }

    var globalHttpServerError = { type: 'danger', msg: 'A server error ocurred.', closeable: true };
    function HttpLogInterceptor($timeout, $q, $rootScope) {
        this.responseError = function(resp) {
            // bump to next event loop, so error/catch can disable it if handled
            $timeout(function() {
                if (resp.config.global !== false) {
                    // make copy and add response obj
                    var errCopy = angular.copy(globalHttpServerError);
                    errCopy.detail = resp;

                    if (!$rootScope.bmErrors) {
                        $rootScope.bmErrors = [];
                    }

                    $rootScope.bmErrors.unshift(errCopy);
                }
            });
            return $q.reject(resp);
        };
    }

    function gotoWaypointPage($window, waypointUrl, destinationUrl) {
        var href = waypointUrl;

        // if dest, encode it in waypoint so we can return after auth
        if (destinationUrl) {
            // remove 'notfound' at the end if it exists
            destinationUrl = destinationUrl.replace(/\/notfound$/, '/');
            // append hash if necessary
            if (waypointUrl.indexOf('#') === -1) {
                href += '#/';
            }
            // append appropriate "hashSearch" delimiter
            href += /#.*\?/.test(waypointUrl) ? '&' : '?';
            // append dest as "hashSearch" param
            href += destinationQueryStringKey + '=' + encodeURIComponent(destinationUrl);
        }

        $window.location.href = href;
    }

    function config($httpProvider) {
        $httpProvider.interceptors.push('HttpAuthInterceptor');
        $httpProvider.interceptors.push('HttpLogInterceptor');
        $httpProvider.interceptors.push('HttpTimeoutInterceptor');
        $httpProvider.interceptors.push('HttpAnalyticsInterceptor');
    }

    //This function is used for the domain switch between linked accounts.
    function processSsoLogin($log, ssoUrl, ssoTokenKey, bmUtil, ssoToken) {
        var ssoApi = ssoUrl + '?' + ssoTokenKey + '=' + ssoToken + '&pre-created=true';
        var request = new XMLHttpRequest();
        /* A synchronous XHR is made to retrieve the long token before other calls can be successfully made.
           Future improvement: a more elegant approach is to use an asynchronous call (which is more pattern consistent)
           and use the event trigger to manually boostrap the Angular(JS) components */
        $log.info('A synchronous XHR is used to retrieve the sso long token before all other calls can be made');
        request.open('GET', ssoApi, false);
        request.send(null);
        if (request.status === 200) {
          var longToken = (JSON.parse(request.responseText)).LongToken;
          bmUtil.cookie(tokenType, null);
          bmUtil.cookie(tokenType, longToken, cookiePath);
        } else {
          $log.info('Sso login failed: ' + request.responseText);
        }
    }

    function run($window, $location, $timeout, $rootScope, $http, $translate, $log, bmUtil, authenticatedSessionData, bmAnalyticsService, ssoUrl, ssoTokenKey) {
        var ssoToken = $location.search().token;
        if (ssoToken) {
            processSsoLogin($log, ssoUrl, ssoTokenKey, bmUtil, ssoToken);
        }

        authenticatedSessionData.get().then(function(data) {
            $http.defaults.headers.common['x-company-id'] = data.bindings.ApplicationConfiguration.CompanyId;

            // DEPRECATED
            $http.defaults.headers.common['x-cobalt-security-userguid'] = data.meta.PrismGuid;
            // x-user-id will replace x-cobalt-security-userguid
            $http.defaults.headers.common['x-user-id'] = data.meta.PrismGuid;

            // DEPRECATED
            $http.defaults.headers.common['x-cobalt-security-sessionid'] = data.meta.SessionId;
            // x-session-id will replace x-cobalt-security-sessionid
            $http.defaults.headers.common['x-session-id'] = data.meta.SessionId;
        });

        logHttpReqestAnalyticsEvents($rootScope, bmAnalyticsService);

        // delay till next event loop so all initial requests have same rootGuid
        // regardless of redirection
        $timeout(function() {
            $rootScope.$on('$stateChangeSuccess', setRouteId);
            $rootScope.$on('$routeChangeSuccess', setRouteId);
        });

        // localize global http response error msg
        function localize() {
            $translate('bm.session.servererror').then(function(val) {
                globalHttpServerError.msg = val;
            });
        }
        $timeout(function() {
            localize(); // localize now (well..next cycle, to get around refresh bug)
            $rootScope.$on('bmLanguageChangeSuccess', localize); // localize on lang change
        });

        function logHttpReqestAnalyticsEvents($rootScope, bmAnalyticsService) {
            $rootScope.$on('$httpRequestEvent', function(evt, data) {
                bmAnalyticsService.track('Browser HTTP request', data);
            });
        }

        function setRouteId() {
            var uuid = bmUtil.generateUUID();
            var guid = bmUtil.generateTRMRGUID(uuid);
            // DEPRECATED
            $http.defaults.headers.common['x-cobalt-pcid'] = guid;
            // x-route-id will replace x-cobalt-pcid
            $http.defaults.headers.common['x-route-id'] = uuid;
        }

        // bootstrap a value for startup requests
        setRouteId();
    }

    // ANGULAR

    AuthenticatedSessionData.$inject = ['$q'];

    AuthenticatedSession.$inject = [
        '$window',
        '$document',
        '$log',
        '$location',
        '$q',
        '$http',
        '$rootScope',
        '$uibModal',
        'HttpLogInterceptor',
        'sessionMetadataUrl',
        'sessionMetadataUrlV2',
        'sessionBindingsUrl',
        'authWaypointUrl',
        'defaultDestinationUrl',
        'ssoUrl',
        'ssoTokenKey',
        'AuthenticatedSessionData',
        'bmUtil',
        'bmTheme',
        'bmLanguageManager',
        'bmEnvironmentConst',
        'bmEnvironment',
        'bmAccess',
        'csWebLoginUriMap'
    ];

    HttpLogInterceptor.$inject = [
        '$timeout',
        '$q',
        '$rootScope'
    ];

    HttpTimeoutInterceptor.$inject = [
        'httpTimeout'
    ];

    HttpAnalyticsInterceptor.$inject = [
        'bmUtil',
        '$rootScope'
    ];

    config.$inject = ['$httpProvider'];

    run.$inject = ['$window',
        '$location',
        '$timeout',
        '$rootScope',
        '$http',
        '$translate',
        '$log',
        'bmUtil',
        'AuthenticatedSessionData',
        'bmAnalyticsService',
        'ssoUrl',
        'ssoTokenKey'
    ];

    angular.module('bluemoon.components.session', [
        'bluemoon.components.util',
        'bluemoon.components.theme',
        'bluemoon.components.i18n',
        'pascalprecht.translate',
        'bmEnvironment',
        'bluemoon.components.analytics'
    ])

        .value('sessionMetadataUrl', '/api/security/v1/sessions')
        .value('sessionMetadataUrlV2', '/api/security/v2/sessions')
        .value('sessionBindingsUrl', '/api/security/v1/session-bindings')
        .value('ssoUrl', '/api/security/v1/sso')
        .value('authWaypointUrl', '/login/')
        .value('defaultDestinationUrl', staffDestUrl)
        .value('ssoTokenKey', 'token')
        .value('httpTimeout', 60000) // 60 seconds
        .value('csWebLoginUriMap', {
            'LOCAL': 'https://cswebdev.int.thomsonreuters.com/myaccount/login.aspx',
            'UNKNOWN': 'https://cswebdev.int.thomsonreuters.com/myaccount/login.aspx',
            'CI': 'https://cswebdev.int.thomsonreuters.com/myaccount/login.aspx',
            'DEMO': 'https://cswebdev.int.thomsonreuters.com/myaccount/login.aspx',
            'QED': 'https://cswebqa.int.thomsonreuters.com/myaccount/login.aspx',
            'PROD': 'https://cs.thomsonreuters.com/myaccount/login.aspx'
        })
        .service('AuthenticatedSession', AuthenticatedSession)
        .service('AuthenticatedSessionData', AuthenticatedSessionData)
        .provider('HttpAuthInterceptor', HttpAuthInterceptorProvider)
        .service('HttpLogInterceptor', HttpLogInterceptor)
        .service('HttpTimeoutInterceptor', HttpTimeoutInterceptor)
        .service('HttpAnalyticsInterceptor', HttpAnalyticsInterceptor)

        .config(config)
        .run(run);

})(window.angular);

/**
 * Blue Moon Components - theme module
 */
(function(angular) {
    'use strict';

    angular.module('bluemoon.components.theme', ['bluemoon.components.util'])
        .value('bmThemeCookieName', 'bmTheme')
        .value('bmThemeType', 'staff') // default to staff
        .value('bmThemeUrl', '/api/profiles/v1/themes')
        .value('bmThemeHeaderUrl', '/api/profiles/v1/themes/header')
        .service('bmTheme', Theme);

    Theme.$inject = [
        '$http',
        '$document',
        '$q',
        'bmThemeUrl',
        'bmThemeHeaderUrl',
        'bmThemeType',
        'bmUtil',
        'bmEnvironment',
        'bmThemeCookieName'
    ];

    function Theme($http, $document, $q, themeUrl, themeHeaderUrl, themeType, util, env, themeCookieName) {
        var self = this,
            promise;

        // properties
        self.data = {
            themeType: themeType
            // header: {...}
            // advert: {...}
        };
        self.useTheme = (themeType === 'client' || !!util.cookie(themeCookieName));

        // methods
        self.load = load;
        self.loadHeader = loadHeader;

        // available for theme override
        self.applyTheme = applyTheme;

        self.persistTheme = persistTheme;

        function persistTheme(companyId) {
            util.cookie(themeCookieName, companyId, '/', true);
        }

        function loadHeader(companyId, refresh) {
            return load(companyId, themeHeaderUrl, refresh);
        }

        // todo: figure out best way to differentiate staff/client/employee
        function load(params, url, refresh) {

            // todo: make sure params match the promise
            if (!refresh && promise) { return promise; }

            url = url || themeUrl;

            if (self.useTheme) {
                if (!angular.isDefined(params)) {
                    params = util.cookie(themeCookieName);
                }
                if (angular.isDefined(params)) {
                    if (typeof params !== 'object') {
                        params = { company: params }; // default to company
                    }
                    // if the response is cached refreshed data will be incorrect
                    promise = $http.get(url, { params: params });
                    promise.then(function(resp) {
                        self.data.header = resp.data;
                    });
                }
            }

            if (!promise) {
                var deferred = $q.defer();
                promise = deferred.promise;
                self.data.header = null;
                deferred.resolve({ data: self.data });
            }

            promise.then(function() {
                resolveAdvertData();
            });

            return promise;
        }

        // Note: this is something that could and maybe should be pushed behind the service
        // layer as it's biz logic that is spilling out to the client
        function resolveAdvertData() {
            var img, txt, href, useAdvert = false, country = env.getCountryCode();

            if (self.data.header) {
                txt = self.data.header.loginPageText;
                img = self.data.header.loginPageImage;
                useAdvert = !!(txt || img);
            }

            if (!self.useTheme && !txt && !img) {
                switch (country) {
                    case 'us':
                        /* NOTE: can't drive it from data due to versioning of img, supply country
                           so consumer can construct a class and declare an image path in css.
                           This should be refactored to use server-side img data which is more
                           consistent with the way we do branding logos. */
                        // img = 'components/img/synergy2015.jpg';
                        href = 'http://cs.thomsonreuters.com/SYNERGY/';
                        break;
                    case 'uk':
                        // see above coment
                        // img = 'components/img/synergy2015-gb.jpg';
                        href = 'https://www.digita.com';
                        break;
                    case 'ca':
                        // add when ready
                        break;
                }
                if (href) {
                    useAdvert = true;
                }
            }

            if (useAdvert) {
                self.data.advert = { country: country, img: img, text: txt, href: href };
            }
        }

        function applyTheme() {
            // todo: should apply theme try to load the theme first?
            var html = angular.element($document[0].documentElement);
            var colors = self.data.header ? self.data.colors : undefined;

            if (!colors) { return; }

            var head = html.find('head'),
                headerFill = normalizeHex(colors.headerFillColor),
                headerText = normalizeHex(colors.headerTextColor),
                altHeaderFill = hexToRgba('#888888', 0.2),
                //altHeaderText = (headerText === '#ffffff' ? '#ddd' : hexToRgba(headerText, 0.5)),
                buttonFill = normalizeHex(colors.buttonFillColor),
                buttonText = normalizeHex(colors.buttonTextColor),
                // todo: sanitize css values, move selectors to appropriate components?
                // try to template this as html
                style = angular.element([
                    '<style>',
                        '.btn.btn-primary {',
                            'color:', buttonText, ' !important;',
                            'background-color:', buttonFill, ' !important;',
                            'border-color:', 'rgba(0,0,0,.2) !important', ';', // ?
                        '}',
                        '.btn.btn-primary:hover {',
                            'border-color:', 'rgba(0,0,0,.4) !important', ';', // ?
                        '}',
                        '.nav-pills > li.active > a,',
                        '.nav-pills > li > a:hover,',
                        '.nav-pills > li > a:focus {',
                            'color:', buttonFill, ' !important;',
                        '}',
                        'bm-nav ul a.bm-header-active {',
                            'border-color:', buttonFill, ' !important;',
                        '}',
                        'bm-header {',
                            'background-color:', headerFill, ';',
                            'color:', headerText, ';',
                        '}',
                        'bm-header header h1 em {',
                            'color:', buttonFill, ';',
                        '}',
                        'bm-header a {',
                            'color:', headerText, ';',
                        '}',
                        'bm-header-active a > .bm-icon,',
                        'bm-header a .bm-profile-photo .initials {',
                            'border-color:', headerText, ';',
                        '}',
                        'bm-header a:focus {',
                            'color:', headerText, ';',
                        '}',
                        'bm-header a:hover > .bm-icon,',
                        'bm-header a:focus > .bm-icon,',
                        'bm-header [dropdown].open > a > .bm-icon {',
                            'border-color:', headerText, ';',
                        '}',
                        'bm-header a:hover,',
                        '.mask-active .bm-header-nav-toggle,',
                        'bm-header [dropdown].open > a {',
                            'color:', headerText, ';',
                            'background-color:', altHeaderFill, ';',
                        '}',
                        'bm-header .dropdown-menu > li > a:hover,',
                        'bm-header .dropdown-menu > li > a:focus,',
                        'bm-header .dropdown-menu > .active > a,',
                        'bm-header .dropdown-menu > .active > a:hover,',
                        'bm-header .dropdown-menu > .active > a:focus {',
                            'color:', buttonText, ' !important;',
                            'background-color:', buttonFill, ';',
                        '}',
                    '</style>'
                ].join(''));

            head.append(style);
        }
    }

    // variation on http://stackoverflow.com/a/5624139
    function normalizeHex(hex) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function(m, r, g, b) {
            return r + r + g + g + b + b;
        });
        return hex.toLowerCase();
    }
    function hexToRgba(hex, a) {
        hex = normalizeHex(hex);
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? 'rgba(' +
            parseInt(result[1], 16) + ',' +
            parseInt(result[2], 16) + ',' +
            parseInt(result[3], 16) + ',' +
            a + ')'
        : null;
    }

})(window.angular);

(function(window, angular){
    'use strict';

    var queue = new window.bmJobQueue();

    angular.module('bmJobQueue', [])
    .value('bmJobQueue', queue);
})(window, window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.passwordValidation', []);
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.passwordValidation').factory('PasswordValidationFactory', passwordValidation);
    passwordValidation.$inject = ['$q', '$translate', '$http'];

    function passwordValidation($q, $translate, $http) {
        return {
            loadPasswordRules: function() {
                var deferred = $q.defer();

                $http.get('/api/profiles/v2/password/rules', {
                            headers: { 'Accept': 'application/json' }
                }).then(function(response){

                    var pwReqs = response.data;

                    var translatePromises = [
                        $translate('bm.password.validation.characterRule'),
                        $translate('bm.password.validation.numberRule'),
                        $translate('bm.password.validation.lowerCaseRule'),
                        $translate('bm.password.validation.upperCaseRule'),
                        $translate('bm.password.validation.specialCharactersRule'),
                        $translate('bm.password.validation.containsProhibitedCharacters')
                    ];

                    $q.all(translatePromises).then(function(translations){

                        deferred.resolve(
                            {
                                charClassReq: pwReqs.classes,
                                charLengthReq: pwReqs.chars,
                                rules:
                                {
                                    characterLengthRule:
                                    {
                                        label : translations[0],
                                        test : function (password) {
                                            return password && password.length >= pwReqs.chars;
                                        }
                                    },
                                    characterTypeRules: [
                                        {
                                            label : translations[1],
                                            test : function (password) {
                                                return password && /[0-9]/.test(password);
                                            }
                                        },
                                        {
                                            label : translations[2],
                                            test : function (password) {
                                                return password && /[a-z]/.test(password);
                                            }
                                        },
                                        {
                                            label : translations[3],
                                            test : function (password) {
                                                return password && /[A-Z]/.test(password);
                                            }
                                        },
                                        {
                                            label : translations[4] + ' ` ~ ! @ # $ £ % ^ & * ( ) _ - + = { } [ ] \\ | : ; " \' , . ? /',
                                            test : function (password) {
                                                return password && /[`~\!@#\$£%\^&\*\(\)_\-+={}\[\]\\\|:;\"\',\.\?]+/.test(password);
                                            }
                                        }
                                    ],
                                    prohibitedCharacterRule:
                                    {
                                        label : translations[5],
                                        test : function (password) {
                                            return password && /[^a-zA-Z0-9`~/\\\[\]+=|(){}:;'"<>,.?!@#$%^&*\-_¡¢£¤¥´ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]/.test(password);
                                        },
                                        getInvalidChars : function (password) {
                                            var matches = new Set();
                                            var pattern = /[^a-zA-Z0-9`~/\\\[\]+=|(){}:;'"<>,.?!@#$%^&*\-_¡¢£¤¥´ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]/g;
                                            var match = pattern.exec(password);

                                            while(match){
                                                matches.add(match[0]);
                                                match = pattern.exec(password);
                                            }
                                            return Array.from(matches);
                                        }

                                    }
                                }
                            }
                        );
                    });
                });

                return deferred.promise;
            }
        };
    }
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.passwordValidation').directive('bmPasswordValidation', passwordValidation);
    passwordValidation.$inject = ['PasswordValidationFactory'];

    function passwordValidation(PasswordValidationFactory) {
        return {
            restrict: 'EA',
            templateUrl: 'components/password-validation/password-validation.2js.html',
            scope: {
                password: '=password'
            },
            controller: ['$scope', function ($scope) {
                PasswordValidationFactory.loadPasswordRules().then(function (resp) {
                    angular.extend($scope, resp);
                });
            }]
        };
    }
}(window.angular));

(function(angular) {
    'use strict';

    angular.module('bluemoon.components.bluemoonRequiredMark', ['pascalprecht.translate'])
        .filter('bluemoonRequiredMark', bluemoonRequiredMark)
        .filter('bmRequiredMark', bluemoonRequiredMark);

    bluemoonRequiredMark.$inject = ['$translate'];
    function bluemoonRequiredMark($translate) {
        return function(input, makeRequired) {
            if(typeof makeRequired === 'undefined' || makeRequired === null) {
                makeRequired = true;
            }
            if(angular.isFunction(input)) {
                input = input();
            }
            if (!makeRequired) {
                return input;
            }
            return $translate.instant(
                'Bluemoon.Components.BluemoonRequiredMark.RequiredFieldLabel',
                { 'n0': input });
        };
    }
}(window.angular));

/// <reference path="~/bower_components/angular/angular.js" />
(function(angular) {
    'use strict';
    var module = angular.module('bluemoon.components.ConfirmNavigationController', []);
    module.controller('bluemoon.components.ConfirmNavigationController',
        ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
            $scope.ok = function() {
                //alert("ok clicked");
                $uibModalInstance.close(false);
            };

            $scope.save = function() {
                //alert("save clicked");
                $uibModalInstance.close(true);
            };

            $scope.cancel = function() {
                //alert("cancel clicked");
                $uibModalInstance.dismiss('cancel');
            };
        }]);

}(window.angular));

/// <reference path="~/bower_components/angular/angular.js" />
(function(angular) {
    'use strict';
    angular.module('bluemoon.components.SaveInProgressModalController', [])
        .controller('bluemoon.components.SaveInProgressModalController',
    [
        '$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
            $scope.cancel = function() {
                $uibModalInstance.dismiss('cancel');
            };
        }
    ]);

}(window.angular));

(function(window, angular, Rx) {
    'use strict';
    // this service is based on this article:
    // http://markcampbell.me/tutorial/2013/10/08/preventing-navigation-in-an-angularjs-project.html
    var NavigationUtils = (function() {
        var _$inject = [
            '$injector',
            '$rootScope',
            '$location',
            '$log',
            '$uibModal',
            'fef.Utils',
            'fef.PromiseUtils',
            '$translate'
        ];

        function NavigationUtilsImpl(
            $injector,
            $rootScope,
            $location,
            $log,
            $uibModal,
            utils,
            promiseUtils,
            $translate) {

            var preventNavigation = false;
            var preventNavigationUrl = null;
            var dialogOpen = false;
            var onSaveFunc = null;
            var _promise = null;
            var _assumeSave = false;
            var $state = $injector.has('$state') ? $injector.get('$state') : null;

            this.allowNavigation = function() {
                preventNavigation = false;
                onSaveFunc = null;
                // don't modify onbeforeunload event while unit testing
                if(!utils.exists(angular.mock)) {
                    window.onbeforeunload = null;
                }
            };

            this.preventNavigation = function(saveFunc, assumeSave) {
                var self = this;
                if(utils.exists(saveFunc) && !angular.isFunction(saveFunc)) {
                    throw new Error('NavigationUtils.preventNavigation: invalid argument saveFunc. Was expecting a function or null/undefined.');
                }

                if(!utils.exists(assumeSave)) {
                    assumeSave = false;
                }
                _assumeSave = assumeSave;
                onSaveFunc = saveFunc;
                preventNavigation = true;
                preventNavigationUrl = $location.absUrl();
                // don't modify onbeforeunload event while unit testing
                if(!utils.exists(angular.mock)) {
                    window.onbeforeunload = function(e) {
                        var ret = self.handleOnBeforeUnload(e);
                        e.returnValue = ret;
                        return ret;
                    };
                }
            };

            /**
             * Captures the required information prior to preventing a state change so it can be re-issued at a later date
             */
            this.pauseStateChange = function (toState, toParams, fromState, fromParams) {
                return {
                    toState: toState ? toState.name : undefined,
                    toParams: toParams ? angular.copy(toParams) : {},
                    fromState: fromState ? fromState.name : undefined,
                    fromParams: fromParams ? angular.copy(fromParams) : {},
                };
            };

            /**
             * Continues a state change that was previously prevented (usually whilst another process such as saving takes place before navigating away)
             */
            this.continueStateChange = function ($state, stateChange) {

                // When working with multiple levels, the id parameter will need to be specified to avoid conflict (e.g. id -> childId -> grandChildId)
                var idStateParam = $state.params.idParam || 'id';

                if(
                    /* originally coming from a 'new' item */
                    stateChange.fromParams[idStateParam] === 'new' &&
                    /* going to a 'new' item */
                    stateChange.toParams[idStateParam] === 'new' &&
                    /* the current state has been updated with an id that is not 'new' (i.e. has been saved) */
                    $state.params[idStateParam] !== 'new' &&
                    /* VERY SPECIFIC: when going to a different state (to avoid a situation such as 'Save & New' updating the id incorrectlly) */
                    stateChange.toState !== stateChange.fromState &&
                    /* VERY SPECIFIC: when coming from the 'general' tab */
                    stateChange.fromState.substr(stateChange.fromState.length - 8, 8) === '.general' &&
                    /* VERY SPECIFIC: when going to a sibling or child state */
                    stateChange.toState.substr(0, stateChange.fromState.length - 8) === stateChange.fromState.substr(0, stateChange.fromState.length - 8)
                    ) {
                    // Update the params to include the newly saved item id
                    stateChange.toParams[idStateParam] = $state.params[idStateParam];
                }

                $state.go(stateChange.toState, stateChange.toParams);

            };

            /**
             * DEPRECATED. Pass a saveFunc to preventNavigation instead.
             */
            this.setPromise = function(promise) {
                _promise = promise;
            };

            var locationChangeStartSubject = new Rx.ReplaySubject(1);
            /**
             * DEPRECATED (probably)
             */
            this.locationChangeStart = function() {
                return this.locationChangeStartSubject.asObservable();
            };

            if(typeof $state !== 'undefined' && $state !== null) {
                this.handleStateChangeStart = function(event, toState, toParams, fromState, fromParams) {
                    var self = this;
                    // tried to navigate while the dialog is open. go ahead and prevent it.
                    // User must dismiss the dialog before continuing.
                    // We only want one dialog at a time. This might catch a double click on
                    // the back button, for instance.
                    if(dialogOpen) {
                        event.preventDefault();
                        return;
                    }

                    if(preventNavigation) {
                        event.preventDefault();
                        dialogOpen = true;
                        var modalInstance;
                        // Capture the parts of the state change that we paused so it can be continued later
                        var pausedStateChange = self.pauseStateChange(toState, toParams, fromState, fromParams);
                        var finishNavigation = function() {
                            dialogOpen = false;
                            preventNavigation = false;
                            // Continue the paused state change
                            self.continueStateChange($state, pausedStateChange);
                        };

                        if(_assumeSave) {
                            if(utils.exists(_promise)) {
                                throw new Error('NavigationUtils.handleStateChangeStart: setting the promise not supported when assumeSave is set to true.');
                            }

                            if(!utils.exists(onSaveFunc)) {
                                throw new Error('NavigationUtils.handleLocationChangeStart: was expecting onSaveFunc to be a function.');
                            }
                            var savePromise = onSaveFunc();
                            savePromise['finally'](function() {
                                dialogOpen = false;
                            });

                            return savePromise.then(function() {
                                finishNavigation();
                            });
                        } else {
                            if(_promise !== null) {
                                modalInstance = $uibModal.open({
                                    templateUrl: 'components/navigation-utils/save-in-progress-modal.2js.html',
                                    controller: 'bluemoon.components.SaveInProgressModalController'
                                });
                                modalInstance.result.then(function() {

                                })['finally'](function() {
                                    dialogOpen = false;
                                });

                                return _promise.then(
                                    function() { // success
                                        modalInstance.dismiss('cancel');
                                        finishNavigation();
                                    },
                                    function() { // error
                                        modalInstance.opened.then(function() {
                                            modalInstance.dismiss('cancel');
                                        });
                                    }
                                );

                            } else {
                                modalInstance = $uibModal.open({
                                    templateUrl: 'components/navigation-utils/confirm-navigation.2js.html',
                                    controller: 'bluemoon.components.ConfirmNavigationController'
                                });
                                modalInstance.result.then(function(saveClicked) {
                                    if(saveClicked) {
                                        if(!utils.exists(onSaveFunc)) {
                                            throw new Error('NavigationUtils.handleLocationChangeStart: was expecting onSaveFunc to be a function.');
                                        }
                                        return onSaveFunc().then(function() {
                                            finishNavigation();
                                        });
                                    } else {
                                        finishNavigation();
                                    }
                                    return promiseUtils.resolvedPromise();
                                })['finally'](function() {
                                    dialogOpen = false;
                                });
                            }
                        }
                    } else {
                        self.allowNavigation();
                    }
                };
            }

            /**
             * DEPRECATED. Use handleStateChangeStart for now.
             */
            this.handleLocationChangeStart = function(event, next, current) {
                var self = this;
                if(_assumeSave) {
                    throw new Error('NavigationUtils.handleLocationChangeStart: assumeSave option not yet supported. Use handleStateChangeStart instead.');
                }
                locationChangeStartSubject.onNext({
                    event: event,
                    next: next,
                    current: current
                });

                // tried to navigate while the dialog is open. go ahead and prevent it.
                // User must dismiss the dialog before continuing.
                // We only want one dialog at a time. This might catch a double click on
                // the back button, for instance.
                if(dialogOpen) {
                    event.preventDefault();
                    return;
                }

                if(preventNavigationUrl !== current || preventNavigationUrl === null) {
                    self.allowNavigation();
                    return;
                }

                if(preventNavigation) {
                    event.preventDefault();
                    dialogOpen = true;
                    var modalInstance;

                    var finishNavigation = function() {
                        preventNavigation = false;
                        var indexOfUrl = $location.absUrl().indexOf($location.url(), 0);
                        var newUrl = next.substr(indexOfUrl, next.length - indexOfUrl);
                        $location.url(newUrl);
                    };

                    if (_promise !== null) {
                        modalInstance = $uibModal.open({
                            templateUrl: 'components/navigation-utils/save-in-progress-modal.2js.html',
                            controller: 'bluemoon.components.SaveInProgressModalController'
                        });
                        modalInstance.result.then(function() {

                        })['finally'](function() {
                            dialogOpen = false;
                        });

                        return _promise.then(
                            function() { // success
                                modalInstance.dismiss('cancel');
                                finishNavigation();
                            },
                            function() { // error
                                modalInstance.opened.then(function() {
                                    modalInstance.dismiss('cancel');
                                });
                            }
                        );

                    } else {
                        modalInstance = $uibModal.open({
                            templateUrl: 'components/navigation-utils/confirm-navigation.2js.html',
                            controller: 'bluemoon.components.ConfirmNavigationController'
                        });
                        modalInstance.result.then(function(saveClicked) {
                            if (saveClicked) {
                                if (!utils.exists(onSaveFunc)) {
                                    throw new Error('NavigationUtils.handleLocationChangeStart: was expecting onSaveFunc to be a function.');
                                }
                                return onSaveFunc().then(function() {
                                    finishNavigation();
                                });
                            } else {
                                finishNavigation();
                            }
                            return promiseUtils.resolvedPromise();
                        })['finally'](function() {
                            dialogOpen = false;
                        });
                    }
                } else {
                    self.allowNavigation();
                }
            };

            this.handleOnBeforeUnload = function(e) {
                // What should we do if the dialog is already open?
                // probably still bring up the browser dialog over the top of it.
                if(preventNavigation && $location.absUrl() === preventNavigationUrl) {
                    e.returnValue = $translate.instant('Bluemoon.Components.NavigationUtils.ConfirmNavigation.BrowserMessage');
                    return e.returnValue;
                }
                e.preventDefault();
            };

            /**
             * Intended to be called on $stateChangeStart in an application. It will look for a redirectTo property on a state
             * object which is a string indicating the name of another state which should be redirected to instead of loading the first state.
             * One use case for this is where we had a state previously and then introduced child states and we want to make
             * the parent state redirect to a child as the default state if you try to go to the parent.
             **/
            this.useRedirectToIfPresentOnState = function(event, toState, toParams){
                if (toState.redirectTo) {
                    event.preventDefault();

                    // location: 'replace' will "update url and also replace last history record",
                    // which fixes a bug where the back button gets stuck on redirected pages.
                    $state.go(toState.redirectTo, toParams, {location: 'replace'});
                }
            };
        }
        NavigationUtilsImpl.$inject = _$inject;
        return NavigationUtilsImpl;
    }());

    angular.module('bluemoon.components.NavigationUtils', [
        'fef',
        'ui.bootstrap.modal',
        'pascalprecht.translate',
        'bluemoon.components.ConfirmNavigationController',
        'bluemoon.components.SaveInProgressModalController'
    ]).service('bluemoon.components.NavigationUtils', NavigationUtils);

}(window, window.angular, window.Rx));

(function() {
    'use strict';
    var ValidationUtils = (function() {
        function ValidationUtils($parse, $q, $translate, utils, notifications) {
            this.$parse = $parse;
            this.$q = $q;
            this.$translate = $translate;
            this.utils = utils;
            this.notifications = notifications;
        }
        ValidationUtils.prototype.processValidationErrors = function(data, response) {
            if(!this.utils.exists(response)) {
                throw new Error('bmValidationUtils: response is required.');
            }
            if(!this.utils.exists(response.error) || !this.utils.exists(response.error.errors) || !this.utils.exists(data)) {
                return;
            }
            for(var i = 0; i < response.error.errors.length; i++) {
                var error = response.error.errors[i];
                // following the JsonPath root object convention.

                var errorParentObject = this.$parse(error.location)({ '$': data });
                if (!this.utils.exists(errorParentObject)) {
                    console.error('Provided error location did not match data. error[' + i + '].location: ' + error.location + ' data: ' + JSON.stringify(data));
                    continue;
                }
                this.setErrorForField(errorParentObject, error.locationField, error);
            }
        };

        ValidationUtils.prototype.getErrorForField = function(data, fieldName) {
            if(!this.utils.stringIsNonBlank(fieldName)) {
                throw new Error('bmValidationUtils.getErrorForField: fieldName is required');
            }
            if(this.utils.exists(data) && this.utils.exists(data.$error)) {
                var fieldError = data.$error[fieldName];
                if(this.utils.exists(fieldError)) {
                    return fieldError.message;
                }
            }
            return '';
        };
        ValidationUtils.prototype.setErrorForField = function (data, fieldName, error) {
            if (angular.isString(error)) {
                error = { message: error };
            }
            if(!this.utils.exists(data.$error)) {
                data.$error = {};
            }
            if(fieldName) {
                data.$error[fieldName] = error;
            } else {
                data.$error.$row = error;
            }
        };

        ValidationUtils.prototype.clearErrorForField = function(data, fieldName) {
            if(!this.utils.stringIsNonBlank(fieldName)) {
                throw new Error('bmValidationUtils.clearErrorForField: fieldName is required');
            }
            if(this.utils.exists(data) && this.utils.exists(data.$error)) {
                data.$error[fieldName] = undefined;
            }
        };

        ValidationUtils.prototype.clearErrors = function(request) {
            for(var field in request) {
                if(request.hasOwnProperty(field)) {
                    if(field === '$error') {
                        request[field] = undefined;
                    } else {
                        var val = request[field];
                        if(val !== null && typeof val === 'object') {
                            this.clearErrors(val);
                        }
                    }
                }
            }
        };

        ValidationUtils.prototype.processErrors = function(data, errorResult, suppressErrors) {
            var error = null;
            var showError = suppressErrors ? false : true;

            if(data === null && errorResult.status === -1) {
                // This occurs when the service is too slow
                error = this.$translate.instant('Bluemoon.Components.ValidationUtils.NoResponseError');
                // Disable the generic "A server error occurred" message.
                errorResult.config.global = false;
            } else if(typeof errorResult === 'string') {
                // error is a plain string, assume that's the error to display?
                error = errorResult;
            } else if (this.utils.exists(errorResult) && this.utils.exists(errorResult.data) && this.utils.exists(errorResult.status) && this.utils.exists(errorResult.headers) && typeof errorResult.headers === 'function' && errorResult.status !== 401 && errorResult.status !== 403 && (errorResult.status < 500 || errorResult.status >= 600)) {
                // Disable the generic "A server error occurred" message.
                errorResult.config.global = false;

                // it's probably an http error. Authorization related errors are handled
                // elsewhere, and result in a redirection, so we don't do anything here for those
                var headers = errorResult.headers();
                var contentType = headers['content-type'];
                contentType = contentType || headers['Content-Type'];
                contentType = contentType || headers['CONTENT-TYPE'];
                if(!this.utils.exists(contentType) || contentType.indexOf('application/json') < 0) {
                    error = errorResult.statusText;
                } else {
                    if(typeof errorResult.data === 'object') {
                        // it's an object, so for now assume it's a validation
                        // error and process it directly.
                        this.processValidationErrors(data, errorResult.data);
                        if(this.utils.exists(errorResult.data.error) && this.utils.exists(errorResult.data.error.message)) {
                            error = errorResult.data.error.message;
                        }
                    } else if(typeof errorResult.data === 'string') {
                        error = errorResult.data;
                    }
                }
            } else {
                showError = false;
            }
            if(!this.utils.stringIsNonBlank(error)) {
                error = this.$translate.instant('Bluemoon.Components.ValidationUtils.GenericValidationError');
            }
            if(showError) {
                this.notifications.setError(error);
            }
        };

        ValidationUtils.prototype.errorForFunc = function() {
            var _this = this;
            return function(data, fieldName) {
                return _this.getErrorForField(data, fieldName);
            };
        };

        ValidationUtils.prototype.clearErrorForFunc = function() {
            var _this = this;
            return function(data, fieldName) {
                _this.clearErrorForField(data, fieldName);
            };
        };

        ValidationUtils.prototype.validatePromise = function(data, promise, suppressErrors) {
            var _this = this;
            return promise.then(function(value) {
                if(_this.utils.exists(data) && _this.utils.exists(value)) {
                    var rawData = data;
                    rawData.id = value.id;
                    rawData.created = value.created;
                    rawData.updated = value.updated;
                    rawData.deleted = value.deleted;
                }
                return value;
            }, function(error) {
                _this.processErrors(data, error, suppressErrors);
                return _this.$q.reject(error);
            });
        };
        ValidationUtils.$inject = ['$parse', '$q', '$translate', 'fef.Utils', 'bluemoon.components.Notifications'];
        return ValidationUtils;
    })();
    angular.module('bmValidationUtils', [
        'fef',
        'pascalprecht.translate',
        'bluemoon.components.Notifications'
    ]).service('bmValidationUtils', ValidationUtils);
})();

(function() {
    'use strict';
    var HttpUtils = (function() {
        function HttpUtils($q, utils, bmValidationUtils) {
            this.$q = $q;
            this.utils = utils;
            this.bmValidationUtils = bmValidationUtils;
        }
        HttpUtils.prototype.getDataFromHttpResponse = function(response) {
            if(this.utils.exists(response)) {
                if(this.utils.exists(response.status) && response.status >= 400) {
                    return this.$q.reject(response);
                }
                if(this.utils.exists(response.data)) {
                    return response.data;
                } else {
                    return null;
                }
            }
            return null;
        };
        HttpUtils.prototype.unwrapHttpPromise = function(promise) {
            var _this = this;
            return promise.then(function(response) { return _this.getDataFromHttpResponse(response); });
        };
        HttpUtils.prototype.unwrapAndValidateHttpPromise = function(data, promise, suppressErrors) {
            return this.bmValidationUtils.validatePromise(data, this.unwrapHttpPromise(promise), suppressErrors);
        };
        HttpUtils.prototype.getStrippedObject = function(resource, prefix, suffix) {
            var _this = this;
            if(!this.utils.exists(resource) || typeof resource !== 'object') {
                return resource;
            }
            if(!this.utils.exists(prefix)) {
                prefix = '$';
            }
            if(!this.utils.exists(suffix)) {
                suffix = 'Expanded';
            }
            var _prefix = prefix.replace(/\$/g, '\\$');
            var _suffix = suffix.replace(/\$/g, '\\$');
            var copy = angular.copy(resource);
            var prefixRegex = new RegExp('^' + _prefix + '.+$', 'g');
            var suffixRegex = new RegExp('^.+' + _suffix + '$', 'g');
            Object.keys(resource).forEach(function(propertyName) {
                var property = resource[propertyName];
                var acopy = copy;
                if((angular.isString(propertyName) && _this.utils.stringIsNonBlank(_prefix) && propertyName.match(prefixRegex)) || (angular.isString(propertyName) && _this.utils.stringIsNonBlank(_suffix) && propertyName.match(suffixRegex))) {
                    delete acopy[propertyName];
                } else if(typeof property === 'object') {
                    acopy[propertyName] = _this.getStrippedObject(property, prefix, suffix);
                }
            });
            return copy;
        };
        HttpUtils.$inject = [
            '$q',
            'fef.Utils',
            'bmValidationUtils'
        ];
        return HttpUtils;
    })();
    angular.module('bmHttpUtils', [
        'fef',
        'bmValidationUtils'
    ]).service('bmHttpUtils', HttpUtils);
})();

(function(window, angular, Rx) {
    'use strict';

    var Alert = (function() {
        function AlertImpl(type, message) {
            if(type !== 'error' && type !== 'info' && type !== 'success') {
                throw new Error('bluemoon.components.Alert: error type must be either \'error\' or \'info\'.');
            }
            if(!angular.isString(message)) {
                throw new Error('bluemoon.components.Alert: error message must be a string');
            }
            this.type = type;
            this.message = message;
        }

        AlertImpl.isAlert = function(obj) {
            return typeof obj === 'undefined' || obj === null ||
                (angular.isObject(obj) &&
                angular.isString(obj.type) &&
                (obj.type === 'error' || obj.type === 'info' || obj.type === 'success') &&
                angular.isString(obj.message));
        };

        return AlertImpl;
    }());

    var Toast = (function() {
        function ToastImpl(message) {
            this.message = message;
        }

        ToastImpl.isToast = function(obj) {
            return angular.isObject(obj) && angular.isString(obj.message);
        };

        return ToastImpl;
    }());

    var Notifications = (function() {
        var _$inject = ['fef.SanityChecks', 'fef.Utils'];
        function NotificationsImpl(sanityChecks, utils) {
            /// <param name="sanityChecks" type="fef.SanityChecks" />
            /// <param name="utils" type="fef.Utils" />
            sanityChecks.checkConstructorUsage(this, NotificationsImpl);
            var self = this;

            /** @private */
            this._utils = utils;

            // I'm not using a caching subject here instead of a field pair,
            // because this is just a simple service.

            /** @private */
            this._alert = null;
            /** @private */
            this._alertStream = new Rx.Subject();
            this._alertStream.subscribe(function(alert) {
                self._alert = alert;
            });

            /** @private */
            this._toastStream = new Rx.Subject();
        }
        NotificationsImpl.$inject = _$inject;

        /**
         * Constructor function for an Alert.
         */
        NotificationsImpl.prototype.Alert = Alert;

        /**
         * Constructor function for a Toast.
         */
        NotificationsImpl.prototype.Toast = Toast;

        /**
         * Set the global alert. Replaces any existing message. Subscribers
         * to the error stream will be notified that the error message changed.
         * @param {Alert} alert The message to set, or null/undefined to clear the error.
         */
        NotificationsImpl.prototype.setAlert = function(alert) {
            if(!Alert.isAlert(alert)) {
                throw new Error('bluemoon.components.Notifications: alert object was badly formed.');
            }
            this._alertStream.onNext(angular.copy(alert));
        };

        /**
         * Set the global error alert. Replaces the existing error or info alert.
         * Subscribers to the alert stream will be notified that the alert changed.
         * @param {string} errorMessage The error message, or null/undefined to clear the alert.
         */
        NotificationsImpl.prototype.setError = function(errorMessage) {
            if(this._utils.exists(errorMessage) && !angular.isString(errorMessage)) {
                throw new Error('Notifications.setError: errorMessage must be a string.');
            }
            if(!this._utils.stringIsNonBlank(errorMessage)) {
                this._alertStream.onNext(null);
            } else {
                this._alertStream.onNext(new Alert('error', errorMessage));
            }
        };

        /**
         * Set the global info alert. Replaces the existing error or info alert.
         * Subscribers to the alert stream will be notified that the alert changed.
         * @param {string} infoMessage The info message, or null/undefined to clear the alert.
         */
        NotificationsImpl.prototype.setInfo = function(infoMessage) {
            if(this._utils.exists(infoMessage) && !angular.isString(infoMessage)) {
                throw new Error('Notifications.setInfo: infoMessage must be a string.');
            }
            if(!this._utils.stringIsNonBlank(infoMessage)) {
                this._alertStream.onNext(null);
            } else {
                this._alertStream.onNext(new Alert('info', infoMessage));
            }
        };

        /**
         * Set the global info alert. Replaces the existing error, info or success alert.
         * Subscribers to the alert stream will be notified that the alert changed.
         * @param {string} successMessage The success message, or null/undefined to clear the alert.
         */
        NotificationsImpl.prototype.setSuccess = function(successMessage) {
            if(this._utils.exists(successMessage) && !angular.isString(successMessage)) {
                throw new Error('Notifications.setSuccess: successMessage must be a string.');
            }
            if(!this._utils.stringIsNonBlank(successMessage)) {
                this._alertStream.onNext(null);
            } else {
                this._alertStream.onNext(new Alert('success', successMessage));
            }
        };

        /**
         * Gets the current alert.
         * @returns {Alert}
         */
        NotificationsImpl.prototype.getAlert = function() {
            return angular.copy(this._alert);
        };

        /**
         * Gets the event stream for changes to the error message.
         * @returns {Rx.Observable}
         * @example
         * var subscription = notifications.errorStream().subscribe(function(errorMessage) {
         *   alert('Error: ' + errorMessage);
         * });
         */
        NotificationsImpl.prototype.alertStream = function() {
            return this._alertStream.asObservable();
        };

        /**
         * An event stream of 'error' type alerts.
         * @returns {Rx.Observable} Observable of Alert objects.
         */
        NotificationsImpl.prototype.errorAlertStream = function() {
            var self = this;
            return self.alertStream().filter(function(alert) {
                return self._utils.exists(alert) && alert.type === 'error';
            });
        };

        /**
         * An event stream of 'info' type alerts.
         */
        NotificationsImpl.prototype.infoAlertStream = function() {
            var self = this;
            return this.alertStream().filter(function(alert) {
                return self._utils.exists(alert) && alert.type === 'info';
            });
        };

        /**
         * Add a new toast object to the list. Any subscribers to the toast
         * stream will be notified that a new toast was added.
         * @param {Object} toastObj The new toast object. TODO: define this interface?
         */
        NotificationsImpl.prototype.addToast = function(toastObj) {
            if(!Toast.isToast(toastObj)) {
                throw new Error('Notifications.addToast: toastObject was badly formed.');
            }
            this._toastStream.onNext(angular.copy(toastObj));
        };

        /**
         * Event stream representing new toasts as they are added.
         * @example
         * var subscription = notifications.toastStream().subscribe(function(toast) {
         *   alert('toast: ' + toast);
         * });
         */
        NotificationsImpl.prototype.toastStream = function() {
            return this._toastStream.asObservable();
        };

        return NotificationsImpl;
    }());

    angular.module('bluemoon.components.Notifications', ['fef']).service('bluemoon.components.Notifications',
        Notifications);

}(window, window.angular, window.Rx));

(function(angular) {
    'use strict';

    var httpStatusCodes = {
        'continue'                        : 100, // [RFC7231,Section6.2.1]
        'switchingProtocols'              : 101, // [RFC7231,Section6.2.2]
        'processing'                      : 102, // [RFC2518]
        'ok'                              : 200, // [RFC7231,Section6.3.1]
        'created'                         : 201, // [RFC7231,Section6.3.2]
        'accepted'                        : 202, // [RFC7231,Section6.3.3]
        'nonAuthoritativeInformation'     : 203, // [RFC7231,Section6.3.4]
        'noContent'                       : 204, // [RFC7231,Section6.3.5]
        'resetContent'                    : 205, // [RFC7231,Section6.3.6]
        'partialContent'                  : 206, // [RFC7233,Section4.1]
        'multiStatus'                     : 207, // [RFC4918]
        'alreadyReported'                 : 208, // [RFC5842]
        'imUsed'                          : 226, // [RFC3229]
        'multipleChoices'                 : 300, // [RFC7231,Section6.4.1]
        'movedPermanently'                : 301, // [RFC7231,Section6.4.2]
        'found'                           : 302, // [RFC7231,Section6.4.3]
        'seeOther'                        : 303, // [RFC7231,Section6.4.4]
        'notModified'                     : 304, // [RFC7232,Section4.1]
        'useProxy'                        : 305, // [RFC7231,Section6.4.5]
        'temporaryRedirect'               : 307, // [RFC7231,Section6.4.7]
        'permanentRedirect'               : 308, // [RFC7238]
        'badRequest'                      : 400, // [RFC7231,Section6.5.1]
        'unauthorized'                    : 401, // [RFC7235,Section3.1]
        'paymentRequired'                 : 402, // [RFC7231,Section6.5.2]
        'forbidden'                       : 403, // [RFC7231,Section6.5.3]
        'notFound'                        : 404, // [RFC7231,Section6.5.4]
        'methodNotAllowed'                : 405, // [RFC7231,Section6.5.5]
        'notAcceptable'                   : 406, // [RFC7231,Section6.5.6]
        'proxyAuthenticationRequired'     : 407, // [RFC7235,Section3.2]
        'requestTimeout'                  : 408, // [RFC7231,Section6.5.7]
        'conflict'                        : 409, // [RFC7231,Section6.5.8]
        'gone'                            : 410, // [RFC7231,Section6.5.9]
        'lengthRequired'                  : 411, // [RFC7231,Section6.5.10]
        'preconditionFailed'              : 412, // [RFC7232,Section4.2]
        'payloadTooLarge'                 : 413, // [RFC7231,Section6.5.11]
        'uriTooLong'                      : 414, // [RFC7231,Section6.5.12]
        'unsupportedMediaType'            : 415, // [RFC7231,Section6.5.13]
        'requestedRangeNotSatisfiable'    : 416, // [RFC7233,Section4.4]
        'expectationFailed'               : 417, // [RFC7231,Section6.5.14]
        'unprocessableEntity'             : 422, // [RFC4918]
        'locked'                          : 423, // [RFC4918]
        'failedDependency'                : 424, // [RFC4918]
        'upgradeRequired'                 : 426, // [RFC7231,Section6.5.15]
        'preconditionRequired'            : 428, // [RFC6585]
        'tooManyRequests'                 : 429, // [RFC6585]
        'requestHeaderFieldsTooLarge'     : 431, // [RFC6585]
        'internalServerError'             : 500, // [RFC7231,Section6.6.1]
        'notImplemented'                  : 501, // [RFC7231,Section6.6.2]
        'badGateway'                      : 502, // [RFC7231,Section6.6.3]
        'serviceUnavailable'              : 503, // [RFC7231,Section6.6.4]
        'gatewayTimeout'                  : 504, // [RFC7231,Section6.6.5]
        'httpVersionNotSupported'         : 505, // [RFC7231,Section6.6.6]
        'variantAlsoNegotiates'           : 506, // [RFC2295]
        'insufficientStorage'             : 507, // [RFC4918]
        'loopDetected'                    : 508, // [RFC5842]
        'notExtended'                     : 510, // [RFC2774]
        'networkAuthenticationRequired'   : 511  // [RFC6585]
    };
    angular.module('bluemoon.components.httpStatusCodes', [])
        .constant('bluemoon.components.httpStatusCodes', httpStatusCodes);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmHttpCache', [])
    .factory('bmHttpCacheHelper', bmHttpCacheHelper)
    .config(configInterceptor);

    /////////

    bmHttpCacheHelper.$inject = ['$cacheFactory'];

    // bmCache config value is time in milliseconds
    // clear cache, pass with value as 0 or less
    // can specifically call clear cache method
    function bmHttpCacheHelper($cacheFactory){
        var lookup = {};

        return {
            request: checkRequest,
            response: checkResponse,
            invalidateHttpCache: invalidateHttpCache
        };

        /////////

        function checkRequest(conf){
            // not setting the config cache property will result in a fresh request and the
            // response will not affect the value stored in cache. any subsequent requests that set
            // set the config cache property will receive what was stored in cache. consumers must
            // invalidate the cache as necessary in order to not receive stale data.

            // would conf really ever be undefined?
            if(!conf){
                return conf;
            }

            // only cache GET requests and those that specify bmCache
            // would method really ever be undefined?
            if((conf.method && conf.method.toUpperCase() !== 'GET') || angular.isUndefined(conf.bmCache)){
                return cleanRequestConfig(conf);
            }

            var httpDefaultCache = $cacheFactory.get('$http');
            var cacheVal = httpDefaultCache.get(conf.url);

            // always opting in to store response in cache if bmCache is defined in http config
            conf.cache = true;

            // no response stored in cache yet so move on
            // the response will be stored in cache
            if(!cacheVal){
                return conf;
            }

            // do we have a stale cached value?
            var timeNow = Date.now();
            var cachedTime = lookup[conf.url];

            // difference between the time now and the cached time greater than the stale interval
            // or the stale interval is being reset specifically
            if(angular.isUndefined(cachedTime) ||  conf.bmCache <= 0 || ((timeNow - cachedTime) > conf.bmCache)){
                invalidateHttpCache(conf.url);
            }

            // the response will be stored in cache
            return conf;
        }

        function checkResponse(resp){
            // track the initial date/time of when response was put into cache
            // this is not a running cache timer
            if(resp && resp.config && resp.config.bmCache && !lookup[resp.config.url]){
                lookup[resp.config.url] = Date.now();
            }

            return resp;
        }

        // allow for invalidating cache brute force
        function invalidateHttpCache(url){
            if(!url){
                return;
            }

            var httpDefaultCache = $cacheFactory.get('$http');
            var cacheVal = httpDefaultCache.get(url);

            // remove from http cache
            if(cacheVal){
                httpDefaultCache.remove(url);
            }

            // remove from hash lookup
            if(lookup[url]){
                delete lookup[url];
            }
        }

        function cleanRequestConfig(conf){
            if(conf && conf.bmCache){
                delete conf.bmCache;
            }

            return conf;
        }
    }

    ///////////

    configInterceptor.$inject = ['$httpProvider'];

    function configInterceptor($httpProvider){
        $httpProvider.interceptors.push('bmHttpCacheHelper');
    }
})(window.angular);

angular.module('bluemoon.components.templates', ['components/bm-image-upload-modal/bm-image-upload-modal.2js.html', 'components/bm-user-availability/bm-user-availability.2js.html', 'components/checkpoint-engage/checkpoint-engage.2js.html', 'components/client-notifications/client-notifications-list.2js.html', 'components/header/bm-staff-header.2js.html', 'components/header/documents-header-button.2js.html', 'components/header/header.2js.html', 'components/header/timer-header-button.2js.html', 'components/help/help.2js.html', 'components/i18n/language-select.2js.html', 'components/linked-accounts/linked-accounts-dialog.2js.html', 'components/linked-accounts/linked-accounts.2js.html', 'components/main/main.2js.html', 'components/modal/modal-base.2js.html', 'components/modal/modal-default.2js.html', 'components/multi-factor-user/multi-factor-user-settings.2js.html', 'components/multi-factor-user/multi-factor-user.2js.html', 'components/multi-factor/multi-factor-profile-modal.2js.html', 'components/multi-factor/multi-factor-profile.2js.html', 'components/nav/nav.2js.html', 'components/navigation-utils/confirm-navigation.2js.html', 'components/navigation-utils/save-in-progress-modal.2js.html', 'components/not-found/bm-staff-not-found.2js.html', 'components/password-validation/password-validation.2js.html', 'components/preview-trial-widget/preview-trial-widget.2js.html', 'components/privacy-policy/privacy-policy.2js.html', 'components/profile-photo-select/profile-photo-select.2js.html', 'components/session/cc-vnext-modal.2js.html', 'components/support-id/support-id.2js.html', 'components/terms-signatory/terms-signatory-modal.2js.html', 'components/view-portal-banner/view-portal-banner.2js.html', 'my-account/link-auth/link-auth-modal.2js.html', 'my-account/my-account-licensee.2js.html', 'my-account/my-account-skinny.2js.html', 'my-account/my-account.2js.html', 'security-questions/security-questions.2js.html', 'update-password/update-password.2js.html', 'user-profile/view-profile-modal.2js.html']);

angular.module("components/bm-image-upload-modal/bm-image-upload-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/bm-image-upload-modal/bm-image-upload-modal.2js.html",
    "<div class=\"bento-modal bm-image-upload-modal\">\n" +
    "    <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.close()\">\n" +
    "      <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"modal-header\">{{vm.uploadTitleText}}</div>\n" +
    "    <div class=\"modal-body bm-modal-body\">\n" +
    "        <!-- make it look like bento-alert -->\n" +
    "        <div class=\"bento-alert-container\" ng-if=\"vm.alerts.length > 0\">\n" +
    "            <div ng-repeat=\"alert in vm.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success': alert.type === 'success', 'alert-warning': alert.type === 'warning', 'alert-info': alert.type === 'info', 'alert-danger': alert.type === 'danger'}\">\n" +
    "                <span>\n" +
    "                    {{alert.msg}}\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- progress indicator -->\n" +
    "        <div class=\"profile-progress\" ng-if=\"vm.progress !== 0\">\n" +
    "            <span translate=\"bm.components.common.uploading\"></span>\n" +
    "            <div class=\"bento-progressbar\">\n" +
    "              <div uib-progressbar value=\"vm.progress\" animate=\"true\" type=\"vm.progressType\">{{vm.progress}}%</div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- photo drop/select -->\n" +
    "        <div ng-if=\"!vm.selectedImageSrc && vm.progress === 0\">\n" +
    "            <div ng-file-drop ng-file-select ng-model=\"vm.selectedFile\" class=\"drop-box align-center\" drag-over-class=\"drag-over\" ng-multiple=\"false\" allow-dir=\"true\" accept=\"'image/*'\" ng-accept=\"'image/*'\" ng-capture=\"'camera'\" ng-file-change=\"vm.fileOnChange($files, $event, $rejectedFiles)\">\n" +
    "                <i class=\"glyphicon glyphicon-picture\"></i>\n" +
    "                <div class=\"drop-box-text\">{{vm.dragImageText}}</div>\n" +
    "                <div class=\"drop-box-text\">\n" +
    "                    - <span translate=\"bm.components.common.or\"></span> -\n" +
    "                </div>\n" +
    "                <div class=\"drop-box-text\">\n" +
    "                    <a class=\"btn btn-default btn-dynamic btn-text-ellipsis\" ng-href=\"\" role=\"button\">{{vm.uploadImageButtonText}}</a>\n" +
    "                </div>\n" +
    "                <div ng-if=\"vm.currentImage && vm.deletable\" class=\"drop-box-text\">\n" +
    "                    - <span translate=\"bm.components.common.or\"></span> -\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"vm.currentImage && vm.deletable\" class=\"align-center\">\n" +
    "                <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.delete()\">\n" +
    "                    {{vm.deleteImageButtonText}}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- photo crop -->\n" +
    "        <div ng-if=\"vm.selectedImageSrc && vm.progress === 0\">\n" +
    "            <div>\n" +
    "                <span translate=\"bm.image.upload.cropPhotoInstructions\"></span> {{vm.saveImageButtonText}}.\n" +
    "            </div>\n" +
    "            <div class=\"crop-area\">\n" +
    "                <img-crop image=\"vm.selectedImageSrc\" result-image=\"vm.croppedImage\" area-type=\"{{ vm.cropShape }}\"></img-crop>\n" +
    "            </div>\n" +
    "            <div class=\"crop-area-text\">\n" +
    "                <a ng-href=\"\" ng-click=\"vm.selectedImageSrc = undefined\">{{vm.uploadAnotherImageText}}</a>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer clearfix\">\n" +
    "        <button class=\"btn btn-primary btn-dynamic\" ng-click=\"vm.save()\" ng-disabled=\"!vm.selectedImageSrc\">\n" +
    "            {{vm.saveImageButtonText}}\n" +
    "        </button>\n" +
    "        <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.cancel()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/bm-user-availability/bm-user-availability.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/bm-user-availability/bm-user-availability.2js.html",
    "<div class=\"bm-availability clearfix\">\n" +
    "    <span class=\"dropdown bento-dropdown pull-left\" uib-dropdown>\n" +
    "      <a role=\"button\" class=\"dropdown-toggle btn btn-default btn-icon\" uib-dropdown-toggle>\n" +
    "        <span class=\"bm-inline-dot bm-selected-dot\" ng-class=\"'bm-' + selectedDot + '-dot'\"></span>\n" +
    "        <i class=\"bento-icon-chevron-down\"></i>\n" +
    "      </a>\n" +
    "      <ul class=\"dropdown-menu dropdown-menu-left bm-availability-dots clearfix\">\n" +
    "        <li>\n" +
    "            <a ng-href=\"\" ng-click=\"changeStatus('Available','green')\">\n" +
    "                <div class=\"bm-dot bm-green-dot pull-left\"></div>\n" +
    "                <div class=\"bm-dot-text pull-left\">{{statusText.available}}</div>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "            <a ng-href=\"\" ng-click=\"changeStatus('Away','yellow')\">\n" +
    "                <div class=\"bm-dot bm-yellow-dot pull-left\"></div>\n" +
    "                <div class=\"bm-dot-text pull-left\">{{statusText.away}}</div>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "            <a ng-href=\"\" ng-click=\"changeStatus('Busy','red')\">\n" +
    "                <div class=\"bm-dot bm-red-dot pull-left\"></div>\n" +
    "                <div class=\"bm-dot-text pull-left\">{{statusText.busy}}</div>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "      </ul>\n" +
    "    </span>\n" +
    "    <input type=\"text\" name=\"bmAvailablity\" id=\"bmAvailablity\" ng-model=\"availabilityText\" ng-blur=\"changeStatusText()\" class=\"form-control bm-availability-text-box pull-left\" />\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/checkpoint-engage/checkpoint-engage.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/checkpoint-engage/checkpoint-engage.2js.html",
    "<form name=\"$ctrl.checkpointForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <h3 class=\"bm-modal-title\" translate=\"bm.header.checkpoint.header\"></h3>\n" +
    "  <!-- error display - make it look like bento-alert -->\n" +
    "  <div class=\"bento-alert-container\" ng-if=\"$ctrl.alerts.length > 0\">\n" +
    "    <div ng-repeat=\"alert in $ctrl.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success': alert.type === 'success', 'alert-warning': alert.type === 'warning', 'alert-info': alert.type === 'info', 'alert-danger': alert.type === 'danger'}\">\n" +
    "      <span>\n" +
    "        {{alert.msg}}\n" +
    "        </span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <!-- creds not entered -->\n" +
    "  <div class=\"row\" ng-if=\"!$ctrl.credsExist && $ctrl.hasPermission\">\n" +
    "    <div class=\"col-sm-8\">\n" +
    "      <div class=\"form-group\" ng-class=\"{ 'has-error': $ctrl.checkpointForm.uid.$error.required && $ctrl.checkpointForm.uid.$touched }\">\n" +
    "        <label for=\"uid\"><span translate=\"bm.header.checkpoint.userName\"></span> *</label>\n" +
    "        <input type=\"text\" class=\"form-control\" id=\"uid\" name=\"uid\" ng-model=\"$ctrl.userData.uid\" required maxlength=\"50\" autocapitalize=\"off\" spellcheck=\"false\" autofocus />\n" +
    "        <div class=\"msg\" translate=\"bm.header.checkpoint.userNameRequired\"></div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"row\" ng-if=\"!$ctrl.credsExist && $ctrl.hasPermission\">\n" +
    "    <div class=\"col-sm-8\">\n" +
    "      <div class=\"form-group\" ng-class=\"{ 'has-error': $ctrl.checkpointForm.pwd.$error.required && $ctrl.checkpointForm.pwd.$touched }\">\n" +
    "        <label for=\"pwd\"><span translate=\"bm.header.viewProfile.password\"></span> *</label>\n" +
    "        <input type=\"password\" class=\"form-control\" id=\"pwd\" name=\"pwd\" ng-model=\"$ctrl.userData.pwd\" required maxlength=\"50\" />\n" +
    "        <div class=\"msg\" translate=\"bm.header.checkpoint.passwordRequired\"></div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"row\" ng-if=\"!$ctrl.credsExist && $ctrl.hasPermission\">\n" +
    "    <div class=\"col-sm-10\">\n" +
    "      <label class=\"checkbox\">\n" +
    "        <input type=\"checkbox\" ng-model=\"$ctrl.userData.agree\" /> <span translate=\"bm.header.checkpoint.agreeLicense\"></span>\n" +
    "      </label>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"modal-required bm-required-fields\" ng-if=\"!$ctrl.credsExist && $ctrl.hasPermission\">\n" +
    "    * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "  </div>\n" +
    "  <!-- creds already entered -->\n" +
    "  <div class=\"row bm-checkpoint-remove-text\" ng-if=\"$ctrl.credsExist && $ctrl.hasPermission\">\n" +
    "    <div class=\"col-sm-8\">\n" +
    "      {{$ctrl.removeText}}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"modal-footer\">\n" +
    "    <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"$ctrl.actions.saveUserData()\" ng-if=\"!$ctrl.credsExist && $ctrl.hasPermission\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"$ctrl.actions.deleteUserData()\" ng-if=\"$ctrl.credsExist && $ctrl.hasPermission\" translate=\"bm.components.common.remove\"></button>\n" +
    "    <button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.actions.cancelUserData()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("components/client-notifications/client-notifications-list.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/client-notifications/client-notifications-list.2js.html",
    "<div class=\"bm-ntfs-virt-list\" bm-flex-col>\n" +
    "    <p ng-if=\"hasZeroItems && !isLoading\" class=\"zero-items-warn\" translate=\"bm.header.profileMenu.zeroNotifications\"></p>\n" +
    "\n" +
    "    <div ng-if=\"!hasZeroItems\" class=\"bm-ntfs-settings bm-animate-if\">\n" +
    "        <a ng-href=\"\" ng-click=\"markAllNotificationsRead()\" translate=\"bm.header.profileMenu.markAllNotificationsRead\"></a>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"!hasZeroItems\" id=\"bm-ntfs-vertical-container\" bm-flex-grow>\n" +
    "        <div ng-repeat=\"item in notifications\" class=\"bm-ntfs-repeated-item bm-animate-if\" ng-class=\"{'bm-last-notification': $last}\" bm-notifications-last-repeat-task bm-flex-row>\n" +
    "            <div class=\"bm-ntfs-indicator-col\" bm-flex-col>\n" +
    "                <div class=\"bm-ntfs-indicator-item\">\n" +
    "                    <i class=\"glyphicon glyphicon-info-sign\"></i>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"bm-ntfs-message-col\" bm-flex-col flex-grow>\n" +
    "                <div class=\"bm-ntfs-text\" ng-click=\"markNotificationRead(item,$event)\" ng-class=\"{'bm-ntfs-text-unread': item.unread}\">\n" +
    "                    <div ng-bind-html=\"item.onvioNotificationText\"></div>\n" +
    "                    <div class=\"bm-ntfs-date\">\n" +
    "                        {{ getFormattedTime(item.timestamp) }}\n" +
    "                        <a ng-href=\"\" class=\"bm-ntfs-mark\" ng-click=\"markNotificationRead(item,$event)\">\n" +
    "                            <span ng-if=\"item.unread\" translate=\"bm.header.profileMenu.markNotificationsRead\"></span>\n" +
    "                        </a>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"bm-ntfs-delete-col\" bm-flex-col>\n" +
    "                <div>\n" +
    "                    <a ng-href=\"\" ng-click=\"deleteNotification(item, $index)\"><i class=\"bento-icon-close-x\" uib-tooltip=\"{{deleteTranslated}}\" tooltip-placement=\"left\" tooltip-class=\"bm-ntfs-delete-tooltip\" tooltip-popup-delay=\"500\" aria-hidden=\"true\"></i></a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/header/bm-staff-header.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/header/bm-staff-header.2js.html",
    "<bm-header>\n" +
    "    <em data-translate=\"bm.staffHeader.brandName\"></em>\n" +
    "    <span data-translate=\"bm.staffHeader.productName\"></span>\n" +
    "</bm-header>\n" +
    "");
}]);

angular.module("components/header/documents-header-button.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/header/documents-header-button.2js.html",
    "<li bm-if-perm=\"OnvioDrive.Documents\">\n" +
    "	<a target=\"_blank\" href=\"/staff/#/documents/all\" title=\"{{ 'Bluemoon.Shell.Navigation.Documents' | translate }}\"><i class=\"bento-icon-file-room\"></i></a>\n" +
    "</li>\n" +
    "");
}]);

angular.module("components/header/header.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/header/header.2js.html",
    "<header ng-click=\"header.clearAppMenuActive()\" bm-flex-row>\n" +
    "    <ul ng-if=\"!header.hideMenus\" class=\"bm-header-left-menu\" bm-flex-row>\n" +
    "      <li>\n" +
    "          <a href id=\"bm-header-app-menu-toggle\" class=\"bm-header-app-menu-toggle\" title=\"{{ 'bm.header.appMenu.toggle' | translate }}\" ng-click=\"header.toggleAppMenuActive()\">\n" +
    "              <i class=\"bento-icon-hamburger-menu\"></i>\n" +
    "          </a>\n" +
    "      </li>\n" +
    "    </ul>\n" +
    "    <!-- header image and text not required for huge? -->\n" +
    "    <h1>\n" +
    "        <!-- <img ng-if=\"header.theme.header.headerImage\" ng-src=\"{{ header.theme.header.headerImage }}\"> -->\n" +
    "        <span ng-transclude></span> <!-- <span ng-bind=\"header.theme.header.headerLine1\"></span> -->\n" +
    "    </h1>\n" +
    "    <!-- App specific menu items !-->\n" +
    "    <ul ng-if=\"!header.hideMenus\" class=\"bm-header-center-menu\" bm-flex-grow bm-flex-row>\n" +
    "        <!-- Preview / Trial mode message -->\n" +
    "        <li bm-if-perm-some=\"['Platform.Trial', 'Platform.PreviewMode']\">\n" +
    "            <preview-trial-widget></preview-trial-widget>\n" +
    "        </li>\n" +
    "        <!-- client dashboard icon -->\n" +
    "        <li ng-if=\"header.hasClientDashboard\">\n" +
    "            <a target=\"_blank\" href=\"/staff/#/client-dashboard{{header.clientSpecificUrl}}\" title=\"{{ 'Bluemoon.Shell.Navigation.ClientDashboard' | translate }}{{header.clientSpecificTitle}}\"><i class=\"bento-icon-vcard\"></i></a>\n" +
    "        </li>\n" +
    "        <li html-element-id=\"bm-header-timer-button\" bm-timer-header-button=\"header.isTimerDropdownOpen\"></li>\n" +
    "        <li bm-documents-header-button></li>\n" +
    "    </ul>\n" +
    "    <ul ng-if=\"!header.hideMenus\" class=\"bm-header-right-menu\" bm-flex-row>\n" +
    "        <li bm-if-has-no-access=\"PlatformHideHelp\">\n" +
    "            <bm-help-dropdown is-dropdown-open=\"header.isHelpDropdownOpen\"></bm-help-dropdown>\n" +
    "        </li>\n" +
    "        <!-- Begining of the linked accounts header -->\n" +
    "        <li id=\"bmLinkedAccountsDropdown\" bm-if-has-access=\"PPE-AccountSwitching\">\n" +
    "            <div ng-show=\"header.linkedAccountFound\">\n" +
    "            <!-- Dropdown Menu-->\n" +
    "            <div id=\"bmLinkedAccountsMenu\" uib-dropdown is-open=\"header.isLinkedAccountsDropdownOpen\" class=\"dropdown bento-dropdown dropdown-menu-right bm-header-dropdown\">\n" +
    "                <a ng-if=\"header.showLinkedAccountsMenu\" ng-disabled=\"header.disableLinkedAccountsMenu\" id=\"bm-header-linked-accounts-dropdown-toggle\" uib-dropdown-toggle>\n" +
    "                    <span class=\"bm-header-linked-accounts-dropdown\"\n" +
    "                        title=\"{{header.selectedLinkedAccount.displayedName}}&#013{{header.selectedLinkedAccount.companyName}}\">\n" +
    "                        <span class=\"bm-header-menu-linked-accounts-item\">{{header.selectedLinkedAccount.displayedName}}</span>\n" +
    "                        <span class=\"bm-header-menu-linked-accounts-item\">{{header.selectedLinkedAccount.companyName}}</span>\n" +
    "                    </span>\n" +
    "                    <i ng-if=\"header.showLinkedAccountsMenu\" class=\"bento-icon-caret-down\"></i>\n" +
    "                </a>\n" +
    "                <span ng-if=\"!header.showLinkedAccountsMenu\" class=\"bm-header-linked-accounts-dropdown\"\n" +
    "                    title=\"{{header.selectedLinkedAccount.displayedName}}&#013{{header.selectedLinkedAccount.companyName}}\">\n" +
    "                    <span class=\"bm-header-menu-linked-accounts-item\">{{header.selectedLinkedAccount.displayedName}}</span>\n" +
    "                    <span class=\"bm-header-menu-linked-accounts-item\">{{header.selectedLinkedAccount.companyName}}</span>\n" +
    "                </span>\n" +
    "\n" +
    "                <!-- <ul class=\"dropdown-menu dropdown-menu-right dropdown-menu-linked-accounts\"> -->\n" +
    "                <ul class=\"dropdown-menu dropdown-menu-linked-accounts\">\n" +
    "                    <li id=\"bmLinkedAccountDropdownMenuHeader\" class=\"dropdown-menu-section-heading-linked-accounts\"><span translate=\"bm.header.linkedAccounts.header\"></span>\n" +
    "                        <span style=\"float: right\"><a class=\"linked-accounts-manager-link\" ng-click=\"header.openManageLinkedAccountsDialog()\" translate=\"bm.header.viewProfile.linkedAccounts.manage\"></a></span>\n" +
    "                    </li>\n" +
    "                    <!-- <li class=\"divider\"></li> -->\n" +
    "                    <li ng-repeat=\"linkedAccount in header.linkedAccounts\">\n" +
    "                        <div class=\"divider\"></div>\n" +
    "                        <div class=\"dropdown-menu-item-linked-accounts\" ng-click=\"header.switchAccount(linkedAccount.linkedAccountId)\"\n" +
    "                            title=\"{{linkedAccount.displayedName}}&#013{{linkedAccount.companyName}}\">\n" +
    "                            <div id=\"linkedAccountAccountName\" class=\"bm-menu-linked-accounts-item\">{{linkedAccount.displayedName}}</div>\n" +
    "                            <div class=\"bm-menu-linked-accounts-item\">{{linkedAccount.companyName}}</div>\n" +
    "                        </div>\n" +
    "                    </li>\n" +
    "                </ul>\n" +
    "            </div>\n" +
    "            </div>\n" +
    "        </li>\n" +
    "        <!-- End of linked accounts header -->\n" +
    "        <li>\n" +
    "            <a href id=\"bm-header-profile-dropdown-toggle\" title=\"{{ 'bm.header.userMenu.toggle' | translate }}\" ng-click=\"header.toggleProfileMenuActive()\">\n" +
    "                <i class=\"bento-icon-user\" ng-if=\"!header.user.photo && !header.user.initials\"></i>\n" +
    "                <bm-profile-photo-select image=\"header.user.photo\" initials=\"{{ header.user.initials }}\" shape=\"circle\" size=\"small\" view-only=\"true\"></bm-profile-photo-select>\n" +
    "                <span ng-if=\"header.totalUnreadCount > 0\" class=\"badge bm-header-profile-badge\">{{header.totalUnreadCount}}</span>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "</header>\n" +
    "<div id=\"bm-header-app-menu\" ng-class=\"{ 'bm-header-app-menu-active': header.appMenuActive }\">\n" +
    "    <header>\n" +
    "        <h1 translate=\"bm.header.appsMenu.title\"></h1>\n" +
    "        <button class=\"bm-header-menu-close-btn\" ng-click=\"header.clearAppMenuActive()\">×</button>\n" +
    "    </header>\n" +
    "    <ul>\n" +
    "        <li bm-if-perm=\"Applications.Onvio\">\n" +
    "            <a id=\"bm-header-apps-staff-link\" href=\"/staff/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.staffProductNameCenter' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.staffProductNameCenter\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.OnvioClientHub\">\n" +
    "            <a ng-if=\"!(header.hasCCVNextIAC || header.hasCCVNextFRP)\" id=\"bm-header-apps-client-link\" href=\"/client/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.clientProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.clientProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <a ng-if=\"header.hasCCVNextIAC || header.hasCCVNextFRP\" href=\"/clientcenter/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.clientProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.clientProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.USAdvisoryTools\">\n" +
    "            <a href=\"/advisory/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.advisoryToolsProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.advisoryToolsProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.USFixedAssets\">\n" +
    "            <a href=\"/fixedassets/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.fixedAssetsProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.fixedAssetsProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.AUTax\">\n" +
    "            <a bm-if-perm-some=\"['Applications.CATax', 'Applications.UKTax', 'Applications.USTax']\" href=\"/autax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.autaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.autaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <a bm-if-not-perm-some=\"['Applications.CATax', 'Applications.UKTax', 'Applications.USTax']\" href=\"/autax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.onviotaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.onviotaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.CATax\">\n" +
    "            <a bm-if-perm-some=\"['Applications.AUTax', 'Applications.UKTax', 'Applications.USTax']\" href=\"/catax/hub\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.cataxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.cataxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <a bm-if-not-perm-some=\"['Applications.AUTax', 'Applications.UKTax', 'Applications.USTax']\" href=\"/catax/hub\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.onviotaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.onviotaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.UKTax\">\n" +
    "            <a bm-if-perm-some=\"['Applications.AUTax', 'Applications.CATax', 'Applications.USTax']\" href=\"/uktax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.uktaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.uktaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <a bm-if-not-perm-some=\"['Applications.AUTax', 'Applications.CATax', 'Applications.USTax']\" href=\"/uktax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.onviotaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.onviotaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.USTax\">\n" +
    "            <a bm-if-perm-some=\"['Applications.AUTax', 'Applications.CATax', 'Applications.UKTax']\" href=\"/ustax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.ustaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ustaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <a bm-if-not-perm-some=\"['Applications.AUTax', 'Applications.CATax', 'Applications.UKTax']\" href=\"/ustax/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.onviotaxProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.onviotaxProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.BRAtendimento\">\n" +
    "            <a href=\"/atendimento/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.atendimentoProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.atendimentoProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm-some=\"['Applications.Workpapers','Applications.CheckpointEngage']\">\n" +
    "            <!-- show workpapers if user has both -->\n" +
    "            <a bm-if-perm=\"Applications.Workpapers\" href=\"/workpapers/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.workpapersProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.workpapersProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "            <!-- otherwise, show checkpoint -->\n" +
    "            <a bm-if-not-perm=\"Applications.Workpapers\" href=\"/checkpoint/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.checkpointEngageProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.checkpointEngageProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.MyPayOnboarding\">\n" +
    "            <a href=\"/uspayrollonboarding/center/#/views/staff\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.mypayOnboardingProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.mypayOnboardingProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.UKSecretarial\">\n" +
    "            <a href=\"/secretarial/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.ukSecretarialProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ukSecretarialProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.UKCompanyFormations\">\n" +
    "            <a href=\"/formations/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.ukCompanyFormationsProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ukCompanyFormationsProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.GTPT\">\n" +
    "            <a href=\"/gptp/#/projects\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.gtptSeed' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.gtptSeed\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"MyPayOnboarding.ReferringAccountant\">\n" +
    "            <a href=\"/uspayrollonboarding/center/#/views/accountant\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.mypayReferringAcct' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.mypayReferringAcct\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.TrialBalance\">\n" +
    "            <a href=\"/trialbalance/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.TrialBalance' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.TrialBalance\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.EstudioOne-VAT\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable['EstudioOne-VAT']}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.EstudioOne-VAT' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.EstudioOne-VAT\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.EstudioOne-Payroll\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable['EstudioOne-Payroll']}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.EstudioOne-Payroll' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.EstudioOne-Payroll\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.EstudioOne-Accounting\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable['EstudioOne-Accounting']}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.EstudioOne-Accounting' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.EstudioOne-Accounting\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.EstudioOne-FixedAssets\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable['EstudioOne-FixedAssets']}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.EstudioOne-FixedAssets' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.EstudioOne-FixedAssets\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.Integra\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable.Integra}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.Integra' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.Integra\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.CheckpointAR\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable.CheckpointAR}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.CheckpointAR' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.CheckpointAR\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.ARTaxAmnesty\">\n" +
    "            <a href=\"/amnesty/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.arTaxAmnestyProductName' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.arTaxAmnestyProductName\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.ARInvestmentAccounts\">\n" +
    "            <a href=\"/arinvestmentaccountsapplication/#/projects\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.arInvestmentAccts' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.arInvestmentAccts\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.Accounts\">\n" +
    "            <a href=\"/accounts/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.ukAccts' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ukAccts\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.UKVAT\">\n" +
    "            <a href=\"/ukvat/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.ukVat' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.ukVat\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.BRBoxE\">\n" +
    "            <a href=\"/boxe/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.brBoxE' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.brBoxE\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.AUActivityStatements\">\n" +
    "            <a href=\"/auactivitystatements/\" target=\"_blank\" ng-click=\"header.launchApp($event)\" bm-flex-row title=\"{{ bm.header.appsMenu.activityStatements | translate }}\">\n" +
    "                <span translate=\"bm.header.appMenu.activityStatements\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "        <li bm-if-perm=\"Applications.OnvioBRSupport\">\n" +
    "            <a ng-href=\"{{header.session.bindings.RoutingTable.OnvioBRSupport}}\" target=\"_blank\" ng-click=\"header.sso($event); header.launchApp($event)\" bm-flex-row title=\"{{ 'bm.header.appsMenu.OnvioBRSupport' | translate }}\">\n" +
    "                <span translate=\"bm.header.appsMenu.OnvioBRSupport\" bm-flex-grow></span>\n" +
    "                <i class=\"bento-icon-newtab\"></i>\n" +
    "            </a>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "</div>\n" +
    "<div id=\"bm-header-profile-menu\" bm-flex-col ng-class=\"{ 'bm-header-profile-menu-active': header.profileMenuActive }\">\n" +
    "    <header class=\"clearfix\">\n" +
    "        <h1 id=\"bm-header-profile-menu-userName\" ng-bind=\"header.user.fullName\"></h1>\n" +
    "        <p id=\"bm-header-profile-menu-email\" ng-bind=\"header.user.email\"></p>\n" +
    "        <a href id=\"bm-header-profile-menu-viewLink\" ng-click=\"header.openProfileModal()\" translate=\"bm.header.profileMenu.viewProfile\"></a>\n" +
    "        <a href ng-if=\"header.hasPrefs\" ng-click=\"header.showUserPreferences()\" id=\"bm-header-profile-menu-viewPreferences\"\n" +
    "            translate=\"bm.userPreferences\"></a>\n" +
    "        <div bento-alert bento-alert-object=\"alerts\"></div>\n" +
    "        <bm-profile-photo-select image=\"header.user.photo\" shape=\"circle\" ng-click=\"header.clearProfileMenuActive()\"></bm-profile-photo-select>\n" +
    "        <button class=\"bm-header-menu-close-btn\" ng-click=\"header.clearProfileMenuActive()\">×</button>\n" +
    "        <button role=\"button\" id=\"bm-header-signout-link\" class=\"btn btn-primary\" ng-click=\"header.signOut()\" translate=\"bm.header.userMenu.signOut\"></button>\n" +
    "    </header>\n" +
    "    <div id=\"bm-header-profile-menu-setAvail\" class=\"clearfix\">\n" +
    "        <bm-user-availability></bm-user-availability>\n" +
    "    </div>\n" +
    "    <uib-tabset id=\"bm-header-profile-menu-tabs\" class=\"tabs-top\" bm-flex-grow bm-flex-col>\n" +
    "        <uib-tab>\n" +
    "            <uib-tab-heading>\n" +
    "                <span translate=\"bm.header.profileMenu.notifications\"></span><span ng-if=\"header.unreadNotificationsCount > 0\" class=\"badge\">{{ header.unreadNotificationsCount }}</span>\n" +
    "            </uib-tab-heading>\n" +
    "            <bm-client-notifications-list></bm-client-notifications-list>\n" +
    "        </uib-tab>\n" +
    "        <uib-tab>\n" +
    "            <uib-tab-heading>\n" +
    "                <span translate=\"bm.header.profileMenu.messages\"></span><span ng-if=\"header.unreadMessagesCount > 0\" class=\"badge\">{{ header.unreadMessagesCount }}</span>\n" +
    "            </uib-tab-heading>\n" +
    "            <p class=\"zero-items-warn\" translate=\"bm.header.profileMenu.zeroMessages\"></p>\n" +
    "        </uib-tab>\n" +
    "    </uib-tabset>\n" +
    "</div>\n" +
    "<div class=\"bm-header-modal-mask\" ng-class=\"{ 'bm-header-app-menu-active': header.appMenuActive, 'bm-header-profile-menu-active': header.profileMenuActive }\" ng-click=\"header.clearMenuActive()\"></div>\n" +
    "");
}]);

angular.module("components/header/timer-header-button.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/header/timer-header-button.2js.html",
    "<li bm-if-perm=\"TimeAndBilling.TimeAndExpense\" ng-show=\"vm.timerDirectiveLoaded\">\n" +
    "    <span uib-dropdown auto-close=\"disabled\" is-open=\"vm.isTimerDropdownOpen\" class=\"dropdown bento-dropdown dropdown-menu-center bm-header-dropdown\">\n" +
    "        <a href uib-dropdown-toggle title=\"{{ 'bm.header.timers.toggle' | translate }}\"><i class=\"bento-icon-stopwatch\"></i><span class=\"badge\" ng-class=\"{ 'bm-badge-active': vm.badge.active}\">{{vm.badge.number}}</span><span class=\"bm-header-menu-item-text\" translate=\"bm.header.timers.toggle\"></span></a>\n" +
    "        <div class=\"dropdown-menu dropdown-menu-center\">\n" +
    "            <time-and-expense-timer id=\"bm-header-timer-control\" time-and-expense-timer-is-dropdown-open=\"vm.isTimerDropdownOpen\", time-and-expense-timer-badge=\"vm.badge\"/>\n" +
    "        </div>\n" +
    "    </span>\n" +
    "</li>\n" +
    "");
}]);

angular.module("components/help/help.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/help/help.2js.html",
    "<span id=\"bm-header-help-dropdown\" uib-dropdown is-open=\"help.isHelpDropdownOpen\" class=\"dropdown bento-dropdown dropdown-menu-right bm-header-dropdown\">\n" +
    "    <a id=\"bm-header-help-dropdown-toggle\" href uib-dropdown-toggle title=\"{{ 'bm.header.helpMenu.toggle' | translate }}\">\n" +
    "        <i class=\"bento-icon-question\"></i>\n" +
    "        <span class=\"bm-header-menu-item-text\" translate=\"bm.header.helpMenu.toggle\"></span>\n" +
    "    </a>\n" +
    "    <ul class=\"dropdown-menu\" ng-controller=\"HelpCtrl\"\n" +
    "        ng-class=\"{'dropdown-menu-right': !useMenuLeft, 'dropdown-menu-left': useMenuLeft}\">\n" +
    "        <!-- Search field -->\n" +
    "        <li ng-click=\"$event.stopPropagation()\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <span class=\"input-group-addon\" ng-click=\"helpSearch()\">\n" +
    "                    <span class=\"glyphicon glyphicon-search\"></span>\n" +
    "                </span>\n" +
    "                <label class=\"sr-only\" for=\"bm-header-help-search\" translate=\"bm.header.helpMenu.searchLabel\"></label>\n" +
    "                <input bento-reset type=\"text\" id=\"bm-header-help-search\" class=\"form-control\" placeholder=\"{{ searchInput.placeholderTxt }}\" ng-model=\"searchInput.text\" ng-keypress=\"searchKeyPress($event)\">\n" +
    "            </div>\n" +
    "        </li>\n" +
    "        <li class=\"divider\"></li>\n" +
    "        <!-- Suggested Topics -->\n" +
    "        <li class=\"dropdown-menu-section-heading\" translate=\"bm.header.helpMenu.topicsHeading\"></li>\n" +
    "        <li ng-repeat=\"menu in help.topics\">\n" +
    "            <a ng-href=\"{{ formatTopicUrl(help, menu.url) }}\" target=\"_blank\">{{menu.title}}</a>\n" +
    "        </li>\n" +
    "        <li class=\"divider\"></li>\n" +
    "        <!-- Additional assistance -->\n" +
    "        <li class=\"dropdown-menu-section-heading\" translate=\"bm.header.helpMenu.assistanceHeading\"></li>\n" +
    "        <li ng-if=\"help && help.howToUrl\" >\n" +
    "            <a ng-href=\"{{ howToLink() }}\" target=\"_blank\" translate=\"bm.header.helpMenu.siteLinkText\"></a>\n" +
    "        </li>\n" +
    "        <li bm-if-has-access=\"HelpCenter_ChatSupport\">\n" +
    "            <a ng-href=\"{{chatWithSupportLink}}  \" target=\"_blank\" translate=\"bm.header.helpMenu.chatwithsupport\"></a>\n" +
    "        </li>\n" +
    "        <li bm-if-has-access=\"HelpCenter_EmailSupport\" >\n" +
    "            <a ng-href=\"{{emailSupportLink}}\" translate=\"bm.header.helpMenu.emailsupport\"></a>\n" +
    "        </li>\n" +
    "\n" +
    "        <!-- privacy policy -->\n" +
    "        <li>\n" +
    "            <bm-privacy-policy-link aria-hidden=\"true\"></bm-privacy-policy-link>\n" +
    "        </li>\n" +
    "        <!-- support id -->\n" +
    "        <li ng-click=\"$event.stopPropagation()\">\n" +
    "            <bm-support-id-link aria-hidden=\"true\"></bm-support-id-link>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "</span>");
}]);

angular.module("components/i18n/language-select.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/i18n/language-select.2js.html",
    "<div bento-select>\n" +
    "    <select\n" +
    "        id=\"{{ name }}\"\n" +
    "        name=\"{{ name }}\"\n" +
    "        class=\"form-control\"\n" +
    "        ng-model=\"selectedLanguage\"\n" +
    "        ng-change=\"selectionChanged()\"\n" +
    "        ng-required=\"required\"\n" +
    "        ng-options=\"language.translatedDescription for language in languageList track by language.code\"\n" +
    "        ng-disabled=\"disabled\">\n" +
    "        <option value=\"\" ng-if=\"showEmpty\"></option>\n" +
    "    </select>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/linked-accounts/linked-accounts-dialog.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/linked-accounts/linked-accounts-dialog.2js.html",
    "<div>\n" +
    "	<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.closeDialog()\">\n" +
    "    	<i class=\"bento-icon-close-x\"></i>\n" +
    "  	</button>\n" +
    "	<bm-linked-accounts user=\"vm.user\" shared-data=\"vm.sharedProfile\"></bm-linked-accounts>\n" +
    "</div>");
}]);

angular.module("components/linked-accounts/linked-accounts.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/linked-accounts/linked-accounts.2js.html",
    "<div>\n" +
    "<form id=\"linkedAccountsForm\" name=\"vm.linkedAccountsForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "	<div id=\"formView\" bento-busy-loader=\"vm.isLoaderBusy\" bento-busy-loader-size=\"default\">\n" +
    "	<h3 class=\"bm-modal-title\" translate=\"bm.header.linkedAccounts.header\"></h3>\n" +
    "	<!-- Alerts -->\n" +
    "	<div class=\"bento-alert-container\" ng-if=\"vm.alerts.length > 0\">\n" +
    "		<div ng-repeat=\"alert in vm.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success' : alert.type === 'success', 'alert-warning' : alert.type === 'warning', 'alert-info' : alert.type === 'info', 'alert-danger' : alert.type === 'danger'}\">\n" +
    "			<span>\n" +
    "				{{alert.msg}}\n" +
    "			</span>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div id=\"linkedAccountsMainView\" ng-if=\"vm.user\">\n" +
    "		<div class=\"row\">\n" +
    "			<div class=\"col-sm-12\">\n" +
    "				<div class=\"form-group\">\n" +
    "					<label><span translate=\"bm.components.linkedAccounts.emailAddressMsg\"></span>&nbsp;<span id=\"userEmail\">{{vm.user.email}}</span></label>\n" +
    "				</div>\n" +
    "			</div>			\n" +
    "		</div>\n" +
    "		<div class=\"row\" id=\"noLinkedAccountsRow\" ng-if=\"vm.showAccounts == false\">\n" +
    "			<span translate=\"bm.components.linkedAccounts.noAccounts\"></span>\n" +
    "		</div>\n" +
    "		<!-- Flexgrid -->\n" +
    "		<div class=\"row\" id=\"linkedAccountsRow\" ng-if=\"vm.showAccounts\">\n" +
    "			<wj-flex-grid\n" +
    "				control=\"vm.flexgrid\" \n" +
    "				items-source=\"vm.gridData\" \n" +
    "				items-source-changed=\"refreshGrid(this.flexgrid)\"\n" +
    "				class=\"bmLinkedAccountsFlexgrid\">\n" +
    "				<wj-flex-grid-column min-width=\"65\" max-width=\"65\" header=\"{{'bm.components.linkedAccounts.active' | translate}}\" binding=\"active\" is-read-only=\"{{vm.hasOneAccount}}\" align=\"center\"></wj-flex-grid-column>\n" +
    "				<wj-flex-grid-column min-width=\"65\" max-width=\"65\" header=\"{{'bm.components.linkedAccounts.home' | translate}}\" is-read-only=\"{{vm.hasOneAccount}}\" align=\"center\">				\n" +
    "					<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "						<input type=\"radio\" ng-change=\"vm.defaultChanged()\" ng-model=\"vm.selectedDefaultLinkAccountId\" value=\"{{$item.linkedAccountId}}\">\n" +
    "					</wj-flex-grid-cell-template>\n" +
    "				</wj-flex-grid-column>\n" +
    "				<wj-flex-grid-column width=\"*\" header=\"{{'bm.components.linkedaccounts.accountName' | translate}}\" binding=\"accountName\" is-read-only=\"true\"> </wj-flex-grid-column>\n" +
    "				<wj-flex-grid-column min-width=\"175\" max-width=\"175\" header=\"{{'bm.components.linkedAccounts.nickname' | translate}}\" binding=\"displayedNickname\" is-read-only=\"false\">\n" +
    "					<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "						<div class=\"columnDisplayedNickname\">\n" +
    "							<div class=\"bmLinkedAccountsNickname\">\n" +
    "								<span id=\"accountName\" ng-if=\"$item.displayedNickname === ''\" translate=\"bm.components.linkedaccounts.accountName\"></span>\n" +
    "								<span ng-if=\"$item.displayedNickname !== ''\">{{$item.displayedNickname}}</span>\n" +
    "							</div>\n" +
    "							<div clase=\"bmLinkedAccountsEdit\">\n" +
    "								<span class=\"bento-icon-edit grid-action-item\"\n" +
    "									ng-click=\"\"\n" +
    "									data-tooltip-placement=\"top\"\n" +
    "									data-tooltip-trigger=\"mouseenter\"\n" +
    "									data-uib-tooltip=\"{{'bm.components.linkedAccounts.edit' | translate}}\"\n" +
    "									data-tooltip-append-to-body=\"true\">\n" +
    "								</span>								\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</wj-flex-grid-cell-template>\n" +
    "				</wj-flex-grid-column>\n" +
    "				<wj-flex-grid-column width=\"*\" header=\"{{'bm.components.linkedAccounts.firm' | translate}}\" binding=\"companyName\" is-read-only=\"true\"></wj-flex-grid-column>\n" +
    "			</wj-flex-grid>	\n" +
    "		</div>\n" +
    "		<!-- End of grid -->\n" +
    "		<div class=\"row\"><p>		\n" +
    "			<div class=\"col-sm-12\">\n" +
    "				<div class=\"form-group\" id=\"linkedAccountDetail\">\n" +
    "					<label>\n" +
    "						<span translate=\"bm.components.linkedAccounts.activeAccount\"></span>\n" +
    "					</label>\n" +
    "					<label>\n" +
    "						<span translate=\"bm.components.linkedAccounts.homeAccount\"></span>\n" +
    "					</label>					\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</p></div>\n" +
    "	</div>\n" +
    "	<div class=\"modal-footer\">\n" +
    "		<button type=\"submit\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.saveLinkedAccounts()\" ng-show=\"vm.user && (vm.linkedAccounts.length > 0)\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "		<button type=\"button\" class=\"btn btn-default bm-animate-if\" ng-click=\"vm.cancelLinkedAccounts()\" translate=\"bm.components.common.close\"></button>\n" +
    "	</div>\n" +
    "	</div>\n" +
    "</form>\n" +
    "</div>");
}]);

angular.module("components/main/main.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/main/main.2js.html",
    "<main ng-transclude></main>\n" +
    "");
}]);

angular.module("components/modal/modal-base.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/modal-base.2js.html",
    "<button ng-if=\"showClose\" type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"$close()\">\n" +
    "	<i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div ng-include=\"templateUrl\"></div>\n" +
    "<div class=\"modal-footer\">\n" +
    "	<button ng-repeat=\"button in buttons\" ng-class=\"[ 'btn', (!!button.primary ? 'btn-primary' : 'btn-default') ]\" ng-click=\"(button.dismiss === true ? $dismiss(button.value) : $close(button.value))\">{{button.text}}</button>\n" +
    "</div>");
}]);

angular.module("components/modal/modal-default.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/modal-default.2js.html",
    "<div class=\"modal-header\">\n" +
    "	{{vars.title}}\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "	<p>\n" +
    "        {{vars.body}}\n" +
    "	</p>\n" +
    "</div>");
}]);

angular.module("components/multi-factor-user/multi-factor-user-settings.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/multi-factor-user/multi-factor-user-settings.2js.html",
    "<div id=\"mfaUserSettingsDiv\">\n" +
    "	<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.close()\">\n" +
    "		<i class=\"bento-icon-close-x\"></i>\n" +
    "	</button>\n" +
    "	<div class=\"modal-header\">\n" +
    "		<span translate=\"bm.components.mfa.user.name\"></span>\n" +
    "	</div>	\n" +
    "	<div class=\"modal-body\">\n" +
    "		<div id=\"mfaModalBody\">\n" +
    "			<!-- <div id=\"busyLoading\"  ng-show=\"vm.isLoading\"> -->\n" +
    "			<div id=\"busyLoading\" ng-show=\"vm.busyLoading\">\n" +
    "				<p><span translate=\"bm.components.common.loading\"></span>...</p>\n" +
    "			</div>\n" +
    "			<div id=\"noDevice\"  ng-show=\"(!vm.busyLoading) && (vm.registeredFactors.length == 0)\">\n" +
    "				<p><span translate=\"bm.components.mfa.user.nodevice\"></span>.</p>\n" +
    "			</div>\n" +
    "			<div id=\"hasDevice\" ng-show=\"vm.registeredFactors.length > 0\">\n" +
    "				<div><p>\n" +
    "					<span translate=\"bm.components.mfa.user.device\"></span>: \n" +
    "					<div id=\"userDevice\">{{vm.userDevice}}</div>\n" +
    "				</p></div>\n" +
    "				<div>\n" +
    "					<p translate=\"bm.components.mfa.user.lostphone\"></p>\n" +
    "					<!-- Lost phone or don't have access to the Thomson Reuters Authetication app? -->\n" +
    "					<!-- Generate a temporary, 24-hour numerical code -->\n" +
    "					<p translate=\"bm.components.mfa.user.invalidate\"></p>\n" +
    "					<!-- for use in place of the app. Generating a code for this user will invalidate any previously-generated codes that you created for their account -->\n" +
    "				</div>\n" +
    "				<button class=\"btn btn-primary\" ng-click=\"vm.generateAccessCode()\" translate=\"bm.components.mfa.user.generate\"></button>\n" +
    "				<div ng-if=\"vm.authCode\" id=\"temporaryAccessCodeDiv\">\n" +
    "					<span translate=\"bm.components.mfa.user.tempcode\"></span>:<span id=\"temporaryAccessCodeLBL\">{{vm.authCode}}</span>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div class=\"modal-footer\">\n" +
    "		<button class=\"btn btn-primary\" ng-click=\"vm.close()\" translate=\"bm.components.common.close\"></button>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("components/multi-factor-user/multi-factor-user.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/multi-factor-user/multi-factor-user.2js.html",
    "<div id=\"mfaUserDiv\" ng-show=\"vm.isMfaAvailable\">\n" +
    "	<div class=\"row\">\n" +
    "		<div class=\"col-md-6\">			\n" +
    "			<label id=\"mfaLbl\" translate=\"bm.components.mfa.user.name\"></label>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div class=\"row\">\n" +
    "		<div class=\"col-md-6\">\n" +
    "			<button id=\"viewSettingsBtn\" type=\"button\" class=\"btn btn-primary\" translate=\"bm.components.common.viewsettings\" ng-click=\"vm.openMfaSettingsModal()\"></button>			\n" +
    "		</div>\n" +
    "	</div>\n" +
    "\n" +
    "<!-- \n" +
    "	<div>\n" +
    "		<button id=\"viewSettingsBtn\" type=\"button\" class=\"btn btn-primary\" translate=\"bm.components.common.viewsettings\" ng-click=\"vm.openMfaSettingsModal()\">	\n" +
    "		</button>\n" +
    "		<label id=\"mfaLbl\" translate=\"bm.components.mfa.user.name\"></label>\n" +
    "	</div>\n" +
    " -->	\n" +
    "</div>");
}]);

angular.module("components/multi-factor/multi-factor-profile-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/multi-factor/multi-factor-profile-modal.2js.html",
    "<form name=\"vm.confirmDeviceForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <div class=\"bento-modal\">\n" +
    "    <div class=\"modal-body\">\n" +
    "      <p translate=\"bm.header.viewProfile.mfaConfirmRemove\" ng-if=\"vm.modalAction === 'remove'\"></p>\n" +
    "      <p translate=\"bm.components.header.viewProfile.mfaConfirmAdd\" ng-if=\"vm.modalAction === 'add'\"></p>\n" +
    "      <div class=\"row\">\n" +
    "        <div class=\"col-sm-8\">\n" +
    "          <div class=\"form-group\" ng-class=\"{'has-error' : vm.confirmDeviceForm.userPassword.$invalid && ((vm.confirmDeviceForm.userPassword.$touched && vm.confirmDeviceForm.userPassword.$dirty) || vm.confirmDeviceForm.$submitted)}\">\n" +
    "            <label for=\"userPassword\"><span translate=\"bm.components.common.password\"></span> *</label>\n" +
    "            <input class=\"form-control\" type=\"password\" id=\"userPassword\" name=\"userPassword\" ng-model=\"vm.user.password\" bm-focus=\"true\" required />\n" +
    "            <div class=\"msg\" ng-messages=\"vm.confirmDeviceForm.userPassword.$error\" ng-if=\"vm.confirmDeviceForm.userPassword.$touched || vm.confirmDeviceForm.$submitted\">\n" +
    "              <span ng-message=\"required\">{{'bm.header.checkpoint.passwordRequired'|translate}}</span>\n" +
    "          </div>\n" +
    "          </div>\n" +
    "          * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "      <button type=\"submit\" class=\"btn btn-primary btn-dynamic\" ng-click=\"vm.confirmDevice()\" translate=\"BM.Components.UpdatePassword.ConfirmPassword\"></button>\n" +
    "      <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.cancelDevice()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("components/multi-factor/multi-factor-profile.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/multi-factor/multi-factor-profile.2js.html",
    "<div class=\"bm-mfa-profile\">\n" +
    "    <h3 class=\"bm-modal-title\" translate=\"bm.header.viewProfile.multifactorTitle\"></h3>\n" +
    "    <div class=\"row bm-lg-top-margin\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "          <span ng-if=\"$ctrl.required\" translate=\"bm.header.viewProfile.mfaRequired\"></span>\n" +
    "          <span ng-if=\"!$ctrl.required\" translate=\"bm.header.viewProfile.mfaOptional\"></span>\n" +
    "          <!-- TODO: NEED THE CORRECT LINK HERE FOR MFA HELP -->\n" +
    "          <a role=\"button\" class=\"btn btn-link btn-icon\" target=\"_blank\" ng-href=\"/ua/help/{{ $ctrl.helpLangCode }}/staff/core/common/mfa-overview.htm\">\n" +
    "            <span class=\"btn-icon-text\" translate=\"bm.header.viewProfile.mfaLearnMore\"></span>\n" +
    "            <i class=\"bento-icon-arrow-forward\"></i>\n" +
    "          </a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-sm-12\">\n" +
    "        <h4 translate=\"bm.header.viewProfile.mfaOptions.header\"></h4>\n" +
    "        <div translate=\"bm.header.viewProfile.mfaOptions.description\" ng-if=\"$ctrl.mutliFactorComplete\"></div>\n" +
    "        <div class=\"device-container\">\n" +
    "          <div translate=\"bm.header.viewProfile.mfaAccountNotPaired\" ng-if=\"!$ctrl.mutliFactorComplete\"></div>\n" +
    "          <div ng-repeat=\"factor in $ctrl.devices\">\n" +
    "              <span>{{factor.name}}</span>\n" +
    "              <a role=\"button\" class=\"btn btn-link btn-icon\" ng-click=\"$ctrl.actions.openConfirmModal('remove', factor)\" ng-if=\"!$ctrl.required || $ctrl.required && $ctrl.devices.length > 1\">\n" +
    "                <i class=\"bento-icon-remove\"></i>\n" +
    "              </a>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <a role=\"button\" class=\"add-link\" ng-href=\"\" ng-click=\"$ctrl.actions.openConfirmModal('add')\" translate=\"bm.header.viewProfile.mfaAddOption\"></a>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-sm-12\" ng-if=\"$ctrl.mutliFactorComplete\">\n" +
    "        <h4 translate=\"bm.header.viewProfile.mfaEmergencyCodes.header\"></h4>\n" +
    "        <p translate=\"bm.header.viewProfile.mfaEmergencyCodes.desc\"></p>\n" +
    "        <button type=\"button\" class=\"btn btn-default\" translate=\"bm.header.viewProfile.mfaEmergencyCodes.generate\" ng-click=\"$ctrl.actions.openConfirmModal('generate')\"></button>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  ");
}]);

angular.module("components/nav/nav.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/nav/nav.2js.html",
    "<nav class=\"navmore-flex\" ng-transclude></nav>\n" +
    "");
}]);

angular.module("components/navigation-utils/confirm-navigation.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/navigation-utils/confirm-navigation.2js.html",
    "<div class=\"modal-header\">\n" +
    "	{{'Bluemoon.Components.NavigationUtils.ConfirmNavigation.Title' | translate}}\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-body\">\n" +
    "	<p>{{'Bluemoon.Components.NavigationUtils.ConfirmNavigation.BodyMessage' | translate}}</p>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-footer\">\n" +
    "    <!-- TODO: These strings should be under FEF namespace -->\n" +
    "	<button type=\"button\" class=\"btn btn-primary\" data-ng-click=\"save()\">{{'Bluemoon.Components.Common.Actions.Save' | translate}}</button>\n" +
    "	<button type=\"button\" class=\"btn btn-default\" data-ng-click=\"ok()\">{{'Bluemoon.Components.Common.Actions.DoNotSave' | translate}}</button>\n" +
    "	<button type=\"button\" class=\"btn btn-default\" data-ng-click=\"cancel()\">{{'Bluemoon.Components.Common.Actions.Cancel' | translate}}</button>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("components/navigation-utils/save-in-progress-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/navigation-utils/save-in-progress-modal.2js.html",
    "<div class=\"modal-header\">\n" +
    "    <h3>{{'Bluemoon.Components.SaveInProgressModal.Title' | translate}}</h3>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-body\">\n" +
    "    <p>{{'Bluemoon.Components.SaveInProgressModal.BodyMessage' | translate}}</p>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"modal-footer\">\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/not-found/bm-staff-not-found.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/not-found/bm-staff-not-found.2js.html",
    "<div class=\"container-fluid\">\n" +
    "    <div class=\"row\">\n" +
    "        <h4 data-translate=\"Bluemoon.Components.Staff.NotFound.MainText\"></h4><br/>\n" +
    "        <a class=\"btn btn-primary\" href=\"/staff/#/\" data-translate=\"Bluemoon.Components.Staff.NotFound.GoToDashboard\"></a>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("components/password-validation/password-validation.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/password-validation/password-validation.2js.html",
    "<div class=\"bm-password-validation\">\n" +
    "    <span translate>bm.password.validation.mustHaveStart</span> <span class=\"{{rules.characterLengthRule.test(password) ? 'passing' : 'failing-required'}}\" translate=\"bm.password.validation.characterRule\" translate-value-val=\"{{charLengthReq}}\"></span> <span translate=\"bm.password.validation.mustHaveEnd\" translate-value-val=\"{{charClassReq}}\"></span>\n" +
    "    <ul>\n" +
    "        <div ng-repeat=\"rule in rules.characterTypeRules\">\n" +
    "            <li class=\"{{ rule.test(password) ? 'passing' : 'failing-optional' }}\">{{ rule.label }}</li>\n" +
    "        </div>\n" +
    "    </ul>\n" +
    "    <p/>\n" +
    "    <span translate>bm.password.validation.excludeTitle</span>\n" +
    "    <ul>\n" +
    "        <li translate>bm.password.validation.excludeWords</li>\n" +
    "        <li translate>bm.password.validation.excludeUserId</li>\n" +
    "        <li translate>bm.password.validation.excludeSequential</li>\n" +
    "    </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/preview-trial-widget/preview-trial-widget.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/preview-trial-widget/preview-trial-widget.2js.html",
    "<div id=\"previewTrialWidget\" class=\"previewMode\" ng-if=\"vm.preview\">\n" +
    "	<div id=\"previewTrialContent\">\n" +
    "		<p><span translate=\"bm.header.previewTrial.previewMode.intro\"></span> <span class=\"orange\" translate=\"bm.header.previewTrial.previewMode.preview\"></span> <span translate=\"bm.header.previewTrial.previewMode.mode\"></span></p>\n" +
    "	</div>\n" +
    "</div>\n" +
    "<div id=\"previewTrialWidget\" class=\"trialMode\" ng-if=\"vm.trial\">\n" +
    "	<div id=\"previewTrialContent\">\n" +
    "		<p><span translate=\"bm.header.previewTrial.trialMode.intro\"></span> {{vm.days}} <span translate=\"bm.header.previewTrial.trialMode.days\"></span></p>\n" +
    "		<a role=\"button\" class=\"btn\" ng-href=\"{{vm.modeButtonLink}}\" translate=\"bm.header.previewTrial.trialMode.button\"></a>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/privacy-policy/privacy-policy.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/privacy-policy/privacy-policy.2js.html",
    "<a href=\"{{$ctrl.privacyUri}}\" target=\"_blank\" translate=\"bm.components.privacyPolicy\"></a>\n" +
    "");
}]);

angular.module("components/profile-photo-select/profile-photo-select.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/profile-photo-select/profile-photo-select.2js.html",
    "<div class=\"bm-profile-photo\" ng-class=\"{ 'img-circle' : vm.shape === 'circle', 'lg-photo' : vm.size === 'large', 'sm-photo' : vm.size === 'small' }\">\n" +
    "    <span class=\"initials\" ng-if=\"!vm.selectEnabled && vm.initials && !vm.image\">{{ vm.initials }}</span>\n" +
    "    <div class=\"silhouette\" ng-style=\"vm.selectedStyle\" ng-if=\"!vm.selectEnabled && vm.image\"></div>\n" +
    "    <a class=\"select-profile\" ng-href=\"\" ng-click=\"vm.openPhotoModal()\" ng-if=\"vm.selectEnabled\">\n" +
    "        <div class=\"silhouette\" ng-style=\"vm.selectedStyle\"></div>\n" +
    "        <span class=\"silhouette-change\" translate=\"bm.header.accountDialog.addProfileImage\"></span>\n" +
    "    </a>\n" +
    "    <bm-image-upload-modal api=\"vm.imageUploadApi\"></bm-image-upload-modal>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/session/cc-vnext-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/session/cc-vnext-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"$close()\">\n" +
    "	<i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\">\n" +
    "	Client Preview Unavailable for Beta Users\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "	<p>\n" +
    "        We are still developing the client preview for the beta version of\n" +
    "        Client Center. We will notify you as we release new features so that\n" +
    "        you can give us your valuable feedback.<br/><br/>\n" +
    "\n" +
    "        If you need to view your client’s portal, close this message,\n" +
    "        change the Client Center Version switch to \"Current\" above the\n" +
    "        client's Client Center Access toggle, save your changes, and then click\n" +
    "        preview again. You won’t lose any data if you switch.\n" +
    "	</p>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "	<button class=\"btn btn-primary\" ng-click=\"$close()\">Ok</button>\n" +
    "</div>");
}]);

angular.module("components/support-id/support-id.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/support-id/support-id.2js.html",
    "<div ng-show=\"$ctrl.enabled\">\n" +
    "    <a ng-click=\"$ctrl.showId=!$ctrl.showId\" href=\"\" target=\"_blank\" translate=\"bm.components.supportId\"></a>\n" +
    "\n" +
    "    <div ng-show=\"$ctrl.showId\" class=\"support-id-display input-group\">\n" +
    "        <span class=\"input-group-addon\" ng-click=\"$ctrl.copyToClip();\">\n" +
    "            <span class=\"glyphicon glyphicon-copy\"></span>\n" +
    "        </span>\n" +
    "        <input id=\"support-id-text\" type=\"text\" placeholder=\"loading\" ng-model=\"$ctrl.supportId\" readonly>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/terms-signatory/terms-signatory-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/terms-signatory/terms-signatory-modal.2js.html",
    "<div class=\"bento-modal bm-terms-signatory\">\n" +
    "    <div class=\"modal-header\" translate>\n" +
    "        bm.terms.signatory.title\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div class=\"bm-signatory-view\" ng-bind-html=\"vm.displayText\"></div>\n" +
    "        <span class=\"bm-signatory-instructions\" translate>\n" +
    "            bm.terms.signatory.instructions\n" +
    "        </span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-primary btn-dynamic\" ng-click=\"vm.setAgreement(true)\" translate>\n" +
    "            bm.terms.signatory.agree\n" +
    "        </button>\n" +
    "        <button class=\"btn btn-default btn-dynamic\" ng-click=\"vm.setAgreement(false)\" translate>\n" +
    "            bm.terms.signatory.disagree\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/view-portal-banner/view-portal-banner.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/view-portal-banner/view-portal-banner.2js.html",
    "<header ng-class=\"{ 'unresolved-theme': banner.unresolvedTheme }\">\n" +
    "    <div id=\"view-portal-banner-left-side\">\n" +
    "        <span translate=\"bm.viewPortalBanner.viewingMsg\"></span><span> {{ banner.uname }}</span>\n" +
    "    </div>\n" +
    "    <div id=\"view-portal-banner-right-side\">\n" +
    "        <button class=\"btn btn-default\" translate=\"bm.viewPortalBanner.doneBtn\" ng-click=\"banner.exitViewPortalMode()\"></button>\n" +
    "    </div>\n" +
    "</header>\n" +
    "");
}]);

angular.module("my-account/link-auth/link-auth-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("my-account/link-auth/link-auth-modal.2js.html",
    "<form name=\"vm.verifyLoginForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <div class=\"bento-modal\" bento-busy-loader=\"vm.isLoaderBusy\" bento-busy-loader-size=\"default\">\n" +
    "    <h3 class=\"modal-header\" translate=\"BM.Components.EmailInUseHeader\"></h3>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <p translate=\"BM.Components.AccountLinkDescription\"></p>\n" +
    "        <!-- Commenting out for now, but may be needed for later -->\n" +
    "        <!-- <a translate=\"BM.Components.TRID\"></a> -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-sm-8\">\n" +
    "                <div class=\"form-group\" ng-class=\"{'has-error' : vm.verifyLogin.pwd.$invalid && ((vm.verifyLogin.pwd.$touched && vm.verifyLogin.pwd.$dirty) || vm.verifyLogin.$submitted)}\">\n" +
    "                    <label for=\"pwd\"><span translate=\"bm.components.common.password\"></span> *</label>\n" +
    "                    <input class=\"form-control\" type=\"password\" id=\"pwd\" name=\"pwd\" ng-model=\"vm.pwd\" bm-focus=\"true\" required />\n" +
    "                    <div class=\"msg\" ng-messages=\"vm.verifyLogin.pwd.$error\" ng-if=\"vm.verifyLogin.pwd.$touched || vm.verifyLogin.$submitted\">\n" +
    "                        <span ng-message=\"required\">{{'bm.header.checkpoint.passwordRequired'|translate}}</span>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button type=\"submit\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.linkAccounts()\" translate=\"Bluemoon.Components.Common.Actions.LinkAccounts\"></button>\n" +
    "        <button type=\"button\" class=\"btn btn-default bm-animate-if\" ng-click=\"vm.changeEmail()\" translate=\"Bluemoon.Components.Common.Actions.ChangeEmail\"></button>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</form>\n" +
    "\n" +
    "");
}]);

angular.module("my-account/my-account-licensee.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("my-account/my-account-licensee.2js.html",
    "<form name=\"vm.myAccountForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <h3 class=\"bm-modal-title\" translate=\"bm.header.accountDialog.header\"></h3>\n" +
    "  <!-- show a banner that looks like an alert -->\n" +
    "  <div ng-if=\"vm.user\" class=\"bento-alert-container bm-profile-btm-margin\">\n" +
    "    <div class=\"alert bento-alert alert-info\" role=\"alert\" translate=\"bm.header.viewProfile.licenseeBanner\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div ng-if=\"vm.user\" class=\"bm-animate-if\">\n" +
    "    <!-- name -->\n" +
    "    <div class=\"row bm-profile-btm-margin\">\n" +
    "      <div class=\"col-sm-8 col-md-6\">\n" +
    "        <span translate=\"bm.header.viewProfile.nameLabel\"></span>: {{ vm.localUser.fullName }}\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <!-- email -->\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-sm-8 col-md-6\">\n" +
    "        <div class=\"form-group\" ng-class=\"{ 'has-error': vm.userIdError !== ''}\">\n" +
    "          <label for=\"userId\"><span translate=\"bm.header.accountDialog.emailLabel\"></span> *</label>\n" +
    "          <input class=\"form-control\" type=\"email\" id=\"userId\" name=\"userId\" ng-model=\"vm.localUser.email\" ng-blur='vm.validateUserId(false)' bm-validate-email required>\n" +
    "          <div class=\"msg\">{{ vm.userIdError }}</div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-required bm-required-fields\" ng-if=\"vm.localUser\">\n" +
    "      * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"modal-footer\">\n" +
    "    <button type=\"submit\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.saveUser()\" ng-if=\"vm.user\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "    <button type=\"button\" class=\"btn btn-default bm-animate-if\" ng-click=\"vm.cancelUser()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "  </div>\n" +
    "  <!-- alerts -->\n" +
    "  <div bento-alert bento-alert-object=\"vm.alerts\"></div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("my-account/my-account-skinny.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("my-account/my-account-skinny.2js.html",
    "<form name=\"vm.myAccountForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <h3 class=\"bm-modal-title\" translate=\"bm.header.accountDialog.header\"></h3>\n" +
    "  <div ng-if=\"vm.user\" class=\"bm-animate-if\">\n" +
    "    <!-- email -->\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-sm-8 col-md-6\">\n" +
    "        <div class=\"form-group\" ng-class=\"{ 'has-error': vm.userIdError !== ''}\">\n" +
    "          <label for=\"userId\"><span translate=\"bm.header.accountDialog.emailLabel\"></span> *</label>\n" +
    "          <input class=\"form-control\" type=\"email\" id=\"userId\" name=\"userId\" ng-model=\"vm.localUser.email\" ng-blur='vm.validateUserId(false)' bm-validate-email required>\n" +
    "          <div class=\"msg\">{{ vm.userIdError }}</div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <!-- name -->\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-4 col-md-2\">\n" +
    "            <div class=\"form-group\">\n" +
    "                <label for=\"prefix\" translate=\"BM.Components.AccountInformation.Prefix\"></label>\n" +
    "                <div bento-select>\n" +
    "                  <select name=\"prefix\"\n" +
    "                    class=\"form-control\"\n" +
    "                    ng-model=\"vm.selectedPrefix\"\n" +
    "                    ng-options=\"prefix.description for prefix in vm.prefixList track by prefix.description\"\n" +
    "                  >\n" +
    "                    <option value=\"\"></option>\n" +
    "                  </select>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-sm-4 col-md-3\">\n" +
    "            <div class=\"form-group\" ng-class=\"{'has-error' : (vm.myAccountForm.firstName.$error.required && vm.myAccountForm.firstName.$dirty)}\">\n" +
    "          <label for=\"firstName\"><span translate=\"BM.Components.AccountInformation.FirstName\"></span> *</label>\n" +
    "              <input class=\"form-control\" type=\"text\" id=\"firstName\" name=\"firstName\" ng-model=\"vm.localUser.firstName\" required />\n" +
    "              <div class=\"msg\" translate=\"BM.Components.AccountInformation.FirstNameInstructions\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"col-sm-4 col-md-2\">\n" +
    "        <div class=\"form-group\">\n" +
    "            <label for=\"middleName\" translate=\"BM.Components.AccountInformation.MiddleName\"></label>\n" +
    "            <input class=\"form-control\" type=\"text\" id=\"middleName\" name=\"middleName\" ng-model=\"vm.localUser.middleName\" />\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"col-sm-4 col-md-3\">\n" +
    "        <div class=\"form-group\" ng-class=\"{'has-error' : (vm.myAccountForm.lastName.$error.required && vm.myAccountForm.lastName.$dirty)}\">\n" +
    "          <label for=\"lastName\"><span translate=\"BM.Components.AccountInformation.LastName\"></span> *</label>\n" +
    "          <input class=\"form-control\" type=\"text\" id=\"lastName\" name=\"lastName\" ng-model=\"vm.localUser.lastName\" required />\n" +
    "          <div class=\"msg\" translate=\"BM.Components.AccountInformation.LastName.Instructions\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"col-sm-4 col-md-2\">\n" +
    "        <div class=\"form-group\">\n" +
    "          <label for=\"suffix\" translate=\"BM.Components.AccountInformation.Suffix\"></label>\n" +
    "            <div bento-select>\n" +
    "              <select name=\"suffix\"\n" +
    "                class=\"form-control\"\n" +
    "                ng-model=\"vm.selectedSuffix\"\n" +
    "                ng-options=\"suffix.description for suffix in vm.suffixList track by suffix.description\"\n" +
    "              >\n" +
    "                <option value=\"\"></option>\n" +
    "              </select>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-required bm-required-fields\" ng-if=\"vm.localUser\">\n" +
    "        * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"modal-footer\">\n" +
    "      <button type=\"submit\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.saveUser()\" ng-if=\"vm.user\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "      <button type=\"button\" class=\"btn btn-default bm-animate-if\" ng-click=\"vm.cancelUser()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "  </div>\n" +
    "  <!-- alerts -->\n" +
    "  <div bento-alert bento-alert-object=\"vm.alerts\"></div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("my-account/my-account.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("my-account/my-account.2js.html",
    "<form name=\"vm.myAccountForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "  <h3 class=\"bm-modal-title\" translate=\"bm.header.accountDialog.header\"></h3>\n" +
    "  <!-- Error -->\n" +
    "  <!-- make it look like bento-alert -->\n" +
    "  <div class=\"bento-alert-container\" ng-if=\"!vm.showTerms && vm.alerts.length > 0\">\n" +
    "      <div ng-repeat=\"alert in vm.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success': alert.type === 'success', 'alert-warning': alert.type === 'warning', 'alert-info': alert.type === 'info', 'alert-danger': alert.type === 'danger'}\">\n" +
    "          <span>\n" +
    "              {{alert.msg}}\n" +
    "          </span>\n" +
    "      </div>\n" +
    "  </div>\n" +
    "  <div class=\"bm-animate-if\" ng-if=\"vm.showTerms\">\n" +
    "    <h3 translate=\"bm.terms.signatory.title\"></h3>\n" +
    "    <div class=\"bm-terms-signatory\">\n" +
    "      <div class=\"bm-signatory-view\" ng-bind-html=\"vm.termsDisplayText\"></div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div ng-if=\"vm.user && !vm.showTerms\" class=\"bm-animate-if\">\n" +
    "    <!-- email -->\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-sm-8 col-md-6\">\n" +
    "        <div class=\"form-group\" ng-class=\"{ 'has-error': vm.userIdError !== ''}\">\n" +
    "          <label for=\"userId\"><span translate=\"bm.header.accountDialog.emailLabel\"></span> *</label>\n" +
    "          <div>\n" +
    "              <input class=\"form-control\" type=\"email\" id=\"userId\" name=\"userId\" ng-model=\"vm.localUser.email\" ng-blur='vm.validateUserId(false)' bm-validate-email required>\n" +
    "          </div>\n" +
    "          <div class=\"msg\">{{ vm.userIdError }}</div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <!-- name -->\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-4 col-md-2\">\n" +
    "            <div class=\"form-group\">\n" +
    "                <label for=\"prefix\" translate=\"BM.Components.AccountInformation.Prefix\"></label>\n" +
    "                <div bento-select>\n" +
    "                  <select name=\"prefix\"\n" +
    "                    class=\"form-control\"\n" +
    "                    ng-model=\"vm.selectedPrefix\"\n" +
    "                    ng-options=\"prefix.description for prefix in vm.prefixList track by prefix.description\"\n" +
    "                  >\n" +
    "                    <option value=\"\"></option>\n" +
    "                  </select>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-sm-4 col-md-3\">\n" +
    "            <div class=\"form-group\" ng-class=\"{'has-error' : (vm.myAccountForm.firstName.$error.required && vm.myAccountForm.firstName.$dirty)}\">\n" +
    "          <label for=\"firstName\"><span translate=\"BM.Components.AccountInformation.FirstName\"></span> *</label>\n" +
    "              <input class=\"form-control\" type=\"text\" id=\"firstName\" name=\"firstName\" ng-model=\"vm.localUser.firstName\" required />\n" +
    "              <div class=\"msg\" translate=\"BM.Components.AccountInformation.FirstNameInstructions\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"col-sm-4 col-md-2\">\n" +
    "        <div class=\"form-group\">\n" +
    "            <label for=\"middleName\" translate=\"BM.Components.AccountInformation.MiddleName\"></label>\n" +
    "            <input class=\"form-control\" type=\"text\" id=\"middleName\" name=\"middleName\" ng-model=\"vm.localUser.middleName\" />\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"col-sm-4 col-md-3\">\n" +
    "        <div class=\"form-group\" ng-class=\"{'has-error' : (vm.myAccountForm.lastName.$error.required && vm.myAccountForm.lastName.$dirty)}\">\n" +
    "          <label for=\"lastName\"><span translate=\"BM.Components.AccountInformation.LastName\"></span> *</label>\n" +
    "          <input class=\"form-control\" type=\"text\" id=\"lastName\" name=\"lastName\" ng-model=\"vm.localUser.lastName\" required />\n" +
    "          <div class=\"msg\" translate=\"BM.Components.AccountInformation.LastName.Instructions\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"col-sm-4 col-md-2\">\n" +
    "        <div class=\"form-group\">\n" +
    "          <label for=\"suffix\" translate=\"BM.Components.AccountInformation.Suffix\"></label>\n" +
    "            <div bento-select>\n" +
    "              <select name=\"suffix\"\n" +
    "                class=\"form-control\"\n" +
    "                ng-model=\"vm.selectedSuffix\"\n" +
    "                ng-options=\"suffix.description for suffix in vm.suffixList track by suffix.description\"\n" +
    "              >\n" +
    "                <option value=\"\"></option>\n" +
    "              </select>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <!-- language -->\n" +
    "    <div class=\"row\" ng-if=\"vm.languageList.length > 1\">\n" +
    "      <div class=\"col-sm-8 col-md-4\">\n" +
    "        <div class=\"form-group\" ng-class=\"{ 'has-error': vm.myAccountForm.language.$dirty && vm.myAccountForm.language.$invalid }\">\n" +
    "            <label for=\"language\"><span translate=\"bm.header.accountDialog.languageLabel\"></span> *</label>\n" +
    "            <bm-language-select name=\"language\" selected-language-code=\"vm.localUser.language\" include-empty-option=\"false\" selection-required=\"true\" on-change=\"vm.languageChanged(language)\"></bm-language-select>\n" +
    "            <div class=\"msg\" translate=\"bm.header.accountDialog.languageRequiredError\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-required bm-required-fields\" ng-if=\"vm.localUser\">\n" +
    "        * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"modal-footer\">\n" +
    "      <button type=\"submit\" class=\"btn btn-primary bm-animate-if\" ng-click=\"vm.saveUser()\" ng-if=\"vm.user && !vm.showTerms\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "      <button type=\"button\" class=\"btn btn-default bm-animate-if\" ng-click=\"vm.cancelUser()\" ng-if=\"!vm.showTerms\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "      <a role=\"button\" class=\"btn btn-link bm-animate-if\" ng-click=\"vm.showTerms=true\" ng-if=\"!vm.showStaffTerms && vm.hasTermsSignatory && !vm.showTerms\" translate=\"bm.header.accountDialog.showTerms\"></a>\n" +
    "      <a role=\"button\" class=\"btn btn-link bm-animate-if\" ng-click=\"vm.showTerms=false\" ng-if=\"!vm.showStaffTerms && vm.hasTermsSignatory && vm.showTerms\" translate=\"bm.header.accountDialog.hideTerms\"></a>\n" +
    "      <a role=\"button\" class=\"btn btn-link bm-animate-if\" href=\"{{vm.termsLink}}\" target=\"_blank\" ng-if=\"vm.showStaffTerms\" translate=\"bm.header.accountDialog.showTerms\"></a>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("security-questions/security-questions.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("security-questions/security-questions.2js.html",
    "<form name=\"vm.securityQuestionsForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "    <h3 class=\"bm-modal-title\" translate=\"BM.Components.SecurityQuestions.Header\"></h3>\n" +
    "    <!-- Error -->\n" +
    "    <!-- make it look like bento-alert -->\n" +
    "    <div class=\"bento-alert-container\" ng-if=\"vm.alerts.length > 0\">\n" +
    "        <div ng-repeat=\"alert in vm.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success': alert.type === 'success', 'alert-warning': alert.type === 'warning', 'alert-info': alert.type === 'info', 'alert-danger': alert.type === 'danger'}\">\n" +
    "            <span>\n" +
    "                {{alert.msg}}\n" +
    "            </span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.questions.length > 0\">\n" +
    "      <div ng-repeat=\"question in vm.questions\">\n" +
    "        <div class=\"row\">\n" +
    "          <div class=\"col-sm-12\">\n" +
    "            <div class=\"form-group\" ng-class=\"{ 'has-error': question.questionError !== ''}\">\n" +
    "              <label for=\"question{{ $index + 1 }}\"><span translate=\"BM.Components.SecurityQuestion.QuestionTag\"></span> {{ $index + 1 }} *</label>\n" +
    "              <div bento-select>\n" +
    "                <select\n" +
    "                  name=\"question{{ $index + 1 }}\"\n" +
    "                  id=\"question{{ $index + 1 }}\"\n" +
    "                  ng-model=\"question.selectedQuestion\"\n" +
    "                  ng-options=\"masterQuestion.question for masterQuestion in question.masterList track by masterQuestion.questionId\"\n" +
    "                  ng-change=\"vm.processQuestionSelect($index, question)\"\n" +
    "                  class=\"form-control\">\n" +
    "                  <option value=\"\"></option>\n" +
    "                </select>\n" +
    "              </div>\n" +
    "              <div class=\"msg\">{{ question.questionError }}</div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "          <div class=\"col-sm-12\">\n" +
    "            <div class=\"form-group\" ng-class=\"{ 'has-error': question.answerError !== '', 'bm-form-group-pair': ($index + 1) !== vm.questions.length }\">\n" +
    "              <label for=\"answer{{ $index + 1 }}\"><span translate=\"BM.Components.SecurityQuestion.AnswerTag\"></span> *</label>\n" +
    "              <input class=\"form-control\" type=\"text\" id=\"answer{{ $index + 1 }}\" name=\"answer{{ $index + 1 }}\" ng-model=\"question.answer\" ng-blur=\"vm.validateAnswer(question, false)\" ng-focus=\"vm.clearDefaultAnswer(question)\" />\n" +
    "              <div class=\"msg\">{{ question.answerError }}</div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-required bm-required-fields\" ng-if=\"vm.questions.length > 0\">\n" +
    "        * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button type=\"submit\" class=\"btn btn-primary btn-circ btn-dynamic\" ng-click=\"vm.saveQuestions()\" ng-if=\"vm.questions.length > 0\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "        <button type=\"button\" class=\"btn btn-default btn-circ btn-dynamic\" ng-click=\"vm.cancelQuestions()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "  </div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("update-password/update-password.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("update-password/update-password.2js.html",
    "<form name=\"vm.updatePasswordForm\" role=\"form\" class=\"css-form\" novalidate>\n" +
    "    <h3 class=\"bm-modal-title\" translate=\"BM.Components.UpdatePassword\"></h3>\n" +
    "    <!-- Error -->\n" +
    "    <!-- make it look like bento-alert -->\n" +
    "    <div class=\"bento-alert-container\" ng-if=\"vm.alerts.length > 0 && !vm.isSkinny\">\n" +
    "        <div ng-repeat=\"alert in vm.alerts\" class=\"alert bento-alert alert-dismissable\" role=\"alert\" ng-class=\"{'alert-success': alert.type === 'success', 'alert-warning': alert.type === 'warning', 'alert-info': alert.type === 'info', 'alert-danger': alert.type === 'danger'}\">\n" +
    "            <span>\n" +
    "                {{alert.msg}}\n" +
    "            </span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <div class=\"form-group\" ng-class=\"{ 'has-error': vm.updatePasswordForm.currentPassword.$error.required && vm.updatePasswordForm.currentPassword.hasVisited }\">\n" +
    "                <label for=\"currentPassword\"><span translate=\"BM.Components.UpdatePassword.CurrentPassword\"></span> *</label>\n" +
    "                <a href class=\"pull-right no-underline\" ng-click=\"vm.showPassword = !vm.showPassword\">\n" +
    "                 <span ng-if=\"vm.showPassword == true\">\n" +
    "                    <span translate=\"BM.Components.UpdatePassword.Hide\">\n" +
    "                    </span>\n" +
    "                </span>\n" +
    "                <span ng-if =\"vm.showPassword == false || vm.showPassword == undefined\">\n" +
    "                    <span translate=\"BM.Components.UpdatePassword.Show\">\n" +
    "                    </span>\n" +
    "                </span></a>\n" +
    "                <input class=\"form-control\" id=\"currentPassword\" name=\"currentPassword\" bm-focus=\"true\" type=\"{{ vm.showPassword ? 'text' : 'password' }}\" ng-model=\"vm.currentPassword\" required maxlength=\"50\"/>\n" +
    "                <div class=\"msg\" translate=\"BM.Components.UpdatePassword.CurrentPassword.Instructions\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <div class=\"form-group\" ng-class=\"{ 'has-error': vm.newPasswordError !== ''}\">\n" +
    "                <label for=\"newPassword\" ><span translate=\"BM.Components.UpdatePassword.NewPassword\"></span> *</label>\n" +
    "                <input class=\"form-control\" id=\"newPassword\" name=\"newPassword\" type=\"{{ vm.showPassword ? 'text' : 'password' }}\" ng-model=\"vm.newPassword\" ng-blur=\"vm.validatePasswordFields(false)\" required maxlength=\"50\"/>\n" +
    "                <div class=\"msg\">{{ vm.newPasswordError }}</div>\n" +
    "                <div class=\"bm-msg-valid\" ng-show=\"vm.newPasswordError === '' && vm.passwordIsValidated\">\n" +
    "                    <span class=\"glyphicon glyphicon-ok\"></span>\n" +
    "                    <span translate=\"BM.Components.UpdatePassword.PasswordAcceptable\"></span>\n" +
    "                </div>\n" +
    "                <div bm-password-validation password=\"vm.newPassword\" ng-show=\"vm.updatePasswordForm.newPassword.hasFocus\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <div class=\"form-group\" ng-class=\"{ 'has-error': vm.isConfirmPasswordInvalid()}\">\n" +
    "                 <label for=\"confirmPassword\"><span translate=\"BM.Components.UpdatePassword.ConfirmPassword\"></span> *</label>\n" +
    "                <input class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" type=\"{{ vm.showPassword ? 'text' : 'password' }}\" ng-model=\"vm.confirmPassword\" ng-blur=\"vm.setConfirmPasswordOutOfFocus()\" ng-focus=\"vm.setConfirmPasswordInFocus()\" maxlength=\"50\"/>\n" +
    "                <div class=\"msg\">{{ vm.confirmPasswordError }}</div>\n" +
    "                <div class=\"bm-msg-valid\" ng-show=\"vm.isConfirmPasswordValid() && vm.newPasswordError === ''\">\n" +
    "                    <span class=\"glyphicon glyphicon-ok\"></span>\n" +
    "                    <span translate=\"BM.Components.UpdatePassword.PasswordConfirmed\"></span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-required bm-required-fields\">\n" +
    "        * <span translate=\"bm.components.common.requiredField\"></span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button type=\"submit\" class=\"btn btn-primary btn-circ btn-dynamic\" ng-click=\"vm.savePassword()\" translate=\"Bluemoon.Components.Common.Actions.Save\"></button>\n" +
    "        <button type=\"button\" class=\"btn btn-default btn-circ btn-dynamic\" ng-click=\"vm.cancelPassword()\" translate=\"Bluemoon.Components.Common.Actions.Cancel\"></button>\n" +
    "    </div>\n" +
    "    <!-- alerts -->\n" +
    "    <div bento-alert bento-alert-object=\"vm.alerts\" ng-if=\"vm.isSkinny\"></div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("user-profile/view-profile-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("user-profile/view-profile-modal.2js.html",
    "<div class=\"bento-modal bm-profile\">\n" +
    "  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"vm.closeProfile()\">\n" +
    "    <i class=\"bento-icon-close-x\"></i>\n" +
    "  </button>\n" +
    "  <div class=\"modal-header\" translate=\"bm.header.userMenu.toggle\"></div>\n" +
    "  <div class=\"modal-body bm-modal-body\">\n" +
    "    <uib-tabset class=\"tabs-left bm-tab-animation\">\n" +
    "      <!-- account information -->\n" +
    "      <uib-tab data-qed-id=\"bm-profile-acct-tab\" deselect=\"vm.tabDeselect('account')\">\n" +
    "        <uib-tab-heading>\n" +
    "          <span translate=\"bm.header.viewProfile.account\"></span><i class=\"bento-icon-warning bm-unsaved-changes\" title=\"{{vm.translatedUnsaved}}\" aria-hidden=\"true\" ng-if=\"vm.sharedProfile.hasUnsavedAccount\"></i>\n" +
    "        </uib-tab-heading>\n" +
    "        <bm-my-account-info languages=\"vm.languages\" user=\"vm.user\" shared-data=\"vm.sharedProfile\"></bm-my-account-info>\n" +
    "      </uib-tab>\n" +
    "      <!-- change password -->\n" +
    "      <uib-tab data-qed-id=\"bm-profile-chgpwd-tab\" deselect=\"vm.tabDeselect('password')\">\n" +
    "        <uib-tab-heading>\n" +
    "          <span translate=\"bm.header.viewProfile.password\"></span><i class=\"bento-icon-warning bm-unsaved-changes\" title=\"{{vm.translatedUnsaved}}\" aria-hidden=\"true\" ng-if=\"vm.sharedProfile.hasUnsavedPassword\"></i>\n" +
    "        </uib-tab-heading>\n" +
    "        <bm-update-password user=\"vm.user\" shared-data=\"vm.sharedProfile\"></bm-update-password>\n" +
    "      </uib-tab>\n" +
    "      <!-- linked accounts -->\n" +
    "      <uib-tab data-qed-id=\"bm-profile-linked-accts-tab\" select=\"vm.tabSelect('linkedAccounts')\" deselect=\"vm.tabDeselect('linkedAccounts')\" bm-if-has-access=\"PPE-AccountSwitching\">\n" +
    "        <uib-tab-heading>\n" +
    "            <div class=\"bm-multi-tab-heading bm-multi-tab-center\">\n" +
    "              <span translate=\"bm.header.viewProfile.linkedAccounts\"></span>\n" +
    "              <i class=\"bento-icon-warning bm-multi-tab-unsaved-changes\" title=\"{{vm.translatedUnsaved}}\" aria-hidden=\"true\" ng-if=\"vm.sharedProfile.hasUnsavedLinkedAccounts\"></i>\n" +
    "            </div>\n" +
    "        </uib-tab-heading>\n" +
    "        <bm-linked-accounts user=\"vm.user\" shared-data=\"vm.sharedProfile\"></bm-linked-accounts>\n" +
    "      </uib-tab>\n" +
    "      <!-- multifactor authentication -->\n" +
    "      <uib-tab data-qed-id=\"bm-profile-mfa-tab\" deselect=\"vm.tabDeselect('multi')\" bm-if-has-access=\"Platform_Enable2FA\">\n" +
    "        <uib-tab-heading>\n" +
    "          <span translate=\"bm.header.viewProfile.multifactorTitle\"></span>\n" +
    "        </uib-tab-heading>\n" +
    "        <bm-multifactor-profile user-data=\"vm.user\"></bm-multifactor-profile>\n" +
    "      </uib-tab>\n" +
    "      <!-- checkpoint engage credentials -->\n" +
    "      <uib-tab data-qed-id=\"bm-profile-ce-creds-tab\" deselect=\"vm.tabDeselect('checkpoint')\" bm-if-perm=\"Applications.CheckpointEngage\">\n" +
    "        <uib-tab-heading>\n" +
    "          <div class=\"bm-multi-tab-heading bm-multi-tab-center\">\n" +
    "            <span translate=\"bm.header.viewProfile.checkPointCredentials\"></span><i class=\"bento-icon-warning bm-unsaved-changes\" title=\"{{vm.translatedUnsaved}}\" aria-hidden=\"true\" ng-if=\"vm.sharedProfile.hasUnsavedCheckpoint\"></i>\n" +
    "          </div>\n" +
    "        </uib-tab-heading>\n" +
    "        <bm-checkpoint-credentials shared-data=\"vm.sharedProfile\"></bm-checkpoint-credentials>\n" +
    "      </uib-tab>\n" +
    "    </uib-tabset>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

/**
 * Blue Moon Components - App Directive
 */

// Global bluemoon-components-app
var bmcomponents;

(function(angular){
    'use strict';

    bmcomponents = angular.module('bluemoon.components.app', [
        'matchmedia-ng',
        'bluemoon.components.session',
        'bmUser'
    ])
        // PROD perf boost (missing fn in 1.2.25)
        // .config(['$compileProvider', function ($compileProvider) {
        //     var isNotProd = !/^onvio/.test(location.hostname);
        //     $compileProvider.debugInfoEnabled(isNotProd);
        // }])
        .directive('bmApp', bmApp);

    // guid used for replace in build process
    bmcomponents.version = '20.3.29';

    bmApp.$inject = ['$document', '$log', 'matchmedia', 'AuthenticatedSession', 'bmUser'];

    function bmApp($document, $log, matchmedia, authenticatedSession, bmUser) {

        return {
            restrict: 'EA',
            controller: [function() {}],
            link: function (scope, element, attrs) {
                var html = $document.find('html');

                if (attrs.bmApp !== 'pre-auth') {
                    /* load intrinsic post-auth objects */
                    authenticatedSession.load().then(function(data) {
                        $log.log('session:', { meta: data.meta, bindings: data.bindings });
                    }).finally(function() {
                        html.addClass('bm-resolved');
                    });
                    bmUser.load();
                }

                /* Mobile first cumulative media classes */

                /* Large devices (large desktops, 1200px and up) */
                var offMatchLg = matchmedia.on('(min-width: 1200px)', function(mql){
                    html.toggleClass('media-screen-lg-min', mql.matches);
                });
                /* Medium devices (desktops, 992px and up) */
                var offMatchMd = matchmedia.on('(min-width: 992px)', function(mql){
                    html.toggleClass('media-screen-md-min', mql.matches);
                });
                /* Small devices (tablets, 768px and up) */
                var offMatchSm = matchmedia.on('(min-width: 768px)', function(mql){
                    html.toggleClass('media-screen-sm-min', mql.matches);
                });
                /* XSmall default (phones, 0px and up) */
                var offMatchXs = matchmedia.on('(min-width: 0px)', function(mql){
                    html.toggleClass('media-screen-xs-min', mql.matches);
                });

                // cleanup
                element.on('$destroy', function () {
                    offMatchXs();
                    offMatchSm();
                    offMatchMd();
                    offMatchLg();
                });
            }
        };
    }

})(window.angular);

/**
 * Blue Moon Components - Header Directive
 */
(function(angular){
    'use strict';

    function bmHeader($window, $document, $rootScope, bmUtil, authenticatedSessionData) {

        return {
            restrict: 'EA',
            templateUrl: 'components/header/header.2js.html',
            transclude: true,
            require: '^bmApp',
            controller: bmHeaderCtrl,
            controllerAs: 'header',

            link: function (scope, element, attrs) {
                var html = angular.element($document[0].documentElement);
                var appLinkList = element[0].querySelector('#bm-header-app-menu ul');

                if (angular.isDefined(attrs.hidemenus)) {
                    scope.header.hideMenus = true;
                }

                // get app menu links after they render,
                // and disable the link that is the current app
                authenticatedSessionData.getBindings().then(function () {
                    setTimeout(function () {
                        var appLinks = appLinkList.querySelectorAll('a');
                        [].forEach.call(appLinks, function(link) {
                            if (link.href && location.href.indexOf(link.href) === 0) {
                                //jshint scripturl:true
                                link.href = 'javascript:void(0)';
                                link.target = '';
                                link.classList.add('selected');
                                return false;
                            }
                        });
                    }, 0);
                });

                scope.header.toggleLeftMenuMaskActive = function(force) {
                    scope.header.closeDropDowns();
                    html.toggleClass('left-menu-mask-active', force);
                };

                scope.header.toggleRightMenuMaskActive = function(force) {
                    scope.header.closeDropDowns();
                    html.toggleClass('right-menu-mask-active', force);
                };

                function windowResized() {
                    var applyNeeded = false;

                    if (scope.header.isAppsDropdownOpen ||
                        scope.header.isMsgsDropdownOpen ||
                        scope.header.isHelpDropdownOpen ||
                        scope.header.isTimerDropdownOpen ||
                        scope.header.isUserDropdownOpen ||
                        scope.header.isLinkedAccountsDropdownOpen) {

                        scope.header.closeDropDowns();
                        applyNeeded = true;
                    }

                    if (applyNeeded) {
                        scope.$apply();
                    }
                }

                // perform window resize actions
                $window.addEventListener('resize', windowResized, false);

                var offLocChgStart = $rootScope.$on('$locationChangeStart', bmUtil.debounce(scope.header.clearMenuActive, 500));

                var offLocChgSuccess = $rootScope.$on('$locationChangeSuccess', bmUtil.debounce(scope.header.updateCustomizedLinks, 500));

                // listeners
                var rmProfPhotoSelectedEvtListener = scope.$on('bmProfilePhotoSelected', scope.header.user.save);

                // authenticatedSessionData.getBindings().then(function(data) {
                //     theme.loadHeader(data.ApplicationConfiguration.CompanyId);
                // });

                // cleanup
                element.on('$destroy', function () {
                    $window.removeEventListener('resize', windowResized, false);
                    offLocChgStart();
                    offLocChgSuccess();
                    rmProfPhotoSelectedEvtListener();
                });
            }
        };
    }

    function bmHeaderCtrl(
        $window,
        $log,
        $rootScope,
        $q,
        $timeout,
        $uibModal,
        $location,
        $translate,
        $scope,
        authenticatedSession,
        bmUser,
        theme,
        myAccountService,
        bmAccess,
        bmPermission,
        bmLicense,
        bmModal,
        bmJobQueue,
        notificationsManager,
        bmUtil,
        bmAnalyticsService,
        csScheduleItemV3,
        LinkedAccountsService,
        $injector,
        $document
    )
    {
        var self = this; // jshint ignore:line
        self.session = authenticatedSession.data;
        self.user = bmUser;
        self.theme = theme.data;
        self.hasStaffApp = false;
        self.hasClientApp = false;
        self.appMenuActive = false;
        self.profileMenuActive = false;
        self.totalUnreadCount = 0;
        self.unreadNotificationsCount = -1;
        self.unreadMessagesCount = -1;
        self.hasClientDashboard = false;
        self.clientSpecificUrl = '';
        self.clientSpecificTitle = '';
        self.hasPrefs = false;
        self.isHelpDropdownOpen = false;
        // needed for linked accounts
        self.linkedAccounts = [];
        self.selectedLinkedAccount = undefined;

        self.showLinkedAccountsMenu = false;
        self.linkedAccountFound = false;
        self.sharedProfile = {};
        self.isLoaderBusy = false;
        self.hasCCVNextIAC = false;
        self.hasCCVNextFRP = false;
        var linkedAccountSessionToken;
        // optional dependency on $state for user-preferences
        var $state = $injector.has('$state') ? $injector.get('$state') : null;

        bmAccess.not('ClientCenterVnext').then(function() {
            self.hasCCVNextIAC = true;
        }).catch(function(error) {
            if (error !== false) {
                console.error('Error checking IAC ClientCenterVnext');
            }
        });

        bmPermission.not('Platform.ccVnext').then(function() {
            self.hasCCVNextFRP = true;
        }).catch(function(error) {
            if (error !== false) {
                console.error('Error checking FRP Platform.ccVnext');
            }
        });

        self.hasApps = function() {
            var frp = authenticatedSession.data.bindings.FeatureResourcePermissions;
            return frp ? Object.keys(frp.FeatureResourcePermissionsMap.Applications).length > 1 : false;
        };
        self.clearMenuActive = function() {
            self.clearAppMenuActive();
            self.clearProfileMenuActive();
        };
        self.clearAppMenuActive = function() {
            if (self.appMenuActive) {
                self.appMenuActive = false;
                self.toggleLeftMenuMaskActive(self.appMenuActive);
                bmAnalyticsService.track('Header App Menu Closed', { label: 'closeAppList' });
            }
        };
        self.clearProfileMenuActive = function() {
            if (self.profileMenuActive) {
                self.profileMenuActive = false;
                self.toggleRightMenuMaskActive(self.profileMenuActive);
                $rootScope.$broadcast('bmProfileMenuClosed');
            }
        };
        self.toggleAppMenuActive = function() {
            $timeout(function() {
                self.appMenuActive = !self.appMenuActive;
                self.toggleLeftMenuMaskActive(self.appMenuActive);

                if(self.appMenuActive){
                    $rootScope.$broadcast('bmAppMenuOpened');
                    bmAnalyticsService.track('Header App Menu Opened', { label: 'openAppList' });
                }
            });
        };
        self.toggleProfileMenuActive = function() {
            self.profileMenuActive = !self.profileMenuActive;
            self.toggleRightMenuMaskActive(self.profileMenuActive);

            if(self.profileMenuActive){
                $rootScope.$broadcast('bmProfileMenuOpened');
            }
        };
        self.closeDropDowns = function() {
            self.isAppsDropdownOpen = false;
            self.isMsgsDropdownOpen = false;
            self.isHelpDropdownOpen = false;
            self.isTimerDropdownOpen = false;
            self.isUserDropdownOpen = false;
            self.isLinkedAccountsDropdownOpen = false;
        };
        self.updateCustomizedLinks = function() {
            self.updateCustomizedProjectLinks();
        };
        self.updateCustomizedProjectLinks = function() {
            var currentUrl = $location.path();

            //start by assuming this isn't customized
            self.clientSpecificUrl = '';
            self.clientSpecificTitle = '';

            // inspect the new url for /projects/UUID
            // if we find it, load the project and update client dashboard link
            if(currentUrl.indexOf('/projects/') > -1) {
                // get everything after that and check for a UUID
                var substring = currentUrl.substring(currentUrl.indexOf('/projects/') + 10);
                if(substring.length > 32) {
                    substring = substring.substring(0, 32);
                }
                if(substring.match(/\w{32}/)) {
                    // assuming we didn't find anything that isn't a word character, try loading the project
                    csScheduleItemV3.get({'scheduleItemId': substring}).then(function(scheduleItem) {
                        if(scheduleItem && scheduleItem.client && scheduleItem.client.id && scheduleItem.client.name) {
                            self.clientSpecificUrl = '/' + scheduleItem.client.id;
                            self.clientSpecificTitle = ': ' + scheduleItem.client.name;
                        }
                    });
                }
            }
        };

        var jwt; // cache jwt
        self.sso = function($event) {
            var link = $event.currentTarget;
            var href = link.href;
            var tokenType = 'UDSLongToken';
            var token = bmUtil.cookie(tokenType);
            if (!jwt) { // lazy jwt
                // get jwt given a UDSLongToken
                // make it synchronous ($http can't do sync) so we avoid window.open and popup blockers
                // not great, but the deprecation warning is a bluff
                var xhr = new $window.XMLHttpRequest();
                xhr.open('POST', '/api/security/v1/jwt/sessions', false); // false = synchronous
                xhr.setRequestHeader('Authorization', tokenType + ' ' + token);
                xhr.onreadystatechange = function() {
                    if (xhr.readyState !== 4 || xhr.status !== 201) { return; }
                    jwt = JSON.parse(xhr.responseText).token;
                };
                xhr.send();
                $log.info('Sorry, while we are aware that synchronous XHR is generally bad, in this case it is intentional.');
            }
            if (!jwt) { return; }
            link.href = href + (/\?/.test(href) ? '&' : '?') + 'token=' + jwt;
            // don't leave jwt laying around
            setTimeout(function() { link.href = href; }, 0);
        };

        self.launchApp = function($event) {
            var link = $event.currentTarget;
            var href = link.href;

            bmAnalyticsService.track('External App Launched', {
                app: $event.currentTarget.parentElement.getAttribute('bm-if-perm'),
                url: href,
                label: 'appLaunch'
            });

            self.clearAppMenuActive();
        };
        self.showUnauthorizedModal = function () {
            bmModal.modal({
                templateUrl: 'components/modal/modal-default.2js.html',
                showClose: false,
                vars: {
                    body: $translate.instant('bm.header.previewTrial.previewMode.UnauthorizedBody'),
                    title: $translate.instant('bm.header.previewTrial.previewMode.UnauthorizedTitle')
                },
                buttons: [
                    { text: $translate.instant('bm.header.previewTrial.previewMode.OKButton'), value: 1, primary: true }
                ]
            });
        };
        self.showUserPreferences = function () {
            bmPermission.has('Platform.PreviewMode')
                .then(function () {
                    self.showUnauthorizedModal();
                }).catch(function () {
                    $state.go('user-preferences');
                });
        };

        self.openProfileModal = function () {
            bmPermission.has('Platform.PreviewMode')
                .then(function () {
                    self.showUnauthorizedModal();
                }).catch(function () {
                    self.openViewProfileDialog();
                });
        };
        self.openViewProfileDialog = function(){
            // if profileevent attribute is specified, fire event, clear menu, return
            if($scope.profileEvent && $document[0].body) {
                $document[0].body.dispatchEvent(new Event('bm-profile-launched'));
                self.clearProfileMenuActive();
                return;
            }
            var modalOptions = {
                templateUrl: 'user-profile/view-profile-modal.2js.html',
                controller: 'bmViewProfileCtrl as vm',
                backdrop: 'static',
                windowClass: 'bm-custom-profile-modal',
                size: 'lg',
                resolve: {
                    languages: function(){
                        return [];
                    },
                    user: function(){
                        return undefined;
                    }
                }
            };

            self.clearProfileMenuActive();

            modalOptions.resolve = {
                languages: function(){
                    return myAccountService.getLanguageListAsync();
                },
                user: function(){
                    return myAccountService.getMyUserSettingsAsync().then(function(resp){
                        return resp.data;
                    });
                }
            };

            openModalWithOptions(modalOptions);
        };

        self.signOut = function() {
            self.clearProfileMenuActive();
            self.closeDropDowns();

            getLogoutUrl().then(function(logoutUrl){
                authenticatedSession.destroy(logoutUrl);
            }, function(){
                authenticatedSession.destroy();
            });
        };

        function openModalWithOptions(modalOptions){
            self.closeDropDowns();
            var instance = $uibModal.open(modalOptions);
            return instance;
        }

        function getLogoutUrl(){
            var themeParams;

            if(self.companyId){
                themeParams = { company: self.companyId };
            }

            return theme.load(themeParams).then(function(){
                if(theme.data && theme.data.header && theme.data.header.logoutUrl){
                    return theme.data.header.logoutUrl;
                }
            });
        }

        function getUnreadCountJob(){
            // returns the job id
            return bmJobQueue.push(function(done){
                notificationsManager.getUnreadNotificationCounts().then(function(data){
                    updateNotificationsCount(data);

                    // job is done running
                    done();
                }, function(){
                    updateNotificationsCount();

                    // job is done running
                    done();
                });
            }, 120000, '** Notifications Refreshed **'); // refresh every 2 minutes
        }

        function updateNotificationsCount(data){
            if(angular.isUndefined(data)){
                self.totalUnreadCount = 0;
                self.unreadNotificationsCount = 0;
                self.unreadMessagesCount = 0;
            } else {
                self.unreadNotificationsCount = data.notifications || 0;
                self.unreadMessagesCount = data.messages || 0;
                self.totalUnreadCount = self.unreadNotificationsCount + self.unreadMessagesCount;
            }
        }

        $scope.$on('bmUpdateCompanyStaffServices', function(event, args) {
            if (args.firmName) {
                setupLinkedAccounts(args.firmName);
            }
        });

        /* Start Linked Accounts Functions */
        function setupLinkedAccounts(broadcastFirmName) {
            var pos = 0;
            var posFound = -1;

            for(pos = 0; pos < self.linkedAccounts.length; pos++) {
                //nickname
                if(!self.linkedAccounts[pos].displayedNickname || self.linkedAccounts[pos].displayedNickname === '') {
                    self.linkedAccounts[pos].displayedNickname = '';
                    self.linkedAccounts[pos].displayedName = self.linkedAccounts[pos].accountName;
                } else {
                    self.linkedAccounts[pos].displayedName = self.linkedAccounts[pos].displayedNickname;
                }
            }

            // setup view
            if(self.linkedAccounts.length > 1) {
                for(pos = 0; pos < self.linkedAccounts.length; pos++) {
                    if(self.linkedAccounts[pos].contactId === self.contactId) {
                        self.linkedAccountFound = true;
                        self.selectedLinkedAccount = self.linkedAccounts[pos];
                        posFound = pos;
                        pos = self.linkedAccounts.length;
                    }
                }
                // remove the account that were logged into
                if(posFound >= 0) {
                    self.linkedAccounts.splice(posFound, 1);
                }

                // if accounts still exist, display menu
                if(self.linkedAccounts.length > 0) {
                    self.showLinkedAccountsMenu = true;
                }
            } else {
                self.selectedLinkedAccount = self.linkedAccounts[0];
                self.showLinkedAccountsMenu = false;
                self.linkedAccountFound = true;
            }
            if (broadcastFirmName) {
                self.selectedLinkedAccount.companyName = broadcastFirmName;
            }
        }

        self.switchAccount = function(linkedAccountId) {
            $scope.$emit('bm-busy-loading-on');

            LinkedAccountsService.createLinkedAccountSession(linkedAccountId).then(function(response){
                if (response.data.RedirectingDomain) {
                    // redirect the window to the new domain with the sso token
                    var ssoUrl = response.data.RedirectingDomain;
                    var routingPath = response.data.RoutingPath;
                    if (routingPath) {
                      // remove the first '/' if it exists
                      var subPath = routingPath.startsWith('/') ? routingPath.substring(1) : routingPath;
                      ssoUrl = ssoUrl + subPath;
                    }
                    if (ssoUrl.indexOf('#') < 0) {
                       // add '#' if it does not exist
                       ssoUrl = ssoUrl + '#/';
                    }
                    ssoUrl = ssoUrl + '?token=' + response.data.SsoTokenId;
                    $window.location.href = ssoUrl;
                } else {
                    // load the new session on the same domain
                    linkedAccountSessionToken = response.data.LongToken;
                    authenticatedSession.switchAccountWithLongToken(linkedAccountSessionToken);
                }
                $scope.$emit('bm-busy-loading-off');
            }).catch(function(error){
                console.log(error);
                $scope.$emit('bm-busy-loading-off');
            });
        };

        self.openManageLinkedAccountsDialog = function() {
            $log.info('Go manage the accounts');

            var modalOptions = {
                templateUrl: 'components/linked-accounts/linked-accounts-dialog.2js.html',
                controller: 'LinkedAccountsDialogCtrl as vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    user: function(){
                        return undefined;
                    },
                    sharedProfile: function(){
                        return {};
                    }
                }
            };

            modalOptions.resolve = {
                user: function(){
                    return self.user;
                },
                sharedProfile: function(){
                    return self.sharedProfile;
                }
            };

            openModalWithOptions(modalOptions);
        };
        /* End Linked Accounts Functions */

        function init(){
            self.closeDropDowns();

            if(authenticatedSession.data){
                authenticatedSession.data.getBindings().then(function(data){
                    self.companyId = data.ApplicationConfiguration.CompanyId;

                    // linked accounts
                    self.contactId = data.ApplicationConfiguration.ContactId;
                    LinkedAccountsService.getActiveOnvioLinkedAccounts().then(function(response){
                        self.linkedAccounts = response.data;
                        setupLinkedAccounts();
                    }).catch(function(error){
                        console.log(error);
                        self.linkedAccounts = [];
                        self.linkedAccountFound = false;
                    });

                });

                // start up the job for getting unread count
                var jid = getUnreadCountJob();

                bmJobQueue.start(jid); // enabled specified job

                // kill the job when profile menu is open
                $rootScope.$on('bmProfileMenuOpened', function(){
                    bmJobQueue.stop(jid);
                    bmJobQueue.remove(jid);

                    // get the most up-to-date counts so lists in tabs match header
                    notificationsManager.getUnreadNotificationCounts().then(function(data){
                        updateNotificationsCount(data);
                    });
                });

                // create new job and start is up so count is immediately refreshed
                $rootScope.$on('bmProfileMenuClosed', function(){
                    jid = getUnreadCountJob();
                    bmJobQueue.start(jid);
                });

                // update count when an item is read
                $rootScope.$on('bmNotificationMarkedAsRead', function(event, args){
                    if(angular.isDefined(args) && args.all === true){
                        self.unreadNotificationsCount = 0;
                    } else if(self.unreadNotificationsCount > 0){
                        self.unreadNotificationsCount -= 1;
                    }

                    self.totalUnreadCount = self.unreadNotificationsCount + self.unreadMessagesCount;
                });

                // update count when an item is read
                $rootScope.$on('bmMessagesMarkedAsRead', function(event, args){
                    if(angular.isDefined(args) && args.all === true){
                        self.unreadMessagesCount = 0;
                    } else if(self.unreadMessagesCount > 0){
                        self.unreadMessagesCount -= 1;
                    }

                    self.totalUnreadCount = self.unreadNotificationsCount + self.unreadMessagesCount;
                });

                // close nav menus when a bound html link is selected
                $rootScope.$on('bmNotificationHtmlClick', function(){
                    self.clearMenuActive();
                });
            }

            bmPermission.has('Applications.Onvio').then(function(){
                self.hasStaffApp = true;
            });

            bmPermission.has('Applications.OnvioClientHub').then(function(){
                self.hasClientApp = true;
            });

            try {
                angular.module('bm.userPreferences');
                $injector.get('userPreferencesService')
                    .hasPreferences()
                    .then(function(hasPrefs) {self.hasPrefs = hasPrefs;})
                    .catch(function() {self.hasPrefs = false;});
            } catch(e) {
                self.hasPrefs = false;
            }

            // must have IAC and FR
            // not available to users with documents basic
            bmAccess.has('Client_Dashboard').then(function(){
                return bmLicense.has('Onvio.ClientDashboard').then(function(){
                    return bmLicense.not('Applications.OnvioDocumentsBasic').then(function(){
                        return bmPermission.not('GFR.ClientFlow').then(function(){
                            self.hasClientDashboard = true;
                        });
                    });
                });
            }).catch(function() {
                self.hasClientDashboard = false;
                bmAnalyticsService.track('bmHeader: bmAccess.has(\'Client_Dashboard\') failed');
            });
        }

        init();
    }

    bmHeader.$inject = ['$window', '$document', '$rootScope', 'bmUtil', 'AuthenticatedSessionData'];

    bmHeaderCtrl.$inject = [
        '$window',
        '$log',
        '$rootScope',
        '$q',
        '$timeout',
        '$uibModal',
        '$location',
        '$translate',
        '$scope',
        'AuthenticatedSession',
        'bmUser',
        'bmTheme',
        'myAccountService',
        'bmAccess',
        'bmPermission',
        'bmLicense',
        'bmModal',
        'bmJobQueue',
        'bmClientNotificationsListManager',
        'bmUtil',
        'bmAnalyticsService',
        'csScheduleItemV3',
        'LinkedAccountsService',
        '$injector',
        '$document'
    ];

    angular.module('bluemoon.components.header', [
        'ui.bootstrap',
        'bento.services',
        'bento.select',
        'bento.tabs',
        'bluemoon.components.session',
        'bluemoon.components.theme',
        'bluemoon.passwordValidation',
        'bluemoon.components.header.timerButton',
        'bluemoon.components.header.documentsButton',
        'bmViewProfile',
        'bmUser',
        'bmAccess',
        'bmPermission',
        'bmLicense',
        'bmUserAvailability',
        'bmClientNotificationsList',
        'bluemoon.components.analytics',
        'bmPrivacyPolicy',
        'bmSupportId',
        'csScheduleItemV3',
        'bmLinkedAccounts',
        'bmPreviewTrialWidget',
        'pascalprecht.translate'
    ])

    .directive('bmHeader', bmHeader);

})(window.angular);

/**
 * Blue Moon Components - View Portal Banner Directive
 */
(function(angular){
    'use strict';

    function bmViewPortalBanner($document, sessionData) {

        return {
            restrict: 'EA',
            templateUrl: 'components/view-portal-banner/view-portal-banner.2js.html',
            transclude: true,
            require: '^bmApp',
            controller: bmViewPortalBannerCtrl,
            controllerAs: 'banner',
            link: function () {
                sessionData.getMeta().then(function(data) {
                    if (data.EmulateePrismGuid) {
                        var html = angular.element($document[0].documentElement)[0];
                        html.classList.add('bm-view-portal-mode');
                    }
                });
            }
        };
    }

    function bmViewPortalBannerCtrl(session, sessionData, theme) {
        var self = this; // jshint ignore:line

        // don't resolve (render) until theme is loaded
        self.unresolvedTheme = true;
        sessionData.getBindings().then(function(data) {
            theme.loadHeader(data.ApplicationConfiguration.CompanyId).then(function() {
                self.unresolvedTheme = false;
            });
        });

        sessionData.getMeta().then(function(data) {
            self.uname = data.FullName;
        });

        self.exitViewPortalMode = function() {
            session.exitViewPortal();
        };
    }

    bmViewPortalBanner.$inject = ['$document', 'AuthenticatedSessionData'];
    bmViewPortalBannerCtrl.$inject = ['AuthenticatedSession', 'AuthenticatedSessionData', 'bmTheme'];

    angular.module('bmViewPortalBanner', [
        'bluemoon.components.session'
    ])

    .directive('bmViewPortalBanner', bmViewPortalBanner);

})(window.angular);

/**
 * Blue Moon Components - Timer Header Button directive.
 * This is the timer menu that is to appear in the header next to the help button in all the apps.
 */
(function(angular){
    'use strict';

    function bmTimerHeaderButton($timeout) {

        return {
            restrict: 'EA',
            templateUrl: 'components/header/timer-header-button.2js.html',
            scope: {
                isTimerDropdownOpen: '=bmTimerHeaderButton',
                htmlElementId: '@'
            },
            link: function(scope, element) {
                // If we don't have the TimeAndExpense Timer code loaded, don't show this button at all.
                var unwatch = scope.$watch(function () { return element[0].querySelector('#bm-header-timer-control'); },
                    function (timerElement) {
                        if (timerElement && timerElement.childElementCount > 0) {
                            scope.vm.timerDirectiveLoaded = true;
                            unwatch();

                            // add an id to the main element if defined
                            if(angular.isDefined(scope.vm.htmlElementId)){
                                element.attr('id', scope.vm.htmlElementId);
                            }
                        }
                    });
                $timeout(function () {
                    // After a while, give up. No point in wasting cpu cycles by watching this forever.
                    unwatch();
                }, 6000);
            },
            bindToController: true,
            controller: function() {
                this.timerDirectiveLoaded = false;
            },
            controllerAs: 'vm'
        };
    }
    bmTimerHeaderButton.$inject = ['$timeout'];

    angular.module('bluemoon.components.header.timerButton', [
        'bluemoon.components.session',
        'bluemoon.components.templates',
        'bmPermission',
    ])

    .directive('bmTimerHeaderButton', bmTimerHeaderButton);

})(window.angular);

/**
 * Blue Moon Components - Documents Header Button directive.
 * This is the documents icon that takes the use to Documnets that is to appear
 in the header next to the help button in all the apps.
 */
(function(angular){
    'use strict';

    function bmDocumentsHeaderButton() {

        return {
            templateUrl: 'components/header/documents-header-button.2js.html',
        };
    }

    // bmDocumentsHeaderButton.$inject = ['$timeout'];

    angular.module('bluemoon.components.header.documentsButton', [
        'bluemoon.components.session',
        'bluemoon.components.templates',
        'bmPermission',
    ])

    .directive('bmDocumentsHeaderButton', bmDocumentsHeaderButton);

})(window.angular);

/**
 * Blue Moon Components - Staff Header Directive
 */
(function(angular){
    'use strict';

    function bmStaffHeader() {
        return {
            restrict: 'EA',
            templateUrl: 'components/header/bm-staff-header.2js.html',
            scope: {
                profileEvent: '@profileEvent'
            }
        };
    }

    angular.module('bluemoon.components.staffHeader', [
        'bluemoon.components.header'
    ])

    .directive('bmStaffHeader', bmStaffHeader);

})(window.angular);

(function(angular) {
    'use strict';
    /*jshint sub:true*/
    angular.module('csScheduleItemV3', ['bluemoon.components.session']).service('csScheduleItemV3',
        ['$http', 'AuthenticatedSessionData',
        function($http, authenticatedSessionData) {
            return {
                get: function(params) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v2/companies/{companyId}/schedule-items/{scheduleItemId}';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        url = url.replace(/{scheduleItemId}/g, paramsCopy['scheduleItemId']);

                        var query = {
                            'expand': paramsCopy['expand']
                        };
                        return $http({ url: url, method: 'GET', params: query, headers: {} });
                    });
                }

            };
        }]);
}(window.angular));

(function(angular) {
    'use strict';

    angular.module('bluemoon.components.bluemoonForceDesktop', [])
    .directive('bluemoonForceDesktop', bluemoonForceDesktop)
    .directive('bmForceDesktop', bluemoonForceDesktop);

    bluemoonForceDesktop.$inject = ['$window'];
    function bluemoonForceDesktop($window) {
        return {
            restrict: 'A',
            replace: false,
            link: function(scope, element) {
                var w = angular.element($window);
                scope.getWindowSize = function() {
                    return { 'width': $window.innerWidth };
                };
                scope.$watch(scope.getWindowSize, function(newValue) {
                    // TODO - bootstrap medium and higher for now.
                    // Still want 'force-desktop' past bootstrap large,
                    // but at some point a HD screen may not want 'force-desktop'
                    if (newValue.width >= 992 /*&& newValue.width < 1200*/) {
                        element.addClass('force-desktop');
                    } else {
                        element.removeClass('force-desktop');
                    }
                }, true);

                w.bind('resize', function() {
                    scope.$apply();
                });
            }
        };
    }
})(window.angular);

(function (angular) {
    'use strict';

    function BmAnalyticsConfigProvider() {

        var provider = this;

        /* Remove permission via FRP. All environments (except local) should report */
        // provider.hasPermission = ['bmPermission', 'bmAnalyticsFRP', function(bmPermission, bmAnalyticsFRP){
        // return bmPermission.has(bmAnalyticsFRP);
        // }];
        provider.hasPermission = ['$q', function ($q) {
            var deferred = $q.defer();
            deferred.resolve(true);
            return deferred.promise;
        }];

        provider.$get = function () {
            return provider;
        };
    }

    // Product Insight integration #7833
    function productInsightIntegration(module) {
        module
            .config([
                'bmEnvironmentConst',
                'bluemoonAnalyticsProvider',
                function (env, bluemoonAnalyticsProvider) {
                    // all env except local
                    if (env.isProdType || env.isLowerType) {
                        bluemoonAnalyticsProvider.sendAnalyticsToProd(env.isProdType, function () {
                            bluemoonAnalyticsProvider.loadTRAACLibrary(function () {
                                bluemoonAnalyticsProvider.configAngulartics();
                            });
                        });
                    }
                }
            ])
            .run([
                'bmEnvironmentConst',
                'AuthenticatedSessionData',
                '$analytics',
                function (env, session, $analytics) {
                    // all env except local
                    if (env.isProdType || env.isLowerType) {
                        $analytics.setSuperProperties({
                            // NOTE: 'app' should be set by consumer
                            //'app': 'My Application Name in Human Readable Form',
                            'server': location.protocol + '//' + location.host,
                            'environment': env.type.toLowerCase()
                        });
                        session.getMeta().then(function (data) {
                            $analytics.setSuperProperties({
                                'uid': data.PrismGuid
                            });
                        }).catch(function () {
                            angular.noop('ng161');
                        });
                    }
                }
            ]);
    }

    function BmAnalyticsService($window, $analytics, $rootScope, $location, $injector, authenticatedSessionData, bmAnalyticsConfig) {
        var service = this;

        var performEventTracking = function (eventName, eventInfo) {
            service.defaultData().then(function (data) {
                var fullData = angular.extend({}, data, eventInfo);
                $analytics.eventTrack(eventName, fullData);
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        var performPageViewedTracking = function (event, current) {
            service.defaultStateData().then(function (data) {
                data.controller = current.controller;
                data.state = current.name;
                data.page = $analytics.settings.pageTracking.basePath + $location.url();

                //NOTE: Could do pageTrack(url) but it wouldn't give us nearly as much info as I'm doing here.
                $analytics.eventTrack('Page Viewed', data);
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        service.track = function (eventName, eventInfo) {
            service.ready().then(function () {
                performEventTracking(eventName, eventInfo);
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        service.init = function () {
            service.ready().then(function () {
                $rootScope.$on('$stateChangeSuccess', function (event, current) {
                    performPageViewedTracking(event, current);
                });
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        service.defaultData = function () {
            return authenticatedSessionData.get().then(function (data) {
                return {
                    category: 'bluemoon-event',
                    label: 'custom-event',
                    companyId: data.bindings.ApplicationConfiguration.CompanyId,
                    sessionId: data.meta.sessionId,
                    contactId: data.bindings.ApplicationConfiguration.ContactId,
                    testFirm: data.bindings.ApplicationConfiguration.TestFirm === 'true'
                };
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        service.defaultStateData = function () {
            return authenticatedSessionData.get().then(function (data) {
                return {
                    companyId: data.bindings.ApplicationConfiguration.CompanyId,
                    sessionId: data.meta.sessionId,
                    contactId: data.bindings.ApplicationConfiguration.ContactId,
                    testFirm: data.bindings.ApplicationConfiguration.TestFirm === 'true'
                };
            }).catch(function () {
                angular.noop('ng161');
            });
        };

        service.hasPermission = function () {
            return $injector.invoke(bmAnalyticsConfig.hasPermission);
        };

        service.ready = function () {
            return service.hasPermission();
        };
    }

    BmAnalyticsService.$inject = ['$window', '$analytics', '$rootScope', '$location', '$injector', 'AuthenticatedSessionData', 'bmAnalyticsConfig'];

    function BmAnalyticsDirective(bmAnalyticsService) {

        function link(scope) {
            bmAnalyticsService.track(scope.eventName, scope.eventInfo);
        }

        return {
            restrict: 'EA',
            replace: true,
            scope: {
                eventName: '@',
                eventInfo: '@'
            },
            link: link
        };
    }

    BmAnalyticsDirective.$inject = ['bmAnalyticsService'];

    function BmAnalyticsOnDirective($q, $compile, analyticsService) {

        function link(scope, element, attr) {

            function getAnalyticsAttribute(bmAnalyticsAttribute) {
                return bmAnalyticsAttribute.replace('bm-analytics', 'analytics');
            }

            analyticsService.ready().then(function () {

                var promisesToWaitFor = [];

                angular.forEach(attr.$attr, function (bmAnalyticsAttr) {
                    if (bmAnalyticsAttr.indexOf('bm-analytics-') === 0) {
                        if (bmAnalyticsAttr === 'bm-analytics-properties') {
                            promisesToWaitFor.push(analyticsService.defaultData().then(function (data) {
                                var properties = attr[attr.$normalize(bmAnalyticsAttr)];
                                var fullData = properties ? angular.extend({}, data, JSON.parse(properties)) : '';
                                element.attr(getAnalyticsAttribute(bmAnalyticsAttr), JSON.stringify(fullData));
                            }));
                        } else if (bmAnalyticsAttr === 'bm-analytics-if') {
                            scope.analyticsIf = function () {
                                return scope.$eval(attr[attr.$normalize(bmAnalyticsAttr)]);
                            };
                            element.attr(getAnalyticsAttribute(bmAnalyticsAttr), 'analyticsIf()');
                        } else {
                            element.attr(getAnalyticsAttribute(bmAnalyticsAttr), attr[attr.$normalize(bmAnalyticsAttr)]);
                        }
                    }
                });

                $q.all(promisesToWaitFor).then(function () {
                    element.removeAttr('bm-analytics-on');
                    if (element.attr('bm-analytics-properties') === undefined) {
                        analyticsService.defaultData().then(function (data) {
                            element.attr(getAnalyticsAttribute('bm-analytics-properties'), JSON.stringify(data));
                            $compile(element)(scope);
                        });
                    } else {
                        $compile(element)(scope);
                    }
                });
            }).catch(function () {
                angular.noop('ng161');
            });

        }

        return {
            restrict: 'A',
            replace: true,
            link: link
        };
    }

    BmAnalyticsOnDirective.$inject = ['$q', '$compile', 'bmAnalyticsService'];

    var bmAnalyticsFRP = 'Onvio.Analytics';

    var module = angular.module('bluemoon.components.analytics', [
        'angulartics',
        'bluemoon.analytics',
        'bmEnvironment',
        'bmPermission',
        'bluemoon.components.session'
    ])
        .constant('bmAnalyticsFRP', bmAnalyticsFRP)
        .provider('bmAnalyticsConfig', BmAnalyticsConfigProvider)
        .service('bmAnalyticsService', BmAnalyticsService)
        .directive('bmAnalytics', BmAnalyticsDirective)
        .directive('bmAnalyticsOn', BmAnalyticsOnDirective)
        .config(['$analyticsProvider', function ($analyticsProvider) {
            $analyticsProvider.virtualPageviews(false);
        }])
        .run(['bmAnalyticsService', function (bmAnalyticsService) {
            bmAnalyticsService.init();
        }]);

    productInsightIntegration(module);

})(window.angular);

(function(angular) {
    'use strict';

    /*
     *  bmFocusOnEvent
     *
     *  Requires: onvio.setup.common.ITouchUtils, fef.Utils, bluemoon.components.Notifications
     *
     *  Scope type: none
     *
     *  Arguments:
     *      The main argument is an expression that evaluates to an angular event name (string).
     *      The bmFocusOnEventWithTouch argument (optional, default false) is an expression that evaluates to true or false.
     *        If true, the focus behavior will be enabled even on touch devices and hybrids where the user
     *        is currently using touch. Otherwise, the focus behavior will be disabled on these devices.
     *      The bmFocusOnEventElementSelector argument (optional, default undefined) is an expression that evaluates to a string.
     *        If provided, the focus behavior will apply to the first descendent that is returned by the provided element selector
     *        Otherwise, the focus behavior will apply to the element that this directive is on.
     *
     *  Description:
     *  Directive to listen for an event on scope (specified as an argument)
     *  and focus the element whenever the event fires. Does a $scope.$on on
     *  the element's scope, given the main argument as the event name, and
     *  gives the element focus when that event occurs. $broadcast that event
     *  from the element's scope (or one of its parent scopes), or $emit it from
     *  a child scope under the element, to cause the element to gain focus.
     */
    angular.module('bmFocusOnEvent',
        [
            'bluemoon.components.Notifications',
            'fef',
            'bmTouchUtils'
        ]).directive('bmFocusOnEvent', [
            '$timeout',
            '$log',
            'bluemoon.components.Notifications',
            'fef.Utils',
            'bmTouchUtils',
            function(
                $timeout,
                $log,
                notifications,
                utils,
                touchUtils
            ) {
                return {
                    link: function($scope, element, attrs) {
                        var enabledOnTouch = false;
                        var elementSelector;
                        var focused = false;
                        if(!utils.exists(attrs.bmFocusOnEvent)) {
                            throw new Error('bmFocusOnEvent requires an event argument');
                        }

                        if(utils.exists(attrs.bmFocusOnEventWithTouch)) {
                            enabledOnTouch = $scope.$eval(attrs.bmFocusOnEventWithTouch);
                        }
                        if (utils.exists(attrs.bmFocusOnEventElementSelector)) {
                            elementSelector = $scope.$eval(attrs.bmFocusOnEventElementSelector);
                        }
                        var deregister = null;
                        var getEventName = function() {
                            return $scope.$eval(attrs.bmFocusOnEvent);
                        };

                        var registerListener = function() {
                            if(deregister !== null) {
                                deregister();
                                deregister = null;
                            }
                            var eventName = getEventName();
                            if (utils.exists(eventName)) {
                                deregister = $scope.$on(eventName, function() {
                                    var focusElement = element;
                                    if (enabledOnTouch || !touchUtils.touchUsed()) {
                                        if (elementSelector) {
                                            focusElement = element.find(elementSelector);
                                            if (!focusElement) {
                                                // Don't do anything if the element could not be found.
                                                return;
                                            }
                                        }
                                        focused = false;
                                        focusElement.bind('focus', function(event) {
                                            focused = true;
                                            focusElement.unbind(event);
                                        });

                                        focusElement.focus();

                                        // If we are in a headless browser, focus() won't do anything.
                                        // But we still want to fire the events.
                                        // So, if the focus event hasn't yet been fired, do that here.
                                        if(!focused) {
                                            focusElement.triggerHandler('focus');
                                        }
                                    }
                                });
                            }
                        };

                        $scope.$watch(attrs.bmFocusOnEvent, registerListener);
                        registerListener();
                    }
                };
            }]);

}(window.angular));

(function() {
    'use strict';
    angular.module('bmFocusOnLink',
        ['bmTouchUtils', 'fef', 'bluemoon.components.Notifications'])
        .directive('bmFocusOnLink', [
        '$timeout',
        '$log',
        'bluemoon.components.Notifications',
        'fef.Utils',
        'bmTouchUtils',
        '$rootScope',
        function($timeout, $log, notifications, utils, touchUtils, $rootScope) {
            return {
                link: function(scope, instanceElement, instanceAttributes) {
                    var enabledAttribute = instanceAttributes.bmFocusOnLink;
                    if(!utils.stringIsNonBlank(enabledAttribute)) {
                        enabledAttribute = 'true';
                    }
                    var enabled = scope.$eval(enabledAttribute);
                    if(enabled) {
                        var enabledOnTouch = instanceAttributes.bmFocusOnLinkWithTouch;
                        if(!utils.exists(enabledOnTouch)) {
                            enabledOnTouch = false;
                        } else {
                            enabledOnTouch = scope.$eval(enabledOnTouch);
                        }
                        // the timeout is to allow the scope digest cycle to settle.
                        // otherwise the selection state may get lost as bindings
                        // fire callbacks and so on.
                        $timeout(function() {
                            var focusElement = function() {
                                if(enabledOnTouch || !touchUtils.touchUsed()) {
                                    instanceElement.focus();
                                    if(utils.exists(instanceElement.select) && angular.isFunction(instanceElement.select)) {
                                        instanceElement.select();
                                    }
                                }
                            };
                            // Focus only works if the control is visible.
                            if(instanceElement.is(':visible')) {
                                focusElement();
                            } else {
                                // Wait until the control becomes visible before trying to focus it.
                                var unwatch = $rootScope.$watch(function() { return instanceElement.is(':visible'); }, function(newValue) {
                                    if(newValue) {
                                        focusElement();
                                        if(utils.exists(unwatch)) {
                                            unwatch();
                                            unwatch = undefined;
                                        }
                                    }
                                });
                                // We run out of digest cycles in some cases (typically trying to add on most screens)
                                // So, trigger a digest every so-often if the control is visible and we haven't focused it yet.
                                var digestFunc = function() {
                                    if(utils.exists(unwatch)) {
                                        if(instanceElement.is(':visible')) {
                                            $rootScope.$digest();
                                        } else {
                                            $timeout(digestFunc, 250);
                                        }
                                    }
                                };
                                $timeout(digestFunc, 250);
                                // After some amount of time of being unable to focus the element, just give up.
                                $timeout(function() {
                                    if(utils.exists(unwatch)) {
                                        unwatch();
                                        unwatch = undefined;
                                    }
                                }, 2000);
                            }
                        }, 10);
                    }
                }
            };
        }
        ]);
}());

(function(angular){
    'use strict';

    // TODO: USE THIS TEMPORARILY UNTIL BENTO SELECT SUPPORTS CHANGE EVENT
    var module = angular.module('bmForceModelChange', []);

    module.directive('bmForceModelChange',function(){
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attr) {
                scope.$watch(attr.ngModel, function(newValue, oldValue){
                    if(newValue && oldValue && newValue !== oldValue){
                        scope.$eval(attr.bmForceModelChange);
                    }
                });
            }
        };
    });
})(window.angular);

(function($) {
    'use strict';
    /* istanbul ignore next */
    var TouchUtils = (function() {
        function TouchUtils() {
            var _this = this;
            this._touchUsed = false;
            this._touchSupported = false;
            var onTouch = function() {
                _this._touchUsed = true;
            };
            var onNonTouch = function() {
                _this._touchUsed = false;
            };
            // Source: https://hacks.mozilla.org/2013/04/detecting-touch-its-the-why-not-the-how/
            if(('ontouchstart' in window) ||
                (navigator.maxTouchPoints > 0) ||
                (navigator.msMaxTouchPoints > 0)) {
                this._touchSupported = true;
                //var body = $('body');
                // This doesn't appear to be working #research
                $('body').context.addEventListener('pointerdown', function(event) {
                    if(event.pointerType === 'touch') {
                        onTouch();
                    } else {
                        onNonTouch();
                    }
                });
                $('body').context.addEventListener('pointermove', function(event) {
                    if(event.pointerType !== 'touch') {
                        onNonTouch();
                    }
                });
                $('body').bind('touchstart', function() {
                    onTouch();
                });
                $('body').bind('onmousemove', function() {
                    onNonTouch();
                });
            }
        }
        TouchUtils.prototype.touchSupported = function() {
            return this._touchSupported;
        };
        /**
         * Not currently working. #research
         */
        TouchUtils.prototype.touchUsed = function() {
            return this._touchUsed;
        };
        TouchUtils.$inject = [];
        return TouchUtils;
    })();
    angular.module('bmTouchUtils', []).service('bmTouchUtils', TouchUtils);
}(window.$));

(function(angular) {
    'use strict';

    angular.module('bmRightClick', [])

    .directive('bmRightClick', function($parse) {
        return function(scope, element, attrs) {
            var fn = $parse(attrs.bmRightClick);
            element.bind('contextmenu', function(event) {
                scope.$apply(function() {
                    fn(scope, {$event:event});
                });
            });
        };
    });

}(window.angular));

/**
 * Blue Moon Components - Nav Directive
 */
(function(angular){
    'use strict';
    var titleSeparator = '|';
    var docTitleReplacePtn = new RegExp('^.+\\s\\' + titleSeparator + '\\s');

    function bmNav($window, $document, $location, $rootScope, $timeout, $translate, authenticatedSessionData) {

        return {
            restrict: 'EA',
            templateUrl: 'components/nav/nav.2js.html',
            transclude: true,
            link: function(scope, element, attrs) {
                var nav,
                    doc = $document[0],
                    syncDocTitle,
                    offLocChgSuccess,
                    unwatchDocTitle,
                    offLangChgSuccess;

                // update active nav item after binding data is loaded and allowed nav items show
                authenticatedSessionData.getBindings().then(function() {
                    // wait till next event loop
                    $timeout(function() {
                        // snapshot static configuration
                        syncDocTitle = scope.$eval(attrs.syncDocTitle) === true;

                        // init navigation menu
                        nav = $window.navmore(element.find('nav')[0]);
                        localizeMoreNavItem($translate, nav);

                        // update active nav item on startup
                        updateSelectedNavItem($rootScope, doc, nav, $location.absUrl());

                        // update active nav item on location change success
                        offLocChgSuccess = $rootScope.$on('$locationChangeSuccess', function (e, url) {
                            updateSelectedNavItem($rootScope, doc, nav, url);
                            // update document title
                            if (syncDocTitle) {
                                syncDocumentTitleWithNavSelection(doc, nav);
                            }
                        });

                        // update more item text on lang change
                        offLangChgSuccess = scope.$on('bmLanguageChangeSuccess', function() {
                            localizeMoreNavItem($translate, nav);
                            if (syncDocTitle) {
                                syncDocumentTitleWithNavSelection(doc, nav);
                            }
                        });

                        if (syncDocTitle) {
                            unwatchDocTitle = $rootScope.$watch(
                                function() {
                                    return doc.title;
                                },
                                function() {
                                    syncDocumentTitleWithNavSelection(doc, nav);
                                }
                            );
                            syncDocumentTitleWithNavSelection(doc, nav);
                        }
                    });
                });

                // cleanup
                element.on('$destroy', function () {
                    if (offLocChgSuccess) {
                        offLocChgSuccess();
                    }
                    if (offLangChgSuccess) {
                        offLangChgSuccess();
                    }
                    if (unwatchDocTitle) {
                        unwatchDocTitle();
                    }
                });
            }
        };

        function syncDocumentTitleWithNavSelection(doc, nav) {
            if (!nav || !nav.navmore) { return; }

            // find top-level selected nav item and use the text (post translation) to update the doc title

            var navSelectedArray = nav.navmore.getSelected();
            if (!navSelectedArray.length) { return; }

            var navSelectedText = navSelectedArray[navSelectedArray.length - 1].textContent.trim();
            if (!navSelectedText) { return; }

            var newTitle = navSelectedText + ' ' + titleSeparator + ' ' + doc.title.replace(docTitleReplacePtn, '');
            if (newTitle === doc.title) { return; }

            // offer subscribers a chance to cancel
            var detail = { oldValue: doc.title, newValue: newTitle, cancel: false };
            $rootScope.$emit('bmNavDocumentTitleBeforeChange', detail);
            if (detail.cancel) { return; }

            doc.title = newTitle;
        }
    }

    function localizeMoreNavItem($translate, nav) {
        $translate('bm.nav.more.item').then(function(more) {
            nav.navmore.setMoreItemText(more);
        });
    }

    function updateSelectedNavItem($rootScope, doc, nav, url) {
        var active = findActiveNavItem(nav, url);
        if (active) {
            // close expanded lists
            nav.navmore.collapse();
            // update selected nav item
            nav.navmore.setSelected(active);
            // fire event with new selection
            $rootScope.$broadcast('bmNavSelectionChanged', {
                selected: nav.navmore.getSelected()
            });
        }
    }

    // sync active nav item with location
    function findActiveNavItem(nav, url) {
        var i, j, candidates, candidate, candidateHrefNoQuery, matches, lastHrefChar, nextUrlChar, bestMatch,
            urlNoQuery = '#' + url.split('?')[0].split('#')[1];

        // find match candidates
        candidates = angular.element(nav).find('a');
        if (!candidates.length) { return; }

        // gather matches
        matches = [];
        for (i = 0; i < candidates.length; i++) {
            candidate = candidates[i];
            if (!candidate.hasAttribute('href')) { continue; }

            // Get all the hrefs represented by this parent link
            var hrefs = ((candidate.getAttribute('href') || '') + ',' + (candidate.getAttribute('bm-href-aliases') || '')).split(',');
            for(j = 0; j < hrefs.length; j++) {

                // strip off query string
                candidateHrefNoQuery = hrefs[j].split('?')[0];
                lastHrefChar = candidateHrefNoQuery.charAt(hrefs[j].length - 1);
                nextUrlChar = urlNoQuery.charAt(candidateHrefNoQuery.length);
                if (urlNoQuery.indexOf(candidateHrefNoQuery) === 0 &&
                    (lastHrefChar === '/' || !nextUrlChar.length || nextUrlChar === '/' || nextUrlChar === '?')) {
                        matches.push({ link: candidate, href: hrefs[j] });
                }
            }
        }

        // find best (longest) match
        for (i = 0; i < matches.length; i++) {
            if (!bestMatch) {
                bestMatch = matches[i];
            } else if (matches[i].href.length > bestMatch.href.length) {
                bestMatch = matches[i];
            }
        }

        return !!bestMatch ? bestMatch.link : undefined;
    }

    bmNav.$inject = ['$window', '$document', '$location', '$rootScope', '$timeout', '$translate', 'AuthenticatedSessionData'];

    angular.module('bluemoon.components.nav', [
        'bluemoon.components.session',
        'pascalprecht.translate'
    ])

    .directive('bmNav', bmNav);

})(window.angular);

/**
 * Blue Moon Components - Staff Not Found Directive
 */
(function(angular){
    'use strict';

    function bmStaffNotFound() {
        return {
            restrict: 'EA',
            templateUrl: 'components/not-found/bm-staff-not-found.2js.html'
        };
    }

    angular.module('bluemoon.components.staffNotFound', [
    ])

    .directive('bmStaffNotFound', bmStaffNotFound);

})(window.angular);

/**
 * Blue Moon Components - Main Directive
 */
(function(angular){
    'use strict';

    function bmMain() {

        return {
            restrict: 'EA',
            templateUrl: 'components/main/main.2js.html',
            transclude: true,
            controller: [function () {
            }],
            controllerAs: 'main',
            link: function () {
            }
        };
    }

    bmMain.$inject = [];

    angular.module('bluemoon.components.main', [
    ])

    .directive('bmMain', bmMain);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.components.busyLoader', [
        'bento.busyloader'
    ])

    .value('bluemoon.components.busyLoader.defaultStartOffsetDefault', 2000)
    .value('bluemoon.components.busyLoader.defaultSize', 'default')

    .service('bmBusyLoaderDefaults', ['$injector',
        'bluemoon.components.busyLoader.defaultStartOffsetDefault',
        'bluemoon.components.busyLoader.defaultSize',
        function($injector, defaultStartOffset, defaultSize) {

            var _getValueFunction = function(key, defaultValue) {
                return function() {
                    return $injector.has(key) ? $injector.get(key) : defaultValue;
                };
            };

            this.startOffset = _getValueFunction('bluemoon.components.busyLoader.startOffset', defaultStartOffset);
            this.size = _getValueFunction('bluemoon.components.busyLoader.size', defaultSize);
    }])

    .directive('bmBusyLoader', [
        '$timeout',
        '$bentoBusyLoader',
        '$rootScope',
        'bmBusyLoaderDefaults',
        function (
            $timeout,
            $bentoBusyLoader,
            $rootScope,
            bmBusyLoaderDefaults){
            return {
                restrict: 'A',
                scope: {
                    bmBusyLoader: '='
                },
                link: function(scope, element){

                    var _defaults = {
                        offset: bmBusyLoaderDefaults.startOffset(),
                        size: bmBusyLoaderDefaults.size()
                    };

                    var _options = angular.extend({}, _defaults,
                        scope.bmBusyLoader || {});

                    var _requestTracker = 0;

                    //  Bento replaces style positions with relative, let's undo that
                    var _originalStylePosition = element[0].style.position;

                    var _busyLoader = $bentoBusyLoader.getNewLoader(element, _options.size);

                    if (_originalStylePosition) {
                        element[0].style.position = _originalStylePosition;
                    }

                    var _busyLoaderTimeout;

                    var _showLoader = function() {
                        _busyLoaderTimeout = $timeout(function(){
                            _busyLoader.show();
                        }, _options.offset);
                    };

                    var _hideLoader = function() {
                        $timeout.cancel(_busyLoaderTimeout);
                        _busyLoader.hide();
                    };

                    scope.$parent.$on('bm-busy-loading-on', function(event) {
                        if (!_requestTracker) {
                            _showLoader();
                        }
                        _requestTracker++;

                        if(angular.isFunction(event.stopPropagation)){
                            event.stopPropagation();
                        }
                    });

                    scope.$parent.$on('bm-busy-loading-off', function(event, options) {

                        var opt = angular.extend({}, options, {});

                        if (_requestTracker === 1 || opt.forceOff) {
                            _hideLoader();
                        }

                        _requestTracker = opt.forceOff ? 0 : Math.max(0, _requestTracker - 1);

                        if(angular.isFunction(event.stopPropagation)){
                            event.stopPropagation();
                        }
                    });

                    $rootScope.$on('$stateChangeStart', function(){
                        _hideLoader();
                        _requestTracker = 0;
                    });
                }
            };
        }
    ]);
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.components.focus', [])

    .directive('bmFocus', ['$timeout',
        function($timeout) {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    scope.$watch(attrs.bmFocus, function(value) {
                        if(value) {
                            $timeout(function() {
                                element[0].focus();
                            }, 700);
                        }
                    });
                }
            };
        }
    ]);
}(window.angular));

(function(angular) {
    'use strict';

    function Permission($q, authenticatedSessionData) {
        var self = this;

        // Can be use for route resolve to determine if you have permission.
        // For example,
        // resolve: {
        //     auth: function() {
        //         return bmPermission.has('OnvioDrive.MyDocuments').catch(function () {
        //             $state.go('notfound');
        //         })
        //     }
        // }
        self.has = function(perms, hasEvery) {
            return authenticatedSessionData.getBindings().then(function(data) {
                var grants = flattenObj(data.FeatureResourcePermissions.FeatureResourcePermissionsMap);
                var granted = false;

                if (angular.isArray(perms)) {
                    perms[hasEvery ? 'every' : 'some'](function(perm) {
                        granted = grants[perm] === 'Granted';
                        return granted;
                    });
                } else if (typeof perms === 'string') {
                    granted = grants[perms] === 'Granted';
                }
                if (granted) {
                    return granted;
                } else {
                    return $q.reject(granted);
                }
            });
        };

        self.hasSome = function(perms) {
            return self.has(perms);
        };

        self.hasEvery = function(perms) {
            return self.has(perms, true);
        };

        self.not = function(perms, hasEvery){
            var deferred = $q.defer();
            self.has(perms, hasEvery).then(function(){
                deferred.reject(false);
            }, function(){
                deferred.resolve(true);
            });
            return deferred.promise;
        };

        self.notSome = function(perms){
            return self.not(perms);
        };

        self.notEvery = function(perms){
            return self.not(perms, true);
        };

        self.hasFirmLicense = function(licenses, hasEvery) {
            return authenticatedSessionData.getBindings().then(function(data) {
                var grants = data.ApplicationConfiguration.Licenses;
                var granted = false;

                if (angular.isArray(licenses)) {
                    licenses[hasEvery ? 'every' : 'some'](function(license) {
                        granted = grants.indexOf(license) > -1;
                        return granted;
                    });
                } else if (typeof licenses === 'string') {
                    granted = grants.indexOf(licenses) > -1;
                }
                if (granted) {
                    return granted;
                } else {
                    return $q.reject(granted);
                }
            });
        };

        self.hasSomeFirmLicense = function(licenses) {
            return self.hasFirmLicense(licenses);
        };

        // has will reject promise on false value,
        // isGranted will resolve with one or many true/false values
        self.isGranted = function(perms) {
            var deferred = $q.defer();
            authenticatedSessionData.getBindings().then(function(data) {
                var grants = flattenObj(data.FeatureResourcePermissions.FeatureResourcePermissionsMap);
                var granted = null;

                if (angular.isArray(perms)) {
                    granted = perms.map(function(perm) {
                        return grants[perm] === 'Granted';
                    });
                } else if (typeof perms === 'string') {
                    granted = grants[perms] === 'Granted';
                }
                deferred.resolve(granted);
            });
            return deferred.promise;
        };
    }

    // Given an Object tree, return flat Object with compound, dot-notated keys
    // (e.g. {a1:{b1:'x',b2:{c1:'y'}},a2:'z'} -> {'a1.b1':'x','a1.b2.c1':'y','a2':'z'})
    function flattenObj(obj, filter) {
        var flat = {};
        function traverse(obj, key) {
            var compound, val;
            for (var prop in obj) {
                compound = key ? key + '.' + prop : prop;
                val = obj[prop];
                if (typeof val === 'object') {
                    traverse(val, compound);
                } else {
                    if (filter) {
                        if (!filter(obj, prop, compound)) { continue; }
                    }
                    flat[compound] = val;
                }
            }
        }
        traverse(obj);
        return flat;
    }

    /* adapted from angularJS 1.3.12 */
    function getBlockNodes(nodes) {
      // TODO(perf): just check if all items in `nodes` are siblings and if they are return the original
      //             collection, otherwise update the original collection.
      var node = nodes[0];
      var endNode = nodes[nodes.length - 1];
      var blockNodes = [node];

      do {
        node = node.nextSibling;
        if (!node) { break; }
        blockNodes.push(node);
      } while (node !== endNode);

      return angular.element(blockNodes);
    }

    /* adapted from ngIf angularJS 1.3.12 */
    function permissionDirective($animate, bmPermission) {
      return {
        multiElement: true,
        transclude: 'element',
        priority: 600,
        terminal: true,
        restrict: 'A',
        $$tlb: true,
        link: function($scope, $element, $attr, ctrl, $transclude) {
            var block, childScope, previousElements;

            function bmIfPermWatchAction(value) {
                handlePermAttrChange('bmIfPerm', value);
            }

            function bmIfPermEveryWatchAction(value) {
                handlePermAttrChange('bmIfPermEvery', value);
            }

            function bmIfPermSomeWatchAction(value) {
                handlePermAttrChange('bmIfPermSome', value);
            }

            function bmIfNotPermWatchAction(value){
                handlePermAttrChange('bmIfNotPerm', value);
            }

            function bmIfNotPermSomeWatchAction(value){
                handlePermAttrChange('bmIfNotPermSome', value);
            }

            function bmIfNotPermEveryWatchAction(value){
                handlePermAttrChange('bmIfNotPermEvery', value);
            }

            function bmIfFirmLicenseSomeWatchAction(value) {
                handlePermAttrChange('bmIfFirmLicenseSome', value);
            }

            function handlePermAttrChange(type, value) {
                bmPermission[type === 'bmIfPermEvery' ? 'hasEvery' : type === 'bmIfNotPermEvery' ? 'notEvery' : type === 'bmIfNotPerm' || type === 'bmIfNotPermSome' ? 'not' : 'has'](value || $attr[type]).then(function() {
                    if (!childScope) {
                      $transclude(function(clone, newScope) {
                        childScope = newScope;
                        clone[clone.length++] = document.createComment(' end ' + type + ': ' + $attr[type] + ' ');
                        // Note: We only need the first/last node of the cloned nodes.
                        // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                        // by a directive with templateUrl when its template arrives.
                        block = {
                          clone: clone
                        };
                        $animate.enter(clone, $element.parent(), $element);
                      });
                    }
                }, function() {
                    if (previousElements) {
                      previousElements.remove();
                      previousElements = null;
                    }
                    if (childScope) {
                      childScope.$destroy();
                      childScope = null;
                    }
                    if (block) {
                      previousElements = getBlockNodes(block.clone);
                      $animate.leave(previousElements).then(function() {
                        previousElements = null;
                      });
                      block = null;
                    }
                });
            }

            if ($attr.bmIfPerm) {
                var unwatchIfPerm = $scope.$watch($attr.bmIfPerm, bmIfPermWatchAction);
            }
            if ($attr.bmIfPermEvery) {
                var unwatchIfPermEvery = $scope.$watch($attr.bmIfPermEvery, bmIfPermEveryWatchAction);
            }
            if ($attr.bmIfPermSome) {
                var unwatchIfPermSome = $scope.$watch($attr.bmIfPermSome, bmIfPermSomeWatchAction);
            }
            if($attr.bmIfNotPerm){
                var unwatchIfNotPerm = $scope.$watch($attr.bmIfNotPerm, bmIfNotPermWatchAction);
            }
            if($attr.bmIfNotPermSome){
                var unwatchIfNotPermSome = $scope.$watch($attr.bmIfNotPermSome, bmIfNotPermSomeWatchAction);
            }
            if ($attr.bmIfNotPermEvery) {
                var unwatchIfNotPermEvery = $scope.$watch($attr.bmIfNotPermEvery, bmIfNotPermEveryWatchAction);
            }
             if ($attr.bmIfFirmLicenseSome) {
                var unwatchIfFirmLicenseSome = $scope.$watch($attr.bmIfFirmLicenseSome, bmIfFirmLicenseSomeWatchAction);
            }

            // cleanup
            $element.on('$destroy', function () {
                if (unwatchIfPerm) { unwatchIfPerm(); }
                if (unwatchIfPermEvery) { unwatchIfPermEvery(); }
                if (unwatchIfPermSome) { unwatchIfPermSome(); }
                if (unwatchIfNotPerm) { unwatchIfNotPerm(); }
                if (unwatchIfNotPermSome) { unwatchIfNotPermSome(); }
                if (unwatchIfNotPermEvery) { unwatchIfNotPermEvery(); }
                if (unwatchIfFirmLicenseSome) { unwatchIfFirmLicenseSome(); }
            });
        }
      };
    }

    Permission.$inject = ['$q', 'AuthenticatedSessionData'];
    permissionDirective.$inject = ['$animate', 'bmPermission'];

    angular.module('bmPermission', ['bluemoon.components.session'])
        .service('bmPermission', Permission)
        .directive('bmIfPerm', permissionDirective)
        .directive('bmIfPermSome', permissionDirective)
        .directive('bmIfPermEvery', permissionDirective)
        .directive('bmIfNotPerm', permissionDirective)
        .directive('bmIfNotPermSome', permissionDirective)
        .directive('bmIfNotPermEvery', permissionDirective)
        .directive('bmIfFirmLicenseSome', permissionDirective);

 })(window.angular);

(function(angular) {
    'use strict';

    function Access($q, bmEnvironment) {
        var self = this;

        // Can be used for route resolve to determine if you have access.
        // For example,
        // resolve: {
        //     selfReg: bmAccess.has('SelfRegistration').catch(function () {
        //         $state.go('notfound');
        //     })
        // }
        self.has = function(accessControls, hasEvery) {
            return bmEnvironment.getEnvironmentAsync().then(function(data) {
                var grants = data.InfrastructureAccessControls;
                var granted = false;
                if (angular.isArray(accessControls)) {
                    accessControls[hasEvery ? 'every' : 'some'](function(accessControl) {
                        if (grants) {
                            granted = grants.indexOf(accessControl) > -1;
                        } else {
                            granted = false;
                        }
                        return granted;
                    });
                } else if (typeof accessControls === 'string') {
                    if (grants) {
                        granted = grants.indexOf(accessControls) > -1;
                    }
                }
                if (granted) {
                    return granted;
                } else {
                    return $q.reject(granted);
                }
            });
        };

        self.hasSome = function(accessControls) {
            return self.has(accessControls);
        };

        self.hasEvery = function(accessControls) {
            return self.has(accessControls, true);
        };

        self.not = function(accessControls){
            var deferred = $q.defer();
            self.has(accessControls).then(function(){
                deferred.reject(false);
            }, function(){
                deferred.resolve(true);
            });
            return deferred.promise;
        };

        self.notSome = function(accessControls){
            return self.not(accessControls);
        };

        self.notEvery = function(accessControls){
            return self.not(accessControls, true);
        };
    }

    /* adapted from angularJS 1.3.12 */
    function getBlockNodes(nodes) {
      // TODO(perf): just check if all items in `nodes` are siblings and if they are return the original
      //             collection, otherwise update the original collection.
      var node = nodes[0];
      var endNode = nodes[nodes.length - 1];
      var blockNodes = [node];

      do {
        node = node.nextSibling;
        if (!node) { break; }
        blockNodes.push(node);
      } while (node !== endNode);

      return angular.element(blockNodes);
    }

    /* adapted from ngIf angularJS 1.3.12 */
    function accessDirective($animate, bmAccess) {
      return {
        multiElement: true,
        transclude: 'element',
        priority: 600,
        terminal: true,
        restrict: 'A',
        $$tlb: true,
        link: function($scope, $element, $attr, ctrl, $transclude) {
            var block, childScope, previousElements;

            function bmIfHasAccessWatchAction(value) {
                handleAccessAttrChange('bmIfHasAccess', value);
            }

            function bmIfHasAccessEveryWatchAction(value) {
                handleAccessAttrChange('bmIfHasAccessEvery', value);
            }

            function bmIfHasAccessSomeWatchAction(value) {
                handleAccessAttrChange('bmIfHasAccessSome', value);
            }

            function bmIfHasNoAccessWatchAction(value){
                handleAccessAttrChange('bmIfHasNoAccess', value);
            }

            function bmIfHasNoAccessSomeWatchAction(value){
                handleAccessAttrChange('bmIfHasNoAccessSome', value);
            }

            function bmIfHasNoAccessEveryWatchAction(value){
                handleAccessAttrChange('bmIfHasNoAccessEvery', value);
            }

            function handleAccessAttrChange(type, value) {
                bmAccess[type === 'bmIfHasAccessEvery' ? 'hasEvery'
                    : type === 'bmIfHasNoAccessEvery' ? 'notEvery'
                    : type === 'bmIfHasNoAccess' || type === 'bmIfHasNoAccessSome' ? 'not'
                    : 'has'
                ](value || $attr[type]).then(function() {

                    if (!childScope) {
                      $transclude(function(clone, newScope) {
                        childScope = newScope;
                        clone[clone.length++] = document.createComment(' end ' + type + ': ' + $attr[type] + ' ');
                        // Note: We only need the first/last node of the cloned nodes.
                        // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                        // by a directive with templateUrl when its template arrives.
                        block = {
                          clone: clone
                        };
                        $animate.enter(clone, $element.parent(), $element);
                      });
                    }
                }, function() {
                    if (previousElements) {
                      previousElements.remove();
                      previousElements = null;
                    }
                    if (childScope) {
                      childScope.$destroy();
                      childScope = null;
                    }
                    if (block) {
                      previousElements = getBlockNodes(block.clone);
                      $animate.leave(previousElements).then(function() {
                        previousElements = null;
                      });
                      block = null;
                    }
                });
            }

            if ($attr.bmIfHasAccess) {
                var unwatchIfHasAccess = $scope.$watch($attr.bmIfHasAccess, bmIfHasAccessWatchAction);
            }
            if ($attr.bmIfHasAccessEvery) {
                var unwatchIfHasAccessEvery = $scope.$watch($attr.bmIfHasAccessEvery, bmIfHasAccessEveryWatchAction);
            }
            if ($attr.bmIfHasAccessSome) {
                var unwatchIfHasAccessSome = $scope.$watch($attr.bmIfHasAccessSome, bmIfHasAccessSomeWatchAction);
            }
            if($attr.bmIfHasNoAccess){
                var unwatchIfHasNoAccess = $scope.$watch($attr.bmIfHasNoAccess, bmIfHasNoAccessWatchAction);
            }
            if($attr.bmIfHasNoAccessSome){
                var unwatchIfHasNoAccessSome = $scope.$watch($attr.bmIfHasNoAccessSome, bmIfHasNoAccessSomeWatchAction);
            }
            if ($attr.bmIfHasNoAccessEvery) {
                var unwatchIfHasNoAccessEvery = $scope.$watch($attr.bmIfHasNoAccessEvery, bmIfHasNoAccessEveryWatchAction);
            }

            // cleanup
            $element.on('$destroy', function () {
                if (unwatchIfHasAccess) { unwatchIfHasAccess(); }
                if (unwatchIfHasAccessEvery) { unwatchIfHasAccessEvery(); }
                if (unwatchIfHasAccessSome) { unwatchIfHasAccessSome(); }
                if (unwatchIfHasNoAccess) { unwatchIfHasNoAccess(); }
                if (unwatchIfHasNoAccessSome) { unwatchIfHasNoAccessSome(); }
                if (unwatchIfHasNoAccessEvery) { unwatchIfHasNoAccessEvery(); }
            });
        }
      };
    }

    Access.$inject = ['$q', 'bmEnvironment'];
    accessDirective.$inject = ['$animate', 'bmAccess'];

    angular.module('bmAccess', ['bmEnvironment'])
        .service('bmAccess', Access)
        .directive('bmIfHasAccess', accessDirective)
        .directive('bmIfHasAccessSome', accessDirective)
        .directive('bmIfHasAccessEvery', accessDirective)
        .directive('bmIfHasNoAccess', accessDirective)
        .directive('bmIfHasNoAccessSome', accessDirective)
        .directive('bmIfHasNoAccessEvery', accessDirective);

 })(window.angular);

(function(angular, location){
    'use strict';

    // NOTE: May need updating when adding domains
    var countryDefaultLangMap = {
        'ar': 'es-AR',
        'au': 'en-AU',
        'br': 'pt-BR',
        'ca': 'en-CA',
        'in': 'en-IN',
        'nl': 'nl-NL',
        'uk': 'en-GB',
        'us': 'en-US'
    };

    var tldCountryOverrideMap = {
        'com': 'us'
    };

    // NOTE: Must be updated when adding languages
    var supportedLanguages = [
        {
            // standardized language code
            code: 'en-US',
            // description in given language
            description: 'English (United States)',
            // countries where this language is available
            countryCodes: [
                'us'
            ],
            // description translations for other languages supported in country
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃƞɠļɨšɧ (Ǔƞɨƭȅɗ Ѕƭăƭȅš)!!!!!!!!]'
                }
            ]
        },
        {
            code: 'en-GB',
            description: 'English (United Kingdom)',
            countryCodes: [
                'uk'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃƞɠļɨšɧ (Ǔƞɨƭȅɗ Ќɨƞɠɗǒɱ)!!!!!!!!]'
                }
            ]
        },
        {
            code: 'en-AU',
            description: 'English (Australia)',
            countryCodes: [
                'au'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃƞɠļɨšɧ (Ăʊšƭɾăļɨă)!!!!!!!]'
                }
            ]
        },
        {
            code: 'en-CA',
            description: 'English (Canada)',
            countryCodes: [
                'ca'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃƞɠļɨšɧ (Ĉăƞăɗă)!!!!!!]'
                },
                {
                    code: 'fr-CA',
                    description: 'Anglais (Canada)'
                }
            ]
        },
        {
            code: 'en-IN',
            description: 'English (India)',
            countryCodes: [
                'in'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃƞɠļɨšɧ (ɨƞɗɨă)!!!!!!!!]'
                }
            ]
        },
        {
            code: 'fr-CA',
            description: 'Français (Canada)',
            countryCodes: [
                'ca'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ƒɾăƞçăɨš (Ĉăƞăɗă)!!!!!!]'
                },
                {
                    code: 'en-CA',
                    description: 'French (Canada)'
                }
            ]
        },
        {
            code: 'es-AR',
            description: 'Español (Argentina)',
            countryCodes: [
                'ar'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ʃšρăñǒļ (Ăɾɠȅƞƭɨƞă)!!!!!!!]'
                }
            ]
        },
        {
            code: 'pt-BR',
            description: 'Português (Brasil)',
            countryCodes: [
                'br'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[Ƥǒɾƭʊɠʊêš (ßɾăšɨļ)!!!!!!]'
                }
            ]
        },
        {
            code: 'nl-NL',
            description: 'Nederlands (Nederland)',
            countryCodes: [
                'nl'
            ],
            translations: [
                {
                    code: 'xx-XX',
                    description: '[ƞêɗêɾļăƞɗš (ƞêɗêɾļăƞɗ)!!!!!!]'
                }
            ]
        },
        {
            code: 'xx-XX',
            description: '[Ƥšȅʊɗǒļǒĉăļɨʐȅɗ!!!!!]',
            countryCodes: [
                'us',
                'uk',
                'ca',
                'au',
                'in',
                'ar',
                'br',
                'nl'
            ],
            translations: [
                {
                    code: 'en-US',
                    description: 'Pseudolocalized'
                },
                {
                    code: 'en-GB',
                    description: 'Pseudolocalised'
                },
                {
                    code: 'en-CA',
                    description: 'Pseudolocalized'
                },
                {
                    code: 'en-AU',
                    description: 'Pseudolocalized'
                },
                {
                    code: 'en-IN',
                    description: 'Pseudolocalized'
                },
                {
                    code: 'es-AR',
                    description: 'Pseudo Localizada'
                },
                {
                    code: 'fr-CA',
                    description: 'Pseudo Localisée'
                },
                {
                    code: 'pt-BR',
                    description: 'Pseudo Localizada'
                },
                {
                    code: 'nl-NL',
                    description: 'Pseudo Gelokaliseerde'
                }
            ]
        }
    ];

    var domainCountryCodePtn = /\.([a-z]+)$/,
        hostname = location.hostname.toLowerCase(),
        isProdEnv = !/^(ci|demo|qed|localhost|\d+)\b/.test(hostname),
        isLowerEnv = /^(ci|demo|qed)\b/.test(hostname),
        isLocalEnv = /^(localhost|0\.0\.0\.0|127\.0\.0\.1)$/.test(hostname),
        envType = isProdEnv ?
            'PROD' : isLowerEnv ?
                hostname.replace(/^(ci|demo|qed)\..*/, '$1').toUpperCase() : isLocalEnv ?
                    'LOCAL' : 'UNKNOWN',
        isQedOrProd = /(PROD|QED)/.test(envType);

    var environmentConst = {
        // caveat: if you use a machine IP address these will be false
        isProdType: isProdEnv,
        isQedOrProdType: isQedOrProd,
        // "lower" = CI, DEMO, or QED
        // caveat: if naming scheme stays from Onvio standard it will be false
        isLowerType: isLowerEnv,
        // caveat: if you use your IP address it will be false
        isLocalType: isLocalEnv,
        // possible values: 'PROD', 'QED', 'DEMO', 'CI', 'LOCAL', 'UNKNOWN'
        type: envType,
        defaultLang: getCountryDefaultLanguage()
    };

    function Environment($q, $http, $location, bmEnvironmentUrl){
        var factory = {
            load: getEnvironmentAsync,
            getEnvironmentAsync: getEnvironmentAsync,
            getSupportedLanguagesAsync: getSupportedLanguagesAsync,
            getCountryDefaultLanguage: getCountryDefaultLanguage,
            getCountryCode: getCountryCode,
            getPrimaryProduct: getPrimaryProduct,
            getRoute: getRoute,
            // older function-style prop to be deprecated, replaced by envConst
            isQedOrProdDomain: testQedOrProdDomain,

            /* Generated functions are available for each key in
               countryDefaultLangMap. For example,

               isUsCountryCode()
               isUkCountryCode()
               isCaCountryCode()
               isArCountryCode()
               isBrCountryCode()
            */
        };

        var environmentDeferred;

        generateCountryTestFns();
        return factory;

        ////////////////////////////////

        function testQedOrProdDomain(){
            return isQedOrProd;
        }

        function generateCountryTestFns() {
            var currentCode = getCountryCode();
            Object.keys(countryDefaultLangMap).forEach(function(code) {
                factory['is' + code.charAt(0).toUpperCase() + code.charAt(1) + 'CountryCode'] = function() {
                    return code === currentCode;
                };
            });
        }

        function getEnvironmentAsync(){
            if(environmentDeferred){
                return environmentDeferred.promise;
            }

            environmentDeferred = $q.defer();

            $http({
                method: 'GET',
                url: bmEnvironmentUrl,
                cache: true
            }).then(function(resp){
                environmentDeferred.resolve(resp.data);
            }, function(){
                environmentDeferred.resolve({});
            });

            return environmentDeferred.promise;
        }

        function getSupportedLanguagesAsync(){
            var languageList = [];
            var baseLanguages = angular.copy(supportedLanguages);

            return getEnvironmentAsync().then(function(environment){
                var locales = angular.isDefined(environment.locales) ? environment.locales : getDomainBasedLocales();

                for(var langIndex = 0; langIndex < baseLanguages.length; langIndex++){
                    if(locales.indexOf(baseLanguages[langIndex].code) >= 0){
                        languageList.push(baseLanguages[langIndex]);
                    }
                }

                return languageList;
            });
        }

        function getPrimaryProduct(){
            // default to onvio for now. may need to default to a product based on domain at some point?
            return getEnvironmentAsync().then(function(environment){
                return (environment.primaryProduct || 'onvio') || 'onvio';
            });
        }

        function getDomainBasedLocales(){
            var locales = [];
            var countryCode = getCountryCode();
            var baseLanguages = angular.copy(supportedLanguages);

            for(var counter = 0; counter < baseLanguages.length; counter++){
                if(baseLanguages[counter].countryCodes.indexOf(countryCode) >= 0){
                    locales.push(baseLanguages[counter].code);
                }
            }

            return locales;
        }

        function getRoute(routeName){
            if(angular.isUndefined(routeName) || routeName === ''){
                return $q.when('');
            }

            return getEnvironmentAsync().then(function(data){
                if(data.RoutingTable && data.RoutingTable[routeName]){
                    return data.RoutingTable[routeName];
                }

                return '';
            });
        }
    }

    function getCountryCode() {
        var matches = domainCountryCodePtn.exec(hostname);
        var tld = (matches && matches[1].toLowerCase()) || 'us';
        return tldCountryOverrideMap[tld] || tld;
    }

    // can't use $location service in config phase.
    // we need to set the default lang in angular translate during config
    function getCountryDefaultLanguage() {
        return countryDefaultLangMap[getCountryCode()] || 'en-US';
    }

    Environment.$inject = ['$q', '$http', '$location', 'bmEnvironmentUrl'];
    angular.module('bmEnvironment', [])
        .factory('bmEnvironment', Environment)
        .constant('bmEnvironmentConst', environmentConst)
        .value('bmEnvironmentUrl', '/api/security/v2/environments')
        // todo: deprecate bmEnvCountryDefaultLang since it's under bmEnvironmentConst
        .constant('bmEnvCountryDefaultLang', getCountryDefaultLanguage())
        .constant('bmSupportedLanguagesMetadata', supportedLanguages);

})(window.angular, window.location);

(function(angular){
    'use strict';

    angular.module('bmUserTermsSignatory', [
        'ui.bootstrap',
        'bluemoon.components.session',
        'bmUser'
    ])
    .factory('bmUserSignatory', bmUserSignatory)
    .controller('bmTermsSignatoryCtrl', bmTermsSignatoryCtrl)
    .directive('bmTermsSignatory',['$uibModal', 'AuthenticatedSession', 'bmUserSignatory', function($uibModal, session, bmUserSignatory){
        return {
            restrict: 'EA',
            link: function(){
                bmUserSignatory.getRequiredUserSignatoryAsync().then(function(signatory){
                    // Any signatories required?
                    if(angular.isDefined(signatory) && angular.isDefined(signatory.terms) && angular.isUndefined(signatory.signatory)){
                        var modalInstance = $uibModal.open({
                            templateUrl: 'components/terms-signatory/terms-signatory-modal.2js.html',
                            controller: 'bmTermsSignatoryCtrl as vm',
                            size: 'lg',
                            backdrop: 'static',
                            keyboard: false,
                            resolve: {
                                termsText: function(){
                                    return signatory.terms.text;
                                }
                            }
                        });

                        modalInstance.result.then(function(isSigned){
                            if(isSigned){
                                // Process signatory
                                bmUserSignatory.setSignatoryForTermsAsync(signatory.terms.id);
                            } else {
                                // Redirect to login page
                                session.destroy();
                            }
                        });
                    }
                }, function(response){
                    if (response) {
                        // Don't propogate error
                        response.config.global = false;
                    }
                });
            }
        };
    }]);

    //////////

    bmUserSignatory.$inject = ['$log', '$q', '$http','bmUser', 'AuthenticatedSessionData'];
    function bmUserSignatory($log, $q, $http, bmUser, sessionData){
        var factory = {
            getRequiredUserSignatoryAsync: getRequiredUserSignatoryAsync,
            setSignatoryForTermsAsync: setSignatoryForTermsAsync
        };

        return factory;

        //////////

        function getRequiredUserSignatoryAsync(){
            var signatory = { terms: undefined, signatory: undefined };

            return sessionData.getMeta().then(function(data) {
                // don't require user to accept terms if 'viewing portal as'
                if (!angular.isUndefined(data.EmulateePrismGuid)) {
                    return signatory;
                }

                return bmUser.load().then(function(){

                    return loadActiveTermsAsync(bmUser.companyId, bmUser.language).then(function(terms){
                        if(angular.isUndefined(terms)){
                            return signatory;
                        }

                        signatory.terms = terms;

                        return loadUserSignatoryForTermsAsync(bmUser, terms.id).then(function(data){
                            signatory.signatory = data;
                            return signatory;
                        });
                    });
                });
            });
        }

        function setSignatoryForTermsAsync(termsId){
            return bmUser.load().then(function(){
                return $http({
                    method: 'POST',
                    url: '/api/profiles/v1/companies/' + bmUser.companyId + '/terms/' + termsId + '/signatories',
                    headers: {
                        'Accept-Language': bmUser.language
                    },
                    data: { termsId: termsId, bluid: bmUser.bluId }
                }).then(function(response){
                    return response;
                }, function(response){
                    response.config.global = false;
                });
            });
        }

        //////////

        function loadActiveTermsAsync(companyId, language){
            return $http({
                method: 'GET',
                url: '/api/profiles/v1/companies/' + companyId + '/terms/active',
                headers: {
                    'Accept-Language': language
                }
            }).then(function(response){
                return response.data;
            }, function(response){
                // 404 = no active terms found
                if(response.status === 404){
                    response.config.global = false;
                    $log.info('Sorry, GET 404 (Not Found) for active terms is a possible valid response, no need for concern.');
                    return undefined;
                }

                return $q.reject(response);
            });
        }

        function loadUserSignatoryForTermsAsync(user, termsId){
            return $http({
                method: 'GET',
                url: '/api/profiles/v1/companies/' + user.companyId + '/terms/' + termsId + '/signatories/' + user.bluId,
                headers: {
                    'Accept-Language': user.language
                }
            }).then(function(response){
                return response.data;
            }, function(response){
                // 404 = no signatory found
                if(response.status === 404){
                    response.config.global = false;
                    $log.info('Sorry, GET 404 (Not Found) for signatories is a possible valid response, no need for concern.');
                    return undefined;
                }

                return $q.reject(response);
            });
        }
    }

    //////////

    bmTermsSignatoryCtrl.$inject = ['$sce', '$uibModalInstance', 'termsText'];
    function bmTermsSignatoryCtrl($sce, $uibModalInstance, termsText){
        /*jshint validthis:true */
        var vm = this;
        vm.setAgreement = setAgreement;
        vm.displayText = $sce.trustAsHtml(convertTermsTextToHtml(termsText));

        //////////

        function setAgreement(agreed){
            $uibModalInstance.close(agreed);
        }

        function convertTermsTextToHtml(text){
            return text.replace(/\r\n|\n\r|\n|\r/g, '<br />');
        }
    }
})(window.angular);

(function(angular) {
    'use strict';

    /* EXPORT */
    angular.module('bmUser', ['bluemoon.myAccount', 'bluemoon.components.util', 'bluemoon.components.i18n'])
        .service('bmUser', User);

    User.$inject = ['$window', 'myAccountService', 'bmUtil', 'bmLanguageManager', 'bmLanguageCookieName'];

    /**
     * Intrinsic current user
     */
    function User(window, usersService, util, langMgr, langCookieName) {
        var self = this;
        var imgDataPrefix = 'data:image;base64,';
        var loadPromise;

        /* PROPS */
        function init() {
            // id (string, optional): TRuid associated with this user in IAM,
            self.id = '';
            // email (string, optional): Email address,
            self.email = '';
            // firstName (string, optional): User's given name,
            self.firstName = '';
            // middleName (string, optional): User's middle name,
            self.middleName = '';
            // lastName (string, optional): User's last or family name,
            self.lastName = '';
            // suffix (string, optional): Post-nominal letters appended to a user's common name,
            self.suffix = '';
            // language (string, optional): User's first language,
            self.language = '';
            // photo (string, optional): User's profile photo,
            self.photo = '';
            // bluId (string, optional): BLUid or PrismGuid associated with this user,
            self.bluId = '';
            // companyId (string, optional): CompanyId associated with this user,
            self.companyId = '';
            // contactId (string, optional): ContactId associated with this user,
            self.contactId = '';
            // licensee (boolean, optional): User is a licensee for CSWeb
            self.licensee = false;
        }

        /* COMPUTEDS */
        window.Object.defineProperties(self, {
            'fullName': {
                enumerable: true,
                get: function() {
                    var delimiter = ' ';
                    // if (useMiddle === true && self.middleName) { delimiter += self.middleName + delimiter; }
                    return (self.firstName + delimiter + self.lastName).trim();
                }
            },
            'initials': {
                enumerable: true,
                get: function() {
                    var delimiter = '';
                    // if (useMiddle === true && self.middleName) { delimiter = self.middleName.charAt(0); }
                    return self.firstName.charAt(0) + delimiter + self.lastName.charAt(0);
                }
            },
            'languages': {
                enumerable: true,
                get: function() {
                    var prefs = [];

                    // cookie
                    var cookiePref = util.cookie(langCookieName);
                    if (cookiePref) { prefs.push(cookiePref); }

                    // service data
                    var asyncPref = self.language;
                    if (asyncPref) { prefs.push(asyncPref); }

                    // browser prefs
                    var navPrefs = window.navigator.languages;
                    if (navPrefs && navPrefs.length) {
                        prefs = prefs.concat(navPrefs);
                    } else {
                        // msie < 11
                        navPrefs = window.navigator.browserLanguage;
                        if (navPrefs) { prefs.push(navPrefs); }
                    }

                    return util.uniq(prefs); // elim dupes
                }
            }
        });

        /* METHODS */
        self.init = init;
        self.load = function(reload) {
            if (!loadPromise || reload === true) {
                loadPromise = usersService.getMyUserSettingsAsync();
                loadPromise.then(function(resp) {
                    if (resp.data.photo) {
                        resp.data.photo = imgDataPrefix + resp.data.photo;
                    }
                    // update data
                    util.extend(self, resp.data);

                    if (self.language) {
                        // update current lang to user's pref
                        langMgr.setUserLanguageAsync(self.language);
                    }
                });
            }

            return loadPromise;
        };
        self.save = function() {
            var obj;

            if (self.photo) {
                obj = angular.copy(self);
                obj.photo = obj.photo.split(';base64,')[1];
            } else {
                obj = self;
            }

            return usersService.saveUserAsync(obj);
        };

        init();
    }

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmFileReader', []);
})(window.angular);

(function(angular, FileReader){
    // http://odetocode.com/blogs/scott/archive/2013/07/03/building-a-filereader-service-for-angularjs-the-service.aspx
    // Note: Possible shim for IE 9 https://github.com/moxiecode/moxie
    'use strict';

    angular.module('bmFileReader').factory('bmFileReader', fileReader);
    fileReader.$inject = ['$q'];

    function fileReader($q)
    {
        return {
            readAsDataURL: readAsDataURL
        };

        /////////////

        function readAsDataURL(file, scope){
            var deferred = $q.defer();
            var reader = getReader(deferred, scope);
            reader.readAsDataURL(file);
            return deferred.promise;
        }

        function onLoad(reader, deferred, scope){
            return function(){
                if(angular.isUndefined(scope)){
                    return;
                }

                scope.$apply(function(){
                    deferred.resolve(reader.result);
                });
            };
        }

        function onError(reader, deferred, scope){
            return function(){
                if(angular.isUndefined(scope)){
                    return;
                }

                scope.$apply(function(){
                    deferred.reject(reader.result);
                });
            };
        }

        function onProgress(reader, scope){
            return function(event){
                if(angular.isUndefined(scope)){
                    return;
                }

                scope.$broadcast('fileProgress',
                    {
                        total: event.total,
                        loaded: event.loaded
                    });
            };
        }

        function getReader(deferred, scope){
            var reader = new FileReader();
            reader.onload = onLoad(reader, deferred, scope);
            reader.onerror = onError(reader, deferred, scope);
            reader.onprogress = onProgress(reader, scope);
            return reader;
        }
    }
})(window.angular, window.FileReader);

(function(angular){
    'use strict';

    angular.module('bmFileReader').directive('fileUploadPreview', filePreview);

    // TODO: COMPLETELY COPIED FROM STAFF. NEED TO REMOVE FROM STAFF.
    function filePreview(){
        return {
            scope: {
                previewCallback: '&previewCallback'
            },
            link: function(scope, element){
                element.bind('change', function(e){
                    var file = (e.srcElement || e.target).files[0];

                    // User defined callback to handle result of file read
                    scope.previewCallback({file: file});
                });
            }
        };
    }
})(window.angular);

(function(angular, Math){
  'use strict';

  angular.module('bmImageUploadModal', [
    'ui.bootstrap',
    'pascalprecht.translate',
    'bluemoon.components.i18n',
    'angularFileUpload',
    'bmFileReader',
    'ngImgCrop',
    'bento.services',
    'bento.progressbar'
  ])

  .controller('bmImageUploadModalCtrl', [
    '$q', '$scope', '$uibModalInstance', '$translate', '$timeout', 'bmFileReader', 'config',
    function ($q, $scope, $uibModalInstance, $translate, $timeout, bmFileReader, config){
    /*jshint validthis:true */
    var vm = this;

    vm.fileOnChange = fileOnChange;
    vm.close = closeModal;
    vm.save = saveImage;
    vm.cancel = cancelModal;
    vm.delete = deleteImage;
    vm.resetAlerts = resetAlerts;
    vm.croppedImage = '';
    vm.progress = 0;
    vm.progressType = 'danger';
    vm.alerts = [];
    vm.cropShape = angular.isDefined(config.cropShape) && config.cropShape === 'square' ? 'square' : 'circle';
    vm.currentImage = angular.isDefined(config.image) && config.image !== '';
    vm.deletable = config.deletable;

    // configurable text options
    var promises = [
      $translate('bm.image.upload.title'),
      $translate('bm.image.upload.dragImage'),
      $translate('bm.image.upload.uploadImageButton'),
      $translate('bm.image.upload.deleteImageButton'),
      $translate('bm.image.upload.uploadAnotherImage'),
      $translate('bm.image.upload.saveImageButton')
    ];

    $q.all(promises).then(function(values){
      vm.uploadTitleText = angular.isDefined(config.uploadTitleText) ? config.uploadTitleText : values[0];
      vm.dragImageText = angular.isDefined(config.dragImageText) ? config.dragImageText : values[1];
      vm.uploadImageButtonText = angular.isDefined(config.uploadImageButtonText) ? config.uploadImageButtonText : values[2];
      vm.deleteImageButtonText = angular.isDefined(config.deleteImageButtonText) ? config.deleteImageButtonText : values[3];
      vm.uploadAnotherImageText = angular.isDefined(config.uploadAnotherImageText) ? config.uploadAnotherImageText : values[4];
      vm.saveImageButtonText = angular.isDefined(config.saveImageButtonText) ? config.saveImageButtonText : values[5];
    });

    $scope.$on('fileProgress', function(e, progress) {
      var progressValue = Math.round((progress.loaded / progress.total) * 100);
      var progressType;

      if (progressValue < 25) {
        progressType = 'danger';
      } else if (progressValue < 50) {
        progressType = 'warning';
      } else if (progressValue < 75) {
        progressType = 'info';
      } else {
        progressType = 'success';
      }

      setProgress(progressValue, progressType);
    });

    ///////////

    function fileOnChange(files, event, rejectedFiles) {
      resetAlerts();

      if(files && files.length > 0){
        // Only selection/drop of one image
        if(files.length > 1){
          $translate('bm.header.profileDialog.multipleFileMessage').then(function(value){
            addAlert(value, 'warning');
          });

          return;
        }

        bmFileReader.readAsDataURL(files[0], $scope).then(function(result){
          setProgress();

          if(result.indexOf('data:image') >= 0){
            vm.selectedImageSrc = result;
              return;
            }

            $translate('bm.header.profileDialog.invalidFileMessage').then(function(value){
              addAlert(value, 'warning');
            });
        }, function(){
          setProgress();

          $translate('bm.header.profileDialog.fileReadMessage').then(function(value){
            addAlert(value, 'danger');
          });
        });
      } else if(angular.isDefined(rejectedFiles) && rejectedFiles.length > 0){
        $translate('bm.header.profileDialog.invalidFileMessage').then(function(value){
          addAlert(value, 'warning');
        });
      }
    }

    function setProgress(progress, progressType){
      // Needed to update watch parameters set on scope for bento-progressbar
      $timeout(function(){
        vm.progress = progress || 0;
        vm.progressType = progressType || 'danger';
      }, 0);
    }

    function saveImage(){
      $uibModalInstance.close(vm.croppedImage);
    }

    function closeModal(){
      $uibModalInstance.dismiss('close');
    }

    function deleteImage(){
      $uibModalInstance.close('');
    }

    function cancelModal(){
      $uibModalInstance.dismiss('cancel');
    }

    function addAlert(message, type){
      resetAlerts();
      vm.alerts.push({ msg: message, type: type, closeable: true });
    }

    function resetAlerts(){
      vm.alerts = [];
    }
  }])

  .directive('bmImageUploadModal',['$uibModal', function($uibModal){
    return {
      restrict: 'E',
      replace: false,
      scope: {
        api: '='
      },
      link: function (scope){
        // provide an api to allow public configuration to  consumer directives
        scope.internalApi = scope.api || {};

        // public method for opening upload modal
        scope.internalApi.openImageUploadModal = function(config){
          // setup the modal dialog
          var modalInstance = $uibModal.open({
            templateUrl: 'components/bm-image-upload-modal/bm-image-upload-modal.2js.html',
            controller: 'bmImageUploadModalCtrl as vm',
            size: 'md',
            backdrop: 'static',
            resolve: {
              config: function(){
                return config;
              }
            }
          });

          modalInstance.result.then(function(uploadedImage){
            // return the selected image
            config.imageUploadCallback(uploadedImage);
          }, function(){
            // return nothing for consumer response to cancel action
            config.imageUploadCallback();
          });
        };
      }
    };
  }]);
})(window.angular, window.Math);

(function(angular){
    'use strict';

    angular.module('bmProfilePhoto', [
        'pascalprecht.translate',
        'bluemoon.components.i18n',
        'bmImageUploadModal'
    ])

    .controller('bmProfilePhotoSelectCtrl', ['bmPermission', 'bmModal','$q', '$scope', '$timeout', '$rootScope', '$translate', function(bmPermission, bmModal,$q, $scope, $timeout, $rootScope, $translate){
        /*jshint validthis:true */
        var vm = this;
        var uploadConfig = {
            imageUploadCallback: imageUploadCallback
        };

        // pick up translated strings
        $rootScope.$on('$bmLanguageChangeSuccess', function () {
            uploadConfig.uploadTitleText = $translate.instant('bm.header.profileDialog.header');
            uploadConfig.dragImageText = $translate.instant('bm.header.profileDialog.dragPhoto');
            uploadConfig.uploadImageButtonText = $translate.instant('bm.header.profileDialog.selectPhoto');
            uploadConfig.deleteImageButtonText = $translate.instant('bm.header.profileDialog.deletePhoto');
            uploadConfig.uploadAnotherImageText = $translate.instant('bm.header.profileDialog.uploadAnotherPhoto');
            uploadConfig.saveImageButtonText = $translate.instant('bm.header.profileDialog.setAsProfilePhoto');
        });

        // provide a shared api with the upload controller for sharing open function
        vm.imageUploadApi = vm.imageUploadApi || {};

        vm.openProfileSelect = function(){
            if(!vm.selectEnabled){
                return;
            }

            uploadConfig.image = vm.image;
            uploadConfig.cropShape = vm.cropShape;
            uploadConfig.deletable = true;
            vm.imageUploadApi.openImageUploadModal(uploadConfig);
        };

        $scope.$watch('vm.image', function(newValue, oldValue){
            if(angular.isDefined(newValue)){
                if(newValue !== ''){
                    vm.selectedStyle = { 'background-image' : 'url(' + newValue + ')' };
                } else if(angular.isDefined(oldValue) && oldValue !== '') {
                    // remove old photo style
                    vm.selectedStyle = undefined;
                }
            }
        });

        $scope.$watch('vm.viewOnly()', function(newValue){
            vm.selectEnabled = !newValue;
        });

        /////////////
        vm.openPhotoModal = function () {
            bmPermission.has('Platform.PreviewMode')
                .then(function () {
                    vm.showUnauthorizedModal();
                }).catch(function () {
                    vm.openProfileSelect();
                });
        };
        vm.showUnauthorizedModal = function () {
            bmModal.modal({
                templateUrl: 'components/modal/modal-default.2js.html',
                showClose: false,
                vars: {
                    body: $translate.instant('bm.header.previewTrial.previewMode.UnauthorizedBody'),
                    title: $translate.instant('bm.header.previewTrial.previewMode.UnauthorizedTitle')
                },
                buttons: [
                    { text: $translate.instant('bm.header.previewTrial.previewMode.OKButton'), value: 1, primary: true }
                ]
            });
        };
        function imageUploadCallback(profileImage){
            // undefined value means the photo selection was dismissed with no changes being made
            if(angular.isUndefined(profileImage)){
                return;
            }

            vm.image = profileImage;
            $timeout(function() {
                $scope.$emit('bmProfilePhotoSelected', profileImage);
            });
        }
    }])

    .directive('bmProfilePhotoSelect',[function(){
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'components/profile-photo-select/profile-photo-select.2js.html',
            scope: {
                image: '=',
                size: '@',
                shape: '@',
                cropShape: '@',
                viewOnly: '&',
                initials: '@'
            },
            controller: 'bmProfilePhotoSelectCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }]);
})(window.angular);

(function(angular){
    'use strict';

    var module = angular.module('bmUserAvailability', [
        'ui.bootstrap',
        'pascalprecht.translate',
        'bmUser'
    ]);

    module.directive('bmUserAvailability', ['$q', '$translate', '$rootScope', 'bmStaffAvailabilityManager',
        function($q, $translate, $rootScope, staffAvailabilityManager){
            return {
                restrict: 'E',
                replace: true,
                templateUrl: 'components/bm-user-availability/bm-user-availability.2js.html',
                scope: {
                },
                link: function(scope){
                    var user;

                    // set defaults
                    scope.statusText = {};
                    scope.selectedDot = 'gray';
                    scope.availabilityText = '';
                    scope.changeStatus = changeStatus;
                    scope.changeStatusText = changeStatusText;

                    // only load/refresh status when the profile menu is opened
                    $rootScope.$on('bmProfileMenuOpened', function(){
                        loadViewData();
                    });

                    ///////////////

                    function loadViewData(){
                        var promises = [
                            $translate('bm.header.status.available'),
                            $translate('bm.header.status.away'),
                            $translate('bm.header.status.busy'),
                            $translate('bm.header.status.offline'),
                            $translate('bm.header.status.idle'),
                            $translate('bm.header.status.online')
                        ];

                        $q.all(promises).then(function(results){
                            scope.statusText.available = results[0];
                            scope.statusText.away = results[1];
                            scope.statusText.busy = results[2];
                            scope.statusText.offline = results[3];

                            // call after translations in case an error is thrown and rejects $q.all
                            staffAvailabilityManager.getUserAvailability().then(function(userAvailability){
                                user = userAvailability;
                                setStatusDisplay(userAvailability);
                            }, function(){
                                user = {};
                                setStatusDisplay(undefined);
                            });
                        });
                    }

                    function setStatusDisplay(userAvailability){
                        if(angular.isUndefined(userAvailability)){
                            $translate(scope.statusText.offline).then(function(str) {
                                scope.availabilityText = str;
                            });
                            scope.selectedDot = 'gray';
                            return;
                        }

                        if(angular.isUndefined(userAvailability.statusMessage) || userAvailability.statusMessage === ''){
                            userAvailability.statusMessage = userAvailability.status;
                        }

                        var transId = 'bm.header.status.' + userAvailability.statusMessage.toLowerCase();
                        $translate(transId, {}, '', userAvailability.statusMessage).then(function(str) {
                            scope.availabilityText = str;
                        });

                        switch(userAvailability.status){
                            case 'Away':
                                scope.selectedDot = 'yellow';
                                break;
                            case 'Available':
                            case 'Online':
                                scope.selectedDot = 'green';
                                break;
                            case 'Busy':
                                scope.selectedDot = 'red';
                                break;
                            default:
                                scope.selectedDot = 'gray';
                        }
                    }

                    function changeStatus(status, color){
                        var updatedUser = angular.copy(user);
                        updatedUser.statusMessage = scope.statusText[status.toLowerCase()];
                        updatedUser.status = status;

                        staffAvailabilityManager.updateUserStatus(updatedUser).then(function(){
                            user = updatedUser;
                            scope.selectedDot = color;
                            scope.availabilityText = updatedUser.statusMessage;
                        });
                    }

                    function changeStatusText(){
                        // did the text even change?
                        if(scope.availabilityText === user.statusMessage){
                            return;
                        }

                        var updatedUser = angular.copy(user);
                        updatedUser.statusMessage = scope.availabilityText;

                        if(scope.selectedDot === 'gray'){
                            updatedUser.status = 'Available';
                        }

                        staffAvailabilityManager.updateUserStatus(updatedUser).then(function(){
                            user = updatedUser;

                            if(scope.selectedDot === 'gray'){
                                scope.selectedDot = 'green';
                            }
                        });
                    }
                }
            };
        }
    ]);

    module.factory('bmStaffAvailabilityManager', availablityManager);
    availablityManager.$inject = ['$http', 'bmUser'];

    function availablityManager($http, bmUser){
        var factory = {
            getUserAvailability: getUserAvailability,
            updateUserStatus: updateUserStatus
        };

        var api = '/api/profiles/v1/staff-availability';

        return factory;

        //////////

        function getUserAvailability(){
            return bmUser.load().then(function(){
                return $http.get(api + '/' + bmUser.contactId).then(function(resp){
                    if(angular.isUndefined(resp) || angular.isUndefined(resp.data) || angular.isUndefined(resp.data.staffAvailability) === 0){
                        return undefined;
                    }

                    var people = resp.data.staffAvailability;
                    var user = people.filter(function(person){
                        return person.self;
                    });

                    return user.length === 0 ? undefined : user[0];
                });
            });
        }

        function updateUserStatus(user){
            return $http({
                method: 'PUT',
                url: api,
                data: user
            });
        }
    }
})(window.angular);

(function(w, angular){
  'use strict';

  var module = angular.module('bmClientNotificationsList', ['pascalprecht.translate', 'bmJobQueue']);
  var notificationOptions = {
    itemsPerPage: 50,
    pageNumber: 1,
    scroller: undefined,
    scrollerWrapper: undefined,
    onScrollHandler: undefined,
    allLoaded: false,
    cleanUpScroller: undefined
  };

  // find the location of the element within the view
  function getOffset(el) {
    el = el.getBoundingClientRect();

    // rounding because IE is dumb
    return {
      left: w.Math.round(el.left + (w.scrollX || w.pageXOffset)),
      top: w.Math.round(el.top + (w.scrollY || w.pageYOffset)),
      bottom: w.Math.round(el.bottom + (w.scrollY  || w.pageYOffset))
    };
  }

  // taken directly from underscore _.now
  var now = Date.now || function(){
    return new Date().getTime();
  };

  // taken directly from underscore _.throttle
  var throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;

    if(!options){
      options = {};
    }

    var later = function(){
      previous = options.leading === false ? 0 : Date.now || now();
      timeout = null;
      result = func.apply(context, args);

      if(!timeout){
        context = args = null;
      }
    };

    var getNow = function(){
      return now;
    };

    return function(){
      var now = getNow();

      if(!previous && options.leading === false){
        previous = now;
      }

      var remaining = wait - (now - previous);
      context = this;
      args = arguments;

      if(remaining <= 0 || remaining > wait){
        if (timeout){
          clearTimeout(timeout);
          timeout = null;
        }

        previous = now;
        result = func.apply(context, args);

        if(!timeout){
          context = args = null;
        }
      } else if(!timeout && options.trailing !== false){
        timeout = setTimeout(later, remaining);
      }

      return result;
    };
  };

  module.directive('bmClientNotificationsList', ['$window', '$timeout', '$translate', 'bmClientNotificationsListManager', function($window, $timeout, $translate, notificationsManager){
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'components/client-notifications/client-notifications-list.2js.html',
      link: function($scope){
        var itemsPerPage = notificationOptions.itemsPerPage;
        var scrollHandler = onScrollHandler;
        var notificationMap;

        $scope.isLoading = false;
        $scope.hasZeroItems = true;
        $scope.markAllNotificationsRead = markAllNotificationsRead;
        $scope.markNotificationRead = markNotificationRead;
        $scope.deleteNotification = deleteNotification;
        $scope.getFormattedTime = getFormattedTime;

        // respond to profile menu events for loading notifications
        $scope.$on('bmProfileMenuOpened', handleOpenedMenu);
        $scope.$on('bmProfileMenuClosed', handleClosedMenu);

        // get translated tooltip for delete notification
        $translate('bm.components.common.delete').then(function(value){
          $scope.deleteTranslated = value;
        }, function(){
          $scope.deleteTranslated = 'Delete';
        });

        $scope.notifications = [];
        notificationOptions.scrollerWrapper = 'bm-ntfs-vertical-container';

        ////////////

        function loadNotifications(whichPage){
          $scope.isLoading = true;

          return notificationsManager.getNotificationList(whichPage, itemsPerPage).then(function(data){
            if(angular.isDefined(data) && angular.isDefined(data.items) && data.items.length > 0){
                $scope.hasZeroItems = false;
                notificationMap = notificationMap || {};

                // sort the items to display by most current descending
                data.items.sort(sortByDatesDescending);

                var currentItem;
                var newItems = [];

                // weed out any dupes
                for(var counter = 0; counter < data.items.length; counter++){
                  currentItem = data.items[counter];

                  // already loaded this notification?
                  if(notificationMap[currentItem.id]){
                    continue;
                  }

                  notificationMap[currentItem.id] = currentItem.id;
                  newItems.push(currentItem);
                }

                if(newItems.length > 0){
                  $scope.notifications = $scope.notifications.concat(newItems);
                }

                // hedge our bets just in case more notifications are returned than the total
                // or there are a bunch of dupes
                if($scope.notifications.length >= data.totalItems || data.items.length < itemsPerPage){
                  notificationOptions.allLoaded = true;
                } else if(angular.isUndefined(notificationOptions.onScrollHandler)){
                  // setup scroll handler to fire paging/scrolling events
                  notificationOptions.onScrollHandler = scrollHandler;
                }

                $scope.isLoading = false;
              } else {
                $scope.hasZeroItems = $scope.notifications.length === 0;
                $scope.isLoading = false;
              }
          }, function(){
              $scope.hasZeroItems = $scope.notifications.length === 0;
              $scope.isLoading = false;
          });
        }

        function onScrollHandler(){
          if(!$scope.isLoading && !notificationOptions.allLoaded){
            // get the viewport position of the last element
            var elements = document.querySelectorAll('.bm-last-notification');
            var element = elements[0];
            var positionFromTop = getOffset(element).top;

            // get the viewport position of the wrapper
            var wrapperElement = document.getElementById(notificationOptions.scrollerWrapper);
            var wrapperOffsets = getOffset(wrapperElement);

            // TODO: COULD TRY TO CALCULATE A BETTER LOADING SCENARIO USING WRAPPER HEIGHT
            // var wrapperHeight = wrapperOffsets.bottom - wrapperOffsets.top;

            // near the bottom of the scroller area - within 300 pixels (approximately 5 items) of the bottom
            if(positionFromTop - wrapperOffsets.bottom < 300){
              // TODO: THIS IS GOING TO NEED TO BE MORE COMPLICATED LOGIC
              loadNotifications(Math.floor($scope.notifications.length / itemsPerPage) + 1);
            }
          }
        }

        function handleOpenedMenu(){
          // always reload notifications when menu is opened in order to sync across sessions
          loadNotifications(1);
        }

        function handleClosedMenu(){
          // reset the notification settings so everything is reloaded fresh
          // give the profile menu some time to close before reset
          $timeout(function(){
            $scope.notifications = [];
            $scope.hasZeroItems = true;
            notificationMap = {};

            // remove notifications and cleanup
            if(angular.isDefined(notificationOptions.cleanUpScroller)){
              notificationOptions.cleanUpScroller();
            }
          }, 200);
        }

        function markAllNotificationsRead(){
          notificationsManager.markAllNotificationsRead().then(function(){
            // loop through current infiniteItems and mark them all as read
            angular.forEach($scope.notifications, function(notification){
              notification.unread = false;

              // update count badges
              $scope.$emit('bmNotificationMarkedAsRead', { all: true });
            });
          });
        }

        function markNotificationRead(notification, event){
          var isBoundHtmlClick = angular.isDefined(event.target.href) && event.target.href !== '';

          // already read?
          if(!notification.unread){
            if(isBoundHtmlClick){
              $scope.$emit('bmNotificationHtmlClick');
            }

            return;
          }

          notificationsManager.markNotificationRead(notification).then(function(){
            notification.unread = false;

            if(isBoundHtmlClick){
              // close of menu will trigger unread count update
              $scope.$emit('bmNotificationHtmlClick');
            } else {
              // update count badges
              $scope.$emit('bmNotificationMarkedAsRead');
            }
          });
        }

        function deleteNotification(notification, index){
          notificationsManager.deleteNotification(notification).then(function(){
            $scope.notifications.splice(index, 1);
            delete notificationMap[notification.id];

            // update count badges if deleted item was unread
            if(notification.unread){
              $scope.$emit('bmNotificationMarkedAsRead');
            }

            if($scope.notifications.length === 0){
              $scope.hasZeroItems = true;
            }

            // force a load of notifications if list is getting small as scroll event won't fire
            if(!$scope.isLoading && !notificationOptions.allLoaded && $scope.notifications.length < 30){
              loadNotifications(1);
            }
          });
        }

        function getFormattedTime(time){
          if(!time){
            return '';
          }

          if($window.moment){
            var now = $window.moment.utc();
            var notificationTime = $window.moment.utc(time);

            // today
            if(now.diff(notificationTime, 'days') <= 0){
              return notificationTime.from(now);
            }

            // different year
            if(now.diff(notificationTime, 'years') > 0){
              return notificationTime.format('MMMM D, YYYY');
            }

            return notificationTime.format('MMMM D');
          }

          return (new Date(time)).toLocaleString();
        }

        function sortByDatesDescending(first, second){
          var firstDate = (new Date(first.timestamp)).getTime();
          var secondDate = (new Date(second.timestamp)).getTime();

          if(isNaN(firstDate) && isNaN(secondDate)){
            return 0;
          }

          if(isNaN(firstDate)){
            return 1;
          }

          if(isNaN(secondDate)){
            return -1;
          }

          return secondDate - firstDate;
        }
      }
    };
  }]);

  module.directive('bmNotificationsLastRepeatTask', [function(){
    return function(scope) {
      // only 1 item in the list?
      if(scope.$first && scope.$last){
        return;
      }

      // initialize scroll events once the last repeated element is in the dom
      if(scope.$last){
        if(angular.isUndefined(notificationOptions.scroller) && angular.isDefined(notificationOptions.onScrollHandler)){
          var throttledScroll = throttle(notificationOptions.onScrollHandler);

          // reference the wrapper element
          notificationOptions.scroller = w.document.getElementById(notificationOptions.scrollerWrapper);
          notificationOptions.scroller.onscroll = throttledScroll;
          notificationOptions.cleanUpScroller = function(){
            notificationOptions.scroller.onscroll = null;
            notificationOptions.scroller = undefined;
            notificationOptions.onScrollHandler = undefined;
            notificationOptions.allLoaded = false;
          };
        }
      }
    };
  }]);

  module.factory('bmClientNotificationsListManager', notificationsManager);
  notificationsManager.$inject = ['$http'];

  function notificationsManager($http){
    var api = '/api/notifications/v1/notifications';

    return {
        getNotificationList: getNotificationList,
        getUnreadNotificationCounts: getUnreadNotificationCounts,
        markNotificationRead: markNotificationRead,
        markAllNotificationsRead: markAllNotificationsRead,
        deleteNotification: deleteNotification
    };

    //////////////////

    function getNotificationList(pageNumber, itemsPerPage){
        if(angular.isUndefined(pageNumber)){
          pageNumber = notificationOptions.pageNumber;
        }

        if(angular.isUndefined(itemsPerPage)){
          itemsPerPage = notificationOptions.itemsPerPage;
        }

        var httpConfig = {
            method: 'GET',
            url: api + '?types=direct&itemsPerPage=' + itemsPerPage + '&pageNumber=' + pageNumber
        };

        return $http(httpConfig).then(function(response){
            return response.data;
        });
    }

    function getUnreadNotificationCounts(){
      // cache for 5 seconds
      return $http({
        method: 'GET',
        url: api + '/unread',
        bmCache: 5000
      }).then(function(response){
        return response.data;
      });
    }

    function markNotificationRead(notification){
      return $http({
        method: 'POST',
        url: api + '/read/' + notification.id
      });
    }

    function markAllNotificationsRead(){
      return $http({
        method: 'POST',
        url: api + '/read'
      });
    }

    function deleteNotification(notification){
      return $http({
        method: 'DELETE',
        url: api + '/' + notification.id
      });
    }
  }
})(window, window.angular);

(function(RegExp, angular){
  'use strict';

  // https://code.angularjs.org/1.5.11/docs/guide/forms - modifying built-in validators
  angular.module('bmValidateEmail', [])
  .directive('bmValidateEmail', function(){
    // taken from staff center contact setup validation
    var EMAIL_REGEXP = new RegExp('^((([a-z]|\\d|[!#\\$%&\'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+(\\.([a-z]|\\d|[!#\\$%&\'\\*\\+\\-' +
      '\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+)*)|((\\x22)((((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(([\\x01-\\x08\\x0b' +
      '\\x0c\\x0e-\\x1f\\x7f]|\\x21|[\\x23-\\x5b]|[\\x5d-\\x7e]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(\\\\([\\x01-\\x09\\x0b\\x0c\\x0d-\\x7f]|' +
      '[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]))))*(((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(\\x22)))@((([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-' +
      '\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-' +
      '\\uFFEF])*([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.)+(([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|' +
      '[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*([a-z]|[\\u00A0-\\uD7FF' +
      '\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.?$', 'i');

    return {
      require: 'ngModel',
      restrict: '',
      link: function(scope, elm, attrs, ctrl) {
        // only apply the validator if ngModel is present and Angular has added the email validator
        if (ctrl && ctrl.$validators.email){
          // this will overwrite the default Angular email validator
          ctrl.$validators.email = function(modelValue){
            return ctrl.$isEmpty(modelValue) || EMAIL_REGEXP.test(modelValue);
          };
        }
      }
    };
  });
})(window.RegExp, window.angular);

(function(angular){
  'use strict';

  angular.module('bmCheckpointCredentials', [
    'pascalprecht.translate',
    'bento.modern',
    'bmPermission'
  ])
  .constant('bmCheckpointRoutes', {
    checkpointSetCredsApi: '/api/workpapers/v1/CheckpointLogin',
    checkpointExistsApi: '/api/workpapers/v1/CheckpointLogin/exists',
    checkpointSessionApi: '/api/smart/integration/v1/sessions'
  })
  .service('bmCheckpointManager', bmCheckpointManager)
  .component('bmCheckpointCredentials', {
    bindings: {
      sharedData: '='
    },
    templateUrl: 'components/checkpoint-engage/checkpoint-engage.2js.html',
    controller: CheckpointCredentialsController,
  });

  // Component Implementation
  CheckpointCredentialsController.$inject = ['$scope', '$translate', 'bmPermission', 'bmCheckpointManager'];
  function CheckpointCredentialsController($scope, $translate, bmPermission, bmCheckpointManager){
    /*jshint validthis:true */
    var ctrl = this;
    var masterData = { uid: '', pwd: '', agree: false };
    var loadedCreds;

    ctrl.$onInit = init;

    /////////////////////////

    function init(){
      ctrl.hasPermission = false;
      ctrl.credsExist = false;
      ctrl.alerts = [];
      ctrl.userData = angular.copy(masterData);
      // ctrl.entitlementData = {};

      // 2-way bound data object to pass information between tabs
      ctrl.sharedLocal = ctrl.sharedData;
      ctrl.sharedLocal.hasUnsavedCheckpoint = false;

      // Create method publicly available through 2-way data bound object
      ctrl.sharedLocal.setCheckpointDirty = setCheckpointDirty;

      // supported actions
      ctrl.actions = {
        saveUserData: saveUserData,
        cancelUserData: cancelUserData,
        deleteUserData: deleteUserData
      };

      // load up checkpoint credentials
      bmPermission.has('Applications.CheckpointEngage').then(function(){
        bmCheckpointManager.getCheckpointCredentials().then(function(creds){
          if(angular.isDefined(creds) && creds.Exists){
            ctrl.credsExist = true;
            loadedCreds = creds;

            bmCheckpointManager.getCheckpointEntitlementDataForSession().then(function(entitlementData){
              $translate('bm.header.checkpoint.removeTextWithName', { 'n0': entitlementData.fullName }).then(function(value){
                ctrl.removeText = value;
              });
            }, function(){
              $translate('bm.header.checkpoint.removeText').then(function(value){
                ctrl.removeText = value;
              });
            });

          } else {
            ctrl.credsExist = false;
          }

          ctrl.hasPermission = true;
        }, function(){
          ctrl.hasPermission = false;
          $translate('bm.header.checkpoint.permissionDenied').then(function(value){
            addAlert(value, 'danger');
          });
        });
      }, function(){
        ctrl.hasPermission = false;
        $translate('bm.header.checkpoint.permissionDenied').then(function(value){
          addAlert(value, 'danger');
        });
      });
    }

    function saveUserData(){
      resetAlerts();

      // is the form valid?
      if(ctrl.checkpointForm.$invalid){
        setFormValidity();
        return;
      }

      // agreed to license?
      if(ctrl.userData.agree === false){
        $translate('bm.header.checkpoint.licenseRequired').then(function(msg){
          addAlert(msg, 'danger');
        });

        return;
      }

      // all good, let's save the credentials
      $scope.$emit('bm-busy-loading-on');
      bmCheckpointManager.saveCheckpointCredentials({
        'apiversion': 1,
        'data': {
          'kind': 'credentials',
          'accessKey': '',
          'userName': ctrl.userData.uid,
          'password': ctrl.userData.pwd
        }
      }).then(function(result){
        $scope.$emit('bm-busy-loading-off');
        // add name to results for remove text display
        result.name = ctrl.userData.uid;
        handleSaveSuccessDisplay(result);
      }, function(error){
        $scope.$emit('bm-busy-loading-off');
        handleSaveErrorDisplay(error);
      });
    }

    function cancelUserData(){
      if(ctrl.sharedLocal.resetOnCancel){
        // clear the user data and reset form
        resetAlerts();
        resetEntryForm(true);
      }

      $scope.$emit('bmProfileCancelAction');
    }

    function resetEntryForm(resetData){
      if(resetData){
        ctrl.userData = angular.copy(masterData);
      }

      ctrl.checkpointForm.$setPristine();
      ctrl.checkpointForm.uid.$setPristine();
      ctrl.checkpointForm.uid.$setValidity('required', true);
      ctrl.checkpointForm.pwd.$setPristine();
      ctrl.checkpointForm.pwd.$setValidity('required', true);
    }

    function deleteUserData(){
      resetAlerts();

      // make sure the creds are loaded
      if(angular.isUndefined(loadedCreds)){
        handleDeleteErrorDisplay();
        return;
      }

      $scope.$emit('bm-busy-loading-on');
      bmCheckpointManager.deleteCheckpointCredentials(loadedCreds.UserDataId).then(function(){
        $scope.$emit('bm-busy-loading-off');
        handleDeleteSuccessDisplay();
      }, function(reject){
        $scope.$emit('bm-busy-loading-off');

        var error = { message: 'error' };

        // get the actual error data
        if(angular.isDefined(reject) && angular.isDefined(reject.data)){
          error = reject.data.error;

          if(angular.isUndefined(error.message) || error.message === ''){
            error.message = 'error';
          }
        }

        handleDeleteErrorDisplay(error);
      });
    }

    function setFormValidity(){
      $translate('BM.Components.IncompleteForm').then(function(msg){
        addAlert(msg, 'danger');
      });

      // toggle all validation messages
      if(ctrl.checkpointForm.uid.$error.required){
        ctrl.checkpointForm.uid.$setDirty();
        ctrl.checkpointForm.uid.$setTouched();
      }

      if(ctrl.checkpointForm.pwd.$error.required){
        ctrl.checkpointForm.pwd.$setDirty();
        ctrl.checkpointForm.pwd.$setTouched();
      }
    }

    function handleSaveSuccessDisplay(data){
      // wipe form entry
      resetEntryForm(true);

      if(angular.isUndefined(data)){
        handleSaveErrorDisplay(data);
        return;
      }

      if(data.message === 'success'){
        $translate('bm.header.checkpoint.saveSuccessful').then(function(value){
          addAlert(value, 'success');
        });
      } else {
        addAlert(data.message, 'success');
      }

      // setup as creds already entered
      $translate('bm.header.checkpoint.removeText', { 'n0': data.name }).then(function(value){
        ctrl.removeText = value;
      });

      ctrl.credsExist = true;
      loadedCreds = {
        Exists: true,
        UserDataId: data.Id
      };

      ctrl.sharedLocal.hasUnsavedCheckpoint = false;
    }

    function handleSaveErrorDisplay(data){
      // generic error message
      if(angular.isUndefined(data) || data.message === 'error'){
        $translate('bm.header.checkpoint.saveError').then(function(value){
          addAlert(value, 'danger');
        });

        return;
      }

      addAlert(data.message, 'danger');
    }

    function handleDeleteSuccessDisplay(){
      ctrl.credsExist = false;
      loadedCreds = null;

      $translate('bm.header.checkpoint.deleteSuccessful').then(function(value){
        addAlert(value, 'success');
      });
    }

    function handleDeleteErrorDisplay(data){
      if(angular.isUndefined(data) || data.message === 'error'){
       $translate('bm.header.checkpoint.deleteError').then(function(value){
          addAlert(value, 'danger');
        });

        return;
      }

      addAlert(data.message, 'danger');
    }

    function setCheckpointDirty(){
      var isClean = angular.equals(masterData, ctrl.userData);
      resetAlerts();

      // only reset the form if its visible
      if(ctrl.hasPermission && !ctrl.credsExist){
        resetEntryForm(false);
      }

      ctrl.sharedLocal.hasUnsavedCheckpoint = !isClean;
    }

    function addAlert(message, type){
      resetAlerts();
      ctrl.alerts.push({ msg: message, type: type, closeable: true, timeout: 2500 });
    }

    function resetAlerts(){
      ctrl.alerts.length = 0;
    }
  }

  // Service Implementation
  bmCheckpointManager.$inject = ['$q', '$http', 'bmCheckpointRoutes'];
  function bmCheckpointManager($q, $http, apiRoutes){
    /*jshint validthis:true */
    var self = this;

    self.getCheckpointCredentials = getCheckpointCredentials;
    self.saveCheckpointCredentials = saveCheckpointCredentials;
    self.deleteCheckpointCredentials = deleteCheckpointCredentials;
    self.getCheckpointEntitlementDataForSession = getCheckpointEntitlementDataForSession;

    ////////////////////////////

    function getCheckpointCredentials() {
      return $http({
        method: 'GET',
        url: apiRoutes.checkpointExistsApi,
        global: false
      }).then(function(resp){
        // return the actual crendential data
        return angular.isDefined(resp) && angular.isDefined(resp.data)? resp.data.data : resp;
      });
    }

    function saveCheckpointCredentials(creds){
      var deferred = $q.defer();

      if(angular.isUndefined(creds)){
        deferred.reject('NOCREDS');
        return deferred.promise;
      }

      $http({
        method: 'POST',
        url: apiRoutes.checkpointSetCredsApi,
        headers: {'Content-Type': 'application/json'},
        data: creds,
        global: false
      }).then(function(resp){
        // return the actual crendential data
        if(angular.isDefined(resp) && angular.isDefined(resp.data)){
          var data = resp.data.data || {};

          if(angular.isUndefined(data.message) || data.message === ''){
            data.message = 'success';
          }

          deferred.resolve(data);
        }

        // handle as generic success
        deferred.resolve();
      }, function(reject){
        // return the actual error data
        if(angular.isDefined(reject) && angular.isDefined(reject.data)){
          var error = reject.data.error || {};

          if(angular.isUndefined(error.message) || error.message === ''){
            error.message = 'error';
          }

          deferred.reject(error);
        }

        // handle as generic error
        deferred.reject();
      });

      return deferred.promise;
    }

    function deleteCheckpointCredentials(userDataId){
      var deferred = $q.defer();

      if(angular.isUndefined(userDataId)){
        deferred.reject('NOUSERDATAID');
        return deferred.promise;
      }

      return $http({
        method: 'DELETE',
        url: apiRoutes.checkpointSetCredsApi + '/' + userDataId,
        global: false
      });
    }

    function getCheckpointEntitlementDataForSession(){
      return $http({
        method: 'GET',
        url: apiRoutes.checkpointSessionApi,
        global: false
      }).then(function(resp){
        // return the actual crendential data
        return angular.isDefined(resp) && angular.isDefined(resp.data)? resp.data.data : resp;
      });
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmPreferenceService', [
    'bmEnvironment',
    'bluemoon.components.util'
  ])
  .service('bmPreferenceService', PreferenceService);

  PreferenceService.$inject = ['$window', '$q', '$http', 'bmEnvironment', 'bmUtil'];
  function PreferenceService($window, $q, $http, environment, bmUtil){
    /*jshint validthis:true */
    var self = this;

    self.getPreferences = getPreferences;
    self.getPreference = getPreference;
    self.addPreference = addPreference;
    self.removePreference = removePreference;

    ////////////////////////////

    // use the profile api returned from environments
    function getUserPreferenceApi(){
      return $q.when('/api/profiles/v1/preferences');
    }

    function getCompanyPreferenceApi(companyId){
      return $q.when('/api/profiles/v1/companies/' + companyId + '/preferences');
    }

    function getPreferences(companyId) {
      if(bmUtil.isNullOrEmpty(companyId)){
        return getUserPreferences();
      } else {
        return getCompanyPreferences(companyId);
      }
    }

    function getCompanyPreferences(companyId) {
      return getCompanyPreferenceApi(companyId).then(function(api){
        return $http.get(api).then(function(preferences){
          return preferences;
        });
      });
    }

    function getPreference(companyId, application, category) {
      if(bmUtil.isNullOrEmpty(companyId)){
        return getUserPreference(application, category);
      } else {
        return getCompanyPreference(companyId, application, category);
      }
    }

    function addPreference(companyId, preference) {
      if(bmUtil.isNullOrEmpty(companyId)){
        return addUserPreference(preference);
      } else {
        return addCompanyPreference(companyId, preference);
      }
    }

    function getCompanyPreference(companyId, application, category) {
      return getCompanyPreferenceApi(companyId).then(function(api){
        return $http({
          method: 'GET',
          url: api,
          params: {application: application, category: category}
        });
      });
    }

    function getUserPreference(application, category){
      return getUserPreferenceApi().then(function(api){
        return $http({
          method: 'GET',
          url: api,
          params: {application: application || '', category: category || ''}
        });
      });
    }

    function addCompanyPreference(companyId, preference) {
      return getCompanyPreference(companyId, preference.application, preference.category).then(function(response){
        var preferences = response.data;
        if(bmUtil.isNullOrEmpty(preferences) || preferences.length === 0){
          return createPreference(companyId, preference);
        } else {
          var preferenceId = preferences[0].id;
          return updatePreference(companyId, preference, preferenceId);
        }
      });
    }

    function createPreference(companyId, preference){
      return getCompanyPreferenceApi(companyId).then(function(api){
        return $http({
          method: 'POST',
          url: api,
          data: preference
        });
      });
    }

    function updatePreference(companyId, preference, preferenceId){
      return getCompanyPreferenceApi(companyId).then(function(api){
        return $http({
          method: 'PUT',
          url: api + '/' + preferenceId,
          data: preference
        });
      });
    }

    function removePreference() {
      // TODO
    }
    function getUserPreferences() {
      // TODO
    }
    function addUserPreference() {
      // TODO
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmMultifactorService', [
    'bmEnvironment',
    'bmAccess',
    'bmPreferenceService',
    'bluemoon.components.session',
    'bluemoon.components.util'
  ])
  .service('bmMultifactorService', MultifactorService);

  MultifactorService.$inject = ['$window', '$q', '$http', 'bmEnvironment', 'AuthenticatedSession', 'bmAccess', 'bmPreferenceService', 'bmUtil', 'languageStorageManager'];
  function MultifactorService($window, $q, $http, environment, session, bmAccess, preferenceService, bmUtil, langMgr){
    /*jshint validthis:true */
    var self = this;
    var authApi;
    var mfaApi;
    var productOptions;

    // TODO: COULD SET THIS AS A CONSTANT
    var products = {
      onvio: {
        sp: 'onvio',
        type: 'ONVIO'
      },
      auth: {
        sp: 'csweb',
        type: 'CSWEB'
      }
    };

    self.getFactors = getFactors;
    self.deleteFactors = deleteFactors;
    self.deleteFactor = deleteFactor;
    self.initFactorSetup = initFactorSetup;
    self.verifyLoginData = verifyLoginData;
    self.getAllFactors = getAllFactors;
    self.enableMultifactorAuthCode = enableMultifactorAuthCode;
    self.registerMultifactorAuthCode = registerMultifactorAuthCode;
    self.getUserJwtToken = getUserJwtToken;

    self.staffRequired = staffRequired;
    self.clientsRequired = clientsRequired;
    self.userRequired = userRequired;
    self.setStaffRequired = setStaffRequired;
    self.setClientsRequired = setClientsRequired;
    self.getMfaStaffPreference = getMfaStaffPreference;
    self.getMfaClientPreference = getMfaClientPreference;

    ////////////////////////////

    function getMfaProductOptions(){
      if(productOptions){
        return $q.when(productOptions);
      }

      return environment.getPrimaryProduct().then(function(productName){
        // default to onvio options
        productOptions = products[productName] ? products[productName] : products.onvio;
        return productOptions;
      });
    }

    // use the auth api returned from environments
    // ex. AuthenticationAggregatorServices: "https://demo.onvio.us/api/auth"
    function getAuthApiRoute(){
      if(authApi){
        return $q.when(authApi);
      }

      // make this work for local development
      if($window.location.host === 'localhost:9000'){
        authApi = 'https://localhost:9000';
        return $q.when(authApi);
      }

      return environment.getRoute('AuthenticationAggregatorServices').then(function(api){
        // make sure to use the protocol used by the browser host and not the route host
        var routeUri = bmUtil.parseUri(api);
        var hostUri = bmUtil.parseUri($window.location);
        authApi = hostUri.protocol + '//' + routeUri.host;
        return authApi;
      });
    }

    // use the mfa api returned from environments
    function getMfaApi(){
      if(mfaApi){
        return $q.when(mfaApi);
      }

      return getAuthApiRoute().then(function(api){
        mfaApi = api + '/api/mfa';
        return mfaApi;
      });
    }

    function getJwtToken(){
      // TODO: AT SOMEPOINT WE MAY NEED TO EXPLICITY FIND IT BASED ON PRODUCT TYPE
      // TO AVOID CLASHING CACHE OR EXPIRED TOKENS
      // onvio uses session storage
      var token = $window.sessionStorage.getItem('tr-auth-token');

      // csweb uses local storage
      if(bmUtil.isNullOrEmpty(token)){
        token = $window.localStorage.getItem('tr-auth-token');
      }

      return token;
    }

    function getBaseFactorsConfig(jwtToken){
      var jwt = jwtToken ? jwtToken : getJwtToken();

      if(jwt === null || angular.isUndefined(jwt) || jwt === ''){
        return null;
      }

      return {
        method: 'GET',
        bmNoAuth: true,
        bmAuthRedirect: false,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + jwt
        }
      };
    }

    function getFactors(allTypes){
      var config = getBaseFactorsConfig();

      if(config === null){
        // send back an empty array if jwt not found
        return $q.when([]);
      }

      // must have IAC in order to actually make request for factors
      // TODO: AT SOME POINT THIS IAC CHECK WILL NEED TO GO AWAY
      return bmAccess.has('Platform_Enable2FA').then(function(){
        return getMfaApi().then(function(api){
          config.url = api + '/v1/factors';
          // don't set errors as global
          config.global = false;

          return $http(config).then(function(resp){
            // really only want factors that are registered and devices
            var factors = [];

            // filter out any 24-hour codes
            if(angular.isArray(resp.data) && resp.data.length > 0){
              factors = resp.data.filter(function(factor){
                return allTypes ? true : angular.isString(factor.type) && factor.type.toUpperCase() !== 'B';
              });
            }

            return factors;
          }, function(){
            // TODO: MAY NEED TO HANDLE THIS DIFFERENTLY
            // send back an empty array if data failed to load
            return [];
          });
        });
      }).catch(function(){
        return [];
      });
    }

    function deleteFactors(factors, jwtToken){
      var deferred = $q.defer();
      if(!angular.isArray(factors) || factors.length === 0){
        deferred.reject('NOFACTORS');
        return deferred.promise;
      }

      var config = jwtToken ? getBaseFactorsConfig(jwtToken) : getBaseFactorsConfig();

      if(config === null){
        deferred.reject();
        return deferred.promise;
      }

      config.method = 'DELETE';

      return getMfaApi().then(function(api){
        config.url = api + '/v1/factors/';

        // don't set errors as global
        config.global = false;

        // need to send a delete for each factor
        var promises = [];

        angular.forEach(factors, function(factor){
          var factorConfig = angular.copy(config);
          factorConfig.url = factorConfig.url + factor.id;
          promises.push($http(factorConfig));
        });

        return $q.all(promises);
      });
    }
    function deleteFactor(factor){

      var config = getBaseFactorsConfig();

      if(config === null){
        $q.reject();
      }

      config.method = 'DELETE';

      return getMfaApi().then(function(api){
        config.url = api + '/v1/factors/';

        // don't set errors as global
        config.global = false;

        var factorConfig = angular.copy(config);
        factorConfig.url = factorConfig.url + factor.id;
        return $http(factorConfig);
      });
    }

    function enableMFACards() {
        return bmAccess.has('Platform_EnableMFACards').then(function() {
            return $q.resolve(true);
        }, function() {
            return $q.resolve(false);
        });
    }

    function initFactorSetup(email, showEmergencyCodesForm){
      var currentLang;

      return enableMFACards().then(function(enableMFACards) {
        return getAuthApiRoute().then(function(api){
          return getMfaProductOptions().then(function(options){
            currentLang = langMgr.get();
            var initSettings = {
              // targetElem: <targetContainer>,
              type: options.type,
              sp: options.sp,
              locale: currentLang,
              enableMFACards: enableMFACards,
              templateData: {
                authSvcHost: api,
                uid: email
              },
              headers: {
                authorization: 'Bearer ' + getJwtToken()
              }
            };
            if (showEmergencyCodesForm) {
              initSettings.startingForm = 'trta1-mfs-emergencycodes';
            }
            return $window.trAuth.modules.mfs.init(initSettings);
          });
        });
      });
    }

    function verifyLoginData(data){
      if(angular.isUndefined(data) || bmUtil.isNullOrEmpty(data.uid) || bmUtil.isNullOrEmpty(data.pwd)){
        var deferred = $q.defer();
        deferred.reject();
        return deferred.promise;
      }

      // TODO: RIGHT NOW THIS PASSWORD CHECK IS SET TO TRID INSTEAD OF PRODUCT OPTIONS
      // set the type just to be safe
      if(angular.isUndefined(data.type) || bmUtil.isNullOrEmpty(data.type)){
        data.type = 'TRID';
      }

      return getAuthApiRoute().then(function(api){
        return $http({
          method: 'POST',
          url: api + '/api/auth/v1/login/authentication',
          data: data,
          global: false
        });
      });
    }

    function staffRequired(companyId){
      if(angular.isUndefined(companyId)) {
        return $q.reject();
      }

      return getMfaStaffPreference(companyId).then(function(response){
          if(angular.isArray(response.data) && response.data.length > 0) {
            // there should only be one mfa-staff preference
            var preference = response.data[0];
            return preference.value && preference.value.required || false;
          }
          return false;
      });
    }

    function setStaffRequired(companyId, staffRequired) {
      if(angular.isUndefined(companyId) || angular.isUndefined(staffRequired)) {
        return $q.reject();
      }

      return setMfaStaffPreference(companyId, staffRequired);
    }

    function clientsRequired(companyId){
      if(angular.isUndefined(companyId)) {
        return $q.reject();
      }
      return getMfaClientPreference(companyId).then(function(response){
        if(angular.isArray(response.data) && response.data.length > 0) {
          // there should only be one mfa-client preference
          var preference = response.data[0];
          return preference.value && preference.value.required || false;
        }
        return false;
      });
    }

    function setClientsRequired(companyId, clientsRequired){
      if(angular.isUndefined(companyId) || angular.isUndefined(clientsRequired)) {
        $q.reject();
      }

      return setMfaClientPreference(companyId, clientsRequired);
    }

    function getMfaStaffPreference(companyId){
      var application = 'onvio';
      var category = 'mfa-staff';
      return preferenceService.getPreference(companyId, application, category);
    }

    function setMfaStaffPreference(companyId, staffRequired){
      var preference = {
        application: 'onvio',
        category: 'mfa-staff',
        value: { required: staffRequired }
      };
      return preferenceService.addPreference(companyId, preference);
    }

    function setMfaClientPreference(companyId, clientsRequired){
      var preference = {
        application: 'onvio',
        category: 'mfa-client',
        value: { required: clientsRequired }
      };
      return preferenceService.addPreference(companyId, preference);
    }

    function getMfaClientPreference(companyId){
      var application = 'onvio';
      var category = 'mfa-client';
      return preferenceService.getPreference(companyId, application, category);
    }

    function userRequired(){
      // TODO: DOES THIS APPLY TO CSWEB???
      var companyId = session.data.bindings.ApplicationConfiguration.CompanyId;
      var grants = session.data.bindings.Grants;
      var isStaff = grants.indexOf('staff') > -1;
      var isClient = grants.indexOf('client') > -1;
      var promises = [
        staffRequired(companyId),
        clientsRequired(companyId)
      ];

      return $q.all(promises).then(function(results){
        var staffIsRequired = results[0];
        var clientIsRequired = results[1];

        return (isClient && clientIsRequired) || (isStaff && staffIsRequired);
      }, function(){
        return false;
      });
    }

    function getAllFactors(jwtToken) {
      if(jwtToken === null || angular.isUndefined(jwtToken) || jwtToken === ''){
        // send back an empty array if jwt not found
        return $q.when([]);
      }

      var config = {
        method: 'GET',
        bmNoAuth: true,
        bmAuthRedirect: false,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + jwtToken
        }
      };

      return getMfaApi().then(function(api) {
        api = api + '/v1/factors';
        config.url = api;

        var factors = [];
        return $http(config).then(function(resp){
          if(angular.isArray(resp.data) && resp.data.length > 0){
            factors = resp.data;
          }
          factors = sortAuthCodeList(factors);
          return factors;
        });
      }).catch(function(){
        return [];
      });
    }

    function getUserJwtToken(contactId) {
      if(angular.isUndefined(contactId)){
        var deferred = $q.defer();
        deferred.reject({ data: 'Invalid contact - unable to get jwt token' });
        return deferred.promise;
      }

      var securityApi = '/api/security/v1/jwt/contacts/';
      var url = securityApi + contactId;
      var options = {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      };

      return $http.post(url, options);
    }

    function enableMultifactorAuthCode(jwtToken) {
      var data = {'type': 'B', 'address': '24-hour code'};
      var options = {
        headers: {'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + jwtToken,
            'Cache-Control': 'no-cache'
        },
        bmNoAuth: true,
        bmAuthRedirect: false,
      };

      return getMfaApi().then(function(api) {
        var url = api + '/v1/factors';
        return $http.post(url, data, options);
      }).catch(function(resp){
        return resp;
      });
    }

    function registerMultifactorAuthCode(jwtToken, inputData) {
      var factor = {
        'name' : '24-hour code',
        'address' : 'Support'
      };
      var data = {
        'mfarId' : inputData.mfarId,
        'factor' : factor
      };
      var options = {
        headers : {
          'Content-Type' : 'application/json',
          'Accept' : 'application/json',
          'Authorization' : 'Bearer' + ' ' + jwtToken,
          'Cache-Control' : 'no-cache'
        },
        bmNoAuth: true,
        bmAuthRedirect: false,
        timeout : 60000000
      };

      return getMfaApi().then(function(api) {
        var url = api + '/v1/factors/' + inputData.factorId + '/register';
        return $http.post(url, data, options);
      }).catch(function(resp){
        return resp;
      });
    }

    function sortAuthCodeList(authCodeList) {
      authCodeList.sort(function(a,b) {
        a = new Date(a.registered);
        b = new Date(b.registered);
        return b - a;
      });

      return authCodeList;
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmMultifactorProfile', [
    'ui.bootstrap',
    'pascalprecht.translate',
    'bento.modern',
    'bluemoon.components.util',
    'bmMultifactorService',
  ])
  .component('bmMultifactorProfile', {
    bindings: {
      userData: '<'
    },
    templateUrl: 'components/multi-factor/multi-factor-profile.2js.html',
    controller: MultifactorProfileController,
  });

  MultifactorProfileController.$inject = ['$window', '$rootScope', '$scope', '$timeout', '$translate', '$uibModal', 'bmMultifactorService', 'languageStorageManager'];
  function MultifactorProfileController($window, $rootScope, $scope, $timeout, $translate, $uibModal, mfaService, languageStorageManager){
    /*jshint validthis:true */
    var ctrl = this;
    var andText = 'and';
    var prefLang = languageStorageManager.get() || 'en-US';

    ctrl.$onInit = init;
    ctrl.helpLangCode = prefLang.toLowerCase().split('-').reverse().join('-');

    ////////////////////////////

    function init(){
      ctrl.user = ctrl.userData;
      ctrl.factors = [];
      ctrl.pairedDeviceText = '';
      ctrl.actions = {
        openConfirmModal: openConfirmModal,
        cancelProfile: cancelProfile
      };

      mfaService.userRequired().then(function(required){
        ctrl.required = required;
      });

      $timeout(function() {
        // localize now (well..next cycle, to get around refresh bug)
        localize();

        // localize on lang change (next cycle to debounce)
        $rootScope.$on('bmLanguageChangeSuccess', localize);
      }, 0);
    }

    function localize(){
      // set factors after text is translated
      $translate('bm.header.viewProfile.And').then(function(value){
        andText = value;
      }).finally(function(){
        setFactors();
      });
    }

    function setFactors(){
      // reset current list of factors
      ctrl.factors = [];

      mfaService.getFactors(true).then(function(factors){
        ctrl.factors = factors;
        setMultiComplete();
      });
    }

    function setMultiComplete(){
      ctrl.devices = ctrl.factors.filter(function(factor) {
        return angular.isString(factor.type) && factor.type.toUpperCase() !== 'B' && factor.type.toUpperCase() !== 'C';
      });
      ctrl.mutliFactorComplete = angular.isArray(ctrl.factors) && ctrl.factors.length > 0;
      // set paired device text
      if(ctrl.mutliFactorComplete){
        if(ctrl.factors.length === 1){
          ctrl.pairedDeviceText = '"' + ctrl.factors[0].name + '."';
        } else if(ctrl.factors.length === 2){
          ctrl.pairedDeviceText = '"' + ctrl.factors[0].name + '" ' + andText + ' "' + ctrl.factors[1].name + '."';
        } else {
          var isLast = false;

          for(var index = 0; index < ctrl.factors.length; index++){
            isLast = index === ctrl.factors.length - 1;

            if(index !== 0){
              ctrl.pairedDeviceText+= ', ';
            }

            ctrl.pairedDeviceText+= (isLast ? andText + ' ' : '') + '"' + ctrl.factors[index].name + (isLast ? '."' : '"');
          }
        }
      }
    }

    function cancelProfile(){
      $scope.$emit('bmProfileCancelAction');
    }

    function openConfirmModal(action, factor){
      var modalInstance = $uibModal.open({
        templateUrl: 'components/multi-factor/multi-factor-profile-modal.2js.html',
        controller: 'bmMfaConfirmDeviceCtrl as vm',
        backdrop: 'static',
        resolve: {
          action: function(){
            return action;
          },
          factor: function(){
            return factor;
          },
          // TODO: DO WE NEED THIS USER?
          user: function(){
            return ctrl.user;
          }
        }
      });

      modalInstance.result.then(function(isConfirmed){
        if(isConfirmed){
          if(action === 'add'){
            startMultiSetup(action);
          } else if(action === 'remove') {
            deleteFactor(factor);
          } else if (action === 'generate') {
            generateEmergencyCodes();
          }
        }
      });
    }
    function generateEmergencyCodes() {
      mfaService.initFactorSetup(ctrl.user.email, true);
    }
    function removeMulti(){
      $rootScope.$emit('bm-busy-loading-on');
      mfaService.getFactors(true).then(function(factors){
        ctrl.factors = factors;
        mfaService.deleteFactors(ctrl.factors).then(function(){
          setFactors();
          $rootScope.$emit('bm-busy-loading-off');
        }, function(){
          $rootScope.$emit('bm-busy-loading-off');
        });
      }, function(){
        $rootScope.$emit('bm-busy-loading-off');
      });
    }
    function deleteFactor(factor){
      // If removing last device, remove mfa
      if(ctrl.devices.length === 1) {
        removeMulti();
      } else {
        $rootScope.$emit('bm-busy-loading-on');
        mfaService.deleteFactor(factor).then(function(){
          setFactors();
          $rootScope.$emit('bm-busy-loading-off');
        }, function(){
          $rootScope.$emit('bm-busy-loading-off');
        });
      }
    }

    function startMultiSetup(action) {
      // make sure to use the local copy of email as it can be updated on account tab
      mfaService.initFactorSetup(ctrl.user.email).then(function(mfaDialog) {
        mfaDialog.addEventListener('tr-mfs-success', function() {
          // done in $timeout in order for scope to update
          $timeout(function() {
            // remove existing factors first just to keep the added factor in the list
            // at this time only allowing 1 device to be setup
            // don't want to remove existing devices until new device is setup through auth component
            if (action === 'remove') {
              removeMulti();
            } else {
              setFactors();
            }
          }, 0);
        });
      });
    }
  }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmMultifactorProfile').controller('bmMfaConfirmDeviceCtrl', confirmModalCtrl);

  confirmModalCtrl.$inject = ['$rootScope', '$uibModalInstance', 'bmMultifactorService', '$translate', 'bmUtil', 'action', 'user'];
  function confirmModalCtrl($rootScope, $uibModalInstance, mfaService, $translate, bmUtil, action, user){
    /*jshint validthis:true */
    var vm = this;
    vm.confirmDevice = confirmDevice;
    vm.cancelDevice = cancelDevice;
    vm.modalAction = bmUtil.isNullOrEmpty(action) ? 'add' : action;
    vm.user = { password: ''};

    ///////////

    function confirmDevice(){
      if(vm.confirmDeviceForm.$invalid || vm.confirmDeviceForm.userPassword.$invalid){
        return;
      }

      // TODO: RIGHT NOW THIS PASSWORD CHECK IS SET TO TRID INSTEAD OF PRODUCT OPTIONS
      var userData = { uid: user.email, pwd: vm.user.password, type: 'TRID' };

      mfaService.verifyLoginData(userData).then(function(){
        closeModal(true);
      }, function(){
        $translate('bm.header.viewProfile.mfaConfirmError').then(function(text){
          // TODO: IF THIS GOES TO A COMPONENT CHANGE TO NOT USE bmErrors
          if (!$rootScope.bmErrors){
            $rootScope.bmErrors = [];
          }

          $rootScope.bmErrors.push({type: 'danger', msg: text, timeout: 2500, closeable: true});
        });
      });
    }

    function cancelDevice(){
      closeModal(false);
    }

    function closeModal(isConfirmed){
      $uibModalInstance.close(isConfirmed);
    }
  }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmMultifactorUser', ['bento.modern']);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bmMultifactorUser').controller('MultifactorUserCtrl', MultifactorUserCtrl);
	MultifactorUserCtrl.$inject = ['$uibModal', 'bmAccess'];

	function MultifactorUserCtrl($uibModal, bmAccess){
        /*jshint validthis:true */
		var vm = this;

		// scope variables
		vm.isMfaAvailable = false;
		vm.contact = {};

		// scope functions
		vm.openMfaSettingsModal = openMfaSettingsModal;

		localStorage.setItem('Platform_Enable2FA', true);

		this.$onChanges = function(changes) {
			if (changes.contact.currentValue && changes.contact.currentValue.id) {
				initialize();
			}
		};

		function openMfaSettingsModal() {
			$uibModal.open({
				templateUrl: 'components/multi-factor-user/multi-factor-user-settings.2js.html',
				controller: 'MultifactorUserSettingsCtrl',
				controllerAs: 'vm',
				backdrop: 'static',
				size: 'md',
				resolve: {
					contactInfo: function(){
						return {
							id: vm.contact.id
						};
					}
				}
			});
		}

		function initialize() {
			// must have IAC in order to actually make request for factors
			// TODO: AT SOME POINT THIS IAC CHECK WILL NEED TO GO AWAY
			bmAccess.has('Platform_Enable2FA').then(function(){
				if(vm.contact.userId) {
					//multifactorUserService.contact = vm.contact;

					// TODO: will need to lookup the companies mfa settings here
					vm.isMfaAvailable = true;
				}
			});
		}
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmMultifactorUser')
        .component('bmMultifactorUser', {
            templateUrl: 'components/multi-factor-user/multi-factor-user.2js.html',
            bindings: {
                contact: '<'
            },
            controller: 'MultifactorUserCtrl',
            controllerAs: 'vm'
        });
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bmMultifactorUser').controller('MultifactorUserSettingsCtrl', multifactorUserSettingsCtrl);
    multifactorUserSettingsCtrl.$inject = ['$window', '$scope', '$uibModalInstance', 'bmMultifactorService', 'contactInfo'];

    function multifactorUserSettingsCtrl($window, $scope, $uibModalInstance, bmMultifactorService, contactInfo) {
        /*jshint validthis:true */
        var vm = this;
        vm.userDevice = 'Some Device';
        vm.authCode = '';
        vm.registeredFactors = [];
        vm.busyLoading = true;
        vm.contactInfo = contactInfo;

        var jwt = '';
        var registeredAuthCodes = [];
        var temporaryAuthCode = '';

        // functiion
        vm.close = closeModal;
        vm.generateAccessCode = generateAccessCode;

        // setup
        init();

        function init() {
            getJwtToken();
        }

        function closeModal() {
            $uibModalInstance.close();
        }

        function generateAccessCode() {
            if(registeredAuthCodes.length > 0) {
                removeAuthFactorAndRegenerate();
            } else {
                createAuthFactorAndRegister();
            }
        }

        function getJwtToken() {
            $scope.$emit('bm-busy-loading-on');
            bmMultifactorService.getUserJwtToken(contactInfo.id).then(function(resp){
                jwt = resp.data.token;
                getFactors();
            }, function(data) {
                vm.busyLoading = false;
                $scope.$emit('bm-busy-loading-off');
                console.log(data);
            });
        }

        function getFactors() {
            bmMultifactorService.getAllFactors(jwt).then(function(data){
                if(angular.isArray(data) && data.length > 0){
                    vm.registeredFactors = data.filter(function(factor){
                        return angular.isString(factor.type) && factor.type.toUpperCase() !== 'B' && factor.type.toUpperCase() !== 'C';
                    });

                    registeredAuthCodes = data.filter(function(factor){
                        return angular.isString(factor.type) && factor.type.toUpperCase() === 'B';
                    });

                    if(angular.isArray(vm.registeredFactors) && vm.registeredFactors.length > 0){
                        var registeredDevice;
                        var registeredDeviceList;
                        for(var pos = 0; pos < vm.registeredFactors.length; pos++) {
                            registeredDevice = vm.registeredFactors[pos];
                            if(pos === 0) {
                                registeredDeviceList = registeredDevice.name;
                            } else {
                                registeredDeviceList = registeredDeviceList + ', ' + registeredDevice.name;
                            }
                        }
                        vm.userDevice = registeredDeviceList;
                    }
                }
                vm.busyLoading = false;
                $scope.$emit('bm-busy-loading-off');
            }, function(data) {
                vm.busyLoading = false;
                $scope.$emit('bm-busy-loading-off');
                console.log(data);
            });
        }

        function removeAuthFactorAndRegenerate() {
            $scope.$emit('bm-busy-loading-on');
            bmMultifactorService.deleteFactors(registeredAuthCodes, jwt).then(function(){
                registeredAuthCodes = [];
                createAuthFactorAndRegister();
            }, function() {
                $scope.$emit('bm-busy-loading-off');
            });
        }

        function createAuthFactorAndRegister() {
            $scope.$emit('bm-busy-loading-on');
            bmMultifactorService.enableMultifactorAuthCode(jwt).then(function(response){
                var authFactor = response.data;
                var otpSecret = authFactor.otpSecret;
                temporaryAuthCode = otpSecret.substring(0, 4) + ' ' + otpSecret.substring(4);
                registerMultifactorAuthCode(authFactor);
            }, function() {
                $scope.$emit('bm-busy-loading-off');
            });
        }

        function registerMultifactorAuthCode(authFactor) {
            bmMultifactorService.registerMultifactorAuthCode(jwt, authFactor).then(function(response){
                var data = response.data;
                data.id = authFactor.factorId;
                registeredAuthCodes = [];
                registeredAuthCodes.push(data);
                vm.authCode = temporaryAuthCode;
                $scope.$emit('bm-busy-loading-off');
            }, function() {
                $scope.$emit('bm-busy-loading-off');
                //window.alert('Error in registerMultifactorAuthCode');
            });
        }
    }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('bmPrivacyPolicy', [
    'pascalprecht.translate',
    'bluemoon.components.i18n'])
  .value('bmPrivacyPolicyUriMap', {
    'en-US': 'https://www.thomsonreuters.com/en/privacy-statement.html',
    'fr-CA': 'https://www.thomsonreuters.com/fr-ca/privacy-statement.html',
    'nl-NL': 'https://www.thomsonreuters.com/nl/privacy.html',
    'es-AR': 'https://www.thomsonreuters.com/es/declaracion-de-privacidad.html',
    'pt-BR': 'https://www.thomsonreuters.com/pt/declaracao-de-privacidade.html'
  })
  .component('bmPrivacyPolicyLink', {
    templateUrl: 'components/privacy-policy/privacy-policy.2js.html',
    controller: privacyPolicyLink,
  })
  .service('bmPrivacyPolicyService', privacyPolicyService);

  ////////////

  // Component implementation
  privacyPolicyLink.$inject = ['$scope', 'bmPrivacyPolicyService', 'bmPrivacyPolicyUriMap'];
  function privacyPolicyLink($scope, privacyService, privacyUriMap){
    /*jshint validthis:true */
    var ctrl = this;

    ctrl.$onInit = init;

    //////////////////////////////

    function init(){
      // load up initial version of privacy policy
      setPrivacyUri();

      // add language change event watch to change text when lanuage changes
      $scope.$on('bmLanguageChangeSuccess', setPrivacyUri);
    }

    function setPrivacyUri(){
      privacyService.getPrivacyPolicyUri().then(function(uri){
        ctrl.privacyUri = uri;
      }, function(){
        // fall back to US for any errors
        ctrl.privacyUri = privacyUriMap['en-US'];
      });
    }
  }

  // Service implementation
  privacyPolicyService.$inject = ['bmLanguageManager', 'bmPrivacyPolicyUriMap'];
  function privacyPolicyService(languageManager, privacyPolicyUriMap){
    /*jshint validthis:true */
    var self = this;

    self.getPrivacyPolicyUri = getPrivacyPolicyUri;

    //////////////////////

    function getPrivacyPolicyUri(){
      return languageManager.getLoadedLanguageAsync().then(function(language){
        return privacyPolicyUriMap[language.code] || privacyPolicyUriMap['en-US'];
      });
    }
  }
})(window.angular);

// Depends on IAC: OnvioSupportID

(function(angular){
  'use strict';

  angular.module('bmSupportId', [
    'pascalprecht.translate',
    'bluemoon.components.i18n',
    'bluemoon.components.analytics'])
  .component('bmSupportIdLink', {
    templateUrl: 'components/support-id/support-id.2js.html',
    controller: supportIdLink,
  })
  .service('bmSupportIdService', supportIdService);

  // Component implementation
  supportIdLink.$inject = ['bmSupportIdService', 'bmAccess', 'bmAnalyticsService'];
  function supportIdLink(supportIdService, bmAccess, bmAnalyticsService){
    /*jshint validthis:true */
    var ctrl = this;
    ctrl.$onInit = init;

    function init(){
      ctrl.enabled = false;
      ctrl.showId = false;
      ctrl.supportId = '';

      ctrl.copyToClip = copyToClip;
      ctrl.loadSupportId = loadSupportId;

      bmAccess.has('OnvioSupportID').then(function(access){
        ctrl.enabled = access;
        // Initial support ID load
        ctrl.loadSupportId();
      }).catch(function() {
        ctrl.enabled = false;
        bmAnalyticsService.track('bmSupportIdService: bmAccess.has(\'OnvioSupportId\') failed');
      });
    }

    function loadSupportId () {
      ctrl.supportId = supportIdService.getRouteId();
    }

    function copyToClip () {
      document.getElementById('support-id-text').select();
      document.execCommand('copy');
    }
  }

  // Service implementation
  function supportIdService(){
    /*jshint validthis:true */
    var self = this;
    self.getRouteId = getRouteId;

    function getRouteId () {
      var inj = window.angular.element(document.querySelector('[ng-app], [data-ng-app], html, body')).injector();
      var routeId = inj.get('$http').defaults.headers.common['x-route-id'];
      return routeId;
    }
  }
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.help', [
        'bmEnvironment',
        'pascalprecht.translate'
    ]);

})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.help')
        .controller('HelpCtrl',
            ['$scope', '$rootScope', '$window', '$timeout', '$translate', 'helpService', 'bmEnvironment',
                function ($scope, $rootScope, $window, $timeout, $translate, helpService, bmEnv) {
                    var defaultUrlPrefix = '/ua/help';
                    var sambaUrlPrefix = '/ua/smb';
                    $scope.help = [];
                    setEnvironmentLinks();
                    $scope.searchInput = { text: '', placeholderTxt: $translate.instant('bm.header.helpMenu.searchLabel') };
                    helpService.load($scope.location).then(function (resp) {
                        $scope.help = [];
                        angular.extend($scope.help, resp.data);
                    });
                    $scope.offLocChgSuccess = $rootScope.$on('$locationChangeSuccess', function () {
                        helpService.load($scope.location).then(function (resp) {
                            $scope.help = [];
                            angular.extend($scope.help, resp.data);
                        });
                    });
                    $rootScope.$on('bmLanguageChangeSuccess', function () {
                        $scope.searchInput.placeholderTxt = $translate.instant('bm.header.helpMenu.searchLabel');
                    });
                    $scope.$on('$destroy', function () {
                        if ($scope.offLocChgSuccess) {
                            $scope.offLocChgSuccess();
                        }
                    });

                    $scope.formatSearchUrl = function (primaryProduct) {
                        var prefix;
                        switch (primaryProduct) {
                            case 'samba':
                            case 'recibos':
                                prefix = sambaUrlPrefix;
                                break;
                            default:
                                prefix = defaultUrlPrefix;
                                break;
                        }
                        var url = prefix + '/search_handler.htm?q=' + encodeURIComponent($scope.searchInput.text);

                        if ($scope.help && $scope.help.parameters) {
                            url += '&' + $scope.formatHelpParametersSuffix($scope.help);
                        }

                        return url;
                    };

                    $scope.formatHelpParametersSuffix = function (help) {
                        var suffix = '';
                        if (help.parameters) {
                            var skipAmperasand = true;
                            angular.forEach(help.parameters, function (value, key) {
                                if (skipAmperasand) {
                                    skipAmperasand = false;
                                } else {
                                    suffix += '&';
                                }

                                suffix += key + '=' + encodeURIComponent(value);
                            });
                        }

                        return suffix;
                    };

                    $scope.formatTopicUrl = function (help, menuUrl) {
                        var url = help.baseUrl + menuUrl;
                        if (help.parameters) {
                            url += '?' + $scope.formatHelpParametersSuffix(help);
                        }

                        return url;
                    };

                    $scope.helpSearch = function () {
                        // if recibos, update help path; #7986
                        bmEnv.load().then(function (data) {
                            var url = $scope.formatSearchUrl(data.primaryProduct);
                            $window.open(url, '_blank');
                        });
                    };

                    $scope.searchKeyPress = function ($event) {
                        if ($event && $event.keyCode === 13) { // Enter key
                            $timeout(function () {
                                $scope.helpSearch();
                            });
                        }
                    };

                    $scope.howToLink = function () {
                        if ($scope.help) {
                            var url = $scope.help.howToUrl;

                            if ($scope.help && $scope.help.parameters) {
                                url += '?' + $scope.formatHelpParametersSuffix($scope.help);
                            }

                            return url;
                        }

                        return '';
                    };

                    function setEnvironmentLinks () {
                        var country = bmEnv.getCountryCode();
                        switch (country) {
                            default:
                                $scope.chatWithSupportLink = 'https://www.livehelpnow.net/lhn/lcv.aspx?d=0&ms=&zzwindow=0&lhnid=12374';
                                $scope.emailSupportLink = 'mailto:onvio.supportus@thomsonreuters.com';
                                break;
                        }
                    }
                }
            ]);
})(window.angular);

/**
 * Blue Moon Components - Help Dropdown Directive
 */
(function (angular) {
    'use strict';

    bmHelpDropdown.$inject = [];
    function bmHelpDropdown() {
        return {
            scope: {
                isDropdownOpen: '=?',
                location: '@?', // the remaining URL after the '#' ex. '/staff/setup/clients'. If absent, defaults to current location
                useMenuLeft: '=?' // Uses a left menu instead
            },
            templateUrl: 'components/help/help.2js.html',
            controller: 'HelpCtrl',
            controllerAs: 'help'
        };
    }

    angular.module('bluemoon.help').directive('bmHelpDropdown', bmHelpDropdown);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.help')
        .factory('helpService', ['$q', '$http', '$location',
            function ($q, $http, $location) {
                return {
                    load: function(location) {
                        if (location && typeof location !== 'string') {
                            throw new Error('Error: location argument should be a non-empty string');
                        }
                        var endpoint = '/api/profiles/v1/help';

                        // If a location was given, use it instead of the current url
                        var currentUrl = $location.absUrl();
                        if (location) {
                            currentUrl = $location.protocol() + '://' + $location.host() + location;
                        }
                        // Debug code to test on localhost
                        if ($location.host() === 'localhost') {
                            currentUrl = 'https://ci.onvio.us/staff/#' + (location ? location : $location.url());
                        }

                        var parameters = '?location=' + encodeURIComponent(currentUrl);
                        var config = {
                            url: endpoint + parameters,
                            method: 'GET',
                            cache: true
                        };

                        return $http(config).then(
                            function(resp) {
                                var defer = $q.defer();
                                defer.resolve(resp);
                                return defer.promise;
                            },
                            function(resp) {
                                resp.config.global = false;
                                return $q.reject(resp);
                            });
                    }
                };
            }
        ]);
})(window.angular);

(function (angular) {
    'use strict';

    var licenseApiUrl = '/api/provisioning/v1/licenses';

    function License($http, $q) {
        var self = this;

        // Can be used for route resolve to determine if you have license.
        // For example,
        // resolve: {
        //     selfReg: bmLicense.has('SelfRegistration').catch(function () {
        //         $state.go('notfound');
        //     })
        // }
        var grants = null;
        var grantsBlockedDefers = null;

        self.load = function () {
            if (grants) {
                return $q.when(grants);
            }

            // We need to run the query.
            // But, someone else may be currently running it, at which point we will just wait for that one call to finish.
            if (!grantsBlockedDefers) {
                grantsBlockedDefers = [];

                $http.get(licenseApiUrl).then(function (resp) {
                    // map into a format we prefer
                    grants = resp.data.featureResources.map(function (val) {
                        return val.feature + '.' + val.resource;
                    });

                    // Resolve all of the waiting promises
                    grantsBlockedDefers.forEach(function (defer) {
                        defer.resolve(grants);
                    });
                    return grants;
                }).catch(function () {
                    // Trigger failure to all of the waiting promises
                    grantsBlockedDefers.forEach(function (defer) {
                        defer.reject();
                    });
                }).finally(function () {
                    // Reset back to the original state.
                    grantsBlockedDefers = undefined;
                });
            }

            // Add ourselves to the list of promises waiting on the query.
            var currentDefer = $q.defer();
            grantsBlockedDefers.push(currentDefer);
            return currentDefer.promise;
        };

        self.hasSync = function (licenses, hasEvery) {
            if (!grants) {
                throw new Error('grants not loaded yet. You must use load() first.');
            }
            var granted = false;
            if (angular.isArray(licenses)) {
                licenses[hasEvery ? 'every' : 'some'](function (license) {
                    if (grants) {
                        granted = grants.indexOf(license) > -1;
                    } else {
                        granted = false;
                    }
                    return granted;
                });
            } else if (typeof licenses === 'string') {
                if (grants) {
                    granted = grants.indexOf(licenses) > -1;
                }
            }
            return granted;
        };
        self.has = function (licenses, hasEvery) {
            return self.load().then(function () {
                var granted = self.hasSync(licenses, hasEvery);
                if (granted) {
                    return granted;
                } else {
                    return $q.reject(granted);
                }
            });
        };

        self.hasSome = function(licenses) {
            return self.has(licenses);
        };

        self.hasEvery = function(licenses) {
            return self.has(licenses, true);
        };

        self.not = function(licenses){
            var deferred = $q.defer();
            self.has(licenses).then(function(){
                deferred.reject(false);
            }, function(){
                deferred.resolve(true);
            });
            return deferred.promise;
        };

        self.notSome = function(licenses){
            return self.not(licenses);
        };

        self.notEvery = function(licenses){
            return self.not(licenses, true);
        };
    }

    /* adapted from angularJS 1.3.12 */
    function getBlockNodes(nodes) {
      // TODO(perf): just check if all items in `nodes` are siblings and if they are return the original
      //             collection, otherwise update the original collection.
      var node = nodes[0];
      var endNode = nodes[nodes.length - 1];
      var blockNodes = [node];

      do {
        node = node.nextSibling;
        if (!node) { break; }
        blockNodes.push(node);
      } while (node !== endNode);

      return angular.element(blockNodes);
    }

    /* adapted from ngIf angularJS 1.3.12 */
    function licenseDirective($animate, bmLicense) {
      return {
        multiElement: true,
        transclude: 'element',
        priority: 600,
        terminal: true,
        restrict: 'A',
        $$tlb: true,
        link: function($scope, $element, $attr, ctrl, $transclude) {
            var block, childScope, previousElements;

            function bmIfHasLicenseWatchAction(value) {
                handleLicenseAttrChange('bmIfHasLicense', value);
            }

            function bmIfHasLicenseEveryWatchAction(value) {
                handleLicenseAttrChange('bmIfHasLicenseEvery', value);
            }

            function bmIfHasLicenseSomeWatchAction(value) {
                handleLicenseAttrChange('bmIfHasLicenseSome', value);
            }

            function bmIfHasNoLicenseWatchAction(value){
                handleLicenseAttrChange('bmIfHasNoLicense', value);
            }

            function bmIfHasNoLicenseSomeWatchAction(value){
                handleLicenseAttrChange('bmIfHasNoLicenseSome', value);
            }

            function bmIfHasNoLicenseEveryWatchAction(value){
                handleLicenseAttrChange('bmIfHasNoLicenseEvery', value);
            }

            function handleLicenseAttrChange(type, value) {
                bmLicense[type === 'bmIfHasLicenseEvery' ? 'hasEvery'
                    : type === 'bmIfHasNoLicenseEvery' ? 'notEvery'
                    : type === 'bmIfHasNoLicense' || type === 'bmIfHasNoLicenseSome' ? 'not'
                    : 'has'
                ](value || $attr[type]).then(function() {

                    if (!childScope) {
                      $transclude(function(clone, newScope) {
                        childScope = newScope;
                        clone[clone.length++] = document.createComment(' end ' + type + ': ' + $attr[type] + ' ');
                        // Note: We only need the first/last node of the cloned nodes.
                        // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                        // by a directive with templateUrl when its template arrives.
                        block = {
                          clone: clone
                        };
                        $animate.enter(clone, $element.parent(), $element);
                      });
                    }
                }, function() {
                    if (previousElements) {
                      previousElements.remove();
                      previousElements = null;
                    }
                    if (childScope) {
                      childScope.$destroy();
                      childScope = null;
                    }
                    if (block) {
                      previousElements = getBlockNodes(block.clone);
                      $animate.leave(previousElements).then(function() {
                        previousElements = null;
                      });
                      block = null;
                    }
                });
            }

            if ($attr.bmIfHasLicense) {
                var unwatchIfHasLicense = $scope.$watch($attr.bmIfHasLicense, bmIfHasLicenseWatchAction);
            }
            if ($attr.bmIfHasLicenseEvery) {
                var unwatchIfHasLicenseEvery = $scope.$watch($attr.bmIfHasLicenseEvery, bmIfHasLicenseEveryWatchAction);
            }
            if ($attr.bmIfHasLicenseSome) {
                var unwatchIfHasLicenseSome = $scope.$watch($attr.bmIfHasLicenseSome, bmIfHasLicenseSomeWatchAction);
            }
            if($attr.bmIfHasNoLicense){
                var unwatchIfHasNoLicense = $scope.$watch($attr.bmIfHasNoLicense, bmIfHasNoLicenseWatchAction);
            }
            if($attr.bmIfHasNoLicenseSome){
                var unwatchIfHasNoLicenseSome = $scope.$watch($attr.bmIfHasNoLicenseSome, bmIfHasNoLicenseSomeWatchAction);
            }
            if ($attr.bmIfHasNoLicenseEvery) {
                var unwatchIfHasNoLicenseEvery = $scope.$watch($attr.bmIfHasNoLicenseEvery, bmIfHasNoLicenseEveryWatchAction);
            }

            // cleanup
            $element.on('$destroy', function () {
                if (unwatchIfHasLicense) { unwatchIfHasLicense(); }
                if (unwatchIfHasLicenseEvery) { unwatchIfHasLicenseEvery(); }
                if (unwatchIfHasLicenseSome) { unwatchIfHasLicenseSome(); }
                if (unwatchIfHasNoLicense) { unwatchIfHasNoLicense(); }
                if (unwatchIfHasNoLicenseSome) { unwatchIfHasNoLicenseSome(); }
                if (unwatchIfHasNoLicenseEvery) { unwatchIfHasNoLicenseEvery(); }
            });
        }
      };
    }

    License.$inject = ['$http', '$q'];
    licenseDirective.$inject = ['$animate', 'bmLicense'];

    angular.module('bmLicense', ['bluemoon.components.session'])
        .service('bmLicense', License)
        .directive('bmIfHasLicense', licenseDirective)
        .directive('bmIfHasLicenseSome', licenseDirective)
        .directive('bmIfHasLicenseEvery', licenseDirective)
        .directive('bmIfHasNoLicense', licenseDirective)
        .directive('bmIfHasNoLicenseSome', licenseDirective)
        .directive('bmIfHasNoLicenseEvery', licenseDirective);

 })(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.myAccount', [
        'bluemoon.components.session',
        'pascalprecht.translate',
        'bluemoon.components.i18n',
        'bluemoon.components.util',
        'bmUserTermsSignatory',
        'bmHttpCache',
        'bmValidateEmail',
        'LinkedAccountsService'
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.myAccount').controller('MyAccountCtrl', myAccountCtrl);
    myAccountCtrl.$inject = ['$q', '$sce','$scope', '$uibModal', '$translate', 'bmUtil','bmAccess', 'myAccountService', 'bmUserSignatory', 'helpService'];

    function myAccountCtrl($q, $sce, $scope, $uibModal, $translate, bmUtil, bmAccess, myAccountService, bmUserSignatory, helpService) {
        /*jshint validthis:true */
        var vm = this;
        var isSkinny = vm.display === 'skinny';
        var licenseeDisplay = false;
        var linkModalOpen = false;

        this.$onInit = function() {
            vm.saveUser = saveUser;
            vm.cancelUser = cancelUser;
            vm.validateUserId = validateUserId;
            vm.languageChanged = languageChanged;
            vm.getTemplateUrl = getTemplateUrl;
            vm.openAccountLinkModal = openAccountLinkModal;
            vm.userIdError = '';
            vm.suffixList = [];
            vm.prefixList = [];
            vm.termsLink = '';
            vm.showStaffTerms = false;
            // 2-way bound data object to pass information between tabs
            vm.sharedLocal = vm.sharedData;
            vm.sharedLocal.hasUnsavedAccount = false;

            initializeView();
        };

        function initializeView(){
            resetAlerts();

            // Create method publicly available through 2-way data bound object
            vm.sharedLocal.setAccountDirty = function(){
                setFormState();
            };

            // should terms link appear
            bmAccess.has('Platform_DisplayOnvioTerms').then(function() {
                vm.showStaffTerms = true;
                getTermsLink().then(function(termsLink) {
                    vm.termsLink = termsLink;
                });
            });
            // Make sure user settings were resolved
            if(angular.isUndefined(vm.user) || vm.user === ''){
                $translate('BM.Components.AccountInformation.LoadError').then(function(alert){
                    addAlert(alert, 'danger');
                });

                return;
            }

            // Set languages - passed on directive property
            vm.languageList = vm.languages;

            // Create a copy of the original user in order to track changes on save
            vm.localUser = angular.copy(vm.user);

            if(angular.isUndefined(vm.localUser.language)){
                vm.localUser.language = 'en-US';
            }

            vm.selectedPrefix = { description: vm.localUser.prefix };
            vm.selectedSuffix = { description: vm.localUser.suffix };

            // set a full name for display if it doesn't exist
            if(angular.isUndefined(vm.localUser.fullName)) {
                var nameParts = [];
                var delimiter = ' ';

                if(!bmUtil.isNullOrEmpty(vm.localUser.prefix)){
                    nameParts.push(vm.localUser.prefix);
                }

                nameParts.push(vm.localUser.firstName);
                nameParts.push(vm.localUser.lastName);

                if(!bmUtil.isNullOrEmpty(vm.localUser.suffix)){
                    nameParts.push(vm.localUser.suffix);
                }

                vm.localUser.fullName = (nameParts.join(delimiter)).trim();
            }

            languageChanged(vm.localUser.language);

            // for skinny display - no terms necessary to be loaded
            if(!isSkinny){
                // load up any terms and conditions information
                bmUserSignatory.getRequiredUserSignatoryAsync().then(function(signatory){
                    setTermsDisplay(signatory);
                });
            }
        }

        // https://stackoverflow.com/questions/23065165/angularjs-directive-dynamic-templates
        function getTemplateUrl(displayType){
            // skinny displayType is used for CSWeb

            // lean towards onvio base template
            var baseTemplate = displayType === 'skinny' ? 'my-account/my-account-skinny.2js.html' : 'my-account/my-account.2js.html';

            // user not loaded
            if(angular.isUndefined(vm.user) || vm.user === ''){
                return baseTemplate;
            }

            // licensee version
            if(displayType === 'skinny' && vm.user.licensee){
                licenseeDisplay = true;
                return 'my-account/my-account-licensee.2js.html';
            }

            // stick with non-licensee version
            return baseTemplate;
        }

        function getTermsLink() {
            return helpService.load().then( function(response) {
                return (response.data.baseUrl.substring(0, response.data.baseUrl.indexOf('core')) + 'general-articles/terms-conditions-onvio.htm');
            });
        }
        function loadLanguageDependentLists(language){
            var promises = [
                myAccountService.getNamePrefixListAsync(language),
                myAccountService.getNameSuffixListAsync(language)
            ];

            $scope.$emit('bm-busy-loading-on');

            return $q.all(promises).then(function(results){
                $scope.$emit('bm-busy-loading-off');

                vm.prefixList = loadListResults(results[0], vm.selectedPrefix);
                vm.suffixList = loadListResults(results[1], vm.selectedSuffix);
            }, function(){
                $scope.$emit('bm-busy-loading-off');
            });
        }

        function loadListResults(list, selected){
            // Always add selected value if available
            var shouldAddSelected = selected !== null && angular.isDefined(selected) && angular.isDefined(selected.description) && selected.description !== '';
            var selectedExists = false;

            for(var index = 0; index < list.length; index++){
                if(shouldAddSelected && list[index].description === selected.description){
                    selectedExists = true;
                    break;
                }
            }

            // Always keep the selected value in the list
            if(shouldAddSelected && !selectedExists){
                list.push({
                    id: list.length,
                    description: selected.description
                });
            }

            return list;
        }

        function languageChanged(language){
            loadLanguageDependentLists(language);
        }

        function setTermsDisplay(signatory){
            if(angular.isDefined(signatory) && angular.isDefined(signatory.terms) && angular.isDefined(signatory.signatory)){
                vm.hasTermsSignatory = true;
                vm.termsDisplayText = $sce.trustAsHtml(signatory.terms.text);
            }
        }

        function saveUser(){
            resetAlerts();
            cleanUserData();
            validateUserId(true);

            if(vm.userIdError !== ''){
                setFormInvalid();
                return;
            }

            validateUserIdAsync().then(function(){
                // do no want to save if the linking modal dialog is open
                if(linkModalOpen === false) {
                    if(vm.userIdError !== '' || vm.myAccountForm.$invalid){
                        setFormInvalid();
                        return;
                    }

                    setSelectedValuesOnUser(vm.localUser);
                    var userToSave = getCleanUserSaveData(vm.localUser);

                    $scope.$emit('bm-busy-loading-on');
                    myAccountService.saveUserAsync(userToSave).then(function(){
                        $scope.$emit('bm-busy-loading-off');
                        vm.myAccountForm.$setPristine();
                        vm.sharedLocal.hasUnsavedAccount = false;

                        // keep user objects in sync
                        vm.user = angular.copy(vm.localUser);

                        // Always persist the language just in case there is an out-of-sync condition between saved settings and UI
                        myAccountService.persistLanguageAsync(userToSave.language);

                        $translate('bm.header.viewProfile.account.saveSuccessful').then(function(value){
                            addAlert(value, 'success');
                        });
                    }, function(error){
                        $scope.$emit('bm-busy-loading-off');
                        // TODO: REPLACE THIS WITH A USEFUL ERROR MESSAGE
                        addAlert(error.data, 'danger');
                    });
                }
            }, function(){
                setFormInvalid();
            });
        }
        function openAccountLinkModal(uid) {
            linkModalOpen = true;
            var modalInstance = $uibModal.open({
                templateUrl: 'my-account/link-auth/link-auth-modal.2js.html',
                controller: 'LinkAuthCtrl as vm',
                backdrop: 'static',
                resolve: {
                    uid: function() {
                        return uid;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                if(result !== 'change email') {
                    linkModalOpen = false;
                }
            }, function(reason) {
                linkModalOpen = false;
                resetAlerts();
                if(angular.isDefined(reason)) {
                    if(reason !== 'change email') {
                        addAlert(reason, 'danger');
                    }
                }
            });
        }
        function setSelectedValuesOnUser(user){
            var prefixToSave = (vm.selectedPrefix !== null && angular.isDefined(vm.selectedPrefix) && angular.isDefined(vm.selectedPrefix.description)) ? vm.selectedPrefix.description : '';
            var suffixToSave = (vm.selectedSuffix !== null && angular.isDefined(vm.selectedSuffix) && angular.isDefined(vm.selectedSuffix.description)) ? vm.selectedSuffix.description : '';

            user.prefix = prefixToSave;
            user.suffix = suffixToSave;
        }

        function getCleanUserSaveData(user){
            return {
                email: user.email,
                prefix: angular.isUndefined(user.prefix) ? '' : user.prefix,
                firstName: user.firstName,
                middleName: angular.isUndefined(user.middleName) ? '' : user.middleName,
                lastName: user.lastName,
                suffix: angular.isUndefined(user.suffix) ? '' : user.suffix,
                language: user.language
            };
        }

        function cleanUserData() {
            // TODO: HACK TO AVOID BAMS INTEGRATION. PASS IN NAME PARSER METHODS
            if(angular.isDefined(vm.localUser.fullName)) {
                vm.localUser.fullName = vm.localUser.fullName.trim();
            }

            if(angular.isDefined(vm.localUser.email)) {
                vm.localUser.email = vm.localUser.email.trim();
            }
            if(angular.isDefined(vm.localUser.firstName)) {
                vm.localUser.firstName = vm.localUser.firstName.trim();
            }
            if(angular.isDefined(vm.localUser.middleName)) {
                vm.localUser.middleName = vm.localUser.middleName.trim();
            }
            if(angular.isDefined(vm.localUser.lastName)) {
                vm.localUser.lastName = vm.localUser.lastName.trim();
            }
        }

        function setFormInvalid(){
            var alert = '';
            $translate('BM.Components.IncompleteForm').then(function(data){
                alert = data;
                addAlert(alert, 'danger');
            });

            // fields don't exist on licensee display
            if(licenseeDisplay){
                return;
            }

            // Toggle all validation messages
            if(vm.myAccountForm.firstName.$error.required){
               vm.myAccountForm.firstName.$dirty = true;
            }

            if(vm.myAccountForm.firstName.$error.required){
               vm.myAccountForm.firstName.$dirty = true;
            }

            if(vm.myAccountForm.lastName.$error.required){
               vm.myAccountForm.lastName.$dirty = true;
            }

            // skinny form doesn't have language field
            if(!isSkinny && vm.myAccountForm.language.$error.required){
               vm.myAccountForm.language.$dirty = true;
            }
        }

        function allowAccountMergingAsync() {
            // check for access to account switching merging IAC
            return bmAccess.has('PPE-AccountSwitchingMerge');

        }

        function validateUserId(isFormSubmit){
            vm.userIdError = '';

            // User id required
            if(vm.myAccountForm.userId.$error.required){
                $translate('BM.Components.EnterEmailAddressError').then(function(data){
                    vm.userIdError = data;
                });
                return;
            }

            if(vm.myAccountForm.userId.$invalid){
                $translate('BM.Components.EnterValidEmailError').then(function(data){
                    vm.userIdError = data;
                });
                return;
            }

            // We don't want to check the email when the 'on-blur' event is called if we are allowed to merge accounts
            allowAccountMergingAsync().catch(function() {
                if(isFormSubmit === false && linkModalOpen === false){
                    validateUserIdAsync();
                }
            });
        }

        function validateUserIdAsync(){
            $scope.$emit('bm-busy-loading-on');
            return myAccountService.loginAlreadyUsedAsync(vm.localUser.email).then(function(response){
                $scope.$emit('bm-busy-loading-off');
                var data = response.data;

                if(angular.isDefined(data) && data.results === 'found'){
                    return allowAccountMergingAsync().then(function() {
                        openAccountLinkModal(vm.localUser.email);
                    }, function() {
                        $translate('BM.Components.EmailInUseError').then(function(data){
                            vm.userIdError = data;
                        });
                    });
                }
            }, function(error){
                $scope.$emit('bm-busy-loading-off');
                $translate('BM.Components.UnableToValidateEmailError').then(function(data){
                    vm.userIdError = data + error.data;
                });
            });
        }

        function cancelUser(){
            if(vm.sharedLocal.resetOnCancel){
                initializeView();
                setFormState();
            }

            $scope.$emit('bmProfileCancelAction');
        }

        function addAlert(message, type){
            resetAlerts();

            var alert = { msg: message, type: type };

            if(isSkinny || licenseeDisplay){
                alert.closeable = !licenseeDisplay;
                alert.timeout = 2500;
            }

            vm.alerts.push(alert);
        }

        function resetAlerts(){
            vm.alerts = [];
        }

        function setFormState(){
            // pickup prefix and suffix
            setSelectedValuesOnUser(vm.localUser);

            var newUser = getCleanUserSaveData(vm.localUser);
            var initialUser = getCleanUserSaveData(vm.user);
            var isClean = angular.equals(newUser, initialUser);

            if(isClean){
                resetAlerts();
                // this assumes the initial value of email was valid
                vm.userIdError = '';
                vm.myAccountForm.$setPristine();
            } else {
                vm.myAccountForm.$setDirty();
            }

            vm.sharedLocal.hasUnsavedAccount = !isClean;
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.myAccount').factory('myAccountService', myAccountService);
    myAccountService.$inject = ['$q','$http', '$rootScope', '$translate', 'AuthenticatedSessionData', 'bmLanguageManager', 'bmHttpCacheHelper'];

    function myAccountService($q, $http, $rootScope, $translate, authenticatedSessionData, bmLanguageManager, bmHttpCacheHelper){
        var factory = {
            getUserSettingsAsync: getUserSettingsAsync,
            getMyUserSettingsAsync: getMyUserSettingsAsync,
            getNameSuffixListAsync: getNameSuffixListAsync,
            getNamePrefixListAsync: getNamePrefixListAsync,
            getLanguageListAsync: getLanguageListAsync,
            saveUserAsync: saveUserAsync,
            saveUser: saveUser,
            persistLanguageAsync: persistLanguageAsync,
            loginAlreadyUsedAsync: loginAlreadyUsedAsync
        };

        var userApi =  '/api/profiles/v1/users';
        return factory;

        //////////

        function getUserSettingsAsync(userTruId){
            if(angular.isUndefined(userTruId)){
                return $translate('bm.account.service.unableToLoadUser').then(function(val){
                    return getRejectedPromise(val);
                });

            }

            // cache for 10 seconds
            return $http({
                method: 'GET',
                url: userApi + '/' + userTruId,
                bmCache: 10000
            });
        }

        function getMyUserSettingsAsync(){
            var promises = [
                getUserTruidFromSession(),
                getCompanyIdFromSession(),
                getContactIdFromSession()
            ];

            return $q.all(promises).then(function(data){
                return getUserSettingsAsync(data[0]).then(function(response){
                    // Persist the user data in order to keep it all in one place
                    if(angular.isDefined(response) && angular.isDefined(response.data)){
                        response.data.bluId = data[0];
                        response.data.companyId = data[1];
                        response.data.contactId = data[2];
                    }

                    return response;
                });
            });
        }

        function getNameSuffixListAsync(languageCode){
            var url = '/api/core/v1/contacts/name-suffixes';
            return getNameAdditionsList(languageCode, url);
        }

        function getNamePrefixListAsync(languageCode){
            var url = '/api/core/v1/contacts/name-prefixes';
            return getNameAdditionsList(languageCode, url);
        }

        function getNameAdditionsList(languageCode, baseUrl){
            if(angular.isUndefined(languageCode) || languageCode === ''){
                languageCode = 'en-US';
            }

            var url = baseUrl + '?language=' + encodeURIComponent(languageCode);

            // cache for 10 minutes
            return $http({
                method: 'GET',
                url: url,
                bmNoAuth: true,
                bmCache: 600000
            }).then(function(response){
                var list = [];

                if(angular.isUndefined(response.data) || angular.isUndefined(response.data.values)){
                    return list;
                }

                var values = response.data.values;

                for(var counter = 0; counter < values.length; counter++){
                    list.push({
                        id: counter,
                        description: values[counter]
                    });
                }

                return list;
            });
        }

        function getLanguageListAsync(){
            return bmLanguageManager.getLanguagesAsync(true).then(function(languages){
                return languages;
            });
        }

        function saveUserAsync(user){
            return getUserTruidFromSession().then(function(userTruId) {

                if(angular.isUndefined(userTruId) || angular.isUndefined(user) || angular.isUndefined(user.email)){
                    return $translate('bm.account.service.unableToLoadUser').then(function(val){
                        return getRejectedPromise(val);
                    });
                }

                return loginAlreadyUsedAsync(user.email).then(function(response){
                    if(response.data.results === 'found'){
                        return $translate('BM.Components.EmailInUseError').then(function(val){
                            return getRejectedPromise(val);
                        });
                    }

                    return $http({
                        method: 'PUT',
                        url: userApi + '/' + userTruId,
                        data: user
                    }).then(function(){
                        bmHttpCacheHelper.invalidateHttpCache(userApi + '/' + userTruId);
                    });
                });
            });
        }

        function saveUser(user) {
            return getUserTruidFromSession().then(function(userTruId){
                if(angular.isUndefined(userTruId) || angular.isUndefined(user) || angular.isUndefined(user.email)){
                    return $translate('bm.account.service.unableToLoadUser').then(function(val){
                        return getRejectedPromise(val);
                    });
                }
                return $http({
                    method: 'PUT',
                    url: userApi + '/' + userTruId,
                    data: user
                }).then(function(){
                    bmHttpCacheHelper.invalidateHttpCache(userApi + '/' + userTruId);
                });
            });
        }

        function persistLanguageAsync(languageCode){
            var curr = bmLanguageManager.getCurrentLanguage();
            if (curr !== languageCode) {
                return bmLanguageManager.setUserLanguageAsync(languageCode).then(function() {
                    $rootScope.$broadcast('bmLanguageChangeByUserSuccess', { language: languageCode });
                });
            } else {
                var deferred = $q.defer();
                deferred.resolve();
                return deferred.promise;
            }
        }

        function getRejectedPromise(rejectReason){
            var deferred = $q.defer();

            if(angular.isString(rejectReason)){
                deferred.reject({ data: rejectReason });
            } else {
                $translate('bm.account.service.unableToProcessUserInfo').then(function(val){
                    deferred.reject({ data: val });
                });
            }

            return deferred.promise;
        }

        function loginAlreadyUsedAsync(email) {
            // No need to verify if email is same as what's in session
            return getEmailAddressFromSession().then(function(sessionEmail) {
                if(angular.isDefined(sessionEmail) && angular.isDefined(email) && email.toLowerCase() === sessionEmail.toLowerCase()){
                    var deferred = $q.defer();

                    deferred.resolve({
                        data: {
                            results: 'notfound'
                        }
                    });

                    return deferred.promise;
                }

                return $http({
                    method: 'GET',
                    url: userApi + '/login-in-use?login=' + encodeURIComponent(email)
                });
            });

        }

        function getUserTruidFromSession(){
            return authenticatedSessionData.getMeta().then(function(data){
                return data.PrismGuid;
            });
        }

        function getEmailAddressFromSession(){
            return authenticatedSessionData.getMeta().then(function(data){
                return data.EmailAddress;
            });
        }

        function getCompanyIdFromSession(){
            return authenticatedSessionData.getBindings().then(function(data){
                if(angular.isDefined(data) && angular.isDefined(data.ApplicationConfiguration)){
                    return data.ApplicationConfiguration.CompanyId;
                }

                return undefined;
            });
        }

        function getContactIdFromSession(){
            return authenticatedSessionData.getBindings().then(function(data){
                if(angular.isDefined(data) && angular.isDefined(data.ApplicationConfiguration)){
                    return data.ApplicationConfiguration.ContactId;
                }

                return undefined;
            });
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.myAccount').directive('bmMyAccountInfo', [function(){
        return {
            restrict: 'E',
            replace: true,
            template: function(elem, attrs){
                // https://stackoverflow.com/questions/23065165/angularjs-directive-dynamic-templates
                return '<ng-include src="vm.getTemplateUrl(\'' + attrs.display + '\')"/>';
            },
            scope: {
                languages: '=',
                user: '=',
                sharedData: '=',
                display: '@'
            },
            controller: 'MyAccountCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }]);
})(window.angular);

(function(angular) {
    'use strict';
        angular.module('bluemoon.myAccount').controller('LinkAuthCtrl', linkAuthCtrl);
        linkAuthCtrl.$inject = [
            'bmAccess',
            '$templateRequest',
            '$scope',
            '$translate',
            '$location',
            '$uibModalInstance',
            'AuthenticatedSession',
            'bmMultifactorService',
            'LinkedAccountsService',
            'myAccountService',
            'languageStorageManager',
            '$compile',
            '$rootScope',
            'uid'
        ];
        function linkAuthCtrl(
            bmAccess,
            $templateRequest,
            $scope,
            $translate,
            $location,
            $uibModalInstance,
            session,
            mfaService,
            linkedAccountsService,
            myAccountService,
            langMgr,
            $compile,
            $rootScope,
            uid
        ) {
            /*jshint validthis:true */
            var vm = this;
            vm.linkAccounts = linkAccounts;
            vm.closeModal = closeModal;
            vm.changeEmail = changeEmail;
            vm.pwd = '';
            vm.isLoaderBusy = false;

            var linkingResult = 'change email';

            function linkAccounts() {
                if (vm.verifyLoginForm.$valid) {
                    vm.isLoaderBusy = true;
                    // TODO: RIGHT NOW THIS PASSWORD CHECK IS SET TO TRID INSTEAD OF PRODUCT OPTIONS
                    var userData = { uid: uid, pwd: vm.pwd, type: 'TRID' };
                    mfaService.verifyLoginData(userData).then(function(){
                        linkedAccountsService.linkExistingAccountWithLogin(userData.uid).then(function(linkedResp) {
                            linkingResult = linkedResp.data.LongToken;
                            session.switchAccountWithLongToken(linkingResult);
                            vm.isLoaderBusy = false;
                            closeModal();
                        }, function(error){
                            linkingResult = 'change email';
                            vm.isLoaderBusy = false;
                            if(error.status === 400) {
                                showLinkingError(error.data.message);
                            } else {
                                $translate('BM.Components.SorryTryAgainLater').then(function(text) {
                                    showLinkingError(text);
                                });
                            }
                        });
                    }, function(){
                        vm.isLoaderBusy = false;
                        $translate('bm.header.viewProfile.mfaConfirmError').then(function(text) {
                            showLinkingError(text);
                        });
                    });
                }
            }

            function closeModal() {
                clearErrors();
                $uibModalInstance.close(linkingResult);
            }

            function changeEmail() {
                clearErrors();
                $uibModalInstance.dismiss('change email');
            }

            function showLinkingError(text) {
                clearErrors();
                $rootScope.bmErrors.splice(0, $rootScope.bmErrors.length);
                $rootScope.bmErrors.push({type: 'danger', msg: text, closeable: true});
            }

            function clearErrors() {
                if (!$rootScope.bmErrors) {
                    $rootScope.bmErrors = [];
                }
                $rootScope.bmErrors = [];
            }
        }
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.updatePassword', [
        'bluemoon.components.session',
        'bluemoon.passwordValidation',
        'pascalprecht.translate',
        'bluemoon.components.focus'
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.updatePassword').controller('UpdatePasswordCtrl', updatePassword);

    updatePassword.$inject = ['$translate', '$scope', 'bmAccess', 'PasswordFactory', 'PasswordValidationFactory'];

    function updatePassword($translate, $scope, bmAccess, PasswordFactory, PasswordValidationFactory){
        /*jshint validthis:true */
        var vm = this;

        var confirmPasswordMsgNoData = '';
        var confirmPasswordMsgNoMatch = '';
        var reusedPasswordError = '';
        var commonPasswordError = '';

        this.$onInit = function(){
            vm.savePassword = savePassword;
            vm.cancelPassword = cancelPassword;
            vm.validatePasswordFields = validatePasswordFields;
            vm.validateConfirmPassword = validateConfirmPassword;
            vm.setConfirmPasswordInFocus = setConfirmPasswordInFocus;
            vm.setConfirmPasswordOutOfFocus = setConfirmPasswordOutOfFocus;
            vm.isConfirmPasswordInvalid = isConfirmPasswordInvalid;
            vm.isConfirmPasswordValid = isConfirmPasswordValid;
            vm.closeAlert = closeAlert;

            vm.newPasswordError = '';
            vm.confirmPasswordError = '';
            vm.confirmPasswordInFocus = false;

            $translate('BM.Components.PasswordMatchError').then(function(data){
                confirmPasswordMsgNoMatch = data;
            });
            $translate('BM.Components.NoDataEnteredError').then(function(data){
                confirmPasswordMsgNoData = data;
            });
            $translate('BM.Components.PasswordUsedPreviouslyError').then(function(data){
                reusedPasswordError = data;
            });
            $translate('BM.Components.PasswordTooCommonError').then(function(data){
                commonPasswordError = data;
            });

            // 2-way bound data object to pass information between tabs
            vm.sharedLocal = vm.sharedData;
            vm.sharedLocal.hasUnsavedPassword = false;

            // Create method publicly available through 2-way data bound object
            vm.sharedLocal.setPasswordDirty = function(){
                setFormState();
            };

            vm.isSkinny = vm.sharedLocal.skinny === true; // controls how alerts are displayed
            vm.alerts = [];

            // Load up password validation rules
            PasswordValidationFactory.loadPasswordRules().then(function(response){
                angular.extend(vm, response);
            });

            // If appropriate, check for the existence of the user data
            bmAccess.has('PPE-AccountSwitching').then(function(){
                checkForUser();
            });
        };

        function checkForUser(){
            // Make sure a user is loaded
            if(angular.isUndefined(vm.user) || vm.user === ''){
                $translate('BM.Components.AccountInformation.LoadError').then(function(alert){
                    addAlert(alert, 'danger');
                });

                return;
            }
        }

        function savePassword(){
            resetAlerts();

            // Validate the form
            validatePasswordFields(true);

            if(vm.updatePasswordForm.$invalid || vm.passwordIsValidated !== true || vm.confirmIsValidated !== true){
                // Toggle all validation messages
                if(vm.updatePasswordForm.currentPassword.$error.required){
                   vm.updatePasswordForm.currentPassword.$dirty = true;
                   vm.updatePasswordForm.currentPassword.hasVisited = true;
                }

                $translate('BM.Components.IncompleteForm').then(function(value){
                    addAlert(value, 'danger');
                });

                return;
            }

            $scope.$emit('bm-busy-loading-on');
            PasswordFactory.savePassword(vm.currentPassword, vm.newPassword).then(function(){
                $scope.$emit('bm-busy-loading-off');
                resetEntryForm();
                vm.sharedLocal.hasUnsavedPassword = false;

                bmAccess.has('PPE-AccountSwitching').then(function(){
                    $translate('BM.Components.PasswordUpdateSuccessful').then(function(value){
                        value  = value + ' ' + vm.user.email;
                        addAlert(value, 'success');
                    });
                }, function() {
                    $translate('bm.header.viewProfile.password.saveSuccessful').then(function(value){
                        addAlert(value, 'success');
                    });
                });
            }, function(response) {
                $scope.$emit('bm-busy-loading-off');

                if (response.status === 401) {
                    $translate('BM.Components.PasswordInvalidError').then(function(value){
                        addAlert(value, 'danger');
                    });
                } else {
                    $translate('BM.Components.PasswordUpdateError').then(function(value){
                        addAlert(value, 'danger');
                    });
                }
            });
        }

        function validatePasswordFields(isSubmit){
            validatePassword(isSubmit);
            validateConfirmPassword(isSubmit);
        }

        function validatePassword(isSubmit){
            // Reset the validation message
            vm.newPasswordError = '';
            vm.passwordIsValidated = false;

            // Password required
            if(vm.updatePasswordForm.newPassword.$error.required){
                $translate('BM.Components.EnterPasswordError').then(function(data){
                    vm.newPasswordError = data;
                });
                return;
            }

            if(angular.isUndefined(vm.rules) || vm.rules.length === 0) {
                return;
            }

            // run the rules
            // first, the character length rule because it's required
            var lengthRule = vm.rules.characterLengthRule;
            if(!lengthRule.test(vm.newPassword)) {
                $translate('BM.Components.ValidPasswordError').then(function(data){
                    vm.newPasswordError = data;
                });
                return;
            } else {
                // second, the character type rules
                var rulesPassed = 0;
                for(var pos = 0; pos < vm.rules.characterTypeRules.length; pos++) {
                    var currentRule = vm.rules.characterTypeRules[pos];
                    if(currentRule.test(vm.newPassword)) {
                        rulesPassed++;
                    }
                }
                if(rulesPassed < vm.charClassReq) {
                    $translate('BM.Components.ValidPasswordError').then(function(data){
                        vm.newPasswordError = data;
                    });
                    return;
                }
            }

            if(vm.rules.prohibitedCharacterRule.test(vm.newPassword)){
                vm.newPasswordError = vm.rules.prohibitedCharacterRule.label + ': ' + vm.rules.prohibitedCharacterRule.getInvalidChars(vm.newPassword).join(', ');
                return;
            }

            if(isSubmit && (vm.currentPassword === vm.newPassword)){
                $translate('BM.Components.NewPasswordMatchError').then(function(data){
                    vm.newPasswordError = data;
                });
                return;
            }

            PasswordFactory.verifyNewPassword(vm.newPassword).then(function(response){
                if (response.data.usedPreviously) {
                    vm.newPasswordError = reusedPasswordError;
                } else if (response.data.tooCommon) {
                    vm.newPasswordError = commonPasswordError;
                }
            });

            vm.passwordIsValidated = true;
        }

        function validateConfirmPassword(isSubmit){
            // Reset the validation message
            vm.confirmPasswordError = '';
            vm.confirmIsValidated = false;

            // Has anything even been entered? Only show message on submit of form.
            if(isSubmit && (angular.isUndefined(vm.confirmPassword) || vm.confirmPassword === '')){
                vm.confirmPasswordError = confirmPasswordMsgNoData;
                return;
            }

            if((angular.isUndefined(vm.confirmPassword) || vm.confirmPassword === '') &&
                (angular.isUndefined(vm.newPassword) || vm.newPassword === '')){
                return;
            }

            if(vm.confirmPassword !== vm.newPassword){
                vm.confirmPasswordError = confirmPasswordMsgNoMatch;
                return;
            }

            vm.confirmIsValidated = true;
        }

        function isConfirmPasswordValid() {
            var isValid = false;
            var newPwd = '';
            var confirmPwd = '';

            if(vm.confirmPassword) {
                if(!vm.updatePasswordForm.newPassword.$error.required) {
                    newPwd = vm.newPassword;
                    confirmPwd = vm.confirmPassword;

                    if((confirmPwd.length === newPwd.length) && (confirmPwd === newPwd)) {
                        isValid = true;
                    }
                }
            }
            return isValid;
        }

        function isConfirmPasswordInvalid() {
            var isInvalid = true;
            var newPwd = '';
            var confirmPwd = '';
            vm.confirmIsValidated = false;

            // Get the data to check
            if(angular.isUndefined(vm.newPassword)){
                newPwd = '';
            } else {
                newPwd = vm.newPassword;
            }
            if(angular.isUndefined(vm.confirmPassword)){
                confirmPwd = '';
            } else {
                confirmPwd = vm.confirmPassword;
            }

            // check the data
            if(vm.confirmPasswordInFocus) {
                vm.updatePasswordForm.confirmPassword.$dirty = true;

                if(confirmPwd === newPwd) {
                    vm.confirmPasswordError = '';
                    isInvalid = false;
                } else if(newPwd.slice(0, confirmPwd.length) !== confirmPwd) {
                    if(confirmPwd === '') {
                        vm.confirmPasswordError = confirmPasswordMsgNoData;
                    } else {
                       vm.confirmPasswordError = confirmPasswordMsgNoMatch;

                    }
                } else {
                     vm.confirmPasswordError = '';
                     isInvalid = false;
                }
            } else {
                if(vm.updatePasswordForm.confirmPassword.$dirty) {
                    vm.confirmPasswordError = '';
                    validateConfirmPassword(true);
                }

                if(vm.confirmPasswordError === '') {
                    isInvalid = false;
                }
            }

            return isInvalid;
        }

        function setConfirmPasswordInFocus() {
            vm.confirmPasswordInFocus = true;
            vm.confirmPasswordError = '';
        }

        function setConfirmPasswordOutOfFocus() {
            vm.confirmPasswordInFocus = false;
        }

        function resetEntryForm(){
            vm.currentPassword = '';
            vm.newPassword = '';
            vm.confirmPassword = '';
            vm.updatePasswordForm.$setPristine();
            vm.passwordIsValidated = false;
            vm.confirmIsValidated = false;

            // clear any validation messages
            vm.updatePasswordForm.currentPassword.$setValidity('required', true);
            vm.newPasswordError = '';
            vm.confirmPasswordError = '';
        }

        function addAlert(message, type){
            resetAlerts();

            var alert = { msg: message, type: type };

            if(vm.isSkinny){
                alert.closeable = true;
                alert.timeout = 2500;
            }

            vm.alerts.push(alert);
        }

        function resetAlerts(){
            vm.alerts.length = 0;
        }

        function closeAlert(index){
            vm.alerts.splice(index, 1);
        }

        function cancelPassword(){
            if(vm.sharedLocal.resetOnCancel){
                vm.currentPassword = '';
                vm.newPassword = '';
                vm.confirmPassword = '';

                setFormState();
            }

            $scope.$emit('bmProfileCancelAction');
        }

        function setFormState(){
            var isClean = (angular.isUndefined(vm.currentPassword) || vm.currentPassword === '') &&
                (angular.isUndefined(vm.newPassword) || vm.newPassword === '') &&
                (angular.isUndefined(vm.confirmPassword) || vm.confirmPassword === '');

            if(isClean){
                resetEntryForm();
                resetAlerts();
            } else {
                vm.updatePasswordForm.$setDirty();
            }

            vm.sharedLocal.hasUnsavedPassword = !isClean;
        }
    }

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.updatePassword').factory('PasswordFactory', passwordFactory);
    passwordFactory.$inject = ['$http'];

    function passwordFactory($http){
        var factory = {
            savePassword: savePassword,
            verifyNewPassword: verifyNewPassword
        };

        var passwordApi = '/api/profiles/v1/password';
        var passwordVerifyApi = '/api/profiles/v2/password/check';

        return factory;

        //////////

        function savePassword(oldPassword, newPassword){
            return $http({
                method: 'PUT',
                url: passwordApi,
                data: { oldPassword: oldPassword, newPassword: newPassword },
                bmAuthRedirect: false // disable 401 redirection
            });
        }

        function verifyNewPassword(password){
            return $http({
                method: 'POST',
                url: passwordVerifyApi,
                headers: {'Content-Type': 'application/json'},
                data: {
                    password: password
                }
            });
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.updatePassword').directive('bmUpdatePassword', [function(){
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'update-password/update-password.2js.html',
            scope: {
                user: '=',
                sharedData: '='
            },
            controller: 'UpdatePasswordCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }]);

})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.securityQuestions', [
        'bluemoon.components.session',
        'pascalprecht.translate',
        'bmForceModelChange',
        'bmHttpCache'
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.securityQuestions').controller('SecurityQuestionsCtrl', securityQuestions);
    securityQuestions.$inject = ['$q', '$scope', '$translate', 'SecurityQuestionsFactory'];

    function securityQuestions($q, $scope, $translate, SecurityQuestionsFactory){
        /*jshint validthis:true */
        var vm = this;
        var questionCounter;
        var answerInitValue;
        var masterQuestions = vm.master;
        var initialUserQuestions = vm.userQuestions;

        vm.saveQuestions = saveQuestions;
        vm.cancelQuestions = cancelQuestions;
        vm.processQuestionSelect = processQuestionSelect;
        vm.validateAnswer = validateAnswer;
        vm.clearDefaultAnswer = clearDefaultAnswer;

        var selectQuestionError = 'Please select a question.';
        var enterAnswerError = 'Please enter an answer.';
        var loadSecurityQuestionsError = 'Unable to load security question information. Please try again.';
        var loadSecurityEnounteredError = 'An error was encountered while loading security questions.';
        var entryDataLoadError = 'Unable to load form entry data. Please try again.';
        var noSecurityQuestionsSetupError = 'Please setup your security questions.';

        // 2-way bound data object to pass information between tabs
        vm.sharedLocal = vm.sharedData;
        vm.sharedLocal.hasUnsavedQuestions = false;

        translateErrors();
        initializeView();

        //////////

        function translateErrors(){
            $translate('BM.Components.Security.SelectQuestionError').then(function(data){
                selectQuestionError = data;
            });
            $translate('BM.Components.Security.EnterAnswerError').then(function(data){
                enterAnswerError = data;
            });
            $translate('BM.Components.Security.LoadSecurityQuestionsError').then(function(data){
                loadSecurityQuestionsError = data;
            });
            $translate('BM.Components.Security.LoadSecurityEnounteredError').then(function(data){
                loadSecurityEnounteredError = data;
            });
            $translate('BM.Components.Security.EntryDataLoadError').then(function(data){
                entryDataLoadError = data;
            });

            $translate('BM.Components.Security.NoSecurityQuestionsSetupError').then(function(data){
                noSecurityQuestionsSetupError = data;
            });
        }

        function initializeView(){
            resetAlerts();
            vm.questions = [];

            // Create method publicly available through 2-way data bound object
            vm.sharedLocal.setQuestionsDirty = function(){
                setFormState();
            };

            // assumes user never setup any questions
            if(angular.isUndefined(initialUserQuestions)){
                initialUserQuestions = getDefaultUserQuestions();
                addAlert(noSecurityQuestionsSetupError, 'danger');
            } else {
                // Note: These characters in javascript seem bad
                answerInitValue = '●●●●●●●●●●●●●●●●●●●●';
            }

            if(angular.isUndefined(masterQuestions) || initialUserQuestions.length === 0){
                addAlert(loadSecurityQuestionsError, 'danger');
                return;
            }

            vm.questions = getBindableData(angular.copy(initialUserQuestions));
            filterMasterQuestions();
        }

        function getDefaultUserQuestions(){
            return [
                { questionId: '', question: '', answer: '' },
                { questionId: '', question: '', answer: '' },
                { questionId: '', question: '', answer: '' }
            ];
        }

        function saveQuestions(){
            resetAlerts();

            // Just make sure
            if(angular.isUndefined(vm.questions) || vm.questions.length === 0){
                addAlert(entryDataLoadError, 'danger');
                return;
            }

            var isFormValid = validateFormEntry(vm.questions);

            if(!isFormValid){
                // Note: Validation messages will be set when isFormValid is processed
                var alert = '';
                 $translate('BM.Components.IncompleteForm').then(function(data){
                    alert = data;
                    addAlert(alert, 'danger');
                });
                return;
            }

            var questionsToSave = getSaveData(angular.copy(vm.questions));

            $scope.$emit('bm-busy-loading-on');
            SecurityQuestionsFactory.saveQuestions(questionsToSave).then(function(){
                $scope.$emit('bm-busy-loading-off');
                vm.sharedLocal.hasUnsavedQuestions = false;
                initialUserQuestions = angular.copy(vm.questions);
                $translate('bm.header.viewProfile.questions.saveSuccessful').then(function(value){
                    addAlert(value, 'success');
                });
            }, function(){
                $scope.$emit('bm-busy-loading-off');
                $translate('BM.Components.IncorrectSecurityQuestion').then(function(value){
                    addAlert(value, 'danger');
                });
            });
        }

        function cancelQuestions(){
            if(vm.sharedLocal.resetOnCancel){
                initializeView();
                setFormState();
            }

            $scope.$emit('bmProfileCancelAction');
        }

        function processQuestionSelect(listIndex, question){
            validateQuestion(question);

            // Answer is required if question is changed in a list
            if(angular.isUndefined(question) || angular.isUndefined(question.answer) || question.answer === answerInitValue){
                question.answer = '';
            }

            // Filter the master questions list for each question
            filterMasterQuestions(listIndex);
        }

        function filterMasterQuestions(listIndex){
            // listIndex = <select> list that the value was changed in
            // Need to filter selected questions out of other master lists so the same question can't be selected twice
            var currentQuestionList;

            for(questionCounter = 0; questionCounter < vm.questions.length; questionCounter++){
                // Don't need skip the list that was just selected
                if(angular.isDefined(listIndex) && questionCounter === listIndex){
                    continue;
                }

                // Get a filtered list
                currentQuestionList = angular.copy(masterQuestions);
                currentQuestionList = currentQuestionList.filter(notAlreadySelected);

                // The first time through will not have a master list of questions
                if(angular.isUndefined(vm.questions[questionCounter].masterList)){
                    vm.questions[questionCounter].masterList = currentQuestionList;
                    continue;
                }

                var removeCounter = vm.questions[questionCounter].masterList.length;
                var questionIdAsInt = parseInt(vm.questions[questionCounter].selectedQuestion.questionId);

                // Clear the existing array without creating a new array object as this will kill scope
                while(removeCounter > 0){
                    removeCounter--;
                    // Don't clear the selected question
                    if(vm.questions[questionCounter].masterList[removeCounter].questionId === questionIdAsInt){
                        continue;
                    }

                    vm.questions[questionCounter].masterList.splice(removeCounter, 1);
                }

                // Append to the array without creating a new array object
                for(var addCounter = 0; addCounter < currentQuestionList.length; addCounter++){
                    if(currentQuestionList[addCounter].questionId === questionIdAsInt){
                        continue;
                    }

                    if(currentQuestionList[addCounter].questionId < questionIdAsInt){
                        vm.questions[questionCounter].masterList.unshift(currentQuestionList[addCounter]);
                    } else {
                        vm.questions[questionCounter].masterList.push(currentQuestionList[addCounter]);
                    }
                }
            }
        }

        function notAlreadySelected(element){
            var alreadySelected = false;
            var questionIdAsInt;

            for(var counter = 0; counter < vm.questions.length; counter++){
                if(alreadySelected){
                    break;
                }

                if(vm.questions[counter].selectedQuestion === null){
                    continue;
                }

                questionIdAsInt = parseInt(vm.questions[counter].selectedQuestion.questionId);
                // questionCounter is global and represents the current list being filtered
                alreadySelected = (element.questionId === questionIdAsInt && questionIdAsInt !== vm.questions[questionCounter].selectedQuestion.questionId);
            }

            return !alreadySelected;
        }

        function clearDefaultAnswer(question){
            if(question.answer === answerInitValue){
                question.answer = '';
            }
        }

        function validateFormEntry(questions){
            var isValid = true;

            angular.forEach(questions, function(question){
                validateQuestion(question);
                validateAnswer(question);

                if(question.questionError !== '' || question.answerError !== ''){
                    isValid = false;
                }
            });

            return isValid;
        }

        function validateQuestion(question){
            if(angular.isUndefined(question)){
                question.questionError = selectQuestionError;
                return;
            }

            if(angular.isUndefined(question) || question.selectedQuestion === null || angular.isUndefined(question.selectedQuestion) || question.selectedQuestion.questionId === ''){
                question.questionError = selectQuestionError;
                return;
            }

            // set unloaded question to the selected question
            if(question.questionId === ''){
                question.questionId = question.selectedQuestion.questionId;
                question.question = question.selectedQuestion.question;
            }

            question.questionError = '';
        }

        function validateAnswer(question){
            if(angular.isUndefined(question) || angular.isUndefined(question.answer) || question.answer === ''){
                question.answerError = enterAnswerError;
                return;
            }

            question.answerError = '';
        }

        function getBindableData(questions){
            angular.forEach(questions, function(question){
                question.answer = answerInitValue;
                question.answerError = '';
                question.questionError = '';

                // Store the selected question separately for the model
                // http://stackoverflow.com/questions/28133187/angularjs-select-cleared-after-selecting-value
                if(angular.isUndefined(question.selectedQuestion)){
                    question.selectedQuestion = question;
                }
            });

            return questions;
        }

        function getSaveData(questionList){
            var questionsToSave = {};
            var questions = [];

            angular.forEach(questionList, function(saveQuestion, index){
                if(angular.isUndefined(saveQuestion.selectedQuestion)){
                    questions.push({
                        questionId: saveQuestion.questionId,
                        question: saveQuestion.question,
                        answer: saveQuestion.answer
                    });
                } else {
                    questions.push({
                        questionId: parseInt(saveQuestion.selectedQuestion.questionId),
                        question: getQuestionTextFromId(saveQuestion.selectedQuestion.questionId),
                        answer: (saveQuestion.answer === answerInitValue) ? initialUserQuestions[index].answer : saveQuestion.answer
                    });
                }
            });

            questionsToSave.questions = questions;
            return questionsToSave;
        }

        function getQuestionTextFromId(questionId){
            var questionText;

            for(var counter = 0; counter < masterQuestions.length; counter++){
                if(parseInt(questionId) === masterQuestions[counter].questionId){
                    questionText = masterQuestions[counter].question;
                    break;
                }
            }

            return questionText;
        }

        function addAlert(message, type){
            resetAlerts();
            vm.alerts.push({ msg: message, type: type });
        }

        function resetAlerts(){
            vm.alerts = [];
        }

        function setFormState(){
            // Is the form valid?
            var isFormValid = validateFormEntry(vm.questions);

            if(!isFormValid){
                vm.sharedLocal.hasUnsavedQuestions = true;
                return;
            }

            var saveData = getSaveData(vm.questions);
            var initialData = getSaveData(initialUserQuestions);
            var isClean = angular.equals(saveData, initialData);

            if(isClean){
                resetAlerts();
            }

            vm.sharedLocal.hasUnsavedQuestions = !isClean;
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.securityQuestions').factory('SecurityQuestionsFactory', securityQuestionsFactory);
    securityQuestionsFactory.$inject = ['$q','$http', 'AuthenticatedSessionData', 'bmHttpCacheHelper'];

    function securityQuestionsFactory($q, $http, authenticatedSessionData, bmHttpCacheHelper){
        var factory = {
            getSecurityQuestions: getSecurityQuestions,
            getUserSecurityQuestions: getUserSecurityQuestions,
            getMyUserSecurityQuestions: getMyUserSecurityQuestions,
            saveQuestions: saveQuestions
        };

        var questionsApi = '/api/profiles/v1/security-questions';

        // cache for 10 minutes
        var baseHttpConfig = {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Compress-Data': 'true',
                'Accept': 'application/json'
            },
            bmCache: 600000
        };

        return factory;

        //////////

        function getUserSecurityQuestions(emailAddress){
            if(angular.isUndefined(emailAddress)){
                var deferred = $q.defer();
                deferred.reject();
                return deferred.promise;
            }

            var apiUrl = questionsApi + '/' + emailAddress;
            return $http.get(apiUrl, baseHttpConfig);
        }

        function getMyUserSecurityQuestions(){
            var myEmail = angular.isDefined(authenticatedSessionData.meta) ? authenticatedSessionData.meta.EmailAddress : undefined;

            return getUserSecurityQuestions(myEmail);
        }

        function getSecurityQuestions(){
            return $http.get(questionsApi, baseHttpConfig);
        }

        function saveQuestions(questions){
            return $http.put(questionsApi, questions).then(function(){
                var emailAddress = angular.isDefined(authenticatedSessionData.meta) ? authenticatedSessionData.meta.EmailAddress : undefined;

                // invalidate any user questions stored in cache
                if(angular.isDefined(emailAddress)){
                    bmHttpCacheHelper.invalidateHttpCache(questionsApi + '/' + emailAddress);
                }
            });
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.securityQuestions').directive('bmSecurityQuestions', [function(){
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'security-questions/security-questions.2js.html',
            scope: {
                master: '=',
                userQuestions: '=',
                sharedData: '='
            },
            controller: 'SecurityQuestionsCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }]);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmViewProfile', [
        'ui.bootstrap',
        'pascalprecht.translate',
        'bmPermission',
        'bluemoon.myAccount',
        'bluemoon.securityQuestions',
        'bluemoon.updatePassword',
        'bmCheckpointCredentials',
        'bmMultifactorProfile',
        'bmLinkedAccounts'
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmViewProfile').controller('bmViewProfileCtrl', bmViewProfileCtrl);
    bmViewProfileCtrl.$inject = ['$scope', '$translate', '$uibModalInstance', 'languages', 'user'];

    function bmViewProfileCtrl($scope, $translate, $uibModalInstance, languages, user){
        /*jshint validthis:true */
        var vm = this;
        vm.languages = languages;
        vm.user = user;

        // object used to share methods between profile directives
        vm.sharedProfile = {};

        vm.closeProfile = closeProfile;
        vm.tabDeselect = tabDeselect;
        vm.tabSelect = tabSelect;

        $scope.$on('bmLanguageChangeSuccess', loadTranslations);
        $scope.$on('bmProfileCancelAction', function(){
            closeProfile();
        });

        loadTranslations();

        //////////

        function loadTranslations(){
            $translate('bm.header.viewProfile.unsavedChanges').then(function(value){
                vm.translatedUnsaved = value;
            }, function(){
                vm.translatedUnsaved = 'Unsaved Changes';
            });
        }

        function closeProfile(){
            $uibModalInstance.dismiss('close');
        }

        function tabSelect(whichTab){
            switch(whichTab){
                case 'linkedAccounts':
                    vm.sharedProfile.refreshLinkedAccounts();
                    break;
                default:
                    break;
            }
        }

        function tabDeselect(whichTab){
            switch(whichTab){
                case 'account':
                    vm.sharedProfile.setAccountDirty();
                    break;
                case 'password':
                    vm.sharedProfile.setPasswordDirty();
                    break;
                case 'checkpoint':
                    vm.sharedProfile.setCheckpointDirty();
                    break;
                case 'linkedAccounts':
                    vm.sharedProfile.setLinkedAccountsDirty();
                    break;
                default:
                    break;
            }
        }
    }
})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.components.timeZoneOffsetInterceptor', [])
        .config(['$httpProvider', function ($httpProvider) {
            $httpProvider.interceptors.push('bmHttpTimeZoneOffsetInterceptor');
        }])
        .service('bmHttpTimeZoneOffsetInterceptor', function () {
            var headerKey = 'User-Time-Zone-Offset-Minutes';
            this.request = function (conf) {
                if (!conf.headers[headerKey]) {
                    conf.headers[headerKey] = new Date().getTimezoneOffset();
                }
                return conf;
            };
        });
})(window.angular);

(function(angular) {
    'use strict';

    /*
     *  bmFormatOnBlur
     *
     *  Requires: ngModel
     *
     *  Scope type: none
     *
     *  Description:
     *  Binds to the blur event and works with ngModel to reformat the view value after a blur. Useful in cases where
     *  a value converter directive accepts multiple input formats that are different from the output format (e.g. dates).
     */
    angular.module('bmFormatOnBlur', ['bento.services'])
        .directive('bmFormatOnBlur', ['$bentoServices',
            function($bentoServices) {
                return {
                    require: 'ngModel',
                    priority: 10,
                    link: function($scope, element, attrs, ctrl) {
                        // when we lose focus, revert to old value if new value is invalid,
                        // then reformat the view.
                        element.bind('blur', function() {
                            $bentoServices.safeApply($scope, angular.noop);

                            // re-run the formatter chain on the $modelValue
                            if(!ctrl.$invalid) {
                                ctrl.$viewValue = ctrl.$modelValue;
                                for(var i = ctrl.$formatters.length - 1; i >= 0; i = i - 1) {
                                    ctrl.$viewValue = ctrl.$formatters[i](ctrl.$viewValue);
                                }

                                // re-render the view
                                ctrl.$render();
                            }
                        });
                    }
                };
    }]);

}(window.angular));

(function(angular){
    'use strict';

    angular.module('bmLinkedAccounts', ['bento.modern', 'LinkedAccountsService', 'wj']);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bmLinkedAccounts').controller('LinkedAccountsCtrl', LinkedAccountsCtrl);
	LinkedAccountsCtrl.$inject = ['$scope', '$translate', '$bentoBusyLoader', 'LinkedAccountsService'];

	function LinkedAccountsCtrl($scope, $translate, $bentoBusyLoader, LinkedAccountsService){
        /*jshint validthis:true */
		var vm = this;

		this.$onInit = function(){
			vm.saveLinkedAccounts = saveLinkedAccounts;
			vm.cancelLinkedAccounts = cancelLinkedAccounts;
			vm.defaultChanged = defaultChanged;

			vm.linkedAccounts = [];
			vm.gridData = [];
			vm.alerts = [];
			vm.linkedAccountsSummaryMsg = '';
			vm.selectedDefaultLinkAccountId = '0';
			vm.flexgrid = undefined;
			vm.hasOneAccount = false;
			vm.showAccounts = true;
			vm.isLoaderBusy = false;

			// 2-way bound data object to pass information between tabs
			vm.sharedLocal = vm.sharedData;
			vm.sharedLocal.hasUnsavedLinkedAccounts = false;

			initializeView();
		};

		function initializeView() {
			resetAlerts();

			// Create method publicly available through 2-way data bound object
			vm.sharedLocal.setLinkedAccountsDirty = function(){
				setFormState();
			};

			vm.sharedLocal.refreshLinkedAccounts = function(){
				if(vm.linkedAccounts.length === 0) {
					loadData();
				}
			};

			// Only used when it's called in a dialog by itself. It will not when called when viewing profile.
			if(vm.sharedLocal.loadLinkedAccounts) {
				loadData();
			}
		}

		function loadData() {
			// Make sure the user was resolved
			if(angular.isUndefined(vm.user) || vm.user === ''){
				$translate('BM.Components.AccountInformation.LoadError').then(function(alert){
					addAlert(alert, 'danger');
				});

				return;
			} else {
				loadLinkedAccounts();
			}
		}

		function loadLinkedAccounts() {
			vm.isLoaderBusy = true;
			LinkedAccountsService.getActiveOnvioLinkedAccounts().then(function(response){
				vm.linkedAccounts = response.data;

				// if no accounts, do not show grid
				if(vm.linkedAccounts && vm.linkedAccounts.length < 1) {
					vm.showAccounts = false;
				}

				// if only one account, disable active and default values
				if(vm.linkedAccounts && vm.linkedAccounts.length < 2) {
					vm.hasOneAccount = true;
				}

				// find the default account
				for(var pos1 = 0; pos1 < vm.linkedAccounts.length; pos1++) {
					var someLinkedAccount = vm.linkedAccounts[pos1];
					if(someLinkedAccount.home) {
						vm.selectedDefaultLinkAccountId = someLinkedAccount.linkedAccountId;
					}

					if(!someLinkedAccount.displayedNickname || someLinkedAccount.displayedNickname === '') {
						vm.linkedAccounts[pos1].displayedNickname = '';
					}
				}

				vm.gridData = vm.linkedAccounts;
				vm.gridData = new wijmo.collections.CollectionView(vm.gridData);  // jshint ignore: line
				vm.gridData.trackChanges = true;
				vm.isLoaderBusy = false;

			}).catch(function(error){
				addAlert(error.message, 'danger');
				vm.isLoaderBusy = false;
				console.log(error);
			});
		}

		function addAlert(message, type){
			resetAlerts();

			var alert = { msg: message, type: type, closeable: true };
			vm.alerts.push(alert);
		}

		function resetAlerts(){
			vm.alerts = [];
		}

		function convertToJson(itemsEdited) {
			var jsonObject = {
				linkedAccountsToUpdate : []
			};

			for(var pos = 0; pos < itemsEdited.length; pos++) {
				var item = itemsEdited[pos];
				jsonObject.linkedAccountsToUpdate.push(item);
			}

			return jsonObject;
		}

		function saveLinkedAccounts() {
			resetAlerts();

			var items = vm.gridData.items;
			var itemsEdited = vm.gridData.itemsEdited;

			// Check for edited items
			if(itemsEdited && itemsEdited.length > 0) {
				// check to make sure all items are valid
				if(hasValidData(items)) {
					// conver to json
					var jsonAccounts = convertToJson(itemsEdited);

					vm.isLoaderBusy = true;
					LinkedAccountsService.updateLinkedAccounts(jsonAccounts).then(function(){
						vm.isLoaderBusy = false;
						$translate('bm.components.linkedAccounts.updateSuccsessful').then(function(msg){
							addAlert(msg, 'success');
						});
					}).catch(function(error){
						vm.isLoaderBusy = false;
						console.log(error);
					});
				}
			}
		}

		function hasValidData(items) {
			var isValid = true;

			if(!hasActiveAccount(items)) {
				isValid = false;
				$translate('bm.components.linkedAccounts.missingActive').then(function(msg){
						addAlert(msg, 'danger');
				}, function() {
					addAlert('Bad translation: You must have at least one active account selected.', 'danger');
				});
			} else if(!hasActiveHomeAccount(items)) {
				isValid = false;
				$translate('bm.components.linkedAccounts.missingActiveHome').then(function(msg){
						addAlert(msg, 'danger');
				}, function() {
					addAlert('Bad translation: You must have an active account marked as home.', 'danger');
				});
			} else if(!hasValidNickname(items)) {
				isValid = false;
				$translate('bm.components.linkedAccounts.invalidNickname').then(function(msg){
						addAlert(msg, 'danger');
				}, function() {
					addAlert('Bad translation: The nickname must be less then 50 characters.', 'danger');
				});

			}
			return isValid;
		}

		function hasActiveAccount(items) {
			var hasOneActiveAccount = false;
			for(var pos = 0; pos < items.length; pos++) {
				if(items[pos].active) {
					hasOneActiveAccount = true;
				}
			}

			return hasOneActiveAccount;
		}

		function hasActiveHomeAccount(items) {
			var activeHomeAccount = false;
			for(var pos = 0; pos < items.length; pos++) {
				if(items[pos].active && items[pos].home) {
					activeHomeAccount = true;
				}
			}

			return activeHomeAccount;
		}

		function hasValidNickname(items) {
			var validNickname = true;
			for(var pos = 0; pos < items.length; pos++) {
				if(items[pos].displayedNickname && items[pos].displayedNickname.length > 50) {
					validNickname = false;
				}
			}

			return validNickname;
		}

		function cancelLinkedAccounts() {
			if(vm.sharedLocal.resetOnCancel) {
				initializeView();
				setFormState();
			}
			resetAlerts();
			$scope.$emit('bmProfileCancelAction');
		}

		function setFormState(){
			var hasChanges = false;

			if(!angular.isUndefined(vm.gridData.itemsEdited)) {
				if(vm.gridData.itemsEdited.length > 0) {
					hasChanges = true;
				}
			}

			if(hasChanges){
				vm.linkedAccountsForm.$setDirty();
			} else {
				resetAlerts();
			}

			vm.sharedLocal.hasUnsavedLinkedAccounts = hasChanges;
		}

		$scope.$watch('selectedDefaultLinkAccountId', function() {
			defaultChanged();
		});

		function defaultChanged() {
			if(vm.flexgrid && (vm.selectedDefaultLinkAccountId !== 0)) {
				var cv = vm.flexgrid.collectionView;
				for(var pos = 0; pos < cv.items.length; pos++) {
					var item = cv.items[pos];
					if((item.linkedAccountId === vm.selectedDefaultLinkAccountId) && (!item.home)) {
						cv.editItem(cv.items[pos]);
						cv.items[pos].home = true;
						cv.items[pos].active = true;
						cv.commitEdit();
						cv.refresh();
					} else if((item.linkedAccountId !== vm.selectedDefaultLinkAccountId) && (item.home)) {
						cv.editItem(cv.items[pos]);
						cv.items[pos].home = false;
						cv.commitEdit();
						cv.refresh();
					}
				}
			}
		}
	}
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmLinkedAccounts').directive('bmLinkedAccounts', bmLinkedAccounts);
    bmLinkedAccounts.$inject = [];

    function bmLinkedAccounts(){
        return {
            restrict: 'EA',
            templateUrl: 'components/linked-accounts/linked-accounts.2js.html',
            scope: {
                user: '=',
                sharedData: '='
            },
            controller: 'LinkedAccountsCtrl',
            controllerAs: 'vm',
            bindToController: true,
            replace: true
        };
    }
})(window.angular);

(function(angular){
  'use strict';

  angular.module('LinkedAccountsService', []).service('LinkedAccountsService', LinkedAccountsService);

  LinkedAccountsService.$inject = ['$q', '$http'];
  function LinkedAccountsService($q, $http){
    /*jshint validthis:true */
    var self = this;
	var linkedAccountsApi = '/api/profiles/v1/accounts';
	var linkedAccountsSessionApi = '/api/security/v2/sessions/accounts';
	var linkExistingAccountApi = '/api/profiles/v1/accounts/merge';

    self.getLinkedAccounts = getLinkedAccounts;
	self.getActiveLinkedAccounts = getActiveLinkedAccounts;
    self.getActiveOnvioLinkedAccounts = getActiveOnvioLinkedAccounts;
    self.updateLinkedAccounts = updateLinkedAccounts;
	self.createLinkedAccountSession = createLinkedAccountSession;
	self.linkExistingAccount = linkExistingAccount;
    self.linkExistingAccountWithLogin = linkExistingAccountWithLogin;

	function getLinkedAccounts() {
		// no need to send the bluid, it will be retrieved from
		return $http({
			method: 'GET',
			url: linkedAccountsApi,
			headers: {'Accept': 'application/json'}
		});
	}

	function getActiveLinkedAccounts() {
		var linkedAccountsUrl = linkedAccountsApi + '?active=true';
		return $http({
			method: 'GET',
			url: linkedAccountsUrl,
			headers: {'Accept': 'application/json'}
		});
	}

	function getActiveOnvioLinkedAccounts() {
        var linkedAccountsUrl = linkedAccountsApi + '?active=true&hideNonOnvio=true';
        return $http({
            method: 'GET',
            url: linkedAccountsUrl,
            headers: {'Accept': 'application/json'}
        });
    }

	function updateLinkedAccounts(linkedAccounts){
		return $http({
			method: 'PUT',
			url: linkedAccountsApi,
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			data: linkedAccounts.linkedAccountsToUpdate
		});
	}

	function createLinkedAccountSession(linkedAcccountId) {
		var apiUrl = linkedAccountsSessionApi + '/' + linkedAcccountId;
		return $http({
			method: 'POST',
			url: apiUrl,
			headers: {'Accept': 'application/json'}
		});
	}

	function linkExistingAccount(bluid) {
		var config = {
			method: 'PUT',
			url: linkExistingAccountApi + '/' + bluid,
		};
		return $http(config);
	}

    function linkExistingAccountWithLogin(email) {
        var config = {
            method: 'PUT',
            url: linkExistingAccountApi + '?login=' + encodeURIComponent(email)
        };

        return $http(config).then(
            function(resp) {
                var defer = $q.defer();
                defer.resolve(resp);
                return defer.promise;
            },
            function(resp) {
                resp.config.global = false;
                return $q.reject(resp);
            }
        );
    }

  }
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bmLinkedAccounts').controller('LinkedAccountsDialogCtrl', LinkedAccountsDialogCtrl);
	LinkedAccountsDialogCtrl.$inject = ['$scope', '$uibModalInstance', 'user', 'sharedProfile' ];

	function LinkedAccountsDialogCtrl($scope, $uibModalInstance, user, sharedProfile){
		/*jshint validthis:true */
		var vm = this;

		vm.user = undefined;
		vm.sharedProfile = {};

		vm.user = user;
		vm.sharedProfile = sharedProfile;
		vm.sharedProfile.loadLinkedAccounts = true;
		vm.closeDialog = closeDialog;

        $scope.$on('bmProfileCancelAction', function(){
            closeDialog();
        });

        function closeDialog(){
            $uibModalInstance.dismiss('close');
        }
	}
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmPreviewTrialWidget', []);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmPreviewTrialWidget').component('previewTrialWidget', {
        templateUrl: 'components/preview-trial-widget/preview-trial-widget.2js.html',
        controller: previewTrialWidgetCtrl,
        controllerAs: 'vm'
    });

    previewTrialWidgetCtrl.$inject = ['previewTrialService', '$translate', '$q', 'bmUtil', 'bmPermission'];
    function previewTrialWidgetCtrl(previewTrialService, $translate, $q, bmUtil, bmPermission) {
        /*jshint validthis:true */
        var vm = this;

        vm.$onInit = onInit;
        function onInit(){
            vm.days = ''; // fall back for 404 error on ProvisioningServices trial api
            vm.lang = getLang();
            bmPermission.has('Platform.Trial').then(function() {
                getRemainingDays().then(function(days){
                    vm.days = days;
                    setMessage();
                });
            });
            bmPermission.has('Platform.PreviewMode').then(function() {
                setMessage();
            });
        }
        function setMessage() {
            bmPermission.has('Platform.Trial').then(function() {
                vm.trial = true;
                vm.modeButtonLink = '/trial/' + vm.lang + '/purchase';
            });
            bmPermission.has('Platform.PreviewMode').then(function() {
                vm.preview = true;
                vm.modeButtonLink = '/trial/' + vm.lang + '/signup';
            });
        }
        function getLang(){
            var lang = bmUtil.cookie('BMLanguageCode');
            return lang.slice(0,2);
        }
        function getRemainingDays() {
            return getTrialExpiration().then(function(expirationDate){
                var today = new Date();
                var expiration = new Date(expirationDate);
                var diff = Math.abs(expiration.getTime() - today.getTime());
                var days = Math.floor(diff / (1000 * 3600 * 24));
                return days;
            });
        }
        function getTrialExpiration(){
            return previewTrialService.getTrialExpiration().then(function(resp){
                return resp.data.expireDate;
            });
        }
    }
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bmPreviewTrialWidget').factory('previewTrialService', previewTrialService);
    previewTrialService.$inject = ['$http'];

    function previewTrialService($http) {
		var factory = {
			getTrialExpiration: getTrialExpiration
		};

		return factory;

		function getTrialExpiration() {
			return $http({
				method: 'GET',
				url: '/api/provisioning/v1/trials'
			});
		}
    }

})(window.angular);

(function (angular) {
    'use strict';

    angular.module('bluemoon.components.modal', ['ui.bootstrap', 'bento.modern']).service('bmModal', [ '$uibModal', function($uibModal) {

        /*
         * Displays a customizable modal.
         *
         * Config object properties:
         *
         * templateUrL: String, optional. Path to the template that should be used for this modal.
         *      If blank, a default template will be used that takes two variables: title and body.
         * showClose: boolean, optional. If true, a close button will be shown in the top-right corner
         *      of the modal. Defaults to true.
         * vars: Map of variables used in the modal template, available to the template as $scope.vars
         * buttons: An array of button config objects:
         *      text: String. Displayed on the button.
         *      value: Any. Supplied to handlers as an argument.
         *      dismiss: Boolean, optional. Determines button click behavior.
         *               If false, onClosed is called when this button is clicked.
         *               If true, onDismissed is called when this button is clicked.
         *               Defaults to false.
         * onClosed: function(any). A handler called when the modal is closed. Takes a button value as an argument.
         * onDismissed: function(any). A handler called when the modal is dismissed. Takes a button value as an argument.
         *
         * returns: The modal that was generated as a bento $uibModalInstance.
         */
        this.modal = function(config){

            if(!config){
                config = {};
            }

            var modal = $uibModal.open({
                templateUrl: 'components/modal/modal-base.2js.html',
                controller: ['$scope', function($scope){

                    $scope.templateUrl = (!config.templateurl ? 'components/modal/modal-default.2js.html' : config.templateUrl);
                    $scope.vars = (!angular.isObject(config.vars) ? {title: 'Default Modal Title', body: 'This is the default modal body. Your config is missing the vals object.'} : config.vars);
                    $scope.buttons = (!angular.isObject(config.buttons) ? [{text: 'Default Button', value: 'default'}] : config.buttons);
                    $scope.showClose = (!config.showClose ? true : config.showClose);

                }]
            });

            modal.result.then(
                function(result){
                    if(!!config.onClosed){
                        config.onClosed(result);
                    }
                }, function(reason){
                    if(!!config.onDismissed){
                        config.onDismissed(reason);
                    }
                }
            );

            return modal;

        };
    }]);

}(window.angular));

// Adapted from christopherthielen's qdecorator
// https://github.com/angular-ui/ui-router/issues/2889

// Prints out unhandled promise rejection stack traces to the console.
// Only works when you are not using minification (because it parses the stack traces).
// Also only tested with Chrome.

// Decorate the $q service when app starts
angular.module('bmUnhandledPromiseRejectionTracer', ['bmEnvironment'])
.decorator('$q', ['$delegate', 'bmEnvironmentConst', function($delegate, bmEnvironmentConst) {
  'use strict';

  // Pass thru if we are not in local dev mode
  if (!bmEnvironmentConst.isLocalType) { return $delegate; }

  // Create a sample promise.
  var promise = $delegate.when();

  // Access the `Promise` prototype (nonstandard, but works)
  var promisePrototoype = Object.getPrototypeOf(promise);
  var isPromisePrototype = typeof promisePrototoype === 'object' &&
    ['then', 'catch', 'finally'].reduce(function(acc, key) {
      return acc && !!promisePrototoype[key];
    }, true);

  if (isPromisePrototype) {
    // The angular $q promise implementation sets `$$state` once in its Promise constructor:
    //
    // function Promise() {
    //   this.$$state = { status: 0 };
    // }
    //
    // Hijack the promise behavior by adding a setter for `$$state` on the Promise prototype.
    // The setter is run each time a promise is created (via any method: $q.when(), promise.then(), etc).
    //
    // The setter records the stack trace in which the promise was created.
    Object.defineProperty(promisePrototoype, '$$state', {
      set: function($$state) {
        this._$$state = $$state;

        if (typeof $$state._status === 'undefined') {
          this._value = this.value;
          this._logged = false;

          // Define a getter for `Promise.$$state.value`
          // ('value' is the resolved or rejected value)
          Object.defineProperty($$state, 'value', {
            enumerable: true,
            set: function(val) {
              this._value = val;
            },
            get: function() {
              // Check if this is the "Possibly unhandled rejection" handler. return the stack trace instead
              if (this.status === 2 && this.pur && new Error().stack.includes('processChecks')) {
                if (!this._logged) {
                  this._logged = true;
                  console.error(this._value);
                }
                return this._context;
              }
              return this._value;
            },
          });
        }

        // Create an Error object and use its stack trace
        $$state._context = new Error('Possibly unhandled rejection (promise creation stack)');
      },
      get: function() {
        return this._$$state;
      },
      enumerable: true,
    });

    // Whenever promise.then() (or .catch or .finally) is called, a new promise is created.
    // Add the chained-from-promise's stack to the new promise's stack to allow analysis of the full promise chain
    var realThenFn = promisePrototoype.then;
    promisePrototoype.then = function() {
      var chainedPromise = realThenFn.apply(this, arguments);

      var prevContext = this.$$state && this.$$state._context;
      var chainedContext = chainedPromise.$$state && chainedPromise.$$state._context;

      if (chainedContext) {
        try {
          chainedContext.stack =  chainedContext.stack +
            '\nPromise Chained from:\n' +
            prevContext.stack;
        } catch (ignored) {}
      }
      return chainedPromise;
    };
  }

  return $delegate;
}]);

/***********************************************
* ng-grid JavaScript Library
* Authors: https://github.com/angular-ui/ng-grid/blob/master/README.md 
* License: MIT (http://www.opensource.org/licenses/mit-license.php)
* Compiled At: 11/04/2014 09:19
***********************************************/
(function(window, $) {
'use strict';

var EXCESS_ROWS = 6;
var SCROLL_THRESHOLD = 4;
var ASC = "asc";

var DESC = "desc";

var NG_FIELD = '_ng_field_';
var NG_DEPTH = '_ng_depth_';
var NG_HIDDEN = '_ng_hidden_';
var NG_COLUMN = '_ng_column_';
var CUSTOM_FILTERS = /CUSTOM_FILTERS/g;
var COL_FIELD = /COL_FIELD/g;
var DISPLAY_CELL_TEMPLATE = /DISPLAY_CELL_TEMPLATE/g;
var EDITABLE_CELL_TEMPLATE = /EDITABLE_CELL_TEMPLATE/g;
var CELL_EDITABLE_CONDITION = /CELL_EDITABLE_CONDITION/g;
var TEMPLATE_REGEXP = /<.+>/;
var FUNC_REGEXP = /(\([^)]*\))?$/;
var DOT_REGEXP = /\./g;
var APOS_REGEXP = /'/g;
var BRACKET_REGEXP = /^(.*)((?:\s*\[\s*\d+\s*\]\s*)|(?:\s*\[\s*"(?:[^"\\]|\\.)*"\s*\]\s*)|(?:\s*\[\s*'(?:[^'\\]|\\.)*'\s*\]\s*))(.*)$/;

window.ngGrid = {};
window.ngGrid.i18n = {};
var ngGridServices = angular.module('ngGrid.services', []);
var ngGridDirectives = angular.module('ngGrid.directives', []);
var ngGridFilters = angular.module('ngGrid.filters', []);

angular.module('ngGrid', ['ngGrid.services', 'ngGrid.directives', 'ngGrid.filters']);

var ngMoveSelectionHandler = function($scope, elm, evt, grid) {
    if ($scope.selectionProvider.selectedItems === undefined || grid.config.noKeyboardNavigation) {
        return true;
    }

    if (document.activeElement.tagName === "INPUT") {
        return true;
    }

    var charCode = evt.which || evt.keyCode,
        newColumnIndex,
        lastInRow = false,
        firstInRow = false,
        rowIndex = $scope.selectionProvider.lastClickedRow === undefined ? 1 : $scope.selectionProvider.lastClickedRow.rowIndex,
        visibleCols = $scope.columns.filter(function(c) {
             return c.visible && c.width > 0;
        }),
        pinnedCols = $scope.columns.filter(function(c) { return c.pinned; });

    if ($scope.col) {
        newColumnIndex = visibleCols.indexOf($scope.col);
    }

    if (charCode !== 37 && charCode !== 38 && charCode !== 39 && charCode !== 40 && (grid.config.noTabInterference || charCode !== 9) && charCode !== 13) {
        return true;
    }

    if ($scope.enableCellSelection) {
        if (charCode === 9) { 
            evt.preventDefault();
        }

        var focusedOnFirstColumn = $scope.showSelectionCheckbox ? newColumnIndex === 1 : newColumnIndex === 0;
        var focusedOnFirstVisibleColumns = newColumnIndex === 1 || newColumnIndex === 0;
        var focusedOnLastVisibleColumns = newColumnIndex === (visibleCols.length - 1) || newColumnIndex === (visibleCols.length - 2);
        var focusedOnLastColumn = visibleCols.indexOf($scope.col) === (visibleCols.length - 1);
        var focusedOnLastPinnedColumn = pinnedCols.indexOf($scope.col) === (pinnedCols.length - 1);

        if (charCode === 37 || charCode === 9 && evt.shiftKey) {
            var scrollTo = 0;

            if (!focusedOnFirstColumn) {
                newColumnIndex -= 1;
            }

            if (focusedOnFirstVisibleColumns) {
                if (focusedOnFirstColumn && charCode === 9 && evt.shiftKey){
                    scrollTo = grid.$canvas.width();
                    newColumnIndex = visibleCols.length - 1;
                    firstInRow = true;
                }
                else {
                    scrollTo = grid.$viewport.scrollLeft() - $scope.col.width;
                }
            }
            else if (pinnedCols.length > 0) {
                scrollTo = grid.$viewport.scrollLeft() - visibleCols[newColumnIndex].width;
            }

            grid.$viewport.scrollLeft(scrollTo);

        }
        else if (charCode === 39 || charCode ===  9 && !evt.shiftKey) {
            if (focusedOnLastVisibleColumns) {
                if (focusedOnLastColumn && charCode ===  9 && !evt.shiftKey) {
                    grid.$viewport.scrollLeft(0);
                    newColumnIndex = $scope.showSelectionCheckbox ? 1 : 0;
                    lastInRow = true;
                }
                else {
                    grid.$viewport.scrollLeft(grid.$viewport.scrollLeft() + $scope.col.width);
                }
            }
            else if (focusedOnLastPinnedColumn) {
                grid.$viewport.scrollLeft(0);
            }

            if (!focusedOnLastColumn) {
                newColumnIndex += 1;
            }
        }
    }

    var items;
    if ($scope.configGroups.length > 0) {
        items = grid.rowFactory.parsedData.filter(function (row) {
            return !row.isAggRow;
        });
    }
    else {
        items = grid.filteredRows;
    }

    var offset = 0;
    if (rowIndex !== 0 && (charCode === 38 || charCode === 13 && evt.shiftKey || charCode === 9 && evt.shiftKey && firstInRow)) { 
        offset = -1;
    }
    else if (rowIndex !== items.length - 1 && (charCode === 40 || charCode === 13 && !evt.shiftKey || charCode === 9 && lastInRow)) {
        offset = 1;
    }

    if (offset) {
        var r = items[rowIndex + offset];
        if (r.beforeSelectionChange(r, evt)) {
            r.continueSelection(evt);
            $scope.$emit('ngGridEventDigestGridParent');

            if ($scope.selectionProvider.lastClickedRow.renderedRowIndex >= $scope.renderedRows.length - EXCESS_ROWS - 2) {
                grid.$viewport.scrollTop(grid.$viewport.scrollTop() + $scope.rowHeight);
            }
            else if ($scope.selectionProvider.lastClickedRow.renderedRowIndex <= EXCESS_ROWS + 2) {
                grid.$viewport.scrollTop(grid.$viewport.scrollTop() - $scope.rowHeight);
            }
      }
    }

    if ($scope.enableCellSelection) {
        setTimeout(function(){
            $scope.domAccessProvider.focusCellElement($scope, $scope.renderedColumns.indexOf(visibleCols[newColumnIndex]));
        }, 3);
    }

    return false;
};

if (!String.prototype.trim) {
    String.prototype.trim = function() {
        return this.replace(/^\s+|\s+$/g, '');
    };
}
if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function(elt ) {
        var len = this.length >>> 0;
        var from = Number(arguments[1]) || 0;
        from = (from < 0) ? Math.ceil(from) : Math.floor(from);
        if (from < 0) {
            from += len;
        }
        for (; from < len; from++) {
            if (from in this && this[from] === elt) {
                return from;
            }
        }
        return -1;
    };
}
if (!Array.prototype.filter) {
    Array.prototype.filter = function(fun ) {
        "use strict";
        var t = Object(this);
        var len = t.length >>> 0;
        if (typeof fun !== "function") {
            throw new TypeError();
        }
        var res = [];
        var thisp = arguments[1];
        for (var i = 0; i < len; i++) {
            if (i in t) {
                var val = t[i]; 
                if (fun.call(thisp, val, i, t)) {
                    res.push(val);
                }
            }
        }
        return res;
    };
}
ngGridFilters.filter('checkmark', function() {
    return function(input) {
        return input ? '\u2714' : '\u2718';
    };
});
ngGridFilters.filter('ngColumns', function() {
    return function(input) {
        return input.filter(function(col) {
            return !col.isAggCol;
        });
    };
});
angular.module('ngGrid.services').factory('$domUtilityService',['$utilityService', '$window', function($utils, $window) {
    var domUtilityService = {};
    var regexCache = {};
    var getWidths = function() {
        var $testContainer = $('<div></div>');
        $testContainer.appendTo('body');
        $testContainer.height(100).width(100).css("position", "absolute").css("overflow", "scroll");
        $testContainer.append('<div style="height: 400px; width: 400px;"></div>');
        domUtilityService.ScrollH = ($testContainer.height() - $testContainer[0].clientHeight);
        domUtilityService.ScrollW = ($testContainer.width() - $testContainer[0].clientWidth);
        $testContainer.empty();
        $testContainer.attr('style', '');
        $testContainer.append('<span style="font-family: Verdana, Helvetica, Sans-Serif; font-size: 14px;"><strong>M</strong></span>');
        domUtilityService.LetterW = $testContainer.children().first().width();
        $testContainer.remove();
    };
    domUtilityService.eventStorage = {};
    domUtilityService.AssignGridContainers = function($scope, rootEl, grid) {
        grid.$root = $(rootEl);
        grid.$topPanel = grid.$root.find(".ngTopPanel");
        grid.$groupPanel = grid.$root.find(".ngGroupPanel");
        grid.$headerContainer = grid.$topPanel.find(".ngHeaderContainer");
        $scope.$headerContainer = grid.$headerContainer;

        grid.$headerScroller = grid.$topPanel.find(".ngHeaderScroller");
        grid.$headers = grid.$headerScroller.children();
        grid.$viewport = grid.$root.find(".ngViewport");
        grid.$canvas = grid.$viewport.find(".ngCanvas");
        grid.$footerPanel = grid.$root.find(".ngFooterPanel");

        var scopeDereg = $scope.$watch(function () {
            return grid.$viewport.scrollLeft();
        }, function (newLeft) {
            return grid.$headerContainer.scrollLeft(newLeft);
        });

        $scope.$on('$destroy', function() {
            if(grid.$root) {
                $(grid.$root.parent()).off('resize.nggrid');

                grid.$root = null;
                grid.$topPanel = null;
                grid.$headerContainer = null;
                grid.$headers = null;
                grid.$canvas = null;
                grid.$footerPanel = null;
            }

            scopeDereg();
        });

        domUtilityService.UpdateGridLayout($scope, grid);
    };
    domUtilityService.getRealWidth = function (obj) {
        var width = 0;
        var props = { visibility: "hidden", display: "block" };
        var hiddenParents = obj.parents().andSelf().not(':visible');
        $.swap(hiddenParents[0], props, function () {
            width = obj.outerWidth();
        });
        return width;
    };
    domUtilityService.UpdateGridLayout = function($scope, grid) {
        if (!grid.$root){
            return;
        }
        var scrollTop = grid.$viewport.scrollTop();
        grid.elementDims.rootMaxW = grid.$root.width();
        if (grid.$root.is(':hidden')) {
            grid.elementDims.rootMaxW = domUtilityService.getRealWidth(grid.$root);
        }
        grid.elementDims.rootMaxH = grid.$root.height();
        grid.refreshDomSizes();
        $scope.adjustScrollTop(scrollTop, true); 
    };
    domUtilityService.numberOfGrids = 0;
    domUtilityService.setStyleText = function(grid, css) {
        var style = grid.styleSheet,
            gridId = grid.gridId,
            doc = $window.document;

        if (!style) {
            style = doc.getElementById(gridId);
        }
        if (!style) {
            style = doc.createElement('style');
            style.type = 'text/css';
            style.id = gridId;
            (doc.head || doc.getElementsByTagName('head')[0]).appendChild(style);
        }

        if (style.styleSheet && !style.sheet) {
            style.styleSheet.cssText = css;
        } else {
            style.innerHTML = css;
        }
        grid.styleSheet = style;
        grid.styleText = css;
    };
    domUtilityService.BuildStyles = function($scope, grid, digest) {
        var rowHeight = grid.config.rowHeight,
            gridId = grid.gridId,
            css,
            cols = $scope.columns,
            sumWidth = 0;

        var trw = $scope.totalRowWidth();
        css = "." + gridId + " .ngCanvas { width: " + trw + "px; }" +
            "." + gridId + " .ngRow { width: " + trw + "px; }" +
            "." + gridId + " .ngCanvas { width: " + trw + "px; }" +
            "." + gridId + " .ngHeaderScroller { width: " + (trw + domUtilityService.ScrollH) + "px}";

        for (var i = 0; i < cols.length; i++) {
            var col = cols[i];
            if (col.visible !== false) {
                var rightPad = 0;
                if ((i === cols.length - 1) && (sumWidth + col.width < grid.elementDims.rootMaxW)) {
                    rightPad = grid.elementDims.rootMaxW - sumWidth - col.width;
                }
                css += "." + gridId + " .col" + i + " { width: " + (col.width + rightPad) + "px; left: " + sumWidth + "px; height: " + rowHeight + "px }" +
                    "." + gridId + " .colt" + i + " { width: " + (col.width + rightPad) + "px; }";
                sumWidth += col.width;
            }
        }
        domUtilityService.setStyleText(grid, css);

        $scope.adjustScrollLeft(grid.$viewport.scrollLeft());
        if (digest) {
            domUtilityService.digest($scope);
        }
    };
    domUtilityService.setColLeft = function(col, colLeft, grid) {
        if (grid.styleText) {
            var regex = regexCache[col.index];
            if (!regex) {
                regex = regexCache[col.index] = new RegExp(".col" + col.index + " { width: [0-9]+px; left: [0-9]+px");
            }
            var css = grid.styleText.replace(regex, ".col" + col.index + " { width: " + col.width + "px; left: " + colLeft + "px");
            domUtilityService.setStyleText(grid, css);
        }
    };
    domUtilityService.setColLeft.immediate = 1;
    domUtilityService.RebuildGrid = function($scope, grid){
        domUtilityService.UpdateGridLayout($scope, grid);
        if (grid.config.maintainColumnRatios == null || grid.config.maintainColumnRatios) {
            grid.configureColumnWidths();
        }
        $scope.adjustScrollLeft(grid.$viewport.scrollLeft());
        domUtilityService.BuildStyles($scope, grid, true);
    };

    domUtilityService.digest = function($scope) {
        if (!$scope.$root.$$phase) {
            $scope.$digest();
        }
    };
    domUtilityService.ScrollH = 17; 
    domUtilityService.ScrollW = 17; 
    domUtilityService.LetterW = 10;
    getWidths();
    return domUtilityService;
}]);

angular.module('ngGrid.services').factory('$sortService', ['$parse', '$utilityService', function($parse, $utils) {
    var sortService = {};
    sortService.colSortFnCache = {}; 
    sortService.isCustomSort = false;
    sortService.guessSortFn = function(item) {
        var itemType = typeof(item);
        switch (itemType) {
            case "number":
                return sortService.sortNumber;
            case "boolean":
                return sortService.sortBool;
            case "string":
                return item.match(/^[-+]?[£$¤]?[\d,.]+%?$/) ? sortService.sortNumberStr : sortService.sortAlpha;
            default:
                if (Object.prototype.toString.call(item) === '[object Date]') {
                    return sortService.sortDate;
                }
                else {
                    return sortService.basicSort;
                }
        }
    };
    sortService.basicSort = function(a, b) {
        if (a === b) {
            return 0;
        }
        if (a < b) {
            return -1;
        }
        return 1;
    };
    sortService.sortNumber = function(a, b) {
        return a - b;
    };
    sortService.sortNumberStr = function(a, b) {
        var numA, numB, badA = false, badB = false;
        numA = parseFloat(a.replace(/[^0-9.-]/g, ''));
        if (isNaN(numA)) {
            badA = true;
        }
        numB = parseFloat(b.replace(/[^0-9.-]/g, ''));
        if (isNaN(numB)) {
            badB = true;
        }
        if (badA && badB) {
            return 0;
        }
        if (badA) {
            return 1;
        }
        if (badB) {
            return -1;
        }
        return numA - numB;
    };
    sortService.sortAlpha = function(a, b) {
        var strA = a.toLowerCase(),
            strB = b.toLowerCase();
        return strA === strB ? 0 : (strA < strB ? -1 : 1);
    };
    sortService.sortDate = function(a, b) {
        var timeA = a.getTime(),
            timeB = b.getTime();
        return timeA === timeB ? 0 : (timeA < timeB ? -1 : 1);
    };
    sortService.sortBool = function(a, b) {
        if (a && b) {
            return 0;
        }
        if (!a && !b) {
            return 0;
        } else {
            return a ? 1 : -1;
        }
    };
    sortService.sortData = function(sortInfo, data ) {
        if (!data || !sortInfo) {
            return;
        }
        var l = sortInfo.fields.length,
            order = sortInfo.fields,
            col,
            direction,
            d = data.slice(0);
        data.sort(function (itemA, itemB) {
            var tem = 0,
                indx = 0,
                res,
                sortFn;
            while (tem === 0 && indx < l) {
                col = sortInfo.columns[indx];
                direction = sortInfo.directions[indx];
                sortFn = sortService.getSortFn(col, d);

                var propA = $utils.evalProperty(itemA, order[indx]);
                var propB = $utils.evalProperty(itemB, order[indx]);
                if (sortService.isCustomSort) {
                    res = sortFn(propA, propB);
                    tem = direction === ASC ? res : 0 - res;
                } else {
                    if (propA == null || propB == null) {
                        if (propB == null && propA == null) {
                            tem = 0;
                        }
                        else if (propA == null) {
                            tem = 1;
                        }
                        else if (propB == null) {
                            tem = -1;
                        }
                    }
                    else {
                        res = sortFn(propA, propB);
                        tem = direction === ASC ? res : 0 - res;
                    }
                }
                indx++;
            }
            return tem;
        });
    };
    sortService.Sort = function(sortInfo, data) {
        if (sortService.isSorting) {
            return;
        }
        sortService.isSorting = true;
        sortService.sortData(sortInfo, data);
        sortService.isSorting = false;
    };
    sortService.getSortFn = function(col, data) {
        var sortFn, item;
        if (sortService.colSortFnCache[col.field]) {
            sortFn = sortService.colSortFnCache[col.field];
        }
        else if (col.sortingAlgorithm !== undefined) {
            sortFn = col.sortingAlgorithm;
            sortService.colSortFnCache[col.field] = col.sortingAlgorithm;
            sortService.isCustomSort = true;
        }
        else { 
            item = data[0];
            if (!item) {
                return sortFn;
            }
            sortFn = sortService.guessSortFn($parse('entity[\''+col.field.replace(DOT_REGEXP, '\'][\'')+'\']')({entity:item}));
            if (sortFn) {
                sortService.colSortFnCache[col.field] = sortFn;
            } else {
                sortFn = sortService.sortAlpha;
            }
        }
        return sortFn;
    };
    return sortService;
}]);

angular.module('ngGrid.services').factory('$utilityService', ['$parse', function ($parse) {
    var funcNameRegex = /function (.{1,})\(/;
    var utils = {
        visualLength: function(node) {
            var elem = document.getElementById('testDataLength');
            if (!elem) {
                elem = document.createElement('SPAN');
                elem.id = "testDataLength";
                elem.style.visibility = "hidden";
                document.body.appendChild(elem);
            }
            var $node = $(node);
            $(elem).css({'font': $node.css('font'),
                        'font-size': $node.css('font-size'),
                        'font-family': $node.css('font-family')});
            elem.innerHTML = $node.text();
            var width = elem.offsetWidth;
            document.body.removeChild(elem);
            return width;
        },
        forIn: function(obj, action) {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    action(obj[prop], prop);
                }
            }
        },
        endsWith: function(str, suffix) {
            if (!str || !suffix || typeof str !== "string") {
                return false;
            }
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        },
        isNullOrUndefined: function(obj) {
            if (obj === undefined || obj === null) {
                return true;
            }
            return false;
        },
        getElementsByClassName: function(cl) {
            if (document.getElementsByClassName) {
                return document.getElementsByClassName(cl);
            }
            else {
                var retnode = [];
                var myclass = new RegExp('\\b' + cl + '\\b');
                var elem = document.getElementsByTagName('*');
                for (var i = 0; i < elem.length; i++) {
                    var classes = elem[i].className;
                    if (myclass.test(classes)) {
                        retnode.push(elem[i]);
                    }
                }
                return retnode;
            }
        },
        newId: (function() {
            var seedId = new Date().getTime();
            return function() {
                return seedId += 1;
            };
        })(),
        seti18n: function($scope, language) {
            var $langPack = window.ngGrid.i18n[language];
            for (var label in $langPack) {
                $scope.i18n[label] = $langPack[label];
            }
        },
        getInstanceType: function (o) {
            var results = (funcNameRegex).exec(o.constructor.toString());
            if (results && results.length > 1) {
                var instanceType = results[1].replace(/^\s+|\s+$/g, ""); 
                return instanceType;
            }
            else {
                return "";
            }
        },
        init: function () {
            function preEval(path) {
                var m = BRACKET_REGEXP.exec(path);
                if (m) {
                    return (m[1] ? preEval(m[1]) : m[1]) + m[2] + (m[3] ? preEval(m[3]) : m[3]);
                } else {
                    path = path.replace(APOS_REGEXP, '\\\'');
                    var parts = path.split(DOT_REGEXP);
                    var preparsed = [parts.shift()];
                    angular.forEach(parts, function (part) {
                        preparsed.push(part.replace(FUNC_REGEXP, '\']$1'));
                    });
                    return preparsed.join('[\'');
                }
            }

            this.preEval = preEval;
            this.evalProperty = function (entity, path) {
                return $parse(preEval('entity.' + path))({ entity: entity });
            };
            delete this.init;
            return this;
        }
    }.init();

    return utils;
}]);

var ngAggregate = function (aggEntity, rowFactory, rowHeight, groupInitState) {
    this.rowIndex = 0;
    this.offsetTop = this.rowIndex * rowHeight;
    this.entity = aggEntity;
    this.label = aggEntity.gLabel;
    this.field = aggEntity.gField;
    this.depth = aggEntity.gDepth;
    this.parent = aggEntity.parent;
    this.children = aggEntity.children;
    this.aggChildren = aggEntity.aggChildren;
    this.aggIndex = aggEntity.aggIndex;
    this.collapsed = groupInitState;
    this.groupInitState = groupInitState;
    this.rowFactory = rowFactory;
    this.rowHeight = rowHeight;
    this.isAggRow = true;
    this.offsetLeft = aggEntity.gDepth * 25;
    this.aggLabelFilter = aggEntity.aggLabelFilter;
};

ngAggregate.prototype.toggleExpand = function () {
    this.collapsed = this.collapsed ? false : true;
    if (this.orig) {
        this.orig.collapsed = this.collapsed;
    }
    this.notifyChildren();
};
ngAggregate.prototype.setExpand = function (state) {
    this.collapsed = state;
    if (this.orig) {
        this.orig.collapsed = state;
    }
    this.notifyChildren();
};
ngAggregate.prototype.notifyChildren = function () {
    var longest = Math.max(this.rowFactory.aggCache.length, this.children.length);
    for (var i = 0; i < longest; i++) {
        if (this.aggChildren[i]) {
            this.aggChildren[i].entity[NG_HIDDEN] = this.collapsed;
            if (this.collapsed) {
                this.aggChildren[i].setExpand(this.collapsed);
            }
        }
        if (this.children[i]) {
            this.children[i][NG_HIDDEN] = this.collapsed;
        }
        if (i > this.aggIndex && this.rowFactory.aggCache[i]) {
            var agg = this.rowFactory.aggCache[i];
            var offset = (30 * this.children.length);
            agg.offsetTop = this.collapsed ? agg.offsetTop - offset : agg.offsetTop + offset;
        }
    }
    this.rowFactory.renderedChange();
};
ngAggregate.prototype.aggClass = function () {
    return this.collapsed ? "ngAggArrowCollapsed" : "ngAggArrowExpanded";
};
ngAggregate.prototype.totalChildren = function () {
    if (this.aggChildren.length > 0) {
        var i = 0;
        var recurse = function (cur) {
            if (cur.aggChildren.length > 0) {
                angular.forEach(cur.aggChildren, function (a) {
                    recurse(a);
                });
            } else {
                i += cur.children.length;
            }
        };
        recurse(this);
        return i;
    } else {
        return this.children.length;
    }
};
ngAggregate.prototype.copy = function () {
    var ret = new ngAggregate(this.entity, this.rowFactory, this.rowHeight, this.groupInitState);
    ret.orig = this;
    return ret;
};

var ngColumn = function (config, $scope, grid, domUtilityService, $templateCache, $utils) {
    var self = this,
        colDef = config.colDef,
        delay = 500,
        clicks = 0,
        timer = null;
    self.colDef = config.colDef;
    self.width = colDef.width;
    self.groupIndex = 0;
    self.isGroupedBy = false;
    self.minWidth = !colDef.minWidth ? 50 : colDef.minWidth;
    self.maxWidth = !colDef.maxWidth ? 9000 : colDef.maxWidth;
    self.enableCellEdit = colDef.enableCellEdit !== undefined ? colDef.enableCellEdit : (config.enableCellEdit || config.enableCellEditOnFocus);
    self.cellEditableCondition = colDef.cellEditableCondition || config.cellEditableCondition || 'true';

    self.headerRowHeight = config.headerRowHeight;
    self.displayName = (colDef.displayName === undefined) ? colDef.field : colDef.displayName;

    self.index = config.index;
    self.isAggCol = config.isAggCol;
    self.cellClass = colDef.cellClass;
    self.sortPriority = undefined;
    self.cellFilter = colDef.cellFilter ? colDef.cellFilter : "";
    self.field = colDef.field;
    self.aggLabelFilter = colDef.aggLabelFilter || colDef.cellFilter;
    self.visible = $utils.isNullOrUndefined(colDef.visible) || colDef.visible;
    self.sortable = false;
    self.resizable = false;
    self.pinnable = false;
    self.pinned = (config.enablePinning && colDef.pinned);
    self.originalIndex = config.originalIndex == null ? self.index : config.originalIndex;
    self.groupable = $utils.isNullOrUndefined(colDef.groupable) || colDef.groupable;
    if (config.enableSort) {
        self.sortable = $utils.isNullOrUndefined(colDef.sortable) || colDef.sortable;
    }
    if (config.enableResize) {
        self.resizable = $utils.isNullOrUndefined(colDef.resizable) || colDef.resizable;
    }
    if (config.enablePinning) {
        self.pinnable = $utils.isNullOrUndefined(colDef.pinnable) || colDef.pinnable;
    }
    self.sortDirection = undefined;
    self.sortingAlgorithm = colDef.sortFn;
    self.headerClass = colDef.headerClass;
    self.cursor = self.sortable ? 'pointer' : 'default';
    self.headerCellTemplate = colDef.headerCellTemplate || $templateCache.get('headerCellTemplate.html');
    self.cellTemplate = colDef.cellTemplate || $templateCache.get('cellTemplate.html').replace(CUSTOM_FILTERS, self.cellFilter ? "|" + self.cellFilter : "");
    if(self.enableCellEdit) {
        self.cellEditTemplate = colDef.cellEditTemplate || $templateCache.get('cellEditTemplate.html');
        self.editableCellTemplate = colDef.editableCellTemplate || $templateCache.get('editableCellTemplate.html');
    }
    if (colDef.cellTemplate && !TEMPLATE_REGEXP.test(colDef.cellTemplate)) {
        self.cellTemplate = $templateCache.get(colDef.cellTemplate) || $.ajax({
            type: "GET",
            url: colDef.cellTemplate,
            async: false
        }).responseText;
    }
    if (self.enableCellEdit && colDef.editableCellTemplate && !TEMPLATE_REGEXP.test(colDef.editableCellTemplate)) {
        self.editableCellTemplate = $templateCache.get(colDef.editableCellTemplate) || $.ajax({
            type: "GET",
            url: colDef.editableCellTemplate,
            async: false
        }).responseText;
    }
    if (colDef.headerCellTemplate && !TEMPLATE_REGEXP.test(colDef.headerCellTemplate)) {
        self.headerCellTemplate = $templateCache.get(colDef.headerCellTemplate) || $.ajax({
            type: "GET",
            url: colDef.headerCellTemplate,
            async: false
        }).responseText;
    }
    self.colIndex = function () {
        var classes = self.pinned ? "pinned " : "";
        classes += "col" + self.index + " colt" + self.index;
        if (self.cellClass) {
            classes += " " + self.cellClass;
        }
        return classes;
    };
    self.groupedByClass = function() {
        return self.isGroupedBy ? "ngGroupedByIcon" : "ngGroupIcon";
    };
    self.toggleVisible = function() {
        self.visible = !self.visible;
    };
    self.showSortButtonUp = function() {
        return self.sortable ? self.sortDirection === DESC : self.sortable;
    };
    self.showSortButtonDown = function() {
        return self.sortable ? self.sortDirection === ASC : self.sortable;
    };
    self.noSortVisible = function() {
        return !self.sortDirection;
    };
    self.sort = function(evt) {
        if (!self.sortable) {
            return true; 
        }
        var dir = self.sortDirection === ASC ? DESC : ASC;
        self.sortDirection = dir;
        config.sortCallback(self, evt);
        return false;
    };
    self.gripClick = function() {
        clicks++; 
        if (clicks === 1) {
            timer = setTimeout(function() {
                clicks = 0; 
            }, delay);
        } else {
            clearTimeout(timer); 
            config.resizeOnDataCallback(self); 
            clicks = 0; 
        }
    };
    self.gripOnMouseDown = function(event) {
        $scope.isColumnResizing = true;
        if (event.ctrlKey && !self.pinned) {
            self.toggleVisible();
            domUtilityService.BuildStyles($scope, grid);
            return true;
        }
        event.target.parentElement.style.cursor = 'col-resize';
        self.startMousePosition = event.clientX;
        self.origWidth = self.width;
        $(document).mousemove(self.onMouseMove);
        $(document).mouseup(self.gripOnMouseUp);
        return false;
    };
    self.onMouseMove = function(event) {
        var diff = event.clientX - self.startMousePosition;
        var newWidth = diff + self.origWidth;
        self.width = (newWidth < self.minWidth ? self.minWidth : (newWidth > self.maxWidth ? self.maxWidth : newWidth));
        $scope.hasUserChangedGridColumnWidths = true;
        domUtilityService.BuildStyles($scope, grid);
        return false;
    };
    self.gripOnMouseUp = function (event) {
        $(document).off('mousemove', self.onMouseMove);
        $(document).off('mouseup', self.gripOnMouseUp);
        event.target.parentElement.style.cursor = 'default';
        domUtilityService.digest($scope);
        $scope.isColumnResizing = false;
        return false;
    };
    self.copy = function() {
        var ret = new ngColumn(config, $scope, grid, domUtilityService, $templateCache, $utils);
        ret.isClone = true;
        ret.orig = self;
        return ret;
    };
    self.setVars = function (fromCol) {
        self.orig = fromCol;
        self.width = fromCol.width;
        self.groupIndex = fromCol.groupIndex;
        self.isGroupedBy = fromCol.isGroupedBy;
        self.displayName = fromCol.displayName;
        self.index = fromCol.index;
        self.isAggCol = fromCol.isAggCol;
        self.cellClass = fromCol.cellClass;
        self.cellFilter = fromCol.cellFilter;
        self.field = fromCol.field;
        self.aggLabelFilter = fromCol.aggLabelFilter;
        self.visible = fromCol.visible;
        self.sortable = fromCol.sortable;
        self.resizable = fromCol.resizable;
        self.pinnable = fromCol.pinnable;
        self.pinned = fromCol.pinned;
        self.originalIndex = fromCol.originalIndex;
        self.sortDirection = fromCol.sortDirection;
        self.sortingAlgorithm = fromCol.sortingAlgorithm;
        self.headerClass = fromCol.headerClass;
        self.headerCellTemplate = fromCol.headerCellTemplate;
        self.cellTemplate = fromCol.cellTemplate;
        self.cellEditTemplate = fromCol.cellEditTemplate;
    };
};

var ngDimension = function (options) {
    this.outerHeight = null;
    this.outerWidth = null;
    $.extend(this, options);
};
var ngDomAccessProvider = function (grid) {
    this.previousColumn = null;
    this.grid = grid;

};

ngDomAccessProvider.prototype.changeUserSelect = function (elm, value) {
    elm.css({
        '-webkit-touch-callout': value,
        '-webkit-user-select': value,
        '-khtml-user-select': value,
        '-moz-user-select': value === 'none' ? '-moz-none' : value,
        '-ms-user-select': value,
        'user-select': value
    });
};
ngDomAccessProvider.prototype.focusCellElement = function ($scope, index) { 
    if ($scope.selectionProvider.lastClickedRow) {
        var columnIndex = index !== undefined ? index : this.previousColumn;
        var elm = $scope.selectionProvider.lastClickedRow.clone ? $scope.selectionProvider.lastClickedRow.clone.elm : $scope.selectionProvider.lastClickedRow.elm;
        if (columnIndex !== undefined && elm) {
            var columns = angular.element(elm[0].children).filter(function () { return this.nodeType !== 8; }); 
            var i = Math.max(Math.min($scope.renderedColumns.length - 1, columnIndex), 0);
            if (this.grid.config.showSelectionCheckbox && angular.element(columns[i]).scope() && angular.element(columns[i]).scope().col.index === 0) {
                i = 1; 
            }
            if (columns[i]) {
                columns[i].children[1].children[0].focus();
            }
            this.previousColumn = columnIndex;
        }
    }
};
ngDomAccessProvider.prototype.selectionHandlers = function ($scope, elm) {
    var doingKeyDown = false;
    var self = this;

    function keydown (evt) {
        if (evt.keyCode === 16) { 
            self.changeUserSelect(elm, 'none', evt);
            return true;
        } else if (!doingKeyDown) {
            doingKeyDown = true;
            var ret = ngMoveSelectionHandler($scope, elm, evt, self.grid);
            doingKeyDown = false;
            return ret;
        }
        return true;
    }

    elm.bind('keydown', keydown);

    function keyup (evt) {
        if (evt.keyCode === 16) { 
            self.changeUserSelect(elm, 'text', evt);
        }
        return true;
    }

    elm.bind('keyup', keyup);

    elm.on('$destroy', function() {
        elm.off('keydown', keydown);
        elm.off('keyup', keyup);
    });
};
var ngEventProvider = function (grid, $scope, domUtilityService, $timeout) {
    var self = this;
    self.colToMove = undefined;
    self.groupToMove = undefined;
    self.assignEvents = function() {
        if (grid.config.jqueryUIDraggable && !grid.config.enablePinning) {
            grid.$groupPanel.droppable({
                addClasses: false,
                drop: function(event) {
                    self.onGroupDrop(event);
                }
            });

            grid.$groupPanel.on('$destroy', function() {
                grid.$groupPanel = null;
            });
        } else {
            grid.$groupPanel.on('mousedown', self.onGroupMouseDown).on('dragover', self.dragOver).on('drop', self.onGroupDrop);
            grid.$topPanel.on('mousedown', '.ngHeaderScroller', self.onHeaderMouseDown).on('dragover', '.ngHeaderScroller', self.dragOver);

            grid.$groupPanel.on('$destroy', function() {
                if (grid.$groupPanel){
                    grid.$groupPanel.off('mousedown');
                }

                grid.$groupPanel = null;
            });

            if (grid.config.enableColumnReordering) {
                grid.$topPanel.on('drop', '.ngHeaderScroller', self.onHeaderDrop);
            }

            grid.$topPanel.on('$destroy', function() {
                if (grid.$topPanel){
                    grid.$topPanel.off('mousedown');
                }

                if (grid.config.enableColumnReordering && grid.$topPanel) {
                    grid.$topPanel.off('drop');
                }

                grid.$topPanel = null;
            });
        }

        $scope.$on('$destroy', $scope.$watch('renderedColumns', function() {
            $timeout(self.setDraggables);
        }));
    };
    self.dragStart = function(evt){
      evt.dataTransfer.setData('text', ''); 
    };
    self.dragOver = function(evt) {
        evt.preventDefault();
    };
    self.setDraggables = function() {
        if (!grid.config.jqueryUIDraggable) {
            if (grid.$root) {
                var columns = grid.$root.find('.ngHeaderSortColumn'); 
                angular.forEach(columns, function(col){
                    if(col.className && col.className.indexOf("ngHeaderSortColumn") !== -1){
                        col.setAttribute('draggable', 'true');
                        if (col.addEventListener) { 
                            col.addEventListener('dragstart', self.dragStart);

                            angular.element(col).on('$destroy', function() {
                                angular.element(col).off('dragstart', self.dragStart);
                                col.removeEventListener('dragstart', self.dragStart);
                            });
                        }
                    }
                });
                if (navigator.userAgent.indexOf("MSIE") !== -1){
                    var sortColumn = grid.$root.find('.ngHeaderSortColumn');
                    sortColumn.bind('selectstart', function () { 
                        this.dragDrop(); 
                        return false; 
                    });
                    angular.element(sortColumn).on('$destroy', function() {
                        sortColumn.off('selectstart');
                    });
                }
            }
        } else {
            if (grid.$root) {
                grid.$root.find('.ngHeaderSortColumn').draggable({
                    helper: 'clone',
                    appendTo: 'body',
                    stack: 'div',
                    addClasses: false,
                    start: function(event) {
                        self.onHeaderMouseDown(event);
                    }
                }).droppable({
                    drop: function(event) {
                        self.onHeaderDrop(event);
                    }
                });
            }
        }
    };
    self.onGroupMouseDown = function(event) {
        var groupItem = $(event.target);
        if (groupItem[0].className !== 'ngRemoveGroup') {
            var groupItemScope = angular.element(groupItem).scope();
            if (groupItemScope) {
                if (!grid.config.jqueryUIDraggable) {
                    groupItem.attr('draggable', 'true');
                    if(this.addEventListener){
                        this.addEventListener('dragstart', self.dragStart);
                        angular.element(this).on('$destroy', function() {
                            this.removeEventListener('dragstart', self.dragStart); 
                        });
                    }
                    if (navigator.userAgent.indexOf("MSIE") !== -1){
                        groupItem.bind('selectstart', function () { 
                            this.dragDrop(); 
                            return false; 
                        });

                        groupItem.on('$destroy', function() {
                            groupItem.off('selectstart');
                        });
                    }
                }
                self.groupToMove = { header: groupItem, groupName: groupItemScope.group, index: groupItemScope.$index };
            }
        } else {
            self.groupToMove = undefined;
        }
    };
    self.onGroupDrop = function(event) {
        event.stopPropagation();
        var groupContainer;
        var groupScope;
        if (self.groupToMove) {
            groupContainer = $(event.target).closest('.ngGroupElement'); 
            if (groupContainer.context.className === 'ngGroupPanel') {
                $scope.configGroups.splice(self.groupToMove.index, 1);
                $scope.configGroups.push(self.groupToMove.groupName);
            } else {
                groupScope = angular.element(groupContainer).scope();
                if (groupScope) {
                    if (self.groupToMove.index !== groupScope.$index) {
                        $scope.configGroups.splice(self.groupToMove.index, 1);
                        $scope.configGroups.splice(groupScope.$index, 0, self.groupToMove.groupName);
                    }
                }
            }
            self.groupToMove = undefined;
            grid.fixGroupIndexes();
        } else if (self.colToMove) {
            if ($scope.configGroups.indexOf(self.colToMove.col) === -1) {
                groupContainer = $(event.target).closest('.ngGroupElement'); 
                if (groupContainer.context.className === 'ngGroupPanel' || groupContainer.context.className === 'ngGroupPanelDescription ng-binding') {
                    $scope.groupBy(self.colToMove.col);
                } else {
                    groupScope = angular.element(groupContainer).scope();
                    if (groupScope) {
                        $scope.removeGroup(groupScope.$index);
                    }
                }
            }
            self.colToMove = undefined;
        }
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    };
    self.onHeaderMouseDown = function(event) {
        var headerContainer = $(event.target).closest('.ngHeaderSortColumn');
        var headerScope = angular.element(headerContainer).scope();
        if (headerScope) {
            self.colToMove = { header: headerContainer, col: headerScope.col };
        }
    };
    self.onHeaderDrop = function(event) {
        if (!self.colToMove || self.colToMove.col.pinned) {
            return;
        }
        var headerContainer = $(event.target).closest('.ngHeaderSortColumn');
        var headerScope = angular.element(headerContainer).scope();
        if (headerScope) {
            if (self.colToMove.col === headerScope.col || headerScope.col.pinned) {
                return;
            }
            $scope.columns.splice(self.colToMove.col.index, 1);
            $scope.columns.splice(headerScope.col.index, 0, self.colToMove.col);
            grid.fixColumnIndexes();
            self.colToMove = undefined;
            domUtilityService.digest($scope);
        }
    };

    self.assignGridEventHandlers = function() {
        if (grid.config.tabIndex === -1) {
            grid.$viewport.attr('tabIndex', domUtilityService.numberOfGrids);
            domUtilityService.numberOfGrids++;
        } else {
            grid.$viewport.attr('tabIndex', grid.config.tabIndex);
        }
        var windowThrottle;
        var windowResize = function(){
            clearTimeout(windowThrottle);
            windowThrottle = setTimeout(function() {
                domUtilityService.RebuildGrid($scope,grid);
            }, 100);
        };
        $(window).on('resize.nggrid', windowResize);
        var parentThrottle;
        var parentResize = function() {
            clearTimeout(parentThrottle);
            parentThrottle = setTimeout(function() {
                domUtilityService.RebuildGrid($scope,grid);
            }, 100);
        };
        $(grid.$root.parent()).on('resize.nggrid', parentResize);

        $scope.$on('$destroy', function(){
            $(window).off('resize.nggrid', windowResize);
        });
    };
    self.assignGridEventHandlers();
    self.assignEvents();
};

var ngFooter = function ($scope, grid) {
    $scope.maxRows = function () {
        var ret = Math.max($scope.totalServerItems, grid.data.length);
        return ret;
    };
     $scope.$on('$destroy', $scope.$watch('totalServerItems',function(n,o){
        $scope.currentMaxPages = $scope.maxPages();
    }));

    $scope.multiSelect = (grid.config.enableRowSelection && grid.config.multiSelect);
    $scope.selectedItemCount = grid.selectedItemCount;
    $scope.maxPages = function () {
        if($scope.maxRows() === 0) {
            return 1;
        }
        return Math.ceil($scope.maxRows() / $scope.pagingOptions.pageSize);
    };

    $scope.pageForward = function() {
        var page = $scope.pagingOptions.currentPage;
        if ($scope.totalServerItems > 0) {
            $scope.pagingOptions.currentPage = Math.min(page + 1, $scope.maxPages());
        } else {
            $scope.pagingOptions.currentPage++;
        }
    };

    $scope.pageBackward = function() {
        var page = $scope.pagingOptions.currentPage;
        $scope.pagingOptions.currentPage = Math.max(page - 1, 1);
    };

    $scope.pageToFirst = function() {
        $scope.pagingOptions.currentPage = 1;
    };

    $scope.pageToLast = function() {
        var maxPages = $scope.maxPages();
        $scope.pagingOptions.currentPage = maxPages;
    };

    $scope.cantPageForward = function() {
        var curPage = $scope.pagingOptions.currentPage;
        var maxPages = $scope.maxPages();
        if ($scope.totalServerItems > 0) {
            return curPage >= maxPages;
        } else {
            return grid.data.length < 1;
        }

    };
    $scope.cantPageToLast = function() {
        if ($scope.totalServerItems > 0) {
            return $scope.cantPageForward();
        } else {
            return true;
        }
    };
    $scope.cantPageBackward = function() {
        var curPage = $scope.pagingOptions.currentPage;
        return curPage <= 1;
    };
};

var ngGrid = function ($scope, options, sortService, domUtilityService, $filter, $templateCache, $utils, $timeout, $parse, $http, $q) {
    var defaults = {
        aggregateTemplate: undefined,
        afterSelectionChange: function() {
        },
        beforeSelectionChange: function() {
            return true;
        },
        checkboxCellTemplate: undefined,
        checkboxHeaderTemplate: undefined,
        columnDefs: undefined,
        data: [],
        dataUpdated: function() {
        },
        enableCellEdit: false,
        enableCellEditOnFocus: false,
        enableCellSelection: false,
        enableColumnResize: false,
        enableColumnReordering: false,
        enableColumnHeavyVirt: false,
        enablePaging: false,
        enablePinning: false,
        enableRowSelection: true,
        enableSorting: true,
        enableHighlighting: false,
        excludeProperties: [],
        filterOptions: {
            filterText: "",
            useExternalFilter: false
        },
        footerRowHeight: 55,
        footerTemplate: undefined,
        forceSyncScrolling: true,
        groups: [],
        groupsCollapsedByDefault: true,
        headerRowHeight: 30,
        headerRowTemplate: undefined,
        jqueryUIDraggable: false,
        jqueryUITheme: false,
        keepLastSelected: true,
        maintainColumnRatios: undefined,
        menuTemplate: undefined,
        multiSelect: true,
        pagingOptions: {
            pageSizes: [250, 500, 1000],
            pageSize: 250,
            currentPage: 1
        },
        pinSelectionCheckbox: false,
        plugins: [],
        primaryKey: undefined,
        rowHeight: 30,
        rowTemplate: undefined,
        selectedItems: [],
        selectionCheckboxColumnWidth: 25,
        selectWithCheckboxOnly: false,
        showColumnMenu: false,
        showFilter: false,
        showFooter: false,
        showGroupPanel: false,
        showSelectionCheckbox: false,
        sortInfo: {fields: [], columns: [], directions: [] },
        tabIndex: -1,
        totalServerItems: 0,
        useExternalSorting: false,
        i18n: 'en',
        virtualizationThreshold: 50,
	noTabInterference: false
    },
        self = this;
    self.maxCanvasHt = 0;
    self.config = $.extend(defaults, window.ngGrid.config, options);
    self.config.showSelectionCheckbox = (self.config.showSelectionCheckbox && self.config.enableColumnHeavyVirt === false);
    self.config.enablePinning = (self.config.enablePinning && self.config.enableColumnHeavyVirt === false);
    self.config.selectWithCheckboxOnly = (self.config.selectWithCheckboxOnly && self.config.showSelectionCheckbox !== false);
    self.config.pinSelectionCheckbox = self.config.enablePinning;

    if (typeof options.columnDefs === "string") {
        self.config.columnDefs = $scope.$eval(options.columnDefs);
    }
    self.rowCache = [];
    self.rowMap = [];
    self.gridId = "ng" + $utils.newId();
    self.$root = null; 
    self.$groupPanel = null;
    self.$topPanel = null;
    self.$headerContainer = null;
    self.$headerScroller = null;
    self.$headers = null;
    self.$viewport = null;
    self.$canvas = null;
    self.rootDim = self.config.gridDim;
    self.data = [];
    self.lateBindColumns = false;
    self.filteredRows = [];

    self.initTemplates = function() {
        var templates = ['rowTemplate', 'aggregateTemplate', 'headerRowTemplate', 'checkboxCellTemplate', 'checkboxHeaderTemplate', 'menuTemplate', 'footerTemplate'];

        var promises = [];
        angular.forEach(templates, function(template) {
            promises.push( self.getTemplate(template) );
        });

        return $q.all(promises);
    };
    self.getTemplate = function (key) {
        var t = self.config[key];
        var uKey = self.gridId + key + ".html";
        var p = $q.defer();
        if (t && !TEMPLATE_REGEXP.test(t)) {
            $http.get(t, {
                cache: $templateCache
            })
            .success(function(data){
                $templateCache.put(uKey, data);
                p.resolve();
            })
            .error(function(err){
                p.reject("Could not load template: " + t);
            });
        } else if (t) {
            $templateCache.put(uKey, t);
            p.resolve();
        } else {
            var dKey = key + ".html";
            $templateCache.put(uKey, $templateCache.get(dKey));
            p.resolve();
        }

        return p.promise;
    };

    if (typeof self.config.data === "object") {
        self.data = self.config.data; 
    }
    self.calcMaxCanvasHeight = function() {
        var calculatedHeight;
        if(self.config.groups.length > 0){
            calculatedHeight = self.rowFactory.parsedData.filter(function(e) {
                return !e[NG_HIDDEN];
            }).length * self.config.rowHeight;
        } else {
            calculatedHeight = self.filteredRows.length * self.config.rowHeight;
        }
        return calculatedHeight;
    };
    self.elementDims = {
        scrollW: 0,
        scrollH: 0,
        rowIndexCellW: self.config.selectionCheckboxColumnWidth,
        rowSelectedCellW: self.config.selectionCheckboxColumnWidth,
        rootMaxW: 0,
        rootMaxH: 0
    };
    self.setRenderedRows = function (newRows) {
        $scope.renderedRows.length = newRows.length;
        for (var i = 0; i < newRows.length; i++) {
            if (!$scope.renderedRows[i] || (newRows[i].isAggRow || $scope.renderedRows[i].isAggRow)) {
                $scope.renderedRows[i] = newRows[i].copy();
                $scope.renderedRows[i].collapsed = newRows[i].collapsed;
                if (!newRows[i].isAggRow) {
                    $scope.renderedRows[i].setVars(newRows[i]);
                }
            } else {
                $scope.renderedRows[i].setVars(newRows[i]);
            }
            $scope.renderedRows[i].rowIndex = newRows[i].rowIndex;
            $scope.renderedRows[i].offsetTop = newRows[i].offsetTop;
            $scope.renderedRows[i].selected = newRows[i].selected;
            newRows[i].renderedRowIndex = i;
        }
        self.refreshDomSizes();
        $scope.$emit('ngGridEventRows', newRows);
    };
    self.minRowsToRender = function() {
        var viewportH = $scope.viewportDimHeight() || 1;
        return Math.floor(viewportH / self.config.rowHeight);
    };
    self.refreshDomSizes = function() {
        var dim = new ngDimension();
        dim.outerWidth = self.elementDims.rootMaxW;
        dim.outerHeight = self.elementDims.rootMaxH;
        self.rootDim = dim;
        self.maxCanvasHt = self.calcMaxCanvasHeight();
    };
    self.buildColumnDefsFromData = function () {
        self.config.columnDefs = [];
        var item = self.data[0];
        if (!item) {
            self.lateBoundColumns = true;
            return;
        }
        $utils.forIn(item, function (prop, propName) {
            if (self.config.excludeProperties.indexOf(propName) === -1) {
                self.config.columnDefs.push({
                    field: propName
                });
            }
        });
    };
    self.buildColumns = function() {
        var columnDefs = self.config.columnDefs,
            cols = [];
        if (!columnDefs) {
            self.buildColumnDefsFromData();
            columnDefs = self.config.columnDefs;
        }
        if (self.config.showSelectionCheckbox) {
            cols.push(new ngColumn({
                colDef: {
                    field: '\u2714',
                    width: self.elementDims.rowSelectedCellW,
                    sortable: false,
                    resizable: false,
                    groupable: false,
                    headerCellTemplate: $templateCache.get($scope.gridId + 'checkboxHeaderTemplate.html'),
                    cellTemplate: $templateCache.get($scope.gridId + 'checkboxCellTemplate.html'),
                    pinned: self.config.pinSelectionCheckbox
                },
                index: 0,
                headerRowHeight: self.config.headerRowHeight,
                sortCallback: self.sortData,
                resizeOnDataCallback: self.resizeOnData,
                enableResize: self.config.enableColumnResize,
                enableSort: self.config.enableSorting,
                enablePinning: self.config.enablePinning
            }, $scope, self, domUtilityService, $templateCache, $utils));
        }
        if (columnDefs.length > 0) {
            var checkboxOffset = self.config.showSelectionCheckbox ? 1 : 0;
            var groupOffset = $scope.configGroups.length;
            $scope.configGroups.length = 0;
            angular.forEach(columnDefs, function(colDef, i) {
                i += checkboxOffset;
                var column = new ngColumn({
                    colDef: colDef,
                    index: i + groupOffset,
                    originalIndex: i,
                    headerRowHeight: self.config.headerRowHeight,
                    sortCallback: self.sortData,
                    resizeOnDataCallback: self.resizeOnData,
                    enableResize: self.config.enableColumnResize,
                    enableSort: self.config.enableSorting,
                    enablePinning: self.config.enablePinning,
                    enableCellEdit: self.config.enableCellEdit || self.config.enableCellEditOnFocus,
                    cellEditableCondition: self.config.cellEditableCondition
                }, $scope, self, domUtilityService, $templateCache, $utils);
                var indx = self.config.groups.indexOf(colDef.field);
                if (indx !== -1) {
                    column.isGroupedBy = true;
                    $scope.configGroups.splice(indx, 0, column);
                    column.groupIndex = $scope.configGroups.length;
                }
                cols.push(column);
            });
            $scope.columns = cols;
            if (self.config.groups.length > 0) {
                self.rowFactory.getGrouping(self.config.groups);
            }
        }
    };
    self.configureColumnWidths = function() {
        var asterisksArray = [],
            percentArray = [],
            asteriskNum = 0,
            totalWidth = 0;
        var indexMap = {};
        angular.forEach($scope.columns, function(ngCol, i) {
            if (!$utils.isNullOrUndefined(ngCol.originalIndex)) {
                var origIndex = ngCol.originalIndex;
                if (self.config.showSelectionCheckbox) {
                    if(ngCol.originalIndex === 0 && ngCol.visible){
                        totalWidth += self.config.selectionCheckboxColumnWidth;
                    }
                    origIndex--;
                }
                indexMap[origIndex] = i;
            } else if (ngCol.isAggCol && ngCol.visible){ 
                totalWidth+=25;
            }
        });

        angular.forEach(self.config.columnDefs, function(colDef, i) {
            var ngColumn = $scope.columns[indexMap[i]];

            colDef.index = i;

            var isPercent = false, t;
            if ($utils.isNullOrUndefined(colDef.width)) {
                colDef.width = "*";
            } else { 
                isPercent = isNaN(colDef.width) ? $utils.endsWith(colDef.width, "%") : false;
                t = isPercent ? colDef.width : parseInt(colDef.width, 10);
            }
            if (isNaN(t)) {
                t = colDef.width;
                if (t === 'auto') { 
                    ngColumn.width = ngColumn.minWidth;
                    totalWidth += ngColumn.width;
                    var temp = ngColumn;

                    $scope.$on('$destroy', $scope.$on("ngGridEventData", function () {
                        self.resizeOnData(temp);
                    }));

                    return;
                } else if (t.indexOf("*") !== -1) { 
                    if (ngColumn.visible !== false) {
                        asteriskNum += t.length;
                    }
                    asterisksArray.push(colDef);
                    return;
                } else if (isPercent) { 
                    percentArray.push(colDef);
                    return;
                } else { 
                    throw "unable to parse column width, use percentage (\"10%\",\"20%\", etc...) or \"*\" to use remaining width of grid";
                }
            } else if (ngColumn.visible !== false) {
                totalWidth += ngColumn.width = parseInt(ngColumn.width, 10);
            }
        });
        if (percentArray.length > 0) {
            self.config.maintainColumnRatios = self.config.maintainColumnRatios !== false;
            var percentWidth = 0; 
            var hiddenPercent = 0; 
            angular.forEach(percentArray, function(colDef) {
                var ngColumn = $scope.columns[indexMap[colDef.index]];
                var percent = parseFloat(colDef.width) / 100;
                percentWidth += percent;

                if (!ngColumn.visible) {
                    hiddenPercent += percent;
                }
            });
            var percentWidthUsed = percentWidth - hiddenPercent;
            angular.forEach(percentArray, function(colDef) {
                var ngColumn = $scope.columns[indexMap[colDef.index]];
                var percent = parseFloat(colDef.width) / 100;
                if (hiddenPercent > 0) {
                    percent = percent / percentWidthUsed;
                }
                else {
                    percent = percent / percentWidth;
                }

                var pixelsForPercentBasedWidth = self.rootDim.outerWidth * percentWidth;
                ngColumn.width = pixelsForPercentBasedWidth * percent;
                totalWidth += ngColumn.width;
            });
        }
        if (asterisksArray.length > 0) {
            self.config.maintainColumnRatios = self.config.maintainColumnRatios !== false;
            var remainingWidth = self.rootDim.outerWidth - totalWidth;
            if (self.maxCanvasHt > $scope.viewportDimHeight()) {
                remainingWidth -= domUtilityService.ScrollW;
            }
            var asteriskVal = Math.floor(remainingWidth / asteriskNum);
            angular.forEach(asterisksArray, function(colDef, i) {
                var ngColumn = $scope.columns[indexMap[colDef.index]];
                ngColumn.width = asteriskVal * colDef.width.length;
                if (ngColumn.width < ngColumn.minWidth) {
                    ngColumn.width = ngColumn.minWidth;
                }
                if (ngColumn.visible !== false) {
                    totalWidth += ngColumn.width;
                }

                var isLast = (i === (asterisksArray.length - 1));
                if(isLast && totalWidth < self.rootDim.outerWidth){
                    var gridWidthDifference = self.rootDim.outerWidth - totalWidth;
                    if(self.maxCanvasHt > $scope.viewportDimHeight()){
                        gridWidthDifference -= domUtilityService.ScrollW;
                    }
                    ngColumn.width += gridWidthDifference;
                }
            });
        }
    };
    self.init = function() {
        return self.initTemplates().then(function(){
            $scope.selectionProvider = new ngSelectionProvider(self, $scope, $parse, $utils);
            $scope.domAccessProvider = new ngDomAccessProvider(self);
            self.rowFactory = new ngRowFactory(self, $scope, domUtilityService, $templateCache, $utils);
            self.searchProvider = new ngSearchProvider($scope, self, $filter, $utils);
            self.styleProvider = new ngStyleProvider($scope, self);
            $scope.$on('$destroy', $scope.$watch('configGroups', function(a) {
              var tempArr = [];
              angular.forEach(a, function(item) {
                tempArr.push(item.field || item);
              });
              self.config.groups = tempArr;
              self.rowFactory.filteredRowsChanged();
              $scope.$emit('ngGridEventGroups', a);
            }, true));
             $scope.$on('$destroy', $scope.$watch('columns', function (a) {
                if(!$scope.isColumnResizing){
                    domUtilityService.RebuildGrid($scope, self);
                }
                $scope.$emit('ngGridEventColumns', a);
            }, true));
             $scope.$on('$destroy', $scope.$watch(function() {
                return options.i18n;
            }, function(newLang) {
                $utils.seti18n($scope, newLang);
            }));
            self.maxCanvasHt = self.calcMaxCanvasHeight();

            if (self.config.sortInfo.fields && self.config.sortInfo.fields.length > 0) {
                $scope.$on('$destroy', $scope.$watch(function() {
                    return self.config.sortInfo;
                }, function(sortInfo){
                    if (!sortService.isSorting) {
                        self.sortColumnsInit();
                        $scope.$emit('ngGridEventSorted', self.config.sortInfo);
                    }
                }, true));
            }
        });
    };
    self.resizeOnData = function(col) {
        var longest = col.minWidth;
        var arr = $utils.getElementsByClassName('col' + col.index);
        angular.forEach(arr, function(elem, index) {
            var i;
            if (index === 0) {
                var kgHeaderText = $(elem).find('.ngHeaderText');
                i = $utils.visualLength(kgHeaderText) + 10; 
            } else {
                var ngCellText = $(elem).find('.ngCellText');
                i = $utils.visualLength(ngCellText) + 10; 
            }
            if (i > longest) {
                longest = i;
            }
        });
        col.width = col.longest = Math.min(col.maxWidth, longest + 7); 
        domUtilityService.BuildStyles($scope, self, true);
    };
    self.lastSortedColumns = [];
    self.sortData = function(col, evt) {
        if (evt && evt.shiftKey && self.config.sortInfo) {
            var indx = self.config.sortInfo.columns.indexOf(col);
            if (indx === -1) {
                if (self.config.sortInfo.columns.length === 1) {
                    self.config.sortInfo.columns[0].sortPriority = 1;
                }
                self.config.sortInfo.columns.push(col);
                col.sortPriority = self.config.sortInfo.columns.length;
                self.config.sortInfo.fields.push(col.field);
                self.config.sortInfo.directions.push(col.sortDirection);
                self.lastSortedColumns.push(col);
            } else {
                self.config.sortInfo.directions[indx] = col.sortDirection;
            }
            $scope.$emit('ngGridEventSorted', self.config.sortInfo);
        } else if (!self.config.useExternalSorting || (self.config.useExternalSorting && self.config.sortInfo )) {
            var isArr = $.isArray(col);
            self.config.sortInfo.columns.length = 0;
            self.config.sortInfo.fields.length = 0;
            self.config.sortInfo.directions.length = 0;
            var push = function (c) {
                self.config.sortInfo.columns.push(c);
                self.config.sortInfo.fields.push(c.field);
                self.config.sortInfo.directions.push(c.sortDirection);
                self.lastSortedColumns.push(c);
            };
            if (isArr) {
                angular.forEach(col, function (c, i) {
                    c.sortPriority = i + 1;
                    push(c);
                });
            } else {
                self.clearSortingData(col);
                col.sortPriority = undefined;
                push(col);
            }

            self.sortActual();
            self.searchProvider.evalFilter();
            $scope.$emit('ngGridEventSorted', self.config.sortInfo);
        }
    };
    self.sortColumnsInit = function() {
        if (self.config.sortInfo.columns) {
            self.config.sortInfo.columns.length = 0;
        } else {
            self.config.sortInfo.columns = [];
        }

        var cols = [];
        angular.forEach($scope.columns, function(c) {
            var i = self.config.sortInfo.fields.indexOf(c.field);
            if (i !== -1) {
                c.sortDirection = self.config.sortInfo.directions[i] || 'asc';
                cols[i] = c;
            }
        });

        if(cols.length === 1){
            self.sortData(cols[0]);
        }else{
            self.sortData(cols);
        }
    };
    self.sortActual = function() {
        if (!self.config.useExternalSorting) {
            var tempData = self.data.slice(0);
            angular.forEach(tempData, function(item, i) {
                var e = self.rowMap[i];
                if (e !== undefined) {
                    var v = self.rowCache[e];
                    if (v !== undefined) {
                        item.preSortSelected = v.selected;
                        item.preSortIndex = i;
                    }
                }
            });
            sortService.Sort(self.config.sortInfo, tempData);
            angular.forEach(tempData, function(item, i) {
                self.rowCache[i].entity = item;
                self.rowCache[i].selected = item.preSortSelected;
                self.rowMap[item.preSortIndex] = i;
                delete item.preSortSelected;
                delete item.preSortIndex;
            });
        }
    };

    self.clearSortingData = function (col) {
        if (!col) {
            angular.forEach(self.lastSortedColumns, function (c) {
                c.sortDirection = "";
                c.sortPriority = null;
            });
            self.lastSortedColumns = [];
        } else {
            angular.forEach(self.lastSortedColumns, function (c) {
                if (col.index !== c.index) {
                    c.sortDirection = "";
                    c.sortPriority = null;
                }
            });
            self.lastSortedColumns[0] = col;
            self.lastSortedColumns.length = 1;
        }
    };
    self.fixColumnIndexes = function() {
        for (var i = 0; i < $scope.columns.length; i++) {
            $scope.columns[i].index = i;
        }
    };
    self.fixGroupIndexes = function() {
        angular.forEach($scope.configGroups, function(item, i) {
            item.groupIndex = i + 1;
        });
    };
    $scope.elementsNeedMeasuring = true;
    $scope.columns = [];
    $scope.renderedRows = [];
    $scope.renderedColumns = [];
    $scope.headerRow = null;
    $scope.rowHeight = self.config.rowHeight;
    $scope.jqueryUITheme = self.config.jqueryUITheme;
    $scope.showSelectionCheckbox = self.config.showSelectionCheckbox;
    $scope.enableCellSelection = self.config.enableCellSelection;
    $scope.enableCellEditOnFocus = self.config.enableCellEditOnFocus;
    $scope.footer = null;
    $scope.selectedItems = self.config.selectedItems;
    $scope.multiSelect = self.config.multiSelect;
    $scope.showFooter = self.config.showFooter;
    $scope.footerRowHeight = $scope.showFooter ? self.config.footerRowHeight : 0;
    $scope.showColumnMenu = self.config.showColumnMenu;
    $scope.forceSyncScrolling = self.config.forceSyncScrolling;
    $scope.showMenu = false;
    $scope.configGroups = [];
    $scope.gridId = self.gridId;
    $scope.enablePaging = self.config.enablePaging;
    $scope.pagingOptions = self.config.pagingOptions;
    $scope.i18n = {};
    $utils.seti18n($scope, self.config.i18n);
    $scope.adjustScrollLeft = function (scrollLeft) {
        var colwidths = 0,
            totalLeft = 0,
            x = $scope.columns.length,
            newCols = [],
            dcv = !self.config.enableColumnHeavyVirt;
        var r = 0;
        var addCol = function (c) {
            if (dcv) {
                newCols.push(c);
            } else {
                if (!$scope.renderedColumns[r]) {
                    $scope.renderedColumns[r] = c.copy();
                } else {
                    $scope.renderedColumns[r].setVars(c);
                }
            }
            r++;
        };
        for (var i = 0; i < x; i++) {
            var col = $scope.columns[i];
            if (col.visible !== false) {
                var w = col.width + colwidths;
                if (col.pinned) {
                    addCol(col);
                    var newLeft = i > 0 ? (scrollLeft + totalLeft) : scrollLeft;
                    domUtilityService.setColLeft(col, newLeft, self);
                    totalLeft += col.width;
                } else {
                    if (w >= scrollLeft) {
                        if (colwidths <= scrollLeft + self.rootDim.outerWidth) {
                            addCol(col);
                        }
                    }
                }
                colwidths += col.width;
            }
        }
        if (dcv) {
            $scope.renderedColumns = newCols;
        }
    };
    self.prevScrollTop = 0;
    self.prevScrollIndex = 0;
    $scope.adjustScrollTop = function(scrollTop, force) {
        if (self.prevScrollTop === scrollTop && !force) {
            return;
        }
        if (scrollTop > 0 && self.$viewport[0].scrollHeight - scrollTop <= self.$viewport.outerHeight()) {
            $scope.$emit('ngGridEventScroll');
        }
        var rowIndex = Math.floor(scrollTop / self.config.rowHeight);
        var newRange;
        if (self.filteredRows.length > self.config.virtualizationThreshold) {
            if (self.prevScrollTop < scrollTop && rowIndex < self.prevScrollIndex + SCROLL_THRESHOLD) {
                return;
            }
            if (self.prevScrollTop > scrollTop && rowIndex > self.prevScrollIndex - SCROLL_THRESHOLD) {
                return;
            }
            newRange = new ngRange(Math.max(0, rowIndex - EXCESS_ROWS), rowIndex + self.minRowsToRender() + EXCESS_ROWS);
        } else {
            var maxLen = $scope.configGroups.length > 0 ? self.rowFactory.parsedData.length : self.filteredRows.length;
            newRange = new ngRange(0, Math.max(maxLen, self.minRowsToRender() + EXCESS_ROWS));
        }
        self.prevScrollTop = scrollTop;
        self.rowFactory.UpdateViewableRange(newRange);
        self.prevScrollIndex = rowIndex;
    };
    $scope.toggleShowMenu = function() {
        $scope.showMenu = !$scope.showMenu;
    };
    $scope.toggleSelectAll = function(state, selectOnlyVisible) {
        $scope.selectionProvider.toggleSelectAll(state, false, selectOnlyVisible);
    };
    $scope.totalFilteredItemsLength = function() {
        return self.filteredRows.length;
    };
    $scope.showGroupPanel = function() {
        return self.config.showGroupPanel;
    };
    $scope.topPanelHeight = function() {
        return self.config.showGroupPanel === true ? self.config.headerRowHeight + 32 : self.config.headerRowHeight;
    };

    $scope.viewportDimHeight = function() {
        return Math.max(0, self.rootDim.outerHeight - $scope.topPanelHeight() - $scope.footerRowHeight - 2);
    };
    $scope.groupBy = function (col) {
        if (self.data.length < 1 || !col.groupable  || !col.field) {
            return;
        }
        if (!col.sortDirection) {
            col.sort({ shiftKey: $scope.configGroups.length > 0 ? true : false });
        }

        var indx = $scope.configGroups.indexOf(col);
        if (indx === -1) {
            col.isGroupedBy = true;
            $scope.configGroups.push(col);
            col.groupIndex = $scope.configGroups.length;
        } else {
            $scope.removeGroup(indx);
        }
        self.$viewport.scrollTop(0);
        domUtilityService.digest($scope);
    };
    $scope.removeGroup = function(index) {
        var col = $scope.columns.filter(function(item) {
            return item.groupIndex === (index + 1);
        })[0];
        col.isGroupedBy = false;
        col.groupIndex = 0;
        if ($scope.columns[index].isAggCol) {
            $scope.columns.splice(index, 1);
            $scope.configGroups.splice(index, 1);
            self.fixGroupIndexes();
        }
        if ($scope.configGroups.length === 0) {
            self.fixColumnIndexes();
            domUtilityService.digest($scope);
        }
        $scope.adjustScrollLeft(0);
    };
    $scope.togglePin = function (col) {
        var indexFrom = col.index;
        var indexTo = 0;
        for (var i = 0; i < $scope.columns.length; i++) {
            if (!$scope.columns[i].pinned) {
                break;
            }
            indexTo++;
        }
        if (col.pinned) {
            indexTo = Math.max(col.originalIndex, indexTo - 1);
        }
        col.pinned = !col.pinned;
        $scope.columns.splice(indexFrom, 1);
        $scope.columns.splice(indexTo, 0, col);
        self.fixColumnIndexes();
        domUtilityService.BuildStyles($scope, self, true);
        self.$viewport.scrollLeft(self.$viewport.scrollLeft() - col.width);
    };
    $scope.totalRowWidth = function() {
        var totalWidth = 0,
            cols = $scope.columns;
        for (var i = 0; i < cols.length; i++) {
            if (cols[i].visible !== false) {
                totalWidth += cols[i].width;
            }
        }
        return totalWidth;
    };
    $scope.headerScrollerDim = function() {
        var viewportH = $scope.viewportDimHeight(),
            maxHeight = self.maxCanvasHt,
            vScrollBarIsOpen = (maxHeight > viewportH),
            newDim = new ngDimension();

        newDim.autoFitHeight = true;
        newDim.outerWidth = $scope.totalRowWidth();
        if (vScrollBarIsOpen) {
            newDim.outerWidth += self.elementDims.scrollW;
        } else if ((maxHeight - viewportH) <= self.elementDims.scrollH) { 
            newDim.outerWidth += self.elementDims.scrollW;
        }
        return newDim;
    };
};

var ngRange = function (top, bottom) {
    this.topRow = top;
    this.bottomRow = bottom;
};
var ngRow = function (entity, config, selectionProvider, rowIndex, $utils) {
	this.entity = entity;
	this.config = config;
	this.selectionProvider = selectionProvider;
	this.rowIndex = rowIndex;
	this.utils = $utils;
	this.selected = selectionProvider.getSelection(entity);
	this.cursor = this.config.enableRowSelection && !this.config.selectWithCheckboxOnly ? 'pointer' : 'default';
	this.beforeSelectionChange = config.beforeSelectionChangeCallback;
	this.afterSelectionChange = config.afterSelectionChangeCallback;
	this.offsetTop = this.rowIndex * config.rowHeight;
	this.rowDisplayIndex = 0;
};

ngRow.prototype.setSelection = function (isSelected) {
	this.selectionProvider.setSelection(this, isSelected);
	this.selectionProvider.lastClickedRow = this;
};
ngRow.prototype.continueSelection = function (event) {
	this.selectionProvider.ChangeSelection(this, event);
};
ngRow.prototype.ensureEntity = function (expected) {
	if (this.entity !== expected) {
		this.entity = expected;
		this.selected = this.selectionProvider.getSelection(this.entity);
	}
};
ngRow.prototype.toggleSelected = function (event) {
	if (!this.config.enableRowSelection && !this.config.enableCellSelection) {
		return true;
	}
	var element = event.target || event;
	if (element.type === "checkbox" && element.parentElement.className !== "ngSelectionCell ng-scope") {
		return true;
	}
	if (this.config.selectWithCheckboxOnly && element.type !== "checkbox") {
		this.selectionProvider.lastClickedRow = this;
		return true;
	} 
	if (this.beforeSelectionChange(this, event)) {
		this.continueSelection(event);
	}
	return false;
};
ngRow.prototype.alternatingRowClass = function () {
	var isEven = (this.rowIndex % 2) === 0;
	var classes = {
		'ngRow' : true,
		'selected': this.selected,
		'even': isEven,
		'odd': !isEven,
		'ui-state-default': this.config.jqueryUITheme && isEven,
		'ui-state-active': this.config.jqueryUITheme && !isEven
	};
	return classes;
};
ngRow.prototype.getProperty = function (path) {
	return this.utils.evalProperty(this.entity, path);
};
ngRow.prototype.copy = function () {
	this.clone = new ngRow(this.entity, this.config, this.selectionProvider, this.rowIndex, this.utils);
	this.clone.isClone = true;
	this.clone.elm = this.elm;
	this.clone.orig = this;
	return this.clone;
};
ngRow.prototype.setVars = function (fromRow) {
	fromRow.clone = this;
	this.entity = fromRow.entity;
	this.selected = fromRow.selected;
    this.orig = fromRow;
};
var ngRowFactory = function (grid, $scope, domUtilityService, $templateCache, $utils) {
    var self = this;
    self.aggCache = {};
    self.parentCache = []; 
    self.dataChanged = true;
    self.parsedData = [];
    self.rowConfig = {};
    self.selectionProvider = $scope.selectionProvider;
    self.rowHeight = 30;
    self.numberOfAggregates = 0;
    self.groupedData = undefined;
    self.rowHeight = grid.config.rowHeight;
    self.rowConfig = {
        enableRowSelection: grid.config.enableRowSelection,
        rowClasses: grid.config.rowClasses,
        selectedItems: $scope.selectedItems,
        selectWithCheckboxOnly: grid.config.selectWithCheckboxOnly,
        beforeSelectionChangeCallback: grid.config.beforeSelectionChange,
        afterSelectionChangeCallback: grid.config.afterSelectionChange,
        jqueryUITheme: grid.config.jqueryUITheme,
        enableCellSelection: grid.config.enableCellSelection,
        rowHeight: grid.config.rowHeight
    };

    self.renderedRange = new ngRange(0, grid.minRowsToRender() + EXCESS_ROWS);
    self.buildEntityRow = function(entity, rowIndex) {
        return new ngRow(entity, self.rowConfig, self.selectionProvider, rowIndex, $utils);
    };

    self.buildAggregateRow = function(aggEntity, rowIndex) {
        var agg = self.aggCache[aggEntity.aggIndex]; 
        if (!agg) {
            agg = new ngAggregate(aggEntity, self, self.rowConfig.rowHeight, grid.config.groupsCollapsedByDefault);
            self.aggCache[aggEntity.aggIndex] = agg;
        }
        agg.rowIndex = rowIndex;
        agg.offsetTop = rowIndex * self.rowConfig.rowHeight;
        return agg;
    };
    self.UpdateViewableRange = function(newRange) {
        self.renderedRange = newRange;
        self.renderedChange();
    };
    self.filteredRowsChanged = function() {
        if (grid.lateBoundColumns && grid.filteredRows.length > 0) {
            grid.config.columnDefs = undefined;
            grid.buildColumns();
            grid.lateBoundColumns = false;
            $scope.$evalAsync(function() {
                $scope.adjustScrollLeft(0);
            });
        }
        self.dataChanged = true;
        if (grid.config.groups.length > 0) {
            self.getGrouping(grid.config.groups);
        }
        self.UpdateViewableRange(self.renderedRange);
    };

    self.renderedChange = function() {
        if (!self.groupedData || grid.config.groups.length < 1) {
            self.renderedChangeNoGroups();
            grid.refreshDomSizes();
            return;
        }
        self.wasGrouped = true;
        self.parentCache = [];
        var x = 0;
        var temp = self.parsedData.filter(function (e) {
            if (e.isAggRow) {
                if (e.parent && e.parent.collapsed) {
                    return false;
                }
                return true;
            }
            if (!e[NG_HIDDEN]) {
                e.rowIndex = x++;
            }
            return !e[NG_HIDDEN];
        });
        self.totalRows = temp.length;
        var rowArr = [];
        for (var i = self.renderedRange.topRow; i < self.renderedRange.bottomRow; i++) {
            if (temp[i]) {
                temp[i].offsetTop = i * grid.config.rowHeight;
                rowArr.push(temp[i]);
            }
        }
        grid.setRenderedRows(rowArr);
    };

    self.renderedChangeNoGroups = function () {
        var rowArr = [];
        for (var i = self.renderedRange.topRow; i < self.renderedRange.bottomRow; i++) {
            if (grid.filteredRows[i]) {
                grid.filteredRows[i].rowIndex = i;
                grid.filteredRows[i].offsetTop = i * grid.config.rowHeight;
                rowArr.push(grid.filteredRows[i]);
            }
        }
        grid.setRenderedRows(rowArr);
    };

    self.fixRowCache = function () {
        var newLen = grid.data.length;
        var diff = newLen - grid.rowCache.length;
        if (diff < 0) {
            grid.rowCache.length = grid.rowMap.length = newLen;
        } else {
            for (var i = grid.rowCache.length; i < newLen; i++) {
                grid.rowCache[i] = grid.rowFactory.buildEntityRow(grid.data[i], i);
            }
        }
    };
    self.parseGroupData = function(g) {
        if (g.values) {
            for (var x = 0; x < g.values.length; x++){
                self.parentCache[self.parentCache.length - 1].children.push(g.values[x]);
                self.parsedData.push(g.values[x]);
            }
        } else {
            for (var prop in g) {
                if (prop === NG_FIELD || prop === NG_DEPTH || prop === NG_COLUMN) {
                    continue;
                } else if (g.hasOwnProperty(prop)) {
                    var agg = self.buildAggregateRow({
                        gField: g[NG_FIELD],
                        gLabel: prop,
                        gDepth: g[NG_DEPTH],
                        isAggRow: true,
                        '_ng_hidden_': false,
                        children: [],
                        aggChildren: [],
                        aggIndex: self.numberOfAggregates,
                        aggLabelFilter: g[NG_COLUMN].aggLabelFilter
                    }, 0);
                    self.numberOfAggregates++;
                    agg.parent = self.parentCache[agg.depth - 1];
                    if (agg.parent) {
                        agg.parent.collapsed = false;
                        agg.parent.aggChildren.push(agg);
                    }
                    self.parsedData.push(agg);
                    self.parentCache[agg.depth] = agg;
                    self.parseGroupData(g[prop]);
                }
            }
        }
    };
    self.getGrouping = function(groups) {
        self.aggCache = [];
        self.numberOfAggregates = 0;
        self.groupedData = {};
        var rows = grid.filteredRows,
            maxDepth = groups.length,
            cols = $scope.columns;

        function filterCols(cols, group) {
            return cols.filter(function(c) {
                return c.field === group;
            });
        }

        for (var x = 0; x < rows.length; x++) {
            var model = rows[x].entity;
            if (!model) {
                return;
            }
            rows[x][NG_HIDDEN] = grid.config.groupsCollapsedByDefault;
            var ptr = self.groupedData;

            for (var y = 0; y < groups.length; y++) {
                var group = groups[y];

                var col = filterCols(cols, group)[0];

                var val = $utils.evalProperty(model, group);
                val = (val === '' || val === null) ? 'null' : val.toString();
                if (!ptr[val]) {
                    ptr[val] = {};
                }
                if (!ptr[NG_FIELD]) {
                    ptr[NG_FIELD] = group;
                }
                if (!ptr[NG_DEPTH]) {
                    ptr[NG_DEPTH] = y;
                }
                if (!ptr[NG_COLUMN]) {
                    ptr[NG_COLUMN] = col;
                }
                ptr = ptr[val];
            }
            if (!ptr.values) {
                ptr.values = [];
            }
            ptr.values.push(rows[x]);
        }
        if(cols.length > 0) {
            for (var z = 0; z < groups.length; z++) {
                if (!cols[z].isAggCol && z <= maxDepth) {
                    cols.splice(0, 0, new ngColumn({
                        colDef: {
                            field: '',
                            width: 25,
                            sortable: false,
                            resizable: false,
                            headerCellTemplate: '<div class="ngAggHeader"></div>',
                            pinned: grid.config.pinSelectionCheckbox
                        },
                        enablePinning: grid.config.enablePinning,
                        isAggCol: true,
                        headerRowHeight: grid.config.headerRowHeight
                    }, $scope, grid, domUtilityService, $templateCache, $utils));
                }
            }
        }

        grid.fixColumnIndexes();
        $scope.adjustScrollLeft(0);
        self.parsedData.length = 0;
        self.parseGroupData(self.groupedData);
        self.fixRowCache();
    };

    if (grid.config.groups.length > 0 && grid.filteredRows.length > 0) {
        self.getGrouping(grid.config.groups);
    }
};
var ngSearchProvider = function ($scope, grid, $filter, $utils) {
    var self = this,
        searchConditions = [];

    self.extFilter = grid.config.filterOptions.useExternalFilter;
    $scope.showFilter = grid.config.showFilter;
    $scope.filterText = '';

    self.fieldMap = {};

    var convertToFieldMap = function(obj) {
        var fieldMap = {};
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                fieldMap[prop.toLowerCase()] = obj[prop];
            }
        }
        return fieldMap;
    };

	var getAllPrimitiveValues = function(value) {
		if(typeof value === "object") {
            var arr = [];
			for(var prop in value) {
				arr = arr.concat(getAllPrimitiveValues(value[prop]));
			}
            return arr;
		}
		else {
			return [value];
		}
	};
    var searchEntireRow = function(condition, item, fieldMap){
        var result;
        for (var prop in item) {
            if (item.hasOwnProperty(prop)) {
                var c = fieldMap[prop.toLowerCase()];
                var pVal = item[prop];
                if(typeof pVal === 'object' && !(pVal instanceof Date)) {
                    var objectFieldMap = convertToFieldMap(c);
                    result = searchEntireRow(condition, pVal, objectFieldMap);
                    if (result) {
                        return true;
                    }
                } else {
                    var f = null,
                        s = null;
                    if (c && c.cellFilter) {
                        s = c.cellFilter.split(':');
                        f = $filter(s[0]);
                    }
                    if (pVal !== null && pVal !== undefined) {
                        if (typeof f === "function") {
                            var filterRes = f(pVal, s[1] ? s[1].slice(1,-1) : "").toString();
                            result = condition.regex.test(filterRes);
                        } else {
                            result = condition.regex.test(pVal.toString());
                        }
                        if (result) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    };

    var searchColumn = function(condition, item){
        var result;
        var col = self.fieldMap[condition.columnDisplay];
        if (!col) {
            return false;
        }
        var sp = col.cellFilter.split(':');
        var filter = col.cellFilter ? $filter(sp[0]) : null;
        var value = item[condition.column] || item[col.field.split('.')[0]] || $utils.evalProperty(item, col.field);
        if (value === null || value === undefined) {
            return false;
        }
        if (typeof filter === "function") {
            var filterResults = filter(typeof value === "object" ? evalObject(value, col.field) : value, sp[1]).toString();
            result = condition.regex.test(filterResults);
        }
        else {
            var primitiveValues = getAllPrimitiveValues(evalObject(value, col.field));
			for(var prop in primitiveValues) {
				result |= condition.regex.test(primitiveValues[prop]);
			}
        }
        if (result) {
            return true;
        }
        return false;
    };

    var filterFunc = function(item) {
        for (var x = 0, len = searchConditions.length; x < len; x++) {
            var condition = searchConditions[x];
            var result;
            if (!condition.column) {
                result = searchEntireRow(condition, item, self.fieldMap);
            } else {
                result = searchColumn(condition, item);
            }
            if(!result) {
                return false;
            }
        }
        return true;
    };

    self.evalFilter = function () {
        if (searchConditions.length === 0) {
            grid.filteredRows = grid.rowCache;
        } else {
            grid.filteredRows = grid.rowCache.filter(function(row) {
                return filterFunc(row.entity);
            });
        }
        for (var i = 0; i < grid.filteredRows.length; i++)
        {
            grid.filteredRows[i].rowIndex = i;

        }
        grid.rowFactory.filteredRowsChanged();
    };
    var evalObject = function (obj, columnName) {
        if (typeof obj !== "object" || typeof columnName !== "string") {
            return obj;
        }
        var args = columnName.split('.');
        var cObj = obj;
        if (args.length > 1) {
            for (var i = 1, len = args.length; i < len; i++) {
                cObj = cObj[args[i]];
                if (!cObj) {
                    return obj;
                }
            }
            return cObj;
        }
        return obj;
    };
    var getRegExp = function (str, modifiers) {
        try {
            return new RegExp(str, modifiers);
        } catch (err) {
            return new RegExp(str.replace(/(\^|\$|\(|\)|<|>|\[|\]|\{|\}|\\|\||\.|\*|\+|\?)/g, '\\$1'));
        }
    };
    var buildSearchConditions = function (a) {
        searchConditions = [];
        var qStr;
        if (!(qStr = $.trim(a))) {
            return;
        }
        var columnFilters = qStr.split(";");
        for (var i = 0; i < columnFilters.length; i++) {
            var args = columnFilters[i].split(':');
            if (args.length > 1) {
                var columnName = $.trim(args[0]);
                var columnValue = $.trim(args[1]);
                if (columnName && columnValue) {
                    searchConditions.push({
                        column: columnName,
                        columnDisplay: columnName.replace(/\s+/g, '').toLowerCase(),
                        regex: getRegExp(columnValue, 'i')
                    });
                }
            } else {
                var val = $.trim(args[0]);
                if (val) {
                    searchConditions.push({
                        column: '',
                        regex: getRegExp(val, 'i')
                    });
                }
            }
        }
    };

    if (!self.extFilter) {
         $scope.$on('$destroy', $scope.$watch('columns', function (cs) {
            for (var i = 0; i < cs.length; i++) {
                var col = cs[i];
                if (col.field) {
                    if(col.field.match(/\./g)){
                        var properties = col.field.split('.');
                        var currentProperty = self.fieldMap;
                        for(var j = 0; j < properties.length - 1; j++) {
                            currentProperty[ properties[j] ] =  currentProperty[ properties[j] ] || {};
                            currentProperty = currentProperty[properties[j]];
                        }
                        currentProperty[ properties[properties.length - 1] ] = col;
                    } else {
                        self.fieldMap[col.field.toLowerCase()] = col;
                    }
                }
                if (col.displayName) {
                    self.fieldMap[col.displayName.toLowerCase().replace(/\s+/g, '')] = col;
                }
            }
        }));
    }

     $scope.$on('$destroy', $scope.$watch(
        function () {
            return grid.config.filterOptions.filterText;
        },
        function (a) {
            $scope.filterText = a;
        }
    ));

    $scope.$on('$destroy', $scope.$watch('filterText', function(a){
        if (!self.extFilter) {
            $scope.$emit('ngGridEventFilter', a);
            buildSearchConditions(a);
            self.evalFilter();
        }
    }));
};

var ngSelectionProvider = function (grid, $scope, $parse, $utils) {
    var self = this;
    self.multi = grid.config.multiSelect;
    self.selectedItems = grid.config.selectedItems;
    self.selectedIndex = grid.config.selectedIndex;
    self.lastClickedRow = undefined;
    self.ignoreSelectedItemChanges = false; 
    var pKeyExpression = grid.config.primaryKey;
    if (pKeyExpression) {
      pKeyExpression = $utils.preEval('entity.' + grid.config.primaryKey);
    }
    self.pKeyParser = $parse(pKeyExpression);
    self.ChangeSelection = function (rowItem, evt) {
        var charCode = evt.which || evt.keyCode;
        var isUpDownKeyPress = (charCode === 40 || charCode === 38);

        if (evt && evt.shiftKey && !evt.keyCode && self.multi && grid.config.enableRowSelection) {
            if (self.lastClickedRow) {
                var rowsArr;
                if ($scope.configGroups.length > 0) {
                    rowsArr = grid.rowFactory.parsedData.filter(function(row) {
                        return !row.isAggRow;
                    });
                }
                else {
                    rowsArr = grid.filteredRows;
                }

                var thisIndx = rowItem.rowIndex;
                var prevIndx = self.lastClickedRowIndex;
                if (thisIndx === prevIndx) {
                    return false;
                }

                if (thisIndx < prevIndx) {
                    thisIndx = thisIndx ^ prevIndx;
                    prevIndx = thisIndx ^ prevIndx;
                    thisIndx = thisIndx ^ prevIndx;
                    thisIndx--;
                }
                else {
                    prevIndx++;
                }

                var rows = [];
                for (; prevIndx <= thisIndx; prevIndx++) {
                    rows.push(rowsArr[prevIndx]);
                }

                if (rows[rows.length - 1].beforeSelectionChange(rows, evt)) {
                    for (var i = 0; i < rows.length; i++) {
                        var ri = rows[i];
                        var selectionState = ri.selected;
                        ri.selected = !selectionState;
                        if (ri.clone) {
                            ri.clone.selected = ri.selected;
                        }
                        var index = self.selectedItems.indexOf(ri.entity);
                        if (index === -1) {
                            self.selectedItems.push(ri.entity);
                        }
                        else {
                            self.selectedItems.splice(index, 1);
                        }
                    }
                    rows[rows.length - 1].afterSelectionChange(rows, evt);
                }
                self.lastClickedRow = rowItem;
                self.lastClickedRowIndex = rowItem.rowIndex;

                return true;
            }
        }
        else if (!self.multi) {
            if (self.lastClickedRow === rowItem) {
                self.setSelection(self.lastClickedRow, grid.config.keepLastSelected ? true : !rowItem.selected);
            } else {
                if (self.lastClickedRow) {
                    self.setSelection(self.lastClickedRow, false);
                }
                self.setSelection(rowItem, !rowItem.selected);
            }
        }
        else if (!evt.keyCode || isUpDownKeyPress && !grid.config.selectWithCheckboxOnly) {
            self.setSelection(rowItem, !rowItem.selected);
        }
        self.lastClickedRow = rowItem;
        self.lastClickedRowIndex = rowItem.rowIndex;
        return true;
    };

    self.getSelection = function (entity) {
        return self.getSelectionIndex(entity) !== -1;
    };

    self.getSelectionIndex = function (entity) {
        var index = -1;
        if (grid.config.primaryKey) {
            var val = self.pKeyParser({entity: entity});
            angular.forEach(self.selectedItems, function (c, k) {
                if (val === self.pKeyParser({entity: c})) {
                    index = k;
                }
            });
        }
        else {
            index = self.selectedItems.indexOf(entity);
        }
        return index;
    };
    self.setSelection = function (rowItem, isSelected) {
        if(grid.config.enableRowSelection){
            if (!isSelected) {
                var indx = self.getSelectionIndex(rowItem.entity);
                if (indx !== -1) {
                    self.selectedItems.splice(indx, 1);
                }
            }
            else {
                if (self.getSelectionIndex(rowItem.entity) === -1) {
                    if (!self.multi && self.selectedItems.length > 0) {
                        self.toggleSelectAll(false, true);
                    }
                    self.selectedItems.push(rowItem.entity);
                }
            }
            rowItem.selected = isSelected;
            if (rowItem.orig) {
                rowItem.orig.selected = isSelected;
            }
            if (rowItem.clone) {
                rowItem.clone.selected = isSelected;
            }
            rowItem.afterSelectionChange(rowItem);
        }
    };
    self.toggleSelectAll = function (checkAll, bypass, selectFiltered) {
        var rows = selectFiltered ? grid.filteredRows : grid.rowCache, wasSelected, index;
        if (bypass || grid.config.beforeSelectionChange(rows, checkAll)) {
            if (!selectFiltered && self.selectedItems.length > 0) {
                self.selectedItems.length = 0;
            }
            for (var i = 0; i < rows.length; i++) {
                wasSelected = rows[i].selected;
                rows[i].selected = checkAll;
                if (rows[i].clone) {
                    rows[i].clone.selected = checkAll;
                }
                if (!wasSelected && checkAll) {
                    self.selectedItems.push(rows[i].entity);
                } else if (wasSelected && !checkAll) {
                    index = self.getSelectionIndex(rows[i].entity);
                    if (index > -1) {
                        self.selectedItems.splice(index, 1);
                    }
                }
            }
            if (!bypass) {
                grid.config.afterSelectionChange(rows, checkAll);
            }
        }
    };
};

var ngStyleProvider = function($scope, grid) {
    $scope.headerCellStyle = function(col) {
        return { "height": col.headerRowHeight + "px" };
    };
    $scope.rowStyle = function (row) {
        var ret = { "top": row.offsetTop + "px", "height": $scope.rowHeight + "px" };
        if (row.isAggRow) {
            ret.left = row.offsetLeft;
        }
        return ret;
    };
    $scope.canvasStyle = function() {
        return { "height": grid.maxCanvasHt + "px" };
    };
    $scope.headerScrollerStyle = function() {
        return { "height": grid.config.headerRowHeight + "px" };
    };
    $scope.topPanelStyle = function() {
        return { "width": grid.rootDim.outerWidth + "px", "height": $scope.topPanelHeight() + "px" };
    };
    $scope.headerStyle = function() {
        return { "width": grid.rootDim.outerWidth + "px", "height": grid.config.headerRowHeight + "px" };
    };
    $scope.groupPanelStyle = function () {
        return { "width": grid.rootDim.outerWidth + "px", "height": "32px" };
    };
    $scope.viewportStyle = function() {
        return { "width": grid.rootDim.outerWidth + "px", "height": $scope.viewportDimHeight() + "px" };
    };
    $scope.footerStyle = function() {
        return { "width": grid.rootDim.outerWidth + "px", "height": $scope.footerRowHeight + "px" };
    };
};
ngGridDirectives.directive('ngCellHasFocus', ['$domUtilityService',
    function (domUtilityService) {
        var focusOnInputElement = function($scope, elm) {
            $scope.isFocused = true;
            domUtilityService.digest($scope);

            $scope.$broadcast('ngGridEventStartCellEdit');
            $scope.$emit('ngGridEventStartCellEdit');

            $scope.$on('$destroy', $scope.$on('ngGridEventEndCellEdit', function() {
                $scope.isFocused = false;
                domUtilityService.digest($scope);
            }));
        };

        return function($scope, elm) {
            var isFocused = false;
            var isCellEditableOnMouseDown = false;

            $scope.editCell = function() {
                if(!$scope.enableCellEditOnFocus) {
                    setTimeout(function() {
                        focusOnInputElement($scope,elm);
                    }, 0);
                }
            };

            function mousedown (evt) {
                if($scope.enableCellEditOnFocus) {
                    isCellEditableOnMouseDown = true;
                } else {
                    elm.focus();
                }
                return true;
            }

            function click (evt) {
                if($scope.enableCellEditOnFocus) {
                    evt.preventDefault();
                    isCellEditableOnMouseDown = false;
                    focusOnInputElement($scope,elm);
                }
            }

            elm.bind('mousedown', mousedown);

            elm.bind('click', click);
            function focus (evt) {
                isFocused = true;
                if($scope.enableCellEditOnFocus && !isCellEditableOnMouseDown) {
                    focusOnInputElement($scope,elm);
                }
                return true;
            }

            elm.bind('focus', focus);

            function blur() {
                isFocused = false;
                return true;
            }

            elm.bind('blur', blur);

            function keydown (evt) {
                if(!$scope.enableCellEditOnFocus) {
                    if (isFocused && evt.keyCode !== 37 && evt.keyCode !== 38 && evt.keyCode !== 39 && evt.keyCode !== 40 && evt.keyCode !== 9 && !evt.shiftKey && evt.keyCode !== 13) {
                        focusOnInputElement($scope,elm);
                    }
                    if (isFocused && evt.shiftKey && (evt.keyCode >= 65 && evt.keyCode <= 90)) {
                        focusOnInputElement($scope, elm);
                    }
                    if (evt.keyCode === 27) {
                        elm.focus();
                    }
                }
                return true;
            }

            elm.bind('keydown', keydown);

            elm.on('$destroy', function() {
                elm.off('mousedown', mousedown);
                elm.off('click', click);
                elm.off('focus', focus);
                elm.off('blur', blur);
                elm.off('keydown', keydown);
            });
        };
    }]);

ngGridDirectives.directive('ngCellText',
  function () {
      return function(scope, elm) {
          function mouseover (evt) {
              evt.preventDefault();
          }
          elm.bind('mouseover', mouseover);

          function mouseleave(evt) {
              evt.preventDefault();
          }
          elm.bind('mouseleave', mouseleave);

          elm.on('$destroy', function() {
            elm.off('mouseover', mouseover);
            elm.off('mouseleave', mouseleave);
          });
      };
  });
ngGridDirectives.directive('ngCell', ['$compile', '$domUtilityService', '$utilityService', function ($compile, domUtilityService, utilityService) {
    var ngCell = {
        scope: false,
        compile: function() {
            return {
                pre: function($scope, iElement) {
                    var html;
                    var cellTemplate = $scope.col.cellTemplate.replace(COL_FIELD, utilityService.preEval('row.entity.' + $scope.col.field) );

                    if ($scope.col.enableCellEdit) {
                        html =  $scope.col.cellEditTemplate;
                        html = html.replace(CELL_EDITABLE_CONDITION, $scope.col.cellEditableCondition);
                        html = html.replace(DISPLAY_CELL_TEMPLATE, cellTemplate);
                        html = html.replace(EDITABLE_CELL_TEMPLATE, $scope.col.editableCellTemplate.replace(COL_FIELD, utilityService.preEval('row.entity.' + $scope.col.field)));
                    } else {
                        html = cellTemplate;
                    }

                    var cellElement = $(html);
                    iElement.append(cellElement);
                    $compile(cellElement)($scope);
                    if ($scope.enableCellSelection && cellElement[0].className.indexOf('ngSelectionCell') === -1) {
                        cellElement[0].setAttribute('tabindex', 0);
                        cellElement.addClass('ngCellElement');
                    }
                },
                post: function($scope, iElement) {
                    if ($scope.enableCellSelection) {
                        $scope.domAccessProvider.selectionHandlers($scope, iElement);
                    }
                    $scope.$on('$destroy', $scope.$on('ngGridEventDigestCell', function() {
                        domUtilityService.digest($scope);
                    }));
                }
            };
        }
    };
    return ngCell;
}]);

ngGridDirectives.directive('ngEditCellIf', [function () {
  return {
    transclude: 'element',
    priority: 1000,
    terminal: true,
    restrict: 'A',
    compile: function (e, a, transclude) {
      return function (scope, element, attr) {

        var childElement;
        var childScope;
         scope.$on('$destroy', scope.$watch(attr['ngEditCellIf'], function (newValue) {
          if (childElement) {
            childElement.remove();
            childElement = undefined;
          }
          if (childScope) {
            childScope.$destroy();
            childScope = undefined;
          }

          if (newValue) {
            childScope = scope.$new();
            transclude(childScope, function (clone) {
              childElement = clone;
              element.after(clone);
            });
          }
        }));
      };
    }
  };
}]);
ngGridDirectives.directive('ngGridFooter', ['$compile', '$templateCache', function ($compile, $templateCache) {
    var ngGridFooter = {
        scope: false,
        compile: function () {
            return {
                pre: function ($scope, iElement) {
                    if (iElement.children().length === 0) {
                        iElement.append($compile($templateCache.get($scope.gridId + 'footerTemplate.html'))($scope));
                    }
                }
            };
        }
    };
    return ngGridFooter;
}]);
ngGridDirectives.directive('ngGridMenu', ['$compile', '$templateCache', function ($compile, $templateCache) {
    var ngGridMenu = {
        scope: false,
        compile: function () {
            return {
                pre: function ($scope, iElement) {
                    if (iElement.children().length === 0) {
                        iElement.append($compile($templateCache.get($scope.gridId + 'menuTemplate.html'))($scope));
                    }
                }
            };
        }
    };
    return ngGridMenu;
}]);
ngGridDirectives.directive('ngGrid', ['$compile', '$filter', '$templateCache', '$sortService', '$domUtilityService', '$utilityService', '$timeout', '$parse', '$http', '$q', function ($compile, $filter, $templateCache, sortService, domUtilityService, $utils, $timeout, $parse, $http, $q) {
    var ngGridDirective = {
        scope: true,
        compile: function() {
            return {
                pre: function($scope, iElement, iAttrs) {
                    var $element = $(iElement);
                    var options = $scope.$eval(iAttrs.ngGrid);
                    options.gridDim = new ngDimension({ outerHeight: $($element).height(), outerWidth: $($element).width() });

                    var grid = new ngGrid($scope, options, sortService, domUtilityService, $filter, $templateCache, $utils, $timeout, $parse, $http, $q);
                    $scope.$on('$destroy', function cleanOptions() {
                        options.gridDim = null;
                        options.selectRow = null;
                        options.selectItem = null;
                        options.selectAll = null;
                        options.selectVisible = null;
                        options.groupBy = null;
                        options.sortBy = null;
                        options.gridId = null;
                        options.ngGrid = null;
                        options.$gridScope = null;
                        options.$gridServices = null;

                        $scope.domAccessProvider.grid = null;
                        angular.element(grid.styleSheet).remove();
                        grid.styleSheet = null;
                    });

                    return grid.init().then(function() {
                        if (typeof options.columnDefs === "string") {
                            $scope.$on('$destroy', $scope.$parent.$watch(options.columnDefs, function (a) {
                                if (!a) {
                                    grid.refreshDomSizes();
                                    grid.buildColumns();
                                    return;
                                }
                                grid.lateBoundColumns = false;
                                $scope.columns = [];
                                grid.config.columnDefs = a;
                                grid.buildColumns();
                                grid.eventProvider.assignEvents();
                                domUtilityService.RebuildGrid($scope, grid);
                            }, true));
                        }
                        else {
                            grid.buildColumns();
                        }
                        if (typeof options.totalServerItems === "string") {
                            $scope.$on('$destroy', $scope.$parent.$watch(options.totalServerItems, function (newTotal, oldTotal) {
                                if (!angular.isDefined(newTotal)) {
                                    $scope.totalServerItems = 0;
                                }
                                else {
                                    $scope.totalServerItems = newTotal;
                                }
                            }));
                        }
                        else {
                            $scope.totalServerItems = 0;
                        }
                        if (typeof options.data === "string") {
                            var dataWatcher = function (a) {
                                grid.data = $.extend([], a);
                                grid.rowFactory.fixRowCache();
                                angular.forEach(grid.data, function (item, j) {
                                    var indx = grid.rowMap[j] || j;
                                    if (grid.rowCache[indx]) {
                                        grid.rowCache[indx].ensureEntity(item);
                                    }
                                    grid.rowMap[indx] = j;
                                });
                                grid.searchProvider.evalFilter();
                                grid.configureColumnWidths();
                                grid.refreshDomSizes();
                                if (grid.config.sortInfo.fields.length > 0) {
                                    grid.sortColumnsInit();
                                    $scope.$emit('ngGridEventSorted', grid.config.sortInfo);
                                }
                                $scope.$emit("ngGridEventData", grid.gridId);
                            };
                            $scope.$on('$destroy', $scope.$parent.$watch(options.data, dataWatcher));
                            $scope.$on('$destroy', $scope.$parent.$watch(options.data + '.length', function() {
                                dataWatcher($scope.$eval(options.data));
								$scope.adjustScrollTop(grid.$viewport.scrollTop(), true);
                            }));
                        }
                        grid.footerController = new ngFooter($scope, grid);
                        iElement.addClass("ngGrid").addClass(grid.gridId.toString());
                        if (!options.enableHighlighting) {
                            iElement.addClass("unselectable");
                        }
                        if (options.jqueryUITheme) {
                            iElement.addClass('ui-widget');
                        }
                        iElement.append($compile($templateCache.get('gridTemplate.html'))($scope));
                        domUtilityService.AssignGridContainers($scope, iElement, grid);
                        grid.eventProvider = new ngEventProvider(grid, $scope, domUtilityService, $timeout);
                        options.selectRow = function (rowIndex, state) {
                            if (grid.rowCache[rowIndex]) {
                                if (grid.rowCache[rowIndex].clone) {
                                    grid.rowCache[rowIndex].clone.setSelection(state ? true : false);
                                } 
                                grid.rowCache[rowIndex].setSelection(state ? true : false);
                            }
                        };
                        options.selectItem = function (itemIndex, state) {
                            options.selectRow(grid.rowMap[itemIndex], state);
                        };
                        options.selectAll = function (state) {
                            $scope.toggleSelectAll(state);
                        };
                        options.selectVisible = function (state) {
                            $scope.toggleSelectAll(state, true);
                        };
                        options.groupBy = function (field) {
                            if (field) {
                                $scope.groupBy($scope.columns.filter(function(c) {
                                    return c.field === field;
                                })[0]);
                            } else {
                                var arr = $.extend(true, [], $scope.configGroups);
                                angular.forEach(arr, $scope.groupBy);
                            }
                        };
                        options.sortBy = function (field) {
                            var col = $scope.columns.filter(function (c) {
                                return c.field === field;
                            })[0];
                            if (col) {
                                col.sort();
                            }
                        };
                        options.gridId = grid.gridId;
                        options.ngGrid = grid;
                        options.$gridScope = $scope;
                        options.$gridServices = { SortService: sortService, DomUtilityService: domUtilityService, UtilityService: $utils };

                        $scope.$on('$destroy', $scope.$on('ngGridEventDigestGrid', function(){
                            domUtilityService.digest($scope.$parent);
                        }));
                        $scope.$on('$destroy', $scope.$on('ngGridEventDigestGridParent', function(){
                            domUtilityService.digest($scope.$parent);
                        }));
                        $scope.$evalAsync(function() {
                            $scope.adjustScrollLeft(0);
                        });
                        angular.forEach(options.plugins, function (p) {
                            if (typeof p === "function") {
                                p = new p(); 
                            }
                            var newScope = $scope.$new();
                            p.init(newScope, grid, options.$gridServices);
                            options.plugins[$utils.getInstanceType(p)] = p;

                            $scope.$on('$destroy', function() {
                                newScope.$destroy();
                            });
                        });
                        if (typeof options.init === "function") {
                            options.init(grid, $scope);
                        }
                        return null;
                    });
                }
            };
        }
    };
    return ngGridDirective;
}]);

ngGridDirectives.directive('ngHeaderCell', ['$compile', function($compile) {
    var ngHeaderCell = {
        scope: false,
        compile: function() {
            return {
                pre: function($scope, iElement) {
                    iElement.append($compile($scope.col.headerCellTemplate)($scope));
                }
            };
        }
    };
    return ngHeaderCell;
}]);
ngGridDirectives.directive('ngHeaderRow', ['$compile', '$templateCache', function ($compile, $templateCache) {
    var ngHeaderRow = {
        scope: false,
        compile: function () {
            return {
                pre: function ($scope, iElement) {
                    if (iElement.children().length === 0) {
                        iElement.append($compile($templateCache.get($scope.gridId + 'headerRowTemplate.html'))($scope));
                    }
                }
            };
        }
    };
    return ngHeaderRow;
}]);
ngGridDirectives.directive('ngInput', [function() {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ngModel) {
            var oldCellValue;
            var dereg = scope.$watch('ngModel', function() {
                oldCellValue = ngModel.$modelValue;
                dereg(); 
            });

            function keydown (evt) {
                switch (evt.keyCode) {
                    case 37: 
                    case 38: 
                    case 39: 
                    case 40: 
                        evt.stopPropagation();
                        break;
                    case 27: 
                        if (!scope.$$phase) {
                            scope.$apply(function() {
                                ngModel.$setViewValue(oldCellValue);
                                elm.blur();
                            });
                        }
                        break;
                    case 13: 
                        if(scope.enableCellEditOnFocus && scope.totalFilteredItemsLength() - 1 > scope.row.rowIndex && scope.row.rowIndex > 0  || scope.col.enableCellEdit) {
                            elm.blur();
                        }
                        break;
                }

                return true;
            }
            elm.bind('keydown', keydown);

            function click (evt) {
                evt.stopPropagation();
            }

            elm.bind('click', click);
            function mousedown (evt) {
                evt.stopPropagation();
            }

            elm.bind('mousedown', mousedown);

            elm.on('$destroy', function() {
                elm.off('keydown', keydown);
                elm.off('click', click);
                elm.off('mousedown', mousedown);
            });

            scope.$on('$destroy', scope.$on('ngGridEventStartCellEdit', function () {
                elm.focus();
                elm.select();
            }));

            angular.element(elm).bind('blur', function () {
                scope.$emit('ngGridEventEndCellEdit');
            });
        }
    };
}]);

ngGridDirectives.directive('ngRow', ['$compile', '$domUtilityService', '$templateCache', function ($compile, domUtilityService, $templateCache) {
    var ngRow = {
        scope: false,
        compile: function() {
            return {
                pre: function($scope, iElement) {
                    $scope.row.elm = iElement;
                    if ($scope.row.clone) {
                        $scope.row.clone.elm = iElement;
                    }
                    if ($scope.row.isAggRow) {
                        var html = $templateCache.get($scope.gridId + 'aggregateTemplate.html');
                        if ($scope.row.aggLabelFilter) {
                            html = html.replace(CUSTOM_FILTERS, '| ' + $scope.row.aggLabelFilter);
                        } else {
                            html = html.replace(CUSTOM_FILTERS, "");
                        }
                        iElement.append($compile(html)($scope));
                    } else {
                        iElement.append($compile($templateCache.get($scope.gridId + 'rowTemplate.html'))($scope));
                    }
					$scope.$on('$destroy', $scope.$on('ngGridEventDigestRow', function(){
						domUtilityService.digest($scope);
					}));
                }
            };
        }
    };
    return ngRow;
}]);
ngGridDirectives.directive('ngViewport', [function() {
    return function($scope, elm) {
        var isMouseWheelActive;
        var prevScollLeft;
        var prevScollTop = 0;
        var ensureDigest = function() {
            if (!$scope.$root.$$phase) {
                $scope.$digest();
            }
        };
        var scrollTimer;

        function scroll (evt) {
            var scrollLeft = evt.target.scrollLeft,
                scrollTop = evt.target.scrollTop;
            if ($scope.$headerContainer) {
                $scope.$headerContainer.scrollLeft(scrollLeft);
            }
            $scope.adjustScrollLeft(scrollLeft);
            $scope.adjustScrollTop(scrollTop);
            if ($scope.forceSyncScrolling) {
                ensureDigest();
            } else {
                clearTimeout(scrollTimer);
                scrollTimer = setTimeout(ensureDigest, 150);
            }
            prevScollLeft = scrollLeft;
            prevScollTop = scrollTop;
            isMouseWheelActive = false;
            return true;
        }

        elm.bind('scroll', scroll);

        function mousewheel() {
            isMouseWheelActive = true;
            if (elm.focus) { elm.focus(); }
            return true;
        }

        elm.bind("mousewheel DOMMouseScroll", mousewheel);

        elm.on('$destroy', function() {
            elm.off('scroll', scroll);
            elm.off('mousewheel DOMMouseScroll', mousewheel);
        });

        if (!$scope.enableCellSelection) {
            $scope.domAccessProvider.selectionHandlers($scope, elm);
        }
    };
}]);
window.ngGrid.i18n['da'] = {
    ngAggregateLabel: 'artikler',
    ngGroupPanelDescription: 'Grupér rækker udfra en kolonne ved at trække dens overskift hertil.',
    ngSearchPlaceHolder: 'Søg...',
    ngMenuText: 'Vælg kolonner:',
    ngShowingItemsLabel: 'Viste rækker:',
    ngTotalItemsLabel: 'Rækker totalt:',
    ngSelectedItemsLabel: 'Valgte rækker:',
    ngPageSizeLabel: 'Side størrelse:',
    ngPagerFirstTitle: 'Første side',
    ngPagerNextTitle: 'Næste side',
    ngPagerPrevTitle: 'Forrige side',
    ngPagerLastTitle: 'Sidste side'
};
window.ngGrid.i18n['de'] = {
    ngAggregateLabel: 'eintrag',
    ngGroupPanelDescription: 'Ziehen Sie eine Spaltenüberschrift hierhin um nach dieser Spalte zu gruppieren.',
    ngSearchPlaceHolder: 'Suche...',
    ngMenuText: 'Spalten auswählen:',
    ngShowingItemsLabel: 'Zeige Einträge:',
    ngTotalItemsLabel: 'Einträge gesamt:',
    ngSelectedItemsLabel: 'Ausgewählte Einträge:',
    ngPageSizeLabel: 'Einträge pro Seite:',
    ngPagerFirstTitle: 'Erste Seite',
    ngPagerNextTitle: 'Nächste Seite',
    ngPagerPrevTitle: 'Vorherige Seite',
    ngPagerLastTitle: 'Letzte Seite'
};
window.ngGrid.i18n['en'] = {
    ngAggregateLabel: 'items',
    ngGroupPanelDescription: 'Drag a column header here and drop it to group by that column.',
    ngSearchPlaceHolder: 'Search...',
    ngMenuText: 'Choose Columns:',
    ngShowingItemsLabel: 'Showing Items:',
    ngTotalItemsLabel: 'Total Items:',
    ngSelectedItemsLabel: 'Selected Items:',
    ngPageSizeLabel: 'Page Size:',
    ngPagerFirstTitle: 'First Page',
    ngPagerNextTitle: 'Next Page',
    ngPagerPrevTitle: 'Previous Page',
    ngPagerLastTitle: 'Last Page'
};
window.ngGrid.i18n['es'] = {
    ngAggregateLabel: 'Artículos',
    ngGroupPanelDescription: 'Arrastre un encabezado de columna aquí y soltarlo para agrupar por esa columna.',
    ngSearchPlaceHolder: 'Buscar...',
    ngMenuText: 'Elegir columnas:',
    ngShowingItemsLabel: 'Artículos Mostrando:',
    ngTotalItemsLabel: 'Artículos Totales:',
    ngSelectedItemsLabel: 'Artículos Seleccionados:',
    ngPageSizeLabel: 'Tamaño de Página:',
    ngPagerFirstTitle: 'Primera Página',
    ngPagerNextTitle: 'Página Siguiente',
    ngPagerPrevTitle: 'Página Anterior',
    ngPagerLastTitle: 'Última Página'
};
window.ngGrid.i18n['fa'] = {
    ngAggregateLabel: 'موردها',
    ngGroupPanelDescription: 'یک عنوان ستون اینجا را بردار و به گروهی از آن ستون بیانداز.',
    ngSearchPlaceHolder: 'جستجو...',
    ngMenuText: 'انتخاب ستون\u200cها:',
    ngShowingItemsLabel: 'نمایش موردها:',
    ngTotalItemsLabel: 'همهٔ موردها:',
    ngSelectedItemsLabel: 'موردهای انتخاب\u200cشده:',
    ngPageSizeLabel: 'اندازهٔ صفحه:',
    ngPagerFirstTitle: 'صفحهٔ اول',
    ngPagerNextTitle: 'صفحهٔ بعد',
    ngPagerPrevTitle: 'صفحهٔ قبل',
    ngPagerLastTitle: 'آخرین صفحه'
};

window.ngGrid.i18n['fr'] = {
    ngAggregateLabel: 'articles',
    ngGroupPanelDescription: 'Faites glisser un en-tête de colonne ici et déposez-le vers un groupe par cette colonne.',
    ngSearchPlaceHolder: 'Recherche...',
    ngMenuText: 'Choisir des colonnes:',
    ngShowingItemsLabel: 'Articles Affichage des:',
    ngTotalItemsLabel: 'Nombre total d\'articles:',
    ngSelectedItemsLabel: 'Éléments Articles:',
    ngPageSizeLabel: 'Taille de page:',
    ngPagerFirstTitle: 'Première page',
    ngPagerNextTitle: 'Page Suivante',
    ngPagerPrevTitle: 'Page précédente',
    ngPagerLastTitle: 'Dernière page'
};
window.ngGrid.i18n['nl'] = {
    ngAggregateLabel: 'items',
    ngGroupPanelDescription: 'Sleep hier een kolomkop om op te groeperen.',
    ngSearchPlaceHolder: 'Zoeken...',
    ngMenuText: 'Kies kolommen:',
    ngShowingItemsLabel: 'Toon items:',
    ngTotalItemsLabel: 'Totaal items:',
    ngSelectedItemsLabel: 'Geselecteerde items:',
    ngPageSizeLabel: 'Pagina grootte:, ',
    ngPagerFirstTitle: 'Eerste pagina',
    ngPagerNextTitle: 'Volgende pagina',
    ngPagerPrevTitle: 'Vorige pagina',
    ngPagerLastTitle: 'Laatste pagina'
};

window.ngGrid.i18n['pt-br'] = {
    ngAggregateLabel: 'itens',
    ngGroupPanelDescription: 'Arraste e solte uma coluna aqui para agrupar por essa coluna',
    ngSearchPlaceHolder: 'Procurar...',
    ngMenuText: 'Selecione as colunas:',
    ngShowingItemsLabel: 'Mostrando os Itens:',
    ngTotalItemsLabel: 'Total de Itens:',
    ngSelectedItemsLabel: 'Items Selecionados:',
    ngPageSizeLabel: 'Tamanho da Página:',
    ngPagerFirstTitle: 'Primeira Página',
    ngPagerNextTitle: 'Próxima Página',
    ngPagerPrevTitle: 'Página Anterior',
    ngPagerLastTitle: 'Última Página'
};

window.ngGrid.i18n['ru'] = {
    ngAggregateLabel: 'записи',
    ngGroupPanelDescription: 'Перетащите сюда заголовок колонки для группировки по этой колонке.',
    ngSearchPlaceHolder: 'Искать...',
    ngMenuText: 'Выберите столбцы:',
    ngShowingItemsLabel: 'Показаны записи:',
    ngTotalItemsLabel: 'Всего записей:',
    ngSelectedItemsLabel: 'Выбранные записи:',
    ngPageSizeLabel: 'Строк на странице:',
    ngPagerFirstTitle: 'Первая страница',
    ngPagerNextTitle: 'Следующая страница',
    ngPagerPrevTitle: 'Предыдущая страница',
    ngPagerLastTitle: 'Последняя страница'
};
window.ngGrid.i18n['zh-cn'] = {
    ngAggregateLabel: '条目',
    ngGroupPanelDescription: '拖曳表头到此处以进行分组',
    ngSearchPlaceHolder: '搜索...',
    ngMenuText: '数据分组与选择列：',
    ngShowingItemsLabel: '当前显示条目：',
    ngTotalItemsLabel: '条目总数：',
    ngSelectedItemsLabel: '选中条目：',
    ngPageSizeLabel: '每页显示数：',
    ngPagerFirstTitle: '回到首页',
    ngPagerNextTitle: '下一页',
    ngPagerPrevTitle: '上一页',
    ngPagerLastTitle: '前往尾页' 
};

window.ngGrid.i18n['zh-tw'] = {
    ngAggregateLabel: '筆',
    ngGroupPanelDescription: '拖拉表頭到此處以進行分組',
    ngSearchPlaceHolder: '搜尋...',
    ngMenuText: '選擇欄位：',
    ngShowingItemsLabel: '目前顯示筆數：',
    ngTotalItemsLabel: '總筆數：',
    ngSelectedItemsLabel: '選取筆數：',
    ngPageSizeLabel: '每頁顯示：',
    ngPagerFirstTitle: '第一頁',
    ngPagerNextTitle: '下一頁',
    ngPagerPrevTitle: '上一頁',
    ngPagerLastTitle: '最後頁'
};

angular.module('ngGrid').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('aggregateTemplate.html',
    "<div ng-click=\"row.toggleExpand()\" ng-style=\"rowStyle(row)\" class=\"ngAggregate\">\r" +
    "\n" +
    "    <span class=\"ngAggregateText\">{{row.label CUSTOM_FILTERS}} ({{row.totalChildren()}} {{AggItemsLabel}})</span>\r" +
    "\n" +
    "    <div class=\"{{row.aggClass()}}\"></div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );
  $templateCache.put('cellEditTemplate.html',
    "<div ng-cell-has-focus ng-dblclick=\"CELL_EDITABLE_CONDITION && editCell()\">\r" +
    "\n" +
    "\t<div ng-edit-cell-if=\"!(isFocused && CELL_EDITABLE_CONDITION)\">\t\r" +
    "\n" +
    "\t\tDISPLAY_CELL_TEMPLATE\r" +
    "\n" +
    "\t</div>\r" +
    "\n" +
    "\t<div ng-edit-cell-if=\"isFocused && CELL_EDITABLE_CONDITION\">\r" +
    "\n" +
    "\t\tEDITABLE_CELL_TEMPLATE\r" +
    "\n" +
    "\t</div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );
  $templateCache.put('cellTemplate.html',
    "<div class=\"ngCellText\" ng-class=\"col.colIndex()\"><span ng-cell-text>{{COL_FIELD CUSTOM_FILTERS}}</span></div>"
  );
  $templateCache.put('checkboxCellTemplate.html',
    "<div class=\"ngSelectionCell\"><input tabindex=\"-1\" class=\"ngSelectionCheckbox\" type=\"checkbox\" ng-checked=\"row.selected\" /></div>"
  );
  $templateCache.put('checkboxHeaderTemplate.html',
    "<input class=\"ngSelectionHeader\" type=\"checkbox\" ng-show=\"multiSelect\" ng-model=\"allSelected\" ng-change=\"toggleSelectAll(allSelected, true)\"/>"
  );
  $templateCache.put('editableCellTemplate.html',
    "<input ng-class=\"'colt' + col.index\" ng-input=\"COL_FIELD\" ng-model=\"COL_FIELD\" />"
  );
  $templateCache.put('footerTemplate.html',
    "<div ng-show=\"showFooter\" class=\"ngFooterPanel\" ng-class=\"{'ui-widget-content': jqueryUITheme, 'ui-corner-bottom': jqueryUITheme}\" ng-style=\"footerStyle()\">\r" +
    "\n" +
    "    <div class=\"ngTotalSelectContainer\" >\r" +
    "\n" +
    "        <div class=\"ngFooterTotalItems\" ng-class=\"{'ngNoMultiSelect': !multiSelect}\" >\r" +
    "\n" +
    "            <span class=\"ngLabel\">{{i18n.ngTotalItemsLabel}} {{maxRows()}}</span><span ng-show=\"filterText.length > 0\" class=\"ngLabel\">({{i18n.ngShowingItemsLabel}} {{totalFilteredItemsLength()}})</span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"ngFooterSelectedItems\" ng-show=\"multiSelect\">\r" +
    "\n" +
    "            <span class=\"ngLabel\">{{i18n.ngSelectedItemsLabel}} {{selectedItems.length}}</span>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"ngPagerContainer\" style=\"float: right; margin-top: 10px;\" ng-show=\"enablePaging\" ng-class=\"{'ngNoMultiSelect': !multiSelect}\">\r" +
    "\n" +
    "        <div style=\"float:left; margin-right: 10px;\" class=\"ngRowCountPicker\">\r" +
    "\n" +
    "            <span style=\"float: left; margin-top: 3px;\" class=\"ngLabel\">{{i18n.ngPageSizeLabel}}</span>\r" +
    "\n" +
    "            <select style=\"float: left;height: 27px; width: 100px\" ng-model=\"pagingOptions.pageSize\" >\r" +
    "\n" +
    "                <option ng-repeat=\"size in pagingOptions.pageSizes\">{{size}}</option>\r" +
    "\n" +
    "            </select>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div style=\"float:left; margin-right: 10px; line-height:25px;\" class=\"ngPagerControl\" style=\"float: left; min-width: 135px;\">\r" +
    "\n" +
    "            <button type=\"button\" class=\"ngPagerButton\" ng-click=\"pageToFirst()\" ng-disabled=\"cantPageBackward()\" title=\"{{i18n.ngPagerFirstTitle}}\"><div class=\"ngPagerFirstTriangle\"><div class=\"ngPagerFirstBar\"></div></div></button>\r" +
    "\n" +
    "            <button type=\"button\" class=\"ngPagerButton\" ng-click=\"pageBackward()\" ng-disabled=\"cantPageBackward()\" title=\"{{i18n.ngPagerPrevTitle}}\"><div class=\"ngPagerFirstTriangle ngPagerPrevTriangle\"></div></button>\r" +
    "\n" +
    "            <input class=\"ngPagerCurrent\" min=\"1\" max=\"{{currentMaxPages}}\" type=\"number\" style=\"width:50px; height: 24px; margin-top: 1px; padding: 0 4px;\" ng-model=\"pagingOptions.currentPage\"/>\r" +
    "\n" +
    "            <span class=\"ngGridMaxPagesNumber\" ng-show=\"maxPages() > 0\">/ {{maxPages()}}</span>\r" +
    "\n" +
    "            <button type=\"button\" class=\"ngPagerButton\" ng-click=\"pageForward()\" ng-disabled=\"cantPageForward()\" title=\"{{i18n.ngPagerNextTitle}}\"><div class=\"ngPagerLastTriangle ngPagerNextTriangle\"></div></button>\r" +
    "\n" +
    "            <button type=\"button\" class=\"ngPagerButton\" ng-click=\"pageToLast()\" ng-disabled=\"cantPageToLast()\" title=\"{{i18n.ngPagerLastTitle}}\"><div class=\"ngPagerLastTriangle\"><div class=\"ngPagerLastBar\"></div></div></button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );
  $templateCache.put('gridTemplate.html',
    "<div class=\"ngTopPanel\" ng-class=\"{'ui-widget-header':jqueryUITheme, 'ui-corner-top': jqueryUITheme}\" ng-style=\"topPanelStyle()\">\r" +
    "\n" +
    "    <div class=\"ngGroupPanel\" ng-show=\"showGroupPanel()\" ng-style=\"groupPanelStyle()\">\r" +
    "\n" +
    "        <div class=\"ngGroupPanelDescription\" ng-show=\"configGroups.length == 0\">{{i18n.ngGroupPanelDescription}}</div>\r" +
    "\n" +
    "        <ul ng-show=\"configGroups.length > 0\" class=\"ngGroupList\">\r" +
    "\n" +
    "            <li class=\"ngGroupItem\" ng-repeat=\"group in configGroups\">\r" +
    "\n" +
    "                <span class=\"ngGroupElement\">\r" +
    "\n" +
    "                    <span class=\"ngGroupName\">{{group.displayName}}\r" +
    "\n" +
    "                        <span ng-click=\"removeGroup($index)\" class=\"ngRemoveGroup\">x</span>\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                    <span ng-hide=\"$last\" class=\"ngGroupArrow\"></span>\r" +
    "\n" +
    "                </span>\r" +
    "\n" +
    "            </li>\r" +
    "\n" +
    "        </ul>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"ngHeaderContainer\" ng-style=\"headerStyle()\">\r" +
    "\n" +
    "        <div ng-header-row class=\"ngHeaderScroller\" ng-style=\"headerScrollerStyle()\"></div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-grid-menu></div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div class=\"ngViewport\" unselectable=\"on\" ng-viewport ng-class=\"{'ui-widget-content': jqueryUITheme}\" ng-style=\"viewportStyle()\">\r" +
    "\n" +
    "    <div class=\"ngCanvas\" ng-style=\"canvasStyle()\">\r" +
    "\n" +
    "        <div ng-style=\"rowStyle(row)\" ng-repeat=\"row in renderedRows\" ng-click=\"row.toggleSelected($event)\" ng-class=\"row.alternatingRowClass()\" ng-row></div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div ng-grid-footer></div>\r" +
    "\n"
  );
  $templateCache.put('headerCellTemplate.html',
    "<div class=\"ngHeaderSortColumn {{col.headerClass}}\" ng-style=\"{'cursor': col.cursor}\" ng-class=\"{ 'ngSorted': !col.noSortVisible() }\">\r" +
    "\n" +
    "    <div ng-click=\"col.sort($event)\" ng-class=\"'colt' + col.index\" class=\"ngHeaderText\">{{col.displayName}}</div>\r" +
    "\n" +
    "    <div class=\"ngSortButtonDown\" ng-click=\"col.sort($event)\" ng-show=\"col.showSortButtonDown()\"></div>\r" +
    "\n" +
    "    <div class=\"ngSortButtonUp\" ng-click=\"col.sort($event)\" ng-show=\"col.showSortButtonUp()\"></div>\r" +
    "\n" +
    "    <div class=\"ngSortPriority\">{{col.sortPriority}}</div>\r" +
    "\n" +
    "    <div ng-class=\"{ ngPinnedIcon: col.pinned, ngUnPinnedIcon: !col.pinned }\" ng-click=\"togglePin(col)\" ng-show=\"col.pinnable\"></div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div ng-show=\"col.resizable\" class=\"ngHeaderGrip\" ng-click=\"col.gripClick($event)\" ng-mousedown=\"col.gripOnMouseDown($event)\"></div>\r" +
    "\n"
  );
  $templateCache.put('headerRowTemplate.html',
    "<div ng-style=\"{ height: col.headerRowHeight }\" ng-repeat=\"col in renderedColumns\" ng-class=\"col.colIndex()\" class=\"ngHeaderCell\">\r" +
    "\n" +
    "\t<div class=\"ngVerticalBar\" ng-style=\"{height: col.headerRowHeight}\" ng-class=\"{ ngVerticalBarVisible: !$last }\">&nbsp;</div>\r" +
    "\n" +
    "\t<div ng-header-cell></div>\r" +
    "\n" +
    "</div>"
  );
  $templateCache.put('menuTemplate.html',
    "<div ng-show=\"showColumnMenu || showFilter\"  class=\"ngHeaderButton\" ng-click=\"toggleShowMenu()\">\r" +
    "\n" +
    "    <div class=\"ngHeaderButtonArrow\"></div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "<div ng-show=\"showMenu\" class=\"ngColMenu\">\r" +
    "\n" +
    "    <div ng-show=\"showFilter\">\r" +
    "\n" +
    "        <input placeholder=\"{{i18n.ngSearchPlaceHolder}}\" type=\"text\" ng-model=\"filterText\"/>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div ng-show=\"showColumnMenu\">\r" +
    "\n" +
    "        <span class=\"ngMenuText\">{{i18n.ngMenuText}}</span>\r" +
    "\n" +
    "        <ul class=\"ngColList\">\r" +
    "\n" +
    "            <li class=\"ngColListItem\" ng-repeat=\"col in columns | ngColumns\">\r" +
    "\n" +
    "                <label><input ng-disabled=\"col.pinned\" type=\"checkbox\" class=\"ngColListCheckbox\" ng-model=\"col.visible\"/>{{col.displayName}}</label>\r" +
    "\n" +
    "\t\t\t\t<a title=\"Group By\" ng-class=\"col.groupedByClass()\" ng-show=\"col.groupable && col.visible\" ng-click=\"groupBy(col)\"></a>\r" +
    "\n" +
    "\t\t\t\t<span class=\"ngGroupingNumber\" ng-show=\"col.groupIndex > 0\">{{col.groupIndex}}</span>          \r" +
    "\n" +
    "            </li>\r" +
    "\n" +
    "        </ul>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );
  $templateCache.put('rowTemplate.html',
    "<div ng-style=\"{ 'cursor': row.cursor }\" ng-repeat=\"col in renderedColumns\" ng-class=\"col.colIndex()\" class=\"ngCell {{col.cellClass}}\">\r" +
    "\n" +
    "\t<div class=\"ngVerticalBar\" ng-style=\"{height: rowHeight}\" ng-class=\"{ ngVerticalBarVisible: !$last }\">&nbsp;</div>\r" +
    "\n" +
    "\t<div ng-cell></div>\r" +
    "\n" +
    "</div>"
  );

}]);

}(window, jQuery));
// THIS CODE IS GENERATED. DO NOT MODIFY
/* istanbul ignore next */
(function(angular) {
    'use strict';
    /*jshint sub:true*/
    angular.module('csEmployeeV2', ['bmHttpUtils', 'bluemoon.components.session']).service('csEmployeeV2',
        ['$http', 'bmHttpUtils', 'AuthenticatedSessionData',
        function($http, bmHttpUtils, authenticatedSessionData) {
            return {
                getList: function(params, suppressErrors) {
                    if (console.warn && console.trace) { console.warn('EmployeeV2_GetList endpoint is deprecated.'); console.trace(); }
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v2/companies/{companyId}/employees';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);

                        var query = {
                            'orderBy': paramsCopy['orderBy'],
                            'search': paramsCopy['search'],
                            'searchBy': paramsCopy['searchBy'],
                            'filter': paramsCopy['filter'],
                            'startIndex': paramsCopy['startIndex'],
                            'pageIndex': paramsCopy['pageIndex'],
                            'itemsPerPage': paramsCopy['itemsPerPage'],
                            'expand': paramsCopy['expand']
                        };
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'GET', params: query, headers: {} }), suppressErrors);
                    });
                },

                post: function(params, suppressErrors) {
                    if (console.warn && console.trace) { console.warn('EmployeeV2_Post endpoint is deprecated.'); console.trace(); }
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v2/companies/{companyId}/employees';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                delete: function(params, suppressErrors) {
                    if (console.warn && console.trace) { console.warn('EmployeeV2_Delete endpoint is deprecated.'); console.trace(); }
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v2/companies/{companyId}/employees/{employeeId}';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        url = url.replace(/{employeeId}/g, paramsCopy['employeeId']);
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'DELETE', params: {}, headers: {} }), suppressErrors);
                    });
                },

                get: function(params, suppressErrors) {
                    if (console.warn && console.trace) { console.warn('EmployeeV2_Get endpoint is deprecated.'); console.trace(); }
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v2/companies/{companyId}/employees/{employeeId}';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        url = url.replace(/{employeeId}/g, paramsCopy['employeeId']);

                        var query = {
                            'expand': paramsCopy['expand']
                        };
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'GET', params: query, headers: {} }), suppressErrors);
                    });
                },

                put: function(params, suppressErrors) {
                    if (console.warn && console.trace) { console.warn('EmployeeV2_Put endpoint is deprecated.'); console.trace(); }
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v2/companies/{companyId}/employees/{employeeId}';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);
                        url = url.replace(/{employeeId}/g, paramsCopy['employeeId']);
                        var strippedData = bmHttpUtils.getStrippedObject(params['data'], '$', 'Expanded');
                        return bmHttpUtils.unwrapAndValidateHttpPromise(params['data'],
                            $http({url: url, method: 'PUT', params: {}, headers: {}, data: strippedData }), suppressErrors);
                    });
                },

                getDefault: function(params, suppressErrors) {
                    if (console.warn && console.trace) { console.warn('EmployeeV2_GetDefault endpoint is deprecated.'); console.trace(); }
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v2/companies/{companyId}/employees/default';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);

                        var query = {
                            'expand': paramsCopy['expand']
                        };
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'GET', params: query, headers: {} }), suppressErrors);
                    });
                },

                verifyValueIsUnique: function(params, suppressErrors) {
                    if (console.warn && console.trace) { console.warn('EmployeeV2_VerifyValueIsUnique endpoint is deprecated.'); console.trace(); }
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v2/companies/{companyId}/employees/verify-value-is-unique';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);

                        var query = {
                            'value': paramsCopy['value'],
                            'excludeId': paramsCopy['excludeId']
                        };
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'GET', params: query, headers: {} }), suppressErrors);
                    });
                }

            };
        }]);
}(window.angular));

(function(angular){
    'use strict';

    angular.module('bluemoon.dms', [
    ])

    .constant('dmsConstants', {
        translationNamespace: 'Bluemoon.DMS'
    })

    .service('dmsService', [
        'dmsConstants',
        '$translate',
        function(dmsConstants, $translate){

            this.translationLoader = function(namespace) {
                return function(key, values) {
                    return $translate.instant([namespace, key].join('.'), values);
                };
            };

            this.fullyQualifiedTranslationNamespace = dmsConstants.translationNamespace;
            this.translations = this.translationLoader(this.fullyQualifiedTranslationNamespace);
        }
    ])

    .directive('dmsHtmlCompile', ['$compile',
        function($compile) {
            return {
                link: function(scope, element, attrs) {

                    var compileExpression = function() {
                        return scope.$eval(attrs.dmsHtmlCompile);
                    };

                    var assignValueToDom = function(value) {
                        // when the 'compile' expression changes
                        // assign it into the current DOM
                        element.html(value);

                        // compile the new DOM and link it to the current
                        // scope.
                        // NOTE: we only compile .childNodes so that
                        // we don't get into infinite loop compiling ourselves
                        $compile(element.contents())(scope);
                    };

                    scope.$watch(compileExpression, assignValueToDom);
                }
            };
        }
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.alerts.templates', []);

    angular.module('bluemoon.dms.alerts', [
        'pascalprecht.translate',
        'bluemoon.dms.alerts.templates',
        'bluemoon.dms.models',
        'bluemoon.dms.ui-services',
        'bluemoon.dms'//,
        //'onvio.components',
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.alerts.upload', [
        'pascalprecht.translate',
        'bluemoon.dms.alerts',
        'bluemoon.dms.upload',
        'bluemoon.dms.ui-services',
        'bluemoon.dms.format',
        'bluemoon.dms.models',
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.alerts.operation', [
        'bluemoon.dms.managers',
        'bluemoon.dms.services',
        'bluemoon.dms.alerts',
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.alerts')

    .constant('dmsAlertDirectiveConstants', {
        translationNamespace: 'Alerts'
    })

    .service('dmsAlertDirectiveService', [
        function() {
            this.templatePath = function(template) {
                return 'components/alerts/' + template + '.2js.html';
            };
        }
    ])

    .directive('dmsAlert', ['dmsAlertDirectiveService',
        function(dmsAlertDirectiveService) {
            return {
                restrict: 'E',
                replace: true,
                scope: {
                    dmsAlert: '=',
                    closeAlert: '&close',
                },
                templateUrl: dmsAlertDirectiveService.templatePath('dms-alert-directive'),
                transclude: true,
            };
        }
    ]);

})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.alerts')

    .constant('dmsAlertConstants', {
        statuses : {
            waiting: 'waiting',
            inProgress: 'in-progress',
            success: 'success',
            error: 'error',
        }
    })

    .service('dmsAlertService', [
        'DmsAlertModel',
        'DmsUploadAlertModel',
        'DmsOperationAlertModel',
        function(
            DmsAlertModel,
            DmsUploadAlertModel,
            DmsOperationAlertModel){
            this._id = 0;

            this.createAlert = function(alertData) {
                alertData.id = this._id++;
                return new DmsAlertModel(alertData);
            };

            this.createUploadAlert = function(alertData){
                alertData.id = this._id++;
                return new DmsUploadAlertModel(alertData);
            };

            this.createOperationAlert = function(operation) {
                return new DmsOperationAlertModel({
                    id: this._id++,
                    operation: operation
                });
            };

            this.removeAlert = function(collection, toRemove) {
                for(var i = 0; i < collection.length; i++) {
                    if (collection[i].id === toRemove.id) {
                        collection.splice(i, 1);
                        break;
                    }
                }
            };

            this.removeAlertWhere = function(collection, predicate) {
                for(var i = 0; i < collection.length; i++) {
                    if (predicate(collection[i])) {
                        collection.splice(i, 1);
                        i--;
                    }
                }
            };
        }
    ]);

})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.alerts.operation')

    .service('dmsAddOperationAlertService', [
        '$translate',
        '$q',
        'dmsApiOperationService',
        'dmsAlertService',
        'dmsAlertConstants',
        'fileManager',
        'folderManager',
        'projectManager',
        'bluemoon.components.httpStatusCodes',
        function(
            $translate,
            $q,
            dmsApiOperationService,
            dmsAlertService,
            dmsAlertConstants,
            fileManager,
            folderManager,
            projectManager,
            httpStatusCodes) {

            this.scopeSetup = function($scope) {

                var _getDestinationContainerId = function() {
                    return $scope.dmsAlert.operation.operationData.destinationContainerId;
                };

                var _getDestinationContainerType = function() {
                    return $scope.dmsAlert.operation.operationData.destinationContainerType;
                };

                var _getOperationData = function() {
                    return $scope.dmsAlert.operation.operationData;
                };

                var _getDestinationItemName = function() {
                    return _getOperationData().item.name;
                };

                var _resolveDefer = function(defer) {
                    return function(s){
                        defer.resolve(s);
                    };
                };

                var _getConflictString = function(operationData) {

                    var defer = $q.defer();

                    var item = operationData.item;

                    switch (item.itemType) {
                        case 'Folder':
                            if (operationData.source === 'dmsUploadService') {
                                $translate('Bluemoon.DMS.Alerts.KeepBothOrReplaceFolders').then(_resolveDefer(defer));
                            }else {
                                $translate('Bluemoon.DMS.Alerts.ItemAlreadyExists').then(_resolveDefer(defer));
                            }
                            break;
                        case 'Project':
                            if (item.productType === 'DMSClientFolder') {
                                $translate('Bluemoon.DMS.Alerts.ItemAlreadyExists').then(_resolveDefer(defer));
                            }
                            break;
                        case 'Document':
                            $translate('Bluemoon.DMS.Alerts.KeepBothOrReplaceFiles').then(_resolveDefer(defer));
                            break;
                    }

                    return defer.promise;
                };

                var _getSuccessString = function(item) {

                    var defer = $q.defer();

                    switch (item.itemType) {
                        case 'Folder':
                            $translate('Bluemoon.DMS.Alerts.ItemAddedSuccessfully',
                                { itemName: item.name }).then(_resolveDefer(defer));
                            break;
                        case 'Project':
                            if (item.productType === 'DMSClientFolder') {
                                $translate('Bluemoon.DMS.Alerts.ItemAddedSuccessfully',
                                    { itemName: item.name }).then(_resolveDefer(defer));
                            }
                            break;
                        case 'Document':
                            $translate('Bluemoon.DMS.Alerts.ItemAddedSuccessfully',
                                { itemName: item.name }).then(_resolveDefer(defer));
                            break;
                    }

                    return defer.promise;
                };

                var _getErrorString = function(item) {

                    var defer = $q.defer();

                    switch (item.itemType) {
                        case 'Folder':
                            $translate('Bluemoon.DMS.Alerts.ItemCouldNotBeAdded',
                                { itemName: item.name }).then(_resolveDefer(defer));
                            break;
                        case 'Project':
                            if (item.productType === 'DMSClientFolder') {
                                $translate('Bluemoon.DMS.Alerts.ItemCouldNotBeAdded',
                                    { itemName: item.name }).then(_resolveDefer(defer));
                            }
                            break;
                        case 'Document':
                            $translate('Bluemoon.DMS.Alerts.ItemCouldNotBeAdded',
                                { itemName: item.name }).then(_resolveDefer(defer));
                            break;
                    }

                    return defer.promise;
                };

                $scope.$watch('dmsAlert.operation.httpStatusCode', function(newHttpStatusCode){

                    var operationData = _getOperationData();
                    var newItem = operationData.item;

                    $scope.dmsAlert.msg = '';

                    if (!newHttpStatusCode) {

                        $translate('Bluemoon.DMS.Alerts.AddInProgress', { itemName: newItem.name }).then(function(s){
                            $scope.dmsAlert.msg = s;
                        });

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.inProgress;
                        $scope.hideAlert = false;

                        return;
                    }

                    switch (newHttpStatusCode) {
                        case httpStatusCodes.conflict:

                            $scope.dmsAlert.msg = $translate('Bluemoon.DMS.Alerts.ItemAlreadyExists',
                                { itemName: newItem.name }).then(function(itemAlreadyExists){
                                    $scope.dmsAlert.msg = itemAlreadyExists;
                                });

                            _getConflictString(operationData)
                                .then(function(conflictString){
                                    $scope.dmsAlert.statement = conflictString;
                                    $scope.dmsAlert.showStatement = true;
                                });

                            $scope.dmsAlert.status = dmsAlertConstants.statuses.error;
                            $scope.hideAlert = false;

                            break;
                        case httpStatusCodes.forbidden:

                            $translate('Bluemoon.DMS.OperationForbidden')
                                .then(function(forbiddenString){
                                    $scope.dmsAlert.msg = forbiddenString;
                                });

                            $scope.dmsAlert.status = dmsAlertConstants.statuses.error;
                            $scope.hideAlert = false;

                            break;
                        case httpStatusCodes.ok:      //  For folders
                        case httpStatusCodes.created: //  For documents

                            _getSuccessString(newItem).then(function(successString){
                                $scope.dmsAlert.msg = successString;
                            });

                            $scope.dmsAlert.status = dmsAlertConstants.statuses.success;
                            $scope.hideAlert = false;

                            break;
                        case undefined:

                            break;
                        default:

                            _getErrorString(newItem).then(function(errorString){
                                $scope.dmsAlert.msg = errorString;
                            });

                            $scope.dmsAlert.status = dmsAlertConstants.statuses.error;
                            $scope.hideAlert = false;

                            break;
                    }
                });

                $scope.keepBoth = function() {

                    dmsApiOperationService.operations.remove($scope.dmsAlert.operation);
                    dmsApiOperationService.clearFromBatch($scope.dmsAlert.operation);

                    var operationData = _getOperationData();
                    var newItem = operationData.item;

                    switch (newItem.itemType) {
                        case 'Folder':
                            folderManager.findName(newItem.parentId, newItem.name,
                                newItem.parentType).then(function(newName) {
                                    newItem.name = newName;

                                    var newAddOperation = folderManager.addFolder(newItem);
                                    newAddOperation.operationCompletedDefer = $scope.dmsAlert.operation.operationCompletedDefer;

                                    $scope.dmsAlert = dmsAlertService.createOperationAlert(newAddOperation);
                                });
                            break;
                        case 'Project':
                            projectManager.findName(
                                newItem.primaryAssociationId,
                                newItem.primaryAssociationType,
                                newItem.name,
                                newItem.productType,
                                newItem.processingYear,
                                newItem.processingPeriod).then(function(newName) {
                                    newItem.name = newName;

                                    var newAddOperation = projectManager.addProject(newItem);
                                    newAddOperation.operationCompletedDefer = $scope.dmsAlert.operation.operationCompletedDefer;

                                    $scope.dmsAlert = dmsAlertService.createOperationAlert(newAddOperation);
                                });
                            break;
                        case 'Document':
                            break;
                    }
                };

                $scope.replace = function() {

                    dmsApiOperationService.operations.remove($scope.dmsAlert.operation);
                    dmsApiOperationService.clearFromBatch($scope.dmsAlert.operation);

                    var operationData = _getOperationData();
                    var newItem = operationData.item;

                    switch (newItem.itemType) {
                        case 'Folder':
                            var destinationContainerId = _getDestinationContainerId();
                            var destinationItemName = _getDestinationItemName();
                            var destinationContainerType = _getDestinationContainerType();

                            folderManager.getFolderExists(destinationContainerId,
                                destinationItemName,
                                destinationContainerType).then(function(existsResponseData){
                                    if (existsResponseData.data && existsResponseData.data.length > 0 && existsResponseData.data[0].exists){
                                        var itemIdToReplace = existsResponseData.data[0].id;

                                        folderManager.deleteFolder(itemIdToReplace).then(function(deleteResponseData){
                                            if (deleteResponseData.status === window.successStatus) {
                                                var newAddOperation = folderManager.addFolder(newItem);
                                                newAddOperation.operationCompletedDefer = $scope.dmsAlert.operation.operationCompletedDefer;

                                                $scope.dmsAlert = dmsAlertService.createOperationAlert(newAddOperation);
                                            }
                                        });
                                    }
                                });
                            break;
                        case 'Project':
                            projectManager.getProjectExists(newItem).then(function(existsResponseData){
                                if (existsResponseData.data && existsResponseData.data.length > 0 && existsResponseData.data[0].exists){
                                    var itemIdToReplace = existsResponseData.data[0].project.id;

                                    projectManager.deleteProject(itemIdToReplace).then(function(deleteResponseData){
                                        if (deleteResponseData.status === window.successStatus) {
                                            var newAddOperation = projectManager.addProject(newItem);
                                            newAddOperation.operationCompletedDefer = $scope.dmsAlert.operation.operationCompletedDefer;

                                            $scope.dmsAlert = dmsAlertService.createOperationAlert(newAddOperation);
                                        }
                                    });
                                }
                            });
                            break;
                        case 'Document':
                            break;
                    }
                };

                $scope.ignoreTransclusion = true;

                $scope.hideAlert = true;
            };
        }
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.alerts.operation')

    .service('dmsCopyOperationAlertService', [
        '$translate',
        '$q',
        'dmsApiOperationService',
        'dmsAlertService',
        'dmsAlertConstants',
        'fileManager',
        'folderManager',
        'bluemoon.components.httpStatusCodes',
        function(
            $translate,
            $q,
            dmsApiOperationService,
            dmsAlertService,
            dmsAlertConstants,
            fileManager,
            folderManager,
            httpStatusCodes) {

            this.scopeSetup = function($scope) {

                var _getDestinationContainerId = function() {
                    return $scope.dmsAlert.operation.operationData.destinationContainerId;
                };

                var _getDestinationContainerType = function() {
                    return $scope.dmsAlert.operation.operationData.destinationContainerType;
                };

                var _getSourceItem = function() {
                    return $scope.dmsAlert.operation.operationData.sourceItem;
                };

                var _getDestinationFileName = function() {
                    return _getSourceItem().name;
                };

                var _resolveDefer = function(defer) {
                    return function(s){
                        defer.resolve(s);
                    };
                };

                var _getConflictString = function(itemType) {
                    var defer = $q.defer();
                    var sourceItem = _getSourceItem();
                    var destinationContainerId = _getDestinationContainerId();

                    switch (itemType) {
                        case 'Folder':

                            folderManager.getFolderAncestors(sourceItem.id).then(function(ancestorData){

                                var isDestinationAnAncestor = false;
                                var currentItem = ancestorData.data;

                                do {
                                    if (currentItem.parentItem && currentItem.parentItem.id === destinationContainerId) {
                                        isDestinationAnAncestor = true;
                                        break;
                                    }
                                } while (!!(currentItem = currentItem.parentItem));

                                if (isDestinationAnAncestor) {
                                    $translate('Bluemoon.DMS.Alerts.KeepBothFolders').then(_resolveDefer(defer));
                                } else {
                                    $translate('Bluemoon.DMS.Alerts.KeepBothOrReplaceFolders').then(_resolveDefer(defer));
                                }
                            });
                            break;
                        case 'Document':
                            if (sourceItem.parentItem.id === destinationContainerId) {
                                $translate('Bluemoon.DMS.Alerts.KeepBothFolders').then(_resolveDefer(defer));
                            } else {
                                $translate('Bluemoon.DMS.Alerts.KeepBothOrReplaceFiles').then(_resolveDefer(defer));
                            }
                            break;
                    }

                    return defer.promise;
                };

                var _getSuccessString = function(sourceItem) {
                    var defer = $q.defer();

                    switch (sourceItem.itemType) {
                        case 'Folder':
                            $translate('Bluemoon.DMS.Alerts.Operation.FolderCopiedSuccessfully',
                                { itemName: (sourceItem.replacementName ? sourceItem.replacementName : sourceItem.name) }).then(_resolveDefer(defer));
                            break;
                        case 'Document':
                            $translate('Bluemoon.DMS.Alerts.Operation.DocumentCopiedSuccessfully',
                                { itemName: (sourceItem.replacementName ? sourceItem.replacementName : sourceItem.name) }).then(_resolveDefer(defer));
                            break;
                    }

                    return defer.promise;
                };

                var _getErrorString = function(sourceItem) {
                    var defer = $q.defer();

                    switch (sourceItem.itemType) {
                        case 'Folder':
                            $translate('Bluemoon.DMS.Alerts.Operation.FolderCouldNotBeCopied',
                                { itemName: sourceItem.name }).then(_resolveDefer(defer));
                            break;
                        case 'Document':
                            $translate('Bluemoon.DMS.Alerts.Operation.DocumentCouldNotBeCopied',
                                { itemName: sourceItem.name }).then(_resolveDefer(defer));
                            break;
                    }

                    return defer.promise;
                };

                $scope.$watch('dmsAlert.operation.httpStatusCode', function(newHttpStatusCode){

                    var sourceItem = _getSourceItem();

                    if (!newHttpStatusCode) {

                        $translate('Bluemoon.DMS.Alerts.CopyInProgress', { itemName: sourceItem.name }).then(function(s){
                            $scope.dmsAlert.msg = s;
                        });

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.inProgress;
                        $scope.hideAlert = false;

                        return;
                    }

                    switch (newHttpStatusCode) {
                        case httpStatusCodes.conflict:

                            var conflictStringPromise = _getConflictString(sourceItem.itemType);

                            $translate('Bluemoon.DMS.Alerts.ItemAlreadyExists',
                                { itemName: sourceItem.name }).then(function(itemAlreadyExistsString){
                                    $scope.dmsAlert.msg = itemAlreadyExistsString;
                                });

                            $scope.dmsAlert.status = dmsAlertConstants.statuses.error;

                            conflictStringPromise.then(function(conflictString){
                                $scope.dmsAlert.statement = conflictString;
                                $scope.hideAlert = false;
                                $scope.dmsAlert.showStatement = true;
                            });

                            break;
                        case httpStatusCodes.forbidden:

                            $translate('Bluemoon.DMS.OperationForbidden')
                                .then(function(operationForbiddenString){
                                    $scope.dmsAlert.msg = operationForbiddenString;
                                });
                            $scope.dmsAlert.status = dmsAlertConstants.statuses.error;
                            $scope.hideAlert = false;

                            break;
                        case httpStatusCodes.ok:      //  For folders
                        case httpStatusCodes.created: //  For documents

                            _getSuccessString(sourceItem).then(function(successString){
                                $scope.dmsAlert.msg = successString;
                            });

                            $scope.dmsAlert.status = dmsAlertConstants.statuses.success;
                            $scope.hideAlert = false;

                            break;
                        default:

                            _getErrorString(sourceItem).then(function(errorString){
                                $scope.dmsAlert.msg = errorString;
                            });

                            $scope.dmsAlert.status = dmsAlertConstants.statuses.error;
                            $scope.hideAlert = false;

                            break;
                    }
                });

                var findNameFunctions = {
                    Folder: folderManager.findName,
                    Document: fileManager.findName,
                };

                var copyItemFunctions = {
                    Folder: folderManager.copyFolder,
                    Document: fileManager.copyDocument,
                };

                var itemExistsFunctions = {
                    Folder: folderManager.getFolderExists,
                    Document: fileManager.getDocumentExists,
                };

                $scope.keepBoth = function() {

                    dmsApiOperationService.operations.remove($scope.dmsAlert.operation);
                    dmsApiOperationService.clearFromBatch($scope.dmsAlert.operation);

                    var destinationContainerId = _getDestinationContainerId();
                    var destinationFileName = _getDestinationFileName();
                    var destinationContainerType = _getDestinationContainerType();

                    var sourceItem = _getSourceItem();

                    var findName = findNameFunctions[sourceItem.itemType];
                    findName(destinationContainerId, destinationFileName,
                        destinationContainerType).then(function(newName) {

                            var copyOfSourceItem = {
                                replacementName: newName
                            };

                            angular.extend(copyOfSourceItem, sourceItem);

                            var copyItem = copyItemFunctions[sourceItem.itemType];
                            var newCopyOperation = copyItem(
                                copyOfSourceItem,
                                destinationContainerId,
                                destinationContainerType);

                            $scope.dmsAlert = dmsAlertService.createOperationAlert(newCopyOperation);
                        });
                };

                $scope.replace = function() {

                    dmsApiOperationService.operations.remove($scope.dmsAlert.operation);
                    dmsApiOperationService.clearFromBatch($scope.dmsAlert.operation);

                    var destinationContainerId = _getDestinationContainerId();
                    var destinationFileName = _getDestinationFileName();
                    var destinationContainerType = _getDestinationContainerType();

                    var sourceItem = _getSourceItem();

                    var itemExists = itemExistsFunctions[sourceItem.itemType];
                    itemExists(destinationContainerId,
                        destinationFileName,
                        destinationContainerType).then(function(existsResponseData){
                            if (existsResponseData.data && existsResponseData.data.length > 0 && existsResponseData.data[0].exists){
                                var itemIdToReplace = existsResponseData.data[0].id;

                                    var deleteItemPromise =
                                        sourceItem.itemType === 'Folder' ? folderManager.deleteFolder(itemIdToReplace) :
                                        sourceItem.itemType === 'Document' ? fileManager.deleteDocument(
                                            destinationContainerId,
                                            itemIdToReplace,
                                            destinationContainerType) : undefined;

                                    if (deleteItemPromise) {
                                        deleteItemPromise.then(function(deleteResponseData){
                                            if (deleteResponseData.status === window.successStatus) {

                                                var copyItem = copyItemFunctions[sourceItem.itemType];

                                                var newCopyOperation = copyItem(
                                                    _getSourceItem(),
                                                    destinationContainerId,
                                                    destinationContainerType);

                                                $scope.dmsAlert = dmsAlertService.createOperationAlert(newCopyOperation);
                                            }
                                        });
                                    }
                            }
                        });
                };

                $scope.ignoreTransclusion = true;

                $scope.hideAlert = true;
            };
        }
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.alerts.operation')

    .service('dmsDeleteOperationAlertService', [
        '$translate',
        '$q',
        'dmsApiOperationService',
        'dmsAlertService',
        'dmsAlertConstants',
        'fileManager',
        'folderManager',
        'projectManager',
        'bluemoon.components.httpStatusCodes',
        function(
            $translate,
            $q,
            dmsApiOperationService,
            dmsAlertService,
            dmsAlertConstants,
            fileManager,
            folderManager,
            projectManager,
            httpStatusCodes) {

            this.scopeSetup = function($scope) {

                var _getOperationData = function() {
                    return $scope.dmsAlert.operation.operationData;
                };

                var _resolveDefer = function(defer) {
                    return function(s){
                        defer.resolve(s);
                    };
                };

                var _getSuccessString = function(item) {

                    var defer = $q.defer();

                    switch (item.itemType) {
                        case 'Folder':
                        case 'Project':
                            $translate('Bluemoon.DMS.Alerts.Operation.FolderDeletedSuccessfully',
                                { itemName: item.name }).then(_resolveDefer(defer));
                            break;
                        case 'Document':
                            $translate('Bluemoon.DMS.Alerts.Operation.DocumentDeletedSuccessfully',
                                { itemName: item.name }).then(_resolveDefer(defer));
                            break;
                    }

                    return defer.promise;
                };

                $scope.$watch('dmsAlert.operation.httpStatusCode', function(newHttpStatusCode){

                    var operationData = _getOperationData();
                    var item = operationData.item;

                    if (!newHttpStatusCode) {

                        $translate('Bluemoon.DMS.Alerts.DeleteInProgress', { itemName: item.name }).then(function(s){
                            $scope.dmsAlert.msg = s;
                        });

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.inProgress;
                        $scope.hideAlert = false;

                        return;
                    }

                    switch (newHttpStatusCode) {
                        case httpStatusCodes.noContent:

                            _getSuccessString(item).then(function(successString){
                                $scope.dmsAlert.msg = successString;
                            });

                            $scope.dmsAlert.status = dmsAlertConstants.statuses.success;
                            $scope.hideAlert = false;

                            break;
                        case httpStatusCodes.forbidden:

                            $translate('Bluemoon.DMS.OperationForbidden')
                                .then(function(operationForbiddenString){
                                    $scope.dmsAlert.msg = operationForbiddenString;
                                });

                            $scope.dmsAlert.status = dmsAlertConstants.statuses.error;
                            $scope.hideAlert = false;

                            break;
                        case undefined:
                            break;
                        default:

                            $translate('Bluemoon.DMS.Alerts.ItemCouldNotBeDeleted',
                                { itemName: item.name }).then(function(itemCouldNotBeDeletedString){
                                    $scope.dmsAlert.msg = itemCouldNotBeDeletedString;
                                });

                            $scope.dmsAlert.status = dmsAlertConstants.statuses.error;
                            $scope.hideAlert = false;

                            break;
                    }

                    $scope.dmsAlert.showStatement = $scope.dmsAlert.statement && $scope.dmsAlert.statement !== '';
                });

                $scope.ignoreTransclusion = true;

                $scope.hideAlert = true;
            };
        }
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.alerts.operation')

    .service('dmsMoveOperationAlertService', [
        '$translate',
        '$q',
        'dmsApiOperationService',
        'dmsAlertService',
        'dmsAlertConstants',
        'fileManager',
        'folderManager',
        'bluemoon.components.httpStatusCodes',
        function(
            $translate,
            $q,
            dmsApiOperationService,
            dmsAlertService,
            dmsAlertConstants,
            fileManager,
            folderManager,
            httpStatusCodes) {

            this.scopeSetup = function($scope) {

                var _getDestinationContainerId = function() {
                    return $scope.dmsAlert.operation.operationData.destinationContainerId;
                };

                var _getDestinationContainerType = function() {
                    return $scope.dmsAlert.operation.operationData.destinationContainerType;
                };

                var _getSourceItem = function() {
                    return $scope.dmsAlert.operation.operationData.sourceItem;
                };

                var _getDestinationFileName = function() {
                    return _getSourceItem().name;
                };

                var _resolveDefer = function(defer) {
                    return function(s){
                        defer.resolve(s);
                    };
                };

                var _getConflictString = function(itemType) {
                    var defer = $q.defer();

                    switch (itemType) {
                        case 'Folder':
                            var sourceItem = _getSourceItem();
                            folderManager.getFolderAncestors(sourceItem.id).then(function(ancestorData){

                                var isDestinationAnAncestor = false;
                                var destinationContainerId = _getDestinationContainerId();
                                var currentItem = ancestorData.data;

                                do {
                                    if (currentItem.parentItem && currentItem.parentItem.id === destinationContainerId) {
                                        isDestinationAnAncestor = true;
                                        break;
                                    }
                                } while (!!(currentItem = currentItem.parentItem));

                                if (isDestinationAnAncestor) {
                                    $translate('Bluemoon.DMS.Alerts.KeepBothFolders').then(_resolveDefer(defer));
                                } else {
                                    $translate('Bluemoon.DMS.Alerts.KeepBothOrReplaceFolders').then(_resolveDefer(defer));
                                }
                            });
                            break;
                        case 'Document':
                            $translate('Bluemoon.DMS.Alerts.KeepBothOrReplaceFiles').then(_resolveDefer(defer));
                            break;
                    }

                    return defer.promise;
                };

                var _getSuccessString = function(sourceItem) {
                    var defer = $q.defer();

                    switch (sourceItem.itemType) {
                        case 'Folder':
                            $translate('Bluemoon.DMS.Alerts.Operation.FolderMovedSuccessfully',
                                { itemName: sourceItem.name }).then(_resolveDefer(defer));
                            break;
                        case 'Document':
                            $translate('Bluemoon.DMS.Alerts.Operation.DocumentMovedSuccessfully',
                                { itemName: sourceItem.name }).then(_resolveDefer(defer));
                            break;
                    }

                    return defer.promise;
                };

                var _getErrorString = function(sourceItem) {
                    var defer = $q.defer();

                    switch (sourceItem.itemType) {
                        case 'Folder':
                            $translate('Bluemoon.DMS.Alerts.Operation.FolderCouldNotBeMoved',
                                { itemName: sourceItem.name }).then(_resolveDefer(defer));
                            break;
                        case 'Document':
                            $translate('Bluemoon.DMS.Alerts.Operation.DocumentCouldNotBeMoved',
                                { itemName: sourceItem.name }).then(_resolveDefer(defer));
                            break;
                    }

                    return defer.promise;
                };

                $scope.$watch('dmsAlert.operation.httpStatusCode', function(newHttpStatusCode){

                    var sourceItem = _getSourceItem();

                    if (!newHttpStatusCode) {

                        $translate('Bluemoon.DMS.Alerts.MoveInProgress', { itemName: sourceItem.name }).then(function(s){
                            $scope.dmsAlert.msg = s;
                        });

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.inProgress;
                        $scope.hideAlert = false;

                        return;
                    }

                    switch (newHttpStatusCode) {
                        case httpStatusCodes.conflict:

                            var conflictStringPromise = _getConflictString(sourceItem.itemType);

                            $translate('Bluemoon.DMS.Alerts.ItemAlreadyExists',
                                { itemName: sourceItem.name }).then(function(itemAlreadyExistsString){
                                    $scope.dmsAlert.msg = itemAlreadyExistsString;
                                });

                            $scope.dmsAlert.status = dmsAlertConstants.statuses.error;

                            conflictStringPromise.then(function(conflictString){
                                $scope.dmsAlert.statement = conflictString;
                                $scope.hideAlert = false;
                                $scope.dmsAlert.showStatement = true;
                            });

                            break;
                        case httpStatusCodes.forbidden:

                            $translate('Bluemoon.DMS.OperationForbidden')
                                .then(function(operationForbiddenString){
                                    $scope.dmsAlert.msg = operationForbiddenString;
                                });

                            $scope.dmsAlert.status = dmsAlertConstants.statuses.error;
                            $scope.hideAlert = false;

                            break;
                        case httpStatusCodes.ok:

                            _getSuccessString(sourceItem).then(function(successString){
                                $scope.dmsAlert.msg = successString;
                            });

                            $scope.dmsAlert.status = dmsAlertConstants.statuses.success;
                            $scope.hideAlert = false;

                            break;
                        default:

                            _getErrorString(sourceItem).then(function(errorString){
                                $scope.dmsAlert.msg = errorString;
                            });

                            $scope.dmsAlert.status = dmsAlertConstants.statuses.error;
                            $scope.hideAlert = false;

                            break;
                    }
                });

                var findNameFunctions = {
                    Folder: folderManager.findName,
                    Document: fileManager.findName,
                };

                var moveItemFunctions = {
                    Folder: folderManager.moveFolder,
                    Document: fileManager.moveDocument,
                };

                var itemExistsFunctions = {
                    Folder: folderManager.getFolderExists,
                    Document: fileManager.getDocumentExists,
                };

                $scope.keepBoth = function() {

                    dmsApiOperationService.operations.remove($scope.dmsAlert.operation);
                    dmsApiOperationService.clearFromBatch($scope.dmsAlert.operation);

                    var destinationContainerId = _getDestinationContainerId();
                    var destinationFileName = _getDestinationFileName();
                    var destinationContainerType = _getDestinationContainerType();

                    var sourceItem = _getSourceItem();

                    var findName = findNameFunctions[sourceItem.itemType];
                    findName(destinationContainerId, destinationFileName,
                        destinationContainerType).then(function(newName) {

                            var sourceItemCopy = angular.copy(sourceItem);

                            sourceItemCopy.name = newName;

                            var moveItem = moveItemFunctions[sourceItemCopy.itemType];
                            var newMoveOperation = moveItem(
                                sourceItemCopy,
                                destinationContainerId,
                                destinationContainerType);

                            $scope.dmsAlert = dmsAlertService.createOperationAlert(newMoveOperation);
                        });
                };

                $scope.replace = function() {

                    dmsApiOperationService.operations.remove($scope.dmsAlert.operation);
                    dmsApiOperationService.clearFromBatch($scope.dmsAlert.operation);

                    var destinationContainerId = _getDestinationContainerId();
                    var destinationFileName = _getDestinationFileName();
                    var destinationContainerType = _getDestinationContainerType();

                    var sourceItem = _getSourceItem();

                    var itemExists = itemExistsFunctions[sourceItem.itemType];
                    itemExists(destinationContainerId,
                        destinationFileName,
                        destinationContainerType).then(function(existsResponseData){
                            if (existsResponseData.data && existsResponseData.data.length > 0 && existsResponseData.data[0].exists){
                                var itemIdToReplace = existsResponseData.data[0].id;

                                var deleteItemPromise =
                                    sourceItem.itemType === 'Folder' ? folderManager.deleteFolder(itemIdToReplace) :
                                    sourceItem.itemType === 'Document' ? fileManager.deleteDocument(
                                        destinationContainerId,
                                        itemIdToReplace,
                                        destinationContainerType) : undefined;

                                if (deleteItemPromise) {
                                    deleteItemPromise.then(function(deleteResponseData){
                                        if (deleteResponseData.status === window.successStatus) {
                                            var moveItem = moveItemFunctions[sourceItem.itemType];
                                            var newMoveOperation = moveItem(
                                                sourceItem,
                                                destinationContainerId,
                                                destinationContainerType);

                                            $scope.dmsAlert = dmsAlertService.createOperationAlert(newMoveOperation);
                                        }
                                    });
                                }
                            }
                        });
                };

                $scope.ignoreTransclusion = true;

                $scope.hideAlert = true;
            };
        }
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.alerts.operation')

    .service('dmsMoveToRecycleBinOperationAlertService', [
        '$translate',
        '$q',
        'dmsApiOperationService',
        'dmsAlertService',
        'dmsAlertConstants',
        'bluemoon.components.httpStatusCodes',
        function(
            $translate,
            $q,
            dmsApiOperationService,
            dmsAlertService,
            dmsAlertConstants,
            httpStatusCodes) {

            this.scopeSetup = function($scope) {

                var _getOperationData = function() {
                    return $scope.dmsAlert.operation.operationData;
                };

                var _resolveDefer = function(defer) {
                    return function(s){
                        defer.resolve(s);
                    };
                };

                var _getSuccessString = function(item) {

                    var defer = $q.defer();

                    switch (item.itemType) {
                    case 'Folder': //                    // case 'Project':
                        $translate('Bluemoon.DMS.Alerts.Operation.FolderMovedToRecycleBinSuccessfully',
                            { itemName: item.name }).then(_resolveDefer(defer));
                        break;
                    case 'Document':
                        $translate('Bluemoon.DMS.Alerts.Operation.DocumentMovedToRecycleBinSuccessfully',
                            { itemName: item.name }).then(_resolveDefer(defer));
                        break;
                    }

                    return defer.promise;
                };

                $scope.$watch('dmsAlert.operation.httpStatusCode', function(newHttpStatusCode){

                    var operationData = _getOperationData();
                    var item = operationData.item;

                    if (!newHttpStatusCode) {

                        $translate('Bluemoon.DMS.Alerts.MoveToRecycleBinInProgress', { itemName: item.name }).then(function(s){
                            $scope.dmsAlert.msg = s;
                        });

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.inProgress;
                        $scope.hideAlert = false;

                        return;
                    }

                    switch (newHttpStatusCode) {
                    case httpStatusCodes.created:

                        _getSuccessString(item).then(function(successString){
                            $scope.dmsAlert.msg = successString;
                        });

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.success;
                        $scope.hideAlert = false;

                        break;
                    case httpStatusCodes.forbidden:

                        $translate('Bluemoon.DMS.OperationForbidden')
                            .then(function(operationForbiddenString){
                                $scope.dmsAlert.msg = operationForbiddenString;
                            });

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.error;
                        $scope.hideAlert = false;

                        break;
                    case undefined:
                        break;
                    default:

                        $translate('Bluemoon.DMS.Alerts.ItemCouldNotBeMovedToRecycleBin',
                            { itemName: item.name }).then(function(itemCouldNotBeDeletedString){
                                $scope.dmsAlert.msg = itemCouldNotBeDeletedString;
                            });

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.error;
                        $scope.hideAlert = false;

                        break;
                    }

                    $scope.dmsAlert.showStatement = $scope.dmsAlert.statement && $scope.dmsAlert.statement !== '';
                });

                $scope.ignoreTransclusion = true;

                $scope.hideAlert = true;
            };
        }
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.alerts.operation')

    .controller('dmsOperationAlertDirectiveController', [
        '$scope',
        'bluemoon.components.httpStatusCodes',
        'dmsAlertService',
        'dmsApiOperationService',
        'dmsApiOperationConstants',
        'dmsMoveOperationAlertService',
        'dmsCopyOperationAlertService',
        'dmsAddOperationAlertService',
        'dmsDeleteOperationAlertService',
        'dmsSendOperationAlertService',
        'dmsMoveToRecycleBinOperationAlertService',
        'dmsRestoreOperationAlertService',
        'dmsPermanentlyDeleteOperationAlertService',
        function(
            $scope,
            httpStatusCodes,
            dmsAlertService,
            dmsApiOperationService,
            dmsApiOperationConstants,
            dmsMoveOperationAlertService,
            dmsCopyOperationAlertService,
            dmsAddOperationAlertService,
            dmsDeleteOperationAlertService,
            dmsSendOperationAlertService,
            dmsMoveToRecycleBinOperationAlertService,
            dmsRestoreOperationAlertService,
            dmsPermanentlyDeleteOperationAlertService){

            $scope.dmsAlert = dmsAlertService.createOperationAlert($scope.dmsOperationModel);

            $scope.closeAlert = function() {
                dmsApiOperationService.operations.remove($scope.dmsAlert.operation);
                dmsApiOperationService.clearFromBatch($scope.dmsAlert.operation);
            };

            switch($scope.dmsAlert.operation.type) {
            case dmsApiOperationConstants.moveType:
                dmsMoveOperationAlertService.scopeSetup($scope);
                break;
            case dmsApiOperationConstants.copyType:
                dmsCopyOperationAlertService.scopeSetup($scope);
                break;
            case dmsApiOperationConstants.addType:
                dmsAddOperationAlertService.scopeSetup($scope);
                break;
            case dmsApiOperationConstants.deleteType:
                dmsDeleteOperationAlertService.scopeSetup($scope);
                break;
            case dmsApiOperationConstants.sendType:
                dmsSendOperationAlertService.scopeSetup($scope);
                break;
            case dmsApiOperationConstants.moveToRecycleType:
                dmsMoveToRecycleBinOperationAlertService.scopeSetup($scope);
                break;
            case dmsApiOperationConstants.restoreType:
                dmsRestoreOperationAlertService.scopeSetup($scope);
                break;
            case dmsApiOperationConstants.permanentlyDeleteType:
                dmsPermanentlyDeleteOperationAlertService.scopeSetup($scope);
                break;
            }
        }
    ])

    .directive('dmsOperationAlert', ['dmsAlertDirectiveService',
        function(dmsAlertDirectiveService) {
            return {
                restrict: 'E',
                replace: true,
                scope: {
                    dmsOperationModel: '=',
                },
                templateUrl: dmsAlertDirectiveService.templatePath('dms-alert-directive'),
                transclude: false,
                controller: 'dmsOperationAlertDirectiveController'
            };
        }
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.alerts.upload')

    .controller('dmsOperationCollectionAlertDirectiveController', [
        '$scope',
        '$translate',
        'dmsApiOperationService',
        'DmsOperationCollectionAlertModel',
        function(
            $scope,
            $translate,
            dmsApiOperationService,
            DmsOperationCollectionAlertModel){

            var getAlertMessage = function(numberOfOperationsWithSuccess, totalNumberOfOperations, numberOfOperationsWithErrors) {
                return $translate('Bluemoon.DMS.Alerts.OperationCollection.OperationsCompletedWithErrors',
                    { operationsCompletedSuccessfully: numberOfOperationsWithSuccess, totalOperations: totalNumberOfOperations, totalErrors: numberOfOperationsWithErrors });
            };

            var getAlertStatus = function(numberOfOperationsWithErrors) {
                return numberOfOperationsWithErrors > 0 ? 'error' : 'success';
            };

            var updateAlert = function() {
                $scope.dmsAlert.status = getAlertStatus($scope.numberOfErrors);

                getAlertMessage($scope.numberOfSuccess, $scope.totalNumberOfAlerts, $scope.numberOfErrors)
                    .then(function(alertMessage){
                        $scope.dmsAlert.msg = alertMessage;
                    });
            };

            $scope.closeAlert = function() {
                dmsApiOperationService.operationQueue.clear();
                dmsApiOperationService.clearBatch();
                dmsApiOperationService.operations.clear();
            };

            $scope.ignoreTransclusion = true;

            $scope.dmsAlert = new DmsOperationCollectionAlertModel({});
            $scope.dmsAlert.status = 'waiting';

            $scope.numberOfErrors = 0;
            $scope.totalNumberOfAlerts = 0;
            $scope.numberOfSuccess = 0;

            $scope.currentBatch = dmsApiOperationService.currentBatch;

            $scope.$watch('currentBatch.error', function(newValue) {
                $scope.numberOfErrors = newValue;
                updateAlert();
            });

            $scope.$watch('currentBatch.success', function(newValue) {
                $scope.numberOfSuccess = newValue;
                updateAlert();
            });

            $scope.$watch('currentBatch.total', function(newValue) {
                $scope.totalNumberOfAlerts = newValue;
                updateAlert();
            });
        }
    ])

    .directive('dmsOperationCollectionAlert', [
        'dmsAlertDirectiveService',
        function(dmsAlertDirectiveService) {
            return {
                restrict: 'E',
                replace: true,
                scope: {
                    dmsOperationCollectionModel: '=',
                    closeAlert: '&close',
                },
                templateUrl: dmsAlertDirectiveService.templatePath('dms-alert-directive'),
                controller: 'dmsOperationCollectionAlertDirectiveController'
            };
        }
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.alerts.operation')

    .service('dmsPermanentlyDeleteOperationAlertService', [
        '$translate',
        '$q',
        'dmsApiOperationService',
        'dmsAlertService',
        'dmsAlertConstants',
        'bluemoon.components.httpStatusCodes',
        function(
            $translate,
            $q,
            dmsApiOperationService,
            dmsAlertService,
            dmsAlertConstants,
            httpStatusCodes) {

            this.scopeSetup = function($scope) {

                var _getOperationData = function() {
                    return $scope.dmsAlert.operation.operationData;
                };

                var _resolveDefer = function(defer) {
                    return function(s){
                        defer.resolve(s);
                    };
                };

                var _getSuccessString = function(item) {

                    var defer = $q.defer();

                    switch (item.itemType) {
                    case 'Folder': //                    // case 'Project':
                        $translate('Bluemoon.DMS.Alerts.Operation.FolderPermanentlyDeletedSuccessfully',
                            { itemName: item.name }).then(_resolveDefer(defer));
                        break;
                    case 'Document':
                        $translate('Bluemoon.DMS.Alerts.Operation.DocumentPermanentlyDeletedSuccessfully',
                            { itemName: item.name }).then(_resolveDefer(defer));
                        break;
                    }

                    return defer.promise;
                };

                $scope.$watch('dmsAlert.operation.httpStatusCode', function(newHttpStatusCode){

                    var operationData = _getOperationData();
                    var item = operationData.item;

                    if (!newHttpStatusCode) {

                        $translate('Bluemoon.DMS.Alerts.PermanentlyDeleteInProgress', { itemName: item.name }).then(function(s){
                            $scope.dmsAlert.msg = s;
                        });

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.inProgress;
                        $scope.hideAlert = false;

                        return;
                    }

                    switch (newHttpStatusCode) {
                    case httpStatusCodes.noContent:

                        _getSuccessString(item).then(function(successString){
                            $scope.dmsAlert.msg = successString;
                        });

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.success;
                        $scope.hideAlert = false;

                        break;
                    case httpStatusCodes.forbidden:

                        $translate('Bluemoon.DMS.OperationForbidden')
                            .then(function(operationForbiddenString){
                                $scope.dmsAlert.msg = operationForbiddenString;
                            });

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.error;
                        $scope.hideAlert = false;

                        break;
                    case undefined:
                        break;
                    default:

                        $translate('Bluemoon.DMS.Alerts.ItemCouldNotBePermanentlyDeleted',
                            { itemName: item.name }).then(function(itemCouldNotBeDeletedString){
                                $scope.dmsAlert.msg = itemCouldNotBeDeletedString;
                            });

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.error;
                        $scope.hideAlert = false;

                        break;
                    }

                    $scope.dmsAlert.showStatement = $scope.dmsAlert.statement && $scope.dmsAlert.statement !== '';
                });

                $scope.ignoreTransclusion = true;

                $scope.hideAlert = true;
            };
        }
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.alerts.operation')

    .service('dmsRestoreOperationAlertService', [
        '$translate',
        '$q',
        'dmsApiOperationService',
        'dmsAlertService',
        'dmsAlertConstants',
        'dmsFolderService',
        'dmsDocumentService',
        'dmsRecycleBinUiService',
        'bluemoon.components.httpStatusCodes',
        function(
            $translate,
            $q,
            dmsApiOperationService,
            dmsAlertService,
            dmsAlertConstants,
            dmsFolderService,
            dmsDocumentService,
            dmsRecycleBinUiService,
            httpStatusCodes) {

            this.scopeSetup = function($scope) {
                var _getSourceItem = function() {
                    return $scope.dmsAlert.operation.operationData.item;
                };

                var _getDestinationContainerId = function() {
                    return _getSourceItem().destinationContainerId;
                };

                var _getDestinationContainerType = function() {
                    return _getSourceItem().destinationContainerType;
                };

                var _getDestinationFileName = function() {
                    return _getSourceItem().name;
                };

                var _resolveDefer = function(defer) {
                    return function(s){
                        defer.resolve(s);
                    };
                };

                var _getConflictString = function(itemType) {
                    var defer = $q.defer();

                    switch (itemType) {
                    case 'Folder':
                    case 'Document':
                        $translate('Bluemoon.DMS.Alerts.KeepBothOrReplaceFiles').then(_resolveDefer(defer));
                        break;
                    }

                    return defer.promise;
                };

                var _getSuccessString = function(sourceItem) {
                    var defer = $q.defer();

                    switch (sourceItem.itemType) {
                    case 'Folder':
                        $translate('Bluemoon.DMS.Alerts.Operation.FolderRestoredSuccessfully',
                            { itemName: sourceItem.name }).then(_resolveDefer(defer));
                        break;
                    case 'Document':
                        $translate('Bluemoon.DMS.Alerts.Operation.DocumentRestoredSuccessfully',
                            { itemName: sourceItem.name }).then(_resolveDefer(defer));
                        break;
                    }

                    return defer.promise;
                };

                var _getErrorString = function(sourceItem) {
                    var defer = $q.defer();

                    switch (sourceItem.itemType) {
                    case 'Folder':
                        $translate('Bluemoon.DMS.Alerts.Operation.FolderCouldNotBeRestored',
                            { itemName: sourceItem.name }).then(_resolveDefer(defer));
                        break;
                    case 'Document':
                        $translate('Bluemoon.DMS.Alerts.Operation.DocumentCouldNotBeRestored',
                            { itemName: sourceItem.name }).then(_resolveDefer(defer));
                        break;
                    }

                    return defer.promise;
                };

                $scope.$watch('dmsAlert.operation.httpStatusCode', function(newHttpStatusCode){

                    var sourceItem = _getSourceItem();

                    if (!newHttpStatusCode) {

                        $translate('Bluemoon.DMS.Alerts.RestoreInProgress', { itemName: sourceItem.name }).then(function(s){
                            $scope.dmsAlert.msg = s;
                        });

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.inProgress;
                        $scope.hideAlert = false;

                        return;
                    }

                    switch (newHttpStatusCode) {
                    case httpStatusCodes.conflict:

                        var conflictStringPromise = _getConflictString(sourceItem.itemType);

                        $translate('Bluemoon.DMS.Alerts.ItemAlreadyExists',
                            { itemName: sourceItem.name }).then(function(itemAlreadyExistsString){
                                $scope.dmsAlert.msg = itemAlreadyExistsString;
                            });

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.error;

                        conflictStringPromise.then(function(conflictString){
                            $scope.dmsAlert.statement = conflictString;
                            $scope.hideAlert = false;
                            $scope.dmsAlert.showStatement = true;
                        });

                        break;
                    case httpStatusCodes.forbidden:

                        $translate('Bluemoon.DMS.OperationForbidden')
                            .then(function(operationForbiddenString){
                                $scope.dmsAlert.msg = operationForbiddenString;
                            });

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.error;
                        $scope.hideAlert = false;

                        break;
                    case httpStatusCodes.ok:

                        _getSuccessString(sourceItem).then(function(successString){
                            $scope.dmsAlert.msg = successString;
                        });

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.success;
                        $scope.hideAlert = false;

                        break;
                    default:

                        _getErrorString(sourceItem).then(function(errorString){
                            $scope.dmsAlert.msg = errorString;
                        });

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.error;
                        $scope.hideAlert = false;

                        break;
                    }
                });

                var findNameFunctions = {
                    Folder: dmsFolderService.findName,
                    Document: dmsDocumentService.findName,
                };

                var restoreItemFunctions = {
                    Folder: dmsRecycleBinUiService.restoreFolder,
                    Document: dmsRecycleBinUiService.restoreDocument,
                };

                var itemExistsFunctions = {
                    Folder: dmsFolderService.getExists,
                    Document: dmsDocumentService.getExists,
                };

                $scope.keepBoth = function() {

                    dmsApiOperationService.operations.remove($scope.dmsAlert.operation);
                    dmsApiOperationService.clearFromBatch($scope.dmsAlert.operation);

                    var destinationContainerId = _getDestinationContainerId();
                    var destinationFileName = _getDestinationFileName();
                    var destinationContainerType = _getDestinationContainerType();

                    var sourceItem = _getSourceItem();

                    var findName = findNameFunctions[sourceItem.itemType];
                    findName(destinationContainerId, destinationContainerType, destinationFileName)
                        .then(function(newName) {

                            var sourceItemCopy = angular.copy(sourceItem);

                            sourceItemCopy.name = newName;

                            var restoreItem = restoreItemFunctions[sourceItemCopy.itemType];
                            var curName = sourceItemCopy.name;
                            var newRestoreOperation = restoreItem({
                                scope: $scope,
                                params: {
                                    trashRequest: {
                                        trashId: sourceItemCopy.id,
                                    },
                                    restoreItemRequest: {
                                        name: curName,
                                        destinationContainerId: destinationContainerId,
                                        destinationContainerType: destinationContainerType
                                    }
                                },
                                busily: false
                            });

                            $scope.dmsAlert = dmsAlertService.createOperationAlert(newRestoreOperation);
                        });
                };

                $scope.replace = function() {

                    dmsApiOperationService.operations.remove($scope.dmsAlert.operation);
                    dmsApiOperationService.clearFromBatch($scope.dmsAlert.operation);

                    var destinationContainerId = _getDestinationContainerId();
                    var destinationFileName = _getDestinationFileName();
                    var destinationContainerType = _getDestinationContainerType();

                    var sourceItem = _getSourceItem();

                    var itemExists = itemExistsFunctions[sourceItem.itemType];
                    itemExists(destinationContainerId, destinationContainerType, [destinationFileName])
                        .then(function(existsResponseData){
                            if (existsResponseData.data && existsResponseData.data.length > 0 && existsResponseData.data[0].exists){
                                var itemIdToReplace = existsResponseData.data[0].id;

                                var deleteItemPromise =
                                    sourceItem.itemType === 'Folder' ? dmsFolderService.delete(itemIdToReplace) :
                                    sourceItem.itemType === 'Document' ? dmsDocumentService.delete(
                                        destinationContainerId,
                                        destinationContainerType,
                                        itemIdToReplace) : undefined;

                                if (deleteItemPromise) {
                                    deleteItemPromise.then(function(deleteResponseData){
                                        deleteResponseData.status = deleteResponseData.response.status;
                                        if (deleteResponseData.status === window.successStatus) {
                                            var restoreItem = restoreItemFunctions[sourceItem.itemType];
                                            var curName = sourceItem.name;
                                            var newRestoreOperation = restoreItem({
                                                scope: $scope,
                                                params: {
                                                    trashRequest: {
                                                        trashId: sourceItem.id,
                                                    },
                                                    restoreItemRequest: {
                                                        name: curName,
                                                        destinationContainerId: destinationContainerId,
                                                        destinationContainerType: destinationContainerType
                                                    }
                                                },
                                                busily: false
                                            });

                                            $scope.dmsAlert = dmsAlertService.createOperationAlert(newRestoreOperation);
                                        }
                                    });
                                }
                            }
                        });
                };

                $scope.ignoreTransclusion = true;

                $scope.hideAlert = true;
            };
        }
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.alerts.operation')

    .service('dmsSendOperationAlertService', [
        '$translate',
        '$q',
        'dmsApiOperationService',
        'dmsAlertService',
        'dmsAlertConstants',
        'fileManager',
        'folderManager',
        'projectManager',
        'bluemoon.components.httpStatusCodes',
        function(
            $translate,
            $q,
            dmsApiOperationService,
            dmsAlertService,
            dmsAlertConstants,
            fileManager,
            folderManager,
            projectManager,
            httpStatusCodes) {

            this.scopeSetup = function($scope) {

                var _getOperationData = function() {
                    return $scope.dmsAlert.operation.operationData;
                };

                var _resolveDefer = function(defer) {
                    return function(s){
                        defer.resolve(s);
                    };
                };

                var _getSuccessString = function() {
                    var defer = $q.defer();
                    $translate('Bluemoon.DMS.Alerts.MessageSentSuccessfully').then(_resolveDefer(defer));
                    return defer.promise;
                };

                $scope.$watch('dmsAlert.operation.httpStatusCode', function(newHttpStatusCode){

                    var operationData = _getOperationData();
                    var newItem = operationData.sharedItems;

                    $scope.dmsAlert.msg = '';

                    if (!newHttpStatusCode) {

                        if(newItem.length === 1){
                            $translate('Bluemoon.DMS.Alerts.SendADocumentInProgress').then(function(s){
                                $scope.dmsAlert.msg = s;
                            });
                        } else if(newItem.length > 1){
                            $translate('Bluemoon.DMS.Alerts.SendDocumentsInProgress').then(function(s){
                                $scope.dmsAlert.msg = s;
                            });
                        }

                        $scope.dmsAlert.status = dmsAlertConstants.statuses.inProgress;
                        $scope.hideAlert = false;

                        return;
                    }

                    switch (newHttpStatusCode) {
                        case httpStatusCodes.created: //  For documents

                            _getSuccessString().then(function(successString){
                                $scope.dmsAlert.msg = successString;
                            });

                            $scope.dmsAlert.status = dmsAlertConstants.statuses.success;
                            $scope.hideAlert = false;

                            break;
                        case undefined:
                            break;
                        default:

                            $translate('Bluemoon.DMS.Alerts.MessageCouldNotBeSent').then(function(s){
                                $scope.dmsAlert.msg = s;
                            });

                            $scope.dmsAlert.status = dmsAlertConstants.statuses.error;
                            $scope.hideAlert = false;

                            break;
                    }

                    $scope.dmsAlert.showStatement = $scope.dmsAlert.statement && $scope.dmsAlert.statement !== '';
                });

                $scope.ignoreTransclusion = true;

                $scope.hideAlert = true;
            };
        }
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.alerts.upload')

    .constant('dmsUploadAlertDirectiveConstants', {
        uploadStatus: {
            waiting: 'waiting',
            uploading: 'uploading',
            success: 'success',
            error: 'error',
        },
    })

    .service('dmsUploadAlertDirectiveService', [
        'dmsAlertConstants',
        function(
            dmsAlertConstants) {
            this.uploadStatusMap = {
                waiting: dmsAlertConstants.statuses.waiting,
                uploading: dmsAlertConstants.statuses.inProgress,
                success: dmsAlertConstants.statuses.success,
                error: dmsAlertConstants.statuses.error,
            };
        }
    ])

    .controller('dmsUploadAlertDirectiveController', [
        '$scope',
        '$translate',
        '$q',
        'dmsUploadAlertDirectiveConstants',
        'dmsUploadService',
        'DmsUploadAlertModel',
        'dmsAlertDirectiveService',
        'dmsUploadAlertDirectiveService',
        'dmsDocumentUiService',
        'formatSizeService',
        function(
            $scope,
            $translate,
            $q,
            dmsUploadAlertDirectiveConstants,
            dmsUploadService,
            DmsUploadAlertModel,
            dmsAlertDirectiveService,
            dmsUploadAlertDirectiveService,
            documentUiService,
            formatSizeService){

            var self = this;

            self._getUploadPercentage = function() {
                return (100 * ($scope.dmsUploadModel.loaded /
                    $scope.dmsUploadModel.total)).toFixed(1);
            };

            self._getUploadFileName = function() {
                return $scope.dmsUploadModel.file.name ||
                    $scope.dmsUploadModel.destinationFileName;
            };

            self._getUploadStatus = function() {
                return $scope.dmsUploadModel.status;
            };

            self._getErrorReason = function() {
                return $scope.dmsUploadModel.error.reason;
            };

            self._getAlertMessage = function() {

                var uploadStatus = self._getUploadStatus(),
                    fileName = self._getUploadFileName();

                switch (uploadStatus) {
                    case dmsUploadAlertDirectiveConstants.uploadStatus.waiting:
                        return $translate('Bluemoon.DMS.Alerts.Upload.FileIsWaitingToUpload',
                            { fileName: fileName });
                    case dmsUploadAlertDirectiveConstants.uploadStatus.uploading:
                        var percentage = self._getUploadPercentage();
                        return $translate('Bluemoon.DMS.Alerts.Upload.FileIsUploading',
                            { fileName: fileName, percentage: percentage });
                    case dmsUploadAlertDirectiveConstants.uploadStatus.success:
                        return $translate('Bluemoon.DMS.Alerts.Upload.FileHasBeenUploaded',
                            { fileName: fileName });
                    case dmsUploadAlertDirectiveConstants.uploadStatus.error:
                        var errorReason = self._getErrorReason();
                        if (errorReason === 'conflict') {
                            return $translate('Bluemoon.DMS.Alerts.ItemAlreadyExists',
                                { itemName: fileName });
                        } else if (errorReason === 'forbidden') {
                            return $translate('Bluemoon.DMS.OperationForbidden');
                        } else if (errorReason && errorReason.indexOf('constraints:')) {
                            return $translate('Bluemoon.DMS.Alerts.Upload.FileCannotBeUploaded',
                                { fileName: fileName });
                        } else {
                            return $translate('Bluemoon.DMS.Alerts.Upload.FileCannotBeUploaded',
                                { fileName: fileName });
                        }
                }

                var defer = $q.defer();
                defer.resolve('');
                return defer.promise;
            };

            self._getStatement = function() {

                var uploadStatus = self._getUploadStatus();

                switch (uploadStatus) {
                    case dmsUploadAlertDirectiveConstants.uploadStatus.error:

                        var errorReason = self._getErrorReason();

                        if (errorReason === 'conflict') {
                            return $translate('Bluemoon.DMS.Alerts.KeepBothOrReplaceFiles');
                        } else if (errorReason === 'constraints:allowedTypes') {
                            return $translate('Bluemoon.DMS.Alerts.Upload.FileTypeNotSupported');
                        } else if (errorReason === 'constraints:maxUploadSize') {
                            return documentUiService.getConstraints({busily: false})
                                .then(function(documentConstraints) {
                                    return formatSizeService.getSizeString(documentConstraints.maxUploadSize);
                                })
                                .then(function(maxUploadSizeString){
                                    return $translate('Bluemoon.DMS.Alerts.Upload.ExceedsMaxUploadSize',
                                        { size: maxUploadSizeString });
                                });
                        } else if (errorReason === 'constraints:minUploadSize') {
                            return $translate('Bluemoon.DMS.Alerts.Upload.DoesNotMeetMinUploadSize');
                        }
                }

                var defer = $q.defer();
                defer.resolve('');
                return defer.promise;
            };

            self._updateAlertMessage = function() {
                self._getAlertMessage()
                    .then(function(alertMessageString){
                        $scope.dmsAlert.msg = alertMessageString;
                    });
            };

            self._updateAlertStatus = function() {
                var uploadStatus = self._getUploadStatus();
                var alertStatus = dmsUploadAlertDirectiveService.uploadStatusMap[uploadStatus];
                $scope.dmsAlert.status = alertStatus;
            };

            self._updateStatement = function() {
                self._getStatement().then(function(statementString){
                    $scope.dmsAlert.statement = statementString;
                    $scope.dmsAlert.showStatement = $scope.dmsAlert.statement !== '';
                });
            };

            $scope.ignoreTransclusion = true;

            $scope.dmsAlert = new DmsUploadAlertModel();

            $scope.closeAlert = function() {
                dmsUploadService.dismissUpload($scope.dmsUploadModel.key);
            };

            $scope.keepBoth = function() {
                dmsUploadService.renameFile($scope.dmsUploadModel);
            };

            $scope.replace = function() {
                dmsUploadService.replaceFile($scope.dmsUploadModel);
            };

            $scope.$watch('dmsUploadModel.status', function() {
                self._updateAlertStatus();
                self._updateAlertMessage();
                self._updateStatement();
            });

            $scope.$watch('dmsUploadModel.loaded', function() {
                self._updateAlertMessage();
            });
        }
    ])

    .directive('dmsUploadAlert', ['dmsAlertDirectiveService',
        function(dmsAlertDirectiveService) {
            return {
                restrict: 'E',
                replace: true,
                scope: {
                    dmsUploadModel: '=dmsUploadModel',
                },
                templateUrl: dmsAlertDirectiveService.templatePath('dms-alert-directive'),
                transclude: false,
                controller: 'dmsUploadAlertDirectiveController'
            };
        }
    ]);
})(window.angular);

(function(angular, _) {
    'use strict';

    angular.module('bluemoon.dms.alerts.upload')

    .controller('dmsUploadCollectionAlertDirectiveController', [
        '$scope',
        '$translate',
        '$q',
        'dmsUploadService',
        'DmsUploadAlertCollectionModel',
        function($scope, $translate, $q, dmsUploadService, DmsUploadAlertCollectionModel){
            $scope.ignoreTransclusion = true;

            $scope.dmsAlert = new DmsUploadAlertCollectionModel({});
            $scope.dmsAlert.status = 'waiting';

            var getAlertProgressPercentage = function(sizeUploaded, totalSizeToUpload) {
                if (!sizeUploaded || isNaN(sizeUploaded) ||
                    !totalSizeToUpload || isNaN(totalSizeToUpload) || totalSizeToUpload === 0){
                    return 100;
                }
                return (100 * (sizeUploaded / totalSizeToUpload).toFixed(1));
            };

            var resolveDefer = function(defer) {
                return function(s){
                    defer.resolve(s);
                };
            };

            var getAlertMessage = function(totalErrors, filesUploaded, totalFilesToUpload, percentage) {

                var defer = $q.defer();

                if (totalErrors === 0) {
                    $translate('Bluemoon.DMS.Alerts.UploadCollection.FilesUploadedWithNoErrors', {
                        filesUploaded: filesUploaded,
                        totalFilesToUpload: totalFilesToUpload,
                        percentage: percentage,
                    }).then(resolveDefer(defer));
                } else if (totalErrors > 0) {
                    $translate('Bluemoon.DMS.Alerts.UploadCollection.FilesUploadedWithErrors', {
                        filesUploaded: filesUploaded,
                        totalFilesToUpload: totalFilesToUpload,
                        totalErrors: totalErrors,
                    }).then(resolveDefer(defer));
                } else {
                    defer.resolve('');
                }

                return defer.promise;
            };

            var getAlertStatus = function(totalErrors) {
                if (totalErrors === 0) {
                    return 'in-progress';
                } else if (totalErrors > 0) {
                    return 'error';
                }
                return '';
            };

            var updateProgressPercentage = function() {
                $scope.dmsAlert.progressPercentage = getAlertProgressPercentage($scope.sizeUploaded, $scope.totalSizeToUpload);
            };

            var updateAlertMessage = function() {
                getAlertMessage($scope.totalErrors, $scope.filesUploaded,
                    $scope.totalFilesToUpload, $scope.dmsAlert.progressPercentage).then(function(alertMessageString){
                        $scope.dmsAlert.msg = alertMessageString;
                    });
            };

            var updateAlertStatus = function() {
                $scope.dmsAlert.status = getAlertStatus($scope.totalErrors);
            };

            var updateAlert = function() {
                updateProgressPercentage();
                updateAlertMessage();
                updateAlertStatus();
            };

            $scope.closeAlert = function() {
                _.each(dmsUploadService.uploads, function(upload) {
                    dmsUploadService.dismissUpload(upload.key);
                });
            };

            $scope.$watch('filesUploaded', updateAlert);
            $scope.$watch('totalFilesToUpload', updateAlert);
            $scope.$watch('sizeUploaded', updateAlert);
            $scope.$watch('totalSizeToUpload', updateAlert);
            $scope.$watch('totalErrors', updateAlert);
        }
    ])

    .directive('dmsUploadCollectionAlert', [
        'dmsAlertDirectiveService',
        function(dmsAlertDirectiveService) {
            return {
                restrict: 'E',
                replace: true,
                scope: {
                    filesUploaded: '=',
                    totalFilesToUpload: '=',
                    sizeUploaded: '=',
                    totalSizeToUpload: '=',
                    totalErrors: '=',
                    closeAlert: '&close',
                },
                templateUrl: dmsAlertDirectiveService.templatePath('dms-alert-directive'),
                controller: 'dmsUploadCollectionAlertDirectiveController'
            };
        }
    ]);
})(window.angular, window._);

angular.module('bluemoon.dms.alerts.templates', ['components/alerts/dms-alert-directive.2js.html']);

angular.module("components/alerts/dms-alert-directive.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/alerts/dms-alert-directive.2js.html",
    "<div>\n" +
    "    <div ng-if=\"!hideAlert\" class=\"alert animate-repeat\"\n" +
    "        ng-class=\"{\n" +
    "            'alert-warning': dmsAlert.status === 'in-progress' || dmsAlert.status === 'warning',\n" +
    "            'alert-success': dmsAlert.status === 'success',\n" +
    "            'alert-info': dmsAlert.status === 'waiting' || dmsAlert.status === 'info',\n" +
    "            'alert-error': dmsAlert.status === 'error'\n" +
    "        }\">\n" +
    "        <button type=\"button\"\n" +
    "            class=\"close\"\n" +
    "            data-dismiss=\"alert\"\n" +
    "            aria-hidden=\"true\"\n" +
    "            ng-click=\"closeAlert($index)\">\n" +
    "            <span aria-hidden=\"true\">\n" +
    "                <i class=\"bento-icon-close-x\"></i>\n" +
    "                    <span class=\"sr-only\">Close</span>\n" +
    "            </span>\n" +
    "        </button>\n" +
    "        <span ng-if=\"!ignoreTransclusion\" class=\"file-alert-text\" ng-transclude></span>\n" +
    "        <span ng-if=\"ignoreTransclusion\" class=\"file-alert-text\" ng-bind-html=\"dmsAlert.msg\"></span>\n" +
    "        <div ng-show=\"dmsAlert.status === 'in-progress' && !dmsAlert.progressive\"\n" +
    "            class=\"progress indefinite-progress\">\n" +
    "            <div class=\"progress-bar progress-bar-striped progress-bar-warning active\"\n" +
    "                role=\"progressbar\"\n" +
    "                aria-valuenow=\"100\"\n" +
    "                aria-valuemin=\"100\"\n" +
    "                aria-valuemax=\"100\"\n" +
    "                style=\"width: 100%\">\n" +
    "                <span class=\"sr-only\">progress</span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div ng-show=\"dmsAlert.progressive\"\n" +
    "            class=\"progress progress-striped active item-progress\">\n" +
    "            <div class=\"progress-bar progress-bar-warning\"\n" +
    "                role=\"progressbar\"\n" +
    "                aria-valuenow=\"{{ dmsAlert.progressPercentage }}\"\n" +
    "                aria-valuemin=\"0\"\n" +
    "                aria-valuemax=\"100\"\n" +
    "                style=\"width: {{ dmsAlert.progressPercentage }}%\">\n" +
    "                <span class=\"sr-only\">progress</span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div ng-show=\"dmsAlert.showStatement\" class=\"statement\">\n" +
    "            <span dms-html-compile=\"dmsAlert.statement\"></span>\n" +
    "        </div>\n" +
    "\n" +
    "    </div>\n" +
    "</div>");
}]);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.all-docs-grid.templates', []);

    angular.module('bluemoon.dms.all-docs-grid', [
        'pascalprecht.translate',
        'bluemoon.components',
        'bluemoon.dms.all-docs-grid.templates',
        'bluemoon.dms.ui-services',
    ])

    .service('dmsAllDocsGridService', function() {
        this.templatePath = function(template) {
            return 'components/all-docs-grid/' + template + '.2js.html';
        };
    })

    .directive('dmsAllDocsGrid', ['dmsAllDocsGridService',
        function(dmsAllDocsGridService) {
            return {
                restrict: 'E',
                replace: true,
                scope : {
                    items : '=',
                    footerMessage : '=',
                    currentContainer : '=',
                    customOptions : '=',
                    viewerHeight : '=',
                    headerRowHeight : '=',
                    rowHeight : '=',
                    virtualizationThreshold : '=',
                    searchMethod : '=',
                    buttons : '='
                },
                templateUrl: dmsAllDocsGridService.templatePath('all-docs-grid-template'),
                controller: 'allDocsGridController'
            };
        }
    ])

    .controller('allDocsGridController', [
        '$rootScope',
        '$scope',
        '$q',
        '$translate',
        'dmsAllDocsGridService',
        function (
            $rootScope,
            $scope,
            $q,
            $translate,
            dmsAllDocsGridService) {

            var vm = this;

            $scope.columnDefs = [
                {
                    cellTemplate: dmsAllDocsGridService.templatePath('all-docs-type-cell-template'),
                    field: 'type',
                    width: '7%',
                    sortable: false //TODO: re-enable at some point
                },
                {
                    cellTemplate: dmsAllDocsGridService.templatePath('all-docs-name-cell-template'),
                    field: 'name',
                    width: '93%'
                },
            ];

            vm._loadStringsForColumnHeaders = function() {
                var translatePromises = [
                    $translate('Bluemoon.DMS.Grid.AllDocuments.Type').then(function(s) {
                        $scope.columnDefs[0].displayName = s;
                    }),
                    $translate('Bluemoon.DMS.Grid.AllDocuments.Name').then(function(s) {
                        $scope.columnDefs[1].displayName = s;
                    })
                ];

                return $q.all(translatePromises);
            };

            vm._tooltipStrings = {};

            vm._loadStringsForTooltips = function() {

                vm._tooltipStrings.folder = vm._tooltipStrings.folder || '';
                vm._tooltipStrings.client = vm._tooltipStrings.client || '';
                vm._tooltipStrings.clients = vm._tooltipStrings.clients || '';
                vm._tooltipStrings.templates = vm._tooltipStrings.templates || '';
                vm._tooltipStrings.recents = vm._tooltipStrings.recents || '';
                vm._tooltipStrings.recycle = vm._tooltipStrings.recycle || '';

                var translatePromises = [
                    $translate('Bluemoon.DMS.Grid.AllDocuments.FolderTooltip').then(function(s){
                        vm._tooltipStrings.folder = s;
                    }),
                    $translate('Bluemoon.DMS.Grid.AllDocuments.ClientTooltip').then(function(s){
                        vm._tooltipStrings.client = s;
                    }),
                    $translate('Bluemoon.DMS.Grid.AllDocuments.ClientsTooltip').then(function(s){
                        vm._tooltipStrings.clients = s;
                    }),
                    $translate('Bluemoon.DMS.Grid.AllDocuments.TemplatesTooltip').then(function(s){
                        vm._tooltipStrings.templates = s;
                    }),
                    $translate('Bluemoon.DMS.SpecialFolders.Recents').then(function(s){
                        vm._tooltipStrings.recents = s;
                    }),
                    $translate('Bluemoon.DMS.SpecialFolders.RecycleBin').then(function(s){
                        vm._tooltipStrings.recycle = s;
                    }),
                ];

                return $q.all(translatePromises);
            };

            //  Run on init
            vm._loadStrings = function() {
                vm._loadStringsForColumnHeaders();
                vm._loadStringsForTooltips();
            };

            vm._loadStrings();

            $scope.$on('bmLanguageChangeSuccess', function() {
                vm._loadStrings();
            });

            var fixedOptions = {
                columnDefs : 'columnDefs',
                data : 'items'
            };

            var customOptions = $scope.customOptions;

            $scope.selectInfo =  [
                    {
                        value: 10,
                        label: 10
                    },
                    {
                        value: 25,
                        label: 25
                    },
                    {
                        value: 50,
                        label: 50
                    },
                    {
                        value: 100,
                        label: 100
                    }
                ];

            $scope.currentInfo = {
                page: 1,
                totalItems: 0,
                numItems: 25,
            };

            $scope.currentInfo.onPageChanged = function(page){
                $scope.pageChange = true;
                $scope.currentInfo.page = page;
                $scope.setPagingData($scope.allItems, $scope.currentInfo.page, $scope.currentInfo.numItems);
            };

            $scope.currentInfo.onSelectChanged = function(size){
                $scope.pageChange = true;
                $scope.currentInfo.numItems = size;
                $scope.setPagingData($scope.allItems, $scope.currentInfo.page, $scope.currentInfo.numItems);
            };

            var defaultOptions = {
                headerRowHeight : $scope.headerRowHeight,
                rowHeight : $scope.rowHeight,
                showSelectionCheckbox : false,
                filterOptions : {
                    filterText : '',
                    useExternalFilter : false
                },
                showColumnMenu : false,
                showGroupPanel : false,
            };

            // pick the slice we currently want to see
            $scope.setPagingData = function(data, page, pageSize){
                if (!$scope.allItems || !data || !(data instanceof Array)) {return; }
                var pagedData = data.slice((page - 1) * pageSize, page * pageSize);
                $scope.items = pagedData;
            };

            $scope.$watchCollection('items', function(){
                if(!$scope.items || $scope.items.length === 0 || !($scope.items instanceof Array)){
                    return;
                }

                if (!$scope.everLoaded){
                    $scope.allItems = $scope.items;
                    $scope.currentInfo.totalItems = $scope.allItems.length;
                    //Only change this on first ever items load
                    if ($scope.currentInfo.totalItems > 10){
                        $scope.setPagingData($scope.items, $scope.currentInfo.page, $scope.currentInfo.numItems);
                    }
                    $scope.everLoaded = true;
                }

                if (!$scope.pageChange && $scope.items && $scope.items.length !== 0){
                    $scope.items = $scope.allItems;
                    $scope.setPagingData($scope.items, $scope.currentInfo.page, $scope.currentInfo.numItems);
                }
                $scope.pageChange = false;
            });

            $scope.options = {};

            $scope.everLoaded = false;
            $scope.pageChange = false;

            $scope.searchInput = {
                text: undefined
            };

            angular.extend($scope.options, defaultOptions);
            angular.extend($scope.options, customOptions);
            angular.extend($scope.options, fixedOptions);

            $scope.getTypeIcon = function(type){
                if (type === 'client'){
                    return 'bento-icon-users';
                } else if (type === 'folder'){
                    return 'bento-icon-folder';
                } else if (type === 'templates') {
                    return 'bento-icon-tree';
                } else if (type === 'recycle') {
                    return 'bento-icon-remove';
                } else if (type === 'recents') {
                    return 'bento-icon-history';
                } else {
                    return type.toLowerCase();
                }
            };

            $scope.getType = function(type){
                if (!angular.isString(type)){
                    throw new Error('type must be a string');
                }

                return vm._tooltipStrings[type] || '';
            };
        }
    ]);

})(window.angular, window._);

angular.module('bluemoon.dms.all-docs-grid.templates', ['components/all-docs-grid/all-docs-grid-template.2js.html', 'components/all-docs-grid/all-docs-name-cell-template.2js.html', 'components/all-docs-grid/all-docs-type-cell-template.2js.html']);

angular.module("components/all-docs-grid/all-docs-grid-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/all-docs-grid/all-docs-grid-template.2js.html",
    "<div class=\"all-docs-main-container dataTables_wrapper\">\n" +
    "  <div class=\"bmoon-grid-style no-scroll-grid bmoon-grid-actions-included\"\n" +
    "      ng-grid=\"options\">\n" +
    "  </div>\n" +
    "  <div class=\"page-section-top\">\n" +
    "        {{ footerMessage }}\n" +
    "  </div>\n" +
    "  <div bento-pagination\n" +
    "     page=\"currentInfo.page\"\n" +
    "     on-change=\"currentInfo.onPageChanged(page)\"\n" +
    "     direction-links=\"true\"\n" +
    "     boundary-links=\"true\"\n" +
    "     total-items=\"currentInfo.totalItems\"\n" +
    "     items-array=\"selectInfo\"\n" +
    "     on-change-size=\"currentInfo.onSelectChanged(size)\"\n" +
    "     items-per-page=\"currentInfo.numItems\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/all-docs-grid/all-docs-name-cell-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/all-docs-grid/all-docs-name-cell-template.2js.html",
    "<div class=\"ngCellText\" ng-class=\"col.colIndex()\">\n" +
    "    <a href=\"\" ng-href=\"{{row.entity.link}}\">\n" +
    "        {{row.getProperty(col.field)}}\n" +
    "    </a>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/all-docs-grid/all-docs-type-cell-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/all-docs-grid/all-docs-type-cell-template.2js.html",
    "<div class=\"ngCellText\" ng-class=\"col.colIndex()\">\n" +
    "  <span uib-tooltip=\"{{ getType(row.entity.itemType) }}\" tooltip-append-to-body=\"true\">\n" +
    "    <i ng-class=\"getTypeIcon(row.entity.itemType)\"></i>\n" +
    "  </span>\n" +
    "</div>\n" +
    "");
}]);

(function(angular) {
    'use strict';

    //  Blank module for dev, overwritten for dist
    angular.module('bluemoon.dms.client-grid.templates', []);

    var bmoonApp = angular.module('bluemoon.dms.client-grid', [
        'pascalprecht.translate',
        'bluemoon.dms.format',
        'bluemoon.dms.managers',
        'bluemoon.dms.client-grid.templates'
    ]);

    var dmsClientGridService = function() {
            this.templatePath = function(template) {
                return 'components/client-grid/' + template + '.2js.html';
            };
        };

    bmoonApp.service('dmsClientGridService', dmsClientGridService);
})(window.angular, window._);

(function(angular) {
    'use strict';

    var bmoonApp = angular.module('bluemoon.dms.client-grid');

    var dmsClientGrid = function(dmsClientGridService) {
            return {
                restrict: 'E',
                replace: true,
                scope : {
                    gridItemsFunction: '&',
                    pageState: '=',
                    currentContainer : '=',
                    customOptions : '=',
                    headerRowHeight : '=',
                    rowHeight : '=',
                    searchMethod : '=',
                    buttons : '='
                },
                templateUrl: dmsClientGridService.templatePath('client-grid-template'),
                controller: 'clientGridController'
            };
        };

    dmsClientGrid.$inject = ['dmsClientGridService'];
    bmoonApp.directive('dmsClientGrid', dmsClientGrid);
})(window.angular, window._);

(function(angular){
    'use strict';

    var bmoonApp = angular.module('bluemoon.dms.client-grid');

    var clientGridController = function($rootScope, $scope, $q, $translate, dmsClientGridService, $timeout, $domUtilityService) {

        //  Initialize
        var vm = this;

        $scope.selectInfo =  [
                {
                    value: 10,
                    label: 10
                },
                {
                    value: 25,
                    label: 25
                },
                {
                    value: 50,
                    label: 50
                },
                {
                    value: 100,
                    label: 100
                }
            ];

        $scope.sortInfo = {
            fields: ['name'],
            directions: ['asc']
        };

        $scope.searchInput = {
            text: undefined
        };

        $scope.options = {};

        var defaultOptions = {
            headerRowHeight : $scope.headerRowHeight,
            rowHeight : $scope.rowHeight,
            showSelectionCheckbox : false,
            filterOptions : {
                filterText : '',
                useExternalFilter : false
            },
            showColumnMenu : false,
            showGroupPanel : false,
        };

        $scope.columnDefs = [
            {
                cellTemplate: dmsClientGridService.templatePath('client-id-cell-template'),
                field: 'code',
                width: '10%',
                minWidth: '150'
            },
            {
                cellTemplate: dmsClientGridService.templatePath('client-name-cell-template'),
                field: 'name',
                width: '90%',
                minWidth: '150'
            },
        ];

        vm._loadStringsForColumnHeaders = function() {
            var translatePromises = [
                $translate('Bluemoon.DMS.Grid.Client.Id').then(function(s) {
                    $scope.columnDefs[0].displayName = s;
                }),
                $translate('Bluemoon.DMS.Grid.Client.Name').then(function(s) {
                    $scope.columnDefs[1].displayName = s;
                })
            ];

            return $q.all(translatePromises);
        };

        //  Run on init
        vm._loadStrings = function() {
            vm._loadStringsForColumnHeaders();
        };

        vm._loadStrings();

        $scope.$on('bmLanguageChangeSuccess', function() {
            vm._loadStrings();
        });

        var fixedOptions = {
            columnDefs : 'columnDefs',
            data : 'displayItems',
            enableSorting: true,
            sortInfo : $scope.sortInfo,
            useExternalSorting : true
        };

        angular.extend($scope.options, defaultOptions);
        angular.extend($scope.options, $scope.customOptions);
        angular.extend($scope.options, fixedOptions);

        $scope.displayItems = [];

        $scope.getIdTooltip = function(code, rowIndex) {
            var clientDiv = document.getElementById('dms-client-id-cell-' + rowIndex);

            if (clientDiv === null) { return null; } //we werent ready yet

            var containingDiv = clientDiv.getElementsByTagName('a')[0];

            if (!containingDiv || !containingDiv.offsetWidth || !containingDiv.scrollWidth) { return null; }

            if (containingDiv.offsetWidth < containingDiv.scrollWidth){
                return code;
            }
            return null;
        };

        $scope.getIdCellId = function(row) {
            return 'dms-client-id-cell-' + row.rowIndex;
        };

        //  Private methods

        var getGridItems = function() {
            $scope.pageState.sort = $scope.sortInfo.fields[0] + ':' +
                $scope.sortInfo.directions[0];
            return $scope.gridItemsFunction().then(function(result) {
                $scope.pageState.totalItems = result.totalItems;
                $scope.displayItems = result.items;
            });
        };

        var ignoreInitialLoadWatchFunction = function(watchFunction) {
            return function(newValue, oldValue) {
                if (newValue !== oldValue) {
                    watchFunction(newValue, oldValue);
                }
            };
        };

        //  Listeners

        $scope.$on('dms-grid-refresh', function() {
            getGridItems();
        });

        //  Watches

        var getGridItemsAfterInitialLoad = ignoreInitialLoadWatchFunction(getGridItems);

        $scope.$watchCollection('sortInfo.fields', getGridItemsAfterInitialLoad);
        $scope.$watchCollection('sortInfo.directions', getGridItemsAfterInitialLoad);
        $scope.$watch('pageState.page', getGridItemsAfterInitialLoad);

        $scope.$watch('pageState.itemsPerPage', ignoreInitialLoadWatchFunction(
            function(){
                getGridItems().then(function(){
                    $timeout(function(){
                        $domUtilityService.RebuildGrid(
                            $scope.options.$gridScope,
                            $scope.options.ngGrid);
                    });
                });
            })
        );

        getGridItems();
    };

    clientGridController.$inject = ['$rootScope', '$scope', '$q', '$translate', 'dmsClientGridService', '$timeout', '$domUtilityService'];
    bmoonApp.controller('clientGridController', clientGridController);
})(window.angular, window._);

angular.module('bluemoon.dms.client-grid.templates', ['components/client-grid/client-grid-template.2js.html', 'components/client-grid/client-id-cell-template.2js.html', 'components/client-grid/client-name-cell-template.2js.html']);

angular.module("components/client-grid/client-grid-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/client-grid/client-grid-template.2js.html",
    "<div class=\"client-main-container dataTables_wrapper\">\n" +
    "  <div class=\"bmoon-grid-style no-scroll-grid bmoon-grid-actions-included\"\n" +
    "      ng-grid=\"options\">\n" +
    "  </div>\n" +
    "  <div class=\"page-section-top\">\n" +
    "        {{ footerMessage }}\n" +
    "  </div>\n" +
    "  <div bento-pagination\n" +
    "    page=\"pageState.page\"\n" +
    "    direction-links=\"true\"\n" +
    "    boundary-links=\"true\"\n" +
    "    total-items=\"pageState.totalItems\"\n" +
    "    items-array=\"selectInfo\"\n" +
    "    items-per-page=\"pageState.itemsPerPage\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/client-grid/client-id-cell-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/client-grid/client-id-cell-template.2js.html",
    "<div class=\"ngCellText client-id-cell\" ng-class=\"col.colIndex()\" ng-attr-id=\"{{getIdCellId(row)}}\">\n" +
    "    <a href=\"\" ng-href=\"{{row.entity.link}}\"\n" +
    "       uib-tooltip=\"{{getIdTooltip(row.entity.code, row.rowIndex)}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">\n" +
    "        {{row.getProperty(col.field)}}\n" +
    "    </a>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/client-grid/client-name-cell-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/client-grid/client-name-cell-template.2js.html",
    "<div class=\"ngCellText\" ng-class=\"col.colIndex()\">\n" +
    "    <a href=\"\" ng-href=\"{{row.entity.link}}\">\n" +
    "        {{row.getProperty(col.field)}}\n" +
    "    </a>\n" +
    "</div>\n" +
    "");
}]);

(function(Dropbox) {
    'use strict';

    var bmoonApp = angular.module('bluemoon.dms.cloud', []);

    var dmsDropbox = function(){

        this.isAvailable = false;

        this.checkAvailability = function(){
            if (!Dropbox || Dropbox === undefined){
                this.isAvailable = false;
            } else {
                this.isAvailable = true;
            }
        };

        var addPeriodToTypes = function(typeArr){
            var newArr = [];
            for (var i = 0; i < typeArr.length; i++){
                newArr.push('.' + typeArr[i]);
            }
            return newArr;
        };

        this.create = function(callback, allowedFileTypes) {
            if (!this.isAvailable) {
                console.log('There was an error connecting to Dropbox.');
                return;
            }

            var fixedTypes;
            if (allowedFileTypes && allowedFileTypes.length > 0) {
                fixedTypes = addPeriodToTypes(allowedFileTypes);
            } else {
                //resort to a reasonable default
                fixedTypes =  ['images', 'documents', 'text'];
            }

            var callbackFn = callback;

            var options = {

                success: function(files) {
                    callbackFn(files);
                },

                cancel: function() {},

                linkType: 'direct', // or "preview"

                multiselect: true, // or false

                extensions: fixedTypes,
            };

            return Dropbox.choose(options);
        };

        this.checkAvailability();
    };

    dmsDropbox.$inject = [];
    bmoonApp.service('dmsDropbox', dmsDropbox);
})(window.Dropbox);

(function(gapi) {
    'use strict';
    /*global google*/

    var bmoonApp = angular.module('bluemoon.dms.cloud');

    var dmsGoogleDrive = function(){
        //TODO: move these so they're more secure?

        // The Browser API key obtained from the Google Developers Console.
        var developerKey = 'AIzaSyCondHOPQXNUjYChzdVdebw_BlrfCbajZM';

        // The Client ID obtained from the Google Developers Console.
        var clientId = '420529219805-mivacv48b2dmg2eqd811rfsmp5oe9krt.apps.googleusercontent.com';

        // Scope to use to access user's photos.
        var scope = ['https://www.googleapis.com/auth/drive.readonly'];

        var gDocsTypeArray = ['application/vnd.google-apps.spreadsheet', 'application/vnd.google-apps.document', 'application/vnd.google-apps.presentation'];

        gapi.load('auth', function(){});

        //Map a MimeType to a ExportLink for GDocs
        var exportMap =
        {
            'application/pdf': 'application/pdf',
            'application/vnd.google-apps.spreadsheet': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.google-apps.document': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.google-apps.presentation': 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
        };

        var pickerApiLoaded = false;
        var oauthToken;
        var callbackFn;
        var internalPicker = null;

        var destroy = function(){
            internalPicker.setVisible(false);
            internalPicker = null;
        };

        var buildLinkFromGDrive = function(file){
            if (file.downloadUrl) {
                return file.downloadUrl;
            } else if (file.exportLinks) {
                var type = exportMap[file.mimeType];
                if (type !== undefined) {
                    return file.exportLinks[type];
                } else {
                    //Resort to PDF if we don't have a known type in our map
                    return file.exportLinks['application/pdf'];
                }
            }
        };

        var buildTitleFromGDrive = function(file, link){
            var extension = '';
            //If this was a Google Document, we exported it as a [arbitrary type] and need to detect that.
            if (link.indexOf('exportFormat=') > -1) {
                var exportIndex = link.lastIndexOf('=') + 1;
                extension = '.' + link.substring(exportIndex, link.length);
            } else if (file.fileExtension && file.fileExtension !== undefined){
                if (file.title.lastIndexOf(file.fileExtension)  !== (file.title.length - file.fileExtension.length)) {
                    extension = '.' + file.fileExtension;
                }
            } else {
                var mimeTypeIndex = file.mimeType.lastIndexOf('/') + 1;
                extension = '.' + file.mimeType.substring(mimeTypeIndex, file.mimeType.length);
            }
            return file.title + extension;
        };

        var loadEventFunctionBuilder = function(request){
            return function(){
                var file = JSON.parse(request.responseText);
                /*jshint camelcase: false */
                var freshToken = gapi.auth.getToken().access_token;
                /*jshint camelcase: true */

                var link = buildLinkFromGDrive(file);
                var title = buildTitleFromGDrive(file, link);
                var size;

                if (gDocsTypeArray.indexOf(file.mimeType) > -1){
                    size = null;
                } else {
                    size = parseInt(file.fileSize);
                }

                callbackFn(link, title, size, freshToken);
            };
        };

        // A simple callback implementation.
        var pickerCallback = function(data){
            if (data[google.picker.Response.ACTION] === google.picker.Action.PICKED){
                for (var i = 0; i < data[google.picker.Response.DOCUMENTS].length; i++){

                    var doc = data[google.picker.Response.DOCUMENTS][i];
                    /*jshint camelcase: false */
                    var accessToken = gapi.auth.getToken().access_token;
                    /*jshint camelcase: true */
                    var request = new XMLHttpRequest();

                    request.open('GET', 'https://www.googleapis.com/drive/v2/files/' + doc.id);
                    request.setRequestHeader('Authorization', 'Bearer ' + accessToken);

                    request.addEventListener('load', loadEventFunctionBuilder(request));

                    request.send();
                }
                destroy();
                return;
            }
            if (data[google.picker.Response.ACTION] === google.picker.Action.CANCEL){
                destroy();
                return;
            }
        };

        // Create and render a Picker object for picking user Photos.
        var createPicker = function(){
            if (pickerApiLoaded && oauthToken && !internalPicker){
                var view = new google.picker.View(google.picker.ViewId.DOCS);
                internalPicker = new google.picker.PickerBuilder()
                                .addView(view)
                                .setOAuthToken(oauthToken)
                                .setDeveloperKey(developerKey)
                                .enableFeature(google.picker.Feature.NAV_HIDDEN)
                                .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
                                .setCallback(pickerCallback)
                                .build();
                internalPicker.setVisible(true);
            }
        };

        var handleAuthResult = function(authResult){
            if (authResult && !authResult.error){
                /*jshint camelcase: false */
                oauthToken = authResult.access_token;
                /*jshint camelcase: true */
                createPicker();
            }
        };

        var onAuthApiLoad = function(){
            window.gapi.auth.authorize(
                {
                    'client_id': clientId,
                    'scope': scope,
                    'immediate': false
                },
            handleAuthResult);
        };

        var onPickerApiLoad = function(){
            pickerApiLoaded = true;
            createPicker();
        };

        // Use the API Loader script to load google.picker and gapi.auth.
        var loadPicker = function(){
            onAuthApiLoad();
            gapi.load('picker', {'callback': onPickerApiLoad});
        };

        this.isAvailable = false;

        this.checkAvailability = function(){
            if (!gapi || gapi === undefined){
                this.isAvailable = false;
            } else {
                this.isAvailable = true;
            }
        };

        this.create = function(callback) {
            if (!this.isAvailable) {
                console.log('There was an error connecting to Google Drive.');
                return;
            }

            callbackFn = callback;
            loadPicker();
        };

        this.checkAvailability();
    };

    dmsGoogleDrive.$inject = [];
    bmoonApp.service('dmsGoogleDrive', dmsGoogleDrive);
})(window.gapi);

(function(BoxSelect) {
    'use strict';

    var bmoonApp = angular.module('bluemoon.dms.cloud');

    var dmsBox = function(){

        this.boxSelect = null;
        var savedCallback = null;

        this.isAvailable = false;

        this.checkAvailability = function(){
            if (!BoxSelect || BoxSelect === undefined){
                this.isAvailable = false;
            } else {
                this.isAvailable = true;
            }
        };

        this.create = function(callback) {
            if (!this.isAvailable) {
                console.log('There was an error connecting to Box.');
                return;
            }

            var options = {
                clientId: '1yw13od7l48p4xr3tgdawjoox7cekzvp',
                linkType: 'direct',
                multiselect: 'true'
            };

            savedCallback = callback;

            if (!this.boxSelect || String(callback) !== String(savedCallback)){
                this.boxSelect = new BoxSelect(options);

                this.boxSelect.success(function(response){
                    savedCallback(response);
                });

                this.boxSelect.cancel(function(){});
            }

            this.boxSelect.launchPopup();
        };

        this.checkAvailability();
    };

    dmsBox.$inject = [];
    bmoonApp.service('dmsBox', dmsBox);
})(window.BoxSelect);

(function(angular, _) {
    'use strict';

    //  Blank module for dev, overwritten for dist
    angular.module('bluemoon.dms.document-grid.templates', []);

    angular.module('bluemoon.dms.document-grid', [
        'pascalprecht.translate',
        'ngGrid',
        'bluemoon.dms.ui-services',
        'bluemoon.dms.format',
        'bluemoon.dms.managers',
        'bluemoon.dms.document-grid.templates',
        'bluemoon.dms.icon'
    ])

    .service('dmsDocumentGridService', function() {
        this.templatePath = function(template) {
            return 'components/document-grid/' + template + '.2js.html';
        };
    })

    .directive('dmsDocumentGrid', ['dmsDocumentGridService',
        function(dmsDocumentGridService) {

            return {
                restrict: 'E',
                replace: true,
                scope : {
                    gridItemsFunction: '&',
                    pageState: '=',
                    selectedItems : '=',
                    clientId : '=',
                    projectId : '=',
                    currentContainer : '=',
                    customOptions : '=',
                    headerRowHeight : '=',
                    rowHeight : '=',
                    searchMethod : '=',
                    buttons : '=',
                    itemHrefFunction : '&',
                },
                templateUrl: dmsDocumentGridService.templatePath('document-grid-template'),
                controller: 'documentGridController'
            };
        }
    ])

    .controller('documentGridController', [
        '$rootScope',
        '$scope',
        '$q',
        '$translate',
        '$sce',
        'fileManager',
        'dmsDocumentGridService',
        'UiService',
        'dmsDocumentUiService',
        'dmsIconService',
        '$attrs',
        '$domUtilityService',
        '$timeout',
        '$filter',
        'bmAccess',
        function (
            $rootScope,
            $scope,
            $q,
            $translate,
            $sce,
            fileManager,
            dmsDocumentGridService,
            UiService,
            documentUiService,
            dmsIconService,
            $attrs,
            $domUtilityService,
            $timeout,
            $filter,
            bmAccess) {
            var vm = this;

            $scope.hasDueDateIac = false;
            $scope.columnDefs = [
                {
                    headerCellTemplate: dmsDocumentGridService.templatePath('header-column-template'),
                    cellTemplate: dmsDocumentGridService.templatePath('type-column-template'),
                    field: 'type',
                    width: '7%',
                    sortable: false //TODO: re-enable at some point
                },
                {
                    headerCellTemplate: dmsDocumentGridService.templatePath('header-column-template'),
                    cellTemplate: dmsDocumentGridService.templatePath('folder-grid-cell-template'),
                    field: 'name',
                    width: '43%',
                },
                {
                    headerCellTemplate: dmsDocumentGridService.templatePath('header-column-template'),
                    cellTemplate: dmsDocumentGridService.templatePath('date-column-template'),
                    field: 'modifiedDate',
                    width: '25%',
                },
                {
                    headerCellTemplate: dmsDocumentGridService.templatePath('header-column-template'),
                    cellTemplate: dmsDocumentGridService.templatePath('size-column-template'),
                    field: 'originalItemSize',
                    width: '25%',
                    sortable: false
                },
            ];

            bmAccess.has('DMS_DocumentDueDate').then(function(){
                $scope.hasDueDateIac = true;
                var dueDatecolumn = {
                    headerCellTemplate: dmsDocumentGridService.templatePath('header-column-template'),
                    cellTemplate: dmsDocumentGridService.templatePath('date-column-template'),
                    field: 'customFields.dueDate',
                    sortField: 'dueDate',
                    width: '12%'
                };
                $scope.columnDefs.splice(2, 0, dueDatecolumn);
                $scope.columnDefs[3].width = '13%';
            });

            vm._loadStringsForColumnHeaders = function() {
                var translatePromises = [
                    $translate('Bluemoon.DMS.Grid.Document.Type').then(function(s) {
                        $scope.columnDefs[0].displayName = s;
                    }),
                    $translate('Bluemoon.DMS.Grid.Document.Name').then(function(s) {
                        $scope.columnDefs[1].displayName = s;
                    }),
                    $translate('Bluemoon.DMS.Grid.Document.DueDate').then(function(s) {
                        if($scope.hasDueDateIac) {
                            $scope.columnDefs[2].displayName = s;
                        }
                    }),
                    $translate('Bluemoon.DMS.Grid.Document.ModifiedDate').then(function(s) {
                        var index = $scope.hasDueDateIac ? 3 : 2;
                        $scope.columnDefs[index].displayName = s;
                    }),
                    $translate('Bluemoon.DMS.Grid.Document.Size').then(function(s) {
                        var index = $scope.hasDueDateIac ? 4 : 3;
                        $scope.columnDefs[index].displayName = s;
                    }),
                ];

                return $q.all(translatePromises);
            };

            vm._loadStringsForFooter = function() {
                if (angular.isString($scope.footerMessage) && angular.isArray($scope.displayItems) &&
                    $scope.displayItems.length === 0){
                    return $translate('Bluemoon.DMS.Grid.Document.FolderIsEmpty').then(function(s) {
                        $scope.footerMessage = s;
                    });
                }

                var defer = $q.defer();
                defer.resolve();
                return defer.promise;
            };

            vm._sharedFolderTooltip = '';
            vm._folderTooltip = '';

            vm._loadStringsForTooltips = function() {

                vm._sharedFolderTooltip = vm._sharedFolderTooltip || '';
                vm._folderTooltip = vm._folderTooltip || '';

                var translatePromises = [
                    $translate('Bluemoon.DMS.Grid.SharedFolder').then(function(s){
                        vm._sharedFolderTooltip = s;
                    }),
                    $translate('Bluemoon.DMS.Grid.Folder').then(function(s){
                        vm._folderTooltip = s;
                    }),
                ];

                return $q.all(translatePromises);
            };

            //  Run on init
            vm._loadStrings = function() {
                vm._loadStringsForColumnHeaders();
                vm._loadStringsForFooter();
                vm._loadStringsForTooltips();
            };

            vm._loadStrings();

            $scope.$on('bmLanguageChangeSuccess', function() {
                vm._loadStrings();
            });

            var fixedOptions = {
                columnDefs : 'columnDefs',
                data : 'displayItems'
            };

            var ascendingDirection = $scope.ascendingDirection = 'asc';
            var descendingDirection = $scope.descendingDirection = 'desc';

            var getOppositeDirection = function(currentDirection) {
                return currentDirection === ascendingDirection ?
                    descendingDirection : ascendingDirection;
            };

            var getPageSort = function(field, direction) {
                return field + ':' + direction;
            };

            var setPageSort = function() {
                var field = $scope.columnDefs[$scope.sortingColumnIndex].sortField ?
                    $scope.columnDefs[$scope.sortingColumnIndex].sortField :
                    $scope.columnDefs[$scope.sortingColumnIndex].field;

                $scope.pageState.sort = getPageSort(field,
                    $scope.sortingDirection);
            };

            $scope.sortingColumnIndex = 1;
            $scope.sortingDirection = ascendingDirection;

            setPageSort();

            $scope.changeSortingColumn = function(newColumn) {
                if (newColumn.sortable) {
                    if ($scope.sortingColumnIndex !== newColumn.colDef.index) {
                        $scope.sortingColumnIndex = newColumn.colDef.index;
                        $scope.sortingDirection = ascendingDirection;
                    } else {
                        $scope.sortingDirection = getOppositeDirection($scope.sortingDirection);
                    }

                    setPageSort();

                    vm.getGridItems();
                }
            };

            $scope.isSortingColumnWithDirection = function(column, direction) {
                return $scope.sortingColumnIndex === column.colDef.index &&
                    direction === $scope.sortingDirection;
            };

            $scope.$watch('pageState.page', function(newValue, oldValue){
                if (oldValue !== newValue) {  //  Blocks initial load
                    vm.getGridItems();
                }
            });

            var forceGridReRender = function() {
                $timeout(function(){
                    $domUtilityService.RebuildGrid(
                        $scope.options.$gridScope,
                        $scope.options.ngGrid);
                });
            };

            $scope.$watch('pageState.itemsPerPage', function(newValue, oldValue){
                if (oldValue !== newValue) {  //  Blocks initial load
                    vm.getGridItems().then(forceGridReRender);
                }
            });

            $scope.displayItems = [];

            var knownFileTypes;

            var getFileTypes = function(){
                return documentUiService.getConstraints({busily: false}).then(function(constraints){
                    return constraints.allowedTypes;
                });
            };

            vm.getGridItems = function(options) {
                return getFileTypes().then(function(resultTypes){
                    knownFileTypes = resultTypes;
                    return $scope.gridItemsFunction({options: options || {}})
                        .then(function(result){
                            return vm._gridItemsFunctionCallback(result);
                        });
                });
            };

            vm._gridItemsFunctionCallback = function(result) {
                $scope.pageState.totalItems = result.totalItems;
                $scope.footerMessage = '';

                $scope.displayItems = result.items;
                vm._loadStringsForFooter();

                var itemsStillSelected = _.filter($scope.displayItems, function(gridItem){
                    return _.find($scope.selectedItems, function(selectedGridItem) {
                        return gridItem.id === selectedGridItem.id;
                    }) !== undefined;
                });

                //  Referential integrity is important here
                $scope.selectedItems.length = 0;
                _.each(itemsStillSelected, function(item){
                    $scope.selectedItems.push(item);
                });
            };

            vm.getGridItems().then(forceGridReRender);

            $scope.isSorted = [false, false, false, false];

            var checkDisable = function(button, selectedItems){
                if (angular.isFunction(button.isEnabled)){
                    button.disabled = !button.isEnabled(selectedItems);
                }
            };

            var onGridSelectionChanged = function(){
                var gridData = { 'currentContainer' : $scope.currentContainer, 'selectedItems' : $scope.selectedItems };
                if ($scope.buttons) {
                    for (var buttonLabel in $scope.buttons) {
                        var button = $scope.buttons[buttonLabel];

                        if (button.moreButtons){
                            for (var subButton in button.moreButtons){
                                checkDisable(button.moreButtons[subButton], gridData);
                            }
                        }

                        checkDisable(button, gridData);
                    }
                }
                if (gridData.selectedItems && gridData.selectedItems.length === 0){
                    var selectAllHeader = angular.element('.ngSelectionHeader').scope();
                    if (selectAllHeader){
                        selectAllHeader.allSelected = false;
                    }
                }
            };

            if ($attrs.itemHrefFunction) {
                $scope.getItemHref = function(item) {
                    return $scope.itemHrefFunction({
                        itemData : {
                            item : item,
                            clientId : $scope.clientId,
                            projectId : $scope.projectId
                        }
                    });
                };
            } else {
                $scope.getItemHref = function(item) {
                    return UiService.getFolderUiItemHref({
                        item : item,
                        clientId : $scope.clientId,
                        projectId : $scope.projectId
                    });
                };
            }

            $scope.downloadFile = function(item) {
                documentUiService.download({
                    params: {
                        document: {
                            id: item.id,
                            parentItem: item.parentItem
                        }
                    }
                });
            };

            $scope.IsPreviewable = function(item) {
                return item.isViewable || fileManager.isPreviewSupported(item.mimeType);
            };

            $scope.GetFolderIcon = function(item) {
                if (item.isShared){
                    // This is a custom icon
                    return 'dms-assorted-shared-folder';
                }
                return 'bento-icon-folder';
            };

            $scope.getFolderTooltip = function(item) {
                return item.isShared ? vm._sharedFolderTooltip : vm._folderTooltip;
            };

            $scope.getLockTooltip = function(item){
                if (item.lock){
                    return $translate.instant('Bluemoon.DMS.Common.Locked');
                } else {
                    return '';
                }
            };

            $scope.getNameTooltip = function(filename, rowIndex) {
                var nameDiv = document.getElementById('dms-folder-name-cell-' + rowIndex);

                if (nameDiv === null) { return null; } //we werent ready yet

                var containingDiv = nameDiv.getElementsByTagName('a')[0];

                if (!containingDiv || !containingDiv.offsetWidth || !containingDiv.scrollWidth) { return null; }

                if (containingDiv.offsetWidth < containingDiv.scrollWidth){
                    return filename;
                }
                return null;
            };

            $scope.getDateTooltip = function(date, rowIndex) {
                var filter = $filter('formatDate');

                var dateDiv = document.getElementById('dms-folder-date-cell-' + rowIndex);

                if (dateDiv === null) { return null; } //we werent ready yet

                var containingDiv = dateDiv.getElementsByTagName('a')[0];

                if (!containingDiv || !containingDiv.offsetWidth || !containingDiv.scrollWidth) { return null; }

                if (containingDiv.offsetWidth < containingDiv.scrollWidth){
                    return filter(date);
                }
                return null;
            };

            $scope.getDateCellId = function(row) {
                return 'dms-folder-date-cell-' + row.rowIndex;
            };

            $scope.getNameCellId = function(row) {
                return 'dms-folder-name-cell-' + row.rowIndex;
            };

            $scope.onSearchInputChange = function($event) {
                if ($scope.searchMethod && $scope.searchInput.text &&
                    $scope.searchInput.text !== '' && $event.keyCode === 13) {
                    $scope.searchMethod($scope.searchInput.text);
                }
            };

            $scope.getFileExtension = function(docName){
                var loc = docName.lastIndexOf('.');
                return docName.substring(loc + 1).toLowerCase();
            };

            $scope.getFileIcon = function(docName){
                var icon = $scope.getFileExtension(docName);

                if (knownFileTypes.indexOf(icon) > -1) {
                    // THESE ARE CUSTOM ICONS
                    return 'icon-' + icon;
                } else {
                    return 'bento-icon-file';
                }
            };

            $scope.getTypeTooltip = function(item) {
                if (item.itemType.toLowerCase() === 'folder'){
                    return item.isShared ? vm._sharedFolderTooltip : vm._folderTooltip;
                } else {
                    if(item.urlType && item.urlType.toLowerCase() === 'checkpointengage'){
                        return 'Checkpoint Engage';
                    } else if (item.urlType && item.urlType.toLowerCase() === 'genericlink') {
                        return 'Link';
                    } else {
                        return $scope.getFileExtension(item.name);
                    }
                }
            };

            $scope.getType = function(item) {
                if (item.itemType.toLowerCase() === 'folder'){
                    return item.isShared ? 'shared-folder' : 'folder';
                } else {
                    if(item.urlType && item.urlType.toLowerCase() === 'checkpointengage'){
                        return 'checkpoint-engage-file-icon';
                    } else if (item.urlType && item.urlType.toLowerCase() === 'genericlink') {
                        return 'bento-icon-link';
                    } else {
                        return $scope.getFileExtension(item.name);
                    }
                }
            };

            $scope.getIcon = function(item) {
                return dmsIconService.getIcon($scope.getType(item));
            };

            var customOptions = $scope.customOptions;

            if (!$scope.selectedItems) {
                $scope.selectedItems = [];
            }

            $scope.selectInfo =  [
                    {
                        value: 10,
                        label: 10
                    },
                    {
                        value: 25,
                        label: 25
                    },
                    {
                        value: 50,
                        label: 50
                    },
                    {
                        value: 100,
                        label: 100
                    }
                ];

            var defaultOptions = {
                headerRowHeight : $scope.headerRowHeight,
                rowHeight : $scope.rowHeight,
                selectedItems : $scope.selectedItems,
                showSelectionCheckbox : true,
                filterOptions : {
                    filterText : '',
                    useExternalFilter : false
                },
            };

            $scope.options = {};

            $scope.searchInput = {
                text: undefined
            };

            angular.extend($scope.options, defaultOptions);
            angular.extend($scope.options, customOptions);
            angular.extend($scope.options, fixedOptions);

            $scope.$watchCollection('selectedItems', onGridSelectionChanged);
            $scope.$watch('currentContainer', onGridSelectionChanged);

            $scope.$on('dms-grid-refresh', function(event, refreshOptions) {
                vm.getGridItems(refreshOptions);
            });
        }
    ]);

})(window.angular, window._);

angular.module('bluemoon.dms.document-grid.templates', ['components/document-grid/date-column-template.2js.html', 'components/document-grid/document-grid-template.2js.html', 'components/document-grid/folder-grid-cell-template.2js.html', 'components/document-grid/header-column-template.2js.html', 'components/document-grid/size-column-template.2js.html', 'components/document-grid/type-column-template.2js.html']);

angular.module("components/document-grid/date-column-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/document-grid/date-column-template.2js.html",
    "<div class=\"ngCellText\" ng-class=\"col.colIndex()\">\n" +
    "    <div class=\"dms-folder-date-cell\" ng-attr-id=\"{{getDateCellId(row)}}\">\n" +
    "        <span ng-cell-text uib-tooltip=\"{{getDateTooltip(row.entity.modifiedDate, row.rowIndex)}}\"\n" +
    "              tooltip-placement=\"top\" tooltip-append-to-body=\"true\">{{COL_FIELD | formatDate}}</span>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/document-grid/document-grid-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/document-grid/document-grid-template.2js.html",
    "<div class=\"document-grid-container dataTables_wrapper\">\n" +
    "	<div class=\"bmoon-grid-style no-scroll-grid bmoon-grid-actions-included\"\n" +
    "		ng-grid=\"options\">\n" +
    "	</div>\n" +
    "	<div class=\"page-section-top dms-center-text\">\n" +
    "        {{ footerMessage }}\n" +
    "  </div>\n" +
    "  <div bento-pagination\n" +
    "    page=\"pageState.page\"\n" +
    "    direction-links=\"true\"\n" +
    "    boundary-links=\"true\"\n" +
    "    total-items=\"pageState.totalItems\"\n" +
    "    items-array=\"selectInfo\"\n" +
    "    items-per-page=\"pageState.itemsPerPage\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/document-grid/folder-grid-cell-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/document-grid/folder-grid-cell-template.2js.html",
    "<div class=\"ngCellText\" ng-attr-id=\"{{getNameCellId(row)}}\"\n" +
    "  ng-if=\"row.entity.itemType === 'Folder'\"\n" +
    "  ng-class=\"col.colIndex()\"\n" +
    "  dms-drag-over\n" +
    "  dms-drag-over-class=\"over-cell\"\n" +
    "  dms-drop\n" +
    "  dms-item=\"{{row.entity}}\"\n" +
    "  dms-move>\n" +
    "  <div class=\"dms-folder-name-cell\">\n" +
    "    <a href=\"\" ng-href=\"{{getItemHref(row.entity)}}\"\n" +
    "      uib-tooltip=\"{{getNameTooltip(row.entity.name, row.rowIndex)}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">\n" +
    "      {{row.getProperty(col.field)}}\n" +
    "    </a>\n" +
    "  </div>\n" +
    "  <span ng-if=\"row.entity.lock\" class=\"bento-icon-lock dms-lock-icon\"\n" +
    "      uib-tooltip=\"{{getLockTooltip(row.entity)}}\" tooltip-placement=\"top\"\n" +
    "      tooltip-append-to-body=\"true\">\n" +
    "  </span>\n" +
    "</div>\n" +
    "<div ng-if=\"row.entity.itemType !== 'Folder'\" class=\"ngCellText\" ng-class=\"col.colIndex()\" ng-attr-id=\"{{getNameCellId(row)}}\">\n" +
    "  <div class=\"dms-folder-name-cell\">\n" +
    "    <a ng-if=\"IsPreviewable(row.entity)\" href=\"\" ng-href=\"{{getItemHref(row.entity)}}\"\n" +
    "      dms-item=\"{{row.entity}}\"\n" +
    "      dms-move\n" +
    "      uib-tooltip=\"{{getNameTooltip(row.entity.name, row.rowIndex)}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">\n" +
    "      {{row.getProperty(col.field)}}\n" +
    "    </a>\n" +
    "    <a ng-if=\"!IsPreviewable(row.entity)\" href=\"\" ng-click=\"downloadFile(row.entity)\"\n" +
    "      dms-item=\"{{row.entity}}\"\n" +
    "      dms-move\n" +
    "      uib-tooltip=\"{{getNameTooltip(row.entity.name, row.rowIndex)}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">\n" +
    "      {{row.getProperty(col.field)}}\n" +
    "    </a>\n" +
    "  </div>\n" +
    "  <span ng-if=\"currentContainer.isShared\" class=\"bento-icon-share\"></span>\n" +
    "  <span ng-if=\"row.entity.lock\" class=\"bento-icon-lock dms-lock-icon\"\n" +
    "      uib-tooltip=\"{{getLockTooltip(row.entity)}}\" tooltip-placement=\"top\"\n" +
    "      tooltip-append-to-body=\"true\">\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/document-grid/header-column-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/document-grid/header-column-template.2js.html",
    "<div ng-click=\"changeSortingColumn(col)\"\n" +
    "	class=\"{{col.headerClass}}\"\n" +
    "	ng-style=\"{cursor: col.cursor}\"\n" +
    "	ng-class=\"{ ngSorted: sortingColumnIndex === col.index - 1, ngHeaderSortColumn: col.sortable }\">\n" +
    "    <div ng-class=\"'colt' + col.index\" class=\"ngHeaderText\">{{col.displayName}}</div>\n" +
    "    <div class=\"ngSortButtonDown\"\n" +
    "    	ng-show=\"isSortingColumnWithDirection(col, ascendingDirection)\"></div>\n" +
    "    <div class=\"ngSortButtonUp\"\n" +
    "    	ng-show=\"isSortingColumnWithDirection(col, descendingDirection)\"></div>\n" +
    "    <div class=\"ngSortPriority\">{{col.sortPriority}}</div>\n" +
    "    <div ng-show=\"col.resizable\" class=\"ngHeaderGrip\"\n" +
    "    	ng-click=\"col.gripClick($event)\" ng-mousedown=\"col.gripOnMouseDown($event)\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/document-grid/size-column-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/document-grid/size-column-template.2js.html",
    "<div class=\"ngCellText\" ng-class=\"col.colIndex()\">\n" +
    "    <span format-size=\"{{COL_FIELD}}\"></span>\n" +
    "</div>");
}]);

angular.module("components/document-grid/type-column-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/document-grid/type-column-template.2js.html",
    "<div class=\"ngCellText dms-type-cell\" ng-class=\"col.colIndex()\">\n" +
    "  <dms-icon data-qe-id=\"dmsDocumentGrid-type-{{row.entity.name}}\" type=\"{{getType(row.entity)}}\" uib-tooltip=\"{{getTypeTooltip(row.entity)}}\" tooltip-append-to-body=\"true\"  tooltip-placement=\"top\"></dms-icon>\n" +
    "</div>");
}]);

(function(angular){
    'use strict';

    //  Blank module for dev, overwritten for dist
    angular.module('bluemoon.dms.folder-selector.templates', []);

    angular.module('bluemoon.dms.folder-selector', [
        'bluemoon.dms.folder-selector.templates',
        'ui.bootstrap',
        'pascalprecht.translate',
    ]);

})(window.angular);

(function(angular, _){
    'use strict';

    angular.module('bluemoon.dms.folder-selector')

    .service('folderSelectorDirectiveService', [
        function() {
            this.templatePath = function(template) {
                return 'components/folder-selector/' + template + '.2js.html';
            };
        }
    ])

    .directive('folderSelector', [
        'folderSelectorDirectiveService',
        function(folderSelectorDirectiveService) {
            return {
                restrict: 'E',
                replace: true,
                scope: {
                    loadRootLevel: '&',
                    selectedItemChanged: '&',
                    currentItemChanged: '&',
                    disabledItems: '='
                },
                controller: 'folderSelectorDirectiveController',
                templateUrl: folderSelectorDirectiveService.templatePath('folder-selector-directive'),
            };
        }
    ])

    .controller('folderSelectorDirectiveController', [
        '$scope',
        '$q',
        'UiService',
        'clientUiService',
        'folderManager',
        'projectManager',
        function($scope, $q, UiService, clientUiService, folderManager, projectManager) {

            var _this = this;

            $scope.isLoading = false;

            $scope.busyLoaderConfig = {
                size: 'small'
            };

            $scope.$on('dmsFolderAdded', function(){
                _this.diveIntoItem($scope.currentItem);
            });

            $scope.$on('dmsProjectAdded', function(){
                _this.diveIntoItem($scope.currentItem);
            });

            $scope.$on('dms-operation-complete', function(event, operationModel) {
                switch (operationModel.type) {
                    case 'add':
                        _this.diveIntoItem($scope.currentItem);
                        break;
                }
            });

            _this.diveIntoItem = function(item) {
                $scope.isLoading = true;
                if (!item) {
                    $scope.loadRootLevel().then(function(result) {
                        _this.setCurrentItem(result);
                        $scope.isLoading = false;
                    });
                } else {
                    $q.all([_this.getContainer(item), _this.getChildren(item)])
                        .then(function(results) {
                            _this.setCurrentItem(results[0], results[1]);
                            $scope.isLoading = false;
                        });
                }
            };

            _this.getContainer = function(item) {
                var defer = $q.defer();

                if (item) {
                    defer.resolve(item);
                }

                return defer.promise;
            };

            var _getClientList = function() {
                return UiService.staffDocumentsPermission().then(function(permission){
                    if (permission === 'Granted') {
                        return clientUiService.getClientList({ busily: false });
                    } else {
                        return clientUiService.getClientsWithProjects({ busily: false });
                    }
                });
            };

            _this.getChildren = function(item) {
                var defer = $q.defer();

                if (item.isClientBranch) {
                    _getClientList().then(function(result){

                        var subContainers = Array.isArray(result.data) ? result.data : [];
                        _.each(subContainers, function(container) {
                            container.parent = item;
                        });

                        defer.resolve(subContainers);
                    });
                } else if (item.isTemplateBranch) {
                    var params = {
                        primaryAssociationId: 'Templates',
                        primaryAssociationType: 'Firm',
                        productType: 'DMSClientFolder' //TODO -- make more dynamic
                    };
                    projectManager.getProjectListWithConfigurationParameters(params).then(function(result) {

                        var subContainers = Array.isArray(result.data) ? result.data : [];
                        _.each(subContainers, function(container) {
                            container.parent = item;
                        });

                        defer.resolve(subContainers);
                    });
                } else if (item.itemType === 'Client') {
                    projectManager.getProjectList(item.id).then(function(result) {

                        var subContainers = Array.isArray(result.data) ? result.data : [];
                        _.each(subContainers, function(container) {
                            container.parent = item;
                        });

                        defer.resolve(subContainers);
                    });
                }else if (item.itemType === 'Project') {
                    projectManager.getProjectChildren(item.id, {
                        containersOnly: true
                    }).then(function(result) {

                        var subContainers = Array.isArray(result.data) ? result.data : [];
                        _.each(subContainers, function(container) {
                            container.parent = item;
                        });

                        defer.resolve(subContainers);
                    });
                } else if (item.itemType === 'Folder') {
                    folderManager.getFolderChildren(item.id, {
                        containersOnly: true
                    }).then(function(result) {

                        var subContainers = Array.isArray(result.data) ? result.data : [];
                        _.each(subContainers, function(container) {
                            container.parent = item;
                        });

                        defer.resolve(subContainers);
                    });
                } else if (item.subContainers) {
                    defer.resolve(item.subContainers);
                }

                return defer.promise;
            };

            _this.selectItem = function(folder) {
                $scope.selectedItem = folder;
                $scope.selectedItemChanged({newlySelectedItem: folder});
            };

            $scope.currentItem = {};
            _this.setCurrentItem = function(item, subContainers) {
                $scope.currentItem = item;
                if (subContainers) {
                    $scope.currentItem.subContainers = subContainers;
                }
                $scope.currentItemChanged({newCurrentItem: item});
            };

            var setupFolder = function(parentFolder, folder) {
                folder.parent = parentFolder;
                if (folder.subContainers && folder.subContainers !== null) {
                    _.each(folder.subContainers, function(subFolder) {
                        setupFolder(folder, subFolder);
                    });
                }
            };

            _this.diveIntoItem(null);
        }
    ]);

})(window.angular, window._);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.folder-selector')

    .directive('folderSelectorPane', [
        '$translate', '$window', 'folderSelectorDirectiveService',
        function($translate, $window, folderSelectorDirectiveService) {
            return {
                restrict: 'E',
                replace: true,
                require: '^folderSelector',
                scope: {
                    folder: '=',
                    isLoading: '=',
                    disabledItems: '='
                },
                controller: 'folderSelectorPaneDirectiveController',
                link: function(scope, element, attrs, folderSelectorControl) {

                    var _ = $window._;

                    $translate('bm.dms.productName').then(function(result){
                        scope.appName = result;
                    });

                    scope.currentFolderBarClick = function() {
                        scope.unselectItems();
                    };

                    scope.backArrowClick = function(event) {
                        scope.diveIntoItem(scope.folder.parent);
                        event.stopPropagation();
                    };

                    scope.itemMouseDown = function(item) {
                        if (!scope.isDisabled(item)) {
                            scope.selectItem(item);
                        }
                    };

                    scope.itemDoubleClick = function(item) {
                        if (!scope.isDisabled(item)) {
                            scope.diveIntoItem(item);
                        }
                    };

                    scope.unselectItems = function() {
                        scope.selectItem(scope.folder);
                    };

                    scope.selectItem = function(item) {
                        scope.selectedItem = item;
                        folderSelectorControl.selectItem(scope.selectedItem);
                    };

                    scope.diveIntoItem = function(item) {
                        scope.selectItem(item);
                        folderSelectorControl.diveIntoItem(item);
                    };

                    scope.breadcrumbCallback = function(item, $event) {
                        if (item && item.container){
                            scope.diveIntoItem(item.container);
                        } else {
                            scope.diveIntoItem(null);
                        }
                        $event.preventDefault();
                    };
                    /*
                    function createDocumentsPath() {
                        return $translate('Bluemoon.DMS.SpecialFolders.AllDocuments').then(function(s){
                            var item = {
                                icon: 'folder',
                                text: s,
                            };
                            return item;
                        });
                    }
                    */
                    //Add in an All Docs crumb, and remove the (redundant) last crumb
                    scope.breadcrumbPathCallback = function(path){
                        //Pop the last entry if there's a (then redundant) one.
                        if (path.length > 1){
                            path.pop();
                        }
                    };

                    scope.rootItem = function() {
                        return folderSelectorControl.rootItem;
                    };

                    scope.isDisabled = function(item) {
                        if (!scope.disabledItems || !item || !item.id || !item.itemType) {
                            return false;
                        }
                        return _.where(scope.disabledItems,
                            { itemType: item.itemType, id: item.id }).length > 0;
                    };

                    scope.getItemIcon = function(item){
                        if (!item) {return; }

                        if (item.isClientBranch){
                            return 'bento-icon-users';
                        } else if (item.isTemplateBranch){
                            return 'bento-icon-tree';
                        } else if (item.isShared){
                            return 'bento-icon-shared-folder';
                        } else {
                            return 'bento-icon-folder';
                        }
                    };

                    scope.getItemLabel = function(item) {
                        if (item.itemType === 'Project' && item.productType !== 'DMSClientFolder' &&
                            item.processingYear) {
                            return item.name + ' (' + item.processingYear + ')';
                        }
                        return item.name;
                    };

                    scope.$watch('isLoading', function(newValue, oldValue) {
                        if (newValue) {
                            scope.$emit('bm-busy-loading-on');
                        } else if (!newValue && oldValue){
                            scope.$emit('bm-busy-loading-off');
                        }
                    });
                },
                templateUrl: folderSelectorDirectiveService.templatePath('folder-selector-pane-directive'),
            };
        }
    ])

    .controller('folderSelectorPaneDirectiveController', [
        '$scope',
        function($scope) {
            $scope.busyLoaderConfig = {
                size: 'small'
            };
        }
    ]);

})(window.angular);

angular.module('bluemoon.dms.folder-selector.templates', ['components/folder-selector/folder-selector-directive.2js.html', 'components/folder-selector/folder-selector-pane-directive.2js.html']);

angular.module("components/folder-selector/folder-selector-directive.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/folder-selector/folder-selector-directive.2js.html",
    "<div class=\"folder-selector\">\n" +
    "	<div>\n" +
    "		<folder-selector-pane\n" +
    "			folder=\"currentItem\"\n" +
    "			is-loading=\"isLoading\"\n" +
    "			disabled-items=\"disabledItems\"></folder-selector-pane>\n" +
    "	</div>\n" +
    "</div>");
}]);

angular.module("components/folder-selector/folder-selector-pane-directive.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/folder-selector/folder-selector-pane-directive.2js.html",
    "<div class=\"folder-selector-pane\">\n" +
    "    <div class=\"current-item text-not-selectable\"\n" +
    "        ng-click=\"currentFolderBarClick($event)\">\n" +
    "        <span ng-if=\"!folder.id || folder.id === 'root' || folder.id === ''\"\n" +
    "            class=\"go-back-arrow glyphicon glyphicon-asterisk\"></span>\n" +
    "        <span ng-if=\"!folder.id || folder.id === 'root' || folder.id === ''\"\n" +
    "            class=\"item-label\">{{appName}}</span>\n" +
    "        <span ng-if=\"folder.id && folder.id !== 'root' && folder.id !== ''\"\n" +
    "            class=\"go-back-arrow glyphicon glyphicon-chevron-left\"\n" +
    "            ng-click=\"backArrowClick($event)\"></span>\n" +
    "        <span ng-if=\"folder.id && folder.id !== 'root' && folder.id !== ''\" class=\"dms-nav-crumb\">\n" +
    "            <dms-nav-breadcrumb container-type=\"{{folder.itemType}}\" container-id=\"{{folder.id}}\" collapse-length=\"0\"\n" +
    "            item-click-callback=\"breadcrumbCallback(item, $event)\" path-loaded-callback=\"breadcrumbPathCallback(path)\"/>\n" +
    "        </span>\n" +
    "        <span ng-if=\"folder.id && folder.id !== 'root' && folder.id !== ''\"\n" +
    "            class=\"item-label\">{{folder.name}}</span>\n" +
    "    </div>\n" +
    "    <ul class=\"item-group\" bm-busy-loader=\"busyLoaderConfig\">\n" +
    "        <li ng-repeat=\"subFolder in folder.subContainers\"\n" +
    "            class=\"item text-not-selectable\"\n" +
    "            ng-class=\"{selected: selectedItem.id === subFolder.id, disabled: isDisabled(subFolder) }\"\n" +
    "            ng-mousedown=\"itemMouseDown(subFolder, $event)\"\n" +
    "            ng-dblclick=\"itemDoubleClick(subFolder, $event)\">\n" +
    "            <span class=\"icon glyphicon\" ng-class=\"getItemIcon(subFolder)\"></span>\n" +
    "            <span class=\"item-label\">{{ getItemLabel(subFolder) }}</span>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "</div>\n" +
    "");
}]);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.format', [
        'bluemoon.dms'
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.format')

    .filter('formatDate', ['$window', function($window){
        return function(date) {
            if(date){
                return $window.moment(date).format('L LT');
            } else {
                return date;
            }
        };
    }])

    .filter('formatDateSmall', ['$window', function($window){
        return function(date) {
            if(date){
                return $window.moment(date).format('L');
            } else {
                return date;
            }
        };
    }]);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.format')

    .service('formatSizeService', ['$translate', '$q', function($translate, $q){

        var _powerOf1024 = function(power) {
            return Math.pow(1024, power);
        };

        var _OneKb = _powerOf1024(1);
        var _OneMb = _powerOf1024(2);
        var _OneGb = _powerOf1024(3);
        var _OneTb = _powerOf1024(4);
        var _OnePb = _powerOf1024(5);

        var _resolveDefer = function(defer) {
            return function(result) {
                defer.resolve(result);
            };
        };

        this.getSizeString = function(size) {
            var defer = $q.defer();

            if (isNaN(size) || size === '') {
                defer.resolve(size);
            } else if (size < _OneKb) {
                $translate('Bluemoon.DMS.Grid.Document.Size.Bytes',
                    {size : size}).then(_resolveDefer(defer));
            } else if (size < _OneMb) {
                $translate('Bluemoon.DMS.Grid.Document.Size.Kilobytes',
                    {size : (size / _OneKb).toFixed(2)}).then(_resolveDefer(defer));
            } else if (size < _OneGb) {
                $translate('Bluemoon.DMS.Grid.Document.Size.Megabytes',
                    {size : (size / _OneMb).toFixed(2)}).then(_resolveDefer(defer));
            } else if (size < _OneTb) {
                $translate('Bluemoon.DMS.Grid.Document.Size.Gigabytes',
                    {size : (size / _OneGb).toFixed(2)}).then(_resolveDefer(defer));
            } else if (size < _OnePb) {
                $translate('Bluemoon.DMS.Grid.Document.Size.Terabytes',
                    {size : (size / _OneTb).toFixed(2)}).then(_resolveDefer(defer));
            }

            return defer.promise;
        };

    }])

    .directive('formatSize', [
        '$translate',
        '$q',
        'formatSizeService', function($translate, $q, formatSizeService){
        return {
            restrict: 'A',
            link: function(scope, element, attr) {
                attr.$observe('formatSize', function() {
                    formatSizeService.getSizeString(attr.formatSize).then(function(formattedSize){
                        element.text(formattedSize);
                    });
                });
            }
        };
    }])

    .filter('formatSize', ['formatSizeService', function(formatSizeService){
        return function(size){
            return formatSizeService.getSizeString(size);
        };
    }]);

})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.grids.templates', []);

    angular.module('bluemoon.dms.grids', [
        'wj',
    ]);
})(window.angular);

/*jshint ignore:start*/
(function (angular, wijmo) {
    'use strict';

    var bmoonApp = angular.module('bluemoon.dms.grids');

    bmoonApp.service('FlexGridSetUpService', flexGridSetUpService);
    flexGridSetUpService.$inject = ['$rootScope'];

    function flexGridSetUpService($rootScope) {
        var self = this;
        var ON_MULTI_SELECT = 'onMultiSelect';
        this.multiSelectPanelObj = {};

        this.setUpMultiSelect = function (panel, r, c, cell, binding) {
            var flex = panel.grid;
            var col = flex.columns[c];
            // check that this is a boolean column

            if (panel.cellType !== wijmo.grid.CellType.RowHeader && col && col.binding === binding) {
                //if (panel.cellType !== wijmo.grid.CellType.RowHeader && col && col.dataType == wijmo.DataType.Boolean && col.binding === binding) {
                //For column header checkbox only
                if (panel.cellType === wijmo.grid.CellType.ColumnHeader) {
                    // prevent sorting on click
                    col.allowSorting = false;
                    // count true values to initialize checkbox
                    var cnt = 0;
                    for (var i = 0; i < flex.rows.length; i++) {
                        if (flex.getCellData(i, c) === true) {
                            cnt++;
                        }
                    }
                    // create and initialize checkbox
                    cell.innerHTML = '<input type="checkbox"> ';

                    // var cb = {};
                    var cb = cell.firstChild;
                    cb.checked = cnt > 0;
                    cb.indeterminate = cnt > 0 && cnt < flex.rows.length;

                    cb.removeEventListener('click', __cbListener);
                    cb.addEventListener('click', __cbListener);

                    //Set up custom sorting for checkbox column
                    cell.removeEventListener('click', __cellListener);
                    cell.addEventListener('click', __cellListener);

                    self.multiSelectPanelObj = {
                        panel: panel,
                        r: r,
                        c: c,
                        cell: cell,
                        flex: flex,
                        col: col,
                        cb: cb
                    };
                }
                //add col-select class to whole column cell
                cell.className += ' col-select';
                // if(flex.getCellData(r,c)==true){
                //     cell.className += ' active';
                // };
            }
        };
        function __cbListener(e) {
            e.stopPropagation();

            self.multiSelectPanelObj.flex.beginUpdate();
            for (var i = 0; i < self.multiSelectPanelObj.flex.rows.length; i++) {
                self.multiSelectPanelObj.flex.setCellData(i, self.multiSelectPanelObj.c, self.multiSelectPanelObj.cb.checked);
            }
            self.multiSelectPanelObj.flex.endUpdate();
            self.multiSelect(self.multiSelectPanelObj.cb.checked);
        }

        /*function __customCBListener(e) {
         e.stopPropagation();

         self.multiSelectPanelObj.flex.beginUpdate();

         if(angular.element(e.target).hasClass('active') || angular.element(e.target).hasClass('indeterminate')){
         self.multiSelectPanelObj.cb.checked = false;
         }else{
         self.multiSelectPanelObj.cb.checked = true;
         }

         for (var i = 0; i < self.multiSelectPanelObj.flex.rows.length; i++) {
         self.multiSelectPanelObj.flex.setCellData(i, self.multiSelectPanelObj.c, self.multiSelectPanelObj.cb.checked);
         }
         self.multiSelectPanelObj.flex.endUpdate();
         self.multiSelect(self.multiSelectPanelObj.cb.checked);
         }*/
        function __cellListener() {
            // $scope.sortingColumn(flex, {
            //     col: col.index
            // });
            //$scope.ctx.flexGrid.autoSizeColumns();
        }

        this.multiSelect = function (checked) {
            $rootScope.$broadcast(ON_MULTI_SELECT, {
                checked: checked
            });
        };
        this.onMultiSelect = function ($scope, handler) {
            $scope.$on(ON_MULTI_SELECT, function (event, message) {
                handler(message);
            });
        };
        this.updateFlexGridRowHeight = function (grid, height, headerHeight) {
            height = height || 48;
            headerHeight = headerHeight || 52;
            grid.rows.defaultSize = height;
            for (var i = 0, total = grid.columnHeaders.rows.length; i < total; i++) {
                grid.columnHeaders.rows[i].height = headerHeight;
            }
        };
        this.initFilters = function (grid, gridFilter, filteredCols) {
            if (!gridFilter) {
                gridFilter = new wijmo.grid.valuefilter.FlexGridFilter(grid);
                // gridFilter.filterColumns = filteredCols;
                // grid.autoSizeColumns();
                this.toggleFilter(false, gridFilter, filteredCols);
            }
            return gridFilter;
        };
        this.setUpActions = function (panel, r, c, cell, header) {
            var col = panel.columns[c];
            if (col.header === header) {
                cell.className += 'cell-actions';
            }
        };
        this.addClassToColumnByHeader = function (panel, r, c, cell, header, className) {
            var col = panel.columns[c];
            if (col.header === header) {
                cell.className += ' ' + className;
            }
        };
        this.addClassToColumnByBinding = function (panel, r, c, cell, binding, className) {
            var col = panel.columns[c];
            if (col.binding === binding) {
                cell.className += ' ' + className;
            }
        };
        this.setUpEdit = function (flex) {
            var host = flex.hostElement;
            host.addEventListener('keydown', function (e) {
                //check for 'Tab' key, Arrow Keys, Enter Keys
                var keysArray = [9, //Tab
                    39, //Right Arrow
                    37, //Left Arrow
                    40, //Down Arrow
                    38, //Up Arrow
                    13, //Enter
                ];
                if (keysArray.indexOf(e.keyCode) >= 0) {
                    //get the current selection
                    var selectedCellRange = flex.selection;
                    //if the selected column is the first column then ignore it
                    if (flex.selection.col <= 1) {
                        selectedCellRange.col = selectedCellRange.col + 1;
                        flex.select(selectedCellRange, true);
                    }
                    //put the cell in edit mode
                    flex.startEditing(false, flex.selection.row, flex.selection.col);
                }

            });
        };
        this.setUpColumnVisibility = function (flex, colBindings, colNum) {
            if (flex && colBindings.length > 0) {
                var columnBindingsToggle = [];
                var columnVis = {};
                // var colBindings = Object.keys(data[0]);
                var ttl = colBindings.length;
                var cols = colNum ? colNum : 5;
                var rows = Math.ceil(ttl / cols);
                var count = 0;
                for (var i = 0; i < cols; i++) {
                    columnBindingsToggle[i] = [];
                    for (var j = 0; j < rows; j++) {
                        columnBindingsToggle[i][j] = colBindings[count];
                        count++;
                        if (count >= ttl) {
                            break;
                        }
                    }
                }
                for (i = 0; i < colBindings.length; i++) {
                    columnVis[colBindings[i].binding] = true;
                }
                return {
                    columnBindingsToggle: columnBindingsToggle,
                    columnVis: columnVis
                };
            }
        };
        this.toggleFilter = function (filtersHidden, gridFilter, filteredCols) {
            //if flexgrid available
            if (gridFilter) {
                //get FlexGridFilter, defined in initGrid
                var f = gridFilter;
                if (f) {
                    //iterate through columns to filtered
                    for (var i = 0, il = filteredCols.length; i < il; i++) {
                        //get column and column filter
                        var col = f.grid.columns.getColumn(filteredCols[i].binding),
                            cf = col ? f.getColumnFilter(col, true) : {};
                        //switch filterType to 0 if filters hidden, otherwise to filterType defined in model
                        cf.filterType = filtersHidden ? 0 : filteredCols[i].filterType;
                    }

                }
                //refresh grid
                f.grid.refresh();
            }

        };
    }
})(window.angular, window.wijmo);
/*jshint ignore:end*/

(function() {
    'use strict';

    var bmoonApp = angular.module('bluemoon.dms.hover', []);

    var hoverClass = function(){
        return {
            restrict: 'A',
            scope: {
                hoverClass: '@'
            },
            link: function(scope, element){
                element.on('mouseenter', function(){
                    element.addClass(scope.hoverClass);
                });
                element.on('mouseleave', function(){
                    element.removeClass(scope.hoverClass);
                });
            }
        };
    };

    hoverClass.$inject = [];
    bmoonApp.directive('hoverClass', hoverClass);
})();

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.http', [
        'bluemoon.dms.models'
    ]);
})(window.angular);

(function(angular){
    'use strict';

    var DmsHttp = (function() {
        var _$inject = ['$q', '$http', 'ResponseData'];

        function DmsHttpImpl($q, $http, ResponseData) {
            var factory = {};

            factory.getBaseServiceUri = function(){
                return '/api/storage/v1/';
            };

            factory.getBaseCoreUri = function(){
                return '/api/core/v1/companies/';
            };

            // Provide an anonymous $http post config
            factory.getAnonymousHttpPostConfig = function(restServiceMethod, requestData, baseUriType) {
                var config = {};
                config.method = 'POST';

                if (baseUriType === 'core') {
                    config.url = this.getBaseCoreUri() + restServiceMethod;
                } else if (baseUriType === 'v3_core') { // temp fix for client calls to use v3
                    config.url = '/api/core/v3/companies/' + restServiceMethod;
                } else { //was of type 'service', i.e. default
                    config.url = this.getBaseServiceUri() + restServiceMethod;
                }

                if (requestData !== null){
                    config.data = requestData;
                }

                config.cache = false;
                return config;
            };

            // Provide an anonymous $http delete config
            factory.getAnonymousHttpDeleteConfig = function(restServiceMethod, requestData, baseUriType) {
                var config = this.getAnonymousHttpPostConfig(restServiceMethod, requestData, baseUriType);
                config.method = 'DELETE';

                config.headers = {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Compress-Data': 'true'
                };

                return config;
            };

            // Provide an anonymous $http put config
            factory.getAnonymousHttpPutConfig = function(restServiceMethod, requestData, baseUriType) {
                var config = this.getAnonymousHttpPostConfig(restServiceMethod, requestData, baseUriType);
                config.method = 'PUT';

                config.headers = {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Compress-Data': 'true'
                };

                return config;
            };

            // Provide an anonymous $http get config
            factory.getAnonymousHttpGetConfig = function(restServiceMethod, baseUriType) {
                var config = this.getAnonymousHttpPostConfig(restServiceMethod, null, baseUriType);
                config.method = 'GET';
                config.headers = {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Compress-Data': 'true',
                    'Accept': 'application/json'
                };

                return config;
            };

            factory.makeHttpRequest = function(httpConfig) {
                var deferred = $q.defer();

                if(httpConfig === null || angular.isUndefined(httpConfig)){
                    deferred.reject(new ResponseData(window.errorStatus, 400, null, 'Invalid Request', {}));
                    return deferred.promise;
                }

                $http(httpConfig).then(function(resp) {
                    deferred.resolve(new ResponseData(window.successStatus, resp.status, resp.data, resp.statusText, resp));
                },
                function(resp) {
                    if (resp.status >= 400 && resp.status < 500) {
                        resp.config.global = false;  //  Stop the generic error handler
                        deferred.reject(new ResponseData(window.errorStatus, resp.status, resp.data, resp.statusText, resp));
                    } else {
                        deferred.reject(resp);
                    }
                });

                return deferred.promise;
            };

            return factory;
        }

        DmsHttpImpl.$inject = _$inject;
        return DmsHttpImpl;
    }());

    angular.module('bluemoon.dms.http')

    .factory('dmsHttp', DmsHttp)

    //TODO: Deprecate
    .factory('httpRequestManager', DmsHttp);
})(window.angular);

(function(angular){
    'use strict';

    var DmsFolderI18n = (function() {
        var _$inject = ['$translate', '$q'];

        function DmsFolderI18nImpl($translate, $q) {

            var service = this;

            service.translate = function(folder) {

                var folderCopy = angular.copy(folder);

                if (folderCopy.name === '|mydocuments|') {
                    return $translate('Bluemoon.DMS.SpecialFolders.MyDocuments').then(function(s){
                        folderCopy.name = s;
                        return folderCopy;
                    });
                } else if (folderCopy.name === '|firmdocuments|') {
                    return $translate('Bluemoon.DMS.SpecialFolders.FirmDocuments').then(function(s){
                        folderCopy.name = s;
                        return folderCopy;
                    });
                }

                return $q.when(folderCopy);
            };

            service.translateName = function(name) {
                if (name === '|mydocuments|') {
                    return $translate('Bluemoon.DMS.SpecialFolders.MyDocuments').then(function(s){
                        return s;
                    });
                } else if (name === '|firmdocuments|') {
                    return $translate('Bluemoon.DMS.SpecialFolders.FirmDocuments').then(function(s){
                        return s;
                    });
                } else {
                    return name;
                }
            };

        }

        DmsFolderI18nImpl.$inject = _$inject;
        return DmsFolderI18nImpl;
    }());

    angular.module('bluemoon.dms.i18n', ['pascalprecht.translate'])

    .service('dmsFolderI18n', DmsFolderI18n);

})(window.angular);

(function(angular) {
    'use strict';

    function DmsIconService() {
        var service = this;

        service.getIcon = function(type) {
            if (type === 'all-docs'){
                return 'bento-icon-group';
            } else if (type === 'client' || type === 'clients'){
                return 'bento-icon-users';
            } else if (type === 'firmTaxAndAccountingLibrary'){
                return 'bento-icon-buildings';
            } else if (type === 'myTaxAndAccountingLibraries') {
                return 'bento-icon-user';
            } else if (type === 'shared-folder'){
                return 'bento-icon-shared-folder';
            } else if (type === 'folder'){
                return 'bento-icon-folder';
            } else if (type === 'templates') {
                return 'bento-icon-tree';
            } else if (type === 'recents') {
                return 'bento-icon-history';
            } else if (type === 'recycle') {
                return 'bento-icon-remove';
            } else if (type === 'pdf') {
                //NOTE: FILE TYPES BELOW
                return 'bento-icon-file-pdf';
            } else if (['xls', 'xlsx', 'xlsm', 'xlt', 'xlsb', 'xltx', 'csv', 'ods'].indexOf(type) > -1) {
                return 'bento-icon-file-excel';
            } else if(['doc', 'docx', 'docm', 'dot', 'dotx', 'dotm', 'odt', 'rtf'].indexOf(type) > -1) {
                return 'bento-icon-file-word';
            } else if (['bmp', 'gif', 'ico', 'jif', 'jfif', 'jpe', 'jpeg', 'jpg', 'pbm', 'pcd', 'pcx', 'pgm', 'png', 'ppm', 'ras', 'tga', 'tif', 'tiff', 'wmf'].indexOf(type) > -1) {
                return 'bento-icon-file-image';
            } else if (type === 'checkpoint-engage-file-icon') {
                return 'checkpoint-engage-file-icon';
            } else if (type === 'bento-icon-link') {
                return 'bento-icon-link';
            } else {
                return 'bento-icon-file';
            }
        };
    }

    DmsIconService.$inject = [];

    function DmsIconDirective(dmsIconService) {

        function link(scope, elt, attr) {

            scope.getIcon = function(){
                return dmsIconService.getIcon(attr.type);
            };
        }

        return {
            restrict: 'EA',
            replace: true,
            link: link,
            template: '<span ng-class="getIcon()"/>'
        };
    }

    DmsIconDirective.$inject = ['dmsIconService'];

    angular.module('bluemoon.dms.icon', [])

    .service('dmsIconService', DmsIconService)
    .directive('dmsIcon', DmsIconDirective);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.managers', [
        'pascalprecht.translate',
        'bluemoon.components.httpStatusCodes',
        'bluemoon.dms.http',
        'bluemoon.dms.models',
        'bluemoon.dms.utility.queue',
        'bluemoon.dms.utility.cache',
        'ui.router',
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.managers')

    .factory('GetSetUpdateToken', [function() {

            var factory = {};

            factory.setUpdateToken = function(updateToken) {

                this.updateToken = updateToken;
            };

            factory.getUpdateToken = function() {

                return this.updateToken;
            };

            return factory;
        }
    ]);
})(window.angular);

(function(angular, _){
    'use strict';

    angular.module('bluemoon.dms.managers')

    .factory('fileManager', ['$q', 'dmsHttp', 'ResponseData', 'dmsApiOperationService', 'Project', 'Folder', 'DmsDocumentsConstraints', '$stateParams', 'GetSetUpdateToken',
        function($q, dmsHttp, ResponseData, dmsApiOperationService, Project, Folder, DmsDocumentsConstraints, $stateParams, GetSetUpdateToken) {

            // TODO: ADD IN ACTUAL AUTHENTICATED REQUESTS
            var factory = {};
            var foldersMethod = 'folders';
            var projectsMethod = 'projects';
            var documentsMethod = 'documents';
            var existsMethod = 'exists';
            var importMethod = 'import';

            factory.selectedItem = null;

            var getDocumentsBaseUri = function(containerType, containerId, includeTrailingSlash){
                var containerTypePath = containerType.match(/project/i) ? projectsMethod : foldersMethod;

                return containerTypePath + '/' + containerId + '/' + documentsMethod + (includeTrailingSlash ? '/' : '');
            };

            factory.getDocumentDownloadUri = function(containerType, containerId, fileId){
                // TODO: VALIDATE THE VALUE
                return dmsHttp.getBaseServiceUri() + getDocumentsBaseUri(containerType, containerId, true) + fileId;
            };

            factory.addAttachmentParameter = function(downloadUrl) {
                if (-1 === downloadUrl.indexOf('?')) {
                    return downloadUrl + '?att=1';
                }
                return downloadUrl + '&att=1';
            };

            factory.getDocumentUploadUri = function(containerId, containerType){
                // TODO: VALIDATE THE VALUE
                return dmsHttp.getBaseServiceUri() + getDocumentsBaseUri(containerType, containerId, false);
            };

            factory.getDocumentImportUri = function(containerId, containerType){
                return dmsHttp.getBaseServiceUri() + getDocumentsBaseUri(containerType, containerId, true) + importMethod + '?notify=false';
            };

            factory._makeGetConstraintsRequest = function() {
                var url = 'documents/constraints';
                var config = dmsHttp.getAnonymousHttpGetConfig(url);
                // config.params = {token: $stateParams.accessToken};
                config.params = {token: GetSetUpdateToken.getUpdateToken()};
                return dmsHttp.makeHttpRequest(config).then(function(responseData){
                    return new DmsDocumentsConstraints(responseData.data);
                });
            };

            var cachedGetConstraintsPromise;

            factory.getConstraints = function() {
                return !cachedGetConstraintsPromise ?
                    (cachedGetConstraintsPromise = factory._makeGetConstraintsRequest()) :
                    cachedGetConstraintsPromise;
            };

            factory.getDocumentInfo = function(containerType, containerId, fileId, includeDownloadUrl) {
                var config = dmsHttp.getAnonymousHttpGetConfig(getDocumentsBaseUri(containerType, containerId, true) + fileId + (includeDownloadUrl ? '/?includeDownloadUrl=true' : ''), false);
                return dmsHttp.makeHttpRequest(config);
            };

            factory.getDocumentExists = function(containerId, filename, containerType) {
                var config = dmsHttp.getAnonymousHttpPostConfig(getDocumentsBaseUri(containerType, containerId, true) + existsMethod, JSON.stringify([filename]));
                return dmsHttp.makeHttpRequest(config);
            };

            factory.getDocumentMetadata = function(containerId, containerType, documentId) {
                var url = getDocumentsBaseUri(containerType, containerId, true) + documentId + '/metadata';
                var config = dmsHttp.getAnonymousHttpGetConfig(url, false);
                return dmsHttp.makeHttpRequest(config);
            };

            factory.getDocumentMetaDataWrapper = function(containerId, containerType, fileId) { // jshint ignore:line
                return factory.getDocumentMetadata(containerId, containerType, fileId)
                .then(function (result) {
                    return result;
                }).catch(function(e){
                    console.error(e);

                    if(e.error && e.error.code && e.error.code === 404) {
                        return false;
                    }

                    // This is to account for all other possible errors
                    // We don't want users seeing the "Document not available" message
                    // on a 500 error or another issue so they can try refreshing if it was a one off error
                    throw e;
                });
            };

            factory.uploadNotification = function(documents) {
                var notificationUrl = 'notifications/documents/upload';
                var config = dmsHttp.getAnonymousHttpPostConfig(notificationUrl, JSON.stringify(documents));
                return dmsHttp.makeHttpRequest(config);
            };

            factory.deleteDocument = function(containerId, documentId, containerType){
                // TODO: VALIDATE THE VALUES BEFORE MAKING REQUEST
                var deleteMethod = getDocumentsBaseUri(containerType, containerId, true) + documentId;
                var config = dmsHttp.getAnonymousHttpDeleteConfig(deleteMethod);

                config.timeout = 1000 * 60 * 15;

                return dmsHttp.makeHttpRequest(config);
            };

            // handles both renaming and moving of documents
            factory.updateDocument = function(document, containerId, containerType){
                // TODO: VALIDATE THE VALUES BEFORE MAKING REQUEST
                var renameMethod = getDocumentsBaseUri(containerType, containerId, true) + document.id;
                var config = dmsHttp.getAnonymousHttpPutConfig(renameMethod, JSON.stringify(document));
                return dmsHttp.makeHttpRequest(config);
            };

            factory.moveDocuments = function(documentList, newParentId, newParentType){
                return _.map(documentList, function(doc){
                    return factory.moveDocument(doc, newParentId, newParentType);
                });
            };

            factory.moveDocument = function(sourceItem, newParentId, newParentType){
                return dmsApiOperationService.createMoveOperation({
                    sourceItem: sourceItem,
                    destinationContainerId : newParentId,
                    destinationContainerType : newParentType,
                }, function() {
                    return factory.updateDocument({
                        containerId: newParentId,
                        containerType: newParentType,
                        id: sourceItem.id,
                        name: sourceItem.name,
                    }, sourceItem.parentItem.id, sourceItem.parentItem.itemType);
                });
            };

            factory.copyDocuments = function(documentList, destinationContainerId, destinationContainerType){
                return _.map(documentList, function(doc){
                    return factory.copyDocument(doc, destinationContainerId, destinationContainerType);
                });
            };

            factory.copyDocument = function(sourceItem, destinationContainerId, destinationContainerType){

                var copyMethod = getDocumentsBaseUri(sourceItem.parentItem.itemType, sourceItem.parentItem.id, true) + sourceItem.id + '/copy';

                var copyDocumentData = {
                    destinationContainerId: destinationContainerId,
                    name: sourceItem.replacementName !== '' ? sourceItem.replacementName : sourceItem.name,
                };

                if (destinationContainerType.toLowerCase() === 'project' ||
                    destinationContainerType.toLowerCase() === 'projects') {
                    copyDocumentData.destinationContainerType = new Project().containerType;
                } else {
                    copyDocumentData.destinationContainerType = new Folder().containerType;
                }

                var config = dmsHttp.getAnonymousHttpPostConfig(copyMethod,
                    copyDocumentData);

                //  Copy can be slow, extend the timeout to 15 minutes
                config.timeout = 1000 * 60 * 15;

                return dmsApiOperationService.createCopyOperation({
                    sourceItem: sourceItem,
                    destinationContainerId : destinationContainerId,
                    destinationContainerType : destinationContainerType,
                }, function() {
                    return dmsHttp.makeHttpRequest(config);
                });
            };

            factory.isPreviewSupported = function(type){
                if(type === 'application/pdf' || type === 'image/jpeg' || type === 'image/bmp' || type === 'image/png' || type === 'image/x-ms-bmp' || type === 'image/x-png') {
                    return true;
                } else {
                    return false;
                }
            };

            factory._findNameRecursive = function(parentId, fileName, depth, deferred, parentType){

                var testName = fileName;
                if (depth) {
                    var depthString = ' (' + depth + ')';
                    var lastDot = fileName.lastIndexOf('.');
                    testName = lastDot >= 0 ?
                        fileName.substring(0, lastDot) + depthString + fileName.substring(lastDot) :
                        fileName + depthString;
                }

                // Check if file exists
                factory.getDocumentExists(parentId, testName, parentType).then(function(result){
                    if(result.data) {
                        var exists = result.data[0].exists;
                        if(exists) {
                            depth++;
                            factory._findNameRecursive(parentId, fileName, depth, deferred, parentType);
                        } else {
                            deferred.resolve(testName);
                        }
                    } else {
                        deferred.resolve(testName);
                    }
                });

                return deferred.promise;
            };

            factory.findName = function(parentId, fileName, parentType){
                return factory._findNameRecursive(parentId, fileName, 0, $q.defer(), parentType);
            };

            factory.hackedTraceList = null;

            return factory;
        }
    ]);
})(window.angular, window._);

(function(angular, _){
    'use strict';

    angular.module('bluemoon.dms.managers')

    .factory('folderManager', [
        '$q',
        '$translate',
        'dmsHttp',
        'ResponseData',
        'Folder',
        'Project',
        'dmsApiOperationService',
        'DmsQueue',
        'dmsCacheFactory',
        function(
            $q,
            $translate,
            dmsHttp,
            ResponseData,
            Folder,
            Project,
            dmsApiOperationService,
            DmsQueue,
            dmsCacheFactory) {

            var factory = {};
            var foldersMethod = 'folders';
            var firmFolderMethod = 'folders/firm';
            var rootFolderMethod = 'folders';
            var folderTreeMethod = 'folders/tree';
            var documentsMethod = 'documents';
            var folderList = {};

            factory.getFolderList = function() {
                var config = dmsHttp.getAnonymousHttpGetConfig(foldersMethod, false);
                return dmsHttp.makeHttpRequest(config).then(function(data){
                    // Save the folder list locally
                    factory.setCachedFolderList(data.data);
                    return data;
                }, function(data){
                    return data;
                });
            };

            factory.getFolderTree = function() {
                var config = dmsHttp.getAnonymousHttpGetConfig(folderTreeMethod, false);
                return dmsHttp.makeHttpRequest(config);
            };

            factory.getFirmFolder = function() {
                var config = dmsHttp.getAnonymousHttpGetConfig(firmFolderMethod, false);
                return dmsHttp.makeHttpRequest(config);
            };

            factory._getSpecialFolderFromCollection = function(collection, specialFolderType) {

                var defer = $q.defer();

                var specialFolder = _.find(collection, function(folder) {
                    return folder.type === specialFolderType;
                });

                if (specialFolder) {

                    var specialFolderCopy = {};
                    angular.extend(specialFolderCopy, specialFolder);

                    factory.translate(specialFolderCopy.name).then(function(translatedName){
                        specialFolderCopy.name = translatedName;
                        defer.resolve(specialFolderCopy);
                    });

                } else {
                    defer.resolve();
                }

                return defer.promise;
            };

            var compareName = function(a, b){
                if (!a || !a.name || !b || !b.name) {return 0;}

                if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                return 0;
            };

            // TODO: Move to folderUIService
            factory.getRootFolder = function() {
                return factory.getAllRootFolders().then(function(result){

                    var firmDocsPromise = factory._getSpecialFolderFromCollection(result.data,
                        'firmTaxAndAccountingLibrary');
                    var myDocsPromise = factory._getSpecialFolderFromCollection(result.data,
                        'myTaxAndAccountingLibraries');

                    return $q.all([firmDocsPromise, myDocsPromise]).then(function(specialFolders){

                        var resultSet = [];
                        var specialFolderIds = [];

                        if (specialFolders) {
                            specialFolders.forEach(function(specialFolder){
                                if (specialFolder) {
                                    specialFolderIds.push(specialFolder.id);
                                    resultSet.push(specialFolder);
                                }
                            });
                        }

                        var sharedFolders = _.reject(result.data, function(folder){
                            return _.contains(specialFolderIds, folder.id);
                        });

                        if (sharedFolders && sharedFolders.length > 0) {
                            sharedFolders.sort(compareName);
                            resultSet = resultSet.concat(sharedFolders);
                        }

                        return new ResponseData(window.successStatus, 0, resultSet);
                    });
                });
            };

            factory._cache = dmsCacheFactory.create('folderManager');

            factory.getAllRootFolders = function() {
                var config = dmsHttp.getAnonymousHttpGetConfig(rootFolderMethod, false);
                var cacheKey = config.url;
                var promise;

                var cachedValue = factory._cache.get(cacheKey);
                if (cachedValue) {
                    promise = cachedValue;
                } else {
                    promise = dmsHttp.makeHttpRequest(config);
                    factory._cache.put(cacheKey, promise);

                    promise.then(function(){
                        factory._cache.setExpiration(cacheKey, 10000);
                    });
                }

                return promise;
            };

            factory.getSingleFirmFolder = function() {
                var deferred = $q.defer();
                //GetRootFolder actually returns an array, we want just a single folder.
                factory.getAllRootFolders().then(function(responseData) {
                    var rootFolder = _.find(responseData.data, function(obj) {return obj.type === 'firmTaxAndAccountingLibrary'; } );
                    deferred.resolve(rootFolder);
                });

                return deferred.promise;
            };

            factory.getSingleMyDocsFolder = function() {
                var deferred = $q.defer();
                //GetRootFolder actually returns an array, we want just a single folder.
                factory.getAllRootFolders().then(function(responseData) {
                    var myDocsFolder = _.find(responseData.data, function(obj) {return obj.type === 'myTaxAndAccountingLibraries'; } );
                    deferred.resolve(myDocsFolder);
                });

                return deferred.promise;
            };

            factory.getSharedFolders = function() {
                var deferred = $q.defer();

                factory.getAllRootFolders().then(function(responseData) {
                    var sharedFolders = _.reject(responseData.data, function(obj) {return obj.type === 'firmTaxAndAccountingLibrary' || obj.type === 'myTaxAndAccountingLibraries'; } );
                    deferred.resolve(sharedFolders);
                });

                return deferred.promise;
            };

            factory.setCachedFolderList = function(folderListToCache) {
                if(folderListToCache === null || angular.isUndefined(folderListToCache)){
                    folderListToCache = {};
                }

                folderList = folderListToCache;
            };

            factory.refreshCachedFolderList = function() {
                factory.setCachedFolderList(null);
                return factory.getFolderList();
            };

            factory.refreshCachedFirmFolder = function() {
                factory.setCachedFolderList(null);
                return factory.getFirmFolder();
            };

            factory.getCachedFolderList = function() {
                return folderList;
            };

            //TODO: Deprecate
            factory.getFolder = function(folderId){
                var getFolderMethod = foldersMethod + '/' + folderId;
                var config = dmsHttp.getAnonymousHttpGetConfig(getFolderMethod, false);
                return dmsHttp.makeHttpRequest(config);
            };

            //TODO: Deprecate
            factory.getFolderChildren = function(folderId, params){
                var getFolderMethod = foldersMethod + '/' + folderId + '/children';
                var config = dmsHttp.getAnonymousHttpGetConfig(getFolderMethod, false);
                config.params = params;
                return dmsHttp.makeHttpRequest(config);
            };

            factory.getFolderDescendants = function(folderId){
                var getFolderMethod = foldersMethod + '/' + folderId + '/descendants';
                var config = dmsHttp.getAnonymousHttpGetConfig(getFolderMethod, false);
                return dmsHttp.makeHttpRequest(config);
            };

            factory.getFolderAncestors = function(folderId){
                var getFolderMethod = foldersMethod + '/' + folderId + '/ancestors';
                var config = dmsHttp.getAnonymousHttpGetConfig(getFolderMethod, false);
                return dmsHttp.makeHttpRequest(config);
            };

            factory.getFolderExists = function(containerId, folderName, containerType) {

                // TODO: Fix up types
                var lowerContainerType = containerType.toLowerCase();
                var hackedContainerType = lowerContainerType === 'folder' ? 'folders' :
                    lowerContainerType === 'project' ? 'projects' : lowerContainerType;

                var getFolderExistsMethod = foldersMethod + '/exists';
                var config = dmsHttp.getAnonymousHttpPostConfig(getFolderExistsMethod, {
                    containerId: containerId,
                    containerType: hackedContainerType,
                    folderNames: [folderName],
                });
                return dmsHttp.makeHttpRequest(config);
            };

            var getCachedFolderRecurrsion = function(itemId, subContainers, selectedItem, parentTree){
                if (angular.isDefined(selectedItem)){
                    return selectedItem;
                }

                for (var counter = 0; counter < subContainers.length; counter++) {
                    if (angular.isUndefined(parentTree)) {
                        parentTree = [];
                    }

                    var parentClone = parentTree.slice(0);

                    if (subContainers[counter].id === itemId) {
                        selectedItem = subContainers[counter];
                        selectedItem.parentTree = parentClone;
                    } else if (angular.isDefined(subContainers[counter].subContainers && subContainers[counter].subContainers.length > 0)){
                        parentClone.push(subContainers[counter]);
                        selectedItem = getCachedFolderRecurrsion(itemId, subContainers[counter].subContainers, selectedItem, parentClone);
                    }

                    if (angular.isDefined(selectedItem)) {
                        return selectedItem;
                    }
                }
            };

            factory.getCachedFolderWithParentTree = function(folderId) {
                return getCachedFolderRecurrsion(folderId, factory.getCachedFolderList(), undefined, undefined);
            };

            factory.getDocumentsListForFolder = function(folderId) {
                var getDocumentsListMethod = foldersMethod + '/' + folderId + '/' + documentsMethod;
                var config = dmsHttp.getAnonymousHttpGetConfig(getDocumentsListMethod, false);
                return dmsHttp.makeHttpRequest(config);
            };

            //TODO: Deprecate
            factory.addFolder = function(folder, source) {
                // TODO: VALIDATE FOLDER BEFORE POSTING
                var config = dmsHttp.getAnonymousHttpPostConfig(foldersMethod, JSON.stringify(folder));

                var lowerContainerType = folder.parentType.toLowerCase();
                var destinationContainerType = lowerContainerType === 'folder' ? 'folders' :
                    lowerContainerType === 'project' ? 'projects' : lowerContainerType;

                return dmsApiOperationService.createAddOperation({
                    destinationContainerId: folder.parentId,
                    destinationContainerType: destinationContainerType,
                    item: folder,
                    source: !source ? '' : source
                }, function() {
                    return dmsHttp.makeHttpRequest(config);
                });
            };

            //TODO: Deprecate
            factory.deleteFolder = function(folderId){
                // TODO: VALIDATE THE FOLDERID BEFORE DELETING
                var deleteMethod = foldersMethod + '/' + folderId;
                var config = dmsHttp.getAnonymousHttpDeleteConfig(deleteMethod);

                config.timeout = 1000 * 60 * 15;

                return dmsHttp.makeHttpRequest(config);
            };

            factory.updateFolder = function(folderUpdateObject) {
                // TODO: VALIDATE FOLDER BEFORE POSTING
                var updateMethod = foldersMethod + '/' + folderUpdateObject.id;
                var config = dmsHttp.getAnonymousHttpPutConfig(updateMethod, folderUpdateObject);
                return dmsHttp.makeHttpRequest(config);
            };

            factory.moveFolders = function(folderList, newParentId, newParentType){
                return _.map(folderList, function(folder){
                    return factory.moveFolder(folder, newParentId, newParentType);
                });
            };

            factory.moveFolder = function(sourceItem, newParentId, newParentType){

                var updateFolderData = {
                    id: sourceItem.id,
                    containerId: newParentId,
                    name: sourceItem.name,
                };

                if (newParentType.toLowerCase() === 'project' || newParentType.toLowerCase() === 'projects') {
                    updateFolderData.containerType = new Project().containerType;
                } else {
                    updateFolderData.containerType = new Folder().containerType;
                }

                return dmsApiOperationService.createMoveOperation({
                    sourceItem: sourceItem,
                    destinationContainerId : newParentId,
                    destinationContainerType : newParentType,
                }, function() {
                    return factory.updateFolder(updateFolderData);
                });
            };

            factory.copyFolders = function(folderList, destinationContainerId, destinationContainerType){
                return _.map(folderList, function(folder){
                    return factory.copyFolder(folder, destinationContainerId, destinationContainerType);
                });
            };

            factory.copyFolder = function(sourceItem, destinationContainerId, destinationContainerType){
                var copyMethod = foldersMethod + '/' + sourceItem.id + '/copy';

                var copyFolderData = {
                    destinationContainerId: destinationContainerId,
                    destinationContainerType: destinationContainerType,
                    name: sourceItem.replacementName,
                };

                if (destinationContainerType.toLowerCase() === 'project' ||
                    destinationContainerType.toLowerCase() === 'projects') {
                    copyFolderData.destinationContainerType = new Project().containerType;
                } else {
                    copyFolderData.destinationContainerType = new Folder().containerType;
                }

                var config = dmsHttp.getAnonymousHttpPostConfig(copyMethod, copyFolderData);

                //  Copy can be slow, extend the timeout to 15 minutes
                config.timeout = 1000 * 60 * 15;

                return dmsApiOperationService.createCopyOperation({
                    sourceItem: sourceItem,
                    destinationContainerId : destinationContainerId,
                    destinationContainerType : destinationContainerType,
                }, function() {
                    return dmsHttp.makeHttpRequest(config);
                });
            };

            factory.getPermissions = function(folderId){
                var permissionMethod = foldersMethod + '/' + folderId + '/permissions';
                var config = dmsHttp.getAnonymousHttpGetConfig(permissionMethod);
                return dmsHttp.makeHttpRequest(config);
            };

            factory.updatePermissions = function(folderId, criteria){
                var permissionMethod = foldersMethod + '/' + folderId + '/permissions';
                var config = dmsHttp.getAnonymousHttpPutConfig(permissionMethod, criteria);
                return dmsHttp.makeHttpRequest(config);
            };

            factory.removePermissions = function(folderId, memberId, cascade){
                var cascadeString = (cascade !== null && cascade !== undefined) ? '?cascade=' + cascade : '';

                var deleteMethod = foldersMethod + '/' + folderId + '/permissions/' + memberId + cascadeString;
                var config = dmsHttp.getAnonymousHttpDeleteConfig(deleteMethod);
                return dmsHttp.makeHttpRequest(config);
            };

            factory._findNameRecursive = function(parentId, folderName, depth, deferred, parentType){

                var testName = folderName;
                if (depth) {
                    var depthString = ' (' + depth + ')';
                    testName = folderName + depthString;
                }

                // Check if file exists
                factory.getFolderExists(parentId, testName, parentType).then(function(result){
                    if(result.data) {
                        var exists = result.data[0].exists;
                        if(exists) {
                            depth++;
                            factory._findNameRecursive(parentId, folderName, depth, deferred, parentType);
                        } else {
                            deferred.resolve(testName);
                        }
                    } else {
                        deferred.resolve(testName);
                    }
                });

                return deferred.promise;
            };

            factory.findName = function(parentId, folderName, parentType){
                return factory._findNameRecursive(parentId, folderName, 0, $q.defer(), parentType);
            };

            factory.translate = function(folderName){
                var defer = $q.defer();

                if (folderName === '|firmdocuments|'){
                    $translate('Bluemoon.DMS.SpecialFolders.FirmDocuments')
                        .then(function(s) { defer.resolve(s); });
                } else if (folderName === '|mydocuments|') {
                    $translate('Bluemoon.DMS.SpecialFolders.MyDocuments')
                        .then(function(s) { defer.resolve(s); });
                } else {
                    defer.resolve(folderName);
                }

                return defer.promise;
            };

            return factory;
        }
    ]);
})(window.angular, window._);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.managers')

    .factory('clientManager', ['$q', 'dmsHttp', 'AuthenticatedSessionData',
        function($q, dmsHttp, authenticatedSessionData) {

            var factory = {};
            var clientMethod = 'clients';
            var clientList = {};

            var getCompanyId = function() {
                return authenticatedSessionData.get().then(function(data) {
                    return data.bindings.ApplicationConfiguration.CompanyId;
                });
            };

            factory.getClientList = function(params) {
                return getCompanyId().then(function(companyId){
                    var getClientListMethod = companyId + '/' + clientMethod;
                    var config = dmsHttp.getAnonymousHttpGetConfig(getClientListMethod, 'v3_core');
                    config.params = params;
                    return dmsHttp.makeHttpRequest(config).then(function(data){
                        // Save the client list locally
                        factory.setCachedClientList(data.data);
                        return data;
                    }, function(data){
                        return data;
                    });
                });
            };

            factory.getClientListViaSearch = function(searchText) {
                return getCompanyId().then(function(companyId){
                    var getClientListMethod = companyId + '/' + clientMethod;
                    var config = dmsHttp.getAnonymousHttpGetConfig(getClientListMethod, 'v3_core');
                    config.params = {
                        search: searchText,
                        //searchBy: "'code', 'name'",
                        companyId: companyId,
                    };
                    return dmsHttp.makeHttpRequest(config);
                });
            };

            factory.getClientsWithProjects = function() {
                return getCompanyId().then(function(companyId){
                    var config = dmsHttp.getAnonymousHttpGetConfig(clientMethod, false);
                    config.params = {
                        withProjects: true,
                        companyId: companyId,
                    };
                    return dmsHttp.makeHttpRequest(config);
                });
            };

            //TODO: Deprecate
            factory.getClient = function(clientId){
                return getCompanyId().then(function(companyId){
                    var getClientMethod = companyId + '/' + clientMethod + '/' + clientId;
                    var config = dmsHttp.getAnonymousHttpGetConfig(getClientMethod, 'v3_core');
                    return dmsHttp.makeHttpRequest(config);
                });
            };

            factory.setCachedClientList = function(clientListToCache) {
                if(clientListToCache === null || angular.isUndefined(clientListToCache)){
                    clientListToCache = {};
                }

                clientList = clientListToCache;
            };

            return factory;
        }
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.managers')

    .factory('projectManager', ['$q', 'dmsHttp', 'dmsApiOperationService', 'Project',
        function($q, dmsHttp, dmsApiOperationService, Project) {

            var factory = {};
            var projectMethod = 'projects';
            var projectList = {};

            //TODO: Deprecate
            factory.addProject = function(project) {
                var config = dmsHttp.getAnonymousHttpPostConfig(projectMethod, JSON.stringify(project));
                var destinationContainerType = project.itemType === 'Project' ?
                    'projects' : project.itemType;
                return dmsApiOperationService.createAddOperation({
                    destinationContainerId: project.parentId,
                    destinationContainerType: destinationContainerType,
                    item: project,
                }, function(){
                    return dmsHttp.makeHttpRequest(config);
                });
            };

            //TODO: Deprecate
            factory.copyProject = function(project, sourceId) {
                var postMethod = projectMethod + '/' + sourceId + '/copy';
                var config = dmsHttp.getAnonymousHttpPostConfig(postMethod, JSON.stringify(project));
                return dmsHttp.makeHttpRequest(config);
            };

            factory.getRootProjects = function() {
                var config = dmsHttp.getAnonymousHttpGetConfig(projectMethod, false);
                return dmsHttp.makeHttpRequest(config);
            };

            factory.getProjectList = function(clientId) {
                var config = dmsHttp.getAnonymousHttpGetConfig(projectMethod, false);
                config.params = {
                    primaryAssociationId: clientId,
                    primaryAssociationType: 'Client',
                };
                return dmsHttp.makeHttpRequest(config).then(function(data){
                    // Save the folder list locally
                    factory.setCachedProjectList(data.data);
                    return data;
                }, function(data){
                    return data;
                });
            };

            factory.getProjectListWithConfigurationParameters = function(params) {
                var config = dmsHttp.getAnonymousHttpGetConfig(projectMethod, false);
                config.params = params;
                return dmsHttp.makeHttpRequest(config);
            };

            factory.getProjectChildren = function(projectId, params) {
                // TODO: VALIDATE THE PROJECTID BEFORE DELETING
                var getMethod = projectMethod + '/' + projectId + '/children';
                var config = dmsHttp.getAnonymousHttpGetConfig(getMethod, false);
                config.params = params;
                return dmsHttp.makeHttpRequest(config);
            };

            factory.deleteProject = function(projectId){
                // TODO: VALIDATE THE PROJECTID BEFORE DELETING
                var deleteMethod = projectMethod + '/' + projectId;
                var config = dmsHttp.getAnonymousHttpDeleteConfig(deleteMethod);

                config.timeout = 1000 * 60 * 15;

                return dmsHttp.makeHttpRequest(config);
            };

            factory.updateProject = function(project) {
                // TODO: VALIDATE PROJECT BEFORE POSTING
                var updateMethod = projectMethod + '/' + project.id;
                var config = dmsHttp.getAnonymousHttpPutConfig(updateMethod, project);
                return dmsHttp.makeHttpRequest(config);
            };

            factory.getProject = function(projectId){
                var getMethod = projectMethod + '/' + projectId;
                var config = dmsHttp.getAnonymousHttpGetConfig(getMethod, false);
                return dmsHttp.makeHttpRequest(config);
            };

            //Helper functions to manage those linked up to the Service calls
            factory.setCachedProjectList = function(projectListToCache) {
                if(projectListToCache === null || angular.isUndefined(projectListToCache)){
                    projectListToCache = {};
                }

                projectList = projectListToCache;
            };

            factory.getProjectExists = function(project) {
                var existsMethod = projectMethod + '/exists';
                var config = dmsHttp.getAnonymousHttpPostConfig(existsMethod, [project]);
                return dmsHttp.makeHttpRequest(config);
            };

            factory.getPermissions = function(projectId){
                var permissionMethod = projectMethod + '/' + projectId + '/permissions';
                var config = dmsHttp.getAnonymousHttpGetConfig(permissionMethod);
                return dmsHttp.makeHttpRequest(config);
            };

            factory.updatePermissions = function(projectId, criteria){
                var permissionMethod = projectMethod + '/' + projectId + '/permissions';
                var config = dmsHttp.getAnonymousHttpPutConfig(permissionMethod, criteria);
                return dmsHttp.makeHttpRequest(config);
            };

            factory.removePermissions = function(projectId, memberId, cascade){
                var cascadeString = (cascade !== null && cascade !== undefined) ? '?cascade=' + cascade : '';

                var deleteMethod = projectMethod + '/' + projectId + '/permissions/' + memberId + cascadeString;
                var config = dmsHttp.getAnonymousHttpDeleteConfig(deleteMethod);
                return dmsHttp.makeHttpRequest(config);
            };

            factory._findNameRecursive = function(primaryAssociationId, primaryAssociationType, projectName, projectType, projectYear, projectPeriodEnd, depth, deferred) {

                var testName = projectName;
                if (depth) {
                    var depthString = ' (' + depth + ')';
                    testName = projectName + depthString;
                }

                var projectToCheck = new Project();
                projectToCheck.name = testName;
                projectToCheck.productType = projectType;
                projectToCheck.primaryAssociationId = primaryAssociationId;
                projectToCheck.primaryAssociationType = primaryAssociationType;
                projectToCheck.processingYear = projectYear;
                projectToCheck.processingPeriod = projectPeriodEnd;

                // Check if file exists
                factory.getProjectExists(projectToCheck).then(function(result){
                    if(result.data) {
                        var exists = result.data[0].exists;
                        if(exists) {
                            depth++;
                            factory._findNameRecursive(primaryAssociationId, primaryAssociationType, projectName, projectType, projectYear, projectPeriodEnd, depth, deferred);
                        } else {
                            deferred.resolve(testName);
                        }
                    } else {
                        deferred.resolve(testName);
                    }
                });

                return deferred.promise;
            };

            factory.findName = function(primaryAssociationId, primaryAssociationType, projectName, projectType, projectYear, projectPeriodEnd){
                return factory._findNameRecursive(primaryAssociationId, primaryAssociationType, projectName, projectType, projectYear, projectPeriodEnd, 0, $q.defer());
            };

            return factory;
        }
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.managers')

    .constant('dmsApiOperationConstants', {
        moveType: 'move',
        copyType: 'copy',
        addType: 'add',
        deleteType: 'delete',
        moveBatchType: 'moveBatch',
        copyBatchType: 'copyBatch',
        sendType: 'send',
        moveToRecycleType: 'moveToRecycle',
        restoreType: 'restore',
        permanentlyDeleteType: 'permanentlyDelete',
    })

    .service('dmsApiOperationService', [
        'dmsApiOperationConstants',
        'DmsApiOperationModel',
        'DmsApiOperationCollectionModel',
        'bluemoon.components.httpStatusCodes',
        '$rootScope',
        '$q',
        'DmsQueue',
        function(
            dmsApiOperationConstants,
            DmsApiOperationModel,
            DmsApiOperationCollectionModel,
            httpStatusCodes,
            $rootScope,
            $q,
            DmsQueue) {

            var _this = this;

            _this._id = 0;

            _this.clearBatch = function() {
                if (!_this.currentBatch) {
                    _this.currentBatch = {};
                }

                _this.currentBatch.total = 0;
                _this.currentBatch.inProgress = 0;
                _this.currentBatch.success = 0;
                _this.currentBatch.error = 0;
            };

            _this.clearFromBatch = function(operationModel) {
                if (operationModel.status === 'error') {
                    _this.currentBatch.error--;
                } else if(operationModel.status === window.successStatus) {
                    _this.currentBatch.success--;
                } else {
                    _this.currentBatch.inProgress--;
                }
                _this.currentBatch.total--;
            };

            _this.clearBatch();

            _this.operationQueue = DmsQueue.newQueue({
                processCapacity: 3,
                batchCompleteCallback: function() {
                    $rootScope.$broadcast('dms-operation-batch-complete');
                }
            });

            _this.addToOperationQueue = function(callback) {
                var defer = $q.defer();
                _this.operationQueue.add({
                    callback: function() {
                        callback().then(function(response){
                            defer.resolve(response);
                        }, function(reason){
                        if (!reason.httpStatusCode && !reason.error.code) { //  Implies ResponseData not returned from http
                                reason.config.global = false;  //  Stop the generic error handler
                            }
                            defer.reject(reason);
                        });
                        return defer.promise;
                    }
                });
                return defer.promise;
            };

            _this.operations = new DmsApiOperationCollectionModel();

            _this._setupCompletionState = function(operationModel) {
                operationModel.promise.then(function(responseData){
                    $rootScope.$broadcast('dms-operation-complete', operationModel);
                    operationModel.operationCompletedDefer.resolve(responseData);
                });
            };

            _this.updateBatch = function(operationModel) {
                _this.currentBatch.inProgress--;
                if (operationModel.status === 'error') {
                    _this.currentBatch.error++;
                } else if (operationModel.status === window.successStatus) {
                    _this.currentBatch.success++;
                }
            };

            _this.create = function(type, operationData, operationCallback, operationCompletedDefer) {

                var promise = _this.addToOperationQueue(operationCallback);

                var newApiOperationModel = new DmsApiOperationModel(type, operationData, promise);
                newApiOperationModel.id = _this._id++;
                _this.operations.add(newApiOperationModel);

                if (!operationCompletedDefer) {
                    operationCompletedDefer = operationCompletedDefer = $q.defer();
                }

                newApiOperationModel.operationCompletedDefer = operationCompletedDefer;
                newApiOperationModel.operationCompleted = function() {
                    return newApiOperationModel.operationCompletedDefer.promise;
                };

                var setStatus = function(responseData) {
                    if (!!responseData && !responseData.httpStatusCode && !!responseData.response && !!responseData.response.httpStatusCode) {
                        responseData.httpStatusCode = responseData.response.httpStatusCode;
                    }

                    newApiOperationModel.httpStatusCode = responseData.httpStatusCode;
                    newApiOperationModel.status =
                        newApiOperationModel.httpStatusCode === httpStatusCodes.created ||
                        newApiOperationModel.httpStatusCode === httpStatusCodes.ok ||
                        newApiOperationModel.httpStatusCode === httpStatusCodes.noContent  ?
                        window.successStatus : 'error';
                    _this.updateBatch(newApiOperationModel);
                };

                var setStatusError = function(responseData) {
                    if (responseData.httpStatusCode) {
                        newApiOperationModel.httpStatusCode = responseData.httpStatusCode;
                    } else if( responseData.error.code){
                        newApiOperationModel.httpStatusCode =  responseData.error.code;
                    } else if (responseData.response.status) {
                        newApiOperationModel.httpStatusCode = responseData.response.status;
                    } else {
                        newApiOperationModel.httpStatusCode = responseData.status;
                    }

                    newApiOperationModel.status = 'error';
                    _this.updateBatch(newApiOperationModel);
                };

                promise.then(setStatus, setStatusError);

                _this._setupCompletionState(newApiOperationModel);

                _this.currentBatch.total++;
                _this.currentBatch.inProgress++;

                return newApiOperationModel;
            };

            _this.createMoveOperation = function(operationData, operationCallback) {

                if (!operationData.sourceItem) {
                    throw new Error('operationData.sourceItem is required.');
                } else if (!operationData.destinationContainerId || operationData.destinationContainerId === '') {
                    throw new Error('operationData.destinationContainerId is required.');
                } else if (!operationData.destinationContainerType || operationData.destinationContainerType === '') {
                    throw new Error('operationData.destinationContainerType is required.');
                } else if (!operationCallback) {
                    throw new Error('operationCallback is required');
                }

                var operationModel = _this.create(dmsApiOperationConstants.moveType, operationData, operationCallback);

                return operationModel;
            };

            _this.createCopyOperation = function(operationData, promise) {

                if (!operationData.sourceItem) {
                    throw new Error('operationData.sourceItem is required.');
                } else if (!operationData.destinationContainerId || operationData.destinationContainerId === '') {
                    throw new Error('operationData.destinationContainerId is required.');
                } else if (!operationData.destinationContainerType || operationData.destinationContainerType === '') {
                    throw new Error('operationData.destinationContainerType is required.');
                } else if (!promise) {
                    throw new Error('promise is required');
                }

                var operationModel = _this.create(dmsApiOperationConstants.copyType, operationData, promise);

                return operationModel;
            };

            _this.createAddOperation = function(operationData, promise) {

                if (!operationData.item) {
                    throw new Error('operationData.item is required.');
                } else if (!promise) {
                    throw new Error('promise is required');
                }

                var operationModel = _this.create(dmsApiOperationConstants.addType, operationData, promise);

                return operationModel;
            };

            _this.createDeleteOperation = function(operationData, promise) {

                if (!operationData.item) {
                    throw new Error('operationData.item is required.');
                } else if (!promise) {
                    throw new Error('promise is required');
                }

                var operationModel = _this.create(dmsApiOperationConstants.deleteType, operationData, promise);

                return operationModel;
            };

            _this.createSendOperation = function(operationData, promise) {

                if (!operationData.sharedItems) {
                    throw new Error('operationData.sharedItems is required.');
                } else if (!promise) {
                    throw new Error('promise is required');
                }

                var operationModel = _this.create(dmsApiOperationConstants.sendType, operationData, promise);

                return operationModel;
            };

            _this.createMoveBatchOperation = function(operationData, promise) {
                return _this.create(dmsApiOperationConstants.moveBatchType, operationData, promise);
            };

            _this.createCopyBatchOperation = function(operationData, promise) {
                return _this.create(dmsApiOperationConstants.copyBatchType, operationData, promise);
            };

            _this.createMoveToRecycleBinOperation = function(operationData, promise) {

                if (!operationData.item) {
                    throw new Error('operationData.item is required.');
                } else if (!promise) {
                    throw new Error('promise is required');
                }

                var operationModel = _this.create(dmsApiOperationConstants.moveToRecycleType, operationData, promise);

                return operationModel;
            };

            _this.createRestoreOperation = function(operationData, promise) {

                if (!operationData.item) {
                    throw new Error('operationData.item is required.');
                } else if (!operationData.item.destinationContainerId || operationData.item.destinationContainerId === '') {
                    throw new Error('destinationContainerId is required.');
                } else if (!operationData.item.destinationContainerType || operationData.item.destinationContainerType === '') {
                    throw new Error('destinationContainerType is required.');
                } else if (!promise) {
                    throw new Error('promise is required');
                }

                var operationModel = _this.create(dmsApiOperationConstants.restoreType, operationData, promise);

                return operationModel;
            };

            _this.createPermanentlyDeleteOperation = function(operationData, promise) {

                if (!operationData.item) {
                    throw new Error('operationData.item is required.');
                } else if (!promise) {
                    throw new Error('promise is required');
                }

                var operationModel = _this.create(dmsApiOperationConstants.permanentlyDeleteType, operationData, promise);

                return operationModel;
            };

        }
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.managers')

    .factory('containerManager', ['dmsHttp',
        function(dmsHttp) {

            var factory = {};

            factory.getTree = function() {
                var config = dmsHttp.getAnonymousHttpGetConfig('containers/tree', false);
                return dmsHttp.makeHttpRequest(config);
            };

            return factory;
        }
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.managers')

    .factory('contactManager', ['$q', 'dmsHttp', 'AuthenticatedSessionData',
        function($q, dmsHttp, authenticatedSessionData) {

            var factory = {};
            var contactsMethod = 'contacts';
            var relatedContactsMethod = 'related-contacts';
            var contactsList = {};

            var filterItems = [
                {
                    by : 'isClientCenterEnabled',
                    op : 'EQ',
                    value : true
                },
                {
                    by : 'isStaffCenterEnabled',
                    op : 'EQ',
                    value : true
                },
                {
                    by : 'entityType.id',
                    op : 'IN',
                    //TODO: long-term we want to just be INDIVIDUAL, for now just keep adding countries.
                    value : 'USINDIVIDUAL,GBINDIVIDUAL,CAINDIVIDUAL'
                }
            ];

            var centersFilter = {
                filter : {
                    groups :
                    [
                        {
                            useOr : true,
                            items : [filterItems[0], filterItems[1]]
                        },
                        {
                            items : [filterItems[2]]
                        }
                    ]
                }
            };

            var clientFilter = {
                filter : {
                    useOr : false,
                    items : [filterItems[0], filterItems[2]]
                }
            };

            var staffFilter = {
                filter : {
                    useOr : false,
                    items : [filterItems[1], filterItems[2]]
                }
            };

            var getCompanyId = function() {
                return authenticatedSessionData.get().then(function(data) {
                    return data.bindings.ApplicationConfiguration.CompanyId;
                });
            };

            factory.getContactList = function() {
                return getCompanyId().then(function(companyId){
                    var getContactsMethod = companyId + '/' + contactsMethod;

                    var config = dmsHttp.getAnonymousHttpGetConfig(getContactsMethod, 'core');
                    return dmsHttp.makeHttpRequest(config);
                });
            };

            //Note: returns a SINGLE contact based on a known Contact ID
            factory.getContact = function(contactId) {
                return getCompanyId().then(function(companyId){
                    var getContactsMethod = companyId + '/' + contactsMethod + '/' + contactId;
                    var config = dmsHttp.getAnonymousHttpGetConfig(getContactsMethod, 'core');
                    return dmsHttp.makeHttpRequest(config);
                });
            };

            //Note: Only returns contacts where they have a Client Center OR Staff Center enabled
            factory.getContactListWithCentersEnabled = function() {
                return getCompanyId().then(function(companyId){
                    var getContactsMethod = companyId + '/' + contactsMethod;

                    var config = dmsHttp.getAnonymousHttpGetConfig(getContactsMethod, 'core');
                    config.params = centersFilter;
                    return dmsHttp.makeHttpRequest(config).then(function(data){
                        // Save the client list locally
                        factory.setCachedContactsList(data.data);
                        return data;
                    }, function(data){
                        return data;
                    });
                });
            };

            //Note: Only returns contacts where they have a Client Center enabled
            factory.getContactListWithClientCenterEnabled = function() {
                return getCompanyId().then(function(companyId){
                    var getContactsMethod = companyId + '/' + contactsMethod;

                    var config = dmsHttp.getAnonymousHttpGetConfig(getContactsMethod, 'core');
                    config.params = clientFilter;
                    return dmsHttp.makeHttpRequest(config).then(function(data){
                        // Save the client list locally
                        factory.setCachedContactsList(data.data);
                        return data;
                    }, function(data){
                        return data;
                    });
                });
            };

            //Note: Only returns contacts where they have a Staff Center enabled
            factory.getContactListWithStaffCenterEnabled = function() {
                return getCompanyId().then(function(companyId){
                    var getContactsMethod = companyId + '/' + contactsMethod;

                    var config = dmsHttp.getAnonymousHttpGetConfig(getContactsMethod, 'core');
                    config.params = staffFilter;
                    return dmsHttp.makeHttpRequest(config).then(function(data){
                        // Save the client list locally
                        factory.setCachedContactsList(data.data);
                        return data;
                    }, function(data){
                        return data;
                    });
                });
            };

            factory.getRelatedContacts = function(contactId) {
                return getCompanyId().then(function(companyId){
                    var getContactsMethod = companyId + '/' + contactsMethod + '/' + contactId + '/' + relatedContactsMethod;

                    var config = dmsHttp.getAnonymousHttpGetConfig(getContactsMethod, 'core');
                    return dmsHttp.makeHttpRequest(config);
                });
            };

            //Note: Only returns contacts where they have a Client Center OR Staff Center enabled
            factory.getRelatedContactsWithCentersEnabled = function(contactId) {
                return getCompanyId().then(function(companyId){
                    var getContactsMethod = companyId + '/' + contactsMethod + '/' + contactId + '/' + relatedContactsMethod;

                    var config = dmsHttp.getAnonymousHttpGetConfig(getContactsMethod, 'core');
                    config.params = centersFilter;
                    return dmsHttp.makeHttpRequest(config);
                });
            };

            //Note: Only returns contacts where they have a Client Center enabled
            factory.getRelatedContactsWithClientCenterEnabled = function(contactId) {
                return getCompanyId().then(function(companyId){
                    var getContactsMethod = companyId + '/' + contactsMethod + '/' + contactId + '/' + relatedContactsMethod;

                    var config = dmsHttp.getAnonymousHttpGetConfig(getContactsMethod, 'core');
                    config.params = clientFilter;
                    return dmsHttp.makeHttpRequest(config);
                });
            };

            //Note: Only returns contacts where they have a Staff Center enabled
            factory.getRelatedContactsWithStaffCenterEnabled = function(contactId) {
                return getCompanyId().then(function(companyId){
                    var getContactsMethod = companyId + '/' + contactsMethod + '/' + contactId + '/' + relatedContactsMethod;

                    var config = dmsHttp.getAnonymousHttpGetConfig(getContactsMethod, 'core');
                    config.params = staffFilter;
                    return dmsHttp.makeHttpRequest(config);
                });
            };

            //Note: this is really just for internal usage.
            factory.setCachedContactsList = function(contactListToCache) {
                if(contactListToCache === null || angular.isUndefined(contactListToCache)){
                    contactListToCache = {};
                }

                contactsList = contactListToCache;
            };

            return factory;
        }
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    var app = angular.module('bluemoon.dms.managers');

    //NOTE: IT IS PREFERRED THAT YOU USE THE SERVICE/UI SERVICE/DATA SERVICE ROUTE.
    var dmsRecentActivityManager = function(dmsHttp){

        var _this = this;

        var recentsMethod = 'recents/documents';

        _this.getRecentActivity = function() {
            var config = dmsHttp.getAnonymousHttpGetConfig(recentsMethod, false);
            return dmsHttp.makeHttpRequest(config);
        };
    };

    dmsRecentActivityManager.$inject = ['dmsHttp'];
    app.service('dmsRecentActivityManager', dmsRecentActivityManager);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.managers')

    .constant('RoleTypes', {
        None: 'None',
        Owner: 'Owner',
        Contributor: 'Contributor',
        Reviewer: 'Reviewer'
    });

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.managers')

    .constant('SourceTypes', {
        NA:         'NA',
        FileSystemDragAndDrop: 'source:fileSystemDragAndDrop',
        FileSystemUploadDialog: 'source:fileSystemUploadDialog',
        Dropbox:    'source:dropbox',
        Google:     'source:google',
        Box:        'source:box'
    });

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.managers')

    .constant('ActivityTypes', {
        Read: 'Read',
        Write: 'Write',
    });

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.managers')

    .constant('StatusTypes', {
        Open: 'Open',
        Closed: 'Closed',
        PastDue: 'PastDue',
    });

})(window.angular);

(function(angular){
    'use strict';

    //  Blank module for dev, overwritten for dist
    angular.module('bluemoon.dms.modal.templates', []);

    angular.module('bluemoon.dms.modal', [
        'bluemoon.dms.modal.templates',
        'ui.bootstrap',
        'bluemoon.components',
        'bluemoon.dms.utility',
        'bluemoon.dms.alerts',
        'bluemoon.dms.format',
    ])

    .service('modalService', [
        function() {

            this.readConfigItem = function(config, prop, def) {
                return config && prop && config[prop] ? config[prop] : def;
            };

        }
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.modal.confirmation', [
        'bluemoon.dms.modal',
    ]);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.modal.new-container', [
        'pascalprecht.translate',
        'bluemoon.dms.modal',
        'bluemoon.dms.validation',
    ]);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.modal.new-document', [
        'pascalprecht.translate',
        'bluemoon.dms.modal',
        'bluemoon.dms.validation',
    ]);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.modal.folder-selection', [
        'bluemoon.dms.modal',
        'bluemoon.dms.folder-selector',
        'bluemoon.dms.ui-services',
        'bluemoon.dms.utility'
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.modal.alert-display', [
        'bluemoon.dms.modal',
    ])

    .constant('alertDisplayModalConstants', {
        translationNamespace: 'AlertDisplay',
    })

    .service('alertDisplayModalService', [
        'dmsService',
        'modalService',
        'alertDisplayModalConstants',
        function(
            dmsService,
            modalService,
            alertDisplayModalConstants){

            this.fullyQualifiedTranslationNamespace = [
                modalService.fullyQualifiedTranslationNamespace,
                alertDisplayModalConstants.translationNamespace,
            ].join('.');

            this.translations = dmsService.translationLoader(this.fullyQualifiedTranslationNamespace);
        }
    ]);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.modal.alert-display.upload', [
        'bluemoon.dms.modal',
    ]);
})(window.angular);

(function(angular) {
    'use strict';

    angular.module('bluemoon.dms.modal.alert-display.operation', [
        'bluemoon.dms.modal.alert-display',
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.modal.alert-display.operation')

    .service('operationAlertDisplayModalService', [
        '$translate',
        '$q',
        'dmsService',
        '$uibModal',
        function(
            $translate,
            $q,
            dmsService,
            $uibModal) {

            var _this = this;

            function loadStrings() {
                var defer = $q.defer();

                $q.all([
                    $translate('Bluemoon.DMS.Modal.AlertDisplay.Operation.Title'),
                    $translate('Bluemoon.DMS.Modal.AlertDisplay.Close'),
                ]).then(function(s){
                    defer.resolve({
                        'Bluemoon.DMS.Modal.AlertDisplay.Operation.Title'                   : s[0],
                        'Bluemoon.DMS.Modal.AlertDisplay.Close'                             : s[1],
                    });
                });

                return defer.promise;
            }

            var _templatePath = function(template) {
                return 'components/modal/alert-display/operation/' + template + '.2js.html';
            };

            var _configObject = function(userConfig) {
                return loadStrings().then(function(translations) {
                    return {
                        title: translations['Bluemoon.DMS.Modal.AlertDisplay.Operation.Title'],
                        descriptionText: '',
                        closeButtonText: translations['Bluemoon.DMS.Modal.AlertDisplay.Close'],
                        dmsOperationCollectionModel: userConfig.dmsOperationCollectionModel,
                        alertCloseCallback: userConfig.alertCloseCallback,
                        keepBothCallback: userConfig.keepBothCallback,
                        replaceCallback: userConfig.replaceCallback,
                    };
                });
            };

            _this.open = function(config) {
                return _configObject(config).then(function(configOptions) {
                    return $uibModal.open({
                        templateUrl: _templatePath('operation-alert-display-modal'),
                        backdrop: 'static',
                        size: configOptions.size,
                        controller: 'operationAlertDisplayModalController',
                        resolve: {
                            configOptions: function() { return configOptions; }
                        }
                    });
                });
            };
        }

    ])

    .controller('operationAlertDisplayModalController', [
        '$scope',
        '$uibModalInstance',
        'configOptions',
        function($scope, $uibModalInstance, configOptions){

            $scope.close = function() {
                $uibModalInstance.close();
            };

            $scope.operations = configOptions.dmsOperationCollectionModel.getCollection();

            $scope.title = configOptions.title;
            $scope.descriptionText = configOptions.descriptionText;
            $scope.closeButtonText = configOptions.closeButtonText;
        }
    ]);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.modal.alert-display.upload')

    .service('uploadAlertDisplayModalService', [
        '$translate',
        '$q',
        '$uibModal',
        function(
            $translate,
            $q,
            $uibModal){

            var _this = this;

            function loadStrings() {
                var defer = $q.defer();

                $q.all([
                    $translate('Bluemoon.DMS.Modal.AlertDisplay.Upload.Title'),
                    $translate('Bluemoon.DMS.Modal.AlertDisplay.Close'),
                ]).then(function(s){
                    defer.resolve({
                        'Bluemoon.DMS.Modal.AlertDisplay.Upload.Title'      : s[0],
                        'Bluemoon.DMS.Modal.AlertDisplay.Close'             : s[1],
                    });
                });

                return defer.promise;
            }

            var _templatePath = function(template) {
                return 'components/modal/alert-display/upload/' + template + '.2js.html';
            };

            var _configObject = function(userConfig) {
                return loadStrings().then(function(translations) {
                    return {
                        title: translations['Bluemoon.DMS.Modal.AlertDisplay.Upload.Title'],
                        descriptionText: '',
                        closeButtonText: translations['Bluemoon.DMS.Modal.AlertDisplay.Close'],
                        uploadCollection: userConfig.uploadCollection,
                    };
                });
            };

            _this.open = function(config) {
                return _configObject(config).then(function(configOptions) {
                    return $uibModal.open({
                        templateUrl: _templatePath('upload-alert-display-modal'),
                        backdrop: 'static',
                        size: configOptions.size,
                        controller: 'uploadAlertDisplayModalController',
                        resolve: {
                            configOptions: function() { return configOptions; }
                        }
                    });
                });
            };

        }
    ])

    .controller('uploadAlertDisplayModalController', [
        '$scope',
        '$uibModalInstance',
        'configOptions',
        function($scope, $uibModalInstance, configOptions){

            $scope.close = function() {
                $uibModalInstance.close();
            };

            $scope.uploads = configOptions.uploadCollection;
            $scope.title = configOptions.title;
            $scope.descriptionText = configOptions.descriptionText;
            $scope.closeButtonText = configOptions.closeButtonText;
        }
    ]);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.modal.confirmation')

    .service('confirmationModalService', [
        '$uibModal',
        function(
            $uibModal){
            var _this = this;

            var _templatePath = function(template) {
                return 'components/modal/confirmation/' + template + '.2js.html';
            };

            _this.open = function(config) {

                if (!config) {
                    throw new Error('config required');
                } else if (!config.message) {
                    throw new Error('message required');
                } else if (!config.positiveConfirmation) {
                    throw new Error('positiveConfirmation required');
                } else if (!config.negativeConfirmation) {
                    throw new Error('negativeConfirmation required');
                }

                var modalInstance = $uibModal.open({
                    templateUrl: _templatePath('confirmation-modal'),
                    backdrop: 'static',
                    size: config.size,
                    controller: 'confirmationModalController',
                    resolve: {
                        configOptions: function() { return config; }
                    }
                });

                return modalInstance;
            };
        }
    ])

    .controller('confirmationModalController', [
        '$scope',
        '$uibModalInstance',
        'configOptions',
        function(
            $scope,
            $uibModalInstance,
            configOptions){

            $scope.message = configOptions.message;
            $scope.positiveConfirmation = configOptions.positiveConfirmation;
            $scope.negativeConfirmation = configOptions.negativeConfirmation;

            $scope.answer = function(confirmed) {
                $uibModalInstance.close(confirmed);
            };
        }
    ]);
})(window.angular);

(function(angular){
    'use strict';

    var DmsDownloadModal = (function() {
        var _$inject = [
            '$q',
            '$uibModal',
        ];

        function DmsDownloadModalImpl($q, $uibModal){

            var service = this;

            service.open = function(documentData) {

                var modalInstance = $uibModal.open({
                    templateUrl: 'components/modal/download/download-modal-view.2js.html',
                    backdrop: 'static',
                    controller: 'dmsDownloadModalController as modalController',
                    resolve: {
                        documentDownloadData: function() { return documentData; }
                    }
                });

                return modalInstance;
            };
        }

        DmsDownloadModalImpl.$inject = _$inject;
        return DmsDownloadModalImpl;
    }());

    var DmsDownloadModalController = (function() {
        var _$inject = ['$document', '$sce', 'dmsDocumentUiService', 'documentDownloadData'];

        function DmsDownloadModalControllerImpl($document, $sce, documentUiService, downloadData){
            var vm = this;

            vm.downloadDocument = function(){
                if(downloadData.accessToken) {
                    documentUiService.download({
                        params: {
                            accessToken: downloadData.accessToken
                        }
                    });
                } else {
                    documentUiService.download({
                        params: {
                            document: downloadData.document
                        }
                    });
                }
            };

            vm.documentName = downloadData.documentName;

            vm.documentSize = downloadData.documentSize;

        }

        DmsDownloadModalControllerImpl.$inject = _$inject;
        return DmsDownloadModalControllerImpl;
    }());

    angular.module('bluemoon.dms.modal.download', ['bluemoon.dms.modal', 'bluemoon.dms.ui-services'])

    .service('dmsDownloadModal', DmsDownloadModal)

    .controller('dmsDownloadModalController', DmsDownloadModalController);

})(window.angular, window._);

(function(angular){
    'use strict';

    var DmsCopyFolderSelectionModalService = (function() {
        var _$inject = ['$translate', '$q', 'dmsService', 'dmsFolderSelectionModalService'];

        function DmsCopyFolderSelectionModalServiceImpl($translate, $q, dmsService, dmsFolderSelectionModalService) {

            var service = this;

            service._loadConfigObject = function(){
                var config = {};
                return $q.all([
                    $translate('Bluemoon.DMS.Modal.FolderSelection.Copy.Title').then(function(s){
                        config.headerText = s;
                    }),
                    $translate('Bluemoon.DMS.Modal.FolderSelection.Copy.Description').then(function(s){
                        config.descriptionText = s;
                    }),
                    $translate('Bluemoon.DMS.Modal.FolderSelection.Copy.SelectButton').then(function(s){
                        config.selectText = s;
                    }),
                    $translate('Bluemoon.DMS.Modal.FolderSelection.CancelButton').then(function(s){
                        config.cancelText = s;
                    }),
                    $translate('Bluemoon.DMS.Modal.FolderSelection.NewFolderButton').then(function(s){
                        config.newFolderText = s;
                    }),
                    $translate('Bluemoon.DMS.OperationForbidden').then(function(s){
                        config.forbiddenText = s;
                    }),
                    $translate('Bluemoon.DMS.Modal.FolderSelection.NoFolderSelected').then(function(s){
                        config.noSelection = s;
                    }),
                ]).then(function(){
                    return config;
                });
            };

            service._openFolderSelectionModal = function(foldersToCopy) {

                var disabledItems = angular.isArray(foldersToCopy) ? foldersToCopy : [foldersToCopy];

                return service._loadConfigObject().then(function(configObject){
                    return dmsFolderSelectionModalService.open({
                        disabledItems: disabledItems,
                        titleText: configObject.headerText,
                        descriptionText: configObject.descriptionText,
                        selectButtonText: configObject.selectText,
                        cancelButtonText: configObject.cancelText,
                        newFolderText: configObject.newFolderText,
                        validate: function(selectedFolder){

                            var result = { errorText: '', alerts: [] };

                            if (!selectedFolder.permissions.addContents) {
                                result.errorText = configObject.forbiddenText;
                                return $q.when(result);
                            }

                            return $q.when(result);
                        }
                    }).result;
                });
            };

            service.open = function(foldersToCopy) {
                return {
                    result: service._openFolderSelectionModal(foldersToCopy)
                };
            };
        }

        DmsCopyFolderSelectionModalServiceImpl.$inject = _$inject;
        return DmsCopyFolderSelectionModalServiceImpl;
    }());

    angular.module('bluemoon.dms.modal.folder-selection')

    //TODO: Deprecate
    .service('copyFolderSelectionModalService', DmsCopyFolderSelectionModalService)

    .service('dmsCopyFolderSelectionModalService', DmsCopyFolderSelectionModalService);

})(window.angular);

(function(angular, _){
    'use strict';

    var DmsFolderSelectionModalService = (function() {
        var _$inject = [
            '$q',
            '$uibModal',
            '$translate',
            'bmPermission',
            'dmsService',
            'modalService',
            'UiService',
            'folderManager'
        ];

        function DmsFolderSelectionModalServiceImpl($q, $uibModal, $translate, bmPermission, dmsService, modalService, UiService, folderManager){

            var service = this;

            function loadStrings() {
                var defer = $q.defer();

                $q.all([
                    $translate('Bluemoon.DMS.Modal.FolderSelection.General.Title'),
                    $translate('Bluemoon.DMS.Modal.FolderSelection.General.Description'),
                    $translate('Bluemoon.DMS.Modal.FolderSelection.General.SelectButton'),
                    $translate('Bluemoon.DMS.Modal.FolderSelection.CancelButton'),
                    $translate('Bluemoon.DMS.Modal.FolderSelection.NewFolderButton'),
                ]).then(function(s){
                    defer.resolve({
                        'Bluemoon.DMS.Modal.FolderSelection.General.Title'                  : s[0],
                        'Bluemoon.DMS.Modal.FolderSelection.General.Description'            : s[1],
                        'Bluemoon.DMS.Modal.FolderSelection.General.SelectButton'           : s[2],
                        'Bluemoon.DMS.Modal.FolderSelection.CancelButton'                   : s[3],
                        'Bluemoon.DMS.Modal.FolderSelection.NewFolderButton'                : s[4],
                    });
                });

                return defer.promise;
            }

            loadStrings().then(function(translations){

                var _templatePath = function(template) {
                    return 'components/modal/folder-selection/' + template + '.2js.html';
                };

                var loadRootLevel = function() {
                    return folderManager.getRootFolder().then(function(result){
                        return $q.all([
                            $translate('Bluemoon.DMS.SpecialFolders.Clients'),
                            $translate('Bluemoon.DMS.SpecialFolders.Templates')
                        ])
                        .then(function(translations){

                            var rootFolder = {
                                id: 'root',
                                isRoot: true,
                                subContainers: []
                            };

                            var CLIENT_DOCS_FRPS = [
                                'OnvioDrive.ClientDocuments',
                                'Onvio.DocumentStorage',
                                'OnvioClientDrive.Drive'
                            ];

                            return bmPermission.hasSome(CLIENT_DOCS_FRPS).then(function() {
                                rootFolder.subContainers.push({
                                    id: 'client',
                                    name: translations[0],
                                    isClientBranch: true,
                                    itemType: 'ClientRoot',
                                    type: 'client',
                                });
                            }, angular.noop).then(function() {
                                rootFolder.subContainers = rootFolder.subContainers.concat(result.data);
                                return bmPermission.has('OnvioDrive.Templates');
                            }).then(function() {
                                rootFolder.subContainers.push({
                                    id: 'Templates',
                                    name: translations[1],
                                    isTemplateBranch: true,
                                    itemType: 'Firm',
                                    type: 'templates',
                                });
                            }, angular.noop).then(function() {
                                //Now, finally, actually form the list and set up links
                                _.each(rootFolder.subContainers, function(container) {
                                    container.parent = rootFolder;
                                });

                                return rootFolder;
                            });
                        });
                    });
                };

                var _configObject = function(userConfig) {
                    return {
                        disabledItems: modalService.readConfigItem(userConfig, 'disabledItems'),
                        unselectableItems: modalService.readConfigItem(userConfig, 'unselectableItems'),
                        startFolder: modalService.readConfigItem(userConfig, 'startFolder', { id : '' }),
                        loadRootLevel: modalService.readConfigItem(userConfig, 'loadRootLevel', loadRootLevel),
                        title: modalService.readConfigItem(userConfig, 'titleText',
                            translations['Bluemoon.DMS.Modal.FolderSelection.General.Title']),
                        descriptionText: modalService.readConfigItem(userConfig, 'descriptionText',
                            translations['Bluemoon.DMS.Modal.FolderSelection.General.Description']),
                        selectButtonText: modalService.readConfigItem(userConfig, 'selectButtonText',
                            translations['Bluemoon.DMS.Modal.FolderSelection.General.SelectButton']),
                        cancelButtonText: modalService.readConfigItem(userConfig, 'cancelButtonText',
                            translations['Bluemoon.DMS.Modal.FolderSelection.CancelButton']),
                        newFolderText: modalService.readConfigItem(userConfig, 'newFolderText',
                            translations['Bluemoon.DMS.Modal.FolderSelection.NewFolderButton']),
                        size: modalService.readConfigItem(userConfig, 'size', ''),
                        validate: modalService.readConfigItem(userConfig, 'validate', function(){
                            return { errorText: '', alerts: [] };
                        }),
                        canSelectItem: modalService.readConfigItem(userConfig, 'canSelectItem',
                            function(selectedItem) {

                                if (!selectedItem ||  !selectedItem.id || selectedItem.itemType === 'Client' ||
                                    selectedItem.isRoot || selectedItem.isClientBranch || selectedItem.isTemplateBranch) {
                                    return false;
                                }

                                if (this.unselectableItems) {
                                    return _.where(this.unselectableItems,
                                        { itemType: selectedItem.itemType, id: selectedItem.id }).length === 0;
                                }

                                return true;
                            })
                    };
                };

                service.open = function(config) {

                    var configOptions = _configObject(config);

                    var modalInstance = $uibModal.open({
                        templateUrl: _templatePath('folder-selection-modal'),
                        backdrop: 'static',
                        size: configOptions.size,
                        controller: 'dmsFolderSelectionModalController',
                        resolve: {
                            configOptions: function() { return configOptions; }
                        }
                    });

                    return modalInstance;
                };

                service.isFolderOneOf = function(selectedFolder, oneOf) {
                    return oneOf && _.find(oneOf,
                        function(f) { return f.id === selectedFolder.id && f.itemType === 'Folder'; }) !== undefined;
                };

                service.isFolderSelected = function(selectedFolder) {
                    return !selectedFolder || !selectedFolder.id || selectedFolder.id.length === 0;
                };

                service.containsOneOf = function(item, oneOf) {
                    return oneOf && _.find(oneOf,
                        function(i){
                            return i.parentId ? i.parentId === item.id :
                                i.containerId ? i.containerId === item.id : false;
                        }) !== undefined;
                };
            });
        }

        DmsFolderSelectionModalServiceImpl.$inject = _$inject;
        return DmsFolderSelectionModalServiceImpl;
    }());

    var DmsFolderSelectionModalController = (function() {
        var _$inject = [
            '$scope',
            '$q',
            '$uibModalInstance',
            'UiService',
            'configOptions',
            'dmsPermission',
            'dmsModalUiService'
        ];

        function DmsFolderSelectionModalControllerImpl($scope, $q, $uibModalInstance, UiService, configOptions, dmsPermission, dmsModalUiService){

            var isStaff;

            $scope.checkStaffStatus = function(){
                UiService.staffDocumentsPermission().then(function(permission){
                    isStaff = (permission === 'Granted');
                });
            };

            $scope.loadRootLevel = function(params) {
                return configOptions.loadRootLevel(params);
            };

            $scope.select = function(){
                $q.when(configOptions.validate($scope.selectedItem)).then(function(validation){
                    if (validation.errorText !== '' || validation.alerts.length > 0) {
                        $scope.errorText = validation.errorText;
                        $scope.alerts = validation.alerts;
                    } else {
                        $uibModalInstance.close($scope.selectedItem);
                    }
                });
            };

            $scope.cancel = function(){
                $uibModalInstance.dismiss('cancel');
            };

            $scope.selectedItemChanged = function(item){
                $scope.selectedItem = item;
                $scope.canSelectItem = configOptions.canSelectItem(item);
            };

            $scope.currentItemChanged = function(item){
                $scope.currentItem = item;
                dmsPermission.has('OnvioDrive.AddFolders').then(function(permission){
                    //If you do not have the Staff permission AND you are clicking on a Storage-level item, we need to flag that.
                    var disableBecauseClient = (!isStaff && item.parent && item.parent.id === 'client');
                    var disableBecauseTemplates = item.id === 'Templates';
                    var allowedToAddFolder = true;
                    if (permission !== true){
                        allowedToAddFolder = false;
                    }
                    $scope.canAddNewFolder = item.id !== '' && item.id !== 'root' && item.id !== 'client' && !disableBecauseClient && !disableBecauseTemplates && allowedToAddFolder;
                });
            };

            $scope.newFolder = function() {
                 $q.when(configOptions.validate($scope.selectedItem)).then(function(validation){
                    if (validation.errorText !== '' || validation.alerts.length > 0) {
                        $scope.errorText = validation.errorText;
                        $scope.alerts = validation.alerts;
                    } else {
                        dmsModalUiService.addFolder({
                            busily: false,
                            addOperation: false,
                            parentContainerId: $scope.currentItem.id,
                            parentContainerType: $scope.currentItem.itemType
                        });
                    }
                });
            };

            $scope.title = configOptions.title;
            $scope.descriptionText = configOptions.descriptionText;
            $scope.selectButtonText = configOptions.selectButtonText;
            $scope.cancelButtonText = configOptions.cancelButtonText;
            $scope.newFolderText = configOptions.newFolderText;
            $scope.errorText = '';
            $scope.alerts = [];
            $scope.disabledItems = configOptions.disabledItems;
            $scope.checkStaffStatus();

            $scope.selectedItemChanged({});
        }

        DmsFolderSelectionModalControllerImpl.$inject = _$inject;
        return DmsFolderSelectionModalControllerImpl;
    }());

    angular.module('bluemoon.dms.modal.folder-selection')

    //TODO: Deprecate
    .service('folderSelectionModalService', DmsFolderSelectionModalService)

    .service('dmsFolderSelectionModalService', DmsFolderSelectionModalService)

    .controller('dmsFolderSelectionModalController', DmsFolderSelectionModalController);

})(window.angular, window._);

(function(angular){
    'use strict';

    var DmsMoveFolderSelectionModalService = (function() {
        var _$inject = ['$translate', '$q', 'dmsService', 'dmsFolderSelectionModalService'];

        function DmsMoveFolderSelectionModalServiceImpl($translate, $q, dmsService, dmsFolderSelectionModalService) {

            var service = this;

            service._loadConfigObject = function(){
                var config = {};
                return $q.all([
                    $translate('Bluemoon.DMS.Modal.FolderSelection.Move.Title').then(function(s){
                        config.headerText = s;
                    }),
                    $translate('Bluemoon.DMS.Modal.FolderSelection.Move.Description').then(function(s){
                        config.descriptionText = s;
                    }),
                    $translate('Bluemoon.DMS.Modal.FolderSelection.Move.SelectButton').then(function(s){
                        config.selectText = s;
                    }),
                    $translate('Bluemoon.DMS.Modal.FolderSelection.CancelButton').then(function(s){
                        config.cancelText = s;
                    }),
                    $translate('Bluemoon.DMS.Modal.FolderSelection.NewFolderButton').then(function(s){
                        config.newFolderText = s;
                    }),
                    $translate('Bluemoon.DMS.OperationForbidden').then(function(s){
                        config.forbiddenText = s;
                    }),
                    $translate('Bluemoon.DMS.Modal.FolderSelection.NoFolderSelected').then(function(s){
                        config.noSelection = s;
                    }),
                ]).then(function(){
                    return config;
                });
            };

            service._openFolderSelectionModal = function(toMove) {

                var disabledItems = angular.isArray(toMove) ? toMove : [toMove];
                var unselectableItems = angular.isArray(toMove) ? [toMove[0].parentItem] : [toMove.parentItem];

                return service._loadConfigObject().then(function(configObject){
                    return dmsFolderSelectionModalService.open({
                        disabledItems: disabledItems,
                        unselectableItems: unselectableItems,
                        titleText: configObject.headerText,
                        descriptionText: configObject.descriptionText,
                        selectButtonText: configObject.selectText,
                        cancelButtonText: configObject.cancelText,
                        newFolderText: configObject.newFolderText,
                        validate: function(selectedFolder){

                            var result = { errorText: '', alerts: [] };

                            if (!selectedFolder.permissions.addContents) {
                                result.errorText = configObject.forbiddenText;
                                return $q.when(result);
                            }

                            return $q.when(result);
                        }
                    }).result;
                });
            };

            service.open = function(toMove) {
                return {
                    result: service._openFolderSelectionModal(toMove)
                };
            };
        }

        DmsMoveFolderSelectionModalServiceImpl.$inject = _$inject;
        return DmsMoveFolderSelectionModalServiceImpl;
    }());

    angular.module('bluemoon.dms.modal.folder-selection')

    //TODO: Deprecate
    .service('moveFolderSelectionModalService', DmsMoveFolderSelectionModalService)

    .service('dmsMoveFolderSelectionModalService', DmsMoveFolderSelectionModalService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsNewContainerModalService = (function(){
        var _$inject = [
            '$q',
            'dmsService',
            '$uibModal',
        ];

        function DmsNewContainerModalServiceImpl($q, dmsService, $uibModal){

            var service = this;

            var _templatePath = function(template) {
                return 'components/modal/new-container/' + template + '.2js.html';
            };

            service.open = function(config) {

                if (config.checkForDuplicates) {
                    if (!config.parentContainerType || config.parentContainerType === '') {
                        throw new Error('parentContainerType required when checking for duplicates');
                    } else if (!config.parentContainerId || config.parentContainerId === '') {
                        throw new Error('parentContainerId required when checking for duplicates');
                    }
                }

                var modalInstance = $uibModal.open({
                    templateUrl: _templatePath('new-container-modal'),
                    backdrop: 'static',
                    size: config.size,
                    controller: 'dmsNewContainerModalController',
                    resolve: {
                        configOptions: function() { return config; }
                    }
                });

                return modalInstance;
            };
        }

        DmsNewContainerModalServiceImpl.$inject = _$inject;
        return DmsNewContainerModalServiceImpl;
    }());

    var DmsNewContainerModalController = (function() {
        var _$inject = [
            '$scope',
            '$uibModalInstance',
            '$q',
            '$translate',
            'systemConstants',
            'FileFolderValidation',
            'configOptions',
            'folderManager',
            'projectManager',
            'UiService'
        ];

        function DmsNewContainerModalControllerImpl($scope, $uibModalInstance, $q, $translate, systemConstants, FileFolderValidation, configOptions, folderManager, projectManager, UiService){

            $scope.templates = [];
            $scope.newContainerData = {};
            $scope.newContainerData.canAdd = true;
            $scope.hasTemplates = false;

            var getTemplatesPermission = function(){
                var deferred = $q.defer();

                UiService.templatesDocumentsPermission().then(function(permission){
                    $scope.hasTemplates = (permission === 'Granted');
                    deferred.resolve();
                });
                return deferred.promise;
            };

            getTemplatesPermission();

            $scope.isAddingProject = function(){
                if (configOptions.parentContainerType !== 'Client') {return false;}

                return $scope.hasTemplates;
            };

            var getTemplates = function(){
                getTemplatesPermission().then(function(){

                    if (!$scope.isAddingProject()) { return; }

                    var params = {
                        primaryAssociationId: 'Templates',
                        primaryAssociationType: 'Firm',
                        productType: 'DMSClientFolder'
                    };

                    $translate('Bluemoon.DMS.Modal.NewContainer.Container.None').then(function(templateRes){

                        $scope.templates.push({ name: templateRes, value: 0 });

                        return projectManager.getProjectListWithConfigurationParameters(params).then(function(res){
                            for (var i = 0; i < res.data.length; i++){
                                $scope.templates.push({name: res.data[i].name, value: res.data[i].id});
                            }
                            $scope.newContainerData.selectedValue = 0;
                        });
                    });

                });
            };

            getTemplates();

            //Code below for loading in strings on a per-needed basis
            if (!configOptions.headerText){
                $translate('Bluemoon.DMS.Modal.NewContainer.Container.Title').then(function(res){
                    $scope.headerText = res;
                });
            } else {
                $scope.headerText = configOptions.headerText;
            }

            if (!configOptions.nameText){
                $translate('Bluemoon.DMS.Modal.NewContainer.Container.Name').then(function(res){
                    $scope.nameText = res;
                });
            } else {
                $scope.nameText = configOptions.nameText;
            }

            if (!configOptions.templateText){
                $translate('Bluemoon.DMS.Modal.NewContainer.Container.Template').then(function(res){
                    $scope.templateText = res;
                });
            } else {
                $scope.nameText = configOptions.templateText;
            }

            if (!configOptions.uniqueNameError){
                $translate('Bluemoon.DMS.Modal.NewContainer.Container.PleaseEnterUniqueName').then(function(res){
                    $scope.uniqueNameError = res;
                });
            } else {
                $scope.uniqueNameError = configOptions.uniqueNameError;
            }

            if (!configOptions.requiredText){
                $translate('Bluemoon.DMS.Modal.NewContainer.Container.RequiredText').then(function(res){
                    $scope.requiredText = res;
                });
            } else {
                $scope.requiredText = configOptions.requiredText;
            }

            if (!configOptions.saveText){
                $translate('Bluemoon.DMS.Modal.NewContainer.Container.Save').then(function(res){
                    $scope.saveText = res;
                });
            } else {
                $scope.saveText = configOptions.saveText;
            }

            if (!configOptions.cancelText){
                $translate('Bluemoon.DMS.Modal.NewContainer.Container.Cancel').then(function(res){
                    $scope.cancelText = res;
                });
            } else {
                $scope.cancelText = configOptions.cancelText;
            }

            //Done with UI work, carry on
            var containerExists = function(parentContainerId, parentContainerType, containerName) {
                var defer = $q.defer();

                var newContainerType = (parentContainerType === 'Folder' ||
                    parentContainerType === 'Project') ? 'Folder' : 'Project';

                var existsFunctionPromise = newContainerType === 'Folder' ?
                    folderManager.getFolderExists(
                        parentContainerId,
                        containerName,
                        parentContainerType) :
                    projectManager.getProjectExists({
                        name: containerName,
                        productType: 'DMSClientFolder',
                        primaryAssociationId: parentContainerId,
                        primaryAssociationType: parentContainerType,
                        processingYear: 1900
                    });

                existsFunctionPromise.then(function(responseData){
                        defer.resolve(responseData.data[0].exists);
                    });

                return defer.promise;
            };

            $scope.newContainerData.resetValidation = function() {
                $scope.newContainerData.alerts = [];
                $scope.newContainerData.containerNameError = '';
            };

            $scope.validateData = function() {
                var defer = $q.defer();

                $scope.newContainerData.resetValidation();

                FileFolderValidation.validateFolderName($scope.newContainerData.containerName).then(function(errMsg){
                    if (errMsg && errMsg !== '') {
                        defer.resolve({
                            errorMessage: errMsg,
                        });
                    } else if (configOptions.checkForDuplicates) {
                        if (!errMsg || errMsg === '') {
                            containerExists(
                                configOptions.parentContainerId,
                                configOptions.parentContainerType,
                                $scope.newContainerData.containerName).then(
                                function(exists){
                                    if (exists) {
                                        defer.resolve({errorMessage: $scope.uniqueNameError});
                                    } else {
                                        defer.resolve({});
                                    }
                                });
                        }
                    }
                });
                return defer.promise;
            };

            $scope.newContainerRequest = function() {
                $scope.validateData().then(function(validationData){
                    if (validationData.errorMessage && validationData.errorMessage !== ''){
                        $scope.newContainerData.containerNameError = validationData.errorMessage;
                    } else {
                        //If we've picked a Template, we need to close and pass that information along
                        if (!!$scope.newContainerData.selectedValue && parseInt($scope.newContainerData.selectedValue) !== 0){
                            $scope.closeModalAction($scope.newContainerData);
                        } else {
                            //we just need to pass along the foldername
                            $scope.closeModalAction($scope.newContainerData.containerName);
                        }
                    }
                });
            };

            $scope.closeModalAction = function(newContainer){
                $uibModalInstance.close(newContainer);
            };

            $scope.cancelNewContainer = function() {
                $uibModalInstance.dismiss('cancelled');
            };

            $scope.newContainerData.resetValidation();

            $scope.newContainerData.maxContainerNameLength = systemConstants.maxFolderNameLength;
        }

        DmsNewContainerModalControllerImpl.$inject = _$inject;
        return DmsNewContainerModalControllerImpl;
    }());

    angular.module('bluemoon.dms.modal.new-container')

    //TODO: Deprecate
    .service('newContainerModalService', DmsNewContainerModalService)

    .service('dmsNewContainerModalService', DmsNewContainerModalService)
    .controller('dmsNewContainerModalController', DmsNewContainerModalController);

})(window.angular);

(function(angular){
    'use strict';

    var DmsNewTemplateModalService = (function() {
        var _$inject = ['$translate', '$q', 'dmsService', 'dmsNewContainerModalService'];

        function DmsNewTemplateModalServiceImpl($translate, $q, dmsService, dmsNewContainerModalService) {

            var service = this;

            service._loadConfigObject = function(config){
                var configObject = config;

                return $q.all([
                    $translate('Bluemoon.DMS.Modal.NewContainer.Template.Title').then(function(s){
                        configObject.headerText = s;
                    }),
                    $translate('Bluemoon.DMS.Modal.NewContainer.Container.Name').then(function(s){
                        configObject.nameText = s;
                    }),
                    $translate('Bluemoon.DMS.Modal.NewContainer.Container.PleaseEnterUniqueName').then(function(s){
                        configObject.uniqueNameError = s;
                    }),
                    $translate('Bluemoon.DMS.Modal.NewContainer.Container.RequiredText').then(function(s){
                        configObject.requiredText = s;
                    }),
                    $translate('Bluemoon.DMS.Modal.NewContainer.Container.Save').then(function(s){
                        configObject.save = s;
                    }),
                    $translate('Bluemoon.DMS.Modal.NewContainer.Container.Cancel').then(function(s){
                        configObject.cancel = s;
                    }),
                ]).then(function(){
                    return configObject;
                });
            };

            service._openNewContainerModal = function(config) {

                return service._loadConfigObject(config).then(function(configObject){
                    return dmsNewContainerModalService.open(configObject).result;
                });
            };

            service.open = function(config) {
                return {
                    result: service._openNewContainerModal(config)
                };
            };
        }

        DmsNewTemplateModalServiceImpl.$inject = _$inject;
        return DmsNewTemplateModalServiceImpl;
    }());

    angular.module('bluemoon.dms.modal.new-container')

    .service('dmsNewTemplateModalService', DmsNewTemplateModalService);

})(window.angular);

 (function(angular){
     'use strict';

     var DmsNewDocumentModalService = (function(){
         var _$inject = [
             '$q',
             'dmsService',
             '$uibModal',
         ];

         function DmsNewDocumentModalServiceImpl($q, dmsService, $uibModal){

             var service = this;

             var _templatePath = function(template) {
                 return 'components/modal/new-document/' + template + '.2js.html';
             };

             service.open = function(config) {

                 if (config.checkForDuplicates) {
                     if (!config.parentContainerType || config.parentContainerType === '') {
                         throw new Error('parentContainerType required when checking for duplicates');
                     } else if (!config.parentContainerId || config.parentContainerId === '') {
                         throw new Error('parentContainerId required when checking for duplicates');
                     }
                 }

                 var modalInstance = $uibModal.open({
                     templateUrl: _templatePath('new-document-modal'),
                     backdrop: 'static',
                     size: config.size,
                     controller: 'dmsNewDocumentModalController',
                     resolve: {
                         configOptions: function() { return config; }
                     }
                 });

                 return modalInstance;
             };
         }

         DmsNewDocumentModalServiceImpl.$inject = _$inject;
         return DmsNewDocumentModalServiceImpl;
     }());

     var DmsNewDocumentModalController = (function() {
         var _$inject = [
             '$scope',
             '$uibModalInstance',
             '$q',
             '$translate',
             'systemConstants',
             'FileFolderValidation',
             'configOptions',
             'fileManager'
         ];

         function DmsNewDocumentModalControllerImpl($scope, $uibModalInstance, $q, $translate, systemConstants, FileFolderValidation, configOptions, fileManager){
             $scope.newDocumentData = {};
             $scope.newDocumentData.metaData = {};
             $scope.newDocumentData.canAdd = true;

             $scope.documentType = function(){
                 if (configOptions.documentType === 'Excel') {
                     return '.xlsx';
                 } else if (configOptions.documentType === 'Word') {
                     return '.docx';
                 }
                 return '';
             };

             //Code below for loading in strings on a per-needed basis
             if (!configOptions.headerText){
                 var translateHeaderText = '';
                 if (configOptions.documentType === 'Excel') {
                     translateHeaderText = $translate('Bluemoon.DMS.Modal.NewDocument.Document.NewExcelSpreadsheet');
                 } else if (configOptions.documentType === 'Word') {
                     translateHeaderText = $translate('Bluemoon.DMS.Modal.NewDocument.Document.NewWordDocument');
                 }
                 translateHeaderText.then(function(res){
                     $scope.headerText = res;
                 });
             } else {
                 $scope.headerText = configOptions.headerText;
             }

             if (!configOptions.nameText){
                 $translate('Bluemoon.DMS.Modal.NewDocument.Document.Name').then(function(res){
                     $scope.nameText = res;
                 });
             } else {
                 $scope.nameText = configOptions.nameText;
             }

             if (!configOptions.uniqueNameError){
                 $translate('Bluemoon.DMS.Modal.NewDocument.Document.PleaseEnterUniqueName').then(function(res){
                     $scope.uniqueNameError = res;
                 });
             } else {
                 $scope.uniqueNameError = configOptions.uniqueNameError;
             }

             if (!configOptions.requiredText){
                 $translate('Bluemoon.DMS.Modal.NewDocument.Document.RequiredText').then(function(res){
                     $scope.requiredText = res;
                 });
             } else {
                 $scope.requiredText = configOptions.requiredText;
             }

             if (!configOptions.saveText){
                 $translate('Bluemoon.DMS.Modal.NewDocument.Document.Save').then(function(res){
                     $scope.saveText = res;
                 });
             } else {
                 $scope.saveText = configOptions.saveText;
             }

             if (!configOptions.cancelText){
                 $translate('Bluemoon.DMS.Modal.NewDocument.Document.Cancel').then(function(res){
                     $scope.cancelText = res;
                 });
             } else {
                 $scope.cancelText = configOptions.cancelText;
             }

             //Done with UI work, carry on
             var documentExists = function(parentContainerId, documentName, parentContainerType) {
                 var defer = $q.defer();

                 var existsFunctionPromise = fileManager.getDocumentExists(
                         parentContainerId,
                         documentName,
                         parentContainerType);

                 existsFunctionPromise.then(function(responseData){
                         defer.resolve(responseData.data[0].exists);
                     });

                 return defer.promise;
             };

             $scope.newDocumentData.resetValidation = function() {
                 $scope.newDocumentData.alerts = [];
                 $scope.newDocumentData.documentNameError = '';
             };

             $scope.validateData = function() {
                 var defer = $q.defer();

                 $scope.newDocumentData.resetValidation();

                 FileFolderValidation.validateFileName($scope.newDocumentData.documentName).then(function(errMsg){
                     if (errMsg && errMsg !== '') {
                         defer.resolve({
                             errorMessage: errMsg,
                         });
                     } else if (configOptions.checkForDuplicates) {
                         if (!errMsg || errMsg === '') {
                             documentExists(
                                 configOptions.parentContainerId,
                                 $scope.newDocumentData.documentName.concat($scope.documentType()),
                                 configOptions.parentContainerType).then(
                                 function(exists){
                                     if (exists) {
                                         defer.resolve({errorMessage: $scope.uniqueNameError});
                                     } else {
                                         defer.resolve({});
                                     }
                                 });
                         }
                     }
                 });

                 return defer.promise;
             };

             $scope.newDocumentRequest = function() {
                 $scope.validateData().then(function(validationData){
                     if (validationData.errorMessage && validationData.errorMessage !== ''){
                         $scope.newDocumentData.documentNameError = validationData.errorMessage;
                     } else {
                         //we just need to pass along the foldername
                         $scope.closeModalAction($scope.newDocumentData.documentName, $scope.newDocumentData.metaData);
                     }
                 });
             };

             $scope.closeModalAction = function(newDocument){
                 $uibModalInstance.close(newDocument);
             };

             $scope.cancelNewDocument = function() {
                 $uibModalInstance.dismiss('cancelled');
             };

             $scope.newDocumentData.resetValidation();
         }

         DmsNewDocumentModalControllerImpl.$inject = _$inject;
         return DmsNewDocumentModalControllerImpl;
     }());

     angular.module('bluemoon.dms.modal.new-document')

     .service('dmsNewDocumentModalService', DmsNewDocumentModalService)
     .controller('dmsNewDocumentModalController', DmsNewDocumentModalController);

 })(window.angular);

(function(angular, _){
    'use strict';

    var ModalSendItemsRecipientListDirectiveService = (function(){
        var _$inject = [];

        function ModalSendItemsRecipientListDirectiveServiceImpl(){

            //  Stolen from angular source
            var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
            var RECIPIENT_SEPERATORS = ';,';
            var RECIPIENT_SEPERATORS_REGEXP = new RegExp(RECIPIENT_SEPERATORS.split('').join('|'));

            var service = this;

            service.recipientSeperatorRegExp = RECIPIENT_SEPERATORS_REGEXP;
            service.defaultRecipientSeperator = RECIPIENT_SEPERATORS[0];

            service.parseViewValue = function(viewValue) {
                var result = [];
                _.each(viewValue.split(service.recipientSeperatorRegExp), function(it) {
                    var trimmed = it.trim();
                    if (trimmed) {
                        result.push(trimmed);
                    }
                });
                return result;
            };

            service.flattenRecipientCollection = function(collection) {
                var result = [];
                _.each(collection, function(it){
                    if (it.type === 'email') {
                        result.push(it.address);
                    }
                });
                return result.join(service.defaultRecipientSeperator + ' ');
            };

            service.buildRecipientCollection = function(viewValue, collection) {
                var parsedViewValue = service.parseViewValue(viewValue);
                _.each(parsedViewValue, function(it){
                    collection.push({ type: 'email', address: it });
                });
            };

            service.validateRecipient = function(recipient) {
                return EMAIL_REGEXP.test(recipient);
            };
        }

        ModalSendItemsRecipientListDirectiveServiceImpl.$inject = _$inject;
        return ModalSendItemsRecipientListDirectiveServiceImpl;
    }());

    var ModalSendItemsRecipientListDirective = (function(){
        var _$inject = ['dmsSendItemsRecipientList._service'];

        function ModalSendItemsRecipientListDirectiveImpl(recipientList) {
            return {
                require: 'ngModel',
                link: function(scope, elm, attrs, ctrl) {
                    ctrl.$validators.recipients = function(modelValue, viewValue) {
                        if (!viewValue) {
                            return true;
                        }

                        return _.every(recipientList.parseViewValue(viewValue), function(it){
                            return recipientList.validateRecipient(it);
                        });
                    };
                }
            };
        }

        ModalSendItemsRecipientListDirectiveImpl.$inject = _$inject;
        return ModalSendItemsRecipientListDirectiveImpl;
    }());

    var ModalSendToDirective = (function(){
        var _$inject = ['dmsSendItemsRecipientList._service', '$timeout', '$document'];

        function ModalSendToDirectiveImpl(recipientList, $timeout, $document) {
            return {
                require: '^form',
                scope: {
                    name: '@',
                    recipients: '=',
                    required: '@'
                },
                template: '<textarea class="form-control" name="{{ name }}" ng-model="to" ng-model-options="{ updateOn: \'blur\' }" dms-send-items-recipient-list ng-required="{{required}}" autofocus></textarea>',
                link: function(scope) {

                    scope.to = '';

                    scope.$watchCollection('recipients', function(newValue){
                        if (newValue) {
                            scope.to = recipientList.flattenRecipientCollection(newValue);
                        }
                    });

                    scope.$watch('to', function(newValue){

                        //  If the model is invalid, this will need to return
                        if (newValue === undefined) {
                            return;
                        }

                        if (!scope.recipients) {
                            scope.recipients = [];
                        }

                        scope.recipients.length = 0;
                        if (newValue) {
                            recipientList.buildRecipientCollection(newValue, scope.recipients);
                        }
                    });

                    $timeout(function() {
                        $document.find('textarea[name="to"]')[0].focus();
                    });
                }
            };
        }

        ModalSendToDirectiveImpl.$inject = _$inject;
        return ModalSendToDirectiveImpl;
    }());

    var ModalService = (function(){
        var _$inject = ['$uibModal', 'bmUser'];

        function ModalServiceImpl($uibModal, bmUser) {
            var service = this;

            service._supportedItemTypes = ['Document'];

            service._validateItems = function(items) {
                if (!angular.isArray(items) || items.length === 0) {
                    throw new Error('items array required');
                } else {
                    _.each(items, function(item){
                        if (!_.contains(service._supportedItemTypes,item.itemType)) {
                            throw new Error('unsupported itemType');
                        } else if(!item.id) {
                            throw new Error('id missing for item');
                        }
                    });
                }
            };

            service.open = function(config){

                if (!config) {
                    throw new Error('config required');
                }

                var items = config.items;

                service._validateItems(items);

                return $uibModal.open({
                    templateUrl: 'components/modal/send-items/send-items-modal.2js.html',
                    backdrop: 'static',
                    controller: 'dmsSendItemsModal._controller as modalController',
                    resolve: {
                        items: function(){ return items; },
                        bmUser: function() {
                            return bmUser.load().then(function(){
                                return bmUser;
                            });
                        }
                    }
                });
            };
        }

        ModalServiceImpl.$inject = _$inject;
        return ModalServiceImpl;
    }());

    var ModalController = (function(){
        var _$inject = ['$uibModalInstance', '$q', '$scope', '$translate', 'bmUser', 'bmLanguageManager', 'items'];

        function ModalControllerImpl($uibModalInstance, $q, $scope, $translate, bmUser, bmLanguageManager, items){

            var vm = this;

            //  Form fields
            vm.recipients = [];

            $q.all([
                $translate('Bluemoon.DMS.Modal.SendItems.AfterTwoWeeks'),
                $translate('Bluemoon.DMS.Modal.SendItems.AfterOneWeek'),
                $translate('Bluemoon.DMS.Modal.SendItems.AfterThreeDays'),
                $translate('Bluemoon.DMS.Modal.SendItems.AfterOneDay'),
            ]).then(function(s){
                vm.expirationValues = [
                    { value: 'AfterTwoWeeks', label: s[0] },
                    { value: 'AfterOneWeek', label: s[1] },
                    { value: 'AfterThreeDays', label: s[2] },
                    { value: 'AfterOneDay', label: s[3] }
                ];

                //  Default to after 3 days
                vm.expiration = vm.expirationValues[2];
            });

             bmLanguageManager.getLanguagesAsync(true).then(function(languages){
                  vm.languageList = languages;
              });

            vm.languageCode = bmUser.language;

            vm.items = items;

            var fullName = bmUser.fullName;

            if(items.length === 1){
                $translate('Bluemoon.DMS.Modal.SendItems.Subject.UserHasSentALink', { fullName: fullName, docName: items[0].name }).then(function(s){
                    vm.subject = s;
                });
            } else if(items.length > 1) {
                $translate('Bluemoon.DMS.Modal.SendItems.Subject.UserHasSentLinks', { fullName: fullName }).then(function(s){
                    vm.subject = s;
                });
            }

            vm.cancel = function(){
                $uibModalInstance.dismiss('cancel');
            };

            vm.send = function(){
                $uibModalInstance.close({
                    recipients: vm.recipients,
                    expiration: vm.expiration.value,
                    items: items,
                    language: vm.languageCode.substr(0,2),
                    locale: vm.languageCode.substr(3,4)
                });
            };
        }

        ModalControllerImpl.$inject = _$inject;
        return ModalControllerImpl;
    }());

    angular.module('bluemoon.dms.modal.send-items', [
        'pascalprecht.translate',
        'bmUser',
        'bluemoon.dms.modal'
    ])

    .directive('dmsSendItemsRecipientList', ModalSendItemsRecipientListDirective)

    .directive('dmsSendItemsModalSendTo', ModalSendToDirective)

    .service('dmsSendItemsRecipientList._service', ModalSendItemsRecipientListDirectiveService)

    .service('dmsSendItemsModalService', ModalService)

    .service('dmsSendItemsModal', ModalService)

    .controller('dmsSendItemsModal._controller', ModalController);

})(window.angular, window._);

angular.module('bluemoon.dms.modal.templates', ['components/modal/alert-display/operation/operation-alert-display-modal.2js.html', 'components/modal/alert-display/upload/upload-alert-display-modal.2js.html', 'components/modal/confirmation/confirmation-modal.2js.html', 'components/modal/download/download-modal-view.2js.html', 'components/modal/folder-selection/folder-selection-modal.2js.html', 'components/modal/new-container/new-container-modal.2js.html', 'components/modal/new-document/new-document-modal.2js.html', 'components/modal/send-items/send-items-modal.2js.html']);

angular.module("components/modal/alert-display/operation/operation-alert-display-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/modal/alert-display/operation/operation-alert-display-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"close()\">\n" +
    "  <i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\">\n" +
    "    {{title}}\n" +
    "</div>\n" +
    "<div class=\"dms modal-body\">\n" +
    "    <div>\n" +
    "        <div>\n" +
    "          {{descriptionText}}\n" +
    "        </div>\n" +
    "        <div class=\"alert-display\">\n" +
    "            <div ng-repeat=\"operation in operations\">\n" +
    "                <dms-operation-alert\n" +
    "                    dms-operation-model=\"operation\"></dms-operation-alert>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-primary\" ng-click=\"close()\">{{closeButtonText}}</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/alert-display/upload/upload-alert-display-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/modal/alert-display/upload/upload-alert-display-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"close()\">\n" +
    "  <i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\">\n" +
    "    {{title}}\n" +
    "</div>\n" +
    "<div class=\"dms modal-body\">\n" +
    "    <div>\n" +
    "        <div>\n" +
    "          {{descriptionText}}\n" +
    "        </div>\n" +
    "        <div class=\"alert-display\">\n" +
    "            <div ng-repeat=\"upload in uploads\">\n" +
    "                <dms-upload-alert\n" +
    "                    dms-upload-model=\"upload\"></dms-upload-alert>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-primary\" ng-click=\"close()\">{{closeButtonText}}</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/confirmation/confirmation-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/modal/confirmation/confirmation-modal.2js.html",
    "<div class=\"modal-body modal-confirm-body\">\n" +
    "  <i class=\"bento-icon-warning modal-confirm-icon\"></i>\n" +
    "  <span class=\"modal-confirm-message\">\n" +
    "    {{ message }}\n" +
    "  </span>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "  <button bm-focus=\"true\" class=\"btn btn-primary\" ng-click=\"answer(true)\">{{ positiveConfirmation }}</button>\n" +
    "  <button class=\"btn btn-default\" ng-click=\"answer(false)\">{{ negativeConfirmation }}</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/download/download-modal-view.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/modal/download/download-modal-view.2js.html",
    "<div class=\"dms\" id=\"dmsDownloadModal\">\n" +
    "    <div class=\"modal-header\" translate=\"Bluemoon.DMS.Viewer.FileTypeNotPreviewable\">\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <button type=\"button\" class=\"btn btn-primary\" ng-click=\"modalController.downloadDocument()\">\n" +
    "            <span class=\"glyphicon glyphicon-log-out dms-glyphicon\"></span>\n" +
    "            <span translate=\"Bluemoon.DMS.Toolbar.Download\"></span>\n" +
    "        </button>\n" +
    "         <span id=\"download-file-info\">\n" +
    "         	<span class=\"download-modal-tooltip-text\" uib-tooltip=\"{{modalController.documentName}}\" tooltip-append-to-body=\"true\">{{modalController.documentName}}</span>\n" +
    "         	<span id=\"download-file-size\" ng-if=\"modalController.documentSize\">(<span format-size=\"{{modalController.documentSize}}\"></span>)</span>\n" +
    "         </span>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/folder-selection/folder-selection-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/modal/folder-selection/folder-selection-modal.2js.html",
    "<div class=\"dms\">\n" +
    "  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\">\n" +
    "    <i class=\"bento-icon-close-x\"></i>\n" +
    "  </button>\n" +
    "  <div class=\"modal-header\">\n" +
    "     {{title}}\n" +
    "  </div>\n" +
    "  <div class=\"modal-body folder-selection-modal\">\n" +
    "  <alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "    <div class=\"form-group\" ng-class=\"{'has-error': errorText !==''}\">\n" +
    "      <div class=\"form-control\">\n" +
    "        <folder-selector\n" +
    "          load-root-level=\"loadRootLevel(params)\"\n" +
    "          selected-item-changed=\"selectedItemChanged(newlySelectedItem)\"\n" +
    "          current-item-changed=\"currentItemChanged(newCurrentItem)\"\n" +
    "          disabled-items=\"disabledItems\"></folder-selector>\n" +
    "      </div>\n" +
    "      <div class=\"msg\">{{ errorText }}</div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"modal-footer\">\n" +
    "      <button class=\"btn btn-primary\" ng-click=\"select()\" ng-disabled=\"!canSelectItem\">{{ selectButtonText }}</button>\n" +
    "      <button class=\"btn btn-default\" ng-click=\"cancel()\">{{ cancelButtonText }}</button>\n" +
    "      <button class=\"btn btn-default btn-new\" ng-disabled=\"!canAddNewFolder\" ng-click=\"newFolder()\">\n" +
    "        <span class=\"glyphicon glyphicon-plus-sign dms-glyphicon\"></span>{{ newFolderText }}\n" +
    "      </button>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/new-container/new-container-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/modal/new-container/new-container-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancelNewContainer()\">\n" +
    "  <i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\">\n" +
    "    {{headerText}}\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <alert class=\"show-hide\" ng-repeat=\"alert in newContainerData.alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "    <form role=\"form\" class=\"css-form\" name=\"newContainerForm\" ng-submit=\"newContainerRequest()\" novalidate>\n" +
    "        <div class=\"form-group\" ng-class=\"{'has-error': newContainerData.containerNameError !==''}\" ng-if=\"newContainerData.canAdd\">\n" +
    "            <label for=\"containerName\">{{nameText}}*</label>\n" +
    "            <input name=\"containerName\" id=\"containerName\" type=\"text\" class=\"form-control\" ng-model=\"newContainerData.containerName\" maxlength=\"{{ newContainerData.maxContainerNameLength }}\" bm-focus=\"true\" autocomplete=\"off\" />\n" +
    "            <div class=\"templateContainer\" ng-show=\"isAddingProject()\" style=\"padding-top: 15px;\">\n" +
    "                <label for=\"containerName\">{{templateText}}</label>\n" +
    "                <div data-bento-select>\n" +
    "                    <select data-ng-model=\"newContainerData.selectedValue\">\n" +
    "                        <option ng-repeat=\"item in templates\" value=\"{{item.value}}\">{{item.name}}</option>\n" +
    "                    </select>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"msg\">{{ newContainerData.containerNameError }}</div>\n" +
    "        </div>\n" +
    "        <div ng-if=\"newContainerData.canAdd\">\n" +
    "            * {{requiredText}}\n" +
    "        </div>\n" +
    "    </form>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-primary\" ng-click=\"newContainerRequest()\" ng-if=\"newContainerData.canAdd\">{{saveText}}</button>\n" +
    "    <button class=\"btn btn-default\" ng-click=\"cancelNewContainer()\">{{cancelText}}</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/new-document/new-document-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/modal/new-document/new-document-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancelNewDocument()\">\n" +
    "  <i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\">\n" +
    "    {{headerText}}\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <alert class=\"show-hide\" ng-repeat=\"alert in newDocumentData.alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "    <form role=\"form\" class=\"css-form\" name=\"newDocumentForm\" ng-submit=\"newDocumentRequest()\" novalidate>\n" +
    "        <div class=\"form-group\" ng-class=\"{'has-error': newDocumentData.documentNameError !==''}\" ng-if=\"newDocumentData.canAdd\">\n" +
    "            <div>\n" +
    "                <label for=\"documentName\">{{nameText}}*</label>\n" +
    "                <div class=\"form-control new-document-bordered-div\">\n" +
    "                    <input name=\"documentName\" maxlength=\"255\" id=\"documentName\" type=\"text\" class=\"new-document-input-no-border\" ng-model=\"newDocumentData.documentName\" bm-focus=\"true\" autocomplete=\"off\" />\n" +
    "                    <div class=\"new-document-extension-padding\">{{documentType()}}</div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"msg\">{{ newDocumentData.documentNameError }}</div>\n" +
    "        </div>\n" +
    "        <div ng-if=\"newDocumentData.canAdd\" class=\"newDocReqText\">\n" +
    "            * {{requiredText}}\n" +
    "        </div>\n" +
    "    </form>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-primary\" ng-click=\"newDocumentRequest()\" ng-if=\"newDocumentData.canAdd\">{{saveText}}</button>\n" +
    "    <button class=\"btn btn-default\" ng-click=\"cancelNewDocument()\">{{cancelText}}</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/send-items/send-items-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/modal/send-items/send-items-modal.2js.html",
    "<div class=\"dms\" id=\"dmsSendItemsModal\">\n" +
    "    <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"modalController.cancel()\">\n" +
    "      <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"modal-header\" translate=\"Bluemoon.DMS.Modal.SendItems.Send\"></div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <form name=\"form\" id=\"form\" novalidate>\n" +
    "\n" +
    "            <div class=\"form-group\" ng-class=\"{'has-error': (form.$submitted || form.to.$dirty) && form.to.$invalid }\">\n" +
    "                <label class=\"required\" for=\"to\"\n" +
    "                    translate=\"Bluemoon.DMS.Modal.SendItems.SendTo\" />\n" +
    "                <dms-send-items-modal-send-to\n" +
    "                    name=\"to\"\n" +
    "                    required=\"true\"\n" +
    "                    recipients=\"modalController.recipients\"></dms-send-items-modal-send-to>\n" +
    "                <div>\n" +
    "                    <span class=\"msg\" ng-show=\"form.to.$error.required\"\n" +
    "                        translate=\"Bluemoon.DMS.Modal.SendItems.RecipientListRequired\" />\n" +
    "                    <span class=\"msg\" ng-show=\"form.to.$error.recipients\"\n" +
    "                        translate=\"Bluemoon.DMS.Modal.SendItems.RecipientListNotValid\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"form-group\">\n" +
    "                <label class=\"required\" for=\"expires\"\n" +
    "                    translate=\"Bluemoon.DMS.Modal.SendItems.Expires\" />\n" +
    "                <div bento-select>\n" +
    "                    <select\n" +
    "                        ng-model=\"modalController.expiration\"\n" +
    "                        ng-options=\"expirationValue as expirationValue.label for expirationValue in modalController.expirationValues\">\n" +
    "                    </select>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"form-group\" ng-if=\"modalController.languageList.length > 1\">\n" +
    "                <label for=\"language\"><span translate=\"Bluemoon.DMS.Modal.SendItems.LanguageLabel\"></span>*</label>\n" +
    "                <bm-language-select name=\"language\" selected-language-code=\"modalController.languageCode\" include-empty-option=\"false\" selection-required=\"true\"></bm-language-select>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"form-group\">\n" +
    "                <label for=\"files\"\n" +
    "                    translate=\"Bluemoon.DMS.Modal.SendItems.Files\" />\n" +
    "                <ul>\n" +
    "                     <li ng-repeat=\"item in modalController.items\">{{item.name}}</li>\n" +
    "                 </ul>\n" +
    "            </div>\n" +
    "        </form>\n" +
    "\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-primary\" type=\"submit\" form=\"form\" ng-click=\"(form.$submitted=true) && form.$valid && modalController.send()\" translate=\"Bluemoon.DMS.Modal.SendItems.Send\"></button>\n" +
    "        <button class=\"btn btn-default\" ng-click=\"modalController.cancel()\" translate=\"Bluemoon.DMS.Modal.SendItems.Cancel\"></button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.models', []);
})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.models')

    .factory('ResponseData', [
        function(){
            return function(status, httpStatusCode, data, message, httpResponse){
                this.status = status;
                this.httpStatusCode = httpStatusCode;

                if (angular.isUndefined(data) || data === null)
                {
                    this.data = null;
                }else
                {
                    if (angular.isUndefined(data.error))
                    {
                        var rtnData = angular.isUndefined(data.data) ? data : data.data;
                        var rtnDataItems = angular.isUndefined(rtnData.items) ? rtnData : rtnData.items;
                        this.currentItemCount = rtnData.currentItemCount;
                        this.itemsPerPage = rtnData.itemsPerPage;
                        this.startIndex = rtnData.startIndex;
                        this.totalItems = rtnData.totalItems;
                        this.pageIndex = rtnData.pageIndex;
                        this.totalPages = rtnData.totalPages;
                        this.data = rtnDataItems;
                        this.message = message;
                        this.$httpResponse = httpResponse;
                    } else {
                        this.error = data.error;
                    }
                }
            };
        }
    ]);
})(window.angular);

(function(angular){
    'use strict';

    var DmsFolder = (function(){
        var _$inject = [];

        function DmsFolderImpl() {
            return function(name, id, parentId, parentType, documentCount, subContainers){
                this.name = name;
                this.id = id;
                this.parentId = parentId;
                this.parentType = parentType;
                this.documentCount = documentCount;
                this.subContainers = subContainers;
                this.itemType = 'Folder';
                this.containerType = 'folders';
            };
        }

        DmsFolderImpl.$inject = _$inject;
        return DmsFolderImpl;
    }());

    angular.module('bluemoon.dms.models')

    .factory('DmsFolderModel', DmsFolder)

    //TODO: Deprecate
    .factory('Folder', DmsFolder);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.models')

    .factory('DmsAlertModel', [
        function() {
            return function(alertData){
                if (!alertData) {
                    return;
                }

                this.id = alertData.id;
                this.type = alertData.type;
                this.msg = alertData.message;
                this.progressive = alertData.progressive;
                this.progressPercentage = alertData.progressPercentage;
                this.status = alertData.status;
                this.statement = alertData.statement;
                this.showStatement = alertData.showStatement;
            };
        }
    ])

    .factory('DmsUploadAlertModel', ['DmsAlertModel',
        function(DmsAlertModel) {

            var DmsUploadAlertModel = function(alertData){
                if (alertData){
                    this.upload = alertData.upload;
                    this.id = alertData.id;
                }
            };

            DmsUploadAlertModel.prototype = new DmsAlertModel({
                id: -1,
                type: 'dms-upload',
                message: '',
                progressive: true,
                progressPercentage: 0,
                status: '',
                statement: '',
                showStatement: false,
            });

            return DmsUploadAlertModel;
        }
    ])

    .factory('DmsUploadAlertCollectionModel', ['DmsAlertModel',
        function(DmsAlertModel) {

            var DmsUploadAlertCollectionModel = function(alertData){
                if (alertData){
                    this.id = alertData.id;
                }
            };

            DmsUploadAlertCollectionModel.prototype = new DmsAlertModel({
                id: -1,
                type: 'dms-upload-collection',
                message: '',
                progressive: true,
                progressPercentage: 0,
                status: '',
                statement: '',
                showStatement: false,
            });

            return DmsUploadAlertCollectionModel;
        }
    ])

    .factory('DmsAlertCollectionModel', ['dmsAlertService',
        function(dmsAlertService) {
            return function(){
                this._collection = [];
                this.length = 0;

                this.getCollection = function() {
                    return this._collection;
                };

                this.add = function(alert) {
                    this._collection.push(alert);
                    this.length++;
                };

                this.remove = function(alert) {
                    dmsAlertService.removeAlert(this._collection, alert);
                    this.length--;
                };

                this.removeWhere = function(predicate) {
                    dmsAlertService.removeAlertWhere(this._collection, predicate);
                    this.length = this._collection.length;
                };

                this.first = function() {
                    return this._collection.length > 0 ? this._collection[0] : undefined;
                };

                this.clear = function() {
                    this._collection.length = 0;
                    this.length = 0;
                };
            };
        }
    ])

    .factory('DmsOperationAlertModel', ['DmsAlertModel',
        function(DmsAlertModel) {

            var DmsOperationAlertModel = function(alertData){
                if (alertData){
                    this.operation = alertData.operation;
                    this.id = alertData.id;
                }
            };

            DmsOperationAlertModel.prototype = new DmsAlertModel({
                id: -1,
                type: 'dms-operation',
                message: '',
                progressive: false,
                progressPercentage: 0,
                status: '',
                statement: '',
                showStatement: false,
            });

            return DmsOperationAlertModel;
        }
    ])

    .factory('DmsOperationCollectionAlertModel', ['DmsAlertModel',
        function(DmsAlertModel) {

            var DmsOperationCollectionAlertModel = function(alertData){
                if (alertData){
                    this.id = alertData.id;
                }
            };

            DmsOperationCollectionAlertModel.prototype = new DmsAlertModel({
                id: -1,
                type: 'dms-operation-collection',
                message: '',
                progressive: true,
                progressPercentage: 0,
                status: '',
                statement: '',
                showStatement: false,
            });

            return DmsOperationCollectionAlertModel;
        }
    ]);

})(window.angular);

(function(angular){
    'use strict';

    var DmsProjectModel = (function(){
        var _$inject = [];

        function DmsProjectModelImpl() {
            return function(id, name, productType, primaryAssociationId, primaryAssociationType, processingYear, processingPeriod){
                this.id = id;
                this.name = name;
                this.productType = productType;
                this.primaryAssociationId = primaryAssociationId;
                this.primaryAssociationType = primaryAssociationType;
                this.processingYear = processingYear;
                this.processingPeriod = processingPeriod;
                this.itemType = 'Project';
                this.containerType = 'projects';
            };
        }

        DmsProjectModelImpl.$inject = _$inject;
        return DmsProjectModelImpl;
    }());

    angular.module('bluemoon.dms.models')

    .factory('DmsProjectModel', DmsProjectModel)

    //TODO: Deprecate
    .factory('Project', DmsProjectModel);

})(window.angular);

(function(angular, _){
    'use strict';

    angular.module('bluemoon.dms.models')

    .factory('DmsApiOperationModel', [
        function() {
            return function(type, operationData, promise){
                this.id = -1;
                this.type = type;
                this.operationData = operationData;
                this.status = undefined;
                this.promise = promise;
            };
        }
    ])

    .factory('DmsApiOperationCollectionModel', [
        function() {
            return function(){
                var _this = this;
                _this._collection = [];
                _this.length = 0;

                _this.getCollection = function() {
                    return _this._collection;
                };

                _this.addCollection = function(operationCollection) {
                    _.each(operationCollection, function(operation) {
                        _this.add(operation);
                    });
                };

                _this.add = function(operation) {
                    _this._collection.push(operation);
                    _this.length++;
                };

                this.remove = function(toRemove) {
                    for(var i = 0; i < _this._collection.length; i++) {
                        if (_this._collection[i].id === toRemove.id) {
                            _this._collection.splice(i, 1);
                            _this.length--;
                            break;
                        }
                    }
                };

                this.removeWhere = function(predicate) {
                    for(var i = 0; i < _this._collection.length; i++) {
                        if (predicate(_this._collection[i])) {
                            _this._collection.splice(i, 1);
                            i--;
                        }
                    }
                    _this.length = _this._collection.length;
                };

                _this.first = function() {
                    return _this._collection.length > 0 ? _this._collection[0] : undefined;
                };

                _this.clear = function() {
                    _this._collection.length = 0;
                    _this.length = 0;
                };
            };
        }
    ]);

})(window.angular, window._);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.models')

    .factory('DmsGridPageState', [
        function() {
            return function(options){

                var defaultOptions = {
                    page: 1,
                    itemsPerPage: 25,
                };

                var _options = angular.extend({}, defaultOptions, options);

                if (!_options.page || !angular.isNumber(_options.page) || _options.page <= 0) {
                    throw new Error('page must be provided and > 0');
                } else if (!_options.sort || _options.sort === '') {
                    throw new Error('sort must be provided.');
                }

                this.page = _options.page;
                this.totalItems = 0;
                this.itemsPerPage = _options.itemsPerPage;
                this.sort = _options.sort;
            };
        }
    ]);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.models')

    .factory('DmsGridItemsFunctionResult', [
        function() {
            return function(page, items, itemsPerPage, totalItems, totalPages, startIndex){
                this.page = page;
                this.items = items;
                this.itemsPerPage = itemsPerPage;
                this.totalItems = totalItems;
                this.totalPages = totalPages;
                this.startIndex = startIndex;
            };
        }
    ]);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.models')

    .factory('DmsDocumentsConstraints', ['$window',
        function($window) {

            var _ = $window._;

            var convertToLower = function(s) {
                return s.toLowerCase();
            };

            return function(constraints){

                var overwritableProperties = {
                    maxUploadSize: 0,
                    maxConvertedSize: 0,
                    minUploadSize: 0,
                    convertedTypes: [],
                    unconvertedTypes: [],
                };

                var initialValues = angular.extend({}, overwritableProperties, constraints);

                for (var property in overwritableProperties) {
                    this[property] = initialValues[property];
                }

                this.convertedTypes = _.map(this.convertedTypes, convertToLower);
                this.unconvertedTypes = _.map(this.unconvertedTypes, convertToLower);
                this.allowedTypes = _.union(this.convertedTypes, this.unconvertedTypes);
            };
        }
    ]);

})(window.angular);

(function(angular, _){
    'use strict';

    var DmsNavBreadcrumbConfig = (function(){
        function DmsNavBreadcrumbConfigImpl() {

            var provider = this;

            provider.itemHref = [function() {
                return function() { return ''; };
            }];

            provider.itemClickable = [function() {
                return function() { return true; };
            }];

            provider.itemClick = null;/*[function() {
                return angular.noop;
            }];*/

            provider.pathLoaded = [function() {
                return angular.noop;
            }];

            provider.$get = function() {
                return provider;
            };
        }

        return DmsNavBreadcrumbConfigImpl;
    })(window.angular);

    var DmsNavBreadcrumbItemDirective = (function(){

        var _$inject = ['$compile','dmsIconService','bmUtil'];

        function DmsNavBreadcrumbItemDirectiveImpl($compile,dmsIconService,bmUtil) {

            function generateItemElement(newItem, click, dragleave, style) {
                if (newItem) {
                    var newItemElement;
                    if(newItem.clickable !== false && newItem.dropTarget === true) {
                        newItemElement = angular.element('<a></a>');
                        if(newItem.lock === undefined || (newItem.lock && newItem.lock.resourceRestrictions.indexOf('CREATE_SUB_RESOURCE') < 0)) {
                            newItemElement = newItemElement
                            .attr('dms-drag-over-class', 'over-crumb')
                            .attr('dms-drag-over', '')
                            .attr('dms-move', '')
                            .attr('dms-drop', '');
                        }
                        newItemElement = newItemElement
                        .attr('dms-drag-leave', dragleave)
                        .attr('dms-item', angular.toJson(newItem.container))
                        .attr('style', style)
                        .text(bmUtil.decodeHtmlEntities(newItem.text));

                        if (newItem.href) {
                            newItemElement.attr('href', newItem.href);
                        } else {
                            newItemElement.attr('ng-click', 'clickFn($event)');
                        }

                    } else if(newItem.clickable !== false && newItem.dropTarget !== true) {
                        newItemElement = angular.element('<a></a>')
                            .attr('dms-drag-leave', dragleave)
                            .attr('style', style)
                            .text(bmUtil.decodeHtmlEntities(newItem.text));

                            if (newItem.href) {
                                newItemElement.attr('href', newItem.href);
                            } else {
                                newItemElement.attr('ng-click', 'clickFn($event)');
                            }

                    } else if(newItem.clickable === false) {
                        newItemElement = angular.element('<span></span>')
                            .attr('dms-drag-leave', dragleave)
                            .attr('style', style)
                            .text(bmUtil.decodeHtmlEntities(newItem.text));
                    }
                    if (newItem.lock) {
                        newItemElement.append('<span class="bento-icon-lock dms-lock-icon" uib-tooltip="{{\'Bluemoon.DMS.Common.Locked\' | translate}}" tooltip-placement="top" tooltip-append-to-body="true"></span>');
                    }
                    return newItemElement;
                }
            }

            function link(scope, element, attr){

                function updateElement() {
                    var newItemElement = generateItemElement(scope.targetItem, scope.targetClick, scope.targetDragleave, scope.targetStyle);
                    element.html($compile(newItemElement)(scope));
                }

                scope.$watch('item', function(){
                    if(scope.item) {
                        scope.targetItem = scope.item;
                        updateElement();
                    }
                });

                scope.$watch('dmsNavBreadcrumbItem', function(){
                    if(scope.dmsNavBreadcrumbItem) {
                        scope.targetItem = scope.dmsNavBreadcrumbItem;
                        updateElement();
                    }
                });

                scope.$watch('style', function(){
                    if(scope.item) {
                        scope.targetStyle = scope.style;
                        updateElement();
                    }
                });

                scope.$watch('dmsNavBreadcrumbItemStyle', function(){
                    if(scope.dmsNavBreadcrumbItem) {
                        scope.targetStyle = scope.dmsNavBreadcrumbItemStyle;
                        updateElement();
                    }
                });

                scope.$watch('dragleave', function(){
                    if(scope.item) {
                        scope.targetDragleave = scope.dragleave;
                        updateElement();
                    }
                });

                scope.$watch('dmsNavBreadcrumbItemDragleave', function(){
                    if(scope.dmsNavBreadcrumbItem) {
                        scope.targetDragleave = scope.dmsNavBreadcrumbItemDragleave;
                        updateElement();
                    }
                });

                attr.$observe('click', function(val){
                    if (val) {
                        scope.targetClick = scope.click;
                        updateElement();
                    }
                });

                attr.$observe('dmsNavBreadcrumbItemClick', function(val){
                    if (val) {
                        scope.targetClick = scope.dmsNavBreadcrumbItemClick;
                        updateElement();
                    }
                });

                scope.clickFn = function($event){
                    if (scope.targetClick && scope.targetItem) {
                        scope.targetClick({ item: scope.targetItem, $event: $event });
                    }
                };
            }

            return {
                restrict: 'EA',
                replace: true,
                scope: {
                    item: '=',
                    dragleave: '@',
                    style: '@',
                    click: '&',
                    dmsNavBreadcrumbItem: '=',
                    dmsNavBreadcrumbItemDragleave: '@',
                    dmsNavBreadcrumbItemStyle: '@',
                    dmsNavBreadcrumbItemClick: '&',
                },
                link: link
            };
        }

        DmsNavBreadcrumbItemDirectiveImpl.$inject = _$inject;
        return DmsNavBreadcrumbItemDirectiveImpl;
    })(window.angular);

    var DmsNavBreadcrumbDirective = (function() {
        var _$inject = ['$document', '$injector', '$q', '$translate', 'dmsNavBreadcrumbConfig', 'dmsClientService', 'dmsProjectService', 'dmsFolderService', 'dmsFolderI18n'];

        function DmsNavBreadcrumbDirectiveImpl($document, $injector, $q, $translate, navBreadcrumbConfig, clientService, projectService, folderService, folderI18n){

            function link(scope, element, attr) {

                var callbacks = {};

                if (attr.itemHrefCallback) {
                    callbacks.itemHref = scope.itemHrefCallback;
                }

                if (attr.itemClickableCallback) {
                    callbacks.itemClickable = scope.itemClickableCallback;
                }

                if (attr.itemClickCallback) {
                    callbacks.itemClick = scope.itemClickCallback;
                }

                if (attr.pathLoadedCallback) {
                    callbacks.pathLoaded = scope.pathLoadedCallback;
                }

                function isRootContainer(item) {
                    return item.id === scope.rootContainerId &&
                        item.itemType === scope.rootContainerType;
                }

                function setItemHref(item) {
                    if (callbacks.itemHref) {
                        item.href = callbacks.itemHref({ item: item });
                    } else if(navBreadcrumbConfig.itemHref) {
                        item.href = $injector.invoke(navBreadcrumbConfig.itemHref)(item);
                    } else {
                        item.href = '';
                    }
                }

                function setItemClickable(item, currentContainer) {
                    if (callbacks.itemClickable) {
                        item.clickable = callbacks.itemClickable({
                            item: item,
                            currentContainer: currentContainer
                        });
                    } else if(navBreadcrumbConfig.itemClickable) {
                        item.clickable = $injector.invoke(navBreadcrumbConfig.itemClickable)(item, currentContainer);
                    } else {
                        item.clickable = true;
                    }
                }

                function createFirmPath(itemId) {
                    if (itemId === 'Templates') {
                        return $translate('Bluemoon.DMS.SpecialFolders.Templates').then(function(s){
                            var item = {
                                container: {
                                    id: 'Templates',
                                    name: s,
                                    isTemplateBranch: true,
                                    itemType: 'TemplateRoot'
                                },
                                icon: 'templates',
                                text: s
                            };

                            var path = [item];

                            return path;
                        });
                    }
                }

                function createClientRootPath() {
                    return $translate('Bluemoon.DMS.SpecialFolders.Clients').then(function(s){
                        var item = {
                            container: {
                                id: 'Client',
                                name: s,
                                isClientBranch: true,
                                itemType: 'ClientRoot'
                            },
                            icon: 'client',
                            text: s,
                        };
                        return [item];
                    });
                }

                function createClientPath(clientId) {
                    return clientService.get(clientId).then(function(result){
                        var path = [];

                        var storageLabelPromise = $translate('Bluemoon.DMS.Breadcrumbs.StorageLabel', {
                            clientName: result.data.name,
                            clientCode: result.data.code
                        });

                        var clientPromise;
                        if (!isRootContainer({ id: clientId, itemType: 'Client'})) {
                            clientPromise = createClientRootPath().then(function(clientRootPath){
                                path = clientRootPath;
                                return storageLabelPromise;
                            });
                        } else {
                            clientPromise = storageLabelPromise;
                        }

                        return clientPromise.then(function(s){

                            var item = {
                                container: result.data,
                                icon: 'folder',
                                text: s,
                            };

                            path.push(item);

                            return path;
                        });
                    });
                }

                function createProjectPath(projectId, currentContainer) {
                    return projectService.get(projectId).then(function(result){
                        var rootItemPromise;
                        if (isRootContainer({id: projectId, itemType: 'Project' })) {
                            rootItemPromise = $q.when([]);
                        } else if (result.data.primaryAssociationType === 'Client') {
                            rootItemPromise = createClientPath(result.data.primaryAssociationId, currentContainer);
                        } else if (result.data.primaryAssociationType === 'Firm') {
                            rootItemPromise = createFirmPath(result.data.primaryAssociationId, currentContainer);
                        }

                        return rootItemPromise.then(function(path){
                            var item = {
                                container: result.data,
                                dropTarget: true,
                                icon: getContainerIconType(result.data),
                                text: result.data.name,
                                lock: result.data.lock,
                            };

                            path.push(item);
                            return path;
                        });
                    });
                }

                function getContainerIconType(container){
                    if (container.isShared) {
                        return 'shared-folder';
                    } else if (!angular.isUndefined(container.type) && !angular.isUndefined(container.rootType) && container.type === container.rootType) {
                        return container.type;
                    } else {
                        return 'folder';
                    }
                }

                function createFolderAndAddToPath(folder, path) {
                    var item = {
                        container: folder,
                        dropTarget: true,
                        icon: getContainerIconType(folder),
                        lock: folder.lock,
                    };

                    path.unshift(item);

                    return folderI18n.translate(folder).then(function(translatedFolder){
                        item.text = translatedFolder.name;
                        item.container.name = translatedFolder.name;
                    });
                }

                function createFolderPath(folderId, currentContainer) {
                    return folderService.getAncestors(folderId).then(function(result){
                        var folderCreatedPromises = [], it = result.data, path = [];
                        do {
                            folderCreatedPromises.push(createFolderAndAddToPath(it, path, currentContainer));
                        } while(!isRootContainer(it) && (it = it.parentItem) && it.itemType === 'Folder');

                        return $q.all(folderCreatedPromises).then(function(){
                            if (it && it.itemType === 'Project') {
                                return createProjectPath(it.id, currentContainer).then(function(projectPath){
                                    return projectPath.concat(path);
                                });
                            } else {
                                // this is specific to client center to add the root folder (i.e. "Documents")
                                var item = {
                                    container: {
                                        id: 'Client',
                                        name: '',
                                        isClientBranch: false,
                                        itemType: 'ClientRoot'
                                    },
                                    icon: 'folder',
                                    text: '',
                                };
                                $translate('Bluemoon.DMS.Breadcrumb.Documents').then(function(s){
                                    item.text = s;
                                    item.container.name = s;
                                });
                                path.unshift(item);
                            }

                            return path;
                        });
                    });
                }

                function itemCallbacks(path, currentContainer) {
                    path.forEach(function(item){
                        setItemClickable(item, currentContainer);
                        if (!item.icon){
                            item.icon = getContainerIconType(currentContainer);
                        }

                        if(item.clickable) {
                            setItemHref(item);
                        }
                    });

                    if (callbacks.pathLoaded) {
                        callbacks.pathLoaded({path: path, container: currentContainer});
                    } else if(navBreadcrumbConfig.pathLoaded) {
                        $injector.invoke(navBreadcrumbConfig.pathLoaded)(path, currentContainer);
                    }
                }

                scope.checkTooltip = function() {
                    if(scope.useTooltip){
                        return scope.useTooltip;
                    }

                    return false;
                };

                scope.setTooltipPath = function() {
                    var toolTipPath = null;
                    if(scope.path && scope.path.length > 0) {
                        toolTipPath = scope.path[0].text;
                        for(var i = 1; i < scope.path.length; ++i){
                            toolTipPath += ' > ' + scope.path[i].text;
                        }
                    }

                    return toolTipPath;
                };

                function removeUnsharedPath(pathInput){

                    pathInput = _.filter(pathInput, function(pathItem){
                        return pathItem.container.itemType === 'ClientRoot' ||
                        pathItem.container.itemType === 'Client' ||
                        (pathItem.container.isShared && pathItem.container.isShared === true);
                    });

                    return pathInput;
                }

                scope.$watchGroup(['containerType', 'containerId', 'rootContainerType', 'rootContainerId'], function(){

                    var currentContainer = {
                        id: scope.containerId,
                        type: scope.containerType
                    };

                    var SUPPORTED_CONTAINER_TYPES = ['ClientRoot', 'Client', 'Project', 'Firm', 'TemplateRoot', 'Folder'];

                    if(scope.containerType && scope.containerId && SUPPORTED_CONTAINER_TYPES.indexOf(scope.containerType) > -1) {
                        if (scope.containerType === 'ClientRoot') {
                            scope.loadStatus = 'loading';
                            createClientRootPath().then(function(path){
                                scope.path = path;
                                scope.loadStatus = 'loaded';

                                itemCallbacks(scope.path, currentContainer);
                            });
                        } else if (scope.containerType === 'Client') {
                            scope.loadStatus = 'loading';
                            createClientPath(scope.containerId, currentContainer).then(function(path){
                                scope.path = path;
                                scope.loadStatus = 'loaded';

                                itemCallbacks(scope.path, currentContainer);
                            });
                        } else if (scope.containerType === 'Project') {
                            scope.loadStatus = 'loading';
                            createProjectPath(scope.containerId, currentContainer).then(function(path){
                                scope.path = path;
                                scope.loadStatus = 'loaded';

                                itemCallbacks(scope.path, currentContainer);
                            });
                        } else if (scope.containerType === 'Firm' || scope.containerType === 'TemplateRoot') {
                            scope.loadStatus = 'loading';
                            createFirmPath(scope.containerId, currentContainer).then(function(path){
                                scope.path = path;
                                scope.loadStatus = 'loaded';

                                itemCallbacks(scope.path, currentContainer);
                            });
                        } else if (scope.containerType === 'Folder') {
                            scope.loadStatus = 'loading';
                            createFolderPath(scope.containerId, currentContainer).then(function(path){
                                scope.path = removeUnsharedPath(path);
                                //scope.path = path;
                                scope.loadStatus = 'loaded';

                                itemCallbacks(scope.path, currentContainer);
                            });
                        }
                    } else {
                        scope.loadStatus = 'loading';
                        scope.path = [];
                        scope.loadStatus = 'loaded';

                        itemCallbacks(scope.path, currentContainer);
                    }
                });

                scope.collapsedElements = function() {
                    if (!scope.path || (!scope.collapseLength && scope.collapseLength !== '0')) {
                        return [];
                    }

                    return scope.path.slice(0, Math.max(0, scope.path.length - scope.collapseLength));
                };

                scope.collapsedElementsLength = function() {
                    return scope.collapsedElements().length;
                };

                scope.nonCollapsedElements = function() {
                    if (!scope.path) {
                        return [];
                    }

                    if (!scope.collapseLength && scope.collapseLength !== '0') {
                        return scope.path;
                    }

                    return scope.path.slice(Math.max(0, scope.path.length - scope.collapseLength));
                };

                scope.dropdown = {
                    isOpen: false
                };

                scope.closeDropdown = function(){
                    scope.dropdown.isOpen = false;
                };

                scope.openDropdown = function(){
                    scope.dropdown.isOpen = true;
                };

                scope.dragOver = function($event){
                    var currentTarget = $event.currentTarget;
                    if(currentTarget){
                        var element = angular.element(currentTarget);
                        if (element.hasClass('collapse-container') || element.parents('.collapse-container').length > 0) {
                            scope.dropdown.isOpen = true;
                        }
                    }
                };

                scope.dragLeave = function($event){
                    var elementAtPoint = $document[0].elementFromPoint($event.pageX, $event.pageY);
                    if(elementAtPoint){
                        var element = angular.element(elementAtPoint);
                        if (!element.hasClass('collapse-container') && element.parents('.collapse-container').length === 0) {
                            scope.dropdown.isOpen = false;
                        }
                    }
                };

                scope.getPadding = function(index){
                    var PADDING_MULTIPLIER = 20;
                    //Initial padding is 20px, so anything after that shound be +20.
                    var padding = PADDING_MULTIPLIER * (index + 1);
                    return 'padding-left: ' + padding + 'px;';
                };

                if (callbacks.itemClick || navBreadcrumbConfig.itemClick) {
                    scope.itemClickCallbackFn = function(item, $event){
                        if (callbacks.itemClick) {
                            callbacks.itemClick({ item: item, $event: $event });
                        } else if(navBreadcrumbConfig.itemClick) {
                            $injector.invoke(navBreadcrumbConfig.itemClick)(item, $event);
                        }
                    };
                }
            }

            return {
                restrict: 'EA',
                replace: true,
                scope: {
                    containerType: '@',
                    containerId: '@',
                    rootContainerType: '@',
                    rootContainerId: '@',
                    collapseLength: '@',
                    itemClickCallback: '&',
                    itemClickableCallback: '&',
                    itemHrefCallback: '&',
                    pathLoadedCallback: '&',
                    useTooltip: '='
                },
                templateUrl: 'components/nav-breadcrumb/nav-breadcrumb.2js.html',
                link: link
            };
        }

        DmsNavBreadcrumbDirectiveImpl.$inject = _$inject;
        return DmsNavBreadcrumbDirectiveImpl;
    })();

    angular.module('bluemoon.dms.nav-breadcrumb.templates', []);

    angular.module('bluemoon.dms.nav-breadcrumb', [
        'pascalprecht.translate',
        'bluemoon.dms.nav-breadcrumb.templates',
        'bluemoon.dms.icon',
        'bluemoon.dms.services',
        'bluemoon.dms.i18n',
    ])

    .provider('dmsNavBreadcrumbConfig', DmsNavBreadcrumbConfig)
    .directive('dmsNavBreadcrumbItem', DmsNavBreadcrumbItemDirective)
    .directive('dmsNavBreadcrumb', DmsNavBreadcrumbDirective);

})(window.angular, window._);

angular.module('bluemoon.dms.nav-breadcrumb.templates', ['components/nav-breadcrumb/nav-breadcrumb.2js.html']);

angular.module("components/nav-breadcrumb/nav-breadcrumb.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/nav-breadcrumb/nav-breadcrumb.2js.html",
    "<div class=\"dms dms-nav-breadcrumb\" uib-tooltip=\"{{setTooltipPath()}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"checkTooltip()\">\n" +
    "    <ol class=\"breadcrumb small-breadcrumb\">\n" +
    "        <li ng-if=\"path.length == 0\">\n" +
    "            <span></span>\n" +
    "        </li>\n" +
    "        <li class=\"collapse-container\" ng-if-start=\"collapsedElementsLength() > 0\">\n" +
    "            <span uib-dropdown\n" +
    "                class=\"dropdown dropdown-menu-left drop-crumb\"\n" +
    "                ng-mouseenter=\"openDropdown()\"\n" +
    "                dms-drag-over=\"dragOver($event)\"\n" +
    "                dms-drag-leave=\"dragLeave($event)\"\n" +
    "                is-open=\"dropdown.isOpen\">\n" +
    "                <i class=\"glyphicon bento-icon-folder-open glyphicon-breadcrumb drop-crumb\"></i>\n" +
    "                <ul class=\"dropdown-menu drop-crumb\" ng-mouseleave=\"closeDropdown()\" dms-drag-leave=\"dragLeave($event)\">\n" +
    "                    <li class=\"dms-nav-breadcrumb-item collapsed-item\"\n" +
    "                        ng-repeat=\"item in collapsedElements()\"\n" +
    "                        dms-nav-breadcrumb-item=\"item\"\n" +
    "                        dms-nav-breadcrumb-item-dragleave=\"dragLeave($event)\"\n" +
    "                        dms-nav-breadcrumb-item-click=\"itemClickCallbackFn(item, $event)\"\n" +
    "                        dms-nav-breadcrumb-item-style=\"{{getPadding($index)}}\">\n" +
    "                    </li>\n" +
    "                </ul>\n" +
    "            </span>\n" +
    "        </li>\n" +
    "        <li ng-if-end class=\"collapsed-breadcrumb-separator\"></li>\n" +
    "        <li class=\"dms-nav-breadcrumb-item non-collapsed-item\"\n" +
    "            ng-repeat-start=\"item in nonCollapsedElements()\"\n" +
    "            dms-nav-breadcrumb-item=\"item\"\n" +
    "            dms-nav-breadcrumb-item-dragleave=\"dragLeave($event)\"\n" +
    "            dms-nav-breadcrumb-item-click=\"itemClickCallbackFn(item, $event)\">\n" +
    "        </li>\n" +
    "        <span ng-if=\"!$last\" ng-repeat-end></span>\n" +
    "    </ol>\n" +
    "</div>\n" +
    "");
}]);

(function(angular) {
    'use strict';

    var DmsRecentsGridConfig = (function(){

        function DmsRecentsGridConfig(){
            var provider = this;

            provider.itemHref = [function(){
                return function() { return ''; };
            }];

            provider.$get = function() {
                return provider;
            };
        }

        return DmsRecentsGridConfig;
    })(window.angular);

    var DmsRecentsGridControlFactory = (function(){

        var _$inject = ['$q', '$translate', '$filter', 'dmsFolderI18n', 'dmsItemUiService'];

        function DmsRecentsGridControlFactoryImpl($q, $translate, $filter, dmsFolderI18n, dmsItemUiService){

            var getFileExtension = function(docName){
                var loc = docName.lastIndexOf('.');
                return docName.substring(loc + 1).toLowerCase();
            };

            var buildPath = function(item){
                var res = '';

                if (!!item.container.containerPath[0] && item.container.containerPath[0].containerType.toLowerCase() === 'projects'){
                    res += item.container.containerPath[0].primaryAssociationName + '/';
                }

                for (var i = 0; i < item.container.containerPath.length; i++){
                    res += item.container.containerPath[i].name;
                    if (i !== item.container.containerPath.length - 1){
                        res += '/';
                    }
                }

                return res;
            };

            var buildRecyclePath = function(){
                return $translate('Bluemoon.DMS.SpecialFolders.RecycleBin');
            };

            var translateFolderNames = function(item){
                var deferred = $q.defer();
                var promiseArr = [];

                for (var i = 0; i < item.container.containerPath.length; i++){
                    if (item.container.containerPath[i].primaryAssociationId !== 'firm'){
                        promiseArr.push(dmsFolderI18n.translate(item.container.containerPath[i]));
                    } else {
                        promiseArr.push($translate('Bluemoon.DMS.SpecialFolders.Templates'));
                    }
                }

                $q.all(promiseArr).then(function(res){
                    for (var i = 0; i < item.container.containerPath.length; i++){
                        //NOTE: We're shortcutting BuildPath here by assigning Templates' primaryAssociationName to a translated form of 'Templates'
                        if (item.container.containerPath[i].primaryAssociationId !== 'firm'){
                            item.container.containerPath[i] = res[i];
                        } else {
                            item.container.containerPath[i].primaryAssociationName = res[i];
                        }
                    }
                    deferred.resolve(item);
                });
                return deferred.promise;
            };

            //NOTE: potentially expandable into other values for activites
            var translateActivity = function(item){

                if (item.container.containerType === 'trash'){
                    return $translate('Bluemoon.DMS.Grid.Recents.Deleted');
                }

                if (item.edit === true){
                    return $translate('Bluemoon.DMS.Grid.Recents.AddedOrModified');
                } else {
                    return $translate('Bluemoon.DMS.Grid.Recents.Viewed');
                }
            };

            var buildExtraItemInformation = function(scope, item){
                var deferred = $q.defer();

                var promiseArr = [];
                var itemArr = [];

                var isInTrash = item.container.containerType.toLowerCase() === 'trash' ||
                                (!!item.container.containerPath[0] && !!item.container.containerPath[0].id &&
                                   item.container.containerPath[0].id.toLowerCase() === 'trash');
                var isInTemplates = (!!item.container.containerPath[0] && !!item.container.containerPath[0].primaryAssociationId &&
                                       item.container.containerPath[0].primaryAssociationId.toLowerCase() === 'templates');

                if (isInTrash){
                    item.container.itemType = 'trash';
                    item.container.containerType = 'trash';
                    itemArr.push(item.container);
                    item.container.containerPath = [item.container];
                } else if (isInTemplates){
                    //Normalize the containerPath so that DmsRouteBuilder can handle it properly.
                    item.container.containerPath[0].primaryAssociationId = 'firm';
                    angular.copy(item.container.containerPath, itemArr);
                } else {
                    angular.copy(item.container.containerPath, itemArr);
                }

                itemArr.push({
                    itemType: 'Document',
                    id: item.id
                });

                item.uri = scope.itemHrefCallbackFn(itemArr);
                item.containerUri = scope.itemHrefCallbackFn(item.container.containerPath);
                item.type = getFileExtension(item.name);

                if (isInTrash){
                    promiseArr.push(buildRecyclePath());
                } else {
                    promiseArr.push(translateFolderNames(item));
                }

                promiseArr.push(translateActivity(item));
                promiseArr.push($filter('formatDate')(item.activityDate));
                promiseArr.push($filter('formatSize')(item.itemSize));

                $q.all(promiseArr).then(function(res){

                    if (isInTrash){
                        item.containerPath = res[0];
                    } else {
                        item.containerPath = buildPath(res[0]);
                    }

                    item.activity = res[1];
                    item.activityDate = res[2];
                    item.size = res[3];

                    deferred.resolve(item);
                });

                return deferred.promise;
            };

            var buildExtraItemArrayInformation = function(scope, itemArr){
                var deferredArr = [];

                for (var i = 0; i < itemArr.length; i++){
                    deferredArr.push(buildExtraItemInformation(scope, itemArr[i]));
                }
                return $q.all(deferredArr);
            };

            function getGridItems(scope, options){
                return dmsItemUiService.getRecent({
                    scope: scope,
                    params: {
                        from: scope.pageState.page,
                        pageSize: scope.pageState.itemsPerPage
                    },
                    busily: options.busily
                }).then(function(result){
                    scope.pageState.page = result.pageIndex;
                    scope.pageState.itemsPerPage = result.itemsPerPage;
                    scope.pageState.totalItems = result.totalItems;
                    scope.pageState.totalPages = result.totalPages;
                    scope.pageState.startIndex = result.startIndex;

                    buildExtraItemArrayInformation(scope, result.data).then(function(res){
                        scope.gridItems = res;
                    });
                });
            }

            function refresh(scope, options){
                getGridItems(scope, options);
            }

            function DmsRecentsGridControl(scope){
                this.scope = scope;
            }

            DmsRecentsGridControl.prototype.refresh = function(options){
                var opt = options || {};
                refresh(this.scope, opt);
            };

            DmsRecentsGridControl.prototype.getGridItems = function(options){
                var opt = options || {};
                return getGridItems(this.scope, opt);
            };

            return DmsRecentsGridControl;
        }

        DmsRecentsGridControlFactoryImpl.$inject = _$inject;
        return DmsRecentsGridControlFactoryImpl;
    })();

    var DmsRecentsGridDirective = (function(){

        var _$inject = ['$injector', '$q', '$translate', '$window', 'DmsRecentsGridControl', 'dmsRecentsGridConfig', 'fileManager', 'documentUiService', 'FlexGridSetUpService'];

        function DmsRecentsGridDirectiveImpl($injector, $q, $translate, $window, DmsRecentsGridControl, dmsRecentsGridConfig, fileManager, documentUiService, FlexGridSetUpService){

            var wijmo = $window.wijmo;
            var callbacks = {};

            function link(scope, element, attr){

                scope.cellPrefix = 'dms-recents-item';

                var control = new DmsRecentsGridControl(scope);

                if (!scope.control){
                    scope.control = {};
                }

                scope.control.control = control;

                scope.pageState = {
                    page: 1,
                    totalItems: 100,
                    itemsPerPage: 25,
                    //sort: 'name:asc'
                };

                if (attr.itemHrefCallback){
                    callbacks.itemHref = scope.itemHrefCallback;
                }

                scope.gridItemsCallback = function(options){
                    return control.getGridItems(options);
                };

                scope.itemHrefCallbackFn = function(entity){
                    var item = entity;

                    if (callbacks.itemHref) {
                        return callbacks.itemHref({item: item});
                    } else if (dmsRecentsGridConfig.itemHref) {
                        return $injector.invoke(dmsRecentsGridConfig.itemHref)(item);
                    }

                    return '';
                };

                /*********************NOTE: View stuff below *********************************/

                scope.pageState.onPageChanged = function (page) {
                    if (scope.gridItems && scope.gridItems.length !== 0) {
                        scope.pageState.page = page;
                        return scope.gridItemsCallback().then(function(res){
                            scope.gridItems = res;
                        });
                    }
                };

                scope.pageState.onSelectChanged = function (size) {
                    if (scope.gridItems && scope.gridItems.length !== 0) {
                        scope.pageState.page = 1;
                        scope.pageState.itemsPerPage = size;
                        return scope.gridItemsCallback().then(function(res){
                            scope.gridItems = res;
                        });
                    }
                };

                scope.selectInfo =  [
                    {
                        value: 10,
                        label: 10
                    },
                    {
                        value: 25,
                        label: 25
                    },
                    {
                        value: 50,
                        label: 50
                    },
                    {
                        value: 100,
                        label: 100
                    }
                ];

                scope.getIconCell = function(type){
                    if (type.toLowerCase() === 'folder'){
                        return 'bento-icon-folder';
                    } else {
                        // THESE ARE CUSTOM ICONS
                        return 'icon-' + type;
                    }
                };

                var loadStrings = function(){
                    var translatePromises = [
                        $translate('Bluemoon.DMS.Grid.Document.Type').then(function(s) {
                            scope.typeHeader = s;
                        }),
                        $translate('Bluemoon.DMS.Grid.Document.Name').then(function(s) {
                            scope.nameHeader = s;
                        }),
                        $translate('Bluemoon.DMS.Grid.Document.ModifiedDate').then(function(s) {
                            scope.dateHeader = s;
                        }),
                        $translate('Bluemoon.DMS.Grid.Document.Size').then(function(s) {
                            scope.sizeHeader = s;
                        }),
                        $translate('Bluemoon.DMS.Grid.Recents.NoRecentItems').then(function(s) {
                            scope.footerMessage = s;
                        })
                    ];
                    return $q.all(translatePromises);
                };

                //Sets height of rows
                var setGridOptions = function(flex) {
                    var rowHeight = 57;
                    var headerHeight = 37;
                    FlexGridSetUpService.updateFlexGridRowHeight(flex, rowHeight, headerHeight);
                };

                // use the "control" attribute to initialize the first grid
                scope.$watch('ctx.flexGrid', function () {
                    var flex = scope.ctx.flexGrid;
                    if (flex) {
                        setGridOptions(flex);
                    }
                });

                scope.itemFormatter = function (panel, r, c) {
                    if (!panel) {return;}

                    var curCol = panel.columns[c];

                    if (!!curCol._binding && curCol._binding._key === 'type'){
                        curCol.minWidth = 62;
                    }
                };

                var showTooltip = function(elementId){
                    var anchor = document.getElementById(elementId);

                    if (!anchor || !anchor.offsetWidth || !anchor.scrollWidth) { return false; }

                    if (anchor.offsetWidth < anchor.scrollWidth){
                        return true;
                    }
                    return false;
                };

                scope.getCellId = function(row, col){
                    return scope.cellPrefix + col.key + '-' + row.index;
                };

                scope.getContainerCellId = function(row){
                    return scope.cellPrefix + 'container' + '-' + row.index;
                };

                scope.showContainerTooltip =  function(row){
                    return showTooltip(scope.cellPrefix + 'container' + '-' + row.index);
                };

                scope.showTooltip = function(row, col){
                    return showTooltip(scope.cellPrefix + col.key + '-' + row.index);
                };

                scope.getValue = function(item, col){
                    return item[col.key];
                };

                scope.IsPreviewable = function(item) {
                    return item.isViewable || fileManager.isPreviewSupported(item.mimeType);
                };

                scope.downloadFile = function(item) {
                    var itemType = (item.container.containerType.toLowerCase() === 'projects') ? 'Project' : 'Folder';
                    documentUiService.download({
                        params: {
                            document: {
                                id: item.id,
                                parentItem: {itemType: itemType, id: item.container.containerId}
                            }
                        }
                    });
                };

                scope.columnDefs = [
                    {
                        width: '*',
                        binding: 'type',
                        isReadOnly: 'true',
                        key: 'type',
                        align: 'center'
                    },
                    {
                        width: '9*',
                        binding: 'name',
                        dataType: 'String',
                        key: 'name',
                        isReadOnly: 'true',
                    },
                    {
                        width: '5*',
                        binding: 'activityDate',
                        dataType: 'Datetime',
                        key: 'activityDate',
                        isReadOnly: 'true',
                    },
                    {
                        width: '5*',
                        binding: 'size',
                        dataType: 'String',
                        key: 'size',
                        isReadOnly: 'true',
                    }
                ];

                scope.ctx = {
                    gridFilter: null,
                    data: scope.gridItems,
                    includeColumnHeader: true,
                    columnBindings: null,
                    columnVis: [],
                    sort: {
                        property: null,
                        ascending: null
                    },
                    filtersHidden: true,
                    columnBindingsMulti: null
                };

                scope.$on('bmLanguageChangeSuccess', function() {
                    loadStrings();
                });

                scope.setColumnDefs = function(){

                    loadStrings().then(function(){
                        scope.columnDefs[0].header = scope.typeHeader;
                        scope.columnDefs[1].header = scope.nameHeader;
                        scope.columnDefs[2].header = scope.dateHeader;
                        scope.columnDefs[3].header = scope.sizeHeader;

                        scope.ctx.columnsAvailable = new wijmo.collections.CollectionView(scope.columnDefs);
                        scope.ctx.columnBindings = scope.columnDefs;
                    });
                };

                scope.setColumnDefs();
            }

            return {
                restrict: 'EA',
                replace: true,
                scope : {
                    control: '=',
                    itemHrefCallback : '&'
                },
                templateUrl: 'components/recents-grid/recents-grid-template.2js.html',
                link: link
            };
        }
        DmsRecentsGridDirectiveImpl.$inject = _$inject;
        return DmsRecentsGridDirectiveImpl;
    })();

    //  Blank module for dev, overwritten for dist
    angular.module('bluemoon.dms.recents-grid.templates', []);

    angular.module('bluemoon.dms.recents-grid', [
        'wj',
        'pascalprecht.translate',
        'bluemoon.dms.grids',
        'bluemoon.dms.icon',
        'bluemoon.dms.i18n',
        'bluemoon.dms.format',
        'bluemoon.dms.ui-services',
        'bluemoon.dms.format',
        'bluemoon.dms.managers',
        'bluemoon.dms.recents-grid.templates'
    ])

    .provider('dmsRecentsGridConfig', DmsRecentsGridConfig)
    .factory('DmsRecentsGridControl', DmsRecentsGridControlFactory)
    .directive('dmsRecentsGrid', DmsRecentsGridDirective);

})(window.angular);

angular.module('bluemoon.dms.recents-grid.templates', ['components/recents-grid/recents-grid-template.2js.html']);

angular.module("components/recents-grid/recents-grid-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/recents-grid/recents-grid-template.2js.html",
    "<div class=\"recents-grid-container\">\n" +
    "    <wj-flex-grid\n" +
    "        class=\"bento-flex-grid\"\n" +
    "        control= \"ctx.flexGrid\"\n" +
    "        items-source=\"gridItems\"\n" +
    "        selection-mode=\"None\"\n" +
    "        allow-sorting=\"false\"\n" +
    "        item-formatter=\"itemFormatter\"\n" +
    "        headers-visibility=\"Column\">\n" +
    "        <wj-flex-grid-column ng-repeat=\"col in columnDefs\"\n" +
    "           width=\"{{col.width}}\"\n" +
    "           binding=\"{{col.binding}}\"\n" +
    "           header=\"{{col.header}}\"\n" +
    "           data-type=\"{{col.dataType}}\"\n" +
    "           format=\"{{col.format}}\"\n" +
    "           is-Read-Only=\"{{col.isReadOnly}}\"\n" +
    "           align=\"{{col.align}}\"\n" +
    "           aggregate=\"{{col.aggregate}}\">\n" +
    "            <wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key ==='type'\">\n" +
    "              <div class=\"dms-wijmo-custom-cell\">\n" +
    "                <div ng-if=\"hasSnippet($item)\" class=\"dms-wijmo-custom-cell-special\">\n" +
    "                    <dms-icon type=\"{{$item.type}}\" uib-tooltip=\"{{$item.type}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\"/>\n" +
    "                </div>\n" +
    "                <div ng-if=\"!hasSnippet($item)\" class=\"dms-wijmo-custom-cell\">\n" +
    "                    <dms-icon type=\"{{$item.type}}\" uib-tooltip=\"{{$item.type}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\"/>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </wj-flex-grid-cell-template>\n" +
    "            <wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key ==='name'\">\n" +
    "                <div class=\"dms-wijmo-custom-cell\">\n" +
    "                  <div ng-if=\"$item.container.containerType.toLowerCase() === 'trash'\" class=\"dms-recents-link\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                       uib-tooltip=\"{{$item.name}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                    {{$item.name}}\n" +
    "                  </div>\n" +
    "                  <a ng-if=\"$item.container.containerType.toLowerCase() !== 'trash' && IsPreviewable($item)\" class=\"dms-recents-link\"\n" +
    "                     ng-href=\"{{$item.uri}}\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                     uib-tooltip=\"{{$item.name}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                    {{$item.name}}\n" +
    "                    \n" +
    "                  </a>\n" +
    "                  <a ng-if=\"$item.container.containerType.toLowerCase() !== 'trash' && !IsPreviewable($item)\" class=\"dms-recents-link\"\n" +
    "                     href=\"\" ng-click=\"downloadFile($item)\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                     uib-tooltip=\"{{$item.name}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                    {{$item.name}}\n" +
    "                  </a>\n" +
    "                  <span ng-if=\"$item.lock\" class=\"bento-icon-lock dms-lock-icon\" uib-tooltip=\"{{'Bluemoon.DMS.Common.Locked' | translate}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\"></span>\n" +
    "                  <div>\n" +
    "                    <a class=\"dms-recents-link\" ng-href=\"{{$item.containerUri}}\" ng-attr-id=\"{{getContainerCellId($row)}}\"\n" +
    "                       uib-tooltip=\"{{$item.containerPath}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showContainerTooltip($row)\">\n" +
    "                      {{$item.containerPath}}\n" +
    "                    </a>\n" +
    "                  </div>\n" +
    "                </div>\n" +
    "            </wj-flex-grid-cell-template>\n" +
    "            <wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key !=='type' && col.key !== 'name'\">\n" +
    "                <div class=\"dms-recents-overflow\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                     uib-tooltip=\"{{getValue($item, col)}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                    {{getValue($item, col)}}\n" +
    "                </div>\n" +
    "            </wj-flex-grid-cell-template>\n" +
    "        </wj-flex-grid-column>\n" +
    "    </wj-flex-grid>\n" +
    "    <div class=\"page-section-top dms-center-text\" ng-if=\"gridItems.length === 0\">\n" +
    "          {{ footerMessage }}\n" +
    "    </div>\n" +
    "    <div bento-pagination\n" +
    "        page=\"pageState.page\"\n" +
    "        on-change=\"pageState.onPageChanged(page)\"\n" +
    "        direction-links=\"true\"\n" +
    "        boundary-links=\"true\"\n" +
    "        total-items=\"pageState.totalItems\"\n" +
    "        items-array=\"selectInfo\"\n" +
    "        on-change-size=\"pageState.onSelectChanged(size)\"\n" +
    "        items-per-page=\"pageState.itemsPerPage\">\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

(function(angular) {
    'use strict';

    var DmsRecycleGridControlFactory = (function(){

        var _$inject = ['$q', '$translate', '$filter', 'dmsFolderI18n', 'dmsRecycleBinUiService'];

        function DmsRecycleGridControlFactoryImpl($q, $translate, $filter, dmsFolderI18n, dmsRecycleBinUiService){

            var getFileExtension = function(docName){
                if (!docName) {return ''; }
                var loc = docName.lastIndexOf('.');
                return docName.substring(loc + 1).toLowerCase();
            };

            var translateFolderNames = function(item){
                var promiseArr = [];
                var deferred = $q.defer();

                var srcPath = item.containerPath;

                if (!srcPath) { deferred.resolve(item); return deferred.promise; }
                for (var i = 0; i < srcPath.length; i++){
                    promiseArr.push(dmsFolderI18n.translateName(srcPath[i].name));
                }

                $q.all(promiseArr).then(function(resArr){
                    for (var i = 0; i < resArr.length; i++){
                        item.containerPath[i].name = resArr[i];
                    }
                    deferred.resolve(item);
                });

                return deferred.promise;
            };

            var buildPath = function(containerPath){
                var res = '';

                if (!containerPath || containerPath[0].id.toLowerCase() === 'trash') { return '';}

                if (containerPath[0].containerType.toLowerCase() === 'projects'){
                    res += containerPath[0].primaryAssociationName + '/';
                }

                for (var i = 0; i < containerPath.length; i++){
                    if(containerPath[i].name){
                        res += containerPath[i].name;
                        if (i !== containerPath.length - 1){
                            res += '/';
                        }
                    }
                }

                return res;
            };

            var buildExtraItemInformation = function(scope, item){
                var deferred = $q.defer();
                var promiseArr = [];

                item.name = item.trashedResource.name;

                if (item.trashedResource.itemType.toLowerCase() !== 'document'){
                    item.type = 'folder';
                } else {
                    item.type = getFileExtension(item.name);
                }

                promiseArr.push(translateFolderNames(item));
                promiseArr.push($filter('formatDate')(item.trashedDate));
                promiseArr.push($translate('Bluemoon.DMS.Grid.Folder'));
                promiseArr.push($translate('Bluemoon.DMS.Grid.Recycle.LocationUnavailable'));

                $q.all(promiseArr).then(function(res){
                    item = res[0];

                    item.path = buildPath(item.containerPath);

                    if (item.path === ''){
                        item.path = res[3];
                        item.location = res[3];
                    } else {
                        item.location = item.containerPath[item.containerPath.length - 1].name;
                    }

                    item.trashedDate = res[1];
                    item.selected = false;

                    if (item.type === 'folder'){
                        item.itemType = res[2];
                    } else {
                        item.itemType = item.trashedResource.itemType;
                    }
                    item.deletedBy = item.trashedBy.lastName + ', ' + item.trashedBy.firstName;

                    deferred.resolve(item);
                });

                return deferred.promise;
            };

            var buildExtraItemArrayInformation = function(scope, itemArr){
                var deferredArr = [];

                for (var i = 0; i < itemArr.length; i++){
                    deferredArr.push(buildExtraItemInformation(scope, itemArr[i]));
                }
                return $q.all(deferredArr);
            };

            function getGridItems(scope, options){
                var params;

                if (!!scope.rootContainerId && scope.rootContainerId !== ''){
                    params = {
                        from: scope.pageState.page,
                        pageSize: scope.pageState.itemsPerPage,
                        rootContainerId: scope.rootContainerId,
                        trashedByCurrentUser: scope.trashedByCurrentUser
                    };
                } else {
                    params = {
                        from: scope.pageState.page,
                        pageSize: scope.pageState.itemsPerPage,
                        trashedByCurrentUser: scope.trashedByCurrentUser
                    };
                }

                return dmsRecycleBinUiService.getRecycleList({
                    scope: scope,
                    params: params,
                    busily: options.busily
                }).then(function(result){
                    scope.pageState.page = result.pageIndex;
                    scope.pageState.itemsPerPage = result.itemsPerPage;
                    scope.pageState.totalItems = result.totalItems;
                    scope.pageState.totalPages = result.totalPages;
                    scope.pageState.startIndex = result.startIndex;

                    buildExtraItemArrayInformation(scope, result.data).then(function(res){
                        scope.gridItems = res;
                    });
                });
            }

            function refresh(scope, options){
                getGridItems(scope, options);
            }

            function DmsRecycleGridControl(scope){
                this.scope = scope;
            }

            DmsRecycleGridControl.prototype.refresh = function(options){
                var opt = options || {};
                refresh(this.scope, opt);
            };

            DmsRecycleGridControl.prototype.getGridItems = function(options){
                var opt = options || {};
                return getGridItems(this.scope, opt);
            };

            return DmsRecycleGridControl;
        }

        DmsRecycleGridControlFactoryImpl.$inject = _$inject;
        return DmsRecycleGridControlFactoryImpl;
    })();

    var DmsRecycleGridDirective = (function(){

        var _$inject = ['$injector', '$q', '$translate', '$window', 'DmsRecycleGridControl', 'FlexGridSetUpService'];

        function DmsRecycleGridDirectiveImpl($injector, $q, $translate, $window, DmsRecycleGridControl, FlexGridSetUpService){

            var wijmo = $window.wijmo;

            function link(scope){

                scope.cellPrefix = 'dms-recycle-item';

                var control = new DmsRecycleGridControl(scope);

                if (!scope.control){
                    scope.control = {};
                }

                scope.control.control = control;

                scope.pageState = {
                    page: 1,
                    totalItems: 100, //TODO: why?
                    itemsPerPage: 25,
                    //sort: 'name:asc'
                };

                scope.gridItemsCallback = function(options){
                    return control.getGridItems(options);
                };

                /*********************NOTE: View stuff below *********************************/

                scope.pageState.onPageChanged = function (page) {
                    if (scope.gridItems && scope.gridItems.length !== 0) {
                        scope.pageState.page = page;
                        return scope.gridItemsCallback().then(function(res){
                            scope.gridItems = res;
                        });
                    }
                };

                scope.pageState.onSelectChanged = function (size) {
                    if (scope.gridItems && scope.gridItems.length !== 0) {
                        scope.pageState.page = 1;
                        scope.pageState.itemsPerPage = size;
                        return scope.gridItemsCallback().then(function(res){
                            scope.gridItems = res;
                        });
                    }
                };

                scope.selectInfo =  [
                    {
                        value: 10,
                        label: 10
                    },
                    {
                        value: 25,
                        label: 25
                    },
                    {
                        value: 50,
                        label: 50
                    },
                    {
                        value: 100,
                        label: 100
                    }
                ];

                var loadStrings = function(){
                    var translatePromises = [
                        $translate('Bluemoon.DMS.Grid.Document.Type').then(function(s) {
                            scope.typeHeader = s;
                        }),
                        $translate('Bluemoon.DMS.Grid.Document.Name').then(function(s) {
                            scope.nameHeader = s;
                        }),
                        $translate('Bluemoon.DMS.Grid.Recycle.OriginalLocation').then(function(s) {
                            scope.locationHeader = s;
                        }),
                        $translate('Bluemoon.DMS.Grid.Recycle.DeletedDate').then(function(s) {
                            scope.dateHeader = s;
                        }),
                        $translate('Bluemoon.DMS.Grid.Recycle.DeletedBy').then(function(s) {
                            scope.deletedHeader = s;
                        }),
                        $translate('Bluemoon.DMS.Grid.Recycle.NoRecycleItems').then(function(s) {
                            scope.footerMessage = s;
                        })
                    ];
                    return $q.all(translatePromises);
                };

                scope.isSelectedHeader = '';

                //Sets height of rows
                var setGridOptions = function(flex) {
                    var rowHeight = 39;
                    var headerHeight = 37;
                    FlexGridSetUpService.updateFlexGridRowHeight(flex, rowHeight, headerHeight);
                };

                // use the "control" attribute to initialize the first grid
                scope.$watch('ctx.flexGrid', function () {
                    var flex = scope.ctx.flexGrid;
                    if (flex) {
                        setGridOptions(flex);
                    }
                });

                scope.columnDefs = [
                    {
                        width: '80',
                        binding: 'type',
                        key: 'type',
                        isReadOnly: 'true',
                        align: 'center'
                    },
                    {
                        width: '*',
                        binding: 'name',
                        dataType: 'String',
                        key: 'name',
                        isReadOnly: 'true',
                    },
                    {
                        width: '*',
                        binding: 'path',
                        dataType: 'String',
                        key: 'path',
                        isReadOnly: 'true',
                    },
                    {
                        width: '*',
                        binding: 'trashedDate',
                        dataType: 'Datetime',
                        key: 'trashedDate',
                        isReadOnly: 'true',
                    },
                    {
                        width: '*',
                        binding: 'deletedBy',
                        dataType: 'String',
                        key: 'deletedBy',
                        isReadOnly: 'true',
                    }
                ];

                scope.ctx = {
                    gridFilter: null,
                    data: scope.gridItems,
                    includeColumnHeader: true,
                    columnBindings: null,
                    columnVis: [],
                    sort: {
                        property: null,
                        ascending: null
                    },
                    filtersHidden: true,
                    columnBindingsMulti: null
                };

                scope.$on('bmLanguageChangeSuccess', function() {
                    loadStrings();
                });

                var showTooltip = function(elementId){
                    var anchor = document.getElementById(elementId);

                    if (!anchor || !anchor.offsetWidth || !anchor.scrollWidth) { return false; }

                    if (anchor.offsetWidth < anchor.scrollWidth){
                        return true;
                    }
                    return false;
                };

                scope.getIconCell = function(type){
                    if (type.toLowerCase() === 'folder'){
                        return 'bento-icon-folder';
                    } else {
                        // THESE ARE CUSTOM ICONS
                        return 'icon-' + type;
                    }
                };

                scope.getCellId = function(row, col){
                    return scope.cellPrefix + col.key + '-' + row.index;
                };

                scope.showTooltip = function(row, col){
                    return showTooltip(scope.cellPrefix + col.key + '-' + row.index);
                };

                scope.getValue = function(item, col){
                    return item[col.key];
                };

                scope.itemFormatter = function (panel, r, c, cell) {
                    scope.updateSelectedItems();
                    FlexGridSetUpService.setUpMultiSelect(panel, r, c, cell, 'selected');
                };

                var checkDisable = function(button){
                    if (angular.isFunction(button.isEnabled)){
                        button.disabled = !button.isEnabled({selectedItems: scope.selectedItems});
                    }
                };

                var onGridSelectionChanged = function(){
                    if (scope.buttons) {
                        for (var buttonLabel in scope.buttons) {
                            var button = scope.buttons[buttonLabel];

                            if (button.moreButtons){
                                for (var subButton in button.moreButtons){
                                    checkDisable(button.moreButtons[subButton]);
                                }
                            }

                            checkDisable(button);
                        }
                    }
                };

                scope.setupGrid = function(){

                    loadStrings().then(function(){
                        scope.columnDefs[0].header = scope.typeHeader;
                        scope.columnDefs[1].header = scope.nameHeader;
                        scope.columnDefs[2].header = scope.locationHeader;
                        scope.columnDefs[3].header = scope.dateHeader;
                        scope.columnDefs[4].header = scope.deletedHeader;

                        scope.ctx.columnsAvailable = new wijmo.collections.CollectionView(scope.columnDefs);
                        scope.ctx.columnBindings = scope.columnDefs;

                        //Set a default state for buttons.
                        onGridSelectionChanged();
                    });
                };

                scope.updateSelectedItems = function(){
                    if (!scope.gridItems) {return;}
                    scope.selectedItems = scope.gridItems.filter(function (_data) {
                        return (_data.selected === true);
                    });
                    onGridSelectionChanged();
                };

                scope.setupGrid();
            }

            return {
                restrict: 'EA',
                replace: true,
                scope : {
                    control: '=',
                    buttons: '=',
                    selectedItems: '=',
                    rootContainerId: '=',
                    trashedByCurrentUser: '=',
                },
                templateUrl: 'components/recycle-grid/recycle-grid-template.2js.html',
                link: link
            };
        }
        DmsRecycleGridDirectiveImpl.$inject = _$inject;
        return DmsRecycleGridDirectiveImpl;
    })();

    //  Blank module for dev, overwritten for dist
    angular.module('bluemoon.dms.recycle-grid.templates', []);

    angular.module('bluemoon.dms.recycle-grid', [
        'wj',
        'pascalprecht.translate',
        'bluemoon.dms.grids',
        'bluemoon.dms.icon',
        'bluemoon.dms.i18n',
        'bluemoon.dms.format',
        'bluemoon.dms.ui-services',
        'bluemoon.dms.format',
        'bluemoon.dms.managers',
        'bluemoon.dms.recycle-grid.templates'
    ])

    .factory('DmsRecycleGridControl', DmsRecycleGridControlFactory)
    .directive('dmsRecycleGrid', DmsRecycleGridDirective);

})(window.angular);

angular.module('bluemoon.dms.recycle-grid.templates', ['components/recycle-grid/recycle-grid-template.2js.html']);

angular.module("components/recycle-grid/recycle-grid-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/recycle-grid/recycle-grid-template.2js.html",
    "<div class=\"recycle-grid-container\">\n" +
    "    <wj-flex-grid\n" +
    "        class=\"bento-flex-grid\"\n" +
    "        control=\"ctx.flexGrid\"\n" +
    "        items-source=\"gridItems\"\n" +
    "        selection-mode=\"None\"\n" +
    "        allow-sorting=\"false\"\n" +
    "        item-formatter=\"itemFormatter\"\n" +
    "        headers-visibility=\"Column\">\n" +
    "        <wj-flex-grid-column header=\"\" width=\"40\" binding=\"selected\">\n" +
    "            <wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "                <input type=\"checkbox\" ng-model=\"$item.selected\" ng-change=\"updateSelectedItems()\"/>\n" +
    "            </wj-flex-grid-cell-template>\n" +
    "        </wj-flex-grid-column>\n" +
    "        <wj-flex-grid-column ng-repeat=\"col in columnDefs\"\n" +
    "            width=\"{{col.width}}\"\n" +
    "            binding=\"{{col.binding}}\"\n" +
    "            header=\"{{col.header}}\"\n" +
    "            data-type=\"{{col.dataType}}\"\n" +
    "            format=\"{{col.format}}\"\n" +
    "            is-Read-Only=\"{{col.isReadOnly}}\"\n" +
    "            align=\"{{col.align}}\"\n" +
    "            aggregate=\"{{col.aggregate}}\">\n" +
    "            <wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key ==='type'\">\n" +
    "                 <div ng-if=\"hasSnippet($item)\" class=\"dms-wijmo-custom-cell-special\">\n" +
    "                    <dms-icon type=\"{{$item.type}}\" uib-tooltip=\"{{$item.type}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\"/>\n" +
    "                </div>\n" +
    "                <div ng-if=\"!hasSnippet($item)\" class=\"dms-wijmo-custom-cell\">\n" +
    "                    <dms-icon type=\"{{$item.type}}\" uib-tooltip=\"{{$item.type}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\"/>\n" +
    "                </div>\n" +
    "            </wj-flex-grid-cell-template>\n" +
    "            <wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key !=='type'\">\n" +
    "                <div class=\"dms-recycle-overflow\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                     uib-tooltip=\"{{getValue($item, col)}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                    {{getValue($item, col)}}\n" +
    "                </div>\n" +
    "            </wj-flex-grid-cell-template>\n" +
    "        </wj-flex-grid-column>\n" +
    "    </wj-flex-grid>\n" +
    "    <div class=\"page-section-top dms-center-text\" ng-if=\"gridItems.length === 0\">\n" +
    "          {{ footerMessage }}\n" +
    "    </div>\n" +
    "    <div bento-pagination\n" +
    "        page=\"pageState.page\"\n" +
    "        on-change=\"pageState.onPageChanged(page)\"\n" +
    "        direction-links=\"true\"\n" +
    "        boundary-links=\"true\"\n" +
    "        total-items=\"pageState.totalItems\"\n" +
    "        items-array=\"selectInfo\"\n" +
    "        on-change-size=\"pageState.onSelectChanged(size)\"\n" +
    "        items-per-page=\"pageState.itemsPerPage\">\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

(function(angular, moment) {
    'use strict';

    var DmsSearchGridConfig = (function(){

        function DmsSearchGridConfig(){
            var provider = this;

            provider.itemHref = [function(){
                return function() { return ''; };
            }];

            provider.$get = function() {
                return provider;
            };
        }

        return DmsSearchGridConfig;
    })(window.angular);

    var DmsSearchGridControlFactory = (function(){

        var _$inject = ['$state', '$q', '$translate', '$filter', '$sce', '$window', 'dmsFolderI18n', 'dmsSearchUiService'];

        function DmsSearchGridControlFactoryImpl($state, $q, $translate, $filter, $sce, $window, dmsFolderI18n, dmsSearchUiService){

            var getFileExtension = function (docName) {
                if (!docName) {return ''; }
                var loc = docName.lastIndexOf('.');
                return docName.substring(loc + 1).toLowerCase();
            };

            var buildExtraItemInformation = function(scope, item){
                var deferred = $q.defer();

                var promiseArr = [];
                var itemArr = [];

                var client = (item.itemType === 'client');

                var clientFile = false;

                if (item.containerPath) {
                    clientFile = (item.containerPath[0].containerType === 'clients');
                }

                var copied = false;

                if (!scope.containerItemType) {
                    if (client) {
                        angular.copy(item, itemArr);
                    } else {
                        angular.copy(item.containerPath, itemArr);
                    }
                    copied = true;
                } else if (scope.searchCriteria.selectedItem.itemType === 'ClientsList') {
                    if (client) {
                        angular.copy(item, itemArr);
                        copied = true;
                    } else if (clientFile) {
                        angular.copy(item.containerPath, itemArr);
                        copied = true;
                    }
                } else if (item.containerPath) {
                    if (scope.searchCriteria.selectedItem.id === item.containerId) {
                        angular.copy(item.containerPath, itemArr);
                        copied = true;
                    } else {
                        for (var i = 0; i < item.containerPath.length; ++i) {
                            if (scope.searchCriteria.selectedItem.id === item.containerPath[i].containerId) {
                                angular.copy(item.containerPath, itemArr);
                                copied = true;
                            }
                        }
                    }
                }

                if (copied) {
                    itemArr.push({
                        itemType: item.itemType,
                        id: item.id
                    });
                }

                if (client) {
                    item.uri = '#/documents/clients/' + item.id + '/storage';
                    item.containerUri = item.uri;
                    item.type = 'client';
                    item.containerPath = 'ID: ' + item.code;
                } else {

                    var containers = item.containerPath;

                    //Build the clickable link to a given Search result
                    var searchLocation = containers[0].containerType;
                    var documentContainer = containers[containers.length - 1];
                    var link = '';
                    var fileHref;

                    //Let's build the HREF based on if this was a search done in a Folder, or in a Client's Project Folder
                    if (searchLocation !== 'clients' && searchLocation !== 'templates'){
                        link = $state.href('folderList', { folderId : documentContainer.containerId });
                        fileHref = $state.href('folderFileView', { folderId : documentContainer.containerId, fileId : item.id });
                    } else if (searchLocation === 'templates'){
                        //DO TEMPLATE THINGS
                        if (documentContainer.containerType === 'folders')
                        {
                            link = $state.href('templateFolderList',   { templateId : containers[1].containerId, folderId : documentContainer.containerId });
                            fileHref = $state.href('templateFileView', { templateId : containers[1].containerId, folderId : documentContainer.containerId, fileId : item.id });
                        } else {
                            link = $state.href('templateRootList',         { templateId : containers[1].containerId });
                            fileHref = $state.href('templateRootFileView', { templateId : containers[1].containerId, fileId : item.id });
                        }
                    } else {
                        //DO PROJECT THINGS
                        if (documentContainer.containerType === 'folders')
                        {
                            link = $state.href('projectFolderList', { clientId : containers[0].containerId, projectId : containers[1].containerId, folderId : documentContainer.containerId });
                            fileHref = $state.href('projectFileView', { clientId : containers[0].containerId, projectId : containers[1].containerId, folderId : documentContainer.containerId, fileId : item.id });
                        } else {
                            link = $state.href('projectRootList', { clientId : containers[0].containerId, projectId : containers[1].containerId });
                            fileHref = $state.href('projectRootFileView', { clientId : containers[0].containerId, projectId : containers[1].containerId, fileId : item.id });
                        }
                    }

                    var containerName = '';
                    scope.translationMap = {'|firmdocuments|': scope.firmDocsText, '|mydocuments|': scope.myDocsText, '|templates|' : scope.templatesText};
                    for(var counter = 0; counter < containers.length; counter++){

                        var curName = scope.translationMap[containers[counter].containerName];
                        if (!curName || curName === '') { curName = containers[counter].containerName; }

                        if (curName) {
                            containerName = containerName + curName;
                            // containerTemplate = containerTemplate + curName;

                            if(counter !== containers.length - 1){
                                containerName = containerName + '/';
                            }
                        }
                    }

                    item.uri = fileHref;
                    item.containerUri = link;
                    item.type = getFileExtension(item.name);
                    item.containerPath = containerName;
                    if (!!item.snippet && item.snippet.length > 0){
                        item.snippet = $sce.trustAsHtml(item.snippet);
                    }
                    promiseArr.push(moment(item.modifiedDate).format('l LT'));
                    promiseArr.push($filter('formatSize')(item.itemSize));
                }

                $q.all(promiseArr).then(function(res){

                    if (!client){
                        item.activityDate = res[0];
                        item.fileSize = res[1];
                    }

                    deferred.resolve(item);
                });

                if (copied) {
                    return deferred.promise;
                } else {
                    return;
                }
            };

            var buildExtraItemArrayInformation = function(scope, itemArr){
                var deferredArr = [];

                for (var i = 0; i < itemArr.length; i++){
                    var promise = buildExtraItemInformation(scope, itemArr[i]);
                    if (promise !== undefined) {
                        deferredArr.push(promise);
                    }
                }
                return $q.all(deferredArr);
            };

            var cleanResults = function(scope, data){

                var cleanedOutResults = [];
                for(var i = 0; i < data.length; i++){
                    // Check for the minimally neccesary items for each row to contain.
                    // Could also argue Snippet, mimeType
                    //ItemType OR Code guarentees checking Folder, Project, File, and Client
                    if (!!data[i].name && !!data[i].id && (!!data[i].itemType || !!data[i].code) ){
                        cleanedOutResults.push(data[i]);
                    } else {
                        //TODO: log within our system, not just write to console
                        console.log('There was an error with ' + data[i].id);
                    }
                }

                scope.searchResultItems = cleanedOutResults;
                scope.pageState.totalItems = cleanedOutResults.length;
            };

            function getGridItems(scope, options) {
                var page = scope.pageState.page;
                var pageSize = scope.pageState.itemsPerPage;
                return dmsSearchUiService.getAggregatedSearchResults({
                    scope: scope,
                    params: {
                        from: scope.pageState.page,
                        pageSize: scope.pageState.itemsPerPage,
                        searchCriteria: scope.searchCriteria
                    },
                    busily: options.busily
                }).then(function (result) {

                    if (scope.searchCriteria.selectedItem) {
                        scope.containerId = scope.searchCriteria.selectedItem.id;
                        scope.containerItemType = scope.searchCriteria.selectedItem.itemType;
                    }

                    if(result.data !== null && result.data.length > 0){
                        cleanResults(scope, result.data);
                    }

                    buildExtraItemArrayInformation(scope, result.data).then(function (res) {
                        scope.pageState.page = page;
                        scope.pageState.itemsPerPage = pageSize;
                        scope.pageState.totalItems = res.length;
                        scope.pageState.totalPages = scope.pageState.totalItems / scope.pageState.itemsPerPage;
                        scope.pageState.startIndex = 0;
                        //var startIndex = (scope.pageState.page - 1) * scope.pageState.itemsPerPage;
                        //var endIndex = startIndex + scope.pageState.itemsPerPage;
                        var wijmo = $window.wijmo;
                        scope.gridItems = res;
                        var slicedGridClient = [];
                        var slicedGridDoc = [];

                        var data = [];
                        for (var i = 0; i < scope.gridItems.length; i++) {
                            if (scope.gridItems[i].itemType === 'client') {
                                scope.gridItems[i].Type = 'Client';
                                slicedGridClient.push(scope.gridItems[i]);
                            } else {
                                scope.gridItems[i].Type = 'Document';
                                slicedGridDoc.push(scope.gridItems[i]);
                            }
                            data.push({
                                key: i,
                                Type: scope.gridItems[i].Type
                            });
                        }

                        function nameComparator() {
                            return function (a, b) {
                                var tempA = a.name.toLowerCase();
                                var tempB = b.name.toLowerCase();
                                if (tempA < tempB) {
                                    return -1;
                                } else if (tempA > tempB) {
                                    return 1;
                                } else {
                                    return 0;
                                }
                            };
                        }

                        slicedGridClient.sort(nameComparator());
                        slicedGridDoc.sort(nameComparator());

                        for (var x = 0; i < slicedGridClient.length + slicedGridDoc.length; x++) {
                            if (x < slicedGridClient.length) {
                                scope.gridItems[x] = slicedGridClient[x];
                            } else {
                                scope.gridItems[x] = slicedGridDoc[x - slicedGridClient.length];
                            }
                        }

                        //custom sort, comparator is defined below
                        scope.gridItems = new wijmo.collections.CollectionView(scope.gridItems);

                        scope.gridItems.pageSize = pageSize;

                        scope.gridItems.sortDescriptions.push(new wijmo.collections.SortDescription('name', true));
                        scope.gridItems.groupDescriptions.push(new wijmo.collections.PropertyGroupDescription('Type'));
                        var sortMap = new wijmo.grid.DataMap(data, 'key', 'Type');
                        scope.gridItems.sortConverter = function (sd, item, value) {
                            if (sd.property === 'Type') {
                                value = sortMap.getDisplayValue(value);
                            }
                            return value;
                        };

                        if (res.length !== 0 && scope.gridItems._fullGroups.length === 2) {
                            if (scope.gridItems._fullGroups[1]._name === 'Client') {
                                var t = scope.gridItems._fullGroups[0];
                                scope.gridItems._fullGroups[0] = scope.gridItems._fullGroups[1];
                                scope.gridItems._fullGroups[1] = t;
                            }
                        }

                        scope.gridItems.length = res.length;
                    });
                });
            }

            function refresh(scope, options){
                getGridItems(scope, options);
            }

            function DmsSearchGridControl(scope){
                this.scope = scope;
            }

            DmsSearchGridControl.prototype.refresh = function(options){
                var opt = options || {};
                refresh(this.scope, opt);
            };

            DmsSearchGridControl.prototype.getGridItems = function(options){
                var opt = options || {};
                return getGridItems(this.scope, opt);
            };

            return DmsSearchGridControl;
        }

        DmsSearchGridControlFactoryImpl.$inject = _$inject;
        return DmsSearchGridControlFactoryImpl;
    })();

    var DmsSearchGridDirective = (function(){

        var _$inject = ['$state', '$injector', '$q', '$translate', '$window', 'DmsSearchGridControl', 'dmsSearchGridConfig', 'fileManager', 'dmsDocumentUiService', 'folderManager', 'clientManager', 'projectManager', 'searchManager', 'FlexGridSetUpService'];

        function DmsSearchGridDirectiveImpl($state, $injector, $q, $translate, $window, DmsSearchGridControl, dmsSearchGridConfig, fileManager, documentUiService, folderManager, clientManager, projectManager, searchManager, FlexGridSetUpService){

            var wijmo = $window.wijmo;
            var callbacks = {};

            function link(scope, element, attr){

                scope.cellPrefix = 'dms-search-item';

                scope.searchCriteria = searchManager.getSearchCriteria();

                if (scope.searchCriteria.searchText === '') {
                    $state.go('allDocsRootList');
                    return;
                }

                var control = new DmsSearchGridControl(scope);

                if (!scope.control){
                    scope.control = {};
                }

                scope.control.control = control;

                scope.pageState = {
                    page: 1,
                    totalItems: 100,
                    itemsPerPage: 25,
                    //sort: 'name:asc'
                };

                if (attr.itemHrefCallback){
                    callbacks.itemHref = scope.itemHrefCallback;
                }

                scope.gridItemsCallback = function(options){
                    return control.getGridItems(options);
                };

                scope.itemHrefCallbackFn = function(entity){
                    var item = entity;

                    if (callbacks.itemHref) {
                        return callbacks.itemHref({item: item});
                    } else if (dmsSearchGridConfig.itemHref) {
                        return $injector.invoke(dmsSearchGridConfig.itemHref)(item);
                    }

                    return '';
                };

                /*********************NOTE: View stuff below *********************************/

                scope.pageState.onPageChanged = function (page) {
                    if (scope.gridItems && scope.gridItems.length !== 0) {
                        scope.pageState.page = page;
                        scope.gridItems.moveToPage(page - 1);
                    }
                };

                scope.pageState.onSelectChanged = function (size) {
                    if (scope.gridItems && scope.gridItems.length !== 0) {
                        scope.pageState.page = 1;
                        scope.gridItems.pageSize = size;
                        scope.pageState.itemsPerPage = size;
                    }
                };

                scope.selectInfo =  [
                    {
                        value: 10,
                        label: 10
                    },
                    {
                        value: 25,
                        label: 25
                    },
                    {
                        value: 50,
                        label: 50
                    },
                    {
                        value: 100,
                        label: 100
                    }
                ];

                var loadStrings = function(){
                    var translatePromises = [
                        $translate('Bluemoon.DMS.SearchDidNotReturnAnyResults').then(function(s) {
                            scope.footerMessage = s;
                        }),
                        $translate('Bluemoon.DMS.SpecialFolders.FirmDocuments').then(function(s) {
                            scope.firmDocsText = s;
                        }),
                        $translate('Bluemoon.DMS.SpecialFolders.MyDocuments').then(function(s) {
                            scope.myDocsText = s;
                        }),
                        $translate('Bluemoon.DMS.SpecialFolders.Templates').then(function(s) {
                            scope.templatesText = s;
                        }),
                        $translate('Bluemoon.DMS.Grid.Document.Type').then(function(s) {
                            scope.typeHeader = s;
                        }),
                        $translate('Bluemoon.DMS.Grid.Document.Name').then(function(s) {
                            scope.nameHeader = s;
                        }),
                        $translate('Bluemoon.DMS.Grid.Document.ModifiedDate').then(function(s) {
                            scope.dateHeader = s;
                        }),
                        $translate('Bluemoon.DMS.Grid.Document.Size').then(function(s) {
                            scope.sizeHeader = s;
                        })
                    ];
                    return $q.all(translatePromises);
                };

                // use the "control" attribute to initialize the first grid
                scope.$watch('ctx.flexGrid', function () {
                    var flex = scope.ctx.flexGrid;
                    if (flex) {
                        setGridOptions(flex);
                    }
                });

                scope.itemFormatter = function (panel, r, c) {
                    if (!panel) {return;}

                    var curCol = panel.columns[c];

                    if (!!curCol._binding && curCol._binding._key === 'type'){
                        curCol.minWidth = 62;
                    }

                    if (panel._rows.length > 1) {
                        if ('snippet' in panel._rows[r]._data) {
                            if (panel._rows[r]._data.snippet !== '') {
                                panel._rows[r].height = 80;
                                return;
                            }
                        }
                        panel._rows[r].height = 60;
                    }
                };

                //Sets height of rows
                function setGridOptions(flex){
                    var rowHeight = 57;
                    var headerHeight = 48;
                    FlexGridSetUpService.updateFlexGridRowHeight(flex, rowHeight, headerHeight);
                }

                var showTooltip = function(elementId){
                    var anchor = document.getElementById(elementId);

                    if (!anchor || !anchor.offsetWidth || !anchor.scrollWidth) { return false; }

                    if (anchor.offsetWidth < anchor.scrollWidth){
                        return true;
                    }
                    return false;
                };

                scope.processSearch = function(term){
                    if (term === undefined) { return; }
                    if (scope.searchCriteria.searchWithinResults && scope.searchResultItems.length === 0) { return; }
                    searchManager.setSearchCriteria(term, scope.searchCriteria.selectedItem, scope.searchCriteria.searchWithinResults);
                    scope.pageState.page = 1;
                    control.refresh();
                };

                scope.getCellId = function(row, col){
                    return scope.cellPrefix + col.key + '-' + row.index;
                };

                scope.getContainerCellId = function(row){
                    return scope.cellPrefix + 'container' + '-' + row.index;
                };

                scope.showContainerTooltip =  function(row){
                    return showTooltip(scope.cellPrefix + 'container' + '-' + row.index);
                };

                scope.showTooltip = function(row, col){
                    return showTooltip(scope.cellPrefix + col.key + '-' + row.index);
                };

                scope.getValue = function(item, col){
                    return item[col.key];
                };

                scope.IsPreviewable = function(mimeType) {
                    return fileManager.isPreviewSupported(mimeType);
                };

                scope.isClient = function (item) {
                    return (item.itemType && item.itemType === 'client');
                };

                scope.hasSnippet = function (item) {
                    return (item.snippet !== undefined && item.snippet !== '');
                };

                scope.downloadFile = function (item) {
                    var containType = item.containerUri[item.containerUri.length - 7];
                    for (var i = 1; i < 7; i++){
                        containType += item.containerUri[item.containerUri.length - 7 + i];
                    }
                    var itemType = (containType === 'folders') ? 'Project' : 'Folder';

                    documentUiService.download({
                        params: {
                            document: {
                                id: item.id,
                                parentItem: { itemType: itemType, id: item.containerId }
                            }
                        }
                    });
                };

                scope.columnDefs = [
                    {
                        width: '*',
                        binding: 'type',
                        isReadOnly: 'true',
                        key: 'type',
                        align: 'center',
                    },
                    {
                        width: '9*',
                        binding: 'name',
                        dataType: 'String',
                        key: 'name',
                        isReadOnly: 'true',
                    },
                    {
                        width: '5*',
                        binding: 'modifiedDate',
                        dataType: 'Datetime',
                        key: 'activityDate',
                        isReadOnly: 'true',
                    },
                    {
                        width: '5*',
                        binding: 'itemSize',
                        dataType: 'String',
                        key: 'fileSize',
                        isReadOnly: 'true',
                    }

                ];

                scope.ctx = {
                    gridFilter: null,
                    data: scope.gridItems,
                    includeColumnHeader: true,
                    columnBindings: null,
                    columnVis: [],
                    sort: {
                        property: null,
                        ascending: null
                    },
                    filtersHidden: true,
                    columnBindingsMulti: null
                };

                scope.$on('bmLanguageChangeSuccess', function() {
                    loadStrings();
                });

                scope.setColumnDefs = function(){

                    loadStrings().then(function(){
                        scope.columnDefs[0].header = scope.typeHeader;
                        scope.columnDefs[1].header = scope.nameHeader;
                        scope.columnDefs[2].header = scope.dateHeader;
                        scope.columnDefs[3].header = scope.sizeHeader;

                        scope.ctx.columnsAvailable = new wijmo.collections.CollectionView(scope.columnDefs);
                        scope.ctx.columnBindings = scope.columnDefs;
                    });
                };

                scope.setColumnDefs();
            }

            return {
                restrict: 'EA',
                replace: true,
                scope : {
                    control: '=',
                    itemHrefCallback : '&'
                },
                templateUrl: 'components/search-grid/search-grid-template.2js.html',
                link: link
            };
        }
        DmsSearchGridDirectiveImpl.$inject = _$inject;
        return DmsSearchGridDirectiveImpl;
    })();

    //  Blank module for dev, overwritten for dist
    angular.module('bluemoon.dms.search-grid.templates', []);

    angular.module('bluemoon.dms.search-grid', [
        'wj',
        'pascalprecht.translate',
        'bluemoon.dms.grids',
        'bluemoon.dms.icon',
        'bluemoon.dms.i18n',
        'bluemoon.dms.format',
        'bluemoon.dms.ui-services',
        'bluemoon.dms.format',
        'bluemoon.dms.managers',
        'bluemoon.dms.search-grid.templates'
    ])

    .provider('dmsSearchGridConfig', DmsSearchGridConfig)
    .factory('DmsSearchGridControl', DmsSearchGridControlFactory)
    .directive('dmsSearchGrid', DmsSearchGridDirective);

})(window.angular, window.moment);

angular.module('bluemoon.dms.search-grid.templates', ['components/search-grid/search-grid-template.2js.html']);

angular.module("components/search-grid/search-grid-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/search-grid/search-grid-template.2js.html",
    "<div class=\"search-grid-container\">\n" +
    "    <div dms-toolbar\n" +
    "        buttons=\"buttons\"\n" +
    "        on-search-enter=\"processSearch\"\n" +
    "        search-term=\"searchCriteria.searchText\"\n" +
    "        has-search-toggle=\"true\"\n" +
    "        toggle-state=\"searchCriteria.searchWithinResults\">\n" +
    "    </div>\n" +
    "    <wj-flex-grid\n" +
    "        class=\"bento-flex-grid\"\n" +
    "        control= \"ctx.flexGrid\"\n" +
    "        items-source=\"gridItems\"\n" +
    "        selection-mode=\"None\"\n" +
    "        allow-sorting=\"true\"\n" +
    "        item-formatter=\"itemFormatter\"\n" +
    "        headers-visibility=\"Column\">\n" +
    "        <wj-flex-grid-column ng-repeat=\"col in columnDefs\"\n" +
    "           width=\"{{col.width}}\"\n" +
    "           binding=\"{{col.binding}}\"\n" +
    "           header=\"{{col.header}}\"\n" +
    "           data-type=\"{{col.dataType}}\"\n" +
    "           format=\"{{col.format}}\"\n" +
    "           is-Read-Only=\"{{col.isReadOnly}}\"\n" +
    "           align=\"{{col.align}}\"\n" +
    "           aggregate=\"{{col.aggregate}}\">\n" +
    "           <wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key ==='type'\">\n" +
    "               <div ng-if=\"hasSnippet($item)\" class=\"dms-wijmo-custom-cell-special\">\n" +
    "                    <dms-icon type=\"{{$item.type}}\" uib-tooltip=\"{{$item.type}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\"/>\n" +
    "                </div>\n" +
    "                <div ng-if=\"!hasSnippet($item)\" class=\"dms-wijmo-custom-cell\">\n" +
    "                    <dms-icon type=\"{{$item.type}}\" uib-tooltip=\"{{$item.type}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\"/>\n" +
    "                </div>\n" +
    "            </wj-flex-grid-cell-template>\n" +
    "            <wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key ==='name'\">\n" +
    "                <div ng-if=\"hasSnippet($item)\" class=\"dms-wijmo-custom-cell-special\">\n" +
    "                    <a ng-if=\"isClient($item) && hasSnippet($item)\" class=\"dms-search-link-special\"\n" +
    "                        ng-href=\"{{$item.uri}}\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                        uib-tooltip=\"{{$item.name}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                        {{$item.name}}\n" +
    "                    </a>\n" +
    "                    <a ng-if=\"isClient($item) && !hasSnippet($item)\" class=\"dms-search-link\"\n" +
    "                        ng-href=\"{{$item.uri}}\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                        uib-tooltip=\"{{$item.name}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                        {{$item.name}}\n" +
    "                    </a>\n" +
    "                    <a ng-if=\"!isClient($item) && IsPreviewable($item.mimeType) && hasSnippet($item)\" class=\"dms-search-link-special\"\n" +
    "                        ng-href=\"{{$item.uri}}\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                        uib-tooltip=\"{{$item.name}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                        {{$item.name}}\n" +
    "                    </a>\n" +
    "                    <a ng-if=\"!isClient($item) && IsPreviewable($item.mimeType && !hasSnippet($item))\" class=\"dms-search-link\"\n" +
    "                        ng-href=\"{{$item.uri}}\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                        uib-tooltip=\"{{$item.name}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                        {{$item.name}}\n" +
    "                    </a>\n" +
    "                    <a ng-if=\"!isClient($item) && !IsPreviewable($item.mimeType) && hasSnippet($item)\" class=\"dms-search-link-special\"\n" +
    "                        href=\"\" ng-click=\"downloadFile($item)\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                        uib-tooltip=\"{{$item.name}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                        {{$item.name}}\n" +
    "                    </a>\n" +
    "                    <a ng-if=\"!isClient($item) && !IsPreviewable($item.mimeType) && !hasSnippet($item)\" class=\"dms-search-link\"\n" +
    "                        href=\"\" ng-click=\"downloadFile($item)\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                        uib-tooltip=\"{{$item.name}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                        {{$item.name}}\n" +
    "                    </a>\n" +
    "                    <span ng-if=\"$item.lock\" class=\"bento-icon-lock dms-lock-icon\" uib-tooltip=\"{{'Bluemoon.DMS.Common.Locked' | translate}}\" \n" +
    "                        tooltip-placement=\"top\" tooltip-append-to-body=\"true\"></span>\n" +
    "                    <div class=\"dms-search-snippet dms-text-hidable\" ng-bind-html=\"$item.snippet\">\n" +
    "                        {{$item.snippet}}\n" +
    "                    </div>\n" +
    "                    <a class=\"dms-search-link\" ng-href=\"{{$item.containerUri}}\" ng-attr-id=\"{{getContainerCellId($row)}}\"\n" +
    "                        uib-tooltip=\"{{$item.containerPath}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showContainerTooltip($row)\">\n" +
    "                        {{$item.containerPath}}\n" +
    "                    </a>\n" +
    "                </div>\n" +
    "                <div ng-if=\"!hasSnippet($item)\" class=\"dms-wijmo-custom-cell\">\n" +
    "                    <a ng-if=\"isClient($item) && hasSnippet($item)\" class=\"dms-search-link-special\"\n" +
    "                        ng-href=\"{{$item.uri}}\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                        uib-tooltip=\"{{$item.name}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                        {{$item.name}}\n" +
    "                    </a>\n" +
    "                    <a ng-if=\"isClient($item) && !hasSnippet($item)\" class=\"dms-search-link\"\n" +
    "                        ng-href=\"{{$item.uri}}\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                        uib-tooltip=\"{{$item.name}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                        {{$item.name}}\n" +
    "                    </a>\n" +
    "                    <a ng-if=\"!isClient($item) && IsPreviewable($item.mimeType) && hasSnippet($item)\" class=\"dms-search-link-special\"\n" +
    "                        ng-href=\"{{$item.uri}}\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                        uib-tooltip=\"{{$item.name}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                        {{$item.name}}\n" +
    "                    </a>\n" +
    "                    <a ng-if=\"!isClient($item) && IsPreviewable($item.mimeType) && !hasSnippet($item)\" class=\"dms-search-link\"\n" +
    "                        ng-href=\"{{$item.uri}}\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                        uib-tooltip=\"{{$item.name}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                        {{$item.name}}\n" +
    "                    </a>\n" +
    "                    <a ng-if=\"!isClient($item) && !IsPreviewable($item.mimeType) && hasSnippet($item)\" class=\"dms-search-link-special\"\n" +
    "                        href=\"\" ng-click=\"downloadFile($item)\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                        uib-tooltip=\"{{$item.name}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                        {{$item.name}}\n" +
    "                    </a>\n" +
    "                    <a ng-if=\"!isClient($item) && !IsPreviewable($item.mimeType) && !hasSnippet($item)\" class=\"dms-search-link\"\n" +
    "                        href=\"\" ng-click=\"downloadFile($item)\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                        uib-tooltip=\"{{$item.name}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                        {{$item.name}}\n" +
    "                    </a>\n" +
    "                    <span ng-if=\"$item.lock\" class=\"bento-icon-lock dms-lock-icon\" uib-tooltip=\"{{'Bluemoon.DMS.Common.Locked' | translate}}\" \n" +
    "                        tooltip-placement=\"top\" tooltip-append-to-body=\"true\"></span>\n" +
    "                    <div class=\"dms-search-snippet dms-text-hidable\" ng-bind-html=\"$item.snippet\">\n" +
    "                        {{$item.snippet}}\n" +
    "                    </div>\n" +
    "                    <a class=\"dms-search-link\" ng-href=\"{{$item.containerUri}}\" ng-attr-id=\"{{getContainerCellId($row)}}\"\n" +
    "                        uib-tooltip=\"{{$item.containerPath}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showContainerTooltip($row)\">\n" +
    "                        {{$item.containerPath}}\n" +
    "                    </a>\n" +
    "                </div>\n" +
    "            </wj-flex-grid-cell-template>\n" +
    "            <wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key !=='type' && col.key !== 'name'\">\n" +
    "                <div class=\"dms-search-overflow-special\" ng-if=\"hasSnippet($item)\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                    uib-tooltip=\"{{getValue($item, col)}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                    {{getValue($item, col)}}\n" +
    "                </div>\n" +
    "                <div class=\"dms-search-overflow\" ng-if=\"!hasSnippet($item)\" ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "                    uib-tooltip=\"{{getValue($item, col)}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\" tooltip-enable=\"showTooltip($row, col)\">\n" +
    "                    {{getValue($item, col)}}\n" +
    "                </div>\n" +
    "            </wj-flex-grid-cell-template>\n" +
    "        </wj-flex-grid-column>\n" +
    "    </wj-flex-grid>\n" +
    "    <div class=\"page-section-top dms-center-text\" ng-if=\"gridItems.length === 0\">\n" +
    "        {{ footerMessage }}\n" +
    "    </div>\n" +
    "    <div bento-pagination\n" +
    "        page=\"pageState.page\"\n" +
    "        on-change=\"pageState.onPageChanged(page)\"\n" +
    "        direction-links=\"true\"\n" +
    "        boundary-links=\"true\"\n" +
    "        total-items=\"pageState.totalItems\"\n" +
    "        items-array=\"selectInfo\"\n" +
    "        on-change-size=\"pageState.onSelectChanged(size)\"\n" +
    "        items-per-page=\"pageState.itemsPerPage\">\n" +
    "    </div>\n" +
    "</div>");
}]);

(function(angular) {
    'use strict';

    var bmoonApp = angular.module('bluemoon.dms.sidebar', ['bluemoon.dms']);

    var dmsSidebarService = function($q, folderManager) {
            var rootFolder;
            var firmFolder;

            this.getRootFolder = function(){
                var deferred = $q.defer();

                if (!rootFolder){
                    //Get single My Documents folder
                    folderManager.getSingleMyDocsFolder().then(function(result){

                        rootFolder = result;

                        deferred.resolve(rootFolder);
                    });
                } else {
                    deferred.resolve(rootFolder);
                }

                return deferred.promise;
            };

            this.getFirmFolder = function(){
                var deferred = $q.defer();

                if (!firmFolder){
                    //Get single My Documents folder
                    folderManager.getSingleFirmFolder().then(function(result){

                        firmFolder = result;

                        deferred.resolve(firmFolder);
                    });
                } else {
                    deferred.resolve(firmFolder);
                }

                return deferred.promise;
            };

        };

    dmsSidebarService.$inject = ['$q', 'folderManager'];
    bmoonApp.service('dmsSidebarService', dmsSidebarService);
})(window.angular, window._);

(function(angular) {
    'use strict';

    //  Blank module for dev, overwritten for dist
    angular.module('bluemoon.dms.storage-grid.templates', []);

    var bmoonApp = angular.module('bluemoon.dms.storage-grid', [
        'pascalprecht.translate',
        'bluemoon.dms.format',
        'bluemoon.dms.managers',
        'bluemoon.dms.storage-grid.templates'
    ]);

    var dmsStorageGridService = function() {
            this.templatePath = function(template) {
                return 'components/storage-grid/' + template + '.2js.html';
            };
        };

    bmoonApp.service('dmsStorageGridService', dmsStorageGridService);
})(window.angular, window._);

(function(angular) {
    'use strict';

    var bmoonApp = angular.module('bluemoon.dms.storage-grid');

    var dmsStorageGrid = function(dmsStorageGridService) {
            return {
                restrict: 'E',
                replace: true,
                scope : {
                    items : '=',
                    selectedItems : '=',
                    currentContainer : '=',
                    customOptions : '=',
                    viewerHeight : '=',
                    headerRowHeight : '=',
                    rowHeight : '=',
                    virtualizationThreshold : '=',
                    searchMethod : '=',
                    refreshInProgress : '=',
                    buttons : '='
                },
                templateUrl: dmsStorageGridService.templatePath('storage-grid-template'),
                controller: 'storageGridController'
            };
        };

    dmsStorageGrid.$inject = ['dmsStorageGridService'];
    bmoonApp.directive('dmsStorageGrid', dmsStorageGrid);
})(window.angular, window._);

(function(angular){
    'use strict';

    var bmoonApp = angular.module('bluemoon.dms.storage-grid');

    var storageGridController = function($rootScope, $scope, $q, $translate, dmsStorageGridService, $timeout, $domUtilityService) {

        var vm = this;

        $scope.columnDefs = [
            {
                cellTemplate: dmsStorageGridService.templatePath('storage-type-cell-template'),
                field: 'productType',
                width: '7%',
                sortable: false //TODO: re-enable at some point
            },
            {
                cellTemplate: dmsStorageGridService.templatePath('storage-name-cell-template'),
                field: 'name',
                width: '43%'
            },
            {
                cellTemplate: dmsStorageGridService.templatePath('storage-year-column-template'),
                field: 'processingYear',
                width: '25%'
            },
            {
                cellTemplate: dmsStorageGridService.templatePath('storage-date-column-template'),
                field: 'processingPeriod',
                width: '25%'
            }
        ];

        vm._loadStringsForColumnHeaders = function() {
            var translatePromises = [
                $translate('Bluemoon.DMS.Grid.Storage.Type').then(function(s) {
                    $scope.columnDefs[0].displayName = s;
                }),
                $translate('Bluemoon.DMS.Grid.Storage.Name').then(function(s) {
                    $scope.columnDefs[1].displayName = s;
                }),
                $translate('Bluemoon.DMS.Grid.Storage.Year').then(function(s) {
                    $scope.columnDefs[2].displayName = s;
                }),
                $translate('Bluemoon.DMS.Grid.Storage.Date').then(function(s) {
                    $scope.columnDefs[3].displayName = s;
                }),
            ];

            return $q.all(translatePromises);
        };

        vm._loadStringsForFooter = function() {
            if (angular.isString($scope.footerMessage) && angular.isArray($scope.items) &&
                $scope.items.length === 0){
                return $translate('Bluemoon.DMS.Grid.Document.FolderIsEmpty').then(function(s) {
                    $scope.footerMessage = s;
                });
            }

            var defer = $q.defer();
            defer.resolve();
            return defer.promise;
        };

        //  Run on init
        vm._loadStrings = function() {
            vm._loadStringsForColumnHeaders();
            vm._loadStringsForFooter();
            vm._loadStringsForTooltips();
        };

        vm._sharedFolderTooltip = '';
        vm._folderTooltip = '';

        vm._loadStringsForTooltips = function() {

            vm._sharedFolderTooltip = vm._sharedFolderTooltip || '';
            vm._folderTooltip = vm._folderTooltip || '';

            var translatePromises = [
                $translate('Bluemoon.DMS.Grid.SharedFolder').then(function(s){
                    vm._sharedFolderTooltip = s;
                }),
                $translate('Bluemoon.DMS.Grid.Folder').then(function(s){
                    vm._folderTooltip = s;
                }),
            ];

            return $q.all(translatePromises);
        };

        vm._loadStrings();

        $scope.$on('bmLanguageChangeSuccess', function() {
            vm._loadStrings();
        });

        var fixedOptions = {
            columnDefs : 'columnDefs',
            data : 'items'
        };

        $scope.getLockTooltip = function(item){
            if (item.lock){
                return $translate.instant('Bluemoon.DMS.Common.Locked');
            } else {
                return '';
            }
        };

        $scope.getStorageIcon = function(item){
            //TODO: re-enable in future releases.
            // if (item.productType !== 'DMSClientFolder'){
            //     return 'dms-storage-icon dms-storage-' + productType.toLowerCase();
            // }

            if (item.isShared){
                return 'bento-icon-shared-folder';
            } else {
                return 'bento-icon-folder';
            }
        };

        $scope.getStorageTooltip = function(item) {
            return item.isShared ? vm._sharedFolderTooltip : vm._folderTooltip;
        };

        $scope.getNameTooltip = function(name, rowIndex) {
            var nameDiv = document.getElementById('dms-storage-name-cell-' + rowIndex);

            if (nameDiv === null) { return null; } //we werent ready yet

            var containingDiv = nameDiv.getElementsByTagName('a')[0];

            if (!containingDiv || !containingDiv.offsetWidth || !containingDiv.scrollWidth) { return null; }

            if (containingDiv.offsetWidth < containingDiv.scrollWidth){
                return name;
            }
            return null;
        };

        $scope.getNameCellId = function(row) {
            return 'dms-storage-name-cell-' + row.rowIndex;
        };

        $scope.getYear = function(processingYear){
            if (processingYear === 1900) { return ''; }

            return processingYear;
        };

        $scope.getProductType = function(row){
            if (row.productType === 'DMSClientFolder') { return $scope.getStorageTooltip(row); }

            return row.productType;
        };

        var customOptions = $scope.customOptions;

        $scope.selectInfo =  [
                {
                    value: 10,
                    label: 10
                },
                {
                    value: 25,
                    label: 25
                },
                {
                    value: 50,
                    label: 50
                },
                {
                    value: 100,
                    label: 100
                }
            ];

        $scope.currentInfo = {
            page: 1,
            totalItems: 0,
            numItems: 25,
        };

        $scope.currentInfo.onPageChanged = function(page){
            $scope.pageChange = true;
            $scope.currentInfo.page = page;
            $scope.setPagingData($scope.allItems, $scope.currentInfo.page, $scope.currentInfo.numItems);
        };

        $scope.currentInfo.onSelectChanged = function(size){
            $scope.pageChange = true;
            $scope.currentInfo.numItems = size;
            $scope.setPagingData($scope.allItems, $scope.currentInfo.page, $scope.currentInfo.numItems);

            $timeout(function(){
                $domUtilityService.RebuildGrid(
                    $scope.options.$gridScope,
                    $scope.options.ngGrid);
            });
        };

        var defaultOptions = {
            headerRowHeight : $scope.headerRowHeight,
            rowHeight : $scope.rowHeight,
            selectedItems : $scope.selectedItems,
            showSelectionCheckbox : true,
            filterOptions : {
                filterText : '',
                useExternalFilter : false
            },
            showColumnMenu : false,
            showGroupPanel : false,
        };

        // pick the slice we currently want to see
        $scope.setPagingData = function(data, page, pageSize){
            if (!$scope.allItems || !data || !(data instanceof Array)) {return; }
            var pagedData = data.slice((page - 1) * pageSize, page * pageSize);
            $scope.items = pagedData;
        };

        $scope.$watchCollection('items', function(){
            $scope.footerMessage = '';

            vm._loadStringsForFooter();

            //  This check may be excessive
            if(!$scope.items || $scope.items.length === 0 || !($scope.items instanceof Array)){
                return;
            }

            $scope.numTimesRefreshed++;

            //Only change this on first ever items load
            if (!$scope.everLoaded || ($scope.numTimesRefreshed > 1 && $scope.refreshInProgress)){
                $scope.allItems = $scope.items;
                $scope.currentInfo.totalItems = $scope.allItems.length;
                if ($scope.currentInfo.totalItems > 10){
                    $scope.setPagingData($scope.items, $scope.currentInfo.page, $scope.currentInfo.numItems);
                }
                $scope.everLoaded = true;
            }

            if (!$scope.pageChange){
                $scope.items = $scope.allItems;
                $scope.setPagingData($scope.items, $scope.currentInfo.page, $scope.currentInfo.numItems);
            }

            $scope.pageChange = false;
            $scope.refreshInProgress = false;
        });

        $scope.options = {};

        $scope.everLoaded = false;
        $scope.pageChange = false;

        $scope.numTimesRefreshed = 0;

        $scope.searchInput = {
            text: undefined
        };

        angular.extend($scope.options, defaultOptions);
        angular.extend($scope.options, customOptions);
        angular.extend($scope.options, fixedOptions);

        var checkDisable = function(button, selectedItems){
            if (angular.isFunction(button.isEnabled)){
                button.disabled = !button.isEnabled(selectedItems);
            }
        };

        var onGridSelectionChanged = function(){
            var gridData = { 'currentContainer' : $scope.currentContainer, 'selectedItems' : $scope.selectedItems };
            if ($scope.buttons) {
                for (var buttonLabel in $scope.buttons) {
                    var button = $scope.buttons[buttonLabel];

                    if (button.moreButtons){
                        for (var subButton in button.moreButtons){
                            checkDisable(button.moreButtons[subButton], gridData);
                        }
                    }

                    checkDisable(button, gridData);
                }
            }
            if (gridData.selectedItems && gridData.selectedItems.length === 0){
                var selectAllHeader = angular.element('.ngSelectionHeader').scope();
                if (selectAllHeader){
                    selectAllHeader.allSelected = false;
                }
            }
        };

        if (!$scope.selectedItems) {
            $scope.selectedItems = [];
        }

        $scope.$watchCollection('selectedItems', onGridSelectionChanged);
        $scope.$watch('currentContainer', onGridSelectionChanged);
    };

    storageGridController.$inject = ['$rootScope', '$scope', '$q', '$translate', 'dmsStorageGridService', '$timeout', '$domUtilityService'];
    bmoonApp.controller('storageGridController', storageGridController);
})(window.angular, window._);

angular.module('bluemoon.dms.storage-grid.templates', ['components/storage-grid/storage-cell-template.2js.html', 'components/storage-grid/storage-date-column-template.2js.html', 'components/storage-grid/storage-grid-template.2js.html', 'components/storage-grid/storage-name-cell-template.2js.html', 'components/storage-grid/storage-type-cell-template.2js.html', 'components/storage-grid/storage-year-column-template.2js.html']);

angular.module("components/storage-grid/storage-cell-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/storage-grid/storage-cell-template.2js.html",
    "<div class=\"ngCellText\" ng-class=\"col.colIndex()\">\n" +
    "    <a href=\"\" ng-href=\"{{row.entity.link}}\">\n" +
    "        {{row.getProperty(col.field)}}\n" +
    "    </a>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/storage-grid/storage-date-column-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/storage-grid/storage-date-column-template.2js.html",
    "<div class=\"ngCellText\" ng-class=\"col.colIndex()\">\n" +
    "    <span ng-cell-text>{{COL_FIELD | formatDateSmall}}</span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/storage-grid/storage-grid-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/storage-grid/storage-grid-template.2js.html",
    "<div class=\"storage-grid-container dataTables_wrapper\">\n" +
    "  <div class=\"bmoon-grid-style no-scroll-grid bmoon-grid-actions-included\"\n" +
    "      ng-grid=\"options\">\n" +
    "  </div>\n" +
    "  <div class=\"page-section-top dms-center-text\">\n" +
    "        {{ footerMessage }}\n" +
    "  </div>\n" +
    "  <div bento-pagination\n" +
    "     page=\"currentInfo.page\"\n" +
    "     on-change=\"currentInfo.onPageChanged(page)\"\n" +
    "     direction-links=\"true\"\n" +
    "     boundary-links=\"true\"\n" +
    "     total-items=\"currentInfo.totalItems\"\n" +
    "     items-array=\"selectInfo\"\n" +
    "     on-change-size=\"currentInfo.onSelectChanged(size)\"\n" +
    "     items-per-page=\"currentInfo.numItems\">\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/storage-grid/storage-name-cell-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/storage-grid/storage-name-cell-template.2js.html",
    "<div class=\"ngCellText\" ng-class=\"col.colIndex()\"\n" +
    "  dms-drag-over\n" +
    "  dms-drag-over-class=\"over-cell\"\n" +
    "  dms-drop\n" +
    "  dms-item=\"{{row.entity}}\" ng-attr-id=\"{{getNameCellId(row)}}\">\n" +
    "    <a href=\"\" ng-href=\"{{row.entity.link}}\"\n" +
    "       uib-tooltip=\"{{getNameTooltip(row.entity.name, row.rowIndex)}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">\n" +
    "        {{row.getProperty(col.field)}}\n" +
    "    </a>\n" +
    "    <span ng-if=\"row.entity.lock\" class=\"bento-icon-lock dms-lock-icon\"\n" +
    "    	uib-tooltip=\"{{getLockTooltip(row.entity)}}\" tooltip-placement=\"top\"\n" +
    "    	tooltip-append-to-body=\"true\">\n" +
    "    </span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/storage-grid/storage-type-cell-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/storage-grid/storage-type-cell-template.2js.html",
    "<div class=\"ngCellText\" ng-class=\"col.colIndex()\">\n" +
    "    <span uib-tooltip=\"{{ getProductType(row.entity) }}\" tooltip-append-to-body=\"true\">\n" +
    "      <i ng-class=\"getStorageIcon(row.entity)\"></i>\n" +
    "    </span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/storage-grid/storage-year-column-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/storage-grid/storage-year-column-template.2js.html",
    "<div class=\"ngCellText\" ng-class=\"col.colIndex()\">\n" +
    "    <span ng-cell-text>{{getYear(row.entity.processingYear)}}</span>\n" +
    "</div>\n" +
    "");
}]);

(function(angular) {
  'use strict';

  var DmsInternalToolbarService = (function() {
    var _$inject = ['$q', '$translate'];

    function DmsInternalToolbarServiceImpl($q, $translate) {
      var service = this;

      service._requireScope = function(scope) {
        if (!scope) {
          throw new Error('scope object required.');
        }
      };

      service.loadStringForSearchText = function(scope) {
        service._requireScope(scope);

        if (!scope.searchInfo || !scope.searchInfo.term) {
          return $translate('Bluemoon.DMS.Toolbar.Search').then(function(s){
              scope.SearchText = s;
          });
        }

        var defer = $q.defer();
        defer.resolve();
        return defer.promise;
      };

      service.loadStringForMenuButtonText = function(scope) {
        service._requireScope(scope);

        return $translate('Bluemoon.DMS.Toolbar.Menu').then(function(s){
          scope.MenuButtonText = s;
        });
      };

      service.loadStringForSearchToggleText = function(scope) {
        service._requireScope(scope);

        return $translate('Bluemoon.DMS.Toolbar.SearchWithinResults').then(function(s){
          scope.searchToggleText = s;
        });
      };

      service.loadStrings = function(scope) {
        service.loadStringForSearchText(scope);
        service.loadStringForMenuButtonText(scope);
        service.loadStringForSearchToggleText(scope);
      };

      return service;
    }

    DmsInternalToolbarServiceImpl.$inject = _$inject;
    return DmsInternalToolbarServiceImpl;
  }());

  var DmsToolbarDirective = (function() {
    var _$inject = ['$window', '$timeout', '$q', '$translate', 'bmAnalyticsService', 'dmsInternalToolbarService', 'dmsToolbarConfig', 'dmsSearchGetSet', 'bmAccess', '$state'];

    function DmsToolbarDirectiveImpl($window, $timeout, $q, $translate, analyticsService, toolbarService, toolbarConfig, dmsSearchGetSet, bmAccess, $state) {
      return {
        restrict: 'EA',
        replace: true,
        scope: {
          buttons: '=',
          onSearchEnter: '=',
          onSearch: '&',
          searchTerm: '=',
          hasSearchToggle: '@',
          toggleState: '='
        },
        template: '<div>' +
                    '<div bento-toolbar class="navbar navbar-default bento-toolbar" ng-class="{\'dms-search-bar\': hasSearchToggle, \'dms-no-more\': hideMoreButton}" toolbar-data="toolbarButtons" aria-controls="tableDms2">' +
                      '<div class="nav navbar-right">' +
                        '<div ng-if="hasSearch" class="dms-search-form-flex">' +
                          '<form role="search">' +
                            '<div class="form-group">' +
                              '<label class="sr-only" for="dms-toolbar-search-input">{{SearchText}}</label>' +
                              '<i class="bento-icon-search"></i>' +
                              '<input type="search" id="dms-toolbar-search-input" bento-reset class="form-control" placeholder="{{SearchText}}" ng-keypress="keySelectPage($event)" ng-model="searchInfo.term" ng-change="searchTextChanged()" autocomplete="off" />' +
                            '</div>' +
                          '</form>' +
                        '</div>' +
                        '<div ng-if="hasSearchToggle && hasSearch" class="dms-search-toggle">' +
                          '<div class="dms-search-toggle-text">{{searchToggleText}}</div>' +
                          '<div bento-toggle ng-model="toggleState" on-change="onToggleChange(value)"></div>' +
                        '</div>' +
                      '</div>' +
                    '</div>' +
                    '<table id="tableDms2">' +
                    '</table>' +
                  '</div>',
        link: function(scope, element, attrs){
          scope.status = [];

          // hack - add an empty button for bento toolbar initialization
          scope.toolbarButtons = [{
            label: '',
            icon: '',
            disabled: true,
            isVisible: false
          }];

          // hack - hide more button when only a search bar
          scope.hideMoreButton = true;

          // watch method here will look for value changes in canShow
          // and update toolbar accordingly
          scope.$watch('buttons', function(newVal){
            if(angular.isUndefined(newVal) || newVal.length === 0){
              return;
            }

            // reset toolbarButtons
            scope.toolbarButtons.length = 0;
            scope.hideMoreButton = false;

            scope.buttons.forEach(function(button){
              button.display = false;

              var toolbarButton = {
                label: button.text,
                icon: button.icon,
                disabled: button.disabled === true,
                click: button.click,
                analyticsEvent: button.analyticsEvent,
                action: function() {
                  scope.handleClick(toolbarButton);
                }
              };

              scope.toolbarButtons.push(toolbarButton);
              var i = scope.toolbarButtons.indexOf(toolbarButton);

              $q.when(button.canShow).then(function(result){
                button.display = result === undefined ? true: result;

                if(button.display !== true){
                  scope.toolbarButtons.splice(i, 1);
                }
              },function(){
                button.display = false;
                scope.toolbarButtons.splice(i, 1);
              });

              if(button.moreButtons){
                toolbarButton.dropdown = [];

                button.moreButtons.forEach(function(moreButton){
                  moreButton.display = false;

                  var toolbarMore = {
                    label: moreButton.text,
                    icon: moreButton.icon,
                    disabled: moreButton.disabled === true,
                    click: moreButton.click,
                    analyticsEvent: moreButton.analyticsEvent,
                    action: function() {
                      scope.handleClick(toolbarMore);
                    }
                  };

                  toolbarButton.dropdown.push(toolbarMore);
                  var j;

                  $q.when(moreButton.canShow).then(function(result){
                    moreButton.display = result === undefined ? true: result;

                    if(moreButton.display !== true){
                      j = toolbarButton.dropdown.indexOf(toolbarMore);
                      toolbarButton.dropdown.splice(j, 1);
                    }
                  },function(){
                    moreButton.display = false;
                    j = toolbarButton.dropdown.indexOf(toolbarMore);
                    toolbarButton.dropdown.splice(j, 1);
                  });
                });
              }

              // scope.toolbarButtons.push(toolbarButton);
            });
          }, true);

          scope.searchEnabled = null;

          bmAccess.has('DMS_HideSearch').then(function() {
            scope.searchEnabled = false;
          }, function() {
            scope.searchEnabled = true;
          });

          scope.searchInfo = {};
          if($state.current.name.toLowerCase().match('search')){
            scope.searchTerm = dmsSearchGetSet.getSearchTerm();
          }

          if (scope.searchTerm) {
            scope.SearchText = scope.searchTerm;
            scope.searchInfo.term = scope.SearchText;
          } else {
            scope.searchInfo.term = '';
          }

          toolbarService.loadStrings(scope);

          scope.$on('bmLanguageChangeSuccess', function(){
            toolbarService.loadStrings(scope);
          });

          scope.hasSearch = attrs.onSearch !== undefined || attrs.onSearchEnter !== undefined;

          if (scope.buttons && scope.buttons.length !== undefined){
            for (var i = 0; i < scope.buttons.length; i++){
              scope.status.push(false);
            }
          }

          scope.searchTextChanged = function(){
            toolbarService.loadStringForSearchText(scope);
          };

          scope.onToggleChange = function(value){
            scope.toggleState = value;
          };

          scope.clearSearch = function(){
            scope.searchInfo.term = '';
            scope.searchTextChanged();
            document.getElementById('dms-toolbar-search-input').focus();
          };

          scope.handleClick = function(button){
            if (button.disabled) {return;}

            if (button.click !== undefined){
              if (toolbarConfig.analytics && button.analyticsEvent) {
                analyticsService.track(button.analyticsEvent, button.analyticsProperties);
              }

              button.click();
            }
          };

          var collapseAllDropdowns = function($event){
            var elt = document.elementFromPoint($event.pageX, $event.pageY);
            if (elt && elt.className.indexOf('dms-toolbar-button') === -1 &&
              scope.buttons !== undefined) {
              //  timeout with no time set is equivalent to executing the function
              //  after the last digest cycle is complete.  This avoids a bug with
              //  the upload button causing the "digest already executing" error.
              $timeout(function(){
                scope.toggleMoreDropdown = false;

                if($window.innerWidth >= 768){
                  for (var i = 0; i < scope.buttons.length; i++){
                    scope.status[i] = false;
                    angular.element(element[0].childNodes[0].childNodes[0].children[i]).removeClass('active-button');
                  }
                } else {
                  for (var j = 0; j < scope.buttons.length; j++){
                    scope.status[j] = false;
                    angular.element(element[0].childNodes[0].childNodes[0].children[0].children[1].children[j]).removeClass('nested-active-button');
                  }
                  angular.element(document.getElementById('dms-menu-dropdown')).removeClass('active-button');
                }
              });
            }
          };

          $window.addEventListener('click', collapseAllDropdowns, false);

          scope.$on('$destroy', function cleanup(){
            $window.removeEventListener('click', collapseAllDropdowns);
          });

          scope.toggleDropdown = function($index){
            for (var i = 0; i < scope.buttons.length; i++){
              if (i !== $index){
                scope.status[i] = false;
              }
            }

            scope.status[$index] = !scope.status[$index];
            if (scope.status[$index] === true){
              if($window.innerWidth >= 768){
                for (i = 0; i < scope.buttons.length; i++){
                    if(i !== $index){
                      angular.element(element[0].childNodes[0].childNodes[0].children[i]).removeClass('active-button');
                    }
                }
              } else {
                for (i = 0; i < scope.buttons.length; i++){
                  if(i !== $index){
                    angular.element(element[0].childNodes[0].childNodes[0].children[0].children[1].children[i]).removeClass('nested-active-button');
                  }
                }
              }

              if($window.innerWidth >= 768){
                element[0].childNodes[0].childNodes[0].children[$index].className += ' active-button';
              } else {
                element[0].childNodes[0].childNodes[0].children[0].children[1].children[$index].className += ' nested-active-button';
              }
            } else {
              if($window.innerWidth >= 768){
                angular.element(element[0].childNodes[0].childNodes[0].children[$index]).removeClass('active-button');
              } else {
                angular.element(element[0].childNodes[0].childNodes[0].children[0].children[1].children[$index]).removeClass('nested-active-button');
              }
            }
          };

          scope.toggleMenu = function(){
            scope.toggleMoreDropdown = !scope.toggleMoreDropdown;

            var button = document.getElementById('dms-menu-dropdown');

            if (scope.toggleMoreDropdown){
              button.className += ' active-button';
            } else {
              angular.element(button).removeClass('active-button');
            }
          };

          scope.keySelectPage = function(ev) {
            if (scope.searchInfo.term !== '' && scope.searchInfo.term !== undefined && ev.which === 13) {
              scope.onSearchEnter(scope.searchInfo.term);
            }
          };
        }
      };
    }

    DmsToolbarDirectiveImpl.$inject = _$inject;
    return DmsToolbarDirectiveImpl;
  }());

  var DmsToolbarConfigProvider = (function(){
    function DmsToolbarConfigProviderImpl() {
      var provider = this;
      provider.analytics = false;
      provider.$get = function() {
        return provider;
      };
    }

    return DmsToolbarConfigProviderImpl;
  })();

  angular.module('bluemoon.dms.toolbar', [
    'bento.nav.toolbar',
    'pascalprecht.translate',
    'bluemoon.components.analytics',
    'bmAccess'
  ])

  .provider('dmsToolbarConfig', DmsToolbarConfigProvider)
  .service('dmsInternalToolbarService', DmsInternalToolbarService)
  .directive('dmsToolbar', DmsToolbarDirective);
})(window.angular);

(function(angular){
    'use strict';

    var DmsServiceStatus = (function(){
        var _$inject = ['bluemoon.components.httpStatusCodes'];

        function DmsServiceStatusImpl(httpStatusCodeConstants) {

            var service = this;

            service.get = function(httpStatusCode) {
                var status;

                switch(httpStatusCode) {
                    case httpStatusCodeConstants.ok:          // 200
                        status = 'ok';
                        break;
                    case httpStatusCodeConstants.created:     // 201
                        status = 'created';
                        break;
                    case httpStatusCodeConstants.noContent:   // 204
                        status = 'no-content';
                        break;
                    case httpStatusCodeConstants.forbidden:   // 403
                        status = 'forbidden';
                        break;
                    case httpStatusCodeConstants.conflict:    // 409
                        status = 'conflict';
                }

                if (!status) {
                    if (httpStatusCode >= 400 && httpStatusCode < 500) {
                        status = 'error';
                    } else if (httpStatusCode >= 500) {
                        status = 'server-error';
                    }
                }

                return status;
            };

        }

        DmsServiceStatusImpl.$inject = _$inject;
        return DmsServiceStatusImpl;
    }());

    var DmsDataService = (function() {
        var _$inject = ['$q', 'dmsHttp', 'dmsServiceStatus'];

        function DmsDataServiceImpl($q, dmsHttp, dmsServiceStatus) {

            var service = this;

            service._successfulResponseCallback = function(response) {
                return {
                    response: response,
                    serviceStatus: dmsServiceStatus.get(response.httpStatusCode),
                    data: response.data,
                    currentItemCount: response.currentItemCount,
                    itemsPerPage: response.itemsPerPage,
                    startIndex: response.startIndex,
                    totalItems: response.totalItems,
                    pageIndex: response.pageIndex,
                    totalPages: response.totalPages,
                    message: response.message
                };
            };

            service._errorResponseCallback = function(response) {
                return $q.reject({
                    response: response,
                    serviceStatus: dmsServiceStatus.get(response.httpStatusCode),
                    error: response.error
                });
            };

            service._makeRequest = function(httpConfig) {
                return dmsHttp.makeHttpRequest(httpConfig)
                    .then(service._successfulResponseCallback, service._errorResponseCallback);
            };

            service.get = function(config) {
                var conf = config || {};

                var uri = conf.uri;
                if (!uri) {
                    throw new Error('uri is required');
                }

                var httpConfig = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'Compress-Data': 'true',
                        'Accept': 'application/json',
                    },
                    url: uri,
                    cache: false
                };

                var timeout = conf.timeout;
                if (timeout) {
                    httpConfig.timeout = timeout;
                }

                var params = conf.params;
                if (params) {
                    httpConfig.params = params;
                }

                return service._makeRequest(httpConfig);
            };

            service.put = function(config) {
                var conf = config || {};

                var uri = conf.uri;
                if (!uri) {
                    throw new Error('uri is required');
                }

                var httpConfig = {
                    method: 'PUT',
                    url: uri,
                    data: conf.data,
                    cache: false,
                };

                var timeout = conf.timeout;
                if (timeout) {
                    httpConfig.timeout = timeout;
                }

                var params = conf.params;
                if (params) {
                    httpConfig.params = params;
                }

                return service._makeRequest(httpConfig);
            };

            service.post = function(config) {
                var conf = config || {};

                var uri = conf.uri;
                if (!uri) {
                    throw new Error('uri is required');
                }

                var httpConfig = {
                    method: 'POST',
                    url: uri,
                    data: conf.data,
                    cache: false,
                };

                var timeout = conf.timeout;
                if (timeout) {
                    httpConfig.timeout = timeout;
                }

                var params = conf.params;
                if (params) {
                    httpConfig.params = params;
                }

                return service._makeRequest(httpConfig);
            };

            service.delete = function(config) {
                var conf = config || {};

                var uri = conf.uri;
                if (!uri) {
                    throw new Error('uri is required');
                }

                var httpConfig = {
                    method: 'DELETE',
                    url: uri,
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'Compress-Data': 'true'
                    }
                };

                var timeout = conf.timeout;
                if (timeout) {
                    httpConfig.timeout = timeout;
                }

                var params = conf.params;
                if (params) {
                    httpConfig.params = params;
                }

                return service._makeRequest(httpConfig);
            };
        }

        DmsDataServiceImpl.$inject = _$inject;
        return DmsDataServiceImpl;
    }());

    angular.module('bluemoon.dms.data-services',
        ['bluemoon.components.httpStatusCodes', 'bmUser', 'bluemoon.dms.http', 'csEmployeeV2'])

    .service('dmsServiceStatus', DmsServiceStatus)

    .service('dmsDataService', DmsDataService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsClientDataService = (function() {
        var _$inject = ['bmUser', 'dmsHttp', 'dmsDataService'];

        function DmsClientDataServiceImpl(bmUser, dmsHttp, dmsDataService) {

            var service = this;

            service.get = function(clientId) {
                return bmUser.load().then(function(){
                    return dmsDataService.get({
                        uri: '/api/core/v3/companies/' + bmUser.companyId + '/clients/' + clientId
                    }).then(function(result){
                        result.data.itemType = 'Client';
                        return result;
                    });
                });
            };

            service.getChildren = function(clientId) {
                return dmsDataService.get({
                    uri: '/api/storage/v1/projects',
                    params: {
                        primaryAssociationId: clientId,
                        primaryAssociationType: 'Client',
                    }
                });
            };
        }

        DmsClientDataServiceImpl.$inject = _$inject;
        return DmsClientDataServiceImpl;
    }());

    angular.module('bluemoon.dms.data-services')

    .service('dmsClientDataService', DmsClientDataService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsEmployeeDataService = (function() {
        var _$inject = ['csEmployeeV2'];

        function DmsEmployeeDataServiceImpl(csEmployeeV2) {

            var service = this;

            service.all = function() {
                return csEmployeeV2.getList({companyId: ''});
            };
        }

        DmsEmployeeDataServiceImpl.$inject = _$inject;
        return DmsEmployeeDataServiceImpl;
    }());

    angular.module('bluemoon.dms.data-services')

    .service('dmsEmployeeDataService', DmsEmployeeDataService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsDocumentDataService = (function() {
        var _$inject = ['dmsDataService'];

        function DmsDocumentDataServiceImpl(dmsDataService) {

            var service = this;

            service.add = function(container, documentData) {
                var uri;

                if (container.type === 'Project') {
                    uri = '/api/storage/v1/projects/' + container.id + '/documents/fromtemplate';
                } else {
                    uri = '/api/storage/v1/folders/' + container.id + '/documents/fromtemplate';
                }

                var documentPayload = {
                    documentType:     documentData.type,
                    name:             documentData.name
                };

                if (typeof documentData.metaData !== 'undefined' && typeof documentData.metaData !== null) {
                    documentPayload.documentMetaData = {
                        reference: documentData.metaData.documentReference,
                        staffAssignment: documentData.metaData.documentStaffAssignment,
                        rollForward: documentData.metaData.documentRollForward,
                        deleteOnFinalize: documentData.metaData.documentDeleteOnFinalize
                    };
                }

                return dmsDataService.post({
                    uri: uri,
                    data: JSON.stringify(documentPayload)
                });
            };

            service.delete = function(containerId, containerType, documentId){
                return dmsDataService.delete({
                    uri: '/api/storage/v1/' + containerType + '/' + containerId + '/documents/' + documentId,
                    timeout: 1000 * 60 * 15  //  Slow operation, so set a long timeout
                });
            };

            service.get = function(container, id, options) {

                var opt = options || {};

                var uri;
                if (container.type === 'Project') {
                    uri = '/api/storage/v1/projects/' + container.id + '/documents/' + id;
                } else {
                    uri = '/api/storage/v1/folders/' + container.id + '/documents/' + id;
                }

                return dmsDataService.get({
                    uri: uri,
                    params: {
                        includeDownloadUrl: opt.includeDownloadUrl
                    }
                });
            };

            service.getFromAccessToken = function(accessToken) {

                return dmsDataService.get({
                    uri: '/api/storage/v1/sharing/share',
                    params: {
                        token: accessToken
                    },
                    bmNoAuth: true
                });
            };

            service.getExists = function(containerId, containerType, documentNamesArr){
                return dmsDataService.post({
                    uri: '/api/storage/v1/' + containerType + '/' + containerId + '/documents/exists',
                    data: JSON.stringify(documentNamesArr)
                });
            };
        }

        DmsDocumentDataServiceImpl.$inject = _$inject;
        return DmsDocumentDataServiceImpl;
    }());

    angular.module('bluemoon.dms.data-services')

    .service('dmsDocumentDataService', DmsDocumentDataService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsFolderDataService = (function() {
        var _$inject = ['dmsHttp', 'dmsDataService'];

        function DmsFolderDataServiceImpl(dmsHttp, dmsDataService) {

            var service = this;

            service.add = function(folder) {
                return dmsDataService.post({
                    uri: '/api/storage/v1/folders',
                    data: JSON.stringify(folder)
                });
            };

            service.get = function(folderId) {
                return dmsDataService.get({
                    uri: '/api/storage/v1/folders/' + folderId
                });
            };

            service.getChildren = function(folderId, pageState) {
                return dmsDataService.get({
                    uri: '/api/storage/v1/folders/' + folderId + '/children',
                    params: {
                        from: pageState.page,
                        pageSize: pageState.itemsPerPage,
                        sort: pageState.sort,
                    }
                });
            };

            service.delete = function(folderId) {
                return dmsDataService.delete({
                    uri: '/api/storage/v1/folders/' + folderId,
                    timeout: 1000 * 60 * 15  //  Slow operation, so set a long timeout
                });
            };

            service.getAncestors = function(folderId) {
                return dmsDataService.get({
                    uri: '/api/storage/v1/folders/' + folderId + '/ancestors'
                });
            };

            service.getExists = function(containerId, containerType, folderNamesArr){
                var request = {
                    containerId: containerId,
                    containerType: containerType,
                    folderNames: folderNamesArr
                };

                return dmsDataService.post({
                    uri: '/api/storage/v1/folders/exists',
                    data: JSON.stringify(request)
                });
            };

        }

        DmsFolderDataServiceImpl.$inject = _$inject;
        return DmsFolderDataServiceImpl;
    }());

    angular.module('bluemoon.dms.data-services')

    .service('dmsFolderDataService', DmsFolderDataService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsProjectDataService = (function() {
        var _$inject = ['dmsDataService'];

        function DmsProjectDataServiceImpl(dmsDataService) {

            var service = this;

            service.add = function(project) {
                return dmsDataService.post({
                    uri: '/api/storage/v1/projects',
                    data: JSON.stringify(project)
                });
            };

            service.get = function(projectId) {
                return dmsDataService.get({
                    uri: '/api/storage/v1/projects/' + projectId
                });
            };

            service.getChildren = function(projectId, pageState) {
                return dmsDataService.get({
                    uri: '/api/storage/v1/projects/' + projectId + '/children',
                    params: {
                        from: pageState.page,
                        pageSize: pageState.itemsPerPage,
                        sort: pageState.sort,
                    }
                });
            };

            service.copy = function(project, sourceId) {
                return dmsDataService.post({
                    uri: '/api/storage/v1/projects/' + sourceId + '/copy',
                    data: JSON.stringify(project),
                    timeout: 1000 * 60 * 15 // copy can be slow, extend the timeout to 15 minutes
                });
            };
        }

        DmsProjectDataServiceImpl.$inject = _$inject;
        return DmsProjectDataServiceImpl;
    }());

    angular.module('bluemoon.dms.data-services')

    .service('dmsProjectDataService', DmsProjectDataService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsItemDataService = (function() {
        var _$inject = ['dmsDataService'];

        function DmsItemDataServiceImpl(dmsDataService) {

            var service = this;

            service.send = function(sharingRequest) {
                return dmsDataService.post({
                    uri: '/api/storage/v2/sharing/share',
                    data: JSON.stringify(sharingRequest),
                });
            };

            service.getRecent = function(options) {
                var opt = options || {};

                return dmsDataService.get({
                    uri: '/api/storage/v1/recents/documents',
                    params: opt
                });
            };
        }

        DmsItemDataServiceImpl.$inject = _$inject;
        return DmsItemDataServiceImpl;
    }());

    angular.module('bluemoon.dms.data-services')

    .service('dmsItemDataService', DmsItemDataService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsRecycleBinDataService = (function() {
        var _$inject = ['dmsDataService'];

        function DmsRecycleBinDataServiceImpl(dmsDataService) {

            var service = this;

            service.getRecycleList = function(options) {
                var opt = options || {};

                return dmsDataService.get({
                    uri: '/api/storage/v1/trash/',
                    params: opt,
                });
            };

            service.moveDocumentToTrash = function(options) {
                var opt = options || {};

                return dmsDataService.post({
                    uri: '/api/storage/v1/trash/documents',
                    data: JSON.stringify(opt),
                });
            };

            service.deleteDocument = function(trashId) {
                return dmsDataService.delete({
                    uri: '/api/storage/v1/trash/documents/' + trashId,
                    timeout: 1000 * 60 * 15  //  Slow operation, so set a long timeout
                });
            };

            service.restoreDocument = function(trashId, restoreItemRequest) {
                return dmsDataService.post({
                    uri: '/api/storage/v1/trash/documents/' + trashId,
                    data: JSON.stringify(restoreItemRequest),
                    timeout: 1000 * 60 * 15  //  Slow operation, so set a long timeout
                });
            };

            service.moveFolderToTrash = function(options) {
                var opt = options || {};

                return dmsDataService.post({
                    uri: '/api/storage/v1/trash/folders',
                    data: JSON.stringify(opt),
                });
            };

            service.deleteFolder = function(trashId) {
                return dmsDataService.delete({
                    uri: '/api/storage/v1/trash/folders/' + trashId,
                    timeout: 1000 * 60 * 15  //  Slow operation, so set a long timeout
                });
            };

            service.restoreFolder = function(trashId, restoreItemRequest) {
                return dmsDataService.post({
                    uri: '/api/storage/v1/trash/folders/' + trashId,
                    data: JSON.stringify(restoreItemRequest),
                    timeout: 1000 * 60 * 15  //  Slow operation, so set a long timeout
                });
            };
        }

        DmsRecycleBinDataServiceImpl.$inject = _$inject;
        return DmsRecycleBinDataServiceImpl;
    }());

    angular.module('bluemoon.dms.data-services')

    .service('dmsRecycleBinDataService', DmsRecycleBinDataService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsRequestsDataService = (function() {
        var _$inject = ['dmsDataService'];

        function DmsRequestsDataServiceImpl(dmsDataService) {

            var service = this;

            service.get = function(requestId) {
                return dmsDataService.get({
                    uri: '/api/storage/v1/requests/' + requestId
                });
            };

            service.getList = function(options) {
                var opt = options || {};

                return dmsDataService.get({
                    uri: '/api/storage/v1/requests',
                    params: opt
                });
            };

            service.add = function(request) {
                return dmsDataService.post({
                    uri: '/api/storage/v1/requests',
                    data: JSON.stringify(request)
                });
            };

            service.edit = function(request) {
                return dmsDataService.put({
                    uri: '/api/storage/v1/requests/' + request.id,
                    data: JSON.stringify(request)
                });
            };

            service.delete = function(requestId) {
                return dmsDataService.delete({
                    uri: '/api/storage/v1/requests/' + requestId,
                    timeout: 1000 * 60 * 15  //  Slow operation, so set a long timeout
                });
            };

            service.sendEmail = function(id, emailRequest) {
                return dmsDataService.post({
                    uri: '/api/storage/v1/requests/' + id + '/email',
                    data: JSON.stringify(emailRequest)
                });
            };

            service.view = function(token) {
                return dmsDataService.get({
                    uri: '/api/storage/v1/requests/view',
                    params: {
                        token: token
                    }
                });
            };

        }

        DmsRequestsDataServiceImpl.$inject = _$inject;
        return DmsRequestsDataServiceImpl;
    }());

    angular.module('bluemoon.dms.data-services')

    .service('dmsRequestsDataService', DmsRequestsDataService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsSearchDataService = (function() {
        var _$inject = ['dmsDataService', 'searchManager'];

        function DmsSearchDataServiceImpl($q, searchManager) {

            var service = this;

            service.getAggregatedSearchResults = function(options) {

                return searchManager.getAggregatedSearchResults(options);

            };
        }

        DmsSearchDataServiceImpl.$inject = _$inject;
        return DmsSearchDataServiceImpl;
    }());

    angular.module('bluemoon.dms.data-services')

    .service('dmsSearchDataService', DmsSearchDataService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsSubRequestsDataService = (function() {
        var _$inject = ['dmsDataService'];

        function DmsSubRequestsDataServiceImpl(dmsDataService) {

            var service = this;

            service.getList = function(requestId, options) {
                var opt = options || {};

                return dmsDataService.get({
                    uri: '/api/storage/v1/requests/' + requestId + '/subrequests',
                    params: opt
                });
            };

            service.add = function(requestId, subRequest) {
                return dmsDataService.post({
                    uri: '/api/storage/v1/requests/' + requestId + '/subrequests',
                    data: JSON.stringify(subRequest)
                });
            };

            service.delete = function(requestId, subRequestId) {
                return dmsDataService.delete({
                    uri: '/api/storage/v1/requests/' + requestId + '/subrequests/' + subRequestId,
                    timeout: 1000 * 60 * 15  //  Slow operation, so set a long timeout
                });
            };

            service.edit = function(requestId, subRequest, options) {
                var opt = options || {};

                return dmsDataService.put({
                    uri: '/api/storage/v1/requests/' + requestId + '/subrequests/' + subRequest.id,
                    params: opt,
                    data: JSON.stringify(subRequest)
                });
            };

            service.get = function(requestId, subRequestId) {
                return dmsDataService.get({
                    uri: '/api/storage/v1/requests/' + requestId + '/subrequests/' + subRequestId
                });
            };
        }

        DmsSubRequestsDataServiceImpl.$inject = _$inject;
        return DmsSubRequestsDataServiceImpl;
    }());

    angular.module('bluemoon.dms.data-services')

    .service('dmsSubRequestsDataService', DmsSubRequestsDataService);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.services', ['bluemoon.dms.data-services']);

})(window.angular);

(function(angular){
    'use strict';

    var DmsClientService = (function() {
        var _$inject = ['dmsClientDataService'];

        function DmsClientServiceImpl(dmsClientDataService) {

            var service = this;

            service.get = function(clientId) {
                if (!angular.isString(clientId)) {
                    throw new Error('clientId is a required parameter');
                }

                return dmsClientDataService.get(clientId);
            };

            service.getChildren = function(clientId) {
                if (!angular.isString(clientId)) {
                    throw new Error('clientId is a required parameter');
                }

                return dmsClientDataService.getChildren(clientId);
            };
        }

        DmsClientServiceImpl.$inject = _$inject;
        return DmsClientServiceImpl;
    }());

    angular.module('bluemoon.dms.services')

    .service('dmsClientService', DmsClientService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsDocumentService = (function() {
        var _$inject = ['dmsDocumentDataService', '$q'];

        function DmsDocumentServiceImpl(dmsDocumentDataService, $q) {

            var service = this;

            service.get = function(container, documentId, options) {
                if (!container) {
                    throw new Error('container is a required parameter');
                }

                if (!angular.isString(container.type) || !angular.isString(container.id)) {
                    throw new Error('container must include a type and id');
                }

                if (!angular.isString(documentId)) {
                    throw new Error('documentId is a required parameter');
                }

                return dmsDocumentDataService.get(container, documentId, options);
            };

            /*For creating Word/Excel files*/
            service.add = function(container, documentData) {
                //add validation code
                if (!container) {
                    throw new Error('container is a required parameter');
                }

                if (!angular.isString(container.type) || !angular.isString(container.id)) {
                    throw new Error('container must include a type and id');
                }

                if (!documentData) {
                    throw new Error('documentData is a required parameter');
                }

                if (!angular.isString(documentData.type) || !angular.isString(documentData.name)) {
                    throw new Error('documentData must include a type and name');
                }

                return dmsDocumentDataService.add(container, documentData);
            };

            service.delete = function(containerId, containerType, documentId) {
                if (!angular.isString(containerId)) {
                    throw new Error('containerId is a required parameter');
                }

                if (!angular.isString(containerType)) {
                    throw new Error('containerType is a required parameter');
                }

                if (!angular.isString(documentId)) {
                    throw new Error('documentId is a required parameter');
                }

                return dmsDocumentDataService.delete(containerId, containerType, documentId);
            };

            service.getFromAccessToken = function(accessToken, options) {
                if (!angular.isString(accessToken)) {
                    throw new Error('accessToken is a required parameter');
                }

                return dmsDocumentDataService.getFromAccessToken(accessToken, options);
            };

            service.getExists = function(containerId, containerType, documentNamesArr) {
                if (!angular.isString(containerId)) {
                    throw new Error('containerId is a required parameter');
                }

                if (!angular.isString(containerType)) {
                    throw new Error('containerType is a required parameter');
                }

                if (!documentNamesArr || documentNamesArr.length === 0) {
                    throw new Error('documentNamesArr is a required parameter');
                }

                return dmsDocumentDataService.getExists(containerId, containerType, documentNamesArr);
            };

            var _findNameRecursive = function(parentId, parentType, documentName, depth, deferred){
                var fileExtension = documentName.split('.').pop();
                var filenameWithoutExtension = documentName.substring(0, documentName.indexOf('.' + fileExtension));
                var testName = documentName;
                if (depth) {
                    var depthString = ' (' + depth + ')';
                    testName = filenameWithoutExtension + depthString + '.' + fileExtension;
                }

                // Check if file exists
                service.getExists(parentId, parentType, [testName]).then(function(result){
                    if(result.data) {
                        var exists = result.data[0].exists;
                        if(exists) {
                            depth++;
                            _findNameRecursive(parentId, parentType, documentName, depth, deferred);
                        } else {
                            deferred.resolve(testName);
                        }
                    } else {
                        deferred.resolve(testName);
                    }
                });

                return deferred.promise;
            };

            service.findName = function(containerId, containerType, documentName){
                return _findNameRecursive(containerId, containerType, documentName, 0, $q.defer());
            };
        }

        DmsDocumentServiceImpl.$inject = _$inject;
        return DmsDocumentServiceImpl;
    }());

    angular.module('bluemoon.dms.services')

    .service('dmsDocumentService', DmsDocumentService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsEmployeeService = (function() {
        var _$inject = ['dmsEmployeeDataService'];

        function DmsEmployeeServiceImpl(dmsEmployeeDataService) {

            var service = this;

            service.all = function() {
                return dmsEmployeeDataService.all();
            };
        }

        DmsEmployeeServiceImpl.$inject = _$inject;
        return DmsEmployeeServiceImpl;
    }());

    angular.module('bluemoon.dms.services')

    .service('dmsEmployeeService', DmsEmployeeService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsFolderService = (function() {
        var _$inject = ['dmsFolderDataService', '$q'];

        function DmsFolderServiceImpl(dmsFolderDataService, $q) {

            var service = this;

            service.add = function(folder) {
                if (!folder) {
                    throw new Error('folder is a required parameter');
                }

                return dmsFolderDataService.add(folder);
            };

            service.get = function(folderId) {
                if (!angular.isString(folderId)) {
                    throw new Error('folderId is a required parameter');
                }

                return dmsFolderDataService.get(folderId);
            };

            service.getChildren = function(folderId, pageState) {
                if (!angular.isString(folderId)) {
                    throw new Error('folderId is a required parameter');
                }

                return dmsFolderDataService.getChildren(folderId, pageState);
            };

            service.delete = function(folderId) {
                if (!angular.isString(folderId)) {
                    throw new Error('folderId is a required parameter');
                }

                return dmsFolderDataService.delete(folderId);
            };

            service.getAncestors = function(folderId) {
                if (!angular.isString(folderId)) {
                    throw new Error('folderId is a required parameter');
                }

                return dmsFolderDataService.getAncestors(folderId);
            };

            service.getExists = function(containerId, containerType, folderNamesArr) {
                if (!angular.isString(containerId)) {
                    throw new Error('containerId is a required parameter');
                }

                if (!angular.isString(containerType)) {
                    throw new Error('containerType is a required parameter');
                }

                if (!folderNamesArr || folderNamesArr.length === 0) {
                    throw new Error('folderNamesArr is a required parameter');
                }

                return dmsFolderDataService.getExists(containerId, containerType, folderNamesArr);
            };

            var _findNameRecursive = function(parentId, parentType, folderName, depth, deferred){
                var testName = folderName;
                if (depth) {
                    var depthString = ' (' + depth + ')';
                    testName = folderName + depthString;
                }

                // Check if file exists
                service.getExists(parentId, parentType, [testName]).then(function(result){
                    if(result.data) {
                        var exists = result.data[0].exists;
                        if(exists) {
                            depth++;
                            _findNameRecursive(parentId, parentType, folderName, depth, deferred);
                        } else {
                            deferred.resolve(testName);
                        }
                    } else {
                        deferred.resolve(testName);
                    }
                });

                return deferred.promise;
            };

            service.findName = function(containerId, containerType, folderName){
                return _findNameRecursive(containerId, containerType, folderName, 0, $q.defer());
            };
        }

        DmsFolderServiceImpl.$inject = _$inject;
        return DmsFolderServiceImpl;
    }());

    angular.module('bluemoon.dms.services')

    .service('dmsFolderService', DmsFolderService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsProjectService = (function() {
        var _$inject = ['dmsProjectDataService'];

        function DmsProjectServiceImpl(dmsProjectDataService) {

            var service = this;

            service.add = function(project) {
                if (!project) {
                    throw new Error('project is a required parameter');
                }

                return dmsProjectDataService.add(project);
            };

            service.get = function(projectId) {
                if (!angular.isString(projectId)) {
                    throw new Error('projectId is a required parameter');
                }

                return dmsProjectDataService.get(projectId);
            };

            service.getChildren = function(projectId, pageState) {
                if (!angular.isString(projectId)) {
                    throw new Error('projectId is a required parameter');
                }

                return dmsProjectDataService.getChildren(projectId, pageState);
            };

            service.copy = function(project, sourceId) {
                if (!project) {
                    throw new Error('project is a required parameter');
                }

                if (!sourceId) {
                    throw new Error('sourceId is a required parameter');
                }

                return dmsProjectDataService.copy(project, sourceId);
            };
        }

        DmsProjectServiceImpl.$inject = _$inject;
        return DmsProjectServiceImpl;
    }());

    angular.module('bluemoon.dms.services')

    .service('dmsProjectService', DmsProjectService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsItemService = (function() {
        var _$inject = ['dmsItemDataService'];

        function DmsItemServiceImpl(itemDataService) {

            var service = this;

            service.send = function(sharingRequest) {

                if (!sharingRequest.sharedItems) {
                    throw new Error('sharedItems is a required parameter');
                }

                if (!angular.isArray(sharingRequest.sharedItems) || sharingRequest.sharedItems.length === 0) {
                    throw new Error('sharedItems must be an array with length > 0');
                }

                if (!sharingRequest.receipents) {
                    throw new Error('receipents is a required parameter');
                }

                if (!angular.isArray(sharingRequest.receipents) || sharingRequest.receipents.length === 0) {
                    throw new Error('receipents must be an array with length > 0');
                }

                if(!sharingRequest.expirationPeriod){
                       throw new Error('expirationPeriod is a required parameter');
                   }

                if (!sharingRequest.language) {
                    throw new Error('language is a required parameter');
                }

                if(sharingRequest.language.length !== 2){
                    throw new Error('language must be exactly two characters long');
                }

                if (!sharingRequest.locale) {
                    throw new Error('locale is a required parameter');
                }

                if (sharingRequest.locale.length !== 2) {
                    throw new Error('locale must be exactly two characters long');
                }

                return itemDataService.send(sharingRequest);
            };

            service.getRecent = function(params) {
                return itemDataService.getRecent(params);
            };

        }

        DmsItemServiceImpl.$inject = _$inject;
        return DmsItemServiceImpl;
    }());

    angular.module('bluemoon.dms.services')

    .service('dmsItemService', DmsItemService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsRecycleBinService = (function() {
        var _$inject = ['dmsRecycleBinDataService'];

        function DmsRecycleBinServiceImpl(dmsRecycleBinDataService) {

            var service = this;

            service.getRecycleList = function(params) {
                return dmsRecycleBinDataService.getRecycleList(params);
            };

            service.moveDocumentToTrash = function(item) {
                if (!item) {
                    throw new Error('item is a required parameter');
                }

                if (!angular.isString(item.id)) {
                    throw new Error('id is a required parameter');
                }

                if (!angular.isString(item.containerType)) {
                    throw new Error('containerType is a required parameter');
                }

                if (!angular.isString(item.containerId)) {
                    throw new Error('containerId is a required parameter');
                }

                return dmsRecycleBinDataService.moveDocumentToTrash(item);
            };

            service.deleteDocument = function(trashId) {
                if (!angular.isString(trashId)) {
                    throw new Error('trashId is a required parameter');
                }

                return dmsRecycleBinDataService.deleteDocument(trashId);
            };

            service.restoreDocument = function(trashId, restoreItemRequest) {
                if (!angular.isString(trashId)) {
                    throw new Error('trashId is a required parameter');
                }

                if (!restoreItemRequest) {
                    throw new Error('restoreItemRequest is a required parameter');
                }

                if (!angular.isString(restoreItemRequest.destinationContainerId)) {
                    throw new Error('destinationContainerId is a required parameter');
                }

                if (!angular.isString(restoreItemRequest.destinationContainerType)) {
                    throw new Error('destinationContainerType is a required parameter');
                }

                return dmsRecycleBinDataService.restoreDocument(trashId, restoreItemRequest);
            };

            service.moveFolderToTrash = function(item) {
                if (!item) {
                    throw new Error('item is a required parameter');
                }

                if (!angular.isString(item.id)) {
                    throw new Error('id is a required parameter');
                }

                if (!angular.isString(item.containerType)) {
                    throw new Error('containerType is a required parameter');
                }

                if (!angular.isString(item.containerId)) {
                    throw new Error('containerId is a required parameter');
                }
                return dmsRecycleBinDataService.moveFolderToTrash(item);
            };

            service.deleteFolder = function(trashId) {
                if (!angular.isString(trashId)) {
                    throw new Error('trashId is a required parameter');
                }

                return dmsRecycleBinDataService.deleteFolder(trashId);
            };

            service.restoreFolder = function(trashId, restoreItemRequest) {
                if (!angular.isString(trashId)) {
                    throw new Error('trashId is a required parameter');
                }

                if (!restoreItemRequest) {
                    throw new Error('restoreItemRequest is a required parameter');
                }

                if (!angular.isString(restoreItemRequest.destinationContainerId)) {
                    throw new Error('destinationContainerId is a required parameter');
                }

                if (!angular.isString(restoreItemRequest.destinationContainerType)) {
                    throw new Error('destinationContainerType is a required parameter');
                }

                return dmsRecycleBinDataService.restoreFolder(trashId, restoreItemRequest);
            };

        }

        DmsRecycleBinServiceImpl.$inject = _$inject;
        return DmsRecycleBinServiceImpl;
    }());

    angular.module('bluemoon.dms.services')

    .service('dmsRecycleBinService', DmsRecycleBinService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsRequestsService = (function() {
        var _$inject = ['dmsRequestsDataService'];

        function DmsRequestsServiceImpl(dmsRequestsDataService) {

            var service = this;

            service.get = function(requestId) {
                if (!angular.isString(requestId)) {
                    throw new Error('requestId is a required parameter');
                }

                return dmsRequestsDataService.get(requestId);
            };

            service.getList = function(options) {
                return dmsRequestsDataService.getList(options);
            };

            service.add = function(request) {
                if (!request) {
                    throw new Error('request is a required parameter');
                }

                return dmsRequestsDataService.add(request);
            };

            service.edit = function(request) {
                if (!request) {
                    throw new Error('request is a required parameter');
                }

                return dmsRequestsDataService.edit(request);
            };

            service.delete = function(requestId) {
                if (!angular.isString(requestId)) {
                    throw new Error('requestId is a required parameter');
                }

                return dmsRequestsDataService.delete(requestId);
            };

            service.sendEmail = function(id, emailRequest) {
                if (!id) {
                    throw new Error('id is a required parameter');
                }

                if (!emailRequest) {
                    throw new Error('emailRequest is a required parameter');
                }

                if (!emailRequest.buttonText) {
                    throw new Error('buttonText is a required parameter');
                }

                if (!emailRequest.message) {
                    throw new Error('message is a required parameter');
                }

                if (!emailRequest.recipients) {
                    throw new Error('recipients is a required parameter');
                }

                if (!emailRequest.language) {
                    throw new Error('language is a required parameter');
                }

                if (!emailRequest.locale) {
                    throw new Error('locale is a required parameter');
                }

                return dmsRequestsDataService.sendEmail(id, emailRequest);
            };

            service.view = function(token) {
                if (!angular.isString(token)) {
                    throw new Error('requestId is a required parameter');
                }

                return dmsRequestsDataService.view(token);
            };
        }

        DmsRequestsServiceImpl.$inject = _$inject;
        return DmsRequestsServiceImpl;
    }());

    angular.module('bluemoon.dms.services')

    .service('dmsRequestsService', DmsRequestsService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsSearchService = (function() {
        var _$inject = ['dmsSearchDataService'];

        function DmsSearchServiceImpl(searchDataService) {

            var service = this;

            service.getAggregatedSearchResults = function(scope) {
                return searchDataService.getAggregatedSearchResults(scope);
            };

        }

        DmsSearchServiceImpl.$inject = _$inject;
        return DmsSearchServiceImpl;
    }());

    angular.module('bluemoon.dms.services')

    .service('dmsSearchService', DmsSearchService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsSubRequestsService = (function() {
        var _$inject = ['dmsSubRequestsDataService'];

        function DmsSubRequestsServiceImpl(dmsSubRequestsDataService) {

            var service = this;

            service.getList = function(requestId, options) {
                if (!requestId) {
                    throw new Error('requestId is a required parameter');
                }

                return dmsSubRequestsDataService.getList(requestId, options);
            };

            service.add = function(requestId, subRequest) {
                if (!requestId) {
                    throw new Error('requestId is a required parameter');
                }

                if (!subRequest) {
                    throw new Error('subRequest is a required parameter');
                }

                if (!subRequest.type) {
                    throw new Error('type is a required parameter');
                }

                if (!subRequest.status) {
                    throw new Error('status is a required parameter');
                }

                return dmsSubRequestsDataService.add(requestId, subRequest);
            };

            service.delete = function(requestId, subRequestId) {
                if (!angular.isString(requestId)) {
                    throw new Error('requestId is a required parameter');
                }

                if (!angular.isString(subRequestId)) {
                    throw new Error('subRequestId is a required parameter');
                }

                return dmsSubRequestsDataService.delete(requestId, subRequestId);
            };

            service.get = function(requestId, subRequestId) {
                if (!angular.isString(requestId)) {
                    throw new Error('requestId is a required parameter');
                }

                if (!angular.isString(subRequestId)) {
                    throw new Error('subRequestId is a required parameter');
                }

                return dmsSubRequestsDataService.get(requestId, subRequestId);
            };

            service.edit = function(requestId, subRequest) {
                if (!requestId) {
                    throw new Error('requestId is a required parameter');
                }

                if (!subRequest) {
                    throw new Error('subRequest is a required parameter');
                }

                if (!subRequest.id) {
                    throw new Error('subRequestId is a required parameter');
                }

                return dmsSubRequestsDataService.edit(requestId, subRequest);
            };

            service.editFromUpdateToken = function(accessToken, requestId, subRequest) {
                if (!accessToken) {
                    throw new Error('accessToken is a required parameter');
                }

                if (!requestId) {
                    throw new Error('requestId is a required parameter');
                }

                if (!subRequest) {
                    throw new Error('subRequest is a required parameter');
                }

                if (!subRequest.id) {
                    throw new Error('subRequestId is a required parameter');
                }

                return dmsSubRequestsDataService.edit(requestId, subRequest, {
                    token: accessToken
                });
            };
        }

        DmsSubRequestsServiceImpl.$inject = _$inject;
        return DmsSubRequestsServiceImpl;
    }());

    angular.module('bluemoon.dms.services')

    .service('dmsSubRequestsService', DmsSubRequestsService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsUiService = (function(){

        var _$inject = [
            '$state',
            '$q',
            '$sce',
            'Folder',
            'Project',
            'fileManager',
            'folderManager',
            'projectManager',
            'AuthenticatedSessionData',
            'newContainerModalService',
            'dmsNewTemplateModalService',
        ];

        function DmsUiServiceImpl(
            $state,
            $q,
            $sce,
            Folder,
            Project,
            fileManager,
            folderManager,
            projectManager,
            authenticatedSessionData,
            newContainerModalService,
            dmsNewTemplateModalService) {
            var _this = this;

            _this.clientDocumentsPermission = function() {
                return authenticatedSessionData.get().then(function(data){
                    var frpMap = data.bindings.FeatureResourcePermissions.FeatureResourcePermissionsMap;
                    if (frpMap && frpMap.Applications) {
                        return frpMap.Applications.OnvioClientHub;
                    }
                    return;
                });
            };

            _this.staffDocumentsPermission = function() {
                return authenticatedSessionData.get().then(function(data){
                    var frpMap = data.bindings.FeatureResourcePermissions.FeatureResourcePermissionsMap;
                    if (frpMap && frpMap.Applications) {
                        return frpMap.Applications.Onvio;
                    }
                    return;
                });
            };

            _this.templatesDocumentsPermission = function() {
                return authenticatedSessionData.get().then(function(data){
                    var frpMap = data.bindings.FeatureResourcePermissions.FeatureResourcePermissionsMap;
                    //NOTE: You can only have Templates if you also have Staff Permissions.
                    if (frpMap && frpMap.Applications && frpMap.Applications.Onvio && frpMap.OnvioDrive) {
                        return frpMap.OnvioDrive.Templates;
                    }
                    return;
                });
            };

            //  TODO: Deprecate
            _this.addFolder = function(parentContainerId, parentContainerType) {

                if (!parentContainerId) {
                    throw new Error('parentContainerId is required.');
                } else if (!parentContainerType || parentContainerType === '') {
                    throw new Error('parentContainerType is required.');
                }

                newContainerModalService.open({
                    checkForDuplicates: true,
                    parentContainerType: parentContainerType,
                    parentContainerId: parentContainerId
                }).result
                    .then(function(newFolderName){
                        if (parentContainerType === 'Folder' || parentContainerType === 'Project') {
                            var folderToAdd = new Folder();
                            folderToAdd.name = newFolderName;
                            folderToAdd.parentId = parentContainerId;
                            folderToAdd.parentType = (parentContainerType === 'Folder') ? 'folders' : 'projects';
                            folderManager.addFolder(folderToAdd);
                        } else if (parentContainerType === 'Client') {
                            var projectToAdd = new Project();
                            projectToAdd.name                       = newFolderName;
                            projectToAdd.productType                = 'DMSClientFolder';
                            projectToAdd.processingYear             = 1900;
                            projectToAdd.primaryAssociationId       = parentContainerId;
                            projectToAdd.primaryAssociationType     = parentContainerType;
                            projectManager.addProject(projectToAdd);
                        }
                    });
            };

            // TODO: Deprecate
            _this.addTemplate = function() {
                var parentType = 'Firm';
                var parentId = 'Templates';
                var productType = 'DMSClientFolder'; //TODO: make more dynamic

                dmsNewTemplateModalService.open({
                    checkForDuplicates: true,
                    parentContainerType: parentType,
                    parentContainerId: parentId
                }).result
                    .then(function(newFolderName){
                        var projectToAdd = new Project();
                        projectToAdd.name                       = newFolderName;
                        projectToAdd.productType                = productType;
                        projectToAdd.processingYear             = 1900;
                        projectToAdd.primaryAssociationId       = parentId;
                        projectToAdd.primaryAssociationType     = parentType;
                        projectManager.addProject(projectToAdd);
                    });
            };

            // TODO: Deprecate
            _this.downloadFile = function(containerType, containerId, fileId) {
                var iframe = document.getElementById('folder-view-invisible-download');
                fileManager.getDocumentInfo(containerType, containerId, fileId, true).then(function(result) {
                    if (result.data) {
                        var file = result.data;
                        if (file.id === fileId) {
                            iframe.src = $sce.trustAsResourceUrl(fileManager.addAttachmentParameter(file.downloadUrl));
                        }
                    }
                });
            };

            _this.getFolderUiItemHref = function(itemData) {
                var item = itemData.item;
                var clientId = itemData.clientId;
                var projectId = itemData.projectId;

                var isInsideProject = clientId !== undefined && projectId !== undefined;

                var stateName = '';
                var params = {};

                if (item.itemType === 'Folder') {
                    if (isInsideProject) {
                        stateName = 'projectFolderList';
                        params = {
                            folderId: item.id,
                            clientId: clientId,
                            projectId: projectId,
                        };
                    } else {
                        stateName = 'folderList';
                        params = {
                            folderId: item.id,
                        };
                    }
                } else if (item.itemType === 'Document') {
                    if (isInsideProject) {
                        if (item.parentItem.id && item.parentItem.itemType === 'Folder')
                        {
                            stateName = 'projectFileView';
                            params = {
                                fileId: item.id,
                                folderId: item.parentItem.id,
                                clientId: clientId,
                                projectId: projectId,
                            };
                        } else {
                            stateName = 'projectRootFileView';
                            params = {
                                fileId: item.id,
                                clientId: clientId,
                                projectId: projectId,
                            };
                        }
                    } else {
                        stateName = 'folderFileView';
                        params = {
                            fileId: item.id,
                            folderId: item.parentItem.id,
                        };
                    }
                }

                return $state.href(stateName, params);
            };

            _this.doBusilyConditionally = function(options) {

                var opt = options || {};

                var condition = opt.condition;
                var scope = opt.scope;

                var doBusily = condition !== false;

                if (doBusily && !scope) {
                    throw new Error('scope required when running busily');
                }

                var callback = opt.callback;
                if (!callback || !angular.isFunction(callback)) {
                    throw new Error('callback required, must be function');
                }

                var processCallbackDeferred = $q.defer();

                if (!doBusily) {
                    callback().then(function(data){
                        processCallbackDeferred.resolve(data);
                    });
                } else {
                    scope.$emit('bm-busy-loading-on');

                    var busyLoaderOff = function() {
                        scope.$emit('bm-busy-loading-off');
                    };

                    callback().then(function(data) {
                        processCallbackDeferred.resolve(data);
                    }, busyLoaderOff).then(busyLoaderOff, busyLoaderOff);
                }

                return processCallbackDeferred.promise;
            };

            _this.runBusily = function(scope, toWrap) {

                if (!scope) {
                    throw new Error('scope required when running busily');
                } else if (!toWrap || !angular.isFunction(toWrap)) {
                    throw new Error('toWrap required, must be function');
                }

                scope.$emit('bm-busy-loading-on');

                var busyLoaderOff = function() {
                    scope.$emit('bm-busy-loading-off');
                };

                var processCallbackDeferred = $q.defer();
                toWrap().then(function(data) {
                    processCallbackDeferred.resolve(data);
                }, busyLoaderOff).then(busyLoaderOff, busyLoaderOff);

                return processCallbackDeferred.promise;
            };

            _this.runBusilyIf = function(currentScope, toWrap, condition) {
                return condition === undefined || condition ?
                    _this.runBusily(currentScope, toWrap) : toWrap();
            };
        }

        DmsUiServiceImpl.$inject = _$inject;
        return DmsUiServiceImpl;
    }());

    angular.module('bluemoon.dms.ui-services', [
        'ui.router',
        'pascalprecht.translate',
        'bluemoon.components',
        'bluemoon.dms.modal.confirmation',
        'bluemoon.dms.modal.new-container',
        'bluemoon.dms.modal.new-document',
        'bluemoon.dms.modal.send-items',
        'bluemoon.dms.modal.download',
        'bluemoon.dms.managers',
        'bluemoon.dms.services',
        'bluemoon.dms.models',
    ])

    .service('UiService', DmsUiService)

    .service('dmsUiService', DmsUiService);

})(window.angular);

(function(angular, _){
    'use strict';

    var DmsModalUiService = (function() {
        var _$inject = [
            '$translate',
            'dmsFolderUiService',
            'dmsDocumentUiService',
            'projectUiService',
            'dmsItemUiService',
            'newContainerModalService',
            'dmsNewTemplateModalService',
            'dmsNewDocumentModalService',
            'dmsSendItemsModal',
            'dmsDownloadModal',
            'confirmationModalService',
            'DmsFolderModel',
            'DmsProjectModel'
        ];

        function DmsModalUiServiceImpl($translate, dmsFolderUiService, documentUiService, projectUiService, itemUiService, newContainerModalService, newTemplateModalService, newDocumentModalService, sendItemsModal, downloadModal, confirmationModalService, DmsFolderModel, DmsProjectModel) {

            var service = this;

            service.addFolder = function(options) {

                var opt = options || {};

                var parentContainerId = opt.parentContainerId;
                var parentContainerType = opt.parentContainerType;

                if (!parentContainerId) {
                    throw new Error('parentContainerId is required.');
                } else if (!parentContainerType || parentContainerType === '') {
                    throw new Error('parentContainerType is required.');
                }

                newContainerModalService.open({
                    checkForDuplicates: true,
                    parentContainerType: parentContainerType,
                    parentContainerId: parentContainerId
                }).result
                    .then(function(newFolderData){
                        if (parentContainerType === 'Folder' || parentContainerType === 'Project') {
                            var folderToAdd = new DmsFolderModel();
                            folderToAdd.name = newFolderData;
                            folderToAdd.parentId = parentContainerId;
                            folderToAdd.parentType = (parentContainerType === 'Folder') ? 'folders' : 'projects';
                            dmsFolderUiService.add({
                                busily: opt.busily,
                                scope: opt.scope,
                                addOperation: opt.addOperation,
                                folder: folderToAdd
                            });
                        } else if (parentContainerType === 'Client') {
                            //Set up stuff in CASE of copy
                            var hasSourceTemplate = false;
                            var sourceTemplateId = null;
                            var newFolderName = '';
                            if (angular.isDefined(newFolderData.selectedValue) && newFolderData.selectedValue !== null){
                                hasSourceTemplate = true;
                                sourceTemplateId = newFolderData.selectedValue;
                                newFolderName = newFolderData.containerName;
                            } else {
                                newFolderName = newFolderData;
                            }

                            var projectToAdd = new DmsProjectModel();
                            projectToAdd.name                       = newFolderName;
                            projectToAdd.productType                = 'DMSClientFolder';
                            projectToAdd.processingYear             = 1900;
                            projectToAdd.primaryAssociationId       = parentContainerId;
                            projectToAdd.primaryAssociationType     = parentContainerType;

                            projectUiService.add({
                                busily: opt.busily,
                                scope: opt.scope,
                                addOperation: opt.addOperation,
                                project: projectToAdd,
                                sourceTemplateId: sourceTemplateId
                            });
                        }
                    });
            };

            service.addTemplate = function(options) {

                var opt = options ||
                {
                    parentContainerType: 'Firm',
                    parentContainerId:   'Templates',
                    productType:         'DMSClientFolder' //TODO: make more dynamic?
                };

                //Let's prevent calling this with invalid Options
                var parentContainerId = opt.parentContainerId;
                var parentContainerType = opt.parentContainerType;

                if (!parentContainerId) {
                    throw new Error('parentContainerId is required.');
                } else if (!parentContainerType || parentContainerType === '') {
                    throw new Error('parentContainerType is required.');
                }

                newTemplateModalService.open({
                    checkForDuplicates: true,
                    parentContainerType: parentContainerType,
                    parentContainerId: parentContainerId
                }).result
                    .then(function(newFolderName){
                        var projectToAdd = new DmsProjectModel();
                        projectToAdd.name                       = newFolderName;
                        projectToAdd.productType                = opt.productType;
                        projectToAdd.processingYear             = 1900;
                        projectToAdd.primaryAssociationId       = parentContainerId;
                        projectToAdd.primaryAssociationType     = parentContainerType;
                        projectUiService.add({
                            busily: opt.busily,
                            scope: opt.scope,
                            addOperation: opt.addOperation,
                            project: projectToAdd
                        });
                    });
            };

            service.addDocument = function(options) {

                var opt = options || {};

                var parentContainerId = opt.parentContainerId;
                var parentContainerType = opt.parentContainerType;
                var menuSourceType = opt.menuSourceType;
                var documentType = opt.documentType;

                if (!parentContainerId) {
                    throw new Error('parentContainerId is required.');
                } else if (!parentContainerType || parentContainerType === '') {
                    throw new Error('parentContainerType is required.');
                } else if (!menuSourceType || menuSourceType === '') {
                    throw new Error('menuSourceType is required.');
                } else if (!documentType || documentType === '') {
                    throw new Error('documentType is required.');
                }

                newDocumentModalService.open({
                    checkForDuplicates: true,
                    parentContainerType: parentContainerType,
                    parentContainerId: parentContainerId,
                    menuSourceType: menuSourceType,
                    documentType: documentType,
                }).result
                    .then(function(newDocumentName, metaData){
                        documentUiService.add({
                            busily: opt.busily,
                            scope: opt.scope,
                            addOperation: opt.addOperation,
                            container: {
                                id:   parentContainerId,
                                type: parentContainerType
                            },
                            documentData: {
                                name: newDocumentName,
                                type: menuSourceType + documentType,
                                metaData: metaData
                            }
                        });
                    });
            };

            service.deleteItems = function(items) {

                if (!items || items.length === 0) {
                    throw new Error('must specify items to delete');
                }

                confirmationModalService.open({
                    size: 'sm',
                    message: $translate.instant('Bluemoon.DMS.UiServices.ModalUiService.DeleteMessage'),
                    positiveConfirmation: $translate.instant('Bluemoon.DMS.UiServices.ModalUiService.Delete'),
                    negativeConfirmation: $translate.instant('Bluemoon.DMS.UiServices.ModalUiService.Cancel')
                }).result
                    .then(function(canDelete){
                        if (canDelete) {
                            _.each(items, function(item){
                            if (item.itemType === 'Folder') {
                                dmsFolderUiService.deleteFolder({
                                    busily: false,
                                    params: {
                                        folder: item
                                    }
                                });
                            } else if (item.itemType === 'Document') {
                                documentUiService.deleteDocument({
                                    busily: false,
                                    params: {
                                        document: item
                                    }
                                });
                            } else if (item.itemType === 'Project') {
                                projectUiService.deleteProject({
                                    busily: false,
                                    params: {
                                        project: item
                                    }
                                });
                            }
                        });
                    }
                });
            };

            service.sendItems = function(items){

                if (!items) {
                    throw new Error('items is a required parameter');
                }

                if (!angular.isArray(items) || items.length === 0) {
                    throw new Error('items must be an array with length > 0');
                }

                return sendItemsModal.open({
                    items: items
                }).result
                    .then(function(result){
                        return itemUiService.send({
                            busily: false,
                            items: result.items,
                            recipients: result.recipients,
                            expiration: result.expiration,
                            language: result.language,
                            locale: result.locale,
                            sendOperation: true
                        });
                    });
            };

            service.downloadDocument = function(options){

                var opt = options || {};

                if(!opt.params || !opt.params.documentName) {
                    throw new Error('documentName is a required parameter');
                }

                if(opt.params.accessToken) {
                    return downloadModal.open({
                        documentName: opt.params.documentName,
                        accessToken: opt.params.accessToken,
                        documentSize: opt.params.documentSize
                    });
                } else if(opt.params.document) {
                    return downloadModal.open({
                        documentName: opt.params.documentName,
                        documentSize: opt.params.documentSize,
                        document: opt.params.document
                    });
                }

                throw new Error('document or accessToken are a required parameter');
            };
        }

        DmsModalUiServiceImpl.$inject = _$inject;
        return DmsModalUiServiceImpl;
    }());

    angular.module('bluemoon.dms.ui-services')

    .service('dmsModalUiService', DmsModalUiService)

    //TODO: Deprecate
    .service('modalUiService', DmsModalUiService);

})(window.angular, window._);

(function(angular){
    'use strict';

    var DmsFolderUiService = (function() {
        var _$inject = [
            '$rootScope',
            '$q',
            'dmsFolderService',
            'folderManager',
            'UiService',
            'dmsApiOperationService',
        ];

        function DmsFolderUiServiceImpl($rootScope, $q, dmsFolderService, folderManager, uiService, dmsApiOperationService) {

            var service = this;

            service._performAdd = function(folder, addOperation) {
                return dmsFolderService.add(folder).then(function(result){
                    if (!addOperation) {
                        $rootScope.$broadcast('dmsFolderAdded');
                    }
                    return result;
                });
            };

            service.add = function(options) {

                var opt = options || {};

                var addOperation = (opt.addOperation !== false);
                var source = opt.source || '';
                var folder = opt.folder;

                var addCallback = function() {

                    var addPromise = service._performAdd(folder, addOperation);

                    if (addOperation){
                        //TODO: Fix type strings
                        var lowerContainerType = folder.parentType.toLowerCase();
                        var destinationContainerType = lowerContainerType === 'folder' ? 'folders' :
                            lowerContainerType === 'project' ? 'projects' : lowerContainerType;

                        dmsApiOperationService.createAddOperation({
                            destinationContainerId: folder.parentId,
                            destinationContainerType: destinationContainerType,
                            item: folder,
                            source: source
                        }, function() {
                            //  Operations still require the old response to work.
                            return addPromise.then(function(r){
                                return r.response;
                            }, function(r){
                                return $q.reject(r.response);
                            });
                        });
                    }

                    return addPromise;
                };

                return uiService.doBusilyConditionally({
                    condition: opt.busily,
                    scope: opt.scope,
                    callback: addCallback
                });
            };

            service.getChildren = function(options) {

                var opt = options || {};
                opt.params = opt.params || {};

                if (!opt.params.folderId) {
                    throw new Error('folderId is a required parameter');
                }

                return uiService.doBusilyConditionally({
                    condition: opt.busily,
                    scope: opt.scope,
                    callback: function() {
                        return dmsFolderService.getChildren(opt.params.folderId, opt.params.pageState);
                    }
                });
            };

            service.deleteFolder = function(options) {

                var opt = options || {};

                if (!opt.params || !options.params.folder) {
                    throw new Error('folder is a required parameter');
                }

                return uiService.runBusilyIf(options.scope,
                    function() {
                        dmsApiOperationService.createDeleteOperation({
                            item: options.params.folder,
                        }, function() {
                            return folderManager.deleteFolder(options.params.folder.id);
                        });
                    },
                    options.busily);
            };

            service.getFirmFolder = function(options) {
                return uiService.runBusilyIf(options.scope,
                    folderManager.getFirmFolder,
                    options.busily);
            };

            //TODO: Deprecate
            service.getFolderChildren = function(options) {
                if (!options.params || !options.params.folderId) {
                    throw new Error('folderId is a required parameter');
                }

                var getFolderChildrenParams = {};
                if (options.params.pageState) {
                    var pageState = options.params.pageState;
                    getFolderChildrenParams.from = pageState.page;
                    getFolderChildrenParams.pageSize = pageState.itemsPerPage;
                    getFolderChildrenParams.sort = pageState.sort;
                }

                return uiService.runBusilyIf(options.scope, function() {
                    return folderManager.getFolderChildren(options.params.folderId,
                        getFolderChildrenParams);
                }, options.busily);
            };

            service.getFolder = function(options) {
                if (!options.params || !options.params.folderId) {
                    throw new Error('folderId is a required parameter');
                }

                return uiService.runBusilyIf(options.scope, function() {
                    return folderManager.getFolder(options.params.folderId);
                }, options.busily);
            };

            service.getRootFolder = function(options) {
                return uiService.runBusilyIf(options.scope,
                    folderManager.getRootFolder,
                    options.busily);
            };
        }

        DmsFolderUiServiceImpl.$inject = _$inject;
        return DmsFolderUiServiceImpl;
    }());

    angular.module('bluemoon.dms.ui-services')

    .service('dmsFolderUiService', DmsFolderUiService)

    //TODO: Deprecate
    .service('folderUiService', DmsFolderUiService);

})(window.angular);

(function(angular){
    'use strict';

    function DocumentUiService($document, $window, $q, $sce, $rootScope, $translate, $timeout, bmUtil, documentService, fileManager, uiService, dmsApiOperationService, dmsCustomProtocolHanderUiService, helpService,
        confirmationModalService, bmUser, bmAccess, bmPermission) {

        var _ = $window._;
        var self = this;

        self._checkIfMeetsConstraints = function(size, type, ignoreSizeCheck) {

            if (!ignoreSizeCheck){
                if ((!size && size !== 0) || !angular.isNumber(size)) {
                    throw new Error('size is a required parameter and must be a Number');
                }
            }

            if (!type || !angular.isString(type)) {
                throw new Error('type is a required parameter and must be a nonempty String');
            }

            return fileManager.getConstraints().then(function(documentConstraints){
                if (!ignoreSizeCheck && size > documentConstraints.maxUploadSize) {
                    return $q.reject('maxUploadSize');
                } else if (!ignoreSizeCheck && size < documentConstraints.minUploadSize) {
                    return $q.reject('minUploadSize');
                } else if (!_.contains(documentConstraints.allowedTypes, type.toLowerCase())) {
                    return $q.reject('allowedTypes');
                }
            });
        };

        self.getConstraints = function(options) {

            var opt = options || {};

            return uiService.runBusilyIf(opt.scope,
                function(){ return fileManager.getConstraints(); },
                opt.busily);
        };

        self.meetsConstraints = function(options) {
            var opt = options || {};

            if (!opt.params || !opt.params.document) {
                throw new Error('document is a required parameter');
            }

            var doc = opt.params.document;

            return uiService.runBusilyIf(opt.scope,
                function(){ return self._checkIfMeetsConstraints(doc.size, doc.type, opt.params.ignoreSizeConstraint); },
                opt.busily);
        };

        self.deleteDocument = function(options) {
            var opt = options || {};

            if (!opt.params || !opt.params.document) {
                throw new Error('document is a required parameter');
            }

            var doc = opt.params.document;

            return uiService.runBusilyIf(opt.scope,
                function() {
                    dmsApiOperationService.createDeleteOperation({
                        item: opt.params.document,
                    }, function() {
                        return fileManager.deleteDocument(doc.parentItem.id,
                            doc.id, doc.parentItem.itemType);
                    });
                },
                opt.busily);
        };

        var downloadIFrameId;
        function downloadDocument(downloadUrl) {
            if(!downloadIFrameId) {
                downloadIFrameId = 'dms-download-' + bmUtil.generateUUID().split('-').join('');
            }

            var iframe = $document[0].querySelector('#' + downloadIFrameId);
            var downloadIFrame;
            if(!iframe){
                downloadIFrame = $document[0].createElement('iframe');
                downloadIFrame.id = downloadIFrameId;
                downloadIFrame.style.display = 'none';

                var body = $document.find('body').eq(0);
                body.append(downloadIFrame);
            } else {
                downloadIFrame = iframe;
            }

            var url = downloadUrl;
            url += (-1 === url.indexOf('?') ? '?' : '&') + 'att=1';

            downloadIFrame.src = $sce.trustAsResourceUrl(url);
        }

        self._openNewDocInLink = function (documentData) {
            if (!documentData || documentData.parentItem === undefined){
                throw new Error('documentData missing parentItem data');
            }

            var parent = documentData.parentItem;
            var url = '/api/storage/v1/{containerType}/{containerId}/documents/{documentId}'
                .replace('{containerType}', parent.itemType === 'Folder' ? 'folders' : 'projects')
                .replace('{containerId}',  parent.id)
                .replace('{documentId}', documentData.id);
            var openDocumentRequest = { url: url, name: documentData.name, userId:bmUser.bluId, contactId:bmUser.contactId};
            var openDocumentRequestJson = JSON.stringify(openDocumentRequest);
            var href = 'onvio:' + btoa(unescape(encodeURIComponent(openDocumentRequestJson))); // jshint ignore:line
            dmsCustomProtocolHanderUiService.openCustomProtocol(href, function () {
                confirmationModalService.open({
                    size: 'sm',
                    message: $translate.instant('Bluemoon.DMS.UiServices.ModalUiService.OpenLocallyErrorMessage'),
                    positiveConfirmation: $translate.instant('Bluemoon.DMS.UiServices.ModalUiService.LearnMore'),
                    negativeConfirmation: $translate.instant('Bluemoon.DMS.UiServices.ModalUiService.Cancel')
                }).result.then(function (learnMore) {
                    if (!learnMore) { return; }
                    helpService.load().then(function (resp) {
                        var help = [];
                        angular.extend(help, resp.data);
                        $window.open(help.baseUrl + 'onvio-link.htm', '_blank');
                    });
                });
            });
            return;
        };

        self.download = function(options) {
            var opt = options || {};

            if(opt.params && opt.params.document) {
                documentService.get({
                    type: opt.params.document.parentItem.itemType,
                    id: opt.params.document.parentItem.id
                }, opt.params.document.id, {
                    includeDownloadUrl: true
                }).then(function(result){
                    downloadDocument(result.data.downloadUrl);
                });
            } else if(opt.params && opt.params.accessToken) {
                documentService.getFromAccessToken(opt.params.accessToken).then(function(result){
                    downloadDocument(result.data.downloadUrl);
                });
            } else {
                throw new Error('document or accessToken are a required parameter');
            }
        };

        self._performAdd = function(container, documentData, addOperation) {
            return documentService.add(container, documentData).then(function(result){
                if (!addOperation) {
                    $rootScope.$broadcast('dmsDocumentAdded');
                }
                return result;
            });
        };

        self.add = function(options) {

                var opt = options || {};

                var addOperation = opt.addOperation !== false;
                var source = opt.source || '';
                var container    = opt.container;
                var documentData = opt.documentData;

                var addCallback = function() {

                    var addPromise = self._performAdd(container, documentData, addOperation);

                    if (addOperation){
                        //TODO: Fix type strings
                        var lowerContainerType = container.type.toLowerCase();
                        var destinationContainerType = lowerContainerType === 'folder' ? 'folders' :
                            lowerContainerType === 'project' ? 'projects' : lowerContainerType;

                        dmsApiOperationService.createAddOperation({
                            destinationContainerId: container.id,
                            destinationContainerType: destinationContainerType,
                            item: {
                                name:           documentData.name,
                                parentId:       container.id,
                                parentType:     destinationContainerType,
                                itemType:       'Document'
                            },
                            source: source
                        }, function() {
                            //  Operations still require the old response to work.
                            return addPromise.then(function (r) {
                                if (navigator.userAgent.indexOf('Mac OS X') === -1) {
                                    bmAccess.not('DMS_HideOpenLocally').then(
                                        function () {
                                            bmPermission.has('OnvioDrive.OpenLocally').then(
                                                function () {
                                                    self._openNewDocInLink(r.response.data);
                                                    return r.response;
                                                });
                                        });
                                } else {
                                    return r.response;
                                }
                                return $q.resolve(r.response);
                            }, function(r){
                                return $q.reject(r.response);
                            });
                        });
                    }

                    return addPromise;
                };

                return uiService.doBusilyConditionally({
                    condition: opt.busily,
                    scope: opt.scope,
                    callback: addCallback
                });
            };
    }

    angular.module('bluemoon.dms.ui-services')

    //  TODO: deprecate
    .service('documentUiService', ['$document', '$window', '$q', '$sce', '$rootScope','$translate', '$timeout', 'bmUtil', 'dmsDocumentService', 'fileManager', 'UiService', 'dmsApiOperationService','dmsCustomProtocolHanderUiService','helpService','confirmationModalService','bmUser','bmAccess', 'bmPermission',
    DocumentUiService])

    .service('dmsDocumentUiService', ['$document', '$window', '$q', '$sce', '$rootScope','$translate', '$timeout', 'bmUtil', 'dmsDocumentService', 'fileManager', 'UiService', 'dmsApiOperationService','dmsCustomProtocolHanderUiService','helpService','confirmationModalService','bmUser','bmAccess', 'bmPermission',
    DocumentUiService]);

})(window.angular);

(function(angular){
    'use strict';

    var DmsEmployeeUiService = (function() {
        var _$inject = [
            'dmsEmployeeService'
        ];

        function DmsEmployeeUiServiceImpl(dmsEmployeeService) {
            var service = this;

            service.getEmployeeList = function() {
                return dmsEmployeeService.all().then(function (result){
                    for (var i = 0; i < result.totalItems; i++){
                        result.items[i].staffDropdownLabel = [result.items[i].code, result.items[i].name];
                    }
                    return result.items;
                });
            };
        }

        DmsEmployeeUiServiceImpl.$inject = _$inject;
        return DmsEmployeeUiServiceImpl;
    }());
    angular.module('bluemoon.dms.ui-services')
    .service('dmsEmployeeUiService', DmsEmployeeUiService);
})(window.angular);

(function(angular){
    'use strict';

    var DmsProjectUiService = (function() {
        var _$inject = [
            '$rootScope',
            '$q',
            'projectManager',
            'UiService',
            'dmsApiOperationService',
            'dmsProjectService'
        ];

        function DmsProjectUiServiceImpl($rootScope, $q, projectManager, uiService, dmsApiOperationService, dmsProjectService) {
            var service = this;

            service._performAdd = function(project, addOperation) {
                return dmsProjectService.add(project).then(function(result){
                    //Add an operation to the stack
                    if (!addOperation) {
                        $rootScope.$broadcast('dmsProjectAdded');
                    }
                    return result;
                });
            };

            service._performCopy = function(project, sourceId, addOperation) {
                return dmsProjectService.copy(project, sourceId).then(function(result){
                    //Add an operation to the stack
                    if (!addOperation) {
                        $rootScope.$broadcast('dmsProjectAdded');
                    }
                    return result;
                });
            };

            service.add = function(options) {

                var opt = options || {};

                var addOperation = (opt.addOperation !== false);
                var fromTemplate = (!!opt.sourceTemplateId);
                var source = opt.source || '';
                var project = opt.project;

                var addCallback = function() {

                    var promise;
                    if (fromTemplate){
                        promise = service._performCopy(project, opt.sourceTemplateId, addOperation);
                    } else {
                        promise = service._performAdd(project, addOperation);
                    }

                    if (addOperation){
                        //TODO: Fix type strings
                        var destinationContainerType = project.itemType === 'Project' ?
                            'projects' : project.itemType;

                        dmsApiOperationService.createAddOperation({
                            destinationContainerId: project.parentId,
                            destinationContainerType: destinationContainerType,
                            item: project,
                            source: source
                        }, function(){
                            //  Operations still require the old response to work.
                            return promise.then(function(r){
                                return r.response;
                            }, function(r){
                                return $q.reject(r.response);
                            });
                        });
                    }

                    return promise;
                };

                return uiService.doBusilyConditionally({
                    condition: opt.busily,
                    scope: opt.scope,
                    callback: addCallback
                });
            };

            service.deleteProject = function(options) {

                var opt = options || {};

                if (!opt.params || !options.params.project) {
                    throw new Error('project is a required parameter');
                }

                return uiService.runBusilyIf(options.scope,
                    function() {
                        dmsApiOperationService.createDeleteOperation({
                            item: options.params.project,
                        }, function() {
                            return projectManager.deleteProject(options.params.project.id);
                        });
                    },
                    options.busily);
            };

            service.getProjectChildren = function(options) {

                if (!options.params || !options.params.projectId) {
                    throw new Error('projectId is a required parameter');
                }

                var getProjectChildrenParams = {};
                if (options.params.pageState) {
                    var pageState = options.params.pageState;
                    getProjectChildrenParams.from = pageState.page;
                    getProjectChildrenParams.pageSize = pageState.itemsPerPage;
                    getProjectChildrenParams.sort = pageState.sort;
                }

                return uiService.runBusilyIf(options.scope, function() {
                    return projectManager.getProjectChildren(options.params.projectId,
                        getProjectChildrenParams);
                }, options.busily);
            };

            service.getProject = function(options) {

                if (!options.params || !options.params.projectId) {
                    throw new Error('projectId is a required parameter');
                }

                return uiService.runBusilyIf(options.scope, function() {
                    return projectManager.getProject(options.params.projectId);
                }, options.busily);
            };

            service.getProjectList = function(options) {

                if (!options.params || !options.params.clientId) {
                    throw new Error('clientId is a required parameter');
                }

                return uiService.runBusilyIf(options.scope, function() {
                    return projectManager.getProjectList(options.params.clientId);
                }, options.busily);
            };

            service.getTemplateList = function(options) {

                if (!options.params || !options.params.primaryAssociationId || options.params.primaryAssociationId !== 'Templates' ||
                    !options.params.primaryAssociationType || options.params.primaryAssociationType !== 'Firm') {
                    throw new Error('Parameters do not match required fields (Templates / Firm)');
                }

                return uiService.runBusilyIf(options.scope, function() {
                    return projectManager.getProjectListWithConfigurationParameters(options.params);
                }, options.busily);
            };

            service.getChildren = function(options) {

                var opt = options || {};
                opt.params = opt.params || {};

                if (!opt.params.projectId) {
                    throw new Error('projectId is a required parameter');
                }

                return uiService.doBusilyConditionally({
                    condition: opt.busily,
                    scope: opt.scope,
                    callback: function() {
                        return dmsProjectService.getChildren(opt.params.projectId, opt.params.pageState);
                    }
                });
            };
        }

        DmsProjectUiServiceImpl.$inject = _$inject;
        return DmsProjectUiServiceImpl;
    }());

    angular.module('bluemoon.dms.ui-services')

    .service('dmsProjectUiService', DmsProjectUiService)

    //TODO: Deprecate
    .service('projectUiService', DmsProjectUiService);

})(window.angular);

(function(angular, _){
    'use strict';

    var DmsClientUiService = (function() {

        var _$inject = ['clientManager', 'UiService', 'dmsClientService'];

        function DmsClientUiServiceImpl(clientManager, uiService, clientService) {

            var service = this;

            service.getClientList = function(options) {

                var opt = options || {};

                var getClientList = {};
                if (opt.params  && opt.params.pageState) {
                    var pageState = opt.params.pageState;
                    getClientList.pageIndex = pageState.page;
                    getClientList.itemsPerPage = pageState.itemsPerPage;

                    var sortString = pageState.sort;
                    var indexOfColon = sortString.lastIndexOf(':');
                    getClientList.orderBy = sortString.substr(0, indexOfColon) + ' ' +
                        sortString.substr(indexOfColon + 1);
                } else {
                    getClientList.pageIndex = 1;
                    getClientList.itemsPerPage = 1000;
                    getClientList.orderBy = 'name asc';
                }

                return uiService.runBusilyIf(opt.scope, function() {
                    return clientManager.getClientList(getClientList).then(function(resp){
                        if (resp.data) {
                            resp.data = _.map(resp.data, function(c) {
                                c.itemType = 'Client';
                                return c;
                            });
                        }
                        return resp;
                    });
                }, opt.busily);
            };

            service.getClientsWithProjects = function(options) {
                return uiService.runBusilyIf(options.scope, function() {
                    return clientManager.getClientsWithProjects();
                }, options.busily);
            };

            service.getChildren = function(options) {
                var opt = options || {};
                opt.params = opt.params || {};

                if (!opt.params.clientId) {
                    throw new Error('clientId is a required parameter');
                }

                return uiService.doBusilyConditionally({
                    condition: opt.busily,
                    scope: opt.scope,
                    callback: function() {
                        return clientService.getChildren(opt.params.clientId);
                    }
                });
            };
        }

        DmsClientUiServiceImpl.$inject = _$inject;
        return DmsClientUiServiceImpl;
    }());

    angular.module('bluemoon.dms.ui-services')

    .service('dmsClientUiService', DmsClientUiService)

    // TODO: Deprecate
    .service('clientUiService', DmsClientUiService);

})(window.angular, window._);

(function(angular){
    'use strict';

    var DmsItemUiService = (function() {
        var _$inject = [
            '$rootScope',
            'dmsUiService',
            'dmsItemService',
            'dmsApiOperationService',
            '$q',
        ];

        function DmsItemUiServiceImpl($rootScope, uiService, itemService, dmsApiOperationService, $q) {

            var service = this;

            service._send = function(sharingRequest, sendOperation) {
                return itemService.send(sharingRequest).then(function(result){
                    if(!sendOperation) {
                        $rootScope.$broadcast('dmsItemsSent');
                    }
                    return result;
                });
            };

            service.send = function(options) {

                var opt = options || {};
                var sendOperation = (opt.sendOperation !== false);

                var sharingRequest =
                {
                    receipents: [],
                    expirationPeriod: opt.expiration,
                    sharedItems: [],
                    language: opt.language,
                    locale: opt.locale
                };

                for(var i = 0; i < opt.recipients.length; ++i){

                    sharingRequest.receipents.push(
                    {
                        emailAddress: opt.recipients[i].address
                    });
                }

                for(i = 0; i < opt.items.length; ++i){

                    sharingRequest.sharedItems.push(
                    {
                        containerId: opt.items[i].containerId,
                        containerType: opt.items[i].parentItem.containerType,
                        documentId: opt.items[i].id,
                        name: opt.items[i].name
                    });
                }

                var sendCallback = function() {

                    var sendPromise = service._send(sharingRequest, sendOperation);

                    if(sendOperation){

                        dmsApiOperationService.createSendOperation({
                            sharedItems: sharingRequest.sharedItems,
                        }, function() {
                            //  Operations still require the old response to work.
                            return sendPromise.then(function(r){
                                return r.response;
                            }, function(r){
                                return $q.reject(r.response);
                            });
                        });
                    }

                    return sendPromise;
                };

                return uiService.doBusilyConditionally({
                    condition: opt.busily,
                    scope: opt.scope,
                    callback: sendCallback
                });
            };

            this.getRecent = function(options) {
                return uiService.runBusilyIf(options.scope, function() {
                    return itemService.getRecent(options.params);
                }, options.busily);
            };
        }

        DmsItemUiServiceImpl.$inject = _$inject;
        return DmsItemUiServiceImpl;
    }());

    angular.module('bluemoon.dms.ui-services')

    .service('dmsItemUiService', DmsItemUiService);

})(window.angular);

(function(angular){
    'use strict';

    var DmsRecycleBinUiService = (function() {
        var _$inject = [
            '$rootScope',
            '$q',
            'dmsUiService',
            'dmsRecycleBinService',
            'dmsApiOperationService'
        ];

        function DmsRecycleBinUiServiceImpl($rootScope, $q, uiService, recycleBinService, dmsApiOperationService) {

            var service = this;

            service.getRecycleList = function(options) {
                return uiService.runBusilyIf(options.scope, function() {
                    return recycleBinService.getRecycleList(options.params);
                }, options.busily);
            };

            service.moveDocumentToTrash = function(options) {
                var opt = options || {};

                if (!opt.params || !options.params.trashRequest) {
                    throw new Error('trashRequest is a required parameter');
                }

                if (!opt.params || !options.params.trashRequest.id) {
                    throw new Error('id is a required parameter');
                }

                if (!opt.params || !options.params.trashRequest.name) {
                    throw new Error('name is a required parameter');
                }

                return uiService.runBusilyIf(opt.scope,
                    function() {
                        return dmsApiOperationService.createMoveToRecycleBinOperation({
                            item: { id: options.params.trashRequest.id,
                                    name: options.params.trashRequest.name,
                                    itemType: 'Document' }
                        }, function() {
                            return recycleBinService.moveDocumentToTrash(options.params.trashRequest);
                        });
                    },
                opt.busily);
            };

            service.deleteDocument = function(options) {
                var opt = options || {};

                if (!opt.params || !options.params.trashRequest) {
                    throw new Error('trashRequest is a required parameter');
                }

                if (!opt.params || !options.params.trashRequest.trashId) {
                    throw new Error('trashId is a required parameter');
                }

                var deleteDocumentInternalFunction = function(){
                    var def = $q.defer();

                    recycleBinService.deleteDocument(options.params.trashRequest.trashId).then(function(r){
                        def.resolve(r.response);
                    }, function(r){
                        def.reject(r.response);
                    });

                    return def.promise;
                };

                var deleteCallback = function() {
                    var deferred = $q.defer();

                    dmsApiOperationService.createPermanentlyDeleteOperation({
                        item: { id: options.params.trashRequest.trashId,
                                name: options.params.trashRequest.name,
                                itemType: 'Document' }
                    }, function() {
                        return deleteDocumentInternalFunction().then(function(res){
                            deferred.resolve(res);
                            return res;
                        });
                    });

                    return deferred.promise;
                };

                return uiService.doBusilyConditionally({
                    condition: opt.busily,
                    scope: opt.scope,
                    callback: deleteCallback
                });
            };

            service.restoreDocument = function(options) {
                var opt = options || {};

                if (!opt.params || !options.params.trashRequest) {
                    throw new Error('trashRequest is a required parameter');
                }

                if (!opt.params || !options.params.trashRequest.trashId) {
                    throw new Error('trashId is a required parameter');
                }

                if (!opt.params || !options.params.restoreItemRequest || !options.params.restoreItemRequest.destinationContainerId) {
                    throw new Error('destinationContainerId is a required parameter');
                }

                if (!opt.params || !options.params.restoreItemRequest || !options.params.restoreItemRequest.destinationContainerType) {
                    throw new Error('destinationContainerId is a required parameter');
                }

                var restoreDocumentInternalFunction = function(){
                    var def = $q.defer();
                    recycleBinService.restoreDocument(options.params.trashRequest.trashId, options.params.restoreItemRequest)
                    .then(function(r){
                        def.resolve(r.response);
                    }, function(r){
                        def.reject(r.response);
                    });

                    return def.promise;
                };

                var restoreCallback = function() {
                    var deferred = $q.defer();

                    dmsApiOperationService.createRestoreOperation({
                        item: { id: options.params.trashRequest.trashId,
                                name: options.params.restoreItemRequest.name,
                                itemType: 'Document',
                                destinationContainerId: options.params.restoreItemRequest.destinationContainerId,
                                destinationContainerType: options.params.restoreItemRequest.destinationContainerType }
                    }, function() {
                        return restoreDocumentInternalFunction().then(function(res){
                            deferred.resolve(res);
                            return res;
                        });
                    });

                    return deferred.promise;
                };

                return uiService.doBusilyConditionally({
                    condition: opt.busily,
                    scope: opt.scope,
                    callback: restoreCallback
                });
            };

            service.moveFolderToTrash = function(options) {
                var opt = options || {};

                if (!opt.params || !options.params.trashRequest) {
                    throw new Error('trashRequest is a required parameter');
                }

                if (!opt.params || !options.params.trashRequest.id) {
                    throw new Error('id is a required parameter');
                }

                if (!opt.params || !options.params.trashRequest.name) {
                    throw new Error('name is a required parameter');
                }

                return uiService.runBusilyIf(opt.scope,
                    function() {
                        return dmsApiOperationService.createMoveToRecycleBinOperation({
                            item: { id: options.params.trashRequest.id,
                                    name: options.params.trashRequest.name,
                                    itemType: 'Folder' }
                        }, function() {
                            return recycleBinService.moveFolderToTrash(options.params.trashRequest).then(function(res){
                                return res;
                            }, function(error){
                                return error;
                            });
                        });
                    },
                opt.busily);
            };

            service.deleteFolder = function(options) {
                var opt = options || {};

                if (!opt.params || !options.params.trashRequest) {
                    throw new Error('trashRequest is a required parameter');
                }

                if (!opt.params || !options.params.trashRequest.trashId) {
                    throw new Error('trashId is a required parameter');
                }

                var deleteFolderInternalFunction = function(){
                    var def = $q.defer();

                    recycleBinService.deleteFolder(options.params.trashRequest.trashId).then(function(r){
                        def.resolve(r.response);
                    }, function(r){
                        def.reject(r.response);
                    });

                    return def.promise;
                };

                var deleteCallback = function() {
                    var deferred = $q.defer();

                    dmsApiOperationService.createPermanentlyDeleteOperation({
                        item: { id: options.params.trashRequest.trashId,
                                name: options.params.trashRequest.name,
                                itemType: 'Folder' }
                    }, function() {
                        return deleteFolderInternalFunction().then(function(res){
                            deferred.resolve(res);
                            return res;
                        });
                    });

                    return deferred.promise;
                };

                return uiService.doBusilyConditionally({
                    condition: opt.busily,
                    scope: opt.scope,
                    callback: deleteCallback
                });
            };

            service.restoreFolder = function(options) {
                var opt = options || {};

                if (!opt.params || !options.params.trashRequest) {
                    throw new Error('trashRequest is a required parameter');
                }

                if (!opt.params || !options.params.trashRequest.trashId) {
                    throw new Error('trashId is a required parameter');
                }

                if (!opt.params || !options.params.restoreItemRequest || !options.params.restoreItemRequest.destinationContainerId) {
                    throw new Error('destinationContainerId is a required parameter');
                }

                if (!opt.params || !options.params.restoreItemRequest || !options.params.restoreItemRequest.destinationContainerType) {
                    throw new Error('destinationContainerId is a required parameter');
                }

                var restoreFolderInternalFunction = function(){
                    var def = $q.defer();
                    recycleBinService.restoreFolder(options.params.trashRequest.trashId, options.params.restoreItemRequest)
                    .then(function(r){
                        def.resolve(r.response);
                    }, function(r){
                        def.reject(r.response);
                    });

                    return def.promise;
                };

                var restoreCallback = function() {
                    var deferred = $q.defer();

                    dmsApiOperationService.createRestoreOperation({
                        item: { id: options.params.trashRequest.trashId,
                                name: options.params.restoreItemRequest.name,
                                itemType: 'Folder',
                                destinationContainerId: options.params.restoreItemRequest.destinationContainerId,
                                destinationContainerType: options.params.restoreItemRequest.destinationContainerType }
                    }, function() {
                        return restoreFolderInternalFunction().then(function(res){
                            deferred.resolve(res);
                            return res;
                        });
                    });

                    return deferred.promise;
                };

                return uiService.doBusilyConditionally({
                    condition: opt.busily,
                    scope: opt.scope,
                    callback: restoreCallback
                });

            };
        }

        DmsRecycleBinUiServiceImpl.$inject = _$inject;
        return DmsRecycleBinUiServiceImpl;
    }());

    angular.module('bluemoon.dms.ui-services')

    .service('dmsRecycleBinUiService', DmsRecycleBinUiService);

})(window.angular);

(function() {
    'use strict';

    var app = angular.module('bluemoon.dms.ui-services');

    var dmsRequestsUiService = function(uiService, dmsRequestsService){

        var _this = this;

        _this.getRequest = function(options) {
            if (!options.params || !options.params.requestId) {
                throw new Error('requestId is a required parameter');
            }

            return uiService.runBusilyIf(options.scope, function() {
                return dmsRequestsService.get(options.params.requestId);
            }, options.busily);
        };

        _this.getList = function(options) {
            return uiService.runBusilyIf(options.scope, function() {
                return dmsRequestsService.getList(options.params);
            }, options.busily);
        };

        _this.add = function(options) {
            if (!options.params || !options.params.request) {
                throw new Error('request is a required parameter');
            }

            return uiService.runBusilyIf(options.scope, function() {
                return dmsRequestsService.add(options.params.request);
            }, options.busily);
        };

        _this.edit = function(options) {
            if (!options.params || !options.params.request) {
                throw new Error('request is a required parameter');
            }

            return uiService.runBusilyIf(options.scope, function() {
                return dmsRequestsService.edit(options.params.request);
            }, options.busily);
        };

        _this.delete = function(options) {
            if (!options.params || !options.params.requestId) {
                throw new Error('requestId is a required parameter');
            }

            return uiService.runBusilyIf(options.scope, function() {
                return dmsRequestsService.delete(options.params.requestId);
            }, options.busily);
        };

        _this.sendEmail = function(options) {
            if (!options.params || !options.params.id) {
                throw new Error('id is a required parameter');
            }

            if (!options.params || !options.params.emailRequest) {
                throw new Error('emailRequest is a required parameter');
            }

            return uiService.runBusilyIf(options.scope, function() {
                return dmsRequestsService.sendEmail(options.params.id, options.params.emailRequest);
            }, options.busily);
        };

        _this.view = function(options) {
            if (!options.params || !options.params.token) {
                throw new Error('token is a required parameter');
            }

            return uiService.runBusilyIf(options.scope, function() {
                return dmsRequestsService.view(options.params.token);
            }, options.busily);
        };
    };

    dmsRequestsUiService.$inject = ['UiService', 'dmsRequestsService'];
    app.service('dmsRequestsUiService', dmsRequestsUiService);
})();

(function(angular){
    'use strict';

    var DmsSearchGetSet = (function() {
        var _$inject = [
            '$q',
        ];

        function DmsSearchGetSetImpl() {

            this.getSearchTerm = function() {
                return this.searchTerm;
            };

            this.setSearchTerm = function (term) {
                this.searchTerm = term;
            };

            this.getSelectedItem = function() {
                return this.selectedItem;
            };

            this.setSelectedItem = function (item) {
                this.selectedItem = item;
            };
        }

        DmsSearchGetSetImpl.$inject = _$inject;
        return DmsSearchGetSetImpl;
    }());

    angular.module('bluemoon.dms.ui-services')

    .service('dmsSearchGetSet', DmsSearchGetSet);

})(window.angular);

(function(angular){
    'use strict';

    var DmsSearchUiService = (function() {
        var _$inject = [
            '$rootScope',
            'dmsUiService',
            'dmsSearchService',
            'dmsApiOperationService',
            '$q',
        ];

        function DmsSearchUiServiceImpl($rootScope, uiService, searchService) {

            this.getAggregatedSearchResults = function (scope) {
                return uiService.runBusilyIf(scope.scope, function () {
                    return searchService.getAggregatedSearchResults(scope);
                }, scope.busily);
            };
        }

        DmsSearchUiServiceImpl.$inject = _$inject;
        return DmsSearchUiServiceImpl;
    }());

    angular.module('bluemoon.dms.ui-services')

    .service('dmsSearchUiService', DmsSearchUiService);

})(window.angular);

(function() {
    'use strict';

    var app = angular.module('bluemoon.dms.ui-services');

    var DmsSubRequestsUiService = function(uiService, dmsSubRequestsService){

        var _this = this;

        _this.getList = function(options) {
            if (!options.params || !options.params.requestId) {
                throw new Error('requestId is a required parameter');
            }

            return uiService.runBusilyIf(options.scope, function() {
                return dmsSubRequestsService.getList(options.params.requestId, options.params);
            }, options.busily);
        };

        _this.add = function(options) {
            if (!options.params || !options.params.requestId) {
                throw new Error('requestId is a required parameter');
            }

            if (!options.params.subRequest) {
                throw new Error('subRequest is a required parameter');
            }

            return uiService.runBusilyIf(options.scope, function() {
                return dmsSubRequestsService.add(options.params.requestId, options.params.subRequest);
            }, options.busily);
        };

        _this.delete = function(options) {
            if (!options.params || !options.params.requestId) {
                throw new Error('requestId is a required parameter');
            }

            if (!options.params.subRequestId) {
                throw new Error('subRequestId is a required parameter');
            }

            return uiService.runBusilyIf(options.scope, function() {
                return dmsSubRequestsService.delete(options.params.requestId, options.params.subRequestId);
            }, options.busily);
        };

        _this.get = function(options) {
            if (!options.params || !options.params.requestId) {
                throw new Error('requestId is a required parameter');
            }

            if (!options.params.subRequestId) {
                throw new Error('subRequestId is a required parameter');
            }

            return uiService.runBusilyIf(options.scope, function() {
                return dmsSubRequestsService.get(options.params.requestId, options.params.subRequestId);
            }, options.busily);
        };

        _this.edit = function(options) {
            if (!options.params || !options.params.requestId) {
                throw new Error('requestId is a required parameter');
            }

            if (!options.params.subRequest) {
                throw new Error('subRequest is a required parameter');
            }

            return uiService.runBusilyIf(options.scope, function() {
                return dmsSubRequestsService.edit(options.params.requestId, options.params.subRequest);
            }, options.busily);
        };
    };

    DmsSubRequestsUiService.$inject = ['UiService', 'dmsSubRequestsService'];
    app.service('dmsSubRequestsUiService', DmsSubRequestsUiService);
})();

(function(angular) {
    'use strict';

    var DmsCustomProtocolHanderUiService = (function() {

        function DmsCustomProtocolHanderUiServiceImpl(){

        var service = this;

        function _registerEvent(target, eventType, cb) {
        if (target.addEventListener) {
            target.addEventListener(eventType, cb);
            return {
                remove: function () {
                    target.removeEventListener(eventType, cb);
                }
            };
        } else {
            target.attachEvent(eventType, cb);
            return {
                remove: function () {
                    target.detachEvent(eventType, cb);
                }
            };
        }
    }

    function _createHiddenIframe(target, uri) {
        var iframe = document.createElement('iframe');
        iframe.src = uri;
        iframe.id = 'hiddenIframe';
        iframe.style.display = 'none';
        target.appendChild(iframe);
        return iframe;
    }

    function openUriWithHiddenFrame(uri, failCb) {
        var handler = _registerEvent(window, 'blur', onBlur);

        var timeout = setTimeout(function () {
            failCb();
            handler.remove();
        }, 5000);

        var iframe = document.querySelector('#hiddenIframe');
        if (!iframe) {
            iframe = _createHiddenIframe(document.body, 'about:blank');
        }

        function onBlur() {
            clearTimeout(timeout);
            handler.remove();
        }

        iframe.contentWindow.location.href = uri;
    }

    function openUriWithTimeoutHack(uri, failCb) {
        var handler = _registerEvent(window, 'blur', onBlur);

        var timeout = setTimeout(function () {
            failCb();
            handler.remove();
        }, 5000);

        function onBlur() {
            clearTimeout(timeout);
            handler.remove();
        }

        window.location = uri;
    }

    function openUriUsingFirefox(uri, failCb) {
        var iframe = document.querySelector('#hiddenIframe');
        if (!iframe) {
            iframe = _createHiddenIframe(document.body, 'about:blank');
        }
        try {
            iframe.contentWindow.location.href = uri;
        } catch (e) {
            if (e.name === 'NS_ERROR_UNKNOWN_PROTOCOL') {
                failCb();
            }
        }
    }

    function openUriUsingIEInOlderWindows(uri, failCb) {
        if (getInternetExplorerVersion() === 10) {
            openUriUsingIE10InWindows7(uri, failCb);
        } else if (getInternetExplorerVersion() === 9 || getInternetExplorerVersion() === 11) {
            openUriWithHiddenFrame(uri, failCb);
        } else {
            openUriInNewWindowHack(uri, failCb);
        }
    }

    function openUriUsingIE10InWindows7(uri, failCb) {
        var timeout = setTimeout(failCb, 5000);
        window.addEventListener('blur', function () {
            clearTimeout(timeout);
        });

        var iframe = document.querySelector('#hiddenIframe');
        if (!iframe) {
            iframe = _createHiddenIframe(document.body, 'about:blank');
        }
        try {
            iframe.contentWindow.location.href = uri;
        } catch (e) {
            failCb();
            clearTimeout(timeout);
        }
    }

    function openUriInNewWindowHack(uri, failCb) {
        var myWindow = window.open('', '', 'width=0,height=0');

        myWindow.document.write('<iframe src="' + uri + '"></iframe>');
        setTimeout(function () {
            try {
                myWindow.setTimeout('window.close()', 1000);
            } catch (e) {
                myWindow.close();
                failCb();
            }
        }, 1000);
    }

    function openUriWithMsLaunchUri(uri, failCb) {
        navigator.msLaunchUri(uri,
            function () {
            },
            failCb
            );
    }

    function checkBrowser() {
        var isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
        return {
            isOpera: isOpera,
            isFirefox: typeof InstallTrigger !== 'undefined',
            isSafari: Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0,
            isChrome: !!window.chrome && !isOpera,
            isIE: /*@cc_on!@*/false || !!document.documentMode   // At least IE6
        };
    }

    function getInternetExplorerVersion() {
        var rv = -1;
        var ua = '';
        var re = '';
        if (navigator.appName === 'Microsoft Internet Explorer') {
            ua = navigator.userAgent;
            re = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');
            if (re.exec(ua) !== null)
            {
                rv = parseFloat(RegExp.$1);
            }
        } else if (navigator.appName === 'Netscape') {
            ua = navigator.userAgent;
            re = new RegExp('Trident/.*rv:([0-9]{1,}[\.0-9]{0,})');
            if (re.exec(ua) !== null) {
                rv = parseFloat(RegExp.$1);
            }
        }
        return rv;
    }

    service.openCustomProtocol = function (uri, failCb) {
        function failCallback() {
            if (failCb)
            {
                failCb();
            }
        }

        if (navigator.msLaunchUri) { //for IE and Edge in Win 8 and Win 10
            openUriWithMsLaunchUri(uri, failCb);
        } else {
            var browser = checkBrowser();

            if (browser.isFirefox) {
                openUriUsingFirefox(uri, failCallback);
            } else if (browser.isChrome) {
                openUriWithTimeoutHack(uri, failCallback);
            } else if (browser.isIE) {
                openUriUsingIEInOlderWindows(uri, failCallback);
            } else {
                openUriWithHiddenFrame(uri, failCallback);
            }
        }
    };
        }

        return DmsCustomProtocolHanderUiServiceImpl;
    }());

    angular.module('bluemoon.dms.ui-services')

    .service('dmsCustomProtocolHanderUiService', DmsCustomProtocolHanderUiService);
})(window.angular);

(function(angular){
    'use strict';

    // blank module for dev, overwritten for dist
    angular.module('bluemoon-dms.templates', []);

    var bmoonApp = angular.module('bluemoon.dms.upload', [
        'angularFileUpload',
        'bluemoon.components.analytics',
        'bluemoon-dms.templates',
        'bluemoon.dms.utility',
        'bluemoon.dms.utility.queue',
        'bluemoon.dms.managers',
        'bluemoon.dms.ui-services'
    ]);

    var dmsupload = function(){

        function DmsUpload(file, parentId){
            this.status = 'waiting';
            this.file = file;
            this.size = 0;
            this.key = null;
            this.id = null;
            this.deferred = null;
            this.parentId = parentId;
            this.loaded = 0;
            this.total = 0;
            this.error = {};

            if (file) {
                this.destinationFileName = file.name;
            }
        }

        return DmsUpload;
    };

    bmoonApp.factory('DmsUpload', dmsupload);
})(window.angular);

(function(angular){
    'use strict';

    var bmoonApp = angular.module('bluemoon.dms.upload');

    var totalUploadProgress = function(){

        function TotalUploadProgress(){
            this.filesUploaded = 0;
            this.totalFiles = 0;
            this.totalErrors = 0;
            this.progress = null;
        }

        return TotalUploadProgress;
    };

    bmoonApp.factory('TotalUploadProgress', totalUploadProgress);
})(window.angular);

(function() {
    'use strict';

    var bmoonApp = angular.module('bluemoon.dms.upload');

    var dmsDragLeave = function($timeout, $parse) {
        return {
            restrict: 'A',
            replace: false,
            link: function(scope, elem, attr) {
                if ('draggable' in document.createElement('span')) {
                    var cancel = null;
                    var makeCloseCallback = false;
                    var fnDragLeave = $parse(attr.dmsDragLeave);
                    elem[0].addEventListener('dragleave', function(evt) {
                        makeCloseCallback = true;
                        evt.preventDefault();
                        cancel = $timeout(function() {
                            if(makeCloseCallback) {
                                (function callback() {
                                    makeCloseCallback = false;
                                    fnDragLeave(scope, {
                                        $event : evt
                                    });
                                })();
                            }
                        });
                    }, false);
                    elem[0].addEventListener('drop', function(evt) {
                        cancel = $timeout(function() {
                            if(makeCloseCallback) {
                                (function callback() {
                                    makeCloseCallback = false;
                                    fnDragLeave(scope, {
                                        $event : evt
                                    });
                                })();
                            }
                        });
                    }, false);
                }
            }
        };
    };

    dmsDragLeave.$inject = ['$timeout', '$parse'];
    bmoonApp.directive('dmsDragLeave', dmsDragLeave);
})();

(function() {
    'use strict';

    var bmoonApp = angular.module('bluemoon.dms.upload');

    var dmsDragOver = function($timeout, $parse) {
        return {
            restrict: 'A',
            replace: false,
            link: function(scope, elem, attr) {
                if ('draggable' in document.createElement('span')) {
                    var cancel = null;
                    var makeCallback = true;
                    var fnDragOver = $parse(attr.dmsDragOver);
                    elem[0].addEventListener('dragstart', function(evt) {
                        evt.dataTransfer.dropEffect = 'copy';
                    }, false);

                    elem[0].addEventListener('dragover', function(evt) {
                        evt.dataTransfer.dropEffect = 'copy';
                        $timeout.cancel(cancel);
                        evt.stopPropagation();
                        evt.preventDefault();
                        elem.addClass(attr.dmsDragOverClass || 'dragover');
                        if(makeCallback) {
                            (function callback() {
                                makeCallback = false;
                                fnDragOver(scope, {
                                    $event : evt
                                });
                            })();
                        }
                    }, false);

                    // Don't turn off dragging until 120ms after the event is fired,
                    // and no dragover event has fired between.
                    // Dragover events fire every ~100ms, so the delay just needs to be longer than that.
                    elem[0].addEventListener('dragleave', function() {
                        cancel = $timeout(function() {
                            makeCallback = true;
                            elem.removeClass(attr.dmsDragOverClass || 'dragover');
                        }, 120);
                    }, false);

                    elem[0].addEventListener('drop', function(evt) {
                        evt.dataTransfer.dropEffect = 'copy';
                        makeCallback = true;
                        elem.removeClass(attr.dmsDragOverClass || 'dragover');
                    }, false);
                }
            }
        };
    };

    dmsDragOver.$inject = ['$timeout', '$parse'];
    bmoonApp.directive('dmsDragOver', dmsDragOver);
})();

(function() {
    'use strict';

    var DmsDropListener = (function(){
        var _$inject = ['SourceTypes', 'dmsUploadService'];

        function DmsDropListenerImpl(SourceTypes, dmsUploadService) {
            var service = this;
            service.listener = function(event) {
                event.dataTransfer.dropEffect = 'copy';
                event.stopPropagation();
                event.preventDefault();

                if (event.dataTransfer.files.length === 0) {
                    return;
                }

                var dmsItem = JSON.parse(event.currentTarget.attributes['dms-item'].value);

                dmsUploadService.addBatch(event.dataTransfer, dmsItem.id,
                    dmsItem.itemType, SourceTypes.FileSystemDragAndDrop);
            };
        }

        DmsDropListenerImpl.$inject = _$inject;
        return DmsDropListenerImpl;
    }());

    var DmsDrop = (function(){
        var _$inject = ['dmsDrop._dropListener'];

        function DmsDropImpl(dropListener) {

            var listener = dropListener.listener;

            var doWhatMSWants = function(event) {
                // IE requires this in order to allow drop events
                // because...
                event.returnValue = false;
            };

            function linkFunction(scope, elem, attr) {
                if ('draggable' in document.createElement('span')) {
                    attr.$observe('dmsItem', function(){
                        if (attr.dmsItem){
                            var dmsItem = JSON.parse(attr.dmsItem);
                            if (dmsItem.id && (!dmsItem.lock || dmsItem.lock.resourceRestrictions.indexOf('CREATE_SUB_RESOURCE') < 0)) {
                                elem[0].addEventListener('drop', listener, false);
                                elem[0].addEventListener('dragenter', doWhatMSWants, false);
                                elem[0].addEventListener('dragover', doWhatMSWants, false);
                            }
                        }
                    });
                }
            }

            return {
                restrict: 'A',
                replace: false,
                link: linkFunction
            };
        }

        DmsDropImpl.$inject = _$inject;
        return DmsDropImpl;
    }());

    angular.module('bluemoon.dms.upload')

    .service('dmsDrop._dropListener', DmsDropListener)

    .directive('dmsDrop', DmsDrop);
})();

(function() {
    'use strict';

    var DraggedData = (function(){
        var _$inject = [];

        function DraggedDataImpl() {
            return {
                item: null
            };
        }

        DraggedDataImpl.$inject = _$inject;
        return DraggedDataImpl;
    }());

    var DragstartListener = (function(){
        var _$inject = ['dmsMove._draggedData'];

        function DragstartListenerImpl(draggedData) {
            var service = this;

            service.listener = function(event) {
                event.dataTransfer.dropEffect = 'move';

                var dmsItemAttribute = event.currentTarget.attributes['dms-item'];
                if (dmsItemAttribute && dmsItemAttribute.value) {
                    draggedData.item = JSON.parse(dmsItemAttribute.value);
                }
            };
        }

        DragstartListenerImpl.$inject = _$inject;
        return DragstartListenerImpl;
    }());

    var DropListener = (function(){
        var _$inject = ['folderManager', 'fileManager', 'dmsMove._draggedData'];

        function DropListenerImpl(folderManager, fileManager, draggedData) {
            var service = this;

            service.listener = function(event) {

                if (!draggedData.item || (draggedData.item.itemType !== 'Folder' &&
                    draggedData.item.itemType !== 'Document')) {
                    return;
                }

                var destinationItem = JSON.parse(event.currentTarget.attributes['dms-item'].value);
                if (draggedData.item.itemType === destinationItem.itemType &&
                    draggedData.item.id === destinationItem.id) {
                    return;
                }

                event.dataTransfer.dropEffect = 'move';

                var moveItemFunction = draggedData.item.itemType === 'Folder' ?
                    folderManager.moveFolder : fileManager.moveDocument;

                moveItemFunction(draggedData.item, destinationItem.id, destinationItem.itemType);

                draggedData.item = null;
            };
        }

        DropListenerImpl.$inject = _$inject;
        return DropListenerImpl;
    }());

    var DmsMove = (function(){
        var _$inject = ['$rootScope', '$q', 'dmsMove._dragstartListener', 'dmsMove._dropListener'];

        function DmsMoveImpl($rootScope, $q, dragstartListener, dropListener) {

            function linkFunction(scope, elem) {
                if ('draggable' in document.createElement('span')) {
                    elem[0].addEventListener('dragstart', dragstartListener.listener, false);
                    elem[0].addEventListener('drop', dropListener.listener, false);
                }
            }

            return {
                restrict: 'A',
                replace: false,
                link: linkFunction
            };
        }

        DmsMoveImpl.$inject = _$inject;
        return DmsMoveImpl;
    }());

    angular.module('bluemoon.dms.upload')

    .value('dmsMove._draggedData', DraggedData)

    .service('dmsMove._dragstartListener', DragstartListener)

    .service('dmsMove._dropListener', DropListener)

    .directive('dmsMove', DmsMove);

})();

(function(window, angular) {
    'use strict';

    var _$inject = [
        '$rootScope',
        '$q',
        '$timeout',
        '$upload',
        '$http',
        '$injector',
        'dmsUploadConfig',
        'bmAnalyticsService',
        'fileManager',
        'folderManager',
        'projectManager',
        'Folder',
        'DmsUpload',
        'TotalUploadProgress',
        'DmsQueue',
        'dmsDocumentUiService',
        'bluemoon.components.httpStatusCodes',
        'SourceTypes',
        'bmEnvironment',
        'dmsPermission'
    ];

    var DmsUploadService = function(
        $rootScope,
        $q,
        $timeout,
        $upload,
        $http,
        $injector,
        uploadConfig,
        analyticsService,
        fileManager,
        folderManager,
        projectManager,
        Folder,
        DmsUpload,
        TotalUploadProgress,
        DmsQueue,
        documentUiService,
        httpStatusCodes,
        SourceTypes,
        bmEnvironment,
        dmsPermission){

        var service = {};
        service.uploads = {};
        service.totalProgress = new TotalUploadProgress();
        service.totalProgress.progress = new DmsUpload();
        var timeout;

        function getUploadUrl(fileUpload) {
            return $injector.invoke(uploadConfig.uploadUrl)(fileUpload);
        }

        function trackEvent(source) {
            if (uploadConfig.analytics) {
                analyticsService.track('dmsUploadStarted', {
                    source: source
                });
            }
        }

        service.addBatch = function(dataTransfer, rootId, containerType, source) {
            // Folder upload process. This is handled differently
            // than a standard upload of items.
            var items = dataTransfer.items;
            if (items && items.length > 0 && items[0].webkitGetAsEntry) {
                for (var i = 0; i < items.length; i++) {
                    traverseFileTree(rootId, items[i].webkitGetAsEntry(), containerType);
                }

                trackEvent(source);
            } else {
                var fileList = dataTransfer.files;
                if (fileList !== null && fileList.length > 0) {
                    for (var j = 0; j < fileList.length; j++) {
                        var fileUpload = new DmsUpload();
                        fileUpload.file = fileList[j];
                        fileUpload.size = fileUpload.file.size;
                        fileUpload.parentId = rootId;
                        fileUpload.parentType = containerType;
                        fileUpload.uploadUri = getUploadUrl(fileUpload);

                        service.addFile(fileUpload);
                    }

                    trackEvent(source);
                }
            }
        };

        //  This is through print driver
        service.addSingle = function(dataTransfer, parentId, parentType, destinationFileName, fileSize) {
            var fileUpload = new DmsUpload();
            fileUpload.file = dataTransfer;
            fileUpload.size = fileSize;
            fileUpload.parentId = parentId;
            fileUpload.parentType = parentType;
            fileUpload.uploadUri = getUploadUrl(fileUpload);
            fileUpload.destinationFileName = destinationFileName;
            service.addFile(fileUpload);
        };

        function traverseFileTree(containerId, item, containerType){
            if (item.isDirectory) {
                dmsPermission.has('OnvioDrive.AddFolders').then(function(permission){
                    if(permission === true){
                        getFolder(containerId, containerType, item.name).then(function(parentData){
                            var dirReader = item.createReader();
                            dirReader.readEntries(function(entries) {
                                for (var i = 0; i < entries.length; i++) {
                                    traverseFileTree(parentData.parentId, entries[i], parentData.parentType);
                                }
                            });
                        });
                    }
                });
            } else {
                item.file(function(file){
                    var fileUpload = new DmsUpload();
                    fileUpload.file = file;
                    fileUpload.size = fileUpload.file.size;
                    fileUpload.parentId = containerId;
                    fileUpload.parentType = containerType;
                    fileUpload.uploadUri = getUploadUrl(fileUpload);
                    service.addFile(fileUpload);
                });
            }
        }

        // Add file. If a file with this name already exists, the
        // upload will not complete. The file will need to be resubmitted
        // with a new name or choose to overwrite the original.
        service.addFile = function(newUpload){
            expireTimeout();
            var fileUpload = createUpload(newUpload);
            addUploadToQueue(fileUpload);
        };

        var isCloudSource = function(source){
            return (source === 'cloud' || source === SourceTypes.Dropbox ||
                    source === SourceTypes.Google || source === SourceTypes.Box);
        };

        // Replaces the original file.
        service.replaceFile = function(newUpload){
            expireTimeout();
            var fileUpload = createUpload(newUpload);
            fileUpload.replace = true;

            if (newUpload.source && isCloudSource(newUpload.source)){
                updateFileFromCloud(fileUpload);
            } else {
                addUploadToQueue(fileUpload);
            }

            return fileUpload.deferred.promise;
        };

        // Rename the file to keep the original.
        service.renameFile = function(newUpload){
            expireTimeout();

            var fileUpload = createUpload(newUpload);

            fileManager.findName(fileUpload.parentId, fileUpload.file.name, fileUpload.parentType)
                .then(function(newName) {
                    fileUpload.destinationFileName = newName;

                    if (newUpload.source && isCloudSource(newUpload.source)){
                        addCloudUploadToQueue(fileUpload);
                    } else {
                        addUploadToQueue(fileUpload);
                    }
                });

            return fileUpload.deferred.promise;
        };

        // Cancel an upload.
        service.dismissUpload = function(key){
            delete service.uploads[key];
            service.totalProgress.totalFiles--;
            service.totalProgress.totalErrors--;
            if(service.totalProgress.filesUploaded === service.totalProgress.totalFiles){
                timeout = $timeout(expireBatch, 3000);
            }
        };

        function getFolder(rootId, rootType, name){
            var deferred = $q.defer();

            var lowerRootType = rootType.toLowerCase();
            if (lowerRootType === 'project' || lowerRootType === 'projects') {
                lowerRootType = 'projects';
            } else {
                lowerRootType = 'folders';
            }

            var getChildren = lowerRootType === 'projects' ? projectManager.getProjectChildren :
                folderManager.getFolderChildren;

            getChildren(rootId).then(function(data){
                //Note: wouldn't you think this should be cast to the JS "Folder" object?
                //but NO, JS doesn't support function overloading & therefore multiple constructors. >:(
                var tempFolder = (data.data.length === 1) ? data.data[0] : null;
                // See if this folder already exists.
                if(tempFolder && tempFolder.subContainers && tempFolder.subContainers.length) {
                    for(var i in tempFolder.subContainers){
                        if(tempFolder.subContainers[i].name === name) {
                            deferred.resolve(tempFolder.subContainers[i].id);
                            return deferred.promise;
                        }
                    }
                }

                // If we got this far, the folder did not exist.
                // Add it!
                var folderToAdd = new Folder();
                folderToAdd.name = name;
                folderToAdd.parentId = rootId;
                folderToAdd.parentType = lowerRootType;

                var addFolderOperationModel = folderManager.addFolder(folderToAdd, 'dmsUploadService');
                addFolderOperationModel.operationCompleted().then(function(result){
                    deferred.resolve(result.status === window.successStatus ? {
                            parentId: result.data.id,
                            parentType: folderToAdd.itemType
                        } : {
                            parentId: rootId,
                            parentType: rootType
                        });
                });

            });

            return deferred.promise;
        }

        var getUploadConfig = function(fileUpload) {
            var config = {
                file: fileUpload.file,
                fileFormDataName: 'file[]',
                url: getUploadUrl(fileUpload),
            };

            if (fileUpload.id !== undefined && fileUpload.id !== null && fileUpload.id !== '' && !fileUpload.destinationFileName) {
                config.method = 'PUT';
                //config.url += '/' + fileUpload.id;
            } else {
                config.method = 'POST';

                if (fileUpload.destinationFileName && fileUpload.destinationFileName !== '') {
                    config.fileName = fileUpload.destinationFileName;
                }
            }

            return config;
        };

        var uploadedBatchData = [];
        service.uploadQueue = DmsQueue.newQueue({
            batchCompleteCallback: function() {
                  $rootScope.$broadcast('dms-upload-batch-complete', uploadedBatchData);
                  if (uploadedBatchData && uploadedBatchData.length > 0) {
                      fileManager.uploadNotification(uploadedBatchData.map(function(documentResponse) { return documentResponse.data; }));
                  }
                  uploadedBatchData = [];
              }
        });

        function addUploadToQueue(fileUpload) {
            service.uploadQueue.add({
                item: fileUpload,
                callback: performUpload
            });
        }

        function addCloudUploadToQueue(fileUpload) {
            service.uploadQueue.add({
                item: fileUpload,
                callback: performCloudUpload
            });
        }

        function meetsConstraints(fileName, size, ignoreSize){

            var fileType = fileName.substr(fileName.lastIndexOf('.') + 1);

            return documentUiService.meetsConstraints({
                busily: false,
                params: {
                    ignoreSizeConstraint: ignoreSize,
                    document: {
                        type: fileType,
                        size: size,
                    }
                }
            });
        }

        function performUpload(fileUpload) {
            var defer = $q.defer();
            var resolve = function() {
                defer.resolve();
            };

            //  Make sure the upload hasn't been cancelled/dismissed
            if (!service.uploads[fileUpload.key]) {
                resolve();
                return defer.promise;
            }

            var fileName = fileUpload.destinationFileName ?
                fileUpload.destinationFileName : fileUpload.file.name;

            meetsConstraints(fileName, fileUpload.size).then(function(){
                if (fileUpload.replace) {
                    upload(fileUpload).then(resolve);
                } else {
                    fileManager.getDocumentExists(fileUpload.parentId, fileName, fileUpload.parentType)
                        .then(function(result){
                            if(result.data && result.data[0].exists) {
                                fileUpload.id = result.data[0].id;
                                fileUpload.status = 'error';
                                service.totalProgress.totalErrors++;
                                fileUpload.error.reason = 'conflict';
                                fileUpload.error.message = 'File already exists.';
                                fileUpload.error.status = 409;
                                resolve();
                            } else {
                                upload(fileUpload).then(resolve);
                            }
                        });
                }
            }, function(reason){
                //  Document doesn't meet constraints
                fileUpload.status = 'error';
                service.totalProgress.totalErrors++;
                fileUpload.error.reason = 'constraints:' + reason;
                resolve();
            });

            return defer.promise;
        }

        function performCloudUpload(fileUpload){
            var defer = $q.defer();
            var resolve = function() {
                defer.resolve();
            };

            //  Make sure the upload hasn't been cancelled/dismissed
            if (!service.uploads[fileUpload.key]) {
                resolve();
                return defer.promise;
            }

            if (fileUpload.destinationFileName && fileUpload.destinationFileName !== '') {
                fileUpload.file.name = fileUpload.destinationFileName;
            }

            var ignoreSizeCheck;

            //If the file came from Google AND has no size, we saw that coming and therefore should have sizeCheck ignored.
            if (!!fileUpload.source && fileUpload.source === SourceTypes.Google && fileUpload.size === null){
                ignoreSizeCheck = true;
            }

            meetsConstraints(fileUpload.file.name, fileUpload.size, ignoreSizeCheck).then(function(){
                if (fileUpload.replace) {
                    cloudUpload(fileUpload).then(resolve);
                } else {
                    fileManager.getDocumentExists(fileUpload.parentId, fileUpload.file.name, fileUpload.parentType)
                        .then(function(result){
                            if(result.data && result.data[0].exists) {
                                fileUpload.id = result.data[0].id;
                                fileUpload.status = 'error';
                                service.totalProgress.totalErrors++;
                                fileUpload.error.reason = 'conflict';
                                fileUpload.error.message = 'File already exists.';
                                fileUpload.error.status = 409;
                                resolve();
                            } else {
                                cloudUpload(fileUpload).then(resolve);
                            }
                        });
                }
            }, function(reason){
                //  Document doesn't meet constraints
                fileUpload.status = 'error';
                service.totalProgress.totalErrors++;
                fileUpload.error.reason = 'constraints:' + reason;
                resolve();
            });

            return defer.promise;
        }

        // var upload = function(fileUpload) {
        //     var uploadPromise;
        //     var uploadConfig = {
        //         timeout: 0
        //     };

        //     if (fileUpload.file instanceof FormData) {
        //         uploadConfig = angular.extend({}, uploadConfig, {
        //             url: fileUpload.uploadUri,
        //             method: 'POST',
        //             transformRequest: angular.identity,
        //             headers: {
        //                 'Content-Type': undefined
        //             },
        //             data: fileUpload.file
        //         });
        //         uploadPromise = $upload.http(uploadConfig);
        //     } else {
        //         uploadConfig = angular.extend({}, uploadConfig, getUploadConfig(fileUpload));
        //         uploadPromise = $upload.upload(uploadConfig);
        //     }

        //     return doUploadWork(fileUpload, uploadPromise);
        // };

        function upload(fileUpload) {
           var uploadPromise;
           var uploadConfig = {
               timeout: 0
           };

           var isFileFormData = fileUpload.file instanceof FormData;
           uploadPromise = bmEnvironment.getEnvironmentAsync().then(function(data) {
               var basePath = data.paths.DocumentServices;
               if (isFileFormData) {
                   uploadConfig = angular.extend({}, uploadConfig, {
                       url: fileUpload.uploadUri,
                       method: 'POST',
                       transformRequest: angular.identity,
                       headers: {
                           'Content-Type': undefined
                       },
                       data: fileUpload.file
                   });
                   // uploadPromise = $upload.http(uploadConfig);
               } else {
                   uploadConfig = angular.extend({}, uploadConfig, getUploadConfig(fileUpload));
                   // uploadPromise = $upload.upload(uploadConfig);
               }
               // hack to replace baseUri with zuul path if necessary
               uploadConfig.url = uploadConfig.url.replace(/^\/api\/storage\b/, basePath);
               return $upload[isFileFormData ? 'http' : 'upload'](uploadConfig);
           });

           return doUploadWork(fileUpload, uploadPromise);
        }

        function cloudUpload(fileUpload) {
            var uploadPromise = $http.post(fileUpload.uploadUri, fileUpload.file);

            return doUploadWork(fileUpload, uploadPromise);
        }

        function doUploadWork(fileUpload, uploadPromise){

            return uploadPromise.then(function(val) {
                service.totalProgress.filesUploaded++;
                if(service.totalProgress.filesUploaded === service.totalProgress.totalFiles) {
                    timeout = $timeout(expireBatch, 3000);
                }
                $timeout(function(){
                        expireItem(fileUpload.key);
                    }, 10000);

                fileUpload.status = 'success';
                $rootScope.$broadcast('dms-file-added', val.data);
                uploadedBatchData.push(val.data);
                fileUpload.deferred.resolve(val);
                //defer.resolve();
            }, function(reason){
                reason.config.global = false;  //  Stop the generic error handler
                // Our upload errored, but we don't want to actually
                // reject the promise. They may retry and we would
                // like to return our original promise.
                fileUpload.status = 'error';
                service.totalProgress.totalErrors++;
                if (reason.data && reason.data.message) {
                    fileUpload.error.message = reason.data.message + ' ' + reason.statusText;
                }

                if (reason.status === httpStatusCodes.conflict) {
                    fileUpload.error.reason = 'conflict';
                } else if (reason.status === httpStatusCodes.forbidden) {
                    fileUpload.error.reason = 'forbidden';
                }

                fileUpload.error.status = reason.status;
                //defer.resolve();
            }, function(evt){
                // Files in error must be removed from error status before a progress event
                // should register.
                if(fileUpload.status !== 'error') {
                    fileUpload.status = 'uploading';
                    if(fileUpload.total < evt.total) {
                        fileUpload.total = evt.total;

                        // We have to correct here. The file size does not match the size to upload
                        // which can lead to odd calculations when uploading many files.
                        service.totalProgress.progress.total += (evt.total - fileUpload.file.size);
                    }
                    service.totalProgress.progress.loaded += (evt.loaded - fileUpload.loaded);
                    fileUpload.loaded = evt.loaded;
                    fileUpload.deferred.notify(evt);
                }
            });
        }

        service.createCloudFilePost = function(containerId, fileurl, filename, filesize, containerType, sourceType, token){
            var upload = createImportUpload(containerId, fileurl, filename, filesize, containerType, sourceType, token);
            addCloudUploadToQueue(upload);
        };

        // This will replace our file.
        function updateFileFromCloud(fileUpload){
            fileManager.getDocumentExists(fileUpload.parentId, fileUpload.file.name, fileUpload.parentType).then(function(result){
                fileUpload.id = fileUpload.file.DocumentId = result.data[0].id;
                addCloudUploadToQueue(fileUpload);
            });
        }

        // Create an Upload based on the existing
        // passed in upload.
        function createUpload(newUpload){
            var deferred;

            // If the upload does not have a key yet,
            // create one and put it in the queue of items.
            if(newUpload.key === null) {
                var fileUpload = new DmsUpload();
                fileUpload.file = newUpload.file;
                fileUpload.size = newUpload.size;
                fileUpload.uploadUri = newUpload.uploadUri;
                fileUpload.parentId = newUpload.parentId;
                fileUpload.parentType = newUpload.parentType;
                fileUpload.source = newUpload.source;
                fileUpload.destinationFileName = newUpload.destinationFileName;

                var ts = new Date().getTime();
                var key = newUpload.file.name + '|' + ts;
                fileUpload.key = key;

                deferred = $q.defer();
                fileUpload.deferred = deferred;

                // Add to our overall progress.
                service.uploads[key] = fileUpload;
                service.totalProgress.totalFiles++;

                service.totalProgress.progress.total += fileUpload.file.size;
                return fileUpload;
            } else {
                service.totalProgress.totalErrors--;
                newUpload.status = 'waiting';
                newUpload.error = {};
                if(newUpload.deferred) {
                    newUpload.deferred.notify();
                } else {
                    deferred = $q.defer();
                    newUpload.deferred = deferred;
                }

                return newUpload;
            }
        }

        // Create an Upload based on the existing
        // passed in upload.
        function createImportUpload(containerId, fileurl, filename, filesize, containerType, sourceType, token){

            var importDocumentRequest;
            if (token !== null && token !== undefined ) {
                importDocumentRequest = { 'DirectFileUrl': fileurl, 'name': filename, 'AuthToken': token };
            } else {
                importDocumentRequest = { 'DirectFileUrl': fileurl, 'name': filename };
            }

            var fileUpload = new DmsUpload();
            fileUpload.file = importDocumentRequest;
            fileUpload.size = filesize;
            fileUpload.source = sourceType;
            fileUpload.uploadUri = fileManager.getDocumentImportUri(containerId, containerType);
            fileUpload.parentId = containerId;
            fileUpload.parentType = containerType;

            return createUpload(fileUpload);
        }

        // Clears the total progress to easily show information such as
        // "1 of 5 files uploaded" without being concerned with the entire
        // upload history.
        function expireBatch(){
            if(service.totalProgress.filesUploaded === service.totalProgress.totalFiles){
                service.totalProgress.filesUploaded = 0;
                service.totalProgress.totalFiles = 0;
                service.totalProgress.totalErrors = 0;
                service.totalProgress.progress = new DmsUpload();
            }
        }

        function expireItem(key){
            delete service.uploads[key];
        }

        // This clears the service level timeout. Sometimes new files
        // are added to the queue as the original queue is finishing.
        // Rather than resetting it, we append and continue uploading.
        function expireTimeout(){
            if(timeout){
                $timeout.cancel(timeout);
                timeout = null;
                expireBatch();
            }
        }

        // Create an Upload based on the existing
        // passed in upload.
        service.createUploadStatus = function(uploadFileName, parentId, fileSize){
            var deferred;

            var fileUpload = new DmsUpload();
            fileUpload.parentId = parentId;
            var ts = new Date().getTime();
            var key = uploadFileName + '|' + ts;
            fileUpload.key = key;

            deferred = $q.defer();
            fileUpload.deferred = deferred;

            // Add to our overall progress.
            service.uploads[key] = fileUpload;
            service.totalProgress.totalFiles++;

            service.totalProgress.progress.total += fileSize;
            return fileUpload;
        };

        // Create an Upload based on the existing
        // passed in upload.
        service.completeUploadStatus = function(fileUpload){
            service.totalProgress.filesUploaded++;
            if(service.totalProgress.filesUploaded === service.totalProgress.totalFiles) {
                timeout = $timeout(expireBatch, 3000);
            }
            $timeout(function(){
                    expireItem(fileUpload.key);
                }, 10000);

            fileUpload.status = 'success';

            // How do we want to handle this?
            //$rootScope.$broadcast('dms-file-added', val.data);
            fileUpload.deferred.resolve();
        };

        return service;
    };

    var DmsUploadConfigProvider = (function(){

        function DmsUploadConfigProviderImpl() {

            var provider = this;

            provider.analytics = false;

            provider.uploadUrl = ['fileManager', function(fileManager) {
                return function(fileUpload) {
                    var url = fileManager.getDocumentUploadUri(fileUpload.parentId, fileUpload.parentType);
                    if (fileUpload.id && !fileUpload.destinationFileName) {
                        url += '/' + fileUpload.id;
                    }
                    return url + '?notify=false'; //v10 breaking change, the default dms provider will not email by default, the notification will be sent when the upload is completed as a seperate call to allow for batch notifications
                };
            }];

            provider.$get = function() {
                return provider;
            };
        }

        return DmsUploadConfigProviderImpl;
    })();

    DmsUploadService.$inject = _$inject;

    angular.module('bluemoon.dms.upload')
        .provider('dmsUploadConfig', DmsUploadConfigProvider)
        .factory('dmsUploadService', DmsUploadService);

})(window, window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.utility', [
        'bluemoon.components.httpStatusCodes'
    ])

    .service('utility', ['systemConstants', 'bluemoon.components.httpStatusCodes',
        function(systemConstants, httpStatusCodes){

            this.containsReservedCharacters = function(string){
                return this.containsCharacters(string, systemConstants.reservedFileAndFolderCharacters);
            };

            this.validFolderNameLength = function(name){
                return this.lengthInRange(name, systemConstants.minFolderNameLength,
                    systemConstants.maxFolderNameLength);
            };

            this.validDocumentNameLength = function(name){
                return this.lengthInRange(name, systemConstants.minDocumentNameLength,
                    systemConstants.maxDocumentNameLength);
            };

            this.containsCharacters = function(string, characters){
                for (var i = 0; i < characters.length; i++){
                    if (string.indexOf(characters[i]) > -1){
                        return true;
                    }
                }
                return false;
            };

            this.lengthInRange = function(container, min, max) {
                return (min <= container.length && container.length <= max);
            };

            this.isConflictCode = function(httpStatusCode) {
                return httpStatusCode === httpStatusCodes.conflict;
            };

            this.isForbiddenCode = function(httpStatusCode) {
                return httpStatusCode === httpStatusCodes.forbidden;
            };

            this.ToolBar = {

                ifNotLocked : function(gridData) {
                    return gridData.selectedItems && window._.every(gridData.selectedItems, function(item) {
                        return !item.lock;
                    }) && gridData.selectedItems.length === 1;
                },

                ifCanBeDeleted : function(gridData) {
                    if(gridData.currentContainer && gridData.currentContainer.permissions &&
                       !gridData.currentContainer.permissions.delete) {
                        // Container has contributor/reviewer permissions

                        // Manually check each item for delete rights
                        return gridData.selectedItems && window._.every(gridData.selectedItems, function(item) {
                            return item.permissions && item.permissions.delete;
                        });
                    } else if(gridData.currentContainer && gridData.currentContainer.permissions &&
                              gridData.currentContainer.permissions.delete) {
                        // Container has owner permissions
                        return gridData.selectedItems && window._.every(gridData.selectedItems, function(item) {
                            return !item.lock;
                        });
                    }
                },

                ifCanBeMoved : function(gridData) {
                    if(gridData.currentContainer && gridData.currentContainer.permissions &&
                        !gridData.currentContainer.permissions.move) {
                        // Container has contributor/reviewer permissions

                        // Manually check each item for move rights
                        return gridData.selectedItems && window._.every(gridData.selectedItems, function(item) {
                            return item.permissions && item.permissions.move;
                        });
                    } else if(gridData.currentContainer && gridData.currentContainer.permissions && gridData.currentContainer.permissions.move) {
                        // Container has owner permissions
                        return gridData.selectedItems && window._.every(gridData.selectedItems, function(item) {
                            return !item.lock;
                        });
                    }
                },

                ifCanBeUpdated : function(gridData) {
                    if(gridData.currentContainer && gridData.currentContainer.permissions && gridData.currentContainer.permissions.update) {
                        return gridData.selectedItems && window._.every(gridData.selectedItems, function(item) {
                            return !item.lock || item.lock.resourceRestrictions.indexOf('UPDATE') < 0;
                        });
                    }
                },

                ifCanAddContents : function(gridData) {
                    return gridData.currentContainer && gridData.currentContainer.permissions && gridData.currentContainer.permissions.addContents&& (!gridData.currentContainer.lock || gridData.currentContainer.lock.resourceRestrictions.indexOf('CREATE_SUB_RESOURCE') < 0);
                },

                ifOnlyOneSelected : function(gridData) {
                    return gridData.selectedItems && gridData.selectedItems.length === 1;
                },

                ifAtLeastOneSelected : function(gridData) {
                    return gridData.selectedItems && gridData.selectedItems.length > 0;
                },

                ifOnlyDocumentsSelected : function(gridData) {
                    return gridData.selectedItems && window._.every(gridData.selectedItems, function(item) {
                        return item.itemType === 'Document';
                    }) && gridData.selectedItems.length > 0;
                },

                ifOnlyOneDocumentSelected : function(gridData) {
                    return gridData.selectedItems && gridData.selectedItems.length === 1 && gridData.selectedItems[0].itemType === 'Document';
                },

                ifOnlyFoldersSelected : function(gridData) {
                    return gridData.selectedItems && window._.every(gridData.selectedItems, function(item) {
                        return item.itemType === 'Folder';
                    }) && gridData.selectedItems.length > 0;
                },

                ifOnlyProjectsSelected : function(gridData){
                    return gridData.selectedItems && window._.every(gridData.selectedItems, function(item) {
                        return item.itemType === 'Project';
                    }) && gridData.selectedItems.length > 0;
                },

                always : function() {
                    return true;
                },

                buttonClick : function(selectedItems, clickFunction) {
                    return function() {
                        if (!this.shouldBeEnabled || this.shouldBeEnabled(selectedItems)) {
                            clickFunction();
                        }
                    };
                }
            };
        }
    ]);
})(window.angular);

(function(window, angular) {
    'use strict';

    var bMoonApp = angular.module('bluemoon.dms.utility');

    var uiStrings = function(systemConstants) {

        this._blankItemMessage = function(field){
            return 'Please enter a ' + field + '.';
        };

        this._exceedsMaxLengthMessage = function(field, length){
            return field + ' cannot exceed ' + length + ' characters.';
        };

        this._exceedsMinLengthMessage = function(field, length){
            return field + ' cannot be less than ' + length + ' characters.';
        };

        this._containsReservedCharactersMessage = function(field, chars){
            return field + ' cannot contain any of the following: ' + chars.split('').join(' ');
        };

        this._cannotBeginWithPeriodMessage = function(field){
            return field + ' cannot begin with a period.';
        };

        this._alreadyExists = function(field){
            return 'Please enter a unique ' + field + '.';
        };

        this.downloadError = 'Error downloading document(s). Please try again later';
        this.downloadErrorNoDocuments = 'No documents to download';

        this.blankFileMessage = this._blankItemMessage('name');

        this.exceedsMaxFileLengthMessage = this._exceedsMaxLengthMessage('Name', systemConstants.maxDocumentNameLength);

        this.exceedsMinFileLengthMessage = this._exceedsMaxLengthMessage('Name', systemConstants.minDocumentNameLength);

        this.fileContainsReservedCharactersMessage = this._containsReservedCharactersMessage('Name', systemConstants.reservedFileAndFolderCharacters);

        this.fileCannotBeginWithPeriodMessage = this._cannotBeginWithPeriodMessage('Name');

        this.folderAlreadyExists = this._alreadyExists('name');
        this.fileAlreadyExists = this._alreadyExists('name');

        this.projectAlreadyExists = this._alreadyExists('name');

        this.noFolderSelected = 'Please select a folder.';

        this.unknownError = 'Unexpected error occurred.';
    };

    uiStrings.$inject = ['systemConstants'];
    bMoonApp.service('UiStrings', uiStrings);
})(window, window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.utility')

    .constant('systemConstants', {
        'reservedFileAndFolderCharacters' : '/?<>\\*|"',
        'minFolderNameLength' : 1,
        'maxFolderNameLength' : 150,
        'minDocumentNameLength' : 1,
        'maxDocumentNameLength' : 255
    });
})(window.angular);

(function(angular, _) {
    'use strict';

    angular.module('bluemoon.dms.utility.queue', [])

    .service('DmsQueue', [
        '$q',
        '$timeout',
        function(
            $q,
            $timeout) {

            var defaults = {
                delay: 100,
                paused: false,
                processCapacity: 4,
                batchCompleteCallback: angular.noop,
            };

            var DmsQueue = function(options) {
                var _this = this;

                options = angular.extend({}, defaults, options);
                var _queueProcessLoopTimeoutPromise = null;

                _this.queue = [];
                _this.delay = options.delay;
                _this.paused = options.paused;
                _this.processCapacity = options.processCapacity;
                _this.batchCompleteCallback = options.batchCompleteCallback;

                _this.processLoopRunning = false;
                _this.numberProcessing = 0;

                _this.size = function() {
                    return _this.queue.length;
                };

                _this.clear = function() {
                    _this.queue = [];
                };

                _this.add = function(queueItemToAdd) {
                    return _this.addEach([queueItemToAdd]);
                };

                _this.addEach = function(queueItemsToAdd) {
                    if (queueItemsToAdd) {

                        var invalidItems = _.find(queueItemsToAdd, function(item){
                            return !_.isNull(item) && !_.isUndefined(item) &&
                                !_.isFunction(item.callback);
                        });

                        if (!_.isUndefined(invalidItems)){
                            throw new Error('callback must be a function.');
                        }

                        _this.queue = _this.queue.concat(queueItemsToAdd);
                    }

                    if (!_this.paused && !_this.processLoopRunning) {
                        _this.go();
                    }
                };

                _this.isProcessing = function() {
                    return _this.processLoopRunning;
                };

                var _stop = function() {
                    if (_queueProcessLoopTimeoutPromise) {
                        $timeout.cancel(_queueProcessLoopTimeoutPromise);
                    }
                    _queueProcessLoopTimeoutPromise = null;
                };

                _this.pause = function() {
                    _stop();
                    _this.paused = true;
                };

                function _callBackComplete(){
                    _this.numberProcessing--;
                    _queueProcessLoopTimeoutPromise =
                        $timeout(_queueProcessLoop, _this.delay);
                }

                function _queueProcessLoop(){
                    _stop();

                    if (_this.paused || !_this.size()) {
                        if (_this.numberProcessing === 0) {
                            _this.processLoopRunning = false;
                            _this.batchCompleteCallback();
                        }
                        return;
                    }

                    var callbackPromise;
                    var queueItemToProcess;

                    while (_this.numberProcessing < _this.processCapacity) {
                        queueItemToProcess = _this.queue.shift();
                        if (!queueItemToProcess) {
                            break;
                        }

                        _this.numberProcessing++;
                        callbackPromise = queueItemToProcess.callback(queueItemToProcess.item);

                        if (!callbackPromise.then) {
                            throw new Error('callback should return a promise.');
                        }

                        callbackPromise.then(_callBackComplete, _callBackComplete);
                    }
                }

                _this.go = function() {
                    _this.processLoopRunning = true;
                    _this.paused = false;
                    if (_this.size() && !_queueProcessLoopTimeoutPromise) {
                        _queueProcessLoop();
                    }
                };
            };

            DmsQueue.newQueue = function (callback, options) {
                return new DmsQueue(callback, options);
            };

            return DmsQueue;
        }
    ]);
})(window.angular, window._);

 (function(angular) {
    'use strict';

    angular.module('bluemoon.dms.utility.cache', [])

    .factory('DmsCache', ['$interval',
        function($interval) {
            return function(cache) {
                var _this = this;
                _this._cache = cache;

                _this.setExpiration = function (key, validDuration) {
                    if (validDuration && angular.isNumber(validDuration)) {
                        $interval(function(){
                            _this._cache.remove(key);
                        }, validDuration, 1);
                    }
                };

                _this.info = _this._cache.info;
                _this.put = _this._cache.put;
                _this.get = _this._cache.get;
                _this.remove = _this._cache.remove;
                _this.removeAll = _this._cache.removeAll;
                _this.destroy = _this._cache.destroy;
            };
        }
    ])

    .factory('dmsCacheFactory', ['$cacheFactory', 'DmsCache',
        function($cacheFactory, DmsCache){
            var factory = {};

            factory.info = $cacheFactory.info;

            factory.create = function(cacheId) {
                return new DmsCache($cacheFactory(cacheId));
            };

            factory.get = function(cacheId) {
                return new DmsCache($cacheFactory.get(cacheId));
            };

            return factory;
        }
    ]);

})(window.angular);

(function(angular){
    'use strict';

    var getFolderDocument = ['fileManager', '$stateParams', function(fileManager, $stateParams) {
        return fileManager.getDocumentMetaDataWrapper($stateParams.folderId, 'folders', $stateParams.fileId);
    }];

    var getProjectDocument = ['fileManager', '$stateParams', function(fileManager, $stateParams) {
        return fileManager.getDocumentMetaDataWrapper($stateParams.projectId, 'projects', $stateParams.fileId);
    }];

    var getTemplateDocument = ['fileManager', '$stateParams', function(fileManager, $stateParams) {
        return fileManager.getDocumentMetaDataWrapper($stateParams.templateId, 'projects', $stateParams.fileId);
    }];

    angular.module('bluemoon.dms.utility.routing', ['bluemoon.dms.services'])

    .controller('dmsProjectRouteRedirect', ['$state', '$stateParams', 'dmsProjectService', function($state, $stateParams, projectService) {
        projectService.get($stateParams.projectId).then(function(result){
            var project = result.data;
            if (project.primaryAssociationType === 'Client') {

                var params = $stateParams;

                params.clientId = project.primaryAssociationId;

                $state.go($state.current.name.replace('WithoutClient', ''), params);
            }
        });
    }])

    .constant('dmsRoutes', {
        defaultRoute: {
            from: '/documents',
            to: '/documents/all'
        },
        routes: [
            //FOLDERS/FILES
            {
                name: 'firmFolder',
                config: {
                    url: '/documents/folder/firm',
                    templateUrl: 'documents/folders/masterlist/folder-master.html',
                    controller: 'folderMaster'
                }
            },
            {
                name: 'folderList',
                config: {
                    url: '/documents/folders/:folderId',
                    templateUrl: 'documents/folders/masterlist/folder-master.html',
                    controller: 'folderMaster'
                }
            },
            {
                name: 'folderFileView',
                config: {
                    url: '/documents/folders/:folderId/file/:fileId',
                    templateUrl: 'documents/files/file-view.html',
                    controller: 'folderFileView',
                    resolve: {
                        getDocument: getFolderDocument
                    }
                }
            },
            //ALL DOCS
            {
                name: 'allDocsRootList',
                config: {
                    url: '/documents/all',
                    templateUrl: 'documents/all-docs/masterlist/all-docs-master.html',
                    controller: 'allDocsMaster'
                }
            },
            //CLIENTS
            {
                name: 'clientRootList',
                config: {
                    url: '/documents/clients',
                    templateUrl: 'documents/clients/masterlist/client-master.html',
                    controller: 'clientMaster'
                }
            },
            {
                name: 'clientStorageList',
                config: {
                    url: '/documents/clients/:clientId/storage',
                    templateUrl: 'documents/storage/masterlist/storage-master.html',
                    controller: 'storageMaster'
                }
            },
            //PROJECTS
            {
                name: 'projectRootList',
                config: {
                    url: '/documents/clients/:clientId/storage/:projectId/folders',
                    templateUrl: 'documents/folders/masterlist/folder-master.html',
                    controller: 'folderMaster'
                }
            },
            {
                name: 'projectFolderList',
                config: {
                    url: '/documents/clients/:clientId/storage/:projectId/folders/:folderId',
                    templateUrl: 'documents/folders/masterlist/folder-master.html',
                    controller: 'folderMaster'
                }
            },
            {
                name: 'projectRootFileView',
                config: {
                    url: '/documents/clients/:clientId/storage/:projectId/file/:fileId',
                    templateUrl: 'documents/files/file-view.html',
                    controller: 'folderFileView',
                    resolve: {
                        getDocument: getProjectDocument
                    }
                }
            },
            {
                name: 'projectFileView',
                config: {
                    url: '/documents/storage/:projectId/folders/:folderId/file/:fileId',
                    templateUrl: 'documents/files/file-view.html',
                    controller: 'folderFileView',
                    resolve: {
                        getDocument: getFolderDocument
                    }
                }
            },
            {
                name: 'projectRootListWithoutClient',
                config: {
                    url: '/documents/storage/:projectId/folders',
                    controller: 'dmsProjectRouteRedirect'
                }
            },
            {
                name: 'projectFolderListWithoutClient',
                config: {
                    url: '/documents/storage/:projectId/folders/:folderId',
                    controller: 'dmsProjectRouteRedirect'
                }
            },
            {
                name: 'projectRootFileViewWithoutClient',
                config: {
                    url: '/documents/storage/:projectId/file/:fileId',
                    controller: 'dmsProjectRouteRedirect',
                    resolve: {
                        getDocument: getProjectDocument
                    }
                }
            },
            {
                name: 'projectFileViewWithoutClient',
                config: {
                    url: '/documents/storage/:projectId/folders/:folderId/file/:fileId',
                    controller: 'dmsProjectRouteRedirect',
                    resolve: {
                        getDocument: getFolderDocument
                    }
                }
            },
            //TEMPLATES
            {
                name: 'templateList',
                config: {
                    url: '/documents/templates',
                    templateUrl: 'documents/templates/masterlist/template-master.html',
                    controller: 'templateMaster',
                    frp: ['OnvioDrive.Templates']
                }
            },
            {
                name: 'templateRootList',
                config: {
                    url: '/documents/templates/:templateId/folders',
                    templateUrl: 'documents/folders/masterlist/folder-master.html',
                    controller: 'folderMaster',
                    frp: ['OnvioDrive.Templates']
                }
            },
            {
                name: 'templateFolderList',
                config: {
                    url: '/documents/templates/:templateId/folders/:folderId',
                    templateUrl: 'documents/folders/masterlist/folder-master.html',
                    controller: 'folderMaster',
                    frp: ['OnvioDrive.Templates']
                }
            },
            {
                name: 'templateRootFileView',
                config: {
                    url: '/documents/templates/:templateId/file/:fileId',
                    templateUrl: 'documents/files/file-view.html',
                    controller: 'folderFileView',
                    frp: ['OnvioDrive.Templates'],
                    resolve: {
                        getDocument: getTemplateDocument
                    }
                }
            },
            {
                name: 'templateFileView',
                config: {
                    url: '/documents/templates/:templateId/folders/:folderId/file/:fileId',
                    templateUrl: 'documents/files/file-view.html',
                    controller: 'folderFileView',
                    frp: ['OnvioDrive.Templates'],
                    resolve: {
                        getDocument: getFolderDocument
                    }
                }
            },
            //REQUESTS
            {
                name: 'requestsList',
                config: {
                    url: '/documents/requests',
                    templateUrl: 'documents/requests/masterlist/request-master.html',
                    controller: 'requestMaster',
                    frp: ['OnvioDrive.Requests']
                }
            },
            {
                name: 'requestAdd',
                config: {
                    url: '/documents/requests/add',
                    templateUrl: 'documents/requests/actions/add-edit-master.html',
                    controller: 'addEditMaster',
                    frp: ['OnvioDrive.Requests']
                }
            },
            {
                name: 'requestEdit',
                config: {
                    url: '/documents/requests/:requestId',
                    templateUrl: 'documents/requests/actions/add-edit-master.html',
                    controller: 'addEditMaster',
                    frp: ['OnvioDrive.Requests']
                }
            },
            //RECYCLE BIN
            {
                name: 'recycleList',
                config: {
                    url: '/documents/recyclebin',
                    templateUrl: 'documents/recycle/masterlist/recycle-view.html',
                    controller: 'recycleMaster',
                    frp: ['OnvioDrive.RecycleBin']
                }
            },
            //RECENT ACTIVITY
            {
                name: 'recentsList',
                config: {
                    url: '/documents/recents',
                    templateUrl: 'documents/recents/masterlist/recents-master.html',
                    controller: 'recentsMaster',
                    frp: ['OnvioDrive.RecentActivity']
                }
            },
            //SEARCH
            {
                name: 'documentSearchResults',
                config: {
                    url: '/documents/files/searchresults',
                    templateUrl: 'documents/search/document-search-results.html',
                    controller: 'searchMaster'
                }
            }
        ]
    });

})(window.angular);

(function(angular){
    'use strict';

    var DmsPermission = (function() {
        var _$inject = ['bmPermission', 'bmAccess'];

        function DmsPermissionImpl(bmPermission, bmAccess) {

            var service = this;

            service.has = function(permission) {
                return bmPermission.has(permission).then(function(){
                    return true;
                }).catch(function(){
                    return false;
                });
            };

            service.hasNegIAC = function(permission) {
                return bmAccess.has(permission).then(function(){
                    return false;
                }).catch(function(){
                    return true;
                });
            };
        }

        DmsPermissionImpl.$inject = _$inject;
        return DmsPermissionImpl;
    }());

    angular.module('bluemoon.dms.utility').service('dmsPermission', DmsPermission);

})(window.angular);

(function(angular){
    'use strict';

    angular.module('bluemoon.dms.validation', [
        'bluemoon.dms.utility'
    ]);
})(window.angular);

(function(window, angular) {
    'use strict';

    angular.module('bluemoon.dms.validation')
        .service('FileFolderValidation', ['systemConstants', 'utility', '$translate', '$q',
            function(systemConstants, utility, $translate, $q){

                var _this = this;

                var loadFileAndFolderNameStrings = function(){

                    var defer = $q.defer();

                    $translate('Bluemoon.DMS.Validation.Name').then(function(result){
                        var lowerCaseResult = result.toLowerCase();

                        $q.all([
                            $translate('Bluemoon.DMS.Validation.BlankField',                        { field: lowerCaseResult }),
                            $translate('Bluemoon.DMS.Validation.FieldExceedsMaxLength',             { field: result, length: systemConstants.maxFolderNameLength}),
                            $translate('Bluemoon.DMS.Validation.FieldFailsToMeetMinLength',         { field: result, length: systemConstants.maxFolderNameLength}),
                            $translate('Bluemoon.DMS.Validation.ContainsReservedCharactersMessage', { field: result }),
                            $translate('Bluemoon.DMS.Validation.FieldCannotBeginWithPeriod',        { field: result }),
                        ]).then(function(s){
                            defer.resolve({
                                'Bluemoon.DMS.Validation.BlankField'                                : s[0],
                                'Bluemoon.DMS.Validation.FieldExceedsMaxLength'                     : s[1],
                                'Bluemoon.DMS.Validation.FieldFailsToMeetMinLength'                 : s[2],
                                'Bluemoon.DMS.Validation.ContainsReservedCharactersMessage'         : s[3],
                                'Bluemoon.DMS.Validation.FieldCannotBeginWithPeriod'                : s[4],
                            });
                        });
                    });

                    return defer.promise;
                };

                _this.containsReservedCharacters = function(string){
                    return utility.containsCharacters(string, systemConstants.reservedFileAndFolderCharacters);
                };

                _this.validateFolderName = function(name){

                    var deferred = $q.defer();

                    loadFileAndFolderNameStrings().then(function(translations){
                        var res = _this._validateName({
                            name : name,
                            blankNameMessage : translations['Bluemoon.DMS.Validation.BlankField'],
                            exceedsMaxLengthMessage : translations['Bluemoon.DMS.Validation.FieldExceedsMaxLength'],
                            failsMinLengthMessage : translations['Bluemoon.DMS.Validation.FieldFailsToMeetMinLength'],
                            containsReservedCharactersMessage : translations['Bluemoon.DMS.Validation.ContainsReservedCharactersMessage'] + systemConstants.reservedFileAndFolderCharacters,
                            beginsWithPeriodMessage : translations['Bluemoon.DMS.Validation.FieldCannotBeginWithPeriod'],
                            minNameLength : systemConstants.minFolderNameLength,
                            maxNameLength : systemConstants.maxFolderNameLength,
                        });

                        deferred.resolve(res);
                    });

                    return deferred.promise;
                };

                _this.validateFileName = function(name){

                    var deferred = $q.defer();

                    loadFileAndFolderNameStrings(name).then(function(translations){
                        var res = _this._validateName({
                            'name' : name,
                            'blankNameMessage' : translations['Bluemoon.DMS.Validation.BlankField'],
                            'exceedsMaxLengthMessage' :  translations['Bluemoon.DMS.Validation.FieldExceedsMaxLength'],
                            'failsMinLengthMessage' : translations['Bluemoon.DMS.Validation.FieldFailsToMeetMinLength'],
                            'containsReservedCharactersMessage' : translations['Bluemoon.DMS.Validation.ContainsReservedCharactersMessage'] + systemConstants.reservedFileAndFolderCharacters,
                            'beginsWithPeriodMessage' : translations['Bluemoon.DMS.Validation.FieldCannotBeginWithPeriod'],
                        });

                        deferred.resolve(res);
                    });

                    return deferred.promise;
                };

                _this._validateName = function(nameValidationObject){
                    var errorMessage;
                    if (angular.isUndefined(nameValidationObject.name) || !angular.isString(nameValidationObject.name) ||
                        nameValidationObject.name === ''){
                        errorMessage = nameValidationObject.blankNameMessage;
                    } else if (nameValidationObject.name.length < nameValidationObject.minNameLength) {
                        errorMessage = nameValidationObject.exceedsMaxLengthMessage;
                    } else if (nameValidationObject.name.length > nameValidationObject.maxNameLength) {
                        errorMessage = nameValidationObject.failsMinLengthMessage;
                    } else if (_this.containsReservedCharacters(nameValidationObject.name)){
                        errorMessage = nameValidationObject.containsReservedCharactersMessage;
                    } else if (nameValidationObject.name[0] === '.') {
                        errorMessage = nameValidationObject.beginsWithPeriodMessage;
                    }
                    return errorMessage;
                };

            }
        ]);

})(window, window.angular);

(function(window, angular) {
    'use strict';

    angular.module('bluemoon.dms.validation')
        .service('ProjectValidation', ['systemConstants', 'utility', '$translate', '$q',
            function(systemConstants, utility, $translate, $q){

                var _this = this;

                var loadProjectNameStrings = function(){

                    var defer = $q.defer();

                    $translate('Bluemoon.DMS.Validation.Name').then(function(result){
                        var lowerCaseResult = result.toLowerCase();

                        $q.all([
                            $translate('Bluemoon.DMS.Validation.BlankField',                        { field: lowerCaseResult }),
                            $translate('Bluemoon.DMS.Validation.FieldExceedsMaxLength',             { field: result, length: systemConstants.maxFolderNameLength}),
                            $translate('Bluemoon.DMS.Validation.FieldFailsToMeetMinLength',         { field: result, length: systemConstants.maxFolderNameLength}),
                            $translate('Bluemoon.DMS.Validation.ContainsReservedCharactersMessage', { field: result }),
                            $translate('Bluemoon.DMS.Validation.FieldCannotBeginWithPeriod',        { field: result }),
                        ]).then(function(s){
                            defer.resolve({
                                'Bluemoon.DMS.Validation.BlankField'                                : s[0],
                                'Bluemoon.DMS.Validation.FieldExceedsMaxLength'                     : s[1],
                                'Bluemoon.DMS.Validation.FieldFailsToMeetMinLength'                 : s[2],
                                'Bluemoon.DMS.Validation.ContainsReservedCharactersMessage'         : s[3],
                                'Bluemoon.DMS.Validation.FieldCannotBeginWithPeriod'                : s[4],
                            });
                        });
                    });

                    return defer.promise;
                };

                _this.containsReservedCharacters = function(string){
                    return utility.containsCharacters(string, systemConstants.reservedFileAndFolderCharacters);
                };

                _this.validateProjectName = function(name){

                    var deferred = $q.defer();

                    loadProjectNameStrings().then(function(translations){
                        var res = _this._validateName({
                            projectName : name,
                            blankNameMessage : translations['Bluemoon.DMS.Validation.BlankField'],
                            exceedsMaxLengthMessage : translations['Bluemoon.DMS.Validation.FieldExceedsMaxLength'],
                            failsMinLengthMessage : translations['Bluemoon.DMS.Validation.FieldFailsToMeetMinLength'],
                            containsReservedCharactersMessage : translations['Bluemoon.DMS.Validation.ContainsReservedCharactersMessage'] + systemConstants.reservedFileAndFolderCharacters,
                            beginsWithPeriodMessage : translations['Bluemoon.DMS.Validation.FieldCannotBeginWithPeriod'],
                            minNameLength : systemConstants.minFolderNameLength,
                            maxNameLength : systemConstants.maxFolderNameLength,
                        });

                        deferred.resolve(res);
                    });

                    return deferred.promise;
                };

                _this._validateName = function(validationObject){
                    var errorMessage;
                    if (angular.isUndefined(validationObject.projectName) || !angular.isString(validationObject.projectName) ||
                        validationObject.projectName === ''){
                        errorMessage = validationObject.blankNameMessage;
                    } else if (validationObject.projectName.length < validationObject.minNameLength) {
                        errorMessage = validationObject.failsMinLengthMessage;
                    } else if (validationObject.projectName.length > validationObject.maxNameLength) {
                        errorMessage = validationObject.exceedsMaxLengthMessage;
                    } else if (_this.containsReservedCharacters(validationObject.projectName)){
                        errorMessage = validationObject.containsReservedCharactersMessage;
                    } else if (validationObject.projectName[0] === '.') {
                        errorMessage = validationObject.beginsWithPeriodMessage;
                    }
                    return errorMessage;
                };
            }
        ]);
})(window, window.angular);

(function(angular){
    'use strict';

    var DmsPreviewableDocumentService = (function(){
        var _$inject = [];

        function DmsPreviewableDocumentServiceImpl() {
            var service = this;

            service.supportedImageType = function(mimeType) {
                return ['image/jpeg',
                    'image/bmp',
                    'image/png',
                    'image/x-ms-bmp',
                    'image/x-png'].indexOf(mimeType) > -1;
            };

            service.supportedPdfType = function(mimeType) {
                return 'application/pdf' === mimeType;
            };

            service.supportedType = function(mimeType) {
                return service.supportedImageType(mimeType) || service.supportedPdfType(mimeType);
            };
        }

        DmsPreviewableDocumentServiceImpl.$inject = _$inject;
        return DmsPreviewableDocumentServiceImpl;
    }());

    var DmsDocumentViewPaneDirective = (function(){
        var _$inject = ['dmsPreviewableDocument', '$timeout', 'bmUtil', '$document', '$sce'];

        function DmsDocumentViewPaneDirectiveImpl(previewableDocument, $timeout, bmUtil, $document, $sce) {

            var pdfIFrameId;
            function pdfIframeInserter(element, src, pdfViewHeight) {
                if(!pdfIFrameId) {
                    pdfIFrameId = 'dms-pdfViewer-' + bmUtil.generateUUID().split('-').join('');
                }

                var iframe = $document[0].querySelector('#' + pdfIFrameId);
                var pdfIFrame;
                if(!iframe){
                    pdfIFrame = $document[0].createElement('iframe');
                    pdfIFrame.id = pdfIFrameId;
                    pdfIFrame.style.width = '100%';
                    pdfIFrame.style.height = pdfViewHeight + 'px';

                    var placement = element.find('div').eq(0);
                    placement.append(pdfIFrame);
                } else {
                    pdfIFrame = iframe;
                }

                var url = src;
                pdfIFrame.src = $sce.trustAsResourceUrl(url);
            }

            function link(scope, element) {
                scope.supportedImageType = previewableDocument.supportedImageType;
                scope.supportedPdfType = previewableDocument.supportedPdfType;
                scope.supportedType = previewableDocument.supportedType;

                scope.$watchGroup(['mimeType', 'src'], function(){
                    if(scope.mimeType && scope.src && scope.pdfViewHeight){
                        if(previewableDocument.supportedPdfType(scope.mimeType)) {
                            $timeout(function(){
                                pdfIframeInserter(element, scope.src, scope.pdfViewHeight);
                            });
                        }
                    }
                });

                scope.$watch('pdfViewHeight', function(newValue){
                    if(element.find('iframe')[0] && newValue){
                        element.find('iframe')[0].style.height = newValue + 'px';
                    }
                });
            }

            return {
                restrict: 'EA',
                replace: true,
                scope: {
                    src: '@',
                    mimeType: '@',
                    pdfViewHeight: '@'
                },
                templateUrl: 'components/viewer/document/document-view-pane.2js.html',
                link: link
            };
        }

        DmsDocumentViewPaneDirectiveImpl.$inject = _$inject;
        return DmsDocumentViewPaneDirectiveImpl;
    }());

    var DmsDocumentViewerDirective = (function() {
        var _$inject = ['$sce', '$translate', 'dmsDocumentService', 'dmsDocumentUiService', 'dmsPreviewableDocument', '$window', '$document'];

        function DmsDocumentViewerDirectiveImpl($sce, $translate, documentService, documentUiService, previewableDocument, $window, $document){

            function link(scope) {

                function loadStrings() {
                    return $translate('Bluemoon.DMS.Toolbar.Download').then(function(s){
                        scope.toolbarButtons[0].text = s;
                    });
                }

                var downloadDocument = angular.noop;

                function downloadDocumentWithAccessToken() {
                    documentUiService.download({
                        params: {
                            accessToken: scope.accessToken
                        }
                    });
                }

                function downloadDocumentWithIdentifier() {
                    documentUiService.download({
                        params: {
                            document: {
                                id: scope.documentId,
                                parentItem: {
                                    id: scope.containerId,
                                    itemType: scope.containerType
                                }
                            }
                        }
                    });
                }

                function setDocumentData(result) {
                    scope.downloadUrl = result.data.downloadUrl;
                    scope.src = $sce.trustAsResourceUrl(result.data.downloadUrl);

                    scope.documentName = result.data.name;
                    scope.mimeType = result.data.mimeType;
                }

                var w = angular.element($window);

                var unwatchToolbar = scope.$watch(function(){
                    return $document[0].querySelector('.bento-toolbar');
                }, function(newValue){
                    if(newValue){
                        scope.pdfViewHeight = w.height() - newValue.getBoundingClientRect().bottom - 45;
                        unwatchToolbar();
                    }

                });

                scope.$watch(function(){
                        return angular.element($window).height();
                }, function(newValue){
                    if(newValue){
                        var toolbar = $document[0].querySelector('.bento-toolbar');
                        if(toolbar){
                            scope.pdfViewHeight = newValue - toolbar.getBoundingClientRect().bottom - 45;
                        }
                    }
                });

                scope.supportedType = previewableDocument.supportedType;

                scope.$watch('accessToken', function(){
                    if (scope.accessToken) {
                        scope.loadStatus = 'loading';
                        documentService.getFromAccessToken(scope.accessToken).then(function(result){
                            downloadDocument = downloadDocumentWithAccessToken;
                            setDocumentData(result);
                            scope.loadStatus = 'loaded';
                            if(scope.onLoad) {
                                scope.onLoad({ data: result.data });
                            }
                        });
                    }
                });

                scope.$watchGroup(['containerType', 'containerId', 'documentId'], function(){
                    if(scope.containerType && scope.containerId && scope.documentId) {
                        scope.loadStatus = 'loading';
                        documentService.get({
                            type: scope.containerType,
                            id: scope.containerId
                        }, scope.documentId, {
                            includeDownloadUrl: true
                        }).then(function(result){
                            downloadDocument = downloadDocumentWithIdentifier;
                            setDocumentData(result);
                            scope.loadStatus = 'loaded';
                            if(scope.onLoad) {
                                scope.onLoad({ data: result.data });
                            }
                        });
                    }
                });

                scope.$on('bmLanguageChangeSuccess', function(){
                    loadStrings();
                });

                scope.toolbarButtons = [{
                    'icon': 'glyphicon-log-out',
                    'click': function(){ downloadDocument(); }
                }];

                scope.loadStatus = 'loading';

                loadStrings();
            }

            return {
                restrict: 'EA',
                replace: true,
                scope: {
                    accessToken: '@',
                    containerType: '@',
                    containerId: '@',
                    documentId: '@',
                    onLoad: '&'
                },
                templateUrl: 'components/viewer/document/document-viewer.2js.html',
                link: link
            };
        }

        DmsDocumentViewerDirectiveImpl.$inject = _$inject;
        return DmsDocumentViewerDirectiveImpl;
    })();

    angular.module('bluemoon.dms.viewer.templates', []);

    angular.module('bluemoon.dms.viewer', [
        'pascalprecht.translate',
        'bluemoon.dms.services',
        'bluemoon.dms.ui-services',
        'bluemoon.dms.toolbar',
        'bluemoon.dms.viewer.templates'
        ])

        .service('dmsPreviewableDocument', DmsPreviewableDocumentService)
        .directive('dmsDocumentViewPane', DmsDocumentViewPaneDirective)
        .directive('dmsDocumentViewer', DmsDocumentViewerDirective);

})(window.angular);

angular.module('bluemoon.dms.viewer.templates', ['components/viewer/document/document-view-pane.2js.html', 'components/viewer/document/document-viewer.2js.html']);

angular.module("components/viewer/document/document-view-pane.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/viewer/document/document-view-pane.2js.html",
    "<div class=\"document-view-pane\">\n" +
    "    <div ng-if=\"mimeType && supportedType(mimeType)\">\n" +
    "        <img ng-if=\"supportedImageType(mimeType)\"\n" +
    "            class=\"img-document-pane\"\n" +
    "            ng-src=\"{{ src }}\" />\n" +
    "    </div>\n" +
    "    <div ng-if=\"mimeType && !supportedType(mimeType)\" class=\"dms-center-text\">\n" +
    "        <br/>\n" +
    "        <span class=\"unsupported-document-pane\" ng-if=\"!supportedType(mimeType)\"\n" +
    "              translate=\"Bluemoon.DMS.Viewer.FileTypeNotPreviewable\"></span>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/viewer/document/document-viewer.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/viewer/document/document-viewer.2js.html",
    "<div class=\"document-viewer\">\n" +
    "	<div ng-if=\"loadStatus === 'loaded' && supportedType(mimeType)\">\n" +
    "		<h2>{{documentName}}</h2>\n" +
    "		<dms-toolbar buttons=\"toolbarButtons\"></dms-toolbar>\n" +
    "		<dms-document-view-pane pdf-view-height=\"{{pdfViewHeight}}\" src=\"{{src}}\" mime-type=\"{{mimeType}}\"></dms-document-view-pane>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

(function(angular){
    'use strict';

    angular.module('onvio.documents', [
        'ngSanitize',
        'ngAnimate',
        'ngGrid',
        'ui.router',
        'pascalprecht.translate',
        'ui.bootstrap',
        'angularFileUpload',
        'bento.modern',
        'bluemoon.components',
        'bluemoon.components.i18n',
        'bluemoon.dms.alerts',
        'bluemoon.dms.alerts.upload',
        'bluemoon.dms.alerts.operation',
        'bluemoon.dms.all-docs-grid',
        'bluemoon.dms.upload',
        'bluemoon.dms.managers',
        'bluemoon.dms.http',
        'bluemoon.dms.models',
        'bluemoon.dms.nav-breadcrumb',
        'bluemoon.dms.utility',
        'bluemoon.dms.utility.routing',
        'bluemoon.dms.toolbar',
        'bluemoon.dms.client-grid',
        'bluemoon.dms.cloud',
        'bluemoon.dms.document-grid',
        'bluemoon.dms.search-grid',
        'bluemoon.dms.storage-grid',
        'bluemoon.dms.recycle-grid',
        'bluemoon.dms.recents-grid',
        'bluemoon.dms.hover',
        'bluemoon.dms.ui-services',
        'bluemoon.dms.modal.folder-selection',
        'bluemoon.dms.modal.alert-display.operation',
        'bluemoon.dms.modal.alert-display.upload',
        'bluemoon.dms.viewer',
        'bluemoon.dms.validation'
    ])

    .config(['dmsNavBreadcrumbConfigProvider', function dmsNavBreadcrumbConfigProviderConfig(navBreadcrumbConfigProvider){
        navBreadcrumbConfigProvider.itemHref = ['$state', '$stateParams', function($state, $stateParams){

            function generateHrefForItem(item) {
                var itemType = item.container.itemType;

                //  Override the client root to all documents
                if (itemType === 'ClientRoot') {
                    return $state.href('allDocsRootList');
                } else if (itemType === 'TemplateRoot') {
                    return $state.href('templateList');
                } else if (itemType === 'Client') {
                    return $state.href('clientStorageList', {
                        clientId: item.container.id
                    });
                } else if (itemType === 'Project') {
                    if (item.container.primaryAssociationType === 'Client') {
                        return $state.href('projectRootList', {
                            projectId: item.container.id,
                            clientId: item.container.primaryAssociationId
                        });
                    } else if (item.container.primaryAssociationType === 'Firm' &&
                        item.container.primaryAssociationId === 'Templates') {
                        return $state.href('templateRootList', {
                            templateId: item.container.id
                        });
                    }
                } else if (itemType === 'Folder') {
                    if($state.current.name === 'templateFolderList') {
                        return $state.href('templateFolderList', {
                            templateId: $stateParams.templateId,
                            folderId: item.container.id
                        });
                    } else if($state.current.name === 'projectFolderList') {
                        return $state.href('projectFolderList', {
                            clientId: $stateParams.clientId,
                            projectId: $stateParams.projectId,
                            folderId: item.container.id
                        });
                    } else {
                        return $state.href('folderList', {
                            folderId: item.container.id
                        });
                    }
                } else if (itemType === 'rootList'){
                    return $state.href('allDocsRootList');
                }

                return '';
            }

            return generateHrefForItem;
        }];

        navBreadcrumbConfigProvider.itemClickable = ['$state', function($state){

            function isItemClickable(item, currentContainer) {
                if (['clientStorageList',
                    'folderList',
                    'projectFolderList',
                    'projectRootList',
                    'templateRootList',
                    'templateFolderList'].indexOf($state.current.name) !== -1) {
                    return item.container.id !== currentContainer.id ||
                        item.container.itemType !== currentContainer.type;
                }
                return true;
            }

            return isItemClickable;
        }];

        // this overrides the breadcrumb name of "Client Documents" and changes it to "Documents"
        navBreadcrumbConfigProvider.pathLoaded = ['$translate', function($translate) {
            return function(path) {
                if (path.length > 0) {
                    path[0].icon = 'folder';
                    path[0].text = '';
                    $translate('Bluemoon.DMS.Breadcrumbs.Documents').then(function(s){
                        path[0].text = s;
                    });
                }
            };
        }];
    }])

    .config(['dmsRecentsGridConfigProvider', function dmsRecentsGridConfigProviderConfig(dmsRecentsGridConfigProvider){

        dmsRecentsGridConfigProvider.itemHref = ['$state', '$stateParams', 'dmsRouteBuilder', function($state, $stateParams, dmsRouteBuilder){

            function generateHrefForItem(arr){
                var clientId = null;
                var projectId = null;
                var folderId = null;
                var fileId = null;
                var isInTrash = false;

                var immediateParent = {};

                if (!!arr[arr.length - 1].itemType && arr[arr.length - 1].itemType === 'Document'){
                    fileId = arr[arr.length - 1].id;
                    //NOTE: since the array is 1 bigger due to the item, we have to go 2 backwards.
                    immediateParent = {
                        type: arr[arr.length - 2].containerType,
                        id: arr[arr.length - 2].id
                    };
                } else {
                    immediateParent = {
                        type: arr[arr.length - 1].containerType,
                        id: arr[arr.length - 1].id
                    };
                }

                var topParent = {
                    type: arr[0].containerType,
                    id: arr[0].id
                };

                if (!!arr[0] && arr[0].containerType.toLowerCase() === 'projects'){
                    clientId = arr[0].primaryAssociationId;
                    projectId = topParent.id;
                    if (projectId !== immediateParent.id){
                        folderId = immediateParent.id;
                    }
                } else if(!!arr[0] && arr[0].containerType.toLowerCase() === 'folders'){
                    folderId = immediateParent.id;
                } else if (!!arr[0] && arr[0].containerType.toLowerCase() === 'trash'){
                    isInTrash = true;
                }

                return dmsRouteBuilder.buildState(clientId, projectId, folderId, fileId, isInTrash);
            }

            return generateHrefForItem;
        }];
    }]);

}(window.angular));

(function(angular, _){
    'use strict';

    var documentsApp = angular.module('onvio.documents');

    documentsApp.config(['$stateProvider', '$urlRouterProvider', 'dmsRoutes', function($stateProvider, $urlRouterProvider, dmsRoutes){
        $urlRouterProvider.when(dmsRoutes.defaultRoute.from, dmsRoutes.defaultRoute.to);

        //Override all "Drive" routes so that bookmarks still are TECHNICALLY valid.
        $urlRouterProvider.rule(function($injector, $location){
            var path = $location.path();
            var fixedPath = path.replace('drive', 'documents');
            if (path !== fixedPath){
                $location.replace().path(fixedPath);
            }
        });

        var configureRoute = function(route){

            if(route.config.resolve && route.config.resolve.getDocument){
                $stateProvider.state(route.name, {
                    url: route.config.url,
                    views : {
                    '@main' : { // here we are using absolute name targeting
                        templateUrl: route.config.templateUrl,
                        controller: route.config.controller,
                        resolve: {
                            getDocument: route.config.resolve.getDocument
                        }
                    },
                    },
                    parent: 'main'
                });
            } else {
                // TODO: USE ABSOLUTE NAMING ROUTES HERE SO WE CAN GO THROUGH MAIN
                // http://stackoverflow.com/questions/26716483/nested-ui-router-state-without-nested-view
                // $stateProvider.state(route.name, route.config);
                // TODO: NEED TO BETTER UNDERSTAND THIS ROUTING SETUP AND HOW IT FITS WITH DOCUMENTS SETUP
                $stateProvider.state(route.name, {
                    url: route.config.url,
                    views : {
                    '@main' : { // here we are using absolute name targeting
                        templateUrl: route.config.templateUrl,
                        controller: route.config.controller
                    },
                    },
                    parent: 'main'
                });
            }
        };

        _.each(dmsRoutes.routes, function(route) {

            //  This is a workaround for https://github.com/angular-translate/angular-translate/issues/855
            if (!route.config.resolve) {
                route.config.resolve = {};
            }

            if (!route.config.frp){
                route.config.frp = [];
            }

            route.config.frp.push('Applications.OnvioClientHub');

            //let's make sure you actually HAVE those frp's.
            //If not, direct to 404.
            route.config.resolve.frpCheck = ['$location', 'bmPermission', function($location, bmPermission){
                return bmPermission.hasEvery(route.config.frp).catch(function(){
                    $location.path('/notfound');
                });
            }];

            configureRoute(route);

            // TODO: Get rid of configureRoute altogether and use method below
            // $stateProvider.state(route.name, route.config);

        });
    }]);
})(window.angular, window._);

(function(angular, _){
    'use strict';

    var allDocsMaster = function($rootScope, $scope, $state, $window, $location, $translate, $q, folderManager, searchManager, DmsGridPageState, UiService, dmsPermission, bmAccess, dmsSearchGetSet, projectManager) {

        $scope.loading = true;

        var recentIAC = null;
        var recyclebinIAC = null;
        bmAccess.has('DMS_HideRecycleBin').then(function() {
            recyclebinIAC = false;
        }, function() {
            recyclebinIAC = true;
        });

        // Setting table height. I think we'll do this another way
        // in the end.
        $scope.rootFolderLink = '';
        $scope.firmFolderLink = '';

        //  Workaround for all docs grid not refreshing grid items on language change
        $scope.$on('bmLanguageChangeSuccess', function() {
            $state.reload();
        });

        $scope.go = function(path){
            $location.path('/' + path);
        };

        //TODO: clean
        var w = angular.element($window);

        $scope.getViewerHeight = function() {
            var grid = document.querySelector('#folder-grid');
            var top = 0;
            if(grid !== null && angular.isFunction(grid.getBoundingClientRect)){
                top = grid.getBoundingClientRect().top;
            }
            return w.height() - top - 75;
        };

        $scope.viewerHeight = $scope.getViewerHeight();

        $scope.$watch($scope.getViewerHeight, function(newValue) {
            $scope.viewerHeight = 'height: ' + newValue + 'px;';
        });

        w.bind('resize', function() {
            $scope.$apply();
        });

        var clearPageAlerts = function(){
            $scope.alerts = [];
        };

        var setupGrid = function() {
            $scope.buttons = [];

            $scope.gridOptions = {
                showColumnMenu : false,
                showGroupPanel : false,
                // sortInfo: { fields: ['name'], directions: ['asc'] }
            };
        };

        $scope.processSearch = function(term){
            if (term === undefined) { return; }
            searchManager.setSearchCriteria(term);
            dmsSearchGetSet.setSearchTerm(term);
            dmsSearchGetSet.setSelectedItem($scope.selectedItem);
            $state.go('documentSearchResults');
        };

        var loadStrings = function(){
            var deferred = $q.defer();

            $q.all([
                $translate('Bluemoon.DMS.SpecialFolders.Templates'),
                $translate('Bluemoon.DMS.SpecialFolders.Recents'),
                $translate('Bluemoon.DMS.SpecialFolders.RecycleBin'),
            ]).then(function(translations){
                $scope.templatesName = translations[0];
                $scope.recentsName   = translations[1];
                $scope.recycleName   = translations[2];
                deferred.resolve();
            });

            return deferred.promise;
        };

        var mainGridHandler = {
            getGridItems : function() {},
            refreshGrid : function(){
                this.getGridItems();
            }
        };

        var compareName = function(a, b){
            if (!a || !a.name || !b || !b.name) {return 0;}

            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        };

        $scope.pageState = new DmsGridPageState({ sort: 'name:asc' });

        var methodMap = {
            initialize : function() {
                $scope.breadCrumbList = [];
                $scope.alerts = [];
            },
            preExecute : function() {
                clearPageAlerts();
                setupGrid();
            },
            postExecute: function(){
                mainGridHandler.refreshGrid();
            },
            execute : function()
            {
                this.initialize();
                var toExecute = methodMap[$state.current.name];
                if (angular.isFunction(toExecute))
                {
                    this.preExecute();
                    toExecute();
                    this.postExecute();
                }
            },
            allDocsRootList : function() {
                mainGridHandler.getGridItems = function(){

                    //Get list of Clients
                    loadStrings().then(function(){

                        var promiseArr = [];
                        var curDataSet = [];

                        promiseArr.push(folderManager.getRootFolder());
                        promiseArr.push(projectManager.getRootProjects());
                        promiseArr.push(recentIAC && dmsPermission.has('OnvioDrive.RecentActivity'));
                        promiseArr.push(dmsPermission.has('Applications.Onvio'));
                        promiseArr.push(dmsPermission.has('OnvioDrive.Templates'));
                        promiseArr.push(recyclebinIAC && dmsPermission.has('OnvioDrive.RecycleBin'));

                        $q.all(promiseArr).then(function(resPromiseArr){
                            var folders = resPromiseArr[0].data;
                            var projects = resPromiseArr[1].data;
                            var recentActivityFRP = resPromiseArr[2];
                            var onvioFRP = resPromiseArr[3];
                            var templatesFRP = resPromiseArr[4];
                            var recycleBinFRP = resPromiseArr[5];

                            // Get a set of projects that are unique based on the primary association ID
                            var uniqueClientProjects = _.uniq(projects, false, function(project) {
                                return project.primaryAssociationId;
                            });

                            var clients = uniqueClientProjects.map(function(project) {
                                return {
                                    id: project.primaryAssociationId,
                                    name: project.primaryAssociationName,
                                    itemType: 'client',
                                    link: $state.href('clientStorageList', { clientId : project.primaryAssociationId })
                                };
                            });

                            clients.sort(compareName);

                            _.each(folders, function(folder){
                                folder.itemType = 'folder';
                                folder.link = $state.href('folderList', { folderId : folder.id });
                            });

                            curDataSet = clients.concat(folders);

                            if (recentActivityFRP === true){
                                var recentsData = {};
                                recentsData.link =  $state.href('recentsList');
                                recentsData.name = $scope.recentsName;
                                //Note -- not REALLY a item type, used to fool the grid into generating a different icon
                                recentsData.itemType = 'recents';

                                curDataSet = curDataSet.concat(recentsData);
                            }

                            if (onvioFRP === true && templatesFRP === true) {
                                var templateData = {};
                                templateData.link =  $state.href('templateList');
                                templateData.name = $scope.templatesName;
                                //Note -- not REALLY a item type, used to fool the grid into generating a different icon
                                templateData.itemType = 'templates';

                                curDataSet = curDataSet.concat(templateData);
                            }

                            if (recycleBinFRP === true){
                                var recycleData = {};
                                recycleData.link =  $state.href('recycleList');
                                recycleData.name = $scope.recycleName;
                                //Note -- not REALLY a item type, used to fool the grid into generating a different icon
                                recycleData.itemType = 'recycle';

                                curDataSet = curDataSet.concat(recycleData);
                            }

                            $scope.gridItems = curDataSet;
                            $scope.loading = false;
                        });
                    });
                };
            },
        };

        // Find a better way to do this
        bmAccess.has('DMS_HideRecentActivity').then(function() {
            recentIAC = false;
            methodMap.execute();
        }, function() {
            recentIAC = true;
            methodMap.execute();
        });

        // methodMap.execute();
    };

    allDocsMaster.$inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$window',
        '$location',
        '$translate',
        '$q',
        'folderManager',
        'searchManager',
        'DmsGridPageState',
        'UiService',
        'dmsPermission',
        'bmAccess',
        'dmsSearchGetSet',
        'projectManager'
    ];
    angular.module('onvio.documents').controller('allDocsMaster', allDocsMaster);
})(window.angular, window._);

// (function(angular){
//     'use strict';

//     var clientMaster = function($scope, $state, $window, $location, clientUiService, searchManager, DmsGridPageState) {
//         // Setting table height. I think we'll do this another way
//         // in the end.

//         $scope.go = function(path){
//             $location.path('/' + path);
//         };

//         //TODO: clean
//         var w = angular.element($window);

//         $scope.getViewerHeight = function() {
//             var grid = document.querySelector('#folder-grid');
//             var top = 0;
//             if(grid !== null && angular.isFunction(grid.getBoundingClientRect)){
//                 top = grid.getBoundingClientRect().top;
//             }
//             return w.height() - top - 75;
//         };

//         $scope.viewerHeight = $scope.getViewerHeight();

//         $scope.$watch($scope.getViewerHeight, function(newValue) {
//             $scope.viewerHeight = 'height: ' + newValue + 'px;';
//         });

//         w.bind('resize', function() {
//             $scope.$apply();
//         });

//         var clearPageAlerts = function(){
//             $scope.alerts = [];
//         };

//         var setupGrid = function() {
//             $scope.buttons = [];

//             $scope.gridOptions = {
//                 showColumnMenu : false,
//                 showGroupPanel : false
//             };
//         };

//         $scope.processSearch = function(term){
//             //TODO: set up some method of searching Clients
//             if (term === undefined) { return; }
//             searchManager.setSearchCriteria(term,$scope.selectedItem);
//             $state.go('documentSearchResults');
//         };

//         var mainGridHandler = {
//             getGridItems : function() {},
//             refreshGrid : function(){
//                 $scope.titleText = 'Client Documents';
//                 $scope.gridItems = this.getGridItems();
//             }
//         };

//         $scope.pageState = new DmsGridPageState({ sort: 'name:asc' });

//         var getClientList = function(options) {

//             var opt = options || {};

//             return clientUiService.getClientList({
//                 scope: $scope,
//                 params: {
//                     pageState: $scope.pageState,
//                 },
//                 busily: opt.busily
//             });
//         };

//         var methodMap = {
//             initialize : function() {
//                 $scope.breadCrumbList = [];
//                 $scope.alerts = [];
//                 $scope.myRoot = 'Clients';
//             },
//             preExecute : function() {
//                 clearPageAlerts();
//                 setupGrid();
//             },
//             postExecute: function(){
//                 mainGridHandler.refreshGrid();
//             },
//             execute : function()
//             {
//                 this.initialize();
//                 var toExecute = methodMap[$state.current.name];
//                 if (angular.isFunction(toExecute))
//                 {
//                     this.preExecute();
//                     toExecute();
//                     this.postExecute();
//                 }
//             },
//             clientRootList : function() {
//                 mainGridHandler.getGridItems = function(){
//                     $scope.selectedItem = { 'itemType':'ClientsList'};
//                     getClientList().then(function(result){
//                         var tempData = result.data;

//                         for(var i = 0; i < tempData.length; i++) {
//                             tempData[i].link = $state.href('clientStorageList', { clientId : tempData[i].id });
//                         }

//                         $scope.gridItems = tempData;
//                     });
//                 };
//             },
//         };

//         methodMap.execute();
//     };

//     clientMaster.$inject = [
//         '$scope',
//         '$state',
//         '$window',
//         '$location',
//         'clientUiService',
//         'searchManager',
//         'DmsGridPageState'
//     ];
//     angular.module('onvio.documents').controller('clientMaster', clientMaster);
// })(window.angular);

/*jshint bitwise: false*/

(function(window, FastClick) {
    'use strict';

    window.successStatus = 'success';
    window.errorStatus = 'error';

    FastClick.attach(window.document.body);

    var getFriendlyFileSizeDisplay = function(a,b,c,d,e){
        return (b = Math, c = b.log, d = 1024, e = c(a) / c(d)|0, a / b.pow(d,e)).toFixed(2) + ' ' + (e ? 'KMGTPEZY'[--e] + 'B' : 'Bytes');
    };

    window.getFriendlyFileSizeDisplay = getFriendlyFileSizeDisplay;

    // TODO: TRANSLATE
    var standardPageValidationError = 'Please make the changes marked.';
    window.standardPageValidationError = standardPageValidationError;
})(window, window.FastClick);

(function(angular) {
    //http://stackoverflow.com/questions/14703517/angular-js-set-element-height-on-page-load
    //<div ng-app="miniapp" ng-controller="AppController" ng-style="style()" resize>
    //    window.height: {{windowHeight}} <br />
    //    window.width: {{windowWidth}} <br />
    //</div>
    'use strict';

    var resize = function($window) {
        return function(scope) {
            var w = angular.element($window);
            scope.$watch(function() {
                return { 'h': w.height(), 'w': w.width() };
            }, function(newValue) {
                scope.windowHeight = newValue.h;
                scope.windowWidth = newValue.w;

                scope.style = function(widthOffset, heightOffset, maxHeight) {
                    var widthValue = angular.isString(widthOffset) && (widthOffset === 'auto' || widthOffset.indexOf('%') > 0) ? widthOffset : undefined;
                    var heightValue = angular.isString(heightOffset) && (heightOffset === 'auto' || heightOffset.indexOf('%') > 0) ? heightOffset : undefined;

                    if (angular.isUndefined(widthValue)) {
                        widthValue = (newValue.w - widthOffset) + 'px';
                    }

                    if (angular.isUndefined(heightValue)) {
                        heightValue = (newValue.h - heightOffset) + 'px';
                    }

                    return {
                        'width': widthValue,
                        'height': heightValue,
                        'max-height': maxHeight
                    };
                };

            }, true);

            w.bind('resize', function() {
                scope.$apply();
            });
        };
    };

    resize.$inject = ['$window'];
    angular.module('onvio.documents').directive('resize', resize);
})(window.angular);

(function() {
    'use strict';

    var selectOnFocus = function() {
        return function(scope, element) {
                element.bind('focus', function() {
                this.select();
            });
        };
    };

    angular.module('onvio.documents').directive('selectOnFocus', selectOnFocus);
}());

(function() {
    'use strict';

    var dmsRouteBuilder = function($state) {
        var _this = this;

        _this.buildState = function(clientId, projectId, folderId, fileId, inTrash){
            //Use this for building links to any arbitrary *location* within DMS
            if (inTrash){
                return $state.href('recycleList');
            }

            if (fileId === null){
                if (clientId !== null && clientId.toLowerCase() === 'firm' && projectId !== null) {
                    if (folderId === null){
                        return $state.href('templateRootList', {
                            templateId: projectId,
                        });
                    } else {
                        return $state.href('templateFolderList', {
                            templateId: projectId,
                            folderId: folderId
                        });
                    }
                } else if (clientId !== null && clientId.toLowerCase() !== 'firm' && projectId !== null) {
                    if (folderId === null){
                        return $state.href('projectRootList', {
                            clientId: clientId,
                            projectId: projectId,
                        });
                    } else {
                        return $state.href('projectFolderList', {
                            clientId: clientId,
                            projectId: projectId,
                            folderId: folderId
                        });
                    }
                } else {
                    return $state.href('folderList', {
                        folderId: folderId
                    });
                }
            } else { //Use this for building links to any arbitrary *file* within DMS.
                if (clientId !== null && clientId.toLowerCase() === 'firm' && projectId !== null) {
                    if (folderId === null){
                        return $state.href('templateRootFileView', {
                            templateId: projectId,
                            fileId: fileId
                        });
                    } else {
                        return $state.href('templateFileView', {
                            templateId: projectId,
                            folderId: folderId,
                            fileId: fileId
                        });
                    }
                } else if (clientId !== null && clientId.toLowerCase() !== 'firm' && projectId !== null) {
                    if (folderId === null){
                        return $state.href('projectRootFileView', {
                            clientId: clientId,
                            projectId: projectId,
                            fileId: fileId
                        });
                    } else {
                        return $state.href('projectFileView', {
                            clientId: clientId,
                            projectId: projectId,
                            folderId: folderId,
                            fileId: fileId
                        });
                    }
                } else {
                    return $state.href('folderFileView', {
                        folderId: folderId,
                        fileId: fileId
                    });
                }
            }
        };
    };

    dmsRouteBuilder.$inject = ['$state'];
    angular.module('onvio.documents').service('dmsRouteBuilder', dmsRouteBuilder);
}());

(function(angular) {
    'use strict';

    var exportManager = function(httpRequestManager) {
        var factory = {};
        var exportRequestMethod = 'export';

        factory.exportDocuments = function(exportRequest) {
            var config = httpRequestManager.getAnonymousHttpPostConfig(exportRequestMethod, exportRequest);
            return httpRequestManager.makeHttpRequest(config);
        };

        factory.checkProgress = function(transactionId, site) {
            var config = httpRequestManager.getAnonymousHttpGetConfig(exportRequestMethod + '/' + transactionId + '/' + 'progress?site=' + site);
            return httpRequestManager.makeHttpRequest(config);
        };

        return factory;
    };

    exportManager.$inject = ['httpRequestManager'];
    angular.module('onvio.documents').factory('exportManager', exportManager);
})(window.angular);



(function(window, angular){
    'use strict';

    var renameFile = function($scope, $uibModalInstance, $translate, $q, fileManager, selectedFile, utility, systemConstants, FileFolderValidation, containerType){
        $scope.renameFileData = {};

        var loadStrings = function(){

            var defer = $q.defer();

            $q.all([
                $translate('Bluemoon.DMS.Modal.Rename.Header'),
                $translate('Bluemoon.DMS.Modal.Rename.NameText'),
                $translate('Bluemoon.DMS.Modal.Rename.RequiredText'),
                $translate('Bluemoon.DMS.Modal.Rename.RenameButtonText'),
                $translate('Bluemoon.DMS.Modal.Rename.CancelButtonText'),
                $translate('Bluemoon.DMS.Modal.Rename.NameAlreadyExists'),
                $translate('Bluemoon.DMS.OperationForbidden'),
                $translate('Bluemoon.DMS.Modal.Rename.UnknownError'),
                $translate('Bluemoon.DMS.Modal.Rename.SelectAFile'),
            ]).then(function(s){
                defer.resolve({
                    'Bluemoon.DMS.Modal.Rename.Header'                              : s[0],
                    'Bluemoon.DMS.Modal.Rename.NameText'                            : s[1],
                    'Bluemoon.DMS.Modal.Rename.RequiredText'                        : s[2],
                    'Bluemoon.DMS.Modal.Rename.RenameButtonText'                    : s[3],
                    'Bluemoon.DMS.Modal.Rename.CancelButtonText'                    : s[4],
                    'Bluemoon.DMS.Modal.Rename.NameAlreadyExists'                   : s[5],
                    'Bluemoon.DMS.OperationForbidden'                               : s[6],
                    'Bluemoon.DMS.Modal.Rename.UnknownError'                        : s[7],
                    'Bluemoon.DMS.Modal.Rename.SelectAFile'                         : s[8],
                });
            });

            return defer.promise;
        };

        loadStrings().then(function(translations){

            var _configObject = function() {
                return {
                    headerText:         translations['Bluemoon.DMS.Modal.Rename.Header'],
                    nameText:           translations['Bluemoon.DMS.Modal.Rename.NameText'],
                    requiredText:       translations['Bluemoon.DMS.Modal.Rename.RequiredText'],
                    renameButtonText:   translations['Bluemoon.DMS.Modal.Rename.RenameButtonText'],
                    cancelButtonText:   translations['Bluemoon.DMS.Modal.Rename.CancelButtonText'],
                    fieldAlreadyExists: translations['Bluemoon.DMS.Modal.Rename.NameAlreadyExists'],
                    operationForbidden: translations['Bluemoon.DMS.OperationForbidden'],
                    unknownError:       translations['Bluemoon.DMS.Modal.Rename.UnknownError'],
                    selectAFile:        translations['Bluemoon.DMS.Modal.Rename.SelectAFile'],
                };
            };

            var config = _configObject();

            $scope.headerText = config.headerText;
            $scope.nameText = config.nameText;
            $scope.requiredText = config.requiredText;
            $scope.renameButtonText = config.renameButtonText;
            $scope.cancelButtonText = config.cancelButtonText;

            var setFileNameAndExtension = function(file) {
                var index = file.lastIndexOf('.');
                if (index > -1) {
                    $scope.renameFileData.fileName = file.substr(0, index);
                    $scope.renameFileData.fileExtension = file.substr(index);
                } else {
                    $scope.renameFileData.fileName = selectedFile.name;
                    $scope.renameFileData.fileExtension = '';
                }
            };

            $scope.renameFileData.resetValidation = function(){
                $scope.renameFileData.alerts = [];
                $scope.renameFileData.fileNameError = '';
            };

            $scope.validateData = function() {

                $scope.renameFileData.resetValidation();

                var noError = false;
                var defered = $q.defer();

                FileFolderValidation.validateFileName($scope.renameFileData.fileName).then(function(errorMessage){
                    if (errorMessage && errorMessage !== ''){
                        $scope.renameFileData.fileNameError = errorMessage;
                    }
                    noError = !$scope.renameFileData.fileNameError || $scope.renameFileData.fileNameError.length === 0;
                    defered.resolve(noError);
                });
                return defered.promise;
            };

            $scope.renameFileRequest = function(){

                $scope.validateData().then(function(res){
                    if (!res) { return; }

                    var fileName = $scope.renameFileData.fileName + $scope.renameFileData.fileExtension;

                    // if user didn't change name, then just close gracefully
                    if (fileName === selectedFile.name){
                        $scope.cancelRenameFile();
                        return;
                    }

                    // determine if this name already exist in container
                    fileManager.getDocumentExists(selectedFile.containerId, fileName, containerType).then(function(result) {
                        if (result.data) {
                            var exists = result.data[0].exists;
                            if (exists) {
                                $scope.renameFileData.fileNameError = config.fieldAlreadyExists;
                                return;
                            }
                        } else {
                            // TODO: How to handles this. Our check if the file
                            // exists already failed. For now we will just go ahead
                            // and add the file.
                        }

                        // update the current files name
                        var fileToRename = {
                            name: fileName,
                            id: selectedFile.id,
                            containerId: selectedFile.containerId
                        };

                        fileManager.updateDocument(fileToRename, fileToRename.containerId, containerType).then(function(result) {
                            if (result.status === window.successStatus) {
                                $scope.closeModalAction(result.data);
                            } else {
                                // selectedFile.name = oldFileName;
                                $scope.renameFileData.alerts.push({ type: 'danger', msg: result.message });
                            }
                        }, function(reason){
                            if (utility.isConflictCode(reason.httpStatusCode)) {
                                $scope.renameFileData.fileNameError = config.fieldAlreadyExists;
                            } else if (utility.isForbiddenCode(reason.httpStatusCode)) {
                                $scope.renameFileData.fileNameError = config.operationForbidden;
                            } else {
                                $scope.renameFileData.fileNameError = config.unknownError;
                            }
                        });
                    });
                });
            };

            $scope.closeModalAction = function(updatedFile){
                $uibModalInstance.close(updatedFile);
            };

            $scope.cancelRenameFile = function(){
                $uibModalInstance.dismiss('cancelled');
            };

            $scope.renameFileData.canRename = true;

            // If no folder is selected then the new folder will be added to the root
            $scope.renameFileData.hasSelectedFile = (selectedFile !== null && angular.isDefined(selectedFile));
            $scope.renameFileData.resetValidation();
            if (!$scope.renameFileData.hasSelectedFile) {
                $scope.renameFileData.alerts.push({ type: 'danger', msg: config.selectAFile });
                $scope.renameFileData.canRename = false;
            }

            setFileNameAndExtension(selectedFile.name);

            $scope.renameFileData.maxDocumentNameLength = systemConstants.maxDocumentNameLength;
        });
    };

    renameFile.$inject = ['$scope', '$uibModalInstance', '$translate', '$q', 'fileManager', 'selectedFile', 'utility', 'systemConstants', 'FileFolderValidation', 'containerType'];
    angular.module('onvio.documents').controller('renameFile', renameFile);
})(window, window.angular);

(function(window, angular, underScore, Dynamsoft) {
    'use strict';

    if (Dynamsoft) {
        Dynamsoft.WebTwainEnv.RegisterEvent('OnWebTwainReady', function() {
            // Dynamic Web TWAIN is ready
            window.DWObject = Dynamsoft.WebTwainEnv.GetWebTwain('dwtcontrolContainer');
        }); // Register OnWebTwainReady event. This event fires as soon as Dynamic Web TWAIN is initialized and ready to be used
    }

    var scanFile = function($scope, $uibModalInstance, $upload, $timeout, $http, $translate, $q, fileManager, dmsUploadService, selectedFolder, systemConstants, FileFolderValidation) {
        $scope.selectedFolder = selectedFolder;
        $scope.scanFileData = {};
        $scope.scanFileData.alerts = [];
        $scope.scanFileData.fileNameError = '';
        $scope.scanFileData.fileId = '';
        $scope.scanFileData.canScan = true;
        $scope.finishMsg = 'Done';
        $scope.scanFileData.scanFileName = $translate.instant('Bluemoon.DMS.Modal.Scan.Untitled');
        $scope.scanFileData.notes = '';
        $scope.scanFileData.keeBoth = 'false';
        $scope.totalProgress = dmsUploadService.totalProgress;
        $scope.downloadTwainError = false;

        var initLoop = 0;
        var seed;
        var defaultResolution = 0;
        var defaultPixelType = 0;
        //var bIE = false;

        Dynamsoft.WebTwainEnv.MainPage = false;
        window.DWObject = null;
        Dynamsoft.WebTwainEnv.Load();

        $scope.scanFileData.resetValidation = function() {
            $scope.scanFileData.alerts = [];
            $scope.scanFileData.fileNameError = '';
        };
        $scope.validateData = function() {

            $scope.scanFileData.resetValidation();

            var noError = false;
            var defered = $q.defer();

            FileFolderValidation.validateFileName($scope.scanFileData.scanFileName).then(function(errorMessage) {
                if (errorMessage && errorMessage !== '') {
                    $scope.scanFileData.fileNameError = errorMessage;
                }
                noError = !$scope.scanFileData.fileNameError || $scope.scanFileData.fileNameError.length === 0;
                defered.resolve(noError);
            });
            return defered.promise;
        };
        $scope.closeModalAction = function(newFile) {
            if (window.DWObject) {
                Dynamsoft.WebTwainEnv.Unload();
                window.DWObject = null;
            }
            $uibModalInstance.close(newFile);
        };

        $scope.cancelScanFile = function() {
            if (window.DWObject) {
                Dynamsoft.WebTwainEnv.Unload();
                window.DWObject = null;
            }
            $uibModalInstance.dismiss('cancelled');
        };
        $scope.uploadTypeClass = function(upload) {
            if (upload.status === 'uploading') { return 'alert-warning'; }
            if (upload.status === 'waiting') { return 'alert-info'; }
            if (upload.status === 'success') { return 'alert-success'; }
            if (upload.status === 'error') { return 'alert-error'; }
        };
        /////////////////////////////////////////////////////////////////////////////////////////////


        $scope.selectFileName = function() {
            var scanFileTextbox = document.getElementById('scanFileName');
            if (scanFileTextbox) {
                scanFileTextbox.select();
            }
        };
        $scope.sourceOnChange = function() {
            //DWObject = gWebTwain.getInstance();
            if (window.DWObject) {
                var InputSource = document.getElementById('source');
                if (InputSource && InputSource.options.length > 0) {
                    if (window.DWObject.SourceCount > 0) {
                        window.DWObject.SelectSourceByIndex(InputSource.selectedIndex);
                    }
                } else {
                    $translate('Bluemoon.DMS.Modal.Scan.UnableToFindScanner').then(function(translatedUnableToFindScannerString){
                        $scope.scanFileData.fileNameError = translatedUnableToFindScannerString;
                        $scope.scanFileData.canScan = false;
                        var scanFileNameContainer = document.getElementById('scanFileName');
                        if (scanFileNameContainer) {
                            scanFileNameContainer.focus();
                        }
                    });
                }

                //window.DWObject.CloseSource();
            }
        };
        $scope.feedScannerControl = function() {
            if (window.DWObject) {
                if (window.DWObject.SourceCount > 0) {
                    var InputSource = document.getElementById('source');
                    if (InputSource) {
                        InputSource.options.length = 0;
                        // fill in the source items.
                        for (var i = 0; i < window.DWObject.SourceCount ; i++) {
                            var sourceName = window.DWObject.GetSourceNameItems(i);
                            if (sourceName.toLowerCase().indexOf('phone') === -1) {
                                InputSource.options.add(new Option(sourceName, i));
                            }
                        }

                        if (window.DWObject.SourceCount > 0) {
                            $scope.sourceOnChange();
                        }
                    }
                    // source type
                    var vPixelType = document.getElementById('BW');
                    if (vPixelType) {
                        vPixelType.checked = true;
                    }
                    // mode
                    var mode = document.getElementById('Mode');
                    if (mode) {
                        mode.options.length = 0;

                        $q.all([
                            $translate('Bluemoon.DMS.Modal.Scan.Mode.BlackAndWhite'),
                            $translate('Bluemoon.DMS.Modal.Scan.Mode.Color'),
                            $translate('Bluemoon.DMS.Modal.Scan.Mode.Grayscale'),
                            ]).then(function(translatedStrings){
                            mode.options.add(new Option(translatedStrings[0], '0', true, true));
                            mode.options.add(new Option(translatedStrings[1], '2'));
                            mode.options.add(new Option(translatedStrings[2], '1'));
                        });
                    }
                    // resolution
                    var resolution = document.getElementById('Resolution');
                    if (resolution) {
                        resolution.options.length = 0;

                        $q.all([
                            $translate('Bluemoon.DMS.Modal.Scan.ResDPI', {dotsPerInch: '200'}),
                            $translate('Bluemoon.DMS.Modal.Scan.ResDPI', {dotsPerInch: '300'}),
                            $translate('Bluemoon.DMS.Modal.Scan.ResDPI', {dotsPerInch: '400'}),
                            $translate('Bluemoon.DMS.Modal.Scan.ResDPI', {dotsPerInch: '600'}),
                            ]).then(function(translatedStrings){
                                resolution.options.add(new Option(translatedStrings[0], 200));
                                resolution.options.add(new Option(translatedStrings[1], 300));
                                resolution.options.add(new Option(translatedStrings[2], 400, true, true));
                                resolution.options.add(new Option(translatedStrings[3], 600));
                            });
                    }
                    var scanButton = document.getElementById('scanButton');
                    if (scanButton) {
                        scanButton.style.display = 'inline';
                    }
                    var scanFileNameContainer = document.getElementById('scanFileName');
                    if (scanFileNameContainer) {
                        scanFileNameContainer.focus();
                        scanFileNameContainer.select();
                    }
                } else {
                    //var containerDownloadControl = document.getElementById('dwtcontrolDownload');
                    //if (containerDownloadControl) {
                    //if (containerDownloadControl.style.display != 'block') {

                    $translate('Bluemoon.DMS.Modal.Scan.UnableToFindScanner').then(function(translatedUnableToFindScannerString){
                        $scope.scanFileData.fileNameError = translatedUnableToFindScannerString;
                        $scope.scanFileData.canScan = false;
                        var scanFileNameContainer = document.getElementById('scanFileName');
                        if (scanFileNameContainer) {
                            scanFileNameContainer.focus();
                        }
                    });

                      //  }
                    //}
                }
            } else {
                $translate('Bluemoon.DMS.Modal.Scan.UnableToFindScanner').then(function(translatedUnableToFindScannerString){
                    $scope.scanFileData.fileNameError = translatedUnableToFindScannerString;
                    $scope.scanFileData.canScan = false;
                    var scanFileNameContainer = document.getElementById('scanFileName');
                    if (scanFileNameContainer) {
                        scanFileNameContainer.focus();
                    }
                });
            }
        };
        $scope.scanSettingsOnchange = function(radioValue) {
            if (radioValue === 1) {
                document.getElementById('Mode').disabled = false;
                document.getElementById('Resolution').disabled = false;
            } else {
                document.getElementById('Mode').disabled = true;
                document.getElementById('Resolution').disabled = true;
            }
        };
        $scope.setEnvironment = function() {
            // Get User Agent Value
            var ua = (navigator.userAgent.toLowerCase());

            // Set the x86 and x64 type
            if (ua.indexOf('win64') > -1 || ua.indexOf('x64') > -1 || ua.indexOf('wow64') > -1) {
                //Dynamsoft.Lib.env.bWin64 = true;
                Dynamsoft.Lib.env.bWin64 = true;
            }

            //// Set the Explorer Type
            //if (ua.indexOf("msie") != -1 || ua.indexOf('trident') != -1) {
            //    Dynamsoft.Lib.env.bIE = true;
            //} else {
            //    Dynamsoft.Lib.env.bIE = false;
            //}

        };
        $scope.initScannerControl = function() {
            if (window.DWObject) {
                clearInterval(seed);
                //DWObject.ProductKey = '9CD29E5EA521DC4A15D7C6F122EFE0768BCFCC1E2E8EF94BC073BB31FE68D7699858BCE5F037438281CC1F18D12A1C3565615FC64B4111B2C4AF54CEF08C146430000000';
                window.DWObject.BrokerProcessType = 1;
                window.DWObject.ImageCaptureDriverType = 3;
                if (Dynamsoft.Lib.product.bChromeEdition) {
                    window.DWObject.RegisterEvent('OnPostAllTransfers', $scope.acquireImageCompleted);
                } else {
                    window.DWObject.RegisterEvent('onPostAllTransfers', $scope.acquireImageCompleted);
                }
                window.DWObject.IfAllowLocalCache = true;
                $scope.feedScannerControl();
            } else {
                initLoop = initLoop + 1;
                if (initLoop > 15) {
                    clearInterval(seed);
                    $scope.setEnvironment();
                    $scope.scanFileData.canScan = false;
                    var controlContainer = document.getElementById('dwtcontrolContainer');
                    if (controlContainer) {
                        controlContainer.style.display = 'none';
                    }

                    var _http = ('https:' === location.protocol ? 'https://' : 'http://');
                    var strHref;

                    var downloadStringPromise;
                    //TODO: for better coding check if IE first
                    if (Dynamsoft.Lib.env.bWin) {
                        if (Dynamsoft.Lib.env.bIE) {
                            downloadStringPromise = $translate('Bluemoon.DMS.Modal.Scan.ActiveXControlRequired');
                        } else {
                            if (location.hostname !== '') {
                                strHref = _http + location.host + location.pathname.substring(0, location.pathname.lastIndexOf('/')) + '/' + Dynamsoft.WebTwainEnv.ResourcesPath + '/DynamicWebTWAINHTML5Edition.exe';
                            } else {
                                strHref = Dynamsoft.WebTwainEnv.ResourcesPath + '/DynamicWebTWAINHTML5Edition.exe';
                            }

                            downloadStringPromise = $translate('Bluemoon.DMS.Modal.Scan.PluginRequired', {downloadUrl: strHref});
                        }
                    } else {
                        if (location.hostname !== '') {
                            strHref = _http + location.host + location.pathname.substring(0, location.pathname.lastIndexOf('/')) + '/' + Dynamsoft.WebTwainEnv.ResourcesPath + '/DynamicWebTWAINMacEdition.pkg';
                        } else {
                            strHref = Dynamsoft.WebTwainEnv.ResourcesPath + '/DynamicWebTWAINHTML5MACFullEdition.pkg';
                        }
                        downloadStringPromise = $translate('Bluemoon.DMS.Modal.Scan.PluginRequired', {downloadUrl: strHref});
                    }

                    downloadStringPromise.then(function(translatedDownloadString){
                        var containerDownload = document.getElementById('dwtcontrolDownload');
                        if (containerDownload) {
                            $scope.downloadTwainError = true;
                            containerDownload.style.display = 'block';
                            containerDownload.innerHTML = translatedDownloadString;
                        }
                    });
                }
            }
        };
        $scope.scanDocument = function() {

            // validate file name
            $scope.validateData().then(function(res) {
                if (!res) { return; }

                $scope.scanFileData.alerts = [];
                $scope.scanFileData.fileNameError = '';
                $scope.scanFileData.fileId = '';

                var scanFileName = $scope.scanFileData.scanFileName;

                if (angular.isUndefined(scanFileName) || !angular.isString(scanFileName) || scanFileName === '') {
                    $translate('Bluemoon.DMS.Modal.Scan.PleaseEnterFileName').then(function(translatedPleaseEnterFileNameString) {
                        $scope.scanFileData.fileNameError = translatedPleaseEnterFileNameString;
                    });
                    return;
                }
                var uploadFileName = $scope.scanFileData.scanFileName;
                if (angular.isUndefined(uploadFileName) || !angular.isString(uploadFileName) || uploadFileName === '') {
                    uploadFileName = 'Untitled';
                }
                uploadFileName = uploadFileName.concat('.pdf');
                // check if file exists
                fileManager.getDocumentExists(selectedFolder.id, uploadFileName, selectedFolder.containerType).then(function(result) {
                    if (result.data) {
                        //console.log('Exist Result Data: Good');
                        var exists = result.data[0].exists;
                        if (exists) {
                            //console.log('Exist Result Data: File exists');
                            $translate('Bluemoon.DMS.Modal.Scan.FileAlreadyExists', { fileName: uploadFileName }).then(function(translatedFileAlreadyExistsString) {
                                $scope.scanFileData.fileNameError = translatedFileAlreadyExistsString;
                                $scope.scanFileData.fileId = result.data[0].id;
                            });
                            return;
                        } else {
                            // console.log('Exist Result Data: No File with that name');
                            $scope.acquireImage();
                        }
                    } else {
                        $scope.acquireImage();
                    }
                });
            });
        };
        $scope.uploadScan = function() {
            var uploadFileName = $scope.scanFileData.scanFileName.concat('.pdf');
            // use below to upload a base64 binary or byte array. upload service needs to change and allow for this..............................
            window.DWObject.SelectedImagesCount = window.DWObject.HowManyImagesInBuffer;
            var imageCount = window.DWObject.HowManyImagesInBuffer;
            for (var i = 0; i < imageCount; i++) { // Loop through each of the images in the viewer.
                window.DWObject.SetSelectedImageIndex(i, i);
            }
            i = window.DWObject.GetSelectedImagesSize('4');
            var imagedata = window.DWObject.SaveSelectedImagesToBase64Binary(); // or SaveSelectedImagesToBytes for byte array -base64: SaveSelectedImagesToBase64Binary()
            var byteCharacters = atob(imagedata);
            var byteNumbers = new Array(byteCharacters.length);
            for (i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var fd = new FormData();
            var blob = new Blob([byteArray], { type: 'application/pdf' });
            var fileSize = blob.size;
            if ($scope.scanFileData.keeBoth === 'true') {
                fileManager.findName(selectedFolder.id, uploadFileName, selectedFolder.containerType).then(function(result) {
                    fd.append('file[]', blob, result);
                    dmsUploadService.addSingle(fd, selectedFolder.id, selectedFolder.containerType, result, fileSize);
                });
            } else {
                fd.append('file[]', blob, uploadFileName);
                dmsUploadService.addSingle(fd, selectedFolder.id, selectedFolder.containerType, uploadFileName, fileSize);
            }
            $scope.closeModalAction(null);
            //if (!Dynamsoft.Lib.env.bIE) {
            //    window.DWObject.RemoveAllSelectedImages();
            //}
        };
        $scope.acquireImageCompleted = function() {
            $scope.uploadScan();
        };

        $scope.acquireImage = function() {
            var bwPixelType = document.getElementById('BW');
            if (window.DWObject) {
                if (window.DWObject.SourceCount > 0) {
                    //window.DWObject.SelectSourceByIndex(document.getElementById("source").selectedIndex);
                    window.DWObject.CloseSource();
                    window.DWObject.OpenSource();
                    if (Dynamsoft.Lib.product.bChromeEdition) {
                        window.DWObject.RegisterEvent('OnPostAllTransfers', $scope.acquireImageCompleted);
                    } else {
                        window.DWObject.RegisterEvent('onPostAllTransfers', $scope.acquireImageCompleted);
                    }
                    window.DWObject.IfAllowLocalCache = true;
                    if (bwPixelType && bwPixelType.checked === true) {
                        // mode
                        var mode = document.getElementById('Mode');
                        if (mode) {
                            window.DWObject.PixelType = mode.value;
                        } else {
                            window.DWObject.PixelType = 0;
                        }
                        //resolution
                        var resolution = document.getElementById('Resolution');
                        if (resolution) {
                            window.DWObject.Resolution = resolution.value;
                        } else {
                            window.DWObject.Resolution = 400;
                        }
                    } else {
                        window.DWObject.Resolution = defaultResolution;
                        window.DWObject.PixelType = defaultPixelType;
                    }
                    window.DWObject.IfShowUI = false;
                    window.DWObject.IfDisableSourceAfterAcquire = true;
                    window.DWObject.AcquireImage();
                } else {
                    $translate('Bluemoon.DMS.Modal.Scan.UnableToFindScanner').then(function(translatedUnableToFindScannerString){
                        $scope.scanFileData.fileNameError = translatedUnableToFindScannerString;
                        $scope.scanFileData.canScan = false;
                    });
                }
            }
        };
        $scope.replace = function() {
            // TODO: check if  $scope.scanFileData.fileId has something before trying to delete
            fileManager.deleteDocument(selectedFolder.id, $scope.scanFileData.fileId, selectedFolder.containerType).then(function(result) {
                if (result.status !== window.successStatus) {
                    $scope.deleteFolderData.alerts.push({ type: 'danger', msg: result.message });
                } else {
                    $scope.acquireImage();
                }
            });
        };
        $scope.uploadPercentage = function(upload) {
            return (100 * (upload.loaded / upload.total)).toFixed(1);
        };
        $scope.closeAlert = function(upload) {
            dmsUploadService.dismissUpload(upload.key);
        };
        $scope.keepBoth = function() {
            $scope.scanFileData.keeBoth = 'true';
            $scope.acquireImage();
        };
        seed = setInterval($scope.initScannerControl, 500);
        $scope.totalUploads = dmsUploadService.totalProgress;
        $scope.getFirstUpload = function() {
            var uploadKeys = Object.keys(dmsUploadService.uploads);
            if (uploadKeys.length > 0) {
                return dmsUploadService.uploads[underScore.sortBy(uploadKeys, function(key) {
                    return key.substr(key.lastIndexOf('|') + 1);
                }).reverse()[0]];
            }
        };
        $scope.scanFileData.maxDocumentNameLength = systemConstants.maxDocumentNameLength;
    };
    scanFile.$inject = ['$scope', '$uibModalInstance', '$upload', '$timeout', '$http', '$translate', '$q', 'fileManager', 'dmsUploadService', 'selectedFolder', 'systemConstants', 'FileFolderValidation', ];
    angular.module('onvio.documents').controller('scanFile', scanFile)

    // This allows the 'Keep or Replace' message to work, as ng-bind and ng-bind-html
    // don't respect the ng-click directives.
    // FIME: Find a better solution - really any solution - other than having directives in translated text!
    .directive('bindHtmlCompile', ['$compile', function ($compile) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
            scope.$watch(function () {
                return scope.$eval(attrs.bindHtmlCompile);
            }, function (value) {
                // Incase value is a TrustedValueHolderType, sometimes it
                // needs to be explicitly called into a string in order to
                // get the HTML string.
                element.html(value && value.toString());
                // If scope is provided use it, otherwise use parent scope
                var compileScope = scope;
                if (attrs.bindHtmlScope) {
                compileScope = scope.$eval(attrs.bindHtmlScope);
                }
                $compile(element.contents())(compileScope);
            });
            }
        };
    }]);
})(window, window.angular, window._, window.Dynamsoft);

(function(angular) {
    'use strict';

    var folderFileView = function($state, $scope, $window, $document, $stateParams, $sce, $uibModal, $q, $translate, fileManager, documentUiService, getDocument) {

        var vm = this;

        $scope.canViewDocument = getDocument ? getDocument : false;

        $scope.download = function() {
            documentUiService.download({
                params: {
                    document: {
                        id: $scope.documentId,
                        parentItem: {
                            id: $scope.parentItemId,
                            itemType: $scope.parentItemType
                        }
                    }
                }
            });
        };

        $scope.rename = function(){
            var modalInstance = $uibModal.open({
                templateUrl: 'documents/files/actions/renamefile/rename-file-modal.2js.html',
                controller: 'renameFile',
                backdrop: 'static',
                resolve: {
                    selectedFile: function(){
                        return $scope.selectedItem;
                    }
                }
            });

            modalInstance.result.then(function(result){
                // Result is the updated document
                $scope.selectedItem.name = result.name;
            });
        };

        var getDocumentForFolder = function(containerId, fileId, includeDownloadUrl, containerType) {
            fileManager.getDocumentInfo(containerType, containerId, fileId, includeDownloadUrl).then(function(result) {
                if (result.data) {
                    var file = result.data;
                    if (file.id === fileId) {
                        $scope.selectedItem = file;
                        $scope.downloadUrl = (file.isViewable) ? $sce.trustAsResourceUrl(file.downloadUrl + '&convertForPreview=1'):$sce.trustAsResourceUrl(file.downloadUrl);
                        $scope.mimeType = (file.isViewable) ? 'application/pdf' : file.mimeType;
                    }
                } else {
                    setPageAlerts('danger', 'File not found.', false);
                    return null;
                }
            });
        };

        function setPageAlerts(type, msg, clearAllExisting){
            if(clearAllExisting){
                clearPageAlerts();
            }

            $scope.alerts.push( { type: type, msg: msg });
        }

        function clearPageAlerts(){
            $scope.alerts = [];
        }

        var w = angular.element($window);

        var unwatchToolbar = $scope.$watch(function(){
            return $document[0].querySelector('#file-view-toolbar');
        }, function(newValue){
            if(newValue){
                $scope.pdfViewHeight = w.height() - newValue.getBoundingClientRect().bottom - 45;
                unwatchToolbar();
            }

        });

        $scope.$watch(function(){
                return angular.element($window).height();
        }, function(newValue){
            if(newValue){
                var toolbar = $document[0].querySelector('#file-view-toolbar');
                if(toolbar){
                    $scope.pdfViewHeight = newValue - toolbar.getBoundingClientRect().bottom - 45;
                }
            }

        });

        w.bind('resize', function() {
            $scope.$apply();
        });

        var loadFileDisplay = function(containerId) {
            var fileId = $stateParams.fileId;
            $scope.alerts = [];
            getDocumentForFolder(containerId, fileId, true, $scope.containerType);
        };

        vm._loadToolbarStrings = function(){
            return $translate('Bluemoon.DMS.Toolbar.FolderGrid.Download').then(function(s){
                $scope.buttons[0].text = s;
            });
        };

        $scope.buttons = [
            {
                'icon': 'bento-icon-download',
                'click': $scope.download
            }
        ];

        vm._setupPreviewer = function(){
            vm._loadToolbarStrings();
        };

        $scope.$on('bmLanguageChangeSuccess', function(){
            vm._loadToolbarStrings();
        });

        var methodMap = {
            initialize : function() {
                // TODO: REMOVE THIS WHEN UNIT TESTS ARE ACTUALLY WRITTEN
                $scope.test = 'test';
                $scope.folderId = undefined;
                $scope.projectId = undefined;
                $scope.templateId = undefined;
                $scope.containerType = undefined;
                $scope.projectObject = undefined;
                $scope.collapseLength = 4;
            },
            preExecute : function() {
                clearPageAlerts();
                vm._setupPreviewer();
            },
            postExecute: function(){
            },
            execute : function()
            {
                this.initialize();

                $scope.documentId = $stateParams.fileId;

                if ($stateParams.clientId !== null && angular.isDefined($stateParams.clientId)){
                    $scope.clientId = $stateParams.clientId;
                }
                if ($stateParams.projectId !== null && angular.isDefined($stateParams.projectId)){
                    $scope.projectId = $stateParams.projectId;
                }
                if ($stateParams.templateId !== null && angular.isDefined($stateParams.templateId)){
                    $scope.templateId = $stateParams.templateId;
                }
                if ($stateParams.folderId !== null && angular.isDefined($stateParams.folderId)){
                    $scope.folderId = $stateParams.folderId;
                }

                var toExecute = methodMap[$state.current.name];
                if (angular.isFunction(toExecute))
                {
                    this.preExecute();
                    toExecute();
                    this.postExecute();
                }
            },
            folderFileView : function() {
                $scope.containerType = 'folders';
                $scope.parentItemType = 'Folder';
                $scope.parentItemId = $scope.folderId;
                loadFileDisplay($scope.folderId);
            },
            projectFileView : function() {
                $scope.containerType = 'folders';
                $scope.parentItemType = 'Folder';
                $scope.parentItemId = $scope.folderId;
                loadFileDisplay($scope.folderId);
            },
            projectRootFileView : function() {
                $scope.containerType = 'projects';
                $scope.parentItemType = 'Project';
                $scope.parentItemId = $scope.projectId;
                loadFileDisplay($scope.projectId);
            },
            //TEMPLATES
            templateFileView : function() {
                $scope.containerType = 'folders';
                $scope.parentItemType = 'Folder';
                $scope.templateId = $scope.parentItemId = $stateParams.templateId;
                loadFileDisplay($scope.folderId);
            },
            templateRootFileView : function() {
                $scope.containerType = 'projects';
                $scope.parentItemType = 'Project';
                $scope.templateId = $scope.parentItemId = $stateParams.templateId;
                loadFileDisplay($scope.templateId);
            },
        };

        methodMap.execute();
    };

    folderFileView.$inject =
    ['$state', '$scope', '$window', '$document', '$stateParams', '$sce', '$uibModal', '$q', '$translate', 'fileManager', 'dmsDocumentUiService', 'getDocument'];
    angular.module('onvio.documents').controller('folderFileView', folderFileView);
})(window.angular);

(function(window, angular){
    'use strict';

    var renameFolder = function($scope, $uibModalInstance, $translate, $q, folderManager, selectedFolder, Folder, systemConstants, FileFolderValidation, utility){

        $scope.renameFolderData = {};

        var loadStrings = function(){

            var defer = $q.defer();

            $q.all([
                $translate('Bluemoon.DMS.Modal.Rename.Header'),
                $translate('Bluemoon.DMS.Modal.Rename.NameText'),
                $translate('Bluemoon.DMS.Modal.Rename.RequiredText'),
                $translate('Bluemoon.DMS.Modal.Rename.RenameButtonText'),
                $translate('Bluemoon.DMS.Modal.Rename.CancelButtonText'),
                $translate('Bluemoon.DMS.Modal.Rename.NameAlreadyExists'),
                $translate('Bluemoon.DMS.OperationForbidden'),
                $translate('Bluemoon.DMS.Modal.Rename.UnknownError'),
            ]).then(function(s){
                defer.resolve({
                    'Bluemoon.DMS.Modal.Rename.Header'                              : s[0],
                    'Bluemoon.DMS.Modal.Rename.NameText'                            : s[1],
                    'Bluemoon.DMS.Modal.Rename.RequiredText'                        : s[2],
                    'Bluemoon.DMS.Modal.Rename.RenameButtonText'                    : s[3],
                    'Bluemoon.DMS.Modal.Rename.CancelButtonText'                    : s[4],
                    'Bluemoon.DMS.Modal.Rename.NameAlreadyExists'                   : s[5],
                    'Bluemoon.DMS.OperationForbidden'                               : s[6],
                    'Bluemoon.DMS.Modal.Rename.UnknownError'                        : s[7],
                });
            });

            return defer.promise;
        };

        loadStrings().then(function(translations){

            var _configObject = function() {
                return {
                    headerText:         translations['Bluemoon.DMS.Modal.Rename.Header'],
                    nameText:           translations['Bluemoon.DMS.Modal.Rename.NameText'],
                    requiredText:       translations['Bluemoon.DMS.Modal.Rename.RequiredText'],
                    renameButtonText:   translations['Bluemoon.DMS.Modal.Rename.RenameButtonText'],
                    cancelButtonText:   translations['Bluemoon.DMS.Modal.Rename.CancelButtonText'],
                    fieldAlreadyExists: translations['Bluemoon.DMS.Modal.Rename.NameAlreadyExists'],
                    operationForbidden: translations['Bluemoon.DMS.OperationForbidden'],
                    unknownError:       translations['Bluemoon.DMS.Modal.Rename.UnknownError'],
                    selectAFile:        translations['Bluemoon.DMS.Modal.Rename.SelectAFile'],
                };
            };

            var config = _configObject();

            $scope.headerText = config.headerText;
            $scope.nameText = config.nameText;
            $scope.requiredText = config.requiredText;
            $scope.renameButtonText = config.renameButtonText;
            $scope.cancelButtonText = config.cancelButtonText;

            $scope.renameFolderData.resetValidation = function(){
                $scope.renameFolderData.alerts = [];
                $scope.renameFolderData.folderNameError = '';
            };

            $scope.validateData = function() {
                $scope.renameFolderData.resetValidation();

                var noError = false;
                var defered = $q.defer();

                FileFolderValidation.validateFolderName($scope.renameFolderData.folderName).then(function(errorMessage){
                    if (errorMessage && errorMessage !== ''){
                        $scope.renameFolderData.folderNameError = errorMessage;
                    }
                    noError = !$scope.renameFolderData.folderNameError || $scope.renameFolderData.folderNameError.length === 0;
                    defered.resolve(noError);
                });
                return defered.promise;
            };

            $scope.renameFolderRequest = function(){

                $scope.validateData().then(function(res){
                    if (!res) { return; }

                    var folderName = $scope.renameFolderData.folderName;

                    // if user didn't change name, then just close gracefully
                    if (folderName === selectedFolder.name){
                        $scope.cancelRenameFolder();
                        return ;
                    }

                    var folderToRename = new Folder();
                    folderToRename.name = folderName;
                    folderToRename.id = selectedFolder.id;
                    folderManager.updateFolder(folderToRename).then(function(result) {
                        // Should folderManager return the renamed folder? Right now nothing is returned, so I will return the updated name
                        $scope.closeModalAction(result.data);
                    }, function(reason) {
                        if (utility.isConflictCode(reason.httpStatusCode)) {
                            $scope.renameFolderData.folderNameError = config.fieldAlreadyExists;
                        } else if (utility.isForbiddenCode(reason.httpStatusCode)) {
                            $scope.renameFolderData.folderNameError = config.operationForbidden;
                        } else {
                            $scope.renameFolderData.folderNameError = config.unknownError;
                        }
                    });

                });
            };

            $scope.closeModalAction = function(updatedFolderName){
                $uibModalInstance.close(updatedFolderName);
            };

            $scope.cancelRenameFolder = function(){
                $uibModalInstance.dismiss('cancelled');
            };

            $scope.renameFolderData.canRename = true;
            $scope.renameFolderData.folderName = selectedFolder.name;

            // If no folder is selected then the new folder will be added to the root
            $scope.renameFolderData.hasSelectedFolder = (selectedFolder !== null && angular.isDefined(selectedFolder));
            $scope.renameFolderData.resetValidation();

            if (!$scope.renameFolderData.hasSelectedFolder) {
                $scope.renameFolderData.canRename = false;
            }

            $scope.renameFolderData.maxFolderNameLength = systemConstants.maxFolderNameLength;
        });
    };

    renameFolder.$inject = ['$scope', '$uibModalInstance', '$translate', '$q', 'folderManager', 'selectedFolder', 'Folder', 'systemConstants', 'FileFolderValidation', 'utility'];
    angular.module('onvio.documents').controller('renameFolder', renameFolder);
})(window, window.angular, window.Folder);

(function(window, angular, _){
    'use strict';

    var shareFolder = function($scope, $uibModalInstance, $q, clientId, containerType, selectedItem, clientManager, contactManager, folderManager, projectManager, RoleTypes){
        $scope.shareFolderData = {};
        $scope.shareFolderData.canShare = true;

        $scope.roleTypes =
            [
                RoleTypes.None,
                RoleTypes.Owner,
                RoleTypes.Contributor,
                RoleTypes.Reviewer,
            ];

        $scope.shareFolderData.resetValidation = function() {
            $scope.shareFolderData.alerts = [];
        };

        $scope.shareFolderRequest = function() {
            $scope.shareFolderData.resetValidation();

            changePermissions(selectedItem);
            //TODO: change permissions of children elements

            closeModalAction(null);
        };

        function changePermissions(container){

            var manager = (containerType === 'projects') ? projectManager : folderManager;

            //Iterate through each contact, and either change or remove roles as needed.
            for (var i = 0; i < $scope.shareFolderData.contactList.length; i++){

                var curItem = $scope.shareFolderData.contactList[i];

                if (curItem.role === RoleTypes.None){
                    manager.removePermissions(container.id, curItem.value.id);
                } else {
                    manager.updatePermissions(container.id, { 'Role': curItem.role, 'MemberId': curItem.value.id, 'MemberType': 'user' });
                }
            }
        }

        $scope.cancelShareFolder = function() {
            $uibModalInstance.dismiss('cancelled');
        };

        function closeModalAction(shareItems){
            $uibModalInstance.close(shareItems);
        }

        //Grid population code below
        $scope.getContactList = function(){

            if (!clientId) { return; }

            var manager = (containerType === 'projects') ? projectManager : folderManager;
            var a = [];
            var curContacts = [];
            var deferred = $q.defer();

            clientManager.getClient(clientId).then(function(clientResult){

                var primaryContactId = clientResult.data.primaryContact.id;

                //Fetch existing permissions, to pair up to whatever Contacts we have available
                manager.getPermissions(selectedItem.id).then(function(result){

                    curContacts = result;

                    contactManager.getRelatedContactsWithClientCenterEnabled(primaryContactId).then(function(result){
                        $scope.shareFolderData.contactList = [];
                        //if we got a result, let's use that data
                        if (result.data.length !== 0){
                            for (var j = 0; j < result.data.length; j++){
                                a.push(
                                    {
                                        label: result.data[j].displayAs,
                                        value: result.data[j],
                                        role: getRole(result.data[j].id, curContacts.data.containerPermissions)
                                    });
                            }
                            deferred.resolve(a);
                        } else {
                            //we need to go deeper
                            contactManager.getContact(primaryContactId).then(function(result){
                                a.push(
                                    {
                                        //We can guarentee there is only 1 result for this GetContact call.
                                        label: result.data.displayAs,
                                        value: result.data,
                                        role: getRole(result.data.id, curContacts.data.containerPermissions)
                                    });
                                deferred.resolve(a);
                            });
                        }
                    }); //end getRelatedContacts

                }); //end manager permissions

            });
            return deferred.promise;
        };

        function getRole(id, arrayOfPermissionsToSearch){

            var matchingContact = _.find(arrayOfPermissionsToSearch, function(obj){ return (obj.memberId === id); });

            return (matchingContact) ? matchingContact.role : $scope.roleTypes[0];
        }

        $scope.shareFolderData.resetValidation();

        $scope.getContactList().then(function(result){
            $scope.shareFolderData.contactList = result;
        });

        $scope.shareFolderData.options = {};

        //GRID THINGS BELOW

        var defaultOptions = {
            headerRowHeight : '40',
            rowHeight : '50',
            showSelectionCheckbox : false,
            filterOptions : {
                filterText : '',
                useExternalFilter : false
            }
        };

        var templatePath = function(template) {
            return 'documents/folders/actions/sharefolder/' + template + '.2js.html';
        };

        var fixedOptions = {
            columnDefs : [
                {
                    cellTemplate: templatePath('name-grid-cell-template'),
                    displayName: 'Client',
                    field: 'label',
                    width: '50%'
                },
                {
                    cellTemplate: templatePath('combo-grid-cell-template'),
                    displayName: 'Role',
                    field: 'role',
                    width: '50%'
                },
            ],
            data : 'shareFolderData.contactList'
        };

        angular.extend($scope.shareFolderData.options, defaultOptions);
        angular.extend($scope.shareFolderData.options, fixedOptions);
    };

    shareFolder.$inject = [
        '$scope',
        '$uibModalInstance',
        '$q',
        'clientId',
        'containerType',
        'selectedItem',
        'clientManager',
        'contactManager',
        'folderManager',
        'projectManager',
        'RoleTypes'
    ];
    angular.module('onvio.documents').controller('shareFolder', shareFolder);
})(window, window.angular, window._);

(function(angular, _){
    'use strict';

    var folderMaster = function(
        $scope,
        $state,
        $stateParams,
        $uibModal,
        $window,
        $q,
        $location,
        $interval,
        $translate,
        bmPermission,
        dmsPermission,
        DmsGridPageState,
        folderManager,
        fileManager,
        searchManager,
        dmsUploadService,
        utility,
        UiService,
        moveFolderSelectionModalService,
        copyFolderSelectionModalService,
        uploadAlertDisplayModalService,
        operationAlertDisplayModalService,
        dmsApiOperationService,
        dmsDropbox,
        dmsGoogleDrive,
        dmsBox,
        dmsModalUiService,
        folderUiService,
        documentUiService,
        projectUiService,
        recycleBinUiService,
        DmsGridItemsFunctionResult,
        SourceTypes,
        bmUser,
        dmsCustomProtocolHanderUiService,
        confirmationModalService,
        helpService,
        dmsSearchGetSet
        ) {

        var knownFileTypes;

        var vm = this;
        var isDropboxUploaded = false;

        $scope.dragDropable = true;
        $scope.isPreviewMode = false;
        // Setting table height. I think we'll do this another way
        // in the end.
        $scope.fileManager = fileManager;

        $scope.go = function(path){
            $location.path('/' + path);
        };

        var w = angular.element($window);

        $scope.getViewerHeight = function() {
            var grid = document.querySelector('#folder-grid');
            var top = 0;
            if(grid !== null && angular.isFunction(grid.getBoundingClientRect)){
                top = grid.getBoundingClientRect().top;
            }
            return w.height() - top - 75;
        };

        $scope.viewerHeight = $scope.getViewerHeight();

        $scope.$watch($scope.getViewerHeight, function(newValue) {
            $scope.viewerHeight = 'height: ' + newValue + 'px;';
        });

        w.bind('resize', function() {
            $scope.$apply();
        });

        var clearPageAlerts = function(){
            $scope.alerts = [];
        };

        $scope.$on('dmsFolderAdded', function(){
            refreshGrid(false);
        });

        var filesOfBatchAdded = 0;
        $scope.$on('dms-file-added', function() {
            filesOfBatchAdded++;
            if (filesOfBatchAdded % 5 === 0) {
                refreshGrid(false);
            }
        });

        $scope.$on('dms-upload-batch-complete', function(){
            if (filesOfBatchAdded % 5 !== 0) {
                refreshGrid(false);
            }
            filesOfBatchAdded = 0;
        });

        var operationsOfBatchComplete = 0;
        $scope.$on('dms-operation-complete', function(event, operationModel) {
            switch (operationModel.type) {
            case 'move':
            case 'copy':
            case 'add':
            case 'delete':
            case 'moveToRecycle':
                operationsOfBatchComplete++;
                if (operationsOfBatchComplete % 5 === 0) {
                    refreshGrid(false);
                }
                break;
            }

            $interval(function(){
                $scope.operations.remove(operationModel);
            }, 10000, 1);
        });

        $scope.$on('dms-operation-batch-complete', function(){
            if (operationsOfBatchComplete % 5 !== 0) {
                refreshGrid(false);
            }

            if (dmsApiOperationService.currentBatch.error === 0) {
                $interval(function(){
                    if (!dmsApiOperationService.operationQueue.isProcessing()) {
                        dmsApiOperationService.clearBatch();
                    }
                }, 10000, 1);
            }

            operationsOfBatchComplete = 0;
        });

        $scope.openLocally = function(){
                    var item = $scope.selectedGridItems[0];
                    var currentContainerType = $scope.containerType.toLowerCase();
                    var url = '/api/storage/v1/{containerType}/{containerId}/documents/{documentId}'
                        .replace('{containerType}', currentContainerType === 'folder' || currentContainerType === 'folders'  ? 'folders' : 'projects')
                        .replace('{containerId}', $scope.containerId)
                        .replace('{documentId}', item.id);
                    var openDocumentRequest = { url: url, name: item.name, userId: bmUser.bluId, contactId: bmUser.contactId };
                    var openDocumentRequestJson = JSON.stringify(openDocumentRequest);
                    var href = 'onvio:' + btoa(unescape(encodeURIComponent(openDocumentRequestJson))); // jshint ignore:line
                    dmsCustomProtocolHanderUiService.openCustomProtocol(href, $scope.showOpenLocallyError);
                };

                $scope.showOpenLocallyError = function(){
                    confirmationModalService.open({
                        size: 'sm',
                        message: $translate.instant('Bluemoon.DMS.UiServices.ModalUiService.OpenLocallyErrorMessage'),
                        positiveConfirmation: $translate.instant('Bluemoon.DMS.UiServices.ModalUiService.LearnMore'),
                        negativeConfirmation: $translate.instant('Bluemoon.DMS.UiServices.ModalUiService.Cancel')
                    }).result.then(function(learnMore){
                        if (!learnMore) { return; }
                        helpService.load().then(function(resp) {
                        var help = [];
                        angular.extend(help, resp.data);
                        $window.open(help.baseUrl + 'onvio-link.htm', '_blank');    });
                        });
                    return;
                };

        $scope.openAddFolderModal = function() {
            dmsModalUiService.addFolder({
                scope: $scope,
                busily: false,
                addOperation: true,
                parentContainerId: $scope.selectedItem.id,
                parentContainerType: $scope.selectedItem.itemType
            });
        };

        $scope.openAddFile = function() {
            var el = document.getElementById('dms-file-select');
            el.value = null;
            var evt;
            if (document.createEvent) {
                evt = document.createEvent('MouseEvents');
                evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            }
            if(evt) {
                el.dispatchEvent(evt);
            } else if(el.click) {
                el.click();
            }
        };

        $scope.onFileSelect = function($files) {
            var dataTransfer = { files : $files};
            dmsUploadService.addBatch(dataTransfer, $scope.selectedItem.id, $scope.containerType);
            $files = [];
        };

        $scope.openScanFileModal = function() {
            var modalInstance = $uibModal.open({
                templateUrl: 'documents/files/actions/scanfile/scan-file-modal.2js.html',
                controller: 'scanFile',
                backdrop: 'static',
                resolve: {
                    selectedFolder: function() {
                        return $scope.selectedItem;
                    }
                }
            });

            modalInstance.result.then(function() {
                refreshGrid();
            });
        };

        $scope.openNewWordDocumentModal = function() {
            dmsModalUiService.addDocument({
                scope: $scope,
                busily: false,
                addOperation: true,
                parentContainerId: $scope.selectedItem.id,
                parentContainerType: $scope.selectedItem.itemType,
                menuSourceType: 'Dms',
                documentType: 'Word',
                documentPurpose: 'document',
            });
        };

        $scope.openNewExcelSpreadsheetModal = function() {
            dmsModalUiService.addDocument({
                scope: $scope,
                busily: false,
                addOperation: true,
                parentContainerId: $scope.selectedItem.id,
                parentContainerType: $scope.selectedItem.itemType,
                menuSourceType: 'Dms',
                documentType: 'Excel',
                documentPurpose: 'document',
            });
        };

        $scope.openSendModal = function(){
            dmsModalUiService.sendItems($scope.selectedGridItems);
        };

        $scope.openDeleteModal = function(){
            dmsModalUiService.deleteItems($scope.selectedGridItems);
        };

        $scope.openRecycleModal = function(){
            var promiseArr = [];

            _.each($scope.selectedGridItems, function(item){
                if (item.itemType === 'Folder') {
                    item.containerType = item.parentItem.containerType;
                    item.containerId = item.parentItem.id;

                    promiseArr.push(recycleBinUiService.moveFolderToTrash({
                        busily: false,
                        params: {
                            trashRequest: item
                        }
                    }));
                } else if (item.itemType === 'Document') {
                    item.containerType = item.parentItem.containerType;

                    promiseArr.push(recycleBinUiService.moveDocumentToTrash({
                        busily: false,
                        params: {
                            trashRequest: item
                        }
                    }));
                }
            });

            $q.all(promiseArr).then(function(){
                refreshGrid();
            });
        };

        var filterItemType = function(itemCollection, itemType) {
            if (!itemCollection || itemCollection.length === 0 ||
                !itemType || itemType === '') {
                return;
            }

            return _.filter(itemCollection, function(item) {
                return item.itemType.toLowerCase() === itemType.toLowerCase();
            });
        };

        var performOnItems = function(itemCollection, itemFunctionMap) {
            if (!itemCollection || itemCollection.length === 0 || !itemFunctionMap) {
                return;
            }

            var returnValues = {};

            for(var itemType in itemFunctionMap) {
                var itemFunction = itemFunctionMap[itemType];
                if (itemFunction && angular.isFunction(itemFunction)) {
                    var filteredItems = filterItemType(itemCollection, itemType);
                    if (filteredItems && filteredItems.length > 0){
                        returnValues[itemType] = itemFunction(filteredItems);
                    }
                } else {
                    throw new TypeError('expected function for itemType ' + itemType);
                }
            }

            return returnValues;
        };

        $scope.openCopyFolderModal = function() {
            copyFolderSelectionModalService.open($scope.selectedGridItems).result
                .then(function(destinationFolder){
                    performOnItems($scope.selectedGridItems, {
                        folder: function(folders) {
                            return folderManager.copyFolders(folders, destinationFolder.id, destinationFolder.itemType);
                        },
                        document: function(documents) {
                            return fileManager.copyDocuments(documents, destinationFolder.id, destinationFolder.itemType);
                        },
                    });
                });
        };

        $scope.openMoveFolderModal = function() {
            moveFolderSelectionModalService.open($scope.selectedGridItems).result
                .then(function(destinationFolder){
                    performOnItems($scope.selectedGridItems, {
                        folder: function(folders) {
                            return folderManager.moveFolders(folders, destinationFolder.id, destinationFolder.itemType);
                        },
                        document: function(documents) {
                            return fileManager.moveDocuments(documents, destinationFolder.id, destinationFolder.itemType);
                        },
                    });
                });
        };

        $scope.downloadFile = function() {
            if (utility.ToolBar.ifOnlyOneDocumentSelected({ selectedItems: $scope.selectedGridItems})){
                var item = $scope.selectedGridItems[0];
                documentUiService.download({
                    params: {
                        document: {
                            id: item.id,
                            parentItem: item.parentItem
                        }
                    }
                });
            }
        };

        $scope.openRenameModal = function() {
            // TODO: VALIDATE SELECTED ITEM IS SET AND IS A FOLDER

            if ($scope.selectedGridItems && $scope.selectedGridItems.length === 1) {

                var templateUrl;
                var controller;
                var resolve;
                var itemToRename = $scope.selectedGridItems[0];
                if (itemToRename.itemType === 'Folder'){
                    templateUrl = 'documents/folders/actions/renamefolder/rename-folder-modal.2js.html';
                    controller = 'renameFolder';
                    resolve = {
                        'selectedFolder': function() {
                            return itemToRename;
                        }
                    };
                } else {
                    templateUrl = 'documents/files/actions/renamefile/rename-file-modal.2js.html';
                    controller = 'renameFile';
                    resolve = {
                        'selectedFile': function() {
                            return itemToRename;
                        },
                        containerType: function(){
                            return $scope.containerType;
                        }
                    };
                }

                var modalInstance = $uibModal.open({
                    templateUrl: templateUrl,
                    controller: controller,
                    backdrop: 'static',
                    resolve: resolve
                });

                modalInstance.result.then(function() {
                    refreshGrid();
                });
            }
        };

        $scope.openUploadAlertDisplayModal = function() {
            if ($scope.totalUploads.totalFiles > 0) {
                uploadAlertDisplayModalService.open({ uploadCollection: $scope.uploads })
                    .then(function(uploadAlertDisplayModalInstance) {
                        if (uploadAlertDisplayModalInstance) {
                            $scope.dialogOpen = true;
                            uploadAlertDisplayModalInstance.result.then(function() {
                                $scope.dialogOpen = false;
                            });
                        }

                        var unregisterTotalFilesWatch = $scope.$watch('totalUploads.totalFiles', function(newValue) {
                            if (newValue === 0) {
                                uploadAlertDisplayModalInstance.close();
                                unregisterTotalFilesWatch();
                            }
                        });
                    });
            }
        };

        $scope.onCellFileDrop = function() {
            console.log('Cell File Drop');
        };

        $scope.openOperationAlertDisplayModal = function() {
            if ($scope.operations.length > 0) {
                operationAlertDisplayModalService.open({ dmsOperationCollectionModel: $scope.operations })
                    .then(function(operationAlertDisplayModalInstance) {
                        var unregisterOperationsLengthWatch = $scope.$watch('operations.length', function(newValue) {
                            if (newValue === 0) {
                                operationAlertDisplayModalInstance.close();
                                unregisterOperationsLengthWatch();
                            }
                        });

                        if (operationAlertDisplayModalInstance) {
                            $scope.dialogOpen = true;
                            operationAlertDisplayModalInstance.result.then(function() {
                                unregisterOperationsLengthWatch();
                                $scope.dialogOpen = false;
                            });
                        }
                    });
            }
        };

        $scope.onCellFileDrop = function() {
            console.log('Cell File Drop');
        };

        $scope.closeDownloadAlert = function() {
            $scope.downloadStatus = 'done';
            $scope.downloadError = false;
        };

        $scope.openDropbox = function(){
            var callback = function(files){
                if(!isDropboxUploaded){
                    for (var i = 0; i < files.length; i++){
                        dmsUploadService.createCloudFilePost($scope.uploadContainerId, files[i].link, files[i].name, files[i].bytes, $scope.uploadContainerType, SourceTypes.Dropbox);
                    }
                    isDropboxUploaded = true;
                }
            };

            dmsDropbox.create(callback, knownFileTypes);
            isDropboxUploaded = false;
        };

        $scope.openGDrive = function(){
            var callback = function(fileLink, fileTitle, fileSize, token){
                dmsUploadService.createCloudFilePost($scope.uploadContainerId, fileLink, fileTitle, fileSize, $scope.uploadContainerType, SourceTypes.Google, token);
            };

            dmsGoogleDrive.create(callback);
        };

        $scope.openBox = function(){

            var callback = function(files){
                for (var i = 0; i < files.length; i++){
                    dmsUploadService.createCloudFilePost($scope.uploadContainerId, files[i].url, files[i].name, files[i].size, $scope.uploadContainerType, SourceTypes.Box);
                }
            };

            dmsBox.create(callback);
        };

        var isPreviewModeEnabled = function() {
            return $scope.isPreviewMode;
        };
        var ifCanUseDropbox = function(gridData){
            return !isPreviewModeEnabled() && utility.ToolBar.ifCanAddContents(gridData) && dmsDropbox.isAvailable;
        };

        var ifCanUseGoogleDrive = function(gridData){
            return !isPreviewModeEnabled() && utility.ToolBar.ifCanAddContents(gridData) && dmsGoogleDrive.isAvailable;
        };

        var ifCanUseBox = function(gridData){
            return !isPreviewModeEnabled() && utility.ToolBar.ifCanAddContents(gridData) && dmsBox.isAvailable;
        };

        vm._loadToolbarStrings = function(){
            var deferred = $q.defer();

            $q.all([
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.New'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.NewFolder'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.NewScan'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.WordDocument'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.ExcelSpreadsheet'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.Upload'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.Manage'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.Download'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.Move'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.Copy'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.Rename'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.Delete'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.Cloud'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.Dropbox'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.GoogleDrive'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.Box'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.Send'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.Open'),
            ]).then(function(s){
                deferred.resolve({
                    'Bluemoon.DMS.Toolbar.FolderGrid.New'                               : s[0],
                    'Bluemoon.DMS.Toolbar.FolderGrid.NewFolder'                         : s[1],
                    'Bluemoon.DMS.Toolbar.FolderGrid.NewScan'                           : s[2],
                    'Bluemoon.DMS.Toolbar.FolderGrid.WordDocument'                      : s[3],
                    'Bluemoon.DMS.Toolbar.FolderGrid.ExcelSpreadsheet'                  : s[4],
                    'Bluemoon.DMS.Toolbar.FolderGrid.Upload'                            : s[5],
                    'Bluemoon.DMS.Toolbar.FolderGrid.Manage'                            : s[6],
                    'Bluemoon.DMS.Toolbar.FolderGrid.Download'                          : s[7],
                    'Bluemoon.DMS.Toolbar.FolderGrid.Move'                              : s[8],
                    'Bluemoon.DMS.Toolbar.FolderGrid.Copy'                              : s[9],
                    'Bluemoon.DMS.Toolbar.FolderGrid.Rename'                            : s[10],
                    'Bluemoon.DMS.Toolbar.FolderGrid.Delete'                            : s[11],
                    'Bluemoon.DMS.Toolbar.FolderGrid.Cloud'                             : s[12],
                    'Bluemoon.DMS.Toolbar.FolderGrid.Dropbox'                           : s[13],
                    'Bluemoon.DMS.Toolbar.FolderGrid.GoogleDrive'                       : s[14],
                    'Bluemoon.DMS.Toolbar.FolderGrid.Box'                               : s[15],
                    'Bluemoon.DMS.Toolbar.FolderGrid.Send'                              : s[16],
                    'Bluemoon.DMS.Toolbar.FolderGrid.Open'                              : s[17],
                });
            });

            return deferred.promise;
        };

        var getFileTypes = function(){
            return documentUiService.getConstraints({busily: false}).then(function(constraints){
                return constraints.allowedTypes;
            });
        };
        var openLocallyEnabled = function(gridData) {
            return !isPreviewModeEnabled() && utility.ToolBar.ifOnlyOneDocumentSelected(gridData) && utility.ToolBar.ifNotLocked(gridData) && utility.ToolBar.ifCanBeUpdated(gridData);
        };

        var ifMoveCanBeEnabled = function(gridData) {
            return !isPreviewModeEnabled() && utility.ToolBar.ifAtLeastOneSelected(gridData) && utility.ToolBar.ifCanBeMoved(gridData) && (utility.ToolBar.ifOnlyDocumentsSelected(gridData) || bmPermission.has('OnvioDrive.AddFolders'));
        };

        var ifCopyCanBeEnabled = function(gridData) {
            return !isPreviewModeEnabled() && utility.ToolBar.ifAtLeastOneSelected(gridData) && utility.ToolBar.ifCanBeUpdated(gridData) && (utility.ToolBar.ifOnlyDocumentsSelected(gridData) || bmPermission.has('OnvioDrive.AddFolders'));
        };

        var ifRenameCanBeEnabled = function(gridData) {
            return !isPreviewModeEnabled() && utility.ToolBar.ifOnlyOneSelected(gridData) && utility.ToolBar.ifCanBeUpdated(gridData) && (utility.ToolBar.ifOnlyDocumentsSelected(gridData) || bmPermission.has('OnvioDrive.EditFolders'));
        };

        var ifRemoveCanBeEnabled = function(gridData) {
            return !isPreviewModeEnabled() && utility.ToolBar.ifAtLeastOneSelected(gridData) && utility.ToolBar.ifCanBeDeleted(gridData) && (utility.ToolBar.ifOnlyDocumentsSelected(gridData) || bmPermission.has('OnvioDrive.DeleteFolders'));
        };
        var ifCanAddContents = function (gridData) {
            return !isPreviewModeEnabled() && utility.ToolBar.ifCanAddContents(gridData);
        };
        var ifOnlyDocumentsSelected = function (gridData) {
            return !isPreviewModeEnabled() && utility.ToolBar.ifOnlyDocumentsSelected(gridData);
        };

        vm._setupGrid = function() {
            var promiseArr = [];
            var deferred = $q.defer();

            promiseArr.push(getFileTypes());
            promiseArr.push(dmsPermission.has('OnvioDrive.RecycleBin'));
            promiseArr.push(dmsPermission.hasNegIAC('DMS_HideRecycleBin'));
            promiseArr.push(dmsPermission.hasNegIAC('DMS_HideOpenLocally'));
            promiseArr.push(dmsPermission.hasNegIAC('Platform_DisableEndpoints'));
            promiseArr.push(dmsPermission.has('Platform.PreviewMode'));

            $q.all(promiseArr).then(function(resArr){
                knownFileTypes = resArr[0];

                var hasRecycleBin = null;

                if(resArr[1] === true && resArr[2] === true){
                    hasRecycleBin = true;
                } else {
                    hasRecycleBin = false;
                }
                $scope.isPreviewMode = resArr[5];
                vm._loadToolbarStrings().then(function(translations){

                    $scope.buttons = [
                        {
                            'text': translations['Bluemoon.DMS.Toolbar.FolderGrid.New'],
                            'isEnabled' : true,
                            'moreButtons':
                            [
                                {
                                    text: translations['Bluemoon.DMS.Toolbar.FolderGrid.NewFolder'],
                                    icon: 'bento-icon-add',
                                    click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openAddFolderModal),
                                    canShow: bmPermission.has('OnvioDrive.AddFolders'),
                                    isEnabled: ifCanAddContents
                                },
                                {
                                    text: translations['Bluemoon.DMS.Toolbar.FolderGrid.NewScan'],
                                    icon: 'bento-icon-scan',
                                    click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openScanFileModal),
                                    isEnabled: ifCanAddContents
                                },
                                {
                                    text: translations['Bluemoon.DMS.Toolbar.FolderGrid.WordDocument'],
                                    icon: 'bento-icon-file-word',
                                    click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openNewWordDocumentModal),
                                    canShow: bmPermission.has('OnvioDrive.NewDocument'),
                                    isEnabled: ifCanAddContents
                                },
                                {
                                    text: translations['Bluemoon.DMS.Toolbar.FolderGrid.ExcelSpreadsheet'],
                                    icon: 'bento-icon-file-excel',
                                    click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openNewExcelSpreadsheetModal),
                                    canShow: bmPermission.has('OnvioDrive.NewDocument'),
                                    isEnabled: ifCanAddContents
                                },
                            ]
                        },
                        {
                            text: translations['Bluemoon.DMS.Toolbar.FolderGrid.Upload'],
                            icon: 'bento-icon-upload',
                            click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openAddFile),
                            isEnabled: ifCanAddContents
                        },
                         {
                            text: translations['Bluemoon.DMS.Toolbar.FolderGrid.Open'],
                            icon: 'bento-icon-exit2',
                            click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openLocally),
                            canShow: resArr[3] && resArr[4] && bmPermission.has('OnvioDrive.OpenLocally'),
                            isEnabled: openLocallyEnabled
                        },
                        {
                            text: translations['Bluemoon.DMS.Toolbar.FolderGrid.Manage'],
                            isEnabled: true,
                            moreButtons:
                            [
                                {
                                    text: translations['Bluemoon.DMS.Toolbar.FolderGrid.Download'],
                                    icon: 'bento-icon-download',
                                    click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.downloadFile),
                                    isEnabled: utility.ToolBar.ifOnlyOneDocumentSelected
                                },
                                {
                                    text: translations['Bluemoon.DMS.Toolbar.FolderGrid.Send'],
                                    icon: 'bento-icon-envelope',
                                    click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openSendModal),
                                    isEnabled: ifOnlyDocumentsSelected,
                                    canShow: bmPermission.has('OnvioDrive.SendingDocuments'), //uses the $watch method in bluemoon-dms-toolbar.js
                                    analyticsEvent: 'dmsToolbar_manage_send',
                                },
                                {
                                    text: translations['Bluemoon.DMS.Toolbar.FolderGrid.Move'],
                                    icon: 'bento-icon-move',
                                    click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openMoveFolderModal),
                                    isEnabled: ifMoveCanBeEnabled
                                },
                                {
                                    text: translations['Bluemoon.DMS.Toolbar.FolderGrid.Copy'],
                                    icon: 'bento-icon-copy',
                                    click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openCopyFolderModal),
                                    isEnabled: ifCopyCanBeEnabled
                                },
                                {
                                    text: translations['Bluemoon.DMS.Toolbar.FolderGrid.Rename'],
                                    icon: 'bento-icon-rename',
                                    click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openRenameModal),
                                    isEnabled: ifRenameCanBeEnabled
                                },
                                {
                                    text: translations['Bluemoon.DMS.Toolbar.FolderGrid.Delete'],
                                    icon: 'bento-icon-remove',
                                    canShow: hasRecycleBin,
                                    click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openRecycleModal),
                                    isEnabled: ifRemoveCanBeEnabled
                                },
                                {
                                    text: translations['Bluemoon.DMS.Toolbar.FolderGrid.Delete'],
                                    icon: 'bento-icon-close-circle',
                                    canShow: (hasRecycleBin === false),
                                    click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openDeleteModal),
                                    isEnabled: ifRemoveCanBeEnabled
                                },
                            ],
                        },
                        {
                            text: translations['Bluemoon.DMS.Toolbar.FolderGrid.Cloud'],
                            isEnabled : true,
                            moreButtons:
                            [
                                {
                                    text: translations['Bluemoon.DMS.Toolbar.FolderGrid.Dropbox'],
                                    icon: 'dms-dropbox-icon',
                                    click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openDropbox),
                                    isEnabled: ifCanUseDropbox
                                },
                                {
                                    text: translations['Bluemoon.DMS.Toolbar.FolderGrid.GoogleDrive'],
                                    icon: 'dms-assorted-google-drive',
                                    click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openGDrive),
                                    isEnabled: ifCanUseGoogleDrive
                                },
                                {
                                    text: translations['Bluemoon.DMS.Toolbar.FolderGrid.Box'],
                                    icon: 'dms-assorted-box-logo',
                                    click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openBox),
                                    isEnabled: ifCanUseBox
                                },
                            ]
                        }
                    ];

                    $scope.gridOptions = {
                        showColumnMenu : false,
                        showGroupPanel : false
                    };

                    deferred.resolve();
                });
            });
            return deferred.promise;
        };

        $scope.$on('bmLanguageChangeSuccess', function(){
            vm._setupGrid();
        });

        $scope.processSearch = function(term){
            if (term === undefined) { return; }
            searchManager.setSearchCriteria(term,$scope.selectedItem);
            dmsSearchGetSet.setSearchTerm(term);
            dmsSearchGetSet.setSelectedItem($scope.selectedItem);
            $state.go('documentSearchResults');
        };

        $scope.getFirstUpload = function() {
            var uploadKeys = Object.keys(dmsUploadService.uploads);
            if (uploadKeys.length > 0) {
                return dmsUploadService.uploads[_.sortBy(uploadKeys, function(key) {
                    return key.substr(key.lastIndexOf('|') + 1);
                }).reverse()[0]];
            }
        };

        $scope.pageState = new DmsGridPageState({ sort: 'name:asc' });

        $scope.getGridItemsCallback = function(options) {
            return vm._getGridItems(options)
                .then(function(result){
                    return new DmsGridItemsFunctionResult(
                        result.pageIndex,
                        result.data,
                        result.itemsPerPage,
                        result.totalItems,
                        result.totalPages,
                        result.startIndex);
                });
        };

        function refreshGrid(busily) {

            var refreshOptions = {
                busily: busily === undefined || busily
            };

            $scope.$broadcast('dms-grid-refresh', refreshOptions);
        }

        vm._getGridItems = angular.noop;

        $scope.refreshInProgress = false;

        vm._getFolder = function(folderId) {
            return folderUiService.getFolder({
                scope: $scope,
                params: {
                    folderId: folderId
                }
            });
        };

        vm._getFolderChildren = function(folderId, pageState, options) {
            return folderUiService.getFolderChildren({
                scope: $scope,
                params: {
                    folderId: folderId,
                    pageState: pageState,
                },
                busily: options.busily
            });
        };

        vm._getFirmFolder = function() {
            return folderUiService.getFirmFolder({
                scope: $scope
            });
        };

        vm._getProjectChildren = function(projectId, pageState, options) {
            return projectUiService.getProjectChildren({
                scope: $scope,
                params: {
                    projectId: projectId,
                    pageState: pageState,
                },
                busily: options.busily
            });
        };

        vm._getSelectedItem = function(folderId) {
            var selectedFolder = folderManager.getCachedFolderWithParentTree(folderId);
            if (selectedFolder) {
                var setSelectedItemDeferred = $q.defer();
                setSelectedItemDeferred.resolve(selectedFolder);
                return setSelectedItemDeferred.promise;
            }
            return vm._getFolder(folderId).then(function(data) {
                    return data.data;
                });
        };

        vm._getSelectedProject = function(projectId) {
            return projectUiService.getProject({
                scope: $scope,
                params: {
                    projectId: projectId
                }
            }).then(function(data) {
                return data.data;
            });
        };

        var defaultBuildLink = function(itemData){
            return UiService.getFolderUiItemHref(itemData);
        };

        var buildTemplateLink = function(itemData){
            if (itemData.item.itemType === 'Document'){
                //If we're inside the root of a template, behave differently
                if ($scope.containerType === 'folders'){
                    return $state.href('templateFileView', { templateId : $scope.templateId, folderId : itemData.item.containerId, fileId: itemData.item.id });
                } else {
                    return $state.href('templateRootFileView', { templateId : $scope.templateId, fileId : itemData.item.id });
                }
            } else {
                return $state.href('templateFolderList', { templateId : $scope.templateId, folderId : itemData.item.id });
            }
        };

        //Set a default behavior, only override it when absolutely necessary (templates)
        $scope.hrefFunction = defaultBuildLink;

        $scope.hrefFunctionCallback = function(itemData) {
            return $scope.hrefFunction(itemData);
        };

        var methodMap = {
            initialize : function() {
                // TODO: REMOVE THIS WHEN UNIT TESTS ARE ACTUALLY WRITTEN
                $scope.test = 'test';
                $scope.totalUploads = dmsUploadService.totalProgress;
                $scope.uploads = dmsUploadService.uploads;
                $scope.uploadContainerType = ($stateParams.folderId !== null && $stateParams.folderId !== undefined) ? 'folders' : 'projects';

                if ($scope.uploadContainerType === 'folders'){
                    $scope.uploadContainerId = $stateParams.folderId;
                } else if ($scope.uploadContainerType === 'projects'){
                    //NOTE: projectId and templateId SHOULD be mutually exclusive.
                    if (!!$stateParams.projectId  && !$stateParams.templateId) {
                        $scope.uploadContainerId = $stateParams.projectId;
                    } else if (!$stateParams.projectId && !!$stateParams.templateId){
                        $scope.uploadContainerId = $stateParams.templateId;
                    }
                }

                $scope.operations = dmsApiOperationService.operations;
                $scope.operationBatch = dmsApiOperationService.currentBatch;
                $scope.selectedItem = {};
                $scope.selectedFolderChildren = [];
                $scope.alerts = [];
                $scope.selectedGridItems = [];
                $scope.gridItems = [];
                $scope.projectId = undefined;
                $scope.templateId = undefined;
                $scope.containerType = undefined;
                $scope.dialogOpen = false;
                $scope.showTitle = false;
                $scope.collapseLength = 4;
            },
            preExecute : function() {
                clearPageAlerts();
                vm._setupGrid();
            },
            postExecute: function(){
                refreshGrid();
            },
            execute : function()
            {
                this.initialize();
                var toExecute = methodMap[$state.current.name];
                if (angular.isFunction(toExecute))
                {
                    this.preExecute();
                    toExecute();
                    this.postExecute();
                }
            },
            firmFolder : function() {
                vm._getGridItems = function(options) {
                    return vm._getFirmFolder(options);
                };
            },
            folderList : function() { //projectFolderList?
                $scope.containerType = 'folders';
                var folderId = $stateParams.folderId;

                $scope.containerItemType = 'Folder';
                $scope.containerId = folderId;

                vm._getSelectedItem(folderId).then(function(data) {
                    $scope.selectedItem = data;
                    $scope.dragDropable = !data || (!data.lock || data.lock.resourceRestrictions.indexOf('CREATE_SUB_RESOURCE') < 0);
                });

                vm._getGridItems = function(options){
                    return vm._getFolderChildren(folderId, $scope.pageState, options);
                };
            },
            projectFolderList : function() { //projectFolderList?
                $scope.projectId = $stateParams.projectId;
                $scope.clientId = $stateParams.clientId;
                $scope.folderId = $stateParams.folderId;
                $scope.containerType = 'folders';

                $scope.containerItemType = 'Folder';
                $scope.containerId = $scope.folderId;

                vm._getSelectedItem($scope.folderId).then(function(data) {
                    $scope.selectedItem = data;
                    $scope.dragDropable = !data || (!data.lock || data.lock.resourceRestrictions.indexOf('CREATE_SUB_RESOURCE') < 0);
                });

                vm._getGridItems = function(options){
                    return vm._getFolderChildren($scope.folderId, $scope.pageState, options);
                };
            },
            projectRootList : function() {
                $scope.projectId = $stateParams.projectId;
                $scope.clientId = $stateParams.clientId;
                $scope.containerType = 'projects';

                $scope.containerItemType = 'Project';
                $scope.containerId = $scope.projectId;

                vm._getSelectedProject($scope.projectId).then(function(data){
                    $scope.selectedItem = data;
                    $scope.dragDropable = !data || (!data.lock || data.lock.resourceRestrictions.indexOf('CREATE_SUB_RESOURCE') < 0);
                });

                vm._getGridItems = function(options){
                    return vm._getProjectChildren($scope.projectId, $scope.pageState, options);
                };
            },
            folderFileView : function() {
            },
            //TEMPLATES
            templateRootList : function() {
                $scope.templateId = $stateParams.templateId;
                $scope.containerType = 'projects'; //TODO: check
                $scope.hrefFunction = buildTemplateLink;

                $scope.containerItemType = 'Project';
                $scope.containerId = $scope.templateId;

                vm._getSelectedProject($scope.templateId).then(function(data){
                    $scope.selectedItem = data;
                    $scope.dragDropable = !data || (!data.lock || data.lock.resourceRestrictions.indexOf('CREATE_SUB_RESOURCE') < 0);
                });

                vm._getGridItems = function(options){
                    return vm._getProjectChildren($scope.templateId, $scope.pageState, options);
                };
            },
            templateFolderList : function() {
                $scope.templateId = $stateParams.templateId;
                $scope.folderId = $stateParams.folderId;
                $scope.containerType = 'folders'; //TODO: check
                $scope.hrefFunction = buildTemplateLink;

                $scope.containerItemType = 'Folder';
                $scope.containerId = $scope.folderId;

                vm._getSelectedItem($scope.folderId).then(function(data) {
                    $scope.selectedItem = data;
                    $scope.dragDropable = !data || (!data.lock || data.lock.resourceRestrictions.indexOf('CREATE_SUB_RESOURCE') < 0);
                });

                vm._getGridItems = function(options){
                    return vm._getFolderChildren($scope.folderId, $scope.pageState, options);
                };
            },
            documentSearchResults : function() {
            }
        };

        methodMap.execute();

        //NOTE: only for helping with unit testing
        vm._execute = function(){
            methodMap.execute();
        };

    };

    folderMaster.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$uibModal',
        '$window',
        '$q',
        '$location',
        '$interval',
        '$translate',
        'bmPermission',
        'dmsPermission',
        'DmsGridPageState',
        'folderManager',
        'fileManager',
        'searchManager',
        'dmsUploadService',
        'utility',
        'UiService',
        'moveFolderSelectionModalService',
        'copyFolderSelectionModalService',
        'uploadAlertDisplayModalService',
        'operationAlertDisplayModalService',
        'dmsApiOperationService',
        'dmsDropbox',
        'dmsGoogleDrive',
        'dmsBox',
        'dmsModalUiService',
        'folderUiService',
        'dmsDocumentUiService',
        'projectUiService',
        'dmsRecycleBinUiService',
        'DmsGridItemsFunctionResult',
        'SourceTypes',
        'bmUser',
        'dmsCustomProtocolHanderUiService',
        'confirmationModalService',
        'helpService',
        'dmsSearchGetSet'
    ];
    angular.module('onvio.documents').controller('folderMaster', folderMaster);
})(window.angular, window._);

(function(angular){
    'use strict';

    var recentsMasterCtl = function(
        $scope,
        $window,
        $location) {

        var vm = this;

        $scope.gridControlContainer = {};

        var gridControl;

        var unwatchGridControl = $scope.$watch('gridControl', function(){
            if ($scope.gridControlContainer.control){
                gridControl = $scope.gridControlContainer.control;
                gridControl.refresh();
                unwatchGridControl();
            }
        });

        // Setting table height. I think we'll do this another way
        // in the end.
        $scope.go = function(path){
            $location.path('/' + path);
        };

        var w = angular.element($window);

        $scope.getViewerHeight = function() {
            var grid = document.querySelector('#folder-grid');
            var top = 0;
            if(grid !== null && angular.isFunction(grid.getBoundingClientRect)){
                top = grid.getBoundingClientRect().top;
            }
            return w.height() - top - 75;
        };

        $scope.viewerHeight = $scope.getViewerHeight();

        $scope.$watch($scope.getViewerHeight, function(newValue) {
            $scope.viewerHeight = 'height: ' + newValue + 'px;';
        });

        w.bind('resize', function() {
            $scope.$apply();
        });

        $scope.$on('bmLanguageChangeSuccess', function(){
            vm._setupGrid();
        });

        var clearAlerts = function(){
            $scope.alerts = [];
        };

        //NOTE: Usually much more complicated, but this particular grid doesn't have any buttons
        vm._setupGrid = function(){
            clearAlerts();
        };

    };

    recentsMasterCtl.$inject = [
        '$scope',
        '$window',
        '$location',
    ];

    angular.module('onvio.documents').controller('recentsMaster', recentsMasterCtl);

})(window.angular);

(function(angular){
    'use strict';

    var recycleMasterCtl = function(
        $interval,
        $scope,
        $window,
        $location,
        $q,
        $translate,
        $uibModal,
        dmsRecycleBinUiService,
        dmsFolderSelectionModalService,
        confirmationModalService,
        dmsFolderService,
        dmsProjectService,
        dmsApiOperationService,
        operationAlertDisplayModalService,
        dmsPermission,
        utility) {

        var vm = this;

        $scope.gridControlContainer = {};
        $scope.buttons = [];

        var gridControl;

        var unwatchGridControl = $scope.$watch('gridControl', function(){
            if ($scope.gridControlContainer.control){
                gridControl = $scope.gridControlContainer.control;
                gridControl.refresh();
                unwatchGridControl();
            }
        });

        // Setting table height. I think we'll do this another way
        // in the end.
        $scope.go = function(path){
            $location.path('/' + path);
        };

        var w = angular.element($window);

        $scope.getViewerHeight = function() {
            var grid = document.querySelector('#folder-grid');
            var top = 0;
            if(grid !== null && angular.isFunction(grid.getBoundingClientRect)){
                top = grid.getBoundingClientRect().top;
            }
            return w.height() - top - 75;
        };

        $scope.viewerHeight = $scope.getViewerHeight();

        $scope.$watch($scope.getViewerHeight, function(newValue) {
            $scope.viewerHeight = 'height: ' + newValue + 'px;';
        });

        w.bind('resize', function() {
            $scope.$apply();
        });

        $scope.$on('bmLanguageChangeSuccess', function(){
            vm._setupGrid();
        });

        var operationsOfBatchComplete = 0;
        $scope.$on('dms-operation-complete', function(event, operationModel) {
            switch (operationModel.type) {
            case 'moveToRecycle':
            case 'permanentlyDelete':
            case 'restore':
                operationsOfBatchComplete++;
                if (operationsOfBatchComplete % 5 === 0) {
                    gridControl.refresh({ busily: false });
                }
                break;
            }

            $interval(function(){
                $scope.operations.remove(operationModel);
            }, 10000, 1);
        });

        $scope.$on('dms-operation-batch-complete', function(){
            if (operationsOfBatchComplete % 5 !== 0) {
                gridControl.refresh({ busily: false });
            }

            if (dmsApiOperationService.currentBatch.error === 0) {
                $interval(function(){
                    if (!dmsApiOperationService.operationQueue.isProcessing()) {
                        dmsApiOperationService.clearBatch();
                    }
                }, 10000, 1);
            }

            operationsOfBatchComplete = 0;
        });

        var restoreItem = function(item, containerId, containerType){

            var promiseItem = {
                scope: $scope,
                params: {
                    trashRequest: {
                        trashId: item.trashId,
                    },
                    restoreItemRequest: {
                        name: item.name,
                        destinationContainerId: containerId,
                        destinationContainerType: containerType
                    }
                },
                busily: false
            };

            if (item.type.toLowerCase() === 'folder'){
                dmsRecycleBinUiService.restoreFolder(promiseItem);
            } else {
                dmsRecycleBinUiService.restoreDocument(promiseItem);
            }
        };

        var selectNewLocation = function(item){

            var config = {
                titleText: $translate.instant('Bluemoon.DMS.Modal.Restore.Container.Title'),
                selectButtonText: $translate.instant('Bluemoon.DMS.Modal.RecycleGrid.Restore')
            };
            dmsFolderSelectionModalService.open(config).result.then(function(res){
                restoreItem(item, res.id, res.containerType);
            });
        };

        $scope.openRestoreModal = function(){
            var curItem = $scope.selectedGridItems[0];

            var curItemContainerType = curItem.containerType.toLowerCase();

            var service;

            if (curItemContainerType === 'folders'){
                service = dmsFolderService;
            } else {
                service = dmsProjectService;
            }

            if (!curItem.containerPath || curItem.containerPath.length === 0 || curItem.containerPath[0].id === 'trash'){
                selectNewLocation(curItem);
            } else {
                restoreItem(curItem, curItem.containerId, curItem.containerType);
            }
        };

        $scope.openDeletePermanentlyModal = function(){

            confirmationModalService.open({
                size: 'sm',
                message: $translate.instant('Bluemoon.DMS.UiServices.ModalUiService.DeleteMessage'),
                positiveConfirmation: $translate.instant('Bluemoon.DMS.UiServices.ModalUiService.Delete'),
                negativeConfirmation: $translate.instant('Bluemoon.DMS.UiServices.ModalUiService.Cancel')
            }).result.then(function(canDelete){
                if (!canDelete) { return ;}

                var promiseArr = [];
                for (var i = 0; i < $scope.selectedGridItems.length; i++){

                    var delObj = {
                        scope: $scope,
                        params: {
                            trashRequest: {
                                trashId: $scope.selectedGridItems[i].trashId,
                                name: $scope.selectedGridItems[i].name
                            }
                        },
                        busily: false
                    };

                    if ($scope.selectedGridItems[i].trashedResource.itemType.toLowerCase() === 'folder'){
                        promiseArr.push(dmsRecycleBinUiService.deleteFolder(delObj));
                    } else {
                        promiseArr.push(dmsRecycleBinUiService.deleteDocument(delObj));
                    }
                }

                $q.all(promiseArr);
            });
        };

        vm._loadToolbarStrings = function(){
            var deferred = $q.defer();

            $q.all([
                $translate('Bluemoon.DMS.Toolbar.RecycleGrid.Restore'),
                $translate('Bluemoon.DMS.Toolbar.RecycleGrid.PermanentlyDelete'),
            ]).then(function(s){
                deferred.resolve({
                    'Bluemoon.DMS.Toolbar.RecycleGrid.Restore'                               : s[0],
                    'Bluemoon.DMS.Toolbar.RecycleGrid.PermanentlyDelete'                     : s[1],
                });
            });

            return deferred.promise;
        };

        var clearAlerts = function(){
            $scope.alerts = [];
        };

        var onlyOneItemSelected = function(gridData){
            return gridData.selectedItems.length === 1;
        };

        vm._setupGrid = function(){
            clearAlerts();

            if (!$scope.selectedGridItems){
                $scope.selectedGridItems = [];
            }

            var promiseArr = [];
            var deferred = $q.defer();
            var allowedToAddFolders = false;
            var allowedToDeleteFolders = false;

            promiseArr.push(dmsPermission.has('OnvioDrive.AddFolders'));
            promiseArr.push(dmsPermission.has('OnvioDrive.DeleteFolders'));
            $q.all(promiseArr).then(function(resArr){
                if(resArr[0] === true)
                {
                    allowedToAddFolders = true;
                }
                if(resArr[1] === true)
                {
                    allowedToDeleteFolders = true;
                }
                vm._loadToolbarStrings().then(function(translations){

                    $scope.buttons = [
                        {
                            text: translations['Bluemoon.DMS.Toolbar.RecycleGrid.Restore'],
                            icon: 'bento-icon-add',
                            click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openRestoreModal),
                            isEnabled: onlyOneItemSelected && (allowedToAddFolders || utility.ToolBar.ifOnlyDocumentsSelected),
                            // canShow: true,
                            analyticsEvent: 'dmsToolbar_restore',
                        },
                        {
                            text: translations['Bluemoon.DMS.Toolbar.RecycleGrid.PermanentlyDelete'],
                            icon: 'bento-icon-remove',
                            click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openDeletePermanentlyModal),
                            isEnabled: utility.ToolBar.ifAtLeastOneSelected && (allowedToDeleteFolders || utility.ToolBar.ifOnlyDocumentsSelected),
                            // canShow: true,
                            analyticsEvent: 'dmsToolbar_permanently_delete',
                        },
                    ];
                    deferred.resolve();
                });
            });
            return deferred.promise;
        };

        $scope.openOperationAlertDisplayModal = function() {
            if ($scope.operations.length > 0) {
                var operationAlertDisplayModalInstance = operationAlertDisplayModalService.open(
                    {
                        dmsOperationCollectionModel: $scope.operations,
                    });

                var unregisterOperationsLengthWatch = $scope.$watch('operations.length', function(newValue) {
                    if (newValue === 0) {
                        operationAlertDisplayModalInstance.close();
                        unregisterOperationsLengthWatch();
                    }
                });

                if (operationAlertDisplayModalInstance) {
                    $scope.dialogOpen = true;
                    operationAlertDisplayModalInstance.result.then(function() {
                        unregisterOperationsLengthWatch();
                        $scope.dialogOpen = false;
                    });
                }
            }
        };

        $scope.operations = dmsApiOperationService.operations;
        vm._setupGrid();
    };

    recycleMasterCtl.$inject = [
        '$interval',
        '$scope',
        '$window',
        '$location',
        '$q',
        '$translate',
        '$uibModal',
        'dmsRecycleBinUiService',
        'dmsFolderSelectionModalService',
        'confirmationModalService',
        'dmsFolderService',
        'dmsProjectService',
        'dmsApiOperationService',
        'operationAlertDisplayModalService',
        'dmsPermission',
        'utility'
    ];

    angular.module('onvio.documents').controller('recycleMaster', recycleMasterCtl);

})(window.angular);

(function(angular){
    'use strict';

    var searchMasterCtl = function(
        $scope,
        $window,
        $location,
        $translate,
        $state,
        dmsSearchGetSet) {

        var vm = this;

        $scope.gridControlContainer = {};

        var gridControl;

        var unwatchGridControl = $scope.$watch('gridControl', function(){
            if ($scope.gridControlContainer.control){
                gridControl = $scope.gridControlContainer.control;
                gridControl.refresh();
                unwatchGridControl();
            }
        });

        function createAllDocumentsPath() {
            return $translate('Onvio.Shell.Navigation.Documents').then(function(s){
                var item = {
                    icon: 'all-docs',
                    href: $state.href('allDocsRootList'),
                    text: s,
                };
                return item;
            });
        }

        function createClientDocumentsPath() {
            return $translate('Onvio.Shell.Navigation.ClientDocuments').then(function(s){
                var item = {
                    container: {
                        id: 'Client',
                        name: s,
                        isClientBranch: true,
                        itemType: 'ClientRoot'
                    },
                    href: $state.href('clientRootList'),
                    icon: 'client',
                    text: s,
                };
                return item;
            });
        }

        function createTemplatesPath() {
            return $translate('Bluemoon.DMS.SpecialFolders.Templates').then(function(s){
                var item = {
                    container: {
                        id: 'Templates',
                        name: s,
                        isTemplateBranch: true,
                        itemType: 'TemplateRoot'
                    },
                    href: $state.href('templateList'),
                    icon: 'templates',
                    text: s
                };
                return item;
            });
        }

        $scope.breadcrumbPathCallback = function(path) {
            if ($scope.item === undefined) {
                createAllDocumentsPath().then(function(res) {
                    path.unshift(res);
                });
            } else if ($scope.item.itemType === 'ClientsList') {
                createClientDocumentsPath().then(function(res) {
                    path.unshift(res);
                });
            } else if ($scope.item.itemType === 'TemplatesList') {
                createTemplatesPath().then(function(res) {
                    path.unshift(res);
                });
            }
        };

        // Setting table height. I think we'll do this another way
        // in the end.
        $scope.go = function(path){
            $location.path('/' + path);
        };

        $scope.item = dmsSearchGetSet.getSelectedItem();

        if ($scope.item !== undefined) {
            $scope.containerId = $scope.item.id;
            $scope.containerType = $scope.item.itemType;
        }

        var w = angular.element($window);

        $scope.getViewerHeight = function() {
            var grid = document.querySelector('#folder-grid');
            var top = 0;
            if(grid !== null && angular.isFunction(grid.getBoundingClientRect)){
                top = grid.getBoundingClientRect().top;
            }
            return w.height() - top - 75;
        };

        $scope.viewerHeight = $scope.getViewerHeight();

        $scope.$watch($scope.getViewerHeight, function(newValue) {
            $scope.viewerHeight = 'height: ' + newValue + 'px;';
        });

        w.bind('resize', function() {
            $scope.$apply();
        });

        $scope.$on('bmLanguageChangeSuccess', function(){
            vm._setupGrid();
        });

        var clearAlerts = function(){
            $scope.alerts = [];
        };

        //NOTE: Usually much more complicated, but this particular grid doesn't have any buttons
        vm._setupGrid = function(){
            clearAlerts();
        };

    };

    searchMasterCtl.$inject = [
        '$scope',
        '$window',
        '$location',
        '$translate',
        '$state',
        'dmsSearchGetSet',
    ];

    angular.module('onvio.documents').controller('searchMaster', searchMasterCtl);

})(window.angular);

(function(angular) {
    'use strict';

    var searchManager = function(dmsHttp, $q, ResponseData, SearchResultItem, projectManager, dmsCacheFactory, clientManager) {
        var factory = {};
        var foldersSearchMethod = 'search/folders';
        var documentsSearchMethod = 'search/documents';
        var searchText = '';
        var searchWithinResults = false;
        var pastResultHandler = '';
        var hadPastDocumentResults = true;
        var selectedItem = {};
        var self = this;
        var pastSearchTerms = [];

        factory._projectCache = dmsCacheFactory.create('projectManager.getProject');
        factory._clientCache = [];
        factory._clientKeywordMap = [];

        this.getProjectViaCache = function(projectId) {
            var cacheKey = projectId;
            var promise;

            var cachedValue = factory._projectCache.get(cacheKey);
            if (cachedValue) {
                promise = cachedValue;
            } else {
                promise = projectManager.getProject(projectId);
                factory._projectCache.put(cacheKey, promise);

                promise.then(function(){
                    factory._projectCache.setExpiration(cacheKey, 10000);
                });
            }

            return promise;
        };

        var buildNewestSearchTerms = function(search){
            var searchTermArr = search.split(' ');

            for (var i = 0; i < searchTermArr.length; i++){

                //if we've searched for this term before, no use pushing it again!
                if (pastSearchTerms.indexOf(searchTermArr[i]) === -1) {
                    pastSearchTerms.push(searchTermArr[i]);
                }
            }
        };

        factory.getClientSearchResults = function(){

            buildNewestSearchTerms(searchText);

            if (searchWithinResults){
                return factory._searchWithinClient();
            } else {
                return clientManager.getClientListViaSearch(searchText).then(function(result){
                    if (result === null || angular.isUndefined(result) || result.data === null || result.data.length === 0) {
                        //TODO: what should the status code be in this fail condition
                        //TODO: is returning 0 results a "failure", or perfectly valid?
                        return new ResponseData(window.successStatus, 404, null);
                    }

                    return factory._buildClientSearchRequestResponse(result.data);
                });
            }
        };

        factory._searchWithinClient = function(){
            var resultIds = factory._clientKeywordMap;
            var statusCode = 200;

            //Check the *newest* term, as we've already narrowed down once every time we've hit this code.
            var curTerm = pastSearchTerms[pastSearchTerms.length - 1].toLowerCase();
            var currentWordIds = factory._clientKeywordMap[curTerm];

            //if this search term isn't in the previous map, we're done right now -- no results.
            if (!currentWordIds){
                resultIds = [];
                return factory._buildSearchWithinClientsResult(resultIds, statusCode);
            }

            //Start the resultIds with "two terms" back, since that was the last "good" search;
            //We can then compare the newest search (1 back) with the previous search (2 back).
            //var previousTerm = pastSearchTerms[pastSearchTerms.length - 2].toLowerCase();
            //resultIds = factory._clientKeywordMap[previousTerm];

            //If this is the first pass we want to init the resultIds as such, with the first grouping of Client Ids.
            var foundAnyResult = false;

            var updatedResultIds = [];
            for (var key in resultIds) {
                for (var i = 0; i < resultIds[key].length; i++){
                    var curId = resultIds[key][i];
                    if (currentWordIds.indexOf(curId) !== -1 && updatedResultIds.indexOf(curId) === -1){
                        foundAnyResult = true;
                        updatedResultIds.push(curId);
                    }
                }
            }
            //Trim out any ids that didn't match in this pass
            resultIds = updatedResultIds;
            return factory._buildSearchWithinClientsResult(resultIds, statusCode);
        };

        factory._buildSearchWithinClientsResult = function(resultIds, statusCode) {
            var result = [];
            //Now that we have a list of valid resultIDs, let's actually make the results!
            factory._clientKeywordMap = []; //nuke the keyword map because we're gonna rebuild it
            for (var i = 0; i < resultIds.length; i++) {
                var curClient = factory._clientCache[resultIds[i]];

                result.push(curClient);
                factory._buildClientKeywordMap(curClient);
            }

            return new ResponseData(window.successStatus, statusCode, result);
        };

        factory.getDocumentSearchResults = function(searchCritera){

            return factory.getContainers(searchCritera).then(function(containers){

                //If we're trying to search within results, but the past search had NO results, let's just bail out now.
                if (containers[0] === 'noprojects' || (searchWithinResults && hadPastDocumentResults === false)){
                    return new ResponseData(window.successStatus, 0, []);
                }

                var dto, config;

                if (!searchWithinResults){
                    dto = { 'containers': containers, 'searchTerm': searchText };
                    config = dmsHttp.getAnonymousHttpPostConfig(documentsSearchMethod, JSON.stringify(dto));
                } else {
                    //use pastResultHandler, searchCriteria.searchText
                    dto = {
                      'searchTerm': searchText,
                      'searchResultHandle': pastResultHandler
                    };

                    config = dmsHttp.getAnonymousHttpPostConfig(documentsSearchMethod + '/search-within', JSON.stringify(dto));
                }

                config.timeout = 1000 * 60 * 15;

                return factory._makeDocumentSearchRequest(config);
            });
        };

        factory._makeDocumentSearchRequest = function(config){
            return dmsHttp.makeHttpRequest(config).then(function(data) {
                return factory._buildDocumentSearchRequestResponse(data);
            }, function(reason){
                return new ResponseData(window.errorStatus, reason.httpStatusCode, null, 'Unable to load documents for specified search.');
            });
        };

        factory._buildClientSearchRequestResponse = function(data){
            var filteredResults = [];
            for(var i = 0; i < data.length; i++){
                data[i].itemType = 'client';
                filteredResults.push(data[i]);
                //Push this result into the cache
                factory._clientCache[data[i].id] = data[i];
                factory._buildClientKeywordMap(data[i]);
            }
            return new ResponseData(window.successStatus, data.statusCode, filteredResults);
        };

        factory._buildClientKeywordMap = function(data){
            var nameWords = [];
            var codeWords = [];

            if (!!data && !!data.name){
                nameWords = data.name.split(' ');
            }

            if (!!data && !!data.code){
                codeWords = data.code.split(' ');
            }

            var result = nameWords.concat(codeWords);

            for (var i = 0; i < result.length; i++){
                //Strip out any non-letter/number characters from each word
                var curWord = result[i].replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase();

                //If nothing has been pushed before, make a new array
                if (!factory._clientKeywordMap[curWord]){
                    factory._clientKeywordMap[curWord] = [];
                }
                //Ensure we only push each ID to that keyword map once. No use having redundancies.
                if (factory._clientKeywordMap[curWord].indexOf(data.id) === -1) {
                    factory._clientKeywordMap[curWord].push(data.id);
                }
            }
        };

        factory._buildDocumentSearchRequestResponse = function(data){
            //If there are any results, lets push them into a response.
            if (!!data && !!data.data && !!data.data.documents && data.data.documents.length !== 0) {
                var filteredResults = [];
                var promises = [];
                pastResultHandler = data.data.resultHandle;

                for(var counter = 0; counter < data.data.documents.length; counter++){
                    if (data.data.documents[counter].isObjectNotFound === true) { continue; }

                    //If this document was found underneath a project at ANY point, we need to get its Client
                    /* jshint ignore:start */
                    var topContainer = data.data.documents[counter].containers[0].containerPath[0];

                    //If this document was found underneath a project at ANY point, we need to get its Client
                    promises.push(factory.updateContainerPath(topContainer, data.data.documents[counter]).then(function(document)
                    {
                        filteredResults.push(new SearchResultItem(document, searchText));
                    }));
                    /* jshint ignore:end */
                }
                //TODO: check that statusCode is right -- is it HttpStatusCode?
                return $q.all(promises).then(function()
                {
                    hadPastDocumentResults = true;
                    return new ResponseData(window.successStatus, data.statusCode, filteredResults);
                });
            } else {
                hadPastDocumentResults = false;

                // TODO: NEED TRANSLATION
                if (!data || !data.data || !data.data.documents) {
                    return new ResponseData(window.errorStatus, data.statusCode, null, 'Unable to load documents for specified search.');
                }

                if (data.data.documents.length === 0){
                    //TODO: is returning 0 documents successful or an error?
                    return new ResponseData(window.successStatus, data.statusCode, null);
                }
            }
        };

        factory.updateContainerPath = function(topContainer, document)
        {
            var deferred = $q.defer();
            if (topContainer.containerType === 'projects'){
                var clientId;

                self.getProjectViaCache(topContainer.containerId).then(function(results){
                    clientId = results.data.primaryAssociationId;
                    if (clientId !== 'Templates'){
                        var clientContainer = { 'containerId' : clientId, 'containerType' : 'clients', 'containerName' : results.data.primaryAssociationName };
                        document.containers[0].containerPath.unshift(clientContainer);
                    } else {
                        var templateContainer = { 'containerId' : 'Templates', 'containerType' : 'templates', 'containerName' : '|templates|' };
                        document.containers[0].containerPath.unshift(templateContainer);
                    }
                    deferred.resolve(document);
                }, function() {
                        deferred.resolve(document);
                    });
            } else {
                deferred.resolve(document);
            }

            return deferred.promise;
        };

        factory.getContainers = function(searchCritera)
        {
            var deferred = $q.defer();
            var containers = [];
            deferred.notify();
            if (angular.isUndefined(searchCritera.selectedItem)){
                deferred.resolve(containers);
            } else {
                switch(searchCritera.selectedItem.itemType)
                {
                case 'Folder':
                    containers.push({ 'containerId' : selectedItem.id, 'containerType' : 'folders' });
                    deferred.resolve(containers);
                    break;
                case 'Project':
                    containers.push({ 'containerId' : selectedItem.id, 'containerType' : 'projects' });
                    deferred.resolve(containers);
                    break;
                case 'TemplatesList':
                    var params = {
                        primaryAssociationId: 'Templates',
                        primaryAssociationType: 'Firm',
                        productType: 'DMSClientFolder' //TODO -- make more dynamic
                    };
                    //need to get all templates and push it into the containers array
                    projectManager.getProjectListWithConfigurationParameters(params).then(function(projects)
                        {
                            if (angular.isArray(projects.data))
                            { containers = window._.map(projects.data, function(project) { if (angular.isDefined(project.itemType && project.itemType === 'Project')) { return { 'containerId' : project.id, 'containerType' : 'projects', 'parentId': 'Templates' }; }}); } else { containers.push('noprojects'); }
                            deferred.resolve(containers);
                        });
                    break;
                case 'Client':
                case 'ClientsList':
                    //need to get all projects for the client and push it into the containers array
                    projectManager.getProjectList(selectedItem.id).then(function(projects)
                        {
                            if (angular.isArray(projects.data))
                            { containers = window._.map(projects.data, function(project) { if (angular.isDefined(project.itemType && project.itemType === 'Project')) { return { 'containerId' : project.id, 'containerType' : 'projects', 'parentId': project.primaryAssociationId }; }}); } else { containers.push('noprojects'); }
                            deferred.resolve(containers);
                        });
                    break;
                default:
                    deferred.resolve(containers);
                }
            }
            return deferred.promise;
        };

        factory.getFolderSearchResults = function(folderId, searchText){
            var dto = { folderId: folderId, searchTerm: searchText };
            var config = dmsHttp.getAnonymousHttpPostConfig(foldersSearchMethod, JSON.stringify(dto));
            return dmsHttp.makeHttpRequest(config).then(function(data){
                if(data !== null && angular.isDefined(data) && data.data !== null && data.data.folders !== null){
                    var filteredResults = [];
                    for(var counter = 0; counter < data.data.folders.length; counter++){
                        if (data.data.folders[counter].isObjectNotFound === true) { continue; }
                        filteredResults.push(new SearchResultItem(data.data.folders[counter], searchText));
                    }

                    return new ResponseData(window.successStatus, data.statusCode, filteredResults, null);
                }

                // TODO: NEED A REAL ERROR MESSAGE HERE PLUS TRANSLATION
                return new ResponseData(window.errorStatus, data.statusCode, null, 'Unable to load folders for specified search.');
            }, function(reason){
                //TODO: check that statusCode is right -- is it HttpStatusCode?
                return new ResponseData(window.errorStatus, reason.statusCode, null, reason.msg);
            });
        };

        factory.getAggregatedSearchResults = function(searchCritera){
            var promises = [];

            if (searchCritera.selectedItem === undefined || searchCritera.selectedItem.itemType === 'ClientsList'){
                promises.push(factory.getClientSearchResults());
            }
            promises.push(factory.getDocumentSearchResults(searchCritera));

            return $q.all(promises).then(function(results){
                var aggregatedData = [];
                var resStatus = window.successStatus;
                // just returning a statusCode of 200 for now. aggregatedData is an array of responseData.
                var resCode   = 200;

                angular.forEach(results, function(result){
                    if (result.data){
                        aggregatedData = aggregatedData.concat(result.data);
                    }
                    //If there was no data, there was a problem, so lets pass that problem along.
                    if (result.status !== window.successStatus){
                        resStatus = window.errorStatus;
                        resCode = result.httpStatusCode;
                    }
                });

                return new ResponseData(resStatus, resCode, aggregatedData);
            });
        };

        factory.setSearchCriteria = function(text, item, withinResults)
        {

            if (withinResults !== null && withinResults === true){
                searchWithinResults = withinResults;
                //cache the previously used term
                buildNewestSearchTerms(text);
            } else {
                searchWithinResults = false;
                pastSearchTerms = [];
            }

            searchText = text;
            selectedItem = item;
        };

        factory.getSearchCriteria = function()
        {
            return { 'searchText' :searchText,
                     'selectedItem' : selectedItem,
                     'searchWithinResults' : searchWithinResults };
        };

        return factory;
    };

    searchManager.$inject = ['dmsHttp', '$q', 'ResponseData', 'SearchResultItem','projectManager', 'dmsCacheFactory', 'clientManager'];
    angular.module('onvio.documents').factory('searchManager', searchManager);
})(window.angular);

(function(angular){
    'use strict';

    var searchResultItem = function($window, formatSizeService, folderManager){

        var setResultPropertiesFromFolder = function(base, folderData){
            base.id = folderData.folderId;

            // TODO: THIS SHOULD REALLY BE DONE ON THE SERVER
            if(base.searchText !== null && angular.isDefined(base.searchText)){
                var re = new RegExp('(' + base.searchText + ')', 'gi');
                base.name = folderData.folderName.replace(re, '<span class="co_searchTerm">$1</span>');
            } else {
                base.name = folderData.folderName;
            }

            base.itemType = 'folder';
            base.snippet = '';
            base.modifiedDate = folderData.createdDate || folderData.modifiedDate;
            base.fileSize = '';
            base.mimeType = '';

            // TODO: THIS SHOULD REALLY BE DONE ON THE SERVER
            var folderWithParents = folderManager.getCachedFolderWithParentTree(folderData.folderId);
            base.containerPath = [];

            if(angular.isUndefined(folderWithParents) || angular.isUndefined(folderWithParents.parentTree) || folderWithParents.parentTree.length === 0){
                base.containerId = '';
            } else {
                base.containerId = folderWithParents.parentTree[folderWithParents.parentTree.length - 1].id;

                for(var counter = 0; counter < folderWithParents.parentTree.length; counter++){
                    base.containerPath.push({ containerId: folderWithParents.parentTree[counter].id, containerName: folderWithParents.parentTree[counter].name });
                }
            }
        };

        var setResultPropertiesFromDocument = function(base, documentData){
            base.itemSize = documentData.itemMetadata.itemSize;

            base.id = documentData.guid;
            base.name = documentData.itemMetadata.name;
            base.itemType = documentData.itemMetadata.fileType;
            if(documentData.itemMetadata.lock){
                base.lock = documentData.itemMetadata.lock;
            }
            base.snippet = (documentData.snippets !== null && documentData.snippets.length > 0) ? documentData.snippets[0].snippetText : '';
            base.containerId =  (documentData.containers.length > 0) ? documentData.containers[0].containerId : null;
            base.containerPath = (documentData.containers.length > 0 && angular.isDefined(documentData.containers[0].containerPath)) ? documentData.containers[0].containerPath : [];
            base.modifiedDate = documentData.itemMetadata.createdDate;

            base.mimeType = documentData.itemMetadata.mimeType;
        };

        function SearchResultItem(restData, searchText){
            if(restData === null){
                return {};
            }

            this.searchText = searchText;

            // Folder or document
            return angular.isDefined(restData.folderId) ? setResultPropertiesFromFolder(this, restData) : setResultPropertiesFromDocument(this, restData);
        }

        SearchResultItem.prototype = {
            getFirstName: function() {
                return this.firstName;
            }
        };

        return SearchResultItem;
    };

    searchResultItem.$inject = ['$window', 'formatSizeService', 'folderManager'];
    angular.module('onvio.documents').factory('SearchResultItem', searchResultItem);
})(window.angular);

(function(window, angular){
    'use strict';

    var renameProject = function($scope, $uibModalInstance, $q, $translate, projectManager, selectedProject, Project, systemConstants, ProjectValidation, utility){

        $scope.renameProjectData = {};

        var loadStrings = function(){

            var defer = $q.defer();

            $q.all([
                $translate('Bluemoon.DMS.Modal.Rename.Header'),
                $translate('Bluemoon.DMS.Modal.Rename.NameText'),
                $translate('Bluemoon.DMS.Modal.Rename.RequiredText'),
                $translate('Bluemoon.DMS.Modal.Rename.RenameButtonText'),
                $translate('Bluemoon.DMS.Modal.Rename.CancelButtonText'),
                $translate('Bluemoon.DMS.Modal.Rename.NameAlreadyExists'),
                $translate('Bluemoon.DMS.OperationForbidden'),
                $translate('Bluemoon.DMS.Modal.Rename.UnknownError'),
            ]).then(function(s){
                defer.resolve({
                    'Bluemoon.DMS.Modal.Rename.Header'                              : s[0],
                    'Bluemoon.DMS.Modal.Rename.NameText'                            : s[1],
                    'Bluemoon.DMS.Modal.Rename.RequiredText'                        : s[2],
                    'Bluemoon.DMS.Modal.Rename.RenameButtonText'                    : s[3],
                    'Bluemoon.DMS.Modal.Rename.CancelButtonText'                    : s[4],
                    'Bluemoon.DMS.Modal.Rename.NameAlreadyExists'                   : s[5],
                    'Bluemoon.DMS.OperationForbidden'                               : s[6],
                    'Bluemoon.DMS.Modal.Rename.UnknownError'                        : s[7],
                });
            });

            return defer.promise;
        };

        loadStrings().then(function(translations){

            var _configObject = function() {
                return {
                    headerText:         translations['Bluemoon.DMS.Modal.Rename.Header'],
                    nameText:           translations['Bluemoon.DMS.Modal.Rename.NameText'],
                    requiredText:       translations['Bluemoon.DMS.Modal.Rename.RequiredText'],
                    renameButtonText:   translations['Bluemoon.DMS.Modal.Rename.RenameButtonText'],
                    cancelButtonText:   translations['Bluemoon.DMS.Modal.Rename.CancelButtonText'],
                    fieldAlreadyExists: translations['Bluemoon.DMS.Modal.Rename.NameAlreadyExists'],
                    operationForbidden: translations['Bluemoon.DMS.OperationForbidden'],
                    unknownError:       translations['Bluemoon.DMS.Modal.Rename.UnknownError'],
                };
            };

            var config = _configObject();

            $scope.headerText = config.headerText;
            $scope.nameText = config.nameText;
            $scope.requiredText = config.requiredText;
            $scope.renameButtonText = config.renameButtonText;
            $scope.cancelButtonText = config.cancelButtonText;

            $scope.renameProjectData.resetValidation = function(){
                $scope.renameProjectData.alerts = [];
                $scope.renameProjectData.projectNameError = '';
            };

            $scope.validateData = function() {
                $scope.renameProjectData.resetValidation();

                var noError = false;
                var defered = $q.defer();

                ProjectValidation.validateProjectName($scope.renameProjectData.projectName).then(function(errorMessage){
                    if (errorMessage && errorMessage !== ''){
                        $scope.renameProjectData.projectNameError = errorMessage;
                    }
                    noError = !$scope.renameProjectData.projectNameError || $scope.renameProjectData.projectNameError.length === 0;
                    defered.resolve(noError);
                });
                return defered.promise;
            };

            $scope.renameProjectRequest = function(){

                $scope.validateData().then(function(res){
                    if (!res) { return; }

                    var projectName = $scope.renameProjectData.projectName;

                    // if user didn't change name, then just close gracefully
                    if (projectName === selectedProject.name){
                        $scope.cancelRenameProject();
                        return ;
                    }

                    var projectToRename = new Project();
                    projectToRename.name                        = projectName;
                    projectToRename.id                          = selectedProject.id;
                    projectToRename.productType                 = selectedProject.productType;
                    projectToRename.processingYear              = selectedProject.processingYear;
                    projectToRename.primaryAssociationId        = selectedProject.primaryAssociationId;
                    projectToRename.primaryAssociationName      = selectedProject.primaryAssociationName;
                    projectToRename.primaryAssociationType      = selectedProject.primaryAssociationType;

                    projectManager.updateProject(projectToRename).then(function(result) {
                        $scope.closeModalAction(result.data);
                    }, function(reason) {
                        if (utility.isConflictCode(reason.httpStatusCode)) {
                            $scope.renameProjectData.projectNameError = config.fieldAlreadyExists;
                        } else if (utility.isForbiddenCode(reason.httpStatusCode)) {
                            $scope.renameProjectData.projectNameError = config.operationForbidden;
                        } else {
                            $scope.renameProjectData.projectNameError = config.unknownError;
                        }
                    });
                });
            };

            $scope.closeModalAction = function(updatedProjectName){
                $uibModalInstance.close(updatedProjectName);
            };

            $scope.cancelRenameProject = function(){
                $uibModalInstance.dismiss('cancelled');
            };

            $scope.renameProjectData.canRename = true;
            $scope.renameProjectData.projectName = selectedProject.name;

            //NOTE: the below should never happen due to only being triggered from the Storage-Master-Controller
            //and specifically when a folder is clicked.
            $scope.renameProjectData.hasSelectedProject = (selectedProject !== null && angular.isDefined(selectedProject));
            $scope.renameProjectData.resetValidation();

            if (!$scope.renameProjectData.hasSelectedProject) {
                $scope.renameProjectData.canRename = false;
            }

            $scope.renameProjectData.maxProjectNameLength = systemConstants.maxFolderNameLength;
        });
    };

    renameProject.$inject = ['$scope', '$uibModalInstance', '$q', '$translate', 'projectManager', 'selectedProject', 'Project', 'systemConstants', 'ProjectValidation', 'utility'];
    angular.module('onvio.documents').controller('renameProject', renameProject);
})(window, window.angular, window.Project);

(function(angular, _){
    'use strict';

    var storageMaster = function(
        $scope,
        $stateParams,
        $state,
        $uibModal,
        $window,
        $location,
        $q,
        $interval,
        $translate,
        utility,
        Project,
        projectUiService,
        clientManager,
        searchManager,
        dmsUploadService,
        operationAlertDisplayModalService,
        uploadAlertDisplayModalService,
        DmsAlertCollectionModel,
        dmsAlertService,
        dmsApiOperationConstants,
        DmsApiOperationCollectionModel,
        dmsApiOperationService,
        UiService,
        dmsModalUiService,
        dmsSearchGetSet) {

        var vm = this;

        var mainGridHandler;

        // Setting table height. I think we'll do this another way
        // in the end.
        $scope.go = function(path){
            $location.path('/' + path);
        };

        //TODO: clean
        var w = angular.element($window);

        $scope.getViewerHeight = function() {
            var grid = document.querySelector('#folder-grid');
            var top = 0;
            if(grid !== null && angular.isFunction(grid.getBoundingClientRect)){
                top = grid.getBoundingClientRect().top;
            }
            return w.height() - top - 75;
        };

        $scope.viewerHeight = $scope.getViewerHeight();

        $scope.$watch($scope.getViewerHeight, function(newValue) {
            $scope.viewerHeight = 'height: ' + newValue + 'px;';
        });

        w.bind('resize', function() {
            $scope.$apply();
        });

        $scope.openAddFolderModal = function() {
            dmsModalUiService.addFolder({
                scope: $scope,
                busily: true,
                addOperation: true,
                parentContainerId: $scope.client.id,
                parentContainerType: 'Client'
            });
        };

        $scope.openRenameModal = function() {
            if ($scope.selectedGridItems && $scope.selectedGridItems.length === 1) {

                var templateUrl;
                var controller;
                var resolve;
                var itemToRename = $scope.selectedGridItems[0];
                if (itemToRename.itemType === 'Folder'){
                    templateUrl = 'documents/folders/actions/renamefolder/rename-folder-modal.2js.html';
                    controller = 'renameFolder';
                    resolve = {
                        'selectedFolder': function() {
                            return itemToRename;
                        }
                    };
                } else {
                    templateUrl = 'documents/storage/actions/renameproject/rename-project-modal.2js.html';
                    controller = 'renameProject';
                    resolve = {
                        'selectedProject': function() {
                            return itemToRename;
                        },
                    };
                }

                var modalInstance = $uibModal.open({
                    templateUrl: templateUrl,
                    controller: controller,
                    backdrop: 'static',
                    resolve: resolve
                });

                modalInstance.result.then(function() {
                    mainGridHandler.refreshGrid();
                });
            }
        };

        $scope.openDeleteProjectModal = function(){
            dmsModalUiService.deleteItems($scope.selectedGridItems);
        };

        $scope.openShareProjectModal = function(){
            var modalInstance = $uibModal.open({
                templateUrl: 'documents/folders/actions/sharefolder/share-folder-modal.2js.html',
                controller: 'shareFolder',
                backdrop: 'static',
                //size: 'sm',
                resolve: {
                    clientId: function(){
                        return $scope.clientId;
                    },
                    containerType: function(){
                        return 'projects';
                    },
                    selectedItem: function(){
                        //NOTE: should always only be one item
                        return $scope.selectedGridItems[0];
                    },
                }
            });

            //Refresh right into this item
            modalInstance.result.then(function() {
                mainGridHandler.refreshGrid();
            });
        };

        $scope.openEditProjectModal = function(){
            var modalInstance = $uibModal.open({
                templateUrl: 'documents/storage/actions/editproject/edit-project-modal.2js.html',
                controller: 'editProject',
                backdrop: 'static',
                size: 'sm',
                resolve: {
                    editItem: function(){
                        return $scope.selectedGridItems;
                    }
                }
            });

            //Refresh right into this item
            modalInstance.result.then(function() {
                mainGridHandler.refreshGrid();
            });
        };

        $scope.openUploadAlertDisplayModal = function() {
            if ($scope.totalUploads.totalFiles > 0) {
                uploadAlertDisplayModalService.open({ uploadCollection: $scope.uploads })
                    .then(function(uploadAlertDisplayModalInstance) {
                        if (uploadAlertDisplayModalInstance) {
                            $scope.dialogOpen = true;
                            uploadAlertDisplayModalInstance.result.then(function() {
                                $scope.dialogOpen = false;
                            });
                        }

                        var unregisterTotalFilesWatch = $scope.$watch('totalUploads.totalFiles', function(newValue) {
                            if (newValue === 0) {
                                uploadAlertDisplayModalInstance.close();
                                unregisterTotalFilesWatch();
                            }
                        });
                    });
            }
        };

        $scope.uploadPercentage = function(upload){
            return (100 * (upload.loaded / upload.total)).toFixed(1);
        };

        $scope.closeAlert = function(upload){
            dmsUploadService.dismissUpload(upload.key);
        };

        $scope.openOperationAlertDisplayModal = function() {
            if ($scope.operations.length > 0) {
                operationAlertDisplayModalService.open({ dmsOperationCollectionModel: $scope.operations })
                    .then(function(operationAlertDisplayModalInstance) {
                        var unregisterOperationsLengthWatch = $scope.$watch('operations.length', function(newValue) {
                            if (newValue === 0) {
                                operationAlertDisplayModalInstance.close();
                                unregisterOperationsLengthWatch();
                            }
                        });

                        if (operationAlertDisplayModalInstance) {
                            $scope.dialogOpen = true;
                            operationAlertDisplayModalInstance.result.then(function() {
                                unregisterOperationsLengthWatch();
                                $scope.dialogOpen = false;
                            });
                        }
                    });
            }
        };

        $scope.getFirstUpload = function() {
            var uploadKeys = Object.keys(dmsUploadService.uploads);
            if (uploadKeys.length > 0) {
                return dmsUploadService.uploads[_.sortBy(uploadKeys, function(key) {
                    return key.substr(key.lastIndexOf('|') + 1);
                }).reverse()[0]];
            }
        };

        var clearPageAlerts = function(){
            $scope.alerts = [];
        };

        vm._setupGrid = function() {
            $scope.buttons = [];

            $scope.gridOptions = {
                showColumnMenu : false,
                showGroupPanel : false,
                showSelectionCheckbox: false,
                sortInfo: { fields: ['name'], directions: ['asc'] }
            };
        };

        $scope.processSearch = function(term){
            //TODO: set up some method of searching Storage
            if (term === undefined) { return; }
            searchManager.setSearchCriteria(term,$scope.selectedItem);
            dmsSearchGetSet.setSearchTerm(term);
            dmsSearchGetSet.setSelectedItem($scope.selectedItem);
            $state.go('documentSearchResults');
        };

        $scope.$on('bmLanguageChangeSuccess', function(){
            vm._setupGrid();
        });

        $scope.$on('dmsProjectAdded', function(){
            mainGridHandler.refreshGrid();
        });

        var operationsOfBatchComplete = 0;
        $scope.$on('dms-operation-complete', function(event, operationModel) {
            switch (operationModel.type) {
                case 'move':
                case 'copy':
                case 'add':
                case 'delete':
                    operationsOfBatchComplete++;
                    if (operationsOfBatchComplete % 5 === 0) {
                        mainGridHandler.refreshGrid();
                    }
                    break;
            }

            $interval(function(){
                $scope.operations.remove(operationModel);
            }, 10000, 1);
        });

        $scope.$on('dms-operation-batch-complete', function(){
            if (operationsOfBatchComplete % 5 !== 0) {
                mainGridHandler.refreshGrid();
            }

            if (dmsApiOperationService.currentBatch.error === 0) {

                $interval(function(){
                    if (!dmsApiOperationService.operationQueue.isProcessing()) {
                        dmsApiOperationService.clearBatch();
                    }
                }, 10000, 1);
            }

            operationsOfBatchComplete = 0;
        });

        mainGridHandler = {
            getGridItems : function() {},
            refreshGrid : function(){
                this.getGridItems().then(function(result){
                    $scope.selectedGridItems.length = 0;
                    $scope.gridItems = result.data;
                    $scope.refreshInProgress = true;
                    for (var i = 0; i < $scope.gridItems.length; i++){
                        $scope.gridItems[i].link = $state.href('projectRootList', { clientId : $scope.clientId, projectId : $scope.gridItems[i].id });
                    }
                });
            }
        };

        $scope.refreshInProgress = false;

        var getProjectList = function(clientId) {
            return projectUiService.getProjectList({
                scope: $scope,
                params: {
                    clientId: clientId
                }
            });
        };

        var methodMap = {
            initialize : function() {
                $scope.selectedGridItems = [];
                $scope.alerts = [];
                $scope.myRoot = 'Clients';
                $scope.totalUploads = dmsUploadService.totalProgress;
                $scope.uploads = dmsUploadService.uploads;
                $scope.operations = dmsApiOperationService.operations;
                $scope.operationBatch = dmsApiOperationService.currentBatch;
                $scope.collapseLength = 4;
            },
            preExecute : function() {
                clearPageAlerts();
                vm._setupGrid();
            },
            postExecute: function(){
                mainGridHandler.refreshGrid();
            },
            execute : function()
            {
                this.initialize();
                var toExecute = methodMap[$state.current.name];
                if (angular.isFunction(toExecute))
                {
                    this.preExecute();
                    toExecute();
                    this.postExecute();
                }
            },
            clientStorageList : function() {
                mainGridHandler.getGridItems = function(){
                    $scope.clientId = $stateParams.clientId;
                    $scope.selectedItem = {'id' : $scope.clientId, 'itemType' : 'Client'};

                    $scope.containerId = $scope.clientId;
                    $scope.containerItemType = 'Client';

                    return getProjectList($scope.clientId);
                };
            },
        };

        methodMap.execute();
    };

    storageMaster.$inject = [
        '$scope',
        '$stateParams',
        '$state',
        '$uibModal',
        '$window',
        '$location',
        '$q',
        '$interval',
        '$translate',
        'utility',
        'Project',
        'projectUiService',
        'clientManager',
        'searchManager',
        'dmsUploadService',
        'operationAlertDisplayModalService',
        'uploadAlertDisplayModalService',
        'DmsAlertCollectionModel',
        'dmsAlertService',
        'dmsApiOperationConstants',
        'DmsApiOperationCollectionModel',
        'dmsApiOperationService',
        'UiService',
        'dmsModalUiService',
        'dmsSearchGetSet'
    ];
    angular.module('onvio.documents').controller('storageMaster', storageMaster);
})(window.angular, window._);

(function(angular, _){
    'use strict';

    var templateMaster = function(
        $scope,
        $stateParams,
        $state,
        $uibModal,
        $window,
        $location,
        $q,
        $interval,
        $translate,
        utility,
        searchManager,
        dmsUploadService,
        operationAlertDisplayModalService,
        uploadAlertDisplayModalService,
        DmsAlertCollectionModel,
        dmsAlertService,
        dmsApiOperationConstants,
        DmsApiOperationCollectionModel,
        dmsApiOperationService,
        dmsModalUiService,
        dmsProjectUiService) {

        var vm = this;

        // Setting table height. I think we'll do this another way
        // in the end.
        $scope.go = function(path){
            $location.path('/' + path);
        };

        //TODO: clean
        var w = angular.element($window);

        $scope.getViewerHeight = function() {
            var grid = document.querySelector('#folder-grid');
            var top = 0;
            if(grid !== null && angular.isFunction(grid.getBoundingClientRect)){
                top = grid.getBoundingClientRect().top;
            }
            return w.height() - top - 75;
        };

        $scope.viewerHeight = $scope.getViewerHeight();

        $scope.$watch($scope.getViewerHeight, function(newValue) {
            $scope.viewerHeight = 'height: ' + newValue + 'px;';
        });

        w.bind('resize', function() {
            $scope.$apply();
        });

        $scope.openAddTemplateModal = function() {
            dmsModalUiService.addTemplate({
                scope: $scope,
                busily: true,
                addOperation: true,
                parentContainerId:   'Templates',
                parentContainerType: 'Firm',
                productType:         'DMSClientFolder' //TODO: make more dynamic
            });
        };

        $scope.openRenameModal = function() {
            if ($scope.selectedGridItems && $scope.selectedGridItems.length === 1) {

                var templateUrl;
                var controller;
                var resolve;
                var itemToRename = $scope.selectedGridItems[0];
                //TODO: clean? this might never happen
                if (itemToRename.itemType === 'Folder'){
                    templateUrl = 'documents/folders/actions/renamefolder/rename-folder-modal.2js.html';
                    controller = 'renameFolder';
                    resolve = {
                        'selectedFolder': function() {
                            return itemToRename;
                        }
                    };
                } else {
                    templateUrl = 'documents/storage/actions/renameproject/rename-project-modal.2js.html';
                    controller = 'renameProject';
                    resolve = {
                        'selectedProject': function() {
                            return itemToRename;
                        },
                    };
                }

                var modalInstance = $uibModal.open({
                    templateUrl: templateUrl,
                    controller: controller,
                    backdrop: 'static',
                    resolve: resolve
                });

                modalInstance.result.then(function() {
                    vm._refreshGrid();
                });
            }
        };

        $scope.openDeleteProjectModal = function(){
            dmsModalUiService.deleteItems($scope.selectedGridItems);
        };

        $scope.openUploadAlertDisplayModal = function() {
            if ($scope.totalUploads.totalFiles > 0) {
                uploadAlertDisplayModalService.open({ uploadCollection: $scope.uploads })
                    .then(function(uploadAlertDisplayModalInstance) {
                        if (uploadAlertDisplayModalInstance) {
                            $scope.dialogOpen = true;
                            uploadAlertDisplayModalInstance.result.then(function() {
                                $scope.dialogOpen = false;
                            });
                        }

                        var unregisterTotalFilesWatch = $scope.$watch('totalUploads.totalFiles', function(newValue) {
                            if (newValue === 0) {
                                uploadAlertDisplayModalInstance.close();
                                unregisterTotalFilesWatch();
                            }
                        });
                    });
            }
        };

        $scope.uploadPercentage = function(upload){
            return (100 * (upload.loaded / upload.total)).toFixed(1);
        };

        $scope.closeAlert = function(upload){
            dmsUploadService.dismissUpload(upload.key);
        };

        $scope.openOperationAlertDisplayModal = function() {
            if ($scope.operations.length > 0) {
                operationAlertDisplayModalService.open({ dmsOperationCollectionModel: $scope.operations })
                    .then(function(operationAlertDisplayModalInstance) {
                        var unregisterOperationsLengthWatch = $scope.$watch('operations.length', function(newValue) {
                            if (newValue === 0) {
                                operationAlertDisplayModalInstance.close();
                                unregisterOperationsLengthWatch();
                            }
                        });

                        if (operationAlertDisplayModalInstance) {
                            $scope.dialogOpen = true;
                            operationAlertDisplayModalInstance.result.then(function() {
                                unregisterOperationsLengthWatch();
                                $scope.dialogOpen = false;
                            });
                        }
                    });
            }
        };

        $scope.getFirstUpload = function() {
            var uploadKeys = Object.keys(dmsUploadService.uploads);
            if (uploadKeys.length > 0) {
                return dmsUploadService.uploads[_.sortBy(uploadKeys, function(key) {
                    return key.substr(key.lastIndexOf('|') + 1);
                }).reverse()[0]];
            }
        };

        var clearPageAlerts = function(){
            $scope.alerts = [];
        };

        vm._loadToolbarStrings = function(){
            var deferred = $q.defer();

            $q.all([
                $translate('Bluemoon.DMS.Toolbar.TemplateGrid.NewTemplate'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.Manage'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.Rename'),
                $translate('Bluemoon.DMS.Toolbar.FolderGrid.Delete'),
            ]).then(function(s){
                deferred.resolve({
                    'Bluemoon.DMS.Toolbar.TemplateGrid.NewTemplate'                     : s[0],
                    'Bluemoon.DMS.Toolbar.FolderGrid.Manage'                            : s[1],
                    'Bluemoon.DMS.Toolbar.FolderGrid.Rename'                            : s[2],
                    'Bluemoon.DMS.Toolbar.FolderGrid.Delete'                            : s[3],
                });
            });

            return deferred.promise;
        };

        var loadBreadcrumbStrings = function(){

            var defer = $q.defer();

            $q.all([
                $translate('Bluemoon.DMS.SpecialFolders.Templates'),
                $translate('Bluemoon.DMS.Breadcrumbs.Documents'),
            ]).then(function(s){
                defer.resolve({
                    'Bluemoon.DMS.SpecialFolders.Templates'                   : s[0],
                    'Bluemoon.DMS.Breadcrumbs.Documents'                      : s[1],
                });
            });

            return defer.promise;
        };

        vm.setBreadCrumbList = function(){
            $scope.breadCrumbList = [];

            loadBreadcrumbStrings().then(function(/*translations*/){

                /*var _configObject = function() {
                    return {
                        templatesText:         translations['Bluemoon.DMS.SpecialFolders.Templates'],
                        docsText:            translations['Bluemoon.DMS.Breadcrumbs.Documents'],
                    };
                };*/

                //var config = _configObject();

                //$scope.breadCrumbList.push(new DmsBreadCrumbModel(config.docsText, $state.href('allDocsRootList'), false, null));
                //$scope.breadCrumbList.push(new DmsBreadCrumbModel(config.templatesText, $state.href('allDocsRootList'), false, null));
            });
        };

        vm._setupGrid = function() {

            vm._loadToolbarStrings().then(function(translations){

                $scope.buttons =
                [
                    {
                        text: translations['Bluemoon.DMS.Toolbar.TemplateGrid.NewTemplate'],
                        icon: 'glyphicon-plus-sign',
                        click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openAddTemplateModal),
                        isEnabled: true
                    },
                    {
                        text: translations['Bluemoon.DMS.Toolbar.FolderGrid.Manage'],
                        moreButtons:
                        [
                            {
                                text: translations['Bluemoon.DMS.Toolbar.FolderGrid.Rename'],
                                icon: 'glyphicon-pencil',
                                click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openRenameModal),
                                isEnabled: utility.ToolBar.ifOnlyOneSelected
                            },
                            {
                                text: translations['Bluemoon.DMS.Toolbar.FolderGrid.Delete'],
                                icon: 'glyphicon-remove',
                                click: utility.ToolBar.buttonClick($scope.selectedGridItems, $scope.openDeleteProjectModal),
                                isEnabled: utility.ToolBar.ifAtLeastOneSelected
                            },
                        ],
                    }
                ];

                $scope.gridOptions = {
                    showColumnMenu : false,
                    showGroupPanel : false
                };
            });
        };

        $scope.processSearch = function(term){
            //TODO: set up some method of searching Storage
            if (term === undefined) { return; }
            searchManager.setSearchCriteria(term, $scope.selectedItem);
            $state.go('documentSearchResults');
        };

        var operationsOfBatchComplete = 0;

        $scope.$on('dms-operation-complete', function(event, operationModel) {
            switch (operationModel.type) {
            case 'move':
            case 'copy':
            case 'add':
            case 'delete':
                operationsOfBatchComplete++;
                if (operationsOfBatchComplete % 5 === 0) {
                    vm._refreshGrid();
                }
                break;
            }

            $interval(function(){
                $scope.operations.remove(operationModel);
            }, 10000, 1);
        });

        $scope.$on('dms-operation-batch-complete', function(){
            if (operationsOfBatchComplete % 5 !== 0) {
                vm._refreshGrid();
            }

            if (dmsApiOperationService.currentBatch.error === 0) {

                $interval(function(){
                    if (!dmsApiOperationService.operationQueue.isProcessing()) {
                        dmsApiOperationService.clearBatch();
                    }
                }, 10000, 1);
            }

            operationsOfBatchComplete = 0;
        });

        $scope.$on('bmLanguageChangeSuccess', function(){
            vm._setupGrid();
        });

        vm._getGridItems = function() {};
        vm._refreshGrid = function(){
            vm._getGridItems().then(function(result){
                $scope.selectedGridItems.length = 0;
                $scope.gridItems = result.data;
                $scope.refreshInProgress = true;
                for (var i = 0; i < $scope.gridItems.length; i++){
                    $scope.gridItems[i].link = $state.href('templateRootList', { templateId : $scope.gridItems[i].id });
                }
            });
        };

        $scope.refreshInProgress = false;

        vm._getTemplateList = function() {
            return dmsProjectUiService.getTemplateList({
                scope: $scope,
                params: {
                    primaryAssociationId: 'Templates',
                    primaryAssociationType: 'Firm',
                    productType: 'DMSClientFolder' //TODO -- make more dynamic
                }
            });
        };
        var methodMap = {
            initialize : function() {
                $scope.selectedGridItems = [];
                $scope.alerts = [];
                $scope.totalUploads = dmsUploadService.totalProgress;
                $scope.uploads = dmsUploadService.uploads;
                $scope.operations = dmsApiOperationService.operations;
                $scope.operationBatch = dmsApiOperationService.currentBatch;
                $scope.selectedItem = { 'itemType':'TemplatesList'};
                $scope.breadCrumbList = [];
                $scope.collapseLength = 4;
            },
            preExecute : function() {
                clearPageAlerts();
                vm._setupGrid();
            },
            postExecute: function(){
                vm._refreshGrid();
            },
            execute : function()
            {
                this.initialize();
                var toExecute = methodMap[$state.current.name];
                if (angular.isFunction(toExecute))
                {
                    this.preExecute();
                    toExecute();
                    this.postExecute();
                }
            },
            templateList : function() {
                vm._getGridItems = function(){
                    vm.setBreadCrumbList();
                    return vm._getTemplateList();
                };
            },
        };

        methodMap.execute();

        //NOTE: only for helping with unit testing
        vm._execute = function(){
            methodMap.execute();
        };

    };

    templateMaster.$inject = [
        '$scope',
        '$stateParams',
        '$state',
        '$uibModal',
        '$window',
        '$location',
        '$q',
        '$interval',
        '$translate',
        'utility',
        'searchManager',
        'dmsUploadService',
        'operationAlertDisplayModalService',
        'uploadAlertDisplayModalService',
        'DmsAlertCollectionModel',
        'dmsAlertService',
        'dmsApiOperationConstants',
        'DmsApiOperationCollectionModel',
        'dmsApiOperationService',
        'dmsModalUiService',
        'dmsProjectUiService'
    ];
    angular.module('onvio.documents').controller('templateMaster', templateMaster);
})(window.angular, window._);

(function (win, angular) {
    'use strict';

    var bmClientApp = angular.module('bm.client.app', [
        'ui.bootstrap',
        'bento.modern',
        'ui.router',
        'wj',
        'pascalprecht.translate',
        'bm.client.app.templates',
        'bm.client.app.config',
        'bluemoon.components',
        'bluemoon.components.analytics',
        'onvio.documents',
        'bmClientAppHeader',
        'bmClientAppNav',
        'bmClientAppMain',
    ]);
    // override for bluemoon-components theme module
    bmClientApp.value('bmThemeType', 'client');

    bmClientApp.run(['$analytics', function ($analytics) {
        $analytics.setSuperProperties({
            app: 'Onvio Client Center'
        });
    }]);

    win.bmClientApp = bmClientApp || {};
}(window, window.angular));

/* jshint ignore:start */

(function(factory) {
    if (typeof define === 'function' && define.amd) {
        define(['moment'], factory); // AMD
    } else if (typeof exports === 'object') {
        module.exports = factory(require('../moment')); // Node
    } else {
        factory((typeof global !== 'undefined' ? global : this).moment); // node or other global
    }
}(function(moment) {
    return moment.defineLocale('xx-xx', {
        months : '[ĵăƞʊăɾɣ!!]_[Ƒȅɓɾʊăɾɣ!!!]_[ʍăɾĉɧ!!]_[Ăρɾɨļ!!]_[ʍăɣ!]_[ĵʊƞȅ!]_[ĵʊļɣ!]_[Ăʊɠʊšƭ!!]_[Ѕȅρƭȅɱɓȅɾ!!!]_[Ǒĉƭǒɓȅɾ!!]_[Ɲǒʋȅɱɓȅɾ!!!]_[Ďȅĉȅɱɓȅɾ!!!]'.split('_'),
        monthsShort : '[ĵăƞ!]_[Ƒȅɓ!]_[ʍăɾ!]_[Ăρɾ!]_[ʍăɣ!]_[ĵʊƞ!]_[ĵʊļ!]_[Ăʊɠ!]_[Ѕȅρ!]_[Ǒĉƭ!]_[Ɲǒʋ!]_[Ďȅĉ!]'.split('_'),
        weekdays : '[Ѕʊƞɗăɣ!!]_[ʍǒƞɗăɣ!!]_[Ҭʊȅšɗăɣ!!]_[Ɯȅɗƞȅšɗăɣ!!!]_[Ҭɧʊɾšɗăɣ!!!]_[Ƒɾɨɗăɣ!!]_[Ѕăƭʊɾɗăɣ!!!]'.split('_'),
        weekdaysShort : '[Ѕʊƞ!]_[ʍǒƞ!]_[Ҭʊȅ!]_[Ɯȅɗ!]_[Ҭɧʊ!]_[Ƒɾɨ!]_[Ѕăƭ!]'.split('_'),
        weekdaysMin : '[Ѕʊ!]_[ʍǒ!]_[Ҭʊ!]_[Ɯȅ!]_[Ҭɧ!]_[Ƒɾ!]_[Ѕă!]'.split('_'),
        longDateFormat : {
            LTS : 'A ss:mm:h',
            LT : 'A mm:h',
            L : 'YYYY/MM/DD',
            LL : 'YYYY, D MMMM',
            LLL : 'YYYY, D MMMM LT',
            LLLL : 'YYYY, D MMMM dddd LT'
        },
        calendar : {
            sameDay : '[[Ҭǒɗăɣ ăƭ!!!]] LT',
            nextDay : '[[Ҭǒɱǒɾɾǒɯ ăƭ!!!!]] LT',
            nextWeek : 'dddd [[ăƭ!]] LT',
            lastDay : '[[¥ȅšƭȅɾɗăɣ ăƭ!!!!]] LT',
            lastWeek : '[[£ăšƭ!]] dddd [[ăƭ!]] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '[ɨƞ %s!!]',
            past : '[%s ăɠǒ!!!]',
            s : '[ă ƒȅɯ šȅĉǒƞɗš!!!!!]',
            m : '[ă ɱɨƞʊƭȅ!!!]',
            mm : '[%d ɱɨƞʊƭȅš!!!!]',
            h : '[ăƞ ɧǒʊɾ!!]',
            hh : '[%d ɧǒʊɾš!!!!]',
            d : '[ă ɗăɣ!!]',
            dd : '[%d ɗăɣš!!!]',
            M : '[ă ɱǒƞƭɧ!!]',
            MM : '[%d ɱǒƞƭɧš!!!!]',
            y : '[ă ɣȅăɾ!!]',
            yy : '[%d ɣȅăɾš!!!!]'
        },
        ordinalParse: /\d{1,2}([šƭ!]|[ƞɗ!]|[ɾɗ!]|[ƭɧ!])/,
        ordinal : function(number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? '[ƭɧ!]' :
                (b === 1) ? '[šƭ!]' :
                (b === 2) ? '[ƞɗ!]' :
                (b === 3) ? '[ɾɗ!]' : '[ƭɧ!]';
            return number + output;
        }
    });
}));
/* jshint ignore:end */

(function(bmClientApp, FastClick){
  'use strict';

  bmClientApp.run(fastClickRun);
  fastClickRun.$inject = [
    '$document'
  ];

  //////////////////////

  function fastClickRun($document) {
    FastClick.attach($document[0].body);
  }
})(window.bmClientApp, window.FastClick);

(function(bmClientApp){
  'use strict';

  bmClientApp.run(setupBoomr);
  setupBoomr.$inject = [
      '$rootScope',
      '$window'
  ];

  /* SOASTA Boomerang mPulse script for RUM */

  function setupBoomr($rootScope, $window) {
    // TR: bail if not QED or DEMO
    /* jshint ignore:start */
    if (!/\b(demo|qed)\.onvio\.us/.test(location.hostname)) { return; }
    /* jshint ignore:end */

    var hadRouteChange = false;
    var boomr = $window.BOOMR;

    // TR: mod to use $stateChangeStart
    $rootScope.$on('$stateChangeStart', function(){
      hadRouteChange = true;
    });

    function hookAngularBoomerang() {
      if (boomr && boomr.version) {
        if (boomr.plugins && boomr.plugins.Angular){
          boomr.plugins.Angular.hook($rootScope, hadRouteChange);
        }

        return true;
      }
    }

    if (!hookAngularBoomerang()){
      if(document.addEventListener){
        document.addEventListener('onBoomerangLoaded', hookAngularBoomerang);
      } else if(document.attachEvent){
        document.attachEvent('onpropertychange', function(e){
          e = e || window.event;
          if (e && e.propertyName === 'onBoomerangLoaded'){
            hookAngularBoomerang();
          }
        });
      }
    }
  }

  // todo: run this when deployed to prod for perf boost
  // see https://docs.angularjs.org/guide/production
  // .config(['$compileProvider', function ($compileProvider) {
  //     $compileProvider.debugInfoEnabled(false);
  // }]);
})(window.bmClientApp);

(function(angular, bmClientApp){
  'use strict';

  bmClientApp.config(config);
  config.$inject = [
    '$translateProvider',
    '$translatePartialLoaderProvider',
    '$locationProvider',
    'bmAppConfig'
  ];

  bmClientApp.run(run);
  run.$inject = [
    '$window',
    '$rootScope',
    '$timeout',
    '$bentoTranslate',
    'languageStorageManager'
  ];

  //////////////////////

  function config($translateProvider, $translatePartialLoaderProvider, $locationProvider, appConfig) {
    //get rid of hashbang
    $locationProvider.hashPrefix('');
    // setup angular translate
    $translateProvider.useLoader('$translatePartialLoader', { urlTemplate: '{part}/{lang}.json' });
    $translatePartialLoaderProvider.addPart(appConfig.translationLoadPath);

    // TODO: sanitizeParameters has trouble with utf-8, use escape until issue is addressed
    // See https://github.com/angular-translate/angular-translate/issues/1101
    // and http://angular-translate.github.io/docs/#/guide/19_security
    $translateProvider.useSanitizeValueStrategy('escapeParameters');
  }

  function run($window, $rootScope, $timeout, $bentoTranslate, languageStorageManager) {
    var loadBentoTranslations = function(lang) {
      // Don't try to load lang files for en-* since they are hardcoded in JS,
      // otherwise errors you can't suppress will show. Also, no xx-XX pseudo.
      if (/^(en|xx)-/.test(lang) || angular.isUndefined(lang)) {
        $timeout(function() {
            $bentoTranslate.setTranslation({});
        });
      } else {
        $bentoTranslate.load('bower_components/nucleus-i18n/dist/bento/' + lang + '.json');
      }
    };

    var setMomentLocale = function(language) {
      // en is the fallback for momentjs, en = en-US.
      if(angular.isString(language)){
        $window.moment.locale([language, 'en']);
      }
    };

    var startupLang = languageStorageManager.get();
    var appInitialized = false;

    loadBentoTranslations(startupLang);
    setMomentLocale(startupLang);

    $timeout(function() {
      appInitialized = true;
    }, 4000);

    $rootScope.$on('bmLanguageChangeSuccess', function(event, changeArgs) {
      if(!appInitialized) {
        setMomentLocale(changeArgs.language);
      } else {
        $window.location.reload();
      }

      if (changeArgs.language !== startupLang) {
        loadBentoTranslations(changeArgs.language);
      }
    });
  }
})(window.angular, window.bmClientApp);

(function(bmClientApp){
  'use strict';

  bmClientApp.config(routes);
  routes.$inject = [
      '$stateProvider',
      '$urlRouterProvider'
  ];

  function routes($stateProvider, $urlRouterProvider) {
    // NOTE: NEED UI-ROUTER VERSION > 0.3.1 FOR $RESOLVE TO WORK WITH ANGULAR COMPONENTS

    // redirect to first nav item you have access to
    $urlRouterProvider.when(/^(\s*|\/)$/, [
      '$window',
      '$location',
      '$state',
      'AuthenticatedSessionData',
      'bmEnvironment',
      function ($window, $location, $state, authenticatedSessionData, bmEnvironment) {
        // Avoid location redirect for Brazil Environment
        if (bmEnvironment.isBrCountryCode()) {
          $state.go('notfound');
        } else {
          authenticatedSessionData.getBindings().then(function (bindings) {
            if (bindings.Grants.indexOf('client.tax') > -1) {
              $window.location.href = '/tax/center';
            } else if (bindings.Grants.indexOf('client.documents') > -1) {
              $location.path('/documents');
            } else {
              $state.go('notfound');
            }
          });
        }
        return true;
      }
    ]);

    $stateProvider
    .state('main', {
      templateUrl: 'main/main.html',
      controller: 'MainCtrl',
      controllerAs: 'ctrl',
      resolve: {
        // Below is an example of controlling access to your app, replace
        // 'Applications.Onvio' with the Feature Resource Permission for your app

        // permission: ['$state', 'bmPermission', function($state, bmPermission) {
        //     bmPermission.has('Applications.Onvio').catch(function () {
        //         $state.go('main.notfound', {}, { location: 'replace' });
        //     });
        // }]
      }
    })

    // nested not found
    .state('main.notfound', {
      url: '/not/found',
      templateUrl: 'notfound/notfound.html'
    })

    // not found
    .state('notfound', {
      url: '/notfound',
      templateUrl: 'notfound/notfound.html'
    });

    // catch-all -> not found
    $urlRouterProvider.otherwise('/notfound');
  }
})(window.bmClientApp);

(function (bmClientApp) {
  'use strict';

  bmClientApp.controller('bmClientAppCtrl', bmClientAppCtrl);

  //////////////////////

  // NOTE: BACK BUTTON CAN SOMETIMES GET A STUCK BUSY LOADER IF LOCATION URL DOESN"T CHANGE
  // MAY NEED TO ADD $locationChange EVENT HANDLERS

  bmClientAppCtrl.$inject = ['$rootScope', '$scope', '$timeout', 'bmTheme', '$location', 'bmEnvironment', '$window'];

  function bmClientAppCtrl($rootScope, $scope, $timeout, bmTheme, $location, bmEnvironment, $window) {
    // used to set HTML title
    $scope.theme = bmTheme.data;

    $rootScope.$on('$stateChangeStart', function (event) {
      // redirect to Onvio Atendimento if is BR Environment
      if (bmEnvironment.isBrCountryCode()) {
        redirectToBrEnvironment(event);
      }
      // delay till next cycle since bm-busy-loader auto hides loader on $stateChangeStart
      $timeout(function () {
        $scope.$emit('bm-busy-loading-on');
      }, 0);
    });

    $rootScope.$on('$stateChangeSuccess', function () {
      // delay till next cycle since $stateChangeStart above delays
      $timeout(function () {
        // send the event up and down to all scopes
        $scope.$emit('bm-busy-loading-off');
        $scope.$broadcast('bm-busy-loading-off');
      }, 0);
    });

    $rootScope.$on('$stateChangeError', function () {
      // delay till next cycle since $stateChangeStart above delays
      $timeout(function () {
        // send the event up and down to all scopes
        $scope.$emit('bm-busy-loading-off');
        $scope.$broadcast('bm-busy-loading-off');
      }, 0);
    });

    function redirectToBrEnvironment(event) {
      var originalLocation = $location.absUrl();
      var clientAppPath = '/client/#/';
      var atendimentoClientAppPath = '/atendimento-client/#/';
      if (originalLocation.indexOf(clientAppPath) > -1) {
        var newLocation = originalLocation.replace(clientAppPath, atendimentoClientAppPath);
        $window.location.href = newLocation;
        event.preventDefault();
      }
    }
  }
})(window.bmClientApp);

angular.module('bm.client.app.config', [])

.constant('bmAppConfig', {translationLoadPath:'i18n'})

;
angular.module('bm.client.app.templates', ['404.html', 'index.html', 'components/client-header/preview-mode-modal/preview-mode-modal.html', 'documents/all-docs/masterlist/all-docs-master.html', 'documents/clients/masterlist/client-master.html', 'documents/files/actions/renamefile/rename-file-modal.2js.html', 'documents/files/actions/scanfile/scan-file-modal.2js.html', 'documents/files/file-view.html', 'documents/folders/actions/renamefolder/rename-folder-modal.2js.html', 'documents/folders/actions/sharefolder/combo-grid-cell-template.2js.html', 'documents/folders/actions/sharefolder/name-grid-cell-template.2js.html', 'documents/folders/actions/sharefolder/share-folder-modal.2js.html', 'documents/folders/masterlist/folder-master.html', 'documents/folders/masterlist/toolbar-template.html', 'documents/recents/masterlist/recents-master.html', 'documents/recycle/masterlist/recycle-view.html', 'documents/search/document-search-results.html', 'documents/storage/actions/renameproject/rename-project-modal.2js.html', 'documents/storage/masterlist/storage-master.html', 'documents/templates/masterlist/template-master.html', 'main/main.html', 'notfound/notfound.html', 'server-check/index.html']);

angular.module("404.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("404.html",
    "<!DOCTYPE html>\n" +
    "<html lang=\"en\">\n" +
    "  <head>\n" +
    "    <meta charset=\"utf-8\">\n" +
    "    <title>Page Not Found :(</title>\n" +
    "    <style>\n" +
    "      ::-moz-selection {\n" +
    "        background: #b3d4fc;\n" +
    "        text-shadow: none;\n" +
    "      }\n" +
    "\n" +
    "      ::selection {\n" +
    "        background: #b3d4fc;\n" +
    "        text-shadow: none;\n" +
    "      }\n" +
    "\n" +
    "      html {\n" +
    "        padding: 30px 10px;\n" +
    "        font-size: 20px;\n" +
    "        line-height: 1.4;\n" +
    "        color: #737373;\n" +
    "        background: #f0f0f0;\n" +
    "        -webkit-text-size-adjust: 100%;\n" +
    "        -ms-text-size-adjust: 100%;\n" +
    "      }\n" +
    "\n" +
    "      html,\n" +
    "      input {\n" +
    "        font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n" +
    "      }\n" +
    "\n" +
    "      body {\n" +
    "        max-width: 500px;\n" +
    "        _width: 500px;\n" +
    "        padding: 30px 20px 50px;\n" +
    "        border: 1px solid #b3b3b3;\n" +
    "        border-radius: 4px;\n" +
    "        margin: 0 auto;\n" +
    "        box-shadow: 0 1px 10px #a7a7a7, inset 0 1px 0 #fff;\n" +
    "        background: #fcfcfc;\n" +
    "      }\n" +
    "\n" +
    "      h1 {\n" +
    "        margin: 0 10px;\n" +
    "        font-size: 50px;\n" +
    "        text-align: center;\n" +
    "      }\n" +
    "\n" +
    "      h1 span {\n" +
    "        color: #bbb;\n" +
    "      }\n" +
    "\n" +
    "      h3 {\n" +
    "        margin: 1.5em 0 0.5em;\n" +
    "      }\n" +
    "\n" +
    "      p {\n" +
    "        margin: 1em 0;\n" +
    "      }\n" +
    "\n" +
    "      ul {\n" +
    "        padding: 0 0 0 40px;\n" +
    "        margin: 1em 0;\n" +
    "      }\n" +
    "\n" +
    "      .container {\n" +
    "        max-width: 380px;\n" +
    "        _width: 380px;\n" +
    "        margin: 0 auto;\n" +
    "      }\n" +
    "\n" +
    "      /* google search */\n" +
    "\n" +
    "      #goog-fixurl ul {\n" +
    "        list-style: none;\n" +
    "        padding: 0;\n" +
    "        margin: 0;\n" +
    "      }\n" +
    "\n" +
    "      #goog-fixurl form {\n" +
    "        margin: 0;\n" +
    "      }\n" +
    "\n" +
    "      #goog-wm-qt,\n" +
    "      #goog-wm-sb {\n" +
    "        border: 1px solid #bbb;\n" +
    "        font-size: 16px;\n" +
    "        line-height: normal;\n" +
    "        vertical-align: top;\n" +
    "        color: #444;\n" +
    "        border-radius: 2px;\n" +
    "      }\n" +
    "\n" +
    "      #goog-wm-qt {\n" +
    "        width: 220px;\n" +
    "        height: 20px;\n" +
    "        padding: 5px;\n" +
    "        margin: 5px 10px 0 0;\n" +
    "        box-shadow: inset 0 1px 1px #ccc;\n" +
    "      }\n" +
    "\n" +
    "      #goog-wm-sb {\n" +
    "        display: inline-block;\n" +
    "        height: 32px;\n" +
    "        padding: 0 10px;\n" +
    "        margin: 5px 0 0;\n" +
    "        white-space: nowrap;\n" +
    "        cursor: pointer;\n" +
    "        background-color: #f5f5f5;\n" +
    "        background-image: -webkit-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n" +
    "        background-image: -moz-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n" +
    "        background-image: -ms-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n" +
    "        background-image: -o-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n" +
    "        -webkit-appearance: none;\n" +
    "        -moz-appearance: none;\n" +
    "        appearance: none;\n" +
    "        *overflow: visible;\n" +
    "        *display: inline;\n" +
    "        *zoom: 1;\n" +
    "      }\n" +
    "\n" +
    "      #goog-wm-sb:hover,\n" +
    "      #goog-wm-sb:focus {\n" +
    "        border-color: #aaa;\n" +
    "        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n" +
    "        background-color: #f8f8f8;\n" +
    "      }\n" +
    "\n" +
    "      #goog-wm-qt:hover,\n" +
    "      #goog-wm-qt:focus {\n" +
    "        border-color: #105cb6;\n" +
    "        outline: 0;\n" +
    "        color: #222;\n" +
    "      }\n" +
    "\n" +
    "      input::-moz-focus-inner {\n" +
    "        padding: 0;\n" +
    "        border: 0;\n" +
    "      }\n" +
    "    </style>\n" +
    "  </head>\n" +
    "  <body>\n" +
    "    <div class=\"container\">\n" +
    "      <h1>Not found <span>:(</span></h1>\n" +
    "      <p>Sorry, but the page you were trying to view does not exist.</p>\n" +
    "      <p>It looks like this was the result of either:</p>\n" +
    "      <ul>\n" +
    "        <li>a mistyped address</li>\n" +
    "        <li>an out-of-date link</li>\n" +
    "      </ul>\n" +
    "      <script>\n" +
    "        var GOOG_FIXURL_LANG = (navigator.language || '').slice(0,2),GOOG_FIXURL_SITE = location.host;\n" +
    "      </script>\n" +
    "      <script src=\"//linkhelp.clients.google.com/tbproxy/lh/wm/fixurl.js\"></script>\n" +
    "    </div>\n" +
    "  </body>\n" +
    "</html>\n" +
    "");
}]);

angular.module("index.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("index.html",
    "<!doctype html>\n" +
    "<html ng-app=\"bm.client.app\" bm-app ng-strict-di ng-controller=\"bmClientAppCtrl as ctrl\">\n" +
    "<head>\n" +
    "    <meta charset=\"utf-8\">\n" +
    "    <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">\n" +
    "    <title ng-bind=\"theme.header.headerLine1\"></title>\n" +
    "    <meta name=\"description\" content=\"Are you a firm client? Sign in here.\">\n" +
    "    <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n" +
    "\n" +
    "    <!-- Anti-Click Jacking https://www.owasp.org/index.php/Clickjacking_Defense_Cheat_Sheet -->\n" +
    "    <style id=\"antiClickjack\">body { display: none !important; }</style>\n" +
    "    <script type=\"text/javascript\">\n" +
    "       if (window.self === top) {\n" +
    "           var antiClickjack = document.getElementById('antiClickjack');\n" +
    "           antiClickjack.parentNode.removeChild(antiClickjack);\n" +
    "       } else {\n" +
    "           top.location = window.self.location;\n" +
    "       }\n" +
    "    </script>\n" +
    "\n" +
    "    <!-- specific to nucleus-client app -->\n" +
    "    <script type=\"text/javascript\">\n" +
    "    if (/\\b(demo|qed)\\.onvio\\.us/.test(location.hostname)) {\n" +
    "        /* jshint ignore:start */\n" +
    "        (function(){if(window.BOOMR&&window.BOOMR.version){return}var dom,doc,where,iframe=document.createElement(\"iframe\"),win=window;function boomerangSaveLoadTime(e){win.BOOMR_onload=e&&e.timeStamp||(new Date).getTime()}if(win.addEventListener){win.addEventListener(\"load\",boomerangSaveLoadTime,false)}else if(win.attachEvent){win.attachEvent(\"onload\",boomerangSaveLoadTime)}iframe.src=\"javascript:false\";iframe.title=\"\";iframe.role=\"presentation\";(iframe.frameElement||iframe).style.cssText=\"width:0;height:0;border:0;display:none;\";where=document.getElementsByTagName(\"script\")[0];where.parentNode.insertBefore(iframe,where);try{doc=iframe.contentWindow.document}catch(e){dom=document.domain;iframe.src=\"javascript:var d=document.open();d.domain='\"+dom+\"';void(0);\";doc=iframe.contentWindow.document}doc.open()._l=function(){var js=this.createElement(\"script\");if(dom)this.domain=dom;js.id=\"boomr-if-as\";js.src=\"//c.go-mpulse.net/boomerang/\"+\"48EBN-K3G8W-YU8RF-RJWHM-SRKWB\";BOOMR_lstart=(new Date).getTime();this.body.appendChild(js)};doc.write('<body onload=\"document._l();\">');doc.close()})();\n" +
    "        /* jshint ignore:end */\n" +
    "    }\n" +
    "    </script>\n" +
    "\n" +
    "    <!-- build:css css/dist.css -->\n" +
    "        <!-- APP RESOURCES: Include app and dependent CSS files here -->\n" +
    "        <!-- bento modern base deps -->\n" +
    "        <link href=\"bower_components/bootstrap/dist/css/bootstrap.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/wijmo/styles/wijmo.css\" rel=\"stylesheet\">\n" +
    "        <!-- bento modern -->\n" +
    "        <link href=\"bower_components/bento-modern/bootstrap/platform-theme.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/bento-modern/components/platform-theme.css\" rel=\"stylesheet\">\n" +
    "        <!-- <link href=\"bower_components/bento-modern/flexgrid/platform-theme.css\" rel=\"stylesheet\"> -->\n" +
    "\n" +
    "        <!-- third party -->\n" +
    "        <link href=\"bower_components/ngImgCrop/compile/unminified/ng-img-crop.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/bluemoon-components/bluemoon-components.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/angular/angular-csp.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/ng-grid/ng-grid.css\" rel=\"stylesheet\">\n" +
    "        <!-- <link href=\"bower_components/animate.css/animate.css\" rel=\"stylesheet\"> -->\n" +
    "        <!-- <link href=\"bower_components/spectrum/spectrum.css\" rel=\"stylesheet\"> -->\n" +
    "\n" +
    "        <!-- DMS -->\n" +
    "        <link href=\"bower_components/bluemoon-dms/alerts/bluemoon-dms-alerts.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/bluemoon-dms/all-docs-grid/bluemoon-dms-all-docs-grid.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/bluemoon-dms/breadcrumbs/bluemoon-dms-breadcrumb.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/bluemoon-dms/client-grid/bluemoon-dms-client-grid.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/bluemoon-dms/document-grid/bluemoon-dms-document-grid.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/bluemoon-dms/grids/bluemoon-dms-grids.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/bluemoon-dms/nav-breadcrumb/bluemoon-dms-nav-breadcrumb.css\" rel=\"stylesheet\" />\n" +
    "        <link href=\"bower_components/bluemoon-dms/images/filetypes.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/bluemoon-dms/images/dms-assorted-icons.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/bluemoon-dms/recents-grid/bluemoon-dms-recents-grid.css\" rel=\"stylesheet\" />\n" +
    "        <link href=\"bower_components/bluemoon-dms/recycle-grid/bluemoon-dms-recycle-grid.css\" rel=\"stylesheet\" />\n" +
    "        <link href=\"bower_components/bluemoon-dms/images/dms-storage-icons.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/bluemoon-dms/search-grid/bluemoon-dms-search-grid.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/bluemoon-dms/storage-grid/bluemoon-dms-storage-grid.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/bluemoon-dms/modal/bluemoon-dms-modal.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/bluemoon-dms/toolbar/bluemoon-dms-toolbar.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"bower_components/bluemoon-dms/folder-selector/bluemoon-dms-folder-selector.css\" rel=\"stylesheet\">\n" +
    "        <!-- TODO: FONT AWESOME SHOULD NOT BE NEEDED? -->\n" +
    "        <!-- <link href=\"bower_components/font-awesome/css/font-awesome.css\" rel=\"stylesheet\"> -->\n" +
    "\n" +
    "        <!-- app -->\n" +
    "        <link href=\"app.css\" rel=\"stylesheet\">\n" +
    "        <link rel=\"stylesheet\" href=\"documents/dms-app.css\">\n" +
    "        <!-- NO STYLES IN FILE -->\n" +
    "        <!-- <link href=\"documents/clients/masterlist/client-master.css\" rel=\"stylesheet\"> -->\n" +
    "        <link href=\"documents/files/file-view.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"documents/files/actions/scanfile/scan-file-modal.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"documents/folders/masterlist/folder-master.css\" rel=\"stylesheet\">\n" +
    "        <!-- TODO: RECENTS CSS NOT REQUIRED WHEN MOVING TO NEW WIJMO -->\n" +
    "        <link href=\"documents/recents/masterlist/recents-master.css\" rel=\"stylesheet\">\n" +
    "        <!-- TODO: REQUIRED CSS WILL CHANGE WHEN MOVING TO NEW WIJMO -->\n" +
    "        <link href=\"documents/recycle/masterlist/recycle-master.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"documents/search/document-search-results.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"documents/storage/masterlist/storage-master.css\" rel=\"stylesheet\">\n" +
    "        <!-- NO STYLES IN FILE -->\n" +
    "        <!-- <link href=\"documents/templates/masterlist/template-master.css\" rel=\"stylesheet\"> -->\n" +
    "    <!-- endbuild -->\n" +
    "\n" +
    "    <!-- build:css css/component.css -->\n" +
    "        <!-- COMPONENT RESOURCES: Include exportable component CSS files here -->\n" +
    "        <link href=\"components/client-header/export/client-header.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"components/client-nav/export/client-nav.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"components/client-main/export/client-main.css\" rel=\"stylesheet\">\n" +
    "        <link href=\"components/client-header/preview-mode-modal/preview-mode-modal.css\" rel=\"stylesheet\">\n" +
    "\n" +
    "    <!-- endbuild -->\n" +
    "\n" +
    "</head>\n" +
    "<body ng-cloak translate-cloak bm-force-desktop bm-busy-loader>\n" +
    "    <!--[if lte IE 10]>\n" +
    "        <p class=\"browsehappy\">You are using an <strong>outdated</strong> browser. Please <a href=\"http://browsehappy.com/\">upgrade your browser</a> to improve your experience.</p>\n" +
    "    <![endif]-->\n" +
    "\n" +
    "    <ui-view></ui-view>\n" +
    "\n" +
    "    <!-- external js loaded outside build system -->\n" +
    "    <script type=\"text/javascript\" src=\"https://www.dropbox.com/static/api/2/dropins.js\" id=\"dropboxjs\" data-app-key=\"04lskc9cxh2svys\"></script>\n" +
    "    <script type=\"text/javascript\" src=\"https://apis.google.com/js/api.js?onload=onApiLoad\"></script>\n" +
    "    <script type=\"text/javascript\" src=\"https://app.box.com/js/static/select.js\"></script>\n" +
    "\n" +
    "    <script src=\"documents/components/scan-resources/12.3.0/dynamsoft.webtwain.initiate.js\"></script>\n" +
    "    <script src=\"documents/components/scan-resources/12.3.0/dynamsoft.webtwain.config.js\"></script>\n" +
    "\n" +
    "    <!-- build:js dist.js -->\n" +
    "        <!-- APP RESOURCES: Include app and dependent JS files here -->\n" +
    "        <!-- jquery required for ng-grid -->\n" +
    "        <script src=\"bower_components/jquery/dist/jquery.js\"></script>\n" +
    "        <script src=\"bower_components/angular/angular.js\"></script>\n" +
    "        <script src=\"bower_components/angular-animate/angular-animate.js\"></script>\n" +
    "        <script src=\"bower_components/angular-sanitize/angular-sanitize.js\"></script>\n" +
    "        <script src=\"bower_components/angular-touch/angular-touch.js\"></script>\n" +
    "        <script src=\"bower_components/underscore/underscore.js\"></script>\n" +
    "        <script src=\"bower_components/angular-translate/angular-translate.js\"></script>\n" +
    "        <script src=\"bower_components/fastclick/lib/fastclick.js\"></script>\n" +
    "\n" +
    "        <!-- bento modern base deps -->\n" +
    "        <script src=\"bower_components/angular-bootstrap/ui-bootstrap-tpls.js\"></script>\n" +
    "\n" +
    "        <!-- bento modern components -->\n" +
    "        <script src=\"bower_components/bento-modern/components/bento-modern.js\"></script>\n" +
    "\n" +
    "        <!-- wijmo -->\n" +
    "        <script type=\"text/javascript\" src=\"bower_components/wijmo/angularjs/controls/wijmo.js\"></script>\n" +
    "        <script type=\"text/javascript\" src=\"bower_components/wijmo/angularjs/controls/wijmo.grid.js\"></script>\n" +
    "        <script type=\"text/javascript\" src=\"bower_components/wijmo/angularjs/interop/wijmo.angular.js\"></script>\n" +
    "\n" +
    "        <!-- third party -->\n" +
    "        <script src=\"bower_components/moment/moment.js\"></script>\n" +
    "        <script src=\"bower_components/moment/locale/fr-ca.js\"></script>\n" +
    "        <script src=\"bower_components/moment/locale/en-ca.js\"></script>\n" +
    "        <script src=\"bower_components/moment/locale/en-gb.js\"></script>\n" +
    "        <script src=\"bower_components/moment/locale/en-au.js\"></script>\n" +
    "        <script src=\"bower_components/moment/locale/es.js\"></script>\n" +
    "        <script src=\"bower_components/moment/locale/pt-br.js\"></script>\n" +
    "        <script src=\"bower_components/moment/locale/nl.js\"></script>\n" +
    "        <script src=\"bower_components/rxjs/dist/rx.js\"></script>\n" +
    "        <script src=\"bower_components/fef/fef.js\"></script>\n" +
    "        <script src=\"bower_components/angulartics/src/angulartics.js\"></script>\n" +
    "        <script src=\"bower_components/angular-translate-loader-partial/angular-translate-loader-partial.js\"></script>\n" +
    "        <script src=\"bower_components/angular-ui-router/release/angular-ui-router.js\"></script>\n" +
    "        <script src=\"bower_components/ng-file-upload/angular-file-upload.js\"></script>\n" +
    "        <script src=\"bower_components/ngImgCrop/compile/unminified/ng-img-crop.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-analytics/dist/bluemoon-analytics.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-analytics/dist/TRAAC.Core.Http.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-components/bluemoon-components.js\"></script>\n" +
    "        <script src=\"bower_components/ng-grid/build/ng-grid.js\"></script>\n" +
    "\n" +
    "        <!-- swagger -->\n" +
    "        <script src=\"bower_components/bm-cs-swaggergen/dist/services/employee-v2.js\"></script>\n" +
    "\n" +
    "        <!-- dms bower -->\n" +
    "        <script src=\"bower_components/bluemoon-dms/bluemoon-dms.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/alerts/bluemoon-dms-alerts.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/all-docs-grid/bluemoon-dms-all-docs-grid.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/client-grid/bluemoon-dms-client-grid.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/cloud/bluemoon-dms-cloud.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/document-grid/bluemoon-dms-document-grid.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/folder-selector/bluemoon-dms-folder-selector.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/formats/bluemoon-dms-format.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/grids/bluemoon-dms-grids.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/hover/bluemoon-dms-hover.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/http/bluemoon-dms-http.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/i18n/bluemoon-dms-i18n.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/icon/bluemoon-dms-icon.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/managers/bluemoon-dms-managers.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/modal/bluemoon-dms-modal.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/models/bluemoon-dms-models.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/nav-breadcrumb/bluemoon-dms-nav-breadcrumb.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/recents-grid/bluemoon-dms-recents-grid.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/recycle-grid/bluemoon-dms-recycle-grid.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/search-grid/bluemoon-dms-search-grid.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/sidebar/bluemoon-dms-sidebar.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/storage-grid/bluemoon-dms-storage-grid.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/toolbar/bluemoon-dms-toolbar.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/data-services/bluemoon-dms-data-services.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/services/bluemoon-dms-services.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/ui-services/bluemoon-dms-ui-services.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/upload/bluemoon-dms-upload.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/utility/bluemoon-dms-utility.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/validation/bluemoon-dms-validation.js\"></script>\n" +
    "        <script src=\"bower_components/bluemoon-dms/viewer/bluemoon-dms-viewer.js\"></script>\n" +
    "\n" +
    "        <!-- dms app -->\n" +
    "        <script src=\"documents/dms-app.js\"></script>\n" +
    "        <script src=\"documents/dms-route-config.js\"></script>\n" +
    "        <script src=\"documents/all-docs/masterlist/all-docs-master-controller.js\"></script>\n" +
    "        <script src=\"documents/clients/masterlist/client-master-controller.js\"></script>\n" +
    "        <script src=\"documents/components/global-helpers.js\"></script>\n" +
    "        <script src=\"documents/components/resize/resize-directive.js\"></script>\n" +
    "        <script src=\"documents/components/select-on-focus.js\"></script>\n" +
    "        <script src=\"documents/components/dms-route-builder.js\"></script>\n" +
    "        <script src=\"documents/export/document-export-factory.js\"></script>\n" +
    "        <script src=\"documents/files/DWT_PageHead.js\"></script>\n" +
    "        <script src=\"documents/files/DWT_PageTail.js\"></script>\n" +
    "        <script src=\"documents/files/actions/renamefile/rename-file-modal.js\"></script>\n" +
    "        <script src=\"documents/files/actions/scanfile/scan-file-modal.js\"></script>\n" +
    "        <script src=\"documents/files/folder-file-view-controller.js\"></script>\n" +
    "        <script src=\"documents/folders/actions/renamefolder/rename-folder-modal.js\"></script>\n" +
    "        <script src=\"documents/folders/actions/sharefolder/share-folder-modal.js\"></script>\n" +
    "        <script src=\"documents/folders/masterlist/folder-master-controller.js\"></script>\n" +
    "        <script src=\"documents/recents/masterlist/recents-master-controller.js\"></script>\n" +
    "        <script src=\"documents/recycle/masterlist/recycle-master-controller.js\"></script>\n" +
    "        <script src=\"documents/search/document-search-controller.js\"></script>\n" +
    "        <script src=\"documents/search/document-search-factory.js\"></script>\n" +
    "        <script src=\"documents/search/search-result-item-model.js\"></script>\n" +
    "        <script src=\"documents/storage/actions/renameproject/rename-project-modal.js\"></script>\n" +
    "        <script src=\"documents/storage/masterlist/storage-master-controller.js\"></script>\n" +
    "        <script src=\"documents/templates/masterlist/template-master-controller.js\"></script>\n" +
    "\n" +
    "        <!-- app -->\n" +
    "        <script src=\"app.js\"></script>\n" +
    "        <script src=\"app-xx-xx.js\"></script>\n" +
    "        <script src=\"app-fastclick-config.js\"></script>\n" +
    "        <script src=\"app-boomerang-config.js\"></script>\n" +
    "        <script src=\"app-translate-config.js\"></script>\n" +
    "        <script src=\"app-route-config.js\"></script>\n" +
    "        <script src=\"app-controller.js\"></script>\n" +
    "        <script src=\"generated/config.js\"></script>\n" +
    "        <script src=\"generated/templates.js\"></script>\n" +
    "        <script src=\"main/main-controller.js\"></script>\n" +
    "    <!-- endbuild -->\n" +
    "\n" +
    "    <!-- build:js component.js -->\n" +
    "        <!-- COMPONENT RESOURCES: Include exportable component JS files here -->\n" +
    "        <script src=\"components/client-header/export/client-header.js\"></script>\n" +
    "        <script src=\"components/client-nav/export/client-nav.js\"></script>\n" +
    "        <script src=\"components/client-main/export/client-main.js\"></script>\n" +
    "        <script src=\"generated/component-templates.js\"></script>\n" +
    "    <!-- endbuild -->\n" +
    "\n" +
    "</body>\n" +
    "</html>\n" +
    "");
}]);

angular.module("components/client-header/preview-mode-modal/preview-mode-modal.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("components/client-header/preview-mode-modal/preview-mode-modal.html",
    "<div class=\"modal-header\" translate=\"bm.client.app.previewMode.title\"></div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <div class=\"bento-alert-container mb\">\n" +
    "        <div class=\"alert bento-alert alert-warning alert-dismissable\" role=\"alert\">\n" +
    "            <span translate=\"bm.client.app.previewMode.data.not.saved.message\"></span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <p translate=\"bm.client.app.previewMode.please.note\"></p>\n" +
    "    <ul>\n" +
    "        <li>\n" +
    "            <p translate=\"bm.client.app.previewMode.content1\"></p>\n" +
    "        </li>\n" +
    "        <li>\n" +
    "            <p translate=\"bm.client.app.previewMode.content2\"></p>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\"> \n" +
    "    <button class=\"btn btn-default btn-min-width\" translate=\"bm.client.app.previewMode.OkButtonText\" ng-click=\"ctrl.closeModal()\">\n" +
    "    </button>\n" +
    "</div>");
}]);

angular.module("documents/all-docs/masterlist/all-docs-master.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("documents/all-docs/masterlist/all-docs-master.html",
    "<div class=\"dms\">\n" +
    "    <div class=\"all-docs-master-container\" bento-busy-loader=\"loading\">\n" +
    "        <alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "        <h1 class=\"no-top-margin\" translate=\"Onvio.Shell.Navigation.Documents\"></h1>\n" +
    "\n" +
    "        <div dms-toolbar\n" +
    "            buttons=\"buttons\"\n" +
    "            on-search-enter=\"processSearch\">\n" +
    "        </div>\n" +
    "\n" +
    "        <dms-all-docs-grid \n" +
    "            items=\"gridItems\"\n" +
    "            footer-message=\"gridFooterMessage\"\n" +
    "            current-container=\"selectedItem\"\n" +
    "            custom-options=\"gridOptions\"\n" +
    "            viewer-height=\"viewerHeight\"\n" +
    "            header-row-height=\"38\"\n" +
    "            row-height=\"39\"\n" +
    "            virtualization-threshold=\"30\"\n" +
    "            search-method=\"processSearch\"\n" +
    "            buttons=\"buttons\">\n" +
    "        </dms-all-docs-grid>\n" +
    "\n" +
    "        <div class=\"alert animate-repeat upload-progress\" ng-class=\"{'alert-warning': totalUploads.totalErrors==0, 'alert-error': totalUploads.totalErrors>0}\" ng-show=\"totalUploads.totalFiles > 1\" ng-click=\"openAddFileModal()\">\n" +
    "            <span ng-if=\"totalUploads.totalErrors==0\">{{totalUploads.filesUploaded}} of {{totalUploads.totalFiles}} files uploaded ({{100*(totalUploads.progress.loaded/totalUploads.progress.total).toFixed(1)}}% complete).</span>\n" +
    "            <span ng-if=\"totalUploads.totalErrors>0\">{{totalUploads.filesUploaded}} of {{totalUploads.totalFiles}} files uploaded with {{totalUploads.totalErrors}} errors. Click for more information.</span>\n" +
    "            <div ng-if=\"totalUploads.totalErrors==0\" class=\"progress progress-striped active file-progress\">\n" +
    "                <div class=\"progress-bar progress-bar-warning\" role=\"progressbar\" aria-valuenow=\"{{totalUploads.progress.loaded}}\" aria-valuemin=\"0\" aria-valuemax=\"{{totalUploads.progress.total}}\" style=\"width: {{100*(totalUploads.progress.loaded/totalUploads.progress.total)}}%\">\n" +
    "                    <span class=\"sr-only\">progress</span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"alert animate-repeat upload-progress\" ng-class=\"{'alert-warning': !downloadError, 'alert-error': downloadError}\" ng-show=\"downloadStatus === 'downloading'\">\n" +
    "            <span ng-if=\"!downloadError\">Downloading files...</span>\n" +
    "            <span ng-if=\"downloadError\" ng-bind=\"downloadMessage\"></span>\n" +
    "            <button ng-if=\"downloadError\" type=\"button\" class=\"close file-alert-text\" aria-hidden=\"true\" ng-click=\"closeDownloadAlert()\">&times;</button>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"alert animate-repeat upload-progress\" ng-class=\"uploadTypeClass(upload)\" ng-show=\"totalUploads.totalFiles == 1\" ng-repeat=\"upload in uploads\">\n" +
    "            <span class=\"file-alert-text\" ng-if=\"upload.status=='waiting'\">{{upload.file.name}} is waiting to upload...</span>\n" +
    "            <span class=\"file-alert-text\" ng-if=\"upload.status=='uploading'\">{{upload.file.name}} is uploading ({{uploadPercentage(upload)}}% Complete).</span>\n" +
    "            <span class=\"file-alert-text\" ng-if=\"upload.status=='error' && upload.error.status==409\">{{upload.file.name}} already exists.</span>\n" +
    "            <span class=\"file-alert-text\" ng-if=\"upload.status=='error' && upload.error.status!=409\">{{upload.file.name}} could not be uploaded.</span>\n" +
    "            <span class=\"file-alert-text\" ng-if=\"upload.status=='success'\">{{upload.file.name}} has been uploaded.</span>\n" +
    "\n" +
    "            <div ng-if=\"upload.status=='uploading'\" class=\"progress progress-striped active file-progress\">\n" +
    "              <div class=\"progress-bar progress-bar-warning\" role=\"progressbar\" aria-valuenow=\"{{upload.loaded}}\" aria-valuemin=\"0\" aria-valuemax=\"{{upload.total}}\" style=\"width: {{uploadPercentage(upload)}}%\">\n" +
    "                <span class=\"sr-only\">progress</span>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <button ng-if=\"upload.status=='error'\" type=\"button\" class=\"close file-alert-text\" data-dismiss=\"alert\" aria-hidden=\"true\" ng-click=\"closeAlert(upload)\">&times;</button>\n" +
    "            <div ng-show=\"upload.status=='error'\" class=\"file-more-information\" ng-animate=\"'file-more-information'\">\n" +
    "                <span ng-if=\"upload.error.status==409\">\n" +
    "                    Would you like to <a class=\"alert-link\" ng-click=\"keepBoth(upload)\">keep both</a> files or\n" +
    "                    <a class=\"alert-link\" ng-click=\"replace(upload)\">replace</a> the original?\n" +
    "                </span>\n" +
    "                <span ng-if=\"upload.error.status!=409\">{{upload.error.message}} ({{upload.error.status}})</span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div ui-view></div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/clients/masterlist/client-master.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("documents/clients/masterlist/client-master.html",
    "<div class=\"dms\">\n" +
    "    <div class=\"client-master-container\">\n" +
    "        <alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "        <h1 class=\"no-top-margin\">{{titleText}}</h1>\n" +
    "\n" +
    "        <div dms-toolbar\n" +
    "            buttons=\"buttons\"\n" +
    "            on-search-enter=\"processSearch\">\n" +
    "        </div>\n" +
    "\n" +
    "        <dms-client-grid\n" +
    "            items=\"gridItems\"\n" +
    "            footer-message=\"gridFooterMessage\"\n" +
    "            current-container=\"selectedItem\"\n" +
    "            custom-options=\"gridOptions\"\n" +
    "            viewer-height=\"viewerHeight\"\n" +
    "            header-row-height=\"38\"\n" +
    "            row-height=\"39\"\n" +
    "            virtualization-threshold=\"30\"\n" +
    "            search-method=\"processSearch\"\n" +
    "            buttons=\"buttons\">\n" +
    "        </dms-client-grid>\n" +
    "\n" +
    "        <div class=\"alert animate-repeat upload-progress\" ng-class=\"{'alert-warning': totalUploads.totalErrors==0, 'alert-error': totalUploads.totalErrors>0}\" ng-show=\"totalUploads.totalFiles > 1\" ng-click=\"openAddFileModal()\">\n" +
    "            <span ng-if=\"totalUploads.totalErrors==0\">{{totalUploads.filesUploaded}} of {{totalUploads.totalFiles}} files uploaded ({{100*(totalUploads.progress.loaded/totalUploads.progress.total).toFixed(1)}}% complete).</span>\n" +
    "            <span ng-if=\"totalUploads.totalErrors>0\">{{totalUploads.filesUploaded}} of {{totalUploads.totalFiles}} files uploaded with {{totalUploads.totalErrors}} errors. Click for more information.</span>\n" +
    "            <div ng-if=\"totalUploads.totalErrors==0\" class=\"progress progress-striped active file-progress\">\n" +
    "                <div class=\"progress-bar progress-bar-warning\" role=\"progressbar\" aria-valuenow=\"{{totalUploads.progress.loaded}}\" aria-valuemin=\"0\" aria-valuemax=\"{{totalUploads.progress.total}}\" style=\"width: {{100*(totalUploads.progress.loaded/totalUploads.progress.total)}}%\">\n" +
    "                    <span class=\"sr-only\">progress</span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"alert animate-repeat upload-progress\" ng-class=\"{'alert-warning': !downloadError, 'alert-error': downloadError}\" ng-show=\"downloadStatus === 'downloading'\">\n" +
    "            <span ng-if=\"!downloadError\">Downloading files...</span>\n" +
    "            <span ng-if=\"downloadError\" ng-bind=\"downloadMessage\"></span>\n" +
    "            <button ng-if=\"downloadError\" type=\"button\" class=\"close file-alert-text\" aria-hidden=\"true\" ng-click=\"closeDownloadAlert()\">&times;</button>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"alert animate-repeat upload-progress\" ng-class=\"uploadTypeClass(upload)\" ng-show=\"totalUploads.totalFiles == 1\" ng-repeat=\"upload in uploads\">\n" +
    "            <span class=\"file-alert-text\" ng-if=\"upload.status=='waiting'\">{{upload.file.name}} is waiting to upload...</span>\n" +
    "            <span class=\"file-alert-text\" ng-if=\"upload.status=='uploading'\">{{upload.file.name}} is uploading ({{uploadPercentage(upload)}}% Complete).</span>\n" +
    "            <span class=\"file-alert-text\" ng-if=\"upload.status=='error' && upload.error.status==409\">{{upload.file.name}} already exists.</span>\n" +
    "            <span class=\"file-alert-text\" ng-if=\"upload.status=='error' && upload.error.status!=409\">{{upload.file.name}} could not be uploaded.</span>\n" +
    "            <span class=\"file-alert-text\" ng-if=\"upload.status=='success'\">{{upload.file.name}} has been uploaded.</span>\n" +
    "\n" +
    "            <div ng-if=\"upload.status=='uploading'\" class=\"progress progress-striped active file-progress\">\n" +
    "              <div class=\"progress-bar progress-bar-warning\" role=\"progressbar\" aria-valuenow=\"{{upload.loaded}}\" aria-valuemin=\"0\" aria-valuemax=\"{{upload.total}}\" style=\"width: {{uploadPercentage(upload)}}%\">\n" +
    "                <span class=\"sr-only\">progress</span>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <button ng-if=\"upload.status=='error'\" type=\"button\" class=\"close file-alert-text\" data-dismiss=\"alert\" aria-hidden=\"true\" ng-click=\"closeAlert(upload)\">&times;</button>\n" +
    "            <div ng-show=\"upload.status=='error'\" class=\"file-more-information\" ng-animate=\"'file-more-information'\">\n" +
    "                <span ng-if=\"upload.error.status==409\">\n" +
    "                    Would you like to <a class=\"alert-link\" ng-click=\"keepBoth(upload)\">keep both</a> files or\n" +
    "                    <a class=\"alert-link\" ng-click=\"replace(upload)\">replace</a> the original?\n" +
    "                </span>\n" +
    "                <span ng-if=\"upload.error.status!=409\">{{upload.error.message}} ({{upload.error.status}})</span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div ui-view></div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/files/actions/renamefile/rename-file-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("documents/files/actions/renamefile/rename-file-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancelRenameFile()\">\n" +
    "  &times;\n" +
    "</button>\n" +
    "<div class=\"modal-header\">\n" +
    "    {{headerText}}\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <alert class=\"show-hide\" ng-repeat=\"alert in renameFileData.alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "    <form role=\"form\" class=\"css-form\" name=\"renameFileForm\" ng-submit=\"renameFileRequest()\" novalidate>\n" +
    "        <div class=\"form-group\" ng-class=\"{'has-error': renameFileData.fileNameError !==''}\" ng-if=\"renameFileData.canRename\">\n" +
    "            <label for=\"fileName\">{{nameText}}*</label>\n" +
    "            <input name=\"fileName\" id=\"fileName\" type=\"text\" class=\"form-control\" ng-model=\"renameFileData.fileName\"\n" +
    "                    maxlength=\"{{ renameFileData.maxDocumentNameLength }}\" bm-focus=\"true\" select-on-focus/>\n" +
    "            <div class=\"msg\">{{ renameFileData.fileNameError }}</div>\n" +
    "        </div>\n" +
    "        <div ng-if=\"renameFileData.canRename\">\n" +
    "            * {{requiredText}}\n" +
    "        </div>\n" +
    "    </form>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-primary\" ng-click=\"renameFileRequest()\" ng-if=\"renameFileData.canRename\">{{renameButtonText}}</button>\n" +
    "    <button class=\"btn btn-default\" ng-click=\"cancelRenameFile()\">{{cancelButtonText}}</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/files/actions/scanfile/scan-file-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("documents/files/actions/scanfile/scan-file-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancelScanFile()\">\n" +
    "      <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"modal-header\" translate=\"Bluemoon.DMS.Modal.Scan.Header\"></div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <uib-alert class=\"show-hide\" ng-repeat=\"alert in scanFileData.alerts\" type=\"alert.type\">{{alert.msg}}</uib-alert>\n" +
    "        <span id=\"dwtcontrolDownload\" class=\"alert-link scan-plugin-download-container\"></span>\n" +
    "        <div id=\"dwtcontrolContainer\"></div>\n" +
    "        <div id=\"DWTNonInstallContainerID\" style=\"width:580px\"></div>\n" +
    "        <div id=\"DWTemessageContainer\" style=\"clear: both;width:580px\"></div>\n" +
    "       \n" +
    "        <form role=\"form\"  class=\"css-form\" name=\"scanFileForm\" novalidate>\n" +
    "            <div id=\"div_ScanImage\" class=\"form-group\"  ng-class=\"{'has-error': scanFileData.fileNameError !==''}\" >\n" +
    "                <label for=\"fileNameLabel\" translate=\"Bluemoon.DMS.Modal.Scan.FileName\"></label>\n" +
    "                <input type=\"text\" tabindex=\"0\" class=\"form-control\" id=\"scanFileName\" name=\"scanFileName\" maxlength=\"{{ scanFileData.maxDocumentNameLength }}\"\n" +
    "                bm-focus=\"true\" select-on-focus ng-model=\"scanFileData.scanFileName\" ng-change=\"scanFileData.resetValidation()\" autocomplete=\"off\" />\n" +
    "                <div class=\"msg\">\n" +
    "                    <span>{{ scanFileData.fileNameError }}</span>\n" +
    "                    <button ng-if=\"scanFileData.fileNameError.indexOf('already')>0\"\n" +
    "                        type=\"button\"\n" +
    "                        class=\"close file-alert-text\"\n" +
    "                        data-dismiss=\"alert\"\n" +
    "                        aria-hidden=\"true\"\n" +
    "                        ng-click=\"closeModalAction(upload)\"><i class=\"bento-icon-close-x\"></i></button>\n" +
    "                    <div ng-show=\"scanFileData.fileNameError.indexOf('already')>0\" class=\"file-more-information\">\n" +
    "                        <!-- Expects 'replace' and 'keepBoth' methods on $scope -->\n" +
    "                        <span bind-html-compile=\"'<span>{{'Bluemoon.DMS.Alerts.KeepBothOrReplaceFiles' | translate}}</span>'\">\n" +
    "                        </span>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <br />\n" +
    "            <div class=\"form-group\">\n" +
    "                <label for=\"source\" translate=\"Bluemoon.DMS.Modal.Scan.SelectSource\"></label>\n" +
    "                <div data-bento-select>\n" +
    "                    <select class=\"form-control\" id=\"source\" onchange=\"angular.element(this).scope().sourceOnChange()\">\n" +
    "                        <option tabindex=\"1\" value = \"\"></option>\n" +
    "                    </select>\n" +
    "                </div>\n" +
    "                <br />\n" +
    "            </div>\n" +
    "            <div class=\"form-group\">\n" +
    "                <span translate=\"Bluemoon.DMS.Modal.Scan.ScanSettings\"></span>\n" +
    "                   <div class=\"scan-setting-container\">\n" +
    "                        <div class=\"scan-setting-section bottom-border\">\n" +
    "                            <label class=\"scan-setting-label\" for='BW'>\n" +
    "                                <input class=\"scan-setting-radio-button\"\n" +
    "                                    tabindex=\"2\"\n" +
    "                                    type='radio'\n" +
    "                                    id='BW'\n" +
    "                                    name='PixelType'\n" +
    "                                    ng-click=\"scanSettingsOnchange(1);\"\n" +
    "                                    value='1'/>\n" +
    "                                <span translate=\"Bluemoon.DMS.Modal.Scan.CustomModeAndResolution\"></span>\n" +
    "                            </label>\n" +
    "                            <div class=\"row\">\n" +
    "                                <div class=\"scan-setting-dropdown-container\">\n" +
    "                                    <div class=\"scan-setting mode col-md-5 col-xs-5\">\n" +
    "                                        <label translate=\"Bluemoon.DMS.Modal.Scan.Mode\"></label>\n" +
    "                                        <div data-bento-select>\n" +
    "                                            <select id='Mode'>\n" +
    "                                                <option tabindex=\"3\" value = ''></option>\n" +
    "                                            </select>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "\n" +
    "                                    <div class=\"scan-setting resolution col-md-5 col-xs-5\">\n" +
    "                                        <label translate=\"Bluemoon.DMS.Modal.Scan.Resolution\"></label>\n" +
    "                                        <div data-bento-select>\n" +
    "                                            <select id='Resolution'>\n" +
    "                                                <option tabindex=\"4\" value = ''></option>\n" +
    "                                            </select>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"scan-setting-section\">\n" +
    "                            <label class=\"scan-setting-label\" for=\"TWAIN\">\n" +
    "                                <input class=\"scan-setting-radio-button\"\n" +
    "                                    tabindex=\"5\"\n" +
    "                                    type='radio'\n" +
    "                                    id='TWAIN'\n" +
    "                                    name='PixelType'\n" +
    "                                    ng-click=\"scanSettingsOnchange(2);\"\n" +
    "                                    value='2'/>\n" +
    "                                <span translate=\"Bluemoon.DMS.Modal.Scan.UseYourDriverSettings\"></span>\n" +
    "                            </label>\n" +
    "                        </div>\n" +
    "                   </div>\n" +
    "            </div>\n" +
    "            <br />\n" +
    "\n" +
    "            <div translate=\"Bluemoon.DMS.Modal.Scan.RequiredField\"></div>\n" +
    "\n" +
    "         </form>\n" +
    "\n" +
    "    </div>\n" +
    "    <div  class=\"modal-footer\">\n" +
    "        <button ng-disabled=\"scanFileData.fileNameError || downloadTwainError\" id=\"scanButton\" class=\"btn btn-primary\" ng-click=\"scanDocument()\" translate=\"Bluemoon.DMS.Modal.Scan.Scan\"></button>\n" +
    "        <button class=\"btn btn-default\" ng-click=\"cancelScanFile()\" translate=\"Bluemoon.DMS.Modal.Scan.Cancel\"></button>\n" +
    "    </div>\n" +
    "    <div id=\"J_waiting\" class=\"D-dialog ks-dialog-hidden\">\n" +
    "            <div class=\"ks-dialog-header\"></div>\n" +
    "            <div class=\"ks-dialog-body\">\n" +
    "                <div class=\"ks-dialog-content\"><div id=\"InstallBody\"></div></div>\n" +
    "            </div>\n" +
    "            <div class=\"ks-dialog-footer\"></div>\n" +
    "        </div>\n" +
    "");
}]);

angular.module("documents/files/file-view.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("documents/files/file-view.html",
    "<div class=\"dms\">\n" +
    "    <h2 ng-if=\"selectedItem.lock\">{{ selectedItem.name }}<span class=\"bento-icon-lock dms-lock-icon\" uib-tooltip=\"{{'Bluemoon.DMS.Common.Locked' | translate}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\"></span></h2>\n" +
    "    <h2 ng-if=\"!selectedItem.lock\">{{ selectedItem.name }}</h2>\n" +
    "    <alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "\n" +
    "    <!-- BREADCRUMB -->\n" +
    "    <dms-nav-breadcrumb ng-if=\"canViewDocument\" container-type=\"{{parentItemType}}\"\n" +
    "    	container-id=\"{{parentItemId}}\"\n" +
    "    	collapse-length=\"3\" ng-cloak></dms-nav-breadcrumb>\n" +
    "\n" +
    "    <!-- TOOLBAR -->\n" +
    "    <div id=\"file-view-toolbar\" ng-if=\"canViewDocument\">\n" +
    "        <div dms-toolbar\n" +
    "             buttons=\"buttons\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- DOCUMENT VIEWER -->\n" +
    "    <dms-document-view-pane ng-if=\"canViewDocument\" pdf-view-height=\"{{pdfViewHeight}}\" src=\"{{downloadUrl}}\" mime-type=\"{{mimeType}}\"></dms-document-view-pane>\n" +
    "\n" +
    "    <!-- NO DOCUMENT MESSAGE -->\n" +
    "    <div id=\"no-document\" ng-if=\"!canViewDocument\">\n" +
    "        <p> {{'Bluemoon.DMS.Preview.NoDocument' | translate}} </p>\n" +
    "    </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("documents/folders/actions/renamefolder/rename-folder-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("documents/folders/actions/renamefolder/rename-folder-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancelRenameFolder()\">\n" +
    "  &times;\n" +
    "</button>\n" +
    "<div class=\"modal-header\">\n" +
    "    {{headerText}}\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <alert class=\"show-hide\" ng-repeat=\"alert in renameFolderData.alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "    <form role=\"form\" class=\"css-form\" name=\"renameFolderForm\" ng-submit=\"renameFolderRequest()\" novalidate>\n" +
    "        <div class=\"form-group\" ng-class=\"{'has-error': renameFolderData.folderNameError !==''}\" ng-if=\"renameFolderData.canRename\">\n" +
    "            <label for=\"folderName\">{{nameText}}*</label>\n" +
    "            <input name=\"folderName\" id=\"folderName\" type=\"text\" class=\"form-control\" ng-model=\"renameFolderData.folderName\"\n" +
    "                maxlength=\"{{ renameFolderData.maxFolderNameLength }}\" bm-focus=\"true\" select-on-focus/>\n" +
    "            <div class=\"msg\">{{ renameFolderData.folderNameError }}</div>\n" +
    "        </div>\n" +
    "        <div ng-if=\"renameFolderData.canRename\">\n" +
    "            * {{requiredText}}\n" +
    "        </div>\n" +
    "    </form>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-primary\" ng-click=\"renameFolderRequest()\" ng-if=\"renameFolderData.canRename\">{{renameButtonText}}</button>\n" +
    "    <button class=\"btn btn-default\" ng-click=\"cancelRenameFolder()\">{{cancelButtonText}}</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/folders/actions/sharefolder/combo-grid-cell-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("documents/folders/actions/sharefolder/combo-grid-cell-template.2js.html",
    "<!--TODO: Replace with Bento's actual Combobox implementation...once it plays nicer with Forms (as of 0.8.9)-->\n" +
    "<div class=\"dms-modal-combobox bento-combobox bento-select\">\n" +
    "    <select ng-model=\"COL_FIELD\">\n" +
    "        <option ng-repeat=\"item in roleTypes\">{{item}}</option>\n" +
    "    </select>\n" +
    "    <span class=\"btn\">\n" +
    "        <span class=\"bento-icon-arrow-down\"></span>\n" +
    "    </span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/folders/actions/sharefolder/name-grid-cell-template.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("documents/folders/actions/sharefolder/name-grid-cell-template.2js.html",
    "<div class=\"ngCellText dms-modal-text\" ng-class=\"col.colIndex()\">\n" +
    "    <span ng-cell-text>{{COL_FIELD}}</span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/folders/actions/sharefolder/share-folder-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("documents/folders/actions/sharefolder/share-folder-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancelShareFolder()\">\n" +
    "  &times;\n" +
    "</button>\n" +
    "<div class=\"modal-header\">\n" +
    "    Share\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <alert class=\"show-hide\" ng-repeat=\"alert in shareFolderData.alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "    <form role=\"form\" class=\"css-form\" name=\"shareFolderForm\" onsubmit=\"return false\" novalidate>\n" +
    "        <div class=\"form-group\" ng-class=\"{'has-error': shareFolderData.shareError !==''}\" ng-if=\"shareFolderData.canShare\">\n" +
    "\n" +
    "            <div class=\"bmoon-grid-style no-scroll-grid bmoon-grid-actions-included\"\n" +
    "                ng-grid=\"shareFolderData.options\">\n" +
    "            </div>\n" +
    "\n" +
    "            <br/><br/>\n" +
    "\n" +
    "            <input name=\"applyToSubfolders\" id=\"applyToSubfolders\" type=\"checkbox\"\n" +
    "                   ng-model=\"shareFolderData.applyToSubfolders\" select-on-focus/>\n" +
    "            <label for=\"applyToSubfolders\">Apply changes to subfolders</label>\n" +
    "\n" +
    "            <!-- <div class=\"msg\">{{ shareFolderData.shareError }}</div> -->\n" +
    "        </div>\n" +
    "<!--         <div ng-if=\"shareFolderData.canShare\">\n" +
    "            * Required Field\n" +
    "        </div> -->\n" +
    "    </form>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-primary\" ng-click=\"shareFolderRequest()\" ng-if=\"shareFolderData.canShare\">Share</button>\n" +
    "    <button class=\"btn btn-default\" ng-click=\"cancelShareFolder()\">Cancel</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/folders/masterlist/folder-master.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("documents/folders/masterlist/folder-master.html",
    "<div class=\"dms\">\n" +
    "    <div class=\"file-drop\"\n" +
    "        dms-drag-over\n" +
    "        ng-attr-dms-drag-over-class=\"{{dragDropable && 'file-drop-over' || ''}}\"\n" +
    "        dms-drop\n" +
    "        dms-item=\"{{selectedItem}}\">\n" +
    "        <alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "\n" +
    "        <dms-nav-breadcrumb\n" +
    "            container-type=\"{{containerItemType}}\"\n" +
    "            container-id=\"{{containerId}}\"\n" +
    "            collapse-length=\"3\" ng-cloak></dms-nav-breadcrumb>\n" +
    "\n" +
    "        <div dms-toolbar\n" +
    "            buttons=\"buttons\"\n" +
    "            on-search-enter=\"processSearch\">\n" +
    "        </div>\n" +
    "        <dms-document-grid\n" +
    "            grid-items-function=\"getGridItemsCallback(options)\"\n" +
    "            page-state=\"pageState\"\n" +
    "            selected-items=\"selectedGridItems\"\n" +
    "            client-id=\"clientId\"\n" +
    "            project-id=\"projectId\"\n" +
    "            current-container=\"selectedItem\"\n" +
    "            custom-options=\"gridOptions\"\n" +
    "            header-row-height=\"38\"\n" +
    "            row-height=\"39\"\n" +
    "            buttons=\"buttons\"\n" +
    "            search-method=\"processSearch\"\n" +
    "            item-href-function=\"hrefFunctionCallback(itemData)\"></dms-document-grid>\n" +
    "\n" +
    "        <div ui-view></div>\n" +
    "\n" +
    "        <input id=\"dms-file-select\"\n" +
    "            type=\"file\"\n" +
    "            style=\"visibility:hidden\"\n" +
    "            ng-file-select=\"onFileSelect($files)\" multiple/>        \n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"bottom-alerts-pane\" ng-if=\"!dialogOpen\">\n" +
    "        <dms-upload-alert ng-if=\"totalUploads.totalFiles === 1\"\n" +
    "            dms-upload-model=\"getFirstUpload()\"></dms-upload-alert>\n" +
    "        <dms-upload-collection-alert ng-if=\"totalUploads.totalFiles > 1\"\n" +
    "            files-uploaded=\"totalUploads.filesUploaded\"\n" +
    "            total-files-to-upload=\"totalUploads.totalFiles\"\n" +
    "            size-uploaded=\"totalUploads.progress.loaded\"\n" +
    "            total-size-to-upload=\"totalUploads.progress.total\"\n" +
    "            total-errors=\"totalUploads.totalErrors\"\n" +
    "            ng-click=\"openUploadAlertDisplayModal()\"></dms-upload-collection-alert>\n" +
    "        <dms-operation-alert ng-if=\"operations.length === 1\"\n" +
    "            dms-operation-model=\"operations.first()\"></dms-operation-alert>\n" +
    "        <dms-operation-collection-alert ng-if=\"operations.length > 1\"\n" +
    "            dms-operation-collection-model=\"operations\"\n" +
    "            ng-click=\"openOperationAlertDisplayModal()\"></dms-operation-collection-alert>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"alert animate-repeat upload-progress\" ng-class=\"{'alert-warning': !downloadError, 'alert-error': downloadError}\" ng-show=\"downloadStatus === 'downloading'\">\n" +
    "        <span ng-if=\"!downloadError\">Downloading files...</span>\n" +
    "        <span ng-if=\"downloadError\" ng-bind=\"downloadMessage\"></span>\n" +
    "        <button ng-if=\"downloadError\" type=\"button\" class=\"close file-alert-text\" aria-hidden=\"true\" ng-click=\"closeDownloadAlert()\">&times;</button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/folders/masterlist/toolbar-template.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("documents/folders/masterlist/toolbar-template.html",
    "<div bento-nav-toolbar class=\"navbar navbar-default bento-toolbar\" lang=\"config.language\">\n" +
    "    <ul class=\"nav navbar-nav\">\n" +
    "        <li ng-class=\"{disabled: buttons.add.disabled }\"><a ng-disabled=\"buttons.add.disabled\" ng-click=\"buttons.add.disabled || buttons.add.click()\"><span class=\"glyphicon {{ buttons.add.icon }}\"></span>{{ buttons.add.text }}</a></li>\n" +
    "        <li ng-class=\"{disabled: buttons.upload.disabled }\"><a ng-disabled=\"buttons.upload.disabled\"  ng-click=\"buttons.upload.disabled || buttons.upload.click()\"><span class=\"glyphicon {{ buttons.upload.icon }}\"></span>{{ buttons.upload.text }}</a></li>\n" +
    "        <li ng-class=\"{disabled: buttons.delete.disabled }\"><a ng-disabled=\"buttons.delete.disabled\" ng-click=\"buttons.delete.disabled || buttons.delete.click()\"><span class=\"glyphicon {{ buttons.delete.icon }}\"></span>{{ buttons.delete.text }}</a></li>\n" +
    "        <li ng-class=\"{disabled: buttons.download.disabled }\"><a ng-disabled=\"buttons.download.disabled\" ng-click=\"buttons.download.disabled || buttons.download.click()\"><span class=\"glyphicon {{ buttons.download.icon }}\"></span>{{ buttons.download.text }}</a></li>\n" +
    "        <li ng-class=\"{disabled: buttons.move.disabled }\"><a ng-disabled=\"buttons.move.disabled\" ng-click=\"buttons.move.disabled || buttons.move.click()\"><span class=\"glyphicon {{ buttons.move.icon }}\"></span>{{ buttons.move.text }}</a></li>\n" +
    "        <li ng-class=\"{disabled: buttons.copy.disabled }\"><a ng-disabled=\"buttons.copy.disabled\" ng-click=\"buttons.copy.disabled || buttons.copy.click()\"><span class=\"glyphicon {{ buttons.sopy.icon }}\"></span>{{ buttons.copy.text }}</a></li>\n" +
    "        <li ng-class=\"{disabled: buttons.scan.disabled }\"><a ng-disabled=\"buttons.scan.disabled\" ng-click=\"buttons.scan.disabled || buttons.scan.click()\"><span class=\"glyphicon {{ buttons.scan.icon }}\"></span>{{ buttons.scan.text }}</a></li>\n" +
    "        <li ng-class=\"{disabled: buttons.rename.disabled }\"><a ng-disabled=\"buttons.rename.disabled\" ng-click=\"buttons.rename.disabled || buttons.rename.click()\"><span class=\"glyphicon {{ buttons.rename.icon }}\"></span>{{ buttons.rename.text }}</a></li>\n" +
    "    </ul>\n" +
    "    <form class=\"navbar-form navbar-right search-filter\" role=\"search\">\n" +
    "        <div class=\"form-group filter-container\">\n" +
    "            <label class=\"sr-only\" for=\"searchInput1\">Search</label>\n" +
    "            <input bento-reset type=\"text\" id=\"searchInput1\" class=\"form-control\" placeholder=\"Search\" ng-model=\"searchInput.text\" ng-keypress=\"onSearchInputChange($event)\" />\n" +
    "        </div>\n" +
    "    </form>\n" +
    "</div>");
}]);

angular.module("documents/recents/masterlist/recents-master.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("documents/recents/masterlist/recents-master.html",
    "<div class=\"dms\">\n" +
    "    <div class=\"recents-master-container\">\n" +
    "        <alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "        <h1 class=\"no-top-margin\" translate=\"Bluemoon.DMS.SpecialFolders.Recents\"></h1>\n" +
    "\n" +
    "        <div dms-toolbar>\n" +
    "        </div>\n" +
    "\n" +
    "        <dms-recents-grid control=\"gridControlContainer\"></dms-recents-grid>\n" +
    "\n" +
    "        <div class=\"bottom-alerts-pane\" ng-if=\"!dialogOpen\">\n" +
    "            <dms-upload-alert ng-if=\"totalUploads.totalFiles === 1\"\n" +
    "                dms-upload-model=\"getFirstUpload()\"></dms-upload-alert>\n" +
    "            <dms-upload-collection-alert ng-if=\"totalUploads.totalFiles > 1\"\n" +
    "                files-uploaded=\"totalUploads.filesUploaded\"\n" +
    "                total-files-to-upload=\"totalUploads.totalFiles\"\n" +
    "                size-uploaded=\"totalUploads.progress.loaded\"\n" +
    "                total-size-to-upload=\"totalUploads.progress.total\"\n" +
    "                total-errors=\"totalUploads.totalErrors\"\n" +
    "                ng-click=\"openUploadAlertDisplayModal()\"></dms-upload-collection-alert>\n" +
    "            <dms-operation-alert ng-if=\"operations.length === 1\"\n" +
    "                dms-operation-model=\"operations.first()\"></dms-operation-alert>\n" +
    "            <dms-operation-collection-alert ng-if=\"operations.length > 1\"\n" +
    "                dms-operation-collection-model=\"operations\"\n" +
    "                ng-click=\"openOperationAlertDisplayModal()\"></dms-operation-collection-alert>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"alert animate-repeat upload-progress\" ng-class=\"{'alert-warning': !downloadError, 'alert-error': downloadError}\" ng-show=\"downloadStatus === 'downloading'\">\n" +
    "            <span ng-if=\"!downloadError\">Downloading files...</span>\n" +
    "            <span ng-if=\"downloadError\" ng-bind=\"downloadMessage\"></span>\n" +
    "            <button ng-if=\"downloadError\" type=\"button\" class=\"close file-alert-text\" aria-hidden=\"true\" ng-click=\"closeDownloadAlert()\">&times;</button>\n" +
    "        </div>\n" +
    "\n" +
    "        <div ui-view></div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/recycle/masterlist/recycle-view.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("documents/recycle/masterlist/recycle-view.html",
    "<div class=\"dms\">\n" +
    "    <div class=\"recycle-master-container\">\n" +
    "        <alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "        <h1 class=\"no-top-margin\" translate=\"Bluemoon.DMS.SpecialFolders.RecycleBin\"></h1>\n" +
    "\n" +
    "        <div dms-toolbar buttons=\"buttons\"></div>\n" +
    "\n" +
    "        <dms-recycle-grid control=\"gridControlContainer\" selected-items=\"selectedGridItems\" buttons=\"buttons\"\n" +
    "        trashed-by-current-user=\"true\"></dms-recycle-grid>\n" +
    "\n" +
    "        <div class=\"bottom-alerts-pane\" ng-if=\"!dialogOpen\">\n" +
    "            <dms-upload-alert ng-if=\"totalUploads.totalFiles === 1\"\n" +
    "                dms-upload-model=\"getFirstUpload()\"></dms-upload-alert>\n" +
    "            <dms-upload-collection-alert ng-if=\"totalUploads.totalFiles > 1\"\n" +
    "                files-uploaded=\"totalUploads.filesUploaded\"\n" +
    "                total-files-to-upload=\"totalUploads.totalFiles\"\n" +
    "                size-uploaded=\"totalUploads.progress.loaded\"\n" +
    "                total-size-to-upload=\"totalUploads.progress.total\"\n" +
    "                total-errors=\"totalUploads.totalErrors\"\n" +
    "                ng-click=\"openUploadAlertDisplayModal()\"></dms-upload-collection-alert>\n" +
    "            <dms-operation-alert ng-if=\"operations.length === 1\"\n" +
    "                dms-operation-model=\"operations.first()\"></dms-operation-alert>\n" +
    "            <dms-operation-collection-alert ng-if=\"operations.length > 1\"\n" +
    "                dms-operation-collection-model=\"operations\"\n" +
    "                ng-click=\"openOperationAlertDisplayModal()\"></dms-operation-collection-alert>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"alert animate-repeat upload-progress\" ng-class=\"{'alert-warning': !downloadError, 'alert-error': downloadError}\" ng-show=\"downloadStatus === 'downloading'\">\n" +
    "            <span ng-if=\"!downloadError\">Downloading files...</span>\n" +
    "            <span ng-if=\"downloadError\" ng-bind=\"downloadMessage\"></span>\n" +
    "            <button ng-if=\"downloadError\" type=\"button\" class=\"close file-alert-text\" aria-hidden=\"true\" ng-click=\"closeDownloadAlert()\">&times;</button>\n" +
    "        </div>\n" +
    "\n" +
    "        <div ui-view></div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/search/document-search-results.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("documents/search/document-search-results.html",
    "<div class=\"dms dms-search\">\n" +
    "    <div class=\"search-master-container\">\n" +
    "        <alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "\n" +
    "        <h1 class=\"no-top-margin\" translate=\"Bluemoon.DMS.SearchResults\"></h1>\n" +
    "\n" +
    "        <dms-nav-breadcrumb\n" +
    "            container-type=\"{{containerType}}\"\n" +
    "            container-id=\"{{containerId}}\"\n" +
    "            path-loaded-callback=\"breadcrumbPathCallback(path)\"\n" +
    "            collapse-length=\"1\" ng-cloak>\n" +
    "        </dms-nav-breadcrumb>\n" +
    "\n" +
    "        <dms-search-grid control=\"gridControlContainer\"></dms-search-grid>\n" +
    "\n" +
    "        <div ui-view></div>\n" +
    "\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/storage/actions/renameproject/rename-project-modal.2js.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("documents/storage/actions/renameproject/rename-project-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancelRenameProject()\">\n" +
    "  &times;\n" +
    "</button>\n" +
    "<div class=\"modal-header\">\n" +
    "    {{headerText}}\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <alert class=\"show-hide\" ng-repeat=\"alert in renameProjectData.alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "    <form role=\"form\" class=\"css-form\" name=\"renameProjectForm\" ng-submit=\"renameProjectRequest()\" novalidate>\n" +
    "        <div class=\"form-group\" ng-class=\"{'has-error': renameProjectData.projectNameError !==''}\" ng-if=\"renameProjectData.canRename\">\n" +
    "            <label for=\"projectName\">{{nameText}}*</label>\n" +
    "            <input name=\"projectName\" id=\"projectName\" type=\"text\" class=\"form-control\" ng-model=\"renameProjectData.projectName\"\n" +
    "                maxlength=\"{{ renameProjectData.maxProjectNameLength }}\" bm-focus=\"true\" select-on-focus/>\n" +
    "            <div class=\"msg\">{{ renameProjectData.projectNameError }}</div>\n" +
    "        </div>\n" +
    "        <div ng-if=\"renameProjectData.canRename\">\n" +
    "            * {{requiredText}}\n" +
    "        </div>\n" +
    "    </form>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-primary\" ng-click=\"renameProjectRequest()\" ng-if=\"renameProjectData.canRename\">{{renameButtonText}}</button>\n" +
    "    <button class=\"btn btn-default\" ng-click=\"cancelRenameProject()\">{{cancelButtonText}}</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/storage/masterlist/storage-master.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("documents/storage/masterlist/storage-master.html",
    "<div class=\"dms\">\n" +
    "    <div class=\"storage-master-container\">\n" +
    "        <alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "\n" +
    "        <dms-nav-breadcrumb\n" +
    "            container-type=\"{{containerItemType}}\"\n" +
    "            container-id=\"{{containerId}}\"\n" +
    "            collapse-length=\"3\" ng-cloak></dms-nav-breadcrumb>\n" +
    "\n" +
    "        <div dms-toolbar\n" +
    "            buttons=\"buttons\"\n" +
    "            on-search-enter=\"processSearch\">\n" +
    "        </div>\n" +
    "\n" +
    "        <dms-storage-grid\n" +
    "            items=\"gridItems\"\n" +
    "            selected-items=\"selectedGridItems\"\n" +
    "            current-container=\"selectedItem\"\n" +
    "            custom-options=\"gridOptions\"\n" +
    "            header-row-height=\"38\"\n" +
    "            row-height=\"39\"\n" +
    "            viewer-height=\"viewerHeight\"\n" +
    "            virtualization-threshold=\"30\"\n" +
    "            buttons=\"buttons\"\n" +
    "            refresh-in-progress=\"refreshInProgress\"\n" +
    "            search-method=\"processSearch\">\n" +
    "        </dms-storage-grid>\n" +
    "\n" +
    "        <div class=\"bottom-alerts-pane\" ng-if=\"!dialogOpen\">\n" +
    "            <dms-upload-alert ng-if=\"totalUploads.totalFiles === 1\"\n" +
    "                dms-upload-model=\"getFirstUpload()\"></dms-upload-alert>\n" +
    "            <dms-upload-collection-alert ng-if=\"totalUploads.totalFiles > 1\"\n" +
    "                files-uploaded=\"totalUploads.filesUploaded\"\n" +
    "                total-files-to-upload=\"totalUploads.totalFiles\"\n" +
    "                size-uploaded=\"totalUploads.progress.loaded\"\n" +
    "                total-size-to-upload=\"totalUploads.progress.total\"\n" +
    "                total-errors=\"totalUploads.totalErrors\"\n" +
    "                ng-click=\"openUploadAlertDisplayModal()\"></dms-upload-collection-alert>\n" +
    "            <dms-operation-alert ng-if=\"operations.length === 1\"\n" +
    "                dms-operation-model=\"operations.first()\"></dms-operation-alert>\n" +
    "            <dms-operation-collection-alert ng-if=\"operations.length > 1\"\n" +
    "                dms-operation-collection-model=\"operations\"\n" +
    "                ng-click=\"openOperationAlertDisplayModal()\"></dms-operation-collection-alert>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"alert animate-repeat upload-progress\" ng-class=\"{'alert-warning': !downloadError, 'alert-error': downloadError}\" ng-show=\"downloadStatus === 'downloading'\">\n" +
    "            <span ng-if=\"!downloadError\">Downloading files...</span>\n" +
    "            <span ng-if=\"downloadError\" ng-bind=\"downloadMessage\"></span>\n" +
    "            <button ng-if=\"downloadError\" type=\"button\" class=\"close file-alert-text\" aria-hidden=\"true\" ng-click=\"closeDownloadAlert()\">&times;</button>\n" +
    "        </div>\n" +
    "\n" +
    "        <div ui-view></div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("documents/templates/masterlist/template-master.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("documents/templates/masterlist/template-master.html",
    "<div class=\"dms\">\n" +
    "    <div class=\"template-master-container\">\n" +
    "        <alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "        <dms-bread-crumb crumb-list=\"breadCrumbList\" collapse-length=\"{{collapseLength}}\" can-select-last-crumb=\"false\" ng-cloak></dms-bread-crumb>\n" +
    "\n" +
    "        <div dms-toolbar\n" +
    "            buttons=\"buttons\"\n" +
    "            on-search-enter=\"processSearch\">\n" +
    "        </div>\n" +
    "\n" +
    "        <dms-storage-grid\n" +
    "            items=\"gridItems\"\n" +
    "            selected-items=\"selectedGridItems\"\n" +
    "            current-container=\"selectedItem\"\n" +
    "            custom-options=\"gridOptions\"\n" +
    "            header-row-height=\"38\"\n" +
    "            row-height=\"39\"\n" +
    "            viewer-height=\"viewerHeight\"\n" +
    "            virtualization-threshold=\"30\"\n" +
    "            buttons=\"buttons\"\n" +
    "            refresh-in-progress=\"refreshInProgress\"\n" +
    "            search-method=\"processSearch\">\n" +
    "        </dms-storage-grid>\n" +
    "\n" +
    "        <div class=\"bottom-alerts-pane\" ng-if=\"!dialogOpen\">\n" +
    "            <dms-upload-alert ng-if=\"totalUploads.totalFiles === 1\"\n" +
    "                dms-upload-model=\"getFirstUpload()\"></dms-upload-alert>\n" +
    "            <dms-upload-collection-alert ng-if=\"totalUploads.totalFiles > 1\"\n" +
    "                files-uploaded=\"totalUploads.filesUploaded\"\n" +
    "                total-files-to-upload=\"totalUploads.totalFiles\"\n" +
    "                size-uploaded=\"totalUploads.progress.loaded\"\n" +
    "                total-size-to-upload=\"totalUploads.progress.total\"\n" +
    "                total-errors=\"totalUploads.totalErrors\"\n" +
    "                ng-click=\"openUploadAlertDisplayModal()\"></dms-upload-collection-alert>\n" +
    "            <dms-operation-alert ng-if=\"operations.length === 1\"\n" +
    "                dms-operation-model=\"operations.first()\"></dms-operation-alert>\n" +
    "            <dms-operation-collection-alert ng-if=\"operations.length > 1\"\n" +
    "                dms-operation-collection-model=\"operations\"\n" +
    "                ng-click=\"openOperationAlertDisplayModal()\"></dms-operation-collection-alert>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"alert animate-repeat upload-progress\" ng-class=\"{'alert-warning': !downloadError, 'alert-error': downloadError}\" ng-show=\"downloadStatus === 'downloading'\">\n" +
    "            <span ng-if=\"!downloadError\">Downloading files...</span>\n" +
    "            <span ng-if=\"downloadError\" ng-bind=\"downloadMessage\"></span>\n" +
    "            <button ng-if=\"downloadError\" type=\"button\" class=\"close file-alert-text\" aria-hidden=\"true\" ng-click=\"closeDownloadAlert()\">&times;</button>\n" +
    "        </div>\n" +
    "\n" +
    "        <div ui-view></div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "<iframe id=\"folder-view-invisible-download\" style=\"display:none;\"></iframe>\n" +
    "");
}]);

angular.module("main/main.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("main/main.html",
    "<bm-view-portal-banner></bm-view-portal-banner>\n" +
    "<bm-client-app-header></bm-client-app-header>\n" +
    "<bm-client-app-nav></bm-client-app-nav>\n" +
    "<bm-client-app-main>\n" +
    "  <!-- Position static required to get around bento bug that rewrites position -->\n" +
    "  <!-- Can't put this with ui-view div and it recreates the directive upon state change -->\n" +
    "  <div bm-busy-loader style=\"position: static\">\n" +
    "    <ui-view></ui-view>\n" +
    "  </div>\n" +
    "  <div class=\"dms\">\n" +
    "    <div class=\"bottom-alerts-pane\">\n" +
    "      <dms-alert ng-hide=\"!ctrl.bmErrorModel\" close=\"ctrl.closeBmErrorAlert()\" dms-alert=\"ctrl.bmErrorModel\">{{ ctrl.bmErrorModel.msg }}</dms-alert>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <bm-terms-signatory></bm-terms-signatory>\n" +
    "</bm-client-app-main>\n" +
    "\n" +
    "<!-- <div bento-alert bento-alert-object=\"$root.bmErrors\"></div> -->\n" +
    "");
}]);

angular.module("notfound/notfound.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("notfound/notfound.html",
    "<div class=\"container-fluid\">\n" +
    "    <div class=\"row\">\n" +
    "        <h4 translate=\"We're sorry. The page you requested could not be found.\"></h4><br/>\n" +
    "        <a class=\"btn btn-primary\" href=\"#/\" translate=\"Start Over\"></a>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("server-check/index.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("server-check/index.html",
    "<Status xmlns:i=\"http://www.w3.org/2001/XMLSchema-instance\" xmlns=\"http://schemas.datacontract.org/2004/07/Cobalt.BlueMoonClients.Web.Models\">\n" +
    "    <Resources>\n" +
    "        <Result>OK</Result>\n" +
    "    </Resources>\n" +
    "</Status>\n" +
    "");
}]);

(function (bmClientApp) {
  'use strict';

  bmClientApp.controller('MainCtrl', MainCtrl);

  MainCtrl.$inject = ['$rootScope', 'DmsAlertModel'];

  function MainCtrl($rootScope, DmsAlertModel) {
    var ctrl = this;

    ctrl.closeBmErrorAlert = closeBmErrorAlert;

    //////////////////////////////

    function closeBmErrorAlert() {
      ctrl.bmErrorModel = null;
    }

    $rootScope.$watchCollection('bmErrors', function(newValue, oldValue){
      if (newValue !== oldValue && !ctrl.bmErrorModel) {
        var bmError = newValue.shift();

        if (bmError) {
          ctrl.bmErrorModel = new DmsAlertModel({
            status: 'error',
            message: bmError.msg
          });
        }
      }
    });
  }
})(window.bmClientApp);
